
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("evZwi", function(module, exports) {

$parcel$export(module.exports, "CustomerLandingPageRelayQuery", function () { return $5bc2dabc89a101dd$export$a2e9c729852eb9a1; });
$parcel$export(module.exports, "getCustomerLandingPageRelayQueryVars", function () { return $5bc2dabc89a101dd$export$d97c1c828e8e0162; });
$parcel$export(module.exports, "CustomerLandingPageContentfulResponse", function () { return $5bc2dabc89a101dd$export$4b589896422ec0e0; });

var $9Dbz6 = parcelRequire("9Dbz6");

var $1FkY0 = parcelRequire("1FkY0");
var $5bc2dabc89a101dd$var$_customerLandingPageRelayQuery;

const $5bc2dabc89a101dd$export$a2e9c729852eb9a1 = $5bc2dabc89a101dd$var$_customerLandingPageRelayQuery !== void 0 ? $5bc2dabc89a101dd$var$_customerLandingPageRelayQuery : ($5bc2dabc89a101dd$var$_customerLandingPageRelayQuery = (parcelRequire("hr57x")), $5bc2dabc89a101dd$var$_customerLandingPageRelayQuery.hash && $5bc2dabc89a101dd$var$_customerLandingPageRelayQuery.hash !== "8c843ab041f86aaa1c91e2fdfd9f9c32" && console.error("The definition of 'customerLandingPageRelayQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $5bc2dabc89a101dd$var$_customerLandingPageRelayQuery);
const $5bc2dabc89a101dd$export$d97c1c828e8e0162 = (location)=>{
    const { locale: locale } = (0, $9Dbz6.parseRoute)(location);
    return {
        locale: (0, $1FkY0.WAC_TO_CPAPI_LOCALE_MAP)[locale] || "en-US"
    };
};
const $5bc2dabc89a101dd$export$4b589896422ec0e0 = (contentfulStories)=>{
    var _contentfulStories_customerStoryCollection_items, _contentfulStories_customerStoryCollection, _contentfulStories_taxonomyIndustryCollection_items, _contentfulStories_taxonomyIndustryCollection, _contentfulStories_taxonomyCompanySizeCollection_items, _contentfulStories_taxonomyCompanySizeCollection, _contentfulStories_productNameCollection_items, _contentfulStories_productNameCollection, _contentfulStories_taxonomyRegionCollection_items, _contentfulStories_taxonomyRegionCollection, _contentfulStories_taxonomySolutionCollection_items, _contentfulStories_taxonomySolutionCollection;
    var _contentfulStories_customerStoryCollection_items_map, _contentfulStories_taxonomyIndustryCollection_items_filter_map, _contentfulStories_taxonomyCompanySizeCollection_items_filter_map, _contentfulStories_productNameCollection_items_filter_map, _contentfulStories_taxonomyRegionCollection_items_filter_map, _contentfulStories_taxonomySolutionCollection_items_filter_map;
    return {
        customerStories: {
            edges: (_contentfulStories_customerStoryCollection_items_map = (_contentfulStories_customerStoryCollection = contentfulStories.customerStoryCollection) === null || _contentfulStories_customerStoryCollection === void 0 ? void 0 : (_contentfulStories_customerStoryCollection_items = _contentfulStories_customerStoryCollection.items) === null || _contentfulStories_customerStoryCollection_items === void 0 ? void 0 : _contentfulStories_customerStoryCollection_items.map((item)=>{
                var _item_customerCompany, _item_customerCompany_logoCollection_items, _item_customerCompany_logoCollection, _item_customerCompany1, _item_customerCompany_industryCollection_items, _item_customerCompany_industryCollection, _item_customerCompany2, _item_customerCompany_region, _item_customerCompany3, _item_customerCompany_organizationSize, _item_customerCompany4, _item_advocateQuotesCollection_items, _item_advocateQuotesCollection, _item_callToActionCollection_items, _item_callToActionCollection, _item_productCollection_items, _item_productCollection, _item_marketplaceAppsCollection_items, _item_marketplaceAppsCollection, _item_solutionCollection_items, _item_solutionCollection, _item_solutionPartnersCollection_items, _item_solutionPartnersCollection;
                return {
                    node: {
                        title: item === null || item === void 0 ? void 0 : item.storyTitleExternal,
                        customerCompany: {
                            name: item === null || item === void 0 ? void 0 : (_item_customerCompany = item.customerCompany) === null || _item_customerCompany === void 0 ? void 0 : _item_customerCompany.organizationNameExternal,
                            logo: item === null || item === void 0 ? void 0 : (_item_customerCompany1 = item.customerCompany) === null || _item_customerCompany1 === void 0 ? void 0 : (_item_customerCompany_logoCollection = _item_customerCompany1.logoCollection) === null || _item_customerCompany_logoCollection === void 0 ? void 0 : (_item_customerCompany_logoCollection_items = _item_customerCompany_logoCollection.items) === null || _item_customerCompany_logoCollection_items === void 0 ? void 0 : _item_customerCompany_logoCollection_items.map((item)=>{
                                return {
                                    description: item === null || item === void 0 ? void 0 : item.description,
                                    contentType: item === null || item === void 0 ? void 0 : item.contentType,
                                    url: item === null || item === void 0 ? void 0 : item.url
                                };
                            }),
                            industry: item === null || item === void 0 ? void 0 : (_item_customerCompany2 = item.customerCompany) === null || _item_customerCompany2 === void 0 ? void 0 : (_item_customerCompany_industryCollection = _item_customerCompany2.industryCollection) === null || _item_customerCompany_industryCollection === void 0 ? void 0 : (_item_customerCompany_industryCollection_items = _item_customerCompany_industryCollection.items) === null || _item_customerCompany_industryCollection_items === void 0 ? void 0 : _item_customerCompany_industryCollection_items.map((item)=>{
                                return {
                                    name: item === null || item === void 0 ? void 0 : item.industryName
                                };
                            }),
                            region: {
                                name: item === null || item === void 0 ? void 0 : (_item_customerCompany3 = item.customerCompany) === null || _item_customerCompany3 === void 0 ? void 0 : (_item_customerCompany_region = _item_customerCompany3.region) === null || _item_customerCompany_region === void 0 ? void 0 : _item_customerCompany_region.regionNameExternal
                            },
                            organizationSize: {
                                name: item === null || item === void 0 ? void 0 : (_item_customerCompany4 = item.customerCompany) === null || _item_customerCompany4 === void 0 ? void 0 : (_item_customerCompany_organizationSize = _item_customerCompany4.organizationSize) === null || _item_customerCompany_organizationSize === void 0 ? void 0 : _item_customerCompany_organizationSize.companySizeTitleExternal
                            }
                        },
                        advocateQuotes: item === null || item === void 0 ? void 0 : (_item_advocateQuotesCollection = item.advocateQuotesCollection) === null || _item_advocateQuotesCollection === void 0 ? void 0 : (_item_advocateQuotesCollection_items = _item_advocateQuotesCollection.items) === null || _item_advocateQuotesCollection_items === void 0 ? void 0 : _item_advocateQuotesCollection_items.map((item)=>{
                            if ((item === null || item === void 0 ? void 0 : item.advocateName) && item.advocateQuote && item.advocateJobTitle && item.advocateHeadshot) return {
                                advocateName: item === null || item === void 0 ? void 0 : item.advocateName,
                                advocateQuote: item === null || item === void 0 ? void 0 : item.advocateQuote,
                                advocateJobTitle: item === null || item === void 0 ? void 0 : item.advocateJobTitle,
                                advocateHeadshot: item === null || item === void 0 ? void 0 : item.advocateHeadshot
                            };
                            return null;
                        }).filter((item)=>item !== null),
                        storyIcon: item === null || item === void 0 ? void 0 : item.storyIcon,
                        callToAction: item === null || item === void 0 ? void 0 : (_item_callToActionCollection = item.callToActionCollection) === null || _item_callToActionCollection === void 0 ? void 0 : (_item_callToActionCollection_items = _item_callToActionCollection.items) === null || _item_callToActionCollection_items === void 0 ? void 0 : _item_callToActionCollection_items.map((item)=>{
                            return {
                                text: item === null || item === void 0 ? void 0 : item.ctaText,
                                url: item === null || item === void 0 ? void 0 : item.ctaUrl
                            };
                        }),
                        products: item === null || item === void 0 ? void 0 : (_item_productCollection = item.productCollection) === null || _item_productCollection === void 0 ? void 0 : (_item_productCollection_items = _item_productCollection.items) === null || _item_productCollection_items === void 0 ? void 0 : _item_productCollection_items.map((item)=>{
                            var _item_productNameReference;
                            return {
                                name: item === null || item === void 0 ? void 0 : (_item_productNameReference = item.productNameReference) === null || _item_productNameReference === void 0 ? void 0 : _item_productNameReference.productName
                            };
                        }),
                        marketplaceApps: item === null || item === void 0 ? void 0 : (_item_marketplaceAppsCollection = item.marketplaceAppsCollection) === null || _item_marketplaceAppsCollection === void 0 ? void 0 : (_item_marketplaceAppsCollection_items = _item_marketplaceAppsCollection.items) === null || _item_marketplaceAppsCollection_items === void 0 ? void 0 : _item_marketplaceAppsCollection_items.map((item)=>{
                            return {
                                name: item === null || item === void 0 ? void 0 : item.title
                            };
                        }),
                        solutions: item === null || item === void 0 ? void 0 : (_item_solutionCollection = item.solutionCollection) === null || _item_solutionCollection === void 0 ? void 0 : (_item_solutionCollection_items = _item_solutionCollection.items) === null || _item_solutionCollection_items === void 0 ? void 0 : _item_solutionCollection_items.map((item)=>{
                            return {
                                name: item === null || item === void 0 ? void 0 : item.solutionNameExternal
                            };
                        }),
                        solutionPartners: item === null || item === void 0 ? void 0 : (_item_solutionPartnersCollection = item.solutionPartnersCollection) === null || _item_solutionPartnersCollection === void 0 ? void 0 : (_item_solutionPartnersCollection_items = _item_solutionPartnersCollection.items) === null || _item_solutionPartnersCollection_items === void 0 ? void 0 : _item_solutionPartnersCollection_items.map((item)=>{
                            return {
                                name: item === null || item === void 0 ? void 0 : item.organizationNameExternal
                            };
                        }),
                        urlSlug: item === null || item === void 0 ? void 0 : item.urlSlug
                    }
                };
            })) !== null && _contentfulStories_customerStoryCollection_items_map !== void 0 ? _contentfulStories_customerStoryCollection_items_map : []
        },
        taxonomyCompanySizeCollection: contentfulStories.taxonomyCompanySizeCollection,
        filters: {
            edges: [
                ...(_contentfulStories_taxonomyIndustryCollection_items_filter_map = contentfulStories === null || contentfulStories === void 0 ? void 0 : (_contentfulStories_taxonomyIndustryCollection = contentfulStories.taxonomyIndustryCollection) === null || _contentfulStories_taxonomyIndustryCollection === void 0 ? void 0 : (_contentfulStories_taxonomyIndustryCollection_items = _contentfulStories_taxonomyIndustryCollection.items) === null || _contentfulStories_taxonomyIndustryCollection_items === void 0 ? void 0 : _contentfulStories_taxonomyIndustryCollection_items.filter((item)=>{
                    var _item_linkedFrom_companyNameInternalCollection_items, _item_linkedFrom_companyNameInternalCollection, _item_linkedFrom;
                    return item === null || item === void 0 ? void 0 : (_item_linkedFrom = item.linkedFrom) === null || _item_linkedFrom === void 0 ? void 0 : (_item_linkedFrom_companyNameInternalCollection = _item_linkedFrom.companyNameInternalCollection) === null || _item_linkedFrom_companyNameInternalCollection === void 0 ? void 0 : (_item_linkedFrom_companyNameInternalCollection_items = _item_linkedFrom_companyNameInternalCollection.items) === null || _item_linkedFrom_companyNameInternalCollection_items === void 0 ? void 0 : _item_linkedFrom_companyNameInternalCollection_items.some((link)=>{
                        var _link_linkedFrom_customerStoryCollection, _link_linkedFrom;
                        return link === null || link === void 0 ? void 0 : (_link_linkedFrom = link.linkedFrom) === null || _link_linkedFrom === void 0 ? void 0 : (_link_linkedFrom_customerStoryCollection = _link_linkedFrom.customerStoryCollection) === null || _link_linkedFrom_customerStoryCollection === void 0 ? void 0 : _link_linkedFrom_customerStoryCollection.total;
                    });
                }).map((element)=>{
                    return {
                        node: {
                            context: {
                                name: element === null || element === void 0 ? void 0 : element.industryName
                            },
                            field: "industry"
                        }
                    };
                })) !== null && _contentfulStories_taxonomyIndustryCollection_items_filter_map !== void 0 ? _contentfulStories_taxonomyIndustryCollection_items_filter_map : [],
                ...(_contentfulStories_taxonomyCompanySizeCollection_items_filter_map = contentfulStories === null || contentfulStories === void 0 ? void 0 : (_contentfulStories_taxonomyCompanySizeCollection = contentfulStories.taxonomyCompanySizeCollection) === null || _contentfulStories_taxonomyCompanySizeCollection === void 0 ? void 0 : (_contentfulStories_taxonomyCompanySizeCollection_items = _contentfulStories_taxonomyCompanySizeCollection.items) === null || _contentfulStories_taxonomyCompanySizeCollection_items === void 0 ? void 0 : _contentfulStories_taxonomyCompanySizeCollection_items.filter((item)=>{
                    var _item_linkedFrom_companyNameInternalCollection_items, _item_linkedFrom_companyNameInternalCollection, _item_linkedFrom;
                    return item === null || item === void 0 ? void 0 : (_item_linkedFrom = item.linkedFrom) === null || _item_linkedFrom === void 0 ? void 0 : (_item_linkedFrom_companyNameInternalCollection = _item_linkedFrom.companyNameInternalCollection) === null || _item_linkedFrom_companyNameInternalCollection === void 0 ? void 0 : (_item_linkedFrom_companyNameInternalCollection_items = _item_linkedFrom_companyNameInternalCollection.items) === null || _item_linkedFrom_companyNameInternalCollection_items === void 0 ? void 0 : _item_linkedFrom_companyNameInternalCollection_items.some((link)=>{
                        var _link_linkedFrom_customerStoryCollection, _link_linkedFrom;
                        return link === null || link === void 0 ? void 0 : (_link_linkedFrom = link.linkedFrom) === null || _link_linkedFrom === void 0 ? void 0 : (_link_linkedFrom_customerStoryCollection = _link_linkedFrom.customerStoryCollection) === null || _link_linkedFrom_customerStoryCollection === void 0 ? void 0 : _link_linkedFrom_customerStoryCollection.total;
                    });
                }).map((element)=>{
                    return {
                        node: {
                            context: {
                                name: element === null || element === void 0 ? void 0 : element.companySizeTitleExternal
                            },
                            field: "organizationSize"
                        }
                    };
                })) !== null && _contentfulStories_taxonomyCompanySizeCollection_items_filter_map !== void 0 ? _contentfulStories_taxonomyCompanySizeCollection_items_filter_map : [],
                ...(_contentfulStories_productNameCollection_items_filter_map = contentfulStories === null || contentfulStories === void 0 ? void 0 : (_contentfulStories_productNameCollection = contentfulStories.productNameCollection) === null || _contentfulStories_productNameCollection === void 0 ? void 0 : (_contentfulStories_productNameCollection_items = _contentfulStories_productNameCollection.items) === null || _contentfulStories_productNameCollection_items === void 0 ? void 0 : _contentfulStories_productNameCollection_items.filter((item)=>{
                    var _item_linkedFrom_productListingCollection_items, _item_linkedFrom_productListingCollection, _item_linkedFrom;
                    return item === null || item === void 0 ? void 0 : (_item_linkedFrom = item.linkedFrom) === null || _item_linkedFrom === void 0 ? void 0 : (_item_linkedFrom_productListingCollection = _item_linkedFrom.productListingCollection) === null || _item_linkedFrom_productListingCollection === void 0 ? void 0 : (_item_linkedFrom_productListingCollection_items = _item_linkedFrom_productListingCollection.items) === null || _item_linkedFrom_productListingCollection_items === void 0 ? void 0 : _item_linkedFrom_productListingCollection_items.some((link)=>{
                        var _link_linkedFrom_customerStoryCollection, _link_linkedFrom;
                        return link === null || link === void 0 ? void 0 : (_link_linkedFrom = link.linkedFrom) === null || _link_linkedFrom === void 0 ? void 0 : (_link_linkedFrom_customerStoryCollection = _link_linkedFrom.customerStoryCollection) === null || _link_linkedFrom_customerStoryCollection === void 0 ? void 0 : _link_linkedFrom_customerStoryCollection.total;
                    });
                }).map((element)=>{
                    return {
                        node: {
                            context: {
                                name: element === null || element === void 0 ? void 0 : element.productName
                            },
                            field: "products"
                        }
                    };
                })) !== null && _contentfulStories_productNameCollection_items_filter_map !== void 0 ? _contentfulStories_productNameCollection_items_filter_map : [],
                ...(_contentfulStories_taxonomyRegionCollection_items_filter_map = contentfulStories === null || contentfulStories === void 0 ? void 0 : (_contentfulStories_taxonomyRegionCollection = contentfulStories.taxonomyRegionCollection) === null || _contentfulStories_taxonomyRegionCollection === void 0 ? void 0 : (_contentfulStories_taxonomyRegionCollection_items = _contentfulStories_taxonomyRegionCollection.items) === null || _contentfulStories_taxonomyRegionCollection_items === void 0 ? void 0 : _contentfulStories_taxonomyRegionCollection_items.filter((item)=>{
                    var _item_linkedFrom_companyNameInternalCollection_items, _item_linkedFrom_companyNameInternalCollection, _item_linkedFrom;
                    return item === null || item === void 0 ? void 0 : (_item_linkedFrom = item.linkedFrom) === null || _item_linkedFrom === void 0 ? void 0 : (_item_linkedFrom_companyNameInternalCollection = _item_linkedFrom.companyNameInternalCollection) === null || _item_linkedFrom_companyNameInternalCollection === void 0 ? void 0 : (_item_linkedFrom_companyNameInternalCollection_items = _item_linkedFrom_companyNameInternalCollection.items) === null || _item_linkedFrom_companyNameInternalCollection_items === void 0 ? void 0 : _item_linkedFrom_companyNameInternalCollection_items.some((link)=>{
                        var _link_linkedFrom_customerStoryCollection, _link_linkedFrom;
                        return link === null || link === void 0 ? void 0 : (_link_linkedFrom = link.linkedFrom) === null || _link_linkedFrom === void 0 ? void 0 : (_link_linkedFrom_customerStoryCollection = _link_linkedFrom.customerStoryCollection) === null || _link_linkedFrom_customerStoryCollection === void 0 ? void 0 : _link_linkedFrom_customerStoryCollection.total;
                    });
                }).map((element)=>{
                    return {
                        node: {
                            context: {
                                name: element === null || element === void 0 ? void 0 : element.regionNameExternal
                            },
                            field: "region"
                        }
                    };
                })) !== null && _contentfulStories_taxonomyRegionCollection_items_filter_map !== void 0 ? _contentfulStories_taxonomyRegionCollection_items_filter_map : [],
                ...(_contentfulStories_taxonomySolutionCollection_items_filter_map = contentfulStories === null || contentfulStories === void 0 ? void 0 : (_contentfulStories_taxonomySolutionCollection = contentfulStories.taxonomySolutionCollection) === null || _contentfulStories_taxonomySolutionCollection === void 0 ? void 0 : (_contentfulStories_taxonomySolutionCollection_items = _contentfulStories_taxonomySolutionCollection.items) === null || _contentfulStories_taxonomySolutionCollection_items === void 0 ? void 0 : _contentfulStories_taxonomySolutionCollection_items.filter((item)=>{
                    var _item_linkedFrom_customerStoryCollection, _item_linkedFrom;
                    return item === null || item === void 0 ? void 0 : (_item_linkedFrom = item.linkedFrom) === null || _item_linkedFrom === void 0 ? void 0 : (_item_linkedFrom_customerStoryCollection = _item_linkedFrom.customerStoryCollection) === null || _item_linkedFrom_customerStoryCollection === void 0 ? void 0 : _item_linkedFrom_customerStoryCollection.total;
                }).map((element)=>{
                    return {
                        node: {
                            context: {
                                name: element === null || element === void 0 ? void 0 : element.solutionNameExternal
                            },
                            field: "solution"
                        }
                    };
                })) !== null && _contentfulStories_taxonomySolutionCollection_items_filter_map !== void 0 ? _contentfulStories_taxonomySolutionCollection_items_filter_map : []
            ]
        }
    };
};

});
parcelRegister("hr57x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $faa39df086fe4063$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<aa76402dc3843fc5341fa58c523e40ae>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $faa39df086fe4063$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "locale",
        "variableName": "locale"
    }, v2 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 200
        },
        v1 /*: any*/ 
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "storyTitleExternal",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizationNameExternal",
        "storageKey": null
    }, v5 = {
        "kind": "Literal",
        "name": "limit",
        "value": 5
    }, v6 = [
        v5 /*: any*/ 
    ], v7 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contentType",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
        }
    ], v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "industryName",
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "regionNameExternal",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "companySizeTitleExternal",
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "concreteType": "CompanyNameInternal",
        "kind": "LinkedField",
        "name": "customerCompany",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "alias": null,
                "args": v6 /*: any*/ ,
                "concreteType": "AssetCollection",
                "kind": "LinkedField",
                "name": "logoCollection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": v7 /*: any*/ ,
                        "storageKey": null
                    }
                ],
                "storageKey": "logoCollection(limit:5)"
            },
            {
                "alias": null,
                "args": v6 /*: any*/ ,
                "concreteType": "CompanyNameInternalIndustryCollection",
                "kind": "LinkedField",
                "name": "industryCollection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "TaxonomyIndustry",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                            v8 /*: any*/ 
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": "industryCollection(limit:5)"
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyRegion",
                "kind": "LinkedField",
                "name": "region",
                "plural": false,
                "selections": [
                    v9 /*: any*/ 
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyCompanySize",
                "kind": "LinkedField",
                "name": "organizationSize",
                "plural": false,
                "selections": [
                    v10 /*: any*/ 
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v12 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "CustomerStoryAdvocateQuotesCollection",
        "kind": "LinkedField",
        "name": "advocateQuotesCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "AdvocateQuote",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "advocateName",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "advocateQuote",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "advocateJobTitle",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "advocateHeadshot",
                        "plural": false,
                        "selections": v7 /*: any*/ ,
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "advocateQuotesCollection(limit:5)"
    }, v13 = {
        "alias": null,
        "args": null,
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "storyIcon",
        "plural": false,
        "selections": v7 /*: any*/ ,
        "storageKey": null
    }, v14 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "CustomerStoryCallToActionCollection",
        "kind": "LinkedField",
        "name": "callToActionCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "CallToAction",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaText",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaUrl",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "callToActionCollection(limit:5)"
    }, v15 = {
        "kind": "Literal",
        "name": "limit",
        "value": 20
    }, v16 = [
        v15 /*: any*/ 
    ], v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "productName",
        "storageKey": null
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductName",
                "kind": "LinkedField",
                "name": "productNameReference",
                "plural": false,
                "selections": [
                    v17 /*: any*/ 
                ],
                "storageKey": null
            }
        ],
        "type": "ProductListing",
        "abstractKey": null
    }, v19 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "CustomerStoryMarketplaceAppsCollection",
        "kind": "LinkedField",
        "name": "marketplaceAppsCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ContextApp",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "marketplaceAppsCollection(limit:5)"
    }, v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "solutionNameExternal",
        "storageKey": null
    }, v21 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "CustomerStorySolutionCollection",
        "kind": "LinkedField",
        "name": "solutionCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomySolution",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v20 /*: any*/ 
                ],
                "storageKey": null
            }
        ],
        "storageKey": "solutionCollection(limit:5)"
    }, v22 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "CustomerStorySolutionPartnersCollection",
        "kind": "LinkedField",
        "name": "solutionPartnersCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "CompanyNameInternal",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v4 /*: any*/ 
                ],
                "storageKey": null
            }
        ],
        "storageKey": "solutionPartnersCollection(limit:5)"
    }, v23 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlSlug",
        "storageKey": null
    }, v24 = [
        v15 /*: any*/ ,
        v1 /*: any*/ 
    ], v25 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "total",
        "storageKey": null
    }, v26 = [
        {
            "kind": "Literal",
            "name": "allowedLocales",
            "value": [
                "en-US",
                "es",
                "ja-JP",
                "pt-BR",
                "fr-FR",
                "de-DE",
                "nl-NL",
                "it-IT",
                "ko-KR",
                "pl-PL",
                "ru-RU",
                "zh-CN"
            ]
        }
    ], v27 = [
        v25 /*: any*/ 
    ], v28 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 1
                }
            ],
            "concreteType": "CustomerStoryCollection",
            "kind": "LinkedField",
            "name": "customerStoryCollection",
            "plural": false,
            "selections": v27 /*: any*/ ,
            "storageKey": "customerStoryCollection(limit:1)"
        }
    ], v29 = {
        "alias": null,
        "args": v26 /*: any*/ ,
        "concreteType": "CompanyNameInternalLinkingCollections",
        "kind": "LinkedField",
        "name": "linkedFrom",
        "plural": false,
        "selections": v28 /*: any*/ ,
        "storageKey": 'linkedFrom(allowedLocales:["en-US","es","ja-JP","pt-BR","fr-FR","de-DE","nl-NL","it-IT","ko-KR","pl-PL","ru-RU","zh-CN"])'
    }, v30 = {
        "alias": null,
        "args": v24 /*: any*/ ,
        "concreteType": "TaxonomyIndustryCollection",
        "kind": "LinkedField",
        "name": "taxonomyIndustryCollection",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyIndustry",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "alias": null,
                        "args": v26 /*: any*/ ,
                        "concreteType": "TaxonomyIndustryLinkingCollections",
                        "kind": "LinkedField",
                        "name": "linkedFrom",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CompanyNameInternalCollection",
                                "kind": "LinkedField",
                                "name": "companyNameInternalCollection",
                                "plural": false,
                                "selections": [
                                    v25 /*: any*/ ,
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CompanyNameInternal",
                                        "kind": "LinkedField",
                                        "name": "items",
                                        "plural": true,
                                        "selections": [
                                            v4 /*: any*/ ,
                                            v29 /*: any*/ 
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": 'linkedFrom(allowedLocales:["en-US","es","ja-JP","pt-BR","fr-FR","de-DE","nl-NL","it-IT","ko-KR","pl-PL","ru-RU","zh-CN"])'
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v31 = {
        "alias": null,
        "args": [
            {
                "kind": "Literal",
                "name": "limit",
                "value": 25
            },
            v1 /*: any*/ 
        ],
        "concreteType": "ProductNameCollection",
        "kind": "LinkedField",
        "name": "productNameCollection",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductName",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v17 /*: any*/ ,
                    {
                        "alias": null,
                        "args": v26 /*: any*/ ,
                        "concreteType": "ProductNameLinkingCollections",
                        "kind": "LinkedField",
                        "name": "linkedFrom",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductListingCollection",
                                "kind": "LinkedField",
                                "name": "productListingCollection",
                                "plural": false,
                                "selections": [
                                    v25 /*: any*/ ,
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProductListing",
                                        "kind": "LinkedField",
                                        "name": "items",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": v26 /*: any*/ ,
                                                "concreteType": "ProductListingLinkingCollections",
                                                "kind": "LinkedField",
                                                "name": "linkedFrom",
                                                "plural": false,
                                                "selections": v28 /*: any*/ ,
                                                "storageKey": 'linkedFrom(allowedLocales:["en-US","es","ja-JP","pt-BR","fr-FR","de-DE","nl-NL","it-IT","ko-KR","pl-PL","ru-RU","zh-CN"])'
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": 'linkedFrom(allowedLocales:["en-US","es","ja-JP","pt-BR","fr-FR","de-DE","nl-NL","it-IT","ko-KR","pl-PL","ru-RU","zh-CN"])'
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v32 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "CompanyNameInternalCollection",
            "kind": "LinkedField",
            "name": "companyNameInternalCollection",
            "plural": false,
            "selections": [
                v25 /*: any*/ ,
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyNameInternal",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        v29 /*: any*/ 
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ], v33 = {
        "alias": null,
        "args": [
            {
                "kind": "Literal",
                "name": "limit",
                "value": 10
            },
            v1 /*: any*/ 
        ],
        "concreteType": "TaxonomyRegionCollection",
        "kind": "LinkedField",
        "name": "taxonomyRegionCollection",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyRegion",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v9 /*: any*/ ,
                    {
                        "alias": null,
                        "args": v26 /*: any*/ ,
                        "concreteType": "TaxonomyRegionLinkingCollections",
                        "kind": "LinkedField",
                        "name": "linkedFrom",
                        "plural": false,
                        "selections": v32 /*: any*/ ,
                        "storageKey": 'linkedFrom(allowedLocales:["en-US","es","ja-JP","pt-BR","fr-FR","de-DE","nl-NL","it-IT","ko-KR","pl-PL","ru-RU","zh-CN"])'
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v34 = {
        "alias": null,
        "args": v24 /*: any*/ ,
        "concreteType": "TaxonomySolutionCollection",
        "kind": "LinkedField",
        "name": "taxonomySolutionCollection",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomySolution",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v20 /*: any*/ ,
                    {
                        "alias": null,
                        "args": v26 /*: any*/ ,
                        "concreteType": "TaxonomySolutionLinkingCollections",
                        "kind": "LinkedField",
                        "name": "linkedFrom",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CustomerStoryCollection",
                                "kind": "LinkedField",
                                "name": "customerStoryCollection",
                                "plural": false,
                                "selections": v27 /*: any*/ ,
                                "storageKey": null
                            }
                        ],
                        "storageKey": 'linkedFrom(allowedLocales:["en-US","es","ja-JP","pt-BR","fr-FR","de-DE","nl-NL","it-IT","ko-KR","pl-PL","ru-RU","zh-CN"])'
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v35 = {
        "alias": null,
        "args": [
            v5 /*: any*/ ,
            v1 /*: any*/ 
        ],
        "concreteType": "TaxonomyCompanySizeCollection",
        "kind": "LinkedField",
        "name": "taxonomyCompanySizeCollection",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyCompanySize",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v10 /*: any*/ ,
                    {
                        "alias": null,
                        "args": v26 /*: any*/ ,
                        "concreteType": "TaxonomyCompanySizeLinkingCollections",
                        "kind": "LinkedField",
                        "name": "linkedFrom",
                        "plural": false,
                        "selections": v32 /*: any*/ ,
                        "storageKey": 'linkedFrom(allowedLocales:["en-US","es","ja-JP","pt-BR","fr-FR","de-DE","nl-NL","it-IT","ko-KR","pl-PL","ru-RU","zh-CN"])'
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "customerLandingPageRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v2 /*: any*/ ,
                    "concreteType": "CustomerStoryCollection",
                    "kind": "LinkedField",
                    "name": "customerStoryCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CustomerStory",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "CustomerStoryProductCollection",
                                    "kind": "LinkedField",
                                    "name": "productCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v18 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "productCollection(limit:20)"
                                },
                                v19 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                v30 /*: any*/ ,
                v31 /*: any*/ ,
                v33 /*: any*/ ,
                v34 /*: any*/ ,
                v35 /*: any*/ 
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "customerLandingPageRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v2 /*: any*/ ,
                    "concreteType": "CustomerStoryCollection",
                    "kind": "LinkedField",
                    "name": "customerStoryCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CustomerStory",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "CustomerStoryProductCollection",
                                    "kind": "LinkedField",
                                    "name": "productCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "__typename",
                                                    "storageKey": null
                                                },
                                                v18 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "productCollection(limit:20)"
                                },
                                v19 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                v30 /*: any*/ ,
                v31 /*: any*/ ,
                v33 /*: any*/ ,
                v34 /*: any*/ ,
                v35 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "fb7371909305d4b09cdd94a5cfde8afb",
            "id": null,
            "metadata": {},
            "name": "customerLandingPageRelayQuery",
            "operationKind": "query",
            "text": 'query customerLandingPageRelayQuery(\n  $locale: String!\n) {\n  customerStoryCollection(locale: $locale, limit: 200) {\n    items {\n      storyTitleExternal\n      customerCompany {\n        organizationNameExternal\n        logoCollection(limit: 5) {\n          items {\n            description\n            contentType\n            url\n          }\n        }\n        industryCollection(limit: 5) {\n          items {\n            industryName\n          }\n        }\n        region {\n          regionNameExternal\n        }\n        organizationSize {\n          companySizeTitleExternal\n        }\n      }\n      advocateQuotesCollection(limit: 5) {\n        items {\n          advocateName\n          advocateQuote\n          advocateJobTitle\n          advocateHeadshot {\n            description\n            contentType\n            url\n          }\n        }\n      }\n      storyIcon {\n        description\n        contentType\n        url\n      }\n      callToActionCollection(limit: 5) {\n        items {\n          ctaText\n          ctaUrl\n        }\n      }\n      productCollection(limit: 20) {\n        items {\n          __typename\n          ... on ProductListing {\n            productNameReference {\n              productName\n            }\n          }\n        }\n      }\n      marketplaceAppsCollection(limit: 5) {\n        items {\n          title\n        }\n      }\n      solutionCollection(limit: 5) {\n        items {\n          solutionNameExternal\n        }\n      }\n      solutionPartnersCollection(limit: 5) {\n        items {\n          organizationNameExternal\n        }\n      }\n      urlSlug\n    }\n  }\n  taxonomyIndustryCollection(locale: $locale, limit: 20) {\n    total\n    items {\n      industryName\n      linkedFrom(allowedLocales: ["en-US", "es", "ja-JP", "pt-BR", "fr-FR", "de-DE", "nl-NL", "it-IT", "ko-KR", "pl-PL", "ru-RU", "zh-CN"]) {\n        companyNameInternalCollection {\n          total\n          items {\n            organizationNameExternal\n            linkedFrom(allowedLocales: ["en-US", "es", "ja-JP", "pt-BR", "fr-FR", "de-DE", "nl-NL", "it-IT", "ko-KR", "pl-PL", "ru-RU", "zh-CN"]) {\n              customerStoryCollection(limit: 1) {\n                total\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  productNameCollection(locale: $locale, limit: 25) {\n    total\n    items {\n      productName\n      linkedFrom(allowedLocales: ["en-US", "es", "ja-JP", "pt-BR", "fr-FR", "de-DE", "nl-NL", "it-IT", "ko-KR", "pl-PL", "ru-RU", "zh-CN"]) {\n        productListingCollection {\n          total\n          items {\n            linkedFrom(allowedLocales: ["en-US", "es", "ja-JP", "pt-BR", "fr-FR", "de-DE", "nl-NL", "it-IT", "ko-KR", "pl-PL", "ru-RU", "zh-CN"]) {\n              customerStoryCollection(limit: 1) {\n                total\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  taxonomyRegionCollection(locale: $locale, limit: 10) {\n    total\n    items {\n      regionNameExternal\n      linkedFrom(allowedLocales: ["en-US", "es", "ja-JP", "pt-BR", "fr-FR", "de-DE", "nl-NL", "it-IT", "ko-KR", "pl-PL", "ru-RU", "zh-CN"]) {\n        companyNameInternalCollection {\n          total\n          items {\n            linkedFrom(allowedLocales: ["en-US", "es", "ja-JP", "pt-BR", "fr-FR", "de-DE", "nl-NL", "it-IT", "ko-KR", "pl-PL", "ru-RU", "zh-CN"]) {\n              customerStoryCollection(limit: 1) {\n                total\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  taxonomySolutionCollection(locale: $locale, limit: 20) {\n    total\n    items {\n      solutionNameExternal\n      linkedFrom(allowedLocales: ["en-US", "es", "ja-JP", "pt-BR", "fr-FR", "de-DE", "nl-NL", "it-IT", "ko-KR", "pl-PL", "ru-RU", "zh-CN"]) {\n        customerStoryCollection {\n          total\n        }\n      }\n    }\n  }\n  taxonomyCompanySizeCollection(locale: $locale, limit: 5) {\n    total\n    items {\n      companySizeTitleExternal\n      linkedFrom(allowedLocales: ["en-US", "es", "ja-JP", "pt-BR", "fr-FR", "de-DE", "nl-NL", "it-IT", "ko-KR", "pl-PL", "ru-RU", "zh-CN"]) {\n        companyNameInternalCollection {\n          total\n          items {\n            linkedFrom(allowedLocales: ["en-US", "es", "ja-JP", "pt-BR", "fr-FR", "de-DE", "nl-NL", "it-IT", "ko-KR", "pl-PL", "ru-RU", "zh-CN"]) {\n              customerStoryCollection(limit: 1) {\n                total\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n'
        }
    };
}();
$faa39df086fe4063$var$node.hash = "8c843ab041f86aaa1c91e2fdfd9f9c32";
var $faa39df086fe4063$export$2e2bcd8739ae039 = $faa39df086fe4063$var$node;

});


parcelRegister("200NX", function(module, exports) {

$parcel$export(module.exports, "RELAY_API_CONTENTFUL", function () { return $52ea49f8e16543b5$export$7b31a9938ec3ba75; });
const $52ea49f8e16543b5$export$7b31a9938ec3ba75 = "contentful";

});

parcelRegister("iTDk2", function(module, exports) {
$parcel$export(module.exports, "AnchorPageRelayQuery", function () { return (parcelRequire("lsqCW")).AnchorPageRelayQuery; });
$parcel$export(module.exports, "getAnchorPageRelayQueryVars", function () { return (parcelRequire("lsqCW")).getAnchorPageRelayQueryVars; });
$parcel$export(module.exports, "shapeAnchorContentfulResponse", function () { return (parcelRequire("lsqCW")).shapeAnchorContentfulResponse; });
$parcel$export(module.exports, "getPricingPageRelayQueryVars", function () { return (parcelRequire("cCupH")).getPricingPageRelayQueryVars; });
$parcel$export(module.exports, "PricingPageRelayQuery", function () { return (parcelRequire("cCupH")).PricingPageRelayQuery; });
$parcel$export(module.exports, "shapePricingContentfulResponse", function () { return (parcelRequire("cCupH")).shapePricingContentfulResponse; });
$parcel$export(module.exports, "AgileOverviewOneQuery", function () { return (parcelRequire("3oPm6")).AgileOverviewOneQuery; });
$parcel$export(module.exports, "getAgileOverviewQueryVars", function () { return (parcelRequire("3oPm6")).getAgileOverviewQueryVars; });
$parcel$export(module.exports, "AgileTutorialOneQuery", function () { return (parcelRequire("bl3E5")).AgileTutorialOneQuery; });
$parcel$export(module.exports, "getAgileTutorialQueryVars", function () { return (parcelRequire("bl3E5")).getAgileTutorialQueryVars; });
$parcel$export(module.exports, "AgileArticleOneQuery", function () { return (parcelRequire("4va49")).AgileArticleOneQuery; });
$parcel$export(module.exports, "getAgileArticleQueryVars", function () { return (parcelRequire("4va49")).getAgileArticleQueryVars; });
parcelRequire("lsqCW");
parcelRequire("cCupH");
parcelRequire("3oPm6");
parcelRequire("bl3E5");
parcelRequire("4va49");

});
parcelRegister("lsqCW", function(module, exports) {

$parcel$export(module.exports, "AnchorPageRelayQuery", function () { return $14dfe06ad6800a0f$export$102ea97ffff273aa; });
$parcel$export(module.exports, "getAnchorPageRelayQueryVars", function () { return $14dfe06ad6800a0f$export$9db61a55a3e7ac2d; });
$parcel$export(module.exports, "shapeAnchorContentfulResponse", function () { return $14dfe06ad6800a0f$export$ee86e87edca54d71; });

var $9Dbz6 = parcelRequire("9Dbz6");

var $1FkY0 = parcelRequire("1FkY0");

var $cyfPT = parcelRequire("cyfPT");
var $14dfe06ad6800a0f$var$_anchorPageRelayQuery;

const $14dfe06ad6800a0f$export$102ea97ffff273aa = $14dfe06ad6800a0f$var$_anchorPageRelayQuery !== void 0 ? $14dfe06ad6800a0f$var$_anchorPageRelayQuery : ($14dfe06ad6800a0f$var$_anchorPageRelayQuery = (parcelRequire("kKuNV")), $14dfe06ad6800a0f$var$_anchorPageRelayQuery.hash && $14dfe06ad6800a0f$var$_anchorPageRelayQuery.hash !== "b5acdf742944624a0b58eb80313c25b1" && console.error("The definition of 'anchorPageRelayQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $14dfe06ad6800a0f$var$_anchorPageRelayQuery);
const $14dfe06ad6800a0f$export$9db61a55a3e7ac2d = (cmsPageVariant, location)=>{
    const { locale: locale } = (0, $9Dbz6.parseRoute)(location);
    return {
        paidVariant: cmsPageVariant,
        locale: (0, $1FkY0.WAC_TO_CPAPI_LOCALE_MAP)[locale] || "en-US"
    };
};
function $14dfe06ad6800a0f$export$ee86e87edca54d71(data) {
    var _data_anchorCollection;
    // eslint-disable-next-line complexity
    return (_data_anchorCollection = data.anchorCollection) === null || _data_anchorCollection === void 0 ? void 0 : _data_anchorCollection.items.map((anchor)=>{
        var _anchor_personaCollection, _anchor_productCollection, _anchor_headlineCollection, _anchor_primaryMessageCollection, // eslint-disable-next-line complexity
        _anchor_bannerCollection, // eslint-disable-next-line complexity
        _anchor_resultsCollection, _anchor_socialProofCollection, _anchor_callToActionCollection;
        return {
            node: {
                name: (anchor === null || anchor === void 0 ? void 0 : anchor.anchorTitleExternal) || "",
                pageVariant: (anchor === null || anchor === void 0 ? void 0 : anchor.paidVariant) || "paid-lp-jsw-features",
                persona: (anchor === null || anchor === void 0 ? void 0 : (_anchor_personaCollection = anchor.personaCollection) === null || _anchor_personaCollection === void 0 ? void 0 : _anchor_personaCollection.items.map((persona)=>({
                        name: (persona === null || persona === void 0 ? void 0 : persona.personaNameExternal) || "",
                        id: (persona === null || persona === void 0 ? void 0 : persona.personaNameExternal) || ""
                    }))) || [],
                product: (anchor === null || anchor === void 0 ? void 0 : (_anchor_productCollection = anchor.productCollection) === null || _anchor_productCollection === void 0 ? void 0 : _anchor_productCollection.items.map((product)=>{
                    var _product_productNameReference;
                    return {
                        productNameId: (product === null || product === void 0 ? void 0 : (_product_productNameReference = product.productNameReference) === null || _product_productNameReference === void 0 ? void 0 : _product_productNameReference.productNameId) || ""
                    };
                })) || [],
                headline: (anchor === null || anchor === void 0 ? void 0 : (_anchor_headlineCollection = anchor.headlineCollection) === null || _anchor_headlineCollection === void 0 ? void 0 : _anchor_headlineCollection.items.map((headline)=>{
                    var _headline_planBenefitsCollection;
                    return {
                        name: (headline === null || headline === void 0 ? void 0 : headline.headlineTitleExternal) || null,
                        subheading: (headline === null || headline === void 0 ? void 0 : headline.headlineSubheading) || null,
                        planBenefits: (headline === null || headline === void 0 ? void 0 : (_headline_planBenefitsCollection = headline.planBenefitsCollection) === null || _headline_planBenefitsCollection === void 0 ? void 0 : _headline_planBenefitsCollection.items.map((planBenefit)=>{
                            var _planBenefit_planBenefits, _planBenefit_supportingAsset, _planBenefit_supportingAsset1, _planBenefit_planFeaturesCollection;
                            return {
                                description: (0, $cyfPT.richTextToHTML)(planBenefit === null || planBenefit === void 0 ? void 0 : (_planBenefit_planBenefits = planBenefit.planBenefits) === null || _planBenefit_planBenefits === void 0 ? void 0 : _planBenefit_planBenefits.json),
                                supportingAsset: {
                                    url: (planBenefit === null || planBenefit === void 0 ? void 0 : (_planBenefit_supportingAsset = planBenefit.supportingAsset) === null || _planBenefit_supportingAsset === void 0 ? void 0 : _planBenefit_supportingAsset.url) || "",
                                    description: (planBenefit === null || planBenefit === void 0 ? void 0 : (_planBenefit_supportingAsset1 = planBenefit.supportingAsset) === null || _planBenefit_supportingAsset1 === void 0 ? void 0 : _planBenefit_supportingAsset1.description) || ""
                                },
                                planFeatures: (planBenefit === null || planBenefit === void 0 ? void 0 : (_planBenefit_planFeaturesCollection = planBenefit.planFeaturesCollection) === null || _planBenefit_planFeaturesCollection === void 0 ? void 0 : _planBenefit_planFeaturesCollection.items.map((planFeature)=>{
                                    var _planFeature_description;
                                    return {
                                        description: (0, $cyfPT.richTextToHTML)(planFeature === null || planFeature === void 0 ? void 0 : (_planFeature_description = planFeature.description) === null || _planFeature_description === void 0 ? void 0 : _planFeature_description.json)
                                    };
                                })) || null
                            };
                        })) || []
                    };
                })) || [],
                primaryMessage: (anchor === null || anchor === void 0 ? void 0 : (_anchor_primaryMessageCollection = anchor.primaryMessageCollection) === null || _anchor_primaryMessageCollection === void 0 ? void 0 : _anchor_primaryMessageCollection.items.map((primaryMessage)=>{
                    var _primaryMessage_supportingExampleCollection;
                    return {
                        name: (primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.primaryMessageTitleExternal) || "",
                        supportingExample: (primaryMessage === null || primaryMessage === void 0 ? void 0 : (_primaryMessage_supportingExampleCollection = primaryMessage.supportingExampleCollection) === null || _primaryMessage_supportingExampleCollection === void 0 ? void 0 : _primaryMessage_supportingExampleCollection.items.map(// eslint-disable-next-line complexity
                        (supportingExample)=>{
                            var _supportingExample_proofpoint, _supportingExample_supportingAsset, _supportingExample_supportingAsset1, _supportingExample_advocateQuote_advocateHeadshot, _supportingExample_advocateQuote, _supportingExample_advocateQuote_advocateHeadshot1, _supportingExample_advocateQuote1, _supportingExample_advocateQuote2, _supportingExample_advocateQuote3, _supportingExample_advocateQuote4;
                            return {
                                proofpoint: (0, $cyfPT.richTextToHTML)(supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_proofpoint = supportingExample.proofpoint) === null || _supportingExample_proofpoint === void 0 ? void 0 : _supportingExample_proofpoint.json),
                                supportingAsset: {
                                    url: (supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_supportingAsset = supportingExample.supportingAsset) === null || _supportingExample_supportingAsset === void 0 ? void 0 : _supportingExample_supportingAsset.url) || "",
                                    description: (supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_supportingAsset1 = supportingExample.supportingAsset) === null || _supportingExample_supportingAsset1 === void 0 ? void 0 : _supportingExample_supportingAsset1.description) || ""
                                },
                                heading: (supportingExample === null || supportingExample === void 0 ? void 0 : supportingExample.supportingExampleHeading) || null,
                                name: (supportingExample === null || supportingExample === void 0 ? void 0 : supportingExample.supportingExampleTitleExternal) || "",
                                advocateQuote: !!(supportingExample === null || supportingExample === void 0 ? void 0 : supportingExample.advocateQuote) ? {
                                    advocateHeadshot: {
                                        url: (supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_advocateQuote = supportingExample.advocateQuote) === null || _supportingExample_advocateQuote === void 0 ? void 0 : (_supportingExample_advocateQuote_advocateHeadshot = _supportingExample_advocateQuote.advocateHeadshot) === null || _supportingExample_advocateQuote_advocateHeadshot === void 0 ? void 0 : _supportingExample_advocateQuote_advocateHeadshot.url) || null,
                                        description: (supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_advocateQuote1 = supportingExample.advocateQuote) === null || _supportingExample_advocateQuote1 === void 0 ? void 0 : (_supportingExample_advocateQuote_advocateHeadshot1 = _supportingExample_advocateQuote1.advocateHeadshot) === null || _supportingExample_advocateQuote_advocateHeadshot1 === void 0 ? void 0 : _supportingExample_advocateQuote_advocateHeadshot1.description) || null
                                    },
                                    advocateName: (supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_advocateQuote2 = supportingExample.advocateQuote) === null || _supportingExample_advocateQuote2 === void 0 ? void 0 : _supportingExample_advocateQuote2.advocateName) || null,
                                    advocateQuote: (supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_advocateQuote3 = supportingExample.advocateQuote) === null || _supportingExample_advocateQuote3 === void 0 ? void 0 : _supportingExample_advocateQuote3.advocateQuote) || null,
                                    advocateJobTitle: (supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_advocateQuote4 = supportingExample.advocateQuote) === null || _supportingExample_advocateQuote4 === void 0 ? void 0 : _supportingExample_advocateQuote4.advocateJobTitle) || null
                                } : null
                            };
                        })) || []
                    };
                })) || [],
                banner: (anchor === null || anchor === void 0 ? void 0 : (_anchor_bannerCollection = anchor.bannerCollection) === null || _anchor_bannerCollection === void 0 ? void 0 : _anchor_bannerCollection.items.map((banner)=>{
                    var _banner_bannerImage, _banner_bannerImage1, _banner_bannerBackground, _banner_bannerText;
                    return {
                        bannerImage: {
                            description: (banner === null || banner === void 0 ? void 0 : (_banner_bannerImage = banner.bannerImage) === null || _banner_bannerImage === void 0 ? void 0 : _banner_bannerImage.description) || null,
                            url: (banner === null || banner === void 0 ? void 0 : (_banner_bannerImage1 = banner.bannerImage) === null || _banner_bannerImage1 === void 0 ? void 0 : _banner_bannerImage1.url) || null
                        },
                        backgroundImage: {
                            url: (banner === null || banner === void 0 ? void 0 : (_banner_bannerBackground = banner.bannerBackground) === null || _banner_bannerBackground === void 0 ? void 0 : _banner_bannerBackground.url) || null
                        },
                        text: (0, $cyfPT.richTextToHTML)(banner === null || banner === void 0 ? void 0 : (_banner_bannerText = banner.bannerText) === null || _banner_bannerText === void 0 ? void 0 : _banner_bannerText.json) || "",
                        url: (banner === null || banner === void 0 ? void 0 : banner.bannerUrl) || "",
                        urlText: (banner === null || banner === void 0 ? void 0 : banner.bannerUrlText) || ""
                    };
                })) || null,
                results: (anchor === null || anchor === void 0 ? void 0 : (_anchor_resultsCollection = anchor.resultsCollection) === null || _anchor_resultsCollection === void 0 ? void 0 : _anchor_resultsCollection.items.map((result)=>{
                    var _result_sys, _result_newResultSubheading, _result_resultAsset, _result_resultAsset1, _result_resultAsset2, _result_resultAsset3, _result_resultAsset4;
                    return {
                        id: (result === null || result === void 0 ? void 0 : (_result_sys = result.sys) === null || _result_sys === void 0 ? void 0 : _result_sys.id) || "",
                        name: (result === null || result === void 0 ? void 0 : result.resultTitleExternal) || "",
                        lozenge: (result === null || result === void 0 ? void 0 : result.lozenge) || null,
                        subheading: (0, $cyfPT.richTextToHTML)(result === null || result === void 0 ? void 0 : (_result_newResultSubheading = result.newResultSubheading) === null || _result_newResultSubheading === void 0 ? void 0 : _result_newResultSubheading.json),
                        asset: {
                            url: (result === null || result === void 0 ? void 0 : (_result_resultAsset = result.resultAsset) === null || _result_resultAsset === void 0 ? void 0 : _result_resultAsset.url) || "",
                            description: (result === null || result === void 0 ? void 0 : (_result_resultAsset1 = result.resultAsset) === null || _result_resultAsset1 === void 0 ? void 0 : _result_resultAsset1.description) || "",
                            fileName: (result === null || result === void 0 ? void 0 : (_result_resultAsset2 = result.resultAsset) === null || _result_resultAsset2 === void 0 ? void 0 : _result_resultAsset2.fileName) || "",
                            title: (result === null || result === void 0 ? void 0 : (_result_resultAsset3 = result.resultAsset) === null || _result_resultAsset3 === void 0 ? void 0 : _result_resultAsset3.title) || "",
                            details: null,
                            contentType: (result === null || result === void 0 ? void 0 : (_result_resultAsset4 = result.resultAsset) === null || _result_resultAsset4 === void 0 ? void 0 : _result_resultAsset4.contentType) || ""
                        }
                    };
                })) || [],
                socialProof: (anchor === null || anchor === void 0 ? void 0 : (_anchor_socialProofCollection = anchor.socialProofCollection) === null || _anchor_socialProofCollection === void 0 ? void 0 : _anchor_socialProofCollection.items.map((proof)=>{
                    var _proof_customersCollection;
                    return {
                        name: (proof === null || proof === void 0 ? void 0 : proof.socialProofTitleExternal) || "",
                        customers: (proof === null || proof === void 0 ? void 0 : (_proof_customersCollection = proof.customersCollection) === null || _proof_customersCollection === void 0 ? void 0 : _proof_customersCollection.items.map((customer)=>{
                            var _customer_logoCollection, _customer_altDarkLogoCollection;
                            return {
                                logo: (customer === null || customer === void 0 ? void 0 : (_customer_logoCollection = customer.logoCollection) === null || _customer_logoCollection === void 0 ? void 0 : _customer_logoCollection.items.map((logo)=>({
                                        url: (logo === null || logo === void 0 ? void 0 : logo.url) || "",
                                        description: (logo === null || logo === void 0 ? void 0 : logo.description) || ""
                                    }))) || [],
                                altDarkLogo: (customer === null || customer === void 0 ? void 0 : (_customer_altDarkLogoCollection = customer.altDarkLogoCollection) === null || _customer_altDarkLogoCollection === void 0 ? void 0 : _customer_altDarkLogoCollection.items.map((darkLogo)=>({
                                        url: (darkLogo === null || darkLogo === void 0 ? void 0 : darkLogo.url) || "",
                                        description: (darkLogo === null || darkLogo === void 0 ? void 0 : darkLogo.description) || ""
                                    }))) || []
                            };
                        })) || []
                    };
                })) || [],
                callToAction: (anchor === null || anchor === void 0 ? void 0 : (_anchor_callToActionCollection = anchor.callToActionCollection) === null || _anchor_callToActionCollection === void 0 ? void 0 : _anchor_callToActionCollection.items.map((cta)=>({
                        valueProposition: (cta === null || cta === void 0 ? void 0 : cta.valueProposition) || "",
                        text: (cta === null || cta === void 0 ? void 0 : cta.ctaText) || "",
                        url: (cta === null || cta === void 0 ? void 0 : cta.ctaUrl) || ""
                    }))) || []
            }
        };
    });
}

});
parcelRegister("kKuNV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $555e7f62f17c993c$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<3210dc1da59269531585a698c5b79a75>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $555e7f62f17c993c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "paidVariant"
        }
    ], v1 = {
        "kind": "Literal",
        "name": "limit",
        "value": 1
    }, v2 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "locale",
            "variableName": "locale"
        },
        {
            "kind": "Literal",
            "name": "skip",
            "value": 0
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "paidVariant",
                    "variableName": "paidVariant"
                }
            ],
            "kind": "ObjectValue",
            "name": "where"
        }
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "anchorTitleExternal",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "paidVariant",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": [
            v1 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "where",
                "value": {
                    "personaNameExternal": "unknown"
                }
            }
        ],
        "concreteType": "AnchorPersonaCollection",
        "kind": "LinkedField",
        "name": "personaCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyPersona",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "personaNameExternal",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": 'personaCollection(limit:1,where:{"personaNameExternal":"unknown"})'
    }, v6 = [
        v1 /*: any*/ 
    ], v7 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "AnchorProductCollection",
        "kind": "LinkedField",
        "name": "productCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductListing",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductName",
                        "kind": "LinkedField",
                        "name": "productNameReference",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "productNameId",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "productCollection(limit:1)"
    }, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "headlineTitleExternal",
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "headlineSubheading",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "json",
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "concreteType": "Sys",
        "kind": "LinkedField",
        "name": "sys",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v12 = [
        {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "inline",
            "plural": true,
            "selections": [
                v11 /*: any*/ 
            ],
            "storageKey": null
        }
    ], v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    }, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
    }, v15 = [
        v13 /*: any*/ ,
        v14 /*: any*/ 
    ], v16 = {
        "alias": null,
        "args": null,
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "supportingAsset",
        "plural": false,
        "selections": v15 /*: any*/ ,
        "storageKey": null
    }, v17 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 6
        }
    ], v18 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 10
        }
    ], v19 = [
        v10 /*: any*/ 
    ], v20 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "AnchorPrimaryMessageCollection",
        "kind": "LinkedField",
        "name": "primaryMessageCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "PrimaryMessage",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "primaryMessageTitleExternal",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": v18 /*: any*/ ,
                        "concreteType": "PrimaryMessageSupportingExampleCollection",
                        "kind": "LinkedField",
                        "name": "supportingExampleCollection",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "SupportingExample",
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SupportingExampleProofpoint",
                                        "kind": "LinkedField",
                                        "name": "proofpoint",
                                        "plural": false,
                                        "selections": v19 /*: any*/ ,
                                        "storageKey": null
                                    },
                                    v16 /*: any*/ ,
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "supportingExampleHeading",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "supportingExampleTitleExternal",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AdvocateQuote",
                                        "kind": "LinkedField",
                                        "name": "advocateQuote",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Asset",
                                                "kind": "LinkedField",
                                                "name": "advocateHeadshot",
                                                "plural": false,
                                                "selections": v15 /*: any*/ ,
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "advocateName",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "advocateQuote",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "advocateJobTitle",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "supportingExampleCollection(limit:10)"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "primaryMessageCollection(limit:1)"
    }, v21 = {
        "alias": null,
        "args": [
            {
                "kind": "Literal",
                "name": "limit",
                "value": 3
            }
        ],
        "concreteType": "AnchorBannerCollection",
        "kind": "LinkedField",
        "name": "bannerCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "Banner",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bannerUrl",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "bannerImage",
                        "plural": false,
                        "selections": v15 /*: any*/ ,
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "bannerBackground",
                        "plural": false,
                        "selections": [
                            v13 /*: any*/ 
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "BannerBannerText",
                        "kind": "LinkedField",
                        "name": "bannerText",
                        "plural": false,
                        "selections": v19 /*: any*/ ,
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bannerUrlText",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "bannerCollection(limit:3)"
    }, v22 = {
        "alias": null,
        "args": v18 /*: any*/ ,
        "concreteType": "AnchorResultsCollection",
        "kind": "LinkedField",
        "name": "resultsCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "Result",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v11 /*: any*/ ,
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "resultTitleExternal",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lozenge",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "ResultNewResultSubheading",
                        "kind": "LinkedField",
                        "name": "newResultSubheading",
                        "plural": false,
                        "selections": v19 /*: any*/ ,
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "resultAsset",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fileName",
                                "storageKey": null
                            },
                            v13 /*: any*/ ,
                            v14 /*: any*/ ,
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "contentType",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "resultsCollection(limit:10)"
    }, v23 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "AnchorCallToActionCollection",
        "kind": "LinkedField",
        "name": "callToActionCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "CallToAction",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "valueProposition",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaText",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaUrl",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "callToActionCollection(limit:1)"
    }, v24 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "Asset",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": v15 /*: any*/ ,
            "storageKey": null
        }
    ], v25 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "AnchorSocialProofCollection",
        "kind": "LinkedField",
        "name": "socialProofCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "SocialProof",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "socialProofTitleExternal",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "limit",
                                "value": 16
                            }
                        ],
                        "concreteType": "SocialProofCustomersCollection",
                        "kind": "LinkedField",
                        "name": "customersCollection",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CompanyNameInternal",
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": v6 /*: any*/ ,
                                        "concreteType": "AssetCollection",
                                        "kind": "LinkedField",
                                        "name": "logoCollection",
                                        "plural": false,
                                        "selections": v24 /*: any*/ ,
                                        "storageKey": "logoCollection(limit:1)"
                                    },
                                    {
                                        "alias": null,
                                        "args": v6 /*: any*/ ,
                                        "concreteType": "AssetCollection",
                                        "kind": "LinkedField",
                                        "name": "altDarkLogoCollection",
                                        "plural": false,
                                        "selections": v24 /*: any*/ ,
                                        "storageKey": "altDarkLogoCollection(limit:1)"
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "customersCollection(limit:16)"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "socialProofCollection(limit:1)"
    }, v26 = [
        {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "inline",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                },
                v11 /*: any*/ 
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "anchorPageRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v2 /*: any*/ ,
                    "concreteType": "AnchorCollection",
                    "kind": "LinkedField",
                    "name": "anchorCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Anchor",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "AnchorHeadlineCollection",
                                    "kind": "LinkedField",
                                    "name": "headlineCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Headline",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": v6 /*: any*/ ,
                                                    "concreteType": "HeadlinePlanBenefitsCollection",
                                                    "kind": "LinkedField",
                                                    "name": "planBenefitsCollection",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "PlanBenefits",
                                                            "kind": "LinkedField",
                                                            "name": "items",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "PlanBenefitsPlanBenefits",
                                                                    "kind": "LinkedField",
                                                                    "name": "planBenefits",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "PlanBenefitsPlanBenefitsLinks",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "PlanBenefitsPlanBenefitsEntries",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "entries",
                                                                                    "plural": false,
                                                                                    "selections": v12 /*: any*/ ,
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "alias": null,
                                                                    "args": v17 /*: any*/ ,
                                                                    "concreteType": "PlanBenefitsPlanFeaturesCollection",
                                                                    "kind": "LinkedField",
                                                                    "name": "planFeaturesCollection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TaxonomyFeature",
                                                                            "kind": "LinkedField",
                                                                            "name": "items",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "TaxonomyFeatureDescription",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "description",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ ,
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "TaxonomyFeatureDescriptionLinks",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "links",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "TaxonomyFeatureDescriptionEntries",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "entries",
                                                                                                    "plural": false,
                                                                                                    "selections": v12 /*: any*/ ,
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": "planFeaturesCollection(limit:6)"
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": "planBenefitsCollection(limit:1)"
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "headlineCollection(limit:1)"
                                },
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v25 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "anchorPageRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v2 /*: any*/ ,
                    "concreteType": "AnchorCollection",
                    "kind": "LinkedField",
                    "name": "anchorCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Anchor",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "AnchorHeadlineCollection",
                                    "kind": "LinkedField",
                                    "name": "headlineCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Headline",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": v6 /*: any*/ ,
                                                    "concreteType": "HeadlinePlanBenefitsCollection",
                                                    "kind": "LinkedField",
                                                    "name": "planBenefitsCollection",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "PlanBenefits",
                                                            "kind": "LinkedField",
                                                            "name": "items",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "PlanBenefitsPlanBenefits",
                                                                    "kind": "LinkedField",
                                                                    "name": "planBenefits",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "PlanBenefitsPlanBenefitsLinks",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "PlanBenefitsPlanBenefitsEntries",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "entries",
                                                                                    "plural": false,
                                                                                    "selections": v26 /*: any*/ ,
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "alias": null,
                                                                    "args": v17 /*: any*/ ,
                                                                    "concreteType": "PlanBenefitsPlanFeaturesCollection",
                                                                    "kind": "LinkedField",
                                                                    "name": "planFeaturesCollection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TaxonomyFeature",
                                                                            "kind": "LinkedField",
                                                                            "name": "items",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "TaxonomyFeatureDescription",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "description",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ ,
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "TaxonomyFeatureDescriptionLinks",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "links",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "TaxonomyFeatureDescriptionEntries",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "entries",
                                                                                                    "plural": false,
                                                                                                    "selections": v26 /*: any*/ ,
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": "planFeaturesCollection(limit:6)"
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": "planBenefitsCollection(limit:1)"
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "headlineCollection(limit:1)"
                                },
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v25 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "c0e29d89a263bf14d5f310fa9fca5b2c",
            "id": null,
            "metadata": {},
            "name": "anchorPageRelayQuery",
            "operationKind": "query",
            "text": 'query anchorPageRelayQuery(\n  $locale: String!\n  $paidVariant: String!\n) {\n  anchorCollection(locale: $locale, where: {paidVariant: $paidVariant}, limit: 1, skip: 0) {\n    items {\n      anchorTitleExternal\n      paidVariant\n      personaCollection(limit: 1, where: {personaNameExternal: "unknown"}) {\n        items {\n          personaNameExternal\n        }\n      }\n      productCollection(limit: 1) {\n        items {\n          productNameReference {\n            productNameId\n          }\n        }\n      }\n      headlineCollection(limit: 1) {\n        items {\n          headlineTitleExternal\n          headlineSubheading\n          planBenefitsCollection(limit: 1) {\n            items {\n              planBenefits {\n                json\n                links {\n                  entries {\n                    inline {\n                      __typename\n                      sys {\n                        id\n                      }\n                    }\n                  }\n                }\n              }\n              supportingAsset {\n                url\n                description\n              }\n              planFeaturesCollection(limit: 6) {\n                items {\n                  description {\n                    json\n                    links {\n                      entries {\n                        inline {\n                          __typename\n                          sys {\n                            id\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      primaryMessageCollection(limit: 1) {\n        items {\n          primaryMessageTitleExternal\n          supportingExampleCollection(limit: 10) {\n            items {\n              proofpoint {\n                json\n              }\n              supportingAsset {\n                url\n                description\n              }\n              supportingExampleHeading\n              supportingExampleTitleExternal\n              advocateQuote {\n                advocateHeadshot {\n                  url\n                  description\n                }\n                advocateName\n                advocateQuote\n                advocateJobTitle\n              }\n            }\n          }\n        }\n      }\n      bannerCollection(limit: 3) {\n        items {\n          bannerUrl\n          bannerImage {\n            url\n            description\n          }\n          bannerBackground {\n            url\n          }\n          bannerText {\n            json\n          }\n          bannerUrlText\n        }\n      }\n      resultsCollection(limit: 10) {\n        items {\n          sys {\n            id\n          }\n          resultTitleExternal\n          lozenge\n          newResultSubheading {\n            json\n          }\n          resultAsset {\n            title\n            fileName\n            url\n            description\n            contentType\n          }\n        }\n      }\n      callToActionCollection(limit: 1) {\n        items {\n          valueProposition\n          ctaText\n          ctaUrl\n        }\n      }\n      socialProofCollection(limit: 1) {\n        items {\n          socialProofTitleExternal\n          customersCollection(limit: 16) {\n            items {\n              logoCollection(limit: 1) {\n                items {\n                  url\n                  description\n                }\n              }\n              altDarkLogoCollection(limit: 1) {\n                items {\n                  url\n                  description\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n'
        }
    };
}();
$555e7f62f17c993c$var$node.hash = "b5acdf742944624a0b58eb80313c25b1";
var $555e7f62f17c993c$export$2e2bcd8739ae039 = $555e7f62f17c993c$var$node;

});


parcelRegister("cCupH", function(module, exports) {

$parcel$export(module.exports, "PricingPageRelayQuery", function () { return $ccb2cd0b4a2b8814$export$1a50c94ee129d160; });
$parcel$export(module.exports, "getPricingPageRelayQueryVars", function () { return $ccb2cd0b4a2b8814$export$73d4337b94775e7c; });
$parcel$export(module.exports, "shapePricingContentfulResponse", function () { return $ccb2cd0b4a2b8814$export$7d2aff0545f03f9e; });

var $9Dbz6 = parcelRequire("9Dbz6");

var $1FkY0 = parcelRequire("1FkY0");

var $cyfPT = parcelRequire("cyfPT");
var $ccb2cd0b4a2b8814$var$_pricingPageRelayQuery;

const $ccb2cd0b4a2b8814$export$1a50c94ee129d160 = $ccb2cd0b4a2b8814$var$_pricingPageRelayQuery !== void 0 ? $ccb2cd0b4a2b8814$var$_pricingPageRelayQuery : ($ccb2cd0b4a2b8814$var$_pricingPageRelayQuery = (parcelRequire("jVXQQ")), $ccb2cd0b4a2b8814$var$_pricingPageRelayQuery.hash && $ccb2cd0b4a2b8814$var$_pricingPageRelayQuery.hash !== "c972d0b0a98f9d312a6714300ced3fae" && console.error("The definition of 'pricingPageRelayQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $ccb2cd0b4a2b8814$var$_pricingPageRelayQuery);
const $ccb2cd0b4a2b8814$export$73d4337b94775e7c = (productNameId, location, pricingTitleInternal = null)=>{
    const { locale: locale } = (0, $9Dbz6.parseRoute)(location);
    return {
        productNameId: productNameId,
        locale: (0, $1FkY0.WAC_TO_CPAPI_LOCALE_MAP)[locale] || "en-US",
        pricingTitleInternal: pricingTitleInternal
    };
};
const $ccb2cd0b4a2b8814$export$7d2aff0545f03f9e = (data)=>{
    // Extract pricingCollection from data if it's nested
    const pricingCollection = data.pricingCollection;
    if (!pricingCollection || !pricingCollection.items) return {
        pricings: {
            edges: []
        }
    };
    return {
        pricings: {
            // @ts-ignore
            edges: pricingCollection.items.filter(Boolean).map((item)=>{
                var _item_headline, _item_comparePlansCollection_items, _item_comparePlansCollection, _item_compareFeaturesCollection_items, _item_compareFeaturesCollection, _item_additionalDetailsCollection_items, _item_additionalDetailsCollection, _item_relatedProductCollection_items, _item_relatedProductCollection, _item_callToActionContainerCollection_items, _item_callToActionContainerCollection, _item_datacenterPlansCollection_items, _item_datacenterPlansCollection;
                var _item_pricingTitleInternal, _item_pricingTitleExternal, _item_pageDescription, _item_compareFeaturesTitle, _item_getMoreDetailsTitle;
                return {
                    __typename: "ContentPlatformPricingResultEdge",
                    node: {
                        __typename: "ContentPlatformPricing",
                        pricingTitleInternal: (_item_pricingTitleInternal = item === null || item === void 0 ? void 0 : item.pricingTitleInternal) !== null && _item_pricingTitleInternal !== void 0 ? _item_pricingTitleInternal : "",
                        pricingTitleExternal: (_item_pricingTitleExternal = item === null || item === void 0 ? void 0 : item.pricingTitleExternal) !== null && _item_pricingTitleExternal !== void 0 ? _item_pricingTitleExternal : null,
                        pageDescription: (_item_pageDescription = item === null || item === void 0 ? void 0 : item.pageDescription) !== null && _item_pageDescription !== void 0 ? _item_pageDescription : null,
                        headline: (item === null || item === void 0 ? void 0 : (_item_headline = item.headline) === null || _item_headline === void 0 ? void 0 : _item_headline.json) ? (0, $cyfPT.richTextToHTML)(item.headline.json) : null,
                        comparePlans: (item === null || item === void 0 ? void 0 : (_item_comparePlansCollection = item.comparePlansCollection) === null || _item_comparePlansCollection === void 0 ? void 0 : (_item_comparePlansCollection_items = _item_comparePlansCollection.items) === null || _item_comparePlansCollection_items === void 0 ? void 0 : _item_comparePlansCollection_items.filter(Boolean).map((plan)=>{
                            var _plan_microCtaCollection_items, _plan_microCtaCollection, _plan_highlightedFeaturesContainerCollection_items, _plan_highlightedFeaturesContainerCollection;
                            var _plan_planTitleExternal, _plan_planOneLiner, _plan_highlightedFeaturesTitle;
                            return {
                                __typename: "ContentPlatformPlan",
                                planTitleExternal: (_plan_planTitleExternal = plan === null || plan === void 0 ? void 0 : plan.planTitleExternal) !== null && _plan_planTitleExternal !== void 0 ? _plan_planTitleExternal : null,
                                planOneLiner: (_plan_planOneLiner = plan === null || plan === void 0 ? void 0 : plan.planOneLiner) !== null && _plan_planOneLiner !== void 0 ? _plan_planOneLiner : null,
                                highlightedFeaturesTitle: (_plan_highlightedFeaturesTitle = plan === null || plan === void 0 ? void 0 : plan.highlightedFeaturesTitle) !== null && _plan_highlightedFeaturesTitle !== void 0 ? _plan_highlightedFeaturesTitle : null,
                                microCta: (plan === null || plan === void 0 ? void 0 : (_plan_microCtaCollection = plan.microCtaCollection) === null || _plan_microCtaCollection === void 0 ? void 0 : (_plan_microCtaCollection_items = _plan_microCtaCollection.items) === null || _plan_microCtaCollection_items === void 0 ? void 0 : _plan_microCtaCollection_items.filter(Boolean).map((cta)=>{
                                    var _cta_ctaMicrocopyTitleExternal, _cta_ctaButtonText, _cta_ctaUrl;
                                    return {
                                        __typename: "ContentPlatformCallToActionMicrocopy",
                                        ctaMicrocopyTitle: (_cta_ctaMicrocopyTitleExternal = cta === null || cta === void 0 ? void 0 : cta.ctaMicrocopyTitleExternal) !== null && _cta_ctaMicrocopyTitleExternal !== void 0 ? _cta_ctaMicrocopyTitleExternal : null,
                                        ctaButtonText: (_cta_ctaButtonText = cta === null || cta === void 0 ? void 0 : cta.ctaButtonText) !== null && _cta_ctaButtonText !== void 0 ? _cta_ctaButtonText : null,
                                        ctaUrl: (_cta_ctaUrl = cta === null || cta === void 0 ? void 0 : cta.ctaUrl) !== null && _cta_ctaUrl !== void 0 ? _cta_ctaUrl : null
                                    };
                                })) || [],
                                highlightedFeaturesContainer: (plan === null || plan === void 0 ? void 0 : (_plan_highlightedFeaturesContainerCollection = plan.highlightedFeaturesContainerCollection) === null || _plan_highlightedFeaturesContainerCollection === void 0 ? void 0 : (_plan_highlightedFeaturesContainerCollection_items = _plan_highlightedFeaturesContainerCollection.items) === null || _plan_highlightedFeaturesContainerCollection_items === void 0 ? void 0 : _plan_highlightedFeaturesContainerCollection_items.filter(Boolean).map((feature)=>{
                                    var _feature_highlightedFeatureDetails;
                                    var _feature_highlightedFeatureTitleExternal, _feature_callOut;
                                    return {
                                        __typename: "ContentPlatformHighlightedFeature",
                                        highlightedFeatureDetails: (feature === null || feature === void 0 ? void 0 : (_feature_highlightedFeatureDetails = feature.highlightedFeatureDetails) === null || _feature_highlightedFeatureDetails === void 0 ? void 0 : _feature_highlightedFeatureDetails.json) ? (0, $cyfPT.richTextToHTML)(feature.highlightedFeatureDetails.json) : null,
                                        highlightedFeatureTitleExternal: (_feature_highlightedFeatureTitleExternal = feature === null || feature === void 0 ? void 0 : feature.highlightedFeatureTitleExternal) !== null && _feature_highlightedFeatureTitleExternal !== void 0 ? _feature_highlightedFeatureTitleExternal : null,
                                        callOut: (_feature_callOut = feature === null || feature === void 0 ? void 0 : feature.callOut) !== null && _feature_callOut !== void 0 ? _feature_callOut : null
                                    };
                                })) || []
                            };
                        })) || [],
                        compareFeaturesTitle: (_item_compareFeaturesTitle = item === null || item === void 0 ? void 0 : item.compareFeaturesTitle) !== null && _item_compareFeaturesTitle !== void 0 ? _item_compareFeaturesTitle : null,
                        compareFeatures: (item === null || item === void 0 ? void 0 : (_item_compareFeaturesCollection = item.compareFeaturesCollection) === null || _item_compareFeaturesCollection === void 0 ? void 0 : (_item_compareFeaturesCollection_items = _item_compareFeaturesCollection.items) === null || _item_compareFeaturesCollection_items === void 0 ? void 0 : _item_compareFeaturesCollection_items.filter(Boolean).map((featureGroup)=>{
                            var _featureGroup_featuresCollection_items, _featureGroup_featuresCollection;
                            var _featureGroup_featureGroupTitleExternal;
                            return {
                                __typename: "ContentPlatformFeatureGroup",
                                featureGroupTitleExternal: (_featureGroup_featureGroupTitleExternal = featureGroup === null || featureGroup === void 0 ? void 0 : featureGroup.featureGroupTitleExternal) !== null && _featureGroup_featureGroupTitleExternal !== void 0 ? _featureGroup_featureGroupTitleExternal : null,
                                features: (featureGroup === null || featureGroup === void 0 ? void 0 : (_featureGroup_featuresCollection = featureGroup.featuresCollection) === null || _featureGroup_featuresCollection === void 0 ? void 0 : (_featureGroup_featuresCollection_items = _featureGroup_featuresCollection.items) === null || _featureGroup_featuresCollection_items === void 0 ? void 0 : _featureGroup_featuresCollection_items.filter(Boolean).map((feature)=>{
                                    var _feature_description, _feature_relevantPlanCollection_items, _feature_relevantPlanCollection, _feature_featureAdditionalInformationCollection_items, _feature_featureAdditionalInformationCollection;
                                    var _feature_callOut, _feature_featureNameExternal, _feature_relevantUrl;
                                    return {
                                        __typename: "ContentPlatformFeature",
                                        callOut: (_feature_callOut = feature === null || feature === void 0 ? void 0 : feature.callOut) !== null && _feature_callOut !== void 0 ? _feature_callOut : null,
                                        featureNameExternal: (_feature_featureNameExternal = feature === null || feature === void 0 ? void 0 : feature.featureNameExternal) !== null && _feature_featureNameExternal !== void 0 ? _feature_featureNameExternal : null,
                                        description: (feature === null || feature === void 0 ? void 0 : (_feature_description = feature.description) === null || _feature_description === void 0 ? void 0 : _feature_description.json) ? (0, $cyfPT.richTextToHTML)(feature.description.json) : null,
                                        relevantPlan: (feature === null || feature === void 0 ? void 0 : (_feature_relevantPlanCollection = feature.relevantPlanCollection) === null || _feature_relevantPlanCollection === void 0 ? void 0 : (_feature_relevantPlanCollection_items = _feature_relevantPlanCollection.items) === null || _feature_relevantPlanCollection_items === void 0 ? void 0 : _feature_relevantPlanCollection_items.filter(Boolean).map((plan)=>{
                                            var _plan_planTitleExternal;
                                            return {
                                                __typename: "ContentPlatformPlan",
                                                planTitleExternal: (_plan_planTitleExternal = plan === null || plan === void 0 ? void 0 : plan.planTitleExternal) !== null && _plan_planTitleExternal !== void 0 ? _plan_planTitleExternal : null
                                            };
                                        })) || [],
                                        relevantUrl: (_feature_relevantUrl = feature === null || feature === void 0 ? void 0 : feature.relevantUrl) !== null && _feature_relevantUrl !== void 0 ? _feature_relevantUrl : null,
                                        featureAdditionalInformation: (feature === null || feature === void 0 ? void 0 : (_feature_featureAdditionalInformationCollection = feature.featureAdditionalInformationCollection) === null || _feature_featureAdditionalInformationCollection === void 0 ? void 0 : (_feature_featureAdditionalInformationCollection_items = _feature_featureAdditionalInformationCollection.items) === null || _feature_featureAdditionalInformationCollection_items === void 0 ? void 0 : _feature_featureAdditionalInformationCollection_items.filter(Boolean).map((info)=>{
                                            var _info_relevantPlanCollection_items, _info_relevantPlanCollection;
                                            var _info_featureAdditionalInformation;
                                            return {
                                                __typename: "ContentPlatformFeatureAdditionalInformation",
                                                featureAdditionalInformation: (_info_featureAdditionalInformation = info === null || info === void 0 ? void 0 : info.featureAdditionalInformation) !== null && _info_featureAdditionalInformation !== void 0 ? _info_featureAdditionalInformation : null,
                                                relevantPlan: (info === null || info === void 0 ? void 0 : (_info_relevantPlanCollection = info.relevantPlanCollection) === null || _info_relevantPlanCollection === void 0 ? void 0 : (_info_relevantPlanCollection_items = _info_relevantPlanCollection.items) === null || _info_relevantPlanCollection_items === void 0 ? void 0 : _info_relevantPlanCollection_items.filter(Boolean).map((plan)=>{
                                                    var _plan_planTitleExternal;
                                                    return {
                                                        __typename: "ContentPlatformPlan",
                                                        planTitleExternal: (_plan_planTitleExternal = plan === null || plan === void 0 ? void 0 : plan.planTitleExternal) !== null && _plan_planTitleExternal !== void 0 ? _plan_planTitleExternal : null
                                                    };
                                                })) || []
                                            };
                                        })) || []
                                    };
                                })) || []
                            };
                        })) || [],
                        getMoreDetailsTitle: (_item_getMoreDetailsTitle = item === null || item === void 0 ? void 0 : item.getMoreDetailsTitle) !== null && _item_getMoreDetailsTitle !== void 0 ? _item_getMoreDetailsTitle : null,
                        additionalDetails: (item === null || item === void 0 ? void 0 : (_item_additionalDetailsCollection = item.additionalDetailsCollection) === null || _item_additionalDetailsCollection === void 0 ? void 0 : (_item_additionalDetailsCollection_items = _item_additionalDetailsCollection.items) === null || _item_additionalDetailsCollection_items === void 0 ? void 0 : _item_additionalDetailsCollection_items.filter(Boolean).map((detail)=>{
                            var _detail_planAdditionalDetails;
                            var _detail_planAdditionalDetailsTitleExternal;
                            return {
                                __typename: "ContentPlatformPlanDetails",
                                planAdditionalDetailsTitleExternal: (_detail_planAdditionalDetailsTitleExternal = detail === null || detail === void 0 ? void 0 : detail.planAdditionalDetailsTitleExternal) !== null && _detail_planAdditionalDetailsTitleExternal !== void 0 ? _detail_planAdditionalDetailsTitleExternal : null,
                                planAdditionalDetails: (detail === null || detail === void 0 ? void 0 : (_detail_planAdditionalDetails = detail.planAdditionalDetails) === null || _detail_planAdditionalDetails === void 0 ? void 0 : _detail_planAdditionalDetails.json) ? (0, $cyfPT.richTextToHTML)(detail.planAdditionalDetails.json) : null
                            };
                        })) || [],
                        relatedProduct: (item === null || item === void 0 ? void 0 : (_item_relatedProductCollection = item.relatedProductCollection) === null || _item_relatedProductCollection === void 0 ? void 0 : (_item_relatedProductCollection_items = _item_relatedProductCollection.items) === null || _item_relatedProductCollection_items === void 0 ? void 0 : _item_relatedProductCollection_items.filter(Boolean).map((product)=>{
                            var _product_productName, _product_productNameId;
                            return {
                                __typename: "ContentPlatformPricingProductName",
                                productName: (_product_productName = product === null || product === void 0 ? void 0 : product.productName) !== null && _product_productName !== void 0 ? _product_productName : "",
                                productNameId: (_product_productNameId = product === null || product === void 0 ? void 0 : product.productNameId) !== null && _product_productNameId !== void 0 ? _product_productNameId : ""
                            };
                        })) || [],
                        callToActionContainer: (item === null || item === void 0 ? void 0 : (_item_callToActionContainerCollection = item.callToActionContainerCollection) === null || _item_callToActionContainerCollection === void 0 ? void 0 : (_item_callToActionContainerCollection_items = _item_callToActionContainerCollection.items) === null || _item_callToActionContainerCollection_items === void 0 ? void 0 : _item_callToActionContainerCollection_items.filter(Boolean).map((cta)=>{
                            var _cta_ctaTitleExternal, _cta_valueProposition, _cta_ctaText, _cta_ctaUrl, _cta_ctaAsset_title, _cta_ctaAsset_description, _cta_ctaAsset_url, _cta_ctaMicrocopyTitleExternal, _cta_ctaButtonText, _cta_ctaUrl1;
                            if (cta && ("ctaTitleExternal" in cta || "valueProposition" in cta || "ctaText" in cta || "ctaAsset" in cta)) // ContentPlatformCallToAction
                            return {
                                __typename: "ContentPlatformCallToAction",
                                title: (_cta_ctaTitleExternal = cta.ctaTitleExternal) !== null && _cta_ctaTitleExternal !== void 0 ? _cta_ctaTitleExternal : null,
                                valueProposition: (_cta_valueProposition = cta.valueProposition) !== null && _cta_valueProposition !== void 0 ? _cta_valueProposition : null,
                                text: (_cta_ctaText = cta.ctaText) !== null && _cta_ctaText !== void 0 ? _cta_ctaText : null,
                                url: (_cta_ctaUrl = cta.ctaUrl) !== null && _cta_ctaUrl !== void 0 ? _cta_ctaUrl : null,
                                asset: cta.ctaAsset ? {
                                    __typename: "ContentPlatformTemplateImageAsset",
                                    title: (_cta_ctaAsset_title = cta.ctaAsset.title) !== null && _cta_ctaAsset_title !== void 0 ? _cta_ctaAsset_title : null,
                                    description: (_cta_ctaAsset_description = cta.ctaAsset.description) !== null && _cta_ctaAsset_description !== void 0 ? _cta_ctaAsset_description : null,
                                    url: (_cta_ctaAsset_url = cta.ctaAsset.url) !== null && _cta_ctaAsset_url !== void 0 ? _cta_ctaAsset_url : ""
                                } : null
                            };
                            else if (cta && ("ctaMicrocopyTitleExternal" in cta || "ctaButtonText" in cta)) // ContentPlatformCallToActionMicrocopy
                            return {
                                __typename: "ContentPlatformCallToActionMicrocopy",
                                ctaMicrocopyTitle: (_cta_ctaMicrocopyTitleExternal = cta.ctaMicrocopyTitleExternal) !== null && _cta_ctaMicrocopyTitleExternal !== void 0 ? _cta_ctaMicrocopyTitleExternal : null,
                                ctaButtonText: (_cta_ctaButtonText = cta.ctaButtonText) !== null && _cta_ctaButtonText !== void 0 ? _cta_ctaButtonText : null,
                                ctaUrl: (_cta_ctaUrl1 = cta.ctaUrl) !== null && _cta_ctaUrl1 !== void 0 ? _cta_ctaUrl1 : null
                            };
                            // Filter null values at the map level
                            return null;
                        }).filter(Boolean)) || [],
                        datacenterPlans: (item === null || item === void 0 ? void 0 : (_item_datacenterPlansCollection = item.datacenterPlansCollection) === null || _item_datacenterPlansCollection === void 0 ? void 0 : (_item_datacenterPlansCollection_items = _item_datacenterPlansCollection.items) === null || _item_datacenterPlansCollection_items === void 0 ? void 0 : _item_datacenterPlansCollection_items.filter(Boolean).map((datacenterPlan)=>{
                            var _datacenterPlan_microCtaCollection_items, _datacenterPlan_microCtaCollection, _datacenterPlan_highlightedFeaturesContainerCollection_items, _datacenterPlan_highlightedFeaturesContainerCollection;
                            var _datacenterPlan_planTitleExternal, _datacenterPlan_planOneLiner, _datacenterPlan_highlightedFeaturesTitle;
                            return {
                                __typename: "ContentPlatformPlan",
                                planTitleExternal: (_datacenterPlan_planTitleExternal = datacenterPlan === null || datacenterPlan === void 0 ? void 0 : datacenterPlan.planTitleExternal) !== null && _datacenterPlan_planTitleExternal !== void 0 ? _datacenterPlan_planTitleExternal : null,
                                planOneLiner: (_datacenterPlan_planOneLiner = datacenterPlan === null || datacenterPlan === void 0 ? void 0 : datacenterPlan.planOneLiner) !== null && _datacenterPlan_planOneLiner !== void 0 ? _datacenterPlan_planOneLiner : null,
                                microCta: (datacenterPlan === null || datacenterPlan === void 0 ? void 0 : (_datacenterPlan_microCtaCollection = datacenterPlan.microCtaCollection) === null || _datacenterPlan_microCtaCollection === void 0 ? void 0 : (_datacenterPlan_microCtaCollection_items = _datacenterPlan_microCtaCollection.items) === null || _datacenterPlan_microCtaCollection_items === void 0 ? void 0 : _datacenterPlan_microCtaCollection_items.filter(Boolean).map((cta)=>{
                                    var _cta_ctaMicrocopyTitleExternal, _cta_ctaButtonText, _cta_ctaUrl;
                                    return {
                                        __typename: "ContentPlatformCallToActionMicrocopy",
                                        ctaMicrocopyTitle: (_cta_ctaMicrocopyTitleExternal = cta === null || cta === void 0 ? void 0 : cta.ctaMicrocopyTitleExternal) !== null && _cta_ctaMicrocopyTitleExternal !== void 0 ? _cta_ctaMicrocopyTitleExternal : null,
                                        ctaButtonText: (_cta_ctaButtonText = cta === null || cta === void 0 ? void 0 : cta.ctaButtonText) !== null && _cta_ctaButtonText !== void 0 ? _cta_ctaButtonText : null,
                                        ctaUrl: (_cta_ctaUrl = cta === null || cta === void 0 ? void 0 : cta.ctaUrl) !== null && _cta_ctaUrl !== void 0 ? _cta_ctaUrl : null
                                    };
                                })) || [],
                                highlightedFeaturesTitle: (_datacenterPlan_highlightedFeaturesTitle = datacenterPlan === null || datacenterPlan === void 0 ? void 0 : datacenterPlan.highlightedFeaturesTitle) !== null && _datacenterPlan_highlightedFeaturesTitle !== void 0 ? _datacenterPlan_highlightedFeaturesTitle : null,
                                highlightedFeaturesContainer: (datacenterPlan === null || datacenterPlan === void 0 ? void 0 : (_datacenterPlan_highlightedFeaturesContainerCollection = datacenterPlan.highlightedFeaturesContainerCollection) === null || _datacenterPlan_highlightedFeaturesContainerCollection === void 0 ? void 0 : (_datacenterPlan_highlightedFeaturesContainerCollection_items = _datacenterPlan_highlightedFeaturesContainerCollection.items) === null || _datacenterPlan_highlightedFeaturesContainerCollection_items === void 0 ? void 0 : _datacenterPlan_highlightedFeaturesContainerCollection_items.filter(Boolean).map((feature)=>{
                                    var _feature_highlightedFeatureDetails;
                                    var _feature_highlightedFeatureTitleExternal, _feature_callOut;
                                    return {
                                        __typename: "ContentPlatformHighlightedFeature",
                                        highlightedFeatureDetails: (feature === null || feature === void 0 ? void 0 : (_feature_highlightedFeatureDetails = feature.highlightedFeatureDetails) === null || _feature_highlightedFeatureDetails === void 0 ? void 0 : _feature_highlightedFeatureDetails.json) ? (0, $cyfPT.richTextToHTML)(feature.highlightedFeatureDetails.json) : null,
                                        highlightedFeatureTitleExternal: (_feature_highlightedFeatureTitleExternal = feature === null || feature === void 0 ? void 0 : feature.highlightedFeatureTitleExternal) !== null && _feature_highlightedFeatureTitleExternal !== void 0 ? _feature_highlightedFeatureTitleExternal : null,
                                        callOut: (_feature_callOut = feature === null || feature === void 0 ? void 0 : feature.callOut) !== null && _feature_callOut !== void 0 ? _feature_callOut : null
                                    };
                                })) || []
                            };
                        })) || []
                    }
                };
            })
        }
    };
};

});
parcelRegister("jVXQQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $219c2058fa11fde4$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<68677983e365c2fac9b611a2c95e4014>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $219c2058fa11fde4$var$node = function() {
    var v0 = {
        "defaultValue": 1,
        "kind": "LocalArgument",
        "name": "limit"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locale"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pricingTitleInternal"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "productNameId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "locale",
            "variableName": "locale"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "pricingTitleInternal_contains",
                    "variableName": "pricingTitleInternal"
                },
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "productNameId_contains",
                            "variableName": "productNameId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "relatedProduct"
                }
            ],
            "kind": "ObjectValue",
            "name": "where"
        }
    ], v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pricingTitleInternal",
        "storageKey": null
    }, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pricingTitleExternal",
        "storageKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pageDescription",
        "storageKey": null
    }, v8 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "json",
            "storageKey": null
        }
    ], v9 = {
        "alias": null,
        "args": null,
        "concreteType": "PricingHeadline",
        "kind": "LinkedField",
        "name": "headline",
        "plural": false,
        "selections": v8 /*: any*/ ,
        "storageKey": null
    }, v10 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 10
        }
    ], v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "planTitleExternal",
        "storageKey": null
    }, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "planOneLiner",
        "storageKey": null
    }, v13 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 15
        }
    ], v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ctaUrl",
        "storageKey": null
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ctaMicrocopyTitleExternal",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ctaButtonText",
                "storageKey": null
            },
            v14 /*: any*/ 
        ],
        "type": "CallToActionMicrocopy",
        "abstractKey": null
    }, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "highlightedFeaturesTitle",
        "storageKey": null
    }, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "callOut",
        "storageKey": null
    }, v18 = {
        "alias": null,
        "args": v13 /*: any*/ ,
        "concreteType": "PlanHighlightedFeaturesContainerCollection",
        "kind": "LinkedField",
        "name": "highlightedFeaturesContainerCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "HighlightedFeature",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "HighlightedFeatureHighlightedFeatureDetails",
                        "kind": "LinkedField",
                        "name": "highlightedFeatureDetails",
                        "plural": false,
                        "selections": v8 /*: any*/ ,
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "highlightedFeatureTitleExternal",
                        "storageKey": null
                    },
                    v17 /*: any*/ 
                ],
                "storageKey": null
            }
        ],
        "storageKey": "highlightedFeaturesContainerCollection(limit:15)"
    }, v19 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                {
                    "alias": null,
                    "args": v13 /*: any*/ ,
                    "concreteType": "PlanMicroCtaCollection",
                    "kind": "LinkedField",
                    "name": "microCtaCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v15 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": "microCtaCollection(limit:15)"
                },
                v16 /*: any*/ ,
                v18 /*: any*/ 
            ],
            "storageKey": null
        }
    ], v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "compareFeaturesTitle",
        "storageKey": null
    }, v21 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
                v11 /*: any*/ 
            ],
            "storageKey": null
        }
    ], v22 = {
        "alias": null,
        "args": v10 /*: any*/ ,
        "concreteType": "PricingCompareFeaturesCollection",
        "kind": "LinkedField",
        "name": "compareFeaturesCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "FeatureGroup",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "featureGroupTitleExternal",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "limit",
                                "value": 20
                            }
                        ],
                        "concreteType": "FeatureGroupFeaturesCollection",
                        "kind": "LinkedField",
                        "name": "featuresCollection",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Feature",
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                    v17 /*: any*/ ,
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "featureNameExternal",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FeatureDescription",
                                        "kind": "LinkedField",
                                        "name": "description",
                                        "plural": false,
                                        "selections": v8 /*: any*/ ,
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FeatureRelevantPlanCollection",
                                        "kind": "LinkedField",
                                        "name": "relevantPlanCollection",
                                        "plural": false,
                                        "selections": v21 /*: any*/ ,
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "relevantUrl",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": v13 /*: any*/ ,
                                        "concreteType": "FeatureFeatureAdditionalInformationCollection",
                                        "kind": "LinkedField",
                                        "name": "featureAdditionalInformationCollection",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "FeatureAdditionalInformation",
                                                "kind": "LinkedField",
                                                "name": "items",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "featureAdditionalInformation",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": v13 /*: any*/ ,
                                                        "concreteType": "FeatureAdditionalInformationRelevantPlanCollection",
                                                        "kind": "LinkedField",
                                                        "name": "relevantPlanCollection",
                                                        "plural": false,
                                                        "selections": v21 /*: any*/ ,
                                                        "storageKey": "relevantPlanCollection(limit:15)"
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": "featureAdditionalInformationCollection(limit:15)"
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "featuresCollection(limit:20)"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "compareFeaturesCollection(limit:10)"
    }, v23 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "getMoreDetailsTitle",
        "storageKey": null
    }, v24 = {
        "alias": null,
        "args": v13 /*: any*/ ,
        "concreteType": "PricingAdditionalDetailsCollection",
        "kind": "LinkedField",
        "name": "additionalDetailsCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "PlanDetails",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "planAdditionalDetailsTitleExternal",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "PlanDetailsPlanAdditionalDetails",
                        "kind": "LinkedField",
                        "name": "planAdditionalDetails",
                        "plural": false,
                        "selections": v8 /*: any*/ ,
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "additionalDetailsCollection(limit:15)"
    }, v25 = {
        "alias": null,
        "args": [
            {
                "kind": "Literal",
                "name": "limit",
                "value": 1
            }
        ],
        "concreteType": "PricingRelatedProductCollection",
        "kind": "LinkedField",
        "name": "relatedProductCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductName",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "productName",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "productNameId",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "relatedProductCollection(limit:1)"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ctaTitleExternal",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "valueProposition",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ctaText",
                "storageKey": null
            },
            v14 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "Asset",
                "kind": "LinkedField",
                "name": "ctaAsset",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "CallToAction",
        "abstractKey": null
    }, v27 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v28 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                {
                    "alias": null,
                    "args": v13 /*: any*/ ,
                    "concreteType": "PlanMicroCtaCollection",
                    "kind": "LinkedField",
                    "name": "microCtaCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v27 /*: any*/ ,
                                v15 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": "microCtaCollection(limit:15)"
                },
                v16 /*: any*/ ,
                v18 /*: any*/ 
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "pricingPageRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v4 /*: any*/ ,
                    "concreteType": "PricingCollection",
                    "kind": "LinkedField",
                    "name": "pricingCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Pricing",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingComparePlansCollection",
                                    "kind": "LinkedField",
                                    "name": "comparePlansCollection",
                                    "plural": false,
                                    "selections": v19 /*: any*/ ,
                                    "storageKey": "comparePlansCollection(limit:10)"
                                },
                                v20 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingCallToActionContainerCollection",
                                    "kind": "LinkedField",
                                    "name": "callToActionContainerCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v26 /*: any*/ ,
                                                v15 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "callToActionContainerCollection(limit:10)"
                                },
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingDatacenterPlansCollection",
                                    "kind": "LinkedField",
                                    "name": "datacenterPlansCollection",
                                    "plural": false,
                                    "selections": v19 /*: any*/ ,
                                    "storageKey": "datacenterPlansCollection(limit:10)"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "pricingPageRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v4 /*: any*/ ,
                    "concreteType": "PricingCollection",
                    "kind": "LinkedField",
                    "name": "pricingCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Pricing",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingComparePlansCollection",
                                    "kind": "LinkedField",
                                    "name": "comparePlansCollection",
                                    "plural": false,
                                    "selections": v28 /*: any*/ ,
                                    "storageKey": "comparePlansCollection(limit:10)"
                                },
                                v20 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingCallToActionContainerCollection",
                                    "kind": "LinkedField",
                                    "name": "callToActionContainerCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v27 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v15 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "callToActionContainerCollection(limit:10)"
                                },
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingDatacenterPlansCollection",
                                    "kind": "LinkedField",
                                    "name": "datacenterPlansCollection",
                                    "plural": false,
                                    "selections": v28 /*: any*/ ,
                                    "storageKey": "datacenterPlansCollection(limit:10)"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "8811cd880e6f31899681a2925b8a3e71",
            "id": null,
            "metadata": {},
            "name": "pricingPageRelayQuery",
            "operationKind": "query",
            "text": "query pricingPageRelayQuery(\n  $limit: Int = 1\n  $productNameId: String!\n  $locale: String!\n  $pricingTitleInternal: String = null\n) {\n  pricingCollection(limit: $limit, where: {relatedProduct: {productNameId_contains: $productNameId}, pricingTitleInternal_contains: $pricingTitleInternal}, locale: $locale) {\n    items {\n      pricingTitleInternal\n      pricingTitleExternal\n      pageDescription\n      headline {\n        json\n      }\n      comparePlansCollection(limit: 10) {\n        items {\n          planTitleExternal\n          planOneLiner\n          microCtaCollection(limit: 15) {\n            items {\n              __typename\n              ... on CallToActionMicrocopy {\n                ctaMicrocopyTitleExternal\n                ctaButtonText\n                ctaUrl\n              }\n            }\n          }\n          highlightedFeaturesTitle\n          highlightedFeaturesContainerCollection(limit: 15) {\n            items {\n              highlightedFeatureDetails {\n                json\n              }\n              highlightedFeatureTitleExternal\n              callOut\n            }\n          }\n        }\n      }\n      compareFeaturesTitle\n      compareFeaturesCollection(limit: 10) {\n        items {\n          featureGroupTitleExternal\n          featuresCollection(limit: 20) {\n            items {\n              callOut\n              featureNameExternal\n              description {\n                json\n              }\n              relevantPlanCollection {\n                items {\n                  planTitleExternal\n                }\n              }\n              relevantUrl\n              featureAdditionalInformationCollection(limit: 15) {\n                items {\n                  featureAdditionalInformation\n                  relevantPlanCollection(limit: 15) {\n                    items {\n                      planTitleExternal\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      getMoreDetailsTitle\n      additionalDetailsCollection(limit: 15) {\n        items {\n          planAdditionalDetailsTitleExternal\n          planAdditionalDetails {\n            json\n          }\n        }\n      }\n      relatedProductCollection(limit: 1) {\n        items {\n          productName\n          productNameId\n        }\n      }\n      callToActionContainerCollection(limit: 10) {\n        items {\n          __typename\n          ... on CallToAction {\n            ctaTitleExternal\n            valueProposition\n            ctaText\n            ctaUrl\n            ctaAsset {\n              title\n              description\n              url\n            }\n          }\n          ... on CallToActionMicrocopy {\n            ctaMicrocopyTitleExternal\n            ctaButtonText\n            ctaUrl\n          }\n        }\n      }\n      datacenterPlansCollection(limit: 10) {\n        items {\n          planTitleExternal\n          planOneLiner\n          microCtaCollection(limit: 15) {\n            items {\n              __typename\n              ... on CallToActionMicrocopy {\n                ctaMicrocopyTitleExternal\n                ctaButtonText\n                ctaUrl\n              }\n            }\n          }\n          highlightedFeaturesTitle\n          highlightedFeaturesContainerCollection(limit: 15) {\n            items {\n              highlightedFeatureDetails {\n                json\n              }\n              highlightedFeatureTitleExternal\n              callOut\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$219c2058fa11fde4$var$node.hash = "c972d0b0a98f9d312a6714300ced3fae";
var $219c2058fa11fde4$export$2e2bcd8739ae039 = $219c2058fa11fde4$var$node;

});



parcelRegister("a6B8g", function(module, exports) {

$parcel$export(module.exports, "FourOhFourPage", function () { return $2f0db47d14246c69$export$20dde44a04c91eb6; });
// @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $luVwe = parcelRequire("luVwe");
const $2f0db47d14246c69$export$20dde44a04c91eb6 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $luVwe.FourOhFourPageTemplate), {});

});
parcelRegister("luVwe", function(module, exports) {

$parcel$export(module.exports, "FourOhFourPageTemplate", function () { return $7767538b4499ca14$export$580adf4c24c28053; });
// @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $kex29 = parcelRequire("kex29");

var $cP0Yq = parcelRequire("cP0Yq");

var $eXdLM = parcelRequire("eXdLM");
const $7767538b4499ca14$export$580adf4c24c28053 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.default), {
                    isShowTryNowLink: true,
                    tryNowLinkCtaButtonColor: "light_grey",
                    productKey: "404"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eXdLM.MainSection), {})
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
        ]
    });
};

});


parcelRegister("7dX9c", function(module, exports) {

$parcel$export(module.exports, "AgileArticlePage", function () { return $1b290d147c157158$export$9e69bbfb3c3216a1; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");

var $i8kxh = parcelRequire("i8kxh");

var $gkV6l = parcelRequire("gkV6l");

var $4himv = parcelRequire("4himv");

var $4va49 = parcelRequire("4va49");

var $4LEyf = parcelRequire("4LEyf");

var $60ddw = parcelRequire("60ddw");
const $1b290d147c157158$export$9e69bbfb3c3216a1 = ({ agileArticle: agileArticle, queryRef: queryRef, location: location })=>{
    var _dataPartOne_articleDetailsCollection, _dataPartTwo_articleDetailsCollection;
    const dataPartOne = (0, $hOqV7.usePreloadedQuery)((0, $4va49.AgileArticleOneQuery), queryRef);
    const dataPartTwo = (0, $hOqV7.useLazyLoadQuery)((0, $4va49.AgileArticleTwoQuery), (0, $4va49.getAgileArticleQueryVars)(location));
    const combinedData = {
        articleDetailsCollection: {
            items: [
                (0, $7Knp0._)({}, (_dataPartOne_articleDetailsCollection = dataPartOne.articleDetailsCollection) === null || _dataPartOne_articleDetailsCollection === void 0 ? void 0 : _dataPartOne_articleDetailsCollection.items[0], (_dataPartTwo_articleDetailsCollection = dataPartTwo.articleDetailsCollection) === null || _dataPartTwo_articleDetailsCollection === void 0 ? void 0 : _dataPartTwo_articleDetailsCollection.items[0])
            ]
        }
    };
    agileArticle = (0, $4va49.shapeAgileArticleContentfulResponse)(combinedData);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4himv.SitesContextProvider), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gkV6l.SiteSelectorContextProvider), {
            analyticsPrefix: "jira-software.ondemand" // TODO: Check if this is correct
            ,
            productKey: (0, $i8kxh.ProductKeys).JIRA_SOFTWARE,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $60ddw.AgileArticleProvider), {
                agileArticle: agileArticle,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4LEyf.AgileArticlePageTemplate), {})
            })
        })
    });
};

});
parcelRegister("4LEyf", function(module, exports) {

$parcel$export(module.exports, "AgileArticlePageTemplate", function () { return $dbd72a95e3a52084$export$7574eb6b457503d5; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $4ktyF = parcelRequire("4ktyF");

var $lHB9W = parcelRequire("lHB9W");

var $3FBn4 = parcelRequire("3FBn4");
parcelRequire("bJo35");
var $28Etm = parcelRequire("28Etm");
parcelRequire("3gB8p");
var $8tITR = parcelRequire("8tITR");
parcelRequire("bnSCE");
var $6sYN8 = parcelRequire("6sYN8");

var $cP0Yq = parcelRequire("cP0Yq");

var $hx0Ku = parcelRequire("hx0Ku");

var $luVwe = parcelRequire("luVwe");

var $h6PiC = parcelRequire("h6PiC");

var $lrVTP = parcelRequire("lrVTP");
parcelRequire("gDqhU");
var $lTwyn = parcelRequire("lTwyn");

var $60ddw = parcelRequire("60ddw");
parcelRequire("eCYM9");
var $hQj9g = parcelRequire("hQj9g");

var $d8QZt = parcelRequire("d8QZt");

var $krNyQ = parcelRequire("krNyQ");

var $aUZ56 = parcelRequire("aUZ56");

var $7unTD = parcelRequire("7unTD");

var $3Wymx = parcelRequire("3Wymx");

var $ibGVp = parcelRequire("ibGVp");
const $dbd72a95e3a52084$export$7574eb6b457503d5 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4ktyF.default), {
        fallback: /*#__PURE__*/ (0, $loA2J.jsx)((0, $luVwe.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)($dbd72a95e3a52084$var$AgileArticlePageTemplateContent, {})
        })
    });
};
const $dbd72a95e3a52084$var$AgileArticlePageTemplateContent = ()=>{
    const agileArticleData = (0, $60ddw.useAgileArticle)();
    if (!agileArticleData) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)($dbd72a95e3a52084$var$AgileArticlePageTemplateContentDetails, (0, $7Knp0._)({}, agileArticleData));
};
const $dbd72a95e3a52084$var$AgileArticlePageTemplateContentDetails = (props)=>{
    var _props_articleIntroduction, _props_bodyTextContainer, _author_authorPicture, _author_authorPicture1;
    const { title: title, subtitle: subtitle, author: author, articleBanner: articleBanner, nextBestAction: nextBestAction } = props;
    const location = (0, $lrVTP.useLocation)();
    const origin = "https://www.atlassian.com";
    const link = `${origin}${location.pathname}`;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.default), {
                isShowTryNowLink: true,
                tryNowLinkCtaUrl: (0, $3FBn4.useLocalizedHref)("/try/cloud/signup"),
                tryNowLinkCtaButtonColor: "blue",
                productKey: "agile"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $hx0Ku.SubNavSoftwareDevelopment), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $h6PiC.AgileBreadcrumbs), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $lTwyn.AgileHeading), {
                title: (0, $lHB9W.expectContent)(title, "Article content not found"),
                description: subtitle,
                author: author,
                imageUrl: articleBanner === null || articleBanner === void 0 ? void 0 : articleBanner.url
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $8tITR.AgilePageLayout), {
                productDiscussedCta: props.productDiscussedCta,
                children: [
                    props.articleSummary && /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        text: props.articleSummary,
                        name: null
                    }),
                    ((_props_articleIntroduction = props.articleIntroduction) === null || _props_articleIntroduction === void 0 ? void 0 : _props_articleIntroduction.length) && props.articleIntroduction.map((data, idx)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hQj9g.AgileIntroduction), {
                                heading: data.articleIntroductionName,
                                image: data.articleIntroductionAsset,
                                embedLink: data.embedLink,
                                description: data.articleIntroductionDetails,
                                body: data.componentizedIntroduction
                            })
                        }, idx)),
                    (_props_bodyTextContainer = props.bodyTextContainer) === null || _props_bodyTextContainer === void 0 ? void 0 : _props_bodyTextContainer.map((data, idx)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aUZ56.BodyTextContainer), {
                                name: data.name,
                                contentComponents: (0, $lHB9W.expectContent)(data.contentComponents, "Article content not found")
                            })
                        }, idx)),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $6sYN8.ArticleShare), {
                        description: props.description,
                        title: title,
                        link: link
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $d8QZt.AgileAuthor), {
                        name: author === null || author === void 0 ? void 0 : author.name,
                        biography: author === null || author === void 0 ? void 0 : author.shortBiography,
                        pictureSrc: author === null || author === void 0 ? void 0 : (_author_authorPicture = author.authorPicture) === null || _author_authorPicture === void 0 ? void 0 : _author_authorPicture.url,
                        contentType: author === null || author === void 0 ? void 0 : (_author_authorPicture1 = author.authorPicture) === null || _author_authorPicture1 === void 0 ? void 0 : _author_authorPicture1.contentType
                    })
                ]
            }),
            nextBestAction && nextBestAction.length && /*#__PURE__*/ (0, $loA2J.jsx)((0, $7unTD.NavigationCards), {
                cardsData: nextBestAction
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $3Wymx.ShareUpNextBar), {
                nodes: (0, $ibGVp.useAgileHubPageTreeData)(),
                title: props.title,
                description: props.description
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $28Etm.AgileFooter), {})
        ]
    });
};

});
parcelRegister("bJo35", function(module, exports) {
$parcel$export(module.exports, "AgileFooter", function () { return (parcelRequire("28Etm")).AgileFooter; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("28Etm")).AgileFooter; });

var $28Etm = parcelRequire("28Etm");
parcelRequire("bujvx");

});
parcelRegister("28Etm", function(module, exports) {

$parcel$export(module.exports, "AgileFooter", function () { return $3d7b2245ed7a880a$export$ec65f9ca3425eb16; });
/* agile-footer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dyZbY = parcelRequire("dyZbY");

var $kex29 = parcelRequire("kex29");

var $bujvx = parcelRequire("bujvx");
// CSS styling
// ==================================================================
const $3d7b2245ed7a880a$var$agileFooterStyles = null; // ==================================================================
const $3d7b2245ed7a880a$export$ec65f9ca3425eb16 = ({ selectedLanguage: selectedLanguage, onLanguageChangeHandler: onLanguageChangeHandler })=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "agile-footer-v2",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("footer", {
            className: (0, $esG4f.default)([
                "_4cvr1h6o _bfhk1hxd _1e0c1txw _2lx2vrvc _1bah1h6o _66f11hxd _1gv8pxbi _1pgb1txw _1h0m1bp4 _14qq1osq _z72t1tcg _dk8g1txw _m9cj1fra _cg6bidpf _1end1wqb"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: "globalFooterContentContainer",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $bujvx.AgileFooterTop), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooterBottom), {
                        selectedLanguage: selectedLanguage,
                        onLanguageChangeHandler: onLanguageChangeHandler
                    })
                ]
            })
        })
    });

});
parcelRegister("bujvx", function(module, exports) {

$parcel$export(module.exports, "AgileFooterTop", function () { return $fe93f370b510ba02$export$d82baf0fba1e4221; });
/* agile-footer-top.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $fLxGV = parcelRequire("fLxGV");
// ==================================================================
// CSS styling
// ==================================================================
const $fe93f370b510ba02$var$containerStyle = null;
const $fe93f370b510ba02$var$rowStyle = null;
const $fe93f370b510ba02$var$linksWrapperStyle = null;
const $fe93f370b510ba02$export$26b6a80e48da8316 = {
    margin: "0",
    padding: "0",
    border: "0",
    fontSize: "100%",
    verticalAlign: "baseline"
}; // ==================================================================
const $fe93f370b510ba02$export$d82baf0fba1e4221 = ()=>{
    const intl = (0, $f6qj2.default)();
    const links1 = [
        {
            text: intl.formatMessage({
                id: "AgileFooter.top.agile-project-management",
                defaultMessage: "Agile project management"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/agile/project-management")
        },
        {
            text: intl.formatMessage({
                id: "AgileFooter.top.scrum",
                defaultMessage: "Scrum"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/agile/scrum")
        },
        {
            text: intl.formatMessage({
                id: "AgileFooter.top.kanban",
                defaultMessage: "Kanban"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/agile/kanban")
        },
        {
            text: intl.formatMessage({
                id: "AgileFooter.top.design",
                defaultMessage: "Design"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/agile/design")
        }
    ];
    const links2 = [
        {
            text: intl.formatMessage({
                id: "AgileFooter.top.software-development",
                defaultMessage: "Software development"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/agile/software-development")
        },
        {
            text: intl.formatMessage({
                id: "AgileFooter.top.product-management",
                defaultMessage: "Product management"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/agile/product-management")
        },
        {
            text: intl.formatMessage({
                id: "AgileFooter.top.teams",
                defaultMessage: "Teams"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/agile/teams")
        },
        {
            text: intl.formatMessage({
                id: "AgileFooter.top.agile-at-scale",
                defaultMessage: "Agile at scale"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/agile/agile-at-scale")
        },
        {
            text: intl.formatMessage({
                id: "AgileFooter.top.devOps",
                defaultMessage: "DevOps"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/agile/devops")
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_ca0qzwfg _u5f37vkz _n3td7vkz _19bv7vkz _kqswh2mm _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1bsb1osq _11rm1hrf _19itidpf _1wyb1osq _s7n41q9y _vchhusvi _1akozwfg _c7s71tcg _4puv7vkz _1r3v1tcg"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_ahbq1wug _12l21wug _1e0c1txw _2lx21bp4 _zulpzwfg _1bsb1osq _181n11p5 _1j8b1ags _1s3r162e"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_nd5l1d4v"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: (0, $esG4f.default)([
                            "_syazpmk4 _1wyb1j6v _1dyznl7k _vwz410nf _k48pbfng _ect4kipj _1s181k92 _17gqcjiy"
                        ]),
                        style: {
                            "--_1ljptrt": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light1000"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "AgileFooter.top.agile-topics",
                            defaultMessage: "Agile Topics"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_nd5lrwmx _1e0c11p5 _yv0ehkll _zulpzwfg _1j8b1t02"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)($fe93f370b510ba02$var$AgileLinkListContainer, {
                            links: links1
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)($fe93f370b510ba02$var$AgileLinkListContainer, {
                            links: links2
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $fLxGV.default), {
                    text: intl.formatMessage({
                        id: "AgileFooter.top.sign-up-for-more-agile",
                        defaultMessage: "Sign up for more agile articles and tutorials."
                    })
                })
            ]
        })
    });
};
const $fe93f370b510ba02$var$AgileLinkListContainer = ({ links: links })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulp1tcg"
        ]),
        children: links.map((linkProp)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), (0, $6iHNw._)((0, $7Knp0._)({}, linkProp), {
                    type: "anchor",
                    className: (0, $esG4f.default)([
                        "_syaz1yg0 _1wyboxwj _vwz4rrl5 _4bfu1r31 _1hmsglyw _ajmmnqa1 _s7n41q9y _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw"
                    ]),
                    style: {
                        "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800"))
                    }
                }))
            }, linkProp.text))
    });
};
var $fe93f370b510ba02$export$2e2bcd8739ae039 = $fe93f370b510ba02$export$d82baf0fba1e4221;

});
parcelRegister("fLxGV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f15b5908c2e3d3d8$export$2e2bcd8739ae039; });
/* agile-mailing-list-signup.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $bQawl = parcelRequire("bQawl");

var $5ohHq = parcelRequire("5ohHq");

var $5KXGt = parcelRequire("5KXGt");
const $f15b5908c2e3d3d8$var$validateEmail = (email)=>{
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
const $f15b5908c2e3d3d8$export$943ba713541231aa = (props)=>{
    const location = (0, $5KXGt.useLocation)();
    const intl = (0, $f6qj2.default)();
    const emptyEmailError = intl.formatMessage({
        id: "AgileFooter.top.emptyEmailError",
        defaultMessage: "This field is required"
    });
    const invalidEmailError = intl.formatMessage({
        id: "AgileFooter.top.invalidEmailError",
        defaultMessage: "This field requires a valid email address"
    });
    const [errorMessage, setErrorMessage] = (0, $iSvIT.useState)("");
    const [isValidatingEmail, setIsValidatingEmail] = (0, $iSvIT.useState)(false);
    const [emailInput, setEmailInput] = (0, $iSvIT.useState)("");
    const [honeypotInput, setHoneypotInput] = (0, $iSvIT.useState)("");
    const [signupSuccess, setSignupSuccess] = (0, $iSvIT.useState)(false);
    const [consentConfig, setConsentConfig] = (0, $iSvIT.useState)();
    (0, $iSvIT.useEffect)(()=>{
        if (isValidatingEmail) {
            if (emailInput === "") setErrorMessage(emptyEmailError);
            else $f15b5908c2e3d3d8$var$validateEmail(emailInput) ? setErrorMessage("") : setErrorMessage(invalidEmailError);
        }
    }, [
        isValidatingEmail,
        emailInput,
        emptyEmailError,
        invalidEmailError
    ]);
    (0, $iSvIT.useEffect)(()=>{
        getConsentConfig();
    }, []);
    const getConsentConfig = async ()=>{
        const stargateUrl = "https://www.atlassian.com/gateway/api";
        const consentConfigUrl = `${stargateUrl}/preferencesV2/consent-config`;
        await fetch(consentConfigUrl, {
            headers: {
                "Accept": "application/json",
                "Content-type": "application/json; charset=UTF-8"
            },
            method: "POST"
        }).then((response)=>response.json()).then((data)=>setConsentConfig(data)).catch(()=>{
            console.error("Failed to fetch consent config");
        });
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setIsValidatingEmail(true);
        if (honeypotInput) return;
        const stargateUrl = "https://www.atlassian.com/gateway/api";
        const postUrl = `${stargateUrl}/preferencesV2/update`; // These are hardcoded values that are required by the endpoint.
        // https://bitbucket.org/atlassian/magnolia-resources/annotate/f65b7a5bf31677bcde32caa3305364c7ffb88808/resources/js/components/generic/exact-target-formV2.ts?at=qa
        await fetch(postUrl, {
            headers: {
                "Accept": "application/json",
                "Content-type": "application/json; charset=UTF-8"
            },
            method: "POST",
            body: JSON.stringify({
                consentCheckboxValue: true,
                consentLabelText: "",
                email: emailInput,
                formId: "10c5c932-68d7-4db6-b1d1-959f4255d218",
                formUrl: location.href,
                locale: (consentConfig === null || consentConfig === void 0 ? void 0 : consentConfig.locale) || "UNKNOWN",
                privacyPolicyText: "",
                site: "atlassian"
            })
        }).then(()=>setSignupSuccess(true)).catch(()=>{
            setErrorMessage(intl.formatMessage({
                id: "AgileFooter.top.signupError",
                defaultMessage: "An error occurred. Please try again."
            }));
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)($f15b5908c2e3d3d8$export$bcccbb2dd132b5ba, (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        errorMessage: errorMessage,
        setIsValidatingEmail: setIsValidatingEmail,
        emailInput: emailInput,
        setEmailInput: setEmailInput,
        setHoneypotInput: setHoneypotInput,
        signupSuccess: signupSuccess,
        handleSubmit: handleSubmit
    }));
};
const $f15b5908c2e3d3d8$export$bcccbb2dd132b5ba = (props)=>{
    const { text: text, showEyebrow: showEyebrow, errorMessage: errorMessage, setIsValidatingEmail: setIsValidatingEmail, emailInput: emailInput, setEmailInput: setEmailInput, setHoneypotInput: setHoneypotInput, signupSuccess: signupSuccess, handleSubmit: handleSubmit } = props;
    const intl = (0, $f6qj2.default)();
    const subscribeText = intl.formatMessage({
        id: "AgileFooter.top.subscribe",
        defaultMessage: "Subscribe"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_nd5l13q9"
        ]),
        children: [
            showEyebrow && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_syazvwuj _1wyboqnp _1dyzt94y _vwz4cs5v _1p1dangw _1f491mrw _aetrb3bt _1ywu1ule _1i2f1hdd _1peqsxj9 _z0ai1ylp"
                ]),
                children: subscribeText
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                children: text
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                children: [
                    !signupSuccess && /*#__PURE__*/ (0, $loA2J.jsxs)("form", {
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                                    htmlFor: "email",
                                    className: (0, $esG4f.default)([
                                        "_1wyboxwj _syazvwuj"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "AgileFooter.top.email",
                                        defaultMessage: "Email"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_6rtho7ao"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                                        id: "email",
                                        type: "email",
                                        placeholder: "email@example.com",
                                        onChange: (e)=>setEmailInput(e.target.value),
                                        onBlur: ()=>emailInput && setIsValidatingEmail(true),
                                        "aria-invalid": errorMessage ? true : undefined,
                                        className: (0, $esG4f.default)([
                                            "_bfhkcd5j _19it1ehm _2rko1l7b _1e0c1o8l _ect4bzd7 _1wyboxwj _vwz411nn _4t3i1ylp _12l2ftgi _p12fp3fh _12ji1r31 _1qu2glyw _12y3idpf _ca0qidpf _u5f31crf _n3tdidpf _19bv1crf _1bsb1osq"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                        }
                                    }),
                                    errorMessage && /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                                        htmlFor: "email",
                                        className: (0, $esG4f.default)([
                                            "_1e0c1ule _1wyboxwj _syaz1sl2 _19pk1crf _2hwxidpf _otyr1crf _18u0idpf"
                                        ]),
                                        children: errorMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0cglyw"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                                    type: "text",
                                    name: "list name",
                                    "aria-label": "keep this field blank",
                                    onChange: (e)=>setHoneypotInput(e.target.value)
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bQawl.default), {
                                    type: "secondary",
                                    text: subscribeText,
                                    inputType: "submit",
                                    dataEventProps: {
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-product-key": "jiraSoftware",
                                        "data-event-container": "exactTargetForm"
                                    },
                                    "aria-label": subscribeText
                                })
                            })
                        ]
                    }),
                    signupSuccess && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "AgileFooter.top.signup-success",
                            defaultMessage: "Thanks for signing up!"
                        })
                    })
                ]
            })
        ]
    });
};
var $f15b5908c2e3d3d8$export$2e2bcd8739ae039 = $f15b5908c2e3d3d8$export$943ba713541231aa;

});




parcelRegister("3gB8p", function(module, exports) {
$parcel$export(module.exports, "AgilePageLayout", function () { return (parcelRequire("8tITR")).AgilePageLayout; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("8tITR")).AgilePageLayout; });

var $8tITR = parcelRequire("8tITR");

});
parcelRegister("8tITR", function(module, exports) {

$parcel$export(module.exports, "AgilePageLayout", function () { return $347fe80be47a6159$export$ec9acf8ba54ff52d; });
/* agile-page-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("XSYWD");
var $i2D0R = parcelRequire("i2D0R");

var $ibGVp = parcelRequire("ibGVp");
const $347fe80be47a6159$var$agilePageLayoutCss = null; // NOTE: Nested selectors are necessary here to be able to style the dangerouslySetInnerHTML blob
const $347fe80be47a6159$var$articleStyles = null; // Used for Agile Articles, Tutorial, and the Agile Coach pages
const $347fe80be47a6159$export$ec9acf8ba54ff52d = ({ children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c11p5 _yv0eaigu _2z05f5ih _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgzwfg _y4tizwfg _zulp1tcg _1bsb1osq _1q51zwfg _85i5ckbl _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx _dbjg1wug _1hvk1wug _isu41wug _15qm1wug _pdlmzwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $i2D0R.AgileHubSideNav), {
                nodes: (0, $ibGVp.useAgileHubPageTreeData)()
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("article", {
                className: (0, $esG4f.default)([
                    "_1461kb7n _f0zu1mrw _dz5jegat _125x18q9 _q7gq1cby _zcqx14u8 _8v2fqlpn _1yziqlpn _1601qlpn _l5k1bfng _r8ntbfng _1a7kbfng _cg411tj6 _qliy1tj6 _1rhq1tj6 _11eb1k8s _17z415sy _qc0pahaf _ggmh1k92 _1axi11ph _1o6v7vkz _ugctnl7k _1edj1k8s _8kc91k92 _1euycjiy _k6x07vkz _8lldnl7k",
                    "main-content"
                ]),
                style: {
                    "--_nmjf06": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.secondary.navy")),
                    "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display")),
                    "--_1tgiy09": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue900"))
                },
                children: children
            })
        ]
    });
};
var $347fe80be47a6159$export$2e2bcd8739ae039 = $347fe80be47a6159$export$ec9acf8ba54ff52d;

});
parcelRegister("XSYWD", function(module, exports) {
$parcel$export(module.exports, "AgileHubSideNav", function () { return (parcelRequire("i2D0R")).AgileHubSideNav; });
parcelRequire("i2D0R");
parcelRequire("7dODU");

});
parcelRegister("i2D0R", function(module, exports) {

$parcel$export(module.exports, "AgileHubSideNav", function () { return $964c13ea74cef355$export$f163550c1b6acb68; });
/* agile-overview-sidenav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $7dODU = parcelRequire("7dODU");
const $964c13ea74cef355$export$f163550c1b6acb68 = ({ nodes: nodes })=>{
    const headerCss = null;
    const agileSideNavCss = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1bsb1osq _c71l1icw _1reo1wug _18m91wug _kqsw1if8 _152ttudo _u7co1wug _1e0cglyw _181n1ule _dz5jkb7n _1q5legat",
            "agile-sidenav"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h5", {
                className: (0, $esG4f.default)([
                    "_1wyboxwj _k48p1fw0 _syazvwuj _1pfhidpf _6rthdlk8 _vwz410nf _1p1dangw _1dyzt94y _ect43aqo"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "agile-overview-sidenav.browse-topics",
                    defaultMessage: "Browse Topics"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $7dODU.PageTree), {
                nodes: nodes
            })
        ]
    });
};

});
parcelRegister("7dODU", function(module, exports) {

$parcel$export(module.exports, "PageTree", function () { return $4940b21963dfbde0$export$73500bf5f2e2b0c4; });
/* page-tree.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $jJ1uJ = parcelRequire("jJ1uJ");

var $3FBn4 = parcelRequire("3FBn4");

var $igbrG = parcelRequire("igbrG");

var $lrVTP = parcelRequire("lrVTP");
const $4940b21963dfbde0$var$PageTreeNode = ({ node: node })=>{
    const { name: name, urlSlug: urlSlug, children: children, level: level, isRoot: isRoot } = node;
    const location = (0, $lrVTP.useLocation)();
    const [isSelected, _setIsSelected] = (0, $iSvIT.useState)(urlSlug && (0, $igbrG.isEqualUnlocalizedPathname)(location.pathname, urlSlug));
    // deeply find if any child is selected
    const hasSelectedChild = (0, $iSvIT.useCallback)((currentNode)=>{
        if (currentNode.urlSlug && (0, $igbrG.isEqualUnlocalizedPathname)(location.pathname, currentNode.urlSlug)) return true;
        else if (currentNode.children) return currentNode.children.some((child)=>hasSelectedChild(child));
        return false;
    }, [
        location.pathname
    ]);
    const hasDropdown = isRoot && children;
    const [expanded, setExpanded] = (0, $iSvIT.useState)(hasSelectedChild(node));
    const isRootSelected = isRoot && hasSelectedChild(node);
    const handleClick = ()=>{
        setExpanded(!expanded);
    };
    const wrapperCss = null;
    const navlinkCss = [
        null
    ];
    const navlinkSpanCss = null;
    const navlinkBulletCss = null;
    const navlinkIconCss = [
        null
    ];
    const navlinkACss = [
        null,
        isSelected && !isRoot && navlinkBulletCss
    ];
    const dropdownCss = [
        null,
        !expanded && null,
        expanded && null
    ];
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_ahbq1ua3"
        ]),
        style: {
            "--_16epgcl": (0, $43MIc.default)(isRoot ? "0" : `${(level !== null && level !== void 0 ? level : 1) * 15}px`)
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                onClick: handleClick,
                onKeyDown: handleClick,
                className: (0, $esG4f.default)([
                    "_1wyb1to8 _ca0qftgi _u5f3idpf _n3tdftgi _19bv1ylp _syaztx7j _k48p91rt _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _3fcw1g80 _1nmz1hna"
                ]),
                style: {
                    "--_129z960": (0, $43MIc.default)(isRoot ? "1rem" : ".9rem"),
                    "--_1tj0m80": (0, $43MIc.default)(isRootSelected ? "#091E42" : "#42526e"),
                    "--_r3az4g": (0, $43MIc.default)(isRootSelected || isSelected ? "600" : "400")
                },
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                    className: (0, $esG4f.default)([
                        "_kqswh2mm"
                    ]),
                    children: [
                        hasDropdown && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            "aria-label": expanded ? "collapse" : "expand",
                            className: (0, $esG4f.default)([
                                "_kqswstnw _1e02idpf _ahbqkqtd _152t1smr _8hrz8s7t _t9ec3qhy _v5641lvb",
                                "agile-sidenav-icon"
                            ]),
                            style: {
                                "--_cf3sb8": (0, $43MIc.default)(expanded ? "rotate(0deg)" : "rotate(-90deg)")
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jJ1uJ))), {
                                size: "large",
                                label: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            "aria-label": `link to ${name}`,
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-event-container": "micrositeNav",
                            "data-product-key": "jiraSoftware",
                            href: (0, $3FBn4.useLocalizedHref)(urlSlug !== null && urlSlug !== void 0 ? urlSlug : ""),
                            onClick: (e)=>{
                                isRoot && hasDropdown && e.preventDefault();
                            },
                            className: (0, $esG4f.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _9oik1r31 _1bnx8stv _jf4cnqa1",
                                isSelected && !isRoot && "_1kt9b3bt _1mp4idpf _kfgtidpf _iajmidpf _1fkridpf _pasc1wug _eid31wug _zr3e1wug _fntn1wug _14h81axk _rfx319bv _1cs8stnw _z5wt1fm0"
                            ]),
                            children: name !== undefined && name.length > 0 ? name.charAt(0).toUpperCase() + name.slice(1) : name
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _1reo15vq _18m915vq",
                    !expanded && "_v564nino _c71lidpf",
                    expanded && "_v5646jez _c71lli4i"
                ]),
                children: children && /*#__PURE__*/ (0, $loA2J.jsx)($4940b21963dfbde0$export$73500bf5f2e2b0c4, {
                    nodes: children
                })
            })
        ]
    });
};
const $4940b21963dfbde0$export$73500bf5f2e2b0c4 = ({ nodes: nodes })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: nodes.map((node)=>/*#__PURE__*/ (0, $loA2J.jsx)($4940b21963dfbde0$var$PageTreeNode, {
                node: node
            }, node.key))
    });
};

});
parcelRegister("jJ1uJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e5c3611483201173$var$_react = $e5c3611483201173$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $e5c3611483201173$var$_chevronDown = $e5c3611483201173$var$_interopRequireDefault((parcelRequire("4vcv5")));
function $e5c3611483201173$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e5c3611483201173$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $e5c3611483201173$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.744 8.744a1.053 1.053 0 0 0 0 1.49l4.547 4.557a1 1 0 0 0 1.416 0l4.55-4.558a1.051 1.051 0 1 0-1.488-1.488l-3.77 3.776-3.768-3.776a1.05 1.05 0 0 0-1.487 0"/></svg>`
    }, props, {
        newIcon: $e5c3611483201173$var$_chevronDown.default
    }));
$e5c3611483201173$var$HipchatChevronDownIcon.displayName = "HipchatChevronDownIcon";
var $e5c3611483201173$var$_default = module.exports.default = $e5c3611483201173$var$HipchatChevronDownIcon;

});
parcelRegister("4vcv5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55c6484ab5ceb86b7f950bb9205e88a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3473c0fe0e2991b1$var$_react = $3473c0fe0e2991b1$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $3473c0fe0e2991b1$var$_baseNew = $3473c0fe0e2991b1$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $3473c0fe0e2991b1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3473c0fe0e2991b1$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $3473c0fe0e2991b1$var$_react.default.createElement($3473c0fe0e2991b1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$3473c0fe0e2991b1$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $3473c0fe0e2991b1$var$_default = module.exports.default = $3473c0fe0e2991b1$var$ChevronDownIcon;

});





parcelRegister("ibGVp", function(module, exports) {

$parcel$export(module.exports, "useAgileHubPageTreeData", function () { return $eeee3dd5745d6325$export$fdffb81740346f39; });

var $f6qj2 = parcelRequire("f6qj2");
const $eeee3dd5745d6325$export$fdffb81740346f39 = ()=>{
    const intl = (0, $f6qj2.default)();
    const AgileHubPageTreeData = [
        {
            key: "manifesto",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.manifesto",
                defaultMessage: "Agile manifesto"
            }),
            urlSlug: "/agile/manifesto",
            level: 0,
            isRoot: true
        },
        {
            key: "scrum",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.scrum",
                defaultMessage: "Scrum"
            }),
            urlSlug: "/agile/scrum",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/scrum",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/scrum",
                    level: 0
                },
                {
                    key: "/agile/scrum/sprints",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-sprints",
                        defaultMessage: "Sprints"
                    }),
                    urlSlug: "/agile/scrum/sprints",
                    level: 1
                },
                {
                    key: "/agile/scrum/sprint-planning",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-sprint-planning",
                        defaultMessage: "Sprint planning"
                    }),
                    urlSlug: "/agile/scrum/sprint-planning",
                    level: 1
                },
                {
                    key: "/agile/scrum/ceremonies",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-ceremonies",
                        defaultMessage: "Ceremonies"
                    }),
                    urlSlug: "/agile/scrum/ceremonies",
                    level: 1
                },
                {
                    key: "/agile/scrum/backlogs",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-backlogs",
                        defaultMessage: "Backlogs"
                    }),
                    urlSlug: "/agile/scrum/backlogs",
                    level: 1
                },
                {
                    key: "/agile/scrum/sprint-reviews",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-sprint-reviews",
                        defaultMessage: "Sprint reviews"
                    }),
                    urlSlug: "/agile/scrum/sprint-reviews",
                    level: 1
                },
                {
                    key: "/agile/scrum/standups",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-standups",
                        defaultMessage: "Standups"
                    }),
                    urlSlug: "/agile/scrum/standups",
                    level: 1
                },
                {
                    key: "/agile/scrum/scrum-master",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-scrum-master",
                        defaultMessage: "Scrum master"
                    }),
                    urlSlug: "/agile/scrum/scrum-master",
                    level: 1
                },
                {
                    key: "/agile/scrum/retrospectives",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-retrospectives",
                        defaultMessage: "Retrospectives"
                    }),
                    urlSlug: "/agile/scrum/retrospectives",
                    level: 1
                },
                {
                    key: "/agile/scrum/distributed-scrum",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-distributed-scrum",
                        defaultMessage: "Distributed scrum"
                    }),
                    urlSlug: "/agile/scrum/distributed-scrum",
                    level: 1
                },
                {
                    key: "/agile/scrum/roles",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-roles",
                        defaultMessage: "Roles"
                    }),
                    urlSlug: "/agile/scrum/roles",
                    level: 1
                },
                {
                    key: "/agile/scrum/scrum-of-scrums",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-scrum-of-scrums",
                        defaultMessage: "Scrum of scrums"
                    }),
                    urlSlug: "/agile/scrum/scrum-of-scrums",
                    level: 1
                },
                {
                    key: "/agile/scrum/artifacts",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-artifacts",
                        defaultMessage: "Agile scrum artifacts"
                    }),
                    urlSlug: "/agile/scrum/artifacts",
                    level: 1
                },
                {
                    key: "/agile/scrum/scrum-metrics",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-scrum-metrics",
                        defaultMessage: "Scrum metrics"
                    }),
                    urlSlug: "/agile/scrum/scrum-metrics",
                    level: 1
                },
                {
                    key: "/agile/scrum/jira-confluence-scrum",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-jira-confluence-scrum",
                        defaultMessage: "Jira Confluence scrum"
                    }),
                    urlSlug: "/agile/scrum/jira-confluence-scrum",
                    level: 1
                },
                {
                    key: "/agile/scrum/agile-vs-scrum",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-agile-vs-scrum",
                        defaultMessage: "Agile vs Scrum"
                    }),
                    urlSlug: "/agile/scrum/agile-vs-scrum",
                    level: 1
                },
                {
                    key: "/agile/scrum/backlog-refinement",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-backlog-refinement",
                        defaultMessage: "Backlog Refinement Guide"
                    }),
                    urlSlug: "/agile/scrum/backlog-refinement",
                    level: 1
                },
                {
                    key: "/agile/scrum/scrum-master-project-manager",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-master-project-manager",
                        defaultMessage: "Scrum master vs. project manager"
                    }),
                    urlSlug: "/agile/scrum/scrum-master-project-manager",
                    level: 1
                }
            ]
        },
        {
            key: "kanban",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.kanban",
                defaultMessage: "Kanban"
            }),
            urlSlug: "/agile/kanban",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/kanban",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.kanban-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/kanban",
                    level: 0
                },
                {
                    key: "/agile/kanban/boards",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.kanban-boards",
                        defaultMessage: "Boards"
                    }),
                    urlSlug: "/agile/kanban/boards",
                    level: 1
                },
                {
                    key: "/agile/kanban/wip-limits",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.kanban-wip-limits",
                        defaultMessage: "WIP limits"
                    }),
                    urlSlug: "/agile/kanban/wip-limits",
                    level: 1
                },
                {
                    key: "/agile/kanban/kanban-vs-scrum",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.kanban-kanban-vs-scrum",
                        defaultMessage: "Kanban vs Scrum"
                    }),
                    urlSlug: "/agile/kanban/kanban-vs-scrum",
                    level: 1
                },
                {
                    key: "/agile/kanban/kanplan",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.kanban-kanplan",
                        defaultMessage: "Kanplan"
                    }),
                    urlSlug: "/agile/kanban/kanplan",
                    level: 1
                },
                {
                    key: "/agile/kanban/cards",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.kanban-cards",
                        defaultMessage: "Kanban cards"
                    }),
                    urlSlug: "/agile/kanban/cards",
                    level: 1
                }
            ]
        },
        {
            key: "project-management",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.project-management",
                defaultMessage: "Agile project management"
            }),
            urlSlug: "/agile/project-management",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/project-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/project-management",
                    level: 0
                },
                {
                    key: "/agile/project-management/project-management-intro",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-project-management-intro",
                        defaultMessage: "Project management intro"
                    }),
                    urlSlug: "/agile/project-management/project-management-intro",
                    level: 1
                },
                {
                    key: "/agile/project-management/workflow",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-workflow",
                        defaultMessage: "Workflow"
                    }),
                    urlSlug: "/agile/project-management/workflow",
                    level: 1
                },
                {
                    key: "/agile/project-management/epics-stories-themes",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-epics-stories-themes",
                        defaultMessage: "Epics, stories, themes"
                    }),
                    urlSlug: "/agile/project-management/epics-stories-themes",
                    level: 1
                },
                {
                    key: "/agile/project-management/epics",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-epics",
                        defaultMessage: "Epics"
                    }),
                    urlSlug: "/agile/project-management/epics",
                    level: 1
                },
                {
                    key: "/agile/project-management/user-stories",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-user-stories",
                        defaultMessage: "User Stories"
                    }),
                    urlSlug: "/agile/project-management/user-stories",
                    level: 1
                },
                {
                    key: "/agile/project-management/estimation",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-estimation",
                        defaultMessage: "Estimation"
                    }),
                    urlSlug: "/agile/project-management/estimation",
                    level: 1
                },
                {
                    key: "/agile/project-management/metrics",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-metrics",
                        defaultMessage: "Metrics"
                    }),
                    urlSlug: "/agile/project-management/metrics",
                    level: 1
                },
                {
                    key: "/agile/project-management/gantt-chart",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-gantt-chart",
                        defaultMessage: "Gantt chart"
                    }),
                    urlSlug: "/agile/project-management/gantt-chart",
                    level: 1
                },
                {
                    key: "/agile/project-management/program-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-program-management",
                        defaultMessage: "Program management vs. project management"
                    }),
                    urlSlug: "/agile/project-management/program-management",
                    level: 1
                },
                {
                    key: "/agile/project-management/project-baseline",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-project-baseline",
                        defaultMessage: "Project baseline"
                    }),
                    urlSlug: "/agile/project-management/project-baseline",
                    level: 1
                },
                {
                    key: "/agile/project-management/continuous-improvement",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-continuous-improvement",
                        defaultMessage: "Continuous improvement"
                    }),
                    urlSlug: "/agile/project-management/continuous-improvement",
                    level: 1
                },
                {
                    key: "/agile/project-management/lean-principles",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-lean-principles",
                        defaultMessage: "Lean principles"
                    }),
                    urlSlug: "/agile/project-management/lean-principles",
                    level: 1
                },
                {
                    key: "/agile/project-management/3-pillars-scrum",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-3-pillars-scrum",
                        defaultMessage: "3 pillars of Scrum"
                    }),
                    urlSlug: "/agile/project-management/3-pillars-scrum",
                    level: 1
                },
                {
                    key: "/agile/project-management/scrum-board",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-scrum-board",
                        defaultMessage: "Scrum Board"
                    }),
                    urlSlug: "/agile/project-management/scrum-board",
                    level: 1
                },
                {
                    key: "/agile/project-management/waterfall-methodology",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-waterfall-methodology",
                        defaultMessage: "Waterfall Methodology"
                    }),
                    urlSlug: "/agile/project-management/waterfall-methodology",
                    level: 1
                },
                {
                    key: "/agile/project-management/velocity-scrum",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-velocity-scrum",
                        defaultMessage: "Velocity in Scrum"
                    }),
                    urlSlug: "/agile/project-management/velocity-scrum",
                    level: 1
                },
                {
                    key: "/agile/project-management/definition-of-ready",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-definition-of-ready",
                        defaultMessage: "What is Definition of Ready"
                    }),
                    urlSlug: "/agile/project-management/definition-of-ready",
                    level: 1
                },
                {
                    key: "/agile/project-management/lean-vs-agile",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-lean-vs-agile",
                        defaultMessage: "Lean vs. agile"
                    }),
                    urlSlug: "/agile/project-management/lean-vs-agile",
                    level: 1
                },
                {
                    key: "/agile/project-management/scrumban",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-scrumban",
                        defaultMessage: "Scrumban"
                    }),
                    urlSlug: "/agile/project-management/scrumban",
                    level: 1
                },
                {
                    key: "/agile/project-management/lean-methodology",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-lean-methodology",
                        defaultMessage: "Lean Methodology"
                    }),
                    urlSlug: "/agile/project-management/lean-methodology",
                    level: 1
                },
                {
                    key: "/agile/project-management/sprint-backlog",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-sprint-backlog",
                        defaultMessage: "Sprint backlog"
                    }),
                    urlSlug: "/agile/project-management/sprint-backlog",
                    level: 1
                },
                {
                    key: "/agile/project-management/burn-up-chart",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-burn-up-chart",
                        defaultMessage: "Burn up chart"
                    }),
                    urlSlug: "/agile/project-management/burn-up-chart",
                    level: 1
                },
                {
                    key: "/agile/project-management/kanban-principles",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-kanban-principles",
                        defaultMessage: "4 kanban principles"
                    }),
                    urlSlug: "/agile/project-management/kanban-principles",
                    level: 1
                },
                {
                    key: "/agile/project-management/kanban-metrics",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-kanban-metrics",
                        defaultMessage: "4 kanban metrics"
                    }),
                    urlSlug: "/agile/project-management/kanban-metrics",
                    level: 1
                },
                {
                    key: "/agile/project-management/program-vs-project-manager",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-program-vs-project-manager",
                        defaultMessage: "Program vs. Project Manager"
                    }),
                    urlSlug: "/agile/project-management/program-vs-project-manager",
                    level: 1
                },
                {
                    key: "/agile/project-management/gantt-chart-examples",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-gantt-chart-examples",
                        defaultMessage: "Gantt chart examples"
                    }),
                    urlSlug: "/agile/project-management/gantt-chart-examples",
                    level: 1
                },
                {
                    key: "/agile/project-management/definition-of-done",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-definition-of-done",
                        defaultMessage: "Definition of done"
                    }),
                    urlSlug: "/agile/project-management/definition-of-done",
                    level: 1
                },
                {
                    key: "/agile/project-management/backlog-grooming",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-backlog-grooming",
                        defaultMessage: "Backlog grooming"
                    }),
                    urlSlug: "/agile/project-management/backlog-grooming",
                    level: 1
                },
                {
                    key: "/agile/project-management/lean-process-improvement",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-lean-process-improvement",
                        defaultMessage: "Lean process improvement"
                    }),
                    urlSlug: "/agile/project-management/lean-process-improvement",
                    level: 1
                },
                {
                    key: "/agile/project-management/backlog-refinement-meeting",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-backlog-refinement-meeting",
                        defaultMessage: "Backlog refinement meetings"
                    }),
                    urlSlug: "/agile/project-management/backlog-refinement-meeting",
                    level: 1
                },
                {
                    key: "/agile/project-management/scrum-values",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-scrum-values",
                        defaultMessage: "Scrum values"
                    }),
                    urlSlug: "/agile/project-management/scrum-values",
                    level: 1
                },
                {
                    key: "/agile/project-management/scope-of-work",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-scope-of-work",
                        defaultMessage: "Scope of work"
                    }),
                    urlSlug: "/agile/project-management/scope-of-work",
                    level: 1
                },
                {
                    key: "/agile/project-management/scrum-tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-scrum-tools",
                        defaultMessage: "Scrum tools"
                    }),
                    urlSlug: "/agile/project-management/scrum-tools",
                    level: 1
                },
                {
                    key: "/agile/project-management/tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-tools",
                        defaultMessage: "Tools"
                    }),
                    urlSlug: "/agile/project-management/tools",
                    level: 1
                },
                {
                    key: "/agile/project-management/workflow-automation-software",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-workflow-automation-software",
                        defaultMessage: "Workflow automation software"
                    }),
                    urlSlug: "/agile/project-management/workflow-automation-software",
                    level: 1
                },
                {
                    key: "/agile/project-management/templates",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-templates",
                        defaultMessage: "Templates"
                    }),
                    urlSlug: "/agile/project-management/templates",
                    level: 1
                },
                {
                    key: "/agile/project-management/task-tracker",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-task-tracker",
                        defaultMessage: "Task tracker"
                    }),
                    urlSlug: "/agile/project-management/task-tracker",
                    level: 1
                },
                {
                    key: "/agile/project-management/workflow-automation",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-workflow-automation",
                        defaultMessage: "Workflow automation"
                    }),
                    urlSlug: "/agile/project-management/workflow-automation",
                    level: 1
                },
                {
                    key: "/agile/project-management/status-report",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-status-report",
                        defaultMessage: "Status report"
                    }),
                    urlSlug: "/agile/project-management/status-report",
                    level: 1
                },
                {
                    key: "/agile/project-management/workflow-chart",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-workflow-chart",
                        defaultMessage: "Workflow chart"
                    }),
                    urlSlug: "/agile/project-management/workflow-chart",
                    level: 1
                },
                {
                    key: "/agile/project-management/project-roadmap",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-project-roadmap",
                        defaultMessage: "Project roadmap"
                    }),
                    urlSlug: "/agile/project-management/project-roadmap",
                    level: 1
                },
                {
                    key: "/agile/project-management/project-schedule",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-project-schedule",
                        defaultMessage: "Project schedule"
                    }),
                    urlSlug: "/agile/project-management/project-schedule",
                    level: 1
                },
                {
                    key: "/agile/project-management/issue-tracking-software",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-issue-tracking-software",
                        defaultMessage: "Tracking software"
                    }),
                    urlSlug: "/agile/project-management/issue-tracking-software",
                    level: 1
                },
                {
                    key: "/agile/project-management/roadmap-tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-roadmap-tools",
                        defaultMessage: "Roadmap tools"
                    }),
                    urlSlug: "/agile/project-management/roadmap-tools",
                    level: 1
                },
                {
                    key: "/agile/project-management/technology-roadmap",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-technology-roadmap",
                        defaultMessage: "Technology roadmap"
                    }),
                    urlSlug: "/agile/project-management/technology-roadmap",
                    level: 1
                },
                {
                    key: "/agile/project-management/project-scheduling-software",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-project-scheduling-software",
                        defaultMessage: "Project scheduling software"
                    }),
                    urlSlug: "/agile/project-management/project-scheduling-software",
                    level: 1
                },
                {
                    key: "/agile/project-management/backlog-management-tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-backlog-management-tools",
                        defaultMessage: "Backlog management tools"
                    }),
                    urlSlug: "/agile/project-management/backlog-management-tools",
                    level: 1
                },
                {
                    key: "/agile/project-management/workflow-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-workflow-management",
                        defaultMessage: "Understanding workflow management strategies"
                    }),
                    urlSlug: "/agile/project-management/workflow-management",
                    level: 1
                },
                {
                    key: "/agile/project-management/workflow-examples",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-workflow-examples",
                        defaultMessage: "Workflow examples"
                    }),
                    urlSlug: "/agile/project-management/workflow-examples",
                    level: 1
                },
                {
                    key: "/agile/project-management/create-project-roadmap",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-create-project-roadmap",
                        defaultMessage: "Create project roadmap"
                    }),
                    urlSlug: "/agile/project-management/create-project-roadmap",
                    level: 1
                },
                {
                    key: "/agile/project-management/sprint-planning-tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-sprint-planning-tools",
                        defaultMessage: "Sprint planning tools"
                    }),
                    urlSlug: "/agile/project-management/sprint-planning-tools",
                    level: 1
                },
                {
                    key: "/agile/project-management/sprint-demo",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-sprint-demo",
                        defaultMessage: "Sprint demo"
                    }),
                    urlSlug: "/agile/project-management/sprint-demo",
                    level: 1
                },
                {
                    key: "/agile/project-management/project-timeline-software",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-project-timeline-software",
                        defaultMessage: "Project Timeline Software"
                    }),
                    urlSlug: "/agile/project-management/project-timeline-software",
                    level: 1
                },
                {
                    key: "/agile/project-management/task-management-tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-task-management-tools",
                        defaultMessage: "Top task management tools"
                    }),
                    urlSlug: "/agile/project-management/task-management-tools",
                    level: 1
                },
                {
                    key: "/agile/project-management/sprint-backlog-product-backlog",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-sprint-backlog-product-backlog",
                        defaultMessage: "Product backlog vs. sprint backlog"
                    }),
                    urlSlug: "/agile/project-management/sprint-backlog-product-backlog",
                    level: 1
                },
                {
                    key: "/agile/project-management/workflow-management-tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-workflow-management-tools",
                        defaultMessage: "Top workflow management tools"
                    }),
                    urlSlug: "/agile/project-management/workflow-management-tools",
                    level: 1
                },
                {
                    key: "/agile/project-management/project-management-dependencies",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-project-management-dependencies",
                        defaultMessage: "Project dependencies"
                    }),
                    urlSlug: "/agile/project-management/project-management-dependencies",
                    level: 1
                },
                {
                    key: "/agile/project-management/task-management-dashboard",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-task-management-dashboard",
                        defaultMessage: "Task dashboard guide"
                    }),
                    urlSlug: "/agile/project-management/task-management-dashboard",
                    level: 1
                },
                {
                    key: "/agile/project-management/sprint-cadence",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-sprint-cadence",
                        defaultMessage: "Sprint cadence"
                    }),
                    urlSlug: "/agile/project-management/sprint-cadence",
                    level: 1
                },
                {
                    key: "/agile/project-management/fast-tracking",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-fast-tracking",
                        defaultMessage: "Fast tracking"
                    }),
                    urlSlug: "/agile/project-management/fast-tracking",
                    level: 1
                }
            ]
        },
        {
            key: "product-management",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.product-management",
                defaultMessage: "Product Management"
            }),
            urlSlug: "/agile/product-management",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/product-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/product-management",
                    level: 0
                },
                {
                    key: "/agile/product-management/product-roadmaps",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-roadmaps",
                        defaultMessage: "Product Roadmaps"
                    }),
                    urlSlug: "/agile/product-management/product-roadmaps",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-manager",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-manager",
                        defaultMessage: "Product Manager"
                    }),
                    urlSlug: "/agile/product-management/product-manager",
                    level: 1
                },
                {
                    key: "/agile/product-management/tips-for-new-product-manager",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-tips-for-new-product-manager",
                        defaultMessage: "Tips for new product managers"
                    }),
                    urlSlug: "/agile/product-management/tips-for-new-product-manager",
                    level: 1
                },
                {
                    key: "/agile/product-management/roadmaps",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-roadmaps",
                        defaultMessage: "Roadmaps"
                    }),
                    urlSlug: "/agile/product-management/roadmaps",
                    level: 1
                },
                {
                    key: "/agile/product-management/tips-for-presenting-product-roadmaps",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-tips-for-presenting-product-roadmaps",
                        defaultMessage: "Tips for presenting product roadmaps"
                    }),
                    urlSlug: "/agile/product-management/tips-for-presenting-product-roadmaps",
                    level: 1
                },
                {
                    key: "/agile/product-management/requirements",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-requirements",
                        defaultMessage: "Requirements"
                    }),
                    urlSlug: "/agile/product-management/requirements",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-analytics",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-analytics",
                        defaultMessage: "Product analytics"
                    }),
                    urlSlug: "/agile/product-management/product-analytics",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-development",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-development",
                        defaultMessage: "Product development"
                    }),
                    urlSlug: "/agile/product-management/product-development",
                    level: 1
                },
                {
                    key: "/agile/product-management/remote-product-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-remote-product-management",
                        defaultMessage: "Remote product management"
                    }),
                    urlSlug: "/agile/product-management/remote-product-management",
                    level: 1
                },
                {
                    key: "/agile/product-management/minimum-viable-product",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-minimum-viable-product",
                        defaultMessage: "Minimal viable product"
                    }),
                    urlSlug: "/agile/product-management/minimum-viable-product",
                    level: 1
                },
                {
                    key: "/agile/product-management/discovery",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-discovery",
                        defaultMessage: "Product discovery"
                    }),
                    urlSlug: "/agile/product-management/discovery",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-specification",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-specification",
                        defaultMessage: "Product specification"
                    }),
                    urlSlug: "/agile/product-management/product-specification",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-development-strategy",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-development-strategy",
                        defaultMessage: "Product development strategy"
                    }),
                    urlSlug: "/agile/product-management/product-development-strategy",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-development-software",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-development-software",
                        defaultMessage: "Product development software"
                    }),
                    urlSlug: "/agile/product-management/product-development-software",
                    level: 1
                },
                {
                    key: "/agile/product-management/new-product-development-process",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-new-product-development-process",
                        defaultMessage: "New product development process"
                    }),
                    urlSlug: "/agile/product-management/new-product-development-process",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-management-kpis",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-management-kpis",
                        defaultMessage: "Product management KPIs"
                    }),
                    urlSlug: "/agile/product-management/product-management-kpis",
                    level: 1
                },
                {
                    key: "/agile/product-management/nps-score",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-nps-score",
                        defaultMessage: "Net Promoter Score (NPS)"
                    }),
                    urlSlug: "/agile/product-management/nps-score",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-critique",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-critique",
                        defaultMessage: "Product critique"
                    }),
                    urlSlug: "/agile/product-management/product-critique",
                    level: 1
                },
                {
                    key: "/agile/product-management/prioritization-framework",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-prioritization-framework",
                        defaultMessage: "Prioritization frameworks"
                    }),
                    urlSlug: "/agile/product-management/prioritization-framework",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-features",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-features",
                        defaultMessage: "Product features"
                    }),
                    urlSlug: "/agile/product-management/product-features",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-management-tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-management-tools",
                        defaultMessage: "Product management tools"
                    }),
                    urlSlug: "/agile/product-management/product-management-tools",
                    level: 1
                },
                {
                    key: "/agile/product-management/plm",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-plm",
                        defaultMessage: "Product Lifecycle Management"
                    }),
                    urlSlug: "/agile/product-management/plm",
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/roadmap-software",
                    key: "/agile/product-management/roadmap-software",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-roadmap-software",
                        defaultMessage: "9 best roadmap software for teams"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-launch-checklist",
                    key: "/agile/product-management/product-launch-checklist",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-launch-checklist",
                        defaultMessage: "Product launch checklist"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-strategy",
                    key: "/agile/product-management/product-strategy",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-strategy",
                        defaultMessage: "Product strategy"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-engineering",
                    key: "/agile/product-management/product-engineering",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-engineering",
                        defaultMessage: "Product engineering"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-operations",
                    key: "/agile/product-management/product-operations",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-operations",
                        defaultMessage: "Product operations"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/portfolio-management",
                    key: "/agile/product-management/portfolio-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-portfolio-management",
                        defaultMessage: "Portfolio management"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/pm-and-ai",
                    key: "/agile/product-management/pm-and-ai",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-pm-and-ai",
                        defaultMessage: "AI and product management"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/growth-product-management",
                    key: "/agile/product-management/growth-product-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-growth-product-management",
                        defaultMessage: "Growth product management"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-metrics",
                    key: "/agile/product-management/product-metrics",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-metrics",
                        defaultMessage: "Product metrics"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-release",
                    key: "/agile/product-management/product-release",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-release",
                        defaultMessage: "Product release"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/feature-request",
                    key: "/agile/product-management/feature-request",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-feature-request",
                        defaultMessage: "Feature request"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-launch",
                    key: "/agile/product-management/product-launch",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-launch",
                        defaultMessage: "Product launch"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-planning",
                    key: "/agile/product-management/product-planning",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-planning",
                        defaultMessage: "Product planning"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-launch-event",
                    key: "/agile/product-management/product-launch-event",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-launch-event",
                        defaultMessage: "Product launch event"
                    }),
                    level: 1
                }
            ]
        },
        {
            key: "value-stream-management",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.value-stream-management",
                defaultMessage: "Value Stream Management"
            }),
            urlSlug: "/agile/value-stream-management",
            level: 0,
            isRoot: true
        },
        {
            key: "agile-at-scale",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.agile-at-scale",
                defaultMessage: "Agile at scale"
            }),
            urlSlug: "/agile/agile-at-scale",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/agile-at-scale",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/agile-at-scale",
                    level: 0
                },
                {
                    key: "/agile/agile-at-scale/managing-an-agile-portfolio",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-managing-an-agile-portfolio",
                        defaultMessage: "Managing an agile portfolio"
                    }),
                    urlSlug: "/agile/agile-at-scale/managing-an-agile-portfolio",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/lean-portfolio-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-lean-portfolio-management",
                        defaultMessage: "Lean portfolio management"
                    }),
                    urlSlug: "/agile/agile-at-scale/lean-portfolio-management",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/okr",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-okr",
                        defaultMessage: "Okrs"
                    }),
                    urlSlug: "/agile/agile-at-scale/okr",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/long-term-agile-planning",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-long-term-agile-planning",
                        defaultMessage: "Long-term agile planning"
                    }),
                    urlSlug: "/agile/agile-at-scale/long-term-agile-planning",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/what-is-safe",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-what-is-safe",
                        defaultMessage: "What is SAFe?"
                    }),
                    urlSlug: "/agile/agile-at-scale/what-is-safe",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/spotify",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-spotify",
                        defaultMessage: "Spotify model"
                    }),
                    urlSlug: "/agile/agile-at-scale/spotify",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/scrum-at-scale",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-scrum-at-scale",
                        defaultMessage: "Organizational agility with Scrum@Scale"
                    }),
                    urlSlug: "/agile/agile-at-scale/scrum-at-scale",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/agile-iron-triangle",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-agile-iron-triangle",
                        defaultMessage: "Agile iron triangle"
                    }),
                    urlSlug: "/agile/agile-at-scale/agile-iron-triangle",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/less",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-less",
                        defaultMessage: "The Large-Scale Scrum (LeSS) framework"
                    }),
                    urlSlug: "/agile/agile-at-scale/less",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/using-improvement-kata-to-support-lean",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-using-improvement-kata-to-support-lean",
                        defaultMessage: "Using Improvement Kata to support lean"
                    }),
                    urlSlug: "/agile/agile-at-scale/using-improvement-kata-to-support-lean",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/beyond-the-basics-whitepaper",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-beyond-the-basics-whitepaper",
                        defaultMessage: "Beyond the basics whitepaper"
                    }),
                    urlSlug: "/agile/agile-at-scale/beyond-the-basics-whitepaper",
                    level: 1
                }
            ]
        },
        {
            key: "software-development",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.software-development",
                defaultMessage: "Software development"
            }),
            urlSlug: "/agile/software-development",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/software-development",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/software-development",
                    level: 0
                },
                {
                    key: "/agile/software-development/developer",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-developer",
                        defaultMessage: "Developer"
                    }),
                    urlSlug: "/agile/software-development/developer",
                    level: 1
                },
                {
                    key: "/agile/software-development/dev-managers-vs-scrum-masters",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-dev-managers-vs-scrum-masters",
                        defaultMessage: "Dev managers vs scrum masters"
                    }),
                    urlSlug: "/agile/software-development/dev-managers-vs-scrum-masters",
                    level: 1
                },
                {
                    key: "/agile/software-development/git",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-git",
                        defaultMessage: "Git"
                    }),
                    urlSlug: "/agile/software-development/git",
                    level: 1
                },
                {
                    key: "/agile/software-development/branching",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-branching",
                        defaultMessage: "Branching"
                    }),
                    urlSlug: "/agile/software-development/branching",
                    level: 1
                },
                {
                    key: "/agile/software-development/git-branching-video",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-git-branching-video",
                        defaultMessage: "Git branching video"
                    }),
                    urlSlug: "/agile/software-development/git-branching-video",
                    level: 1
                },
                {
                    key: "/agile/software-development/code-reviews",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-code-reviews",
                        defaultMessage: "Code reviews"
                    }),
                    urlSlug: "/agile/software-development/code-reviews",
                    level: 1
                },
                {
                    key: "/agile/software-development/release",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-release",
                        defaultMessage: "Release"
                    }),
                    urlSlug: "/agile/software-development/release",
                    level: 1
                },
                {
                    key: "/agile/software-development/technical-debt",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-technical-debt",
                        defaultMessage: "Technical debt"
                    }),
                    urlSlug: "/agile/software-development/technical-debt",
                    level: 1
                },
                {
                    key: "/agile/software-development/testing",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-testing",
                        defaultMessage: "Testing"
                    }),
                    urlSlug: "/agile/software-development/testing",
                    level: 1
                },
                {
                    key: "/agile/software-development/incident-response",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-incident-response",
                        defaultMessage: "Incident response"
                    }),
                    urlSlug: "/agile/software-development/incident-response",
                    level: 1
                },
                {
                    key: "/agile/software-development/continuous-integration",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-continuous-integration",
                        defaultMessage: "Continuous integration"
                    }),
                    urlSlug: "/agile/software-development/continuous-integration",
                    level: 1
                },
                {
                    key: "/agile/software-development/sdlc",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-sdlc",
                        defaultMessage: "Sdlc"
                    }),
                    urlSlug: "/agile/software-development/sdlc",
                    level: 1
                },
                {
                    key: "/agile/software-development/bug-triage",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-bug-triage",
                        defaultMessage: "Bug triage: definition, examples, and best practices"
                    }),
                    urlSlug: "/agile/software-development/bug-triage",
                    level: 1
                },
                {
                    key: "/agile/software-development/software-deployment",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-software-deployment",
                        defaultMessage: "Software deployment"
                    }),
                    urlSlug: "/agile/software-development/software-deployment",
                    level: 1
                }
            ]
        },
        {
            key: "design",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.design",
                defaultMessage: "Design"
            }),
            urlSlug: "/agile/design",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/design",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.design-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/design",
                    level: 0
                },
                {
                    key: "/agile/design/product-design-process-customer-interview",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.design-product-design-process-customer-interview",
                        defaultMessage: "Product design process customer interview"
                    }),
                    urlSlug: "/agile/design/product-design-process-customer-interview",
                    level: 1
                },
                {
                    key: "/agile/design/collaborative-design-in-agile-teams-video",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.design-collaborative-design-in-agile-teams-video",
                        defaultMessage: "Collaborative design in agile teams video"
                    }),
                    urlSlug: "/agile/design/collaborative-design-in-agile-teams-video",
                    level: 1
                }
            ]
        },
        {
            key: "agile-marketing",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.agile-marketing",
                defaultMessage: "Agile marketing"
            }),
            urlSlug: "/agile/agile-marketing",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/agile-marketing",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-marketing-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/agile-marketing",
                    level: 0
                },
                {
                    key: "/agile/agile-marketing/what-is-agile-marketing",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-marketing-what-is-agile-marketing",
                        defaultMessage: "What is Agile Marketing?"
                    }),
                    urlSlug: "/agile/agile-marketing/what-is-agile-marketing",
                    level: 1
                },
                {
                    key: "/agile/agile-marketing/agile-marketing-team",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-marketing-agile-marketing-team",
                        defaultMessage: "How to create an agile marketing team"
                    }),
                    urlSlug: "/agile/agile-marketing/agile-marketing-team",
                    level: 1
                }
            ]
        },
        {
            key: "advantage",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.advantage",
                defaultMessage: "The agile advantage"
            }),
            urlSlug: "/agile/advantage",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/advantage",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.advantage-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/advantage",
                    level: 0
                },
                {
                    key: "/agile/advantage/connect-business-strategy-to-development-reality",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.advantage-connect-business-strategy-to-development-reality",
                        defaultMessage: "Connecting business strategy to development reality"
                    }),
                    urlSlug: "/agile/advantage/connect-business-strategy-to-development-reality",
                    level: 1
                },
                {
                    key: "/agile/advantage/agile-is-a-competitive-advantage",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.advantage-agile-is-a-competitive-advantage",
                        defaultMessage: "Agile is a competitive advantage"
                    }),
                    urlSlug: "/agile/advantage/agile-is-a-competitive-advantage",
                    level: 1
                },
                {
                    key: "/agile/advantage/agile-mindset",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.advantage-agile-mindset",
                        defaultMessage: "Cultivating an agile mindset"
                    }),
                    urlSlug: "/agile/advantage/agile-mindset",
                    level: 1
                },
                {
                    key: "/agile/advantage/going-agile",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.advantage-going-agile",
                        defaultMessage: "Going agile"
                    }),
                    urlSlug: "/agile/advantage/going-agile",
                    level: 1
                }
            ]
        },
        {
            key: "devops",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.devops",
                defaultMessage: "DevOps"
            }),
            urlSlug: "/agile/devops",
            level: 0,
            isRoot: true
        },
        {
            key: "teams",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.teams",
                defaultMessage: "Agile Teams"
            }),
            urlSlug: "/agile/teams",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/teams",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/teams",
                    level: 0
                },
                {
                    key: "/agile/teams/remote-teams",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-remote-teams",
                        defaultMessage: "Remote teams"
                    }),
                    urlSlug: "/agile/teams/remote-teams",
                    level: 1
                },
                {
                    key: "/agile/teams/working-with-specialists",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-working-with-specialists",
                        defaultMessage: "Working with specialists"
                    }),
                    urlSlug: "/agile/teams/working-with-specialists",
                    level: 1
                },
                {
                    key: "/agile/teams/release-ready-teams",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-release-ready-teams",
                        defaultMessage: "Release ready teams"
                    }),
                    urlSlug: "/agile/teams/release-ready-teams",
                    level: 1
                },
                {
                    key: "/agile/teams/agilents-agile-transformation-journey",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-agilents-agile-transformation-journey",
                        defaultMessage: "Agilent\u2019s agile transformation journey"
                    }),
                    urlSlug: "/agile/teams/agilents-agile-transformation-journey",
                    level: 1
                },
                {
                    key: "/agile/teams/advanced-roadmaps-teams",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-advanced-roadmaps-teams",
                        defaultMessage: "Advanced Roadmaps"
                    }),
                    urlSlug: "/agile/teams/advanced-roadmaps-teams",
                    level: 1
                },
                {
                    key: "/agile/teams/jira-twitter-unified-projects-teamwork",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-jira-twitter-unified-projects-teamwork",
                        defaultMessage: "How Twitter uses Jira"
                    }),
                    urlSlug: "/agile/teams/jira-twitter-unified-projects-teamwork",
                    level: 1
                },
                {
                    key: "/agile/teams/scrum-kanban-agile",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-scrum-kanban-agile",
                        defaultMessage: "How we chose our agile"
                    }),
                    urlSlug: "/agile/teams/scrum-kanban-agile",
                    level: 1
                }
            ]
        },
        {
            key: "tutorials",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.tutorials",
                defaultMessage: "Agile tutorials"
            }),
            urlSlug: "/agile/tutorials",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/tutorials",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/tutorials",
                    level: 0
                },
                {
                    key: "/agile/tutorials/jira-confluence-sprint-refinement",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-jira-confluence-sprint-refinement",
                        defaultMessage: "Jira and Confluence sprint refinement"
                    }),
                    urlSlug: "/agile/tutorials/jira-confluence-sprint-refinement",
                    level: 1
                },
                {
                    key: "/agile/tutorials/how-to-do-scrum-with-jira",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-how-to-do-scrum-with-jira-software",
                        defaultMessage: "How to do scrum with Jira"
                    }),
                    urlSlug: "/agile/tutorials/how-to-do-scrum-with-jira",
                    level: 1
                },
                {
                    key: "/agile/tutorials/how-to-do-kanban-with-jira",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-how-to-do-kanban-with-jira-software",
                        defaultMessage: "Learn kanban with Jira"
                    }),
                    urlSlug: "/agile/tutorials/how-to-do-kanban-with-jira",
                    level: 1
                },
                {
                    key: "/agile/tutorials/epics",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-epics",
                        defaultMessage: "Learn how to use Epics in Jira"
                    }),
                    urlSlug: "/agile/tutorials/epics",
                    level: 1
                },
                {
                    key: "/agile/tutorials/creating-your-agile-board",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-creating-your-agile-board",
                        defaultMessage: "Learn how to create an agile board in Jira"
                    }),
                    urlSlug: "/agile/tutorials/creating-your-agile-board",
                    level: 1
                },
                {
                    key: "/agile/tutorials/sprints",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-sprints",
                        defaultMessage: "Learn how to use sprints in Jira"
                    }),
                    urlSlug: "/agile/tutorials/sprints",
                    level: 1
                },
                {
                    key: "/agile/tutorials/versions",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-versions",
                        defaultMessage: "Learn Versions with Jira"
                    }),
                    urlSlug: "/agile/tutorials/versions",
                    level: 1
                },
                {
                    key: "/agile/tutorials/issues",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-issues",
                        defaultMessage: "Learn Issues with Jira"
                    }),
                    urlSlug: "/agile/tutorials/issues",
                    level: 1
                },
                {
                    key: "/agile/tutorials/burndown-charts",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-burndown-charts",
                        defaultMessage: "Learn burndown charts with Jira"
                    }),
                    urlSlug: "/agile/tutorials/burndown-charts",
                    level: 1
                },
                {
                    key: "/agile/tutorials/how-to-auto-create-subtasks-with-jira-automation",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-how-to-auto-create-subtasks-with-jira-software-automation",
                        defaultMessage: "Auto-create sub-tasks and update fields in Jira"
                    }),
                    urlSlug: "/agile/tutorials/how-to-auto-create-subtasks-with-jira-automation",
                    level: 1
                },
                {
                    key: "/agile/tutorials/how-to-automatically-assign-issues-with-jira-software-automation",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-how-to-automatically-assign-issues-with-jira-software-automation",
                        defaultMessage: "How to automatically assign issues with Jira Automation"
                    }),
                    urlSlug: "/agile/tutorials/how-to-automatically-assign-issues-with-jira-software-automation",
                    level: 1
                },
                {
                    key: "/agile/tutorials/how-to-sync-epics-stories-with-jira-software-automation",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-how-to-sync-epics-stories-with-jira-software-automation",
                        defaultMessage: "How to sync epics stories with Jira Automation"
                    }),
                    urlSlug: "/agile/tutorials/how-to-sync-epics-stories-with-jira-software-automation",
                    level: 1
                },
                {
                    key: "/agile/tutorials/how-to-escalate-overdue-issues-with-jira-software-automation",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-how-to-escalate-overdue-issues-with-jira-software-automation",
                        defaultMessage: "Automatically escalate overdue issues in Jira"
                    }),
                    urlSlug: "/agile/tutorials/how-to-escalate-overdue-issues-with-jira-software-automation",
                    level: 1
                }
            ]
        },
        {
            key: "agile-conversations",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.agile-conversations",
                defaultMessage: "Agile conversations"
            }),
            urlSlug: "/agile/agile-conversations",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/agile-conversations",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-conversations-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/agile-conversations",
                    level: 0
                },
                {
                    key: "/agile/agile-conversations/marketing-agility",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-conversations-marketing-agility",
                        defaultMessage: "Unlocking marketing agility"
                    }),
                    urlSlug: "/agile/agile-conversations/marketing-agility",
                    level: 1
                },
                {
                    key: "/agile/agile-conversations/customer-research-tips",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-conversations-customer-research-tips",
                        defaultMessage: "The power of agile and customer insights"
                    }),
                    urlSlug: "/agile/agile-conversations/customer-research-tips",
                    level: 1
                },
                {
                    key: "/agile/agile-conversations/think-big-work-small",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-conversations-think-big-work-small",
                        defaultMessage: "Think big, work small"
                    }),
                    urlSlug: "/agile/agile-conversations/think-big-work-small",
                    level: 1
                }
            ]
        },
        {
            key: "about",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.about",
                defaultMessage: "About the Agile Coach"
            }),
            urlSlug: "/agile/about",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/about",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.about-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/about",
                    level: 0
                },
                {
                    key: "/agile/about/dan-radigan",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.about-dan-radigan",
                        defaultMessage: "Dan Radigan"
                    }),
                    urlSlug: "/agile/about/dan-radigan",
                    level: 1
                },
                {
                    key: "/agile/about/max-rehkopf",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.about-max-rehkopf",
                        defaultMessage: "Max Rehkopf"
                    }),
                    urlSlug: "/agile/about/max-rehkopf",
                    level: 1
                },
                {
                    key: "/agile/about/claire-drumond",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.about-claire-drumond",
                        defaultMessage: "Claire Drumond"
                    }),
                    urlSlug: "/agile/about/claire-drumond",
                    level: 1
                },
                {
                    key: "/agile/about/laura-daly",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.about-laura-daly",
                        defaultMessage: "Laura Daly"
                    }),
                    urlSlug: "/agile/about/laura-daly",
                    level: 1
                },
                {
                    key: "/agile/about/sherif-mansour",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.about-sherif-mansour",
                        defaultMessage: "Sherif Mansour"
                    }),
                    urlSlug: "/agile/about/sherif-mansour",
                    level: 1
                },
                {
                    key: "/agile/about/martin-suntinger",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.about-martin-suntinger",
                        defaultMessage: "Martin Suntinger"
                    }),
                    urlSlug: "/agile/about/martin-suntinger",
                    level: 1
                }
            ]
        },
        {
            key: "articles",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.articles",
                defaultMessage: "All articles"
            }),
            urlSlug: "/agile/articles",
            level: 0,
            isRoot: true
        }
    ];
    return AgileHubPageTreeData;
};

});



parcelRegister("bnSCE", function(module, exports) {
$parcel$export(module.exports, "ArticleShare", function () { return (parcelRequire("6sYN8")).ArticleShare; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("6sYN8")).ArticleShare; });

var $6sYN8 = parcelRequire("6sYN8");

});
parcelRegister("6sYN8", function(module, exports) {

$parcel$export(module.exports, "ArticleShare", function () { return $4f41c6afbc578d46$export$8316e2489e314828; });
/* article-share.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $baiMc = parcelRequire("baiMc");
const $4f41c6afbc578d46$var$ArticleShareContainerStyle = null;
const $4f41c6afbc578d46$var$ColumnStyles = null;
const $4f41c6afbc578d46$export$8316e2489e314828 = ({ description: description, link: link, title: title, source: source })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _bfhku67f _1tke1n2x _1n261g80 _s7n41q9y"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _1bsb1osq _2lx21bp4 _1aax1e5h _ca0qidpf _u5f3gktf _n3tdidpf _19bvgktf _kqswh2mm _19pk1wug _2hwx1wug _otyr1wug _18u01wug"
            ]),
            children: description && link && title && /*#__PURE__*/ (0, $loA2J.jsx)((0, $baiMc.SocialShareMenu), {
                description: description,
                link: link,
                title: title,
                source: source
            })
        })
    });
};

});
parcelRegister("baiMc", function(module, exports) {

$parcel$export(module.exports, "SocialShareMenu", function () { return $18239fd81c7e3271$export$22d14db7e0bd3bb5; });
/* social-share-menu.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");
const $18239fd81c7e3271$var$socialShareButtonStyle = {
    base: "_1e0c1o8l _1bsb1u1b _4t3i1u1b _1reo15vq _18m915vq",
    facebook: "_11q7153z _1lrw1osq",
    twitter: "_1itk1dl8 _12vemgnk _1lrw1osq _uokl1h6o",
    linkedin: "_1itk7ct8 _12vemgnk _1lrw1osq"
};
const $18239fd81c7e3271$var$SocialShareButtonActions = {
    facebook: {
        action: "https://www.facebook.com/dialog/feed",
        params: (props)=>({
                app_id: "743864389089816",
                caption: props.title,
                link: props.link,
                description: props.description,
                picture: "",
                name: props.title
            })
    },
    twitter: {
        action: "https://twitter.com/share",
        params: (props)=>({
                text: props.description,
                url: props.link,
                via: props.source
            })
    },
    linkedin: {
        action: "https://www.linkedin.com/shareArticle",
        params: (props)=>({
                mini: "true",
                url: props.link,
                title: props.title,
                summary: props.description,
                source: props.source
            })
    }
};
const $18239fd81c7e3271$export$49e0960a058fa5ad = ({ title: title, variant: variant, action: action })=>{
    const href = (0, $iSvIT.useMemo)(()=>{
        const actionDescriptor = $18239fd81c7e3271$var$SocialShareButtonActions[variant];
        const url = new URL(actionDescriptor.action);
        const params = new URLSearchParams(actionDescriptor.params(action));
        for (const [key, value] of params.entries())url.searchParams.set(key, value);
        return url.href;
    }, [
        variant,
        action
    ]);
    const clickHandler = (0, $iSvIT.useCallback)((e)=>{
        if (typeof window !== "undefined") {
            window.open(href, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600");
            e.preventDefault();
        }
    }, [
        href
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        "aria-label": "Share to Social Media",
        href: href,
        title: title,
        onClick: clickHandler,
        className: (0, $esG4f.default)([
            $18239fd81c7e3271$var$socialShareButtonStyle.base,
            $18239fd81c7e3271$var$socialShareButtonStyle[variant]
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            style: {
                pointerEvents: "none",
                visibility: "hidden"
            },
            children: title
        })
    });
};
const $18239fd81c7e3271$var$socialShareMenuItemStyle = null;
const $18239fd81c7e3271$var$socialShareMenuStyle = null;
const $18239fd81c7e3271$var$shareTextStyle = null;
const $18239fd81c7e3271$export$22d14db7e0bd3bb5 = ({ description: description, link: link, title: title, source: source })=>{
    const intl = (0, $f6qj2.default)();
    const action = (0, $iSvIT.useMemo)(()=>({
            title: title,
            description: description,
            link: link,
            source: source !== null && source !== void 0 ? source : "Atlassian"
        }), [
        description,
        link,
        title,
        source
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_syaz1bqd _1e0c1txw _2lx21bp4 _y3gn1e5h",
                    "eyebrow-md"
                ]),
                children: intl.formatMessage({
                    id: "Agile.article.share",
                    defaultMessage: "Share this article"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("ul", {
                className: (0, $esG4f.default)([
                    "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("li", {
                        className: (0, $esG4f.default)([
                            "_4t3i1u1b _7hrg14y2 _ca0qyh40 _u5f3yh40 _n3tdyh40 _19bvyh40"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)($18239fd81c7e3271$export$49e0960a058fa5ad, {
                            variant: "facebook",
                            action: action,
                            title: intl.formatMessage({
                                id: "Agile.share-menu.facebook",
                                defaultMessage: "Share on Facebook"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("li", {
                        className: (0, $esG4f.default)([
                            "_4t3i1u1b _7hrg14y2 _ca0qyh40 _u5f3yh40 _n3tdyh40 _19bvyh40"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)($18239fd81c7e3271$export$49e0960a058fa5ad, {
                            variant: "twitter",
                            action: action,
                            title: intl.formatMessage({
                                id: "Agile.share-menu.twitter",
                                defaultMessage: "Share on Twitter"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("li", {
                        className: (0, $esG4f.default)([
                            "_4t3i1u1b _7hrg14y2 _ca0qyh40 _u5f3yh40 _n3tdyh40 _19bvyh40"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)($18239fd81c7e3271$export$49e0960a058fa5ad, {
                            variant: "linkedin",
                            action: action,
                            title: intl.formatMessage({
                                id: "Agile.share-menu.linkedin",
                                defaultMessage: "Share on LinkedIn"
                            })
                        })
                    })
                ]
            })
        ]
    });
};

});



parcelRegister("hx0Ku", function(module, exports) {

$parcel$export(module.exports, "SubNavSoftwareDevelopment", function () { return $dd75b11cf0609d62$export$f91d8d46274171ba; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");

var $8X9yo = parcelRequire("8X9yo");

var $k5PB7 = parcelRequire("k5PB7");
const $dd75b11cf0609d62$export$f91d8d46274171ba = ()=>{
    const intl = (0, $f6qj2.default)();
    const productKey = "agile";
    const headerLinkText = intl.formatMessage({
        id: "software-development.logo-label",
        defaultMessage: "Software Development"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8X9yo.SubNav), {
        productKey: productKey,
        headerLinkText: headerLinkText,
        headerLinkHref: (0, $3FBn4.useLocalizedHref)("/software-development"),
        desktopLinks: [
            {
                globalLinksKey: "devops",
                linkText: intl.formatMessage({
                    id: "software-development.subnav.devops",
                    defaultMessage: "DevOps"
                }),
                hasSubnav: true,
                content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $k5PB7.DevopsDropdown), {})
            },
            {
                globalLinksKey: "agile",
                linkText: intl.formatMessage({
                    id: "software-development.subnav.agile",
                    defaultMessage: "Agile"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/agile"),
                hasSubnav: false
            },
            {
                globalLinksKey: "microservices",
                linkText: intl.formatMessage({
                    id: "software-development.subnav.microservices",
                    defaultMessage: "Microservices"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/microservices"),
                hasSubnav: false
            }
        ],
        mobileLinks: [
            {
                mobileLinkKey: "subnav-links",
                mobileLinksProps: [
                    {
                        globalLinksKey: "devops",
                        linkText: intl.formatMessage({
                            id: "software-development.subnav-mobile.dropdown.devops",
                            defaultMessage: "DevOps"
                        }),
                        hasSubnav: true,
                        dropdownType: "devops"
                    },
                    {
                        globalLinksKey: "agile",
                        linkText: intl.formatMessage({
                            id: "software-development.subnav-mobile.agile",
                            defaultMessage: "Agile"
                        }),
                        hasSubnav: false,
                        href: (0, $3FBn4.useLocalizedHref)("/agile")
                    },
                    {
                        globalLinksKey: "microservices",
                        linkText: intl.formatMessage({
                            id: "software-development.subnav-mobile.microservices",
                            defaultMessage: "Microservices"
                        }),
                        hasSubnav: false,
                        href: (0, $3FBn4.useLocalizedHref)("/microservices")
                    }
                ]
            }
        ]
    });
};

});
parcelRegister("8X9yo", function(module, exports) {

$parcel$export(module.exports, "SubNav", function () { return $f4ad761f70655513$export$4a51633636d7017c; });
/* subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dyZbY = parcelRequire("dyZbY");

var $5ohHq = parcelRequire("5ohHq");

var $hbBKK = parcelRequire("hbBKK");

var $3L9Vp = parcelRequire("3L9Vp");
const $f4ad761f70655513$var$navigationBarWrapperCss = null; // @ts-ignore
const $f4ad761f70655513$var$navBarShadow = null;
const $f4ad761f70655513$var$navigationBarLogoCss = null;
const $f4ad761f70655513$var$textWrapperCss = null;
const $f4ad761f70655513$var$textCss = null; // @ts-ignore
const $f4ad761f70655513$var$ffTextCss = null;
const $f4ad761f70655513$var$mobileNavCss = null;
const $f4ad761f70655513$var$subNavCss = null;
const $f4ad761f70655513$export$4f1b8c6dfaa906bb = ({ productKey: productKey, headerLinkText: headerLinkText, headerLinkHref: headerLinkHref, desktopLinks: desktopLinks })=>{
    const globalLinksRef = (0, $iSvIT.useRef)(null);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_mqm21k0a _4cvr1h6o _11q7cd5j _1e0c1txw _4t3it9kd _2lx2vrvc _1bah1h6o _1pbykb7n _1mjbglyw",
            "desktop-sub-nav"
        ]),
        style: {
            "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300")),
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1e0cglyw _4cvr1h6o _1bah1h6o _16jlkb7n _1o9zkb7n _i0dlf1ug _18zr1ylp _2lx2vrvc _kqswh2mm _1pbyegat _195g1tcg _dm251txw _10jxtfvk _owpuidpf _165t1osq _xtn71wqb",
                "sub-navigation-bar"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("nav", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4t3i1osq _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _4cvr1h6o _glte1wug",
                            "navigation-bar-logo"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            "data-testid": "sub-navigation-bar-logo-link",
                            href: headerLinkHref,
                            "aria-label": headerLinkText,
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-event-container": "subNavWac",
                            "data-product-key": productKey,
                            className: (0, $esG4f.default)([
                                "_4t3i1osq _syaz1hlo _4cvr1h6o _1e0c1txw _2lx2vrvc"
                            ]),
                            style: {
                                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                className: (0, $esG4f.default)([
                                    "_1wyb1k92 _k48pni7l"
                                ]),
                                children: headerLinkText
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $hbBKK.default), {
                        globalLinksProps: desktopLinks,
                        globalLinksRef: globalLinksRef,
                        isSubnav: true
                    })
                ]
            })
        })
    });
};
const $f4ad761f70655513$export$4a51633636d7017c = ({ productKey: productKey, headerLinkText: headerLinkText, headerLinkHref: headerLinkHref, desktopLinks: desktopLinks, mobileLinks: mobileLinks })=>{
    const globalNavItemKeys = (0, $iSvIT.useMemo)(()=>{
        return desktopLinks.map((link)=>link.globalLinksKey);
    }, [
        desktopLinks
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "subnav",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_kqsw1if8 _1pbykb7n _152t8vuz _12ho1ex1 _180k88uy"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $hbBKK.GlobalNavProvider), {
                    globalNavItemKeys: globalNavItemKeys,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)($f4ad761f70655513$export$4f1b8c6dfaa906bb, {
                        productKey: productKey,
                        headerLinkText: headerLinkText,
                        headerLinkHref: headerLinkHref,
                        desktopLinks: desktopLinks
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0cglyw _1mjb1ule",
                        "mobile-nav"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3L9Vp.MobileSubNav), {
                        productKey: productKey,
                        headerLinkText: headerLinkText,
                        headerLinkHref: headerLinkHref,
                        isShowSearchButton: false,
                        mobileLinks: mobileLinks
                    })
                })
            ]
        })
    });
};
$f4ad761f70655513$export$4a51633636d7017c.displayName = "SubNav";

});
parcelRegister("3L9Vp", function(module, exports) {

$parcel$export(module.exports, "MobileSubNav", function () { return $fd308501c66bbae4$export$7b30ebdb7f5cc633; });
/* subnav-mobile.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");

var $aoDWS = parcelRequire("aoDWS");

var $4What = parcelRequire("4What");

var $kQQu6 = parcelRequire("kQQu6");

var $e9PKE = parcelRequire("e9PKE");

var $k5PB7 = parcelRequire("k5PB7");

var $5bpkQ = parcelRequire("5bpkQ");
const $fd308501c66bbae4$var$containerCss = null; // @ts-ignore
const $fd308501c66bbae4$var$navBarShadow = null;
const $fd308501c66bbae4$var$shownInnerMobileDropdownMenuStyle = null;
const $fd308501c66bbae4$var$hiddenInnerMobileDropdownMenuStyle = null;
const $fd308501c66bbae4$var$menuContentStyle = null;
const $fd308501c66bbae4$var$containerClosedCss = null;
const $fd308501c66bbae4$var$containerOpenCss = null;
const $fd308501c66bbae4$var$navBarClosedCss = null; // @ts-ignore
const $fd308501c66bbae4$var$alignNavBarText = null;
const $fd308501c66bbae4$var$navBarOpenCss = null;
const $fd308501c66bbae4$var$fadeIn = null;
const $fd308501c66bbae4$var$slideInLeft = null;
const $fd308501c66bbae4$var$slideInRight = null;
const $fd308501c66bbae4$var$fadeInCss = null;
const $fd308501c66bbae4$var$slideInLeftCss = null;
const $fd308501c66bbae4$var$slideInRightCss = null;
const $fd308501c66bbae4$export$e0ff47c11cc5d411 = ({ menuPage: menuPage = "default", firstOpen: firstOpen, mobileLinksSections: mobileLinksSections, handleMenuPage: handleMenuPage })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    firstOpen && "",
                    firstOpen && "_tzy4idpf _y44v10k4",
                    !firstOpen && "",
                    !firstOpen && "_tzy4idpf _y44vydmd",
                    menuPage === "default" ? "_1e0c1ule _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz" : "_1e0cglyw _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz",
                    "inner-mobile-dropdown-menu"
                ]),
                children: mobileLinksSections.map(({ mobileLinkKey: mobileLinkKey, mobileLinksProps: mobileLinksProps }, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $kQQu6.MobileNavLinksContainer), {
                        mobileLinkKey: mobileLinkKey,
                        mobileLinksProps: mobileLinksProps,
                        handleMenuPage: handleMenuPage,
                        isIncludeBottomDivider: false
                    }, index))
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_tzy4idpf _y44vm8zv",
                    menuPage === "devops" ? "_1e0c1ule _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz" : "_1e0cglyw _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $k5PB7.DevopsDropdown), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_tzy4idpf _y44vm8zv",
                    menuPage === "categories" ? "_1e0c1ule _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz" : "_1e0cglyw _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $e9PKE.CategoriesDropdown), {})
            })
        ]
    });
};
const $fd308501c66bbae4$var$textWrapperCss = null;
const $fd308501c66bbae4$var$textCss = null; // @ts-ignore
const $fd308501c66bbae4$var$ffTextCss = null;
const $fd308501c66bbae4$export$7b30ebdb7f5cc633 = ({ headerLinkText: headerLinkText, headerLinkHref: headerLinkHref, productKey: productKey, mobileLinks: mobileLinks })=>{
    const { userInfo: userInfo, showMenu: showMenu, firstOpen: firstOpen, menuPage: menuPage, handleToggleMenu: handleToggleMenu, handleFirstOpen: handleFirstOpen, handleMenuPage: handleMenuPage } = (0, $aoDWS.useMobileNavDisplay)(false);
    const headerLink = /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4t3i1osq _syaz1hlo _4cvr1h6o _1e0c1txw _2lx2vrvc"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            className: (0, $esG4f.default)([
                "_1wyb1k92 _ca0q1ou6 _u5f37vkz _n3tdgktf _19bvidpf _k48pni7l"
            ]),
            children: headerLinkText
        })
    });
    const mobileGlobalNavDropdownMenu = ()=>/*#__PURE__*/ (0, $loA2J.jsx)($fd308501c66bbae4$export$e0ff47c11cc5d411, {
            showMenu: showMenu,
            isUserLoggedIn: userInfo.isUserLoggedIn,
            menuPage: menuPage,
            firstOpen: firstOpen,
            mobileLinksSections: mobileLinks,
            handleToggleMenu: handleToggleMenu,
            handleMenuPage: handleMenuPage,
            handleFirstOpen: handleFirstOpen,
            productKey: productKey
        });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_mqm21k0a _152t8vuz _11q7cd5j _1e0c1txw _2lx21bp4 _zulputpp _4t3i1mcy _1bah1h6o",
            showMenu ? "_ca0qftgi _u5f3ftgi _n3tdftgi _19bvftgi _tnru1kxc _1rfm1osq _1o831wug _98bk1wug _13zm1n9t _1kmxftgi _1ggm1tcg _1ykz1tcg _1mae1tcg _2rfoqfx8" : "_ca0qftgi _u5f3ftgi _n3tdftgi _19bvftgi"
        ]),
        style: {
            "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300")),
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    showMenu ? "_su07pxbi _1e0c1txw _4cvr1h6o _1bah1yb4" : "_18zrpxbi _1e0c1txw _1bah1yb4"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5bpkQ.MobileSubNavTop), {
                    productKey: productKey,
                    showMenu: showMenu,
                    handleToggleMenu: handleToggleMenu,
                    menuPage: menuPage,
                    handleMenuPage: handleMenuPage,
                    handleFirstOpen: handleFirstOpen,
                    mobileLogo: headerLink,
                    mobileLogoAriaLabel: headerLinkText,
                    mobileLogoHref: headerLinkHref,
                    mobileLogoDataEventContainer: "subNavWac",
                    tabletDropdownMenu: mobileGlobalNavDropdownMenu()
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                id: "nav-mobile-dropdown-menu",
                className: (0, $esG4f.default)([
                    "_1e0cglyw _1bsb1wug _181nglyw",
                    showMenu && "_1e0c1ule"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4What.Divider), {})
                    }),
                    mobileGlobalNavDropdownMenu()
                ]
            })
        ]
    });
};

});
parcelRegister("e9PKE", function(module, exports) {

$parcel$export(module.exports, "CategoriesDropdown", function () { return $b665f4b087de0640$export$abcf464d25ebdb87; });
/* subnav-categories-dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");
const $b665f4b087de0640$var$wrapperStyle = null;
const $b665f4b087de0640$var$headerStyle = null;
const $b665f4b087de0640$var$linkColumnStyle = null;
const $b665f4b087de0640$var$linkStyle = null;
const $b665f4b087de0640$var$CategoriesDropdownContentSection = ({ header: header, links: links })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_1p1dangw _syaz1hlo _1wyboqnp _ect4bzd7 _k48p1fw0 _vwz41j6v"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                },
                children: header
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _umai1ylp _1bsbntd2"
                ]),
                children: links.map((link)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                        href: link.href,
                        "data-event": "clicked",
                        "data-event-component": "linkButton",
                        "data-event-container": "Sub-Nav-link-in-dropdown",
                        onClick: link.onClick,
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1hlo _1wyboxwj _1wpzh9n0 _30l317la"
                        ]),
                        style: {
                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                        },
                        children: link.text
                    }, link.text))
            })
        ]
    });
};
const $b665f4b087de0640$export$abcf464d25ebdb87 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)($b665f4b087de0640$var$CategoriesDropdownContentSection, {
        header: intl.formatMessage({
            id: "jira-templates.subnav.categories.type.header",
            defaultMessage: "categories"
        }),
        links: [
            {
                text: intl.formatMessage({
                    id: "jira-templates.subnav.categories.type.software-development",
                    defaultMessage: "Software Development"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/software/jira/templates/software-development")
            },
            {
                text: intl.formatMessage({
                    id: "jira-templates.subnav.categories.type.marketing",
                    defaultMessage: "Marketing"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/software/jira/templates/marketing")
            },
            {
                text: intl.formatMessage({
                    id: "jira-templates.subnav.categories.type.design",
                    defaultMessage: "Design"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/software/jira/templates/design")
            },
            {
                text: intl.formatMessage({
                    id: "jira-templates.subnav.categories.type.sales",
                    defaultMessage: "Sales"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/software/jira/templates/sales")
            },
            {
                text: intl.formatMessage({
                    id: "jira-templates.subnav.categories.type.operations",
                    defaultMessage: "Operations"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/software/jira/templates/operations")
            },
            {
                text: intl.formatMessage({
                    id: "jira-templates.subnav.categories.type.service-management",
                    defaultMessage: "Service Management"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/software/jira/templates/service-management")
            },
            {
                text: intl.formatMessage({
                    id: "jira-templates.subnav.categories.type.hr",
                    defaultMessage: "HR"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/software/jira/templates/hr")
            },
            {
                text: intl.formatMessage({
                    id: "jira-templates.subnav.categories.type.legal",
                    defaultMessage: "Legal"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/software/jira/templates/legal")
            },
            {
                text: intl.formatMessage({
                    id: "jira-templates.subnav.categories.type.it-operations",
                    defaultMessage: "IT Operations"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/software/jira/templates/it-operations")
            },
            {
                text: intl.formatMessage({
                    id: "jira-templates.subnav.categories.type.finance",
                    defaultMessage: "Finance"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/software/jira/templates/finance")
            },
            {
                text: intl.formatMessage({
                    id: "jira-templates.subnav.categories.type.project-management",
                    defaultMessage: "Project Management"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/project-management/templates")
            }
        ]
    }, "categories");
};

});

parcelRegister("k5PB7", function(module, exports) {

$parcel$export(module.exports, "DevopsDropdown", function () { return $5f22cbdb8437888a$export$14a5b297e74877f3; });
/* subnav-devops-dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");
const $5f22cbdb8437888a$var$wrapperStyle = null;
const $5f22cbdb8437888a$var$headerStyle = null;
const $5f22cbdb8437888a$var$linkColumnStyle = null;
const $5f22cbdb8437888a$var$linkStyle = null;
const $5f22cbdb8437888a$var$DevopsDropdownContentSection = ({ header: header, links: links })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_1p1dangw _syaz1hlo _1wyboqnp _ect4bzd7 _k48p1fw0 _vwz41j6v"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                },
                children: header
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _umai1ylp _1bsbntd2"
                ]),
                children: links.map((link)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                        href: link.href,
                        "data-event": "clicked",
                        "data-event-component": "linkButton",
                        "data-event-container": "Sub-Nav-link-in-dropdown",
                        onClick: link.onClick,
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1hlo _1wyboxwj _1wpzh9n0 _30l317la"
                        ]),
                        style: {
                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                        },
                        children: link.text
                    }, link.text))
            })
        ]
    });
};
const $5f22cbdb8437888a$export$14a5b297e74877f3 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)($5f22cbdb8437888a$var$DevopsDropdownContentSection, {
        header: intl.formatMessage({
            id: "software-development.subnav.devops.type.header",
            defaultMessage: "devops"
        }),
        links: [
            {
                text: intl.formatMessage({
                    id: "software-development.subnav.devops.type.continuous-delivery",
                    defaultMessage: "Continuous Delivery"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/continuous-delivery")
            },
            {
                text: intl.formatMessage({
                    id: "software-development.subnav.devops.type.git",
                    defaultMessage: "Git"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/git")
            }
        ]
    }, "devops");
};

});

parcelRegister("5bpkQ", function(module, exports) {

$parcel$export(module.exports, "MobileSubNavTop", function () { return $7a3edb18ce981c99$export$4dbd6629097ee82e; });
/* subnav-mobile-top.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $d0cJX = parcelRequire("d0cJX");
const $7a3edb18ce981c99$var$mobileLogoCss = null;
const $7a3edb18ce981c99$var$tabletLogoCss = null;
const $7a3edb18ce981c99$var$logoCss = null;
const $7a3edb18ce981c99$var$backButtonCss = null;
const $7a3edb18ce981c99$var$chevronCss = null;
const $7a3edb18ce981c99$var$mobileIconContainerCss = null;
const $7a3edb18ce981c99$var$mobileDropdownMenuCss = null;
const $7a3edb18ce981c99$var$tabletIconContainerCss = null;
const $7a3edb18ce981c99$var$dropdownCss = null;
const $7a3edb18ce981c99$export$4dbd6629097ee82e = ({ productKey: productKey, showMenu: showMenu, handleToggleMenu: handleToggleMenu, menuPage: menuPage, handleMenuPage: handleMenuPage, handleFirstOpen: handleFirstOpen, mobileLogo: mobileLogo, mobileLogoAriaLabel: mobileLogoAriaLabel = "Atlassian logo", mobileLogoHref: mobileLogoHref = "/", mobileLogoDataEventContainer: mobileLogoDataEventContainer = "subNavWac", tabletDropdownMenu: tabletDropdownMenu })=>{
    const intl = (0, $f6qj2.default)();
    const [mobileDropdownMenu, setMobileDropdownMenu] = (0, $iSvIT.useState)(null);
    const handleClickOutside = (0, $iSvIT.useCallback)((event)=>{
        const path = event.composedPath && event.composedPath();
        if (mobileDropdownMenu) {
            const style = window.getComputedStyle(mobileDropdownMenu);
            const insideTabletMobileDropdownMenu = Array.prototype.includes.call(Array.prototype.map.call(path, (el)=>{
                return el.id === "nav-tablet-mobile-dropdown-menu-button";
            }), true);
            if (!insideTabletMobileDropdownMenu && style.display !== "none") {
                handleToggleMenu(false);
                handleMenuPage("default");
                handleFirstOpen(false);
            }
        }
    }, [
        mobileDropdownMenu,
        handleToggleMenu,
        handleMenuPage,
        handleFirstOpen
    ]);
    const handleKeydown = (0, $iSvIT.useCallback)((event)=>{
        if (event.code == "Escape" && showMenu) {
            handleToggleMenu(false);
            handleMenuPage("default");
            handleFirstOpen(false);
        }
    }, [
        handleToggleMenu,
        handleMenuPage,
        handleFirstOpen,
        showMenu
    ]);
    (0, $iSvIT.useEffect)(()=>{
        const element = document.getElementById("nav-tablet-mobile-dropdown-menu-button");
        setMobileDropdownMenu(element);
    }, []);
    (0, $iSvIT.useEffect)(()=>{
        document.addEventListener("click", handleClickOutside);
        document.addEventListener("keydown", handleKeydown);
        return ()=>{
            document.removeEventListener("click", handleClickOutside);
            document.removeEventListener("keydown", handleKeydown);
        };
    }, [
        handleClickOutside,
        handleKeydown
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _4cvr1h6o _181nglyw",
                    "mobile-nav-company-logo"
                ]),
                children: menuPage === "default" || !showMenu ? /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                    href: mobileLogoHref,
                    "aria-label": mobileLogoAriaLabel,
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": mobileLogoDataEventContainer,
                    "data-product-key": productKey,
                    className: (0, $esG4f.default)([
                        "_4t3i183y"
                    ]),
                    children: mobileLogo
                }) : /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                    style: {
                        all: "unset",
                        width: "100%"
                    },
                    onClick: (e)=>{
                        e.preventDefault();
                        handleMenuPage("default");
                        handleFirstOpen(false);
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_syazaqb7 _1e0c1txw _4cvr1h6o"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1mou1pzu"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d0cJX))), {
                                    label: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                children: intl.formatMessage({
                                    id: "subnav.menu-back",
                                    defaultMessage: "Back"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _181n1txw _q8t51h6o",
                    "tablet-nav-company-logo"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                    href: mobileLogoHref,
                    "aria-label": mobileLogoAriaLabel,
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": mobileLogoDataEventContainer,
                    "data-product-key": productKey,
                    className: (0, $esG4f.default)([
                        "_4t3i183y"
                    ]),
                    children: mobileLogo
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4t3i1ylp _1e0c1txw _4cvr1h6o _181nglyw"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                    style: {
                        all: "unset"
                    },
                    "aria-label": intl.formatMessage({
                        id: "subnav.menu-icon.toggle",
                        defaultMessage: "Toggle Menu"
                    }),
                    className: (0, $esG4f.default)([
                        "_1e0cglyw _80omtlke _tnv2qshr _13jeglyw _7w28rbzz _1mjb1ule _xc2i12x7",
                        "subnavToggleMenu"
                    ]),
                    onClick: (e)=>{
                        e.preventDefault();
                        handleToggleMenu(!showMenu);
                        handleMenuPage("default");
                        handleFirstOpen(!showMenu);
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                        width: "18",
                        height: "11",
                        viewBox: "0 0 18 11",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        className: (0, $esG4f.default)([
                            "_v5644h09",
                            showMenu && "_t9ec1sub"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            d: "M17 1.86328L9 9.13601L1 1.86328",
                            stroke: "#101214",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                id: "nav-tablet-mobile-dropdown-menu-button",
                className: (0, $esG4f.default)([
                    "_1e0cglyw _181n1txw _q8t51h6o _1rqih2mm"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                        style: {
                            all: "unset"
                        },
                        "aria-label": intl.formatMessage({
                            id: "subnav.menu-icon.toggle",
                            defaultMessage: "Toggle Menu"
                        }),
                        className: (0, $esG4f.default)([
                            "_1e0cglyw _80omtlke _tnv2qshr _13jeglyw _7w28rbzz _1mjb1ule _xc2i12x7",
                            "subnavToggleMenu"
                        ]),
                        onClick: (e)=>{
                            e.preventDefault();
                            handleToggleMenu(!showMenu);
                            handleMenuPage("default");
                            handleFirstOpen(!showMenu);
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                            width: "18",
                            height: "11",
                            viewBox: "0 0 18 11",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: (0, $esG4f.default)([
                                "_v5644h09",
                                showMenu && "_t9ec1sub"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                d: "M17 1.86328L9 9.13601L1 1.86328",
                                stroke: "#101214",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0cglyw _1lpykb7n _12ho1osq _1d2yxilx _14b51ris _1rqistnw _1xlo1j15 _e7o81dj1 _sfejpt1k _dwk3usvi _nv391wug _1bv01wug _1kkmgktf _z21jg2rd _nxbczf9h _6o24b4wl _1jb3u67f _1ocvidpf _1cac122b _1gw0zo7u _164f1ur6",
                            showMenu && "_181n1ule",
                            "mobile-dropdown-menu"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1pfhftgi _6rthftgi _1e0cglyw _1bah1y6m _4cvr1h6o",
                                    menuPage !== "default" && "_1e0c1txw"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                    style: {
                                        all: "unset"
                                    },
                                    onClick: (e)=>{
                                        e.preventDefault();
                                        handleMenuPage("default");
                                        handleFirstOpen(false);
                                    },
                                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_syazaqb7 _1e0c1txw _4cvr1h6o"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_1mou1pzu"
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d0cJX))), {
                                                    label: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                children: intl.formatMessage({
                                                    id: "subnav.menu-back",
                                                    defaultMessage: "Back"
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            tabletDropdownMenu
                        ]
                    })
                ]
            }),
            showMenu && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqsw1n9t _1e0c1ule _1bsb1osq _4t3i1osq _1e02idpf _rjxpidpf _u7coidpf _bfhk1ebw _1pby1mrw",
                    "overlay"
                ])
            })
        ]
    });
};

});




parcelRegister("h6PiC", function(module, exports) {

$parcel$export(module.exports, "AgileBreadcrumbs", function () { return $6a5b4d3fc20315ca$export$2ce562bcf8da2de8; });

var $loA2J = parcelRequire("loA2J");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");

var $ibGVp = parcelRequire("ibGVp");

var $2OqHh = parcelRequire("2OqHh");

var $lrVTP = parcelRequire("lrVTP");
const $6a5b4d3fc20315ca$export$71ac4f9beafb009b = (paths)=>{
    const agileTree = (0, $ibGVp.useAgileHubPageTreeData)();
    const names = paths.map((path)=>{
        if (path === "/agile") return {
            name: "Agile",
            path: "/agile"
        };
        const node = agileTree.find((obj)=>path.includes(obj.urlSlug));
        if (node) {
            if (path === node.urlSlug) return {
                name: node.name,
                path: node.urlSlug
            };
            else {
                const childNode = node.children && node.children.find((obj)=>path === obj.urlSlug);
                if (childNode) return {
                    name: childNode.name,
                    path: childNode.urlSlug
                };
            }
        }
        return {
            name: "",
            path: ""
        };
    });
    return names;
};
const $6a5b4d3fc20315ca$export$2ce562bcf8da2de8 = ()=>{
    const location = (0, $lrVTP.useLocation)();
    const { pathname: pathname } = location;
    const segmentPaths = (0, $2OqHh.getProgressivePathSegments)(pathname);
    const segmentObjs = $6a5b4d3fc20315ca$export$71ac4f9beafb009b(segmentPaths);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
        layout: "12",
        alignItems: "top",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Breadcrumbs), {
            links: segmentObjs
        })
    });
};

});
parcelRegister("2OqHh", function(module, exports) {

$parcel$export(module.exports, "getProgressivePathSegments", function () { return $6445275238d5e176$export$d491212abeef3206; });

var $igbrG = parcelRequire("igbrG");
const $6445275238d5e176$export$d491212abeef3206 = (path)=>{
    let proPath = "/";
    if (!path || !path.startsWith("/")) return [];
    return path.split("/").filter(Boolean) // remove empty array elements
    .filter((p)=>!(0, $igbrG.isValidLocale)(p)).map((value)=>{
        proPath += `${value}/`;
        return proPath.replace(/\/$/, "");
    });
};

});


parcelRegister("gDqhU", function(module, exports) {
$parcel$export(module.exports, "AgileHeading", function () { return (parcelRequire("lTwyn")).AgileHeading; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("lTwyn")).AgileHeading; });

var $lTwyn = parcelRequire("lTwyn");

});
parcelRegister("lTwyn", function(module, exports) {

$parcel$export(module.exports, "AgileHeading", function () { return $3da6520e2c550ecc$export$9f1161956c98afd6; });
/* agile-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
parcelRequire("dyrzP");
var $9Kv7x = parcelRequire("9Kv7x");

var $lHB9W = parcelRequire("lHB9W");
const $3da6520e2c550ecc$var$headerStyles = null;
const $3da6520e2c550ecc$var$eyebrowStyles = null;
const $3da6520e2c550ecc$var$h1Styles = null;
const $3da6520e2c550ecc$var$pStyles = null; // TODO: Switch to shared Article Grid component
// or at least exported widths/paddings, once in place
const $3da6520e2c550ecc$var$contentBlockStyles = null;
const $3da6520e2c550ecc$var$authorStyles = null;
const $3da6520e2c550ecc$var$headshotStyles = null;
const $3da6520e2c550ecc$export$9f1161956c98afd6 = ({ title: title, eyebrow: eyebrow, description: description, imageUrl: imageUrl, author: author })=>{
    var _author_authorPicture;
    return /*#__PURE__*/ (0, $loA2J.jsx)("header", {
        style: imageUrl ? {
            backgroundImage: `url(${imageUrl})`
        } : undefined,
        className: (0, $esG4f.default)([
            "_1lrw1dfr _1rjc1jly _1e0c11p5 _4cvr1h6o _6a6z1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1bsb1osq _p12fzqdx _ca0q1j6v _u5f3viql _n3tdidpf _19bvviql _bfhku67f _su071wqb"
            ]),
            children: [
                eyebrow && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: (0, $esG4f.default)([
                        "_syazvwuj _1wyboqnp _1dyzt94y _vwz4cs5v _1p1dangw",
                        "eyebrow-sm"
                    ]),
                    children: eyebrow
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                    className: (0, $esG4f.default)([
                        "_k48pbfng _1wyb1lne _1pfh7vkz _6rth7vkz _1dyzidpf _vwz410nf _syaz1bqd _d8hs1tcg"
                    ]),
                    children: title
                }),
                description && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: (0, $esG4f.default)([
                        "_1wyb1k92 _vwz419ii _6rth7vkz _syaz1bqd _1tnt1tcg",
                        "body-lg"
                    ]),
                    children: description
                }),
                author && /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                    className: (0, $esG4f.default)([
                        "_1wyboxwj _1e0c1txw _zulp1j6v _4cvr1h6o _1p1dangw",
                        "body-sm"
                    ]),
                    children: [
                        ((_author_authorPicture = author.authorPicture) === null || _author_authorPicture === void 0 ? void 0 : _author_authorPicture.url) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $9Kv7x.ContentPlatformImage), {
                            src: author.authorPicture.url,
                            baseWidth: 36,
                            width: 36,
                            height: 36,
                            alt: "",
                            className: (0, $esG4f.default)([
                                "_2rko1ssb _1bsbahaf _4t3iahaf _5ral1dfr"
                            ])
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "agile.heading.author.byline",
                            defaultMessage: "by {authorName}",
                            values: {
                                authorName: (0, $lHB9W.expectContent)(author.name, "Author name not found")
                            }
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("dyrzP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("9Kv7x")).ContentPlatformImage; });

var $9Kv7x = parcelRequire("9Kv7x");

});
parcelRegister("9Kv7x", function(module, exports) {

$parcel$export(module.exports, "ContentPlatformImage", function () { return $ecf502f0947f1c39$export$f8e4eb6f7b9af79c; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $bhreu = parcelRequire("bhreu");
const $ecf502f0947f1c39$export$f8e4eb6f7b9af79c = (_param)=>{
    var { contentType: contentType, src: src, alt: alt, baseWidth: baseWidth } = _param, rest = (0, $akGnX._)(_param, [
        "contentType",
        "src",
        "alt",
        "baseWidth"
    ]);
    const queryPairs = [];
    let srcSet = [];
    if (contentType === "image/png") {
        queryPairs.push("fm=webp");
        if (baseWidth) {
            srcSet = (0, $bhreu.getSrcSet)(src, baseWidth, queryPairs, "w");
            queryPairs.push(`w=${baseWidth}`);
        }
    }
    const queryString = queryPairs.length > 0 ? `?${queryPairs.join("&")}` : "";
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $loA2J.jsx)("img", (0, $6iHNw._)((0, $7Knp0._)({
        loading: "lazy"
    }, rest), {
        src: `${src}${queryString}`,
        srcSet: srcSet.length > 0 ? srcSet.join(",") : undefined,
        alt: alt
    })));
};

});




parcelRegister("60ddw", function(module, exports) {

$parcel$export(module.exports, "AgileArticleProvider", function () { return $8e568f111cb146a0$export$ecb2b49a912f88b6; });
$parcel$export(module.exports, "useAgileArticle", function () { return $8e568f111cb146a0$export$8e273e37741217be; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $goGkF = parcelRequire("goGkF");

var $1qD46 = parcelRequire("1qD46");

var $gpl9P = parcelRequire("gpl9P");
const $8e568f111cb146a0$export$4607bcc71139ee8e = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $8e568f111cb146a0$var$useAgileArticleContextValue = (agileArticle)=>{
    const [contextValue, setContextValue] = (0, $iSvIT.useState)(agileArticle);
    (0, $iSvIT.useEffect)(()=>{
        const fetchAgileArticleFromClient = async ()=>{
            const client = new (0, $gpl9P.AGGClient)({
                gatewayUrl: "https://www.atlassian.com/gateway/api/graphql"
            });
            const { route: route, locale: locale } = (0, $1qD46.getCurrentRoute)();
            const agileArticle = await (0, $goGkF.getTemplateData)(route, locale, client);
            setContextValue(agileArticle);
        };
        if (!contextValue) fetchAgileArticleFromClient();
    // empty dependency array so this effect only runs once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return contextValue;
};
const $8e568f111cb146a0$export$ecb2b49a912f88b6 = (props)=>{
    const value = $8e568f111cb146a0$var$useAgileArticleContextValue(props.agileArticle);
    return /*#__PURE__*/ (0, $loA2J.jsx)($8e568f111cb146a0$export$4607bcc71139ee8e.Provider, {
        value: value,
        children: props.children
    });
};
const $8e568f111cb146a0$export$8e273e37741217be = ()=>{
    const agileArticle = (0, $iSvIT.useContext)($8e568f111cb146a0$export$4607bcc71139ee8e);
    if (!agileArticle) console.warn("SSR failed to fetch content on the server. Fetching content on the client.");
    return agileArticle;
};

});

parcelRegister("eCYM9", function(module, exports) {
$parcel$export(module.exports, "AgileIntroduction", function () { return (parcelRequire("hQj9g")).AgileIntroduction; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("hQj9g")).AgileIntroduction; });

var $hQj9g = parcelRequire("hQj9g");

});
parcelRegister("hQj9g", function(module, exports) {

$parcel$export(module.exports, "AgileIntroduction", function () { return $47e2e782a3f37a0c$export$e27c7ba731ddc3de; });
/* agile-introduction.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6O6jV = parcelRequire("6O6jV");

var $24ahW = parcelRequire("24ahW");

var $kPtGB = parcelRequire("kPtGB");

var $krNyQ = parcelRequire("krNyQ");
const $47e2e782a3f37a0c$var$headingStyle = null;
const $47e2e782a3f37a0c$var$contentWrapperCss = null;
const $47e2e782a3f37a0c$export$e27c7ba731ddc3de = ({ heading: heading, description: description, image: image, embedLink: embedLink, body: body })=>{
    var _image_description;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            heading && /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_1pfhidpf"
                ]),
                children: heading
            }),
            description && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_6rthgktf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                    text: description,
                    name: null
                })
            }),
            embedLink && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_6rthgktf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6O6jV.AgileVideo), {
                    embedLink: embedLink,
                    title: (_image_description = image === null || image === void 0 ? void 0 : image.description) !== null && _image_description !== void 0 ? _image_description : "",
                    thumbnail: image !== null && image !== void 0 ? image : null
                })
            }),
            image && !embedLink && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_6rthgktf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kPtGB.BodyAssetComponent), {
                    asset: image
                })
            }),
            body === null || body === void 0 ? void 0 : body.map((component, idx)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_6rthgktf"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $24ahW.RichContent), (0, $7Knp0._)({}, component))
                }, idx))
        ]
    });
};

});
parcelRegister("6O6jV", function(module, exports) {

$parcel$export(module.exports, "AgileVideo", function () { return $e10046294791441a$export$a01c1a169afc755c; });
/* agile-video.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
const $e10046294791441a$var$PlayIcon = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        className: (0, $esG4f.default)([
            "_lswu12e0 _kqswstnw _1e02idpf _rjxpidpf _152tidpf _u7coidpf _19pk1wug _2hwx1wug _otyr1wug _18u01wug",
            "play-icon"
        ]),
        width: "70px",
        height: "70px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M16,0 C7.163444,-5.41083001e-16 1.082166e-15,7.163444 0,16 C-1.082166e-15,24.836556 7.163444,32 16,32 C24.836556,32 32,24.836556 32,16 C32,11.7565362 30.3142906,7.68687356 27.3137085,4.6862915 C24.3131264,1.68570945 20.2434638,2.5983722e-16 16,0 Z M11.1288889,22.2222222 L11.1288889,9.77777778 L23.6533333,16 L11.1288889,22.2222222 Z"
        })
    });
};
const $e10046294791441a$export$a01c1a169afc755c = (props)=>{
    const { embedLink: embedLink, title: title, thumbnail: thumbnail } = props;
    const [isPlaying, setIsPlaying] = (0, $iSvIT.useState)(false);
    const bgImage = `url("${thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.url}")`;
    const videoOverlayCss = null;
    const iFrameCss = null;
    const videoDataEventProps = {
        "data-product-key": "jiraSoftware",
        "data-event-component": "linkButton",
        "data-event-container": "videoEmbedInline",
        "data-event": "clicked"
    };
    const handleClick = (e)=>{
        e.preventDefault();
        setIsPlaying(true);
    };
    const VideoSection = ()=>{
        const isIFrame = embedLink.includes("iframe");
        if (isIFrame) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: embedLink
            },
            className: (0, $esG4f.default)([
                "_digdyfq0 _11av1ule _1stxbb7n _i01y1osq _91ut1wug _mi22p5ev"
            ])
        });
        else return /*#__PURE__*/ (0, $loA2J.jsx)("iframe", {
            width: "100%",
            height: "auto",
            src: $e10046294791441a$var$addAutoplay(embedLink),
            title: title,
            allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; autoplay;",
            allowFullScreen: true,
            "data-gtm-yt-inspected-12": "true",
            className: (0, $esG4f.default)([
                "_s7n4yfq0 _1e0c1ule _1h1tbb7n _1bsb1osq _4t3i1wug _3y3kp5ev"
            ])
        });
        return null;
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1reo15vq _18m915vq"
        ]),
        children: [
            !isPlaying && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1tke1osq _1bsb1osq _kqswh2mm _19itidpf _80omtlke _1reo15vq _18m915vq _1e0c1txw"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("a", (0, $6iHNw._)((0, $7Knp0._)({
                    className: (0, $esG4f.default)([
                        "_1e0c1ule _1bsb1osq _1tke1osq",
                        "play-trigger"
                    ]),
                    href: embedLink,
                    onClick: handleClick,
                    onKeyDown: ()=>setIsPlaying(true)
                }, videoDataEventProps), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                            src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAABFJREFUKBVjYBgFoyFAhRAAAAJJAAFEkgypAAAAAElFTkSuQmCC",
                            alt: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.name,
                            className: (0, $esG4f.default)([
                                "_p12f1osq _1bsb1osq _4t3i1wug _8hrzaqso _t9ec1h7a _v5648pnm _1itk1n01 _1lrw1dfr _ouxl1ssb _bfhkygj1 _11q31n0t _s7n4yfq0 _irr3u67f _1llw1vf8"
                            ]),
                            style: {
                                "--_um3idz": (0, $43MIc.default)(bgImage)
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)($e10046294791441a$var$PlayIcon, {})
                    ]
                }))
            }),
            isPlaying && /*#__PURE__*/ (0, $loA2J.jsx)(VideoSection, {})
        ]
    });
};
const $e10046294791441a$var$addAutoplay = (url)=>{
    if (url.includes("?")) return `${url}&autoplay=1`;
    else return `${url}?autoplay=1`;
};

});

parcelRegister("24ahW", function(module, exports) {

$parcel$export(module.exports, "RichContent", function () { return $b2b688ce7aa281ec$export$9d332a2389d1bc72; });
// TODO: Move/refactor these components into this "rich-content" space

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $6O6jV = parcelRequire("6O6jV");

var $kPtGB = parcelRequire("kPtGB");

var $krNyQ = parcelRequire("krNyQ");

var $8OgiW = parcelRequire("8OgiW");

var $cGGbE = parcelRequire("cGGbE");

var $1VLtH = parcelRequire("1VLtH");

var $9DAsV = parcelRequire("9DAsV");

var $dOPT4 = parcelRequire("dOPT4");

var $ZQ88u = parcelRequire("ZQ88u");
const $b2b688ce7aa281ec$export$9d332a2389d1bc72 = (data)=>{
    if ((0, $ZQ88u.isTextComponent)(data)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), (0, $7Knp0._)({}, data));
    else if ((0, $ZQ88u.isEmbedComponent)(data)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6O6jV.AgileVideo), {
        embedLink: data.embedded || "",
        title: data.embeddedVideoAssetName || "",
        thumbnail: data.embedAssetOverlay
    });
    else if ((0, $ZQ88u.isProTipText)(data)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cGGbE.ProTipTextComponent), (0, $7Knp0._)({}, data));
    else if ((0, $ZQ88u.isTwitterComponent)(data)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9DAsV.TwitterTextComponent), (0, $7Knp0._)({}, data));
    else if ((0, $ZQ88u.isAssetComponent)(data)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $kPtGB.BodyAssetComponent), (0, $7Knp0._)({}, data));
    else if ((0, $ZQ88u.isCallToAction)(data)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dOPT4.ProductCTA), (0, $7Knp0._)({
        name: ""
    }, data));
    else if ((0, $ZQ88u.isCallOutComponent)(data)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8OgiW.CallOutComponent), (0, $7Knp0._)({}, data));
    else if ((0, $ZQ88u.isQuestionComponent)(data)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1VLtH.QuestionComponent), (0, $7Knp0._)({}, data));
    return null;
};

});
parcelRegister("kPtGB", function(module, exports) {

$parcel$export(module.exports, "BodyAssetComponent", function () { return $574d36e33dd7bf78$export$fdfd397940e11f58; });
/* body-asset.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
parcelRequire("dyrzP");
var $9Kv7x = parcelRequire("9Kv7x");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $574d36e33dd7bf78$export$fdfd397940e11f58 = (data)=>{
    var _data_asset, _data_asset1, _data_asset2, _data_asset3;
    // NOTE: Nested selectors are necessary here to be able to style the dangerouslySetInnerHTML blob
    const bodyAssetCss = null;
    const layout = data.assetRelatedText ? "6-6" : "12";
    const localeCode = (0, $3FBn4.useLocale)();
    const html = (0, $iSvIT.useMemo)(()=>{
        let initialHtml = data.assetRelatedText || ""; // Hacky stuff: Need to wrap tables in a div to make them scrollable
        const tableRegex = /<table[^>]*>[\s\S]*?<\/table>/g;
        const tableMatch = initialHtml.match(tableRegex);
        if (tableMatch) {
            const tableHtml = tableMatch[0];
            const newTableHtml = `<div class="table-wrapper">${tableHtml}</div>`;
            initialHtml = initialHtml.replace(tableHtml, newTableHtml);
        } // Hacky stuff pt2: Need to fix relative localized links
        const relativeLinkRegex = RegExp('(?:\\"https:\\/\\/\\/)(?<urlSlug>.+?)\\"', "g");
        initialHtml = initialHtml.replace(relativeLinkRegex, (_match, _p1, _offset, _string, groups)=>{
            return localeCode === (0, $3FBn4.DEFAULT_LOCALE) ? `"/${groups.urlSlug}"` : `"/${localeCode}/${groups.urlSlug}"`;
        }); // handle case where link is relative and not localized
        const relativeUrlRegex = new RegExp(`href="\\/(${localeCode}\\/)?([^"]*)"`, "g");
        initialHtml = initialHtml.replace(relativeUrlRegex, (_match, _p1, _p2)=>{
            // If the locale code is already present, return the match as is
            if (_p1) return _match; // Otherwise, prepend the locale code to the URL
            return `href="/${localeCode}/${_p2}"`;
        }); // handle case where absolute WAC links are not localized
        const absolutePathRegex = RegExp('\\"https:\\/\\/www\\.atlassian\\.com\\/(?<urlSlug>.+?)\\"', "g");
        initialHtml = initialHtml.replace(absolutePathRegex, (_match, _p1, _offset, _string, groups)=>{
            return localeCode === (0, $3FBn4.DEFAULT_LOCALE) ? `"/${groups.urlSlug}"` : `"/${localeCode}/${groups.urlSlug}"`;
        }); // Hacky stuff pt3: replace &amp;nbsp; with &nbsp;
        initialHtml = initialHtml.replace(/&amp;nbsp;/g, "&nbsp;");
        return initialHtml;
    }, [
        data.assetRelatedText,
        localeCode
    ]);
    var _data_asset_description, _ref;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1n261g80 _rtys1osq _bna71wug _fvk9idpf _6bbsidpf _q7gq19as _zcqxbs82 _1v71idpf _43dsrbzz _59381r31 _yha28stv _1nmznqa1 _5lhmtlke _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
            layout: layout,
            alignItems: "top",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9Kv7x.ContentPlatformImage), {
                        src: (_data_asset = data.asset) === null || _data_asset === void 0 ? void 0 : _data_asset.url,
                        alt: (_ref = (_data_asset_description = (_data_asset1 = data.asset) === null || _data_asset1 === void 0 ? void 0 : _data_asset1.description) !== null && _data_asset_description !== void 0 ? _data_asset_description : (_data_asset2 = data.asset) === null || _data_asset2 === void 0 ? void 0 : _data_asset2.name) !== null && _ref !== void 0 ? _ref : "",
                        baseWidth: 740,
                        contentType: (_data_asset3 = data.asset) === null || _data_asset3 === void 0 ? void 0 : _data_asset3.contentType
                    })
                }),
                data.assetRelatedText && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: html
                    }
                })
            ]
        })
    });
};

});

parcelRegister("krNyQ", function(module, exports) {

$parcel$export(module.exports, "RichTextComponent", function () { return $d64565553e7f2513$export$f7b0c3f1955f2d70; });
/* body-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $3FBn4 = parcelRequire("3FBn4");
// NOTE: Nested selectors are necessary here to be able to style the dangerouslySetInnerHTML blob
const $d64565553e7f2513$var$richTextCss = null;
const $d64565553e7f2513$export$f7b0c3f1955f2d70 = (data)=>{
    const localeCode = (0, $3FBn4.useLocale)();
    const html = (0, $iSvIT.useMemo)(()=>{
        let initialHtml = data.text || ""; // Hacky stuff: Need to wrap tables in a div to make them scrollable
        const tableRegex = /<table[^>]*>[\s\S]*?<\/table>/g;
        const tableMatch = initialHtml.match(tableRegex);
        if (tableMatch) {
            const tableHtml = tableMatch[0];
            const newTableHtml = `<div class="table-wrapper">${tableHtml}</div>`;
            initialHtml = initialHtml.replace(tableHtml, newTableHtml);
        } // Hacky stuff pt2: Need to fix relative localized links
        const relativeLinkRegex = RegExp('(?:\\"https:\\/\\/\\/)(?<urlSlug>.+?)\\"', "g");
        initialHtml = initialHtml.replace(relativeLinkRegex, (_match, _p1, _offset, _string, groups)=>{
            return localeCode === (0, $3FBn4.DEFAULT_LOCALE) ? `"/${groups.urlSlug}"` : `"/${localeCode}/${groups.urlSlug}"`;
        }); // handle case where link is relative and not localized
        const relativeUrlRegex = new RegExp(`href="\\/(${localeCode}\\/)?([^"]*)"`, "g");
        initialHtml = initialHtml.replace(relativeUrlRegex, (_match, _p1, _p2)=>{
            // If the locale code is already present, return the match as is
            if (_p1) return _match; // Otherwise, prepend the locale code to the URL
            return `href="/${localeCode}/${_p2}"`;
        }); // handle case where absolute WAC links are not localized
        const absolutePathRegex = RegExp('\\"https:\\/\\/www\\.atlassian\\.com\\/(?![a-z]{2}\\/)(?<urlSlug>.+?)\\"', "g");
        initialHtml = initialHtml.replace(absolutePathRegex, (_match, _p1, _offset, _string, groups)=>{
            return localeCode === (0, $3FBn4.DEFAULT_LOCALE) ? `"/${groups.urlSlug}"` : `"/${localeCode}/${groups.urlSlug}"`;
        }); // Hacky stuff pt3: replace &amp;nbsp; with &nbsp;
        initialHtml = initialHtml.replace(/&amp;nbsp;/g, "&nbsp;").replace(/&amp;amp;/g, "&amp;");
        return initialHtml;
    }, [
        data.text,
        localeCode
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        dangerouslySetInnerHTML: {
            __html: html
        },
        className: (0, $esG4f.default)([
            "_q7gq1cby _zcqx1rqn _1v71idpf _1lmscfaq _1c56idpf _1s5ridpf _1glg12lh _1d9p1ule _1806idpf _1of3zh62 _1fr8ftgi _1160ftgi _lxprftgi _il49ftgi _xhev1e5h _o6n98xuz _1rm5idpf _1ht62e77 _wqy81e5h _1c2jj1oc _yb6gnqa1 _2b5et94y _p4li7vkz _owip7vkz _6aut7vkz _1pqw7vkz _134q1ule _1mjs1wug _22rsvbgk _1txxidpf _1gc1idpf _43dsrbzz _59381r31 _yha28stv _1nmznqa1 _5lhmtlke _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1 _2yrbagmp _43dz1u0t _5cr0h2mm _1dg11fu0 _1r7587ef _kbnuzwfg _1mcew6e8 _1frx1u0t _81wzyxqu _ui0gdlk8 _u0rjsusb _1ob3yxqu _1pubidpf _120wstnw _16g612gs _1ghd1h6o _1fhp1j6v _ha8hvwuj _14371k8s _1128bs82 _btqhidpf _1tadidpf _1ejb1tcg _1ahqidpf _172k12u0 _y5iq1lzr _olif1nu9 _r5plvwuj _1ipc1k8s _1yqebs82"
        ])
    });
};

});

parcelRegister("8OgiW", function(module, exports) {

$parcel$export(module.exports, "CallOutComponent", function () { return $93eb6c7692a8eb50$export$83ebdc814321a04a; });

var $loA2J = parcelRequire("loA2J");

var $jUNbR = parcelRequire("jUNbR");
const $93eb6c7692a8eb50$export$83ebdc814321a04a = (data)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $jUNbR.InfoText), {
        text: data.callOutText,
        type: "html",
        headingText: data.title
    });

});
parcelRegister("jUNbR", function(module, exports) {

$parcel$export(module.exports, "InfoText", function () { return $649956aec092af99$export$ed2cd9eb2d1973f0; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");
const $649956aec092af99$var$InfoSvg = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36.01",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("title", {
                children: "status-exclaim"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                id: "Layer_2",
                "data-name": "Layer 2",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                    id: "N700",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fill: "#243858",
                        d: "M18,0A18.27,18.27,0,0,0,0,18.32,17.73,17.73,0,0,0,18,36,18.27,18.27,0,0,0,36,17.69,17.73,17.73,0,0,0,18,0ZM17,9A1,1,0,1,1,19,9V20.45a1,1,0,0,1-2.09,0Zm1,19a1.86,1.86,0,1,1,1.86-1.86A1.87,1.87,0,0,1,18,28Z"
                    })
                })
            })
        ]
    });
const $649956aec092af99$export$ed2cd9eb2d1973f0 = (data)=>{
    const iconWrapperCss = null;
    const flexContainerCss = null;
    const textContainerCss = null;
    const eyebrowCss = null;
    const textCss = null;
    const linkCss = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1n261q9c _4cvr1h6o _2lx2vrvc _16jlkb7n _1o9zkb7n _i0dl1wug"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1ule _1bsb1ul9 _4t3i1ul9 _12l21m13 _1sb2b3bt _ouxlidpf _1lrw1f51"
                ]),
                children: !data.hideIcon && /*#__PURE__*/ (0, $loA2J.jsx)($649956aec092af99$var$InfoSvg, {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1ule _1bsb1osq _191w9o2f _ca0qyh40 _u5f3idpf _n3tdyh40 _19bv1ul9"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: (0, $esG4f.default)([
                            "_syazvwuj _1wyb1j6v _vwz41ikt _k48p4jg8 _1p1dangw _6rth19bv _ect41pz4"
                        ]),
                        style: {
                            "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                        },
                        children: data.headingText && data.headingText
                    }),
                    data.type === "html" ? /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        dangerouslySetInnerHTML: {
                            __html: data.text
                        },
                        className: (0, $esG4f.default)([
                            "_1pfh1wug _6rth1wug _syaz1mpp _1wyb19as",
                            "_43dsrbzz _59381r31 _yha28stv _1nmznqa1 _5lhmtlke _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1"
                        ])
                    }) : data.type === "component" ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1pfh1wug _6rth1wug _syaz1mpp _1wyb19as"
                        ]),
                        children: data.children
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_1pfh1wug _6rth1wug _syaz1mpp _1wyb19as"
                        ]),
                        children: data.text
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("cGGbE", function(module, exports) {

$parcel$export(module.exports, "ProTipTextComponent", function () { return $a594bf6eae525e7b$export$1d1201405e1543cb; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $jUNbR = parcelRequire("jUNbR");
const $a594bf6eae525e7b$export$1d1201405e1543cb = (data)=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jUNbR.InfoText), {
        text: data.proTipText,
        headingText: intl.formatMessage({
            id: "agile.overview.protip",
            defaultMessage: "Pro Tip:"
        })
    });
};

});

parcelRegister("1VLtH", function(module, exports) {

$parcel$export(module.exports, "QuestionComponent", function () { return $7f3c97bc6c646d65$export$640700a7579a4d9c; });

var $loA2J = parcelRequire("loA2J");

var $jUNbR = parcelRequire("jUNbR");
const $7f3c97bc6c646d65$export$640700a7579a4d9c = (data)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $jUNbR.InfoText), {
        text: data.answer,
        type: "html",
        headingText: data.questionTitle
    });

});

parcelRegister("9DAsV", function(module, exports) {

$parcel$export(module.exports, "TwitterTextComponent", function () { return $c6f448d1dd384d72$export$f03ace5c63ba1512; });
/* twitter-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $c6f448d1dd384d72$export$f03ace5c63ba1512 = (data)=>{
    const iconWrapperCss = null;
    const flexContainerCss = null;
    const textContainerCss = null;
    const tweetTextCss = null;
    const localizedUrl = data.tweetText ? encodeURI("https://twitter.com/intent/tweet?text=" + data.tweetText) : "";
    var _data_tweetText;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1n261q9c _4cvr1h6o _2lx2vrvc _16jlkb7n _1o9zkb7n _i0dl1wug"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1ule _1bsb1ul9 _4t3i1ul9 _12l2o61n _11q716fq _1sb2b3bt _ouxlidpf _1lrw1f51"
                ])
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1ule _1bsb1osq _191w9o2f _ca0qyh40 _u5f3idpf _n3tdyh40 _19bv1ul9"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                    href: localizedUrl,
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": "panel",
                    "data-product-key": "jiraSoftware",
                    className: (0, $esG4f.default)([
                        "_1pfh1wug _6rth1wug _1wyb1k8s _vwz4cjiy _4bfu1r31 _1hms8stv _ajmmnqa1 _syazrbzz _30l3oelr _9oik1r31 _1bnxglyw _jf4cnqa1"
                    ]),
                    children: (_data_tweetText = data.tweetText) !== null && _data_tweetText !== void 0 ? _data_tweetText : ""
                })
            })
        ]
    });
};

});

parcelRegister("dOPT4", function(module, exports) {

$parcel$export(module.exports, "ProductCTA", function () { return $4f9991e15f92afeb$export$73a34690202fd920; });
/* product-cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $gkV6l = parcelRequire("gkV6l");
parcelRequire("9HFEq");
var $dbhgV = parcelRequire("dbhgV");

var $3FBn4 = parcelRequire("3FBn4");
const $4f9991e15f92afeb$export$73a34690202fd920 = (props)=>{
    var _props_asset, _props_asset1, _props_asset2;
    const { openModalForTemplate: openModalForTemplate } = (0, $gkV6l.useSiteSelectorContext)();
    const openSiteSelectorModal = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        var _props_dataBlueprintModule, _props_name;
        openModalForTemplate({
            templateId: (_props_dataBlueprintModule = props.dataBlueprintModule) !== null && _props_dataBlueprintModule !== void 0 ? _props_dataBlueprintModule : "",
            templateName: (_props_name = props.name) !== null && _props_name !== void 0 ? _props_name : "",
            productKey: props.productName
        });
    };
    var _props_url;
    const ctaUrl = (0, $3FBn4.useLocalizedHref)((_props_url = props.url) !== null && _props_url !== void 0 ? _props_url : "");
    const ctaProps = props.dataBlueprintModule ? {
        buttonProps: {
            text: props.text,
            inputType: "button",
            type: "secondary",
            size: "small",
            onClick: openSiteSelectorModal // No dataEventProps as the SiteSelectorModal handles the analytics
        }
    } : {
        buttonProps: {
            text: props.text,
            type: "secondary",
            size: "small",
            url: ctaUrl,
            dataEventProps: {
                "data-product-key": "jiraSoftware",
                "data-event-component": "linkButton",
                "data-event-container": "siteSelectorModal",
                "data-event": "clicked"
            }
        }
    };
    // FIXME: These nested selectors are hacks to force the Card component to look like a product CTA card
    const productCTACss = null;
    var _props_title, _props_asset_url, _props_asset_description, _ref;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1pfh1tcg _85i5zwfg _1ir41y44 _6bmm14ds _9lfu1lct _15sh13la _fa07zwfg _49p6zwfg _17ihzwfg _ibjezwfg _jhc31hxd _1xqk13la _ym7q1h6o _1you1h6o _liug1fhb _lt831bp4 _18yx1ns9 _135z1ule _1umu1wug _3uw81wug _ge7e1wug _1yr51wug _hcapuuw1 _mezj1wug _64xw1bqd _uyj9gktf _xff7bfng _1of01bqd _p1067vkz _7iyz1nn1 _1jdc2hjt _byzn1osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dbhgV.Card), {
            className: "product-cta-card",
            bodyText: props.valueProposition,
            headerText: (_props_title = props.title) !== null && _props_title !== void 0 ? _props_title : "",
            pictureProps: {
                image: {
                    src: (_props_asset_url = (_props_asset = props.asset) === null || _props_asset === void 0 ? void 0 : _props_asset.url) !== null && _props_asset_url !== void 0 ? _props_asset_url : "",
                    alt: (_ref = (_props_asset_description = (_props_asset1 = props.asset) === null || _props_asset1 === void 0 ? void 0 : _props_asset1.description) !== null && _props_asset_description !== void 0 ? _props_asset_description : (_props_asset2 = props.asset) === null || _props_asset2 === void 0 ? void 0 : _props_asset2.name) !== null && _ref !== void 0 ? _ref : ""
                }
            },
            orientation: "horizontal",
            ctaProps: ctaProps
        })
    });
};

});
parcelRegister("9HFEq", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return (parcelRequire("dbhgV")).Card; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("dbhgV")).Card; });

var $dbhgV = parcelRequire("dbhgV");

});
parcelRegister("dbhgV", function(module, exports) {

$parcel$export(module.exports, "Card", function () { return $1d73d5771cc6d344$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");
const $1d73d5771cc6d344$var$containerStyles = null;
const $1d73d5771cc6d344$var$contentBlockStyles = null;
const $1d73d5771cc6d344$var$barStyles = null; /**
                         * @deprecated - Please use @/libraries/design/components/card instead
                         */ 
const $1d73d5771cc6d344$export$60332b2344f7fe41 = (props)=>{
    const { textColor: textColor, headerType: headerType, headerText: headerText, bodyText: bodyText, eyebrowText: eyebrowText, footerHeader: footerHeader, footerText: footerText, imageLink: imageLink, imageAltText: imageAltText, backgroundColor: backgroundColor, colorBars: colorBars, iconName: iconName, iconColor: iconColor, iconSize: iconSize, barColor: barColor = "", className: className, ctaProps: ctaProps, aspectRatio: aspectRatio, orientation: orientation, pictureProps: pictureProps, clickableCardUrl: clickableCardUrl } = props;
    if (imageLink && !imageAltText) throw new Error("If using an image, please provide an alt text for accessibility purposes!");
    const cardBackBackgroundColor = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "#ffffff";
    const cardBackTextColor = textColor !== null && textColor !== void 0 ? textColor : "#091e42";
    const cardBackColor = null;
    const contentBlockIconColor = iconColor !== null && iconColor !== void 0 ? iconColor : "#091e42";
    const handleClick = ()=>{
        if (clickableCardUrl) window.location.href = clickableCardUrl;
    };
    const clickableCardStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_2rkoyh40 _16qs1nta _1e0c1txw _2lx21bp4 _p12fg505 _7cca15wb _4t3i1osq",
            "_bfhk16d1 _syazn54i",
            "_80om1wzl",
            className
        ]),
        onClick: handleClick,
        style: {
            "--_1vkwvj7": (0, $43MIc.default)(cardBackBackgroundColor),
            "--_1dl5pj2": (0, $43MIc.default)(cardBackTextColor),
            "--_8vvi5m": (0, $43MIc.default)(clickableCardUrl ? "pointer" : "default")
        },
        children: [
            colorBars == "top" || colorBars == "both" ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderTopRightRadius: "4px",
                    borderTopLeftRadius: "4px"
                },
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : "",
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                cardStyle: true,
                aspectRatio: aspectRatio,
                orientation: orientation,
                headerType: headerType,
                headerText: headerText,
                bodyText: bodyText,
                imageLink: imageLink,
                imageAltText: imageAltText,
                eyebrowText: eyebrowText,
                footerHeader: footerHeader,
                footerText: footerText,
                iconColor: contentBlockIconColor,
                iconName: iconName,
                iconSize: iconSize,
                ctaProps: ctaProps,
                pictureProps: pictureProps,
                className: (0, $esG4f.default)([
                    "_4t3i1osq"
                ])
            }),
            colorBars == "bottom" || colorBars == "both" ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderBottomRightRadius: "4px",
                    borderBottomLeftRadius: "4px"
                },
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : ""
        ]
    });
};

});
parcelRegister("ix9oc", function(module, exports) {
$parcel$export(module.exports, "ContentBlock", function () { return (parcelRequire("3hz64")).ContentBlock; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("3hz64")).ContentBlock; });

var $3hz64 = parcelRequire("3hz64");

});
parcelRegister("3hz64", function(module, exports) {

$parcel$export(module.exports, "ContentBlock", function () { return $d1a7b02864c21377$export$eb38b3b9c7f5f31b; });
/* content-block.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $8xSOc = parcelRequire("8xSOc");

var $91nJf = parcelRequire("91nJf");

var $A9zZc = parcelRequire("A9zZc");

var $Erp3T = parcelRequire("Erp3T");
parcelRequire("f0Hih");
var $dhmEV = parcelRequire("dhmEV");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");

var $bQawl = parcelRequire("bQawl");

var $bhreu = parcelRequire("bhreu");
function $d1a7b02864c21377$var$getHeaderTag(text, header, lozenge, lozengeAppearance) {
    const headerTag = header ? header : "h3";
    const headerText = /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            text,
            lozenge && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_ahbqftgi _1e0c1o8l"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c116y _s7n4nkob"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                        appearance: lozengeAppearance,
                        children: lozenge
                    })
                })
            })
        ]
    });
    const style = lozenge ? {
        style: {
            display: "inline-block"
        }
    } : null;
    return /*#__PURE__*/ (0, $iSvIT.createElement)(headerTag, style, headerText);
} /* Gives p tag  so that page structure follows HTML semantic ordering */ 
function $d1a7b02864c21377$var$getEyebrowTag(// @ts-ignore
headerType, eyebrowText) {
    return /*#__PURE__*/ (0, $iSvIT.createElement)(`p`, {
        className: "contentBlock-eyebrow"
    }, eyebrowText);
}
function $d1a7b02864c21377$var$renderLinks({ ctaProps: ctaProps, product: product, edition: edition }) {
    if (!ctaProps) return null;
    let firstLink;
    if ("buttonProps" in ctaProps && "text" in ctaProps.buttonProps) firstLink = /*#__PURE__*/ (0, $loA2J.jsx)((0, $bQawl.Button), (0, $7Knp0._)({}, ctaProps.buttonProps));
    else if ("buttonProps" in ctaProps && "variant" in ctaProps.buttonProps) firstLink = /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), (0, $7Knp0._)({}, ctaProps.buttonProps));
    else if ("primaryLinkProps" in ctaProps && ctaProps.primaryLinkProps) firstLink = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), (0, $7Knp0._)({}, ctaProps.primaryLinkProps));
    const secondaryLink = "secondaryLinkProps" in ctaProps ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), (0, $7Knp0._)({}, ctaProps.secondaryLinkProps)) : null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dhmEV.default), {
        intentType: "button",
        containerId: "ctaSection",
        edition: edition,
        productKey: product === null || product === void 0 ? void 0 : product.key,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: "contentBlock-linkFlex",
            children: [
                firstLink,
                secondaryLink
            ]
        })
    });
} /**
   * This method retrieves either the eyebrow or icon decoration. If both are present, the icon is returned.
   * @param headerType
   */ 
const $d1a7b02864c21377$var$getDecoration = (headerType, eyebrowText, iconName, iconColor, iconSize)=>{
    if (iconName) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Icon), {
        name: iconName,
        color: iconColor,
        size: iconSize
    });
    else if (eyebrowText) return $d1a7b02864c21377$var$getEyebrowTag(headerType, eyebrowText);
    return null;
};
const $d1a7b02864c21377$var$getImage = (pictureProps, imageLink, imageAltText, aspectRatio)=>{
    if (pictureProps) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: "img-section",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), (0, $7Knp0._)({}, pictureProps))
    });
    else if (imageLink && imageAltText) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: "img-section",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
            src: imageLink,
            alt: imageAltText,
            aspectRatio: aspectRatio
        })
    });
    else return null;
};
const $d1a7b02864c21377$var$isHtml = (text)=>{
    return text.startsWith("<") && text.endsWith(">") && text.includes("</");
}; /**
    * @deprecated - Please use @/libraries/design/components/content-block instead
    */ 
const $d1a7b02864c21377$export$eb38b3b9c7f5f31b = ({ headerText: headerText, isBannerRichText: isBannerRichText = false, lozenge: lozenge, lozengeAppearance: lozengeAppearance = "inprogress", bodyText: bodyText, bodyComponent: bodyComponent, headerType: headerType = "h3", eyebrowText: eyebrowText, className: className = "", imageLink: imageLink, imageAltText: imageAltText, pictureProps: pictureProps, iconName: iconName, iconColor: iconColor, iconSize: iconSize, ctaProps: ctaProps, aspectRatio: aspectRatio = "1/1", orientation: orientation, cardStyle: cardStyle, isCentered: isCentered = false, horizontalRule: horizontalRule })=>{
    const { product: product, edition: edition } = (0, $Erp3T.useProductIntent)();
    if (imageLink && !imageAltText) throw new Error("If using an image, please provide an alt text for accessibility purposes!");
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            isBannerRichText && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && isCentered && orientation === "horizontal" && cardStyle && headerType === "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _a5ip1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && isCentered && orientation === "horizontal" && !cardStyle && headerType === "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _a5ip1osq _1ma11kwk _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation === "horizontal" && cardStyle && headerType === "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation === "horizontal" && !cardStyle && headerType === "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && isCentered && orientation === "horizontal" && cardStyle && headerType !== "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && isCentered && orientation === "horizontal" && !cardStyle && headerType !== "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _a5ip1osq _1ma11kwk _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation === "horizontal" && cardStyle && headerType !== "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation === "horizontal" && !cardStyle && headerType !== "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && isCentered && orientation !== "horizontal" && cardStyle && headerType === "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && isCentered && orientation !== "horizontal" && !cardStyle && headerType !== "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation !== "horizontal" && cardStyle && headerType === "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation !== "horizontal" && !cardStyle && headerType === "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && isCentered && orientation !== "horizontal" && cardStyle && headerType !== "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation !== "horizontal" && cardStyle && headerType !== "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation !== "horizontal" && !cardStyle && headerType !== "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            `content-block ${className}`
        ]),
        style: {
            "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
        },
        children: [
            $d1a7b02864c21377$var$getImage(pictureProps, imageLink, imageAltText, aspectRatio),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: "text-section",
                children: [
                    headerText && $d1a7b02864c21377$var$getHeaderTag(headerText, headerType, lozenge, lozengeAppearance),
                    $d1a7b02864c21377$var$getDecoration(headerType, eyebrowText, iconName, iconColor, iconSize),
                    horizontalRule && /*#__PURE__*/ (0, $loA2J.jsx)("hr", {
                        className: (0, $esG4f.default)([
                            "_4t3iyh40 _p12f1fra"
                        ])
                    }),
                    bodyText ? typeof bodyText === "string" && $d1a7b02864c21377$var$isHtml(bodyText) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $A9zZc.SanitizedRichText), {
                        innerHTML: bodyText
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: "contentBlock-body",
                        children: bodyText
                    }) : null,
                    !bodyText && bodyComponent && /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: "contentBlock-body",
                        children: bodyComponent
                    }),
                    $d1a7b02864c21377$var$renderLinks({
                        ctaProps: ctaProps,
                        product: product,
                        edition: edition
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("f0Hih", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("dhmEV")).default; });

var $dhmEV = parcelRequire("dhmEV");

});






parcelRegister("ZQ88u", function(module, exports) {

$parcel$export(module.exports, "isTextComponent", function () { return $b38aef75a4439eb4$export$4bf69398599dba31; });
$parcel$export(module.exports, "isAssetComponent", function () { return $b38aef75a4439eb4$export$61be03ff0b6c6c6e; });
$parcel$export(module.exports, "isEmbedComponent", function () { return $b38aef75a4439eb4$export$9846e8db24db36f4; });
$parcel$export(module.exports, "isProTipText", function () { return $b38aef75a4439eb4$export$cfaa1a75f40e26f5; });
$parcel$export(module.exports, "isTwitterComponent", function () { return $b38aef75a4439eb4$export$99fa2f2e7e0ad570; });
$parcel$export(module.exports, "isCallToAction", function () { return $b38aef75a4439eb4$export$ab20f6e6e266a5a6; });
$parcel$export(module.exports, "isQuestionComponent", function () { return $b38aef75a4439eb4$export$9c5fde415fc473c8; });
$parcel$export(module.exports, "isCallOutComponent", function () { return $b38aef75a4439eb4$export$a58e7eebbfe3c431; });
const $b38aef75a4439eb4$export$4bf69398599dba31 = (component)=>{
    return component.__typename === "ContentPlatformTextComponent" || component.__typename === "TextComponent";
};
const $b38aef75a4439eb4$export$61be03ff0b6c6c6e = (component)=>{
    return component.__typename === "ContentPlatformAssetComponent" || component.__typename === "AssetComponent";
};
const $b38aef75a4439eb4$export$9846e8db24db36f4 = (component)=>{
    return component.__typename === "ContentPlatformEmbeddedVideoAsset" || component.__typename === "EmbeddedVideoAsset";
};
const $b38aef75a4439eb4$export$cfaa1a75f40e26f5 = (component)=>{
    return component.__typename === "ContentPlatformProTipComponent" || component.__typename === "ProTipComponent";
};
const $b38aef75a4439eb4$export$99fa2f2e7e0ad570 = (component)=>{
    return component.__typename === "ContentPlatformTwitterComponent" || component.__typename === "TwitterComponent";
};
const $b38aef75a4439eb4$export$ab20f6e6e266a5a6 = (component)=>{
    return component.__typename === "ContentPlatformCallToAction" || component.__typename === "CallToAction";
};
const $b38aef75a4439eb4$export$9c5fde415fc473c8 = (component)=>{
    return component.__typename === "ContentPlatformQuestionComponent" || component.__typename === "QuestionComponent";
};
const $b38aef75a4439eb4$export$a58e7eebbfe3c431 = (component)=>{
    return component.__typename === "ContentPlatformCallOutComponent" || component.__typename === "CallOutComponent";
};

});




parcelRegister("d8QZt", function(module, exports) {

$parcel$export(module.exports, "AgileAuthor", function () { return $f7abd47c290fd088$export$44bdcccc1a3ea89c; });
/* agile-author.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $9Kv7x = parcelRequire("9Kv7x");

var $5ohHq = parcelRequire("5ohHq");
const $f7abd47c290fd088$export$44bdcccc1a3ea89c = ({ name: name, biography: biography, pictureSrc: pictureSrc, contentType: contentType })=>{
    if (!name || !biography || !pictureSrc) return null;
    const pictureProps = {
        src: pictureSrc,
        alt: name,
        baseWidth: 100,
        contentType: contentType
    };
    const containerCss = null;
    const nameCss = null;
    const biographyCss = null;
    const pictureCss = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _mqm21i89 _1pfh10yn _1q5110yn _1gde1bp4 _navj1q9c _ag851h6o _v736idpf _xsmr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_i0dl12xx _1o9zidpf _1bsb53f4 _4t3i53f4 _6rth7vkz _s7n41q9y"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9Kv7x.ContentPlatformImage), (0, $6iHNw._)((0, $7Knp0._)({}, pictureProps), {
                    className: (0, $esG4f.default)([
                        "_p12f1osq"
                    ])
                }))
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_bozggktf _s7n41q9y _v736idpf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: (0, $esG4f.default)([
                            "_1wyb1j6v _85i519bv _1p1dangw _syaz1mpp"
                        ]),
                        children: name
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_ect4bzd7 _1wyb15s1 _syaz1mpp _vwz4bs82 _1pfhidpf _6rth1tcg _y3gn1e5h"
                        ]),
                        style: {
                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                        },
                        children: biography
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("aUZ56", function(module, exports) {

$parcel$export(module.exports, "BodyTextContainer", function () { return $c70a78a7f6a839e7$export$4c2d02ebf4a10152; });
/* body-text-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $24ahW = parcelRequire("24ahW");
/**
 * Styles
 */ const $c70a78a7f6a839e7$var$headerCss = null;
const $c70a78a7f6a839e7$var$contentComponentWrapperCss = null; /**
                                          * Render content component based on type
                                          */ 
const $c70a78a7f6a839e7$export$4c2d02ebf4a10152 = (props)=>{
    const { name: name, contentComponents: contentComponents } = props;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rthdlk8"
                ]),
                children: name
            }),
            contentComponents && contentComponents.map((component, idx)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_6rthgktf"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $24ahW.RichContent), (0, $7Knp0._)({}, component))
                }, idx))
        ]
    }, name);
};

});

parcelRegister("7unTD", function(module, exports) {

$parcel$export(module.exports, "NavigationCard", function () { return $0ac1f3d1426fa7a2$export$1ea67d5e048e23b7; });
$parcel$export(module.exports, "useCardProps", function () { return $0ac1f3d1426fa7a2$export$397757db538349a2; });
$parcel$export(module.exports, "NavigationCards", function () { return $0ac1f3d1426fa7a2$export$b46258c722788b51; });
/* navigation-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("9HFEq");
var $dbhgV = parcelRequire("dbhgV");

var $lHB9W = parcelRequire("lHB9W");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $0ac1f3d1426fa7a2$export$1ea67d5e048e23b7 = (props)=>{
    const { eyebrowText: eyebrowText, headerText: headerText, bodyText: bodyText, ctaText: ctaText, ctaHref: ctaHref, image: image, showLink: showLink } = props;
    const pictureProps = image ? {
        image: {
            src: image.url,
            alt: image.description ? image.name : ""
        }
    } : undefined;
    const ctaProps = ctaText && ctaHref ? {
        primaryLinkProps: {
            text: ctaText,
            href: ctaHref,
            // Localized from CPAPI?
            type: "primary",
            dataEventProps: {
                "data-event": "clicked",
                "data-event-component": "linkButton",
                "data-product-key": "jiraSoftware",
                "data-event-container": "agileCardLink"
            }
        }
    } : undefined;
    const localizedCtaHref = (0, $3FBn4.useLocalizedHref)(ctaHref !== null && ctaHref !== void 0 ? ctaHref : "");
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _4t3i1osq _2rko1y44 _1m541cgf _2ebcglyw _gyir54rc _10gg14ds _80gp1cdp _3tur1osq _2mj61hna _9q85kb7n _1a7z1j6v _1wu5bs82 _17plb3bt _qkj51ule _17bx1hdd _1tegsxj9 _4bkb1ylp _1qv9grf3",
            !showLink && "_1knyglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dbhgV.Card), {
                className: "navigation-card",
                headerText: headerText || "",
                bodyText: bodyText,
                eyebrowText: eyebrowText || "",
                orientation: "vertical",
                pictureProps: pictureProps,
                ctaProps: ctaProps
            }),
            ctaHref && /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                href: localizedCtaHref,
                "aria-label": headerText || "",
                "data-event": "clicked",
                "data-event-component": "linkButton",
                "data-product-key": "jiraSoftware",
                "data-event-container": "agileCardLink",
                className: (0, $esG4f.default)([
                    "_kqswstnw _1e02idpf _rjxpidpf _152tidpf _u7coidpf"
                ])
            })
        ]
    });
};
const $0ac1f3d1426fa7a2$var$isTutorial = (data)=>{
    return data.__typename === "ContentPlatformTutorial" || data.__typename === "Tutorial";
};
const $0ac1f3d1426fa7a2$var$isHubArticle = (data)=>{
    return data.__typename === "ContentPlatformHubArticle" || data.__typename === "MicrositeArticle";
};
const $0ac1f3d1426fa7a2$var$isProductFeature = (data)=>{
    return data.__typename === "ContentPlatformProductFeature" || data.__typename === "ProductFeature";
};
const $0ac1f3d1426fa7a2$var$isFeaturedVideo = (data)=>{
    return data.__typename === "ContentPlatformFeaturedVideo" || data.__typename === "FeaturedVideo";
};
const $0ac1f3d1426fa7a2$export$397757db538349a2 = (data, showLink)=>{
    const intl = (0, $f6qj2.default)();
    const tutorialEyeBrowText = intl.formatMessage({
        id: "agile.overview.navigation-cards.tutorial-eyebrow",
        defaultMessage: "Tutorial"
    });
    const tutorialCtaText = intl.formatMessage({
        id: "agile.overview.navigation-cards.tutorial-cta",
        defaultMessage: "Try this tutorial"
    });
    const articleEyeBrowText = intl.formatMessage({
        id: "agile.overview.navigation-cards.article-eyebrow",
        defaultMessage: "Article"
    });
    const articleCtaText = intl.formatMessage({
        id: "agile.overview.navigation-cards.article-cta",
        defaultMessage: "Read this article"
    });
    const productFeatureEyeBrowText = intl.formatMessage({
        id: "agile.overview.navigation-cards.product-feature-eyebrow",
        defaultMessage: "Product Feature"
    });
    const featuredVideoEyeBrowText = intl.formatMessage({
        id: "agile.overview.navigation-cards.featured-video-eyebrow",
        defaultMessage: "Video"
    });
    const buildCardProps = (0, $iSvIT.useCallback)(// eslint-disable-next-line complexity
    (cards, data)=>{
        var _data_callToAction_, _data_callToAction, _data_callToAction_1, _data_callToAction1;
        if ($0ac1f3d1426fa7a2$var$isTutorial(data)) cards.push({
            eyebrowText: tutorialEyeBrowText,
            headerText: data.name,
            bodyText: data.description,
            ctaText: tutorialCtaText,
            ctaHref: data.urlSlug,
            image: data.tutorialBanner || undefined,
            showLink: showLink !== null && showLink !== void 0 ? showLink : true
        });
        else if ($0ac1f3d1426fa7a2$var$isHubArticle(data)) cards.push({
            eyebrowText: articleEyeBrowText,
            headerText: data.articleName,
            bodyText: data.description,
            ctaText: articleCtaText,
            ctaHref: data.urlSlug,
            image: (data === null || data === void 0 ? void 0 : data.articleBanner) || undefined,
            showLink: showLink !== null && showLink !== void 0 ? showLink : false
        });
        else if ($0ac1f3d1426fa7a2$var$isProductFeature(data)) cards.push({
            eyebrowText: productFeatureEyeBrowText,
            headerText: data.name,
            bodyText: data.description,
            ctaText: (_data_callToAction = data.callToAction) === null || _data_callToAction === void 0 ? void 0 : (_data_callToAction_ = _data_callToAction[0]) === null || _data_callToAction_ === void 0 ? void 0 : _data_callToAction_.text,
            ctaHref: (_data_callToAction1 = data.callToAction) === null || _data_callToAction1 === void 0 ? void 0 : (_data_callToAction_1 = _data_callToAction1[0]) === null || _data_callToAction_1 === void 0 ? void 0 : _data_callToAction_1.url,
            image: undefined,
            showLink: showLink !== null && showLink !== void 0 ? showLink : true
        });
        else if ($0ac1f3d1426fa7a2$var$isFeaturedVideo(data)) cards.push({
            eyebrowText: featuredVideoEyeBrowText,
            headerText: data.videoName,
            bodyText: data.description,
            ctaText: data.callToActionText,
            ctaHref: data.link,
            image: undefined,
            showLink: showLink !== null && showLink !== void 0 ? showLink : true
        });
        else console.error("Unknown next best action type", data);
        return cards;
    }, [
        tutorialEyeBrowText,
        tutorialCtaText,
        articleEyeBrowText,
        articleCtaText,
        productFeatureEyeBrowText,
        featuredVideoEyeBrowText,
        showLink
    ]);
    return (0, $iSvIT.useMemo)(()=>data.reduce(buildCardProps, []), [
        buildCardProps,
        data
    ]);
};
const $0ac1f3d1426fa7a2$export$b46258c722788b51 = (props)=>{
    var _cardsProps_slice;
    const cardsProps = $0ac1f3d1426fa7a2$export$397757db538349a2((0, $lHB9W.expectContent)(props.cardsData, "Next best action not found"), true);
    const navigationCardCss = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_85i5ys9h _1q511wqb _1t4u1dfr _124xymf6 _php015vq _tgvo15vq _1d8u1j8p _1qeivwuj _1qef1crf _1adhl8b6 _bsma1tcg _crcvangw _15jft94y _q2dt3aqo _qliy1bqd"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
            layout: "6-6",
            alignItems: "center",
            children: [
                (_cardsProps_slice = cardsProps.slice(0, 2)) === null || _cardsProps_slice === void 0 ? void 0 : _cardsProps_slice.map((props, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)($0ac1f3d1426fa7a2$export$1ea67d5e048e23b7, (0, $7Knp0._)({}, props))
                    }, index)),
                cardsProps.length === 1 && /*#__PURE__*/ (0, $loA2J.jsx)("div", {})
            ]
        })
    });
};

});

parcelRegister("3Wymx", function(module, exports) {

$parcel$export(module.exports, "ShareUpNextBar", function () { return $bf1dc22a909bda9b$export$c7e03914d4cb5822; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("4nUAn");
var $gUpxA = parcelRequire("gUpxA");

var $3FBn4 = parcelRequire("3FBn4");
parcelRequire("8jm44");
var $5Z6Lb = parcelRequire("5Z6Lb");

var $lrVTP = parcelRequire("lrVTP");
function $bf1dc22a909bda9b$var$useAgileShareUpNextProps(pageTree, title, description) {
    const intl = (0, $f6qj2.default)();
    const location = (0, $lrVTP.useLocation)();
    const origin = "https://www.atlassian.com";
    const link = `${origin}${location.pathname}`;
    const defaultNextUrlSlug = (0, $3FBn4.useLocalizedHref)("/agile");
    const defaultNextName = intl.formatMessage({
        id: "Agile.main.default-next-page-title",
        defaultMessage: "Agile"
    });
    return (0, $iSvIT.useMemo)(()=>({
            title: title,
            description: description,
            link: link,
            defaultNextPage: {
                name: defaultNextName,
                urlSlug: defaultNextUrlSlug
            },
            pageTree: pageTree
        }), [
        title,
        description,
        link,
        pageTree,
        defaultNextName,
        defaultNextUrlSlug
    ]);
}
const $bf1dc22a909bda9b$export$c7e03914d4cb5822 = ({ nodes: nodes, title: title, description: description })=>{
    const agileShareUpNextProps = $bf1dc22a909bda9b$var$useAgileShareUpNextProps(nodes, title, description);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $gUpxA.ScrollUpBar), {
        sticky: true,
        anchor: "bottom",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5Z6Lb.AgileShareUpNext), (0, $7Knp0._)({}, agileShareUpNextProps))
    });
};

});
parcelRegister("4nUAn", function(module, exports) {
$parcel$export(module.exports, "ScrollUpBar", function () { return (parcelRequire("gUpxA")).ScrollUpBar; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("gUpxA")).ScrollUpBar; });

var $gUpxA = parcelRequire("gUpxA");

});
parcelRegister("gUpxA", function(module, exports) {

$parcel$export(module.exports, "ScrollUpBar", function () { return $9a48e9bffad5dc6b$export$da8a398acf5e0aa8; });
/* scroll-up-bar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $eDoPe = parcelRequire("eDoPe");

var $bPjPt = parcelRequire("bPjPt");
const $9a48e9bffad5dc6b$var$TOP = "top";
const $9a48e9bffad5dc6b$var$BOTTOM = "bottom";
const $9a48e9bffad5dc6b$var$ScrollUpBarStyleMap = {
    base: "_v564x7w3 _t9ec1kli _kqsw1n9t",
    sticky: "_kqsw1if8",
    top: "_1r0417zq",
    bottom: "_1r041cj7",
    stuck: "_v5641ag2"
};
const $9a48e9bffad5dc6b$var$ScrollUpBarHiddenStyleMap = {
    top: "_t9ecz6y5",
    bottom: "_t9ec3k1b"
};
const $9a48e9bffad5dc6b$var$ScrollUpBarBackgroundStyleMap = {
    base: "_bfhku67f _aetrb3bt _18postnw _11fnglyw _9v7aidpf _1peqidpf _qc5ogcyp",
    top: "_11fnglyw _8x3udtpc",
    bottom: "_11fnglyw _8x3u4uke",
    stuck: "_1peqkb7n _11fnglyw _qc5o1pz1"
}; /**
    * `ScrollUpBar` allows for an overlay of content to be displayed
    * when the user scrolls up, and hidden when the user scrolls down.
    */ 
const $9a48e9bffad5dc6b$export$da8a398acf5e0aa8 = ({ children: children, sticky: sticky, anchor: anchor = $9a48e9bffad5dc6b$var$BOTTOM })=>{
    const [scrollRef, direction] = (0, $bPjPt.useVerticalScrollDirection)();
    const [topRef, topInView, topEntry] = (0, $eDoPe.useInView)();
    const [bottomRef, bottomInView, bottomEntry] = (0, $eDoPe.useInView)(); // The `ScrollUpBar` is  always 'stuck' (aka fixed) by default.
    let stuck = true;
    if (sticky) // If the `ScrollUpBar` is sticky, it should only be 'stuck'
    // if it is not in view. Two sentinel elements are observed
    // (using `IntersectionObserver`) to determine if the `ScrollUpBar`
    // is in view. If the intersection observers haven't
    // initialized yet, default to assuming the bar is in view,
    // so that any 'stuck' state is not applied too eagerly.
    stuck = !(topInView || topEntry == null || bottomInView || bottomEntry == null);
     // The `ScrollUpBar` should only be hidden if it is stuck
    // and the user is scrolling down.
    const hidden = stuck && direction == "down";
    const containerStyle = [
        $9a48e9bffad5dc6b$var$ScrollUpBarStyleMap.base,
        $9a48e9bffad5dc6b$var$ScrollUpBarStyleMap[anchor],
        sticky && $9a48e9bffad5dc6b$var$ScrollUpBarStyleMap.sticky,
        stuck && $9a48e9bffad5dc6b$var$ScrollUpBarStyleMap.stuck,
        hidden && $9a48e9bffad5dc6b$var$ScrollUpBarHiddenStyleMap[anchor]
    ];
    const bgStyle = [
        $9a48e9bffad5dc6b$var$ScrollUpBarBackgroundStyleMap.base,
        $9a48e9bffad5dc6b$var$ScrollUpBarBackgroundStyleMap[anchor],
        stuck && $9a48e9bffad5dc6b$var$ScrollUpBarBackgroundStyleMap.stuck
    ];
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            sticky ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                ref: topRef,
                "aria-hidden": "true",
                style: {
                    pointerEvents: "none",
                    visibility: "hidden"
                }
            }) : null,
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                ref: scrollRef,
                className: (0, $esG4f.default)([
                    $9a48e9bffad5dc6b$var$ScrollUpBarStyleMap.base,
                    $9a48e9bffad5dc6b$var$ScrollUpBarStyleMap[anchor],
                    sticky && $9a48e9bffad5dc6b$var$ScrollUpBarStyleMap.sticky,
                    stuck && $9a48e9bffad5dc6b$var$ScrollUpBarStyleMap.stuck,
                    hidden && $9a48e9bffad5dc6b$var$ScrollUpBarHiddenStyleMap[anchor]
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            $9a48e9bffad5dc6b$var$ScrollUpBarBackgroundStyleMap.base,
                            $9a48e9bffad5dc6b$var$ScrollUpBarBackgroundStyleMap[anchor],
                            stuck && $9a48e9bffad5dc6b$var$ScrollUpBarBackgroundStyleMap.stuck
                        ])
                    }),
                    children
                ]
            }),
            sticky ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                ref: bottomRef,
                "aria-hidden": "true",
                style: {
                    pointerEvents: "none",
                    visibility: "hidden"
                }
            }) : null
        ]
    });
};

});
parcelRegister("bPjPt", function(module, exports) {

$parcel$export(module.exports, "useVerticalScrollDirection", function () { return $993f4974cff45598$export$17c00a9141dd0ac6; });

var $iSvIT = parcelRequire("iSvIT");

var $5KXGt = parcelRequire("5KXGt");
function $993f4974cff45598$var$getScrollTop(node) {
    var _node_documentElement;
    var _node_documentElement_scrollTop, _ref;
    return (_ref = (_node_documentElement_scrollTop = node === null || node === void 0 ? void 0 : (_node_documentElement = node.documentElement) === null || _node_documentElement === void 0 ? void 0 : _node_documentElement.scrollTop) !== null && _node_documentElement_scrollTop !== void 0 ? _node_documentElement_scrollTop : node === null || node === void 0 ? void 0 : node.scrollTop) !== null && _ref !== void 0 ? _ref : 0;
}
function $993f4974cff45598$export$17c00a9141dd0ac6() {
    const scrollTop = (0, $iSvIT.useRef)(0);
    const [direction, setDirection] = (0, $iSvIT.useState)(null);
    const ref = (0, $iSvIT.useCallback)((node)=>{
        if (!node) return;
        var _getNearestScrollNode;
        const scrollNode = (_getNearestScrollNode = (0, $5KXGt.getNearestScrollNode)(node)) !== null && _getNearestScrollNode !== void 0 ? _getNearestScrollNode : (0, $5KXGt.getWindow)(node);
        scrollNode === null || scrollNode === void 0 ? void 0 : scrollNode.addEventListener("scroll", (event)=>{
            const nextScrollTop = $993f4974cff45598$var$getScrollTop(event.target);
            const dir = nextScrollTop < scrollTop.current ? "up" : "down";
            scrollTop.current = nextScrollTop;
            setDirection(dir);
        });
    }, []);
    return [
        ref,
        direction
    ];
}

});



parcelRegister("8jm44", function(module, exports) {
$parcel$export(module.exports, "AgileShareUpNext", function () { return (parcelRequire("5Z6Lb")).AgileShareUpNext; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("5Z6Lb")).AgileShareUpNext; });

var $5Z6Lb = parcelRequire("5Z6Lb");

});
parcelRegister("5Z6Lb", function(module, exports) {

$parcel$export(module.exports, "AgileShareUpNext", function () { return $513c926e320beed6$export$e5a57032b3ca2653; });
/* share-up-next.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $aFJtg = parcelRequire("aFJtg");

var $gTuW6 = parcelRequire("gTuW6");

var $ixUnw = parcelRequire("ixUnw");
const $513c926e320beed6$var$AgileShareUpNextContainerStyle = null;
const $513c926e320beed6$var$ColumnStyles = null;
const $513c926e320beed6$export$e5a57032b3ca2653 = ({ defaultNextPage: defaultNextPage, pageTree: pageTree, description: description, link: link, title: title, source: source })=>{
    const nextPage = (0, $ixUnw.useNextPage)(defaultNextPage, pageTree);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _bfhku67f _1tke1n2x _1n261g80 _s7n41q9y"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bsb1ssb _2lx21bp4 _1aax1e5h _ca0qidpf _u5f3gktf _n3tdidpf _19bvgktf _kqswh2mm _19pk1wug _2hwx1wug _otyr1wug _18u01wug"
                ]),
                children: description && link && title && /*#__PURE__*/ (0, $loA2J.jsx)((0, $aFJtg.SocialShareMenu), {
                    description: description,
                    link: link,
                    title: title,
                    source: source
                }) || /*#__PURE__*/ (0, $loA2J.jsx)("span", {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bsb1ssb _2lx21bp4 _1aax1e5h _ca0qidpf _u5f3gktf _n3tdidpf _19bvgktf _kqswh2mm _19pk1wug _2hwx1wug _otyr1wug _18u01wug"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gTuW6.AgileUpNextLink), (0, $7Knp0._)({}, nextPage))
            })
        ]
    });
};

});
parcelRegister("aFJtg", function(module, exports) {

$parcel$export(module.exports, "SocialShareMenu", function () { return $cf99e867aee0593b$export$22d14db7e0bd3bb5; });
/* social-share-menu.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");
const $cf99e867aee0593b$var$SocialShareButtonStyle = {
    base: "_1e0c1o8l _1bsb1u1b _4t3i1u1b _1reo15vq _18m915vq",
    facebook: "_11q7621r",
    twitter: "_11q788zb",
    linkedin: "_11q71e9h"
};
const $cf99e867aee0593b$var$SocialShareButtonActions = {
    facebook: {
        action: "https://www.facebook.com/dialog/feed",
        params: (props)=>({
                app_id: "743864389089816",
                caption: props.title,
                link: props.link,
                description: props.description,
                picture: "",
                name: props.title
            })
    },
    twitter: {
        action: "https://twitter.com/share",
        params: (props)=>({
                text: props.description,
                url: props.link,
                via: props.source
            })
    },
    linkedin: {
        action: "https://www.linkedin.com/shareArticle",
        params: (props)=>({
                mini: "true",
                url: props.link,
                title: props.title,
                summary: props.description,
                source: props.source
            })
    }
};
const $cf99e867aee0593b$var$SocialShareButton = ({ title: title, variant: variant, action: action })=>{
    const href = (0, $iSvIT.useMemo)(()=>{
        const actionDescriptor = $cf99e867aee0593b$var$SocialShareButtonActions[variant];
        const url = new URL(actionDescriptor.action);
        const params = new URLSearchParams(actionDescriptor.params(action));
        for (const [key, value] of params.entries())url.searchParams.set(key, value);
        return url.href;
    }, [
        variant,
        action
    ]);
    const clickHandler = (0, $iSvIT.useCallback)((e)=>{
        if (typeof window !== "undefined") {
            window.open(href, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600");
            e.preventDefault();
        }
    }, [
        href
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: href,
        title: title,
        onClick: clickHandler,
        className: (0, $esG4f.default)([
            $cf99e867aee0593b$var$SocialShareButtonStyle.base,
            $cf99e867aee0593b$var$SocialShareButtonStyle[variant]
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            style: {
                pointerEvents: "none",
                visibility: "hidden"
            },
            children: title
        })
    });
};
const $cf99e867aee0593b$var$SocialShareMenuStyle = null;
const $cf99e867aee0593b$export$22d14db7e0bd3bb5 = ({ description: description, link: link, title: title, source: source })=>{
    const intl = (0, $f6qj2.default)();
    const action = (0, $iSvIT.useMemo)(()=>({
            title: title,
            description: description,
            link: link,
            source: source !== null && source !== void 0 ? source : "Atlassian"
        }), [
        description,
        link,
        title,
        source
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("ul", {
        className: (0, $esG4f.default)([
            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _17yb1u1b"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("li", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)($cf99e867aee0593b$var$SocialShareButton, {
                    variant: "facebook",
                    action: action,
                    title: intl.formatMessage({
                        id: "Agile.share-menu.facebook",
                        defaultMessage: "Share on Facebook"
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("li", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)($cf99e867aee0593b$var$SocialShareButton, {
                    variant: "twitter",
                    action: action,
                    title: intl.formatMessage({
                        id: "Agile.share-menu.twitter",
                        defaultMessage: "Share on Twitter"
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("li", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)($cf99e867aee0593b$var$SocialShareButton, {
                    variant: "linkedin",
                    action: action,
                    title: intl.formatMessage({
                        id: "Agile.share-menu.linkedin",
                        defaultMessage: "Share on LinkedIn"
                    })
                })
            })
        ]
    });
};

});

parcelRegister("gTuW6", function(module, exports) {

$parcel$export(module.exports, "AgileUpNextLink", function () { return $1d9caf6c86a43283$export$d6aa7a1a39df0b76; });
/* up-next-link.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");
// NOTE: Extracted from "@/libraries/wpl/foundations/src/icons/basic/arrow-right-no-circle"
// because it does not support 'currentcolor'.
// see: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#currentcolor_keyword
const $1d9caf6c86a43283$var$ArrowRightNoCircle = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 11 8",
        fill: "none",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.40796 0L6.32831 1.2021L8.07854 3.1497H0.763182C0.341906 3.1497 0 3.53038 0 3.99943C0 4.46849 0.341906 4.84917 0.763182 4.84917H8.07854L6.32831 6.7979L7.40796 8L11 3.99943L7.40796 0Z",
            fill: "currentcolor"
        })
    });
const $1d9caf6c86a43283$var$AgileUpNextLinkContainerStyle = null;
const $1d9caf6c86a43283$var$AgileUpNextLinkTextStyle = null;
const $1d9caf6c86a43283$var$AgileUpNextLinkArrowStyle = null;
const $1d9caf6c86a43283$export$d6aa7a1a39df0b76 = ({ name: name, urlSlug: urlSlug })=>{
    const intl = (0, $f6qj2.default)();
    const linkText = intl.formatMessage({
        id: "Agile.main.up-next-link",
        defaultMessage: "Up Next"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "agile-up-next-link",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _4cvresu3"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1ule _19pk1lpd _2hwx1ul9 _otyridpf _18u0idpf"
                ]),
                children: linkText
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": "agileUpNextLink",
                    "data-product-key": "jiraSoftware",
                    href: (0, $3FBn4.useLocalizedHref)(urlSlug),
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _4cvr1h6o _1bahesu3 _1n261q9c _zulp19bv _syazrbzz _1wyb1k92 _y3gnusic _vwz4kb7n _1acvf6fq _tvyuz12g _14mws58n _1qjc1txw _173k1h6o _zq3l1h6o _1r42idpf _30l3oelr _v6ed1jfq _uxxm1wug _so7d1j6v"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            children: name
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: "link-arrow-up-next",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)($1d9caf6c86a43283$var$ArrowRightNoCircle, {})
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("ixUnw", function(module, exports) {

$parcel$export(module.exports, "useNextPage", function () { return $cc9d4ac936a9d26b$export$1075e8f8ce8db3ce; });

var $iSvIT = parcelRequire("iSvIT");

var $igbrG = parcelRequire("igbrG");

var $lrVTP = parcelRequire("lrVTP");
function $cc9d4ac936a9d26b$var$isLocation(urlSlug, location) {
    const url = new URL((0, $igbrG.delocalizePathname)(urlSlug), location.origin);
    return (0, $igbrG.isEqualUnlocalizedPathname)(url.pathname, location.pathname) && url.hash == location.hash;
}
function $cc9d4ac936a9d26b$var$findNextPage(nodes, location) {
    let foundCurrent = false;
    const queue = [
        ...nodes
    ].reverse();
    while(queue.length){
        const next = queue.pop();
        if (!next) continue;
        if (next.urlSlug && $cc9d4ac936a9d26b$var$isLocation(next.urlSlug, location)) foundCurrent = true;
        else if (foundCurrent && next.urlSlug != null) return {
            name: next.name,
            urlSlug: next.urlSlug
        };
        if ((next === null || next === void 0 ? void 0 : next.children) != null) for(let i = next.children.length - 1; i >= 0; i--){
            const child = next.children[i];
            if (child) queue.push(child);
        }
    }
    return null;
}
function $cc9d4ac936a9d26b$export$1075e8f8ce8db3ce(root, nodes) {
    const location = (0, $lrVTP.useLocation)();
    return (0, $iSvIT.useMemo)(()=>{
        // Base case: current location is agile hub landing page,
        // so find the first node with a `urlSlug`.
        if ($cc9d4ac936a9d26b$var$isLocation(root.urlSlug, location)) for (const node of nodes){
            if (node.urlSlug != null) return {
                name: node.name,
                urlSlug: node.urlSlug
            };
        }
        var _findNextPage;
        // Otherwise, find the next page.
        // If the current location is not found, or there is
        // no page after the current location, return the root.
        return (_findNextPage = $cc9d4ac936a9d26b$var$findNextPage(nodes, location)) !== null && _findNextPage !== void 0 ? _findNextPage : root;
    }, [
        root,
        nodes,
        location
    ]);
}

});






parcelRegister("7Fuy3", function(module, exports) {

$parcel$export(module.exports, "AgileOverviewPage", function () { return $435f18dd9ca203e8$export$be1de7c01f2a75bf; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");

var $i8kxh = parcelRequire("i8kxh");

var $gkV6l = parcelRequire("gkV6l");

var $4himv = parcelRequire("4himv");

var $3oPm6 = parcelRequire("3oPm6");

var $hH6Yi = parcelRequire("hH6Yi");

var $jzaJl = parcelRequire("jzaJl");
const $435f18dd9ca203e8$export$be1de7c01f2a75bf = ({ agileOverview: agileOverview, queryRef: queryRef, location: location })=>{
    var _dataPartOne_micrositeTopicOverviewCollection, _dataPartTwo_micrositeTopicOverviewCollection;
    const dataPartOne = (0, $hOqV7.usePreloadedQuery)((0, $3oPm6.AgileOverviewOneQuery), queryRef);
    const dataPartTwo = (0, $hOqV7.useLazyLoadQuery)((0, $3oPm6.AgileOverviewTwoQuery), (0, $3oPm6.getAgileOverviewQueryVars)(location));
    const combinedData = {
        micrositeTopicOverviewCollection: {
            items: [
                (0, $7Knp0._)({}, (_dataPartOne_micrositeTopicOverviewCollection = dataPartOne.micrositeTopicOverviewCollection) === null || _dataPartOne_micrositeTopicOverviewCollection === void 0 ? void 0 : _dataPartOne_micrositeTopicOverviewCollection.items[0], (_dataPartTwo_micrositeTopicOverviewCollection = dataPartTwo.micrositeTopicOverviewCollection) === null || _dataPartTwo_micrositeTopicOverviewCollection === void 0 ? void 0 : _dataPartTwo_micrositeTopicOverviewCollection.items[0])
            ]
        }
    };
    agileOverview = (0, $3oPm6.shapeAgileOverviewContentfulResponse)(combinedData);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4himv.SitesContextProvider), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gkV6l.SiteSelectorContextProvider), {
            analyticsPrefix: "jira-software.ondemand" // TODO: Check if this is correct
            ,
            productKey: (0, $i8kxh.ProductKeys).JIRA_SOFTWARE,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jzaJl.AgileOverviewProvider), {
                agileOverview: agileOverview,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hH6Yi.AgileOverviewPageTemplate), {})
            })
        })
    });
};

});
parcelRegister("hH6Yi", function(module, exports) {

$parcel$export(module.exports, "AgileOverviewPageTemplate", function () { return $b14a9a962390d55c$export$22da6a544e7c9853; });
/* agile-overview-page.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $4ktyF = parcelRequire("4ktyF");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("bJo35");
var $28Etm = parcelRequire("28Etm");
parcelRequire("XSYWD");
var $i2D0R = parcelRequire("i2D0R");

var $cP0Yq = parcelRequire("cP0Yq");

var $hKuvf = parcelRequire("hKuvf");

var $jzaJl = parcelRequire("jzaJl");

var $d8QZt = parcelRequire("d8QZt");

var $ct9CG = parcelRequire("ct9CG");

var $2UYm8 = parcelRequire("2UYm8");

var $9heuA = parcelRequire("9heuA");

var $7unTD = parcelRequire("7unTD");

var $dOPT4 = parcelRequire("dOPT4");

var $3Wymx = parcelRequire("3Wymx");

var $ibGVp = parcelRequire("ibGVp");
// FIXME: These nested selectors are hacks to components we own
const $b14a9a962390d55c$var$rowWrapperCss = null;
const $b14a9a962390d55c$var$mainContentCss = null;
const $b14a9a962390d55c$export$22da6a544e7c9853 = ()=>{
    const agileOverviewData = (0, $jzaJl.useAgileOverview)();
    if (!agileOverviewData) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)($b14a9a962390d55c$var$AgileOverviewPageTemplateContent, (0, $7Knp0._)({}, agileOverviewData));
};
const $b14a9a962390d55c$var$AgileOverviewPageTemplateContent = (props)=>{
    var _props_author, _props_author1, _props_author_authorPicture, _props_author2, _props_author_authorPicture1, _props_author3;
    const agileHeroProps = {
        headerText: props.title,
        secondaryText: props.subtitle || "",
        backgroundPicture: props.bannerImage
    };
    const agileAuthorProps = {
        name: (_props_author = props.author) === null || _props_author === void 0 ? void 0 : _props_author.name,
        biography: (_props_author1 = props.author) === null || _props_author1 === void 0 ? void 0 : _props_author1.shortBiography,
        pictureSrc: (_props_author2 = props.author) === null || _props_author2 === void 0 ? void 0 : (_props_author_authorPicture = _props_author2.authorPicture) === null || _props_author_authorPicture === void 0 ? void 0 : _props_author_authorPicture.url,
        contentType: (_props_author3 = props.author) === null || _props_author3 === void 0 ? void 0 : (_props_author_authorPicture1 = _props_author3.authorPicture) === null || _props_author_authorPicture1 === void 0 ? void 0 : _props_author_authorPicture1.contentType
    };
    const agileCardsProps = (0, $7unTD.useCardProps)((props === null || props === void 0 ? void 0 : props.featuredContentContainer) || []);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.default), {
                isShowTryNowLink: true,
                tryNowLinkCtaButtonColor: "blue",
                productKey: "agile"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $hKuvf.default), {
                selectedNavLink: "agile"
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4ktyF.default), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $2UYm8.AgileHero), (0, $7Knp0._)({}, agileHeroProps)),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1iqz17cv _a2cwzg3v _1yzi1g6w _11fhglyw _16qs1qj0 _1q51zwfg _85i5ckbl"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                            layout: "3-9",
                            alignItems: "top",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $i2D0R.AgileHubSideNav), {
                                    nodes: (0, $ibGVp.useAgileHubPageTreeData)()
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: (0, $esG4f.default)([
                                        "_14611g6w _f0zu1nbp _dzjezg3v _1xpq1nbp"
                                    ]),
                                    children: [
                                        props.mainCallToAction && /*#__PURE__*/ (0, $loA2J.jsx)((0, $dOPT4.ProductCTA), (0, $7Knp0._)({
                                            name: "Kanban"
                                        }, props.mainCallToAction)),
                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $9heuA.AgileOverviewMainContent), {
                                            topicOverviewData: props
                                        }),
                                        props.author && /*#__PURE__*/ (0, $loA2J.jsx)((0, $d8QZt.AgileAuthor), (0, $7Knp0._)({}, agileAuthorProps)),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_181nglyw"
                                            ]),
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ct9CG.AgileCards), {
                                                headerText: props.name,
                                                cardsProps: agileCardsProps
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $7unTD.NavigationCards), {
                        cardsData: props.nextBestAction
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $3Wymx.ShareUpNextBar), {
                        nodes: (0, $ibGVp.useAgileHubPageTreeData)(),
                        title: props.title,
                        description: props.description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $28Etm.AgileFooter), {})
        ]
    });
};

});
parcelRegister("hKuvf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d14aee97da736e57$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("1ppvA");
var $foLdD = parcelRequire("foLdD");
var $luYKm = parcelRequire("luYKm");
var $jGRaW = parcelRequire("jGRaW");

var $3FBn4 = parcelRequire("3FBn4");
const $d14aee97da736e57$export$3114ed03a2c45c8b = ({ selectedNavLink: selectedNavLink })=>{
    const intl = (0, $f6qj2.default)();
    const devopsDropdown = [
        {
            header: "",
            hideHeader: true,
            items: [
                {
                    label: intl.formatMessage({
                        id: "SoftwareDevelopment.navbar.dropdown.link.delivery",
                        defaultMessage: "Continuous Delivery"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/continuous-delivery"),
                    isSelected: selectedNavLink === "continuousDelivery"
                },
                {
                    label: intl.formatMessage({
                        id: "SoftwareDevelopment.navbar.dropdown.link.git",
                        defaultMessage: "Git"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/git"),
                    isSelected: selectedNavLink === "git"
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $foLdD.ProductNavBar), {
        productHref: (0, $3FBn4.useLocalizedHref)("/software-development"),
        productName: "softwaredevelopment",
        ariaLabel: intl.formatMessage({
            id: "SoftwareDevelopmentProductNav.logo-label",
            defaultMessage: "Software Development"
        }),
        showTextWithoutLogo: true,
        showFreeHrefButton: false,
        dataProductKey: "softwareDevelopment",
        logoLinkWrapperWidth: "max-content",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $luYKm.ProductNavDropdown), {
                label: intl.formatMessage({
                    id: "SoftwareDevelopment.navbar.dropdown.devops",
                    defaultMessage: "DevOps"
                }),
                groups: devopsDropdown
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jGRaW.ProductNavLink), {
                label: intl.formatMessage({
                    id: "SoftwareDevelopment.navbar.agile",
                    defaultMessage: "Agile"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/agile"),
                isSelected: selectedNavLink === "agile"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jGRaW.ProductNavLink), {
                label: intl.formatMessage({
                    id: "SoftwareDevelopment.navbar.microservices",
                    defaultMessage: "Microservices"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/microservices"),
                isSelected: selectedNavLink === "microservices"
            })
        ]
    });
};
var $d14aee97da736e57$export$2e2bcd8739ae039 = $d14aee97da736e57$export$3114ed03a2c45c8b;

});
parcelRegister("1ppvA", function(module, exports) {
$parcel$export(module.exports, "ProductNavBar", function () { return (parcelRequire("foLdD")).ProductNavBar; });

$parcel$export(module.exports, "ProductNavBar", function () { return (parcelRequire("foLdD")).ProductNavBar; });
$parcel$export(module.exports, "ProductNavLink", function () { return (parcelRequire("jGRaW")).ProductNavLink; });
$parcel$export(module.exports, "ProductNavDropdown", function () { return (parcelRequire("luYKm")).ProductNavDropdown; });

var $foLdD = parcelRequire("foLdD");

var $jGRaW = parcelRequire("jGRaW");

var $luYKm = parcelRequire("luYKm");

});
parcelRegister("foLdD", function(module, exports) {

$parcel$export(module.exports, "ProductNavBar", function () { return $5058fda3eedddac7$export$6bfdc568e00f9e3d; });
/* product-navbar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $jJ1uJ = parcelRequire("jJ1uJ");

var $4xseM = parcelRequire("4xseM");

var $4XrxY = parcelRequire("4XrxY");

var $5KXGt = parcelRequire("5KXGt");

var $bQawl = parcelRequire("bQawl");
const $5058fda3eedddac7$var$navigationWrapperCss = null;
const $5058fda3eedddac7$var$navigationBarWrapperCss = null;
const $5058fda3eedddac7$var$navigationBarCss = null;
const $5058fda3eedddac7$var$logoAndLinksCss = null;
const $5058fda3eedddac7$var$keyframeChevron = null;
const $5058fda3eedddac7$var$removeKeyframeChevron = null;
const $5058fda3eedddac7$var$dropdownSlideInAnimation = null;
const $5058fda3eedddac7$var$dropdownSlideOutAnimation = null;
const $5058fda3eedddac7$var$listItemCss = null;
const $5058fda3eedddac7$var$buttonWrapper = null;
const $5058fda3eedddac7$var$linkAndButtonWrapper = null;
const $5058fda3eedddac7$var$buttonStyle = null;
const $5058fda3eedddac7$var$contactSalesButtonStyle = null; // eslint-disable-next-line complexity
const $5058fda3eedddac7$export$6bfdc568e00f9e3d = (props)=>{
    const intl = (0, $f6qj2.default)();
    var _props_showFreeHrefButton;
    const isShowFreeHrefButton = (_props_showFreeHrefButton = props.showFreeHrefButton) !== null && _props_showFreeHrefButton !== void 0 ? _props_showFreeHrefButton : true;
    var _props_showContactSalesHrefButton;
    const isShowContactSalesHrefButton = (_props_showContactSalesHrefButton = props.showContactSalesHrefButton) !== null && _props_showContactSalesHrefButton !== void 0 ? _props_showContactSalesHrefButton : false;
    var _props_showTextWithoutLogo;
    const showTextWithoutLogo = (_props_showTextWithoutLogo = props.showTextWithoutLogo) !== null && _props_showTextWithoutLogo !== void 0 ? _props_showTextWithoutLogo : false;
    const [activeDropdown, setActive] = (0, $iSvIT.useState)(null);
    const [buttonType, setButtonType] = (0, $iSvIT.useState)("secondary");
    const location = (0, $5KXGt.useLocation)();
    (0, $iSvIT.useEffect)(()=>{
        window.addEventListener("scroll", handleScroll);
    }, []);
    (0, $iSvIT.useEffect)(()=>{
        (0, $4xseM.Initializer).autoTrack();
    }, [
        activeDropdown,
        props.showFreeHrefButton
    ]);
    const handleScroll = ()=>{
        setButtonType(window.scrollY > 56 ? "primary" : "secondary");
    };
    const getItFreeText = intl.formatMessage({
        id: "productNavBar.get-it-free-button",
        defaultMessage: "Get it free"
    });
    const getContactSalesText = intl.formatMessage({
        id: "productNavBar.contact-sales-button",
        defaultMessage: "Contact sales"
    });
    const dropdownCss = [
        activeDropdown === null && null,
        activeDropdown && null,
        !activeDropdown && null
    ];
    const mobileCategoriesWrapperCss = [
        activeDropdown === null && null,
        activeDropdown && null,
        !activeDropdown && null
    ];
    const renderSelectionItems = (isMobile)=>{
        const categoriesWrapperCss = [
            !isMobile && null
        ];
        return /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
            className: (0, $esG4f.default)([
                !isMobile && "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _qtt8glyw _18s8119w _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1mjbglyw"
            ]),
            children: props.children && (0, $iSvIT.Children).map(props.children, (child, index)=>child ? /*#__PURE__*/ (0, $loA2J.jsx)("li", {
                    className: (0, $esG4f.default)([
                        "_kqswh2mm"
                    ]),
                    children: /*#__PURE__*/ (0, $iSvIT.cloneElement)(child, {
                        isSelected: child.props.isSelected || (0, $5KXGt.isEqualUnlocalizedPathname)(child.props.href, location.pathname),
                        isMobile: isMobile
                    })
                }, index) : null)
        });
    };
    const renderDropdownButton = ()=>{
        if (props.children) return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
            onClick: ()=>setActive(!activeDropdown),
            className: (0, $esG4f.default)([
                activeDropdown === null && "_1e0cglyw _80omtlke _tnv2qshr _13jeglyw _7w28rbzz _1mjb1ule _xc2i12x7 _19ekxy5q _rulpxy5q",
                activeDropdown && "",
                activeDropdown && "_1px1qbue _48hmq7pw _1e0cglyw _80omtlke _tnv2qshr _13jeglyw _7w28rbzz _1mjb1ule _xc2i12x7 _19ekxy5q _rulpxy5q",
                !activeDropdown && "",
                !activeDropdown && "_1px1k4ed _48hmq7pw _1e0cglyw _80omtlke _tnv2qshr _13jeglyw _7w28rbzz _1mjb1ule _xc2i12x7 _19ekxy5q _rulpxy5q"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jJ1uJ))), {
                label: ""
            })
        });
        return null;
    };
    const logoWrapperCss = [
        props.logoLinkWrapperWidth !== "" && null,
        props.logoLinkWrapperWidth === "" && null,
        props.logoLinkWrapperWidth === undefined && null
    ];
    const textWrapperCss = null;
    const textCss = null;
    const boxShadowCss = props.productName !== "confluence" && props.productName !== "jira" && null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqsw1n9t _1bsb1osq _152tidpf _1pby11wp"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4cvr1y6m _bfhku67f _1e0c1txw _2lx2vrvc _1bah1h6o",
                    props.productName !== "confluence" && props.productName !== "jira" && "_16qsg1bn"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_4cvr1h6o _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _1bah1yb4 _165t1wqb _10jx1fra _1yag119w _1vkh8vuz _13zno7np _em6nh2mm _4ik0kb7n _1gdevrvc _navj1g80 _tnru1wug _15tx119w",
                        "productNavBar"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw"
                            ]),
                            children: [
                                showTextWithoutLogo ? /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                    href: props.productHref,
                                    "aria-label": props.ariaLabel,
                                    className: (0, $esG4f.default)([
                                        "_4t3i12am _syaz1mpp _4cvr1h6o _1e0c1txw _2lx2vrvc"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        className: (0, $esG4f.default)([
                                            "_1wyb166g _k48pbfng"
                                        ]),
                                        children: props.ariaLabel
                                    })
                                }) : /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                    href: props.productHref,
                                    "aria-label": props.ariaLabel,
                                    className: (0, $esG4f.default)([
                                        props.logoLinkWrapperWidth !== "" && "_1bsb1izz _4cvr1h6o _1e0c1txw",
                                        props.logoLinkWrapperWidth === "" && "_1bsb2lms _4cvr1h6o _1e0c1txw",
                                        props.logoLinkWrapperWidth === undefined && "_1bsb2lms _4cvr1h6o _1e0c1txw"
                                    ]),
                                    style: {
                                        "--_evdsab": (0, $43MIc.default)(props.logoLinkWrapperWidth)
                                    },
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Logo), {
                                        brand: props.productName,
                                        type: "logo",
                                        appearance: "brand"
                                    })
                                }),
                                renderDropdownButton(),
                                renderSelectionItems(false)
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _4cvr1h6o"
                            ]),
                            children: [
                                isShowFreeHrefButton && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1e0c1txw _ca0qo7ao _u5f3idpf _n3tdo7ao _19bvidpf",
                                        "showFreeHrefButton"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bQawl.default), {
                                        text: getItFreeText,
                                        url: props.freeHref,
                                        type: buttonType,
                                        "aria-label": getItFreeText,
                                        dataEventProps: {
                                            "data-event-container": "navbar",
                                            "data-event": "clicked",
                                            "data-event-component": "linkButton",
                                            "data-label": getItFreeText,
                                            "data-label-english": "Get it free",
                                            "data-product-key": props.dataProductKey,
                                            "data-track-event": `${props.dataProductKey}.get-it-free-button-clicked`
                                        },
                                        onClick: props.onClick,
                                        className: (0, $esG4f.default)([
                                            "_1wyb1j6v _k48pbfng _4t3iviql _1bsb1wug _1aaxusic _v5647x7w _3fcw1q9c _13zmh2mm _1rfm1wug _1gdevrvc _navj1g80 _1l7dn7od"
                                        ])
                                    })
                                }),
                                isShowContactSalesHrefButton && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: "showContactSalesHrefButton",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bQawl.default), {
                                        text: getContactSalesText,
                                        color: "yellow",
                                        url: props.freeHref,
                                        type: buttonType,
                                        "aria-label": getContactSalesText,
                                        dataEventProps: {
                                            "data-event-container": "navbar",
                                            "data-event": "clicked",
                                            "data-event-component": "linkButton",
                                            "data-label": getContactSalesText,
                                            "data-product-key": props.dataProductKey
                                        },
                                        onClick: props.onClick,
                                        className: (0, $esG4f.default)([
                                            "_1wyb1j6v _k48pbfng _4t3iviql _bfhk14w1 _1bsb1wug _1aaxusic _v5647x7w _3fcw1q9c _13zmh2mm _1rfm1wug _1gdevrvc _navj1g80 _1l7dn7od"
                                        ])
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    activeDropdown === null && "_16jlkb7n _1o9zkb7n _i0dlf1ug _1h6d1mpp _bfhk1hxd _mqm21ehm _179r1jv8 _16qsg1bn _c71lidpf _1reo15vq _18m91wug _kqswstnw _1bsb1osq _102oidpf _1kvxidpf _1ysjidpf _17d4idpf _1hzio7ao _3n4midpf _ltofo7ao _k7zy1ul9 _1hmtglyw _163ro7ao _dm25glyw",
                    activeDropdown && "",
                    activeDropdown && "_y44v18yz _16jlkb7n _1o9zkb7n _i0dlf1ug _1h6d1mpp _bfhk1hxd _mqm21ehm _179r1jv8 _16qsg1bn _c71lidpf _1reo15vq _18m91wug _kqswstnw _1bsb1osq _102oidpf _1kvxidpf _1ysjidpf _17d4idpf _1hzio7ao _3n4midpf _ltofo7ao _k7zy1ul9 _1hmtglyw _163ro7ao _dm25glyw",
                    !activeDropdown && "",
                    !activeDropdown && "_y44v1eb4 _16jlkb7n _1o9zkb7n _i0dlf1ug _1h6d1mpp _bfhk1hxd _mqm21ehm _179r1jv8 _16qsg1bn _c71lidpf _1reo15vq _18m91wug _kqswstnw _1bsb1osq _102oidpf _1kvxidpf _1ysjidpf _17d4idpf _1hzio7ao _3n4midpf _ltofo7ao _k7zy1ul9 _1hmtglyw _163ro7ao _dm25glyw",
                    "mobileCategoriesWrapper"
                ]),
                children: renderSelectionItems(true)
            })
        ]
    });
};
var $5058fda3eedddac7$export$2e2bcd8739ae039 = $5058fda3eedddac7$export$6bfdc568e00f9e3d;

});

parcelRegister("jGRaW", function(module, exports) {

$parcel$export(module.exports, "ProductNavLink", function () { return $c45c0fbf58488d75$export$df4f9873dfab197b; });
/* product-navlink.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $c45c0fbf58488d75$var$linkStyle = null;
const $c45c0fbf58488d75$export$df4f9873dfab197b = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_18ywh2mm _9c4j1l7b _1hw71ule _19tb1j6v _1la1kb7n _8bvm119w _i7kgzu5n _5i9qrbzz _1x5rusvi _1qxa59zy _1unt1r31 _jsn2glyw _1b4hnqa1 _1mcc10vn _1ry4oelr _906b1osq _1nzh1xjh _1euc119w _3uyxrbzz _1u7j19bv _c12j1r31 _1udz8stv _4ba5nqa1 _1u6y1r31 _14ifglyw _f3mxnqa1 _1sinoelr _jhsausvi _c3hm4m1f _1ohxni7l _4mi7nclz _b4f8nclz"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("a", (0, $6iHNw._)((0, $7Knp0._)({
            className: props.isSelected ? "selected" : "",
            href: props.href
        }, props.dataEventProps), {
            "data-label": props.label,
            children: props.label
        }))
    });
};
var $c45c0fbf58488d75$export$2e2bcd8739ae039 = $c45c0fbf58488d75$export$df4f9873dfab197b;

});

parcelRegister("luYKm", function(module, exports) {

$parcel$export(module.exports, "ProductNavDropdown", function () { return $c5bcaacf49524b95$export$39cc2d4a9bc14e7d; });
/* product-navdropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable jsx-a11y/anchor-is-valid */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $fKhJX = parcelRequire("fKhJX");

var $3EnyL = parcelRequire("3EnyL");
const $c5bcaacf49524b95$var$parentItemStyle = null;
const $c5bcaacf49524b95$var$dropdownStyle = null;
const $c5bcaacf49524b95$var$listStyle = null;
const $c5bcaacf49524b95$var$headerStyle = null;
const $c5bcaacf49524b95$var$listItemStyle = null;
const $c5bcaacf49524b95$var$linkStyle = null;
const $c5bcaacf49524b95$var$mobileDropdownStyle = null;
const $c5bcaacf49524b95$export$39cc2d4a9bc14e7d = ({ label: label, isMobile: isMobile = false, groups: groups, dataProductKey: dataProductKey = "jiraSoftware" })=>{
    const [isDropdownVisible, setDropdownVisible] = (0, $iSvIT.useState)(false);
    const [isMobileDropdownVisible, setMobileDropdownVisible] = (0, $iSvIT.useState)(false);
    const dropdownRef = (0, $iSvIT.useRef)(null);
    (0, $3EnyL.useOutsideEvent)(dropdownRef, "click", ()=>setDropdownVisible(false));
    (0, $3EnyL.useOutsideEvent)(dropdownRef, "focusin", ()=>setDropdownVisible(false));
    const innerRef = (0, $iSvIT.useRef)(null);
    (0, $3EnyL.useOutsideEvent)(innerRef, "click", ()=>setDropdownVisible(false));
    (0, $3EnyL.useOutsideEvent)(innerRef, "focusin", ()=>setDropdownVisible(false));
    const handleTouchEnd = (event)=>{
        event.preventDefault();
        setMobileDropdownVisible((state)=>!state);
    };
    const handleClick = ()=>setMobileDropdownVisible((state)=>!state);
    const handleMouseEnter = ()=>setDropdownVisible(true);
    const handleMouseLeave = ()=>setDropdownVisible(false);
    const handleKeyUp = (event)=>{
        if (event.key === "Enter") setDropdownVisible((state)=>!state);
    };
    (0, $iSvIT.useEffect)(()=>{
        if (isDropdownVisible || isMobileDropdownVisible) (0, $fKhJX.Tracking).autoTrackLinks(true);
    }, [
        isDropdownVisible,
        isMobileDropdownVisible
    ]);
    const renderGroups = (dataProductKey)=>groups === null || groups === void 0 ? void 0 : groups.map(({ header: header, items: items, hideHeader: hideHeader }, groupIndex)=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $iSvIT.Fragment), {
                children: [
                    !hideHeader && /*#__PURE__*/ (0, $loA2J.jsx)("li", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("h5", {
                            className: (0, $esG4f.default)([
                                "_1e0c1ule _ca0q1y44 _u5f31ul9 _n3td1y44 _19bv1ul9 _o5721q9c _4bfu1r31 _1hmsglyw _ajmmnqa1 _1wyb1j6v _syaz1bqd _19pk1crf _2hwxidpf _otyridpf _18u0idpf _1p1dangw _k48p1fw0 _vwz410nf _1dyzt94y"
                            ]),
                            children: header
                        })
                    }),
                    items.map(({ label: itemLabel, labelEnglish: itemLabelEnglish, href: href, isSelected: isSelected }, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                            className: (0, $esG4f.default)([
                                "_kqswh2mm _1pfh1crf _6rth1crf _1ohxni7l _ym7n1bqd _zgzju67f"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                className: (0, $esG4f.default)([
                                    "_1wyb1j6v _vwz4851k _1e0c1ule _ca0q1y44 _u5f31ul9 _n3td1y44 _19bv1ul9 _o5721q9c _4bfu1r31 _1hmsglyw _ajmmnqa1 _syazrbzz _1l4er3uz _irr3rbzz _30l3u67f",
                                    isSelected ? "selected" : ""
                                ]),
                                href: href,
                                id: `dropdown-${label.toLowerCase()}-${index}`,
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "navbarDropdownLink",
                                "data-product-key": dataProductKey,
                                "data-label": itemLabel,
                                "data-label-english": itemLabelEnglish,
                                children: itemLabel
                            })
                        }, `${itemLabel}-${index}`))
                ]
            }, `${header}-${groupIndex}`));
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                ref: dropdownRef,
                onTouchEnd: handleTouchEnd,
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave,
                onClick: handleClick,
                onFocus: handleMouseEnter,
                onKeyUp: handleKeyUp,
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                        id: `dropdown-${label.toLowerCase()}`,
                        href: "#",
                        "data-event": "clicked",
                        "data-label": label,
                        "data-event-component": "linkButton",
                        "data-event-container": "navbarDropdown",
                        "data-product-key": dataProductKey,
                        className: (0, $esG4f.default)([
                            "_kqswh2mm _152t1l7b _1e0c1txw _4cvr1h6o _1wyb1j6v _vwz4kb7n _syazrbzz _30l3oelr _1b75y6p2 _rtay4h09 _16m51fys _1nbi1f51 _1l3vb3bt _1m5l1o8l _1t6ii2wt _1k6s1crf _1dqh1crf _d6wu1vv5 _1j5e4h09 _1y3ib3bt _1mhxi2wt _1nwwi2wt _fl6h1axk _l23r1axk _u5pl1kw7 _ytugq07a _gs6s19bv _1t7gbf4l _7wutjyd4 _k11laqso _1vie3iz4 _ue5g119w _1yagzu5n _1gs5usvi _v9tz59zy _1s4p1osq _6ssj1xjh _17p3119w _1a5h19bv",
                            isMobileDropdownVisible ? "open" : ""
                        ]),
                        children: label
                    }),
                    !isMobile && isDropdownVisible ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        ref: innerRef,
                        className: (0, $esG4f.default)([
                            "_bfhku67f _19itulfz _2rko1y44 _16qsg1bn _kqswstnw _152t1osq _1e021ssb _t9ec1e6q _1pbyzo7u"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                            className: (0, $esG4f.default)([
                                "_qtt8glyw _bozgidpf _1q5114y2 _85i514y2 _kqswh2mm _1pbykb7n _1rusu67f _iajmidpf _1g0vidpf _1fkr1osq _z5wt1ssb _14h81fby _1kt9f705 _kfgtidpf _1mp4idpf _1cs8stnw _dsq4glyw _7dwzzr6s _15l21hqi _1bqq1mrw _1guf1osq _g0nf1ssb _eq43105i _aetrf705 _1qdgidpf _z0aiidpf _18postnw _11fnglyw _1cteu67f _clh3zr6s"
                            ]),
                            children: renderGroups(dataProductKey)
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: isMobile && isMobileDropdownVisible ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    ref: innerRef,
                    className: (0, $esG4f.default)([
                        "_1hziidpf _3n4midpf _ltofidpf _k7zyidpf"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                        children: renderGroups(dataProductKey)
                    })
                }) : null
            })
        ]
    });
};
var $c5bcaacf49524b95$export$2e2bcd8739ae039 = $c5bcaacf49524b95$export$39cc2d4a9bc14e7d;

});



parcelRegister("jzaJl", function(module, exports) {

$parcel$export(module.exports, "AgileOverviewProvider", function () { return $65393e046fe61601$export$45b81a39c29b3e59; });
$parcel$export(module.exports, "useAgileOverview", function () { return $65393e046fe61601$export$809688ba543042f1; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $goGkF = parcelRequire("goGkF");

var $1qD46 = parcelRequire("1qD46");

var $gpl9P = parcelRequire("gpl9P");
const $65393e046fe61601$export$bb3d35787c3373e0 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $65393e046fe61601$var$useAgileOverviewContextValue = (agileOverview)=>{
    const [contextValue, setContextValue] = (0, $iSvIT.useState)(agileOverview);
    (0, $iSvIT.useEffect)(()=>{
        const fetchAgileOverviewFromClient = async ()=>{
            const client = new (0, $gpl9P.AGGClient)({
                gatewayUrl: "https://www.atlassian.com/gateway/api/graphql"
            });
            const { route: route, locale: locale } = (0, $1qD46.getCurrentRoute)();
            const agileOverview = await (0, $goGkF.getTemplateData)(route, locale, client);
            setContextValue(agileOverview);
        };
        if (!contextValue) fetchAgileOverviewFromClient();
    // empty dependency array so this effect only runs once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return contextValue;
};
const $65393e046fe61601$export$45b81a39c29b3e59 = (props)=>{
    const value = $65393e046fe61601$var$useAgileOverviewContextValue(props.agileOverview);
    return /*#__PURE__*/ (0, $loA2J.jsx)($65393e046fe61601$export$bb3d35787c3373e0.Provider, {
        value: value,
        children: props.children
    });
};
const $65393e046fe61601$export$809688ba543042f1 = ()=>{
    const agileOverview = (0, $iSvIT.useContext)($65393e046fe61601$export$bb3d35787c3373e0);
    if (!agileOverview) console.warn("SSR failed to fetch content on the server. Fetching content on the client.");
    return agileOverview;
};

});

parcelRegister("ct9CG", function(module, exports) {

$parcel$export(module.exports, "AgileCards", function () { return $3ce7cb2552d9c29d$export$8d784affd4fac712; });
/* agile-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $7unTD = parcelRequire("7unTD");
const $3ce7cb2552d9c29d$export$8d784affd4fac712 = ({ headerText: headerText, cardsProps: cardsProps })=>{
    const containerCSS = null;
    const headerCSS = null;
    const cardCSS = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_ca0q7vkz _u5f37vkz _n3td7vkz _19bvidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                className: (0, $esG4f.default)([
                    "_syaz1bqd _1wyb1k8s _vwz415sy _6rth7vkz _1pfhidpf _1dyznl7k _k48pbfng"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "AgileOverview.AgileCards.Card.Header",
                    defaultMessage: "{headerText} featured content",
                    values: {
                        headerText: headerText
                    },
                    description: "headerText is an agile concept such as Kanban, Agile project management, Design, etc."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1n261g80 _ahbq1h22 _12l21h22 _1q517vkz _85i57vkz _syaz1bqd _1qeivwuj _1qef1crf _1adhl8b6 _bsma1tcg _crcvangw _15jft94y _q2dt1td8 _qliy1bqd _1biu1j8p _3tur1osq _yk5jh9n0 _3cbl1osq _1p94idpf _d47fidpf _1qv9idpf _d600idpf"
                ]),
                children: cardsProps.map((props)=>{
                    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1bsbx683 _i0dlx683 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1cgj1y44 _10gg14ds _12rr1ssb _16xt1ssb _1rfm1osq _1a1x1osq"
                        ]),
                        children: /*#__PURE__*/ (0, $iSvIT.createElement)((0, $7unTD.NavigationCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                            key: `${props.headerText}-body-card`
                        }))
                    }, `${props.headerText}-body-card-container`);
                })
            })
        ]
    });
};

});

parcelRegister("2UYm8", function(module, exports) {

$parcel$export(module.exports, "AgileHero", function () { return $dd468f84557c2609$export$9df2733b25de56ba; });
/* agile-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $lHB9W = parcelRequire("lHB9W");
const $dd468f84557c2609$export$9df2733b25de56ba = ({ headerText: headerText, secondaryText: secondaryText, backgroundPicture: backgroundPicture })=>{
    const heroCss = null;
    const headerCss = null;
    const secondaryCss = null;
    const capitalize = (title)=>{
        return title.charAt(0).toUpperCase() + title.slice(1);
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_y3gn1h6o _1itk10ch _ouxl1ssb _1lrw1dfr _12vemgnk _ahbq1wug _12l21wug _1q51vbgk _85i5vbgk _bozg7vkz _y4ti7vkz _1ul91osq _11rm1hrf _syazu67f"
        ]),
        style: {
            "--_13fp5a": (0, $43MIc.default)((0, $lHB9W.expectContent)(backgroundPicture).url, ")", "url(")
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_k48p1nn1 _1wybviql _1pfh7vkz _6rth7vkz _ahbqidpf _12l2idpf _1dyzidpf _vwz4zz36 _1s18yn4p _fz891wto"
                ]),
                children: capitalize((0, $lHB9W.expectContent)(headerText))
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_1wyb1k92 _ect4kipj _1dyznl7k _vwz419ii _k48p1kze _6rth7vkz"
                ]),
                children: secondaryText
            })
        ]
    });
};

});

parcelRegister("9heuA", function(module, exports) {

$parcel$export(module.exports, "AgileOverviewMainContent", function () { return $541c342ecca99e9c$export$97937ae50eb0879; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $ct9CG = parcelRequire("ct9CG");

var $7unTD = parcelRequire("7unTD");

var $aUZ56 = parcelRequire("aUZ56");

var $9R3Il = parcelRequire("9R3Il");
const $541c342ecca99e9c$var$readOnBelowCss = null;
const $541c342ecca99e9c$var$continuedCss = null; // FIXME: These styles seem like they are in the wrong place. Shouldn't they be in the rich text component?
// NOTE: Nested selectors are necessary here to be able to style the dangerouslySetInnerHTML blob
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ const $541c342ecca99e9c$var$mainContentWrapperCss = null; /* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors */ 
const $541c342ecca99e9c$var$ReadOnBelow = ()=>{
    const handleClick = (e)=>{
        var _document_getElementById;
        e.preventDefault();
        (_document_getElementById = document.getElementById("continued")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.scrollIntoView({
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
            href: "#continued",
            onClick: handleClick,
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-product-key": "jiraSoftware",
            className: (0, $esG4f.default)([
                "_y3gn1h6o _ca0q1ylp _u5f3idpf _n3td1ylp _19bvidpf _kqswh2mm _1e0c1ule _k48p1fw0 _syazvwuj _1wyboxwj _1dyzt94y _vwz410nf _wnkw1ylp _6rthdlk8 _1p1dangw _30l3oelr _sugaglyw"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "agile.overview.readOnBelow",
                defaultMessage: "Read on below"
            })
        })
    });
};
const $541c342ecca99e9c$var$Continued = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        id: "continued",
        className: (0, $esG4f.default)([
            "_syazvwuj _ca0q1ylp _u5f3idpf _n3td1ylp _19bvidpf _kqswh2mm _y3gn1h6o _1wyboqnp _vwz4cs5v _1p1dangw _1dyzt94y _sugaglyw"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "agile.overview.continued",
                defaultMessage: "[Continued]"
            })
        })
    });
};
const $541c342ecca99e9c$export$97937ae50eb0879 = (props)=>{
    var _props_topicOverviewData_bodyTextContainer;
    const TopicIntroductionSection = ()=>{
        const topicIntroductionContent = props.topicOverviewData.topicIntroduction;
        return topicIntroductionContent === null || topicIntroductionContent === void 0 ? void 0 : topicIntroductionContent.map((data, idx)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9R3Il.TopicIntroduction), (0, $7Knp0._)({}, data))
            }, idx));
    };
    const BodyTextContainerSection = ()=>{
        const bodyTextContent = props.topicOverviewData.bodyTextContainer;
        return bodyTextContent === null || bodyTextContent === void 0 ? void 0 : bodyTextContent.map((data, idx)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aUZ56.BodyTextContainer), (0, $7Knp0._)({}, data))
            }, idx));
    };
    const hasBodyText = !!((_props_topicOverviewData_bodyTextContainer = props.topicOverviewData.bodyTextContainer) === null || _props_topicOverviewData_bodyTextContainer === void 0 ? void 0 : _props_topicOverviewData_bodyTextContainer.length);
    const featuredContentCardProps = (0, $7unTD.useCardProps)(props.topicOverviewData.featuredContentContainer || []);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1dm8q5uf _125x1mpp _q7gq1cby _zcqx14u8 _8v2f19ye _1yzi19ye _160119ye _l5k1bfng _r8ntbfng _1a7kbfng _cg411bqd _qliy1bqd _1rhq1bqd _11eb1k8s _17z415sy _qc0pahaf _ggmh1k92 _1axi11ph _1o6v7vkz _ugctnl7k _1edj1k8s _8kc91k92 _1euycjiy _k6x07vkz _8lldnl7k"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)(TopicIntroductionSection, {}),
            hasBodyText && /*#__PURE__*/ (0, $loA2J.jsx)($541c342ecca99e9c$var$ReadOnBelow, {}),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_sugaglyw"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ct9CG.AgileCards), {
                    headerText: props.topicOverviewData.name,
                    cardsProps: featuredContentCardProps
                })
            }),
            hasBodyText && /*#__PURE__*/ (0, $loA2J.jsx)($541c342ecca99e9c$var$Continued, {}),
            /*#__PURE__*/ (0, $loA2J.jsx)(BodyTextContainerSection, {})
        ]
    });
};

});
parcelRegister("9R3Il", function(module, exports) {

$parcel$export(module.exports, "TopicIntroduction", function () { return $e54728cd8221c89e$export$eec80089618278cb; });
/* topic-introduction.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6O6jV = parcelRequire("6O6jV");

var $bhreu = parcelRequire("bhreu");

var $krNyQ = parcelRequire("krNyQ");
const $e54728cd8221c89e$var$topicIntroductionWrapperCss = null;
const $e54728cd8221c89e$var$headerCss = null;
const $e54728cd8221c89e$var$assetCss = null;
const $e54728cd8221c89e$export$eec80089618278cb = ({ title: title, details: details, embedLink: embedLink, asset: asset })=>{
    const renderIntroductionAsset = ()=>{
        // If there's an embedLink, we expect an asset to go with it.
        if (embedLink && (asset === null || asset === void 0 ? void 0 : asset.length)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6O6jV.AgileVideo), {
            embedLink: embedLink,
            title: title !== null && title !== void 0 ? title : "",
            thumbnail: asset[0]
        });
        if (asset) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
            children: asset.map((asset)=>/*#__PURE__*/ {
                var _asset_url, _asset_description, _ref;
                return (0, $loA2J.jsx)((0, $bhreu.Picture), {
                    image: {
                        src: (_asset_url = asset === null || asset === void 0 ? void 0 : asset.url) !== null && _asset_url !== void 0 ? _asset_url : "",
                        alt: (_ref = (_asset_description = asset === null || asset === void 0 ? void 0 : asset.description) !== null && _asset_description !== void 0 ? _asset_description : asset === null || asset === void 0 ? void 0 : asset.name) !== null && _ref !== void 0 ? _ref : ""
                    }
                }, asset === null || asset === void 0 ? void 0 : asset.name);
            })
        });
        return null;
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1ule _kqswh2mm _4t3i1osq _1q517vkz",
            "topicIntroduction"
        ]),
        children: [
            title && /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_6rthjbgo _1pfh7vkz"
                ]),
                children: title
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: "topicIntroduction-body",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                    text: details,
                    name: null
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1ule _kqswh2mm",
                    "topicIntroduction-asset"
                ]),
                children: renderIntroductionAsset()
            })
        ]
    });
};

});




parcelRegister("cQTaT", function(module, exports) {

$parcel$export(module.exports, "AgileTutorialPage", function () { return $b8da5671654dd570$export$349cd38ca298bc00; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");

var $i8kxh = parcelRequire("i8kxh");

var $gkV6l = parcelRequire("gkV6l");

var $4himv = parcelRequire("4himv");

var $bl3E5 = parcelRequire("bl3E5");
parcelRequire("6sQha");
var $khjCY = parcelRequire("khjCY");

var $8jOop = parcelRequire("8jOop");
const $b8da5671654dd570$export$349cd38ca298bc00 = ({ agileTutorial: agileTutorial, queryRef: queryRef, location: location })=>{
    var _dataPartOne_tutorialDetailsCollection, _dataPartTwo_tutorialDetailsCollection;
    const dataPartOne = (0, $hOqV7.usePreloadedQuery)((0, $bl3E5.AgileTutorialOneQuery), queryRef);
    const dataPartTwo = (0, $hOqV7.useLazyLoadQuery)((0, $bl3E5.AgileTutorialTwoQuery), (0, $bl3E5.getAgileTutorialQueryVars)(location));
    const combinedData = {
        tutorialDetailsCollection: {
            items: [
                (0, $7Knp0._)({}, (_dataPartOne_tutorialDetailsCollection = dataPartOne.tutorialDetailsCollection) === null || _dataPartOne_tutorialDetailsCollection === void 0 ? void 0 : _dataPartOne_tutorialDetailsCollection.items[0], (_dataPartTwo_tutorialDetailsCollection = dataPartTwo.tutorialDetailsCollection) === null || _dataPartTwo_tutorialDetailsCollection === void 0 ? void 0 : _dataPartTwo_tutorialDetailsCollection.items[0])
            ]
        }
    };
    agileTutorial = (0, $bl3E5.shapeAgileHubTutorialContentfulResponse)(combinedData);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4himv.SitesContextProvider), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gkV6l.SiteSelectorContextProvider), {
            analyticsPrefix: "jira-software.ondemand" // TODO: Check if this is correct
            ,
            productKey: (0, $i8kxh.ProductKeys).JIRA_SOFTWARE,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8jOop.AgileTutorialProvider), {
                tutorial: agileTutorial,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $khjCY.AgileTutorialPageTemplate), {})
            })
        })
    });
};

});
parcelRegister("6sQha", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("khjCY")).AgileTutorialPageTemplate; });

var $khjCY = parcelRequire("khjCY");

var $8jOop = parcelRequire("8jOop");

});
parcelRegister("khjCY", function(module, exports) {

$parcel$export(module.exports, "AgileTutorialPageTemplate", function () { return $1347c41e99733ac2$export$cb83217e8e23e82; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $4ktyF = parcelRequire("4ktyF");

var $lHB9W = parcelRequire("lHB9W");

var $3FBn4 = parcelRequire("3FBn4");
parcelRequire("bJo35");
var $28Etm = parcelRequire("28Etm");
parcelRequire("gDqhU");
var $lTwyn = parcelRequire("lTwyn");
parcelRequire("3gB8p");
var $8tITR = parcelRequire("8tITR");
parcelRequire("bnSCE");
var $6sYN8 = parcelRequire("6sYN8");

var $cP0Yq = parcelRequire("cP0Yq");

var $hKuvf = parcelRequire("hKuvf");

var $ibGVp = parcelRequire("ibGVp");

var $lrVTP = parcelRequire("lrVTP");

var $8jOop = parcelRequire("8jOop");

var $h6PiC = parcelRequire("h6PiC");
parcelRequire("eCYM9");
var $hQj9g = parcelRequire("hQj9g");

var $5DpJf = parcelRequire("5DpJf");

var $d8QZt = parcelRequire("d8QZt");

var $krNyQ = parcelRequire("krNyQ");

var $aUZ56 = parcelRequire("aUZ56");

var $7unTD = parcelRequire("7unTD");

var $3Wymx = parcelRequire("3Wymx");
const $1347c41e99733ac2$export$cb83217e8e23e82 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4ktyF.ContentNotFoundErrorBoundary), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)($1347c41e99733ac2$var$AgileTutorialPageTemplateContent, {})
        })
    });
};
const $1347c41e99733ac2$var$AgileTutorialPageTemplateContent = ()=>{
    const agileTutorialData = (0, $8jOop.useAgileTutorial)();
    if (!agileTutorialData) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)($1347c41e99733ac2$export$a5672212085745d8, (0, $7Knp0._)({}, agileTutorialData));
};
const $1347c41e99733ac2$export$a5672212085745d8 = (_param)=>{
    var { title: title, subtitle: subtitle, author: author, tutorialBanner: tutorialBanner, nextBestAction: nextBestAction, tutorialIntroduction: tutorialIntroduction } = _param, props = (0, $akGnX._)(_param, [
        "title",
        "subtitle",
        "author",
        "tutorialBanner",
        "nextBestAction",
        "tutorialIntroduction"
    ]);
    var _props_beforeYouBegin, _props_tutorialInstructions, _props_tutorialInstructions__tutorialInstructionSteps, _props_tutorialInstructions_, _author_authorPicture, _author_authorPicture1;
    const intl = (0, $f6qj2.default)();
    const location = (0, $lrVTP.useLocation)();
    const origin = "https://www.atlassian.com";
    const link = `${origin}${location.pathname}`;
    (0, $lHB9W.expectContent)(title, "No tutorial data found");
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.default), {
                isShowTryNowLink: true,
                tryNowLinkCtaUrl: (0, $3FBn4.useLocalizedHref)("/try/cloud/signup"),
                tryNowLinkCtaButtonColor: "blue",
                productKey: "agile"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $hKuvf.default), {
                selectedNavLink: "agile"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $h6PiC.AgileBreadcrumbs), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $lTwyn.AgileHeading), {
                title: title,
                eyebrow: intl.formatMessage({
                    id: "agile.tutorial.heading.eyebrow",
                    defaultMessage: "Tutorial"
                }),
                description: subtitle,
                author: author,
                imageUrl: tutorialBanner === null || tutorialBanner === void 0 ? void 0 : tutorialBanner.url
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $8tITR.AgilePageLayout), {
                productDiscussedCta: props.productDiscussedCta,
                relatedTemplateCta: props.relatedTemplateCta,
                children: [
                    props.tutorialSummary && /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        text: props.tutorialSummary,
                        name: null
                    }),
                    (tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.length) && tutorialIntroduction.map((data, idx)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hQj9g.AgileIntroduction), {
                                heading: data.tutorialIntroductionName,
                                description: data.tutorialIntroductionDetails
                            })
                        }, idx)),
                    ((_props_beforeYouBegin = props.beforeYouBegin) === null || _props_beforeYouBegin === void 0 ? void 0 : _props_beforeYouBegin.length) && props.beforeYouBegin.map((data, idx)=>/*#__PURE__*/ (0, $iSvIT.createElement)((0, $5DpJf.BeforeYouBegin), (0, $6iHNw._)((0, $7Knp0._)({}, data), {
                            key: data.beforeYouBeginTitle || idx
                        }))),
                    ((_props_tutorialInstructions = props.tutorialInstructions) === null || _props_tutorialInstructions === void 0 ? void 0 : _props_tutorialInstructions.length) && ((_props_tutorialInstructions_ = props.tutorialInstructions[0]) === null || _props_tutorialInstructions_ === void 0 ? void 0 : (_props_tutorialInstructions__tutorialInstructionSteps = _props_tutorialInstructions_.tutorialInstructionSteps) === null || _props_tutorialInstructions__tutorialInstructionSteps === void 0 ? void 0 : _props_tutorialInstructions__tutorialInstructionSteps.map((data, idx)=>/*#__PURE__*/ {
                        var _data_tutorialUseStepTitle;
                        return (0, $loA2J.jsx)("div", {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aUZ56.BodyTextContainer), {
                                name: (_data_tutorialUseStepTitle = data.tutorialUseStepTitle) !== null && _data_tutorialUseStepTitle !== void 0 ? _data_tutorialUseStepTitle : "",
                                contentComponents: data.tutorialBodyTextContainer
                            })
                        }, idx);
                    })),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $6sYN8.ArticleShare), {
                        description: props.description,
                        title: title,
                        link: link
                    }),
                    author && /*#__PURE__*/ (0, $loA2J.jsx)((0, $d8QZt.AgileAuthor), {
                        name: author.name,
                        biography: author.shortBiography,
                        pictureSrc: (_author_authorPicture = author.authorPicture) === null || _author_authorPicture === void 0 ? void 0 : _author_authorPicture.url,
                        contentType: (_author_authorPicture1 = author.authorPicture) === null || _author_authorPicture1 === void 0 ? void 0 : _author_authorPicture1.contentType
                    })
                ]
            }),
            nextBestAction && nextBestAction.length && /*#__PURE__*/ (0, $loA2J.jsx)((0, $7unTD.NavigationCards), {
                cardsData: nextBestAction
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $3Wymx.ShareUpNextBar), {
                nodes: (0, $ibGVp.useAgileHubPageTreeData)(),
                title: title,
                description: props.description
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $28Etm.AgileFooter), {})
        ]
    });
};

});
parcelRegister("8jOop", function(module, exports) {

$parcel$export(module.exports, "AgileTutorialProvider", function () { return $4c197ed8003c8f32$export$5b6bc69cc0cfd36f; });
$parcel$export(module.exports, "useAgileTutorial", function () { return $4c197ed8003c8f32$export$6fcc1c5b95c7a022; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $1qD46 = parcelRequire("1qD46");

var $gpl9P = parcelRequire("gpl9P");

var $goGkF = parcelRequire("goGkF");
const $4c197ed8003c8f32$export$8a581789f2930e3c = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $4c197ed8003c8f32$var$useAgileTutorialContextValue = (tutorial)=>{
    const [contextValue, setContextValue] = (0, $iSvIT.useState)(tutorial);
    (0, $iSvIT.useEffect)(()=>{
        const fetchAgileTutorialFromClient = async ()=>{
            const client = new (0, $gpl9P.AGGClient)({
                gatewayUrl: "https://www.atlassian.com/gateway/api/graphql"
            });
            const { route: route, locale: locale } = (0, $1qD46.getCurrentRoute)();
            const agileTutorial = await (0, $goGkF.getTemplateData)(route, locale, client);
            setContextValue(agileTutorial);
        };
        if (!contextValue) fetchAgileTutorialFromClient();
    // empty dependency array so this effect only runs once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return contextValue;
};
const $4c197ed8003c8f32$export$5b6bc69cc0cfd36f = (props)=>{
    const value = $4c197ed8003c8f32$var$useAgileTutorialContextValue(props.tutorial);
    return /*#__PURE__*/ (0, $loA2J.jsx)($4c197ed8003c8f32$export$8a581789f2930e3c.Provider, {
        value: value,
        children: props.children
    });
};
const $4c197ed8003c8f32$export$6fcc1c5b95c7a022 = ()=>{
    const tutorial = (0, $iSvIT.useContext)($4c197ed8003c8f32$export$8a581789f2930e3c);
    if (!tutorial) console.warn("SSR failed to fetch content on the server. Fetching content on the client.");
    return tutorial;
};

});

parcelRegister("5DpJf", function(module, exports) {

$parcel$export(module.exports, "BeforeYouBegin", function () { return $1f27ad1f91d84b91$export$750aa447cfb7bc73; });
/* before-you-begin.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $91nJf = parcelRequire("91nJf");
parcelRequire("dyrzP");
var $9Kv7x = parcelRequire("9Kv7x");

var $jUNbR = parcelRequire("jUNbR");

var $3FBn4 = parcelRequire("3FBn4");

var $krNyQ = parcelRequire("krNyQ");

var $1VLtH = parcelRequire("1VLtH");
const $1f27ad1f91d84b91$var$BeforeYouBeginButton = ({ url: url, text: text })=>{
    const localized = (0, $3FBn4.useLocalizedHref)(url);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
        variant: "primary",
        href: localized,
        className: (0, $esG4f.default)([
            "_1mou10yf"
        ]),
        children: text
    });
};
const $1f27ad1f91d84b91$var$CoreContent = ({ time: time, audience: audience, prerequisite: prerequisite, ctaMicrocopy: ctaMicrocopy })=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            time && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("b", {
                            children: intl.formatMessage({
                                id: "agile.hub.before-you-begin.time",
                                defaultMessage: "Time:"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        children: time
                    })
                ]
            }),
            audience && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("b", {
                            children: intl.formatMessage({
                                id: "agile.hub.before-you-begin.audience",
                                defaultMessage: "Audience:"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        text: audience,
                        name: null
                    })
                ]
            }),
            prerequisite && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("b", {
                            children: intl.formatMessage({
                                id: "agile.hub.before-you-begin.prerequisite",
                                defaultMessage: "Prerequisite:"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        text: prerequisite,
                        name: null
                    })
                ]
            }),
            (ctaMicrocopy === null || ctaMicrocopy === void 0 ? void 0 : ctaMicrocopy.ctaUrl) && (ctaMicrocopy === null || ctaMicrocopy === void 0 ? void 0 : ctaMicrocopy.ctaButtonText) && /*#__PURE__*/ (0, $loA2J.jsx)($1f27ad1f91d84b91$var$BeforeYouBeginButton, {
                url: ctaMicrocopy.ctaUrl,
                text: ctaMicrocopy.ctaButtonText
            })
        ]
    });
};
const $1f27ad1f91d84b91$var$containerStyles = null;
const $1f27ad1f91d84b91$export$750aa447cfb7bc73 = (_param)=>{
    var { relatedAsset: relatedAsset, relatedQuestions: relatedQuestions } = _param, props = (0, $akGnX._)(_param, [
        "relatedAsset",
        "relatedQuestions"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c11p5 _zulpviql _6rthviql"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jUNbR.InfoText), {
                hideIcon: true,
                type: "component",
                children: /*#__PURE__*/ (0, $loA2J.jsx)($1f27ad1f91d84b91$var$CoreContent, (0, $7Knp0._)({}, props))
            }),
            relatedAsset && /*#__PURE__*/ (0, $loA2J.jsx)((0, $9Kv7x.ContentPlatformImage), {
                src: relatedAsset.url,
                alt: relatedAsset.description,
                contentType: relatedAsset.contentType,
                baseWidth: 728,
                width: relatedAsset.width,
                height: relatedAsset.height,
                style: {
                    maxWidth: "100%"
                }
            }),
            relatedQuestions && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1VLtH.QuestionComponent), (0, $7Knp0._)({}, relatedQuestions))
        ]
    });
};

});




parcelRegister("5asZh", function(module, exports) {

$parcel$export(module.exports, "BuyCloudOrgSetupPage", function () { return $b0dc0b15608b03f6$export$4e76f99368941eb8; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("fK0JH");
var $69E0c = parcelRequire("69E0c");
const $b0dc0b15608b03f6$export$4e76f99368941eb8 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $69E0c.BuyCloudOrgSetupPageTemplate), {});

});
parcelRegister("fK0JH", function(module, exports) {
$parcel$export(module.exports, "BuyCloudOrgSetupPageTemplate", function () { return (parcelRequire("69E0c")).BuyCloudOrgSetupPageTemplate; });

var $69E0c = parcelRequire("69E0c");

});
parcelRegister("69E0c", function(module, exports) {

$parcel$export(module.exports, "BuyCloudOrgSetupPageTemplate", function () { return $433a9e82b7be5b52$export$61ed6150ce1cf26a; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $4KDmv = parcelRequire("4KDmv");

const $433a9e82b7be5b52$var$DirectBuyOrgSetupContainer = /*#__PURE__*/ (0, $iSvIT.lazy)(()=>// @ts-ignore
    (parcelRequire("cUfNq")));
const $433a9e82b7be5b52$export$61ed6150ce1cf26a = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4KDmv.ClientOnly), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)($433a9e82b7be5b52$var$DirectBuyOrgSetupContainer, {})
    });
};

});
parcelRegister("cUfNq", function(module, exports) {




















module.exports = Promise.all([
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("7ZpLH")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("ikpVv")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("ePCGr")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("9o0nb")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("8KBcn")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("9qK5W")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("1z79P")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("WEkDC")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("51okE")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("ilNeS"))
]).then(()=>parcelRequire("lAXMS"));

});
parcelRegister("frKV3", function(module, exports) {
"use strict";

var $jhlcP = parcelRequire("jhlcP");
module.exports = $jhlcP(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(("" + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement("script");
        script.async = true;
        script.type = "module";
        script.charset = "utf-8";
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("jhlcP", function(module, exports) {
"use strict";
var $039f3a07df33262a$var$cachedBundles = {};
var $039f3a07df33262a$var$cachedPreloads = {};
var $039f3a07df33262a$var$cachedPrefetches = {};
function $039f3a07df33262a$var$getCache(type) {
    switch(type){
        case "preload":
            return $039f3a07df33262a$var$cachedPreloads;
        case "prefetch":
            return $039f3a07df33262a$var$cachedPrefetches;
        default:
            return $039f3a07df33262a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $039f3a07df33262a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});






parcelRegister("3vHgs", function(module, exports) {

$parcel$export(module.exports, "BuyCloudPostOrderProvisioningPage", function () { return $f3d356f088ef388a$export$a5f8b599017bd5cd; });

var $loA2J = parcelRequire("loA2J");

var $bAifl = parcelRequire("bAifl");
const $f3d356f088ef388a$export$a5f8b599017bd5cd = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $bAifl.BuyCloudPostOrderProvisioningPageTemplate), {});

});

parcelRegister("eyRtN", function(module, exports) {

$parcel$export(module.exports, "BuyCloudSiteSetupPage", function () { return $31b5c3b1dbf18c26$export$4febe9f853354faf; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("7hsl5");
var $9Bvyy = parcelRequire("9Bvyy");
const $31b5c3b1dbf18c26$export$4febe9f853354faf = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $9Bvyy.BuyCloudSiteSetupPageTemplate), {});

});
parcelRegister("7hsl5", function(module, exports) {
$parcel$export(module.exports, "BuyCloudSiteSetupPageTemplate", function () { return (parcelRequire("9Bvyy")).BuyCloudSiteSetupPageTemplate; });

var $9Bvyy = parcelRequire("9Bvyy");

});
parcelRegister("9Bvyy", function(module, exports) {

$parcel$export(module.exports, "BuyCloudSiteSetupPageTemplate", function () { return $43424054f365dd7c$export$17d9bc116915a14; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $4KDmv = parcelRequire("4KDmv");

const $43424054f365dd7c$var$DirectBuySiteSetupContainer = /*#__PURE__*/ (0, $iSvIT.lazy)(()=>// @ts-ignore
    (parcelRequire("5M2Zd")));
const $43424054f365dd7c$export$17d9bc116915a14 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4KDmv.ClientOnly), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)($43424054f365dd7c$var$DirectBuySiteSetupContainer, {})
    });
};

});
parcelRegister("5M2Zd", function(module, exports) {




















module.exports = Promise.all([
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("7ZpLH")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("ikpVv")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("ePCGr")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("9o0nb")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("8KBcn")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("9qK5W")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("1z79P")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("WEkDC")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("51okE")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("fHb5q"))
]).then(()=>parcelRequire("eyfo2"));

});




parcelRegister("dgztS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac98e24d1e602069$export$2e2bcd8739ae039; });
/* cdn-library.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $4XrxY = parcelRequire("4XrxY");

var $bbRMU = parcelRequire("bbRMU");
const $ac98e24d1e602069$var$CDNLibrary = ()=>{
    var _window;
    const [bgColor, setBgColor] = (0, $iSvIT.useState)("#f0f0f0"); // Redirect to the homepage if the page is accessed from atlassian.com
    if (((_window = window) === null || _window === void 0 ? void 0 : _window.location.hostname) === "atlassian.com") window.location.href = "/";
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_ca0q1wto _u5f3idpf _n3td1wto _19bvidpf _1tke1kxc _bfhkbs0x"
        ]),
        style: {
            "--_1w9snyi": (0, $43MIc.default)(bgColor)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.TypographyStyles), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_kqsw1n9t _152tidpf _1e0c1txw _1bah1yb4 _zulp1wto _ca0qviql _u5f3viql _n3tdviql _19bvviql _1bsb1osq _16qsd8sd _bfhkbs0x"
                    ]),
                    style: {
                        "--_1w9snyi": (0, $43MIc.default)(bgColor)
                    },
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                            type: "color",
                            value: bgColor,
                            onChange: (e)=>setBgColor(e.target.value),
                            title: "Change background color of the page"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("b", {
                                        children: "Last updated:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    children: new Date((0, $bbRMU.lastUpdated)).toLocaleString()
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    children: $ac98e24d1e602069$var$calculateHowLongAgo(new Date((0, $bbRMU.lastUpdated)))
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1q51webb _rzby1wto _8k2z1wug _nd4uidpf _9u9n1wug _iowe1h6o"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                                children: "WAC-WEB CDN Library"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                className: (0, $esG4f.default)([
                                    "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1ogm _y3gn1h6o"
                                ]),
                                children: "These are the asset files uploaded to the WAC CDN. Search, filter, and copy the URL of the asset you are looking for quick and easy."
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _2lx21bp4 _zulpviql _19pk1wto _2hwxidpf _otyr1wto _18u0idpf"
                                ]),
                                children: (0, $bbRMU.cdnLibraryData).map((section)=>/*#__PURE__*/ (0, $loA2J.jsx)($ac98e24d1e602069$var$DirectorySection, {
                                        directory: section.directory,
                                        files: section.files
                                    }, section.directory))
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $ac98e24d1e602069$var$DirectorySection = ({ directory: directory, files: files })=>{
    const [showFiles, setShowFiles] = (0, $iSvIT.useState)(false);
    const [filter, setFilter] = (0, $iSvIT.useState)("");
    const filteredFiles = files.filter((file)=>file.includes(filter));
    if (files.length === 0) return null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _4cvr1h6o _6a6z1e5h _yv0ek13l _zulpviql _1n461j6v _if5y1j6v _1gnp1j6v _7e5b1j6v _cq5utlke"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        children: directory
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("label", {
                        htmlFor: directory + "show",
                        className: (0, $esG4f.default)([
                            "_80omtlke"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                                id: directory + "show",
                                type: "checkbox",
                                checked: showFiles,
                                onChange: ()=>setShowFiles((prev)=>!prev)
                            }),
                            "Show ",
                            files.length === 1 ? "file" : "files",
                            " (",
                            filteredFiles.length,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("label", {
                        htmlFor: directory + "filter",
                        children: [
                            "Filter:",
                            " ",
                            /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                                id: directory + "filter",
                                type: "text",
                                value: filter,
                                onChange: (e)=>setFilter(e.target.value)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1vyd _2lx21bp4 _zulpviql"
                ]),
                style: {
                    "--_1dd9cxe": (0, $43MIc.default)(showFiles ? "flex" : "none")
                },
                children: filteredFiles.map((file)=>/*#__PURE__*/ (0, $loA2J.jsx)($ac98e24d1e602069$var$FilePreview, {
                        file: file
                    }, file))
            })
        ]
    });
};
const $ac98e24d1e602069$var$FilePreview = ({ file: file })=>{
    const copyToClipboard = ()=>{
        navigator.clipboard.writeText(file);
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _4cvrv2br _6a6zv2br _zulp1j6v _19pkidpf _2hwxviql _otyridpf _18u0viql _bozg1j6v _191w1qv1 _43ds13q2"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _zulpviql"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                onClick: copyToClipboard,
                                title: "Save to clipboard",
                                children: "COPY URL"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                href: file,
                                target: "_blank",
                                rel: "noreferrer",
                                children: "OPEN IN NEW TAB"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        children: file
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_p12f1kdj _mezj1osq _1y2k1osq _rtys1osq _26rc1osq _19l31osq _1ghp1osq"
                ]),
                children: [
                    $ac98e24d1e602069$var$isVideo(file) && // Tech debt: Adding this disable to unblock commits for GWP-2646
                    // eslint-disable-next-line jsx-a11y/media-has-caption
                    /*#__PURE__*/ (0, $loA2J.jsx)("video", {
                        src: file,
                        controls: true
                    }),
                    $ac98e24d1e602069$var$isImage(file) && /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                        src: file,
                        alt: file,
                        loading: "lazy"
                    })
                ]
            })
        ]
    });
};
const $ac98e24d1e602069$var$isVideo = (file)=>{
    return file.endsWith(".mp4") || file.endsWith(".webm");
};
const $ac98e24d1e602069$var$isImage = (file)=>{
    return file.endsWith(".svg") || file.endsWith(".webp") || file.endsWith(".png") || file.endsWith(".jpg") || file.endsWith(".jpeg") || file.endsWith(".gif");
};
const $ac98e24d1e602069$var$calculateHowLongAgo = (datePast)=>{
    // Calculate the difference between now and the datePast
    const difference = new Date().getTime() - datePast.getTime(); // Convert difference into days, hours, and minutes
    const daysDifference = Math.floor(difference / 86400000);
    const hoursDifference = Math.floor(difference % 86400000 / 3600000);
    const minutesDifference = Math.floor(difference % 3600000 / 60000); // Construct the output string
    let result = "";
    if (daysDifference > 0) result += daysDifference + " day" + (daysDifference > 1 ? "s" : "");
    if (daysDifference > 0 && hoursDifference > 0) result += ", ";
    if (hoursDifference > 0) result += hoursDifference + " hour" + (hoursDifference > 1 ? "s" : "");
    if (hoursDifference > 0 && minutesDifference > 0) result += ", and ";
    if (minutesDifference > 0) result += minutesDifference + " minute" + (minutesDifference > 1 ? "s" : "");
    return result + " ago";
};
var $ac98e24d1e602069$export$2e2bcd8739ae039 = $ac98e24d1e602069$var$CDNLibrary;

});
parcelRegister("bbRMU", function(module, exports) {

$parcel$export(module.exports, "lastUpdated", function () { return $6be48186f17336a8$export$c60d1a715a48771d; });
$parcel$export(module.exports, "cdnLibraryData", function () { return $6be48186f17336a8$export$48209f5fd1d7ca21; });
// This file is auto-generated by the script generate-cdn-library-data.mjs
const $6be48186f17336a8$export$c60d1a715a48771d = "2024-04-20T06:39:46.627Z";
const $6be48186f17336a8$export$48209f5fd1d7ca21 = [
    {
        directory: "download/",
        files: []
    },
    {
        directory: "keynote/",
        files: []
    },
    {
        directory: "keyword-cluster/",
        files: []
    },
    {
        directory: "mp4-animations/",
        files: [
            "https://wac-cdn.atlassian.com/misc-assets/mp4-animations/jira-hero-wac-animation.mp4"
        ]
    },
    {
        directory: "optimizely/",
        files: []
    },
    {
        directory: "pdfs/",
        files: [
            "https://wac-cdn.atlassian.com/misc-assets/pdfs/CSD-10312_France_Gender_Equity_Disclosure-FY24_Q3.pdf"
        ]
    },
    {
        directory: "svgs/",
        files: [
            "https://wac-cdn.atlassian.com/misc-assets/svgs/audi-n50.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/avocado.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/beacon-blue.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/beacon-hero.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/beacon-white.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/bitbucket-blue.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/blue-wave-background.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/canva-n50.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/code-aws-devops.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/code-aws-jsw.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/compass-hero.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence-blue.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence-hero.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence-social-proof-reel.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence-whiteboards-logo-lockup-blue.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence-whiteboards-logo-lockup.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/crowd.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/devops-background.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/devops-v2-left-optimized.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/envelope-n2n.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/figma.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/google-drive-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/google-drive.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jira-core-hero.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jira-hero.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jira-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jira-ops-blue-rgb.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jira-product-discovery-logo-blue.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jira-service-management-logo-gradient-blue.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jira-software-blue.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jira-software-white.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jira-work-management-logo-gradient-blue.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jira.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jpd-firstimpression-hero.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jpd-white.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jsd-hero.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jsd-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jsm-social-proof-reel.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jsw-social-proof-reel.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jwm-social-proof-reel.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/logo-gradient-blue-compass.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/loom.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/loom_beam_color.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/menu.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/microsoft-teams.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/ms-teams.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/opsgenie-blue-rgb.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/slack-icon-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/slack.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/ss-atlassian-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/ss-jsw-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/statuspage-blue.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/statuspage-white.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/success-n2e.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/team-central-beta-color.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/team-central-beta-white.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/team-central-hero.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/tempo-logo-white.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/tempo-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/trello-icon-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/trello-logo.svg"
        ]
    },
    {
        directory: "test-svgs/",
        files: []
    },
    {
        directory: "testreplica/",
        files: []
    },
    {
        directory: "videos/",
        files: []
    },
    {
        directory: "webp-images/",
        files: [
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/001 Plan-1878220112.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/002 Track-61709455.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/003 Collab-1370881390.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/004 Launch-3779179643.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/005 Report-161454665.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/10C-Logo-Nextiva1.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/10C-Logo-Nextiva@2x 1.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/5_New%20Mobile@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/9D-Logo-Lufthansa-Systems.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/9D-Logo-Lufthansa-Systems_l.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ADD_DARK_MODE@2x_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ADD_DARK_MODE@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ADD_DARK_MODE@2x_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ADD_DARK_MODE@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/AUTO_LOAD_BALANCE@2x_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/AUTO_LOAD_BALANCE@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/AUTO_LOAD_BALANCE@2x_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/AUTO_LOAD_BALANCE@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Air_Canada-logo-n0.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Announcement_Banner.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Archived_Page.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Arvato Systems-4222291387.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Atlassian-Intelligence-icon.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Atlassian-intelligence.webm",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Atlassian_DHCS_Ryan_Alpha-1206744447.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Atlassian_Presents_Unleash_logo_banner.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Automation.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Automation_Triggers.1353.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Automation_Triggers.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/BANC.LY-SUPPORT@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/BANC.LY_SUPPORT@2x_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/BANC.LY_SUPPORT@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/BANC.LY_SUPPORT@2x_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/BANC.LY_SUPPORT@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/BG-Hero-1440-left.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/BG-Hero-1440-right.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/BG-Hero-768-right.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/BG-dot_filled_circle.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Backlog.1353.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Blog_360x265@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Blue%20Best%20Practices@4x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Blue%20Demo%20Video@4x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Blue%20Use%20Cases@4x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Board-with-nav-collapsed.1353.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Board.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Bulk_archiving.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CE_-_Macros__@1x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CE_-_Page_versioning__@1x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CE_-_Unlimited_spaces__@1x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ AI-3298633667.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ AI_LowBR.mp4",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ Confluence-2040505915.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ Confluence_LowBR.mp4",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ JPD-286968629.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ JPD_LowBR.mp4",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ JSM-3020245023.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ JSM_LowBR.mp4",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ Loom-791474346.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ Loom_LowBR.mp4",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_A_HD (0-00-00-00)-4060786602.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_A_LowBR.mp4",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_A_LowBR.webm",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_B_HD (0-00-09-24)-1969559334.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_B_LowBR.mp4",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_B_LowBR.webm",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_C_HD (0-00-16-35)-1443600009.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_C_LowBR.mp4",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_C_LowBR.webm",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_FULL_LowBR.mp4",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_FULL_LowBR.webm",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Jira-4003614779.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Jira_LowBR.mp4",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204 project north star plan@2x.webp-2125193628.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204-Templates-screen@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204-cta-left.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204-cta-right.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204-hero-left-side.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204-hero-right-side.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_Break_down_information_silos@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_Employee_Resource_hub@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_Get_on_the_same_page@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_Templates_screen@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_Weekly_status@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_Your_entire_team_on_one_platform@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_project_north_star_plan@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_project_overview@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-8431-FY24-Team-24-Animated-Website-Hero_v03.webm",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ClearwaterAnalytics-823945256.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Community@2x-3332122863.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Community@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CommunityMobile_360x235@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Conf_ProductTour_BlueBestPractices.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Conf_ProductTour_BlueDemoVideo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Conf_ProductTour_BlueUseCases.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Conf_ProductTour_Hero.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Conf_ProductTour_Mobile.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Conf_ProductTour_Thumbnail.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Confluence%20PT%20thumbnail@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Confluence@2x-blue.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_(1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_deDE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_frFR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_ptBR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_deDE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_frFR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_ptBR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_(1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_deDE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_frFR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_ptBR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Collaboration.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_(1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_deDE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_frFR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_ptBR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_SourceOfTruth.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Templates.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_BusinessPlan.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_BusinessPlan_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_BusinessPlan_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_BusinessPlan_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_BusinessPlan_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Marketing.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Marketing_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Marketing_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Marketing_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Marketing_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Product.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_ProductJA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_ProductPT.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Product_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Product_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Productivity-revised.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Productivity-revisedJA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Productivity-revisedPT.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Productivity-revised_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Productivity-revised_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Project.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_ProjectJA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_ProjectPT.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Project_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Project_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Advanced%20search%201.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Advanced_search.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Advanced_search_1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Integration.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_KnowledgeMangement.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Real%20time%20Editing%201.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Real_time_Editing.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Real_time_Editing_1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Wiki.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Wiki-961320203.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Wiki_deDE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Wiki_frFR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Wiki_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Wiki_ptBR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Confluence_AI.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Copy_Space_Permissions-optimized.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/DESIGN_TEAMS@2x-de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/DESIGN_TEAMS@2x-ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/DESIGN_TEAMS@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/DESIGN_TEAMS@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/DESIGN_TEAMS@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/DHCS-1703508494.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Dektop_TL@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Dependency-management.1353.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Desktop_BL-2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Desktop_BR-2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Desktop_TR-2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Doodle-3562754075.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/DropBox-4186472046.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Endenred-734004069.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Engineering_team.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Ent%20sign-responsive.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/FLO_logo_horizontal_white%201.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/FUN@2x-de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/FUN@2x-ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/FUN@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/FUN@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/FUN@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Frame 1010105996-1698270861.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GW-1212_ds_jsm_bancly_help_center2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-dark-sectionbg.png",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-dark-sectionbg.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-dark-sectionbg2.png",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-dark-sectionbg2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-dark-sectionbg3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-footerbg.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-mobile-workflow-diagram.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-tab-bg2-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-tab-bg2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-tab-bg3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-tablet-footerbg.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1212-unlock-collaboration-2790x1554.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1212_Incident_issue_view_jsm.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1212_it_ops_tab.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1212_jsm_bancly_help_center2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1212_service_management_screenshot.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Group 6273011-2525946013.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Group 6273205-1701574714.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Group 6273206-2473828409.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Group 6273207-554690744.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Guest_markers_in_product.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/HERO_ROADMAPS@2x-de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/HERO_ROADMAPS@2x-ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/HERO_ROADMAPS@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/HERO_ROADMAPS@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/HERO_ROADMAPS@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/HR_team.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/IP_allowlist.1353.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ITSM-1400.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Impossible-Alone-Video-Header-Image-@2X%202.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Impossible-Alone-Video-Header-Image-smile.webp-647850140.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Impossible-Alone-Video-Header-Image.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Insights.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Inspect_Perms-optimized.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JA sign-responsive.webp-1988963931.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JA%20sign-responsive.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JPD_screen_framed.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM + topics.png",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSMJiraprovisioning.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_AI.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_BG%20Graphics.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_CTA Background.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_CTA%20Background.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DeliverFast.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DeliverFast_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DeliverFast_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DeliverFast_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DeliverFast_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DevOps.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DevOps_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DevOps_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DevOps_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DevOps_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Automation.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Automation_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Automation_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Automation_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Automation_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_ITIL.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_ITIL_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_ITIL_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_ITIL_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_ITIL_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Knowledge.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Knowledge_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Knowledge_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Knowledge_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Knowledge_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_SLA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_SLA_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_SLA_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_SLA_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_SLA_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Change.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Change_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Change_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Change_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Change_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Configuration.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Configuration_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Configuration_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Configuration_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Configuration_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_DynamicForms.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_DynamicForms_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_DynamicForms_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_DynamicForms_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_DynamicForms_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Incident.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Incident_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Incident_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Incident_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Incident_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Integrations.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Integrations_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Integrations_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Integrations_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Integrations_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Problem.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Problem_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Problem_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Problem_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Problem_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Request.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Request_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Request_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Request_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Request_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_SelfService.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_SelfService_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_SelfService_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_SelfService_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_SelfService_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_ServiceDesk.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_ServiceDesk_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_ServiceDesk_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_ServiceDesk_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_ServiceDesk_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_MakeVisible.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_MakeVisible_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_MakeVisible_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_MakeVisible_ja_JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_MakeVisible_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW%20free-responsive.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW%20sign-responsive.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_AI.1353.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Automation.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Automation_br.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Automation_de.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Automation_en.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Automation_fr.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Automation_ja.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Backlog_x2%202.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Backlog_x2_2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Backlog_x2_2_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Backlog_x2_2_pt-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Backlog_x2_2_pt-de.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Backlog_x2_2pt-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Blue_Grid.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_br.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_de.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_en.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_fr.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_ja.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bug_Tracking.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_br.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_de.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_en.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_fr.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_ja.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Capacity.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Capacity_deDE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Capacity_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Capacity_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Capacity_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Forecast.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Forecast_deDE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Forecast_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Forecast_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Forecast_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Goals_deDE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Goals_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Goals_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Goals_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Kanban.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ProductTour_DarkModeIllustration_BugTracking_Spot.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ProductTour_DarkModeIllustration_Hero.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ProductTour_DarkModeIllustration_Wave.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ProductTour_DarkModeIllustration_Workflow.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ProductTour_PromoBannerGeo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Reports.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ReportsInsights_2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ReportsInsights_2_deDE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ReportsInsights_2_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ReportsInsights_2_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ReportsInsights_2_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Reports_br.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Reports_de.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Reports_en.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Reports_fr.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Reports_ja.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Roadmaps_br.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Roadmaps_ja.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_SingleSource.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_SingleSource_deDE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_SingleSource_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_SingleSource_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_SingleSource_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Visualization.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Visualization_deDE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Visualization_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Visualization_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Visualization_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JWM.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-Board-Software-3233077719.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-Calendar-Marketing-4146978900.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-List-Design-1069502226.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-On-call-IT-3030871761.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-Timeline-Product Management-3301759489.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-Timeline-Project Management-2679766879.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JiraConfluenceprovisioning.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JiraJSMProvisioning.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Joe Cotant Roblox-2296603445.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_ES.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_JA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_RU.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_ptBR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Kiva-1702957319.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Lang_support@1x-from-@harry.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Logo-wall-left-2221824116.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Logo-wall-right-3214451279.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Lumen-381040365.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/MARKETING_CALENDAR@2x-de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/MARKETING_CALENDAR@2x-ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/MARKETING_CALENDAR@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/MARKETING_CALENDAR@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/MARKETING_CALENDAR@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Marketing_team.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/MehmetSari-4103257443.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/MercedesBenz-357676847.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Microsoft-teams-logo-1526817987.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Microsoft_Teams_Logo_2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Miro-logo-3117227469.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/MissionControl.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Mobile_B-2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Mobile_T@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Networking_people_spot@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/OPEN-INCIDENTS@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/OPEN_INCIDENTS@2x_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/OPEN_INCIDENTS@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/OPEN_INCIDENTS@2x_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/OPEN_INCIDENTS@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/OPERATIONS@2x-de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/OPERATIONS@2x-ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/OPERATIONS@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/OPERATIONS@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/OPERATIONS@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Octicons-cloud-download.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Overview_issue_hiearchy.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-01.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-02.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-03.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-04.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-07.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-11.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-13.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-01.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-02.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-03.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-04.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-07.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-11.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-13.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-01.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-02.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-03.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-04.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-07.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-13.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-01.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-02.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-03.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-04.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-07.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-11.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-13.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/POS-system.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PRODUCT_TEAMS@2x-de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PRODUCT_TEAMS@2x-ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PRODUCT_TEAMS@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PRODUCT_TEAMS@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PRODUCT_TEAMS@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Pasted Graphic-2395339363.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Prem%20sign-responsive.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Premium_feature_-_site_analytics-2X_2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Product_Management.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Product_team.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/QMetry-logo-978966706.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/RTR_logo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Releases.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Roblox Interview Joe Cotant + Alpha-1942757731.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Roblox-3121607094.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/RobloxJoeCotant-1985850389.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Round 5.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/RoyalCaribbean-2310931816.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Rule-builder-component_list-2x_.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SERVICE_CENTER@2x_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SERVICE_CENTER@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SERVICE_CENTER@2x_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SERVICE_CENTER@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SOFTWARE_TEAMS@2x-ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SOFTWARE_TEAMS@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SOFTWARE_TEAMS@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SOFTWARE_TEAMS@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SUBTASKS@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SUBTASKS@2x_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SUBTASKS@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SUBTASKS@2x_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SUBTASKS@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen%20Shot%202023-01-05%20at%203.48%201.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights%20JA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_ES.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_JA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_RU.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-kanban_board@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-scrum_board@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_ES.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_JA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_RU.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_ptBR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Social%20Unleash%20193x122.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Software AG-2524322619.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SonyMusic-3191867672.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Spotify_Logo-N0.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Stars.webp-347416437.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/StephanieLeue_CPO_Doodle-2892442182.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Structured_page_tree__@1x_(2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TEAM_ANALYTICS@2x_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TEAM_ANALYTICS@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TEAM_ANALYTICS@2x_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TEAM_ANALYTICS@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TEMPLATES_de-DE@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TEMPLATES_fr-FR@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TEMPLATES_ja-JP@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TEMPLATES_pt-BR@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TOOLS@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TRACK_PROGRESS@2x-de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TRACK_PROGRESS@2x-ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TRACK_PROGRESS@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TRACK_PROGRESS@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TRACK_PROGRESS@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Team%20Playbook_360x265@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Team-24-Animated-Website-Hero_Mobile_329x253.webm",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Team-Calendars.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Team-Logo-1786577449.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Team_Logo only_1200_628.webp-2037705328.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Team_Logo-1729653467.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Team_Logo.webp-1729653467.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Team_Logo_-977956.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Team_Logo_only_1200_628.webp-3936184367.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TheVeryGroup-1520026636.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Ticket_created@2x_1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Timeline.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/WaisRoyalCaribbean-4173208448.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/add-dark-mode.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/admin-insights.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/admin-key.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/advanced-roadmaps-timeline.1353.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/agile-reporting.1353.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-deeplink-atlassian-intelligence-logo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-deeplink-banner-background-mobile.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-deeplink-banner-background-tablet.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-deeplink-banner-background.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-img.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/air-table-3638621307.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-add-people-modal.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-automation-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-customer-service-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-customer-support-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-iress-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-open-cases-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-silverline-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-support-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-trouble-ticket-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_HR_support_screenshot.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_JSM_topics.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_automation_rule_jsm.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_automation_screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_business_team_support.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_change_details_jsm.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_facilities.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_facilities2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_incident_issue_view_jsm.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_jsm_cs.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_jsm_cs2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_jsm_features_dynamic_forms.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_project_templates.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_team_analytics_dashboard.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_topics_jsm.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/artboard-hand.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/artboard-stars.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/arvato-johannes-siebzehnrubl-2519619866.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/asana-363871342.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/aset-selection.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/assign-and-prioritize2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/assign-and-prioritize_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/assign-and-prioritize_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/assign-and-prioritize_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/assign-and-prioritize_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/astronaut.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/atlassian-unleash.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/audi-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/audit-logs.cdnVersion1351.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-rules.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-rules2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-rules_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-rules_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-rules_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string-ES.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string-JA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string-RU.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation2_1_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation2_1_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation2_1_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation2_1_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation2xpng.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automationscreen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/backing1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/backing2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/backing3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/backing4.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/balsamiq-1570513082.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bannerAlert_team24_bg_l.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bannerAlert_team24_bg_l_.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bannerAlert_team24_bg_l_with_lines.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bannerAlert_team24_bg_r.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bannerAlert_team24_bg_r_.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bannerAlert_team24_logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bannerAlert_team24_logo_.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bg_atl_cloud_hero_small.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bitbucketscreen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bitbucketscreen2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/blue-angle.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/blue-closing-angle.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bonobos-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/breakdownInfoSilos.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bring-visibility.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bucket_test.png",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bucket_test_2.png",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/canva-363018985.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/canva-logo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/canvalogo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/capacity-management.1354.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/cec1c0b14a8ceca297df71534fae13dd-481890245.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/check-green.1353.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/check-green.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/checkmark-paper-plane-illustration.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/choose_your_own_adventure_1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/choose_your_own_adventure_DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/choose_your_own_adventure_FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/choose_your_own_adventure_JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/choose_your_own_adventure_br.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/clearwater-analytics-erica-larson-783154932.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/closing-banner-graphic.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate-2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate-3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate-4.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate_1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate_2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate_3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate_4.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/community-bubble-icon-3561157108.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/con-onboard-invite.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/con-onboard-product-question-collaboration.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/con-onboard-product-question-default.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/con-onboard-product-question-knowledge-base.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/con-onboard-product-question-trying-out.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/con-onboard-team.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/con-onboard-template-background-2765676952.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence-create-a-page.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence-organize-your-work.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence-share-it-with-your-team.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluencelp-feature-collaboration.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluencelp-feature-documentation.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluencelp-feature-templates.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluencelp-templates-businessplan.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluencelp-templates-marketing.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluencelp-templates-product.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/construction.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/content_gif_v1.0.2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/create_issue_2_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/create_issue_2_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/create_issue_2_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/create_issue_2_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/create_issue_2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ctaLeft.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ctaRight.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/curved-arrow-icon-3497580723.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/customer service screen.webp-3113962215.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/customer-story-company-placeholder-mercedes-benz-3039099905.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/customer-story-company-placeholder-roblox-4173828533.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/customer-story-filter-icon-3367749555.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/customer-story-hero-asset-placeholder-mercedes-benz-1758178859.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/customer-story-person-placeholder-roblox-2783909767.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/customers-team24-hero-background.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/dark-shape.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/database-server-on-v3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/demo-deeny-fullcard1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/department-of-defense-n50.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/deploymentscreen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/desc.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/design-card-1-3753095941.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/design-card-2-1415836422.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/design-card-3-3083932167.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/design-main-2975787526.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/devOps_template_1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/devOps_template_DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/devOps_template_FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/devOps_template_JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/devOps_template_br.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/devops-diagram-compressed.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/devops-diagram-compressed.webp-1760218363.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/dhcs-ryan-mosley-4192898571.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/dhcs2-419927292.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/dhcsfigma-846763754.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/dhcsfigma2-303950232.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/dominos-n0.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/doodle-stephanie-leue-1192382875.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/doodle2-1344893385.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/doodlefigma-3413596895.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/double-feature-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/double-feature-2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/dropbox-damien-davis-3638188557.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/earf-high-res.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/earf.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/earf2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/earth-noise.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/edenred-razvan-nechifor-1301495753.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/emp-screen-campaign-management.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/emp-screen-content-management.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/emp-screen-customer-journey-mapping.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/emp-screen-go-to-market.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/emp-screen-kanban.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/emp-screen-roadmap.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/emp-screen-scrum.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/employeeResourcehub.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/empower-employees.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/empower1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/empower2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/empower3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/empower4.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/empower5.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-bars.webp-2356904232.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-data-center-icon-3736035258.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-graph.webp-3089236614.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-grid.webp-3189788274.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-quarter-circle.webp-2345858369.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprisetabContentImage-978864670.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/esm_templates.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/explore-apps-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/fabric-sign-up-hero-rev@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/feature-code-image-three.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/features-code-image-one.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/features-code-image-three.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/features-code-image-two.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/figma-363833302.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/figma-logo-4073520400.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/figma.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/file.webp-1703115956.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ford-n0.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/forresterfigma-3996254026.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/fullcard1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/fullcard2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/fullcard3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/fullcard4.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/gartnerfigma-4234034927.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/gartnerpeerinsightsfigma-3794251448.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/gestural-line.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/getOnTheSamePage.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/git-lab-204839338.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/github-3505995671.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/github-logo-1518537873.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-analytics-3286988256.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-docs-2740153165.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-docs-logo-950929547.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-docs.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-drive-2276762714.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-drive-logo-2396662236.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-drive.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-play-280x86.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-sheets-1718541418.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/header-line.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/hero-illustration%20.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/hero-illustration.webp-1789985659.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/hero-screenshot-main.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/hero-screenshot.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardDesign.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardIt.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardMarketing.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardOps.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardSoftwareDev.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroLeftSide.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroRightSide.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/high-velocity.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/hot-jar-1014134517.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/how-to-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/hubspot-3684386805.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/hubspotLogo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/icongithub.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/iconsalesforce.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/image-368080789.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/image.webp-368080789.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/image0_1822_82735.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/image1-1147150532.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/image2-951482151.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/image3-917086086.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/img-arrow.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/incident-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/infobip-logo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/iss-logo-white.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/iss-logo-white_l.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/it-card-1-197982346.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/it-card-2-3557245065.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/it-card-3-1450489864.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/it-main-2485041033.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/itsm-market-event-wac-homepage-nov16-thumbnail.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jenkins-214038284.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-board-sparkle.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-family-hero.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-feature-v2-cta.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-homepage-full.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-homepage-res.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-ticket-loop-de-loop.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jpd-pt-impact_assessment.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jpd-pt-improve_discoverability.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jpd-pt-performance.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-competitors-service-desk.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-engie-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-explore-apps-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-incident-issue-view-shadow.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-incident-issue-view.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-logo-ginkgo-bioworks.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-nextiva-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-request-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-saint-gobain-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-subtasks.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-deliverfast.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-devops.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-hero-portal.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-makevisible.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsw-admin insights screenshot with sidebar.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsw-admin%20insights%20screenshot%20with%20sidebar.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsw-admin_insights_screenshot_with_sidebar.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsw-project-archiving.1353.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jwm-mobile.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jwm.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/kanban-mobile.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/kanban.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/kiva-brit-heiring-2670154364.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/launch-darkly-198811051.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/load-balance-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/logged-in-states.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/login-flyout.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/logo-angle.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/logo-canva-80x80.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/lucid_motors_logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/lucid_motors_logo_l.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/lumen-mai-lian-scarlett-2328968069.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/lumenfigma-2189149097.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/mailchimp-1767865028.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-card-1-2762112147.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-card-2-1921074928.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-card-3-2388914769.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-main-3970751984.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/maximize-efficiency_1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/maximize-efficiency_DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/maximize-efficiency_FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/maximize-efficiency_JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/maximize-efficiency_br.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/mbenz-357294988.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/mercedes-benz-mehmet-sari-366365367.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/mercedesbenz2-2811812509.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/mercedesbenzfigma-1447440523.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/microsoft-365-3971673211.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/microsoft-office-1075029899.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/microsoft-teams-500184357.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/miro.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/mobile-dark-shape.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardDesign.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardIt.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardMarketing.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardOps.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardSoftwareDev.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/monday-3089500834.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ms-teams.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/nasa-logo-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/nav-expanded-products.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-collaborate-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-collaborate-2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-collaborate-3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-collaborate-4.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-double-feature-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-double-feature-2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-staggered-double-feature-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-staggered-double-feature-2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/nextiva-logo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/notifications2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/notifications_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/notifications_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/notifications_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/notifications_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/object lightning 1.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/page-insights.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/page-space-permissions.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/paid-hero.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/pendo-379684898.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/placeholder-video-1920x1080.webm",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/power-of-teamwork-stroke.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/pre-approved-change.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/prod-management-card-1-4088370720.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/prod-management-card-2-3111339843.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/prod-management-card-3-4125726562.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/prod-management-main-2176065091.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/prodbutton.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/proj-management-card-1-4087893998.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/proj-management-card-2-3111006349.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/proj-management-card-3-4125393068.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/proj-management-main-2175731597.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/projectNorthStarPlan.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/projectOverview@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/public_links_1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/quote.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/redfinfigma-3508974692.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/reports_and_insights_1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/reports_and_insights_DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/reports_and_insights_FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/reports_and_insights_JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/reports_and_insights_br.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/resource-agile.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/resource-community.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/resource-devops.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/resource-playbook.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/roadmaps_1462x860_en.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/roblox-joe-cotant-466070325.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/roblox2-2160814116.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/robloxfigma-3257924658.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/rocket-icon.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/royal-caribbean-wais-mojaddidi-3806226212.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/royalcaribbean2-1165951194.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/royalcaribbeanfigma-286749900.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/salesforce-2848088583.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/salesforce-logo-1329625985.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scottf-usericon.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_ES.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_JA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_RU.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_ptBR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev%20status%20in%20issue.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_ES.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_JA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_RU.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_ptBR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_ES.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_JA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_RU.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_ptBR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-roadmaps_(1848x1062.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-scrum-de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/script-runner-1229978336.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-accent-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-accent-2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-accent-3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-accent-4.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-accent-5.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-brand-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-brand-2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-brand-3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-brand-4.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-brand-5.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-portrait-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-portrait-2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-portrait-3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-portrait-4.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-portrait-5.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-screenshot-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-screenshot-2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-screenshot-3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-screenshot-4.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-screenshot-5.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scrum_template_1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scrum_template_DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scrum_template_FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scrum_template_JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scrum_template_br.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/seamless-integration2_1_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/seamless-integration2_1_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/seamless-integration2_1_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/seamless-integration2_1_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/seamless-integration2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/service-center.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/service-desk-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/service-map.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/service-now-3403321428.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/sickkids_logo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/signal.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/slack-375335524.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/slack-logo-4089617954.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/slack.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/smartsheet-2509293444.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-card-1-2014673720.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-card-2-1837920251.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-card-3-2211238458.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-main-4112590587.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/softwareag-tim-brutscher-149530773.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/sony-music-publishing-alison-wood-1422956484.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/sony_music_publishing_logo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/sophosLogo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/sprints-mobile.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/sprints.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/star.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/statsig-4214018365.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/stay-on-track-re-export_br.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/stay-on-track-re-export_de.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/stay-on-track-re-export_fr.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/stay-on-track-re-export_ja.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/sunlifefigma-451494296.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/sydney.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/sydney.webp-3093752750.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/tab2image-29451184.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/tab3image-29484945.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/tab4image-29379446.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/tab5image-29413207.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-ad-banner-confluence-logo-desktop.webp-1192641009.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-ad-banner-confluence-right-hand-image-desktop.webp-3380811166.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-ad-banner-confluence-right-hand-image-tablet.webp-2937812902.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-anu-desktop.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-anu-tablet.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-logo-confluence-ad-banner-desktop.webp-1441519569.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-promotion-header-poster.webp-1047714346.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-promotion-header-static-desktop.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-promotion-header-static-mobile.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-promotion-header-static-tablet.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-right-hand-image-confluence-desktop.webp-4272371151.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24_attribution-logo-above-center_full-color_RGB.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24_attribution-logo-above-left_full-color_RGB.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-tour_government_attribution-logo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-card-test.webp-4063272267.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-color-lockup-desktop-3939666149.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-liftedbar-left-desktop-1497436778.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-liftedbar-left-tablet-3665178386.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-liftedbar-right-desktop-2027904593.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-liftedbar-right-tablet-1999618345.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-panel.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-testimonial-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-testimonial-2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-testimonial-audi.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-testimonial-hubspot.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-testimonial-kiva.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24_card.webp-3094176962.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24promo.webp-432199718.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24promobanner.webp-3262748562.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24promobannerwithdates.webp-3177688311.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24promowithdates.webp-3515396547.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24widerpromobanner.webp-2328022111.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team_24_logo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team_anywear_illo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/template-blogpost.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/template-brainwriting-theme-white-v2.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/template-brainwriting-theme-white.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/template-choice-business-card-header.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/template-choice-kanban-card-header.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/template-choice-scrum-card-header-update.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/template-choice-scrum-card-header.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/template-confluence-chart.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/template_library-2X.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/templates-screenshot.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/templatesScreen@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/test_png.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-roblox.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial4.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/timeline-view-de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/timeline-view-fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/timeline_view_(1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/timeline_view_updated.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/toast_logo_n70_1.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/track-bugs2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/track-bugs_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/track-bugs_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/track-bugs_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/track-bugs_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/trophy.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/trophy.webp-3079354842.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/trust-center-cloud-icon-3087608378.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/underline-header.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/unified-service-view.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/unitedfigma-3439270545.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/upgradescreen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/user-icon-scottf.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-1-customer-service.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-1-hero-employee-support.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-1-hero-engineering-support.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-1-hero-it-management-tab.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-1-hero-it-operations.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-2-hero-customer-service.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-2-hero-employee-support.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-2-hero-engineering-support.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-2-hero-it-operations.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-2-hero-it-support.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/very-group-rob-crompton-1788084465.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/video-play-light.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/wac_banner_background_11_14_23.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/wac_lifted_bar_bg.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/wac_lifted_bar_bg_lu.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/wac_lifted_bar_tablet_bg.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/weeklyStatus@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/welcome-login-product.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/whiteboards.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/workflow-diagram.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/workflow.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/wrike-368502576.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/yale_school_mgmt_logo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/yellow-gestural-lines-2995366884.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/yourEntireTeamOnOnePlatform@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/zendesk-97087002.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/zoom-1703389861.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/zoom-logo-3117034915.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/zoom.webp"
        ]
    }
];

});


parcelRegister("ewIf8", function(module, exports) {

$parcel$export(module.exports, "StrategyCollectionPricingPage", function () { return $aaf1031df9567026$export$8a26b3769c1320bc; });

var $loA2J = parcelRequire("loA2J");

var $dT5kE = parcelRequire("dT5kE");

var $au1lu = parcelRequire("au1lu");
const $aaf1031df9567026$export$8a26b3769c1320bc = (props)=>{
    const { pricingContent: pricingContent, queryRef: queryRef } = props;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dT5kE.PricingContentContextProviderRelay), {
        productId: "strategy-collection",
        pricingContent: pricingContent,
        // @ts-ignore
        queryRef: queryRef,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $au1lu.StrategyCollectionPricingPageTemplate), {})
    });
};

});
parcelRegister("au1lu", function(module, exports) {

$parcel$export(module.exports, "StrategyCollectionPricingPageTemplate", function () { return $afd1321dd86d5f0f$export$22ea4bdc4834ca4; });
/* strategy-collection-pricing-page.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("gUyvS");
var $khjAx = parcelRequire("khjAx");

var $dT5kE = parcelRequire("dT5kE");
parcelRequire("3XyMp");
var $f8O3L = parcelRequire("f8O3L");
var $ceE90 = parcelRequire("ceE90");

var $j1oGG = parcelRequire("j1oGG");
parcelRequire("ccYBS");
var $1FqEx = parcelRequire("1FqEx");

var $9mVWX = parcelRequire("9mVWX");

var $2RWab = parcelRequire("2RWab");

var $9TIUR = parcelRequire("9TIUR");
const $afd1321dd86d5f0f$export$22ea4bdc4834ca4 = (props)=>{
    var _content_callToActionContainer, _content_callToActionContainer1;
    // @ts-ignore
    const intl = (0, $f6qj2.default)();
    const content = (0, $dT5kE.usePricingContentContext)();
    const featuresCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[1]; // @ts-ignore
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer1 = content.callToActionContainer) === null || _content_callToActionContainer1 === void 0 ? void 0 : _content_callToActionContainer1[0];
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _featuresCtaContent_text, _featuresCtaContent_url, _content_getMoreDetailsTitle, _content_additionalDetails;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2RWab.StrategyCollectionNavbar), {}),
        showFallback: content === null || content === void 0 ? void 0 : content.hasError,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1FqEx.ParentScrollTracking), {
            scrollTrackingEnabled: true,
            pageId: "strategy-collection-pricing-page",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _zulp7vkz"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $9mVWX.Hero), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PageHeading), {
                            children: content === null || content === void 0 ? void 0 : content.headline
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $9TIUR.StrategyCollectionPriceFinder), {
                    pricing: props.pricing,
                    countryCode: props.countryCode
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $khjAx.PricingFeatureTable), {
                    title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                    comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                    compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined,
                    linkValues: {
                        linkText: (_featuresCtaContent_text = featuresCtaContent === null || featuresCtaContent === void 0 ? void 0 : featuresCtaContent.text) !== null && _featuresCtaContent_text !== void 0 ? _featuresCtaContent_text : undefined,
                        linkHref: (_featuresCtaContent_url = featuresCtaContent === null || featuresCtaContent === void 0 ? void 0 : featuresCtaContent.url) !== null && _featuresCtaContent_url !== void 0 ? _featuresCtaContent_url : undefined
                    },
                    dataProductKey: "strategyCollection"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $f8O3L.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1FqEx.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ceE90.PricingFaq), {
                            header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                            planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                        })
                    })
                })
            ]
        })
    });
};
const $afd1321dd86d5f0f$var$headingContainerCss = null;

});
parcelRegister("gUyvS", function(module, exports) {
$parcel$export(module.exports, "PricingFeatureTable", function () { return (parcelRequire("khjAx")).PricingFeatureTable; });
parcelRequire("khjAx");

});
parcelRegister("khjAx", function(module, exports) {

$parcel$export(module.exports, "PricingFeatureTable", function () { return $f9aa7394487cf7d8$export$49da9cb6ddf668ee; });
/* features-table.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $8xSOc = parcelRequire("8xSOc");

var $91nJf = parcelRequire("91nJf");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $3mtQK = parcelRequire("3mtQK");

var $7mfju = parcelRequire("7mfju");

var $gPkR0 = parcelRequire("gPkR0");

var $1u7RU = parcelRequire("1u7RU");
const $f9aa7394487cf7d8$var$tdStyles = null;
const $f9aa7394487cf7d8$var$advanceHeadingStyles = null;
const $f9aa7394487cf7d8$var$advanceTitleStyles = null;
const $f9aa7394487cf7d8$var$advanceButtontyles = null;
const $f9aa7394487cf7d8$var$advanceSoftStyles = null;
const $f9aa7394487cf7d8$var$featureTableSubHeader = null;
const $f9aa7394487cf7d8$var$featuresTableHeadIdPrefix = "featTableHead_";
const $f9aa7394487cf7d8$export$5a7d94d7c691844a = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        className: (0, $esG4f.default)([
            "_y3gn1h6o _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1bsb1osq _b8yq1git _n09v1ylp _1txjidpf _y4duvbgk _u19lidpf _jpg4bfng"
        ])
    }));
};
const $f9aa7394487cf7d8$export$de898cfe2ca10ff8 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulp7vkz"
        ]),
        children: props.children
    });
};
const $f9aa7394487cf7d8$export$f052fee91dc6777a = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("h2", (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        className: (0, $esG4f.default)([
            "_syaz1hlo _k48p1fw0 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb14no _1cqszwfg _3p1c1ylp _py5ockbl"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
        }
    }));
};
const $f9aa7394487cf7d8$export$a433b7aa5ad7fd61 = ({ linkText: linkText, linkHref: linkHref })=>{
    const intl = (0, $f6qj2.default)();
    const defaultLinkText = intl.formatMessage({
        id: "PricingPages.featureTable.subHeader",
        defaultMessage: "Learn about features"
    });
    const defaultLinkHref = `https://www.atlassian.com${(0, $3FBn4.useLocalizedHref)("/software/jira/features")}`;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1wyb7vkz _vwz4gktf"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
            text: linkText !== null && linkText !== void 0 ? linkText : defaultLinkText,
            href: linkHref !== null && linkHref !== void 0 ? linkHref : defaultLinkHref,
            className: "link-class",
            type: "primary"
        })
    });
};
const $f9aa7394487cf7d8$var$FeaturesTableContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createContext({
    planTiers: []
});
const $f9aa7394487cf7d8$export$e2b8eb038115bae6 = (props)=>{
    const intl = (0, $f6qj2.default)();
    const localizedSignupURL = (0, $3FBn4.useLocalizedHref)((0, $7mfju.SIGNUP_CTA_URL));
    const localizedContactURL = (0, $3FBn4.useLocalizedHref)((0, $7mfju.CONTACT_CTA_URL));
    return /*#__PURE__*/ (0, $loA2J.jsx)($f9aa7394487cf7d8$var$FeaturesTableContext.Provider, {
        value: {
            planTiers: props.planTiers
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("table", {
            className: (0, $esG4f.default)([
                "_2lx21bp4 _1kqm1n9t _1bsb1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _y3gn1h6o _yq5hcfaq _btyzidpf _suga1txw _476d1tcg _1e0c5mfb _1pfhzwfg _1mt1ckbl"
            ]),
            children: [
                props.captionText && /*#__PURE__*/ (0, $loA2J.jsx)("caption", {
                    className: (0, $esG4f.default)([
                        "_y3gnv2br _ca0qzwfg _u5f3dlk8 _n3tddlk8 _19bvdlk8 _ect41pz4 _1wyb1k92 _1kmx1tcg _1ggmdlk8 _1ykzdlk8 _1maedlk8"
                    ]),
                    style: {
                        "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                    },
                    children: props.captionText
                }),
                props.subCaptionText && /*#__PURE__*/ (0, $loA2J.jsx)("caption", {
                    className: (0, $esG4f.default)([
                        "_y3gnv2br _ca0qidpf _u5f3dlk8 _n3tddlk8 _19bvdlk8 _ect41pz4 _1wyb1j6v"
                    ]),
                    style: {
                        "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                    },
                    children: props.subCaptionText
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("thead", {
                    className: (0, $esG4f.default)([
                        "_179ru1j4 _sugaglyw _1pbykb7n _154i88uy _kqsw1if8 _11q7cd5j"
                    ]),
                    style: {
                        "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400")),
                        "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("tr", {
                        className: (0, $esG4f.default)([
                            "_17gvangw _7dd6v2br"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)($f9aa7394487cf7d8$var$FeaturesTableHeadCell, {
                                index: 0
                            }),
                            props.planTiers.map((tierContent, index)=>{
                                let edition, ctaBtnText = "", ctaBtnUrl = "", dataEventPropsLabel = "start-trial";
                                if (props.stickyCtasEnabled && props.dataProductKey) {
                                    const startFreeTrialText = intl.formatMessage({
                                        id: "Pricing.CompareFeatures.StartFreeTrial",
                                        defaultMessage: (0, $7mfju.CtaBtnText).START_FREE_TRIAL
                                    });
                                    const getItNowText = intl.formatMessage({
                                        id: "Pricing.CompareFeatures.GetItNow",
                                        defaultMessage: (0, $7mfju.CtaBtnText).GET_IT_NOW
                                    });
                                    const contactSalesText = intl.formatMessage({
                                        id: "Pricing.CompareFeatures.ContactSales",
                                        defaultMessage: (0, $7mfju.CtaBtnText).CONTACT_SALES
                                    });
                                    ctaBtnText = startFreeTrialText;
                                    dataEventPropsLabel = dataEventPropsLabel = `${tierContent}-start-trial-compare-features`; // tech-debt: get cta text and urls from contentful
                                    // ticket: https://hello.jira.atlassian.cloud/browse/PRICING-1542
                                    switch(tierContent){
                                        case (0, $7mfju.SpecialPlanNames).FREE:
                                            edition = (0, $7mfju.Edition).FREE;
                                            ctaBtnText = getItNowText;
                                            ctaBtnUrl = localizedSignupURL + "?bundle=jira-software&edition=free";
                                            dataEventPropsLabel = `${tierContent}-get-it-now-compare-features`;
                                            break;
                                        case (0, $7mfju.SpecialPlanNames).STANDARD:
                                            edition = (0, $7mfju.Edition).STANDARD;
                                            ctaBtnUrl = localizedSignupURL + "?bundle=jira-software&edition=standard";
                                            break;
                                        case (0, $7mfju.SpecialPlanNames).PREMIUM:
                                            edition = (0, $7mfju.Edition).PREMIUM;
                                            ctaBtnUrl = localizedSignupURL + "?bundle=jira-software&edition=premium";
                                            break;
                                        case (0, $7mfju.SpecialPlanNames).ENTERPRISE:
                                            edition = (0, $7mfju.Edition).ENTERPRISE;
                                            ctaBtnText = contactSalesText;
                                            ctaBtnUrl = localizedContactURL;
                                            dataEventPropsLabel = `${tierContent}-contact-sales-compare-features`;
                                            break;
                                    }
                                }
                                return /*#__PURE__*/ (0, $loA2J.jsx)($f9aa7394487cf7d8$var$FeaturesTableHeadCell, {
                                    index: index,
                                    children: typeof tierContent === "string" ? /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        id: `${$f9aa7394487cf7d8$var$featuresTableHeadIdPrefix}${index}`,
                                        className: (0, $esG4f.default)([
                                            "_1e0c1txw _2lx21bp4 _zulpftgi _4cvr1y6m"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                className: (0, $esG4f.default)([
                                                    "_syaz1hlo _k48p1fw0"
                                                ]),
                                                style: {
                                                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                                                },
                                                children: tierContent
                                            }),
                                            props.stickyCtasEnabled && props.dataProductKey && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1u7RU.StickyCTAContextProvider), {
                                                isSticky: undefined,
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gPkR0.CtaButton), {
                                                    edition: edition,
                                                    dataProductKey: props.dataProductKey,
                                                    type: "secondary",
                                                    text: ctaBtnText,
                                                    dataEventPropsLabel: dataEventPropsLabel,
                                                    url: ctaBtnUrl,
                                                    isDisabled: false,
                                                    containerId: (0, $7mfju.COMPARE_FEATURES_CONTAINER)
                                                })
                                            })
                                        ]
                                    }) : tierContent ? /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_y3gn1e5h"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                className: (0, $esG4f.default)([
                                                    "_syaz1hlo _k48p1fw0"
                                                ]),
                                                style: {
                                                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                                                },
                                                children: tierContent.title
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                        className: (0, $esG4f.default)([
                                                            "_syaz1hlo _k48p1fw0"
                                                        ]),
                                                        style: {
                                                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                                                        },
                                                        children: tierContent.price
                                                    }),
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                        className: (0, $esG4f.default)([
                                                            "_syaznqye _ahbqi2wt"
                                                        ]),
                                                        style: {
                                                            "--_1a8xanm": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light600"))
                                                        },
                                                        children: "per user"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                                                size: "small",
                                                variant: "secondary",
                                                color: "black",
                                                colorAgainst: "other",
                                                href: "https://www.atlassian.com/enterprise/contact?formType=product-features",
                                                className: (0, $esG4f.default)([
                                                    "_1pfhw1gv"
                                                ]),
                                                children: tierContent.button
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        children: "Invalid Data"
                                    })
                                }, index);
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("tbody", {
                    children: props.children
                })
            ]
        })
    });
};
const $f9aa7394487cf7d8$var$FeaturesTableHeadCell = (_param)=>{
    var { advance: advance } = _param, props = (0, $akGnX._)(_param, [
        "advance"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("th", (0, $6iHNw._)((0, $7Knp0._)({
        scope: "col"
    }, props), {
        className: (0, $esG4f.default)([
            "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _s7n41q9y _t51zyzqy _10msglyw"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
        }
    }));
};
const $f9aa7394487cf7d8$var$lozengeContainerCss = null;
const $f9aa7394487cf7d8$export$4a48add4d33bb5cb = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("tr", {
        className: (0, $esG4f.default)([
            "_syaz1hlo _2lx21bp4 _19pk7vkz _2hwxidpf _otyr7vkz _18u0idpf _bfhk1rga _v56411zw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _s7n41q9y _y3gn1h6o _sugaglyw"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("td", {
                className: (0, $esG4f.default)([
                    "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _s7n41q9y _t51zyzqy _10msglyw",
                    "_y3gnv2br"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                    "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    className: (0, $esG4f.default)([
                        "_syaz1hlo _1bsb1osq _k48p8n31 _4t3i1wug _1e0c1ule _1i4q1hna"
                    ]),
                    style: {
                        "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                    },
                    children: props.headerTitle
                })
            }),
            props.tierCellsContent.map((content, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("td", {
                    className: (0, $esG4f.default)([
                        "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _s7n41q9y _t51zyzqy _10msglyw"
                    ]),
                    style: {
                        "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                        "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
                    },
                    children: content
                }, index))
        ]
    });
};
const $f9aa7394487cf7d8$export$8d6c1dc4bc4e86f2 = (props)=>{
    let lozenge = null;
    const { text: text, expanderContent: expanderContent, href: href } = props.featureCellContent;
    if (props.lozengeText) lozenge = /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        className: (0, $esG4f.default)([
            "_ahbq1y44"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
            children: props.lozengeText
        })
    });
    const rowDescId = `rowDesc_${props.id}`;
    let featureCellContent;
    if (href) featureCellContent = /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                id: rowDescId,
                text: text,
                href: href,
                type: "primary",
                className: (0, $esG4f.default)([
                    "_1wybdlk8 _ahbq1y44"
                ])
            }),
            lozenge
        ]
    });
    else {
        const children = expanderContent ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: expanderContent
            },
            className: (0, $esG4f.default)([
                "_1wybdlk8 _syazr2ho _43dsrbzz _59381r31 _yha28stv _1nmznqa1 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1"
            ]),
            style: {
                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
            }
        }) : undefined;
        featureCellContent = /*#__PURE__*/ (0, $loA2J.jsx)((0, $3mtQK.ExpandableContent), {
            eventDataName: text,
            label: /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                id: rowDescId,
                children: [
                    text,
                    lozenge
                ]
            }),
            children: children
        });
    }
    return /*#__PURE__*/ (0, $loA2J.jsxs)("tr", {
        className: (0, $esG4f.default)([
            "_19pk7vkz _2hwxidpf _otyr7vkz _18u0idpf _bfhkcd5j _v56411zw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _s7n41q9y _y3gn1h6o _1ckvidpf _irr31rga _1o4gu1j4 _a5ztgktf _suga1txw _1gde1bp4"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100")),
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("td", {
                className: (0, $esG4f.default)([
                    "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _s7n41q9y _t51zyzqy _10msglyw",
                    "_y3gnv2br _16nmgktf _1w6hgktf _gtp7150w _1kmxdlk8 _1ggmdlk8 _1ykzdlk8 _1maedlk8"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                    "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400")),
                    "--_8nj8hf": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light200"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    className: (0, $esG4f.default)([
                        "_1bsb1osq _1reo15vq"
                    ]),
                    children: featureCellContent
                })
            }),
            props.tierCellsContent.map((content, index)=>/*#__PURE__*/ (0, $loA2J.jsx)($f9aa7394487cf7d8$export$17906fe86bec07d9, {
                    index: index,
                    cellContent: content,
                    rowDescId: rowDescId
                }, index))
        ]
    });
};
const $f9aa7394487cf7d8$export$17906fe86bec07d9 = ({ cellContent: cellContent, index: index, rowDescId: rowDescId })=>{
    const { planTiers: planTiers } = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useContext($f9aa7394487cf7d8$var$FeaturesTableContext);
    const tierContent = planTiers[index];
    const cellContentStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("td", {
        className: (0, $esG4f.default)([
            "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _s7n41q9y _t51zyzqy _10msglyw",
            "_s7n4jp4b"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_suga1txw _1e0cglyw"
                ]),
                children: typeof tierContent === "string" ? tierContent : tierContent && /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
                    children: tierContent.title
                })
            }),
            cellContent && /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _zulpu2gc"
                ]),
                children: [
                    cellContent.checkmark && /*#__PURE__*/ (0, $loA2J.jsx)($f9aa7394487cf7d8$export$4f481e0a96cfbed6, {
                        containerProps: {
                            "aria-labelledby": `${$f9aa7394487cf7d8$var$featuresTableHeadIdPrefix}${index} ${rowDescId}`,
                            "tabIndex": 0,
                            "style": {
                                marginBlockStart: "-6px"
                            }
                        }
                    }),
                    cellContent.textContent && /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: cellContent.textContent
                        },
                        className: (0, $esG4f.default)([
                            "_y3gnv2br _1wybdlk8 _43dsrbzz _59381r31 _yha28stv _1nmznqa1 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1"
                        ])
                    })
                ]
            })
        ]
    });
};
const $f9aa7394487cf7d8$export$4f481e0a96cfbed6 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", (0, $6iHNw._)((0, $7Knp0._)({}, props.containerProps), {
        className: (0, $esG4f.default)([
            "_1a1x1ssb"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            "data-testid": "checkmark",
            className: (0, $esG4f.default)([
                "_bfhkl30o _2rko1ssb _syazcd5j _1e0c1o8l _1o9zidpf _k48p8n31 _vwz41tcg _19pk1y44 _2hwx1y44 _otyr1y44 _18u01y44 _y3gn1h6o _4t3i1tcg _1bsb1tcg"
            ]),
            style: {
                "--_1x006p6": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.lime700")),
                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
            },
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Icon), {
                name: "featurecheckmark",
                size: "xs",
                color: (0, $5ohHq.wacToken)("color.neutral.light0")
            })
        })
    }));
};
const $f9aa7394487cf7d8$export$49da9cb6ddf668ee = ({ title: title, comparePlans: comparePlans, compareFeatures: compareFeatures, linkValues: linkValues, dataProductKey: dataProductKey, stickyCtasEnabled: stickyCtasEnabled })=>{
    const intl = (0, $f6qj2.default)();
    if (!comparePlans || !compareFeatures) return null;
     // maintain a list to keep track of the plans in the contentful order
    var _comparePlans_map;
    const orderedPlanTiers = (_comparePlans_map = comparePlans === null || comparePlans === void 0 ? void 0 : comparePlans.map((plan)=>{
        var _plan_planTitleExternal;
        return (_plan_planTitleExternal = plan.planTitleExternal) !== null && _plan_planTitleExternal !== void 0 ? _plan_planTitleExternal : "";
    })) !== null && _comparePlans_map !== void 0 ? _comparePlans_map : [];
    const fallbackTitle = intl.formatMessage({
        id: "PricingFeatureTable.fallbackTitle",
        defaultMessage: "Compare Features"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)($f9aa7394487cf7d8$export$5a7d94d7c691844a, {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)($f9aa7394487cf7d8$export$de898cfe2ca10ff8, {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)($f9aa7394487cf7d8$export$f052fee91dc6777a, {
                        children: title !== null && title !== void 0 ? title : fallbackTitle
                    }),
                    (linkValues === null || linkValues === void 0 ? void 0 : linkValues.linkHref) && (linkValues === null || linkValues === void 0 ? void 0 : linkValues.linkText) ? /*#__PURE__*/ (0, $loA2J.jsx)($f9aa7394487cf7d8$export$a433b7aa5ad7fd61, (0, $7Knp0._)({}, linkValues)) : null
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)($f9aa7394487cf7d8$export$e2b8eb038115bae6, {
                captionText: "",
                planTiers: orderedPlanTiers,
                dataProductKey: dataProductKey,
                stickyCtasEnabled: stickyCtasEnabled,
                children: compareFeatures === null || compareFeatures === void 0 ? void 0 : compareFeatures.map((featureGroup, index)=>{
                    return /*#__PURE__*/ (0, $loA2J.jsx)($f9aa7394487cf7d8$export$4612d2a76503b8a4, {
                        featureGroup: featureGroup,
                        orderedPlanTiers: orderedPlanTiers,
                        groupIndex: index
                    }, featureGroup.featureGroupTitleExternal);
                })
            })
        ]
    });
};
const $f9aa7394487cf7d8$export$4612d2a76503b8a4 = ({ featureGroup: featureGroup, orderedPlanTiers: orderedPlanTiers, groupIndex: groupIndex })=>{
    const { featureGroupTitleExternal: featureGroupTitleExternal, features: features } = featureGroup;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)($f9aa7394487cf7d8$export$4a48add4d33bb5cb, {
                headerTitle: featureGroupTitleExternal !== null && featureGroupTitleExternal !== void 0 ? featureGroupTitleExternal : "",
                tierCellsContent: Array(Object.keys(orderedPlanTiers).length).fill("")
            }),
            features === null || features === void 0 ? void 0 : features.map((feature, index)=>{
                const { featureNameExternal: featureNameExternal, description: description, relevantUrl: relevantUrl, callOut: callOut, featureAdditionalInformation: featureAdditionalInformation, relevantPlan: relevantPlan } = feature; // Initialize an object to store feature cell information for each plan.
                // The keys will be the plan names, and the values will be initially set to exmpty objects.
                const featureCellInfo = orderedPlanTiers.reduce((obj, plan)=>{
                    obj[plan] = {};
                    return obj;
                }, {});
                if (featureAdditionalInformation) // Iterate over each addtional information and update the appropiriate featureCellInfo with corresponding messages
                featureAdditionalInformation === null || featureAdditionalInformation === void 0 ? void 0 : featureAdditionalInformation.forEach((info)=>{
                    const { featureAdditionalInformation: message, relevantPlan: featureRelevantPlans } = info;
                    featureRelevantPlans === null || featureRelevantPlans === void 0 ? void 0 : featureRelevantPlans.forEach((plan)=>{
                        const planTitleExternal = plan.planTitleExternal;
                        if (featureCellInfo[planTitleExternal]) featureCellInfo[planTitleExternal].textContent = message !== null && message !== void 0 ? message : "";
                    });
                });
                 // hanlding boolean values
                if (relevantPlan) relevantPlan === null || relevantPlan === void 0 ? void 0 : relevantPlan.forEach((plan)=>{
                    // Mark this plan as true in featureCellInfo
                    const planTitleExternal = plan.planTitleExternal;
                    if (featureCellInfo[planTitleExternal]) featureCellInfo[planTitleExternal].checkmark = true;
                });
                 // Generate the ordered values for tierCellsContent
                const orderedValues = orderedPlanTiers.map((key)=>featureCellInfo[key]).filter((value)=>value !== undefined);
                return /*#__PURE__*/ (0, $loA2J.jsx)($f9aa7394487cf7d8$export$8d6c1dc4bc4e86f2, {
                    featureCellContent: {
                        text: featureNameExternal !== null && featureNameExternal !== void 0 ? featureNameExternal : "",
                        expanderContent: description !== null && description !== void 0 ? description : null,
                        href: relevantUrl !== null && relevantUrl !== void 0 ? relevantUrl : null
                    },
                    lozengeText: callOut,
                    tierCellsContent: orderedValues,
                    id: `${groupIndex}_${index}`
                }, featureNameExternal);
            })
        ]
    });
};

});


parcelRegister("3XyMp", function(module, exports) {
$parcel$export(module.exports, "PricingFaq", function () { return (parcelRequire("ceE90")).PricingFaq; });
$parcel$export(module.exports, "QuotationsAdornment", function () { return (parcelRequire("f8O3L")).QuotationsAdornment; });
parcelRequire("ceE90");
parcelRequire("f8O3L");

});

parcelRegister("ccYBS", function(module, exports) {
$parcel$export(module.exports, "ScrollTracking", function () { return (parcelRequire("e6FyV")).ScrollTracking; });
$parcel$export(module.exports, "useScrollTracking", function () { return (parcelRequire("e6FyV")).useScrollTracking; });
$parcel$export(module.exports, "withScrollTracking", function () { return (parcelRequire("e6FyV")).withScrollTracking; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return (parcelRequire("1FqEx")).ParentScrollTracking; });
parcelRequire("e6FyV");
parcelRequire("1FqEx");

});
parcelRegister("e6FyV", function(module, exports) {

$parcel$export(module.exports, "useScrollTracking", function () { return $dd17d79dac682b5f$export$17700584f55fbc70; });
$parcel$export(module.exports, "ScrollTracking", function () { return $dd17d79dac682b5f$export$1725757b7947b890; });
$parcel$export(module.exports, "withScrollTracking", function () { return $dd17d79dac682b5f$export$391633ede08dabb1; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $eDoPe = parcelRequire("eDoPe");

var $g9kzu = parcelRequire("g9kzu");

var $1FqEx = parcelRequire("1FqEx");

var $dWbel = parcelRequire("dWbel");
const $dd17d79dac682b5f$export$17700584f55fbc70 = (section, props = {})=>{
    const { index: index, observerOptions: observerOptions, dwellTimeEnabled: dwellTimeEnabled, additionalAttributes: additionalAttributes } = props;
    const hasFunctionBeenCalled = (0, $iSvIT.useRef)(false);
    const scrollPercentage = (0, $iSvIT.useRef)(0);
    const { pageId: pageId, scrollTrackingEnabled: scrollTrackingEnabled } = (0, $1FqEx.useParentScrollTracking)();
    const { ref: ref, inView: inView, entry: entry } = (0, $eDoPe.useInView)((0, $6iHNw._)((0, $7Knp0._)({
        threshold: 0.5,
        triggerOnce: true
    }, observerOptions), {
        skip: (observerOptions === null || observerOptions === void 0 ? void 0 : observerOptions.skip) || !scrollTrackingEnabled
    }));
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const handleScroll = ()=>{
        const windowHeight = window.innerHeight;
        const fullHeight = document.documentElement.scrollHeight;
        const currentPosition = window.scrollY;
        scrollPercentage.current = Math.round(currentPosition / (fullHeight - windowHeight) * 100);
    };
    (0, $iSvIT.useEffect)(()=>{
        if (inView && !hasFunctionBeenCalled.current && section) {
            handleScroll();
            const scrollTrackAnalyticsPayload = {
                eventType: "ui",
                action: "scrolledTo",
                actionSubject: "section",
                source: window.location.pathname,
                attributes: (0, $7Knp0._)({
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId
                }, additionalAttributes)
            };
            const dwellTimeTrackAnalyticsPayload = {
                eventType: "ui",
                action: "dwellTimeTracked",
                actionSubject: "section",
                source: window.location.pathname,
                attributes: (0, $7Knp0._)({
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId
                }, additionalAttributes)
            };
            if (analyticsClient) {
                createAnalyticsEvent((0, $7Knp0._)({}, scrollTrackAnalyticsPayload)).fire();
                hasFunctionBeenCalled.current = true;
            }
            if (dwellTimeEnabled) {
                const activityEvents = [
                    "mousemove",
                    "keydown",
                    "scroll",
                    "touchstart"
                ];
                let intervalId = undefined;
                let activityTimeout = undefined;
                let active = true;
                // stop tracking after 1 minute of inactivity
                const setActive = ()=>{
                    active = true;
                    clearTimeout(activityTimeout);
                    activityTimeout = setTimeout(()=>{
                        active = false;
                    }, 60000);
                };
                activityEvents.forEach((evt)=>{
                    window.addEventListener(evt, setActive);
                });
                // emmit every 5 seconds if the user is active
                intervalId = setInterval(()=>{
                    if (active) {
                        handleScroll();
                        createAnalyticsEvent((0, $7Knp0._)({}, dwellTimeTrackAnalyticsPayload)).fire();
                    } else {
                        clearInterval(intervalId);
                        clearTimeout(activityTimeout);
                        activityEvents.forEach((evt)=>{
                            window.removeEventListener(evt, setActive);
                        });
                    }
                }, 5000);
            }
        }
    }, [
        additionalAttributes,
        analyticsClient,
        createAnalyticsEvent,
        dwellTimeEnabled,
        hasFunctionBeenCalled,
        inView,
        index,
        pageId,
        section
    ]);
    return {
        ref: ref,
        inView: inView,
        entry: entry
    };
};
const $dd17d79dac682b5f$export$1725757b7947b890 = ({ section: section, index: index, observerOptions: observerOptions, children: children, as: RootElement = "div" })=>{
    const { ref: ref } = $dd17d79dac682b5f$export$17700584f55fbc70(section, {
        index: index,
        observerOptions: observerOptions
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)(RootElement, {
        ref: ref,
        children: children
    });
};
function $dd17d79dac682b5f$export$391633ede08dabb1(section, InnerComponent, options) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (props)=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)($dd17d79dac682b5f$export$1725757b7947b890, (0, $6iHNw._)((0, $7Knp0._)({
            section: section
        }, options), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)(InnerComponent, (0, $7Knp0._)({}, props))
        }));
    };
}

});
parcelRegister("1FqEx", function(module, exports) {

$parcel$export(module.exports, "useParentScrollTracking", function () { return $5f5c2bfbd45e6855$export$164ddb76b909974a; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return $5f5c2bfbd45e6855$export$248f1dfc9396e7e4; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("ccYBS");
var $e6FyV = parcelRequire("e6FyV");
const $5f5c2bfbd45e6855$var$ScrollTrackingContext = /*#__PURE__*/ (0, $iSvIT.createContext)({
    pageId: "wac-web",
    scrollTrackingEnabled: true
});
const $5f5c2bfbd45e6855$export$164ddb76b909974a = ()=>{
    return (0, $iSvIT.useContext)($5f5c2bfbd45e6855$var$ScrollTrackingContext);
};
const $5f5c2bfbd45e6855$export$248f1dfc9396e7e4 = (props)=>{
    const parentContext = $5f5c2bfbd45e6855$export$164ddb76b909974a();
    const arrayChildren = (0, $iSvIT.Children).toArray(props.children);
    const definedName = (child)=>{
        if (/*#__PURE__*/ (0, $iSvIT.isValidElement)(child) && child.type) {
            // Use a type assertion to tell TypeScript that the type has a displayName
            const namedComponent = child.type;
            return namedComponent.displayName;
        } else return undefined;
    };
    // Determine tracking of parent undefined means true
    const parentTrackScrolling = parentContext.scrollTrackingEnabled === undefined ? true : parentContext.scrollTrackingEnabled;
    // Parent should take precedence if parent tracking is disabled
    const trackScrolling = parentTrackScrolling && (props.scrollTrackingEnabled === undefined ? true : props.scrollTrackingEnabled);
    var _props_pageId;
    const pageId = (_props_pageId = props.pageId) !== null && _props_pageId !== void 0 ? _props_pageId : parentContext.pageId;
    return /*#__PURE__*/ (0, $loA2J.jsx)($5f5c2bfbd45e6855$var$ScrollTrackingContext.Provider, {
        value: {
            pageId: pageId,
            scrollTrackingEnabled: trackScrolling
        },
        children: (0, $iSvIT.Children).map(arrayChildren, (child, index)=>{
            const name = definedName(child);
            return name ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $e6FyV.ScrollTracking), {
                index: `${index}/${arrayChildren.length}`,
                section: name,
                as: props.as,
                children: child
            }, index) : child;
        })
    });
};

});



parcelRegister("9mVWX", function(module, exports) {

$parcel$export(module.exports, "Hero", function () { return $32d63d7122c2c473$export$887967f05dc521ae; });
// @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $bhreu = parcelRequire("bhreu");
const $32d63d7122c2c473$export$887967f05dc521ae = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5j2mvlle35t45d0e48ye5tqpoe0m63gu.svg",
            alt: intl.formatMessage({
                id: "StrategyCollectionPricingPageTemplate.headingLogoAlt",
                defaultMessage: "Strategy Collection logo"
            })
        }
    });
};

});

parcelRegister("2RWab", function(module, exports) {

$parcel$export(module.exports, "StrategyCollectionNavbar", function () { return $d5a5b968eec327c1$export$8f1cb1d63697797a; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $cP0Yq = parcelRequire("cP0Yq");

var $4R0f2 = parcelRequire("4R0f2");

var $b49hK = parcelRequire("b49hK");
const $d5a5b968eec327c1$export$8f1cb1d63697797a = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.GlobalNav), {
        productKey: "home",
        compoundNav: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $4R0f2.CollectionsCompoundSubNavProps)()), {
            ctaUrl: (0, $b49hK.CTA_URL_PATH)
        })
    });
};

});
parcelRegister("4R0f2", function(module, exports) {

$parcel$export(module.exports, "CollectionsCompoundSubNavProps", function () { return $265ebf1ac0867280$export$7390cb3961621991; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");

var $ispPN = parcelRequire("ispPN");

var $gAJUc = parcelRequire("gAJUc");

var $aOuDE = parcelRequire("aOuDE");
const $265ebf1ac0867280$export$7390cb3961621991 = ()=>{
    const intl = (0, $f6qj2.default)();
    const teamworkOverviewHref = (0, $3FBn4.useLocalizedHref)("/collections/teamwork");
    const teamworkFeaturesHref = (0, $3FBn4.useLocalizedHref)("/collections/teamwork/features");
    const teamworkPricingHref = (0, $3FBn4.useLocalizedHref)("/collections/teamwork/pricing");
    const strategyOverviewHref = (0, $3FBn4.useLocalizedHref)("/collections/strategy");
    const strategyDemoCenterHref = (0, $3FBn4.useLocalizedHref)("/collections/strategy/demo-center");
    const strategyPricingHref = (0, $3FBn4.useLocalizedHref)("/collections/strategy/pricing");
    const serviceHref = (0, $3FBn4.useLocalizedHref)("/collections/service");
    const softwareHref = (0, $3FBn4.useLocalizedHref)("/collections/software");
    const isGwp7850 = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7850GlobalNavChangesForTeam25Eu);
    const collectionsHref = (0, $3FBn4.useLocalizedHref)("/collections");
    // todo: GWP-8380 support collections subnav dropdown menu in mobile
    // 1024 == `media.below.md`, which is the mobile-display threshold
    // specified in services/wac-web/src/patterns/global-nav/src/nav-product-page.tsx
    const isMobile = (0, $aOuDE.useIsMobile)(1024);
    const hasSubnav = isGwp7850 && !isMobile;
    const props = {
        optionalClassName: isGwp7850 ? "collections-nav" : "",
        compoundSubNavTitle: "Collections",
        compoundSubNavTitleHref: collectionsHref,
        compoundSubNavLinksProps: [
            {
                globalLinksKey: "overview",
                linkText: intl.formatMessage({
                    id: "collectionsCompoundSubNav.Navlink.overview",
                    defaultMessage: "Overview"
                }),
                hasSubnav: false,
                href: collectionsHref
            },
            {
                globalLinksKey: "teamwork",
                linkText: "Teamwork",
                href: teamworkOverviewHref,
                hasSubnav: hasSubnav,
                content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ispPN.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.overview",
                                        defaultMessage: "Overview"
                                    }),
                                    href: teamworkOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.features",
                                        defaultMessage: "Features"
                                    }),
                                    href: teamworkFeaturesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.pricing",
                                        defaultMessage: "Pricing"
                                    }),
                                    href: teamworkPricingHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: "strategy",
                linkText: "Strategy",
                href: strategyOverviewHref,
                hasSubnav: hasSubnav,
                content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ispPN.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.overview",
                                        defaultMessage: "Overview"
                                    }),
                                    href: strategyOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.demoCenter",
                                        defaultMessage: "Demo Center"
                                    }),
                                    href: strategyDemoCenterHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.pricing",
                                        defaultMessage: "Pricing"
                                    }),
                                    href: strategyPricingHref
                                }
                            ]
                        }
                    ]
                })
            }
        ],
        isShowCta: isGwp7850 ? false : true,
        ctaButtonText: intl.formatMessage({
            id: "collectionsCompoundSubNav.cta.contactSales",
            defaultMessage: "Contact Sales"
        }),
        ctaButtonVariant: "primary",
        ctaUrl: "#contact"
    };
    if (isGwp7850) {
        props.compoundSubNavLinksProps.push({
            globalLinksKey: "service",
            linkText: "Service",
            hasSubnav: false,
            href: serviceHref
        }, {
            globalLinksKey: "software",
            linkText: "Software",
            hasSubnav: false,
            href: softwareHref
        });
        props.compoundSubNavLinksProps.shift();
    }
    return props;
};

});
parcelRegister("ispPN", function(module, exports) {

$parcel$export(module.exports, "DropdownContent", function () { return $16fe9e86fc1396d8$export$59308621e1a05692; });

var $9g0oR = parcelRequire("9g0oR");
const $16fe9e86fc1396d8$export$59308621e1a05692 = (0, $9g0oR.DropdownContent);

});


parcelRegister("b49hK", function(module, exports) {

$parcel$export(module.exports, "CTA_URL_PATH", function () { return $51d399db3476ba7f$export$d5587a12d9eea1dc; });
const $51d399db3476ba7f$export$d5587a12d9eea1dc = "/collections/strategy#contact";

});


parcelRegister("9TIUR", function(module, exports) {

$parcel$export(module.exports, "StrategyCollectionPriceFinder", function () { return $1612184c49960d77$export$2faf81ba1ab86dc7; });
// @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $6x1qA = parcelRequire("6x1qA");
var $f6qj2 = parcelRequire("f6qj2");

var $7mfju = parcelRequire("7mfju");

var $l9lQF = parcelRequire("l9lQF");

var $7OWgU = parcelRequire("7OWgU");

var $esRX2 = parcelRequire("esRX2");

var $dT5kE = parcelRequire("dT5kE");

var $b49hK = parcelRequire("b49hK");

var $4Xtx9 = parcelRequire("4Xtx9");
const $1612184c49960d77$export$2faf81ba1ab86dc7 = (props)=>{
    var _props_pricing_ccpPricingData, _props_pricing;
    // @ts-ignore
    const intl = (0, $f6qj2.default)();
    const content = {
        enterprise: (0, $dT5kE.usePricingPlanComparison)("Strategy Collection") // please ensure this matches the plan-comparison entry in Contentful
    };
    const enterprisePlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "enterprise");
    const productPlans = [
        {
            planName: (0, $7mfju.SpecialPlanNames).ENTERPRISE,
            planTitleComponent: ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
                    children: "Strategy Collection"
                }),
            offeringSku: "strategy-collection-enterprise-sku",
            recommendationLimit: 2000,
            signupLimit: 2000,
            planFeatureMessages: enterprisePlanFeatureMessages,
            signupURLInfo: {
                urlDomain: window.location.origin,
                urlPath: (0, $b49hK.CTA_URL_PATH),
                shouldLocalize: true
            }
        }
    ];
    const messages = (0, $6x1qA.defineMessages)({
        unitCountInputTextRedesign: {
            id: "StrategyCollectionPriceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size"
        },
        unitCountInputTerm: {
            id: "StrategyCollectionPriceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        cardUnitCountTierRange: {
            id: "StrategyCollectionPriceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardEnterpriseMinimumCount: {
            id: "StrategyCollectionPriceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above"
        }
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $l9lQF.PriceFinderContextProvider), {
            dataProductKey: "strategyCollection",
            productPlans: productPlans,
            defaultUnitCount: 50,
            isAnnualBillingOnly: true,
            enterpriseMinimumCount: 50,
            contactURL: (0, $b49hK.CTA_URL_PATH),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OWgU.default), {
                        messages: messages,
                        serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.strategyCollection,
                        countryCode: props.countryCode
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $4Xtx9.Disclaimer), {})
                ]
            })
        })
    });
};

});
parcelRegister("esRX2", function(module, exports) {

$parcel$export(module.exports, "createPlanFeatureMessages", function () { return $4f8dba51759f94c4$export$8fd76139fda318d8; });

var $loA2J = parcelRequire("loA2J");
const $4f8dba51759f94c4$export$68568ac1e2cced1f = (highlightedFeatures)=>{
    return highlightedFeatures.map((highlight)=>({
            featureMessage: highlight.highlightedFeatureDetails ? {
                text: highlight.highlightedFeatureTitleExternal,
                content: ()=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: highlight.highlightedFeatureDetails
                        }
                    })
            } : highlight.highlightedFeatureTitleExternal,
            lozengeText: highlight.callOut
        }));
};
const $4f8dba51759f94c4$export$8fd76139fda318d8 = (content, planKey)=>{
    const plan = content === null || content === void 0 ? void 0 : content[planKey];
    return (plan === null || plan === void 0 ? void 0 : plan.highlightedFeaturesContainer) ? $4f8dba51759f94c4$export$68568ac1e2cced1f(plan.highlightedFeaturesContainer) : [];
};

});

parcelRegister("4Xtx9", function(module, exports) {

$parcel$export(module.exports, "Disclaimer", function () { return $8b09b9fc539da5d3$export$74f29a5c5ac28ae1; });
/* disclaimer.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $5ohHq = parcelRequire("5ohHq");
const $8b09b9fc539da5d3$export$74f29a5c5ac28ae1 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_b961rdnh"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            className: (0, $esG4f.default)([
                "_k48p1nn1 _vwz4gktf _1wybdlk8 _syaz1hlo"
            ]),
            style: {
                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
            },
            children: intl.formatMessage({
                id: "StrategyCollectionPriceFinder.disclaimer",
                defaultMessage: "This estimate isn\u2019t binding for either you or Atlassian. Figures shown here are intended to show an estimation of the final price, not the cost after taxes and other potential changes."
            })
        })
    });
};
const $8b09b9fc539da5d3$var$containerCss = null;
const $8b09b9fc539da5d3$var$textCss = null;

});




parcelRegister("hVOzm", function(module, exports) {

$parcel$export(module.exports, "TeamworkCollectionPricingPage", function () { return $dbbc21dbf8e1b62b$export$ed5df383947f6344; });

var $loA2J = parcelRequire("loA2J");

var $dT5kE = parcelRequire("dT5kE");

var $6uV1Z = parcelRequire("6uV1Z");
const $dbbc21dbf8e1b62b$export$ed5df383947f6344 = (props)=>{
    const { pricingContent: pricingContent, queryRef: queryRef } = props;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dT5kE.PricingContentContextProviderRelay), {
        productId: "teamwork-collection",
        pricingContent: pricingContent,
        // @ts-ignore
        queryRef: queryRef,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6uV1Z.TeamworkCollectionPricingPageTemplate), {})
    });
};

});
parcelRegister("6uV1Z", function(module, exports) {

$parcel$export(module.exports, "TeamworkCollectionPricingPageTemplate", function () { return $7ba3b9cd631ab71d$export$dc72c095d5764aad; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("gUyvS");
var $khjAx = parcelRequire("khjAx");
parcelRequire("kmJhl");
var $591nI = parcelRequire("591nI");
var $bofgW = parcelRequire("bofgW");

var $dT5kE = parcelRequire("dT5kE");
parcelRequire("3XyMp");
var $f8O3L = parcelRequire("f8O3L");
var $ceE90 = parcelRequire("ceE90");

var $j1oGG = parcelRequire("j1oGG");

var $51Zx0 = parcelRequire("51Zx0");

var $3FBn4 = parcelRequire("3FBn4");

var $1FqEx = parcelRequire("1FqEx");

var $8PL6n = parcelRequire("8PL6n");

var $awMjc = parcelRequire("awMjc");
const $7ba3b9cd631ab71d$export$dc72c095d5764aad = (props)=>{
    var _content_callToActionContainer, _content_callToActionContainer1, _questionsCtaContent_asset;
    const intl = (0, $f6qj2.default)();
    const content = (0, $dT5kE.usePricingContentContext)();
    const featuresCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[1];
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer1 = content.callToActionContainer) === null || _content_callToActionContainer1 === void 0 ? void 0 : _content_callToActionContainer1[0];
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _featuresCtaContent_text, _featuresCtaContent_url, _content_getMoreDetailsTitle, _content_additionalDetails, _questionsCtaContent_url, _questionsCtaContent_title, _questionsCtaContent_text, _questionsCtaContent_valueProposition;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8PL6n.TeamworkCollectionNavbar), {}),
        showFallback: content === null || content === void 0 ? void 0 : content.hasError,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1FqEx.ParentScrollTracking), {
            scrollTrackingEnabled: true,
            pageId: "teamwork-collection-pricing-page",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PageHeading), {
                    children: content === null || content === void 0 ? void 0 : content.headline
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $51Zx0.TeamworkCollectionPricingHero), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $awMjc.TeamworkCollectionPriceFinder), {
                    pricing: props.pricing,
                    countryCode: props.countryCode
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $khjAx.PricingFeatureTable), {
                    title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                    comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                    compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined,
                    linkValues: {
                        linkText: (_featuresCtaContent_text = featuresCtaContent === null || featuresCtaContent === void 0 ? void 0 : featuresCtaContent.text) !== null && _featuresCtaContent_text !== void 0 ? _featuresCtaContent_text : undefined,
                        linkHref: (_featuresCtaContent_url = featuresCtaContent === null || featuresCtaContent === void 0 ? void 0 : featuresCtaContent.url) !== null && _featuresCtaContent_url !== void 0 ? _featuresCtaContent_url : undefined
                    },
                    dataProductKey: "teamworkCollection"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $591nI.AtlassianGuardAddOnShared), {
                    headingText: intl.formatMessage({
                        id: "TeamworkCollection.pricing.atlassianGuard.heading",
                        defaultMessage: "Teamwork Collection Premium and Enterprise include Atlassian Guard Standard"
                    }),
                    bodyText: "",
                    ctaHref: (0, $3FBn4.useLocalizedHref)("/software/guard")
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $f8O3L.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1FqEx.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ceE90.PricingFaq), {
                            header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                            planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bofgW.QuestionsCta), {
                    product: "Teamwork Collection",
                    ctaHref: (_questionsCtaContent_url = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.url) !== null && _questionsCtaContent_url !== void 0 ? _questionsCtaContent_url : undefined,
                    questionsHeader: (_questionsCtaContent_title = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.title) !== null && _questionsCtaContent_title !== void 0 ? _questionsCtaContent_title : undefined,
                    priceAndLicensingLinkText: (_questionsCtaContent_text = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.text) !== null && _questionsCtaContent_text !== void 0 ? _questionsCtaContent_text : undefined,
                    questionsBody: (_questionsCtaContent_valueProposition = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.valueProposition) !== null && _questionsCtaContent_valueProposition !== void 0 ? _questionsCtaContent_valueProposition : undefined,
                    imageHref: questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : (_questionsCtaContent_asset = questionsCtaContent.asset) === null || _questionsCtaContent_asset === void 0 ? void 0 : _questionsCtaContent_asset.url
                })
            ]
        })
    });
};

});
parcelRegister("kmJhl", function(module, exports) {
$parcel$export(module.exports, "DataCenterSection", function () { return (parcelRequire("9376M")).DataCenterSection; });
$parcel$export(module.exports, "QuestionsCta", function () { return (parcelRequire("bofgW")).QuestionsCta; });
$parcel$export(module.exports, "DemoAddOn", function () { return (parcelRequire("jCXOw")).DemoAddOn; });
$parcel$export(module.exports, "AtlassianGuardAddOnShared", function () { return (parcelRequire("591nI")).AtlassianGuardAddOnShared; });

var $3fWYb = parcelRequire("3fWYb");
parcelRequire("gUyvS");
parcelRequire("5k7qk");
parcelRequire("gqIS0");
parcelRequire("fjYvS");
parcelRequire("5gDm1");
parcelRequire("2glvp");
parcelRequire("bofgW");
parcelRequire("jCXOw");
parcelRequire("591nI");

});
parcelRegister("3fWYb", function(module, exports) {
/* pricing-tiers.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");
const $f99d3fb69af8d7bf$var$sectionCss = null;
const $f99d3fb69af8d7bf$var$headerCss = null;
const $f99d3fb69af8d7bf$var$cardsWrapperCss = null;
const $f99d3fb69af8d7bf$var$cardWrapperCss = null;
const $f99d3fb69af8d7bf$var$costCss = null;
const $f99d3fb69af8d7bf$var$costAndQuantityColor = "#172b4d";
const $f99d3fb69af8d7bf$var$costLabelCss = null;
const $f99d3fb69af8d7bf$var$quantityCss = null;
const $f99d3fb69af8d7bf$var$footerWrapperCss = null;
const $f99d3fb69af8d7bf$var$PricingCard = ({ ctaEmphasis: ctaEmphasis, tier: tier, cost: cost, costLabel: costLabel, quantity: quantity, cta: cta, ctaUrl: ctaUrl, description1: description1, description2: description2, linkText: linkText, linkUrl: linkUrl })=>{
    const cardHeaderCss = [
        ctaEmphasis && null,
        !ctaEmphasis && null
    ];
    const ctaCss = [
        ctaEmphasis && null,
        !ctaEmphasis && null
    ];
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _bfhkcd5j _1h6d1hxd _16qso5yx _2rko1y44 _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4 _vwz411nn _y3gn1h6o _ca0qidpf _u5f3idpf _n3td1l27 _19bvidpf"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                className: (0, $esG4f.default)([
                    ctaEmphasis && "_bfhk1hxd _1wyb1k8s _k48pbfng _1dyznl7k _vwz411ph _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q1tcg _u5f31crf _n3td1tcg _19bv1crf _1bsb1osq",
                    !ctaEmphasis && "_11q7glyw _1wyb1k8s _k48pbfng _1dyznl7k _vwz411ph _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q1tcg _u5f31crf _n3td1tcg _19bv1crf _1bsb1osq"
                ]),
                children: tier
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_ect41pz4 _1wyb1ady _k48pni7l _vwz4kb7n _6rth1crf _1pfh1ylp"
                ]),
                style: {
                    "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                },
                children: cost
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_syazalr3 _1wyb1k92 _vwz4cjiy"
                ]),
                children: costLabel
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_syazalr3 _1wyboxwj _vwz411nn"
                ]),
                children: quantity
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                href: ctaUrl,
                className: (0, $esG4f.default)([
                    ctaEmphasis && "_bfhkrbzz _syaz12cp _k48pbfng _irr31cml _4cvx1cml _19it36id _2rko1l7b _1e0c1ule _1wyb7vkz _vwz4bs82 _6rth1tcg _1pfhzwfg _ca0qh72c _u5f37vkz _n3tdh72c _19bv7vkz _4bfu1snc _1hmsagmp _ajmmvv82 _v564p9y3",
                    !ctaEmphasis && "_bfhk1j28 _syaz1pd3 _k48p1nn1 _irr34m1f _4cvx1cml _19it36id _2rko1l7b _1e0c1ule _1wyb7vkz _vwz4bs82 _6rth1tcg _1pfhzwfg _ca0qh72c _u5f37vkz _n3tdh72c _19bv7vkz _4bfu1snc _1hmsagmp _ajmmvv82 _v564p9y3"
                ]),
                children: cta
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: description1
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: description2
            }),
            linkText && linkUrl && /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                href: linkUrl,
                children: linkText
            })
        ]
    });
};
const $f99d3fb69af8d7bf$export$8db7662682d3869a = ({ header: header, cards: cards, footer: footer })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1yd3vbgk _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1fra _1q51vbgk _43dsrbzz _59381r31 _yha28stv _1nmznqa1 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1 _xlt1idpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_1s18ahaf _14b5f2ck _syaz1bqd _ect41pz4 _k48pbfng _vwz411ph _19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0qzwfg _u5f37vkz _n3tdckbl _19bv7vkz _y3gn1h6o _1cqs1k8s _1u2qzwfg _1rfm1osq"
                ]),
                style: {
                    "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                },
                children: header
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4cvr1fhb _1e0c1txw _zulpzwfg _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz _1gde1bp4 _q5ugidpf _7tld1wug _14adidpf _4uro1wug _1rfmf2ck _bna31osq"
                ]),
                children: cards.map((card, index)=>/*#__PURE__*/ (0, $loA2J.jsx)($f99d3fb69af8d7bf$var$PricingCard, (0, $7Knp0._)({}, card), `PricingCard-${index}`))
            }),
            footer && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4cvr1h6o _bfhkcd5j _1h6d1hxd _16qso5yx _2rko1y44 _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4 _vwz411nn _y3gn1h6o _ca0qidpf _u5f3idpf _n3td1l27 _19bvidpf",
                    "_19pkzwfg _2hwx7vkz _otyrzwfg _18u07vkz _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _25gb1ylp _u9mw1ylp _13e01ylp _182g1ylp"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: footer
            })
        ]
    });
};
var $f99d3fb69af8d7bf$export$2e2bcd8739ae039 = $f99d3fb69af8d7bf$export$8db7662682d3869a;

});

parcelRegister("5k7qk", function(module, exports) {

$parcel$export(module.exports, "PricingTabs", function () { return $85c813c6e3f2d588$export$72a589327a08c3da; });
/* tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $9BfLx = parcelRequire("9BfLx");

var $1BHKA = parcelRequire("1BHKA");

var $5Sihc = parcelRequire("5Sihc");

var $5Kqyf = parcelRequire("5Kqyf");
parcelRequire("jiMfu");
var $jyOQy = parcelRequire("jyOQy");
const $85c813c6e3f2d588$var$tabStyles = null;
const $85c813c6e3f2d588$export$72a589327a08c3da = ({ jiraCalculatorComponent: jiraCalculatorComponent, confluenceCalculatorComponent: confluenceCalculatorComponent, trelloCalculatorComponent: trelloCalculatorComponent, loomCalculatorComponent: loomCalculatorComponent, dataProductKey: dataProductKey })=>{
    const intl = (0, $f6qj2.default)();
    const defaultProductKey = "nonProfitCalculator";
    const defaultJiraCalculatorComponent = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
            children: "Default Jira Component"
        });
    const defaultConfluenceCalculatorComponent = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
            children: "Default Confluence Component"
        });
    const defaultTrelloCalculatorComponent = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
            children: "Default Trello Component"
        });
    const defaultLoomCalculatorComponent = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
            children: "Default Loom Component"
        });
    const JiraComponent = jiraCalculatorComponent !== null && jiraCalculatorComponent !== void 0 ? jiraCalculatorComponent : defaultJiraCalculatorComponent;
    const ConfluenceComponent = confluenceCalculatorComponent !== null && confluenceCalculatorComponent !== void 0 ? confluenceCalculatorComponent : defaultConfluenceCalculatorComponent;
    const TrelloComponent = trelloCalculatorComponent !== null && trelloCalculatorComponent !== void 0 ? trelloCalculatorComponent : defaultTrelloCalculatorComponent;
    const LoomComponent = loomCalculatorComponent !== null && loomCalculatorComponent !== void 0 ? loomCalculatorComponent : defaultLoomCalculatorComponent;
    const possibleTabs = [
        {
            id: "jira",
            textLabel: intl.formatMessage({
                id: "PricingTabs.jira",
                defaultMessage: "Jira"
            }),
            component: typeof JiraComponent === "function" ? /*#__PURE__*/ (0, $loA2J.jsx)(JiraComponent, {}) : JiraComponent,
            iconBefore: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1BHKA.JiraMarkBrand), {
                className: "logoSize"
            }),
            isAvailable: Boolean(jiraCalculatorComponent)
        },
        {
            id: "confluence",
            textLabel: intl.formatMessage({
                id: "PricingTabs.confluence",
                defaultMessage: "Confluence"
            }),
            component: typeof ConfluenceComponent === "function" ? /*#__PURE__*/ (0, $loA2J.jsx)(ConfluenceComponent, {}) : ConfluenceComponent,
            iconBefore: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9BfLx.ConfluenceMarkBrand), {
                className: "logoSize"
            }),
            isAvailable: Boolean(confluenceCalculatorComponent)
        },
        {
            id: "loom",
            textLabel: intl.formatMessage({
                id: "PricingTabs.loom",
                defaultMessage: "Loom"
            }),
            component: typeof LoomComponent === "function" ? /*#__PURE__*/ (0, $loA2J.jsx)(LoomComponent, {}) : LoomComponent,
            iconBefore: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5Sihc.LoomMarkBrandV2), {
                className: "logoSize"
            }),
            isAvailable: Boolean(loomCalculatorComponent)
        },
        {
            id: "trello",
            textLabel: intl.formatMessage({
                id: "PricingTabs.trello",
                defaultMessage: "Trello"
            }),
            component: typeof TrelloComponent === "function" ? /*#__PURE__*/ (0, $loA2J.jsx)(TrelloComponent, {}) : TrelloComponent,
            iconBefore: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5Kqyf.TrelloMarkBrand), {
                className: "logoSize"
            }),
            isAvailable: Boolean(trelloCalculatorComponent)
        }
    ];
    const tabs = possibleTabs.filter((tab)=>tab.isAvailable);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_p12f1osq _1kde1ule _5pbc1f4h _mp6aglyw _1v4zidpf _1n3n1osq _si4cgrf3 _1p4fgrf3 _r7togrf3 _17a1grf3 _1ypridpf _n8lpka7h _9ss6idpf _cy2pka7h _11cq1txw _1b5s1h6o _1rvg1h6o _jmjjr3uz _inr21hxd _u4d1idpf _1v9nh2mm _7l98t94y _1bvkvle5 _1gvk1x1l _150515x9 _1afqkb7n _1b7v1crf _pu7u1crf _kqje1crf _16vm1crf _rclkownn _12lk189y _f40hu67f _wx5ou67f _qr3o14mz _1xry14mz _1lx01r31 _xx3h1r31 _1lleglyw _dqzjglyw _u4pp1o36 _12t91o36 _1lxtxja1 _xaq6xja1 _1s6ccs5v _1jp7cs5v _1xilrbzz _1jca1wug _16blt94y _2g4515iw _dt8dglyw _929l14y2 _15uvglyw _1schglyw _1qmzglyw _1fv4glyw _a47gglyw _fp1f7vkz _ipo11crf _mzrv1git _1plp1osq _1ckkidpf _o6gx1wug _1bmhidpf _196a1wug _mzhvidpf _113widpf _12kyidpf _1vg7idpf _w4c110yn _9kzd10yn _1qsfglyw _fe4v7vkz _1x987vkz _1pqlidpf _1lp010j7"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jyOQy.TabsCustom), {
            id: "pricingtabs",
            label: "pricing tabs",
            headerText: "",
            bodyText: "",
            className: "pricing-tabs",
            tabs: tabs,
            dataProductKey: dataProductKey !== null && dataProductKey !== void 0 ? dataProductKey : defaultProductKey,
            banner: true
        })
    });
};
$85c813c6e3f2d588$export$72a589327a08c3da.displayName = "TabbedCalculatorSection";

});
parcelRegister("5Sihc", function(module, exports) {

$parcel$export(module.exports, "LoomMarkBrandV2", function () { return $f1bb5b3980367c3d$export$e783a4d8175ce805; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $4J1z5 = parcelRequire("4J1z5");
const $f1bb5b3980367c3d$export$e783a4d8175ce805 = (_param)=>/*#__PURE__*/ {
    var { width: width = "100%", height: height = "100%", className: className } = _param, rest = (0, $akGnX._)(_param, [
        "width",
        "height",
        "className"
    ]);
    return (0, $loA2J.jsx)("svg", (0, $6iHNw._)((0, $7Knp0._)({
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M41 22.1094H31.0579L39.6682 17.1383L37.7774 13.8622L29.167 18.8334L34.1371 10.2237L30.861 8.33173L25.891 16.9414V7H22.109V16.9423L17.137 8.33173L13.862 10.2228L18.833 18.8324L10.2227 13.8622L8.33169 17.1373L16.942 22.1085H7V25.8906H16.9411L8.33169 30.8617L10.2227 34.1378L18.8321 29.1676L13.8611 37.7772L17.137 39.6682L22.1081 31.0577V41H25.8901V31.0586L30.8601 39.6682L34.136 37.7772L29.1651 29.1667L37.7754 34.1378L39.6664 30.8617L31.057 25.8915H40.998V22.1094H41ZM24 29.1437C21.1483 29.1437 18.8368 26.8324 18.8368 23.9805C18.8368 21.1287 21.1483 18.8172 24 18.8172C26.8517 18.8172 29.1631 21.1287 29.1631 23.9805C29.1631 26.8324 26.8517 29.1437 24 29.1437Z",
            fill: "#625DF5"
        })
    }));
};
$f1bb5b3980367c3d$export$e783a4d8175ce805.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4J1z5))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4J1z5))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4J1z5))).number
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4J1z5))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4J1z5))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4J1z5))).number
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4J1z5))).string
};

});

parcelRegister("jiMfu", function(module, exports) {
$parcel$export(module.exports, "TabsCustom", function () { return (parcelRequire("jyOQy")).TabsCustom; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("jyOQy")).TabsCustom; });

var $jyOQy = parcelRequire("jyOQy");

});
parcelRegister("jyOQy", function(module, exports) {

$parcel$export(module.exports, "TabsCustom", function () { return $39f05605f83ebefc$export$da3a983bae6b9d3a; });
/* tabs-custom.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");
parcelRequire("gXzhc");
var $fYNW7 = parcelRequire("fYNW7");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");
const $39f05605f83ebefc$var$CustomTabsStyle = null;
const $39f05605f83ebefc$export$da3a983bae6b9d3a = ({ id: id, label: label, headerText: headerText, bodyText: bodyText, tabs: tabs, dataProductKey: dataProductKey, colors: colors, ctaProps: ctaProps, linkPosition: linkPosition = "bottom", backgroundProperties: backgroundProperties, className: className, banner: banner })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.StyledBackground), (0, $6iHNw._)((0, $7Knp0._)({}, backgroundProperties), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1yt41d5t _13zni5hb _15tx1jx0",
                className
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                        headerText: headerText,
                        headerType: "h2",
                        bodyText: bodyText,
                        isCentered: true,
                        ctaProps: linkPosition == "top" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? ctaProps : {}
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fYNW7.TabGroup), {
                        colors: colors,
                        tabContentType: "custom",
                        tabs: tabs,
                        id: id,
                        label: label,
                        dataProductKey: dataProductKey,
                        banner: banner
                    })
                }),
                linkPosition == "bottom" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_y3gn1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), (0, $7Knp0._)({}, ctaProps.primaryLinkProps))
                    })
                }) : null
            ]
        })
    }));
};

});
parcelRegister("gXzhc", function(module, exports) {
$parcel$export(module.exports, "Quote", function () { return (parcelRequire("fYNW7")).Quote; });
$parcel$export(module.exports, "TabGroup", function () { return (parcelRequire("fYNW7")).TabGroup; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("fYNW7")).TabGroup; });

var $fYNW7 = parcelRequire("fYNW7");

});
parcelRegister("fYNW7", function(module, exports) {

$parcel$export(module.exports, "Quote", function () { return $13325c239d889a62$export$82b8d343c504672; });
$parcel$export(module.exports, "TabGroup", function () { return $13325c239d889a62$export$85fd4ed3b8ca1010; });
/* tab-group.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");

var $lrVTP = parcelRequire("lrVTP");
parcelRequire("9HFEq");
var $dbhgV = parcelRequire("dbhgV");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");

var $bhreu = parcelRequire("bhreu");
parcelRequire("isSvf");
var $lxS8L = parcelRequire("lxS8L");
const $13325c239d889a62$var$bannerStyle = null;
const $13325c239d889a62$var$TabGroupStyle = null;
const $13325c239d889a62$var$quoteSidebar = null;
const $13325c239d889a62$var$tabPanel = null;
const $13325c239d889a62$var$contentBlockStyle = null;
const $13325c239d889a62$var$cardRules = {
    6: 1,
    5: 2,
    4: 2,
    3: 3,
    2: 4
};
const $13325c239d889a62$var$CardStyleDisplay = (tab)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
        children: tab.cards.map((card, index)=>{
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dbhgV.Card), (0, $6iHNw._)((0, $7Knp0._)({}, card), {
                aspectRatio: tab.cards.length < 3 ? "16/9" : "3/2"
            }), index);
        })
    });
};
const $13325c239d889a62$export$625d95e4189a6523 = (props)=>{
    var _tabDisplay_videoProps_videoLink, _tabDisplay_imageProps_src, _tabDisplay_imageProps_alt;
    const tabDisplay = props.tab.display;
    let elementToDisplay = null;
    if ("videoProps" in tabDisplay && ((_tabDisplay_videoProps_videoLink = tabDisplay.videoProps.videoLink) === null || _tabDisplay_videoProps_videoLink === void 0 ? void 0 : _tabDisplay_videoProps_videoLink.length)) elementToDisplay = /*#__PURE__*/ (0, $loA2J.jsx)((0, $lxS8L.Video), (0, $7Knp0._)({}, tabDisplay.videoProps));
    else if ("imageProps" in tabDisplay && ((_tabDisplay_imageProps_src = tabDisplay.imageProps.src) === null || _tabDisplay_imageProps_src === void 0 ? void 0 : _tabDisplay_imageProps_src.length) && ((_tabDisplay_imageProps_alt = tabDisplay.imageProps.alt) === null || _tabDisplay_imageProps_alt === void 0 ? void 0 : _tabDisplay_imageProps_alt.length)) elementToDisplay = /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), (0, $7Knp0._)({}, tabDisplay.imageProps));
    else if (/*#__PURE__*/ (0, $iSvIT.isValidElement)(tabDisplay)) elementToDisplay = tabDisplay;
    return elementToDisplay;
};
const $13325c239d889a62$export$82b8d343c504672 = (props)=>{
    var _props_colors;
    const backgroundImageColor = ((_props_colors = props.colors) === null || _props_colors === void 0 ? void 0 : _props_colors.quoteColor) ? `linear-gradient(90deg, transparent, ${props.colors.quoteColor})` : "transparent";
    const quoteWrapperClass = props.isDisplayInSmScreen ? "quote-wrapper isDisplayInSmScreen" : "quote-wrapper";
    const quoteStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_y3gn1e5h _19pkidpf _2hwxidpf _otyr1tcg _18u0idpf _ca0q1ul9 _u5f312am _n3td1ul9 _19bvidpf _2rko1ygb _1itk1mlj _urbdidpf _bh33qgp8 _z1c11pz4 _1r1x8n31 _sjb1gktf _1pntidpf _1pugidpf _s3jyidpf _177hangw _1i5midpf _utopidpf _rggridpf _1ie3idpf _14sxoxwj _1uc8angw _sugaglyw _1kmxidpf _1ggmidpf _1ykzidpf _1maeidpf _p0bo1ule",
            quoteWrapperClass
        ]),
        style: {
            "--_xnxqej": (0, $43MIc.default)(backgroundImageColor),
            "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
        },
        children: [
            props.image ? props.image : null,
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: "quote-blurb",
                children: props.quote
            }),
            props.name ? /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: "quote-name",
                children: props.name
            }) : null,
            props.company ? /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: "quote-company",
                children: props.company
            }) : null
        ]
    });
};
const $13325c239d889a62$var$QuoteTextImage = (tab, colors)=>{
    var _tab_headerTextType;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
        layout: "4-8",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_y3gn1e5h"
                ]),
                children: [
                    tab.headerText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                        headerText: tab.headerText,
                        bodyText: tab.bodyText,
                        headerType: (_tab_headerTextType = tab.headerTextType) !== null && _tab_headerTextType !== void 0 ? _tab_headerTextType : "h3",
                        iconName: tab.iconName,
                        className: (0, $esG4f.default)([
                            "_p12f1osq _19pkidpf _2hwx1wug _otyr1tcg _18u01wug _gltebxu3"
                        ])
                    }) : null,
                    tab.quote ? /*#__PURE__*/ (0, $loA2J.jsx)($13325c239d889a62$export$82b8d343c504672, {
                        image: tab.quoteImageProps && /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), (0, $7Knp0._)({}, tab.quoteImageProps)),
                        quote: tab.quote,
                        name: tab.name,
                        company: tab.company,
                        isDisplayInSmScreen: tab.isDisplayQuoteInSmScreen || false,
                        colors: colors
                    }) : null,
                    tab.ctaProps && tab.ctaProps.primaryLinkProps ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), (0, $7Knp0._)({}, tab.ctaProps.primaryLinkProps)) : null
                ]
            }),
            $13325c239d889a62$export$625d95e4189a6523({
                tab: tab
            })
        ]
    });
};
const $13325c239d889a62$var$TextImageFullWidth = (tab)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            children: [
                tab.headerText ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_p12f1osq _19pkidpf _2hwx1wug _otyr1tcg _18u01wug _gltebxu3",
                        "content-block"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                        headerText: tab.headerText,
                        bodyText: tab.bodyText,
                        headerType: "h2",
                        isCentered: true
                    })
                }) : null,
                $13325c239d889a62$export$625d95e4189a6523({
                    tab: tab
                })
            ]
        })
    });
};
const $13325c239d889a62$var$TabContent = (tabContentType, tab, tabsLength, colors)=>{
    const cardRule = $13325c239d889a62$var$cardRules[tabsLength];
    switch(tabContentType){
        case "custom":
            if (!("component" in tab)) throw new Error("Must provide a `customComponent` JSX node");
            return tab.component;
        case "cards":
            if (!("cards" in tab)) throw new Error("Must provide an array of card values in the `cards` tab prop");
            else if (tab.cards.length > cardRule) throw new Error(`For a group of ${tabsLength} tabs, no more than ${cardRule} cards per tab`);
            return $13325c239d889a62$var$CardStyleDisplay(tab);
        case "quoteTextImage":
            if (!("display" in tab)) throw new Error("Please provide image or video props");
            return $13325c239d889a62$var$QuoteTextImage(tab, colors);
        case "textImageFullWidth":
            if (!("display" in tab)) throw new Error("Please provide image or video props");
            return $13325c239d889a62$var$TextImageFullWidth(tab);
        default:
            return null;
    }
};
const $13325c239d889a62$var$updateURL = (tabId)=>{
    const newParams = new URLSearchParams(window.location.search);
    if (tabId) {
        newParams.set("tab", tabId);
        window.history.pushState({}, "", `?${newParams.toString()}`);
    }
};
const $13325c239d889a62$var$getTabStyle = (colors, isActive)=>{
    if (isActive) return {
        backgroundColor: (colors === null || colors === void 0 ? void 0 : colors.activeBG) || "#b2d4ff",
        color: (colors === null || colors === void 0 ? void 0 : colors.activeText) || "#091e42",
        borderColor: (colors === null || colors === void 0 ? void 0 : colors.activeBG) || "#b2d4ff",
        hoverBG: (colors === null || colors === void 0 ? void 0 : colors.activeBG) || "#b2d4ff",
        hoverText: (colors === null || colors === void 0 ? void 0 : colors.activeText) || "#091e42",
        activeBGColor: (colors === null || colors === void 0 ? void 0 : colors.activeBG) || "#b2d4ff",
        hoverBGColor: (colors === null || colors === void 0 ? void 0 : colors.activeBG) || "#b2d4ff"
    };
    return {
        backgroundColor: (colors === null || colors === void 0 ? void 0 : colors.defaultBG) || "#f4f5f7",
        color: (colors === null || colors === void 0 ? void 0 : colors.defaultText) || "#091e42",
        borderColor: "transparent",
        hoverBG: (colors === null || colors === void 0 ? void 0 : colors.hoverBG) || "#ebecf0",
        hoverText: (colors === null || colors === void 0 ? void 0 : colors.hoverText) || "#091e42",
        activeBGColor: (colors === null || colors === void 0 ? void 0 : colors.activeBG) || "#b2d4ff",
        hoverBGColor: (colors === null || colors === void 0 ? void 0 : colors.hoverBG) || "#ebecf0"
    };
};
const $13325c239d889a62$var$TabGroupInner = ({ index: index, currentTab: currentTab, tab: tab, colors: colors, dataProductKey: dataProductKey, onDesktopClickHandler: onDesktopClickHandler, setCurrentTab: setCurrentTab })=>{
    const isActive = index === currentTab;
    const { activeBGColor: activeBGColor, hoverBGColor: hoverBGColor, backgroundColor: backgroundColor, color: color, borderColor: borderColor, hoverBG: hoverBG, hoverText: hoverText } = $13325c239d889a62$var$getTabStyle(colors, isActive);
    const tabStyle = null;
    var _tab_iconBefore;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("button", {
        type: "button",
        role: "tab",
        value: tab.textLabel,
        "aria-selected": index === currentTab,
        "aria-controls": tab.id,
        id: tab.id,
        "data-event-component": "linkButton",
        "data-event-container": "tabContent",
        "data-event": "clicked",
        "data-label": tab.textLabel,
        "data-label-english": tab.dataLabelEnglish,
        "data-product-key": dataProductKey,
        onClick: (event)=>{
            setCurrentTab(index);
            $13325c239d889a62$var$updateURL(tab.id);
            if (onDesktopClickHandler) onDesktopClickHandler(event);
        },
        className: (0, $esG4f.default)([
            "_80omtlke _2rko12am _vchhusvi _1y1m1u8q _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _r06hglyw _1dqonqa1 _189eyh40 _1h6d1j28 _ect41td8 _1dyz1d98 _1seqidpf _zecv1wug _1uldidpf _1pp41wug _3zq41ule _1blx1osq _3p1c1k92 _so7d1qy7 _bfhkaxbu _syaz1aj3 _jomr10a2 _irr310a2 _f8pj7ny5 _30l37ny5 _858u1srq _4cvx1srq _1qyg1r31 _1vu3glyw _1j6qidpf _o6871w4s _q4ztj7jn"
        ]),
        style: {
            "--_1ly4823": (0, $43MIc.default)(backgroundColor),
            "--_1ylxx6h": (0, $43MIc.default)(color),
            "--_mf9og": (0, $43MIc.default)(hoverBG),
            "--_3siqzd": (0, $43MIc.default)(hoverText),
            "--_37cwmb": (0, $43MIc.default)(borderColor),
            "--_1kkre8f": (0, $43MIc.default)(activeBGColor),
            "--_h2utlw": (0, $43MIc.default)(hoverBGColor)
        },
        children: [
            (_tab_iconBefore = tab.iconBefore) !== null && _tab_iconBefore !== void 0 ? _tab_iconBefore : tab.iconBefore,
            tab.isForceDisplayTextLabelOnPill ? tab.textLabel : "headerText" in tab ? tab.headerText : tab.textLabel
        ]
    }, `tab-${index}-${tab.id}`);
};
const $13325c239d889a62$var$TabOption = ({ index: index, currentTab: currentTab, tab: tab, colors: colors, dataProductKey: dataProductKey })=>{
    const isActive = index === currentTab;
    const { activeBGColor: activeBGColor, hoverBGColor: hoverBGColor, backgroundColor: backgroundColor, color: color, borderColor: borderColor, hoverBG: hoverBG, hoverText: hoverText } = $13325c239d889a62$var$getTabStyle(colors, isActive);
    const tabStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("option", {
        "data-index": index,
        "data-id": tab.id,
        "data-event-component": "linkButton",
        "data-event-container": "tabContent",
        "data-event": "clicked",
        "data-label": tab.textLabel,
        "data-product-key": dataProductKey,
        value: tab.textLabel,
        "aria-selected": index === currentTab,
        "aria-describedby": `tab-${tab.id}`,
        className: (0, $esG4f.default)([
            "_80omtlke _2rko12am _vchhusvi _1y1m1u8q _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _r06hglyw _1dqonqa1 _189eyh40 _1h6d1j28 _ect41td8 _1dyz1d98 _1seqidpf _zecv1wug _1uldidpf _1pp41wug _3zq41ule _1blx1osq _3p1c1k92 _so7d1qy7 _bfhkaxbu _syaz1aj3 _jomr10a2 _irr310a2 _f8pj7ny5 _30l37ny5 _858u1srq _4cvx1srq _1qyg1r31 _1vu3glyw _1j6qidpf _o6871w4s _q4ztj7jn"
        ]),
        style: {
            "--_1ly4823": (0, $43MIc.default)(backgroundColor),
            "--_1ylxx6h": (0, $43MIc.default)(color),
            "--_mf9og": (0, $43MIc.default)(hoverBG),
            "--_3siqzd": (0, $43MIc.default)(hoverText),
            "--_37cwmb": (0, $43MIc.default)(borderColor),
            "--_1kkre8f": (0, $43MIc.default)(activeBGColor),
            "--_h2utlw": (0, $43MIc.default)(hoverBGColor)
        },
        children: tab.isForceDisplayTextLabelOnPill ? tab.textLabel : "headerText" in tab ? tab.headerText : tab.textLabel
    }, `option-${index}-${tab.id}`);
};
const $13325c239d889a62$var$TabSelect = ({ id: id, currentTab: currentTab, tabs: tabs, colors: colors, updateURL: updateURL, onMobileChangeHandler: onMobileChangeHandler, setCurrentTab: setCurrentTab, dataProductKey: dataProductKey })=>{
    var _tabs_currentTab, _tabs_;
    const isActive = true; // Always active for TabSelect
    const { activeBGColor: activeBGColor, hoverBGColor: hoverBGColor, backgroundColor: backgroundColor, color: color, borderColor: borderColor, hoverBG: hoverBG, hoverText: hoverText } = $13325c239d889a62$var$getTabStyle(colors, isActive);
    const tabStyle = null;
    const handleChange = (event)=>{
        var _event_target_selectedOptions_, _event_target, _event_target_selectedOptions_1, _event_target1;
        const selectedIndex = event === null || event === void 0 ? void 0 : (_event_target = event.target) === null || _event_target === void 0 ? void 0 : (_event_target_selectedOptions_ = _event_target.selectedOptions[0]) === null || _event_target_selectedOptions_ === void 0 ? void 0 : _event_target_selectedOptions_.dataset["index"];
        const selectedId = event === null || event === void 0 ? void 0 : (_event_target1 = event.target) === null || _event_target1 === void 0 ? void 0 : (_event_target_selectedOptions_1 = _event_target1.selectedOptions[0]) === null || _event_target_selectedOptions_1 === void 0 ? void 0 : _event_target_selectedOptions_1.dataset["id"];
        setCurrentTab(Number(selectedIndex));
        updateURL(selectedId);
        if (onMobileChangeHandler) onMobileChangeHandler(event);
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("select", {
        id: id,
        className: (0, $esG4f.default)([
            "_80omtlke _2rko12am _vchhusvi _1y1m1u8q _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _r06hglyw _1dqonqa1 _189eyh40 _1h6d1j28 _ect41td8 _1dyz1d98 _1seqidpf _zecv1wug _1uldidpf _1pp41wug _3zq41ule _1blx1osq _3p1c1k92 _so7d1qy7 _bfhkaxbu _syaz1aj3 _jomr10a2 _irr310a2 _f8pj7ny5 _30l37ny5 _858u1srq _4cvx1srq _1qyg1r31 _1vu3glyw _1j6qidpf _o6871w4s _q4ztj7jn",
            "select"
        ]),
        value: ((_tabs_currentTab = tabs[currentTab]) === null || _tabs_currentTab === void 0 ? void 0 : _tabs_currentTab.textLabel) || ((_tabs_ = tabs[0]) === null || _tabs_ === void 0 ? void 0 : _tabs_.textLabel),
        onChange: handleChange,
        style: {
            "--_1ly4823": (0, $43MIc.default)(backgroundColor),
            "--_1ylxx6h": (0, $43MIc.default)(color),
            "--_mf9og": (0, $43MIc.default)(hoverBG),
            "--_3siqzd": (0, $43MIc.default)(hoverText),
            "--_37cwmb": (0, $43MIc.default)(borderColor),
            "--_1kkre8f": (0, $43MIc.default)(activeBGColor),
            "--_h2utlw": (0, $43MIc.default)(hoverBGColor)
        },
        children: tabs.map((tab, index)=>{
            return /*#__PURE__*/ (0, $loA2J.jsx)($13325c239d889a62$var$TabOption, {
                index: index,
                tab: tab,
                colors: colors,
                dataProductKey: dataProductKey,
                currentTab: currentTab
            }, `option-${index}-${tab.id}`);
        })
    });
};
const $13325c239d889a62$export$85fd4ed3b8ca1010 = (props)=>{
    var _tabsMap_currentTab, _tabsMap_currentTab1;
    const { tabContentType: tabContentType, tabs: tabs, colors: colors, id: id, label: label, dataProductKey: dataProductKey, onDesktopClickHandler: onDesktopClickHandler, onMobileChangeHandler: onMobileChangeHandler, banner: banner } = props;
    const location = (0, $lrVTP.useLocation)();
    const [currentTab, setCurrentTab] = (0, $iSvIT.useState)(()=>{
        var _location_search;
        const params = new URLSearchParams((_location_search = location.search) !== null && _location_search !== void 0 ? _location_search : window.location.search);
        const paramID = params.get("tab");
        const matchingTab = tabs.findIndex((tab)=>{
            return tab.id === paramID;
        });
        if (matchingTab >= 0) return matchingTab;
        return 0;
    });
    if (!id || !label) throw new Error('"id" and "label" props are required for accessibility!');
    if (tabs.length > 6 || tabs.length < 1) throw new Error("Must have a minimum of 1 and a maximum of 6 tabs per group!");
    const tabsMap = tabs.reduce(function(map, obj, index) {
        map[index] = obj;
        return map;
    }, {});
    const MobileSelect = ()=>{
        const selectContainerColor = (colors === null || colors === void 0 ? void 0 : colors.activeText) ? colors.activeText : "#091e42";
        const selectContainerStyles = null;
        return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1bah1h6o _suga1txw _181nglyw _12xhh2mm _d7qx1osq _c2wd1pna _qj6jstnw _14z6gktf _7x8didpf _jm44idpf _wppf1wug _6mc91wug _1yyz1wug _c8mx1wug _1vd7171q",
                "select-container"
            ]),
            style: {
                "--_1uth3n3": (0, $43MIc.default)(selectContainerColor)
            },
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: "select-container-inner",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                        htmlFor: id,
                        "aria-label": label,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)($13325c239d889a62$var$TabSelect, {
                            id: id,
                            currentTab: currentTab,
                            tabs: tabs,
                            colors: colors,
                            updateURL: $13325c239d889a62$var$updateURL,
                            setCurrentTab: setCurrentTab,
                            dataProductKey: dataProductKey,
                            onMobileChangeHandler: onMobileChangeHandler
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                        width: "15",
                        height: "8",
                        viewBox: "0 0 15 8",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            d: "M1.5 1L7.5 7L13.5 1",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_p12f1osq",
            "tab-group"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                role: "tablist",
                className: (0, $esG4f.default)([
                    "_sugaglyw _1cj31txw _196r1h6o _270t1g80 _wmdl7vkz"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: "tab-group-inner",
                        children: [
                            tabs.map((tab, index)=>{
                                return /*#__PURE__*/ (0, $loA2J.jsx)($13325c239d889a62$var$TabGroupInner, {
                                    tab: tab,
                                    index: index,
                                    colors: colors,
                                    dataProductKey: dataProductKey,
                                    onDesktopClickHandler: onDesktopClickHandler,
                                    setCurrentTab: setCurrentTab,
                                    currentTab: currentTab
                                }, `tab-${index}-${tab.id}`);
                            }),
                            banner && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1wyb1crf _syazcd5j _11q717la _y3gn1h6o _1bsb1osq _1dyzt94y _k48pni7l _vwz4f6fq _ca0q1l7b _u5f31l7b _n3td1l7b _19bv1l7b _1p1dangw"
                                ]),
                                style: {
                                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                                },
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "tabGroup.banner",
                                    defaultMessage: "showing 75% off"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)(MobileSelect, {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: "tab-panels",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_19pkgktf _2hwx1wug _otyridpf _18u01wug _mderglyw",
                        "tab-panel"
                    ]),
                    "aria-hidden": false,
                    id: `tab-${(_tabsMap_currentTab = tabsMap[currentTab]) === null || _tabsMap_currentTab === void 0 ? void 0 : _tabsMap_currentTab.id}`,
                    children: $13325c239d889a62$var$TabContent(tabContentType, tabsMap[currentTab], tabs.length, colors)
                }, `tabpanel-${currentTab}-${(_tabsMap_currentTab1 = tabsMap[currentTab]) === null || _tabsMap_currentTab1 === void 0 ? void 0 : _tabsMap_currentTab1.id}`)
            })
        ]
    });
};

});
parcelRegister("isSvf", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return (parcelRequire("lxS8L")).Video; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("lxS8L")).Video; });

var $lxS8L = parcelRequire("lxS8L");

});
parcelRegister("lxS8L", function(module, exports) {

$parcel$export(module.exports, "Video", function () { return $ed253e67f972fd3a$export$ae01dedf5c052bb; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $ed253e67f972fd3a$var$videoStyle = (ratio)=>{
    const aspectRatioCSS = ratio && ratio !== "none" ? {
        aspectRatio: ratio,
        objectFit: "cover"
    } : {};
    return (0, $7Knp0._)({
        maxWidth: "100%"
    }, aspectRatioCSS);
};
const $ed253e67f972fd3a$export$ae01dedf5c052bb = ({ videoLink: videoLink, videoType: videoType, videoPreviewImage: videoPreviewImage, loop: loop = true, muted: muted = true, aspectRatio: aspectRatio, alternativeSources: alternativeSources, className: className, fallbackText: fallbackText, onEnded: onEnded, children: children })=>{
    const videoRef = (0, $iSvIT.useRef)(null);
    // reload video player if video source prop changes dynamically
    (0, $iSvIT.useEffect)(()=>{
        var _videoRef_current;
        (_videoRef_current = videoRef.current) === null || _videoRef_current === void 0 ? void 0 : _videoRef_current.load();
    }, [
        videoLink
    ]);
    return(// eslint-disable-next-line jsx-a11y/media-has-caption
    /*#__PURE__*/ (0, $loA2J.jsxs)("video", {
        playsInline: true,
        muted: muted,
        preload: "auto",
        poster: videoPreviewImage,
        autoPlay: true,
        className: className,
        style: $ed253e67f972fd3a$var$videoStyle(aspectRatio),
        loop: loop,
        ref: videoRef,
        onEnded: onEnded,
        children: [
            fallbackText,
            /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                src: videoLink,
                type: `video/${videoType ? videoType : "mp4"}`
            }),
            alternativeSources ? alternativeSources.map((source, index)=>{
                return /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    src: source.videoLink,
                    type: `video/${source.videoType ? source.videoType : "mp4"}`
                }, index);
            }) : null,
            children
        ]
    }));
};

});







parcelRegister("gqIS0", function(module, exports) {
parcelRequire("7OWgU");

});

parcelRegister("fjYvS", function(module, exports) {
$parcel$export(module.exports, "DataCenterSection", function () { return (parcelRequire("9376M")).DataCenterSection; });
parcelRequire("9376M");

});
parcelRegister("9376M", function(module, exports) {

$parcel$export(module.exports, "DataCenterSection", function () { return $23021f66432e9c0a$export$3e74b76dd9e071d6; });
/* data-center-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $91nJf = parcelRequire("91nJf");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");
const $23021f66432e9c0a$var$ctaButtonStyles = null;
const $23021f66432e9c0a$var$dataCenterSectionContainer = null;
const $23021f66432e9c0a$var$headingStyle = null;
const $23021f66432e9c0a$var$descriptionStyle = null;
const $23021f66432e9c0a$var$rightSection = null;
const $23021f66432e9c0a$var$ctaWrapper = null;
const $23021f66432e9c0a$var$svgStyles = null;
const $23021f66432e9c0a$export$64adec1d96f4a7a4 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: `https://wac-cdn.atlassian.com/misc-assets/webp-images/Illo_DataCenter.svg`,
            alt: ""
        },
        className: (0, $esG4f.default)([
            "_1bsb112f _4t3i1jj5 _1s4pawd2 _1kne10uk"
        ])
    });
};
const $23021f66432e9c0a$export$3e74b76dd9e071d6 = (props)=>{
    var _props_buttonCta, _props_buttonCta1, _props_linkCta, _props_linkCta1;
    const intl = (0, $f6qj2.default)();
    const title = intl.formatMessage({
        id: "Pricing.DataCenterSection.title",
        defaultMessage: "Data Center Products"
    });
    const description = intl.formatMessage({
        id: "Pricing.DataCenterSection.description",
        defaultMessage: "Data Center is our self-managed product offering for customers with strict regulatory or security requirements. To learn more about this offering, please contact us."
    });
    const buttonCtaLabel = intl.formatMessage({
        id: "Pricing.DataCenterSection.buttonCta",
        defaultMessage: "Contact Us"
    });
    const linkCtaLabel = intl.formatMessage({
        id: "Pricing.DataCenterSection.linkCta",
        defaultMessage: "Learn more"
    });
    const buttonCtaHref = `https://www.atlassian.com${(0, $3FBn4.useLocalizedHref)("/enterprise/contact?formType=product-features")}`;
    const linkCtaHref = `https://www.atlassian.com${(0, $3FBn4.useLocalizedHref)("/enterprise/data-center")}`;
    var _props_title, _props_description, _props_buttonCta_href, _props_buttonCta_label, _props_linkCta_label, _props_linkCta_href;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_bfhk17la _mkrz1ohv _1e0c1txw _4cvr1y6m _1bah1h6o _zulpvbgk _ca0q1et3 _u5f313rr _n3td88uy _19bv13rr _2osnqslr _8fz61fdn _tl281et3 _axwi1l27 _1hwcvbgk _sp8t1l27 _1s4p1osq _1gde1bp4"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)($23021f66432e9c0a$export$64adec1d96f4a7a4, {}),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_syazcd5j _p12fukw8 _8fz61im0"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        id: "data-center-section-heading",
                        className: (0, $esG4f.default)([
                            "_1wybzwfg _vwz410mc _19pkidpf _2hwxidpf _otyr7vkz _18u0idpf _so7d1f4h _19q11u1b _1cqs1tcg _1bys1ul9"
                        ]),
                        children: (_props_title = props.title) !== null && _props_title !== void 0 ? _props_title : title
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_1wyb7vkz _vwz41tcg _6rth1tcg"
                        ]),
                        children: (_props_description = props.description) !== null && _props_description !== void 0 ? _props_description : description
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_4cvr1h6o _1e0c1txw _zulp7vkz _1gde1bp4 _1rfmwz92"
                        ]),
                        children: [
                            props.buttonCta !== null && /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                                size: "small",
                                variant: "secondary",
                                color: "white",
                                colorAgainst: "other",
                                href: (_props_buttonCta_href = (_props_buttonCta = props.buttonCta) === null || _props_buttonCta === void 0 ? void 0 : _props_buttonCta.href) !== null && _props_buttonCta_href !== void 0 ? _props_buttonCta_href : buttonCtaHref,
                                className: (0, $esG4f.default)([
                                    "_4t3i1ylp _1bsbwz92 _o5721q9c"
                                ]),
                                children: (_props_buttonCta_label = (_props_buttonCta1 = props.buttonCta) === null || _props_buttonCta1 === void 0 ? void 0 : _props_buttonCta1.label) !== null && _props_buttonCta_label !== void 0 ? _props_buttonCta_label : buttonCtaLabel
                            }),
                            props.linkCta !== null && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                bgColor: "bgBlackBlue",
                                text: (_props_linkCta_label = (_props_linkCta = props.linkCta) === null || _props_linkCta === void 0 ? void 0 : _props_linkCta.label) !== null && _props_linkCta_label !== void 0 ? _props_linkCta_label : linkCtaLabel,
                                href: (_props_linkCta_href = (_props_linkCta1 = props.linkCta) === null || _props_linkCta1 === void 0 ? void 0 : _props_linkCta1.href) !== null && _props_linkCta_href !== void 0 ? _props_linkCta_href : linkCtaHref,
                                id: "data-center-section-link",
                                ariaLabelledby: "data-center-section-link data-center-section-heading"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$23021f66432e9c0a$export$3e74b76dd9e071d6.displayName = "DataCenterSection";

});


parcelRegister("5gDm1", function(module, exports) {
/* addon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $8ohE3 = parcelRequire("8ohE3");

var $1UUq1 = parcelRequire("1UUq1");
const $9fa9f1a5b1eedc13$var$addonContainerCss = null;
const $9fa9f1a5b1eedc13$var$sectionLeftCss = null;
const $9fa9f1a5b1eedc13$var$sectionRightCss = null;
const $9fa9f1a5b1eedc13$var$headingTextCss = null;
const $9fa9f1a5b1eedc13$var$bodyTextCss = null;
const $9fa9f1a5b1eedc13$var$featureListCss = null;
const $9fa9f1a5b1eedc13$var$featureListItemCss = null;
const $9fa9f1a5b1eedc13$export$b4fbd0ed3ac70e71 = ({ logo: logo, heading: heading, subheading: subheading, features: features, learnMore: learnMore, imgSrc: imgSrc, imgAlt: imgAlt })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4 _2rkogktf _bfhku67f _16qsdtw3 _zulpftgi _1bsb1osq _p12f16yw _9959vrvc _a64kzwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        children: logo
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                        className: (0, $esG4f.default)([
                            "_1wybqslr _k48p1nn1 _vwz41f4h _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1q51183y _kqswh2mm"
                        ]),
                        children: heading
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1q511y44"
                        ]),
                        children: subheading
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                        className: (0, $esG4f.default)([
                            "_2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1pfh183y _6rth1tcg"
                        ]),
                        children: features.map((feature, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("li", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _4cvrv2br _zulpftgi _1q511y44"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8ohE3))), {
                                        size: "medium",
                                        label: "",
                                        primaryColor: "#44546F"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        children: feature
                                    })
                                ]
                            }, index))
                    }),
                    learnMore && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        text: learnMore.text,
                        type: "primary",
                        href: learnMore.href,
                        onClick: learnMore.onClick
                    })
                ]
            }),
            imgSrc && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _je3o1txw _vu061h6o _1i7q10sk"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                    src: imgSrc,
                    alt: imgAlt,
                    height: 268,
                    width: 504
                })
            })
        ]
    });
};
const $9fa9f1a5b1eedc13$export$e80698ec11357cbb = {
    eventName: "pricingAddonLearnMoreClicked",
    eventType: "ui",
    eventComponent: "linkButton",
    event: "clicked",
    actionSubject: "linkButton",
    actionSubjectId: "pricingAddonLearnMore",
    action: "clicked"
};

});
parcelRegister("8ohE3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61be4092527ee305$var$_react = $61be4092527ee305$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $61be4092527ee305$var$_checkMark = $61be4092527ee305$var$_interopRequireDefault((parcelRequire("hlDQ4")));
function $61be4092527ee305$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $61be4092527ee305$var$CheckIcon = (props)=>/*#__PURE__*/ $61be4092527ee305$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $61be4092527ee305$var$_checkMark.default
    }));
$61be4092527ee305$var$CheckIcon.displayName = "CheckIcon";
var $61be4092527ee305$var$_default = module.exports.default = $61be4092527ee305$var$CheckIcon;

});
parcelRegister("hlDQ4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5437a6fa40a6a5e2291c258b3bd34ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0342603590f0e1a6$var$_react = $0342603590f0e1a6$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $0342603590f0e1a6$var$_baseNew = $0342603590f0e1a6$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $0342603590f0e1a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0342603590f0e1a6$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $0342603590f0e1a6$var$_react.default.createElement($0342603590f0e1a6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$0342603590f0e1a6$var$CheckMarkIcon.displayName = "CheckMarkIcon";
var $0342603590f0e1a6$var$_default = module.exports.default = $0342603590f0e1a6$var$CheckMarkIcon;

});



parcelRegister("2glvp", function(module, exports) {
/* addons-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $65ae6d42d9f24617$var$rootCss = null;
const $65ae6d42d9f24617$var$angledEdgeCss = null;
const $65ae6d42d9f24617$var$headingCss = null;
const $65ae6d42d9f24617$var$childrenCss = null;
const $65ae6d42d9f24617$export$ef9150b23047bebe = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_19pkvbgk _2hwx1wug _otyrvbgk _18u01wug _bfhkdoyu _kqswh2mm _p12f194r"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_syazu67f _1wybzwfg _k48p1fw0 _vwz410mc _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q1wqb _u5f31tcg _n3tdidpf _19bv1tcg _1s1814no _17gqor1b _1akofhn8 _c7s71tcg _4puvidpf _1r3v1tcg _fz891ylp _1ol9ckbl _h1401wqb"
                ]),
                children: props.heading
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _1pbykb7n _p12f194r _1bsb1osq _u7coidpf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($65ae6d42d9f24617$var$AngledEdgeBackground, {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _1pbycs5v _152tckbl _1e02idpf _rjxpidpf _ahbq1wug _12l21wug _bozgzwfg _y4tizwfg _1e0c1txw _1bah1h6o _4cvr1fhb _2lx2vrvc _zulpzwfg _na0i1bp4 _dh1a1h6o _2osnckbl"
                ]),
                children: props.children
            })
        ]
    });
};
const $65ae6d42d9f24617$var$AngledEdgeBackground = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1312 180",
        fill: "none",
        width: "100%",
        height: "100%",
        className: (0, $esG4f.default)([
            "_kqswh2mm _u7co1bs0"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M0 180L1312 180L1312 0.000114699L5.65586e-06 115.305L0 180Z",
            fill: "white"
        })
    });
};

});

parcelRegister("bofgW", function(module, exports) {

$parcel$export(module.exports, "QuestionsCta", function () { return $05fcec1929cc584e$export$7874bf850b18c607; });
/* questions-cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $1UUq1 = parcelRequire("1UUq1");

var $bhreu = parcelRequire("bhreu");
const $05fcec1929cc584e$var$containerCss = null;
const $05fcec1929cc584e$var$sectionLeftCss = null;
const $05fcec1929cc584e$var$sectionLeftTextCss = null;
const $05fcec1929cc584e$var$headingCss = null;
const $05fcec1929cc584e$var$svgStyles = null;
const $05fcec1929cc584e$export$7874bf850b18c607 = ({ questionsHeader: questionsHeader, questionsBody: questionsBody, priceAndLicensingLinkText: priceAndLicensingLinkText, ctaHref: ctaHref, imageHref: imageHref = "https://dam-cdn.atl.orangelogic.com/AssetLink/0s31nt386q2lt662011182pvct037sp1.svg", product: product })=>{
    const intl = (0, $f6qj2.default)();
    if (!ctaHref || !product && !questionsBody) return null;
    const fallbackQuestionsHeader = intl.formatMessage({
        id: "PricingPage.QuestionsCta.questionsHeader",
        defaultMessage: "Questions?"
    });
    const fallbackQuestionsBody = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "PricingPage.QuestionsCta.questionsBody",
        defaultMessage: "We got answers. Read our full list of common questions and answers for general cloud pricing and licensing or specific {product} pricing and licensing.",
        values: {
            product: product
        }
    });
    const text = intl.formatMessage({
        id: "PricingPage.QuestionsCta.priceAndLicensingLinkText",
        defaultMessage: "See price and licensing page"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1y6m _1bah1h6o _bfhkr3uz _1e0c1txw _syazu67f _1reoewfl _18m9ewfl _ca0qvbgk _u5f31uvc _n3tdvbgk _19bvd3xy _2osnqslr _8fz61fdn _tl28vbgk _axwi1l27 _1hwc1et3 _sp8t1l27 _1gde1sxn _1vth1hhm _mkrz22xr _zulpt9kd"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _4cvr1y6m _y3gn1e5h _zulp7vkz _85i519bv _xlt110yn"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                        "data-testid": "questions-cta-header",
                        className: (0, $esG4f.default)([
                            "_1wybzwfg _vwz410mc _so7d1f4h _19q11u1b _1cqs1tcg _1bys1ul9",
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazu67f"
                        ]),
                        children: questionsHeader !== null && questionsHeader !== void 0 ? questionsHeader : fallbackQuestionsHeader
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        "data-testid": "questions-cta-body",
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazu67f"
                        ]),
                        children: questionsBody !== null && questionsBody !== void 0 ? questionsBody : fallbackQuestionsBody
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        text: priceAndLicensingLinkText !== null && priceAndLicensingLinkText !== void 0 ? priceAndLicensingLinkText : text,
                        href: ctaHref,
                        anchorProps: {
                            "data-testid": "questions-cta-link"
                        },
                        bgColor: "bgBlackBlue"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                image: {
                    src: imageHref,
                    alt: ""
                },
                className: (0, $esG4f.default)([
                    "_1bsb7l9q _4t3irb92 _1s4pnxnw _1kne1yvi"
                ])
            })
        ]
    });
};
$05fcec1929cc584e$export$7874bf850b18c607.displayName = "QuestionsCTASection";

});

parcelRegister("jCXOw", function(module, exports) {

$parcel$export(module.exports, "DemoAddOn", function () { return $3711102d4f1537db$export$b100dca757cd91d; });
/* demo-add-on.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $bhreu = parcelRequire("bhreu");
const $3711102d4f1537db$var$containerCss = null;
const $3711102d4f1537db$var$sectionRightCss = null;
const $3711102d4f1537db$var$headingTextCss = null;
const $3711102d4f1537db$var$bodyTextCss = null;
const $3711102d4f1537db$var$svgStyles = null;
const $3711102d4f1537db$export$98641d5fe71eada5 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/rl8k3b0oo518e2ag657731kn07r84m04.svg",
            alt: ""
        },
        className: (0, $esG4f.default)([
            "_1bsb1qi6 _4t3ii8ts _1s4pvrzy _1kne11yp"
        ])
    });
};
const $3711102d4f1537db$export$b100dca757cd91d = ({ headingText: headingText, bodyText: bodyText, linkText: linkText, ctaHref: ctaHref })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const defaultHeadingText = formatMessage({
        id: "PricingPages.atlassianGuard.demoAddOn.heading",
        defaultMessage: "See what Atlassian Guard can do for you"
    });
    const defaultBodyText = formatMessage({
        id: "PricingPages.atlassianGuard.demoAddOn.body",
        defaultMessage: "Join our live monthly demo to gain practical guidance for implementing security best practices and controls across Atlassian cloud."
    });
    const defaultLinkText = formatMessage({
        id: "PricingPages.atlassianGuard.demoAddOn.cta",
        defaultMessage: "Register for the demo"
    });
    const handleClick = ()=>{
        if (ctaHref) window.location.href = ctaHref;
    };
    const clickableCardStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        tabIndex: 0,
        onClick: handleClick,
        role: "link",
        onKeyDown: (e)=>{
            if (e.code == "Enter" || e.code == "Space") {
                e.preventDefault();
                handleClick();
            }
        },
        className: (0, $esG4f.default)([
            "_p12f1qhy _19pkidpf _2hwx1wug _otyridpf _18u01wug _1yt4oahv _1e0c1txw _1bahv2br _2rkovwyg _1gde1bp4 _ag851h6o _8164183y _133ixy5q _s51s1ejb _16qszucj _v56416gf _1dbz1cd0 _zulpoahv",
            "_80om2v03"
        ]),
        style: {
            "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
            "--_1ivi1ch": (0, $43MIc.default)(ctaHref ? "pointer" : "default")
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)($3711102d4f1537db$export$98641d5fe71eada5, {}),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _zulppxbi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                        id: "atlassian-guard-add-on-heading",
                        className: (0, $esG4f.default)([
                            "_1wyb1tcg _k48p1fw0 _vwz41ul9 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1hlo"
                        ]),
                        style: {
                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                        },
                        children: headingText !== null && headingText !== void 0 ? headingText : defaultHeadingText
                    }),
                    bodyText !== "" && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1hlo"
                        ]),
                        style: {
                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                        },
                        children: bodyText !== null && bodyText !== void 0 ? bodyText : defaultBodyText
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        text: linkText !== null && linkText !== void 0 ? linkText : defaultLinkText,
                        type: "primary",
                        href: ctaHref,
                        id: "atlassian-guard-add-on-cta",
                        ariaLabelledby: "atlassian-guard-addon-cta atlassian-guard-add-on-heading"
                    })
                ]
            })
        ]
    });
};
$3711102d4f1537db$export$b100dca757cd91d.displayName = "DemoAddOnSection";

});

parcelRegister("591nI", function(module, exports) {

$parcel$export(module.exports, "AtlassianGuardAddOnShared", function () { return $3d3ddd491f15dd5c$export$fcf33b8d632fa1db; });
/* atlassian-guard-add-on-shared.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $a0rKx = parcelRequire("a0rKx");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $bhreu = parcelRequire("bhreu");
const $3d3ddd491f15dd5c$var$containerCss = null;
const $3d3ddd491f15dd5c$var$sectionRightCss = null;
const $3d3ddd491f15dd5c$var$atlassianGuardLogoContainerCss = null;
const $3d3ddd491f15dd5c$var$headingTextCss = null;
const $3d3ddd491f15dd5c$var$bodyTextCss = null;
const $3d3ddd491f15dd5c$var$svgStyles = null;
const $3d3ddd491f15dd5c$export$5cd54d97896804b4 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/xxlo4l61p3fn223u1nahuu4r6r3ug1a2.svg",
            alt: ""
        },
        className: (0, $esG4f.default)([
            "_1bsbvrzy _4t3i11yp _glte1qi6 _165ti8ts"
        ])
    });
};
const $3d3ddd491f15dd5c$export$fcf33b8d632fa1db = ({ headingText: headingText, bodyText: bodyText, linkText: linkText, ctaHref: ctaHref })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const defaultHeadingText = formatMessage({
        id: "PricingPagesTeam.atlassianGuard.heading",
        defaultMessage: "Safeguard your mission-critical data"
    });
    const defaultBodyText = formatMessage({
        id: "PricingPagesTeam.atlassianGuard.body",
        defaultMessage: "Add Atlassian Guard for enhanced security and visibility across your Atlassian cloud products. Set proactive security policies, quickly detect suspicious behavior, and take action with suggested remediation steps to protect your most valuable work. Additionally, with a Cloud Enterprise plan, you get support for multiple identity providers (IdPs) and Atlassian Guard Standard."
    });
    const defaultLinkText = formatMessage({
        id: "PricingPages.atlassianGuard.cta",
        defaultMessage: "Learn more"
    });
    const handleClick = ()=>{
        if (ctaHref) window.location.href = ctaHref;
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "atlassianGuardAddOnShared",
        tabIndex: 0,
        onClick: handleClick,
        role: "link",
        onKeyDown: (e)=>{
            if (e.code == "Enter" || e.code == "Space") {
                e.preventDefault();
                handleClick();
            }
        },
        className: (0, $esG4f.default)([
            "_p12f1qhy _19pkidpf _2hwx1wug _otyridpf _18u01wug _1yt4oahv _1e0c1txw _2rkovwyg _4cvr1h6o _1gde1bp4 _8164183y _133ixy5q _s51s1ejb _16qszucj _v56416gf _1dbz1cd0 _zulpoahv _80omtlke"
        ]),
        style: {
            "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)($3d3ddd491f15dd5c$export$5cd54d97896804b4, {}),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _zulppxbi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: (0, $esG4f.default)([
                            "_4t3ixy5q _1752xy5q"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $a0rKx.GuardLogo), {
                            appearance: "brand"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                        id: "atlassian-guard-add-on-heading",
                        className: (0, $esG4f.default)([
                            "_1wyb1tcg _k48p1fw0 _vwz41ul9 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                        ]),
                        children: headingText !== null && headingText !== void 0 ? headingText : defaultHeadingText
                    }),
                    bodyText !== "" && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1io3"
                        ]),
                        style: {
                            "--_138lqrp": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark500"))
                        },
                        children: bodyText !== null && bodyText !== void 0 ? bodyText : defaultBodyText
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        text: linkText !== null && linkText !== void 0 ? linkText : defaultLinkText,
                        type: "primary",
                        href: ctaHref,
                        id: "atlassian-guard-add-on-cta",
                        ariaLabelledby: "atlassian-guard-add-on-cta atlassian-guard-add-on-heading"
                    })
                ]
            })
        ]
    });
};
$3d3ddd491f15dd5c$export$fcf33b8d632fa1db.displayName = "AtlassianGuardAddOn";

});
parcelRegister("a0rKx", function(module, exports) {

$parcel$export(module.exports, "GuardLogo", function () { return $748f6df228342c19$export$a4a891d202775deb; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $748f6df228342c19$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114 32" focusable="false" aria-hidden="true">\n      <path\n        d="M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038"\n        fill="'.concat(colors.iconColor, '"\n      />\n      <path\n        d="M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z"\n        fill="').concat(colors.textColor, '"\n      />\n    </svg>');
};
var $748f6df228342c19$export$a4a891d202775deb = function GuardLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Guard" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $748f6df228342c19$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});



parcelRegister("51Zx0", function(module, exports) {

$parcel$export(module.exports, "TeamworkCollectionPricingHero", function () { return $a871f47e03e0a0cc$export$11d510446f2a0235; });

var $loA2J = parcelRequire("loA2J");

var $juk3G = parcelRequire("juk3G");
const $a871f47e03e0a0cc$export$11d510446f2a0235 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $juk3G.CollectionPricingHero), {
        collectionImage: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/wwq35151x13e6200i5xc4qs5r21er0q5.svg",
            alt: "Teamwork Collection"
        },
        products: [
            {
                name: "Jira",
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/36a5pi244g3e1j3540td888vgj855s0u/collections-teamwork-jira.svg",
                    alt: "Jira"
                }
            },
            {
                name: "Confluence",
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/nj0wofvhj3q26f3vy866q801p5bbw83w/collections-teamwork-confluence.svg",
                    alt: "Confluence"
                }
            },
            {
                name: "Loom",
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/138cux5d67t757a2ddy0l833ihe728l8/collections-teamwork-loom.svg",
                    alt: "Loom"
                }
            },
            {
                name: "Rovo",
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/bijp0lf52qxqdt3257q0kj73t8d5681g.svg",
                    alt: "Rovo"
                }
            }
        ]
    });
};

});
parcelRegister("juk3G", function(module, exports) {

$parcel$export(module.exports, "CollectionPricingHero", function () { return $5832e5ef371102fc$export$8065869e82d5a4c7; });
/* collection-pricing-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $dFgsR = parcelRequire("dFgsR");
const $5832e5ef371102fc$var$horizontalOrientationCss = null;
const $5832e5ef371102fc$var$verticalOrientationCss = null;
const $5832e5ef371102fc$var$logoCss = null;
const $5832e5ef371102fc$var$verticalLogoCss = null;
const $5832e5ef371102fc$export$8065869e82d5a4c7 = (props)=>{
    const orientation = props.orientation || "horizontal";
    const messages = (0, $dFgsR.useCollectionPricingHeroMessages)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _1f2ygktf"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1bsb1ns9 _p12fuoas"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _zulppxbi _1yt417la _1lp7vrvc _19wgxy5q _6yttgfpe"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _4cvr1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                image: {
                                    src: props.collectionImage.src,
                                    alt: props.collectionImage.alt,
                                    height: props.collectionImage.height,
                                    width: props.collectionImage.width
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _2lx21bp4 _zulp1crf"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                    className: (0, $esG4f.default)([
                                        "_ect4bzd7 _1wyb19bv _k48p1nn1 _1p1dangw _syaz1yg0 _vwz47vkz _y3gn1h6o _uj6k18uv"
                                    ]),
                                    style: {
                                        "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                                        "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800"))
                                    },
                                    children: messages.includes
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        orientation === "horizontal" ? "_1e0c11p5 _yv0efsjm _2z05im57 _zulpxy5q _gy1pxy5q _1p57pxbi _ect41pz4 _k48p1nn1 _1wyb1wbj" : "_1e0c1txw _2lx21bp4 _zulppxbi"
                                    ]),
                                    style: {
                                        "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                                    },
                                    children: props.products.map((product, key)=>{
                                        return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                            className: (0, $esG4f.default)([
                                                orientation === "horizontal" ? "_1e0c1txw _4cvr1h6o _zulp12x7 _1bsb1n5l" : "_1e0c1txw _4cvr1h6o _4t3igktf"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                                    image: {
                                                        src: product.image.src,
                                                        alt: product.image.alt
                                                    },
                                                    className: (0, $esG4f.default)([
                                                        "_y4ti9pc2"
                                                    ]),
                                                    style: {
                                                        height: "20px",
                                                        "--_s4yu5j": (0, $43MIc.default)(orientation === "vertical" ? "var(--ds-space-075, 6px)" : 0)
                                                    }
                                                }),
                                                product.name
                                            ]
                                        }, key);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1bsb1osq _mqm21djo"
                    ]),
                    style: {
                        "--_w9vrer": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark1100"))
                    }
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_syaz1hlo _1e0c1ule _y3gn1h6o _ect4bzd7 _1wyb7vkz _zg8l4jg8 _k48p1fw0 _vwz41ou6 _1yt4zu5n"
                            ]),
                            style: {
                                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                            },
                            children: messages.heading
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _1bah1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _1n261g80 _1bah1h6o _zulpu2gc _19wgpxbi"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)($5832e5ef371102fc$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/k383m26br4w8fu6i68s0qbnym881f0wb.svg",
                                        name: messages.home,
                                        alt: messages.home
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)($5832e5ef371102fc$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/r7k15161ensv07cht48h87c31ueh7sh3.svg",
                                        name: messages.goals,
                                        alt: messages.goals
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)($5832e5ef371102fc$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/51ht267g50ve2d3051aw8nrgs0k11ad6.svg",
                                        name: messages.teams,
                                        alt: messages.teams
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)($5832e5ef371102fc$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/2pqaabre17cu7mx66ydvhplnbt4hh3ub.svg",
                                        name: messages.studio,
                                        alt: messages.studio
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)($5832e5ef371102fc$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/to7s6r4xr4564x6jhc134qhgevi13wo3.svg",
                                        name: messages.search,
                                        alt: messages.search
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)($5832e5ef371102fc$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/pe661ex05dvkmxul5nf4fi1e20hq8063.svg",
                                        name: messages.chat,
                                        alt: messages.chat
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)($5832e5ef371102fc$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8f6ta76fw1d04u40k8fp622i67154764.svg",
                                        name: messages.analytics,
                                        alt: messages.analytics
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)($5832e5ef371102fc$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/dv817l8n01hct543cmd030ksu3hfj0k6.svg",
                                        name: messages.admin,
                                        alt: messages.admin
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $5832e5ef371102fc$var$Subproduct = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulp1b66 _1ul91l27 _1yt41giy"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_19pkrdoj _2hwxrdoj _otyrrdoj _18u0rdoj _4t3igktf _1bsbgktf"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: {
                            src: props.src,
                            alt: props.alt
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_y3gn1h6o _ect4bzd7 _1wybsm30 _zg8l4jg8 _k48p1nn1 _vwz41crf"
                ]),
                style: {
                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                },
                children: props.name
            })
        ]
    });
};

});
parcelRegister("dFgsR", function(module, exports) {

$parcel$export(module.exports, "useCollectionPricingHeroMessages", function () { return $97609ee87abf024f$export$7c226aa081048b2; });

var $f6qj2 = parcelRequire("f6qj2");

var $gAJUc = parcelRequire("gAJUc");
function $97609ee87abf024f$export$7c226aa081048b2() {
    const intl = (0, $f6qj2.default)();
    const hardcoded = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp8279CollectionHeroIntl);
    if (hardcoded) return $97609ee87abf024f$export$22298271baa6ded9(intl.locale);
    return {
        heading: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.platformAppsHeading",
            defaultMessage: "Plus all Atlassian Platform Apps"
        }),
        includes: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.includes",
            defaultMessage: "Includes"
        }),
        home: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.home.alt",
            defaultMessage: "Home"
        }),
        goals: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.goals",
            defaultMessage: "Goals"
        }),
        teams: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.teams",
            defaultMessage: "Teams"
        }),
        studio: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.studio",
            defaultMessage: "Studio"
        }),
        search: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.search",
            defaultMessage: "Search"
        }),
        chat: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.chat",
            defaultMessage: "Chat"
        }),
        analytics: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.analytics",
            defaultMessage: "Analytics"
        }),
        admin: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.admin",
            defaultMessage: "Admin"
        })
    };
}
function $97609ee87abf024f$export$22298271baa6ded9(locale) {
    var _MESSAGES_locale;
    return (_MESSAGES_locale = $97609ee87abf024f$var$MESSAGES[locale]) !== null && _MESSAGES_locale !== void 0 ? _MESSAGES_locale : $97609ee87abf024f$var$enMessages;
}
const $97609ee87abf024f$var$enMessages = {
    home: "Home",
    heading: "Plus all Atlassian Platform Apps",
    includes: "Includes",
    goals: "Goals",
    teams: "Teams",
    studio: "Studio",
    search: "Search",
    chat: "Chat",
    analytics: "Analytics",
    admin: "Admin"
};
const $97609ee87abf024f$var$MESSAGES = {
    en: $97609ee87abf024f$var$enMessages,
    nl: {
        home: "Home",
        heading: "Plus alle Atlassian Platform-apps",
        includes: "Omvat",
        goals: "Doelstellingen",
        teams: "Teams",
        studio: "Studio",
        search: "Zoeken",
        chat: "Chat",
        analytics: "Analyses",
        admin: "Beheerder"
    },
    es: {
        home: "Inicio",
        heading: "Adem\xe1s de todas las aplicaciones de la plataforma de Atlassian",
        includes: "Incluye",
        goals: "Objetivos",
        teams: "Equipos",
        studio: "Studio",
        search: "Buscar",
        chat: "Chat",
        analytics: "An\xe1lisis",
        admin: "Administrativo"
    },
    ru: {
        home: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
        heading: "\u0410 \u0442\u0430\u043A\u0436\u0435 \u0432\u0441\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B Atlassian",
        includes: "\u0412\u043A\u043B\u044E\u0447\u0430\u0435\u0442",
        goals: "\u0426\u0435\u043B\u0438",
        teams: "\u041A\u043E\u043C\u0430\u043D\u0434\u044B",
        studio: "\u041C\u0430\u0441\u0442\u0435\u0440\u0441\u043A\u0430\u044F",
        search: "\u041F\u043E\u0438\u0441\u043A",
        chat: "\u0427\u0430\u0442",
        analytics: "\u0410\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0430",
        admin: "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440"
    },
    fr: {
        home: "Accueil",
        heading: "Et toutes les apps de la plateforme Atlassian",
        includes: "Fonctionnalit\xe9s incluses",
        goals: "Objectifs",
        teams: "\xc9quipes",
        studio: "Studio",
        search: "Recherche",
        chat: "Chat",
        analytics: "Analyses",
        admin: "Administrateur"
    },
    ko: {
        home: "\uD648",
        heading: "\uBC0F \uBAA8\uB4E0 Atlassian \uD50C\uB7AB\uD3FC \uC571",
        includes: "\uD3EC\uD568 \uC0AC\uD56D",
        goals: "\uBAA9\uD45C",
        teams: "\uD300",
        studio: "\uC2A4\uD29C\uB514\uC624",
        search: "\uAC80\uC0C9",
        chat: "\uCC44\uD305",
        analytics: "\uBD84\uC11D",
        admin: "\uAD00\uB9AC\uC790"
    },
    br: {
        home: "In\xedcio",
        heading: "Al\xe9m de todos os apps da plataforma Atlassian",
        includes: "Inclui",
        goals: "Metas",
        teams: "Equipes",
        studio: "Studio",
        search: "Pesquisar",
        chat: "Bate-papo",
        analytics: "Dados de An\xe1lise",
        admin: "Admin"
    },
    pl: {
        home: "Strona g\u0142\xf3wna",
        heading: "Plus wszystkie aplikacje platformy Atlassian",
        includes: "Obejmuje",
        goals: "Cele",
        teams: "Zespo\u0142y",
        studio: "Studio",
        search: "Wyszukiwanie",
        chat: "Czat",
        analytics: "Analizy",
        admin: "Administrator"
    },
    de: {
        home: "Home",
        heading: "Plus alle Apps der Atlassian-Plattform",
        includes: "Beinhaltet",
        goals: "Ziele",
        teams: "Teams",
        studio: "Studio",
        search: "Suchen",
        chat: "Chat",
        analytics: "Analysen",
        admin: "Administrator"
    },
    zh: {
        home: "\u9996\u9875",
        heading: "\u4EE5\u53CA\u6240\u6709 Atlassian \u5E73\u53F0\u5E94\u7528",
        includes: "\u5305\u62EC",
        goals: "\u76EE\u6807",
        teams: "\u56E2\u961F",
        studio: "\u5DE5\u4F5C\u5BA4",
        search: "\u641C\u7D22",
        chat: "\u804A\u5929",
        analytics: "\u5206\u6790",
        admin: "\u7BA1\u7406\u5458"
    },
    it: {
        home: "Pagina iniziale",
        heading: "E tutte le app della piattaforma di Atlassian",
        includes: "Include",
        goals: "Obiettivi",
        teams: "Team",
        studio: "Studio",
        search: "Cerca",
        chat: "Chat",
        analytics: "Analisi",
        admin: "Amministratore"
    },
    ja: {
        home: "\u30DB\u30FC\u30E0",
        heading: "\u3055\u3089\u306B\u3059\u3079\u3066\u306E\u30A2\u30C8\u30E9\u30B7\u30A2\u30F3 \u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0 \u30A2\u30D7\u30EA",
        includes: "\u30A4\u30F3\u30AF\u30EB\u30FC\u30C9",
        goals: "\u76EE\u6A19",
        teams: "\u30C1\u30FC\u30E0",
        studio: "\u30B9\u30BF\u30B8\u30AA",
        search: "\u691C\u7D22",
        chat: "\u30C1\u30E3\u30C3\u30C8",
        analytics: "\u5206\u6790\u6A5F\u80FD",
        admin: "\u7BA1\u7406\u8005"
    }
};

});



parcelRegister("8PL6n", function(module, exports) {

$parcel$export(module.exports, "TeamworkCollectionNavbar", function () { return $f02da071f5e993e4$export$693b523fb4eb0711; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $cP0Yq = parcelRequire("cP0Yq");

var $4R0f2 = parcelRequire("4R0f2");
const $f02da071f5e993e4$export$693b523fb4eb0711 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.GlobalNav), {
        productKey: "home",
        compoundNav: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $4R0f2.CollectionsCompoundSubNavProps)()), {
            ctaUrl: "/collections/teamwork#contact"
        })
    });
};

});

parcelRegister("awMjc", function(module, exports) {

$parcel$export(module.exports, "TeamworkCollectionPriceFinder", function () { return $6aab71af230c6d6b$export$9c2caa4596f790ac; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $6x1qA = parcelRequire("6x1qA");

var $l9lQF = parcelRequire("l9lQF");

var $7OWgU = parcelRequire("7OWgU");

var $esRX2 = parcelRequire("esRX2");

var $dT5kE = parcelRequire("dT5kE");

var $k2Rjw = parcelRequire("k2Rjw");
const $6aab71af230c6d6b$export$9c2caa4596f790ac = (props)=>{
    var _props_pricing_ccpPricingData, _props_pricing;
    const content = {
        free: (0, $dT5kE.usePricingPlanComparison)("Free"),
        standard: (0, $dT5kE.usePricingPlanComparison)("Standard"),
        premium: (0, $dT5kE.usePricingPlanComparison)("Premium"),
        enterprise: (0, $dT5kE.usePricingPlanComparison)("Enterprise")
    };
    const freePlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "free");
    const standardPlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "standard");
    const premiumPlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "premium");
    const enterprisePlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "enterprise");
    // planNames should not be translated
    const productPlans = [
        {
            planName: "Free",
            offeringSku: (0, $k2Rjw.offeringSkus).free,
            // @ts-ignore
            description: content.free.planOneLiner,
            recommendationLimit: 0,
            signupLimit: 10,
            planFeatureMessages: freePlanFeatureMessages,
            signupURLInfo: {
                shouldLocalize: true,
                urlDomain: window.location.origin,
                urlPath: "/collections/teamwork#contact"
            }
        },
        {
            planName: "Standard",
            offeringSku: (0, $k2Rjw.offeringSkus).standard,
            // @ts-ignore
            description: content.standard.planOneLiner,
            recommendationLimit: 0,
            signupLimit: 100000,
            planFeatureMessages: standardPlanFeatureMessages,
            signupURLInfo: {
                shouldLocalize: true,
                urlDomain: window.location.origin,
                urlPath: "/collections/teamwork#contact"
            }
        },
        {
            planName: "Premium",
            offeringSku: (0, $k2Rjw.offeringSkus).premium,
            // @ts-ignore
            description: content.premium.planOneLiner,
            recommendationLimit: 0,
            signupLimit: 100000,
            planFeatureMessages: premiumPlanFeatureMessages,
            signupURLInfo: {
                shouldLocalize: true,
                urlDomain: window.location.origin,
                urlPath: "/collections/teamwork#contact"
            }
        },
        {
            planName: "Enterprise",
            offeringSku: (0, $k2Rjw.offeringSkus).enterprise,
            // @ts-ignore
            description: content.enterprise.planOneLiner,
            recommendationLimit: 5000,
            signupLimit: 100000,
            planFeatureMessages: enterprisePlanFeatureMessages,
            signupURLInfo: {
                shouldLocalize: true,
                urlDomain: window.location.origin,
                urlPath: "/collections/teamwork#contact"
            }
        }
    ];
    const messages = (0, $6x1qA.defineMessages)({
        unitCountInputTextRedesign: {
            id: "TeamworkCollectionPriceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputTerm: {
            id: "TeamworkCollectionPriceFinder.unitCountInputText",
            defaultMessage: "users"
        },
        cardEnterpriseMinimumCount: {
            id: "TeamworkCollectionPriceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardOverSignupLimit: {
            id: "TeamworkCollectionPriceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardUnitCountTierRange: {
            id: "TeamworkCollectionPriceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "TeamworkCollectionPriceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user/month"
        }
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $l9lQF.PriceFinderContextProvider), {
            dataProductKey: "teamworkCollection",
            productPlans: productPlans,
            defaultUnitCount: 300,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OWgU.default), {
                messages: messages,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.teamworkCollection,
                countryCode: props.countryCode
            })
        })
    });
};

});
parcelRegister("k2Rjw", function(module, exports) {

$parcel$export(module.exports, "offeringSkus", function () { return $f8a267f84256e079$export$b2421372229fc1c9; });
const $f8a267f84256e079$export$b2421372229fc1c9 = {
    free: "teamwork-collection-free-sku",
    standard: "teamwork-collection-standard-sku",
    premium: "teamwork-collection-premium-sku",
    enterprise: "teamwork-collection-enterprise-sku"
};

});




parcelRegister("jeTGv", function(module, exports) {

$parcel$export(module.exports, "CustomersLandingPage", function () { return $6ec9fe0636fb7cab$export$ba23a27a05802abe; });

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");

var $evZwi = parcelRequire("evZwi");

var $4ktyF = parcelRequire("4ktyF");
parcelRequire("54HnG");
var $8phep = parcelRequire("8phep");
const $6ec9fe0636fb7cab$export$ba23a27a05802abe = ({ queryRef: queryRef })=>{
    const preloadedQueryResult = (0, $hOqV7.usePreloadedQuery)((0, $evZwi.CustomerLandingPageRelayQuery), queryRef || null);
    const contentfulResponse = (0, $evZwi.CustomerLandingPageContentfulResponse)(preloadedQueryResult);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4ktyF.default), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8phep.CustomersLandingPageRelayTemplate), {
            // @ts-ignore
            customerLanding: contentfulResponse
        })
    });
};

});
parcelRegister("54HnG", function(module, exports) {
$parcel$export(module.exports, "CustomersLandingPageRelayTemplate", function () { return (parcelRequire("8phep")).CustomersLandingPageRelayTemplate; });

var $8phep = parcelRequire("8phep");

});
parcelRegister("8phep", function(module, exports) {

$parcel$export(module.exports, "CustomersLandingPageRelayTemplate", function () { return $f1cdf8668dac3e64$export$1d3625540e7063b8; });
/* eslint-disable complexity */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $dyZbY = parcelRequire("dyZbY");

var $4XrxY = parcelRequire("4XrxY");

var $kex29 = parcelRequire("kex29");

var $cP0Yq = parcelRequire("cP0Yq");
parcelRequire("ju8Fs");
var $ikB9y = parcelRequire("ikB9y");
var $fTcHC = parcelRequire("fTcHC");
var $jLexR = parcelRequire("jLexR");
var $53agj = parcelRequire("53agj");
var $iyN25 = parcelRequire("iyN25");
parcelRequire("i3c3n");
var $aegm4 = parcelRequire("aegm4");
var $bs52B = parcelRequire("bs52B");
var $cFUxJ = parcelRequire("cFUxJ");

var $goGkF = parcelRequire("goGkF");
const $f1cdf8668dac3e64$var$STORIES_AT_A_TIME = 10;
const $f1cdf8668dac3e64$var$productOrder = [
    "Jira",
    "Jira Service Management",
    "Jira Align",
    "Jira Product Discovery",
    "Confluence",
    "Trello",
    "Bitbucket",
    "Atlassian Access",
    "Guard",
    "Statuspage",
    "Compass",
    "Bamboo"
];
const $f1cdf8668dac3e64$var$orgSizeOrder = [
    "Small/Medium",
    // Small/Medium
    "Enterprise",
    // Enterprise
    "Large Enterprise" // Large Enterprise
];
const $f1cdf8668dac3e64$var$prioritizedSlugMap = {
    "adesso": true,
    "airties": true,
    "arvato-systems": true,
    "avalara": true,
    "canva": true,
    "celonis": true,
    "clearwater-analytics": true,
    "dhcs": true,
    "dish-wireless": true,
    "doodle": true,
    "dropbox": true,
    "edenred": true,
    "fath": true,
    "fiona": true,
    "glovo": true,
    "hy-vee": true,
    "ifood": true,
    "interpark": true,
    "iress": true,
    "kiva": true,
    "lumen": true,
    "mercedes-benz": true,
    "mettle": true,
    "ossur": true,
    "reddit": true,
    "riverty": true,
    "rivian": true,
    "roblox": true,
    "royal-caribbean": true,
    "softwareag": true,
    "sonymusic-publishing": true,
    "state-of-utah": true,
    "sunlife": true,
    "the-very-group": true,
    "united-airlines": true,
    "united": true,
    "us-space-force": true,
    "voith": true
};
const $f1cdf8668dac3e64$export$1b8a19b49348996e = (customers, filterByEnterprise)=>{
    var _customers_filters, _customers_filters1, _customers_filters2, _customers_filters3, _customers_filters4;
    const industry = (0, $aegm4.getFilterOptions)((_customers_filters = customers.filters) === null || _customers_filters === void 0 ? void 0 : _customers_filters.industries);
    const region = (0, $aegm4.getFilterOptions)((_customers_filters1 = customers.filters) === null || _customers_filters1 === void 0 ? void 0 : _customers_filters1.regions, "region");
    const product = (0, $aegm4.getFilterOptions)((_customers_filters2 = customers.filters) === null || _customers_filters2 === void 0 ? void 0 : _customers_filters2.products);
    const solution = (0, $aegm4.getFilterOptions)((_customers_filters3 = customers.filters) === null || _customers_filters3 === void 0 ? void 0 : _customers_filters3.solutions);
    let teamSize = (0, $aegm4.getFilterOptions)((_customers_filters4 = customers.filters) === null || _customers_filters4 === void 0 ? void 0 : _customers_filters4.teamSizes, "team size");
    const defaulted = (0, $7Knp0._)({}, (0, $bs52B.defaultCustomerStoryFilterOptionsObject));
    if (Object.keys(industry).length) defaulted.industry = industry;
    if (Object.keys(region).length) defaulted["more filters"] = (0, $7Knp0._)({}, defaulted["more filters"], region);
    const teamEnterpriseOverride = {
        Enterprise: {
            committedActive: true,
            stagedActive: true,
            grouping: "team size"
        }
    };
    if (filterByEnterprise) teamSize = (0, $7Knp0._)({}, teamSize, teamEnterpriseOverride);
    if (Object.keys(teamSize).length) defaulted["more filters"] = (0, $7Knp0._)({}, defaulted["more filters"], teamSize);
    if (Object.keys(solution).length) defaulted.solution = solution;
    if (Object.keys(product).length) defaulted.product = product;
    return defaulted;
};
const $f1cdf8668dac3e64$export$970674147b1999f = (data)=>{
    var _data_filters, _data_customerStories;
    const filters = data === null || data === void 0 ? void 0 : (_data_filters = data.filters) === null || _data_filters === void 0 ? void 0 : _data_filters.edges.sort((a, b)=>a.node.context.name < b.node.context.name ? -1 : 1);
    const result = {
        customerStories: data === null || data === void 0 ? void 0 : (_data_customerStories = data.customerStories) === null || _data_customerStories === void 0 ? void 0 : _data_customerStories.edges.filter((story)=>{
            var _story_node_title, _story_node;
            return (_story_node = story.node) === null || _story_node === void 0 ? void 0 : (_story_node_title = _story_node.title) === null || _story_node_title === void 0 ? void 0 : _story_node_title.trim();
        }).sort((storyA, storyB)=>{
            var _a_advocateQuotes_, _a_advocateQuotes, _a_storyIcon, _b_advocateQuotes_, _b_advocateQuotes, _b_storyIcon, _a_customerCompany, _b_customerCompany;
            // Stories with a quote or a spot illustration are featured and appear first,
            // otherwise we use a secondary sort (alphabetical)
            const a = storyA.node;
            const b = storyB.node;
            if (b.urlSlug && $f1cdf8668dac3e64$var$prioritizedSlugMap[b.urlSlug]) return 1;
            if (a.urlSlug && $f1cdf8668dac3e64$var$prioritizedSlugMap[a.urlSlug] || (a === null || a === void 0 ? void 0 : (_a_advocateQuotes = a.advocateQuotes) === null || _a_advocateQuotes === void 0 ? void 0 : (_a_advocateQuotes_ = _a_advocateQuotes[0]) === null || _a_advocateQuotes_ === void 0 ? void 0 : _a_advocateQuotes_.advocateName) || (a === null || a === void 0 ? void 0 : (_a_storyIcon = a.storyIcon) === null || _a_storyIcon === void 0 ? void 0 : _a_storyIcon.url)) return -1;
            else if ((b === null || b === void 0 ? void 0 : (_b_advocateQuotes = b.advocateQuotes) === null || _b_advocateQuotes === void 0 ? void 0 : (_b_advocateQuotes_ = _b_advocateQuotes[0]) === null || _b_advocateQuotes_ === void 0 ? void 0 : _b_advocateQuotes_.advocateName) || (b === null || b === void 0 ? void 0 : (_b_storyIcon = b.storyIcon) === null || _b_storyIcon === void 0 ? void 0 : _b_storyIcon.url)) return 1;
            var _a_customerCompany_name;
            const aName = (_a_customerCompany_name = a === null || a === void 0 ? void 0 : (_a_customerCompany = a.customerCompany) === null || _a_customerCompany === void 0 ? void 0 : _a_customerCompany.name) !== null && _a_customerCompany_name !== void 0 ? _a_customerCompany_name : "";
            var _b_customerCompany_name;
            const bName = (_b_customerCompany_name = b === null || b === void 0 ? void 0 : (_b_customerCompany = b.customerCompany) === null || _b_customerCompany === void 0 ? void 0 : _b_customerCompany.name) !== null && _b_customerCompany_name !== void 0 ? _b_customerCompany_name : "";
            return aName < bName ? -1 : 1;
        }).map((story)=>(0, $goGkF.flattenTemplateImageAssets)(story.node)),
        // Get lists to populate filters, by category
        filters: {
            industries: filters === null || filters === void 0 ? void 0 : filters.filter((filter)=>{
                var _filter_node;
                return (filter === null || filter === void 0 ? void 0 : (_filter_node = filter.node) === null || _filter_node === void 0 ? void 0 : _filter_node.field) === "industry";
            }).map((filter)=>{
                var _filter_node;
                return filter === null || filter === void 0 ? void 0 : (_filter_node = filter.node) === null || _filter_node === void 0 ? void 0 : _filter_node.context;
            }),
            regions: filters === null || filters === void 0 ? void 0 : filters.filter((filter)=>{
                var _filter_node;
                return (filter === null || filter === void 0 ? void 0 : (_filter_node = filter.node) === null || _filter_node === void 0 ? void 0 : _filter_node.field) === "region";
            }).map((filter)=>{
                var _filter_node;
                return filter === null || filter === void 0 ? void 0 : (_filter_node = filter.node) === null || _filter_node === void 0 ? void 0 : _filter_node.context;
            }),
            solutions: filters === null || filters === void 0 ? void 0 : filters.filter((filter)=>{
                var _filter_node;
                return (filter === null || filter === void 0 ? void 0 : (_filter_node = filter.node) === null || _filter_node === void 0 ? void 0 : _filter_node.field) === "solution";
            }).map((filter)=>{
                var _filter_node;
                return filter === null || filter === void 0 ? void 0 : (_filter_node = filter.node) === null || _filter_node === void 0 ? void 0 : _filter_node.context;
            }),
            teamSizes: filters === null || filters === void 0 ? void 0 : filters.filter((filter)=>{
                var _filter_node;
                return (filter === null || filter === void 0 ? void 0 : (_filter_node = filter.node) === null || _filter_node === void 0 ? void 0 : _filter_node.field) === "organizationSize";
            }).map((filter)=>{
                var _filter_node;
                return filter === null || filter === void 0 ? void 0 : (_filter_node = filter.node) === null || _filter_node === void 0 ? void 0 : _filter_node.context;
            }).sort((a, b)=>{
                const aIndex = $f1cdf8668dac3e64$var$orgSizeOrder.indexOf(a.name);
                const bIndex = $f1cdf8668dac3e64$var$orgSizeOrder.indexOf(b.name);
                if (aIndex < 0) return 1;
                else if (bIndex < 0) return -1;
                return aIndex - bIndex;
            }),
            products: filters === null || filters === void 0 ? void 0 : filters.filter((filter)=>{
                var _filter_node;
                return (filter === null || filter === void 0 ? void 0 : (_filter_node = filter.node) === null || _filter_node === void 0 ? void 0 : _filter_node.field) === "products";
            }).map((filter)=>{
                var _filter_node;
                return filter === null || filter === void 0 ? void 0 : (_filter_node = filter.node) === null || _filter_node === void 0 ? void 0 : _filter_node.context;
            }).sort((a, b)=>{
                const aIndex = $f1cdf8668dac3e64$var$productOrder.indexOf(a.name);
                const bIndex = $f1cdf8668dac3e64$var$productOrder.indexOf(b.name);
                if (aIndex < 0) return 1;
                else if (bIndex < 0) return -1;
                return aIndex - bIndex;
            })
        }
    };
    return result;
};
const $f1cdf8668dac3e64$export$1d3625540e7063b8 = ({ customerLanding: customerLanding })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const filterByEnterpriseParam = $f1cdf8668dac3e64$var$getFilterByEnterpriseParam();
    const [filterByEnterprise, setFilterByEnterprise] = (0, $iSvIT.useState)(filterByEnterpriseParam);
    const customers = $f1cdf8668dac3e64$export$970674147b1999f(customerLanding);
    const [filterObjectValue, setFilterObjectValue] = (0, $iSvIT.useState)($f1cdf8668dac3e64$export$1b8a19b49348996e(customers, filterByEnterprise));
    const [searchFilterString, setSearchString] = (0, $iSvIT.useState)("");
    const [searchInputFieldFocused, setSearchInputFieldFocused] = (0, $iSvIT.useState)(false);
    const [filterSearchhasRun, setFilterSearchHasRun] = (0, $iSvIT.useState)(false);
    const [customerStoryList, updateCustomerStoryList] = (0, $iSvIT.useState)(customers.customerStories);
    const [numberOfCustomerStories, setNumberOfCustomerStories] = (0, $iSvIT.useState)(customerStoryList === null || customerStoryList === void 0 ? void 0 : customerStoryList.length);
    const [numberOfVisibleStories, setNumberOfVisibleStories] = (0, $iSvIT.useState)($f1cdf8668dac3e64$var$STORIES_AT_A_TIME);
    (0, $iSvIT.useEffect)(()=>{
        setNumberOfCustomerStories(customerStoryList === null || customerStoryList === void 0 ? void 0 : customerStoryList.length);
    }, [
        customerStoryList
    ]);
    (0, $iSvIT.useEffect)(()=>{
        // if the URL parameter `filterByEnterprise` is true, and we have received customer stories
        // proceed to run a search with the enterprise filter
        if (filterByEnterprise && customers.customerStories.length > 0) {
            runSearchWithFilters(filterObjectValue, "");
            //set to false so that getDefaultFilterObject() ignores overriding the teamSize filter
            setFilterByEnterprise(false);
        }
    // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        customers
    ]);
    const clearAllFilters = ()=>{
        setFilterObjectValue($f1cdf8668dac3e64$export$1b8a19b49348996e(customers, filterByEnterprise));
        updateCustomerStoryList(customers.customerStories);
        setSearchString("");
        setSearchInputFieldFocused(false);
        setFilterSearchHasRun(false);
    };
    const clearSearchField = ()=>{
        setSearchString("");
        setSearchInputFieldFocused(false);
        runSearchWithFilters(filterObjectValue, "");
    };
    const setSearchStringWrapper = (searchString)=>{
        setSearchString(searchString);
    };
    const loadMoreStories = ()=>{
        setNumberOfVisibleStories(numberOfVisibleStories + $f1cdf8668dac3e64$var$STORIES_AT_A_TIME);
    };
    const runSearchWithFilters = (filterObject, searchString)=>{
        var _customers_customerStories;
        var _searchString_toLowerCase;
        const normalizedSearchString = (_searchString_toLowerCase = searchString.toLowerCase()) !== null && _searchString_toLowerCase !== void 0 ? _searchString_toLowerCase : "";
        const filtersAreActive = (0, $aegm4.areFiltersAreActive)(filterObject);
        if (!filtersAreActive && normalizedSearchString.length === 0) {
            setFilterSearchHasRun(false);
            if (customers.customerStories.length !== numberOfCustomerStories) updateCustomerStoryList(customers.customerStories);
            return;
        }
        // Initial text based search
        const searchResults = (_customers_customerStories = customers.customerStories) === null || _customers_customerStories === void 0 ? void 0 : _customers_customerStories.filter((story)=>{
            var _story_title_toLowerCase, _story_title, _story_customerCompany_name_toLowerCase, _story_customerCompany_name, _story_customerCompany, _story_urlSlug_toLowerCase, _story_urlSlug, _story_customerCompany_region_name_toLowerCase, _story_customerCompany_region_name, _story_customerCompany_region, _story_customerCompany1, // @ts-ignore
            _story_customerCompany_industry_filter, _story_customerCompany_industry, _story_customerCompany2, // @ts-ignore
            _story_products_filter, _story_products, _story_customerCompany_organizationSize_name_toLowerCase, _story_customerCompany_organizationSize_name, _story_customerCompany_organizationSize, _story_customerCompany3;
            if (searchFilterString === null || searchFilterString === void 0 ? void 0 : searchFilterString.length) return ((_story_title = story.title) === null || _story_title === void 0 ? void 0 : (_story_title_toLowerCase = _story_title.toLowerCase()) === null || _story_title_toLowerCase === void 0 ? void 0 : _story_title_toLowerCase.includes(normalizedSearchString)) || ((_story_customerCompany = story.customerCompany) === null || _story_customerCompany === void 0 ? void 0 : (_story_customerCompany_name = _story_customerCompany.name) === null || _story_customerCompany_name === void 0 ? void 0 : (_story_customerCompany_name_toLowerCase = _story_customerCompany_name.toLowerCase()) === null || _story_customerCompany_name_toLowerCase === void 0 ? void 0 : _story_customerCompany_name_toLowerCase.includes(normalizedSearchString)) || ((_story_urlSlug = story.urlSlug) === null || _story_urlSlug === void 0 ? void 0 : (_story_urlSlug_toLowerCase = _story_urlSlug.toLowerCase()) === null || _story_urlSlug_toLowerCase === void 0 ? void 0 : _story_urlSlug_toLowerCase.includes(normalizedSearchString)) || ((_story_customerCompany1 = story.customerCompany) === null || _story_customerCompany1 === void 0 ? void 0 : (_story_customerCompany_region = _story_customerCompany1.region) === null || _story_customerCompany_region === void 0 ? void 0 : (_story_customerCompany_region_name = _story_customerCompany_region.name) === null || _story_customerCompany_region_name === void 0 ? void 0 : (_story_customerCompany_region_name_toLowerCase = _story_customerCompany_region_name.toLowerCase()) === null || _story_customerCompany_region_name_toLowerCase === void 0 ? void 0 : _story_customerCompany_region_name_toLowerCase.includes(normalizedSearchString)) || ((_story_customerCompany2 = story.customerCompany) === null || _story_customerCompany2 === void 0 ? void 0 : (_story_customerCompany_industry = _story_customerCompany2.industry) === null || _story_customerCompany_industry === void 0 ? void 0 : (_story_customerCompany_industry_filter = _story_customerCompany_industry.filter((industry)=>{
                var _industry_name_toLowerCase, _industry_name;
                return (_industry_name = industry.name) === null || _industry_name === void 0 ? void 0 : (_industry_name_toLowerCase = _industry_name.toLowerCase()) === null || _industry_name_toLowerCase === void 0 ? void 0 : _industry_name_toLowerCase.includes(normalizedSearchString);
            })) === null || _story_customerCompany_industry_filter === void 0 ? void 0 : _story_customerCompany_industry_filter.length) || ((_story_products = story.products) === null || _story_products === void 0 ? void 0 : (_story_products_filter = _story_products.filter((product)=>{
                var _product_name_toLowerCase, _product_name;
                return (_product_name = product.name) === null || _product_name === void 0 ? void 0 : (_product_name_toLowerCase = _product_name.toLowerCase()) === null || _product_name_toLowerCase === void 0 ? void 0 : _product_name_toLowerCase.includes(normalizedSearchString);
            })) === null || _story_products_filter === void 0 ? void 0 : _story_products_filter.length) || ((_story_customerCompany3 = story.customerCompany) === null || _story_customerCompany3 === void 0 ? void 0 : (_story_customerCompany_organizationSize = _story_customerCompany3.organizationSize) === null || _story_customerCompany_organizationSize === void 0 ? void 0 : (_story_customerCompany_organizationSize_name = _story_customerCompany_organizationSize.name) === null || _story_customerCompany_organizationSize_name === void 0 ? void 0 : (_story_customerCompany_organizationSize_name_toLowerCase = _story_customerCompany_organizationSize_name.toLowerCase()) === null || _story_customerCompany_organizationSize_name_toLowerCase === void 0 ? void 0 : _story_customerCompany_organizationSize_name_toLowerCase.includes(normalizedSearchString));
            return true;
        });
        const filterResults = (0, $cFUxJ.filterCustomerStories)(searchResults, filterObject, "committedActive");
        updateCustomerStoryList(filterResults);
        setFilterSearchHasRun(true);
        createAnalyticsEvent({
            eventComponent: "customerFilter",
            eventType: "ui",
            action: "clicked",
            actionSubject: "component",
            attributes: {
                filtersApplied: (0, $aegm4.getFilterEventProps)(filterObject),
                page_path: "/customers"
            }
        }).fire();
    };
    // In order to get the number of Customer Stories matching the stagedActive filter
    // we need to we'll call the filterCustomerStories function with the stagedActive flag
    const numberOfCustomerStoriesFilteredByStagedActive = (0, $iSvIT.useMemo)(()=>{
        var _filterCustomerStories;
        return (_filterCustomerStories = (0, $cFUxJ.filterCustomerStories)(customers.customerStories, filterObjectValue, "stagedActive")) === null || _filterCustomerStories === void 0 ? void 0 : _filterCustomerStories.length;
    }, [
        filterObjectValue,
        customers.customerStories
    ]);
    let fallbackCustomerStoryList = (0, $iSvIT.useMemo)(()=>{
        return [];
    }, []);
    fallbackCustomerStoryList = (0, $iSvIT.useMemo)(()=>{
        return (0, $aegm4.handleFallbackCustomerStories)(customers.customerStories);
    }, [
        customers.customerStories
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $dyZbY.default), {
        name: "customers-page",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.default), {
                isShowTryNowLink: true,
                productKey: "customers"
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.TypographyStyles), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $ikB9y.CarouselSection), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $fTcHC.CustomerStoryFilters), {
                        filterObject: filterObjectValue,
                        clearAllFilterButtonClickHandler: clearAllFilters,
                        setFilterObjectValue: setFilterObjectValue,
                        runSearchWithFilters: runSearchWithFilters,
                        numberOfCustomerStoriesByCommittedValues: numberOfCustomerStories,
                        numberOfCustomerStoriesByStagedValues: numberOfCustomerStoriesFilteredByStagedActive,
                        searchStringValue: searchFilterString,
                        searchInputFieldFocused: searchInputFieldFocused,
                        setSearchInputFieldFocused: setSearchInputFieldFocused,
                        clearSearchField: clearSearchField,
                        setSearchString: setSearchStringWrapper,
                        hasFilterSearchRun: filterSearchhasRun
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $jLexR.CustomerStoriesSection), {
                        totalNumberOfCustomerStories: numberOfCustomerStories,
                        customerStoryList: customerStoryList === null || customerStoryList === void 0 ? void 0 : customerStoryList.slice(0, numberOfVisibleStories),
                        fallbackCustomerStoryList: fallbackCustomerStoryList,
                        filterSearchHasRun: filterSearchhasRun,
                        loadMoreStories: loadMoreStories
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $53agj.GlobalStatsSection), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $iyN25.FutureOfTeamwork), {})
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
        ]
    });
};
const $f1cdf8668dac3e64$var$getFilterByEnterpriseParam = ()=>{
    const { searchParams: searchParams } = new URL(window.location.href);
    const enterpriseParam = searchParams.get("filterByEnterprise");
    return enterpriseParam === "true";
};

});
parcelRegister("ju8Fs", function(module, exports) {
$parcel$export(module.exports, "CarouselSection", function () { return (parcelRequire("ikB9y")).CarouselSection; });
$parcel$export(module.exports, "CustomerStoriesSection", function () { return (parcelRequire("jLexR")).CustomerStoriesSection; });
$parcel$export(module.exports, "CustomerStoryFilters", function () { return (parcelRequire("fTcHC")).CustomerStoryFilters; });
$parcel$export(module.exports, "GlobalStatsSection", function () { return (parcelRequire("53agj")).GlobalStatsSection; });
$parcel$export(module.exports, "FutureOfTeamwork", function () { return (parcelRequire("iyN25")).FutureOfTeamwork; });
parcelRequire("ikB9y");
parcelRequire("gZeiy");
parcelRequire("jLexR");
parcelRequire("fTcHC");
parcelRequire("53agj");
parcelRequire("iyN25");

});
parcelRegister("ikB9y", function(module, exports) {

$parcel$export(module.exports, "CarouselSection", function () { return $a6b0a942cd0a8d10$export$5edf3752a9da9c72; });
/* carousel-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("1HoZL");
var $926Vv = parcelRequire("926Vv");

var $8z7A0 = parcelRequire("8z7A0");
const $a6b0a942cd0a8d10$export$5edf3752a9da9c72 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $dyZbY.default), {
        name: "customers-page-testimonial",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                layout: "8-4",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                        className: (0, $esG4f.default)([
                            "_1kd31nn1"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "CustomersLandingPage.CustomerStoriesCarouselSection.header",
                            values: {
                                span: (chunks)=>{
                                    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        children: chunks
                                    });
                                }
                            },
                            defaultMessage: "Customer stories <span>driven by the power of teamwork</span>"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {})
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $926Vv.ADG4CustomerTestimonials), {
                testimonials: $a6b0a942cd0a8d10$var$Testimonials(),
                className: "customer-stories-carousel"
            })
        ]
    });
};
const $a6b0a942cd0a8d10$var$h1Styles = null;
const $a6b0a942cd0a8d10$var$Testimonials = ()=>{
    const intl = (0, $f6qj2.default)();
    const testimonials = [
        {
            eyebrow: "Enterprise",
            name: "Joe Cotant",
            logo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8z7A0.TestimonialRoblox), {}),
            title: intl.formatMessage({
                id: "CustomersLandingPage.testimonial1.title",
                defaultMessage: "Senior Technical Program Manager, Roblox"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Robloxcustomerspage-394635826.webp",
            quote: intl.formatMessage({
                id: "CustomersLandingPage.testimonial1.quote",
                defaultMessage: "For the two teams we've already migrated from Wrike to Jira, each of those will amount to $150,000/year in savings."
            }),
            link: {
                text: intl.formatMessage({
                    id: "CustomersLandingPage.testimonial1.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $3FBn4.useLocalizedHref)("/customers/roblox")
            },
            label: "Roblox"
        },
        {
            name: "Wais Mojaddidi",
            logo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8z7A0.TestimonialRoyalCaribbean), {}),
            title: intl.formatMessage({
                id: "CustomersLandingPage.testimonial2.title",
                defaultMessage: "Director of Agile Delivery, Global E-commerce, Royal Caribbean"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/RoyalCaribbeancustomerspage-711769836.webp",
            quote: intl.formatMessage({
                id: "CustomersLandingPage.testimonial2.quote",
                defaultMessage: "By leveraging Jira and Confluence for automated reporting, we\u2019re saving over 800 hours and $500k per year in management consulting costs."
            }),
            link: {
                text: intl.formatMessage({
                    id: "CustomersLandingPage.testimonial2.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $3FBn4.useLocalizedHref)("/customers/royal-caribbean")
            },
            label: "Royal Caribbean International"
        },
        {
            name: "Mehmet Sari",
            logo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8z7A0.TestimonialMercedesBenz), {}),
            title: intl.formatMessage({
                id: "CustomersLandingPage.testimonial3.title",
                defaultMessage: "Modern Collaboration Platform Team, Mercedes-Benz"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/MercedesBenzcustomerspage-666640299.webp",
            quote: intl.formatMessage({
                id: "CustomersLandingPage.testimonial3.quote",
                defaultMessage: "With Atlassian cloud, everything regarding server maintenance is done for us, and there\u2019s less downtime and better performance."
            }),
            link: {
                text: intl.formatMessage({
                    id: "CustomersLandingPage.testimonial3.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $3FBn4.useLocalizedHref)("/customers/mercedes-benz")
            },
            label: "Mercedes Benz"
        },
        {
            name: "Stephanie Leue",
            logo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8z7A0.TestimonialDoodle), {}),
            title: intl.formatMessage({
                id: "CustomersLandingPage.testimonial4.title",
                defaultMessage: "Former Chief Product Officer, Doodle"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Doodlecustomerspage-541108127.webp",
            quote: intl.formatMessage({
                id: "CustomersLandingPage.testimonial4.quote",
                defaultMessage: "Jira Product Discovery translated our entire process into a highly transparent workflow, connected to the work we were already doing in Jira. That was a mind-blowing moment."
            }),
            link: {
                text: intl.formatMessage({
                    id: "CustomersLandingPage.testimonial4.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $3FBn4.useLocalizedHref)("/customers/doodle")
            },
            label: "Doodle"
        },
        {
            name: "Ryan Mosley",
            logo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8z7A0.TestimonialDHCS), {}),
            title: intl.formatMessage({
                id: "CustomersLandingPage.testimonial5.title",
                defaultMessage: "Chief of Factory & Engineering Modernization, DHCS"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/DHCScustomerspage-1081811850.webp",
            quote: intl.formatMessage({
                id: "CustomersLandingPage.testimonial5.quote",
                defaultMessage: "By tracking everything in Jira and all of our developer tools, we reduced the cost to get the team set up and deliver the product from $2.8 million to $600,000."
            }),
            link: {
                text: intl.formatMessage({
                    id: "CustomersLandingPage.testimonial5.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $3FBn4.useLocalizedHref)("/customers/dhcs")
            },
            label: "DHCS California Department of Health Care Services"
        }
    ];
    return testimonials;
};

});
parcelRegister("1HoZL", function(module, exports) {
$parcel$export(module.exports, "ADG4CustomerTestimonials", function () { return (parcelRequire("926Vv")).ADG4CustomerTestimonials; });

var $926Vv = parcelRequire("926Vv");

});
parcelRegister("926Vv", function(module, exports) {

$parcel$export(module.exports, "ADG4CustomerTestimonials", function () { return $1b23d4a428aa3c27$export$d0511cb0623812b3; });
/* customer-testimonials.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $eDoPe = parcelRequire("eDoPe");

var $cutM5 = parcelRequire("cutM5");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");
// @ts-ignore
const $1b23d4a428aa3c27$var$AUTO_TRANSITION_INTERVAL = 8000; /* eslint-disable local/ensure-wac-token-usage */ 
// Not able to use wacToken function with cssMap. Need to refactor this in the future to use dynamic functions
const $1b23d4a428aa3c27$var$backgroundColorStyleMap = {
    blue: "_bfhkdoyu",
    black: "_bfhkr3uz",
    white: "_bfhku67f"
};
const $1b23d4a428aa3c27$var$backgroundShapeStyleMap = {
    "image-left": "_mkrz75ra _1vthq8qa",
    "image-right": "_mkrz1ofp _1vth1ofp"
};
const $1b23d4a428aa3c27$var$customerImagesSectionStyleMap = {
    "image-left": "_1461n7od",
    "image-right": "_uhi5cs5v"
};
const $1b23d4a428aa3c27$var$customerQuotesSectionStyleMap = {
    "image-left": "_1461n7od",
    "image-right": "_uhi5kb7n _1fltkb7n"
};
const $1b23d4a428aa3c27$var$fontColorStyleMap = {
    "dark-bg": "_syaz12cp",
    "white-bg": "_syazn7od"
};
const $1b23d4a428aa3c27$var$topLineStyleMap = {
    blue: "_bfhk1nof",
    black: "_bfhku67f",
    white: "_bfhkr3uz"
};
const $1b23d4a428aa3c27$var$logoOptionStyleMap = {
    "dark-bg": "_d4ksu67f _i862u67f",
    "white-bg": "_d4ksr3uz _i862r3uz"
}; // eslint-disable-next-line complexity
const $1b23d4a428aa3c27$export$d0511cb0623812b3 = ({ bgColor: bgColor = "blue", heading: heading, subheading: subheading, cta: cta, testimonials: testimonials, productKey: productKey, className: className, imagePosition: imagePosition = "left", testimonialCta: testimonialCta })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)();
    const logosContainerStyles = null;
    const bgTheme = bgColor === "blue" || bgColor === "black" ? "dark-bg" : "white-bg";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4Tabs), {
        loop: true,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
                ref: scrollRef,
                className: sectionIsVisible ? "is-visible" : "",
                children: [
                    !heading && !subheading && !cta ? null : /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                        layout: "8",
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_y3gn1h6o _6rth1ylp"
                            ]),
                            children: [
                                heading && /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                    className: (0, $esG4f.default)([
                                        "_1mouqlbw",
                                        ""
                                    ]),
                                    children: heading
                                }),
                                subheading && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                    className: (0, $esG4f.default)([
                                        "_1mou1kvp",
                                        "body-lg"
                                    ]),
                                    children: subheading
                                }),
                                cta && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                    text: cta.text,
                                    href: cta.url,
                                    dataEventProps: cta.dataEventProps,
                                    type: "primary"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        ref: scrollRef,
                        className: (0, $esG4f.default)([
                            "_kqswh2mm _1pbykb7n _6rth1jfw",
                            $1b23d4a428aa3c27$var$fontColorStyleMap[bgTheme],
                            `${className} ${sectionIsVisible ? "is-visible" : ""} image-${imagePosition} ${bgColor}-background`
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_kqswstnw _1r04idpf _1bsb1lk2 _p12fklux _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1rfm1osq",
                                            $1b23d4a428aa3c27$var$backgroundColorStyleMap[bgColor],
                                            $1b23d4a428aa3c27$var$backgroundShapeStyleMap[`image-${imagePosition}`],
                                            "bgshape"
                                        ])
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c11p5 _yv0ehkll _2z05hkll _1ir7idpf _bhknkb7n _1rrs1txw _s9hn1ekt _16l7kb7n _w53ccs5v"
                                        ]),
                                        children: testimonials.map((testimonial, index)=>{
                                            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4TabPanel), {
                                                id: `${index}`,
                                                panelIndex: index,
                                                forceRender: true,
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)($1b23d4a428aa3c27$var$TopRowContent, {
                                                    testimonial: testimonial,
                                                    imagePosition: imagePosition,
                                                    index: index,
                                                    bgTheme: bgTheme,
                                                    bgColor: bgColor
                                                })
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_kqswh2mm _1e0c1txw _1p57v47k _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o",
                                            "row-width"
                                        ]),
                                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                            className: (0, $esG4f.default)([
                                                "_1reo15vq _18m915vq _1bsb1osq _1bah1yb4 _1v611bp4 _476dgktf",
                                                "_1e0clk1h _1jz9dz2r",
                                                "logos-container"
                                            ]),
                                            style: {
                                                "--_k8hunf": (0, $43MIc.default)(testimonialCta ? "flex" : "block"),
                                                "--_1t0o0zy": (0, $43MIc.default)(testimonialCta ? "0" : "auto")
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cutM5.Adg4DraggableTabList), {
                                                    className: (0, $esG4f.default)([
                                                        "_6rth1fu0 _1q511aa3 _qtt8agmp",
                                                        "logos"
                                                    ]),
                                                    rowGap: "32px",
                                                    children: [
                                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                            className: (0, $esG4f.default)([
                                                                "_kqswstnw _152tt94y _1e02idpf _rjxpidpf _4t3it94y _2rkoyh40 _tzy4105o _xaej183y",
                                                                $1b23d4a428aa3c27$var$topLineStyleMap[bgColor],
                                                                "top-line"
                                                            ])
                                                        }),
                                                        testimonials.map((testimonial, index)=>{
                                                            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTab), {
                                                                as: "button",
                                                                className: (0, $esG4f.default)([
                                                                    $1b23d4a428aa3c27$var$logoOptionStyleMap[bgTheme],
                                                                    "_1e0c1txw _1bah1fhb _4cvr1fhb _kqswh2mm _1atpidpf",
                                                                    "logo-option"
                                                                ]),
                                                                tabIndex: index,
                                                                dataEventProps: {
                                                                    "data-product-key": productKey,
                                                                    "data-event-component": "tab",
                                                                    "data-event-container": "testimonialsSection",
                                                                    "data-event": "clicked",
                                                                    "data-label-english": testimonial.label
                                                                },
                                                                label: testimonial.label,
                                                                children: /*#__PURE__*/ (0, $loA2J.jsx)($1b23d4a428aa3c27$var$LogoTabContent, {
                                                                    testimonialLogo: testimonial.logo
                                                                })
                                                            }, index);
                                                        })
                                                    ]
                                                }),
                                                testimonialCta && testimonialCta
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
const $1b23d4a428aa3c27$var$TopRowContent = ({ testimonial: testimonial, imagePosition: imagePosition, index: index, bgTheme: bgTheme, bgColor: bgColor, isPanelActive: isPanelActive })=>{
    var _testimonial_link_type;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _1e0c1txw _1p57v47k _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o",
            "_6rth1ylp _1e0c11p5 _yv0ewxkt _gy1pzwfg _tzy4idpf _1pbykb7n _1ph4hkll",
            isPanelActive && "_tzy4kb7n _1pbycs5v",
            "row-width top-row"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _i0dlhwvj _1e0c1txw _1bah1h6o _4cvresu3 _16xt1ssb _1rfm1vuk _q5ugidpf _7tld1wug _14adidpf _4uro1wug _7bcc1n8h _18jmidpf _qji61wug _ms0lidpf _v5we1wug",
                    $1b23d4a428aa3c27$var$customerImagesSectionStyleMap[`image-${imagePosition}`],
                    "customer-images-section"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_bna7ng7t _1jtm1c95 _1fhe1c95 _1cwsdlvw _mezj1wug _v4pn1ule",
                        isPanelActive && "_m3691nt4"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: {
                            src: testimonial.image,
                            alt: testimonial.title
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_i0dl1nrf _1reo15vq _18m915vq _1a8l1ssb",
                    $1b23d4a428aa3c27$var$customerQuotesSectionStyleMap[`image-${imagePosition}`],
                    "customer-quotes-section"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _4t3i1osq _1bahh9n0 _2rkogktf _kqswh2mm _19pkidpf _2hwx1wug _otyridpf _18u01wug _26vxys9h _12rr1e9y _1rfm1osq",
                        "testimonial-quotes-section"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_v5641pn7 _1e0c1txw _2lx21bp4 _zulp1tcg",
                            isPanelActive && "_y44v13sw _11vozap6",
                            "quote-container"
                        ]),
                        children: [
                            testimonial.eyebrow && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                className: (0, $esG4f.default)([
                                    $1b23d4a428aa3c27$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "eyebrow-md"
                                ]),
                                children: testimonial.eyebrow
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("blockquote", {
                                className: (0, $esG4f.default)([
                                    $1b23d4a428aa3c27$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "callout"
                                ]),
                                children: [
                                    "\u201C",
                                    testimonial.quote,
                                    "\u201D"
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                                className: (0, $esG4f.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        className: (0, $esG4f.default)([
                                            $1b23d4a428aa3c27$var$fontColorStyleMap[bgTheme],
                                            "eyebrow-lg"
                                        ]),
                                        children: testimonial.name
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        className: (0, $esG4f.default)([
                                            $1b23d4a428aa3c27$var$fontColorStyleMap[bgTheme],
                                            "body-md title"
                                        ]),
                                        children: testimonial.title
                                    })
                                ]
                            }),
                            testimonial.link && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                anchorProps: {
                                    tabIndex: isPanelActive ? 0 : -1
                                },
                                text: testimonial.link.text,
                                href: testimonial.link.url,
                                type: (_testimonial_link_type = testimonial.link.type) !== null && _testimonial_link_type !== void 0 ? _testimonial_link_type : "primary",
                                bgColor: bgColor === "blue" || bgColor === "black" ? "bgBlackBlue" : "bgWhite",
                                dataEventProps: testimonial.link.dataEventProps
                            })
                        ]
                    }, index)
                })
            })
        ]
    });
};
const $1b23d4a428aa3c27$var$topRowActiveStyle = null;
const $1b23d4a428aa3c27$var$customerImagesImgActiveStyle = null;
const $1b23d4a428aa3c27$var$quoteContainerActiveStyle = null;
const $1b23d4a428aa3c27$var$LogoTabContent = ({ testimonialLogo: testimonialLogo, isSelected: isSelected })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    isSelected && "_tzy4kb7n _kqswstnw _152tj39m _1e02idpf _rjxpidpf _4t3i14y2 _2rkoyh40",
                    "top-marker"
                ])
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_11q7glyw _19itidpf _r06hglyw _1q51gktf _80omtlke _kqswh2mm"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    className: (0, $esG4f.default)([
                        "_tzy4105o _v5641bs3 _16l4kb7n",
                        "_4t3i1u1b _1e0c1txw _4cvr1h6o",
                        isSelected && "_tzy4kb7n",
                        "logo-img-container"
                    ]),
                    children: testimonialLogo
                })
            })
        ]
    });
}; // LogoTabContent styles
const $1b23d4a428aa3c27$var$logoImgStyle = null;
const $1b23d4a428aa3c27$var$logoImgSelectedStyle = null;
const $1b23d4a428aa3c27$var$logoButtonStyle = null;
const $1b23d4a428aa3c27$var$topMarkerStyle = null;
const $1b23d4a428aa3c27$var$logoImgContainerStyle = null; // ADG4CustomerTestimonials styles
const $1b23d4a428aa3c27$var$headerStyles = null;
const $1b23d4a428aa3c27$var$h2Styles = null;
const $1b23d4a428aa3c27$var$pStyles = null;
const $1b23d4a428aa3c27$var$topLineStyles = null;
const $1b23d4a428aa3c27$var$testimonialKeyframeStyles = null;
const $1b23d4a428aa3c27$var$rowWidthStyle = null;
const $1b23d4a428aa3c27$var$topRowStyle = null;
const $1b23d4a428aa3c27$var$bgShapeStyle = null;
const $1b23d4a428aa3c27$var$customerImagesSectionStyles = null;
const $1b23d4a428aa3c27$var$customerImagesSectionImageStyles = null;
const $1b23d4a428aa3c27$var$customerQuotesSectionStyle = null;
const $1b23d4a428aa3c27$var$testimonialQuotesSectionStyle = null;
const $1b23d4a428aa3c27$var$quoteContainerStyle = null;
const $1b23d4a428aa3c27$var$quoteContainerPStyle = null;
const $1b23d4a428aa3c27$var$logosContainerBaseStyle = null;
const $1b23d4a428aa3c27$var$logosStyle = null;
const $1b23d4a428aa3c27$var$logoOptionStyle = null;
const $1b23d4a428aa3c27$var$testimonialStyles = null;
const $1b23d4a428aa3c27$var$tabPanelWrapperStyles = null;

});


parcelRegister("8z7A0", function(module, exports) {

$parcel$export(module.exports, "TestimonialRedfin", function () { return $31e5b10935f9b9be$export$faa4c35a40f54c9f; });
$parcel$export(module.exports, "TestimonialDHCS", function () { return $31e5b10935f9b9be$export$559c708bf478ce1; });
$parcel$export(module.exports, "TestimonialDropbox", function () { return $31e5b10935f9b9be$export$3944c61ebd3bc79e; });
$parcel$export(module.exports, "TestimonialRoblox", function () { return $31e5b10935f9b9be$export$d76e3d65f440a2bb; });
$parcel$export(module.exports, "TestimonialLumen", function () { return $31e5b10935f9b9be$export$2d5c2c6aa86b2349; });
$parcel$export(module.exports, "TestimonialDoodle", function () { return $31e5b10935f9b9be$export$72c6ec790fc33a37; });
$parcel$export(module.exports, "TestimonialRoyalCaribbean", function () { return $31e5b10935f9b9be$export$ea2a07b098c3c428; });
$parcel$export(module.exports, "TestimonialMercedesBenz", function () { return $31e5b10935f9b9be$export$3192ac60f265126c; });
$parcel$export(module.exports, "TestimonialSunLife", function () { return $31e5b10935f9b9be$export$53d258996873a1e3; });
$parcel$export(module.exports, "TestimonialUnited", function () { return $31e5b10935f9b9be$export$6a1b58616eb8f4e3; });
/* testimonial-logos.tsx generated by @compiled/babel-plugin v0.28.8 */ /* testimonial logos */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $bhreu = parcelRequire("bhreu");
const $31e5b10935f9b9be$export$c237744daee40794 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "25",
        viewBox: "0 0 69 25",
        fill: "none",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M56.6992 0.810686C54.0412 0.806395 51.4603 1.7031 49.3776 3.35447C47.295 1.70299 44.714 0.806273 42.056 0.810686C39.3982 0.806573 36.8175 1.70327 34.7348 3.35447C32.6524 1.70291 30.0715 0.806178 27.4136 0.810686C24.7558 0.806573 22.1751 1.70327 20.0924 3.35447C18.0098 1.70321 15.429 0.806512 12.7712 0.810686C6.24899 0.810686 0.963501 6.09579 0.963501 12.6184C0.963501 19.1402 6.2486 24.4261 12.7712 24.4261C15.429 24.4302 18.0097 23.5335 20.0924 21.8823C22.175 23.5336 24.7558 24.4303 27.4136 24.4261C30.0715 24.4305 32.6523 23.5338 34.7348 21.8823C36.8175 23.5335 39.3982 24.4302 42.056 24.4261C44.714 24.4305 47.2949 23.5338 49.3776 21.8823C51.4603 23.5338 54.0412 24.4305 56.6992 24.4261C63.2214 24.4261 68.5065 19.1406 68.5065 12.6184C68.5065 6.09617 63.2214 0.810686 56.6992 0.810686ZM18.1605 19.9534C16.6559 21.051 14.7762 21.7209 12.7712 21.7209C7.73975 21.7209 3.66831 17.6498 3.66831 12.6184C3.66831 7.58693 7.73975 3.5155 12.7712 3.5155C14.7762 3.5155 16.6547 4.18574 18.1605 5.28373C16.5015 7.36796 15.6007 9.95451 15.6063 12.6184C15.6075 15.2812 16.5075 17.8657 18.1605 19.9534ZM20.0928 18.0269C18.9324 16.4627 18.3077 14.5659 18.3115 12.6184C18.3066 10.6707 18.9314 8.77353 20.0928 7.20992C21.2539 8.77365 21.8787 10.6707 21.8741 12.6184C21.8777 14.5659 21.253 16.4627 20.0928 18.0269ZM32.8032 19.9534C31.24 21.1043 29.3486 21.7229 27.4075 21.7182C25.4703 21.7221 23.5832 21.1035 22.0244 19.9534C23.6775 17.866 24.5775 15.2815 24.5785 12.6188C24.5841 9.95489 23.6834 7.36835 22.0244 5.28412C23.583 4.13374 25.4702 3.51491 27.4075 3.51896C29.427 3.51896 31.2929 4.17229 32.8032 5.28412C31.1443 7.36835 30.2435 9.95489 30.2491 12.6188C30.2502 15.2815 31.1502 17.8659 32.8032 19.9534ZM34.7348 18.0269C33.5744 16.4627 32.9497 14.5659 32.9535 12.6184C32.9488 10.6707 33.5736 8.77362 34.7348 7.20992C35.8962 8.77352 36.5212 10.6706 36.5165 12.6184C36.5202 14.566 35.8953 16.4628 34.7348 18.0269ZM47.4457 19.9534C45.9353 21.0656 44.0694 21.7182 42.0503 21.7182C40.0311 21.7182 38.1771 21.0645 36.6668 19.9534C38.32 17.8661 39.22 15.2816 39.2209 12.6188C39.2265 9.95489 38.3258 7.36835 36.6668 5.28412C38.1771 4.17268 40.0311 3.51896 42.0503 3.51896C44.0694 3.51896 45.9353 4.17229 47.4457 5.28412C45.7869 7.36845 44.8862 9.95493 44.8915 12.6188C44.8928 15.2815 45.7928 17.8658 47.4457 19.9534ZM49.378 18.0269C48.2176 16.4627 47.5929 14.5659 47.5967 12.6184C47.5916 10.6706 48.2165 8.77346 49.378 7.20992C50.5391 8.77365 51.1639 10.6707 51.1593 12.6184C51.1628 14.5659 50.5381 16.4626 49.378 18.0269ZM56.6992 21.7209C54.6935 21.7209 52.8142 21.051 51.3099 19.9534C52.9629 17.8659 53.8629 15.2815 53.8641 12.6188C53.8694 9.95493 52.9687 7.36845 51.3099 5.28412C52.8157 4.18651 54.6938 3.51588 56.6992 3.51588C61.7299 3.51588 65.8021 7.58732 65.8021 12.6188C65.8021 17.6495 61.7299 21.7209 56.6992 21.7209Z",
            fill: "#101214"
        })
    });
};
const $31e5b10935f9b9be$export$7952818aa3b430a7 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "85",
        height: "25",
        viewBox: "0 0 85 25",
        fill: "none",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M45.0486 23.7095H56.5358C58.2522 23.7095 59.6608 23.0052 60.805 21.5961C61.9053 20.2318 62.4776 18.6035 62.4776 16.7555C62.4776 13.0143 57.6804 10.3735 55.831 10.3735H49.5375C49.0534 10.3735 48.6565 10.1533 48.3491 9.8016C48.0408 9.40515 47.8649 8.9653 47.8649 8.43685C47.8649 7.8207 48.0408 7.2927 48.3491 6.85241C48.7012 6.41255 49.1411 6.14856 49.6695 6.14856H61.465V1.43862H49.4489C47.2922 1.43862 45.6191 2.09907 44.4307 3.37521C43.3751 4.56366 42.8462 6.14811 42.8462 8.04086C42.8462 9.8893 43.3751 11.518 44.4307 12.8376C45.6191 14.29 47.0282 15.0391 48.7446 15.0391H56.0073C56.4467 15.0391 56.7993 15.1711 57.0629 15.5223C57.3712 15.8745 57.5032 16.3148 57.5032 16.7994C57.5032 17.3717 57.283 17.8997 56.9309 18.34C56.5349 18.736 56.0946 18.9561 55.5232 18.9561H43.9036L43.7277 18.6478L39.3704 4.65181L39.1502 4.21151C38.0938 2.05477 36.3335 0.998769 33.9128 0.998769C32.5923 0.998769 31.4039 1.30662 30.3474 1.96706C29.2471 2.62706 28.5428 3.59536 28.1468 4.82811L22.2927 23.6652L27.6184 23.7099L32.9879 6.941C33.1199 6.41256 33.4282 6.14856 33.8242 6.14856C34.0443 6.14856 34.2202 6.23626 34.3522 6.36871C34.4842 6.54456 34.5723 6.72086 34.6162 6.941L40.0295 23.7099L45.0486 23.7095ZM5.43611 8.30485V23.6652H0.50647V6.63226C0.50647 4.43166 1.03492 2.89106 2.17907 1.96706C3.05922 1.30662 4.37966 0.954468 6.22811 0.954468C7.72441 0.954468 9.001 1.39477 10.1452 2.23107C11.2893 3.06736 12.0375 4.21151 12.4339 5.62011L15.6466 16.9314L16.1751 18.472C16.2189 18.7798 16.3952 19 16.5711 19.1754C16.7912 19.3521 17.0109 19.4403 17.2754 19.3521C17.7157 19.3083 17.9358 19.0438 17.9358 18.6478V1.48292H22.9975V18.4277C22.9975 20.3204 22.5576 21.7295 21.6332 22.7416C20.753 23.7538 19.4326 24.2822 17.6718 24.2822C16.1312 24.2822 14.8546 23.9739 13.8425 23.4459C12.6102 22.8298 11.8177 21.8615 11.4656 20.5844L7.76871 7.68871L7.50471 6.85241C7.41656 6.54455 7.24071 6.32441 7.02056 6.10426C6.80041 5.92796 6.53641 5.88411 6.27241 5.92796C6.00841 5.97226 5.83256 6.10426 5.65626 6.36826C5.51155 6.60704 5.43538 6.88105 5.43611 7.16026V8.30485ZM84.2204 23.7095L78.4988 4.65181L78.2786 4.21151C77.2222 2.05477 75.4619 0.998769 73.0411 0.998769C71.7207 0.998769 70.5322 1.30662 69.4762 1.96706C68.375 2.62706 67.6716 3.59536 67.2747 4.82811L61.4211 23.6652L66.7467 23.7099L72.1162 6.941C72.2482 6.41256 72.5565 6.14856 72.9525 6.14856C73.1727 6.14856 73.3485 6.23626 73.4805 6.36871C73.6134 6.54456 73.7007 6.72086 73.7454 6.941L79.1588 23.7099L84.2204 23.7095Z",
            fill: "#101214"
        })
    });
};
const $31e5b10935f9b9be$export$53457fb076dd0473 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "71",
        height: "30",
        viewBox: "0 0 71 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M6.19961 0H0.302734V29.4403H6.19961V0ZM21.6954 29.4381H27.5923V9.42706H21.6954V29.4381ZM36.7814 29.4381H43.5707L50.36 9.42706H44.4632C44.4632 9.42706 41.3098 20.2777 40.349 23.7307H40.2807C39.3199 20.2777 36.0982 9.42706 36.0982 9.42706H29.8576L36.7814 29.4381ZM70.9264 9.42706H65.2344V12.175C64.2736 10.0617 62.0127 8.86294 59.3375 8.86294C54.5381 8.86294 50.6972 12.8801 50.6972 19.4315C50.6972 25.9828 54.3993 30 59.0621 30C62.3543 30 64.2736 28.3803 65.3027 26.5469V29.4359H70.9925L70.9264 9.42706ZM65.1 19.9273C65.1 23.5919 62.9052 25.3526 60.7104 25.3526C58.3107 25.3526 56.7329 22.8162 56.7329 19.4337C56.7329 16.0511 58.379 13.5148 60.9153 13.5148C62.9713 13.5148 65.0978 15.2755 65.0978 18.9401V19.9273H65.1ZM7.70688 18.9401C17.1692 18.9401 19.364 10.8374 19.364 9.42706H18.542C9.07973 9.42706 6.88493 17.5297 6.88493 18.9401H7.70688ZM6.88493 19.6452C6.88493 21.1238 8.53103 29.3676 18.6787 29.3676H19.5006C19.5006 27.8889 17.8545 19.6452 7.70688 19.6452H6.88493ZM28.2093 3.93125C28.2093 2.02953 26.7703 0.407668 24.9171 0.407668C24.8488 0.407668 24.7805 0.407668 24.7122 0.407668C22.8611 0.337153 21.2833 1.81578 21.215 3.7197C21.215 3.79022 21.215 3.86073 21.215 3.93125C21.215 5.83297 22.654 7.45483 24.5072 7.45483C24.5755 7.45483 24.6439 7.45483 24.7122 7.45483C26.5632 7.52534 28.141 6.04672 28.2093 4.1428C28.2093 4.07228 28.2093 4.00176 28.2093 3.93125Z",
            fill: "white"
        })
    });
};
const $31e5b10935f9b9be$export$17670a653fa957a4 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "102",
        height: "31",
        viewBox: "0 0 102 31",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M0 6.34607H3.55597V14.2464H11.0557V6.34607H14.6163V25.739H11.0557V17.6727H3.55597V25.739H0V6.34607ZM25.8816 19.4224C25.8816 21.0458 24.559 22.3669 22.936 22.3669C21.3123 22.3669 19.9905 21.0458 19.9905 19.4224V11.0731H16.6182V19.4224C16.6182 22.9057 19.4525 25.739 22.936 25.739C26.4186 25.739 29.2527 22.9057 29.2527 19.4224V11.0731H25.8816V19.4224ZM38.6669 11.1709C36.9941 11.1709 35.8265 11.6563 34.6988 12.7632V6.34607H31.3156V18.2388C31.3156 22.6904 34.5341 25.739 38.15 25.739C42.1699 25.739 45.692 22.636 45.692 18.4551C45.692 14.3273 42.4442 11.1709 38.6669 11.1709ZM38.751 22.6091C36.4585 22.6091 34.7054 20.6945 34.7054 18.4551C34.7054 16.2154 36.4585 14.3002 38.751 14.3002C40.6935 14.3002 42.4476 16.2154 42.4476 18.4551C42.4476 20.6945 40.6935 22.6091 38.751 22.6091ZM51.3744 12.0232C51.3744 10.3225 52.5076 9.78333 53.7482 9.78333C54.7469 9.78333 56.0685 10.5387 56.931 11.4561L59.1427 8.86645C58.0373 7.38286 55.7986 6.35742 53.9641 6.35742C50.2948 6.35742 47.6509 8.48878 47.6509 12.0232C47.6509 18.5786 55.7176 16.5007 55.7176 20.1706C55.7176 21.3024 54.6118 22.3015 53.3446 22.3015C51.3475 22.3015 50.6997 21.3303 49.7828 20.3048L47.3274 22.8404C48.8931 24.756 50.8348 25.7276 53.1552 25.7276C56.635 25.7276 59.4409 23.5694 59.4409 20.1967C59.4409 12.913 51.3744 15.1794 51.3744 12.0232ZM68.3475 10.9809C64.732 10.9809 61.5131 14.0277 61.5131 18.4802V30.4037H64.8961V23.956C66.0239 25.0621 67.191 25.5484 68.8644 25.5484C72.6415 25.5484 75.8897 22.3924 75.8897 18.2645C75.8897 14.0831 72.3666 10.9809 68.3475 10.9809ZM68.9487 22.4195C66.6564 22.4195 64.9031 20.5022 64.9031 18.2645C64.9031 16.0248 66.6564 14.1096 68.9487 14.1096C70.8908 14.1096 72.6451 16.0248 72.6451 18.2645C72.6451 20.5022 70.8908 22.4195 68.9487 22.4195ZM100.793 22.6091C98.7974 22.6091 98.2309 21.7462 98.2309 20.4238V14.5699H101.333V11.6027H98.2309V7.69061L94.8058 9.22798V21.1522C94.8058 24.201 96.9093 25.739 99.7946 25.739C100.226 25.739 100.82 25.7111 101.144 25.6312L101.981 22.5561C101.603 22.5822 101.172 22.6091 100.793 22.6091Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M91.8684 14.7425C91.2198 13.6266 90.3075 12.7321 89.1669 12.0586C88.3146 11.5624 87.4308 11.2475 86.4348 11.1122V7.56661C87.4308 7.14373 88.0489 6.20773 88.0489 5.11576C88.0489 3.62739 86.8553 2.42129 85.3681 2.42129C83.8798 2.42129 82.6653 3.62739 82.6653 5.11576C82.6653 6.20773 83.2477 7.14373 84.2437 7.56661V11.1138C83.4469 11.229 82.6207 11.4774 81.8662 11.859C80.325 10.6885 75.2715 6.84873 72.3153 4.60602C72.3854 4.35325 72.4394 4.09271 72.4394 3.81782C72.4394 2.16931 71.1044 0.83313 69.4553 0.83313C67.8062 0.83313 66.4718 2.16931 66.4718 3.81782C66.4718 5.46614 67.8076 6.80271 69.4567 6.80271C70.0192 6.80271 70.5395 6.63818 70.9885 6.36768L71.6123 6.84096L80.1848 13.0175C79.7316 13.4336 79.3095 13.9069 78.9719 14.4379C78.2877 15.5205 77.8696 16.7117 77.8696 18.011V18.2821C77.8696 19.1942 78.0429 20.0554 78.3381 20.8643C78.598 21.5706 78.9781 22.2128 79.4488 22.7934L76.6037 25.6455C76.1914 25.492 75.7436 25.4605 75.3139 25.5548C74.8841 25.649 74.4906 25.865 74.1803 26.1769C73.9655 26.3907 73.7953 26.6449 73.6794 26.925C73.5636 27.205 73.5044 27.5053 73.5055 27.8083C73.5057 28.4244 73.7457 29.0035 74.1815 29.4391C74.3951 29.6541 74.6493 29.8245 74.9293 29.9406C75.2092 30.0566 75.5094 30.1159 75.8125 30.1151C76.1157 30.1159 76.416 30.0566 76.696 29.9405C76.9761 29.8245 77.2303 29.654 77.4441 29.4391C77.6588 29.2253 77.829 28.9712 77.9449 28.6913C78.0608 28.4113 78.1201 28.1113 78.1194 27.8083C78.1194 27.5699 78.0825 27.3372 78.0132 27.1161L80.9539 24.175C81.357 24.4535 81.7925 24.688 82.2606 24.8901C83.1838 25.2893 84.2029 25.5325 85.3182 25.5325H85.5225C86.7555 25.5325 87.9186 25.2429 89.012 24.6505C90.1641 24.0245 91.0658 23.1683 91.7471 22.0754C92.4319 20.9794 92.809 19.7685 92.809 18.4363V18.3698C92.809 17.0593 92.5056 15.8502 91.8684 14.7425ZM88.2754 20.9121C87.4772 21.7991 86.5597 22.3455 85.5225 22.3455H85.3516C84.7592 22.3455 84.1798 22.1817 83.6125 21.8839C82.9731 21.5561 82.487 21.0884 82.0892 20.4962C81.6781 19.9149 81.455 19.2803 81.455 18.6074V18.4031C81.455 17.7415 81.5819 17.1143 81.9018 16.5219C82.2438 15.8743 82.7057 15.3708 83.3201 14.9704C83.9232 14.5728 84.5674 14.3778 85.2849 14.3778H85.3516C86.0022 14.3778 86.6181 14.5061 87.1993 14.8035C87.7915 15.1206 88.2754 15.5538 88.6504 16.1237C89.0148 16.6938 89.2315 17.3087 89.3012 17.9786C89.3122 18.1178 89.3177 18.2604 89.3177 18.3967C89.3177 19.3058 88.9703 20.1478 88.2754 20.9121Z",
                fill: "#101214"
            })
        ]
    });
};
const $31e5b10935f9b9be$export$faa4c35a40f54c9f = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "74",
        height: "21",
        viewBox: "0 0 74 21",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M38.2467 4.39989C36.9006 3.47215 35.0814 3.13135 32.662 3.13135H28.0898V18.8903H32.759C34.4205 18.8903 35.8515 18.6694 37.0461 18.1708C38.2467 17.6596 39.1866 16.8518 39.8233 15.6842C40.46 14.5166 40.7935 13.002 40.7935 11.0708C40.7935 9.40462 40.5934 8.0351 40.175 6.93696C39.7506 5.83883 39.1139 5.00576 38.2467 4.39989ZM37.0218 13.7972C36.7975 14.5861 36.4337 15.1856 35.8758 15.6022C35.2573 16.0566 34.3295 16.3027 33.1835 16.3027H31.5462V5.72523H32.9227C34.2749 5.73154 35.2755 5.95243 35.9486 6.46994C36.4397 6.85492 36.7854 7.38506 37.0097 8.11084C37.2341 8.84293 37.3311 9.75804 37.3311 10.9004C37.3311 12.0427 37.2462 13.0146 37.0218 13.7972Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M42.9609 18.8903H46.4234V12.1752H50.4194V9.60658H46.4234V5.72523H52.5963V3.13135H42.9609V18.8903Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M54.7842 18.8912H58.2467V3.13232H54.7842C54.7842 3.13232 54.76 18.8912 54.7842 18.8912Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M73.4648 3.13135H69.9902V12.1752L63.5505 3.13135H60.7793V18.8903H64.2599V9.60658L70.6269 18.8903H73.4648V3.13135Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M15.0294 19.4902C14.7384 19.3703 14.4473 19.1368 13.6651 17.7673L12.1006 15.0787L10.2633 11.9042L10.1056 11.6329C10.1966 11.6076 10.2815 11.576 10.3724 11.5445C12.4826 10.7935 13.7136 8.78021 13.7136 5.91496C13.7136 4.49495 13.1618 3.18855 12.1127 2.21032C11.9611 2.07778 11.8035 1.94525 11.6337 1.82534C10.233 0.859735 8.34105 0.5 5.8185 0.5H1.05841H0.985639C0.676384 0.5 0.646065 0.683023 0.767342 0.853424C0.87649 0.99858 1.00383 1.20054 1.05234 1.70543V17.5275C0.997767 18.1712 0.870427 18.3795 0.767342 18.5246C0.646065 18.695 0.70064 18.8843 1.00989 18.878H4.53904V12.1756H6.13988L7.26775 14.1699L8.68669 16.6755L9.37796 17.8935C10.2512 19.4271 11.0152 20.2728 12.5433 20.4558C12.7494 20.4874 12.9738 20.5 13.2103 20.5C13.2285 20.5 13.4286 20.5 13.4468 20.5C13.9925 20.5 14.5322 20.2728 14.8597 20.1213C14.9021 20.1024 14.9506 20.0835 14.9931 20.0645C15.3872 19.8752 15.272 19.5912 15.0294 19.4902ZM6.77659 9.60697H4.65425H4.53297V3.13174H6.77659C7.88626 3.13174 8.72913 3.28321 9.36584 3.88277C9.60232 4.11628 9.77817 4.39397 9.91158 4.72846C10.0692 5.13869 10.1481 5.62465 10.1481 6.21789C10.142 7.07621 10.0632 9.60697 6.77659 9.60697Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M19.5662 12.1752H23.5683V9.60658H19.5662V5.71891H25.7391V3.13135H16.0977V18.8903H25.7391V16.2774H19.5662V12.1752Z",
                fill: "white"
            })
        ]
    });
};
const $31e5b10935f9b9be$var$testimonialDHCSStyle = null;
const $31e5b10935f9b9be$export$559c708bf478ce1 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-dhcs-2416114995.webp",
            alt: ""
        },
        className: (0, $esG4f.default)([
            "_1bsb10e3 _4t3i1u1b"
        ])
    });
};
const $31e5b10935f9b9be$export$2e83fbbf538f5ae7 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "57",
        height: "34",
        viewBox: "0 0 57 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                clipPath: "url(#clip0_7035_3621)",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M38.2791 29.91C38.2336 29.8512 38.1835 29.8059 38.1153 29.7698C38.047 29.7336 37.9742 29.7109 37.8878 29.7109C37.8104 29.7109 37.7376 29.72 37.6694 29.7562C37.6012 29.7833 37.5466 29.8331 37.4965 29.8874C37.4465 29.9417 37.4192 30.0095 37.3919 30.0865C37.3646 30.1634 37.3555 30.2358 37.3555 30.3217V30.3308H38.4019C38.4019 30.2539 38.3928 30.1815 38.3746 30.1046C38.3564 30.0276 38.3291 29.9643 38.2791 29.9055V29.91Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M1.32617 26.4219V34.0001H55.8044V26.4219H1.32617ZM14.3065 31.7741L13.9744 30.9145H12.6959L12.382 31.7741H11.9361L13.2009 28.4578H13.4876L14.7751 31.7741H14.3065ZM16.4767 29.8241C16.3994 29.7879 16.3266 29.7653 16.2401 29.7653C16.1628 29.7653 16.0763 29.7834 16.0035 29.8332C15.9171 29.8694 15.8307 29.9372 15.7351 30.0323V31.7651H15.2983V29.3989H15.6623L15.7215 29.6658C15.7988 29.5979 15.8625 29.5436 15.9217 29.4939C15.9808 29.4577 16.0354 29.417 16.0945 29.3989C16.14 29.3808 16.1992 29.3627 16.2356 29.3536C16.2811 29.3446 16.322 29.3446 16.3675 29.3446C16.4267 29.3446 16.4813 29.3536 16.5313 29.3627C16.5768 29.3808 16.6178 29.3989 16.6542 29.4215L16.4813 29.8287L16.4767 29.8241ZM18.0509 31.7741H17.7188L16.7952 29.3989H17.2411L17.878 31.1995H17.8871L18.6014 29.3989H19.0291L18.0464 31.7741H18.0509ZM20.8217 31.756L20.7261 31.5298C20.6988 31.566 20.6488 31.5977 20.6033 31.6338C20.5578 31.661 20.4987 31.6927 20.4395 31.7198C20.3804 31.7379 20.3167 31.756 20.2484 31.7786C20.1802 31.7877 20.1074 31.7967 20.0209 31.7967C19.9163 31.7967 19.8208 31.7877 19.7343 31.7515C19.6388 31.7243 19.5614 31.6746 19.4977 31.6112C19.4295 31.5524 19.3749 31.48 19.3339 31.385C19.2975 31.2991 19.2748 31.195 19.2748 31.0819C19.2748 30.8466 19.3612 30.6566 19.5205 30.5209C19.6843 30.3897 19.9208 30.3128 20.2348 30.3037L20.6897 30.2856V30.1997C20.6897 30.1137 20.6806 30.0368 20.6534 29.9734C20.6261 29.9101 20.5942 29.8603 20.5487 29.8241C20.5123 29.7879 20.4532 29.7563 20.3986 29.7382C20.344 29.7201 20.2757 29.711 20.2075 29.711C20.1301 29.711 20.0664 29.7201 20.0073 29.7291C19.939 29.7382 19.8844 29.7563 19.8344 29.7744C19.7889 29.7925 19.7389 29.8106 19.7025 29.8422C19.6661 29.8739 19.6251 29.8875 19.5887 29.9191L19.4249 29.616C19.5023 29.5572 19.5751 29.521 19.6433 29.4848C19.7116 29.4486 19.7844 29.417 19.8526 29.3989C19.9208 29.3717 19.9845 29.3627 20.0619 29.3536C20.1301 29.3446 20.2029 29.3446 20.2803 29.3446C20.4031 29.3446 20.5169 29.3627 20.6215 29.3898C20.7261 29.417 20.8126 29.4667 20.8899 29.5301C20.9673 29.5979 21.0219 29.6794 21.0719 29.7879C21.1174 29.892 21.1402 30.0232 21.1402 30.177V31.3217C21.1402 31.4167 21.1493 31.5026 21.1493 31.5569C21.1584 31.6158 21.1675 31.6429 21.1675 31.6791C21.1675 31.7153 21.1766 31.747 21.1857 31.7651H20.8126L20.8217 31.756ZM22.9555 31.747C22.8327 31.7922 22.7189 31.8148 22.6143 31.8148C22.5187 31.8148 22.4414 31.8058 22.3777 31.7786C22.314 31.7515 22.2549 31.7198 22.2139 31.6746C22.1684 31.6293 22.1366 31.5705 22.1184 31.5117C22.1002 31.4438 22.0911 31.3805 22.0911 31.3036V29.7698H21.6998V29.3989H22.0911V28.8695L22.5369 28.7293V29.4034H23.2603L23.1193 29.7653H22.5369V31.1588C22.5369 31.2538 22.5551 31.3307 22.5961 31.376C22.637 31.4212 22.6916 31.4438 22.769 31.4438C22.8054 31.4438 22.8463 31.4348 22.8827 31.4257C22.9191 31.4167 22.9601 31.4076 22.9965 31.3895C23.0329 31.3714 23.0647 31.3624 23.092 31.3443C23.1102 31.3171 23.1375 31.3081 23.1602 31.2855L23.2922 31.5886C23.1875 31.6655 23.0829 31.7198 22.9601 31.7605L22.9555 31.747ZM25.8218 31.0909C25.7627 31.2538 25.6808 31.385 25.5761 31.4981C25.4806 31.5931 25.3669 31.67 25.2349 31.7243C25.103 31.7696 24.9574 31.8012 24.7981 31.8012C24.4842 31.8012 24.234 31.7062 24.0383 31.5162C23.9337 31.4031 23.8472 31.2719 23.7927 31.109C23.7335 30.9462 23.7062 30.7697 23.7062 30.5797C23.7062 30.3897 23.7335 30.2178 23.7927 30.0594C23.8518 29.8965 23.9337 29.7653 24.0383 29.6522C24.1339 29.5482 24.2476 29.4712 24.3796 29.4169C24.5024 29.3581 24.648 29.331 24.8072 29.331C24.9801 29.331 25.1212 29.3581 25.2531 29.4169C25.3851 29.4758 25.4988 29.5482 25.5943 29.6522C25.699 29.7653 25.7854 29.8965 25.8218 30.0503C25.881 30.1997 25.9083 30.3806 25.9083 30.5706C25.9083 30.7607 25.881 30.9326 25.8218 31.0909ZM29.7755 31.281C29.7164 31.3941 29.6436 31.48 29.548 31.5569C29.4525 31.6339 29.3388 31.6881 29.2068 31.7379C29.0749 31.7741 28.9293 31.8058 28.7791 31.8058C28.6654 31.8058 28.5699 31.7967 28.4743 31.7786C28.3788 31.7605 28.2923 31.7424 28.215 31.7108C28.1376 31.6836 28.0739 31.6519 28.0057 31.6248C27.9374 31.5977 27.8919 31.5569 27.8328 31.5298L28.033 31.1905C28.0694 31.2176 28.1103 31.2493 28.1558 31.2764C28.2013 31.3036 28.2605 31.3352 28.3287 31.3533C28.3879 31.3714 28.4607 31.3895 28.5289 31.4122C28.6062 31.4303 28.679 31.4303 28.7564 31.4303C28.8246 31.4303 28.8974 31.4212 28.9748 31.4031C29.0521 31.385 29.1158 31.3579 29.175 31.3172C29.2341 31.2764 29.2796 31.2312 29.316 31.1769C29.3524 31.1181 29.3751 31.0457 29.3751 30.9688C29.3751 30.8828 29.357 30.7969 29.316 30.7335C29.2751 30.6702 29.2205 30.6023 29.1522 30.5435C29.084 30.4847 29.0112 30.4394 28.9247 30.3806C28.8383 30.3354 28.7518 30.2856 28.6654 30.2313C28.579 30.1861 28.4925 30.1273 28.4061 30.0684C28.3196 30.0096 28.2423 29.9463 28.1786 29.8694C28.1103 29.7925 28.0557 29.7065 28.0057 29.6115C27.9693 29.5165 27.9374 29.4034 27.9374 29.2722C27.9374 29.1591 27.9556 29.046 28.0057 28.9419C28.0512 28.8378 28.1103 28.7519 28.1968 28.675C28.2832 28.5981 28.3879 28.5438 28.5107 28.494C28.6335 28.4488 28.7791 28.4261 28.9293 28.4261C29.1022 28.4261 29.2523 28.4442 29.3751 28.4849C29.498 28.5257 29.6026 28.5619 29.68 28.5981L29.6709 29.0324C29.5662 28.9645 29.4616 28.9193 29.3297 28.8831C29.2068 28.8469 29.0703 28.8152 28.9384 28.8152C28.861 28.8152 28.7882 28.8243 28.72 28.8424C28.6517 28.8605 28.5971 28.8786 28.538 28.9193C28.4925 28.9555 28.4425 28.9962 28.4152 29.0505C28.3879 29.0957 28.3697 29.1636 28.3697 29.2405C28.3697 29.3265 28.3879 29.4034 28.4379 29.4667C28.4743 29.5346 28.5335 29.5979 28.6017 29.6477C28.6699 29.7065 28.7427 29.7608 28.8292 29.8106C28.9156 29.8603 29.0021 29.9146 29.0976 29.9599C29.1932 30.0051 29.2796 30.0639 29.3661 30.1318C29.4525 30.1906 29.5298 30.2539 29.5935 30.3309C29.6982 30.4168 29.7573 30.5028 29.7937 30.5978C29.8301 30.6928 29.862 30.8059 29.862 30.9281C29.862 31.0593 29.8347 31.1859 29.7755 31.29V31.281ZM31.5818 31.946C31.5044 32.1632 31.4316 32.3351 31.3452 32.4663C31.2587 32.5975 31.1723 32.7016 31.0858 32.7694C30.9994 32.8464 30.9039 32.8916 30.8083 32.9097C30.7128 32.9278 30.6172 32.9459 30.5126 32.9459C30.4079 32.9459 30.3215 32.9368 30.2441 32.9187C30.1668 32.9007 30.1031 32.8826 30.0349 32.8509L30.1486 32.5116C30.1941 32.5387 30.2532 32.5568 30.3124 32.5704C30.3715 32.5794 30.4352 32.5885 30.5035 32.5885C30.5717 32.5885 30.6354 32.5704 30.7037 32.5432C30.7719 32.5161 30.8356 32.4663 30.8948 32.403C30.9539 32.3396 31.0085 32.2537 31.0676 32.1451C31.1268 32.041 31.1723 31.9189 31.2087 31.7651L30.1304 29.3989H30.599L31.4089 31.2448H31.4271L32.0458 29.3989H32.4826L31.5772 31.946H31.5818ZM34.3935 31.4257C34.348 31.5117 34.2797 31.5886 34.1933 31.6429C34.1068 31.7017 34.0113 31.7379 33.8976 31.7651C33.7838 31.7922 33.6701 31.8012 33.5336 31.8012C33.4471 31.8012 33.3607 31.7922 33.297 31.7832C33.2197 31.7741 33.156 31.756 33.0968 31.7379C33.0377 31.7198 32.9831 31.7017 32.9239 31.67C32.8784 31.6519 32.8284 31.6248 32.792 31.5931L32.9421 31.2538C32.9785 31.2719 33.0195 31.2991 33.0559 31.3217C33.1014 31.3398 33.1423 31.3579 33.1969 31.3805C33.2561 31.3986 33.3015 31.4076 33.3607 31.4257C33.4198 31.4348 33.4744 31.4438 33.5427 31.4438C33.6109 31.4438 33.6746 31.4348 33.7338 31.4257C33.7929 31.4076 33.8384 31.3895 33.8839 31.3579C33.9203 31.3307 33.9613 31.2991 33.9795 31.2538C33.9977 31.2176 34.0159 31.1678 34.0159 31.1226C34.0159 31.0547 33.9977 31.0005 33.9704 30.9507C33.9431 30.9009 33.9021 30.8647 33.8475 30.8285C33.802 30.7923 33.7429 30.7607 33.6746 30.7335C33.6064 30.7064 33.5427 30.6747 33.4744 30.6476C33.4062 30.6204 33.3425 30.5797 33.2743 30.5435C33.206 30.5073 33.1514 30.4575 33.1014 30.4123C33.0559 30.3535 33.0058 30.2992 32.9785 30.2223C32.9512 30.1454 32.933 30.0594 32.933 29.9553C32.933 29.8694 32.9512 29.7834 32.9785 29.6975C33.0149 29.6205 33.065 29.5482 33.1287 29.4893C33.1924 29.4305 33.2788 29.3853 33.388 29.3491C33.4926 29.3129 33.6064 29.3038 33.752 29.3038C33.8839 29.3038 33.9977 29.3129 34.1023 29.34C34.2069 29.3581 34.2934 29.3989 34.3798 29.426V29.806C34.3343 29.7879 34.2843 29.7698 34.2479 29.7472C34.2024 29.7291 34.1523 29.7201 34.1068 29.702C34.0614 29.6929 34.0022 29.6748 33.9567 29.6748C33.8976 29.6658 33.843 29.6658 33.7838 29.6658C33.7247 29.6658 33.6701 29.6748 33.62 29.6839C33.57 29.6929 33.5245 29.711 33.4881 29.7291C33.4517 29.7472 33.4198 29.7744 33.4016 29.8151C33.3834 29.8558 33.3743 29.892 33.3743 29.9372C33.3743 29.9961 33.3925 30.0504 33.4198 30.0865C33.4471 30.1227 33.4972 30.1635 33.5427 30.1997C33.5882 30.2358 33.6473 30.2675 33.7156 30.2947C33.7838 30.3218 33.8475 30.3535 33.9158 30.3897C33.984 30.4168 34.0477 30.4575 34.116 30.4937C34.1842 30.5299 34.2388 30.5797 34.2888 30.634C34.3571 30.7109 34.3935 30.7652 34.4208 30.8421C34.4481 30.919 34.4663 31.005 34.4663 31.1C34.4663 31.2221 34.439 31.3352 34.3889 31.4212L34.3935 31.4257ZM36.1542 31.747C36.0314 31.7922 35.9176 31.8148 35.813 31.8148C35.7174 31.8148 35.6401 31.8058 35.5764 31.7786C35.5127 31.7515 35.4536 31.7198 35.4126 31.6746C35.3671 31.6293 35.3353 31.5705 35.3171 31.5117C35.2989 31.4438 35.2898 31.3805 35.2898 31.3036V29.7698H34.8985V29.3989H35.2898V28.8695L35.7356 28.7293V29.4034H36.459L36.318 29.7653H35.7356V31.1588C35.7356 31.2538 35.7538 31.3307 35.7948 31.376C35.8357 31.4212 35.8903 31.4438 35.9677 31.4438C36.0041 31.4438 36.045 31.4348 36.0814 31.4257C36.1178 31.4167 36.1588 31.4076 36.1952 31.3895C36.2316 31.3714 36.2634 31.3624 36.2907 31.3443C36.3089 31.3171 36.3362 31.3081 36.359 31.2855L36.4909 31.5886C36.3863 31.6655 36.2816 31.7198 36.1588 31.7605L36.1542 31.747ZM38.9068 30.6566H37.3917C37.3917 30.7697 37.4008 30.8647 37.4372 30.9597C37.4645 31.0547 37.5146 31.1407 37.5783 31.204C37.6374 31.281 37.7102 31.3352 37.8058 31.376C37.9013 31.4167 38.006 31.4348 38.1197 31.4348C38.2243 31.4348 38.329 31.4167 38.4245 31.376C38.5292 31.3398 38.6156 31.2991 38.7021 31.2538L38.8249 31.5569C38.7112 31.6429 38.5974 31.6972 38.4518 31.7379C38.3199 31.7741 38.1743 31.7967 38.0424 31.7967C37.8422 31.7967 37.6784 31.7605 37.5373 31.6927C37.3963 31.6248 37.278 31.5298 37.187 31.4167C37.096 31.3036 37.0232 31.1724 36.9777 31.0185C36.9322 30.8692 36.9095 30.7154 36.9095 30.5435C36.9095 30.3716 36.9277 30.2223 36.9777 30.0684C37.0232 29.9282 37.0915 29.7925 37.1779 29.6884C37.2644 29.5844 37.369 29.4984 37.4918 29.4305C37.6147 29.3627 37.7512 29.3355 37.9013 29.3355C38.0515 29.3355 38.197 29.3627 38.3108 29.4215C38.4245 29.4803 38.5292 29.5617 38.6156 29.6658C38.693 29.7698 38.7567 29.901 38.834 30.0368C38.8795 30.1861 38.9022 30.358 38.9022 30.539V30.6521L38.9068 30.6566ZM42.9651 31.7651H42.5193V30.2404C42.5193 30.1635 42.5102 30.1001 42.5011 30.0323C42.492 29.9644 42.4738 29.9191 42.4419 29.8694C42.4146 29.8241 42.3737 29.7834 42.3282 29.7563C42.2827 29.7291 42.2235 29.7201 42.1371 29.7201C42.0597 29.7201 41.996 29.7291 41.9369 29.7472C41.8687 29.7653 41.8141 29.7925 41.7549 29.8241C41.6958 29.8513 41.6412 29.892 41.5911 29.9282L41.4501 30.0413C41.4501 30.0413 41.4592 30.0775 41.4592 30.1001V31.7651H41.0133V30.2494C41.0133 30.1725 41.0042 30.1092 40.9951 30.0413C40.986 29.9734 40.9678 29.9191 40.936 29.8694C40.9041 29.8196 40.8677 29.7834 40.8222 29.7563C40.7767 29.7291 40.7085 29.7201 40.6311 29.7201C40.5538 29.7201 40.4901 29.7291 40.431 29.7472C40.3627 29.7653 40.3081 29.7925 40.249 29.8241C40.1898 29.8558 40.1352 29.892 40.0852 29.9282L39.9441 30.0413V31.747H39.4983V29.3808H39.8713L39.9305 29.6567C40.0806 29.5436 40.2262 29.4577 40.3582 29.3989C40.4901 29.34 40.6357 29.3129 40.7585 29.3129C40.8996 29.3129 41.027 29.3491 41.1316 29.4169C41.2362 29.4848 41.3136 29.5798 41.35 29.6929C41.4182 29.6341 41.4819 29.5798 41.5593 29.5301C41.6366 29.4803 41.7003 29.4441 41.7777 29.4079C41.855 29.3808 41.9187 29.3491 41.9961 29.331C42.0734 29.3129 42.1371 29.3038 42.2053 29.3038C42.3009 29.3038 42.3964 29.3129 42.4829 29.34C42.5693 29.3672 42.6467 29.4079 42.7195 29.4622C42.815 29.5572 42.8696 29.6432 42.9105 29.7382C42.9469 29.8332 42.9697 29.9553 42.9697 30.1092V31.7651H42.9651ZM45.1081 31.4303C45.0626 31.5117 44.9943 31.5886 44.9079 31.6429C44.8214 31.6972 44.7259 31.7379 44.6121 31.7651C44.4984 31.7922 44.3847 31.8012 44.2482 31.8012C44.1617 31.8012 44.0753 31.7922 44.0116 31.7832C43.9342 31.7741 43.8705 31.756 43.8114 31.7379C43.7522 31.7198 43.6976 31.7017 43.6385 31.6746C43.593 31.6565 43.543 31.6293 43.5066 31.6022L43.6567 31.2674C43.6931 31.2855 43.734 31.3126 43.7704 31.3307C43.8159 31.3488 43.8569 31.3669 43.9115 31.385C43.9706 31.4031 44.0161 31.4122 44.0753 31.4303C44.1344 31.4393 44.189 31.4484 44.2573 31.4484C44.3255 31.4484 44.3892 31.4393 44.4483 31.4303C44.5075 31.4122 44.553 31.3941 44.5985 31.3669C44.6349 31.3398 44.6758 31.3126 44.694 31.2629C44.7122 31.2267 44.7304 31.1814 44.7304 31.1317C44.7304 31.0683 44.7122 31.0095 44.6849 30.9643C44.6576 30.919 44.6167 30.8828 44.5621 30.8421C44.5166 30.8059 44.4574 30.7788 44.3892 30.7471C44.321 30.7199 44.2573 30.6928 44.189 30.6657C44.1208 30.6385 44.0571 30.6023 43.9888 30.5616C43.9206 30.5254 43.866 30.4802 43.8159 30.4304C43.7704 30.3761 43.7204 30.3173 43.6931 30.2449C43.6658 30.1725 43.6476 30.0865 43.6476 29.9825C43.6476 29.901 43.6658 29.8151 43.6931 29.7337C43.7295 29.6613 43.7795 29.5843 43.8432 29.5301C43.9069 29.4758 43.9934 29.426 44.1026 29.3898C44.2072 29.3536 44.321 29.3446 44.4665 29.3446C44.5985 29.3446 44.7122 29.3536 44.8169 29.3808C44.9215 29.3989 45.008 29.435 45.0944 29.4622V29.8332C45.0489 29.8151 44.9989 29.797 44.9625 29.7789C44.917 29.7608 44.8669 29.7517 44.8214 29.7337C44.7759 29.7156 44.7168 29.7065 44.6713 29.7065C44.6121 29.6975 44.5575 29.6975 44.4984 29.6975C44.4392 29.6975 44.3847 29.7065 44.3346 29.7156C44.2891 29.7246 44.2391 29.7427 44.2027 29.7608C44.1663 29.7789 44.1344 29.806 44.1162 29.8422C44.098 29.8784 44.0889 29.9146 44.0889 29.9644C44.0889 30.0187 44.1071 30.0775 44.1344 30.1137C44.1617 30.1499 44.2118 30.1861 44.2573 30.2268C44.3028 30.2675 44.3619 30.2901 44.4301 30.3218C44.4984 30.349 44.5621 30.3761 44.6303 30.4168C44.6986 30.444 44.7623 30.4802 44.8305 30.5209C44.8988 30.5616 44.9534 30.6023 45.0034 30.6611C45.0489 30.7154 45.099 30.7742 45.1263 30.8466C45.1627 30.9281 45.1854 31.014 45.1854 31.1181C45.1854 31.2402 45.1581 31.3488 45.1081 31.4348V31.4303Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M20.6989 30.6386L20.2712 30.6567C20.0801 30.6657 19.9391 30.7019 19.8526 30.7698C19.7662 30.8376 19.7207 30.9191 19.7207 31.0457C19.7207 31.1046 19.7298 31.1589 19.748 31.2086C19.7662 31.2539 19.7935 31.2946 19.8344 31.3308C19.8754 31.367 19.9118 31.3986 19.9664 31.4167C20.0255 31.4348 20.0892 31.4439 20.1575 31.4439C20.2348 31.4439 20.2894 31.4439 20.3486 31.4258C20.4077 31.4077 20.4532 31.3896 20.4987 31.367C20.5442 31.3443 20.5851 31.3217 20.6215 31.2901C20.6488 31.2629 20.6807 31.2448 20.708 31.2131H20.6989V30.634V30.6386Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M13.4011 29.2857C13.3829 29.2178 13.3647 29.1636 13.3556 29.1047H13.3465C13.3283 29.1726 13.3101 29.2269 13.2874 29.2948C13.2646 29.3626 13.2419 29.435 13.21 29.5119L12.8506 30.5073H13.8197L13.4784 29.5119C13.4511 29.426 13.4193 29.349 13.4011 29.2857Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M25.2891 29.9373C25.23 29.8604 25.1663 29.7971 25.0798 29.7563C24.9934 29.7111 24.8979 29.6885 24.7932 29.6885C24.6886 29.6885 24.6021 29.7156 24.5157 29.7563C24.4383 29.8016 24.3746 29.8604 24.3155 29.9373C24.2563 30.0142 24.2199 30.1092 24.1926 30.2133C24.1653 30.3174 24.1562 30.4305 24.1562 30.5617C24.1562 30.6929 24.1744 30.8195 24.2017 30.9236C24.229 31.0277 24.2791 31.1227 24.3337 31.1996C24.3928 31.2765 24.4565 31.3398 24.543 31.3806C24.6203 31.4258 24.7159 31.4484 24.8205 31.4484C24.9252 31.4484 25.0207 31.4213 25.098 31.3806C25.1754 31.3353 25.2391 31.2765 25.2982 31.1996C25.3437 31.1227 25.3938 31.0277 25.4211 30.9236C25.4484 30.8195 25.4666 30.7064 25.4666 30.5752C25.4666 30.444 25.4484 30.3174 25.4211 30.2133C25.3847 30.1092 25.3437 30.0142 25.2891 29.9373Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M49.0617 17.776H49.8989V23.4585H49.2892L46.3183 19.3957V23.4585H45.4811V17.776H46.1863L49.0617 21.7076V17.776ZM42.401 17.7308L44.6394 23.4585H43.6794L43.1835 22.1058H40.9633L40.4673 23.4585H39.5438L41.8095 17.7308H42.401ZM42.906 21.3774L42.0688 19.0835L41.2317 21.3774H42.906ZM37.4008 17.776L35.7447 21.3457L34.0295 17.776H33.256L32.6555 23.4585H33.5609L33.9249 19.4636L35.5446 22.8342H35.8949L37.4964 19.3776L37.8786 23.4676H38.7657L38.1652 17.7851H37.4054V17.776H37.4008ZM29.0612 19.0926C29.0612 18.6175 29.4525 18.3551 30.0804 18.3551C30.6036 18.3551 31.1177 18.613 31.327 18.7442L31.6318 18.0611C31.4589 17.9479 30.822 17.6177 30.0622 17.6177C28.902 17.6177 28.1558 18.2239 28.1558 19.1605C28.1558 21.1602 30.9948 20.4001 30.9948 21.8524C30.9948 22.4406 30.4898 22.7256 29.7482 22.7256H28.6836L28.3424 23.4721H29.771C31.1313 23.4721 31.9048 22.7618 31.9048 21.7936C31.923 19.6536 29.0658 20.3142 29.0658 19.0926H29.0612ZM25.7354 17.776H24.8573V23.4585H27.6554L27.9966 22.712H25.7308V17.776H25.7354ZM21.3358 20.8435H23.3559V20.106H21.3358V18.5044H23.6789V17.767H20.4714V23.4495H23.7654V22.712H21.3358V20.848V20.8435ZM15.403 18.5135H17.0045V23.4585H17.8826V18.5135H19.4841V17.767H15.4075V18.5135H15.403ZM14.5931 19.4636C14.5931 18.5813 14.0699 17.776 12.7914 17.776H10.9989V23.4585H11.8542V18.4501H12.5776C13.2828 18.4501 13.6923 18.8845 13.6923 19.4455C13.6923 20.3051 13.0735 20.6082 12.2364 20.6082H12.1226L13.9698 23.4585H15.0345L13.4148 21.0426C14.0608 20.8254 14.584 20.3051 14.584 19.4591L14.5931 19.4636ZM7.28629 20.8435H9.31547V20.106H7.29539V18.5044H9.6385V17.767H6.43095V23.4495H9.72494V22.712H7.29539L7.28629 20.848V20.8435ZM5.30717 21.7845C5.30717 22.6758 4.68841 23.4902 3.15516 23.4902H1.32617V17.7489H3.17335C4.51552 17.7489 5.03874 18.4139 5.03874 19.1695C5.03874 19.7577 4.65656 20.1468 4.28803 20.3458C4.74301 20.5177 5.30717 20.8933 5.30717 21.7845ZM4.41998 21.8388C4.41998 21.0607 3.75117 20.7485 2.90492 20.7485H2.63649L2.94132 20.0744C3.38719 20.0744 4.16064 19.9974 4.16064 19.1921C4.16064 18.8121 3.91496 18.4366 3.08236 18.4366H2.16787V22.7935H3.12786C3.87856 22.7844 4.41543 22.4451 4.41543 21.8388H4.41998ZM54.9536 17.776V21.7076L52.0782 17.776H51.373V23.4585H52.2101V19.3957L55.1811 23.4585H55.7908V17.776H54.9536Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M43.0972 3.15343H45.5177V5.27532H43.0972V9.92628C43.0972 10.8945 43.4612 11.3288 44.3939 11.3288H45.2037V13.4416H43.3474C41.3274 13.4416 40.4811 12.288 40.4811 10.7135V5.27532H38.9479V3.15343H40.4811V0.787226L43.1018 0V3.15343H43.0972ZM37.3054 10.7226C37.3054 12.202 37.3509 12.9576 37.5056 13.4416H35.0761L34.8577 12.5323C34.1798 13.1385 33.238 13.6588 31.8685 13.6588C29.9622 13.6588 28.479 12.3151 28.479 10.2973C28.479 8.16633 30.1669 6.95383 32.8012 6.86786L34.6666 6.8V6.57379C34.6666 5.33413 33.7612 5.031 32.6647 5.031C31.732 5.031 29.7484 5.12601 29.7484 5.12601V3.167C29.7484 3.167 31.5955 3.07199 33.1879 3.07199C35.7403 3.07199 37.2918 4.04019 37.2918 6.73666V10.7226H37.3009H37.3054ZM34.6711 8.60067L33.1561 8.64591C31.7366 8.6821 31.0996 9.23407 31.0996 10.0937C31.0996 10.9533 31.6911 11.5912 32.7876 11.5912C33.7021 11.5912 34.3299 11.2428 34.6711 10.9397V8.60067ZM23.0011 9.83127L20.5898 3.15343H17.6871L21.8956 13.4281H23.8883L28.1833 3.15343H25.4898L23.0057 9.83127H23.0011ZM13.5332 3.15343H11.2947V13.4281H13.9518V6.26613C14.5614 5.69607 15.2939 5.59202 15.9127 5.59202C16.122 5.59202 16.3813 5.61916 16.6543 5.70512V3.13985C15.6715 3.13985 14.8526 3.28011 13.8244 4.23021L13.5286 3.1489L13.5332 3.15343ZM9.06082 10.7226C9.06082 12.202 9.10631 12.9576 9.261 13.4416H6.83146L6.61307 12.5323C5.93516 13.1385 4.99337 13.6588 3.62391 13.6588C1.71758 13.6588 0.234375 12.3151 0.234375 10.2973C0.234375 8.16633 1.92232 6.95383 4.5566 6.86786L6.42198 6.8V6.57379C6.42198 5.33413 5.51659 5.031 4.42011 5.031C3.48742 5.031 1.50374 5.12601 1.50374 5.12601V3.167C1.50374 3.167 3.35093 3.07199 4.94333 3.07199C7.49571 3.07199 9.04717 4.04019 9.04717 6.73666V10.7226H9.05627H9.06082ZM6.42198 8.60067L4.90693 8.64591C3.48742 8.6821 2.85046 9.23407 2.85046 10.0937C2.85046 10.9533 3.44192 11.5912 4.5384 11.5912C5.45289 11.5912 6.08075 11.2428 6.42198 10.9397V8.60067ZM56.8965 8.27944C56.8965 11.3876 54.8855 13.7629 51.6962 13.7629C48.5068 13.7629 46.5322 11.3967 46.5322 8.3654C46.5322 4.85003 48.9026 2.8322 51.7144 2.8322C54.5261 2.8322 56.8965 4.78217 56.8965 8.27944ZM54.2031 8.29754C54.2031 6.3159 53.2886 4.88623 51.6689 4.88623C50.0492 4.88623 49.2029 6.38377 49.2029 8.29754C49.2029 10.2113 50.1447 11.745 51.7371 11.745C53.3295 11.745 54.2031 10.2294 54.2031 8.29754Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                    id: "clip0_7035_3621",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "56.6667",
                        height: "34",
                        fill: "white",
                        transform: "translate(0.229492)"
                    })
                })
            })
        ]
    });
};
const $31e5b10935f9b9be$var$testimonialDropboxStyle = null;
const $31e5b10935f9b9be$export$3944c61ebd3bc79e = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-dropbox-2272682323.webp",
            alt: ""
        },
        className: (0, $esG4f.default)([
            "_1bsbs0l4 _4t3izwfg"
        ])
    });
};
const $31e5b10935f9b9be$var$testimonialRobloxStyle = null;
const $31e5b10935f9b9be$export$d76e3d65f440a2bb = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-roblox-1428046955.webp",
            alt: ""
        },
        className: (0, $esG4f.default)([
            "_1bsb1j4a _4t3i1tcg"
        ])
    });
};
const $31e5b10935f9b9be$var$testimonialLumenStyle = null;
const $31e5b10935f9b9be$export$2d5c2c6aa86b2349 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-lumen-3277500912.webp",
            alt: ""
        },
        className: (0, $esG4f.default)([
            "_1bsb1j4a _4t3if6fq"
        ])
    });
}; // ask for new svg for Toast
const $31e5b10935f9b9be$export$5ea2342df8447e77 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "89",
        height: "23",
        viewBox: "0 0 89 23",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M31.9993 21.1745C29.5465 21.1745 28.2194 19.926 28.2194 17.5961V10.7638H27.3641C26.9562 10.7589 26.5629 10.5918 26.2779 10.3018C25.9928 10.0118 25.8355 9.62348 25.8453 9.22042C25.865 8.40939 26.5384 7.76057 27.3641 7.75566H28.2194V5.72071C28.2931 4.81629 29.0599 4.1134 29.984 4.1134C30.9081 4.1134 31.6798 4.81138 31.7486 5.72071V7.75566H33.1249C33.5179 7.76704 33.8913 7.92991 34.1671 8.21022C34.4428 8.49053 34.5995 8.86658 34.6044 9.25974C34.5995 9.65291 34.4428 10.029 34.1671 10.3093C33.8913 10.5896 33.5179 10.7524 33.1249 10.7638H31.7486V16.672C31.7486 17.7043 32.4122 18.1073 32.9627 18.1073H33.2674C34.2603 18.1073 34.8158 18.7561 34.8158 19.6016C34.8158 20.447 34.2898 21.1745 31.9993 21.1745Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M43.035 21.1744C38.6505 21.1744 36.0012 18.0286 36.0012 14.2881C36.0012 10.577 38.6555 7.43119 43.035 7.43119C47.449 7.43119 50.0983 10.577 50.0983 14.2881C50.1278 15.2155 49.9639 16.1389 49.617 16.9996C49.2701 17.8602 48.7478 18.6392 48.0834 19.287C47.419 19.9347 46.627 20.4371 45.7579 20.762C44.8887 21.087 43.9614 21.2274 43.035 21.1744ZM43.035 10.4934C40.8526 10.4934 39.6434 12.2531 39.6434 14.2881C39.6434 16.323 40.8575 18.1171 43.035 18.1171C45.2125 18.1171 46.4561 16.3574 46.4561 14.2881C46.4561 12.2531 45.2125 10.4934 43.035 10.4934ZM62.48 21.0122H62.2048C61.9295 21.0122 60.6859 20.7959 60.6859 19.4934C59.7766 20.5502 58.2086 21.1744 56.4686 21.1744C54.3452 21.1744 51.8334 19.7637 51.8334 16.8342C51.8334 13.7719 54.3452 12.607 56.4686 12.607C58.2381 12.607 59.8061 13.1772 60.6859 14.2045V12.4399C60.6859 11.1128 59.5259 10.2427 57.7613 10.2427C56.707 10.2208 55.67 10.5134 54.7826 11.0833C54.5909 11.1997 54.3727 11.2657 54.1486 11.275C53.4113 11.2651 52.8214 10.6704 52.8214 9.94783C52.8253 9.70892 52.8914 9.47515 53.0131 9.26951C53.8389 7.96695 56.8176 7.42627 58.361 7.42627C61.3937 7.42627 64.1807 8.62069 64.1807 12.3858V19.3017C64.1856 20.2356 63.4238 21.0024 62.4702 21.0073L62.48 21.0122ZM60.6859 16.0772C60.1059 15.3203 59.0049 14.9369 57.8744 14.9369C56.4932 14.9369 55.3626 15.6349 55.3626 16.9178C55.3626 18.1368 56.4932 18.8446 57.8744 18.8446C59.0049 18.8446 60.1059 18.4661 60.6859 17.7042V16.0772Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M72.4687 21.1745C70.7336 21.1745 67.9466 20.6043 67.1209 19.4345C66.9587 19.2231 66.8702 18.9675 66.8751 18.7021C66.8853 18.3204 67.0431 17.9575 67.3154 17.6898C67.5876 17.4221 67.9531 17.2705 68.335 17.2668C68.5905 17.2668 68.8363 17.3356 69.0526 17.4683C70.0996 18.0631 71.4808 18.5251 72.6359 18.5251C74.1547 18.5251 74.8723 17.9304 74.8723 17.1144C74.8723 14.9468 66.9537 16.7065 66.9537 11.5552C66.9537 9.35805 68.915 7.43616 72.4147 7.43616C74.1498 7.43616 76.5239 7.98176 77.271 9.03364C77.414 9.22724 77.4915 9.46143 77.4922 9.70213C77.4676 10.4296 76.8581 11.0096 76.1159 11.0047C75.8848 11.0052 75.6571 10.9495 75.4523 10.8425C74.5313 10.328 73.4942 10.0573 72.4392 10.056C71.1711 10.056 70.3453 10.6262 70.3453 11.3586C70.3453 13.31 78.2344 11.683 78.2344 16.967C78.2344 19.3558 76.1651 21.1745 72.4687 21.1745ZM85.2928 21.1745C82.8401 21.1745 81.5129 19.926 81.5129 17.5961V10.7638H80.6577C80.2497 10.7589 79.8565 10.5918 79.5714 10.3018C79.2863 10.0118 79.129 9.62348 79.1388 9.22042C79.1585 8.4094 79.8319 7.76057 80.6577 7.75566H81.5129V5.72071C81.5534 5.28091 81.7569 4.87215 82.0834 4.57474C82.4099 4.27733 82.8359 4.11277 83.2775 4.11341C84.2016 4.11341 84.9733 4.81138 85.0421 5.72071V7.75566H86.4233C86.8164 7.76704 87.1898 7.92992 87.4655 8.21023C87.7412 8.49054 87.8979 8.86658 87.9028 9.25975C87.8979 9.65291 87.7412 10.029 87.4655 10.3093C87.1898 10.5896 86.8164 10.7524 86.4233 10.7638H85.0421V16.672C85.0421 17.7043 85.7057 18.1073 86.2562 18.1073H86.561C87.5539 18.1073 88.1044 18.7561 88.1044 19.6016C88.1044 20.447 87.5883 21.1745 85.2928 21.1745Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M23.5989 15.7873C23.6186 14.3373 23.5547 12.8872 23.4072 11.4471C23.2991 10.4738 22.9698 9.22533 21.913 8.96974C22.0492 9.00427 22.1924 8.99915 22.3259 8.95499C23.5498 8.316 23.4564 6.73818 23.0238 5.59783C22.4537 4.10357 21.1019 3.04186 19.7601 2.33897C17.2714 1.09804 14.5118 0.499666 11.7327 0.598398C8.95364 0.69713 6.24345 1.48982 3.84917 2.90423C2.63509 3.65136 1.23914 5.11121 1.85355 6.73818C2.02012 7.14309 2.26576 7.51071 2.5761 7.81955L3.03814 8.30125C2.4139 9.14669 1.95677 9.91348 1.66185 10.9408C0.777095 14.0374 0.924555 16.0281 1.16541 18.5153C1.31778 20.0538 1.82406 22.3443 3.59849 22.5999C5.04359 22.8015 6.61158 22.3247 8.05668 22.1526C9.64925 21.9658 11.2566 21.6709 12.8688 21.7152C15.1397 21.7741 17.3909 22.3099 19.6667 22.3345C20.866 22.3443 22.8616 22.4623 23.2204 20.8796C23.5596 19.3755 23.5744 17.8124 23.5744 16.2788C23.594 16.1166 23.594 15.9495 23.594 15.7922L23.5989 15.7873ZM21.0036 18.3875C20.4384 19.6606 18.8409 19.518 17.7251 19.4246L12.7361 18.8299C11.2516 18.7856 9.78196 19.0658 8.33686 19.3853C7.25549 19.6212 5.74648 20.2455 4.76834 19.4148C3.68205 18.4956 3.49035 16.9276 3.47561 15.6054C3.49602 14.4115 3.61438 13.2213 3.82951 12.0467C3.96222 11.3193 4.1785 10.6115 4.46359 9.93314C4.8519 8.95008 5.42699 8.35532 5.45648 8.38481C5.16648 8.08498 4.81749 7.92277 4.62088 7.5148C3.87866 5.96648 5.73174 4.65409 6.74429 4.20679C10.2882 2.62406 15.2429 2.78135 18.5902 4.81138C19.6323 5.44545 21.6574 7.62294 19.765 8.70922C20.9299 9.25974 21.2297 10.9211 21.3575 12.1008C21.562 13.9955 21.5024 15.9095 21.1806 17.7878C21.1458 17.9947 21.0896 18.1962 21.0036 18.3875Z",
                fill: "#101214"
            })
        ]
    });
}; // ask for new svg Splunk
const $31e5b10935f9b9be$export$13c02cb17fc407de = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "103",
        height: "29",
        viewBox: "0 0 103 29",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M29.4863 0.270996L29.6308 22.1619H32.9144V0.270996H29.4863ZM70.1289 0.270996V22.1706H74.0802C74.0802 22.1706 74.113 14.268 74.1568 14.2768C74.2006 14.2768 80.0476 22.4705 80.1002 22.4421C80.1593 22.4267 83.6049 21.1877 83.6049 21.1527C83.6049 21.1264 77.7316 13.62 77.7316 13.6113C77.7316 13.5938 82.657 8.11231 82.6132 8.06852C82.4775 7.94156 79.809 6.78791 79.7324 6.8295C79.6974 6.85577 74.0802 12.9524 74.0802 12.9524V0.270996H70.1289ZM4.6708 6.94771C3.25009 7.24761 1.91693 8.15609 1.36966 9.20685C1.1214 9.71444 0.993808 10.2725 0.996846 10.8376C0.999884 11.4026 1.13347 11.9593 1.38717 12.4642C1.73743 13.1406 2.75535 14.0819 4.33587 15.1918C6.04774 16.4068 6.69571 17.0131 6.85989 17.5867C7.10726 18.4338 6.73073 19.2285 5.90983 19.6225C5.50047 19.8195 5.31877 19.8436 4.592 19.8108C3.64412 19.767 2.99396 19.5262 2.02858 18.8344C1.71992 18.6221 1.43752 18.4667 1.4025 18.5017C1.36966 18.5367 1.061 18.9986 0.719503 19.5284L0.10437 20.4763L0.334224 20.6558C0.472137 20.7499 0.881496 20.9995 1.25802 21.2118C3.85865 22.6566 7.70488 22.4267 9.65535 20.7083C10.1652 20.2713 10.5541 19.7106 10.7849 19.08C11.0156 18.4494 11.0805 17.7701 10.9732 17.1073C10.7849 15.8332 10.0822 14.997 7.87563 13.3968C6.14187 12.1402 5.32096 11.4485 5.1327 11.0807C4.76494 10.3605 5.02106 9.66874 5.79818 9.26595C6.19222 9.06237 6.35421 9.04486 7.13353 9.07769C7.89314 9.10396 8.12518 9.16525 8.75783 9.46297L9.49336 9.82198L10.0647 8.92445C10.3821 8.42972 10.612 7.9919 10.5879 7.95031C10.485 7.79707 9.27883 7.2914 8.52579 7.09657C7.52537 6.8295 5.59241 6.75288 4.6708 6.9499V6.94771ZM22.0368 8.88286C23.7662 9.69283 24.6878 12.2322 24.3135 15.1239C24.1821 16.1506 23.8166 17.3897 23.4751 17.9632C23.1314 18.5542 22.4659 19.1956 21.9339 19.443C20.9598 19.9027 19.515 19.7254 18.6 19.0315C17.3347 18.0661 16.6407 15.6975 16.9056 13.2348C17.1552 10.9778 17.9673 9.54835 19.3858 8.88943C20.1214 8.54793 21.3122 8.54793 22.0368 8.88286ZM20.4629 6.3676C19.4296 6.59965 18.6087 7.06154 17.7199 7.90653L16.9144 8.67709V6.83826H13.2126V28.7291H16.9144V19.802L17.6258 20.4938C18.9239 21.7678 20.4475 22.2823 22.2251 22.0327C23.3875 21.8707 24.2084 21.573 25.0731 20.9907C27.503 19.3664 28.8449 16.1244 28.4771 12.7378C28.1269 9.52426 26.4763 7.30016 23.8144 6.45517C23.1314 6.23188 21.2663 6.1881 20.4629 6.3676ZM35.6683 6.83826C35.6683 6.83826 35.7887 18.4076 35.8653 18.7425C36.163 20.0166 37.0189 21.2293 37.9778 21.7525C38.8578 22.2297 39.567 22.3764 40.8936 22.3764C42.7828 22.3676 43.9277 21.9145 45.3309 20.6229L46.0489 19.9728V22.1619H49.8623L49.812 6.83826H46.0489C46.0489 6.83826 46.0993 16.3564 46.0489 16.6891C45.8256 18.0245 44.7924 19.119 43.7394 19.4693C43.1155 19.6816 42.021 19.8524 41.3621 19.7495C40.6878 19.64 39.5495 18.8957 39.4817 17.7837V6.88861L35.6683 6.83826ZM67.375 22.1619C67.375 22.1619 67.2546 10.5925 67.178 10.2576C66.8803 8.98356 66.0243 7.77081 65.0655 7.24762C64.1855 6.7704 63.4762 6.62373 62.1496 6.62373C60.2605 6.63248 59.1156 7.08562 57.7124 8.37718L56.9944 9.02734V6.83826H53.181L53.2313 22.1619H56.9944C56.9944 22.1619 56.944 12.6437 56.9944 12.311C57.2176 10.9756 58.2509 9.88109 59.3038 9.53083C59.9277 9.31849 60.7486 9.1565 61.6812 9.25063C62.6115 9.35133 63.6295 10.1985 63.5616 11.2164V22.1115L67.375 22.1619Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M87.6399 5.74365V9.02728L100.774 13.4055L87.6399 19.1015V22.1618L102.963 15.5945V11.2164L87.6399 5.74365Z",
                fill: "#101214"
            })
        ]
    });
}; // ask for new svg for Blend
const $31e5b10935f9b9be$export$9deaa7e38ca0abdf = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "85",
        height: "25",
        viewBox: "0 0 85 25",
        fill: "none",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M45.0486 23.7095H56.5358C58.2522 23.7095 59.6608 23.0052 60.805 21.5961C61.9053 20.2318 62.4776 18.6035 62.4776 16.7555C62.4776 13.0143 57.6804 10.3735 55.831 10.3735H49.5375C49.0534 10.3735 48.6565 10.1533 48.3491 9.8016C48.0408 9.40515 47.8649 8.9653 47.8649 8.43685C47.8649 7.8207 48.0408 7.2927 48.3491 6.85241C48.7012 6.41255 49.1411 6.14856 49.6695 6.14856H61.465V1.43862H49.4489C47.2922 1.43862 45.6191 2.09907 44.4307 3.37521C43.3751 4.56366 42.8462 6.14811 42.8462 8.04086C42.8462 9.8893 43.3751 11.518 44.4307 12.8376C45.6191 14.29 47.0282 15.0391 48.7446 15.0391H56.0073C56.4467 15.0391 56.7993 15.1711 57.0629 15.5223C57.3712 15.8745 57.5032 16.3148 57.5032 16.7994C57.5032 17.3717 57.283 17.8997 56.9309 18.34C56.5349 18.736 56.0946 18.9561 55.5232 18.9561H43.9036L43.7277 18.6478L39.3704 4.65181L39.1502 4.21151C38.0938 2.05477 36.3335 0.998769 33.9128 0.998769C32.5923 0.998769 31.4039 1.30662 30.3474 1.96706C29.2471 2.62706 28.5428 3.59536 28.1468 4.82811L22.2927 23.6652L27.6184 23.7099L32.9879 6.941C33.1199 6.41256 33.4282 6.14856 33.8242 6.14856C34.0443 6.14856 34.2202 6.23626 34.3522 6.36871C34.4842 6.54456 34.5723 6.72086 34.6162 6.941L40.0295 23.7099L45.0486 23.7095ZM5.43611 8.30485V23.6652H0.50647V6.63226C0.50647 4.43166 1.03492 2.89106 2.17907 1.96706C3.05922 1.30662 4.37966 0.954468 6.22811 0.954468C7.72441 0.954468 9.001 1.39477 10.1452 2.23107C11.2893 3.06736 12.0375 4.21151 12.4339 5.62011L15.6466 16.9314L16.1751 18.472C16.2189 18.7798 16.3952 19 16.5711 19.1754C16.7912 19.3521 17.0109 19.4403 17.2754 19.3521C17.7157 19.3083 17.9358 19.0438 17.9358 18.6478V1.48292H22.9975V18.4277C22.9975 20.3204 22.5576 21.7295 21.6332 22.7416C20.753 23.7538 19.4326 24.2822 17.6718 24.2822C16.1312 24.2822 14.8546 23.9739 13.8425 23.4459C12.6102 22.8298 11.8177 21.8615 11.4656 20.5844L7.76871 7.68871L7.50471 6.85241C7.41656 6.54455 7.24071 6.32441 7.02056 6.10426C6.80041 5.92796 6.53641 5.88411 6.27241 5.92796C6.00841 5.97226 5.83256 6.10426 5.65626 6.36826C5.51155 6.60704 5.43538 6.88105 5.43611 7.16026V8.30485ZM84.2204 23.7095L78.4988 4.65181L78.2786 4.21151C77.2222 2.05477 75.4619 0.998769 73.0411 0.998769C71.7207 0.998769 70.5322 1.30662 69.4762 1.96706C68.375 2.62706 67.6716 3.59536 67.2747 4.82811L61.4211 23.6652L66.7467 23.7099L72.1162 6.941C72.2482 6.41256 72.5565 6.14856 72.9525 6.14856C73.1727 6.14856 73.3485 6.23626 73.4805 6.36871C73.6134 6.54456 73.7007 6.72086 73.7454 6.941L79.1588 23.7099L84.2204 23.7095Z",
            fill: "#101214"
        })
    });
};
const $31e5b10935f9b9be$var$testimonialDoodleStyle = null;
const $31e5b10935f9b9be$export$72c6ec790fc33a37 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-doodle-1380981062.webp",
            alt: ""
        },
        className: (0, $esG4f.default)([
            "_1bsb1qr7 _4t3i1tcg"
        ])
    });
};
const $31e5b10935f9b9be$var$testimonialRoyalCaribbeanStyle = null;
const $31e5b10935f9b9be$export$ea2a07b098c3c428 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-royal-caribbean-3438806072.webp",
            alt: ""
        },
        className: (0, $esG4f.default)([
            "_1bsbhcro _4t3i1u1b"
        ])
    });
};
const $31e5b10935f9b9be$var$testimonialMercedesBenzStyle = null;
const $31e5b10935f9b9be$export$3192ac60f265126c = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-mercedes-benz-2937659039.webp",
            alt: ""
        },
        className: (0, $esG4f.default)([
            "_1bsbwz92 _4t3i1u1b"
        ])
    });
};
const $31e5b10935f9b9be$var$testimonialSunLifeStyle = null;
const $31e5b10935f9b9be$export$53d258996873a1e3 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonials-sun-life-resize-2840009056.webp",
            alt: ""
        },
        className: (0, $esG4f.default)([
            "_1bsb18cf _4t3i1u1b"
        ])
    });
const $31e5b10935f9b9be$var$testimonialUnitedStyle = null;
const $31e5b10935f9b9be$export$6a1b58616eb8f4e3 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonials-united-resize-2634290916.webp",
            alt: ""
        },
        className: (0, $esG4f.default)([
            "_1bsb1qr7 _4t3i1u1b"
        ])
    });

});


parcelRegister("gZeiy", function(module, exports) {
/* cta-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $3FBn4 = parcelRequire("3FBn4");

var $jPLZK = parcelRequire("jPLZK");
const $dcb04a690a315ad9$export$5faac140015d325f = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jPLZK.Adg4CtaWithArrows), {
        header: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "CustomersLandingPage.cta.header",
            defaultMessage: "<startWriting>Start writing your <teamWorkStory>teamwork story</teamWorkStory> <gestureLines>today</gestureLines></startWriting>",
            values: {
                startWriting: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: "h1 reduced-font-weight",
                        children: str
                    }),
                teamWorkStory: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: "h1",
                        children: str
                    }),
                gestureLines: (str)=>/*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                        children: [
                            str,
                            /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/yellow-gestural-lines-2995366884.webp",
                                alt: "",
                                className: (0, $esG4f.default)([
                                    "_kqswstnw _1bsb4bvh _4t3i4bvh _1pfh14id _ahbq14id _1hr21qjk _15951a70 _12rrd4y9 _1vkh14no _1rfmd4y9 _tnru14no"
                                ])
                            })
                        ]
                    })
            }
        }),
        ctaProps: {
            ctaText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "CustomersLandingPage.cta.buttonText",
                defaultMessage: "Become an advocate"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/advocacy"),
            dataEventProps: {
                "data-event": "clicked",
                "data-event-component": "linkButton",
                "data-event-container": "ctaSection",
                "data-product-key": "customers"
            }
        }
    });
};
const $dcb04a690a315ad9$var$customerStoryCTAGestureStyle = null;

});
parcelRegister("jPLZK", function(module, exports) {

$parcel$export(module.exports, "Adg4CtaWithArrows", function () { return $5b552751fb8b2244$export$23afe6443f3f8d50; });
/* cta-with-arrows.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $eDoPe = parcelRequire("eDoPe");

var $91nJf = parcelRequire("91nJf");

var $4XrxY = parcelRequire("4XrxY");
const $5b552751fb8b2244$var$ArrowPencilPointRight = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        className: props.className,
        style: {
            color: props.color ? props.color : "currentColor",
            transform: `rotate(${props.rotate ? props.rotate : "0"}deg)`
        },
        width: "72",
        height: "25",
        viewBox: "0 0 72 25",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M59.9377 15.3992C59.0173 14.9197 58.1224 14.8026 57.2375 14.6506C56.2764 14.4847 55.3298 14.5122 54.3661 14.6939C53.5179 14.8575 52.6572 14.756 51.8548 14.5047C50.3545 14.0308 48.8161 13.9548 47.2581 13.9487C46.2852 13.9435 45.2992 13.8949 44.3421 13.7474C43.6788 13.6425 43.0503 13.3313 42.3766 13.1053C41.985 13.7302 41.3847 13.7038 40.7654 13.4715C39.4868 12.9907 38.1709 12.9018 36.8181 12.9291C36.0821 12.9425 35.3546 12.7709 34.7504 12.2942C34.6729 12.2382 34.5745 12.21 34.4827 12.1765C33.8726 12.7787 33.1602 12.7406 32.4202 12.5737C31.2308 12.3121 30.0329 12.0735 28.8435 11.8119C28.0392 11.6324 27.2369 11.435 26.434 11.2435C25.6375 11.0468 24.8746 10.7635 24.004 10.9669C22.9249 11.2205 21.8431 10.958 20.7692 10.7864C19.5431 10.5869 18.3301 10.2689 17.1034 10.1833C15.0061 10.0312 12.9448 9.66091 10.8685 9.37304C9.87464 9.2337 8.87682 9.12994 7.89344 8.94972C6.89235 8.76766 5.89651 8.53817 4.91509 8.28619C3.86938 8.02152 2.82958 7.7035 1.79371 7.40388C1.12194 7.21408 0.740116 6.67063 0.443572 6.11206C0.359595 5.95341 0.591152 5.53371 0.780077 5.33746C1.3744 4.71561 2.13013 4.41639 2.99148 4.35003C4.92541 4.19732 6.85018 4.28953 8.7651 4.47067C10.4852 4.63154 12.1902 4.92878 13.8886 5.23134C15.8515 5.57338 17.8274 5.79684 19.8165 5.95571C21.368 6.07507 22.9135 6.30175 24.4618 6.45076C25.9089 6.59525 27.3614 6.69231 28.8151 6.83149C30.4224 6.98663 32.0303 7.13584 33.6388 7.3331C35.9198 7.60628 38.1897 7.92627 40.47 8.20538C42.0904 8.40386 43.7114 8.59642 45.3646 8.49847C46.3027 8.4401 47.2618 8.62379 48.1927 8.79256C49.5336 9.03394 50.885 9.07253 52.239 9.14136C53.8902 9.22311 55.5421 9.29894 57.1985 9.38723C57.6735 9.41263 58.1432 9.48547 58.6182 9.51087C58.7481 9.52438 58.8865 9.46081 59.0203 9.43874C58.9685 9.31341 58.9514 9.14372 58.8583 9.06807C58.3052 8.61476 57.7305 8.19518 57.1775 7.74187C55.7106 6.53386 54.2437 5.32585 52.784 4.1066C52.2211 3.63427 51.8989 2.98308 51.5571 2.34784C51.3492 1.9604 51.5341 1.63781 51.7218 1.34547C51.9021 1.06438 52.0235 0.669208 52.4453 0.635111C52.7346 0.611222 53.0239 0.587334 53.3159 0.593703C54.7643 0.618392 56.0541 1.16031 57.3235 1.77807C58.2302 2.22017 59.1204 2.70255 60.0415 3.12217C60.4279 3.30028 60.6627 3.55259 60.8241 3.92919C60.9383 4.19293 61.0275 4.52005 61.4388 4.203C61.6212 4.06605 61.8429 4.11309 62.0102 4.32839C62.2563 4.64183 62.5469 4.92992 62.7922 5.24929C62.9589 5.47051 63.1498 5.52635 63.422 5.54866C64.448 5.61337 65.2517 6.12273 65.8284 6.95631C66.199 7.4926 66.6963 7.85616 67.2599 8.10666C67.9146 8.39663 68.5004 8.76939 68.9623 9.29118C69.8119 10.2491 70.6155 11.2442 71.4126 12.2446C71.7531 12.6758 71.6567 13.4934 71.2651 13.9024C70.5625 14.639 69.8337 15.3428 69.1476 16.093C68.7802 16.4986 68.4883 16.978 68.1472 17.4163C68.0081 17.5937 67.8625 17.8305 67.6703 17.8944C66.9192 18.1522 66.4311 18.7311 65.8676 19.2362C65.6354 19.4459 65.3887 19.6782 65.1073 19.7928C64.1935 20.1716 63.2705 20.5253 62.3343 20.8358C62.0614 20.9274 61.7282 20.8087 61.4231 20.813C61.2854 20.8167 61.0794 20.8432 61.0217 20.9332C60.5146 21.738 59.7602 22.1333 58.8588 22.1835C57.4825 22.2623 56.1856 22.7031 54.8565 23.0027C53.3253 23.3472 51.7949 23.6858 50.267 24.0547C49.0888 24.34 47.9008 24.4443 46.6976 24.4151C46.1853 24.4038 45.8133 24.1493 45.6316 23.7406C45.2412 22.8424 45.1435 22.8622 45.7706 22.0519C45.8893 21.8963 46.0244 21.7544 46.1209 21.5846C46.4935 20.9157 47.1521 20.7922 47.8029 20.5781C48.9181 20.2143 50.011 19.7822 51.0986 19.3436C52.5241 18.7662 53.93 18.1508 55.345 17.5603C56.1092 17.2379 56.8866 16.959 57.6358 16.6111C58.3849 16.2632 59.1046 15.8583 59.9219 15.4335L59.9377 15.3992Z",
            fill: "currentColor"
        })
    });
};
const $5b552751fb8b2244$var$ArrowPencilPointLeft = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        className: props.className,
        style: {
            color: props.color ? props.color : "currentColor",
            transform: `rotate(${props.rotate ? props.rotate : "0"}deg)`
        },
        width: "72",
        height: "24",
        viewBox: "0 0 72 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M11.9227 9.89136C12.8559 10.3198 13.7536 10.3994 14.6425 10.5132C15.6079 10.6375 16.5536 10.5757 17.5121 10.3645C18.3557 10.175 19.219 10.2409 20.0279 10.4536C21.5408 10.855 23.0808 10.8711 24.6387 10.819C25.6115 10.7878 26.5986 10.7979 27.5595 10.9047C28.2255 10.9812 28.8622 11.2582 29.5419 11.4511C29.9165 10.8335 30.5174 10.8367 31.1428 11.0378C32.4341 11.4541 33.7522 11.4909 35.1039 11.4143C35.8394 11.3739 36.5714 11.5124 37.1884 11.9499C37.2673 12.001 37.3665 12.0246 37.4592 12.0536C38.0528 11.4497 38.7662 11.46 39.5105 11.5935C40.7067 11.8016 41.9108 11.9872 43.107 12.1954C43.9159 12.3387 44.7234 12.4993 45.5314 12.6542C46.3329 12.8144 47.1034 13.0593 47.9682 12.8307C49.0403 12.5458 50.1289 12.7587 51.2072 12.8844C52.4385 13.0312 53.6598 13.293 54.8886 13.3299C56.9895 13.3986 59.0603 13.6792 61.1439 13.8797C62.1414 13.9771 63.1418 14.0401 64.1298 14.1774C65.1356 14.3158 66.1374 14.5002 67.1254 14.7068C68.1781 14.9233 69.2262 15.1914 70.27 15.442C70.9467 15.6001 71.3431 16.1103 71.6547 16.6383C71.743 16.7882 71.5228 17.2018 71.3392 17.3982C70.7618 18.0204 70.0144 18.3373 69.155 18.4334C67.2256 18.6528 65.2988 18.6354 63.3794 18.5319C61.6553 18.4407 59.9427 18.2174 58.2364 17.9886C56.2648 17.7317 54.2832 17.5896 52.2903 17.5103C50.7359 17.4529 49.1846 17.2917 47.6327 17.2056C46.1819 17.12 44.7272 17.0804 43.27 17.0002C41.6589 16.9103 40.0473 16.8262 38.4337 16.6958C36.1459 16.5171 33.8679 16.2928 31.5805 16.1083C29.9551 15.9771 28.3292 15.8517 26.6791 16.0077C25.7428 16.099 24.7789 15.9574 23.8437 15.8292C22.4965 15.6462 21.1444 15.6593 19.7888 15.6433C18.1357 15.6259 16.4822 15.6142 14.8237 15.5907C14.3482 15.5838 13.8766 15.531 13.4011 15.5242C13.2708 15.516 13.1342 15.5825 13.001 15.6088C13.0562 15.7278 13.0778 15.8909 13.173 15.9604C13.7382 16.3773 14.3241 16.7607 14.8892 17.1776C16.3885 18.2886 17.8877 19.3997 19.38 20.5219C19.9556 20.9567 20.2952 21.5731 20.6541 22.1733C20.8725 22.5395 20.6963 22.8576 20.5166 23.1467C20.3439 23.4247 20.2332 23.8105 19.8124 23.8591C19.5238 23.8929 19.2352 23.9268 18.9432 23.9315C17.4944 23.9616 16.1902 23.4867 14.9044 22.9378C13.986 22.545 13.0829 22.1126 12.1507 21.742C11.7596 21.5845 11.518 21.3498 11.3464 20.9924C11.2252 20.7421 11.1271 20.4298 10.7245 20.7511C10.5458 20.89 10.3229 20.8529 10.1498 20.6513C9.89537 20.358 9.59702 20.0909 9.34308 19.7918C9.1705 19.5846 8.97812 19.5378 8.70533 19.5264C7.67779 19.5021 6.86056 19.0405 6.26148 18.2576C5.87639 17.7539 5.3694 17.4216 4.79922 17.2009C4.13681 16.9455 3.54102 16.6076 3.06516 16.1213C2.18987 15.2285 1.35949 14.2982 0.535518 13.3625C0.183447 12.9591 0.257735 12.1666 0.638219 11.7573C1.32072 11.0204 2.03035 10.3142 2.69609 9.56467C3.0524 9.15964 3.33129 8.68618 3.66048 8.25055C3.79472 8.07415 3.93392 7.8403 4.12436 7.77141C4.86836 7.49476 5.34066 6.91795 5.89038 6.40956C6.11689 6.19853 6.35721 5.96526 6.63547 5.84414C7.53885 5.44466 8.45209 5.06891 9.37962 4.73449C9.64998 4.63598 9.98638 4.73803 10.2912 4.72256C10.4289 4.7139 10.6341 4.68061 10.6894 4.59166C11.1746 3.79615 11.9181 3.38661 12.818 3.30462C14.1919 3.17737 15.4766 2.7037 16.7973 2.36515C18.3188 1.9757 19.8398 1.59199 21.3573 1.17919C22.5275 0.860049 23.7125 0.715138 24.9162 0.698488C25.4287 0.690319 25.8075 0.922123 26.0002 1.30974C26.4148 2.16189 26.512 2.13913 25.9069 2.94442C25.7924 3.09896 25.6611 3.24088 25.5693 3.4084C25.2149 4.06773 24.5597 4.21134 23.9149 4.44224C22.8097 4.8348 21.7288 5.29241 20.6532 5.75615C19.2436 6.36638 17.8547 7.01257 16.456 7.63504C15.7006 7.97452 14.9309 8.27266 14.1914 8.63624C13.4518 8.99982 12.7432 9.41734 11.9375 9.85763L11.9227 9.89136Z",
            fill: "currentColor"
        })
    });
};
const $5b552751fb8b2244$export$23afe6443f3f8d50 = ({ header: header, paragraph: paragraph, ctaProps: ctaProps })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)();
    const noParagraphSpacing = !paragraph ? "var(--ds-space-400, 32px)" : "var(--ds-space-200, 16px)";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
            ref: scrollRef,
            className: (0, $esG4f.default)([
                "_kqswh2mm _1reo15vq _18m915vq _y3gn1h6o _ca0q53f4 _u5f3idpf _n3td53f4 _19bvidpf _1e0c1txw _1n261g80 _f5vqudic _zci31l2x _1t48oqhq _1n4lnrqp _zzvs5wpz _1azozpb8 _apb77mmw _1uezt77u _17nbrleh _txzv1cbv _9ptdmgh4 _12bi1mht _qcpm6o8t _fdgfstnw _t9uvidpf _1vllidpf _iejih2mm _1mwq1ssb _lt79p2n4 _5gswidpf _s3i1idpf _4qqm1u1b _14y8idpf _1bcxjyd4 _1y27zk8b _k98bidpf _1nspidpf _5vlustnw _ncds12o8 _ekvjkb7n _1ljpq7pw _1nt81hy9 _1mon1osq _jw8hpxbi _1aynxy5q _2trp1nn1",
                sectionIsVisible ? "is-visible" : ""
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: "arrows arrows-left",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)($5b552751fb8b2244$var$ArrowPencilPointRight, {
                            className: "arrow1",
                            rotate: 10,
                            color: "1868DB"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)($5b552751fb8b2244$var$ArrowPencilPointRight, {
                            className: "arrow2",
                            rotate: 8,
                            color: "BC5DF2"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)($5b552751fb8b2244$var$ArrowPencilPointRight, {
                            className: "arrow3",
                            rotate: -6,
                            color: "101214"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)($5b552751fb8b2244$var$ArrowPencilPointRight, {
                            className: "arrow4",
                            rotate: -13,
                            color: "101214"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)($5b552751fb8b2244$var$ArrowPencilPointRight, {
                            className: "arrow5",
                            rotate: -15,
                            color: "FFA900"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)($5b552751fb8b2244$var$ArrowPencilPointRight, {
                            className: "arrow6",
                            rotate: -15,
                            color: "1868DB"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: "arrows arrows-right",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)($5b552751fb8b2244$var$ArrowPencilPointLeft, {
                            className: "arrow7",
                            rotate: -10,
                            color: "101214"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)($5b552751fb8b2244$var$ArrowPencilPointLeft, {
                            className: "arrow8",
                            rotate: -20,
                            color: "1868DB"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)($5b552751fb8b2244$var$ArrowPencilPointLeft, {
                            className: "arrow9",
                            rotate: 5,
                            color: "82B536"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)($5b552751fb8b2244$var$ArrowPencilPointLeft, {
                            className: "arrow10",
                            rotate: 5,
                            color: "1868DB"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)($5b552751fb8b2244$var$ArrowPencilPointLeft, {
                            className: "arrow11",
                            rotate: 10,
                            color: "FFA900"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)($5b552751fb8b2244$var$ArrowPencilPointLeft, {
                            className: "arrow12",
                            rotate: 10,
                            color: "101214"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: "row-width",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                style: {
                                    marginBottom: noParagraphSpacing
                                },
                                children: header
                            }),
                            paragraph && /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                                layout: "8",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                    className: ".body-lg",
                                    children: paragraph
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                                variant: "secondary",
                                color: "black",
                                href: ctaProps.href,
                                dataEventProps: ctaProps.dataEventProps,
                                children: ctaProps.ctaText
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $5b552751fb8b2244$var$ctaStyles = null;

});


parcelRegister("jLexR", function(module, exports) {

$parcel$export(module.exports, "CustomerStoriesSection", function () { return $efe6be764ceb6e4a$export$48ea351ea7a5a012; });
/* customer-stories.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $9gh2a = parcelRequire("9gh2a");

var $91nJf = parcelRequire("91nJf");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("f2wO1");
var $gOfeT = parcelRequire("gOfeT");
var $h3QSK = parcelRequire("h3QSK");
parcelRequire("i3c3n");
var $aegm4 = parcelRequire("aegm4");
const $efe6be764ceb6e4a$export$48ea351ea7a5a012 = ({ totalNumberOfCustomerStories: totalNumberOfCustomerStories, customerStoryList: customerStoryList, fallbackCustomerStoryList: fallbackCustomerStoryList, filterSearchHasRun: filterSearchHasRun, loadMoreStories: loadMoreStories })=>{
    const intl = (0, $f6qj2.default)();
    const [numStories, setNumStories] = (0, $iSvIT.useState)(0);
    const { width: width } = (0, $aegm4.useWindowDimensions)();
    const numColumns = (0, $aegm4.getNumberOfCustomerStoryColumns)(width);
    let storyGrid = (0, $iSvIT.useMemo)(()=>{
        return {};
    }, []);
    storyGrid = (0, $iSvIT.useMemo)(()=>{
        if (numStories !== customerStoryList.length) setNumStories(customerStoryList.length);
         // if the number of columns has changed, re-sort the stories
        if (numColumns !== Object.keys(storyGrid).length) return (0, $aegm4.sortStoriesByHeight)(storyGrid, customerStoryList.slice(0, numStories), numColumns); // if the number of stories has changed, append the new stories to the grid
        else return (0, $aegm4.sortStoriesByHeight)(storyGrid, customerStoryList.slice(0, customerStoryList.length), numColumns);
        return storyGrid;
    }, [
        numStories,
        storyGrid,
        customerStoryList,
        numColumns
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "customers-page-stories-grid",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_6rth12bs"
                ]),
                children: [
                    customerStoryList.length === 0 && filterSearchHasRun ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $gOfeT.CustomerStoryNoResultsFallback), {
                        numColumns: numColumns,
                        fallbackCustomerStories: fallbackCustomerStoryList
                    }) : customerStoryList.length === 0 && !filterSearchHasRun ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _1bah1h6o _4cvr1y6m _1pfh1lit _4t3i1us8"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gh2a.default), {
                                size: "xlarge"
                            })
                        })
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $h3QSK.CustomerStoriesGrid), {
                        numColumns: numColumns,
                        storiesGrid: storyGrid
                    }),
                    numStories !== 0 && numStories < totalNumberOfCustomerStories && /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_19pkzwfg _2hwx1wug _otyridpf _18u01wug _1e0c1txw _1n261g80 _2lx21bp4 _1bah1h6o _4cvr1h6o"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "CustomersLandingPage.showingListOfStories",
                                        defaultMessage: "Showing <numberOfCustomerStories></numberOfCustomerStories> of <totalNumberOfCustomerStories></totalNumberOfCustomerStories> stories",
                                        values: {
                                            numberOfCustomerStories: ()=>customerStoryList.length,
                                            totalNumberOfCustomerStories: ()=>totalNumberOfCustomerStories
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                                    variant: "secondary",
                                    color: "black",
                                    onClick: loadMoreStories,
                                    dataEventProps: {
                                        "data-event": "clicked",
                                        "data-event-component": "button",
                                        "data-event-container": "customerStorySection",
                                        "data-product-key": "customers",
                                        "data-label-english": "Load more stories"
                                    },
                                    children: intl.formatMessage({
                                        id: "CustomersLandingPage.loadMoreStories",
                                        defaultMessage: "Load more stories"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $efe6be764ceb6e4a$var$customerStoryContainerStyles = null;
const $efe6be764ceb6e4a$var$spinnerStyles = null;
const $efe6be764ceb6e4a$var$loadMoreStyles = null;

});
parcelRegister("f2wO1", function(module, exports) {
$parcel$export(module.exports, "CustomerStoryFilterSliderFilter", function () { return (parcelRequire("zblkl")).CustomerStoryFilterSliderFilter; });
$parcel$export(module.exports, "CustomerStoriesGrid", function () { return (parcelRequire("h3QSK")).CustomerStoriesGrid; });
$parcel$export(module.exports, "CustomerStoryCard", function () { return (parcelRequire("i9Gqm")).CustomerStoryCard; });
$parcel$export(module.exports, "CustomerStoryFilterModalBasic", function () { return (parcelRequire("lJ5eV")).CustomerStoryFilterModalBasic; });
$parcel$export(module.exports, "CustomerStoryFilterModalComplex", function () { return (parcelRequire("gJCuW")).CustomerStoryFilterModalComplex; });
$parcel$export(module.exports, "CustomerStoryFilterModalComplexGrouping", function () { return (parcelRequire("9SiO3")).CustomerStoryFilterModalComplexGrouping; });
$parcel$export(module.exports, "CustomerStoryFilterModalRadioButton", function () { return (parcelRequire("9SiO3")).CustomerStoryFilterModalRadioButton; });
$parcel$export(module.exports, "CustomerStoryNoResultsFallback", function () { return (parcelRequire("gOfeT")).CustomerStoryNoResultsFallback; });
$parcel$export(module.exports, "CustomerStorySearchBar", function () { return (parcelRequire("8hLLi")).CustomerStorySearchBar; });
$parcel$export(module.exports, "SearchButton", function () { return (parcelRequire("4rWB5")).SearchButton; });
$parcel$export(module.exports, "SearchCloseButton", function () { return (parcelRequire("bsZNC")).SearchCloseButton; });
parcelRequire("zblkl");
parcelRequire("h3QSK");
parcelRequire("i9Gqm");
parcelRequire("lJ5eV");
parcelRequire("gJCuW");
parcelRequire("9SiO3");
parcelRequire("gOfeT");
parcelRequire("8hLLi");
parcelRequire("4rWB5");
parcelRequire("bsZNC");

});
parcelRegister("zblkl", function(module, exports) {

$parcel$export(module.exports, "CustomerStoryFilterSliderFilter", function () { return $4e54d3573683ea96$export$4555d391c790a08; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("i3c3n");
var $2bAiT = parcelRequire("2bAiT");
const $4e54d3573683ea96$export$4555d391c790a08 = ({ subFilterName: subFilterName, subFilterDescription: subFilterDescription, active: active, updateFilterObject: updateFilterObject })=>{
    const localizedMap = (0, $2bAiT.LocalizedFilterOptions)();
    const optionId = `filter-checkbox-${subFilterName.replace(/\s/g, "")}`;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: "filter-slider-button-container",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                children: localizedMap[subFilterName]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: "filter-slider-content",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        children: localizedMap[subFilterDescription]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("label", {
                        className: "switch",
                        htmlFor: optionId,
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                                type: "checkbox",
                                id: optionId,
                                checked: active,
                                onClick: ()=>updateFilterObject(subFilterName)
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                className: "slider round"
                            })
                        ]
                    })
                ]
            })
        ]
    }, subFilterName);
};

});
parcelRegister("i3c3n", function(module, exports) {
$parcel$export(module.exports, "filterCustomerStories", function () { return (parcelRequire("cFUxJ")).filterCustomerStories; });
$parcel$export(module.exports, "defaultCustomerStoryFilterOptionsObject", function () { return (parcelRequire("bs52B")).defaultCustomerStoryFilterOptionsObject; });
$parcel$export(module.exports, "areFiltersAreActive", function () { return (parcelRequire("aegm4")).areFiltersAreActive; });
$parcel$export(module.exports, "commitAllStagedActiveValues", function () { return (parcelRequire("aegm4")).commitAllStagedActiveValues; });
$parcel$export(module.exports, "getActiveFiltersByFilterType", function () { return (parcelRequire("aegm4")).getActiveFiltersByFilterType; });
$parcel$export(module.exports, "getFilterEventProps", function () { return (parcelRequire("aegm4")).getFilterEventProps; });
$parcel$export(module.exports, "getFilterOptions", function () { return (parcelRequire("aegm4")).getFilterOptions; });
$parcel$export(module.exports, "getNumberOfCustomerStoryColumns", function () { return (parcelRequire("aegm4")).getNumberOfCustomerStoryColumns; });
$parcel$export(module.exports, "handleFallbackCustomerStories", function () { return (parcelRequire("aegm4")).handleFallbackCustomerStories; });
$parcel$export(module.exports, "isContentPlatformFacetAvailable", function () { return (parcelRequire("aegm4")).isContentPlatformFacetAvailable; });
$parcel$export(module.exports, "resetAllStagedActiveToCommittedActiveValue", function () { return (parcelRequire("aegm4")).resetAllStagedActiveToCommittedActiveValue; });
$parcel$export(module.exports, "setAllStagedActiveToFalse", function () { return (parcelRequire("aegm4")).setAllStagedActiveToFalse; });
$parcel$export(module.exports, "sortStoriesByHeight", function () { return (parcelRequire("aegm4")).sortStoriesByHeight; });
$parcel$export(module.exports, "useWindowDimensions", function () { return (parcelRequire("aegm4")).useWindowDimensions; });
$parcel$export(module.exports, "LocalizedFilterOptions", function () { return (parcelRequire("2bAiT")).LocalizedFilterOptions; });
parcelRequire("cFUxJ");
parcelRequire("bs52B");
parcelRequire("aegm4");
parcelRequire("2bAiT");
parcelRequire("rOpvN");

});
parcelRegister("cFUxJ", function(module, exports) {

$parcel$export(module.exports, "filterCustomerStories", function () { return $bfe1c2e777fe3448$export$e00c2f7823dc318c; });
const $bfe1c2e777fe3448$export$e00c2f7823dc318c = (results, filters, committedState)=>{
    var _filters_morefilters_Marketplaceapps, _filters_morefilters_Solutionpartner;
    const filteredProducts = Object.entries(filters.product).reduce((acc, [subFilterName, subFilterObject])=>{
        if (subFilterObject[committedState]) acc.push(subFilterName);
        return acc;
    }, []);
    const filteredIndustries = Object.entries(filters.industry).reduce((acc, [subFilterName, subFilterObject])=>{
        if (subFilterObject[committedState]) acc.push(subFilterName);
        return acc;
    }, []);
    const filteredSolutions = Object.entries(filters.solution).reduce((acc, [subFilterName, subFilterObject])=>{
        if (subFilterObject[committedState]) acc.push(subFilterName);
        return acc;
    }, []);
    const filteredRegions = Object.entries(filters["more filters"]).reduce((acc, [subFilterName, subFilterObject])=>{
        if (subFilterObject.grouping === "region") {
            if (subFilterObject[committedState]) acc.push(subFilterName);
        }
        return acc;
    }, []);
    const filteredTeamSize = Object.entries(filters["more filters"]).reduce((acc, [subFilterName, subFilterObject])=>{
        if (subFilterObject.grouping === "team size") {
            if (subFilterObject[committedState]) acc.push(subFilterName);
        }
        return acc;
    }, []);
    const filteredMarketplaceApps = (_filters_morefilters_Marketplaceapps = filters["more filters"]["Marketplace apps"]) === null || _filters_morefilters_Marketplaceapps === void 0 ? void 0 : _filters_morefilters_Marketplaceapps[committedState];
    const filteredSolutionPartner = (_filters_morefilters_Solutionpartner = filters["more filters"]["Solution partner"]) === null || _filters_morefilters_Solutionpartner === void 0 ? void 0 : _filters_morefilters_Solutionpartner[committedState];
    const filterByCategory = (selectedCategoryValues, customerValues = [])=>{
        if (selectedCategoryValues.length > 0) {
            if ((customerValues === null || customerValues === void 0 ? void 0 : customerValues.length) > 0) {
                // Include if filter is applied and this company has that industry
                if (selectedCategoryValues.filter((selected)=>{
                    return customerValues.includes(selected);
                }).length > 0) return true;
            }
            // Remove this item if there is a filter applied but this customer does not have the appropriate value
            return false;
        }
        // Include all items if no filter has been requested
        return true;
    };
    const includeIfExists = (isEnabled = false, customerValues = [])=>{
        if (isEnabled) return (customerValues === null || customerValues === void 0 ? void 0 : customerValues.length) > 0;
        return true;
    };
    const filteredResults = results === null || results === void 0 ? void 0 : results.filter((customerStory)=>{
        var _customerStory_customerCompany_industry, _customerStory_customerCompany;
        return filterByCategory(filteredIndustries, (_customerStory_customerCompany = customerStory.customerCompany) === null || _customerStory_customerCompany === void 0 ? void 0 : (_customerStory_customerCompany_industry = _customerStory_customerCompany.industry) === null || _customerStory_customerCompany_industry === void 0 ? void 0 : _customerStory_customerCompany_industry.map((industry)=>{
            var _industry_name;
            return (_industry_name = industry.name) !== null && _industry_name !== void 0 ? _industry_name : "";
        }));
    }).filter((customerStory)=>{
        var _customerStory_products;
        return filterByCategory(filteredProducts, (_customerStory_products = customerStory.products) === null || _customerStory_products === void 0 ? void 0 : _customerStory_products.map((product)=>{
            var _product_name;
            return (_product_name = product.name) !== null && _product_name !== void 0 ? _product_name : "";
        }));
    }).filter((customerStory)=>{
        var _customerStory_solutions;
        return filterByCategory(filteredSolutions, (_customerStory_solutions = customerStory.solutions) === null || _customerStory_solutions === void 0 ? void 0 : _customerStory_solutions.map((solution)=>{
            var _solution_name;
            return (_solution_name = solution.name) !== null && _solution_name !== void 0 ? _solution_name : "";
        }));
    }).filter((customerStory)=>{
        var _customerStory_customerCompany_region, _customerStory_customerCompany;
        var _customerStory_customerCompany_region_name;
        return filterByCategory(filteredRegions, [
            (_customerStory_customerCompany_region_name = (_customerStory_customerCompany = customerStory.customerCompany) === null || _customerStory_customerCompany === void 0 ? void 0 : (_customerStory_customerCompany_region = _customerStory_customerCompany.region) === null || _customerStory_customerCompany_region === void 0 ? void 0 : _customerStory_customerCompany_region.name) !== null && _customerStory_customerCompany_region_name !== void 0 ? _customerStory_customerCompany_region_name : ""
        ]);
    }).filter((customerStory)=>{
        var _customerStory_customerCompany_organizationSize, _customerStory_customerCompany;
        var _customerStory_customerCompany_organizationSize_name;
        return filterByCategory(filteredTeamSize, [
            (_customerStory_customerCompany_organizationSize_name = (_customerStory_customerCompany = customerStory.customerCompany) === null || _customerStory_customerCompany === void 0 ? void 0 : (_customerStory_customerCompany_organizationSize = _customerStory_customerCompany.organizationSize) === null || _customerStory_customerCompany_organizationSize === void 0 ? void 0 : _customerStory_customerCompany_organizationSize.name) !== null && _customerStory_customerCompany_organizationSize_name !== void 0 ? _customerStory_customerCompany_organizationSize_name : ""
        ]);
    }).filter((customerStory)=>{
        var _customerStory_marketplaceApps;
        return includeIfExists(filteredMarketplaceApps, (_customerStory_marketplaceApps = customerStory.marketplaceApps) === null || _customerStory_marketplaceApps === void 0 ? void 0 : _customerStory_marketplaceApps.map((app)=>{
            var _app_name;
            return (_app_name = app.name) !== null && _app_name !== void 0 ? _app_name : "";
        }));
    }).filter((customerStory)=>{
        var _customerStory_solutionPartners;
        return includeIfExists(filteredSolutionPartner, (_customerStory_solutionPartners = customerStory.solutionPartners) === null || _customerStory_solutionPartners === void 0 ? void 0 : _customerStory_solutionPartners.map((partner)=>{
            var _partner_name;
            return (_partner_name = partner.name) !== null && _partner_name !== void 0 ? _partner_name : "";
        }));
    });
    return filteredResults;
};

});

parcelRegister("bs52B", function(module, exports) {

$parcel$export(module.exports, "defaultCustomerStoryFilterOptionsObject", function () { return $dcfb5c242dbcc7be$export$6f0fff8c0ca899ac; });
const $dcfb5c242dbcc7be$export$6f0fff8c0ca899ac = {
    "solution": {
    },
    "product": {
    },
    "industry": {
    },
    "more filters": {
        "Marketplace apps": {
            committedActive: false,
            stagedActive: false,
            description: "Only show stories from customers that use marketplace apps"
        },
        "Solution partner": {
            committedActive: false,
            stagedActive: false,
            description: "Only show stories from customers that have a solution partner"
        }
    }
};

});

parcelRegister("aegm4", function(module, exports) {

$parcel$export(module.exports, "areFiltersAreActive", function () { return $7fcd72bd9d17764e$export$caf5989571fe03fd; });
$parcel$export(module.exports, "commitAllStagedActiveValues", function () { return $7fcd72bd9d17764e$export$995b34954b6e3c5d; });
$parcel$export(module.exports, "setAllStagedActiveToFalse", function () { return $7fcd72bd9d17764e$export$32ef36095a2643ff; });
$parcel$export(module.exports, "resetAllStagedActiveToCommittedActiveValue", function () { return $7fcd72bd9d17764e$export$6e8eccaa2da87c2a; });
$parcel$export(module.exports, "getActiveFiltersByFilterType", function () { return $7fcd72bd9d17764e$export$5c95673afb2371b8; });
$parcel$export(module.exports, "handleFallbackCustomerStories", function () { return $7fcd72bd9d17764e$export$bb39b836f537201; });
$parcel$export(module.exports, "sortStoriesByHeight", function () { return $7fcd72bd9d17764e$export$bf9342a233bd676b; });
$parcel$export(module.exports, "getNumberOfCustomerStoryColumns", function () { return $7fcd72bd9d17764e$export$65d9e924579f6503; });
$parcel$export(module.exports, "useWindowDimensions", function () { return $7fcd72bd9d17764e$export$f715c0e61b2c1a36; });
$parcel$export(module.exports, "isContentPlatformFacetAvailable", function () { return $7fcd72bd9d17764e$export$f2735cb33092c31f; });
$parcel$export(module.exports, "getFilterOptions", function () { return $7fcd72bd9d17764e$export$8ba04a2269d8d395; });
$parcel$export(module.exports, "getFilterEventProps", function () { return $7fcd72bd9d17764e$export$c09429083a9f1f77; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $iSvIT = parcelRequire("iSvIT");
const $7fcd72bd9d17764e$var$sizeMap = {
    lg: 4,
    md: 3,
    sm: 2
};
const $7fcd72bd9d17764e$export$caf5989571fe03fd = (filterObject)=>{
    let isActive = false;
    const filterCategories = Object.values(filterObject);
    let i = 0;
    while(!isActive && i < filterCategories.length){
        const filterCategoryValues = filterCategories[i];
        let j = 0;
        while(!isActive && j < Object.values(filterCategoryValues).length){
            const subFilterObject = Object.values(filterCategoryValues)[j];
            if (subFilterObject["committedActive"]) isActive = true;
            j++;
        }
        i++;
    }
    return isActive;
};
const $7fcd72bd9d17764e$export$995b34954b6e3c5d = (prevState)=>{
    return Object.keys(prevState).reduce((acc, filterCategory)=>{
        acc[filterCategory] = (0, $7Knp0._)({}, prevState[filterCategory], Object.entries(prevState[filterCategory]).reduce((acc, [filterOptionName, filterOptionValue])=>{
            acc[filterOptionName] = (0, $6iHNw._)((0, $7Knp0._)({}, filterOptionValue), {
                committedActive: filterOptionValue.stagedActive
            });
            return acc;
        }, {}));
        return acc;
    }, {});
};
const $7fcd72bd9d17764e$export$32ef36095a2643ff = (prevState)=>{
    return Object.keys(prevState).reduce((acc, filterCategory)=>{
        acc[filterCategory] = (0, $7Knp0._)({}, prevState[filterCategory], Object.entries(prevState[filterCategory]).reduce((acc, [filterOptionName, filterOptionValue])=>{
            acc[filterOptionName] = (0, $6iHNw._)((0, $7Knp0._)({}, filterOptionValue), {
                stagedActive: false
            });
            return acc;
        }, {}));
        return acc;
    }, {});
};
const $7fcd72bd9d17764e$export$6e8eccaa2da87c2a = (prevState)=>{
    return Object.keys(prevState).reduce((acc, filterCategory)=>{
        acc[filterCategory] = (0, $7Knp0._)({}, prevState[filterCategory], Object.entries(prevState[filterCategory]).reduce((acc, [filterOptionName, filterOptionValue])=>{
            acc[filterOptionName] = (0, $6iHNw._)((0, $7Knp0._)({}, filterOptionValue), {
                stagedActive: filterOptionValue.committedActive
            });
            return acc;
        }, {}));
        return acc;
    }, {});
};
const $7fcd72bd9d17764e$export$b16988f469572eb0 = (event, filter, onClickHandler)=>{
    if (event.key === "Enter") onClickHandler(filter);
};
const $7fcd72bd9d17764e$export$5c95673afb2371b8 = (filter, filterObject)=>{
    if (filter === "all") return Object.values(filterObject).reduce((acc, filterCategory)=>acc + Object.values(filterCategory).reduce((subacc, filterOption)=>filterOption.committedActive ? subacc + 1 : subacc, 0), 0);
    else return Object.values(filterObject[filter]).reduce((acc, subFilter)=>subFilter.committedActive ? acc + 1 : acc, 0);
};
const $7fcd72bd9d17764e$var$NUMBER_OF_FALLBACK_STORIES = 3;
const $7fcd72bd9d17764e$export$bb39b836f537201 = (customerStories)=>{
    const fallbackCustomerStoryList = new Array($7fcd72bd9d17764e$var$NUMBER_OF_FALLBACK_STORIES);
    const extraFallbackCustomerStoryList = [];
    customerStories.forEach((story)=>{
        switch(story.urlSlug){
            case "the-very-group":
                fallbackCustomerStoryList[0] = story;
                break;
            case "sonymusic-publishing":
                fallbackCustomerStoryList[1] = story;
                break;
            case "lumen":
                fallbackCustomerStoryList[2] = story;
                break;
            case "edenred":
            case "engie":
            case "sunlife":
                extraFallbackCustomerStoryList.push(story);
                break;
            default:
                break;
        }
    });
    let extraFallbackStoriesUsed = 0;
    // If one of the original three are missing,
    // we'll use the extra fallback stories
    fallbackCustomerStoryList.forEach((story, index)=>{
        if (!story && extraFallbackCustomerStoryList[extraFallbackStoriesUsed]) {
            fallbackCustomerStoryList[index] = extraFallbackCustomerStoryList[extraFallbackStoriesUsed];
            extraFallbackStoriesUsed++;
        }
    });
    return fallbackCustomerStoryList;
};
const $7fcd72bd9d17764e$var$getShortestColumnIndex = (storyList)=>{
    let shortestColumnIndex = 0;
    let shortestHeight = storyList[0].height;
    Object.values(storyList).forEach((story, index)=>{
        if (shortestHeight > story.height) {
            shortestColumnIndex = index;
            shortestHeight = story.height;
        }
    });
    return shortestColumnIndex;
};
const $7fcd72bd9d17764e$export$bf9342a233bd676b = (storiesList, stories, rows)=>{
    if (Object.keys(storiesList).length === 0) // initialize object
    for(let i = 0; i < rows; i++)storiesList[i] = {
        stories: [],
        height: 0
    };
    else if (Object.keys(storiesList).length !== rows || stories.length !== 0) {
        // clear out existing object, and re-intialize it
        for(const key in storiesList)delete storiesList[key];
        for(let i = 0; i < rows; i++)storiesList[i] = {
            stories: [],
            height: 0
        };
    }
    let shortestColumnIndex = 0;
    stories.forEach((story)=>{
        var _story_advocateQuotes, _story_storyIcon;
        shortestColumnIndex = $7fcd72bd9d17764e$var$getShortestColumnIndex(storiesList);
        const storyGridItem = storiesList[shortestColumnIndex];
        if ((_story_advocateQuotes = story.advocateQuotes) === null || _story_advocateQuotes === void 0 ? void 0 : _story_advocateQuotes.length) storyGridItem.height += $7fcd72bd9d17764e$var$sizeMap["lg"];
        else if ((_story_storyIcon = story.storyIcon) === null || _story_storyIcon === void 0 ? void 0 : _story_storyIcon.url) storyGridItem.height += $7fcd72bd9d17764e$var$sizeMap["md"];
        else storyGridItem.height += $7fcd72bd9d17764e$var$sizeMap["sm"];
        storyGridItem.stories.push(story);
    });
    return storiesList;
};
const $7fcd72bd9d17764e$export$65d9e924579f6503 = (width)=>{
    if (width > 1024) return 3;
    else if (width > 768) return 2;
    else if (width <= 768) return 1;
    else return 1;
};
const $7fcd72bd9d17764e$export$2d18ca8a66126a1d = ()=>{
    const { innerWidth: width } = window;
    return {
        width: width
    };
};
function $7fcd72bd9d17764e$export$f715c0e61b2c1a36() {
    const [windowDimensions, setWindowDimensions] = (0, $iSvIT.useState)($7fcd72bd9d17764e$export$2d18ca8a66126a1d());
    (0, $iSvIT.useEffect)(()=>{
        function handleResize() {
            setWindowDimensions($7fcd72bd9d17764e$export$2d18ca8a66126a1d());
        }
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return windowDimensions;
}
function $7fcd72bd9d17764e$export$f2735cb33092c31f(category) {
    return category === "industry" || category === "product" || category === "solution" || category === "region" || category === "team size";
}
const $7fcd72bd9d17764e$var$defaultCustomerStoryFilterOptionValue = {
    committedActive: false,
    stagedActive: false
};
function $7fcd72bd9d17764e$export$8ba04a2269d8d395(filters, subFilter) {
    const defaulted = {};
    filters.forEach((filter)=>{
        defaulted[filter.name] = (0, $6iHNw._)((0, $7Knp0._)({}, $7fcd72bd9d17764e$var$defaultCustomerStoryFilterOptionValue), {
            grouping: subFilter === "region" || subFilter === "team size" ? subFilter : undefined
        });
    });
    return defaulted;
}
function $7fcd72bd9d17764e$export$c09429083a9f1f77(filterObject) {
    const committedActive = Object.keys(filterObject).map((key)=>{
        const map = Object.keys(filterObject[key]).map((key2)=>{
            const root = filterObject[key];
            const value = root[key2];
            var _value_grouping;
            const category = (_value_grouping = value === null || value === void 0 ? void 0 : value.grouping) !== null && _value_grouping !== void 0 ? _value_grouping : key;
            return (value === null || value === void 0 ? void 0 : value.committedActive) ? `${category}=${key2}` : "";
        }).filter((item)=>item === null || item === void 0 ? void 0 : item.length);
        return map;
    });
    return committedActive.flat().join("|");
}

});

parcelRegister("2bAiT", function(module, exports) {

$parcel$export(module.exports, "LocalizedFilterOptions", function () { return $c730967f6a2c61b9$export$1021dd15869d400b; });

var $f6qj2 = parcelRequire("f6qj2");

var $gAJUc = parcelRequire("gAJUc");
const $c730967f6a2c61b9$export$1021dd15869d400b = ()=>{
    const intl = (0, $f6qj2.default)();
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    return {
        "solution": intl.formatMessage({
            id: "CustomersLandingPage.filterCategory.solution",
            defaultMessage: "solution"
        }),
        "product": gwp7518NavIconUpdates ? intl.formatMessage({
            id: "CustomersLandingPage.filterCategory.product-gwp-7518",
            defaultMessage: "App"
        }) : intl.formatMessage({
            id: "CustomersLandingPage.filterCategory.product",
            defaultMessage: "product"
        }),
        "industry": intl.formatMessage({
            id: "CustomersLandingPage.filterCategory.industry",
            defaultMessage: "industry"
        }),
        "more filters": intl.formatMessage({
            id: "CustomersLandingPage.filterCategory.morefilters",
            defaultMessage: "more filters"
        }),
        "Work Management": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.WorkManagement",
            defaultMessage: "Work Management"
        }),
        "Agile / DevOps": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.AgileDevOps",
            defaultMessage: "Agile / DevOps"
        }),
        "ITSM": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.ITSM",
            defaultMessage: "ITSMs"
        }),
        "Cloud Migration": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.CloudMigration",
            defaultMessage: "Cloud Migration"
        }),
        "Jira": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Jira",
            defaultMessage: "Jira"
        }),
        "Jira Service Management": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.JiraServiceManagement",
            defaultMessage: "Jira Service Management"
        }),
        "Jira Align": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.JiraAlign",
            defaultMessage: "Jira Align"
        }),
        "Jira Product Discovery": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.JiraProductDiscovery",
            defaultMessage: "Jira Product Discovery"
        }),
        "Confluence": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Confluence",
            defaultMessage: "Confluence"
        }),
        "Trello": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Trello",
            defaultMessage: "Trello"
        }),
        "Bitbucket": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Bitbucket",
            defaultMessage: "Bitbucket"
        }),
        "Guard": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Guard",
            defaultMessage: "Guard"
        }),
        "Statuspage": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Statuspage",
            defaultMessage: "Statuspage"
        }),
        "Compass": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Compass",
            defaultMessage: "Compass"
        }),
        "Bamboo": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Bamboo",
            defaultMessage: "Bamboo"
        }),
        "Automotive": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Automotive",
            defaultMessage: "Automotive"
        }),
        "Aviation": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Aviation",
            defaultMessage: "Aviation"
        }),
        "Consumer Goods & Retail": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.ConsumerGoodsRetail",
            defaultMessage: "Consumer Goods & Retail"
        }),
        "Education": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Education",
            defaultMessage: "Education"
        }),
        "Energy & Utilties": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.EnergyUtilties",
            defaultMessage: "Energy & Utilties"
        }),
        "Entertainment & Media": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.EntertainmentMedia",
            defaultMessage: "Entertainment & Media"
        }),
        "Financial Services": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.FinancialServices",
            defaultMessage: "Financial Services"
        }),
        "Government": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Government",
            defaultMessage: "Government"
        }),
        "Healthcare & Life Sciences": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.HealthcareLifeSciences",
            defaultMessage: "Healthcare & Life Sciences"
        }),
        "Internet & Telecommunications": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.InternetTelecommunications",
            defaultMessage: "Internet & Telecommunications"
        }),
        "Manufacturing": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Manufacturing",
            defaultMessage: "Manufacturing"
        }),
        "Non-Profit": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.NonProfit",
            defaultMessage: "Non-Profit"
        }),
        "Real Estate": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.RealEstate",
            defaultMessage: "Real Estate"
        }),
        "Software": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Software",
            defaultMessage: "Software"
        }),
        "Technology": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Technology",
            defaultMessage: "Technology"
        }),
        "Marketplace apps": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.MarketplaceApps",
            defaultMessage: "Marketplace apps"
        }),
        "Only show stories from customers that use marketplace apps": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.MarketplaceApps.description",
            defaultMessage: "Only show stories from customers that use Marketplace apps"
        }),
        "Solution partner": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.SolutionPartner",
            defaultMessage: "Solution partner"
        }),
        "Only show stories from customers that have a solution partner": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.SolutionPartner.description",
            defaultMessage: "Only show stories from customers that have a Solution Partner"
        }),
        "Americas": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Americas",
            defaultMessage: "Americas"
        }),
        "Europe, Middle East, Africa": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.EuropeMiddleEastAfrica",
            defaultMessage: "Europe, Middle East, Africa"
        }),
        "Asia Pacific": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.AsiaPacific",
            defaultMessage: "Asia Pacific"
        }),
        "Global": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Global",
            defaultMessage: "Global"
        }),
        "Small/Medium Business": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.SmallMediumBusiness",
            defaultMessage: "Small/Medium Business"
        }),
        "Enterprise": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.Enterprise",
            defaultMessage: "Enterprise"
        }),
        "Large Enterprise": intl.formatMessage({
            id: "CustomersLandingPage.subFilter.LargeEnterprise",
            defaultMessage: "Large Enterprise"
        })
    };
};

});

parcelRegister("rOpvN", function(module, exports) {

});



parcelRegister("h3QSK", function(module, exports) {

$parcel$export(module.exports, "CustomerStoriesGrid", function () { return $840a06c99430c07e$export$630103427516de50; });
/* customer-stories-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("f2wO1");
var $i9Gqm = parcelRequire("i9Gqm");
const $840a06c99430c07e$export$630103427516de50 = ({ storiesGrid: storiesGrid, numColumns: numColumns })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: numColumns === 1 ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            layout: "12",
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _zulpzwfg"
                ]),
                children: storiesGrid[0] && storiesGrid[0].stories.map((story, index)=>{
                    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $i9Gqm.CustomerStoryCard), (0, $7Knp0._)({}, story), index);
                })
            })
        }) : numColumns === 2 ? /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
            layout: "6-6",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _zulpzwfg"
                    ]),
                    children: storiesGrid[0] && storiesGrid[0].stories.map((story, index)=>{
                        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $i9Gqm.CustomerStoryCard), (0, $7Knp0._)({}, story), index);
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _zulpzwfg"
                    ]),
                    children: storiesGrid[1] && storiesGrid[1].stories.map((story, index)=>{
                        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $i9Gqm.CustomerStoryCard), (0, $7Knp0._)({}, story), index);
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
            layout: "4-4-4",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _zulpzwfg"
                    ]),
                    children: storiesGrid[0] && storiesGrid[0].stories.map((story, index)=>{
                        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $i9Gqm.CustomerStoryCard), (0, $7Knp0._)({}, story), index);
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _zulpzwfg"
                    ]),
                    children: storiesGrid[1] && storiesGrid[1].stories.map((story, index)=>{
                        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $i9Gqm.CustomerStoryCard), (0, $7Knp0._)({}, story), index);
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _zulpzwfg"
                    ]),
                    children: storiesGrid[2] && storiesGrid[2].stories.map((story, index)=>{
                        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $i9Gqm.CustomerStoryCard), (0, $7Knp0._)({}, story), index);
                    })
                })
            ]
        })
    });
};
const $840a06c99430c07e$var$columnStyles = null;

});

parcelRegister("i9Gqm", function(module, exports) {

$parcel$export(module.exports, "CustomerStoryCard", function () { return $719d2afd0652e438$export$ec4bed50821b5168; });
/* customer-story-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
parcelRequire("dyrzP");
var $9Kv7x = parcelRequire("9Kv7x");

var $lHB9W = parcelRequire("lHB9W");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");
const $719d2afd0652e438$export$ec4bed50821b5168 = ({ title: title, urlSlug: urlSlug, customerCompany: customerCompany, advocateQuotes: advocateQuotes, storyIcon: storyIcon, callToAction: callToAction })=>{
    var _callToAction_, _advocateQuote_advocateHeadshot, _customerCompany_logo_, _customerCompany_logo, _advocateQuote_advocateHeadshot1;
    var _callToAction__url;
    const href = (0, $3FBn4.useLocalizedHref)((_callToAction__url = callToAction === null || callToAction === void 0 ? void 0 : (_callToAction_ = callToAction[0]) === null || _callToAction_ === void 0 ? void 0 : _callToAction_.url) !== null && _callToAction__url !== void 0 ? _callToAction__url : `/customers/${urlSlug}`);
    const isExternalHref = href.startsWith("https://");
    const advocateQuote = advocateQuotes === null || advocateQuotes === void 0 ? void 0 : advocateQuotes[0];
    const isQuote = !!(advocateQuote === null || advocateQuote === void 0 ? void 0 : (_advocateQuote_advocateHeadshot = advocateQuote.advocateHeadshot) === null || _advocateQuote_advocateHeadshot === void 0 ? void 0 : _advocateQuote_advocateHeadshot.url);
    var _customerCompany_name, _ref;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
        href: href,
        target: isExternalHref ? "_blank" : undefined,
        rel: isExternalHref ? "noreferrer noopener" : undefined,
        className: (0, $esG4f.default)([
            "_311tkb7n _1dbzjojz _1vpokb7n _ca0q1tcg _u5f31tcg _n3tdzwfg _19bv1tcg _bfhku67f _2rkogktf _16qs1yxe _v56416gf _r57hidpf _zy2nm7ou"
        ]),
        children: [
            customerCompany && ((customerCompany === null || customerCompany === void 0 ? void 0 : (_customerCompany_logo = customerCompany.logo) === null || _customerCompany_logo === void 0 ? void 0 : (_customerCompany_logo_ = _customerCompany_logo[0]) === null || _customerCompany_logo_ === void 0 ? void 0 : _customerCompany_logo_.url) ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_6rth1tcg _rtysmlf1 _bna71ylp _1jpx1f51"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9Kv7x.ContentPlatformImage), {
                    alt: (_ref = (_customerCompany_name = customerCompany.name) !== null && _customerCompany_name !== void 0 ? _customerCompany_name : customerCompany.logo[0].description) !== null && _ref !== void 0 ? _ref : " ",
                    src: customerCompany.logo[0].url,
                    contentType: customerCompany.logo[0].contentType,
                    baseWidth: 200,
                    height: "40px"
                })
            }) : /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_6rth1tcg _rtysmlf1 _bna71ylp _1jpx1f51"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    children: (0, $lHB9W.expectContent)(customerCompany.name)
                })
            })),
            (storyIcon === null || storyIcon === void 0 ? void 0 : storyIcon.url) && !isQuote && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_6rth1tcg _1e0c1txw _mezj1osq _rtys163v _salg1wug _18zxkb7n"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9Kv7x.ContentPlatformImage), {
                    alt: " " /* we consider these illustrations decorative */ ,
                    src: storyIcon.url,
                    contentType: storyIcon.contentType,
                    baseWidth: 300
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _zulp1k8s _19pkidpf _2hwxidpf _otyr1tcg _18u0idpf _1b4didpf _vo4eidpf _wotzidpf _1ugbidpf _mezj1osq _rtys1ltq _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _czr612u0 _xx1w1lzr _btqhidpf _1tadidpf _1ejbidpf _1ahqidpf"
                ]),
                children: (advocateQuote === null || advocateQuote === void 0 ? void 0 : (_advocateQuote_advocateHeadshot1 = advocateQuote.advocateHeadshot) === null || _advocateQuote_advocateHeadshot1 === void 0 ? void 0 : _advocateQuote_advocateHeadshot1.url) ? /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $9Kv7x.ContentPlatformImage), {
                            alt: " " /* details here would duplicate information elsewhere on the card */ ,
                            src: advocateQuote.advocateHeadshot.url,
                            contentType: advocateQuote.advocateHeadshot.contentType,
                            baseWidth: 400
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                                    children: advocateQuote.advocateName
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                    className: "eyebrow-md",
                                    children: advocateQuote.advocateJobTitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("blockquote", {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                className: "body-lg",
                                children: advocateQuote.advocateQuote
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: "body-lg",
                    children: title
                })
            }),
            callToAction && callToAction[0] && callToAction[0].text && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                className: "customer-story-link-container",
                href: href,
                text: callToAction[0].text,
                type: "primary",
                isStyleOnly: true
            })
        ]
    });
};
const $719d2afd0652e438$var$customerStoryCardsStyles = null;
const $719d2afd0652e438$var$customerLogoStyles = null;
const $719d2afd0652e438$var$spotIllustrationStyles = null;
const $719d2afd0652e438$var$storyTitleStyles = null;

});

parcelRegister("lJ5eV", function(module, exports) {

$parcel$export(module.exports, "CustomerStoryFilterModalBasic", function () { return $1c8f6c27039cdd4b$export$bcad7e14b9c41118; });
/* customer-story-filter-modal-basic.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("i3c3n");
var $2bAiT = parcelRequire("2bAiT");
var $aegm4 = parcelRequire("aegm4");
const $1c8f6c27039cdd4b$export$bcad7e14b9c41118 = ({ subFilter: subFilter, subFilterObject: subFilterObject, updateFilterObject: updateFilterObject })=>{
    const localizedMap = (0, $2bAiT.LocalizedFilterOptions)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqswstnw _bfhku67f _2rkogktf _1pbycs5v _152t4bvh _ca0q7vkz _u5f31tcg _n3td1tcg _19bv1tcg _2lx21bp4 _16qsjojz _11ko1txw _rs1e1bp4 _m0njftgi _13qeidpf _1esjidpf _lnxxidpf _1yn0tlke _1m5y1txw _6xef1q9c _5red1h6o _53691y6m _130f1oen _un46gktf _1ebcgktf _tmbl1l7b _ghxb16z6 _ym6vgktf _118yftgi _otnau67f _1jfy1txw _vjdb1h6o _16db1h6o _1mpgidpf _94z6doyu _1srq1oen _sj1jkb7n",
            subFilter
        ]),
        id: "customer-story-modal-component-parent",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            children: Object.keys(subFilterObject).map((filterOptionName, index)=>{
                const filterObject = subFilterObject[filterOptionName];
                const active = filterObject.stagedActive;
                const optionId = `option-${subFilter.replace(/\s/g, "")}-${index}`;
                return /*#__PURE__*/ (0, $loA2J.jsxs)("label", {
                    htmlFor: optionId,
                    className: "filter-radio-button-container",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                            id: optionId,
                            type: "checkbox",
                            onClick: ()=>updateFilterObject(filterOptionName),
                            className: (0, $esG4f.default)([
                                "_kqswstnw _1pby1mrw _tzy4idpf"
                            ])
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: active ? "checked" : "",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Icon), {
                                name: "featurecheckmark",
                                size: "xs",
                                color: "#FFFFFF"
                            })
                        }),
                        (0, $aegm4.isContentPlatformFacetAvailable)(subFilter) ? filterOptionName : localizedMap[filterOptionName]
                    ]
                }, filterOptionName);
            })
        })
    });
};
const $1c8f6c27039cdd4b$var$customerStoryFilterModalBasicStyle = null;
const $1c8f6c27039cdd4b$var$actualInputStyle = null;

});

parcelRegister("gJCuW", function(module, exports) {

$parcel$export(module.exports, "CustomerStoryFilterModalComplex", function () { return $15e847f59b7113d1$export$2f70c3bf84c20631; });
/* customer-story-filter-modal-complex.tsx generated by @compiled/babel-plugin v0.28.8 */ // This file has tons of nested selector errors that should be fixed.
// eslint-disable-next-line local/no-block-disable-of-nested-eslint
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $91nJf = parcelRequire("91nJf");

var $4XrxY = parcelRequire("4XrxY");

var $cbjCN = parcelRequire("cbjCN");
parcelRequire("f2wO1");
var $9SiO3 = parcelRequire("9SiO3");
const $15e847f59b7113d1$export$2f70c3bf84c20631 = ({ numberOfCustomerStories: numberOfCustomerStories, filterObject: filterObject, onlyShowMoreFiltersCategory: onlyShowMoreFiltersCategory, updateFilterObject: updateFilterObject, closeModal: closeModal, resetFilters: resetFilters, clearMoreFilters: clearMoreFilters, clearFilters: clearFilters, runSearch: runSearch })=>{
    const intl = (0, $f6qj2.default)(); // Handle clicking outside the modal
    const handleClickingOutsideModal = (event)=>{
        if (event.target === event.currentTarget) {
            resetFilters();
            closeModal();
        }
    }; // Handle "esc" key being pressed to close the modal
    const handleKeyDownOutsideModal = (event)=>{
        if (event.key === "Escape") {
            resetFilters();
            closeModal();
        }
    }; // Handle click on the close button
    const handleClickingCloseModal = ()=>{
        resetFilters();
        closeModal();
    };
    const handleClearFilterClick = ()=>{
        if (onlyShowMoreFiltersCategory && clearMoreFilters) clearMoreFilters();
        else clearFilters();
    };
    let filterObjectKeys = Object.keys(filterObject);
    if (onlyShowMoreFiltersCategory) filterObjectKeys = [
        "more filters"
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        id: "customer-story-modal-component-parent",
        onKeyDown: handleKeyDownOutsideModal,
        onClick: handleClickingOutsideModal,
        className: (0, $esG4f.default)([
            "_kqsw1n9t _bfhk1ebw _1e02idpf _rjxpidpf _152tidpf _u7coidpf _1pbyouyt _1bsb1osq _4t3i1osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1rfm1osq _1rkb1osq _476didpf _123r1osq _a5ztidpf _gltephn8 _10jxphn8 _1mt1vbgk _kqswh2mm _1e0c1txw _2lx21bp4 _1reo15vq _18m915vq _bfhku67f _2rkogktf _16qsjojz _ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _19pkzwfg _2hwx1wug _otyrzwfg _18u01wug _1bsb1vuk _c71l1vuk _5mp0zwfg _uoe41txw _3p8m1yb4 _1f3a1h6o _xg3n1hjg _1eapidpf _feifidpf _1ul1idpf _c6iridpf _g0kv1fw0 _1d8aviql _1ys6tlke _1cpiqlpt _9xq715zi _xxjoglyw _pz8qglyw _1ydrglyw _br967vkz _ek7didpf _1xe37vkz _1gn8idpf _maetidpf _j5v9idpf _gnleidpf _l0efidpf _btwe1nn1 _1htt1k8s _1tnn1dk0 _ojp91tcg _1map1hjg _z5h1glyw _16ng1txw _1t661q9c _hy5i1yb4 _4pizidpf _13tl1osq _1wfif1ug _irdu1txw _1xae1bp4 _ikai1g80 _h2051y6m _1qitidpf _6dklidpf _yzz41ssb _7gqi1ssb _e3ic1tcg _1a66idpf _1eehidpf _mmhcidpf _119utlke _1yuw1txw _17zw1q9c _32f11h6o _1o5g1y6m _1shw1oen _9hinglyw _11w4gktf _1m9jgktf _ivy21l7b _1nsa16z6 _w3o2gktf _1p0lftgi _larvu67f _g1v11txw _1ggp1h6o _c2211h6o _1yr2doyu _1kdj1oen _1jezidpf _1sc3idpf _1xbzidpf _1fnuidpf _1y6a1txw _cj8a1g80 _7mj11yb4 _1a8f1osq _117t1tcg _yitridpf _1s8v1tcg _bwjgidpf _12u91tcg _1ur61txw _1drn1q9c _e9uk1yb4 _f1q21h6o _icc91hjg _kqdu12it _xtvnidpf _1a8gidpf _1579idpf _4cxwidpf _1jpwh2mm _t2ds1o8l _12kv1ylp _14rtgktf _1rhyidpf _hijaidpf _1srsidpf _1fj8doyu _1qzh1k0w _1ld0stnw _1f8ttlke _1jwpidpf _qqok1fkg _7l1y1cqc _7nn21u1b _cnocstnw _19tvb3bt _1mm47vkz _p98b7vkz _1qpgyh40 _13p3yh40 _w8ksu67f _hess1cqc _w28t1ssb _euwfdoyu _158b1k0w _1ab91tcg _1vva1ssb _1bqyzwfg _1hi7idpf _1bklidpf _3lyjidpf _18hj1txw _1x8i1yb4 _1b3v1h6o _i5ni1hjg _16xodoyu"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: "filter-modal-header",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                            children: "Filters"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                            type: "button",
                            onClick: handleClickingCloseModal,
                            className: (0, $esG4f.default)([
                                "_19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1wyb1j6v _ect48q0o _80omtlke _syazalr3"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Icon), {
                                name: "cross",
                                size: "small"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: "filter-modal-body",
                    children: filterObjectKeys.map((filterCategory, index)=>{
                        const filterCategoryTyped = filterCategory;
                        if (filterCategoryTyped === "more filters") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9SiO3.CustomerStoryFilterModalComplexGrouping), {
                            filterCategory: "more filters",
                            filterObject: filterObject,
                            updateFilterObject: (subFilterName)=>updateFilterObject(filterCategoryTyped, subFilterName)
                        }, index);
                        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cbjCN.ComplexModalFilterCategorySection), {
                            filterCategory: filterCategoryTyped,
                            filterObject: filterObject,
                            updateFilterObject: updateFilterObject
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: "filter-modal-footer",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                            type: "button",
                            className: (0, $esG4f.default)([
                                "_19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1wyb1j6v _ect48q0o _80omtlke _syazalr3",
                                "filter-modal-clear-all"
                            ]),
                            onClick: handleClearFilterClick,
                            children: intl.formatMessage({
                                id: "CustomersLandingPage.clearAll",
                                defaultMessage: "Clear all"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                            className: "filter-apply-button",
                            variant: "primary",
                            size: "small",
                            color: "blue",
                            onClick: runSearch,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "CustomersLandingPage.showResults",
                                defaultMessage: "Show <numberOfCustomerStories></numberOfCustomerStories> results",
                                values: {
                                    numberOfCustomerStories: ()=>numberOfCustomerStories
                                }
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $15e847f59b7113d1$var$customerStoryFilterModalBackgroundStyle = null;
const $15e847f59b7113d1$var$customerStoryFilterModalStyle = null;
const $15e847f59b7113d1$var$buttonBaselineStyle = null;

});
parcelRegister("cbjCN", function(module, exports) {

$parcel$export(module.exports, "ComplexModalFilterCategorySection", function () { return $797db6f32101a2fb$export$7e2a92574800a5cf; });
/* complex-modal-filter-category-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("i3c3n");
var $aegm4 = parcelRequire("aegm4");
parcelRequire("f2wO1");
var $9SiO3 = parcelRequire("9SiO3");
const $797db6f32101a2fb$var$MAX_SUBFILTERS_BEFORE_EXPAND = 8;
const $797db6f32101a2fb$var$MAX_COLUMN_ENTRIES_BEFORE_EXPAND = 4;
const $797db6f32101a2fb$var$MAX_SUBFILTERS_BEFORE_TWO_COLUMNS = 5;
const $797db6f32101a2fb$var$NUMBER_OF_COLUMNS = 2;
const $797db6f32101a2fb$export$7e2a92574800a5cf = ({ filterCategory: filterCategory, filterObject: filterObject, updateFilterObject: updateFilterObject })=>{
    const intl = (0, $f6qj2.default)();
    const [showingMore, setShowingMore] = (0, $iSvIT.useState)(false);
    const { width: width } = (0, $aegm4.useWindowDimensions)();
    const FilterColumnOne = [];
    const FilterColumnTwo = []; // List of keys to see how many subfilters are in the category
    const keys = Object.keys(filterObject[filterCategory]);
    const expandSubsection = ()=>{
        setShowingMore(!showingMore);
    };
    Object.entries(filterObject[filterCategory]).forEach(([subFilterName, subFilterObject], index)=>{
        // On tablet and desktop, split the subfilters into two columns
        if (width > 768) {
            // If there are less than 5 subfilters,
            // or if the current subfilter is in the first half of the list,
            // Then add it to the first column
            if (keys.length < $797db6f32101a2fb$var$MAX_SUBFILTERS_BEFORE_TWO_COLUMNS || keys.length / $797db6f32101a2fb$var$NUMBER_OF_COLUMNS > index) {
                const isSubFilterHidden = FilterColumnOne.length >= $797db6f32101a2fb$var$MAX_COLUMN_ENTRIES_BEFORE_EXPAND && keys.length > $797db6f32101a2fb$var$MAX_SUBFILTERS_BEFORE_EXPAND && !showingMore;
                FilterColumnOne.push(/*#__PURE__*/ (0, $loA2J.jsx)((0, $9SiO3.CustomerStoryFilterModalRadioButton), {
                    index: index,
                    filterCategory: filterCategory,
                    subFilterName: subFilterName,
                    grouping: subFilterObject.grouping,
                    active: subFilterObject.stagedActive,
                    isSubFilterHidden: isSubFilterHidden,
                    updateFilterObject: updateFilterObject
                }, index)); // if the current subfilter is in the first half of the list,
            // Then add it to the first column
            } else {
                const isSubFilterHidden = FilterColumnTwo.length >= $797db6f32101a2fb$var$MAX_COLUMN_ENTRIES_BEFORE_EXPAND && keys.length > $797db6f32101a2fb$var$MAX_SUBFILTERS_BEFORE_EXPAND && !showingMore;
                FilterColumnTwo.push(/*#__PURE__*/ (0, $loA2J.jsx)((0, $9SiO3.CustomerStoryFilterModalRadioButton), {
                    index: index,
                    filterCategory: filterCategory,
                    subFilterName: subFilterName,
                    grouping: subFilterObject.grouping,
                    active: subFilterObject.stagedActive,
                    isSubFilterHidden: isSubFilterHidden,
                    updateFilterObject: updateFilterObject
                }, index));
            }
        } else {
            // On mobile, add all subfilters to the first column
            const isSubFilterHidden = FilterColumnOne.length >= $797db6f32101a2fb$var$MAX_COLUMN_ENTRIES_BEFORE_EXPAND && !showingMore;
            FilterColumnOne.push(/*#__PURE__*/ (0, $loA2J.jsx)((0, $9SiO3.CustomerStoryFilterModalRadioButton), {
                index: index,
                filterCategory: filterCategory,
                subFilterName: subFilterName,
                grouping: subFilterObject.grouping,
                active: subFilterObject.stagedActive,
                isSubFilterHidden: isSubFilterHidden,
                updateFilterObject: updateFilterObject
            }, index));
        }
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                children: filterCategory
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: "filter-modal-grouping-container",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: "filter-modal-grouping-column filter-column-1",
                        children: FilterColumnOne
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: "filter-modal-grouping-column filter-column-2",
                        children: FilterColumnTwo
                    })
                ]
            }),
            keys.length > $797db6f32101a2fb$var$MAX_SUBFILTERS_BEFORE_EXPAND && /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                type: "button",
                onClick: expandSubsection,
                className: (0, $esG4f.default)([
                    "_19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1wyb1j6v _ect48q0o _80omtlke _syazalr3 _1pfh1k8s"
                ]),
                children: !showingMore ? intl.formatMessage({
                    id: "CustomersLandingPage.showMore",
                    defaultMessage: "Show more"
                }) : intl.formatMessage({
                    id: "CustomersLandingPage.showLess",
                    defaultMessage: "Show less"
                })
            })
        ]
    });
};
const $797db6f32101a2fb$var$showButtonStyle = null;

});


parcelRegister("9SiO3", function(module, exports) {

$parcel$export(module.exports, "CustomerStoryFilterModalRadioButton", function () { return $8afe7fd5407a3478$export$ab592b785f13f9e8; });
$parcel$export(module.exports, "CustomerStoryFilterModalComplexGrouping", function () { return $8afe7fd5407a3478$export$6ceba011e8ba7c3e; });
/* customer-story-filter-modal-grouping.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("i3c3n");
var $2bAiT = parcelRequire("2bAiT");
var $aegm4 = parcelRequire("aegm4");
parcelRequire("f2wO1");
var $zblkl = parcelRequire("zblkl");
const $8afe7fd5407a3478$var$actualInputStyle = null;
const $8afe7fd5407a3478$export$ab592b785f13f9e8 = ({ index: index, filterCategory: filterCategory, subFilterName: subFilterName, grouping: grouping, active: active, isSubFilterHidden: isSubFilterHidden, updateFilterObject: updateFilterObject })=>{
    const localizedMap = (0, $2bAiT.LocalizedFilterOptions)();
    const optionId = `option-${(grouping !== null && grouping !== void 0 ? grouping : filterCategory).replace(/\s/g, "")}-${index}`;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("label", {
        htmlFor: optionId,
        className: `filter-radio-button-container ${isSubFilterHidden ? "hide-subfilter" : ""}`,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                id: optionId,
                type: "checkbox",
                onClick: ()=>updateFilterObject(filterCategory, subFilterName),
                className: (0, $esG4f.default)([
                    "_kqswstnw _1pby1mrw _tzy4idpf"
                ])
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: active ? "checked" : "",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Icon), {
                    name: "featurecheckmark",
                    size: "xs",
                    color: "#FFFFFF"
                })
            }),
            (0, $aegm4.isContentPlatformFacetAvailable)(grouping !== null && grouping !== void 0 ? grouping : filterCategory) ? subFilterName : localizedMap[subFilterName]
        ]
    });
};
const $8afe7fd5407a3478$export$6ceba011e8ba7c3e = ({ filterCategory: filterCategory, filterObject: filterObject, updateFilterObject: updateFilterObject })=>{
    const intl = (0, $f6qj2.default)();
    const sliderFilterContainer = [];
    const regionFilterContainer = [];
    const teamSizeFilterContainer = [];
    Object.keys(filterObject[filterCategory]).map((subFilter, index)=>{
        const subFilterObject = filterObject[filterCategory][subFilter];
        if (subFilterObject.description) sliderFilterContainer.push(/*#__PURE__*/ (0, $loA2J.jsx)((0, $zblkl.CustomerStoryFilterSliderFilter), {
            subFilterName: subFilter,
            active: subFilterObject.stagedActive,
            updateFilterObject: ()=>updateFilterObject(subFilter),
            subFilterDescription: subFilterObject.description
        }, subFilter));
        else if (subFilterObject.grouping === "region") regionFilterContainer.push(/*#__PURE__*/ (0, $loA2J.jsx)($8afe7fd5407a3478$export$ab592b785f13f9e8, {
            index: index,
            filterCategory: filterCategory,
            subFilterName: subFilter,
            grouping: subFilterObject.grouping,
            active: subFilterObject.stagedActive,
            isSubFilterHidden: false,
            updateFilterObject: ()=>updateFilterObject(subFilter)
        }, index));
        else teamSizeFilterContainer.push(/*#__PURE__*/ (0, $loA2J.jsx)($8afe7fd5407a3478$export$ab592b785f13f9e8, {
            index: index,
            filterCategory: filterCategory,
            subFilterName: subFilter,
            grouping: subFilterObject.grouping,
            active: subFilterObject.stagedActive,
            isSubFilterHidden: false,
            updateFilterObject: ()=>updateFilterObject(subFilter)
        }, index));
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: "filter-modal-body-more-filters",
        children: [
            sliderFilterContainer.map((sliderFilter)=>{
                return sliderFilter;
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1bsb1osq _179r1hjg _85i51tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                        children: intl.formatMessage({
                            id: "CustomersLandingPage.filterGrouping.region",
                            defaultMessage: "Region"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: "filter-modal-grouping-container",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: "filter-modal-grouping-column",
                            children: regionFilterContainer.map((regionFilter)=>{
                                return regionFilter;
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1pfh1tcg _1bsb1osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                        children: intl.formatMessage({
                            id: "CustomersLandingPage.filterGrouping.TeamSize",
                            defaultMessage: "Team size"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: "filter-modal-grouping-container",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: "filter-modal-grouping-column",
                            children: teamSizeFilterContainer.map((regionFilter)=>{
                                return regionFilter;
                            })
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("gOfeT", function(module, exports) {

$parcel$export(module.exports, "CustomerStoryNoResultsFallback", function () { return $1e101b8f4744ff4d$export$bdcbebb305fb33c3; });
/* customer-story-no-results-fallback-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("i3c3n");
var $aegm4 = parcelRequire("aegm4");
parcelRequire("f2wO1");
var $h3QSK = parcelRequire("h3QSK");
const $1e101b8f4744ff4d$export$bdcbebb305fb33c3 = ({ numColumns: numColumns, fallbackCustomerStories: fallbackCustomerStories })=>{
    const intl = (0, $f6qj2.default)();
    const fallbackStoriesGrid = (0, $aegm4.sortStoriesByHeight)({}, fallbackCustomerStories, numColumns);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx21bp4 _y3gn1e5h _amuvangw _1li31tcg"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: "eyebrow-md",
                    children: intl.formatMessage({
                        id: "CustomersLandingPage.recommendedStories",
                        defaultMessage: "Recommended stories you may like"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $h3QSK.CustomerStoriesGrid), {
                    storiesGrid: fallbackStoriesGrid,
                    numColumns: numColumns
                })
            ]
        })
    });
};
const $1e101b8f4744ff4d$var$customerStoryRecommendedStoriesStyles = null;

});

parcelRegister("8hLLi", function(module, exports) {

$parcel$export(module.exports, "CustomerStorySearchBar", function () { return $6ad5a2fab1d3838b$export$b6376e21a285c40b; });
/* customer-story-search-bar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");
parcelRequire("f2wO1");
var $bsZNC = parcelRequire("bsZNC");
var $4rWB5 = parcelRequire("4rWB5");
const $6ad5a2fab1d3838b$export$b6376e21a285c40b = ({ searchStringValue: searchStringValue, searchInputFieldFocused: searchInputFieldFocused, setSearchString: setSearchString, setSearchInputFieldFocused: setSearchInputFieldFocused, clearSearchField: clearSearchField, runSearch: runSearch })=>{
    const intl = (0, $f6qj2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const searchRef = (0, $iSvIT.useRef)(null);
    const onSearchInputChange = (event)=>{
        setSearchString(event.target.value);
    };
    const handleSearchBarFocus = ()=>{
        setSearchInputFieldFocused(true);
        createAnalyticsEvent({
            origin: "web",
            platform: "web",
            product: "marketing",
            source: "none",
            userIdType: "atlassianAccount",
            eventComponent: "searchInput",
            event: "clicked",
            eventType: "ui",
            action: "clicked",
            actionSubject: "component",
            attributes: {
                url: location.href,
                page_path: location.pathname,
                eventComponent: "customerStorysearchInput"
            }
        }).fire();
    };
    const handleOnBlur = ()=>{
        if (searchStringValue === "") setSearchInputFieldFocused(false);
        else setSearchInputFieldFocused(true);
    };
    const handleSearchButtonClick = (0, $iSvIT.useCallback)(()=>{
        if (searchRef.current) searchRef.current.focus();
        runSearch();
    }, [
        runSearch
    ]);
    const handleClearSearchButtonClick = ()=>{
        clearSearchField();
        if (searchRef.current) searchRef.current.focus();
    };
    const searchClassName = searchInputFieldFocused ? "search-active" : "";
    return /*#__PURE__*/ (0, $loA2J.jsxs)("form", {
        onSubmit: (evt)=>{
            evt.preventDefault();
            handleSearchButtonClick();
        },
        className: (0, $esG4f.default)([
            "_4t3ior1b _1bsb1osq _bfhk17fj _2rko1ylp _1e0c1txw _1n261q9c _1bah1yb4 _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz _scffglyw _1rwq1j28 _xmji1r31 _gxxuglyw _34ir1o36 _5hv91osq _17ea1vuk _125xdlk8 _psgkqlpt _yizh1fw0 _ggg71nn1 _1owa1w8u _4u6k1j28 _10709by0 _1f021txw _1vh3esu3 _dier1q9c _1b10idpf _cpccftgi _1s5lidpf _18asftgi _1sku1h6o _12nmbz2e _1d2m1f4h _11vy1dfy _p2rgx19p"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                className: searchClassName,
                type: "text",
                placeholder: intl.formatMessage({
                    id: "CustomersLandingPage.searchPlaceholder",
                    defaultMessage: "Search customer stories"
                }),
                onFocus: handleSearchBarFocus,
                onBlur: handleOnBlur,
                onChange: onSearchInputChange,
                value: searchStringValue,
                ref: searchRef
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: `search-buttons-container ${searchClassName}`,
                children: [
                    searchInputFieldFocused && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bsZNC.SearchCloseButton), {
                                onClick: handleClearSearchButtonClick
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: "search-buttons-divider"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $4rWB5.SearchButton), {})
                ]
            })
        ]
    });
};
const $6ad5a2fab1d3838b$var$searchBarContainerStyle = null;

});

parcelRegister("4rWB5", function(module, exports) {

$parcel$export(module.exports, "SearchButton", function () { return $102f9430748a162c$export$690bcf3a1f1e9f2f; });
/* customer-story-search-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $2YVsr = parcelRequire("2YVsr");
const $102f9430748a162c$var$searchIconStyle = null;
const $102f9430748a162c$export$690bcf3a1f1e9f2f = ()=>{
    const intl = (0, $f6qj2.default)();
    const translated = {
        searchLabel: intl.formatMessage({
            id: "CustomerLandingPage.search.label",
            defaultMessage: "Search"
        })
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
        type: "submit",
        id: "customer-story-search-icon",
        "aria-label": translated.searchLabel,
        "data-event": "clicked",
        "data-event-component": "button",
        "data-event-container": "customerStorySearchButton",
        "data-product-key": "customer",
        className: (0, $esG4f.default)([
            "_ahbqftgi _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz14rb _ql0oj1oc _1nj1qlpt _11vn1ssb _17521wug _i2i314y2 _uhas14y2 _5jw914y2 _7wy914y2 _w8l5zwfg _xwbjzwfg"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2YVsr))), {
            label: translated.searchLabel,
            primaryColor: "#101214"
        })
    });
};

});

parcelRegister("bsZNC", function(module, exports) {

$parcel$export(module.exports, "SearchCloseButton", function () { return $d85d386c0f076937$export$c5139e00bcad35c8; });
/* customer-story-search-close-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $l8KEj = parcelRequire("l8KEj");
const $d85d386c0f076937$var$searchIconStyle = null;
const $d85d386c0f076937$export$c5139e00bcad35c8 = (props)=>{
    const intl = (0, $f6qj2.default)();
    const translated = {
        searchCloseLabel: intl.formatMessage({
            id: "CustomerLandingPage.search.close.label",
            defaultMessage: "Search close"
        })
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
        type: "button",
        onClick: props.onClick,
        id: "customer-story-search-icon",
        "aria-label": translated.searchCloseLabel,
        "data-event": "clicked",
        "data-event-component": "button",
        "data-event-container": "customerStorySearchCloseButton",
        "data-product-key": "customer",
        className: (0, $esG4f.default)([
            "_1pfh1y44 _12l2ftgi _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz14rb _ql0oj1oc _1nj1qlpt _11vn1ssb _17521wug _i2i314y2 _uhas14y2 _5jw914y2 _7wy914y2 _w8l51ul9"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $l8KEj.Cross), {
            size: "24"
        })
    });
};

});



parcelRegister("fTcHC", function(module, exports) {

$parcel$export(module.exports, "CustomerStoryFilters", function () { return $58c466831834e47a$export$801647fac331cbf3; });
/* customer-story-filters.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $dyZbY = parcelRequire("dyZbY");

var $91nJf = parcelRequire("91nJf");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("f2wO1");
var $gJCuW = parcelRequire("gJCuW");
var $lJ5eV = parcelRequire("lJ5eV");
var $8hLLi = parcelRequire("8hLLi");
parcelRequire("i3c3n");
var $2bAiT = parcelRequire("2bAiT");
var $aegm4 = parcelRequire("aegm4");
const $58c466831834e47a$export$801647fac331cbf3 = ({ filterObject: filterObject, numberOfCustomerStoriesByCommittedValues: numberOfCustomerStoriesByCommittedValues, numberOfCustomerStoriesByStagedValues: numberOfCustomerStoriesByStagedValues, searchStringValue: searchStringValue, searchInputFieldFocused: searchInputFieldFocused, hasFilterSearchRun: hasFilterSearchRun, setFilterObjectValue: setFilterObjectValue, setSearchInputFieldFocused: setSearchInputFieldFocused, setSearchString: setSearchString, clearAllFilterButtonClickHandler: clearAllFilterButtonClickHandler, clearSearchField: clearSearchField, runSearchWithFilters: runSearchWithFilters })=>{
    const intl = (0, $f6qj2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const localizedMap = (0, $2bAiT.LocalizedFilterOptions)();
    const whichFilterModalIsOpenObjectDefaultState = {
        "solution": false,
        "product": false,
        "industry": false,
        "more filters": false
    };
    const { width: width } = (0, $aegm4.useWindowDimensions)();
    Object.freeze(whichFilterModalIsOpenObjectDefaultState);
    const [whichFilterModalIsOpenObject, updateWhichFilterModalIsOpenObject] = (0, $iSvIT.useState)(whichFilterModalIsOpenObjectDefaultState); // Updates the state of which filter modal is open
    // If a modal is closing, we commit all the stagedActive values
    const updateWhichFilterModalIsShown = (subFilter)=>{
        const isModalClosing = Object.keys(whichFilterModalIsOpenObject).filter((key)=>whichFilterModalIsOpenObject[key]);
        updateWhichFilterModalIsOpenObject(()=>(0, $6iHNw._)((0, $7Knp0._)({}, whichFilterModalIsOpenObjectDefaultState), {
                [subFilter]: !whichFilterModalIsOpenObject[subFilter]
            }));
        if (isModalClosing.length > 0) setFilterObjectValue((prevState)=>{
            filterObject = (0, $7Knp0._)({}, prevState, (0, $aegm4.commitAllStagedActiveValues)(prevState));
            runSearchWithFilters(filterObject, searchStringValue);
            return filterObject;
        });
    }; // Updates the stagedActive value of the filter
    const updateSubFilterStagedValue = (subFilterName, filterOptionName)=>{
        setFilterObjectValue((prevState)=>{
            return (0, $6iHNw._)((0, $7Knp0._)({}, prevState), {
                [subFilterName]: (0, $6iHNw._)((0, $7Knp0._)({}, prevState[subFilterName]), {
                    [filterOptionName]: (0, $6iHNw._)((0, $7Knp0._)({}, prevState[subFilterName][filterOptionName]), {
                        stagedActive: !prevState[subFilterName][filterOptionName].stagedActive
                    })
                })
            });
        });
    };
    const clearAllStagedValues = ()=>{
        setFilterObjectValue((prevState)=>{
            return (0, $7Knp0._)({}, prevState, (0, $aegm4.setAllStagedActiveToFalse)(prevState));
        });
    }; // Clears all stagedActive values in the more filters section
    const clearMoreFilterStagedValues = ()=>{
        setFilterObjectValue((prevState)=>{
            const updatedFilterState = Object.entries(prevState["more filters"]).reduce((acc, [filterOptionName, filterOptionValue])=>{
                acc[filterOptionName] = (0, $6iHNw._)((0, $7Knp0._)({}, filterOptionValue), {
                    stagedActive: false
                });
                return acc;
            }, {});
            return (0, $6iHNw._)((0, $7Knp0._)({}, prevState), {
                ["more filters"]: (0, $7Knp0._)({}, prevState["more filters"], updatedFilterState)
            });
        });
    }; // resets all stagedActive values to their committedActive value
    const resetAllStagedValues = ()=>{
        setFilterObjectValue((prevState)=>{
            const updatedFilterState = (0, $aegm4.resetAllStagedActiveToCommittedActiveValue)(prevState);
            return (0, $7Knp0._)({}, prevState, updatedFilterState);
        });
    }; // Closes complex modal and runs search
    const runSearchWithFiltersWrapper = ()=>{
        updateWhichFilterModalIsShown("more filters");
        runSearchWithFilters(filterObject, searchStringValue);
    }; // Handles logic for determining which filter modal to show
    const getFilterModal = (showFilter, filterKey)=>{
        if (!showFilter || !whichFilterModalIsOpenObject[filterKey]) return null;
        const numCols = (0, $aegm4.getNumberOfCustomerStoryColumns)(width);
        if (numCols === 3) {
            if (filterKey === "more filters") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $gJCuW.CustomerStoryFilterModalComplex), {
                numberOfCustomerStories: numberOfCustomerStoriesByStagedValues,
                filterObject: filterObject,
                onlyShowMoreFiltersCategory: true,
                updateFilterObject: updateSubFilterStagedValue,
                closeModal: ()=>updateWhichFilterModalIsShown("more filters"),
                resetFilters: resetAllStagedValues,
                clearMoreFilters: clearMoreFilterStagedValues,
                clearFilters: clearAllStagedValues,
                runSearch: runSearchWithFiltersWrapper
            });
            else return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lJ5eV.CustomerStoryFilterModalBasic), {
                subFilter: filterKey,
                subFilterObject: filterObject[filterKey],
                updateFilterObject: (filterOptionName)=>updateSubFilterStagedValue(filterKey, filterOptionName)
            });
        } else return /*#__PURE__*/ (0, $loA2J.jsx)((0, $gJCuW.CustomerStoryFilterModalComplex), {
            numberOfCustomerStories: numberOfCustomerStoriesByStagedValues,
            filterObject: filterObject,
            onlyShowMoreFiltersCategory: false,
            updateFilterObject: updateSubFilterStagedValue,
            closeModal: ()=>updateWhichFilterModalIsShown("more filters"),
            resetFilters: resetAllStagedValues,
            clearFilters: clearAllStagedValues,
            runSearch: runSearchWithFiltersWrapper
        });
    };
    const filterButtonClickWrapper = (ev, filterCategory)=>{
        ev.preventDefault();
        createAnalyticsEvent({
            origin: "web",
            platform: "web",
            product: "marketing",
            source: "none",
            userIdType: "atlassianAccount",
            eventComponent: "customerFilterButton",
            event: "clicked",
            eventType: "ui",
            action: "clicked",
            actionSubject: "component",
            attributes: {
                labelEnglish: filterCategory,
                url: location.href,
                page_path: location.pathname,
                eventComponent: "customerFilterButton"
            }
        }).fire();
        updateWhichFilterModalIsShown(filterCategory);
    };
    const buttonPropsList = [
        {
            variant: "primary",
            color: "light_grey",
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onClick: (ev)=>filterButtonClickWrapper(ev, "solution")
        },
        {
            variant: "primary",
            color: "light_grey",
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onClick: (ev)=>filterButtonClickWrapper(ev, "product")
        },
        {
            variant: "primary",
            color: "light_grey",
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onClick: (ev)=>filterButtonClickWrapper(ev, "industry")
        },
        {
            variant: "secondary",
            color: "light_grey",
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onClick: (ev)=>filterButtonClickWrapper(ev, "more filters")
        }
    ];
    const totalNumberOfActiveFilters = (0, $iSvIT.useMemo)(()=>{
        return (0, $aegm4.getActiveFiltersByFilterType)("all", filterObject) || 0;
    }, [
        filterObject
    ]); // If any filter modal is open, show the modal
    const showModal = Object.values(whichFilterModalIsOpenObject).filter((isActiveValue)=>isActiveValue).length > 0;
    const handleDocumentClick = (0, $iSvIT.useCallback)((event)=>{
        if (showModal) {
            let parentNode = event.target;
            while(parentNode && parentNode.nodeName !== "BODY"){
                if (parentNode.id === "customer-story-modal-component-parent") return;
                parentNode = parentNode.parentNode;
            }
        } // If we are here, it means the click was outside the modal
        const isModalClosing = Object.keys(whichFilterModalIsOpenObject).filter((key)=>whichFilterModalIsOpenObject[key]);
        if (isModalClosing.length > 0) {
            updateWhichFilterModalIsOpenObject(()=>(0, $7Knp0._)({}, whichFilterModalIsOpenObjectDefaultState));
            setFilterObjectValue((prevState)=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                filterObject = (0, $7Knp0._)({}, prevState, (0, $aegm4.commitAllStagedActiveValues)(prevState));
                runSearchWithFilters(filterObject, searchStringValue);
                return filterObject;
            });
        }
    }, [
        showModal
    ]); // Attach and detach the event listener for the document click
    // This is used to determine if there is a click outside of the filter modals
    (0, $iSvIT.useEffect)(()=>{
        // Attach the listeners on component mount.
        document.addEventListener("click", handleDocumentClick, false); // Detach the listeners on component unmount.
        return ()=>{
            document.removeEventListener("click", handleDocumentClick, false);
        };
    }, [
        handleDocumentClick
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "customers-page-filters",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
                className: (0, $esG4f.default)([
                    "_19pkys9h _2hwxidpf _otyrzwfg _18u0idpf _12eoidpf _1mg17vkz"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _1n261q9c _1bah1yb4"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: (0, $esG4f.default)([
                                        "_kqswh2mm _1e0c1txw _1n261q9c _i0dl1ns9 _v5646lqh _1a8lka7h _1vn5glyw",
                                        Object.keys(filterObject.industry).length === 0 && "_tzy4idpf"
                                    ]),
                                    children: [
                                        buttonPropsList.map((buttonProp, index)=>{
                                            const filterKey = Object.keys(filterObject)[index]; // Inefficient, we should look into memoizing this
                                            const numFiltersActive = (0, $aegm4.getActiveFiltersByFilterType)(filterKey, filterObject);
                                            const buttonClassNameBuilder = `customer-story-filter-button-adg4 ${numFiltersActive ? "filter-active" : ""} ${whichFilterModalIsOpenObject[filterKey] ? "selected" : ""} ${filterKey === "more filters" ? "more-filters" : ""}`;
                                            const filterModal = getFilterModal(showModal, filterKey);
                                            return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                                className: "customer-story-filter-button",
                                                children: [
                                                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $91nJf.Adg4Button), (0, $6iHNw._)((0, $7Knp0._)({}, buttonProp), {
                                                        className: (0, $esG4f.default)([
                                                            "_bja41dk0 _lf657vkz _1edd7vkz _1yprtlke _5pbz1j6v _1ffa1ipv _10tp1nn1 _1mjbglyw _qjacf1gs _12rgftgi _inqm18ms _3smh17fj _irr317fj _kasp1vpm _s9qi1vpm _1pmm1vpm _1il01o8l _pnatglyw _18csplmo",
                                                            buttonClassNameBuilder
                                                        ]),
                                                        id: "customer-story-modal-component-parent",
                                                        children: [
                                                            localizedMap[filterKey],
                                                            " ",
                                                            $58c466831834e47a$var$filterDropDownArrowSVG,
                                                            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                                className: (0, $esG4f.default)([
                                                                    "_1e0cglyw _ae4v1h6o _bfhkshej _2rko1ssb _ahbqftgi _syazqlpt _1bsbgktf _4t3igktf _k48pni7l"
                                                                ]),
                                                                children: numFiltersActive
                                                            })
                                                        ]
                                                    })),
                                                    filterModal
                                                ]
                                            }, index);
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                            id: "customer-story-modal-component-parent",
                                            className: (0, $esG4f.default)([
                                                "_1e0cglyw _1mjb1ule"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $loA2J.jsxs)("button", {
                                                    id: "more filters",
                                                    onClick: (ev)=>filterButtonClickWrapper(ev, "more filters"),
                                                    className: (0, $esG4f.default)([
                                                        "_80omtlke _1e0c1txw _1bah1h6o _4cvr1h6o _11q7glyw _19itglyw _2rko53f4 _4t3i1ylp _1bsb1osq _syazqlpt _ca0qftgi _u5f37vkz _n3tdftgi _19bv7vkz _zulpftgi _irr317fj",
                                                        totalNumberOfActiveFilters && "_ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _bfhk1vpm _3smh1vpm _irr31vpm"
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                                                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/customer-story-filter-icon-3367749555.webp",
                                                            alt: "Filter icon",
                                                            className: (0, $esG4f.default)([
                                                                "_1bsb1tcg _4t3i1tcg"
                                                            ])
                                                        }),
                                                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                            className: (0, $esG4f.default)([
                                                                "_1e0c1o8l",
                                                                totalNumberOfActiveFilters && "_1e0cglyw"
                                                            ]),
                                                            children: intl.formatMessage({
                                                                id: "CustomersLandingPage.button.filters",
                                                                defaultMessage: "Filters"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                            className: (0, $esG4f.default)([
                                                                "_1e0cglyw _1bah1h6o _4cvr1h6o _bfhkshej _2rko1ssb _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazqlpt _1bsb1tcg _4t3i1tcg _k48pni7l",
                                                                totalNumberOfActiveFilters && "_1e0c1txw"
                                                            ]),
                                                            children: totalNumberOfActiveFilters
                                                        })
                                                    ]
                                                }),
                                                getFilterModal(showModal, "more filters")
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1e0c1txw _1n261q9c _p12f1jax _i0dlmko7 _1bahesu3 _8fz61w8u _1a8l1w8u _o5kcesu3"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8hLLi.CustomerStorySearchBar), {
                                        searchStringValue: searchStringValue,
                                        setSearchString: setSearchString,
                                        runSearch: ()=>runSearchWithFilters(filterObject, searchStringValue),
                                        searchInputFieldFocused: searchInputFieldFocused,
                                        setSearchInputFieldFocused: setSearchInputFieldFocused,
                                        clearSearchField: clearSearchField
                                    })
                                })
                            ]
                        })
                    }),
                    hasFilterSearchRun && /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _1n261q9c _1bsbzqdx _p12f1osq _19pkqslr _2hwx1wug _otyridpf _18u01wug _1bah1y6m _4cvr1h6o _4t3i1f4h _y3gn1e5h"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("h5", {
                                    className: (0, $esG4f.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _12l27vkz _1wybgktf _k48p1fw0 _syazqlpt"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "CustomersLandingPage.numberOfResults",
                                        defaultMessage: "<numberOfCustomerStories></numberOfCustomerStories> results",
                                        values: {
                                            numberOfCustomerStories: ()=>numberOfCustomerStoriesByCommittedValues
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                    type: "button",
                                    onClick: clearAllFilterButtonClickHandler,
                                    className: (0, $esG4f.default)([
                                        "_4bfu1r31 _1hms8stv _ajmmnqa1 _ect48q0o _80omtlke _syazoelr _1wybdlk8 _11q7glyw _19itidpf"
                                    ]),
                                    children: intl.formatMessage({
                                        id: "CustomersLandingPage.clear",
                                        defaultMessage: "Clear"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $58c466831834e47a$var$filterDropDownArrowSVG = /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
    width: "10",
    height: "6",
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "customer-story-filter-dropdown-arrow",
    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
        d: "M9 1.18164L5 4.818L1 1.18164",
        stroke: "#101214",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })
});
const $58c466831834e47a$var$customerStoriesSectionContainerStyle = null;
const $58c466831834e47a$var$customerStoriesFilterContainerStyle = null;
const $58c466831834e47a$var$filterButtonContainerStyle = null;
const $58c466831834e47a$var$mobileFilterButtonContainerStyles = null;
const $58c466831834e47a$var$mobileFilterButtonStyles = null;
const $58c466831834e47a$var$mobileFilterButtonActiveStyles = null;
const $58c466831834e47a$var$mobileFilterButtonImgStyles = null;
const $58c466831834e47a$var$mobileFilterButtonTextStyles = null;
const $58c466831834e47a$var$mobileFilterInnerStyles = null;
const $58c466831834e47a$var$mobileFilterHiddenStyles = null;
const $58c466831834e47a$var$mobileFilterButtonTextActiveStyles = null;
const $58c466831834e47a$var$filterButtonStyles = null;
const $58c466831834e47a$var$filterButtonCountStyles = null;
const $58c466831834e47a$var$searchButtonContainerStyle = null;
const $58c466831834e47a$var$filterResultStyle = null;
const $58c466831834e47a$var$filterResultLabelStyle = null;
const $58c466831834e47a$var$filterClearStyle = null;

});

parcelRegister("53agj", function(module, exports) {

$parcel$export(module.exports, "GlobalStatsSection", function () { return $2ee0ece93609ec33$export$844b01b63b4da82f; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $5ohHq = parcelRequire("5ohHq");

var $2p5f0 = parcelRequire("2p5f0");
const $2ee0ece93609ec33$export$844b01b63b4da82f = ()=>{
    const intl = (0, $f6qj2.default)();
    const statsProps = {
        headerText: intl.formatMessage({
            id: "CustomersLandingPage.stats.header",
            defaultMessage: "Teams across the globe run on Atlassian"
        }),
        bigStat: {
            stat: "300000",
            statText: intl.formatMessage({
                id: "CustomersLandingPage.numberOfCustomersTxt",
                defaultMessage: "companies power team collaboration with Atlassian"
            }),
            statColor: (0, $5ohHq.wacToken)("color.primary.blue"),
            statSymbol: {
                symbolCharacter: "+",
                symbolCharacterColor: (0, $5ohHq.wacToken)("color.primary.blue")
            }
        },
        littleStats: [
            {
                stat: "200",
                statText: intl.formatMessage({
                    id: "CustomersLandingPage.numberOfCountriesTxt",
                    defaultMessage: "countries and territories have companies that use Atlassian"
                }),
                statColor: (0, $5ohHq.wacToken)("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: "+",
                    symbolCharacterColor: (0, $5ohHq.wacToken)("color.primary.blue")
                }
            },
            {
                stat: "80",
                statText: intl.formatMessage({
                    id: "CustomersLandingPage.fortune500CompaniesTxt",
                    defaultMessage: "of Fortune 500 companies use Atlassian products"
                }),
                statColor: (0, $5ohHq.wacToken)("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: "%",
                    symbolCharacterColor: (0, $5ohHq.wacToken)("color.primary.blue")
                }
            }
        ]
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "customers-page-stats",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2p5f0.Stats), (0, $7Knp0._)({}, statsProps))
        })
    });
};

});
parcelRegister("2p5f0", function(module, exports) {

$parcel$export(module.exports, "Stats", function () { return $4cd1e849e8192d3a$export$3cdec2bba15e3523; });
/* stats.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $eDoPe = parcelRequire("eDoPe");

var $fxdfZ = parcelRequire("fxdfZ");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $4cd1e849e8192d3a$var$earthStyles = null;
const $4cd1e849e8192d3a$export$cc52242338d2406f = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqswstnw _1e02idpf _152txard _bna71wug _rtys1osq _t9ec1u9r _1h1t1ekt _tnru1wug _1rfm12eq _xaejlc6t _1eg616tw _95u51a2f"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/435e558616x6e3c2jvth65jiq2vusf20.webp",
                alt: "",
                width: 700,
                height: 700
            }
        })
    });
};
const $4cd1e849e8192d3a$var$easeOutQuad = (t)=>t * (2 - t);
const $4cd1e849e8192d3a$var$frameDuration = 1000 / 60;
const $4cd1e849e8192d3a$var$AnimateCount = ({ children: children = "0", duration: duration = 2000 })=>{
    const countTo = parseInt(children, 10);
    const [count, setCount] = (0, $iSvIT.useState)(0);
    (0, $iSvIT.useEffect)(()=>{
        let frame = 0;
        const totalFrames = Math.round(duration / $4cd1e849e8192d3a$var$frameDuration);
        const counter = setInterval(()=>{
            frame++;
            const progress = $4cd1e849e8192d3a$var$easeOutQuad(frame / totalFrames);
            setCount(countTo * progress);
            if (frame === totalFrames) clearInterval(counter);
        }, $4cd1e849e8192d3a$var$frameDuration);
        return ()=>clearInterval(counter);
    }, [
        countTo,
        duration
    ]);
    return Math.floor(count).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
const $4cd1e849e8192d3a$export$3cdec2bba15e3523 = (statsProps)=>{
    var _statsProps_bigStat_statSymbol, _statsProps_bigStat_statSymbol1;
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        ref: scrollRef,
        className: (0, $esG4f.default)([
            "_p12f1git _19pkidpf _2hwx1wug _otyridpf _18u01wug _kqswh2mm _1pbykb7n _ca0qymf6 _u5f3idpf _n3td53f4 _19bvidpf _1reo15vq _18m915vq _11q71rga _mkrz13pj _1vth1g58 _1kmxidpf _1ggmidpf _1ykzidpf _1maeidpf _srwz1ylp"
        ]),
        style: {
            "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1q51gktf _85i5gktf _1gde1bp4",
                    "wrapper"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1q511ul9 _p12f1osq _1e0c1txw _4cvr1y6m _zulp1ylp _kqswh2mm _1t19idpf _p7vbidpf _1rhg1w8u _19wggktf _1gde1bp4 _1u2q1wqb",
                            "text-wrapper"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_16jlkb7n _1o9zkb7n _i0dl1ssb _1fe7kb7n _12ihkb7n _1a1xf1ug _1rfm1osq",
                                    "fifty"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                        className: (0, $esG4f.default)([
                                            "_1wyb8pqr _vwz4cjiy _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: statsProps.headerText
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                                        className: (0, $esG4f.default)([
                                            "_ect4qlpn _vwz4zg3v _k48p53lb _19pk19bv _2hwxidpf _otyrftgi _18u0idpf _kqswh2mm _syaz17la",
                                            "_1wyb1qf2 _g4miqd8k _1lzo1bc9",
                                            "big-stat"
                                        ]),
                                        style: {
                                            "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display")),
                                            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                                                className: (0, $esG4f.default)([
                                                    "_syaz1bjw",
                                                    "big-stat"
                                                ]),
                                                style: {
                                                    "--_1shjtka": (0, $43MIc.default)(statsProps.bigStat.statColor ? statsProps.bigStat.statColor : (0, $5ohHq.wacToken)("color.primary.black"))
                                                },
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $fxdfZ.default), {
                                                        fallback: null,
                                                        children: sectionIsVisible ? /*#__PURE__*/ (0, $loA2J.jsx)($4cd1e849e8192d3a$var$AnimateCount, {
                                                            children: statsProps.bigStat.stat
                                                        }) : statsProps.bigStat.stat
                                                    })
                                                ]
                                            }),
                                            statsProps.bigStat.statSymbol && /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                className: (0, $esG4f.default)([
                                                    "_syaz1y4s"
                                                ]),
                                                style: {
                                                    "--_1bnfnau": (0, $43MIc.default)(((_statsProps_bigStat_statSymbol = statsProps.bigStat.statSymbol) === null || _statsProps_bigStat_statSymbol === void 0 ? void 0 : _statsProps_bigStat_statSymbol.symbolCharacterColor) ? statsProps.bigStat.statSymbol.symbolCharacterColor : (0, $5ohHq.wacToken)("color.primary.black"))
                                                },
                                                children: (_statsProps_bigStat_statSymbol1 = statsProps.bigStat.statSymbol) === null || _statsProps_bigStat_statSymbol1 === void 0 ? void 0 : _statsProps_bigStat_statSymbol1.symbolCharacter
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        className: (0, $esG4f.default)([
                                            "_1wyb1j6v _k48pl8b6 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: statsProps.bigStat.statText
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_16jlkb7n _1o9zkb7n _i0dl1r5k _1e0c1txw _zulpgktf _2lx21bp4 _y4ti1ylp _1fe7kb7n _12ihkb7n _1a1xf1ug _chtuidpf",
                                    "thirty"
                                ]),
                                children: statsProps.littleStats.map((statObj, index)=>{
                                    var _statObj_statSymbol, _statObj_statSymbol1;
                                    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_kqswh2mm _bozggktf",
                                            "stat-wrapper"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_kqswstnw _4t3i1osq _11q71hlo _1bsbyh40 _1e02idpf"
                                                ]),
                                                style: {
                                                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                className: (0, $esG4f.default)([
                                                    "_ect4qlpn _vwz4zg3v _k48p53lb _19pk19bv _2hwxidpf _otyrftgi _18u0idpf _kqswh2mm _syaz17la",
                                                    "_1wybxxch",
                                                    "little-stat"
                                                ]),
                                                style: {
                                                    "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display")),
                                                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                                                },
                                                children: /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                                                    className: (0, $esG4f.default)([
                                                        "_syazoodi"
                                                    ]),
                                                    style: {
                                                        "--_11wxpl2": (0, $43MIc.default)(statObj.statColor ? statObj.statColor : (0, $5ohHq.wacToken)("color.primary.black"))
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $fxdfZ.default), {
                                                            fallback: null,
                                                            children: sectionIsVisible ? /*#__PURE__*/ (0, $loA2J.jsx)($4cd1e849e8192d3a$var$AnimateCount, {
                                                                children: statObj.stat
                                                            }) : statObj.stat
                                                        }),
                                                        statObj.statSymbol && /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                            className: (0, $esG4f.default)([
                                                                "_syaz16k1"
                                                            ]),
                                                            style: {
                                                                "--_1nxvphm": (0, $43MIc.default)(((_statObj_statSymbol = statObj.statSymbol) === null || _statObj_statSymbol === void 0 ? void 0 : _statObj_statSymbol.symbolCharacterColor) ? statObj.statSymbol.symbolCharacterColor : (0, $5ohHq.wacToken)("color.primary.black"))
                                                            },
                                                            children: (_statObj_statSymbol1 = statObj.statSymbol) === null || _statObj_statSymbol1 === void 0 ? void 0 : _statObj_statSymbol1.symbolCharacter
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                className: (0, $esG4f.default)([
                                                    "_1wyb1j6v _k48pl8b6 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                                ]),
                                                children: statObj.statText
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1h1tgbua _kqswh2mm _rjxpidpf _u7coidpf _152tidpf _4t3i1osq _1e0c1txw _1bah1h6o _mmgkgktf _1rfm1osq _tnru68cl _srwzidpf _476d1ylp _1t06idpf _1jc21gwv _10jx1gwv",
                            "earth-contents"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)($4cd1e849e8192d3a$export$cc52242338d2406f, {}),
                            /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                                className: (0, $esG4f.default)([
                                    "_kqswstnw _152tidpf _1o2w1n0t _rjxp3ll0 _p5ce1x96 _1l7d176h _xaej15qf _1rfm68cl _tnru1wug",
                                    "blob"
                                ]),
                                width: "102",
                                height: "95",
                                "aria-hidden": "true",
                                viewBox: "0 0 102 95",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M97.6377 58.2134C98.2297 54.8868 98.5329 51.356 98.5329 47.6063C98.5329 43.8566 98.2152 40.2236 97.6233 36.8533C94.057 16.8063 80.2829 4.44834 60.9645 1.28226C57.6726 0.742421 54.2074 0.46521 50.6123 0.46521C47.0172 0.46521 43.2632 0.771614 39.8414 1.34063C20.5085 4.60885 6.74887 16.923 3.18262 36.8533C2.57621 40.2236 2.27301 43.7982 2.27301 47.6063C2.27301 51.4143 2.57621 54.8868 3.16818 58.2134C6.70555 78.1144 20.4797 90.4578 39.8414 93.726C43.2632 94.3096 46.8728 94.6014 50.6123 94.6014C54.3518 94.6014 57.6726 94.3242 60.9645 93.7844C80.3118 90.6037 94.1148 78.2312 97.6521 58.2134H97.6377Z",
                                        fill: "#FCA700"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                                className: (0, $esG4f.default)([
                                    "_1bsbutna _4t3i1wug _kqswstnw _1e021nh5 _u7co1228 _sugaglyw",
                                    "lightning"
                                ]),
                                width: "131",
                                height: "139",
                                "aria-hidden": "true",
                                viewBox: "0 0 131 139",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M20.4793 61.2896C11.5228 63.9778 10.6462 63.8696 8.14861 74.6224C5.48565 77.7767 3.98043 82.2375 2.50009 87.7471C1.52422 89.9276 8.05758 89.112 4.36913 89.8361C6.75918 90.66 13.6813 90.2023 14.4338 91.2343C10.9604 99.0243 8.42147 107.638 6.13066 115.911C6.18028 130.151 27.1036 98.5582 29.5102 96.5941C30.7176 93.1152 44.2806 78.484 38.1442 78.1761C29.196 76.6947 23.4234 81.4636 30.1387 69.8369C30.2793 69.3875 33.3061 62.3049 32.6197 60.1909C28.0133 62.1883 27.0788 70.1864 24.2752 74.5474C19.5778 80.881 28.6253 81.9463 32.6114 81.3554C32.5618 82.2875 36.1345 80.7562 35.2909 82.7037C30.1718 90.2606 12.9866 112.723 13.028 112.765C11.7296 115.611 9.81084 116.752 9.33117 115.861C9.04172 115.328 18.2546 92.6159 19.5117 89.6947C20.5289 86.1243 14.2436 86.9482 14.2436 86.9482C14.2436 86.9482 14.897 87.2727 16.7578 87.3226C14.8143 87.8969 9.87707 87.1396 6.51115 86.8733C7.08179 81.7382 13.7061 65.3676 13.7061 65.3676C13.7061 65.3676 27.7817 64.2191 31.3378 59.9662C28.7245 59.7415 24.3001 61.0649 20.471 61.2979L20.4793 61.2896Z",
                                        fill: "#101214"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M128.71 53.5661L129.636 51.8599C129.934 51.294 130.314 50.7031 130.413 50.1954C130.537 49.6877 130.521 49.2633 130.488 48.9138C130.48 48.8139 130.488 48.7556 130.438 48.6391C130.397 48.5225 130.306 48.3894 130.248 48.3395C130.116 48.2313 129.983 48.1147 129.818 47.9982C129.487 47.7735 129.065 47.5322 128.47 47.424C127.858 47.3408 127.205 47.2908 126.576 47.2159C123.392 46.8913 120.216 46.5667 117.082 46.2505C114.138 45.9425 111.227 45.6346 108.341 45.335C105.76 45.052 103.205 44.7774 100.691 44.5027C100.492 44.4528 100.178 44.5193 100.137 44.253C100.153 44.0283 100.31 43.8369 100.393 43.6455C100.972 42.3971 101.543 41.1571 102.113 39.9336C103.395 37.1955 104.644 34.5239 105.86 31.9189C108.316 26.7256 110.689 21.8236 112.972 17.2878L112.699 17.5541C112.889 17.2295 113.303 16.1393 113.576 15.9479C113.923 14.9075 114.436 13.4843 115.039 11.9113C115.345 11.129 115.66 10.3051 115.982 9.47285L116.47 8.22446C116.76 7.53368 117.041 6.85116 117.322 6.17702C117.653 5.36141 117.702 4.6707 117.653 4.06315C117.587 3.43063 117.347 2.78144 116.958 2.27376C116.189 1.21679 114.948 0.800607 114.088 0.867188C113.063 1.14183 112.219 1.35825 111.632 1.51638C111.326 1.63289 111.086 1.7245 110.913 1.78276C110.789 1.82437 110.731 1.8493 110.731 1.8493C106.794 3.33905 102.626 4.49591 98.4578 5.61114C98.4578 5.61114 97.0768 5.87744 94.8769 6.31021C93.7687 6.5266 92.462 6.78464 91.0065 7.07593C90.2787 7.22574 89.5096 7.39216 88.7157 7.55861C88.3187 7.64184 87.9052 7.74169 87.4834 7.84988C87.0865 7.94975 86.6896 8.05795 86.2843 8.16614C83.0673 8.99008 79.4202 9.78077 76.1535 11.1124C74.5243 11.7699 73.0026 12.5771 71.729 13.4843C70.4472 14.3915 69.4216 15.4152 68.6939 16.3473C66.6181 18.4696 65.0798 21.008 63.8228 23.613C62.5575 26.2263 61.5733 28.9228 60.5974 31.5943C59.6464 34.2826 58.6292 36.8626 57.5458 39.5008L54.3536 47.3907C54.3536 47.3907 49.4163 60.7236 48.4156 64.9348C48.0931 66.2831 47.8864 67.4066 47.7871 68.2472C48.1841 68.2139 48.7382 68.1889 49.4328 68.1806C50.6899 65.9085 52.6582 61.3311 55.4452 53.7408C55.5527 53.5993 55.8008 53.1084 55.8918 53.0668C57.0744 49.6378 58.3315 46.2838 59.6465 42.9547C60.3163 41.2985 60.9862 39.6424 61.656 37.9862C62.3507 36.2967 62.9958 34.5821 63.6243 32.9176C64.8896 29.5886 66.1467 26.3178 67.7842 23.4132C68.6029 21.9651 69.5126 20.6085 70.5546 19.4267C71.5967 18.2365 72.7297 17.2711 74.086 16.4389C73.8213 16.3224 74.086 15.9145 74.4995 15.8479L74.5243 16.1808C76.3189 14.999 78.2789 14.2666 80.181 13.6924C82.0914 13.1181 83.9853 12.7103 85.8874 12.2609L87.3181 11.9113L88.7157 11.5452C89.6254 11.3205 90.5352 11.0957 91.4697 10.871C93.3801 10.3966 95.3814 9.84733 97.5233 9.11493C97.5068 9.12326 96.6053 9.71416 96.5888 9.7308C100.037 8.97344 103.627 8.15785 107.398 7.15081C108.341 6.88448 109.292 6.62649 110.259 6.32688C110.739 6.18539 111.227 6.03554 111.715 5.86909L112.145 5.72767L112.236 5.69435C112.352 5.64441 112.509 5.57783 112.616 5.69435C112.732 5.80254 112.658 5.96065 112.6 6.08549C109.813 12.3025 106.877 18.869 103.883 25.5521C102.32 29.0476 100.74 32.5681 99.1691 36.0969C98.3834 37.8613 97.5978 39.6257 96.8121 41.3818L95.8527 43.5206C95.6625 43.9284 95.4971 44.3446 95.431 44.7275C95.3648 45.1103 95.3649 45.4515 95.3897 45.7595C95.4145 46.3587 95.828 47.1993 96.3408 47.6321C96.5806 47.8484 96.837 47.9983 97.1595 48.1647C97.4903 48.3145 97.879 48.4394 98.3173 48.4893C105.239 49.1801 111.988 49.8542 118.521 50.5117C120.068 50.6615 121.598 50.8113 123.119 50.9528L124.252 51.061L124.74 51.1026H124.839L125.269 51.1275C125.327 51.1442 125.451 51.0943 125.46 51.1858L125.377 51.3689L125.195 51.76C124.906 52.3177 124.608 52.867 124.318 53.4246C123.979 54.0654 123.648 54.7063 123.293 55.3305L123.417 55.2056V55.2888C123.649 54.9726 123.963 54.5066 124.327 53.9073C124.674 53.3497 125.087 52.6838 125.534 51.9515C125.724 51.6851 125.956 51.3606 126.212 50.9778C126.262 50.8779 126.378 50.7947 126.378 50.6782C126.328 50.5866 126.204 50.6199 126.121 50.5783C125.915 50.5367 125.716 50.4951 125.517 50.4618C125.294 50.4202 125.071 50.3785 124.864 50.3369C124.393 50.2703 123.938 50.2038 123.5 50.1455C122.59 50.0207 121.763 49.9041 121.052 49.8126C119.638 49.6212 118.72 49.4963 118.72 49.4963C120.109 49.4547 121.523 49.463 122.946 49.5046C123.64 49.5379 124.343 49.5629 125.046 49.5962C125.592 49.6212 126.163 49.6544 126.742 49.6961L127.618 49.7709C127.693 49.7792 127.767 49.771 127.833 49.7959C127.899 49.8209 127.949 49.8958 127.932 49.9707C127.874 50.1038 127.8 50.2287 127.734 50.3536C127.453 50.8613 127.172 51.3772 126.882 51.8932C126.551 52.4758 126.212 53.0667 125.873 53.6493C125.501 54.2985 125.129 54.9476 124.732 55.5884C123.136 58.1352 121.564 60.7152 119.886 63.212C119.067 64.477 118.248 65.7338 117.438 66.9822C116.611 68.2222 115.8 69.4623 115.023 70.7107L114.742 70.4277C117.512 66.1749 119.629 62.1717 120.44 60.5571C115.593 68.2639 108.068 79.6908 99.8224 90.4602C95.7453 95.8783 91.4531 101.105 87.5 105.816C85.5069 108.154 83.6213 110.393 81.8185 112.399C80.9253 113.414 80.0735 114.388 79.263 115.312C78.4443 116.227 77.6669 117.093 76.9391 117.9C77.2037 117.842 78.1548 116.718 79.2382 115.578C80.3133 114.429 81.4959 113.223 82.3229 113.056C81.5786 113.888 80.8261 114.721 80.0818 115.545C79.3292 116.36 78.5684 117.176 77.8241 117.983C77.0715 118.79 76.3271 119.589 75.5911 120.38C74.8468 121.162 74.086 121.92 73.3416 122.661C72.8951 122.211 74.7641 120.646 75.0205 120.222C74.3093 120.788 72.1094 122.952 68.7187 126.114C67.0151 127.687 65.055 129.552 62.789 131.541C62.5161 131.782 62.2432 132.024 61.9703 132.273L61.7718 132.44C61.6312 132.531 61.532 132.681 61.3666 132.714C61.2012 132.739 61.0275 132.631 60.9614 132.465C60.8869 132.29 60.9944 132.115 61.0358 131.948C61.6395 129.901 62.268 127.754 62.9131 125.54C63.6822 122.96 64.4927 120.305 65.3446 117.6C67.0482 112.191 68.9006 106.573 70.8606 100.963C72.8124 95.3539 74.8716 89.7445 76.9474 84.3348C77.9811 81.63 79.0232 78.975 80.0569 76.395L80.4374 75.4296L80.6276 74.9469C80.6607 74.8636 80.6938 74.8054 80.7186 74.6889L80.8013 74.3227C81.0246 73.3406 81.2479 72.3668 81.4712 71.4014C81.5787 70.9187 81.6944 70.436 81.8019 69.9616L81.9674 69.2459L82.0501 68.8881C82.0583 68.8298 82.0914 68.7632 82.0832 68.7216C82.0584 68.6633 82.0087 68.6633 81.9591 68.6384C81.2313 68.3471 80.5036 68.0557 79.7841 67.7644C77.7 67.8477 75.6656 67.9226 73.6807 67.9975C72.2418 68.0391 70.8359 68.0724 69.4796 68.1057C66.767 68.1639 64.2198 68.1889 61.8959 68.1889C57.2398 68.1723 53.4522 68.164 50.8719 68.1557C50.3426 68.1557 49.8794 68.1557 49.4494 68.1557C49.2757 68.4719 49.1186 68.7382 48.9698 68.9629C49.8216 69.1128 50.9545 69.2792 52.4266 69.4789L51.5086 69.7619C56.082 70.0698 60.2584 70.253 64.501 70.4194C66.6181 70.4943 68.7517 70.5692 70.9516 70.6525C72.0515 70.6858 73.168 70.7274 74.3093 70.769C74.8799 70.7856 75.4588 70.8106 76.0377 70.8272C76.4512 70.8522 76.8647 70.8771 77.2865 70.9021C77.394 70.8938 77.4932 70.8855 77.5759 70.8772C78.2706 70.8189 78.3451 70.8355 78.6759 70.5276C79.0067 70.461 79.6517 70.3445 79.7261 70.203C79.8502 70.1031 79.9991 70.0116 80.1645 69.9367C80.2141 69.9201 80.3299 69.8785 80.3299 69.9367C80.3299 69.97 80.3299 70.0199 80.3216 70.0781C80.2803 70.3029 80.1645 70.6857 80.0074 71.1268C79.6931 72.0173 79.2217 73.0743 78.9819 73.7235C78.1549 72.5416 75.2273 79.3828 72.5809 87.1395C69.8931 94.8712 67.5443 103.469 66.8331 105.433C65.452 105.832 64.2198 113.214 63.0289 115.461C63.0372 115.278 63.1116 114.13 63.1281 113.98C62.7891 114.463 61.9538 117.026 60.9945 120.48C60.5148 122.203 59.9937 124.15 59.4727 126.156C58.9352 128.295 58.3811 130.5 57.8518 132.606C57.703 133.255 57.6368 133.821 57.6202 134.346C57.612 134.878 57.8105 135.427 58.1744 135.844C58.8773 136.709 60.1427 136.925 60.9779 136.501C61.7553 136.06 62.4582 135.394 63.0867 134.795C63.6491 134.271 64.1453 133.813 64.5588 133.438C66.0971 132.048 66.4692 131.907 64.7408 133.987C71.4147 128.528 78.742 121.678 86.1437 113.705C93.5702 105.757 100.972 96.6024 108.035 86.79C115.081 76.961 121.688 66.3996 127.61 55.6551L128.743 53.5661H128.71Z",
                                        fill: "#101214"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $4cd1e849e8192d3a$var$wrapperStyle = null;
const $4cd1e849e8192d3a$var$earthContents = null;
const $4cd1e849e8192d3a$var$blobStyles = null;
const $4cd1e849e8192d3a$var$lightningStyles = null;
const $4cd1e849e8192d3a$var$TextWrapperStyles = null;
const $4cd1e849e8192d3a$var$fiftyStyles = null;
const $4cd1e849e8192d3a$var$h2Styles = null;
const $4cd1e849e8192d3a$var$statStyles = null;
const $4cd1e849e8192d3a$var$bigStatStyles = null;
const $4cd1e849e8192d3a$var$littleStatStyles = null;
const $4cd1e849e8192d3a$var$statTextStyles = null;
const $4cd1e849e8192d3a$var$thirtyStyles = null;
const $4cd1e849e8192d3a$var$statWrapperStyles = null;
const $4cd1e849e8192d3a$var$dividerStyles = null;
const $4cd1e849e8192d3a$var$statsStyles = null;

});


parcelRegister("iyN25", function(module, exports) {

$parcel$export(module.exports, "FutureOfTeamwork", function () { return $e40eb2275c5ec5a3$export$a40f2b95cdffc95c; });
/* future-of-teamwork.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $eDoPe = parcelRequire("eDoPe");

var $dFnC9 = parcelRequire("dFnC9");

var $dyZbY = parcelRequire("dyZbY");

var $91nJf = parcelRequire("91nJf");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $e40eb2275c5ec5a3$export$a40f2b95cdffc95c = ()=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "customers-page-futureOfTeamwork",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
            ref: scrollRef,
            className: (0, $esG4f.default)([
                "_kqswh2mm _1reo15vq _18m915vq _y3gn1h6o _ca0q53f4 _u5f3idpf _n3td53f4 _19bvidpf _p12f1git _19pk1wqb _2hwx1wug _otyridpf _18u01wug _gtagoshw _1k3j12qd _mzmgihc0 _1kmx11ux _1ggmidpf _1ykz1wqb _1maeidpf _dqkyoza4 _1n46idpf _if5yidpf _1gnpidpf _7e5bidpf _w77hr5sb _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _2trp1nn1",
                sectionIsVisible ? "is-visible" : ""
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                layout: "8",
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1txw _2lx21bp4 _4cvr1h6o _zulpzwfg _p12f1oh5 _kqswh2mm _11wmstnw _tf4iidpf _mp8c15ko _98ph1e0x _7xg24bvh _1oli1wte _19zd183y _1fqc5gyx _1r4k11ux _ynmi101a _r7byckbl _1i6qljo4 _3iilglyw",
                        "content-wrapper"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                            width: "93",
                            height: "91",
                            viewBox: "0 0 93 91",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "big-star",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                                id: "Gestural Line/star 1",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                    id: "star 1",
                                    d: "M63.1582 46.7878C65.7082 46.5678 99.8282 38.3178 90.8782 36.5278C87.5582 37.4578 84.9782 36.5178 83.3182 39.0378C82.8382 36.0678 76.3282 40.8078 75.3282 40.9878C74.8782 38.7378 64.6782 44.5278 66.1682 42.4378C61.5382 42.4978 55.7882 44.1177 49.8082 46.0177C46.8782 44.0277 59.4382 29.8278 54.1582 32.8978C54.5282 32.0978 55.9482 28.6378 55.7582 30.9278C57.4282 28.9678 75.6082 -1.03222 68.0482 4.04778C62.9482 10.2378 59.1182 20.6078 54.7982 25.7278C50.5982 27.4578 47.6882 42.3178 43.0082 40.8378C40.2782 37.4978 33.2382 -3.40217 28.2382 0.227831C29.1082 3.40783 28.3182 6.25777 30.7482 7.78777C27.7782 8.26777 32.5182 14.7778 32.6982 15.7778C30.4982 16.1978 36.1982 26.4378 34.1482 24.9378C34.1882 27.8278 34.8382 31.1678 35.7782 34.7178C34.5282 33.7678 33.1582 31.5978 32.3682 31.2778C23.9482 27.8678 17.5682 20.0278 8.7982 15.7778C1.4282 25.1678 66.5982 48.8577 26.1882 52.3978C18.5882 57.3577 8.48819 58.1177 0.00819142 62.8877C-0.721809 73.2177 47.6182 44.7178 33.6682 61.0878C31.4982 68.0078 28.2782 75.7778 23.8282 82.5978C20.9882 108.608 45.1382 37.9478 44.1382 64.9078C47.4682 71.3478 50.6882 79.1078 52.3382 87.0978C64.1482 104.418 48.0282 58.5978 46.3382 52.1078C52.7382 49.3778 77.4782 80.3378 81.9582 75.4578C82.1682 74.7678 78.6082 70.9378 77.5282 70.5278C76.7982 70.8978 76.4282 71.1977 75.9982 70.5177C78.1682 68.4277 70.5582 65.7878 69.8382 65.0678C71.4382 63.4778 60.8482 58.3077 63.4182 58.3877C61.4382 55.6177 58.4082 52.8277 54.9582 50.0177C61.0782 48.8377 63.7382 44.5177 63.1782 46.7677L63.1582 46.7878Z",
                                    fill: "#FCA700"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                            width: "49",
                            height: "51",
                            viewBox: "0 0 49 51",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "sm-star",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                                id: "Gestural Line/star 3",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                    id: "Vector",
                                    d: "M47.4104 41.8537C47.4404 41.8037 47.4404 41.7137 47.5004 41.6437C45.7504 40.7637 45.5504 38.6038 44.2005 37.3138L44.1504 37.2637C42.7804 36.8237 43.1505 35.4538 41.4505 35.4438C41.4505 35.4438 41.8904 35.2237 41.9004 35.2237C39.1404 32.4837 32.3204 25.7537 32.3204 25.7537C32.1704 26.3637 33.4104 25.3037 34.6604 25.4837C34.6604 25.4837 34.7503 25.2538 34.8403 25.4338C38.0303 22.3238 41.6205 21.1338 45.7005 19.6538C47.7405 19.1038 48.0504 13.3337 44.5604 15.7237C44.5204 15.6837 44.4304 15.6538 44.3904 15.5838C43.1704 17.0038 41.1404 16.4837 39.6004 17.2237L39.5404 17.2537L36.9804 18.5037C35.5904 19.0737 33.9403 19.5238 32.2103 19.9638C32.2603 19.9138 32.3104 19.8638 32.3604 19.8138C32.3604 19.8138 32.5404 17.0438 32.4904 15.6738C32.4904 15.6738 34.2404 13.4738 33.6604 11.9638C34.6504 10.1938 38.1703 6.3237 34.9703 5.2237C33.9203 5.2237 33.1004 4.31373 32.7404 6.00373C32.6804 5.99373 32.6004 6.01371 32.5204 5.98371C32.3304 7.73371 30.2604 8.97374 29.6904 10.6337L29.6704 10.7038C29.8104 12.1238 28.7105 13.5238 28.7005 13.5238C28.1805 14.8238 27.5004 16.2437 26.7804 17.7237C26.4804 16.9237 26.1504 16.2138 25.8204 15.7038C24.6204 14.4038 25.1304 -3.35621 20.6904 0.56379C20.9004 3.91379 21.9604 7.40374 21.1004 10.3837C20.6804 10.6137 21.3203 11.8038 21.8403 12.7738C21.8003 14.0037 21.5504 14.6638 21.4804 16.4238C19.2804 14.8338 9.6804 6.7838 10.2704 12.2038C11.3004 12.7538 12.0503 13.3838 12.5903 14.6638C13.0903 15.2138 17.5004 17.6938 17.6404 18.3138C17.3504 19.1738 22.5605 19.8637 20.4505 20.5037C20.7605 21.1837 21.1804 21.8338 21.6704 22.4638C19.3904 22.7038 16.6604 23.3737 15.2304 24.2437C14.9804 24.6737 5.88033 25.2537 2.58033 27.3837C0.610334 28.4937 -1.12958 29.0438 0.920422 30.7138C1.66042 30.1138 4.44038 30.9738 4.38038 30.1838C5.06038 30.4638 9.66042 28.7037 10.1704 29.0037C10.4204 29.4037 14.0404 27.2838 13.6104 28.2838C16.1204 28.9938 19.1804 28.4137 22.3604 27.6037C21.1004 29.6037 19.8605 32.4537 19.7005 34.2237C18.6205 36.4937 15.7704 41.5138 14.8604 44.5938C13.5604 46.8338 14.0104 47.0138 15.6504 48.1638L15.6804 48.1938C16.0204 48.4238 15.6404 48.1937 16.9304 48.2437C16.8004 48.1237 16.6104 47.6038 16.3604 47.6938C16.5304 47.3438 18.4904 46.8437 17.6704 46.3737C17.6404 46.3037 18.9204 45.3237 19.0504 44.2637C20.1904 40.4837 22.9204 38.5737 24.9404 34.2637C24.8904 34.7137 28.2904 43.1838 28.1304 47.4038C27.8804 49.4838 32.9204 52.5838 32.1904 47.9438C32.2504 47.9238 32.3004 47.8438 32.3904 47.8338C31.5804 45.9238 32.6504 43.9537 32.2304 42.0137L32.2103 41.9338C31.3003 40.7538 32.3504 39.7738 30.9104 38.8138C30.9104 38.8138 31.4004 38.8637 31.4104 38.8737C30.7704 36.1237 30.3704 32.7637 29.7704 29.7537C31.9204 31.7037 33.8103 33.8037 34.5903 36.1137L34.6904 35.9638C34.6904 36.0338 34.8403 36.0837 34.7103 36.2437C36.5203 36.6237 37.1404 37.3837 38.4505 37.8937C38.4505 37.8937 39.8504 40.4237 41.4804 40.5137L43.9603 44.0238C45.0303 45.8338 50.8004 44.7937 47.4505 41.8937L47.4104 41.8537Z",
                                    fill: "#101214"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                            width: "74",
                            height: "71",
                            viewBox: "0 0 74 71",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "checkmark",
                            children: /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                id: "Gestural Line/symbol check 1",
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        id: "Vector",
                                        d: "M44.0389 33.5379C45.8049 32.3341 51.7382 25.3965 46.0606 27.0247C44.5346 28.2363 37.5403 37.5739 33.6984 42.3892C32.8541 40.4137 30.4297 38.2529 28.6559 37.1571C27.5793 36.1616 27.1455 37.8054 27.1455 37.8054C27.4476 38.2453 27.7652 38.9397 28.501 39.4954C29.3221 40.1127 29.4305 41.3937 30.7783 42.3738C35.5186 45.8078 33.3808 50.8623 37.9663 42.1036C39.5464 38.2606 43.5122 37.0105 44.0312 33.5379H44.0389Z",
                                        fill: "#82B536"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        id: "Vector_2",
                                        d: "M73.9993 33.2525C74.0381 23.2745 72.4037 7.62464 61.5132 3.92824C69.0653 14.0065 73.643 30.2429 69.4371 42.7366C65.541 62.5305 35.4644 73.635 17.3394 62.1677C19.1984 63.9272 23.4508 65.9259 26.0611 66.6976C19.1364 68.1947 3.56753 50.7699 14.5897 60.2539C-16.6875 20.4424 32.8308 -17.6327 61.3351 16.7538C53.2486 1.15796 32.2499 -4.17445 19.3146 3.41126C-43.0075 52.5834 64.6115 110.815 73.9916 33.2525H73.9993Z",
                                        fill: "#82B536"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "CustomersLandingPage.futureOfTeamworkHeader",
                                defaultMessage: "<helpUsShape>Help us shape</helpUsShape> <theFutureOfTeamwork>the future of teamwork</theFutureOfTeamwork>",
                                values: {
                                    helpUsShape: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                            className: "h1 reduced-font-weight",
                                            children: str
                                        }),
                                    theFutureOfTeamwork: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                            className: "h1",
                                            children: str
                                        })
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: ".body-lg",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "CustomersLandingPage.futureOfTeamworkParagraph",
                                defaultMessage: "At Atlassian, we believe the impossible is possible - together. Join us today to help us inspire teamwork anywhere and everywhere, worldwide."
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                            variant: "secondary",
                            color: "black",
                            href: (0, $3FBn4.useLocalizedHref)("/customers/advocacy"),
                            dataEventProps: {
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "ctaSection",
                                "data-product-key": "customers",
                                "data-label-english": "Share your story"
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "CustomersLandingPage.futureOfTeamworkButton",
                                defaultMessage: "Share your story"
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $e40eb2275c5ec5a3$var$sectionStyles = null;
const $e40eb2275c5ec5a3$var$contentWrapperStyles = null;

});





parcelRegister("cy7iU", function(module, exports) {

$parcel$export(module.exports, "EnterpriseContactThanksPage", function () { return $c9069f3d9adaf682$export$66942264c1afdb2a; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dJtkq");
var $3qqsV = parcelRequire("3qqsV");
const $c9069f3d9adaf682$export$66942264c1afdb2a = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $3qqsV.EnterpriseContactThanksPageTemplate), {});

});
parcelRegister("dJtkq", function(module, exports) {
$parcel$export(module.exports, "EnterpriseContactThanksPageTemplate", function () { return (parcelRequire("3qqsV")).EnterpriseContactThanksPageTemplate; });

var $3qqsV = parcelRequire("3qqsV");

});
parcelRegister("3qqsV", function(module, exports) {

$parcel$export(module.exports, "EnterpriseContactThanksPageTemplate", function () { return $2c1fbae734b86527$export$cb652a9a98cba1b2; });
/* enterprise-contact-thanks.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6lf9h = parcelRequire("6lf9h");

var $kex29 = parcelRequire("kex29");

var $cP0Yq = parcelRequire("cP0Yq");

var $hcYHY = parcelRequire("hcYHY");

var $6EKII = parcelRequire("6EKII");
const $2c1fbae734b86527$var$wrapperStyle = null;
const $2c1fbae734b86527$export$cb652a9a98cba1b2 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_vchhusvi _11rm1hrf _1e0c1txw _2lx21bp4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.default), {
                            isShowTryNowLink: false,
                            tryNowLinkCtaButtonColor: "light_grey",
                            productKey: "enterpriseContactThanks"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $6lf9h.ContactSalesNav), {
                        showContactSales: true
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hcYHY.default), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6EKII.default), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("6lf9h", function(module, exports) {

$parcel$export(module.exports, "ContactSalesNav", function () { return $2671f376f5f2efa4$export$98b85ca48705081; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("1ppvA");
var $foLdD = parcelRequire("foLdD");
var $jGRaW = parcelRequire("jGRaW");

var $3FBn4 = parcelRequire("3FBn4");
const $2671f376f5f2efa4$export$98b85ca48705081 = ({ showContactSales: showContactSales })=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $foLdD.ProductNavBar), {
        productHref: (0, $3FBn4.useLocalizedHref)("/enterprise"),
        productName: "enterprise",
        showFreeHrefButton: false,
        showTextWithoutLogo: true,
        showContactSalesHrefButton: showContactSales,
        freeHref: (0, $3FBn4.useLocalizedHref)("/enterprise/contact?formType=product-features"),
        ariaLabel: intl.formatMessage({
            id: "contact-sales-thanks.logo-label",
            defaultMessage: "Enterprise"
        }),
        dataProductKey: "enterpriseContactSales",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jGRaW.ProductNavLink), {
                label: intl.formatMessage({
                    id: "contact-sales.navbar.overview",
                    defaultMessage: "Overview"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/enterprise")
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jGRaW.ProductNavLink), {
                label: intl.formatMessage({
                    id: "contact-sales.navbar.cloud",
                    defaultMessage: "Cloud"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/enterprise/cloud")
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jGRaW.ProductNavLink), {
                label: intl.formatMessage({
                    id: "contact-sales.navbar.data-center",
                    defaultMessage: "Data Center"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/enterprise/data-center")
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jGRaW.ProductNavLink), {
                label: intl.formatMessage({
                    id: "contact-sales.navbar.services",
                    defaultMessage: "Services"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/enterprise/services")
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jGRaW.ProductNavLink), {
                label: intl.formatMessage({
                    id: "contact-sales.navbar.resources",
                    defaultMessage: "Resources"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/enterprise/resources")
            })
        ]
    });
};
$2671f376f5f2efa4$export$98b85ca48705081.displayName = "ContactSalesNav";

});

parcelRegister("hcYHY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d878a82f08dbe522$export$2e2bcd8739ae039; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");
const $d878a82f08dbe522$var$outerWrapperStyle = null;
const $d878a82f08dbe522$var$rowWrapperStyle = null;
const $d878a82f08dbe522$var$columnStyle = null;
const $d878a82f08dbe522$var$headerTextStyle = null;
const $d878a82f08dbe522$var$descriptionTextSytle = null;
const $d878a82f08dbe522$var$imageStyle = null;
const $d878a82f08dbe522$export$6e76f8357f41ff9b = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("img", {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Ticket_created@2x_1.webp",
        alt: "Ticket",
        className: (0, $esG4f.default)([
            "_vchhusvi _1e0c1nu9 _y3gn1h6o _4t3i1qnl _6rth7vkz _p12f1osq _1reozryt _18m9zryt _1bsb1178 _1b3h1ntv _wii51fhb _1rx61osq"
        ])
    });
};
const $d878a82f08dbe522$var$Hero = ()=>{
    const intl = (0, $f6qj2.default)();
    const headerText = intl.formatMessage({
        id: "enterpriseContactThanksPage.message-recieved",
        defaultMessage: "Message received"
    });
    const descriptionTicketText = intl.formatMessage({
        id: "enterpriseContactThanksPage.creating-ticket",
        defaultMessage: "Our sales team is creating a ticket and will email you within 2 business days."
    });
    const descriptionResourcesText = intl.formatMessage({
        id: "enterpriseContactThanksPage.resources-to-start",
        defaultMessage: "In the meantime, here are some resources to get you started."
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _vchhusvi _11rm1hrf _1e0c1ule _12qx1osq _85i5zwfg _1q5116xz"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_vchhusvi _1e0c1txw _1n261g80 _12l21wug _ahbq1wug _p12f1git"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _vchhusvi _1e0c1ule _2lx21bp4 _1aax1e5h _1tket94y _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _y3gn1h6o _1bsbf2ck _1rfm1osq _1fqp1jgg _1ywm1jgg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)($d878a82f08dbe522$export$6e76f8357f41ff9b, {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_vchhusvi _1e0c1ule _6rth1tcg _ect41jfk _1wyb1wto _k48pbfng _1dyz4jg8 _vwz41k7u _y3gn1h6o _s7n41q9y _syaz1bqd _flz0yn4p _280zzz36 _1po47vkz _1lzoyn4p _119zzz36 _qtem7vkz _1cqsviql _1bys10nf _srwzdlk8"
                        ]),
                        children: headerText
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_vchhusvi _1e0c1ule _ect41jfk _1wyb1k92 _k48p1nn1 _1dyznl7k _vwz419ii _y3gn1h6o _s7n41q9y _syazvwuj"
                        ]),
                        children: [
                            descriptionTicketText,
                            /*#__PURE__*/ (0, $loA2J.jsx)("br", {}),
                            descriptionResourcesText
                        ]
                    })
                ]
            })
        })
    });
};
var $d878a82f08dbe522$export$2e2bcd8739ae039 = $d878a82f08dbe522$var$Hero;

});

parcelRegister("6EKII", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $233c230b68c16148$export$2e2bcd8739ae039; });
/* resource-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");

var $28Po9 = parcelRequire("28Po9");
const $233c230b68c16148$var$wrapperCardStyle = null;
const $233c230b68c16148$var$resourceCardsStyling = null;
const $233c230b68c16148$var$ResourceCards = ()=>{
    const intl = (0, $f6qj2.default)();
    const roadMapsText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.ViewRoadmaps",
        defaultMessage: "View roadmaps"
    });
    const advancedFeaturesText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.AdvancedFeatures",
        defaultMessage: "See advanced features"
    });
    const browseResourcesText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.BrowseResources",
        defaultMessage: "Browse resources"
    });
    const resourceCards = [
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.FeatureRoadmaps",
                defaultMessage: "Feature Roadmaps"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.FeatureRoadmaps.dsc",
                defaultMessage: "See what's in our pipeline for Cloud and Data Center products."
            }),
            buttonText: roadMapsText,
            url: (0, $3FBn4.useLocalizedHref)("/roadmap/cloud")
        },
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.CloudPremium",
                defaultMessage: "Cloud Premium products"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.CloudPremium.dsc",
                defaultMessage: "Learn about advanced product features for enterprises."
            }),
            buttonText: advancedFeaturesText,
            url: (0, $3FBn4.useLocalizedHref)("/software/premium")
        },
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.EnterpriseResources",
                defaultMessage: "More enterprise resources"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.EnterpriseResources.dsc",
                defaultMessage: "View resources, filtered by Cloud and Data Center product features."
            }),
            buttonText: browseResourcesText,
            url: (0, $3FBn4.useLocalizedHref)("/enterprise/resources?format=&topic=product-features&platform=")
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _vchhusvi _11rm1hrf _1e0c1ule _1ul91osq _85i57vkz _1q517vkz"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_vchhusvi _1e0c1txw _2lx2vrvc _ahbq1wug _12l21wug _p12f1fra _1gde1bp4"
            ]),
            children: resourceCards.map((cardProps)=>/*#__PURE__*/ (0, $iSvIT.createElement)((0, $28Po9.default), (0, $6iHNw._)((0, $7Knp0._)({}, cardProps), {
                    key: cardProps.header,
                    type: "primary",
                    color: "grey"
                })))
        })
    });
};
var $233c230b68c16148$export$2e2bcd8739ae039 = $233c230b68c16148$var$ResourceCards;

});
parcelRegister("28Po9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74c3a029b02b232c$export$2e2bcd8739ae039; });
/* resource-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $bQawl = parcelRequire("bQawl");
const $74c3a029b02b232c$var$resourceCardStyles = {
    primary: {
        white: {
            padding: "24px",
            borderStyle: "solid",
            borderWidth: "1px",
            borderRadius: "10px",
            borderColor: "#c1c7d0",
            width: "310px"
        },
        grey: {
            height: "100%",
            padding: "40px",
            backgroundColor: "#fafbfc",
            borderRadius: "3px"
        }
    },
    secondary: {}
};
const $74c3a029b02b232c$var$wrapperStyle = null;
const $74c3a029b02b232c$var$headerStyle = null;
const $74c3a029b02b232c$var$descriptionStyle = null;
const $74c3a029b02b232c$var$buttonStyle = null;
const $74c3a029b02b232c$var$ResourceCard = ({ header: header, description: description, buttonText: buttonText, url: url, type: type, color: color })=>{
    const formattedType = type === null || type === void 0 ? void 0 : type.toLowerCase();
    const resourceCardType = formattedType === "secondary" ? "secondary" : "primary";
    const formattedColor = color === null || color === void 0 ? void 0 : color.toLowerCase();
    const resourceCardColor = formattedColor === "grey" ? "grey" : "white";
    const styles = $74c3a029b02b232c$var$resourceCardStyles[resourceCardType][resourceCardColor]; /* eslint-disable @typescript-eslint/no-non-null-assertion */ 
    const { padding: padding, width: width, height: height, borderStyle: borderStyle, borderRadius: borderRadius, borderWidth: borderWidth, borderColor: borderColor, backgroundColor: backgroundColor } = styles ? styles : $74c3a029b02b232c$var$resourceCardStyles.primary.white; /* eslint-enable @typescript-eslint/no-non-null-assertion */ 
    const backgroundStyle = null;
    const templatesTabCardDataEventProps = {
        "data-product-key": "enterpriseContactSales",
        "data-event-component": "linkButton",
        "data-event-container": "cardSection",
        "data-event": "clicked"
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _vchhusvi _1e0c1ule _1aax1e5h _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1tket94y _ect4czdy _1wyb7vkz _vwz47vkz _s7n41q9y _14b527ks"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_vchhusvi _1e0c1ule _2lx21bp4 _1yt418y6 _1bsb9tg7 _4t3imry4 _1dqo1yif _2rko1qt3 _189e1ywc _bfhkaxbu _1h6d1srq"
            ]),
            style: {
                "--_1xumd0e": (0, $43MIc.default)(padding),
                "--_1ea5ebz": (0, $43MIc.default)(width),
                "--_roksyz": (0, $43MIc.default)(height),
                "--_ahoyl5": (0, $43MIc.default)(borderStyle),
                "--_1lnby5": (0, $43MIc.default)(borderRadius),
                "--_g1hsiq": (0, $43MIc.default)(borderWidth),
                "--_1ly4823": (0, $43MIc.default)(backgroundColor),
                "--_37cwmb": (0, $43MIc.default)(borderColor)
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_vchhusvi _1e0c1ule _6rth1tcg _ect418zh _1wyb1k92 _k48pbfng _1dyz165v _vwz4cjiy _s7n41q9y _syaz1bqd _qtemdlk8 _1cqs1j6v _srwzdlk8 _1bys10nf"
                    ]),
                    children: header
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_vchhusvi _1e0c1ule _6rth1tcg _ect4czdy _1wyb7vkz _k48p1nn1 _vwz4bs82 _syazvwuj _s7n41q9y"
                    ]),
                    children: description
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bQawl.default), {
                        text: buttonText,
                        "aria-label": buttonText,
                        url: url,
                        type: "secondary",
                        color: "whiteblue",
                        dataEventProps: templatesTabCardDataEventProps,
                        className: (0, $esG4f.default)([
                            "_bfhku67f _syazrbzz _vchhusvi _1e0c1o8l _4t3in7od _1tkel07h _85i56mu8 _bozg19bv _y4ti19bv _1q516mu8 _ect418gv _1wyboxwj _k48pbfng _vwz4nqt0 _y3gn1h6o _1hmsglyw _ajmmnqa1 _1keg1wug _3fcw1g80 _s7n41q9y _d5ymcfaq _1dqonqa1 _189et94y _80omtlke _2rko1l7b _qmxj15zi _1y1musvi _qjkj1u8q _1lrw1wug"
                        ])
                    })
                })
            ]
        })
    });
};
var $74c3a029b02b232c$export$2e2bcd8739ae039 = $74c3a029b02b232c$var$ResourceCard;

});





parcelRegister("cZ6ed", function(module, exports) {

$parcel$export(module.exports, "EnterpriseLandingPage", function () { return $0a767fd229666046$export$da7e1b175932c7dc; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("bxAHQ");
var $aqA4l = parcelRequire("aqA4l");
const $0a767fd229666046$export$da7e1b175932c7dc = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aqA4l.EnterpriseLandingPageTemplate), {});
};

});
parcelRegister("bxAHQ", function(module, exports) {
$parcel$export(module.exports, "EnterpriseLandingPageTemplate", function () { return (parcelRequire("aqA4l")).EnterpriseLandingPageTemplate; });

var $aqA4l = parcelRequire("aqA4l");

});
parcelRegister("aqA4l", function(module, exports) {

$parcel$export(module.exports, "EnterpriseLandingPageTemplate", function () { return $96cf49449622757b$export$8cba5fe34aed322c; });

var $loA2J = parcelRequire("loA2J");

var $4LHd8 = parcelRequire("4LHd8");

var $dyZbY = parcelRequire("dyZbY");
parcelRequire("3QHAr");
var $bESgj = parcelRequire("bESgj");

var $4XrxY = parcelRequire("4XrxY");

var $kex29 = parcelRequire("kex29");
parcelRequire("6iLAo");
var $bwE7U = parcelRequire("bwE7U");
var $hBv6L = parcelRequire("hBv6L");
var $8A8QS = parcelRequire("8A8QS");
var $kDPBE = parcelRequire("kDPBE");
var $bRtJQ = parcelRequire("bRtJQ");
var $9I4AD = parcelRequire("9I4AD");
var $1DDk6 = parcelRequire("1DDk6");
var $7hyE5 = parcelRequire("7hyE5");
var $JTayi = parcelRequire("JTayi");
var $7pyJC = parcelRequire("7pyJC");
var $axpN6 = parcelRequire("axpN6");
var $7wnzs = parcelRequire("7wnzs");
var $eUfO2 = parcelRequire("eUfO2");
var $igFQ5 = parcelRequire("igFQ5");
const $96cf49449622757b$export$8cba5fe34aed322c = ()=>{
    const shouldShowHeroV2 = (0, $4LHd8.default).getExperimentValue("wac-enterprise-hero-v2", "value", false);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $dyZbY.default), {
        name: "enterprise-page",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.TypographyStyles), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $bwE7U.EnterprisePageProductNav), {
                        isActive: "overview"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $hBv6L.HeroEnterpriseTakeoverTurbo), {}),
                    shouldShowHeroV2 ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8A8QS.HeroV2Section), {}) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $kDPBE.HeroSection), {}),
                    shouldShowHeroV2 ? null : /*#__PURE__*/ (0, $loA2J.jsx)((0, $bRtJQ.BadgesSection), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $9I4AD.TabsSection), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1DDk6.CarouselSection), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $7hyE5.PlatformSection), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $JTayi.StatsSection), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $7pyJC.ResourcesSection), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $bESgj.Adg4SectionDivider), {
                        bgColor: "#F0F1F2"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $axpN6.SupportSection), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $7wnzs.DataCenterSection), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $eUfO2.CtaSection), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $igFQ5.GartnerDisclaimer), {})
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("3QHAr", function(module, exports) {
$parcel$export(module.exports, "Adg4SectionDivider", function () { return (parcelRequire("bESgj")).Adg4SectionDivider; });
$parcel$export(module.exports, "SECTION_DIVIDER_VARIATION", function () { return (parcelRequire("bESgj")).SECTION_DIVIDER_VARIATION; });
parcelRequire("bESgj");

});
parcelRegister("bESgj", function(module, exports) {

$parcel$export(module.exports, "SECTION_DIVIDER_VARIATION", function () { return $895786c36feeeaea$export$89ad02e8b5e6fb05; });
$parcel$export(module.exports, "Adg4SectionDivider", function () { return $895786c36feeeaea$export$2446497a3d298a13; });
/* section-divider.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
var $895786c36feeeaea$export$89ad02e8b5e6fb05;
(function(SECTION_DIVIDER_VARIATION) {
    SECTION_DIVIDER_VARIATION["NORMAL"] = "normal";
    SECTION_DIVIDER_VARIATION["REVERSE"] = "reverse";
    SECTION_DIVIDER_VARIATION["FLIP"] = "flip";
    SECTION_DIVIDER_VARIATION["REVERSE_FLIP"] = "reverse-flip";
})($895786c36feeeaea$export$89ad02e8b5e6fb05 || ($895786c36feeeaea$export$89ad02e8b5e6fb05 = {}));
const $895786c36feeeaea$export$2446497a3d298a13 = ({ bgColor: bgColor = "#1868DB", colorAgainst: colorAgainst = "#FFF", desktopHeight: desktopHeight = 120, tabletHeight: tabletHeight = 80, mobileHeight: mobileHeight = 60, variation: variation })=>{
    const sectionDividerStyles = null;
    const colorBehindDividerStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_bfhk1tls"
        ]),
        style: {
            "--_1gwlqo7": (0, $43MIc.default)(colorAgainst)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_mkrzsrs8 _11q7bs0x _4t3iepwt _1vkh1mjl _tnruenus",
                variation === "reverse" && "_mkrz1fra",
                variation === "flip" && "_mkrz1n6g",
                variation === "reverse-flip" && "_mkrz1vud"
            ]),
            style: {
                "--_1w9snyi": (0, $43MIc.default)(bgColor),
                "--_qqqbix": (0, $43MIc.default)(desktopHeight, "px"),
                "--_1ly4yra": (0, $43MIc.default)(tabletHeight, "px"),
                "--_klg1fm": (0, $43MIc.default)(mobileHeight, "px")
            }
        })
    });
};

});


parcelRegister("6iLAo", function(module, exports) {
$parcel$export(module.exports, "CtaSection", function () { return (parcelRequire("eUfO2")).CtaSection; });
$parcel$export(module.exports, "DataCenterSection", function () { return (parcelRequire("7wnzs")).DataCenterSection; });
$parcel$export(module.exports, "GartnerDisclaimer", function () { return (parcelRequire("igFQ5")).GartnerDisclaimer; });
$parcel$export(module.exports, "HeroSection", function () { return (parcelRequire("kDPBE")).HeroSection; });
$parcel$export(module.exports, "HeroEnterpriseTakeoverTurbo", function () { return (parcelRequire("hBv6L")).HeroEnterpriseTakeoverTurbo; });
$parcel$export(module.exports, "PlatformSection", function () { return (parcelRequire("7hyE5")).PlatformSection; });
$parcel$export(module.exports, "ResourcesSection", function () { return (parcelRequire("7pyJC")).ResourcesSection; });
$parcel$export(module.exports, "StatsSection", function () { return (parcelRequire("JTayi")).StatsSection; });
$parcel$export(module.exports, "SupportSection", function () { return (parcelRequire("axpN6")).SupportSection; });
$parcel$export(module.exports, "TabsSection", function () { return (parcelRequire("9I4AD")).TabsSection; });
$parcel$export(module.exports, "CarouselSection", function () { return (parcelRequire("1DDk6")).CarouselSection; });
$parcel$export(module.exports, "BadgesSection", function () { return (parcelRequire("bRtJQ")).BadgesSection; });
$parcel$export(module.exports, "EnterprisePageProductNav", function () { return (parcelRequire("bwE7U")).EnterprisePageProductNav; });
$parcel$export(module.exports, "HeroV2Section", function () { return (parcelRequire("8A8QS")).HeroV2Section; });
parcelRequire("eUfO2");
parcelRequire("7wnzs");
parcelRequire("igFQ5");
parcelRequire("kDPBE");
parcelRequire("hBv6L");
parcelRequire("7hyE5");
parcelRequire("7pyJC");
parcelRequire("JTayi");
parcelRequire("axpN6");
parcelRequire("9I4AD");
parcelRequire("1DDk6");
parcelRequire("bRtJQ");
parcelRequire("bwE7U");
parcelRequire("8A8QS");

});
parcelRegister("eUfO2", function(module, exports) {

$parcel$export(module.exports, "CtaSection", function () { return $889bce6cb977e8a4$export$a241c84f183c05c2; });
/* cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $3FBn4 = parcelRequire("3FBn4");

var $kG61r = parcelRequire("kG61r");
const $889bce6cb977e8a4$export$a241c84f183c05c2 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "enterprise-page-cta",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
            className: (0, $esG4f.default)([
                "_1itk11ql _ca0q1ylp _u5f3idpf _n3td1ylp _19bvidpf _vd3yidpf _mla21wug _kubfidpf _3x9r1wug"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kG61r.ADG4CtaWithPolygonBackground), {
                header: intl.formatMessage({
                    id: "EnterpriseLandingPage.CallToActionSection.header",
                    defaultMessage: "Build your system of work with Atlassian"
                }),
                ctaText: intl.formatMessage({
                    id: "EnterpriseLandingPage.CallToActionSection.buttonText",
                    defaultMessage: "Contact sales"
                }),
                ctaUrl: (0, $3FBn4.useLocalizedHref)("/enterprise/contact?formType=product-features"),
                ctaLabel: "Contact sales",
                productKey: "enterprise"
            })
        })
    });
};
const $889bce6cb977e8a4$var$ctaSectionContainerStyle = null;

});
parcelRegister("kG61r", function(module, exports) {

$parcel$export(module.exports, "ADG4CtaWithPolygonBackground", function () { return $86b2c7811891ac1f$export$eacf4ba154ffd9bb; });
/* cta-with-polygon-background.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $eDoPe = parcelRequire("eDoPe");

var $91nJf = parcelRequire("91nJf");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $86b2c7811891ac1f$var$ctaStyles = null;
const $86b2c7811891ac1f$var$h3Styles = null;
const $86b2c7811891ac1f$var$typographyOverrides = null;
const $86b2c7811891ac1f$var$polygonStyles = null;
const $86b2c7811891ac1f$export$eacf4ba154ffd9bb = ({ header: header, paragraph: paragraph, ctaText: ctaText, ctaUrl: ctaUrl, ctaLabel: ctaLabel, productKey: productKey, backgroundColor: backgroundColor = "#101214", buttonVariant: buttonVariant = "secondary", buttonColor: buttonColor = "white" })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)();
    const noParagraphSpacing = !paragraph ? "var(--ds-space-400, 32px)" : 0;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
            ref: scrollRef,
            className: (0, $esG4f.default)([
                "_p12f1git _18s84p42 _y3gn1h6o",
                "_syaz121t _6rth4cqu",
                sectionIsVisible ? "is-visible" : ""
            ]),
            style: {
                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
            },
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                style: {
                    "--background-color": backgroundColor
                },
                className: (0, $esG4f.default)([
                    "_11q76ulk _mkrz1q5k _1vthpg2b _1yt4koci",
                    "polygon"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                className: (0, $esG4f.default)([
                                    "_1wyb1fu0 _vwz41da2 _1cqs1h67 _1jw853lb _1bys1fu0",
                                    "_syaz121t _6rth4cqu",
                                    "header h3"
                                ]),
                                style: {
                                    marginBottom: noParagraphSpacing,
                                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                                },
                                children: header
                            }),
                            paragraph && /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                                layout: "8",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                    className: (0, $esG4f.default)([
                                        "_syaz121t _6rth4cqu",
                                        ".body-lg"
                                    ]),
                                    style: {
                                        "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                                    },
                                    children: paragraph
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                                variant: buttonVariant,
                                color: buttonColor,
                                colorAgainst: backgroundColor == "#101214" ? "black" : "other",
                                href: ctaUrl,
                                dataEventProps: {
                                    "data-product-key": productKey,
                                    "data-event": "clicked",
                                    "data-event-component": "linkButton",
                                    "data-event-container": "ctaSection",
                                    "data-label-english": ctaLabel
                                },
                                className: (0, $esG4f.default)([
                                    "_6rthzwfg"
                                ]),
                                children: ctaText
                            })
                        ]
                    })
                })
            })
        })
    });
};

});


parcelRegister("7wnzs", function(module, exports) {

$parcel$export(module.exports, "DataCenterSection", function () { return $cc910999a483a5d6$export$3e74b76dd9e071d6; });
/* data-center.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $cc910999a483a5d6$export$3e74b76dd9e071d6 = ()=>{
    const intl = (0, $f6qj2.default)();
    const dataCenterSectionContent = {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.DataCenterSection.headerText",
            defaultMessage: "Not ready to move to cloud?"
        }),
        bodyText: intl.formatMessage({
            id: "EnterpriseLandingPage.DataCenterSection.bodyText",
            defaultMessage: "Atlassian Data Center is our self-managed, enterprise-grade offering designed for organizations with strict security and compliance requirements."
        }),
        linkText: intl.formatMessage({
            id: "EnterpriseLandingPage.DataCenterSection.linkText",
            defaultMessage: "Learn about Data Center"
        }),
        href: (0, $3FBn4.useLocalizedHref)("/enterprise/data-center")
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "enterprise-page-dataCenter",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
            className: (0, $esG4f.default)([
                "_bfhk17fj _ca0qys9h _u5f3idpf _n3tdys9h _19bvidpf _quu713sl _3int1tcg _4fugzwfg _1ynq1tcg _1j3nzwfg _4sdyiec4 _12ce3739 _1tsvgktf _fd8v1txw _1bwb1q9c _1iievrvc _68jdvle5 _9u9rnxnw _19q81txw _12dhx19p _19pe1h6o _lmm31y6m _1yusvle5 _1hkovle5 _30721txw _y1mj1g80 _4vzb1w8u _m5gb1y6m _12vwzwfg _1crqcv93 _leujidpf _14zaidpf _1il1idpf _fs5uidpf _p5u7ftgi _bpkv1ul9 _1r27idpf _2lgdidpf _6wouidpf _1c7pidpf _1ppp1ogm _1lywftgi _5k731txw _1c2n1osq _5hes1j6v _qc6e1k8s _gvxubfng _nd0zzwfg _1mmnzwfg _awmxzwfg _1xi6zwfg _l7qw1g80 _ar0r1h6o _1p7u1osq _1ubi1h6o _18q6esu3 _1vumzwfg _fls593m8 _2uu193m8 _zbwo1txw _o3yo1g80 _i5yc1osq _13ku1h6o _dbaqidpf _1qoridpf _1a5bidpf _1rafidpf _1f1p1h6o _1j211tcg _1wfzidpf _212widpf _15d21crf _vh6pidpf _1nr81wug _1h01idpf _cc93idpf _e7z31crf _1u52idpf _14hs1osq _pd60glyw _fnxl1txw _rc231h6o _1ogs1osq"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                layout: "12",
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: "data-center-container",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: "img-container",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                image: {
                                    src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-data-center-icon-3736035258.webp",
                                    alt: ""
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: "text-container",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                                    children: dataCenterSectionContent.headerText
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                    children: dataCenterSectionContent.bodyText
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                    href: dataCenterSectionContent.href,
                                    text: dataCenterSectionContent.linkText,
                                    type: "primary",
                                    dataEventProps: {
                                        "data-label": dataCenterSectionContent.linkText,
                                        "data-product-key": "enterprise",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "dataCenterSection",
                                        "data-event": "clicked",
                                        "data-label-english": "Learn about Data Center"
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
const $cc910999a483a5d6$var$dataCenterSectionContainerStyle = null;

});

parcelRegister("igFQ5", function(module, exports) {

$parcel$export(module.exports, "GartnerDisclaimer", function () { return $727aa6f289c598b7$export$46ba377055e90871; });
/* gartner-disclaimer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $dyZbY = parcelRequire("dyZbY");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $727aa6f289c598b7$var$finePrintStyles = null;
const $727aa6f289c598b7$export$46ba377055e90871 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "enterprise-page-disclaimer",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_syazfesn _18s81jx0",
                    "fine-print"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "EnterpriseLandingPage.gartnerDisclaimer",
                    defaultMessage: "* Gartner, Magic Quadrant for DevOps Platforms, Manjunath Bhat, Thomas Murphy, Joachim Herschmann, Daniel Betts, Chris Saunderson, Hassan Ennaciri, Bill Holz, Peter Hyde, 5 June 2023.  {br}{br} Gartner, Magic Quadrant for Enterprise Agile Planning Tools, Bill Blosen, Mike West, Keith Mann, Deacon D.K Wan, Akis Sklavounakis, Hassan Ennaciri, Sarah Davies, 25 April 2022.  {br}{br} Gartner, Voice of the Customer for Enterprise Agile Planning Tools, By Peer Contributors, 13 December 2023.  {br}{br} Gartner does not endorse any vendor, product or service depicted in its research publications, and does not advise technology users to select only those vendors with the highest ratings or other designation. Gartner research publications consist of the opinions of Gartner\u2019s research organization and should not be construed as statements of fact. Gartner disclaims all warranties, expressed or implied, with respect to this research, including any warranties of merchantability or fitness for a particular purpose.  {br}{br} Gartner Peer Insights content consists of the opinions of individual end users based on their own experiences with the vendors listed on the platform, should not be construed as statements of fact, nor do they represent the views of Gartner or its affiliates. Gartner does not endorse any vendor, product or service depicted in this content nor makes any warranties, expressed or implied, with respect to this content, about its accuracy or completeness, including any warranties of merchantability or fitness for a particular purpose.  {br}{br} GARTNER is a registered trademark and service mark, and the GARTNER PEER INSIGHTS CUSTOMERS\u2019 CHOICE badge, MAGIC QUADRANT and PEER INSIGHTS are trademarks and service marks, of Gartner, Inc. and/or its affiliates in the U.S. and internationally and are used herein with permission. All rights reserved.",
                    values: (0, $3FBn4.DEFAULT_VALUES)
                })
            })
        })
    });

});

parcelRegister("kDPBE", function(module, exports) {

$parcel$export(module.exports, "HeroSection", function () { return $d86f6eff78ebfa65$export$4489c2ed11909944; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $91nJf = parcelRequire("91nJf");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $d86f6eff78ebfa65$export$4489c2ed11909944 = ()=>{
    const intl = (0, $f6qj2.default)();
    const heroSectionHeaderText = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "EnterpriseLandingPage.Hero.Title",
        defaultMessage: "Transform <span>teamwork at scale</span> with Atlassian",
        values: (0, $3FBn4.DEFAULT_VALUES)
    });
    const heroSectionButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.Hero.ContactSales",
        defaultMessage: "Contact sales"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "enterprise-page-hero",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1xusidpf _pdfi1ul9 _hfczidpf _t0uc1ul9 _1humidpf _vxqx1wqb _m3vkidpf _l2as1wqb _kqswh2mm"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                alignItems: "center",
                layout: "12",
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1j444cyy _10j0ubw4 _1cbbgktf _l9wpidpf _f4o91wqb _14dmidpf _xgqm1zx8 _2h35g6j5 _bzzima1m _18jm1wqb _qji6idpf _ms0l1wqb _v5weidpf _1bl41w8u _b2g01l0k _13hpuihq _1isq1ikj _y3gn1h6o _kqswh2mm _19it1i89 _2rkogktf _19pk1wqb _2hwxidpf _otyr1wqb _18u0idpf _1reo15vq _18m915vq _1tke1edt _1itk105u _ouxlvvtf _12vemgnk _1lrw9efu _1e8sbxu3 _psnd1osr _q4ef6276 _18tn1fw0 _dkzuidpf _17f71wug _at0e1ul9 _1nx01wug _bpsp1nn1"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                            className: "superhero-contrast",
                            children: heroSectionHeaderText
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                            variant: "primary",
                            href: (0, $3FBn4.useLocalizedHref)("/enterprise/contact?formType=product-features"),
                            dataEventProps: {
                                "data-product-key": "enterprise",
                                "data-event-component": "linkButton",
                                "data-event-container": "ctaSection",
                                "data-event": "clicked",
                                "data-label": heroSectionButtonText,
                                "data-label-english": "Contact sales"
                            },
                            children: heroSectionButtonText
                        })
                    ]
                })
            })
        })
    });
};
const $d86f6eff78ebfa65$var$heroStyle = null;
const $d86f6eff78ebfa65$var$heroSectionBoxStyle = null;

});

parcelRegister("hBv6L", function(module, exports) {

$parcel$export(module.exports, "HeroEnterpriseTakeoverTurbo", function () { return $346e776a0c4e8ae6$export$5f34b2edc97abcd5; });
/* hero-takeover-turbo.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $91nJf = parcelRequire("91nJf");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $gAJUc = parcelRequire("gAJUc");
const $346e776a0c4e8ae6$export$5f34b2edc97abcd5 = ()=>{
    const intl = (0, $f6qj2.default)();
    const ctaLink = (0, $3FBn4.useLocalizedHref)("/enterprise/atlassian-williams-racing");
    const turboBodyText = intl.formatMessage({
        id: "HomePage.hero-turbo.body-text",
        defaultMessage: "Introducing Atlassian Williams Racing. Two teamwork powerhouses join forces to usher in a new era of Formula 1 racing."
    });
    const turboFeatureGate = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp5046TurboBannerEnterprise);
    if (turboFeatureGate) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "homepage-turbo",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1reo15vq _18m915vq _11q7jk2v _18s8zucw _mkrz95kk"
            ]),
            style: {
                "--_1b67llw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue700"))
            },
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _1e0c1txw _4cvr1h6o _zulptudo _1bsb1fra _p12f1osq _1yt415v9 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _na0i1bp4 _gu181h6o _dh1a1h6o _2osnpxbi _o5kc1h6o _6ssjnl7l"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_kqswh2mm _1e0c1txw _zulp1ejb _2lx21bp4 _4cvr1y6m _1bsb9tyk _acte1nn1 _qpk8yn4p _dd34idpf _l0uhidpf _ldjiidpf _g49yidpf _mihdcjiy _m78dcd5j _1tc71693 _1qf11ule _1hzvviql _vubcviql _125xcd5j _q7gqoxwj _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _txws1k92 _1kt119ii _19qkdgin _ov511osq _1s4p1wug _8fz6dgin _6ssj1e2i _gu181h6o _dh1a1h6o _o5kc1h6o"
                        ]),
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                        },
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                className: "hero hero-turbo",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "HomePage.hero-turbo.heading",
                                    defaultMessage: "Unleash the <strong>power of teamwork</strong>",
                                    values: (0, $3FBn4.DEFAULT_VALUES)
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                className: "turbo",
                                children: turboBodyText
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                                variant: "primary",
                                color: "yellow",
                                size: "large",
                                href: ctaLink,
                                dataEventProps: {
                                    "data-event": "clicked",
                                    "data-event-component": "linkButton",
                                    // @ts-ignore
                                    "data-event-container": "turboHero",
                                    "data-product-key": "home",
                                    "data-label-english": "Find out more"
                                },
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "HomePage.hero-turbo.cta-link-livery",
                                    defaultMessage: "Find out more"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_kqswh2mm _1yt41jx0 _1bsb16tw _mezj1osq _bna71wug _18zx1kb5 _1s4p1osq"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                            image: {
                                alt: "",
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4l06vv7x28fd2whw3f1i721165ooydn4.webp"
                            }
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {});
};
const $346e776a0c4e8ae6$var$heroTurboCSS = null;
const $346e776a0c4e8ae6$var$containingWidth = null;
const $346e776a0c4e8ae6$var$leftHero = null;
const $346e776a0c4e8ae6$var$rightHero = null;
$346e776a0c4e8ae6$export$5f34b2edc97abcd5.displayName = "HeroEnterpriseTakeoverTurbo";

});

parcelRegister("7hyE5", function(module, exports) {

$parcel$export(module.exports, "PlatformSection", function () { return $4524a40b297550c9$export$156caa82c28797f7; });
/* platform.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");
parcelRequire("9HFEq");
var $dbhgV = parcelRequire("dbhgV");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $4524a40b297550c9$export$156caa82c28797f7 = ()=>{
    const intl = (0, $f6qj2.default)();
    const platformCardsCrossProductExperience = [
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.collaboration.headerText",
                defaultMessage: "Collaboration"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.collaboration.bodyText",
                defaultMessage: "Keep work flowing across teams and tools."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/platform/collaboration"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.intelligence.headerText",
                defaultMessage: "Intelligence"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.intelligence.bodyText",
                defaultMessage: "Transform teamwork with the power of AI-human collaboration."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/artificial-intelligence"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.automation.headerText",
                defaultMessage: "Automation"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.automation.bodyText",
                defaultMessage: "Replace manual, time-consuming work with modern workflows."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/platform/automation"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.analytics.headerText",
                defaultMessage: "Analytics"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.analytics.bodyText",
                defaultMessage: "Make faster decisions with accessible data-informed insights."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/platform/analytics"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.extensibility.headerText",
                defaultMessage: "Extensibility"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.extensibility.bodyText",
                defaultMessage: "Customize your tools to meet the unique needs of each team."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: "https://marketplace.atlassian.com/",
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        }
    ];
    const platformCardsEnterpriseGradeCapabilities = [
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.resilience.headerText",
                defaultMessage: "Resilience at scale"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.resilience.bodyText",
                defaultMessage: "Adapt to any challenge with software designed to dynamically scale to meet the needs of any team, regardless of size or complexity."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/trust/resilience"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.security.headerText",
                defaultMessage: "Security and compliance"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.security.bodyText",
                defaultMessage: "Meet regulatory requirements and effectively manage your organization's data using comprehensive controls."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/trust/data-protection"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "enterprise-page-platformSection",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
            className: (0, $esG4f.default)([
                "_ca0q1ylp _u5f3idpf _n3td1ylp _19bvidpf _1sc1zwfg _1o2nzwfg _16zdidpf _jvlqidpf _1j3nzwfg _4fugzwfg"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_y3gn1h6o _q7gqgktf _w77horz4 _clfdftgi _11pq1wug _q0a5ftgi _c3k81wug"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            children: intl.formatMessage({
                                id: "EnterpriseLandingPage.Platform.headerText",
                                defaultMessage: "Unify your teams on one powerful platform"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_bfhk1t97 _ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _y3gn1h6o _1x1tidpf _s9kqidpf _4wztidpf _98csidpf"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                    children: intl.formatMessage({
                                        id: "EnterpriseLandingPage.Platform.crossProductExperince.headerText",
                                        defaultMessage: "Experiences built to help work flow"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_19pkzwfg _2hwx1wug _otyrzwfg _18u01wug _1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _1n261q9c _zulpzwfg _ohma7vkz _iz1bzlre _1seo1wug _ox5hglyw _1f7i1osq _1r6y7vkz _1d9j7vkz _tuj67vkz _1cae7vkz _1m5l7vkz _bapsidpf _24o4idpf _ru7pidpf _1pqjidpf _1oan1fw0 _ax17ftgi _2axr1osq _1swwidpf _bzvvidpf _1dr6idpf _1o9tidpf _7dyf1j6v _scyo1k8s _1xaw1g80 _1rrc1tcg _1sgw17i6 _161z1osq"
                                    ]),
                                    children: platformCardsCrossProductExperience.map((cardProps, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $dbhgV.Card), (0, $7Knp0._)({
                                            className: "platform-row-one-card"
                                        }, cardProps), index))
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_ip65idpf _g8ou1wug _1opiidpf _1x951wug _dmb7idpf"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_bfhkcs0v _ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _y3gn1h6o _1x1tidpf _s9kqidpf _4wztidpf _98csidpf _clfd7vkz _11pq1wug _q0a57vkz _c3k81wug _w77horz4 _kckd1w8u _19tb1j6v _1la11k8s _bpspbfng"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                    children: intl.formatMessage({
                                        id: "EnterpriseLandingPage.Platform.commonDataModel.headerText",
                                        defaultMessage: "A common data model designed to unlock key insights"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                    children: intl.formatMessage({
                                        id: "EnterpriseLandingPage.Platform.commonDataModel.bodyText",
                                        defaultMessage: "Unify Atlassian and third-party data to connect teams, deepen collaboration, and drive results."
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                    type: "primary",
                                    href: (0, $3FBn4.useLocalizedHref)("/platform"),
                                    text: intl.formatMessage({
                                        id: "EnterpriseLandingPage.Platform.commonDataModel.linkText",
                                        defaultMessage: "Learn about our platform"
                                    }),
                                    dataEventProps: {
                                        "data-product-key": "enterprise",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "platformSection",
                                        "data-event": "clicked",
                                        "data-label": intl.formatMessage({
                                            id: "EnterpriseLandingPage.Platform.commonDataModel.dataLabel",
                                            defaultMessage: "Learn about our platform"
                                        }),
                                        "data-label-english": "Learn about our platform"
                                    }
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_ip65idpf _g8ou1wug _1opiidpf _1x951wug _dmb7idpf"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_bfhk1ymo _ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _y3gn1h6o _1x1tidpf _s9kqidpf _4wztidpf _98csidpf"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                    children: intl.formatMessage({
                                        id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilites.headerText",
                                        defaultMessage: "All built on enterprise-grade foundations"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_19pkzwfg _2hwx1wug _otyrzwfg _18u01wug _1bsb1w8u _1e0c1txw _1bah1h6o _1n261q9c _zulpzwfg _1wa17vkz _1ull1ssb _10ql1wug _tlbsglyw _lz7x1osq _knw07vkz _w3mz7vkz _14877vkz _6mwl7vkz _xc0a7vkz _19elidpf _wsnuidpf _1lioidpf _rkcxidpf _14uv1fw0 _x8poftgi _2fdk1osq _6qlpidpf _7m8oidpf _196hidpf _47ltidpf _1b8g1j6v _1xzh1k8s _1qza1osq _11901g80 _17duzwfg _kyxpidpf _3x14zwfg _p8qcidpf _rvvr1osq"
                                    ]),
                                    children: platformCardsEnterpriseGradeCapabilities.map((cardProps, index)=>{
                                        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dbhgV.Card), (0, $7Knp0._)({
                                            className: "platform-row-three-card"
                                        }, cardProps), index);
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
const $4524a40b297550c9$var$platformSectionBoxContainer = null;
const $4524a40b297550c9$var$platformBoxContainer = null;
const $4524a40b297550c9$var$platformSectionHeaderContainerStyle = null;
const $4524a40b297550c9$var$platformSectionBoxRowOneStyle = null;
const $4524a40b297550c9$var$platformSectionRowOneCardContainerStyle = null;
const $4524a40b297550c9$var$platformSectionBoxRowTwoStyle = null;
const $4524a40b297550c9$var$platformSectionBoxRowThreeStyle = null;
const $4524a40b297550c9$var$platformSectionRowThreeCardContainerStyle = null;

});

parcelRegister("7pyJC", function(module, exports) {

$parcel$export(module.exports, "ResourcesSection", function () { return $48a7222b05a825e8$export$3f0336208d56829f; });
/* resources.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $48a7222b05a825e8$export$3f0336208d56829f = ()=>{
    const intl = (0, $f6qj2.default)();
    const tileList = [
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.trustCenter.headerText",
                defaultMessage: "Trust Center"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.trustCenter.bodyText",
                defaultMessage: "Keep your organization\u2019s data secure, maintain compliance, and achieve resilience at scale."
            }),
            imageProps: {
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/trust-center-cloud-icon-3087608378.webp",
                alt: ""
            },
            linkProps: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.Resources.card.trustCenter.linkText",
                    defaultMessage: "Visit our Trust Center"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/trust"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "resourcesSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.Resources.card.trustCenter.dataLabel",
                        defaultMessage: "Visit our Trust Center"
                    }),
                    "data-label-english": "Visit our Trust Center"
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.publicRoadmap.headerText",
                defaultMessage: "Public Roadmap"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.publicRoadmap.bodyText",
                defaultMessage: "Discover the latest features in the Atlassian cloud and see what we\u2019re working on next."
            }),
            imageProps: {
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/curved-arrow-icon-3497580723.webp",
                alt: ""
            },
            linkProps: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.Resources.card.publicRoadmap.linkText",
                    defaultMessage: "Check out the Cloud Roadmap"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/roadmap/cloud"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "resourcesSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.Resources.card.publicRoadmap.dataLabel",
                        defaultMessage: "Check out the Cloud Roadmap"
                    }),
                    "data-label-english": "Check out the Cloud Roadmap"
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.community.headerText",
                defaultMessage: "Enterprise Community"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.community.bodyText",
                defaultMessage: "Ask questions and learn best practices for our products at scale from Atlassian advocates."
            }),
            imageProps: {
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/community-bubble-icon-3561157108.webp",
                alt: ""
            },
            linkProps: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.Resources.card.community.linkText",
                    defaultMessage: "Join the Enterprise Community"
                }),
                href: "https://community.atlassian.com/t5/Enterprise/gh-p/Enterprise",
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "resourcesSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.Resources.card.community.dataLabel",
                        defaultMessage: "Join the Enterprise Community"
                    }),
                    "data-label-english": "Join the Enterprise Community"
                }
            }
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "enterprise-page-resourcesSection",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
            className: (0, $esG4f.default)([
                "_ca0qzwfg _u5f3idpf _n3tdidpf _19bvidpf _1afj1h6o _l5k11fw0 _16qeidpf _3ontidpf _19szidpf _i5bbidpf _cw8vusvi _hycy1txw _pg7i1bp4 _ezjiidpf _n5mbidpf _ypkd1tcg _1a0jidpf _14tm1ule _ix4uidpf _1gb7mhvn _64bp1osq _41c21txw _1iyj1osq _1kkgftgi _zkiw1e5h _fhnp1bp4 _1jxlzwfg _uuujidpf _1tu71fw0 _wft81crf _1jklidpf _1l021osq _178z1tcg _zlemidpf _ibgk1ul9 _o6yp1j6v _1syj1k8s _1chlbfng _wsbmf6fq _irte1j6v _w2lm1h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        children: intl.formatMessage({
                            id: "EnterpriseLandingPage.Resources.sectionHeader",
                            defaultMessage: "Teamwork starts with trust"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "4-4-4",
                    children: tileList.map((content, index)=>{
                        return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: "resources-section-container",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: "img-section",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                                        src: content.imageProps.src,
                                        alt: content.imageProps.alt,
                                        className: (0, $esG4f.default)([
                                            "_1h1t1fut _5ral1f51",
                                            "enterprise-resources-card-image"
                                        ])
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: "text-section",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                            children: content.headerText
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                            className: "contentBlock-body",
                                            children: content.bodyText
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: "contentBlock-linkFlex",
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                                text: content.linkProps.text,
                                                href: content.linkProps.href,
                                                dataEventProps: content.linkProps.dataEventProps,
                                                type: "primary"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
};
const $48a7222b05a825e8$var$resourcesSectionContainerStyle = null;

});

parcelRegister("JTayi", function(module, exports) {

$parcel$export(module.exports, "StatsSection", function () { return $a7b3a8516c5339be$export$49e22b3583223277; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $5ohHq = parcelRequire("5ohHq");

var $2p5f0 = parcelRequire("2p5f0");

var $gAJUc = parcelRequire("gAJUc");
const $a7b3a8516c5339be$export$49e22b3583223277 = ()=>{
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    const intl = (0, $f6qj2.default)();
    const statsProps = {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.stats.header",
            defaultMessage: "High-performing enterprises run on Atlassian"
        }),
        bigStat: {
            stat: "200",
            statText: intl.formatMessage({
                id: "EnterpriseLandingPage.stats.bigText",
                defaultMessage: "countries around the world where Atlassian software helps power enterprise"
            }),
            statColor: (0, $5ohHq.wacToken)("color.primary.blue"),
            statSymbol: {
                symbolCharacter: "+",
                symbolCharacterColor: (0, $5ohHq.wacToken)("color.primary.blue")
            }
        },
        littleStats: [
            {
                stat: "44",
                statText: intl.formatMessage({
                    id: "EnterpriseLandingPage.stats.littleText1",
                    defaultMessage: "of enterprise customers are able to make faster data-driven decisions after moving to the cloud"
                }),
                statColor: (0, $5ohHq.wacToken)("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: "%",
                    symbolCharacterColor: (0, $5ohHq.wacToken)("color.primary.blue")
                }
            },
            {
                stat: "79",
                statText: gwp7518NavIconUpdates ? intl.formatMessage({
                    id: "EnterpriseLandingPage.stats.littleText2-gwp-7518",
                    defaultMessage: "of enterprise customers are satisfied with Atlassian cloud apps"
                }) : intl.formatMessage({
                    id: "EnterpriseLandingPage.stats.littleText2",
                    defaultMessage: "of enterprise customers are satisfied with Atlassian cloud products"
                }),
                statColor: (0, $5ohHq.wacToken)("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: "%",
                    symbolCharacterColor: (0, $5ohHq.wacToken)("color.primary.blue")
                }
            }
        ]
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "enterprise-page-stats",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2p5f0.Stats), (0, $7Knp0._)({}, statsProps))
        })
    });
};

});

parcelRegister("axpN6", function(module, exports) {

$parcel$export(module.exports, "SupportSection", function () { return $816d290a4a39bcfe$export$17b1756ef4d0cdd6; });
/* support.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");
parcelRequire("9HFEq");
var $dbhgV = parcelRequire("dbhgV");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $816d290a4a39bcfe$export$17b1756ef4d0cdd6 = ()=>{
    const intl = (0, $f6qj2.default)();
    const cardList = [
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.headerText.advisoryServices",
                defaultMessage: "Advisory Services"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.bodyText.advisoryServices",
                defaultMessage: "Maximize your Atlassian investment and achieve your goals with strategic, technical, and practice guidance from Atlassian\u2019s in-house experts."
            }),
            iconName: "lightning",
            iconSize: "small",
            clickableCardUrl: (0, $3FBn4.useLocalizedHref)("/enterprise/services/advisory-services"),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/enterprise/services/advisory-services"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "supportSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.headerText.enterprisePartners",
                defaultMessage: "Enterprise Partners"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.bodyText.enterprisePartners",
                defaultMessage: "Consulting, hands-on technical implementation, and best practices to optimize your Atlassian portfolio and ensure your success."
            }),
            iconName: "partners",
            iconSize: "small",
            clickableCardUrl: (0, $3FBn4.useLocalizedHref)("/enterprise/enterprise-partners"),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/enterprise/enterprise-partners"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "supportSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.headerText.customerSupport",
                defaultMessage: "Customer Support"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.bodyText.customerSupport",
                defaultMessage: "Get 24/7 support with 30-minute response times for critical issues included with Cloud Enterprise and Data Center subscriptions."
            }),
            iconName: "sparkle",
            iconSize: "small",
            clickableCardUrl: (0, $3FBn4.useLocalizedHref)("/enterprise/support-services"),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/enterprise/support-services"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "supportSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "enterprise-page-supportSection",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
            className: (0, $esG4f.default)([
                "_bfhk17fj _85i51ylp _94n51n1a _1afj1h6o _l5k11fw0 _1eavgktf _7qsbtlke _4mdwglyw _nmva14mp _8mry16gf _ajae1tcg _17s71tcg _1uza1tcg _18bc1tcg _bo1n1osq _1gm71fw0 _5hjp1osq _1xi9idpf _1yay1j6v _1k931k8s _cwu5jojz _9rk41fp4 _wxo81jeb _1qj31yy8"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        children: intl.formatMessage({
                            id: "EnterpriseLandingPage.Support.headerText",
                            defaultMessage: "Support designed for every enterprise"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "4-4-4",
                    children: cardList.map((CardProps, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $dbhgV.Card), (0, $7Knp0._)({
                            className: `support-section-card support-section-card-${index}`,
                            headerType: "h4"
                        }, CardProps), index))
                })
            ]
        })
    });
};
const $816d290a4a39bcfe$var$SupportSectionContainerStyles = null;
var $816d290a4a39bcfe$export$2e2bcd8739ae039 = $816d290a4a39bcfe$export$17b1756ef4d0cdd6;

});

parcelRegister("9I4AD", function(module, exports) {

$parcel$export(module.exports, "TabsSection", function () { return $40d4ec2240824626$export$502de1d4d55224c1; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");
parcelRequire("4Bezw");
var $g5uJU = parcelRequire("g5uJU");
parcelRequire("bqzO8");
var $4FzaJ = parcelRequire("4FzaJ");
var $f22PF = parcelRequire("f22PF");
var $e7p0a = parcelRequire("e7p0a");
var $6b9A1 = parcelRequire("6b9A1");
const $40d4ec2240824626$export$502de1d4d55224c1 = ()=>{
    const intl = (0, $f6qj2.default)();
    const tabs = [
        {
            id: "tab1",
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.softwareDevelopment",
                defaultMessage: "Software development"
            }),
            englishLabel: "Software development",
            tabComponent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4FzaJ.EnterpriseSoftwareDevelopment), {})
        },
        {
            id: "tab2",
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.Service management",
                defaultMessage: "Service management"
            }),
            englishLabel: "Service management",
            tabComponent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $f22PF.EnterpriseServiceManagement), {})
        },
        {
            id: "tab3",
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.enterpriseStrategyAndPlanning",
                defaultMessage: "Enterprise strategy & planning"
            }),
            englishLabel: "Enterprise strategy & planning",
            tabComponent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $e7p0a.EnterpriseStrategyAndPlanning), {})
        },
        {
            id: "tab4",
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.workManagement",
                defaultMessage: "Work management"
            }),
            englishLabel: "Work management",
            tabComponent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6b9A1.EnterpriseWorkManagement), {})
        }
    ];
    const solutionsHeader = intl.formatMessage({
        id: "EnterpriseLandingPage.solutions.header",
        defaultMessage: "Industry-leading solutions to accelerate your business"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "enterprise-page-tabs",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $g5uJU.TabsWithCards), {
            h2Text: solutionsHeader,
            tabsData: tabs
        })
    });
};

});
parcelRegister("4Bezw", function(module, exports) {
$parcel$export(module.exports, "TabsWithCards", function () { return (parcelRequire("g5uJU")).TabsWithCards; });
parcelRequire("g5uJU");

});
parcelRegister("g5uJU", function(module, exports) {

$parcel$export(module.exports, "TabsWithCards", function () { return $bc1fe4aca38ac20e$export$3c855d4d211f5f7e; });
/* tabs-with-cards.pattern.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $cutM5 = parcelRequire("cutM5");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $bc1fe4aca38ac20e$var$Tab = ({ title: title, isSelected: isSelected, dataEventProps: dataEventProps })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("button", (0, $6iHNw._)((0, $7Knp0._)({}, dataEventProps), {
        className: (0, $esG4f.default)([
            "_1ul9ymf6 _bfhk17fj _4cvr1h6o _1bah1h6o _vchhusvi _1e0c1txw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _4t3i12am _2rko1f4h _y4ti1ul9 _bozg1ul9 _80omtlke _19it1hmt _ect4lnmy _k48p1nn1 _1wybgktf _1dbzzucj _1bg41b66 _nt751hlo",
            isSelected && "_19it8djs _bfhk1ybm"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100"))
        },
        children: title
    }));
};
const $bc1fe4aca38ac20e$export$3c855d4d211f5f7e = ({ h2Text: h2Text, tabsData: tabsData })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        id: "tabs",
        className: (0, $esG4f.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cutM5.Adg4Tabs), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        className: (0, $esG4f.default)([
                            "_1bsb1osq _y3gn1h6o _6rthidpf"
                        ]),
                        children: h2Text
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTabList), {
                    rowGap: "12px",
                    className: (0, $esG4f.default)([
                        "_ca0q1ylp _u5f31wqb _n3td1qjk _19bv1wqb _1kmx1ylp _1ggmzwfg _1ykz1ul9 _1maezwfg",
                        "tab-list"
                    ]),
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTab), {
                            tabIndex: index,
                            className: "round-tab",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)($bc1fe4aca38ac20e$var$Tab, {
                                title: tab.title,
                                dataEventProps: {
                                    "data-product-key": "home",
                                    "data-event": "clicked",
                                    "data-event-component": "button",
                                    "data-event-container": "tabsMenu",
                                    "data-label": tab.title,
                                    "data-label-english": tab.englishLabel
                                }
                            })
                        }, index))
                }),
                tabsData.map((tab, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4TabPanel), {
                        panelIndex: index,
                        id: tab.id,
                        children: tab.tabComponent
                    }, index))
            ]
        })
    });
};
const $bc1fe4aca38ac20e$var$sectionStyles = null;
const $bc1fe4aca38ac20e$var$h2Styles = null;
const $bc1fe4aca38ac20e$var$tabList = null;
const $bc1fe4aca38ac20e$var$tabStyles = null;
const $bc1fe4aca38ac20e$var$currentStyle = null;

});


parcelRegister("bqzO8", function(module, exports) {

$parcel$export(module.exports, "EnterpriseStrategyAndPlanning", function () { return (parcelRequire("e7p0a")).EnterpriseStrategyAndPlanning; });
$parcel$export(module.exports, "EnterpriseServiceManagement", function () { return (parcelRequire("f22PF")).EnterpriseServiceManagement; });
$parcel$export(module.exports, "EnterpriseSoftwareDevelopment", function () { return (parcelRequire("4FzaJ")).EnterpriseSoftwareDevelopment; });
$parcel$export(module.exports, "EnterpriseWorkManagement", function () { return (parcelRequire("6b9A1")).EnterpriseWorkManagement; });

var $e7p0a = parcelRequire("e7p0a");

var $f22PF = parcelRequire("f22PF");

var $4FzaJ = parcelRequire("4FzaJ");

var $6b9A1 = parcelRequire("6b9A1");

});
parcelRegister("e7p0a", function(module, exports) {

$parcel$export(module.exports, "EnterpriseStrategyAndPlanning", function () { return $05b23948ff62de43$export$b230c8e7621aa6c7; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $efepR = parcelRequire("efepR");

var $3FBn4 = parcelRequire("3FBn4");

var $d3R1O = parcelRequire("d3R1O");
const $05b23948ff62de43$export$b230c8e7621aa6c7 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $efepR.default), {
        contentList: [
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.makeAllWorkVisible",
                    defaultMessage: "Make all work visible in real-time"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.makeAllWorkVisible.bodytext",
                    defaultMessage: "Spot and solve blockers faster with visibility into all work from teams across your enterprise."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.alignEveryTeam",
                    defaultMessage: "Align every team to strategy"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.alignEveryTeam.bodyText",
                    defaultMessage: "Get everyone on the same page so you can solve for dependencies, scope, and roadmaps across teams and portfolios."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.stayFocusedOnCustomerValue",
                    defaultMessage: "Stay focused on customer value"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.stayFocusedOnCustomerValue.bodyText",
                    defaultMessage: "Map investments to customer value creation so you can make confident decisions at make-or-break moments."
                })
            }
        ],
        contentLink: {
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.StrategyAndPlanning.learnMore",
                defaultMessage: "Learn about enterprise strategy & planning"
            }),
            link: (0, $3FBn4.useLocalizedHref)("/software/jira/align"),
            linkLabel: "Learn about enterprise strategy & planning",
            productKey: "enterprise"
        },
        pictureProps: {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1tu5g7e71x67ptt70udllxtw5705vl17.webp",
                alt: "",
                width: 1544,
                height: 1092
            }
        },
        tabContentEyebrowText: intl.formatMessage({
            id: "EnterpriseLandingPage.tab.StrategyAndPlanning.resources",
            defaultMessage: "Enterprise strategy & planning resources"
        }),
        cardsContent: [
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.predictsReport",
                    defaultMessage: "Report"
                }),
                headerText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.predictsReport.headerText",
                    defaultMessage: 'Gartner<sup>\xae</sup> Predicts 2024: Strategic Portfolio Leaders Must Plan for the "Never Normal"',
                    values: (0, $d3R1O.formatRegisteredSymbol)
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.predictsReport.linkText",
                        defaultMessage: "Read report"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("software/jira/align/resources/gartner-strategic-portfolio-management"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Read report"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/kx4vls2kbgf442m7wq2p88a182k0sy20.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.reportWebinar",
                    defaultMessage: "Demo center"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.reportWebinar.headerText",
                    defaultMessage: "Learn how to boost Enterprise Strategy & Planning with Jira Align"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.reportWebinar.linkText",
                        defaultMessage: "Explore demos"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/jira/align/demo"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Explore demos"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-02-demo@2x-3880751788.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.ITSMGuide",
                    defaultMessage: "Webinar"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.ITSMGuide.headerText",
                    defaultMessage: "Transformations Across Hybrid Environments"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.ITSMGuide.linkText",
                        defaultMessage: "Watch webinar"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/webinars/agile-at-scale/transformations-across-hybrid-environments"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Watch webinar"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/kv2eo50o020nn5amk6ahukj52h35405s.webp",
                        alt: ""
                    }
                }
            }
        ]
    });
};

});
parcelRegister("efepR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cef5c4644cdf7bf7$export$2e2bcd8739ae039; });
/* tabs-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $vqrsL = parcelRequire("vqrsL");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");

var $aOuDE = parcelRequire("aOuDE");
const $cef5c4644cdf7bf7$var$settings = {
    arrows: false,
    centerMode: true,
    dots: true,
    infinite: false,
    swipeToSlide: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
}; // Source https://github.com/kenwheeler/slick/blob/master/slick/slick.css
// FIXME: Nested selectors are used here to target dynamically inserted child elements
const $cef5c4644cdf7bf7$var$slickStyle = null;
const $cef5c4644cdf7bf7$var$TabsContent = (tabsContentProps)=>{
    var _tabsContentProps_contentLink, _tabsContentProps_contentLink1, _tabsContentProps_contentLink2;
    const isMobile = (0, $aOuDE.useIsMobile)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_y44v951u",
                tabsContentProps.className || ""
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_dm2511p5 _1rqtaigu _pdlmzwfg"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_uhi5kb7n _eao7qfx8"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_kzvi1txw _1gzvzwfg",
                                            "content-list"
                                        ]),
                                        children: tabsContentProps.contentList.map((content, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_xlt17vkz _40tuftgi _1tnt1tcg _v9tzum4z _p6svglyw",
                                                    "content-text"
                                                ]),
                                                style: {
                                                    "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                                        className: (0, $esG4f.default)([
                                                            "_6rthidpf _1pfhidpf",
                                                            content === null || content === void 0 ? void 0 : content.headerType
                                                        ]),
                                                        children: content.headerText
                                                    }),
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                        className: (0, $esG4f.default)([
                                                            "_476dftgi"
                                                        ]),
                                                        children: content.bodyText
                                                    })
                                                ]
                                            }, "content-" + index))
                                    }),
                                    tabsContentProps.contentLink && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_gq9a1h6o",
                                            "link-content-container"
                                        ]),
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                            href: tabsContentProps.contentLink.link,
                                            text: (_tabsContentProps_contentLink = tabsContentProps.contentLink) === null || _tabsContentProps_contentLink === void 0 ? void 0 : _tabsContentProps_contentLink.linkText,
                                            type: "primary",
                                            dataEventProps: {
                                                "data-product-key": (_tabsContentProps_contentLink1 = tabsContentProps.contentLink) === null || _tabsContentProps_contentLink1 === void 0 ? void 0 : _tabsContentProps_contentLink1.productKey,
                                                "data-event": "clicked",
                                                "data-event-component": "linkButton",
                                                "data-event-container": "tabsSection",
                                                "data-label-english": (_tabsContentProps_contentLink2 = tabsContentProps.contentLink) === null || _tabsContentProps_contentLink2 === void 0 ? void 0 : _tabsContentProps_contentLink2.linkLabel
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1reo15vq _18m915vq _uhi5qfx8 _eao71mrw _1iyegktf"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), (0, $6iHNw._)((0, $7Knp0._)({}, tabsContentProps.pictureProps), {
                                    className: (0, $esG4f.default)([
                                        "_rtys1osq _1jpx1f51 _mezj1osq _1oo31q9y _bna71wug _m369951u _ovn1i2wt"
                                    ])
                                }))
                            })
                        ]
                    })
                }),
                tabsContentProps.tabContentEyebrowText && /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: "tab-content-header-wrapper",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            className: (0, $esG4f.default)([
                                "_y3gn1h6o _1pfhidpf _6rth1tcg",
                                "eyebrow-md"
                            ]),
                            children: tabsContentProps.tabContentEyebrowText
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: "tabs-content-cards",
                    children: isMobile ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_vnijh2mm _1ls01ule _1dtvusvi _1kb1glyw _fjwtglyw _1wv2glyw _1r6vglyw _zookglyw _8rkdglyw _1tpbmuzh _u8dlmuzh _e1ct1j28 _1t25h2mm _8lsh15vq _kuv715vq _19moidpf _1vqqidpf _m8oxidpf _bzd2idpf _snlxh2mm _1rfpidpf _104oidpf _j6fg1ule _gkdh1wug _1jbo1wug _1t4e15vq _1u35glyw _1vrb1e5h _m8yv1osq _11wpftgi _ehjsftgi _13e4ftgi _12l3ftgi _gzcot94y _1xnx1ule _6rj8idpf _k58e13la _qmn3idpf _bjmnidpf _6qh814y2 _1qzl14y2 _1dx414y2 _1n6c14y2 _1mfj1h6o _12bq1o8l _nog6tlke _1njogktf _1ssvgktf _110yidpf _1glb14y2 _1a57idpf _c30z14y2 _1yjcidpf _qop8idpf _63deidpf _l4aeidpf _1jkiidpf _1xco1ule _je42idpf _176uidpf _rtji14y2 _1jth14y2 _9af414y2 _9uha14y2 _11votlke _omsfgktf _6fzegktf _5l3c1j28 _iygb1j28 _c2ls1r31 _6ejeglyw _1e79idpf _54up1hlo _1gdw1osq _cshx1hlo _2g951ssb _1f1o1mp2 _z3otldb6 _w1ixgktf _1kauidpf _fcd11h6o _slqlidpf _4if1gktf _vcsd13la _1wxl1h6o"
                        ]),
                        style: {
                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($vqrsL))), (0, $6iHNw._)((0, $7Knp0._)({}, $cef5c4644cdf7bf7$var$settings), {
                            children: tabsContentProps.cardsContent.map((cardContent, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)($cef5c4644cdf7bf7$var$TabCard, (0, $7Knp0._)({}, cardContent))
                                }, "card-" + index))
                        }))
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                        layout: "4-4-4",
                        containerType: "ul",
                        children: tabsContentProps.cardsContent.map((cardContent, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)($cef5c4644cdf7bf7$var$TabCard, (0, $6iHNw._)((0, $7Knp0._)({}, cardContent), {
                                    containerType: "li"
                                }))
                            }, "card-" + index))
                    })
                })
            ]
        })
    });
};
const $cef5c4644cdf7bf7$var$slidein = null;
const $cef5c4644cdf7bf7$var$wrapperStyles = null;
const $cef5c4644cdf7bf7$var$bigImgWrapperStyles = null;
const $cef5c4644cdf7bf7$var$contentListWrapperStyle = null;
const $cef5c4644cdf7bf7$var$contentListTextWrapperStyle = null;
const $cef5c4644cdf7bf7$var$contentListStyles = null;
const $cef5c4644cdf7bf7$var$contentImageStyle = null;
const $cef5c4644cdf7bf7$var$eyebrowStyle = null;
const $cef5c4644cdf7bf7$var$ContentTextStyles = null;
const $cef5c4644cdf7bf7$var$ContentTextPStyle = null;
const $cef5c4644cdf7bf7$var$contentListHeaderStyle = null;
const $cef5c4644cdf7bf7$var$linkContainerStyle = null;
const $cef5c4644cdf7bf7$var$TabCard = (cardContentProps)=>{
    const { eyebrowText: eyebrowText, headerText: headerText, bodyText: bodyText, ctaProps: ctaProps, pictureProps: pictureProps, containerType: containerType } = cardContentProps;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Card), {
        title: headerText,
        titleAs: "h3",
        image: pictureProps,
        body: bodyText,
        eyebrow: eyebrowText,
        callToAction: ctaProps,
        containerType: containerType
    });
};
var $cef5c4644cdf7bf7$export$2e2bcd8739ae039 = $cef5c4644cdf7bf7$var$TabsContent;

});

parcelRegister("d3R1O", function(module, exports) {

$parcel$export(module.exports, "formatRegisteredSymbol", function () { return $f3eed0372d8cd144$export$7c6a07146a40a24d; });
/* utils.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $f3eed0372d8cd144$export$7c6a07146a40a24d = {
    sup: (chunks)=>/*#__PURE__*/ (0, $loA2J.jsx)("sup", {
            className: (0, $esG4f.default)([
                "_vwz4idpf"
            ]),
            children: chunks
        })
};

});


parcelRegister("f22PF", function(module, exports) {

$parcel$export(module.exports, "EnterpriseServiceManagement", function () { return $b4c353f9ed9f199d$export$851060687c9906bd; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $efepR = parcelRequire("efepR");

var $3FBn4 = parcelRequire("3FBn4");
const $b4c353f9ed9f199d$export$851060687c9906bd = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $efepR.default), {
        contentList: [
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.deliverValue",
                    defaultMessage: "Deliver value fast"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.deliverValue.bodytext",
                    defaultMessage: "Replace costly legacy tools and deploy faster with a powerful, easy-to-use platform that has transparent pricing."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.accelerateDevOps",
                    defaultMessage: "Accelerate dev and ops"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.accelerateDevOps.bodyText",
                    defaultMessage: "Instead of siloed tools, increase visibility and the flow of work by connecting Development and IT Operations teams on a single platform."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.empowerServiceForAll",
                    defaultMessage: "Empower service for all"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.empowerServiceForAll.bodyText",
                    defaultMessage: "Help every team take ownership of their service experience and scale practices - without costly add-ons or confusing deployments."
                })
            }
        ],
        contentLink: {
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.serviceManagement.learnMore",
                defaultMessage: "Learn about service management"
            }),
            link: (0, $3FBn4.useLocalizedHref)("/solutions/itsm"),
            linkLabel: "Learn about service management",
            productKey: "enterprise"
        },
        pictureProps: {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/x2s3unwoyy1xp3222df5pu0j23fx7lki.webp",
                alt: "",
                width: 1544,
                height: 1092
            }
        },
        tabContentEyebrowText: intl.formatMessage({
            id: "EnterpriseLandingPage.tab.serviceManagement.resources",
            defaultMessage: "Service management resources"
        }),
        cardsContent: [
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.forresterReport",
                    defaultMessage: "Forrester report"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.forresterReport.headerText",
                    defaultMessage: "Atlassian is a Leader in Enterprise Service Management, Q4 2023"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.card.forresterReport.linkText",
                        defaultMessage: "Read report"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/forrester/wave-enterprise-service-management"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Read report"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/forresterWave-3356930698.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.reportWebinar",
                    defaultMessage: "ROI resources"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.reportWebinar.headerText",
                    defaultMessage: "The Total Economic Impact of Jira Service Management"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.card.reportWebinar.linkText",
                        defaultMessage: "Explore resources"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/jira/service-management/total-economic-impact-hub"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Explore resources"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/totEconomicImpact-1137923345.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.ITSMGuide",
                    defaultMessage: "Guide"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.ITSMGuide.headerText",
                    defaultMessage: "ITSM for high-velocity teams"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.card.ITSMGuide.linkText",
                        defaultMessage: "Download guide"
                    }),
                    href: "https://wac-cdn.atlassian.com/it/dam/jcr:4ec50253-90f1-4d6c-98e2-2ff994cf94db/Jira-Service-Management-Overview-Datasheet.pdf?cdnVersion=1275#:~:text=Jira%20Service%20Management%20offers%20business,approach%20of%20legacy%20ITSM%20solutions.&text=Empower%20all%20teams%20across%20IT,business%20with%20intuitive%2C%20flexible%20workflows.&text=Make%20work%20visible%20through%20the%20open%20and%20collaborative%20Jira%20platform.",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Download guide"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/itServiceMngmt-1552092334.webp",
                        alt: ""
                    }
                }
            }
        ]
    });
};

});

parcelRegister("4FzaJ", function(module, exports) {

$parcel$export(module.exports, "EnterpriseSoftwareDevelopment", function () { return $945ea06806822c59$export$24da22834a2c8907; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $efepR = parcelRequire("efepR");

var $3FBn4 = parcelRequire("3FBn4");

var $d3R1O = parcelRequire("d3R1O");
const $945ea06806822c59$export$24da22834a2c8907 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $efepR.default), {
        contentList: [
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.supercharge",
                    defaultMessage: "Supercharge dev productivity"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.supercharge.bodytext",
                    defaultMessage: "Reduce bottlenecks and keep your software teams in the flow with everything you need to discover, plan, build, and operate world-class software."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.eliminateSilos",
                    defaultMessage: "Eliminate knowledge silos"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.eliminateSilos.bodyText",
                    defaultMessage: "Create better harmony between software and business teams by keeping work visible across your entire organization."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.accelerateDevops.driveBetterOutcomes",
                    defaultMessage: "Drive better business outcomes"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.accelerateDevops.driveBetterOutcomes.bodyText",
                    defaultMessage: "Connect and visualize data from all of your Atlassian and third-party tools to make faster and more informed decisions."
                })
            }
        ],
        contentLink: {
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.softwareDevelopment.learnMore",
                defaultMessage: "Learn about software development"
            }),
            link: (0, $3FBn4.useLocalizedHref)("/teams/software-development"),
            linkLabel: "Learn about software development",
            productKey: "enterprise"
        },
        pictureProps: {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5kq1t5b8yd8rfi6b617314esnw1mt5ra.webp",
                alt: "",
                width: 1544,
                height: 1092
            }
        },
        tabContentEyebrowText: intl.formatMessage({
            id: "EnterpriseLandingPage.tab.softwareDevelopment.resources",
            defaultMessage: "Software development resources"
        }),
        cardsContent: [
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.openDevOps",
                    defaultMessage: "Solutions"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.openDevOps.headerText",
                    defaultMessage: "Open DevOps: Keep your tools, ditch the setup"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.card.openDevOps.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/solutions/devops"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Learn more"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-01-solutions@2x-310314428.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.magicQuadrant",
                    defaultMessage: "Report"
                }),
                headerText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.magicQuadrant.headerText",
                    defaultMessage: "Atlassian named a Leader in the 2024 Gartner<sup>\xae</sup> Magic Quadrant\u2122 for DevOps Platforms",
                    values: (0, $d3R1O.formatRegisteredSymbol)
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.card.magicQuadrant.linkText",
                        defaultMessage: "Read report"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/gartner/magic-quadrant-devops"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Read report"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-01-report@2x-1971220130.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.devExDemo",
                    defaultMessage: "Demo"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.devExDemo.headerText",
                    defaultMessage: "Maximize Developer Experience Demo"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.card.devExDemo.linkText",
                        defaultMessage: "Watch on-demand"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/webinars/enterprise-cloud/Maximize-Developer-Experience-with-Atlassian"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Watch on-demand"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-03-demo@2x-531224759.webp",
                        alt: ""
                    }
                }
            }
        ]
    });
};

});

parcelRegister("6b9A1", function(module, exports) {

$parcel$export(module.exports, "EnterpriseWorkManagement", function () { return $306082cfdf3eee3d$export$26da8c8cc9d60467; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $efepR = parcelRequire("efepR");

var $3FBn4 = parcelRequire("3FBn4");
const $306082cfdf3eee3d$export$26da8c8cc9d60467 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $efepR.default), {
        contentList: [
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.planForSuccess",
                    defaultMessage: "Plan for success"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.planForSuccess.bodytext",
                    defaultMessage: "Create, communicate, and organize your plans and content to make it easier for all teams to discover your org\u2019s most important work."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.collaborateOnSharedGoals",
                    defaultMessage: "Collaborate on shared goals"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.collaborateOnSharedGoals.bodyText",
                    defaultMessage: "Track and communicate your goals by sharing project status to keep everyone across your organization has visibility into work being done."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.flexYourWays",
                    defaultMessage: "Flex your ways of working"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.flexYourWays.bodyText",
                    defaultMessage: "Let your teams work the way they prefer, using their own process, language, and views while still staying connected to other team\u2019s projects."
                })
            }
        ],
        contentLink: {
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.WorkManagement.learnMore",
                defaultMessage: "Learn about work management"
            }),
            link: (0, $3FBn4.useLocalizedHref)("/solutions/work-management"),
            linkLabel: "Learn about work management",
            productKey: "enterprise"
        },
        pictureProps: {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/65p0f3lsvwv2tt0v473y166n7i4147ad.webp",
                alt: "",
                width: 1519,
                height: 1093
            }
        },
        tabContentEyebrowText: intl.formatMessage({
            id: "EnterpriseLandingPage.tab.WorkManagement.resources",
            defaultMessage: "Work management resources"
        }),
        cardsContent: [
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.workMngmtSolutionsAndTools",
                    defaultMessage: "Solutions"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.workMngmtSolutionsAndTools.headerText",
                    defaultMessage: "Atlassian Work Management solutions and tools"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.card.workMngmtSolutionsAndTools.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/solutions/work-management"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Learn more"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/work-01-solutions@2x-3900037778.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.guideToWorkMngmt",
                    defaultMessage: "Guide"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.guideToWorkMngmt.headerText",
                    defaultMessage: "A Comprehensive Guide to Work Management"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.card.guideToWorkMngmt.linkText",
                        defaultMessage: "Get the guide"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/blog/work-management/guide-to-work-management-2024"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Get the guide"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/work-02-guide@2x-511342337.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.ITSMGuide",
                    defaultMessage: "Report"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.ITSMGuide.headerText",
                    defaultMessage: "The economic benefits of improving work management with Atlassian"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.card.ITSMGuide.linkText",
                        defaultMessage: "Read report"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/whitepapers/esg-work-management-report"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Read report"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/work-03-report@2x-1528241620.webp",
                        alt: ""
                    }
                }
            }
        ]
    });
};

});



parcelRegister("1DDk6", function(module, exports) {

$parcel$export(module.exports, "CarouselSection", function () { return $5c3ebf4711ee3213$export$5edf3752a9da9c72; });
/* carousel-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $3FBn4 = parcelRequire("3FBn4");
parcelRequire("1HoZL");
var $926Vv = parcelRequire("926Vv");

var $8z7A0 = parcelRequire("8z7A0");
const $5c3ebf4711ee3213$export$5edf3752a9da9c72 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4nbubfng"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
            name: "enterprise-page-testimonials",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $926Vv.ADG4CustomerTestimonials), {
                bgColor: "black",
                heading: intl.formatMessage({
                    id: "EnterpriseLandingPage.carousel.heading",
                    defaultMessage: "Trusted by over 80% of the Fortune 500"
                }),
                cta: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.carousel.heading.cta",
                        defaultMessage: "Explore all customers stories"
                    }),
                    url: (0, $3FBn4.useLocalizedHref)("/customers?filterByEnterprise=true"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "customersSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.carousel.heading.ctaDataLabel",
                            defaultMessage: "Explore all customers stories"
                        }),
                        "data-label-english": "Explore all customers stories"
                    }
                },
                testimonials: $5c3ebf4711ee3213$var$Testimonials(),
                className: "customer-stories-carousel"
            })
        })
    });
};
const $5c3ebf4711ee3213$var$Testimonials = ()=>{
    const intl = (0, $f6qj2.default)();
    const testimonials = [
        {
            name: "Sun Life Employee",
            logo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8z7A0.TestimonialSunLife), {}),
            title: "",
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 SunLife on Black 2x 1-2143605095.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial1.quote",
                defaultMessage: "Jira Cloud and Confluence Cloud are a big step in the right direction from the previous tools we were using. All the new functionality really improved my day to day."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial1.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $3FBn4.useLocalizedHref)("/customers/sunlife"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial1.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "Sun Life"
        },
        {
            name: "Mehmet Sari",
            logo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8z7A0.TestimonialMercedesBenz), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial2.title",
                defaultMessage: "Modern Collaboration Platform Team, Mercedes-Benz"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 Mercedes-Benz on Black 2x 1-2641411897.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial2.quote",
                defaultMessage: "Atlassian cloud is the solution for high performance, high security, high availability, and the newest features."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial2.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $3FBn4.useLocalizedHref)("/customers/mercedes-benz"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial2.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "Mercedes Benz"
        },
        {
            name: "Ryan Mosley",
            logo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8z7A0.TestimonialDHCS), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial3.title",
                defaultMessage: "Chief of Factory & Engineering Modernization, DHCS"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 DHCS on Black 2x 1-2317410165.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial3.quote",
                defaultMessage: "By tracking everything in Jira and all of our developer tools, we reduced the cost to get the team set up and deliver the product from $2.8 million to $600,000."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial3.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $3FBn4.useLocalizedHref)("/customers/dhcs"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial3.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "DHCS California Department of Health Care Services"
        },
        {
            name: "Mai Lian Scarlett",
            logo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8z7A0.TestimonialLumen), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial4.title",
                defaultMessage: "Former Senior Director, Agile Transformation Office, Lumen"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 Lumen on Black 2x 1-2939378294.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial4.quote",
                defaultMessage: "Our partnership with Atlassian has really been an accelerator and an enabler to our digital transformation\u2026We\u2019re excited to see Atlassian\u2019s commitment to the cloud platform."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial4.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $3FBn4.useLocalizedHref)("/customers/lumen"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial4.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "Lumen"
        },
        {
            name: "Oxana Trotsenko",
            logo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8z7A0.TestimonialUnited), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial5.title",
                defaultMessage: "Chief of Staff of Digital Technology, United Airlines"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 United on Black 2x 1-995190318.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial5.quote",
                defaultMessage: "Atlassian cloud provides you flexibility, cost savings over time, and efficiency\u2026When I think about technology in the modern world, we would not consider anything else."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial5.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $3FBn4.useLocalizedHref)("/customers/united-airlines"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial5.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "United Airlines"
        },
        {
            name: "Evan Lerer",
            logo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8z7A0.TestimonialRedfin), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial6.title",
                defaultMessage: "Director of Engineering, Redfin"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 Redfin on Black 2x 1-8548123.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial6.quote",
                defaultMessage: "We trust Atlassian to help our team deliver world-class products that redefine real estate in the customer\u2019s favor."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial6.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $3FBn4.useLocalizedHref)("/customers/redfin"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial6.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "Redfin"
        }
    ];
    return testimonials;
};
const $5c3ebf4711ee3213$var$carouselSectionStyles = null;

});

parcelRegister("bRtJQ", function(module, exports) {

$parcel$export(module.exports, "BadgesSection", function () { return $5fea55453885ce86$export$a81af8b662eb2b7; });
/* badges.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $5fea55453885ce86$export$a81af8b662eb2b7 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "enterprise-page-badges",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_6rth8ved"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_y3gn1h6o _6rth19bv",
                        "eyebrow-md"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "EnterpriseLandingPage.badges.eyebrow",
                        defaultMessage: "Recognized by world-class analysts"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                    layout: "3-3-3-3",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)($5fea55453885ce86$var$Badge, {
                            href: (0, $3FBn4.useLocalizedHref)("/forrester/wave-enterprise-service-management"),
                            imageUrl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/forrester_wave_leader_2023-3286669196.webp",
                            imageAlt: "",
                            badgeText: intl.formatMessage({
                                id: "EnterpriseLandingPage.badges.badge1",
                                defaultMessage: "Atlassian is a Leader in The Forrester Wave\u2122: Enterprise Service Management, Q4 2023."
                            }),
                            badgeLabel: "Atlassian is a Leader in The Forrester Wave\u2122: Enterprise Service Management, Q4 2023."
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)($5fea55453885ce86$var$Badge, {
                            imageUrl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/gartner_logo.svg",
                            imageAlt: "",
                            badgeText: intl.formatMessage({
                                id: "EnterpriseLandingPage.badges.badge2",
                                defaultMessage: "A Leader in the 2023 Gartner\xae Magic Quadrant\u2122 for DevOps Platforms*"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)($5fea55453885ce86$var$Badge, {
                            imageUrl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/gartner_logo.svg",
                            imageAlt: "",
                            badgeText: intl.formatMessage({
                                id: "EnterpriseLandingPage.badges.badge3",
                                defaultMessage: "A Leader in the 2023 Gartner\xae Magic Quadrant\u2122 for Enterprise Agile Planning Tools*"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)($5fea55453885ce86$var$Badge, {
                            imageUrl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Peer-Insights-Customers-Choice-2023.svg",
                            imageAlt: "",
                            badgeText: intl.formatMessage({
                                id: "EnterpriseLandingPage.badges.badge4",
                                defaultMessage: "A Gartner\xae Peer Insights\u2122 Customers' Choice for Enterprise Agile Planning Tools."
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $5fea55453885ce86$var$badgeSectionStyles = null;
const $5fea55453885ce86$var$divStyles = null;
const $5fea55453885ce86$var$Badge = ({ href: href, imageUrl: imageUrl, imageAlt: imageAlt, badgeText: badgeText, badgeLabel: badgeLabel })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1ml653f4 _kmx4ys9h _q1391ule _1cac1wug _14fh1wug _gdebo7ao _qgibo7ao _1bsa1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
            href: href,
            "data-product-key": "enterprise",
            "data-event-component": "link",
            "data-event-container": "badgesSection",
            "data-event": "clicked",
            "data-label": badgeText,
            "data-label-english": badgeLabel,
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: "image-container",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                        src: imageUrl,
                        alt: imageAlt
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: "badge-text body-sm",
                    children: badgeText
                })
            ]
        })
    });
};
const $5fea55453885ce86$var$BadgeStyles = null;

});

parcelRegister("bwE7U", function(module, exports) {

$parcel$export(module.exports, "EnterprisePageProductNav", function () { return $3f60c9aa58855bbf$export$e36ad2737327f9c; });
$parcel$export(module.exports, "default", function () { return $3f60c9aa58855bbf$export$2e2bcd8739ae039; });
/* enterprise-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");
const $3f60c9aa58855bbf$var$logoWrapperStyles = null;
const $3f60c9aa58855bbf$var$EnterpriseLogo = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1q51v77o _4t3i1osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Logo), {
            brand: "enterprise",
            type: "logo",
            appearance: "brand"
        })
    });
const $3f60c9aa58855bbf$export$e36ad2737327f9c = ({ isActive: isActive })=>{
    const intl = (0, $f6qj2.default)();
    const ctaButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.navbar.cta",
        defaultMessage: "Contact sales"
    });
    const mobileCtaButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.navbar.mobile.cta",
        defaultMessage: "Contact sales"
    });
    const links = [
        {
            globalLinksKey: "overview",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.overview",
                defaultMessage: "Overview"
            }),
            hasSubnav: false,
            isActive: isActive == "overview",
            productKey: "enterprise",
            href: (0, $3FBn4.useLocalizedHref)("/enterprise")
        },
        {
            globalLinksKey: "success",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.success",
                defaultMessage: "Success"
            }),
            hasSubnav: false,
            isActive: isActive == "success",
            productKey: "enterprise",
            href: (0, $3FBn4.useLocalizedHref)("/enterprise/success")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            isActive: isActive == "resources",
            productKey: "enterprise",
            href: (0, $3FBn4.useLocalizedHref)("/enterprise/resources")
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "enterprise-page-product-navigation",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
            productLogoUrl: (0, $3FBn4.useLocalizedHref)("/enterprise"),
            productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($3f60c9aa58855bbf$var$EnterpriseLogo, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "EnterpriseLandingPage.label",
                defaultMessage: "Enterprise"
            }),
            mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($3f60c9aa58855bbf$var$EnterpriseLogo, {}),
            productPageNavLinks: links,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-enterprise",
                    mobileLinksProps: links
                }
            ],
            navigationTrynowCtaText: ctaButtonText,
            navigationTrynowCtaUrl: (0, $3FBn4.useLocalizedHref)("/enterprise/contact?formType=product-features"),
            mobileCtaText: mobileCtaButtonText,
            mobileCtaUrl: (0, $3FBn4.useLocalizedHref)("/enterprise/contact?formType=product-features")
        })
    });
};
var $3f60c9aa58855bbf$export$2e2bcd8739ae039 = $3f60c9aa58855bbf$export$e36ad2737327f9c;

});

parcelRegister("8A8QS", function(module, exports) {

$parcel$export(module.exports, "HeroV2Section", function () { return $9eb9661fb5f8913d$export$cd8aff68574ce209; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $aX40r = parcelRequire("aX40r");

var $7wGIa = parcelRequire("7wGIa");

var $5o8uh = parcelRequire("5o8uh");

var $fAcZc = parcelRequire("fAcZc");
const $9eb9661fb5f8913d$export$11abae89ba61f3a8 = 8000;
const $9eb9661fb5f8913d$export$cd8aff68574ce209 = ()=>{
    const intl = (0, $f6qj2.default)();
    const tabs = [
        {
            tabComponent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5o8uh.EnterpriseTabContent), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.enterprise",
                defaultMessage: "Enterprise"
            }),
            caption: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.enterprise.caption",
                defaultMessage: "Atlassian\u2019s System of Work"
            }),
            englishLabel: "enterprise",
            id: "enterprise"
        },
        {
            tabComponent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fAcZc.ProductTabContent), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.product",
                defaultMessage: "Product"
            }),
            caption: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.product.caption",
                defaultMessage: "Atlassian\u2019s latest AI innovation"
            }),
            englishLabel: "product",
            id: "product"
        },
        {
            tabComponent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7wGIa.AnalystsTabContent), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.analysts",
                defaultMessage: "Analysts"
            }),
            caption: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.analysts.caption",
                defaultMessage: "Gartner Magic Quadrant Leader"
            }),
            englishLabel: "analysts",
            id: "analysts"
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aX40r.EnterpriseTabsWithCards), {
        tabsData: tabs,
        tabSwitchInterval: $9eb9661fb5f8913d$export$11abae89ba61f3a8
    });
};

});
parcelRegister("aX40r", function(module, exports) {

$parcel$export(module.exports, "EnterpriseTabsWithCards", function () { return $73b4cc7d3d6bb8e6$export$255fc2fb2ce9d4ee; });
/* enterprise-tabs-with-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $cutM5 = parcelRequire("cutM5");
const $73b4cc7d3d6bb8e6$var$Tab = ({ title: title, caption: caption, isSelected: isSelected, dataEventProps: dataEventProps })=>{
    const eyebrowStyle = null;
    const captionStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("button", (0, $6iHNw._)((0, $7Knp0._)({}, dataEventProps), {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bsb1ns9 _4t3i1osq _1tkekz1e _p12f5jys _ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg _2lx21bp4 _4cvr1y6m _80omtlke _16jlkb7n _2rkogktf _19itglyw _11q7u66n _16qss1rx _ect4lnmy _k48p1nn1 _1wybgktf _syaz1iem _152tr8pp _v5641gvb _1mdbkz1e _uhd05jys _1j96zwfg _jvmrzwfg _k0mszwfg _1b7pzwfg _1x6l13rr _j6qupd6w _xut117n1 _ceho8wlv _jx4017n1 _1i7q122r _1dbzyicz",
            isSelected && "_19it1oen _16qsyicz _syazr3uz"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_ect48q0o _1wybdlk8 _zg8l4jg8 _k48p1nn1 _vwz4f6fq _1p1dangw _19pkidpf _2hwxidpf _otyr7vkz _18u0idpf"
                ]),
                children: title
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_ect4kipj _1wybf6fq _zg8l4jg8 _k48p1fw0 _vwz41tcg _y3gn1e5h _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1fhb _1bsb1osq"
                ]),
                children: caption
            })
        ]
    }));
};
const $73b4cc7d3d6bb8e6$export$255fc2fb2ce9d4ee = ({ tabsData: tabsData, tabSwitchInterval: tabSwitchInterval })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        id: "tabs",
        className: (0, $esG4f.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cutM5.Adg4Tabs), {
            tabSwitchInterval: tabSwitchInterval,
            loop: true,
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswh2mm _1e0c1ule"
                    ]),
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4TabPanel), {
                            panelIndex: index,
                            id: tab.id,
                            children: tab.tabComponent
                        }, index))
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswh2mm _1e0c1ule _1pbycs5v _152tr8pp"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTabList), {
                        rowGap: "12px",
                        className: (0, $esG4f.default)([
                            "_ca0qidpf _u5f31wqb _n3td1qjk _19bv1wqb _1e0c1txw _4cvr1fhb _zulpzwfg _1kmxidpf _1ggmzwfg _1ykz1ul9 _1maezwfg",
                            "tab-list"
                        ]),
                        children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTab), {
                                tabIndex: index,
                                className: "round-tab",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)($73b4cc7d3d6bb8e6$var$Tab, {
                                    title: tab.title,
                                    caption: tab.caption,
                                    dataEventProps: {
                                        "data-product-key": "home",
                                        "data-event": "clicked",
                                        "data-event-component": "button",
                                        "data-event-container": "tabsMenu",
                                        "data-label": tab.title,
                                        "data-label-english": tab.englishLabel
                                    }
                                })
                            }, index))
                    })
                })
            ]
        })
    });
};
const $73b4cc7d3d6bb8e6$var$topSectionStyles = null;
const $73b4cc7d3d6bb8e6$var$bottomSectionStyles = null;
const $73b4cc7d3d6bb8e6$var$sectionStyles = null;
const $73b4cc7d3d6bb8e6$var$tabList = null;
const $73b4cc7d3d6bb8e6$var$tabStyles = null;
const $73b4cc7d3d6bb8e6$var$currentStyle = null;

});

parcelRegister("7wGIa", function(module, exports) {

$parcel$export(module.exports, "AnalystsTabContent", function () { return $462f3e6308cbb906$export$bfe5f81b459a55ca; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $2h2NK = parcelRequire("2h2NK");

var $3FBn4 = parcelRequire("3FBn4");
const $462f3e6308cbb906$export$bfe5f81b459a55ca = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $2h2NK.EnterpriseHero), {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.analysts.header",
            defaultMessage: "Atlassian named a Leader in DevOps Platforms by Gartner"
        }),
        bodyText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.analysts.body",
            defaultMessage: "Learn about our unified DevOps platform that connects engineering, IT Ops, and business teams"
        }),
        textAlign: "right",
        cta: {
            text: intl.formatMessage({
                id: "EnterpriseLandingPage.hero.analysts.cta",
                defaultMessage: "Read the report"
            }),
            dataEventProps: {
                "data-product-key": "enterprise",
                "data-event-component": "linkButton",
                "data-event-container": "heroSection",
                "data-event": "clicked",
                "data-label": "enterprise-hero-analysts-cta",
                "data-label-english": "Read the report"
            },
            href: (0, $3FBn4.useLocalizedHref)("/gartner/magic-quadrant-devops")
        },
        ctaType: "button",
        color: "light",
        backgroundImgSrc: {
            xs: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-carousel/bg-mag-quad-xs.webp",
            sm: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-carousel/bg-mag-quad-sm.webp",
            md: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-carousel/bg-mag-quad-md.webp",
            lg: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-carousel/bg-mag-quad-lg.webp"
        }
    });
};

});
parcelRegister("2h2NK", function(module, exports) {

$parcel$export(module.exports, "EnterpriseHero", function () { return $4437c9def831ed94$export$9d702f5b43ea4715; });
/* enterprise-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $91nJf = parcelRequire("91nJf");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
const $4437c9def831ed94$var$contentMaxWidth = {
    center: {
        xs: "378px",
        sm: "534px",
        md: "568px",
        lg: "568px"
    },
    left: {
        xs: "378px",
        sm: "421px",
        md: "514px",
        lg: "568px"
    },
    right: {
        xs: "378px",
        sm: "365px",
        md: "514px",
        lg: "668px"
    }
};
const $4437c9def831ed94$export$9d702f5b43ea4715 = ({ headerText: headerText, bodyText: bodyText, textAlign: textAlign = "center", color: color = "light", cta: cta, ctaType: ctaType, backgroundImgSrc: backgroundImgSrc })=>{
    const textColor = color === "light" ? (0, $5ohHq.wacToken)("color.neutral.light0") : (0, $5ohHq.wacToken)("color.primary.black");
    const inlineStart = textAlign === "left" ? "199.5px" : textAlign === "right" ? "-140px" : "0";
    const alignItems = textAlign === "left" ? "flex-start" : textAlign === "right" ? "flex-end" : "center";
    const justifyContent = textAlign === "left" ? "flex-start" : textAlign === "right" ? "flex-end" : "center";
    const containerStyle = null;
    const { md: md, lg: lg } = $4437c9def831ed94$var$contentMaxWidth[textAlign];
    const contentStyle = null;
    const headerStyle = null;
    const bodyStyle = null;
    const ctaStyle = null;
    const CallToAction = ()=>{
        if (!cta) return null;
        if (ctaType === "button") {
            const { text: text, href: href, dataEventProps: dataEventProps } = cta;
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                variant: "primary",
                size: "small",
                color: "yellow",
                href: href,
                dataEventProps: dataEventProps,
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1wpzn3xj _es5ofn2t _1gwbyfnk"
                ]),
                style: {
                    "--_k2wmiu": (0, $43MIc.default)(alignItems),
                    "--_2idk6s": (0, $43MIc.default)(textAlign === "center" ? "center" : "flex-start"),
                    "--_1t1mgkw": (0, $43MIc.default)(textAlign === "right" ? "center" : alignItems)
                },
                children: text
            });
        } else if (ctaType === "link") {
            const { text: text, href: href, dataEventProps: dataEventProps } = cta;
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                type: "external",
                href: href,
                text: text,
                dataEventProps: dataEventProps
            });
        }
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
            children: cta
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_y44v19jp _11q7xprm _p12fklux _4t3i1c5i _1o9zidpf _kqswh2mm _19pk1wqb _2hwx1wug _otyridpf _18u01wug _ca0qidpf _u5f3zwfg _n3tdidpf _19bvzwfg _1e0c1txw _1bahjlb8 _4cvr1h6o _yj3y1b9g _1d4udzi4 _1j96idpf _jvmr1wqb _k0msidpf _1b7p1wqb _ibctnzkm _v8ts8nql _2ysd8nql"
        ]),
        style: {
            "--_n0tana": (0, $43MIc.default)(backgroundImgSrc === null || backgroundImgSrc === void 0 ? void 0 : backgroundImgSrc.xs, ")", "url("),
            "--_1ecqhzh": (0, $43MIc.default)(justifyContent),
            "--_188fmqn": (0, $43MIc.default)(textAlign === "right" ? "center" : justifyContent),
            "--_c4618e": (0, $43MIc.default)(textAlign === "right" ? `url(${backgroundImgSrc === null || backgroundImgSrc === void 0 ? void 0 : backgroundImgSrc.xs}) 50% / 100% 100% no-repeat` : `url(${backgroundImgSrc === null || backgroundImgSrc === void 0 ? void 0 : backgroundImgSrc.sm}) 50% / cover no-repeat`),
            "--_450zrg": (0, $43MIc.default)(backgroundImgSrc === null || backgroundImgSrc === void 0 ? void 0 : backgroundImgSrc.md, ")", "url("),
            "--_11tlo2t": (0, $43MIc.default)(backgroundImgSrc === null || backgroundImgSrc === void 0 ? void 0 : backgroundImgSrc.lg, ")", "url(")
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_kqswh2mm _1e0c1txw _2lx21bp4 _1bahkeqs _4cvrn3xj _18s81any _y3gn2i2r _p12f1oh5 _7bccng7t _b14zybpo _sfxvybpo _10vrkeqs _yir31oh5 _1rsv1oh5 _1190gb00 _ytj9ydnc"
            ]),
            style: {
                "--_ux0pmw": (0, $43MIc.default)(textAlign),
                "--_k2wmiu": (0, $43MIc.default)(alignItems),
                "--_1x9bz3": (0, $43MIc.default)(textAlign === "center" ? "0 auto" : "0"),
                "--_xk83tk": (0, $43MIc.default)(textAlign === "center" ? "center" : "left"),
                "--_14ulcc6": (0, $43MIc.default)(textAlign === "right" ? "center" : textAlign),
                "--_1itq52x": (0, $43MIc.default)(inlineStart),
                "--_1ndsstv": (0, $43MIc.default)(textAlign === "right" ? "668px" : "568px")
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    className: (0, $esG4f.default)([
                        "_ect41pz4 _1wybigbc _zg8l4jg8 _k48p9y44 _vwz4v9r7 _18s81khp _syaz1u00 _50pk12am _167l1ady _1sg4idpf _maxsidpf _1jvh1f4h _1ucaidpf _b14zybpo _17gq8vuz _1s18ckbl _15flidpf _1d2widpf _1svy7vkz _seovidpf",
                        "enterprise-hero-header-text"
                    ]),
                    style: {
                        "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display")),
                        "--_j86zen": (0, $43MIc.default)(textAlign === "right" ? "10vw" : "44px"),
                        "--_1l1q5sn": (0, $43MIc.default)(textAlign === "right" ? "12vw" : "50px"),
                        "--_192zam2": (0, $43MIc.default)(textAlign === "right" ? "0 0 5vw 0" : "0 0 28px 0"),
                        "--_srel9g": (0, $43MIc.default)(textColor),
                        "--_14ulcc6": (0, $43MIc.default)(textAlign === "right" ? "center" : textAlign)
                    },
                    children: headerText
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    className: (0, $esG4f.default)([
                        "_ect4bzd7 _1wyb7vkz _zg8l4jg8 _k48p1nn1 _vwz41tcg _4t3i1ns9 _c71lt9kd _1bsb1ns9 _19pkidpf _2hwxidpf _otyr1f4h _18u0idpf _syaz1u00 _b14zybpo _1dxp1yu0 _1sg4idpf _maxsidpf _1jvhzwfg _1ucaidpf _b8yq1ns9 _1s18gktf _17gq1f4h"
                    ]),
                    style: {
                        "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                        "--_srel9g": (0, $43MIc.default)(textColor),
                        "--_14ulcc6": (0, $43MIc.default)(textAlign === "right" ? "center" : textAlign)
                    },
                    children: bodyText
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)(CallToAction, {})
            ]
        })
    });
};

});


parcelRegister("5o8uh", function(module, exports) {

$parcel$export(module.exports, "EnterpriseTabContent", function () { return $c7bd5c6898a0abe5$export$6b3a3100e0e8582e; });
/* eslint-disable local/no-non-orangelogic-images-eslint */ 
var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $2h2NK = parcelRequire("2h2NK");
const $c7bd5c6898a0abe5$export$6b3a3100e0e8582e = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $2h2NK.EnterpriseHero), {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.enterprise-new.headerText",
            defaultMessage: "Forward Together"
        }),
        bodyText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.enterprise-new.bodyText",
            defaultMessage: "Discover how Atlassian Williams Racing is accelerating teamwork transformation on the grid using the Atlassian Cloud Platform."
        }),
        cta: {
            text: intl.formatMessage({
                id: "EnterpriseLandingPage.hero.enterprise.cta",
                defaultMessage: "Watch video"
            }),
            dataEventProps: {
                "data-product-key": "enterprise",
                "data-event-component": "linkButton",
                "data-event-container": "heroSection",
                "data-event": "clicked",
                "data-label": "enterprise-hero-enterprise-cta",
                "data-label-english": "Watch video"
            },
            href: "https://www.youtube.com/watch?v=sSKY7pNdlvI"
        },
        ctaType: "link",
        color: "dark",
        backgroundImgSrc: {
            xs: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-sm-107626183.webp",
            sm: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-md-2984500272.webp",
            md: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-lg-2107118674.webp",
            lg: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-1621379571.webp"
        }
    });
};

});

parcelRegister("fAcZc", function(module, exports) {

$parcel$export(module.exports, "ProductTabContent", function () { return $cac3f8bda1c8ed8b$export$36e1444062b1b431; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $2h2NK = parcelRequire("2h2NK");

var $3FBn4 = parcelRequire("3FBn4");
const $cac3f8bda1c8ed8b$export$36e1444062b1b431 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $2h2NK.EnterpriseHero), {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.product.header",
            defaultMessage: "Say Hello to Rovo"
        }),
        bodyText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.product.body",
            defaultMessage: "Atlassian's AI-powered solution that makes teamwork easier and faster."
        }),
        textAlign: "center",
        cta: {
            text: intl.formatMessage({
                id: "EnterpriseLandingPage.hero.product.cta",
                defaultMessage: "Learn more"
            }),
            dataEventProps: {
                "data-product-key": "enterprise",
                "data-event-component": "linkButton",
                "data-event-container": "heroSection",
                "data-event": "clicked",
                "data-label": "enterprise-hero-product-cta",
                "data-label-english": "Learn more"
            },
            href: (0, $3FBn4.useLocalizedHref)("/software/rovo")
        },
        ctaType: "button",
        color: "dark",
        backgroundImgSrc: {
            xs: "https://wac-cdn.atlassian.com/misc-assets/webp-images/bg-rovo-mobile@2x-1408243573.webp",
            sm: "https://wac-cdn.atlassian.com/misc-assets/webp-images/bg-rovo-tablet@2x-1411287807.webp",
            md: "https://wac-cdn.atlassian.com/misc-assets/webp-images/bg-rovo-desktop-S@2x-1748573145.webp",
            lg: "https://wac-cdn.atlassian.com/misc-assets/webp-images/bg-rovo-desktop-L@2x-2396412742.webp"
        }
    });
};

});






parcelRegister("jJFPZ", function(module, exports) {

$parcel$export(module.exports, "JiraLandingPage", function () { return $7254183d9cfc8753$export$6ef3579312c51d6a; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("7e8IA");
var $cNEGt = parcelRequire("cNEGt");
const $7254183d9cfc8753$export$6ef3579312c51d6a = ()=>{
    const template = /*#__PURE__*/ (0, $loA2J.jsx)((0, $cNEGt.LoggedOutOrNoJiraProductTourOverview), {});
    return template;
};

});
parcelRegister("7e8IA", function(module, exports) {
$parcel$export(module.exports, "LoggedOutOrNoJiraProductTourOverview", function () { return (parcelRequire("cNEGt")).LoggedOutOrNoJiraProductTourOverview; });

var $cNEGt = parcelRequire("cNEGt");

});
parcelRegister("cNEGt", function(module, exports) {

$parcel$export(module.exports, "LoggedOutOrNoJiraProductTourOverview", function () { return $99096c301ab3974e$export$94dc3fb7b045f547; });
/* jira-software-logged-out-page.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dyZbY = parcelRequire("dyZbY");

var $iMdoL = parcelRequire("iMdoL");

var $5ohHq = parcelRequire("5ohHq");

var $jq0gD = parcelRequire("jq0gD");
parcelRequire("ccYBS");
var $1FqEx = parcelRequire("1FqEx");

var $dJVgs = parcelRequire("dJVgs");

var $7eVxf = parcelRequire("7eVxf");

var $fz6gY = parcelRequire("fz6gY");

var $ffiZE = parcelRequire("ffiZE");
parcelRequire("gTvSH");
var $dChrM = parcelRequire("dChrM");
var $i8fOS = parcelRequire("i8fOS");
var $eceIQ = parcelRequire("eceIQ");
var $3YHG8 = parcelRequire("3YHG8");
var $LSaI0 = parcelRequire("LSaI0");
var $3lrJv = parcelRequire("3lrJv");
var $ifaJo = parcelRequire("ifaJo");

var $4SPlL = parcelRequire("4SPlL");

var $amOtK = parcelRequire("amOtK");
const $99096c301ab3974e$export$94dc3fb7b045f547 = ()=>{
    const isLoggedOut = (0, $iMdoL.useLoggedOut)();
    let heroSection = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dChrM.NoJiraHeroSection), {});
    if (isLoggedOut) heroSection = /*#__PURE__*/ (0, $loA2J.jsx)((0, $amOtK.LoggedOutHeroSection), {});
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $dyZbY.default), {
        name: "logged-out-no-jira-product-tour",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $fz6gY.JiraSoftwarePageBannerAlert), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jq0gD.default), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJVgs.default), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("main", {
                "data-testid": "loggedOutNoJira",
                id: "content",
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _1reo15vq _18m915vq"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1FqEx.ParentScrollTracking), {
                    scrollTrackingEnabled: true,
                    pageId: "Jira",
                    children: [
                        heroSection,
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $ffiZE.GartnerSection), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $i8fOS.JswCollaborateSection), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eVxf.AiRefreshSection), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $eceIQ.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $3YHG8.JswDoubleFeatureSection), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $LSaI0.IntegrationsSection), {}),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_bfhk17la"
                            ]),
                            style: {
                                "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                            },
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $3lrJv.TestimonialSection), {}),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $ifaJo.ClosingBanner), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $4SPlL.Footer), {})
                    ]
                })
            })
        ]
    });
};
const $99096c301ab3974e$var$sectionContainerStyles = null;
const $99096c301ab3974e$var$backgroundStyles = null;

});
parcelRegister("jq0gD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5a34c2ff8a2778c$export$2e2bcd8739ae039; });
/* sticky-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $gAJUc = parcelRequire("gAJUc");
const $c5a34c2ff8a2778c$var$StickyContainer = ({ children: children })=>{
    const isMultipleStickyStart = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).wacLiftedBannerSticky);
    if (!isMultipleStickyStart) return children;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": "banner-nav-combo",
        className: (0, $esG4f.default)([
            "_kqsw1if8 _152tidpf _1pbyqfx8"
        ]),
        children: children
    });
};
const $c5a34c2ff8a2778c$var$sticky = null;
var $c5a34c2ff8a2778c$export$2e2bcd8739ae039 = $c5a34c2ff8a2778c$var$StickyContainer;

});

parcelRegister("dJVgs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95299be710b4e4ff$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $hbBKK = parcelRequire("hbBKK");

var $9g0oR = parcelRequire("9g0oR");

var $gAJUc = parcelRequire("gAJUc");
parcelRequire("wXgqV");
var $6TGlD = parcelRequire("6TGlD");
parcelRequire("5goCs");
var $epQac = parcelRequire("epQac");
const $95299be710b4e4ff$var$JiraLogo = ()=>{
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV2), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    });
};
const $95299be710b4e4ff$var$JiraSoftwareNav = ({ productNavCtaCTAClickFunction: productNavCtaCTAClickFunction, isUseOpenCrossFlow: isUseOpenCrossFlow = false })=>{
    var _newLinks_find, _newLinks_find1;
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&edition=free");
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).JIRA_SOFTWARE,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    const productNavOnClick = (0, $iSvIT.useMemo)(()=>productNavCtaCTAClickFunction && isUseOpenCrossFlow ? productNavCtaCTAClickFunction : openCrossFlow, [
        openCrossFlow,
        productNavCtaCTAClickFunction,
        isUseOpenCrossFlow
    ]);
    const solutionsDropdownStyles = (0, $iSvIT.useMemo)(()=>{
        return {
            width: "fit-content !important",
            margin: 0,
            transform: "translateX(-40%)"
        };
    }, []);
    // Teams Hrefs
    const marketingHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/marketing");
    const engineeringHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/engineering");
    const designHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/design");
    const operationsHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/operations");
    const itHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/it");
    // Use Cases Hrefs
    const planningHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/planning");
    const campaignManagementHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/campaign-management");
    const agileProjectManagementHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/agile-project-management");
    const programManagementHref = (0, $3FBn4.useLocalizedHref)("/jira/solutions/program-management");
    //Company Size Hrefs
    const enterpriseHref = (0, $3FBn4.useLocalizedHref)("/software/jira/enterprise");
    const solutionsDropdown = (0, $iSvIT.useMemo)(()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $9g0oR.DropdownContent), {
            contentSections: [
                {
                    header: intl.formatMessage({
                        id: "software-jira.navbar.solutions.teams.header",
                        defaultMessage: "Teams"
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.marketing",
                                defaultMessage: "Marketing"
                            }),
                            href: marketingHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.engineering",
                                defaultMessage: "Engineering"
                            }),
                            href: engineeringHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.design",
                                defaultMessage: "Design"
                            }),
                            href: designHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.operations",
                                defaultMessage: "Operations"
                            }),
                            href: operationsHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.it",
                                defaultMessage: "IT"
                            }),
                            href: itHref
                        }
                    ]
                },
                {
                    header: intl.formatMessage({
                        id: "software-jira.navbar.solutions.useCases.header",
                        defaultMessage: "Use Cases"
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.useCases.planning",
                                defaultMessage: "Planning"
                            }),
                            href: planningHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.useCases.campaign-management",
                                defaultMessage: "Campaign Management"
                            }),
                            href: campaignManagementHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.useCases.agile-project-management",
                                defaultMessage: "Agile Project Management"
                            }),
                            href: agileProjectManagementHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.useCases.program-management",
                                defaultMessage: "Program Management"
                            }),
                            href: programManagementHref
                        }
                    ]
                },
                {
                    header: intl.formatMessage({
                        id: "software-jira.navbar.solutions.companySize.header",
                        defaultMessage: "Company Size"
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.companySize.enterprise",
                                defaultMessage: "Enterprise"
                            }),
                            href: enterpriseHref
                        }
                    ]
                }
            ]
        }), [
        intl,
        marketingHref,
        engineeringHref,
        designHref,
        operationsHref,
        itHref,
        planningHref,
        campaignManagementHref,
        agileProjectManagementHref,
        programManagementHref,
        enterpriseHref
    ]);
    const featuresHref = (0, $3FBn4.useLocalizedHref)("/software/jira/features");
    const productGuideHref = (0, $3FBn4.useLocalizedHref)("/software/jira/guides/getting-started/introduction");
    const templatesHref = (0, $3FBn4.useLocalizedHref)("/software/jira/templates");
    const pricingHref = (0, $3FBn4.useLocalizedHref)("/software/jira/pricing");
    const productLogoHref = (0, $3FBn4.useLocalizedHref)("/software/jira");
    const templateCategoriesShown = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).jiraTemplatesDxpMigration);
    const featuresDropdownShown = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).jiraFeaturesSubNav);
    const templatesLinkContent = (0, $iSvIT.useMemo)(()=>{
        const common = {
            globalLinksKey: "templates",
            linkText: intl.formatMessage({
                id: "software-jira.navbar.templates",
                defaultMessage: "Templates"
            }),
            productKey: "jira"
        };
        return templateCategoriesShown ? (0, $6iHNw._)((0, $7Knp0._)({}, common), {
            hasSubnav: true,
            content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $epQac.TemplateCategoriesDropdown), {}),
            dropdownType: "templates",
            containerPosition: "relative"
        }) : (0, $6iHNw._)((0, $7Knp0._)({}, common), {
            hasSubnav: false,
            href: templatesHref
        });
    }, [
        templatesHref,
        templateCategoriesShown
    ]);
    const featuresLinkContent = (0, $iSvIT.useMemo)(()=>{
        const common = {
            globalLinksKey: "features",
            linkText: intl.formatMessage({
                id: "software-jira.navbar.features",
                defaultMessage: "Features"
            }),
            productKey: "jira"
        };
        return featuresDropdownShown ? (0, $6iHNw._)((0, $7Knp0._)({}, common), {
            hasSubnav: true,
            content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6TGlD.FeaturesDropdown), {}),
            dropdownType: "features",
            containerPosition: "relative"
        }) : (0, $6iHNw._)((0, $7Knp0._)({}, common), {
            hasSubnav: false,
            href: featuresHref
        });
    }, [
        featuresHref,
        featuresDropdownShown
    ]);
    const newLinks = (0, $iSvIT.useMemo)(()=>[
            featuresLinkContent,
            {
                globalLinksKey: "solutions",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.solutions",
                    defaultMessage: "Solutions"
                }),
                hasSubnav: true,
                productKey: "jira",
                containerPosition: "relative",
                containerStyles: solutionsDropdownStyles,
                dropdownType: "solutions",
                content: solutionsDropdown
            },
            {
                globalLinksKey: "productGuide",
                linkText: gwp7518NavIconUpdates ? intl.formatMessage({
                    id: "software-jira.navbar.product-guide-gwp-7518",
                    defaultMessage: "Guide"
                }) : intl.formatMessage({
                    id: "software-jira.navbar.product-guide",
                    defaultMessage: "Product guide"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: productGuideHref
            },
            templatesLinkContent,
            {
                globalLinksKey: "pricing",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.pricing",
                    defaultMessage: "Pricing"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: pricingHref
            }
        ], [
        intl,
        featuresHref,
        solutionsDropdown,
        solutionsDropdownStyles,
        productGuideHref,
        templatesHref,
        pricingHref
    ]);
    const links = (0, $iSvIT.useMemo)(()=>[
            {
                globalLinksKey: "features",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.features",
                    defaultMessage: "Features"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: featuresHref
            },
            {
                globalLinksKey: "productGuide",
                linkText: gwp7518NavIconUpdates ? intl.formatMessage({
                    id: "software-jira.navbar.product-guide-gwp-7518",
                    defaultMessage: "Guide"
                }) : intl.formatMessage({
                    id: "software-jira.navbar.product-guide",
                    defaultMessage: "Product guide"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: productGuideHref
            },
            templatesLinkContent,
            {
                globalLinksKey: "pricing",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.pricing",
                    defaultMessage: "Pricing"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: pricingHref
            },
            {
                globalLinksKey: "enterprise",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.enterprise",
                    defaultMessage: "Enterprise"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: enterpriseHref
            }
        ], [
        enterpriseHref,
        featuresHref,
        intl,
        pricingHref,
        productGuideHref,
        templatesHref
    ]);
    const globalNavItemKeys = (0, $iSvIT.useMemo)(()=>{
        return links.map((link)=>link.globalLinksKey);
    }, [
        links
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hbBKK.GlobalNavProvider), {
        globalNavItemKeys: globalNavItemKeys,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
            productLogoUrl: productLogoHref,
            productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($95299be710b4e4ff$var$JiraLogo, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "wacJiraSoftwareNavigation.logo-label",
                defaultMessage: "Jira Software logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "JiraeSoftwarePageTemplate.navbar.getitfree",
                defaultMessage: "Get it free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: (e)=>{
                if (productNavOnClick) productNavOnClick(e);
            },
            mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($95299be710b4e4ff$var$JiraLogo, {}),
            navigationTrynowCtaText: intl.formatMessage({
                id: "JiraFeatureSoftwarePageTemplate.heroCTA",
                defaultMessage: "Get it free"
            }),
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: (e)=>{
                if (productNavOnClick) productNavOnClick(e);
            },
            productPageNavLinks: newLinks,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-jira",
                    mobileLinksProps: newLinks
                }
            ],
            additionalMenuPageObjectsArray: [
                {
                    menuPageKey: "solutions",
                    menuPageObjects: (_newLinks_find = newLinks.find((link)=>link.globalLinksKey === "solutions")) === null || _newLinks_find === void 0 ? void 0 : _newLinks_find.content
                },
                {
                    menuPageKey: "templates",
                    menuPageObjects: (_newLinks_find1 = newLinks.find((link)=>link.globalLinksKey === "templates")) === null || _newLinks_find1 === void 0 ? void 0 : _newLinks_find1.content
                }
            ]
        })
    });
};
$95299be710b4e4ff$var$JiraSoftwareNav.displayName = "JiraSoftwareNav";
var $95299be710b4e4ff$export$2e2bcd8739ae039 = $95299be710b4e4ff$var$JiraSoftwareNav;

});
parcelRegister("wXgqV", function(module, exports) {
$parcel$export(module.exports, "FeaturesDropdown", function () { return (parcelRequire("6TGlD")).FeaturesDropdown; });
parcelRequire("6TGlD");

});
parcelRegister("6TGlD", function(module, exports) {

$parcel$export(module.exports, "FeaturesDropdown", function () { return $931d8f64452f5962$export$ad0d22100914784b; });
// @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");

var $9g0oR = parcelRequire("9g0oR");
const $931d8f64452f5962$export$ad0d22100914784b = ()=>{
    const locale = (0, $3FBn4.useLocale)();
    const intl = (0, $f6qj2.default)();
    const allFeaturesLink = {
        text: intl.formatMessage({
            id: "jira.FeaturesDropdown.allFeatures",
            defaultMessage: "All Features"
        }),
        href: (0, $3FBn4.getLocalizedHref)({
            href: "/software/jira/features",
            locale: locale
        })
    };
    const featureLinks = [
        {
            text: intl.formatMessage({
                id: "jira.FeaturesDropdown.rovo",
                defaultMessage: "Rovo in Jira"
            }),
            href: (0, $3FBn4.getLocalizedHref)({
                href: "/software/jira/ai",
                locale: locale
            })
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9g0oR.DropdownContent), {
        orientation: "column",
        contentSections: [
            {
                links: [
                    allFeaturesLink,
                    ...featureLinks
                ]
            }
        ]
    });
};

});


parcelRegister("5goCs", function(module, exports) {
$parcel$export(module.exports, "TemplateCategoriesDropdown", function () { return (parcelRequire("epQac")).TemplateCategoriesDropdown; });
parcelRequire("epQac");

});
parcelRegister("epQac", function(module, exports) {

$parcel$export(module.exports, "TemplateCategoriesDropdown", function () { return $b829a312c9341cb7$export$8bb7e16f8f8a7ba6; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");

var $9g0oR = parcelRequire("9g0oR");
parcelRequire("jF7is");
var $ijtPZ = parcelRequire("ijtPZ");
const $b829a312c9341cb7$export$8bb7e16f8f8a7ba6 = ()=>{
    const locale = (0, $3FBn4.useLocale)();
    const intl = (0, $f6qj2.default)();
    const { data: data } = (0, $ijtPZ.useJiraTemplateCategories)();
    const allTemplateLink = {
        text: intl.formatMessage({
            id: "ira.TemplateCategoriesDropdown.allTemplates",
            defaultMessage: "All templates"
        }),
        href: (0, $3FBn4.getLocalizedHref)({
            href: "/software/jira/templates",
            locale: locale
        })
    };
    const templateLinks = data.map((category)=>({
            text: category.categoryNameExternal,
            href: (0, $3FBn4.getLocalizedHref)({
                href: `/software/jira/templates/${category.urlSlug}`,
                locale: locale
            })
        }));
    const jsmTemplatesLink = {
        text: intl.formatMessage({
            id: "Jira.TemplateCategoriesDropdown.JiraServiceManagementTemplates",
            defaultMessage: "Jira Service Management templates"
        }),
        href: (0, $3FBn4.getLocalizedHref)({
            href: "/software/jira/templates/service-management",
            locale: locale
        }),
        anchorProps: {
            target: "_blank"
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9g0oR.DropdownContent), {
        orientation: "column",
        contentSections: [
            {
                links: [
                    allTemplateLink,
                    ...templateLinks
                ]
            },
            {
                links: [
                    jsmTemplatesLink
                ]
            }
        ]
    });
};

});
parcelRegister("jF7is", function(module, exports) {
$parcel$export(module.exports, "useJiraTemplateCategories", function () { return (parcelRequire("ijtPZ")).useJiraTemplateCategories; });
parcelRequire("8FQ7c");
parcelRequire("ijtPZ");

});
parcelRegister("8FQ7c", function(module, exports) {

$parcel$export(module.exports, "getTemplateCategories", function () { return $439693367266da4f$export$819167f3de5f32cb; });

var $loA5d = parcelRequire("loA5d");

var $kNCWT = parcelRequire("kNCWT");
let $439693367266da4f$var$_ = (t)=>t, $439693367266da4f$var$t;
const $439693367266da4f$var$JIRA_PRODUCT_INTERNAL_TITLE = "Jira Cloud Product";
const $439693367266da4f$export$52bf0b65d881440d = (0, $loA5d.gql)($439693367266da4f$var$t || ($439693367266da4f$var$t = $439693367266da4f$var$_`
query ($locale: String) {
  taxonomyTemplateCategoryCollection(
    locale: $locale
    limit: 100,
    where: {
      product: {
        internalTitle: "${0}"
      }
    }
    # for the short-term, sort-ordering is done via the internal-name
    # todo: GWP-6125 implement a long term sort-ordering solution
    order: categoryNameInternal_ASC
  ) {
    items {
      sys {
        id
      }
      categoryNameInternal
      categoryNameExternal
      urlSlug
    }
  }
}
`), $439693367266da4f$var$JIRA_PRODUCT_INTERNAL_TITLE);
const $439693367266da4f$export$819167f3de5f32cb = (args)=>{
    const { locale: locale } = args;
    return (0, $loA5d.request)({
        url: (0, $kNCWT.CONTENTFUL_GRAPHQL_API_URL),
        document: $439693367266da4f$export$52bf0b65d881440d,
        variables: {
            locale: locale
        },
        requestHeaders: {
            Authorization: `Bearer ${window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES}`
        }
    });
};

});
parcelRegister("loA5d", function(module, exports) {

$parcel$export(module.exports, "request", function () { return $f937d4321ee3da05$export$b5fe3f66a567bec0; });
$parcel$export(module.exports, "gql", function () { return $f937d4321ee3da05$export$72e4926bf8358653; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $8JaQT = parcelRequire("8JaQT");

var $42TZw = parcelRequire("42TZw");

var $gUOuz = parcelRequire("gUOuz");

var $Llgr7 = parcelRequire("Llgr7");

var $lKnm7 = parcelRequire("lKnm7");

var $2bAdR = parcelRequire("2bAdR");

var $bbHBz = parcelRequire("bbHBz");
/**
 * Convert the given headers configuration into a plain object.
 */ const $f937d4321ee3da05$var$resolveHeaders = (headers)=>{
    let oHeaders = {};
    if (headers) {
        if (typeof Headers !== `undefined` && headers instanceof Headers || $2bAdR && $2bAdR.Headers && headers instanceof $2bAdR.Headers) oHeaders = (0, $42TZw.HeadersInstanceToPlainObject)(headers);
        else if (Array.isArray(headers)) headers.forEach(([name, value])=>{
            if (name && value !== undefined) oHeaders[name] = value;
        });
        else oHeaders = headers;
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 */ const $f937d4321ee3da05$var$cleanQuery = (str)=>str.replace(/([\s,]|#[^\n\r]+)+/g, ` `).trim();
/**
 * Create query string for GraphQL request
 */ const $f937d4321ee3da05$var$buildRequestConfig = (params)=>{
    if (!Array.isArray(params.query)) {
        const params_ = params;
        const search = [
            `query=${encodeURIComponent($f937d4321ee3da05$var$cleanQuery(params_.query))}`
        ];
        if (params.variables) search.push(`variables=${encodeURIComponent(params_.jsonSerializer.stringify(params_.variables))}`);
        if (params_.operationName) search.push(`operationName=${encodeURIComponent(params_.operationName)}`);
        return search.join(`&`);
    }
    if (typeof params.variables !== `undefined` && !Array.isArray(params.variables)) throw new Error(`Cannot create query with given variable type, array expected`);
    // Batch support
    const params_ = params;
    const payload = params.query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: $f937d4321ee3da05$var$cleanQuery(currentQuery),
            variables: params_.variables ? params_.jsonSerializer.stringify(params_.variables[index]) : undefined
        });
        return acc;
    }, []);
    return `query=${encodeURIComponent(params_.jsonSerializer.stringify(payload))}`;
};
const $f937d4321ee3da05$var$createHttpMethodFetcher = (method)=>async (params)=>{
        const { url: url, query: query, variables: variables, operationName: operationName, fetch: fetch, fetchOptions: fetchOptions, middleware: middleware } = params;
        const headers = (0, $7Knp0._)({}, params.headers);
        let queryParams = ``;
        let body = undefined;
        var _fetchOptions_jsonSerializer;
        if (method === `POST`) {
            body = $f937d4321ee3da05$var$createRequestBody(query, variables, operationName, fetchOptions.jsonSerializer);
            if (typeof body === `string`) // @ts-expect-error todo
            headers[`Content-Type`] = `application/json`;
        } else // @ts-expect-error todo needs ADT for TS to understand the different states
        queryParams = $f937d4321ee3da05$var$buildRequestConfig({
            query: query,
            variables: variables,
            operationName: operationName,
            jsonSerializer: (_fetchOptions_jsonSerializer = fetchOptions.jsonSerializer) !== null && _fetchOptions_jsonSerializer !== void 0 ? _fetchOptions_jsonSerializer : (0, $8JaQT.defaultJsonSerializer)
        });
        const init = (0, $7Knp0._)({
            method: method,
            headers: headers,
            body: body
        }, fetchOptions);
        let urlResolved = url;
        let initResolved = init;
        if (middleware) {
            const result = await Promise.resolve(middleware((0, $6iHNw._)((0, $7Knp0._)({}, init), {
                url: url,
                operationName: operationName,
                variables: variables
            })));
            const { url: urlNew } = result, initNew = (0, $akGnX._)(result, [
                "url"
            ]);
            urlResolved = urlNew;
            initResolved = initNew;
        }
        if (queryParams) urlResolved = `${urlResolved}?${queryParams}`;
        return await fetch(urlResolved, initResolved);
    };
/**
 * GraphQL Client.
 */ class $f937d4321ee3da05$export$b0f268a6eae2cdf1 {
    async request(documentOrOptions, ...variablesAndRequestHeaders) {
        const [variables, requestHeaders] = variablesAndRequestHeaders;
        const requestOptions = (0, $gUOuz.parseRequestArgs)(documentOrOptions, variables, requestHeaders);
        const _this_requestConfig = this.requestConfig, { headers: headers, fetch: fetch = (0, (/*@__PURE__*/$parcel$interopDefault($2bAdR))), method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware } = _this_requestConfig, fetchOptions = (0, $akGnX._)(_this_requestConfig, [
            "headers",
            "fetch",
            "method",
            "requestMiddleware",
            "responseMiddleware"
        ]);
        const { url: url } = this;
        if (requestOptions.signal !== undefined) fetchOptions.signal = requestOptions.signal;
        const { query: query, operationName: operationName } = (0, $Llgr7.resolveRequestDocument)(requestOptions.document);
        return $f937d4321ee3da05$var$makeRequest({
            url: url,
            query: query,
            variables: requestOptions.variables,
            headers: (0, $7Knp0._)({}, $f937d4321ee3da05$var$resolveHeaders($f937d4321ee3da05$var$callOrIdentity(headers)), $f937d4321ee3da05$var$resolveHeaders(requestOptions.requestHeaders)),
            operationName: operationName,
            fetch: fetch,
            method: method,
            fetchOptions: fetchOptions,
            middleware: requestMiddleware
        }).then((response)=>{
            if (responseMiddleware) responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (responseMiddleware) responseMiddleware(error);
            throw error;
        });
    }
    // prettier-ignore
    batchRequests(documentsOrOptions, requestHeaders) {
        const batchRequestOptions = (0, $gUOuz.parseBatchRequestArgs)(documentsOrOptions, requestHeaders);
        const _this_requestConfig = this.requestConfig, { headers: headers } = _this_requestConfig, fetchOptions = (0, $akGnX._)(_this_requestConfig, [
            "headers"
        ]);
        if (batchRequestOptions.signal !== undefined) fetchOptions.signal = batchRequestOptions.signal;
        const queries = batchRequestOptions.documents.map(({ document: document })=>(0, $Llgr7.resolveRequestDocument)(document).query);
        const variables = batchRequestOptions.documents.map(({ variables: variables })=>variables);
        var _this_requestConfig_fetch;
        return $f937d4321ee3da05$var$makeRequest({
            url: this.url,
            query: queries,
            variables: // @ts-expect-error TODO reconcile batch variables into system.
            variables,
            headers: (0, $7Knp0._)({}, $f937d4321ee3da05$var$resolveHeaders($f937d4321ee3da05$var$callOrIdentity(headers)), $f937d4321ee3da05$var$resolveHeaders(batchRequestOptions.requestHeaders)),
            operationName: undefined,
            fetch: (_this_requestConfig_fetch = this.requestConfig.fetch) !== null && _this_requestConfig_fetch !== void 0 ? _this_requestConfig_fetch : (0, (/*@__PURE__*/$parcel$interopDefault($2bAdR))),
            method: this.requestConfig.method || `POST`,
            fetchOptions: fetchOptions,
            middleware: this.requestConfig.requestMiddleware
        }).then((response)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(error);
            throw error;
        });
    }
    setHeaders(headers) {
        this.requestConfig.headers = headers;
        return this;
    }
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */ setHeader(key, value) {
        const { headers: headers } = this.requestConfig;
        if (headers) // todo what if headers is in nested array form... ?
        //@ts-expect-error todo
        headers[key] = value;
        else this.requestConfig.headers = {
            [key]: value
        };
        return this;
    }
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */ setEndpoint(value) {
        this.url = value;
        return this;
    }
    constructor(url, requestConfig = {}){
        this.url = url;
        this.requestConfig = requestConfig;
        /**
         * Send a GraphQL query to the server.
         */ this.rawRequest = async (...args)=>{
            const [queryOrOptions, variables, requestHeaders] = args;
            const rawRequestOptions = (0, $gUOuz.parseRawRequestArgs)(queryOrOptions, variables, requestHeaders);
            const _this_requestConfig = this.requestConfig, { headers: headers, fetch: fetch = (0, (/*@__PURE__*/$parcel$interopDefault($2bAdR))), method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware } = _this_requestConfig, fetchOptions = (0, $akGnX._)(_this_requestConfig, [
                "headers",
                "fetch",
                "method",
                "requestMiddleware",
                "responseMiddleware"
            ]);
            const { url: url } = this;
            if (rawRequestOptions.signal !== undefined) fetchOptions.signal = rawRequestOptions.signal;
            const { operationName: operationName } = (0, $Llgr7.resolveRequestDocument)(rawRequestOptions.query);
            return $f937d4321ee3da05$var$makeRequest({
                url: url,
                query: rawRequestOptions.query,
                variables: rawRequestOptions.variables,
                headers: (0, $7Knp0._)({}, $f937d4321ee3da05$var$resolveHeaders($f937d4321ee3da05$var$callOrIdentity(headers)), $f937d4321ee3da05$var$resolveHeaders(rawRequestOptions.requestHeaders)),
                operationName: operationName,
                fetch: fetch,
                method: method,
                fetchOptions: fetchOptions,
                middleware: requestMiddleware
            }).then((response)=>{
                if (responseMiddleware) responseMiddleware(response);
                return response;
            }).catch((error)=>{
                if (responseMiddleware) responseMiddleware(error);
                throw error;
            });
        };
    }
}
const $f937d4321ee3da05$var$makeRequest = async (params)=>{
    const { query: query, variables: variables, fetchOptions: fetchOptions } = params;
    var _params_method;
    const fetcher = $f937d4321ee3da05$var$createHttpMethodFetcher((0, $42TZw.uppercase)((_params_method = params.method) !== null && _params_method !== void 0 ? _params_method : `post`));
    const isBatchingQuery = Array.isArray(params.query);
    const response = await fetcher(params);
    var _fetchOptions_jsonSerializer;
    const result = await $f937d4321ee3da05$var$getResult(response, (_fetchOptions_jsonSerializer = fetchOptions.jsonSerializer) !== null && _fetchOptions_jsonSerializer !== void 0 ? _fetchOptions_jsonSerializer : (0, $8JaQT.defaultJsonSerializer));
    const successfullyReceivedData = Array.isArray(result) ? !result.some(({ data: data })=>!data) : Boolean(result.data);
    const successfullyPassedErrorPolicy = Array.isArray(result) || !result.errors || Array.isArray(result.errors) && !result.errors.length || fetchOptions.errorPolicy === `all` || fetchOptions.errorPolicy === `ignore`;
    if (response.ok && successfullyPassedErrorPolicy && successfullyReceivedData) {
        // @ts-expect-error TODO fixme
        const _ref = Array.isArray(result) ? result : result, { errors: _ } = _ref, rest = (0, $akGnX._)(_ref, [
            "errors"
        ]);
        const data = fetchOptions.errorPolicy === `ignore` ? rest : result;
        const dataEnvelope = isBatchingQuery ? {
            data: data
        } : data;
        // @ts-expect-error TODO
        return (0, $6iHNw._)((0, $7Knp0._)({}, dataEnvelope), {
            headers: response.headers,
            status: response.status
        });
    } else {
        const errorResult = typeof result === `string` ? {
            error: result
        } : result;
        throw new (0, $lKnm7.ClientError)(// @ts-expect-error TODO
        (0, $6iHNw._)((0, $7Knp0._)({}, errorResult), {
            status: response.status,
            headers: response.headers
        }), {
            query: query,
            variables: variables
        });
    }
};
/**
 * Send a GraphQL Query to the GraphQL server for execution.
 */ const $f937d4321ee3da05$export$3052fa16c23a17ef = async (...args)=>{
    const [urlOrOptions, query, ...variablesAndRequestHeaders] = args;
    const requestOptions = (0, $gUOuz.parseRawRequestExtendedArgs)(urlOrOptions, query, ...variablesAndRequestHeaders);
    const client = new $f937d4321ee3da05$export$b0f268a6eae2cdf1(requestOptions.url);
    return client.rawRequest((0, $7Knp0._)({}, requestOptions));
};
// prettier-ignore
// eslint-disable-next-line
async function $f937d4321ee3da05$export$b5fe3f66a567bec0(urlOrOptions, document, ...variablesAndRequestHeaders) {
    const requestOptions = (0, $gUOuz.parseRequestExtendedArgs)(urlOrOptions, document, ...variablesAndRequestHeaders);
    const client = new $f937d4321ee3da05$export$b0f268a6eae2cdf1(requestOptions.url);
    return client.request((0, $7Knp0._)({}, requestOptions));
}
/**
 * Send a batch of GraphQL Document to the GraphQL server for execution.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */ const $f937d4321ee3da05$export$72420c3222c11ca1 = async (...args)=>{
    const params = $f937d4321ee3da05$var$parseBatchRequestsArgsExtended(args);
    const client = new $f937d4321ee3da05$export$b0f268a6eae2cdf1(params.url);
    return client.batchRequests(params);
};
const $f937d4321ee3da05$var$parseBatchRequestsArgsExtended = (args)=>{
    if (args.length === 1) return args[0];
    else return {
        url: args[0],
        documents: args[1],
        requestHeaders: args[2],
        signal: undefined
    };
};
const $f937d4321ee3da05$var$createRequestBody = (query, variables, operationName, jsonSerializer)=>{
    const jsonSerializer_ = jsonSerializer !== null && jsonSerializer !== void 0 ? jsonSerializer : (0, $8JaQT.defaultJsonSerializer);
    if (!Array.isArray(query)) return jsonSerializer_.stringify({
        query: query,
        variables: variables,
        operationName: operationName
    });
    if (typeof variables !== `undefined` && !Array.isArray(variables)) throw new Error(`Cannot create request body with given variable type, array expected`);
    // Batch support
    const payload = query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: currentQuery,
            variables: variables ? variables[index] : undefined
        });
        return acc;
    }, []);
    return jsonSerializer_.stringify(payload);
};
const $f937d4321ee3da05$var$getResult = async (response, jsonSerializer)=>{
    let contentType;
    response.headers.forEach((value, key)=>{
        if (key.toLowerCase() === `content-type`) contentType = value;
    });
    if (contentType && (contentType.toLowerCase().startsWith(`application/json`) || contentType.toLowerCase().startsWith(`application/graphql+json`) || contentType.toLowerCase().startsWith(`application/graphql-response+json`))) return jsonSerializer.parse(await response.text());
    else return response.text();
};
const $f937d4321ee3da05$var$callOrIdentity = (value)=>{
    return typeof value === `function` ? value() : value;
};
const $f937d4321ee3da05$export$72e4926bf8358653 = (chunks, ...variables)=>{
    return chunks.reduce((acc, chunk, index)=>`${acc}${chunk}${index in variables ? String(variables[index]) : ``}`, ``);
};
var $f937d4321ee3da05$export$2e2bcd8739ae039 = $f937d4321ee3da05$export$b5fe3f66a567bec0;

});
parcelRegister("8JaQT", function(module, exports) {

$parcel$export(module.exports, "defaultJsonSerializer", function () { return $65aaf1b4daf2f5dd$export$94978876ea00418f; });
const $65aaf1b4daf2f5dd$export$94978876ea00418f = JSON;

});

parcelRegister("42TZw", function(module, exports) {

$parcel$export(module.exports, "uppercase", function () { return $2f22c802412ba8aa$export$6cfe151e6b925e83; });
$parcel$export(module.exports, "HeadersInstanceToPlainObject", function () { return $2f22c802412ba8aa$export$8cbbf7c85c69d7bd; });
const $2f22c802412ba8aa$export$6cfe151e6b925e83 = (str)=>str.toUpperCase();
const $2f22c802412ba8aa$export$8cbbf7c85c69d7bd = (headers)=>{
    const o = {};
    headers.forEach((v, k)=>{
        o[k] = v;
    });
    return o;
};

});

parcelRegister("gUOuz", function(module, exports) {

$parcel$export(module.exports, "parseRequestArgs", function () { return $c5090afbd2d358dc$export$23fbebc38045fef1; });
$parcel$export(module.exports, "parseRawRequestArgs", function () { return $c5090afbd2d358dc$export$915c311301d24138; });
$parcel$export(module.exports, "parseBatchRequestArgs", function () { return $c5090afbd2d358dc$export$db48f1a2d994371; });
$parcel$export(module.exports, "parseRequestExtendedArgs", function () { return $c5090afbd2d358dc$export$77a1c1c6dd0fc83d; });
$parcel$export(module.exports, "parseRawRequestExtendedArgs", function () { return $c5090afbd2d358dc$export$7dbb6e4001743509; });
const $c5090afbd2d358dc$export$23fbebc38045fef1 = (documentOrOptions, variables, requestHeaders)=>{
    return documentOrOptions.document ? documentOrOptions : {
        document: documentOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $c5090afbd2d358dc$export$915c311301d24138 = (queryOrOptions, variables, requestHeaders)=>{
    return queryOrOptions.query ? queryOrOptions : {
        query: queryOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $c5090afbd2d358dc$export$db48f1a2d994371 = (documentsOrOptions, requestHeaders)=>{
    return documentsOrOptions.documents ? documentsOrOptions : {
        documents: documentsOrOptions,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $c5090afbd2d358dc$export$77a1c1c6dd0fc83d = (urlOrOptions, document, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.document ? urlOrOptions : {
        url: urlOrOptions,
        document: document,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $c5090afbd2d358dc$export$7dbb6e4001743509 = (urlOrOptions, query, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.query ? urlOrOptions : {
        url: urlOrOptions,
        query: query,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};

});

parcelRegister("Llgr7", function(module, exports) {

$parcel$export(module.exports, "resolveRequestDocument", function () { return $08e4e2824a10a250$export$8a71244cbc138170; });

var $23Ewe = parcelRequire("23Ewe");
var $gX72x = parcelRequire("gX72x");
/**
 * helpers
 */ const $08e4e2824a10a250$var$extractOperationName = (document)=>{
    var _operationDefinitions__name, _operationDefinitions_;
    let operationName = undefined;
    const operationDefinitions = document.definitions.filter((definition)=>definition.kind === `OperationDefinition`);
    if (operationDefinitions.length === 1) operationName = (_operationDefinitions_ = operationDefinitions[0]) === null || _operationDefinitions_ === void 0 ? void 0 : (_operationDefinitions__name = _operationDefinitions_.name) === null || _operationDefinitions__name === void 0 ? void 0 : _operationDefinitions__name.value;
    return operationName;
};
const $08e4e2824a10a250$export$8a71244cbc138170 = (document)=>{
    if (typeof document === `string`) {
        let operationName = undefined;
        try {
            const parsedDocument = (0, $23Ewe.parse)(document);
            operationName = $08e4e2824a10a250$var$extractOperationName(parsedDocument);
        } catch (err) {
        // Failed parsing the document, the operationName will be undefined
        }
        return {
            query: document,
            operationName: operationName
        };
    }
    const operationName = $08e4e2824a10a250$var$extractOperationName(document);
    return {
        query: (0, $gX72x.print)(document),
        operationName: operationName
    };
};

});

parcelRegister("lKnm7", function(module, exports) {

$parcel$export(module.exports, "ClientError", function () { return $fd5002cdc1e73ea3$export$bb8c263ad32caa8; });
class $fd5002cdc1e73ea3$export$bb8c263ad32caa8 extends Error {
    static extractMessage(response) {
        var _response_errors_, _response_errors;
        var _response_errors__message;
        return (_response_errors__message = (_response_errors = response.errors) === null || _response_errors === void 0 ? void 0 : (_response_errors_ = _response_errors[0]) === null || _response_errors_ === void 0 ? void 0 : _response_errors_.message) !== null && _response_errors__message !== void 0 ? _response_errors__message : `GraphQL Error (Code: ${response.status})`;
    }
    constructor(response, request){
        const message = `${$fd5002cdc1e73ea3$export$bb8c263ad32caa8.extractMessage(response)}: ${JSON.stringify({
            response: response,
            request: request
        })}`;
        super(message);
        Object.setPrototypeOf(this, $fd5002cdc1e73ea3$export$bb8c263ad32caa8.prototype);
        this.response = response;
        this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === `function`) Error.captureStackTrace(this, $fd5002cdc1e73ea3$export$bb8c263ad32caa8);
    }
}

});

parcelRegister("2bAdR", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("bbHBz", function(module, exports) {
/* eslint-disable */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $Llgr7 = parcelRequire("Llgr7");

var $lKnm7 = parcelRequire("lKnm7");
// import type WebSocket from 'ws'
const $82528bd6da91277a$var$CONNECTION_INIT = `connection_init`;
const $82528bd6da91277a$var$CONNECTION_ACK = `connection_ack`;
const $82528bd6da91277a$var$PING = `ping`;
const $82528bd6da91277a$var$PONG = `pong`;
const $82528bd6da91277a$var$SUBSCRIBE = `subscribe`;
const $82528bd6da91277a$var$NEXT = `next`;
const $82528bd6da91277a$var$ERROR = `error`;
const $82528bd6da91277a$var$COMPLETE = `complete`;
class $82528bd6da91277a$var$GraphQLWebSocketMessage {
    get type() {
        return this._type;
    }
    get id() {
        return this._id;
    }
    get payload() {
        return this._payload;
    }
    get text() {
        const result = {
            type: this.type
        };
        if (this.id != null && this.id != undefined) result.id = this.id;
        if (this.payload != null && this.payload != undefined) result.payload = this.payload;
        return JSON.stringify(result);
    }
    static parse(data, f) {
        const { type: type, payload: payload, id: id } = JSON.parse(data);
        return new $82528bd6da91277a$var$GraphQLWebSocketMessage(type, f(payload), id);
    }
    constructor(type, payload, id){
        this._type = type;
        this._payload = payload;
        this._id = id;
    }
}
class $82528bd6da91277a$export$5eb90cb6288c26cf {
    makeSubscribe(query, operationName, subscriber, variables) {
        const subscriptionId = (this.socketState.lastRequestId++).toString();
        this.socketState.subscriptions[subscriptionId] = {
            query: query,
            variables: variables,
            subscriber: subscriber
        };
        this.socket.send($82528bd6da91277a$var$Subscribe(subscriptionId, {
            query: query,
            operationName: operationName,
            variables: variables
        }).text);
        return ()=>{
            this.socket.send($82528bd6da91277a$var$Complete(subscriptionId).text);
            delete this.socketState.subscriptions[subscriptionId];
        };
    }
    rawRequest(query, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.rawSubscribe(query, {
                next: (data, extensions)=>result = {
                        data: data,
                        extensions: extensions
                    },
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    request(document, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.subscribe(document, {
                next: (data)=>result = data,
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    subscribe(document, subscriber, variables) {
        const { query: query, operationName: operationName } = (0, $Llgr7.resolveRequestDocument)(document);
        return this.makeSubscribe(query, operationName, subscriber, variables);
    }
    rawSubscribe(query, subscriber, variables) {
        return this.makeSubscribe(query, undefined, subscriber, variables);
    }
    ping(payload) {
        this.socket.send($82528bd6da91277a$var$Ping(payload).text);
    }
    close() {
        this.socket.close(1000);
    }
    constructor(socket, { onInit: onInit, onAcknowledged: onAcknowledged, onPing: onPing, onPong: onPong }){
        this.socketState = {
            acknowledged: false,
            lastRequestId: 0,
            subscriptions: {}
        };
        this.socket = socket;
        socket.addEventListener(`open`, async (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
            socket.send($82528bd6da91277a$var$ConnectionInit(onInit ? await onInit() : null).text);
        });
        socket.addEventListener(`close`, (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
        });
        socket.addEventListener(`error`, (e)=>{
            console.error(e);
        });
        socket.addEventListener(`message`, (e)=>{
            try {
                const message = $82528bd6da91277a$var$parseMessage(e.data);
                switch(message.type){
                    case $82528bd6da91277a$var$CONNECTION_ACK:
                        if (this.socketState.acknowledged) console.warn(`Duplicate CONNECTION_ACK message ignored`);
                        else {
                            this.socketState.acknowledged = true;
                            if (onAcknowledged) onAcknowledged(message.payload);
                        }
                        return;
                    case $82528bd6da91277a$var$PING:
                        if (onPing) onPing(message.payload).then((r)=>socket.send($82528bd6da91277a$var$Pong(r).text));
                        else socket.send($82528bd6da91277a$var$Pong(null).text);
                        return;
                    case $82528bd6da91277a$var$PONG:
                        if (onPong) onPong(message.payload);
                        return;
                }
                if (!this.socketState.acknowledged) // Web-socket connection not acknowledged
                return;
                if (message.id === undefined || message.id === null || !this.socketState.subscriptions[message.id]) // No subscription identifer or subscription indentifier is not found
                return;
                const { query: query, variables: variables, subscriber: subscriber } = this.socketState.subscriptions[message.id];
                switch(message.type){
                    case $82528bd6da91277a$var$NEXT:
                        if (!message.payload.errors && message.payload.data) subscriber.next && subscriber.next(message.payload.data);
                        if (message.payload.errors) subscriber.error && subscriber.error(new (0, $lKnm7.ClientError)((0, $6iHNw._)((0, $7Knp0._)({}, message.payload), {
                            status: 200
                        }), {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $82528bd6da91277a$var$ERROR:
                        subscriber.error && subscriber.error(new (0, $lKnm7.ClientError)({
                            errors: message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $82528bd6da91277a$var$COMPLETE:
                        subscriber.complete && subscriber.complete();
                        delete this.socketState.subscriptions[message.id];
                        return;
                }
            } catch (e) {
                // Unexpected errors while handling graphql-ws message
                console.error(e);
                socket.close(1006);
            }
            socket.close(4400, `Unknown graphql-ws message.`);
        });
    }
}
$82528bd6da91277a$export$5eb90cb6288c26cf.PROTOCOL = `graphql-transport-ws`;
// Helper functions
function $82528bd6da91277a$var$parseMessage(data, f = (a)=>a) {
    const m = $82528bd6da91277a$var$GraphQLWebSocketMessage.parse(data, f);
    return m;
}
function $82528bd6da91277a$var$ConnectionInit(payload) {
    return new $82528bd6da91277a$var$GraphQLWebSocketMessage($82528bd6da91277a$var$CONNECTION_INIT, payload);
}
function $82528bd6da91277a$var$Ping(payload) {
    return new $82528bd6da91277a$var$GraphQLWebSocketMessage($82528bd6da91277a$var$PING, payload, undefined);
}
function $82528bd6da91277a$var$Pong(payload) {
    return new $82528bd6da91277a$var$GraphQLWebSocketMessage($82528bd6da91277a$var$PONG, payload, undefined);
}
function $82528bd6da91277a$var$Subscribe(id, payload) {
    return new $82528bd6da91277a$var$GraphQLWebSocketMessage($82528bd6da91277a$var$SUBSCRIBE, payload, id);
}
function $82528bd6da91277a$var$Complete(id) {
    return new $82528bd6da91277a$var$GraphQLWebSocketMessage($82528bd6da91277a$var$COMPLETE, undefined, id);
}

});



parcelRegister("ijtPZ", function(module, exports) {

$parcel$export(module.exports, "useJiraTemplateCategories", function () { return $d9bdcf0f19bc293e$export$ef1e726410cc2d37; });

var $iSvIT = parcelRequire("iSvIT");

var $3FBn4 = parcelRequire("3FBn4");

var $1FkY0 = parcelRequire("1FkY0");

var $8FQ7c = parcelRequire("8FQ7c");
// cache data per locale to optimize duplicate queries
const $d9bdcf0f19bc293e$var$cache = new Map();
const $d9bdcf0f19bc293e$export$d2adf65b87e47523 = ()=>{
    $d9bdcf0f19bc293e$var$cache.clear();
};
const $d9bdcf0f19bc293e$export$ef1e726410cc2d37 = ()=>{
    const locale = (0, $3FBn4.useLocale)();
    const mappedLocale = (0, $1FkY0.WAC_TO_CPAPI_LOCALE_MAP)[locale];
    // initialize state from cache if available
    const cacheEntry = mappedLocale ? $d9bdcf0f19bc293e$var$cache.get(mappedLocale) : undefined;
    var _cacheEntry_data;
    const [data, setData] = (0, $iSvIT.useState)((_cacheEntry_data = cacheEntry === null || cacheEntry === void 0 ? void 0 : cacheEntry.data) !== null && _cacheEntry_data !== void 0 ? _cacheEntry_data : []);
    const [loading, setLoading] = (0, $iSvIT.useState)(false);
    const [error, setError] = (0, $iSvIT.useState)(null);
    (0, $iSvIT.useEffect)(()=>{
        // if we don't have a mapped locale, do nothing
        if (!mappedLocale) return;
        const existingCache = $d9bdcf0f19bc293e$var$cache.get(mappedLocale);
        // if we already have cached data, use it
        if ((existingCache === null || existingCache === void 0 ? void 0 : existingCache.data) && !existingCache.promise) {
            setData(existingCache.data);
            return;
        }
        // if a fetch is already in progress, wait for it
        if (existingCache === null || existingCache === void 0 ? void 0 : existingCache.promise) {
            setLoading(true);
            existingCache.promise.then((items)=>{
                setData(items);
                setLoading(false);
            }).catch((err)=>{
                setError(err);
                setLoading(false);
            });
            return;
        }
        // start a new fetch
        setLoading(true);
        setError(null);
        const fetchPromise = (0, $8FQ7c.getTemplateCategories)({
            // @ts-ignore
            locale: mappedLocale
        }).then((response)=>{
            var _response_taxonomyTemplateCategoryCollection_items;
            const items = (_response_taxonomyTemplateCategoryCollection_items = response.taxonomyTemplateCategoryCollection.items) !== null && _response_taxonomyTemplateCategoryCollection_items !== void 0 ? _response_taxonomyTemplateCategoryCollection_items : [];
            // update cache with data and clear promise
            $d9bdcf0f19bc293e$var$cache.set(mappedLocale, {
                data: items,
                promise: null
            });
            setData(items);
            setLoading(false);
            return items;
        }).catch((err)=>{
            // clear promise on error
            const entry = $d9bdcf0f19bc293e$var$cache.get(mappedLocale);
            if (entry) entry.promise = null;
            setError(err);
            setLoading(false);
            throw err;
        });
        var _existingCache_data;
        // store the in-flight promise
        $d9bdcf0f19bc293e$var$cache.set(mappedLocale, {
            data: (_existingCache_data = existingCache === null || existingCache === void 0 ? void 0 : existingCache.data) !== null && _existingCache_data !== void 0 ? _existingCache_data : [],
            promise: fetchPromise
        });
    }, [
        locale,
        mappedLocale
    ]);
    return {
        data: data,
        loading: loading,
        error: error
    };
};

});





parcelRegister("7eVxf", function(module, exports) {

$parcel$export(module.exports, "AiRefreshSection", function () { return $df2b70e4c49508dd$export$53cedacbbc185d7; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $dTlTl = parcelRequire("dTlTl");

var $gAJUc = parcelRequire("gAJUc");

var $8Sghh = parcelRequire("8Sghh");

var $6MUoN = parcelRequire("6MUoN");
var $jfEgq = parcelRequire("jfEgq");

var $383oO = parcelRequire("383oO");
const $df2b70e4c49508dd$export$53cedacbbc185d7 = ()=>{
    const intl = (0, $f6qj2.default)();
    const useGWP7617Gate = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    if (useGWP7617Gate) return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $6MUoN.FeaturedInfoSection), {
        variant: (0, $jfEgq.LAUNCH),
        eyebrow: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.AiRefreshSection.eyebrow",
            defaultMessage: "Plan, Track, and Collaborate"
        }),
        header: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.AiRefreshSection.heading",
            defaultMessage: "Where your team + AI come together"
        }),
        description: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.AiRefreshSection.description",
            defaultMessage: "Jira\u2019s AI helps teams drive better outcomes, faster."
        }),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                video: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/374p64xck763gywok4l212n24sji512r.mp4",
                    controls: false,
                    autoplay: true,
                    muted: true,
                    loop: true,
                    width: 1300,
                    height: 694
                },
                Icon: (0, $383oO.TimelineIcon),
                title: intl.formatMessage({
                    id: "JiraSoftwarePage.AiRefreshSection.Card1.Title",
                    defaultMessage: "Jumpstart planning"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwarePage.AiRefreshSection.Card1.Description",
                    defaultMessage: "Create work items from your favorite tools, then use AI to break down big ideas, polish descriptions, and link relevant resources in a snap."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        // eslint-disable-next-line local/no-non-orangelogic-images-eslint
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-ai-refresh/workflow-builder.webp",
                        alt: intl.formatMessage({
                            id: "JiraSoftwarePage.AiRefreshSection.Card2.ImageAlt",
                            defaultMessage: "Shared release date module in Jira"
                        })
                    }
                },
                Icon: (0, $383oO.RedoIcon),
                title: intl.formatMessage({
                    id: "JiraSoftwarePage.AiRefreshSection.Card2.Title",
                    defaultMessage: "Focus on impact"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwarePage.AiRefreshSection.Card2.Description",
                    defaultMessage: "Cut down on admin with AI agents that make it easier to create project plans, identify trends, and flag potential risks."
                }),
                ctaProps: {
                    link: {
                        text: intl.formatMessage({
                            id: "JiraSoftwarePage.AiRefreshSection.Card2.LinkText",
                            defaultMessage: "Meet Rovo agents"
                        }),
                        href: "/software/rovo/use-cases?feature=agent&"
                    }
                }
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        // eslint-disable-next-line local/no-non-orangelogic-images-eslint
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-ai-refresh/linked-work-items.webp",
                        alt: intl.formatMessage({
                            id: "JiraSoftwarePage.AiRefreshSection.Card3.ImageAlt",
                            defaultMessage: "Shared release date module in Jira"
                        })
                    }
                },
                Icon: (0, $383oO.FastIcon),
                title: intl.formatMessage({
                    id: "JiraSoftwarePage.AiRefreshSection.Card3.Title",
                    defaultMessage: "Stay in sync"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwarePage.AiRefreshSection.Card3.Description",
                    defaultMessage: "Surface related work, summarize lengthy comments, and connect work to company goals to give your team the details they need to work faster and make better decisions."
                }),
                ctaProps: {
                    link: {
                        text: intl.formatMessage({
                            id: "JiraSoftwarePage.AiRefreshSection.Card3.LinkText",
                            defaultMessage: "Explore AI features"
                        }),
                        href: "/software/jira/ai"
                    }
                }
            })
        ]
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8Sghh.Ai), {});
};

});
parcelRegister("dTlTl", function(module, exports) {

$parcel$export(module.exports, "FeaturedInfoCard", function () { return $8a0d0ab999fa5d32$export$d26c611c5262ca6a; });
/* featured-info-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $bhreu = parcelRequire("bhreu");

var $lbVpk = parcelRequire("lbVpk");

var $1O6nN = parcelRequire("1O6nN");

var $5ohHq = parcelRequire("5ohHq");
const $8a0d0ab999fa5d32$var$containerStyles = null;
const $8a0d0ab999fa5d32$var$cardStyles = null;
const $8a0d0ab999fa5d32$var$cardBodyStyles = null;
const $8a0d0ab999fa5d32$var$ctaStyles = null;
const $8a0d0ab999fa5d32$var$renderCta = ({ ctaProps: ctaProps })=>{
    if ("button" in ctaProps && ctaProps.button !== undefined) // Button + optional Link case
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1n261g80 _zulpv47k _4cvr1h6o _1bah1y6m"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $lbVpk.Button), (0, $6iHNw._)((0, $7Knp0._)({}, ctaProps.button), {
                children: ctaProps.buttonText
            })),
            "link" in ctaProps && ctaProps.link && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1O6nN.Link), (0, $7Knp0._)({}, ctaProps.link))
        ]
    });
     // Link only case
    if ("link" in ctaProps && ctaProps.link !== undefined) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1n261g80 _zulpv47k _4cvr1h6o _1bah1y6m"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1O6nN.Link), (0, $7Knp0._)({}, ctaProps.link))
    });
    return null;
}; // eslint-disable-next-line complexity
const $8a0d0ab999fa5d32$export$d26c611c5262ca6a = ({ Icon: Icon, title: title, body: body, iconSize: iconSize = "24", image: image, video: video, ctaProps: ctaProps })=>{
    var _video_captions, _video_captions1, _video_captions2;
    var _video_controls, _video_preload;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_7cca15wb _1bsb1osq _4t3i1osq _gm59vrvc _o4yy1fhb _1bjp1ohn _5olw1ohn _13ndkb7n _5gu2kb7n _1g3pf1ug _7u5mf1ug _q8sr1wug _kw8y1wug _1cb1qfx8 _1ndykb7n _1ofjf1ug _sv321h6o",
            "featured-info-card"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx21bp4 _4cvr1y6m _1o9zidpf _2rkou2gc _1bsb1osq _4t3i1osq _1reozryt _18m9zryt _11q7cd5j _1i4oidpf _eytuidpf _1q3x1osq _1fj51wug _ufqd1ule _1x1tidpf _clfdidpf _s9kqidpf _11pqidpf _4wztidpf _q0a5idpf _98csidpf _c3k8idpf _1axi10nf _zcqx10nf"
            ]),
            style: {
                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
            },
            children: [
                video ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: "video",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("video", {
                        src: video.src,
                        poster: video.poster,
                        autoPlay: video.autoplay,
                        muted: video.muted,
                        loop: video.loop,
                        controls: (_video_controls = video.controls) !== null && _video_controls !== void 0 ? _video_controls : true,
                        width: video.width,
                        height: video.height,
                        preload: (_video_preload = video.preload) !== null && _video_preload !== void 0 ? _video_preload : "metadata",
                        "aria-label": video.alt || title,
                        style: video.width && video.height ? {
                            aspectRatio: `${video.width}/${video.height}`
                        } : undefined,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("track", {
                            kind: "captions",
                            src: ((_video_captions = video.captions) === null || _video_captions === void 0 ? void 0 : _video_captions.src) || "",
                            srcLang: ((_video_captions1 = video.captions) === null || _video_captions1 === void 0 ? void 0 : _video_captions1.srclang) || "en",
                            label: ((_video_captions2 = video.captions) === null || _video_captions2 === void 0 ? void 0 : _video_captions2.label) || "Captions",
                            default: true
                        })
                    })
                }) : image ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: "image",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), (0, $7Knp0._)({}, image))
                }) : null,
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _1yt4xy5q _4cvr1y6m _zulp19bv _1o9zidpf _2rkou2gc _11q7cd5j _1x1tidpf _clfdidpf _s9kqidpf _11pqidpf _4wztidpf _q0a5idpf _98csidpf _c3k8idpf _1axi10nf _zcqx10nf _zcqx1k8s",
                        "body"
                    ]),
                    style: {
                        "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                    },
                    children: [
                        Icon && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)(Icon, {
                                size: iconSize
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                            className: "h4",
                            children: title
                        }),
                        body && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            children: body
                        }),
                        ctaProps && $8a0d0ab999fa5d32$var$renderCta({
                            ctaProps: ctaProps
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("8Sghh", function(module, exports) {

$parcel$export(module.exports, "Ai", function () { return $d5d777ae03c51319$export$7ae07b56aa46260e; });
/* ai.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $91nJf = parcelRequire("91nJf");

var $cssyA = parcelRequire("cssyA");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");
parcelRequire("Tf71T");
var $fkaMJ = parcelRequire("fkaMJ");
parcelRequire("5GuYI");
var $6qcUm = parcelRequire("6qcUm");
const $d5d777ae03c51319$export$7ae07b56aa46260e = ()=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $f6qj2.default)();
    const title = formatMessage({
        id: "jira-product-tour.ai-section.title-text",
        defaultMessage: "Your next move, suggested by AI"
    });
    const subTitle = formatMessage({
        id: "jira-product-tour.ai-section.subtitle-text",
        defaultMessage: "Atlassian Intelligence takes your big ideas and automatically suggests the tasks to help get it done."
    });
    const buttonText = formatMessage({
        id: "jira-product-tour.ai-section.button-text",
        defaultMessage: "Explore Atlassian Intelligence"
    });
    const videoLink = (0, $fkaMJ.getAiVideo)(locale);
    const imageLink = (0, $fkaMJ.getAiImage)(locale);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: "atlas-55799-ai-button-clicked",
                section: "ai-section"
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _6a6z1h6o _bfhk17la _syazu67f _ca0qvbgk _u5f39by0 _n3tdvbgk _19bv9by0 _zulpzwfg"
                ]),
                style: {
                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $6qcUm.Intelligence), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                        className: (0, $esG4f.default)([
                            "_1wybckbl _k48p1fw0 _vwz4bs82 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o _flz0zwfg _1lzozwfg _1cqs1tcg"
                        ]),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_syazcd5j _y3gn1h6o _ect4bzd7 _1wyb7vkz _k48p1nn1"
                        ]),
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                        },
                        children: subTitle
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1tz91y44 _1k797vkz"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                            variant: "secondary",
                            color: "white",
                            colorAgainst: "other",
                            size: "large",
                            href: (0, $3FBn4.useLocalizedHref)("/software/jira/ai"),
                            onClick: handleClick,
                            dataEventProps: {
                                "data-product-key": "jira",
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "ctaSection",
                                "data-label": "explore-atlassian-intelligence",
                                "data-label-english": `${buttonText}`,
                                "data-track-event": "jira-pt.ai-section.explore-atlassian-intelligence"
                            },
                            children: buttonText
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("video", {
                        playsInline: true,
                        muted: true,
                        preload: "auto",
                        autoPlay: true,
                        loop: true,
                        controls: true,
                        className: (0, $esG4f.default)([
                            "_p12f1uof _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _19451ogm _liwcglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                            src: videoLink,
                            type: "video/mp4"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $cssyA.Picture), {
                        image: {
                            src: imageLink,
                            alt: "",
                            width: 2752,
                            height: 1838
                        },
                        className: (0, $esG4f.default)([
                            "_mezj1osq _bna71wug _14bq7vkz _3tce7vkz _1ym67vkz _1xr17vkz _1z4kglyw"
                        ])
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1tkemgvx _12vemgnk _ouxlbbky _1lrwykpt _1itkoro1 _1jgo1wqb _1w8u1dh4"
                ])
            })
        ]
    });
};
const $d5d777ae03c51319$var$aiSectionStyles = null;
const $d5d777ae03c51319$var$imageStyles = null;
const $d5d777ae03c51319$var$videoStyles = null;
const $d5d777ae03c51319$var$titleStyles = null;
const $d5d777ae03c51319$var$subTitleStyles = null;
const $d5d777ae03c51319$var$buttonStyles = null;
const $d5d777ae03c51319$var$footerStyles = null;

});
parcelRegister("Tf71T", function(module, exports) {
$parcel$export(module.exports, "AirCanadaLogo", function () { return (parcelRequire("3VOWJ")).AirCanadaLogo; });
$parcel$export(module.exports, "CanvaLogo", function () { return (parcelRequire("kZdUe")).CanvaLogo; });
$parcel$export(module.exports, "DominosLogo", function () { return (parcelRequire("ZNKQZ")).DominosLogo; });
$parcel$export(module.exports, "FordLogo", function () { return (parcelRequire("eYMfY")).FordLogo; });
$parcel$export(module.exports, "NasaLogo", function () { return (parcelRequire("ffaCM")).NasaLogo; });
$parcel$export(module.exports, "VisaLogo", function () { return (parcelRequire("aWQH0")).VisaLogo; });
$parcel$export(module.exports, "ArrowRight", function () { return (parcelRequire("fFExq")).ArrowRight; });
$parcel$export(module.exports, "getAiImage", function () { return (parcelRequire("fkaMJ")).getAiImage; });
$parcel$export(module.exports, "getAiImageJSM", function () { return (parcelRequire("fkaMJ")).getAiImageJSM; });
$parcel$export(module.exports, "getAiVideo", function () { return (parcelRequire("fkaMJ")).getAiVideo; });
$parcel$export(module.exports, "getAiVideoJSM", function () { return (parcelRequire("fkaMJ")).getAiVideoJSM; });
$parcel$export(module.exports, "getCollaborateFirstImage", function () { return (parcelRequire("fkaMJ")).getCollaborateFirstImage; });
$parcel$export(module.exports, "getCollaborateFourthImage", function () { return (parcelRequire("fkaMJ")).getCollaborateFourthImage; });
$parcel$export(module.exports, "getCollaborateSecondImage", function () { return (parcelRequire("fkaMJ")).getCollaborateSecondImage; });
$parcel$export(module.exports, "getCollaborateThirdImage", function () { return (parcelRequire("fkaMJ")).getCollaborateThirdImage; });
$parcel$export(module.exports, "getDoubleFeatureFirstImage", function () { return (parcelRequire("fkaMJ")).getDoubleFeatureFirstImage; });
$parcel$export(module.exports, "getDoubleFeatureSecondImage", function () { return (parcelRequire("fkaMJ")).getDoubleFeatureSecondImage; });
$parcel$export(module.exports, "getStaggeredDoubleFeautureFirstImage", function () { return (parcelRequire("fkaMJ")).getStaggeredDoubleFeautureFirstImage; });
$parcel$export(module.exports, "getStaggeredDoubleFeautureSecondImage", function () { return (parcelRequire("fkaMJ")).getStaggeredDoubleFeautureSecondImage; });
parcelRequire("3VOWJ");
parcelRequire("kZdUe");
parcelRequire("ZNKQZ");
parcelRequire("eYMfY");
parcelRequire("ffaCM");
parcelRequire("aWQH0");
parcelRequire("fFExq");
parcelRequire("fkaMJ");

});
parcelRegister("3VOWJ", function(module, exports) {

$parcel$export(module.exports, "AirCanadaLogo", function () { return $1cf44e45b7efae2c$export$ea8385ffd753ff4e; });

var $loA2J = parcelRequire("loA2J");
const $1cf44e45b7efae2c$export$ea8385ffd753ff4e = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "185",
        height: "24",
        viewBox: "0 0 185 24",
        fill: "currentColor",
        role: "img",
        "aria-label": "Air Canada",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M12.8603 17.077C12.8603 16.2693 13.2065 16.1539 14.0142 16.6154C15.3988 17.4231 16.7834 18.1154 16.7834 18.1154C16.7834 17.6539 17.2449 17.3077 18.0526 17.5385C18.8603 17.7693 19.668 17.8847 19.668 17.8847C19.668 17.8847 19.2065 16.8462 18.9757 16.3847C18.6295 15.577 18.9757 15.1154 19.3218 15C19.3218 15 18.8603 14.6539 18.5141 14.4231C17.8218 13.9616 17.9372 13.3847 18.6295 13.1539C19.5526 12.6924 20.8218 12.2308 20.8218 12.2308C20.4757 12.0001 20.0142 11.4231 20.4757 10.6154C20.9372 9.92312 21.7449 8.88466 21.7449 8.88466H19.5526C18.7449 8.88466 18.5141 8.19234 18.5141 7.73081C18.5141 7.73081 17.2449 8.6539 16.3218 9.23083C15.5142 9.80775 14.8218 9.23083 14.9372 8.30774C15.168 6.92313 15.2834 5.30775 15.2834 5.30775C14.8219 5.76928 14.0141 5.65391 13.5526 4.96159C12.9757 3.80774 12.3988 2.42312 12.3988 2.42312C12.3988 2.42312 11.8218 3.80774 11.2449 4.96159C10.8987 5.65391 10.0911 5.76928 9.62953 5.42312C9.62953 5.42312 9.74493 7.03849 9.97569 8.42311C10.0911 9.2308 9.39877 9.80772 8.59108 9.2308C7.66799 8.65387 6.28338 7.73079 6.28338 7.73079C6.28338 8.19232 6.05261 8.76924 5.24492 8.88464H3.05262C3.05262 8.88464 3.86031 9.92309 4.32184 10.6154C4.78337 11.3077 4.32184 12 3.97568 12.2308C3.97568 12.2308 5.12953 12.8077 6.16798 13.1539C6.8603 13.5 7.09107 13.9616 6.28338 14.4231C6.05261 14.6539 5.47569 15 5.47569 15C5.93722 15.1154 6.28338 15.5769 5.93722 16.3846C5.70645 16.8462 5.2449 17.8846 5.2449 17.8846C5.2449 17.8846 6.05259 17.6539 6.86028 17.5385C7.66797 17.3077 8.01413 17.7692 8.1295 18.1154C8.1295 18.1154 9.51411 17.3077 10.8987 16.6154C11.591 16.1539 12.0526 16.3846 12.0526 17.0769V19.0385C12.0526 20.1923 11.8218 21.3462 11.4756 22.0385C6.28335 21.4615 1.89872 17.3077 1.89872 11.7692C1.89872 6.11538 6.62948 1.50001 12.5141 1.50001C18.3987 1.50001 23.1295 6.11541 23.1295 11.7692C23.1295 17.0769 18.9756 21.4615 13.668 22.0385V23.4231C19.8987 22.8461 24.7449 17.8846 24.7449 11.7692C24.7449 5.1923 19.2064 0 12.3987 0C5.70643 0 0.167969 5.1923 0.167969 11.6538C0.167969 17.3077 4.43721 22.0385 10.0911 23.0769C11.0141 23.3077 11.5911 23.4231 12.168 24C12.7449 22.8461 12.8603 20.5384 12.8603 19.2692V17.077Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M62.3613 17.8843V5.42273H68.4767C71.7075 5.42273 73.2075 6.80734 73.3229 8.53812C73.3229 9.34581 73.2075 10.1535 72.6306 10.7304C72.0537 11.3073 71.8229 11.5381 70.7844 12.115L75.3998 17.9997H72.0537L67.8998 12.692H65.1306V17.8843L62.3613 17.8843ZM65.1306 11.0766H66.3998C69.7459 11.0766 70.4383 10.4997 70.4383 8.88428C70.4383 7.2689 68.9382 7.03814 66.7459 7.03814H65.1306V11.0766Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M35.0156 17.8843L40.4387 5.42273H43.7849L49.208 17.8843H45.8618L44.3618 14.5381H38.5926L37.0926 17.8843H35.0156ZM39.2849 12.9228H43.5541L41.3618 7.96122L39.2849 12.9228Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M55.9002 5.42273H53.0156V17.8843H55.9002V5.42273Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M96.1674 17.4227C94.7827 17.9997 93.052 18.2304 90.9751 18.2304C88.552 18.2304 86.5904 17.6535 85.2058 16.4996C83.8213 15.3458 83.1289 13.7304 83.1289 11.6535C83.1289 9.57654 83.8212 7.84579 85.2058 6.80731C86.5905 5.65346 88.552 5.07654 91.2058 5.07654C92.8212 5.07654 94.4366 5.19193 96.1674 5.53807V7.615C94.3212 7.03808 92.5904 6.80731 91.3212 6.80731C89.7058 6.80731 88.552 7.26884 87.6289 8.07653C86.8212 8.88422 86.3597 10.1535 86.3597 11.6535C86.3597 13.1534 86.8212 14.3073 87.7443 15.2304C88.6674 16.0381 89.9366 16.4996 91.552 16.4996C93.052 16.4996 94.6674 16.1534 96.1674 15.5765L96.1674 17.4227Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M99.7461 17.8843L105.169 5.42273H108.515L113.938 17.8843H110.592L109.092 14.5381H103.323L101.823 17.8843H99.7461ZM104.131 12.9228H108.4L106.323 7.96122L104.131 12.9228Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M135.861 17.8843L141.284 5.42273H144.631L150.054 17.8843H146.708L145.207 14.5381H139.438L137.938 17.8843H135.861ZM140.131 12.9228H144.4L142.207 7.96122L140.131 12.9228Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M176.477 7.96119L178.669 12.9227H174.4L176.477 7.96119ZM175.554 5.42273L170.131 17.8843H172.208L173.708 14.5381H179.477L180.977 17.8843H184.323L178.9 5.42273H175.554Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M118.092 17.8843V5.42273H121.438L129.284 14.3074V5.42273H131.707V17.8843H128.592L120.515 8.53812V17.8843H118.092Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M154.092 17.8843V5.42273H160.092C162.284 5.42273 163.9 5.99965 165.053 6.92274C166.207 7.96119 166.784 9.46121 166.784 11.3074C166.784 13.3843 166.207 14.9997 164.938 16.0381C163.669 17.192 162.053 17.7689 159.861 17.7689H154.092L154.092 17.8843ZM156.976 16.1535H159.169C160.669 16.1535 161.823 15.8074 162.63 14.9997C163.438 14.192 163.784 13.1535 163.784 11.5381C163.784 10.3843 163.438 9.34581 162.861 8.53812C162.4 7.96119 161.938 7.61503 161.361 7.38427C160.784 7.1535 159.976 7.03811 158.823 7.03811H157.092V16.1535H156.976Z"
            })
        ]
    });

});

parcelRegister("kZdUe", function(module, exports) {

$parcel$export(module.exports, "CanvaLogo", function () { return $f832a75fd13d1307$export$41d9e6d43cf45e91; });

var $loA2J = parcelRequire("loA2J");
const $f832a75fd13d1307$export$41d9e6d43cf45e91 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "73",
        height: "73",
        viewBox: "0 0 73 73",
        fill: "currentColor",
        role: "img",
        "aria-label": "Canva",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M51.3643 35.0746C50.9233 35.0746 50.7793 35.6686 50.7793 36.1096C50.8126 36.9942 51.1568 37.8387 51.7513 38.4946C51.9811 37.9215 52.106 37.3118 52.1203 36.6946C52.1023 35.5966 51.6613 35.0746 51.3643 35.0746Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M36.4512 0.69458C29.3311 0.69458 22.3708 2.80594 16.4507 6.76167C10.5305 10.7174 5.91628 16.3398 3.19152 22.918C0.46677 29.4961 -0.24615 36.7345 1.14292 43.7178C2.53199 50.7011 5.96065 57.1157 10.9953 62.1504C16.03 67.1851 22.4446 70.6138 29.4279 72.0029C36.4113 73.3919 43.6497 72.679 50.2278 69.9542C56.8059 67.2295 62.4284 62.6153 66.3841 56.6951C70.3398 50.7749 72.4512 43.8147 72.4512 36.6946C72.4512 27.1468 68.6583 17.99 61.907 11.2387C55.1557 4.48743 45.999 0.69458 36.4512 0.69458ZM62.3892 46.4686C62.2848 46.4807 62.1794 46.4552 62.0922 46.3966C61.4858 46.201 60.9422 45.848 60.5169 45.3737C60.0915 44.8993 59.7997 44.3206 59.6712 43.6966C59.4147 44.0614 59.0735 44.3584 58.6769 44.5622C58.2803 44.766 57.8401 44.8705 57.3942 44.8666C56.6375 44.8137 55.9229 44.4992 55.3728 43.977C54.8226 43.4548 54.4714 42.7575 54.3792 42.0046C54.3079 41.31 54.3815 40.6083 54.5952 39.9436C54.0646 40.309 53.4392 40.5123 52.7952 40.5286H52.2822C51.2379 42.1236 49.8891 43.4968 48.3132 44.5696C47.9532 44.7729 47.5547 44.8986 47.1432 44.9386C47.0175 44.945 46.8921 44.9223 46.7766 44.8724C46.6611 44.8224 46.5586 44.7465 46.4772 44.6506C46.2312 44.3978 46.0396 44.0972 45.9143 43.7675C45.7889 43.4378 45.7324 43.086 45.7482 42.7336C44.5868 44.0553 42.9904 44.9174 41.2482 45.1636C41.0186 45.172 40.7896 45.1348 40.5745 45.054C40.3593 44.9733 40.1624 44.8507 39.9949 44.6934C39.8275 44.536 39.693 44.347 39.5992 44.1373C39.5053 43.9275 39.454 43.7013 39.4482 43.4716C39.4004 43.0775 39.4248 42.6779 39.5202 42.2926C39.8189 40.8972 40.2098 39.5232 40.6902 38.1796C40.6902 38.0356 40.6182 37.9636 40.5462 37.9636C39.8172 37.9636 37.3152 40.5286 36.9462 42.2206L36.6492 43.6156C36.5554 44.0328 36.3297 44.4087 36.0055 44.6876C35.6812 44.9664 35.2758 45.1333 34.8492 45.1636C34.7031 45.1712 34.5598 45.1221 34.4491 45.0265C34.3384 44.9309 34.2689 44.7962 34.2552 44.6506V44.2096L34.4082 43.4716C33.4455 44.2995 32.2918 44.8748 31.0512 45.1456C30.6669 45.1923 30.2794 45.0879 29.9705 44.8546C29.6616 44.6212 29.4553 44.277 29.3952 43.8946C29.145 44.2716 28.8072 44.5824 28.4106 44.8003C28.0141 45.0181 27.5706 45.1366 27.1182 45.1456C26.5535 45.121 26.0067 44.9396 25.5394 44.6216C25.072 44.3037 24.7024 43.8618 24.4722 43.3456C23.6937 44.2137 22.8075 44.9789 21.8352 45.6226C20.3011 46.7055 18.4907 47.3298 16.6152 47.4226C15.018 47.3779 13.4957 46.7355 12.3492 45.6226C11.105 44.3767 10.3293 42.7394 10.1532 40.9876C9.45119 35.7946 12.6462 28.9816 17.5512 26.0386C18.6183 25.3792 19.843 25.0187 21.0972 24.9946C22.1451 24.9667 23.1666 25.3257 23.9667 26.003C24.7669 26.6803 25.2896 27.6284 25.4352 28.6666C25.5805 29.5671 25.4134 30.4903 24.9615 31.2827C24.5096 32.0751 23.8002 32.6891 22.9512 33.0226C21.9252 33.5356 21.4122 33.5356 21.2592 33.2386C21.2132 33.1384 21.2033 33.0254 21.2311 32.9187C21.259 32.8121 21.323 32.7184 21.4122 32.6536C23.3202 31.1146 23.3202 29.7916 23.0952 27.9556C23.094 27.4674 22.9074 26.998 22.5733 26.6421C22.2391 26.2862 21.7823 26.0705 21.2952 26.0386C17.4792 26.0386 12.1872 34.3456 12.9252 40.3666C13.2132 42.7156 14.7252 45.4336 17.6232 45.4336C18.6458 45.4096 19.6506 45.1607 20.5662 44.7046C21.9121 44.1221 23.0998 43.2274 24.0312 42.0946C23.8152 39.3046 26.2362 35.7946 29.7642 35.7946C31.3122 35.7946 32.5542 36.3796 32.7072 37.5946C32.7491 37.8246 32.7377 38.0613 32.674 38.2862C32.6102 38.5112 32.4957 38.7186 32.3392 38.8924C32.1828 39.0662 31.9886 39.2019 31.7715 39.2889C31.5545 39.376 31.3204 39.4121 31.0872 39.3946C30.6462 39.3946 29.9892 39.2506 29.9082 38.8816C29.8272 38.5126 30.8712 38.6656 30.7182 37.7026C30.6462 37.1176 29.9892 36.9016 29.3952 36.9016C27.1902 36.9016 25.9482 39.9886 26.1642 41.8966C26.2362 42.7966 26.7492 43.6966 27.4872 43.6966C28.2252 43.6966 29.1072 42.7426 29.3952 41.4196C29.4903 41.003 29.7164 40.6279 30.0403 40.3492C30.3643 40.0706 30.7691 39.9032 31.1952 39.8716C31.5642 39.8716 31.7892 40.0246 31.7892 40.3846V40.8256C31.7082 41.1946 31.4202 42.6256 31.4202 42.8146C31.4177 42.8921 31.4311 42.9693 31.4596 43.0414C31.4881 43.1135 31.5311 43.179 31.586 43.2338C31.6408 43.2886 31.7063 43.3316 31.7784 43.3601C31.8505 43.3887 31.9277 43.4021 32.0052 43.3996C33.0226 43.0491 33.9462 42.4703 34.7052 41.7076C35.0742 39.9076 35.5152 37.5946 35.5152 37.4506C35.5289 37.2199 35.5905 36.9945 35.696 36.7889C35.8016 36.5833 35.9488 36.402 36.1282 36.2563C36.3077 36.1107 36.5155 36.0041 36.7385 35.9432C36.9614 35.8823 37.1946 35.8684 37.4232 35.9026C37.5698 35.8952 37.7133 35.9458 37.8228 36.0435C37.9323 36.1412 37.9989 36.2781 38.0082 36.4246V36.8566L37.6482 38.8456C38.9712 37.0456 41.0232 35.7586 42.2742 35.7586C42.5153 35.7419 42.754 35.8156 42.9437 35.9654C43.1334 36.1151 43.2605 36.3302 43.3002 36.5686C43.3143 37.0429 43.2411 37.5158 43.0842 37.9636C42.5581 39.4664 42.1459 41.0068 41.8512 42.5716C41.819 42.6702 41.8121 42.7752 41.831 42.8772C41.8498 42.9792 41.894 43.0748 41.9593 43.1554C42.0246 43.2359 42.1091 43.2988 42.205 43.3383C42.3008 43.3778 42.4051 43.3927 42.5082 43.3816C43.183 43.2388 43.8229 42.9641 44.3913 42.5734C44.9596 42.1826 45.4452 41.6835 45.8202 41.1046V40.3666C45.764 39.3003 45.8888 38.2322 46.1892 37.2076C46.3356 36.8008 46.591 36.4421 46.9275 36.1707C47.264 35.8992 47.6686 35.7255 48.0972 35.6686C48.1761 35.66 48.2559 35.6693 48.3308 35.6957C48.4056 35.7221 48.4736 35.7649 48.5297 35.821C48.5859 35.8772 48.6287 35.9451 48.6551 36.02C48.6815 36.0949 48.6907 36.1747 48.6822 36.2536C48.6934 36.4042 48.6688 36.5554 48.6102 36.6946C48.1656 37.948 47.9166 39.2624 47.8722 40.5916C47.8865 41.3998 47.9799 42.2046 48.1512 42.9946C48.1469 43.0243 48.1495 43.0547 48.1587 43.0833C48.1679 43.1119 48.1835 43.138 48.2044 43.1597C48.2252 43.1814 48.2507 43.1981 48.2789 43.2084C48.3071 43.2188 48.3373 43.2226 48.3672 43.2196C49.4848 42.374 50.4059 41.2962 51.0672 40.0606C50.5825 39.7281 50.1924 39.2755 49.9352 38.747C49.6781 38.2184 49.5626 37.6322 49.6002 37.0456C49.6002 34.8406 50.9232 33.6616 52.2462 33.6616C52.522 33.6642 52.794 33.7254 53.0443 33.8413C53.2946 33.9571 53.5174 34.1249 53.6979 34.3335C53.8783 34.542 54.0123 34.7866 54.091 35.0509C54.1697 35.3152 54.1912 35.5933 54.1542 35.8666C54.09 36.9274 53.782 37.9591 53.2542 38.8816H53.5512C53.8931 38.8929 54.2332 38.8258 54.5452 38.6854C54.8572 38.545 55.1329 38.335 55.3512 38.0716C55.4796 37.928 55.6282 37.8037 55.7922 37.7026C56.3143 37.051 56.9738 36.5227 57.7237 36.1556C58.4736 35.7884 59.2953 35.5914 60.1302 35.5786C61.6692 35.5786 62.9202 36.1636 63.0642 37.3786C63.105 37.6131 63.0938 37.8537 63.0316 38.0835C62.9693 38.3133 62.8575 38.5266 62.7039 38.7085C62.5504 38.8904 62.3588 39.0364 62.1427 39.1363C61.9266 39.2362 61.6912 39.2875 61.4532 39.2866C61.0122 39.2866 60.2742 39.1426 60.2742 38.7736C60.2742 38.4046 61.2282 38.5486 61.1742 37.5946C61.1022 37.0096 60.4362 36.6946 59.8512 36.6946C57.7902 36.6946 56.3952 39.3946 56.6202 41.6896C56.6922 42.5896 57.1332 43.4896 57.9432 43.4896C58.6002 43.4896 59.5542 42.5356 59.9232 41.2126C60.0332 40.8046 60.2639 40.4393 60.5851 40.1647C60.9063 39.89 61.303 39.7189 61.7232 39.6736C61.7963 39.6632 61.8709 39.6688 61.9417 39.6899C62.0125 39.7109 62.0779 39.7471 62.1334 39.7958C62.189 39.8445 62.2334 39.9046 62.2635 39.9721C62.2937 40.0395 62.3089 40.1127 62.3082 40.1866C62.2297 40.8778 62.1064 41.5633 61.9392 42.2386C61.8296 42.747 61.7812 43.2667 61.7952 43.7866C61.8989 44.4661 62.2138 45.0959 62.6952 45.5866C62.8071 45.6829 62.8859 45.812 62.9202 45.9556C62.9365 46.0279 62.934 46.1033 62.9127 46.1744C62.8915 46.2455 62.8523 46.3099 62.799 46.3614C62.7456 46.413 62.6799 46.4499 62.6081 46.4687C62.5363 46.4874 62.4609 46.4874 62.3892 46.4686Z"
            })
        ]
    });

});

parcelRegister("ZNKQZ", function(module, exports) {

$parcel$export(module.exports, "DominosLogo", function () { return $2c88d7e26e8b56ac$export$3a87515d6bae358a; });

var $loA2J = parcelRequire("loA2J");
const $2c88d7e26e8b56ac$export$3a87515d6bae358a = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "149",
        height: "33",
        viewBox: "0 0 149 33",
        fill: "currentColor",
        role: "img",
        "aria-label": "Domino\u2019s",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M85.1443 21.4717C83.5509 17.7341 78.0566 18.8925 76.5524 21.2925V19.4237H71.7656V32.6781H76.7245V26.0093C76.7245 23.5197 77.2535 23.3405 78.5856 23.2509C79.9114 23.1613 80.4468 23.3405 80.4468 26.0093L80.536 32.6781H85.3228V25.8301C85.3228 24.5821 85.5905 23.4301 86.9162 23.4301C88.5097 23.3405 88.8666 23.5197 88.8666 25.4781V32.7741H93.9147V22.8925C94.004 18.1821 87.3624 18.0925 85.1443 21.4717Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M63.1736 18.4457C59.2729 18.4457 56.0859 21.6457 56.0859 25.5625C56.0859 29.4793 59.2729 32.6793 63.1736 32.6793C67.0744 32.6793 70.2614 29.4793 70.2614 25.5625C70.2614 21.6457 67.0744 18.4457 63.1736 18.4457ZM63.1736 28.0521C61.7587 28.0521 60.6942 26.8937 60.6942 25.5625C60.6942 24.1417 61.8479 23.0729 63.1736 23.0729C64.4994 23.0729 65.6531 24.2313 65.6531 25.5625C65.6594 26.9001 64.5058 28.0521 63.1736 28.0521Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M49.7117 15.1528C48.7365 14.7112 47.7613 14.3528 46.6969 14.2632C45.1927 14.084 43.6821 13.9944 42.1778 13.9944H36.6836V32.676H41.7317C43.4144 32.676 45.0971 32.5864 46.6905 32.4072C47.755 32.228 48.8194 31.9656 49.7882 31.5176C51.2924 30.7176 52.6246 29.5592 53.5998 28.1384C55.3717 25.2008 55.3717 21.4696 53.5998 18.532C52.6373 17.1112 51.3052 15.9528 49.7117 15.1528ZM49.0935 25.5592C48.7365 26.18 48.2075 26.8072 47.5 27.1592C47.1431 27.3384 46.7033 27.5176 46.2571 27.6008C45.5496 27.6904 44.9313 27.78 44.2175 27.6904H42.1778V18.8904H44.4788C45.0971 18.8904 45.7217 18.8904 46.34 18.98C46.7798 19.0696 47.2259 19.1592 47.5829 19.4216C48.2011 19.78 48.7365 20.3112 49.1763 21.0216C49.5333 21.732 49.7053 22.532 49.7053 23.2424C49.6225 24.0488 49.444 24.8488 49.0935 25.5592Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M101.002 19.1608H96.043V32.5944H101.002V19.1608Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M136.701 16.4923C136.88 15.6923 136.88 14.8027 136.523 14.0923C136.083 13.1131 135.108 12.4923 134.044 12.4923C132.801 12.4027 131.653 13.2923 131.386 14.4507C131.029 15.8715 131.825 17.2987 133.247 17.7403C133.604 17.8299 133.954 17.7403 133.687 18.1819C133.419 18.5403 133.068 18.8923 132.711 19.1611L133.24 19.9611C135.376 18.8027 136.44 17.6443 136.701 16.4923Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M125.541 18.4457C121.64 18.4457 118.453 21.6457 118.453 25.5625C118.453 29.4793 121.64 32.6793 125.541 32.6793C129.442 32.6793 132.629 29.4793 132.629 25.5625C132.629 21.6457 129.442 18.4457 125.541 18.4457ZM125.541 28.0521C124.126 28.0521 123.061 26.8937 123.061 25.5625C123.061 24.2313 124.215 23.0729 125.541 23.0729C126.867 23.0729 128.02 24.2313 128.02 25.5625C128.02 26.9001 126.956 28.0521 125.541 28.0521Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M142.286 23.6923C139.807 23.6923 139.985 22.0027 141.49 21.9131C143.083 21.8235 144.677 22.2715 145.919 23.2443L147.513 20.1339C143.172 17.5547 135.817 17.9131 135.645 22.6235C135.556 25.2923 137.595 26.6235 141.757 27.0715C144.772 27.4299 143.886 28.7611 142.197 28.9403C140.514 29.1195 138.921 28.3195 137.238 27.3403L135.109 30.5403C140.954 34.2779 147.774 32.5883 148.042 28.2299C148.31 25.6507 146.27 23.6027 142.286 23.6923Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M108.089 21.2934V19.4246H103.303V32.679H108.089V26.0102C108.089 23.7894 109.065 23.3414 110.129 23.2518C111.455 23.0726 112.43 23.3414 112.43 26.0102L112.519 32.679H117.306V22.983C117.217 18.183 109.951 18.183 108.089 21.2934Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M98.5225 12.4861C97.0183 12.4861 95.7754 13.7341 95.7754 15.2445C95.7754 16.7549 97.0183 18.0029 98.5225 18.0029C100.027 18.0029 101.27 16.7549 101.27 15.2445C101.27 13.7341 100.027 12.4861 98.5225 12.4861Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M31.8143 10.4361L22.5148 1.09853C22.075 0.656934 21.4504 0.656934 21.0106 1.09853L11.1758 10.8841L21.9858 21.7385L31.8206 11.9529C32.2604 11.5049 32.2604 10.8841 31.8143 10.4361ZM23.7577 12.9321C22.6933 14.0009 21.0106 14.0009 20.0354 12.9321C18.971 11.8633 18.971 10.1737 20.0354 9.19453C21.0998 8.12573 22.7825 8.12573 23.7577 9.19453C24.7329 10.1737 24.7329 11.8633 23.7577 12.9321Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M10.5567 11.5936L0.632581 21.4688C0.192786 21.9104 0.192786 22.5376 0.632581 22.9792L9.93202 32.3168C10.3718 32.7584 10.9964 32.7584 11.4362 32.3168L21.2711 22.5376L10.5567 11.5936ZM8.60626 24.2272C7.54183 25.2064 5.85913 25.2064 4.88393 24.2272C3.8195 23.1584 3.8195 21.4688 4.88393 20.4896C5.94836 19.5104 7.63106 19.5104 8.60626 20.4896C9.58145 21.4688 9.58145 23.1584 8.60626 24.2272ZM12.5899 24.2272C11.5255 23.248 11.5255 21.4688 12.5899 20.4896C13.6543 19.4208 15.337 19.4208 16.3122 20.4896C17.3767 21.5584 17.3767 23.248 16.3122 24.2272C15.2478 25.296 13.6543 25.296 12.5899 24.2272Z"
            })
        ]
    });

});

parcelRegister("eYMfY", function(module, exports) {

$parcel$export(module.exports, "FordLogo", function () { return $02f29ea8980591cf$export$22ac95c9dec2accf; });

var $loA2J = parcelRequire("loA2J");
const $02f29ea8980591cf$export$22ac95c9dec2accf = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "115",
        height: "41",
        viewBox: "0 0 115 41",
        fill: "currentColor",
        role: "img",
        "aria-label": "Ford",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M57.3414 0.674927C25.954 0.674927 0.511719 9.52522 0.511719 20.4487C0.511719 31.3721 25.954 40.2178 57.3414 40.2178C88.7289 40.2178 114.171 31.3721 114.171 20.4487C114.171 9.52522 88.7266 0.674927 57.3414 0.674927ZM57.3414 38.5218C27.058 38.5218 2.50943 30.4349 2.50943 20.4647C2.50943 10.4944 27.058 2.38007 57.3414 2.38007C87.6249 2.38007 112.171 10.4692 112.171 20.4487C112.171 30.4281 87.6249 38.5149 57.3414 38.5149V38.5218Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M44.9218 17.9264C46.4007 17.739 48.5789 17.531 49.9869 17.451C50.2978 17.4327 50.3618 17.4373 50.4875 17.5904C50.8651 18.0357 51.3234 18.4057 51.8384 18.6807C51.9825 18.7797 52.1491 18.841 52.3229 18.859C52.4138 18.8581 52.5033 18.8371 52.5851 18.7976C52.6668 18.7581 52.7389 18.701 52.7961 18.6304C52.8642 18.5664 52.9111 18.4829 52.9303 18.3913C52.9495 18.2998 52.9401 18.2045 52.9035 18.1184C52.8189 17.9722 51.8452 17.4327 51.8132 17.2156C51.7927 17.0762 51.9458 17.0464 51.9458 17.0464C52.3523 16.9276 52.731 16.7287 53.0596 16.4614C53.3881 16.1941 53.6599 15.8638 53.8589 15.4899C54.3047 14.635 54.3778 13.4967 53.5641 12.8659C52.8487 12.3059 51.7698 12.3973 50.9104 13.1676C50.5297 13.5183 50.2394 13.9559 50.0643 14.4431C49.8892 14.9302 49.8344 15.4524 49.9047 15.9653C49.9252 16.1299 49.9047 16.1939 49.6898 16.1939C48.3961 16.2967 47.1481 16.3333 45.7629 16.4064C45.6692 16.4064 45.6395 16.3516 45.6944 16.2853C47.2944 13.515 49.6738 11.5402 52.3229 9.59273C52.4967 9.46244 52.4418 9.21101 52.4349 9.00301C57.1984 10.0362 61.8064 11.963 66.7389 11.9242C68.7824 11.9059 70.7367 11.595 72.6064 10.5687C74.2498 9.67502 74.9172 8.84301 74.9675 7.98359C75.0064 7.38473 74.5927 7.00987 74.0029 7.13787C69.0087 8.28073 64.2498 8.28073 59.2829 7.67044C53.6464 6.98473 48.2384 5.5813 42.6315 5.5813C41.7881 5.5813 40.9424 5.6133 40.0875 5.68416C34.6681 6.1413 29.5115 9.19273 29.5001 13.8259C29.5001 16.1733 31.1641 18.0796 33.7538 17.995C36.7915 17.8899 39.2898 15.4556 40.5995 12.3859C41.0955 11.2179 40.1767 10.7356 39.7378 11.4053C38.9816 12.5797 37.9217 13.5275 36.6704 14.1482C35.2372 14.8476 33.7104 14.6579 33.2418 13.4967C32.5904 11.8556 33.9458 9.4053 37.0384 8.23959C41.5069 6.58473 46.1812 7.67959 50.6772 8.5253C50.7389 8.5253 50.9789 8.65787 50.7687 8.7653C49.7477 9.25956 48.7956 9.88504 47.9367 10.6259C46.8736 11.497 45.8899 12.4608 44.9972 13.5059C44.1058 14.5893 43.4727 15.563 42.6384 16.6304C42.6102 16.6728 42.5727 16.708 42.5287 16.7334C42.4847 16.7587 42.4354 16.7736 42.3847 16.7767C40.3367 17.131 38.3458 17.3596 36.5218 18.619C36.1469 18.8796 35.9847 19.339 36.2109 19.6956C36.2693 19.7689 36.3417 19.8298 36.4239 19.8748C36.506 19.9198 36.5963 19.948 36.6895 19.9578C36.7827 19.9676 36.8769 19.9587 36.9666 19.9318C37.0563 19.9048 37.1397 19.8603 37.2121 19.8007C38.2556 18.9932 39.5317 18.5436 40.8509 18.5184C40.9081 18.5184 40.9355 18.5344 40.9538 18.5687C40.9577 18.5849 40.9579 18.6017 40.9543 18.618C40.9507 18.6342 40.9435 18.6494 40.9332 18.6624C38.9287 21.4442 38.4189 22.0727 36.9195 23.7962C36.1743 24.6452 35.3806 25.4503 34.5424 26.2076C31.1138 29.387 27.4384 29.3322 26.1149 27.3505C25.7719 26.8382 25.5751 26.242 25.5457 25.6262C25.5163 25.0104 25.6554 24.3982 25.9481 23.8556C26.5858 22.5779 27.8704 21.6453 28.9424 21.099C29.3401 20.8956 29.4544 20.3859 29.0567 19.9219C28.8052 19.6224 28.1904 19.5676 27.7332 19.6522C26.3321 19.9104 24.6727 20.971 23.6966 22.2464C22.56 23.6964 22.0329 25.5321 22.2269 27.3642C22.5606 30.8865 25.4544 32.9162 28.7435 32.891C31.3629 32.8705 33.8269 32.0796 36.7938 29.067C39.5572 26.2579 42.0784 22.0659 44.4395 18.1733C44.5127 18.0453 44.5675 17.9699 44.9218 17.9264ZM51.8909 13.8602C52.0025 13.736 52.1556 13.6569 52.3214 13.6375C52.4872 13.6181 52.6543 13.6599 52.7915 13.755C53.0544 13.9836 52.9309 14.539 52.6635 14.9299C52.3735 15.3647 51.9359 15.6797 51.4315 15.8167H51.3972C51.3218 15.8167 51.2601 15.7642 51.2258 15.5882C51.1896 15.2679 51.2311 14.9436 51.3469 14.6428C51.4627 14.3419 51.6493 14.0735 51.8909 13.8602Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M92.5408 13.7385H89.5031C89.2745 13.7385 89.1625 13.7682 89.0574 13.9671C88.7054 14.6368 84.4516 21.0117 83.6608 22.2482C83.5305 22.4357 83.3659 22.4082 83.3454 22.1957C83.2676 21.4597 82.6322 20.6162 81.6311 20.2117C80.9069 19.9192 80.117 19.8283 79.3454 19.9488C77.9465 20.1362 76.7008 20.8631 75.6036 21.7065C73.9556 22.9637 72.5294 24.5911 70.6916 25.7934C69.6836 26.4585 68.3122 27.0254 67.3979 26.1751C66.5659 25.4025 66.6596 23.6882 67.9305 22.3602C68.0676 22.2231 68.2276 22.3397 68.2025 22.4631C68.1338 22.7513 68.1425 23.0525 68.2276 23.3362C68.3127 23.62 68.4712 23.8763 68.6871 24.0791C68.9628 24.3176 69.3042 24.4672 69.6665 24.508C70.0288 24.5488 70.3949 24.4789 70.7168 24.3077C71.1004 24.1091 71.4297 23.8197 71.6759 23.4648C71.9221 23.1098 72.0778 22.7 72.1294 22.2711C72.1744 21.9558 72.1541 21.6346 72.0697 21.3275C71.9854 21.0204 71.8387 20.7339 71.6389 20.4859C71.4391 20.2378 71.1904 20.0336 70.9083 19.8857C70.6262 19.7379 70.3167 19.6497 69.9991 19.6265C68.9385 19.5534 67.9237 19.9214 66.9362 20.7397C66.468 21.1167 66.0609 21.5639 65.7294 22.0654C65.6219 22.214 65.4619 22.23 65.4688 22.006C65.5168 20.2757 64.7991 19.2997 63.3682 19.2631C62.2551 19.238 61.0688 19.8391 60.1408 20.5797C59.1282 21.3934 58.2391 22.4722 57.2882 23.4894C57.1694 23.6151 57.0596 23.6082 57.0345 23.366C57.0048 22.2231 56.7145 21.1054 56.1842 20.3168C56.087 20.1724 55.9398 20.0692 55.771 20.027C55.6021 19.9848 55.4236 20.0066 55.2699 20.0882C54.891 20.269 54.5298 20.4848 54.1911 20.7328C54.0929 20.8138 54.0225 20.9234 53.9897 21.0464C53.9569 21.1693 53.9634 21.2994 54.0082 21.4185C54.5153 23.1725 54.4097 25.0469 53.7088 26.7328C53.0711 28.2437 51.8276 29.6014 50.3694 30.0654C49.4094 30.3671 48.4082 30.2185 47.7888 29.366C46.9408 28.1911 47.2836 26.1431 48.5476 24.4471C49.6676 22.95 51.2905 22.0014 52.8905 21.3865C52.9278 21.3788 52.9629 21.3627 52.9931 21.3394C53.0232 21.3161 53.0477 21.2863 53.0647 21.2522C53.0816 21.2181 53.0906 21.1805 53.0909 21.1424C53.0912 21.1043 53.0829 21.0666 53.0665 21.0322C52.9774 20.7648 52.8379 20.406 52.7831 20.2414C52.6322 19.8482 52.2208 19.7842 51.7134 19.8391C50.5628 19.9917 49.4524 20.3642 48.4425 20.9362C45.6996 22.3991 44.3282 25.2311 43.7385 26.7488C43.5351 27.3179 43.2453 27.8521 42.8791 28.3328C42.4494 28.8723 41.9076 29.366 40.9179 30.2345C40.8649 30.2853 40.8289 30.3512 40.815 30.4233C40.8011 30.4954 40.8099 30.57 40.8402 30.6368C40.9408 30.8425 41.4574 31.5694 41.5991 31.638C41.6734 31.6578 41.7516 31.6586 41.8263 31.6402C41.901 31.6218 41.9699 31.5849 42.0265 31.5328C42.7381 31.0436 43.3848 30.466 43.9511 29.814C44.0951 29.6448 44.2391 29.718 44.3145 29.9785C44.4953 30.6541 44.84 31.2745 45.3181 31.7849C45.7961 32.2953 46.3928 32.6798 47.0551 32.9043C49.5694 33.7523 52.1591 32.5294 54.1225 30.39C55.3682 29.0368 55.8208 28.166 56.2985 27.574C57.1122 26.5705 58.7122 24.326 60.6094 22.886C61.3065 22.3511 62.1339 21.9442 62.5476 22.214C62.8814 22.4425 62.9888 22.934 62.4539 23.9054C60.5134 27.4482 57.6539 31.6128 57.1351 32.6208C57.0368 32.7991 57.1351 32.934 57.3065 32.934C58.3236 32.934 59.3294 32.934 60.2505 32.934C60.312 32.9324 60.372 32.9144 60.4243 32.8819C60.4765 32.8493 60.5191 32.8034 60.5476 32.7488C62.0379 30.4174 63.4391 28.2002 64.9408 25.9054C65.0254 25.7705 65.1031 25.8757 65.1054 25.9351C65.1396 26.4654 65.2676 27.1945 65.5854 27.6722C65.8183 28.0636 66.1499 28.387 66.547 28.6101C66.9441 28.8331 67.3928 28.9479 67.8482 28.9431C68.5591 28.9431 68.9202 28.8425 69.6768 28.5545C70.2133 28.3555 70.7201 28.084 71.1831 27.7477C71.4116 27.59 71.4482 27.8528 71.4414 27.894C71.0962 29.7431 71.5236 31.9351 73.3637 32.8448C75.5625 33.9283 77.9808 32.406 79.3751 31.0277C79.5076 30.8951 79.6539 30.9088 79.6699 31.1945C79.7065 31.7943 79.9552 32.3614 80.3717 32.7945C81.5374 33.9625 83.8894 33.4985 86.2505 31.67C87.7659 30.502 89.3545 28.8471 90.7854 27.0985C90.8043 27.0796 90.8193 27.0572 90.8296 27.0325C90.8398 27.0078 90.8451 26.9813 90.8451 26.9545C90.8451 26.9278 90.8398 26.9013 90.8296 26.8766C90.8193 26.8519 90.8043 26.8294 90.7854 26.8105C90.5568 26.582 90.2528 26.3237 90.0357 26.1248C89.9887 26.089 89.9313 26.0697 89.8722 26.0697C89.8132 26.0697 89.7558 26.089 89.7088 26.1248C88.2414 27.5237 86.9179 29.1168 85.0094 30.4334C84.3625 30.8905 83.3362 31.2494 82.8745 30.6231C82.6939 30.3808 82.7145 30.0448 82.8928 29.606C83.4482 28.2162 92.2642 14.79 92.7214 13.9945C92.8036 13.8391 92.7214 13.7385 92.5408 13.7385ZM81.0665 25.238C81.0848 25.3431 81.2174 25.4414 81.3476 25.4871C81.3956 25.5031 81.4208 25.5397 81.3705 25.6448C81.031 26.3334 80.6333 26.9918 80.1819 27.6128C79.7627 28.23 79.2525 28.7802 78.6688 29.2448C77.9831 29.8117 77.0917 30.4174 76.2505 30.4174C75.9983 30.4206 75.7493 30.3609 75.5259 30.2437C75.0688 30.0151 74.8745 29.3728 74.8814 28.8585C74.9065 27.414 75.5488 25.9305 76.7351 24.4722C78.1819 22.6894 79.7819 21.766 80.8311 22.2711C81.9191 22.79 81.5739 24.0448 81.0871 25.0345C81.0538 25.097 81.0464 25.1701 81.0665 25.238Z"
            })
        ]
    });

});

parcelRegister("ffaCM", function(module, exports) {

$parcel$export(module.exports, "NasaLogo", function () { return $c9d60dfb6fbd33d9$export$e44efe2f415651b3; });

var $loA2J = parcelRequire("loA2J");
const $c9d60dfb6fbd33d9$export$e44efe2f415651b3 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "88",
        height: "72",
        viewBox: "0 0 88 72",
        fill: "currentColor",
        role: "img",
        "aria-label": "NASA",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M76.4359 36C76.4359 55.7457 60.1693 71.9967 40.4025 71.9967C20.6364 71.9967 4.36914 55.7447 4.36914 36C4.36914 16.2532 20.256 0.0032959 40.4025 0.0032959C59.787 0.0032959 76.4359 16.2541 76.4359 36Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M48.5289 54.9456C63.9235 61.2787 61.2524 45.2754 53.0462 33.0216C48.3951 26.0795 42.3294 20.2956 38.5036 17.5045C25.8183 8.24615 17.9873 13.8614 26.9449 32.1201C29.8412 38.0235 33.5609 42.0079 36.4663 45.7634C38.6851 48.6306 43.0069 50.0662 41.4845 51.426C39.7687 52.9603 35.6147 46.1937 35.6147 46.1937C32.5467 42.4938 29.6224 38.5457 26.6085 33.1273C19.723 20.7524 20.7158 8.12178 33.1799 13.6237C43.7574 18.2953 53.8606 31.3977 57.9232 40.7025C59.7991 44.9995 64.9144 61.9986 48.6221 55.1256",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M0.658203 46.6707C7.43066 42.1604 13.8517 39.2483 24.7788 35.6388C40.1336 30.5663 51.6898 27.1567 65.87 20.0294C72.2171 16.8399 83.23 9.68665 87.168 3.46851C85.9891 5.87521 82.3362 10.5597 80.6837 12.6312C61.4447 36.7206 20.464 35.3546 0.928637 46.9194"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M10.4824 29.0644C16.6807 29.113 16.0726 29.0519 16.145 29.1246C16.2532 29.1246 21.0941 37.461 21.0941 37.5334C21.0941 37.5686 21.0581 34.5706 21.0581 30.8208C21.0581 30.3878 19.8666 29.1249 19.9021 29.1249C21.6714 29.1249 23.9836 29.161 23.9836 29.161C23.1173 30.1715 22.9441 30.0881 22.9367 30.713C22.9123 32.7206 22.8897 36.4321 22.9367 40.6002C22.9435 41.2251 23.4064 41.4665 24.1652 42.5491H18.4931C16.6508 39.4818 13.2748 33.7275 13.2916 33.7443C13.3176 33.7706 13.2189 37.3537 13.327 40.2399C13.3634 41.1936 13.797 41.5028 14.5921 42.3694C14.5921 42.3694 15.5067 42.345 10.1484 42.4052C11.7741 41.5389 11.5581 40.4565 11.5574 40.4205C11.4991 36.4321 11.5452 33.0222 11.5452 30.8208C11.5452 30.46 11.5208 30.4957 10.4015 29.1246M29.8626 35.2239C30.383 33.417 30.8276 31.8024 31.0388 30.749C31.0745 30.5684 30.6415 29.9191 29.9552 29.2694L29.9066 29.1686C33.2163 29.1793 36.6739 29.1979 36.6739 29.1979C37.5771 31.3987 39.6358 37.5695 41.1893 41.3592C41.6 42.36 42.3093 42.5497 42.3093 42.5497C39.4916 42.514 34.2626 42.5384 34.2904 42.514C35.6988 41.2501 35.5182 41.2501 34.904 39.4112H30.4973C29.594 41.5037 30.7787 42.4859 30.9303 42.4782C29.9274 42.5302 26.5236 42.4782 26.5236 42.4782C28.3659 41.1783 28.2571 40.7817 28.2571 40.7817C28.7631 38.9812 29.3495 37.0087 29.8629 35.2236L31.671 35.2239L30.8942 37.7137H34.3992L32.4481 32.7334L31.6713 35.2233L29.8632 35.223M60.1359 35.4042C60.6554 33.5979 61.1003 31.9826 61.3115 30.9293C61.3469 30.749 60.9133 30.0997 60.2273 29.4494L60.1787 29.3492C63.4893 29.3599 66.9475 29.3782 66.9475 29.3782C67.8492 31.5796 69.9085 37.7498 71.4614 41.5395C71.8718 42.5415 72.5804 42.73 72.5804 42.73C69.7646 42.6943 64.5353 42.7187 64.5625 42.6943C65.9712 41.4313 65.7912 41.4313 65.177 39.5915H60.7694C59.8661 41.6843 61.0502 42.6662 61.2017 42.6591C60.1998 42.7105 56.7951 42.6591 56.7951 42.6591C58.6374 41.3598 58.5295 40.9626 58.5295 40.9626C59.0355 39.1615 59.6216 37.1899 60.1359 35.4042H61.9437C61.5544 36.65 61.1675 37.8949 61.1675 37.8949H64.6706L62.7195 32.914C62.7195 32.914 62.3324 34.1586 61.9437 35.4035L60.1359 35.4042ZM54.4372 32.4462C54.3654 29.8824 54.4372 29.0531 54.4372 29.0531C53.317 29.9558 53.8826 29.8406 51.0784 29.3779C42.9977 28.0447 42.382 35.5884 46.7795 37.2804C50.4709 38.7013 51.7784 38.98 51.2223 40.3114C51.0417 40.7459 47.6825 42.3331 44.2148 39.1209L44.2854 43.596C44.7193 43.1496 45.912 42.3331 45.912 42.3331C45.9471 42.3331 49.6706 43.9731 53.0276 42.261C58.194 39.6272 55.6155 35.3635 50.102 33.6725C45.5138 32.265 49.849 28.9807 54.4 32.4816M40.9091 3.27236C40.9089 3.35014 40.8779 3.42468 40.823 3.47974C40.768 3.5348 40.6936 3.56592 40.6158 3.56632C40.538 3.56584 40.4636 3.53469 40.4087 3.47965C40.3537 3.42461 40.3227 3.35011 40.3224 3.27236C40.3224 3.11284 40.4554 2.97961 40.6158 2.97961C40.6934 2.97986 40.7678 3.01076 40.8227 3.06559C40.8777 3.12042 40.9087 3.19473 40.9091 3.27236ZM42.9443 7.71602C42.9443 7.91404 42.7799 8.07752 42.5831 8.07752C42.4873 8.07712 42.3955 8.03891 42.3278 7.97122C42.26 7.90352 42.2218 7.8118 42.2213 7.71602C42.2213 7.51862 42.3844 7.35575 42.5831 7.35575C42.7802 7.35575 42.9443 7.51832 42.9443 7.71602ZM48.224 14.9783C48.224 15.1757 48.062 15.3392 47.8625 15.3392C47.7669 15.3386 47.6755 15.3003 47.6079 15.2328C47.5403 15.1653 47.502 15.0739 47.5013 14.9783C47.5013 14.7803 47.6526 14.6165 47.8515 14.6165C48.0507 14.6171 48.224 14.7803 48.224 14.9783ZM39.7357 10.2196C39.7354 10.2973 39.7044 10.3717 39.6494 10.4266C39.5945 10.4815 39.52 10.5124 39.4424 10.5126C39.3646 10.5124 39.2901 10.4815 39.2351 10.4266C39.18 10.3717 39.1489 10.2973 39.1484 10.2196C39.1484 10.0592 39.2813 9.92625 39.4424 9.92625C39.5201 9.92649 39.5946 9.95747 39.6495 10.0124C39.7045 10.0674 39.7355 10.1419 39.7357 10.2196ZM42.8984 11.889C42.8979 11.9665 42.8668 12.0407 42.812 12.0954C42.7571 12.1502 42.6829 12.1812 42.6054 12.1817C42.5278 12.1813 42.4535 12.1504 42.3985 12.0956C42.3435 12.0408 42.3124 11.9666 42.3117 11.889C42.3117 11.7285 42.4446 11.5959 42.6054 11.5959C42.7658 11.5959 42.8984 11.7285 42.8984 11.889ZM38.7884 7.21947C38.7884 7.41748 38.6253 7.58096 38.4273 7.58096C38.2292 7.58096 38.0661 7.4184 38.0661 7.21947C38.0661 7.02206 38.2292 6.85828 38.4273 6.85828C38.6253 6.85828 38.7884 7.02145 38.7884 7.21947ZM34.0031 10.1295C34.0031 10.2905 33.8708 10.4228 33.7095 10.4228C33.6318 10.4224 33.5574 10.3914 33.5025 10.3364C33.4476 10.2815 33.4165 10.2071 33.4161 10.1295C33.4161 9.96903 33.5487 9.8361 33.7095 9.8361C33.7872 9.83634 33.8617 9.86732 33.9168 9.92227C33.9718 9.97723 34.0028 10.0517 34.0031 10.1295ZM34.8587 10.7152C34.8584 10.7931 34.8274 10.8677 34.7723 10.9228C34.7172 10.9778 34.6427 11.0089 34.5648 11.0092C34.4869 11.0088 34.4124 10.9777 34.3574 10.9227C34.3023 10.8676 34.2712 10.7931 34.2708 10.7152C34.2743 10.6396 34.3068 10.5682 34.3615 10.5159C34.4163 10.4636 34.4891 10.4344 34.5648 10.4344C34.6405 10.4344 34.7133 10.4636 34.7681 10.5159C34.8228 10.5682 34.8553 10.6396 34.8587 10.7152ZM35.7174 11.3019C35.7172 11.3797 35.6862 11.4543 35.6313 11.5093C35.5763 11.5644 35.5018 11.5955 35.4241 11.5959C35.3463 11.5955 35.2717 11.5644 35.2168 11.5093C35.1618 11.4543 35.1307 11.3798 35.1304 11.3019C35.1304 11.1421 35.2633 11.0095 35.4241 11.0095C35.5851 11.0095 35.7174 11.1418 35.7174 11.3019ZM34.4096 12.4301C34.4088 12.5078 34.3775 12.582 34.3225 12.6369C34.2676 12.6918 34.1933 12.7228 34.1156 12.7235C34.0379 12.7231 33.9634 12.6921 33.9084 12.6372C33.8534 12.5822 33.8222 12.5079 33.8216 12.4301C33.8216 12.2697 33.9542 12.1371 34.1156 12.1371C34.276 12.1371 34.4096 12.2697 34.4096 12.4301ZM27.5903 17.2115C27.5899 17.2892 27.5587 17.3635 27.5036 17.4184C27.4486 17.4732 27.3741 17.504 27.2964 17.5042C27.1353 17.5042 27.0027 17.3722 27.0027 17.2115C27.0027 17.0507 27.1357 16.9178 27.2964 16.9178C27.4571 16.9178 27.5903 17.0504 27.5903 17.2115ZM28.8542 18.7457C28.8536 18.8234 28.8224 18.8976 28.7674 18.9525C28.7125 19.0073 28.6382 19.0383 28.5605 19.0388C28.4829 19.0383 28.4085 19.0073 28.3535 18.9525C28.2985 18.8977 28.2673 18.8234 28.2666 18.7457C28.2666 18.5844 28.3995 18.4524 28.5605 18.4524C28.7216 18.4524 28.8542 18.5844 28.8542 18.7457ZM27.8495 43.5111C27.849 43.5887 27.8179 43.6631 27.7629 43.718C27.7079 43.7728 27.6335 43.8038 27.5558 43.8041C27.3948 43.8041 27.2625 43.6715 27.2625 43.5111C27.2625 43.3506 27.3948 43.2174 27.5558 43.2174C27.7172 43.2174 27.8495 43.3506 27.8495 43.5111ZM28.0301 50.3434C28.0301 50.5414 27.8669 50.7046 27.6689 50.7046C27.4709 50.7046 27.3077 50.5423 27.3077 50.3434C27.3077 50.146 27.4709 49.9828 27.6689 49.9828C27.7644 49.9833 27.8559 50.0214 27.9235 50.0889C27.9911 50.1564 28.0294 50.2479 28.0301 50.3434ZM24.1459 53.8429C24.1453 53.9204 24.1143 53.9946 24.0594 54.0493C24.0046 54.1041 23.9304 54.1351 23.8529 54.1356C23.7753 54.1352 23.7009 54.1043 23.646 54.0495C23.591 53.9947 23.5598 53.9205 23.5592 53.8429C23.5592 53.6812 23.6921 53.5492 23.8529 53.5492C24.0133 53.5492 24.1459 53.6809 24.1459 53.8429ZM19.4957 55.2601C19.495 55.3558 19.4567 55.4474 19.389 55.515C19.3212 55.5826 19.2296 55.6208 19.1339 55.6213C19.0382 55.621 18.9465 55.5828 18.8788 55.5152C18.8112 55.4475 18.773 55.3558 18.7727 55.2601C18.7727 55.0624 18.9359 54.8989 19.1339 54.8989C19.2295 54.8995 19.3212 54.9377 19.3889 55.0053C19.4566 55.0729 19.4949 55.1644 19.4957 55.2601ZM18.5472 52.1038C18.5472 52.3009 18.384 52.4641 18.1866 52.4641C18.0911 52.4636 17.9996 52.4255 17.932 52.3581C17.8644 52.2907 17.8261 52.1993 17.8254 52.1038C17.8258 52.0081 17.8639 51.9163 17.9316 51.8485C17.9992 51.7808 18.0908 51.7424 18.1866 51.7417C18.384 51.7426 18.5472 51.9055 18.5472 52.1038ZM18.006 54.1115C18.006 54.2725 17.8731 54.4045 17.7123 54.4045C17.5516 54.4045 17.4184 54.2725 17.4184 54.1115C17.4184 53.9516 17.5516 53.8181 17.7123 53.8181C17.8731 53.8181 18.006 53.9507 18.006 54.1115ZM14.5282 52.4433C14.5278 52.5208 14.4968 52.5951 14.442 52.6499C14.3872 52.7047 14.313 52.7358 14.2355 52.7364C14.1578 52.736 14.0833 52.7051 14.0283 52.6502C13.9733 52.5954 13.9421 52.521 13.9415 52.4433C13.9415 52.2835 14.0742 52.1503 14.2355 52.1503C14.3956 52.1503 14.5282 52.2826 14.5282 52.4433ZM26.6748 58.0809C26.6748 58.2419 26.5535 58.3745 26.3931 58.3745C26.2321 58.3745 26.0878 58.2419 26.0878 58.0809C26.0878 57.9204 26.2208 57.7875 26.3812 57.7875C26.5428 57.7875 26.6748 57.9201 26.6748 58.0809ZM30.3332 55.3979C30.3332 55.5959 30.1816 55.7597 29.983 55.7597C29.785 55.7597 29.6108 55.5969 29.6108 55.3979C29.6108 55.2005 29.774 55.0373 29.972 55.0373C30.0675 55.0378 30.159 55.076 30.2267 55.1435C30.2943 55.211 30.3325 55.3024 30.3332 55.3979ZM30.7518 58.8479C30.7518 59.0089 30.6073 59.1421 30.4472 59.1421C30.3693 59.1417 30.2948 59.1105 30.2397 59.0554C30.1847 59.0003 30.1536 58.9257 30.1532 58.8479C30.1532 58.6881 30.2858 58.5554 30.4472 58.5554C30.6073 58.5551 30.7518 58.6871 30.7518 58.8479ZM45.7861 55.5538C45.7856 55.6313 45.7546 55.7056 45.6998 55.7605C45.6451 55.8154 45.5709 55.8466 45.4934 55.8474C45.4155 55.847 45.341 55.8159 45.2859 55.7609C45.2308 55.706 45.1995 55.6316 45.1988 55.5538C45.1988 55.3927 45.3314 55.2607 45.4934 55.2607C45.6535 55.2607 45.7861 55.3927 45.7861 55.5538ZM38.7884 58.0347C38.7881 58.1124 38.7571 58.1868 38.7021 58.2417C38.6472 58.2966 38.5728 58.3275 38.4951 58.3278C38.4175 58.3274 38.3431 58.2964 38.2882 58.2415C38.2333 58.1867 38.2022 58.1124 38.2017 58.0347C38.2017 57.8749 38.3347 57.7417 38.4951 57.7417C38.6564 57.7417 38.7884 57.8743 38.7884 58.0347ZM57.6183 61.6008C57.6176 61.6784 57.5865 61.7527 57.5315 61.8075C57.4766 61.8624 57.4022 61.8934 57.3246 61.8938C57.2469 61.8935 57.1724 61.8626 57.1173 61.8077C57.0622 61.7529 57.031 61.6785 57.0303 61.6008C57.0303 61.4407 57.1636 61.3077 57.3246 61.3077C57.485 61.3077 57.6183 61.4401 57.6183 61.6008ZM59.1519 47.728C59.1514 47.8238 59.1131 47.9154 59.0453 47.9831C58.9776 48.0508 58.8859 48.089 58.7901 48.0895C58.6945 48.0889 58.6028 48.0507 58.5352 47.983C58.4675 47.9153 58.4292 47.8237 58.4286 47.728C58.4286 47.53 58.5915 47.3665 58.7901 47.3665C58.8859 47.3669 58.9777 47.4051 59.0454 47.4728C59.1132 47.5405 59.1515 47.6322 59.1519 47.728ZM56.2643 49.6898C56.2637 49.7676 56.2325 49.8421 56.1774 49.897C56.1223 49.952 56.0478 49.983 55.97 49.9834C55.8099 49.9834 55.677 49.8505 55.677 49.6898C55.677 49.5291 55.8099 49.397 55.97 49.397C56.1313 49.397 56.2643 49.5288 56.2643 49.6898ZM59.1098 50.2551C59.1098 50.4528 58.9469 50.6169 58.748 50.6169C58.549 50.6169 58.3862 50.4537 58.3862 50.2551C58.3862 50.0577 58.549 49.8939 58.748 49.8939C58.9469 49.8939 59.1098 50.0577 59.1098 50.2551ZM56.2643 53.7509C56.2637 53.8286 56.2325 53.903 56.1774 53.9579C56.1223 54.0128 56.0478 54.0437 55.97 54.0439C55.8925 54.0434 55.8182 54.0123 55.7634 53.9575C55.7086 53.9026 55.6775 53.8284 55.677 53.7509C55.677 53.5898 55.8099 53.4572 55.97 53.4572C56.1313 53.4572 56.2643 53.5895 56.2643 53.7509ZM63.6225 45.7662C63.6225 45.9263 63.489 46.0596 63.3289 46.0596C63.2513 46.0589 63.1771 46.0278 63.1222 45.9729C63.0674 45.918 63.0364 45.8438 63.0358 45.7662C63.0358 45.6055 63.1684 45.4735 63.3289 45.4735C63.4893 45.4735 63.6225 45.6055 63.6225 45.7662ZM64.3345 47.5477C64.3345 47.7454 64.1839 47.9092 63.9849 47.9092C63.7866 47.9092 63.6121 47.7463 63.6121 47.5477C63.6121 47.3497 63.775 47.1868 63.973 47.1868C64.1716 47.1874 64.3345 47.3497 64.3345 47.5477ZM69.404 49.6684C69.404 49.8661 69.2426 50.0296 69.0425 50.0296C68.9467 50.0293 68.855 49.9911 68.7872 49.9235C68.7195 49.8558 68.6812 49.7641 68.6807 49.6684C68.6813 49.5726 68.7196 49.481 68.7873 49.4133C68.855 49.3456 68.9467 49.3074 69.0425 49.3069C69.1383 49.3072 69.23 49.3454 69.2978 49.4131C69.3655 49.4809 69.4037 49.5726 69.404 49.6684ZM64.2547 53.4364C64.254 53.5142 64.2227 53.5885 64.1677 53.6433C64.1126 53.6981 64.0382 53.7291 63.9605 53.7295C63.8828 53.7291 63.8085 53.6981 63.7535 53.6433C63.6985 53.5884 63.6674 53.5141 63.6668 53.4364C63.6668 53.2754 63.8001 53.1428 63.9605 53.1428C64.1209 53.1428 64.2547 53.2745 64.2547 53.4364ZM67.5064 50.3682C67.506 50.4458 67.475 50.5201 67.4201 50.5749C67.3652 50.6298 67.2909 50.6608 67.2133 50.6612C67.1357 50.6607 67.0614 50.6297 67.0065 50.5749C66.9516 50.52 66.9205 50.4458 66.92 50.3682C66.92 50.208 67.0535 50.0748 67.2133 50.0748C67.3737 50.0748 67.5064 50.2071 67.5064 50.3682ZM66.9074 55.1046C66.907 55.1822 66.876 55.2565 66.8212 55.3113C66.7663 55.3662 66.692 55.3972 66.6144 55.3976C66.5366 55.3975 66.462 55.3666 66.4069 55.3117C66.3518 55.2568 66.3206 55.1824 66.3201 55.1046C66.3201 54.9448 66.4527 54.8112 66.6144 54.8112C66.7748 54.8112 66.9074 54.9438 66.9074 55.1046ZM68.2856 47.233C68.2856 47.4808 68.0815 47.684 67.8336 47.684C67.5861 47.684 67.3823 47.4808 67.3823 47.233C67.3823 46.9854 67.5861 46.7822 67.8336 46.7822C68.0815 46.7822 68.2856 46.9854 68.2856 47.233Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M67.8322 45.8578L67.698 47.0981L66.4675 47.2338L67.7087 47.3682L67.8444 48.6544L67.9801 47.3682L69.1987 47.21L67.9691 47.0972L67.8322 45.8578ZM65.1223 55.0797C65.1223 55.3279 64.9185 55.5317 64.6707 55.5317C64.551 55.5312 64.4363 55.4834 64.3517 55.3988C64.267 55.3141 64.2192 55.1994 64.2188 55.0797C64.2188 54.8322 64.4229 54.629 64.6707 54.629C64.7902 54.6295 64.9046 54.6771 64.9892 54.7615C65.0738 54.8459 65.1216 54.9603 65.1223 55.0797Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M64.6731 53.7047L64.5374 54.9457L63.3074 55.0804L64.5487 55.2161L64.6847 56.5011L64.8204 55.2161L66.0384 55.0578L64.8078 54.9448L64.6731 53.7047ZM31.4384 17.8199C31.4384 18.0674 31.2346 18.2709 30.9871 18.2709C30.8675 18.2706 30.7529 18.223 30.6682 18.1385C30.5835 18.054 30.5357 17.9395 30.5352 17.8199C30.5352 17.5717 30.7387 17.3685 30.9871 17.3685C31.2346 17.3691 31.4384 17.5723 31.4384 17.8199Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M30.9876 16.4441L30.8519 17.6845L29.6211 17.8201L30.863 17.9543L30.9986 19.2411L31.1337 17.9543L32.3529 17.7972L31.1221 17.6839L30.9876 16.4441ZM48.237 6.90409C48.237 7.15161 48.0329 7.35543 47.7851 7.35543C47.5373 7.35543 47.334 7.15161 47.334 6.90409C47.334 6.65597 47.5369 6.45215 47.7851 6.45215C48.0332 6.45215 48.237 6.65658 48.237 6.90409Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M47.7847 5.5271L47.6503 6.76834L46.42 6.90402L47.6616 7.03878L47.796 8.32464L47.9317 7.03878L49.1503 6.88049L47.9198 6.76773L47.7847 5.5271ZM27.8154 62.3008C27.8154 62.5489 27.6116 62.7521 27.3641 62.7521C27.2444 62.7517 27.1298 62.704 27.0451 62.6195C26.9605 62.535 26.9127 62.4204 26.9121 62.3008C26.9121 62.0536 27.1159 61.8491 27.3641 61.8491C27.6116 61.8494 27.8154 62.0539 27.8154 62.3008Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M27.3734 60.923L27.2384 62.1642L26.0078 62.2993L27.2494 62.434L27.3847 63.7199L27.5198 62.434L28.739 62.2764L27.5088 62.1633L27.3734 60.923Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M87.1638 3.46875C81.6723 19.7596 59.6743 32.3392 41.1564 44.3476C29.9849 51.595 18.8935 59.9362 11.2578 67.0335C9.24526 68.9052 11.6679 66.3335 10.8966 67.124C21.5526 54.8548 33.8104 47.5467 40.5841 42.9463C52.0398 35.1636 58.5556 33.2021 78.3195 14.9975"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M5.23755 43.8289C3.26537 44.7929 1.49884 45.746 0 46.6765L0.911835 47.0084C2.22275 46.2013 3.79646 45.3595 5.45421 44.6179M15.6491 62.0592C13.7728 63.6953 11.9275 65.3667 10.1142 67.0724L10.0317 68.3164C11.7429 66.5529 13.845 64.6501 16.2709 62.6303"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M48.5295 54.9457C63.9241 61.2787 61.253 45.2755 53.0468 33.0216C48.3954 26.0796 42.6597 20.5725 38.5039 17.5045C33.6514 13.9217 33.1777 13.6246 33.1777 13.6246C44.014 18.7678 53.8584 31.3984 57.9204 40.7038C59.797 45.0005 64.912 61.9996 48.6193 55.1266",
                fill: "white"
            })
        ]
    });

});

parcelRegister("aWQH0", function(module, exports) {

$parcel$export(module.exports, "VisaLogo", function () { return $3796f047ffb865cc$export$c17820a482ea0e7b; });

var $loA2J = parcelRequire("loA2J");
const $3796f047ffb865cc$export$c17820a482ea0e7b = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "61",
        height: "19",
        viewBox: "0 0 61 19",
        fill: "currentColor",
        role: "img",
        "aria-label": "Visa",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M44.4329 0.753178C43.0385 0.245085 41.5646 -0.00987869 40.0805 0.000292741C35.2812 0.000292741 31.8917 2.41793 31.8677 5.88841C31.8378 8.43803 34.2764 9.87481 36.1211 10.7267C38.0138 11.6026 38.6467 12.1545 38.6407 12.9374C38.6287 14.1282 37.129 14.6681 35.7342 14.6681C33.8175 14.6681 32.7706 14.4011 31.1599 13.7322L30.5629 13.4533L29.882 17.4487C31.0489 17.9346 33.1516 18.3515 35.3232 18.3875C40.4255 18.3875 43.761 15.9849 43.8 12.2924C43.8419 10.2558 42.5221 8.71698 39.7446 7.44517C38.0558 6.6203 37.009 6.06838 37.009 5.23151C37.009 4.49062 37.9058 3.69874 39.7806 3.69874C41.0282 3.66855 42.2682 3.90264 43.419 4.38563L43.8689 4.5866L44.5498 0.726183L44.4329 0.753178ZM56.887 0.324244H53.1376C51.9707 0.324244 51.0919 0.645195 50.5819 1.80302L43.371 18.1386H48.4733L49.4931 15.46L55.7202 15.466C55.8672 16.0929 56.3171 18.1386 56.3171 18.1386H60.8164L56.887 0.324244ZM24.9658 0.174265H29.8281L26.7865 17.9976H21.9302L24.9658 0.168267V0.174265ZM12.6226 9.99779L13.1266 12.4724L17.8778 0.324244H23.0281L15.3762 18.1146H10.238L6.03862 3.05083C5.97061 2.80245 5.81088 2.58912 5.59169 2.45392C4.07812 1.67205 2.47439 1.07871 0.816406 0.687187L0.882396 0.312243H8.70822C9.77006 0.354237 10.6249 0.687188 10.9099 1.82102L12.6196 10.0068L12.6226 9.99779ZM50.8879 11.8155L52.8256 6.83027C52.8016 6.88426 53.2245 5.80142 53.4705 5.13252L53.8035 6.67129L54.9283 11.8125H50.8849L50.8879 11.8155Z"
        })
    });

});

parcelRegister("fFExq", function(module, exports) {

$parcel$export(module.exports, "ArrowRight", function () { return $ee64df7f31100616$export$acad20503ad73ac1; });

var $loA2J = parcelRequire("loA2J");
const $ee64df7f31100616$export$acad20503ad73ac1 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        "aria-hidden": "true",
        width: "11",
        height: "8",
        viewBox: "0 0 11 8",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.40796 0L6.32831 1.2021L8.07854 3.1497H0.763182C0.341906 3.1497 0 3.53038 0 3.99943C0 4.46849 0.341906 4.84917 0.763182 4.84917H8.07854L6.32831 6.7979L7.40796 8L11 3.99943L7.40796 0Z"
        })
    });

});

parcelRegister("fkaMJ", function(module, exports) {

$parcel$export(module.exports, "getProductSoftwareDevelopmentModalImage", function () { return $10461bbd0abce98a$export$6954fe49bbdabc54; });
$parcel$export(module.exports, "getProductMarketingModalImage", function () { return $10461bbd0abce98a$export$cc19a82b226e3f08; });
$parcel$export(module.exports, "getProductItModalImage", function () { return $10461bbd0abce98a$export$fa7e84d2d2c567a7; });
$parcel$export(module.exports, "getUpdatedProductItModalImage", function () { return $10461bbd0abce98a$export$f31d1f714b55f0fb; });
$parcel$export(module.exports, "getProductDesignModalImage", function () { return $10461bbd0abce98a$export$e0ab49165f0180f7; });
$parcel$export(module.exports, "getProductOperationsModalImage", function () { return $10461bbd0abce98a$export$51a8246da0eeafec; });
$parcel$export(module.exports, "getDoubleFeatureFirstImage", function () { return $10461bbd0abce98a$export$af7f348492750745; });
$parcel$export(module.exports, "getDoubleFeatureSecondImage", function () { return $10461bbd0abce98a$export$51c1e8c9994962ad; });
$parcel$export(module.exports, "getCollaborateFirstImage", function () { return $10461bbd0abce98a$export$7a98b35c48983fe6; });
$parcel$export(module.exports, "getCollaborateSecondImage", function () { return $10461bbd0abce98a$export$3ff8286854e1bb40; });
$parcel$export(module.exports, "getCollaborateThirdImage", function () { return $10461bbd0abce98a$export$54ce02c1025509fa; });
$parcel$export(module.exports, "getCollaborateFourthImage", function () { return $10461bbd0abce98a$export$ea3cb1bf26550cc6; });
$parcel$export(module.exports, "getHeroCardOperationsImage", function () { return $10461bbd0abce98a$export$a27f10b8f2dbe6ec; });
$parcel$export(module.exports, "getHeroCardDesignImage", function () { return $10461bbd0abce98a$export$d2a58a00fc2c43; });
$parcel$export(module.exports, "getHeroCardItImage", function () { return $10461bbd0abce98a$export$e7e5a083e5974d8d; });
$parcel$export(module.exports, "getHeroCardMarketingImage", function () { return $10461bbd0abce98a$export$bf236abab7f9a91d; });
$parcel$export(module.exports, "getHeroCardSoftwareDevelopmentImage", function () { return $10461bbd0abce98a$export$44d7a932d2767a7a; });
$parcel$export(module.exports, "getStaggeredDoubleFeautureSecondImage", function () { return $10461bbd0abce98a$export$2d0f6370ca103766; });
$parcel$export(module.exports, "getStaggeredDoubleFeautureFirstImage", function () { return $10461bbd0abce98a$export$78335ebe3bbd9065; });
$parcel$export(module.exports, "getAiVideo", function () { return $10461bbd0abce98a$export$944f00714b8c3d98; });
$parcel$export(module.exports, "getAiImage", function () { return $10461bbd0abce98a$export$2e497ec5a3f0e9f7; });
$parcel$export(module.exports, "getAiVideoJSM", function () { return $10461bbd0abce98a$export$e88a1961b910936; });
$parcel$export(module.exports, "getAiImageJSM", function () { return $10461bbd0abce98a$export$be405a6adaf81ee7; });
/* eslint-disable @typescript-eslint/no-non-null-assertion */ const $10461bbd0abce98a$var$aiVideoJSMProductTourMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/ov2b53oh3ly6rgucw1do7w4xoni4d6qh.mp4"
};
const $10461bbd0abce98a$var$aiImageJSMProductTourMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/3cd8m6q81i47wxm8nt733jv5h885h064.webp"
};
const $10461bbd0abce98a$var$aiVideoMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/c57sisavif7febh3gsegy4vp55lm66v1.mp4"
};
const $10461bbd0abce98a$var$aiImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/3mo3s2f6q0xfbg75wj1fqyjayo6ta246.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/l3mu66v75b212vhbp3v18217neb26r30.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/25qwhvk4ue212kn22s30d38la4p58d81.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/4hhj8m4kmqh5es882153t0um1s327867.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/d5t1854qx65olc52p81k78p5336547sl.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/8mj2v25vh521026wl1f7wv3a7ts63cb0.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/avkee2xvjgp258dmf71tt5u060cr0bj4.webp"
};
const $10461bbd0abce98a$var$staggaredDoubleFeautureFirstImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/ex8536t33720160jkps31diiavoq7wa6.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/t67x4j1qeis0c6330we56e5op7j58040.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/4863jx76lcis60cobj438qq2f76r6110.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/q5q45b8nf7dwl071122e311n0x2c8i6o.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/qd37iok4pb43q380hyxv8ran8iegwopd.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/qyc8q4674b85g13bsliagfc2sv2nt1l7.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/8c4y5koi0roj2a5gl14ya60101g867dp.webp"
};
const $10461bbd0abce98a$var$staggaredDoubleFeautureSecondImageMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-staggered-double-feature-2.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/ye325r1c82vwe80p17v707876sor0v57.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/kc48608o743ijn83hfsc7248o0855n33.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/r0138653i47tn4bd3ms25o67277wb4en.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/25a73j3b325y5433sgkc4056k8u2bgs2.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/qyc8q4674b85g13bsliagfc2sv2nt1l7.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/rulhdo87w10h368w5k071a7544kfdi34.webp"
};
const $10461bbd0abce98a$var$heroCardSoftwareDevelopmentImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/ue25kj6kn4wq0wn1qg02q56fyop66rj8.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/t1p200v6f4ug14ngayoyim42cy1618bc.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/684fjfuywyexc1a23u572wcj05fi84y0.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/m51m5bb51aj4548p81jssu7w660ro0f8.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/l01f0tas2w10qap5g6u81tcq516vg37x.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/smh5n4ctme1r523d1g3uf7lm60130o04.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/0j22k38v760owv56755oje0p37yeo711.webp"
};
const $10461bbd0abce98a$var$heroCardMarketingImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/m5hssc3g11uo84qx614br11443b744l3.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/63wxf44y8ut01ncxb0vo3g1762p76oe7.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/5u4x162411psnh2s22l4le4184aj4al3.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/30rrl683rurgws20103f520tec8a0b4r.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/q5gymh0604qp2b2vy2fiwymo6bcj5x47.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/6hq32u063ywsjill83o7v2a283g6jtq3.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/p3hnqjlr54wg1w56adkc254mb756ye22.webp"
};
const $10461bbd0abce98a$var$heroCardItImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/b00tc08w5880bt2xx078p24e142u0561.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/01oj3p2mmd1srk878al477q26840m1yv.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/fj108jc842621v46n6djd408300vcfod.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/vvuv40v0ibe0c2jh7xqdy3le0ev673np.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/tg55er46478ged8wg75q0muh70l03xp4.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/w2vr012658o07r84oikfd3vmw1728e31.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/sqst050suh056l837i652ato1382b4p0.webp"
};
const $10461bbd0abce98a$var$heroCardDesignImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/n831bpy2hv077jl7q3uvymb57bx0js6d.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/t7m1271fl2r40704e4u5i1r07b28bv3a.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/3v68u503i5xkawuuf45g6uq85syu7h05.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/686564sowva47fegxg4y73oi8o6d77s6.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/rvj516a70mqo3hu0lgv2si7h0w08015i.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/l0u14221yq50dk1khv04lunbo6k271fd.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/66sjkv3q65r33272rgr0y35m72726ekc.webp"
};
const $10461bbd0abce98a$var$heroCardOperationsImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/6w08m6f83182557c4n2gdqd5lc8bxgux.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/7t8ueumf388d67yap32075jv4n0w83lq.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/360yo8kpm3rl16l3d714vx8puhjs3a8x.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/p6ioacvwp466w8lh28582w86io78kv75.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/2hx5h0y3380nx822w58k37ou7lt382a0.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/b75eb832avo555l01i0tf77yfr23ai80.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/2y560886wr2048l0r4hxs6w5ym64doj7.webp"
};
const $10461bbd0abce98a$var$collaborateFirstImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/1u8phig8g50c70bnq25c6x5htq6b253w.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/25udrh4pt816l1xn2s76v5fbk866h103.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/71x7642o01xexq1j3j36318p8hp3l4a7.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/6g6278kp6hdn68of821401s82qbd3dc8.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/df3a577s74j71s4q86w3fw2xh7r0kpxv.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/khf18qf74wmj0l07o8wh834t2h473ofn.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/26i42bqsjw1p6528lnf58602d7sjyksj.webp"
};
const $10461bbd0abce98a$var$collaborateSecondImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/30ref08c2xjhdi3bypsd4l534o6343k6.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/u53361562rpcil174kh548pmj47wk23r.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/3it6mj67uqnn1kqqec0fili26xy1ad5a.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/h78h53re850ksk5b2u6mi3840u213jr7.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/cuikrei76g1lf48du36620j33lfkbaav.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/orake1uc43tel34v10d2lgp47pnkv65h.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/yykayg74usu65600v256n3sqnv6x6yov.webp"
};
const $10461bbd0abce98a$var$collaborateThirdImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/2tqg4ls4336u276d4f6y7rennjd1t742.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/866dvbo07ft271755xa204dm1p4ej1sa.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/vai65atabw3lwv7w0abi8w748gf3725m.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/c3b3d36p064m286t2w140a75imlk0b76.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/s8038n5n37vkf1w3c75iy7y1o7871a43.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/hi58ex76esr013c8kr8xys2p036873w2.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/5r0r46q12refy5k44k760k6g3tyiy7l0.webp"
};
const $10461bbd0abce98a$var$collaborateFourthImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/j7ib7le01l6x411v5h42l87m64l0f611.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/m88b68g3r0vsqpmoe60kf2sps5717w22.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/6wox43k7ynt50p8w10bx6yj464ohbi68.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/01076d8sr5n4102kr7mgk302120o1421.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/pxrvm8q420v080r6nk43l87l6j1jr5j7.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/34301480xcnvb0qv17v074o405q67r30.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/o80f05nbv41b7i2ug006675p00r6027r.webp"
};
const $10461bbd0abce98a$var$doubleFeatureFirstImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/754lk6c6s3xkb50hyimkf4aujig8h7e8.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/85025n6sg53gb1o54gw52sa0a8l5252y.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/kp1g7ob05s14rv38xrl478bak8j1enwc.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/6c3xt34m70oh8712kl7p3225la77fb25.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/e717x180w2841fge4313e207b27f0jlp.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/52w7e23sbeuy32p6y3n06w7e2082yhxu.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/v74q0j753uk82d464054gqr5u568dw5w.webp"
};
const $10461bbd0abce98a$var$doubleFeatureSecondImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/m8lju6a7edoja1ey3g865yj77rgt2n6j.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/iddw2873d71vdyu0wrmasn218jn87a7f.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/3e6ib72c51x05342cv48k07a0wo1jx7v.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/x64it50wnwrpqm50wye4140q63lm47y7.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/63apc7jibfy0ms6ntjv1486rcen53oc4.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/3761m3b1ktjte0puv5f23r67n0be6rg5.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/837mvx5jali362e7a7504m853u81l73w.webp"
};
const $10461bbd0abce98a$var$productSoftwareDevelopmentModalImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/41y0vfa38q60m5384dg7sa765mf4ro28.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/pr2e520p47gw100v5eep6831u755nm23.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/m5070g810735714b11i5081065621m4s.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/46du0bd600v7yneguim2p18s2bmx38vt.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/365d4k835x4xj45a5wf6r7u3i865283g.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/6smuygao6ka5l72ud1e80j6cw33a5107.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/0k440p3esv0l6u5c6dvgv2660166u7m4.webp"
};
const $10461bbd0abce98a$var$productMarketingModalImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/i58e36nty6p6km3a64v20ow565ecq126.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/hxx6isxs3m277360y8iub0e65pn6so78.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/j21lvt288m01q3m7g6f0l3d1bhjmdb24.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/7u5oc32sv0yh6q1vdh2u60jnq8dwy2vk.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/61nt5bt5l4sebtma1l3a7e6w400dae0g.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/ibp320cjl61b0rd8873ra2o332j266j4.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/wkx7n8q12fn88166l3y207e5f53xd646.webp"
};
const $10461bbd0abce98a$var$productItModalImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/75ous6w840rg1doie0203543yt22qnpa.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/r52381x63k34ljy2v248746pixvx76e5.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/d7q26epsti24r540gfcd4c5c1173cmc8.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/330645peuxhlid3577lr71073dm5ieyl.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/xpyktqf5jil6xah1xd7u54g8f08vi74j.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/7a7kgk12347go142kr1euulv6058uak6.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/p70x4xyevviso1is348gj5yuci5735pk.webp"
};
const $10461bbd0abce98a$var$updatedProductItModalImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/whjwswo26s750yn06387a0s80ehy3e52.webp"
};
const $10461bbd0abce98a$var$productDesignModalImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/b2x4amce3w8mn2b213mtx3r31n44403q.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/44u783fxt66o02mxf5lr7kbw1xty380i.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/08smrtsr040biq47toh66t6us66q1o00.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/7y78rlqj681mf1jlh7o65l525s6m7eya.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/1a3lwr5vav0fd2a3yp4ouw244u1d1u36.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/57dmhof07485d05q2cdubfx65vxs85ah.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/u11mi1pyr7ncq1ur1b2x20y0774185ru.webp"
};
const $10461bbd0abce98a$var$productOperationsModalImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/rf4b8d0jn3u85g7rn8uf8481a1n1t8l5.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/q4hr0hm0ooqt42r0156010yevq5v3646.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/m5p21md0n60ec14qju78yfq7517sase0.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/n1w6347fgj1icy62w6gmak63ty1i66rq.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/7v5df3xyd24e02x68l71pi0vrpsi1h86.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/v1e777xn7wd21g22ytpg5t44d055li82.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/0eo1cu114id26b7ed48g46igo4j11pma.webp"
};
const $10461bbd0abce98a$export$6954fe49bbdabc54 = (locale)=>{
    return $10461bbd0abce98a$var$productSoftwareDevelopmentModalImageMap[locale] || $10461bbd0abce98a$var$productSoftwareDevelopmentModalImageMap["en"];
};
const $10461bbd0abce98a$export$cc19a82b226e3f08 = (locale)=>{
    return $10461bbd0abce98a$var$productMarketingModalImageMap[locale] || $10461bbd0abce98a$var$productMarketingModalImageMap["en"];
};
const $10461bbd0abce98a$export$fa7e84d2d2c567a7 = (locale)=>{
    return $10461bbd0abce98a$var$productItModalImageMap[locale] || $10461bbd0abce98a$var$productItModalImageMap["en"];
};
const $10461bbd0abce98a$export$f31d1f714b55f0fb = (locale)=>{
    return $10461bbd0abce98a$var$updatedProductItModalImageMap[locale] || $10461bbd0abce98a$var$updatedProductItModalImageMap["en"];
};
const $10461bbd0abce98a$export$e0ab49165f0180f7 = (locale)=>{
    return $10461bbd0abce98a$var$productDesignModalImageMap[locale] || $10461bbd0abce98a$var$productDesignModalImageMap["en"];
};
const $10461bbd0abce98a$export$51a8246da0eeafec = (locale)=>{
    return $10461bbd0abce98a$var$productOperationsModalImageMap[locale] || $10461bbd0abce98a$var$productOperationsModalImageMap["en"];
};
const $10461bbd0abce98a$export$af7f348492750745 = (locale)=>{
    return $10461bbd0abce98a$var$doubleFeatureFirstImageMap[locale] || $10461bbd0abce98a$var$doubleFeatureFirstImageMap["en"];
};
const $10461bbd0abce98a$export$51c1e8c9994962ad = (locale)=>{
    return $10461bbd0abce98a$var$doubleFeatureSecondImageMap[locale] || $10461bbd0abce98a$var$doubleFeatureSecondImageMap["en"];
};
const $10461bbd0abce98a$export$7a98b35c48983fe6 = (locale)=>{
    return $10461bbd0abce98a$var$collaborateFirstImageMap[locale] || $10461bbd0abce98a$var$collaborateFirstImageMap["en"];
};
const $10461bbd0abce98a$export$3ff8286854e1bb40 = (locale)=>{
    return $10461bbd0abce98a$var$collaborateSecondImageMap[locale] || $10461bbd0abce98a$var$collaborateSecondImageMap["en"];
};
const $10461bbd0abce98a$export$54ce02c1025509fa = (locale)=>{
    return $10461bbd0abce98a$var$collaborateThirdImageMap[locale] || $10461bbd0abce98a$var$collaborateThirdImageMap["en"];
};
const $10461bbd0abce98a$export$ea3cb1bf26550cc6 = (locale)=>{
    return $10461bbd0abce98a$var$collaborateFourthImageMap[locale] || $10461bbd0abce98a$var$collaborateFourthImageMap["en"];
};
const $10461bbd0abce98a$export$a27f10b8f2dbe6ec = (locale)=>{
    return $10461bbd0abce98a$var$heroCardOperationsImageMap[locale] || $10461bbd0abce98a$var$heroCardOperationsImageMap["en"];
};
const $10461bbd0abce98a$export$d2a58a00fc2c43 = (locale)=>{
    return $10461bbd0abce98a$var$heroCardDesignImageMap[locale] || $10461bbd0abce98a$var$heroCardDesignImageMap["en"];
};
const $10461bbd0abce98a$export$e7e5a083e5974d8d = (locale)=>{
    return $10461bbd0abce98a$var$heroCardItImageMap[locale] || $10461bbd0abce98a$var$heroCardItImageMap["en"];
};
const $10461bbd0abce98a$export$bf236abab7f9a91d = (locale)=>{
    return $10461bbd0abce98a$var$heroCardMarketingImageMap[locale] || $10461bbd0abce98a$var$heroCardMarketingImageMap["en"];
};
const $10461bbd0abce98a$export$44d7a932d2767a7a = (locale)=>{
    return $10461bbd0abce98a$var$heroCardSoftwareDevelopmentImageMap[locale] || $10461bbd0abce98a$var$heroCardSoftwareDevelopmentImageMap["en"];
};
const $10461bbd0abce98a$export$2d0f6370ca103766 = (locale)=>{
    return $10461bbd0abce98a$var$staggaredDoubleFeautureSecondImageMap[locale] || $10461bbd0abce98a$var$staggaredDoubleFeautureSecondImageMap["en"];
};
const $10461bbd0abce98a$export$78335ebe3bbd9065 = (locale)=>{
    return $10461bbd0abce98a$var$staggaredDoubleFeautureFirstImageMap[locale] || $10461bbd0abce98a$var$staggaredDoubleFeautureFirstImageMap["en"];
};
const $10461bbd0abce98a$export$944f00714b8c3d98 = (locale)=>{
    return $10461bbd0abce98a$var$aiVideoMap[locale] || $10461bbd0abce98a$var$aiVideoMap["en"];
};
const $10461bbd0abce98a$export$2e497ec5a3f0e9f7 = (locale)=>{
    return $10461bbd0abce98a$var$aiImageMap[locale] || $10461bbd0abce98a$var$aiImageMap["en"];
};
const $10461bbd0abce98a$export$e88a1961b910936 = (locale)=>{
    return $10461bbd0abce98a$var$aiVideoJSMProductTourMap[locale] || $10461bbd0abce98a$var$aiVideoJSMProductTourMap["en"];
};
const $10461bbd0abce98a$export$be405a6adaf81ee7 = (locale)=>{
    return $10461bbd0abce98a$var$aiImageJSMProductTourMap[locale] || $10461bbd0abce98a$var$aiImageJSMProductTourMap["en"];
};

});


parcelRegister("5GuYI", function(module, exports) {
$parcel$export(module.exports, "Intelligence", function () { return (parcelRequire("6qcUm")).Intelligence; });
parcelRequire("6qcUm");

});
parcelRegister("6qcUm", function(module, exports) {

$parcel$export(module.exports, "Intelligence", function () { return $4a8565725743744b$export$f080dd2dfaa7a195; });

var $loA2J = parcelRequire("loA2J");
const $4a8565725743744b$export$f080dd2dfaa7a195 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
            width: "48",
            height: "48",
            viewBox: "0 0 48 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                    id: "Group 626186",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            id: "Vector (Stroke)",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M37.3027 23.8756C37.3027 22.4546 38.4547 21.3027 39.8757 21.3027H44.5842C46.0052 21.3027 47.1572 22.4546 47.1572 23.8756C47.1572 25.2967 46.0052 26.4486 44.5842 26.4486H39.8757C38.4547 26.4486 37.3027 25.2967 37.3027 23.8756Z",
                            fill: "url(#paint0_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            id: "Vector (Stroke)_2",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M24.0007 0.718933C25.4217 0.718933 26.5737 1.87089 26.5737 3.2919V8.00043C26.5737 9.42144 25.4217 10.5734 24.0007 10.5734C22.5797 10.5734 21.4277 9.42144 21.4277 8.00043V3.2919C21.4277 1.87089 22.5797 0.718933 24.0007 0.718933Z",
                            fill: "url(#paint1_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            id: "Vector (Stroke)_3",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0.84375 23.8756C0.84375 22.4546 1.99571 21.3027 3.41672 21.3027H8.12525C9.54626 21.3027 10.6982 22.4546 10.6982 23.8756C10.6982 25.2967 9.54626 26.4486 8.12525 26.4486H3.41672C1.99571 26.4486 0.84375 25.2967 0.84375 23.8756Z",
                            fill: "url(#paint2_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            id: "Vector (Stroke)_4",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M24.0007 37.1779C25.4217 37.1779 26.5737 38.3298 26.5737 39.7508V44.4594C26.5737 45.8804 25.4217 47.0323 24.0007 47.0323C22.5797 47.0323 21.4277 45.8804 21.4277 44.4594V39.7508C21.4277 38.3298 22.5797 37.1779 24.0007 37.1779Z",
                            fill: "url(#paint3_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            id: "Vector (Stroke)_5",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M29.9001 29.7752C30.9049 28.7703 32.534 28.7703 33.5388 29.7752L43.8307 40.067C44.8355 41.0718 44.8355 42.7009 43.8307 43.7058C42.8259 44.7106 41.1968 44.7106 40.192 43.7058L29.9001 33.4139C28.8953 32.4091 28.8953 30.78 29.9001 29.7752Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            id: "Vector (Stroke)_6",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M43.8307 4.04548C44.8355 5.05028 44.8355 6.6794 43.8307 7.6842L33.5388 17.9761C32.534 18.9809 30.9049 18.9809 29.9001 17.9761C28.8953 16.9713 28.8953 15.3422 29.9001 14.3373L40.192 4.04548C41.1968 3.04067 42.8259 3.04067 43.8307 4.04548Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            id: "Vector (Stroke)_7",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M4.16962 4.04548C5.17443 3.04067 6.80354 3.04067 7.80835 4.04548L18.1002 14.3373C19.105 15.3422 19.105 16.9713 18.1002 17.9761C17.0954 18.9809 15.4663 18.9809 14.4615 17.9761L4.16962 7.6842C3.16481 6.6794 3.16481 5.05028 4.16962 4.04548Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            id: "Vector (Stroke)_8",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M18.1002 29.7752C19.105 30.78 19.105 32.4091 18.1002 33.4139L7.80835 43.7058C6.80354 44.7106 5.17443 44.7106 4.16962 43.7058C3.16481 42.7009 3.16481 41.0718 4.16962 40.067L14.4615 29.7752C15.4663 28.7703 17.0954 28.7703 18.1002 29.7752Z",
                            fill: "white"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                            id: "paint0_linear_2487_5195",
                            x1: "47.1571",
                            y1: "23.8756",
                            x2: "38.1517",
                            y2: "23.8756",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    offset: "0.270833",
                                    stopColor: "#9BC6FF"
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "white"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                            id: "paint1_linear_2487_5195",
                            x1: "25.2872",
                            y1: "0.718933",
                            x2: "25.2872",
                            y2: "9.72432",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    offset: "0.1875",
                                    stopColor: "#9BC6FF"
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "white"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                            id: "paint2_linear_2487_5195",
                            x1: "10.6981",
                            y1: "23.8756",
                            x2: "1.69272",
                            y2: "23.8756",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    stopColor: "white"
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    offset: "0.791667",
                                    stopColor: "#2684FF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                            id: "paint3_linear_2487_5195",
                            x1: "25.2872",
                            y1: "36.7404",
                            x2: "25.2872",
                            y2: "47.0323",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    stopColor: "white"
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    offset: "0.802083",
                                    stopColor: "#A6CCFE"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});



parcelRegister("6MUoN", function(module, exports) {

$parcel$export(module.exports, "FeaturedImages", function () { return $f00a6d5a352a5caf$export$946cd9d3a173e972; });
$parcel$export(module.exports, "FeaturedInfoSection", function () { return $f00a6d5a352a5caf$export$2e0f2d2dcf045a0b; });
$parcel$export(module.exports, "PLAN", function () { return (parcelRequire("jfEgq")).PLAN; });
$parcel$export(module.exports, "TRACK", function () { return (parcelRequire("jfEgq")).TRACK; });
$parcel$export(module.exports, "LAUNCH", function () { return (parcelRequire("jfEgq")).LAUNCH; });
$parcel$export(module.exports, "REPORT", function () { return (parcelRequire("jfEgq")).REPORT; });
/* featured-info.tsx generated by @compiled/babel-plugin v0.28.8 */ // eslint-disable no-non-orangelogic-images-eslint

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $jfEgq = parcelRequire("jfEgq");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $f00a6d5a352a5caf$var$featuresSectionStyles = null;
const $f00a6d5a352a5caf$var$featuresGridStyles = null;
const $f00a6d5a352a5caf$export$946cd9d3a173e972 = {
    collaborateAutomateWorkflows: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/collaborate-automate-workflows.webp",
    collaborateShareKeyResources: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/collaborate-share-key-resources.webp",
    collaborateStreamlineRequests: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/jswf-collaborate-streamline-requests-2.webp",
    planAlignWorkToGoals: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/plan-align-work-to-goals.webp",
    planGetTheBigPicture: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/plan-get-the-big-picture.webp",
    planJumpstartWithExpertTemplates: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/plan-jumpstart-with-expert-templates.webp",
    planPlanAndAssignWork: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/plan-plan-and-assign-work.webp",
    reportLearnAsYouDeliver: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/report-learn-as-you-deliver-2.webp",
    reportShareRealTimeUpdates: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/report-share-real-time-updates.webp",
    reportTrackYourProgressToGoals: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/report-track-your-progress-to-goals-2.webp",
    reportUnderstandTeamPerformance: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/report-understand-team-performance-2.webp",
    trackManageDependencies: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/track-manage-dependencies.webp",
    trackMonitorProgress: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/track-monitor-progress.webp",
    trackRemoveManualWork: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/track-remove-manual-work.webp",
    trackTrackWorkWhereYouWork: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/track-track-work-where-you-work.webp",
    streamlineRequests: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/streamline-requests.webp",
    shareKeyResources: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/share-key-resources.webp"
};
const $f00a6d5a352a5caf$export$2e0f2d2dcf045a0b = ({ variant: variant, eyebrow: eyebrow, header: header, description: description, children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_11q71rga _ca0qckbl _u5f3idpf _n3tdckbl _19bvidpf"
        ]),
        style: {
            "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.TypographyStyles), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $jfEgq.FeaturedInfoHeader), {
                    variant: variant,
                    eyebrow: eyebrow,
                    header: header,
                    description: description
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c11p5 _kqswh2mm _yv0ehkll _zulpzwfg _19pkidpf _2hwxzwfg _otyridpf _18u0zwfg _b8yq1nx3 _15flidpf _1d2w1wug _1svyidpf _seov1wug _1j8bfsjm _f2s5g31l"
                    ]),
                    children: children
                })
            ]
        })
    });
};

});
parcelRegister("jfEgq", function(module, exports) {

$parcel$export(module.exports, "PLAN", function () { return $d77e5b7fb8590a92$export$c303e491e026ebc6; });
$parcel$export(module.exports, "TRACK", function () { return $d77e5b7fb8590a92$export$23a21f8efe49e17f; });
$parcel$export(module.exports, "LAUNCH", function () { return $d77e5b7fb8590a92$export$609f530f49033bf7; });
$parcel$export(module.exports, "REPORT", function () { return $d77e5b7fb8590a92$export$e3d31417f21c1ce7; });
$parcel$export(module.exports, "FeaturedInfoHeader", function () { return $d77e5b7fb8590a92$export$4bbaf432f1794430; });
/* featured-info-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");
const $d77e5b7fb8590a92$export$c303e491e026ebc6 = "plan";
const $d77e5b7fb8590a92$export$23a21f8efe49e17f = "track";
const $d77e5b7fb8590a92$export$609f530f49033bf7 = "launch";
const $d77e5b7fb8590a92$export$e3d31417f21c1ce7 = "report";
const $d77e5b7fb8590a92$var$containerStyles = null;
const $d77e5b7fb8590a92$var$planVariantStyles = null;
const $d77e5b7fb8590a92$var$trackVariantStyles = null;
const $d77e5b7fb8590a92$var$launchVariantStyles = null;
const $d77e5b7fb8590a92$var$reportVariantStyles = null;
const $d77e5b7fb8590a92$var$headerStyles = null;
const $d77e5b7fb8590a92$var$eyebrowStyles = null;
const $d77e5b7fb8590a92$var$PlanEyelash = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "46",
        height: "26",
        viewBox: "0 0 46 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M27.8179 8.5621L28.9492 7.54226C28.9492 7.54226 29.1999 6.94045 28.9993 6.53364C28.8767 6.28288 28.6873 6.03769 28.4811 5.84822C28.0631 5.46928 27.5672 5.34664 27.3498 5.94291C27.322 5.92619 27.2774 5.92622 27.2384 5.89835C27.1604 6.65623 26.2241 6.69528 25.8842 7.25812C26.018 7.35285 25.8731 7.28036 25.8731 7.28036C25.9232 7.87663 25.3548 8.2166 25.3548 8.22217C24.6137 9.36457 23.2539 10.6407 22.5908 11.9949L22.6186 12.006L22.641 12.0283C22.8862 12.0506 22.5295 12.3849 22.4905 12.2512C21.7047 12.658 20.646 13.8896 20.4899 14.7589C20.6571 14.8703 20.5679 15.0208 20.5233 14.9539C19.9605 14.9149 15.4912 19.7742 17.8819 19.6739L18.0268 19.8411C18.3556 19.5848 20.6292 17.6177 20.6459 17.64C21.1029 17.8796 21.0193 15.7174 21.493 16.6982C23.9951 16.2301 27.0991 10.5125 27.0991 10.5125L27.1715 9.83268C27.1715 9.83268 28.0742 9.27539 27.8123 8.55652L27.8179 8.5621Z",
                fill: (0, $5ohHq.wacToken)("color.neutral.light0")
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M8.85401 4.95098L8.60878 4.31569C8.60878 4.31569 9.15488 3.40732 8.59204 2.88906L9.12706 1.4625C9.12706 1.4625 9.07134 0.810485 8.70912 0.542998C8.48064 0.375818 8.202 0.242056 7.93451 0.175184C7.39396 0.0302949 6.89243 0.14737 6.97045 0.782652C6.93701 0.782652 6.89795 0.799313 6.8478 0.79374C7.12643 1.50147 6.31288 1.96401 6.27387 2.62159C6.43548 2.64388 6.55806 2.69403 6.4689 2.69403L6.26829 2.64948C6.58593 3.15659 5.88373 3.29032 6.49672 3.81972L6.2404 3.71938C6.10666 5.07911 5.4825 6.82894 5.52151 8.33913H5.55498C5.55498 8.33913 5.64414 8.71807 5.55498 8.61776C5.04229 9.34221 4.67449 10.9193 4.92526 11.7607C5.12588 11.783 2.79095 18.5148 4.86397 17.3278L5.07016 17.4114C5.24291 17.0325 5.3822 16.7149 5.87816 16.3861C5.85587 16.3192 5.90047 16.3247 5.68314 16.2802C5.65527 16.2579 5.594 16.2189 5.50484 16.2077C4.98101 16.1074 6.70848 13.0257 6.70848 13.0257C8.71464 11.4598 8.84843 4.95656 8.84843 4.95656L8.85401 4.95098Z",
                fill: (0, $5ohHq.wacToken)("color.neutral.light0")
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M44.1735 17.8016C43.984 17.2722 43.6106 16.9267 43.1314 17.3503C43.1147 17.3224 43.0756 17.3001 43.0534 17.2555C42.6243 17.8852 41.7828 17.4728 41.2199 17.8128C41.2924 17.9577 41.1976 17.8295 41.1976 17.8295C40.958 18.3756 40.3004 18.409 40.3004 18.4146C39.1023 19.0722 37.3024 19.5459 36.082 20.4264L36.0987 20.4486L36.1098 20.4765C36.316 20.6103 35.8423 20.7384 35.8702 20.5991C34.9841 20.5824 33.4684 21.1675 32.9222 21.8529C33.017 22.0313 33.0672 21.5297 33.3792 22.1037C33.2009 22.1873 33.056 22.3545 32.8777 22.4214C32.7105 22.0313 32.8665 22.1204 32.8554 22.0424C32.3761 21.7415 26.1404 23.9037 28.2914 24.9458L28.3415 25.1631C28.7539 25.0907 29.6232 24.9235 29.5842 24.8399C29.3725 24.3551 31.6907 24.4331 31.6963 24.4665L32.8888 24.0374C35.3129 24.8065 40.7574 21.2511 40.7574 21.2511L41.1475 20.6883C41.1475 20.6883 42.2063 20.627 42.3177 19.8691L43.7945 19.5069C43.7945 19.5069 44.3016 19.0945 44.3128 18.6431C44.3239 18.3645 44.2737 18.0579 44.1846 17.796L44.1735 17.8016Z",
                fill: (0, $5ohHq.wacToken)("color.neutral.light0")
            })
        ]
    });
const $d77e5b7fb8590a92$var$TrackEyelash = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "43",
        height: "20",
        viewBox: "0 0 43 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M41.1672 6.20799C29.1522 -1.68807 19.1878 -0.0992864 12.5988 1.16576C9.10339 0.0506007 -6.62876 8.95992 3.16787 6.59171C7.3767 3.10833 21.6519 1.39363 29.518 4.72712C31.8203 2.91049 46.5871 12.3833 41.1612 6.20799H41.1672Z",
                fill: (0, $5ohHq.wacToken)("color.primary.black")
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M34.6504 11.8079C29.9799 7.55705 23.1151 8.00677 20.2852 8.34252C22.5635 6.96356 16.5019 7.59904 15.5187 8.30051C16.478 8.24055 15.9745 8.85811 15.1771 8.92406C14.9252 7.26931 4.39719 11.1483 7.26304 13.1508C8.54008 12.4853 9.17553 13.0789 9.28944 11.7599C9.93096 13.3247 11.244 11.0884 11.6816 10.9145C12.6169 11.2203 12.593 11.598 13.8101 10.6927C15.4408 10.6927 17.773 11.1424 20.513 10.6328C24.3321 10.5069 26.4066 11.688 29.5662 11.9937C30.8972 12.4854 37.5462 15.627 34.6624 11.8199L34.6504 11.8079Z",
                fill: (0, $5ohHq.wacToken)("color.primary.black")
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M28.9065 17.8751C27.0359 16.2983 24.6736 15.369 21.3641 15.5788C22.7551 16.736 21.4541 16.706 20.5668 16.1484C22.3295 14.8773 16.7837 15.1892 18.2106 16.2803C17.8389 16.5441 17.4252 16.3822 17.707 16.0824C15.6385 15.1412 9.31332 19.7457 14.4574 18.7505C14.2176 17.9351 15.1289 19.9256 15.8064 17.977C16.5978 18.5166 16.3459 18.8104 17.0414 18.061C17.7728 18.109 19.2118 19.0083 20.6807 18.4327C22.7731 17.9411 23.5346 19.7757 25.1054 18.7025C26.0407 19.5059 30.5013 20.3512 28.8945 17.8691L28.9065 17.8751Z",
                fill: (0, $5ohHq.wacToken)("color.primary.black")
            })
        ]
    });
const $d77e5b7fb8590a92$var$LaunchEyelash = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "58",
        height: "20",
        viewBox: "0 0 58 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M50.3635 18.9904C50.6395 18.4167 52.3934 17.7903 52.2324 17.1698C52.4164 17.2517 53.1467 16.561 53.0374 15.9171C55.1363 14.4477 58 10.0161 58 10.0161C58 10.0161 56.3036 6.15833 54.13 5.07533C54.0725 5.15729 48.1151 -1.82082 47.7068 1.34037C48.2186 1.5277 48.3221 3.24884 48.8742 2.55806C49.2939 1.75606 50.2887 3.78741 50.6568 3.86937C50.3865 4.7182 51.2548 5.73687 51.8758 5.83053C52.7844 7.10671 54.13 8.3418 54.13 8.3418C54.13 8.3418 47.3963 7.55744 45.1594 8.86289C44.1933 8.29505 25.6081 7.85015 32.6236 9.02096C31.1572 9.98688 25.2516 8.65797 29.1676 8.4004C18.5984 8.14282 13.0263 7.32917 0.979278 10.8123C-2.42494 12.3402 4.08448 12.1236 4.77452 11.5967C4.87803 11.1342 4.90103 10.8474 5.37257 10.9177C5.52208 12.6446 9.75435 10.2855 10.2604 10.3674C17.0631 11.4797 31.4678 10.461 40.2601 11.9128C42.3532 11.7957 51.0305 10.9411 52.5141 10.9411C53.9977 10.9411 53.0202 11.6084 52.0139 12.3695C51.9794 12.3695 51.9736 12.4456 51.8758 12.3812C51.7723 14.3189 50.444 15.8408 48.9087 17.1287C48.0806 17.7844 49.2537 20.694 50.3635 18.9904Z",
            fill: (0, $5ohHq.wacToken)("color.primary.black")
        })
    });
const $d77e5b7fb8590a92$var$ReportEyelash = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "51",
        height: "50",
        viewBox: "0 0 51 50",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M30.3513 23.6639C31.5684 22.8331 35.6575 18.0452 31.7445 19.1689C30.6929 20.0051 25.8724 26.4493 23.2247 29.7726C22.6428 28.4092 20.9719 26.9179 19.7495 26.1617C19.0074 25.4747 18.7085 26.6091 18.7085 26.6091C18.9167 26.9127 19.1356 27.392 19.6427 27.7754C20.2085 28.2015 20.2833 29.0855 21.2121 29.7619C24.4792 32.1319 23.0058 35.6202 26.1661 29.5754C27.2551 26.9232 29.9882 26.0605 30.3459 23.6639H30.3513Z",
                fill: (0, $5ohHq.wacToken)("color.primary.black")
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M50.9995 23.467C51.0262 16.5808 49.8999 5.78014 42.3943 3.2291C47.5991 10.1845 50.754 21.3899 47.8553 30.0123C45.1702 43.6729 24.4417 51.3366 11.9501 43.4225C13.2313 44.6368 16.162 46.0163 17.961 46.5488C13.1886 47.582 2.45871 35.5564 10.0551 42.1018C-11.5009 14.6262 22.6267 -11.651 42.2715 12.0806C36.6983 1.31722 22.2263 -2.3629 13.3114 2.87232C-29.6403 36.808 44.5296 76.9961 50.9942 23.467H50.9995Z",
                fill: (0, $5ohHq.wacToken)("color.primary.black")
            })
        ]
    });
const $d77e5b7fb8590a92$export$4bbaf432f1794430 = ({ variant: variant, eyebrow: eyebrow, header: header, description: description })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _p12f17kt _19pkidpf _2hwx1wug _otyridpf _18u01wug _1reozryt _1b3husvi _1pbyidpf _1kt9b3bt _1cs8stnw _dsq4glyw _1mp417kt _kfgtocp2 _1g0v1mrw _1tes1qqs _7dwzzr6s",
            variant === $d77e5b7fb8590a92$export$c303e491e026ebc6 && "_1ikbcd5j _1loecd5j _iwqycd5j _1rus17la _tgsmh130 _13zg1gqn _1tynglyw _1w7r13g9 _1m1v1827",
            variant === $d77e5b7fb8590a92$export$23a21f8efe49e17f && "_1rusmd2z _1mp41gvu _tgsm1iq9 _1ksz1b5c",
            variant === $d77e5b7fb8590a92$export$609f530f49033bf7 && "_1rusyamf _kfgt8re4 _tgsm14z4 _13zg1gqn _1tynglyw _6my9ocp2 _1cnl1uo2 _1w7r1827",
            variant === $d77e5b7fb8590a92$export$e3d31417f21c1ce7 && "_1rus9f4l _kfgtlwrb _tgsm19fw _13zg1gqn _1tynglyw _1cnl1hc7 _1w7r1uo2 _1m1v13g9"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_p19pmn": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.lime400")),
            "--_l6d3j7": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.yellow200")),
            "--_k62i9u": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.purple400"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx21bp4 _zulpu2gc _19pkidpf _2hwx1wug _otyrzwfg _18u01wug _p12f1nx3 _ca0q4bvh _u5f3idpf _n3tdidpf _19bvidpf _1c58idpf _1fexidpf _1mh0idpf _av1ridpf _c5hwbxu3 _w7wbidpf _1iipidpf _6bnpidpf _cxn3idpf _dn1fbxu3 _178vidpf _obsiidpf _1qcbidpf _fzpmidpf _1rkbkd3c _1kmx4bvh _1ggmidpf _1ykzidpf _1maeidpf"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    className: "h2",
                    children: header
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1f491mrw _1e0c1txw _2lx21bp4 _zulpdlk8"
                    ]),
                    children: [
                        variant === $d77e5b7fb8590a92$export$c303e491e026ebc6 && /*#__PURE__*/ (0, $loA2J.jsx)($d77e5b7fb8590a92$var$PlanEyelash, {}),
                        variant === $d77e5b7fb8590a92$export$23a21f8efe49e17f && /*#__PURE__*/ (0, $loA2J.jsx)($d77e5b7fb8590a92$var$TrackEyelash, {}),
                        variant === $d77e5b7fb8590a92$export$609f530f49033bf7 && /*#__PURE__*/ (0, $loA2J.jsx)($d77e5b7fb8590a92$var$LaunchEyelash, {}),
                        variant === $d77e5b7fb8590a92$export$e3d31417f21c1ce7 && /*#__PURE__*/ (0, $loA2J.jsx)($d77e5b7fb8590a92$var$ReportEyelash, {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                            className: "eyebrow-md",
                            children: eyebrow
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: "body-md",
                    children: description
                })
            ]
        })
    });
};

});


parcelRegister("383oO", function(module, exports) {

$parcel$export(module.exports, "TimelineIcon", function () { return $4d8be46535eee816$export$e5aa73ddcf9d62e8; });
$parcel$export(module.exports, "RedoIcon", function () { return $4d8be46535eee816$export$d275b7689549104e; });
$parcel$export(module.exports, "FastIcon", function () { return $4d8be46535eee816$export$74dd0403ff5f7484; });
$parcel$export(module.exports, "LaunchSection", function () { return $4d8be46535eee816$export$a181f92ca97e792; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $dTlTl = parcelRequire("dTlTl");

var $hrScA = parcelRequire("hrScA");

var $fvAxO = parcelRequire("fvAxO");

var $10R19 = parcelRequire("10R19");

var $6MUoN = parcelRequire("6MUoN");
var $jfEgq = parcelRequire("jfEgq");
const $4d8be46535eee816$export$e5aa73ddcf9d62e8 = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M0 5.26807L16.5 5.26807V1.51807L0 1.51807V5.26807Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M1.5 17.2681L18 17.2681V13.5181L1.5 13.5181L1.5 17.2681Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M24 23.2681L7.5 23.2681V19.5181L24 19.5181V23.2681Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M6 11.2681L22.5 11.2681V7.51806L6 7.51807V11.2681Z",
                fill: "#1868DB"
            })
        ]
    });
const $4d8be46535eee816$export$d275b7689549104e = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M2.87302 12.5736C2.87302 8.60683 6.08876 5.39109 10.0556 5.39109C14.0224 5.39109 17.2381 8.60683 17.2381 12.5736V13.415L15.3809 11.5578L13.3494 13.5893L18.6747 18.9146L24 13.5893L21.9685 11.5578L20.1111 13.4151V12.5736C20.1111 7.0201 15.6091 2.51807 10.0556 2.51807C4.50203 2.51807 0 7.0201 0 12.5736C0 18.1272 4.50203 22.6292 10.0556 22.6292V19.7562C6.08876 19.7562 2.87302 16.5405 2.87302 12.5736Z",
            fill: "#1868DB"
        })
    });
const $4d8be46535eee816$export$74dd0403ff5f7484 = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M0 15.1847L10.6667 0.518066V9.8514H17.3333L6.66667 24.5181V15.1847H0Z",
            fill: "#1868DB"
        })
    });
const $4d8be46535eee816$export$a181f92ca97e792 = ()=>{
    const intl = (0, $f6qj2.default)();
    const showGwp7999JiraFeaturesUpdates = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).gwp7999JiraFeatures);
    const launchSharedReleaseDatesImage = (0, $10R19.useLocalizedImage)("launchSharedReleaseDatesImage");
    const launchYourFavoriteAppImage = (0, $10R19.useLocalizedImage)("launchYourFavoriteAppImage");
    const launchWorkflowsAutomationImage = (0, $10R19.useLocalizedImage)("launchWorkflowsAutomationImage");
    if (showGwp7999JiraFeaturesUpdates) return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $6MUoN.FeaturedInfoSection), {
        variant: (0, $jfEgq.LAUNCH),
        eyebrow: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Eyebrow",
            defaultMessage: "Collaborate"
        }),
        header: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Header",
            defaultMessage: "Get every team on the same page"
        }),
        description: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Description",
            defaultMessage: "Jira brings teams, tools, and AI together to keep the entire org in sync and deliver impact faster."
        }),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: (0, $6MUoN.FeaturedImages).collaborateStreamlineRequests,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.StreamlineRequests.Alt",
                            defaultMessage: "Forms in Jira"
                        })
                    }
                },
                Icon: $4d8be46535eee816$export$e5aa73ddcf9d62e8,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.StreamlineRequests.Header",
                    defaultMessage: "Streamline Requests"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.StreamlineRequests.Description",
                    defaultMessage: "Make it easy for partner teams to submit requests and track progress with forms."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: (0, $6MUoN.FeaturedImages).collaborateShareKeyResources,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.ShareResources.Alt",
                            defaultMessage: "Release management in Jira"
                        })
                    }
                },
                Icon: $4d8be46535eee816$export$d275b7689549104e,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.ShareResources.Header",
                    defaultMessage: "Share key resources"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.ShareResources.Description",
                    defaultMessage: "Keep everyone aligned by sharing key resources like content calendars or release announcements."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: (0, $6MUoN.FeaturedImages).collaborateAutomateWorkflows,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.AutomateWorkflows.Alt",
                            defaultMessage: "Manage workflows in Jira"
                        })
                    }
                },
                Icon: $4d8be46535eee816$export$74dd0403ff5f7484,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.AutomateWorkflows.Header",
                    defaultMessage: "Automate workflows"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.AutomateWorkflows.Description",
                    defaultMessage: "Scale processes and save time with customizable workflows that integrate with your tech stack."
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $6MUoN.FeaturedInfoSection), {
        variant: (0, $jfEgq.LAUNCH),
        eyebrow: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Eyebrow",
            defaultMessage: "Collaborate and launch"
        }),
        header: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Header",
            defaultMessage: "Connect, collaborate, celebrate"
        }),
        description: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Description",
            defaultMessage: "Jira better connects teams and work for more seamless collaboration and faster alignment."
        }),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: launchSharedReleaseDatesImage,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.ReleaseDates.ImageAlt",
                            defaultMessage: "Shared release date module in Jira"
                        })
                    }
                },
                Icon: $4d8be46535eee816$export$e5aa73ddcf9d62e8,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.ReleaseDates.Header",
                    defaultMessage: "Shared release dates"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.ReleaseDates.Description",
                    defaultMessage: "The only place where teams who make your product are connected to teams who launch it. When dates change, every team is in the know."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: launchYourFavoriteAppImage,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.SlackFigma.ImageAlt",
                            defaultMessage: "Slack and Jira integration"
                        })
                    }
                },
                Icon: $4d8be46535eee816$export$d275b7689549104e,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.SlackFigma.Header",
                    defaultMessage: "Slack, Figma, {openBracket}your favorite app{closeBracket} "
                }, {
                    openBracket: "<",
                    closeBracket: ">"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.SlackFigma.Description",
                    defaultMessage: "Bring in real-time data and information from popular 3rd party apps like Slack, Figma, and GitHub, so Jira becomes your team\u2019s trusted source for information."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: launchWorkflowsAutomationImage,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.WorkflowAutomation.ImageAlt",
                            defaultMessage: "Workflow trigger setup screen in Jira"
                        })
                    }
                },
                Icon: $4d8be46535eee816$export$74dd0403ff5f7484,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.WorkflowsAutomation.Header",
                    defaultMessage: "Workflows and automation"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.WorkflowAutomation.Description",
                    defaultMessage: "Save time and scale your work confidently with no-code automation and workflows, like approvals, that keeps work moving forward when no one is watching."
                })
            })
        ]
    });
};

});
parcelRegister("10R19", function(module, exports) {

$parcel$export(module.exports, "useLocalizedImage", function () { return $71f029b32c897b06$export$351d137f57ab4fe2; });

var $f6qj2 = parcelRequire("f6qj2");
/**
 * Enforces that values in `imageMaps` satisfy the type `ImageMap`
 * while still allowing for the keys in `imageMaps`
 * to be extracted and used as a union type.
 */ const $71f029b32c897b06$var$createImageMaps = (imageMaps)=>imageMaps;
/**
 * A map of image ids to their localized URLs.
 *
 * The keys in the map are the ids that should be passed to `useLocalizedImage`.
 * The values are objects thap map locales to URLs for localized images.
 * Note that the `en` is required!
 */ const $71f029b32c897b06$var$imageMaps = $71f029b32c897b06$var$createImageMaps({
    // Add image ids and their localized URLs here
    heroImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/image-368080789.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero_es-ES-280262892.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero_hu-HU-1564215628.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero_ko-KR-2299841745.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero-nl-NL-29055006.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero_ru-RU-3031695244.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Herofr-FR-34984137.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Heroit-IT-215402249.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Heroptbr-PTBR-2288648393.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero_de-DE-3182006582.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero-1517722948.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero-1037378293.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero-2582835035.webp"
    },
    planLabelImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan-1878220112.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan_es-ES-2320946370.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan_hu-HU-219670370.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan_ko-KR-830423807.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan_nl-NL-2786930498.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan_ru-RU-3701573538.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Planfr-FR-3457271915.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Planit-IT-3195604523.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Planptbr-PTBR-3247145579.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan_de-DE-2971266205.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan-1551581806.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan-2929654303.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan_zh-CN-681007050.webp"
    },
    trackLabelImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track-61709455.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track_es-ES-3383229661.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track_hu-HU-28375869.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track_ko-KR-1956228992.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track_nl-NL-1580836701.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track_ru-RU-1652057597.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Trackfr-FR-545895028.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Trackit-IT-3805011636.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Trackptbr-PTBR-1151313332.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track_de-DE-1856152322.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track-1287427121.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track-2267954944.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track_zh-CN-2298675573.webp"
    },
    collaborateLabelImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab-1370881390.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab_es-ES-3256840060.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab_hu-HU-2907439260.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab_ko-KR-1915737025.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab_nl-NL-3907414524.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab_ru-RU-1681301724.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collabfr-FR-306933269.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collabit-IT-2959014357.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collabptbr-PTBR-1526398485.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab_de-DE-3903230755.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab-559675728.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab-2507891681.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab_zh-CN-3730365236.webp"
    },
    launchLabelImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch-3779179643.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch_es-ES-1284707561.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch_hu-HU-4125799561.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch_ko-KR-804198996.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch_nl-NL-1935282025.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch_ru-RU-3225671625.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launchfr-FR-492072672.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launchit-IT-2893616864.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launchptbr-PTBR-177406496.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch_de-DE-3859546614.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch-236640965.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch-724975156.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch_zh-CN-3721511201.webp"
    },
    reportLabelImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report-161454665.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report_es-ES-585529307.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report_hu-HU-388065915.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report_ko-KR-403646438.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report_nl-NL-1236103771.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report_ru-RU-3382627771.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Reportfr-FR-426962258.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Reportit-IT-2146252498.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Reportptbr-PTBR-1506788626.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report_de-DE-1473304260.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report-1135116023.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report-3347665734.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report_zh-CN-2860637139.webp"
    },
    planListViewImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/plan-list-view-194474286.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_es-ES-2187812077.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_hu-HU-529772653.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ko-KR-912241933.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_nl-NL-3071040621.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ru-RU-1543276909.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001fr-FR-4036874011.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001it-IT-1435305947.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001ptbr-PTBR-1646874907.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_de-DE-3074059530.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001-948026910.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001-4156364335.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_zh-CN-248550045.webp"
    },
    planCalendarImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/plan-calendar-view-3686747294.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_es-ES-4180018574.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_hu-HU-2766112334.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ko-KR-3040982382.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_nl-NL-751132046.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ru-RU-3037425358.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002fr-FR-264278680.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002it-IT-774319384.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002ptbr-PTBR-2340951128.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_de-DE-852905257.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002-528338429.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002-1352144332.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_zh-CN-92973118.webp"
    },
    planSprintsBacklogImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/plan-sprints-backlog-3533034495.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_es-ES-111313327.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_hu-HU-2885932719.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ko-KR-2978588495.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_nl-NL-3774460207.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ru-RU-4230471727.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003fr-FR-726055961.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003it-IT-2656446425.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003ptbr-PTBR-891882521.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_de-DE-3628604488.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003-3756990428.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003-846581101.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_zh-CN-1061927263.webp"
    },
    planTimelineImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/plan-timeline-4119095287.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_es-ES-1062283080.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_hu-HU-3613163400.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_ko-KR-3905143976.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_nl-NL-629198920.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_ru-RU-631159688.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004fr-FR-1420566174.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004it-IT-3283003422.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004ptbr-PTBR-3398383966.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_de-DE-3798227823.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004-2344293819.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004-65640202.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_zh-CN-43781880.webp"
    },
    trackProjectBoardsImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/track-project-boards-1345608737.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_es-ES-2893710705.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_hu-HU-1128889137.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ko-KR-1991995121.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_nl-NL-3117326833.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ru-RU-2679980209.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001fr-FR-775791207.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001it-IT-3559459943.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001ptbr-PTBR-1057291367.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_de-DE-2702397782.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001-2821188546.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001-3940287731.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_zh-CN-2162175841.webp"
    },
    trackTaskManagementImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/track-task-management-158514083.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_es-ES-1304081970.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_hu-HU-3046449970.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ko-KR-4045234866.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_nl-NL-1847663410.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ru-RU-143791666.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002fr-FR-3937704452.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002it-IT-2056260804.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002ptbr-PTBR-1262140356.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_de-DE-2273949461.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002-1980867905.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002-3060959664.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_zh-CN-1124331746.webp"
    },
    trackDependencyManagementImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/track-dependency-management-3383416513.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_es-ES-519446131.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_hu-HU-2597762739.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ko-KR-2710641267.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_nl-NL-948636659.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ru-RU-805907123.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003fr-FR-3862859045.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003it-IT-899278885.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003ptbr-PTBR-561550885.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_de-DE-3571317332.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003-681376448.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003-792789361.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_zh-CN-3400868451.webp"
    },
    trackGoalTrackingImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/track-goal-tracking-2550106487.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_es-ES-3670223412.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_hu-HU-3589060020.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_ko-KR-1965549108.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_nl-NL-1673756468.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_ru-RU-2335341108.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004fr-FR-34424514.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004it-IT-3310367362.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004ptbr-PTBR-2386394754.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_de-DE-2554936851.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004-3474928967.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004-2541054262.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_zh-CN-2539167460.webp"
    },
    launchSharedReleaseDatesImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/launch-shared-release-dates-1278148773.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_es-ES-2825366097.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_hu-HU-17543633.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ko-KR-1641702961.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_nl-NL-3905234641.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ru-RU-1474490321.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001fr-FR-1231209191.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001it-IT-2864685991.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001ptbr-PTBR-1060273383.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_de-DE-336816374.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001-3868783586.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001-1515546771.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_zh-CN-1419555617.webp"
    },
    launchYourFavoriteAppImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/launch-your-favorite-app-2394898694.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_es-ES-3521797326.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_hu-HU-436086830.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ko-KR-3646187539.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_nl-NL-2753210190.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ru-RU-772035182.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002fr-FR-2890898724.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002it-IT-659776164.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002ptbr-PTBR-1851042404.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_de-DE-1088218453.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002-3724103425.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002-22237808.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_zh-CN-1063538050.webp"
    },
    launchWorkflowsAutomationImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/launch-workflows-automation-2356540848.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_es-ES-1136820627.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_hu-HU-1318620819.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ko-KR-4096002803.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_nl-NL-701640211.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ru-RU-1260566547.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003fr-FR-742697573.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003it-IT-555982117.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003ptbr-PTBR-3107713637.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_de-DE-816862644.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003-671006752.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003-3547956049.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_zh-CN-2248394595.webp"
    },
    reportPlanYourWorkImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/report-plan-your-work-3125149458.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_es-ES-632410416.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_hu-HU-3065455472.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ko-KR-1532904656.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_nl-NL-1310062384.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ru-RU-2476318832.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001fr-FR-3982217318.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001it-IT-2788550118.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001ptbr-PTBR-2400170662.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_de-DE-1437448791.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001-428996611.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001-573869554.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_zh-CN-2842346112.webp"
    },
    reportDuringYourProjectImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/report-during-your-project-3187559990.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_es-ES-2948979027.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_hu-HU-3833184595.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ko-KR-3046902707.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_nl-NL-373810899.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ru-RU-937298899.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002fr-FR-2722552485.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002it-IT-1760744037.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002ptbr-PTBR-2857878437.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_de-DE-384230900.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002-1804751584.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002-873723665.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_zh-CN-2609941795.webp"
    },
    reportWhenYouLaunchImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/report-when-you-launch-1999669051.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_es-ES-184654834.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_hu-HU-2168975026.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ko-KR-933027090.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_nl-NL-3642225138.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ru-RU-116775218.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003fr-FR-1939314020.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003it-IT-1748958436.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003ptbr-PTBR-4034521252.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_de-DE-3037516437.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003-4127636161.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003-912760624.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_zh-CN-1622278210.webp"
    },
    reportBringItAllTogetherImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/report-bring-it-all-together-2435824002.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_es-ES-35668245.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_hu-HU-1879148693.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_ko-KR-681638133.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_nl-NL-1789762965.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_ru-RU-2525782933.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004fr-FR-904249251.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004it-IT-1751247971.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004ptbr-PTBR-966252707.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_de-DE-1966850610.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004-92672934.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004-1929635927.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_zh-CN-4274294245.webp"
    },
    artificialIntelligenceImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/artificial-intelligence-2046937004.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Image%20AI001_es-ES%201_es-ES-989623482.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_hu-HU-3851804662.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ko-KO-813949256.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_nl-NL-1612463222.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/AI_Smart%20summary_JSW%201_ru-RU-2161971397.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001fr-FR-1823876768.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_it-IT-2008232250.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001ptbr-PTBR-3467326432.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_de-DE-1473393171.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001-440488517.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001-928822708.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001-2477633690.webp"
    }
});
function $71f029b32c897b06$export$351d137f57ab4fe2(id) {
    const intl = (0, $f6qj2.default)();
    const imageMap = $71f029b32c897b06$var$imageMaps[id];
    var _imageMap_intl_locale;
    return (_imageMap_intl_locale = imageMap[intl.locale]) !== null && _imageMap_intl_locale !== void 0 ? _imageMap_intl_locale : imageMap.en;
}

});



parcelRegister("fz6gY", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePageBannerAlert", function () { return $981fae5954049203$export$5f2661a957aa01ba; });

var $loA2J = parcelRequire("loA2J");

var $auB13 = parcelRequire("auB13");
const $981fae5954049203$export$5f2661a957aa01ba = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $auB13.GWP8238AcquisitionBanner), {
        productKey: "jiraSoftware",
        identifier: "JiraSoftwarePageTemplate.banner.gwp-8238-announcement",
        ufoSegmentName: "jira-software-bannerAlert-gwp8238",
        testId: "gwp-8238-announcement-jira",
        linkTextId: "JiraSoftwarePage.banner-alert.gwp-8238-announcement.link-text",
        linkTextDefault: "Learn more"
    });
};

});
parcelRegister("auB13", function(module, exports) {

$parcel$export(module.exports, "GWP8238AcquisitionBanner", function () { return $29a6ad693cea50fd$export$21516a4ccbdd4e52; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $3FBn4 = parcelRequire("3FBn4");

var $gAJUc = parcelRequire("gAJUc");

var $47768 = parcelRequire("47768");
const $29a6ad693cea50fd$var$AcquisitionAnnouncementDetail = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "BannerAlert.gwp-8238-announcement.event-details",
        defaultMessage: "<strong>Breaking news:</strong> DX to join Atlassian!",
        values: (0, $3FBn4.DEFAULT_VALUES)
    });
const $29a6ad693cea50fd$export$21516a4ccbdd4e52 = ({ productKey: productKey, identifier: identifier, ufoSegmentName: ufoSegmentName, testId: testId, linkTextId: linkTextId = "BannerAlert.gwp-8238-announcement.link-text", linkTextDefault: linkTextDefault = "Learn more" })=>{
    const intl = (0, $f6qj2.default)();
    if (!(0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp8238BannerAnnouncement)) return null;
    const linkText = intl.formatMessage({
        id: linkTextId,
        defaultMessage: linkTextDefault
    });
    const acquisitionAnnouncementConfig = {
        imageProps: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/v8lbu3715h6ef46x68cmh3tl207d4l74.svg",
            alt: "DX",
            width: 50
        },
        imageMobileProps: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/v8lbu3715h6ef46x68cmh3tl207d4l74.svg",
            alt: "DX",
            width: 50
        },
        identifier: identifier,
        text: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)($29a6ad693cea50fd$var$AcquisitionAnnouncementDetail, {}),
                /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    "data-testid": testId
                })
            ]
        }),
        mobileText: /*#__PURE__*/ (0, $loA2J.jsx)($29a6ad693cea50fd$var$AcquisitionAnnouncementDetail, {}),
        productKey: productKey,
        backgroundPreset: "gwp-8238-announcement",
        linkText: linkText,
        linkUrl: "https://www.atlassian.com/blog/announcements/atlassian-acquires-dx",
        dataEventProps: {
            "data-product-key": productKey,
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": linkText,
            "data-label-english": "Learn more"
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: ufoSegmentName,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $47768.EnhancedBannerAlert), (0, $7Knp0._)({}, acquisitionAnnouncementConfig))
    });
};

});
parcelRegister("47768", function(module, exports) {

$parcel$export(module.exports, "EnhancedBannerAlert", function () { return $6b681fb7f69a74b7$export$e2bb4f4abc9a31da; });
/* enhanced-banner-alert.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");

var $1syhO = parcelRequire("1syhO");
const $6b681fb7f69a74b7$export$e2bb4f4abc9a31da = (bannerInfo)=>{
    const bannerStorageItem = `BannerAlert_dismiss-${bannerInfo.identifier}`;
    const closeIconDataEventProps = {
        "data-product-key": bannerInfo.productKey,
        "data-event-component": "button",
        "data-event-container": "announcementBanner",
        "data-event": "clicked",
        "data-label": "Close",
        "data-label-english": "Close"
    };
    const [isHidden, setIsHidden] = (0, $iSvIT.useState)(true);
    const mobileClass = bannerInfo.mobileTextThirdScreen ? "three-screen" : "two-screen";
    (0, $iSvIT.useEffect)(()=>{
        const dismissValue = (0, $1syhO.getLocalStorage)(bannerStorageItem);
        if (dismissValue !== "1") setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    let mobileProps = bannerInfo.imageProps;
    if (bannerInfo.imageMobileProps && bannerInfo.imageMobileProps.src) mobileProps = bannerInfo.imageMobileProps;
    const bannerBgPreset = bannerInfo.backgroundPreset ? `bg-${bannerInfo.backgroundPreset}` : `bg-none`;
    const bannerType = bannerInfo.bannerType ? `banner-type-${bannerInfo.bannerType}` : "banner-type-default";
    const bgLinkColor = bannerInfo.backgroundPreset == "gwp-5090-banners" ? "bgBlackBlue" : "bgWhite";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_bfhk1ybm _kqswh2mm _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _1pbykb7n _85i5yh40 _189eh5ge _1dqonqa1 _5pio2icb _nzmgglyw _1auo1lef _21w0idpf _15641crf _s4s5idpf _1qlo1crf _7j8l1lk2 _jw2n1wug _1yvc1wug _19z9gktf _nue91vuk _1lrfidpf _pytjidpf _smywidpf _4tf1idpf _1dkqidpf _1i8zidpf _1twsidpf _c7u0idpf _1u1bjk2v _1876mq8p _gsz9mgnk _evayglyw _lhr7161t _1cmq12iu _88w1cd5j _5vmz1ejb _3kek1ejb _190eni2e _wb1217a9 _vb1gvgh6 _1at2oyge _49yzdf70 _cfy01ule _18901k92 _1aavidpf _72q2idpf _11sc1y44 _i4q0idpf _n8ff1cby _qho21j28 _1w7d1hlo _sqps1ybm _iawm1hlo _abydglyw _6c4acd5j _udn3glyw _2fl2idpf _1kn8cd5j _1vxmcd5j _1mafcd5j _waepcd5j _1y8xcd5j _1ur0cd5j _ojfccd5j _1yaacd5j _11zscd5j _1s05cd5j _6rr71ybm _fsy11ybm _sx881ybm _1s7h1ybm _1gudcd5j _1m8acd5j _1lcvcd5j _v05mcd5j _lkhdni7l _pu49ni7l _162fni7l _19ycni7l _102q1hbo _2utfmgnk _1vm51dlf _1e74altx _1o3a1izt _1blmu4dp _1si213i1 _1k051ms4 _1yip1f51 _6zpp1f51 _eyt5xchc _nxj7u58z _7w4fcd5j _xfs2idpf _17es1rga _lfur1dgx _1t0kmgnk _ejrwidpf _1m4lanty _7ax8uuw1 _1ww71tcg _cfnoftgi _ogm61et3 _ve7k1ule _1mt7kfja _76j711ux _1dxgidpf _1i4jt1wm _ne8lqiko _1it7ys9h _umq2mgvx _16471dnu _1uhmmr2s _6cysidpf _yo8p1tcg _17pqqslr _ti1kp3fh _onmtn7od",
                `${bannerBgPreset} ${bannerType}`
            ]),
            "data-dismissed": isHidden ? "true" : undefined,
            "data-testid": "banner-alert-container",
            style: (0, $6iHNw._)((0, $7Knp0._)({}, bannerInfo.customCSS), {
                "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100")),
                "--_e0fbx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.purple500")),
                "--_1tgiy09": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue900")),
                "--_1b67llw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue700")),
                "--_1avknp6": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.secondary.red")),
                "--_1vwzriw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.yellow")),
                "--_b9m2cq": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.secondary.green")),
                "--_1lpv4ka": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.lime")),
                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
            }),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1rjcpxbi _1e0c1txw _2lx2vrvc _zulpzwfg _kqswh2mm _6rth12gs _sugaglyw",
                                    "desktop-container"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c1txw _4cvr1h6o"
                                        ]),
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                            image: (0, $7Knp0._)({
                                                width: 209
                                            }, bannerInfo.imageProps),
                                            style: {
                                                maxWidth: "100%",
                                                height: "auto"
                                            },
                                            forceEagerLoad: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_191w1xtt _4t3i1osq _sugaglyw",
                                            "line"
                                        ]),
                                        style: {
                                            "--_k3797e": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light700"))
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1bsb1osq _1e0c1txw _2lx2vrvc _1bah1yb4 _4cvr1h6o _zulpzwfg _na0i1bp4 _dh1a1y6m _2osn14y2 _ag851h6o _10ca1q9c"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                className: (0, $esG4f.default)([
                                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                    "body-md"
                                                ]),
                                                children: bannerInfo.text
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                                bgColor: bgLinkColor,
                                                text: bannerInfo.linkText,
                                                href: bannerInfo.linkUrl,
                                                type: "primary",
                                                dataEventProps: bannerInfo.dataEventProps
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1rjcpxbi _1e0cglyw _2lx21bp4 _4cvr1h6o _suga1txw",
                                    "mobile-container"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c11p5 _p12f1osq _18zr7vkz"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow341opw _ezr91onc _17k8119v _18shrjc5 _1h6z1ule",
                                                    "_19pkidpf _2hwx1wug _otyridpf _18u01wug",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                                        image: (0, $7Knp0._)({
                                                            width: 180
                                                        }, mobileProps),
                                                        style: {
                                                            maxWidth: "100%",
                                                            height: "auto"
                                                        },
                                                        forceEagerLoad: true
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow341opw _ezr91onc _17k8119v _18shrjc5 _1h6z1ule",
                                                    "_y3gn1h6o _1mou1wug _tzy4idpf _ju25i11n",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                    className: (0, $esG4f.default)([
                                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                        "body-md"
                                                    ]),
                                                    children: bannerInfo.mobileText
                                                })
                                            }),
                                            bannerInfo.mobileTextThirdScreen && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow341opw _ezr91onc _17k8119v _18shrjc5 _1h6z1ule",
                                                    "_y3gn1h6o _1mou1wug _tzy4idpf _ju251onc",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                    className: (0, $esG4f.default)([
                                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                        "body-md"
                                                    ]),
                                                    children: bannerInfo.mobileTextThirdScreen
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                        bgColor: bgLinkColor,
                                        text: bannerInfo.linkText,
                                        href: bannerInfo.linkUrl,
                                        type: "primary",
                                        dataEventProps: bannerInfo.dataEventProps
                                    })
                                ]
                            })
                        ]
                    })
                }),
                bannerInfo.bannerType != "lifted" && /*#__PURE__*/ (0, $loA2J.jsx)("button", (0, $6iHNw._)((0, $7Knp0._)({
                    className: (0, $esG4f.default)([
                        "_19itidpf _r06hglyw _bfhk1j28 _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _1pbykb7n _rjxpidpf _19pk7vkz _2hwx7vkz _otyr7vkz _18u07vkz",
                        `close-button-symbol`
                    ]),
                    "data-testid": "close-button",
                    "aria-label": "Close",
                    onClick: ()=>{
                        setIsHidden(true);
                        (0, $1syhO.setLocalStorage)(bannerStorageItem, "1");
                    }
                }, closeIconDataEventProps), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Cross), {
                        size: "24"
                    })
                }))
            ]
        })
    });
};
const $6b681fb7f69a74b7$var$scrollUpTwoScreens = null;
const $6b681fb7f69a74b7$var$scrollUpThreeScreens = null;
const $6b681fb7f69a74b7$var$desktopContainerStyles = null;
const $6b681fb7f69a74b7$var$mobileContainerStyles = null;
const $6b681fb7f69a74b7$var$desktopLogoStyles = null;
const $6b681fb7f69a74b7$var$marqueeContainerStyles = null;
const $6b681fb7f69a74b7$var$marqueeItemStyle = null;
const $6b681fb7f69a74b7$var$marqueeItem1Styles = null;
const $6b681fb7f69a74b7$var$marqueeItem2Styles = null;
const $6b681fb7f69a74b7$var$marqueeItem3Styles = null;
const $6b681fb7f69a74b7$var$containerStyles = null;
const $6b681fb7f69a74b7$var$contentStyles = null;
const $6b681fb7f69a74b7$var$pStyle = null;
const $6b681fb7f69a74b7$var$lineStyle = null;
const $6b681fb7f69a74b7$var$closeStyles = null;

});



parcelRegister("ffiZE", function(module, exports) {

$parcel$export(module.exports, "GartnerSection", function () { return $555b109880d44bfe$export$4c6bc3f3981e1f4c; });
/* gartner-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $9iWJ8 = parcelRequire("9iWJ8");
const $555b109880d44bfe$var$GartnerStyles = null;
const $555b109880d44bfe$export$4c6bc3f3981e1f4c = ({ experimentEnabled: experimentEnabled })=>{
    const getGwp4948GartnerJiraProductTourExperiment = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).gwp4948GartnerJiraProductTourExperiment);
    const gwp4948GartnerJiraProductTourExperimentIsActive = experimentEnabled || getGwp4948GartnerJiraProductTourExperiment != undefined && getGwp4948GartnerJiraProductTourExperiment.type === "enrolled" && getGwp4948GartnerJiraProductTourExperiment.value === "test";
    const intl = (0, $f6qj2.default)();
    const gartnerImage = // eslint-disable-next-line local/no-non-orangelogic-images-eslint
    "https://wac-cdn.atlassian.com/misc-assets/webp-images/gartner-jsw-left-img.webp";
    const gartnerMarketingHref = (0, $3FBn4.useLocalizedHref)("https://www.atlassian.com/gartner/magic-quadrant-marketing-work-management");
    const gartnerDevopsHref = (0, $3FBn4.useLocalizedHref)("https://www.atlassian.com/gartner/magic-quadrant-devops");
    const gartnerMarketingLink = (children)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
            href: gartnerMarketingHref,
            children: children
        });
    const gartnerDevopsLink = (children)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
            href: gartnerDevopsHref,
            children: children
        });
    if (gwp4948GartnerJiraProductTourExperimentIsActive) return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _vwz410nf _1bah1h6o _ca0q53f4 _u5f3idpf _n3td12am _19bvidpf _1pfhkgzx _1itk1a3y _43ds17la _11eb8pqr _d62sidpf _dubxo1fv"
        ]),
        style: {
            "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100")),
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                    image: {
                        src: gartnerImage,
                        alt: ""
                    }
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            children: intl.formatMessage({
                                id: "JiraSoftwarePageTemplate.GartnerSection.header",
                                defaultMessage: "Atlassian named a Leader in the 2024 Gartner\xae Magic Quadrant"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "JiraSoftwarePageTemplate.GartnerSection.body",
                            defaultMessage: `The best work management solution for all teams \u{2014} Atlassian is the only platform to be recognized as a Leader for both <gartnerMarketingLink>Marketing</gartnerMarketingLink> and <gartnerDevopsLink>DevOps</gartnerDevopsLink>`,
                            values: {
                                gartnerMarketingLink: gartnerMarketingLink,
                                gartnerDevopsLink: gartnerDevopsLink
                            }
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {});
};

});

parcelRegister("gTvSH", function(module, exports) {

$parcel$export(module.exports, "BuildAndSupportDoubleFeatureSection", function () { return (parcelRequire("eceIQ")).default; });
$parcel$export(module.exports, "JswCollaborateSection", function () { return (parcelRequire("i8fOS")).JswCollaborateSection; });
$parcel$export(module.exports, "JswDoubleFeatureSection", function () { return (parcelRequire("3YHG8")).JswDoubleFeatureSection; });
$parcel$export(module.exports, "TestimonialSection", function () { return (parcelRequire("3lrJv")).TestimonialSection; });
$parcel$export(module.exports, "ClosingBanner", function () { return (parcelRequire("ifaJo")).ClosingBanner; });
$parcel$export(module.exports, "IntegrationsSection", function () { return (parcelRequire("LSaI0")).IntegrationsSection; });
$parcel$export(module.exports, "NoJiraHeroSection", function () { return (parcelRequire("dChrM")).NoJiraHeroSection; });

var $eceIQ = parcelRequire("eceIQ");

var $ifaJo = parcelRequire("ifaJo");

var $LSaI0 = parcelRequire("LSaI0");

var $i8fOS = parcelRequire("i8fOS");

var $3YHG8 = parcelRequire("3YHG8");

var $dChrM = parcelRequire("dChrM");

var $3lrJv = parcelRequire("3lrJv");

});
parcelRegister("eceIQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $863c4d1174fb4b13$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");

var $gAJUc = parcelRequire("gAJUc");

var $en0R4 = parcelRequire("en0R4");
parcelRequire("Tf71T");
var $fkaMJ = parcelRequire("fkaMJ");
const $863c4d1174fb4b13$var$BuildAndSupportDoubleFeatureSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const useGWP7617Gate = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    const tailoredHeadingText = useGWP7617Gate ? intl.formatMessage({
        id: "jira-product-tour.staggered-double-feature-section.header-text-gwp-7617",
        defaultMessage: "Tailor for your team"
    }) : intl.formatMessage({
        id: "jira-product-tour.staggered-double-feature-section.second-feature-header-text",
        defaultMessage: "Tailor it for your team"
    });
    const tailoredBodyText = useGWP7617Gate ? intl.formatMessage({
        id: "jira-product-tour.staggered-double-feature-section.second-feature-body-text-gwp-7617",
        defaultMessage: "Customize Jira to match your team\u2019s processes, workflows, language, and more. Integrate with every tool you use to get work done. "
    }) : intl.formatMessage({
        id: "jira-product-tour.staggered-double-feature-section.second-feature-body-text",
        defaultMessage: "Configure Jira to match your team\u2019s processes, workflows, language, and more. Integrate with every tool you use to get work done."
    });
    const tailoredLinkNew = (0, $3FBn4.useLocalizedHref)("/software/jira/guides/getting-started/basics#step-3-set-up-your-columns");
    const tailoredLinkOld = (0, $3FBn4.useLocalizedHref)("/software/jira/guides/issues/overview#what-is-an-issue");
    const tailoredLink = useGWP7617Gate ? tailoredLinkNew : tailoredLinkOld;
    const featureData = [
        {
            headingText: intl.formatMessage({
                id: "jira-product-tour.staggered-double-feature-section.first-feature-header-text",
                defaultMessage: "Everything in one place"
            }),
            bodyText: intl.formatMessage({
                id: "jira-product-tour.staggered-double-feature-section.first-feature-body-text",
                defaultMessage: "The context you need, when you need it. See software team release dates, real-time views of Figma designs, and more, all inside Jira."
            }),
            linkText: intl.formatMessage({
                id: "jira-product-tour.staggered-double-feature-section.first-feature-link-text",
                defaultMessage: "Explore features"
            }),
            linkUrl: (0, $3FBn4.useLocalizedHref)("/software/jira/features"),
            imageLink: (0, $fkaMJ.getStaggeredDoubleFeautureFirstImage)(intl.locale),
            analyticsEventLabel: "atlas-55799-jira-features-button-clicked",
            imageHeight: 440
        },
        {
            headingText: tailoredHeadingText,
            bodyText: tailoredBodyText,
            linkText: intl.formatMessage({
                id: "jira-product-tour.staggered-double-feature-section.second-feature-link-text",
                defaultMessage: "Learn more"
            }),
            linkUrl: tailoredLink,
            imageLink: (0, $fkaMJ.getStaggeredDoubleFeautureSecondImage)(intl.locale),
            analyticsEventLabel: "atlas-55799-jira-issues-button-clicked",
            imageHeight: 490
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $en0R4.StaggeredFeatureList), {
        mainHeadingText: intl.formatMessage({
            id: "jira-product-tour.staggered-double-feature-section.header-text",
            defaultMessage: "Bring every team together under one roof"
        }),
        subHeadingText: intl.formatMessage({
            id: "jira-product-tour.staggered-double-feature-section.subheader-text",
            defaultMessage: "Spend less time trying to get aligned and more time driving projects forward with confidence."
        }),
        featureData: featureData,
        startingImagePosition: "left"
    });
};
$863c4d1174fb4b13$var$BuildAndSupportDoubleFeatureSection.displayName = "BuildAndSupportDoubleFeatureSection";
var $863c4d1174fb4b13$export$2e2bcd8739ae039 = $863c4d1174fb4b13$var$BuildAndSupportDoubleFeatureSection;

});
parcelRegister("en0R4", function(module, exports) {

$parcel$export(module.exports, "StaggeredFeatureList", function () { return $6b1c5035c8eea7b3$export$5bd229e30bf4ab20; });
/* staggered-feature-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $1V1HX = parcelRequire("1V1HX");
const $6b1c5035c8eea7b3$var$containerStyle = null;
const $6b1c5035c8eea7b3$var$mainHeadingTextStyle = null;
const $6b1c5035c8eea7b3$var$subHeadingTextStyle = null;
const $6b1c5035c8eea7b3$var$featureContainerStyle = null;
const $6b1c5035c8eea7b3$var$featureImageContainerStyle = null;
const $6b1c5035c8eea7b3$var$featureBodyContainerStyle = null;
const $6b1c5035c8eea7b3$var$featureLinkStyles = null;
const $6b1c5035c8eea7b3$var$featureHeadingTextStyle = null;
const $6b1c5035c8eea7b3$var$featureBodyTextStyle = null;
const $6b1c5035c8eea7b3$var$Feature = ({ featureData: featureData, imagePosition: imagePosition })=>{
    if (imagePosition === "left") return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx2vrvc _1pfhvbgk _79ty1bp4 _1np61h6o _1rwy1tcg _zzrm1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)($6b1c5035c8eea7b3$var$FeatureImage, (0, $7Knp0._)({}, featureData)),
            /*#__PURE__*/ (0, $loA2J.jsx)($6b1c5035c8eea7b3$var$FeatureBody, (0, $7Knp0._)({}, featureData))
        ]
    });
    else return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx2vrvc _1pfhvbgk _79ty1bp4 _1np61h6o _1rwy1tcg _zzrm1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)($6b1c5035c8eea7b3$var$FeatureBody, (0, $7Knp0._)({}, featureData)),
            /*#__PURE__*/ (0, $loA2J.jsx)($6b1c5035c8eea7b3$var$FeatureImage, (0, $7Knp0._)({}, featureData))
        ]
    });
};
const $6b1c5035c8eea7b3$var$FeatureImage = ({ imageLink: imageLink, imageHeight: imageHeight })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1tvckb7n _1rwy1tcg _1y8o1ogm _bna71ns9 _rtys1ogm _1lre1osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
            image: {
                src: imageLink,
                alt: "",
                width: 600,
                height: imageHeight
            }
        })
    });
};
const $6b1c5035c8eea7b3$var$FeatureBody = ({ headingText: headingText, bodyText: bodyText, linkUrl: linkUrl, linkText: linkText, analyticsEventLabel: analyticsEventLabel })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: `${analyticsEventLabel}`,
                section: "staggered-feature-section"
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _1o9zgrho _4cvr1h6o _1pfhvrzy _1bsb1diq _zulpftgi _1tvccs5v _1rwy1tcg _zzrm1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                className: (0, $esG4f.default)([
                    "_1wybzwfg _ect41pz4 _k48p1fw0 _vwz410mc _slp31hna _195gidpf _1mouidpf _y3gn1h6o"
                ]),
                style: {
                    "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                },
                children: headingText
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1wyb7vkz _ect4bzd7 _k48p1nn1 _vwz41gkc _slp31hna _y3gn1h6o _p12fng7t _ca0qidpf _u5f310yn _n3tdidpf _19bv10yn _1y8o1osq"
                ]),
                style: {
                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                },
                children: bodyText
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
                href: linkUrl,
                onClick: handleClick,
                "aria-label": formatMessage({
                    id: "learnMoreAbout",
                    defaultMessage: "Learn more about {subject}"
                }, {
                    subject: headingText
                }),
                className: (0, $esG4f.default)([
                    "_syaz17la"
                ]),
                style: {
                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                },
                children: [
                    linkText,
                    " ",
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1V1HX.ArrowRightNoCircle), {})
                ]
            })
        ]
    });
};
const $6b1c5035c8eea7b3$export$5bd229e30bf4ab20 = ({ mainHeadingText: mainHeadingText, subHeadingText: subHeadingText, featureData: featureData, startingImagePosition: startingImagePosition })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1mou16xz _195gidpf _1e0c1txw _1bah1h6o _4cvr1h6o _2lx21bp4 _91qc9by0 _1x7014no"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_y3gn1h6o _ect41pz4 _1wybckbl _zg8l4jg8 _k48p1fw0 _slp31hna _flz0zwfg _1lzozwfg _1cqs1ul9"
                ]),
                style: {
                    "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                },
                children: mainHeadingText
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_y3gn1h6o _ect4bzd7 _1wybgktf _zg8l4jg8 _k48p1nn1 _vwz41f4h _1pfh7vkz _1bsbbxu3 _79ty1bp4 _1np61h6o _1rwy1tcg _7se29by0 _zzrm1osq _s637jwe6"
                ]),
                style: {
                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                },
                children: subHeadingText
            }),
            featureData.map((feature, index)=>index % 2 === 0 ? /*#__PURE__*/ (0, $loA2J.jsx)($6b1c5035c8eea7b3$var$Feature, {
                    imagePosition: startingImagePosition === "left" ? "left" : "right",
                    featureData: feature
                }, index) : /*#__PURE__*/ (0, $loA2J.jsx)($6b1c5035c8eea7b3$var$Feature, {
                    imagePosition: startingImagePosition === "left" ? "right" : "left",
                    featureData: feature
                }, index))
        ]
    });
};

});
parcelRegister("1V1HX", function(module, exports) {

$parcel$export(module.exports, "ArrowRightNoCircle", function () { return $e2115d36ef8842de$export$c6abe79c9e2193ff; });

var $loA2J = parcelRequire("loA2J");
const $e2115d36ef8842de$export$c6abe79c9e2193ff = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        "aria-hidden": "true",
        width: "11",
        height: "8",
        viewBox: "0 0 11 8",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M7.40796 0L6.32831 1.2021L8.07854 3.1497H0.763182C0.341906 3.1497 0 3.53038 0 3.99943C0 4.46849 0.341906 4.84917 0.763182 4.84917H8.07854L6.32831 6.7979L7.40796 8L11 3.99943L7.40796 0Z"
        })
    });

});



parcelRegister("ifaJo", function(module, exports) {

$parcel$export(module.exports, "ClosingBanner", function () { return $092617e980744e77$export$3c134be78c4f7e1c; });
/* closing-banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $91nJf = parcelRequire("91nJf");
parcelRequire("f0Hih");
var $dhmEV = parcelRequire("dhmEV");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $gAJUc = parcelRequire("gAJUc");
const $092617e980744e77$export$3c134be78c4f7e1c = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const useGWP7617Gate = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    const text = useGWP7617Gate ? formatMessage({
        id: "jira-product-tour.closing-banner.header-text-gwp-7617",
        defaultMessage: "No matter what you dream up, Jira helps you get it done."
    }) : formatMessage({
        id: "jira-product-tour.closing-banner.header-text",
        defaultMessage: "No matter what you're trying to dream up, Jira helps you get it done"
    });
    const buttonText = formatMessage({
        id: "jira-product-tour.closing-banner.button-text",
        defaultMessage: "Get Jira free"
    });
    const ctaButtonUrl = "/try/cloud/signup?bundle=jira-software";
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1b1v _4cvr1h6o _p12f1dho _19pkidpf _2hwx1wug _otyridpf _18u01wug _1eogidpf _qjx39by0 _1celidpf _5n7a9by0 _1gde1bp4 _nssp1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _ca0qidpf _u5f3gktf _n3tdidpf _19bvgktf _zulp1ylp _144t1wqb _zzsz1h6o _1tz91y44"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        className: (0, $esG4f.default)([
                            "_p12fntfb _ect41pz4 _k48p1fw0 _1wyb1ylp _vwz4ckbl _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazcd5j _xsmr1h6o _1cqs1ul9 _1bys14no"
                        ]),
                        style: {
                            "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display")),
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                        },
                        children: text
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dhmEV.default), {
                        intentType: "button",
                        containerId: "jira-product-tour-overview-closing-banner",
                        productKey: "jira-software.ondemand",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                            variant: "primary",
                            size: "small",
                            color: "yellow",
                            href: (0, $3FBn4.useLocalizedHref)(ctaButtonUrl),
                            dataEventProps: {
                                "data-product-key": "jira",
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "ctaSection",
                                "data-label": "get-jira-free",
                                "data-label-english": `${buttonText}`,
                                "data-track-event": "jira-pt.closing-banner.get-jira-free"
                            },
                            children: buttonText
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _1bsbhvew _4t3ieq5r _1wpzh9n0 _1wn41h6o _1tvd1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_mezjhvew _bna7eq5r"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                            image: {
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/865y3n8f2i1843j2vs45535l48vtx77r.webp",
                                alt: "",
                                width: 303,
                                height: 303
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_kqswstnw _152t1skh _1e021wqb"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                            image: {
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/xbvh6b7g0mjibasf143rj6711054m0cf.webp",
                                alt: "",
                                width: 95,
                                height: 97
                            }
                        })
                    })
                ]
            })
        ]
    });
};
$092617e980744e77$export$3c134be78c4f7e1c.displayName = "ClosingBanner";
const $092617e980744e77$var$ctaBannerContainer = null;
const $092617e980744e77$var$contentContainer = null;
const $092617e980744e77$var$headerStyles = null;
const $092617e980744e77$var$imageContainer = null;
const $092617e980744e77$var$imageStyles = null;
const $092617e980744e77$var$overlayStarImage = null;

});

parcelRegister("LSaI0", function(module, exports) {

$parcel$export(module.exports, "IntegrationsSection", function () { return $def0c68b01417b46$export$94c8b142f0acfaff; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $7pCFH = parcelRequire("7pCFH");

var $gAJUc = parcelRequire("gAJUc");
const $def0c68b01417b46$export$94c8b142f0acfaff = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const intl = (0, $f6qj2.default)();
    const useGWP7617Gate = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    // TODO: add width and height prop to iconData to use in Picture component
    const iconData = [
        {
            url: "https://dam-cdn.atl.orangelogic.com/AssetLink/n773sikm845802hme5xs1ne04uy2g837.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.microsoft-alt-text",
                defaultMessage: "Microsoft Teams icon"
            }),
            width: 60,
            height: 50
        },
        {
            url: "https://dam-cdn.atl.orangelogic.com/AssetLink/s2b5621s46n36ogarwic4734b30xge4b.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.google-drive-alt-text",
                defaultMessage: "Google Drive icon"
            }),
            width: 60,
            height: 50
        },
        {
            url: "https://dam-cdn.atl.orangelogic.com/AssetLink/wrb81j78p4733kc10bdjw8v637h1w438.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.google-doc-alt-text",
                defaultMessage: "Google Docs icon"
            }),
            width: 60,
            height: 50
        },
        {
            url: "https://dam-cdn.atl.orangelogic.com/AssetLink/1m0x1742g31t1446203avy1kpi468me1.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.figma-alt-text",
                defaultMessage: "Figma icon"
            }),
            width: 48,
            height: 60
        },
        {
            url: "https://dam-cdn.atl.orangelogic.com/AssetLink/s2035t28j8p045avd6kjvjpr68g0uyfb.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.miro-alt-text",
                defaultMessage: "Miro icon"
            }),
            width: 60,
            height: 50
        },
        {
            url: "https://dam-cdn.atl.orangelogic.com/AssetLink/ow67lf57t0be1t6ami55288g1dx2kp46.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.slack-alt-text",
                defaultMessage: "Slack icon"
            }),
            width: 60,
            height: 58
        },
        {
            url: "https://dam-cdn.atl.orangelogic.com/AssetLink/uje2jom52scmv5bs8o1ej15sp162l6h0.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.zoom-alt-text",
                defaultMessage: "Zoom icon"
            }),
            width: 60,
            height: 13
        }
    ];
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: "atlas-55799-integrations-button-clicked",
                section: "integration-section"
            }
        }).fire();
    };
    const headingText = useGWP7617Gate ? intl.formatMessage({
        id: "jira-product-tour.integrations-section.heading-text-gwp-7617",
        defaultMessage: "Meet teams where they work"
    }) : intl.formatMessage({
        id: "jira-product-tour.integrations-section.heading-text",
        defaultMessage: "Meets teams where they work"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7pCFH.OffsetIconCollection), {
        headingText: headingText,
        bodyText: intl.formatMessage({
            id: "jira-product-tour.integrations-section.body-text",
            defaultMessage: "If your team uses it, we integrate with it. Easily add your favorite tools from the Atlassian Marketplace, keeping Jira as your central source of truth."
        }),
        iconData: iconData,
        ctaText: intl.formatMessage({
            id: "jira-product-tour.integrations-section.cta-text",
            defaultMessage: "Go to Marketplace"
        }),
        ctaLink: "https://marketplace.atlassian.com",
        ctaOnClickFunc: handleClick
    });
};
$def0c68b01417b46$export$94c8b142f0acfaff.displayName = "IntegrationsSection";

});
parcelRegister("7pCFH", function(module, exports) {

$parcel$export(module.exports, "OffsetIconCollection", function () { return $e0325788b8999329$export$87daf6ae3676874; });
/* offset-icon-collection.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $eDoPe = parcelRequire("eDoPe");

var $bhreu = parcelRequire("bhreu");
const $e0325788b8999329$var$sectionContainer = null;
const $e0325788b8999329$var$contentContainer = null;
const $e0325788b8999329$var$textContainerStyles = null;
const $e0325788b8999329$var$headingTextStyles = null;
const $e0325788b8999329$var$ctaStyles = null;
const $e0325788b8999329$var$iconContainerStyles = null;
const $e0325788b8999329$var$iconPictureStyles = null;
const $e0325788b8999329$var$animationStyle = null;
const $e0325788b8999329$export$4b1f681ca613adbb = ({ src: src, alt: alt, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: src,
            alt: alt,
            width: width,
            height: height
        }
    });
};
const $e0325788b8999329$export$87daf6ae3676874 = ({ iconData: iconData, headingText: headingText, bodyText: bodyText, ctaText: ctaText, ctaLink: ctaLink, ctaOnClickFunc: ctaOnClickFunc })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1bsb1osq _bfhk1hxd _1e0c1txw _1bah1h6o _4cvr1h6o _2lx21bp4 _1pbykb7n _kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx2vrvc _p12f17gh _1mou1qr7 _liwc1txw _79ty1bp4 _1np61h6o _s637jwe6 _1eogidpf _qjx39by0 _1celidpf _5n7a9by0 _1x701ylp"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _zulp1ul9 _4cvr1y6m _syazqlpt _bozg1ul9 _m80d1h6o _79ty1bp4 _1np61h6o _s637jwe6 _1eogidpf _qjx310yn _1celidpf _5n7a10yn"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            className: (0, $esG4f.default)([
                                "_k48p1fw0 _1wyb1wto _vwz4cjiy _1mouidpf _1r3wl07h"
                            ]),
                            children: headingText
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            children: bodyText
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            href: ctaLink,
                            onClick: ctaOnClickFunc,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                className: (0, $esG4f.default)([
                                    "_11q7glyw _1wyb1k92 _r06hglyw _2rko1ul9 _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _ect41kw7 _19it1axk _80omtlke"
                                ]),
                                children: ctaText
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    ref: scrollRef,
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1n261g80 _i0dl1osq _zulp1wyk _1bah1h6o _ae4v1h6o _p12f18a8 _1o9zidpf _zzrm1kdj _1rwy1ylp"
                    ]),
                    children: iconData.map((icon, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            style: {
                                animationDelay: `${0.5 + 0.25 * index}s`
                            },
                            className: (0, $esG4f.default)([
                                "_2rko1ul9 _1e0c1txw _4cvr1h6o _1bah1h6o _tip8kb7n _5sagw1p3 _bfhku67f _1bsb53f4 _4t3i53f4 _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf _vavro7ao _zzrmvbgk _1gdlvbgk _60iy1txw _2a1o1h6o _1biz1h6o _137x8tad _mgbt1343 _v1631fm0 _1vsm1fm0 _1v3g1fm0 _1vvw1fm0 _rtys1osq _19l31osq _mezj1wug _bna71wug",
                                sectionIsVisible && "_j7hq1nm9"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)($e0325788b8999329$export$4b1f681ca613adbb, {
                                src: icon.url,
                                alt: icon.altText,
                                width: icon.width,
                                height: icon.height
                            })
                        }, index))
                })
            ]
        })
    });
};

});


parcelRegister("i8fOS", function(module, exports) {

$parcel$export(module.exports, "JswCollaborateSection", function () { return $89940f222a367d7c$export$46dbd2229fc0687f; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $gAJUc = parcelRequire("gAJUc");
parcelRequire("6EIiq");
var $kk7V4 = parcelRequire("kk7V4");
parcelRequire("Tf71T");
var $fkaMJ = parcelRequire("fkaMJ");
const $89940f222a367d7c$export$46dbd2229fc0687f = ()=>{
    const intl = (0, $f6qj2.default)();
    const useGWP7617Gate = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    // first item
    const firstFeatureDescriptionOld = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.first-feature-description-text",
        defaultMessage: "From short projects, to large cross-functional programs, Jira helps break big ideas down into achievable steps. Organize work, create milestones, map dependencies and more."
    });
    const firstFeatureDescriptionAI = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.first-feature-description-text-ai",
        defaultMessage: "From short projects, to large cross-functional programs, Jira uses AI to help break big ideas down into achievable steps. Organize work, create milestones, map dependencies and more."
    });
    // third item
    const thirdFeatureTitleOld = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.third-feature-title-text",
        defaultMessage: "Track work your way"
    });
    const thirdFeatureTitleAI = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.third-feature-title-text-ai",
        defaultMessage: "Work your way"
    });
    const thirdFeatureDescriptionOld = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.third-feature-description-text",
        defaultMessage: "Visualize work with lists, boards, backlogs, and more. Make workflows for any process and integrate with tools you love."
    });
    const thirdFeatureDescriptionAI = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.third-feature-description-text-ai",
        defaultMessage: "Keep Jira in sync with your favorite tools, customize your workflows with AI \u2013 and, stay on top of it all with lists, boards, and timeline views."
    });
    // fourth item
    const fourthFeatureTitleOld = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.fourth-feature-title-text",
        defaultMessage: "Optimize with insights"
    });
    const fourthFeatureTitleAI = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.fourth-feature-title-text-ai",
        defaultMessage: "Keep your projects on track"
    });
    const fourthFeatureDescriptionOld = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.fourth-feature-description-text",
        defaultMessage: "Get visibility into project progress, understand risks, and surface insights from real-time data to help you improve team performance."
    });
    const fourthFeatureDescriptionAI = intl.formatMessage({
        id: "jira-product-tour.collaborate-section.fourth-feature-description-text-ai",
        defaultMessage: "Get visibility into project progress, understand risks, and surface insights from real-time data to help you improve team performance."
    });
    const options = [
        {
            title: intl.formatMessage({
                id: "jira-product-tour.collaborate-section.first-feature-title-text",
                defaultMessage: "\u26A1 Plan and organize tasks"
            }),
            image: (0, $fkaMJ.getCollaborateFirstImage)(intl.locale),
            description: useGWP7617Gate ? firstFeatureDescriptionAI : firstFeatureDescriptionOld
        },
        {
            title: intl.formatMessage({
                id: "jira-product-tour.collaborate-section.second-feature-title-text",
                defaultMessage: "Align work to goals"
            }),
            image: (0, $fkaMJ.getCollaborateSecondImage)(intl.locale),
            description: intl.formatMessage({
                id: "jira-product-tour.collaborate-section.second-feature-description-text",
                defaultMessage: "Link work to goals so everyone can see how their work contributes to company objectives and stay aligned to what\u2019s important."
            })
        },
        {
            title: useGWP7617Gate ? thirdFeatureTitleAI : thirdFeatureTitleOld,
            image: (0, $fkaMJ.getCollaborateThirdImage)(intl.locale),
            description: useGWP7617Gate ? thirdFeatureDescriptionAI : thirdFeatureDescriptionOld
        },
        {
            title: useGWP7617Gate ? fourthFeatureTitleAI : fourthFeatureTitleOld,
            image: (0, $fkaMJ.getCollaborateFourthImage)(intl.locale),
            description: useGWP7617Gate ? fourthFeatureDescriptionAI : fourthFeatureDescriptionOld
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $kk7V4.JswCollaborate), {
        options: options,
        heading: intl.formatMessage({
            id: "jira-product-tour.collaborate-section.title-text",
            defaultMessage: "Made for complex projects or everyday tasks"
        })
    });
};
$89940f222a367d7c$export$46dbd2229fc0687f.displayName = "JswCollaborateSection";

});
parcelRegister("6EIiq", function(module, exports) {
$parcel$export(module.exports, "JswCollaborate", function () { return (parcelRequire("kk7V4")).JswCollaborate; });
$parcel$export(module.exports, "JswDoubleFeatureCard", function () { return (parcelRequire("2HmFK")).JswDoubleFeatureCard; });
$parcel$export(module.exports, "TestimonialCard", function () { return (parcelRequire("79Fc3")).TestimonialCard; });
$parcel$export(module.exports, "LogoBanner", function () { return (parcelRequire("bwq2g")).LogoBanner; });
$parcel$export(module.exports, "Header", function () { return (parcelRequire("9lQ9Q")).Header; });
$parcel$export(module.exports, "HeroCards", function () { return (parcelRequire("i9Hfh")).HeroCards; });
parcelRequire("kk7V4");
parcelRequire("2HmFK");
parcelRequire("79Fc3");
parcelRequire("bwq2g");
parcelRequire("9lQ9Q");
parcelRequire("i9Hfh");

});
parcelRegister("kk7V4", function(module, exports) {

$parcel$export(module.exports, "JswCollaborate", function () { return $940c3efccbb6701f$export$b0665de8e27040dd; });
/* jsw-collaborate.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $eDoPe = parcelRequire("eDoPe");

var $f6qj2 = parcelRequire("f6qj2");

var $cssyA = parcelRequire("cssyA");

var $5ohHq = parcelRequire("5ohHq");
const $940c3efccbb6701f$export$b0665de8e27040dd = ({ heading: heading, options: options })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)();
    const [activeOption, setActiveOption] = (0, $iSvIT.useState)(0);
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const changeActive = (index)=>{
        // Cancel all animations before activeOption change
        const progressGrowAnimations = document.getAnimations().filter((animation)=>{
            return animation instanceof CSSAnimation && animation.animationName === "progressgrow";
        });
        progressGrowAnimations.forEach((animation)=>{
            animation.cancel();
        });
        setActiveOption(index);
    };
    (0, $iSvIT.useEffect)(()=>{
        const progressGrowAnimations = document.getAnimations().filter((animation)=>{
            return animation instanceof CSSAnimation && animation.animationName === "progressgrow";
        }); // set finish event
        progressGrowAnimations.forEach((animation)=>{
            animation.onfinish = ()=>{
                setActiveOption(activeOption == options.length - 1 ? 0 : activeOption + 1);
                animation.cancel();
            };
        }); // Only cycle when visible
        if (!sectionIsVisible) progressGrowAnimations.forEach((animation)=>{
            animation.pause();
        });
        else progressGrowAnimations.forEach((animation)=>{
            animation.play();
        });
    }, [
        activeOption,
        options.length,
        sectionIsVisible
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        ref: scrollRef,
        className: (0, $esG4f.default)([
            "_kqswh2mm _1e0c11p5 _6a6z1h6o _4cvr1h6o _1rjc12am _195gzwfg _1ilvzwfg _91qcidpf",
            sectionIsVisible ? "is-visible" : ""
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_y3gn1h6o _91qc9by0 _8fz6e0nm _mezj1mcy _bna71k4y _5nenxk0h _twjk1qjk _14w91a70 _j0lcd4y9 _1jtm14no _rpid14y2 _1h8ed4y9 _1ga514no _1ftj14y2",
                    "top-section"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("h2", {
                    className: (0, $esG4f.default)([
                        "_k48p1fw0 _1wybckbl _vwz48vuz _19pkidpf _2hwxidpf _otyr1ul9 _18u0idpf _1r3w1ul9 _73n214no _z9soidpf _161zidpf _2a8ridpf _ikcgidpf"
                    ]),
                    children: [
                        heading,
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $cssyA.Picture), {
                            image: {
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/s31k3rin80p38d25a3wn54b8354r27vm.webp",
                                alt: "",
                                width: 245,
                                height: 279
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_91qc9by0 _jzgezwfg _1q5112am _11q7cd5j",
                    "bottom-section"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    "aria-label": formatMessage({
                        id: "jira-product-tour.collaborate-section.carousel",
                        defaultMessage: "Carousel"
                    }),
                    className: (0, $esG4f.default)([
                        "_p12f1uof _1e0c1txw _1n261g80 _zulpzwfg _zzrm1osq _79ty1bp4 _1np61h6o _9et11h6o _1yytidpf",
                        "row-width"
                    ]),
                    role: "region",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_i0dlbihp _kqswh2mm _cot22huk",
                                "half texts"
                            ]),
                            children: options.map((option, index)=>{
                                const src = (0, $cssyA.extendBfldrCacheTime)(option.image);
                                const isActive = activeOption == index;
                                return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: "option-container",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsxs)("button", {
                                            className: (0, $esG4f.default)([
                                                "_11q7glyw _r06hglyw _1r04idpf _80omtlke _19itidpf _1wyb1j6v _y3gn1e5h _19pkidpf _2hwxidpf _otyrzwfg _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvgktf _kqswh2mm _4t3i1osq _1vdjzwfg _1bfn10mc _1mjg1tcg _kmcs1ul9 _zpjv1w81 _19141wug _h95w1gmh",
                                                `option ${activeOption == index ? "active" : "inactive"}`
                                            ]),
                                            onClick: ()=>changeActive(index),
                                            children: [
                                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                    className: (0, $esG4f.default)([
                                                        "_kqswstnw _1e02idpf _152tidpf _u7coidpf _1bsb1l7b _4t3i1osq _bfhk1kby",
                                                        "progress"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                        className: (0, $esG4f.default)([
                                                            "_bfhkoelr _4t3iidpf"
                                                        ])
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                                    className: (0, $esG4f.default)([
                                                        "_1wyb1tcg _vwz41ul9 _k48p1fw0 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _v5641fa5 _1496ni7l"
                                                    ]),
                                                    children: option.title
                                                }),
                                                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                    className: (0, $esG4f.default)([
                                                        "_v5641qn0 _c71lidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1reo15vq _18m915vq"
                                                    ]),
                                                    children: option.description
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_1e0cglyw _liwc11p5 _9et11h6o _1np61h6o",
                                                "mobile-images"
                                            ]),
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cssyA.Picture), {
                                                image: {
                                                    src: src,
                                                    alt: option.title
                                                },
                                                style: {
                                                    aspectRatio: "5/4",
                                                    display: isActive ? "block" : "none",
                                                    width: "100%",
                                                    height: "auto"
                                                },
                                                className: (0, $esG4f.default)([
                                                    "_kqswh2mm _p12f1ogm"
                                                ])
                                            })
                                        })
                                    ]
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            "aria-live": "polite",
                            className: (0, $esG4f.default)([
                                "_i0dlbihp _kqswh2mm _cot22huk",
                                "half images"
                            ]),
                            role: "status",
                            children: options.map((option, index)=>{
                                const src = (0, $cssyA.extendBfldrCacheTime)(option.image);
                                const isActive = activeOption == index;
                                return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_liwcglyw",
                                        "desktop-images"
                                    ]),
                                    hidden: !isActive,
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cssyA.Picture), {
                                        image: {
                                            src: src,
                                            alt: option.title
                                        },
                                        style: {
                                            aspectRatio: "5/4",
                                            position: "absolute",
                                            width: "100%",
                                            height: "auto"
                                        }
                                    })
                                }, index);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $940c3efccbb6701f$var$topSectionForPictureStyles = null;
const $940c3efccbb6701f$var$mobileImagesStyles = null;
const $940c3efccbb6701f$var$desktopImagesStyles = null;
const $940c3efccbb6701f$var$rowWidthStyles = null;
const $940c3efccbb6701f$var$halfStyles = null;
const $940c3efccbb6701f$var$progressStyles = null;
const $940c3efccbb6701f$var$buttonStyles = null;
const $940c3efccbb6701f$var$optionDescriptionStyles = null;
const $940c3efccbb6701f$var$innerDivProgressStyles = null;
const $940c3efccbb6701f$var$optionH3Styles = null;
const $940c3efccbb6701f$var$bottomSectionStyles = null;
const $940c3efccbb6701f$var$optionContainerImageStyles = null;
const $940c3efccbb6701f$var$h2Styles = null;
const $940c3efccbb6701f$var$empowerStyles = null;

});

parcelRegister("2HmFK", function(module, exports) {

$parcel$export(module.exports, "JswDoubleFeatureCard", function () { return $f45432a6ddb75a8d$export$881c15c7192d6044; });
/* double-feature-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $cssyA = parcelRequire("cssyA");

var $5ohHq = parcelRequire("5ohHq");
const $f45432a6ddb75a8d$export$881c15c7192d6044 = ({ title: title, description: description, image: image })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c11p5 _1bsb1diq _zulp1gkc _11q7cd5j _16qs188r _1y8o1diq _zzrm1osq"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_mezj1osq _bna71osq"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cssyA.Picture), {
                    image: {
                        src: image,
                        alt: ""
                    }
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                        className: (0, $esG4f.default)([
                            "_syaz1hlo _y3gn1h6o _ect41pz4 _1wyb1tcg _k48p1fw0 _vwz41ul9 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                        ]),
                        style: {
                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                            "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_syaz1hlo _y3gn1h6o _ect4bzd7 _1wybo7ao _k48p1nn1 _vwz41gkc _ca0qftgi _u5f353f4 _n3td8ved _19bv53f4 _1eogftgi _qjx310yn _1cel10yn _5n7a10yn"
                        ]),
                        style: {
                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                        },
                        children: description
                    })
                ]
            })
        ]
    });
};
const $f45432a6ddb75a8d$var$cardStyle = null;
const $f45432a6ddb75a8d$var$titleStyles = null;
const $f45432a6ddb75a8d$var$descriptionStyles = null;
const $f45432a6ddb75a8d$var$imageContainerStyle = null;

});

parcelRegister("79Fc3", function(module, exports) {

$parcel$export(module.exports, "TestimonialCard", function () { return $e23554c3f6ab95ff$export$a34a40ba0fc7f13f; });
/* testimonial-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $cssyA = parcelRequire("cssyA");
const $e23554c3f6ab95ff$export$e4a9ef29ffd77837 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqswstnw _1bsb9by0 _rjxp4l2f _152t1vmu _1mjbglyw"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cssyA.Picture), {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8egyb3e0hgar3nj26we824nso1lfh124.webp",
                alt: "",
                width: 78,
                height: 47
            }
        })
    });
};
const $e23554c3f6ab95ff$export$8c97d8ed71074b34 = ({ image: image })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_ahbq1hnc _1pfh1hnc _mezj1w6l _bna75k64"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cssyA.Picture), {
            image: {
                src: image,
                alt: "",
                width: 255,
                height: 238
            }
        })
    });
};
const $e23554c3f6ab95ff$export$a34a40ba0fc7f13f = ({ image: image, quote: quote, name: name, title: title })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)($e23554c3f6ab95ff$export$e4a9ef29ffd77837, {}),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _syazr3uz _p12f1kqb _85i510yn _bfhku67f _2rko1uj0 _1gde1bp4 _1rkbjwe6"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)($e23554c3f6ab95ff$export$8c97d8ed71074b34, {
                        image: image
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1bsb17ek _ahbq16gx _1qoxo7ao _suga1txw _1gde1bp4 _nssp1h6o _chtu1ou6 _v7361ou6"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                                className: (0, $esG4f.default)([
                                    "_1wyb1k92 _syaz1yn5 _ect41td8 _1rkbncxg _q5ug1pa9 _7tld182x _14adidpf _4uroidpf _1cqsgktf _1bys1f4h _18ghnl7k _chtu1ou6",
                                    "quote"
                                ]),
                                children: [
                                    "\u201C",
                                    quote,
                                    "\u201D"
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("hr", {
                                className: (0, $esG4f.default)([
                                    "_1bsb19n7 _4t3it94y _syaz9sh9 _19pk7vkz _2hwxidpf _otyridpf _18u0idpf _1rfmajfg"
                                ])
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                className: (0, $esG4f.default)([
                                    "_1wybqgp8 _k48pni7l _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "name"
                                ]),
                                children: name
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                className: (0, $esG4f.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wybgktf _ui901hgu _62c41qje _1jw81nn1 _1bys1tcg _1rkb1rr2",
                                    "title"
                                ]),
                                children: title
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $e23554c3f6ab95ff$var$cardContainerStyles = null;
const $e23554c3f6ab95ff$var$testimonialQuoteImageStyles = null;
const $e23554c3f6ab95ff$var$testimonialQuotesSectionStyles = null;
const $e23554c3f6ab95ff$var$customerImagePictureStyles = null;
const $e23554c3f6ab95ff$var$quoteContainerStyles = null;
const $e23554c3f6ab95ff$var$quoteStyles = null;
const $e23554c3f6ab95ff$var$hrContainerStyles = null;
const $e23554c3f6ab95ff$var$nameStyles = null;
const $e23554c3f6ab95ff$var$titleStyles = null;

});

parcelRegister("bwq2g", function(module, exports) {

$parcel$export(module.exports, "LogoBanner", function () { return $4afbd21e59168ba3$export$f856413bacaabd31; });
/* logo-banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("Tf71T");
var $ffaCM = parcelRequire("ffaCM");
var $3VOWJ = parcelRequire("3VOWJ");
var $aWQH0 = parcelRequire("aWQH0");
var $kZdUe = parcelRequire("kZdUe");
var $ZNKQZ = parcelRequire("ZNKQZ");
var $eYMfY = parcelRequire("eYMfY");
const $4afbd21e59168ba3$var$svgArray = [
    (0, $ffaCM.NasaLogo),
    (0, $3VOWJ.AirCanadaLogo),
    (0, $aWQH0.VisaLogo),
    (0, $kZdUe.CanvaLogo),
    (0, $ZNKQZ.DominosLogo),
    (0, $eYMfY.FordLogo)
];
const $4afbd21e59168ba3$export$f856413bacaabd31 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_bfhk1hxd _mkrztcy0 _1qv2ewaa"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
            className: (0, $esG4f.default)([
                "_qtt8glyw _ca0qys9h _u5f3idpf _n3tdys9h _19bvidpf _tzy415iw _p12f2w76 _19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1txw _2lx2vrvc _4cvr1h6o _1bahitcz _1eog1ul9 _qjx3idpf _1cel1ul9 _5n7aidpf _liwc11p5 _13gz16hb _9et11h6o _17sl19q2 _4pgi1hwe _1fu1116b _eulesxk5 _tme71sp7 _1odz101s _r5d653f4 _b3uv1f06 _1avyys9h"
            ]),
            children: $4afbd21e59168ba3$var$svgArray.map((Component, idx)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                    id: `item-${idx}`,
                    className: (0, $esG4f.default)([
                        "_syaz1yg0 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _cjbs1ylp _12ra68cl"
                    ]),
                    style: {
                        "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800"))
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)(Component, {})
                }, idx))
        })
    });
};
$4afbd21e59168ba3$export$f856413bacaabd31.displayName = "LogoBanner";
const $4afbd21e59168ba3$var$logoBannerStyles = null;
const $4afbd21e59168ba3$var$logoContainerStyles = null;
const $4afbd21e59168ba3$var$logoStyles = null;

});

parcelRegister("9lQ9Q", function(module, exports) {

$parcel$export(module.exports, "Header", function () { return $a292fdf7f0ef6a0e$export$8b251419efc915eb; });
/* header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $i8kxh = parcelRequire("i8kxh");

var $91nJf = parcelRequire("91nJf");

var $3LLDq = parcelRequire("3LLDq");

var $dhmEV = parcelRequire("dhmEV");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");
const $a292fdf7f0ef6a0e$export$8b251419efc915eb = ()=>{
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).JIRA_SOFTWARE,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: "/try/cloud/signup?bundle=jira-software"
    });
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const subHeading = formatMessage({
        id: "jira-product-tour.hero-header.sub-header-text",
        defaultMessage: "The only project management tool you need to plan and track work across every team."
    });
    const buttonText = formatMessage({
        id: "jira-product-tour.hero-header.button-text",
        defaultMessage: "Get Jira free"
    });
    const mainHeading = formatMessage({
        id: "jira-product-tour.hero-header.header-text",
        defaultMessage: "<strong>Great outcomes</strong> start with <em>Jira</em>"
    }, {
        strong: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                className: (0, $esG4f.default)([
                    "_k48p8n31 _1e0c1ule _181n1nu9"
                ]),
                children: text
            }),
        em: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)("em", {
                className: (0, $esG4f.default)([
                    "_zg8l4jg8 _kqswh2mm _3p6m49fr _1v5vmgnk _19h91f51 _aetrb3bt _1qdggktf _1gufd439 _1czd12gs _g0nfmyb0 _18postnw _14tt14id _1ruvyjp0"
                ]),
                children: text
            })
    });
    const handleClick = (e)=>{
        if (openCrossFlow) openCrossFlow(e);
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c11p5 _6a6z1h6o _1q51vbgk _jzgezwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_syaz1hlo _1wyb14no _k48p4jg8 _vwz41gnr _19pkidpf _2hwx1crf _otyr1crf _18u01crf _y3gn1h6o _flz0ckbl _fz891k4y"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                },
                children: mainHeading
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_ect4bzd7 _k48p1nn1 _1wybgktf _vwz41f4h _y3gn1h6o _syaz1hlo _ca0qidpf _u5f39by0 _n3td1ylp _19bv9by0 _so7d7vkz _19q11ou6 _tl28idpf _axwix19p _1hwc1ylp _sp8tx19p"
                ]),
                style: {
                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                },
                children: subHeading
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dhmEV.default), {
                intentType: "button",
                containerId: "heroSection",
                productKey: "jira-software.ondemand",
                edition: "free",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                    onClick: handleClick,
                    href: (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-software"),
                    variant: "primary",
                    size: "large",
                    color: "blue",
                    dataEventProps: {
                        "data-product-key": "jira",
                        "data-event": "clicked",
                        "data-event-component": "button",
                        "data-event-container": "heroSection",
                        "data-label": "get-jira-free",
                        "data-label-english": "Get Jira Free",
                        "data-track-event": "jira-pt.hero-cta.get-jira-free"
                    },
                    children: buttonText
                })
            })
        ]
    });
};
const $a292fdf7f0ef6a0e$var$sectionStyles = null;
const $a292fdf7f0ef6a0e$var$subheadingStyles = null;
const $a292fdf7f0ef6a0e$var$mainHeadingStyles = null;
const $a292fdf7f0ef6a0e$var$mainHeadingStrongStyles = null;
const $a292fdf7f0ef6a0e$var$mainHeadingEmStyles = null;

});

parcelRegister("i9Hfh", function(module, exports) {

$parcel$export(module.exports, "HeroCards", function () { return $cd47a200a284685b$export$fd47e26e7f1281cb; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $4LHd8 = parcelRequire("4LHd8");

var $5ohHq = parcelRequire("5ohHq");

var $fkaMJ = parcelRequire("fkaMJ");

var $hj5uN = parcelRequire("hj5uN");

var $4XbYD = parcelRequire("4XbYD");

var $5cYgp = parcelRequire("5cYgp");

var $dkr6a = parcelRequire("dkr6a");
const $cd47a200a284685b$export$fd47e26e7f1281cb = ()=>{
    const intl = (0, $f6qj2.default)();
    const itModalUpdate = (0, $4LHd8.default).checkGate("it-copy-and-image-update");
    const softwareCard = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-cards-software-development-card.eyebrow-text",
            defaultMessage: "product & issue tracking"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-cards-software-development-card.title-text",
            defaultMessage: "Software Development"
        }),
        image: (0, $fkaMJ.getHeroCardSoftwareDevelopmentImage)(intl.locale),
        BackgroundImage: (0, $4XbYD.OrangeCard),
        label: "software-development"
    };
    const marketingCard = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-cards-marketing-card.eyebrow-text",
            defaultMessage: "plan & launch campaigns"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-cards-marketing-card.title-text",
            defaultMessage: "Marketing"
        }),
        image: (0, $fkaMJ.getHeroCardMarketingImage)(intl.locale),
        BackgroundImage: (0, $4XbYD.PurpleCard),
        label: "marketing"
    };
    const itCard = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-cards-it-card.eyebrow-text",
            defaultMessage: "manage & track requests"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-cards-it-card.title-text",
            defaultMessage: "IT"
        }),
        image: (0, $fkaMJ.getHeroCardItImage)(intl.locale),
        BackgroundImage: (0, $4XbYD.GreenCard),
        label: "it"
    };
    const updatedItCard = (0, $6iHNw._)((0, $7Knp0._)({}, itCard), {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-cards-it-card.updated-eyebrow-text",
            defaultMessage: "plan & track it projects"
        })
    });
    const designCard = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-cards-design-card.eyebrow-text",
            defaultMessage: "build creative workflows"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-cards-design-card.title-text",
            defaultMessage: "Design"
        }),
        image: (0, $fkaMJ.getHeroCardDesignImage)(intl.locale),
        BackgroundImage: (0, $4XbYD.BlueCard),
        label: "design"
    };
    const operationsCard = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-cards-operations-card.eyebrow-text",
            defaultMessage: "create custom processes"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-cards-operations-card.title-text",
            defaultMessage: "Operations"
        }),
        image: (0, $fkaMJ.getHeroCardOperationsImage)(intl.locale),
        BackgroundImage: (0, $4XbYD.BlackCard),
        label: "operations"
    }; // @ts-ignore
    const finalUpdatedItCard = itModalUpdate ? updatedItCard : itCard;
    const heroCardText = [
        softwareCard,
        marketingCard,
        updatedItCard,
        designCard,
        operationsCard
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dkr6a.HeroContextProvider), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx2vrvc _1bah1y6m _1bsb1osq _p12f1ns9 _zulp7vkz _1reo1wug _12l21wug _ahbq1wug _ca0qvbgk _u5f319bv _n3td19bv _19bv19bv _a5o9coo4 _jzge1l27 _105s1y6m _2g9e19bv _1rwy1l7b _1w1e15zi _z6961l7b"
            ]),
            style: {
                "--_1mbq9ci": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark800"))
            },
            children: [
                heroCardText.map((card, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $hj5uN.HeroCard), {
                        eyebrow: card.eyebrow,
                        title: card.title,
                        image: card.image,
                        BackgroundImage: card.BackgroundImage,
                        idx: index,
                        label: card.label
                    }, index)),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $5cYgp.JswProductModalCarousel), {})
            ]
        })
    });
};
const $cd47a200a284685b$var$heroCardsStyling = null;

});
parcelRegister("hj5uN", function(module, exports) {

$parcel$export(module.exports, "HeroCard", function () { return $34f60c54b10100c8$export$57301f0520e516bf; });
/* hero-card.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/no-block-disable-of-nested-eslint */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $cssyA = parcelRequire("cssyA");

var $5ohHq = parcelRequire("5ohHq");

var $dkr6a = parcelRequire("dkr6a");
const $34f60c54b10100c8$export$57301f0520e516bf = ({ eyebrow: eyebrow, title: title, image: image, BackgroundImage: BackgroundImage, idx: idx, label: label })=>{
    const { openModal: openModal } = (0, $dkr6a.useHeroState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const intl = (0, $f6qj2.default)();
    const handleClick = ()=>{
        openModal(idx);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: `atlas-55799-${label}-modal-opened`,
                section: "hero-section"
            }
        }).fire();
    };
    const eyebrowText = intl.locale === "en" ? eyebrow : "";
    return /*#__PURE__*/ (0, $loA2J.jsxs)("button", {
        onClick: handleClick,
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _1bah1yb4 _y3gn1e5h _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _2rkoqslr _c71l1kdj _1ul9gx0z _11q7cd5j _16qszucj _80omtlke _v564188d _1reozryt _18m9zryt _1i7qgx0z _5jif1dft _1ii31cd0 _hzy51qv5 _1lsjkb7n _c1lpkb7n _mlnj1xcn _1y8o122m _123rnklw"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_bozg1u1b"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_syaz1hlo _ect41qje _1wyb1crf _k48p1nn1 _vwz47vkz _1dyz1wr8 _1p1dangw _1q511pa9 _3fcw1q9c _1bysw1gv _1rfmn6wy"
                        ]),
                        style: {
                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                        },
                        children: eyebrowText
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _1bsbzdsj _syaz1hlo _ect41qje _1wyb1tcg _k48p1fw0 _vwz41ul9 _1q511v6z _slp31hna _ct361wug _1bah1yb4 _zzrmn6wy _1gdl1oqx _1p1d1tcg _1r3wgktf _ui901hlo _1jw8ni7l _1bys1f4h"
                        ]),
                        style: {
                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                        },
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _18m9zryt _c71l1kdj"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)(BackgroundImage, {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_2rkoqslr _15801u1b _f45rstnw _dgw6idpf _1hlvidpf"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cssyA.Picture), {
                            image: {
                                src: image,
                                width: 227,
                                height: 364,
                                alt: "",
                                loading: "eager"
                            }
                        })
                    })
                ]
            })
        ]
    });
};
const $34f60c54b10100c8$var$cardStyles = null;
const $34f60c54b10100c8$var$textStyles = null;
const $34f60c54b10100c8$var$eyebrowStyles = null;
const $34f60c54b10100c8$var$titleStyles = null;
const $34f60c54b10100c8$var$imageContainer = null;
const $34f60c54b10100c8$var$pictureStyles = null;

});
parcelRegister("dkr6a", function(module, exports) {

$parcel$export(module.exports, "useHeroState", function () { return $19d01614a6de30f2$export$e2b31be5fe4d64c8; });
$parcel$export(module.exports, "HeroContextProvider", function () { return $19d01614a6de30f2$export$b1ebf81440d0ff8d; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $19d01614a6de30f2$var$initVal = {
    modalIndex: -1,
    closeModal: ()=>-1,
    openModal: ()=>0
};
const $19d01614a6de30f2$export$63ebd153bf781d5f = /*#__PURE__*/ (0, $iSvIT.createContext)($19d01614a6de30f2$var$initVal);
const $19d01614a6de30f2$export$e2b31be5fe4d64c8 = ()=>{
    return (0, $iSvIT.useContext)($19d01614a6de30f2$export$63ebd153bf781d5f);
};
const $19d01614a6de30f2$export$b1ebf81440d0ff8d = ({ children: children })=>{
    const [modalIndex, setModalIndex] = (0, $iSvIT.useState)(-1);
    const openModal = (num)=>setModalIndex(num);
    const closeModal = ()=>setModalIndex(-1);
    return /*#__PURE__*/ (0, $loA2J.jsx)($19d01614a6de30f2$export$63ebd153bf781d5f.Provider, {
        value: {
            modalIndex: modalIndex,
            openModal: openModal,
            closeModal: closeModal
        },
        children: children
    });
};

});


parcelRegister("4XbYD", function(module, exports) {

$parcel$export(module.exports, "OrangeCard", function () { return $f3527aef46806cf2$export$b9f0637fcee76583; });
$parcel$export(module.exports, "PurpleCard", function () { return $f3527aef46806cf2$export$265c26304bb77354; });
$parcel$export(module.exports, "GreenCard", function () { return $f3527aef46806cf2$export$961a018b253e0f90; });
$parcel$export(module.exports, "BlueCard", function () { return $f3527aef46806cf2$export$294f4b24111c26a1; });
$parcel$export(module.exports, "BlackCard", function () { return $f3527aef46806cf2$export$89725581676ad6dc; });

var $loA2J = parcelRequire("loA2J");
const $f3527aef46806cf2$export$b9f0637fcee76583 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        style: {
            transition: "400ms"
        },
        opacity: "0",
        width: "260",
        height: "100%",
        viewBox: "0 0 260 392",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M190 10.1105L287 0.5V551.5H190V10.1105Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                y: "309.5",
                width: "72",
                height: "242",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M12 174L242 93.5V551.5H33.7079L12 174Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M91.3757 345.607C94.4326 316.532 72.821 353.827 66.5766 359.591C66.6744 349.361 70.2219 339.822 71.6661 329.54C71.4521 329.774 71.4286 329.07 71.6094 328.451C73.7067 306.146 55.5882 335.822 52.852 342.965C52.8571 342.947 53.3076 341.612 53.3161 341.582C31.2979 381.303 52.5372 327.158 50.7712 312.8C48.0114 301.66 39.0231 319.691 36.7403 323.74C31.7817 332.292 13.1954 371.804 21.3158 339.578L21.2302 339.793L21.2235 339.686C19.9412 343.752 15.1863 361.553 23.3964 349.43C10.382 367.677 25.8305 321.339 26.8121 316.021C26.1187 322.416 23.5003 329.295 23.3121 331.581C41.6247 260.152 8.32378 331.528 -3.15113 344.753C-3.42866 340.861 -2.2046 336.52 -1.45501 332.791C-1.98174 333.871 -3.12206 341.129 -3.73261 342.354C-3.72327 338.625 1.46654 318.867 -0.581947 328.733C-0.457885 325.429 13.7951 290.239 0.489425 297.317C-9.28835 307.87 -13.5004 323.636 -23.888 333.64C-27.6163 327.225 -8.20945 290.969 -22.1535 295.019C-27.7263 298.074 -47.3766 333.181 -43.7036 312.264C-42.1393 303.197 -44.4527 311.487 -45.0251 315.266C-45.0595 314.841 -45.0769 314.422 -45.0925 313.996C-47.299 337.542 -24.8339 295.427 -19.3444 295.729C-19.8045 309.234 -37.4438 360.038 -12.0674 320.742C-12.162 320.968 -12.767 322.392 -12.8497 322.576C-9.19942 319.69 -2.36649 297.801 4.10625 299.033C4.95454 300.683 2.22361 313.34 3.286 305.572C-18.0291 379.053 3.4966 342.697 25.4581 304.882C28.5782 319.533 11.6245 341.427 18.0739 356.474C32.5546 349.034 35.4669 325.194 47.1207 313.346C48.9171 319.068 44.6492 329.85 43.4684 336.596L43.6763 336.143C36.233 364.657 39.9023 372.572 56.209 341.886C58.3648 338.768 71.6989 313.331 68.9071 329.746C59.4974 378.571 64.4338 364.369 88.6115 336.779C92.4748 337.752 87.4444 359.722 91.3626 345.61L91.3757 345.607Z",
                fill: "#101214"
            })
        ]
    });
};
const $f3527aef46806cf2$export$265c26304bb77354 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        style: {
            transition: "400ms"
        },
        opacity: "0",
        width: "260",
        height: "100%",
        viewBox: "0 0 260 391",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M190 88.1977L287 80V550H190V88.1977Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                y: "245",
                width: "72",
                height: "305",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M18.5 0L261 16V550H35.5011L18.5 0Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M32.3957 245.058C33.5425 244.959 48.888 241.246 44.8628 240.44C43.3696 240.859 42.2092 240.436 41.4627 241.57C41.2468 240.233 38.3189 242.367 37.8691 242.448C37.6668 241.435 33.0793 244.041 33.7494 243.1C31.6671 243.127 29.081 243.856 26.3915 244.712C25.0737 243.816 30.7226 237.425 28.3479 238.807C28.5143 238.446 29.153 236.889 29.0675 237.92C29.8186 237.038 37.9951 223.535 34.595 225.822C32.3012 228.608 30.5787 233.275 28.6358 235.58C26.7468 236.358 25.438 243.046 23.3332 242.38C22.1054 240.877 18.9391 222.469 16.6904 224.103C17.0817 225.534 16.7264 226.816 17.8193 227.505C16.4835 227.721 18.6153 230.651 18.6963 231.101C17.7068 231.29 20.2704 235.899 19.3484 235.224C19.3664 236.525 19.6587 238.028 20.0815 239.626C19.5193 239.198 18.9032 238.221 18.5479 238.077C14.761 236.543 11.8915 233.014 7.94723 231.101C4.63257 235.327 33.9428 245.99 15.7684 247.583C12.3503 249.815 7.8078 250.157 3.99392 252.304C3.6656 256.954 25.4066 244.126 19.1325 251.494C18.1566 254.609 16.7084 258.106 14.707 261.175C13.4297 272.882 24.2912 241.079 23.8414 253.213C25.3391 256.112 26.7873 259.605 27.5294 263.201C32.8409 270.996 25.591 250.374 24.8309 247.453C27.7093 246.224 38.8361 260.158 40.851 257.962C40.9454 257.651 39.3443 255.927 38.8586 255.743C38.5303 255.909 38.3639 256.044 38.1705 255.738C39.1464 254.798 35.7238 253.61 35.4 253.286C36.1196 252.57 31.3568 250.243 32.5126 250.279C31.6221 249.032 30.2594 247.777 28.7077 246.512C31.4602 245.981 32.6565 244.036 32.4047 245.049L32.3957 245.058Z",
                fill: "#101214"
            })
        ]
    });
};
const $f3527aef46806cf2$export$961a018b253e0f90 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        style: {
            transition: "400ms"
        },
        opacity: "0",
        width: "260",
        height: "100%",
        viewBox: "0 0 260 409",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M75.9004 26.5L287.4 0.5V569H119.4L75.9004 26.5Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M-5.59961 311L67.4004 286L72.4004 568.5H0.400391L-5.59961 311Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M9.40039 151L242.4 110.5V568.5H34.1083L21.4004 352L9.40039 151Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M38.8986 132.781C39.2166 132.221 36.9442 123.743 35.8543 126.325C35.3391 127.211 35.4683 127.971 36.3627 128.134C34.6953 128.569 37.0904 129.969 36.6079 130.815C35.405 130.663 38.0687 132.76 36.8029 132.437C36.3425 141.913 49.4139 159.478 40.5422 137.288C40.2112 139.625 39.5574 137.525 39.7288 136.473C41.3639 137.777 39.6836 133.639 39.0942 132.906C39.2394 134.228 37.9371 132.161 38.895 132.785L38.8986 132.781Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M26.0831 151.179C25.9033 149.969 17.1793 145.733 16.3356 145.174C14.3049 144.321 14.3929 147.139 16.0855 147.422C16.3879 147.621 18.8106 148.168 17.851 148.841C18.5768 151.171 22.8129 151.064 23.2479 153.049C23.7743 152.669 24.4966 153.313 24.8533 153.111C24.8407 153.717 25.6701 153.967 25.7296 153.816C28.0241 156.156 30.1997 152.73 27.1018 151.667C27.2204 151.551 26.6349 150.91 26.0911 151.178L26.0831 151.179Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M13.214 183.803C14.6822 184.753 13.2253 184.829 12.5136 184.357C13.6609 183.246 10.784 183.546 10.075 183.952C10.379 183.982 10.4712 184.496 9.84193 184.471C10.3094 183.168 2.35086 182.948 6.04574 185.633C6.18193 185.627 6.26697 184.6 6.41885 184.919C6.11372 186.476 7.39131 185.384 7.74683 185.263C7.71942 186.071 8.07319 185.319 8.154 185.653C7.69634 186.742 9.77517 184.913 9.26035 185.992C11.045 187.634 14.7083 185.435 16.0664 186.932C17.0725 185.111 22.8461 187.798 20.677 184.338C18.1787 183.565 16.1276 183.133 13.214 183.803Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M-1.49997 165.314C-2.19099 167.811 3.30413 167.242 4.76979 168.257C6.53807 169.708 25.7928 174.672 20.8767 169.788C15.0359 168.335 10.5165 166.116 3.19864 165.256C2.02145 165.029 -1.61684 163.57 -1.49997 165.314Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M57.4411 142.901C59.4435 144.317 56.8745 146.385 58.5173 147.732C61.6811 149.754 63.1253 131.281 59.8252 131.898C57.053 132.811 58.6706 141.577 57.4411 142.901Z",
                fill: "#101214"
            })
        ]
    });
};
const $f3527aef46806cf2$export$294f4b24111c26a1 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        style: {
            transition: "400ms"
        },
        opacity: "0",
        width: "260",
        height: "100%",
        viewBox: "0 0 260 399",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                x: "-0.199219",
                y: "280",
                width: "72",
                height: "278",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M11.8008 138.97L241.801 109V558H33.5086L11.8008 138.97Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M90.8008 21.5233L280.801 0.5L286.801 558H90.8008V21.5233Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M55.8008 315.386C53.0837 310.928 56.2763 303.048 51.8894 298.79C43.0193 295.942 41.3834 312.505 35.5983 314.656C32.9661 310.471 35.7511 304.135 32.4397 299.771C32.5982 299.877 33.1077 300.429 33.1643 300.501C24.464 290.96 21.5771 313.413 14.9939 314.74C12.2316 310.148 16.8959 297.698 8.42202 298.227C3.07847 298.305 -3.06324 320.558 -6.14824 312.979L-6.15955 313.085L-6.19918 313.046C-5.89917 318.446 -1.16129 312.449 -0.312218 310.755C-7.56903 324.119 -7.16713 307.244 -7.90866 301.114C-6.45956 302.736 -7.05958 307.188 -6.56711 309.106C-6.63504 285.705 -18.9581 306.263 -24.5846 314.506C-28.5753 314.305 -25.6828 304.787 -27.4545 301.66C-27.3526 302.329 -26.6847 306.113 -27.3413 306.849C-27.5168 304.079 -27.3583 298.222 -31.666 298.929C-31.2244 298.021 -29.0621 298.929 -28.813 299.347C-37.836 295.084 -39.0303 313.202 -46.089 314.79C-48.1438 310.075 -45.54 304.045 -48.4155 299.403C-56.7761 290.498 -65.867 327.608 -67.401 309.49C-67.8708 305.834 -66.5066 299.431 -71.1992 298.801C-70.4577 299.23 -68.7992 300.384 -68.8897 302.179C-69.0143 301.989 -69.1331 301.8 -69.2577 301.621C-67.984 306.397 -70.1294 311.513 -67.8595 316.01C-61.9669 321.533 -56.0403 297.86 -50.0684 300.228C-47.6117 303.293 -49.3722 308.353 -48.7495 312.02C-48.7948 311.903 -49.0212 311.145 -49.0608 311.045C-47.4249 328.622 -35.8887 303.388 -37.0152 307.149C-22.5185 284.546 -36.5567 329.725 -20.8487 314.974C-17.1467 311.914 -14.8711 300.172 -9.98608 301.738C-9.32946 307.79 -9.0068 325.211 0.0557327 313.943C3.46905 310.17 4.82756 302.151 9.87677 301.036C12.5542 305.767 8.05408 322.286 18.4412 316.936C18.3393 316.975 18.2431 317.019 18.1355 317.058C22.347 315.609 26.632 296.137 31.0472 302.006C32.751 305.818 29.5415 316.791 36.1077 317.119C41.8532 316.646 47.7289 292.587 51.7761 303.522C52.512 306.13 52.1837 317.654 55.7894 315.37L55.8008 315.386Z",
                fill: "#101214"
            })
        ]
    });
};
const $f3527aef46806cf2$export$89725581676ad6dc = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        style: {
            transition: "400ms"
        },
        opacity: "0",
        width: "260",
        height: "100%",
        viewBox: "0 0 260 428",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M190.199 46.1105L287.199 36.5V587.5H190.199V46.1105Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                x: "0.199219",
                y: "345.5",
                width: "72",
                height: "242",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M12.1992 210L242.199 129.5V587.5H33.9071L12.1992 210Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M264.513 26.5943C264.532 26.5625 264.532 26.5053 264.57 26.4609C263.451 25.9017 263.323 24.5292 262.46 23.7096L262.428 23.6778C261.552 23.3982 261.789 22.5277 260.702 22.5213C260.702 22.5213 260.983 22.3815 260.99 22.3815C259.225 20.6405 254.864 16.3642 254.864 16.3642C254.768 16.7518 255.561 16.0782 256.36 16.1926C256.36 16.1926 256.418 16.0465 256.475 16.1609C258.515 14.1848 260.811 13.4286 263.419 12.4882C264.724 12.1387 264.922 8.47237 262.69 9.991C262.665 9.96558 262.607 9.94659 262.582 9.90211C261.802 10.8044 260.504 10.4739 259.519 10.9441L259.481 10.9632L257.844 11.7575C256.955 12.1196 255.9 12.4056 254.794 12.6852C254.826 12.6534 254.858 12.6217 254.89 12.5899C254.89 12.5899 255.005 10.8298 254.973 9.95927C254.973 9.95927 256.092 8.5614 255.721 7.60193C256.354 6.47725 258.605 4.01814 256.559 3.31919C255.887 3.31919 255.363 2.74099 255.133 3.81483C255.094 3.80848 255.043 3.82117 254.992 3.80211C254.871 4.91408 253.547 5.702 253.183 6.75678L253.17 6.8013C253.259 7.70359 252.556 8.59313 252.55 8.59313C252.217 9.41916 251.782 10.3214 251.322 11.2618C251.13 10.7535 250.919 10.3024 250.708 9.97836C249.941 9.15232 250.267 -2.13257 247.428 0.358238C247.563 2.48686 248.24 4.70441 247.69 6.59793C247.422 6.74407 247.831 7.50022 248.164 8.11657C248.138 8.89812 247.978 9.31751 247.933 10.4358C246.527 9.42553 240.389 4.3105 240.766 7.75442C241.424 8.1039 241.904 8.50418 242.249 9.3175C242.569 9.66698 245.389 11.2428 245.478 11.6368C245.293 12.1832 248.624 12.6216 247.275 13.0283C247.473 13.4604 247.742 13.8734 248.055 14.2737C246.597 14.4262 244.852 14.8519 243.937 15.4047C243.777 15.6779 237.959 16.0465 235.849 17.3999C234.589 18.1052 233.477 18.4547 234.788 19.5159C235.261 19.1346 237.038 19.6811 237 19.1791C237.435 19.357 240.376 18.2386 240.702 18.4293C240.862 18.6834 243.176 17.3364 242.901 17.9718C244.506 18.4229 246.463 18.0544 248.496 17.5397C247.69 18.8105 246.898 20.6214 246.795 21.7461C246.105 23.1885 244.282 26.3783 243.701 28.3354C242.869 29.7587 243.157 29.873 244.206 30.6037L244.225 30.6228C244.442 30.769 244.199 30.6228 245.024 30.6545C244.941 30.5783 244.82 30.2479 244.66 30.3051C244.768 30.0827 246.022 29.765 245.497 29.4663C245.478 29.4219 246.297 28.7992 246.38 28.1256C247.109 25.7238 248.854 24.5101 250.146 21.7715C250.114 22.0575 252.288 27.4394 252.185 30.1208C252.025 31.4425 255.248 33.4123 254.781 30.464C254.82 30.4513 254.851 30.4004 254.909 30.3941C254.391 29.1805 255.075 27.9286 254.807 26.696L254.794 26.6451C254.212 25.8954 254.883 25.2727 253.963 24.6627C253.963 24.6627 254.276 24.6944 254.282 24.7008C253.873 22.9534 253.617 20.8184 253.234 18.9058C254.609 20.1449 255.817 21.4792 256.316 22.947L256.38 22.8518C256.38 22.8962 256.475 22.928 256.392 23.0296C257.55 23.2711 257.946 23.754 258.784 24.0781C258.784 24.0781 259.679 25.6857 260.721 25.7428L262.307 27.9731C262.991 29.1232 266.68 28.4624 264.538 26.6197L264.513 26.5943Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("5cYgp", function(module, exports) {

$parcel$export(module.exports, "JswProductModalCarousel", function () { return $8fe6efeb0eceb4e9$export$e7364013ca7b67b5; });
/* product-modal-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $4LHd8 = parcelRequire("4LHd8");

var $kbkBb = parcelRequire("kbkBb");

var $9LKVP = parcelRequire("9LKVP");

var $8A4p1 = parcelRequire("8A4p1");

var $9Ltn5 = parcelRequire("9Ltn5");

var $hDVVP = parcelRequire("hDVVP");

var $bzMno = parcelRequire("bzMno");

var $42MLU = parcelRequire("42MLU");

var $gSc26 = parcelRequire("gSc26");

var $ieXtC = parcelRequire("ieXtC");

var $ixaDK = parcelRequire("ixaDK");

var $aOabo = parcelRequire("aOabo");

var $49i1j = parcelRequire("49i1j");

var $8Dgsy = parcelRequire("8Dgsy");

var $3FBn4 = parcelRequire("3FBn4");

var $aBBZY = parcelRequire("aBBZY");

var $fkaMJ = parcelRequire("fkaMJ");

var $cmE4B = parcelRequire("cmE4B");

var $8ZhzG = parcelRequire("8ZhzG");

var $7qjEF = parcelRequire("7qjEF");

var $dkr6a = parcelRequire("dkr6a");
const $8fe6efeb0eceb4e9$export$e7364013ca7b67b5 = ()=>{
    const { modalIndex: modalIndex } = (0, $dkr6a.useHeroState)();
    const intl = (0, $f6qj2.default)();
    const itModalUpdate = (0, $4LHd8.default).checkGate("it-copy-and-image-update"); // Disable scroll if modal is open
    (0, $iSvIT.useEffect)(()=>{
        if (modalIndex !== -1) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "unset";
    }, [
        modalIndex
    ]);
    const softwareModal = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-modal-software-development.eyebrow-text",
            defaultMessage: "product and issue tracking"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-modal-software-development.title-text",
            defaultMessage: "Software Development"
        }),
        description: intl.formatMessage({
            id: "jira-product-tour.hero-modal-software-development.description-text",
            defaultMessage: "Plan, track, release and support world-class software. Jira is the single source of truth for your entire development lifecycle."
        }),
        image: (0, $fkaMJ.getProductSoftwareDevelopmentModalImage)(intl.locale),
        iconCollection: [
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bzMno))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-software-development-icon-analytics.icon-text",
                    defaultMessage: "Analytics"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aOabo))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-software-development-icon-progress-tracking.icon-text",
                    defaultMessage: "Progress tracking"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42MLU))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-software-development-icon-sprint-planning.icon-text",
                    defaultMessage: "Sprint planning"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gSc26))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-software-development-icon-forms.icon-text",
                    defaultMessage: "Forms"
                })
            }
        ],
        BackgroundImage: (0, $cmE4B.OrangeModal),
        ctaLink: (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&jiraProductTourSignupType=software-development"),
        label: "software-development",
        personaData: {
            team: "Software Development",
            persona: "Software Development Generic"
        }
    };
    const marketingModal = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-modal-marketing.eyebrow-text",
            defaultMessage: "plan and launch campaigns"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-modal-marketing.title-text",
            defaultMessage: "Marketing"
        }),
        description: intl.formatMessage({
            id: "jira-product-tour.hero-modal-marketing.description-text",
            defaultMessage: "Make launching viral marketing campaigns a breeze. Break down complex campaigns into actionable steps, easily collect requests, and stay aligned with cross-functional teams."
        }),
        image: (0, $fkaMJ.getProductMarketingModalImage)(intl.locale),
        iconCollection: [
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kbkBb))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-marketing-icon-progress-tracking.icon-text",
                    defaultMessage: "Progress tracking"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9LKVP))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-marketing-icon-calendar-view.icon-text",
                    defaultMessage: "Calendar view"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gSc26))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-marketing-icon-forms.icon-text",
                    defaultMessage: "Forms"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Ltn5))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-marketing-icon-reporting.icon-text",
                    defaultMessage: "Reporting"
                })
            }
        ],
        BackgroundImage: (0, $cmE4B.PurpleModal),
        ctaLink: (0, $3FBn4.useLocalizedHref)(`/try/cloud/signup?bundle=jira-software&templateId=${(0, $aBBZY.TemplateKey).CampaignManagement}`),
        label: "marketing",
        personaData: {
            team: "Marketing",
            persona: "Marketing Generic"
        }
    };
    const itModal = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-modal-it.eyebrow-text",
            defaultMessage: "manage and track requests"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-modal-it.title-text",
            defaultMessage: "IT support services"
        }),
        description: intl.formatMessage({
            id: "jira-product-tour.hero-modal-it.description-text",
            defaultMessage: "Easily build custom forms, track requests, and fully automate your intake process. Communicate progress and collaborate directly on requests with internal stakeholders in one place."
        }),
        image: (0, $fkaMJ.getProductItModalImage)(intl.locale),
        iconCollection: [
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hDVVP))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-it-icon-resolve-incidents.icon-text",
                    defaultMessage: "Resolve incidents"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ieXtC))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-it-icon-help-desk.icon-text",
                    defaultMessage: "Help desk"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($49i1j))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-it-icon-manage-requests.icon-text",
                    defaultMessage: "Manage requests"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8A4p1))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-it-icon-reporting.icon-text",
                    defaultMessage: "Reporting"
                })
            }
        ],
        BackgroundImage: (0, $cmE4B.GreenModal),
        ctaLink: (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&jiraProductTourSignupType=it"),
        label: "it",
        personaData: {
            team: "IT Support",
            persona: "IT Support Generic"
        }
    };
    const updatedItModal = (0, $6iHNw._)((0, $7Knp0._)({}, itModal), {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-modal-it.updated-eyebrow-text",
            defaultMessage: "plan and track it projects"
        }),
        description: intl.formatMessage({
            id: "jira-product-tour.hero-modal-it.updated-description-text",
            defaultMessage: "Streamline IT projects and deliver reliable services to internal teams, from migration management to software deployment. Gain visibility across IT workflows to align technology projects to business goals."
        }),
        image: (0, $fkaMJ.getUpdatedProductItModalImage)(intl.locale),
        iconCollection: [
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aOabo))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-it-icon-resolve-incidents.updated-icon-text",
                    defaultMessage: "Progress tracking"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($49i1j))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-it-icon-help-desk.updated-icon-text",
                    defaultMessage: "Intake requests"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ixaDK))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-it-icon-manage-requests.updated-icon-text",
                    defaultMessage: "Release management"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8A4p1))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-it-icon-reporting.icon-text",
                    defaultMessage: "Reporting"
                })
            }
        ]
    });
    const designModal = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-modal-design.eyebrow-text",
            defaultMessage: "build creative workflows"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-modal-design.title-text",
            defaultMessage: "Design"
        }),
        description: intl.formatMessage({
            id: "jira-product-tour.hero-modal-design.description-text",
            defaultMessage: "Collaborate on, organize, and deliver creative requests with ease. Give real-time visibility into designs with Jira\u2019s Figma integration and accelerate approvals."
        }),
        image: (0, $fkaMJ.getProductDesignModalImage)(intl.locale),
        iconCollection: [
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kbkBb))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-design-task-planning.icon-text",
                    defaultMessage: "Task planning"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ieXtC))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-design-progress-tracking.icon-text",
                    defaultMessage: "Progress tracking"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($49i1j))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-design-prioritization.icon-text",
                    defaultMessage: "Prioritization"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Ltn5))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-design-forms.icon-text",
                    defaultMessage: "Forms"
                })
            }
        ],
        BackgroundImage: (0, $cmE4B.BlueModal),
        ctaLink: (0, $3FBn4.useLocalizedHref)(`/try/cloud/signup?bundle=jira-software&templateId=${(0, $aBBZY.TemplateKey).WebDesignProcess}`),
        label: "design",
        personaData: {
            team: "Design",
            persona: "Design Generic"
        }
    };
    const operationsModal = {
        eyebrow: intl.formatMessage({
            id: "jira-product-tour.hero-modal-operations.eyebrow-text",
            defaultMessage: "create intake processes"
        }),
        title: intl.formatMessage({
            id: "jira-product-tour.hero-modal-operations.title-text",
            defaultMessage: "Operations"
        }),
        description: intl.formatMessage({
            id: "jira-product-tour.hero-modal-operations.description-text",
            defaultMessage: "Manage procurement, office, and new vendor requests, craft new operational processes, monitor operational risks and more. Keep your company running at maximum efficiency with Jira."
        }),
        image: (0, $fkaMJ.getProductOperationsModalImage)(intl.locale),
        iconCollection: [
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kbkBb))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-operations-task-planning.icon-text",
                    defaultMessage: "Task planning"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aOabo))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-operations-progress-tracking.icon-text",
                    defaultMessage: "Progress tracking"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Dgsy))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-operations-prioritization.icon-text",
                    defaultMessage: "Prioritization"
                })
            },
            {
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gSc26))), {
                    size: "small",
                    label: ""
                }),
                description: intl.formatMessage({
                    id: "jira-product-tour.hero-modal-operations-forms.icon-text",
                    defaultMessage: "Forms"
                })
            }
        ],
        BackgroundImage: (0, $cmE4B.BlackModal),
        ctaLink: (0, $3FBn4.useLocalizedHref)(`/try/cloud/signup?bundle=jira-software&templateId=${(0, $aBBZY.TemplateKey).SimplifiedProcessControl}`),
        label: "operations",
        personaData: {
            team: "Operations",
            persona: "Operations Generic"
        }
    }; // @ts-ignore
    const finalItModal = itModalUpdate ? updatedItModal : itModal;
    const JswProductTourModalCards = [
        softwareModal,
        marketingModal,
        updatedItModal,
        designModal,
        operationsModal
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: modalIndex !== -1 && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $8ZhzG.ProductModalCarousel), {
                    children: JswProductTourModalCards.map((props, idx)=>{
                        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7qjEF.ProductModalCard), (0, $7Knp0._)({}, props), idx);
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_kqsw1n9t _1e02idpf _152tidpf _rjxpidpf _u7coidpf _1e0c1txw _4cvr1h6o _1bah1h6o _11q71sgx _1pbyzo7u _je3oglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7qjEF.ProductModalCard), (0, $7Knp0._)({}, JswProductTourModalCards[modalIndex]))
                })
            ]
        })
    });
};
const $8fe6efeb0eceb4e9$var$modalBackgroundStyles = null;

});
parcelRegister("kbkBb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb14d03462ea02a1$var$_react = $eb14d03462ea02a1$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $eb14d03462ea02a1$var$_listBulleted = $eb14d03462ea02a1$var$_interopRequireDefault((parcelRequire("89oGH")));
function $eb14d03462ea02a1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eb14d03462ea02a1$var$BulletListIcon = (props)=>/*#__PURE__*/ $eb14d03462ea02a1$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="10" y="15" rx="1"/><rect width="2" height="2" x="6" y="15" rx="1"/><rect width="8" height="2" x="10" y="11" rx="1"/><rect width="2" height="2" x="6" y="11" rx="1"/><rect width="8" height="2" x="10" y="7" rx="1"/><rect width="2" height="2" x="6" y="7" rx="1"/></g></svg>`
    }, props, {
        newIcon: $eb14d03462ea02a1$var$_listBulleted.default
    }));
$eb14d03462ea02a1$var$BulletListIcon.displayName = "BulletListIcon";
var $eb14d03462ea02a1$var$_default = module.exports.default = $eb14d03462ea02a1$var$BulletListIcon;

});
parcelRegister("89oGH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c464a7d95484e897372db9f1fff872cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ef250770984bd81$var$_react = $5ef250770984bd81$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $5ef250770984bd81$var$_baseNew = $5ef250770984bd81$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $5ef250770984bd81$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ef250770984bd81$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $5ef250770984bd81$var$_react.default.createElement($5ef250770984bd81$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$5ef250770984bd81$var$ListBulletedIcon.displayName = "ListBulletedIcon";
var $5ef250770984bd81$var$_default = module.exports.default = $5ef250770984bd81$var$ListBulletedIcon;

});


parcelRegister("9LKVP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $71cce87e5833f486$var$_react = $71cce87e5833f486$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $71cce87e5833f486$var$_calendar = $71cce87e5833f486$var$_interopRequireDefault((parcelRequire("7M1uQ")));
function $71cce87e5833f486$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $71cce87e5833f486$var$CalendarIcon = (props)=>/*#__PURE__*/ $71cce87e5833f486$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $71cce87e5833f486$var$_calendar.default
    }));
$71cce87e5833f486$var$CalendarIcon.displayName = "CalendarIcon";
var $71cce87e5833f486$var$_default = module.exports.default = $71cce87e5833f486$var$CalendarIcon;

});
parcelRegister("7M1uQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a8e2d490a0851af$var$_react = $5a8e2d490a0851af$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $5a8e2d490a0851af$var$_baseNew = $5a8e2d490a0851af$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $5a8e2d490a0851af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a8e2d490a0851af$var$CalendarIcon = (props)=>/*#__PURE__*/ $5a8e2d490a0851af$var$_react.default.createElement($5a8e2d490a0851af$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$5a8e2d490a0851af$var$CalendarIcon.displayName = "CalendarIcon";
var $5a8e2d490a0851af$var$_default = module.exports.default = $5a8e2d490a0851af$var$CalendarIcon;

});


parcelRegister("8A4p1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63f519c8ab72f6bb$var$_react = $63f519c8ab72f6bb$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $63f519c8ab72f6bb$var$_feedback = $63f519c8ab72f6bb$var$_interopRequireDefault((parcelRequire("llWxg")));
function $63f519c8ab72f6bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $63f519c8ab72f6bb$var$FeedbackIcon = (props)=>/*#__PURE__*/ $63f519c8ab72f6bb$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $63f519c8ab72f6bb$var$_feedback.default
    }));
$63f519c8ab72f6bb$var$FeedbackIcon.displayName = "FeedbackIcon";
var $63f519c8ab72f6bb$var$_default = module.exports.default = $63f519c8ab72f6bb$var$FeedbackIcon;

});
parcelRegister("llWxg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238518c984ab5d0530bd2cff7eccbeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8b8f712153f66c5$var$_react = $f8b8f712153f66c5$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $f8b8f712153f66c5$var$_baseNew = $f8b8f712153f66c5$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $f8b8f712153f66c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f8b8f712153f66c5$var$FeedbackIcon = (props)=>/*#__PURE__*/ $f8b8f712153f66c5$var$_react.default.createElement($f8b8f712153f66c5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$f8b8f712153f66c5$var$FeedbackIcon.displayName = "FeedbackIcon";
var $f8b8f712153f66c5$var$_default = module.exports.default = $f8b8f712153f66c5$var$FeedbackIcon;

});


parcelRegister("9Ltn5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $71bf4968771b6364$var$_react = $71bf4968771b6364$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $71bf4968771b6364$var$_file = $71bf4968771b6364$var$_interopRequireDefault((parcelRequire("jwsof")));
function $71bf4968771b6364$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $71bf4968771b6364$var$FileIcon = (props)=>/*#__PURE__*/ $71bf4968771b6364$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M17 10.005V19H7V5h5.99v2.49a1.5 1.5 0 0 0 1.5 1.5h4.5v-.522c0-.297-.132-.578-.359-.768l-5.074-4.236c-.36-.3-.813-.464-1.282-.464H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8.995z"/><rect width="8" height="2" x="8" y="12" rx="1"/><rect width="4" height="2" x="8" y="15" rx="1"/></g></svg>`
    }, props, {
        newIcon: $71bf4968771b6364$var$_file.default
    }));
$71bf4968771b6364$var$FileIcon.displayName = "FileIcon";
var $71bf4968771b6364$var$_default = module.exports.default = $71bf4968771b6364$var$FileIcon;

});
parcelRegister("jwsof", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e367072653dd9624$var$_react = $e367072653dd9624$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $e367072653dd9624$var$_baseNew = $e367072653dd9624$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $e367072653dd9624$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e367072653dd9624$var$FileIcon = (props)=>/*#__PURE__*/ $e367072653dd9624$var$_react.default.createElement($e367072653dd9624$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$e367072653dd9624$var$FileIcon.displayName = "FileIcon";
var $e367072653dd9624$var$_default = module.exports.default = $e367072653dd9624$var$FileIcon;

});


parcelRegister("hDVVP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cd8304336590be24$var$_react = $cd8304336590be24$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $cd8304336590be24$var$_flagFilled = $cd8304336590be24$var$_interopRequireDefault((parcelRequire("ltyKB")));
function $cd8304336590be24$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cd8304336590be24$var$FlagFilledIcon = (props)=>/*#__PURE__*/ $cd8304336590be24$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6 12.235v6.446c0 .537.45.977 1 .977s1-.44 1-.977v-5.778c1.17-.341 2.389-.045 3.768.29.982.238 2.036.495 3.13.495a5.7 5.7 0 0 0 2.547-.567 1 1 0 0 0 .563-.9V5.466a.998.998 0 0 0-1.437-.9c-1.345.654-2.731.317-4.331-.071-1.729-.42-3.687-.895-5.678.072A1 1 0 0 0 6 5.466z"/></svg>`
    }, props, {
        newIcon: $cd8304336590be24$var$_flagFilled.default
    }));
$cd8304336590be24$var$FlagFilledIcon.displayName = "FlagFilledIcon";
var $cd8304336590be24$var$_default = module.exports.default = $cd8304336590be24$var$FlagFilledIcon;

});
parcelRegister("ltyKB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88c1f65a7c2db6559a42eb4e9e9ef8e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa274326ad5d8ed5$var$_react = $fa274326ad5d8ed5$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $fa274326ad5d8ed5$var$_baseNew = $fa274326ad5d8ed5$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $fa274326ad5d8ed5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FlagFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: active feature flags.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fa274326ad5d8ed5$var$FlagFilledIcon = (props)=>/*#__PURE__*/ $fa274326ad5d8ed5$var$_react.default.createElement($fa274326ad5d8ed5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 1.75A.75.75 0 0 1 2.75 1H14a.75.75 0 0 1 .6 1.2l-2.662 3.55L14.6 9.3a.75.75 0 0 1-.6 1.2H3.5V15H2z" clip-rule="evenodd"/>`
    }, props));
$fa274326ad5d8ed5$var$FlagFilledIcon.displayName = "FlagFilledIcon";
var $fa274326ad5d8ed5$var$_default = module.exports.default = $fa274326ad5d8ed5$var$FlagFilledIcon;

});


parcelRegister("bzMno", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86d87d24bdacf9fc$var$_react = $86d87d24bdacf9fc$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $86d87d24bdacf9fc$var$_chartTrend = $86d87d24bdacf9fc$var$_interopRequireDefault((parcelRequire("7lagR")));
function $86d87d24bdacf9fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $86d87d24bdacf9fc$var$GraphLineIcon = (props)=>/*#__PURE__*/ $86d87d24bdacf9fc$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M21 17H5c-.55 0-1-.45-1-1.01V6a1 1 0 1 0-2 0v9.99A3 3 0 0 0 5 19h16a1 1 0 0 0 0-2m-3-8v3a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="M13.293 13.707a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L14 11.586l-2.293-2.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L11 11.414z"/></g></svg>`
    }, props, {
        newIcon: $86d87d24bdacf9fc$var$_chartTrend.default
    }));
$86d87d24bdacf9fc$var$GraphLineIcon.displayName = "GraphLineIcon";
var $86d87d24bdacf9fc$var$_default = module.exports.default = $86d87d24bdacf9fc$var$GraphLineIcon;

});
parcelRegister("7lagR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d4a862ad906af43648c20a01ac989d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5582762c7d38d6f5$var$_react = $5582762c7d38d6f5$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $5582762c7d38d6f5$var$_baseNew = $5582762c7d38d6f5$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $5582762c7d38d6f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrend".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5582762c7d38d6f5$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $5582762c7d38d6f5$var$_react.default.createElement($5582762c7d38d6f5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h1.5v7.94l3.22-3.22a.75.75 0 0 1 1.06 0L8.5 7.44l3.94-3.94H10V2h4.25a.75.75 0 0 1 .75.75V7h-1.5V4.56L9.03 9.03a.75.75 0 0 1-1.06 0L6.25 7.31 2.5 11.06V13a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$5582762c7d38d6f5$var$ChartTrendIcon.displayName = "ChartTrendIcon";
var $5582762c7d38d6f5$var$_default = module.exports.default = $5582762c7d38d6f5$var$ChartTrendIcon;

});


parcelRegister("42MLU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f1d2e5c73fdd8d1$var$_react = $2f1d2e5c73fdd8d1$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $2f1d2e5c73fdd8d1$var$_workItems = $2f1d2e5c73fdd8d1$var$_interopRequireDefault((parcelRequire("t3Z1q")));
function $2f1d2e5c73fdd8d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f1d2e5c73fdd8d1$var$IssuesIcon = (props)=>/*#__PURE__*/ $2f1d2e5c73fdd8d1$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 12.99C5 13 19.01 13 19.01 13 19 13 19 5.01 19 5.01 19 5 5 5 5 5zM3 5.01C3 3.9 3.89 3 5 3h14.01A2 2 0 0 1 21 5.01v7.98A2 2 0 0 1 19.01 15H5a2 2 0 0 1-2-2.01zM19 19c0 1.11-.9 2-2.01 2H7.01A2.01 2.01 0 0 1 5 19zm1-3a2 2 0 0 1-1.99 2H5.99A2 2 0 0 1 4 16z"/><path d="M10.674 11.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3z"/></g></svg>`
    }, props, {
        newIcon: $2f1d2e5c73fdd8d1$var$_workItems.default
    }));
$2f1d2e5c73fdd8d1$var$IssuesIcon.displayName = "IssuesIcon";
var $2f1d2e5c73fdd8d1$var$_default = module.exports.default = $2f1d2e5c73fdd8d1$var$IssuesIcon;

});
parcelRegister("t3Z1q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fa0a7a20e9878c1f12b50feba4970dc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0575cc88aefdce62$var$_react = $0575cc88aefdce62$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $0575cc88aefdce62$var$_baseNew = $0575cc88aefdce62$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $0575cc88aefdce62$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItems".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0575cc88aefdce62$var$WorkItemsIcon = (props)=>/*#__PURE__*/ $0575cc88aefdce62$var$_react.default.createElement($0575cc88aefdce62$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.5 4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zM9.448 5.608l-3.167 3.75a.75.75 0 0 1-1.09.061l-.055-.06-1.584-1.876 1.146-.966 1.01 1.196 2.594-3.071zM13 10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="M14.5 11.75V7H16v4.75A3.25 3.25 0 0 1 12.75 15H5v-1.5h7.75a1.75 1.75 0 0 0 1.75-1.75"/>`
    }, props));
$0575cc88aefdce62$var$WorkItemsIcon.displayName = "WorkItemsIcon";
var $0575cc88aefdce62$var$_default = module.exports.default = $0575cc88aefdce62$var$WorkItemsIcon;

});


parcelRegister("gSc26", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c48b05f711b32c58$var$_react = $c48b05f711b32c58$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $c48b05f711b32c58$var$_menu = $c48b05f711b32c58$var$_interopRequireDefault((parcelRequire("deFqc")));
function $c48b05f711b32c58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c48b05f711b32c58$var$MenuIcon = (props)=>/*#__PURE__*/ $c48b05f711b32c58$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 15h14v2H5zm0-8h14v2H5zm0 4h14v2H5z"/></svg>`
    }, props, {
        newIcon: $c48b05f711b32c58$var$_menu.default
    }));
$c48b05f711b32c58$var$MenuIcon.displayName = "MenuIcon";
var $c48b05f711b32c58$var$_default = module.exports.default = $c48b05f711b32c58$var$MenuIcon;

});
parcelRegister("deFqc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ecb53df8812f428ed0814030a719aff1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a2cb69e85570948$var$_react = $9a2cb69e85570948$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $9a2cb69e85570948$var$_baseNew = $9a2cb69e85570948$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $9a2cb69e85570948$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Menu".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for accessing the menu in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a2cb69e85570948$var$MenuIcon = (props)=>/*#__PURE__*/ $9a2cb69e85570948$var$_react.default.createElement($9a2cb69e85570948$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm0 5.25H1v-1.5h14zM15 14H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$9a2cb69e85570948$var$MenuIcon.displayName = "MenuIcon";
var $9a2cb69e85570948$var$_default = module.exports.default = $9a2cb69e85570948$var$MenuIcon;

});


parcelRegister("ieXtC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d477aba94fe327ce$var$_react = $d477aba94fe327ce$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $d477aba94fe327ce$var$_questionCircle = $d477aba94fe327ce$var$_interopRequireDefault((parcelRequire("6uMfJ")));
function $d477aba94fe327ce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d477aba94fe327ce$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $d477aba94fe327ce$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
    }, props, {
        newIcon: $d477aba94fe327ce$var$_questionCircle.default
    }));
$d477aba94fe327ce$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $d477aba94fe327ce$var$_default = module.exports.default = $d477aba94fe327ce$var$QuestionCircleIcon;

});
parcelRegister("6uMfJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63dc429f33c9470dc156b62d0ec66db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4baaf96be261b345$var$_react = $4baaf96be261b345$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $4baaf96be261b345$var$_baseNew = $4baaf96be261b345$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $4baaf96be261b345$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4baaf96be261b345$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $4baaf96be261b345$var$_react.default.createElement($4baaf96be261b345$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$4baaf96be261b345$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $4baaf96be261b345$var$_default = module.exports.default = $4baaf96be261b345$var$QuestionCircleIcon;

});


parcelRegister("ixaDK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d7e38ffb7694e997$var$_react = $d7e38ffb7694e997$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $d7e38ffb7694e997$var$_refresh = $d7e38ffb7694e997$var$_interopRequireDefault((parcelRequire("5sfxx")));
function $d7e38ffb7694e997$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d7e38ffb7694e997$var$RefreshIcon = (props)=>/*#__PURE__*/ $d7e38ffb7694e997$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $d7e38ffb7694e997$var$_refresh.default
    }));
$d7e38ffb7694e997$var$RefreshIcon.displayName = "RefreshIcon";
var $d7e38ffb7694e997$var$_default = module.exports.default = $d7e38ffb7694e997$var$RefreshIcon;

});
parcelRegister("5sfxx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d727d3cc18de179b7b728d0be1f533d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3f8b9f2e6d41a4e8$var$_react = $3f8b9f2e6d41a4e8$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $3f8b9f2e6d41a4e8$var$_baseNew = $3f8b9f2e6d41a4e8$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $3f8b9f2e6d41a4e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3f8b9f2e6d41a4e8$var$RefreshIcon = (props)=>/*#__PURE__*/ $3f8b9f2e6d41a4e8$var$_react.default.createElement($3f8b9f2e6d41a4e8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 3.67V1H1v5c0 .414.336.75.75.75H6.5v-1.5H3.236a5.5 5.5 0 1 1-.666 3.63l-1.48.24A7.002 7.002 0 0 0 15 8 7 7 0 0 0 2.5 3.67" clip-rule="evenodd"/>`
    }, props));
$3f8b9f2e6d41a4e8$var$RefreshIcon.displayName = "RefreshIcon";
var $3f8b9f2e6d41a4e8$var$_default = module.exports.default = $3f8b9f2e6d41a4e8$var$RefreshIcon;

});


parcelRegister("aOabo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7de678fbce1024bb$var$_react = $7de678fbce1024bb$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $7de678fbce1024bb$var$_roadmap = $7de678fbce1024bb$var$_interopRequireDefault((parcelRequire("30lzE")));
function $7de678fbce1024bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7de678fbce1024bb$var$RoadmapIcon = (props)=>/*#__PURE__*/ $7de678fbce1024bb$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 2h10a3 3 0 0 1 0 6H6a3 3 0 1 1 0-6m0 2a1 1 0 1 0 0 2h10a1 1 0 0 0 0-2zm4 5h8a3 3 0 0 1 0 6h-8a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2zm-4 5h6a3 3 0 0 1 0 6H6a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        newIcon: $7de678fbce1024bb$var$_roadmap.default
    }));
$7de678fbce1024bb$var$RoadmapIcon.displayName = "RoadmapIcon";
var $7de678fbce1024bb$var$_default = module.exports.default = $7de678fbce1024bb$var$RoadmapIcon;

});
parcelRegister("30lzE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e0a5e9b0b4b1b954a0d2b89a777fbfe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23021b54e58d1b56$var$_react = $23021b54e58d1b56$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $23021b54e58d1b56$var$_baseNew = $23021b54e58d1b56$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $23021b54e58d1b56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23021b54e58d1b56$var$RoadmapIcon = (props)=>/*#__PURE__*/ $23021b54e58d1b56$var$_react.default.createElement($23021b54e58d1b56$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$23021b54e58d1b56$var$RoadmapIcon.displayName = "RoadmapIcon";
var $23021b54e58d1b56$var$_default = module.exports.default = $23021b54e58d1b56$var$RoadmapIcon;

});


parcelRegister("49i1j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3055fb23f427cc25$var$_react = $3055fb23f427cc25$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $3055fb23f427cc25$var$_send = $3055fb23f427cc25$var$_interopRequireDefault((parcelRequire("7zXyR")));
function $3055fb23f427cc25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3055fb23f427cc25$var$SendIcon = (props)=>/*#__PURE__*/ $3055fb23f427cc25$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M6.978 19.477c0 1.371 1.645 2.042 2.577 1.05L21.558 7.723C22.518 6.695 21.803 5 20.409 5H3.496C2.178 5 1.505 6.607 2.418 7.572l4.56 4.828zm1.993-1.265v-6.627L3.856 6.169c.303.322.078.857-.36.857h15.963z"/><path d="m8.416 12.902 4.01-1.95a1.04 1.04 0 0 0 .474-1.365.98.98 0 0 0-1.324-.489l-4.01 1.95c-.497.242-.71.853-.475 1.364a.98.98 0 0 0 1.325.49"/></g></svg>`
    }, props, {
        newIcon: $3055fb23f427cc25$var$_send.default
    }));
$3055fb23f427cc25$var$SendIcon.displayName = "SendIcon";
var $3055fb23f427cc25$var$_default = module.exports.default = $3055fb23f427cc25$var$SendIcon;

});
parcelRegister("7zXyR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17ddc348c6f916127485ad6ca25becea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $584a00ed115d12a1$var$_react = $584a00ed115d12a1$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $584a00ed115d12a1$var$_baseNew = $584a00ed115d12a1$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $584a00ed115d12a1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Send".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sending messages in Rovo Chat.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $584a00ed115d12a1$var$SendIcon = (props)=>/*#__PURE__*/ $584a00ed115d12a1$var$_react.default.createElement($584a00ed115d12a1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 1.22a.75.75 0 0 1 .173.79l-5 13.5a.75.75 0 0 1-1.361.1l-2.895-5.307L.391 7.408A.75.75 0 0 1 .49 6.047l13.5-5a.75.75 0 0 1 .79.173M7.177 9.884l1.942 3.56 3.237-8.74zm4.118-6.24L2.556 6.881l3.56 1.942z" clip-rule="evenodd"/>`
    }, props));
$584a00ed115d12a1$var$SendIcon.displayName = "SendIcon";
var $584a00ed115d12a1$var$_default = module.exports.default = $584a00ed115d12a1$var$SendIcon;

});


parcelRegister("8Dgsy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $648ebbc2c69b3e0a$var$_react = $648ebbc2c69b3e0a$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $648ebbc2c69b3e0a$var$_starStarred = $648ebbc2c69b3e0a$var$_interopRequireDefault((parcelRequire("g8hkf")));
function $648ebbc2c69b3e0a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $648ebbc2c69b3e0a$var$StarFilledIcon = (props)=>/*#__PURE__*/ $648ebbc2c69b3e0a$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12.072 17.284-3.905 2.053a1 1 0 0 1-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 0 1 .554-1.705l4.366-.635 1.953-3.956a1 1 0 0 1 1.794 0l1.952 3.956 4.366.635a1 1 0 0 1 .555 1.705l-3.16 3.08.746 4.349a1 1 0 0 1-1.45 1.054z"/></svg>`
    }, props, {
        newIcon: $648ebbc2c69b3e0a$var$_starStarred.default
    }));
$648ebbc2c69b3e0a$var$StarFilledIcon.displayName = "StarFilledIcon";
var $648ebbc2c69b3e0a$var$_default = module.exports.default = $648ebbc2c69b3e0a$var$StarFilledIcon;

});
parcelRegister("g8hkf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bbead533cd4a5363$var$_react = $bbead533cd4a5363$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $bbead533cd4a5363$var$_baseNew = $bbead533cd4a5363$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $bbead533cd4a5363$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bbead533cd4a5363$var$StarStarredIcon = (props)=>/*#__PURE__*/ $bbead533cd4a5363$var$_react.default.createElement($bbead533cd4a5363$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$bbead533cd4a5363$var$StarStarredIcon.displayName = "StarStarredIcon";
var $bbead533cd4a5363$var$_default = module.exports.default = $bbead533cd4a5363$var$StarStarredIcon;

});


parcelRegister("aBBZY", function(module, exports) {

$parcel$export(module.exports, "TemplateKey", function () { return $480f95371e73837d$export$21f5be7276c6a79d; });
var $480f95371e73837d$export$21f5be7276c6a79d;
(function(TemplateKey) {
    TemplateKey["SimplifiedBasic"] = "com.pyxis.greenhopper.jira:gh-simplified-basic";
    TemplateKey["Scrum"] = "com.pyxis.greenhopper.jira:gh-simplified-agility-scrum";
    TemplateKey["Kanban"] = "com.pyxis.greenhopper.jira:gh-simplified-agility-kanban";
    TemplateKey["WebDesignProcess"] = "com.atlassian.jira-core-project-templates:jira-work-management-web-design-process";
    TemplateKey["GoToMarket"] = "com.atlassian.jira-core-project-templates:jira-work-management-go-to-market";
    TemplateKey["SimplifiedProcessControl"] = "com.atlassian.jira-core-project-templates:jira-core-simplified-process-control";
    TemplateKey["ProcessControlTeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-process-control-team-managed";
    TemplateKey["SalesPipeline"] = "com.atlassian.jira-core-project-templates:jira-work-management-sales-pipeline";
    TemplateKey["SimplifiedProcurement"] = "com.atlassian.jira-core-project-templates:jira-core-simplified-procurement";
    TemplateKey["EmployeeOnboarding"] = "com.atlassian.jira-core-project-templates:jira-work-management-employee-onboarding";
    TemplateKey["PersonalTaskPlanner"] = "com.atlassian.jira-core-project-templates:jira-work-management-personal-task-planner";
    TemplateKey["CampaignManagement"] = "com.atlassian.jira-core-project-templates:jira-work-management-campaign-management";
    TemplateKey["CampaignManagementTeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-campaign-management-team-managed";
    TemplateKey["CampaignManagementV2TeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-campaign-management-team-managed-v2";
    TemplateKey["Recruitment"] = "com.atlassian.jira-core-project-templates:jira-core-simplified-recruitment";
    TemplateKey["RecruitmentTeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-recruitment-team-managed";
    TemplateKey["LeadTracking"] = "com.atlassian.jira-core-project-templates:jira-core-simplified-lead-tracking";
    TemplateKey["LeadTrackingTeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-lead-tracking-team-managed";
    TemplateKey["MonthEndClose"] = "com.atlassian.jira-core-project-templates:jira-work-management-month-end-close";
    TemplateKey["MonthEndCloseTeamManaged"] = "com.atlassian.jira-core-project-templates:jira-work-management-month-end-close-team-managed";
})($480f95371e73837d$export$21f5be7276c6a79d || ($480f95371e73837d$export$21f5be7276c6a79d = {}));

});

parcelRegister("cmE4B", function(module, exports) {

$parcel$export(module.exports, "OrangeModal", function () { return $5da4c58ea654b814$export$6c8874c44e988ef8; });
$parcel$export(module.exports, "PurpleModal", function () { return $5da4c58ea654b814$export$fd3dd56b06272778; });
$parcel$export(module.exports, "GreenModal", function () { return $5da4c58ea654b814$export$4e38f8e127b6b98b; });
$parcel$export(module.exports, "BlueModal", function () { return $5da4c58ea654b814$export$f4813b8b24b3c6ba; });
$parcel$export(module.exports, "BlackModal", function () { return $5da4c58ea654b814$export$523a506d2ef0ae23; });

var $loA2J = parcelRequire("loA2J");
const $5da4c58ea654b814$export$6c8874c44e988ef8 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        viewBox: "0 0 757 491",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M356 15.3286L756.5 0.5L743 448H356V15.3286Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M43 232.398L388 184V470L52.2992 459.355L43 232.398Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M130.234 460.03C140.887 430.441 107.574 463.703 99.1998 468.074C101.862 457.404 108.184 448.371 112.355 438.004C112.058 438.192 112.208 437.45 112.563 436.851C120.461 414.086 92.9297 440.308 88.1073 447.052C88.1175 447.034 88.951 445.758 88.968 445.729C54.5977 481.419 91.7038 430.441 93.3267 414.961C93.0425 402.582 78.5587 419.05 75.0123 422.678C67.3702 430.305 36.8636 466.687 53.9276 435.147L53.7787 435.35L53.798 435.236C51.3589 439.146 41.6341 456.497 53.7788 446C34.7693 461.626 63.4948 417.275 65.9126 411.975C63.5461 418.477 58.9206 424.975 58.1411 427.315C96.3111 357.491 41.5077 423.285 25.4617 434.069C26.1251 429.926 28.5681 425.713 30.3316 422.012C29.4769 423.002 26.3986 430.288 25.4147 431.407C26.3559 427.511 37.0523 408.23 32.3143 418.001C33.277 414.579 57.8915 381.568 41.3467 385.439C27.8528 393.88 19.2388 409.247 5.2045 416.952C2.66538 409.255 33.2703 376.495 16.7724 377.032C9.82032 378.748 -20.7683 410.243 -11.4671 389.347C-7.46621 380.282 -12.1051 388.336 -13.6843 392.136C-13.6164 391.682 -13.531 391.239 -13.4422 390.79C-21.7707 414.823 13.6935 376.748 19.715 378.519C15.8326 392.517 -16.441 440.957 21.5529 406.601C21.3914 406.812 20.3641 408.14 20.2264 408.31C25.0007 406.262 38.054 385.188 44.9353 388.193C45.4657 390.142 39.2729 402.652 42.3922 394.811C0.374836 465.986 33.3582 433.682 67.1895 399.97C66.9974 416.115 42.7024 434.51 46.1091 451.952C64.0492 448.014 73.2351 423.861 89.1359 414.564C89.7026 421.023 82.271 431.164 79.2755 437.904L79.6195 437.485C64.2344 465.324 66.334 474.572 92.1053 446.813C95.2779 444.125 116.437 421.066 109.239 437.488C86.5994 486.04 95.6274 472.501 129.368 450.066C133.416 452.108 122.344 473.745 130.219 460.029L130.234 460.03Z",
                fill: "#101214"
            })
        ]
    });
};
const $5da4c58ea654b814$export$fd3dd56b06272778 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        viewBox: "0 0 729 447",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M453 6.8593L729 0V325H453V6.8593Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M21 229.336L218 185V447L26.31 437.248L21 229.336Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M28.471 195.058C29.6205 194.959 45.0014 191.246 40.9669 190.44C39.4702 190.859 38.3072 190.436 37.5589 191.57C37.3425 190.233 34.4079 192.367 33.9571 192.448C33.7542 191.435 29.1562 194.041 29.8279 193.1C27.7407 193.127 25.1487 193.856 22.453 194.712C21.1322 193.816 26.7941 187.425 24.4139 188.807C24.5807 188.446 25.2208 186.889 25.1352 187.92C25.888 187.038 34.0833 173.535 30.6754 175.822C28.3763 178.608 26.6498 183.275 24.7024 185.58C22.8091 186.358 21.4973 193.046 19.3876 192.38C18.1569 190.877 14.9834 172.469 12.7295 174.103C13.1216 175.534 12.7655 176.816 13.8609 177.505C12.5221 177.721 14.6588 180.651 14.74 181.101C13.7482 181.29 16.3177 185.899 15.3936 185.224C15.4117 186.525 15.7047 188.028 16.1284 189.626C15.5649 189.198 14.9473 188.221 14.5912 188.077C10.7956 186.543 7.91954 183.014 3.96613 181.101C0.643816 185.327 30.0217 195.99 11.8053 197.583C8.37936 199.815 3.82638 200.157 0.0036926 202.304C-0.325383 206.954 21.4657 194.126 15.1772 201.494C14.199 204.609 12.7475 208.106 10.7415 211.175C9.46124 222.882 20.3478 191.079 19.897 203.213C21.3981 206.112 22.8497 209.605 23.5935 213.201C28.9173 220.996 21.6506 200.374 20.8887 197.453C23.7738 196.224 34.9263 210.158 36.9458 207.962C37.0405 207.651 35.4357 205.927 34.9488 205.743C34.6198 205.909 34.453 206.044 34.2591 205.738C35.2373 204.798 31.8068 203.61 31.4823 203.286C32.2035 202.57 27.4297 200.243 28.5882 200.279C27.6956 199.032 26.3298 197.777 24.7745 196.512C27.5334 195.981 28.7325 194.036 28.48 195.049L28.471 195.058Z",
                fill: "#101214"
            })
        ]
    });
};
const $5da4c58ea654b814$export$4e38f8e127b6b98b = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        viewBox: "0 0 740 478",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M739.945 477.053L728.47 42.8846L403.714 51.9593L402.956 475.471L739.945 477.053Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M66.2766 21.5979C66.7767 20.978 65.6542 10.1027 63.8098 13.042C63.0037 14.0204 63.013 14.9796 64.0782 15.3669C61.9471 15.5508 64.6106 17.7697 63.8524 18.7063C62.4064 18.268 65.2624 21.3987 63.7729 20.7378C61.3465 32.2642 73.9329 56.5486 67.4076 27.4713C66.5426 30.2678 66.1529 27.5553 66.5698 26.3008C68.3198 28.2426 67.071 22.8154 66.4921 21.7923C66.4105 23.4442 65.2187 20.6369 66.2713 21.6025L66.2766 21.5979Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M46.9395 41.4791C46.9566 39.9576 37.0855 32.9328 36.1601 32.0708C33.8362 30.599 33.3907 34.0732 35.4116 34.7754C35.7436 35.0826 38.6085 36.2619 37.299 36.8864C37.7317 39.8964 42.95 40.6524 43.0937 43.1784C43.8141 42.8232 44.5739 43.7637 45.051 43.5916C44.9167 44.3313 45.8852 44.8118 45.9878 44.6391C48.3432 47.9902 51.6853 44.2447 48.0933 42.2918C48.2618 42.1735 47.6694 41.2644 46.9494 41.4798L46.9395 41.4791Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M24.7401 78.7976C26.3547 80.2709 24.5525 80.0579 23.772 79.3305C25.3978 78.2085 21.8092 77.9733 20.8595 78.3227C21.2268 78.4227 21.2389 79.0726 20.4717 78.9103C21.3013 77.4094 11.5803 75.4721 15.5859 79.54C15.7542 79.5615 16.0603 78.3193 16.184 78.7421C15.5038 80.5878 17.2858 79.5164 17.7456 79.443C17.5533 80.4283 18.1351 79.5794 18.1687 80.006C17.3932 81.2461 20.303 79.438 19.4595 80.6534C21.3263 83.0425 26.2528 81.1126 27.625 83.2332C29.2172 81.2103 35.7726 85.7171 33.7911 81.0187C30.8779 79.5466 28.4464 78.5866 24.7401 78.7976Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M10.3204 53.0348C8.98192 55.9537 15.8356 56.4071 17.4345 57.9592C19.3188 60.1099 41.9669 70.2344 36.895 63.213C30.0144 60.2067 24.9055 56.5376 16.0964 53.9487C14.6967 53.4237 10.5196 50.8717 10.3204 53.0348Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M87.0372 37.8984C89.2159 40.0542 85.6577 42.0527 87.4086 44.0495C90.893 47.1931 96.2939 24.8368 92.1239 24.9014C88.5433 25.4405 88.8059 36.5316 87.0372 37.8984Z",
                fill: "#101214"
            })
        ]
    });
};
const $5da4c58ea654b814$export$f4813b8b24b3c6ba = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        viewBox: "0 0 748 441",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M0 203.398L355 155V441L9.56873 430.355L0 203.398Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M748 21.7328C744.748 16.1599 748.569 6.30979 743.319 0.987671C732.702 -2.57202 730.745 18.1313 723.821 20.8202C720.67 15.5886 724.004 7.66819 720.04 2.21372C720.23 2.34607 720.84 3.03576 720.907 3.12632C710.495 -8.79968 707.039 19.2669 699.16 20.9248C695.854 15.1847 701.437 -0.377695 691.295 0.284086C684.899 0.381612 677.549 28.1973 673.856 18.7234L673.843 18.8559L673.795 18.8071C674.154 25.5572 679.825 18.0616 680.841 15.9439C672.156 32.6487 672.637 11.5552 671.749 3.89249C673.484 5.91963 672.766 11.4856 673.355 13.882C673.274 -15.3688 658.525 10.3292 651.791 20.6321C647.014 20.3813 650.476 8.48332 648.356 4.57533C648.478 5.41126 649.277 10.1411 648.491 11.0607C648.281 7.59849 648.471 0.277127 643.315 1.16182C643.844 0.0263465 646.432 1.16182 646.73 1.68428C635.931 -3.6448 634.501 19.002 626.053 20.9874C623.594 15.094 626.71 7.55679 623.269 1.75401C613.262 -9.37785 602.382 37.0094 600.546 14.3626C599.984 9.79281 601.616 1.78879 596 1.00162C596.888 1.53801 598.873 2.98004 598.764 5.22313C598.615 4.98628 598.473 4.74943 598.324 4.52652C599.848 10.4965 597.28 16.8914 599.997 22.5131C607.05 29.4165 614.143 -0.175617 621.29 2.78498C624.231 6.61635 622.124 12.9415 622.869 17.5252C622.815 17.3789 622.544 16.4316 622.496 16.3062C624.454 38.2773 638.261 6.73472 636.913 11.4369C654.264 -16.8177 637.462 39.6566 656.262 21.2173C660.693 17.3929 663.416 2.7153 669.263 4.67278C670.049 12.238 670.435 34.014 681.282 19.9285C685.367 15.2124 686.993 5.18826 693.036 3.79504C696.24 9.70927 690.854 30.3569 703.286 23.6694C703.164 23.7182 703.049 23.7739 702.92 23.8226C707.961 22.0114 713.089 -2.32819 718.374 5.00714C720.413 9.77196 716.572 23.4883 724.43 23.8993C731.307 23.3072 738.339 -6.76563 743.183 6.9019C744.064 10.162 743.671 24.568 747.986 21.7119L748 21.7328Z",
                fill: "#101214"
            })
        ]
    });
};
const $5da4c58ea654b814$export$523a506d2ef0ae23 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        viewBox: "0 0 721 465",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M359.416 94.2542L274.408 67.7112L9.74577 90.2379L0.164061 457.629L312.003 464.667L359.416 94.2542Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M720.092 34.905C720.117 34.8633 720.117 34.7882 720.168 34.7299C718.688 33.996 718.519 32.1946 717.377 31.1188L717.335 31.0771C716.177 30.7101 716.489 29.5676 715.052 29.5593C715.052 29.5593 715.424 29.3757 715.432 29.3757C713.098 27.0906 707.331 21.478 707.331 21.478C707.204 21.9867 708.253 21.1027 709.31 21.2528C709.31 21.2528 709.386 21.061 709.462 21.2112C712.16 18.6175 715.196 17.625 718.646 16.3908C720.371 15.9321 720.633 11.12 717.682 13.1132C717.648 13.0798 717.572 13.0549 717.538 12.9965C716.506 14.1808 714.79 13.747 713.487 14.3641L713.437 14.3892L711.272 15.4317C710.096 15.907 708.701 16.2824 707.238 16.6493C707.28 16.6076 707.323 16.5659 707.365 16.5242C707.365 16.5242 707.517 14.2141 707.475 13.0715C707.475 13.0715 708.955 11.2368 708.464 9.97753C709.302 8.50139 712.278 5.27381 709.572 4.35644C708.684 4.35644 707.991 3.59755 707.686 5.00697C707.636 4.99863 707.568 5.01529 707.5 4.99027C707.34 6.44973 705.589 7.48388 705.107 8.86828L705.09 8.92671C705.209 10.111 704.279 11.2785 704.27 11.2785C703.83 12.3626 703.255 13.5469 702.646 14.7811C702.393 14.114 702.114 13.5219 701.835 13.0966C700.82 12.0124 701.251 -2.799 697.497 0.470187C697.674 3.26401 698.57 6.17454 697.843 8.65978C697.488 8.8516 698.029 9.84404 698.469 10.653C698.435 11.6788 698.224 12.2292 698.165 13.697C696.304 12.371 688.186 5.65753 688.685 10.1777C689.556 10.6364 690.19 11.1617 690.647 12.2292C691.07 12.6879 694.799 14.7562 694.917 15.2733C694.672 15.9905 699.078 16.5659 697.294 17.0996C697.556 17.6667 697.911 18.2089 698.325 18.7343C696.397 18.9344 694.089 19.4931 692.879 20.2187C692.668 20.5773 684.973 21.061 682.182 22.8374C680.516 23.7631 679.045 24.2218 680.778 25.6146C681.404 25.1142 683.755 25.8314 683.704 25.1725C684.279 25.4061 688.169 23.9382 688.6 24.1884C688.812 24.522 691.873 22.754 691.509 23.588C693.632 24.1801 696.22 23.6963 698.909 23.0208C697.843 24.6888 696.795 27.0656 696.659 28.5417C695.746 30.4349 693.336 34.6215 692.566 37.1902C691.467 39.0583 691.848 39.2083 693.235 40.1674L693.26 40.1925C693.547 40.3843 693.226 40.1924 694.317 40.2341C694.207 40.134 694.046 39.7004 693.835 39.7755C693.979 39.4836 695.636 39.0665 694.943 38.6746C694.917 38.6162 696 37.7989 696.11 36.9149C697.074 33.7625 699.382 32.1696 701.09 28.5751C701.048 28.9504 703.923 36.0142 703.788 39.5336C703.577 41.2682 707.839 43.8536 707.221 39.984C707.272 39.9673 707.314 39.9006 707.39 39.8922C706.705 38.2993 707.61 36.6564 707.255 35.0384L707.238 34.9718C706.469 33.9877 707.357 33.1704 706.139 32.3698C706.139 32.3698 706.553 32.4114 706.562 32.4197C706.02 30.1263 705.682 27.3242 705.175 24.8139C706.993 26.4401 708.591 28.1915 709.251 30.118L709.335 29.9929C709.335 30.0513 709.462 30.0929 709.352 30.2264C710.883 30.5433 711.407 31.1771 712.515 31.6025C712.515 31.6025 713.699 33.7124 715.077 33.7875L717.174 36.7147C718.079 38.2242 722.959 37.3569 720.126 34.9384L720.092 34.905Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("8ZhzG", function(module, exports) {

$parcel$export(module.exports, "ProductModalCarousel", function () { return $e69ddbf4989dff64$export$4bbc33d47571e3e6; });
/* modal-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $vqrsL = parcelRequire("vqrsL");

var $g9kzu = parcelRequire("g9kzu");

var $dkr6a = parcelRequire("dkr6a");
const $e69ddbf4989dff64$var$LeftArrow = ({ onClick: onClick })=>/*#__PURE__*/ (0, $loA2J.jsx)("button", {
        onClick: onClick,
        className: (0, $esG4f.default)([
            "_kqswstnw _19itglyw _80omtlke _1pbykb7n _bfhk1j28 _152t1ssb _1e0216lh"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "65",
            height: "64",
            viewBox: "0 0 65 64",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M56.6172 32C56.6172 18.6667 45.9505 8 32.6172 8C19.2838 8 8.61718 18.6667 8.61719 32C8.61719 45.3333 19.2839 56 32.6172 56C45.9505 56 56.6172 45.3333 56.6172 32Z",
                    fill: "#101214"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M35.2842 20.2667L39.0176 24.0001L31.0176 32.0001L39.0176 40.0001L35.2842 43.7334L23.5509 32.0001L35.2842 20.2667Z",
                    fill: "white"
                })
            ]
        })
    });
const $e69ddbf4989dff64$var$RightArrow = ({ onClick: onClick })=>/*#__PURE__*/ (0, $loA2J.jsx)("button", {
        onClick: onClick,
        className: (0, $esG4f.default)([
            "_kqswstnw _19itglyw _80omtlke _1pbykb7n _bfhk1j28 _152t1ssb _rjxp16lh"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "64",
            height: "64",
            viewBox: "0 0 64 64",
            fill: "#none",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M8 32C8 45.3333 18.6667 56 32 56C45.3333 56 56 45.3333 56 32C56 18.6667 45.3333 8 32 8C18.6667 8 8 18.6667 8 32Z",
                    fill: "#101214"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M29.3329 43.7333L25.5996 39.9999L33.5996 31.9999L25.5996 23.9999L29.3329 20.2666L41.0663 31.9999L29.3329 43.7333Z",
                    fill: "white"
                })
            ]
        })
    });
const $e69ddbf4989dff64$var$settings = {
    prevArrow: /*#__PURE__*/ (0, $loA2J.jsx)($e69ddbf4989dff64$var$LeftArrow, {}),
    nextArrow: /*#__PURE__*/ (0, $loA2J.jsx)($e69ddbf4989dff64$var$RightArrow, {})
};
const $e69ddbf4989dff64$export$4bbc33d47571e3e6 = ({ children: children })=>{
    const { modalIndex: modalIndex } = (0, $dkr6a.useHeroState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const beforeChange = (currentSlide, nextSlide)=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: "atlas-55799-carousel-slide-button-clicked",
                section: "hero-section",
                slide: currentSlide,
                nextSlide: nextSlide
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqsw1n9t _1e02idpf _152tidpf _rjxpidpf _u7coidpf _1e0c1txw _4cvr1h6o _1bah1h6o _11q71sgx _1pbyzo7u _liwcglyw"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_j6fg1txw _19moidpf _1vqqkfja _m8oxidpf _bzd2kfja _3otn1r31 _1d59glyw _r3kx1o36 _1u351txw _6aywidpf _1imc1wqb _1plyidpf _1k001wqb _1xnx1ule _qzmo15vq",
                "_1bsb1w8u"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($vqrsL))), (0, $6iHNw._)((0, $7Knp0._)({}, $e69ddbf4989dff64$var$settings), {
                initialSlide: modalIndex,
                beforeChange: beforeChange,
                children: children
            }))
        })
    });
};
const $e69ddbf4989dff64$var$modalBackgroundStyles = null;
const $e69ddbf4989dff64$var$sliderParent = null; // Source https://github.com/kenwheeler/slick/blob/master/slick/slick.css
const $e69ddbf4989dff64$var$slickStyle = null;
const $e69ddbf4989dff64$var$arrowButton = null;
const $e69ddbf4989dff64$var$buttonLeft = null;
const $e69ddbf4989dff64$var$buttonRight = null;

});

parcelRegister("7qjEF", function(module, exports) {

$parcel$export(module.exports, "ProductModalCard", function () { return $29613b8def1eb14b$export$91f997500fc720d5; });
/* product-modal-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $f448m = parcelRequire("f448m");

var $91nJf = parcelRequire("91nJf");
parcelRequire("f0Hih");
var $dhmEV = parcelRequire("dhmEV");

var $k4Qty = parcelRequire("k4Qty");

var $dkr6a = parcelRequire("dkr6a");
const $29613b8def1eb14b$export$91f997500fc720d5 = ({ eyebrow: eyebrow, title: title, description: description, iconCollection: iconCollection, image: image, BackgroundImage: BackgroundImage, ctaLink: ctaLink, label: label, personaData: personaData })=>{
    const intl = (0, $f6qj2.default)();
    const { closeModal: closeModal } = (0, $dkr6a.useHeroState)();
    const { setAnchorLocalStorage: setAnchorLocalStorage } = (0, $k4Qty.useAnchorLocalStorage)();
    const handleClick = ()=>{
        // Set team/persona in local storage for various uses later in funnel
        setAnchorLocalStorage(personaData);
    };
    const buttonText = intl.formatMessage({
        id: "jira-product-tour.hero-modal-cta-btn.btn-text",
        defaultMessage: "Get started"
    });
    const iconTitle = intl.formatMessage({
        id: "jira-product-tour.hero-modal-icon-title.title-text",
        defaultMessage: "Collaborate with these features"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2rkoqslr _11q71q2x _16qsaa27 _1bahesu3 _1bsb1w8u _4t3i1w8u _1ikw1us8 _6ru51osq _79ty1sxn _1p9vu67f _tnru1vuk _1rfm1w8u"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_16jlkb7n _kqswh2mm _1e0c11p5 _6a6z1h6o _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_4t3i1vuk _1bsb1vuk _kqswstnw _1e0c1txw _1bah1h6o _1rfm1vuk _tnru1vuk"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)(BackgroundImage, {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                        src: image,
                        alt: "",
                        className: (0, $esG4f.default)([
                            "_c71l1w8u _p12f12it _kqswstnw _1rkb1w8u _123r1w8u"
                        ])
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1bsbr60k _2rkoqslr _bfhku67f _zzrm1osq"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_ca0qidpf _u5f3d6z3 _n3tdidpf _19bvd6z3"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                            onClick: closeModal,
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _1bahesu3 _1bsb1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhk1j28 _19itglyw _1pfh7vkz _80omtlke"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f448m))), {
                                size: "medium",
                                label: "Close"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_syaz1x0p _ect41qje _1wybdlk8 _k48p1nn1 _vwz4f6fq _1dyzt94y _1p1dangw _1q511skh _1cqs1crf _1bys7vkz"
                            ]),
                            children: eyebrow
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_syaz1x0p _ect41qje _1wybzwfg _k48p1fw0 _vwz410mc _1pfh14y2 _1cqs1tcg _1bysvpzd"
                            ]),
                            children: title
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1pfh1gkc _1cqs7vkz _1bys1tcg _srwz7vkz"
                            ]),
                            children: description
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_4t3it94y _bfhk1sas _1pfhzwfg",
                                "_liwcglyw"
                            ])
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1pfhzwfg _6rthrdoj _syazr3uz _1wyb7vkz _k48p1nn1 _vwz41tcg _1bsbn8ye",
                                "_liwcglyw"
                            ]),
                            children: iconTitle
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c116y _2lx21bp4 _4cvr1y6m _zulpftgi _81641y44"
                            ]),
                            children: iconCollection.map((icon, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1e0c1txw"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o"
                                            ]),
                                            children: icon.icon
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_syazr3uz _1wybdlk8 _k48p1nn1 _vwz4gktf"
                                            ]),
                                            children: icon.description
                                        })
                                    ]
                                }, index))
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1q51zwfg _1u2q7vkz _xlt17vkz"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dhmEV.default), {
                                intentType: "button",
                                containerId: "jira-product-tour-overview-hero-modal-" + personaData.team,
                                productKey: "jira-software.ondemand",
                                edition: "free",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                                    onClick: handleClick,
                                    href: ctaLink,
                                    variant: "primary",
                                    size: "small",
                                    color: "blue",
                                    dataEventProps: {
                                        "data-product-key": "jira",
                                        "data-event": "clicked",
                                        "data-event-component": "button",
                                        "data-event-container": "heroSection",
                                        "data-label": "get-started",
                                        "data-label-english": "Get Started",
                                        "data-track-event": `jira-pt.hero-modal-${label}.get-started`
                                    },
                                    children: buttonText
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $29613b8def1eb14b$var$modalStyles = null;
const $29613b8def1eb14b$var$modalImageStyles = null;
const $29613b8def1eb14b$var$imageStyles = null;
const $29613b8def1eb14b$var$backgroundStyles = null;
const $29613b8def1eb14b$var$modalContentStyles = null;
const $29613b8def1eb14b$var$textSpaceStyles = null;
const $29613b8def1eb14b$var$closeModalButtonStyles = null;
const $29613b8def1eb14b$var$eyebrowStyles = null;
const $29613b8def1eb14b$var$titleStyles = null;
const $29613b8def1eb14b$var$descriptionStyles = null;
const $29613b8def1eb14b$var$seporatorStyles = null;
const $29613b8def1eb14b$var$iconTitleStyles = null;
const $29613b8def1eb14b$var$iconDescriptionStyles = null;
const $29613b8def1eb14b$var$iconContainerStyles = null;
const $29613b8def1eb14b$var$iconAndTextStyles = null;
const $29613b8def1eb14b$var$iconStyles = null;
const $29613b8def1eb14b$var$buttonSpaceStyles = null;
const $29613b8def1eb14b$var$displayNoneBelowLg = null;

});





parcelRegister("3YHG8", function(module, exports) {

$parcel$export(module.exports, "JswDoubleFeatureSection", function () { return $b14b8822e5b0e43f$export$fa980c3455a6cd08; });
/* jsw-double-feature.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("6EIiq");
var $2HmFK = parcelRequire("2HmFK");
parcelRequire("Tf71T");
var $fkaMJ = parcelRequire("fkaMJ");
const $b14b8822e5b0e43f$export$fa980c3455a6cd08 = ()=>{
    const intl = (0, $f6qj2.default)();
    const doubleFeatureItems = [
        {
            title: intl.formatMessage({
                id: "jira-product-tour.double-feature-section.first-card-title-text",
                defaultMessage: "Easily see every team\u2019s progress"
            }),
            description: intl.formatMessage({
                id: "jira-product-tour.double-feature-section.first-card-description-text",
                defaultMessage: "Track every team\u2019s work in a single timeline. Understand progress, map dependencies, and stay ahead of risks."
            }),
            image: (0, $fkaMJ.getDoubleFeatureFirstImage)(intl.locale)
        },
        {
            title: intl.formatMessage({
                id: "jira-product-tour.double-feature-section.second-card-title-text",
                defaultMessage: "Map work to company impact"
            }),
            description: intl.formatMessage({
                id: "jira-product-tour.double-feature-section.second-card-description-text",
                defaultMessage: "With goals in Jira, it\u2019s easy to track all the tasks across projects that contribute to a goal, no matter what team is working on it."
            }),
            image: (0, $fkaMJ.getDoubleFeatureSecondImage)(intl.locale)
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c11p5 _1eog16gx _qjx3idpf _1celidpf _5n7aidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_syaz1hlo _y3gn1h6o _ect41pz4 _1wyb1ylp _k48p1fw0 _vwz4ckbl _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r3w1ul9 _1eogidpf _qjx310yn _1celidpf _5n7a10yn"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                    "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                },
                children: intl.formatMessage({
                    id: "jira-product-tour.double-feature-section.title-text",
                    defaultMessage: "Never lose sight of the big picture"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bah1h6o _zulp1ul9 _ca0q1u1b _u5f3idpf _n3td10yn _19bvidpf _79ty1bp4 _1np61h6o _1yytzwfg _1eog1u1b _qjx39by0 _1cel10yn _5n7a9by0"
                ]),
                children: doubleFeatureItems.map((item, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $2HmFK.JswDoubleFeatureCard), {
                        title: item.title,
                        description: item.description,
                        image: item.image
                    }, index))
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_mkrzzwj5 _bfhkr3uz _4t3ir0r7 _1pby1mrw _1pfh1o8r"
                ])
            })
        ]
    });
};
$b14b8822e5b0e43f$export$fa980c3455a6cd08.displayName = "JswDoubleFeatureSection";
const $b14b8822e5b0e43f$var$containerStyles = null;
const $b14b8822e5b0e43f$var$titleStyles = null;
const $b14b8822e5b0e43f$var$cardContainerStyles = null;
const $b14b8822e5b0e43f$var$blackShapeStyles = null;

});

parcelRegister("dChrM", function(module, exports) {

$parcel$export(module.exports, "NoJiraHeroSection", function () { return $eaeba0b41e899260$export$68338f1ab5428abb; });
/* no-jira-hero-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dyZbY = parcelRequire("dyZbY");
parcelRequire("6EIiq");
var $9lQ9Q = parcelRequire("9lQ9Q");
var $i9Hfh = parcelRequire("i9Hfh");
var $bwq2g = parcelRequire("bwq2g");
const $eaeba0b41e899260$export$68338f1ab5428abb = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $dyZbY.default), {
        name: "logged-out-no-jira-product-tour-hero",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_bfhk1hxd _1bsb1osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $9lQ9Q.Header), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $i9Hfh.HeroCards), {})
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bwq2g.LogoBanner), {})
        ]
    });
};
$eaeba0b41e899260$export$68338f1ab5428abb.displayName = "NoJiraHeroSection";
const $eaeba0b41e899260$var$heroStyles = null;

});

parcelRegister("3lrJv", function(module, exports) {

$parcel$export(module.exports, "TestimonialSection", function () { return $d9a9d23c92c85c34$export$1b0efcc7c1027c88; });
/* testimonial.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $gAJUc = parcelRequire("gAJUc");
parcelRequire("6EIiq");
var $79Fc3 = parcelRequire("79Fc3");
parcelRequire("Tf71T");
var $fFExq = parcelRequire("fFExq");
const $d9a9d23c92c85c34$export$f756e64b0cdd0c57 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_mezj1u1b _bna710mc _1egfglyw"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3t76qr31nd0pyj71cs0562wxs6agxl02.webp",
                alt: ""
            }
        })
    });
};
const $d9a9d23c92c85c34$export$1b0efcc7c1027c88 = ()=>{
    const intl = (0, $f6qj2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const useGWP7617Gate = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7617JiraShortTermAiInfusionGate);
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: "atlas-55799-testimonial-button-clicked",
                section: "testimonial-section"
            }
        }).fire();
    };
    const header = intl.formatMessage({
        id: "jira-product-tour.testimonial-section.header-text",
        defaultMessage: "For teams big & small"
    });
    const subtitle = intl.formatMessage({
        id: "jira-product-tour.testimonial-section.subtitle-text",
        defaultMessage: "Hear from start-ups & large enterprises that prefer Atlassian"
    });
    const ctaTextOld = intl.formatMessage({
        id: "jira-product-tour.testimonial-section.cta-text",
        defaultMessage: "See more customer stories"
    });
    const ctaTextAi = intl.formatMessage({
        id: "jira-product-tour.testimonial-section.cta-text-ai",
        defaultMessage: "See how Roblox boosts collaboration with AI"
    });
    const ctaText = useGWP7617Gate ? ctaTextAi : ctaTextOld;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_mkrz16pp _11q71hlo _1e0c1txw _4cvr1h6o _1bah1h6o _ca0q19bv _u5f3idpf _n3td53f4 _19bvidpf _2tde53f4 _1a87idpf _uwpc53f4 _3r7oidpf _1kmx19bv _1ggmidpf _1ykzuuw1 _1maeidpf"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_kqswh2mm _1e0c1txw _4cvr1y6m _a64k1w81 _79ty1bp4 _1np61h6o _1yytidpf"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _4cvr1y6m _zulp19bv"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)($d9a9d23c92c85c34$export$f756e64b0cdd0c57, {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_liwc1txw _79ty1bp4 _105s1h6o _1rkb1i94 _1kmxidpf _1ggm10yn _1ykzidpf _1mae10yn"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1i7q1ogy _liwc1txw _79ty1bp4 _m80d1h6o _1yyt10yn _1p1d8vuz _1rkbjwe6"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                        className: (0, $esG4f.default)([
                                            "_syazcd5j _ect41pz4 _k48p1fw0 _vwz44jg8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _fz891ylp _1ol9ckbl _flz0ckbl _1lzo1ylp _1cqs1ul9"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                                            "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                                        },
                                        children: header
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1pfh1y44 _syaz1f62 _ect4bzd7 _1wyb7vkz _k48p1nn1 _vwz41tcg"
                                        ]),
                                        style: {
                                            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400")),
                                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                        },
                                        children: subtitle
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1pfhzwfg _1rwyidpf"
                                        ]),
                                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
                                            href: (0, $3FBn4.useLocalizedHref)("/customers/roblox"),
                                            onClick: handleClick,
                                            className: (0, $esG4f.default)([
                                                "_syazcqtm"
                                            ]),
                                            style: {
                                                "--_r4erkq": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue400"))
                                            },
                                            children: [
                                                ctaText,
                                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $fFExq.ArrowRight), {})
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $79Fc3.TestimonialCard), {
                    image: "https://dam-cdn.atl.orangelogic.com/AssetLink/thb1c563p4m28u32ri7fe867jx24dxpl.webp",
                    quote: intl.formatMessage({
                        id: "jira-product-tour.testimonial-section.quote-text",
                        defaultMessage: "Before, our team saw Atlassian as individual tools...Now, [features & integrations] like Jira macros & Smart Links have really been pivotal in collaboration, productivity, & discoverability."
                    }),
                    name: intl.formatMessage({
                        id: "jira-product-tour.testimonial-section.name-text",
                        defaultMessage: "Joe Cotant"
                    }),
                    title: intl.formatMessage({
                        id: "jira-product-tour.testimonial-section.job-title-text",
                        defaultMessage: "Senior Technical Program Manager, Roblox"
                    })
                })
            ]
        })
    });
};
$d9a9d23c92c85c34$export$1b0efcc7c1027c88.displayName = "TestimonialSection";
const $d9a9d23c92c85c34$var$sectionContainer = null;
const $d9a9d23c92c85c34$var$testimonialContainer = null;
const $d9a9d23c92c85c34$var$testimonialContentContainer = null;
const $d9a9d23c92c85c34$var$leftContainer = null;
const $d9a9d23c92c85c34$var$contentStyles = null;
const $d9a9d23c92c85c34$var$headingStyles = null;
const $d9a9d23c92c85c34$var$subtitleStyles = null;
const $d9a9d23c92c85c34$var$linkStyles = null;
const $d9a9d23c92c85c34$var$anchorStyles = null;
const $d9a9d23c92c85c34$var$starStyles = null;

});


parcelRegister("4SPlL", function(module, exports) {

$parcel$export(module.exports, "Footer", function () { return $3b53ceb08ed62362$export$a06f1c675e846f6f; });

var $loA2J = parcelRequire("loA2J");

var $kex29 = parcelRequire("kex29");
const $3b53ceb08ed62362$export$a06f1c675e846f6f = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
    });
};
$3b53ceb08ed62362$export$a06f1c675e846f6f.displayName = "Footer";

});

parcelRegister("amOtK", function(module, exports) {

$parcel$export(module.exports, "LoggedOutHeroSection", function () { return $a3f6d0e2e3781a04$export$a8760ddc663c337c; });
/* logged-out-hero-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("6EIiq");
var $i9Hfh = parcelRequire("i9Hfh");
var $bwq2g = parcelRequire("bwq2g");

var $fRWcM = parcelRequire("fRWcM");

var $8nZ6Z = parcelRequire("8nZ6Z");
const $a3f6d0e2e3781a04$export$a8760ddc663c337c = ()=>{
    const intl = (0, $f6qj2.default)();
    const headerContent = {
        mainHeadingFirstPart: intl.formatMessage({
            id: "jira-product-tour.hero-header.first-header-text",
            defaultMessage: "Great outcomes"
        }),
        mainHeadingSecondPart: intl.formatMessage({
            id: "jira-product-tour.hero-header.second-header-text",
            defaultMessage: "start with Jira"
        }),
        subHeading: intl.formatMessage({
            id: "jira-product-tour.hero-header.sub-header-text",
            defaultMessage: "The only project management tool you need to plan and track work across every team."
        }),
        buttonText: intl.formatMessage({
            id: "jira-product-tour.hero-header.button-text",
            defaultMessage: "Get Jira free"
        })
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1MbAx.FeatureExposed), {
        experimentKey: "jfind-jpto-organic-optimize-embedded-signup",
        group: "Test",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_bfhk1hxd _1bsb1osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _p12f1qe4 _4cvr1h6o _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulpckbl _tl28idpf _axwi1tcg _1hwcidpf _sp8t1tcg _1gde1bp4 _1wm01tcg"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $fRWcM.LoggedOutHeader), (0, $7Knp0._)({}, headerContent)),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_p12fkbql _1bsb1osq _1wafckbl"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8nZ6Z.LoggedOutJiraProductTourAccountCreation), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $i9Hfh.HeroCards), {})
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bwq2g.LogoBanner), {})
        ]
    });
};
$a3f6d0e2e3781a04$export$a8760ddc663c337c.displayName = "LoggedOutHeroSection";
const $a3f6d0e2e3781a04$var$heroStyles = null;
const $a3f6d0e2e3781a04$var$containerStyles = null;
const $a3f6d0e2e3781a04$var$formStyles = null;

});
parcelRegister("fRWcM", function(module, exports) {

$parcel$export(module.exports, "LoggedOutHeader", function () { return $2bb7663f6200a070$export$e0bdd3a7befb091b; });
/* logged-out-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $5ohHq = parcelRequire("5ohHq");

var $9iWJ8 = parcelRequire("9iWJ8");
const $2bb7663f6200a070$export$e0bdd3a7befb091b = ({ subHeading: subHeading, testGWP7617Experiment: testGWP7617Experiment })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const gwp7617Experiment = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).gwp7617JiraShortTermAiInfusionExperiment);
    const useGWP7617Experiment = testGWP7617Experiment || gwp7617Experiment != undefined && gwp7617Experiment.type === "enrolled" && gwp7617Experiment.value === "test";
    const mainHeading = useGWP7617Experiment ? formatMessage({
        id: "jira-product-tour.hero-header.header-text-gwp-7617",
        defaultMessage: "<strong>Focus <br></br>on <span>outcomes,</span></strong><br></br> not admin"
    }, {
        strong: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                children: text
            }),
        span: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)("span", {
                children: text
            }),
        br: ()=>/*#__PURE__*/ (0, $loA2J.jsx)("br", {})
    }) : formatMessage({
        id: "jira-product-tour.hero-header.header-text",
        defaultMessage: "<strong>Great outcomes</strong> start with <em>Jira</em>"
    }, {
        strong: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                children: text
            }),
        em: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)("em", {
                children: text
            })
    });
    const displayedSubheading = useGWP7617Experiment ? formatMessage({
        id: "jira-product-tour.hero-header.subheading-text-gwp-7617",
        defaultMessage: "AI-powered project management that removes the work around work."
    }) : subHeading;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "logged-out-header",
        className: (0, $esG4f.default)([
            "_1e0c11p5 _p12f1y37 _6a6zv2br _jzgezwfg _1rkbko4j _zzsz1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_syaz1hlo _1wyb14no _k48p4jg8 _1bsb1osq _vwz41gnr _2h8iglyw _60qa8n31 _1fxr1ule _cq6t4jg8 _a7ooh2mm _143949fr _mnurmgnk _c9e31f51 _1vd9b3bt _h9bzgktf _1x9td439 _odmg12gs _1sphmyb0 _1sbfstnw _vr2wh2mm _15lnbx14 _vvh0mgnk _12ng1f51 _140bb3bt _18ywo7ao _1mt1yjp0 _tedggktf _h3qd1y44 _1yl3stnw _erwr1nu9 _15701ule _flz0ckbl _17q314id _fz891k4y _k5t0yjp0 _xsmr1h6o"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                },
                children: mainHeading
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_ect4bzd7 _k48p1nn1 _1wybgktf _vwz41f4h _syaz1hlo _so7d7vkz _19q11ou6 _xsmr1h6o"
                ]),
                style: {
                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                },
                children: displayedSubheading
            })
        ]
    });
};
const $2bb7663f6200a070$var$sectionStyles = null;
const $2bb7663f6200a070$var$subheadingStyles = null;
const $2bb7663f6200a070$var$mainHeadingStyles = null;

});

parcelRegister("8nZ6Z", function(module, exports) {

$parcel$export(module.exports, "LoggedOutJiraProductTourAccountCreation", function () { return $da9c13a6fbe55892$export$f1c46015a9dcb031; });

var $loA2J = parcelRequire("loA2J");

var $axg8K = parcelRequire("axg8K");
var $aZTjH = parcelRequire("aZTjH");

var $9iWJ8 = parcelRequire("9iWJ8");
const $da9c13a6fbe55892$export$f1c46015a9dcb031 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.default), {
        Login: null,
        Social: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9iWJ8.ExperimentView), {
            experiment: (0, $9iWJ8.experiments).cfind4311JiraEliminateMicrosoftSignup,
            render: (value)=>{
                if (value) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aZTjH.Social), {
                    providers: {
                        google: "Google"
                    }
                });
                return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aZTjH.Social), {
                    providers: {
                        google: "Google",
                        microsoft: "Microsoft"
                    }
                });
            }
        })
    });

});
parcelRegister("axg8K", function(module, exports) {
$parcel$export(module.exports, "Input", function () { return (parcelRequire("dKFLo")).Input; });
$parcel$export(module.exports, "InputIcon", function () { return (parcelRequire("fuUhM")).InputIcon; });
$parcel$export(module.exports, "Login", function () { return (parcelRequire("9CUtk")).Login; });
$parcel$export(module.exports, "LogoButton", function () { return (parcelRequire("fYPhW")).LogoButton; });
$parcel$export(module.exports, "ProviderLogo", function () { return (parcelRequire("fYPhW")).ProviderLogo; });
$parcel$export(module.exports, "Separator", function () { return (parcelRequire("4kWD7")).Separator; });
$parcel$export(module.exports, "Social", function () { return (parcelRequire("aZTjH")).Social; });
$parcel$export(module.exports, "Submit", function () { return (parcelRequire("g9fB0")).Submit; });
$parcel$export(module.exports, "useAccountCreationContext", function () { return (parcelRequire("a3QsU")).useAccountCreationContext; });

$parcel$export(module.exports, "default", function () { return $1e3a62a4f38e1eb2$export$2e2bcd8739ae039; });

var $gX3Qo = parcelRequire("gX3Qo");
parcelRequire("5Hsvq");
parcelRequire("gZnXH");
var $1e3a62a4f38e1eb2$export$2e2bcd8739ae039 = (0, $gX3Qo.AccountCreation);

});
parcelRegister("gX3Qo", function(module, exports) {

$parcel$export(module.exports, "AccountCreation", function () { return $f814c25b4c9544dc$export$b841b541bc741e79; });

var $7Knp0 = parcelRequire("7Knp0");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");
parcelRequire("5Hsvq");
var $2bT0L = parcelRequire("2bT0L");
parcelRequire("gZnXH");
var $a3QsU = parcelRequire("a3QsU");
const $f814c25b4c9544dc$export$b841b541bc741e79 = (_param)=>/*#__PURE__*/ {
    var { identityCobranding: identityCobranding, templateId: templateId } = _param, props = (0, $akGnX._)(_param, [
        "identityCobranding",
        "templateId"
    ]);
    return (0, $loA2J.jsx)((0, $a3QsU.AccountCreationContextProvider), {
        identityCobranding: identityCobranding,
        templateId: templateId,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2bT0L.Content), (0, $7Knp0._)({}, props))
    });
};

});
parcelRegister("5Hsvq", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return (parcelRequire("2bT0L")).Content; });
$parcel$export(module.exports, "Input", function () { return (parcelRequire("dKFLo")).Input; });
$parcel$export(module.exports, "InputIcon", function () { return (parcelRequire("fuUhM")).InputIcon; });
$parcel$export(module.exports, "Login", function () { return (parcelRequire("9CUtk")).Login; });
$parcel$export(module.exports, "Separator", function () { return (parcelRequire("4kWD7")).Separator; });
$parcel$export(module.exports, "LogoButton", function () { return (parcelRequire("fYPhW")).LogoButton; });
$parcel$export(module.exports, "ProviderLogo", function () { return (parcelRequire("fYPhW")).ProviderLogo; });
$parcel$export(module.exports, "Social", function () { return (parcelRequire("aZTjH")).Social; });
$parcel$export(module.exports, "Submit", function () { return (parcelRequire("g9fB0")).Submit; });
parcelRequire("a7tWk");
parcelRequire("iBEnu");
parcelRequire("bJf1a");
parcelRequire("7WH0a");
parcelRequire("fA47Y");
parcelRequire("4kWD7");
parcelRequire("80xo3");
parcelRequire("cGC0Q");

});
parcelRegister("a7tWk", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return (parcelRequire("2bT0L")).Content; });
parcelRequire("2bT0L");

});
parcelRegister("2bT0L", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $23ac6fbd88a3dc80$export$7c6e2c02157bb7d2; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $6oKbD = parcelRequire("6oKbD");
parcelRequire("gZnXH");
var $a3QsU = parcelRequire("a3QsU");
parcelRequire("iBEnu");
var $3k7s7 = parcelRequire("3k7s7");
parcelRequire("bJf1a");
var $dKFLo = parcelRequire("dKFLo");
parcelRequire("fA47Y");
var $9CUtk = parcelRequire("9CUtk");

var $4kWD7 = parcelRequire("4kWD7");
parcelRequire("80xo3");
var $aZTjH = parcelRequire("aZTjH");
parcelRequire("cGC0Q");
var $g9fB0 = parcelRequire("g9fB0");
const $23ac6fbd88a3dc80$export$7c6e2c02157bb7d2 = ({ Submit: Submit = /*#__PURE__*/ (0, $loA2J.jsx)((0, $g9fB0.Submit), {}), Input: Input = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dKFLo.Input), {}), Social: Social = /*#__PURE__*/ (0, $loA2J.jsx)((0, $aZTjH.Social), {}), Separator: Separator = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4kWD7.Separator), {}), Error: Error = /*#__PURE__*/ (0, $loA2J.jsx)((0, $3k7s7.Error), {}), Login: Login = /*#__PURE__*/ (0, $loA2J.jsx)((0, $9CUtk.Login), {}) })=>{
    const { onSubmitWithReCAPTCHA: onSubmitWithReCAPTCHA } = (0, $a3QsU.useAccountCreationContext)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $6oKbD.default), {
                onSubmit: onSubmitWithReCAPTCHA,
                isDisabled: false,
                children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $loA2J.jsxs)("form", (0, $6iHNw._)((0, $7Knp0._)({}, formProps), {
                        autoComplete: "off",
                        "data-testid": "account-creation",
                        children: [
                            Input,
                            Submit
                        ]
                    }))
            }),
            Error,
            Separator,
            Social,
            Login
        ]
    });
};

});
parcelRegister("gZnXH", function(module, exports) {
$parcel$export(module.exports, "AccountCreationContextProvider", function () { return (parcelRequire("a3QsU")).AccountCreationContextProvider; });
$parcel$export(module.exports, "useAccountCreationContext", function () { return (parcelRequire("a3QsU")).useAccountCreationContext; });
parcelRequire("a3QsU");

});
parcelRegister("a3QsU", function(module, exports) {

$parcel$export(module.exports, "useAccountCreationContext", function () { return $48ea53e91458f1c9$export$30b295205cfae694; });
$parcel$export(module.exports, "AccountCreationContextProvider", function () { return $48ea53e91458f1c9$export$b0a1b3550379fc78; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $eZAyW = parcelRequire("eZAyW");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $jgJpJ = parcelRequire("jgJpJ");
parcelRequire("f0Hih");
var $dhmEV = parcelRequire("dhmEV");

var $iMdoL = parcelRequire("iMdoL");

var $gkhN4 = parcelRequire("gkhN4");

var $9iWJ8 = parcelRequire("9iWJ8");

var $lrVTP = parcelRequire("lrVTP");

var $dWbel = parcelRequire("dWbel");
const { IDENTITY_USER_SIGNUP_API: $48ea53e91458f1c9$var$IDENTITY_USER_SIGNUP_API } = (0, $jgJpJ.UfoCustomTimingKey);
const $48ea53e91458f1c9$export$52bc2238e0ff8657 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $48ea53e91458f1c9$export$30b295205cfae694 = ()=>{
    const context = (0, $iSvIT.useContext)($48ea53e91458f1c9$export$52bc2238e0ff8657);
    if (!context) throw new Error("useAccountCreationContext must be used within a AccountCreationContextProvider");
    return context;
};
const $48ea53e91458f1c9$export$b0a1b3550379fc78 = ({ identityCobranding: identityCobranding = "wac", templateId: templateId, children: children })=>{
    const location = (0, $lrVTP.useLocation)();
    const isEmbedded = !location.pathname.endsWith("/try/cloud/signup");
    const { product: product, edition: edition } = (0, $iMdoL.useUserContext)();
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const intl = (0, $f6qj2.default)();
    const [isEmailValid, setIsEmailValid] = (0, $iSvIT.useState)(false);
    const [hasSubmitted, setHasSubmitted] = (0, $iSvIT.useState)(false);
    const [isReadyForInvalid, setIsReadyForInvalid] = (0, $iSvIT.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $iSvIT.useState)(false);
    const [formError, setFormError] = (0, $iSvIT.useState)(false);
    const [_email, setEmail] = (0, $iSvIT.useState)("");
    const [typeAheadEmail, setTypeAheadEmail] = (0, $iSvIT.useState)("");
    const [onSubmitProps, setOnSubmitProps] = (0, $iSvIT.useState)(undefined);
    const [recaptchaFailedToLoad, setRecaptchaFailedToLoad] = (0, $iSvIT.useState)(false);
    const [recaptchaRetryTimeRemainingSecond, setRecaptchaRetryTimeRemainingSecond] = (0, $iSvIT.useState)(60);
    const [tryIntentAnalyticsEventHasFired, setTryIntentAnalyticsEventHasFired] = (0, $iSvIT.useState)(false);
    const localePath = (0, $jgJpJ.getLocalePath)(intl.locale);
    const signupClient = (0, $gkhN4.useBxpWebStargateClient)();
    const { executeRecaptcha: executeRecaptcha } = (0, $eZAyW.useGoogleReCaptcha)();
    const continueParam = (0, $jgJpJ.getContinueParam)(location);
    // identity interstitial redirect experiments
    const redirectExperiments = [
        (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).cfind4802JiraAccountCreationRedirect)
    ];
    const dataFoundationsActionSubjectId = !!isEmbedded ? "embedded" : "standalone";
    // default experiment params
    if (identityCobranding === "wac") {
        if ((product === null || product === void 0 ? void 0 : product.name) === "confluence") identityCobranding = "wac--otp-confluence";
        else if ((product === null || product === void 0 ? void 0 : product.name) === "jira") identityCobranding = "wac--otp-jira";
        else if ((product === null || product === void 0 ? void 0 : product.name) === "loom") identityCobranding = "wac--loom";
        else if ((product === null || product === void 0 ? void 0 : product.name) === "jira-product-discovery") identityCobranding = "wac--jpd";
        else if ((product === null || product === void 0 ? void 0 : product.name) === "jira-servicedesk") identityCobranding = "wac--jsm";
    }
    const redirectTo = continueParam ? continueParam : (0, $jgJpJ.getNameYourSiteRedirectUrl)({
        bundle: product === null || product === void 0 ? void 0 : product.bundle,
        edition: edition,
        localePath: localePath,
        templateId: templateId,
        application: identityCobranding
    });
    (0, $iSvIT.useEffect)(()=>{
        if (!analyticsClient) return;
        (0, $jgJpJ.trackDataFoundationsAccountCreationComponent)(createAnalyticsEvent, {
            actionSubjectId: dataFoundationsActionSubjectId,
            productKey: product === null || product === void 0 ? void 0 : product.key,
            edition: edition
        });
        (0, $jgJpJ.ufoEventSignupFormLoad).success({
            customData: {
                webPlatform: "bxp-ui",
                reactComponent: "DefaultSignupForm",
                isLoggedIn: false
            }
        });
        (0, $jgJpJ.trackSignFormLoad)(createAnalyticsEvent);
        (0, $jgJpJ.trackTimeToFormReady)(createAnalyticsEvent, performance.now());
    }, [
        createAnalyticsEvent,
        edition,
        product === null || product === void 0 ? void 0 : product.key,
        dataFoundationsActionSubjectId,
        analyticsClient
    ]);
    const onSubmitWithReCAPTCHA = (0, $iSvIT.useCallback)(async ({ email: email })=>{
        setIsReadyForInvalid(true);
        if (!email || !isEmailValid) {
            (0, $jgJpJ.trackInvalidEmail)(createAnalyticsEvent);
            return;
        }
        // check identity interstitial redirect experiments for enrollment
        if (redirectExperiments.some(({ type: type })=>type === "enrolled")) {
            redirectExperiments.forEach((experiment)=>{
                if (experiment.type === "enrolled") experiment.fireExposure();
            });
            const shouldRedirectToInterstitial = redirectExperiments.some((experiment)=>experiment.type === "enrolled" && experiment.value);
            if (shouldRedirectToInterstitial) {
                const url = (0, $jgJpJ.getIdentityInterstitialUrl)(email, redirectTo, identityCobranding);
                window.location.assign(url);
                return;
            }
        }
        setOnSubmitProps({
            email: email
        });
        setIsSubmitting(true);
        if (!executeRecaptcha && recaptchaRetryTimeRemainingSecond > 0) {
            // set trigger that will wait for Recaptcha retry logic
            setFormError(true);
            setIsSubmitting(false);
            setRecaptchaFailedToLoad(true);
            return;
        }
        setRecaptchaFailedToLoad(false);
        // Start UFO to begin duration measurements for account creation
        (0, $jgJpJ.ufoEventAccountCreation).start({
            productKey: product === null || product === void 0 ? void 0 : product.key,
            webPlatform: "bxp-ui"
        });
        const gRecaptchaResponse = await (0, $jgJpJ.getRecaptcha)(email, executeRecaptcha);
        (0, $jgJpJ.ufoEventAccountCreation).setCustomData({
            gRecaptchaResponse: gRecaptchaResponse !== null && gRecaptchaResponse !== void 0 ? gRecaptchaResponse : "none",
            executeRecaptchaExists: Boolean(executeRecaptcha),
            reactComponent: "AccountCreationContextProvider"
        });
        // Handle missing reCAPTCHA response
        if (!gRecaptchaResponse) {
            (0, $jgJpJ.trackRecaptchaFailure)(createAnalyticsEvent, "account-creation");
            const invalidRecaptchaError = new Error("Missing reCAPTCHA token");
            (0, $jgJpJ.ufoEventAccountCreation).failure({
                customData: {
                    reactComponent: "AccountCreationContextProvider"
                },
                error: invalidRecaptchaError
            });
            throw invalidRecaptchaError;
        }
        (0, $jgJpJ.trackFormSubmit)(createAnalyticsEvent, product === null || product === void 0 ? void 0 : product.key, edition);
        const existingUserRedirectUrl = await (0, $jgJpJ.getMethodsAvailableRedirection)({
            email: email,
            application: identityCobranding,
            signupClient: signupClient,
            createAnalyticsEvent: createAnalyticsEvent,
            successRedirect: redirectTo
        }).catch((error)=>{
            setFormError(true);
            setIsSubmitting(false);
            (0, $jgJpJ.trackSignupFailure)(createAnalyticsEvent);
            throw new Error(error);
        });
        if (existingUserRedirectUrl) {
            window.location.assign(existingUserRedirectUrl.replace("/initiate/password", ""));
            return;
        }
        const newUserRedirectTo = redirectTo + `&n2n=true`;
        (0, $jgJpJ.ufoEventAccountCreation).startSubstep($48ea53e91458f1c9$var$IDENTITY_USER_SIGNUP_API);
        await signupClient.userSignup({
            application: identityCobranding,
            displayName: "",
            email: email,
            gRecaptchaResponse: gRecaptchaResponse,
            locale: intl.locale,
            products: [
                {
                    productKey: (product === null || product === void 0 ? void 0 : product.key) || (0, $jgJpJ.ProductKey).JIRA_SOFTWARE,
                    edition: edition || "free"
                }
            ],
            redirectTo: newUserRedirectTo
        }).then(({ otpRedirect: otpRedirect })=>{
            (0, $jgJpJ.ufoEventAccountCreation).endSubstep($48ea53e91458f1c9$var$IDENTITY_USER_SIGNUP_API);
            if (!otpRedirect) throw new Error("No OTP redirect");
            // Reliability SLO "good event" metric emitted for submit account creation
            (0, $jgJpJ.ufoEventAccountCreation).success({
                customData: {
                    reactComponent: "AccountCreationContextProvider"
                }
            });
            (0, $jgJpJ.trackSubmitSuccess)(createAnalyticsEvent);
            window.location.assign(otpRedirect);
        }).catch((error)=>{
            // Reliability SLO "bad event" metric emitted for submit account creation
            (0, $jgJpJ.ufoEventAccountCreation).endSubstep($48ea53e91458f1c9$var$IDENTITY_USER_SIGNUP_API);
            (0, $jgJpJ.ufoEventAccountCreation).failure({
                customData: {
                    reactComponent: "AccountCreationContextProvider"
                },
                error: error
            });
            setEmail(email);
            setFormError(true);
            setHasSubmitted(true);
            setIsSubmitting(false);
            (0, $jgJpJ.trackSignupFailure)(createAnalyticsEvent);
            throw new Error(error);
        });
    }, [
        createAnalyticsEvent,
        edition,
        executeRecaptcha,
        identityCobranding,
        intl.locale,
        isEmailValid,
        product,
        recaptchaRetryTimeRemainingSecond,
        redirectTo,
        signupClient
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (recaptchaFailedToLoad && recaptchaRetryTimeRemainingSecond <= 0) (0, $jgJpJ.ufoEventAccountCreation).failure({
            customData: {
                reactComponent: "AccountCreationContextProvider",
                recaptchaRetryTimeRemainingSecond: 0
            },
            error: new Error("Recaptcha retry failed")
        });
        if (onSubmitProps && recaptchaFailedToLoad && executeRecaptcha) onSubmitWithReCAPTCHA(onSubmitProps).then(()=>{
            (0, $jgJpJ.ufoEventAccountCreation).success({
                customData: {
                    reactComponent: "AccountCreationContextProvider",
                    analyticsEvent: "succeeded",
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                }
            });
        }).catch((error)=>{
            setFormError(true);
            (0, $jgJpJ.ufoEventAccountCreation).failure({
                customData: {
                    reactComponent: "AccountCreationContextProvider",
                    analyticsEvent: "errored",
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                },
                error: error
            });
            return;
        }).finally(()=>{
            setIsSubmitting(false);
        });
    }, [
        executeRecaptcha,
        recaptchaFailedToLoad,
        onSubmitProps,
        onSubmitWithReCAPTCHA,
        recaptchaRetryTimeRemainingSecond
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (!recaptchaFailedToLoad) return;
        if (recaptchaRetryTimeRemainingSecond <= 0) return;
        const intervalId = setInterval(()=>{
            setRecaptchaRetryTimeRemainingSecond(recaptchaRetryTimeRemainingSecond - 1);
        }, 1000);
        return ()=>clearInterval(intervalId);
    }, [
        recaptchaFailedToLoad,
        recaptchaRetryTimeRemainingSecond
    ]);
    const onClickSocialButton = (provider)=>{
        (0, $jgJpJ.trackContinueWithSocialSignups)(createAnalyticsEvent, provider, product === null || product === void 0 ? void 0 : product.key, edition);
        const socialRedirectUrl = (0, $jgJpJ.getSocialButtonUrl)({
            redirectTo: redirectTo,
            identityCobranding: identityCobranding,
            provider: provider
        });
        window.location.assign(socialRedirectUrl);
    };
    const onClickSubmitButton = ()=>(0, $jgJpJ.trackSubmitButtonClick)(createAnalyticsEvent);
    return /*#__PURE__*/ (0, $loA2J.jsx)($48ea53e91458f1c9$export$52bc2238e0ff8657.Provider, {
        value: {
            dataFoundationsActionSubjectId: dataFoundationsActionSubjectId,
            edition: edition,
            formError: formError,
            hasSubmitted: hasSubmitted,
            identityCobranding: identityCobranding,
            isReadyForInvalid: isReadyForInvalid,
            isSubmitting: isSubmitting,
            onClickSocialButton: onClickSocialButton,
            onClickSubmitButton: onClickSubmitButton,
            onSubmitWithReCAPTCHA: onSubmitWithReCAPTCHA,
            product: product,
            redirectTo: redirectTo,
            setIsEmailValid: setIsEmailValid,
            setIsReadyForInvalid: setIsReadyForInvalid,
            setTypeAheadEmail: setTypeAheadEmail,
            typeAheadEmail: typeAheadEmail,
            tryIntentAnalyticsEventHasFired: tryIntentAnalyticsEventHasFired
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dhmEV.default), {
            edition: edition,
            intentType: "form",
            productKey: product === null || product === void 0 ? void 0 : product.key,
            onAnalyticsEventFired: ()=>!tryIntentAnalyticsEventHasFired && setTryIntentAnalyticsEventHasFired(true),
            children: children
        })
    });
};

});


parcelRegister("iBEnu", function(module, exports) {
$parcel$export(module.exports, "Error", function () { return (parcelRequire("3k7s7")).Error; });
parcelRequire("3k7s7");

});
parcelRegister("3k7s7", function(module, exports) {

$parcel$export(module.exports, "Error", function () { return $665309e9abc4fc8b$export$edf27be85e5f6da0; });
/* error.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $1UUq1 = parcelRequire("1UUq1");
parcelRequire("gZnXH");
var $a3QsU = parcelRequire("a3QsU");
const $665309e9abc4fc8b$export$edf27be85e5f6da0 = ({ errorText: errorText })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $f6qj2.default)();
    const { formError: formError } = (0, $a3QsU.useAccountCreationContext)();
    if (!formError) return null;
    if (errorText === undefined) errorText = locale === "en" ? formatMessage({
        id: "AccountCreation.userSignupError",
        defaultMessage: `It's taking longer than expected to get you started. Please refresh and try again or <contactUsLink>contact us</contactUsLink>.`
    }, {
        contactUsLink: $665309e9abc4fc8b$var$contactUsLink
    }) : formatMessage({
        id: "BxpUiSignup.SignupForm.formError",
        defaultMessage: "It's taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <contactUsLink>contact us</contactUsLink>."
    }, {
        contactUsLink: $665309e9abc4fc8b$var$contactUsLink
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("p", {
        role: "alert",
        className: (0, $esG4f.default)([
            "_syaz1cjc _19pk1j6v _2hwxidpf _otyr1j6v _18u0idpf _3fcw150s"
        ]),
        children: errorText
    });
};
const $665309e9abc4fc8b$var$contactUsLink = (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
        text: text,
        "aria-label": text,
        type: "inline",
        href: "/company/contact",
        className: "linkText"
    });
const $665309e9abc4fc8b$var$errorCss = null;

});


parcelRegister("bJf1a", function(module, exports) {
$parcel$export(module.exports, "Input", function () { return (parcelRequire("dKFLo")).Input; });
parcelRequire("dKFLo");

});
parcelRegister("dKFLo", function(module, exports) {

$parcel$export(module.exports, "Input", function () { return $4d62c2fdd6741ebb$export$f5b8910cec6cf069; });
/* input.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $26kkA = parcelRequire("26kkA");

var $7OGW4 = parcelRequire("7OGW4");

var $jgJpJ = parcelRequire("jgJpJ");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("gZnXH");
var $a3QsU = parcelRequire("a3QsU");
parcelRequire("7WH0a");
var $fuUhM = parcelRequire("fuUhM");
const $4d62c2fdd6741ebb$var$HELP_TEXT_ID = "account_creation_email_help_text";
const $4d62c2fdd6741ebb$export$f5b8910cec6cf069 = ({ helpText: helpText, errorMessageText: errorMessageText, labelText: labelText, placeholderText: placeholderText })=>{
    const { isReadyForInvalid: isReadyForInvalid, setIsEmailValid: setIsEmailValid, setIsReadyForInvalid: setIsReadyForInvalid, setTypeAheadEmail: setTypeAheadEmail, typeAheadEmail: typeAheadEmail } = (0, $a3QsU.useAccountCreationContext)();
    const [email, setEmail] = (0, $iSvIT.useState)(typeAheadEmail);
    const [isValid, setValid] = (0, $iSvIT.useState)();
    const intl = (0, $f6qj2.default)();
    if (helpText === undefined) helpText = intl.formatMessage({
        id: "signupForm.accountCreation.helperText",
        defaultMessage: "Using a work email helps find teammates and boost collaboration."
    });
    if (errorMessageText === undefined) errorMessageText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.invalidEmail",
        defaultMessage: "Please enter a valid email address."
    });
    if (labelText === undefined) labelText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.workEmail",
        defaultMessage: "Work email"
    });
    if (placeholderText === undefined) placeholderText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.emailPlaceholder",
        defaultMessage: "you@company.com"
    });
    (0, $iSvIT.useEffect)(()=>{
        const isValid = (0, $jgJpJ.emailIsValid)(email); // wait to show invalid state if the user is not finished typing
        if (!isValid && !isReadyForInvalid) {
            setValid(undefined);
            return;
        }
        setValid(isValid);
        setIsEmailValid(isValid);
    }, [
        email,
        setIsEmailValid,
        isReadyForInvalid
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_6rth7vkz _1rwq121t _1heubzd7 _125x1syg _62vcmccc _1d6jidpf _1t2q1kw7 _17rnbzd7 _1q9pbfng _d78pglyw"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
            "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $26kkA.default), {
            "aria-required": true,
            isRequired: true,
            label: labelText,
            name: "email",
            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_zbay183y",
                        isValid === true && "_1lo6qn1y",
                        isValid === false && "_1lo61wfy"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OGW4.default), (0, $6iHNw._)((0, $7Knp0._)({}, fieldProps), {
                            autoComplete: "email",
                            "aria-describedby": $4d62c2fdd6741ebb$var$HELP_TEXT_ID,
                            elemAfterInput: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fuUhM.InputIcon), {
                                valid: isValid
                            }),
                            onBlur: ()=>setIsReadyForInvalid(true),
                            onChange: (e)=>{
                                setEmail(e.target.value);
                                setTypeAheadEmail(e.target.value);
                                fieldProps.onChange(e);
                            },
                            placeholder: placeholderText,
                            testId: "email_field",
                            type: "email",
                            value: email
                        })),
                        isValid === false ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            id: $4d62c2fdd6741ebb$var$HELP_TEXT_ID,
                            role: "alert",
                            className: (0, $esG4f.default)([
                                "_syaz1tmw _1wybepq8 _vwz4bs82 _1pfhi2wt"
                            ]),
                            style: {
                                "--_1h1y5xv": (0, $43MIc.default)((0, $jgJpJ.fontSize).xs)
                            },
                            children: errorMessageText
                        }) : helpText ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            id: $4d62c2fdd6741ebb$var$HELP_TEXT_ID,
                            className: (0, $esG4f.default)([
                                "_syaz1io3 _1wybepq8 _vwz4bs82 _1pfhi2wt"
                            ]),
                            style: {
                                "--_138lqrp": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark500")),
                                "--_1h1y5xv": (0, $43MIc.default)((0, $jgJpJ.fontSize).xs)
                            },
                            children: helpText
                        }) : null
                    ]
                })
        })
    });
};
const $4d62c2fdd6741ebb$var$errorMessageCss = null;
const $4d62c2fdd6741ebb$var$helpTextCss = null;
const $4d62c2fdd6741ebb$var$fieldCss = null;
const $4d62c2fdd6741ebb$var$inputCss = null;
const $4d62c2fdd6741ebb$var$inputInvalidCss = null;
const $4d62c2fdd6741ebb$var$inputValidCss = null;

});
parcelRegister("7WH0a", function(module, exports) {
$parcel$export(module.exports, "InputIcon", function () { return (parcelRequire("fuUhM")).InputIcon; });
parcelRequire("fuUhM");

});
parcelRegister("fuUhM", function(module, exports) {

$parcel$export(module.exports, "InputIcon", function () { return $7d9f88f07b8cb2ac$export$f8fea9f50a4bfae6; });
/* input-icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $bDTBs = parcelRequire("bDTBs");

var $1EpFI = parcelRequire("1EpFI");

var $jgJpJ = parcelRequire("jgJpJ");

var $5ohHq = parcelRequire("5ohHq");
const $7d9f88f07b8cb2ac$export$f8fea9f50a4bfae6 = ({ valid: valid })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const validMessage = formatMessage({
        id: "signupForm.accountCreation.validEmailIcon",
        defaultMessage: "Success"
    });
    const invalidMessage = formatMessage({
        id: "signupForm.accountCreation.invalidEmailIcon",
        defaultMessage: "Warning"
    });
    if (valid === undefined) return null;
    return valid ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _lswucd5j _1wyb1syg _y4tiftgi _syaz1ua5"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bDTBs))), {
            label: validMessage,
            size: "medium"
        })
    }) : /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _lswucd5j _1wyb1syg _y4tiftgi _syaz1bqt"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1EpFI))), {
            label: invalidMessage,
            size: "medium"
        })
    });
};
const $7d9f88f07b8cb2ac$var$iconWrapperStyle = {
    alignItems: "center",
    display: "flex",
    fill: (0, $5ohHq.wacToken)("color.neutral.light0"),
    fontSize: (0, $jgJpJ.fontSize).md,
    paddingInlineEnd: 8
};
const $7d9f88f07b8cb2ac$var$iconValidCss = null;
const $7d9f88f07b8cb2ac$var$iconInvalidCss = null;

});




parcelRegister("fA47Y", function(module, exports) {
$parcel$export(module.exports, "Login", function () { return (parcelRequire("9CUtk")).Login; });
parcelRequire("9CUtk");

});
parcelRegister("9CUtk", function(module, exports) {

$parcel$export(module.exports, "Login", function () { return $7eb7007ec0fb9816$export$21a94553ffa41578; });
/* login.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $jgJpJ = parcelRequire("jgJpJ");

var $1UUq1 = parcelRequire("1UUq1");

var $lrVTP = parcelRequire("lrVTP");
parcelRequire("gZnXH");
var $a3QsU = parcelRequire("a3QsU");
const $7eb7007ec0fb9816$export$21a94553ffa41578 = ({ loginText: loginText })=>{
    const intl = (0, $f6qj2.default)();
    const location = (0, $lrVTP.useLocation)();
    const { product: product } = (0, $a3QsU.useAccountCreationContext)();
    if (loginText === undefined) loginText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.existingProduct",
        defaultMessage: "Already have {product}? <logInLink>Log in</logInLink>"
    }, {
        product: product === null || product === void 0 ? void 0 : product.description,
        logInLink: (text)=>$7eb7007ec0fb9816$var$logInLink(text, location)
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("p", {
        className: (0, $esG4f.default)([
            "_1wyb8oy7 _19pk14b4 _2hwxgrf3 _otyrgrf3 _18u0grf3 _y3gn1h6o"
        ]),
        style: {
            "--_djwknj": (0, $43MIc.default)((0, $jgJpJ.fontSize).sm)
        },
        children: loginText
    });
};
const $7eb7007ec0fb9816$var$logInLink = (text, location)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
        text: text,
        "aria-label": text,
        type: "inline",
        href: (0, $jgJpJ.getLoginUrl)(location)
    });
const $7eb7007ec0fb9816$var$existingProductCss = null;

});


parcelRegister("80xo3", function(module, exports) {
$parcel$export(module.exports, "LogoButton", function () { return (parcelRequire("fYPhW")).LogoButton; });
$parcel$export(module.exports, "ProviderLogo", function () { return (parcelRequire("fYPhW")).ProviderLogo; });
$parcel$export(module.exports, "Social", function () { return (parcelRequire("aZTjH")).Social; });
parcelRequire("fYPhW");
parcelRequire("aZTjH");

});
parcelRegister("aZTjH", function(module, exports) {

$parcel$export(module.exports, "Social", function () { return $a38670e4fd5fec74$export$9a0fadb2797ac9a5; });
/* social.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("gZnXH");
var $a3QsU = parcelRequire("a3QsU");

var $fYPhW = parcelRequire("fYPhW");
const $a38670e4fd5fec74$export$9a0fadb2797ac9a5 = ({ providers: providers })=>{
    const intl = (0, $f6qj2.default)();
    const { onClickSocialButton: onClickSocialButton } = (0, $a3QsU.useAccountCreationContext)();
    if (providers === undefined) providers = {
        google: "Google",
        microsoft: "Microsoft",
        apple: "Apple",
        slack: "Slack"
    };
    const buttons = Object.entries(providers);
    const buttonGridCss = null;
    const buttonListCss = null; /* eslint-disable jsx-a11y/no-redundant-roles */ 
    /* added role="list" to ul for safari https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility  */ return /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
        role: "list",
        className: (0, $esG4f.default)([
            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            buttons.length > 1 && "_1e0c11p5 _zulp7vkz _yv0efsjm"
        ]),
        children: buttons.map(([provider, label])=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $fYPhW.LogoButton), {
                    "aria-label": intl.formatMessage({
                        id: "social.label.signup",
                        defaultMessage: "sign up with {provider}"
                    }, {
                        provider: label
                    }),
                    onClick: ()=>onClickSocialButton(provider),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $fYPhW.ProviderLogo), {
                            logo: provider
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            children: label
                        })
                    ]
                })
            }, provider))
    });
};

});


parcelRegister("cGC0Q", function(module, exports) {
$parcel$export(module.exports, "Submit", function () { return (parcelRequire("g9fB0")).Submit; });
parcelRequire("g9fB0");

});
parcelRegister("g9fB0", function(module, exports) {

$parcel$export(module.exports, "Submit", function () { return $2e88de5ad09fd3a8$export$2c4cf1f7b42ef78c; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $91nJf = parcelRequire("91nJf");
parcelRequire("gZnXH");
var $a3QsU = parcelRequire("a3QsU");
const $2e88de5ad09fd3a8$export$2c4cf1f7b42ef78c = ({ buttonText: buttonText })=>{
    const intl = (0, $f6qj2.default)();
    const { isSubmitting: isSubmitting, hasSubmitted: hasSubmitted, formError: formError, onClickSubmitButton: onClickSubmitButton } = (0, $a3QsU.useAccountCreationContext)();
    if (buttonText === undefined) buttonText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.submit",
        defaultMessage: "Sign up"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
        type: "submit",
        isDisabled: isSubmitting || hasSubmitted && !formError,
        isFullWidth: true,
        isLoading: isSubmitting || hasSubmitted && !formError,
        onClick: onClickSubmitButton,
        children: buttonText
    });
};

});












parcelRegister("iiPAa", function(module, exports) {

$parcel$export(module.exports, "CheckemailPage", function () { return $95bbb137417743e7$export$137de9ee4cfd53f4; });
// @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");
parcelRequire("jcrr3");
var $d3aQP = parcelRequire("d3aQP");
const $95bbb137417743e7$export$137de9ee4cfd53f4 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $d3aQP.CheckemailPageTemplate), {});

});
parcelRegister("jcrr3", function(module, exports) {
$parcel$export(module.exports, "CheckemailPageTemplate", function () { return (parcelRequire("d3aQP")).CheckemailPageTemplate; });

var $d3aQP = parcelRequire("d3aQP");

});
parcelRegister("d3aQP", function(module, exports) {

$parcel$export(module.exports, "CheckemailPageTemplate", function () { return $f0f94192d24d77a5$export$81cea22471256edf; });
/* checkemail-page.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");

var $akWBI = parcelRequire("akWBI");

var $dZ7Yw = parcelRequire("dZ7Yw");

var $bZf8U = parcelRequire("bZf8U");
const $f0f94192d24d77a5$var$ContainerStyle = null;
const $f0f94192d24d77a5$var$InnerStyle = null;
const $f0f94192d24d77a5$export$81cea22471256edf = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _4cvr1h6o _1wpz1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_4cvr1fhb _1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _ca0q1wto _u5f31wto _n3td1wto _19bv1wto _k48p4jg8 _ect4bzd7 _xlob1h6o _szfsglyw _stfgidpf _d32voelr _dpd3116y _1o7p1osq _1r4aidpf _125m1tcg _1hbsidpf _1u71idpf _y2qtidpf _fl8bidpf _1gflidpf _yhjmidpf _1gqnidpf _11lvidpf _ficf1h6o _397o1r31 _108nglyw _uulsnqa1 _1eo0tlke _4pkprbzz _1pnjrbzz _1k4x1ltp _wlf1oelr _k58frbzz _8t1xrbzz _knlz1ltp"
            ]),
            style: {
                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Logo), {
                        type: "logo",
                        appearance: "brand",
                        brand: "atlassian"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bZf8U.EmailedYou), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $dZ7Yw.EmailButtons), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $akWBI.ContactSupport), {})
            ]
        })
    });
};

});
parcelRegister("akWBI", function(module, exports) {

$parcel$export(module.exports, "ContactSupport", function () { return $91c62826486ee1c3$export$d65ea6ee8960e96a; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $3FBn4 = parcelRequire("3FBn4");
const $91c62826486ee1c3$export$d65ea6ee8960e96a = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                style: {
                    display: "inline-block",
                    width: "22rem"
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "checkemail.didNotReceive",
                    defaultMessage: "<strong>{question}</strong> Check your spam folder.",
                    values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
                        question: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "checkemail.question",
                            defaultMessage: "Didn't receive an email?"
                        })
                    })
                })
            })
        })
    });
};

});

parcelRegister("dZ7Yw", function(module, exports) {

$parcel$export(module.exports, "EmailButtons", function () { return $23c3e5e70fe94f97$export$78d42fa1f0d70d0; });
/* email-buttons.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $6IiXU = parcelRequire("6IiXU");

var $cm1E8 = parcelRequire("cm1E8");
const $23c3e5e70fe94f97$var$overallContainerStyle = null;
const $23c3e5e70fe94f97$var$socialButtonStyles = null;
const $23c3e5e70fe94f97$var$CHECK_EMAIL_PAGE_TRACKING_EVENT_NAMES = {
    OPEN_GMAIL_CLICKED: "check_email_page_open_gmail_clicked",
    OPEN_OUTLOOK_CLICKED: "check_email_page_open_outlook_clicked"
};
const $23c3e5e70fe94f97$export$78d42fa1f0d70d0 = ()=>{
    const intl = (0, $f6qj2.default)();
    const openGmail = intl.formatMessage({
        id: "checkemail.openGmail",
        defaultMessage: "Open Gmail"
    });
    const openOutlook = intl.formatMessage({
        id: "checkemail.openOutlook",
        defaultMessage: "Open Outlook"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c116y _zulp1j6v"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_4cvr1h6o _bfhku67f _19it1s07 _2rko1l7b _vchhusvi _1e0c116y _zulpoark _1bah1h6o _19pkidpf _2hwxidpf _otyr1j6v _18u0idpf _jomr1qgq _f8pj1nct _irr31qgq _30l31nct _1ah3t94y _1ii71ule _w8l51k8s _17521k8s _12s31kwk _37z21h6o _incy116y _1sjq4jg8"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
                        appearance: "link",
                        "data-event-component": "linkButton",
                        "data-event-container": "gmailButton",
                        "data-event": "clicked",
                        "data-product-key": "checkEmail",
                        "data-name": $23c3e5e70fe94f97$var$CHECK_EMAIL_PAGE_TRACKING_EVENT_NAMES.OPEN_GMAIL_CLICKED,
                        href: "https://mail.google.com/mail/u/0/#search/atlassian+from%3A(%40atlassian.com)+in%3Aanywhere",
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: "buttonText",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $cm1E8.GmailLogo), {}),
                                openGmail
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_4cvr1h6o _bfhku67f _19it1s07 _2rko1l7b _vchhusvi _1e0c116y _zulpoark _1bah1h6o _19pkidpf _2hwxidpf _otyr1j6v _18u0idpf _jomr1qgq _f8pj1nct _irr31qgq _30l31nct _1ah3t94y _1ii71ule _w8l51k8s _17521k8s _12s31kwk _37z21h6o _incy116y _1sjq4jg8"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
                        appearance: "link",
                        href: "https://outlook.live.com/mail/0/inbox",
                        "data-event-component": "linkButton",
                        "data-event-container": "outlookButton",
                        "data-event": "clicked",
                        "data-product-key": "checkEmail",
                        "data-name": $23c3e5e70fe94f97$var$CHECK_EMAIL_PAGE_TRACKING_EVENT_NAMES.OPEN_OUTLOOK_CLICKED,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: "buttonText",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $cm1E8.OutlookLogo), {}),
                                openOutlook
                            ]
                        })
                    })
                })
            ]
        })
    });
};

});
parcelRegister("cm1E8", function(module, exports) {

$parcel$export(module.exports, "GmailLogo", function () { return $75dda975985e0fd5$export$e0989a788da1a704; });
$parcel$export(module.exports, "OutlookLogo", function () { return $75dda975985e0fd5$export$2926c6045834af46; });
$parcel$export(module.exports, "EmailLetterIcon", function () { return $75dda975985e0fd5$export$8ead1903281b785a; });

var $loA2J = parcelRequire("loA2J");
const $75dda975985e0fd5$export$e0989a788da1a704 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": "true",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "52 42 88 66",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#4285f4",
                d: "M58 108h14V74L52 59v43c0 3.32 2.69 6 6 6"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#34a853",
                d: "M120 108h14c3.32 0 6-2.69 6-6V59l-20 15"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#fbbc04",
                d: "M120 48v26l20-15v-8c0-7.42-8.47-11.65-14.4-7.2"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#ea4335",
                d: "M72 74V48l24 18 24-18v26L96 92"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#c5221f",
                d: "M52 51v8l20 15V48l-5.6-4.2c-5.94-4.45-14.4-.22-14.4 7.2"
            })
        ]
    });
const $75dda975985e0fd5$export$2926c6045834af46 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": "true",
        viewBox: "-0.12979372698077785 0 33.25199671942124 32",
        xmlns: "http://www.w3.org/2000/svg",
        width: "2500",
        height: "2397",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M28.596 2H11.404A1.404 1.404 0 0 0 10 3.404V5l9.69 3L30 5V3.404A1.404 1.404 0 0 0 28.596 2z",
                fill: "#0364b8"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M31.65 17.405A11.341 11.341 0 0 0 32 16a.666.666 0 0 0-.333-.576l-.013-.008-.004-.002L20.812 9.24a1.499 1.499 0 0 0-.145-.083 1.5 1.5 0 0 0-1.334 0 1.49 1.49 0 0 0-.145.082L8.35 15.415l-.004.002-.012.007A.666.666 0 0 0 8 16a11.344 11.344 0 0 0 .35 1.405l11.492 8.405z",
                fill: "#0a2767"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M24 5h-7l-2.021 3L17 11l7 6h6v-6z",
                fill: "#28a8ea"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M10 5h7v6h-7z",
                fill: "#0078d4"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M24 5h6v6h-6z",
                fill: "#50d9ff"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M24 17l-7-6h-7v6l7 6 10.832 1.768z",
                fill: "#0364b8"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M10.031 5H30",
                fill: "none"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M17 11h7v6h-7z",
                fill: "#0078d4"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M10 17h7v6h-7z",
                fill: "#064a8c"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M24 17h6v6h-6z",
                fill: "#0078d4"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M20.19 25.218l-11.793-8.6.495-.87s10.745 6.12 10.909 6.212a.528.528 0 0 0 .42-.012l10.933-6.23.496.869z",
                fill: "#0a2767",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M31.667 16.577l-.014.008-.003.002-10.838 6.174a1.497 1.497 0 0 1-1.46.091l3.774 5.061 8.254 1.797v.004A1.498 1.498 0 0 0 32 28.5V16a.666.666 0 0 1-.333.577z",
                fill: "#1490df"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M32 28.5v-.738l-9.983-5.688-1.205.687a1.497 1.497 0 0 1-1.46.091l3.774 5.061 8.254 1.797v.004A1.498 1.498 0 0 0 32 28.5z",
                opacity: ".05"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M31.95 28.883L21.007 22.65l-.195.11a1.497 1.497 0 0 1-1.46.092l3.774 5.061 8.254 1.797v.004a1.501 1.501 0 0 0 .57-.83z",
                opacity: ".1"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M8.35 16.59v-.01h-.01l-.03-.02A.65.65 0 0 1 8 16v12.5A1.498 1.498 0 0 0 9.5 30h21a1.503 1.503 0 0 0 .37-.05.637.637 0 0 0 .18-.06.142.142 0 0 0 .06-.02 1.048 1.048 0 0 0 .23-.13c.02-.01.03-.01.04-.03z",
                fill: "#28a8ea"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M18 24.667V8.333A1.337 1.337 0 0 0 16.667 7H10.03V14.456l-1.68.958-.005.002-.012.007A.666.666 0 0 0 8 16v.005V16 26h8.667A1.337 1.337 0 0 0 18 24.667z",
                opacity: ".1"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M17 25.667V9.333A1.337 1.337 0 0 0 15.667 8H10.03V14.456l-1.68.958-.005.002-.012.007A.666.666 0 0 0 8 16v.005V16 27h7.667A1.337 1.337 0 0 0 17 25.667z",
                opacity: ".2"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M17 23.667V9.333A1.337 1.337 0 0 0 15.667 8H10.03V14.456l-1.68.958-.005.002-.012.007A.666.666 0 0 0 8 16v.005V16 25h7.667A1.337 1.337 0 0 0 17 23.667z",
                opacity: ".2"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M16 23.667V9.333A1.337 1.337 0 0 0 14.667 8H10.03V14.456l-1.68.958-.005.002-.012.007A.666.666 0 0 0 8 16v.005V16 25h6.667A1.337 1.337 0 0 0 16 23.667z",
                opacity: ".2"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M1.333 8h13.334A1.333 1.333 0 0 1 16 9.333v13.334A1.333 1.333 0 0 1 14.667 24H1.333A1.333 1.333 0 0 1 0 22.667V9.333A1.333 1.333 0 0 1 1.333 8z",
                fill: "#0078d4"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M3.867 13.468a4.181 4.181 0 0 1 1.642-1.814A4.965 4.965 0 0 1 8.119 11a4.617 4.617 0 0 1 2.413.62 4.14 4.14 0 0 1 1.598 1.733 5.597 5.597 0 0 1 .56 2.55 5.901 5.901 0 0 1-.577 2.666 4.239 4.239 0 0 1-1.645 1.794A4.8 4.8 0 0 1 7.963 21a4.729 4.729 0 0 1-2.468-.627 4.204 4.204 0 0 1-1.618-1.736 5.459 5.459 0 0 1-.567-2.519 6.055 6.055 0 0 1 .557-2.65zm1.75 4.258a2.716 2.716 0 0 0 .923 1.194 2.411 2.411 0 0 0 1.443.435 2.533 2.533 0 0 0 1.541-.449 2.603 2.603 0 0 0 .897-1.197 4.626 4.626 0 0 0 .286-1.665 5.063 5.063 0 0 0-.27-1.686 2.669 2.669 0 0 0-.866-1.24 2.387 2.387 0 0 0-1.527-.473 2.493 2.493 0 0 0-1.477.439 2.741 2.741 0 0 0-.944 1.203 4.776 4.776 0 0 0-.007 3.44z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M0 0h32v32H0z",
                fill: "none"
            })
        ]
    });
const $75dda975985e0fd5$export$8ead1903281b785a = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "150",
        height: "128",
        viewBox: "0 0 150 128",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                clipPath: "url(#clip0)",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "150",
                        height: "127.685",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M149.861 52.5802L91.7015 5.85771C86.9468 2.06703 81.046 0.00274658 74.9651 0.00274658C68.8843 0.00274658 62.9835 2.06703 58.2287 5.85771L0.13947 52.5802H0V127.615H150V52.5802H149.861Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M131.241 15.6206H17.7126V107.545H131.241V15.6206Z",
                        fill: "#FAFBFC"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M118.271 39.8884H30.6136V41.2831H118.271V39.8884Z",
                        fill: "#3384FF"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M131.241 13.5983H17.7126V22.0711H131.241V13.5983Z",
                        fill: "#1DB9D4"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M76.4295 46.5829H30.6136V47.9776H76.4295V46.5829Z",
                        fill: "#3384FF"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M118.271 33.1938H30.6136V34.5885H118.271V33.1938Z",
                        fill: "#3384FF"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M118.271 59.9023H30.6136V61.297H118.271V59.9023Z",
                        fill: "#3384FF"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M118.271 66.5969H30.6136V67.9916H118.271V66.5969Z",
                        fill: "#3384FF"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M81.0321 73.2914H30.6136V74.6861H81.0321V73.2914Z",
                        fill: "#3384FF"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M150 127.685C124.547 127.685 108.368 123.57 98.2566 117.782C74.8954 104.254 71.9665 84.7977 47.5593 68.5495C30.265 57.0432 12.2734 53.7656 0 52.7196V127.685H150Z",
                        fill: "url(#paint0_linear)"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M0 127.685C25.5927 127.685 41.6318 123.57 51.7434 117.782C75.1046 104.254 77.9637 84.7977 102.441 68.5495C119.665 57.0432 137.727 53.7656 150 52.7196V127.685H0Z",
                        fill: "#6BD5E5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                        id: "paint0_linear",
                        x1: "74.993",
                        y1: "127.699",
                        x2: "74.993",
                        y2: "52.7057",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                stopColor: "#1DB9D4"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "0.12",
                                stopColor: "#38C3DA"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "0.26",
                                stopColor: "#4FCBDF"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "0.41",
                                stopColor: "#5FD1E2"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "0.59",
                                stopColor: "#68D4E4"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "0.82",
                                stopColor: "#6BD5E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "clip0",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                            width: "150",
                            height: "127.685",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });

});


parcelRegister("bZf8U", function(module, exports) {

$parcel$export(module.exports, "EmailedYou", function () { return $2edc7e164099e013$export$3f894db345e46fe7; });
/* emailed-you.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $cm1E8 = parcelRequire("cm1E8");
const $2edc7e164099e013$var$h1Style = null;
const $2edc7e164099e013$var$pStyle = null;
const $2edc7e164099e013$export$3f894db345e46fe7 = ()=>{
    const intl = (0, $f6qj2.default)();
    const headerMessage = {
        identifier: "checkemail.header",
        text: intl.formatMessage({
            id: "checkemail.header.text",
            defaultMessage: "Verify and activate your account"
        })
    };
    const weveEmailedYou = {
        identifier: "checkemail.emailedYou",
        text: intl.formatMessage({
            id: "checkemail.emailedYou.text",
            defaultMessage: "We've emailed your verification link. Verify your account to create your site"
        })
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_1wybahaf _k48pbfng _syazl4fm _ect41485"
                ]),
                children: headerMessage.text
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cm1E8.EmailLetterIcon), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_syazl4fm _y3gn1h6o _1bsbiolt _1e0c116y _ect41485 _ca0qviql _u5f3idpf _n3tdidpf _19bvidpf _1wyb1j6v"
                ]),
                children: weveEmailedYou.text
            })
        ]
    });
};

});




parcelRegister("1eXgi", function(module, exports) {

$parcel$export(module.exports, "SoftwareBitbucketPricingPage", function () { return $9d9000839f572cbe$export$a036524a443241f4; });

var $loA2J = parcelRequire("loA2J");

var $dT5kE = parcelRequire("dT5kE");
parcelRequire("gBOid");
var $3Mmqs = parcelRequire("3Mmqs");
const $9d9000839f572cbe$export$a036524a443241f4 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dT5kE.PricingContentContextProviderRelay), {
        productId: "bitbucket",
        pricingContent: pricingContent,
        queryRef: queryRef,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            "data-testid": "bitbucket-pricing-page",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3Mmqs.SoftwareBitbucketPricingPageTemplate), {
                pricing: pricing,
                countryCode: countryCode
            })
        })
    });
};

});
parcelRegister("gBOid", function(module, exports) {
$parcel$export(module.exports, "SoftwareBitbucketPricingPageTemplate", function () { return (parcelRequire("3Mmqs")).SoftwareBitbucketPricingPageTemplate; });

var $3Mmqs = parcelRequire("3Mmqs");

});
parcelRegister("3Mmqs", function(module, exports) {

$parcel$export(module.exports, "SoftwareBitbucketPricingPageTemplate", function () { return $56f60dbcd81584d7$export$d089087e1703e7f4; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");
parcelRequire("gUyvS");
var $khjAx = parcelRequire("khjAx");
parcelRequire("kmJhl");
var $9376M = parcelRequire("9376M");
var $bofgW = parcelRequire("bofgW");

var $dT5kE = parcelRequire("dT5kE");
parcelRequire("3XyMp");
var $f8O3L = parcelRequire("f8O3L");
var $ceE90 = parcelRequire("ceE90");

var $j1oGG = parcelRequire("j1oGG");
parcelRequire("3aCqg");
var $gxFZp = parcelRequire("gxFZp");

var $1FqEx = parcelRequire("1FqEx");

var $4AcxW = parcelRequire("4AcxW");
const $56f60dbcd81584d7$export$d089087e1703e7f4 = ({ pricing: pricing, countryCode: countryCode })=>{
    var _content_callToActionContainer, _pricing_hamsPricingData, _questionsCtaContent_asset;
    const content = (0, $dT5kE.usePricingContentContext)();
    const dataCenterContent = (0, $dT5kE.useDatacenterPlans)("Contact Us", "Learn more");
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[0];
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _content_getMoreDetailsTitle, _content_additionalDetails, _questionsCtaContent_url, _questionsCtaContent_title, _questionsCtaContent_text, _questionsCtaContent_valueProposition;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gxFZp.BitbucketNav), {}),
        showFallback: content === null || content === void 0 ? void 0 : content.hasError,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1FqEx.ParentScrollTracking), {
            pageId: "bitbucket-pricing-page",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PageHeading), {
                    children: content === null || content === void 0 ? void 0 : content.headline
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4AcxW.BitbucketPriceFinder), {
                    serverSideHAMSPricing: pricing === null || pricing === void 0 ? void 0 : (_pricing_hamsPricingData = pricing.hamsPricingData) === null || _pricing_hamsPricingData === void 0 ? void 0 : _pricing_hamsPricingData.bitbucket,
                    countryCode: countryCode
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $khjAx.PricingFeatureTable), {
                    title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                    comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                    compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $9376M.DataCenterSection), (0, $7Knp0._)({}, dataCenterContent)),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $f8O3L.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1FqEx.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ceE90.PricingFaq), {
                            header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                            planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bofgW.QuestionsCta), {
                    product: "Bitbucket",
                    ctaHref: (_questionsCtaContent_url = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.url) !== null && _questionsCtaContent_url !== void 0 ? _questionsCtaContent_url : undefined,
                    questionsHeader: (_questionsCtaContent_title = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.title) !== null && _questionsCtaContent_title !== void 0 ? _questionsCtaContent_title : undefined,
                    priceAndLicensingLinkText: (_questionsCtaContent_text = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.text) !== null && _questionsCtaContent_text !== void 0 ? _questionsCtaContent_text : undefined,
                    questionsBody: (_questionsCtaContent_valueProposition = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.valueProposition) !== null && _questionsCtaContent_valueProposition !== void 0 ? _questionsCtaContent_valueProposition : undefined,
                    imageHref: questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : (_questionsCtaContent_asset = questionsCtaContent.asset) === null || _questionsCtaContent_asset === void 0 ? void 0 : _questionsCtaContent_asset.url
                })
            ]
        })
    });
};

});
parcelRegister("3aCqg", function(module, exports) {
$parcel$export(module.exports, "BitbucketNav", function () { return (parcelRequire("gxFZp")).BitbucketNav; });
$parcel$export(module.exports, "WhyBitbucketSubnav", function () { return (parcelRequire("44Pau")).WhyBitbucketSubnav; });
parcelRequire("gxFZp");
parcelRequire("44Pau");

});
parcelRegister("gxFZp", function(module, exports) {

$parcel$export(module.exports, "BitbucketNav", function () { return $3fabb197901cb5ca$export$374e7235418bdbdb; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $5netJ = parcelRequire("5netJ");

var $dyZbY = parcelRequire("dyZbY");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $gAJUc = parcelRequire("gAJUc");
parcelRequire("3aCqg");
var $44Pau = parcelRequire("44Pau");
const $3fabb197901cb5ca$var$BitbucketLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "bitbucket",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $5netJ.BitbucketLogo), {
        appearance: "brand"
    });
};
const $3fabb197901cb5ca$export$374e7235418bdbdb = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=bitbucket&edition=free");
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).BITBUCKET,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    const dataCenterHref = (0, $3FBn4.useLocalizedHref)("/software/bitbucket/enterprise/data-center");
    const pricingHref = (0, $3FBn4.useLocalizedHref)("/software/bitbucket/pricing");
    const links = [
        {
            globalLinksKey: "whyBitbucket",
            linkText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.whyBitbucket",
                defaultMessage: "Why Bitbucket"
            }),
            productKey: "bitbucket",
            hasSubnav: true,
            dropdownType: "why-bitbucket"
        },
        {
            globalLinksKey: "self-hosted",
            linkText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.selfhosted",
                defaultMessage: "Self-Hosted"
            }),
            hasSubnav: false,
            productKey: "bitbucket",
            href: dataCenterHref
        },
        {
            globalLinksKey: "pricing",
            linkText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.pricing",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            productKey: "bitbucket",
            href: pricingHref
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "confluence-pt-cfind-1234-BitbucketNav",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
            productKey: "bitbucket",
            productLogoUrl: "/software/bitbucket",
            productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($3fabb197901cb5ca$var$BitbucketLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.bitbucket-logo",
                defaultMessage: "Bitbucket logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($3fabb197901cb5ca$var$BitbucketLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "whyBitbucket",
                    linkText: intl.formatMessage({
                        id: "BitbucketPageTemplate.navbar.whyBitbucket",
                        defaultMessage: "Why Bitbucket"
                    }),
                    containerStyles: {
                        width: "fit-content",
                        margin: 0
                    },
                    hasSubnav: true,
                    content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $44Pau.WhyBitbucketSubnav), {
                        productKey: "bitbucket"
                    })
                },
                {
                    globalLinksKey: "self-hosted",
                    linkText: intl.formatMessage({
                        id: "BitbucketPageTemplate.navbar.selfhosted",
                        defaultMessage: "Self-Hosted"
                    }),
                    hasSubnav: false,
                    productKey: "bitbucket",
                    href: dataCenterHref
                },
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "BitbucketPageTemplate.navbar.pricing",
                        defaultMessage: "Pricing"
                    }),
                    hasSubnav: false,
                    productKey: "bitbucket",
                    href: pricingHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-bitbucket",
                    mobileLinksProps: links
                }
            ]
        })
    });
};

});
parcelRegister("5netJ", function(module, exports) {

$parcel$export(module.exports, "BitbucketLogo", function () { return $3e9a54e2937c19ed$export$bd40525f5333524b; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $3e9a54e2937c19ed$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 158 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n        <path fill='.concat(colors.iconColor, ' d="m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95"/>\n        <path fill=').concat(colors.textColor, ' d="M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z"/>\n      </svg>');
};
var $3e9a54e2937c19ed$export$bd40525f5333524b = function BitbucketLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Bitbucket" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $3e9a54e2937c19ed$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("44Pau", function(module, exports) {

$parcel$export(module.exports, "WhyBitbucketSubnav", function () { return $9633d059a3ed42d2$export$7b115720fff1fb0d; });
/* why-bitbucket-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $6x1qA = parcelRequire("6x1qA");
var $f6qj2 = parcelRequire("f6qj2");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $3XIdt = parcelRequire("3XIdt");

var $baj2f = parcelRequire("baj2f");

var $jGfor = parcelRequire("jGfor");

var $hbBKK = parcelRequire("hbBKK");
function $9633d059a3ed42d2$var$useWhyBitbucketLinks() {
    return {
        features: {
            id: "solution",
            title: (0, $6x1qA.defineMessage)({
                id: "bitbucketnav.subnav.whybitbucket.links.solution",
                defaultMessage: "Solution"
            }),
            items: [
                {
                    id: "ci-cd",
                    text: (0, $6x1qA.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.work-management",
                        defaultMessage: "CI/CD"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/bitbucket/features/pipelines")
                },
                {
                    id: "cloud-security",
                    text: (0, $6x1qA.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.cloud-security",
                        defaultMessage: "Cloud Security"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/bitbucket/features/cloud-security")
                },
                {
                    id: "dev-sec-ops",
                    text: (0, $6x1qA.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.dev-sec-ops",
                        defaultMessage: "DevSecOps"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/bitbucket/features/devsecops")
                },
                {
                    id: "code-review",
                    text: (0, $6x1qA.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.it-service-management",
                        defaultMessage: "Code Review"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/bitbucket/features/code-review")
                },
                {
                    id: "jira-integrations",
                    text: (0, $6x1qA.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.agile-devops",
                        defaultMessage: "Jira Integrations"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/jira/bitbucket-integration")
                }
            ]
        },
        plans: {
            id: "plans",
            title: (0, $6x1qA.defineMessage)({
                id: "bitbucketnav.subnav.whybitbucket.links.plans",
                defaultMessage: "Plans"
            }),
            items: [
                {
                    id: "bitbucket-cloud-premium",
                    text: (0, $6x1qA.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.bitbucket-cloud-premium",
                        defaultMessage: "Bitbucket Cloud Premium"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/bitbucket/premium")
                }
            ]
        }
    };
}
const $9633d059a3ed42d2$export$7b115720fff1fb0d = ({ productKey: productKey = "bitbucket" })=>{
    const intl = (0, $f6qj2.default)();
    const bitbucketLinks = $9633d059a3ed42d2$var$useWhyBitbucketLinks();
    const linkColumns = Object.values(bitbucketLinks);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hbBKK.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3XIdt.MotionContainer), {
                direction: "up",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_bfhk1rga"
                    ]),
                    style: {
                        "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $baj2f.RowGrid), {
                        numCols: 2,
                        columnGap: "var(--ds-space-500, 40px)",
                        paddingBlock: "var(--ds-space-500, 40px)",
                        paddingInline: "var(--ds-space-500, 40px)",
                        children: linkColumns.map((column)=>{
                            return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jGfor.LinkColumn), {
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        className: (0, $esG4f.default)([
                                            "_1p1dangw _syaz1hlo _1wyboqnp _ect4bzd7 _k48p1fw0 _vwz41j6v"
                                        ]),
                                        style: {
                                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                        },
                                        children: intl.formatMessage(column.title)
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c11p5 _2z0510ma"
                                        ]),
                                        children: column.items.map((link)=>{
                                            return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_bpsp1nn1 _19tboxwj _43ds1hlo _qfs11r31 _s41oglyw _1k6pnqa1 _1cay1hlo _oavv1ep1 _oxk41ep1 _1e0c1txw _4cvrh9n0"
                                                ]),
                                                style: {
                                                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                                    "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
                                                },
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                                    type: "anchor",
                                                    href: link.href,
                                                    text: intl.formatMessage(link.text),
                                                    ariaLabel: intl.formatMessage(link.text),
                                                    dataEventProps: {
                                                        "data-event": "clicked",
                                                        "data-event-component": "linkButton",
                                                        "data-event-container": "globalNavSubnav",
                                                        "data-product-key": productKey
                                                    }
                                                })
                                            }, link.id);
                                        })
                                    })
                                ]
                            }, column.id);
                        })
                    })
                })
            })
        })
    });
};

});


parcelRegister("4AcxW", function(module, exports) {

$parcel$export(module.exports, "BitbucketPriceFinder", function () { return $c71097ed52bf7560$export$3f1971038752fd47; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $6x1qA = parcelRequire("6x1qA");

var $7OWgU = parcelRequire("7OWgU");

var $l9lQF = parcelRequire("l9lQF");

var $dT5kE = parcelRequire("dT5kE");
const $c71097ed52bf7560$export$3f1971038752fd47 = (props)=>{
    var _content_free, _content_free1, _content_standard, _content_standard1, _content_premium, _content_premium1;
    const content = {
        free: (0, $dT5kE.usePricingPlanComparison)("Free"),
        standard: (0, $dT5kE.usePricingPlanComparison)("Standard"),
        premium: (0, $dT5kE.usePricingPlanComparison)("Premium")
    };
    var _content_free_planTitleExternal, _content_free_planOneLiner, _content_standard_planTitleExternal, _content_standard_planOneLiner, _content_premium_planTitleExternal, _content_premium_planOneLiner;
    const bitbucketProductPlans = [
        {
            planName: (_content_free_planTitleExternal = (_content_free = content.free) === null || _content_free === void 0 ? void 0 : _content_free.planTitleExternal) !== null && _content_free_planTitleExternal !== void 0 ? _content_free_planTitleExternal : "Free",
            description: (_content_free_planOneLiner = (_content_free1 = content.free) === null || _content_free1 === void 0 ? void 0 : _content_free1.planOneLiner) !== null && _content_free_planOneLiner !== void 0 ? _content_free_planOneLiner : "",
            recommendationLimit: 0,
            signupLimit: 35000,
            signupURLSuffix: "?bundle=bitbucket&edition=free",
            planFeatureMessages: []
        },
        {
            planName: (_content_standard_planTitleExternal = (_content_standard = content.standard) === null || _content_standard === void 0 ? void 0 : _content_standard.planTitleExternal) !== null && _content_standard_planTitleExternal !== void 0 ? _content_standard_planTitleExternal : "Standard",
            description: (_content_standard_planOneLiner = (_content_standard1 = content.standard) === null || _content_standard1 === void 0 ? void 0 : _content_standard1.planOneLiner) !== null && _content_standard_planOneLiner !== void 0 ? _content_standard_planOneLiner : "",
            recommendationLimit: 5,
            signupLimit: 35000,
            signupURLSuffix: "?bundle=bitbucket&edition=standard",
            planFeatureMessages: []
        },
        {
            planName: (_content_premium_planTitleExternal = (_content_premium = content.premium) === null || _content_premium === void 0 ? void 0 : _content_premium.planTitleExternal) !== null && _content_premium_planTitleExternal !== void 0 ? _content_premium_planTitleExternal : "Premium",
            description: (_content_premium_planOneLiner = (_content_premium1 = content.premium) === null || _content_premium1 === void 0 ? void 0 : _content_premium1.planOneLiner) !== null && _content_premium_planOneLiner !== void 0 ? _content_premium_planOneLiner : "",
            recommendationLimit: 100,
            signupLimit: 35000,
            signupURLSuffix: "?bundle=bitbucket&edition=premium",
            planFeatureMessages: []
        }
    ];
    const messages = (0, $6x1qA.defineMessages)({
        unitCountInputText: {
            id: "BitbucketSoftwarePricingPage.priceFinder.unitCountInputText",
            defaultMessage: "How many users are on your team?"
        },
        unitCountInputTextRedesign: {
            id: "BitbucketSoftwarePricingPage.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputTerm: {
            id: "BitbucketSoftwarePricingPage.priceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        billingCycleText: {
            id: "BitbucketSoftwarePricingPage.priceFinder.billingCycleText",
            defaultMessage: "Billing cycle:"
        },
        unitCountInputTooltip: {
            id: "BitbucketSoftwarePricingPage.priceFinder.unitCountInputTooltip",
            defaultMessage: "A Bitbucket Software user is any user who can log in to Bitbucket Software, and who exists in User Management"
        },
        monthlyExampleHelpText: {
            id: "BitbucketSoftwarePricingPage.priceFinder.monthlyExampleHelpText",
            defaultMessage: "Monthly plans give you flexibility as your number of active users changes, so pay for seats as you use them. Remember that the number of seats may change the total price."
        },
        annualExampleHelpText: {
            id: "BitbucketSoftwarePricingPage.priceFinder.annualExampleHelpText",
            defaultMessage: "Annual plans give you flexibility and help you prepare for growth. Buy a group of seats at a flat rate now, then fill your empty seats through the year at no extra cost."
        },
        exampleStandardPlan: {
            id: "BitbucketSoftwarePricingPage.priceFinder.exampleStandardPlan",
            defaultMessage: "Pricing for {unitCount} users on Standard plan",
            description: "Standard is a plan name and should not be translated"
        },
        cardOverSignupLimit: {
            id: "BitbucketSoftwarePricingPage.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "BitbucketSoftwarePricingPage.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "BitbucketSoftwarePricingPage.priceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "BitbucketSoftwarePricingPageTeam24.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        },
        cardFreeDescription: {
            id: "BitbucketSoftwarePricingPage.priceFinder.cardFreeDescription",
            defaultMessage: "Always free for 10 users"
        }
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $l9lQF.PriceFinderContextProvider), {
            dataProductKey: "bitbucket",
            productPlans: bitbucketProductPlans,
            defaultUnitCount: 5,
            isMonthlyBillingOnly: true,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OWgU.default), (0, $7Knp0._)({
                messages: messages,
                hamsProductKey: "com.atlassian.bitbucket.manual"
            }, props))
        })
    });
};
$c71097ed52bf7560$export$3f1971038752fd47.displayName = "BitbucketPriceFinderSection";

});




parcelRegister("3kaLT", function(module, exports) {

$parcel$export(module.exports, "SoftwareCompassPricingPage", function () { return $64d6c203af6a6e07$export$a2e7512bef730a43; });

var $loA2J = parcelRequire("loA2J");

var $dT5kE = parcelRequire("dT5kE");

var $7jR9M = parcelRequire("7jR9M");
const $64d6c203af6a6e07$export$a2e7512bef730a43 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dT5kE.PricingContentContextProviderRelay), {
        productId: "compass",
        pricingContent: pricingContent,
        queryRef: queryRef,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            "data-testid": "compass-pricing-page",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7jR9M.SoftwareCompassPricingPageTemplate), {
                pricing: pricing,
                countryCode: countryCode
            })
        })
    });
};

});
parcelRegister("7jR9M", function(module, exports) {

$parcel$export(module.exports, "SoftwareCompassPricingPageTemplate", function () { return $b8ae8419a135140b$export$45aaac790ab82a3a; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");
parcelRequire("gUyvS");
var $khjAx = parcelRequire("khjAx");
parcelRequire("kmJhl");
var $bofgW = parcelRequire("bofgW");

var $dT5kE = parcelRequire("dT5kE");
parcelRequire("3XyMp");
var $f8O3L = parcelRequire("f8O3L");

var $j1oGG = parcelRequire("j1oGG");
parcelRequire("ccYBS");
var $1FqEx = parcelRequire("1FqEx");

var $ceE90 = parcelRequire("ceE90");

var $hDoR2 = parcelRequire("hDoR2");

var $7tcjU = parcelRequire("7tcjU");
const $b8ae8419a135140b$export$45aaac790ab82a3a = ({ pricing: pricing, countryCode: countryCode })=>{
    var _content_callToActionContainer, _questionsCtaContent_asset;
    const content = (0, $dT5kE.usePricingContentContext)();
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[0];
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _content_getMoreDetailsTitle, _content_additionalDetails, _questionsCtaContent_url, _questionsCtaContent_title, _questionsCtaContent_text, _questionsCtaContent_valueProposition;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hDoR2.CompassNav), {}),
        showFallback: content === null || content === void 0 ? void 0 : content.hasError,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1FqEx.ParentScrollTracking), {
            pageId: "compass-pricing-page",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PageHeading), {
                    children: content === null || content === void 0 ? void 0 : content.headline
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $7tcjU.SoftwareCompassPriceFinder), {
                    pricing: pricing,
                    countryCode: countryCode
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $khjAx.PricingFeatureTable), {
                    title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                    comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                    compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $f8O3L.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1FqEx.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ceE90.PricingFaq), {
                            header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                            planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bofgW.QuestionsCta), {
                    product: "Compass",
                    ctaHref: (_questionsCtaContent_url = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.url) !== null && _questionsCtaContent_url !== void 0 ? _questionsCtaContent_url : undefined,
                    questionsHeader: (_questionsCtaContent_title = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.title) !== null && _questionsCtaContent_title !== void 0 ? _questionsCtaContent_title : undefined,
                    priceAndLicensingLinkText: (_questionsCtaContent_text = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.text) !== null && _questionsCtaContent_text !== void 0 ? _questionsCtaContent_text : undefined,
                    questionsBody: (_questionsCtaContent_valueProposition = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.valueProposition) !== null && _questionsCtaContent_valueProposition !== void 0 ? _questionsCtaContent_valueProposition : undefined,
                    imageHref: questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : (_questionsCtaContent_asset = questionsCtaContent.asset) === null || _questionsCtaContent_asset === void 0 ? void 0 : _questionsCtaContent_asset.url
                })
            ]
        })
    });
};

});
parcelRegister("hDoR2", function(module, exports) {

$parcel$export(module.exports, "CompassNav", function () { return $b48207cde0746e41$export$78e93448314ae49; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $7JG5H = parcelRequire("7JG5H");

var $dyZbY = parcelRequire("dyZbY");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $gAJUc = parcelRequire("gAJUc");
const $b48207cde0746e41$var$CompassLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "compass",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $7JG5H.CompassLogo), {
        appearance: "brand"
    });
};
const $b48207cde0746e41$export$78e93448314ae49 = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=compass&edition=free");
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).COMPASS,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    const pricingHref = (0, $3FBn4.useLocalizedHref)("/software/compass/pricing");
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "confluence-pt-cfind-1234-CompassNav",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
            productLogoUrl: "/software/compass",
            productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($b48207cde0746e41$var$CompassLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "CompassPageTemplate.navbar.compass-logo",
                defaultMessage: "Compass logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "CompassPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: "CompassPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($b48207cde0746e41$var$CompassLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "features",
                    linkText: intl.formatMessage({
                        id: "CompassPageTemplate.navbar.features",
                        defaultMessage: "Features"
                    }),
                    hasSubnav: false,
                    productKey: "compass",
                    href: (0, $3FBn4.useLocalizedHref)("/software/compass/features")
                },
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "CompassPageTemplate.navbar.pricing",
                        defaultMessage: "Pricing"
                    }),
                    hasSubnav: false,
                    productKey: "compass",
                    href: pricingHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-compass",
                    mobileLinksProps: [
                        {
                            globalLinksKey: "features",
                            linkText: intl.formatMessage({
                                id: "CompassPageTemplate.navbar.features",
                                defaultMessage: "Features"
                            }),
                            hasSubnav: false,
                            productKey: "compass",
                            href: (0, $3FBn4.useLocalizedHref)("/software/compass/features")
                        },
                        {
                            globalLinksKey: "pricing",
                            linkText: intl.formatMessage({
                                id: "CompassPageTemplate.navbar.pricing",
                                defaultMessage: "Pricing"
                            }),
                            hasSubnav: false,
                            productKey: "compass",
                            href: pricingHref
                        }
                    ]
                }
            ]
        })
    });
};

});
parcelRegister("7JG5H", function(module, exports) {

$parcel$export(module.exports, "CompassLogo", function () { return $5a1d62c42d86e741$export$eb7d748e4f9c9676; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $5a1d62c42d86e741$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 155 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n    <path fill='.concat(colors.iconColor, ' d="M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z"/>\n    <path fill="').concat(colors.textColor, '" d="M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227"/>\n  </svg>');
};
var $5a1d62c42d86e741$export$eb7d748e4f9c9676 = function CompassLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Compass" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $5a1d62c42d86e741$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("7tcjU", function(module, exports) {

$parcel$export(module.exports, "SoftwareCompassPriceFinder", function () { return $cf5cf54c453f3e75$export$5a248d92074c4b1b; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $6x1qA = parcelRequire("6x1qA");

var $7OWgU = parcelRequire("7OWgU");

var $l9lQF = parcelRequire("l9lQF");

var $esRX2 = parcelRequire("esRX2");

var $dT5kE = parcelRequire("dT5kE");
const $cf5cf54c453f3e75$export$5a248d92074c4b1b = (props)=>{
    var _content_free, _content_free1, _content_standard, _content_standard1, _content_premium, _content_premium1, _props_pricing_ccpPricingData, _props_pricing;
    const content = {
        free: (0, $dT5kE.usePricingPlanComparison)("Free"),
        standard: (0, $dT5kE.usePricingPlanComparison)("Standard"),
        premium: (0, $dT5kE.usePricingPlanComparison)("Premium")
    };
    const freePlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "free");
    const standardPlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "standard");
    const premiumPlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "premium");
    const SoftwareCompassPricingProductPlans = [
        {
            planName: ((_content_free = content.free) === null || _content_free === void 0 ? void 0 : _content_free.planTitleExternal) || "Free",
            offeringSku: "compass-free",
            description: ((_content_free1 = content.free) === null || _content_free1 === void 0 ? void 0 : _content_free1.planOneLiner) || "",
            recommendationLimit: 0,
            signupLimit: 3,
            signupURLSuffix: "?bundle=compass&edition=free",
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: ((_content_standard = content.standard) === null || _content_standard === void 0 ? void 0 : _content_standard.planTitleExternal) || "Standard",
            offeringSku: "compass-standard",
            description: ((_content_standard1 = content.standard) === null || _content_standard1 === void 0 ? void 0 : _content_standard1.planOneLiner) || "",
            recommendationLimit: 3,
            signupLimit: 35000,
            signupURLSuffix: "?bundle=compass&edition=standard",
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: ((_content_premium = content.premium) === null || _content_premium === void 0 ? void 0 : _content_premium.planTitleExternal) || "Premium",
            offeringSku: "compass-premium-sku",
            description: ((_content_premium1 = content.premium) === null || _content_premium1 === void 0 ? void 0 : _content_premium1.planOneLiner) || "",
            recommendationLimit: 250,
            signupLimit: 35000,
            signupURLSuffix: "?bundle=compass&edition=premium",
            planFeatureMessages: premiumPlanFeatureMessages
        }
    ];
    const messages = (0, $6x1qA.defineMessages)({
        unitCountInputTextRedesign: {
            id: "CompassPricingPage.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        cardOverSignupLimit: {
            id: "CompassPricingPage.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        unitCountInputTerm: {
            id: "CompassPricingPage.priceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        cardEnterpriseMinimumCount: {
            id: "CompassPricingPage.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "CompassPricingPage.priceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "CompassPricingPage.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        }
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $l9lQF.PriceFinderContextProvider), {
            dataProductKey: "compass",
            productPlans: SoftwareCompassPricingProductPlans,
            defaultUnitCount: 300,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OWgU.default), (0, $7Knp0._)({
                messages: messages,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.compass,
                countryCode: props.countryCode
            }, props))
        })
    });
};
$cf5cf54c453f3e75$export$5a248d92074c4b1b.displayName = "SoftwareCompassPriceFinderSection";

});



parcelRegister("5l8W2", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorAutomation", function () { return $0e8ce27bfa819471$export$7f9d44dab84ab3fb; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $cLLBP = parcelRequire("cLLBP");

var $lpiK5 = parcelRequire("lpiK5");

var $bCSEP = parcelRequire("bCSEP");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");

var $cBkUf = parcelRequire("cBkUf");

var $aR9rM = parcelRequire("aR9rM");
const $0e8ce27bfa819471$export$7f9d44dab84ab3fb = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $iSvIT.useEffect)(()=>{
        if ((0, $aR9rM.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cLLBP.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Automation.start-with-page.title",
                defaultMessage: "Start with a page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Automation.start-with-page.body",
                defaultMessage: "Plan projects, share knowledge, and automate workflows, all in one place."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Automation.supercharge-productivity.title",
                defaultMessage: "Supercharge productivity"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Automation.supercharge-productivity.body",
                defaultMessage: "Save time by automating repetitive, manual tasks."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/qrpd4w43508d10hq328mq05417ilsc7y.webp",
            imgAltText: "Confluence automating emails"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Automation.connect-work.title",
                defaultMessage: "Connect all your work"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Automation.connect-work.body",
                defaultMessage: "Stay organized in dedicated workspaces, equipped with AI-powered search."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": "A display of various confluence features",
        "id": "confluence-automation-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-automation";
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lpiK5.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: "confluence"
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bCSEP.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "cfind-3090-paid-confluence-product-tour",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cBkUf.ConfluencePagePaidLpConflAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
            pageId: pageId,
            persona: "unknown",
            pageVariant: "brandUpdate",
            dataProductKey: "confluence-PaidLpConfAnchorAutomation",
            keyword: pageProps.keyword,
            carouselHeroProps: carouselHeroProps,
            customHeroSection: customHeroSection
        }))
    });
};

});
parcelRegister("8rqVU", function(module, exports) {
$parcel$export(module.exports, "useCCPPriceFinderData", function () { return (parcelRequire("kxn2n")).useCCPPriceFinderData; });
$parcel$export(module.exports, "useHAMSPriceData", function () { return (parcelRequire("kxn2n")).useHAMSPriceData; });
$parcel$export(module.exports, "AnchorPageRelayQuery", function () { return (parcelRequire("lsqCW")).AnchorPageRelayQuery; });
$parcel$export(module.exports, "PricingPageRelayQuery", function () { return (parcelRequire("cCupH")).PricingPageRelayQuery; });
$parcel$export(module.exports, "shapeAnchorContentfulResponse", function () { return (parcelRequire("lsqCW")).shapeAnchorContentfulResponse; });
$parcel$export(module.exports, "shapePricingContentfulResponse", function () { return (parcelRequire("cCupH")).shapePricingContentfulResponse; });
parcelRequire("kxn2n");
parcelRequire("iTDk2");

});

parcelRegister("cLLBP", function(module, exports) {

$parcel$export(module.exports, "useLogMeInD0to6", function () { return $b7c58f52fc05a7cb$export$dc29ba926b713c7f; });

var $277zl = parcelRequire("277zl");

var $iMdoL = parcelRequire("iMdoL");
const $b7c58f52fc05a7cb$export$dc29ba926b713c7f = ({ availableProducts: availableProducts, userProfile: userProfile })=>{
    const confluenceD0to6 = (0, $iMdoL.useConfluenceD0to6)();
    const useLogMeInOriginalResponse = (0, $277zl.useLogMeIn)({
        availableProducts: availableProducts,
        userProfile: userProfile,
        siteType: (0, $277zl.AtlSiteType).CONFLUENCE
    });
    const shouldShowLogMeIn = !!confluenceD0to6 && useLogMeInOriginalResponse.shouldShowLogMeIn;
    return {
        userProfileName: useLogMeInOriginalResponse.userProfileName,
        recentSites: useLogMeInOriginalResponse.recentSites,
        shouldShowLogMeIn: shouldShowLogMeIn
    };
};

});
parcelRegister("277zl", function(module, exports) {

$parcel$export(module.exports, "AtlSiteType", function () { return $2bde5ca46c5f16ac$export$25e165f6cdbb7fba; });
$parcel$export(module.exports, "useLogMeIn", function () { return $2bde5ca46c5f16ac$export$3b3e141b692cc8f3; });

var $5wOn9 = parcelRequire("5wOn9");
var $2bde5ca46c5f16ac$export$25e165f6cdbb7fba;
(function(AtlSiteType) {
    AtlSiteType["CONFLUENCE"] = "confluence.ondemand";
    AtlSiteType["JIRA"] = "jira-software.ondemand";
})($2bde5ca46c5f16ac$export$25e165f6cdbb7fba || ($2bde5ca46c5f16ac$export$25e165f6cdbb7fba = {}));
const $2bde5ca46c5f16ac$var$filterAvailableSites = (availableProducts, siteType)=>{
    if (availableProducts) {
        const filteredSites = availableProducts.sites.filter((site)=>{
            return site.products.includes(siteType);
        }) || [];
        return filteredSites;
    } else return [];
};
const $2bde5ca46c5f16ac$export$3b3e141b692cc8f3 = ({ availableProducts: availableProducts, userProfile: userProfile, siteType: siteType = "confluence.ondemand" })=>{
    const filteredSites = $2bde5ca46c5f16ac$var$filterAvailableSites(availableProducts, siteType);
    const loggedInUserName = (0, $5wOn9.useLoggedInUser)().name;
    const userProfileName = (userProfile === null || userProfile === void 0 ? void 0 : userProfile.name) || loggedInUserName;
    return {
        userProfileName: userProfileName,
        recentSites: filteredSites,
        shouldShowLogMeIn: !!userProfileName && filteredSites.length > 0
    };
};

});


parcelRegister("lpiK5", function(module, exports) {

$parcel$export(module.exports, "PaidHeroCarousel", function () { return $76a3a41f3816f197$export$f092ba03447984fe; });
/* paid-hero-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");
parcelRequire("al79j");
var $4L1BA = parcelRequire("4L1BA");

var $hwuMM = parcelRequire("hwuMM");

var $6JN6z = parcelRequire("6JN6z");

var $4KDmv = parcelRequire("4KDmv");

var $1MbAx = parcelRequire("1MbAx");
const $76a3a41f3816f197$var$paidHeroContainerStyles = null;
const $76a3a41f3816f197$var$backgroundGradient = null;
const $76a3a41f3816f197$var$paidHeroContentStyles = null;
const $76a3a41f3816f197$var$blockStartPadding = null;
const $76a3a41f3816f197$var$signUpFormContainerStyles = null;
const $76a3a41f3816f197$var$carouselContainerStyles = null;
const $76a3a41f3816f197$var$rebrandBackground = null;
const $76a3a41f3816f197$export$f092ba03447984fe = ({ pageId: pageId, embeddedSignup: embeddedSignup, carouselSlides: carouselSlides, customSignupHeader: customSignupHeader, shouldUseTransparentBackground: shouldUseTransparentBackground, shouldUseBlockStartPadding: shouldUseBlockStartPadding = true, shouldUseNewBrandBackground: shouldUseNewBrandBackground })=>{
    const intl = (0, $f6qj2.default)();
    const isLiftAndShiftExposure = pageId === "paid-lp-conf-features" || pageId === "confluence-default";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: isLiftAndShiftExposure ? "cfind-1466-lift-and-shift" : "wac-conf-anchors-lift-and-shift",
        group: isLiftAndShiftExposure ? "treatmentA" : "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            id: "start-trial",
            className: (0, $esG4f.default)([
                "_1e0c1txw _1bah1h6o",
                !shouldUseTransparentBackground && "_11q7i1wq",
                shouldUseNewBrandBackground && "_1pfh1wqb _kqswh2mm _1kt9b3bt _1cs8stnw _iajmgktf _z5wtidpf _1enw53f4 _1rusuzct _1fkrymf6 _7dwz16qr _8kay1h6o _1g0v1oqz _dsq4glyw _aetrb3bt _18postnw _1hfkuzct _19nq1h39 _g0nfuuw1 _1czdidpf _1gufidpf _clh31mo7 _1tlb1h6o _1bqq1oqz _11fnglyw"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1tke1fbq _p12fzqdx _gy1pckbl _1p571tcg _1bsb1osq _1bah1h6o",
                    shouldUseBlockStartPadding && "_1q511wqb"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _1bah1h6o _4cvr1h6o _16jlkb7n _1o9zkb7n _i0dl1osq _p12f1usy"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                            name: isLiftAndShiftExposure ? "conf-lift-and-shift-features-signup-module" : "conf-lift-and-shift-signup-module",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4KDmv.ClientOnly), {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hwuMM.default), (0, $6iHNw._)((0, $7Knp0._)({}, embeddedSignup), {
                                    variantOverride: pageId,
                                    customSignupHeader: customSignupHeader
                                }))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_4cvr1h6o _1e0c1txw _1bah1h6o _1ul91178 _16jlkb7n _1o9zkb7n _i0dl1osq _y4tizwfg _sugaglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6JN6z.BanditsAssetWrapper), {
                            product: "confluence",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                                name: isLiftAndShiftExposure ? "cfind-1466-carousel" : "conf-lift-and-shift-carousel",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4L1BA.Carousel), {
                                    "aria-label": intl.formatMessage({
                                        id: "ConfluenceSoftwarePage.v4.CarouselHero.AriaLabel",
                                        defaultMessage: "A display of various confluence features",
                                        description: "Aria label for the carousel section"
                                    }),
                                    slides: carouselSlides,
                                    id: "confluence-features-carousel"
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};

});
parcelRegister("al79j", function(module, exports) {
$parcel$export(module.exports, "Carousel", function () { return (parcelRequire("4L1BA")).Carousel; });
$parcel$export(module.exports, "VideoCarousel", function () { return (parcelRequire("2kLmv")).VideoCarousel; });
parcelRequire("2drdU");
parcelRequire("4L1BA");
parcelRequire("2kLmv");

});
parcelRegister("2drdU", function(module, exports) {

$parcel$export(module.exports, "ArrowButton", function () { return $ec122054541dc2de$export$15d663f77d176497; });
$parcel$export(module.exports, "PlayPauseButton", function () { return $ec122054541dc2de$export$e0201548afaa4886; });
/* carouselButtons.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $aE9vI = parcelRequire("aE9vI");

var $3uZ6C = parcelRequire("3uZ6C");
const $ec122054541dc2de$var$iconButtonStyles = null;
const $ec122054541dc2de$export$15d663f77d176497 = ({ onClick: onClick, icon: icon, "aria-label": ariaLabel })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
        onClick: onClick,
        "aria-label": ariaLabel,
        className: (0, $esG4f.default)([
            "_19it8cnq _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _1bah1h6o _80omtlke _4t3izwfg _1bsbzwfg"
        ]),
        children: icon
    });
};
const $ec122054541dc2de$export$e0201548afaa4886 = ({ onClick: onClick, isRotating: isRotating })=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
        onClick: onClick,
        className: (0, $esG4f.default)([
            "_19it8cnq _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _1bah1h6o _80omtlke _4t3izwfg _1bsbzwfg"
        ]),
        children: isRotating ? /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aE9vI))), {
            label: intl.formatMessage({
                id: "confluence.paid.lp.carousel.pause",
                defaultMessage: "Pause carousel"
            }),
            size: "small"
        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3uZ6C))), {
            label: intl.formatMessage({
                id: "confluence.paid.lp.carousel.play",
                defaultMessage: "Play carousel"
            }),
            size: "small"
        })
    });
};

});
parcelRegister("aE9vI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c0504678a6ffb09$var$_react = $7c0504678a6ffb09$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $7c0504678a6ffb09$var$_videoPause = $7c0504678a6ffb09$var$_interopRequireDefault((parcelRequire("2kURI")));
function $7c0504678a6ffb09$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7c0504678a6ffb09$var$VidPauseIcon = (props)=>/*#__PURE__*/ $7c0504678a6ffb09$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 4h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1m10 0h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $7c0504678a6ffb09$var$_videoPause.default
    }));
$7c0504678a6ffb09$var$VidPauseIcon.displayName = "VidPauseIcon";
var $7c0504678a6ffb09$var$_default = module.exports.default = $7c0504678a6ffb09$var$VidPauseIcon;

});
parcelRegister("2kURI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9dac8ccc4d1b894102a944d61ac4f665>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b398f5450b42256$var$_react = $1b398f5450b42256$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $1b398f5450b42256$var$_baseNew = $1b398f5450b42256$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $1b398f5450b42256$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPause".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pause video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1b398f5450b42256$var$VideoPauseIcon = (props)=>/*#__PURE__*/ $1b398f5450b42256$var$_react.default.createElement($1b398f5450b42256$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$1b398f5450b42256$var$VideoPauseIcon.displayName = "VideoPauseIcon";
var $1b398f5450b42256$var$_default = module.exports.default = $1b398f5450b42256$var$VideoPauseIcon;

});


parcelRegister("3uZ6C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28c392c347bb3244$var$_react = $28c392c347bb3244$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $28c392c347bb3244$var$_videoPlay = $28c392c347bb3244$var$_interopRequireDefault((parcelRequire("4GzQ1")));
function $28c392c347bb3244$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $28c392c347bb3244$var$VidPlayIcon = (props)=>/*#__PURE__*/ $28c392c347bb3244$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.595 19.522C7.162 20.364 6 19.702 6 18.04V5.963C6 4.3 7.158 3.635 8.595 4.479l11.083 6.51c.951.559.958 1.46 0 2.023z"/></svg>`
    }, props, {
        newIcon: $28c392c347bb3244$var$_videoPlay.default
    }));
$28c392c347bb3244$var$VidPlayIcon.displayName = "VidPlayIcon";
var $28c392c347bb3244$var$_default = module.exports.default = $28c392c347bb3244$var$VidPlayIcon;

});
parcelRegister("4GzQ1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::92409a0bcef1d03143cf6035c99e88da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3696e25833a0c73f$var$_react = $3696e25833a0c73f$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $3696e25833a0c73f$var$_baseNew = $3696e25833a0c73f$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $3696e25833a0c73f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for play video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3696e25833a0c73f$var$VideoPlayIcon = (props)=>/*#__PURE__*/ $3696e25833a0c73f$var$_react.default.createElement($3696e25833a0c73f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.112C2 1.592 3.63.627 4.963 1.36l8.902 4.888c1.383.76 1.383 2.747 0 3.506l-8.902 4.888C3.63 15.373 2 14.408 2 12.888zm2.24-.438a.5.5 0 0 0-.74.438v9.776a.5.5 0 0 0 .74.438l8.903-4.888a.5.5 0 0 0 0-.876z" clip-rule="evenodd"/>`
    }, props));
$3696e25833a0c73f$var$VideoPlayIcon.displayName = "VideoPlayIcon";
var $3696e25833a0c73f$var$_default = module.exports.default = $3696e25833a0c73f$var$VideoPlayIcon;

});



parcelRegister("4L1BA", function(module, exports) {

$parcel$export(module.exports, "Carousel", function () { return $4782b203528ec4e1$export$144901db2ea8e967; });
/* carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $d0cJX = parcelRequire("d0cJX");

var $3Bf61 = parcelRequire("3Bf61");
parcelRequire("cIqek");
var $eGxBJ = parcelRequire("eGxBJ");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $2drdU = parcelRequire("2drdU");
const $4782b203528ec4e1$var$carouselSlideStyle = null;
const $4782b203528ec4e1$var$imageStyle = null;
const $4782b203528ec4e1$var$infoContainerStyle = null;
const $4782b203528ec4e1$var$textContainerStyle = null;
const $4782b203528ec4e1$var$primaryTextStyle = null;
const $4782b203528ec4e1$var$subTextStyle = null;
const $4782b203528ec4e1$var$anchorPrimaryTextStyle = null;
const $4782b203528ec4e1$var$anchorSubTextStyle = null;
const $4782b203528ec4e1$export$cabb5ccfbd60cbd4 = ({ primaryText: primaryText, description: description, imgSrc: imgSrc, imgAltText: imgAltText, id: id, stylingType: stylingType })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        role: "tabpanel",
        id: id,
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulp7vkz"
        ]),
        children: [
            stylingType === "anchor" ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                image: {
                    src: imgSrc,
                    alt: ""
                },
                className: (0, $esG4f.default)([
                    "_1bsb1osq"
                ])
            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $eGxBJ.Adg4RaisedMedia), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                    src: imgSrc,
                    alt: imgAltText,
                    className: (0, $esG4f.default)([
                        "_1bsb1osq"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bah1yb4 _4cvr1h6o _195g1tcg _zulp7vkz _1tke53f4"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_k48pni7l",
                                stylingType === "anchor" && "_y3gn1h6o _syaz1hlo _ect41pz4 _1wyb1k8s _k48p1fw0 _vwz4l07h _6rth14y2"
                            ]),
                            style: {
                                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                            },
                            children: primaryText
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_k48p1nn1",
                                stylingType === "anchor" && "_y3gn1h6o _syaz1hlo _1wyb1j6v _vwz41k8s"
                            ]),
                            style: {
                                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                            },
                            children: description
                        })
                    ]
                })
            })
        ]
    });
};
const $4782b203528ec4e1$var$carouselTabListStyle = null;
const $4782b203528ec4e1$var$dotStyle = null;
const $4782b203528ec4e1$var$currentDotStyle = null;
const $4782b203528ec4e1$var$carouselStyles = null;
const $4782b203528ec4e1$var$controlsContainerStyles = null;
const $4782b203528ec4e1$var$centeredControlsContainerStyles = null;
const $4782b203528ec4e1$var$rightAlignedControlsContainerStyles = null;
const $4782b203528ec4e1$export$144901db2ea8e967 = ({ "aria-label": ariaLabel, slides: slides, "id": carouselId, showPlayButton: showPlayButton = true, stylingType: stylingType })=>{
    const intl = (0, $f6qj2.default)();
    const cycleTime = 7000;
    const timeoutRef = (0, $iSvIT.useRef)(null);
    const tabsRef = (0, $iSvIT.useRef)({});
    const [visibleSlideIndex, _setVisibleSlideIndex] = (0, $iSvIT.useState)(0);
    const visibleSlide = slides[visibleSlideIndex];
    if (visibleSlide === undefined) throw new Error("Slide index out of bounds.");
    const setVisibleSlideIndex = (newState, moveFocus = false)=>{
        _setVisibleSlideIndex((prevState)=>{
            var _tabsRef_current_calculatedState;
            let calculatedState;
            if (typeof newState === "function") calculatedState = newState(prevState);
            else calculatedState = newState;
            moveFocus && (tabsRef === null || tabsRef === void 0 ? void 0 : (_tabsRef_current_calculatedState = tabsRef.current[calculatedState]) === null || _tabsRef_current_calculatedState === void 0 ? void 0 : _tabsRef_current_calculatedState.focus());
            return calculatedState;
        });
    };
    const moveToPreviousSlide = (moveFocus = false)=>{
        setVisibleSlideIndex((prev)=>{
            return prev === 0 ? slides.length - 1 : prev - 1;
        }, moveFocus);
    };
    const moveToNextSlide = (0, $iSvIT.useCallback)((moveFocus = false)=>{
        setVisibleSlideIndex((prev)=>{
            return prev === slides.length - 1 ? 0 : prev + 1;
        }, moveFocus);
    }, [
        slides.length
    ]);
    const [isRotating, setIsRotating] = (0, $iSvIT.useState)(true);
    const stopRotating = ()=>{
        (timeoutRef === null || timeoutRef === void 0 ? void 0 : timeoutRef.current) !== null && window.clearInterval(timeoutRef.current);
        setIsRotating(false);
    };
    const startRotating = ()=>{
        timeoutRef.current = window.setInterval(()=>{
            moveToNextSlide();
        }, cycleTime);
        setIsRotating(true);
    };
    const toggleRotating = ()=>{
        isRotating ? stopRotating() : startRotating();
    };
    (0, $iSvIT.useEffect)(startRotating, [
        moveToNextSlide
    ]);
    const handleKeyDown = (e)=>{
        switch(e.key){
            case "ArrowRight":
                moveToNextSlide(true);
                break;
            case "ArrowLeft":
                moveToPreviousSlide(true);
                break;
            case "Home":
                setVisibleSlideIndex(0, true);
                break;
            case "End":
                setVisibleSlideIndex(slides.length - 1, true);
                break;
            default:
                return;
        }
        stopRotating();
        e.preventDefault();
    };
    const handleTabClick = (index)=>{
        stopRotating();
        setVisibleSlideIndex(index);
    };
    const handlePreviousClick = ()=>{
        stopRotating();
        moveToPreviousSlide();
    };
    const handleNextClick = ()=>{
        stopRotating();
        moveToNextSlide();
    };
    const getSlideId = (suffix)=>`${carouselId}-${suffix}`;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        "aria-label": ariaLabel,
        "aria-roledescription": "carousel",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                "aria-atomic": false,
                "aria-live": isRotating ? "off" : "polite",
                children: /*#__PURE__*/ (0, $loA2J.jsx)($4782b203528ec4e1$export$cabb5ccfbd60cbd4, (0, $6iHNw._)((0, $7Knp0._)({}, visibleSlide), {
                    id: getSlideId(visibleSlideIndex),
                    stylingType: stylingType
                }), visibleSlide.primaryText)
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _1lmceh92 _yv0e1n6q _zulpe2fx"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_nd5l1h6o _1e0c1txw _4cvr1h6o _zulp7vkz"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $2drdU.ArrowButton), {
                                onClick: handlePreviousClick,
                                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d0cJX))), {
                                    label: "",
                                    size: "medium"
                                }),
                                "aria-label": intl.formatMessage({
                                    id: "confluence.paid.lp.carousel.previous.label",
                                    defaultMessage: "Previous slide"
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                role: "tablist",
                                "aria-label": intl.formatMessage({
                                    id: "confluence.paid.lp.carousel.tablist.label",
                                    defaultMessage: "Choose a slide to display."
                                }),
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _zulp1tcg"
                                ]),
                                children: slides.map((slide, index)=>{
                                    const isVisibleTab = visibleSlideIndex === index;
                                    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        "aria-controls": getSlideId(index),
                                        "aria-selected": isVisibleTab,
                                        role: "tab",
                                        "aria-label": intl.formatMessage({
                                            id: "confluence.paid.lp.carousel.tab.label",
                                            defaultMessage: `Slide {slideNumber}`
                                        }, {
                                            slideNumber: `${index + 1}`
                                        }),
                                        tabIndex: isVisibleTab ? 0 : -1,
                                        onKeyDown: handleKeyDown,
                                        onClick: ()=>handleTabClick(index),
                                        ref: (node)=>{
                                            if (node) tabsRef.current[index] = node;
                                        },
                                        className: (0, $esG4f.default)([
                                            "_2rko1ssb _80omtlke _1bsb1crf _4t3i1crf _bfhkcd5j",
                                            isVisibleTab && "_bfhkrbzz"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                                        }
                                    }, `${slide.primaryText}-${index}`);
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $2drdU.ArrowButton), {
                                onClick: handleNextClick,
                                "aria-label": intl.formatMessage({
                                    id: "confluence.paid.lp.carousel.next.label",
                                    defaultMessage: "Next slide"
                                }),
                                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Bf61))), {
                                    label: "",
                                    size: "medium"
                                })
                            })
                        ]
                    }),
                    showPlayButton && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_nd5lusic"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2drdU.PlayPauseButton), {
                            onClick: toggleRotating,
                            isRotating: isRotating
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("cIqek", function(module, exports) {
$parcel$export(module.exports, "Adg4RaisedMedia", function () { return (parcelRequire("eGxBJ")).Adg4RaisedMedia; });
parcelRequire("eGxBJ");

});
parcelRegister("eGxBJ", function(module, exports) {

$parcel$export(module.exports, "Adg4RaisedMedia", function () { return $87cd6c26a4a4ed0a$export$bfa1278d9934b266; });
/* raised-media.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $87cd6c26a4a4ed0a$var$raisedImage = null;
const $87cd6c26a4a4ed0a$export$bfa1278d9934b266 = ({ className: className, children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_16qs1qw3 _2rko1crf _1e0c1txw _1reo15vq _18m915vq",
            className
        ]),
        children: children
    });
};

});



parcelRegister("2kLmv", function(module, exports) {

$parcel$export(module.exports, "VideoCarousel", function () { return $877c7feef28df468$export$402838bbb52a01c9; });
/* videoCarousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $eDoPe = parcelRequire("eDoPe");

var $f6qj2 = parcelRequire("f6qj2");

var $d0cJX = parcelRequire("d0cJX");

var $3Bf61 = parcelRequire("3Bf61");
parcelRequire("cIqek");
var $eGxBJ = parcelRequire("eGxBJ");

var $5ohHq = parcelRequire("5ohHq");

var $2drdU = parcelRequire("2drdU");
const $877c7feef28df468$var$carouselSlideStyle = null;
const $877c7feef28df468$var$infoContainerStyle = null;
const $877c7feef28df468$var$textContainerStyle = null;
const $877c7feef28df468$var$primaryTextStyle = null;
const $877c7feef28df468$var$subTextStyle = null;
const $877c7feef28df468$var$videoStyle = null;
const $877c7feef28df468$var$rightAlignedControlsContainerStyles = null;
const $877c7feef28df468$export$542984e3b3a8582e = ({ primaryText: primaryText, description: description, videoSrcMp4: videoSrcMp4, videoSrcWebm: videoSrcWebm, videoPreviewSrc: videoPreviewSrc, id: id, loop: loop, onEnded: onEnded })=>{
    const { ref: containerRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)({
        initialInView: true,
        threshold: 0.3
    });
    const videoRef = /*#__PURE__*/ (0, $iSvIT.createRef)();
    (0, $iSvIT.useEffect)(()=>{
        const videoElem = videoRef.current;
        if (!videoElem) return; // Pause the video when it's out of view
        if (!sectionIsVisible && !videoElem.paused) videoElem.pause();
         // Play the video when it's in view
        if (sectionIsVisible && videoElem.paused) {
            videoElem.currentTime = 0;
            videoElem.play().catch(()=>{});
        }
    }, [
        videoRef,
        sectionIsVisible
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        role: "tabpanel",
        id: id,
        ref: containerRef,
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulp7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $eGxBJ.Adg4RaisedMedia), {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("video", {
                    width: 1920,
                    height: 1080,
                    playsInline: true,
                    muted: true,
                    preload: "auto",
                    poster: videoPreviewSrc,
                    autoPlay: true,
                    loop: loop,
                    ref: videoRef,
                    onEnded: onEnded,
                    onLoadedMetadata: (videoEvent)=>{
                        try {
                            videoEvent.currentTarget.currentTime = 0; // Set currentTime to workaround Safari not autplaying
                            if (videoEvent.currentTarget.parentElement) videoEvent.currentTarget.play().catch(()=>false); // Call play() as backup to ensure the video is playing
                        } catch (error) {
                            console.log("Error calling play method on video after onCanPlay is invoked.");
                        }
                    },
                    className: (0, $esG4f.default)([
                        "_p12f1osq _4t3i1wug"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                            src: videoSrcMp4,
                            type: `video/mp4`
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                            src: videoSrcWebm,
                            type: `video/webm`
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bah1yb4 _4cvr1h6o _zulp7vkz _1tke53f4"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _1bsb1osq _y3gn1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                            className: (0, $esG4f.default)([
                                "_k48p53lb _1wyba982 _vwz41i72 _1dyzzyni _6rthi2wt _ect4qlpn _so7dlb34"
                            ]),
                            style: {
                                "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                            },
                            children: primaryText
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_k48p1nn1 _1wyb7vkz _vwz41tcg"
                            ]),
                            children: description
                        })
                    ]
                })
            })
        ]
    });
};
const $877c7feef28df468$var$carouselTabListStyle = null;
const $877c7feef28df468$var$dotStyle = null;
const $877c7feef28df468$var$currentDotStyle = null;
const $877c7feef28df468$var$carouselStyles = null;
const $877c7feef28df468$var$controlsContainerStyles = null;
const $877c7feef28df468$var$centeredControlsContainerStyles = null;
const $877c7feef28df468$export$402838bbb52a01c9 = ({ "aria-label": ariaLabel, slides: slides, "id": carouselId })=>{
    const intl = (0, $f6qj2.default)();
    const tabsRef = (0, $iSvIT.useRef)({});
    const [visibleSlideIndex, _setVisibleSlideIndex] = (0, $iSvIT.useState)(0);
    const visibleSlide = slides[visibleSlideIndex];
    if (visibleSlide === undefined) throw new Error("Slide index out of bounds.");
    const setVisibleSlideIndex = (newState, moveFocus = false)=>{
        _setVisibleSlideIndex((prevState)=>{
            var _tabsRef_current_calculatedState;
            let calculatedState;
            if (typeof newState === "function") calculatedState = newState(prevState);
            else calculatedState = newState;
            moveFocus && (tabsRef === null || tabsRef === void 0 ? void 0 : (_tabsRef_current_calculatedState = tabsRef.current[calculatedState]) === null || _tabsRef_current_calculatedState === void 0 ? void 0 : _tabsRef_current_calculatedState.focus());
            return calculatedState;
        });
    };
    const moveToPreviousSlide = (moveFocus = false)=>{
        setVisibleSlideIndex((prev)=>{
            return prev === 0 ? slides.length - 1 : prev - 1;
        }, moveFocus);
    };
    const moveToNextSlide = (0, $iSvIT.useCallback)((moveFocus = false)=>{
        setVisibleSlideIndex((prev)=>{
            return prev === slides.length - 1 ? 0 : prev + 1;
        }, moveFocus);
    }, [
        slides.length
    ]);
    const [isRotating, setIsRotating] = (0, $iSvIT.useState)(true);
    (0, $iSvIT.useEffect)(()=>setIsRotating(true), [
        moveToNextSlide
    ]);
    const handleKeyDown = (e)=>{
        switch(e.key){
            case "ArrowRight":
                moveToNextSlide(true);
                break;
            case "ArrowLeft":
                moveToPreviousSlide(true);
                break;
            case "Home":
                setVisibleSlideIndex(0, true);
                break;
            case "End":
                setVisibleSlideIndex(slides.length - 1, true);
                break;
            default:
                return;
        }
        setIsRotating(false);
        e.preventDefault();
    };
    const handleTabClick = (index)=>{
        setIsRotating(false);
        setVisibleSlideIndex(index);
    };
    const handlePreviousClick = ()=>{
        setIsRotating(false);
        moveToPreviousSlide();
    };
    const handleNextClick = ()=>{
        setIsRotating(false);
        moveToNextSlide();
    };
    const getSlideId = (suffix)=>`${carouselId}-${suffix}`;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        "aria-label": ariaLabel,
        "aria-roledescription": "carousel",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                "aria-atomic": false,
                "aria-live": isRotating ? "off" : "polite",
                children: /*#__PURE__*/ (0, $loA2J.jsx)($877c7feef28df468$export$542984e3b3a8582e, (0, $6iHNw._)((0, $7Knp0._)({}, visibleSlide), {
                    id: getSlideId(visibleSlideIndex),
                    loop: !isRotating,
                    onEnded: ()=>moveToNextSlide()
                }), visibleSlide.primaryText)
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _1lmceh92 _yv0e1n6q _zulpe2fx _1pfh1crf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_nd5l1h6o _1e0c1txw _4cvr1h6o _zulp7vkz"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $2drdU.ArrowButton), {
                                onClick: handlePreviousClick,
                                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d0cJX))), {
                                    label: "",
                                    size: "medium"
                                }),
                                "aria-label": intl.formatMessage({
                                    id: "confluence.paid.lp.carousel.previous.label",
                                    defaultMessage: "Previous slide"
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                role: "tablist",
                                "aria-label": intl.formatMessage({
                                    id: "confluence.paid.lp.carousel.tablist.label",
                                    defaultMessage: "Choose a slide to display."
                                }),
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _zulp1tcg"
                                ]),
                                children: slides.map((slide, index)=>{
                                    const isVisibleTab = visibleSlideIndex === index;
                                    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        "aria-controls": getSlideId(index),
                                        "aria-selected": isVisibleTab,
                                        role: "tab",
                                        "aria-label": intl.formatMessage({
                                            id: "confluence.paid.lp.carousel.tab.label",
                                            defaultMessage: `Slide {slideNumber}`
                                        }, {
                                            slideNumber: `${index + 1}`
                                        }),
                                        tabIndex: isVisibleTab ? 0 : -1,
                                        onKeyDown: handleKeyDown,
                                        onClick: ()=>handleTabClick(index),
                                        ref: (node)=>{
                                            if (node) tabsRef.current[index] = node;
                                        },
                                        className: (0, $esG4f.default)([
                                            "_2rko1ssb _80omtlke _1bsb1crf _4t3i1crf _bfhkcd5j",
                                            isVisibleTab && "_bfhkrbzz"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                                        }
                                    }, `${slide.primaryText}-${index}`);
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $2drdU.ArrowButton), {
                                onClick: handleNextClick,
                                "aria-label": intl.formatMessage({
                                    id: "confluence.paid.lp.carousel.next.label",
                                    defaultMessage: "Next slide"
                                }),
                                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Bf61))), {
                                    label: "",
                                    size: "medium"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_nd5lusic"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2drdU.PlayPauseButton), {
                            onClick: ()=>setIsRotating(!isRotating),
                            isRotating: isRotating
                        })
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("hwuMM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c9ce988b095e529$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $jgJpJ = parcelRequire("jgJpJ");
parcelRequire("f0Hih");
var $dhmEV = parcelRequire("dhmEV");

var $iMdoL = parcelRequire("iMdoL");

var $dWbel = parcelRequire("dWbel");
parcelRequire("2z7nN");
var $fPivo = parcelRequire("fPivo");
parcelRequire("jQIyh");
var $6mUgP = parcelRequire("6mUgP");
parcelRequire("WKdxa");
var $cRAeL = parcelRequire("cRAeL");
const $6c9ce988b095e529$var$EmbeddedSignupModule = ({ bundle: bundle, edition: edition = "free", useCurrentRedirect: useCurrentRedirect, variantOverride: variantOverride, customSignupHeader: customSignupHeader })=>{
    var _profile_cohorts, _profile_cohorts1, _profile_cohorts2;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { profile: profile, user: user } = (0, $iMdoL.useUserContext)();
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    (0, $iSvIT.useEffect)(()=>{
        var _profile_cohorts, _profile_cohorts1, _profile_cohorts2;
        if (!analyticsClient || user.requestInProgress || profile.requestInProgress) return;
        if (user.isUserLoggedIn) createAnalyticsEvent({
            eventType: "ui",
            action: "viewed",
            actionSubject: "siteNameComponent",
            containerId: "bxp-ui-signup",
            actionSubjectId: "embedded",
            attributes: {
                productKey: (0, $jgJpJ.getPrimaryProductKeyFromBundle)(bundle),
                edition: edition,
                userType: (_profile_cohorts = profile.cohorts) === null || _profile_cohorts === void 0 ? void 0 : _profile_cohorts.userType,
                domainType: (_profile_cohorts1 = profile.cohorts) === null || _profile_cohorts1 === void 0 ? void 0 : _profile_cohorts1.domainType,
                companyType: (_profile_cohorts2 = profile.cohorts) === null || _profile_cohorts2 === void 0 ? void 0 : _profile_cohorts2.companyType
            }
        }).fire();
        else createAnalyticsEvent({
            eventType: "ui",
            action: "viewed",
            actionSubject: "accountCreationComponent",
            containerId: "bxp-ui-signup",
            actionSubjectId: "embedded",
            attributes: {
                productKey: (0, $jgJpJ.getPrimaryProductKeyFromBundle)(bundle),
                edition: edition
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        analyticsClient,
        user.isUserLoggedIn,
        user.requestInProgress,
        bundle,
        edition,
        profile.requestInProgress,
        (_profile_cohorts = profile.cohorts) === null || _profile_cohorts === void 0 ? void 0 : _profile_cohorts.userType,
        (_profile_cohorts1 = profile.cohorts) === null || _profile_cohorts1 === void 0 ? void 0 : _profile_cohorts1.domainType,
        (_profile_cohorts2 = profile.cohorts) === null || _profile_cohorts2 === void 0 ? void 0 : _profile_cohorts2.companyType
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cRAeL.SignupFormContextProvider), {
        bundle: bundle,
        edition: edition,
        useCurrentRedirect: useCurrentRedirect,
        isEmbedded: true,
        customHeader: customSignupHeader,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            "data-testid": "signup-module",
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                "aria-busy": user.requestInProgress,
                "aria-live": "polite",
                children: user.requestInProgress ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $fPivo.FormLoading), {
                    notFullHeight: true
                }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dhmEV.default), {
                    intentType: "form",
                    productKey: (0, $jgJpJ.getPrimaryProductKeyFromBundle)(bundle),
                    edition: edition,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6mUgP.EmbeddedSignupForm), {
                        bundle: bundle,
                        isUserLoggedIn: user.isUserLoggedIn,
                        variantOverride: variantOverride
                    })
                })
            })
        })
    });
};
var $6c9ce988b095e529$export$2e2bcd8739ae039 = $6c9ce988b095e529$var$EmbeddedSignupModule;

});
parcelRegister("2z7nN", function(module, exports) {
$parcel$export(module.exports, "FormLoading", function () { return (parcelRequire("fPivo")).FormLoading; });
$parcel$export(module.exports, "SignupForm", function () { return (parcelRequire("ddN1B")).SignupForm; });
$parcel$export(module.exports, "SignupFormSuccessUFOEvent", function () { return (parcelRequire("9ax0J")).SignupFormSuccessUFOEvent; });
$parcel$export(module.exports, "SiteNameForm", function () { return (parcelRequire("2oRUX")).SiteNameForm; });
parcelRequire("5OjGY");
parcelRequire("jQIyh");
parcelRequire("aHxuL");

});
parcelRegister("5OjGY", function(module, exports) {
$parcel$export(module.exports, "FormLoading", function () { return (parcelRequire("fPivo")).FormLoading; });
parcelRequire("fPivo");

});
parcelRegister("fPivo", function(module, exports) {

$parcel$export(module.exports, "FormLoading", function () { return $8116958daecdf4bd$export$2f1709634d27333b; });
/* form-loading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $9gh2a = parcelRequire("9gh2a");
const $8116958daecdf4bd$export$2f1709634d27333b = ({ notFullHeight: notFullHeight = false })=>{
    const intl = (0, $f6qj2.default)();
    const loading = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.loading",
        defaultMessage: "Loading"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        role: "progressbar",
        "aria-label": loading,
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o",
            !notFullHeight && "_4t3i1kxc"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gh2a.default), {
            size: "large"
        })
    });
};
const $8116958daecdf4bd$var$formLoadingCss = null;
const $8116958daecdf4bd$var$formLoadingFullHeightCss = null;

});


parcelRegister("jQIyh", function(module, exports) {
$parcel$export(module.exports, "SignupForm", function () { return (parcelRequire("ddN1B")).SignupForm; });
$parcel$export(module.exports, "SignupFormSuccessUFOEvent", function () { return (parcelRequire("9ax0J")).SignupFormSuccessUFOEvent; });
$parcel$export(module.exports, "EmbeddedSignupForm", function () { return (parcelRequire("6mUgP")).EmbeddedSignupForm; });
parcelRequire("ddN1B");
parcelRequire("9ax0J");
parcelRequire("6mUgP");

});
parcelRegister("ddN1B", function(module, exports) {

$parcel$export(module.exports, "SignupForm", function () { return $e02a856af8e7cd76$export$cc15cfe224a6a69b; });

var $loA2J = parcelRequire("loA2J");

var $6WBIS = parcelRequire("6WBIS");
parcelRequire("WKdxa");
var $cRAeL = parcelRequire("cRAeL");
var $1qjOG = parcelRequire("1qjOG");
parcelRequire("ao0u9");
var $dxCBa = parcelRequire("dxCBa");
var $hFUS5 = parcelRequire("hFUS5");
const $e02a856af8e7cd76$export$cc15cfe224a6a69b = ({ emailFormOnly: emailFormOnly, animatedSocialBanner: animatedSocialBanner, hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles, bgColor: bgColor = "bgWhite", customSignInProviders: customSignInProviders, hideLegalText: hideLegalText })=>{
    const { productName: productName } = (0, $cRAeL.useSignupFormContext)();
    const { isAnimatedHero: isAnimatedHero } = (0, $6WBIS.usePaidJswProductTourContext)();
    let variant = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dxCBa.DefaultSignupForm), {});
    if (isAnimatedHero || emailFormOnly) variant = /*#__PURE__*/ (0, $loA2J.jsx)((0, $hFUS5.PaidEmailForm), {
        animatedSocialBanner: animatedSocialBanner,
        hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles,
        bgColor: bgColor,
        customSignInProviders: customSignInProviders,
        hideLegalText: hideLegalText
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1qjOG.SignupAnalyticsContext), {
        productName: productName,
        children: variant
    });
};

});
parcelRegister("6WBIS", function(module, exports) {

$parcel$export(module.exports, "usePaidJswProductTourContext", function () { return $b2db430733957aa0$export$28c0cc092f6791a9; });

var $iSvIT = parcelRequire("iSvIT");

var $8cKGP = parcelRequire("8cKGP");
const $b2db430733957aa0$var$defaultValues = {
    isLoggedIn: false,
    paidJiraPageType: (0, $8cKGP.PaidJiraPageType).DEFAULT
};
const $b2db430733957aa0$export$f56a0290ee9b71c2 = /*#__PURE__*/ (0, $iSvIT.createContext)($b2db430733957aa0$var$defaultValues);
const $b2db430733957aa0$export$28c0cc092f6791a9 = ()=>{
    const { isLoggedIn: isLoggedIn, paidJiraPageType: paidJiraPageType } = (0, $iSvIT.useContext)($b2db430733957aa0$export$f56a0290ee9b71c2);
    // if user is logged out and page paid-lp-jsw-features page show animated hero
    const isAnimatedHero = !isLoggedIn && paidJiraPageType === (0, $8cKGP.PaidJiraPageType).PAID_LP_JSW_FEATURES;
    return {
        isLoggedIn: isLoggedIn,
        paidJiraPageType: paidJiraPageType,
        isAnimatedHero: isAnimatedHero
    };
};

});
parcelRegister("8cKGP", function(module, exports) {

$parcel$export(module.exports, "PaidJiraPageType", function () { return $34c280fcea47d3c0$export$334cec9362a8bc36; });
var $34c280fcea47d3c0$export$334cec9362a8bc36;
(function(PaidJiraPageType) {
    PaidJiraPageType[PaidJiraPageType["PAID_LP_JSW_FEATURES"] = 0] = "PAID_LP_JSW_FEATURES";
    PaidJiraPageType[PaidJiraPageType["PAID_LP_JSW_ROADMAPS"] = 1] = "PAID_LP_JSW_ROADMAPS";
    PaidJiraPageType[PaidJiraPageType["PAID_LP_JSW_TEMPLATE"] = 2] = "PAID_LP_JSW_TEMPLATE";
    PaidJiraPageType[PaidJiraPageType["PAID_LP_JSW_TRACKER"] = 3] = "PAID_LP_JSW_TRACKER";
    PaidJiraPageType[PaidJiraPageType["PAID_LP_JSW_PM"] = 4] = "PAID_LP_JSW_PM";
    PaidJiraPageType[PaidJiraPageType["DEFAULT"] = 5] = "DEFAULT";
})($34c280fcea47d3c0$export$334cec9362a8bc36 || ($34c280fcea47d3c0$export$334cec9362a8bc36 = {}));

});


parcelRegister("WKdxa", function(module, exports) {
$parcel$export(module.exports, "SignupAnalyticsContext", function () { return (parcelRequire("1qjOG")).SignupAnalyticsContext; });
$parcel$export(module.exports, "SignupFormContextProvider", function () { return (parcelRequire("cRAeL")).SignupFormContextProvider; });
$parcel$export(module.exports, "useSignupFormContext", function () { return (parcelRequire("cRAeL")).useSignupFormContext; });
parcelRequire("1qjOG");
parcelRequire("cRAeL");

});
parcelRegister("1qjOG", function(module, exports) {

$parcel$export(module.exports, "SignupAnalyticsContext", function () { return $b53aa7ce3d8316c8$export$1bde86e98d910a3d; });

var $loA2J = parcelRequire("loA2J");

var $jXTzN = parcelRequire("jXTzN");
const $b53aa7ce3d8316c8$export$1bde86e98d910a3d = ({ children: children, productName: productName })=>{
    const defaultAnalyticsData = {
        schemaVersion: 1,
        action: "event",
        event: "event",
        // event verb, in past tense (eg, "clicked")
        eventType: "ui",
        eventComponent: "signUp",
        // name of component being interacted with, in camelCase
        eventContainer: "signUp",
        // container, in camelCase; eg, component that contains this component within a page
        eventColumn: "signUpForm",
        // should be bundleInformation or signUpForm
        eventName: "signupFormJSWv2",
        uuid: "signupFormJSWv2",
        productName: // required for Magnolia events, unique id for a given component if available
        productName
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jXTzN.default), {
        data: defaultAnalyticsData,
        children: children
    });
};

});
parcelRegister("jXTzN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e88ea34f6d81d425$export$2e2bcd8739ae039; });

var $9D0e3 = parcelRequire("9D0e3");

var $dPl4k = parcelRequire("dPl4k");

var $XAEGR = parcelRequire("XAEGR");
var $e88ea34f6d81d425$var$_process$env;
var $e88ea34f6d81d425$var$ExportedAnalyticsContext;
if (typeof $XAEGR !== "undefined" && $XAEGR !== null && ($e88ea34f6d81d425$var$_process$env = {}, true) && $e88ea34f6d81d425$var$_process$env !== void 0 && $e88ea34f6d81d425$var$_process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]) $e88ea34f6d81d425$var$ExportedAnalyticsContext = (0, $dPl4k.default);
else $e88ea34f6d81d425$var$ExportedAnalyticsContext = (0, $9D0e3.default);
var $e88ea34f6d81d425$export$2e2bcd8739ae039 = $e88ea34f6d81d425$var$ExportedAnalyticsContext;

});
parcelRegister("9D0e3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7027ee6886356bbf$export$2e2bcd8739ae039; });

var $4Z10T = parcelRequire("4Z10T");

var $6rQsM = parcelRequire("6rQsM");

var $9TYIF = parcelRequire("9TYIF");

var $inya7 = parcelRequire("inya7");

var $k3rDa = parcelRequire("k3rDa");

var $hiHUU = parcelRequire("hiHUU");

var $8A1dt = parcelRequire("8A1dt");

var $6NMpj = parcelRequire("6NMpj");

var $iSvIT = parcelRequire("iSvIT");

var $4J1z5 = parcelRequire("4J1z5");

var $lEO1D = parcelRequire("lEO1D");
function $7027ee6886356bbf$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7027ee6886356bbf$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $8A1dt.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $8A1dt.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $hiHUU.default)(this, result);
    };
}
function $7027ee6886356bbf$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $7027ee6886356bbf$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($4J1z5))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($4J1z5))).func
};
var $7027ee6886356bbf$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $7027ee6886356bbf$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    (0, $k3rDa.default)(AnalyticsContext, _Component);
    var _super = $7027ee6886356bbf$var$_createSuper(AnalyticsContext);
    function AnalyticsContext(props) {
        var _this;
        (0, $6rQsM.default)(this, AnalyticsContext);
        _this = _super.call(this, props);
        (0, $6NMpj.default)((0, $inya7.default)(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, $6NMpj.default)((0, $inya7.default)(_this), "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $7027ee6886356bbf$var$noop : _this$context$getAtla;
            return [].concat((0, $4Z10T.default)(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, $6NMpj.default)((0, $inya7.default)(_this), "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $7027ee6886356bbf$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, $9TYIF.default)(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $lEO1D.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsContext;
}((0, $iSvIT.Component));
(0, $6NMpj.default)($7027ee6886356bbf$var$AnalyticsContext, "contextTypes", $7027ee6886356bbf$var$ContextTypes);
(0, $6NMpj.default)($7027ee6886356bbf$var$AnalyticsContext, "childContextTypes", $7027ee6886356bbf$var$ContextTypes);
var $7027ee6886356bbf$export$2e2bcd8739ae039 = $7027ee6886356bbf$var$AnalyticsContext;

});

parcelRegister("dPl4k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a110619b8ce731eb$export$2e2bcd8739ae039; });

var $4Z10T = parcelRequire("4Z10T");

var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");

var $5kXR2 = parcelRequire("5kXR2");

var $8T92u = parcelRequire("8T92u");
var $a110619b8ce731eb$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $8T92u.useTrackedRef)(data);
    var analyticsContext = (0, $5kXR2.useAnalyticsContext)();
    var getAtlaskitAnalyticsContext = (0, $iSvIT.useCallback)(function() {
        return [].concat((0, $4Z10T.default)(analyticsContext.getAtlaskitAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        analyticsContext,
        dataRef
    ]);
    var value = (0, $iSvIT.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: analyticsContext.getAtlaskitAnalyticsEventHandlers
        };
    }, [
        analyticsContext,
        getAtlaskitAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $lEO1D.default).Provider, {
        value: value
    }, children);
};
var $a110619b8ce731eb$export$2e2bcd8739ae039 = $a110619b8ce731eb$var$AnalyticsContext;

});



parcelRegister("cRAeL", function(module, exports) {

$parcel$export(module.exports, "useSignupFormContext", function () { return $3e4b5876cc14462a$export$700674aef42f5290; });
$parcel$export(module.exports, "SignupFormContextProvider", function () { return $3e4b5876cc14462a$export$aaba79cce552c89; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $eZAyW = parcelRequire("eZAyW");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $jgJpJ = parcelRequire("jgJpJ");

var $gkhN4 = parcelRequire("gkhN4");

var $lrVTP = parcelRequire("lrVTP");
const { IDENTITY_USER_SIGNUP_API: $3e4b5876cc14462a$var$IDENTITY_USER_SIGNUP_API } = (0, $jgJpJ.UfoCustomTimingKey);
const $3e4b5876cc14462a$export$46bf5b535cc4ff18 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $3e4b5876cc14462a$export$700674aef42f5290 = ()=>{
    const context = (0, $iSvIT.useContext)($3e4b5876cc14462a$export$46bf5b535cc4ff18);
    if (!context) throw new Error("useSignupFormContext must be used within a SignupFormContextProvider");
    return context;
};
const $3e4b5876cc14462a$export$aaba79cce552c89 = ({ bundle: bundle, children: children, edition: edition = "free", isEmbedded: isEmbedded = false, useCurrentRedirect: useCurrentRedirect, customHeader: customHeader })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const intl = (0, $f6qj2.default)();
    const location = (0, $lrVTP.useLocation)();
    const [isEmailValid, setIsEmailValid] = (0, $iSvIT.useState)(false);
    const [hasSubmitted, setHasSubmitted] = (0, $iSvIT.useState)(false);
    const [isReadyForInvalid, setIsReadyForInvalid] = (0, $iSvIT.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $iSvIT.useState)(false);
    const [formError, setFormError] = (0, $iSvIT.useState)(false);
    const [email, setEmail] = (0, $iSvIT.useState)("");
    const [typeAheadEmail, setTypeAheadEmail] = (0, $iSvIT.useState)("");
    const [onSubmitProps, setOnSubmitProps] = (0, $iSvIT.useState)(undefined);
    const [recaptchaFailedToLoad, setRecaptchaFailedToLoad] = (0, $iSvIT.useState)(false);
    const [recaptchaRetryTimeRemainingSecond, setRecaptchaRetryTimeRemainingSecond] = (0, $iSvIT.useState)(60);
    const localePath = (0, $jgJpJ.getLocalePath)(intl.locale);
    const signupClient = (0, $gkhN4.useBxpWebStargateClient)();
    const { executeRecaptcha: executeRecaptcha } = (0, $eZAyW.useGoogleReCaptcha)();
    const continueParam = (0, $jgJpJ.getContinueParam)(location);
    const redirectTo = useCurrentRedirect ? window.location.href : continueParam ? continueParam : (0, $jgJpJ.getNameYourSiteRedirectUrl)({
        bundle: bundle,
        edition: edition,
        localePath: localePath
    });
    const products = (0, $jgJpJ.getProductsFromBundle)(bundle);
    // default experiment params
    let identityCobranding = "wac";
    if (bundle === "confluence") identityCobranding = "wac--otp-confluence";
    else if (bundle === "jira-software") identityCobranding = "wac--otp-jira";
    (0, $iSvIT.useEffect)(()=>{
        (0, $jgJpJ.trackSignFormLoad)(createAnalyticsEvent);
        (0, $jgJpJ.trackTimeToFormReady)(createAnalyticsEvent, performance.now());
    }, [
        createAnalyticsEvent
    ]);
    // Embedded form does not show product logo
    const showProductLogo = !isEmbedded;
    const productKey = products.map(({ productKey: productKey })=>productKey).join(",");
    const productName = products.map(({ productName: productName })=>productName).join(" + ");
    const productLogos = products.map(({ productLogo: productLogo })=>productLogo);
    const onSubmitWithReCAPTCHA = (0, $iSvIT.useCallback)(async ({ email: email })=>{
        var _products_;
        setIsReadyForInvalid(true);
        if (!email || !isEmailValid) {
            (0, $jgJpJ.trackInvalidEmail)(createAnalyticsEvent);
            return;
        }
        setOnSubmitProps({
            email: email
        });
        if (!executeRecaptcha && recaptchaRetryTimeRemainingSecond > 0) {
            // set trigger that will wait for Recaptcha retry logic
            setFormError(true);
            setIsSubmitting(true);
            setRecaptchaFailedToLoad(true);
            return;
        }
        setRecaptchaFailedToLoad(false);
        // Start UFO to begin duration measurements for account creation
        (0, $jgJpJ.ufoEventAccountCreation).start({
            productKey: (0, $jgJpJ.getPrimaryProductKeyFromBundle)(bundle),
            webPlatform: "bxp-ui"
        });
        const gRecaptchaResponse = await (0, $jgJpJ.getRecaptcha)(email, executeRecaptcha);
        (0, $jgJpJ.ufoEventAccountCreation).setCustomData({
            gRecaptchaResponse: gRecaptchaResponse !== null && gRecaptchaResponse !== void 0 ? gRecaptchaResponse : "none",
            executeRecaptchaExists: Boolean(executeRecaptcha),
            reactComponent: "SignupFormContextProvider"
        });
        // Handle missing reCAPTCHA response
        if (!gRecaptchaResponse) {
            (0, $jgJpJ.trackRecaptchaFailure)(createAnalyticsEvent, "bxp-ui-signup-form");
            const invalidRecaptchaError = new Error("Missing reCAPTCHA token");
            (0, $jgJpJ.ufoEventAccountCreation).failure({
                customData: {
                    reactComponent: "SignupFormContextProvider"
                },
                error: invalidRecaptchaError
            });
            throw invalidRecaptchaError;
        }
        (0, $jgJpJ.trackFormSubmit)(createAnalyticsEvent, (_products_ = products[0]) === null || _products_ === void 0 ? void 0 : _products_.productKey, edition);
        const existingUserRedirectUrl = await (0, $jgJpJ.getMethodsAvailableRedirection)({
            email: email,
            application: identityCobranding,
            signupClient: signupClient,
            createAnalyticsEvent: createAnalyticsEvent,
            successRedirect: redirectTo
        }).catch((error)=>{
            setFormError(true);
            (0, $jgJpJ.trackSignupFailure)(createAnalyticsEvent);
            throw new Error(error);
        });
        if (existingUserRedirectUrl) {
            window.location.assign(existingUserRedirectUrl.replace("/initiate/password", ""));
            return;
        }
        const newUserRedirectTo = redirectTo + `&n2n=true`;
        (0, $jgJpJ.ufoEventAccountCreation).startSubstep($3e4b5876cc14462a$var$IDENTITY_USER_SIGNUP_API);
        await signupClient.userSignup({
            application: identityCobranding,
            displayName: "",
            email: email,
            gRecaptchaResponse: gRecaptchaResponse,
            locale: intl.locale,
            products: products.map(({ productKey: productKey })=>({
                    productKey: productKey,
                    edition: edition
                })),
            redirectTo: newUserRedirectTo
        }).then(({ otpRedirect: otpRedirect })=>{
            (0, $jgJpJ.ufoEventAccountCreation).endSubstep($3e4b5876cc14462a$var$IDENTITY_USER_SIGNUP_API);
            if (!otpRedirect) throw new Error("No OTP redirect");
            // Reliability SLO "good event" metric emitted for submit account creation
            (0, $jgJpJ.ufoEventAccountCreation).success({
                customData: {
                    reactComponent: "SignupFormContextProvider"
                }
            });
            window.location.assign(otpRedirect);
            setHasSubmitted(true);
        }).catch((error)=>{
            // Reliability SLO "bad event" metric emitted for submit account creation
            (0, $jgJpJ.ufoEventAccountCreation).endSubstep($3e4b5876cc14462a$var$IDENTITY_USER_SIGNUP_API);
            (0, $jgJpJ.ufoEventAccountCreation).failure({
                customData: {
                    reactComponent: "SignupFormContextProvider"
                },
                error: error
            });
            setFormError(true);
            (0, $jgJpJ.trackSignupFailure)(createAnalyticsEvent);
            throw new Error(error);
        });
        (0, $jgJpJ.trackSubmitSuccess)(createAnalyticsEvent);
        (0, $jgJpJ.trackRedirectCheckEmail)(createAnalyticsEvent);
        setEmail(email);
    }, [
        bundle,
        createAnalyticsEvent,
        edition,
        executeRecaptcha,
        identityCobranding,
        intl.locale,
        isEmailValid,
        products,
        redirectTo,
        signupClient
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (recaptchaFailedToLoad && recaptchaRetryTimeRemainingSecond <= 0) (0, $jgJpJ.ufoEventAccountCreation).failure({
            customData: {
                reactComponent: "SignupFormContextProvider",
                recaptchaRetryTimeRemainingSecond: 0
            },
            error: new Error("Recaptcha retry failed")
        });
        if (onSubmitProps && recaptchaFailedToLoad && executeRecaptcha) onSubmitWithReCAPTCHA(onSubmitProps).then(()=>{
            (0, $jgJpJ.ufoEventAccountCreation).success({
                customData: {
                    reactComponent: "SignupFormContextProvider",
                    analyticsEvent: "succeeded",
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                }
            });
        }).catch((error)=>{
            setFormError(true);
            setIsSubmitting(false);
            (0, $jgJpJ.ufoEventAccountCreation).failure({
                customData: {
                    reactComponent: "SignupFormContextProvider",
                    analyticsEvent: "errored",
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                },
                error: error
            });
            return;
        });
    }, [
        executeRecaptcha,
        recaptchaFailedToLoad,
        onSubmitProps,
        recaptchaRetryTimeRemainingSecond
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (!recaptchaFailedToLoad) return;
        if (recaptchaRetryTimeRemainingSecond <= 0) return;
        const intervalId = setInterval(()=>{
            setRecaptchaRetryTimeRemainingSecond(recaptchaRetryTimeRemainingSecond - 1);
        }, 1000);
        return ()=>clearInterval(intervalId);
    }, [
        recaptchaFailedToLoad,
        recaptchaRetryTimeRemainingSecond
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($3e4b5876cc14462a$export$46bf5b535cc4ff18.Provider, {
        value: {
            bundle: bundle,
            isEmbedded: isEmbedded,
            email: email,
            formError: formError,
            hasSubmitted: hasSubmitted,
            isSubmitting: isSubmitting,
            identityCobranding: identityCobranding,
            isEmailValid: isEmailValid,
            isReadyForInvalid: isReadyForInvalid,
            onSubmitWithReCAPTCHA: onSubmitWithReCAPTCHA,
            productKey: productKey,
            edition: edition,
            productLogos: productLogos,
            products: products,
            productName: productName,
            redirectTo: redirectTo,
            setIsEmailValid: setIsEmailValid,
            setIsReadyForInvalid: setIsReadyForInvalid,
            showProductLogo: showProductLogo,
            typeAheadEmail: typeAheadEmail,
            setTypeAheadEmail: setTypeAheadEmail,
            customHeader: customHeader
        },
        children: children
    });
};

});


parcelRegister("ao0u9", function(module, exports) {
$parcel$export(module.exports, "PaidEmailForm", function () { return (parcelRequire("hFUS5")).PaidEmailForm; });
$parcel$export(module.exports, "DefaultSignupForm", function () { return (parcelRequire("dxCBa")).DefaultSignupForm; });
parcelRequire("hFUS5");
parcelRequire("dxCBa");

});
parcelRegister("hFUS5", function(module, exports) {

$parcel$export(module.exports, "PaidEmailForm", function () { return $8f61a174033ef387$export$eb5413c805d258b4; });
/* paid-email-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $6x1qA = parcelRequire("6x1qA");
var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $6oKbD = parcelRequire("6oKbD");

var $jgJpJ = parcelRequire("jgJpJ");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("9DfPf");
var $5jy1A = parcelRequire("5jy1A");
var $bcjjH = parcelRequire("bcjjH");
var $6PtZq = parcelRequire("6PtZq");
var $jMrU6 = parcelRequire("jMrU6");
var $fVvJ6 = parcelRequire("fVvJ6");
var $9cpbu = parcelRequire("9cpbu");
parcelRequire("WKdxa");
var $cRAeL = parcelRequire("cRAeL");
const $8f61a174033ef387$var$confluenceEmbeddedExistingText = (0, $6x1qA.defineMessage)({
    id: "BxpUiSignup.SignupForm.existingProduct.confluence.embedded",
    defaultMessage: "Trying to access {product}? <logInLink>Log in</logInLink>"
});
const $8f61a174033ef387$export$eb5413c805d258b4 = ({ animatedSocialBanner: animatedSocialBanner, hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles, bgColor: bgColor = "bgWhite", customSignInProviders: customSignInProviders, hideLegalText: hideLegalText = false })=>{
    const { formError: formError, hasSubmitted: hasSubmitted, isEmailValid: isEmailValid, onSubmitWithReCAPTCHA: onSubmitWithReCAPTCHA, productKey: productKey, edition: edition, setIsEmailValid: setIsEmailValid, setTypeAheadEmail: setTypeAheadEmail, productName: productName } = (0, $cRAeL.useSignupFormContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    (0, $iSvIT.useEffect)(()=>{
        const customData = {
            webPlatform: "bxp-ui",
            reactComponent: "PaidEmailForm",
            experimentName: "paid-email-form",
            isLoggedIn: false
        };
        (0, $jgJpJ.ufoEventTryCloudSignupPageLoad).success({
            customData: customData
        });
        (0, $jgJpJ.ufoEventPaidSignupJSWLandingPageLoad).success({
            customData: {
                reactComponent: "PaidEmailForm",
                experimentName: "paid-email-form"
            }
        });
        (0, $jgJpJ.trackDataFoundationsAccountCreationComponent)(createAnalyticsEvent, {
            actionSubjectId: "embedded",
            productKey: productKey,
            edition: edition
        });
    }, [
        createAnalyticsEvent,
        productKey,
        edition
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6oKbD.default), {
        onSubmit: onSubmitWithReCAPTCHA,
        isDisabled: false,
        children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $loA2J.jsxs)("form", (0, $6iHNw._)((0, $7Knp0._)({}, formProps), {
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5jy1A.InputEmail), {
                        setIsEmailValid: setIsEmailValid,
                        submitting: submitting,
                        setTypeAheadEmail: setTypeAheadEmail,
                        hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles
                    }),
                    !hideLegalText && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_1wybepq8 _vwz4bs82"
                        ]),
                        style: {
                            "--_1h1y5xv": (0, $43MIc.default)((0, $jgJpJ.fontSize).xs)
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bcjjH.EulaText), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $6PtZq.ButtonSubmit), {
                        "data-testid": "signup-form-submit",
                        submitting: submitting,
                        hasSubmitted: hasSubmitted,
                        isEmailValid: isEmailValid,
                        formError: false,
                        hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles
                    }),
                    formError && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_syazgryn _19pki2wt _2hwxidpf _otyr1tcg _18u0idpf",
                            "errorMessageText"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "BxpUiSignup.SignupForm.formError",
                            defaultMessage: "It's taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <contactUsLink>contact us</contactUsLink>.",
                            values: {
                                contactUsLink: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                        text: text,
                                        "aria-label": text,
                                        type: "inline",
                                        href: "/company/contact",
                                        className: "linkText"
                                    })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_179r14vf _vwz4400g _19pkviql _2hwx1j6v _otyrviql _18u01j6v _16jlkb7n"
                                ])
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                className: (0, $esG4f.default)([
                                    "_syaz1c68 _ect4bzd7 _k48p1nn1",
                                    "separatorText"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                },
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "BxpUiSignup.SignupForm.orPaidExperiment",
                                    defaultMessage: "Or sign up with"
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_179r14vf _vwz4400g _19pkviql _2hwx1j6v _otyrviql _18u01j6v _16jlkb7n"
                                ])
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $jMrU6.SignInButtons), {
                        hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles,
                        customSignInProviders: customSignInProviders
                    }),
                    animatedSocialBanner && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1pfh1ylp"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fVvJ6.AnimatedSocialProof), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $9cpbu.ExistingProductText), {
                        messageOverride: $8f61a174033ef387$var$confluenceEmbeddedExistingText,
                        productName: productName,
                        bgColor: bgColor
                    })
                ]
            }))
    });
};
const $8f61a174033ef387$var$animatedSocialProof = null;
const $8f61a174033ef387$var$formErrorStyle = null;
const $8f61a174033ef387$var$legalTextCss = null;
const $8f61a174033ef387$var$orPaidSeparatorStyle = null;
const $8f61a174033ef387$var$separatorText = null;
const $8f61a174033ef387$var$separatorContainer = null;

});
parcelRegister("9DfPf", function(module, exports) {
$parcel$export(module.exports, "AnimatedSocialProof", function () { return (parcelRequire("fVvJ6")).AnimatedSocialProof; });
$parcel$export(module.exports, "ButtonSubmit", function () { return (parcelRequire("6PtZq")).ButtonSubmit; });
$parcel$export(module.exports, "EmailForm", function () { return (parcelRequire("aGugh")).EmailForm; });
$parcel$export(module.exports, "EulaText", function () { return (parcelRequire("bcjjH")).EulaText; });
$parcel$export(module.exports, "ExistingProductText", function () { return (parcelRequire("9cpbu")).ExistingProductText; });
$parcel$export(module.exports, "InputEmail", function () { return (parcelRequire("5jy1A")).InputEmail; });
$parcel$export(module.exports, "SignInButtons", function () { return (parcelRequire("jMrU6")).SignInButtons; });
parcelRequire("72EKa");
parcelRequire("aYz6E");
parcelRequire("swQEv");
parcelRequire("4XUO1");
parcelRequire("5CXM7");
parcelRequire("c5qwq");
parcelRequire("7ubNM");

});
parcelRegister("72EKa", function(module, exports) {
$parcel$export(module.exports, "AnimatedSocialProof", function () { return (parcelRequire("fVvJ6")).AnimatedSocialProof; });
parcelRequire("fVvJ6");

});
parcelRegister("fVvJ6", function(module, exports) {

$parcel$export(module.exports, "AnimatedSocialProof", function () { return $b0ce53f5c3f7960f$export$b9b8b5eca0edeb76; });
/* animated-social-proof.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
parcelRequire("goy7h");
var $hsIsf = parcelRequire("hsIsf");
var $gLfKe = parcelRequire("gLfKe");
var $gFJSc = parcelRequire("gFJSc");
var $6rfnk = parcelRequire("6rfnk");
var $b32Sf = parcelRequire("b32Sf");
var $kKkgA = parcelRequire("kKkgA");
var $81noK = parcelRequire("81noK");
const $b0ce53f5c3f7960f$var$carouselCss = null;
const $b0ce53f5c3f7960f$var$trackCss = null;
const $b0ce53f5c3f7960f$var$imageCss = null;
const $b0ce53f5c3f7960f$var$logos = [
    (0, $hsIsf.DominosLogo),
    (0, $gLfKe.SquareLogo),
    (0, $gFJSc.EbayLogo),
    (0, $6rfnk.CiscoLogo),
    (0, $b32Sf.FordLogo),
    (0, $kKkgA.PaypalLogo),
    (0, $81noK.NasaLogo)
];
const $b0ce53f5c3f7960f$export$b9b8b5eca0edeb76 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1reo15vq _18m915vq _4t3ildb6 _kqswh2mm _1bsb1osq _1mjbglyw"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_y44v9j94 _1e0c1txw _kqswstnw"
            ]),
            children: [
                ...$b0ce53f5c3f7960f$var$logos,
                ...$b0ce53f5c3f7960f$var$logos
            ].map((Logo, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _4t3ildb6 _1bsbymf6 _12l2zwfg"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)(Logo, {})
                }, index))
        })
    });

});
parcelRegister("goy7h", function(module, exports) {
$parcel$export(module.exports, "CiscoLogo", function () { return (parcelRequire("6rfnk")).CiscoLogo; });
$parcel$export(module.exports, "DominosLogo", function () { return (parcelRequire("hsIsf")).DominosLogo; });
$parcel$export(module.exports, "EbayLogo", function () { return (parcelRequire("gFJSc")).EbayLogo; });
$parcel$export(module.exports, "FordLogo", function () { return (parcelRequire("b32Sf")).FordLogo; });
$parcel$export(module.exports, "NasaLogo", function () { return (parcelRequire("81noK")).NasaLogo; });
$parcel$export(module.exports, "PaypalLogo", function () { return (parcelRequire("kKkgA")).PaypalLogo; });
$parcel$export(module.exports, "SquareLogo", function () { return (parcelRequire("gLfKe")).SquareLogo; });
parcelRequire("6rfnk");
parcelRequire("hsIsf");
parcelRequire("gFJSc");
parcelRequire("b32Sf");
parcelRequire("81noK");
parcelRequire("kKkgA");
parcelRequire("gLfKe");

});
parcelRegister("6rfnk", function(module, exports) {

$parcel$export(module.exports, "CiscoLogo", function () { return $debdeb521bfd1710$export$c0ee1f55c8145cdb; });

var $loA2J = parcelRequire("loA2J");
const $debdeb521bfd1710$export$c0ee1f55c8145cdb = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "0 0 79 42",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M22.2429424,41.0366151 L25.691892,41.0366151 L25.691892,27.4402999 L22.2429424,27.4402999 L22.2429424,41.0366151 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M53.4978468,31.3359257 C53.356853,31.2637727 52.2457684,30.6093615 50.5963441,30.6093615 C48.3677661,30.6093615 46.8208827,32.1541075 46.8208827,34.236813 C46.8208827,36.2574334 48.300305,37.8659425 50.5963441,37.8659425 C52.2181094,37.8659425 53.3463965,37.2252908 53.4978468,37.1447479 L53.4978468,40.7936775 C53.0644091,40.9148275 51.8878872,41.2782774 50.3561825,41.2782774 C46.4764936,41.2782774 43.0720684,38.6176764 43.0720684,34.236813 C43.0720684,30.1757722 46.1526803,27.1987047 50.3561825,27.1987047 C51.9728882,27.1987047 53.1716723,27.590009 53.4978468,27.6863249 L53.4978468,31.3359257 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M17.5025508,31.3359257 C17.3639182,31.2637727 16.2551948,30.6093615 14.6057704,30.6093615 C12.3721328,30.6093615 10.8262613,32.1541075 10.8262613,34.236813 C10.8262613,36.2574334 12.3077075,37.8659425 14.6057704,37.8659425 C16.2271984,37.8659425 17.354811,37.2252908 17.5025508,37.1447479 L17.5025508,40.7936775 C17.07451,40.9148275 15.8983255,41.2782774 14.3581881,41.2782774 C10.481535,41.2782774 7.08115739,38.6176764 7.08115739,34.236813 C7.08115739,30.1757722 10.161432,27.1987047 14.3581881,27.1987047 C15.9802907,27.1987047 17.1787375,27.590009 17.5025508,27.6863249 L17.5025508,31.3359257 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M64.3466401,30.6607076 C62.3008817,30.6607076 60.78132,32.2621693 60.78132,34.236813 C60.78132,36.215484 62.3008817,37.8156032 64.3466401,37.8156032 C66.3900373,37.8156032 67.9136467,36.215484 67.9136467,34.236813 C67.9136467,32.2621693 66.3900373,30.6607076 64.3466401,30.6607076 M71.5673408,34.236813 C71.5673408,38.1263646 68.5491304,41.2782774 64.3466401,41.2782774 C60.1438125,41.2782774 57.1293124,38.1263646 57.1293124,34.236813 C57.1293124,30.3529666 60.1438125,27.1987047 64.3466401,27.1987047 C68.5491304,27.1987047 71.5673408,30.3529666 71.5673408,34.236813"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M38.7701066,30.5307315 C38.7188362,30.5142873 37.2663983,30.1155999 36.0736858,30.1155999 C34.6917448,30.1155999 33.9412398,30.5760369 33.9412398,31.2301125 C33.9412398,32.0583621 34.9541685,32.3459674 35.5221911,32.5245042 L36.4730556,32.8262046 C38.7117528,33.5339754 39.7310902,35.0592569 39.7310902,36.7154206 C39.7310902,40.1307757 36.7125425,41.2781767 34.0734636,41.2781767 C32.2381839,41.2781767 30.5206239,40.9425812 30.3512965,40.9070081 L30.3512965,37.7779159 C30.6552088,37.8544316 32.1012378,38.2843294 33.6079819,38.2843294 C35.3231808,38.2843294 36.1124759,37.7839566 36.1124759,37.0144361 C36.1124759,36.325123 35.4297694,35.9271068 34.575037,35.6596372 C34.3655703,35.5905045 34.0518761,35.4928462 33.8383616,35.4237136 C31.917069,34.8189705 30.316554,33.6964036 30.316554,31.4459004 C30.316554,28.9027578 32.229414,27.1945769 35.4085191,27.1945769 C37.0876263,27.1945769 38.6672284,27.5999762 38.7701066,27.6278306 L38.7701066,30.5307315 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M3.42405648,12.8286741 C3.42405648,11.8910203 2.65567435,11.1308966 1.71223062,11.1308966 C0.770136118,11.1308966 6.74611175e-05,11.8910203 6.74611175e-05,12.8286741 L6.74611175e-05,16.3970608 C6.74611175e-05,17.3397485 0.770136118,18.0998723 1.71223062,18.0998723 C2.65567435,18.0998723 3.42405648,17.3397485 3.42405648,16.3970608 L3.42405648,12.8286741 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M12.8283386,8.14366055 C12.8283386,7.20667798 12.0596192,6.44521184 11.1165128,6.44521184 C10.1734064,6.44521184 9.40434963,7.20667798 9.40434963,8.14366055 L9.40434963,16.3969601 C9.40434963,17.3396478 10.1734064,18.0997716 11.1165128,18.0997716 C12.0596192,18.0997716 12.8283386,17.3396478 12.8283386,16.3969601 L12.8283386,8.14366055 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M22.2328907,1.73395472 C22.2328907,0.796972141 21.4634966,0.0368483835 20.5203902,0.0368483835 C19.5776211,0.0368483835 18.808227,0.796972141 18.808227,1.73395472 L18.808227,19.789327 C18.808227,20.7310079 19.5776211,21.4918029 20.5203902,21.4918029 C21.4634966,21.4918029 22.2328907,20.7310079 22.2328907,19.789327 L22.2328907,1.73395472 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M31.6367681,8.14366055 C31.6367681,7.20667798 30.8677113,6.44521184 29.9242676,6.44521184 C28.9814985,6.44521184 28.212779,7.20667798 28.212779,8.14366055 L28.212779,16.3969601 C28.212779,17.3396478 28.9814985,18.0997716 29.9242676,18.0997716 C30.8677113,18.0997716 31.6367681,17.3396478 31.6367681,16.3969601 L31.6367681,8.14366055 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M41.0304588,12.8286741 C41.0304588,11.8910203 40.266799,11.1308966 39.3284148,11.1308966 C38.385983,11.1308966 37.6169263,11.8910203 37.6169263,12.8286741 L37.6169263,16.3970608 C37.6169263,17.3397485 38.385983,18.0998723 39.3284148,18.0998723 C40.266799,18.0998723 41.0304588,17.3397485 41.0304588,16.3970608 L41.0304588,12.8286741 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M50.4383164,8.14366055 C50.4383164,7.20667798 49.6746566,6.44521184 48.7318875,6.44521184 C47.7911422,6.44521184 47.0254585,7.20667798 47.0254585,8.14366055 L47.0254585,16.3969601 C47.0254585,17.3396478 47.7911422,18.0997716 48.7318875,18.0997716 C49.6746566,18.0997716 50.4383164,17.3396478 50.4383164,16.3969601 L50.4383164,8.14366055 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M59.8490074,1.73395472 C59.8490074,0.796972141 59.0846729,0.0368483835 58.1425784,0.0368483835 C57.1987974,0.0368483835 56.4354748,0.796972141 56.4354748,1.73395472 L56.4354748,19.789327 C56.4354748,20.7310079 57.1987974,21.4918029 58.1425784,21.4918029 C59.0846729,21.4918029 59.8490074,20.7310079 59.8490074,19.789327 L59.8490074,1.73395472 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M69.2578432,8.14366055 C69.2578432,7.20667798 68.4941833,6.44521184 67.5298267,6.44521184 C66.5863829,6.44521184 65.8227231,7.20667798 65.8227231,8.14366055 L65.8227231,16.3969601 C65.8227231,17.3396478 66.5863829,18.0997716 67.5298267,18.0997716 C68.4941833,18.0997716 69.2578432,17.3396478 69.2578432,16.3969601 L69.2578432,8.14366055 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M78.6469129,12.8286741 C78.6469129,11.8910203 77.8808919,11.1308966 76.9404839,11.1308966 C75.9973775,11.1308966 75.2316938,11.8910203 75.2316938,12.8286741 L75.2316938,16.3970608 C75.2316938,17.3397485 75.9973775,18.0998723 76.9404839,18.0998723 C77.8808919,18.0998723 78.6469129,17.3397485 78.6469129,16.3970608 L78.6469129,12.8286741 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M76.6735065,39.2465823 L76.6735065,39.4596855 L76.0639953,39.4596855 L76.0639953,41.0366486 L75.8133773,41.0366486 L75.8133773,39.4596855 L75.2011676,39.4596855 L75.2011676,39.2465823 L76.6735065,39.2465823 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M76.8013453,39.2465823 L77.1936317,39.2465823 L77.7312968,40.714477 L77.741416,40.714477 L78.2618785,39.2465823 L78.6467442,39.2465823 L78.6467442,41.0366486 L78.3893801,41.0366486 L78.3893801,39.5677472 L78.3809474,39.5677472 L77.835187,41.0366486 L77.5973865,41.0366486 L77.0644437,39.5677472 L77.052638,39.5677472 L77.052638,41.0366486 L76.8013453,41.0366486 L76.8013453,39.2465823 Z"
            })
        ]
    });

});

parcelRegister("hsIsf", function(module, exports) {

$parcel$export(module.exports, "DominosLogo", function () { return $80701b14ec6746c0$export$3a87515d6bae358a; });

var $loA2J = parcelRequire("loA2J");
const $80701b14ec6746c0$export$3a87515d6bae358a = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "0 0 2318.3 500",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M1331.1,323.5c-25-58.4-111.2-40.3-134.8-2.8v-29.2h-75.1v207.1h77.8V394.4c0-38.9,8.3-41.7,29.2-43.1 c20.8-1.4,29.2,1.4,29.2,43.1l1.4,104.2h75.1v-107c0-19.5,4.2-37.5,25-37.5c25-1.4,30.6,1.4,30.6,32v114h79.2V345.7 C1470.1,272.1,1365.9,270.7,1331.1,323.5z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M986.4,276.2c-61.2,0-111.2,50-111.2,111.2s50,111.2,111.2,111.2s111.2-50,111.2-111.2 S1047.6,276.2,986.4,276.2z M986.4,426.3c-22.2,0-38.9-18.1-38.9-38.9c0-22.2,18.1-38.9,38.9-38.9c20.8,0,38.9,18.1,38.9,38.9 C1025.4,408.3,1007.3,426.3,986.4,426.3z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M775.2,224.8c-15.3-6.9-30.6-12.5-47.3-13.9c-23.6-2.8-47.3-4.2-70.9-4.2h-86.2v291.9h79.2 c26.4,0,52.8-1.4,77.8-4.2c16.7-2.8,33.4-6.9,48.6-13.9c23.6-12.5,44.5-30.6,59.8-52.8c27.8-45.9,27.8-104.2,0-150.1 C821.1,255.4,800.2,237.3,775.2,224.8z M765.5,387.4c-5.6,9.7-13.9,19.5-25,25c-5.6,2.8-12.5,5.6-19.5,6.9 c-11.1,1.4-20.8,2.8-32,1.4h-32V283.2h36.1c9.7,0,19.5,0,29.2,1.4c6.9,1.4,13.9,2.8,19.5,6.9c9.7,5.6,18.1,13.9,25,25 c5.6,11.1,8.3,23.6,8.3,34.7C773.8,363.8,771,376.3,765.5,387.4z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                x: 1502.1,
                y: 287.4,
                width: 77.8,
                height: 209.9
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M2140,245.7c2.8-12.5,2.8-26.4-2.8-37.5c-6.9-15.3-22.2-25-38.9-25c-19.5-1.4-37.5,12.5-41.7,30.6 c-5.6,22.2,6.9,44.5,29.2,51.4c5.6,1.4,11.1,0,6.9,6.9c-4.2,5.6-9.7,11.1-15.3,15.3l8.3,12.5 C2119.2,281.8,2135.9,263.7,2140,245.7z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M1964.9,276.2c-61.2,0-111.2,50-111.2,111.2s50,111.2,111.2,111.2s111.2-50,111.2-111.2 S2026.1,276.2,1964.9,276.2z M1964.9,426.3c-22.2,0-38.9-18.1-38.9-38.9c0-20.8,18.1-38.9,38.9-38.9s38.9,18.1,38.9,38.9 C2003.8,408.3,1987.1,426.3,1964.9,426.3z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M2227.6,358.2c-38.9,0-36.1-26.4-12.5-27.8c25-1.4,50,5.6,69.5,20.8l25-48.6 c-68.1-40.3-183.5-34.7-186.2,38.9l0,0c-1.4,41.7,30.6,62.5,95.9,69.5c47.3,5.6,33.4,26.4,6.9,29.2c-26.4,2.8-51.4-9.7-77.8-25 l-33.4,50c91.7,58.4,198.7,32,202.9-36.1C2322.1,388.8,2290.1,356.8,2227.6,358.2z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M1691.1,320.7v-29.2h-75.1v207.1h75.1V394.4c0-34.7,15.3-41.7,32-43.1c20.8-2.8,36.1,1.4,36.1,43.1l1.4,104.2 h75.1V347.1C1834.3,272.1,1720.3,272.1,1691.1,320.7z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M1541,183.1c-23.6,0-43.1,19.5-43.1,43.1c0,23.6,19.5,43.1,43.1,43.1s43.1-19.5,43.1-43.1 C1584.1,202.6,1564.6,183.1,1541,183.1z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M494.4,151.1L348.5,5.2l0,0c-6.9-6.9-16.7-6.9-23.6,0L170.6,158.1l169.6,169.6l154.3-152.9l0,0 C501.4,167.8,501.4,158.1,494.4,151.1z M368,190.1c-16.7,16.7-43.1,16.7-58.4,0c-16.7-16.7-16.7-43.1,0-58.4l0,0 c16.7-16.7,43.1-16.7,58.4,0C383.3,147,383.3,173.4,368,190.1z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M160.9,169.2L5.2,323.5l0,0l0,0c-6.9,6.9-6.9,16.7,0,23.6l145.9,145.9l0,0c6.9,6.9,16.7,6.9,23.6,0L329,340.2 L160.9,169.2z M130.3,366.6c-16.7,15.3-43.1,15.3-58.4,0c-16.7-16.7-16.7-43.1,0-58.4s43.1-15.3,58.4,0 C145.6,323.5,145.6,349.9,130.3,366.6z M192.8,366.6c-16.7-15.3-16.7-43.1,0-58.4l0,0c16.7-16.7,43.1-16.7,58.4,0 c16.7,16.7,16.7,43.1,0,58.4C234.5,383.3,209.5,383.3,192.8,366.6z"
            })
        ]
    });

});

parcelRegister("gFJSc", function(module, exports) {

$parcel$export(module.exports, "EbayLogo", function () { return $f3e6ba164304e8ca$export$6e7d7fb1946ca256; });

var $loA2J = parcelRequire("loA2J");
const $f3e6ba164304e8ca$export$6e7d7fb1946ca256 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "0 0 100 44",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M13.039,8.84c-12.47,0-13,9.69-12.9,12.23,0,0-.62,11.35,12.58,11.35,11.35,0,11.89-7.12,11.89-7.12h-5.22s-1,3.94-6.67,3.83C5.469,29,5.2,21.95,5.2,21.95h20.11S26.829,8.84,13.039,8.84ZM5.389,18.5s.34-6.34,7.52-6.34,7.15,6.34,7.15,6.34Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M39.249,8.84c-6.26,0-9,3.72-9,3.72V0h-5l.08,26.51s0,3.08-.22,5.14h4.88l.21-3s2.28,3.75,8.94,3.75,11.92-4.09,12.05-11.7S45.549,8.86,39.249,8.84ZM38.1,29c-7.92.11-7.79-8.4-7.79-8.4s-.29-8.2,7.77-8.38,7.79,8.56,7.79,8.56S46.029,28.92,38.1,29Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M74.429,26.4c0-3.43.11-6.48,0-8.65-.13-2.52.11-8.54-10.7-9,0,0-10.39-.94-11.46,6.77h5.3s.4-3.54,5.81-3.43c5.08.11,6,2.6,6,5.68h-5.83c-2.63,0-11.84.3-12.69,5.92-1,6.67,4.92,8.73,9.58,8.7s7.31-1.42,9.27-3.91l.21,3.11h4.63S74.429,29.83,74.429,26.4Zm-13.14,2.81s-5,0-5.33-4c-.32-4.28,7.77-4,7.77-4h5.7S70.339,29.32,61.289,29.21Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("polygon", {
                points: "71.679 9.67 77.509 9.67 86.049 26.69 94.599 9.67 99.869 9.67 84.449 40 78.799 40 83.269 31.57 71.679 9.67"
            })
        ]
    });

});

parcelRegister("b32Sf", function(module, exports) {

$parcel$export(module.exports, "FordLogo", function () { return $8ecf4c15685a11f0$export$22ac95c9dec2accf; });

var $loA2J = parcelRequire("loA2J");
const $8ecf4c15685a11f0$export$22ac95c9dec2accf = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "0 0 500 175",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M250,1C112.68,1,1.37,39.72,1.37,87.51S112.68,174,250,174,498.63,135.3,498.63,87.51,387.31,1,250,1Zm0,165.58c-132.49,0-239.89-35.38-239.89-79S117.51,8.46,250,8.46,489.88,43.85,489.88,87.51,382.49,166.55,250,166.55Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M195.67,76.48c6.47-.82,16-1.73,22.16-2.08,1.36-.08,1.64-.06,2.19.61a20.27,20.27,0,0,0,5.91,4.77,4.58,4.58,0,0,0,2.12.78,2.7,2.7,0,0,0,2.07-1,2,2,0,0,0,.47-2.24c-.37-.64-4.63-3-4.77-3.95-.09-.61.58-.74.58-.74a13.9,13.9,0,0,0,8.37-6.81c1.95-3.74,2.27-8.72-1.29-11.48-3.13-2.45-7.85-2.05-11.61,1.32a14.05,14.05,0,0,0-4.4,12.24c.09.72,0,1-.94,1-5.66.45-11.12.61-17.18.93-.41,0-.54-.24-.3-.53,7-12.12,17.41-20.76,29-29.28.76-.57.52-1.67.49-2.58,20.84,4.52,41,12.95,62.58,12.78,8.94-.08,17.49-1.44,25.67-5.93,7.19-3.91,10.11-7.55,10.33-11.31.17-2.62-1.64-4.26-4.22-3.7-21.85,5-42.67,5-64.4,2.33-24.66-3-48.32-9.14-72.85-9.14-3.69,0-7.39.14-11.13.45-23.71,2-46.27,15.35-46.32,35.62,0,10.27,7.28,18.61,18.61,18.24,13.29-.46,24.22-11.11,29.95-24.54,2.17-5.11-1.85-7.22-3.77-4.29a33.85,33.85,0,0,1-13.42,12c-6.27,3.06-12.95,2.23-15-2.85-2.85-7.18,3.08-17.9,16.61-23,19.55-7.24,40-2.45,59.67,1.25.27,0,1.32.58.4,1.05a57,57,0,0,0-12.39,8.14A101.62,101.62,0,0,0,196,57.14c-3.9,4.74-6.67,9-10.32,13.67a1.44,1.44,0,0,1-1.11.64C175.61,73,166.9,74,158.92,79.51c-1.64,1.14-2.35,3.15-1.36,4.71a3.09,3.09,0,0,0,4.38.46,26.85,26.85,0,0,1,15.92-5.61c.25,0,.37.07.45.22a.48.48,0,0,1-.09.41c-8.77,12.17-11,14.92-17.56,22.46a128,128,0,0,1-10.4,10.55c-15,13.91-31.08,13.67-36.87,5a14.83,14.83,0,0,1-.73-15.29c2.79-5.59,8.41-9.67,13.1-12.06,1.74-.89,2.24-3.12.5-5.15-1.1-1.31-3.79-1.55-5.79-1.18-6.13,1.13-13.39,5.77-17.66,11.35a31,31,0,0,0-6.43,22.39c1.46,15.41,14.12,24.29,28.51,24.18,11.46-.09,22.24-3.55,35.22-16.73,12.09-12.29,23.12-30.63,33.45-47.66C193.88,77,194.12,76.67,195.67,76.48Zm30.49-17.79a3,3,0,0,1,3.94-.46c1.15,1,.61,3.43-.56,5.14a9.46,9.46,0,0,1-5.39,3.88H224c-.33,0-.6-.23-.75-1A8.77,8.77,0,0,1,226.16,58.69Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M404,58.15H390.71c-1,0-1.49.13-1.95,1-1.54,2.93-20.15,30.82-23.61,36.23-.57.82-1.29.7-1.38-.23-.34-3.22-3.12-6.91-7.5-8.68a18.91,18.91,0,0,0-10-1.15c-6.12.82-11.57,4-16.37,7.69-7.21,5.5-13.45,12.62-21.49,17.88C304,113.8,298,116.28,294,112.56c-3.64-3.38-3.23-10.88,2.33-16.69.6-.6,1.3-.09,1.19.45a7.36,7.36,0,0,0,2.12,7.07,7.9,7.9,0,0,0,8.88,1,11.59,11.59,0,0,0,6.18-8.91,10.16,10.16,0,0,0-9.32-11.57c-4.64-.32-9.08,1.29-13.4,4.87a25.5,25.5,0,0,0-5.28,5.8c-.47.65-1.17.72-1.14-.26.21-7.57-2.93-11.84-9.19-12-4.87-.11-10.06,2.52-14.12,5.76-4.43,3.56-8.32,8.28-12.48,12.73-.52.55-1,.52-1.11-.54-.13-5-1.4-9.89-3.72-13.34a3.08,3.08,0,0,0-4-1,29.48,29.48,0,0,0-4.72,2.82,2.67,2.67,0,0,0-.8,3A35.14,35.14,0,0,1,234.11,115c-2.79,6.61-8.23,12.55-14.61,14.58-4.2,1.32-8.58.67-11.29-3.06-3.71-5.14-2.21-14.1,3.32-21.52,4.9-6.55,12-10.7,19-13.39a1.1,1.1,0,0,0,.77-1.55c-.39-1.17-1-2.74-1.24-3.46-.66-1.72-2.46-2-4.68-1.76a39.6,39.6,0,0,0-14.31,4.8c-12,6.4-18,18.79-20.58,25.43a25.72,25.72,0,0,1-3.76,6.93c-1.88,2.36-4.25,4.52-8.58,8.32a1.55,1.55,0,0,0-.34,1.76c.44.9,2.7,4.08,3.32,4.38A2,2,0,0,0,183,136a44.67,44.67,0,0,0,8.42-7.52c.63-.74,1.26-.42,1.59.72A18.59,18.59,0,0,0,205,142c11,3.71,22.33-1.64,30.92-11,5.45-5.92,7.43-9.73,9.52-12.32C249,114.29,256,104.47,264.3,98.17c3.05-2.34,6.67-4.12,8.48-2.94,1.46,1,1.93,3.15-.41,7.4-8.49,15.5-21,33.72-23.27,38.13-.43.78,0,1.37.75,1.37,4.45,0,8.85,0,12.88,0a1.51,1.51,0,0,0,1.3-.81c6.52-10.2,12.65-19.9,19.22-29.94.37-.59.71-.13.72.13.15,2.32.71,5.51,2.1,7.6a11.38,11.38,0,0,0,9.9,5.56c3.11,0,4.69-.44,8-1.7a27.46,27.46,0,0,0,6.59-3.53c1-.69,1.16.46,1.13.64-1.51,8.09.36,17.68,8.41,21.66,9.62,4.74,20.2-1.92,26.3-7.95.58-.58,1.22-.52,1.29.73a11.07,11.07,0,0,0,3.07,7c5.1,5.11,15.39,3.08,25.72-4.92,6.63-5.11,13.58-12.35,19.84-20a.89.89,0,0,0,0-1.26c-1-1-2.33-2.13-3.28-3a1.18,1.18,0,0,0-1.43,0c-6.42,6.12-12.21,13.09-20.56,18.85-2.83,2-7.32,3.57-9.34.83-.79-1.06-.7-2.53.08-4.45,2.43-6.08,41-64.82,43-68.3C405.15,58.59,404.79,58.15,404,58.15ZM353.8,108.46c.08.46.66.89,1.23,1.09.21.07.32.23.1.69a59.09,59.09,0,0,1-5.2,8.61,32.38,32.38,0,0,1-6.62,7.14c-3,2.48-6.9,5.13-10.58,5.13a6.64,6.64,0,0,1-3.17-.76c-2-1-2.85-3.81-2.82-6.06.11-6.32,2.92-12.81,8.11-19.19,6.33-7.8,13.33-11.84,17.92-9.63,4.76,2.27,3.25,7.76,1.12,12.09A1.18,1.18,0,0,0,353.8,108.46Z"
            })
        ]
    });

});

parcelRegister("81noK", function(module, exports) {

$parcel$export(module.exports, "NasaLogo", function () { return $71e12af7c89771a6$export$e44efe2f415651b3; });

var $loA2J = parcelRequire("loA2J");
const $71e12af7c89771a6$export$e44efe2f415651b3 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "2.834 70.312 187.088 52.134",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M102.379 121.166h25.672c3.836 0 6.984-1.574 9.541-4.723 2.459-3.049 3.738-6.688 3.738-10.818 0-8.361-10.721-14.263-14.854-14.263h-14.065c-1.082 0-1.969-.492-2.656-1.278-.689-.886-1.082-1.869-1.082-3.05 0-1.377.393-2.557 1.082-3.541.787-.983 1.77-1.573 2.951-1.573h26.361V71.394h-26.854c-4.82 0-8.559 1.476-11.215 4.328-2.359 2.656-3.541 6.197-3.541 10.427 0 4.131 1.182 7.771 3.541 10.72 2.656 3.246 5.805 4.92 9.641 4.92h16.231c.982 0 1.77.295 2.359 1.08.689.787.984 1.771.984 2.854 0 1.279-.492 2.459-1.279 3.443-.885.885-1.869 1.377-3.146 1.377H99.82l-.393-.689-9.738-31.279-.492-.984c-2.361-4.82-6.295-7.18-11.705-7.18-2.951 0-5.607.688-7.968 2.164-2.459 1.475-4.033 3.639-4.918 6.394l-13.083 42.098 11.902.1 12-37.476c.295-1.181.984-1.771 1.869-1.771.492 0 .885.196 1.18.492.295.393.492.787.59 1.279l12.098 37.476h11.217v-.001zM13.851 86.739v34.328H2.834V83.001c0-4.918 1.181-8.361 3.738-10.426 1.967-1.476 4.918-2.263 9.049-2.263 3.344 0 6.197.984 8.754 2.853 2.557 1.869 4.229 4.426 5.115 7.574l7.18 25.279 1.181 3.443c.098.688.492 1.18.885 1.572.492.395.983.592 1.574.395.984-.098 1.476-.689 1.476-1.574V71.493h11.312v37.869c0 4.23-.983 7.379-3.049 9.641-1.967 2.262-4.918 3.443-8.853 3.443-3.443 0-6.296-.689-8.558-1.869-2.754-1.377-4.525-3.541-5.312-6.395l-8.262-28.82-.59-1.869c-.197-.688-.59-1.18-1.082-1.672-.492-.394-1.082-.492-1.672-.394-.59.099-.983.394-1.377.984a3.398 3.398 0 0 0-.492 1.77v2.558zm176.071 34.427-12.787-42.591-.492-.984c-2.361-4.82-6.295-7.18-11.705-7.18-2.951 0-5.607.688-7.967 2.164-2.461 1.475-4.033 3.639-4.92 6.394l-13.082 42.098 11.902.1 12-37.476c.295-1.181.984-1.771 1.869-1.771.492 0 .885.196 1.18.492.297.393.492.787.592 1.279l12.098 37.476h11.312v-.001z"
        })
    });

});

parcelRegister("kKkgA", function(module, exports) {

$parcel$export(module.exports, "PaypalLogo", function () { return $3ea8a3dfeffca036$export$de02d99730715183; });

var $loA2J = parcelRequire("loA2J");
const $3ea8a3dfeffca036$export$de02d99730715183 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "0 0 500 121",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M44,28.51h34.1c18.31,0,25.2,9.26,24.14,22.9C100.52,73.89,86.93,86.33,68.9,86.33H59.8c-2.47,0-4.14,1.63-4.81,6.07l-3.9,25.77c-.26,1.68-1.14,2.66-2.46,2.78H27.25c-2,0-2.73-1.54-2.21-4.88L38.1,33.4C38.63,30.08,40.44,28.51,44,28.51Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M192.08,27c11.5,0,22.12,6.24,20.67,21.79-1.73,18.45-11.67,28.72-27.3,28.76H171.81c-2,0-2.91,1.6-3.43,4.89L165.75,99.2c-.39,2.54-1.69,3.79-3.62,3.79h-12.7c-2,0-2.73-1.29-2.28-4.19l10.5-67.28c.52-3.31,1.78-4.54,4-4.54ZM171.39,63h10.34c6.47-.25,10.77-4.73,11.2-12.81.27-5-3.1-8.56-8.47-8.54l-9.73.05L171.39,63Zm75.88,34.84c1.16-1,2.34-1.6,2.17-.3l-.41,3.12c-.22,1.62.43,2.49,1.95,2.49h11.28c1.9,0,2.83-.77,3.29-3.7l7-43.65c.35-2.19-.18-3.26-1.85-3.26h-12.4c-1.12,0-1.67.62-2,2.33l-.46,2.69c-.24,1.4-.88,1.64-1.48.23-2.1-5-7.47-7.22-15-7.06-17.4.36-29.14,13.57-30.39,30.5-1,13.1,8.42,23.39,20.79,23.39,9,0,13-2.68,17.51-6.78Zm-9.44-6.7c-7.49,0-12.72-6-11.63-13.3a16.2,16.2,0,0,1,15.58-13.3c7.5,0,12.72,6,11.63,13.3a16.21,16.21,0,0,1-15.58,13.3ZM294.6,52.39H283.2c-2.36,0-3.32,1.72-2.57,3.92l14.21,41.6-14,19.79c-1.17,1.65-.27,3.16,1.38,3.16h12.86a4,4,0,0,0,3.83-1.87l43.68-62.68c1.35-1.93.72-4-1.49-4H328.94c-2.09,0-2.93.82-4.12,2.56L306.59,81.35l-8.1-26.49C298,53.23,296.79,52.39,294.6,52.39Z",
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M388.06,27c11.51,0,22.13,6.24,20.67,21.79C407,67.22,397.07,77.49,381.44,77.53H367.8c-2,0-2.91,1.6-3.43,4.89L361.74,99.2c-.4,2.54-1.7,3.79-3.62,3.79h-12.7c-2,0-2.73-1.29-2.28-4.19l10.5-67.28c.51-3.31,1.78-4.54,4-4.54ZM367.38,63h10.34c6.47-.25,10.77-4.73,11.2-12.81.27-5-3.1-8.56-8.47-8.54l-9.74.05L367.38,63Zm75.88,34.84c1.16-1,2.34-1.6,2.17-.3l-.41,3.12c-.22,1.62.43,2.49,2,2.49h11.28c1.9,0,2.82-.77,3.29-3.7l6.95-43.65c.35-2.19-.18-3.26-1.84-3.26H454.24c-1.12,0-1.66.62-1.95,2.33l-.46,2.69c-.24,1.4-.88,1.64-1.48.23-2.11-5-7.47-7.22-15-7.06-17.41.36-29.14,13.57-30.4,30.5-1,13.1,8.42,23.39,20.79,23.39,9,0,13-2.68,17.52-6.78Zm-9.44-6.7c-7.5,0-12.72-6-11.63-13.3a16.2,16.2,0,0,1,15.58-13.3c7.49,0,12.72,6,11.63,13.3a16.21,16.21,0,0,1-15.58,13.3Zm52,12.09h-13a1.53,1.53,0,0,1-1.6-1.8l11.45-72.49a2.25,2.25,0,0,1,2.17-1.8h13a1.53,1.53,0,0,1,1.6,1.8L488,101.42A2.26,2.26,0,0,1,485.86,103.22Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M22.72.05H56.86c9.61,0,21,.31,28.64,7,5.1,4.5,7.77,11.66,7.15,19.34C90.56,52.5,75,67.1,54.06,67.1H37.22c-2.86,0-4.76,1.9-5.57,7L27,104c-.3,1.93-1.14,3.08-2.68,3.21h-21c-2.34,0-3.17-1.78-2.56-5.65L15.84,5.72C16.44,1.88,18.54.05,22.72.05Z",
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M32.14,71.13l6-37.73c.53-3.32,2.34-4.89,5.94-4.89h34.1A33.35,33.35,0,0,1,91.92,31C88.5,54.21,73.49,67.1,53.84,67.1H37C34.79,67.1,33.14,68.23,32.14,71.13Z"
            })
        ]
    });

});

parcelRegister("gLfKe", function(module, exports) {

$parcel$export(module.exports, "SquareLogo", function () { return $120a07dc587b3849$export$dcc1072f6b07484d; });

var $loA2J = parcelRequire("loA2J");
const $120a07dc587b3849$export$dcc1072f6b07484d = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        opacity: 0.8,
        viewBox: "0 0 2048.9 500",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M318.2,303c0,8.4-6.8,15.2-15.1,15.2H197c-8.3,0-15.1-6.8-15.1-15.2V197c0-8.3,6.8-15.1,15.1-15.1h106.1 c8.3,0,15.1,6.8,15.1,15.1V303z M409.1,382.6c0,14.6-11.9,26.5-26.5,26.5H117.4c-14.6,0-26.5-11.9-26.5-26.5V117.4 c0-14.6,11.9-26.5,26.5-26.5h265.2c14.6,0,26.5,11.9,26.5,26.5V382.6z M416.7,0H83.3C37.5,0,0,37.5,0,83.3v333.3 C0,462.5,37.5,500,83.3,500h333.3c45.8,0,83.3-37.5,83.3-83.3V83.3C500,37.5,462.5,0,416.7,0"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M731.4,414.2c-29.6,0-58.1-11.4-78.2-31.5c-17.9-17.9-27.8-41.1-27.8-65.4h30c0,16.3,6.7,32,19,44.2 c14.5,14.4,35.3,22.7,57,22.7h0.3c41.9,0,75.9-29.3,75.9-65.3c0-27-15-48.5-87.7-65.3c-29.6-6.8-49.5-16-62.8-28.8 c-14.1-13.7-21-31.9-21-55.8c0-47,42.1-85.3,94-85.3c24.8,0,48.2,8.5,65.9,24.1c18.2,16,28.3,37.6,28.3,60.9h-30 c0-30.3-28.8-54.9-64.2-54.9c-34.7,0-64,25.3-64,55.3c0,27.4,9.4,43.5,60.7,55.3c54.7,12.6,110.8,33.8,110.9,94.5 c0,25.8-11.2,50-31.5,68c-19.9,17.6-46.4,27.3-74.4,27.3H731.4z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M995.8,201.4c-53.9,0-92.8,40.2-92.8,93.7c0,53.1,39.8,92.1,92.8,92.1c51.5,0,90.8-41.9,90.8-92.5 C1086.7,244.1,1047.3,201.4,995.8,201.4 M1085,499.6V368.1h-0.8c-19.5,29.8-53,45.2-88.3,45.2c-68,0-121.9-51-121.9-119.4 c0-68,55.2-118.6,121.9-118.6c35.3,0,68.8,15.3,88.3,45.6h0.8v-39.8h29v318.5H1085z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M1530.6,201.4c-53.9,0-92.8,40.2-92.8,93.7c0,53.1,39.8,92.1,92.8,92.1c51.4,0,90.8-41.9,90.8-92.5 C1621.3,244.1,1582,201.4,1530.6,201.4 M1619.7,407.9v-39.8h-0.8c-19.9,29.8-53.1,45.2-88.3,45.2c-68,0-121.9-51-121.9-119.4 c0-68,55.1-118.6,121.9-118.6c35.7,0,68.9,15,88.3,45.6h0.8v-39.8h29v226.8H1619.7z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M1735.7,275.2v132.7h-29.1V181.1h29.1v32.8h0.8c12.5-29,34.4-36.5,63.9-38.6V206 C1760.6,209.3,1735.7,234.6,1735.7,275.2"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M1930.3,201.4c-45.2,0-81.3,33.2-88.4,77.5H2019C2011.6,234.6,1975.9,201.4,1930.3,201.4 M2048.5,305.1H1842 c2.1,44.8,43.6,82.1,88,82.1c34.8,0,68.8-19.9,81.3-53.5h30.6c-16.5,47.3-61.3,79.6-111.5,79.6c-65.5,0-118.2-53.5-118.2-118.6 c0-64.7,52.7-119.4,117.8-119.4c66.4,0,119,56,119,121.5C2048.9,299.6,2048.5,302.1,2048.5,305.1"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M1339.3,408.2v-35.4h-0.8c-13.3,28-42.9,40.9-72.9,40.9c-29.6,0-59.6-10.4-78.3-34.1 c-16.2-20.4-20-47.9-20-73.3V180.3h29.2v125.4c0,47.1,17.1,81.7,69.2,81.7c19.1,0,34.2-5,48.3-18.4c20-19.1,23.7-41.7,23.7-68.3 V180.3h29.2v227.9H1339.3z"
            })
        ]
    });

});




parcelRegister("aYz6E", function(module, exports) {
$parcel$export(module.exports, "ButtonSubmit", function () { return (parcelRequire("6PtZq")).ButtonSubmit; });
parcelRequire("6PtZq");

});
parcelRegister("6PtZq", function(module, exports) {

$parcel$export(module.exports, "ButtonSubmit", function () { return $89a3ae4d6b6ede37$export$883ac606d954afa4; });
/* button-submit.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $3XfGP = parcelRequire("3XfGP");
parcelRequire("WKdxa");
var $cRAeL = parcelRequire("cRAeL");

var $jgJpJ = parcelRequire("jgJpJ");
const $89a3ae4d6b6ede37$export$883ac606d954afa4 = ({ submitting: submitting, hasSubmitted: hasSubmitted, formError: formError, hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const intl = (0, $f6qj2.default)();
    const { isSubmitting: formContextSubmitting } = (0, $cRAeL.useSignupFormContext)();
    const submitMessage = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.submit",
        defaultMessage: "Sign up"
    });
    const submitButtonStyle = hasRebrandedSignupFormStyles ? (0, $7Knp0._)({}, $89a3ae4d6b6ede37$var$baseSubmitButtonStyle, $89a3ae4d6b6ede37$var$roundedSubmitButtonStyle) : $89a3ae4d6b6ede37$var$baseSubmitButtonStyle;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3XfGP.default), {
        style: submitButtonStyle,
        className: (0, $esG4f.default)([
            "_k48p1nn1 _6kab1h6o",
            "SignupSubmitBtn"
        ]),
        shouldFitContainer: true,
        type: "submit",
        appearance: "primary",
        isDisabled: formContextSubmitting || submitting || hasSubmitted && !formError,
        isLoading: formContextSubmitting || submitting || hasSubmitted && !formError,
        onClick: ()=>(0, $jgJpJ.trackSignUpWithEmail)(createAnalyticsEvent),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            id: "SubmitMessage",
            children: submitMessage
        })
    });
};
const $89a3ae4d6b6ede37$var$submitButtonCss = null;
const $89a3ae4d6b6ede37$var$baseSubmitButtonStyle = {
    height: 40
};
const $89a3ae4d6b6ede37$var$roundedSubmitButtonStyle = {
    borderRadius: "40px"
};

});
parcelRegister("3XfGP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e130d715135cd6b$export$2e2bcd8739ae039; });

var $iB48s = parcelRequire("iB48s");

var $dQt1t = parcelRequire("dQt1t");

var $iSvIT = parcelRequire("iSvIT");

var $6IiXU = parcelRequire("6IiXU");

var $4WLmP = parcelRequire("4WLmP");
var $2e130d715135cd6b$var$_excluded = [
    "appearance",
    "isDisabled",
    "isSelected",
    "isLoading",
    "spacing"
];
/**
 * __Loading button__
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ var $2e130d715135cd6b$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function LoadingButton(_ref, ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, spacing = _ref.spacing, rest = (0, $dQt1t.default)(_ref, $2e130d715135cd6b$var$_excluded);
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $6IiXU.default), (0, $iB48s.default)({}, rest, {
        ref: ref,
        appearance: appearance,
        "aria-busy": isLoading,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $4WLmP.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    }));
});
// Tools including enzyme rely on components having a display name
$2e130d715135cd6b$var$LoadingButton.displayName = "LoadingButton";
var $2e130d715135cd6b$export$2e2bcd8739ae039 = $2e130d715135cd6b$var$LoadingButton;

});
parcelRegister("4WLmP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39a15251825d0efd$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $8HJYY = parcelRequire("8HJYY");
function $39a15251825d0efd$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return "inherit";
    if (isSelected) return "invert";
    if (appearance === "primary" || appearance === "danger") return "invert";
    return "inherit";
}
function $39a15251825d0efd$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing;
    var size = spacing === "default" ? "medium" : "small";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $8HJYY.default), {
        size: size,
        appearance: $39a15251825d0efd$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("8HJYY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65660203519f4bc0$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $jkaxq = parcelRequire("jkaxq");

var $lG0aY = parcelRequire("lG0aY");

var $9c5Gg = parcelRequire("9c5Gg");

var $3lt1l = parcelRequire("3lt1l");
/**
 * Returns the appropriate circle stroke color.
 */ function $65660203519f4bc0$var$getStrokeColor(_ref) {
    var mode = _ref.mode, appearance = _ref.appearance;
    if (mode === "light") return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $lG0aY.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $lG0aY.N0), ")");
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $lG0aY.DN900), ")") : "var(--ds-icon-inverse, ".concat((0, $lG0aY.DN500), ")");
}
var $65660203519f4bc0$var$rotate = (0, $2ZUkg.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $65660203519f4bc0$var$rotateStyles = (0, $2ZUkg.css)({
    animation: "".concat($65660203519f4bc0$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $65660203519f4bc0$var$loadIn = (0, $2ZUkg.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $65660203519f4bc0$var$loadInStyles = (0, $2ZUkg.css)({
    animation: "".concat($65660203519f4bc0$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $65660203519f4bc0$var$wrapperStyles = (0, $2ZUkg.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $65660203519f4bc0$var$circleStyles = (0, $2ZUkg.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $65660203519f4bc0$var$useLayoutEffect = typeof window === "undefined" ? (0, $iSvIT.useEffect) : (0, $iSvIT.useLayoutEffect);
var $65660203519f4bc0$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function Spinner(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "inherit" : _ref2$appearance, _ref2$delay = _ref2.delay, delay = _ref2$delay === void 0 ? 0 : _ref2$delay, interactionName = _ref2.interactionName, label = _ref2.label, _ref2$size = _ref2.size, providedSize = _ref2$size === void 0 ? "medium" : _ref2$size, testId = _ref2.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $3lt1l.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var _useGlobalTheme = (0, $9c5Gg.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var stroke = $65660203519f4bc0$var$getStrokeColor({
        mode: mode,
        appearance: appearance
    });
    var context = (0, $iSvIT.useContext)((0, $jkaxq.default));
    $65660203519f4bc0$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $2ZUkg.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $65660203519f4bc0$var$wrapperStyles,
            $65660203519f4bc0$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $2ZUkg.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label,
        css: $65660203519f4bc0$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        }
    }, (0, $2ZUkg.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $65660203519f4bc0$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));

});
parcelRegister("3lt1l", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $26f9d8295bdc29c4$export$4e9f1640bbe7a1a8; });
var $26f9d8295bdc29c4$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});






parcelRegister("swQEv", function(module, exports) {
$parcel$export(module.exports, "EmailForm", function () { return (parcelRequire("aGugh")).EmailForm; });
parcelRequire("aGugh");

});
parcelRegister("aGugh", function(module, exports) {

$parcel$export(module.exports, "EmailForm", function () { return $8b17fed474f10f6b$export$89af2fd9aa25b6d8; });
/* email-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $6oKbD = parcelRequire("6oKbD");

var $jgJpJ = parcelRequire("jgJpJ");

var $1UUq1 = parcelRequire("1UUq1");

var $dWbel = parcelRequire("dWbel");
parcelRequire("WKdxa");
var $cRAeL = parcelRequire("cRAeL");
parcelRequire("aYz6E");
var $6PtZq = parcelRequire("6PtZq");
parcelRequire("4XUO1");
var $bcjjH = parcelRequire("bcjjH");
parcelRequire("c5qwq");
var $5jy1A = parcelRequire("5jy1A");
parcelRequire("7ubNM");
var $jMrU6 = parcelRequire("jMrU6");
const $8b17fed474f10f6b$export$89af2fd9aa25b6d8 = ()=>{
    const { isEmbedded: isEmbedded, productKey: productKey, edition: edition, formError: formError, hasSubmitted: hasSubmitted, isEmailValid: isEmailValid, onSubmitWithReCAPTCHA: onSubmitWithReCAPTCHA, setIsEmailValid: setIsEmailValid, setTypeAheadEmail: setTypeAheadEmail } = (0, $cRAeL.useSignupFormContext)();
    const intl = (0, $f6qj2.default)();
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const separatorText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.or",
        defaultMessage: "Or continue with"
    });
    (0, $iSvIT.useEffect)(()=>{
        const dataFoundationsActionSubjectId = !!isEmbedded ? "embedded" : "standalone";
        if (analyticsClient) (0, $jgJpJ.trackDataFoundationsAccountCreationComponent)(createAnalyticsEvent, {
            actionSubjectId: dataFoundationsActionSubjectId,
            productKey: productKey,
            edition: edition
        });
    }, [
        createAnalyticsEvent,
        productKey,
        edition,
        isEmbedded,
        analyticsClient
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6oKbD.default), {
        onSubmit: onSubmitWithReCAPTCHA,
        isDisabled: false,
        children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $loA2J.jsxs)("form", (0, $6iHNw._)((0, $7Knp0._)({}, formProps), {
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5jy1A.InputEmail), {
                        setIsEmailValid: setIsEmailValid,
                        submitting: submitting,
                        setTypeAheadEmail: setTypeAheadEmail,
                        workCallout: true
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_1wybepq8 _vwz4bs82"
                        ]),
                        style: {
                            "--_1h1y5xv": (0, $43MIc.default)((0, $jgJpJ.fontSize).xs)
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bcjjH.EulaText), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $6PtZq.ButtonSubmit), {
                        "data-testid": "signup-form-submit",
                        submitting: submitting,
                        hasSubmitted: hasSubmitted,
                        isEmailValid: isEmailValid,
                        formError: false
                    }),
                    formError && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_syazgryn _19pki2wt _2hwxidpf _otyr1tcg _18u0idpf"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "BxpUiSignup.SignupForm.formError",
                            defaultMessage: "It's taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <contactUsLink>contact us</contactUsLink>.",
                            values: {
                                contactUsLink: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                        text: text,
                                        "aria-label": text,
                                        type: "inline",
                                        href: "/company/contact"
                                    })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_179r11xk _vwz4400g _19pkviql _2hwx1j6v _otyrviql _18u01j6v _y3gn1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_bfhku67f _ca0qidpf _u5f31j6v _n3tdidpf _19bv1j6v"
                            ]),
                            children: separatorText
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $jMrU6.SignInButtons), {})
                ]
            }))
    });
};
const $8b17fed474f10f6b$var$formErrorStyle = null;
const $8b17fed474f10f6b$var$legalTextCss = null;
const $8b17fed474f10f6b$var$orSeparatorStyle = null;
const $8b17fed474f10f6b$var$orSeparatorSpanStyle = null;

});
parcelRegister("4XUO1", function(module, exports) {
$parcel$export(module.exports, "EulaText", function () { return (parcelRequire("bcjjH")).EulaText; });
parcelRequire("bcjjH");

});
parcelRegister("bcjjH", function(module, exports) {

$parcel$export(module.exports, "EulaText", function () { return $9d116397159ef9f3$export$76bbdd07dd3614a3; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");
const $9d116397159ef9f3$export$76bbdd07dd3614a3 = ()=>{
    const signupBundle = new URLSearchParams(window.location.search).get("bundle");
    const isCompass = signupBundle === "compass";
    const termsOfServiceLinkHref = (0, $3FBn4.useLocalizedHref)("/legal/cloud-terms-of-service");
    const aiTermsLinkHref = (0, $3FBn4.useLocalizedHref)("/legal/product-specific-terms#atlassian-intelligence-specific-terms");
    const privacyPolicyLinkHref = (0, $3FBn4.useLocalizedHref)("/legal/privacy-policy#what-this-policy-covers");
    const messageId = isCompass ? "BxpUiSignup.SignupForm.compass.termsAndConditions" : "BxpUiSignup.SignupForm.termsAndConditions";
    const defaultMessage = isCompass ? "I agree to the <termsOfServiceLink> Atlassian Customer Agreement</termsOfServiceLink>, and <privacyPolicyLink>Privacy Policy</privacyPolicyLink>. Atlassian will collect, use, and process data from across your Atlassian products, which may include data originating from connected third party apps, in accordance with the <termsOfServiceLink> Atlassian Customer Agreement</termsOfServiceLink> and <privacyPolicyLink>Privacy Policy</privacyPolicyLink>." : "I agree to the <termsOfServiceLink>Atlassian Customer Agreement</termsOfServiceLink>, which incorporates by reference the <aiTermsLink>AI Product-Specific Terms</aiTermsLink>, and acknowledge the <privacyPolicyLink>Privacy Policy</privacyPolicyLink>.";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: messageId,
        defaultMessage: defaultMessage,
        values: {
            termsOfServiceLink: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                    text: text,
                    "aria-label": text,
                    type: "inline",
                    href: termsOfServiceLinkHref,
                    className: "linkText"
                }),
            aiTermsLink: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                    text: text,
                    "aria-label": text,
                    type: "inline",
                    href: aiTermsLinkHref,
                    className: "linkText"
                }),
            privacyPolicyLink: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                    text: text,
                    "aria-label": text,
                    type: "inline",
                    href: privacyPolicyLinkHref,
                    className: "linkText"
                })
        }
    });
};

});


parcelRegister("c5qwq", function(module, exports) {
$parcel$export(module.exports, "InputEmail", function () { return (parcelRequire("5jy1A")).InputEmail; });
parcelRequire("5jy1A");

});
parcelRegister("5jy1A", function(module, exports) {

$parcel$export(module.exports, "InputEmail", function () { return $e6d4a1470f96a3f4$export$497a6aaf7dad75ee; });
/* input-email.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $26kkA = parcelRequire("26kkA");

var $bDTBs = parcelRequire("bDTBs");

var $1EpFI = parcelRequire("1EpFI");

var $7OGW4 = parcelRequire("7OGW4");

var $48zDN = parcelRequire("48zDN");

var $jgJpJ = parcelRequire("jgJpJ");

var $6WBIS = parcelRequire("6WBIS");

var $cRAeL = parcelRequire("cRAeL");
const $e6d4a1470f96a3f4$export$497a6aaf7dad75ee = ({ hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles, setIsEmailValid: setIsEmailValid, setTypeAheadEmail: setTypeAheadEmail, submitting: submitting, workCallout: workCallout })=>{
    const { isAnimatedHero: isAnimatedHero } = (0, $6WBIS.usePaidJswProductTourContext)();
    const { typeAheadEmail: typeAheadEmail, isReadyForInvalid: isReadyForInvalid, setIsReadyForInvalid: setIsReadyForInvalid } = (0, $cRAeL.useSignupFormContext)();
    const [email, setEmail] = (0, $iSvIT.useState)(typeAheadEmail);
    const [isValid, setValid] = (0, $iSvIT.useState)();
    const intl = (0, $f6qj2.default)();
    const errorMessageText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.invalidEmail",
        defaultMessage: "Please enter a valid email address."
    });
    const workCalloutText = workCallout ? intl.formatMessage({
        id: "BxpUiSignup.SignupForm.workCallout",
        defaultMessage: "Find teammates, plus keep work and life separate by using your work email."
    }) : "";
    const labelText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.workEmail",
        defaultMessage: "Work email"
    });
    const placeholderText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.emailPlaceholder",
        defaultMessage: "you@company.com"
    });
    const paidPlaceholderText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.emailPlaceholderPaidExperiment",
        defaultMessage: "Enter work email"
    });
    (0, $iSvIT.useEffect)(()=>{
        if (submitting && !isReadyForInvalid) setIsReadyForInvalid(true);
    }, [
        submitting,
        isReadyForInvalid
    ]);
    (0, $iSvIT.useEffect)(()=>{
        const isValid = (0, $jgJpJ.emailIsValid)(email); // wait to show invalid state if the user is not finished typing
        if (!isValid && !isReadyForInvalid) {
            setValid(undefined);
            return;
        }
        setValid(isValid);
        setIsEmailValid(isValid);
    }, [
        email,
        setIsEmailValid,
        isReadyForInvalid
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_6rth7vkz _1rwq12cp _125x1syg _1d6jidpf _18fjglyw"
        ]),
        style: {
            "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $26kkA.default), {
            "aria-required": true,
            isRequired: true,
            label: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_k48pbfng",
                    isAnimatedHero && "_1q51idpf",
                    "workEmail"
                ]),
                children: labelText
            }),
            name: "email",
            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        isValid === true && "_1lo61rfg",
                        isValid === false && "_1lo6gryn"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OGW4.default), (0, $6iHNw._)((0, $7Knp0._)({}, fieldProps), {
                            autoComplete: "on",
                            elemAfterInput: /*#__PURE__*/ (0, $loA2J.jsx)($e6d4a1470f96a3f4$var$InputIcon, {
                                valid: isValid
                            }),
                            onBlur: ()=>setIsReadyForInvalid(true),
                            onChange: (e)=>{
                                setEmail(e.target.value);
                                setTypeAheadEmail(e.target.value);
                                fieldProps.onChange(e);
                            },
                            placeholder: isAnimatedHero ? paidPlaceholderText : placeholderText,
                            testId: "email_field",
                            type: "email",
                            value: email,
                            className: (0, $esG4f.default)([
                                hasRebrandedSignupFormStyles && "_2rko1fu0 _bozgftgi _y4tiftgi"
                            ])
                        })),
                        isValid === false ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_syaz1du8 _1wybepq8 _vwz4bs82 _1pfhi2wt",
                                "errorMessageText"
                            ]),
                            "aria-live": "assertive",
                            role: "alert",
                            style: {
                                "--_1h1y5xv": (0, $43MIc.default)((0, $jgJpJ.fontSize).xs)
                            },
                            children: errorMessageText
                        }) : workCallout ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1wybepq8 _vwz4bs82 _1pfhi2wt _syazvwuj"
                            ]),
                            style: {
                                "--_1h1y5xv": (0, $43MIc.default)((0, $jgJpJ.fontSize).xs)
                            },
                            children: workCalloutText
                        }) : null
                    ]
                })
        })
    });
};
const $e6d4a1470f96a3f4$var$InputIcon = ({ valid: valid })=>typeof valid === "undefined" ? null : valid ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _lswuu67f _1wyb1syg _y4tiftgi _syazuhq2"
        ]),
        style: {
            "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bDTBs))), {
            label: "",
            size: "medium"
        })
    }) : /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _lswuu67f _1wyb1syg _y4tiftgi _syaz1du8"
        ]),
        style: {
            "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1EpFI))), {
            label: "",
            size: "medium"
        })
    });
const $e6d4a1470f96a3f4$var$errorMessageCss = null;
const $e6d4a1470f96a3f4$var$helpTextCss = null;
const $e6d4a1470f96a3f4$var$textFieldStyles = null;
const $e6d4a1470f96a3f4$var$fieldCss = null;
const $e6d4a1470f96a3f4$var$iconWrapperStyle = {
    alignItems: "center",
    display: "flex",
    fill: (0, $48zDN.N0),
    fontSize: (0, $jgJpJ.fontSize).md,
    paddingInlineEnd: 8
};
const $e6d4a1470f96a3f4$var$iconValidCss = null;
const $e6d4a1470f96a3f4$var$iconInvalidCss = null;
const $e6d4a1470f96a3f4$var$inputInvalidCss = null;
const $e6d4a1470f96a3f4$var$inputValidCss = null;
const $e6d4a1470f96a3f4$var$labelCss = null;
const $e6d4a1470f96a3f4$var$noTopPadding = null;

});


parcelRegister("7ubNM", function(module, exports) {
$parcel$export(module.exports, "SignInButtons", function () { return (parcelRequire("jMrU6")).SignInButtons; });
parcelRequire("jMrU6");

});
parcelRegister("jMrU6", function(module, exports) {

$parcel$export(module.exports, "SignInButtons", function () { return $8455861e08387f3c$export$54801483963f513f; });
/* sign-in-buttons.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $g9kzu = parcelRequire("g9kzu");

var $i6iy0 = parcelRequire("i6iy0");

var $jgJpJ = parcelRequire("jgJpJ");
parcelRequire("WKdxa");
var $cRAeL = parcelRequire("cRAeL");
parcelRequire("9A79K");
var $a0vgS = parcelRequire("a0vgS");
const $8455861e08387f3c$export$54801483963f513f = ({ hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles, customSignInProviders: customSignInProviders })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { identityCobranding: identityCobranding, redirectTo: redirectTo, edition: edition, bundle: bundle } = (0, $cRAeL.useSignupFormContext)();
    function getLoginOrigin(provider) {
        const metadataId = `wac-signup-${provider}`;
        const originTracingOptions = {
            product: metadataId
        };
        if (!(0, $jgJpJ.isProduction)()) originTracingOptions.id = "static-uuid-for-testing";
        const loginOrigin = new (0, $i6iy0.default)((0, $7Knp0._)({}, originTracingOptions));
        return loginOrigin.encode();
    }
    const providerLabels = {
        google: "Google",
        microsoft: "Microsoft",
        apple: "Apple",
        slack: "Slack"
    };
    const providers = customSignInProviders || [
        "google",
        "microsoft",
        "apple",
        "slack"
    ];
    const buttons = providers.map((provider)=>{
        const continueUrl = new URL(redirectTo);
        continueUrl.searchParams.append("social-signup-login", "true");
        const params = new URLSearchParams({
            application: identityCobranding,
            continue: continueUrl.href,
            prompt: "select_account",
            atlOrigin: encodeURIComponent(getLoginOrigin(provider))
        });
        return {
            provider: provider,
            label: providerLabels[provider],
            href: `${(0, $jgJpJ.getIdentityBaseUrl)()}/login/initiate/${provider}?${params}`
        };
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            buttons.length > 1 && "_1e0c11p5 _zulp7vkz _yv0efsjm"
        ]),
        children: buttons.map(({ provider: provider, label: label, href: href })=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $a0vgS.LogoButton), {
                hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles,
                href: href,
                onClick: ()=>(0, $jgJpJ.trackContinueWithSocialSignups)(createAnalyticsEvent, provider, (0, $jgJpJ.getPrimaryProductKeyFromBundle)(bundle), edition),
                type: provider,
                label: label
            }, provider))
    });
};
const $8455861e08387f3c$var$buttonGridCss = null;

});
parcelRegister("9A79K", function(module, exports) {
$parcel$export(module.exports, "LogoButton", function () { return (parcelRequire("a0vgS")).LogoButton; });
parcelRequire("41onJ");

});
parcelRegister("41onJ", function(module, exports) {
$parcel$export(module.exports, "LogoButton", function () { return (parcelRequire("a0vgS")).LogoButton; });
parcelRequire("a0vgS");

});
parcelRegister("a0vgS", function(module, exports) {

$parcel$export(module.exports, "LogoButton", function () { return $1ad1d28ba144220d$export$ce671d21b66bb548; });
/* logo-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $el2uA = parcelRequire("el2uA");
const $1ad1d28ba144220d$var$ProviderLogo = ({ logo: logo })=>{
    switch(logo){
        case "google":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $el2uA.GoogleLogo), {});
        case "microsoft":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $el2uA.MicrosoftLogo), {});
        case "apple":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $el2uA.AppleLogo), {});
        case "slack":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $el2uA.SlackLogo), {});
    }
};
const $1ad1d28ba144220d$export$ce671d21b66bb548 = ({ hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles, href: href, onClick: onClick, type: type, label: label })=>/*#__PURE__*/ (0, $loA2J.jsxs)("a", {
        href: href,
        onClick: onClick,
        id: `${type}-social-button`,
        "aria-label": type,
        className: (0, $esG4f.default)([
            "_4cvr1h6o _bfhku67f _2rko1l7b _16qs1yxe _syaz1nct _1e0c1txw _zulp1kwk _4t3i1ylp _1bah1h6o _ca0q1kwk _u5f3oqnp _n3td1kwk _19bvoqnp _4bfu1snc _1hmsagmp _ajmmvv82 _jomr1hxd _irr31hxd _f8pj1nct _30l31nct _1ah3t94y",
            hasRebrandedSignupFormStyles && "_2rko1ylp"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)($1ad1d28ba144220d$var$ProviderLogo, {
                logo: type
            }),
            " ",
            label
        ]
    });
const $1ad1d28ba144220d$var$roundedLogoButtonCss = null;
const $1ad1d28ba144220d$var$logoButtonCss = null;

});
parcelRegister("el2uA", function(module, exports) {

$parcel$export(module.exports, "AppleLogo", function () { return $1f406bb1f2678d1f$export$570c8af14df4c066; });
$parcel$export(module.exports, "GoogleLogo", function () { return $1f406bb1f2678d1f$export$deb5eaa840e39fbf; });
$parcel$export(module.exports, "MicrosoftLogo", function () { return $1f406bb1f2678d1f$export$416f81fce45348; });
$parcel$export(module.exports, "SlackLogo", function () { return $1f406bb1f2678d1f$export$741d0a87d063b83b; });
/* logos.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $1f406bb1f2678d1f$export$570c8af14df4c066 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        "aria-hidden": "true",
        fill: "currentColor",
        viewBox: "0 0 170 170",
        className: (0, $esG4f.default)([
            "_1e0c1ule _1bsbf6fq _4t3if6fq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M150.37 130.25c-2.45 5.66-5.35 10.87-8.71 15.66-4.58 6.53-8.33 11.05-11.22 13.56-4.48 4.12-9.28 6.23-14.42 6.35-3.69 0-8.14-1.05-13.32-3.18-5.197-2.12-9.973-3.17-14.34-3.17-4.58 0-9.492 1.05-14.746 3.17-5.262 2.13-9.501 3.24-12.742 3.35-4.929.21-9.842-1.96-14.746-6.52-3.13-2.73-7.045-7.41-11.735-14.04-5.032-7.08-9.169-15.29-12.41-24.65-3.471-10.11-5.211-19.9-5.211-29.378 0-10.857 2.346-20.221 7.045-28.068 3.693-6.303 8.606-11.275 14.755-14.925s12.793-5.51 19.948-5.629c3.915 0 9.049 1.211 15.429 3.591 6.362 2.388 10.447 3.599 12.238 3.599 1.339 0 5.877-1.416 13.57-4.239 7.275-2.618 13.415-3.702 18.445-3.275 13.63 1.1 23.87 6.473 30.68 16.153-12.19 7.386-18.22 17.731-18.1 31.002.11 10.337 3.86 18.939 11.23 25.769 3.34 3.17 7.07 5.62 11.22 7.36-.9 2.61-1.85 5.11-2.86 7.51zM119.11 7.24c0 8.102-2.96 15.667-8.86 22.669-7.12 8.324-15.732 13.134-25.071 12.375a25.222 25.222 0 0 1-.188-3.07c0-7.778 3.386-16.102 9.399-22.908 3.002-3.446 6.82-6.311 11.45-8.597 4.62-2.252 8.99-3.497 13.1-3.71.12 1.083.17 2.166.17 3.24z"
        })
    });
const $1f406bb1f2678d1f$export$deb5eaa840e39fbf = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 18 18",
        className: (0, $esG4f.default)([
            "_1e0c1ule _1bsbf6fq _4t3if6fq"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M17.64 9.205c0-.639-.057-1.252-.164-1.841H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615Z",
                fill: "#4285F4"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18Z",
                fill: "#34A853"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332Z",
                fill: "#FBBC05"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58Z",
                fill: "#EA4335"
            })
        ]
    });
const $1f406bb1f2678d1f$export$416f81fce45348 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 21 21",
        className: (0, $esG4f.default)([
            "_1e0c1ule _1bsbf6fq _4t3if6fq"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#f25022",
                d: "M1 1h9v9H1z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#00a4ef",
                d: "M1 11h9v9H1z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#7fba00",
                d: "M11 1h9v9h-9z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#ffb900",
                d: "M11 11h9v9h-9z"
            })
        ]
    });
const $1f406bb1f2678d1f$export$741d0a87d063b83b = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 127 127",
        className: (0, $esG4f.default)([
            "_1e0c1ule _1bsbf6fq _4t3if6fq"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M27.2 80c0 7.3-5.9 13.2-13.2 13.2C6.7 93.2.8 87.3.8 80c0-7.3 5.9-13.2 13.2-13.2h13.2V80zm6.6 0c0-7.3 5.9-13.2 13.2-13.2 7.3 0 13.2 5.9 13.2 13.2v33c0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V80z",
                fill: "#E01E5A"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M47 27c-7.3 0-13.2-5.9-13.2-13.2C33.8 6.5 39.7.6 47 .6c7.3 0 13.2 5.9 13.2 13.2V27H47zm0 6.7c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H13.9C6.6 60.1.7 54.2.7 46.9c0-7.3 5.9-13.2 13.2-13.2H47z",
                fill: "#36C5F0"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M99.9 46.9c0-7.3 5.9-13.2 13.2-13.2 7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H99.9V46.9zm-6.6 0c0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V13.8C66.9 6.5 72.8.6 80.1.6c7.3 0 13.2 5.9 13.2 13.2v33.1z",
                fill: "#2EB67D"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M80.1 99.8c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V99.8h13.2zm0-6.6c-7.3 0-13.2-5.9-13.2-13.2 0-7.3 5.9-13.2 13.2-13.2h33.1c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H80.1z",
                fill: "#ECB22E"
            })
        ]
    });
const $1f406bb1f2678d1f$var$logoCss = null;

});








parcelRegister("5CXM7", function(module, exports) {
$parcel$export(module.exports, "ExistingProductText", function () { return (parcelRequire("9cpbu")).ExistingProductText; });
parcelRequire("9cpbu");

});
parcelRegister("9cpbu", function(module, exports) {

$parcel$export(module.exports, "ExistingProductText", function () { return $c2a715d391cd7e2d$export$2421ab9e56e71ee7; });
/* existing-product-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6x1qA = parcelRequire("6x1qA");
var $dFnC9 = parcelRequire("dFnC9");

var $jgJpJ = parcelRequire("jgJpJ");

var $1UUq1 = parcelRequire("1UUq1");

var $lrVTP = parcelRequire("lrVTP");
const $c2a715d391cd7e2d$var$existingText = (0, $6x1qA.defineMessage)({
    id: "BxpUiSignup.SignupForm.existingProduct",
    defaultMessage: "Already have {product}? <logInLink>Log in</logInLink>"
});
const $c2a715d391cd7e2d$export$2421ab9e56e71ee7 = ({ messageOverride: messageOverride, productName: productName, bgColor: bgColor = "bgWhite" })=>{
    const location = (0, $lrVTP.useLocation)();
    const loginUrl = new URL("/login", (0, $jgJpJ.getIdentityBaseUrl)());
    const continueParam = (0, $jgJpJ.getContinueParam)(location);
    if (continueParam) loginUrl.searchParams.append("continue", continueParam);
    else {
        const defaultContinueUrl = new URL("/gateway/api/start/authredirect", (0, $jgJpJ.getWacIntegrationUrl)()).toString();
        loginUrl.searchParams.append("continue", defaultContinueUrl);
    }
    return /*#__PURE__*/ (0, $loA2J.jsx)("p", {
        className: (0, $esG4f.default)([
            "_19pk14b4 _2hwxgrf3 _otyrgrf3 _18u0grf3 _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, messageOverride !== null && messageOverride !== void 0 ? messageOverride : $c2a715d391cd7e2d$var$existingText), {
            values: {
                product: productName,
                logInLink: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        text: text,
                        "aria-label": text,
                        type: "inline",
                        href: loginUrl.toString(),
                        bgColor: bgColor,
                        className: "linkText"
                    })
            }
        }))
    });
};
const $c2a715d391cd7e2d$var$existingProductCss = null;

});




parcelRegister("dxCBa", function(module, exports) {

$parcel$export(module.exports, "DefaultSignupForm", function () { return $3abd9b66f6cc1446$export$1ec51f8461f7bee0; });
/* default-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $jgJpJ = parcelRequire("jgJpJ");

var $akark = parcelRequire("akark");
parcelRequire("9DfPf");
var $aGugh = parcelRequire("aGugh");
var $9cpbu = parcelRequire("9cpbu");
parcelRequire("WKdxa");
var $cRAeL = parcelRequire("cRAeL");
const $3abd9b66f6cc1446$export$1ec51f8461f7bee0 = ()=>{
    const { bundle: bundle, edition: edition, showProductLogo: showProductLogo, products: products, productName: productName, isEmbedded: isEmbedded } = (0, $cRAeL.useSignupFormContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    (0, $iSvIT.useEffect)(()=>{
        const dataFoundationsActionSubjectId = !!isEmbedded ? "embedded" : "standalone";
        (0, $jgJpJ.trackDataFoundationsAccountCreationComponent)(createAnalyticsEvent, {
            actionSubjectId: dataFoundationsActionSubjectId,
            productKey: (0, $jgJpJ.getPrimaryProductKeyFromBundle)(bundle),
            edition: edition
        });
    }, [
        createAnalyticsEvent,
        bundle,
        edition,
        isEmbedded
    ]);
    (0, $iSvIT.useEffect)(()=>{
        const customData = {
            webPlatform: "bxp-ui",
            reactComponent: "DefaultSignupForm",
            isLoggedIn: false
        };
        (0, $jgJpJ.ufoEventTryCloudSignupPageLoad).success({
            customData: customData
        });
        if (isEmbedded) {
            (0, $jgJpJ.ufoEventPaidSignupJSWLandingPageLoad).success({
                customData: {
                    reactComponent: "DefaultSignupForm"
                }
            });
            (0, $jgJpJ.ufoEventPaidSignupConfluenceLandingPageLoad).success({
                customData: {
                    reactComponent: "DefaultSignupForm"
                }
            });
            (0, $jgJpJ.ufoEventPaidSignupJSMLandingPageLoad).success({
                customData: {
                    reactComponent: "DefaultSignupForm"
                }
            });
        } else (0, $jgJpJ.ufoEventTryCloudSignupPageLoad).success({
            customData: customData
        });
    }, []);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $akark.SignupModuleWrapper), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            "data-testid": "signup-form",
            className: (0, $esG4f.default)([
                "_4cvr1fhb _syaz1bqd _1e0c1txw _2lx21bp4 _1bah1h6o"
            ]),
            children: [
                showProductLogo && /*#__PURE__*/ (0, $loA2J.jsx)($3abd9b66f6cc1446$var$ProductLogos, {
                    products: products
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                    children: products.length > 1 ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "BxpUiSignup.SignupForm.headerBundle",
                        defaultMessage: "Get started"
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "BxpUiSignup.SignupForm.header",
                        defaultMessage: "Get started with {product}",
                        values: {
                            product: productName
                        }
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    children: bundle === "jira-service-management-jira-software" ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "BxpUiSignup.SignupForm.subheaderJSWJSM",
                        defaultMessage: "It's free for up to 3 agents and 10 users."
                    }) : bundle === "jira-service-management" ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "BxpUiSignup.SignupForm.subheaderJSM",
                        defaultMessage: "Free for up to 3 agents"
                    }) : bundle === "jira-software" && edition === "standard" ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "BxpUiSignup.SignupForm.subheader.jsw.standard",
                        defaultMessage: "14-day free trial for unlimited users on the Standard plan \u2014 no credit card needed"
                    }) : bundle === "jira-software" && edition === "premium" ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "BxpUiSignup.SignupForm.subheader.jsw.premium",
                        defaultMessage: "30-day free trial for unlimited users on the Premium plan \u2014 no credit card needed"
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "BxpUiSignup.SignupForm.subheader.1",
                        defaultMessage: "It's free for up to 10 users \u2014 no credit card needed."
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $aGugh.EmailForm), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $9cpbu.ExistingProductText), {
                    productName: productName
                })
            ]
        })
    });
};
const $3abd9b66f6cc1446$var$ProductLogos = ({ products: products })=>{
    const [baseProduct, ...bundledProducts] = products;
    if (!baseProduct) return null;
    const { productKey: baseProductKey, productLogo: BaseProductLogo } = baseProduct;
    const isBundle = bundledProducts.length > 0;
    const size = isBundle ? "medium" : "large";
    if (!isBundle) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _6rthgktf"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)(BaseProductLogo, {
            appearance: "brand",
            size: size
        }, baseProductKey)
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _6rthgktf _4cvr1h6o _gy1p1crf _1n261g80 _1p571y44"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)(BaseProductLogo, {
                appearance: "brand",
                size: size
            }, baseProductKey),
            bundledProducts.map(({ productKey: bundledProductKey, productLogo: BundledProductLogo })=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_1wyb1tcg _1pfhmyb0"
                            ]),
                            children: "+"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)(BundledProductLogo, {
                            appearance: "brand",
                            size: size
                        }, bundledProductKey)
                    ]
                }))
        ]
    });
};
const $3abd9b66f6cc1446$var$containerStyle = null;
const $3abd9b66f6cc1446$var$productLogoCss = null;
const $3abd9b66f6cc1446$var$multipleProductLogosCss = null;
const $3abd9b66f6cc1446$var$multipleProductLogosPlusCss = null;

});
parcelRegister("akark", function(module, exports) {

$parcel$export(module.exports, "SignupModuleWrapper", function () { return $a5cc370be4294f45$export$eecae687e7c61946; });
/* signup-module-wrapper.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $a6bec = parcelRequire("a6bec");

var $jgJpJ = parcelRequire("jgJpJ");
const $a5cc370be4294f45$var$signupModule = null;
const $a5cc370be4294f45$var$fullHeightSignupModule = null;
const $a5cc370be4294f45$var$fullPageSignupModule = null;
const $a5cc370be4294f45$var$container = null;
const $a5cc370be4294f45$var$fullPageContainer = null;
const $a5cc370be4294f45$var$footer = null;
const $a5cc370be4294f45$export$eecae687e7c61946 = ({ fullPage: fullPage, fullHeight: fullHeight = true, hideFooter: hideFooter, children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _vchhusvi _1e0c1txw _2lx21bp4 _ect41qje _1wyb8oy7 _1bah1yb4 _ca0q1k8s _u5f31j6v _n3td1k8s _19bv1j6v",
            fullPage && "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1mpv1wug _15y11wug",
            fullHeight && "_1tke1us8 _15y110j7"
        ]),
        style: {
            "--_djwknj": (0, $43MIc.default)((0, $jgJpJ.fontSize).sm)
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_16jlkb7n _1o9zkb7n _i0dlf1ug _p12f1f23 _1bsb1osq _cadt1qje _8v2f1qje _iowe1h6o _1afj1h6o _1vfhqwb1 _1twlni7l _1xd21btq _rzbyidpf _8k2zidpf _nd4uidpf _9u9nidpf _k4bkidpf _ihmi78gw _1riqidpf _15cu78gw _11eb1kw7 _l5k14jg8 _1n461kwk _if5yidpf _1gnp1kwk _7e5bidpf _1g0f1k8s _cg41alr3 _1t2qalr3 _125xalr3 _doqyalr3 _zcqxbs82 _clfd1j6v _11pqidpf _q0a51j6v _c3k8idpf _1sgrepq8 _kminepq8 _43dsoelr _9m7f1r31 _rfqo1r31 _w7sw8stv _1bgk8stv _15a9nqa1 _1t0pnqa1",
                    fullPage && "_p12f1osq _kiyaidpf _1mt1idpf"
                ]),
                style: {
                    "--_1n7yiy6": (0, $43MIc.default)((0, $jgJpJ.fontSize).xl),
                    "--_1h1y5xv": (0, $43MIc.default)((0, $jgJpJ.fontSize).xs)
                },
                children: children
            }),
            !hideFooter && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_19pk1k8s _2hwx1wug _otyr1k8s _18u01wug"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $a6bec.AtlassianLogo), {
                    appearance: "brand",
                    size: "small",
                    testId: "atlassian-logo",
                    label: "Atlassian logo"
                })
            })
        ]
    });
};

});




parcelRegister("9ax0J", function(module, exports) {

$parcel$export(module.exports, "SignupFormSuccessUFOEvent", function () { return $3f42f0750934027f$export$44219095b16ac4f0; });

var $iSvIT = parcelRequire("iSvIT");

var $jgJpJ = parcelRequire("jgJpJ");
const $3f42f0750934027f$export$44219095b16ac4f0 = ()=>{
    (0, $iSvIT.useLayoutEffect)(()=>{
        (0, $jgJpJ.ufoEventSignupFormLoad).success({
            customData: {
                webPlatform: "bxp-ui",
                reactComponent: "DefaultSignupForm",
                isLoggedIn: false
            }
        });
    });
    return null;
};

});

parcelRegister("6mUgP", function(module, exports) {

$parcel$export(module.exports, "EmbeddedSignupForm", function () { return $7580e073cd6b04a9$export$7572837522fb3c8b; });

var $loA2J = parcelRequire("loA2J");

var $6kzTi = parcelRequire("6kzTi");

var $jgJpJ = parcelRequire("jgJpJ");

var $4toHd = parcelRequire("4toHd");
parcelRequire("gHQuP");
var $a5anJ = parcelRequire("a5anJ");
var $i8Gkd = parcelRequire("i8Gkd");
var $53H84 = parcelRequire("53H84");
parcelRequire("WKdxa");
var $cRAeL = parcelRequire("cRAeL");
var $1qjOG = parcelRequire("1qjOG");
const $7580e073cd6b04a9$var$variants = {
    "paid-lp-conf-features": /*#__PURE__*/ (0, $loA2J.jsx)((0, $a5anJ.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "paid-lp-conf-features"
    }),
    "paid-lp-confl-projectmgmt": /*#__PURE__*/ (0, $loA2J.jsx)((0, $a5anJ.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "paid-lp-confl-projectmgmt"
    }),
    "paid-lp-confl-documentation": /*#__PURE__*/ (0, $loA2J.jsx)((0, $a5anJ.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "paid-lp-confl-documentation"
    }),
    "paid-lp-confl-template": /*#__PURE__*/ (0, $loA2J.jsx)((0, $a5anJ.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "paid-lp-confl-template"
    }),
    "anchor-lp-conf-automation": /*#__PURE__*/ (0, $loA2J.jsx)((0, $a5anJ.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "anchor-lp-conf-automation"
    }),
    "anchor-lp-conf-collaboration": /*#__PURE__*/ (0, $loA2J.jsx)((0, $a5anJ.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "anchor-lp-conf-collaboration"
    }),
    "anchor-lp-conf-teamwork": /*#__PURE__*/ (0, $loA2J.jsx)((0, $a5anJ.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "anchor-lp-conf-teamwork"
    }),
    "anchor-lp-conf-work-management": /*#__PURE__*/ (0, $loA2J.jsx)((0, $a5anJ.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "anchor-lp-conf-work-management"
    }),
    "anchor-lp-conf-competitors": /*#__PURE__*/ (0, $loA2J.jsx)((0, $a5anJ.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "anchor-lp-conf-competitors"
    }),
    "default": /*#__PURE__*/ (0, $loA2J.jsx)((0, $i8Gkd.DefaultEmbeddedSignupForm), {}),
    "confluence-default": /*#__PURE__*/ (0, $loA2J.jsx)((0, $6kzTi.CFindEmbeddedSignupForm), {})
};
const $7580e073cd6b04a9$export$7572837522fb3c8b = ({ bundle: bundle, isUserLoggedIn: isUserLoggedIn, variantOverride: variantOverride })=>{
    const { productKey: productKey, productName: productName } = (0, $cRAeL.useSignupFormContext)();
    if (isUserLoggedIn && bundle) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4toHd.SiteNameContextProvider), {
        productKey: productKey,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $53H84.LoggedInForm), {})
    });
    let variantName = "default";
    if (productKey === (0, $jgJpJ.ProductKey).CONFLUENCE) variantName = "confluence-default";
    if (variantOverride) variantName = variantOverride;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1qjOG.SignupAnalyticsContext), {
        productName: productName,
        children: $7580e073cd6b04a9$var$variants[variantName]
    });
};

});
parcelRegister("6kzTi", function(module, exports) {

$parcel$export(module.exports, "CFindEmbeddedSignupForm", function () { return $deef4e104104daf5$export$30d022a977c0a6db; });
/* cfind-embedded-signup.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6x1qA = parcelRequire("6x1qA");
var $dFnC9 = parcelRequire("dFnC9");

var $6JN6z = parcelRequire("6JN6z");

var $lp1yP = parcelRequire("lp1yP");
parcelRequire("9DfPf");
var $9cpbu = parcelRequire("9cpbu");
parcelRequire("WKdxa");
var $cRAeL = parcelRequire("cRAeL");

var $iWMXV = parcelRequire("iWMXV");

var $lN3YF = parcelRequire("lN3YF");
const $deef4e104104daf5$var$confluenceEmbeddedExistingText = (0, $6x1qA.defineMessage)({
    id: "BxpUiSignup.SignupForm.existingProduct.confluence.embedded",
    defaultMessage: "Trying to access {product}? <logInLink>Log in</logInLink>"
});
const $deef4e104104daf5$export$30d022a977c0a6db = ()=>{
    const { productName: productName, customHeader: customHeader } = (0, $cRAeL.useSignupFormContext)();
    const defaultHeader = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.features",
        defaultMessage: "Goodbye silos, hello teamwork with Confluence"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lp1yP.EmbeddedSignupModuleWrapper), {
        hideFooter: true,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            "data-testid": "signup-form",
            className: (0, $esG4f.default)([
                "_4cvr1fhb _bfhku67f _16qsoopq _2rkogktf _syaz1bqd _1e0c1txw _2lx21bp4 _1bah1h6o _ca0qzwfg _u5f312am _n3tdzwfg _19bv12am _1bsb1erl"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                    className: (0, $esG4f.default)([
                        "_y4tivbgk _y3gn1qpp"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6JN6z.BanditsHeaderWrapper), {
                        product: "confluence",
                        type: "header",
                        children: customHeader || defaultHeader
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    className: (0, $esG4f.default)([
                        "_1wyb1gpt _k48pocj5 _y3gn1qpp"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6JN6z.BanditsHeaderWrapper), {
                        product: "confluence",
                        type: "subheader",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "BxpUiSignup.SignupForm.subheader.1",
                            defaultMessage: "It's free for up to 10 users \u2014 no credit card needed."
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $iWMXV.EmailForm), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $lN3YF.SocialEndorsement), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $9cpbu.ExistingProductText), {
                    messageOverride: $deef4e104104daf5$var$confluenceEmbeddedExistingText,
                    productName: productName
                })
            ]
        })
    });
};
const $deef4e104104daf5$var$containerStyle = null;
const $deef4e104104daf5$var$headerStyle = null;
const $deef4e104104daf5$var$subheaderStyle = null;

});
parcelRegister("6JN6z", function(module, exports) {

$parcel$export(module.exports, "BanditsProvider", function () { return $54ee6c432cc378b8$export$ed6616ed0f76d929; });
$parcel$export(module.exports, "BanditsHeaderWrapper", function () { return $54ee6c432cc378b8$export$1cb749e21ac9e393; });
$parcel$export(module.exports, "BanditsAssetWrapper", function () { return $54ee6c432cc378b8$export$f9fbacfdb5ded657; });
/* bandits-components.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $hjMWG = parcelRequire("hjMWG");

var $bhreu = parcelRequire("bhreu");

var $jbZl4 = parcelRequire("jbZl4");

var $gFK1O = parcelRequire("gFK1O");
const $54ee6c432cc378b8$var$BanditsContext = /*#__PURE__*/ (0, $iSvIT.createContext)({
    banditsContent: null,
    loading: false,
    error: null
});
const $54ee6c432cc378b8$export$ed6616ed0f76d929 = ({ product: product, keyword: keyword, isExperimentEnabled: isExperimentEnabled = false, children: children })=>{
    const anonymousId = decodeURIComponent((0, $gFK1O.Cookie).readCookie("ajs_anonymous_id") || "").replace(/['"]+/g, "");
    const [banditsContent, setBanditsContent] = (0, $iSvIT.useState)(isExperimentEnabled ? null : (0, $jbZl4.nullBanditsContent));
    const [loading, setLoading] = (0, $iSvIT.useState)(isExperimentEnabled);
    const [error, setError] = (0, $iSvIT.useState)(null);
    (0, $iSvIT.useEffect)(()=>{
        if (!isExperimentEnabled) return;
        const getBanditsContent = async ()=>{
            const content = await (0, $jbZl4.getGrsAndContentfulContent)({
                keyword: keyword || "",
                product: product,
                locale: "en-US",
                anonymousId: anonymousId
            });
            if (content === null || content === void 0 ? void 0 : content.recoSessionId) (0, $jbZl4.setGrsDataToLocalStorage)({
                recoSessionId: content.recoSessionId,
                recoEntityId: content.recoEntityId
            });
            setBanditsContent(content);
        };
        try {
            getBanditsContent();
        } catch (e) {
            setError(e);
        } finally{
            setLoading(false);
        }
    }, [
        isExperimentEnabled,
        keyword,
        product,
        anonymousId
    ]);
    const value = (0, $iSvIT.useMemo)(()=>({
            banditsContent: banditsContent,
            loading: loading,
            error: error
        }), [
        banditsContent,
        loading,
        error
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($54ee6c432cc378b8$var$BanditsContext.Provider, {
        value: value,
        children: children
    });
};
const $54ee6c432cc378b8$export$d85787cef2955e0c = ()=>{
    const context = (0, $iSvIT.useContext)($54ee6c432cc378b8$var$BanditsContext);
    if (!context) console.info("useBanditsContext is not used within a BanditsProvider");
    return context;
}; // Wrapper Components
const $54ee6c432cc378b8$var$imgContainer = null;
const $54ee6c432cc378b8$var$confluenceImgContainer = null;
const $54ee6c432cc378b8$export$1cb749e21ac9e393 = ({ product: product, type: type = "header", children: children })=>{
    var _banditsContent_headline, _banditsContent_headline1;
    const { banditsContent: banditsContent, loading: loading, error: error } = $54ee6c432cc378b8$export$d85787cef2955e0c();
    const SkeletonComponent = product === "jira" ? $54ee6c432cc378b8$export$15339ba7c5b3a2b8 : $54ee6c432cc378b8$export$ce1a828edc281b5e;
    if (loading || !banditsContent) return /*#__PURE__*/ (0, $loA2J.jsx)(SkeletonComponent, {
        type: type
    });
    if (error || !(banditsContent === null || banditsContent === void 0 ? void 0 : banditsContent.headline)) return children;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: type === "header" ? banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_headline = banditsContent.headline) === null || _banditsContent_headline === void 0 ? void 0 : _banditsContent_headline.title : banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_headline1 = banditsContent.headline) === null || _banditsContent_headline1 === void 0 ? void 0 : _banditsContent_headline1.subheading
    });
}; // eslint-disable-next-line complexity
const $54ee6c432cc378b8$export$f9fbacfdb5ded657 = ({ product: product, showChildren: showChildren = false, children: children })=>{
    var _banditsContent_asset, _banditsContent_asset1, _banditsContent_asset_video1Mp4, _banditsContent_asset2, _banditsContent_asset_image1, _banditsContent_asset3, _banditsContent_asset_video1Mp41, _banditsContent_asset4, _banditsContent_asset_video1Webm, _banditsContent_asset5, _banditsContent_asset_image11, _banditsContent_asset6, _banditsContent_asset_image12, _banditsContent_asset7;
    const { banditsContent: banditsContent, loading: loading, error: error } = $54ee6c432cc378b8$export$d85787cef2955e0c();
    if (loading || !banditsContent) return /*#__PURE__*/ (0, $loA2J.jsx)($54ee6c432cc378b8$export$8a7df558a5bc35a7, {});
    if (showChildren || error || !(banditsContent === null || banditsContent === void 0 ? void 0 : banditsContent.asset) || (banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset = banditsContent.asset) === null || _banditsContent_asset === void 0 ? void 0 : _banditsContent_asset.id) === (0, $jbZl4.JIRA_FEATURES_ASSET_CONTROL) || (banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset1 = banditsContent.asset) === null || _banditsContent_asset1 === void 0 ? void 0 : _banditsContent_asset1.id) === (0, $jbZl4.CONFLUENCE_FEATURES_ASSET_CONTROL)) return children;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o _c71lstmo _1bsb1osq _p12f1kpv",
            product === "confluence" && "_1ul91178 _p12f1osq _16jlkb7n _1o9zkb7n _i0dl1osq _sugaglyw"
        ]),
        children: (banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset2 = banditsContent.asset) === null || _banditsContent_asset2 === void 0 ? void 0 : (_banditsContent_asset_video1Mp4 = _banditsContent_asset2.video1Mp4) === null || _banditsContent_asset_video1Mp4 === void 0 ? void 0 : _banditsContent_asset_video1Mp4.url) ? /*#__PURE__*/ (0, $loA2J.jsxs)("video", {
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true,
            preload: "auto",
            poster: banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset3 = banditsContent.asset) === null || _banditsContent_asset3 === void 0 ? void 0 : (_banditsContent_asset_image1 = _banditsContent_asset3.image1) === null || _banditsContent_asset_image1 === void 0 ? void 0 : _banditsContent_asset_image1.url,
            controls: true,
            className: (0, $esG4f.default)([
                "_c71lcv93 _p12f1osq"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    src: banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset4 = banditsContent.asset) === null || _banditsContent_asset4 === void 0 ? void 0 : (_banditsContent_asset_video1Mp41 = _banditsContent_asset4.video1Mp4) === null || _banditsContent_asset_video1Mp41 === void 0 ? void 0 : _banditsContent_asset_video1Mp41.url,
                    type: "video/mp4"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    src: banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset5 = banditsContent.asset) === null || _banditsContent_asset5 === void 0 ? void 0 : (_banditsContent_asset_video1Webm = _banditsContent_asset5.video1Webm) === null || _banditsContent_asset_video1Webm === void 0 ? void 0 : _banditsContent_asset_video1Webm.url,
                    type: "video/webm"
                })
            ]
        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
            image: {
                src: (banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset6 = banditsContent.asset) === null || _banditsContent_asset6 === void 0 ? void 0 : (_banditsContent_asset_image11 = _banditsContent_asset6.image1) === null || _banditsContent_asset_image11 === void 0 ? void 0 : _banditsContent_asset_image11.url) || "",
                alt: (banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset7 = banditsContent.asset) === null || _banditsContent_asset7 === void 0 ? void 0 : (_banditsContent_asset_image12 = _banditsContent_asset7.image1) === null || _banditsContent_asset_image12 === void 0 ? void 0 : _banditsContent_asset_image12.description) || ""
            },
            className: (0, $esG4f.default)([
                "_c71lcv93"
            ])
        })
    });
}; // Skeleton Components
const $54ee6c432cc378b8$var$sectionGap = null;
const $54ee6c432cc378b8$var$desktopDisplay = null;
const $54ee6c432cc378b8$var$tabletDisplay = null;
const $54ee6c432cc378b8$var$mobileDisplay = null;
const $54ee6c432cc378b8$var$containerStyles = null;
const $54ee6c432cc378b8$export$15339ba7c5b3a2b8 = ({ type: type })=>{
    if (type === "subheader") return;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "hero-header-skeleton",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _dm251ule"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _dh1a1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                                width: "420px",
                                height: "64px"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                                width: "360px",
                                height: "64px"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _kzvi1ule"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _dh1a1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                                width: "680px",
                                height: "64px"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                                width: "460px",
                                height: "64px"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _suga1ule"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _dh1a1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                                width: "320px",
                                height: "64px"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                                width: "280px",
                                height: "64px"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                                width: "240px",
                                height: "64px"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $54ee6c432cc378b8$export$ce1a828edc281b5e = ({ type: type })=>{
    if (type === "subheader") return;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_6rthu2gc"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                    width: "280px",
                    height: "32px"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_6rthu2gc"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                    width: "300px",
                    height: "32px"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_6rthu2gc"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                    width: "320px",
                    height: "32px"
                })
            })
        ]
    });
};
const $54ee6c432cc378b8$export$8a7df558a5bc35a7 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "hero-asset-skeleton",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _dm251ule"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                    width: "600px",
                    height: "480px"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _kzvi1ule"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                    width: "420px",
                    height: "280px"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _suga1ule"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                    width: "250px",
                    height: "200px"
                })
            })
        ]
    });
};

});
parcelRegister("hjMWG", function(module, exports) {

$parcel$export(module.exports, "Adg4Skeleton", function () { return $74c1b43210cd442a$export$e754784845e8828d; });

var $7Knp0 = parcelRequire("7Knp0");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $g2OHD = parcelRequire("g2OHD");

var $kwHar = parcelRequire("kwHar");

var $5ohHq = parcelRequire("5ohHq");
const $74c1b43210cd442a$export$e754784845e8828d = (_param)=>{
    var { width: width, height: height, groupName: groupName, testId: testId } = _param, props = (0, $akGnX._)(_param, [
        "width",
        "height",
        "groupName",
        "testId"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g2OHD.default), (0, $7Knp0._)({
        width: width,
        height: height,
        groupName: groupName,
        testId: testId,
        isShimmering: true,
        borderRadius: (0, $kwHar.default)("space.100"),
        color: (0, $5ohHq.wacToken)("color.neutral.light200"),
        ShimmeringEndColor: (0, $5ohHq.wacToken)("color.neutral.light300")
    }, props));
};

});
parcelRegister("g2OHD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bae429c214074d74$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8TInU = parcelRequire("8TInU");

var $1tzue = parcelRequire("1tzue");

var $iSvIT = parcelRequire("iSvIT");

var $b8Gks = parcelRequire("b8Gks");
var $k1KzN = parcelRequire("k1KzN");
function $bae429c214074d74$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bae429c214074d74$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bae429c214074d74$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1tzue.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bae429c214074d74$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bae429c214074d74$var$shimmerKeyframes = null;
var $bae429c214074d74$var$skeletonStyles = null;
var $bae429c214074d74$var$activeShimmerStyles = null;
/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */ var $bae429c214074d74$var$Skeleton = function Skeleton(_ref) {
    var width = _ref.width, height = _ref.height, _ref$borderRadius = _ref.borderRadius, borderRadius = _ref$borderRadius === void 0 ? "100px" : _ref$borderRadius, color = _ref.color, ShimmeringEndColor = _ref.ShimmeringEndColor, _ref$isShimmering = _ref.isShimmering, isShimmering = _ref$isShimmering === void 0 ? false : _ref$isShimmering, groupName = _ref.groupName, testId = _ref.testId;
    var groupDataAttribute = groupName && "data-".concat(groupName);
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $8TInU.default)({
        "data-testid": testId
    }, groupDataAttribute && (0, $1tzue.default)({}, groupDataAttribute, "true"), {
        className: (0, $b8Gks.default)([
            "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkn82g",
            isShimmering && "",
            isShimmering && "_j7hq586c"
        ]),
        style: $bae429c214074d74$var$_objectSpread($bae429c214074d74$var$_objectSpread({}, {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            "--ds-skeleton-from-color": color && ShimmeringEndColor ? color : undefined,
            "--ds-skeleton-to-color": color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        }), {}, {
            "--_wenvhl": (0, $k1KzN.default)("var(--ds-skeleton-from-color, ".concat("var(--ds-skeleton, #091E420F)", ")")),
            "--_1soe2er": (0, $k1KzN.default)("var(--ds-skeleton-to-color, ".concat("var(--ds-skeleton-subtle, #091E4208)", ")"))
        })
    }));
};
var $bae429c214074d74$export$2e2bcd8739ae039 = $bae429c214074d74$var$Skeleton;

});
parcelRegister("8TInU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67a5e3a84d125062$export$2e2bcd8739ae039; });
function $67a5e3a84d125062$export$2e2bcd8739ae039() {
    return $67a5e3a84d125062$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $67a5e3a84d125062$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("1tzue", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $113406c6bdee5322$export$2e2bcd8739ae039; });

var $k4PRg = parcelRequire("k4PRg");
function $113406c6bdee5322$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $k4PRg.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("k4PRg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9dc684bfecaec5f$export$2e2bcd8739ae039; });

var $1bWKL = parcelRequire("1bWKL");

var $75jqn = parcelRequire("75jqn");
function $e9dc684bfecaec5f$export$2e2bcd8739ae039(t) {
    var i = (0, $75jqn.default)(t, "string");
    return "symbol" == (0, $1bWKL.default)(i) ? i : i + "";
}

});
parcelRegister("1bWKL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0de464af02e7f83b$export$2e2bcd8739ae039; });
function $0de464af02e7f83b$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $0de464af02e7f83b$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0de464af02e7f83b$export$2e2bcd8739ae039(o);
}

});

parcelRegister("75jqn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $528811526f37b7b7$export$2e2bcd8739ae039; });

var $1bWKL = parcelRequire("1bWKL");
function $528811526f37b7b7$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $1bWKL.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $1bWKL.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("b8Gks", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81c146b95d18c9fb$export$2e2bcd8739ae039; });
const $81c146b95d18c9fb$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $81c146b95d18c9fb$var$ATOMIC_GROUP_LENGTH = 5;
function $81c146b95d18c9fb$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $81c146b95d18c9fb$var$UNDERSCORE_UNICODE ? $81c146b95d18c9fb$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("k1KzN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e94807bc1aa32f2f$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $e94807bc1aa32f2f$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});




parcelRegister("lp1yP", function(module, exports) {

$parcel$export(module.exports, "EmbeddedSignupModuleWrapper", function () { return $c29d0dbfba22be96$export$35f817a3baeda3fe; });
/* embedded-signup-module-wrapper.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $a6bec = parcelRequire("a6bec");

var $jgJpJ = parcelRequire("jgJpJ");
const $c29d0dbfba22be96$var$signupModule = null;
const $c29d0dbfba22be96$var$container = null;
const $c29d0dbfba22be96$var$footer = null;
const $c29d0dbfba22be96$export$35f817a3baeda3fe = ({ hideFooter: hideFooter, children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _vchhusvi _1e0c1txw _2lx21bp4 _ect41qje _1wyb8oy7 _ca0qviql _u5f3viql _n3tdviql _19bvviql _1kmxviql _1ggm1kwk _1ykzviql _1mae1kwk _ie1cviql _78i21j6v _1db0viql _dpmd1j6v _i6jxviql _1lh71j6v _z3ncviql _wpai1j6v"
        ]),
        style: {
            "--_djwknj": (0, $43MIc.default)((0, $jgJpJ.fontSize).sm)
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_p12fnl1e _1bsb1osq _cadt1qje _8v2f1qje _iowe1h6o _1afj1h6o _1vfhqwb1 _1twlni7l _1xd21btq _rzbyidpf _8k2zidpf _nd4uidpf _9u9nidpf _11eb1kw7 _l5k14jg8 _1n461kwk _if5yidpf _1gnp1kwk _7e5bidpf _1g0f1k8s _cg41alr3 _1t2qalr3 _125xalr3 _doqyalr3 _zcqxbs82 _clfd1j6v _11pqidpf _q0a51j6v _c3k8idpf _1sgrepq8 _kminepq8 _59381r31 _yha2glyw _1nmznqa1 _43dsoelr _1cayoelr _9m7f1r31 _rfqo1r31 _w7sw8stv _1bgk8stv _15a9nqa1 _1t0pnqa1"
                ]),
                style: {
                    "--_1n7yiy6": (0, $43MIc.default)((0, $jgJpJ.fontSize).xl),
                    "--_1h1y5xv": (0, $43MIc.default)((0, $jgJpJ.fontSize).xs)
                },
                children: children
            }),
            !hideFooter && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_19pk1k8s _2hwx1wug _otyridpf _18u01wug"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $a6bec.AtlassianLogo), {
                    appearance: "brand",
                    size: "small",
                    testId: "atlassian-logo",
                    label: "Atlassian logo"
                })
            })
        ]
    });
};

});

parcelRegister("iWMXV", function(module, exports) {

$parcel$export(module.exports, "EmailForm", function () { return $d9e071d77a1fa82e$export$89af2fd9aa25b6d8; });
/* email-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $6oKbD = parcelRequire("6oKbD");

var $jgJpJ = parcelRequire("jgJpJ");

var $1UUq1 = parcelRequire("1UUq1");

var $dWbel = parcelRequire("dWbel");
parcelRequire("9DfPf");
var $5jy1A = parcelRequire("5jy1A");
var $6PtZq = parcelRequire("6PtZq");
var $jMrU6 = parcelRequire("jMrU6");
parcelRequire("WKdxa");
var $cRAeL = parcelRequire("cRAeL");
const $d9e071d77a1fa82e$export$89af2fd9aa25b6d8 = ()=>{
    const { isEmbedded: isEmbedded, productKey: productKey, edition: edition, formError: formError, hasSubmitted: hasSubmitted, isEmailValid: isEmailValid, onSubmitWithReCAPTCHA: onSubmitWithReCAPTCHA, setIsEmailValid: setIsEmailValid, setTypeAheadEmail: setTypeAheadEmail } = (0, $cRAeL.useSignupFormContext)();
    const intl = (0, $f6qj2.default)();
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const separatorText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.or",
        defaultMessage: "Or continue with"
    });
    (0, $iSvIT.useEffect)(()=>{
        const dataFoundationsActionSubjectId = !!isEmbedded ? "embedded" : "standalone";
        if (analyticsClient) (0, $jgJpJ.trackDataFoundationsAccountCreationComponent)(createAnalyticsEvent, {
            actionSubjectId: dataFoundationsActionSubjectId,
            productKey: productKey,
            edition: edition
        });
    }, [
        createAnalyticsEvent,
        productKey,
        edition,
        isEmbedded,
        analyticsClient
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6oKbD.default), {
        onSubmit: onSubmitWithReCAPTCHA,
        isDisabled: false,
        children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $loA2J.jsxs)("form", (0, $6iHNw._)((0, $7Knp0._)({}, formProps), {
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5jy1A.InputEmail), {
                        setIsEmailValid: setIsEmailValid,
                        submitting: submitting,
                        setTypeAheadEmail: setTypeAheadEmail,
                        workCallout: true
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $6PtZq.ButtonSubmit), {
                        "data-testid": "signup-form-submit",
                        submitting: submitting,
                        hasSubmitted: hasSubmitted,
                        isEmailValid: isEmailValid,
                        formError: false
                    }),
                    formError && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_syazgryn _19pki2wt _2hwxidpf _otyr1tcg _18u0idpf"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "BxpUiSignup.SignupForm.formError",
                            defaultMessage: "It's taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <contactUsLink>contact us</contactUsLink>.",
                            values: {
                                contactUsLink: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                        text: text,
                                        "aria-label": text,
                                        type: "inline",
                                        href: "/company/contact"
                                    })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_179r11xk _vwz4400g _19pkviql _2hwx1j6v _otyrviql _18u01j6v _y3gn1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_bfhku67f _ca0qidpf _u5f31j6v _n3tdidpf _19bv1j6v"
                            ]),
                            children: separatorText
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $jMrU6.SignInButtons), {})
                ]
            }))
    });
};
const $d9e071d77a1fa82e$var$formErrorStyle = null;
const $d9e071d77a1fa82e$var$orSeparatorStyle = null;
const $d9e071d77a1fa82e$var$orSeparatorSpanStyle = null;

});

parcelRegister("lN3YF", function(module, exports) {

$parcel$export(module.exports, "SocialEndorsement", function () { return $a85362096b094067$export$782656e60c9cecfd; });
/* social-endorsement.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $1MbAx = parcelRequire("1MbAx");
const $a85362096b094067$var$carouselStyle = null;
const $a85362096b094067$var$trackStyle = null;
const $a85362096b094067$var$logoStyle = null;
const $a85362096b094067$var$SocialEndorsementComponent = ()=>{
    const logos = [
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/canva.svg",
            alt: "Canva",
            width: 95
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/nasa.svg",
            alt: "Nasa",
            width: 60
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/illumina.svg",
            alt: "Illumina",
            width: 103
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/docker.svg",
            alt: "Docker",
            width: 108
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/new-york-times.svg",
            alt: "The New York Times",
            width: 165
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/audi.svg",
            alt: "Audi",
            width: 68
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": "cfind-2675-social-proof",
        className: (0, $esG4f.default)([
            "_1reo15vq _18m915vq _4t3i14no _kqswh2mm _1q511tcg _1bsb1osq _vchh1ntv"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_y44v9j94 _1e0c1txw _zulpzwfg _kqswstnw"
            ]),
            children: [
                ...logos,
                ...logos
            ].map((logo, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                        src: logo.src,
                        alt: logo.alt,
                        loading: "lazy",
                        width: logo.width,
                        className: (0, $esG4f.default)([
                            "_lcxvglyw _kdamllbs _4t3i14no _16bullbs"
                        ])
                    })
                }, index))
        })
    });
};
const $a85362096b094067$export$782656e60c9cecfd = (0, $1MbAx.withFeatureExposed)("cfind-2675-social-proof-paid", "true", $a85362096b094067$var$SocialEndorsementComponent);

});


parcelRegister("gHQuP", function(module, exports) {
$parcel$export(module.exports, "ConfluenceFeaturesPageEmbeddedSignupForm", function () { return (parcelRequire("a5anJ")).ConfluenceFeaturesPageEmbeddedSignupForm; });
$parcel$export(module.exports, "DefaultEmbeddedSignupForm", function () { return (parcelRequire("i8Gkd")).DefaultEmbeddedSignupForm; });
$parcel$export(module.exports, "LoggedInForm", function () { return (parcelRequire("53H84")).LoggedInForm; });
parcelRequire("6kzTi");
parcelRequire("a5anJ");
parcelRequire("i8Gkd");
parcelRequire("53H84");

});
parcelRegister("a5anJ", function(module, exports) {

$parcel$export(module.exports, "ConfluenceFeaturesPageEmbeddedSignupForm", function () { return $a02c75a45b8462de$export$2394908a1a97673f; });
/* confluence-features-page-embedded.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6x1qA = parcelRequire("6x1qA");
var $dFnC9 = parcelRequire("dFnC9");

var $lp1yP = parcelRequire("lp1yP");
parcelRequire("9DfPf");
var $aGugh = parcelRequire("aGugh");
var $9cpbu = parcelRequire("9cpbu");
parcelRequire("WKdxa");
var $cRAeL = parcelRequire("cRAeL");
const $a02c75a45b8462de$var$confluenceEmbeddedExistingText = (0, $6x1qA.defineMessage)({
    id: "BxpUiSignup.SignupForm.existingProduct.confluence.embedded",
    defaultMessage: "Trying to access {product}? <logInLink>Log in</logInLink>"
});
const $a02c75a45b8462de$export$2394908a1a97673f = ({ variant: variant })=>{
    const { productName: productName } = (0, $cRAeL.useSignupFormContext)();
    const headers = {
        "paid-lp-conf-features": /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.features",
            defaultMessage: "Goodbye silos, hello teamwork with Confluence"
        }),
        "anchor-lp-conf-competitors": /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.competitors",
            defaultMessage: "Confluence is the #1 collaboration tool for productive teams"
        }),
        "anchor-lp-conf-work-management": /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.work.management",
            defaultMessage: "Bring your team\u2019s work together with Confluence"
        }),
        "anchor-lp-conf-teamwork": /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.teamwork",
            defaultMessage: "Accelerate teamwork and productivity with Confluence"
        }),
        "anchor-lp-conf-collaboration": /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.collaboration",
            defaultMessage: "Turn ideas into action with Confluence"
        }),
        "anchor-lp-conf-automation": /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.automation",
            defaultMessage: "Collaborate better with Confluence"
        }),
        "paid-lp-confl-template": /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.template",
            defaultMessage: "There\u2019s a Confluence template for that"
        }),
        "paid-lp-confl-documentation": /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.documentation",
            defaultMessage: "Technically superior documentation starts with Confluence"
        }),
        "paid-lp-confl-projectmgmt": /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.project.management",
            defaultMessage: "Confluence makes project management easy"
        })
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lp1yP.EmbeddedSignupModuleWrapper), {
        hideFooter: true,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            "data-testid": "signup-form",
            className: (0, $esG4f.default)([
                "_4cvr1fhb _bfhku67f _16qsoopq _2rkogktf _syaz1bqd _1e0c1txw _2lx21bp4 _1bah1h6o _ca0qzwfg _u5f312am _n3tdzwfg _19bv12am _1bsb1erl"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                    className: (0, $esG4f.default)([
                        "_y4tivbgk _y3gn1qpp"
                    ]),
                    children: headers[variant]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    className: (0, $esG4f.default)([
                        "_1wyb1gpt _k48pocj5 _y3gn1qpp"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "BxpUiSignup.SignupForm.subheader.1",
                        defaultMessage: "It's free for up to 10 users \u2014 no credit card needed."
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $aGugh.EmailForm), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $9cpbu.ExistingProductText), {
                    messageOverride: $a02c75a45b8462de$var$confluenceEmbeddedExistingText,
                    productName: productName
                })
            ]
        })
    });
};
const $a02c75a45b8462de$var$containerStyle = null;
const $a02c75a45b8462de$var$headerStyle = null;
const $a02c75a45b8462de$var$subheaderStyle = null;

});

parcelRegister("i8Gkd", function(module, exports) {

$parcel$export(module.exports, "DefaultEmbeddedSignupForm", function () { return $82d21b13d4ccb8cc$export$ec3bbe4365c4cdfa; });
/* default-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $lp1yP = parcelRequire("lp1yP");
parcelRequire("9DfPf");
var $aGugh = parcelRequire("aGugh");
var $9cpbu = parcelRequire("9cpbu");
parcelRequire("WKdxa");
var $cRAeL = parcelRequire("cRAeL");
const $82d21b13d4ccb8cc$export$ec3bbe4365c4cdfa = ()=>{
    const { showProductLogo: showProductLogo, productLogos: productLogos, productName: productName } = (0, $cRAeL.useSignupFormContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lp1yP.EmbeddedSignupModuleWrapper), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            "data-testid": "signup-form",
            className: (0, $esG4f.default)([
                "_4cvr1fhb _syaz1bqd _1e0c1txw _2lx21bp4 _1bah1h6o"
            ]),
            children: [
                showProductLogo && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1bah1h6o _6rthgktf"
                    ]),
                    children: productLogos.map((ProductLogo, index)=>/*#__PURE__*/ (0, $loA2J.jsx)(ProductLogo, {
                            appearance: "brand"
                        }, index))
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "BxpUiSignup.EmbeddedSignupForm.header",
                        defaultMessage: "Get started with {product}",
                        values: {
                            product: productName
                        }
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "BxpUiSignup.EmbeddedSignupForm.subheader.1",
                        defaultMessage: "It's free for up to 10 users \u2014 no credit card needed."
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $aGugh.EmailForm), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $9cpbu.ExistingProductText), {
                    productName: productName
                })
            ]
        })
    });
};
const $82d21b13d4ccb8cc$var$containerStyle = null;
const $82d21b13d4ccb8cc$var$productLogoCss = null;

});

parcelRegister("53H84", function(module, exports) {

$parcel$export(module.exports, "LoggedInForm", function () { return $f4b5f74431d39c3d$export$c5d014cdd7dc976f; });
/* logged-in-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $47Euo = parcelRequire("47Euo");

var $jgJpJ = parcelRequire("jgJpJ");

var $4toHd = parcelRequire("4toHd");
const $f4b5f74431d39c3d$var$containerStyles = null;
const $f4b5f74431d39c3d$var$headerStyles = null;
const $f4b5f74431d39c3d$export$c5d014cdd7dc976f = ()=>{
    const intl = (0, $f6qj2.default)();
    const { userInfo: { name: name } } = (0, $4toHd.useSiteNameContext)();
    const headerText = intl.formatMessage({
        id: "BxpUiSignup.nameSite.header",
        defaultMessage: "Welcome back, {name}"
    }, {
        name: (0, $jgJpJ.getFirstName)(name)
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_bfhku67f _2rkogktf _ca0q1ylp _u5f312am _n3td8vuz _19bv12am _1bsb1erl"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_k48pbfng"
                ]),
                children: headerText
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {
                WeekOneUser: null
            })
        ]
    });
};

});
parcelRegister("47Euo", function(module, exports) {
$parcel$export(module.exports, "ExistingUser", function () { return (parcelRequire("fOAR4")).ExistingUser; });
$parcel$export(module.exports, "NewUser", function () { return (parcelRequire("lXpJc")).NewUser; });
$parcel$export(module.exports, "ReturnToProduct", function () { return (parcelRequire("fwI3y")).ReturnToProduct; });
$parcel$export(module.exports, "SitePicker", function () { return (parcelRequire("gNKPy")).SitePicker; });

$parcel$export(module.exports, "default", function () { return $a2fbbb40a532c3c3$export$2e2bcd8739ae039; });

var $4IavQ = parcelRequire("4IavQ");
parcelRequire("dhiHj");
parcelRequire("biQJa");
var $a2fbbb40a532c3c3$export$2e2bcd8739ae039 = (0, $4IavQ.SiteActivation);

});
parcelRegister("4IavQ", function(module, exports) {

$parcel$export(module.exports, "SiteActivation", function () { return $ded2e4e9460465e4$export$5f19f51fdf3d70; });
/* site-activation.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $iMdoL = parcelRequire("iMdoL");
parcelRequire("biQJa");
var $hFZ05 = parcelRequire("hFZ05");

var $lXhsL = parcelRequire("lXhsL");
const $ded2e4e9460465e4$export$5f19f51fdf3d70 = (props)=>{
    const cohort = (0, $iMdoL.useCohort)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": "site-activation",
        "data-cohort": cohort,
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hFZ05.SiteActivationContextProvider), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lXhsL.SiteActivationSwitcher), (0, $7Knp0._)({}, props))
        })
    });
};
// fill the available space in the parent container
const $ded2e4e9460465e4$var$siteActivationCss = null;

});
parcelRegister("biQJa", function(module, exports) {
$parcel$export(module.exports, "SiteActivationContextProvider", function () { return (parcelRequire("hFZ05")).SiteActivationContextProvider; });
$parcel$export(module.exports, "useSiteActivationContext", function () { return (parcelRequire("hFZ05")).useSiteActivationContext; });
parcelRequire("hSQrG");
parcelRequire("hFZ05");

});
parcelRegister("hSQrG", function(module, exports) {

$parcel$export(module.exports, "useRecommendedSiteName", function () { return $c5ced0576bd99bf0$export$c2aa7c9492b42e56; });

var $iSvIT = parcelRequire("iSvIT");

var $aYwtv = parcelRequire("aYwtv");

var $5wOn9 = parcelRequire("5wOn9");

var $hFZ05 = parcelRequire("hFZ05");
function $c5ced0576bd99bf0$export$c2aa7c9492b42e56(props = {}) {
    const { siteName: siteName, setSiteNameValue: setSiteNameValue, recommendedSiteName: recommendedSiteName } = (0, $hFZ05.useSiteActivationContext)();
    const [siteNamePopulated, setSiteNamePopulated] = (0, $iSvIT.useState)();
    const client = (0, $aYwtv.useBxpWebStargateClient)();
    const user = (0, $5wOn9.useLoggedInUser)();
    const email = user === null || user === void 0 ? void 0 : user.email;
    (0, $iSvIT.useEffect)(()=>{
        if (email) client.getRecommendedSiteName({
            email: email
        }).then((result)=>setSiteNameValue(result.recommendedName)).catch(props.onError);
    }, [
        client,
        email,
        props.onError,
        setSiteNameValue
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (siteNamePopulated) // take no action because site name was already changed via either user interaction or site-name recommendation
        return;
        if (siteName) // user has already started typing, let's not overwrite their input with a recommended site name
        setSiteNamePopulated(true);
        else if (recommendedSiteName) {
            setSiteNameValue(recommendedSiteName);
            setSiteNamePopulated(true);
        }
    }, [
        siteNamePopulated,
        recommendedSiteName,
        siteName,
        setSiteNameValue
    ]);
}

});
parcelRegister("hFZ05", function(module, exports) {

$parcel$export(module.exports, "useSiteActivationContext", function () { return $ea14a84f25ad216e$export$48473054405e7add; });
$parcel$export(module.exports, "SiteActivationContextProvider", function () { return $ea14a84f25ad216e$export$e1087d57f38afae1; });
//TO DO: in the next PR refactor and test this context

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $eZAyW = parcelRequire("eZAyW");

var $f6qj2 = parcelRequire("f6qj2");

var $cGDYS = parcelRequire("cGDYS");

var $g9kzu = parcelRequire("g9kzu");

var $jFQmg = parcelRequire("jFQmg");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $aYwtv = parcelRequire("aYwtv");

var $3FBn4 = parcelRequire("3FBn4");

var $gFK1O = parcelRequire("gFK1O");

var $lrVTP = parcelRequire("lrVTP");

var $dwSjs = parcelRequire("dwSjs");

var $fBroD = parcelRequire("fBroD");
const { ABORTED: $ea14a84f25ad216e$var$ABORTED, SUCCEEDED: $ea14a84f25ad216e$var$SUCCEEDED } = (0, $jgJpJ.UfoExperienceStatus);
const { PRESS: $ea14a84f25ad216e$var$PRESS, TRANSITION: $ea14a84f25ad216e$var$TRANSITION } = (0, $jgJpJ.UfoInteractionType);
const $ea14a84f25ad216e$var$ufoBaseLogs = [
    {
        name: "pkg:site-activation"
    },
    {
        name: "component:siteActivationContextProvider"
    }
];
const $ea14a84f25ad216e$export$fe5d808150ab3415 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $ea14a84f25ad216e$export$48473054405e7add = ()=>{
    const context = (0, $iSvIT.useContext)($ea14a84f25ad216e$export$fe5d808150ab3415);
    if (!context) throw new Error("useSiteActivationContext must be used within a SiteActivationContextProvider");
    return context;
};
const $ea14a84f25ad216e$export$e1087d57f38afae1 = ({ children: children })=>{
    var _transactionAccounts_, _profile_cohorts, _location_pathname;
    //HOOKS
    const intl = (0, $f6qj2.default)();
    const { executeRecaptcha: executeRecaptcha } = (0, $eZAyW.useGoogleReCaptcha)();
    const signupClient = (0, $aYwtv.useBxpWebStargateClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const analyticsClient = (0, $jFQmg.useAnalyticsClient)();
    const { profile: profile, user: user, product: product, edition: originalEdition = "free", transactionAccounts: transactionAccounts } = (0, $iMdoL.useUserContext)();
    /**
   * Rovo Dev (aka DEVAI) is a special case, it only has a single
   * edition, standard. There is an outstanding DACI:
   * https://hello.atlassian.net/wiki/spaces/uts/pages/5807772710/Rovo+Dev+Everywhere+SKU+DACI
   * If/when this DACI is resolved and Rovo Dev supports the free
   * edition, this special case can then be removed.
   */ let edition = originalEdition;
    if ((product === null || product === void 0 ? void 0 : product.key) === (0, $jgJpJ.ProductKey).DEVAI) edition = "standard";
    const { companyType: companyType, domainType: domainType, userType: userType } = (profile === null || profile === void 0 ? void 0 : profile.cohorts) || {};
    const cohort = (0, $iMdoL.useCohort)();
    const expandableSites = (0, $iMdoL.useCrossflowEligibleSites)();
    const upgradableSites = (0, $iMdoL.useUpgradableSites)();
    const stargateClient = (0, $aYwtv.useBxpWebStargateClient)();
    const location = (0, $lrVTP.useLocation)();
    const sites = (0, $iSvIT.useMemo)(()=>{
        var _ref;
        return (_ref = cohort === (0, $iMdoL.COHORTS).UPGRADE_ELIGIBLE_USER ? upgradableSites : expandableSites) !== null && _ref !== void 0 ? _ref : [];
    }, [
        cohort,
        expandableSites,
        upgradableSites
    ]);
    const isWorkspaceProduct = (0, $iSvIT.useMemo)(()=>!!(product === null || product === void 0 ? void 0 : product.key) && [
            (0, $jgJpJ.ProductKey).CONFLUENCE,
            (0, $jgJpJ.ProductKey).TEAMWORK_COLLECTION,
            (0, $jgJpJ.ProductKey).SERVICE_COLLECTION
        ].includes(product === null || product === void 0 ? void 0 : product.key), [
        product === null || product === void 0 ? void 0 : product.key
    ]);
    //STATE
    const [showSitePicker, setShowSitePicker] = (0, $iSvIT.useState)(sites.length > 0);
    const [siteNameValid, setSiteNameValid] = (0, $iSvIT.useState)(false);
    const [hasSubmitted, setHasSubmitted] = (0, $iSvIT.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $iSvIT.useState)(false);
    const [sitePickerValue, setSitePickerValue] = (0, $iSvIT.useState)(sites[0]);
    const [siteName, setSiteNameValue] = (0, $iSvIT.useState)("");
    const [recommendedSiteName] = (0, $iSvIT.useState)("");
    var _transactionAccounts__id;
    const [selectedTransactionAccountId, setSelectedTransactionAccountId] = (0, $iSvIT.useState)((_transactionAccounts__id = (_transactionAccounts_ = transactionAccounts[0]) === null || _transactionAccounts_ === void 0 ? void 0 : _transactionAccounts_.id) !== null && _transactionAccounts__id !== void 0 ? _transactionAccounts__id : "");
    const [recaptchaFailedToLoad, setRecaptchFailedToLoad] = (0, $iSvIT.useState)(false);
    const [recaptchaRetryTimeRemainingSecond, setRecaptchaRetryTimeRemainingSecond] = (0, $iSvIT.useState)(60);
    const [validatationMessage, setValidationMessage] = (0, $iSvIT.useState)();
    //VARIABLES
    const searchParameters = new URLSearchParams(location.search);
    var _searchParameters_get;
    const platform = (_searchParameters_get = searchParameters.get("platform")) !== null && _searchParameters_get !== void 0 ? _searchParameters_get : "routing";
    const primaryCollectionProduct = searchParameters.get("primaryCollectionProduct");
    const localizedContactUrl = (0, $3FBn4.useLocalizedHref)("/company/contact");
    const isNewUser = ((_profile_cohorts = profile.cohorts) === null || _profile_cohorts === void 0 ? void 0 : _profile_cohorts.userType) === "new-user";
    const productKey = product === null || product === void 0 ? void 0 : product.key;
    const { isValid: isValid, isValidating: isValidating, error: error } = (0, $dwSjs.useSiteNameValidation)(siteName, setSiteNameValid);
    const isEmbedded = !((_location_pathname = location.pathname) === null || _location_pathname === void 0 ? void 0 : _location_pathname.endsWith("/try/cloud/signup"));
    const dataFoundationsActionSubjectId = !!isEmbedded ? "embedded" : "standalone";
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    const redirectToAdminHubForShadowIt = (error)=>{
        var _error_response;
        const errorCode = error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status;
        const redirectUrlShadowIt = errorCode === 403 && (0, $jgJpJ.getRedirectUrlFromShadowItError)(error);
        // Shadow IT unauthorized user redirects to adminhub's Shadow IT request flow.
        if (errorCode === 403 && Boolean(redirectUrlShadowIt)) window.location.assign(redirectUrlShadowIt);
    };
    const showRecaptchaFormError = (0, $iSvIT.useCallback)(()=>{
        const anonymousId = decodeURIComponent((0, $gFK1O.Cookie).readCookie("ajs_anonymous_id") || "n/a");
        setValidationMessage((0, $6iHNw._)((0, $7Knp0._)({}, (0, $fBroD.messages).timeout), {
            values: {
                // eslint-disable-next-line react/no-unstable-nested-components
                "href-support": (node)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                        href: localizedContactUrl,
                        children: node
                    }),
                "error_id": `Anonymous ID: ${anonymousId}`
            }
        }));
        // Reset form to allow re-submit
        setIsSubmitting(false);
        setHasSubmitted(false);
    }, [
        localizedContactUrl
    ]);
    const activateSiteHandler = (0, $iSvIT.useCallback)(async (signupId, privacyPolicy)=>{
        setIsSubmitting(true);
        if (!executeRecaptcha && recaptchaRetryTimeRemainingSecond > 0) {
            // set trigger that will wait for Recaptcha retry logic
            setRecaptchFailedToLoad(true);
            return;
        }
        setRecaptchFailedToLoad(false);
        const localeData = await signupClient.getConsentConfig();
        const testingPurposes = (0, $jgJpJ.isTestTenantByName)(siteName);
        const signupContext = (0, $jgJpJ.getSignupContext)({
            productKey: productKey,
            testingPurposes: testingPurposes,
            signupId: signupId,
            search: location.search
        });
        const MAX_SIGNUP_CONTEXT_LENGTH = 8192;
        let signupContextString = JSON.stringify(signupContext);
        if (signupContextString.length > MAX_SIGNUP_CONTEXT_LENGTH) signupContextString = "{}";
        const ccpProducts = (0, $jgJpJ.mapProductKeyAndEditionToCcpProduct)({
            productKey: productKey,
            edition: edition
        });
        // service collections with a primaryCollectionProduct prioritize that product first
        const childProductsForPriorityActivation = productKey === (0, $jgJpJ.ProductKey).SERVICE_COLLECTION && primaryCollectionProduct ? [
            primaryCollectionProduct
        ] : [];
        const gRecaptchaResponse = await (0, $jgJpJ.getRecaptcha)(user.email || "", executeRecaptcha);
        (0, $jgJpJ.ufoEventNewSiteN2NSubmit).setCustomData({
            gRecaptchaResponse: gRecaptchaResponse !== null && gRecaptchaResponse !== void 0 ? gRecaptchaResponse : "none",
            executeRecaptchaExists: Boolean(executeRecaptcha),
            reactComponent: "SiteActivationProvider"
        });
        // Handle missing reCAPTCHA response
        if (!gRecaptchaResponse) {
            (0, $jgJpJ.trackRecaptchaFailure)(createAnalyticsEvent, "site-activation");
            showRecaptchaFormError();
            return;
        }
        // Set experiment metadata before starting UFO event for GraphQL webhook setup
        (0, $jgJpJ.ufoEventGraphQLWebhookSetup).setCustomData({
            webPlatform: "site-activation"
        });
        var _localeData_locale;
        // get consents
        const consent = (0, $jgJpJ.getConsents)((_localeData_locale = localeData.locale) !== null && _localeData_locale !== void 0 ? _localeData_locale : "US-VA", localeData.localeRequiresMarketingCommunicationOptIn, privacyPolicy);
        const response = await signupClient.activateProduct({
            displayName: user.name,
            email: user.email || "",
            ccpProducts: [
                ccpProducts
            ],
            childProductsForPriorityActivation: childProductsForPriorityActivation,
            siteName: siteName,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            useCcpPlatform: platform === "ccp",
            consent: consent,
            platform: platform,
            signupContext: signupContextString,
            isNewUser: productKey === (0, $jgJpJ.ProductKey).JIRA_SOFTWARE || isNewUser,
            gRecaptchaResponse: gRecaptchaResponse,
            testingPurposes: testingPurposes,
            signupId: signupId,
            transactionAccountId: selectedTransactionAccountId
        });
        const redirectUrl = (0, $jgJpJ.getConfirmationPageUrl)({
            locale: intl.locale,
            productKey: productKey,
            response: response,
            siteName: siteName,
            signupId: signupId,
            edition: edition,
            primaryCollectionProduct: primaryCollectionProduct
        });
        window.location.assign(redirectUrl);
    }, [
        executeRecaptcha,
        recaptchaRetryTimeRemainingSecond,
        showRecaptchaFormError,
        signupClient,
        siteName,
        primaryCollectionProduct,
        location.search,
        productKey,
        edition,
        user,
        platform,
        isNewUser,
        intl.locale,
        createAnalyticsEvent,
        selectedTransactionAccountId
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (profile.requestInProgress || !analyticsClient) return;
        (0, $jgJpJ.trackSiteActivationViewed)(createAnalyticsEvent, {
            actionSubjectId: dataFoundationsActionSubjectId,
            cohort: cohort,
            productKey: productKey,
            edition: edition,
            userType: userType,
            domainType: domainType,
            companyType: companyType,
            numTxas: transactionAccounts.length
        });
    }, [
        analyticsClient,
        cohort,
        createAnalyticsEvent,
        companyType,
        dataFoundationsActionSubjectId,
        domainType,
        edition,
        productKey,
        profile.requestInProgress,
        userType
    ]);
    (0, $iSvIT.useEffect)(()=>{
        const ufoSubmitEvent = showSitePicker ? (0, $jgJpJ.ufoEventExistingSiteN2ESubmit) : (0, $jgJpJ.ufoEventNewSiteN2NSubmit);
        if (recaptchaFailedToLoad && recaptchaRetryTimeRemainingSecond <= 0) ufoSubmitEvent.failure({
            customData: {
                reactComponent: "SiteActivationContextProvider",
                analyticsEvent: "errored",
                recaptchaRetryTimeRemainingSecond: 0,
                siteType: showSitePicker ? "existing-site" : "new-site"
            },
            error: new Error("Recaptcha retry failed")
        });
        if (recaptchaFailedToLoad) activateSiteHandler().then(()=>{
            ufoSubmitEvent.success({
                customData: {
                    reactComponent: "SiteActivationContextProvider",
                    analyticsEvent: "succeeded",
                    siteType: showSitePicker ? "existing-site" : "new-site",
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                }
            });
        }).catch((error)=>{
            showRecaptchaFormError();
            ufoSubmitEvent.failure({
                customData: {
                    reactComponent: "SiteActivationContextProvider",
                    analyticsEvent: "errored",
                    siteType: showSitePicker ? "existing-site" : "new-site",
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                },
                error: error
            });
            return;
        });
    }, [
        activateSiteHandler,
        executeRecaptcha,
        localizedContactUrl,
        recaptchaFailedToLoad,
        recaptchaRetryTimeRemainingSecond,
        showRecaptchaFormError,
        showSitePicker
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (!recaptchaFailedToLoad) return;
        if (recaptchaRetryTimeRemainingSecond <= 0) return;
        const intervalId = setInterval(()=>{
            setRecaptchaRetryTimeRemainingSecond(recaptchaRetryTimeRemainingSecond - 1);
        }, 1000);
        return ()=>clearInterval(intervalId);
    }, [
        recaptchaFailedToLoad,
        recaptchaRetryTimeRemainingSecond
    ]);
    // eslint-disable-next-line complexity
    const activateSite = async ({ privacyPolicy: privacyPolicy })=>{
        var _profile_cohorts;
        setHasSubmitted(true);
        sessionStorage.setItem("provisioningStartTime", `${Date.now()}`);
        // Start UFOs to begin duration metrics for signup submit
        (0, $jgJpJ.ufoEventNewSiteN2NSubmit).start({
            productKey: productKey,
            webPlatform: "site-activation"
        });
        (0, $jgJpJ.ufoEventExistingSiteN2ESubmit).start({
            productKey: productKey,
            webPlatform: "site-activation"
        });
        const ufoLogs = [
            ...$ea14a84f25ad216e$var$ufoBaseLogs,
            {
                name: "method:activateSite"
            }
        ];
        // user must be logged in
        if (!user.isUserLoggedIn) return;
        // Generate a signup ID and add it to all the events in this flow.
        // This id is used to stitch together a view of the end-to-end
        // provisioning experience, all the way to landing in product.
        const signupId = (0, $cGDYS.default)();
        const isN2N = !showSitePicker && !sitePickerValue;
        const domainType = profile && ((_profile_cohorts = profile.cohorts) === null || _profile_cohorts === void 0 ? void 0 : _profile_cohorts.domainType);
        (0, $jgJpJ.trackSignupStarted)(createAnalyticsEvent, signupId, productKey, edition, isN2N, domainType);
        // handle site picker submit
        if (showSitePicker) {
            if (sitePickerValue) {
                const upgradableProduct = sitePickerValue.products.find((product)=>[
                        product.productKey,
                        product.partOfCollection
                    ].includes(productKey) && product.productEdition === "free");
                if (upgradableProduct) {
                    // send to adminhub
                    const redirectUrl = await (0, $jgJpJ.getAdminHubUpgradeProductUrl)(sitePickerValue, productKey, edition);
                    createAnalyticsEvent({
                        eventName: "signupUpgrade",
                        eventComponent: "button",
                        billingSystem: upgradableProduct.billingSourceSystem,
                        event: "clicked",
                        eventType: "ui",
                        action: "upgrade"
                    }).fire("signup");
                    window.location.assign(redirectUrl);
                    return;
                }
                try {
                    // Check for Shadow IT authorization.
                    await signupClient.getActivationAuthorization({
                        productKeys: [
                            productKey
                        ],
                        productEdition: edition,
                        cloudId: sitePickerValue.cloudId,
                        siteName: sitePickerValue === null || sitePickerValue === void 0 ? void 0 : sitePickerValue.displayName
                    });
                    const crossFlowActivationUrl = (0, $jgJpJ.getCrossFlowActivationUrl)({
                        cloudId: sitePickerValue.cloudId,
                        edition: edition,
                        productKey: primaryCollectionProduct !== null && primaryCollectionProduct !== void 0 ? primaryCollectionProduct : productKey,
                        siteName: sitePickerValue === null || sitePickerValue === void 0 ? void 0 : sitePickerValue.displayName
                    });
                    (0, $jgJpJ.ufoEventExistingSiteN2ESubmit).success({
                        customData: {
                            reactComponent: "SiteActivationContextProvider",
                            analyticsEvent: "succeeded",
                            siteType: "existing-site"
                        }
                    });
                    (0, $jgJpJ.trackSitePickerSubmit)({
                        createAnalyticsEvent: createAnalyticsEvent,
                        targetCloudId: sitePickerValue.cloudId,
                        provisionedProducts: [
                            {
                                product: productKey,
                                edition: edition
                            }
                        ],
                        signupUrl: crossFlowActivationUrl,
                        aaid: user.accountId
                    });
                    window.location.assign(crossFlowActivationUrl);
                } catch (error) {
                    (0, $jgJpJ.ufoEventExistingSiteN2ESubmit).failure({
                        customData: {
                            reactComponent: "SiteActivationContextProvider",
                            analyticsEvent: "errored",
                            siteType: "existing-site"
                        },
                        error: error
                    });
                    redirectToAdminHubForShadowIt(error);
                }
            }
            return;
        }
        if (isValidating) {
            const { availability: availability } = await stargateClient.checkCloudNameAvailability({
                cloudName: siteName
            });
            if (availability !== "AVAILABLE") {
                setHasSubmitted(false); // reset to allow re-submit
                return;
            }
            setSiteNameValid(true);
        }
        if (!siteNameValid && !isValidating || !siteName) {
            setHasSubmitted(false); // reset to allow re-submit
            return;
        }
        (0, $jgJpJ.trackSubmitSuccess)(createAnalyticsEvent);
        if (siteName !== recommendedSiteName) (0, $jgJpJ.trackSiteNameChangedFromRecommendedSiteName)(createAnalyticsEvent, siteName, recommendedSiteName);
        let setTimeoutId;
        const interactionId = (0, $cGDYS.default)();
        (0, $jgJpJ.operateWithSignupUFOLogging)({
            interactionId: interactionId,
            interactionName: "try-cloud-signup_form-submit",
            type: "press",
            timeout: 120000,
            labelStack: [
                {
                    name: "uip"
                }
            ],
            errorContext: "error occured on signup form submit button"
        }, async ()=>Promise.race([
                new Promise((_resolve, reject)=>{
                    setTimeoutId = setTimeout(()=>{
                        reject((0, $jgJpJ.SignupUFOLoggingActionTimeoutError));
                    }, 60000);
                }),
                activateSiteHandler(signupId, privacyPolicy).finally(()=>{
                    if (setTimeoutId) clearTimeout(setTimeoutId);
                })
            ])).then(()=>{
            // SLO "good event" for N2N signup submit
            (0, $jgJpJ.ufoEventNewSiteN2NSubmit).success({
                customData: {
                    reactComponent: "SiteActivationContextProvider",
                    analyticsEvent: "succeeded",
                    siteType: "new-site"
                }
            });
            (0, $jgJpJ.trackAndCompleteUFOEvent)({
                experienceName: (0, $jgJpJ.UfoEventName).ACTIVATE_PRODUCT_API_SUCCESS,
                experienceStatus: $ea14a84f25ad216e$var$SUCCEEDED,
                interactionType: $ea14a84f25ad216e$var$TRANSITION,
                ufoLogger: ufoLogs
            });
            // Reliabiltiy SLO "good event" for signup submit captured on bxp-ui only
            (0, $jgJpJ.trackAndCompleteUFOEvent)({
                experienceName: (0, $jgJpJ.UfoEventName).BXPUI_SIGNUP_SUBMIT_SLO_SUCCEEDED,
                experienceStatus: $ea14a84f25ad216e$var$SUCCEEDED,
                interactionType: $ea14a84f25ad216e$var$PRESS,
                ufoLogger: ufoLogs
            });
            // Reliabiltiy SLO "good event" for signup submit captured across bxp-ui and bxpkit
            (0, $jgJpJ.trackAndCompleteUFOEvent)({
                experienceName: (0, $jgJpJ.UfoEventName).DEFAULT_SIGNUP_SUBMIT_SLO_SUCCEEDED,
                experienceStatus: $ea14a84f25ad216e$var$SUCCEEDED,
                interactionType: $ea14a84f25ad216e$var$PRESS,
                ufoLogger: ufoLogs
            });
        }).catch((error)=>{
            var _error_response_headers, _error_response;
            // SLO "bad event" for N2N signup submit
            (0, $jgJpJ.ufoEventNewSiteN2NSubmit).failure({
                customData: {
                    reactComponent: "SiteActivationContextProvider",
                    analyticsEvent: "errored",
                    siteType: "new-site"
                },
                error: error
            });
            redirectToAdminHubForShadowIt(error);
            const traceId = error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_headers = _error_response.headers) === null || _error_response_headers === void 0 ? void 0 : _error_response_headers.get("atl-traceid");
            setValidationMessage((0, $6iHNw._)((0, $7Knp0._)({}, (0, $fBroD.messages).timeout), {
                values: {
                    // eslint-disable-next-line react/no-unstable-nested-components
                    "href-support": (node)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            href: localizedContactUrl,
                            children: node
                        }),
                    "error_id": traceId ? `Trace ID: ${traceId}` : `Interaction ID: ${interactionId}`
                }
            }));
            // don't re-enable the form when there is an HTTP exception. this helps with rate-limiting
            const errorType = (0, $jgJpJ.SignupGetUFOErrorType)(error);
            if (errorType !== "http_exception") {
                // Reset form to allow re-submit
                setIsSubmitting(false);
                setHasSubmitted(false);
            }
            (0, $jgJpJ.trackAndCompleteUFOEvent)({
                experienceName: (0, $jgJpJ.UfoEventName).ACTIVATE_PRODUCT_API_ERROR,
                experienceStatus: $ea14a84f25ad216e$var$ABORTED,
                interactionType: $ea14a84f25ad216e$var$TRANSITION,
                error: error,
                errorName: "ActivateProductError",
                errorMessage: "error occured on activateProduct",
                ufoLogger: ufoLogs
            });
            // Reliabiltiy SLO "bad event" for signup submit captured on bxp-ui only
            (0, $jgJpJ.trackAndCompleteUFOEvent)({
                experienceName: (0, $jgJpJ.UfoEventName).BXPUI_SIGNUP_SUBMIT_SLO_FAILED,
                experienceStatus: $ea14a84f25ad216e$var$ABORTED,
                interactionType: $ea14a84f25ad216e$var$PRESS,
                error: error,
                errorName: "ActivateProductError",
                errorMessage: "error occured on activateProduct",
                ufoLogger: ufoLogs
            });
            // Reliabiltiy SLO "bad event" for signup submit captured across bxp-ui and bxpkit
            (0, $jgJpJ.trackAndCompleteUFOEvent)({
                experienceName: (0, $jgJpJ.UfoEventName).DEFAULT_SIGNUP_SUBMIT_SLO_FAILED,
                experienceStatus: $ea14a84f25ad216e$var$ABORTED,
                interactionType: $ea14a84f25ad216e$var$PRESS,
                error: error,
                errorName: "ActivateProductError",
                errorMessage: "error occured on activateProduct",
                ufoLogger: ufoLogs
            });
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)($ea14a84f25ad216e$export$fe5d808150ab3415.Provider, {
        value: {
            isSubmitting: isSubmitting,
            activateSite: activateSite,
            showSitePicker: showSitePicker,
            sites: sites,
            isRequestInProgress: profile.requestInProgress,
            email: user.email,
            sitePickerValue: sitePickerValue,
            setSitePickerValue: setSitePickerValue,
            setSiteNameValid: setSiteNameValid,
            siteName: siteName,
            setSiteNameValue: setSiteNameValue,
            setShowSitePicker: setShowSitePicker,
            recommendedSiteName: recommendedSiteName,
            hasSubmitted: hasSubmitted,
            setHasSubmitted: setHasSubmitted,
            validationMessageState: [
                validatationMessage,
                setValidationMessage
            ],
            isValid: isValid,
            isValidating: isValidating,
            error: error,
            isWorkspaceProduct: isWorkspaceProduct,
            selectedTransactionAccountId: selectedTransactionAccountId,
            setSelectedTransactionAccountId: setSelectedTransactionAccountId
        },
        children: children
    });
};

});
parcelRegister("fBroD", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $9f3c2e95e8688e2f$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $9f3c2e95e8688e2f$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    timeout: {
        id: "siteActivation.nameSite.error.timeout",
        defaultMessage: "Something went wrong on our end. Please try again. If this keeps happening, <href-support>contact support</href-support>. (Issue ID for Atlassian use: {error_id})"
    },
    invalidName: {
        id: "siteActivation.nameSite.error.invalidName",
        defaultMessage: "Your site name must be at least 3 characters long. Use only lowercase letters and numbers."
    },
    maxLength: {
        id: "siteActivation.nameSite.error.maxLength",
        defaultMessage: "That's a bit too long \u2014 try something 50 characters or less."
    },
    unavailable: {
        id: "siteActivation.nameSite.error.unavailable",
        defaultMessage: "This site is already taken."
    },
    networkError: {
        id: "siteActivation.nameSite.error.networkError",
        defaultMessage: "Something went wrong. Please try again later."
    }
});

});




parcelRegister("lXhsL", function(module, exports) {

$parcel$export(module.exports, "SiteActivationSwitcher", function () { return $bca07f5e1d47addb$export$336514a242c2c5c0; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");
parcelRequire("dhiHj");
var $fOAR4 = parcelRequire("fOAR4");
var $h0Hfa = parcelRequire("h0Hfa");
var $lXpJc = parcelRequire("lXpJc");
var $9aW3V = parcelRequire("9aW3V");
var $4bUDl = parcelRequire("4bUDl");
const $bca07f5e1d47addb$export$336514a242c2c5c0 = ({ ExistingUser: ExistingUser = /*#__PURE__*/ (0, $loA2J.jsx)((0, $fOAR4.ExistingUser), {}), ManagedUser: ManagedUser = /*#__PURE__*/ (0, $loA2J.jsx)((0, $h0Hfa.ManagedUser), {}), NewUser: NewUser = /*#__PURE__*/ (0, $loA2J.jsx)((0, $lXpJc.NewUser), {}), WeekOneUser: WeekOneUser = /*#__PURE__*/ (0, $loA2J.jsx)((0, $9aW3V.WeekOneUser), {}), UpgradeEligibleUser: UpgradeEligibleUser = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4bUDl.UpgradeEligibleUser), {}), CurrentProductUser: CurrentProductUser, UpliftEligibleUser: UpliftEligibleUser, CrossflowEligibleUser: CrossflowEligibleUser })=>{
    const cohort = (0, $iMdoL.useCohort)();
    if (cohort === (0, $iMdoL.COHORTS).MANAGED_USER && ManagedUser) return ManagedUser;
    if (cohort === (0, $iMdoL.COHORTS).WEEK_ONE_USER && WeekOneUser) return WeekOneUser;
    if (cohort === (0, $iMdoL.COHORTS).CURRENT_PRODUCT_USER && CurrentProductUser) return CurrentProductUser;
    if (cohort === (0, $iMdoL.COHORTS).NEW_USER && NewUser) return NewUser;
    if (cohort === (0, $iMdoL.COHORTS).UPGRADE_ELIGIBLE_USER && UpgradeEligibleUser) return UpgradeEligibleUser;
    if (cohort === (0, $iMdoL.COHORTS).UPLIFT_ELIGIBLE_USER && UpliftEligibleUser) return UpliftEligibleUser;
    if (cohort === (0, $iMdoL.COHORTS).CROSSFLOW_ELIGIBLE_USER && CrossflowEligibleUser) return CrossflowEligibleUser;
    return ExistingUser;
};

});
parcelRegister("dhiHj", function(module, exports) {
$parcel$export(module.exports, "ReturnToProduct", function () { return (parcelRequire("fwI3y")).ReturnToProduct; });
$parcel$export(module.exports, "SitePicker", function () { return (parcelRequire("gNKPy")).SitePicker; });
$parcel$export(module.exports, "ExistingUser", function () { return (parcelRequire("fOAR4")).ExistingUser; });
$parcel$export(module.exports, "ManagedUser", function () { return (parcelRequire("h0Hfa")).ManagedUser; });
$parcel$export(module.exports, "NewUser", function () { return (parcelRequire("lXpJc")).NewUser; });
$parcel$export(module.exports, "WeekOneUser", function () { return (parcelRequire("9aW3V")).WeekOneUser; });
$parcel$export(module.exports, "UpgradeEligibleUser", function () { return (parcelRequire("4bUDl")).UpgradeEligibleUser; });
parcelRequire("8HNBH");
parcelRequire("hIYuQ");
parcelRequire("eQore");
parcelRequire("cpLkq");
parcelRequire("6ZAeC");
parcelRequire("bavlo");

});
parcelRegister("8HNBH", function(module, exports) {
$parcel$export(module.exports, "Dropdown", function () { return (parcelRequire("jqbIe")).Dropdown; });
$parcel$export(module.exports, "ReturnToProduct", function () { return (parcelRequire("fwI3y")).ReturnToProduct; });
$parcel$export(module.exports, "SiteNameInput", function () { return (parcelRequire("hXsC1")).SiteNameInput; });
$parcel$export(module.exports, "SitePicker", function () { return (parcelRequire("gNKPy")).SitePicker; });
$parcel$export(module.exports, "SiteToggleButton", function () { return (parcelRequire("bI30y")).SiteToggleButton; });
$parcel$export(module.exports, "Label", function () { return (parcelRequire("511ro")).Label; });
parcelRequire("jqbIe");
parcelRequire("aw7DU");
parcelRequire("fwI3y");
parcelRequire("hXsC1");
parcelRequire("gNKPy");
parcelRequire("bI30y");
parcelRequire("fsv0y");
parcelRequire("511ro");

});
parcelRegister("jqbIe", function(module, exports) {

$parcel$export(module.exports, "Dropdown", function () { return $d6e0fac41afc499d$export$931cbfb6bfb85fc; });
/* dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $26kkA = parcelRequire("26kkA");

var $c9Cls = parcelRequire("c9Cls");

var $jgJpJ = parcelRequire("jgJpJ");

var $5ohHq = parcelRequire("5ohHq");

var $hFZ05 = parcelRequire("hFZ05");
const $d6e0fac41afc499d$export$931cbfb6bfb85fc = ({ sites: sites })=>{
    const { sitePickerValue: sitePickerValue, setSitePickerValue: setSitePickerValue, isSubmitting: isSubmitting, isRequestInProgress: isRequestInProgress, isWorkspaceProduct: isWorkspaceProduct } = (0, $hFZ05.useSiteActivationContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": "adg4-site-picker",
        className: (0, $esG4f.default)([
            "_1heubzd7 _125x1syg _62vcmccc _1mmsglyw _pqyq183y _84yz183y _tnizyh40 _101oyh40 _9fwgmccc _1n42bzd7 _19hkbzd7 _1700grf3 _156ugrf3 _16z5grf3 _iazigrf3 _1ybr1crf _uy3o19bv"
        ]),
        style: {
            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
            "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $26kkA.default), {
            "aria-required": true,
            isRequired: true,
            defaultValue: sites[0],
            isDisabled: isSubmitting,
            id: "site-picker-field",
            name: "site-picker-field",
            testId: "site-picker-field",
            label: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_ect4bzd7 _1wybdlk8 _k48p4jg8 _vwz4gktf"
                ]),
                style: {
                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                },
                children: isWorkspaceProduct ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "siteActivation.yourWorkspace",
                    defaultMessage: "Your workspace"
                }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "WacSignupForm.siteNameN2ELabel",
                    defaultMessage: "Your site"
                })
            }),
            children: (_param)=>/*#__PURE__*/ {
                var { fieldProps: { id: id } } = _param, rest = (0, $akGnX._)(_param.fieldProps, [
                    "id"
                ]);
                return (0, $loA2J.jsx)((0, $c9Cls.default), (0, $6iHNw._)((0, $7Knp0._)({}, rest), {
                    inputId: id,
                    options: sites,
                    getOptionLabel: (option)=>option.url.replace("https://", ""),
                    getOptionValue: (option)=>option.cloudId,
                    value: sitePickerValue,
                    onChange: (newValue)=>setSitePickerValue(newValue !== null && newValue !== void 0 ? newValue : sites[0]),
                    isLoading: isRequestInProgress,
                    isSearchable: false,
                    styles: {
                        menu: (base)=>(0, $6iHNw._)((0, $7Knp0._)({}, base), {
                                fontSize: (0, $jgJpJ.fontSize).md
                            }),
                        valueContainer: (base)=>(0, $6iHNw._)((0, $7Knp0._)({}, base), {
                                fontSize: (0, $jgJpJ.fontSize).md,
                                paddingTop: "8px",
                                paddingRight: "6px",
                                paddingBottom: "8px",
                                paddingLeft: "6px"
                            }),
                        singleValue: (base)=>(0, $6iHNw._)((0, $7Knp0._)({}, base), {
                                margin: 0
                            })
                    }
                }));
            }
        })
    });
};
const $d6e0fac41afc499d$var$labelCss = null;
const $d6e0fac41afc499d$var$inputAndLabelStyles = null;

});

parcelRegister("aw7DU", function(module, exports) {

$parcel$export(module.exports, "IsValidOrLoading", function () { return $b973c0a9df3b00b7$export$71ec10810b978f7e; });

var $loA2J = parcelRequire("loA2J");

var $bDTBs = parcelRequire("bDTBs");

var $53DZ3 = parcelRequire("53DZ3");

var $9gh2a = parcelRequire("9gh2a");

var $kwHar = parcelRequire("kwHar");
const $b973c0a9df3b00b7$export$71ec10810b978f7e = ({ isValidating: isValidating, siteNameValue: siteNameValue, validationMessage: validationMessage })=>{
    if (siteNameValue === "") return null;
    if (isValidating) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gh2a.default), {
        size: "small",
        testId: "spinner"
    });
    if (validationMessage) return /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($53DZ3))), {
        label: "warning",
        primaryColor: (0, $kwHar.default)("color.border.danger")
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bDTBs))), {
        label: "success",
        primaryColor: (0, $kwHar.default)("color.border.success")
    });
};

});
parcelRegister("53DZ3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3aec3f7c0e69d664$var$_react = $3aec3f7c0e69d664$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $3aec3f7c0e69d664$var$_statusWarning = $3aec3f7c0e69d664$var$_interopRequireDefault((parcelRequire("goemm")));
function $3aec3f7c0e69d664$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3aec3f7c0e69d664$var$WarningIcon = (props)=>/*#__PURE__*/ $3aec3f7c0e69d664$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $3aec3f7c0e69d664$var$_statusWarning.default
    }));
$3aec3f7c0e69d664$var$WarningIcon.displayName = "WarningIcon";
var $3aec3f7c0e69d664$var$_default = module.exports.default = $3aec3f7c0e69d664$var$WarningIcon;

});
parcelRegister("goemm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::435e803a057e79e21a0d31c5b12f3f81>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $beea06c80568ff37$var$_react = $beea06c80568ff37$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $beea06c80568ff37$var$_baseNew = $beea06c80568ff37$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $beea06c80568ff37$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $beea06c80568ff37$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $beea06c80568ff37$var$_react.default.createElement($beea06c80568ff37$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$beea06c80568ff37$var$StatusWarningIcon.displayName = "StatusWarningIcon";
var $beea06c80568ff37$var$_default = module.exports.default = $beea06c80568ff37$var$StatusWarningIcon;

});



parcelRegister("fwI3y", function(module, exports) {

$parcel$export(module.exports, "ReturnToProduct", function () { return $5f91fa891cf867a6$export$1cac7f8e3baae627; });
/* return-to-product.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $lrVTP = parcelRequire("lrVTP");
parcelRequire("biQJa");
var $hFZ05 = parcelRequire("hFZ05");
parcelRequire("hIYuQ");
var $fOAR4 = parcelRequire("fOAR4");
const $5f91fa891cf867a6$export$1cac7f8e3baae627 = ({ ExistingUser: ExistingUser = /*#__PURE__*/ (0, $loA2J.jsx)((0, $fOAR4.ExistingUser), {}), sites: sites })=>{
    const location = (0, $lrVTP.useLocation)();
    const createNewWorkspace = (0, $iSvIT.useMemo)(()=>{
        const queryParams = new URLSearchParams(location.search);
        return queryParams.get("createNew") === "true";
    }, [
        location.search
    ]);
    const [showSiteNaming, setShowSiteNaming] = (0, $iSvIT.useState)(createNewWorkspace);
    const { product: product } = (0, $iMdoL.useUserContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const intl = (0, $f6qj2.default)();
    const sitesWithCurrentProduct = (0, $iMdoL.useSitesWithCurrentProduct)();
    const { isWorkspaceProduct: isWorkspaceProduct } = (0, $hFZ05.useSiteActivationContext)();
    const { user: { email: email } } = (0, $iMdoL.useUserContext)();
    const { productName: productName } = (0, $jgJpJ.getProductData)(product === null || product === void 0 ? void 0 : product.key);
    if (sites === undefined) sites = sitesWithCurrentProduct;
    const goToProductButtonText = isWorkspaceProduct ? intl.formatMessage({
        id: "bxpSignup.siteExpansion.goToWorkspace",
        defaultMessage: "Go to workspace"
    }) : intl.formatMessage({
        id: "bxpSignup.siteExpansion.goToProduct",
        defaultMessage: "Go to {productName}"
    }, {
        productName: productName
    });
    const createNewWorkspaceMessageValues = {
        link: (str)=>$5f91fa891cf867a6$var$createNewWorkspaceMessageLink(str, ()=>{
                setShowSiteNaming(true);
                createAnalyticsEvent({
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "contactExpandGoToSiteNamingScreen",
                    attributes: {
                        productName: product === null || product === void 0 ? void 0 : product.name
                    }
                }).fire();
            })
    };
    const createNewWorkspaceMessage = isWorkspaceProduct ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedConfluenceCreateNewWorkspaceLink",
        defaultMessage: "or <link>create a new workspace</link>"
    }, createNewWorkspaceMessageValues) : intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedJiraCreateNewWorkspaceLink",
        defaultMessage: "or <link>start a new site</link>"
    }, createNewWorkspaceMessageValues);
    const clickReturnToExistingWorkspace = ()=>{
        setShowSiteNaming(false);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "contactExpandGoToReturnToProductScreen",
            attributes: {
                productName: product === null || product === void 0 ? void 0 : product.name
            }
        }).fire();
    };
    const goToExistingWorkspaceMessageValues = {
        link: (str)=>$5f91fa891cf867a6$var$link(str, clickReturnToExistingWorkspace)
    };
    const goToExistingWorkspaceMessage = isWorkspaceProduct ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedGoToExistingWorkspace",
        defaultMessage: "or <link>visit an existing workspace</link>"
    }, goToExistingWorkspaceMessageValues) : intl.formatMessage({
        id: "bxpSignup.companyExpand.cobrandedReturnToJoinSites",
        defaultMessage: "or <link>join an existing site</link>"
    }, goToExistingWorkspaceMessageValues);
    return showSiteNaming ? /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n _zulp7vkz"
        ]),
        children: [
            ExistingUser,
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: goToExistingWorkspaceMessage
            })
        ]
    }) : /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n _zulp7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _zulpzwfg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_ect4bzd7 _1wybdlk8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                        ]),
                        style: {
                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.2",
                            defaultMessage: "You\u2019re logged in as {email}. <switchAccountLink>Switch account</switchAccountLink>",
                            values: {
                                email: /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                                    className: (0, $esG4f.default)([
                                        "_k48pni7l _ct361wug _1i4q1hna _1nmz1hna _slp31hna"
                                    ]),
                                    children: email
                                }),
                                switchAccountLink: $5f91fa891cf867a6$var$switchAccountLink
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        "data-testid": "return-to-product",
                        className: (0, $esG4f.default)([
                            "_1e0c11p5 _zulp7vkz"
                        ]),
                        children: sites === null || sites === void 0 ? void 0 : sites.map((site, index)=>/*#__PURE__*/ {
                            var _product_key;
                            return (0, $loA2J.jsxs)("a", {
                                href: $5f91fa891cf867a6$var$getProductUrl({
                                    url: site.url,
                                    productKey: (_product_key = product === null || product === void 0 ? void 0 : product.key) !== null && _product_key !== void 0 ? _product_key : ""
                                }),
                                onClick: (e)=>{
                                    e.preventDefault(); // wait for event to fire
                                    createAnalyticsEvent({
                                        eventType: "ui",
                                        action: "clicked",
                                        actionSubject: "button",
                                        actionSubjectId: "contactExpandClickReturnToProductButton",
                                        attributes: {
                                            productName: productName
                                        }
                                    }).fire();
                                    var _product_key;
                                    window.location.href = $5f91fa891cf867a6$var$getProductUrl({
                                        url: site.url,
                                        productKey: (_product_key = product === null || product === void 0 ? void 0 : product.key) !== null && _product_key !== void 0 ? _product_key : ""
                                    });
                                },
                                className: (0, $esG4f.default)([
                                    "_4cvr1h6o _19ityzqy _2rkoftgi _1e0c11p5 _zulp19bv _yv0e1ghl _1bah1yb4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1bsb1osq _9oik1snc _1bnxagmp _jf4cvv82"
                                ]),
                                style: {
                                    "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
                                },
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1wyb7vkz _1reo15vq _18m915vq"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                className: (0, $esG4f.default)([
                                                    "_k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                                ]),
                                                children: productName
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_syaz1hap _ect4bzd7 _1wybdlk8 _1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                                                ]),
                                                style: {
                                                    "--_k3797e": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light700")),
                                                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                                },
                                                children: site.displayName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_p12fmgvx"
                                        ]),
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
                                            variant: "primary",
                                            size: "small",
                                            color: "blue",
                                            children: goToProductButtonText
                                        })
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: createNewWorkspaceMessage
            })
        ]
    });
};
const $5f91fa891cf867a6$var$link = (str, clickReturnToExistingWorkspace)=>/*#__PURE__*/ (0, $loA2J.jsx)("button", {
        onClick: clickReturnToExistingWorkspace,
        className: (0, $esG4f.default)([
            "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l33gnd"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
        },
        children: str
    });
const $5f91fa891cf867a6$var$createNewWorkspaceMessageLink = (str, exitView)=>/*#__PURE__*/ (0, $loA2J.jsx)("button", {
        onClick: exitView,
        className: (0, $esG4f.default)([
            "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
        },
        children: str
    });
const $5f91fa891cf867a6$var$switchAccountLink = (children)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
        href: (0, $jgJpJ.getSwitchAccountUrl)(),
        className: (0, $esG4f.default)([
            "_syaz17la _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
        },
        children: children
    });
const $5f91fa891cf867a6$var$getProductUrl = ({ url: url, productKey: productKey })=>{
    switch(productKey){
        case (0, $jgJpJ.ProductKey).JIRA_SOFTWARE:
            return `${url}/jira`;
        case (0, $jgJpJ.ProductKey).CONFLUENCE:
            return `${url}/wiki`;
        default:
            return url;
    }
};
const $5f91fa891cf867a6$var$containerCss = null;
const $5f91fa891cf867a6$var$goToExistingWorkspaceLinkCss = null;
const $5f91fa891cf867a6$var$goToExistingWorkspaceMessageCss = null;
const $5f91fa891cf867a6$var$switchAccountSubheader = null;
const $5f91fa891cf867a6$var$contentCss = null;
const $5f91fa891cf867a6$var$createNewWorkspaceMessageCss = null;
const $5f91fa891cf867a6$var$createNewWorkspaceLinkCss = null;
const $5f91fa891cf867a6$var$boxContainerCss = null;
const $5f91fa891cf867a6$var$siteBoxCss = null;
const $5f91fa891cf867a6$var$goToProductButtonCss = null;
const $5f91fa891cf867a6$var$bold = null;
const $5f91fa891cf867a6$var$siteCss = null;
const $5f91fa891cf867a6$var$siteNameCss = null;
const $5f91fa891cf867a6$var$emailCss = null;
const $5f91fa891cf867a6$var$switchAccountLinkCss = null;

});
parcelRegister("hIYuQ", function(module, exports) {
$parcel$export(module.exports, "ExistingUser", function () { return (parcelRequire("fOAR4")).ExistingUser; });
parcelRequire("fOAR4");

});
parcelRegister("fOAR4", function(module, exports) {

$parcel$export(module.exports, "ExistingUser", function () { return $4b6f32c4c2db1836$export$706672462bf25099; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $ajeUJ = parcelRequire("ajeUJ");
const $4b6f32c4c2db1836$export$706672462bf25099 = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $ajeUJ.Content), (0, $7Knp0._)({}, props));

});
parcelRegister("ajeUJ", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $5c194a071654b57f$export$7c6e2c02157bb7d2; });
/* content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6oKbD = parcelRequire("6oKbD");

var $9iWJ8 = parcelRequire("9iWJ8");

var $hFZ05 = parcelRequire("hFZ05");
parcelRequire("8HNBH");
var $gNKPy = parcelRequire("gNKPy");
var $hXsC1 = parcelRequire("hXsC1");
var $bI30y = parcelRequire("bI30y");

var $9yDhn = parcelRequire("9yDhn");

var $dfFLm = parcelRequire("dfFLm");
const $5c194a071654b57f$export$7c6e2c02157bb7d2 = ({ SitePicker: SitePicker = /*#__PURE__*/ (0, $loA2J.jsx)((0, $gNKPy.SitePicker), {}), SiteNameInput: SiteNameInput = /*#__PURE__*/ (0, $loA2J.jsx)((0, $hXsC1.SiteNameInput), {}), SiteToggleButton: SiteToggleButton = /*#__PURE__*/ (0, $loA2J.jsx)((0, $bI30y.SiteToggleButton), {}), SubmitButton: SubmitButton, PrivacyPolicy: PrivacyPolicy = null })=>{
    const { showSitePicker: showSitePicker, setShowSitePicker: setShowSitePicker, activateSite: activateSite, sites: sites } = (0, $hFZ05.useSiteActivationContext)();
    const sitePickerEnabled = sites.length > 0 && SitePicker && SiteToggleButton; // if the site picker is not enabled, let context know it is not showing
    (0, $iSvIT.useEffect)(()=>{
        if (!sitePickerEnabled && showSitePicker) setShowSitePicker(false);
    }, [
        sitePickerEnabled
    ]);
    const activateSiteWithPrivacyPolicy = ()=>{
        var _document_getElementById;
        const privacyPolicy = ((_document_getElementById = document.getElementById("privacy-policy-text")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.innerHTML) || "";
        activateSite({
            privacyPolicy: privacyPolicy
        });
    };
    if (SubmitButton === undefined) SubmitButton = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dfFLm.ExistingSitesSubmitButton), {
        hasPrivacyPolicy: !!PrivacyPolicy
    });
     // Only show if more than one transaction account, creating a new site, and experiment is enabled
    const gwp8627SignupTransactionSelectorExperiment = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).gwp8627SignupTransactionSelector);
    const showTxaSelector = !showSitePicker && gwp8627SignupTransactionSelectorExperiment && gwp8627SignupTransactionSelectorExperiment.type === "enrolled" && gwp8627SignupTransactionSelectorExperiment.value;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6oKbD.default), {
        onSubmit: activateSiteWithPrivacyPolicy,
        isDisabled: false,
        children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $loA2J.jsxs)("form", (0, $6iHNw._)((0, $7Knp0._)({}, formProps), {
                autoComplete: "off",
                "data-testid": "existing-sites-site-activation",
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _zulp1tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        children: [
                            showSitePicker && sitePickerEnabled ? SitePicker : SiteNameInput,
                            sitePickerEnabled && SiteToggleButton
                        ]
                    }),
                    showTxaSelector && /*#__PURE__*/ (0, $loA2J.jsx)((0, $9yDhn.TransactionAccountSelector), {}),
                    SubmitButton,
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        id: "privacy-policy-text",
                        children: PrivacyPolicy
                    })
                ]
            }))
    });
};
const $5c194a071654b57f$var$containerCss = null;

});
parcelRegister("9yDhn", function(module, exports) {

$parcel$export(module.exports, "TransactionAccountSelector", function () { return $00c83a0f1b31a6b0$export$24b383d12e62d81f; });
/* transaction-account-selector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $adeWn = parcelRequire("adeWn");

var $c9Cls = parcelRequire("c9Cls");

var $iMdoL = parcelRequire("iMdoL");

var $5ohHq = parcelRequire("5ohHq");

var $hFZ05 = parcelRequire("hFZ05");
parcelRequire("8HNBH");
var $511ro = parcelRequire("511ro");
const $00c83a0f1b31a6b0$var$container = null;
const $00c83a0f1b31a6b0$export$24b383d12e62d81f = ()=>{
    const { transactionAccounts: transactionAccounts } = (0, $iMdoL.useUserContext)();
    const { isSubmitting: isSubmitting, selectedTransactionAccountId: selectedTransactionAccountId, setSelectedTransactionAccountId: setSelectedTransactionAccountId } = (0, $hFZ05.useSiteActivationContext)();
    const handleSelectionChange = (value)=>{
        if (value) setSelectedTransactionAccountId(value.value);
    };
    const selectedValue = transactionAccounts.find((account)=>account.id === selectedTransactionAccountId);
    const transactionAccountLabel = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "siteActivation.transactionAccountSelectorLabel",
        defaultMessage: "Billing Account"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "transaction-account-select-container",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulpyh40"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $adeWn.Label), {
                htmlFor: "transaction-account-select",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $511ro.Label), {
                    children: transactionAccountLabel
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $c9Cls.default), {
                inputId: "transaction-account-select",
                options: transactionAccounts.map((transactionAccount)=>({
                        label: transactionAccount.number,
                        value: transactionAccount.id
                    })),
                value: selectedValue ? {
                    label: selectedValue.number,
                    value: selectedValue.id
                } : null,
                onChange: handleSelectionChange,
                isDisabled: isSubmitting,
                isRequired: true,
                styles: {
                    control: (rest)=>(0, $6iHNw._)((0, $7Knp0._)({}, rest), {
                            borderRadius: "21px",
                            fontFamily: (0, $5ohHq.wacToken)("font.charlie.text"),
                            fontSize: "1rem",
                            padding: "0px 6px"
                        })
                }
            })
        ]
    });
};

});

parcelRegister("dfFLm", function(module, exports) {

$parcel$export(module.exports, "ExistingSitesSubmitButton", function () { return $1cc441750aaeac1c$export$795867072991ebfa; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $fsv0y = parcelRequire("fsv0y");
const $1cc441750aaeac1c$export$795867072991ebfa = ({ hasPrivacyPolicy: hasPrivacyPolicy = false })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const submitMessage = hasPrivacyPolicy ? formatMessage({
        id: "siteActivation.nameSite.agreeButton",
        defaultMessage: "Agree and start now"
    }) : formatMessage({
        id: "siteActivation.nameSiteNewUser.continueButton",
        defaultMessage: "Continue"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fsv0y.SubmitButton), {
        submitMessage: submitMessage
    });
};

});
parcelRegister("fsv0y", function(module, exports) {

$parcel$export(module.exports, "SubmitButton", function () { return $4a5e74e197d41ade$export$8b7b7cdfb85d78c5; });
/* submit-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $91nJf = parcelRequire("91nJf");

var $hFZ05 = parcelRequire("hFZ05");
const $4a5e74e197d41ade$export$8b7b7cdfb85d78c5 = ({ submitMessage: submitMessage })=>{
    const { isSubmitting: isSubmitting, hasSubmitted: hasSubmitted } = (0, $hFZ05.useSiteActivationContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_14hp1osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
            isDisabled: isSubmitting || hasSubmitted,
            isLoading: isSubmitting || hasSubmitted,
            type: "submit",
            dataEventProps: {
                "data-product-key": "jira",
                "data-event": "clicked",
                "data-event-component": "linkButton",
                "data-event-container": "siteName",
                "data-label": "continue-or-agree",
                "data-label-english": submitMessage,
                "data-track-event": "jira-site-name.site-name-form.atlas-66195.site-name"
            },
            children: submitMessage
        })
    });
};
const $4a5e74e197d41ade$var$buttonStyles = null;

});






parcelRegister("hXsC1", function(module, exports) {

$parcel$export(module.exports, "SiteNameInput", function () { return $2de8f145ecfa9aee$export$42a3d109cf521241; });
/* site-name-input.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $26kkA = parcelRequire("26kkA");

var $7OGW4 = parcelRequire("7OGW4");

var $dwSjs = parcelRequire("dwSjs");

var $jgJpJ = parcelRequire("jgJpJ");

var $5ohHq = parcelRequire("5ohHq");

var $hSQrG = parcelRequire("hSQrG");

var $hFZ05 = parcelRequire("hFZ05");

var $fBroD = parcelRequire("fBroD");

var $aw7DU = parcelRequire("aw7DU");

var $511ro = parcelRequire("511ro");
const $2de8f145ecfa9aee$export$42a3d109cf521241 = ({ inputLabel: inputLabel })=>{
    (0, $hSQrG.useRecommendedSiteName)({
        onError: console.error
    }); // onError catches errors from endpoint
    const { siteName: siteName, setSiteNameValue: setSiteNameValue, isSubmitting: isSubmitting, validationMessageState: [validationMessage, setValidationMessage], isValid: isValid, isValidating: isValidating, error: error, isWorkspaceProduct: isWorkspaceProduct } = (0, $hFZ05.useSiteActivationContext)();
    const siteNameAddressSuffix = (0, $jgJpJ.isProduction)() ? ".atlassian.net" : ".jira-dev.com";
    (0, $iSvIT.useEffect)(()=>{
        switch(error){
            case (0, $dwSjs.ErrorType).NO_ERROR:
                setValidationMessage(undefined);
                break;
            case (0, $dwSjs.ErrorType).INVALID_NAME:
                setValidationMessage((0, $fBroD.messages).invalidName);
                break;
            case (0, $dwSjs.ErrorType).MAXIMUM_LENGTH:
                setValidationMessage((0, $fBroD.messages).maxLength);
                break;
            case (0, $dwSjs.ErrorType).UNAVAILABLE:
                setValidationMessage((0, $fBroD.messages).unavailable);
                break;
            case (0, $dwSjs.ErrorType).NETWORK_ERROR:
                setValidationMessage((0, $fBroD.messages).networkError);
                break;
        }
    }, [
        error,
        setValidationMessage
    ]);
    const label = (inputLabel !== null && inputLabel !== void 0 ? inputLabel : isWorkspaceProduct) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "siteActivation.yourWorkspace",
        defaultMessage: "Your workspace"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "accountActivation.nameSite.inputSiteNameLabel",
        defaultMessage: "Your site"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": "adg4-site-name-input",
        className: (0, $esG4f.default)([
            "_pqyq183y _84yz183y _62vcmccc _9fwgmccc _mo2i1hlo _1451bzd7 _lsdidlk8 _1ilx1nn1 _lonvgktf"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_8xzq121t _1rwq121t _r64ckb7n _1ljbkb7n _17eaf1ug _1heubzd7 _125x1j6v _5hv91wug _1d6jidpf _1mmsglyw"
            ]),
            style: {
                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
            },
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $26kkA.default), {
                "aria-required": true,
                isDisabled: isSubmitting,
                name: "site-name",
                label: /*#__PURE__*/ (0, $loA2J.jsx)((0, $511ro.Label), {
                    children: label
                }),
                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            isValid && "_1lo6qn1y",
                            validationMessage !== undefined && "_1lo61wfy"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OGW4.default), (0, $6iHNw._)((0, $7Knp0._)({
                                type: "text",
                                autoComplete: "on",
                                testId: "site-name-input"
                            }, fieldProps), {
                                value: siteName,
                                onChange: (e)=>{
                                    setSiteNameValue(e.currentTarget.value);
                                    fieldProps.onChange(e);
                                },
                                "aria-describedby": validationMessage ? "site-name-error" : undefined,
                                elemAfterInput: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: (0, $esG4f.default)([
                                        "_4cvr1h6o _syaztqnc _1e0c1txw _1wyb1j6v _k48p1nn1 _1bahesu3 _y4tiftgi _1bsb1wug"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                            className: (0, $esG4f.default)([
                                                "_bfhku67f _1wyb8oy7 _y4tiftgi _o5721q9c"
                                            ]),
                                            style: {
                                                "--_djwknj": (0, $43MIc.default)((0, $jgJpJ.fontSize).sm)
                                            },
                                            children: siteNameAddressSuffix
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $aw7DU.IsValidOrLoading), {
                                            isValidating: isValidating,
                                            siteNameValue: siteName,
                                            validationMessage: validationMessage
                                        })
                                    ]
                                })
                            })),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                id: "site-name-error",
                                role: "alert",
                                className: (0, $esG4f.default)([
                                    "_syaz1tmw _1wyboqnp _43ds17la _59381r31 _yha28stv _1nmznqa1",
                                    validationMessage && "_1pfhi2wt"
                                ]),
                                style: {
                                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                                },
                                children: validationMessage && /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, validationMessage))
                            })
                        ]
                    })
            })
        })
    });
};
const $2de8f145ecfa9aee$var$inputInvalidCss = null;
const $2de8f145ecfa9aee$var$inputValidCss = null;
const $2de8f145ecfa9aee$var$fieldWrapperCss = null;
const $2de8f145ecfa9aee$var$siteNameAfterLabelCss = null;
const $2de8f145ecfa9aee$var$siteNameAfterCss = null;
const $2de8f145ecfa9aee$var$siteNameErrorCss = null;
const $2de8f145ecfa9aee$var$siteNameErrorVisibleCss = null;
const $2de8f145ecfa9aee$var$inputAndLabelStyles = null;

});
parcelRegister("511ro", function(module, exports) {

$parcel$export(module.exports, "Label", function () { return $3ea5cc307a19c6ef$export$b04be29aa201d4f5; });
/* label.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");
const $3ea5cc307a19c6ef$var$labelCss = null;
const $3ea5cc307a19c6ef$export$b04be29aa201d4f5 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        className: (0, $esG4f.default)([
            "_ect4bzd7 _1wybdlk8 _k48p4jg8 _vwz4gktf"
        ]),
        style: {
            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
        },
        children: children
    });
};

});


parcelRegister("gNKPy", function(module, exports) {

$parcel$export(module.exports, "SitePicker", function () { return $41d6367d1432a1f8$export$7793ee10ee71ac54; });
/* site-picker.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $26kkA = parcelRequire("26kkA");

var $7OGW4 = parcelRequire("7OGW4");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("biQJa");
var $hFZ05 = parcelRequire("hFZ05");
parcelRequire("8HNBH");
var $511ro = parcelRequire("511ro");
var $jqbIe = parcelRequire("jqbIe");
const $41d6367d1432a1f8$export$7793ee10ee71ac54 = ()=>{
    var _sites_;
    const { sites: sites, isWorkspaceProduct: isWorkspaceProduct } = (0, $hFZ05.useSiteActivationContext)();
    const label = /*#__PURE__*/ (0, $loA2J.jsx)((0, $511ro.Label), {
        children: isWorkspaceProduct ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "siteActivation.yourWorkspace",
            defaultMessage: "Your workspace"
        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "siteActivation.siteNameSitePickerLabel",
            defaultMessage: "Your site"
        })
    });
    if (sites.length === 1) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1mmsglyw _11ur183y _1rys1rga _a5o8xv17 _1tgt1kw7 _1cgv7vkz _1b7z1nn1 _jxt4bzd7 _1f3hi2wt _nrq3ftgi _1npwi2wt _aszr7vkz"
        ]),
        style: {
            "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100")),
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400")),
            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $26kkA.default), {
            "aria-required": true,
            isRequired: true,
            isDisabled: true,
            name: "site-picker-field",
            id: "site-picker-field",
            testId: "site-picker-field",
            label: label,
            defaultValue: (_sites_ = sites[0]) === null || _sites_ === void 0 ? void 0 : _sites_.url.replace("https://", ""),
            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $7OGW4.default), (0, $7Knp0._)({}, fieldProps))
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jqbIe.Dropdown), {
        sites: sites
    });
};
const $41d6367d1432a1f8$var$inputCss = null;

});

parcelRegister("bI30y", function(module, exports) {

$parcel$export(module.exports, "SiteToggleButton", function () { return $8624e3cd529e56de$export$3bfd0ee4a8c5295a; });
/* site-toggle-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $6IiXU = parcelRequire("6IiXU");

var $jgJpJ = parcelRequire("jgJpJ");

var $hFZ05 = parcelRequire("hFZ05");
const $8624e3cd529e56de$export$3bfd0ee4a8c5295a = ()=>{
    const intl = (0, $f6qj2.default)();
    const { isWorkspaceProduct: isWorkspaceProduct, showSitePicker: showSitePicker, setShowSitePicker: setShowSitePicker } = (0, $hFZ05.useSiteActivationContext)();
    const toggleYourSiteButtonText = showSitePicker ? isWorkspaceProduct ? intl.formatMessage({
        id: "siteActivation.nameSite.startNewWorkspaceButton",
        defaultMessage: "Start a new workspace"
    }) : intl.formatMessage({
        id: "siteActivation.nameSite.startNewSiteButton",
        defaultMessage: "Start a new site"
    }) : isWorkspaceProduct ? intl.formatMessage({
        id: "siteActivation.nameSite.useExistingWorkspaceButton",
        defaultMessage: "Use an existing workspace"
    }) : intl.formatMessage({
        id: "siteActivation.nameSite.useExistingSiteButton",
        defaultMessage: "Use an existing site"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
        appearance: "link",
        onClick: ()=>setShowSitePicker(!showSitePicker),
        className: (0, $esG4f.default)([
            "_18zrgrf3"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
            className: (0, $esG4f.default)([
                "_4cvr1h6o _1e0c1txw _1wyb8oy7 _zulp1y44 _syazrbzz"
            ]),
            style: {
                "--_djwknj": (0, $43MIc.default)((0, $jgJpJ.fontSize).sm)
            },
            children: [
                toggleYourSiteButtonText,
                /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                    "aria-hidden": true,
                    fill: "currentColor",
                    height: "8",
                    width: "12",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m7.908 0-1.08 1.202 1.75 1.948H1.264C.842 3.15.5 3.53.5 4c0 .469.342.85.763.85H8.58l-1.75 1.948L7.907 8 11.5 4 7.908 0Z"
                    })
                })
            ]
        })
    });
};
const $8624e3cd529e56de$var$buttonCss = null;
const $8624e3cd529e56de$var$buttonInnerCss = null;

});


parcelRegister("eQore", function(module, exports) {
$parcel$export(module.exports, "ManagedUser", function () { return (parcelRequire("h0Hfa")).ManagedUser; });
parcelRequire("h0Hfa");

});
parcelRegister("h0Hfa", function(module, exports) {

$parcel$export(module.exports, "ManagedUser", function () { return $b944039ed1bd1919$export$fcb76302df2c072d; });
/* managed-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $iMdoL = parcelRequire("iMdoL");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("hIYuQ");
var $fOAR4 = parcelRequire("fOAR4");

var $8ZEkt = parcelRequire("8ZEkt");
const $b944039ed1bd1919$export$fcb76302df2c072d = ()=>{
    var _profile_attributes_managingOrg, _profile_attributes;
    const [showSiteNaming, setShowSiteNaming] = (0, $iSvIT.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const sites = (0, $iMdoL.useManagingOrgUserSites)();
    const { profile: profile, product: product } = (0, $iMdoL.useUserContext)();
    const orgId = profile === null || profile === void 0 ? void 0 : (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : (_profile_attributes_managingOrg = _profile_attributes.managingOrg) === null || _profile_attributes_managingOrg === void 0 ? void 0 : _profile_attributes_managingOrg.orgId;
    const clickGoToExistingWorkspace = ()=>{
        setShowSiteNaming(false);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "guardGoToReturnToProductScreen",
            attributes: {
                orgId: orgId,
                productName: product === null || product === void 0 ? void 0 : product.name
            }
        }).fire();
    };
    const goToExistingWorkspaceMessageValues = {
        link: (str)=>$b944039ed1bd1919$var$goToExistingWorkspace(str, clickGoToExistingWorkspace)
    };
    const goToExistingWorkspaceMessage = formatMessage({
        id: "bxpSignup.companyExpand.cobrandedReturnToJoinSites",
        defaultMessage: "or <link>join an existing site</link>"
    }, goToExistingWorkspaceMessageValues);
    const clickGoToSiteNamingScreen = ()=>{
        setShowSiteNaming(true);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "guardGoToSiteNamingScreen",
            attributes: {
                orgId: orgId,
                productName: product === null || product === void 0 ? void 0 : product.name
            }
        }).fire();
    };
    const goToSiteNamingMessageValues = {
        link: (str)=>$b944039ed1bd1919$var$goToSiteNaming(str, clickGoToSiteNamingScreen)
    };
    const goToSiteNamingMessage = formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedJiraCreateNewWorkspaceLink",
        defaultMessage: "or <link>start a new site</link>"
    }, goToSiteNamingMessageValues);
    return (sites === null || sites === void 0 ? void 0 : sites.length) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "signup-guard-return-to-product",
        group: "treatment",
        metadata: {
            orgId: orgId
        },
        children: showSiteNaming ? /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_ae4v1yb4 _1e0c1txw _2lx21bp4 _16jlkb7n _zulp7vkz _1bah1yb4"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $fOAR4.ExistingUser), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1wybdlk8 _k48pbfng _y3gn1h6o"
                    ]),
                    children: goToExistingWorkspaceMessage
                })
            ]
        }) : /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_ae4v1yb4 _1e0c1txw _2lx21bp4 _16jlkb7n _zulp7vkz _1bah1yb4"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $8ZEkt.SitesList), {
                    sites: sites
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1wybdlk8 _k48pbfng _y3gn1h6o"
                    ]),
                    children: goToSiteNamingMessage
                })
            ]
        })
    }) : null;
};
const $b944039ed1bd1919$var$goToSiteNaming = (str, clickGoToSiteNamingScreen)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
        onClick: clickGoToSiteNamingScreen,
        className: (0, $esG4f.default)([
            "_bfhkmzrp _19itgrf3 _2rkogrf3 _syaz17la _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
        },
        children: str
    });
const $b944039ed1bd1919$var$goToExistingWorkspace = (str, clickGoToExistingWorkspace)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
        onClick: clickGoToExistingWorkspace,
        className: (0, $esG4f.default)([
            "_bfhkmzrp _19itgrf3 _2rkogrf3 _syaz17la _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
        },
        children: str
    });
const $b944039ed1bd1919$var$containerCss = null;
const $b944039ed1bd1919$var$goToLinkCss = null;
const $b944039ed1bd1919$var$goToMessageCss = null;

});
parcelRegister("8ZEkt", function(module, exports) {

$parcel$export(module.exports, "SitesList", function () { return $66bcb8a798700f34$export$e2789664959efdd3; });
/* sites-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
const $66bcb8a798700f34$export$e2789664959efdd3 = ({ sites: sites })=>{
    var _profile_attributes_managingOrg, _profile_attributes;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { profile: profile, product: product, user: { email: email } } = (0, $iMdoL.useUserContext)();
    const orgId = (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : (_profile_attributes_managingOrg = _profile_attributes.managingOrg) === null || _profile_attributes_managingOrg === void 0 ? void 0 : _profile_attributes_managingOrg.orgId;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _zulp7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wybdlk8 _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.2",
                    defaultMessage: "You\u2019re logged in as {email}. <switchAccountLink>Switch account</switchAccountLink>",
                    values: {
                        email: /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                            className: (0, $esG4f.default)([
                                "_k48pni7l _ct361wug _1i4q1hna _1nmz1hna _slp31hna"
                            ]),
                            children: email
                        }),
                        switchAccountLink: $66bcb8a798700f34$var$switchAccountLink
                    }
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4cvr1h6o _1e0c11p5 _1bsb1osq _1jc21k1x _1mbp1wug"
                ]),
                children: sites.map(({ displayName: displayName, url: url })=>/*#__PURE__*/ (0, $loA2J.jsxs)("a", {
                        href: $66bcb8a798700f34$var$getIdentityUrl({
                            url: url,
                            productKey: product === null || product === void 0 ? void 0 : product.key
                        }),
                        onClick: (e)=>{
                            e.preventDefault(); // wait for event to fire
                            createAnalyticsEvent({
                                eventType: "ui",
                                action: "clicked",
                                actionSubject: "button",
                                actionSubjectId: "guardClickReturnToProductButton",
                                attributes: {
                                    orgId: orgId,
                                    productName: product === null || product === void 0 ? void 0 : product.name
                                }
                            }).fire();
                            window.location.href = $66bcb8a798700f34$var$getIdentityUrl({
                                url: url,
                                productKey: product === null || product === void 0 ? void 0 : product.key
                            });
                        },
                        className: (0, $esG4f.default)([
                            "_4cvr1h6o _179rzgxb _1e0c11p5 _zulp1y44 _yv0e9sye _1bah1yb4 _ca0q7vkz _u5f3ftgi _n3td7vkz _19bvftgi _1bsb1osq _9oik1snc _1bnxagmp _jf4cvv82 _8gg5glyw"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1wyb1syg"
                                ]),
                                style: {
                                    "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
                                },
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        className: (0, $esG4f.default)([
                                            "_k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: product === null || product === void 0 ? void 0 : product.name
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_syaz131l _1reo15vq _18m915vq _1bto1l2s _o5721q9c _1wybdlk8"
                                        ]),
                                        children: displayName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_p12f13i4 _1e0c1txw _1bahesu3"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
                                    variant: "secondary",
                                    size: "small",
                                    color: "black",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "bxpSignup.siteExpansion.goToProduct",
                                        defaultMessage: "Go to {productName}",
                                        values: {
                                            productName: product === null || product === void 0 ? void 0 : product.description
                                        }
                                    })
                                })
                            })
                        ]
                    }, url))
            })
        ]
    });
};
const $66bcb8a798700f34$var$switchAccountLink = (children)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
        href: (0, $jgJpJ.getSwitchAccountUrl)(),
        className: (0, $esG4f.default)([
            "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz17la _o5721q9c _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
        },
        children: children
    });
const $66bcb8a798700f34$var$getIdentityUrl = ({ url: url, productKey: productKey })=>{
    switch(productKey){
        case (0, $jgJpJ.ProductKey).JIRA_SOFTWARE:
            return `${(0, $jgJpJ.getIdentityBaseUrl)()}/login?${new URLSearchParams({
                continue: `${url}/jira`,
                application: "jira"
            })}`;
        case (0, $jgJpJ.ProductKey).CONFLUENCE:
            return `${(0, $jgJpJ.getIdentityBaseUrl)()}/login?${new URLSearchParams({
                continue: `${url}/wiki`,
                application: "confluence"
            })}`;
        case (0, $jgJpJ.ProductKey).DEVAI:
            return `${(0, $jgJpJ.getIdentityBaseUrl)()}/login?${new URLSearchParams({
                continue: `${url}/rovodev`,
                application: "devai"
            })}`;
        default:
            return url;
    }
};
const $66bcb8a798700f34$var$containerCss = null;
const $66bcb8a798700f34$var$switchAccountSubheader = null;
const $66bcb8a798700f34$var$sitesListCss = null;
const $66bcb8a798700f34$var$siteBoxCss = null;
const $66bcb8a798700f34$var$productNameCss = null;
const $66bcb8a798700f34$var$siteCss = null;
const $66bcb8a798700f34$var$siteNameCss = null;
const $66bcb8a798700f34$var$goToSiteButtonContainerCss = null;
const $66bcb8a798700f34$var$emailCss = null;
const $66bcb8a798700f34$var$switchAccountLinkCss = null;

});



parcelRegister("cpLkq", function(module, exports) {
$parcel$export(module.exports, "NewUser", function () { return (parcelRequire("lXpJc")).NewUser; });
parcelRequire("lXpJc");

});
parcelRegister("lXpJc", function(module, exports) {

$parcel$export(module.exports, "NewUser", function () { return $87cbd8392ad36d29$export$17cbb676e2e98676; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $448Ia = parcelRequire("448Ia");
const $87cbd8392ad36d29$export$17cbb676e2e98676 = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $448Ia.Content), (0, $7Knp0._)({}, props));

});
parcelRegister("448Ia", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $b728d3cf0b016f5d$export$7c6e2c02157bb7d2; });
/* content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6oKbD = parcelRequire("6oKbD");

var $hFZ05 = parcelRequire("hFZ05");

var $hXsC1 = parcelRequire("hXsC1");

var $4zAGe = parcelRequire("4zAGe");

var $dJ9cc = parcelRequire("dJ9cc");
const $b728d3cf0b016f5d$export$7c6e2c02157bb7d2 = ({ SiteNameInput: SiteNameInput = /*#__PURE__*/ (0, $loA2J.jsx)((0, $hXsC1.SiteNameInput), {}), HelperText: HelperText = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4zAGe.HelperText), {}), SubmitButton: SubmitButton, PrivacyPolicy: PrivacyPolicy = null })=>{
    const { activateSite: activateSite } = (0, $hFZ05.useSiteActivationContext)();
    const activateSiteWithPrivacyPolicy = ()=>{
        var _document_getElementById;
        const privacyPolicy = ((_document_getElementById = document.getElementById("privacy-policy-text")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.innerHTML) || "";
        activateSite({
            privacyPolicy: privacyPolicy
        });
    };
    if (SubmitButton === undefined) SubmitButton = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJ9cc.NewUserSubmitButton), {
        hasPrivacyPolicy: !!PrivacyPolicy
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6oKbD.default), {
        onSubmit: activateSiteWithPrivacyPolicy,
        isDisabled: false,
        children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $loA2J.jsxs)("form", (0, $6iHNw._)((0, $7Knp0._)({}, formProps), {
                autoComplete: "off",
                "data-testid": "new-user-site-activation",
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _zulp1tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        children: [
                            SiteNameInput,
                            HelperText
                        ]
                    }),
                    SubmitButton,
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        id: "privacy-policy-text",
                        children: PrivacyPolicy
                    })
                ]
            }))
    });
};
const $b728d3cf0b016f5d$var$containerCss = null;

});
parcelRegister("4zAGe", function(module, exports) {

$parcel$export(module.exports, "HelperText", function () { return $bf555ed982d4096e$export$7bc3de131d90901c; });
/* helper-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $gAJUc = parcelRequire("gAJUc");
parcelRequire("biQJa");
var $hFZ05 = parcelRequire("hFZ05");
const $bf555ed982d4096e$export$7bc3de131d90901c = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const { isWorkspaceProduct: isWorkspaceProduct } = (0, $hFZ05.useSiteActivationContext)();
    const workspaceTextEnabled = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).cfind4773WorkspaceHelperText);
    const text = isWorkspaceProduct && workspaceTextEnabled ? formatMessage({
        id: "siteActivation.nameSite.inputWorkspaceNameHelperText",
        defaultMessage: "This workspace name is just a suggestion. Feel free to change to something your team will recognize."
    }) : formatMessage({
        id: "siteActivation.nameSite.inputSiteNameHelperText",
        defaultMessage: "This site name is just a suggestion. Feel free to change to something your team will recognize."
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("p", {
        className: (0, $esG4f.default)([
            "_syazalr3 _1wyboqnp _vwz4bs82 _19pk1kwk _2hwxidpf _otyridpf _18u0idpf"
        ]),
        children: text
    });
};
const $bf555ed982d4096e$var$helperTextCss = null;

});

parcelRegister("dJ9cc", function(module, exports) {

$parcel$export(module.exports, "NewUserSubmitButton", function () { return $a3f870106a879a49$export$f05369598c89e38f; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $fsv0y = parcelRequire("fsv0y");
const $a3f870106a879a49$export$f05369598c89e38f = ({ hasPrivacyPolicy: hasPrivacyPolicy = false })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const submitMessage = hasPrivacyPolicy ? formatMessage({
        id: "siteActivation.nameSite.agreeButton",
        defaultMessage: "Agree and start now"
    }) : formatMessage({
        id: "siteActivation.nameSiteNewUser.continueButton",
        defaultMessage: "Continue"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fsv0y.SubmitButton), {
        submitMessage: submitMessage
    });
};

});




parcelRegister("6ZAeC", function(module, exports) {
$parcel$export(module.exports, "WeekOneUser", function () { return (parcelRequire("9aW3V")).WeekOneUser; });
parcelRequire("9aW3V");

});
parcelRegister("9aW3V", function(module, exports) {

$parcel$export(module.exports, "WeekOneUser", function () { return $8640fa6c758a5637$export$16be3dbbc731576d; });
/* week-one-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $91nJf = parcelRequire("91nJf");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("hIYuQ");
var $fOAR4 = parcelRequire("fOAR4");
parcelRequire("eLaKk");
var $jOry7 = parcelRequire("jOry7");
const $8640fa6c758a5637$export$16be3dbbc731576d = ()=>{
    const createNewWorkspace = (0, $iSvIT.useMemo)(()=>{
        if (typeof window === "undefined") return false;
        const queryParams = new URLSearchParams(window.location.search);
        return queryParams.get("createNew") === "true";
    }, []);
    const [showSiteNaming, setShowSiteNaming] = (0, $iSvIT.useState)(createNewWorkspace);
    const { product: product } = (0, $iMdoL.useUserContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const intl = (0, $f6qj2.default)();
    const clickReturnToExistingWorkspace = ()=>{
        setShowSiteNaming(false);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "contactExpandGoToReturnToProductScreen",
            attributes: {
                productName: product === null || product === void 0 ? void 0 : product.name
            }
        }).fire();
    };
    const goToExistingWorkspaceMessageValues = {
        link: (str)=>$8640fa6c758a5637$var$link(str, clickReturnToExistingWorkspace)
    };
    const goToExistingWorkspaceMessage = (product === null || product === void 0 ? void 0 : product.key) === (0, $jgJpJ.ProductKey).CONFLUENCE ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedGoToExistingWorkspace",
        defaultMessage: "or <link>visit an existing workspace</link>"
    }, goToExistingWorkspaceMessageValues) : intl.formatMessage({
        id: "bxpSignup.companyExpand.cobrandedReturnToJoinSites",
        defaultMessage: "or <link>join an existing site</link>"
    }, goToExistingWorkspaceMessageValues);
    return showSiteNaming ? /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $fOAR4.ExistingUser), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: goToExistingWorkspaceMessage
            })
        ]
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $jOry7.ReturnToExistingProduct), {
        productKeyForExpand: (product === null || product === void 0 ? void 0 : product.key) || (0, $jgJpJ.ProductKey).JIRA_SOFTWARE,
        exitView: ()=>{
            setShowSiteNaming(true);
            createAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "contactExpandGoToSiteNamingScreen",
                attributes: {
                    productName: product === null || product === void 0 ? void 0 : product.name
                }
            }).fire();
        }
    });
};
const $8640fa6c758a5637$var$containerCss = null;
const $8640fa6c758a5637$var$goToExistingWorkspaceLinkCss = null;
const $8640fa6c758a5637$var$goToExistingWorkspaceMessageCss = null;
const $8640fa6c758a5637$var$link = (str, clickReturnToExistingWorkspace)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
        onClick: clickReturnToExistingWorkspace,
        className: (0, $esG4f.default)([
            "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l3l3k2"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
        },
        children: str
    });

});
parcelRegister("eLaKk", function(module, exports) {
$parcel$export(module.exports, "ReturnToExistingProduct", function () { return (parcelRequire("jOry7")).ReturnToExistingProduct; });
parcelRequire("jOry7");

});
parcelRegister("jOry7", function(module, exports) {

$parcel$export(module.exports, "ReturnToExistingProduct", function () { return $68b65d8ffbf43d63$export$ba7c22a9ce02f49f; });
/* return-to-existing-product.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $91nJf = parcelRequire("91nJf");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $5ohHq = parcelRequire("5ohHq");
const $68b65d8ffbf43d63$export$ba7c22a9ce02f49f = ({ exitView: exitView, productKeyForExpand: productKeyForExpand })=>{
    const d0to6JiraSite = (0, $iMdoL.useProductD0to6Site)({
        productKey: productKeyForExpand
    });
    const { product: product } = (0, $iMdoL.useUserContext)();
    const { user: { email: email } } = (0, $iMdoL.useUserContext)();
    const { productName: productName } = (0, $jgJpJ.getProductData)(product === null || product === void 0 ? void 0 : product.key);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const intl = (0, $f6qj2.default)();
    const goToProductButtonText = productKeyForExpand === (0, $jgJpJ.ProductKey).CONFLUENCE ? intl.formatMessage({
        id: "bxpSignup.siteExpansion.goToWorkspace",
        defaultMessage: "Go to workspace"
    }) : intl.formatMessage({
        id: "bxpSignup.siteExpansion.goToProduct",
        defaultMessage: "Go to {productName}"
    }, {
        productName: productName
    });
    const createNewWorkspaceMessageValues = {
        link: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                onClick: exitView,
                className: (0, $esG4f.default)([
                    "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
                ]),
                style: {
                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
                    "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
                },
                children: str
            })
    };
    const createNewWorkspaceMessage = productKeyForExpand === (0, $jgJpJ.ProductKey).CONFLUENCE ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedConfluenceCreateNewWorkspaceLink",
        defaultMessage: "or <link>create a new workspace</link>"
    }, createNewWorkspaceMessageValues) : intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedJiraCreateNewWorkspaceLink",
        defaultMessage: "or <link>start a new site</link>"
    }, createNewWorkspaceMessageValues);
    var _product_key;
    return !d0to6JiraSite ? null : /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n _zulp7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _zulpzwfg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_ect4bzd7 _1wybdlk8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                        ]),
                        style: {
                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.2",
                            defaultMessage: "You\u2019re logged in as {email}. <switchAccountLink>Switch account</switchAccountLink>",
                            values: {
                                email: /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                                    className: (0, $esG4f.default)([
                                        "_k48pni7l _ct361wug _1i4q1hna _1nmz1hna _slp31hna"
                                    ]),
                                    children: email
                                }),
                                switchAccountLink: $68b65d8ffbf43d63$var$switchAccountLink
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        "data-testid": "return-to-existing-product",
                        className: (0, $esG4f.default)([
                            "_4cvr1h6o _19ityzqy _2rkoftgi _1e0c11p5 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1bsb1osq"
                        ]),
                        style: {
                            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
                            href: $68b65d8ffbf43d63$var$getProductUrl({
                                url: d0to6JiraSite.url,
                                productKey: (_product_key = product === null || product === void 0 ? void 0 : product.key) !== null && _product_key !== void 0 ? _product_key : ""
                            }),
                            onClick: (e)=>{
                                e.preventDefault(); // wait for event to fire
                                createAnalyticsEvent({
                                    eventType: "ui",
                                    action: "clicked",
                                    actionSubject: "button",
                                    actionSubjectId: "contactExpandClickReturnToProductButton",
                                    attributes: {
                                        productName: productName
                                    }
                                }).fire();
                                var _product_key;
                                window.location.href = $68b65d8ffbf43d63$var$getProductUrl({
                                    url: d0to6JiraSite.url,
                                    productKey: (_product_key = product === null || product === void 0 ? void 0 : product.key) !== null && _product_key !== void 0 ? _product_key : ""
                                });
                            },
                            className: (0, $esG4f.default)([
                                "_4cvr1h6o _1e0c1txw _1bah1yb4 _1bsb1osq _9oik1snc _1bnxagmp _jf4cvv82"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1wyb1syg _1reo15vq _18m915vq"
                                    ]),
                                    style: {
                                        "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                            className: (0, $esG4f.default)([
                                                "_k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                            ]),
                                            children: productName
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_syaz1hap _ect4bzd7 _1wybdlk8 _1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                                            ]),
                                            style: {
                                                "--_k3797e": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light700")),
                                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                            },
                                            children: d0to6JiraSite.displayName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                                    variant: "primary",
                                    size: "small",
                                    color: "blue",
                                    children: goToProductButtonText
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: createNewWorkspaceMessage
            })
        ]
    });
};
const $68b65d8ffbf43d63$var$switchAccountLink = (children)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
        href: (0, $jgJpJ.getSwitchAccountUrl)(),
        className: (0, $esG4f.default)([
            "_syaz17la _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
        },
        children: children
    });
const $68b65d8ffbf43d63$var$getProductUrl = ({ url: url, productKey: productKey })=>{
    switch(productKey){
        case (0, $jgJpJ.ProductKey).JIRA_SOFTWARE:
            return `${url}/jira`;
        case (0, $jgJpJ.ProductKey).CONFLUENCE:
            return `${url}/wiki`;
        default:
            return url;
    }
};
const $68b65d8ffbf43d63$var$switchAccountSubheader = null;
const $68b65d8ffbf43d63$var$containerCss = null;
const $68b65d8ffbf43d63$var$contentCss = null;
const $68b65d8ffbf43d63$var$createNewWorkspaceMessageCss = null;
const $68b65d8ffbf43d63$var$createNewWorkspaceLinkCss = null;
const $68b65d8ffbf43d63$var$boxContainerCss = null;
const $68b65d8ffbf43d63$var$siteBoxCss = null;
const $68b65d8ffbf43d63$var$bold = null;
const $68b65d8ffbf43d63$var$siteCss = null;
const $68b65d8ffbf43d63$var$siteNameCss = null;
const $68b65d8ffbf43d63$var$emailCss = null;
const $68b65d8ffbf43d63$var$switchAccountLinkCss = null;

});




parcelRegister("bavlo", function(module, exports) {
$parcel$export(module.exports, "UpgradeEligibleUser", function () { return (parcelRequire("4bUDl")).UpgradeEligibleUser; });
parcelRequire("4bUDl");

});
parcelRegister("4bUDl", function(module, exports) {

$parcel$export(module.exports, "UpgradeEligibleUser", function () { return $8e7faf1a5ddb3ab3$export$31213096ab10a3ce; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $1WTin = parcelRequire("1WTin");
const $8e7faf1a5ddb3ab3$export$31213096ab10a3ce = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1WTin.Content), (0, $7Knp0._)({}, props));

});
parcelRegister("1WTin", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $f566390ee8645ce2$export$7c6e2c02157bb7d2; });
/* content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6oKbD = parcelRequire("6oKbD");

var $hFZ05 = parcelRequire("hFZ05");
parcelRequire("8HNBH");
var $hXsC1 = parcelRequire("hXsC1");
var $gNKPy = parcelRequire("gNKPy");
var $bI30y = parcelRequire("bI30y");

var $11F1Y = parcelRequire("11F1Y");
const $f566390ee8645ce2$export$7c6e2c02157bb7d2 = ({ SiteNameInput: SiteNameInput = /*#__PURE__*/ (0, $loA2J.jsx)((0, $hXsC1.SiteNameInput), {}), SitePicker: SitePicker = /*#__PURE__*/ (0, $loA2J.jsx)((0, $gNKPy.SitePicker), {}), SiteToggleButton: SiteToggleButton = /*#__PURE__*/ (0, $loA2J.jsx)((0, $bI30y.SiteToggleButton), {}), SubmitButton: SubmitButton = /*#__PURE__*/ (0, $loA2J.jsx)((0, $11F1Y.UpgradeEligibleSubmitButton), {}) })=>{
    const { activateSite: activateSite, showSitePicker: showSitePicker } = (0, $hFZ05.useSiteActivationContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6oKbD.default), {
        onSubmit: activateSite,
        isDisabled: false,
        children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $loA2J.jsxs)("form", (0, $6iHNw._)((0, $7Knp0._)({}, formProps), {
                autoComplete: "off",
                "data-testid": "upgrade-eligible-site-activation",
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _zulp1tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        children: [
                            showSitePicker ? SitePicker : SiteNameInput,
                            SiteToggleButton
                        ]
                    }),
                    SubmitButton
                ]
            }))
    });
};
const $f566390ee8645ce2$var$containerCss = null;

});
parcelRegister("11F1Y", function(module, exports) {

$parcel$export(module.exports, "UpgradeEligibleSubmitButton", function () { return $562dcc9badb6c755$export$9143452c910a3be3; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("biQJa");
var $hFZ05 = parcelRequire("hFZ05");

var $fsv0y = parcelRequire("fsv0y");
const $562dcc9badb6c755$export$9143452c910a3be3 = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const { showSitePicker: showSitePicker } = (0, $hFZ05.useSiteActivationContext)();
    const submitMessage = showSitePicker ? formatMessage({
        id: "WacSignupForm.upgradeButtonText",
        defaultMessage: "Upgrade now"
    }) : formatMessage({
        id: "siteActivation.nameSiteNewUser.continueButton",
        defaultMessage: "Continue"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fsv0y.SubmitButton), {
        submitMessage: submitMessage
    });
};

});












parcelRegister("aHxuL", function(module, exports) {
$parcel$export(module.exports, "SiteNameForm", function () { return (parcelRequire("2oRUX")).SiteNameForm; });
parcelRequire("2oRUX");

});
parcelRegister("2oRUX", function(module, exports) {

$parcel$export(module.exports, "SiteNameForm", function () { return $a8dbe5e19137898e$export$1fa728897f20426d; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $bLpA6 = parcelRequire("bLpA6");

var $9O063 = parcelRequire("9O063");

var $iu8Ap = parcelRequire("iu8Ap");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $1MbAx = parcelRequire("1MbAx");

var $lrVTP = parcelRequire("lrVTP");

var $jgJpJ = parcelRequire("jgJpJ");

var $akark = parcelRequire("akark");
parcelRequire("WKdxa");
var $cRAeL = parcelRequire("cRAeL");
parcelRequire("bSrj2");
var $S65DD = parcelRequire("S65DD");

var $l8lyw = parcelRequire("l8lyw");

var $dkKVh = parcelRequire("dkKVh");

var $4TKhr = parcelRequire("4TKhr");

var $9O063 = parcelRequire("9O063");

var $4toHd = parcelRequire("4toHd");
const $a8dbe5e19137898e$export$1fa728897f20426d = ({ isNewUser: isNewUser, hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles, bgColor: bgColor })=>{
    const { productKey: productKey } = (0, $cRAeL.useSignupFormContext)();
    const { pathname: pathname, search: search } = (0, $lrVTP.useLocation)();
    const queryParams = new URLSearchParams(search);
    const hasConfluenceD0to6 = (0, $iMdoL.useConfluenceD0to6)();
    const hasJiraD0to6 = (0, $iMdoL.useJiraD0to6)();
    const userIsManagedByGuardOrgAndHasSites = (0, $iMdoL.useUserIsManagedByGuardOrgAndHasSites)();
    // guard only shows up on the signup page
    const guardReturnToProductEnabled = pathname.endsWith("/try/cloud/signup");
    const shouldShowGuardReturnToProduct = guardReturnToProductEnabled && userIsManagedByGuardOrgAndHasSites;
    const variant = (0, $iSvIT.useMemo)(()=>{
        if (shouldShowGuardReturnToProduct) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $S65DD.GuardReturnToProduct), {});
        if (hasRebrandedSignupFormStyles) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $akark.SignupModuleWrapper), {
            hideFooter: true,
            fullPage: false,
            fullHeight: false,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dkKVh.Adg4SiteNameForm), {
                showSubheader: false,
                isOnDarkBackground: bgColor === "bgWhite" ? false : true
            })
        });
        if (productKey === (0, $jgJpJ.ProductKey).JIRA_SOFTWARE) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.SignupBackgroundLayout), {
            ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bLpA6.JiraLogo), {
                size: "xlarge",
                appearance: "brand"
            }),
            children: hasJiraD0to6 ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
                experimentKey: "jfind-contact-expand-ii",
                group: "Test",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4TKhr.CobrandedContactExpand), {
                    productKeyForExpand: (0, $jgJpJ.ProductKey).JIRA_SOFTWARE
                })
            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dkKVh.Adg4SiteNameForm), {})
        });
        if (productKey === (0, $jgJpJ.ProductKey).CONFLUENCE) {
            // Do not show contact expand if user clicked on a "create new" link
            const createNewWorkspace = queryParams.get("createNew") === "true";
            if (isNewUser) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.SignupBackgroundLayout), {
                ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9O063.CobrandedProductLogo), {}),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9O063.ConfluenceNewUserWorkspaceNameForm), {})
            });
            else if (hasConfluenceD0to6) // contact-expand
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
                experimentKey: "cfind-2658_redirect_contact_expand_to_product",
                group: "Test",
                conditions: [
                    !createNewWorkspace
                ],
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.SignupBackgroundLayout), {
                    ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9O063.CobrandedProductLogo), {}),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4TKhr.CobrandedContactExpand), {
                        productKeyForExpand: (0, $jgJpJ.ProductKey).CONFLUENCE
                    })
                })
            });
            else // existing-user or crossflow
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.SignupBackgroundLayout), {
                ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9O063.CobrandedProductLogo), {}),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dkKVh.Adg4SiteNameForm), {})
            });
        }
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $akark.SignupModuleWrapper), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $l8lyw.DefaultSiteName), {})
        });
    }, [
        shouldShowGuardReturnToProduct,
        hasJiraD0to6,
        hasRebrandedSignupFormStyles,
        productKey,
        isNewUser,
        hasConfluenceD0to6,
        bgColor
    ]);
    (0, $iSvIT.useEffect)(()=>{
        const customData = {
            webPlatform: "bxp-ui",
            reactComponent: "SiteNameForm",
            isLoggedIn: true
        };
        (0, $jgJpJ.ufoEventTryCloudSignupPageLoad).success({
            customData: customData
        });
    }, []);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4toHd.SiteNameContextProvider), {
        productKey: productKey,
        isNewUser: isNewUser,
        children: variant
    });
};

});
parcelRegister("bSrj2", function(module, exports) {
$parcel$export(module.exports, "GuardReturnToProduct", function () { return (parcelRequire("S65DD")).GuardReturnToProduct; });
parcelRequire("S65DD");

});
parcelRegister("S65DD", function(module, exports) {

$parcel$export(module.exports, "GuardReturnToProduct", function () { return $f7d6ac9df5aedd70$export$ca1f1cdc01d1b736; });
/* guard-return-to-product.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $bLpA6 = parcelRequire("bLpA6");

var $91nJf = parcelRequire("91nJf");

var $iu8Ap = parcelRequire("iu8Ap");

var $jgJpJ = parcelRequire("jgJpJ");

var $11sdu = parcelRequire("11sdu");

var $iMdoL = parcelRequire("iMdoL");

var $5ohHq = parcelRequire("5ohHq");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("WKdxa");
var $cRAeL = parcelRequire("cRAeL");

var $9O063 = parcelRequire("9O063");

var $dkKVh = parcelRequire("dkKVh");

var $gkgE0 = parcelRequire("gkgE0");
const $f7d6ac9df5aedd70$export$ca1f1cdc01d1b736 = ()=>{
    var _profile_attributes_managingOrg, _profile_attributes;
    const [showSiteNaming, setShowSiteNaming] = (0, $iSvIT.useState)(false);
    const { productName: productName, productKey: productKey } = (0, $cRAeL.useSignupFormContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const sites = (0, $iMdoL.useManagingOrgUserSites)();
    const { profile: profile } = (0, $iMdoL.useUserContext)();
    const orgId = profile === null || profile === void 0 ? void 0 : (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : (_profile_attributes_managingOrg = _profile_attributes.managingOrg) === null || _profile_attributes_managingOrg === void 0 ? void 0 : _profile_attributes_managingOrg.orgId;
    const clickGoToExistingWorkspace = ()=>{
        setShowSiteNaming(false);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "guardGoToReturnToProductScreen",
            attributes: {
                orgId: orgId,
                productName: productName
            }
        }).fire();
    };
    const goToExistingWorkspaceMessageValues = {
        link: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                onClick: clickGoToExistingWorkspace,
                className: (0, $esG4f.default)([
                    "_bfhkmzrp _19itgrf3 _2rkogrf3 _syaz17la _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
                ]),
                style: {
                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
                    "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
                },
                children: str
            })
    };
    const goToExistingWorkspaceMessage = formatMessage({
        id: "bxpSignup.companyExpand.cobrandedReturnToJoinSites",
        defaultMessage: "or <link>join an existing site</link>"
    }, goToExistingWorkspaceMessageValues);
    const clickGoToSiteNamingScreen = ()=>{
        setShowSiteNaming(true);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "guardGoToSiteNamingScreen",
            attributes: {
                orgId: orgId,
                productName: productName
            }
        }).fire();
    };
    const goToSiteNamingMessageValues = {
        link: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                onClick: clickGoToSiteNamingScreen,
                className: (0, $esG4f.default)([
                    "_bfhkmzrp _19itgrf3 _2rkogrf3 _syaz17la _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
                ]),
                style: {
                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
                    "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
                },
                children: str
            })
    };
    const goToSiteNamingMessage = formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedJiraCreateNewWorkspaceLink",
        defaultMessage: "or <link>start a new site</link>"
    }, goToSiteNamingMessageValues);
    return (sites === null || sites === void 0 ? void 0 : sites.length) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "signup-guard-return-to-product",
        group: "treatment",
        metadata: {
            orgId: orgId
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.SignupBackgroundLayout), {
            ProductLogo: productKey === (0, $jgJpJ.ProductKey).CONFLUENCE ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $9O063.CobrandedProductLogo), {}) : productKey === (0, $jgJpJ.ProductKey).DEVAI ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $11sdu.RovoDevAgentsLogo), {}) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $bLpA6.JiraLogo), {
                size: "xlarge",
                appearance: "brand"
            }),
            children: showSiteNaming ? /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _1tke1lk4 _zulp7vkz _ae4v1yb4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dkKVh.Adg4SiteNameForm), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1wybdlk8 _k48pbfng _y3gn1h6o"
                        ]),
                        children: goToExistingWorkspaceMessage
                    })
                ]
            }) : /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _1tke1lk4 _zulp7vkz _ae4v1yb4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $gkgE0.SitesList), {
                        sites: sites
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1wybdlk8 _k48pbfng _y3gn1h6o"
                        ]),
                        children: goToSiteNamingMessage
                    })
                ]
            })
        })
    }) : null;
};
const $f7d6ac9df5aedd70$var$containerCss = null;
const $f7d6ac9df5aedd70$var$goToLinkCss = null;
const $f7d6ac9df5aedd70$var$goToMessageCss = null;

});
parcelRegister("dkKVh", function(module, exports) {

$parcel$export(module.exports, "Adg4SiteNameForm", function () { return $f367f9738dc1eb77$export$968b755aaceecde4; });
/* site-name-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $6oKbD = parcelRequire("6oKbD");

var $91nJf = parcelRequire("91nJf");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $5ohHq = parcelRequire("5ohHq");

var $25Gvl = parcelRequire("25Gvl");

var $gDAhb = parcelRequire("gDAhb");

var $4toHd = parcelRequire("4toHd");

var $8lfjs = parcelRequire("8lfjs");
parcelRequire("15W0K");
var $lQzxd = parcelRequire("lQzxd");
const $f367f9738dc1eb77$export$e6873bfe3b33e63d = ({ isOnDarkBackground: isOnDarkBackground = false })=>{
    var _profile_attributes;
    const intl = (0, $f6qj2.default)();
    const { isNewUser: isNewUser, showSitePickerState: [showSitePicker, setShowSitePicker], productData: { productKey: productKey } } = (0, $4toHd.useSiteNameContext)();
    const { profile: profile } = (0, $iMdoL.useUserContext)();
    const [hasAvailableSites, setHasAvailableSites] = (0, $iSvIT.useState)(false);
    let toggleYourSiteButtonText;
    if (productKey === (0, $jgJpJ.ProductKey).CONFLUENCE) toggleYourSiteButtonText = showSitePicker ? intl.formatMessage({
        id: "BxpUiSignup.nameSite.createNewWorkspaceButton",
        defaultMessage: "Create a new workspace"
    }) : intl.formatMessage({
        id: "BxpUiSignup.nameSite.visitExistingWorkspaceButton",
        defaultMessage: "Visit an existing workspace"
    });
    else toggleYourSiteButtonText = showSitePicker ? intl.formatMessage({
        id: "BxpUiSignup.nameSite.startNewSiteButton",
        defaultMessage: "Start a new site"
    }) : intl.formatMessage({
        id: "BxpUiSignup.nameSite.useExistingSiteButton",
        defaultMessage: "Use an existing site"
    });
    (0, $iSvIT.useEffect)(()=>{
        if (!profile.requestInProgress) {
            var _profile_attributes;
            var _profile_attributes_existingSites_filter;
            const filteredAvailableSites = (_profile_attributes_existingSites_filter = (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingSites.filter(({ products: products })=>!products.some((product)=>product.productKey === productKey))) !== null && _profile_attributes_existingSites_filter !== void 0 ? _profile_attributes_existingSites_filter : [];
            setHasAvailableSites(filteredAvailableSites.length > 0);
            setShowSitePicker(filteredAvailableSites.length > 0);
        }
    }, [
        (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingSites,
        profile.requestInProgress,
        productKey,
        setShowSitePicker
    ]);
    return isNewUser ? /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                "data-testid": "adg4-site-name-input",
                className: (0, $esG4f.default)([
                    "_pqyq183y _84yz183y _62vcmccc _9fwgmccc _mo2i1hlo _1451bzd7 _lsdidlk8 _1ilx1nn1 _lonvgktf",
                    isOnDarkBackground && "_mo2i121t"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gDAhb.InputSiteName), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_syaz1hlo _ect4bzd7 _1wyb1crf _vwz4f6fq _k48p1nn1 _19pk1kwk _2hwxidpf _otyridpf _18u0idpf",
                    isOnDarkBackground && "_syaz121t"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "BxpUiSignup.nameSite.inputSiteNameMessage",
                    defaultMessage: "This site name is just a suggestion. Feel free to change to something your team will recognize."
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            showSitePicker ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                "data-testid": "adg4-site-picker",
                className: (0, $esG4f.default)([
                    "_pqyq183y _84yz183y _62vcmccc _9fwgmccc _mo2i1hlo _1451bzd7 _lsdidlk8 _1ilx1nn1 _lonvgktf",
                    isOnDarkBackground && "_mo2i121t"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: productKey === (0, $jgJpJ.ProductKey).CONFLUENCE ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lfjs.WorkspacePickerField), {}) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lfjs.SitePickerField), {})
            }) : /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                "data-testid": "adg4-site-name-input",
                className: (0, $esG4f.default)([
                    "_pqyq183y _84yz183y _62vcmccc _9fwgmccc _mo2i1hlo _1451bzd7 _lsdidlk8 _1ilx1nn1 _lonvgktf",
                    isOnDarkBackground && "_mo2i121t"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: productKey === (0, $jgJpJ.ProductKey).CONFLUENCE ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $gDAhb.InputWorkspaceName), {}) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $gDAhb.InputSiteName), {})
            }),
            hasAvailableSites && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                "data-testid": "adg4-available-sites-button",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gDAhb.ArrowLinkButton), {
                    text: toggleYourSiteButtonText,
                    onClick: ()=>setShowSitePicker(!showSitePicker),
                    isOnDarkBackground: isOnDarkBackground
                })
            })
        ]
    });
};
const $f367f9738dc1eb77$export$968b755aaceecde4 = ({ showSubheader: showSubheader = true, isOnDarkBackground: isOnDarkBackground = false })=>{
    const intl = (0, $f6qj2.default)();
    const { userInfo: { name: name }, isNewUser: isNewUser, isSubmittingState: [isSubmitting], activateSite: activateSite, productData: { productKey: productKey } } = (0, $4toHd.useSiteNameContext)();
    let subHeaderText;
    if (isNewUser) subHeaderText = intl.formatMessage({
        id: "BxpUiSignup.nameSite.cobrandedNewUserSubHeader",
        defaultMessage: "Sites are the shared space where people organize teams, work, and projects."
    });
    else if (productKey === (0, $jgJpJ.ProductKey).CONFLUENCE) subHeaderText = /*#__PURE__*/ (0, $loA2J.jsx)((0, $25Gvl.Jfind1315SubHeading), {
        returnString: true
    });
    else if (productKey === (0, $jgJpJ.ProductKey).DEVAI) subHeaderText = intl.formatMessage({
        id: "BxpUiSignup.nameSite.devAiJoinBetaSubHeader",
        defaultMessage: "Join the free beta program"
    });
    else subHeaderText = intl.formatMessage({
        id: "BxpUiSignup.nameSite.cobrandedSubHeader",
        defaultMessage: "It\u2019s free for up to 10 users - no credit card needed."
    });
    const siteNameAgreeButton = intl.formatMessage({
        id: "BxpUiSignup.nameSite.continueButton",
        defaultMessage: "Continue"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "adg4-site-name-form",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _zulpu2gc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o",
                            isOnDarkBackground && "_syaz121t"
                        ]),
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                        },
                        children: isNewUser ? /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                            className: (0, $esG4f.default)([
                                "_kqswh2mm"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "signupForm.accountCreation.cobrandedLoggedOutHeader",
                                    defaultMessage: `Create a <accentImage>site</accentImage>`,
                                    values: {
                                        accentImage: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
                                                children: text
                                            })
                                    }
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                                    "aria-hidden": "true",
                                    fill: "#FCA700",
                                    viewBox: "0 0 57 52",
                                    className: (0, $esG4f.default)([
                                        "_4t3i1ex1 _152td439 _rjxp1muf _kqswstnw _1bsb1mcy"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M43.9096 31.989C44.2964 32.1979 50.1032 30.4768 48.3209 29.7729C47.7086 29.434 47.1876 29.537 47.0824 30.1563C46.7711 29.0152 45.8277 30.6914 45.2428 30.3744C45.338 29.5426 43.9174 31.4167 44.1295 30.5384C37.6167 30.3944 25.6493 39.724 40.8255 33.2041C39.218 33.0188 40.6554 32.5298 41.3794 32.6287C40.4962 33.7793 43.3258 32.5457 43.8251 32.1261C42.9181 32.2503 44.3277 31.315 43.9065 31.9866L43.9096 31.989Z"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M31.1742 23.4941C32.0038 23.3481 34.8483 17.2583 35.2257 16.6666C35.7963 15.2515 33.8616 15.3637 33.6797 16.5353C33.5454 16.7474 33.1876 18.4271 32.7181 17.7781C31.123 18.3209 31.2287 21.2383 29.8684 21.5744C30.1331 21.9302 29.6966 22.4398 29.8375 22.6819C29.4217 22.6843 29.2562 23.2605 29.3603 23.2987C27.7702 24.9228 30.1396 26.3595 30.8463 24.2051C30.9274 24.2847 31.3634 23.8695 31.1748 23.4996L31.1742 23.4941Z"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M8.6666 15.2222C8.02491 16.2514 7.96222 15.2487 8.28065 14.7497C9.05234 15.52 8.82473 13.5428 8.54045 13.0616C8.52243 13.2717 8.17 13.3446 8.18227 12.9105C9.08124 13.2088 9.17211 7.72002 7.35544 10.3155C7.36042 10.4093 8.06672 10.4491 7.84889 10.5596C6.77715 10.3778 7.53675 11.2383 7.62227 11.4811C7.06702 11.477 7.58662 11.707 7.35778 11.7688C6.60614 11.4733 7.8784 12.8725 7.13341 12.5375C6.01834 13.7974 7.55678 16.2818 6.53876 17.2452C7.79737 17.9053 5.99454 21.9334 8.35492 20.3752C8.8673 18.6393 9.14873 17.2179 8.6666 15.2222Z"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M21.257 4.74268C19.536 4.31212 19.9685 8.08877 19.2823 9.11742C18.2988 10.3626 15.0337 23.7231 18.3519 20.2458C19.306 16.1939 20.7963 13.0387 21.3321 7.97975C21.4791 7.16432 22.4539 4.63025 21.257 4.74268Z"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M37.0965 44.953C36.1393 46.3589 34.6992 44.6262 33.7861 45.783C32.4207 48.0004 45.1215 48.6579 44.6732 46.3948C44.025 44.501 38.0156 45.7761 37.0965 44.953Z"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $lQzxd.WelcomeBackHeading), {
                            name: name
                        })
                    }),
                    showSubheader && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o",
                            isOnDarkBackground && "_syaz121t"
                        ]),
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                        },
                        children: subHeaderText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $6oKbD.default), {
                onSubmit: activateSite,
                isDisabled: false,
                children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $loA2J.jsx)("form", (0, $6iHNw._)((0, $7Knp0._)({}, formProps), {
                        autoComplete: "off",
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_19pk1tcg _2hwxidpf _otyr1tcg _18u0idpf"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)($f367f9738dc1eb77$export$e6873bfe3b33e63d, {
                                        isOnDarkBackground: isOnDarkBackground
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_14hp1osq"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                                        isDisabled: submitting || isSubmitting,
                                        isLoading: submitting || isSubmitting,
                                        type: "submit",
                                        dataEventProps: {
                                            "data-product-key": "jira",
                                            "data-event": "clicked",
                                            "data-event-component": "linkButton",
                                            "data-event-container": "siteName",
                                            "data-label": "continue-or-agree",
                                            "data-label-english": siteNameAgreeButton,
                                            "data-track-event": "jira-site-name.site-name-form.atlas-66195.site-name"
                                        },
                                        color: isOnDarkBackground ? "yellow" : undefined,
                                        children: siteNameAgreeButton
                                    })
                                })
                            ]
                        })
                    }))
            })
        ]
    });
};
const $f367f9738dc1eb77$var$containerCss = null;
const $f367f9738dc1eb77$var$headerGroupCss = null;
const $f367f9738dc1eb77$var$headerCss = null;
const $f367f9738dc1eb77$var$darkBackgroundTextStyles = null;
const $f367f9738dc1eb77$var$formWrapperCss = null;
const $f367f9738dc1eb77$var$suggestionStyles = null;
const $f367f9738dc1eb77$var$buttonStyles = null;
const $f367f9738dc1eb77$var$inputAndLabelStyles = null;
const $f367f9738dc1eb77$var$darkBackgroundInputAndLabelStyles = null;
const $f367f9738dc1eb77$var$accentImageSpanCss = null;
const $f367f9738dc1eb77$var$accentImageCss = null;

});
parcelRegister("15W0K", function(module, exports) {
$parcel$export(module.exports, "WelcomeBackHeading", function () { return (parcelRequire("lQzxd")).WelcomeBackHeading; });
parcelRequire("lQzxd");

});
parcelRegister("lQzxd", function(module, exports) {

$parcel$export(module.exports, "WelcomeBackHeading", function () { return $3de26478ec782459$export$f8a24991e7eb3d8f; });
/* welcome-back-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $jgJpJ = parcelRequire("jgJpJ");
const $3de26478ec782459$export$f8a24991e7eb3d8f = ({ name: name })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "BxpSignup.SiteExpansionForm.cobrandedHeader",
        defaultMessage: "<scribbleSpan>Welcome</scribbleSpan> back, {name}",
        values: {
            name: (0, $jgJpJ.getFirstName)(name),
            scribbleSpan: $3de26478ec782459$var$scribbleSpan
        }
    });
};
const $3de26478ec782459$var$scribbleSpan = (children)=>/*#__PURE__*/ (0, $loA2J.jsxs)("span", {
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                "aria-hidden": true,
                viewBox: "0 0 105 17",
                className: (0, $esG4f.default)([
                    "_lswuh727 _4t3io7ao _u7co1bs0 _1e02idpf _kqswstnw _t9ec1bh4 _1bsb1l8a"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M104.435 9.68613C86.4938 6.51631 73.1262 13.83 55.0489 7.43996C54.1658 10.0608 51.9298 13.3276 48.6487 13.3318C51.3855 13.3082 55.8543 6.49074 51.3954 11.0379C48.7638 14.5108 37.5257 10.0724 46.1409 13.2376C40.1743 12.5113 34.7527 8.16936 30.7652 4.31768C24.1184 -1.18196 29.0775 9.35501 24.148 14.5541C17.1646 21.7785 -3.47552 2.46837 0.735557 2.51293C3.38441 4.93365 6.96197 6.46719 8.41505 9.13148C34.4142 25.1383 15.8926 -4.08831 31.4374 0.975475C56.6666 21.4402 44.0238 3.05288 58.9761 4.49783C67.6031 11.908 104.856 0.972575 104.442 9.68622L104.435 9.68613Z"
                })
            })
        ]
    });
const $3de26478ec782459$var$accentImageCss = null;
const $3de26478ec782459$var$scribbleSpanCss = null;

});



parcelRegister("gkgE0", function(module, exports) {

$parcel$export(module.exports, "SitesList", function () { return $96f13c8e44724a10$export$e2789664959efdd3; });
/* sites-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $91nJf = parcelRequire("91nJf");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("WKdxa");
var $cRAeL = parcelRequire("cRAeL");
parcelRequire("15W0K");
var $lQzxd = parcelRequire("lQzxd");
const $96f13c8e44724a10$export$e2789664959efdd3 = ({ sites: sites })=>{
    var _profile_attributes_managingOrg, _profile_attributes;
    const { productKey: productKey } = (0, $cRAeL.useSignupFormContext)();
    const { productName: productName } = (0, $jgJpJ.getProductData)(productKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { profile: profile, user: { email: email, name: name } } = (0, $iMdoL.useUserContext)();
    const orgId = (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : (_profile_attributes_managingOrg = _profile_attributes.managingOrg) === null || _profile_attributes_managingOrg === void 0 ? void 0 : _profile_attributes_managingOrg.orgId;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c11p5 _zulp1tcg"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _zulpu2gc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lQzxd.WelcomeBackHeading), {
                            name: name
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.1",
                            defaultMessage: "Pick up where you left off in {productName}",
                            values: {
                                productName: productName
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wybdlk8 _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.2",
                    defaultMessage: "You\u2019re logged in as {email}. <switchAccountLink>Switch account</switchAccountLink>",
                    values: {
                        email: /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                            className: (0, $esG4f.default)([
                                "_k48pni7l _ct361wug _1i4q1hna _1nmz1hna _slp31hna"
                            ]),
                            children: email
                        }),
                        switchAccountLink: $96f13c8e44724a10$var$switchAccountLink
                    }
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4cvr1h6o _1e0c11p5 _1bsb1osq _1jc21k1x _1mbp1wug"
                ]),
                children: sites.map(({ displayName: displayName, url: url })=>/*#__PURE__*/ (0, $loA2J.jsxs)("a", {
                        href: $96f13c8e44724a10$var$getIdentityUrl({
                            url: url,
                            productKey: productKey
                        }),
                        onClick: (e)=>{
                            e.preventDefault(); // wait for event to fire
                            createAnalyticsEvent({
                                eventType: "ui",
                                action: "clicked",
                                actionSubject: "button",
                                actionSubjectId: "guardClickReturnToProductButton",
                                attributes: {
                                    orgId: orgId,
                                    productName: productName
                                }
                            }).fire();
                            window.location.href = $96f13c8e44724a10$var$getIdentityUrl({
                                url: url,
                                productKey: productKey
                            });
                        },
                        className: (0, $esG4f.default)([
                            "_4cvr1h6o _179rzgxb _1e0c11p5 _zulp1y44 _yv0e9sye _1bah1yb4 _ca0q7vkz _u5f3ftgi _n3td7vkz _19bvftgi _1bsb1osq _9oik1snc _1bnxagmp _jf4cvv82 _8gg5glyw"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1wyb1syg"
                                ]),
                                style: {
                                    "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
                                },
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        className: (0, $esG4f.default)([
                                            "_k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: productName
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_syaz131l _1reo15vq _18m915vq _1bto1l2s _o5721q9c _1wybdlk8"
                                        ]),
                                        children: displayName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_p12f13i4 _1e0c1txw _1bahesu3"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                                    variant: "secondary",
                                    size: "small",
                                    color: "black",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "bxpSignup.siteExpansion.goToProduct",
                                        defaultMessage: "Go to {productName}",
                                        values: {
                                            productName: productName
                                        }
                                    })
                                })
                            })
                        ]
                    }, url))
            })
        ]
    });
};
const $96f13c8e44724a10$var$switchAccountLink = (children)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
        href: (0, $jgJpJ.getSwitchAccountUrl)(),
        className: (0, $esG4f.default)([
            "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz17la _o5721q9c _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
        },
        children: children
    });
const $96f13c8e44724a10$var$getIdentityUrl = ({ url: url, productKey: productKey })=>{
    switch(productKey){
        case (0, $jgJpJ.ProductKey).JIRA_SOFTWARE:
            return `${(0, $jgJpJ.getIdentityBaseUrl)()}/login?${new URLSearchParams({
                continue: `${url}/jira`,
                application: "jira"
            })}`;
        case (0, $jgJpJ.ProductKey).CONFLUENCE:
            return `${(0, $jgJpJ.getIdentityBaseUrl)()}/login?${new URLSearchParams({
                continue: `${url}/wiki`,
                application: "confluence"
            })}`;
        case (0, $jgJpJ.ProductKey).DEVAI:
            return `${(0, $jgJpJ.getIdentityBaseUrl)()}/login?${new URLSearchParams({
                continue: `${url}/rovodev`,
                application: "devai"
            })}`;
        default:
            return url;
    }
};
const $96f13c8e44724a10$var$containerCss = null;
const $96f13c8e44724a10$var$headerGroupCss = null;
const $96f13c8e44724a10$var$headerCss = null;
const $96f13c8e44724a10$var$switchAccountSubheader = null;
const $96f13c8e44724a10$var$sitesListCss = null;
const $96f13c8e44724a10$var$siteBoxCss = null;
const $96f13c8e44724a10$var$productNameCss = null;
const $96f13c8e44724a10$var$siteCss = null;
const $96f13c8e44724a10$var$siteNameCss = null;
const $96f13c8e44724a10$var$goToSiteButtonContainerCss = null;
const $96f13c8e44724a10$var$emailCss = null;
const $96f13c8e44724a10$var$switchAccountLinkCss = null;

});



parcelRegister("4TKhr", function(module, exports) {

$parcel$export(module.exports, "CobrandedContactExpand", function () { return $61021b7621e86001$export$c02e6a955b961e26; });
/* cobranded-contact-expand.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $91nJf = parcelRequire("91nJf");

var $jgJpJ = parcelRequire("jgJpJ");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("WKdxa");
var $cRAeL = parcelRequire("cRAeL");

var $18EPo = parcelRequire("18EPo");

var $dkKVh = parcelRequire("dkKVh");
const $61021b7621e86001$export$c02e6a955b961e26 = ({ productKeyForExpand: productKeyForExpand })=>{
    const createNewWorkspace = (0, $iSvIT.useMemo)(()=>{
        if (typeof window === "undefined") return false;
        const queryParams = new URLSearchParams(window.location.search);
        return queryParams.get("createNew") === "true";
    }, []);
    const [showSiteNaming, setShowSiteNaming] = (0, $iSvIT.useState)(createNewWorkspace);
    const { productName: productName } = (0, $cRAeL.useSignupFormContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const intl = (0, $f6qj2.default)();
    const clickReturnToExistingWorkspace = ()=>{
        setShowSiteNaming(false);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "contactExpandGoToReturnToProductScreen",
            attributes: {
                productName: productName
            }
        }).fire();
    };
    const goToExistingWorkspaceMessageValues = {
        link: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                onClick: clickReturnToExistingWorkspace,
                className: (0, $esG4f.default)([
                    "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l3l3k2"
                ]),
                style: {
                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                },
                children: str
            })
    };
    const goToExistingWorkspaceMessage = productKeyForExpand === (0, $jgJpJ.ProductKey).CONFLUENCE ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedGoToExistingWorkspace",
        defaultMessage: "or <link>visit an existing workspace</link>"
    }, goToExistingWorkspaceMessageValues) : intl.formatMessage({
        id: "bxpSignup.companyExpand.cobrandedReturnToJoinSites",
        defaultMessage: "or <link>join an existing site</link>"
    }, goToExistingWorkspaceMessageValues);
    return showSiteNaming ? /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c11p5 _1tke1lk4 _ae4v1yb4"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dkKVh.Adg4SiteNameForm), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: goToExistingWorkspaceMessage
            })
        ]
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $18EPo.CobrandedReturnToExistingProduct), {
        productKeyForExpand: productKeyForExpand,
        exitView: ()=>{
            setShowSiteNaming(true);
            createAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "contactExpandGoToSiteNamingScreen",
                attributes: {
                    productName: productName
                }
            }).fire();
        }
    });
};
const $61021b7621e86001$var$containerCss = null;
const $61021b7621e86001$var$goToExistingWorkspaceLinkCss = null;
const $61021b7621e86001$var$goToExistingWorkspaceMessageCss = null;

});
parcelRegister("18EPo", function(module, exports) {

$parcel$export(module.exports, "CobrandedReturnToExistingProduct", function () { return $255f9296a7acccf2$export$1eeead6b5d168927; });
/* cobranded-return-to-existing-product.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $91nJf = parcelRequire("91nJf");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("WKdxa");
var $cRAeL = parcelRequire("cRAeL");
parcelRequire("15W0K");
var $lQzxd = parcelRequire("lQzxd");
const $255f9296a7acccf2$export$1eeead6b5d168927 = ({ exitView: exitView, productKeyForExpand: productKeyForExpand })=>{
    const d0to6JiraSite = (0, $iMdoL.useProductD0to6Site)({
        productKey: productKeyForExpand
    });
    const { productKey: productKey } = (0, $cRAeL.useSignupFormContext)();
    const { user: { email: email, name: name } } = (0, $iMdoL.useUserContext)();
    const { productName: productName } = (0, $jgJpJ.getProductData)(productKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const intl = (0, $f6qj2.default)();
    const goToProductButtonText = productKeyForExpand === (0, $jgJpJ.ProductKey).CONFLUENCE ? intl.formatMessage({
        id: "bxpSignup.siteExpansion.goToWorkspace",
        defaultMessage: "Go to workspace"
    }) : intl.formatMessage({
        id: "bxpSignup.siteExpansion.goToProduct",
        defaultMessage: "Go to {productName}"
    }, {
        productName: productName
    });
    const createNewWorkspaceMessageValues = {
        link: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                onClick: exitView,
                className: (0, $esG4f.default)([
                    "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
                ]),
                style: {
                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
                    "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
                },
                children: str
            })
    };
    const createNewWorkspaceMessage = productKeyForExpand === (0, $jgJpJ.ProductKey).CONFLUENCE ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedConfluenceCreateNewWorkspaceLink",
        defaultMessage: "or <link>create a new workspace</link>"
    }, createNewWorkspaceMessageValues) : intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedJiraCreateNewWorkspaceLink",
        defaultMessage: "or <link>start a new site</link>"
    }, createNewWorkspaceMessageValues);
    return !d0to6JiraSite ? null : /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c11p5 _1tke1lk4 _ae4v1yb4"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _4cvr1h6o _syaz1bqd _zulp1tcg _19pk1wug _2hwxidpf _otyr1wug _18u0idpf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c11p5 _zulpu2gc"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                                className: (0, $esG4f.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lQzxd.WelcomeBackHeading), {
                                    name: name
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                className: (0, $esG4f.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.1",
                                    defaultMessage: "Pick up where you left off in {productName}",
                                    values: {
                                        productName: productName
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ect4bzd7 _1wybdlk8 _y3gn1h6o"
                        ]),
                        style: {
                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.2",
                            defaultMessage: "You\u2019re logged in as {email}. <switchAccountLink>Switch account</switchAccountLink>",
                            values: {
                                email: /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                                    className: (0, $esG4f.default)([
                                        "_k48pni7l _ct361wug _1i4q1hna _1nmz1hna _slp31hna"
                                    ]),
                                    children: email
                                }),
                                switchAccountLink: $255f9296a7acccf2$var$switchAccountLink
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        "data-testid": "return-to-existing-product",
                        className: (0, $esG4f.default)([
                            "_4cvr1h6o _1e0c11p5 _1bsb1osq _19ityzqy _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _2rkoftgi"
                        ]),
                        style: {
                            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
                            href: $255f9296a7acccf2$var$getProductUrl({
                                url: d0to6JiraSite.url,
                                productKey: productKey
                            }),
                            onClick: (e)=>{
                                e.preventDefault(); // wait for event to fire
                                createAnalyticsEvent({
                                    eventType: "ui",
                                    action: "clicked",
                                    actionSubject: "button",
                                    actionSubjectId: "contactExpandClickReturnToProductButton",
                                    attributes: {
                                        productName: productName
                                    }
                                }).fire();
                                window.location.href = $255f9296a7acccf2$var$getProductUrl({
                                    url: d0to6JiraSite.url,
                                    productKey: productKey
                                });
                            },
                            className: (0, $esG4f.default)([
                                "_4cvr1h6o _1e0c1txw _1bah1yb4 _1bsb1osq _9oik1snc _1bnxagmp _jf4cvv82"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1wyb1syg _1reo15vq _18m915vq"
                                    ]),
                                    style: {
                                        "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                            className: (0, $esG4f.default)([
                                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1nn1"
                                            ]),
                                            children: productName
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_syaz9sh9 _1reo15vq _18m915vq _1bto1l2s _o5721q9c _ect4bzd7 _1wybdlk8"
                                            ]),
                                            style: {
                                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                            },
                                            children: d0to6JiraSite.displayName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                                    variant: "primary",
                                    size: "small",
                                    color: "blue",
                                    children: goToProductButtonText
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: createNewWorkspaceMessage
            })
        ]
    });
};
const $255f9296a7acccf2$var$switchAccountLink = (children)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
        href: (0, $jgJpJ.getSwitchAccountUrl)(),
        className: (0, $esG4f.default)([
            "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz17la _o5721q9c _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
        },
        children: children
    });
const $255f9296a7acccf2$var$getProductUrl = ({ url: url, productKey: productKey })=>{
    switch(productKey){
        case (0, $jgJpJ.ProductKey).JIRA_SOFTWARE:
            return `${url}/jira`;
        case (0, $jgJpJ.ProductKey).CONFLUENCE:
            return `${url}/wiki`;
        default:
            return url;
    }
};
const $255f9296a7acccf2$var$containerCss = null;
const $255f9296a7acccf2$var$formContainerCss = null;
const $255f9296a7acccf2$var$headerGroupCss = null;
const $255f9296a7acccf2$var$headerCss = null;
const $255f9296a7acccf2$var$switchAccountSubheader = null;
const $255f9296a7acccf2$var$createNewWorkspaceMessageCss = null;
const $255f9296a7acccf2$var$createNewWorkspaceLinkCss = null;
const $255f9296a7acccf2$var$boxContainerCss = null;
const $255f9296a7acccf2$var$siteBoxCss = null;
const $255f9296a7acccf2$var$bold = null;
const $255f9296a7acccf2$var$siteCss = null;
const $255f9296a7acccf2$var$siteNameCss = null;
const $255f9296a7acccf2$var$emailCss = null;
const $255f9296a7acccf2$var$switchAccountLinkCss = null;

});







parcelRegister("bCSEP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7790ab17c8a7d7e0$export$2e2bcd8739ae039; });

var $365qV = parcelRequire("365qV");

var $gnPGs = parcelRequire("gnPGs");

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $4XrxY = parcelRequire("4XrxY");

var $iKQ5R = parcelRequire("iKQ5R");

var $6Rc0c = parcelRequire("6Rc0c");
const $7790ab17c8a7d7e0$export$4489c2ed11909944 = (_param)=>{
    var props = (0, $365qV._)({}, (0, $gnPGs._)(_param));
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $iSvIT.Fragment), {
        children: [
            props.loggedInPaid ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6Rc0c.default), (0, $7Knp0._)({}, props))
            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $6Rc0c.default), (0, $7Knp0._)({}, props)),
            !props.hideExploreMore && /*#__PURE__*/ (0, $loA2J.jsx)((0, $iKQ5R.default), {})
        ]
    });
};
var $7790ab17c8a7d7e0$export$2e2bcd8739ae039 = $7790ab17c8a7d7e0$export$4489c2ed11909944;

});
parcelRegister("iKQ5R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $830b6c4b1826a982$export$2e2bcd8739ae039; });
/* explore-more-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
parcelRequire("ivwKs");
var $6ZLWI = parcelRequire("6ZLWI");
var $3Z3ZV = parcelRequire("3Z3ZV");

var $jMPt0 = parcelRequire("jMPt0");
const $830b6c4b1826a982$var$exploreStyle = null;
const $830b6c4b1826a982$var$largeSparklesIconContainerStyles = null;
const $830b6c4b1826a982$var$mediumSparklesIconContainerStyles = null;
const $830b6c4b1826a982$var$smallSparklesIconContainerStyles = null;
const $830b6c4b1826a982$export$ce05c083d6af8c49 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jMPt0.default), {
        header: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1rkb1kdj"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "ConfluenceSoftwarePageTemplate.heroHeaderExploreMoreOfConfluence",
                    defaultMessage: "Explore more of Confluence"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    className: (0, $esG4f.default)([
                        "_kqswstnw _11wmh2mm _fc2710yn _1kyz14y2 _1mjbglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6ZLWI.SparklesIcon), {
                        width: "120",
                        height: "80"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    className: (0, $esG4f.default)([
                        "_kqswstnw _11wmh2mm _fc271crf _1kyz14y2 _dm25glyw _sugaglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6ZLWI.SparklesIcon), {
                        width: "90",
                        height: "60"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    className: (0, $esG4f.default)([
                        "_kqswstnw _11wmh2mm _fc27ftgi _1kyz1l7b _181nglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3Z3ZV.ThickSparklesIcon), {
                        width: "60",
                        height: "40"
                    })
                })
            ]
        }),
        subHeader: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "ConfluenceSoftwarePage.heroHeaderExploreMoreOfConfluence.subHeading",
            defaultMessage: "Create, collaborate, and connect your team's knowledge, all in one place"
        })
    });
};
var $830b6c4b1826a982$export$2e2bcd8739ae039 = $830b6c4b1826a982$export$ce05c083d6af8c49;

});
parcelRegister("ivwKs", function(module, exports) {
$parcel$export(module.exports, "OfficeBuildingIcon", function () { return (parcelRequire("eE9yc")).OfficeBuildingIcon; });
$parcel$export(module.exports, "PlayIcon", function () { return (parcelRequire("ei9Un")).PlayIcon; });
$parcel$export(module.exports, "DocumentsIcon", function () { return (parcelRequire("b0Cxt")).DocumentsIcon; });
$parcel$export(module.exports, "SparklesIcon", function () { return (parcelRequire("6ZLWI")).SparklesIcon; });
$parcel$export(module.exports, "ThickSparklesIcon", function () { return (parcelRequire("3Z3ZV")).ThickSparklesIcon; });
$parcel$export(module.exports, "GroupsIcon", function () { return (parcelRequire("d3pUa")).GroupsIcon; });
parcelRequire("gRU0L");
parcelRequire("eE9yc");
parcelRequire("dja2c");
parcelRequire("ei9Un");
parcelRequire("b0Cxt");
parcelRequire("6ZLWI");
parcelRequire("3Z3ZV");
parcelRequire("d3pUa");

});
parcelRegister("gRU0L", function(module, exports) {

var $loA2J = parcelRequire("loA2J");
const $a83d74519978d980$export$a3543c9c8473fb3d = ({ size: size })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                id: "Brand Icons/Comment",
                clipPath: "url(#clip0_5565_6276)",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    id: "Vector",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.9995 34.4994L37.9995 34.499V10.499L9.99951 10.4994V40.499L19.9995 34.4994ZM31.999 20.5H15.999V16.5H31.999V20.5ZM24.999 28.5H15.999V24.5H24.999V28.5Z",
                    fill: "#101214"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                    id: "clip0_5565_6276",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "48",
                        height: "48",
                        fill: "white",
                        transform: "translate(-0.000976562 0.5)"
                    })
                })
            })
        ]
    });
};

});

parcelRegister("eE9yc", function(module, exports) {

$parcel$export(module.exports, "OfficeBuildingIcon", function () { return $6098dcfa7688f0c7$export$2a7e5122c4e1fda; });

var $loA2J = parcelRequire("loA2J");
const $6098dcfa7688f0c7$export$2a7e5122c4e1fda = ({ size: size })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                id: "Brand Icons/Office Building",
                clipPath: "url(#clip0_5565_6283)",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    id: "Vector",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.999 40.5V8.5H35.999V40.5H26.9995V33.5H20.9995V40.5H11.999ZM17.999 15.5H21.999V12.5H17.999V15.5ZM25.999 15.5H29.999V12.5H25.999V15.5ZM21.999 22.5H17.999V19.5H21.999V22.5ZM17.999 29.5H21.999V26.5H17.999V29.5ZM29.999 22.5H25.999V19.5H29.999V22.5ZM25.999 29.5H29.999V26.5H25.999V29.5Z",
                    fill: "#101214"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                    id: "clip0_5565_6283",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "48",
                        height: "48",
                        fill: "white",
                        transform: "translate(-0.000976562 0.5)"
                    })
                })
            })
        ]
    });
};

});

parcelRegister("dja2c", function(module, exports) {

var $loA2J = parcelRequire("loA2J");
const $376b1a3408a5c69f$export$fec93b5f1e2bccb4 = ({ size: size })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 11 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            id: "arrow",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.40698 0.5L6.32733 1.7021L8.07756 3.6497H0.762206C0.340929 3.6497 -0.000976562 4.03038 -0.000976562 4.49943C-0.000976562 4.96849 0.340929 5.34917 0.762206 5.34917H8.07756L6.32733 7.2979L7.40698 8.5L10.999 4.49943L7.40698 0.5Z",
            fill: "#0065FF"
        })
    });
};

});

parcelRegister("ei9Un", function(module, exports) {

$parcel$export(module.exports, "PlayIcon", function () { return $1e1140c87aa31f70$export$a6630b90defda83f; });

var $loA2J = parcelRequire("loA2J");
const $1e1140c87aa31f70$export$a6630b90defda83f = ({ size: size })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                clipPath: "url(#clip0_5565_6290)",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M37.999 10.5H9.99902V38.5H37.999V10.5ZM17.0027 16C15.8981 16 15.0027 16.8954 15.0027 18C15.0027 19.1046 15.8981 20 17.0027 20C18.1073 20 19.0027 19.1046 19.0027 18C19.0027 16.8954 18.1073 16 17.0027 16ZM17.0027 29C15.8981 29 15.0027 29.8954 15.0027 31C15.0027 32.1046 15.8981 33 17.0027 33C18.1073 33 19.0027 32.1046 19.0027 31C19.0027 29.8954 18.1073 29 17.0027 29ZM15.0027 24.5C15.0027 23.3954 15.8981 22.5 17.0027 22.5C18.1073 22.5 19.0027 23.3954 19.0027 24.5C19.0027 25.6046 18.1073 26.5 17.0027 26.5C15.8981 26.5 15.0027 25.6046 15.0027 24.5ZM31.999 19.5139L21.999 19.5139V16.5139L31.999 16.5139V19.5139ZM31.999 26L21.999 26V23L31.999 23V26ZM21.999 32.5H31.999V29.5H21.999V32.5Z",
                    fill: "#101214"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                x: "11.999",
                y: "12.5",
                width: "24",
                height: "24",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M30.999 24L19.749 30.4952L19.749 17.5048L30.999 24Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                    id: "clip0_5565_6290",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "48",
                        height: "48",
                        fill: "white",
                        transform: "translate(-0.000976562 0.5)"
                    })
                })
            })
        ]
    });
};

});

parcelRegister("b0Cxt", function(module, exports) {

$parcel$export(module.exports, "DocumentsIcon", function () { return $4a3886a3620096d2$export$f4d1f69b1f255ce3; });

var $loA2J = parcelRequire("loA2J");
const $4a3886a3620096d2$export$f4d1f69b1f255ce3 = ({ size: size })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                id: "Brand Icons/Documents",
                clipPath: "url(#clip0_5565_6299)",
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                    id: "Vector",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.9993 8.5H20.9993L29.9993 17.5V33.5H10.9993V8.5ZM18.9993 19.5V11.5L26.9993 19.5H18.9993Z",
                            fill: "#101214"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            d: "M32.9991 18.5V36.5H16.9991V40.5H36.9991V18.5H32.9991Z",
                            fill: "#101214"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                    id: "clip0_5565_6299",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "48",
                        height: "48",
                        fill: "white",
                        transform: "translate(-0.000976562 0.5)"
                    })
                })
            })
        ]
    });
};

});

parcelRegister("6ZLWI", function(module, exports) {

$parcel$export(module.exports, "SparklesIcon", function () { return $45cb3d6a97d34ac7$export$a05b22346a85e647; });

var $loA2J = parcelRequire("loA2J");
const $45cb3d6a97d34ac7$export$a05b22346a85e647 = ({ width: width, height: height })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 122 82",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
            id: "Gestural Line/star 7",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    id: "Vector",
                    d: "M27.8084 18.2872C24.4456 16.7937 16.6276 20.7744 17.5199 14.5683C16.7065 16.9365 20.2695 2.56069 17.3317 4.61946C17.101 4.3398 16.1662 6.63659 16.4758 6.708C16.8339 9.13569 14.497 14.1696 14.2663 18.0253C14.2481 17.8944 -6.35927 17.6029 2.88523 20.0484C4.59695 20.2507 17.6656 18.9298 13.0342 26.3259C14.2543 43.7363 17.1678 31.3836 17.01 20.8815C18.9463 21.2801 32.9193 21.0719 27.8023 18.2872H27.8084Z",
                    fill: "#101214"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    id: "Vector_2",
                    d: "M120.32 39.0772C115.701 38.2025 110.116 40.8504 108.89 36.4056C110.371 35.644 109.431 22.3749 107.543 29.4676C107.871 29.6164 108.308 29.4914 108.119 29.8009C106.22 29.8842 108.332 32.3237 107.488 32.77C106.311 32.1809 108.338 35.3941 107.154 34.5849C106.426 35.763 106.353 37.3279 106.426 38.9761C107.106 39.4878 88.4408 37.8098 96.447 41.2312C97.0115 39.4521 96.5381 42.3915 99.1906 40.6719C101.679 41.6954 103.33 42.1 106.584 42.0881C105.261 45.807 108.866 60.9205 109.631 49.7817C110.189 47.5206 107.561 39.4521 113.437 42.5224C114.748 40.9694 124.921 41.9452 120.308 39.0713L120.32 39.0772Z",
                    fill: "#101214"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    id: "Vector_3",
                    d: "M82.6317 11.6885C78.0125 10.8138 72.4282 13.4617 71.2021 9.01685C72.6832 8.25522 71.7423 -5.01372 69.8546 2.07894C70.1824 2.2277 70.6194 2.10271 70.4312 2.41212C68.5313 2.49542 70.6437 4.93501 69.8 5.38127C68.6224 4.7922 70.6497 8.00535 69.4661 7.19612C68.7377 8.37426 68.6649 9.93917 68.7377 11.5874C69.4176 12.0991 50.7464 10.4211 58.7587 13.8425C59.3233 12.0634 58.8498 15.0028 61.5024 13.2832C63.991 14.3066 65.642 14.7112 68.8955 14.6993C67.7908 18.2754 70.7226 33.2462 72.1733 22.4406C72.064 20.6555 70.1216 11.9444 75.7545 15.1337C77.0656 13.5807 87.2388 14.5566 82.6257 11.6826L82.6317 11.6885Z",
                    fill: "#101214"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    id: "Vector_4",
                    d: "M71.3178 67.2696C66.6986 66.3949 61.1143 69.0428 59.8881 64.598C61.3692 63.8363 60.4284 50.5673 58.5406 57.66C58.8684 57.8087 59.3054 57.6838 59.1172 57.9932C57.2174 58.0765 59.3297 60.5161 58.486 60.9624C57.3084 60.3733 59.3358 63.5865 58.1521 62.7772C57.4237 63.9554 57.3509 65.5203 57.4238 67.1685C58.1036 67.6802 39.4325 66.0022 47.4448 69.4236C48.0093 67.6445 47.5358 70.5839 50.1884 68.8643C52.6771 69.8877 54.3281 70.2924 57.5816 70.2805C56.2584 73.9993 59.8638 89.1129 60.6286 77.9741C61.1871 75.713 58.5588 67.6445 64.4345 70.7148C65.7456 69.1618 75.9188 70.1376 71.3057 67.2637L71.3178 67.2696Z",
                    fill: "#101214"
                })
            ]
        })
    });
};

});

parcelRegister("3Z3ZV", function(module, exports) {

$parcel$export(module.exports, "ThickSparklesIcon", function () { return $76c00089e75f9895$export$8016ce75dc94b90d; });

var $loA2J = parcelRequire("loA2J");
const $76c00089e75f9895$export$8016ce75dc94b90d = ({ width: width, height: height })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 62 43",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M14.0609 10.1436C12.3934 9.39683 8.51669 11.3872 8.95914 8.28414C8.55582 9.46824 10.3226 2.28034 8.86582 3.30973C8.75144 3.1699 8.28791 4.3183 8.44142 4.354C8.619 5.56784 7.46019 8.08479 7.34581 10.0127C7.33678 9.94721 -2.88176 9.80144 1.70229 11.0242C2.55108 11.1254 9.03138 10.4649 6.73484 14.163C7.33982 22.8681 8.78454 16.6918 8.70629 11.4407C9.66644 11.6401 16.5952 11.5359 14.0579 10.1436H14.0609Z",
                fill: "#101214",
                stroke: "black"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M59.9349 20.5386C57.6444 20.1013 54.8753 21.4252 54.2673 19.2028C55.0017 18.822 54.5352 12.1875 53.5991 15.7338C53.7617 15.8082 53.9784 15.7457 53.8851 15.9004C52.943 15.9421 53.9904 17.1619 53.5721 17.385C52.9881 17.0905 53.9934 18.697 53.4065 18.2924C53.0453 18.8815 53.0092 19.664 53.0453 20.4881C53.3824 20.7439 44.127 19.9049 48.0971 21.6156C48.377 20.726 48.1422 22.1958 49.4575 21.336C50.6916 21.8477 51.5103 22.05 53.1236 22.044C52.4674 23.9035 54.2553 31.4602 54.6346 25.8908C54.9115 24.7603 53.6082 20.7261 56.5217 22.2612C57.1719 21.4847 62.2164 21.9726 59.9289 20.5356L59.9349 20.5386Z",
                fill: "#101214",
                stroke: "black"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M41.2465 6.84425C38.956 6.4069 36.1869 7.73083 35.579 5.50842C36.3134 5.12761 35.8468 -1.50686 34.9108 2.03947C35.0733 2.11385 35.29 2.05135 35.1967 2.20606C34.2546 2.24771 35.3021 3.4675 34.8837 3.69064C34.2998 3.3961 35.3051 5.00267 34.7181 4.59806C34.3569 5.18713 34.3208 5.96959 34.357 6.79369C34.6941 7.04955 25.4357 6.21055 29.4087 7.92123C29.6886 7.03168 29.4539 8.5014 30.7692 7.64159C32.0032 8.15331 32.8219 8.35562 34.4352 8.34967C33.8874 10.1377 35.3412 17.6231 36.0605 12.2203C36.0063 11.3278 35.0432 6.97219 37.8364 8.56685C38.4865 7.79034 43.531 8.27828 41.2435 6.8413L41.2465 6.84425Z",
                fill: "#101214",
                stroke: "black"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M35.6353 34.6348C33.3447 34.1975 30.5756 35.5214 29.9676 33.299C30.702 32.9182 30.2355 26.2837 29.2994 29.83C29.462 29.9044 29.6787 29.8419 29.5854 29.9966C28.6433 30.0383 29.6907 31.2581 29.2724 31.4812C28.6884 31.1867 29.6937 32.7932 29.1068 32.3886C28.7456 32.9777 28.7095 33.7601 28.7456 34.5843C29.0827 34.8401 19.8243 34.0011 23.7974 35.7118C24.0773 34.8222 23.8425 36.292 25.1578 35.4322C26.3919 35.9439 27.2106 36.1462 28.8239 36.1402C28.1677 37.9997 29.9556 45.5564 30.3348 39.987C30.6117 38.8565 29.3085 34.8222 32.222 36.3574C32.8722 35.5809 37.9167 36.0688 35.6292 34.6318L35.6353 34.6348Z",
                fill: "#101214",
                stroke: "black"
            })
        ]
    });
};

});

parcelRegister("d3pUa", function(module, exports) {

$parcel$export(module.exports, "GroupsIcon", function () { return $9be7233492d17b21$export$6b0e36037a267557; });

var $loA2J = parcelRequire("loA2J");
const $9be7233492d17b21$export$6b0e36037a267557 = ({ size: size })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 49 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("g", {
            id: "Brand Icons/Groups",
            clipPath: "url(#clip0_6876_13409)",
            filter: "url(#filter0_d_6876_13409)",
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                id: "Vector",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M17.4463 31.5C17.4463 27.634 20.5803 24.5 24.4463 24.5C28.3123 24.5 31.4463 27.634 31.4463 31.5V40.5H17.4463V31.5Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M30.4463 15.5C30.4463 18.8137 27.76 21.5 24.4463 21.5C21.1326 21.5 18.4463 18.8137 18.4463 15.5C18.4463 12.1863 21.1326 9.5 24.4463 9.5C27.76 9.5 30.4463 12.1863 30.4463 15.5Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M31.2581 21.3824C31.6422 21.4595 32.0395 21.5 32.4463 21.5C35.76 21.5 38.4463 18.8137 38.4463 15.5C38.4463 12.1863 35.76 9.5 32.4463 9.5C32.0395 9.5 31.6422 9.54048 31.2581 9.61764C32.6216 11.1952 33.4463 13.2513 33.4463 15.5C33.4463 17.7487 32.6216 19.8048 31.2581 21.3824Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M17.6345 9.61764C16.271 11.1952 15.4463 13.2513 15.4463 15.5C15.4463 17.7487 16.271 19.8048 17.6345 21.3824C17.2504 21.4595 16.8531 21.5 16.4463 21.5C13.1326 21.5 10.4463 18.8137 10.4463 15.5C10.4463 12.1863 13.1326 9.5 16.4463 9.5C16.8531 9.5 17.2504 9.54048 17.6345 9.61764Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M17.3049 24.5C15.5366 26.3037 14.4463 28.7745 14.4463 31.5V40.5H10.4463V29.5C10.4463 26.7386 12.6849 24.5 15.4463 24.5H17.3049Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M34.4463 40.5V31.5C34.4463 28.7745 33.356 26.3037 31.5877 24.5H33.4463C36.2077 24.5 38.4463 26.7386 38.4463 29.5V40.5H34.4463Z",
                        fill: "#101214"
                    })
                ]
            })
        })
    });
};

});


parcelRegister("jMPt0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $575ffc753706a38c$export$2e2bcd8739ae039; });
/* header-text-block.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");
const $575ffc753706a38c$var$headerTextBlock = null;
const $575ffc753706a38c$var$headerText = null;
const $575ffc753706a38c$var$headerSubText = null;
const $575ffc753706a38c$var$leftAlignedStyle = null;
const $575ffc753706a38c$var$button = null;
const $575ffc753706a38c$export$b0d75561f67a4b0d = ({ header: header, subHeader: subHeader, leftAligned: leftAligned, cta: cta })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _1e0c1txw _2lx21bp4 _1bah1h6o _1q51oahv _85i5xncg _ag851h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3td7vkz _19bvidpf",
                    leftAligned && "_y3gn1e5h",
                    "superhero-contrast"
                ]),
                children: header
            }),
            subHeader && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3td7vkz _19bvidpf",
                    leftAligned && "_y3gn1e5h",
                    "body-lg"
                ]),
                children: subHeader
            }),
            cta && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_y3gn1h6o _bpsp1nn1 _43dscd5j"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: cta
            })
        ]
    });
};
var $575ffc753706a38c$export$2e2bcd8739ae039 = $575ffc753706a38c$export$b0d75561f67a4b0d;

});


parcelRegister("6Rc0c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ef0c777d21e74ce$export$2e2bcd8739ae039; });
/* log-me-in.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $91nJf = parcelRequire("91nJf");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $47768 = parcelRequire("47768");

var $9iWJ8 = parcelRequire("9iWJ8");

var $dWbel = parcelRequire("dWbel");

var $jDqaa = parcelRequire("jDqaa");
const $7ef0c777d21e74ce$var$START_URL = "https://start.atlassian.com";
const $7ef0c777d21e74ce$var$SIGNUP_URL = "https://atlassian.com/try/cloud/signup?bundle=confluence&edition=free";
const $7ef0c777d21e74ce$var$sectionCSS = null;
const $7ef0c777d21e74ce$var$wrapLogMeSecAndLines = null; // Adjustments for fixed top nav.
// The logged in paid pages have a position:fixed top nav.
const $7ef0c777d21e74ce$var$wrapLogMeSecAndLinesLoggedInPaid = null;
const $7ef0c777d21e74ce$var$logMeBackInSectionStyle = null;
const $7ef0c777d21e74ce$var$headingStyle = null;
const $7ef0c777d21e74ce$var$subHeadingStyle = null;
const $7ef0c777d21e74ce$var$confluenceSiteBoxContainerStyle = null;
const $7ef0c777d21e74ce$var$flareContainerCss = null;
const $7ef0c777d21e74ce$var$confluenceSiteBoxUnderlayStyle = null;
const $7ef0c777d21e74ce$var$confluenceSiteBoxStyle = null;
const $7ef0c777d21e74ce$var$logoAndSiteNameStyle = null;
const $7ef0c777d21e74ce$var$logoStyle = null;
const $7ef0c777d21e74ce$var$siteStyle = null;
const $7ef0c777d21e74ce$var$productStyle = null;
const $7ef0c777d21e74ce$var$siteNameStyle = null;
const $7ef0c777d21e74ce$var$otherSiteLinkStyle = null;
const $7ef0c777d21e74ce$var$buttonStyle = null;
const $7ef0c777d21e74ce$var$imgWrapperStyle = null;
const $7ef0c777d21e74ce$var$imgStyle = null;
var $7ef0c777d21e74ce$var$TRACKING_EVENT_NAMES;
(function(TRACKING_EVENT_NAMES) {
    TRACKING_EVENT_NAMES["loggedInHeroProductCtaClicked"] = "loggedInHeroProductCtaClicked";
    TRACKING_EVENT_NAMES["loggedInHeroAnotherSiteCtaClicked"] = "loggedInHeroAnotherSiteCtaClicked";
    TRACKING_EVENT_NAMES["loggedInHeroNewSiteCtaClicked"] = "loggedInHeroNewSiteCtaClicked";
})($7ef0c777d21e74ce$var$TRACKING_EVENT_NAMES || ($7ef0c777d21e74ce$var$TRACKING_EVENT_NAMES = {}));
const $7ef0c777d21e74ce$export$48ece50d13cfbebc = ({ confluenceSites: confluenceSites, userProfileName: userProfileName, imgSrc: // eslint-disable-next-line local/no-non-orangelogic-images-eslint
imgSrc = "https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero Image B-1884788674.webp", loggedInPaid: loggedInPaid })=>{
    var _confluenceSites_, _confluenceSites_1;
    const createConfluenceUrl = (url)=>{
        try {
            const tempUrl = new URL(url);
            tempUrl.pathname = "/wiki";
            tempUrl.search = "";
            return tempUrl.toString();
        } catch (e) {
            return url;
        }
    };
    const getSitenameFromUrl = (url)=>{
        try {
            const tempUrl = new URL(url);
            return tempUrl.hostname.split(".")[0] || "";
        } catch (e) {
            return "";
        }
    };
    const firstName = userProfileName === null || userProfileName === void 0 ? void 0 : userProfileName.split(" ")[0];
    const siteUrl = createConfluenceUrl(((_confluenceSites_ = confluenceSites[0]) === null || _confluenceSites_ === void 0 ? void 0 : _confluenceSites_.url) || "") || $7ef0c777d21e74ce$var$START_URL;
    const siteName = getSitenameFromUrl(((_confluenceSites_1 = confluenceSites[0]) === null || _confluenceSites_1 === void 0 ? void 0 : _confluenceSites_1.url) || "");
    const hasMultipleConfluences = confluenceSites.length > 1;
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    (0, $iSvIT.useEffect)(()=>{
        if (typeof window !== "undefined") createAnalyticsEvent({
            eventType: "ui",
            action: "loaded",
            actionSubject: "page",
            actionSubjectId: "loggedInHero",
            source: "/software/confluence",
            attributes: {
                url: window.location.href
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const clickHandler = (eventName)=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "loggedInHero",
            source: "/software/confluence",
            attributes: {
                eventName: eventName,
                url: window.location.href
            }
        }).fire();
    };
    const intl = (0, $f6qj2.default)();
    const linkUrl = loggedInPaid ? $7ef0c777d21e74ce$var$SIGNUP_URL : $7ef0c777d21e74ce$var$START_URL;
    const signupHref = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=confluence&edition=free&createNew=true");
    const gwp5090BannerExperiment = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).gwp5090ExperimentBannerConfluence);
    const gwp5090IsLiftedBanner = gwp5090BannerExperiment != undefined && gwp5090BannerExperiment.type === "enrolled" && gwp5090BannerExperiment.value === "lifted";
    const gwp5090Team25Config = {
        identifier: "GWP5090.confluence-product-tour.lifted",
        customCSS: {
            position: "absolute",
            margin: "auto",
            inset: "auto 0 90px"
        },
        bannerType: "lifted",
        text: /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "team25-banners-and-butterbars.confluence.text",
                defaultMessage: "<strong>April 8-10 \u2022 Anaheim, California</strong>Hear from the world\u2019s leading product experts on how to boost team performance at Team \u201925!",
                values: (0, $3FBn4.DEFAULT_VALUES)
            })
        }),
        mobileText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "team25-banners-and-butterbars.confluence.mobile-text",
                defaultMessage: "<strong>April 8-10 \u2022 Anaheim, California</strong>Hear from leading product experts!",
                values: (0, $3FBn4.DEFAULT_VALUES)
            })
        }),
        productKey: "home",
        backgroundPreset: "gwp-5090-banners",
        imageProps: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/gf1wkse40oux4nf58b103kknvb18p4yc.webp",
            alt: "Team25",
            //Event name is not localized
            width: 200
        },
        linkText: intl.formatMessage({
            id: "team25-banners-and-butterbars.confluence.cta",
            defaultMessage: "Get your pass"
        }),
        linkUrl: "https://events.atlassian.com/team?utm_medium=event-web-referral&utm_source=confluence_product-tour&event_context=701QB00000Lg6oBYAR&utm_campaign=K:event|H:any|N:Team_25|P:agnostic|O:event-marketing|F:pre-event|C:event-home&utm_content=lifted-bar_WEBTEAM-17396&event_id=216653",
        dataEventProps: {
            "data-product-key": "home",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": intl.formatMessage({
                id: "team25-banners-and-butterbars.confluence.cta",
                defaultMessage: "Get your pass"
            }),
            "data-label-english": "Get your pass"
        }
    };
    const classWrapperName = gwp5090IsLiftedBanner ? "lifted" : "standard";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
            className: (0, $esG4f.default)([
                "_1yeuh2mm",
                classWrapperName
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1itk1m1u _1lrw1dfr _1e0c1txw _4cvr1h6o _1bah1h6o _zulp1a0z _19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0q1wto _u5f31lev _n3td1fqw _19bv1lev _165t1kc5 _na0i1bp4 _2osnckbl _13lo7rrr",
                        loggedInPaid && "_165t1wug _5br81et3 _rvh8ys9h _17y2ys9h _2936ys9h _jk7n16xz _la4x1tcg _d8uxys9h _1vw11tcg",
                        classWrapperName
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_ca0q1tcg _u5f3idpf _n3td1tcg _19bvidpf _1lp7vrvc _10jx1erl _1s4p1osq"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                                    className: (0, $esG4f.default)([
                                        "_1wybckbl _vwz48vuz _k48pbfng _1pfhidpf _6rthftgi"
                                    ]),
                                    children: firstName ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "ConfluenceSoftwarePageTemplate.loggedInHero.welcomeBackWithName",
                                        defaultMessage: `Welcome back, {name}.`,
                                        values: {
                                            name: firstName
                                        }
                                    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "ConfluenceSoftwarePageTemplate.loggedInHero.welcomeBack",
                                        defaultMessage: "Welcome back"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                    className: (0, $esG4f.default)([
                                        "_1wybgktf _6rth1tcg _1pfhidpf"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "ConfluenceSoftwarePageTemplate.loggedInHero.pickUpWhereYouLeftOff",
                                        defaultMessage: "Pick up where you left off in Confluence."
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: (0, $esG4f.default)([
                                        "_kqswh2mm"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_kqswstnw _1e02k4tm _1pbycs5v _14qqglyw"
                                            ]),
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jDqaa.FlareSvg), {})
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                            className: (0, $esG4f.default)([
                                                "_kqswh2mm _1pbykb7n _1bsb1wug _4t3it9kd _1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _19it1puz _2rko1y44 _ca0q7vkz _u5f31tcg _n3td7vkz _19bv7vkz _bfhku67f _yhmu1bp4 _9pnu1wug _te6cv2br _jk7n1v6z _la4x7vkz _d8ux7vkz _1vw17vkz"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                                    className: (0, $esG4f.default)([
                                                        "_1e0c1txw _2lx2vrvc _4cvr1h6o _1ul9idpf"
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                            className: (0, $esG4f.default)([
                                                                "_12l219bv _1pfhrdoj"
                                                            ]),
                                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Logo), {
                                                                brand: "confluence",
                                                                type: "mark",
                                                                appearance: "brand"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                                            className: (0, $esG4f.default)([
                                                                "_vwz4qslr _1wyb7vkz _1reo15vq _18m915vq"
                                                            ]),
                                                            children: [
                                                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                                    className: (0, $esG4f.default)([
                                                                        "_k48pbfng _4t3iqslr _1wybl52n _y3gnv2br"
                                                                    ]),
                                                                    children: "Confluence"
                                                                }),
                                                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                                    className: (0, $esG4f.default)([
                                                                        "_k48powjs _1bto1l2s _1reo15vq _18m915vq _o5721q9c _4t3iqslr"
                                                                    ]),
                                                                    children: siteName
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                                                    id: "confluence-button",
                                                    variant: "primary",
                                                    size: "small",
                                                    color: "blue",
                                                    href: siteUrl,
                                                    onClick: ()=>clickHandler("loggedInHeroProductCtaClicked"),
                                                    className: (0, $esG4f.default)([
                                                        "_o5721q9c _ahbqo7ao _19tjidpf _1qza1osq _5m7p1osq"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                        id: "ConfluenceSoftwarePageTemplate.loggedInHero.goToConfluence",
                                                        defaultMessage: "Go to Confluence"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_1bsb1w8u _kqswstnw _u7conicn _rjxpd439 _bfhkh727 _4t3i1wqb _9pnu1l8a"
                                            ])
                                        })
                                    ]
                                }),
                                hasMultipleConfluences && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                    href: linkUrl,
                                    text: intl.formatMessage({
                                        id: "ConfluenceSoftwarePageTemplate.loggedInHero.lookingForDifferentSite",
                                        defaultMessage: "Looking for a different site?"
                                    }),
                                    onClick: ()=>clickHandler("loggedInHeroAnotherSiteCtaClicked"),
                                    className: (0, $esG4f.default)([
                                        "_1pfhckbl"
                                    ])
                                }),
                                loggedInPaid && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                    href: signupHref,
                                    text: intl.formatMessage({
                                        id: "ConfluenceSoftwarePageTemplate.loggedInHero.orCreateANewWorkspace",
                                        defaultMessage: "Or create a new workspace"
                                    }),
                                    onClick: ()=>clickHandler("loggedInHeroNewSiteCtaClicked"),
                                    className: (0, $esG4f.default)([
                                        "_1pfhckbl"
                                    ])
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_10jxstmo _1s4p1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                                alt: "",
                                src: imgSrc,
                                className: (0, $esG4f.default)([
                                    "_1bsb1osq"
                                ])
                            })
                        })
                    ]
                }),
                gwp5090IsLiftedBanner && /*#__PURE__*/ (0, $loA2J.jsx)((0, $47768.EnhancedBannerAlert), (0, $7Knp0._)({}, gwp5090Team25Config))
            ]
        })
    });
};
var $7ef0c777d21e74ce$export$2e2bcd8739ae039 = $7ef0c777d21e74ce$export$48ece50d13cfbebc;

});
parcelRegister("jDqaa", function(module, exports) {

$parcel$export(module.exports, "FlareSvg", function () { return $bf538dde6e964d98$export$7b83271ab79d7cd2; });

var $loA2J = parcelRequire("loA2J");

var $bhreu = parcelRequire("bhreu");
const $bf538dde6e964d98$export$7b83271ab79d7cd2 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8ra1mh2pbsd5j7i3kc5rdw2h5815w1i1.svg",
            alt: "",
            width: 77,
            height: 81
        }
    });

});



parcelRegister("cBkUf", function(module, exports) {

$parcel$export(module.exports, "ConfluencePagePaidLpConflAnchor", function () { return $ec721d9323471da6$export$66f40902ad8b3dc6; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $5tcZn = parcelRequire("5tcZn");

var $f6qj2 = parcelRequire("f6qj2");

var $bESgj = parcelRequire("bESgj");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");
parcelRequire("D0EyQ");
var $g8Gdb = parcelRequire("g8Gdb");

var $3fquc = parcelRequire("3fquc");

var $k4Qty = parcelRequire("k4Qty");

var $fR8rA = parcelRequire("fR8rA");

var $aR9rM = parcelRequire("aR9rM");
const $ec721d9323471da6$var$LANDING_TYPE = "confluence-rebranded-anchor";
const $ec721d9323471da6$export$66f40902ad8b3dc6 = ({ anchorContents: anchorContents, persona: persona, teamType: teamType, pageId: pageId, pageVariant: pageVariant, animatedJiraTourProps: animatedJiraTourProps, dataProductKey: dataProductKey, carouselHeroProps: carouselHeroProps, keyword: keyword, subAnchor: subAnchor, customHeroSection: customHeroSection })=>{
    const intl = (0, $f6qj2.default)();
    const productHref = (0, $3FBn4.useLocalizedHref)("/software/confluence");
    const [content, setContent] = (0, $iSvIT.useState)(undefined);
    const { setAnchorLocalStorage: setAnchorLocalStorage } = (0, $k4Qty.useAnchorLocalStorage)();
    (0, $iSvIT.useEffect)(()=>{
        const anchorLocalStorageData = {
            persona: persona,
            team: "",
            teamTypeInferredMl: teamType
        };
        if (!!keyword) anchorLocalStorageData.keyword = keyword;
        if (!!subAnchor) anchorLocalStorageData.subAnchor = subAnchor;
        setAnchorLocalStorage(anchorLocalStorageData);
        setContent(anchorContents);
    // We only want to run this useEffect once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!content) // TODO: loading UI for static renders
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {});
    const props = {
        hideNavigationBar: false,
        landingType: $ec721d9323471da6$var$LANDING_TYPE,
        pageId: pageId,
        animatedJiraTourProps: animatedJiraTourProps,
        showHorizontalRule: false,
        productNavProps: {
            productHref: productHref,
            productName: "confluence",
            ariaLabel: intl.formatMessage({
                id: "wacConfluenceNavigation.logo-label",
                defaultMessage: "Confluence logo"
            }),
            dataProductKey: "confluence",
            showFreeHrefButton: false
        },
        heroProps: $ec721d9323471da6$var$getHeroProps({
            resp: content,
            pageVariant: pageVariant,
            keyword: keyword,
            subAnchor: subAnchor
        }),
        carouselHeroProps: carouselHeroProps,
        tabsProps: $ec721d9323471da6$var$getTabProps(content, dataProductKey, pageVariant, keyword, subAnchor),
        ctaWithPolyGonProps: $ec721d9323471da6$var$getCtaWithPolygonProps(content, pageId, dataProductKey),
        testimonialProps: $ec721d9323471da6$var$getTestimonialProps(content),
        alternatingTextAndImageProps: $ec721d9323471da6$var$getAlternatingTextAndImageProps(content),
        resultSectionDivider: {
            color: (0, $5ohHq.wacToken)("color.neutral.light100"),
            variation: (0, $bESgj.SECTION_DIVIDER_VARIATION).NORMAL
        },
        hasRebrandedSignupFormStyles: true,
        heroBgColor: "bgWhite",
        customHeroSection: customHeroSection
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3fquc.PaidLandingTemplate), (0, $7Knp0._)({}, props));
};
const $ec721d9323471da6$var$heroFeatureMatrix = {
    engineering: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: true,
        showScribble: false,
        showEyeLash: false,
        showFourSocialButtons: false
    },
    featuresCerebro: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: true,
        showScribble: false,
        showEyeLash: false,
        showFourSocialButtons: false
    },
    keywords: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: true,
        showScribble: true,
        showEyeLash: true,
        showFourSocialButtons: false
    },
    subAnchor: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: true,
        showScribble: true,
        showEyeLash: true,
        showFourSocialButtons: false
    },
    marketing: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: true,
        showScribble: false,
        showEyeLash: false,
        showFourSocialButtons: false
    },
    brandUpdate: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: false,
        showScribble: true,
        showEyeLash: true,
        showFourSocialButtons: true
    }
};
const $ec721d9323471da6$var$getHeroFeatures = (pageVariant)=>{
    const defaultFeatures = {
        useNewHero: false,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: false,
        showScribble: false,
        showEyeLash: false,
        showFourSocialButtons: false
    };
    return $ec721d9323471da6$var$heroFeatureMatrix[pageVariant] || defaultFeatures;
};
const $ec721d9323471da6$var$getAnimation = ({ pageVariant: pageVariant, keyword: keyword, subAnchor: subAnchor })=>{
    if (pageVariant === "keywords") return (0, $fR8rA.getAnimationByKeyword)((keyword === null || keyword === void 0 ? void 0 : keyword.trim()) || "");
    else if (pageVariant === "subAnchor") return (0, $aR9rM.getAnimationBySubAnchor)((subAnchor === null || subAnchor === void 0 ? void 0 : subAnchor.trim()) || "");
    return undefined;
};
// eslint-disable-next-line complexity
const $ec721d9323471da6$var$getHeroProps = ({ resp: resp, pageVariant: pageVariant, keyword: keyword, subAnchor: subAnchor })=>{
    const defaultProps = {
        theme: "dark-on-light",
        headerText: "",
        secondaryText: "",
        signup: {
            bundle: "confluence",
            edition: "free",
            featureFlags: {
                enableDefaultExpandedEmail: false,
                enableDeferredFullName: true
            }
        }
    };
    if (!resp || !resp[0]) return defaultProps;
    const { headline: headline } = resp[0].node;
    const data = headline && headline[0] ? headline[0] : null;
    const planBenefits = (data === null || data === void 0 ? void 0 : data.planBenefits) && (data === null || data === void 0 ? void 0 : data.planBenefits[0]) ? data === null || data === void 0 ? void 0 : data.planBenefits[0] : null;
    const supportingAsset = planBenefits === null || planBenefits === void 0 ? void 0 : planBenefits.supportingAsset;
    const features = $ec721d9323471da6$var$getHeroFeatures(pageVariant);
    const getImage = (url, description)=>url && description ? {
            src: url ? url : "",
            alt: description || ""
        } : undefined;
    const getFeaturesRawHtml = ()=>planBenefits && planBenefits.planFeatures && planBenefits.planFeatures[0] ? planBenefits.planFeatures[0].description || "" : "";
    const animation = $ec721d9323471da6$var$getAnimation({
        pageVariant: pageVariant,
        keyword: keyword,
        subAnchor: subAnchor
    });
    return (0, $6iHNw._)((0, $7Knp0._)({}, defaultProps, features), {
        headerText: (data === null || data === void 0 ? void 0 : data.name) || "",
        secondaryText: (data === null || data === void 0 ? void 0 : data.subheading) || "",
        image: getImage(supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.url, supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.description),
        featuresRawHtml: getFeaturesRawHtml(),
        tertiaryText: (planBenefits === null || planBenefits === void 0 ? void 0 : planBenefits.description) || "",
        animation: animation
    });
};
const $ec721d9323471da6$var$getTabProps = (resp, dataProductKey, pageVariant, keyword, subAnchor)=>{
    const defaultProps = {
        dataProductKey: dataProductKey,
        headerText: "",
        tabStyles: {
            defaultBG: (0, $5ohHq.wacToken)("color.neutral.light200"),
            // eslint-disable-next-line local/ensure-wac-token-usage
            defaultText: "#172B4D",
            hoverBG: (0, $5ohHq.wacToken)("color.neutral.light200"),
            // eslint-disable-next-line local/ensure-wac-token-usage
            hoverText: "#172B4D",
            activeBG: (0, $5ohHq.wacToken)("color.extended.blue100"),
            // eslint-disable-next-line local/ensure-wac-token-usage
            activeText: "#172B4D"
        },
        styles: {
            "--lp-tabs-hover": "#0C66E4",
            "--lp-tabs-unselected": "#172B4D"
        },
        tabs: undefined
    };
    if (!resp || !resp[0]) return defaultProps;
    const tabs = $ec721d9323471da6$var$getTabs(resp, pageVariant, keyword, subAnchor);
    const primaryMessage = $ec721d9323471da6$var$getPrimaryMessage(resp);
    return (0, $6iHNw._)((0, $7Knp0._)({}, defaultProps), {
        landingType: $ec721d9323471da6$var$LANDING_TYPE,
        headerText: (primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.name) || "",
        tabs: tabs
    });
};
const $ec721d9323471da6$var$getCtaWithPolygonProps = (resp, pageId, dataProductKey)=>{
    const cta = $ec721d9323471da6$var$getCta(resp);
    return {
        header: (cta === null || cta === void 0 ? void 0 : cta.valueProposition) || "",
        ctaText: (cta === null || cta === void 0 ? void 0 : cta.text) || "",
        ctaUrl: (cta === null || cta === void 0 ? void 0 : cta.url) || "",
        ctaLabel: pageId,
        backgroundColor: (0, $5ohHq.wacToken)("color.extended.blue700"),
        productKey: dataProductKey,
        buttonVariant: "primary",
        buttonColor: "yellow"
    };
};
const $ec721d9323471da6$var$getTestimonialProps = (resp)=>{
    var _data_customers;
    if (!resp || !resp[0]) return undefined;
    const { socialProof: socialProof } = resp[0].node;
    const data = socialProof && socialProof[0] ? socialProof[0] : null;
    if (!data) return undefined;
    return {
        headerText: data === null || data === void 0 ? void 0 : data.name,
        logos: data === null || data === void 0 ? void 0 : (_data_customers = data.customers) === null || _data_customers === void 0 ? void 0 : _data_customers.map((customer)=>{
            return {
                src: customer && customer.altDarkLogo && (customer === null || customer === void 0 ? void 0 : customer.altDarkLogo[0]) && (customer === null || customer === void 0 ? void 0 : customer.altDarkLogo[0].url) ? customer === null || customer === void 0 ? void 0 : customer.altDarkLogo[0].url : "",
                alt: customer && customer.altDarkLogo && (customer === null || customer === void 0 ? void 0 : customer.altDarkLogo[0]) && (customer === null || customer === void 0 ? void 0 : customer.altDarkLogo[0].description) ? customer === null || customer === void 0 ? void 0 : customer.altDarkLogo[0].description : "",
                lazy: true
            };
        })
    };
};
const $ec721d9323471da6$var$getAlternatingTextAndImageProps = (resp)=>{
    const results = $ec721d9323471da6$var$getResults(resp);
    function generateProps(result, index) {
        var _result_asset, _result_asset1;
        // this shouldn't go past
        const countMap = [
            "one",
            "two",
            "three",
            "four"
        ];
        const count = (0, (/*@__PURE__*/$parcel$interopDefault($5tcZn)))(`${countMap[index]}`);
        const position = index % 2 === 1 ? "left" : "right";
        return {
            backgroundColor: (0, $5ohHq.wacToken)("color.neutral.light100"),
            [`row${count}Header`]: (result === null || result === void 0 ? void 0 : result.name) || "",
            [`row${count}Lozenge`]: (result === null || result === void 0 ? void 0 : result.lozenge) || "",
            [`row${count}Body`]: (result === null || result === void 0 ? void 0 : result.subheading) || "",
            [`row${count}ImageLink`]: result === null || result === void 0 ? void 0 : (_result_asset = result.asset) === null || _result_asset === void 0 ? void 0 : _result_asset.url,
            [`row${count}ImageAltText`]: (result === null || result === void 0 ? void 0 : (_result_asset1 = result.asset) === null || _result_asset1 === void 0 ? void 0 : _result_asset1.description) || "",
            [`row${count}ImagePosition`]: position
        };
    }
    const contentBlocks = results === null || results === void 0 ? void 0 : results.map((result, index)=>generateProps(result, index)).slice(0, 4) // ensure max of 4 results so we don't break the pattern
    .filter((result)=>!!result).reduce((acc, curr)=>{
        return (0, $7Knp0._)({}, acc, curr);
    });
    return (0, $7Knp0._)({
        imageWidth: "100%",
        imageTextSideRowOnePaddingBelowLargeScreen: "32px 0 16px",
        imageTextSideRowTwoPadding: "16px 0",
        imageTextSideRowThreePaddingBelowLargeScreen: "16px 0 32px"
    }, contentBlocks);
};
const $ec721d9323471da6$var$getPrimaryMessage = (resp)=>{
    if (!resp || !resp[0]) return null;
    const { primaryMessage: primaryMessage } = resp[0].node;
    const data = primaryMessage && primaryMessage[0] ? primaryMessage[0] : null;
    return data;
};
const $ec721d9323471da6$var$getTabs = (resp, pageVariant, keyword, subAnchor)=>{
    const primaryMessage = $ec721d9323471da6$var$getPrimaryMessage(resp);
    if (!primaryMessage || !(primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.supportingExample)) return undefined;
    if (pageVariant === "keywords") return primaryMessage.supportingExample.filter((tab)=>tab !== null).map((tab)=>({
            textLabel: "",
            id: "",
            component: (0, $fR8rA.generateTabComponent)(keyword, {
                title: (primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.name) || "",
                description: (tab === null || tab === void 0 ? void 0 : tab.name) || "",
                content: (tab === null || tab === void 0 ? void 0 : tab.proofpoint) || ""
            })
        }));
    if (pageVariant === "subAnchor") return primaryMessage.supportingExample.filter((tab)=>tab !== null).map((tab)=>({
            textLabel: "",
            id: "",
            component: (0, $aR9rM.generateTabComponentSubAnchor)(subAnchor, {
                title: (primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.name) || "",
                description: (tab === null || tab === void 0 ? void 0 : tab.name) || "",
                content: (tab === null || tab === void 0 ? void 0 : tab.proofpoint) || ""
            })
        }));
    return primaryMessage.supportingExample.filter((tab)=>tab !== null)// eslint-disable-next-line complexity
    .map((tab)=>{
        var _advocateQuote_advocateHeadshot, _advocateQuote_advocateHeadshot1;
        const supportingAsset = tab === null || tab === void 0 ? void 0 : tab.supportingAsset;
        const advocateQuote = tab === null || tab === void 0 ? void 0 : tab.advocateQuote;
        return {
            textLabel: (tab === null || tab === void 0 ? void 0 : tab.name) || "",
            id: (tab === null || tab === void 0 ? void 0 : tab.name) || "",
            component: /*#__PURE__*/ (0, $loA2J.jsx)((0, $g8Gdb.default), {
                isShowTestimonyBorder: false,
                isIncludeTestimony: !!(tab === null || tab === void 0 ? void 0 : tab.advocateQuote),
                testimonyIsUsingTextQuotationMarks: true,
                title: (tab === null || tab === void 0 ? void 0 : tab.heading) || "",
                rawHtmlContent: (tab === null || tab === void 0 ? void 0 : tab.proofpoint) || "",
                imageSrc: (supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.url) || "",
                imageAlt: (supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.description) || "",
                quoteBlurb: (advocateQuote === null || advocateQuote === void 0 ? void 0 : advocateQuote.advocateQuote) || "",
                quoteName: (advocateQuote === null || advocateQuote === void 0 ? void 0 : advocateQuote.advocateName) || "",
                quoteCompany: (advocateQuote === null || advocateQuote === void 0 ? void 0 : advocateQuote.advocateJobTitle) || "",
                testimonyImageSrc: (advocateQuote === null || advocateQuote === void 0 ? void 0 : (_advocateQuote_advocateHeadshot = advocateQuote.advocateHeadshot) === null || _advocateQuote_advocateHeadshot === void 0 ? void 0 : _advocateQuote_advocateHeadshot.url) || "",
                testimonyImageAlt: (advocateQuote === null || advocateQuote === void 0 ? void 0 : (_advocateQuote_advocateHeadshot1 = advocateQuote.advocateHeadshot) === null || _advocateQuote_advocateHeadshot1 === void 0 ? void 0 : _advocateQuote_advocateHeadshot1.description) || ""
            }, tab === null || tab === void 0 ? void 0 : tab.name)
        };
    });
};
const $ec721d9323471da6$var$getResults = (resp)=>{
    if (!resp || !resp[0]) return null;
    const { results: results } = resp[0].node;
    const data = results && results.length ? results : null;
    return data;
};
const $ec721d9323471da6$var$getCta = (resp)=>{
    if (!resp || !resp[0]) return null;
    const { callToAction: callToAction } = resp[0].node;
    const data = callToAction && callToAction[0] ? callToAction[0] : null;
    return data;
};

});
parcelRegister("5tcZn", function(module, exports) {

var $7Pwoh = parcelRequire("7Pwoh");

var $fkdjt = parcelRequire("fkdjt");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $3fb9bc86d9b07fbd$var$capitalize(string) {
    return $fkdjt($7Pwoh(string).toLowerCase());
}
module.exports = $3fb9bc86d9b07fbd$var$capitalize;

});
parcelRegister("fkdjt", function(module, exports) {

var $jKAgP = parcelRequire("jKAgP");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $b2830cfaaf0eef42$var$upperFirst = $jKAgP("toUpperCase");
module.exports = $b2830cfaaf0eef42$var$upperFirst;

});
parcelRegister("jKAgP", function(module, exports) {

var $ji61b = parcelRequire("ji61b");

var $fPcta = parcelRequire("fPcta");

var $ei0GC = parcelRequire("ei0GC");

var $7Pwoh = parcelRequire("7Pwoh");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $e60e72c04fe5b0cf$var$createCaseFirst(methodName) {
    return function(string) {
        string = $7Pwoh(string);
        var strSymbols = $fPcta(string) ? $ei0GC(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $ji61b(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $e60e72c04fe5b0cf$var$createCaseFirst;

});
parcelRegister("ji61b", function(module, exports) {

var $6Up2L = parcelRequire("6Up2L");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $e0b45dd3e501843f$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $6Up2L(array, start, end);
}
module.exports = $e0b45dd3e501843f$var$castSlice;

});
parcelRegister("6Up2L", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $507b662ca25b5d42$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $507b662ca25b5d42$var$baseSlice;

});


parcelRegister("fPcta", function(module, exports) {
/** Used to compose unicode character classes. */ var $b8554a9b43584300$var$rsAstralRange = "\ud800-\udfff", $b8554a9b43584300$var$rsComboMarksRange = "\\u0300-\\u036f", $b8554a9b43584300$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $b8554a9b43584300$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $b8554a9b43584300$var$rsComboRange = $b8554a9b43584300$var$rsComboMarksRange + $b8554a9b43584300$var$reComboHalfMarksRange + $b8554a9b43584300$var$rsComboSymbolsRange, $b8554a9b43584300$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $b8554a9b43584300$var$rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $b8554a9b43584300$var$reHasUnicode = RegExp("[" + $b8554a9b43584300$var$rsZWJ + $b8554a9b43584300$var$rsAstralRange + $b8554a9b43584300$var$rsComboRange + $b8554a9b43584300$var$rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $b8554a9b43584300$var$hasUnicode(string) {
    return $b8554a9b43584300$var$reHasUnicode.test(string);
}
module.exports = $b8554a9b43584300$var$hasUnicode;

});

parcelRegister("ei0GC", function(module, exports) {

var $1feF0 = parcelRequire("1feF0");

var $fPcta = parcelRequire("fPcta");

var $jlkJG = parcelRequire("jlkJG");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $a673476afac12397$var$stringToArray(string) {
    return $fPcta(string) ? $jlkJG(string) : $1feF0(string);
}
module.exports = $a673476afac12397$var$stringToArray;

});
parcelRegister("1feF0", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $0e82906dc4075dba$var$asciiToArray(string) {
    return string.split("");
}
module.exports = $0e82906dc4075dba$var$asciiToArray;

});

parcelRegister("jlkJG", function(module, exports) {
/** Used to compose unicode character classes. */ var $e150102b5bcf98b0$var$rsAstralRange = "\ud800-\udfff", $e150102b5bcf98b0$var$rsComboMarksRange = "\\u0300-\\u036f", $e150102b5bcf98b0$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $e150102b5bcf98b0$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $e150102b5bcf98b0$var$rsComboRange = $e150102b5bcf98b0$var$rsComboMarksRange + $e150102b5bcf98b0$var$reComboHalfMarksRange + $e150102b5bcf98b0$var$rsComboSymbolsRange, $e150102b5bcf98b0$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $e150102b5bcf98b0$var$rsAstral = "[" + $e150102b5bcf98b0$var$rsAstralRange + "]", $e150102b5bcf98b0$var$rsCombo = "[" + $e150102b5bcf98b0$var$rsComboRange + "]", $e150102b5bcf98b0$var$rsFitz = "\ud83c[\udffb-\udfff]", $e150102b5bcf98b0$var$rsModifier = "(?:" + $e150102b5bcf98b0$var$rsCombo + "|" + $e150102b5bcf98b0$var$rsFitz + ")", $e150102b5bcf98b0$var$rsNonAstral = "[^" + $e150102b5bcf98b0$var$rsAstralRange + "]", $e150102b5bcf98b0$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $e150102b5bcf98b0$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $e150102b5bcf98b0$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $e150102b5bcf98b0$var$reOptMod = $e150102b5bcf98b0$var$rsModifier + "?", $e150102b5bcf98b0$var$rsOptVar = "[" + $e150102b5bcf98b0$var$rsVarRange + "]?", $e150102b5bcf98b0$var$rsOptJoin = "(?:" + $e150102b5bcf98b0$var$rsZWJ + "(?:" + [
    $e150102b5bcf98b0$var$rsNonAstral,
    $e150102b5bcf98b0$var$rsRegional,
    $e150102b5bcf98b0$var$rsSurrPair
].join("|") + ")" + $e150102b5bcf98b0$var$rsOptVar + $e150102b5bcf98b0$var$reOptMod + ")*", $e150102b5bcf98b0$var$rsSeq = $e150102b5bcf98b0$var$rsOptVar + $e150102b5bcf98b0$var$reOptMod + $e150102b5bcf98b0$var$rsOptJoin, $e150102b5bcf98b0$var$rsSymbol = "(?:" + [
    $e150102b5bcf98b0$var$rsNonAstral + $e150102b5bcf98b0$var$rsCombo + "?",
    $e150102b5bcf98b0$var$rsCombo,
    $e150102b5bcf98b0$var$rsRegional,
    $e150102b5bcf98b0$var$rsSurrPair,
    $e150102b5bcf98b0$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $e150102b5bcf98b0$var$reUnicode = RegExp($e150102b5bcf98b0$var$rsFitz + "(?=" + $e150102b5bcf98b0$var$rsFitz + ")|" + $e150102b5bcf98b0$var$rsSymbol + $e150102b5bcf98b0$var$rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $e150102b5bcf98b0$var$unicodeToArray(string) {
    return string.match($e150102b5bcf98b0$var$reUnicode) || [];
}
module.exports = $e150102b5bcf98b0$var$unicodeToArray;

});





parcelRegister("D0EyQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("g8Gdb")).default; });

var $g8Gdb = parcelRequire("g8Gdb");

var $hPglE = parcelRequire("hPglE");

});
parcelRegister("g8Gdb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0cf44a5c63ed9aa$export$2e2bcd8739ae039; });
/* image-checklist-side.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $7L1zQ = parcelRequire("7L1zQ");
parcelRequire("85QdM");
var $fILoL = parcelRequire("fILoL");
parcelRequire("2SXGt");
var $3yfYx = parcelRequire("3yfYx");

var $bhreu = parcelRequire("bhreu");

var $4XrxY = parcelRequire("4XrxY");
// ================================================
// CSS
// ================================================
const $d0cf44a5c63ed9aa$var$checklistWithNoPullQuoteStyle = null;
const $d0cf44a5c63ed9aa$var$titleStyles = null; // ================================================
// Rendering Functions
// ================================================
const $d0cf44a5c63ed9aa$var$HorizontalRuleMobile = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1e0cglyw _7n83ssan _suga1ule"
            ])
        })
    });
const $d0cf44a5c63ed9aa$var$ChecklistWithImage = ({ title: title, listItems: listItems, rawHtmlContent: rawHtmlContent, imageSrc: imageSrc, imageAlt: imageAlt, isIncludeTestimony: isIncludeTestimony = false, quoteBlurb: quoteBlurb, quoteName: quoteName, quoteCompany: quoteCompany, testimonyImageSrc: testimonyImageSrc, testimonyImageAlt: testimonyImageAlt, isShowTestimonyBorder: isShowTestimonyBorder = true, testimonyIsUsingTextQuotationMarks: testimonyIsUsingTextQuotationMarks = false, isSmallQuote: isSmallQuote = false, isIncludeHorizontalMobileRule: isIncludeHorizontalMobileRule = true })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            !isIncludeTestimony && "_xlt1zwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                layout: "4-8",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                className: (0, $esG4f.default)([
                                    "_1pfhidpf _k48pbfng _syaz1bqd _1dyzidpf _1gw8ahaf"
                                ]),
                                children: title
                            }),
                            listItems && listItems.length && /*#__PURE__*/ (0, $loA2J.jsx)((0, $3yfYx.default), {
                                listItems: listItems
                            }),
                            rawHtmlContent && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: "tab-content",
                                dangerouslySetInnerHTML: {
                                    __html: (0, (/*@__PURE__*/$parcel$interopDefault($7L1zQ)))(rawHtmlContent)
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
                            src: imageSrc,
                            alt: imageAlt
                        })
                    })
                ]
            }),
            isIncludeTestimony && isIncludeHorizontalMobileRule && /*#__PURE__*/ (0, $loA2J.jsx)($d0cf44a5c63ed9aa$var$HorizontalRuleMobile, {}),
            isIncludeTestimony && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    isSmallQuote ? "_1q511wqb" : "_1q517vkz"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fILoL.PullQuote), {
                    logoSrc: testimonyImageSrc,
                    logoAltText: testimonyImageAlt,
                    quoteBlurb: quoteBlurb || "",
                    quoteCompany: quoteCompany || "",
                    quoteName: quoteName || "",
                    isShowBorder: isShowTestimonyBorder,
                    isUsingTextQuotationMarks: testimonyIsUsingTextQuotationMarks,
                    isSmall: isSmallQuote
                })
            })
        ]
    });
};
var $d0cf44a5c63ed9aa$export$2e2bcd8739ae039 = $d0cf44a5c63ed9aa$var$ChecklistWithImage;

});
parcelRegister("85QdM", function(module, exports) {
$parcel$export(module.exports, "PullQuote", function () { return (parcelRequire("fILoL")).PullQuote; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("fILoL")).PullQuote; });

var $fILoL = parcelRequire("fILoL");

});
parcelRegister("fILoL", function(module, exports) {

$parcel$export(module.exports, "PullQuote", function () { return $5fda6378fc4d083a$export$f32a6ca59ed1d5d5; });
/* pull-quote.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $bhreu = parcelRequire("bhreu");

var $4XrxY = parcelRequire("4XrxY");
const $5fda6378fc4d083a$var$pullQuoteCss = null;
const $5fda6378fc4d083a$var$borderCss = null;
const $5fda6378fc4d083a$var$smallBorderCss = null;
const $5fda6378fc4d083a$var$smallWidthCss = null;
const $5fda6378fc4d083a$var$quoteCss = null;
const $5fda6378fc4d083a$var$quotationMarkStyle = {
    height: "24px"
};
const $5fda6378fc4d083a$var$quoteBlurbCss = null;
const $5fda6378fc4d083a$var$nameAndCompanyContainerCss = null;
const $5fda6378fc4d083a$var$quoteNameCss = null;
const $5fda6378fc4d083a$var$smallQuoteNameCss = null;
const $5fda6378fc4d083a$var$quoteCompanyCss = null;
const $5fda6378fc4d083a$var$smallQuoteCompanyCss = null;
const $5fda6378fc4d083a$var$pullQuoteImgContainerCss = null;
const $5fda6378fc4d083a$var$pullQuoteImgCss = null; /**
                               * @deprecated - Please use @/libraries/design/components/pull-quote instead
                               */ 
const $5fda6378fc4d083a$export$f32a6ca59ed1d5d5 = ({ logoSrc: logoSrc, logoAltText: logoAltText, quoteBlurb: quoteBlurb, quoteName: quoteName, quoteCompany: quoteCompany, isShowBorder: isShowBorder = false, isUsingTextQuotationMarks: isUsingTextQuotationMarks = false, isSmall: isSmall = false })=>{
    const isShowQuoteLogo = !!logoSrc;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
        layout: "10",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1q51zwfg _85i5zwfg _1e0c1txw _2lx21bp4 _1bah1yb4 _16ng1h6o _ae4v1h6o _1lp7vrvc",
                isShowBorder && !isSmall && "_mqm2136u _179r136u",
                isShowBorder && isSmall && "_mqm21bu1 _179r1bu1",
                isSmall && "_1bsb12it _10fp1h6o"
            ]),
            children: [
                isShowQuoteLogo && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_y3gn1h6o _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _6rthzwfg _12l2idpf _1ob9idpf _1lvazwfg"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                        src: logoSrc || "",
                        alt: logoAltText || "",
                        className: (0, $esG4f.default)([
                            "_5ralzm06 _4t3iuuw1 _1bsb1osq _1xlo1osq _14b5mgvx _glte1wdt"
                        ])
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_y3gn1e5h"
                    ]),
                    children: [
                        !isUsingTextQuotationMarks && /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                            style: $5fda6378fc4d083a$var$quotationMarkStyle,
                            image: {
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/41knb7g4sf3cg6sj54o2uubv0r3r3n33.svg",
                                alt: "Quotation mark"
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _2lx21bp4 _4t3i1w8u _1bah1yb4"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                                    className: (0, $esG4f.default)([
                                        isSmall ? "_syazl4fm" : "_1wybgktf _vwz41f4h _k48pb4wl _1s181f4h _17gq1ylp",
                                        isSmall ? "body-sm" : ""
                                    ]),
                                    children: [
                                        isUsingTextQuotationMarks ? "\u201C" : "",
                                        quoteBlurb,
                                        "\u201D"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                            className: (0, $esG4f.default)([
                                                isSmall ? "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p9y44 _1wyb1crf _vwz4qslr _1p1dangw" : "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p8n31 _1wyb7vkz _vwz41tcg"
                                            ]),
                                            children: quoteName
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                            className: (0, $esG4f.default)([
                                                isSmall ? "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1nn1 _1wyb1crf _vwz4qslr _1p1dangw" : "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb7vkz _vwz41tcg"
                                            ]),
                                            children: quoteCompany
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});


parcelRegister("2SXGt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("3yfYx")).default; });

var $3yfYx = parcelRequire("3yfYx");

});
parcelRegister("3yfYx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $500803e34bc0e53c$export$2e2bcd8739ae039; });
/* checklist.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $4XrxY = parcelRequire("4XrxY");
const $500803e34bc0e53c$var$listItemStyles = null;
const $500803e34bc0e53c$var$Checklist = ({ listItems: listItems })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
        className: (0, $esG4f.default)([
            "_qtt8glyw _lswu1mzw _19bvgktf _19pkidpf _1mswidpf _53os1tcg _f0hdh2mm _2ts0glyw _138k1fm0 _1u82o7ao _s22yzwfg _59281o8l _rus87vkz _1vhestnw _mz937vkz _f1xm7vkz _oonc1y44 _13421l7b _3p611o8l _4fnt7vkz _1exr7vkz _ivf7r3uz _1v9r1j6v _1mmx1k8s"
        ]),
        children: listItems.map((listItem, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Icon), {
                        name: "checkmarkbasic",
                        color: "#6554c0",
                        size: "xs"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        children: listItem
                    })
                ]
            }, index))
    });
};
var $500803e34bc0e53c$export$2e2bcd8739ae039 = $500803e34bc0e53c$var$Checklist;

});



parcelRegister("hPglE", function(module, exports) {

var $loA2J = parcelRequire("loA2J");
const $b8801b26a3dceeed$export$9a4e871e025287ef = (props)=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            props.strongText ? /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                children: props.strongText
            }) : "",
            props.plainText
        ]
    });

});


parcelRegister("3fquc", function(module, exports) {

$parcel$export(module.exports, "PaidLandingTemplate", function () { return $597627ab39e74502$export$b9ca3a4496ce259; });
/* paid-landing.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");
parcelRequire("3QHAr");
var $bESgj = parcelRequire("bESgj");
parcelRequire("fovuc");
var $5ZfUA = parcelRequire("5ZfUA");
parcelRequire("1ppvA");
var $foLdD = parcelRequire("foLdD");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");

var $kG61r = parcelRequire("kG61r");

var $kex29 = parcelRequire("kex29");
parcelRequire("8OrlP");
var $fS5dz = parcelRequire("fS5dz");
parcelRequire("37w71");
var $36iSx = parcelRequire("36iSx");

var $5wOn9 = parcelRequire("5wOn9");
parcelRequire("ccYBS");
var $1FqEx = parcelRequire("1FqEx");

var $g8aT4 = parcelRequire("g8aT4");

var $2T8Od = parcelRequire("2T8Od");

var $ktWzt = parcelRequire("ktWzt");

var $1ZfHO = parcelRequire("1ZfHO");

var $f1BdN = parcelRequire("f1BdN");

var $ka2Mp = parcelRequire("ka2Mp");

var $l0hW2 = parcelRequire("l0hW2");
const $597627ab39e74502$var$HorizontalRule = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_179r137p"
            ]),
            style: {
                "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300"))
            }
        })
    }); // eslint-disable-next-line complexity
const $597627ab39e74502$export$b9ca3a4496ce259 = ({ landingType: landingType, pageId: pageId, showHorizontalRule: showHorizontalRule, productNavProps: productNavProps, bannerAlertProps: bannerAlertProps, heroProps: heroProps, bannerProps: bannerProps, tabsProps: tabsProps, customSection: customSection, customHeroSection: customHeroSection, carouselHeroProps: carouselHeroProps, alternatingTextAndImageProps: alternatingTextAndImageProps, ctaProps: ctaProps, ctaWithPolyGonProps: ctaWithPolyGonProps, testimonialProps: testimonialProps, animatedJiraTourProps: animatedJiraTourProps, hideNavigationBar: hideNavigationBar, heroImageSubheader: heroImageSubheader, resultSectionDivider: resultSectionDivider, hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles, heroBgColor: heroBgColor = "bgWhite", auxiaResponse: auxiaResponse })=>{
    const { isUserLoggedIn: isUserLoggedIn } = (0, $5wOn9.useLoggedInUser)(); // Temporary solution to show animated hero only for logged out users on anchor pages
    // This can be removed once we implement a way to configure this via CMS
    const showAnimatedHero = !isUserLoggedIn && (pageId === "paid-lp-jsw-features" || !!heroProps.useNewHero);
    const showStaticTestimonials = !heroProps.animatedSocialBanner;
    const hasBannerAlert = bannerAlertProps ? true : false;
    const defaultPaidArgs = (0, $6iHNw._)((0, $7Knp0._)({}, heroProps), {
        animatedJiraTourProps: animatedJiraTourProps,
        subheader: heroProps.secondaryText,
        header: heroProps.headerText,
        hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles,
        heroImageSubheader: heroImageSubheader,
        carouselHeroProps: carouselHeroProps,
        hasBannerAlert: hasBannerAlert,
        heroBgColor: heroBgColor,
        auxiaResponse: auxiaResponse
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("main", {
        id: "content",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1FqEx.ParentScrollTracking), {
            pageId: pageId,
            scrollTrackingEnabled: pageId ? true : false,
            children: [
                !hideNavigationBar && /*#__PURE__*/ (0, $loA2J.jsx)((0, $foLdD.ProductNavBar), (0, $7Knp0._)({}, productNavProps)),
                bannerAlertProps && /*#__PURE__*/ (0, $loA2J.jsx)((0, $5ZfUA.BannerAlert), (0, $6iHNw._)((0, $7Knp0._)({}, bannerAlertProps), {
                    hasProductNavBar: !hideNavigationBar
                })),
                customHeroSection ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $ktWzt.PaidCustomHeroSection), {
                    customHeroSection: customHeroSection
                }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $ka2Mp.PaidHeroSectionTypes), {
                    darkSolidTheme: heroProps.darkSolidTheme,
                    landingType: landingType,
                    heroComponent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $f1BdN.PaidHeroSectionTemplate), (0, $7Knp0._)({}, defaultPaidArgs)),
                    showAnimatedHero: showAnimatedHero,
                    showNewHero: defaultPaidArgs.useNewHero
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $l0hW2.PaidTabsSection), (0, $7Knp0._)({}, tabsProps)),
                customSection && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1ZfHO.PaidCustomSection), {
                    customSection: customSection
                }),
                showHorizontalRule && /*#__PURE__*/ (0, $loA2J.jsx)($597627ab39e74502$var$HorizontalRule, {}),
                bannerProps && /*#__PURE__*/ (0, $loA2J.jsx)((0, $36iSx.SimpleImageTextSide), (0, $7Knp0._)({}, bannerProps)),
                resultSectionDivider && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_6rth1cg9"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bESgj.Adg4SectionDivider), {
                        bgColor: resultSectionDivider.color,
                        variation: resultSectionDivider.variation
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $g8aT4.PaidAlternatingImageText), {
                    landingType: landingType,
                    alternatingImageTextProps: alternatingTextAndImageProps
                }),
                ctaProps && /*#__PURE__*/ (0, $loA2J.jsx)((0, $2T8Od.PaidCtaSection), {
                    ctaProps: ctaProps,
                    landingType: landingType
                }),
                ctaWithPolyGonProps && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                resultSectionDivider && "_bfhkyt3g _1pfh1cg9 _4t3iuuw1"
                            ]),
                            style: {
                                "--_1he1i5": (0, $43MIc.default)(resultSectionDivider === null || resultSectionDivider === void 0 ? void 0 : resultSectionDivider.color)
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                resultSectionDivider && "_1pfh1snh"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kG61r.ADG4CtaWithPolygonBackground), (0, $7Knp0._)({}, ctaWithPolyGonProps))
                        })
                    ]
                }),
                showStaticTestimonials && testimonialProps && /*#__PURE__*/ (0, $loA2J.jsx)((0, $fS5dz.PaidSocialProof), (0, $7Knp0._)({}, testimonialProps)),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
            ]
        })
    });
};

});
parcelRegister("fovuc", function(module, exports) {
$parcel$export(module.exports, "BannerAlert", function () { return (parcelRequire("5ZfUA")).BannerAlert; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("5ZfUA")).BannerAlert; });

var $5ZfUA = parcelRequire("5ZfUA");

});
parcelRegister("5ZfUA", function(module, exports) {

$parcel$export(module.exports, "BannerAlert", function () { return $a7a242474da496d8$export$4eb8f3e4e539379b; });
/* banner-alert.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");

var $1syhO = parcelRequire("1syhO");
const $a7a242474da496d8$var$containerStyles = null;
const $a7a242474da496d8$var$contentStyles = null;
const $a7a242474da496d8$var$closeIconStyles = null; /**
                               * @deprecated - Please use @/libraries/design/components/banner-alert instead
                               */ 
const $a7a242474da496d8$export$4eb8f3e4e539379b = ({ identifier: identifier, text: text, linkText: linkText, linkUrl: linkUrl, dataEventProps: dataEventProps, hasProductNavBar: hasProductNavBar })=>{
    const intl = (0, $f6qj2.default)();
    const bannerStorageItem = `BannerAlert_dismiss-${identifier}`;
    const translatedLabel = intl.formatMessage({
        id: "banner-alert.close.aria-label",
        defaultMessage: "Close"
    });
    const [isHidden, setIsHidden] = (0, $iSvIT.useState)(true);
    (0, $iSvIT.useEffect)(()=>{
        let dismissValue = null;
        dismissValue = (0, $1syhO.getLocalStorage)(bannerStorageItem);
        if (dismissValue !== "1") setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    const dynamicStyles = hasProductNavBar ? {
        marginBlockStart: "60px"
    } : {};
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "banner-alert",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            "data-dismissed": isHidden ? "true" : undefined,
            className: (0, $esG4f.default)([
                "_bfhkuzct _kqswh2mm _y4ti1ejb _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _1pbykb7n _nzmgglyw"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                    "aria-label": translatedLabel,
                    onClick: ()=>{
                        setIsHidden(true);
                        (0, $1syhO.setLocalStorage)(bannerStorageItem, "1");
                    },
                    className: (0, $esG4f.default)([
                        "_r06hglyw _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _rjxp1ul9 _152tpxbi _1nj119tk"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Cross), {
                        size: "20"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    style: dynamicStyles,
                    className: (0, $esG4f.default)([
                        "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _bozgxy5q _y4tixncg _1e0c11p5 _syaz1mpp _1a9ox7w3 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1 _1d61glyw _14l354rc"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                children: text
                            }),
                            "\xa0",
                            linkText && linkUrl && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                text: linkText,
                                href: linkUrl,
                                type: "inline",
                                dataEventProps: dataEventProps
                            })
                        ]
                    })
                })
            ]
        })
    });
};

});


parcelRegister("8OrlP", function(module, exports) {
$parcel$export(module.exports, "PaidSocialProof", function () { return (parcelRequire("fS5dz")).PaidSocialProof; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("fS5dz")).PaidSocialProof; });

var $fS5dz = parcelRequire("fS5dz");

});
parcelRegister("fS5dz", function(module, exports) {

$parcel$export(module.exports, "PaidSocialProof", function () { return $db7309abe43fc140$export$ebcf40293fae7986; });
/* paid-social-proof.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $bhreu = parcelRequire("bhreu");
const $db7309abe43fc140$var$customerSectionStyles = null;
const $db7309abe43fc140$var$h3Styles = null;
const $db7309abe43fc140$var$containerStyles = null;
const $db7309abe43fc140$var$imageStyles = null;
const $db7309abe43fc140$var$largeLogoStyles = null;
const $db7309abe43fc140$var$smallLogoStyle = null;
const $db7309abe43fc140$export$ebcf40293fae7986 = ({ headerText: headerText, logos: logos, logoSize: logoSize = "small" })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1bah1h6o _4cvr1h6o _y3gn1h6o _ca0q1j6v _u5f3idpf _n3tdviql _19bvidpf _1k9l12bs _1qwm12bs"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                className: (0, $esG4f.default)([
                    "_1wyb1tcg _vwz411ph _k48pbfng _syaz1bqd _ca0q1j6v _u5f31j6v _n3tdviql _19bv1j6v _1moun7od _3fcw10xh"
                ]),
                children: headerText
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _zulpzb0d _4cvr1h6o _y3gn1h6o _1n261g80 _195g1wug _p12f1fra _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1xf6vrvc _fukk1fhb _e47i1j6v _ldth1j6v _bjh61j6v _1nny1j6v"
                ]),
                children: logos === null || logos === void 0 ? void 0 : logos.map((inlineLogo, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_4t3i66rk _bna71osq _mezj1wug",
                            logoSize === "small" ? "_1u7oldb6" : "_19rt1w81 _1u7o16xz"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                            image: (0, $7Knp0._)({}, inlineLogo)
                        })
                    }, index))
            })
        ]
    });
};
$db7309abe43fc140$export$ebcf40293fae7986.displayName = "PaidSocialProof";

});


parcelRegister("37w71", function(module, exports) {
$parcel$export(module.exports, "SimpleImageTextSide", function () { return (parcelRequire("36iSx")).SimpleImageTextSide; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("36iSx")).SimpleImageTextSide; });

var $36iSx = parcelRequire("36iSx");

});
parcelRegister("36iSx", function(module, exports) {

$parcel$export(module.exports, "SimpleImageTextSide", function () { return $724e6fa8a9d5f35b$export$c449191a6146bc15; });
/* simple-image-text-side.tsx generated by @compiled/babel-plugin v0.28.8 */ //@ts-nocheck

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");
const $724e6fa8a9d5f35b$var$simpleImageTextSideStyle = null;
const $724e6fa8a9d5f35b$var$RenderImage = ({ imageLink: imageLink, imageAltText: imageAltText, aspectRatio: aspectRatio })=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: imageLink,
            alt: imageAltText,
            aspectRatio: aspectRatio
        },
        className: (0, $esG4f.default)([
            "_rtys1osq _1jpx1f51 _mezj1osq _1oo31q9y _bna71wug _688gkb7n"
        ])
    });
const $724e6fa8a9d5f35b$var$RenderContent = ({ eyebrowText: eyebrowText, headerText: headerText, isBannerRichText: isBannerRichText, headerType: headerType, lozenge: lozenge, bodyText: bodyText, ctaProps: ctaProps, horizontalRule: horizontalRule, linkText: linkText, linkUrl: linkUrl })=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                eyebrowText: eyebrowText,
                headerText: headerText,
                isBannerRichText: isBannerRichText,
                headerType: headerType,
                lozenge: lozenge,
                bodyText: bodyText,
                ctaProps: ctaProps,
                horizontalRule: horizontalRule
            }),
            linkText && linkUrl && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                text: linkText,
                href: linkUrl,
                type: "primary"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1jab1ylp _3fdxglyw _5jnq1ylp _uknx7vkz _b9s91ylp"
                ])
            })
        ]
    });
const $724e6fa8a9d5f35b$export$c449191a6146bc15 = ({ eyebrowText: eyebrowText, headerText: headerText, isBannerRichText: isBannerRichText = false, headerType: headerType = "h2", lozenge: lozenge, bodyText: bodyText, linkText: linkText, linkUrl: linkUrl, imageLink: imageLink, imageAltText: imageAltText, imagePosition: imagePosition, className: className = "", ctaProps: ctaProps, aspectRatio: aspectRatio, horizontalRule: horizontalRule = false, alignItems: alignItems = "center", rowProps: rowProps = "6-6", backgroundColor: backgroundColor = "transparent", margin: margin = "80px 0" })=>{
    const renderImageProps = {
        imageLink: imageLink,
        imageAltText: imageAltText,
        aspectRatio: aspectRatio
    };
    const renderContentProps = {
        eyebrowText: eyebrowText,
        headerText: headerText,
        isBannerRichText: isBannerRichText,
        headerType: headerType,
        lozenge: lozenge,
        bodyText: bodyText,
        ctaProps: ctaProps,
        horizontalRule: horizontalRule,
        linkText: linkText,
        linkUrl: linkUrl
    };
    const first = imagePosition === "left" ? /*#__PURE__*/ (0, $loA2J.jsx)($724e6fa8a9d5f35b$var$RenderImage, (0, $7Knp0._)({}, renderImageProps)) : /*#__PURE__*/ (0, $loA2J.jsx)($724e6fa8a9d5f35b$var$RenderContent, (0, $7Knp0._)({}, renderContentProps));
    const second = imagePosition === "left" ? /*#__PURE__*/ (0, $loA2J.jsx)($724e6fa8a9d5f35b$var$RenderContent, (0, $7Knp0._)({}, renderContentProps)) : /*#__PURE__*/ (0, $loA2J.jsx)($724e6fa8a9d5f35b$var$RenderImage, (0, $7Knp0._)({}, renderImageProps));
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_ca0qys9h _u5f3idpf _n3tdys9h _19bvidpf _1kmx7vkz _1ggmidpf _1ykz7vkz _1maeidpf _i6jx1wqb _1lh7idpf _z3nc1wqb _wpaiidpf",
            className
        ]),
        style: {
            "--bkgd-color": backgroundColor,
            "--margin": margin,
            "backgroundColor": "var(--bkgd-color, transparent)",
            "margin": "var(--margin, 0)"
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
            layout: rowProps,
            alignItems: alignItems,
            children: [
                first,
                second
            ]
        })
    });
};

});


parcelRegister("g8aT4", function(module, exports) {

$parcel$export(module.exports, "PaidAlternatingImageText", function () { return $aa0dd19b03b4e303$export$45a2817884af97dc; });
/* paid-alternating-image-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6wqcV = parcelRequire("6wqcV");
const $aa0dd19b03b4e303$var$anchorPageStyles = null;
const $aa0dd19b03b4e303$var$confluenceAnchorStyles = null;
const $aa0dd19b03b4e303$export$45a2817884af97dc = ({ alternatingImageTextProps: alternatingImageTextProps, landingType: landingType })=>{
    if (!alternatingImageTextProps) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            landingType === "jira-software-anchor" && "_7e8vgktf",
            landingType === "confluence-rebranded-anchor" && "_vussviql _1b6r1fw0 _p1061k92"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6wqcV.default), (0, $7Knp0._)({}, alternatingImageTextProps))
    });
};
$aa0dd19b03b4e303$export$45a2817884af97dc.displayName = "PaidAlternatingImageText";

});
parcelRegister("6wqcV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54e11afe56605a57$export$2e2bcd8739ae039; });
/* three-alternating-image-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("37w71");
var $36iSx = parcelRequire("36iSx");
// eslint-disable-next-line complexity
const $54e11afe56605a57$var$ThreeAlternatingImageText = ({ backgroundColor: backgroundColor, backgroundImage: backgroundImage, horizontalRuleColor: horizontalRuleColor, imageWidth: imageWidth, rowHeaderType: rowHeaderType = "h2", rowPropsOdd: rowPropsOdd = "6-6", rowPropsEven: rowPropsEven = "6-6", imageTextSideRowOnePadding: imageTextSideRowOnePadding, imageTextSideRowOnePaddingBelowLargeScreen: imageTextSideRowOnePaddingBelowLargeScreen, rowOneHeader: rowOneHeader, rowOneLozenge: rowOneLozenge, rowOneBody: rowOneBody, rowOneImageLink: rowOneImageLink, rowOneImageAltText: rowOneImageAltText, rowOneImagePosition: rowOneImagePosition = "left", rowOneEyebrowText: rowOneEyebrowText, imageTextSideRowTwoPadding: imageTextSideRowTwoPadding, imageTextSideRowTwoPaddingBelowLargeScreen: imageTextSideRowTwoPaddingBelowLargeScreen, rowTwoHeader: rowTwoHeader, rowTwoLozenge: rowTwoLozenge, rowTwoBody: rowTwoBody, rowTwoImageLink: rowTwoImageLink, rowTwoImageAltText: rowTwoImageAltText, rowTwoImagePosition: rowTwoImagePosition = "right", rowTwoEyebrowText: rowTwoEyebrowText, imageTextSideRowThreePadding: imageTextSideRowThreePadding, imageTextSideRowThreePaddingBelowLargeScreen: imageTextSideRowThreePaddingBelowLargeScreen, rowThreeHeader: rowThreeHeader, rowThreeLozenge: rowThreeLozenge, rowThreeBody: rowThreeBody, rowThreeImageLink: rowThreeImageLink, rowThreeImageAltText: rowThreeImageAltText, rowThreeImagePosition: rowThreeImagePosition = "left", rowThreeEyebrowText: rowThreeEyebrowText, imageTextSideRowFourPadding: imageTextSideRowFourPadding, imageTextSideRowFourPaddingBelowLargeScreen: imageTextSideRowFourPaddingBelowLargeScreen, rowFourHeader: rowFourHeader, rowFourLozenge: rowFourLozenge, rowFourBody: rowFourBody, rowFourImageLink: rowFourImageLink, rowFourImageAltText: rowFourImageAltText = "Alt Text", rowFourImagePosition: rowFourImagePosition, rowFourEyebrowText: rowFourEyebrowText })=>{
    const imageWidthValue = imageWidth !== null && imageWidth !== void 0 ? imageWidth : "550px";
    const imageTextSideRowOnePaddingValue = imageTextSideRowOnePadding !== null && imageTextSideRowOnePadding !== void 0 ? imageTextSideRowOnePadding : "64px 0 16px";
    const imageTextSideRowOnePaddingBelowLargeScreenValue = imageTextSideRowOnePaddingBelowLargeScreen !== null && imageTextSideRowOnePaddingBelowLargeScreen !== void 0 ? imageTextSideRowOnePaddingBelowLargeScreen : "64px 0 16px";
    const imageTextSideRowTwoPaddingValue = imageTextSideRowTwoPadding !== null && imageTextSideRowTwoPadding !== void 0 ? imageTextSideRowTwoPadding : "32px 0";
    const imageTextSideRowTwoPaddingBelowLargeScreenValue = imageTextSideRowTwoPaddingBelowLargeScreen !== null && imageTextSideRowTwoPaddingBelowLargeScreen !== void 0 ? imageTextSideRowTwoPaddingBelowLargeScreen : "16px 0";
    const imageTextSideRowThreePaddingValue = imageTextSideRowThreePadding !== null && imageTextSideRowThreePadding !== void 0 ? imageTextSideRowThreePadding : "16px 0 64px";
    const imageTextSideRowThreePaddingBelowLargeScreenValue = imageTextSideRowThreePaddingBelowLargeScreen !== null && imageTextSideRowThreePaddingBelowLargeScreen !== void 0 ? imageTextSideRowThreePaddingBelowLargeScreen : "16px 0 64px";
    const imageTextSideRowFourPaddingValue = imageTextSideRowFourPadding !== null && imageTextSideRowFourPadding !== void 0 ? imageTextSideRowFourPadding : "16px 0 64px";
    const imageTextSideRowFourPaddingBelowLargeScreenValue = imageTextSideRowFourPaddingBelowLargeScreen !== null && imageTextSideRowFourPaddingBelowLargeScreen !== void 0 ? imageTextSideRowFourPaddingBelowLargeScreen : "16px 0 64px";
    const ThreeAlternatingImageTextStyles = null;
    const isShowHorizontalRule = !!horizontalRuleColor;
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_j2qggma6 _cotpidpf _u5lc1ule _hm0s1wug _ceny1wug _o4bz1oh5 _17xw1bqd _vussviql _i80qidpf _1y3uidpf _vq3z1tcg _1x7sidpf _18m21038 _27c31k8s _e87pidpf _6mt8idpf _vljsdlk8 _1j6nidpf _yza7idpf _1vbdidpf _13r21ylp _dcnaidpf _vbkqidpf _9by51q87 _1of01mpp _5wk3idpf _1fus1j99 _19y1l3tq _1ltr7ip2 _1g391fux _amtq1col _kju2v4do _1djgx7vm _1drv1abn"
        ]),
        style: {
            "--_bwa4xl": (0, $43MIc.default)(imageWidthValue),
            "--_1cdekw0": (0, $43MIc.default)(horizontalRuleColor),
            "--_1o5bebe": (0, $43MIc.default)(imageTextSideRowOnePaddingValue),
            "--_1dlh24j": (0, $43MIc.default)(imageTextSideRowOnePaddingBelowLargeScreenValue),
            "--_1nsshok": (0, $43MIc.default)(imageTextSideRowTwoPaddingValue),
            "--_1e6od0m": (0, $43MIc.default)(imageTextSideRowTwoPaddingBelowLargeScreenValue),
            "--_1u1sozo": (0, $43MIc.default)(imageTextSideRowThreePaddingValue),
            "--_1div133": (0, $43MIc.default)(imageTextSideRowThreePaddingBelowLargeScreenValue),
            "--_1rnt45i": (0, $43MIc.default)(imageTextSideRowFourPaddingValue),
            "--_15kis35": (0, $43MIc.default)(imageTextSideRowFourPaddingBelowLargeScreenValue)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_bfhkaxbu _1itk1u11",
                "background-side-by-side"
            ]),
            style: {
                "--_1ly4823": (0, $43MIc.default)(backgroundColor),
                "--_1jwom28": (0, $43MIc.default)(backgroundImage)
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $36iSx.SimpleImageTextSide), {
                    headerType: rowHeaderType,
                    headerText: rowOneHeader,
                    lozenge: rowOneLozenge,
                    bodyText: rowOneBody,
                    imageLink: rowOneImageLink,
                    imageAltText: rowOneImageAltText,
                    imagePosition: rowOneImagePosition,
                    horizontalRule: isShowHorizontalRule,
                    className: "image-text-side-row-1",
                    eyebrowText: rowOneEyebrowText,
                    rowProps: rowPropsOdd
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $36iSx.SimpleImageTextSide), {
                    headerType: rowHeaderType,
                    headerText: rowTwoHeader,
                    lozenge: rowTwoLozenge,
                    bodyText: rowTwoBody,
                    imageLink: rowTwoImageLink,
                    imageAltText: rowTwoImageAltText,
                    horizontalRule: isShowHorizontalRule,
                    imagePosition: rowTwoImagePosition,
                    className: "image-text-side-row-2",
                    eyebrowText: rowTwoEyebrowText,
                    rowProps: rowPropsEven
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $36iSx.SimpleImageTextSide), {
                    headerType: rowHeaderType,
                    headerText: rowThreeHeader,
                    lozenge: rowThreeLozenge,
                    bodyText: rowThreeBody,
                    imageLink: rowThreeImageLink,
                    imageAltText: rowThreeImageAltText,
                    imagePosition: rowThreeImagePosition,
                    horizontalRule: isShowHorizontalRule,
                    className: "image-text-side-row-3",
                    eyebrowText: rowThreeEyebrowText,
                    rowProps: rowPropsOdd
                }),
                rowFourImageLink ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $36iSx.SimpleImageTextSide), {
                    headerType: rowHeaderType,
                    headerText: rowFourHeader,
                    lozenge: rowFourLozenge,
                    bodyText: rowFourBody,
                    imageLink: rowFourImageLink,
                    imageAltText: rowFourImageAltText,
                    imagePosition: rowFourImagePosition,
                    horizontalRule: isShowHorizontalRule,
                    className: "image-text-side-row-4",
                    eyebrowText: rowFourEyebrowText,
                    rowProps: rowPropsEven
                }) : null
            ]
        })
    });
};
$54e11afe56605a57$var$ThreeAlternatingImageText.displayName = "ThreeAlternatingImageText";
var $54e11afe56605a57$export$2e2bcd8739ae039 = $54e11afe56605a57$var$ThreeAlternatingImageText;

});


parcelRegister("2T8Od", function(module, exports) {

$parcel$export(module.exports, "PaidCtaSection", function () { return $7d0f18c817ee6502$export$5e5db24264a78d; });
/* paid-cta-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("bseXG");
var $oAjmY = parcelRequire("oAjmY");
const $7d0f18c817ee6502$var$ctaStyles = {
    "jira-software": "_syaz1m8h _12vemgnk _ouxl1ssb _1lrw1dfr _1itk14uh _1dhs103n",
    "jira-software-anchor": "_syazr3uz _bfhkoelr _6vsiidpf _t0odidpf _mqkjidpf _xz03idpf",
    "jira-software-rebranded-anchor": "_syazr3uz _bfhkoelr _6vsiidpf _t0odidpf _mqkjidpf _xz03idpf",
    "jira-service-management": "_syazu67f _1itkj4zg _ouxl1ssb _1lrw1dfr _12vemgnk",
    "jira-service-management-anchor": "_syazu67f _1itk1k2f _ouxl1ssb _1lrw1dfr _12vemgnk",
    "confluence-paid": "_syazu67f _1itkuuyn _ouxl1ssb _1lrw1dfr _12vemgnk",
    "confluence-anchor": "_1itk1gd4 _ouxl1ssb _12vemgnk _1lrw1dfr _ol8u1keg _1rmvwbzg _1f9f995e _r2cimgnk _u6yg1f51",
    "confluence-rebranded-anchor": "_1itk1gd4 _ouxl1ssb _12vemgnk _1lrw1dfr _ol8u1keg _1rmvwbzg _1f9f995e _r2cimgnk _u6yg1f51"
};
const $7d0f18c817ee6502$export$5e5db24264a78d = ({ ctaProps: ctaProps, landingType: landingType })=>{
    const { layout: ctaLayout = "10" } = ctaProps, otherCtaProps = (0, $akGnX._)(ctaProps, [
        "layout"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            $7d0f18c817ee6502$var$ctaStyles[landingType]
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            layout: ctaLayout,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $oAjmY.PaidCtaPrimary), (0, $7Knp0._)({}, otherCtaProps))
        })
    });
};
$7d0f18c817ee6502$export$5e5db24264a78d.displayName = "PaidCta";

});
parcelRegister("bseXG", function(module, exports) {
$parcel$export(module.exports, "PaidCtaPrimary", function () { return (parcelRequire("oAjmY")).PaidCtaPrimary; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("oAjmY")).PaidCtaPrimary; });

var $oAjmY = parcelRequire("oAjmY");

});
parcelRegister("oAjmY", function(module, exports) {

$parcel$export(module.exports, "PaidCtaPrimary", function () { return $ff0bde82509c25d4$export$a88d1ab51f344f2e; });
/* paid-cta-primary.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
parcelRequire("ebLO8");
var $hd9uO = parcelRequire("hd9uO");
const $ff0bde82509c25d4$var$ctaSectionBaseStyle = null;
const $ff0bde82509c25d4$export$a88d1ab51f344f2e = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_xgyx1k8s _1xcsahaf"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hd9uO.CTAPrimary), (0, $7Knp0._)({
            className: "cta-primary",
            backgroundProperties: {
                /* this is deprecated, but need it temporarily to override current behavior */ textColor: "n0"
            }
        }, props))
    });
};

});
parcelRegister("ebLO8", function(module, exports) {
$parcel$export(module.exports, "CTAPrimary", function () { return (parcelRequire("hd9uO")).CTAPrimary; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("hd9uO")).CTAPrimary; });

var $hd9uO = parcelRequire("hd9uO");

});
parcelRegister("hd9uO", function(module, exports) {

$parcel$export(module.exports, "CTAPrimary", function () { return $7410bb543046794d$export$2803c38b17523474; });
/* cta-primary.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");

var $4XrxY = parcelRequire("4XrxY");
const $7410bb543046794d$var$ctaPrimaryStyle = null;
const $7410bb543046794d$export$2803c38b17523474 = ({ headerText: headerText, bodyText: bodyText, className: className, eyebrowText: eyebrowText, footNoteText: footNoteText, ctaProps: ctaProps, backgroundProperties: backgroundProperties })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.StyledBackground), (0, $6iHNw._)((0, $7Knp0._)({}, backgroundProperties), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1akovbgk _c7s7idpf _4puvvbgk _1r3vidpf _y3gn1h6o _i6jxckbl _1lh7idpf _z3ncckbl _wpaiidpf _1kmxzwfg _1ggmidpf _1ykzzwfg _1maeidpf _1916oxwj _jti51ul9 _xjyr1wug _2thuidpf _hbr31wug",
                className
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: "primary-cta-content",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                        isCentered: true,
                        headerText: headerText,
                        headerType: "h2",
                        eyebrowText: eyebrowText,
                        bodyText: bodyText,
                        ctaProps: ctaProps
                    }),
                    footNoteText ? /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: "footnote-text",
                        children: footNoteText
                    }) : null
                ]
            })
        })
    }));
};

});





parcelRegister("ktWzt", function(module, exports) {

$parcel$export(module.exports, "PaidCustomHeroSection", function () { return $f06ef0f0309e1767$export$a51999b742dcc5f1; });

var $loA2J = parcelRequire("loA2J");
const $f06ef0f0309e1767$export$a51999b742dcc5f1 = ({ customHeroSection: // eslint-disable-next-line react/prop-types
customHeroSection })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: customHeroSection
    });
};
$f06ef0f0309e1767$export$a51999b742dcc5f1.displayName = "CustomHero";

});

parcelRegister("1ZfHO", function(module, exports) {

$parcel$export(module.exports, "PaidCustomSection", function () { return $b2614cd9a62213b6$export$4781d68a90c3d141; });

var $loA2J = parcelRequire("loA2J");
const $b2614cd9a62213b6$export$4781d68a90c3d141 = ({ customSection: // eslint-disable-next-line react/prop-types
customSection })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: customSection
    });
};
$b2614cd9a62213b6$export$4781d68a90c3d141.displayName = "Custom";

});

parcelRegister("f1BdN", function(module, exports) {

$parcel$export(module.exports, "PaidHeroSectionTemplate", function () { return $da2112968d5b09bb$export$b2d485e7a33c4d4a; });
/* paid-hero-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $eVwxl = parcelRequire("eVwxl");

var $7L1zQ = parcelRequire("7L1zQ");
parcelRequire("al79j");
var $2kLmv = parcelRequire("2kLmv");
var $4L1BA = parcelRequire("4L1BA");

var $gZ0A3 = parcelRequire("gZ0A3");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $cQk7Y = parcelRequire("cQk7Y");

var $1syhO = parcelRequire("1syhO");

var $5KXGt = parcelRequire("5KXGt");

var $f2a5L = parcelRequire("f2a5L");
const $da2112968d5b09bb$var$formColumn = null;
const $da2112968d5b09bb$var$formColumnWithEyelash = null;
const $da2112968d5b09bb$var$HeaderEyelashStyle = null;
const $da2112968d5b09bb$var$contentStyle = null;
const $da2112968d5b09bb$var$withAnimation = null;
const $da2112968d5b09bb$var$signupFormContainer = null;
const $da2112968d5b09bb$var$headingBasicStyles = null;
const $da2112968d5b09bb$var$heavyFontWeightStyles = null;
const $da2112968d5b09bb$var$subheaderStyles = null;
const $da2112968d5b09bb$var$whiteFontColor = null;
const $da2112968d5b09bb$var$subheaderStylesWithEyelash = null;
const $da2112968d5b09bb$var$imgContainer = null;
const $da2112968d5b09bb$var$staticImageContainer = null;
const $da2112968d5b09bb$var$animationHeroContainer = null;
const $da2112968d5b09bb$var$carouselContainerStyles = null;
const $da2112968d5b09bb$var$squaresContainer = null;
const $da2112968d5b09bb$var$squareOne = null;
const $da2112968d5b09bb$var$squareTwo = null;
const $da2112968d5b09bb$var$eyelashStyle = null;
const $da2112968d5b09bb$var$underlineStyles = null;
const $da2112968d5b09bb$var$strokeRight = null;
const $da2112968d5b09bb$var$accentImgStyles = null;
const $da2112968d5b09bb$var$AnimatedJiraTourStyles = null;
const $da2112968d5b09bb$var$heroImageSubheaderStyles = null;
const $da2112968d5b09bb$var$Squares = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqswstnw _1bsb1osq _4t3i1lk2 _1e0c1txw _2lx21bp4"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _152tidpf _rjxpidpf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                    width: "311",
                    height: "220",
                    viewBox: "0 0 311 220",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M7.34559 1.71298L310.956 0.712733L305.579 218.935L0.637246 219.618L7.34559 1.71298Z",
                        fill: "#FFA900"
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _u7coidpf _1e02idpf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                    width: "252",
                    height: "219",
                    viewBox: "0 0 252 219",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M2.76007 0.226074H251.614V212.007L0.0842285 218.146L2.76007 0.226074Z",
                        fill: "#82B536"
                    })
                })
            })
        ]
    });
};
const $da2112968d5b09bb$var$EyeLash = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        className: (0, $esG4f.default)([
            "_y44vlrv9 _kqswh2mm",
            "_kqswstnw _1e0c1o8l _152t1mi1 _1e02bx3o _1bsb1wpv _4t3ickbl _1s4pd6z3 _1kne1wpv _1rfm1f4h _tnru1u1b",
            "eyelash"
        ]),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/f0scafs8p034p4uxb1r3f84m05g8s742.svg",
            alt: "",
            width: 99,
            height: 50
        }
    });
};
const $da2112968d5b09bb$var$Scribble = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        className: (0, $esG4f.default)([
            "_y44vlrv9 _kqswh2mm",
            "_4t3i7vkz _1bsbl1r9 _6rth7vkz _dh1a1e5h _ag851e5h",
            "scribble"
        ]),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4g12qeh147330006huh36yys682jpa05.svg",
            alt: "",
            width: 90,
            height: 16
        }
    });
};
const $da2112968d5b09bb$var$AnimationWrapper = ({ lottieAnimationPromise: lottieAnimationPromise, riveAnimation: RiveAnimation })=>{
    const [lottieAnimationData, setLottieAnimationData] = (0, $iSvIT.useState)();
    (0, $iSvIT.useEffect)(()=>{
        (async ()=>{
            if (lottieAnimationPromise && !RiveAnimation) {
                const lottieAnimation = await lottieAnimationPromise;
                setLottieAnimationData(lottieAnimation);
            }
        })();
    }, [
        RiveAnimation,
        lottieAnimationPromise
    ]);
    if (RiveAnimation) return /*#__PURE__*/ (0, $loA2J.jsx)(RiveAnimation, {});
    else if (lottieAnimationData) return /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eVwxl))), {
        options: {
            loop: false,
            autoplay: true,
            animationData: lottieAnimationData,
            rendererSettings: {
                preserveAspectRatio: "xMidYMid slice"
            }
        }
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        "data-testid": "default-animation",
        viewBox: "0 0 600 350",
        width: "600",
        height: "350",
        style: {
            width: "100%"
        }
    });
}; // eslint-disable-next-line complexity
const $da2112968d5b09bb$export$b2d485e7a33c4d4a = ({ header: header, subheader: subheader, image: image, darkSolidTheme: darkSolidTheme, showAnimatedHero: showAnimatedHero, carouselHeroProps: carouselHeroProps, animatedJiraTourProps: animatedJiraTourProps, heroImageSubheader: heroImageSubheader, hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles, showScribble: showScribble, showEyeLash: showEyeLash, animation: animation, hasBannerAlert: hasBannerAlert = false, heroBgColor: heroBgColor = "bgWhite", showFourSocialButtons: showFourSocialButtons, auxiaResponse: auxiaResponse })=>{
    var _this, _carouselHeroProps_slides;
    // the default behavior is to show the animated hero image based on darkSolidTheme
    // however we can override this behavior if showAnimatedHero is explicitly set
    const showAnimated = showAnimatedHero !== undefined ? showAnimatedHero : !darkSolidTheme;
    (0, $iSvIT.useEffect)(()=>{
        const getaaCompleteQueryObj = (0, $1syhO.getLocalStorage)((0, $cQk7Y.AA_AUTOCOMPLETE_POTENTIAL_CONVERSION_EVENT_LOCAL_STORAGE_KEY));
        if (getaaCompleteQueryObj) {
            const parsedStringifyAttributes = JSON.parse(getaaCompleteQueryObj);
            (0, $cQk7Y.sendConversionEventAlgolia)({
                objectID: parsedStringifyAttributes.objectID,
                queryID: parsedStringifyAttributes.queryID,
                position: parsedStringifyAttributes.position
            });
        }
    }, []);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx2vrvc _zulpzwfg _85i5gad4 _1bah1h6o _4cvr1h6o _ogq01wqb _p56c1wqb _na0i1bp4 _v736zwfg _chtuzwfg",
            animation && "_na0i1sxn",
            !hasBannerAlert && "_1q512to5"
        ]),
        style: {
            "--_1grn0ad": (0, $43MIc.default)(darkSolidTheme ? "60px" : "40px")
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _10jxdgin _dh1a1h6o",
                    showEyeLash && "_10jx1kx4",
                    heroBgColor !== "bgWhite" && "_syazcd5j"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            showEyeLash && "_kqswh2mm"
                        ]),
                        children: [
                            showEyeLash && /*#__PURE__*/ (0, $loA2J.jsx)($da2112968d5b09bb$var$EyeLash, {}),
                            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                                className: (0, $esG4f.default)([
                                    "_1dyzidpf _1pfhidpf _6rthidpf _k48pbfng _1wybviql _vwz410nf _y3gn1h6o _uj6k1e5h _1hwfyn4p _cr9zzz36 _1awl7vkz _h60i1wto _s3b91k7u _1qir1tcg",
                                    hasRebrandedSignupFormStyles && "_k48p9y44"
                                ]),
                                children: header
                            })
                        ]
                    }),
                    darkSolidTheme && /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: (0, $esG4f.default)([
                            "_6rth7vkz _y3gn1h6o _uj6k1e5h",
                            heroBgColor !== "bgWhite" && "_syazcd5j"
                        ]),
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                        },
                        children: subheader
                    }),
                    showScribble && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                className: (0, $esG4f.default)([
                                    "_syaz1hlo _ect4bzd7 _1wyb7vkz _zg8l4jg8 _k48p1nn1 _vwz41tcg _1mjb1txw _o5kc1e5h"
                                ]),
                                style: {
                                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                },
                                children: subheader
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)($da2112968d5b09bb$var$Scribble, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_p12f1feq _1bsb1osq"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5KXGt.ClientOnly), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $f2a5L.PaidAccountCreation), {
                                darkSolidTheme: darkSolidTheme,
                                showFourSocialButtons: showFourSocialButtons,
                                auxiaResponse: auxiaResponse
                            })
                        })
                    })
                ]
            }),
            animation && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)($da2112968d5b09bb$var$AnimationWrapper, (0, $7Knp0._)({}, animation))
            }),
            showAnimated && /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _1h1th1c8 _4t3i1wug _1tket94y _1bsb1osq _1ul91c3h _p12f1c3h _1e0c1txw _4cvr1h6o _1bah1h6o _s6371ogm _1y8o1c3h _1mjbglyw _ca0q1ul9 _u5f31ul9 _n3td1ul9 _19bv1ul9"
                ]),
                children: [
                    (darkSolidTheme || hasRebrandedSignupFormStyles) && /*#__PURE__*/ (0, $loA2J.jsx)($da2112968d5b09bb$var$Squares, {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $gZ0A3.AnimatedJiraTour), (0, $6iHNw._)((0, $7Knp0._)({}, animatedJiraTourProps), {
                        className: (0, $esG4f.default)([
                            "_kqswstnw _152t16gx _rjxp9by0 _1e029by0 _u7co16gx _1pbyzo7u"
                        ])
                    }))
                ]
            }),
            carouselHeroProps ? ((_this = (_carouselHeroProps_slides = carouselHeroProps.slides) === null || _carouselHeroProps_slides === void 0 ? void 0 : _carouselHeroProps_slides[0]) === null || _this === void 0 ? void 0 : _this["videoSrcMp4"]) ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4cvr1h6o _1e0c1txw _1bah1h6o _1bsbcv93 _4t3i1ogm _1rfm1osq _tnru1osq"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2kLmv.VideoCarousel), (0, $7Knp0._)({}, carouselHeroProps))
            }) : /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4cvr1h6o _1e0c1txw _1bah1h6o _1bsbcv93 _4t3i1ogm _1rfm1osq _tnru1osq"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4L1BA.Carousel), (0, $7Knp0._)({}, carouselHeroProps))
            }) : (image || heroImageSubheader) && /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    showAnimated ? "_1e0cglyw _1mjb1txw _o5kc1h6o _na0i1bp4" : "_1bsbstmo _1wpz1h6o _1mjb1txw _o5kc1h6o _na0i1bp4 _1rfm1wug"
                ]),
                children: [
                    image && /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: image,
                        style: {
                            maxWidth: "100%",
                            height: "auto"
                        }
                    }),
                    heroImageSubheader && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: (0, (/*@__PURE__*/$parcel$interopDefault($7L1zQ)))(heroImageSubheader)
                        },
                        className: (0, $esG4f.default)([
                            "_ca0qidpf _u5f39by0 _n3tdidpf _19bv9by0",
                            heroBgColor !== "bgWhite" && "_syazcd5j"
                        ]),
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                        }
                    })
                ]
            })
        ]
    });
};
$da2112968d5b09bb$export$b2d485e7a33c4d4a.displayName = "PaidHero";

});
parcelRegister("eVwxl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $g2Zao = parcelRequire("g2Zao");
var $addfa0b2bba7c1f7$var$_extends3 = $addfa0b2bba7c1f7$var$_interopRequireDefault($g2Zao);

var $1h8uE = parcelRequire("1h8uE");
var $addfa0b2bba7c1f7$var$_getPrototypeOf2 = $addfa0b2bba7c1f7$var$_interopRequireDefault($1h8uE);

var $9WQmH = parcelRequire("9WQmH");
var $addfa0b2bba7c1f7$var$_classCallCheck3 = $addfa0b2bba7c1f7$var$_interopRequireDefault($9WQmH);

var $cvgGt = parcelRequire("cvgGt");
var $addfa0b2bba7c1f7$var$_createClass3 = $addfa0b2bba7c1f7$var$_interopRequireDefault($cvgGt);

var $lJwmB = parcelRequire("lJwmB");
var $addfa0b2bba7c1f7$var$_possibleConstructorReturn3 = $addfa0b2bba7c1f7$var$_interopRequireDefault($lJwmB);

var $2jBgE = parcelRequire("2jBgE");
var $addfa0b2bba7c1f7$var$_inherits3 = $addfa0b2bba7c1f7$var$_interopRequireDefault($2jBgE);

var $iSvIT = parcelRequire("iSvIT");
var $addfa0b2bba7c1f7$var$_react2 = $addfa0b2bba7c1f7$var$_interopRequireDefault($iSvIT);

var $4J1z5 = parcelRequire("4J1z5");
var $addfa0b2bba7c1f7$var$_propTypes2 = $addfa0b2bba7c1f7$var$_interopRequireDefault($4J1z5);

var $RDZaD = parcelRequire("RDZaD");
var $addfa0b2bba7c1f7$var$_lottieWeb2 = $addfa0b2bba7c1f7$var$_interopRequireDefault($RDZaD);
function $addfa0b2bba7c1f7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $addfa0b2bba7c1f7$var$Lottie = function(_React$Component) {
    (0, $addfa0b2bba7c1f7$var$_inherits3.default)(Lottie, _React$Component);
    function Lottie() {
        var _ref;
        var _temp, _this, _ret;
        (0, $addfa0b2bba7c1f7$var$_classCallCheck3.default)(this, Lottie);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, $addfa0b2bba7c1f7$var$_possibleConstructorReturn3.default)(this, (_ref = Lottie.__proto__ || (0, $addfa0b2bba7c1f7$var$_getPrototypeOf2.default)(Lottie)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.handleClickToPause = function() {
            // The pause() method is for handling pausing by passing a prop isPaused
            // This method is for handling the ability to pause by clicking on the animation
            if (_this.anim.isPaused) _this.anim.play();
            else _this.anim.pause();
        }, _temp), (0, $addfa0b2bba7c1f7$var$_possibleConstructorReturn3.default)(_this, _ret);
    }
    (0, $addfa0b2bba7c1f7$var$_createClass3.default)(Lottie, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _props = this.props, options = _props.options, eventListeners = _props.eventListeners;
                var loop = options.loop, autoplay = options.autoplay, animationData = options.animationData, rendererSettings = options.rendererSettings, segments = options.segments;
                this.options = {
                    container: this.el,
                    renderer: "svg",
                    loop: loop !== false,
                    autoplay: autoplay !== false,
                    segments: segments !== false,
                    animationData: animationData,
                    rendererSettings: rendererSettings
                };
                this.options = (0, $addfa0b2bba7c1f7$var$_extends3.default)({}, this.options, options);
                this.anim = $addfa0b2bba7c1f7$var$_lottieWeb2.default.loadAnimation(this.options);
                this.registerEvents(eventListeners);
            }
        },
        {
            key: "componentWillUpdate",
            value: function componentWillUpdate(nextProps /* , nextState */ ) {
                /* Recreate the animation handle if the data is changed */ if (this.options.animationData !== nextProps.options.animationData) {
                    this.deRegisterEvents(this.props.eventListeners);
                    this.destroy();
                    this.options = (0, $addfa0b2bba7c1f7$var$_extends3.default)({}, this.options, nextProps.options);
                    this.anim = $addfa0b2bba7c1f7$var$_lottieWeb2.default.loadAnimation(this.options);
                    this.registerEvents(nextProps.eventListeners);
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (this.props.isStopped) this.stop();
                else if (this.props.segments) this.playSegments();
                else this.play();
                this.pause();
                this.setSpeed();
                this.setDirection();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.deRegisterEvents(this.props.eventListeners);
                this.destroy();
                this.options.animationData = null;
                this.anim = null;
            }
        },
        {
            key: "setSpeed",
            value: function setSpeed() {
                this.anim.setSpeed(this.props.speed);
            }
        },
        {
            key: "setDirection",
            value: function setDirection() {
                this.anim.setDirection(this.props.direction);
            }
        },
        {
            key: "play",
            value: function play() {
                this.anim.play();
            }
        },
        {
            key: "playSegments",
            value: function playSegments() {
                this.anim.playSegments(this.props.segments);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.anim.stop();
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this.props.isPaused && !this.anim.isPaused) this.anim.pause();
                else if (!this.props.isPaused && this.anim.isPaused) this.anim.pause();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.anim.destroy();
            }
        },
        {
            key: "registerEvents",
            value: function registerEvents(eventListeners) {
                var _this2 = this;
                eventListeners.forEach(function(eventListener) {
                    _this2.anim.addEventListener(eventListener.eventName, eventListener.callback);
                });
            }
        },
        {
            key: "deRegisterEvents",
            value: function deRegisterEvents(eventListeners) {
                var _this3 = this;
                eventListeners.forEach(function(eventListener) {
                    _this3.anim.removeEventListener(eventListener.eventName, eventListener.callback);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                var _props2 = this.props, width = _props2.width, height = _props2.height, ariaRole = _props2.ariaRole, ariaLabel = _props2.ariaLabel, isClickToPauseDisabled = _props2.isClickToPauseDisabled, title = _props2.title;
                var getSize = function getSize(initial) {
                    var size = void 0;
                    if (typeof initial === "number") size = initial + "px";
                    else size = initial || "100%";
                    return size;
                };
                var lottieStyles = (0, $addfa0b2bba7c1f7$var$_extends3.default)({
                    width: getSize(width),
                    height: getSize(height),
                    overflow: "hidden",
                    margin: "0 auto",
                    outline: "none"
                }, this.props.style);
                var onClickHandler = isClickToPauseDisabled ? function() {
                    return null;
                } : this.handleClickToPause;
                return(// Bug with eslint rules https://github.com/airbnb/javascript/issues/1374
                // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                $addfa0b2bba7c1f7$var$_react2.default.createElement("div", {
                    ref: function ref(c) {
                        _this4.el = c;
                    },
                    style: lottieStyles,
                    onClick: onClickHandler,
                    title: title,
                    role: ariaRole,
                    "aria-label": ariaLabel,
                    tabIndex: "0"
                }));
            }
        }
    ]);
    return Lottie;
}($addfa0b2bba7c1f7$var$_react2.default.Component);
module.exports.default = $addfa0b2bba7c1f7$var$Lottie;
$addfa0b2bba7c1f7$var$Lottie.propTypes = {
    eventListeners: $addfa0b2bba7c1f7$var$_propTypes2.default.arrayOf($addfa0b2bba7c1f7$var$_propTypes2.default.object),
    options: $addfa0b2bba7c1f7$var$_propTypes2.default.object.isRequired,
    height: $addfa0b2bba7c1f7$var$_propTypes2.default.oneOfType([
        $addfa0b2bba7c1f7$var$_propTypes2.default.string,
        $addfa0b2bba7c1f7$var$_propTypes2.default.number
    ]),
    width: $addfa0b2bba7c1f7$var$_propTypes2.default.oneOfType([
        $addfa0b2bba7c1f7$var$_propTypes2.default.string,
        $addfa0b2bba7c1f7$var$_propTypes2.default.number
    ]),
    isStopped: $addfa0b2bba7c1f7$var$_propTypes2.default.bool,
    isPaused: $addfa0b2bba7c1f7$var$_propTypes2.default.bool,
    speed: $addfa0b2bba7c1f7$var$_propTypes2.default.number,
    segments: $addfa0b2bba7c1f7$var$_propTypes2.default.arrayOf($addfa0b2bba7c1f7$var$_propTypes2.default.number),
    direction: $addfa0b2bba7c1f7$var$_propTypes2.default.number,
    ariaRole: $addfa0b2bba7c1f7$var$_propTypes2.default.string,
    ariaLabel: $addfa0b2bba7c1f7$var$_propTypes2.default.string,
    isClickToPauseDisabled: $addfa0b2bba7c1f7$var$_propTypes2.default.bool,
    title: $addfa0b2bba7c1f7$var$_propTypes2.default.string,
    style: $addfa0b2bba7c1f7$var$_propTypes2.default.string
};
$addfa0b2bba7c1f7$var$Lottie.defaultProps = {
    eventListeners: [],
    isStopped: false,
    isPaused: false,
    speed: 1,
    ariaRole: "button",
    ariaLabel: "animation",
    isClickToPauseDisabled: false,
    title: ""
};

});
parcelRegister("g2Zao", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $baec47b06afad90b$export$1e511d4a378977f5; }, function (v) { return $baec47b06afad90b$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $baec47b06afad90b$export$2e2bcd8739ae039; }, function (v) { return $baec47b06afad90b$export$2e2bcd8739ae039 = v; });
var $baec47b06afad90b$export$1e511d4a378977f5;
var $baec47b06afad90b$export$2e2bcd8739ae039;
"use strict";
$baec47b06afad90b$export$1e511d4a378977f5 = true;

var $bdshB = parcelRequire("bdshB");
var $baec47b06afad90b$var$_assign2 = $baec47b06afad90b$var$_interopRequireDefault($bdshB);
function $baec47b06afad90b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$baec47b06afad90b$export$2e2bcd8739ae039 = $baec47b06afad90b$var$_assign2.default || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

});
parcelRegister("bdshB", function(module, exports) {

module.exports = {
    "default": (parcelRequire("78ymw")),
    __esModule: true
};

});
parcelRegister("78ymw", function(module, exports) {
parcelRequire("b19eZ");

module.exports = (parcelRequire("4SFzU")).Object.assign;

});
parcelRegister("b19eZ", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $75Z3R = parcelRequire("75Z3R");

$75Z3R($75Z3R.S + $75Z3R.F, "Object", {
    assign: (parcelRequire("8gbK9"))
});

});
parcelRegister("75Z3R", function(module, exports) {

var $1AuLW = parcelRequire("1AuLW");

var $4SFzU = parcelRequire("4SFzU");

var $3sJtH = parcelRequire("3sJtH");

var $iExTK = parcelRequire("iExTK");

var $g0HGW = parcelRequire("g0HGW");
var $52a85d87ab01f988$var$PROTOTYPE = "prototype";
var $52a85d87ab01f988$var$$export = function(type, name, source) {
    var IS_FORCED = type & $52a85d87ab01f988$var$$export.F;
    var IS_GLOBAL = type & $52a85d87ab01f988$var$$export.G;
    var IS_STATIC = type & $52a85d87ab01f988$var$$export.S;
    var IS_PROTO = type & $52a85d87ab01f988$var$$export.P;
    var IS_BIND = type & $52a85d87ab01f988$var$$export.B;
    var IS_WRAP = type & $52a85d87ab01f988$var$$export.W;
    var exports = IS_GLOBAL ? $4SFzU : $4SFzU[name] || ($4SFzU[name] = {});
    var expProto = exports[$52a85d87ab01f988$var$PROTOTYPE];
    var target = IS_GLOBAL ? $1AuLW : IS_STATIC ? $1AuLW[name] : ($1AuLW[name] || {})[$52a85d87ab01f988$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $g0HGW(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != "function" ? source[key] : IS_BIND && own ? $3sJtH(out, $1AuLW) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$52a85d87ab01f988$var$PROTOTYPE] = C[$52a85d87ab01f988$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == "function" ? $3sJtH(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $52a85d87ab01f988$var$$export.R && expProto && !expProto[key]) $iExTK(expProto, key, out);
        }
    }
};
// type bitmap
$52a85d87ab01f988$var$$export.F = 1; // forced
$52a85d87ab01f988$var$$export.G = 2; // global
$52a85d87ab01f988$var$$export.S = 4; // static
$52a85d87ab01f988$var$$export.P = 8; // proto
$52a85d87ab01f988$var$$export.B = 16; // bind
$52a85d87ab01f988$var$$export.W = 32; // wrap
$52a85d87ab01f988$var$$export.U = 64; // safe
$52a85d87ab01f988$var$$export.R = 128; // real proto method for `library`
module.exports = $52a85d87ab01f988$var$$export;

});
parcelRegister("1AuLW", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $128105f5f59c0941$var$global = module.exports = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();
if (typeof __g == "number") __g = $128105f5f59c0941$var$global; // eslint-disable-line no-undef

});

parcelRegister("4SFzU", function(module, exports) {
var $38dc7527a531a938$var$core = module.exports = {
    version: "2.6.12"
};
if (typeof __e == "number") __e = $38dc7527a531a938$var$core; // eslint-disable-line no-undef

});

parcelRegister("3sJtH", function(module, exports) {
// optional / simple context binding

var $9oWtE = parcelRequire("9oWtE");
module.exports = function(fn, that, length) {
    $9oWtE(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("9oWtE", function(module, exports) {
module.exports = function(it) {
    if (typeof it != "function") throw TypeError(it + " is not a function!");
    return it;
};

});


parcelRegister("iExTK", function(module, exports) {

var $iBrdT = parcelRequire("iBrdT");

var $gvRfU = parcelRequire("gvRfU");

module.exports = (parcelRequire("6PWiG")) ? function(object, key, value) {
    return $iBrdT.f(object, key, $gvRfU(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("iBrdT", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $d8b0cca867c4eadf$export$2d1720544b23b823; }, function (v) { return $d8b0cca867c4eadf$export$2d1720544b23b823 = v; });
var $d8b0cca867c4eadf$export$2d1720544b23b823;

var $eDerj = parcelRequire("eDerj");

var $3nnaa = parcelRequire("3nnaa");

var $2Vesb = parcelRequire("2Vesb");
var $d8b0cca867c4eadf$var$dP = Object.defineProperty;

$d8b0cca867c4eadf$export$2d1720544b23b823 = (parcelRequire("6PWiG")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $eDerj(O);
    P = $2Vesb(P, true);
    $eDerj(Attributes);
    if ($3nnaa) try {
        return $d8b0cca867c4eadf$var$dP(O, P, Attributes);
    } catch (e) {}
    if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported!");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("eDerj", function(module, exports) {

var $2nsjc = parcelRequire("2nsjc");
module.exports = function(it) {
    if (!$2nsjc(it)) throw TypeError(it + " is not an object!");
    return it;
};

});
parcelRegister("2nsjc", function(module, exports) {
module.exports = function(it) {
    return typeof it === "object" ? it !== null : typeof it === "function";
};

});


parcelRegister("3nnaa", function(module, exports) {



module.exports = !(parcelRequire("6PWiG")) && !(parcelRequire("iboYp"))(function() {
    return Object.defineProperty((parcelRequire("7jXC6"))("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("6PWiG", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("iboYp"))(function() {
    return Object.defineProperty({}, "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("iboYp", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("7jXC6", function(module, exports) {

var $2nsjc = parcelRequire("2nsjc");

var $1AuLW = parcelRequire("1AuLW");
var $55488cbd2ded3e40$require$document = $1AuLW.document;
// typeof document.createElement is 'object' in old IE
var $55488cbd2ded3e40$var$is = $2nsjc($55488cbd2ded3e40$require$document) && $2nsjc($55488cbd2ded3e40$require$document.createElement);
module.exports = function(it) {
    return $55488cbd2ded3e40$var$is ? $55488cbd2ded3e40$require$document.createElement(it) : {};
};

});


parcelRegister("2Vesb", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $2nsjc = parcelRequire("2nsjc");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$2nsjc(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == "function" && !$2nsjc(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == "function" && !$2nsjc(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == "function" && !$2nsjc(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("gvRfU", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("g0HGW", function(module, exports) {
var $ba7e89a7c4aea708$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $ba7e89a7c4aea708$var$hasOwnProperty.call(it, key);
};

});


parcelRegister("8gbK9", function(module, exports) {
"use strict";

var $6PWiG = parcelRequire("6PWiG");

var $fqgBW = parcelRequire("fqgBW");

var $db7TP = parcelRequire("db7TP");

var $7vOZZ = parcelRequire("7vOZZ");

var $jW0KZ = parcelRequire("jW0KZ");

var $b6PKH = parcelRequire("b6PKH");
var $6038ed5326cf90e3$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$6038ed5326cf90e3$var$$assign || (parcelRequire("iboYp"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = "abcdefghijklmnopqrst";
    A[S] = 7;
    K.split("").forEach(function(k) {
        B[k] = k;
    });
    return $6038ed5326cf90e3$var$$assign({}, A)[S] != 7 || Object.keys($6038ed5326cf90e3$var$$assign({}, B)).join("") != K;
}) ? function assign(target, source) {
    var T = $jW0KZ(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $db7TP.f;
    var isEnum = $7vOZZ.f;
    while(aLen > index){
        var S = $b6PKH(arguments[index++]);
        var keys = getSymbols ? $fqgBW(S).concat(getSymbols(S)) : $fqgBW(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$6PWiG || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $6038ed5326cf90e3$var$$assign;

});
parcelRegister("fqgBW", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $3OIHq = parcelRequire("3OIHq");

var $2z1q1 = parcelRequire("2z1q1");
module.exports = Object.keys || function keys(O) {
    return $3OIHq(O, $2z1q1);
};

});
parcelRegister("3OIHq", function(module, exports) {

var $g0HGW = parcelRequire("g0HGW");

var $9Q2Wj = parcelRequire("9Q2Wj");

var $2c78b7019cc97d5d$var$arrayIndexOf = (parcelRequire("dcPHG"))(false);

var $2c78b7019cc97d5d$var$IE_PROTO = (parcelRequire("lrjzQ"))("IE_PROTO");
module.exports = function(object, names) {
    var O = $9Q2Wj(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $2c78b7019cc97d5d$var$IE_PROTO) $g0HGW(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($g0HGW(O, key = names[i++])) ~$2c78b7019cc97d5d$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("9Q2Wj", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $b6PKH = parcelRequire("b6PKH");

var $35XDJ = parcelRequire("35XDJ");
module.exports = function(it) {
    return $b6PKH($35XDJ(it));
};

});
parcelRegister("b6PKH", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $50HPO = parcelRequire("50HPO");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object("z").propertyIsEnumerable(0) ? Object : function(it) {
    return $50HPO(it) == "String" ? it.split("") : Object(it);
};

});
parcelRegister("50HPO", function(module, exports) {
var $3a5ef480641b2ab8$var$toString = {}.toString;
module.exports = function(it) {
    return $3a5ef480641b2ab8$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("35XDJ", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("dcPHG", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $9Q2Wj = parcelRequire("9Q2Wj");

var $an8id = parcelRequire("an8id");

var $g5ewU = parcelRequire("g5ewU");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $9Q2Wj($this);
        var length = $an8id(O.length);
        var index = $g5ewU(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("an8id", function(module, exports) {
// 7.1.15 ToLength

var $fImuS = parcelRequire("fImuS");
var $78d27c231a08b826$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $78d27c231a08b826$var$min($fImuS(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("fImuS", function(module, exports) {
// 7.1.4 ToInteger
var $b70c6a8a18347573$var$ceil = Math.ceil;
var $b70c6a8a18347573$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $b70c6a8a18347573$var$floor : $b70c6a8a18347573$var$ceil)(it);
};

});


parcelRegister("g5ewU", function(module, exports) {

var $fImuS = parcelRequire("fImuS");
var $bb58624cb57ecd28$var$max = Math.max;
var $bb58624cb57ecd28$var$min = Math.min;
module.exports = function(index, length) {
    index = $fImuS(index);
    return index < 0 ? $bb58624cb57ecd28$var$max(index + length, 0) : $bb58624cb57ecd28$var$min(index, length);
};

});


parcelRegister("lrjzQ", function(module, exports) {

var $f9bb4e3763885ef4$var$shared = (parcelRequire("7CF7I"))("keys");

var $8YI2k = parcelRequire("8YI2k");
module.exports = function(key) {
    return $f9bb4e3763885ef4$var$shared[key] || ($f9bb4e3763885ef4$var$shared[key] = $8YI2k(key));
};

});
parcelRegister("7CF7I", function(module, exports) {

var $4SFzU = parcelRequire("4SFzU");

var $1AuLW = parcelRequire("1AuLW");
var $58cbfb44d63508fe$var$SHARED = "__core-js_shared__";
var $58cbfb44d63508fe$var$store = $1AuLW[$58cbfb44d63508fe$var$SHARED] || ($1AuLW[$58cbfb44d63508fe$var$SHARED] = {});

(module.exports = function(key, value) {
    return $58cbfb44d63508fe$var$store[key] || ($58cbfb44d63508fe$var$store[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: $4SFzU.version,
    mode: (parcelRequire("jIt8b")) ? "pure" : "global",
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("jIt8b", function(module, exports) {
module.exports = true;

});


parcelRegister("8YI2k", function(module, exports) {
var $6896160eddc7f9cc$var$id = 0;
var $6896160eddc7f9cc$var$px = Math.random();
module.exports = function(key) {
    return "Symbol(".concat(key === undefined ? "" : key, ")_", (++$6896160eddc7f9cc$var$id + $6896160eddc7f9cc$var$px).toString(36));
};

});



parcelRegister("2z1q1", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");

});


parcelRegister("db7TP", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $99826e16f4222c7f$export$2d1720544b23b823; }, function (v) { return $99826e16f4222c7f$export$2d1720544b23b823 = v; });
var $99826e16f4222c7f$export$2d1720544b23b823;
$99826e16f4222c7f$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("7vOZZ", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $5782fcf41f03d896$export$2d1720544b23b823; }, function (v) { return $5782fcf41f03d896$export$2d1720544b23b823 = v; });
var $5782fcf41f03d896$export$2d1720544b23b823;
$5782fcf41f03d896$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});

parcelRegister("jW0KZ", function(module, exports) {
// 7.1.13 ToObject(argument)

var $35XDJ = parcelRequire("35XDJ");
module.exports = function(it) {
    return Object($35XDJ(it));
};

});






parcelRegister("1h8uE", function(module, exports) {

module.exports = {
    "default": (parcelRequire("3Mnjm")),
    __esModule: true
};

});
parcelRegister("3Mnjm", function(module, exports) {
parcelRequire("5Llvy");

module.exports = (parcelRequire("4SFzU")).Object.getPrototypeOf;

});
parcelRegister("5Llvy", function(module, exports) {
// 19.1.2.9 Object.getPrototypeOf(O)

var $jW0KZ = parcelRequire("jW0KZ");

var $6MnXd = parcelRequire("6MnXd");

(parcelRequire("hwrK4"))("getPrototypeOf", function() {
    return function getPrototypeOf(it) {
        return $6MnXd($jW0KZ(it));
    };
});

});
parcelRegister("6MnXd", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $g0HGW = parcelRequire("g0HGW");

var $jW0KZ = parcelRequire("jW0KZ");

var $4ef9ce8b4c1a395a$var$IE_PROTO = (parcelRequire("lrjzQ"))("IE_PROTO");
var $4ef9ce8b4c1a395a$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $jW0KZ(O);
    if ($g0HGW(O, $4ef9ce8b4c1a395a$var$IE_PROTO)) return O[$4ef9ce8b4c1a395a$var$IE_PROTO];
    if (typeof O.constructor == "function" && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $4ef9ce8b4c1a395a$var$ObjectProto : null;
};

});

parcelRegister("hwrK4", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $75Z3R = parcelRequire("75Z3R");

var $4SFzU = parcelRequire("4SFzU");

var $iboYp = parcelRequire("iboYp");
module.exports = function(KEY, exec) {
    var fn = ($4SFzU.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $75Z3R($75Z3R.S + $75Z3R.F * $iboYp(function() {
        fn(1);
    }), "Object", exp);
};

});




parcelRegister("9WQmH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $73e22678524f7692$export$1e511d4a378977f5; }, function (v) { return $73e22678524f7692$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $73e22678524f7692$export$2e2bcd8739ae039; }, function (v) { return $73e22678524f7692$export$2e2bcd8739ae039 = v; });
var $73e22678524f7692$export$1e511d4a378977f5;
var $73e22678524f7692$export$2e2bcd8739ae039;
"use strict";
$73e22678524f7692$export$1e511d4a378977f5 = true;
$73e22678524f7692$export$2e2bcd8739ae039 = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};

});

parcelRegister("cvgGt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $91a5526562cd347a$export$1e511d4a378977f5; }, function (v) { return $91a5526562cd347a$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $91a5526562cd347a$export$2e2bcd8739ae039; }, function (v) { return $91a5526562cd347a$export$2e2bcd8739ae039 = v; });
var $91a5526562cd347a$export$1e511d4a378977f5;
var $91a5526562cd347a$export$2e2bcd8739ae039;
"use strict";
$91a5526562cd347a$export$1e511d4a378977f5 = true;

var $inGgH = parcelRequire("inGgH");
var $91a5526562cd347a$var$_defineProperty2 = $91a5526562cd347a$var$_interopRequireDefault($inGgH);
function $91a5526562cd347a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$91a5526562cd347a$export$2e2bcd8739ae039 = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, $91a5526562cd347a$var$_defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

});
parcelRegister("inGgH", function(module, exports) {

module.exports = {
    "default": (parcelRequire("bN0AR")),
    __esModule: true
};

});
parcelRegister("bN0AR", function(module, exports) {
parcelRequire("8pLfP");

var $4SFzU = parcelRequire("4SFzU");
var $8954bb2e0df1efca$require$$Object = $4SFzU.Object;
module.exports = function defineProperty(it, key, desc) {
    return $8954bb2e0df1efca$require$$Object.defineProperty(it, key, desc);
};

});
parcelRegister("8pLfP", function(module, exports) {

var $75Z3R = parcelRequire("75Z3R");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$75Z3R($75Z3R.S + $75Z3R.F * !(parcelRequire("6PWiG")), "Object", {
    defineProperty: (parcelRequire("iBrdT")).f
});

});




parcelRegister("lJwmB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $fd26e7a6a39af892$export$1e511d4a378977f5; }, function (v) { return $fd26e7a6a39af892$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $fd26e7a6a39af892$export$2e2bcd8739ae039; }, function (v) { return $fd26e7a6a39af892$export$2e2bcd8739ae039 = v; });
var $fd26e7a6a39af892$export$1e511d4a378977f5;
var $fd26e7a6a39af892$export$2e2bcd8739ae039;
"use strict";
$fd26e7a6a39af892$export$1e511d4a378977f5 = true;

var $bCUvt = parcelRequire("bCUvt");
var $fd26e7a6a39af892$var$_typeof3 = $fd26e7a6a39af892$var$_interopRequireDefault($bCUvt);
function $fd26e7a6a39af892$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$fd26e7a6a39af892$export$2e2bcd8739ae039 = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, $fd26e7a6a39af892$var$_typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

});
parcelRegister("bCUvt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $876f135811fc51da$export$1e511d4a378977f5; }, function (v) { return $876f135811fc51da$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $876f135811fc51da$export$2e2bcd8739ae039; }, function (v) { return $876f135811fc51da$export$2e2bcd8739ae039 = v; });
var $876f135811fc51da$export$1e511d4a378977f5;
var $876f135811fc51da$export$2e2bcd8739ae039;
"use strict";
$876f135811fc51da$export$1e511d4a378977f5 = true;

var $1uVwf = parcelRequire("1uVwf");
var $876f135811fc51da$var$_iterator2 = $876f135811fc51da$var$_interopRequireDefault($1uVwf);

var $fi2Vk = parcelRequire("fi2Vk");
var $876f135811fc51da$var$_symbol2 = $876f135811fc51da$var$_interopRequireDefault($fi2Vk);
var $876f135811fc51da$var$_typeof = typeof $876f135811fc51da$var$_symbol2.default === "function" && typeof $876f135811fc51da$var$_iterator2.default === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof $876f135811fc51da$var$_symbol2.default === "function" && obj.constructor === $876f135811fc51da$var$_symbol2.default && obj !== $876f135811fc51da$var$_symbol2.default.prototype ? "symbol" : typeof obj;
};
function $876f135811fc51da$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$876f135811fc51da$export$2e2bcd8739ae039 = typeof $876f135811fc51da$var$_symbol2.default === "function" && $876f135811fc51da$var$_typeof($876f135811fc51da$var$_iterator2.default) === "symbol" ? function(obj) {
    return typeof obj === "undefined" ? "undefined" : $876f135811fc51da$var$_typeof(obj);
} : function(obj) {
    return obj && typeof $876f135811fc51da$var$_symbol2.default === "function" && obj.constructor === $876f135811fc51da$var$_symbol2.default && obj !== $876f135811fc51da$var$_symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : $876f135811fc51da$var$_typeof(obj);
};

});
parcelRegister("1uVwf", function(module, exports) {

module.exports = {
    "default": (parcelRequire("kENcz")),
    __esModule: true
};

});
parcelRegister("kENcz", function(module, exports) {
parcelRequire("g9YHo");
parcelRequire("26zJj");

module.exports = (parcelRequire("d6MUZ")).f("iterator");

});
parcelRegister("g9YHo", function(module, exports) {
"use strict";

var $bc3c921fb597885c$var$$at = (parcelRequire("3Tmfi"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("gBlb6"))(String, "String", function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $bc3c921fb597885c$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});

});
parcelRegister("3Tmfi", function(module, exports) {

var $fImuS = parcelRequire("fImuS");

var $35XDJ = parcelRequire("35XDJ");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($35XDJ(that));
        var i = $fImuS(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? "" : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});

parcelRegister("gBlb6", function(module, exports) {
"use strict";

var $jIt8b = parcelRequire("jIt8b");

var $75Z3R = parcelRequire("75Z3R");

var $j2Pin = parcelRequire("j2Pin");

var $iExTK = parcelRequire("iExTK");

var $5vJys = parcelRequire("5vJys");

var $fUvK3 = parcelRequire("fUvK3");

var $2QMfD = parcelRequire("2QMfD");

var $6MnXd = parcelRequire("6MnXd");

var $c1608794fb3db469$var$ITERATOR = (parcelRequire("5ZFqh"))("iterator");
var $c1608794fb3db469$var$BUGGY = !([].keys && "next" in [].keys()); // Safari has buggy iterators w/o `next`
var $c1608794fb3db469$var$FF_ITERATOR = "@@iterator";
var $c1608794fb3db469$var$KEYS = "keys";
var $c1608794fb3db469$var$VALUES = "values";
var $c1608794fb3db469$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $fUvK3(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$c1608794fb3db469$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $c1608794fb3db469$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $c1608794fb3db469$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + " Iterator";
    var DEF_VALUES = DEFAULT == $c1608794fb3db469$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$c1608794fb3db469$var$ITERATOR] || proto[$c1608794fb3db469$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod("entries") : undefined;
    var $anyNative = NAME == "Array" ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $6MnXd($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $2QMfD(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$jIt8b && typeof IteratorPrototype[$c1608794fb3db469$var$ITERATOR] != "function") $iExTK(IteratorPrototype, $c1608794fb3db469$var$ITERATOR, $c1608794fb3db469$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $c1608794fb3db469$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$jIt8b || FORCED) && ($c1608794fb3db469$var$BUGGY || VALUES_BUG || !proto[$c1608794fb3db469$var$ITERATOR])) $iExTK(proto, $c1608794fb3db469$var$ITERATOR, $default);
    // Plug for library
    $5vJys[NAME] = $default;
    $5vJys[TAG] = $c1608794fb3db469$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($c1608794fb3db469$var$VALUES),
            keys: IS_SET ? $default : getMethod($c1608794fb3db469$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $j2Pin(proto, key, methods[key]);
        } else $75Z3R($75Z3R.P + $75Z3R.F * ($c1608794fb3db469$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("j2Pin", function(module, exports) {

module.exports = (parcelRequire("iExTK"));

});

parcelRegister("5vJys", function(module, exports) {
module.exports = {};

});

parcelRegister("fUvK3", function(module, exports) {
"use strict";

var $76SJO = parcelRequire("76SJO");

var $gvRfU = parcelRequire("gvRfU");

var $2QMfD = parcelRequire("2QMfD");
var $b954b5409de06eb9$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("iExTK"))($b954b5409de06eb9$var$IteratorPrototype, (parcelRequire("5ZFqh"))("iterator"), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $76SJO($b954b5409de06eb9$var$IteratorPrototype, {
        next: $gvRfU(1, next)
    });
    $2QMfD(Constructor, NAME + " Iterator");
};

});
parcelRegister("76SJO", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $eDerj = parcelRequire("eDerj");

var $hA0V4 = parcelRequire("hA0V4");

var $2z1q1 = parcelRequire("2z1q1");

var $52d38dc603153253$var$IE_PROTO = (parcelRequire("lrjzQ"))("IE_PROTO");
var $52d38dc603153253$var$Empty = function() {};
var $52d38dc603153253$var$PROTOTYPE = "prototype";


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $52d38dc603153253$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("7jXC6"))("iframe");
    var i = $2z1q1.length;
    var lt = "<";
    var gt = ">";
    var iframeDocument;
    iframe.style.display = "none";
    (parcelRequire("3etrR")).appendChild(iframe);
    iframe.src = "javascript:"; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + "script" + gt + "document.F=Object" + lt + "/script" + gt);
    iframeDocument.close();
    $52d38dc603153253$var$createDict = iframeDocument.F;
    while(i--)delete $52d38dc603153253$var$createDict[$52d38dc603153253$var$PROTOTYPE][$2z1q1[i]];
    return $52d38dc603153253$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $52d38dc603153253$var$Empty[$52d38dc603153253$var$PROTOTYPE] = $eDerj(O);
        result = new $52d38dc603153253$var$Empty();
        $52d38dc603153253$var$Empty[$52d38dc603153253$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$52d38dc603153253$var$IE_PROTO] = O;
    } else result = $52d38dc603153253$var$createDict();
    return Properties === undefined ? result : $hA0V4(result, Properties);
};

});
parcelRegister("hA0V4", function(module, exports) {

var $iBrdT = parcelRequire("iBrdT");

var $eDerj = parcelRequire("eDerj");

var $fqgBW = parcelRequire("fqgBW");

module.exports = (parcelRequire("6PWiG")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $eDerj(O);
    var keys = $fqgBW(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$iBrdT.f(O, P = keys[i++], Properties[P]);
    return O;
};

});

parcelRegister("3etrR", function(module, exports) {

var $1AuLW = parcelRequire("1AuLW");
var $25a985c07a27830a$require$document = $1AuLW.document;
module.exports = $25a985c07a27830a$require$document && $25a985c07a27830a$require$document.documentElement;

});


parcelRegister("2QMfD", function(module, exports) {

var $iBrdT = parcelRequire("iBrdT");
var $2135ddc816d36465$require$def = $iBrdT.f;

var $g0HGW = parcelRequire("g0HGW");

var $2135ddc816d36465$var$TAG = (parcelRequire("5ZFqh"))("toStringTag");
module.exports = function(it, tag, stat) {
    if (it && !$g0HGW(it = stat ? it : it.prototype, $2135ddc816d36465$var$TAG)) $2135ddc816d36465$require$def(it, $2135ddc816d36465$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("5ZFqh", function(module, exports) {

var $45d2c7f58f7c6d92$var$store = (parcelRequire("7CF7I"))("wks");

var $8YI2k = parcelRequire("8YI2k");

var $1AuLW = parcelRequire("1AuLW");
var $45d2c7f58f7c6d92$require$Symbol = $1AuLW.Symbol;
var $45d2c7f58f7c6d92$var$USE_SYMBOL = typeof $45d2c7f58f7c6d92$require$Symbol == "function";
var $45d2c7f58f7c6d92$var$$exports = module.exports = function(name) {
    return $45d2c7f58f7c6d92$var$store[name] || ($45d2c7f58f7c6d92$var$store[name] = $45d2c7f58f7c6d92$var$USE_SYMBOL && $45d2c7f58f7c6d92$require$Symbol[name] || ($45d2c7f58f7c6d92$var$USE_SYMBOL ? $45d2c7f58f7c6d92$require$Symbol : $8YI2k)("Symbol." + name));
};
$45d2c7f58f7c6d92$var$$exports.store = $45d2c7f58f7c6d92$var$store;

});





parcelRegister("26zJj", function(module, exports) {
parcelRequire("9hETM");

var $1AuLW = parcelRequire("1AuLW");

var $iExTK = parcelRequire("iExTK");

var $5vJys = parcelRequire("5vJys");

var $1887db88136e9eb6$var$TO_STRING_TAG = (parcelRequire("5ZFqh"))("toStringTag");
var $1887db88136e9eb6$var$DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(",");
for(var $1887db88136e9eb6$var$i = 0; $1887db88136e9eb6$var$i < $1887db88136e9eb6$var$DOMIterables.length; $1887db88136e9eb6$var$i++){
    var $1887db88136e9eb6$var$NAME = $1887db88136e9eb6$var$DOMIterables[$1887db88136e9eb6$var$i];
    var $1887db88136e9eb6$var$Collection = $1AuLW[$1887db88136e9eb6$var$NAME];
    var $1887db88136e9eb6$var$proto = $1887db88136e9eb6$var$Collection && $1887db88136e9eb6$var$Collection.prototype;
    if ($1887db88136e9eb6$var$proto && !$1887db88136e9eb6$var$proto[$1887db88136e9eb6$var$TO_STRING_TAG]) $iExTK($1887db88136e9eb6$var$proto, $1887db88136e9eb6$var$TO_STRING_TAG, $1887db88136e9eb6$var$NAME);
    $5vJys[$1887db88136e9eb6$var$NAME] = $5vJys.Array;
}

});
parcelRegister("9hETM", function(module, exports) {
"use strict";

var $23nxa = parcelRequire("23nxa");

var $1hdmL = parcelRequire("1hdmL");

var $5vJys = parcelRequire("5vJys");

var $9Q2Wj = parcelRequire("9Q2Wj");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("gBlb6"))(Array, "Array", function(iterated, kind) {
    this._t = $9Q2Wj(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $1hdmL(1);
    }
    if (kind == "keys") return $1hdmL(0, index);
    if (kind == "values") return $1hdmL(0, O[index]);
    return $1hdmL(0, [
        index,
        O[index]
    ]);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$5vJys.Arguments = $5vJys.Array;
$23nxa("keys");
$23nxa("values");
$23nxa("entries");

});
parcelRegister("23nxa", function(module, exports) {
module.exports = function() {};

});

parcelRegister("1hdmL", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});



parcelRegister("d6MUZ", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $98b1c80a64847de3$export$2d1720544b23b823; }, function (v) { return $98b1c80a64847de3$export$2d1720544b23b823 = v; });
var $98b1c80a64847de3$export$2d1720544b23b823;

$98b1c80a64847de3$export$2d1720544b23b823 = (parcelRequire("5ZFqh"));

});



parcelRegister("fi2Vk", function(module, exports) {

module.exports = {
    "default": (parcelRequire("gtrIV")),
    __esModule: true
};

});
parcelRegister("gtrIV", function(module, exports) {
parcelRequire("675M0");
parcelRequire("fX4Lx");
parcelRequire("1LrBr");
parcelRequire("djOgr");

module.exports = (parcelRequire("4SFzU")).Symbol;

});
parcelRegister("675M0", function(module, exports) {
"use strict";

var $1AuLW = parcelRequire("1AuLW");

var $g0HGW = parcelRequire("g0HGW");

var $6PWiG = parcelRequire("6PWiG");

var $75Z3R = parcelRequire("75Z3R");

var $j2Pin = parcelRequire("j2Pin");

var $6JbdZ = parcelRequire("6JbdZ");
var $4737dffdbbf3b11b$require$META = $6JbdZ.KEY;

var $iboYp = parcelRequire("iboYp");

var $7CF7I = parcelRequire("7CF7I");

var $2QMfD = parcelRequire("2QMfD");

var $8YI2k = parcelRequire("8YI2k");

var $5ZFqh = parcelRequire("5ZFqh");

var $d6MUZ = parcelRequire("d6MUZ");

var $jQD7S = parcelRequire("jQD7S");

var $2RLvg = parcelRequire("2RLvg");

var $jbWKd = parcelRequire("jbWKd");

var $eDerj = parcelRequire("eDerj");

var $2nsjc = parcelRequire("2nsjc");

var $jW0KZ = parcelRequire("jW0KZ");

var $9Q2Wj = parcelRequire("9Q2Wj");

var $2Vesb = parcelRequire("2Vesb");

var $gvRfU = parcelRequire("gvRfU");

var $76SJO = parcelRequire("76SJO");

var $fOLBW = parcelRequire("fOLBW");

var $9buIj = parcelRequire("9buIj");

var $db7TP = parcelRequire("db7TP");

var $iBrdT = parcelRequire("iBrdT");

var $fqgBW = parcelRequire("fqgBW");
var $4737dffdbbf3b11b$var$gOPD = $9buIj.f;
var $4737dffdbbf3b11b$var$dP = $iBrdT.f;
var $4737dffdbbf3b11b$var$gOPN = $fOLBW.f;
var $4737dffdbbf3b11b$var$$Symbol = $1AuLW.Symbol;
var $4737dffdbbf3b11b$var$$JSON = $1AuLW.JSON;
var $4737dffdbbf3b11b$var$_stringify = $4737dffdbbf3b11b$var$$JSON && $4737dffdbbf3b11b$var$$JSON.stringify;
var $4737dffdbbf3b11b$var$PROTOTYPE = "prototype";
var $4737dffdbbf3b11b$var$HIDDEN = $5ZFqh("_hidden");
var $4737dffdbbf3b11b$var$TO_PRIMITIVE = $5ZFqh("toPrimitive");
var $4737dffdbbf3b11b$var$isEnum = {}.propertyIsEnumerable;
var $4737dffdbbf3b11b$var$SymbolRegistry = $7CF7I("symbol-registry");
var $4737dffdbbf3b11b$var$AllSymbols = $7CF7I("symbols");
var $4737dffdbbf3b11b$var$OPSymbols = $7CF7I("op-symbols");
var $4737dffdbbf3b11b$var$ObjectProto = Object[$4737dffdbbf3b11b$var$PROTOTYPE];
var $4737dffdbbf3b11b$var$USE_NATIVE = typeof $4737dffdbbf3b11b$var$$Symbol == "function" && !!$db7TP.f;
var $4737dffdbbf3b11b$var$QObject = $1AuLW.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $4737dffdbbf3b11b$var$setter = !$4737dffdbbf3b11b$var$QObject || !$4737dffdbbf3b11b$var$QObject[$4737dffdbbf3b11b$var$PROTOTYPE] || !$4737dffdbbf3b11b$var$QObject[$4737dffdbbf3b11b$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $4737dffdbbf3b11b$var$setSymbolDesc = $6PWiG && $iboYp(function() {
    return $76SJO($4737dffdbbf3b11b$var$dP({}, "a", {
        get: function() {
            return $4737dffdbbf3b11b$var$dP(this, "a", {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $4737dffdbbf3b11b$var$gOPD($4737dffdbbf3b11b$var$ObjectProto, key);
    if (protoDesc) delete $4737dffdbbf3b11b$var$ObjectProto[key];
    $4737dffdbbf3b11b$var$dP(it, key, D);
    if (protoDesc && it !== $4737dffdbbf3b11b$var$ObjectProto) $4737dffdbbf3b11b$var$dP($4737dffdbbf3b11b$var$ObjectProto, key, protoDesc);
} : $4737dffdbbf3b11b$var$dP;
var $4737dffdbbf3b11b$var$wrap = function(tag) {
    var sym = $4737dffdbbf3b11b$var$AllSymbols[tag] = $76SJO($4737dffdbbf3b11b$var$$Symbol[$4737dffdbbf3b11b$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $4737dffdbbf3b11b$var$isSymbol = $4737dffdbbf3b11b$var$USE_NATIVE && typeof $4737dffdbbf3b11b$var$$Symbol.iterator == "symbol" ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    return it instanceof $4737dffdbbf3b11b$var$$Symbol;
};
var $4737dffdbbf3b11b$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $4737dffdbbf3b11b$var$ObjectProto) $4737dffdbbf3b11b$var$$defineProperty($4737dffdbbf3b11b$var$OPSymbols, key, D);
    $eDerj(it);
    key = $2Vesb(key, true);
    $eDerj(D);
    if ($g0HGW($4737dffdbbf3b11b$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$g0HGW(it, $4737dffdbbf3b11b$var$HIDDEN)) $4737dffdbbf3b11b$var$dP(it, $4737dffdbbf3b11b$var$HIDDEN, $gvRfU(1, {}));
            it[$4737dffdbbf3b11b$var$HIDDEN][key] = true;
        } else {
            if ($g0HGW(it, $4737dffdbbf3b11b$var$HIDDEN) && it[$4737dffdbbf3b11b$var$HIDDEN][key]) it[$4737dffdbbf3b11b$var$HIDDEN][key] = false;
            D = $76SJO(D, {
                enumerable: $gvRfU(0, false)
            });
        }
        return $4737dffdbbf3b11b$var$setSymbolDesc(it, key, D);
    }
    return $4737dffdbbf3b11b$var$dP(it, key, D);
};
var $4737dffdbbf3b11b$var$$defineProperties = function defineProperties(it, P) {
    $eDerj(it);
    var keys = $2RLvg(P = $9Q2Wj(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$4737dffdbbf3b11b$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $4737dffdbbf3b11b$var$$create = function create(it, P) {
    return P === undefined ? $76SJO(it) : $4737dffdbbf3b11b$var$$defineProperties($76SJO(it), P);
};
var $4737dffdbbf3b11b$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $4737dffdbbf3b11b$var$isEnum.call(this, key = $2Vesb(key, true));
    if (this === $4737dffdbbf3b11b$var$ObjectProto && $g0HGW($4737dffdbbf3b11b$var$AllSymbols, key) && !$g0HGW($4737dffdbbf3b11b$var$OPSymbols, key)) return false;
    return E || !$g0HGW(this, key) || !$g0HGW($4737dffdbbf3b11b$var$AllSymbols, key) || $g0HGW(this, $4737dffdbbf3b11b$var$HIDDEN) && this[$4737dffdbbf3b11b$var$HIDDEN][key] ? E : true;
};
var $4737dffdbbf3b11b$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $9Q2Wj(it);
    key = $2Vesb(key, true);
    if (it === $4737dffdbbf3b11b$var$ObjectProto && $g0HGW($4737dffdbbf3b11b$var$AllSymbols, key) && !$g0HGW($4737dffdbbf3b11b$var$OPSymbols, key)) return;
    var D = $4737dffdbbf3b11b$var$gOPD(it, key);
    if (D && $g0HGW($4737dffdbbf3b11b$var$AllSymbols, key) && !($g0HGW(it, $4737dffdbbf3b11b$var$HIDDEN) && it[$4737dffdbbf3b11b$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $4737dffdbbf3b11b$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $4737dffdbbf3b11b$var$gOPN($9Q2Wj(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$g0HGW($4737dffdbbf3b11b$var$AllSymbols, key = names[i++]) && key != $4737dffdbbf3b11b$var$HIDDEN && key != $4737dffdbbf3b11b$require$META) result.push(key);
    return result;
};
var $4737dffdbbf3b11b$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $4737dffdbbf3b11b$var$ObjectProto;
    var names = $4737dffdbbf3b11b$var$gOPN(IS_OP ? $4737dffdbbf3b11b$var$OPSymbols : $9Q2Wj(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($g0HGW($4737dffdbbf3b11b$var$AllSymbols, key = names[i++]) && (IS_OP ? $g0HGW($4737dffdbbf3b11b$var$ObjectProto, key) : true)) result.push($4737dffdbbf3b11b$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$4737dffdbbf3b11b$var$USE_NATIVE) {
    $4737dffdbbf3b11b$var$$Symbol = function Symbol() {
        if (this instanceof $4737dffdbbf3b11b$var$$Symbol) throw TypeError("Symbol is not a constructor!");
        var tag = $8YI2k(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $4737dffdbbf3b11b$var$ObjectProto) $set.call($4737dffdbbf3b11b$var$OPSymbols, value);
            if ($g0HGW(this, $4737dffdbbf3b11b$var$HIDDEN) && $g0HGW(this[$4737dffdbbf3b11b$var$HIDDEN], tag)) this[$4737dffdbbf3b11b$var$HIDDEN][tag] = false;
            $4737dffdbbf3b11b$var$setSymbolDesc(this, tag, $gvRfU(1, value));
        };
        if ($6PWiG && $4737dffdbbf3b11b$var$setter) $4737dffdbbf3b11b$var$setSymbolDesc($4737dffdbbf3b11b$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $4737dffdbbf3b11b$var$wrap(tag);
    };
    $j2Pin($4737dffdbbf3b11b$var$$Symbol[$4737dffdbbf3b11b$var$PROTOTYPE], "toString", function toString() {
        return this._k;
    });
    $9buIj.f = $4737dffdbbf3b11b$var$$getOwnPropertyDescriptor;
    $iBrdT.f = $4737dffdbbf3b11b$var$$defineProperty;
    (parcelRequire("4USFc")).f = $fOLBW.f = $4737dffdbbf3b11b$var$$getOwnPropertyNames;
    (parcelRequire("7vOZZ")).f = $4737dffdbbf3b11b$var$$propertyIsEnumerable;
    $db7TP.f = $4737dffdbbf3b11b$var$$getOwnPropertySymbols;
    if ($6PWiG && !(parcelRequire("jIt8b"))) $j2Pin($4737dffdbbf3b11b$var$ObjectProto, "propertyIsEnumerable", $4737dffdbbf3b11b$var$$propertyIsEnumerable, true);
    $d6MUZ.f = function(name) {
        return $4737dffdbbf3b11b$var$wrap($5ZFqh(name));
    };
}
$75Z3R($75Z3R.G + $75Z3R.W + $75Z3R.F * !$4737dffdbbf3b11b$var$USE_NATIVE, {
    Symbol: $4737dffdbbf3b11b$var$$Symbol
});
for(var $4737dffdbbf3b11b$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
"hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), $4737dffdbbf3b11b$var$j = 0; $4737dffdbbf3b11b$var$es6Symbols.length > $4737dffdbbf3b11b$var$j;)$5ZFqh($4737dffdbbf3b11b$var$es6Symbols[$4737dffdbbf3b11b$var$j++]);
for(var $4737dffdbbf3b11b$var$wellKnownSymbols = $fqgBW($5ZFqh.store), $4737dffdbbf3b11b$var$k = 0; $4737dffdbbf3b11b$var$wellKnownSymbols.length > $4737dffdbbf3b11b$var$k;)$jQD7S($4737dffdbbf3b11b$var$wellKnownSymbols[$4737dffdbbf3b11b$var$k++]);
$75Z3R($75Z3R.S + $75Z3R.F * !$4737dffdbbf3b11b$var$USE_NATIVE, "Symbol", {
    // 19.4.2.1 Symbol.for(key)
    "for": function(key) {
        return $g0HGW($4737dffdbbf3b11b$var$SymbolRegistry, key += "") ? $4737dffdbbf3b11b$var$SymbolRegistry[key] : $4737dffdbbf3b11b$var$SymbolRegistry[key] = $4737dffdbbf3b11b$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$4737dffdbbf3b11b$var$isSymbol(sym)) throw TypeError(sym + " is not a symbol!");
        for(var key in $4737dffdbbf3b11b$var$SymbolRegistry)if ($4737dffdbbf3b11b$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $4737dffdbbf3b11b$var$setter = true;
    },
    useSimple: function() {
        $4737dffdbbf3b11b$var$setter = false;
    }
});
$75Z3R($75Z3R.S + $75Z3R.F * !$4737dffdbbf3b11b$var$USE_NATIVE, "Object", {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $4737dffdbbf3b11b$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $4737dffdbbf3b11b$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $4737dffdbbf3b11b$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $4737dffdbbf3b11b$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $4737dffdbbf3b11b$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $4737dffdbbf3b11b$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $4737dffdbbf3b11b$var$FAILS_ON_PRIMITIVES = $iboYp(function() {
    $db7TP.f(1);
});
$75Z3R($75Z3R.S + $75Z3R.F * $4737dffdbbf3b11b$var$FAILS_ON_PRIMITIVES, "Object", {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $db7TP.f($jW0KZ(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$4737dffdbbf3b11b$var$$JSON && $75Z3R($75Z3R.S + $75Z3R.F * (!$4737dffdbbf3b11b$var$USE_NATIVE || $iboYp(function() {
    var S = $4737dffdbbf3b11b$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $4737dffdbbf3b11b$var$_stringify([
        S
    ]) != "[null]" || $4737dffdbbf3b11b$var$_stringify({
        a: S
    }) != "{}" || $4737dffdbbf3b11b$var$_stringify(Object(S)) != "{}";
})), "JSON", {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$2nsjc(replacer) && it === undefined || $4737dffdbbf3b11b$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$jbWKd(replacer)) replacer = function(key, value) {
            if (typeof $replacer == "function") value = $replacer.call(this, key, value);
            if (!$4737dffdbbf3b11b$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $4737dffdbbf3b11b$var$_stringify.apply($4737dffdbbf3b11b$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$4737dffdbbf3b11b$var$$Symbol[$4737dffdbbf3b11b$var$PROTOTYPE][$4737dffdbbf3b11b$var$TO_PRIMITIVE] || (parcelRequire("iExTK"))($4737dffdbbf3b11b$var$$Symbol[$4737dffdbbf3b11b$var$PROTOTYPE], $4737dffdbbf3b11b$var$TO_PRIMITIVE, $4737dffdbbf3b11b$var$$Symbol[$4737dffdbbf3b11b$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$2QMfD($4737dffdbbf3b11b$var$$Symbol, "Symbol");
// 20.2.1.9 Math[@@toStringTag]
$2QMfD(Math, "Math", true);
// 24.3.3 JSON[@@toStringTag]
$2QMfD($1AuLW.JSON, "JSON", true);

});
parcelRegister("6JbdZ", function(module, exports) {

var $4e5fa70cd5df429f$var$META = (parcelRequire("8YI2k"))("meta");

var $2nsjc = parcelRequire("2nsjc");

var $g0HGW = parcelRequire("g0HGW");

var $iBrdT = parcelRequire("iBrdT");
var $4e5fa70cd5df429f$require$setDesc = $iBrdT.f;
var $4e5fa70cd5df429f$var$id = 0;
var $4e5fa70cd5df429f$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $4e5fa70cd5df429f$var$FREEZE = !(parcelRequire("iboYp"))(function() {
    return $4e5fa70cd5df429f$var$isExtensible(Object.preventExtensions({}));
});
var $4e5fa70cd5df429f$var$setMeta = function(it) {
    $4e5fa70cd5df429f$require$setDesc(it, $4e5fa70cd5df429f$var$META, {
        value: {
            i: "O" + ++$4e5fa70cd5df429f$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $4e5fa70cd5df429f$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$2nsjc(it)) return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
    if (!$g0HGW(it, $4e5fa70cd5df429f$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$4e5fa70cd5df429f$var$isExtensible(it)) return "F";
        // not necessary to add metadata
        if (!create) return "E";
        // add missing metadata
        $4e5fa70cd5df429f$var$setMeta(it);
    // return object ID
    }
    return it[$4e5fa70cd5df429f$var$META].i;
};
var $4e5fa70cd5df429f$var$getWeak = function(it, create) {
    if (!$g0HGW(it, $4e5fa70cd5df429f$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$4e5fa70cd5df429f$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $4e5fa70cd5df429f$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$4e5fa70cd5df429f$var$META].w;
};
// add metadata on freeze-family methods calling
var $4e5fa70cd5df429f$var$onFreeze = function(it) {
    if ($4e5fa70cd5df429f$var$FREEZE && $4e5fa70cd5df429f$var$meta.NEED && $4e5fa70cd5df429f$var$isExtensible(it) && !$g0HGW(it, $4e5fa70cd5df429f$var$META)) $4e5fa70cd5df429f$var$setMeta(it);
    return it;
};
var $4e5fa70cd5df429f$var$meta = module.exports = {
    KEY: $4e5fa70cd5df429f$var$META,
    NEED: false,
    fastKey: $4e5fa70cd5df429f$var$fastKey,
    getWeak: $4e5fa70cd5df429f$var$getWeak,
    onFreeze: $4e5fa70cd5df429f$var$onFreeze
};

});

parcelRegister("jQD7S", function(module, exports) {

var $1AuLW = parcelRequire("1AuLW");

var $4SFzU = parcelRequire("4SFzU");

var $jIt8b = parcelRequire("jIt8b");

var $d6MUZ = parcelRequire("d6MUZ");

var $iBrdT = parcelRequire("iBrdT");
var $e73139406703c154$require$defineProperty = $iBrdT.f;
module.exports = function(name) {
    var $Symbol = $4SFzU.Symbol || ($4SFzU.Symbol = $jIt8b ? {} : $1AuLW.Symbol || {});
    if (name.charAt(0) != "_" && !(name in $Symbol)) $e73139406703c154$require$defineProperty($Symbol, name, {
        value: $d6MUZ.f(name)
    });
};

});

parcelRegister("2RLvg", function(module, exports) {
// all enumerable object keys, includes symbols

var $fqgBW = parcelRequire("fqgBW");

var $db7TP = parcelRequire("db7TP");

var $7vOZZ = parcelRequire("7vOZZ");
module.exports = function(it) {
    var result = $fqgBW(it);
    var getSymbols = $db7TP.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $7vOZZ.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};

});

parcelRegister("jbWKd", function(module, exports) {
// 7.2.2 IsArray(argument)

var $50HPO = parcelRequire("50HPO");
module.exports = Array.isArray || function isArray(arg) {
    return $50HPO(arg) == "Array";
};

});

parcelRegister("fOLBW", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $b8407514ba6f6e57$export$2d1720544b23b823; }, function (v) { return $b8407514ba6f6e57$export$2d1720544b23b823 = v; });
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $b8407514ba6f6e57$export$2d1720544b23b823;

var $9Q2Wj = parcelRequire("9Q2Wj");

var $4USFc = parcelRequire("4USFc");
var $b8407514ba6f6e57$require$gOPN = $4USFc.f;
var $b8407514ba6f6e57$var$toString = {}.toString;
var $b8407514ba6f6e57$var$windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $b8407514ba6f6e57$var$getWindowNames = function(it) {
    try {
        return $b8407514ba6f6e57$require$gOPN(it);
    } catch (e) {
        return $b8407514ba6f6e57$var$windowNames.slice();
    }
};
$b8407514ba6f6e57$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $b8407514ba6f6e57$var$windowNames && $b8407514ba6f6e57$var$toString.call(it) == "[object Window]" ? $b8407514ba6f6e57$var$getWindowNames(it) : $b8407514ba6f6e57$require$gOPN($9Q2Wj(it));
};

});
parcelRegister("4USFc", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $3946cb71b401f5d4$export$2d1720544b23b823; }, function (v) { return $3946cb71b401f5d4$export$2d1720544b23b823 = v; });
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $3946cb71b401f5d4$export$2d1720544b23b823;

var $3OIHq = parcelRequire("3OIHq");

var $3946cb71b401f5d4$var$hiddenKeys = (parcelRequire("2z1q1")).concat("length", "prototype");
$3946cb71b401f5d4$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $3OIHq(O, $3946cb71b401f5d4$var$hiddenKeys);
};

});


parcelRegister("9buIj", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $6afcf73d785504fe$export$2d1720544b23b823; }, function (v) { return $6afcf73d785504fe$export$2d1720544b23b823 = v; });
var $6afcf73d785504fe$export$2d1720544b23b823;

var $7vOZZ = parcelRequire("7vOZZ");

var $gvRfU = parcelRequire("gvRfU");

var $9Q2Wj = parcelRequire("9Q2Wj");

var $2Vesb = parcelRequire("2Vesb");

var $g0HGW = parcelRequire("g0HGW");

var $3nnaa = parcelRequire("3nnaa");
var $6afcf73d785504fe$var$gOPD = Object.getOwnPropertyDescriptor;

$6afcf73d785504fe$export$2d1720544b23b823 = (parcelRequire("6PWiG")) ? $6afcf73d785504fe$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $9Q2Wj(O);
    P = $2Vesb(P, true);
    if ($3nnaa) try {
        return $6afcf73d785504fe$var$gOPD(O, P);
    } catch (e) {}
    if ($g0HGW(O, P)) return $gvRfU(!$7vOZZ.f.call(O, P), O[P]);
};

});


parcelRegister("fX4Lx", function(module, exports) {

});

parcelRegister("1LrBr", function(module, exports) {

(parcelRequire("jQD7S"))("asyncIterator");

});

parcelRegister("djOgr", function(module, exports) {

(parcelRequire("jQD7S"))("observable");

});





parcelRegister("2jBgE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $1afa43a8f55b07fd$export$1e511d4a378977f5; }, function (v) { return $1afa43a8f55b07fd$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $1afa43a8f55b07fd$export$2e2bcd8739ae039; }, function (v) { return $1afa43a8f55b07fd$export$2e2bcd8739ae039 = v; });
var $1afa43a8f55b07fd$export$1e511d4a378977f5;
var $1afa43a8f55b07fd$export$2e2bcd8739ae039;
"use strict";
$1afa43a8f55b07fd$export$1e511d4a378977f5 = true;

var $fCdpI = parcelRequire("fCdpI");
var $1afa43a8f55b07fd$var$_setPrototypeOf2 = $1afa43a8f55b07fd$var$_interopRequireDefault($fCdpI);

var $7luTY = parcelRequire("7luTY");
var $1afa43a8f55b07fd$var$_create2 = $1afa43a8f55b07fd$var$_interopRequireDefault($7luTY);

var $bCUvt = parcelRequire("bCUvt");
var $1afa43a8f55b07fd$var$_typeof3 = $1afa43a8f55b07fd$var$_interopRequireDefault($bCUvt);
function $1afa43a8f55b07fd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$1afa43a8f55b07fd$export$2e2bcd8739ae039 = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $1afa43a8f55b07fd$var$_typeof3.default)(superClass)));
    subClass.prototype = (0, $1afa43a8f55b07fd$var$_create2.default)(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $1afa43a8f55b07fd$var$_setPrototypeOf2.default ? (0, $1afa43a8f55b07fd$var$_setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

});
parcelRegister("fCdpI", function(module, exports) {

module.exports = {
    "default": (parcelRequire("bQgwP")),
    __esModule: true
};

});
parcelRegister("bQgwP", function(module, exports) {
parcelRequire("bPNhy");

module.exports = (parcelRequire("4SFzU")).Object.setPrototypeOf;

});
parcelRegister("bPNhy", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $75Z3R = parcelRequire("75Z3R");

$75Z3R($75Z3R.S, "Object", {
    setPrototypeOf: (parcelRequire("1nVm7")).set
});

});
parcelRegister("1nVm7", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $2nsjc = parcelRequire("2nsjc");

var $eDerj = parcelRequire("eDerj");
var $10246e16fc494eae$var$check = function(O, proto) {
    $eDerj(O);
    if (!$2nsjc(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ("__proto__" in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("3sJtH"))(Function.call, (parcelRequire("9buIj")).f(Object.prototype, "__proto__").set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $10246e16fc494eae$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $10246e16fc494eae$var$check
};

});




parcelRegister("7luTY", function(module, exports) {

module.exports = {
    "default": (parcelRequire("8YqYW")),
    __esModule: true
};

});
parcelRegister("8YqYW", function(module, exports) {
parcelRequire("a5k5U");

var $4SFzU = parcelRequire("4SFzU");
var $6888db66216122da$require$$Object = $4SFzU.Object;
module.exports = function create(P, D) {
    return $6888db66216122da$require$$Object.create(P, D);
};

});
parcelRegister("a5k5U", function(module, exports) {

var $75Z3R = parcelRequire("75Z3R");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$75Z3R($75Z3R.S, "Object", {
    create: (parcelRequire("76SJO"))
});

});





parcelRegister("gZ0A3", function(module, exports) {

$parcel$export(module.exports, "AnimatedJiraTour", function () { return $c0a9533d02a38d35$export$d6ccd257c217bac1; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $el0Oi = parcelRequire("el0Oi");

var $85mql = parcelRequire("85mql");

var $8XM36 = parcelRequire("8XM36");

var $4MTGk = parcelRequire("4MTGk");
const $c0a9533d02a38d35$export$d6ccd257c217bac1 = (props)=>{
    const [{ animationStep: animationStep }, { setMessages: setMessages }] = (0, $4MTGk.useAnimatedJiraBoardStore)();
    const isCardTyping = (0, $iSvIT.useMemo)(()=>{
        return animationStep === (0, $85mql.AnimationSteps).CARD_TYPING;
    }, [
        animationStep
    ]);
    const intl = (0, $f6qj2.default)();
    const messages = {
        toDo: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.toDo",
            defaultMessage: "To Do"
        }),
        inProgress: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.inProgress",
            defaultMessage: "In Progress"
        }),
        done: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.done",
            defaultMessage: "Done"
        }),
        todoStaticLabel: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.todoStaticLabel",
            defaultMessage: "Design AI shopping suggestions for homepage"
        }),
        inProgStaticLabel1: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.inProgStaticLabel1",
            defaultMessage: "Create AI-generated shopping suggestions for homepage"
        }),
        inProgStaticLabel2: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.inProgStaticLabel2",
            defaultMessage: "Add advanced analytics tracking events"
        }),
        doneStaticLabel1: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.doneStaticLabel1",
            defaultMessage: "Improve payment checkout time on mobile"
        }),
        doneStaticLabel2: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.doneStaticLabel2",
            defaultMessage: "Define requirements to use new AI integrations"
        }),
        animatedCardHeading: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.animatedCardHeading",
            defaultMessage: "Design new billing API"
        }),
        createIssueModalIssueTypeAssetLabel1: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalIssueTypeAssetLabel1",
            defaultMessage: "Issue type: Task"
        }),
        createIssueModalIssueTypeAssetLabel2: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalIssueTypeAssetLabel2",
            defaultMessage: "Issue type: Story"
        }),
        createIssueModalIssueTypeAssetLabel3: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalIssueTypeAssetLabel3",
            defaultMessage: "Issue type: Bug"
        }),
        createIssueModalPriorityAssetLabel1: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalPriorityAssetLabel1",
            defaultMessage: "Priority: High"
        }),
        createIssueModalPriorityAssetLabel2: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalPriorityAssetLabel2",
            defaultMessage: "Priority: Critical"
        }),
        createIssueModalPriorityAssetLabel3: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalPriorityAssetLabel3",
            defaultMessage: "Priority: Blocker"
        }),
        createIssueModalPriorityAssetLabel4: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalPriorityAssetLabel4",
            defaultMessage: "Priority: Minor"
        }),
        createIssueModalAssigneeAssetLabel1: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalAssigneeAssetLabel1",
            defaultMessage: "Assignee: Alvin"
        }),
        createIssueModalAssigneeAssetLabel2: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalAssigneeAssetLabel2",
            defaultMessage: "Assignee: Jane"
        }),
        createIssueModalAssigneeAssetLabel3: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalAssigneeAssetLabel3",
            defaultMessage: "Assignee: Blake"
        }),
        epicNameFeatures: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.epicNameFeatures",
            defaultMessage: "features"
        }),
        epicNameAnalytics: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.epicNameAnalytics",
            defaultMessage: "analytics"
        }),
        epicNamePayments: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.epicNamePayments",
            defaultMessage: "payments"
        }),
        priorityHigh: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.priorityHigh",
            defaultMessage: "high"
        }),
        priorityCritical: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.priorityCritical",
            defaultMessage: "critical"
        }),
        priorityMinor: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.priorityMinor",
            defaultMessage: "minor"
        }),
        priorityBlocker: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.priorityBlocker",
            defaultMessage: "blocker"
        }),
        issueTypeBug: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.issueTypeBug",
            defaultMessage: "bug"
        }),
        issueTypeStory: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.issueTypeStory",
            defaultMessage: "story"
        }),
        issueTypeTask: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.issueTypeTask",
            defaultMessage: "task"
        }),
        epicNameAssets: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.epicNameAssets",
            defaultMessage: "assets"
        }),
        epicNameStrategy: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.epicNameStrategy",
            defaultMessage: "strategy"
        }),
        epicNameBudget: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.epicNameBudget",
            defaultMessage: "budget"
        }),
        epicNameQ1Campaign: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.epicQ1Campaign",
            defaultMessage: "q1 campaign"
        })
    };
    (0, $iSvIT.useState)(()=>{
        setMessages(messages);
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            isCardTyping && /*#__PURE__*/ (0, $loA2J.jsx)((0, $el0Oi.AnimatedTypingCard), {
                card: props.animatedJiraCardOverride
            }),
            !isCardTyping && /*#__PURE__*/ (0, $loA2J.jsx)((0, $8XM36.JswAnimatedBoard), {
                inProgressCardsOverride: props.inProgressCardsOverride,
                doneCardsOverride: props.doneCardsOverride
            })
        ]
    });
};

});
parcelRegister("el0Oi", function(module, exports) {

$parcel$export(module.exports, "AnimatedTypingCard", function () { return $933ec7858f8ede69$export$6e2fcd8758e3fff8; });
/* animated-typing-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");

var $85mql = parcelRequire("85mql");
parcelRequire("krGYQ");
var $78oyp = parcelRequire("78oyp");
var $LEeB6 = parcelRequire("LEeB6");

var $4MTGk = parcelRequire("4MTGk");
const $933ec7858f8ede69$var$cardStyles = null;
const $933ec7858f8ede69$var$cardTitleWrapper = null;
const $933ec7858f8ede69$var$cardTitle = null;
const $933ec7858f8ede69$var$issueTypeContainer = null;
const $933ec7858f8ede69$var$typePriorityAssigneeRow = null;
const $933ec7858f8ede69$var$animateCard = null;
const $933ec7858f8ede69$export$6e2fcd8758e3fff8 = (props)=>{
    // constants
    const id = (0, $85mql.ANIMATED_CARD_ID);
    const issueType = (0, $85mql.IssueTypeName).STORY;
    const [{ messages: messages }, { animateIssue: animateIssue, nextAnimationStep: nextAnimationStep }] = (0, $4MTGk.useAnimatedJiraBoardStore)();
    const cardDetails = (0, $iSvIT.useMemo)(()=>{
        return (0, $6iHNw._)((0, $7Knp0._)({
            summary: messages.animatedCardHeading,
            issueType: issueType,
            epicName: (0, $85mql.EpicName).FEATURES,
            assignee: (0, $85mql.Assignee).ALVIN,
            priority: (0, $85mql.Priority).HIGH
        }, props.card), {
            id: id
        });
    }, [
        id,
        issueType,
        messages.animatedCardHeading,
        props.card
    ]);
    const issueTypeElement = (0, $78oyp.getAssetOptionsForIssueType)(cardDetails.issueType, messages, true);
    (0, $iSvIT.useEffect)(()=>{
        setTimeout(()=>{
            nextAnimationStep();
            animateIssue(cardDetails);
        }, 4200);
    }, [
        animateIssue,
        cardDetails,
        nextAnimationStep
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "aria-describedby": id,
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _1bah1yb4 _syaz10fz _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf _2rko19bv _11q7cd5j _1bsbdgin _4t3iuuw1 _16qs1ie2 _1reo15vq _18m915vq",
            "_y44vyt1s"
        ]),
        style: {
            "--_1vqiml3": (0, $43MIc.default)((0, $LEeB6.colors).text),
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1bsb1ns9"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    id: id,
                    className: (0, $esG4f.default)([
                        "_syaz1765 _1wyb1tcg _zg8l4jg8 _k48pni7l _1bsb1osq _vwz41wqb _1reo15vq _18m915vq _t51zuaqw _o5721q9c _y44vn48t"
                    ]),
                    style: {
                        "--_1jttx64": (0, $43MIc.default)((0, $LEeB6.colors).black),
                        "--_1cyyhae": (0, $43MIc.default)((0, $LEeB6.colors).textSelected)
                    },
                    children: cardDetails.summary
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx2vrvc",
                    "type-priority-assignee-row"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx2vrvc _4cvr1h6o _zulp14y2",
                        "issue-type-container"
                    ]),
                    children: issueTypeElement
                })
            })
        ]
    });
};

});
parcelRegister("85mql", function(module, exports) {

$parcel$export(module.exports, "AnimationSteps", function () { return $a3bbdd86b7939cd2$export$34f7398b19a809cb; });
$parcel$export(module.exports, "IssueTypeName", function () { return $a3bbdd86b7939cd2$export$41bec0868bbe9664; });
$parcel$export(module.exports, "EpicName", function () { return $a3bbdd86b7939cd2$export$82af5b919cf981f7; });
$parcel$export(module.exports, "Assignee", function () { return $a3bbdd86b7939cd2$export$361f73eba39649ac; });
$parcel$export(module.exports, "Priority", function () { return $a3bbdd86b7939cd2$export$300334f671c43555; });
$parcel$export(module.exports, "stepsLength", function () { return $a3bbdd86b7939cd2$export$33096039fd990cf4; });
$parcel$export(module.exports, "ANIMATED_CARD_ID", function () { return $a3bbdd86b7939cd2$export$a04d920b5f45f5a4; });
var $a3bbdd86b7939cd2$export$34f7398b19a809cb;
(function(AnimationSteps) {
    AnimationSteps[AnimationSteps["CARD_TYPING"] = 0] = "CARD_TYPING";
    AnimationSteps[AnimationSteps["TODO_COL"] = 1] = "TODO_COL";
    AnimationSteps[AnimationSteps["IN_PROG_COL"] = 2] = "IN_PROG_COL";
    AnimationSteps[AnimationSteps["DONE_COL"] = 3] = "DONE_COL";
})($a3bbdd86b7939cd2$export$34f7398b19a809cb || ($a3bbdd86b7939cd2$export$34f7398b19a809cb = {}));
var $a3bbdd86b7939cd2$export$b6032183171af19f;
(function(Project) {
    Project["TeamRocket"] = "team-rocket";
})($a3bbdd86b7939cd2$export$b6032183171af19f || ($a3bbdd86b7939cd2$export$b6032183171af19f = {}));
var $a3bbdd86b7939cd2$export$41bec0868bbe9664;
(function(IssueTypeName) {
    IssueTypeName["TASK"] = "task";
    IssueTypeName["STORY"] = "story";
    IssueTypeName["BUG"] = "bug";
    IssueTypeName["NO_ISSUE"] = "no-issue";
})($a3bbdd86b7939cd2$export$41bec0868bbe9664 || ($a3bbdd86b7939cd2$export$41bec0868bbe9664 = {}));
var $a3bbdd86b7939cd2$export$82af5b919cf981f7;
(function(EpicName) {
    EpicName["FEATURES"] = "features";
    EpicName["ANALYTICS"] = "analytics";
    EpicName["PAYMENTS"] = "payments";
    EpicName["ASSETS"] = "assets";
    EpicName["STRATEGY"] = "strategy";
    EpicName["BUDGET"] = "budget";
    EpicName["Q1_CAMPAIGN"] = "q1 campaign";
})($a3bbdd86b7939cd2$export$82af5b919cf981f7 || ($a3bbdd86b7939cd2$export$82af5b919cf981f7 = {}));
var $a3bbdd86b7939cd2$export$361f73eba39649ac;
(function(Assignee) {
    Assignee["ALVIN"] = "alvin";
    Assignee["JANE"] = "jane";
    Assignee["BLAKE"] = "blake";
})($a3bbdd86b7939cd2$export$361f73eba39649ac || ($a3bbdd86b7939cd2$export$361f73eba39649ac = {}));
var $a3bbdd86b7939cd2$export$300334f671c43555;
(function(Priority) {
    Priority["HIGH"] = "high";
    Priority["CRITICAL"] = "critical";
    Priority["BLOCKER"] = "blocker";
    Priority["MINOR"] = "minor";
})($a3bbdd86b7939cd2$export$300334f671c43555 || ($a3bbdd86b7939cd2$export$300334f671c43555 = {}));
const $a3bbdd86b7939cd2$export$33096039fd990cf4 = Object.keys($a3bbdd86b7939cd2$export$34f7398b19a809cb).length / 2;
const $a3bbdd86b7939cd2$export$22aad1fd6cb58c70 = 255;
const $a3bbdd86b7939cd2$export$938f0a0c059b7000 = 3000;
const $a3bbdd86b7939cd2$export$a04d920b5f45f5a4 = "animated-card";

});

parcelRegister("krGYQ", function(module, exports) {
$parcel$export(module.exports, "colors", function () { return (parcelRequire("LEeB6")).colors; });
$parcel$export(module.exports, "getAssetForEpicLink", function () { return (parcelRequire("78oyp")).getAssetForEpicLink; });
$parcel$export(module.exports, "getAssetOptionsForAssignee", function () { return (parcelRequire("78oyp")).getAssetOptionsForAssignee; });
$parcel$export(module.exports, "getAssetOptionsForIssueType", function () { return (parcelRequire("78oyp")).getAssetOptionsForIssueType; });
$parcel$export(module.exports, "getAssetOptionsForPriority", function () { return (parcelRequire("78oyp")).getAssetOptionsForPriority; });
parcelRequire("LEeB6");
parcelRequire("78oyp");

});
parcelRegister("LEeB6", function(module, exports) {

$parcel$export(module.exports, "colors", function () { return $b5ec46f4b3ddf218$export$8f45430ccf837300; });
/* eslint-disable local/ensure-wac-token-usage */ // custom colors that are not covered by wacToken
const $b5ec46f4b3ddf218$export$8f45430ccf837300 = {
    black: "#000000",
    elevationSurfaceSunken: "#F7F8F9",
    text: "#172B4D",
    textSelected: "#0C66E4",
    textSubtle: "#44546F"
};

});

parcelRegister("78oyp", function(module, exports) {

$parcel$export(module.exports, "getAssetOptionsForIssueType", function () { return $3cc3a7da94a279db$export$d3e272371e479228; });
$parcel$export(module.exports, "getAssetOptionsForPriority", function () { return $3cc3a7da94a279db$export$5aec24a3628dae7c; });
$parcel$export(module.exports, "getAssetOptionsForAssignee", function () { return $3cc3a7da94a279db$export$d910478ee874e351; });
$parcel$export(module.exports, "getAssetForEpicLink", function () { return $3cc3a7da94a279db$export$2eeaca611ab4ba57; });
/* get-asset-options.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $RBncq = parcelRequire("RBncq");

var $h6XJS = parcelRequire("h6XJS");

var $3m6hY = parcelRequire("3m6hY");

var $8xSOc = parcelRequire("8xSOc");
parcelRequire("kbBaE");
var $1qPcY = parcelRequire("1qPcY");
var $iIcC7 = parcelRequire("iIcC7");
var $l9rqd = parcelRequire("l9rqd");
var $aegDZ = parcelRequire("aegDZ");
var $4Juu3 = parcelRequire("4Juu3");
var $lB82X = parcelRequire("lB82X");
var $89lHQ = parcelRequire("89lHQ");

var $85mql = parcelRequire("85mql");
const $3cc3a7da94a279db$var$issueText = null;
const $3cc3a7da94a279db$export$d3e272371e479228 = (value, messages, includeLabel)=>{
    const { createIssueModalIssueTypeAssetLabel1: createIssueModalIssueTypeAssetLabel1, createIssueModalIssueTypeAssetLabel2: createIssueModalIssueTypeAssetLabel2, createIssueModalIssueTypeAssetLabel3: createIssueModalIssueTypeAssetLabel3 } = includeLabel ? messages : {
        createIssueModalIssueTypeAssetLabel1: "",
        createIssueModalIssueTypeAssetLabel2: "",
        createIssueModalIssueTypeAssetLabel3: ""
    };
    switch(value){
        case (0, $85mql.IssueTypeName).TASK:
            return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3m6hY))), {
                        label: createIssueModalIssueTypeAssetLabel1
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        "aria-hidden": true,
                        className: (0, $esG4f.default)([
                            "_1p1dangw _ahbq1y44 _1wyb1skh _zg8l4jg8 _k48p1fw0 _vwz47vkz"
                        ]),
                        children: messages.issueTypeTask
                    })
                ]
            });
        case (0, $85mql.IssueTypeName).STORY:
            return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h6XJS))), {
                        label: createIssueModalIssueTypeAssetLabel2
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        "aria-hidden": true,
                        className: (0, $esG4f.default)([
                            "_1p1dangw _ahbq1y44 _1wyb1skh _zg8l4jg8 _k48p1fw0 _vwz47vkz"
                        ]),
                        children: messages.issueTypeStory
                    })
                ]
            });
        case (0, $85mql.IssueTypeName).BUG:
            return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($RBncq))), {
                        label: createIssueModalIssueTypeAssetLabel3
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        "aria-hidden": true,
                        className: (0, $esG4f.default)([
                            "_1p1dangw _ahbq1y44 _1wyb1skh _zg8l4jg8 _k48p1fw0 _vwz47vkz"
                        ]),
                        children: messages.issueTypeBug
                    })
                ]
            });
        case (0, $85mql.IssueTypeName).NO_ISSUE:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {});
        default:
            console.warn(`Asset for issue type ${value} does not exist.`);
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3m6hY))), {
                label: createIssueModalIssueTypeAssetLabel1
            });
    }
};
const $3cc3a7da94a279db$export$5aec24a3628dae7c = (value, messages, includeLabel)=>{
    const { createIssueModalPriorityAssetLabel1: createIssueModalPriorityAssetLabel1, createIssueModalPriorityAssetLabel2: createIssueModalPriorityAssetLabel2, createIssueModalPriorityAssetLabel3: createIssueModalPriorityAssetLabel3, createIssueModalPriorityAssetLabel4: createIssueModalPriorityAssetLabel4 } = includeLabel ? messages : {
        createIssueModalPriorityAssetLabel1: "",
        createIssueModalPriorityAssetLabel2: "",
        createIssueModalPriorityAssetLabel3: "",
        createIssueModalPriorityAssetLabel4: ""
    };
    switch(value){
        case (0, $85mql.Priority).HIGH:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1qPcY.PriorityHigh16Icon), {
                label: createIssueModalPriorityAssetLabel1
            });
        case (0, $85mql.Priority).CRITICAL:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iIcC7.PriorityCritical24Icon), {
                label: createIssueModalPriorityAssetLabel2
            });
        case (0, $85mql.Priority).BLOCKER:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $l9rqd.PriorityBlocker24Icon), {
                label: createIssueModalPriorityAssetLabel3
            });
        case (0, $85mql.Priority).MINOR:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aegDZ.PriorityMinor24Icon), {
                label: createIssueModalPriorityAssetLabel4
            });
        default:
            console.warn(`Asset for priority ${value} does not exist.`);
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aegDZ.PriorityMinor24Icon), {
                label: createIssueModalPriorityAssetLabel1
            });
    }
};
const $3cc3a7da94a279db$export$d910478ee874e351 = (value, messages, includeLabel)=>{
    const { createIssueModalAssigneeAssetLabel1: createIssueModalAssigneeAssetLabel1, createIssueModalAssigneeAssetLabel2: createIssueModalAssigneeAssetLabel2, createIssueModalAssigneeAssetLabel3: createIssueModalAssigneeAssetLabel3 } = includeLabel ? messages : {
        createIssueModalAssigneeAssetLabel1: "",
        createIssueModalAssigneeAssetLabel2: "",
        createIssueModalAssigneeAssetLabel3: ""
    };
    switch(value){
        case (0, $85mql.Assignee).ALVIN:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4Juu3.AssigneeAlvin24Image), {
                alt: createIssueModalAssigneeAssetLabel1
            });
        case (0, $85mql.Assignee).JANE:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lB82X.AssigneeJane24Image), {
                alt: createIssueModalAssigneeAssetLabel2
            });
        case (0, $85mql.Assignee).BLAKE:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $89lHQ.AssigneeBlake24Image), {
                alt: createIssueModalAssigneeAssetLabel3
            });
        default:
            console.warn(`Asset for assignee ${value} does not exist.`);
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4Juu3.AssigneeAlvin24Image), {
                alt: createIssueModalAssigneeAssetLabel1
            });
    }
};
const $3cc3a7da94a279db$export$2eeaca611ab4ba57 = (value, messages)=>{
    switch(value){
        case (0, $85mql.EpicName).FEATURES:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                appearance: "inprogress",
                isBold: true,
                children: messages.epicNameFeatures
            });
        case (0, $85mql.EpicName).ANALYTICS:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                appearance: "success",
                isBold: true,
                children: messages.epicNameAnalytics
            });
        case (0, $85mql.EpicName).PAYMENTS:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                appearance: "new",
                isBold: true,
                children: messages.epicNamePayments
            });
        case (0, $85mql.EpicName).ASSETS:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                appearance: "moved",
                isBold: true,
                children: messages.epicNameAssets
            });
        case (0, $85mql.EpicName).STRATEGY:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                appearance: "inprogress",
                isBold: true,
                children: messages.epicNameStrategy
            });
        case (0, $85mql.EpicName).BUDGET:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                appearance: "success",
                isBold: true,
                children: messages.epicNameBudget
            });
        case (0, $85mql.EpicName).Q1_CAMPAIGN:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                appearance: "inprogress",
                isBold: true,
                children: messages.epicNameQ1Campaign
            });
        default:
            console.warn(`Asset for epic link ${value} does not exist.`);
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                appearance: "inprogress",
                isBold: true,
                children: value
            });
    }
};

});
parcelRegister("RBncq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0a11f0e335025ed4$var$_react = $0a11f0e335025ed4$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $aq08R = parcelRequire("aq08R");
function $0a11f0e335025ed4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $0a11f0e335025ed4$var$Bug16Icon = (props)=>/*#__PURE__*/ $0a11f0e335025ed4$var$_react.default.createElement($aq08R.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6 12a4 4 0 100-8 4 4 0 000 8z"/></svg>`
    }, props, {
        size: "small"
    }));
$0a11f0e335025ed4$var$Bug16Icon.displayName = "Bug16Icon";
var $0a11f0e335025ed4$var$_default = $0a11f0e335025ed4$var$Bug16Icon;
module.exports.default = $0a11f0e335025ed4$var$_default;

});
parcelRegister("aq08R", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $795c7147db52ce07$export$f04a61298a47a40f; });

var $2p5Xr = parcelRequire("2p5Xr");

var $5ScFE = parcelRequire("5ScFE");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $92BHb = parcelRequire("92BHb");

var $7R2ca = parcelRequire("7R2ca");

var $iVdhe = parcelRequire("iVdhe");
function $795c7147db52ce07$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $795c7147db52ce07$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $795c7147db52ce07$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $5ScFE.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $795c7147db52ce07$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $795c7147db52ce07$var$iconStyles = (0, $2ZUkg.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> svg": $795c7147db52ce07$var$_objectSpread($795c7147db52ce07$var$_objectSpread({}, (0, $iVdhe.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $795c7147db52ce07$var$baseHcmStyles = (0, $2ZUkg.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $795c7147db52ce07$var$primaryEqualsSecondaryHcmStyles = (0, $2ZUkg.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $795c7147db52ce07$var$secondaryTransparentHcmStyles = (0, $2ZUkg.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $795c7147db52ce07$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $2ZUkg.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $iVdhe.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    var _useGlobalTheme = (0, $92BHb.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $2ZUkg.jsx)("span", (0, $2p5Xr.default)({
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            "--icon-secondary-color": secondaryColor || (0, $7R2ca.getBackground)(mode)
        }
    }, glyphProps, {
        css: [
            $795c7147db52ce07$var$iconStyles,
            $795c7147db52ce07$var$baseHcmStyles,
            primaryColor === secondaryColor && $795c7147db52ce07$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $795c7147db52ce07$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $2ZUkg.css)({
                width: dimensions.width,
                height: dimensions.height,
                "> svg": dimensions
            })
        ]
    }));
});
var $795c7147db52ce07$export$2e2bcd8739ae039 = $795c7147db52ce07$export$f04a61298a47a40f;

});
parcelRegister("2p5Xr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c0289aaad73c457$export$2e2bcd8739ae039; });
function $1c0289aaad73c457$export$2e2bcd8739ae039() {
    return $1c0289aaad73c457$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1c0289aaad73c457$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("5ScFE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $446bd3124bfb46c2$export$2e2bcd8739ae039; });

var $jltev = parcelRequire("jltev");
function $446bd3124bfb46c2$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $jltev.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("jltev", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e156a78f7e3181fe$export$2e2bcd8739ae039; });

var $5x5Bg = parcelRequire("5x5Bg");

var $drI6V = parcelRequire("drI6V");
function $e156a78f7e3181fe$export$2e2bcd8739ae039(t) {
    var i = (0, $drI6V.default)(t, "string");
    return "symbol" == (0, $5x5Bg.default)(i) ? i : i + "";
}

});
parcelRegister("5x5Bg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $407460e2a6ec6969$export$2e2bcd8739ae039; });
function $407460e2a6ec6969$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $407460e2a6ec6969$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $407460e2a6ec6969$export$2e2bcd8739ae039(o);
}

});

parcelRegister("drI6V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ca0036d50b30d3c$export$2e2bcd8739ae039; });

var $5x5Bg = parcelRequire("5x5Bg");
function $9ca0036d50b30d3c$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $5x5Bg.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $5x5Bg.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("92BHb", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", function () { return $69518a8212815c20$export$7692396083754928; });

var $85ijK = parcelRequire("85ijK");
// Create default global light theme
var $69518a8212815c20$var$_createTheme = (0, $85ijK.createTheme)(function() {
    return {
        mode: "light"
    };
}), $69518a8212815c20$var$Provider = $69518a8212815c20$var$_createTheme.Provider, $69518a8212815c20$var$Consumer = $69518a8212815c20$var$_createTheme.Consumer, $69518a8212815c20$export$7692396083754928 = $69518a8212815c20$var$_createTheme.useTheme;
var $69518a8212815c20$export$2e2bcd8739ae039 = {
    Provider: $69518a8212815c20$var$Provider,
    Consumer: $69518a8212815c20$var$Consumer
};

});
parcelRegister("85ijK", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $5e2cffcff8166eb4$export$25d302a5b900a763; });

var $FOVCo = parcelRequire("FOVCo");

var $iSvIT = parcelRequire("iSvIT");
var $5e2cffcff8166eb4$var$_excluded = [
    "children"
];
function $5e2cffcff8166eb4$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $iSvIT.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $iSvIT.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $FOVCo.default)(props, $5e2cffcff8166eb4$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $iSvIT.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $iSvIT.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});
parcelRegister("FOVCo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07db55c12b80e284$export$2e2bcd8739ae039; });

var $eRAvS = parcelRequire("eRAvS");
function $07db55c12b80e284$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $eRAvS.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("eRAvS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad2256b344d80bcd$export$2e2bcd8739ae039; });
function $ad2256b344d80bcd$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});




parcelRegister("7R2ca", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $5b7f2f8e5b7c88e2$export$18cb9425622d4e06; });
var $5b7f2f8e5b7c88e2$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $5b7f2f8e5b7c88e2$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "light";
    return $5b7f2f8e5b7c88e2$var$themedBackground[mode];
};

});

parcelRegister("iVdhe", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $dc67d9642d22a737$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $dc67d9642d22a737$export$3eb7d6130acfda37; });

var $G3TfW = parcelRequire("G3TfW");

var $2ZUkg = parcelRequire("2ZUkg");
var $dc67d9642d22a737$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
var $dc67d9642d22a737$var$smallStyles = (0, $2ZUkg.css)((0, $G3TfW.dimensions).small);
var $dc67d9642d22a737$var$mediumStyles = (0, $2ZUkg.css)((0, $G3TfW.dimensions).medium);
var $dc67d9642d22a737$var$largeStyles = (0, $2ZUkg.css)((0, $G3TfW.dimensions).large);
var $dc67d9642d22a737$var$xlargeStyles = (0, $2ZUkg.css)((0, $G3TfW.dimensions).xlarge);
var $dc67d9642d22a737$export$ef0ad74202575b64 = {
    small: $dc67d9642d22a737$var$smallStyles,
    medium: $dc67d9642d22a737$var$mediumStyles,
    large: $dc67d9642d22a737$var$largeStyles,
    xlarge: $dc67d9642d22a737$var$xlargeStyles
};
var $dc67d9642d22a737$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $G3TfW.dimensions)[size];
    return undefined;
};

});
parcelRegister("G3TfW", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $07e6f0e0864a7d74$export$62ad7b0c781000e9; });
var $07e6f0e0864a7d74$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $07e6f0e0864a7d74$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $07e6f0e0864a7d74$export$62ad7b0c781000e9 = {
    small: {
        width: $07e6f0e0864a7d74$export$c647cb0ee6e282fe.small,
        height: $07e6f0e0864a7d74$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $07e6f0e0864a7d74$export$c647cb0ee6e282fe.medium,
        height: $07e6f0e0864a7d74$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $07e6f0e0864a7d74$export$c647cb0ee6e282fe.large,
        height: $07e6f0e0864a7d74$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $07e6f0e0864a7d74$export$c647cb0ee6e282fe.xlarge,
        height: $07e6f0e0864a7d74$export$c647cb0ee6e282fe.xlarge
    }
};

});




parcelRegister("h6XJS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c751561ab60544bd$var$_react = $c751561ab60544bd$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $aq08R = parcelRequire("aq08R");
function $c751561ab60544bd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c751561ab60544bd$var$Story16Icon = (props)=>/*#__PURE__*/ $c751561ab60544bd$var$_react.default.createElement($aq08R.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36B37E" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6 11l-2.863 1.822c-.42.38-1.137.111-1.137-.427v-8.19C4 3.54 4.596 3 5.333 3h5.334C11.403 3 12 3.539 12 4.206v8.19c0 .537-.719.806-1.139.426L8 11zm0-2.371l2 1.274V5H6v4.902L8 8.63z"/></svg>`
    }, props, {
        size: "small"
    }));
$c751561ab60544bd$var$Story16Icon.displayName = "Story16Icon";
var $c751561ab60544bd$var$_default = $c751561ab60544bd$var$Story16Icon;
module.exports.default = $c751561ab60544bd$var$_default;

});

parcelRegister("3m6hY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $27184e06ef42eb5b$var$_react = $27184e06ef42eb5b$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $aq08R = parcelRequire("aq08R");
function $27184e06ef42eb5b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $27184e06ef42eb5b$var$Task16Icon = (props)=>/*#__PURE__*/ $27184e06ef42eb5b$var$_react.default.createElement($aq08R.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0114.006 16H1.994A1.995 1.995 0 010 14.006V1.994zM4.667 3C3.747 3 3 3.746 3 4.667v6.666C3 12.253 3.746 13 4.667 13h6.666c.92 0 1.667-.746 1.667-1.667V4.667C13 3.747 12.254 3 11.333 3H4.667zM5 5v6h6V5H5z"/></svg>`
    }, props, {
        size: "small"
    }));
$27184e06ef42eb5b$var$Task16Icon.displayName = "Task16Icon";
var $27184e06ef42eb5b$var$_default = $27184e06ef42eb5b$var$Task16Icon;
module.exports.default = $27184e06ef42eb5b$var$_default;

});

parcelRegister("kbBaE", function(module, exports) {

$parcel$export(module.exports, "PriorityHigh16Icon", function () { return (parcelRequire("1qPcY")).PriorityHigh16Icon; });
$parcel$export(module.exports, "PriorityCritical24Icon", function () { return (parcelRequire("iIcC7")).PriorityCritical24Icon; });
$parcel$export(module.exports, "PriorityBlocker24Icon", function () { return (parcelRequire("l9rqd")).PriorityBlocker24Icon; });
$parcel$export(module.exports, "PriorityMinor24Icon", function () { return (parcelRequire("aegDZ")).PriorityMinor24Icon; });
$parcel$export(module.exports, "AssigneeAlvin24Image", function () { return (parcelRequire("4Juu3")).AssigneeAlvin24Image; });
$parcel$export(module.exports, "AssigneeJane24Image", function () { return (parcelRequire("lB82X")).AssigneeJane24Image; });
$parcel$export(module.exports, "AssigneeBlake24Image", function () { return (parcelRequire("89lHQ")).AssigneeBlake24Image; });

var $1qPcY = parcelRequire("1qPcY");

var $iIcC7 = parcelRequire("iIcC7");

var $l9rqd = parcelRequire("l9rqd");

var $aegDZ = parcelRequire("aegDZ");

var $4Juu3 = parcelRequire("4Juu3");

var $lB82X = parcelRequire("lB82X");

var $89lHQ = parcelRequire("89lHQ");

});
parcelRegister("1qPcY", function(module, exports) {

$parcel$export(module.exports, "PriorityHigh16Icon", function () { return $820f3485f51b6b16$export$dd6325c289ca803; });

var $loA2J = parcelRequire("loA2J");

var $1IjLq = parcelRequire("1IjLq");

var $48zDN = parcelRequire("48zDN");
const $820f3485f51b6b16$var$PriorityHigh16Glyph = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props["data-testid"],
        className: props.className,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M9.34379 4.09779L9.41258 4.14609L12.7459 6.81275C13.0334 7.04276 13.08 7.46229 12.85 7.7498C12.6377 8.01519 12.2639 8.07532 11.9815 7.9021L11.913 7.85391L8.99612 5.52L6.07925 7.85391C5.81386 8.06623 5.43597 8.04284 5.1985 7.81185L5.14221 7.7498C4.92989 7.48441 4.95328 7.10652 5.18427 6.86905L5.24632 6.81275L8.57965 4.14609C8.801 3.96901 9.10705 3.95291 9.34379 4.09779Z",
            fill: (0, $48zDN.R300)
        })
    });
const $820f3485f51b6b16$export$dd6325c289ca803 = ({ label: label })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1IjLq.default), {
        glyph: $820f3485f51b6b16$var$PriorityHigh16Glyph,
        label: label
    });
};

});

parcelRegister("iIcC7", function(module, exports) {

$parcel$export(module.exports, "PriorityCritical24Icon", function () { return $b3de3bdf6b339ece$export$e8c8b58c821b2482; });

var $loA2J = parcelRequire("loA2J");

var $1IjLq = parcelRequire("1IjLq");

var $48zDN = parcelRequire("48zDN");
const $b3de3bdf6b339ece$var$PriorityCritical24Glyph = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props["data-testid"],
        className: props.className,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M11.3753 4.21913L6.3753 8.21913C6.13809 8.4089 6 8.69622 6 9V19L6.00589 19.112C6.08752 19.8788 6.99969 20.2809 7.6247 19.7809L12 16.28L16.3753 19.7809C17.0301 20.3047 18 19.8385 18 19V9C18 8.69622 17.8619 8.4089 17.6247 8.21913L12.6247 4.21913C12.2595 3.92696 11.7405 3.92696 11.3753 4.21913Z",
            fill: (0, $48zDN.R300)
        })
    });
const $b3de3bdf6b339ece$export$e8c8b58c821b2482 = ({ label: label })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1IjLq.default), {
        glyph: $b3de3bdf6b339ece$var$PriorityCritical24Glyph,
        label: label
    });
};

});

parcelRegister("l9rqd", function(module, exports) {

$parcel$export(module.exports, "PriorityBlocker24Icon", function () { return $ab2542cd2d76cb15$export$13dfa89176f2d0ab; });

var $loA2J = parcelRequire("loA2J");

var $1IjLq = parcelRequire("1IjLq");

var $48zDN = parcelRequire("48zDN");
const $ab2542cd2d76cb15$var$PriorityBlocker24Glyph = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props["data-testid"],
        className: props.className,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM7 11L6.88338 11.0067C6.38604 11.0645 6 11.4872 6 12C6 12.5523 6.44772 13 7 13H17L17.1166 12.9933C17.614 12.9355 18 12.5128 18 12C18 11.4477 17.5523 11 17 11H7Z",
            fill: (0, $48zDN.R300)
        })
    });
const $ab2542cd2d76cb15$export$13dfa89176f2d0ab = ({ label: label })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1IjLq.default), {
        glyph: $ab2542cd2d76cb15$var$PriorityBlocker24Glyph,
        label: label
    });
};

});

parcelRegister("aegDZ", function(module, exports) {

$parcel$export(module.exports, "PriorityMinor24Icon", function () { return $cbd766515436e751$export$7da8240bfa3b7af4; });

var $loA2J = parcelRequire("loA2J");

var $1IjLq = parcelRequire("1IjLq");
const $cbd766515436e751$var$PriorityMinor24Glyph = (props)=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props["data-testid"],
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M18.4491 14.975C18.6764 14.8427 18.9468 14.8054 19.2015 14.871C19.4563 14.9367 19.6749 15.1001 19.81 15.3258C19.9451 15.5516 19.9858 15.8214 19.9233 16.077C19.8608 16.3325 19.7001 16.5531 19.4761 16.691L12.5061 20.864C12.3503 20.9571 12.1722 21.0062 11.9908 21.0058C11.8093 21.0055 11.6314 20.9557 11.4761 20.862L4.57005 16.69C4.34303 16.5529 4.17977 16.3312 4.11619 16.0737C4.05262 15.8162 4.09393 15.544 4.23105 15.317C4.36817 15.09 4.58986 14.9267 4.84734 14.8631C5.10483 14.7996 5.37703 14.8409 5.60405 14.978L11.9951 18.84L18.4491 14.976V14.975Z",
                fill: "#388BFF"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M11.9951 12.837L18.4491 8.97197C18.6764 8.83969 18.9468 8.80233 19.2015 8.868C19.4563 8.93367 19.6749 9.09707 19.81 9.3228C19.9451 9.54853 19.9858 9.8184 19.9233 10.0739C19.8608 10.3295 19.7001 10.5501 19.4761 10.688L12.5061 14.862C12.3503 14.9551 12.1722 15.0041 11.9908 15.0038C11.8093 15.0034 11.6314 14.9537 11.4761 14.86L4.57005 10.686C4.34303 10.5489 4.17977 10.3272 4.11619 10.0697C4.05262 9.81219 4.09393 9.54 4.23105 9.31297C4.36817 9.08595 4.58986 8.92269 4.84734 8.85911C5.10483 8.79554 5.37703 8.83685 5.60405 8.97397L11.9951 12.837Z",
                fill: "#388BFF"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M11.9951 6.82306L18.4491 2.95806C18.5618 2.88868 18.6872 2.84237 18.8179 2.82182C18.9487 2.80127 19.0822 2.80688 19.2108 2.83833C19.3394 2.86978 19.4604 2.92644 19.5669 3.00503C19.6734 3.08362 19.7633 3.18257 19.8313 3.29615C19.8992 3.40973 19.944 3.53567 19.9629 3.66668C19.9818 3.79768 19.9746 3.93114 19.9415 4.05932C19.9085 4.18749 19.8503 4.30783 19.7704 4.41336C19.6905 4.51889 19.5905 4.6075 19.4761 4.67406L12.5061 8.84806C12.3503 8.9412 12.1722 8.99022 11.9908 8.98987C11.8093 8.98952 11.6314 8.93981 11.4761 8.84606L4.57005 4.67206C4.34303 4.53494 4.17977 4.31326 4.11619 4.05577C4.05262 3.79828 4.09393 3.52609 4.23105 3.29906C4.36817 3.07203 4.58986 2.90878 4.84734 2.8452C5.10483 2.78163 5.37703 2.82294 5.60405 2.96006L11.9951 6.82306Z",
                fill: "#388BFF"
            })
        ]
    });
const $cbd766515436e751$export$7da8240bfa3b7af4 = ({ label: label })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1IjLq.default), {
        glyph: $cbd766515436e751$var$PriorityMinor24Glyph,
        label: label
    });
};

});

parcelRegister("4Juu3", function(module, exports) {

$parcel$export(module.exports, "AssigneeAlvin24Image", function () { return $4cf00137a25b325f$export$c9d73c94996ebdb; });

var $loA2J = parcelRequire("loA2J");

var $cssyA = parcelRequire("cssyA");
const $4cf00137a25b325f$export$c9d73c94996ebdb = (props)=>{
    const src = (0, $cssyA.extendBfldrCacheTime)("https://dam-cdn.atl.orangelogic.com/AssetLink/w3ew83t6fv2xk12878a62ut0qlbr50w8.svg");
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $loA2J.jsx)("img", {
        height: 24,
        width: 24,
        alt: props.alt,
        src: src,
        "data-testid": props["data-testid"],
        className: props.className
    }));
};

});

parcelRegister("lB82X", function(module, exports) {

$parcel$export(module.exports, "AssigneeJane24Image", function () { return $d956d18005e42768$export$ba7e78c878adef6e; });

var $loA2J = parcelRequire("loA2J");

var $cssyA = parcelRequire("cssyA");
const $d956d18005e42768$export$ba7e78c878adef6e = (props)=>{
    const src = (0, $cssyA.extendBfldrCacheTime)("https://dam-cdn.atl.orangelogic.com/AssetLink/6smlwl4eifdmx52le043b047ywb2js6v.svg");
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $loA2J.jsx)("img", {
        height: 24,
        width: 24,
        alt: props.alt,
        src: src,
        "data-testid": props["data-testid"],
        className: props.className
    }));
};

});

parcelRegister("89lHQ", function(module, exports) {

$parcel$export(module.exports, "AssigneeBlake24Image", function () { return $86076b615a15e4ba$export$6f4e8d70caa23820; });

var $loA2J = parcelRequire("loA2J");

var $cssyA = parcelRequire("cssyA");
const $86076b615a15e4ba$export$6f4e8d70caa23820 = (props)=>{
    const src = (0, $cssyA.extendBfldrCacheTime)("https://dam-cdn.atl.orangelogic.com/AssetLink/gtou8x0538yr0283q5f5ph4a1qtx16c1.svg");
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $loA2J.jsx)("img", {
        height: 24,
        width: 24,
        alt: props.alt,
        src: src,
        "data-testid": props["data-testid"],
        className: props.className
    }));
};

});




parcelRegister("4MTGk", function(module, exports) {

$parcel$export(module.exports, "useMessages", function () { return $b4409b0b7598ec0d$export$4d17e2d9c5348842; });
$parcel$export(module.exports, "useAnimatedJiraBoardStore", function () { return $b4409b0b7598ec0d$export$736729dc5e146045; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $4ejMU = parcelRequire("4ejMU");
var $ij7wO = parcelRequire("ij7wO");

var $fjR4V = parcelRequire("fjR4V");

var $85mql = parcelRequire("85mql");
const $b4409b0b7598ec0d$var$initialState = {
    animationStep: (0, $85mql.AnimationSteps).CARD_TYPING,
    isCreateButtonFocused: false,
    todoCol: [],
    inProgressCol: [],
    doneCol: [],
    messages: (0, $fjR4V.messages)
};
const $b4409b0b7598ec0d$var$genericRestartAction = ()=>({ setState: setState, getState: getState })=>{
        const { messages: messages } = getState();
        setState((0, $6iHNw._)((0, $7Knp0._)({}, $b4409b0b7598ec0d$var$initialState), {
            messages: messages,
            isCreateButtonFocused: true
        }));
    };
const $b4409b0b7598ec0d$var$actions = {
    animateIssue: (animatedCardData)=>({ setState: setState, getState: getState })=>{
            const { todoCol: todoCol } = getState();
            const todoColAppend = todoCol.concat([
                animatedCardData
            ]);
            setState({
                todoCol: todoColAppend
            });
        },
    nextAnimationStep: ()=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { animationStep: animationStep } = getState();
            if (animationStep === (0, $85mql.stepsLength) - 1) {
                dispatch($b4409b0b7598ec0d$var$genericRestartAction());
                return;
            }
            setState({
                animationStep: animationStep + 1
            });
        },
    restartDemo: ()=>({ setState: setState, getState: getState })=>{
            const { messages: messages, inProgressCol: inProgressCol, doneCol: doneCol } = getState();
            setState((0, $6iHNw._)((0, $7Knp0._)({}, $b4409b0b7598ec0d$var$initialState), {
                messages: messages,
                inProgressCol: inProgressCol,
                doneCol: doneCol,
                isCreateButtonFocused: true
            }));
        },
    setTodoCol: (colInfo)=>({ setState: setState })=>{
            setState({
                todoCol: colInfo
            });
        },
    setDoneCol: (colInfo)=>({ setState: setState })=>{
            setState({
                doneCol: colInfo
            });
        },
    setInProgressCol: (colInfo)=>({ setState: setState })=>{
            setState({
                inProgressCol: colInfo
            });
        },
    setMessages: (messages)=>({ setState: setState })=>{
            setState({
                messages: messages
            });
        },
    transitionToInProgress: ()=>({ setState: setState, getState: getState })=>{
            const { todoCol: todoCol, inProgressCol: inProgressCol } = getState();
            const todoColPop = todoCol.pop();
            const todoCopy = todoCol;
            if (todoColPop) {
                const inProgressAppend = inProgressCol.concat([
                    todoColPop
                ]);
                setState({
                    todoCol: todoCopy,
                    inProgressCol: inProgressAppend
                });
            }
        },
    transitionToDone: ()=>({ setState: setState, getState: getState })=>{
            const { inProgressCol: inProgressCol, doneCol: doneCol } = getState();
            const inProgColPop = inProgressCol.pop();
            const inProgCopy = inProgressCol;
            if (inProgColPop) {
                const doneColAppend = doneCol.concat([
                    inProgColPop
                ]);
                setState({
                    inProgressCol: inProgCopy,
                    doneCol: doneColAppend
                });
            }
        }
};
const $b4409b0b7598ec0d$var$InteractiveBoardStore = (0, $ij7wO.createStore)({
    initialState: $b4409b0b7598ec0d$var$initialState,
    actions: $b4409b0b7598ec0d$var$actions,
    name: "jsw-interactive-board-store"
});
const $b4409b0b7598ec0d$var$getMessages = (state)=>state.messages;
const $b4409b0b7598ec0d$export$4d17e2d9c5348842 = (0, $4ejMU.createHook)($b4409b0b7598ec0d$var$InteractiveBoardStore, {
    selector: $b4409b0b7598ec0d$var$getMessages
});
const $b4409b0b7598ec0d$export$736729dc5e146045 = (0, $4ejMU.createHook)($b4409b0b7598ec0d$var$InteractiveBoardStore);

});
parcelRegister("4ejMU", function(module, exports) {

$parcel$export(module.exports, "createHook", function () { return $3147d1b443b9e51c$export$e7f733c8fc2b8a24; });

var $iSvIT = parcelRequire("iSvIT");

var $ddmnE = parcelRequire("ddmnE");

var $cOw7m = parcelRequire("cOw7m");

var $lJiBM = parcelRequire("lJiBM");
const $3147d1b443b9e51c$var$EMPTY_SELECTOR = ()=>undefined;
const $3147d1b443b9e51c$var$DEFAULT_SELECTOR = (state)=>state;
function $3147d1b443b9e51c$export$e7f733c8fc2b8a24(Store, _temp) {
    let { selector: selector } = _temp === void 0 ? {} : _temp;
    return function useSweetState(propsArg) {
        const { retrieveStore: retrieveStore } = (0, $iSvIT.useContext)((0, $cOw7m.Context));
        const { storeState: storeState, actions: actions } = retrieveStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, $iSvIT.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, $iSvIT.useMemo)(()=>selector ? (0, $lJiBM.getSelectorInstance)(selector, storeState, hasPropsArg) : selector === null ? $3147d1b443b9e51c$var$EMPTY_SELECTOR : $3147d1b443b9e51c$var$DEFAULT_SELECTOR, [
            hasPropsArg,
            storeState
        ]);
        const forceUpdate = (0, $iSvIT.useState)({})[1];
        const getSnapshot = (0, $iSvIT.useCallback)(()=>{
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            const state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        const currentState = (0, $ddmnE.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function $3147d1b443b9e51c$export$7c643e1d6648e418(Store) {
    const useHook = $3147d1b443b9e51c$export$e7f733c8fc2b8a24(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function $3147d1b443b9e51c$export$6e4e5611de132e85(Store, _temp2) {
    let { selector: selector } = _temp2 === void 0 ? {} : _temp2;
    const useHook = $3147d1b443b9e51c$export$e7f733c8fc2b8a24(Store, {
        selector: selector
    });
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}

});
parcelRegister("ddmnE", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7N4Fa"));

});
parcelRegister("7N4Fa", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $5ac0b9fa938ca169$export$306c0aa65ff9ec16; }, function (v) { return $5ac0b9fa938ca169$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5ac0b9fa938ca169$export$306c0aa65ff9ec16;
"use strict";

var $iSvIT = parcelRequire("iSvIT");
function $5ac0b9fa938ca169$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $5ac0b9fa938ca169$var$k = "function" === typeof Object.is ? Object.is : $5ac0b9fa938ca169$var$h, $5ac0b9fa938ca169$var$l = $iSvIT.useState, $5ac0b9fa938ca169$var$m = $iSvIT.useEffect, $5ac0b9fa938ca169$var$n = $iSvIT.useLayoutEffect, $5ac0b9fa938ca169$var$p = $iSvIT.useDebugValue;
function $5ac0b9fa938ca169$var$q(a, b) {
    var d = b(), f = $5ac0b9fa938ca169$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $5ac0b9fa938ca169$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $5ac0b9fa938ca169$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $5ac0b9fa938ca169$var$m(function() {
        $5ac0b9fa938ca169$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $5ac0b9fa938ca169$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $5ac0b9fa938ca169$var$p(d);
    return d;
}
function $5ac0b9fa938ca169$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$5ac0b9fa938ca169$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $5ac0b9fa938ca169$var$t(a, b) {
    return b();
}
var $5ac0b9fa938ca169$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $5ac0b9fa938ca169$var$t : $5ac0b9fa938ca169$var$q;
$5ac0b9fa938ca169$export$306c0aa65ff9ec16 = void 0 !== $iSvIT.useSyncExternalStore ? $iSvIT.useSyncExternalStore : $5ac0b9fa938ca169$var$u;

});


parcelRegister("cOw7m", function(module, exports) {

$parcel$export(module.exports, "Context", function () { return $954311787a7a9d4b$export$841858b892ce1f4c; });

var $iSvIT = parcelRequire("iSvIT");

var $lpR5b = parcelRequire("lpR5b");
const $954311787a7a9d4b$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createContext({
    globalRegistry: (0, $lpR5b.defaultRegistry),
    retrieveStore: (Store)=>(0, $lpR5b.defaultRegistry).getStore(Store)
}, ()=>0);

});
parcelRegister("lpR5b", function(module, exports) {

$parcel$export(module.exports, "StoreRegistry", function () { return $f9751bdf01f254fb$export$acb47f32da33501e; });
$parcel$export(module.exports, "defaultRegistry", function () { return $f9751bdf01f254fb$export$9d726ae4880b1060; });

var $knL8K = parcelRequire("knL8K");

var $b5nxz = parcelRequire("b5nxz");

var $amTpN = parcelRequire("amTpN");
const $f9751bdf01f254fb$export$e4d628ba0054221b = "__global__";
class $f9751bdf01f254fb$export$acb47f32da33501e {
    constructor(defaultScope){
        var _this = this;
        if (defaultScope === void 0) defaultScope = $f9751bdf01f254fb$export$e4d628ba0054221b;
        this.stores = new Map();
        this.initStore = (key, Store, config)=>{
            const { initialState: initialState, actions: actions } = Store;
            if (Store.containedBy && !config.contained(Store)) {
                const err = new Error(`Store ${Store.key} should be contained by a container but it is used globally. ` + `While it might still work, it will likely cause unexpected behaviours.`);
                if ((0, $knL8K.default).scheduling()) Promise.reject(err);
                else throw err;
            }
            const storeState = (0, $amTpN.default)(key, initialState);
            let boundActions;
            const store = {
                storeState: storeState,
                // these are used only when container-less, so we generate them on-demand
                get actions () {
                    if (!boundActions) boundActions = (0, $b5nxz.bindActions)(actions, storeState, config);
                    return boundActions;
                }
            };
            this.stores.set(key, store);
            return store;
        };
        this.hasStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.has(key);
        };
        this.getStore = function(Store, scopeId, config) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            if (config === void 0) config = {
                props: ()=>({}),
                contained: ()=>false
            };
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.get(key) || config && _this.initStore(key, Store, config);
        };
        this.deleteStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            _this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
const $f9751bdf01f254fb$export$9d726ae4880b1060 = new $f9751bdf01f254fb$export$acb47f32da33501e();

});
parcelRegister("knL8K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed6a85a5d0b76162$export$2e2bcd8739ae039; });
const $ed6a85a5d0b76162$var$supports = {
    scheduling () {
        return typeof window !== "undefined" && typeof MessageChannel === "function";
    }
};
var $ed6a85a5d0b76162$export$2e2bcd8739ae039 = $ed6a85a5d0b76162$var$supports;

});

parcelRegister("b5nxz", function(module, exports) {

$parcel$export(module.exports, "bindActions", function () { return $81226bfe8fdb29cc$export$5ee1d46cd0883a22; });

var $32b6k = parcelRequire("32b6k");
const $81226bfe8fdb29cc$var$namedMutator = (storeState, actionName)=>function() {
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arguments);
    };
const $81226bfe8fdb29cc$var$warnings = new WeakMap();
const $81226bfe8fdb29cc$export$5f944353e69b9bf3 = (storeState, actionFn, actionKey, config, actions)=>{
    const callThunk = (instance, thunkFn, actionName)=>thunkFn({
            setState: (0, $32b6k.default).devtools ? $81226bfe8fdb29cc$var$namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            get actions () {
                if (!$81226bfe8fdb29cc$var$warnings.has(actionFn)) $81226bfe8fdb29cc$var$warnings.set(actionFn, console.warn(`react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. ` + `Please check action '${actionName}' of Store '${instance.storeState.key}' and use 'dispatch' instead`));
                return actions;
            },
            dispatch: (tFn)=>callThunk(instance, tFn, `${actionName}.dispatch`)
        }, config.props());
    return function() {
        return callThunk({
            storeState: storeState,
            actions: actions
        }, actionFn(...arguments), actionKey);
    };
};
const $81226bfe8fdb29cc$export$5ee1d46cd0883a22 = function bindActions(actions, storeState, config, boundActions) {
    if (boundActions === void 0) boundActions = null;
    return Object.keys(actions).reduce((acc, k)=>{
        acc[k] = $81226bfe8fdb29cc$export$5f944353e69b9bf3(storeState, actions[k], k, config, boundActions || acc);
        return acc;
    }, {});
};

});
parcelRegister("32b6k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $235a2b70b09311b6$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
const $235a2b70b09311b6$var$defaultMutator = (prevState, partialState)=>{
    // Merge the partial state and the previous state.
    return Object.assign({}, prevState, partialState);
};
const $235a2b70b09311b6$var$defaults = {
    batchUpdates: "useSyncExternalStore" in (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))),
    devtools: false,
    middlewares: new Set(),
    mutator: $235a2b70b09311b6$var$defaultMutator
};
var $235a2b70b09311b6$export$2e2bcd8739ae039 = $235a2b70b09311b6$var$defaults;

});


parcelRegister("amTpN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78c6f1b8e3207aab$export$2e2bcd8739ae039; });

var $1fYRB = parcelRequire("1fYRB");

var $7An9N = parcelRequire("7An9N");

var $32b6k = parcelRequire("32b6k");

var $dBnk0 = parcelRequire("dBnk0");
function $78c6f1b8e3207aab$var$createStoreState(key, initialState) {
    let listeners = new Set();
    let currentState = initialState;
    const storeState = {
        key: key,
        getState () {
            return currentState;
        },
        setState (nextState) {
            currentState = nextState; // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, $dBnk0.default)(storeState.notify);
        },
        resetState () {
            storeState.setState(initialState);
        },
        notify () {
            for (const listener of listeners)listener(storeState.getState());
        },
        subscribe (listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners () {
            return listeners;
        }
    };
    storeState.mutator = (0, $1fYRB.default)(storeState, (0, $32b6k.default).middlewares);
    return storeState;
}
var $78c6f1b8e3207aab$export$2e2bcd8739ae039 = (0, $7An9N.default)($78c6f1b8e3207aab$var$createStoreState);

});
parcelRegister("1fYRB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ea667615f05c781$export$2e2bcd8739ae039; });

var $32b6k = parcelRequire("32b6k");

var $lRpT0 = parcelRequire("lRpT0");
const $0ea667615f05c781$var$applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, $lRpT0.default)).reduceRight((next, mw)=>mw(storeState)(next), (0, $32b6k.default).mutator);
var $0ea667615f05c781$export$2e2bcd8739ae039 = $0ea667615f05c781$var$applyMiddleware;

});
parcelRegister("lRpT0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fea2a0a62a3f3d78$export$2e2bcd8739ae039; });

var $jeDlX = parcelRequire("jeDlX");
const $fea2a0a62a3f3d78$var$updateMiddleware = (storeState)=>(next)=>(arg)=>{
            let output;
            const state = storeState.getState();
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, $jeDlX.default)(nextState, state)) storeState.setState(nextState);
            return output;
        };
var $fea2a0a62a3f3d78$export$2e2bcd8739ae039 = $fea2a0a62a3f3d78$var$updateMiddleware;

});
parcelRegister("jeDlX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e00dd9dc5df37bb5$export$2e2bcd8739ae039; });
// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
const $e00dd9dc5df37bb5$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $e00dd9dc5df37bb5$var$CACHE = new WeakMap();
function $e00dd9dc5df37bb5$export$2e2bcd8739ae039(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    } else {
        // Handle Date, RegExp, String, Number, ... and complex objects
        const strA = "" + objA;
        const strB = "" + objB;
        if (strA !== strB || strA[0] === "[" && strA !== "[object Object]") return false;
         // do object comparison
        let keysA;
        if ($e00dd9dc5df37bb5$var$CACHE.has(objA)) keysA = $e00dd9dc5df37bb5$var$CACHE.get(objA);
        else {
            keysA = Object.keys(objA);
            $e00dd9dc5df37bb5$var$CACHE.set(objA, keysA);
        }
        let keysB;
        if ($e00dd9dc5df37bb5$var$CACHE.has(objB)) keysB = $e00dd9dc5df37bb5$var$CACHE.get(objB);
        else {
            keysB = Object.keys(objB);
            $e00dd9dc5df37bb5$var$CACHE.set(objB, keysB);
        }
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(let i = 0; i < keysA.length; i++){
            if (!$e00dd9dc5df37bb5$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        }
        return true;
    }
}

});



parcelRegister("7An9N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $585ddbaf69d40087$export$2e2bcd8739ae039; });

var $32b6k = parcelRequire("32b6k");
const $585ddbaf69d40087$var$connectDevTools = (storeState, config)=>{
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(Object.assign({
        name: `Store ${storeState.key}`,
        serialize: true,
        trace: true
    }, config));
    devTools.init(storeState.getState());
    devTools.subscribe((message)=>{
        if (message.type === "DISPATCH") switch(message.payload.type){
            case "RESET":
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case "COMMIT":
                devTools.init(storeState.getState());
                return;
            case "ROLLBACK":
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case "JUMP_TO_STATE":
            case "JUMP_TO_ACTION":
                storeState.setState(JSON.parse(message.state));
                return;
        }
        else if (message.type === "ACTION") {
            let action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const $585ddbaf69d40087$var$withDevtools = (createStoreState)=>function() {
        const storeState = createStoreState(...arguments);
        if ((0, $32b6k.default).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            let devTools;
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, $32b6k.default).devtools === "function" ? (0, $32b6k.default).devtools(storeState) : {};
                        devTools = $585ddbaf69d40087$var$connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
var $585ddbaf69d40087$export$2e2bcd8739ae039 = $585ddbaf69d40087$var$withDevtools;

});

parcelRegister("dBnk0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e70d249bbd39012$export$2e2bcd8739ae039; });

var $32b6k = parcelRequire("32b6k");

var $kBjs0 = parcelRequire("kBjs0");

var $knL8K = parcelRequire("knL8K");
const $9e70d249bbd39012$var$QUEUE = [];
let $9e70d249bbd39012$var$scheduled;
function $9e70d249bbd39012$export$2e2bcd8739ae039(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, $32b6k.default).batchUpdates || !(0, $knL8K.default).scheduling()) return (0, $kBjs0.batch)(()=>fn()); // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!$9e70d249bbd39012$var$QUEUE.includes(fn)) $9e70d249bbd39012$var$QUEUE.push(fn); // if something already started schedule, skip
    if ($9e70d249bbd39012$var$scheduled) return;
    $9e70d249bbd39012$var$scheduled = (0, $kBjs0.batch)(()=>{
        let queueFn;
        while(queueFn = $9e70d249bbd39012$var$QUEUE.shift())queueFn();
        $9e70d249bbd39012$var$scheduled = null;
    });
}

});
parcelRegister("kBjs0", function(module, exports) {

$parcel$export(module.exports, "batch", function () { return $eff659d98b43d1ca$export$712ea50be43a7858; });
/* eslint-disable import/no-unresolved */ 
var $i5UxU = parcelRequire("i5UxU");

var $58T21 = parcelRequire("58T21");

var $32b6k = parcelRequire("32b6k");

var $knL8K = parcelRequire("knL8K");
let $eff659d98b43d1ca$var$isInsideBatchedSchedule = false;
function $eff659d98b43d1ca$export$712ea50be43a7858(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, $32b6k.default).batchUpdates || !(0, $knL8K.default).scheduling() || $eff659d98b43d1ca$var$isInsideBatchedSchedule) return (0, $i5UxU.unstable_batchedUpdates)(fn);
    $eff659d98b43d1ca$var$isInsideBatchedSchedule = true; // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, $58T21.unstable_scheduleCallback)((0, $58T21.unstable_ImmediatePriority), function scheduleBatchedUpdates() {
        (0, $i5UxU.unstable_batchedUpdates)(fn);
        $eff659d98b43d1ca$var$isInsideBatchedSchedule = false;
    });
}

});
parcelRegister("58T21", function(module, exports) {
"use strict";

module.exports = (parcelRequire("f7QOs"));

});
parcelRegister("f7QOs", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $b0307a01c97f3576$export$c4744153514ff05d; }, function (v) { return $b0307a01c97f3576$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $b0307a01c97f3576$export$3e506c1ccc9cc1a7; }, function (v) { return $b0307a01c97f3576$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $b0307a01c97f3576$export$e26fe2ed2fa76875; }, function (v) { return $b0307a01c97f3576$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $b0307a01c97f3576$export$502329bbf4b505b1; }, function (v) { return $b0307a01c97f3576$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $b0307a01c97f3576$export$6e3807111c4874c4; }, function (v) { return $b0307a01c97f3576$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $b0307a01c97f3576$export$c27134553091fb3a; }, function (v) { return $b0307a01c97f3576$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $b0307a01c97f3576$export$33ee1acdc04fd2a2; }, function (v) { return $b0307a01c97f3576$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $b0307a01c97f3576$export$b00a404bbd5edef2; }, function (v) { return $b0307a01c97f3576$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $b0307a01c97f3576$export$d66a1c1c77bd778b; }, function (v) { return $b0307a01c97f3576$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $b0307a01c97f3576$export$d3dfb8e4810cb555; }, function (v) { return $b0307a01c97f3576$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $b0307a01c97f3576$export$72fdf0e06517287b; }, function (v) { return $b0307a01c97f3576$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $b0307a01c97f3576$export$816d2913ae6b83b1; }, function (v) { return $b0307a01c97f3576$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $b0307a01c97f3576$export$61bcfe829111a1d0; }, function (v) { return $b0307a01c97f3576$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $b0307a01c97f3576$export$7ee8c9beb337bc3f; }, function (v) { return $b0307a01c97f3576$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $b0307a01c97f3576$export$b5836b71941fa3ed; }, function (v) { return $b0307a01c97f3576$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $b0307a01c97f3576$export$cf845f2c119da08a; }, function (v) { return $b0307a01c97f3576$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b0307a01c97f3576$export$c4744153514ff05d;
var $b0307a01c97f3576$export$3e506c1ccc9cc1a7;
var $b0307a01c97f3576$export$e26fe2ed2fa76875;
var $b0307a01c97f3576$export$502329bbf4b505b1;
var $b0307a01c97f3576$export$6e3807111c4874c4;
var $b0307a01c97f3576$export$c27134553091fb3a;
var $b0307a01c97f3576$export$33ee1acdc04fd2a2;
var $b0307a01c97f3576$export$b00a404bbd5edef2;
var $b0307a01c97f3576$export$d66a1c1c77bd778b;
var $b0307a01c97f3576$export$d3dfb8e4810cb555;
var $b0307a01c97f3576$export$72fdf0e06517287b;
var $b0307a01c97f3576$export$816d2913ae6b83b1;
var $b0307a01c97f3576$export$61bcfe829111a1d0;
var $b0307a01c97f3576$export$7ee8c9beb337bc3f;
var $b0307a01c97f3576$export$b5836b71941fa3ed;
var $b0307a01c97f3576$export$cf845f2c119da08a;
"use strict";
function $b0307a01c97f3576$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $b0307a01c97f3576$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $b0307a01c97f3576$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $b0307a01c97f3576$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $b0307a01c97f3576$var$compare(left, last)) rightIndex < length && 0 > $b0307a01c97f3576$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $b0307a01c97f3576$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $b0307a01c97f3576$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$b0307a01c97f3576$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $b0307a01c97f3576$var$localPerformance = performance;
    $b0307a01c97f3576$export$c4744153514ff05d = function() {
        return $b0307a01c97f3576$var$localPerformance.now();
    };
} else {
    var $b0307a01c97f3576$var$localDate = Date, $b0307a01c97f3576$var$initialTime = $b0307a01c97f3576$var$localDate.now();
    $b0307a01c97f3576$export$c4744153514ff05d = function() {
        return $b0307a01c97f3576$var$localDate.now() - $b0307a01c97f3576$var$initialTime;
    };
}
var $b0307a01c97f3576$var$taskQueue = [], $b0307a01c97f3576$var$timerQueue = [], $b0307a01c97f3576$var$taskIdCounter = 1, $b0307a01c97f3576$var$currentTask = null, $b0307a01c97f3576$var$currentPriorityLevel = 3, $b0307a01c97f3576$var$isPerformingWork = !1, $b0307a01c97f3576$var$isHostCallbackScheduled = !1, $b0307a01c97f3576$var$isHostTimeoutScheduled = !1, $b0307a01c97f3576$var$needsPaint = !1, $b0307a01c97f3576$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $b0307a01c97f3576$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $b0307a01c97f3576$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $b0307a01c97f3576$var$advanceTimers(currentTime) {
    for(var timer = $b0307a01c97f3576$var$peek($b0307a01c97f3576$var$timerQueue); null !== timer;){
        if (null === timer.callback) $b0307a01c97f3576$var$pop($b0307a01c97f3576$var$timerQueue);
        else if (timer.startTime <= currentTime) $b0307a01c97f3576$var$pop($b0307a01c97f3576$var$timerQueue), timer.sortIndex = timer.expirationTime, $b0307a01c97f3576$var$push($b0307a01c97f3576$var$taskQueue, timer);
        else break;
        timer = $b0307a01c97f3576$var$peek($b0307a01c97f3576$var$timerQueue);
    }
}
function $b0307a01c97f3576$var$handleTimeout(currentTime) {
    $b0307a01c97f3576$var$isHostTimeoutScheduled = !1;
    $b0307a01c97f3576$var$advanceTimers(currentTime);
    if (!$b0307a01c97f3576$var$isHostCallbackScheduled) {
        if (null !== $b0307a01c97f3576$var$peek($b0307a01c97f3576$var$taskQueue)) $b0307a01c97f3576$var$isHostCallbackScheduled = !0, $b0307a01c97f3576$var$isMessageLoopRunning || ($b0307a01c97f3576$var$isMessageLoopRunning = !0, $b0307a01c97f3576$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $b0307a01c97f3576$var$peek($b0307a01c97f3576$var$timerQueue);
            null !== firstTimer && $b0307a01c97f3576$var$requestHostTimeout($b0307a01c97f3576$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $b0307a01c97f3576$var$isMessageLoopRunning = !1, $b0307a01c97f3576$var$taskTimeoutID = -1, $b0307a01c97f3576$var$frameInterval = 5, $b0307a01c97f3576$var$startTime = -1;
function $b0307a01c97f3576$var$shouldYieldToHost() {
    return $b0307a01c97f3576$var$needsPaint ? !0 : $b0307a01c97f3576$export$c4744153514ff05d() - $b0307a01c97f3576$var$startTime < $b0307a01c97f3576$var$frameInterval ? !1 : !0;
}
function $b0307a01c97f3576$var$performWorkUntilDeadline() {
    $b0307a01c97f3576$var$needsPaint = !1;
    if ($b0307a01c97f3576$var$isMessageLoopRunning) {
        var currentTime = $b0307a01c97f3576$export$c4744153514ff05d();
        $b0307a01c97f3576$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $b0307a01c97f3576$var$isHostCallbackScheduled = !1;
                $b0307a01c97f3576$var$isHostTimeoutScheduled && ($b0307a01c97f3576$var$isHostTimeoutScheduled = !1, $b0307a01c97f3576$var$localClearTimeout($b0307a01c97f3576$var$taskTimeoutID), $b0307a01c97f3576$var$taskTimeoutID = -1);
                $b0307a01c97f3576$var$isPerformingWork = !0;
                var previousPriorityLevel = $b0307a01c97f3576$var$currentPriorityLevel;
                try {
                    b: {
                        $b0307a01c97f3576$var$advanceTimers(currentTime);
                        for($b0307a01c97f3576$var$currentTask = $b0307a01c97f3576$var$peek($b0307a01c97f3576$var$taskQueue); null !== $b0307a01c97f3576$var$currentTask && !($b0307a01c97f3576$var$currentTask.expirationTime > currentTime && $b0307a01c97f3576$var$shouldYieldToHost());){
                            var callback = $b0307a01c97f3576$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $b0307a01c97f3576$var$currentTask.callback = null;
                                $b0307a01c97f3576$var$currentPriorityLevel = $b0307a01c97f3576$var$currentTask.priorityLevel;
                                var continuationCallback = callback($b0307a01c97f3576$var$currentTask.expirationTime <= currentTime);
                                currentTime = $b0307a01c97f3576$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $b0307a01c97f3576$var$currentTask.callback = continuationCallback;
                                    $b0307a01c97f3576$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $b0307a01c97f3576$var$currentTask === $b0307a01c97f3576$var$peek($b0307a01c97f3576$var$taskQueue) && $b0307a01c97f3576$var$pop($b0307a01c97f3576$var$taskQueue);
                                $b0307a01c97f3576$var$advanceTimers(currentTime);
                            } else $b0307a01c97f3576$var$pop($b0307a01c97f3576$var$taskQueue);
                            $b0307a01c97f3576$var$currentTask = $b0307a01c97f3576$var$peek($b0307a01c97f3576$var$taskQueue);
                        }
                        if (null !== $b0307a01c97f3576$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $b0307a01c97f3576$var$peek($b0307a01c97f3576$var$timerQueue);
                            null !== firstTimer && $b0307a01c97f3576$var$requestHostTimeout($b0307a01c97f3576$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $b0307a01c97f3576$var$currentTask = null, $b0307a01c97f3576$var$currentPriorityLevel = previousPriorityLevel, $b0307a01c97f3576$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $b0307a01c97f3576$var$schedulePerformWorkUntilDeadline() : $b0307a01c97f3576$var$isMessageLoopRunning = !1;
        }
    }
}
var $b0307a01c97f3576$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $b0307a01c97f3576$var$localSetImmediate) $b0307a01c97f3576$var$schedulePerformWorkUntilDeadline = function() {
    $b0307a01c97f3576$var$localSetImmediate($b0307a01c97f3576$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $b0307a01c97f3576$var$channel = new MessageChannel(), $b0307a01c97f3576$var$port = $b0307a01c97f3576$var$channel.port2;
    $b0307a01c97f3576$var$channel.port1.onmessage = $b0307a01c97f3576$var$performWorkUntilDeadline;
    $b0307a01c97f3576$var$schedulePerformWorkUntilDeadline = function() {
        $b0307a01c97f3576$var$port.postMessage(null);
    };
} else $b0307a01c97f3576$var$schedulePerformWorkUntilDeadline = function() {
    $b0307a01c97f3576$var$localSetTimeout($b0307a01c97f3576$var$performWorkUntilDeadline, 0);
};
function $b0307a01c97f3576$var$requestHostTimeout(callback, ms) {
    $b0307a01c97f3576$var$taskTimeoutID = $b0307a01c97f3576$var$localSetTimeout(function() {
        callback($b0307a01c97f3576$export$c4744153514ff05d());
    }, ms);
}
$b0307a01c97f3576$export$3e506c1ccc9cc1a7 = 5;
$b0307a01c97f3576$export$e26fe2ed2fa76875 = 1;
$b0307a01c97f3576$export$502329bbf4b505b1 = 4;
$b0307a01c97f3576$export$6e3807111c4874c4 = 3;
$b0307a01c97f3576$export$c27134553091fb3a = null;
$b0307a01c97f3576$export$33ee1acdc04fd2a2 = 2;
$b0307a01c97f3576$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$b0307a01c97f3576$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $b0307a01c97f3576$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$b0307a01c97f3576$export$d3dfb8e4810cb555 = function() {
    return $b0307a01c97f3576$var$currentPriorityLevel;
};
$b0307a01c97f3576$export$72fdf0e06517287b = function(eventHandler) {
    switch($b0307a01c97f3576$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $b0307a01c97f3576$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $b0307a01c97f3576$var$currentPriorityLevel;
    $b0307a01c97f3576$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $b0307a01c97f3576$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$b0307a01c97f3576$export$816d2913ae6b83b1 = function() {
    $b0307a01c97f3576$var$needsPaint = !0;
};
$b0307a01c97f3576$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $b0307a01c97f3576$var$currentPriorityLevel;
    $b0307a01c97f3576$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $b0307a01c97f3576$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$b0307a01c97f3576$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $b0307a01c97f3576$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $b0307a01c97f3576$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $b0307a01c97f3576$var$push($b0307a01c97f3576$var$timerQueue, priorityLevel), null === $b0307a01c97f3576$var$peek($b0307a01c97f3576$var$taskQueue) && priorityLevel === $b0307a01c97f3576$var$peek($b0307a01c97f3576$var$timerQueue) && ($b0307a01c97f3576$var$isHostTimeoutScheduled ? ($b0307a01c97f3576$var$localClearTimeout($b0307a01c97f3576$var$taskTimeoutID), $b0307a01c97f3576$var$taskTimeoutID = -1) : $b0307a01c97f3576$var$isHostTimeoutScheduled = !0, $b0307a01c97f3576$var$requestHostTimeout($b0307a01c97f3576$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $b0307a01c97f3576$var$push($b0307a01c97f3576$var$taskQueue, priorityLevel), $b0307a01c97f3576$var$isHostCallbackScheduled || $b0307a01c97f3576$var$isPerformingWork || ($b0307a01c97f3576$var$isHostCallbackScheduled = !0, $b0307a01c97f3576$var$isMessageLoopRunning || ($b0307a01c97f3576$var$isMessageLoopRunning = !0, $b0307a01c97f3576$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$b0307a01c97f3576$export$b5836b71941fa3ed = $b0307a01c97f3576$var$shouldYieldToHost;
$b0307a01c97f3576$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $b0307a01c97f3576$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $b0307a01c97f3576$var$currentPriorityLevel;
        $b0307a01c97f3576$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $b0307a01c97f3576$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});







parcelRegister("lJiBM", function(module, exports) {

$parcel$export(module.exports, "getSelectorInstance", function () { return $fd1c3c32a6295823$export$38d24f3c60944dd5; });

var $bShO0 = parcelRequire("bShO0");
function $fd1c3c32a6295823$export$595d22ed68ca2841() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, $bShO0.default)(function() {
        return resultFunc.apply(null, arguments);
    }); // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, $bShO0.default)(function() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)params.push(dependencies[i].apply(null, arguments));
         // then call the final func with all them as arguments
        return memoizedResultFunc.apply(null, params);
    }, true); // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}
function $fd1c3c32a6295823$export$d2c200d79fc82f8c(selector) {
    const isReselector = typeof selector.resultFunc === "function" && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return $fd1c3c32a6295823$export$595d22ed68ca2841(dependencies, resultFunc);
}
const $fd1c3c32a6295823$var$cache = new WeakMap();
function $fd1c3c32a6295823$export$38d24f3c60944dd5(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!$fd1c3c32a6295823$var$cache.has(storeState)) $fd1c3c32a6295823$var$cache.set(storeState, new WeakMap());
        const scopeSelectors = $fd1c3c32a6295823$var$cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, $fd1c3c32a6295823$export$d2c200d79fc82f8c(selector));
        return scopeSelectors.get(selector);
    }
    return $fd1c3c32a6295823$export$d2c200d79fc82f8c(selector);
}

});
parcelRegister("bShO0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a528caf8f93cc44$export$2e2bcd8739ae039; });

var $jeDlX = parcelRequire("jeDlX");
function $8a528caf8f93cc44$var$exactEqual(objA, objB) {
    return objA === objB;
}
function $8a528caf8f93cc44$var$areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false; // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, $jeDlX.default)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!$8a528caf8f93cc44$var$exactEqual(prev[i], next[i])) return false;
    }
    return true;
}
function $8a528caf8f93cc44$export$2e2bcd8739ae039(resultFn, propsMode) {
    if (propsMode === void 0) propsMode = false;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    const result = function result() {
        if (calledOnce && $8a528caf8f93cc44$var$areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
        const nextResult = resultFn.apply(this, arguments);
        if (!propsMode && (0, $jeDlX.default)(nextResult, lastResult)) return lastResult;
        lastResult = nextResult;
        calledOnce = true;
        lastArgs = arguments;
        return lastResult;
    };
    return result;
}

});



parcelRegister("ij7wO", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $d53fd7446c9610ca$export$f51a9068ac82ea43; });

var $bBz8v = parcelRequire("bBz8v");
function $d53fd7446c9610ca$var$createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), "") : "";
    return [
        name,
        (0, $bBz8v.default)(src + JSON.stringify(initialState))
    ].filter(Boolean).join("__");
}
function $d53fd7446c9610ca$export$f51a9068ac82ea43(_ref) {
    let { name: name = "", initialState: initialState, actions: actions, containedBy: containedBy, handlers: handlers = {} } = _ref;
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            return key || (key = $d53fd7446c9610ca$var$createKey(initialState, actions, name));
        },
        initialState: initialState,
        actions: actions,
        containedBy: containedBy,
        handlers: handlers
    };
}

});
parcelRegister("bBz8v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $872e67bf853e2a66$export$2e2bcd8739ae039; });
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $872e67bf853e2a66$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});


parcelRegister("fjR4V", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $a7d8509912833bae$export$defe85febe8b728c; });
const $a7d8509912833bae$export$defe85febe8b728c = {
    toDo: "To Do",
    inProgress: "In Progress",
    done: "Done",
    todoStaticLabel: "Design AI shopping suggestions for homepage",
    inProgStaticLabel1: "Create AI-generated shopping suggestions for homepage",
    inProgStaticLabel2: "Add advanced analytics tracking events",
    doneStaticLabel1: "Improve payment checkout time on mobile",
    doneStaticLabel2: "Define requirements to use new AI integrations",
    animatedCardHeading: "Design new billing API",
    createIssueModalIssueTypeAssetLabel1: "Issue type: Task",
    createIssueModalIssueTypeAssetLabel2: "Issue type: Story",
    createIssueModalIssueTypeAssetLabel3: "Issue type: Bug",
    createIssueModalPriorityAssetLabel1: "Priority: High",
    createIssueModalPriorityAssetLabel2: "Priority: Critical",
    createIssueModalPriorityAssetLabel3: "Priority: Blocker",
    createIssueModalPriorityAssetLabel4: "Priority: Minor",
    createIssueModalAssigneeAssetLabel1: "Assignee: Alvin",
    createIssueModalAssigneeAssetLabel2: "Assignee: Jane",
    createIssueModalAssigneeAssetLabel3: "Assignee: Blake",
    epicNameFeatures: "features",
    epicNameAnalytics: "analytics",
    epicNamePayments: "payments",
    epicNameAssets: "assets",
    epicNameStrategy: "strategy",
    epicNameBudget: "budget",
    epicNameQ1Campaign: "q1 campaign",
    priorityHigh: "high",
    priorityCritical: "critical",
    priorityMinor: "minor",
    priorityBlocker: "blocker",
    issueTypeBug: "bug",
    issueTypeStory: "story",
    issueTypeTask: "task"
};

});



parcelRegister("8XM36", function(module, exports) {

$parcel$export(module.exports, "JswAnimatedBoard", function () { return $47755984e888f8d9$export$d89965761ac203a5; });
/* jsw-animated-board.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $85mql = parcelRequire("85mql");

var $4MTGk = parcelRequire("4MTGk");

var $5ohHq = parcelRequire("5ohHq");

var $75gRE = parcelRequire("75gRE");

var $ij1vr = parcelRequire("ij1vr");
const $47755984e888f8d9$var$rootContainerStyle = null;
const $47755984e888f8d9$var$growBoard = null;
const $47755984e888f8d9$var$shrinkBoard = null;
const $47755984e888f8d9$var$fadeOut = null;
const $47755984e888f8d9$var$fadeIn = null;
const $47755984e888f8d9$var$animationBoardStyles = null;
const $47755984e888f8d9$export$d89965761ac203a5 = (props)=>{
    const [{ messages: messages }, { setInProgressCol: setInProgressCol, setDoneCol: setDoneCol }] = (0, $4MTGk.useAnimatedJiraBoardStore)();
    (0, $iSvIT.useState)(()=>{
        var _props_inProgressCardsOverride;
        setInProgressCol((_props_inProgressCardsOverride = props.inProgressCardsOverride) !== null && _props_inProgressCardsOverride !== void 0 ? _props_inProgressCardsOverride : [
            {
                id: "inProg1",
                summary: messages.inProgStaticLabel1,
                issueType: (0, $85mql.IssueTypeName).STORY,
                epicName: (0, $85mql.EpicName).FEATURES,
                assignee: (0, $85mql.Assignee).JANE,
                priority: (0, $85mql.Priority).BLOCKER
            },
            {
                id: "inProg2",
                summary: messages.inProgStaticLabel2,
                issueType: (0, $85mql.IssueTypeName).STORY,
                epicName: (0, $85mql.EpicName).ANALYTICS,
                assignee: (0, $85mql.Assignee).BLAKE,
                priority: (0, $85mql.Priority).HIGH
            }
        ]);
        var _props_doneCardsOverride;
        setDoneCol((_props_doneCardsOverride = props.doneCardsOverride) !== null && _props_doneCardsOverride !== void 0 ? _props_doneCardsOverride : [
            {
                id: "done1",
                summary: messages.doneStaticLabel1,
                issueType: (0, $85mql.IssueTypeName).BUG,
                epicName: (0, $85mql.EpicName).PAYMENTS,
                assignee: (0, $85mql.Assignee).ALVIN,
                priority: (0, $85mql.Priority).MINOR
            },
            {
                id: "done2",
                summary: messages.doneStaticLabel2,
                issueType: (0, $85mql.IssueTypeName).TASK,
                epicName: (0, $85mql.EpicName).FEATURES,
                assignee: (0, $85mql.Assignee).JANE,
                priority: (0, $85mql.Priority).CRITICAL
            }
        ]);
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_c71l1deq _p12f1c3h _1bsb1osq _bfhkcd5j _2rko19bv _ca0qftgi _u5f3ftgi _n3tdftgi _19bvftgi _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _zulp7vkz _16qs162a _1y8o1ogm",
            "_y44vmxuu"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $ij1vr.BoardHeader), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $75gRE.BoardBody), {})
        ]
    });
};
var $47755984e888f8d9$export$2e2bcd8739ae039 = $47755984e888f8d9$export$d89965761ac203a5;

});
parcelRegister("75gRE", function(module, exports) {

$parcel$export(module.exports, "BoardBody", function () { return $92fb490a37279e2f$export$655dea6f92c41d9; });
/* board-body.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6tXZU = parcelRequire("6tXZU");

var $85mql = parcelRequire("85mql");

var $4MTGk = parcelRequire("4MTGk");
const $92fb490a37279e2f$var$boardBodyStyle = null;
const $92fb490a37279e2f$var$columnContainerStyle = null;
const $92fb490a37279e2f$export$655dea6f92c41d9 = ()=>{
    const [{ messages: messages, todoCol: todoCol, inProgressCol: inProgressCol, doneCol: doneCol, animationStep: animationStep }, { transitionToInProgress: transitionToInProgress, transitionToDone: transitionToDone }] = (0, $4MTGk.useAnimatedJiraBoardStore)();
    (0, $iSvIT.useEffect)(()=>{
        switch(animationStep){
            case (0, $85mql.AnimationSteps).IN_PROG_COL:
                transitionToInProgress();
                break;
            case (0, $85mql.AnimationSteps).DONE_COL:
                transitionToDone();
                break;
        }
    }, [
        animationStep
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_2rkoftgi _18m915vq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _zulp1crf"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $6tXZU.Column), {
                    title: messages.toDo,
                    cards: todoCol
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $6tXZU.Column), {
                    title: messages.inProgress,
                    cards: inProgressCol
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $6tXZU.Column), {
                    title: messages.done,
                    cards: doneCol
                })
            ]
        })
    });
};

});
parcelRegister("6tXZU", function(module, exports) {

$parcel$export(module.exports, "Column", function () { return $261e8b2195555046$export$816b5d811295e6bc; });
/* column.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $cEOcu = parcelRequire("cEOcu");
parcelRequire("krGYQ");
var $LEeB6 = parcelRequire("LEeB6");
const $261e8b2195555046$var$columnStyle = null;
const $261e8b2195555046$var$columnTitleStyle = null;
const $261e8b2195555046$var$listStyle = null;
const $261e8b2195555046$export$816b5d811295e6bc = ({ title: title, cards: cards })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_bfhkcnsw _2rkoftgi _16jlkb7n _1o9zkb7n _i0dlf1ug _bozg14y2 _y4ti14y2 _1tkeitct"
        ]),
        style: {
            "--_1li0dij": (0, $43MIc.default)((0, $LEeB6.colors).elevationSurfaceSunken)
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                className: (0, $esG4f.default)([
                    "_bfhkcnsw _syaz1h2j _1e0c1ule _1wyb1crf _k48pni7l _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1p1dangw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _vwz411ph"
                ]),
                style: {
                    "--_1li0dij": (0, $43MIc.default)((0, $LEeB6.colors).elevationSurfaceSunken),
                    "--_3qpi7d": (0, $43MIc.default)((0, $LEeB6.colors).textSubtle)
                },
                children: title
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                role: "list",
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21sxn"
                ]),
                children: cards.map((card, i)=>{
                    return card.id && /*#__PURE__*/ (0, $loA2J.jsx)((0, $cEOcu.Card), {
                        role: "listitem",
                        priority: card.priority,
                        epicName: card.epicName,
                        assignee: card.assignee,
                        issueType: card.issueType,
                        summary: card.summary,
                        id: card.id
                    }, i);
                })
            })
        ]
    });
};

});
parcelRegister("cEOcu", function(module, exports) {

$parcel$export(module.exports, "Card", function () { return $1e4bd18a89a08b02$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");

var $85mql = parcelRequire("85mql");
parcelRequire("krGYQ");
var $78oyp = parcelRequire("78oyp");
var $LEeB6 = parcelRequire("LEeB6");

var $4MTGk = parcelRequire("4MTGk");
const $1e4bd18a89a08b02$export$60332b2344f7fe41 = ({ summary: summary, epicName: epicName, issueType: issueType, priority: priority, assignee: assignee, id: id, role: role })=>{
    const [isAnimatedCardId, setIsAnimatedCardId] = (0, $iSvIT.useState)(false);
    const [messages] = (0, $4MTGk.useMessages)();
    const [, { nextAnimationStep: nextAnimationStep }] = (0, $4MTGk.useAnimatedJiraBoardStore)();
    const epicLinkElement = (0, $78oyp.getAssetForEpicLink)(epicName, messages);
    const issueTypeElement = (0, $78oyp.getAssetOptionsForIssueType)(issueType, messages, true);
    (0, $iSvIT.useEffect)(()=>{
        if (id === (0, $85mql.ANIMATED_CARD_ID)) {
            setIsAnimatedCardId(true);
            setTimeout(()=>{
                nextAnimationStep();
            }, 4250);
        }
    }, [
        id,
        nextAnimationStep
    ]);
    const priorityElement = (0, $78oyp.getAssetOptionsForPriority)(priority, messages, true);
    const assigneeElement = (0, $78oyp.getAssetOptionsForAssignee)(assignee, messages, true);
    const cardStyles = null;
    const labelContainer = null;
    const epicLinkRow = null;
    const issueTypeContainer = null;
    const typePriorityAssigneeRow = null;
    const priorityAssigneeContainer = null;
    const animateCardonRender = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "aria-describedby": id,
        role: role,
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _1bah1yb4 _syaz10fz _19pk14y2 _2hwxidpf _otyr14y2 _18u0idpf _ca0q1crf _u5f31crf _n3td1crf _19bv1crf _2rko1y44 _11q7cd5j _16qs1drn _zulpftgi",
            isAnimatedCardId && "_c71lidpf _1reo15vq _18m915vq _o5721q9c _y44v4ib8 _ca0qidpf _u5f31crf _n3tdidpf _19bv1crf _16qs1trb"
        ]),
        style: {
            "--_1vqiml3": (0, $43MIc.default)((0, $LEeB6.colors).text),
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1cyyhae": (0, $43MIc.default)((0, $LEeB6.colors).textSelected)
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                id: id,
                className: (0, $esG4f.default)([
                    "_1wybdlk8 _zg8l4jg8 _k48p1nn1 _vwz4iio8 _1bsb1vuk"
                ]),
                children: summary
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx2vrvc"
                ]),
                children: epicLinkElement
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx2vrvc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _2lx2vrvc _4cvr1h6o _zulp14y2"
                        ]),
                        children: issueTypeElement
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _2lx2vrvc _zulpftgi _ahbq1wug"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                children: priorityElement
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                children: assigneeElement
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});



parcelRegister("ij1vr", function(module, exports) {

$parcel$export(module.exports, "BoardHeader", function () { return $efad6805288f285f$export$67b80e16fd3c69b6; });
/* board-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $FFB2A = parcelRequire("FFB2A");
var $cvaTj = parcelRequire("cvaTj");
var $3BXVF = parcelRequire("3BXVF");
var $8jNT4 = parcelRequire("8jNT4");
var $eLIbZ = parcelRequire("eLIbZ");
var $7IMRw = parcelRequire("7IMRw");
var $60YlP = parcelRequire("60YlP");
var $7sRIl = parcelRequire("7sRIl");

var $objBZ = parcelRequire("objBZ");

var $8zMNO = parcelRequire("8zMNO");
var $bLpA6 = parcelRequire("bLpA6");
const $efad6805288f285f$var$AtlassianProductHome = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $eLIbZ.default), {
        icon: (0, $8zMNO.JiraIcon),
        logo: (0, $bLpA6.JiraLogo)
    });
const $efad6805288f285f$var$greyLine = null;
const $efad6805288f285f$var$lineContainer = null;
const $efad6805288f285f$var$lineContainerWithBlueBackground = null;
const $efad6805288f285f$var$blueBackground = null;
const $efad6805288f285f$var$overlay = null;
const $efad6805288f285f$var$fakeProfile = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $7IMRw.Profile), {
        icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $objBZ.default), {
            size: "small"
        }),
        onClick: ()=>null,
        tooltip: "Your profile and settings"
    });
const $efad6805288f285f$var$fakeSearch = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $60YlP.Search), {
        onClick: ()=>null,
        placeholder: "Search...",
        tooltip: "Search",
        label: "Search",
        value: ""
    });
};
const $efad6805288f285f$var$fakeSettings = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $7sRIl.Settings), {
        tooltip: "Product settings"
    });
const $efad6805288f285f$var$fakeNotifications = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $8jNT4.Notifications), {
        badge: ()=>null,
        tooltip: "Notifications"
    });
const $efad6805288f285f$var$fakeAppSwitcher = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $FFB2A.AppSwitcher), {
        tooltip: "Switch between apps"
    });
const $efad6805288f285f$var$fakeHelp = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $3BXVF.Help), {
        tooltip: "Get help"
    });
const $efad6805288f285f$export$67b80e16fd3c69b6 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cvaTj.AtlassianNavigation), {
            label: "site",
            renderProductHome: $efad6805288f285f$var$AtlassianProductHome,
            primaryItems: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_4t3i1y44 _2rkomt0u _11q7b7m8 _1bsb8ved _12l2ftgi _ahbqftgi"
                        ])
                    })
                }, "fake1"),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_4t3i1y44 _2rkomt0u _11q7b7m8 _1bsb8ved _12l2ftgi _ahbqftgi"
                        ])
                    })
                }, "fake2"),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_4t3i1y44 _2rkomt0u _11q7b7m8 _1bsb8ved _12l2ftgi _ahbqftgi"
                        ])
                    })
                }, "fake3"),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1h6o",
                        "_ca0q19bv _u5f319bv _n3td19bv _19bv19bv"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_2rkomt0u _11q73wju _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_4t3i1y44 _2rkomt0u _11q7b7m8 _1bsb8ved _12l2ftgi _ahbqftgi"
                            ])
                        })
                    })
                }, "fake4")
            ],
            renderSearch: $efad6805288f285f$var$fakeSearch,
            renderProfile: $efad6805288f285f$var$fakeProfile,
            renderSettings: $efad6805288f285f$var$fakeSettings,
            renderNotifications: $efad6805288f285f$var$fakeNotifications,
            renderAppSwitcher: $efad6805288f285f$var$fakeAppSwitcher,
            renderHelp: $efad6805288f285f$var$fakeHelp
        })
    });
};

});
parcelRegister("FFB2A", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", function () { return $07d418a26c73ef13$export$9923361bd43fa030; });

var $djxp7 = parcelRequire("djxp7");

var $gmKOS = parcelRequire("gmKOS");

var $iSvIT = parcelRequire("iSvIT");

var $9UTJR = parcelRequire("9UTJR");

var $2okzL = parcelRequire("2okzL");
var $07d418a26c73ef13$var$_excluded = [
    "tooltip"
];
var $07d418a26c73ef13$export$9923361bd43fa030 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var tooltip = props.tooltip, iconButtonProps = (0, $gmKOS.default)(props, $07d418a26c73ef13$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2okzL.IconButton), (0, $djxp7.default)({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9UTJR))), {
            label: typeof tooltip === "string" ? tooltip : "Appswitcher Icon"
        }),
        tooltip: tooltip,
        ref: ref
    }, iconButtonProps));
});
var // exists only to extract props
// eslint-disable-next-line @repo/internal/react/use-noop
$07d418a26c73ef13$export$2e2bcd8739ae039 = function(props) {};

});
parcelRegister("9UTJR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7384948d85569f8d$var$_react = $7384948d85569f8d$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $fWDTK = parcelRequire("fWDTK");
function $7384948d85569f8d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7384948d85569f8d$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $7384948d85569f8d$var$_react.default.createElement($fWDTK.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M4 5.01C4 4.451 4.443 4 5.01 4h1.98C7.549 4 8 4.443 8 5.01v1.98C8 7.549 7.557 8 6.99 8H5.01C4.451 8 4 7.557 4 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 13.549 7.557 14 6.99 14H5.01C4.451 14 4 13.557 4 12.99v-1.98zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C14 7.549 13.557 8 12.99 8h-1.98C10.451 8 10 7.557 10 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C20 7.549 19.557 8 18.99 8h-1.98C16.451 8 16 7.557 16 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 19.549 7.557 20 6.99 20H5.01C4.451 20 4 19.557 4 18.99v-1.98zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98z"/></svg>`
    }, props));
$7384948d85569f8d$var$AppSwitcherIcon.displayName = "AppSwitcherIcon";
var $7384948d85569f8d$var$_default = $7384948d85569f8d$var$AppSwitcherIcon;
module.exports.default = $7384948d85569f8d$var$_default;

});


parcelRegister("3BXVF", function(module, exports) {

$parcel$export(module.exports, "Help", function () { return $2a13507b11193b1d$export$1be7516c0280bee8; });

var $djxp7 = parcelRequire("djxp7");

var $gmKOS = parcelRequire("gmKOS");

var $iSvIT = parcelRequire("iSvIT");

var $6mQDG = parcelRequire("6mQDG");

var $72HvB = parcelRequire("72HvB");

var $8HxaM = parcelRequire("8HxaM");

var $2okzL = parcelRequire("2okzL");
var $2a13507b11193b1d$var$_excluded = [
    "badge",
    "tooltip"
];
var $2a13507b11193b1d$var$HELP_NOTIFICATION_BADGE_ID = "atlassian-navigation-help-notification-count";
var $2a13507b11193b1d$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var badge = props.badge, tooltip = props.tooltip, iconButtonProps = (0, $gmKOS.default)(props, $2a13507b11193b1d$var$_excluded);
    var _useTheme = (0, $72HvB.useTheme)(), navigation = _useTheme.mode.navigation;
    var button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2okzL.IconButton), (0, $djxp7.default)({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6mQDG))), {
            label: typeof tooltip === "string" ? tooltip : "Help Icon",
            secondaryColor: navigation.backgroundColor
        }),
        ref: ref,
        tooltip: tooltip
    }, iconButtonProps));
    return badge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $8HxaM.BadgeContainer), {
        id: $2a13507b11193b1d$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        role: "listitem"
    }, button) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        role: "listitem"
    }, button);
});
var $2a13507b11193b1d$export$2e2bcd8739ae039 = $2a13507b11193b1d$export$1be7516c0280bee8;

});
parcelRegister("6mQDG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a2da127aa66cbb3$var$_react = $4a2da127aa66cbb3$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $fWDTK = parcelRequire("fWDTK");
function $4a2da127aa66cbb3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4a2da127aa66cbb3$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $4a2da127aa66cbb3$var$_react.default.createElement($fWDTK.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><circle fill="inherit" cx="12" cy="18" r="1"/><path d="M15.89 9.05a3.975 3.975 0 00-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.992.992 0 00.982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 014.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 00-1 .987v2.014a1.001 1.001 0 002.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0015.89 9.05" fill="inherit"/></g></svg>`
    }, props));
$4a2da127aa66cbb3$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $4a2da127aa66cbb3$var$_default = $4a2da127aa66cbb3$var$QuestionCircleIcon;
module.exports.default = $4a2da127aa66cbb3$var$_default;

});

parcelRegister("8HxaM", function(module, exports) {

$parcel$export(module.exports, "BadgeContainer", function () { return $655c12581db550f9$export$f710265eb5a003da; });
/** @jsx jsx */ 
var $2ZUkg = parcelRequire("2ZUkg");
var $655c12581db550f9$var$badgeContainerStyles = (0, $2ZUkg.css)({
    position: "absolute",
    insetBlockStart: "var(--ds-space-negative-050, -4px)",
    insetInlineEnd: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none"
});
var $655c12581db550f9$var$containerStyles = (0, $2ZUkg.css)({
    position: "relative"
});
var $655c12581db550f9$export$f710265eb5a003da = function BadgeContainer(props) {
    var badgeId = props.id, Badge = props.badge, children = props.children, role = props.role;
    return (0, $2ZUkg.jsx)("div", {
        css: $655c12581db550f9$var$containerStyles,
        role: role
    }, children, (0, $2ZUkg.jsx)("div", {
        css: $655c12581db550f9$var$badgeContainerStyles,
        id: badgeId,
        "aria-hidden": true
    }, (0, $2ZUkg.jsx)(Badge, null)));
};

});


parcelRegister("8jNT4", function(module, exports) {

$parcel$export(module.exports, "Notifications", function () { return $60e6cb9ef3722a68$export$36ba2f559d49a8f6; });

var $djxp7 = parcelRequire("djxp7");

var $gmKOS = parcelRequire("gmKOS");

var $iSvIT = parcelRequire("iSvIT");

var $elPvH = parcelRequire("elPvH");

var $8HxaM = parcelRequire("8HxaM");

var $2okzL = parcelRequire("2okzL");
var $60e6cb9ef3722a68$var$_excluded = [
    "badge",
    "tooltip"
];
var $60e6cb9ef3722a68$var$NOTIFICATIONS_BADGE_ID = "atlassian-navigation-notification-count";
var $60e6cb9ef3722a68$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var badge = props.badge, tooltip = props.tooltip, iconButtonProps = (0, $gmKOS.default)(props, $60e6cb9ef3722a68$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $8HxaM.BadgeContainer), {
        id: $60e6cb9ef3722a68$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2okzL.IconButton), (0, $djxp7.default)({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($elPvH))), {
            label: typeof tooltip === "string" ? tooltip : "Notification Icon"
        }),
        tooltip: tooltip,
        ref: ref,
        "aria-describedby": $60e6cb9ef3722a68$var$NOTIFICATIONS_BADGE_ID
    }, iconButtonProps)));
});
var $60e6cb9ef3722a68$export$2e2bcd8739ae039 = $60e6cb9ef3722a68$export$36ba2f559d49a8f6;

});
parcelRegister("elPvH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a72afbbec612fc81$var$_react = $a72afbbec612fc81$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $fWDTK = parcelRequire("fWDTK");
function $a72afbbec612fc81$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a72afbbec612fc81$var$NotificationIcon = (props)=>/*#__PURE__*/ $a72afbbec612fc81$var$_react.default.createElement($fWDTK.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6.485 17.669a2 2 0 002.829 0l-2.829-2.83a2 2 0 000 2.83zm4.897-12.191l-.725.725c-.782.782-2.21 1.813-3.206 2.311l-3.017 1.509c-.495.248-.584.774-.187 1.171l8.556 8.556c.398.396.922.313 1.171-.188l1.51-3.016c.494-.988 1.526-2.42 2.311-3.206l.725-.726a5.048 5.048 0 00.64-6.356 1.01 1.01 0 10-1.354-1.494c-.023.025-.046.049-.066.075a5.043 5.043 0 00-2.788-.84 5.036 5.036 0 00-3.57 1.478z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$a72afbbec612fc81$var$NotificationIcon.displayName = "NotificationIcon";
var $a72afbbec612fc81$var$_default = $a72afbbec612fc81$var$NotificationIcon;
module.exports.default = $a72afbbec612fc81$var$_default;

});


parcelRegister("60YlP", function(module, exports) {

$parcel$export(module.exports, "Search", function () { return $46118ea46a2e1af5$export$4b85d3515bd863a5; });

var $djxp7 = parcelRequire("djxp7");

var $gmKOS = parcelRequire("gmKOS");

var $lrtwL = parcelRequire("lrtwL");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $g1gzF = parcelRequire("g1gzF");

var $9sI6P = parcelRequire("9sI6P");

var $72HvB = parcelRequire("72HvB");

var $2okzL = parcelRequire("2okzL");
var $46118ea46a2e1af5$var$_excluded = [
    "placeholder",
    "tooltip",
    "label",
    "value"
];
var $46118ea46a2e1af5$var$searchInputContainerStyles = (0, $2ZUkg.css)((0, $lrtwL.default)({
    position: "relative",
    marginInlineEnd: "var(--ds-space-100, 8px)",
    marginInlineStart: "var(--ds-space-250, 20px)"
}, "@media (max-width: ".concat((0, $9sI6P.CREATE_BREAKPOINT) - 1, "px)"), {
    display: "none !important"
}));
var $46118ea46a2e1af5$var$searchInputIconStyles = (0, $2ZUkg.css)({
    width: "20px",
    height: "20px",
    position: "absolute",
    insetBlockStart: "5px",
    insetInlineStart: "10px",
    pointerEvents: "none"
});
var $46118ea46a2e1af5$var$newSearchBorderStyles = (0, $2ZUkg.css)({
    border: "var(--ds-border-width, 1px)".concat(" solid"),
    "&:focus": {
        boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " var(", (0, $9sI6P.varSearchFocusBorderColor), ")")
    }
});
var $46118ea46a2e1af5$var$searchInputStyles = (0, $2ZUkg.css)({
    boxSizing: "border-box",
    width: "220px",
    height: "var(--ds-space-400, 32px)",
    padding: "0 ".concat("var(--ds-space-100, 8px)", " 0 ", "var(--ds-space-500, 40px)"),
    backgroundColor: "var(".concat((0, $9sI6P.varSearchBackgroundColor), ")"),
    border: "2px solid",
    borderColor: "var(".concat((0, $9sI6P.varSearchBorderColor), ")"),
    borderRadius: "var(--ds-border-radius-200, 6px)",
    color: "var(".concat((0, $9sI6P.varSearchColor), ")"),
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    outline: "none",
    "::placeholder": {
        color: "inherit"
    },
    "&:focus": {
        borderColor: "var(".concat((0, $9sI6P.varSearchFocusBorderColor), ")")
    },
    "&:hover": {
        backgroundColor: "var(".concat((0, $9sI6P.varSearchHoverBackgroundColor), ")")
    }
});
var $46118ea46a2e1af5$var$searchIconStyles = (0, $2ZUkg.css)((0, $lrtwL.default)({}, "@media (min-width: ".concat((0, $9sI6P.CREATE_BREAKPOINT), "px)"), {
    display: "none !important"
}));
var $46118ea46a2e1af5$var$SearchComponent = function SearchComponent(props) {
    var _searchInputDynamicSt;
    var onClick = props.onClick, placeholder = props.placeholder, label = props.label, value = props.value;
    var theme = (0, $72HvB.useTheme)();
    var search = theme.mode.search;
    var onChange = function onChange() {
        // @ts-expect-error
        onClick && onClick.apply(void 0, arguments);
    };
    var onInputClick = function onInputClick() {
        // @ts-expect-error
        onClick && onClick.apply(void 0, arguments);
    };
    var searchInputDynamicStyles = (_searchInputDynamicSt = {}, (0, $lrtwL.default)(_searchInputDynamicSt, (0, $9sI6P.varSearchBackgroundColor), search.default.backgroundColor), (0, $lrtwL.default)(_searchInputDynamicSt, (0, $9sI6P.varSearchColor), search.default.color), (0, $lrtwL.default)(_searchInputDynamicSt, (0, $9sI6P.varSearchBorderColor), search.default.borderColor), (0, $lrtwL.default)(_searchInputDynamicSt, (0, $9sI6P.varSearchFocusBorderColor), search.focus.borderColor), (0, $lrtwL.default)(_searchInputDynamicSt, (0, $9sI6P.varSearchHoverBackgroundColor), search.hover.backgroundColor), _searchInputDynamicSt);
    return (0, $2ZUkg.jsx)("div", {
        css: $46118ea46a2e1af5$var$searchInputContainerStyles,
        role: "search"
    }, (0, $2ZUkg.jsx)("div", {
        css: $46118ea46a2e1af5$var$searchInputIconStyles
    }, (0, $2ZUkg.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g1gzF))), {
        label: ""
    })), (0, $2ZUkg.jsx)("input", {
        style: searchInputDynamicStyles,
        css: [
            $46118ea46a2e1af5$var$searchInputStyles,
            $46118ea46a2e1af5$var$newSearchBorderStyles
        ],
        "aria-label": label,
        placeholder: placeholder,
        onChange: onChange,
        onClick: onInputClick,
        value: value
    }));
};
var $46118ea46a2e1af5$export$4b85d3515bd863a5 = function Search(props) {
    var placeholder = props.placeholder, tooltip = props.tooltip, label = props.label, value = props.value, iconButtonProps = (0, $gmKOS.default)(props, $46118ea46a2e1af5$var$_excluded);
    return (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), null, (0, $2ZUkg.jsx)($46118ea46a2e1af5$var$SearchComponent, {
        onClick: iconButtonProps.onClick,
        placeholder: placeholder,
        label: label,
        value: value || ""
    }), (0, $2ZUkg.jsx)((0, $2okzL.IconButton), (0, $djxp7.default)({
        css: $46118ea46a2e1af5$var$searchIconStyles,
        icon: (0, $2ZUkg.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g1gzF))), {
            label: label
        }),
        tooltip: tooltip
    }, iconButtonProps)));
};
var $46118ea46a2e1af5$export$2e2bcd8739ae039 = $46118ea46a2e1af5$export$4b85d3515bd863a5;

});
parcelRegister("g1gzF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba9998ab444a1668$var$_react = $ba9998ab444a1668$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $fWDTK = parcelRequire("fWDTK");
function $ba9998ab444a1668$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ba9998ab444a1668$var$SearchIcon = (props)=>/*#__PURE__*/ $ba9998ab444a1668$var$_react.default.createElement($fWDTK.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M16.436 15.085l3.94 4.01a1 1 0 01-1.425 1.402l-3.938-4.006a7.5 7.5 0 111.423-1.406zM10.5 16a5.5 5.5 0 100-11 5.5 5.5 0 000 11z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$ba9998ab444a1668$var$SearchIcon.displayName = "SearchIcon";
var $ba9998ab444a1668$var$_default = $ba9998ab444a1668$var$SearchIcon;
module.exports.default = $ba9998ab444a1668$var$_default;

});


parcelRegister("7sRIl", function(module, exports) {

$parcel$export(module.exports, "Settings", function () { return $56f4d0774543a202$export$c72f6eaae7b9adff; });

var $djxp7 = parcelRequire("djxp7");

var $gmKOS = parcelRequire("gmKOS");

var $iSvIT = parcelRequire("iSvIT");

var $hjM0l = parcelRequire("hjM0l");

var $2okzL = parcelRequire("2okzL");
var $56f4d0774543a202$var$_excluded = [
    "tooltip"
];
var $56f4d0774543a202$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var tooltip = props.tooltip, iconButtonProps = (0, $gmKOS.default)(props, $56f4d0774543a202$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2okzL.IconButton), (0, $djxp7.default)({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hjM0l))), {
            label: typeof tooltip === "string" ? tooltip : "Settings Icon"
        }),
        ref: ref,
        tooltip: tooltip
    }, iconButtonProps)));
});
var $56f4d0774543a202$export$2e2bcd8739ae039 = $56f4d0774543a202$export$c72f6eaae7b9adff;

});
parcelRegister("hjM0l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0340ed3493689d0b$var$_react = $0340ed3493689d0b$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $fWDTK = parcelRequire("fWDTK");
function $0340ed3493689d0b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $0340ed3493689d0b$var$SettingsIcon = (props)=>/*#__PURE__*/ $0340ed3493689d0b$var$_react.default.createElement($fWDTK.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.701 16.7a5.002 5.002 0 110-10.003 5.002 5.002 0 010 10.004m8.368-3.117a1.995 1.995 0 01-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 00.315-.574 8.947 8.947 0 00-.836-1.993.477.477 0 00-.598-.195 2.04 2.04 0 01-1.29.08 1.988 1.988 0 01-1.404-1.395 2.04 2.04 0 01.076-1.297.478.478 0 00-.196-.597 8.98 8.98 0 00-1.975-.826.479.479 0 00-.574.314 1.995 1.995 0 01-1.885 1.346 1.994 1.994 0 01-1.884-1.345.482.482 0 00-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 00-.198.582A2.002 2.002 0 014.445 7.06a.478.478 0 00-.595.196 8.946 8.946 0 00-.833 1.994.48.48 0 00.308.572 1.995 1.995 0 011.323 1.877c0 .867-.552 1.599-1.324 1.877a.479.479 0 00-.308.57 8.99 8.99 0 00.723 1.79.477.477 0 00.624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 00.168.628 8.946 8.946 0 002.11.897.474.474 0 00.57-.313 1.995 1.995 0 011.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 00.57.313 8.964 8.964 0 002.084-.883.473.473 0 00.167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 00.628-.19 8.925 8.925 0 00.728-1.793.478.478 0 00-.314-.573" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$0340ed3493689d0b$var$SettingsIcon.displayName = "SettingsIcon";
var $0340ed3493689d0b$var$_default = $0340ed3493689d0b$var$SettingsIcon;
module.exports.default = $0340ed3493689d0b$var$_default;

});


parcelRegister("8zMNO", function(module, exports) {

$parcel$export(module.exports, "JiraIcon", function () { return $63e772beee40ff4e$export$c4b5b1f965d8b3eb; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $63e772beee40ff4e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>\n    </svg>');
};
var $63e772beee40ff4e$export$c4b5b1f965d8b3eb = function JiraIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        svg: $63e772beee40ff4e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});




parcelRegister("f2a5L", function(module, exports) {

$parcel$export(module.exports, "PaidAccountCreation", function () { return $9ec365143654b648$export$8cfb1818275d36da; });
/* paid-account-creation.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $3wnRY = parcelRequire("3wnRY");

var $2emKj = parcelRequire("2emKj");

var $axg8K = parcelRequire("axg8K");
var $dKFLo = parcelRequire("dKFLo");
var $9CUtk = parcelRequire("9CUtk");
var $aZTjH = parcelRequire("aZTjH");
var $g9fB0 = parcelRequire("g9fB0");
parcelRequire("9DfPf");
var $fVvJ6 = parcelRequire("fVvJ6");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $gFK1O = parcelRequire("gFK1O");

var $lrVTP = parcelRequire("lrVTP");

var $8Ct52 = parcelRequire("8Ct52");

var $csseQ = parcelRequire("csseQ");
const $9ec365143654b648$export$8cfb1818275d36da = ({ darkSolidTheme: darkSolidTheme, showFourSocialButtons: showFourSocialButtons, auxiaResponse: auxiaResponse })=>{
    const { product: product } = (0, $iMdoL.useUserContext)();
    const i18n = (0, $f6qj2.default)();
    const location = (0, $lrVTP.useLocation)();
    const isAuxiaPage = (0, $iMdoL.useJiraServiceManagementIntent)() && (0, $3wnRY.isAuxiaServedPage)(auxiaResponse);
    const logInLink = (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
            text: text,
            "aria-label": text,
            type: "inline",
            href: (0, $jgJpJ.getLoginUrl)(location),
            onClick: ()=>{
                if (isAuxiaPage) {
                    const anonymousId = decodeURIComponent((0, $gFK1O.Cookie).readCookie("ajs_anonymous_id") || "").replace(/['"]+/g, "");
                    (0, $2emKj.sendAnalyticsToAuxia)({
                        anonymousId: anonymousId,
                        treatmentTrackingId: auxiaResponse.treatmentTrackingId,
                        treatmentId: auxiaResponse.treatmentId,
                        interactionType: "CLICKED",
                        interactionTimeMicros: (0, $2emKj.convertDateTimeToInteractionTimeMicros)(Date.now()),
                        actionName: "login_button"
                    });
                }
            }
        });
    const loginText = i18n.formatMessage({
        id: "BxpUiSignup.SignupForm.existingProduct.confluence.embedded",
        defaultMessage: "Trying to access {product}? <logInLink>Log in</logInLink>"
    }, {
        product: product === null || product === void 0 ? void 0 : product.description,
        logInLink: logInLink
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.default), {
        Input: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                darkSolidTheme && "_ie4m121t _frvh121t _q7r4cd5j",
                !darkSolidTheme && "_frvh1p0d _ie4m1cjc"
            ]),
            style: {
                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
            },
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dKFLo.Input), {})
        }),
        Login: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_26vxviql",
                darkSolidTheme && "_43ds121t"
            ]),
            style: {
                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $fVvJ6.AnimatedSocialProof), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $9CUtk.Login), {
                    loginText: loginText
                })
            ]
        }),
        Social: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                showFourSocialButtons && "_jk741ezz _zs121ylp _1b94glyw"
            ]),
            children: [
                !isAuxiaPage && !showFourSocialButtons && /*#__PURE__*/ (0, $loA2J.jsx)((0, $aZTjH.Social), {
                    providers: {
                        google: "Google",
                        microsoft: "Microsoft"
                    }
                }),
                !isAuxiaPage && showFourSocialButtons && /*#__PURE__*/ (0, $loA2J.jsx)((0, $aZTjH.Social), {}),
                isAuxiaPage && !showFourSocialButtons && /*#__PURE__*/ (0, $loA2J.jsx)((0, $8Ct52.AuxiaSocial), {
                    providers: {
                        google: "Google",
                        microsoft: "Microsoft"
                    },
                    auxiaResponse: auxiaResponse
                }),
                isAuxiaPage && showFourSocialButtons && /*#__PURE__*/ (0, $loA2J.jsx)((0, $8Ct52.AuxiaSocial), {})
            ]
        }),
        Submit: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                darkSolidTheme && "_7dirhyuj _d32v16l4 _6pup1s4t _4pkp16l4"
            ]),
            style: {
                "--_1f8eaoq": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.yellow400"))
            },
            children: [
                !isAuxiaPage && /*#__PURE__*/ (0, $loA2J.jsx)((0, $g9fB0.Submit), {}),
                isAuxiaPage && /*#__PURE__*/ (0, $loA2J.jsx)((0, $csseQ.AuxiaSubmit), {
                    auxiaResponse: auxiaResponse
                })
            ]
        })
    });
};
const $9ec365143654b648$var$socialWrapperStyle = null;
const $9ec365143654b648$var$loginSocialProofCss = null;
const $9ec365143654b648$var$yellowButtonCss = null;
const $9ec365143654b648$var$whiteLinkCss = null;
const $9ec365143654b648$var$whiteTextCss = null;
const $9ec365143654b648$var$darkGrayTextCss = null;

});
parcelRegister("3wnRY", function(module, exports) {

$parcel$export(module.exports, "isAuxiaServedPage", function () { return $874fe77c2166f21b$export$d387d4c6b79063ea; });
$parcel$export(module.exports, "isAuxiaResponseMalformed", function () { return $874fe77c2166f21b$export$b9e49162afc62078; });

var $gAJUc = parcelRequire("gAJUc");
function $874fe77c2166f21b$var$isValidAuxiaResponse(auxiaResponse) {
    return auxiaResponse !== null && auxiaResponse !== undefined && typeof auxiaResponse.treatmentId === "string" && typeof auxiaResponse.treatmentTrackingId === "string" && auxiaResponse.treatmentId.length > 0 && auxiaResponse.treatmentTrackingId.length > 0 && Array.isArray(auxiaResponse.auxiaTreatment) && auxiaResponse.auxiaTreatment.length > 0;
}
const $874fe77c2166f21b$export$d387d4c6b79063ea = (auxiaResponse)=>{
    const usingAuxiaTreatment = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).jsmPaidLpAuxiaIntegration);
    return usingAuxiaTreatment && $874fe77c2166f21b$var$isValidAuxiaResponse(auxiaResponse);
};
const $874fe77c2166f21b$export$b9e49162afc62078 = (auxiaResponse)=>{
    const usingAuxiaTreatment = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).jsmPaidLpAuxiaIntegration);
    return usingAuxiaTreatment && !$874fe77c2166f21b$var$isValidAuxiaResponse(auxiaResponse);
};

});

parcelRegister("2emKj", function(module, exports) {

$parcel$export(module.exports, "convertDateTimeToInteractionTimeMicros", function () { return $500b74bf812140d1$export$1219d02973c84a52; });
$parcel$export(module.exports, "sendAnalyticsToAuxia", function () { return $500b74bf812140d1$export$3d1788c6d7ad0255; });
const $500b74bf812140d1$var$setWindowAnalyticsObject = ({ interactionType: interactionType, wasSent: wasSent })=>{
    if (interactionType === "VIEWED") // @ts-ignore
    window.sentViewedAuxiaAnalytics = wasSent.toString();
    else if (interactionType === "CLICKED") // @ts-ignore
    window.sentClickedAuxiaAnalytics = wasSent.toString();
};
const $500b74bf812140d1$export$1219d02973c84a52 = (dateTime)=>{
    const microSeconds = dateTime * 1000;
    return microSeconds.toString();
};
const $500b74bf812140d1$export$3d1788c6d7ad0255 = async ({ anonymousId: anonymousId, treatmentTrackingId: treatmentTrackingId, treatmentId: treatmentId, interactionType: interactionType, interactionTimeMicros: interactionTimeMicros, actionName: actionName })=>{
    const url = "https://apis.auxia.io/v1/LogTreatmentInteraction";
    const auxiaRequest = {
        projectId: "1921",
        userId: anonymousId,
        treatmentTrackingId: treatmentTrackingId,
        treatmentId: treatmentId,
        surface: "LANDING_PAGE_JSM",
        interactionType: interactionType,
        interactionTimeMicros: interactionTimeMicros,
        languageCode: "en",
        actionName: actionName || ""
    };
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-api-key": "AIzaSyCUlO-ukAKTA1Khu87fez3UspN5PEtFOsY"
            },
            body: JSON.stringify(auxiaRequest)
        });
        const data = await response.json();
        const stringData = JSON.stringify(data);
        const responseContainsError = stringData !== "{}";
        if (responseContainsError) throw Error(`Auxia did not properly receive analytics: ${stringData}`);
        $500b74bf812140d1$var$setWindowAnalyticsObject({
            interactionType: interactionType,
            wasSent: true
        });
    } catch (e) {
        console.error(`sendAnalyticsToAuxia call error:
                        Request Body: ${JSON.stringify(auxiaRequest)}
                        Error: ${e}
                    `);
    }
};

});

parcelRegister("8Ct52", function(module, exports) {

$parcel$export(module.exports, "AuxiaSocial", function () { return $b83cbb7845080c0f$export$fe45cc996003fded; });
/* paid-jsm-account-creation-social-auxia.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $3wnRY = parcelRequire("3wnRY");

var $2emKj = parcelRequire("2emKj");
parcelRequire("axg8K");
var $a3QsU = parcelRequire("a3QsU");
var $fYPhW = parcelRequire("fYPhW");

var $gFK1O = parcelRequire("gFK1O");
const $b83cbb7845080c0f$export$fe45cc996003fded = ({ providers: providers, auxiaResponse: auxiaResponse })=>{
    const intl = (0, $f6qj2.default)();
    const { onClickSocialButton: onClickSocialButton } = (0, $a3QsU.useAccountCreationContext)();
    if (providers === undefined) providers = {
        google: "Google",
        microsoft: "Microsoft",
        apple: "Apple",
        slack: "Slack"
    };
    const buttons = Object.entries(providers);
    const buttonGridCss = null;
    const buttonListCss = null; /* eslint-disable jsx-a11y/no-redundant-roles */ 
    /* added role="list" to ul for safari https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility  */ return /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
        role: "list",
        className: (0, $esG4f.default)([
            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            buttons.length > 1 && "_1e0c11p5 _zulp7vkz _yv0efsjm"
        ]),
        children: buttons.map(([provider, label])=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $fYPhW.LogoButton), {
                    "aria-label": intl.formatMessage({
                        id: "social.label.signup",
                        defaultMessage: "sign up with {provider}"
                    }, {
                        provider: label
                    }),
                    onClick: ()=>{
                        if ((0, $3wnRY.isAuxiaServedPage)(auxiaResponse)) {
                            const anonymousId = decodeURIComponent((0, $gFK1O.Cookie).readCookie("ajs_anonymous_id") || "").replace(/['"]+/g, "");
                            (0, $2emKj.sendAnalyticsToAuxia)({
                                anonymousId: anonymousId,
                                treatmentTrackingId: auxiaResponse.treatmentTrackingId,
                                treatmentId: auxiaResponse.treatmentId,
                                interactionType: "CLICKED",
                                interactionTimeMicros: (0, $2emKj.convertDateTimeToInteractionTimeMicros)(Date.now()),
                                actionName: `${provider}_login`
                            });
                        }
                        return onClickSocialButton(provider);
                    },
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $fYPhW.ProviderLogo), {
                            logo: provider
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            children: label
                        })
                    ]
                })
            }, provider))
    });
};

});

parcelRegister("csseQ", function(module, exports) {

$parcel$export(module.exports, "AuxiaSubmit", function () { return $12eb4e2041cefa71$export$f9bc420969cdc1a3; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $3wnRY = parcelRequire("3wnRY");

var $2emKj = parcelRequire("2emKj");

var $91nJf = parcelRequire("91nJf");
parcelRequire("axg8K");
var $a3QsU = parcelRequire("a3QsU");

var $gFK1O = parcelRequire("gFK1O");
const $12eb4e2041cefa71$export$f9bc420969cdc1a3 = ({ buttonText: buttonText, auxiaResponse: auxiaResponse })=>{
    const intl = (0, $f6qj2.default)();
    const { isSubmitting: isSubmitting, hasSubmitted: hasSubmitted, formError: formError, onClickSubmitButton: onClickSubmitButton } = (0, $a3QsU.useAccountCreationContext)();
    if (buttonText === undefined) buttonText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.submit",
        defaultMessage: "Sign up"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
        type: "submit",
        isDisabled: isSubmitting || hasSubmitted && !formError,
        isFullWidth: true,
        isLoading: isSubmitting || hasSubmitted && !formError,
        onClick: ()=>{
            if ((0, $3wnRY.isAuxiaServedPage)(auxiaResponse)) {
                const anonymousId = decodeURIComponent((0, $gFK1O.Cookie).readCookie("ajs_anonymous_id") || "").replace(/['"]+/g, "");
                (0, $2emKj.sendAnalyticsToAuxia)({
                    anonymousId: anonymousId,
                    treatmentTrackingId: auxiaResponse.treatmentTrackingId,
                    treatmentId: auxiaResponse.treatmentId,
                    interactionType: "CLICKED",
                    interactionTimeMicros: (0, $2emKj.convertDateTimeToInteractionTimeMicros)(Date.now()),
                    actionName: "sign_up"
                });
            }
            return onClickSubmitButton();
        },
        children: buttonText
    });
};

});



parcelRegister("ka2Mp", function(module, exports) {

$parcel$export(module.exports, "PaidHeroSectionTypes", function () { return $f0451b41d7e12a5e$export$f14a1c5ae1fdb785; });
/* paid-hero-section-types.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");
const $f0451b41d7e12a5e$var$heroStyles = {
    "jira-software": "_bfhkuzct _1itk1mj5 _ouxlsfij _12vemgnk _1lrw16om _1rmv1nmc",
    "jira-software-anchor": "_syazr3uz _bfhkdoyu _1ndau67f _1twl8n31 _r8nt1nn1 _7gaj1h6o",
    "jira-software-rebranded-anchor": "_1pfh1wqb _kqswh2mm _1kt9b3bt _1cs8stnw _iajmgktf _z5wtidpf _1enw53f4 _1rusuzct _1fkrymf6 _7dwz16qr _8kay1h6o _1g0v1oqz _dsq4glyw _aetrb3bt _18postnw _1hfkuzct _19nq1h39 _g0nfuuw1 _1czdidpf _1gufidpf _clh31mo7 _1tlb1h6o _1bqq1oqz _11fnglyw",
    "jira-service-management": "_ct361wug _11q71yp8",
    "jira-service-management-anchor": "_syazr3uz _bfhkdoyu _1ndau67f _1twl8n31 _r8nt1nn1 _7gaj1h6o",
    "confluence-paid": "_16qs1qj0 _1itk1yrd _ouxlroey _12veeva1 _1lrw13e2",
    "confluence-anchor": "_16qs1qj0 _1itkr87c _ouxl1ssb _12vemgnk _1lrw1dfr _1rmvw151 _1f9f8d6s _r2cimgnk _u6yg1f51",
    "confluence-rebranded-anchor": "_1pfh1wqb _kqswh2mm _1kt9b3bt _1cs8stnw _iajmgktf _z5wtidpf _1enw53f4 _1rusuzct _1fkrymf6 _7dwz16qr _8kay1h6o _1g0v1oqz _dsq4glyw _aetrb3bt _18postnw _1hfkuzct _19nq1h39 _g0nfuuw1 _1czdidpf _1gufidpf _clh31mo7 _1tlb1h6o _1bqq1oqz _11fnglyw"
};
const $f0451b41d7e12a5e$var$JSMRebrandedAnchorBackground = null;
const $f0451b41d7e12a5e$var$darkThemeEmailForm = null;
const $f0451b41d7e12a5e$var$defaultHeroStyles = null;
const $f0451b41d7e12a5e$var$padding = null;
const $f0451b41d7e12a5e$export$f14a1c5ae1fdb785 = ({ darkSolidTheme: darkSolidTheme, landingType: landingType, heroComponent: heroComponent, showAnimatedHero: showAnimatedHero, showNewHero: showNewHero })=>{
    const customHero = !darkSolidTheme && showNewHero && $f0451b41d7e12a5e$var$heroStyles[landingType];
    const defaultHero = !darkSolidTheme && !showNewHero && $f0451b41d7e12a5e$var$defaultHeroStyles;
    const isRebrandedJSMHero = darkSolidTheme && showNewHero && landingType === "jira-service-management-anchor";
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        id: "start-trial",
        className: (0, $esG4f.default)([
            showAnimatedHero && darkSolidTheme && "_bfhk17la _syazcd5j _n3c5cd5j _h4c66nkb _4pvyr2ho _1ajj1s4t _235jr2ho _dadmcd5j _128a121t _1ro31q34",
            showAnimatedHero && !darkSolidTheme && showNewHero && $f0451b41d7e12a5e$var$heroStyles[landingType],
            showAnimatedHero && !darkSolidTheme && !showNewHero && "_bfhkuzct _1itk1mj5 _ouxlsfij _12vemgnk _1lrw16om _ij141nmc",
            !showAnimatedHero && $f0451b41d7e12a5e$var$heroStyles[landingType],
            isRebrandedJSMHero && "_bfhk1ism",
            "_1q511wqb"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1vwzriw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.yellow")),
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_1oxqp4m": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.yellow300"))
        },
        children: heroComponent
    });
};
$f0451b41d7e12a5e$export$f14a1c5ae1fdb785.displayName = "PaidHero";

});

parcelRegister("l0hW2", function(module, exports) {

$parcel$export(module.exports, "PaidTabsSection", function () { return $14750b23f3088979$export$4db38360327330ee; });
/* paid-tabs-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
parcelRequire("5IQ8d");
var $8VcJD = parcelRequire("8VcJD");
const $14750b23f3088979$var$anchorStyles = null;
const $14750b23f3088979$var$jsmAndConfTabsStyles = null;
const $14750b23f3088979$export$4db38360327330ee = (tabsProps)=>{
    const { styles: tabsStyles, landingType: landingType } = tabsProps, otherTabsProps = (0, $akGnX._)(tabsProps, [
        "styles",
        "landingType"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            landingType === "jira-software-anchor" && "_wndr138k _irhiangw _jwciangw _x5s11kwk _1hhbidpf _19e6idpf _1rvsidpf _13bjgktf _1m99glyw _ez63b3bt _kljastnw _11p1rdoj _o15y1skh _s0awdlk8 _1rflidpf _4yy7idpf _1mneidpf _1moqidpf _1b72idpf _1sjjidpf _1gum1fm0 _7iau7ogb _1hqaidpf _1bch1ylp _1yb1idpf _79pazwfg _1rhwidpf _iwhj1ylp _ddh0idpf _1fdoidpf _qaxvidpf",
            landingType === "jira-service-management-anchor" && "_wndr138k _irhiangw _jwciangw _x5s11kwk _1hhbidpf _19e6idpf _1rvsidpf _13bjgktf _1m99glyw _ez63b3bt _kljastnw _11p1rdoj _o15y1skh _s0awdlk8 _1rflidpf _4yy7idpf _1mneidpf _1moqidpf _1b72idpf _1sjjidpf _1gum1fm0 _7iau7ogb _1hqaidpf _1bch1ylp _1yb1idpf _79pazwfg _1rhwidpf _iwhj1ylp _ddh0idpf _1fdoidpf _qaxvidpf",
            landingType === "jira-service-management-anchor" && "_kbzovh8j _1spxdgqm _balx1vrj _fptxvh8j",
            landingType === "confluence-rebranded-anchor" && "_wndr138k _irhiangw _jwciangw _x5s11kwk _1hhbidpf _19e6idpf _1rvsidpf _13bjgktf _1m99glyw _ez63b3bt _kljastnw _11p1rdoj _o15y1skh _s0awdlk8 _1rflidpf _4yy7idpf _1mneidpf _1moqidpf _1b72idpf _1sjjidpf _1gum1fm0 _7iau7ogb _1hqaidpf _1bch1ylp _1yb1idpf _79pazwfg _1rhwidpf _iwhj1ylp _ddh0idpf _1fdoidpf _qaxvidpf",
            landingType === "confluence-rebranded-anchor" && "_kbzovh8j _1spxdgqm _balx1vrj _fptxvh8j",
            "tabs-section"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8VcJD.PaidTabs), (0, $7Knp0._)({}, otherTabsProps))
    });
};
$14750b23f3088979$export$4db38360327330ee.displayName = "PaidTabs";

});
parcelRegister("5IQ8d", function(module, exports) {
$parcel$export(module.exports, "PaidTabs", function () { return (parcelRequire("8VcJD")).PaidTabs; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("8VcJD")).PaidTabs; });

var $8VcJD = parcelRequire("8VcJD");

});
parcelRegister("8VcJD", function(module, exports) {

$parcel$export(module.exports, "PaidTabs", function () { return $b5ac358d9c704444$export$699a6a05a32d157; });
/* paid-tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("85QdM");
var $fILoL = parcelRequire("fILoL");
parcelRequire("gXzhc");
var $fYNW7 = parcelRequire("fYNW7");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("D0EyQ");
var $g8Gdb = parcelRequire("g8Gdb");
parcelRequire("37w71");
var $36iSx = parcelRequire("36iSx");
const $b5ac358d9c704444$var$tabCustomStyles = null;
const $b5ac358d9c704444$var$tabSectionTitleStyles = null;
const $b5ac358d9c704444$var$singleTabStyles = null;
const $b5ac358d9c704444$var$pullQuotesContainerStyles = null;
const $b5ac358d9c704444$var$renderChecklist = (tab)=>{
    var _tab_listItems;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g8Gdb.default), {
        title: tab.title,
        listItems: (_tab_listItems = tab.listItems) !== null && _tab_listItems !== void 0 ? _tab_listItems : [],
        imageSrc: tab.picture.image.src,
        imageAlt: tab.picture.image.alt
    });
};
const $b5ac358d9c704444$var$renderBodyText = (tab)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $36iSx.SimpleImageTextSide), {
        headerText: tab.title,
        headerType: "h3",
        bodyText: tab.body,
        imageLink: tab.picture.image.src,
        imageAltText: tab.picture.image.alt,
        alignItems: "top",
        rowProps: "4-8",
        className: "simple-image-text-side-tabs"
    });
};
const $b5ac358d9c704444$var$generateTabs = (tabsViaProps)=>{
    const transformedTabs = tabsViaProps.map((tab)=>{
        var _tab_listItems;
        var _tab_pullQuote_isShowBorder;
        return {
            textLabel: tab.textLabel,
            id: tab.id,
            component: /*#__PURE__*/ (0, $loA2J.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                children: [
                    ((_tab_listItems = tab.listItems) === null || _tab_listItems === void 0 ? void 0 : _tab_listItems.length) ? $b5ac358d9c704444$var$renderChecklist(tab) : $b5ac358d9c704444$var$renderBodyText(tab),
                    tab.pullQuote && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1q517vkz"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fILoL.PullQuote), {
                            logoSrc: tab.pullQuote.logoSrc,
                            logoAltText: tab.pullQuote.logoAltText,
                            quoteBlurb: tab.pullQuote.quoteBlurb || "",
                            quoteCompany: tab.pullQuote.quoteCompany || "",
                            quoteName: tab.pullQuote.quoteName || "",
                            isShowBorder: (_tab_pullQuote_isShowBorder = tab.pullQuote.isShowBorder) !== null && _tab_pullQuote_isShowBorder !== void 0 ? _tab_pullQuote_isShowBorder : false,
                            isUsingTextQuotationMarks: tab.pullQuote.isUsingTextQuotationMarks
                        })
                    })
                ]
            })
        };
    });
    return transformedTabs;
};
const $b5ac358d9c704444$export$699a6a05a32d157 = ({ headerText: headerText, tabStyles: tabStyles, tabs: tabs, tabsConfig: tabsConfig, dataProductKey: dataProductKey, layout: layout = "8" })=>{
    var _tabs_;
    tabs = tabsConfig ? $b5ac358d9c704444$var$generateTabs(tabsConfig) : tabs !== null && tabs !== void 0 ? tabs : [];
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_19pk1ylp _otyr1wqb _btm9gktf _hywlokh7 _rpgtoxwj _1dl31k92 _1o4gidpf _1g2bidpf _16rridpf _1x1cidpf _1j4q1oe7 _1w42mw4m _1i7w1bqd _1qf41k92 _11451k8s"
        ]),
        children: tabs.length === 1 ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _ca0qidpf _u5f31wqb _n3tdidpf _19bv1wqb _1kmxidpf _1ggmzwfg _1ykzidpf _1maezwfg _11ebviql _1kll1k8s"
            ]),
            children: (_tabs_ = tabs[0]) === null || _tabs_ === void 0 ? void 0 : _tabs_.component
        }) : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: layout,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        className: (0, $esG4f.default)([
                            "_y3gn1h6o _1wyb1k8s _6rth1ylp _k48pbfng _syaz1bqd _1gw8ahaf"
                        ]),
                        children: headerText
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $fYNW7.TabGroup), {
                    tabContentType: "custom",
                    tabs: tabs,
                    id: "tabs",
                    label: "tabs",
                    colors: tabStyles,
                    dataProductKey: dataProductKey
                })
            ]
        })
    });
};

});




parcelRegister("fR8rA", function(module, exports) {

$parcel$export(module.exports, "isTargetedKeyword", function () { return $f0fb984d6e55c153$export$cb97405e1165a712; });
$parcel$export(module.exports, "getPageId", function () { return $f0fb984d6e55c153$export$2ce6e339a89daf7a; });
$parcel$export(module.exports, "generateTabComponent", function () { return $f0fb984d6e55c153$export$58cc84c10393e7c7; });
$parcel$export(module.exports, "getAnimationByKeyword", function () { return $f0fb984d6e55c153$export$91b39788ec2acd40; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $cutM5 = parcelRequire("cutM5");

var $5SzKt = parcelRequire("5SzKt");

var $aL97s = parcelRequire("aL97s");

var $fNv2y = parcelRequire("fNv2y");

var $f8LoV = parcelRequire("f8LoV");
const $f0fb984d6e55c153$export$cb97405e1165a712 = (keyword = "")=>[
        "document editor",
        "documento editor",
        "document sharing",
        "doc editing",
        "editar um documento",
        "editar documentos online",
        "doc editing online",
        "doc editor online",
        "text editor online",
        "word",
        "notion",
        "google docs",
        "microsoft word",
        "microsoft word en l\xednea",
        "word gratis",
        "word editor",
        "word online",
        "microsoft word gratis descargar",
        "microsoft office",
        "spreadsheets",
        "google sheets",
        "project plan",
        "project management tool",
        "project management platform",
        "software project management tools",
        "project management template",
        "plan del proyecto",
        "task list",
        "digital diagram",
        "diagrama digital",
        "diagrama de flujo",
        "online flow chart",
        "creador de diagramas de flujo",
        "diagramas de flujo online",
        "hacer un diagrama de flujo",
        "diagrama de flujo online",
        "programas para hacer diagramas de flujo",
        "fluxograma online",
        "diagrama de flujo online gratis",
        "flowchart",
        "criar mapas mentais"
    ].includes(keyword);
const $f0fb984d6e55c153$export$2ce6e339a89daf7a = (keyword = "")=>{
    return ({
        "document editor": "paid-lp-conf-keywords-documentation",
        "documento editor": "paid-lp-conf-keywords-documentation",
        "document sharing": "paid-lp-conf-keywords-documentation",
        "doc editing": "paid-lp-conf-keywords-documentation",
        "editar um documento": "paid-lp-conf-keywords-documentation",
        "editar documentos online": "paid-lp-conf-keywords-documentation",
        "doc editing online": "paid-lp-conf-keywords-documentation",
        "doc editor online": "paid-lp-conf-keywords-documentation",
        "text editor online": "paid-lp-conf-keywords-documentation",
        "word": "paid-lp-conf-keywords-competitors",
        "notion": "paid-lp-conf-keywords-competitors",
        "google docs": "paid-lp-conf-keywords-competitors",
        "microsoft word": "paid-lp-conf-keywords-competitors",
        "microsoft word en l\xednea": "paid-lp-conf-keywords-competitors",
        "word gratis": "paid-lp-conf-keywords-competitors",
        "word editor": "paid-lp-conf-keywords-competitors",
        "word online": "paid-lp-conf-keywords-competitors",
        "microsoft word gratis descargar": "paid-lp-conf-keywords-competitors",
        "microsoft office": "paid-lp-conf-keywords-competitors",
        "spreadsheets": "paid-lp-conf-keywords-spreadsheets",
        "google sheets": "paid-lp-conf-keywords-spreadsheets",
        "project plan": "paid-lp-conf-keywords-project-plan",
        "project management tool": "paid-lp-conf-keywords-project-plan",
        "project management platform": "paid-lp-conf-keywords-project-plan",
        "software project management tools": "paid-lp-conf-keywords-project-plan",
        "project management template": "paid-lp-conf-keywords-project-plan",
        "plan del proyecto": "paid-lp-conf-keywords-project-plan",
        "task list": "paid-lp-conf-keywords-task-list",
        "digital diagram": "paid-lp-conf-keywords-digital-diagram",
        "diagrama digital": "paid-lp-conf-keywords-digital-diagram",
        "diagrama de flujo": "paid-lp-conf-keywords-digital-diagram",
        "online flow chart": "paid-lp-conf-keywords-digital-diagram",
        "creador de diagramas de flujo": "paid-lp-conf-keywords-digital-diagram",
        "diagramas de flujo online": "paid-lp-conf-keywords-digital-diagram",
        "hacer un diagrama de flujo": "paid-lp-conf-keywords-digital-diagram",
        "diagrama de flujo online": "paid-lp-conf-keywords-digital-diagram",
        "programas para hacer diagramas de flujo": "paid-lp-conf-keywords-digital-diagram",
        "fluxograma online": "paid-lp-conf-keywords-digital-diagram",
        "diagrama de flujo online gratis": "paid-lp-conf-keywords-digital-diagram",
        "flowchart": "paid-lp-conf-keywords-digital-diagram",
        "criar mapas mentais": "paid-lp-conf-keywords-mental-map"
    })[keyword] || "paid-lp-conf-keywords-documentation";
};
const $f0fb984d6e55c153$export$58cc84c10393e7c7 = (keyword = "", tab)=>{
    let videoProps;
    if ([
        "spreadsheets",
        "google sheets"
    ].includes(keyword)) videoProps = {
        videoSrcMp4: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Databases_LowBR_reencode.mp4",
        videoSrcWebm: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Databases_LowBR.webm",
        videoPreviewSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Databases_Preview.webp"
    };
    else if ([
        "digital diagram",
        "diagrama digital",
        "diagrama de flujo",
        "criar mapas mentais",
        "online flow chart",
        "creador de diagramas de flujo",
        "diagramas de flujo online",
        "hacer un diagrama de flujo",
        "diagrama de flujo online",
        "programas para hacer diagramas de flujo",
        "fluxograma online",
        "diagrama de flujo online gratis",
        "flowchart"
    ].includes(keyword)) videoProps = {
        videoSrcMp4: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Whiteboards_LowBR_reencode.mp4",
        videoSrcWebm: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Whiteboards_LowBR.webm",
        videoPreviewSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Whiteboards_Preview.webp"
    };
    else videoProps = {
        videoSrcMp4: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Pages_LowBR_reencode.mp4",
        videoSrcWebm: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Pages_LowBR.webm",
        videoPreviewSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Pages_Preview.webp"
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4Tabs), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $f8LoV.ContentTypeVideo), (0, $6iHNw._)((0, $7Knp0._)({}, videoProps), {
            showBackground: true,
            active: true,
            showAsterisks: true,
            hideSeparator: true,
            title: tab.title,
            description: tab.description,
            iconCollection: Array.from(new DOMParser().parseFromString(tab.content, "text/html").querySelectorAll("p")).slice(0, 3).map((p, i)=>({
                    description: p.textContent || "",
                    icon: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $fNv2y.Rocket), {
                            size: "small"
                        }, "Rocket"),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5SzKt.Megaphone), {
                            size: "small"
                        }, "Megaphone"),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $aL97s.Notepad), {
                            size: "small"
                        }, "Notepad")
                    ][i]
                }))
        }))
    });
};





const $f0fb984d6e55c153$export$91b39788ec2acd40 = (keyword)=>{
    let animation;
    if ([
        "spreadsheets",
        "google sheets"
    ].includes(keyword)) animation = (parcelRequire("7MDGJ"));
    else if ([
        "digital diagram",
        "diagrama digital",
        "diagrama de flujo",
        "criar mapas mentais",
        "online flow chart",
        "creador de diagramas de flujo",
        "diagramas de flujo online",
        "hacer un diagrama de flujo",
        "diagrama de flujo online",
        "programas para hacer diagramas de flujo",
        "fluxograma online",
        "diagrama de flujo online gratis",
        "flowchart"
    ].includes(keyword)) animation = (parcelRequire("1prlM"));
    else if ([
        "project plan",
        "project management tool",
        "project management platform",
        "software project management tools",
        "project management template",
        "plan del proyecto"
    ].includes(keyword)) animation = (parcelRequire("kHmPt"));
    else if ([
        "task list"
    ].includes(keyword)) animation = (parcelRequire("ccuey"));
    else animation = (parcelRequire("11aRP"));
    return animation ? {
        lottieAnimationPromise: animation
    } : undefined;
};

});
parcelRegister("f8LoV", function(module, exports) {

$parcel$export(module.exports, "ContentTypeVideo", function () { return $4ea19f8be29b8ca3$export$fcfc83b800268bb4; });
/* content-type-video.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $eDoPe = parcelRequire("eDoPe");
parcelRequire("cIqek");
var $eGxBJ = parcelRequire("eGxBJ");

var $cutM5 = parcelRequire("cutM5");

var $5ohHq = parcelRequire("5ohHq");

var $3HFsP = parcelRequire("3HFsP");
const $4ea19f8be29b8ca3$var$imageStyle = null;
const $4ea19f8be29b8ca3$var$reusableImageStyle = null;
const $4ea19f8be29b8ca3$var$backgroundStyle = null;
const $4ea19f8be29b8ca3$var$reusuablePurpleBackgroundStyle = null;
const $4ea19f8be29b8ca3$var$reusuableGreenBackgroundStyle = null;
const $4ea19f8be29b8ca3$var$reusuableOrangeBackgroundStyle = null;
const $4ea19f8be29b8ca3$var$videoStyle = null;
const $4ea19f8be29b8ca3$var$combinedVideoSizing = null;
const $4ea19f8be29b8ca3$var$iconSpacingOverride = null; // eslint-disable-next-line complexity
const $4ea19f8be29b8ca3$export$fcfc83b800268bb4 = (_param)=>{
    var { active: active, videoSrcMp4: videoSrcMp4, videoSrcWebm: videoSrcWebm, videoPreviewSrc: videoPreviewSrc, showBackground: showBackground, useSpecificBackgroundStyle: useSpecificBackgroundStyle = "none", isUseReusableXflowFeatureInfo: isUseReusableXflowFeatureInfo = false, addPaddingAboveListInReusableXflow: addPaddingAboveListInReusableXflow = false } = _param, props = (0, $akGnX._)(_param, [
        "active",
        "videoSrcMp4",
        "videoSrcWebm",
        "videoPreviewSrc",
        "showBackground",
        "useSpecificBackgroundStyle",
        "isUseReusableXflowFeatureInfo",
        "addPaddingAboveListInReusableXflow"
    ]);
    const { userSelected: userSelected, goToNextTab: goToNextTab } = (0, $cutM5.useAdg4TabsContext)();
    const { ref: containerRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)({
        initialInView: true,
        threshold: 0.3
    });
    const videoRef = /*#__PURE__*/ (0, $iSvIT.createRef)();
    (0, $iSvIT.useEffect)(()=>{
        if (sectionIsVisible && active && videoRef.current && videoRef.current.play) {
            videoRef.current.autoplay = true;
            videoRef.current.currentTime = 0;
            videoRef.current.play().catch(()=>{});
        } else if (!active || !sectionIsVisible) {
            var _videoRef_current, _videoRef_current1;
            if ((_videoRef_current = videoRef.current) === null || _videoRef_current === void 0 ? void 0 : _videoRef_current.paused) return;
            (_videoRef_current1 = videoRef.current) === null || _videoRef_current1 === void 0 ? void 0 : _videoRef_current1.pause();
        }
    }, [
        active,
        videoRef,
        sectionIsVisible
    ]);
    const FeatureInfoImageAndVideo = /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        ref: containerRef,
        className: (0, $esG4f.default)([
            isUseReusableXflowFeatureInfo ? "_1rjct7po _18zr16gx _kqswh2mm _1pbykb7n" : "_85i51tcg _26vx1tcg _d2ik1tcg",
            showBackground && useSpecificBackgroundStyle === "none" && "_1kt9b3bt _1rusowgw _1cs8stnw _qnec1hnc _1aukidpf _1mp411be _kfgt1osq _1g0v1mrw _tgsmyvst _11r71lk2 _1c9g1ghs _aw8s3pft _9n3r13va _8n7u1vuk _16ho16gx _b4lq13sl _lu7ho2qy _1kgg1w8u _1res9by0 _1hup12it _1knvgojt _11bbglyw _aetrb3bt _3p6mvjx7 _18postnw _19do1avk _1x881h6c _z0ai1iyx _1qdgypwq _idl91r5k _15cz1x1l _maqlscyu _j9q0qdsu _184p1nuc _15i6obt3 _jw3xx19p _1f4cyrmy _1606p1rm _1y3iglyw",
            showBackground && useSpecificBackgroundStyle === "purple" && "_1kt9b3bt _1ruscm6p _1cs8stnw _z5wtidpf _iajmidpf _1mp41osq _kfgt1osq _1g0v1mrw _tgsm1x17",
            showBackground && useSpecificBackgroundStyle === "green" && "_1kt9b3bt _1rusowgw _1cs8stnw _z5wtidpf _iajmidpf _1mp41osq _kfgt1osq _1g0v1mrw _tgsmhz6d",
            showBackground && useSpecificBackgroundStyle === "orange" && "_1kt9b3bt _1rus6nkb _1cs8stnw _z5wtbz2e _iajmidpf _1mp41vuk _kfgt1osq _1g0v1mrw _tgsm8z3g"
        ]),
        style: {
            "--_1lpv4ka": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.lime")),
            "--_1fb7i9d": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.purple")),
            "--_1vwzriw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.yellow"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eGxBJ.Adg4RaisedMedia), {
            className: isUseReusableXflowFeatureInfo ? "reusable-xflow-video" : "",
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _tnru9hbq _1vkh1xbk _1dny1wug _1lxi1wug",
                    isUseReusableXflowFeatureInfo ? "reusable" : ""
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("video", {
                    playsInline: true,
                    muted: true,
                    preload: "auto",
                    poster: videoPreviewSrc,
                    autoPlay: !!active,
                    loop: userSelected,
                    ref: videoRef,
                    onEnded: ()=>{
                        if (!userSelected && !isUseReusableXflowFeatureInfo) goToNextTab();
                    },
                    onLoadedMetadata: (videoEvent)=>{
                        if (!active) return;
                        try {
                            videoEvent.currentTarget.currentTime = 0; // Set currentTime to workaround Safari not autplaying
                            if (videoEvent.currentTarget.parentElement) videoEvent.currentTarget.play().catch(()=>false); // Call play() as backup to ensure the video is playing
                        } catch (error) {
                            console.log("Error calling play method on video after onCanPlay is invoked.");
                        }
                    },
                    className: (0, $esG4f.default)([
                        "_p12f1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                            src: videoSrcMp4,
                            type: `video/mp4`
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                            src: videoSrcWebm,
                            type: `video/webm`
                        })
                    ]
                })
            })
        })
    });
    return isUseReusableXflowFeatureInfo ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_pi1jftgi _w0qwidpf _8lhc1crf _1lre1osq _10mf1wug _1ya5idpf _445tidpf",
            "tab-content-image-container"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3HFsP.FeatureInfo), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
            reverseLayout: true,
            children: FeatureInfoImageAndVideo
        }))
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $3HFsP.FeatureInfo), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        reverseLayout: true,
        children: FeatureInfoImageAndVideo
    }));
};

});
parcelRegister("3HFsP", function(module, exports) {

$parcel$export(module.exports, "FeatureInfo", function () { return $fb5294f77b031b67$export$64a41dfe32d2aceb; });
/* feature-info.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");

var $iGlh4 = parcelRequire("iGlh4");
const $fb5294f77b031b67$var$containerStyles = null;
const $fb5294f77b031b67$var$containerReverseStyles = null;
const $fb5294f77b031b67$var$contentStyles = null;
const $fb5294f77b031b67$var$textContentStyles = null;
const $fb5294f77b031b67$var$textSpaceStyles = null;
const $fb5294f77b031b67$var$asterisksStyle = null;
const $fb5294f77b031b67$var$eyebrowStyles = null;
const $fb5294f77b031b67$var$titleStyles = null;
const $fb5294f77b031b67$var$descriptionStyles = null;
const $fb5294f77b031b67$var$separatorStyles = null;
const $fb5294f77b031b67$var$iconTitleStyles = null;
const $fb5294f77b031b67$var$iconContainerStyles = null;
const $fb5294f77b031b67$var$iconAndTextStyles = null;
const $fb5294f77b031b67$var$iconStyles = null;
const $fb5294f77b031b67$var$buttonSpaceStyles = null;
const $fb5294f77b031b67$var$displayNoneBelowLg = null;
const $fb5294f77b031b67$var$topPaddingStyles = null;
const $fb5294f77b031b67$export$64a41dfe32d2aceb = ({ eyebrow: eyebrow, title: title, description: description, iconTitle: iconTitle, iconCollection: iconCollection, reverseLayout: reverseLayout, cta: cta, showAsterisks: showAsterisks, hideSeparator: hideSeparator, addPaddingAboveList: addPaddingAboveList, children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bahesu3 _p12f1fra _zulpzwfg _1s4p1osq _na0i1sxn _tnv2cd5j _2osnidpf _15951w8u _1vkh1w8u _11qb1w8u _15sj1vuk",
            reverseLayout && "_2lx21sbv _na0i1bp4",
            "container-styles"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _ahbq1wug _12l21wug"
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_i0dl1r5k _2rkoqslr _11q7cd5j _1s4p1osq _1d2yr60k"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1q511crf",
                        "tab-text-content"
                    ]),
                    children: [
                        showAsterisks && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1mjbglyw"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iGlh4.Asterisks), {
                                size: "64"
                            })
                        }),
                        eyebrow && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_6rth14y2",
                                "eyebrow-md"
                            ]),
                            children: eyebrow
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            className: (0, $esG4f.default)([
                                "_1mouidpf",
                                "h3"
                            ]),
                            children: title
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: (0, $esG4f.default)([
                                "_1wyb1k92 _1pfh7vkz _srwz7vkz",
                                "tab-text-content-description"
                            ]),
                            children: description
                        }),
                        !hideSeparator && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_4t3it94y _11q7mmjq _1pfhzwfg",
                                "_1mjbglyw"
                            ]),
                            style: {
                                "--_1ayut75": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light500"))
                            }
                        }),
                        iconTitle && /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                            className: (0, $esG4f.default)([
                                "_1pfhzwfg _6rthrdoj _1bsbn8ye",
                                "_1mjbglyw",
                                "body-md"
                            ]),
                            children: iconTitle
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                            className: (0, $esG4f.default)([
                                "_1e0c116y _2lx21bp4 _4cvr1y6m _qtt8glyw _18zridpf _1mouidpf _zulpftgi _81641y44",
                                addPaddingAboveList && "_1q517vkz"
                            ]),
                            children: iconCollection.map((icon, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("li", {
                                    className: (0, $esG4f.default)([
                                        "_1e0c1txw _1bah1h6o _4cvr1y6m _15ueidpf _1uz3idpf"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_1bsb1tcg _4t3i1tcg _y3gn1h6o _1o9zidpf"
                                            ]),
                                            children: icon.icon
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                            className: "body-sm",
                                            children: icon.description
                                        })
                                    ]
                                }, index))
                        }),
                        cta && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1pfhzwfg _476d7vkz _srwz7vkz",
                                "tab-text-content-cta"
                            ]),
                            children: cta
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("iGlh4", function(module, exports) {

$parcel$export(module.exports, "Asterisks", function () { return $ac9fe5530b4ba1ed$export$73598a4b20da4aa6; });

var $loA2J = parcelRequire("loA2J");
const $ac9fe5530b4ba1ed$export$73598a4b20da4aa6 = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 68 69",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M19.557 39.6214C19.5694 39.6016 19.5693 39.5658 19.5941 39.538C18.8722 39.1886 18.7897 38.3308 18.2329 37.8185L18.2122 37.7986C17.6471 37.6239 17.7997 37.0798 17.0985 37.0758C17.0985 37.0758 17.28 36.9884 17.2841 36.9884C16.1456 35.9003 13.3323 33.2276 13.3323 33.2276C13.2704 33.4699 13.7819 33.0489 14.2976 33.1204C14.2976 33.1204 14.3347 33.0291 14.3718 33.1006C15.6877 31.8655 17.1686 31.3929 18.8516 30.8051C19.6931 30.5867 19.821 28.2952 18.3814 29.2444C18.3649 29.2285 18.3277 29.2166 18.3112 29.1888C17.808 29.7527 16.9706 29.5462 16.3353 29.8401L16.3106 29.852L15.2545 30.3484C14.6812 30.5748 14.0005 30.7535 13.2869 30.9283C13.3075 30.9084 13.3282 30.8885 13.3488 30.8687C13.3488 30.8687 13.423 29.7686 13.4024 29.2245C13.4024 29.2245 14.1243 28.3509 13.8851 27.7512C14.2934 27.0483 15.7454 25.5113 14.4254 25.0745C13.9923 25.0745 13.654 24.7131 13.5055 25.3843C13.4808 25.3803 13.4478 25.3882 13.4148 25.3763C13.3364 26.0713 12.4826 26.5638 12.2474 27.223L12.2392 27.2508C12.2969 27.8147 11.8432 28.3707 11.8391 28.3707C11.6245 28.887 11.344 29.4509 11.047 30.0386C10.9233 29.7209 10.7872 29.439 10.651 29.2365C10.156 28.7202 10.3664 21.6671 8.53489 23.2239C8.62152 24.5543 9.05873 25.9403 8.70398 27.1237C8.53073 27.215 8.79473 27.6876 9.00923 28.0729C8.99273 28.5613 8.88961 28.8234 8.86073 29.5224C7.95323 28.891 3.9932 25.6941 4.23658 27.8465C4.66146 28.0649 4.97082 28.3151 5.19357 28.8234C5.39982 29.0419 7.21898 30.0268 7.27673 30.273C7.15711 30.6145 9.30628 30.8885 8.43589 31.1427C8.56377 31.4127 8.73701 31.6709 8.93914 31.9211C7.99863 32.0164 6.87247 32.2824 6.28258 32.6279C6.17946 32.7987 2.42566 33.029 1.0644 33.8749C0.251765 34.3158 -0.465956 34.5342 0.379678 35.1974C0.684931 34.9591 1.83168 35.3007 1.80693 34.9869C2.08743 35.0981 3.98496 34.3991 4.19534 34.5183C4.29847 34.6771 5.79171 33.8352 5.61433 34.2324C6.64971 34.5143 7.91198 34.284 9.22374 33.9623C8.70399 34.7566 8.19252 35.8884 8.12652 36.5913C7.68101 37.4928 6.50534 39.4864 6.12996 40.7096C5.5937 41.5992 5.77935 41.6706 6.45585 42.1273L6.46824 42.1393C6.60849 42.2306 6.45174 42.1392 6.98387 42.1591C6.93025 42.1114 6.85184 41.905 6.74872 41.9407C6.81884 41.8017 7.62737 41.6031 7.28912 41.4165C7.27675 41.3887 7.80475 40.9995 7.85838 40.5785C8.32863 39.0774 9.45477 38.3188 10.288 36.6072C10.2674 36.7859 11.6699 40.1496 11.6039 41.8255C11.5008 42.6515 13.5798 43.8827 13.2787 42.04C13.3034 42.032 13.324 42.0003 13.3612 41.9963C13.027 41.2378 13.4684 40.4554 13.2952 39.685L13.2869 39.6532C12.9115 39.1846 13.3447 38.7954 12.7507 38.4142C12.7507 38.4142 12.9528 38.434 12.9569 38.438C12.6929 37.3459 12.5279 36.0115 12.2804 34.8161C13.1673 35.5905 13.9469 36.4245 14.2687 37.3419L14.3099 37.2824C14.3099 37.3102 14.3718 37.33 14.3182 37.3935C15.0648 37.5444 15.3206 37.8463 15.861 38.0488C15.861 38.0488 16.4384 39.0535 17.1108 39.0893L18.1338 40.4832C18.5752 41.202 20.9554 40.789 19.5735 39.6373L19.557 39.6214Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M42.5669 2.2075C42.553 2.2157 42.5416 2.23755 42.5177 2.24667C42.8478 2.69041 42.625 3.24131 42.8023 3.73206L42.8086 3.7508C43.0986 4.03772 42.8319 4.32183 43.2595 4.54769C43.2595 4.54769 43.1207 4.54332 43.1182 4.54201C43.4678 5.57026 44.3369 8.10121 44.3369 8.10121C44.4519 7.97276 44.0049 8.06727 43.7123 7.85926C43.7123 7.85926 43.6606 7.90329 43.6606 7.84774C42.4623 8.18387 41.406 8.00108 40.1894 7.82434C39.6051 7.68982 38.7969 9.05056 39.9797 8.92873C39.9848 8.9437 40.0037 8.9628 40.0049 8.98506C40.4924 8.8005 40.9388 9.19363 41.4209 9.21628L41.4398 9.21687L42.2439 9.24972C42.6667 9.29395 43.1399 9.40149 43.6321 9.52199C43.6131 9.52756 43.5942 9.53313 43.5752 9.53871C43.5752 9.53871 43.1793 10.1879 43.0186 10.5272C43.0186 10.5272 42.2987 10.8315 42.254 11.2745C41.7803 11.5743 40.4025 12.0517 41.0707 12.7394C41.3356 12.8774 41.4273 13.2062 41.732 12.8431C41.7459 12.8534 41.7686 12.859 41.7849 12.8768C42.0543 12.4768 42.7334 12.4476 43.0873 12.1193L43.1012 12.1049C43.2455 11.7416 43.7002 11.5462 43.7027 11.5475C43.9984 11.3001 44.3496 11.0446 44.7185 10.7797C44.693 11.0135 44.6864 11.2292 44.7051 11.3965C44.8434 11.87 42.4676 16.1166 44.0838 15.748C44.4546 14.9068 44.6288 13.9198 45.2228 13.309C45.3579 13.3084 45.347 12.9352 45.3386 12.6313C45.5043 12.3378 45.6509 12.2103 45.8912 11.792C46.2451 12.4674 47.6485 15.6843 48.1854 14.2903C47.9952 14.0213 47.8857 13.7698 47.9114 13.3879C47.8548 13.1886 47.056 12.0066 47.0991 11.8376C47.2811 11.6669 46.054 10.8145 46.6673 10.9364C46.6751 10.7305 46.6514 10.5174 46.6075 10.3C47.2131 10.5413 47.9866 10.7374 48.4575 10.7141C48.5749 10.6425 50.9442 11.6976 52.0463 11.6139C52.6837 11.6032 53.1923 11.6983 52.8864 11.0233C52.6238 11.0717 52.0312 10.4975 51.9464 10.6973C51.8103 10.5399 50.427 10.3628 50.3363 10.2229C50.3239 10.0929 49.1423 10.1321 49.3774 9.94569C48.8339 9.44336 47.9885 9.18209 47.0838 8.96089C47.6547 8.64071 48.3281 8.11144 48.5925 7.70256C49.1522 7.29314 50.5064 6.44839 51.1257 5.81989C51.7371 5.44667 51.6463 5.34382 51.3781 4.84896L51.3743 4.83772C51.3176 4.73717 51.3844 4.84299 51.0652 4.66131C51.0829 4.70754 51.065 4.85881 51.1395 4.8698C51.0523 4.93247 50.4945 4.79633 50.6419 5.01826C50.6407 5.0392 50.1937 5.109 50.0268 5.34938C49.2609 6.11767 48.3305 6.22279 47.2755 7.00416C47.3451 6.90143 47.559 4.39732 48.1333 3.39336C48.4596 2.92101 47.5803 1.50565 47.1773 2.72859C47.1597 2.72556 47.1369 2.73843 47.113 2.72903C47.0757 3.2994 46.5565 3.63728 46.4169 4.16369L46.4119 4.18574C46.4922 4.59194 46.1032 4.69197 46.3451 5.11439C46.3451 5.11439 46.2278 5.03786 46.2265 5.03412C46.04 5.78618 45.7158 6.65485 45.4863 7.4648C45.1906 6.7086 44.9795 5.95015 45.075 5.28657L45.0308 5.30982C45.0397 5.29282 45.0082 5.261 45.0612 5.23922C44.6526 4.90904 44.5924 4.64294 44.3264 4.3469C44.3264 4.3469 44.2933 3.54841 43.8935 3.31232L43.7119 2.13385C43.671 1.5536 42.0836 1.04786 42.5619 2.19251L42.5669 2.2075Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M56.2986 51.5129C57.3201 51.4258 70.9872 48.1615 67.4022 47.4532C66.0723 47.8212 65.0389 47.4493 64.3739 48.4464C64.1817 47.2712 61.574 49.1468 61.1735 49.218C60.9932 48.3277 56.9075 50.6187 57.5043 49.7917C55.6497 49.8154 53.3465 50.4564 50.9512 51.2082C49.7775 50.4208 54.8086 44.8022 52.6936 46.0169C52.8418 45.7004 53.4106 44.3313 53.3345 45.2374C54.0034 44.4619 61.2856 32.5916 58.2574 34.6016C56.2145 37.0509 54.6804 41.1541 52.95 43.1799C51.2676 43.8645 50.102 49.7442 48.2274 49.1586C47.1338 47.8371 44.3139 31.6538 42.3111 33.0901C42.6596 34.3484 42.3431 35.4761 43.3165 36.0814C42.1268 36.2714 44.0255 38.8472 44.0976 39.2429C43.2164 39.4091 45.4996 43.4609 44.6784 42.8673C44.6944 44.0108 44.9548 45.3324 45.3313 46.7371C44.8306 46.3612 44.2819 45.5025 43.9654 45.3759C40.5927 44.0267 38.0371 40.9245 34.5242 39.2429C31.5721 42.9583 57.6766 52.3319 41.49 53.7326C38.4457 55.6952 34.4 55.9959 31.0033 57.8833C30.7109 61.9706 50.0739 50.6939 44.4861 57.1711C43.6169 59.9092 42.3271 62.9836 40.5446 65.6821C39.407 75.9737 49.0806 48.0151 48.68 58.6826C50.0139 61.2307 51.3037 64.3012 51.9646 67.4627C56.6952 74.3158 50.2382 56.1859 49.5612 53.6179C52.1248 52.5377 62.0347 64.7879 63.8292 62.857C63.9133 62.584 62.4873 61.0685 62.0547 60.9063C61.7623 61.0527 61.6141 61.1714 61.4418 60.9023C62.3111 60.0753 59.2628 59.0308 58.9744 58.7459C59.6153 58.1168 55.3734 56.0711 56.4028 56.1027C55.6097 55.0067 54.396 53.9028 53.0141 52.7909C55.4655 52.324 56.531 50.6147 56.3067 51.505L56.2986 51.5129Z",
                fill: "#101214"
            })
        ]
    });

});



parcelRegister("7MDGJ", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("kvQDr")).then(()=>parcelRequire("4tKz6"));

});

parcelRegister("1prlM", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("dNW3u")).then(()=>parcelRequire("amJzI"));

});

parcelRegister("kHmPt", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("kI20X")).then(()=>parcelRequire("gnTdH"));

});

parcelRegister("ccuey", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("6Yjdx")).then(()=>parcelRequire("4YuhO"));

});

parcelRegister("11aRP", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("cbHYr")).then(()=>parcelRequire("cplh3"));

});




parcelRegister("bmKvu", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSoftwarePageVariantAnchorLpConfCollaboration", function () { return $ba7a3730bd826271$export$bef8c54fab70371e; });
// @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $cLLBP = parcelRequire("cLLBP");

var $lpiK5 = parcelRequire("lpiK5");

var $bCSEP = parcelRequire("bCSEP");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("7DAJg");
var $eVoOD = parcelRequire("eVoOD");

var $cBkUf = parcelRequire("cBkUf");

var $aR9rM = parcelRequire("aR9rM");
const $ba7a3730bd826271$export$bef8c54fab70371e = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $iSvIT.useEffect)(()=>{
        if ((0, $aR9rM.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cLLBP.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Collaboration.get-on-the-same-page.title",
                defaultMessage: "Get on the same page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Collaboration.get-on-the-same-page.body",
                defaultMessage: "Plan projects, take notes, and brainstorm \u2013 all in one place."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Collaboration.collaborate-live-across-time-zones.title",
                defaultMessage: "Collaborate live across time zones"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Collaboration.collaborate-live-across-time-zones.body",
                defaultMessage: "Move work forward with real-time editing and inline comments."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp",
            imgAltText: "A Confluence page with multiple teammates editing and leaving comments"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Collaboration.find-what-you-need.title",
                defaultMessage: "Find what you need"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Collaboration.find-what-you-need.body",
                defaultMessage: "Stay organized in dedicated workspaces, equipped with AI-powered search."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": intl.formatMessage((0, $eVoOD.carouselHeroMessages).ariaLabel),
        "id": "confluence-collaboration-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-collaboration";
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lpiK5.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: "confluence"
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bCSEP.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "cfind-3090-paid-confluence-product-tour",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cBkUf.ConfluencePagePaidLpConflAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
            pageId: pageId,
            persona: "unknown",
            pageVariant: "brandUpdate",
            dataProductKey: "confluence-AnchorLpConfCollaboration",
            keyword: pageProps.keyword,
            carouselHeroProps: carouselHeroProps,
            customHeroSection: customHeroSection
        }))
    });
};

});
parcelRegister("7DAJg", function(module, exports) {
$parcel$export(module.exports, "carouselHeroMessages", function () { return (parcelRequire("eVoOD")).carouselHeroMessages; });
parcelRequire("eVoOD");

});
parcelRegister("eVoOD", function(module, exports) {

$parcel$export(module.exports, "carouselHeroMessages", function () { return $8d7db556946c4e34$export$556302becf693fc2; });

var $6x1qA = parcelRequire("6x1qA");
const $8d7db556946c4e34$export$556302becf693fc2 = (0, $6x1qA.defineMessages)({
    ariaLabel: {
        id: "ConfluenceSoftwarePage.v4.CarouselHero.AriaLabel",
        defaultMessage: "A display of various confluence features",
        description: "Aria label for the carousel section"
    }
});

});



parcelRegister("bYVXE", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorCompetitors", function () { return $2aa4c33c47f6bd67$export$97018adfbdd04630; });
// @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $cLLBP = parcelRequire("cLLBP");

var $lpiK5 = parcelRequire("lpiK5");

var $bCSEP = parcelRequire("bCSEP");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("7DAJg");
var $eVoOD = parcelRequire("eVoOD");

var $cBkUf = parcelRequire("cBkUf");

var $aR9rM = parcelRequire("aR9rM");
const $2aa4c33c47f6bd67$export$97018adfbdd04630 = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $iSvIT.useEffect)(()=>{
        if ((0, $aR9rM.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cLLBP.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Competitors.achieve-team-goals-together.title",
                defaultMessage: "Achieve team goals together"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Competitors.achieve-team-goals-together.body",
                defaultMessage: "Plan projects, take notes, and brainstorm. Let AI write your first draft."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Competitors.get-everyone-on-the-same-page.title",
                defaultMessage: "Get everyone on the same page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Competitors.get-everyone-on-the-same-page.body",
                defaultMessage: "Collaborate with your teams using real-time editing and inline comments."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp",
            imgAltText: "A Confluence page with multiple teammates editing and leaving comments"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Competitors.connect-teams-content-context.title",
                defaultMessage: "Connect teams, content, and context"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Competitors.connect-teams-content-context.body",
                defaultMessage: "Stay organized in dedicated workspaces, equipped with AI-powered search."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": intl.formatMessage((0, $eVoOD.carouselHeroMessages).ariaLabel),
        "id": "confluence-competitors-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-competitors";
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lpiK5.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: "confluence"
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bCSEP.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "cfind-3090-paid-confluence-product-tour",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cBkUf.ConfluencePagePaidLpConflAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
            pageId: pageId,
            persona: "unknown",
            pageVariant: "brandUpdate",
            dataProductKey: "confluence-PaidLpConflCompetitors",
            keyword: pageProps.keyword,
            carouselHeroProps: carouselHeroProps,
            customHeroSection: customHeroSection
        }))
    });
};

});

parcelRegister("3hOaF", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorCustomerService", function () { return $14033f026504c14e$export$dee2b0bf0794eecf; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $cLLBP = parcelRequire("cLLBP");

var $bCSEP = parcelRequire("bCSEP");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("7DAJg");
var $eVoOD = parcelRequire("eVoOD");

var $cBkUf = parcelRequire("cBkUf");

var $aR9rM = parcelRequire("aR9rM");
const $14033f026504c14e$export$dee2b0bf0794eecf = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $iSvIT.useEffect)(()=>{
        if ((0, $aR9rM.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cLLBP.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    // TODO: add missing images
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.CustomerService.dynamic-documentation.title",
                defaultMessage: "Dynamic documentation"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.CustomerService.dynamic-documentation.body",
                defaultMessage: "Brainstorm ideas and workflows, document best practices, and share knowledge\u2014all in one place."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.CustomerService.scale-practices.title",
                defaultMessage: "Scale best practices across your org"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.CustomerService.scale-practices.body",
                defaultMessage: "Boost productivity by using Automation to coordinate workflows, prompting next steps when a dependency is completed."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/k2it51f6l70x62mw505kfe305m744wnv.webp",
            imgAltText: "A Confluence automation rule"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.CustomerService.connect-your-work.title",
                defaultMessage: "Centralize and connect all your work"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.CustomerService.connect-your-work.body",
                defaultMessage: "Keep FAQs and commonly referenced documentation organized and easily findable in dedicated workspaces."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/23124865qxudxy6cj8rl3g6my5h472d7.webp",
            imgAltText: "Organized Customer Success Hub in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": intl.formatMessage((0, $eVoOD.carouselHeroMessages).ariaLabel),
        "id": "confluence-customer-service-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-team-customerservice";
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bCSEP.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cBkUf.ConfluencePagePaidLpConflAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        pageId: pageId,
        persona: "unknown",
        pageVariant: "customerService",
        dataProductKey: "confluence-AnchorLpConfCustomerService",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection
    }));
};

});

parcelRegister("dP45N", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorDesign", function () { return $0f7fda858a53a626$export$e823aa878f5ce57e; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $cLLBP = parcelRequire("cLLBP");

var $bCSEP = parcelRequire("bCSEP");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("7DAJg");
var $eVoOD = parcelRequire("eVoOD");

var $cBkUf = parcelRequire("cBkUf");

var $aR9rM = parcelRequire("aR9rM");
const $0f7fda858a53a626$export$e823aa878f5ce57e = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $iSvIT.useEffect)(()=>{
        if ((0, $aR9rM.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cLLBP.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Design.dynamic-documentation.title",
                defaultMessage: "Dynamic documentation"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Design.dynamic-documentation.body",
                defaultMessage: "Brainstorm ideas, document design guidelines, and take notes\u2014all in one place."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Design.same-page.title",
                defaultMessage: "Get everyone on the same page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Design.same-page.body",
                defaultMessage: "Collaborate with cross-functional teams using real-time editing and inline comments."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp",
            imgAltText: "A Confluence page with multiple teammates editing and leaving comments"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Design.context-designers-need.title",
                defaultMessage: "The context designers need"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Design.context-designers-need.body",
                defaultMessage: "Stay organized with dedicated team workspaces, all equipped with AI-powered search."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": intl.formatMessage((0, $eVoOD.carouselHeroMessages).ariaLabel),
        "id": "confluence-design-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-team-design";
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bCSEP.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cBkUf.ConfluencePagePaidLpConflAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        pageId: pageId,
        persona: "unknown",
        pageVariant: "design",
        dataProductKey: "confluence-AnchorLpConfDesign",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection
    }));
};

});

parcelRegister("l9dqv", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorEngineering", function () { return $951a4fced4b6265f$export$e45207782b7349c7; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $cLLBP = parcelRequire("cLLBP");

var $bCSEP = parcelRequire("bCSEP");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("7DAJg");
var $eVoOD = parcelRequire("eVoOD");

var $cBkUf = parcelRequire("cBkUf");

var $aR9rM = parcelRequire("aR9rM");
const $951a4fced4b6265f$export$e45207782b7349c7 = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $iSvIT.useEffect)(()=>{
        if ((0, $aR9rM.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cLLBP.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const pageId = "anchor-lp-conf-team-engineering";
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bCSEP.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Engineering.dynamic-documentation.title",
                defaultMessage: "Dynamic documentation"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Engineering.dynamic-documentation.body",
                defaultMessage: "Brainstorm workflows, plan sprints, and take release notes\u2014all in one place."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/0du4h6u1u85gdfw51btwg1w486m05ehy.webp",
            imgAltText: "A Confluence page with advanced roadmap integration"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Engineering.get-everyone-on-the-same-page.title",
                defaultMessage: "Get everyone on the same page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Engineering.get-everyone-on-the-same-page.body",
                defaultMessage: "Collaborate with cross-functional teams using real-time editing and inline comments."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/b2d5d0n6c3585bx8t07l0kmlsd36648q.webp",
            imgAltText: "A Confluence page with multiple teammates editing and leaving comments"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Engineering.the-context-software-developers-need.title",
                defaultMessage: "The context software developers need"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Engineering.the-context-software-developers-need.body",
                defaultMessage: "Stay organized with dedicated team workspaces, all equipped with AI-powered search."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/21k4hektb512gekkj3ibm325ahan4vrh.webp",
            imgAltText: "A Confluence page titled Project Hub"
        }
    ];
    const carouselHeroProps = {
        "aria-label": intl.formatMessage((0, $eVoOD.carouselHeroMessages).ariaLabel),
        "id": "confluence-engineering-carousel",
        "slides": carouselSlides
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cBkUf.ConfluencePagePaidLpConflAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        pageId: pageId,
        persona: "unknown",
        pageVariant: "engineering",
        dataProductKey: "confluence-PaidLpConflEngineering",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection,
        teamType: ""
    }));
};

});

parcelRegister("jZQGv", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorHr", function () { return $62900223d9c179e2$export$d807d62fc3dbe5f7; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $cLLBP = parcelRequire("cLLBP");

var $bCSEP = parcelRequire("bCSEP");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("7DAJg");
var $eVoOD = parcelRequire("eVoOD");

var $cBkUf = parcelRequire("cBkUf");

var $aR9rM = parcelRequire("aR9rM");
const $62900223d9c179e2$export$d807d62fc3dbe5f7 = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $iSvIT.useEffect)(()=>{
        if ((0, $aR9rM.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cLLBP.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Hr.source-of-truth.title",
                defaultMessage: "A single source of truth"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Hr.source-of-truth.body",
                defaultMessage: "Confluence brings together recruiting, onboarding, and employee development\u2014all in one place."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/6ow1y2k84sc71x364sfir34k2fu2k4o8.webp",
            imgAltText: "Organized HR Hub in Confluence"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Hr.scale-practices.title",
                defaultMessage: "Scale best practices across your org"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Hr.scale-practices.body",
                defaultMessage: "Boost productivity by using Automation to coordinate workflows, prompting next steps when a dependency is completed."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1d4ro6h610bxw33m1v70c0ik55110tmg.webp",
            imgAltText: "A Confluence automation rule"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Hr.simplify-workflows.title",
                defaultMessage: "Simplify HR workflows"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Hr.simplify-workflows.body",
                defaultMessage: "Brainstorm ideas for employee engagement, coordinate training, and share announcements with the entire org."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/g46gcy7jab7kyu00487ys6bkiv0e7a1f.webp",
            imgAltText: "Ideas on Confluence Sticky Notes"
        }
    ];
    const carouselHeroProps = {
        "aria-label": intl.formatMessage((0, $eVoOD.carouselHeroMessages).ariaLabel),
        "id": "confluence-hr-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-team-hr";
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bCSEP.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cBkUf.ConfluencePagePaidLpConflAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        pageId: pageId,
        persona: "unknown",
        pageVariant: "hr",
        dataProductKey: "confluence-AnchorLpConfHr",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection
    }));
};

});

parcelRegister("d7VZR", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorLegal", function () { return $3529aa261627e9e1$export$b53560d6986ee58d; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $cLLBP = parcelRequire("cLLBP");

var $bCSEP = parcelRequire("bCSEP");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("7DAJg");
var $eVoOD = parcelRequire("eVoOD");

var $cBkUf = parcelRequire("cBkUf");

var $aR9rM = parcelRequire("aR9rM");
const $3529aa261627e9e1$export$b53560d6986ee58d = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $iSvIT.useEffect)(()=>{
        if ((0, $aR9rM.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cLLBP.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bCSEP.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Legal.dynamic-documentation.title",
                defaultMessage: "Dynamic Documentation"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Legal.dynamic-documentation.body",
                defaultMessage: "Brainstorm on whiteboards, draft pages, and record video messages. Customize documentation to suit your clients' and team's needs."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Legal.same-page.title",
                defaultMessage: "Get on the same page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Legal.same-page.body",
                defaultMessage: "Collaborate with your team using real-time editing and inline comments. Easily manage permissions so only the right people have access to information."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp",
            imgAltText: "A Confluence page with multiple teammates editing and leaving comments"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Legal.centralize-work.title",
                defaultMessage: "Centralize and connect all your work"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Legal.centralize-work.body",
                defaultMessage: "Keep commonly used legal forms, decision registers, and meeting notes organized in dedicated workspaces."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/prhqp320pa2f46636madbq6hv2kuff62.webp",
            imgAltText: "Organized Legal Hub in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": intl.formatMessage((0, $eVoOD.carouselHeroMessages).ariaLabel),
        "id": "confluence-legal-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-team-legal";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cBkUf.ConfluencePagePaidLpConflAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        pageId: pageId,
        persona: "unknown",
        pageVariant: "legal",
        dataProductKey: "confluence-AnchorLpConfLegal",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection
    }));
};

});

parcelRegister("dIAEL", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorMarketing", function () { return $aa93168f007926d4$export$11286c25bf03cb0c; });
// @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $cLLBP = parcelRequire("cLLBP");

var $bCSEP = parcelRequire("bCSEP");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("7DAJg");
var $eVoOD = parcelRequire("eVoOD");

var $cBkUf = parcelRequire("cBkUf");

var $aR9rM = parcelRequire("aR9rM");
const $aa93168f007926d4$export$11286c25bf03cb0c = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $iSvIT.useEffect)(()=>{
        if ((0, $aR9rM.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cLLBP.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.marketing-goals.title",
                defaultMessage: "Achieve marketing goals together"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.marketing-goals.body",
                defaultMessage: "Plan campaigns, take notes, and brainstorm. Let AI write your first draft."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.same-page.title",
                defaultMessage: "Get everyone on the same page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.same-page.body",
                defaultMessage: "Collaborate with cross-functional teams using real-time editing and inline comments."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp",
            imgAltText: "A Confluence page with multiple teammates editing and leaving comments"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.marketing-deadlines.title",
                defaultMessage: "Hit marketing launch deadlines"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.marketing-deadlines.body",
                defaultMessage: "Stay organized with dedicated marketing workspaces equipped with AI-powered search."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": intl.formatMessage((0, $eVoOD.carouselHeroMessages).ariaLabel),
        "id": "confluence-marketing-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-team-marketing";
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bCSEP.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cBkUf.ConfluencePagePaidLpConflAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        pageId: pageId,
        // TODO: replace with pageProps.persona when all personas are added
        persona: "unknown",
        pageVariant: "marketing",
        dataProductKey: "confluence-AnchorLpConfMarketing",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection
    }));
};

});

parcelRegister("aQuME", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorOperations", function () { return $1dd1e47e8cb4e9ca$export$75eaa13c52290701; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $cLLBP = parcelRequire("cLLBP");

var $bCSEP = parcelRequire("bCSEP");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("7DAJg");
var $eVoOD = parcelRequire("eVoOD");

var $cBkUf = parcelRequire("cBkUf");

var $aR9rM = parcelRequire("aR9rM");
const $1dd1e47e8cb4e9ca$export$75eaa13c52290701 = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $iSvIT.useEffect)(()=>{
        if ((0, $aR9rM.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cLLBP.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Operations.dynamic-documentation.title",
                defaultMessage: "Dynamic documentation"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Operations.dynamic-documentation.body",
                defaultMessage: "Brainstorm more efficient workflows, manage resources, and share knowledge\u2014all in one place."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Operations.streamline-processes.title",
                defaultMessage: "Streamline processes and team efficiency"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Operations.streamline-processes.body",
                defaultMessage: "Boost productivity by using Automation to coordinate workflows, prompting next steps when a dependency is completed."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/n5g67a5u6744u0183v1em5q6rjc4oer5.webp",
            imgAltText: "A Confluence automation rule"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Operations.same-page.title",
                defaultMessage: "Get everyone on the same page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Operations.same-page.body",
                defaultMessage: "Keep teams organized with dedicated workspaces, all equipped with AI-powered search."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": intl.formatMessage((0, $eVoOD.carouselHeroMessages).ariaLabel),
        "id": "confluence-operations-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-team-operations";
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bCSEP.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cBkUf.ConfluencePagePaidLpConflAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        pageId: pageId,
        persona: "unknown",
        pageVariant: "operations",
        dataProductKey: "confluence-AnchorLpConfOperations",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection
    }));
};

});

parcelRegister("kGjia", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorProgramMgmt", function () { return $ce150ca241987a6d$export$7f35a3c71359f12a; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $cLLBP = parcelRequire("cLLBP");

var $bCSEP = parcelRequire("bCSEP");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("7DAJg");
var $eVoOD = parcelRequire("eVoOD");

var $cBkUf = parcelRequire("cBkUf");

var $aR9rM = parcelRequire("aR9rM");
const $ce150ca241987a6d$export$7f35a3c71359f12a = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $iSvIT.useEffect)(()=>{
        if ((0, $aR9rM.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cLLBP.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    // TODO: add missing images
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.ProgramMgmt.project-goals.title",
                defaultMessage: "Achieve project goals together"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.ProgramMgmt.project-goals.body",
                defaultMessage: "Brainstorm ideas, plan projects, take notes, and share knowledge\u2014all in one place."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.ProgramMgmt.team-efficiency.title",
                defaultMessage: "Streamline processes and team efficiency"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.ProgramMgmt.team-efficiency.body",
                defaultMessage: "Boost productivity by using Automation to coordinate workflows, prompting next steps when a dependency is completed."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/3rpsu66gd78285buk60k1t08w568ds37.webp",
            imgAltText: "A Confluence automation rule"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.ProgramMgmt.project-deadlines.title",
                defaultMessage: "Hit project deadlines"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.ProgramMgmt.project-deadlines.body",
                defaultMessage: "Keep teams organized with dedicated workspaces, equipped with AI-powered search."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": intl.formatMessage((0, $eVoOD.carouselHeroMessages).ariaLabel),
        "id": "confluence-program-management-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-team-programmgmt";
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bCSEP.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cBkUf.ConfluencePagePaidLpConflAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        pageId: pageId,
        persona: "unknown",
        pageVariant: "programMgmt",
        dataProductKey: "confluence-AnchorLpConfProgramMgmt",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection
    }));
};

});

parcelRegister("iPHuy", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorTeamwork", function () { return $800e3b2c1dd12397$export$c24154344f2ebeeb; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $cLLBP = parcelRequire("cLLBP");

var $lpiK5 = parcelRequire("lpiK5");

var $bCSEP = parcelRequire("bCSEP");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("7DAJg");
var $eVoOD = parcelRequire("eVoOD");

var $cBkUf = parcelRequire("cBkUf");

var $aR9rM = parcelRequire("aR9rM");
const $800e3b2c1dd12397$export$c24154344f2ebeeb = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $iSvIT.useEffect)(()=>{
        if ((0, $aR9rM.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cLLBP.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Teamwork.get-everyone-on-the-same-page.title",
                defaultMessage: "Get everyone on the same page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Teamwork.get-everyone-on-the-same-page.body",
                defaultMessage: "Plan projects, take notes, and brainstorm. Let AI write your first draft."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Teamwork.bring-teams-together.title",
                defaultMessage: "Bring teams together"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Teamwork.bring-teams-together.body",
                defaultMessage: "Invite your teams to collaborate using real-time editing and inline comments."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp",
            imgAltText: "A Confluence page with multiple teammates editing and leaving comments"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Teamwork.centralize-the-teams-work.title",
                defaultMessage: "Centralize the team\u2019s work"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Teamwork.centralize-the-teams-work.body",
                defaultMessage: "Stay organized and up-to-date with dedicated team workspaces."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": intl.formatMessage((0, $eVoOD.carouselHeroMessages).ariaLabel),
        "id": "confluence-teamwork-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-teamwork";
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lpiK5.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: "confluence"
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bCSEP.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "cfind-3090-paid-confluence-product-tour",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cBkUf.ConfluencePagePaidLpConflAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
            pageId: pageId,
            persona: "unknown",
            pageVariant: "brandUpdate",
            dataProductKey: "confluence-AnchorLpConfTeamwork",
            keyword: pageProps.keyword,
            carouselHeroProps: carouselHeroProps,
            customHeroSection: customHeroSection
        }))
    });
};

});

parcelRegister("29ctt", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorWorkManagement", function () { return $870de23f34c2b5fb$export$9fca2d06de428e79; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $cLLBP = parcelRequire("cLLBP");

var $lpiK5 = parcelRequire("lpiK5");

var $bCSEP = parcelRequire("bCSEP");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");

var $cBkUf = parcelRequire("cBkUf");

var $aR9rM = parcelRequire("aR9rM");
const $870de23f34c2b5fb$export$9fca2d06de428e79 = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $iSvIT.useEffect)(()=>{
        if ((0, $aR9rM.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cLLBP.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.WorkManagement.move-work-forward.title",
                defaultMessage: "Move work forward"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.WorkManagement.move-work-forward.body",
                defaultMessage: "Plan projects, take notes, and brainstorm \u2014 all in one place."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.WorkManagement.work-better-together.title",
                defaultMessage: "Work better, together"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.WorkManagement.work-better-together.body",
                defaultMessage: "Collaborate with your teams with real-time editing and inline comments."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp",
            imgAltText: "A Confluence page with multiple teammates editing and leaving comments"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.WorkManagement.connect-all-your-work.title",
                defaultMessage: "Connect all your work"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.WorkManagement.connect-all-your-work.body",
                defaultMessage: "Stay organized and up-to-date with dedicated team workspaces."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": "A display of various confluence features",
        "id": "confluence-work-management-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-work-management";
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lpiK5.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: "confluence"
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bCSEP.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "cfind-3090-paid-confluence-product-tour",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cBkUf.ConfluencePagePaidLpConflAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
            pageId: pageId,
            persona: "unknown",
            pageVariant: "brandUpdate",
            dataProductKey: "confluence-PaidLpConfWorkManagementAutomation",
            keyword: pageProps.keyword,
            carouselHeroProps: carouselHeroProps,
            customHeroSection: customHeroSection
        }))
    });
};

});

parcelRegister("dUMGS", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSoftwarePageVariantPaidLpConfFeatures", function () { return $4ba37ca03424023a$export$8f2e6fd6be55a708; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $cLLBP = parcelRequire("cLLBP");

var $5ohHq = parcelRequire("5ohHq");

var $dHeH7 = parcelRequire("dHeH7");
parcelRequire("D0EyQ");
var $g8Gdb = parcelRequire("g8Gdb");

var $lpiK5 = parcelRequire("lpiK5");

var $1k2D1 = parcelRequire("1k2D1");

var $bCSEP = parcelRequire("bCSEP");

var $6JN6z = parcelRequire("6JN6z");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");

var $aR9rM = parcelRequire("aR9rM");
const $4ba37ca03424023a$export$8f2e6fd6be55a708 = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $iSvIT.useEffect)(()=>{
        if ((0, $aR9rM.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cLLBP.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselLiftAndShift = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.start-with-page.title",
                defaultMessage: "Start with a page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.start-with-page.body",
                defaultMessage: "Plan projects, take notes, and brainstorm. Let AI write your first draft."
            }),
            // will fix in separate ticket GWP-4659
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/cs8c8dbwh841g64nad3y8o63fo6peqkv.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.share-with-teams.title",
                defaultMessage: "Share with your teams"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.share-with-teams.body",
                defaultMessage: "Invite your teams to collaborate using real-time editing and inline comments."
            }),
            // will fix in separate ticket GWP-4659
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/63i2v45spmjd7q66mqefep624mf6y20h.webp",
            imgAltText: "A Confluence page with multiple teammates editing and leaving comments"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.connect-work.title",
                defaultMessage: "Connect all your work"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.connect-work.body",
                defaultMessage: "Stay organized in dedicated workspaces, equipped with AI-powered search."
            }),
            // will fix in separate ticket GWP-4659
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/o47q33qpw6cp3211df81a3noi34e41ib.webp",
            imgAltText: "A Confluence page with a summary being generated by Atlassian Intelligence"
        }
    ];
    const showDefault = !shouldShowLogMeIn;
    let customHeroSection = /*#__PURE__*/ (0, $loA2J.jsx)((0, $lpiK5.PaidHeroCarousel), {
        pageId: showDefault ? "confluence-default" : "paid-lp-conf-features",
        embeddedSignup: {
            bundle: "confluence"
        },
        carouselSlides: carouselLiftAndShift,
        keyword: pageProps.keyword
    });
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bCSEP.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    const props = {
        customHeroSection: customHeroSection,
        heroProps: {
            headerText: intl.formatMessage({
                id: "ConfluenceSoftwarePagePaidLpConfFeatures.heroHeader",
                defaultMessage: "Accomplish more together with Confluence"
            }),
            secondaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePagePaidLpConfFeatures.heroBody",
                defaultMessage: "So many features, so little time \u2014 all built to meet your team\u2019s needs"
            }),
            featuresLabel: intl.formatMessage({
                id: "ConfluenceSoftwarePagePaidLpConfFeatures.heroListHeading",
                defaultMessage: "What you get on the free plan:"
            }),
            featuresList: [
                intl.formatMessage({
                    id: "ConfluenceSoftwarePagePaidLpConfFeatures.heroListItem1",
                    defaultMessage: "Supports up to 10 users or 3 agents"
                }),
                intl.formatMessage({
                    id: "ConfluenceSoftwarePagePaidLpConfFeatures.heroListItem2",
                    defaultMessage: "Includes 2 GB of storage"
                }),
                intl.formatMessage({
                    id: "ConfluenceSoftwarePagePaidLpConfFeatures.heroListItem3",
                    defaultMessage: "Offers Community support"
                }),
                intl.formatMessage({
                    id: "ConfluenceSoftwarePagePaidLpConfFeatures.heroListItem4",
                    defaultMessage: "Is always free, no credit card needed"
                })
            ],
            signup: {
                bundle: "confluence",
                edition: "free"
            }
        },
        tabsProps: {
            dataProductKey: "confluence-PaidLpConflFeatures",
            headerText: intl.formatMessage({
                id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsHeader",
                defaultMessage: "Jump start company-wide collaboration with fewer tools by using Confluence."
            }),
            tabStyles: {
                // eslint-disable-next-line local/ensure-wac-token-usage
                defaultBG: "#ebecf0",
                // eslint-disable-next-line local/ensure-wac-token-usage
                defaultText: "#42526e",
                // eslint-disable-next-line local/ensure-wac-token-usage
                activeBG: "#0747a6",
                activeText: (0, $5ohHq.wacToken)("color.neutral.light0"),
                // eslint-disable-next-line local/ensure-wac-token-usage
                hoverBG: "#ebecf0",
                // eslint-disable-next-line local/ensure-wac-token-usage
                hoverText: "#42526e"
            },
            styles: {
                "--lp-tabs-hover": "#c1c7d0",
                "--lp-tabs-unselected": "#6b778c"
            },
            tabs: [
                {
                    textLabel: intl.formatMessage({
                        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.pill.documentation",
                        defaultMessage: "Documentation"
                    }),
                    id: "tab-documentation",
                    component: $4ba37ca03424023a$var$Documentation()
                },
                {
                    textLabel: intl.formatMessage({
                        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.pill.collaboration",
                        defaultMessage: "Collaboration"
                    }),
                    id: "tab-collaboration",
                    component: $4ba37ca03424023a$var$Collaboration()
                },
                {
                    textLabel: intl.formatMessage({
                        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.pill.truth",
                        defaultMessage: "Single source of truth"
                    }),
                    id: "tab-truth",
                    component: $4ba37ca03424023a$var$Truth()
                },
                {
                    textLabel: intl.formatMessage({
                        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.pill.templates",
                        defaultMessage: "Templates"
                    }),
                    id: "tab-templates",
                    component: $4ba37ca03424023a$var$Templates()
                }
            ]
        },
        keyword: pageProps.keyword,
        subAnchor: pageProps.subAnchor
    };
    if (showDefault) props.testimonialProps = undefined;
    const gwpAJContextualBanditsConfExperiment = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).gwpAJContextualBanditsConfluence);
    const isExperimentEnabled = gwpAJContextualBanditsConfExperiment.type === "enrolled" && gwpAJContextualBanditsConfExperiment.value;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6JN6z.BanditsProvider), {
        product: "confluence",
        isExperimentEnabled: isExperimentEnabled,
        keyword: pageProps.keyword,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1k2D1.PaidLandingConfTemplate), (0, $7Knp0._)({}, props))
    });
};
/* Tabs */ const $4ba37ca03424023a$var$Documentation = ()=>{
    const intl = (0, $f6qj2.default)();
    const title = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsHeader.documentation",
        defaultMessage: "Create better documentation for your teams"
    });
    const listItems = [
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.documentation.listItem1",
            defaultMessage: "Organize pages, attachments, and even spaces with keyword labels \u2014 such as meeting type or project name."
        }, "listItem1"),
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.documentation.listItem2",
            defaultMessage: "Use the advanced search & page tree to quickly find and label key docs in a well-organized page tree."
        }, "listItem2"),
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.documentation.listItem3",
            defaultMessage: "Use the Table of Contents macro to help colleagues quickly locate information."
        }, "listItem3")
    ];
    const imageSrc = (0, $dHeH7.getLocalizedImage)("documentation", intl.locale);
    const imageAlt = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsImageAltText.documentation",
        defaultMessage: "Documentation"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g8Gdb.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $4ba37ca03424023a$var$Collaboration = ()=>{
    const intl = (0, $f6qj2.default)();
    const title = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsHeader.collaboration",
        defaultMessage: "Collaborate with teams in real-time"
    });
    const listItems = [
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.collaboration.listItem1",
            defaultMessage: "Co-edit together in real time and publish updates that highlight changes."
        }, "listItem1"),
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.collaboration.listItem2",
            defaultMessage: "Make it a \u201Cteam effort\u201D with in-line and page comments, likes, and visual elements, such as images, GIFs, and emojis."
        }, "listItem2"),
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.collaboration.listItem3",
            defaultMessage: "Alert your teammates when you tag them or assign a task so everyone stays on top of progress."
        }, "listItem3")
    ];
    const imageSrc = (0, $dHeH7.getLocalizedImage)("collaboration", intl.locale);
    const imageAlt = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsImageAltText.collaboration",
        defaultMessage: "Project collaboration"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g8Gdb.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $4ba37ca03424023a$var$Truth = ()=>{
    const intl = (0, $f6qj2.default)();
    const title = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsHeader.truth",
        defaultMessage: "Share information between teams"
    });
    const listItems = [
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.truth.listItem1",
            defaultMessage: "Keep employees informed with open access to information they need, but share and protect sensitive content with permission settings."
        }, "listItem1"),
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.truth.listItem2",
            defaultMessage: "Easily get back to recent spaces, in-progress work, and drafts, and stay updated with activity and popular feeds on your personal \u201Chomepage.\u201D"
        }, "listItem2")
    ];
    const imageSrc = (0, $dHeH7.getLocalizedImage)("truth", intl.locale);
    const imageAlt = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsImageAltText.truth",
        defaultMessage: "Program manager hub"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g8Gdb.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $4ba37ca03424023a$var$Templates = ()=>{
    const intl = (0, $f6qj2.default)();
    const title = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsHeader.templates",
        defaultMessage: "There\u2019s a template for that"
    });
    const listItems = [
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.templates.listItem1",
            defaultMessage: "Use best-practices templates, from product roadmaps to marketing plans so you can quickly jump right in."
        }, "listItem1"),
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.templates.listItem2",
            defaultMessage: "Kickstart the creation stage by spending less time formatting pages and more time getting sh*t done."
        }, "listItem2"),
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.templates.listItem3",
            defaultMessage: "Start with a blank page or choose from over 75 customizable templates for every team\u2013from strategy and planning docs to reports."
        }, "listItem3")
    ];
    const imageSrc = (0, $dHeH7.getLocalizedImage)("templates", intl.locale);
    const imageAlt = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsImageAltText.templates",
        defaultMessage: "Confluence templates"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g8Gdb.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};

});
parcelRegister("dHeH7", function(module, exports) {

$parcel$export(module.exports, "getLocalizedImage", function () { return $bb638855f1b3554e$export$df12673c228208c7; });
// no localized image for es, ru
const $bb638855f1b3554e$var$tabsSectionCollaborationImageMap = {
    de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-02.webp",
    fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-02.webp",
    br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-02.webp",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Collaboration.webp",
    ja: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-02.webp"
};
// no localized image for es, ru
const $bb638855f1b3554e$var$tabsSectionDocumentationImageMap = {
    de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_deDE.webp",
    fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_frFR.webp",
    br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_ptBR.webp",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation.webp",
    ja: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_ja-JP.webp"
};
// no localized image for es, ru
const $bb638855f1b3554e$var$tabsSectionTemplatesImageMap = {
    de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-13.webp",
    fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-13.webp",
    br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-13.webp",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Templates.webp",
    ja: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-13.webp"
};
// no localized image for es, ru
const $bb638855f1b3554e$var$tabsSectionTruthImageMap = {
    de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-11.webp",
    fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-11.webp",
    br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-11.webp",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_SourceOfTruth.webp",
    ja: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-13.webp"
};
// no localized image for es, ru
const $bb638855f1b3554e$var$rowOneImageMap = {
    de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_deDE.webp",
    fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_frFR.webp",
    br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_ptBR.webp",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x.webp",
    ja: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_ja-JP.webp"
};
// no localized image for es, ru
const $bb638855f1b3554e$var$rowTwoImageMap = {
    de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_deDE.webp",
    fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_frFR.webp",
    br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_ptBR.webp",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x.webp",
    ja: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_ja-JP.webp"
};
// no localized image for es, ru
const $bb638855f1b3554e$var$rowThreeImageMap = {
    de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_deDE.webp",
    fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_frFR.webp",
    br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_ptBR.webp",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x.webp",
    ja: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_ja-JP.webp"
};
const $bb638855f1b3554e$var$getCorrespondingImageMap = (descriptor)=>{
    switch(descriptor){
        case "collaboration":
            return $bb638855f1b3554e$var$tabsSectionCollaborationImageMap;
        case "documentation":
            return $bb638855f1b3554e$var$tabsSectionDocumentationImageMap;
        case "row one":
            return $bb638855f1b3554e$var$rowOneImageMap;
        case "row two":
            return $bb638855f1b3554e$var$rowTwoImageMap;
        case "row three":
            return $bb638855f1b3554e$var$rowThreeImageMap;
        case "templates":
            return $bb638855f1b3554e$var$tabsSectionTemplatesImageMap;
        case "truth":
            return $bb638855f1b3554e$var$tabsSectionTruthImageMap;
        default:
            throw new Error(`Unknown descriptor: ${descriptor}`);
    }
};
const $bb638855f1b3554e$export$df12673c228208c7 = (descriptor, locale)=>{
    const map = $bb638855f1b3554e$var$getCorrespondingImageMap(descriptor);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return map[locale] || map["en"];
};

});

parcelRegister("1k2D1", function(module, exports) {

$parcel$export(module.exports, "PaidLandingConfTemplate", function () { return $1f0e306e8b61b121$export$5c32e5cc9dc425db; });
/* eslint-disable local/ensure-wac-token-usage */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");

var $1MbAx = parcelRequire("1MbAx");

var $k4Qty = parcelRequire("k4Qty");

var $dHeH7 = parcelRequire("dHeH7");

var $5KXGt = parcelRequire("5KXGt");

var $3fquc = parcelRequire("3fquc");
const $1f0e306e8b61b121$export$5c32e5cc9dc425db = (props)=>{
    const intl = (0, $f6qj2.default)();
    const userInfo = (0, $5KXGt.useLoggedInUser)();
    const { setAnchorLocalStorage: setAnchorLocalStorage } = (0, $k4Qty.useAnchorLocalStorage)();
    (0, $iSvIT.useEffect)(()=>{
        const { keyword: keyword, subAnchor: subAnchor } = props;
        const anchorLocalStorage = {};
        if (!!keyword) anchorLocalStorage.keyword = keyword;
        if (!!subAnchor) anchorLocalStorage.subAnchor = subAnchor;
        if (Object.keys(anchorLocalStorage).length > 0) setAnchorLocalStorage(anchorLocalStorage);
    }, [
        props.keyword
    ]);
    const embeddedSignup = !userInfo.isUserLoggedIn && !userInfo.requestInProgress ? {
        bundle: "confluence",
        edition: "free",
        useCurrentRedirect: true
    } : undefined;
    (0, $1MbAx.useFeatureExposed)("cfind-1254-paid-embedded-signup-form", "Test", {
        conditions: [
            !!embeddedSignup
        ]
    });
    const finalProps = (0, $6iHNw._)((0, $7Knp0._)({
        landingType: "confluence-paid",
        productNavProps: {
            productHref: (0, $3FBn4.useLocalizedHref)("/software/confluence"),
            productName: "confluence",
            ariaLabel: intl.formatMessage({
                id: "wacConfluenceNavigation.logo-label",
                defaultMessage: "Confluence logo"
            }),
            dataProductKey: "confluence",
            showFreeHrefButton: false
        },
        alternatingTextAndImageProps: {
            backgroundColor: "#e6fcff",
            horizontalRuleColor: "#dfe1e5",
            //Row 1
            rowOneHeader: intl.formatMessage({
                id: "ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowOneHeader",
                defaultMessage: "Move work forward"
            }),
            rowOneBody: intl.formatMessage({
                id: "ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowOneBody",
                defaultMessage: "Kickstart collaboration with a flexible workspace \u2014 from actionable meeting notes to inspiring project plans."
            }),
            rowOneImageLink: (0, $dHeH7.getLocalizedImage)("row one", intl.locale),
            rowOneImageAltText: intl.formatMessage({
                id: "ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowOneImageAltText",
                defaultMessage: "Screenshot of IT template"
            }),
            //Row 2
            rowTwoHeader: intl.formatMessage({
                id: "ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowTwoHeader",
                defaultMessage: "Capture all the knowledge"
            }),
            rowTwoBody: intl.formatMessage({
                id: "ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowTwoBody",
                defaultMessage: "Save everyone time by harnessing your teams' collective knowledge into easy-to-find information."
            }),
            rowTwoImageLink: (0, $dHeH7.getLocalizedImage)("row two", intl.locale),
            rowTwoImageAltText: intl.formatMessage({
                id: "ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowTwoImageAltText",
                defaultMessage: "Screenshot of strategic template in use"
            }),
            //Row 3
            rowThreeHeader: intl.formatMessage({
                id: "ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowThreeHeader",
                defaultMessage: "Inspire conversation & connection"
            }),
            rowThreeBody: intl.formatMessage({
                id: "ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowThreeBody",
                defaultMessage: "Motivate teams company-wide to share announcements, comment, and provide feedback."
            }),
            rowThreeImageLink: (0, $dHeH7.getLocalizedImage)("row three", intl.locale),
            rowThreeImageAltText: intl.formatMessage({
                id: "ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowThreeImageAltText",
                defaultMessage: "Screenshot of IT template"
            })
        },
        ctaProps: {
            headerText: intl.formatMessage({
                id: "ConfluenceSoftwarePage.paidLpConfDefault.ctaSection.title",
                defaultMessage: "Make quick decisions, gain alignment, and transform how your team works together."
            }),
            ctaProps: {
                buttonProps: {
                    color: "yellow",
                    url: "#start-trial",
                    text: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.paidLpConfDefault.ctaSection.button",
                        defaultMessage: "Get it free"
                    }),
                    dataEventProps: {
                        "data-event": "clicked",
                        "data-event-container": "ctaSection",
                        "data-event-component": "linkButton",
                        "data-product-key": "confluence"
                    }
                }
            }
        },
        testimonialProps: {
            headerText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.paidLpConfDefault.customerSection.customersUseConfluenceToMoveWorkForward",
                defaultMessage: "75,000+ customers use Confluence to move work forward."
            }),
            logoSize: "large",
            logos: [
                {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:b12e4075-84f4-467e-9acf-f062c8fdaece/twilio-n50.svg",
                    alt: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.twilio",
                        defaultMessage: "Twilio logo"
                    }),
                    width: "107px",
                    height: "32px",
                    loading: "lazy"
                },
                {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:35c6a74c-a259-4dac-8df8-ea8c5b12f44d/nasa-n50.svg",
                    alt: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.nasa",
                        defaultMessage: "NASA logo"
                    }),
                    width: "71px",
                    height: "60px",
                    loading: "lazy"
                },
                {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:5a1e47e3-be98-4279-a3a2-c626164dbd5d/illumina-n50.svg",
                    alt: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.illumina",
                        defaultMessage: "Illumina logo"
                    }),
                    width: "100px",
                    height: "24px",
                    loading: "lazy"
                },
                {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:731482d9-54c4-48e7-a10b-ab601ca4fbd6/docker-n50.svg",
                    alt: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.docker",
                        defaultMessage: "Docker logo"
                    }),
                    width: "126px",
                    height: "33px",
                    loading: "lazy"
                },
                {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:7343b372-8a2a-4156-8755-bcf38735ca6b/morningstar-n50.svg",
                    alt: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.morningStart",
                        defaultMessage: "MorningStart logo"
                    }),
                    width: "134px",
                    height: "30px",
                    loading: "lazy"
                },
                {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:c67f93d6-d8be-4970-b4f5-addf24c13e4e/rtr-n50.svg",
                    alt: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.rtr",
                        defaultMessage: "RTR logo"
                    }),
                    width: "43.71px",
                    height: "60px",
                    loading: "lazy"
                },
                {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:b62031f5-0770-46cb-a1c2-50cdacb8a0b0/anz-n50.svg",
                    alt: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.anz",
                        defaultMessage: "ANZ logo"
                    }),
                    width: "102px",
                    height: "32px",
                    loading: "lazy"
                },
                {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:475f41d8-45f4-48c9-a9b2-d78215ae4b16/nyt-n50.svg",
                    alt: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.theNewYorkTimes",
                        defaultMessage: "The New York Times logo"
                    }),
                    width: "223px",
                    height: "32px",
                    loading: "lazy"
                },
                {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:6841df63-0c84-4075-9ac5-1ed0f8ddea17/gopro-n50.svg",
                    alt: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.goPro",
                        defaultMessage: "GoPro logo"
                    }),
                    width: "110px",
                    height: "35px",
                    loading: "lazy"
                }
            ]
        }
    }, props), {
        heroProps: (0, $6iHNw._)((0, $7Knp0._)({}, props.heroProps), {
            embeddedSignup: embeddedSignup
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3fquc.PaidLandingTemplate), (0, $7Knp0._)({}, finalProps));
};

});


parcelRegister("iiM0Q", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSoftwarePageVariantPaidLpConfKeywords", function () { return $fdaa1f15e9d84215$export$bdb004359ea2e77b; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");

var $fR8rA = parcelRequire("fR8rA");

var $cBkUf = parcelRequire("cBkUf");

var $aR9rM = parcelRequire("aR9rM");
const $fdaa1f15e9d84215$export$bdb004359ea2e77b = (pageProps)=>{
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $iSvIT.useEffect)(()=>{
        if ((0, $aR9rM.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data)
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "cfind-2260-nbps-paid-anchor-journey",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cBkUf.ConfluencePagePaidLpConflAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
            pageId: (0, $fR8rA.getPageId)(pageProps.keyword),
            persona: "unknown",
            pageVariant: "keywords",
            dataProductKey: "confluence-PaidLpConflKeywords"
        }))
    });
};

});

parcelRegister("28rj9", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSoftwarePageVariantPaidLpConfSubAnchors", function () { return $15833f6809c7d118$export$5bd0bf292ae6f984; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $9iWJ8 = parcelRequire("9iWJ8");

var $cBkUf = parcelRequire("cBkUf");

var $aR9rM = parcelRequire("aR9rM");
const $15833f6809c7d118$export$5bd0bf292ae6f984 = (pageProps)=>{
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $iSvIT.useEffect)(()=>{
        if (!exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data)
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cBkUf.ConfluencePagePaidLpConflAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        pageId: (0, $aR9rM.getPageId)(pageProps.subAnchor),
        persona: "unknown",
        pageVariant: "subAnchor",
        dataProductKey: "confluence-PaidLpConflSubAnchor"
    }));
};

});

parcelRegister("gr0Wo", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSoftwarePageVariantPaidLpConflDocumentation", function () { return $9c3cdef74dd6edc7$export$2a2456203daa2a03; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $cLLBP = parcelRequire("cLLBP");

var $lpiK5 = parcelRequire("lpiK5");

var $bCSEP = parcelRequire("bCSEP");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");

var $cBkUf = parcelRequire("cBkUf");

var $aR9rM = parcelRequire("aR9rM");
const $9c3cdef74dd6edc7$export$2a2456203daa2a03 = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $iSvIT.useEffect)(()=>{
        if ((0, $aR9rM.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cLLBP.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.dynamic-documentation.title",
                defaultMessage: "Dynamic documentation"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.dynamic-documentation.body",
                defaultMessage: "Plan projects, take notes, and keep track of changes \u2013 all in one place."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.save-time-repeat-less.title",
                defaultMessage: "Save time, repeat less"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.save-time-repeat-less.body",
                defaultMessage: "Scale the production of documentation for faster project delivery."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/033m853kq4f084xpcj7g6l0u2da8thu4.webp",
            imgAltText: "Start a Page with a Confluence Template"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.centralize-knowledge.title",
                defaultMessage: "Centralize knowledge"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.centralize-knowledge.body",
                defaultMessage: "Stay organized and find what you need with dedicated team workspaces."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": "A display of various confluence features",
        "id": "confluence-documentation-carousel",
        "slides": carouselSlides
    };
    const pageId = "paid-lp-confl-documentation";
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lpiK5.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: "confluence"
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bCSEP.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "cfind-3090-paid-confluence-product-tour",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cBkUf.ConfluencePagePaidLpConflAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
            pageId: pageId,
            persona: "unknown",
            pageVariant: "brandUpdate",
            dataProductKey: "confluence-PaidLpConflDocumentation",
            keyword: pageProps.keyword,
            carouselHeroProps: carouselHeroProps,
            customHeroSection: customHeroSection
        }))
    });
};

});

parcelRegister("eYo1w", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSoftwarePageVariantPaidLpConflProjectMgmt", function () { return $3af7adf98464916b$export$d2c906712b67f2f1; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $cLLBP = parcelRequire("cLLBP");

var $lpiK5 = parcelRequire("lpiK5");

var $bCSEP = parcelRequire("bCSEP");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");

var $cBkUf = parcelRequire("cBkUf");

var $aR9rM = parcelRequire("aR9rM");
const $3af7adf98464916b$export$d2c906712b67f2f1 = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $iSvIT.useEffect)(()=>{
        if ((0, $aR9rM.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cLLBP.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Projectmgmt.achieve-project-goals-together.title",
                defaultMessage: "Achieve project goals together"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Projectmgmt.achieve-project-goals-together.body",
                defaultMessage: "Plan projects, take notes, and brainstorm. Let AI write your first draft."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Projectmgmt.get-everyone-on-the-same-page.title",
                defaultMessage: "Get everyone on the same page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Projectmgmt.get-everyone-on-the-same-page.body",
                defaultMessage: "Collaborate with your teams using real-time editing and inline comments."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp",
            imgAltText: "A Confluence page with multiple teammates editing and leaving comments"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Projectmgmt.hit-project-deadlines.title",
                defaultMessage: "Hit project deadlines"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Projectmgmt.hit-project-deadlines.body",
                defaultMessage: "Stay organized in dedicated workspaces, equipped with AI-powered search."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": "A display of various confluence features",
        "id": "confluence-projectmgmt-carousel",
        "slides": carouselSlides
    };
    const pageId = "paid-lp-confl-projectmgmt";
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lpiK5.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: "confluence"
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bCSEP.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "cfind-3090-paid-confluence-product-tour",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cBkUf.ConfluencePagePaidLpConflAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
            pageId: pageId,
            persona: "unknown",
            pageVariant: "brandUpdate",
            dataProductKey: "confluence-PaidLpConflProjectMgmt",
            keyword: pageProps.keyword,
            carouselHeroProps: carouselHeroProps,
            customHeroSection: customHeroSection
        }))
    });
};

});

parcelRegister("88Nc8", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSoftwarePageVariantPaidLpConflTemplate", function () { return $22b67561691147b0$export$e1067e28e1b2acea; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $cLLBP = parcelRequire("cLLBP");

var $lpiK5 = parcelRequire("lpiK5");

var $bCSEP = parcelRequire("bCSEP");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");

var $cBkUf = parcelRequire("cBkUf");

var $aR9rM = parcelRequire("aR9rM");
const $22b67561691147b0$export$e1067e28e1b2acea = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $iSvIT.useEffect)(()=>{
        if ((0, $aR9rM.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cLLBP.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Template.start-with-a-page.title",
                defaultMessage: "Start with a page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Template.start-with-a-page.body",
                defaultMessage: "Plan projects, take notes, and brainstorm. Get started with a template."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/033m853kq4f084xpcj7g6l0u2da8thu4.webp",
            imgAltText: "Start a Page with a Confluence Template"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Template.share-with-your-teams.title",
                defaultMessage: "Share with your teams"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Template.share-with-your-teams.body",
                defaultMessage: "Invite your teams to collaborate using real-time editing and inline comments."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp",
            imgAltText: "A Confluence page with multiple teammates editing and leaving comments"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Template.connect-all-your-work.title",
                defaultMessage: "Connect all your work"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Template.connect-all-your-work.body",
                defaultMessage: "Stay organized and find what you need with dedicated team workspaces."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": "A display of various confluence features",
        "id": "confluence-template-carousel",
        "slides": carouselSlides
    };
    const pageId = "paid-lp-confl-template";
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lpiK5.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: "confluence"
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bCSEP.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "cfind-3090-paid-confluence-product-tour",
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cBkUf.ConfluencePagePaidLpConflAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
            pageId: pageId,
            persona: "unknown",
            pageVariant: "brandUpdate",
            dataProductKey: "confluence-PaidLpConflTemplate",
            keyword: pageProps.keyword,
            carouselHeroProps: carouselHeroProps,
            customHeroSection: customHeroSection
        }))
    });
};

});

parcelRegister("cvEcp", function(module, exports) {

$parcel$export(module.exports, "ConfluenceFreePage", function () { return $c41b54b7986c799d$export$5c727b1e47c0f85c; });

var $3FBn4 = parcelRequire("3FBn4");
const $c41b54b7986c799d$export$5c727b1e47c0f85c = ()=>{
    const signupPath = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup");
    location.href = `${signupPath}?bundle=confluence&edition=free`;
    return null;
};

});

parcelRegister("4Kg8I", function(module, exports) {

$parcel$export(module.exports, "ConfluencePricingPage", function () { return $748551ed218f2dac$export$6bdd18cae91b5a8; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $4LHd8 = parcelRequire("4LHd8");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");

var $dT5kE = parcelRequire("dT5kE");
parcelRequire("aRHrH");
var $9O2F2 = parcelRequire("9O2F2");
parcelRequire("6xVrv");
var $8iyv1 = parcelRequire("8iyv1");

var $9iWJ8 = parcelRequire("9iWJ8");
const $748551ed218f2dac$export$6bdd18cae91b5a8 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $4LHd8.default).checkGate("gwp-737-enable-intercom-chat-confluence");
    const [pricingDirectBuyCheckoutFired, pricingDirectBuyCheckoutFireExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).pricingDirectBuyCheckout);
    (0, $iSvIT.useEffect)(()=>{
        if (!pricingDirectBuyCheckoutFired) pricingDirectBuyCheckoutFireExposure();
    }, [
        pricingDirectBuyCheckoutFired,
        pricingDirectBuyCheckoutFireExposure
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9O2F2.IntercomProvider), {
        appId: "p0ww63i2",
        triggerBoot: isBootIntercom,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3LLDq.CrossFlowTouchpointProvider), {
            productKeys: [
                (0, $i8kxh.ProductKeys).CONFLUENCE
            ],
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dT5kE.PricingContentContextProviderRelay), {
                productId: "confluence",
                pricingContent: pricingContent,
                queryRef: queryRef,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8iyv1.ConfluencePricingPageV2Template), {
                    pricing: pricing,
                    countryCode: countryCode
                })
            })
        })
    });
};

});
parcelRegister("aRHrH", function(module, exports) {
$parcel$export(module.exports, "IntercomProvider", function () { return (parcelRequire("9O2F2")).IntercomProvider; });
parcelRequire("9O2F2");
parcelRequire("42XIn");

});
parcelRegister("9O2F2", function(module, exports) {

$parcel$export(module.exports, "IntercomProvider", function () { return $be094a112486886f$export$5091c5023e5c7eba; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $l4i0P = parcelRequire("l4i0P");

var $gkhN4 = parcelRequire("gkhN4");

var $7OS3I = parcelRequire("7OS3I");
const $be094a112486886f$var$isWindowExist = typeof window !== "undefined";
const $be094a112486886f$export$e578ca56db818a8e = /*#__PURE__*/ $iSvIT.createContext(undefined);
const $be094a112486886f$export$5091c5023e5c7eba = ({ appId: appId, triggerBoot: triggerBoot = false, children: children })=>{
    const isBooted = $iSvIT.useRef(false);
    const isInit = $iSvIT.useRef(false);
    const stargateClient = (0, $gkhN4.useBxpWebStargateClient)();
    const initIntercomInstance = $iSvIT.useCallback(()=>{
        if (!isInit.current) {
            (0, $7OS3I.default)(appId);
            isInit.current = true;
        }
    }, [
        appId
    ]);
    // Ensure DOM is fully ready and stable before Intercom initialization
    const ensureDOMReady = $iSvIT.useCallback(()=>{
        return new Promise((resolve)=>{
            if (document.readyState === "complete") // DOM is ready, but add buffer time for iframe stability
            setTimeout(resolve, 500);
            else {
                // Wait for DOM completion, then add buffer time
                const cleanup = ()=>{
                    document.removeEventListener("DOMContentLoaded", handleLoad);
                    window.removeEventListener("load", handleLoad);
                };
                const handleLoad = ()=>{
                    cleanup();
                    clearTimeout(safetyTimeout);
                    setTimeout(resolve, 500);
                };
                // Add event listeners for DOM ready
                document.addEventListener("DOMContentLoaded", handleLoad);
                window.addEventListener("load", handleLoad);
                // Safety timeout: resolve after 10 seconds even if events don't fire
                const safetyTimeout = setTimeout(()=>{
                    cleanup();
                    console.error("Intercom: DOM ready timeout reached, proceeding anyway");
                    resolve();
                }, 10000);
            }
        });
    }, []);
    const boot = $iSvIT.useCallback(async ()=>{
        if ($be094a112486886f$var$isWindowExist && isInit.current && !isBooted.current) {
            var _window_intercomSettings;
            const intercomSettings = (_window_intercomSettings = window.intercomSettings) !== null && _window_intercomSettings !== void 0 ? _window_intercomSettings : {
                app_id: appId
            };
            try {
                var _window_Intercom, _window, _window_Intercom1, _window1;
                // Wait for DOM to be fully ready and stable
                await ensureDOMReady();
                (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "boot", (0, $7Knp0._)({
                    alignment: "right",
                    horizontal_padding: 20,
                    vertical_padding: 20,
                    custom_launcher_selector: "#intercomLauncher"
                }, intercomSettings));
                (_window_Intercom1 = (_window1 = window).Intercom) === null || _window_Intercom1 === void 0 ? void 0 : _window_Intercom1.call(_window1, "trackEvent", "widget-loaded");
            } catch (error) {
                console.warn("Intercom boot failed:", error);
            } finally{
                isBooted.current = true; // Set value as true to enable functionality of show/hide methods
            }
        }
    }, [
        appId,
        ensureDOMReady
    ]);
    const shutdown = $iSvIT.useCallback(()=>{
        if (!isBooted.current) return;
        if ($be094a112486886f$var$isWindowExist) {
            var _window_Intercom, _window;
            (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "shutdown");
            delete window.intercomSettings;
            isBooted.current = false;
        }
    }, []);
    const show = $iSvIT.useCallback(()=>{
        var _window_Intercom, _window;
        if ($be094a112486886f$var$isWindowExist && isBooted.current) (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "show");
    }, []);
    const hide = $iSvIT.useCallback(()=>{
        var _window_Intercom, _window;
        if ($be094a112486886f$var$isWindowExist && isBooted.current) (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "hide");
    }, []);
    $iSvIT.useEffect(()=>{
        if ($be094a112486886f$var$isWindowExist && triggerBoot) (async function() {
            const intercomSettingsObj = {
                app_id: appId
            };
            const anonId = (0, $l4i0P.default).get("ajs_anonymous_id") || "";
            if (anonId) intercomSettingsObj["anonymousId"] = anonId;
            const getwayApiMeGetResponse = await stargateClient.me({}).catch(()=>null);
            if (getwayApiMeGetResponse) {
                intercomSettingsObj["name"] = getwayApiMeGetResponse.name;
                intercomSettingsObj["email"] = getwayApiMeGetResponse.email;
            }
            if ($be094a112486886f$var$isWindowExist) window.intercomSettings = intercomSettingsObj;
            if (!isInit.current) initIntercomInstance();
            if (isInit.current && !isBooted.current) boot();
        })();
        // clean up code
        return ()=>{
            if (isInit.current) shutdown();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerBoot,
        stargateClient
    ]);
    const providerValue = $iSvIT.useMemo(()=>{
        return {
            initIntercomInstance: initIntercomInstance,
            boot: boot,
            shutdown: shutdown,
            show: show,
            hide: hide
        };
    }, [
        initIntercomInstance,
        boot,
        shutdown,
        show,
        hide
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($be094a112486886f$export$e578ca56db818a8e.Provider, {
        value: providerValue,
        children: children
    });
};
const $be094a112486886f$export$28418e623d2470bc = ()=>{
    const context = $iSvIT.useContext($be094a112486886f$export$e578ca56db818a8e);
    if (context === undefined) throw new Error("This hook must be used within IntercomProvider");
    return context;
};

});
parcelRegister("7OS3I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f03bd135604494e$export$2e2bcd8739ae039; });
function $9f03bd135604494e$var$isIELikeWindow(w) {
    return Object.prototype.hasOwnProperty.call(w, "attachEvent");
}
// Function per instruction here: https://developers.intercom.com/installing-intercom/web/installation/
const $9f03bd135604494e$var$initializeIntercomInstance = (appId)=>{
    const w = window;
    const ic = w.Intercom;
    if (typeof ic === "function") {
        ic("reattach_activator");
        ic("update", w.intercomSettings);
    } else {
        const d = document;
        const i = function() {
            i.c(arguments);
        };
        i.q = [];
        i.c = function(args) {
            i.q.push(args);
        };
        w.Intercom = i;
        const l = function() {
            var _x_parentNode;
            const s = d.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://widget.intercom.io/widget/" + appId;
            const x = d.getElementsByTagName("script")[0];
            x === null || x === void 0 ? void 0 : (_x_parentNode = x.parentNode) === null || _x_parentNode === void 0 ? void 0 : _x_parentNode.insertBefore(s, x);
        };
        if (document.readyState === "complete") l();
        else if ($9f03bd135604494e$var$isIELikeWindow(w)) w.attachEvent("onload", l);
        else w.addEventListener("load", l, false);
    }
};
var $9f03bd135604494e$export$2e2bcd8739ae039 = $9f03bd135604494e$var$initializeIntercomInstance;

});


parcelRegister("42XIn", function(module, exports) {
// Intercom Types & Interface ===========================================================
// all the Interface stuff from: https://developers.intercom.com/installing-intercom/web/attributes-objects/

});


parcelRegister("6xVrv", function(module, exports) {
$parcel$export(module.exports, "ConfluencePricingPageV2Template", function () { return (parcelRequire("8iyv1")).ConfluencePricingPageV2Template; });
parcelRequire("8iyv1");

});
parcelRegister("8iyv1", function(module, exports) {

$parcel$export(module.exports, "ConfluencePricingPageV2Template", function () { return $4c10ceff0f02fdae$export$d4dd4cff5718a25c; });

var $loA2J = parcelRequire("loA2J");

var $i4sgZ = parcelRequire("i4sgZ");

var $83YdV = parcelRequire("83YdV");
parcelRequire("kmJhl");
var $bofgW = parcelRequire("bofgW");
parcelRequire("gUyvS");
var $khjAx = parcelRequire("khjAx");

var $dT5kE = parcelRequire("dT5kE");
parcelRequire("3XyMp");
var $f8O3L = parcelRequire("f8O3L");
var $ceE90 = parcelRequire("ceE90");

var $j1oGG = parcelRequire("j1oGG");

var $kGZng = parcelRequire("kGZng");

var $1FqEx = parcelRequire("1FqEx");

var $le1v7 = parcelRequire("le1v7");
const $4c10ceff0f02fdae$export$d4dd4cff5718a25c = (props)=>{
    var _content_callToActionContainer, _content_callToActionContainer1, _questionsCtaContent_asset;
    const content = (0, $dT5kE.usePricingContentContext)();
    const featuresCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[1];
    const dataCenterContent = (0, $dT5kE.useDatacenterPlans)("Contact Us", "Learn more");
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer1 = content.callToActionContainer) === null || _content_callToActionContainer1 === void 0 ? void 0 : _content_callToActionContainer1[0];
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _featuresCtaContent_text, _featuresCtaContent_url, _content_getMoreDetailsTitle, _content_additionalDetails, _questionsCtaContent_url, _questionsCtaContent_title, _questionsCtaContent_text, _questionsCtaContent_valueProposition;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kGZng.default), {}),
        showFallback: content === null || content === void 0 ? void 0 : content.hasError,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1FqEx.ParentScrollTracking), {
            scrollTrackingEnabled: true,
            pageId: "confluence-pricing-page",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PageHeading), {
                    children: content === null || content === void 0 ? void 0 : content.headline
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $le1v7.default), {
                    pricing: props.pricing,
                    countryCode: props.countryCode
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $khjAx.PricingFeatureTable), {
                    title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                    comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                    compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined,
                    linkValues: {
                        linkText: (_featuresCtaContent_text = featuresCtaContent === null || featuresCtaContent === void 0 ? void 0 : featuresCtaContent.text) !== null && _featuresCtaContent_text !== void 0 ? _featuresCtaContent_text : undefined,
                        linkHref: (_featuresCtaContent_url = featuresCtaContent === null || featuresCtaContent === void 0 ? void 0 : featuresCtaContent.url) !== null && _featuresCtaContent_url !== void 0 ? _featuresCtaContent_url : undefined
                    },
                    dataProductKey: "confluence"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $i4sgZ.DataCenterPromoCard), {
                    dataCenterContent: dataCenterContent
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $83YdV.TwcPromo), {
                    product: "confluence"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $f8O3L.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1FqEx.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ceE90.PricingFaq), {
                            header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                            planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bofgW.QuestionsCta), {
                    product: "Confluence",
                    ctaHref: (_questionsCtaContent_url = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.url) !== null && _questionsCtaContent_url !== void 0 ? _questionsCtaContent_url : undefined,
                    questionsHeader: (_questionsCtaContent_title = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.title) !== null && _questionsCtaContent_title !== void 0 ? _questionsCtaContent_title : undefined,
                    priceAndLicensingLinkText: (_questionsCtaContent_text = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.text) !== null && _questionsCtaContent_text !== void 0 ? _questionsCtaContent_text : undefined,
                    questionsBody: (_questionsCtaContent_valueProposition = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.valueProposition) !== null && _questionsCtaContent_valueProposition !== void 0 ? _questionsCtaContent_valueProposition : undefined,
                    imageHref: questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : (_questionsCtaContent_asset = questionsCtaContent.asset) === null || _questionsCtaContent_asset === void 0 ? void 0 : _questionsCtaContent_asset.url
                })
            ]
        })
    });
};

});
parcelRegister("i4sgZ", function(module, exports) {

$parcel$export(module.exports, "DataCenterPromoCard", function () { return $122604791fa40fc4$export$3e66a33f1e68491c; });
/* data-center-promo-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $1UUq1 = parcelRequire("1UUq1");
const $122604791fa40fc4$export$3e66a33f1e68491c = ({ dataCenterContent: dataCenterContent })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1bsbauwl _1pfh1ejb"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Card), {
            orientation: "horizontal",
            columns: 10,
            title: dataCenterContent.title,
            body: dataCenterContent.description,
            callToAction: {
                text: "Learn more",
                href: "/enterprise/data-center"
            },
            spotIllustrationUrl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Illo_DataCenter.svg"
        })
    });
};

});

parcelRegister("83YdV", function(module, exports) {

$parcel$export(module.exports, "TwcPromo", function () { return $23fad3f7cfabd12a$export$f72cba571c49850d; });
/* twc-promo.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
const $23fad3f7cfabd12a$export$f72cba571c49850d = ({ product: product })=>{
    const intl = (0, $f6qj2.default)();
    let text = intl.formatMessage({
        id: "TeamworkCollection.promo.jira.body",
        defaultMessage: "Get Jira, Confluence, Loom, and Rovo in one collection to bring together projects, knowledge, video communication, and AI-powered insights."
    });
    if (product === "confluence") text = intl.formatMessage({
        id: "TeamworkCollection.promo.confluence.body",
        defaultMessage: "Get Confluence, Jira, Loom, and Rovo in one collection to bring together knowledge, projects, video communication, and AI-powered insights."
    });
    if (product === "loom") text = intl.formatMessage({
        id: "TeamworkCollection.promo.loom.body",
        defaultMessage: "Get Loom, Jira, Confluence, and Rovo in one collection to bring together video communication, projects, knowledge, and AI-powered insights."
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1bsbauwl _1mouxy5q"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.ContentBlock), {
            logo: "teamworkCollection",
            title: intl.formatMessage({
                id: "TeamworkCollection.promo.title",
                defaultMessage: "All your tools, one collection"
            }),
            text: text,
            callToActionProps: {
                link: {
                    text: intl.formatMessage({
                        id: "TeamworkCollection.promo.body",
                        defaultMessage: "Explore Teamwork Collection"
                    }),
                    href: "/collections/teamwork"
                }
            },
            pictureProps: {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/aa0u073wh672n4goi3ncd44ousro7sqc.png",
                    alt: ""
                }
            },
            orientation: "horizontal-reverse",
            columns: 12,
            backgroundColor: `${(0, $5ohHq.wacToken)("color.extended.blue200")}`,
            hat: "high-right"
        })
    });
};

});

parcelRegister("le1v7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2098c6b449329ed$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $6x1qA = parcelRequire("6x1qA");
var $f6qj2 = parcelRequire("f6qj2");

var $7OWgU = parcelRequire("7OWgU");

var $l9lQF = parcelRequire("l9lQF");

var $esRX2 = parcelRequire("esRX2");

var $dT5kE = parcelRequire("dT5kE");

var $gAJUc = parcelRequire("gAJUc");
const $d2098c6b449329ed$var$ConfluencePriceFinder = (props)=>{
    var _props_pricing_ccpPricingData, _props_pricing;
    const content = {
        free: (0, $dT5kE.usePricingPlanComparison)("Free"),
        standard: (0, $dT5kE.usePricingPlanComparison)("Standard"),
        premium: (0, $dT5kE.usePricingPlanComparison)("Premium"),
        enterprise: (0, $dT5kE.usePricingPlanComparison)("Enterprise")
    };
    const freePlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "free");
    const standardPlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "standard");
    const premiumPlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "premium");
    const enterprisePlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "enterprise");
    const intl = (0, $f6qj2.default)();
    // planNames should not be translated
    const confluenceProductPlans = [
        {
            planName: "Free",
            offeringSku: "confluence-free",
            description: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.priceFinder.freeDescription",
                defaultMessage: "Free forever for 10 users"
            }),
            recommendationLimit: 0,
            signupLimit: 150000,
            signupURLSuffix: "?bundle=confluence&edition=free&signupSource=pricing&editionIntent=free",
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: "Standard",
            offeringSku: "confluence-standard",
            description: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.priceFinder.standardDescription",
                defaultMessage: "Everything you need to get started"
            }),
            recommendationLimit: 10,
            signupLimit: 150000,
            signupURLSuffix: "?bundle=confluence&edition=standard",
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: "Premium",
            offeringSku: "confluence-premium",
            description: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.priceFinder.premiumDescription",
                defaultMessage: "Connect work across teams"
            }),
            recommendationLimit: 250,
            signupLimit: 150000,
            signupURLSuffix: "?bundle=confluence&edition=premium",
            planFeatureMessages: premiumPlanFeatureMessages
        },
        {
            planName: "Enterprise",
            offeringSku: "confluence-enterprise-sku",
            description: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.priceFinder.enterpriseDescription",
                defaultMessage: "Advanced analytics, scale and security for enterprises"
            }),
            recommendationLimit: 5000,
            signupLimit: 150000,
            planFeatureMessages: enterprisePlanFeatureMessages
        }
    ];
    const messages = (0, $6x1qA.defineMessages)({
        headerText: {
            id: "ConfluencePricingPageTeam24.priceFinder.headerText",
            defaultMessage: "Build Your <blue>Source of Truth</blue>"
        },
        unitCountInputTextRedesign: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputDirectBuy: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputDirectBuy",
            defaultMessage: "What's your team size?"
        },
        unitCountInputTerm: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        billingCycleText: {
            id: "ConfluencePricingPage.priceFinder.billingCycleText",
            defaultMessage: "Billing cycle:"
        },
        unitCountInputText: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputText",
            defaultMessage: "How many users are on your team?"
        },
        unitCountInputTooltip: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTooltip",
            defaultMessage: "A Confluence user is any user who can log in to Confluence, and who exists in User Management"
        },
        monthlyExampleHelpText: {
            id: "ConfluencePricingPage.priceFinder.monthlyExampleHelpText",
            defaultMessage: "Monthly plans give you flexibility as your number of active users changes, so pay for seats as you use them. Remember that the number of seats may change the total price."
        },
        annualExampleHelpText: {
            id: "ConfluencePricingPage.priceFinder.annualExampleHelpText",
            defaultMessage: "Annual plans give you flexibility and help you prepare for growth. Buy a group of seats at a flat rate now, then fill your empty seats through the year at no extra cost."
        },
        exampleStandardPlan: {
            id: "ConfluencePricingPage.priceFinder.exampleStandardPlan",
            defaultMessage: "Pricing for {unitCount} users on Standard plan",
            description: "Standard is a plan name and should not be translated"
        },
        cardOverSignupLimit: {
            id: "ConfluencePricingPage.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "ConfluencePricingPage.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "ConfluencePricingPage.priceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "ConfluencePricingPageTeam24.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        },
        cardFreeDescription: {
            id: "ConfluencePricingPage.priceFinder.cardFreeDescription",
            defaultMessage: "Always free for 10 users"
        }
    });
    const sourceFromProductPlans = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7546ConfluencePricingCtaCtaUrlSource);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $l9lQF.PriceFinderContextProvider), {
            dataProductKey: "confluence",
            ctaUrlSource: sourceFromProductPlans ? "productPlans" : undefined,
            productPlans: confluenceProductPlans,
            defaultUnitCount: 300,
            shouldAddBuyNow: true,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OWgU.default), {
                messages: messages,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.confluence,
                countryCode: props.countryCode
            })
        })
    });
};
$d2098c6b449329ed$var$ConfluencePriceFinder.displayName = "ConfluencePriceFinderTeam24";
var $d2098c6b449329ed$export$2e2bcd8739ae039 = $d2098c6b449329ed$var$ConfluencePriceFinder;

});




parcelRegister("lDCFR", function(module, exports) {

$parcel$export(module.exports, "getPricingTitleInternal", function () { return $f18ad4ff27f97395$export$933c1404a4ee79b; });
const $f18ad4ff27f97395$export$933c1404a4ee79b = ()=>{
    return "Confluence Pricing Page";
};

});

parcelRegister("aSYwy", function(module, exports) {

$parcel$export(module.exports, "ConfluenceTemplateCategoryRelayPage", function () { return $e184c1faf91327e3$export$edf498f6a1736180; });

var $loA2J = parcelRequire("loA2J");

var $dH3QU = parcelRequire("dH3QU");
const $e184c1faf91327e3$export$edf498f6a1736180 = ({ queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dH3QU.ConfluenceTemplatesUnifiedRelayPageTemplate), {
        queryRef: queryRef
    });
};

});

parcelRegister("crPWy", function(module, exports) {

$parcel$export(module.exports, "ConfluenceTemplateCollectionDetailsRelayPage", function () { return $fd1f4833e429387e$export$bc0513752517fd32; });

var $loA2J = parcelRequire("loA2J");

var $6sE8c = parcelRequire("6sE8c");
const $fd1f4833e429387e$export$bc0513752517fd32 = ({ queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6sE8c.ConfluenceTemplateCollectionDetailsRelayPageTemplate), {
        queryRef: queryRef
    });
};

});

parcelRegister("e15Q8", function(module, exports) {

$parcel$export(module.exports, "ConfluenceTemplateDetailsRelayPage", function () { return $3cabeed800ac8e7d$export$ed4c86e3dbd647b; });

var $loA2J = parcelRequire("loA2J");

var $78sex = parcelRequire("78sex");
const $3cabeed800ac8e7d$export$ed4c86e3dbd647b = ({ queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $78sex.ConfluenceTemplateDetailsRelayPageTemplate), {
        queryRef: queryRef
    });
};

});
parcelRegister("78sex", function(module, exports) {

$parcel$export(module.exports, "ConfluenceTemplateDetailsRelayPageQuery", function () { return $7d7a3259636ee566$export$690b2909d81a5261; });
$parcel$export(module.exports, "getConfluenceTemplateDetailsRelayPageQueryVars", function () { return $7d7a3259636ee566$export$55ab657411300858; });
$parcel$export(module.exports, "ConfluenceTemplateDetailsRelayPageTemplate", function () { return $7d7a3259636ee566$export$ee61b52ae9fd1251; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");

var $cunfD = parcelRequire("cunfD");

var $1XyNv = parcelRequire("1XyNv");

var $5VuC0 = parcelRequire("5VuC0");

var $4ktyF = parcelRequire("4ktyF");

var $lHB9W = parcelRequire("lHB9W");

var $3FBn4 = parcelRequire("3FBn4");

var $1MbAx = parcelRequire("1MbAx");

var $lGc56 = parcelRequire("lGc56");

var $a8pnN = parcelRequire("a8pnN");

var $3xvUi = parcelRequire("3xvUi");

var $jPdsy = parcelRequire("jPdsy");

var $fWQ89 = parcelRequire("fWQ89");

var $8b1Ol = parcelRequire("8b1Ol");
var $7d7a3259636ee566$var$_confluenceTemplateDetailsContentfulRelayPageQuery;
const $7d7a3259636ee566$var$detailPageStyles = null;
const $7d7a3259636ee566$var$detailPageContentStyles = null;
const $7d7a3259636ee566$var$backLinkStyles = null;
const $7d7a3259636ee566$var$leftSectionStyles = null;
const $7d7a3259636ee566$var$rightSectionStyles = null;
const $7d7a3259636ee566$var$parseTemplateUrlSlug = (pathname)=>{
    const [urlSlug, maybeTemplatesSlug] = pathname.split("/").reverse();
    return urlSlug && maybeTemplatesSlug === "templates" ? urlSlug : "";
};

const $7d7a3259636ee566$export$690b2909d81a5261 = $7d7a3259636ee566$var$_confluenceTemplateDetailsContentfulRelayPageQuery !== void 0 ? $7d7a3259636ee566$var$_confluenceTemplateDetailsContentfulRelayPageQuery : ($7d7a3259636ee566$var$_confluenceTemplateDetailsContentfulRelayPageQuery = (parcelRequire("2KyLQ")), $7d7a3259636ee566$var$_confluenceTemplateDetailsContentfulRelayPageQuery.hash && $7d7a3259636ee566$var$_confluenceTemplateDetailsContentfulRelayPageQuery.hash !== "58f05b29349913b5b21e570429855a37" && console.error("The definition of 'confluenceTemplateDetailsContentfulRelayPageQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $7d7a3259636ee566$var$_confluenceTemplateDetailsContentfulRelayPageQuery);
const $7d7a3259636ee566$export$55ab657411300858 = (location, partialVars)=>{
    var _partialVars_locale;
    const locale = (_partialVars_locale = partialVars === null || partialVars === void 0 ? void 0 : partialVars.locale) !== null && _partialVars_locale !== void 0 ? _partialVars_locale : (0, $a8pnN.parseQueryLocale)(location);
    var _partialVars_urlSlug;
    const urlSlug = (_partialVars_urlSlug = partialVars === null || partialVars === void 0 ? void 0 : partialVars.urlSlug) !== null && _partialVars_urlSlug !== void 0 ? _partialVars_urlSlug : $7d7a3259636ee566$var$parseTemplateUrlSlug(location.pathname);
    return {
        locale: locale,
        urlSlug: urlSlug
    };
};
const $7d7a3259636ee566$var$DetailPageContentRelay = ({ queryRef: queryRef })=>{
    const { templates: templates } = (0, $hOqV7.usePreloadedQuery)($7d7a3259636ee566$export$690b2909d81a5261, queryRef);
    const template = (0, $lHB9W.expectContent)(templates === null || templates === void 0 ? void 0 : templates.items[0]);
    const intl = (0, $f6qj2.default)();
    const templatesLink = (0, $3FBn4.useLocalizedHref)("/software/confluence/templates");
    const linkText = intl.formatMessage({
        id: "ConfluenceTemplateMessages.backLink.cfind.1508",
        defaultMessage: "Explore all Confluence templates"
    });
    const backAriaLabel = (0, $1XyNv.ConfluenceTemplateMessages).searchBackAriaLabel.defaultMessage;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": "confluence-template-details-page",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _1bah1h6o _2lx21bp4 _4cvr1h6o _bozg7vkz _y4ti7vkz"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _zulpd6z3 _1bah1h6o _p12f1osq _1gde1bp4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _2lx21bp4 _1bsb1feq _1q5188uy _1pfhj6h1 _4t3i1osq _152tidpf _tnru1wug _v7367vkz _chtu7vkz _13zmh2mm _1rfm1osq _1rqi1if8"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_syaz9sh9 _1wyb7vkz _k48pbfng _1dyz131x _p12f6ecz _ca0q8vuz _u5f3idpf _n3td8vuz _19bvidpf _1bsb1osq"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsxs)("a", (0, $6iHNw._)((0, $7Knp0._)({
                                    href: templatesLink,
                                    "aria-label": backAriaLabel
                                }, (0, $5VuC0.ConfluenceTemplateAnalytics).searchBackButton()), {
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $cunfD.LeftArrowIcon), {
                                            size: "13"
                                        }),
                                        linkText
                                    ]
                                }))
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $fWQ89.TemplateHeaderSection), {
                                template: template
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8b1Ol.TemplateKeyFeaturesSection), {
                                template: template
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $3xvUi.TemplateCategorySection), {
                                template: template
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        "data-testid": "TemplateDetailsBody-top",
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _2lx21bp4 _1q51bv7e _1bsborz4 _v7367vkz _chtu7vkz _1u2qidpf _1rfm1osq"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jPdsy.TemplateDetailsSection), {
                            template: template
                        })
                    })
                ]
            })
        })
    });
};
const $7d7a3259636ee566$export$d11f6c32a9aaae4d = ({ queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lGc56.SharedHeaderFooterContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4ktyF.default), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)($7d7a3259636ee566$var$DetailPageContentRelay, {
                    queryRef: queryRef
                })
            })
        })
    });
};
const $7d7a3259636ee566$export$ee61b52ae9fd1251 = (0, $1MbAx.withFeatureExposed)("template-details-page-template-details-seo-v2", "enrolled", $7d7a3259636ee566$export$d11f6c32a9aaae4d);

});
parcelRegister("3xvUi", function(module, exports) {

$parcel$export(module.exports, "TemplateCategorySection", function () { return $f4e32fb04d5369a7$export$238f728cc1d4638a; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");

var $8xSOc = parcelRequire("8xSOc");

var $4VhzM = parcelRequire("4VhzM");
var $f4e32fb04d5369a7$var$_templateCategorySectionContentfulRelayFragment;
const $f4e32fb04d5369a7$var$WHITEBOARD_TEMPLATE_ID = "1HlskYfRNciSnQ02SDhCPs";
const $f4e32fb04d5369a7$var$templateCategorySectionStyles = null;
const $f4e32fb04d5369a7$var$headingStyles = null;
const $f4e32fb04d5369a7$var$categoryContainerStyles = null;
const $f4e32fb04d5369a7$var$categoriesColumnStyles = null;

const $f4e32fb04d5369a7$var$TemplateCategorySectionRelayFragment = $f4e32fb04d5369a7$var$_templateCategorySectionContentfulRelayFragment !== void 0 ? $f4e32fb04d5369a7$var$_templateCategorySectionContentfulRelayFragment : ($f4e32fb04d5369a7$var$_templateCategorySectionContentfulRelayFragment = (parcelRequire("kzvZb")), $f4e32fb04d5369a7$var$_templateCategorySectionContentfulRelayFragment.hash && $f4e32fb04d5369a7$var$_templateCategorySectionContentfulRelayFragment.hash !== "488fa70f5b471114a1118928e06ba1f2" && console.error("The definition of 'templateCategorySectionContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $f4e32fb04d5369a7$var$_templateCategorySectionContentfulRelayFragment); // eslint-disable-next-line complexity
const $f4e32fb04d5369a7$export$238f728cc1d4638a = ({ template: template })=>{
    var _data_categories, _data_templateTypeCollection, _type_sys;
    const data = (0, $hOqV7.useFragment)($f4e32fb04d5369a7$var$TemplateCategorySectionRelayFragment, template);
    const categories = (data === null || data === void 0 ? void 0 : (_data_categories = data.categories) === null || _data_categories === void 0 ? void 0 : _data_categories.items) || [];
    const templateType = (data === null || data === void 0 ? void 0 : (_data_templateTypeCollection = data.templateTypeCollection) === null || _data_templateTypeCollection === void 0 ? void 0 : _data_templateTypeCollection.items) || [];
    const intl = (0, $f6qj2.default)();
    const categoryText = intl.formatMessage({
        id: "ConfluenceTemplateMessages.categories.heading",
        defaultMessage: "CATEGORIES"
    });
    const experimentCategories = (categories !== null && categories !== void 0 ? categories : []).filter(// eslint-disable-next-line complexity
    (category)=>(category === null || category === void 0 ? void 0 : category.urlSlug) === "recommended" || (category === null || category === void 0 ? void 0 : category.urlSlug) === "project-management" || (category === null || category === void 0 ? void 0 : category.urlSlug) === "software-development-and-it" || (category === null || category === void 0 ? void 0 : category.urlSlug) === "product-management" || (category === null || category === void 0 ? void 0 : category.urlSlug) === "marketing-and-sales" || (category === null || category === void 0 ? void 0 : category.urlSlug) === "design" || (category === null || category === void 0 ? void 0 : category.urlSlug) === "finance-and-operations" || (category === null || category === void 0 ? void 0 : category.urlSlug) === "human-resources");
    var _templateType_;
    const type = (_templateType_ = templateType === null || templateType === void 0 ? void 0 : templateType[0]) !== null && _templateType_ !== void 0 ? _templateType_ : {
        id: null,
        templateTypeName: null
    };
    const templateTypeKey = "sys" in type && ((_type_sys = type.sys) === null || _type_sys === void 0 ? void 0 : _type_sys.id) === $f4e32fb04d5369a7$var$WHITEBOARD_TEMPLATE_ID ? (0, $4VhzM.TemplateType).Whiteboard : (0, $4VhzM.TemplateType).Page;
    var _type_templateTypeNameExternal;
    const templateTypeLabel = "templateTypeNameExternal" in type ? (_type_templateTypeNameExternal = type.templateTypeNameExternal) !== null && _type_templateTypeNameExternal !== void 0 ? _type_templateTypeNameExternal : (0, $4VhzM.TemplateType).Page : (0, $4VhzM.TemplateType).Page;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_syaz19tk _1wyboqnp _k48p1nn1 _1dyzt94y _6rth1tcg _1pfh1f4h"
                ]),
                children: categoryText
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4"
                ]),
                children: [
                    experimentCategories.map((category)=>{
                        var _category_sys;
                        return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c116y _4t3izwfg _85i57vkz"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                                appearance: "inprogress",
                                children: category === null || category === void 0 ? void 0 : category.categoryNameExternal
                            })
                        }, category === null || category === void 0 ? void 0 : (_category_sys = category.sys) === null || _category_sys === void 0 ? void 0 : _category_sys.id);
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c116y _4t3izwfg _85i57vkz"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                            appearance: templateTypeKey === (0, $4VhzM.TemplateType).Page ? "inprogress" : "success",
                            isBold: true,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "confluence.templates.detail.template.type",
                                defaultMessage: `{templateType} template`,
                                values: {
                                    templateType: templateTypeLabel
                                }
                            })
                        })
                    }, templateTypeKey)
                ]
            })
        ]
    });
};

});
parcelRegister("kzvZb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $80c5292c0319e213$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<0604e3f78425700337e1ded3f9b5b1cc>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $80c5292c0319e213$var$node = function() {
    var v0 = {
        "alias": null,
        "args": null,
        "concreteType": "Sys",
        "kind": "LinkedField",
        "name": "sys",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            }
        ],
        "storageKey": null
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "templateCategorySectionContentfulRelayFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductTemplateTemplateTypeCollection",
                "kind": "LinkedField",
                "name": "templateTypeCollection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "TaxonomyTemplateType",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "templateTypeNameExternal",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": "categories",
                "args": null,
                "concreteType": "ProductTemplateCategoryCollection",
                "kind": "LinkedField",
                "name": "categoryCollection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "TaxonomyTemplateCategory",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "categoryNameExternal",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "urlSlug",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "ProductTemplate",
        "abstractKey": null
    };
}();
$80c5292c0319e213$var$node.hash = "488fa70f5b471114a1118928e06ba1f2";
var $80c5292c0319e213$export$2e2bcd8739ae039 = $80c5292c0319e213$var$node;

});


parcelRegister("jPdsy", function(module, exports) {

$parcel$export(module.exports, "TemplateDetailsSection", function () { return $12d781c1a584bab2$export$1a14eb006a5f8a7b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $hOqV7 = parcelRequire("hOqV7");

var $i8kxh = parcelRequire("i8kxh");

var $gkV6l = parcelRequire("gkV6l");

var $95kuv = parcelRequire("95kuv");

var $iKQQs = parcelRequire("iKQQs");

var $afxk9 = parcelRequire("afxk9");

var $267RQ = parcelRequire("267RQ");

var $9AFPk = parcelRequire("9AFPk");
var $12d781c1a584bab2$var$_templateDetailsSectionContentfulRelayFragment;
const $12d781c1a584bab2$var$WHITEBOARD_TEMPLATE_ID = "1HlskYfRNciSnQ02SDhCPs";
const $12d781c1a584bab2$var$templateDetailsSectionStyles = null;
const $12d781c1a584bab2$var$ctaButtonContainerStyles = null;
const $12d781c1a584bab2$var$previewSectionStyles = null;

const $12d781c1a584bab2$var$TemplateDetailsSectionFragment = $12d781c1a584bab2$var$_templateDetailsSectionContentfulRelayFragment !== void 0 ? $12d781c1a584bab2$var$_templateDetailsSectionContentfulRelayFragment : ($12d781c1a584bab2$var$_templateDetailsSectionContentfulRelayFragment = (parcelRequire("aElNK")), $12d781c1a584bab2$var$_templateDetailsSectionContentfulRelayFragment.hash && $12d781c1a584bab2$var$_templateDetailsSectionContentfulRelayFragment.hash !== "e8b8a2fa5d16d077e413ac61f87dea66" && console.error("The definition of 'templateDetailsSectionContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $12d781c1a584bab2$var$_templateDetailsSectionContentfulRelayFragment);
const $12d781c1a584bab2$export$1a14eb006a5f8a7b = ({ template: templateRef })=>{
    var _templateTypeCollection_items__sys, _templateTypeCollection_items_, _templateTypeCollection_items;
    const template = (0, $hOqV7.useFragment)($12d781c1a584bab2$var$TemplateDetailsSectionFragment, templateRef);
    const { pluginModuleKey: pluginModuleKey, templateNameExternal: templateNameExternal, templateTypeCollection: templateTypeCollection } = template;
    const { openModalForTemplate: openModalForTemplate } = (0, $gkV6l.useSiteSelectorContext)();
    const buttonUseTemplateClicked = ()=>{
        openModalForTemplate({
            templateId: pluginModuleKey !== null && pluginModuleKey !== void 0 ? pluginModuleKey : "",
            templateName: templateNameExternal !== null && templateNameExternal !== void 0 ? templateNameExternal : "",
            productKey: (0, $i8kxh.ProductKeys).CONFLUENCE
        });
    };
    const navigateToSignupClick = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        buttonUseTemplateClicked();
    };
    const navigateToSignupKeyDown = (event)=>{
        if (event.code === "Space" || event.code === "Enter") {
            event.stopPropagation();
            event.preventDefault();
            buttonUseTemplateClicked();
        }
    };
    const isWhiteBoardTemplate = (templateTypeCollection === null || templateTypeCollection === void 0 ? void 0 : (_templateTypeCollection_items = templateTypeCollection.items) === null || _templateTypeCollection_items === void 0 ? void 0 : (_templateTypeCollection_items_ = _templateTypeCollection_items[0]) === null || _templateTypeCollection_items_ === void 0 ? void 0 : (_templateTypeCollection_items__sys = _templateTypeCollection_items_.sys) === null || _templateTypeCollection_items__sys === void 0 ? void 0 : _templateTypeCollection_items__sys.id) === $12d781c1a584bab2$var$WHITEBOARD_TEMPLATE_ID;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "TemplateDetailsSection",
        className: (0, $esG4f.default)([
            "_tnru1wug"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                onClick: isWhiteBoardTemplate ? undefined : navigateToSignupClick,
                onKeyDown: isWhiteBoardTemplate ? undefined : navigateToSignupKeyDown,
                role: "img",
                "aria-label": "Template preview" // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                ,
                tabIndex: 0,
                className: (0, $esG4f.default)([
                    !isWhiteBoardTemplate && "_80omtlke"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $afxk9.TemplatePreview), {
                    template: template
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $iKQQs.TemplateDescription), {
                template: template
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $9AFPk.TemplateTabbedSection), {
                template: template
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _suga1ule _476dvbgk"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $95kuv.TemplateCtaButtons), {
                    name: templateNameExternal !== null && templateNameExternal !== void 0 ? templateNameExternal : "",
                    pluginModuleKey: pluginModuleKey !== null && pluginModuleKey !== void 0 ? pluginModuleKey : ""
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $267RQ.TemplateRelatedTemplates), {
                template: template
            })
        ]
    });
};

});
parcelRegister("95kuv", function(module, exports) {

$parcel$export(module.exports, "TemplateCtaButtons", function () { return $ce9517abf3e8b64e$export$20303b6b07b1d49e; });
/* template-cta-buttons.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $i8kxh = parcelRequire("i8kxh");

var $gkV6l = parcelRequire("gkV6l");

var $bQawl = parcelRequire("bQawl");
const $ce9517abf3e8b64e$var$ctaContainerStyles = null;
const $ce9517abf3e8b64e$export$20303b6b07b1d49e = ({ name: name, pluginModuleKey: pluginModuleKey })=>{
    const intl = (0, $f6qj2.default)();
    const { openModalForTemplate: openModalForTemplate } = (0, $gkV6l.useSiteSelectorContext)();
    const buttonText = intl.formatMessage({
        id: "ConfluenceTemplateMessages.useTemplate",
        defaultMessage: "Use template"
    });
    const navigateToSignup = (0, $iSvIT.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
        openModalForTemplate({
            templateId: pluginModuleKey !== null && pluginModuleKey !== void 0 ? pluginModuleKey : "",
            templateName: name !== null && name !== void 0 ? name : "",
            productKey: (0, $i8kxh.ProductKeys).CONFLUENCE
        });
    }, [
        openModalForTemplate,
        name,
        pluginModuleKey
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _zulp14no _1bah1y6m _nssp1h6o _1ogzkb7n _10df1ylp _16vj1ylp _1wm61j6v"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bQawl.default), {
            className: "cta-button",
            onClick: navigateToSignup,
            size: "small",
            text: buttonText
        })
    });
};

});

parcelRegister("iKQQs", function(module, exports) {

$parcel$export(module.exports, "TemplateDescription", function () { return $d21ff73d1b3f26b7$export$809977f0794a1530; });

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");

var $cyfPT = parcelRequire("cyfPT");

var $A9zZc = parcelRequire("A9zZc");
var $d21ff73d1b3f26b7$var$_templateDescriptionContentfulRelayFragment;

const $d21ff73d1b3f26b7$var$TemplateDescriptionRelayFragment = $d21ff73d1b3f26b7$var$_templateDescriptionContentfulRelayFragment !== void 0 ? $d21ff73d1b3f26b7$var$_templateDescriptionContentfulRelayFragment : ($d21ff73d1b3f26b7$var$_templateDescriptionContentfulRelayFragment = (parcelRequire("ly6OB")), $d21ff73d1b3f26b7$var$_templateDescriptionContentfulRelayFragment.hash && $d21ff73d1b3f26b7$var$_templateDescriptionContentfulRelayFragment.hash !== "feb20f99c8568003e487a1eac2d28713" && console.error("The definition of 'templateDescriptionContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $d21ff73d1b3f26b7$var$_templateDescriptionContentfulRelayFragment);
const $d21ff73d1b3f26b7$export$809977f0794a1530 = ({ template: template })=>{
    const { aboutThisTemplate: aboutThisTemplate } = (0, $hOqV7.useFragment)($d21ff73d1b3f26b7$var$TemplateDescriptionRelayFragment, template);
    if (!aboutThisTemplate) return null;
    const aboutThisTemplateString = (aboutThisTemplate === null || aboutThisTemplate === void 0 ? void 0 : aboutThisTemplate.json) ? (0, $cyfPT.richTextToHTML)(aboutThisTemplate.json) : "";
    const renderDescription = ()=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $A9zZc.SanitizedRichText), {
            innerHTML: aboutThisTemplateString
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        "data-testid": "confluence-template-details-template-description",
        children: renderDescription()
    });
};

});
parcelRegister("ly6OB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $bc0d45e37eeb524f$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<c868d6a326acca2cad7e84c95fb71b5f>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bc0d45e37eeb524f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateDescriptionContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "ProductTemplateAboutThisTemplate",
            "kind": "LinkedField",
            "name": "aboutThisTemplate",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "json",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "ProductTemplate",
    "abstractKey": null
};
$bc0d45e37eeb524f$var$node.hash = "feb20f99c8568003e487a1eac2d28713";
var $bc0d45e37eeb524f$export$2e2bcd8739ae039 = $bc0d45e37eeb524f$var$node;

});


parcelRegister("afxk9", function(module, exports) {

$parcel$export(module.exports, "TemplatePreview", function () { return $5deb3b319bdd5a59$export$48a171bbad47b95a; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $hOqV7 = parcelRequire("hOqV7");

var $1IKTR = parcelRequire("1IKTR");

var $4VhzM = parcelRequire("4VhzM");
var $5deb3b319bdd5a59$var$_templatePreviewContentfulRelayFragment;
const $5deb3b319bdd5a59$var$WHITEBOARD_TEMPLATE_ID = "1HlskYfRNciSnQ02SDhCPs";
const $5deb3b319bdd5a59$var$templatePreviewSection = null;
const $5deb3b319bdd5a59$var$previewBackgroundContainer = null;
const $5deb3b319bdd5a59$var$relativePosition = null;

const $5deb3b319bdd5a59$var$TemplatePreviewRelayFragment = $5deb3b319bdd5a59$var$_templatePreviewContentfulRelayFragment !== void 0 ? $5deb3b319bdd5a59$var$_templatePreviewContentfulRelayFragment : ($5deb3b319bdd5a59$var$_templatePreviewContentfulRelayFragment = (parcelRequire("jX9s2")), $5deb3b319bdd5a59$var$_templatePreviewContentfulRelayFragment.hash && $5deb3b319bdd5a59$var$_templatePreviewContentfulRelayFragment.hash !== "dad8d8814494331f36c5867d050c8524" && console.error("The definition of 'templatePreviewContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $5deb3b319bdd5a59$var$_templatePreviewContentfulRelayFragment);
const $5deb3b319bdd5a59$export$48a171bbad47b95a = ({ template: template })=>{
    var _templateTypeCollection_items__sys, _templateTypeCollection_items_;
    const { templateNameExternal: templateNameExternal, templateTypeCollection: templateTypeCollection, templatePreviews: templatePreviews } = (0, $hOqV7.useFragment)($5deb3b319bdd5a59$var$TemplatePreviewRelayFragment, template);
    var _templatePreviews_items_;
    const templatePreview = (_templatePreviews_items_ = templatePreviews === null || templatePreviews === void 0 ? void 0 : templatePreviews.items[0]) !== null && _templatePreviews_items_ !== void 0 ? _templatePreviews_items_ : null;
    if (!templatePreview) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_85i57vkz _y3gn1h6o"
        ]),
        children: templatePreview && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_kqswh2mm _85i5ckbl _y4tigktf _bozggktf"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _19pkidpf _2hwx1wug _otyridpf _18u01wug _mnhno812 _9ha51oh5 _3s7lz8o0 _zl7jzoqa"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1IKTR.TemplatePreviewWindow), {
                    url: templatePreview.url || "",
                    alt: templateNameExternal !== null && templateNameExternal !== void 0 ? templateNameExternal : "",
                    templateType: (templateTypeCollection === null || templateTypeCollection === void 0 ? void 0 : (_templateTypeCollection_items_ = templateTypeCollection.items[0]) === null || _templateTypeCollection_items_ === void 0 ? void 0 : (_templateTypeCollection_items__sys = _templateTypeCollection_items_.sys) === null || _templateTypeCollection_items__sys === void 0 ? void 0 : _templateTypeCollection_items__sys.id) === $5deb3b319bdd5a59$var$WHITEBOARD_TEMPLATE_ID ? (0, $4VhzM.TemplateType).Whiteboard : (0, $4VhzM.TemplateType).Page
                })
            })
        })
    });
};

});
parcelRegister("1IKTR", function(module, exports) {

$parcel$export(module.exports, "TemplatePreviewWindow", function () { return $d97b2f2c7d425037$export$7dbe3d9b4e16c7ed; });
/* template-preview-window.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $lHjhp = parcelRequire("lHjhp");

var $4VhzM = parcelRequire("4VhzM");

var $5ohHq = parcelRequire("5ohHq");

var $kqt8V = parcelRequire("kqt8V");

var $ik2oV = parcelRequire("ik2oV");
const $d97b2f2c7d425037$var$previewTopBar = null;
const $d97b2f2c7d425037$var$previewBarDot = null;
const $d97b2f2c7d425037$var$previewImage = null; /**
                            * @deprecated These pages are now in Uniform, using the TemplatePreview Uniform component.
                            */ 
const $d97b2f2c7d425037$export$7dbe3d9b4e16c7ed = ({ url: url, alt: alt, templateType: templateType })=>{
    const templatePreview = null;
    const previewScreenshot = null;
    const whiteboardPreviewWrapper = null;
    const zoomControls = null;
    const zoomControl = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_p12f1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug"
        ]),
        children: templateType === (0, $4VhzM.TemplateType).Whiteboard ? /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _ca0qi2wt _u5f31crf _n3tdi2wt _19bv1crf _4t3i7vkz _vchhusvi _1s1g1y44 _5fbc1y44 _bfhkalr3"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21y44 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21y44 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21y44 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_4t3i1gwv _18m91wug _bfhku67f _1yxn1y44 _1ein1y44 _16qsapdr _4mbabn52 _kno315vq",
                        "_80om1qgj _ou2u1osq"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lHjhp.TransformWrapper), {
                        children: ({ zoomIn: zoomIn, zoomOut: zoomOut })=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $lHjhp.TransformComponent), {
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                                            src: url,
                                            alt: alt,
                                            className: (0, $esG4f.default)([
                                                "_1bsb1osq _p12f1osq"
                                            ])
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c1txw _zulpftgi _kqswstnw _u7co7vkz _rjxp7vkz"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                                onClick: ()=>zoomIn(),
                                                "aria-label": "Zoom In",
                                                className: (0, $esG4f.default)([
                                                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _11q7glyw _80omtlke"
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kqt8V.ZoomIn), {
                                                    size: "16"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                                onClick: ()=>zoomOut(),
                                                "aria-label": "Zoom Out",
                                                className: (0, $esG4f.default)([
                                                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _11q7glyw _80omtlke"
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ik2oV.ZoomOut), {
                                                    size: "16"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _ca0qi2wt _u5f31crf _n3tdi2wt _19bv1crf _4t3i7vkz _vchhusvi _1s1g1y44 _5fbc1y44 _bfhkalr3"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21y44 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21y44 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21y44 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_4t3i1gwv _18m91wug _bfhku67f _1yxn1y44 _1ein1y44 _16qsapdr _4mbabn52 _kno315vq"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                        src: url,
                        alt: alt,
                        className: (0, $esG4f.default)([
                            "_1bsb1osq _p12f1osq"
                        ])
                    })
                })
            ]
        })
    });
};

});
parcelRegister("lHjhp", function(module, exports) {

$parcel$export(module.exports, "TransformWrapper", function () { return $fcbc91b54b018d11$export$51cb649375dcd655; });
$parcel$export(module.exports, "TransformComponent", function () { return $fcbc91b54b018d11$export$1def2aa75b7c7fe0; });

var $iSvIT = parcelRequire("iSvIT");
/**
 * Rounds number to given decimal
 * eg. roundNumber(2.34343, 1) => 2.3
 */ var $fcbc91b54b018d11$var$roundNumber = function(num, decimal) {
    return Number(num.toFixed(decimal));
};
/**
 * Checks if value is number, if not it returns default value
 * 1# eg. checkIsNumber(2, 30) => 2
 * 2# eg. checkIsNumber(null, 30) => 30
 */ var $fcbc91b54b018d11$var$checkIsNumber = function(num, defaultValue) {
    return typeof num === "number" ? num : defaultValue;
};
var $fcbc91b54b018d11$var$handleCallback = function(context, event, callback) {
    if (callback && typeof callback === "function") callback(context, event);
};
/* eslint-disable no-plusplus */ /* eslint-disable no-param-reassign */ /**
 * Functions should return denominator of the target value, which is the next animation step.
 * t is a value from 0 to 1, reflecting the percentage of animation status.
 */ var $fcbc91b54b018d11$var$easeOut = function(t) {
    return -Math.cos(t * Math.PI) / 2 + 0.5;
};
// linear
var $fcbc91b54b018d11$var$linear = function(t) {
    return t;
};
// accelerating from zero velocity
var $fcbc91b54b018d11$var$easeInQuad = function(t) {
    return t * t;
};
// decelerating to zero velocity
var $fcbc91b54b018d11$var$easeOutQuad = function(t) {
    return t * (2 - t);
};
// acceleration until halfway, then deceleration
var $fcbc91b54b018d11$var$easeInOutQuad = function(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};
// accelerating from zero velocity
var $fcbc91b54b018d11$var$easeInCubic = function(t) {
    return t * t * t;
};
// decelerating to zero velocity
var $fcbc91b54b018d11$var$easeOutCubic = function(t) {
    return --t * t * t + 1;
};
// acceleration until halfway, then deceleration
var $fcbc91b54b018d11$var$easeInOutCubic = function(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
};
// accelerating from zero velocity
var $fcbc91b54b018d11$var$easeInQuart = function(t) {
    return t * t * t * t;
};
// decelerating to zero velocity
var $fcbc91b54b018d11$var$easeOutQuart = function(t) {
    return 1 - --t * t * t * t;
};
// acceleration until halfway, then deceleration
var $fcbc91b54b018d11$var$easeInOutQuart = function(t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
};
// accelerating from zero velocity
var $fcbc91b54b018d11$var$easeInQuint = function(t) {
    return t * t * t * t * t;
};
// decelerating to zero velocity
var $fcbc91b54b018d11$var$easeOutQuint = function(t) {
    return 1 + --t * t * t * t * t;
};
// acceleration until halfway, then deceleration
var $fcbc91b54b018d11$var$easeInOutQuint = function(t) {
    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
};
var $fcbc91b54b018d11$var$animations = {
    easeOut: $fcbc91b54b018d11$var$easeOut,
    linear: $fcbc91b54b018d11$var$linear,
    easeInQuad: $fcbc91b54b018d11$var$easeInQuad,
    easeOutQuad: $fcbc91b54b018d11$var$easeOutQuad,
    easeInOutQuad: $fcbc91b54b018d11$var$easeInOutQuad,
    easeInCubic: $fcbc91b54b018d11$var$easeInCubic,
    easeOutCubic: $fcbc91b54b018d11$var$easeOutCubic,
    easeInOutCubic: $fcbc91b54b018d11$var$easeInOutCubic,
    easeInQuart: $fcbc91b54b018d11$var$easeInQuart,
    easeOutQuart: $fcbc91b54b018d11$var$easeOutQuart,
    easeInOutQuart: $fcbc91b54b018d11$var$easeInOutQuart,
    easeInQuint: $fcbc91b54b018d11$var$easeInQuint,
    easeOutQuint: $fcbc91b54b018d11$var$easeOutQuint,
    easeInOutQuint: $fcbc91b54b018d11$var$easeInOutQuint
};
/* eslint-disable no-param-reassign */ var $fcbc91b54b018d11$var$handleCancelAnimationFrame = function(animation) {
    if (typeof animation === "number") cancelAnimationFrame(animation);
};
var $fcbc91b54b018d11$var$handleCancelAnimation = function(contextInstance) {
    if (!contextInstance.mounted) return;
    $fcbc91b54b018d11$var$handleCancelAnimationFrame(contextInstance.animation);
    // Clear animation state
    contextInstance.animate = false;
    contextInstance.animation = null;
    contextInstance.velocity = null;
};
function $fcbc91b54b018d11$var$handleSetupAnimation(contextInstance, animationName, animationTime, callback) {
    if (!contextInstance.mounted) return;
    var startTime = new Date().getTime();
    var lastStep = 1;
    // if another animation is active
    $fcbc91b54b018d11$var$handleCancelAnimation(contextInstance);
    // new animation
    contextInstance.animation = function() {
        if (!contextInstance.mounted) return $fcbc91b54b018d11$var$handleCancelAnimationFrame(contextInstance.animation);
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / animationTime;
        var animationType = $fcbc91b54b018d11$var$animations[animationName];
        var step = animationType(animationProgress);
        if (frameTime >= animationTime) {
            callback(lastStep);
            contextInstance.animation = null;
        } else if (contextInstance.animation) {
            callback(step);
            requestAnimationFrame(contextInstance.animation);
        }
    };
    requestAnimationFrame(contextInstance.animation);
}
function $fcbc91b54b018d11$var$isValidTargetState(targetState) {
    var scale = targetState.scale, positionX = targetState.positionX, positionY = targetState.positionY;
    if (Number.isNaN(scale) || Number.isNaN(positionX) || Number.isNaN(positionY)) return false;
    return true;
}
function $fcbc91b54b018d11$var$animate(contextInstance, targetState, animationTime, animationName) {
    var isValid = $fcbc91b54b018d11$var$isValidTargetState(targetState);
    if (!contextInstance.mounted || !isValid) return;
    var setTransformState = contextInstance.setTransformState;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDiff = targetState.scale - scale;
    var positionXDiff = targetState.positionX - positionX;
    var positionYDiff = targetState.positionY - positionY;
    if (animationTime === 0) setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
    else // animation start timestamp
    $fcbc91b54b018d11$var$handleSetupAnimation(contextInstance, animationName, animationTime, function(step) {
        var newScale = scale + scaleDiff * step;
        var newPositionX = positionX + positionXDiff * step;
        var newPositionY = positionY + positionYDiff * step;
        setTransformState(newScale, newPositionX, newPositionY);
    });
}
/* eslint-disable no-param-reassign */ function $fcbc91b54b018d11$var$getComponentsSizes(wrapperComponent, contentComponent, newScale) {
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var contentWidth = contentComponent.offsetWidth;
    var contentHeight = contentComponent.offsetHeight;
    var newContentWidth = contentWidth * newScale;
    var newContentHeight = contentHeight * newScale;
    var newDiffWidth = wrapperWidth - newContentWidth;
    var newDiffHeight = wrapperHeight - newContentHeight;
    return {
        wrapperWidth: wrapperWidth,
        wrapperHeight: wrapperHeight,
        newContentWidth: newContentWidth,
        newDiffWidth: newDiffWidth,
        newContentHeight: newContentHeight,
        newDiffHeight: newDiffHeight
    };
}
var $fcbc91b54b018d11$var$getBounds = function(wrapperWidth, newContentWidth, diffWidth, wrapperHeight, newContentHeight, diffHeight, centerZoomedOut) {
    var scaleWidthFactor = wrapperWidth > newContentWidth ? diffWidth * (centerZoomedOut ? 1 : 0.5) : 0;
    var scaleHeightFactor = wrapperHeight > newContentHeight ? diffHeight * (centerZoomedOut ? 1 : 0.5) : 0;
    var minPositionX = wrapperWidth - newContentWidth - scaleWidthFactor;
    var maxPositionX = scaleWidthFactor;
    var minPositionY = wrapperHeight - newContentHeight - scaleHeightFactor;
    var maxPositionY = scaleHeightFactor;
    return {
        minPositionX: minPositionX,
        maxPositionX: maxPositionX,
        minPositionY: minPositionY,
        maxPositionY: maxPositionY
    };
};
var $fcbc91b54b018d11$var$calculateBounds = function(contextInstance, newScale) {
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
    var centerZoomedOut = contextInstance.setup.centerZoomedOut;
    if (!wrapperComponent || !contentComponent) throw new Error("Components are not mounted");
    var _a = $fcbc91b54b018d11$var$getComponentsSizes(wrapperComponent, contentComponent, newScale), wrapperWidth = _a.wrapperWidth, wrapperHeight = _a.wrapperHeight, newContentWidth = _a.newContentWidth, newDiffWidth = _a.newDiffWidth, newContentHeight = _a.newContentHeight, newDiffHeight = _a.newDiffHeight;
    var bounds = $fcbc91b54b018d11$var$getBounds(wrapperWidth, newContentWidth, newDiffWidth, wrapperHeight, newContentHeight, newDiffHeight, Boolean(centerZoomedOut));
    return bounds;
};
/**
 * Keeps value between given bounds, used for limiting view to given boundaries
 * 1# eg. boundLimiter(2, 0, 3, true) => 2
 * 2# eg. boundLimiter(4, 0, 3, true) => 3
 * 3# eg. boundLimiter(-2, 0, 3, true) => 0
 * 4# eg. boundLimiter(10, 0, 3, false) => 10
 */ var $fcbc91b54b018d11$var$boundLimiter = function(value, minBound, maxBound, isActive) {
    if (!isActive) return $fcbc91b54b018d11$var$roundNumber(value, 2);
    if (value < minBound) return $fcbc91b54b018d11$var$roundNumber(minBound, 2);
    if (value > maxBound) return $fcbc91b54b018d11$var$roundNumber(maxBound, 2);
    return $fcbc91b54b018d11$var$roundNumber(value, 2);
};
var $fcbc91b54b018d11$var$handleCalculateBounds = function(contextInstance, newScale) {
    var bounds = $fcbc91b54b018d11$var$calculateBounds(contextInstance, newScale);
    // Save bounds
    contextInstance.bounds = bounds;
    return bounds;
};
function $fcbc91b54b018d11$var$getMouseBoundedPosition(positionX, positionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent) {
    var minPositionX = bounds.minPositionX, minPositionY = bounds.minPositionY, maxPositionX = bounds.maxPositionX, maxPositionY = bounds.maxPositionY;
    var paddingX = 0;
    var paddingY = 0;
    if (wrapperComponent) {
        paddingX = paddingValueX;
        paddingY = paddingValueY;
    }
    var x = $fcbc91b54b018d11$var$boundLimiter(positionX, minPositionX - paddingX, maxPositionX + paddingX, limitToBounds);
    var y = $fcbc91b54b018d11$var$boundLimiter(positionY, minPositionY - paddingY, maxPositionY + paddingY, limitToBounds);
    return {
        x: x,
        y: y
    };
}
function $fcbc91b54b018d11$var$handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds) {
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDifference = newScale - scale;
    if (typeof mouseX !== "number" || typeof mouseY !== "number") {
        console.error("Mouse X and Y position were not provided!");
        return {
            x: positionX,
            y: positionY
        };
    }
    var calculatedPositionX = positionX - mouseX * scaleDifference;
    var calculatedPositionY = positionY - mouseY * scaleDifference;
    // do not limit to bounds when there is padding animation,
    // it causes animation strange behaviour
    var newPositions = $fcbc91b54b018d11$var$getMouseBoundedPosition(calculatedPositionX, calculatedPositionY, bounds, limitToBounds, 0, 0, null);
    return newPositions;
}
function $fcbc91b54b018d11$var$checkZoomBounds(zoom, minScale, maxScale, zoomPadding, enablePadding) {
    var scalePadding = enablePadding ? zoomPadding : 0;
    var minScaleWithPadding = minScale - scalePadding;
    if (!Number.isNaN(maxScale) && zoom >= maxScale) return maxScale;
    if (!Number.isNaN(minScale) && zoom <= minScaleWithPadding) return minScaleWithPadding;
    return zoom;
}
var $fcbc91b54b018d11$var$isPanningStartAllowed = function(contextInstance, event) {
    var excluded = contextInstance.setup.panning.excluded;
    var isInitialized = contextInstance.isInitialized, wrapperComponent = contextInstance.wrapperComponent;
    var target = event.target;
    var targetIsShadowDom = "shadowRoot" in target && "composedPath" in event;
    var isWrapperChild = targetIsShadowDom ? event.composedPath().some(function(el) {
        if (!(el instanceof Element)) return false;
        return wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(el);
    }) : wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild;
    if (!isAllowed) return false;
    var isExcluded = $fcbc91b54b018d11$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $fcbc91b54b018d11$var$isPanningAllowed = function(contextInstance) {
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning, setup = contextInstance.setup;
    var disabled = setup.panning.disabled;
    var isAllowed = isInitialized && isPanning && !disabled;
    if (!isAllowed) return false;
    return true;
};
var $fcbc91b54b018d11$var$handlePanningSetup = function(contextInstance, event) {
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    // Panning with mouse
    var x = event.clientX;
    var y = event.clientY;
    contextInstance.startCoords = {
        x: x - positionX,
        y: y - positionY
    };
};
var $fcbc91b54b018d11$var$handleTouchPanningSetup = function(contextInstance, event) {
    var touches = event.touches;
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    // Panning with touch
    var oneFingerTouch = touches.length === 1;
    if (oneFingerTouch) {
        var x = touches[0].clientX;
        var y = touches[0].clientY;
        contextInstance.startCoords = {
            x: x - positionX,
            y: y - positionY
        };
    }
};
function $fcbc91b54b018d11$var$handlePanToBounds(contextInstance) {
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
    var _b = contextInstance.setup, disabled = _b.disabled, limitToBounds = _b.limitToBounds, centerZoomedOut = _b.centerZoomedOut;
    var wrapperComponent = contextInstance.wrapperComponent;
    if (disabled || !wrapperComponent || !contextInstance.bounds) return;
    var _c = contextInstance.bounds, maxPositionX = _c.maxPositionX, minPositionX = _c.minPositionX, maxPositionY = _c.maxPositionY, minPositionY = _c.minPositionY;
    var xChanged = positionX > maxPositionX || positionX < minPositionX;
    var yChanged = positionY > maxPositionY || positionY < minPositionY;
    var mousePosX = positionX > maxPositionX ? wrapperComponent.offsetWidth : contextInstance.setup.minPositionX || 0;
    var mousePosY = positionY > maxPositionY ? wrapperComponent.offsetHeight : contextInstance.setup.minPositionY || 0;
    var _d = $fcbc91b54b018d11$var$handleCalculateZoomPositions(contextInstance, mousePosX, mousePosY, scale, contextInstance.bounds, limitToBounds || centerZoomedOut), x = _d.x, y = _d.y;
    return {
        scale: scale,
        positionX: xChanged ? x : positionX,
        positionY: yChanged ? y : positionY
    };
}
function $fcbc91b54b018d11$var$handleNewPosition(contextInstance, newPositionX, newPositionY, paddingValueX, paddingValueY) {
    var limitToBounds = contextInstance.setup.limitToBounds;
    var wrapperComponent = contextInstance.wrapperComponent, bounds = contextInstance.bounds;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (wrapperComponent === null || bounds === null || newPositionX === positionX && newPositionY === positionY) return;
    var _b = $fcbc91b54b018d11$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent), x = _b.x, y = _b.y;
    contextInstance.setTransformState(scale, x, y);
}
var $fcbc91b54b018d11$var$getPanningClientPosition = function(contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, transformState = contextInstance.transformState;
    var panning = contextInstance.setup.panning;
    var lockAxisX = panning.lockAxisX, lockAxisY = panning.lockAxisY;
    var positionX = transformState.positionX, positionY = transformState.positionY;
    if (!startCoords) return {
        x: positionX,
        y: positionY
    };
    var mouseX = clientX - startCoords.x;
    var mouseY = clientY - startCoords.y;
    var newPositionX = lockAxisX ? positionX : mouseX;
    var newPositionY = lockAxisY ? positionY : mouseY;
    return {
        x: newPositionX,
        y: newPositionY
    };
};
var $fcbc91b54b018d11$var$getPaddingValue = function(contextInstance, size) {
    var setup = contextInstance.setup, transformState = contextInstance.transformState;
    var scale = transformState.scale;
    var minScale = setup.minScale, disablePadding = setup.disablePadding;
    if (size > 0 && scale >= minScale && !disablePadding) return size;
    return 0;
};
var $fcbc91b54b018d11$var$isVelocityCalculationAllowed = function(contextInstance) {
    var mounted = contextInstance.mounted;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var scale = contextInstance.transformState.scale;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
    if (!isAllowed) return false;
    return true;
};
var $fcbc91b54b018d11$var$isVelocityAllowed = function(contextInstance) {
    var mounted = contextInstance.mounted, velocity = contextInstance.velocity, bounds = contextInstance.bounds;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var scale = contextInstance.transformState.scale;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
    if (!isAllowed) return false;
    if (!velocity || !bounds) return false;
    return true;
};
function $fcbc91b54b018d11$var$getVelocityMoveTime(contextInstance, velocity) {
    var velocityAnimation = contextInstance.setup.velocityAnimation;
    var equalToMove = velocityAnimation.equalToMove, animationTime = velocityAnimation.animationTime, sensitivity = velocityAnimation.sensitivity;
    if (equalToMove) return animationTime * velocity * sensitivity;
    return animationTime;
}
function $fcbc91b54b018d11$var$getVelocityPosition(newPosition, startPosition, currentPosition, isLocked, limitToBounds, minPosition, maxPosition, minTarget, maxTarget, step) {
    if (limitToBounds) {
        if (startPosition > maxPosition && currentPosition > maxPosition) {
            var calculatedPosition = maxPosition + (newPosition - maxPosition) * step;
            if (calculatedPosition > maxTarget) return maxTarget;
            if (calculatedPosition < maxPosition) return maxPosition;
            return calculatedPosition;
        }
        if (startPosition < minPosition && currentPosition < minPosition) {
            var calculatedPosition = minPosition + (newPosition - minPosition) * step;
            if (calculatedPosition < minTarget) return minTarget;
            if (calculatedPosition > minPosition) return minPosition;
            return calculatedPosition;
        }
    }
    if (isLocked) return startPosition;
    return $fcbc91b54b018d11$var$boundLimiter(newPosition, minPosition, maxPosition, limitToBounds);
}
function $fcbc91b54b018d11$var$getSizeMultiplier(wrapperComponent, equalToMove) {
    var defaultMultiplier = 1;
    if (equalToMove) return Math.min(defaultMultiplier, wrapperComponent.offsetWidth / window.innerWidth);
    return defaultMultiplier;
}
function $fcbc91b54b018d11$var$handleCalculateVelocity(contextInstance, position) {
    var isAllowed = $fcbc91b54b018d11$var$isVelocityCalculationAllowed(contextInstance);
    if (!isAllowed) return;
    var lastMousePosition = contextInstance.lastMousePosition, velocityTime = contextInstance.velocityTime, setup = contextInstance.setup;
    var wrapperComponent = contextInstance.wrapperComponent;
    var equalToMove = setup.velocityAnimation.equalToMove;
    var now = Date.now();
    if (lastMousePosition && velocityTime && wrapperComponent) {
        var sizeMultiplier = $fcbc91b54b018d11$var$getSizeMultiplier(wrapperComponent, equalToMove);
        var distanceX = position.x - lastMousePosition.x;
        var distanceY = position.y - lastMousePosition.y;
        var velocityX = distanceX / sizeMultiplier;
        var velocityY = distanceY / sizeMultiplier;
        var interval = now - velocityTime;
        var speed = distanceX * distanceX + distanceY * distanceY;
        var velocity = Math.sqrt(speed) / interval;
        contextInstance.velocity = {
            velocityX: velocityX,
            velocityY: velocityY,
            total: velocity
        };
    }
    contextInstance.lastMousePosition = position;
    contextInstance.velocityTime = now;
}
function $fcbc91b54b018d11$var$handleVelocityPanning(contextInstance) {
    var velocity = contextInstance.velocity, bounds = contextInstance.bounds, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var isAllowed = $fcbc91b54b018d11$var$isVelocityAllowed(contextInstance);
    if (!isAllowed || !velocity || !bounds || !wrapperComponent) return;
    var velocityX = velocity.velocityX, velocityY = velocity.velocityY, total = velocity.total;
    var maxPositionX = bounds.maxPositionX, minPositionX = bounds.minPositionX, maxPositionY = bounds.maxPositionY, minPositionY = bounds.minPositionY;
    var limitToBounds = setup.limitToBounds, alignmentAnimation = setup.alignmentAnimation;
    var zoomAnimation = setup.zoomAnimation, panning = setup.panning;
    var lockAxisY = panning.lockAxisY, lockAxisX = panning.lockAxisX;
    var animationType = zoomAnimation.animationType;
    var sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, velocityAlignmentTime = alignmentAnimation.velocityAlignmentTime;
    var alignAnimationTime = velocityAlignmentTime;
    var moveAnimationTime = $fcbc91b54b018d11$var$getVelocityMoveTime(contextInstance, total);
    var finalAnimationTime = Math.max(moveAnimationTime, alignAnimationTime);
    var paddingValueX = $fcbc91b54b018d11$var$getPaddingValue(contextInstance, sizeX);
    var paddingValueY = $fcbc91b54b018d11$var$getPaddingValue(contextInstance, sizeY);
    var paddingX = paddingValueX * wrapperComponent.offsetWidth / 100;
    var paddingY = paddingValueY * wrapperComponent.offsetHeight / 100;
    var maxTargetX = maxPositionX + paddingX;
    var minTargetX = minPositionX - paddingX;
    var maxTargetY = maxPositionY + paddingY;
    var minTargetY = minPositionY - paddingY;
    var startState = contextInstance.transformState;
    var startTime = new Date().getTime();
    $fcbc91b54b018d11$var$handleSetupAnimation(contextInstance, animationType, finalAnimationTime, function(step) {
        var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / alignAnimationTime;
        var alignAnimation = $fcbc91b54b018d11$var$animations[alignmentAnimation.animationType];
        var alignStep = 1 - alignAnimation(Math.min(1, animationProgress));
        var customStep = 1 - step;
        var newPositionX = positionX + velocityX * customStep;
        var newPositionY = positionY + velocityY * customStep;
        var currentPositionX = $fcbc91b54b018d11$var$getVelocityPosition(newPositionX, startState.positionX, positionX, lockAxisX, limitToBounds, minPositionX, maxPositionX, minTargetX, maxTargetX, alignStep);
        var currentPositionY = $fcbc91b54b018d11$var$getVelocityPosition(newPositionY, startState.positionY, positionY, lockAxisY, limitToBounds, minPositionY, maxPositionY, minTargetY, maxTargetY, alignStep);
        if (positionX !== newPositionX || positionY !== newPositionY) contextInstance.setTransformState(scale, currentPositionX, currentPositionY);
    });
}
function $fcbc91b54b018d11$var$handlePanningStart(contextInstance, event) {
    var scale = contextInstance.transformState.scale;
    $fcbc91b54b018d11$var$handleCancelAnimation(contextInstance);
    $fcbc91b54b018d11$var$handleCalculateBounds(contextInstance, scale);
    if (window.TouchEvent !== undefined && event instanceof TouchEvent) $fcbc91b54b018d11$var$handleTouchPanningSetup(contextInstance, event);
    else $fcbc91b54b018d11$var$handlePanningSetup(contextInstance, event);
}
function $fcbc91b54b018d11$var$handleAlignToBounds(contextInstance) {
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, minScale = _a.minScale, alignmentAnimation = _a.alignmentAnimation;
    var disabled = alignmentAnimation.disabled, sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, animationTime = alignmentAnimation.animationTime, animationType = alignmentAnimation.animationType;
    var isDisabled = disabled || scale < minScale || !sizeX && !sizeY;
    if (isDisabled) return;
    var targetState = $fcbc91b54b018d11$var$handlePanToBounds(contextInstance);
    if (targetState) $fcbc91b54b018d11$var$animate(contextInstance, targetState, animationTime, animationType);
}
function $fcbc91b54b018d11$var$handlePanning(contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, setup = contextInstance.setup;
    var _a = setup.alignmentAnimation, sizeX = _a.sizeX, sizeY = _a.sizeY;
    if (!startCoords) return;
    var _b = $fcbc91b54b018d11$var$getPanningClientPosition(contextInstance, clientX, clientY), x = _b.x, y = _b.y;
    var paddingValueX = $fcbc91b54b018d11$var$getPaddingValue(contextInstance, sizeX);
    var paddingValueY = $fcbc91b54b018d11$var$getPaddingValue(contextInstance, sizeY);
    $fcbc91b54b018d11$var$handleCalculateVelocity(contextInstance, {
        x: x,
        y: y
    });
    $fcbc91b54b018d11$var$handleNewPosition(contextInstance, x, y, paddingValueX, paddingValueY);
}
function $fcbc91b54b018d11$var$handlePanningEnd(contextInstance) {
    if (contextInstance.isPanning) {
        var velocityDisabled = contextInstance.setup.panning.velocityDisabled;
        var velocity = contextInstance.velocity, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        contextInstance.isPanning = false;
        contextInstance.animate = false;
        contextInstance.animation = null;
        var wrapperRect = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.getBoundingClientRect();
        var contentRect = contentComponent === null || contentComponent === void 0 ? void 0 : contentComponent.getBoundingClientRect();
        var wrapperWidth = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.width) || 0;
        var wrapperHeight = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.height) || 0;
        var contentWidth = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.width) || 0;
        var contentHeight = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.height) || 0;
        var isZoomed = wrapperWidth < contentWidth || wrapperHeight < contentHeight;
        var shouldAnimate = !velocityDisabled && velocity && (velocity === null || velocity === void 0 ? void 0 : velocity.total) > 0.1 && isZoomed;
        if (shouldAnimate) $fcbc91b54b018d11$var$handleVelocityPanning(contextInstance);
        else $fcbc91b54b018d11$var$handleAlignToBounds(contextInstance);
    }
}
function $fcbc91b54b018d11$var$handleZoomToPoint(contextInstance, scale, mouseX, mouseY) {
    var _a = contextInstance.setup, minScale = _a.minScale, maxScale = _a.maxScale, limitToBounds = _a.limitToBounds;
    var newScale = $fcbc91b54b018d11$var$checkZoomBounds($fcbc91b54b018d11$var$roundNumber(scale, 2), minScale, maxScale, 0, false);
    var bounds = $fcbc91b54b018d11$var$handleCalculateBounds(contextInstance, newScale);
    var _b = $fcbc91b54b018d11$var$handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds), x = _b.x, y = _b.y;
    return {
        scale: newScale,
        positionX: x,
        positionY: y
    };
}
function $fcbc91b54b018d11$var$handleAlignToScaleBounds(contextInstance, mousePositionX, mousePositionY) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.setup, minScale = _a.minScale, limitToBounds = _a.limitToBounds, zoomAnimation = _a.zoomAnimation;
    var disabled = zoomAnimation.disabled, animationTime = zoomAnimation.animationTime, animationType = zoomAnimation.animationType;
    var isDisabled = disabled || scale >= minScale;
    if (scale >= 1 || limitToBounds) // fire fit to bounds animation
    $fcbc91b54b018d11$var$handleAlignToBounds(contextInstance);
    if (isDisabled || !wrapperComponent || !contextInstance.mounted) return;
    var mouseX = mousePositionX || wrapperComponent.offsetWidth / 2;
    var mouseY = mousePositionY || wrapperComponent.offsetHeight / 2;
    var targetState = $fcbc91b54b018d11$var$handleZoomToPoint(contextInstance, minScale, mouseX, mouseY);
    if (targetState) $fcbc91b54b018d11$var$animate(contextInstance, targetState, animationTime, animationType);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $fcbc91b54b018d11$var$__assign = function() {
    $fcbc91b54b018d11$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fcbc91b54b018d11$var$__assign.apply(this, arguments);
};
function $fcbc91b54b018d11$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $fcbc91b54b018d11$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var $fcbc91b54b018d11$var$initialState = {
    previousScale: 1,
    scale: 1,
    positionX: 0,
    positionY: 0
};
var $fcbc91b54b018d11$var$initialSetup = {
    disabled: false,
    minPositionX: null,
    maxPositionX: null,
    minPositionY: null,
    maxPositionY: null,
    minScale: 1,
    maxScale: 8,
    limitToBounds: true,
    centerZoomedOut: false,
    centerOnInit: false,
    disablePadding: false,
    smooth: true,
    wheel: {
        step: 0.2,
        disabled: false,
        smoothStep: 0.001,
        wheelDisabled: false,
        touchPadDisabled: false,
        activationKeys: [],
        excluded: []
    },
    panning: {
        disabled: false,
        velocityDisabled: false,
        lockAxisX: false,
        lockAxisY: false,
        allowLeftClickPan: true,
        allowMiddleClickPan: true,
        allowRightClickPan: true,
        wheelPanning: false,
        activationKeys: [],
        excluded: []
    },
    pinch: {
        step: 5,
        disabled: false,
        excluded: []
    },
    doubleClick: {
        disabled: false,
        step: 0.7,
        mode: "zoomIn",
        animationType: "easeOut",
        animationTime: 200,
        excluded: []
    },
    zoomAnimation: {
        disabled: false,
        size: 0.4,
        animationTime: 200,
        animationType: "easeOut"
    },
    alignmentAnimation: {
        disabled: false,
        sizeX: 100,
        sizeY: 100,
        animationTime: 200,
        velocityAlignmentTime: 400,
        animationType: "easeOut"
    },
    velocityAnimation: {
        disabled: false,
        sensitivity: 1,
        animationTime: 400,
        animationType: "easeOut",
        equalToMove: true
    }
};
var $fcbc91b54b018d11$var$baseClasses = {
    wrapperClass: "react-transform-wrapper",
    contentClass: "react-transform-component"
};
var $fcbc91b54b018d11$var$createState = function(props) {
    var _a, _b, _c, _d;
    return {
        previousScale: (_a = props.initialScale) !== null && _a !== void 0 ? _a : $fcbc91b54b018d11$var$initialState.scale,
        scale: (_b = props.initialScale) !== null && _b !== void 0 ? _b : $fcbc91b54b018d11$var$initialState.scale,
        positionX: (_c = props.initialPositionX) !== null && _c !== void 0 ? _c : $fcbc91b54b018d11$var$initialState.positionX,
        positionY: (_d = props.initialPositionY) !== null && _d !== void 0 ? _d : $fcbc91b54b018d11$var$initialState.positionY
    };
};
var $fcbc91b54b018d11$var$createSetup = function(props) {
    var newSetup = $fcbc91b54b018d11$var$__assign({}, $fcbc91b54b018d11$var$initialSetup);
    Object.keys(props).forEach(function(key) {
        var validValue = typeof props[key] !== "undefined";
        var validParameter = typeof $fcbc91b54b018d11$var$initialSetup[key] !== "undefined";
        if (validParameter && validValue) {
            var dataType = Object.prototype.toString.call($fcbc91b54b018d11$var$initialSetup[key]);
            var isObject = dataType === "[object Object]";
            var isArray = dataType === "[object Array]";
            if (isObject) newSetup[key] = $fcbc91b54b018d11$var$__assign($fcbc91b54b018d11$var$__assign({}, $fcbc91b54b018d11$var$initialSetup[key]), props[key]);
            else if (isArray) newSetup[key] = $fcbc91b54b018d11$var$__spreadArray($fcbc91b54b018d11$var$__spreadArray([], $fcbc91b54b018d11$var$initialSetup[key], true), props[key], true);
            else newSetup[key] = props[key];
        }
    });
    return newSetup;
};
var $fcbc91b54b018d11$var$handleCalculateButtonZoom = function(contextInstance, delta, step) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, smooth = setup.smooth;
    var size = zoomAnimation.size;
    if (!wrapperComponent) throw new Error("Wrapper is not mounted");
    var targetScale = smooth ? scale * Math.exp(delta * step) : scale + delta * step;
    var newScale = $fcbc91b54b018d11$var$checkZoomBounds($fcbc91b54b018d11$var$roundNumber(targetScale, 3), minScale, maxScale, size, false);
    return newScale;
};
function $fcbc91b54b018d11$var$handleZoomToViewCenter(contextInstance, delta, step, animationTime, animationType) {
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (!wrapperComponent) return console.error("No WrapperComponent found");
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var mouseX = (wrapperWidth / 2 - positionX) / scale;
    var mouseY = (wrapperHeight / 2 - positionY) / scale;
    var newScale = $fcbc91b54b018d11$var$handleCalculateButtonZoom(contextInstance, delta, step);
    var targetState = $fcbc91b54b018d11$var$handleZoomToPoint(contextInstance, newScale, mouseX, mouseY);
    if (!targetState) return console.error("Error during zoom event. New transformation state was not calculated.");
    $fcbc91b54b018d11$var$animate(contextInstance, targetState, animationTime, animationType);
}
function $fcbc91b54b018d11$var$resetTransformations(contextInstance, animationTime, animationType, onResetTransformation) {
    var setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var limitToBounds = setup.limitToBounds;
    var initialTransformation = $fcbc91b54b018d11$var$createState(contextInstance.props);
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (!wrapperComponent) return;
    var newBounds = $fcbc91b54b018d11$var$calculateBounds(contextInstance, initialTransformation.scale);
    var boundedPositions = $fcbc91b54b018d11$var$getMouseBoundedPosition(initialTransformation.positionX, initialTransformation.positionY, newBounds, limitToBounds, 0, 0, wrapperComponent);
    var newState = {
        scale: initialTransformation.scale,
        positionX: boundedPositions.x,
        positionY: boundedPositions.y
    };
    if (scale === initialTransformation.scale && positionX === initialTransformation.positionX && positionY === initialTransformation.positionY) return;
    onResetTransformation === null || onResetTransformation === void 0 || onResetTransformation();
    $fcbc91b54b018d11$var$animate(contextInstance, newState, animationTime, animationType);
}
function $fcbc91b54b018d11$var$getOffset(element, wrapper, content, state) {
    var offset = element.getBoundingClientRect();
    var wrapperOffset = wrapper.getBoundingClientRect();
    var contentOffset = content.getBoundingClientRect();
    var xOff = wrapperOffset.x * state.scale;
    var yOff = wrapperOffset.y * state.scale;
    return {
        x: (offset.x - contentOffset.x + xOff) / state.scale,
        y: (offset.y - contentOffset.y + yOff) / state.scale
    };
}
function $fcbc91b54b018d11$var$calculateZoomToNode(contextInstance, node, customZoom) {
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent, transformState = contextInstance.transformState;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, minScale = _a.minScale, maxScale = _a.maxScale;
    if (!wrapperComponent || !contentComponent) return transformState;
    var wrapperRect = wrapperComponent.getBoundingClientRect();
    var nodeRect = node.getBoundingClientRect();
    var nodeOffset = $fcbc91b54b018d11$var$getOffset(node, wrapperComponent, contentComponent, transformState);
    var nodeLeft = nodeOffset.x;
    var nodeTop = nodeOffset.y;
    var nodeWidth = nodeRect.width / transformState.scale;
    var nodeHeight = nodeRect.height / transformState.scale;
    var scaleX = wrapperComponent.offsetWidth / nodeWidth;
    var scaleY = wrapperComponent.offsetHeight / nodeHeight;
    var newScale = $fcbc91b54b018d11$var$checkZoomBounds(customZoom || Math.min(scaleX, scaleY), minScale, maxScale, 0, false);
    var offsetX = (wrapperRect.width - nodeWidth * newScale) / 2;
    var offsetY = (wrapperRect.height - nodeHeight * newScale) / 2;
    var newPositionX = (wrapperRect.left - nodeLeft) * newScale + offsetX;
    var newPositionY = (wrapperRect.top - nodeTop) * newScale + offsetY;
    var bounds = $fcbc91b54b018d11$var$calculateBounds(contextInstance, newScale);
    var _b = $fcbc91b54b018d11$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, 0, 0, wrapperComponent), x = _b.x, y = _b.y;
    return {
        positionX: x,
        positionY: y,
        scale: newScale
    };
}
var $fcbc91b54b018d11$var$zoomIn = function(contextInstance) {
    return function(step, animationTime, animationType) {
        if (step === void 0) step = 0.5;
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        $fcbc91b54b018d11$var$handleZoomToViewCenter(contextInstance, 1, step, animationTime, animationType);
    };
};
var $fcbc91b54b018d11$var$zoomOut = function(contextInstance) {
    return function(step, animationTime, animationType) {
        if (step === void 0) step = 0.5;
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        $fcbc91b54b018d11$var$handleZoomToViewCenter(contextInstance, -1, step, animationTime, animationType);
    };
};
var $fcbc91b54b018d11$var$setTransform = function(contextInstance) {
    return function(newPositionX, newPositionY, newScale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
        var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        var disabled = contextInstance.setup.disabled;
        if (disabled || !wrapperComponent || !contentComponent) return;
        var targetState = {
            positionX: Number.isNaN(newPositionX) ? positionX : newPositionX,
            positionY: Number.isNaN(newPositionY) ? positionY : newPositionY,
            scale: Number.isNaN(newScale) ? scale : newScale
        };
        $fcbc91b54b018d11$var$animate(contextInstance, targetState, animationTime, animationType);
    };
};
var $fcbc91b54b018d11$var$resetTransform = function(contextInstance) {
    return function(animationTime, animationType) {
        if (animationTime === void 0) animationTime = 200;
        if (animationType === void 0) animationType = "easeOut";
        $fcbc91b54b018d11$var$resetTransformations(contextInstance, animationTime, animationType);
    };
};
var $fcbc91b54b018d11$var$centerView = function(contextInstance) {
    return function(scale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 200;
        if (animationType === void 0) animationType = "easeOut";
        var transformState = contextInstance.transformState, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        if (wrapperComponent && contentComponent) {
            var targetState = $fcbc91b54b018d11$export$a51b33620579dad4(scale || transformState.scale, wrapperComponent, contentComponent);
            $fcbc91b54b018d11$var$animate(contextInstance, targetState, animationTime, animationType);
        }
    };
};
var $fcbc91b54b018d11$var$zoomToElement = function(contextInstance) {
    return function(node, scale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 600;
        if (animationType === void 0) animationType = "easeOut";
        $fcbc91b54b018d11$var$handleCancelAnimation(contextInstance);
        var wrapperComponent = contextInstance.wrapperComponent;
        var target = typeof node === "string" ? document.getElementById(node) : node;
        if (wrapperComponent && target && wrapperComponent.contains(target)) {
            var targetState = $fcbc91b54b018d11$var$calculateZoomToNode(contextInstance, target, scale);
            $fcbc91b54b018d11$var$animate(contextInstance, targetState, animationTime, animationType);
        }
    };
};
var $fcbc91b54b018d11$var$getControls = function(contextInstance) {
    return {
        instance: contextInstance,
        zoomIn: $fcbc91b54b018d11$var$zoomIn(contextInstance),
        zoomOut: $fcbc91b54b018d11$var$zoomOut(contextInstance),
        setTransform: $fcbc91b54b018d11$var$setTransform(contextInstance),
        resetTransform: $fcbc91b54b018d11$var$resetTransform(contextInstance),
        centerView: $fcbc91b54b018d11$var$centerView(contextInstance),
        zoomToElement: $fcbc91b54b018d11$var$zoomToElement(contextInstance)
    };
};
var $fcbc91b54b018d11$var$getState = function(contextInstance) {
    return {
        instance: contextInstance,
        state: contextInstance.transformState
    };
};
var $fcbc91b54b018d11$var$getContext = function(contextInstance) {
    var ref = {};
    Object.assign(ref, $fcbc91b54b018d11$var$getState(contextInstance));
    Object.assign(ref, $fcbc91b54b018d11$var$getControls(contextInstance));
    return ref;
};
// We want to make event listeners non-passive, and to do so have to check
// that browsers support EventListenerOptions in the first place.
// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
var $fcbc91b54b018d11$var$passiveSupported = false;
function $fcbc91b54b018d11$var$makePassiveEventOption() {
    try {
        var options = {
            get passive () {
                // This function will be called when the browser
                //   attempts to access the passive property.
                $fcbc91b54b018d11$var$passiveSupported = true;
                return false;
            }
        };
        return options;
    } catch (err) {
        $fcbc91b54b018d11$var$passiveSupported = false;
        return $fcbc91b54b018d11$var$passiveSupported;
    }
}
var $fcbc91b54b018d11$var$matchPrefix = ".".concat($fcbc91b54b018d11$var$baseClasses.wrapperClass);
var $fcbc91b54b018d11$var$isExcludedNode = function(node, excluded) {
    return excluded.some(function(exclude) {
        return node.matches("".concat($fcbc91b54b018d11$var$matchPrefix, " ").concat(exclude, ", ").concat($fcbc91b54b018d11$var$matchPrefix, " .").concat(exclude, ", ").concat($fcbc91b54b018d11$var$matchPrefix, " ").concat(exclude, " *, ").concat($fcbc91b54b018d11$var$matchPrefix, " .").concat(exclude, " *"));
    });
};
var $fcbc91b54b018d11$var$cancelTimeout = function(timeout) {
    if (timeout) clearTimeout(timeout);
};
var $fcbc91b54b018d11$export$c15ec262effbd456 = function(x, y, scale) {
    // Standard translate prevents blurry svg on the safari
    return "translate(".concat(x, "px, ").concat(y, "px) scale(").concat(scale, ")");
};
var $fcbc91b54b018d11$export$3b94f66093db6f05 = function(x, y, scale) {
    // The shorthand for matrix does not work for Safari hence the need to explicitly use matrix3d
    // Refer to https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/matrix
    var a = scale;
    var b = 0;
    var c = 0;
    var d = scale;
    var tx = x;
    var ty = y;
    return "matrix3d(".concat(a, ", ").concat(b, ", 0, 0, ").concat(c, ", ").concat(d, ", 0, 0, 0, 0, 1, 0, ").concat(tx, ", ").concat(ty, ", 0, 1)");
};
var $fcbc91b54b018d11$export$a51b33620579dad4 = function(scale, wrapperComponent, contentComponent) {
    var contentWidth = contentComponent.offsetWidth * scale;
    var contentHeight = contentComponent.offsetHeight * scale;
    var centerPositionX = (wrapperComponent.offsetWidth - contentWidth) / 2;
    var centerPositionY = (wrapperComponent.offsetHeight - contentHeight) / 2;
    return {
        scale: scale,
        positionX: centerPositionX,
        positionY: centerPositionY
    };
};
function $fcbc91b54b018d11$var$mergeRefs(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
var $fcbc91b54b018d11$var$isWheelAllowed = function(contextInstance, event) {
    var _a = contextInstance.setup.wheel, disabled = _a.disabled, wheelDisabled = _a.wheelDisabled, touchPadDisabled = _a.touchPadDisabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning;
    var target = event.target;
    var isAllowed = isInitialized && !isPanning && !disabled && target;
    if (!isAllowed) return false;
    // Event ctrlKey detects if touchpad action is executing wheel or pinch gesture
    if (wheelDisabled && !event.ctrlKey) return false;
    if (touchPadDisabled && event.ctrlKey) return false;
    var isExcluded = $fcbc91b54b018d11$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $fcbc91b54b018d11$var$getDeltaY = function(event) {
    if (event) return event.deltaY < 0 ? 1 : -1;
    return 0;
};
function $fcbc91b54b018d11$var$getDelta(event, customDelta) {
    var deltaY = $fcbc91b54b018d11$var$getDeltaY(event);
    var delta = $fcbc91b54b018d11$var$checkIsNumber(customDelta, deltaY);
    return delta;
}
function $fcbc91b54b018d11$var$getMousePosition(event, contentComponent, scale) {
    var contentRect = contentComponent.getBoundingClientRect();
    var mouseX = 0;
    var mouseY = 0;
    if ("clientX" in event) {
        // mouse position x, y over wrapper component
        mouseX = (event.clientX - contentRect.left) / scale;
        mouseY = (event.clientY - contentRect.top) / scale;
    } else {
        var touch = event.touches[0];
        mouseX = (touch.clientX - contentRect.left) / scale;
        mouseY = (touch.clientY - contentRect.top) / scale;
    }
    if (Number.isNaN(mouseX) || Number.isNaN(mouseY)) console.error("No mouse or touch offset found");
    return {
        x: mouseX,
        y: mouseY
    };
}
var $fcbc91b54b018d11$var$handleCalculateWheelZoom = function(contextInstance, delta, step, disable, getTarget) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, disablePadding = setup.disablePadding;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!wrapperComponent) throw new Error("Wrapper is not mounted");
    var targetScale = scale + delta * step;
    if (getTarget) return targetScale;
    var paddingEnabled = disable ? false : !disabled;
    var newScale = $fcbc91b54b018d11$var$checkZoomBounds($fcbc91b54b018d11$var$roundNumber(targetScale, 3), minScale, maxScale, size, paddingEnabled && !disablePadding);
    return newScale;
};
var $fcbc91b54b018d11$var$handleWheelZoomStop = function(contextInstance, event) {
    var previousWheelEvent = contextInstance.previousWheelEvent;
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, maxScale = _a.maxScale, minScale = _a.minScale;
    if (!previousWheelEvent) return false;
    if (scale < maxScale || scale > minScale) return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY)) return true;
    if (previousWheelEvent.deltaY > 0 && previousWheelEvent.deltaY < event.deltaY) return true;
    if (previousWheelEvent.deltaY < 0 && previousWheelEvent.deltaY > event.deltaY) return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY)) return true;
    return false;
};
var $fcbc91b54b018d11$var$isPinchStartAllowed = function(contextInstance, event) {
    var _a = contextInstance.setup.pinch, disabled = _a.disabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized;
    var target = event.target;
    var isAllowed = isInitialized && !disabled && target;
    if (!isAllowed) return false;
    var isExcluded = $fcbc91b54b018d11$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $fcbc91b54b018d11$var$isPinchAllowed = function(contextInstance) {
    var disabled = contextInstance.setup.pinch.disabled;
    var isInitialized = contextInstance.isInitialized, pinchStartDistance = contextInstance.pinchStartDistance;
    var isAllowed = isInitialized && !disabled && pinchStartDistance;
    if (!isAllowed) return false;
    return true;
};
var $fcbc91b54b018d11$var$calculateTouchMidPoint = function(event, scale, contentComponent) {
    var contentRect = contentComponent.getBoundingClientRect();
    var touches = event.touches;
    var firstPointX = $fcbc91b54b018d11$var$roundNumber(touches[0].clientX - contentRect.left, 5);
    var firstPointY = $fcbc91b54b018d11$var$roundNumber(touches[0].clientY - contentRect.top, 5);
    var secondPointX = $fcbc91b54b018d11$var$roundNumber(touches[1].clientX - contentRect.left, 5);
    var secondPointY = $fcbc91b54b018d11$var$roundNumber(touches[1].clientY - contentRect.top, 5);
    return {
        x: (firstPointX + secondPointX) / 2 / scale,
        y: (firstPointY + secondPointY) / 2 / scale
    };
};
var $fcbc91b54b018d11$var$getTouchDistance = function(event) {
    return Math.sqrt(Math.pow(event.touches[0].pageX - event.touches[1].pageX, 2) + Math.pow(event.touches[0].pageY - event.touches[1].pageY, 2));
};
var $fcbc91b54b018d11$var$calculatePinchZoom = function(contextInstance, currentDistance) {
    var pinchStartScale = contextInstance.pinchStartScale, pinchStartDistance = contextInstance.pinchStartDistance, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, disablePadding = setup.disablePadding;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!pinchStartScale || pinchStartDistance === null || !currentDistance) throw new Error("Pinch touches distance was not provided");
    if (currentDistance < 0) return contextInstance.transformState.scale;
    var touchProportion = currentDistance / pinchStartDistance;
    var scaleDifference = touchProportion * pinchStartScale;
    return $fcbc91b54b018d11$var$checkZoomBounds($fcbc91b54b018d11$var$roundNumber(scaleDifference, 2), minScale, maxScale, size, !disabled && !disablePadding);
};
var $fcbc91b54b018d11$var$wheelStopEventTime = 160;
var $fcbc91b54b018d11$var$wheelAnimationTime = 100;
var $fcbc91b54b018d11$var$handleWheelStart = function(contextInstance, event) {
    var _a = contextInstance.props, onWheelStart = _a.onWheelStart, onZoomStart = _a.onZoomStart;
    if (!contextInstance.wheelStopEventTimer) {
        $fcbc91b54b018d11$var$handleCancelAnimation(contextInstance);
        $fcbc91b54b018d11$var$handleCallback($fcbc91b54b018d11$var$getContext(contextInstance), event, onWheelStart);
        $fcbc91b54b018d11$var$handleCallback($fcbc91b54b018d11$var$getContext(contextInstance), event, onZoomStart);
    }
};
var $fcbc91b54b018d11$var$handleWheelZoom = function(contextInstance, event) {
    var _a = contextInstance.props, onWheel = _a.onWheel, onZoom = _a.onZoom;
    var contentComponent = contextInstance.contentComponent, setup = contextInstance.setup, transformState = contextInstance.transformState;
    var scale = transformState.scale;
    var limitToBounds = setup.limitToBounds, centerZoomedOut = setup.centerZoomedOut, zoomAnimation = setup.zoomAnimation, wheel = setup.wheel, disablePadding = setup.disablePadding, smooth = setup.smooth;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    var step = wheel.step, smoothStep = wheel.smoothStep;
    if (!contentComponent) throw new Error("Component not mounted");
    event.preventDefault();
    event.stopPropagation();
    var delta = $fcbc91b54b018d11$var$getDelta(event, null);
    var zoomStep = smooth ? smoothStep * Math.abs(event.deltaY) : step;
    var newScale = $fcbc91b54b018d11$var$handleCalculateWheelZoom(contextInstance, delta, zoomStep, !event.ctrlKey);
    // if scale not change
    if (scale === newScale) return;
    var bounds = $fcbc91b54b018d11$var$handleCalculateBounds(contextInstance, newScale);
    var mousePosition = $fcbc91b54b018d11$var$getMousePosition(event, contentComponent, scale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut || disablePadding;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = $fcbc91b54b018d11$var$handleCalculateZoomPositions(contextInstance, mousePosition.x, mousePosition.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.previousWheelEvent = event;
    contextInstance.setTransformState(newScale, x, y);
    $fcbc91b54b018d11$var$handleCallback($fcbc91b54b018d11$var$getContext(contextInstance), event, onWheel);
    $fcbc91b54b018d11$var$handleCallback($fcbc91b54b018d11$var$getContext(contextInstance), event, onZoom);
};
var $fcbc91b54b018d11$var$handleWheelStop = function(contextInstance, event) {
    var _a = contextInstance.props, onWheelStop = _a.onWheelStop, onZoomStop = _a.onZoomStop;
    // fire animation
    $fcbc91b54b018d11$var$cancelTimeout(contextInstance.wheelAnimationTimer);
    contextInstance.wheelAnimationTimer = setTimeout(function() {
        if (!contextInstance.mounted) return;
        $fcbc91b54b018d11$var$handleAlignToScaleBounds(contextInstance, event.x, event.y);
        contextInstance.wheelAnimationTimer = null;
    }, $fcbc91b54b018d11$var$wheelAnimationTime);
    // Wheel stop event
    var hasStoppedZooming = $fcbc91b54b018d11$var$handleWheelZoomStop(contextInstance, event);
    if (hasStoppedZooming) {
        $fcbc91b54b018d11$var$cancelTimeout(contextInstance.wheelStopEventTimer);
        contextInstance.wheelStopEventTimer = setTimeout(function() {
            if (!contextInstance.mounted) return;
            contextInstance.wheelStopEventTimer = null;
            $fcbc91b54b018d11$var$handleCallback($fcbc91b54b018d11$var$getContext(contextInstance), event, onWheelStop);
            $fcbc91b54b018d11$var$handleCallback($fcbc91b54b018d11$var$getContext(contextInstance), event, onZoomStop);
        }, $fcbc91b54b018d11$var$wheelStopEventTime);
    }
};
var $fcbc91b54b018d11$var$getTouchCenter = function(event) {
    var totalX = 0;
    var totalY = 0;
    // Sum up the positions of all touches
    for(var i = 0; i < 2; i += 1){
        totalX += event.touches[i].clientX;
        totalY += event.touches[i].clientY;
    }
    // Calculate the average position
    var x = totalX / 2;
    var y = totalY / 2;
    return {
        x: x,
        y: y
    };
};
var $fcbc91b54b018d11$var$handlePinchStart = function(contextInstance, event) {
    var distance = $fcbc91b54b018d11$var$getTouchDistance(event);
    contextInstance.pinchStartDistance = distance;
    contextInstance.lastDistance = distance;
    contextInstance.pinchStartScale = contextInstance.transformState.scale;
    contextInstance.isPanning = false;
    var center = $fcbc91b54b018d11$var$getTouchCenter(event);
    contextInstance.pinchLastCenterX = center.x;
    contextInstance.pinchLastCenterY = center.y;
    $fcbc91b54b018d11$var$handleCancelAnimation(contextInstance);
};
var $fcbc91b54b018d11$var$handlePinchZoom = function(contextInstance, event) {
    var contentComponent = contextInstance.contentComponent, pinchStartDistance = contextInstance.pinchStartDistance, wrapperComponent = contextInstance.wrapperComponent;
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, centerZoomedOut = _a.centerZoomedOut, zoomAnimation = _a.zoomAnimation, alignmentAnimation = _a.alignmentAnimation;
    var disabled = zoomAnimation.disabled, size = zoomAnimation.size;
    // if one finger starts from outside of wrapper
    if (pinchStartDistance === null || !contentComponent) return;
    var midPoint = $fcbc91b54b018d11$var$calculateTouchMidPoint(event, scale, contentComponent);
    // if touches goes off of the wrapper element
    if (!Number.isFinite(midPoint.x) || !Number.isFinite(midPoint.y)) return;
    var currentDistance = $fcbc91b54b018d11$var$getTouchDistance(event);
    var newScale = $fcbc91b54b018d11$var$calculatePinchZoom(contextInstance, currentDistance);
    var center = $fcbc91b54b018d11$var$getTouchCenter(event);
    // pan should be scale invariant.
    var panX = center.x - (contextInstance.pinchLastCenterX || 0);
    var panY = center.y - (contextInstance.pinchLastCenterY || 0);
    if (newScale === scale && panX === 0 && panY === 0) return;
    contextInstance.pinchLastCenterX = center.x;
    contextInstance.pinchLastCenterY = center.y;
    var bounds = $fcbc91b54b018d11$var$handleCalculateBounds(contextInstance, newScale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = $fcbc91b54b018d11$var$handleCalculateZoomPositions(contextInstance, midPoint.x, midPoint.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.pinchMidpoint = midPoint;
    contextInstance.lastDistance = currentDistance;
    var sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY;
    var paddingValueX = $fcbc91b54b018d11$var$getPaddingValue(contextInstance, sizeX);
    var paddingValueY = $fcbc91b54b018d11$var$getPaddingValue(contextInstance, sizeY);
    var newPositionX = x + panX;
    var newPositionY = y + panY;
    var _c = $fcbc91b54b018d11$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent), finalX = _c.x, finalY = _c.y;
    contextInstance.setTransformState(newScale, finalX, finalY);
};
var $fcbc91b54b018d11$var$handlePinchStop = function(contextInstance) {
    var pinchMidpoint = contextInstance.pinchMidpoint;
    contextInstance.velocity = null;
    contextInstance.lastDistance = null;
    contextInstance.pinchMidpoint = null;
    contextInstance.pinchStartScale = null;
    contextInstance.pinchStartDistance = null;
    $fcbc91b54b018d11$var$handleAlignToScaleBounds(contextInstance, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.x, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.y);
};
var $fcbc91b54b018d11$var$handleDoubleClickStop = function(contextInstance, event) {
    var onZoomStop = contextInstance.props.onZoomStop;
    var animationTime = contextInstance.setup.doubleClick.animationTime;
    $fcbc91b54b018d11$var$cancelTimeout(contextInstance.doubleClickStopEventTimer);
    contextInstance.doubleClickStopEventTimer = setTimeout(function() {
        contextInstance.doubleClickStopEventTimer = null;
        $fcbc91b54b018d11$var$handleCallback($fcbc91b54b018d11$var$getContext(contextInstance), event, onZoomStop);
    }, animationTime);
};
var $fcbc91b54b018d11$var$handleDoubleClickResetMode = function(contextInstance, event) {
    var _a = contextInstance.props, onZoomStart = _a.onZoomStart, onZoom = _a.onZoom;
    var _b = contextInstance.setup.doubleClick, animationTime = _b.animationTime, animationType = _b.animationType;
    $fcbc91b54b018d11$var$handleCallback($fcbc91b54b018d11$var$getContext(contextInstance), event, onZoomStart);
    $fcbc91b54b018d11$var$resetTransformations(contextInstance, animationTime, animationType, function() {
        return $fcbc91b54b018d11$var$handleCallback($fcbc91b54b018d11$var$getContext(contextInstance), event, onZoom);
    });
    $fcbc91b54b018d11$var$handleDoubleClickStop(contextInstance, event);
};
function $fcbc91b54b018d11$var$getDoubleClickScale(mode, scale) {
    if (mode === "toggle") return scale === 1 ? 1 : -1;
    return mode === "zoomOut" ? -1 : 1;
}
function $fcbc91b54b018d11$var$handleDoubleClick(contextInstance, event) {
    var setup = contextInstance.setup, doubleClickStopEventTimer = contextInstance.doubleClickStopEventTimer, transformState = contextInstance.transformState, contentComponent = contextInstance.contentComponent;
    var scale = transformState.scale;
    var _a = contextInstance.props, onZoomStart = _a.onZoomStart, onZoom = _a.onZoom;
    var _b = setup.doubleClick, disabled = _b.disabled, mode = _b.mode, step = _b.step, animationTime = _b.animationTime, animationType = _b.animationType;
    if (disabled) return;
    if (doubleClickStopEventTimer) return;
    if (mode === "reset") return $fcbc91b54b018d11$var$handleDoubleClickResetMode(contextInstance, event);
    if (!contentComponent) return console.error("No ContentComponent found");
    var delta = $fcbc91b54b018d11$var$getDoubleClickScale(mode, contextInstance.transformState.scale);
    var newScale = $fcbc91b54b018d11$var$handleCalculateButtonZoom(contextInstance, delta, step);
    // stop execution when scale didn't change
    if (scale === newScale) return;
    $fcbc91b54b018d11$var$handleCallback($fcbc91b54b018d11$var$getContext(contextInstance), event, onZoomStart);
    var mousePosition = $fcbc91b54b018d11$var$getMousePosition(event, contentComponent, scale);
    var targetState = $fcbc91b54b018d11$var$handleZoomToPoint(contextInstance, newScale, mousePosition.x, mousePosition.y);
    if (!targetState) return console.error("Error during zoom event. New transformation state was not calculated.");
    $fcbc91b54b018d11$var$handleCallback($fcbc91b54b018d11$var$getContext(contextInstance), event, onZoom);
    $fcbc91b54b018d11$var$animate(contextInstance, targetState, animationTime, animationType);
    $fcbc91b54b018d11$var$handleDoubleClickStop(contextInstance, event);
}
var $fcbc91b54b018d11$var$isDoubleClickAllowed = function(contextInstance, event) {
    var isInitialized = contextInstance.isInitialized, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var _a = setup.doubleClick, disabled = _a.disabled, excluded = _a.excluded;
    var target = event.target;
    var isWrapperChild = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild && !disabled;
    if (!isAllowed) return false;
    var isExcluded = $fcbc91b54b018d11$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $fcbc91b54b018d11$var$ZoomPanPinch = /** @class */ function() {
    function ZoomPanPinch(props) {
        var _this = this;
        this.mounted = true;
        this.pinchLastCenterX = null;
        this.pinchLastCenterY = null;
        this.onChangeCallbacks = new Set();
        this.onInitCallbacks = new Set();
        // Components
        this.wrapperComponent = null;
        this.contentComponent = null;
        // Initialization
        this.isInitialized = false;
        this.bounds = null;
        // wheel helpers
        this.previousWheelEvent = null;
        this.wheelStopEventTimer = null;
        this.wheelAnimationTimer = null;
        // panning helpers
        this.isPanning = false;
        this.isWheelPanning = false;
        this.startCoords = null;
        this.lastTouch = null;
        // pinch helpers
        this.distance = null;
        this.lastDistance = null;
        this.pinchStartDistance = null;
        this.pinchStartScale = null;
        this.pinchMidpoint = null;
        // double click helpers
        this.doubleClickStopEventTimer = null;
        // velocity helpers
        this.velocity = null;
        this.velocityTime = null;
        this.lastMousePosition = null;
        // animations helpers
        this.animate = false;
        this.animation = null;
        this.maxBounds = null;
        // key press
        this.pressedKeys = {};
        this.mount = function() {
            _this.initializeWindowEvents();
        };
        this.unmount = function() {
            _this.cleanupWindowEvents();
        };
        this.update = function(newProps) {
            _this.props = newProps;
            $fcbc91b54b018d11$var$handleCalculateBounds(_this, _this.transformState.scale);
            _this.setup = $fcbc91b54b018d11$var$createSetup(newProps);
        };
        this.initializeWindowEvents = function() {
            var _a, _b;
            var passive = $fcbc91b54b018d11$var$makePassiveEventOption();
            var currentDocument = (_a = _this.wrapperComponent) === null || _a === void 0 ? void 0 : _a.ownerDocument;
            var currentWindow = currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.defaultView;
            (_b = _this.wrapperComponent) === null || _b === void 0 || _b.addEventListener("wheel", _this.onWheelPanning, passive);
            // Panning on window to allow panning when mouse is out of component wrapper
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mousedown", _this.onPanningStart, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mousemove", _this.onPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mouseup", _this.onPanningStop, passive);
            currentDocument === null || currentDocument === void 0 || currentDocument.addEventListener("mouseleave", _this.clearPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("keyup", _this.setKeyUnPressed, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("keydown", _this.setKeyPressed, passive);
        };
        this.cleanupWindowEvents = function() {
            var _a, _b;
            var passive = $fcbc91b54b018d11$var$makePassiveEventOption();
            var currentDocument = (_a = _this.wrapperComponent) === null || _a === void 0 ? void 0 : _a.ownerDocument;
            var currentWindow = currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.defaultView;
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mousedown", _this.onPanningStart, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mousemove", _this.onPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mouseup", _this.onPanningStop, passive);
            currentDocument === null || currentDocument === void 0 || currentDocument.removeEventListener("mouseleave", _this.clearPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("keyup", _this.setKeyUnPressed, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("keydown", _this.setKeyPressed, passive);
            document.removeEventListener("mouseleave", _this.clearPanning, passive);
            $fcbc91b54b018d11$var$handleCancelAnimation(_this);
            (_b = _this.observer) === null || _b === void 0 || _b.disconnect();
        };
        this.handleInitializeWrapperEvents = function(wrapper) {
            // Zooming events on wrapper
            var passive = $fcbc91b54b018d11$var$makePassiveEventOption();
            wrapper.addEventListener("wheel", _this.onWheelZoom, passive);
            wrapper.addEventListener("dblclick", _this.onDoubleClick, passive);
            wrapper.addEventListener("touchstart", _this.onTouchPanningStart, passive);
            wrapper.addEventListener("touchmove", _this.onTouchPanning, passive);
            wrapper.addEventListener("touchend", _this.onTouchPanningStop, passive);
        };
        this.handleInitialize = function(contentComponent) {
            var centerOnInit = _this.setup.centerOnInit;
            _this.applyTransformation();
            _this.onInitCallbacks.forEach(function(callback) {
                return callback($fcbc91b54b018d11$var$getContext(_this));
            });
            if (centerOnInit) {
                _this.setCenter();
                _this.observer = new ResizeObserver(function() {
                    var _a;
                    var currentWidth = contentComponent.offsetWidth;
                    var currentHeight = contentComponent.offsetHeight;
                    if (currentWidth > 0 || currentHeight > 0) {
                        _this.onInitCallbacks.forEach(function(callback) {
                            return callback($fcbc91b54b018d11$var$getContext(_this));
                        });
                        _this.setCenter();
                        (_a = _this.observer) === null || _a === void 0 || _a.disconnect();
                    }
                });
                // if nothing about the contentComponent has changed after 5 seconds, disconnect the observer
                setTimeout(function() {
                    var _a;
                    (_a = _this.observer) === null || _a === void 0 || _a.disconnect();
                }, 5000);
                // Start observing the target node for configured mutations
                _this.observer.observe(contentComponent);
            }
        };
        /// ///////
        // Zoom
        /// ///////
        this.onWheelZoom = function(event) {
            var disabled = _this.setup.disabled;
            if (disabled) return;
            var isAllowed = $fcbc91b54b018d11$var$isWheelAllowed(_this, event);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.wheel.activationKeys);
            if (!keysPressed) return;
            $fcbc91b54b018d11$var$handleWheelStart(_this, event);
            $fcbc91b54b018d11$var$handleWheelZoom(_this, event);
            $fcbc91b54b018d11$var$handleWheelStop(_this, event);
        };
        /// ///////
        // Pan
        /// ///////
        this.onWheelPanning = function(event) {
            var _a = _this.setup, disabled = _a.disabled, wheel = _a.wheel, panning = _a.panning;
            if (!_this.wrapperComponent || !_this.contentComponent || disabled || !wheel.wheelDisabled || panning.disabled || !panning.wheelPanning || event.ctrlKey) return;
            event.preventDefault();
            event.stopPropagation();
            var _b = _this.transformState, positionX = _b.positionX, positionY = _b.positionY;
            var mouseX = positionX - event.deltaX;
            var mouseY = positionY - event.deltaY;
            var newPositionX = panning.lockAxisX ? positionX : mouseX;
            var newPositionY = panning.lockAxisY ? positionY : mouseY;
            var _c = _this.setup.alignmentAnimation, sizeX = _c.sizeX, sizeY = _c.sizeY;
            var paddingValueX = $fcbc91b54b018d11$var$getPaddingValue(_this, sizeX);
            var paddingValueY = $fcbc91b54b018d11$var$getPaddingValue(_this, sizeY);
            if (newPositionX === positionX && newPositionY === positionY) return;
            $fcbc91b54b018d11$var$handleNewPosition(_this, newPositionX, newPositionY, paddingValueX, paddingValueY);
        };
        this.onPanningStart = function(event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled) return;
            var isAllowed = $fcbc91b54b018d11$var$isPanningStartAllowed(_this, event);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed) return;
            if (event.button === 0 && !_this.setup.panning.allowLeftClickPan) return;
            if (event.button === 1 && !_this.setup.panning.allowMiddleClickPan) return;
            if (event.button === 2 && !_this.setup.panning.allowRightClickPan) return;
            event.preventDefault();
            event.stopPropagation();
            $fcbc91b54b018d11$var$handleCancelAnimation(_this);
            $fcbc91b54b018d11$var$handlePanningStart(_this, event);
            $fcbc91b54b018d11$var$handleCallback($fcbc91b54b018d11$var$getContext(_this), event, onPanningStart);
        };
        this.onPanning = function(event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (disabled) return;
            var isAllowed = $fcbc91b54b018d11$var$isPanningAllowed(_this);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed) return;
            event.preventDefault();
            event.stopPropagation();
            $fcbc91b54b018d11$var$handlePanning(_this, event.clientX, event.clientY);
            $fcbc91b54b018d11$var$handleCallback($fcbc91b54b018d11$var$getContext(_this), event, onPanning);
        };
        this.onPanningStop = function(event) {
            var onPanningStop = _this.props.onPanningStop;
            if (_this.isPanning) {
                $fcbc91b54b018d11$var$handlePanningEnd(_this);
                $fcbc91b54b018d11$var$handleCallback($fcbc91b54b018d11$var$getContext(_this), event, onPanningStop);
            }
        };
        /// ///////
        // Pinch
        /// ///////
        this.onPinchStart = function(event) {
            var disabled = _this.setup.disabled;
            var _a = _this.props, onPinchingStart = _a.onPinchingStart, onZoomStart = _a.onZoomStart;
            if (disabled) return;
            var isAllowed = $fcbc91b54b018d11$var$isPinchStartAllowed(_this, event);
            if (!isAllowed) return;
            $fcbc91b54b018d11$var$handlePinchStart(_this, event);
            $fcbc91b54b018d11$var$handleCancelAnimation(_this);
            $fcbc91b54b018d11$var$handleCallback($fcbc91b54b018d11$var$getContext(_this), event, onPinchingStart);
            $fcbc91b54b018d11$var$handleCallback($fcbc91b54b018d11$var$getContext(_this), event, onZoomStart);
        };
        this.onPinch = function(event) {
            var disabled = _this.setup.disabled;
            var _a = _this.props, onPinching = _a.onPinching, onZoom = _a.onZoom;
            if (disabled) return;
            var isAllowed = $fcbc91b54b018d11$var$isPinchAllowed(_this);
            if (!isAllowed) return;
            event.preventDefault();
            event.stopPropagation();
            $fcbc91b54b018d11$var$handlePinchZoom(_this, event);
            $fcbc91b54b018d11$var$handleCallback($fcbc91b54b018d11$var$getContext(_this), event, onPinching);
            $fcbc91b54b018d11$var$handleCallback($fcbc91b54b018d11$var$getContext(_this), event, onZoom);
        };
        this.onPinchStop = function(event) {
            var _a = _this.props, onPinchingStop = _a.onPinchingStop, onZoomStop = _a.onZoomStop;
            if (_this.pinchStartScale) {
                $fcbc91b54b018d11$var$handlePinchStop(_this);
                $fcbc91b54b018d11$var$handleCallback($fcbc91b54b018d11$var$getContext(_this), event, onPinchingStop);
                $fcbc91b54b018d11$var$handleCallback($fcbc91b54b018d11$var$getContext(_this), event, onZoomStop);
            }
        };
        /// ///////
        // Touch
        /// ///////
        this.onTouchPanningStart = function(event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled) return;
            var isAllowed = $fcbc91b54b018d11$var$isPanningStartAllowed(_this, event);
            if (!isAllowed) return;
            var isDoubleTap = _this.lastTouch && +new Date() - _this.lastTouch < 200;
            if (!isDoubleTap) {
                _this.lastTouch = +new Date();
                $fcbc91b54b018d11$var$handleCancelAnimation(_this);
                var touches = event.touches;
                var isPanningAction = touches.length === 1;
                var isPinchAction = touches.length === 2;
                if (isPanningAction) {
                    $fcbc91b54b018d11$var$handleCancelAnimation(_this);
                    $fcbc91b54b018d11$var$handlePanningStart(_this, event);
                    $fcbc91b54b018d11$var$handleCallback($fcbc91b54b018d11$var$getContext(_this), event, onPanningStart);
                }
                if (isPinchAction) _this.onPinchStart(event);
            }
        };
        this.onTouchPanning = function(event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (_this.isPanning && event.touches.length === 1) {
                if (disabled) return;
                var isAllowed = $fcbc91b54b018d11$var$isPanningAllowed(_this);
                if (!isAllowed) return;
                event.preventDefault();
                event.stopPropagation();
                var touch = event.touches[0];
                $fcbc91b54b018d11$var$handlePanning(_this, touch.clientX, touch.clientY);
                $fcbc91b54b018d11$var$handleCallback($fcbc91b54b018d11$var$getContext(_this), event, onPanning);
            } else if (event.touches.length > 1) _this.onPinch(event);
        };
        this.onTouchPanningStop = function(event) {
            _this.onPanningStop(event);
            _this.onPinchStop(event);
        };
        /// ///////
        // Double Click
        /// ///////
        this.onDoubleClick = function(event) {
            var disabled = _this.setup.disabled;
            if (disabled) return;
            var isAllowed = $fcbc91b54b018d11$var$isDoubleClickAllowed(_this, event);
            if (!isAllowed) return;
            $fcbc91b54b018d11$var$handleDoubleClick(_this, event);
        };
        /// ///////
        // Helpers
        /// ///////
        this.clearPanning = function(event) {
            if (_this.isPanning) _this.onPanningStop(event);
        };
        this.setKeyPressed = function(e) {
            _this.pressedKeys[e.key] = true;
        };
        this.setKeyUnPressed = function(e) {
            _this.pressedKeys[e.key] = false;
        };
        this.isPressingKeys = function(keys) {
            if (!keys.length) return true;
            return Boolean(keys.find(function(key) {
                return _this.pressedKeys[key];
            }));
        };
        this.setTransformState = function(scale, positionX, positionY) {
            var onTransformed = _this.props.onTransformed;
            if (!Number.isNaN(scale) && !Number.isNaN(positionX) && !Number.isNaN(positionY)) {
                if (scale !== _this.transformState.scale) {
                    _this.transformState.previousScale = _this.transformState.scale;
                    _this.transformState.scale = scale;
                }
                _this.transformState.positionX = positionX;
                _this.transformState.positionY = positionY;
                _this.applyTransformation();
                var ctx_1 = $fcbc91b54b018d11$var$getContext(_this);
                _this.onChangeCallbacks.forEach(function(callback) {
                    return callback(ctx_1);
                });
                $fcbc91b54b018d11$var$handleCallback(ctx_1, {
                    scale: scale,
                    positionX: positionX,
                    positionY: positionY
                }, onTransformed);
            } else console.error("Detected NaN set state values");
        };
        this.setCenter = function() {
            if (_this.wrapperComponent && _this.contentComponent) {
                var targetState = $fcbc91b54b018d11$export$a51b33620579dad4(_this.transformState.scale, _this.wrapperComponent, _this.contentComponent);
                _this.setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
            }
        };
        this.handleTransformStyles = function(x, y, scale) {
            if (_this.props.customTransform) return _this.props.customTransform(x, y, scale);
            return $fcbc91b54b018d11$export$c15ec262effbd456(x, y, scale);
        };
        this.applyTransformation = function() {
            if (!_this.mounted || !_this.contentComponent) return;
            var _a = _this.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
            var transform = _this.handleTransformStyles(positionX, positionY, scale);
            _this.contentComponent.style.transform = transform;
        };
        this.getContext = function() {
            return $fcbc91b54b018d11$var$getContext(_this);
        };
        /**
         * Hooks
         */ this.onChange = function(callback) {
            if (!_this.onChangeCallbacks.has(callback)) _this.onChangeCallbacks.add(callback);
            return function() {
                _this.onChangeCallbacks.delete(callback);
            };
        };
        this.onInit = function(callback) {
            if (!_this.onInitCallbacks.has(callback)) _this.onInitCallbacks.add(callback);
            return function() {
                _this.onInitCallbacks.delete(callback);
            };
        };
        /**
         * Initialization
         */ this.init = function(wrapperComponent, contentComponent) {
            _this.cleanupWindowEvents();
            _this.wrapperComponent = wrapperComponent;
            _this.contentComponent = contentComponent;
            $fcbc91b54b018d11$var$handleCalculateBounds(_this, _this.transformState.scale);
            _this.handleInitializeWrapperEvents(wrapperComponent);
            _this.handleInitialize(contentComponent);
            _this.initializeWindowEvents();
            _this.isInitialized = true;
            var ctx = $fcbc91b54b018d11$var$getContext(_this);
            $fcbc91b54b018d11$var$handleCallback(ctx, undefined, _this.props.onInit);
        };
        this.props = props;
        this.setup = $fcbc91b54b018d11$var$createSetup(this.props);
        this.transformState = $fcbc91b54b018d11$var$createState(this.props);
    }
    return ZoomPanPinch;
}();
var $fcbc91b54b018d11$export$841858b892ce1f4c = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createContext(null);
var $fcbc91b54b018d11$var$getContent = function(children, ctx) {
    if (typeof children === "function") return children(ctx);
    return children;
};
var $fcbc91b54b018d11$export$51cb649375dcd655 = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function(props, ref) {
    var instance = (0, $iSvIT.useRef)(new $fcbc91b54b018d11$var$ZoomPanPinch(props)).current;
    var content = $fcbc91b54b018d11$var$getContent(props.children, $fcbc91b54b018d11$var$getControls(instance));
    (0, $iSvIT.useImperativeHandle)(ref, function() {
        return $fcbc91b54b018d11$var$getControls(instance);
    }, [
        instance
    ]);
    (0, $iSvIT.useEffect)(function() {
        instance.update(props);
    }, [
        instance,
        props
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($fcbc91b54b018d11$export$841858b892ce1f4c.Provider, {
        value: instance
    }, content);
});
var $fcbc91b54b018d11$export$cbc53e226f857b23 = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function(props, ref) {
    var localRef = (0, $iSvIT.useRef)(null);
    var instance = (0, $iSvIT.useContext)($fcbc91b54b018d11$export$841858b892ce1f4c);
    (0, $iSvIT.useEffect)(function() {
        return instance.onChange(function(ctx) {
            if (localRef.current) {
                var positionX = 0;
                var positionY = 0;
                localRef.current.style.transform = instance.handleTransformStyles(positionX, positionY, 1 / ctx.instance.transformState.scale);
            }
        });
    }, [
        instance
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", $fcbc91b54b018d11$var$__assign({}, props, {
        ref: $fcbc91b54b018d11$var$mergeRefs([
            localRef,
            ref
        ])
    }));
});
var $fcbc91b54b018d11$var$initialElementRect = {
    width: 0,
    height: 0,
    y: 0,
    x: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
};
var $fcbc91b54b018d11$var$useResize = function(ref, onResize, dependencies) {
    var resizeObserverRef = (0, $iSvIT.useRef)();
    var rectRef = (0, $iSvIT.useRef)($fcbc91b54b018d11$var$initialElementRect);
    var didUnmount = (0, $iSvIT.useRef)(false);
    (0, $iSvIT.useLayoutEffect)(function() {
        var _a;
        didUnmount.current = false;
        if (!("ResizeObserver" in window)) return;
        if (ref) {
            resizeObserverRef.current = new ResizeObserver(function(entries) {
                var newSize = ref.getBoundingClientRect();
                if (!Array.isArray(entries) || !entries.length || didUnmount.current || newSize.width === rectRef.current.width && newSize.height === rectRef.current.height) return;
                onResize(newSize, ref);
                rectRef.current = newSize;
            });
            (_a = resizeObserverRef.current) === null || _a === void 0 || _a.observe(ref);
        }
        return function() {
            var _a;
            didUnmount.current = true;
            if (ref) (_a = resizeObserverRef.current) === null || _a === void 0 || _a.unobserve(ref);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $fcbc91b54b018d11$var$__spreadArray([
        onResize,
        ref
    ], dependencies, true));
};
var $fcbc91b54b018d11$var$previewStyles = {
    position: "absolute",
    zIndex: 2,
    top: "0px",
    left: "0px",
    boxSizing: "border-box",
    border: "3px solid red",
    transformOrigin: "0% 0%",
    boxShadow: "rgba(0,0,0,0.2) 0 0 0 10000000px"
};
var $fcbc91b54b018d11$export$a97dd8f3835953ef = function(_a) {
    var _b = _a.width, width = _b === void 0 ? 200 : _b, _c = _a.height, height = _c === void 0 ? 200 : _c, _d = _a.borderColor, borderColor = _d === void 0 ? "red" : _d, children = _a.children, rest = $fcbc91b54b018d11$var$__rest(_a, [
        "width",
        "height",
        "borderColor",
        "children"
    ]);
    var _e = (0, $iSvIT.useState)(false), initialized = _e[0], setInitialized = _e[1];
    var instance = $fcbc91b54b018d11$export$1708b11af87412f8();
    var miniMapInstance = (0, $iSvIT.useRef)(null);
    var mainRef = (0, $iSvIT.useRef)(null);
    var wrapperRef = (0, $iSvIT.useRef)(null);
    var previewRef = (0, $iSvIT.useRef)(null);
    var getViewportSize = (0, $iSvIT.useCallback)(function() {
        if (instance.wrapperComponent) {
            var rect = instance.wrapperComponent.getBoundingClientRect();
            return {
                width: rect.width,
                height: rect.height
            };
        }
        return {
            width: 0,
            height: 0
        };
    }, [
        instance.wrapperComponent
    ]);
    var getContentSize = (0, $iSvIT.useCallback)(function() {
        if (instance.contentComponent) {
            var rect = instance.contentComponent.getBoundingClientRect();
            return {
                width: rect.width / instance.transformState.scale,
                height: rect.height / instance.transformState.scale
            };
        }
        return {
            width: 0,
            height: 0
        };
    }, [
        instance.contentComponent,
        instance.transformState.scale
    ]);
    var computeMiniMapScale = (0, $iSvIT.useCallback)(function() {
        var contentSize = getContentSize();
        var scaleX = width / contentSize.width;
        var scaleY = height / contentSize.height;
        var scale = scaleY > scaleX ? scaleX : scaleY;
        return scale;
    }, [
        getContentSize,
        height,
        width
    ]);
    var computeMiniMapSize = function() {
        var contentSize = getContentSize();
        var scaleX = width / contentSize.width;
        var scaleY = height / contentSize.height;
        if (scaleY > scaleX) return {
            width: width,
            height: contentSize.height * scaleX
        };
        return {
            width: contentSize.width * scaleY,
            height: height
        };
    };
    var computeMiniMapStyle = function() {
        var scale = computeMiniMapScale();
        var style = {
            transform: "scale(".concat(scale || 1, ")"),
            transformOrigin: "0% 0%",
            position: "absolute",
            boxSizing: "border-box",
            zIndex: 1,
            overflow: "hidden"
        };
        Object.keys(style).forEach(function(key) {
            if (wrapperRef.current) wrapperRef.current.style[key] = style[key];
        });
    };
    var transformMiniMap = function() {
        computeMiniMapStyle();
        var miniSize = computeMiniMapSize();
        var wrapSize = getContentSize();
        if (wrapperRef.current) {
            wrapperRef.current.style.width = "".concat(wrapSize.width, "px");
            wrapperRef.current.style.height = "".concat(wrapSize.height, "px");
        }
        if (mainRef.current) {
            mainRef.current.style.width = "".concat(miniSize.width, "px");
            mainRef.current.style.height = "".concat(miniSize.height, "px");
        }
        if (previewRef.current) {
            var size = getViewportSize();
            var scale = computeMiniMapScale();
            var previewScale = scale * (1 / instance.transformState.scale);
            var transform = instance.handleTransformStyles(-instance.transformState.positionX * previewScale, -instance.transformState.positionY * previewScale, 1);
            previewRef.current.style.transform = transform;
            previewRef.current.style.width = "".concat(size.width * previewScale, "px");
            previewRef.current.style.height = "".concat(size.height * previewScale, "px");
        }
    };
    var initialize = function() {
        transformMiniMap();
    };
    $fcbc91b54b018d11$export$769cca75086a299c(function() {
        transformMiniMap();
    });
    $fcbc91b54b018d11$export$e14839139473133b(function() {
        initialize();
        setInitialized(true);
    });
    $fcbc91b54b018d11$var$useResize(instance.contentComponent, initialize, [
        initialized
    ]);
    (0, $iSvIT.useEffect)(function() {
        return instance.onChange(function(zpp) {
            var scale = computeMiniMapScale();
            if (miniMapInstance.current) {
                miniMapInstance.current.instance.transformState.scale = zpp.instance.transformState.scale;
                miniMapInstance.current.instance.transformState.positionX = zpp.instance.transformState.positionX * scale;
                miniMapInstance.current.instance.transformState.positionY = zpp.instance.transformState.positionY * scale;
            }
        });
    }, [
        computeMiniMapScale,
        instance,
        miniMapInstance
    ]);
    var wrapperStyle = (0, $iSvIT.useMemo)(function() {
        return {
            position: "relative",
            zIndex: 2,
            overflow: "hidden"
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", $fcbc91b54b018d11$var$__assign({}, rest, {
        ref: mainRef,
        style: wrapperStyle,
        className: "rzpp-mini-map ".concat(rest.className || "")
    }), (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", $fcbc91b54b018d11$var$__assign({}, rest, {
        ref: wrapperRef,
        className: "rzpp-wrapper"
    }), children), (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        className: "rzpp-preview",
        ref: previewRef,
        style: $fcbc91b54b018d11$var$__assign($fcbc91b54b018d11$var$__assign({}, $fcbc91b54b018d11$var$previewStyles), {
            borderColor: borderColor
        })
    }));
};
function $fcbc91b54b018d11$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") return;
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $fcbc91b54b018d11$var$css_248z = ".transform-component-module_wrapper__SPB86 {\n  position: relative;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  overflow: hidden;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n  margin: 0;\n  padding: 0;\n}\n.transform-component-module_content__FBWxo {\n  display: flex;\n  flex-wrap: wrap;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  margin: 0;\n  padding: 0;\n  transform-origin: 0% 0%;\n}\n.transform-component-module_content__FBWxo img {\n  pointer-events: none;\n}\n";
var $fcbc91b54b018d11$var$styles = {
    "wrapper": "transform-component-module_wrapper__SPB86",
    "content": "transform-component-module_content__FBWxo"
};
$fcbc91b54b018d11$var$styleInject($fcbc91b54b018d11$var$css_248z);
var $fcbc91b54b018d11$export$1def2aa75b7c7fe0 = function(_a) {
    var children = _a.children, _b = _a.wrapperClass, wrapperClass = _b === void 0 ? "" : _b, _c = _a.contentClass, contentClass = _c === void 0 ? "" : _c, wrapperStyle = _a.wrapperStyle, contentStyle = _a.contentStyle, _d = _a.wrapperProps, wrapperProps = _d === void 0 ? {} : _d, _e = _a.contentProps, contentProps = _e === void 0 ? {} : _e;
    var _f = (0, $iSvIT.useContext)($fcbc91b54b018d11$export$841858b892ce1f4c), init = _f.init, cleanupWindowEvents = _f.cleanupWindowEvents;
    var wrapperRef = (0, $iSvIT.useRef)(null);
    var contentRef = (0, $iSvIT.useRef)(null);
    (0, $iSvIT.useEffect)(function() {
        var wrapper = wrapperRef.current;
        var content = contentRef.current;
        if (wrapper !== null && content !== null && init) init === null || init === void 0 || init(wrapper, content);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        return function() {
            cleanupWindowEvents === null || cleanupWindowEvents === void 0 || cleanupWindowEvents();
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", $fcbc91b54b018d11$var$__assign({}, wrapperProps, {
        ref: wrapperRef,
        className: "".concat($fcbc91b54b018d11$var$baseClasses.wrapperClass, " ").concat($fcbc91b54b018d11$var$styles.wrapper, " ").concat(wrapperClass),
        style: wrapperStyle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", $fcbc91b54b018d11$var$__assign({}, contentProps, {
        ref: contentRef,
        className: "".concat($fcbc91b54b018d11$var$baseClasses.contentClass, " ").concat($fcbc91b54b018d11$var$styles.content, " ").concat(contentClass),
        style: contentStyle
    }), children));
};
var $fcbc91b54b018d11$export$1708b11af87412f8 = function() {
    var libraryContext = (0, $iSvIT.useContext)($fcbc91b54b018d11$export$841858b892ce1f4c);
    if (!libraryContext) throw new Error("Transform context must be placed inside TransformWrapper");
    return libraryContext;
};
var $fcbc91b54b018d11$export$8a75c83865bcf9dd = function() {
    var libraryContext = $fcbc91b54b018d11$export$1708b11af87412f8();
    return $fcbc91b54b018d11$var$getControls(libraryContext);
};
var $fcbc91b54b018d11$export$e14839139473133b = function(callback) {
    var libraryContext = $fcbc91b54b018d11$export$1708b11af87412f8();
    (0, $iSvIT.useEffect)(function() {
        var unmountCallback;
        var unmount;
        if (libraryContext.contentComponent && libraryContext.wrapperComponent) unmountCallback = callback($fcbc91b54b018d11$var$getState(libraryContext));
        else unmount = libraryContext.onInit(function(ref) {
            unmountCallback = callback($fcbc91b54b018d11$var$getState(ref.instance));
        });
        return function() {
            unmount === null || unmount === void 0 || unmount();
            unmountCallback === null || unmountCallback === void 0 || unmountCallback();
        };
    }, []);
};
var $fcbc91b54b018d11$export$769cca75086a299c = function(callback) {
    var libraryContext = $fcbc91b54b018d11$export$1708b11af87412f8();
    (0, $iSvIT.useEffect)(function() {
        var unmountCallback;
        var unmount = libraryContext.onChange(function(ref) {
            unmountCallback = callback($fcbc91b54b018d11$var$getState(ref.instance));
        });
        return function() {
            unmount();
            unmountCallback === null || unmountCallback === void 0 || unmountCallback();
        };
    }, [
        callback,
        libraryContext
    ]);
};
function $fcbc91b54b018d11$export$4915c4f91c47b682(callback) {
    var libraryContext = $fcbc91b54b018d11$export$1708b11af87412f8();
    var _a = (0, $iSvIT.useState)(callback($fcbc91b54b018d11$var$getState(libraryContext))), transformRender = _a[0], setTransformRender = _a[1];
    (0, $iSvIT.useEffect)(function() {
        var mounted = true;
        var unmount = libraryContext.onChange(function(ref) {
            if (mounted) setTransformRender(callback($fcbc91b54b018d11$var$getState(ref.instance)));
        });
        return function() {
            unmount();
            mounted = false;
        };
    }, [
        callback,
        libraryContext
    ]);
    return transformRender;
}

});

parcelRegister("kqt8V", function(module, exports) {

$parcel$export(module.exports, "ZoomIn", function () { return $27a6265f28c6db3d$export$d13069184bfa0730; });

var $loA2J = parcelRequire("loA2J");
const $27a6265f28c6db3d$export$d13069184bfa0730 = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        id: "icon-content-zoom in",
        width: size,
        height: size,
        viewBox: "0 0 62 63",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M59.66,53.76 C61.58,55.68 61.58,58.79 59.66,60.71 C57.74,62.63 54.63,62.63 52.71,60.71 L37.65,45.65 L44.6,38.7 L59.66,53.76 Z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M26.23,0.18 C40.72,0.18 52.46,11.93 52.46,26.42 C52.46,40.9 40.72,52.65 26.23,52.65 C11.74,52.65 0,40.9 0,26.42 C0,11.93 11.74,0.18 26.23,0.18 Z M46.97,26.42 C46.97,37.87 37.69,47.16 26.23,47.16 C14.78,47.16 5.49,37.87 5.49,26.42 C5.49,14.96 14.78,5.67 26.23,5.67 C37.69,5.67 46.97,14.96 46.97,26.42 Z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M26.23,47.16 C37.69,47.16 46.97,37.87 46.97,26.42 C46.97,14.96 37.69,5.67 26.23,5.67 C14.78,5.67 5.49,14.96 5.49,26.42 C5.49,37.87 14.78,47.16 26.23,47.16 Z M26.54,14.52 C28.05,14.52 29.28,15.75 29.28,17.26 L29.28,23.97 L35.99,23.97 C37.51,23.97 38.74,25.2 38.74,26.72 C38.74,28.24 37.51,29.46 35.99,29.46 L29.28,29.46 L29.28,36.18 C29.28,37.69 28.05,38.92 26.54,38.92 C25.02,38.92 23.79,37.69 23.79,36.18 L23.79,29.46 L17.08,29.46 C15.56,29.46 14.34,28.24 14.34,26.72 C14.34,25.2 15.56,23.97 17.08,23.97 L23.79,23.97 L23.79,17.26 C23.79,15.75 25.02,14.52 26.54,14.52 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });

});

parcelRegister("ik2oV", function(module, exports) {

$parcel$export(module.exports, "ZoomOut", function () { return $efe15ce6919f0663$export$adc4acb67269225; });

var $loA2J = parcelRequire("loA2J");
const $efe15ce6919f0663$export$adc4acb67269225 = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        id: "icon-content-zoom out",
        width: size,
        height: size,
        viewBox: "0 0 62 63",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M59.66,53.76 C61.58,55.68 61.58,58.79 59.66,60.71 C57.74,62.63 54.63,62.63 52.71,60.71 L37.33,45.33 L44.28,38.38 L59.66,53.76 Z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M52.46,26.42 C52.46,11.93 40.72,0.18 26.23,0.18 C11.74,0.18 0,11.93 0,26.42 C0,40.9 11.74,52.65 26.23,52.65 C40.72,52.65 52.46,40.9 52.46,26.42 Z M26.23,47.16 C37.69,47.16 46.97,37.87 46.97,26.42 C46.97,14.96 37.69,5.67 26.23,5.67 C14.78,5.67 5.49,14.96 5.49,26.42 C5.49,37.87 14.78,47.16 26.23,47.16 Z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M26.23,47.16 C37.69,47.16 46.97,37.87 46.97,26.42 C46.97,14.96 37.69,5.67 26.23,5.67 C14.78,5.67 5.49,14.96 5.49,26.42 C5.49,37.87 14.78,47.16 26.23,47.16 Z M38.74,26.72 C38.74,25.2 37.51,23.97 35.99,23.97 L17.08,23.97 L16.95,23.98 C15.5,24.05 14.34,25.25 14.34,26.72 C14.34,28.24 15.56,29.47 17.08,29.47 L35.99,29.47 L36.12,29.46 C37.58,29.39 38.74,28.19 38.74,26.72 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });

});


parcelRegister("jX9s2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $3acad4a414841778$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<90d50cdcf380b3a9fe613330e6d712ac>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3acad4a414841778$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templatePreviewContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "templateNameExternal",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "ProductTemplateTemplateTypeCollection",
            "kind": "LinkedField",
            "name": "templateTypeCollection",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaxonomyTemplateType",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Sys",
                            "kind": "LinkedField",
                            "name": "sys",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": "templatePreviews",
            "args": null,
            "concreteType": "AssetCollection",
            "kind": "LinkedField",
            "name": "templatePreviewCollection",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Asset",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "ProductTemplate",
    "abstractKey": null
};
$3acad4a414841778$var$node.hash = "dad8d8814494331f36c5867d050c8524";
var $3acad4a414841778$export$2e2bcd8739ae039 = $3acad4a414841778$var$node;

});


parcelRegister("267RQ", function(module, exports) {

$parcel$export(module.exports, "TemplateRelatedTemplates", function () { return $cac52137e6d04ec8$export$7e056a1cce206233; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");

var $1XyNv = parcelRequire("1XyNv");

var $5ohHq = parcelRequire("5ohHq");

var $iIoKV = parcelRequire("iIoKV");
var $cac52137e6d04ec8$var$_templateRelatedTemplatesContentfulRelayFragment;
const $cac52137e6d04ec8$var$tabbedSectionHeading = null;
const $cac52137e6d04ec8$var$relatedTemplatesStyles = null;
const $cac52137e6d04ec8$var$relatedTemplatesMobileStyles = null;
const $cac52137e6d04ec8$var$relatedSectionStyles = null;
const $cac52137e6d04ec8$var$buttonLeft = null;
const $cac52137e6d04ec8$var$buttonRight = null;
const $cac52137e6d04ec8$var$buttonLeftArrow = null;
const $cac52137e6d04ec8$var$buttonRightArrow = null;
const $cac52137e6d04ec8$var$LeftArrow = ({ onClick: onClick, label: label })=>/*#__PURE__*/ (0, $loA2J.jsx)("button", {
        onClick: onClick,
        "aria-label": label,
        className: (0, $esG4f.default)([
            "_bfhkcd5j _1e0c1ule _vchhusvi _1e02idpf _152t1ssb _1bsbzwfg _4t3izwfg _19itglyw _16qs1a7r _t9ec1krs _2rko1ssb _12ji1r31 _1qu2glyw _12y31o36 _80omtlke _syazrbzz _vwz4an13 _1pbykb7n _1wpz1h6o"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            className: (0, $esG4f.default)([
                "_t9eczk8b _1bsb1crf _4t3i1crf _1e0c1o8l _vwz4idpf _kqswstnw _1pfhyjp0 _ahbqmyb0 _vchhusvi _mqm2pqxa _191wpqxa _1wyb7vkz"
            ])
        })
    });
const $cac52137e6d04ec8$var$RightArrow = ({ onClick: onClick, label: label })=>/*#__PURE__*/ (0, $loA2J.jsx)("button", {
        onClick: onClick,
        "aria-label": label,
        className: (0, $esG4f.default)([
            "_bfhkcd5j _vchhusvi _1e0c1ule _rjxpidpf _152t1ssb _1bsbzwfg _4t3izwfg _19itglyw _16qs1a7r _t9ec1krs _2rko1ssb _12ji1r31 _1qu2glyw _12y31o36 _80omtlke _syazrbzz _vwz4an13 _1pbykb7n _1wpz1h6o"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            className: (0, $esG4f.default)([
                "_t9ec1hke _1bsb1crf _4t3i1crf _1e0c1o8l _vwz4idpf _kqswstnw _1pfhyjp0 _ahbq1bs0 _vchhusvi _mqm2pqxa _191wpqxa _1wyb7vkz"
            ])
        })
    });

const $cac52137e6d04ec8$var$TemplateRelatedTemplatesRelayFragment = $cac52137e6d04ec8$var$_templateRelatedTemplatesContentfulRelayFragment !== void 0 ? $cac52137e6d04ec8$var$_templateRelatedTemplatesContentfulRelayFragment : ($cac52137e6d04ec8$var$_templateRelatedTemplatesContentfulRelayFragment = (parcelRequire("PjKSP")), $cac52137e6d04ec8$var$_templateRelatedTemplatesContentfulRelayFragment.hash && $cac52137e6d04ec8$var$_templateRelatedTemplatesContentfulRelayFragment.hash !== "6fdcb09848f43d30eb54f40624d96941" && console.error("The definition of 'templateRelatedTemplatesContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $cac52137e6d04ec8$var$_templateRelatedTemplatesContentfulRelayFragment);
const $cac52137e6d04ec8$export$7e056a1cce206233 = ({ template: template })=>{
    const { relatedTemplatesCollection: relatedTemplatesCollection } = (0, $hOqV7.useFragment)($cac52137e6d04ec8$var$TemplateRelatedTemplatesRelayFragment, template);
    const intl = (0, $f6qj2.default)();
    const previousLabel = intl.formatMessage((0, $1XyNv.ConfluenceTemplateMessages).carouselPreviousLabel);
    const nextLabel = intl.formatMessage((0, $1XyNv.ConfluenceTemplateMessages).carouselNextLabel);
    const [currentIndex, setCurrentIndex] = (0, $iSvIT.useState)(0);
    const hasRelatedTemplates = relatedTemplatesCollection && relatedTemplatesCollection.items.length > 0;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1pfh68cl _ahbq1wug _12l21wug _476dvbgk"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_1wybahaf _vwz4yn4p _k48pbfng _1dyznl7k _syazdtn8 _ect41pz4 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1ylp _1cqs1k8s _1bys1m1q"
                ]),
                style: {
                    "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $1XyNv.ConfluenceTemplateMessages).relatedTemplatesTitle))
            }),
            hasRelatedTemplates && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0cglyw _dm251txw _pdlmzwfg"
                        ]),
                        children: [
                            currentIndex !== 0 && /*#__PURE__*/ (0, $loA2J.jsx)($cac52137e6d04ec8$var$LeftArrow, {
                                label: previousLabel,
                                onClick: ()=>{
                                    setCurrentIndex((prevIndex)=>(prevIndex - 1 + relatedTemplatesCollection.items.length) % relatedTemplatesCollection.items.length);
                                }
                            }),
                            relatedTemplatesCollection.items.slice(currentIndex, currentIndex + 2).map((relatedTemplate)=>{
                                var _relatedTemplate_sys;
                                return relatedTemplate && /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iIoKV.TemplateCard), {
                                        template: relatedTemplate
                                    })
                                }, (_relatedTemplate_sys = relatedTemplate.sys) === null || _relatedTemplate_sys === void 0 ? void 0 : _relatedTemplate_sys.id);
                            }),
                            currentIndex + 2 < relatedTemplatesCollection.items.length && /*#__PURE__*/ (0, $loA2J.jsx)($cac52137e6d04ec8$var$RightArrow, {
                                label: nextLabel,
                                onClick: ()=>{
                                    setCurrentIndex((prevIndex)=>(prevIndex + 1) % relatedTemplatesCollection.items.length);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_4cvr1h6o _1e0c1txw _1n261g80 _zulpzwfg _dm25glyw"
                        ]),
                        children: relatedTemplatesCollection.items.map((relatedTemplate)=>{
                            var _relatedTemplate_sys;
                            return relatedTemplate && /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iIoKV.TemplateCard), {
                                    template: relatedTemplate
                                })
                            }, (_relatedTemplate_sys = relatedTemplate.sys) === null || _relatedTemplate_sys === void 0 ? void 0 : _relatedTemplate_sys.id);
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("PjKSP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $4c80818db458ed37$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<5e5e20a65fa473102e66633a871353f8>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4c80818db458ed37$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateRelatedTemplatesContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "ProductTemplateRelatedTemplatesCollection",
            "kind": "LinkedField",
            "name": "relatedTemplatesCollection",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductTemplate",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Sys",
                            "kind": "LinkedField",
                            "name": "sys",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "templateCardContentfulRelayFragment"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "ProductTemplate",
    "abstractKey": null
};
$4c80818db458ed37$var$node.hash = "6fdcb09848f43d30eb54f40624d96941";
var $4c80818db458ed37$export$2e2bcd8739ae039 = $4c80818db458ed37$var$node;

});


parcelRegister("9AFPk", function(module, exports) {

$parcel$export(module.exports, "TemplateTabbedSection", function () { return $6c189e34a93e2bd8$export$c76d52df442babb1; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");

var $cyfPT = parcelRequire("cyfPT");

var $cutM5 = parcelRequire("cutM5");

var $A9zZc = parcelRequire("A9zZc");

var $cRwVc = parcelRequire("cRwVc");

var $9CA5V = parcelRequire("9CA5V");

var $cdeeW = parcelRequire("cdeeW");
var $6c189e34a93e2bd8$var$_templateTabbedSectionContentfulRelayFragment;
const $6c189e34a93e2bd8$var$tabStyles = null;
const $6c189e34a93e2bd8$var$currentStyle = null;
const $6c189e34a93e2bd8$var$tabSectionStyle = null;
const $6c189e34a93e2bd8$var$sectionStyles = null;
const $6c189e34a93e2bd8$var$styles = null;
const $6c189e34a93e2bd8$var$TabHeading = ({ title: title, isSelected: isSelected })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_bfhk150w _4cvr1h6o _1bah1h6o _vchhusvi _1e0c1txw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _1yt41ois _2rko17td _80omtlke _19itzv82 _1wybf6fq _bfw78djs _irr31ybm _30l317la",
            isSelected && "_19it8djs _bfhk1ybm _syaz17la",
            "h5"
        ]),
        style: {
            "--_8nj8hf": (0, $43MIc.default)((0, $cRwVc.default)("color.neutral.light200")),
            "--_514je1": (0, $43MIc.default)((0, $cRwVc.default)("corner.radius.pill")),
            "--_1r6llbg": (0, $43MIc.default)((0, $cRwVc.default)("color.primary.blue")),
            "--_1hkddbi": (0, $43MIc.default)((0, $cRwVc.default)("color.extended.blue100"))
        },
        children: title
    });
};

const $6c189e34a93e2bd8$var$TemplateTabbedSectionRelayFragment = $6c189e34a93e2bd8$var$_templateTabbedSectionContentfulRelayFragment !== void 0 ? $6c189e34a93e2bd8$var$_templateTabbedSectionContentfulRelayFragment : ($6c189e34a93e2bd8$var$_templateTabbedSectionContentfulRelayFragment = (parcelRequire("1RYwV")), $6c189e34a93e2bd8$var$_templateTabbedSectionContentfulRelayFragment.hash && $6c189e34a93e2bd8$var$_templateTabbedSectionContentfulRelayFragment.hash !== "9e2878135e8f926d46ac10f3a93bce05" && console.error("The definition of 'templateTabbedSectionContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $6c189e34a93e2bd8$var$_templateTabbedSectionContentfulRelayFragment); // eslint-disable-next-line complexity
const $6c189e34a93e2bd8$export$c76d52df442babb1 = ({ template: templateRef })=>{
    var _template_templateOverviewCollection, _template_templateOverviewCollection_items, _template_templateOverviewCollection1, _template_templateBenefitsCollection, _template_templateBenefitsCollection1, _template_templateBenefitsCollection_items, _template_templateBenefitsCollection2, _template_howToUseThisTemplateCollection, _template_howToUseThisTemplateCollection1, _template_howToUseThisTemplateCollection_items, _template_howToUseThisTemplateCollection2, _template_templateProductRationaleCollection, _template_templateProductRationaleCollection_items, _template_templateProductRationaleCollection1;
    const intl = (0, $f6qj2.default)();
    const template = (0, $hOqV7.useFragment)($6c189e34a93e2bd8$var$TemplateTabbedSectionRelayFragment, templateRef);
    const tabs = [
        {
            id: "tab1",
            title: intl.formatMessage({
                id: "ConfluenceTemplateMessages.tabs.overview.cfind.1508",
                defaultMessage: "Overview"
            }),
            hide: !((_template_templateOverviewCollection = template.templateOverviewCollection) === null || _template_templateOverviewCollection === void 0 ? void 0 : _template_templateOverviewCollection.items[0]),
            component: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
                className: (0, $esG4f.default)([
                    "_1pfh8vuz"
                ]),
                children: (_template_templateOverviewCollection1 = template.templateOverviewCollection) === null || _template_templateOverviewCollection1 === void 0 ? void 0 : (_template_templateOverviewCollection_items = _template_templateOverviewCollection1.items) === null || _template_templateOverviewCollection_items === void 0 ? void 0 : _template_templateOverviewCollection_items.map((overview, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                className: (0, $esG4f.default)([
                                    "_1wybahaf _vwz4yn4p _k48pbfng _1dyznl7k _syazdtn8 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1ylp _1kzs1k8s _16cb1m1q"
                                ]),
                                children: overview === null || overview === void 0 ? void 0 : overview.overviewTitle
                            }),
                            (overview === null || overview === void 0 ? void 0 : overview.overviewDescription) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $A9zZc.SanitizedRichText), {
                                innerHTML: (0, $cyfPT.richTextToHTML)(overview === null || overview === void 0 ? void 0 : overview.overviewDescription.json)
                            })
                        ]
                    }, `overview-${index}`))
            })
        },
        {
            id: "tab2",
            title: intl.formatMessage({
                id: "ConfluenceTemplateMessages.tabs.benefits.cfind.1508",
                defaultMessage: "Benefits"
            }),
            hide: !((_template_templateBenefitsCollection = template.templateBenefitsCollection) === null || _template_templateBenefitsCollection === void 0 ? void 0 : _template_templateBenefitsCollection.items) || ((_template_templateBenefitsCollection1 = template.templateBenefitsCollection) === null || _template_templateBenefitsCollection1 === void 0 ? void 0 : _template_templateBenefitsCollection1.items.length) === 0,
            component: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
                children: (_template_templateBenefitsCollection2 = template.templateBenefitsCollection) === null || _template_templateBenefitsCollection2 === void 0 ? void 0 : (_template_templateBenefitsCollection_items = _template_templateBenefitsCollection2.items) === null || _template_templateBenefitsCollection_items === void 0 ? void 0 : _template_templateBenefitsCollection_items.map((templateBenefitsContainer, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $9CA5V.TemplateBenefits), {
                        templateBenefits: templateBenefitsContainer
                    }, `benefits-${index}`))
            })
        },
        {
            id: "tab3",
            title: intl.formatMessage({
                id: "ConfluenceTemplateMessages.tabs.howTo.cfind.1508",
                defaultMessage: "How to"
            }),
            hide: !((_template_howToUseThisTemplateCollection = template.howToUseThisTemplateCollection) === null || _template_howToUseThisTemplateCollection === void 0 ? void 0 : _template_howToUseThisTemplateCollection.items) || ((_template_howToUseThisTemplateCollection1 = template.howToUseThisTemplateCollection) === null || _template_howToUseThisTemplateCollection1 === void 0 ? void 0 : _template_howToUseThisTemplateCollection1.items.length) === 0,
            component: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
                children: (_template_howToUseThisTemplateCollection2 = template.howToUseThisTemplateCollection) === null || _template_howToUseThisTemplateCollection2 === void 0 ? void 0 : (_template_howToUseThisTemplateCollection_items = _template_howToUseThisTemplateCollection2.items) === null || _template_howToUseThisTemplateCollection_items === void 0 ? void 0 : _template_howToUseThisTemplateCollection_items.map((templateGuide, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cdeeW.TemplateGuide), {
                        templateGuide: templateGuide
                    }, `how2use-${index}`))
            })
        },
        {
            id: "tab4",
            title: intl.formatMessage({
                id: "ConfluenceTemplateMessages.tabs.whyConfluence.cfind.1508",
                defaultMessage: "Why Confluence?"
            }),
            // temporary content for demoing... will be replaced with content from template object
            hide: !((_template_templateProductRationaleCollection = template.templateProductRationaleCollection) === null || _template_templateProductRationaleCollection === void 0 ? void 0 : _template_templateProductRationaleCollection.items),
            component: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
                className: (0, $esG4f.default)([
                    "_1pfh8vuz"
                ]),
                children: (_template_templateProductRationaleCollection1 = template.templateProductRationaleCollection) === null || _template_templateProductRationaleCollection1 === void 0 ? void 0 : (_template_templateProductRationaleCollection_items = _template_templateProductRationaleCollection1.items) === null || _template_templateProductRationaleCollection_items === void 0 ? void 0 : _template_templateProductRationaleCollection_items.map((rationale, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                className: (0, $esG4f.default)([
                                    "_1wybahaf _vwz4yn4p _k48pbfng _1dyznl7k _syazdtn8 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1ylp _1kzs1k8s _16cb1m1q"
                                ]),
                                children: rationale === null || rationale === void 0 ? void 0 : rationale.rationaleTitle
                            }),
                            (rationale === null || rationale === void 0 ? void 0 : rationale.templateProductRationaleDescription) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $A9zZc.SanitizedRichText), {
                                innerHTML: (0, $cyfPT.richTextToHTML)(rationale === null || rationale === void 0 ? void 0 : rationale.templateProductRationaleDescription.json)
                            })
                        ]
                    }, `rationale-${index}`))
            })
        }
    ];
    const renderTabbedSection = ()=>{
        return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cutM5.Adg4Tabs), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTabList), {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _e8gh1h6o"
                    ]),
                    children: tabs.filter((tab)=>!tab.hide).map((tab)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTab), {
                            title: tab.title,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)($6c189e34a93e2bd8$var$TabHeading, {
                                title: tab.title
                            })
                        }, tab.id))
                }),
                tabs.filter((tab)=>!tab.hide).map((tab, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4TabPanel), {
                        keepInDom: true,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
                            children: tab.component
                        })
                    }, index))
            ]
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        "data-testid": "template-tabbed-section",
        className: (0, $esG4f.default)([
            "_syaz1tj6 _1q51vbgk _1bsb1osq _1e0c1txw _2lx21bp4 _1o8315zi _98bk15zi _1rfm1osq"
        ]),
        style: {
            "--_1tgiy09": (0, $43MIc.default)((0, $cRwVc.default)("color.extended.blue900"))
        },
        children: renderTabbedSection()
    });
};

});
parcelRegister("9CA5V", function(module, exports) {

$parcel$export(module.exports, "TemplateBenefits", function () { return $cfb328503605d733$export$c51d82a2312a377b; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $hOqV7 = parcelRequire("hOqV7");

var $cyfPT = parcelRequire("cyfPT");

var $A9zZc = parcelRequire("A9zZc");
var $cfb328503605d733$var$_templateBenefitsContentfulRelayFragment;
const $cfb328503605d733$var$tabbedSectionStyle = null;
const $cfb328503605d733$var$stepContainerStyle = null;
const $cfb328503605d733$var$tabbedSectionHeading = null;
const $cfb328503605d733$var$stepHeading = null;
const $cfb328503605d733$var$stepContentWrapper = null;
const $cfb328503605d733$var$TemplateBenefitsStep = ({ templateBenefitNameExternal: templateBenefitNameExternal, shortDescription: shortDescription })=>{
    const name = templateBenefitNameExternal;
    const description = (shortDescription === null || shortDescription === void 0 ? void 0 : shortDescription.json) ? (0, $cyfPT.richTextToHTML)(shortDescription.json) : "";
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1yb4 _85i51wto _6rth1wto _179r87ef _zulpviql _1sag1bp4 _qw09glyw"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx21bp4 _zulpviql _11yr1k8s"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                    className: (0, $esG4f.default)([
                        "_1wyb1k8s _vwz4viql _k48pbfng _1dyznl7k _syazdtn8 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1cqs1k92 _1bys1k8s"
                    ]),
                    children: name
                }),
                description && /*#__PURE__*/ (0, $loA2J.jsx)((0, $A9zZc.SanitizedRichText), {
                    innerHTML: description
                })
            ]
        })
    });
};

const $cfb328503605d733$var$TemplateBenefitsRelayFragment = $cfb328503605d733$var$_templateBenefitsContentfulRelayFragment !== void 0 ? $cfb328503605d733$var$_templateBenefitsContentfulRelayFragment : ($cfb328503605d733$var$_templateBenefitsContentfulRelayFragment = (parcelRequire("itWmQ")), $cfb328503605d733$var$_templateBenefitsContentfulRelayFragment.hash && $cfb328503605d733$var$_templateBenefitsContentfulRelayFragment.hash !== "0aed3146fda17479886541e7fa74c49c" && console.error("The definition of 'templateBenefitsContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $cfb328503605d733$var$_templateBenefitsContentfulRelayFragment);
const $cfb328503605d733$export$c51d82a2312a377b = ({ templateBenefits: templateBenefits })=>{
    var _data_templateBenefitContainerCollection;
    const data = (0, $hOqV7.useFragment)($cfb328503605d733$var$TemplateBenefitsRelayFragment, templateBenefits);
    var _data_templateBenefitContainerCollection_items;
    const benefits = (_data_templateBenefitContainerCollection_items = (_data_templateBenefitContainerCollection = data.templateBenefitContainerCollection) === null || _data_templateBenefitContainerCollection === void 0 ? void 0 : _data_templateBenefitContainerCollection.items) !== null && _data_templateBenefitContainerCollection_items !== void 0 ? _data_templateBenefitContainerCollection_items : [];
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1pfh8vuz _ahbq1wug _12l21wug _mnhn1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_1wybahaf _vwz4yn4p _k48pbfng _1dyznl7k _syazdtn8 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1ylp _1kzs1k8s _16cb1m1q"
                ]),
                children: data.benefitsTitle
            }),
            benefits.map((benefitDetail, index)=>benefitDetail && /*#__PURE__*/ (0, $loA2J.jsx)($cfb328503605d733$var$TemplateBenefitsStep, (0, $7Knp0._)({}, benefitDetail), `benefit-${index}`))
        ]
    });
};

});
parcelRegister("itWmQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $b6b6d8f61d8b9b4b$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<d0d97a268f36e5b06bacc8737d58fa3a>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b6b6d8f61d8b9b4b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateBenefitsContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "benefitsTitle",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "TemplateBenefitContainerTemplateBenefitContainerCollection",
            "kind": "LinkedField",
            "name": "templateBenefitContainerCollection",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "TemplateBenefit",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "templateBenefitNameExternal",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TemplateBenefitShortDescription",
                            "kind": "LinkedField",
                            "name": "shortDescription",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "json",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "TemplateBenefitContainer",
    "abstractKey": null
};
$b6b6d8f61d8b9b4b$var$node.hash = "0aed3146fda17479886541e7fa74c49c";
var $b6b6d8f61d8b9b4b$export$2e2bcd8739ae039 = $b6b6d8f61d8b9b4b$var$node;

});


parcelRegister("cdeeW", function(module, exports) {

$parcel$export(module.exports, "TemplateGuide", function () { return $adafd73b4e5f143a$export$a0154bb39f3a2a91; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $hOqV7 = parcelRequire("hOqV7");

var $cyfPT = parcelRequire("cyfPT");

var $A9zZc = parcelRequire("A9zZc");

var $lHB9W = parcelRequire("lHB9W");
var $adafd73b4e5f143a$var$_templateGuideContentfulRelayFragment;
const $adafd73b4e5f143a$var$stepContainerStyle = null;
const $adafd73b4e5f143a$var$guideSectionHeading = null;
const $adafd73b4e5f143a$var$stepHeading = null;
const $adafd73b4e5f143a$var$stepContentWrapper = null;
const $adafd73b4e5f143a$var$stepImageWrapper = null;
const $adafd73b4e5f143a$var$stepImageStyle = null;
const $adafd73b4e5f143a$var$TemplateDetailStep = ({ step: step })=>{
    var _step_stepAsset;
    var _step_stepNameExternal;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1yb4 _85i51wto _6rth1wto _179r87ef _zulpviql _1sag1bp4 _qw09glyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _zulpviql _11yr1k8s"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                        className: (0, $esG4f.default)([
                            "_1wyb1k8s _vwz4viql _k48pbfng _1dyznl7k _syazdtn8 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1cqs1k92 _1bys1k8s"
                        ]),
                        children: step === null || step === void 0 ? void 0 : step.stepNameExternal
                    }),
                    (step === null || step === void 0 ? void 0 : step.stepDescription) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $A9zZc.SanitizedRichText), {
                        innerHTML: (0, $cyfPT.richTextToHTML)(step === null || step === void 0 ? void 0 : step.stepDescription.json)
                    })
                ]
            }),
            (step === null || step === void 0 ? void 0 : step.stepAsset) && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_16jlidpf _1o9zidpf _69fu1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                    src: ((_step_stepAsset = step.stepAsset) === null || _step_stepAsset === void 0 ? void 0 : _step_stepAsset.url) || "",
                    alt: (_step_stepNameExternal = step.stepNameExternal) !== null && _step_stepNameExternal !== void 0 ? _step_stepNameExternal : "",
                    className: (0, $esG4f.default)([
                        "_p12fsb0t _i0i01yk2 _mnhno812"
                    ])
                })
            })
        ]
    });
};

const $adafd73b4e5f143a$var$TemplateGuideRelayFragment = $adafd73b4e5f143a$var$_templateGuideContentfulRelayFragment !== void 0 ? $adafd73b4e5f143a$var$_templateGuideContentfulRelayFragment : ($adafd73b4e5f143a$var$_templateGuideContentfulRelayFragment = (parcelRequire("d3bcC")), $adafd73b4e5f143a$var$_templateGuideContentfulRelayFragment.hash && $adafd73b4e5f143a$var$_templateGuideContentfulRelayFragment.hash !== "0e73fcc9a5b16d949c71909fe7de9c38" && console.error("The definition of 'templateGuideContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $adafd73b4e5f143a$var$_templateGuideContentfulRelayFragment);
const $adafd73b4e5f143a$export$a0154bb39f3a2a91 = ({ templateGuide: templateGuide })=>{
    var _data_templateStepsCollection;
    const data = (0, $hOqV7.useFragment)($adafd73b4e5f143a$var$TemplateGuideRelayFragment, templateGuide);
    const name = data.templateGuideNameExternal;
    const steps = (_data_templateStepsCollection = data.templateStepsCollection) === null || _data_templateStepsCollection === void 0 ? void 0 : _data_templateStepsCollection.items;
    const guideName = (0, $lHB9W.expectContent)(name, "Template guide name not found");
    const guideSectionStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1pfh8vuz _ahbq1wug _12l21wug _49yfidpf _hfixidpf _mnhn1osq _i0i0z8o0"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_1wybahaf _vwz4yn4p _k48pbfng _1dyznl7k _syazdtn8 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1ylp _1kzs1k8s _16cb1m1q"
                ]),
                children: guideName
            }),
            steps === null || steps === void 0 ? void 0 : steps.map((step, index)=>/*#__PURE__*/ (0, $loA2J.jsx)($adafd73b4e5f143a$var$TemplateDetailStep, {
                    step: step
                }, `step-${index}`))
        ]
    });
};

});
parcelRegister("d3bcC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f635c7499ac0a9ad$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<ab1c2c9ad603ce07e3a7949a8d210f73>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f635c7499ac0a9ad$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateGuideContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "templateGuideNameExternal",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "TemplateGuideTemplateStepsCollection",
            "kind": "LinkedField",
            "name": "templateStepsCollection",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "TemplateUseStep",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "stepNameExternal",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TemplateUseStepStepDescription",
                            "kind": "LinkedField",
                            "name": "stepDescription",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "json",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "stepAsset",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "url",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "TemplateGuide",
    "abstractKey": null
};
$f635c7499ac0a9ad$var$node.hash = "0e73fcc9a5b16d949c71909fe7de9c38";
var $f635c7499ac0a9ad$export$2e2bcd8739ae039 = $f635c7499ac0a9ad$var$node;

});


parcelRegister("1RYwV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $343034f9c1ace3bb$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<00ee0f9e76c76376e5aedb6c4b48c533>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $343034f9c1ace3bb$var$node = function() {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "json",
            "storageKey": null
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "templateTabbedSectionContentfulRelayFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductTemplateTemplateOverviewCollection",
                "kind": "LinkedField",
                "name": "templateOverviewCollection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "TemplateOverview",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "overviewTitle",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "TemplateOverviewOverviewDescription",
                                "kind": "LinkedField",
                                "name": "overviewDescription",
                                "plural": false,
                                "selections": v0 /*: any*/ ,
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductTemplateTemplateBenefitsCollection",
                "kind": "LinkedField",
                "name": "templateBenefitsCollection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "TemplateBenefitContainer",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                            {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "templateBenefitsContentfulRelayFragment"
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductTemplateHowToUseThisTemplateCollection",
                "kind": "LinkedField",
                "name": "howToUseThisTemplateCollection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "TemplateGuide",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                            {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "templateGuideContentfulRelayFragment"
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductTemplateTemplateProductRationaleCollection",
                "kind": "LinkedField",
                "name": "templateProductRationaleCollection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "TemplateProductRationale",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rationaleTitle",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "TemplateProductRationaleTemplateProductRationaleDescription",
                                "kind": "LinkedField",
                                "name": "templateProductRationaleDescription",
                                "plural": false,
                                "selections": v0 /*: any*/ ,
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "ProductTemplate",
        "abstractKey": null
    };
}();
$343034f9c1ace3bb$var$node.hash = "9e2878135e8f926d46ac10f3a93bce05";
var $343034f9c1ace3bb$export$2e2bcd8739ae039 = $343034f9c1ace3bb$var$node;

});


parcelRegister("aElNK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ba5e3f42782b7174$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<035d64212bd2516ee41d4e4e51b50c04>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ba5e3f42782b7174$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateDetailsSectionContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "templateNameExternal",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pluginModuleKey",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "ProductTemplateTemplateTypeCollection",
            "kind": "LinkedField",
            "name": "templateTypeCollection",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaxonomyTemplateType",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Sys",
                            "kind": "LinkedField",
                            "name": "sys",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "templateTypeNameExternal",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "templatePreviewContentfulRelayFragment"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "templateDescriptionContentfulRelayFragment"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "templateTabbedSectionContentfulRelayFragment"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "templateRelatedTemplatesContentfulRelayFragment"
        }
    ],
    "type": "ProductTemplate",
    "abstractKey": null
};
$ba5e3f42782b7174$var$node.hash = "e8b8a2fa5d16d077e413ac61f87dea66";
var $ba5e3f42782b7174$export$2e2bcd8739ae039 = $ba5e3f42782b7174$var$node;

});


parcelRegister("fWQ89", function(module, exports) {

$parcel$export(module.exports, "TemplateHeaderSection", function () { return $b0bf473b1e1f8957$export$8e42656558633420; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");

var $1XyNv = parcelRequire("1XyNv");

var $95kuv = parcelRequire("95kuv");

var $9hcZe = parcelRequire("9hcZe");
var $b0bf473b1e1f8957$var$_templateHeaderSectionContentfulRelayFragment;
const $b0bf473b1e1f8957$var$headerSectionStyles = null;
const $b0bf473b1e1f8957$var$titleStyles = null;
const $b0bf473b1e1f8957$var$subTitleStyles = null;

const $b0bf473b1e1f8957$var$TemplateHeaderSectionContentfulRelayFragment = $b0bf473b1e1f8957$var$_templateHeaderSectionContentfulRelayFragment !== void 0 ? $b0bf473b1e1f8957$var$_templateHeaderSectionContentfulRelayFragment : ($b0bf473b1e1f8957$var$_templateHeaderSectionContentfulRelayFragment = (parcelRequire("45dRv")), $b0bf473b1e1f8957$var$_templateHeaderSectionContentfulRelayFragment.hash && $b0bf473b1e1f8957$var$_templateHeaderSectionContentfulRelayFragment.hash !== "8f8ff649db77b91366c4318c307ecb02" && console.error("The definition of 'templateHeaderSectionContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $b0bf473b1e1f8957$var$_templateHeaderSectionContentfulRelayFragment);
const $b0bf473b1e1f8957$export$8e42656558633420 = ({ template: templateRef })=>{
    const template = (0, $hOqV7.useFragment)($b0bf473b1e1f8957$var$TemplateHeaderSectionContentfulRelayFragment, templateRef);
    const { templateNameExternal: templateNameExternal, oneLinerHeadline: oneLinerHeadline, pluginModuleKey: pluginModuleKey } = template;
    const intl = (0, $f6qj2.default)();
    const templateName = intl.formatMessage((0, $1XyNv.ConfluenceTemplateMessages).templateTitle, {
        templateName: templateNameExternal !== null && templateNameExternal !== void 0 ? templateNameExternal : ""
    });
    const renderCtaButons = ()=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $95kuv.TemplateCtaButtons), {
            name: templateName,
            pluginModuleKey: pluginModuleKey || ""
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        "data-testid": "TemplateHeaderSection",
        className: (0, $esG4f.default)([
            "_12ornqa1 _1r62t94y _1ezz1f7l _1e0c1txw _2lx21bp4 _85i51tcg _ag851h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_syazalr3 _ect4kipj _1wyb1ex1 _zg8l4jg8 _k48pbfng _vwz41wqb _6rth7vkz _1pfhidpf _1i4q1hna _xsmr1h6o"
                ]),
                children: templateName
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $9hcZe.TemplateAuthor), {
                template: template
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_syazalr3 _ect48q0o _1wybgktf _zg8l4jg8 _k48p1nn1 _vwz41f4h _6rthzwfg _1pfhidpf _xsmr1h6o"
                ]),
                children: oneLinerHeadline
            }),
            renderCtaButons()
        ]
    });
};

});
parcelRegister("9hcZe", function(module, exports) {

$parcel$export(module.exports, "TemplateAuthor", function () { return $11007b2bb85318fc$export$f6f32ceede8fcfff; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $hOqV7 = parcelRequire("hOqV7");

var $1XyNv = parcelRequire("1XyNv");
var $11007b2bb85318fc$var$_templateAuthorContentfulRelayFragment;
const $11007b2bb85318fc$var$templateAuthor = null;
const $11007b2bb85318fc$var$isAuthor = (contributor)=>(contributor === null || contributor === void 0 ? void 0 : contributor.__typename) === "Author";
const $11007b2bb85318fc$var$isOrganization = (contributor)=>(contributor === null || contributor === void 0 ? void 0 : contributor.__typename) === "CompanyNameInternal";

const $11007b2bb85318fc$var$TemplateAuthorRelayFragment = $11007b2bb85318fc$var$_templateAuthorContentfulRelayFragment !== void 0 ? $11007b2bb85318fc$var$_templateAuthorContentfulRelayFragment : ($11007b2bb85318fc$var$_templateAuthorContentfulRelayFragment = (parcelRequire("klGkS")), $11007b2bb85318fc$var$_templateAuthorContentfulRelayFragment.hash && $11007b2bb85318fc$var$_templateAuthorContentfulRelayFragment.hash !== "f1d1931be967bc795ac40098c74ecc54" && console.error("The definition of 'templateAuthorContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $11007b2bb85318fc$var$_templateAuthorContentfulRelayFragment);
const $11007b2bb85318fc$export$f6f32ceede8fcfff = ({ template: template })=>{
    var _author_organization;
    const { contributor: contributor } = (0, $hOqV7.useFragment)($11007b2bb85318fc$var$TemplateAuthorRelayFragment, template);
    let contributorName = $11007b2bb85318fc$var$isAuthor(contributor) && contributor.authorNameExternal || $11007b2bb85318fc$var$isOrganization(contributor) && contributor.organizationNameExternal || undefined;
    const author = $11007b2bb85318fc$var$isAuthor(contributor) ? contributor : null;
    let authorDetail = author === null || author === void 0 ? void 0 : author.jobTitle;
    if (authorDetail && (author === null || author === void 0 ? void 0 : (_author_organization = author.organization) === null || _author_organization === void 0 ? void 0 : _author_organization.organizationNameExternal)) authorDetail = `${authorDetail} @ ${author.organization.organizationNameExternal}`;
    if (authorDetail) contributorName = `${contributorName}, (${authorDetail})`;
    return contributorName && /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
        className: (0, $esG4f.default)([
            "_1wyboqnp _vwz41neg _k48pbfng _syazrbzz _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1tcg _1p1dangw"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $1XyNv.ConfluenceTemplateMessages).templateAuthorByLine), {
            values: {
                author: contributorName
            }
        }))
    });
};

});
parcelRegister("klGkS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $50500fafb45ab71e$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<924a1724830bde4a0d657e5e8135325a>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $50500fafb45ab71e$var$node = function() {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organizationNameExternal",
            "storageKey": null
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "templateAuthorContentfulRelayFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "contributor",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "authorNameExternal",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "jobTitle",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CompanyNameInternal",
                                "kind": "LinkedField",
                                "name": "organization",
                                "plural": false,
                                "selections": v0 /*: any*/ ,
                                "storageKey": null
                            }
                        ],
                        "type": "Author",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": v0 /*: any*/ ,
                        "type": "CompanyNameInternal",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "ProductTemplate",
        "abstractKey": null
    };
}();
$50500fafb45ab71e$var$node.hash = "f1d1931be967bc795ac40098c74ecc54";
var $50500fafb45ab71e$export$2e2bcd8739ae039 = $50500fafb45ab71e$var$node;

});


parcelRegister("45dRv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $8ab38643b6fb5dc9$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<c3300acdc249c500bc3a727bd6e88894>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8ab38643b6fb5dc9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateHeaderSectionContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "templateNameExternal",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "oneLinerHeadline",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pluginModuleKey",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "templateAuthorContentfulRelayFragment"
        }
    ],
    "type": "ProductTemplate",
    "abstractKey": null
};
$8ab38643b6fb5dc9$var$node.hash = "8f8ff649db77b91366c4318c307ecb02";
var $8ab38643b6fb5dc9$export$2e2bcd8739ae039 = $8ab38643b6fb5dc9$var$node;

});


parcelRegister("8b1Ol", function(module, exports) {

$parcel$export(module.exports, "TemplateKeyFeaturesSection", function () { return $82770422dcf905f7$export$b2854e9c3155c1cd; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");

var $l2OTr = parcelRequire("l2OTr");
var $82770422dcf905f7$var$_templateKeyFeaturesSectionContentfulRelayFragment;
const $82770422dcf905f7$var$keyFeaturesStyles = null;
const $82770422dcf905f7$var$headingStyles = null;
const $82770422dcf905f7$var$featureStyles = null;
const $82770422dcf905f7$var$featureTextStyles = null;

const $82770422dcf905f7$var$TemplateKeyFeaturesSectionFragment = $82770422dcf905f7$var$_templateKeyFeaturesSectionContentfulRelayFragment !== void 0 ? $82770422dcf905f7$var$_templateKeyFeaturesSectionContentfulRelayFragment : ($82770422dcf905f7$var$_templateKeyFeaturesSectionContentfulRelayFragment = (parcelRequire("2THDh")), $82770422dcf905f7$var$_templateKeyFeaturesSectionContentfulRelayFragment.hash && $82770422dcf905f7$var$_templateKeyFeaturesSectionContentfulRelayFragment.hash !== "ea58d8a7472ddea992087c51d1db8a28" && console.error("The definition of 'templateKeyFeaturesSectionContentfulRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $82770422dcf905f7$var$_templateKeyFeaturesSectionContentfulRelayFragment); // TODO: will get features from template
const $82770422dcf905f7$export$b2854e9c3155c1cd = ({ template: template })=>{
    var _data_keyFeaturesCollection;
    const data = (0, $hOqV7.useFragment)($82770422dcf905f7$var$TemplateKeyFeaturesSectionFragment, template);
    const keyFeatures = (data === null || data === void 0 ? void 0 : (_data_keyFeaturesCollection = data.keyFeaturesCollection) === null || _data_keyFeaturesCollection === void 0 ? void 0 : _data_keyFeaturesCollection.items) || [];
    const intl = (0, $f6qj2.default)(); // TODO: temp placeholder data for UI purposes
    const features = keyFeatures !== null && keyFeatures !== void 0 ? keyFeatures : [];
    const headingText = intl.formatMessage({
        id: "ConfluenceTemplateMessages.keyFeatures.heading",
        defaultMessage: "KEY FEATURES"
    });
    return !!features.length && /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1q51zwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h5", {
                className: (0, $esG4f.default)([
                    "_syaz19tk _1wyboqnp _k48p1nn1 _1dyzt94y _6rthftgi"
                ]),
                children: headingText
            }),
            features.filter((feature)=>(feature === null || feature === void 0 ? void 0 : feature.featureNameExternal) != null).map((feature)=>/*#__PURE__*/ {
                var _feature_featureNameExternal;
                return (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_4cvr1h6o _syazalr3 _1e0c1txw _4t3i1ylp _1q51ftgi"
                    ]),
                    children: [
                        (0, $l2OTr.getIcon)((_feature_featureNameExternal = feature === null || feature === void 0 ? void 0 : feature.featureNameExternal) !== null && _feature_featureNameExternal !== void 0 ? _feature_featureNameExternal : ""),
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_ahbqdlk8"
                            ]),
                            children: feature === null || feature === void 0 ? void 0 : feature.featureNameExternal
                        })
                    ]
                }, feature === null || feature === void 0 ? void 0 : feature.featureNameExternal);
            })
        ]
    });
};
var $82770422dcf905f7$export$2e2bcd8739ae039 = $82770422dcf905f7$export$b2854e9c3155c1cd;

});
parcelRegister("l2OTr", function(module, exports) {

$parcel$export(module.exports, "getIcon", function () { return $d661b68c903e32f4$export$16b26cd5e98d9100; });

var $loA2J = parcelRequire("loA2J");

var $kkNq7 = parcelRequire("kkNq7");

var $2eqAL = parcelRequire("2eqAL");

var $kGv70 = parcelRequire("kGv70");

var $bKqge = parcelRequire("bKqge");

var $judwC = parcelRequire("judwC");

var $iHyWi = parcelRequire("iHyWi");

var $bDTBs = parcelRequire("bDTBs");

var $j6Mjf = parcelRequire("j6Mjf");

var $54Z58 = parcelRequire("54Z58");

var $9TuM8 = parcelRequire("9TuM8");

var $8nSEF = parcelRequire("8nSEF");

var $kPkjS = parcelRequire("kPkjS");

var $dtz0w = parcelRequire("dtz0w");

var $imXhV = parcelRequire("imXhV");

var $bJ0Y9 = parcelRequire("bJ0Y9");

var $1EpFI = parcelRequire("1EpFI");

var $8A4p1 = parcelRequire("8A4p1");

var $d1xAD = parcelRequire("d1xAD");

var $DynGV = parcelRequire("DynGV");

var $cNevM = parcelRequire("cNevM");

var $e9JPb = parcelRequire("e9JPb");

var $lhvME = parcelRequire("lhvME");

var $itghZ = parcelRequire("itghZ");

var $fqjcR = parcelRequire("fqjcR");

var $ixaDK = parcelRequire("ixaDK");

var $aOabo = parcelRequire("aOabo");

var $2YVsr = parcelRequire("2YVsr");

var $cgxwH = parcelRequire("cgxwH");

var $haaTf = parcelRequire("haaTf");

var $egeJ8 = parcelRequire("egeJ8");

var $2HBdl = parcelRequire("2HBdl");

var $iHnIP = parcelRequire("iHnIP");

var $lnsmo = parcelRequire("lnsmo");

var $6akvZ = parcelRequire("6akvZ");
const $d661b68c903e32f4$var$featureIconMap = {
    "analysis": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lnsmo))), {
        label: ""
    }),
    "automation": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cgxwH))), {
        label: ""
    }),
    "business updates": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ixaDK))), {
        label: ""
    }),
    "communication": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($j6Mjf))), {
        label: ""
    }),
    "company wiki": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dtz0w))), {
        label: ""
    }),
    "content management": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8nSEF))), {
        label: ""
    }),
    "decision tracking": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($54Z58))), {
        label: ""
    }),
    "deployment strategy": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9JPb))), {
        label: ""
    }),
    "documentation": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kPkjS))), {
        label: ""
    }),
    "feedback": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8A4p1))), {
        label: ""
    }),
    "forms": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2eqAL))), {
        label: ""
    }),
    "goal setting": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($judwC))), {
        label: ""
    }),
    "goal tracking": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iHyWi))), {
        label: ""
    }),
    "ideation": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bJ0Y9))), {
        label: ""
    }),
    "intranet": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6akvZ))), {
        label: ""
    }),
    "knowledge base": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bKqge))), {
        label: ""
    }),
    "marketing research": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2YVsr))), {
        label: ""
    }),
    "note taking": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($imXhV))), {
        label: ""
    }),
    "onboarding": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($DynGV))), {
        label: ""
    }),
    "operations": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9TuM8))), {
        label: ""
    }),
    "prioritization": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kkNq7))), {
        label: ""
    }),
    "problem solving": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bDTBs))), {
        label: ""
    }),
    "progress tracking": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($egeJ8))), {
        label: ""
    }),
    "project management": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fqjcR))), {
        label: ""
    }),
    "reporting": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d1xAD))), {
        label: ""
    }),
    "requirements": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lhvME))), {
        label: ""
    }),
    "resource": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bKqge))), {
        label: ""
    }),
    "retrospective": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kGv70))), {
        label: ""
    }),
    "risk assessment": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1EpFI))), {
        label: ""
    }),
    "roadmaps": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aOabo))), {
        label: ""
    }),
    "stakeholder alignment": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($itghZ))), {
        label: ""
    }),
    "task planning": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cNevM))), {
        label: ""
    }),
    "task tracking": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HBdl))), {
        label: ""
    }),
    "team alignment": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iHnIP))), {
        label: ""
    }),
    "team collaboration": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iHnIP))), {
        label: ""
    }),
    "workflows": /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($haaTf))), {
        label: ""
    })
};
const $d661b68c903e32f4$export$16b26cd5e98d9100 = (feature)=>{
    var _featureIconMap_feature_toLowerCase;
    return (_featureIconMap_feature_toLowerCase = $d661b68c903e32f4$var$featureIconMap[feature.toLowerCase()]) !== null && _featureIconMap_feature_toLowerCase !== void 0 ? _featureIconMap_feature_toLowerCase : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iHyWi))), {
        label: ""
    });
};

});
parcelRegister("kkNq7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ecdc02c1caa631e5$var$_react = $ecdc02c1caa631e5$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $ecdc02c1caa631e5$var$_backlog = $ecdc02c1caa631e5$var$_interopRequireDefault((parcelRequire("7fq8b")));
function $ecdc02c1caa631e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ecdc02c1caa631e5$var$BacklogIcon = (props)=>/*#__PURE__*/ $ecdc02c1caa631e5$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.002C5 19 17 19 17 19v-2.002C17 17 5 17 5 17zm-2-2.004C3 15.894 3.895 15 4.994 15h12.012c1.101 0 1.994.898 1.994 1.998v2.004A1.997 1.997 0 0 1 17.006 21H4.994A2 2 0 0 1 3 19.002z"/><path d="M5 15h12v-2H5zm-2-4h16v6H3z"/><path d="M7 11.002C7 11 19 11 19 11V8.998C19 9 7 9 7 9zM5 8.998C5 7.894 5.895 7 6.994 7h12.012C20.107 7 21 7.898 21 8.998v2.004A1.997 1.997 0 0 1 19.006 13H6.994A2 2 0 0 1 5 11.002z"/><path d="M5 5v2h12V5zm-2-.002C3 3.894 3.895 3 4.994 3h12.012C18.107 3 19 3.898 19 4.998V9H3z"/></g></svg>`
    }, props, {
        newIcon: $ecdc02c1caa631e5$var$_backlog.default
    }));
$ecdc02c1caa631e5$var$BacklogIcon.displayName = "BacklogIcon";
var $ecdc02c1caa631e5$var$_default = module.exports.default = $ecdc02c1caa631e5$var$BacklogIcon;

});
parcelRegister("7fq8b", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::471b5e5cdc883753bc3e3b52ee5ae2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $546e343250e73767$var$_react = $546e343250e73767$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $546e343250e73767$var$_baseNew = $546e343250e73767$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $546e343250e73767$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $546e343250e73767$var$BacklogIcon = (props)=>/*#__PURE__*/ $546e343250e73767$var$_react.default.createElement($546e343250e73767$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$546e343250e73767$var$BacklogIcon.displayName = "BacklogIcon";
var $546e343250e73767$var$_default = module.exports.default = $546e343250e73767$var$BacklogIcon;

});


parcelRegister("2eqAL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1a01842f93cc26da$var$_react = $1a01842f93cc26da$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");
function $1a01842f93cc26da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1a01842f93cc26da$var$BillingIcon = (props)=>/*#__PURE__*/ $1a01842f93cc26da$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="5" height="2" x="8" y="9" rx="1"/><rect width="5" height="2" x="8" y="12" rx="1"/><rect width="5" height="2" x="8" y="15" rx="1"/><rect width="2" height="2" x="14" y="12" rx="1"/><rect width="2" height="2" x="14" y="15" rx="1"/><rect width="2" height="2" x="14" y="9" rx="1"/></g></svg>`
    }, props));
$1a01842f93cc26da$var$BillingIcon.displayName = "BillingIcon";
var $1a01842f93cc26da$var$_default = module.exports.default = $1a01842f93cc26da$var$BillingIcon;

});

parcelRegister("kGv70", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0efdd17975cfad6$var$_react = $f0efdd17975cfad6$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $f0efdd17975cfad6$var$_board = $f0efdd17975cfad6$var$_interopRequireDefault((parcelRequire("lPup9")));
function $f0efdd17975cfad6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f0efdd17975cfad6$var$BoardIcon = (props)=>/*#__PURE__*/ $f0efdd17975cfad6$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M8 6v12h2V6zm6 0v12h2V6z"/></g></svg>`
    }, props, {
        newIcon: $f0efdd17975cfad6$var$_board.default
    }));
$f0efdd17975cfad6$var$BoardIcon.displayName = "BoardIcon";
var $f0efdd17975cfad6$var$_default = module.exports.default = $f0efdd17975cfad6$var$BoardIcon;

});
parcelRegister("lPup9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfc058bc597636775f186a66702ef9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe45f21b5f8e4d30$var$_react = $fe45f21b5f8e4d30$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $fe45f21b5f8e4d30$var$_baseNew = $fe45f21b5f8e4d30$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $fe45f21b5f8e4d30$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe45f21b5f8e4d30$var$BoardIcon = (props)=>/*#__PURE__*/ $fe45f21b5f8e4d30$var$_react.default.createElement($fe45f21b5f8e4d30$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$fe45f21b5f8e4d30$var$BoardIcon.displayName = "BoardIcon";
var $fe45f21b5f8e4d30$var$_default = module.exports.default = $fe45f21b5f8e4d30$var$BoardIcon;

});


parcelRegister("bKqge", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88d85c6fd5282691$var$_react = $88d85c6fd5282691$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $88d85c6fd5282691$var$_bookWithBookmark = $88d85c6fd5282691$var$_interopRequireDefault((parcelRequire("kqqsh")));
function $88d85c6fd5282691$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $88d85c6fd5282691$var$BookIcon = (props)=>/*#__PURE__*/ $88d85c6fd5282691$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M7 6.002v9.996c0 .546.446 1.002.995 1.002h8.01c.54 0 .995-.449.995-1.002V6.002C17 5.456 16.554 5 16.005 5h-8.01C7.455 5 7 5.449 7 6.002m-2 0A3.005 3.005 0 0 1 7.995 3h8.01A3.003 3.003 0 0 1 19 6.002v9.996A3.005 3.005 0 0 1 16.005 19h-8.01A3.003 3.003 0 0 1 5 15.998z"/><path d="M9 7h6v4H9zm0 6h6v2H9zm1 7.86V20H7v.86L8.5 20zM7 18h3v2H7z"/></g></svg>`
    }, props, {
        newIcon: $88d85c6fd5282691$var$_bookWithBookmark.default
    }));
$88d85c6fd5282691$var$BookIcon.displayName = "BookIcon";
var $88d85c6fd5282691$var$_default = module.exports.default = $88d85c6fd5282691$var$BookIcon;

});
parcelRegister("kqqsh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83cc862a6ce0fb1f7d8883d625af8c63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $edeac1c64e4915f3$var$_react = $edeac1c64e4915f3$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $edeac1c64e4915f3$var$_baseNew = $edeac1c64e4915f3$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $edeac1c64e4915f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookWithBookmark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $edeac1c64e4915f3$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $edeac1c64e4915f3$var$_react.default.createElement($edeac1c64e4915f3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.875A2.875 2.875 0 0 1 4.875 0h8.375a.75.75 0 0 1 .75.75V9.5a.75.75 0 0 1-.75.75V13H14v1.5h-3.5V13h1.25v-2.75H4.875a1.375 1.375 0 1 0 0 2.75H5.5v1.5h-.625A2.875 2.875 0 0 1 2 11.625zM3.5 9.1a2.86 2.86 0 0 1 1.375-.35H12.5V1.5H4.875c-.76 0-1.375.616-1.375 1.375z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$edeac1c64e4915f3$var$BookWithBookmarkIcon.displayName = "BookWithBookmarkIcon";
var $edeac1c64e4915f3$var$_default = module.exports.default = $edeac1c64e4915f3$var$BookWithBookmarkIcon;

});


parcelRegister("judwC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2fb4f7342147a3d$var$_react = $e2fb4f7342147a3d$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");
function $e2fb4f7342147a3d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e2fb4f7342147a3d$var$CameraTakePictureIcon = (props)=>/*#__PURE__*/ $e2fb4f7342147a3d$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="12" cy="12" r="5"/><path fill-rule="nonzero" d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12m0 1a7 7 0 1 1 0-14 7 7 0 0 1 0 14"/></g></svg>`
    }, props));
$e2fb4f7342147a3d$var$CameraTakePictureIcon.displayName = "CameraTakePictureIcon";
var $e2fb4f7342147a3d$var$_default = module.exports.default = $e2fb4f7342147a3d$var$CameraTakePictureIcon;

});

parcelRegister("iHyWi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9d7585a20730163$var$_react = $d9d7585a20730163$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $d9d7585a20730163$var$_statusSuccess = $d9d7585a20730163$var$_interopRequireDefault((parcelRequire("hxhx5")));
function $d9d7585a20730163$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d9d7585a20730163$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $d9d7585a20730163$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $d9d7585a20730163$var$_statusSuccess.default
    }));
$d9d7585a20730163$var$CheckCircleIcon.displayName = "CheckCircleIcon";
var $d9d7585a20730163$var$_default = module.exports.default = $d9d7585a20730163$var$CheckCircleIcon;

});
parcelRegister("hxhx5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8cc756abdbbefcea85e2842ee2eda39e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc431e5821625fac$var$_react = $cc431e5821625fac$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $cc431e5821625fac$var$_baseNew = $cc431e5821625fac$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $cc431e5821625fac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cc431e5821625fac$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $cc431e5821625fac$var$_react.default.createElement($cc431e5821625fac$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$cc431e5821625fac$var$StatusSuccessIcon.displayName = "StatusSuccessIcon";
var $cc431e5821625fac$var$_default = module.exports.default = $cc431e5821625fac$var$StatusSuccessIcon;

});


parcelRegister("j6Mjf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de940d15d276efdb$var$_react = $de940d15d276efdb$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $de940d15d276efdb$var$_comment = $de940d15d276efdb$var$_interopRequireDefault((parcelRequire("ctYD4")));
function $de940d15d276efdb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $de940d15d276efdb$var$CommentIcon = (props)=>/*#__PURE__*/ $de940d15d276efdb$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51s7.002 2.472 7.002 5.51c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51m14.84 7.771v-.001s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716"/><rect width="10" height="2" x="7" y="9" rx="1"/><rect width="5" height="2" x="7" y="12" rx="1"/></g></svg>`
    }, props, {
        newIcon: $de940d15d276efdb$var$_comment.default
    }));
$de940d15d276efdb$var$CommentIcon.displayName = "CommentIcon";
var $de940d15d276efdb$var$_default = module.exports.default = $de940d15d276efdb$var$CommentIcon;

});
parcelRegister("ctYD4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9167392384132023$var$_react = $9167392384132023$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $9167392384132023$var$_baseNew = $9167392384132023$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $9167392384132023$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9167392384132023$var$CommentIcon = (props)=>/*#__PURE__*/ $9167392384132023$var$_react.default.createElement($9167392384132023$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$9167392384132023$var$CommentIcon.displayName = "CommentIcon";
var $9167392384132023$var$_default = module.exports.default = $9167392384132023$var$CommentIcon;

});


parcelRegister("54Z58", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b2cb50a58f9d7c1$var$_react = $3b2cb50a58f9d7c1$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $3b2cb50a58f9d7c1$var$_decision = $3b2cb50a58f9d7c1$var$_interopRequireDefault((parcelRequire("jcATf")));
function $3b2cb50a58f9d7c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3b2cb50a58f9d7c1$var$DecisionIcon = (props)=>/*#__PURE__*/ $3b2cb50a58f9d7c1$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="m19.29 3.29-5 5A1 1 0 1 0 15.7 9.7l5-5a1 1 0 1 0-1.41-1.41M8.04 4.93a.96.96 0 1 0 .01-1.91L4.06 3A1.05 1.05 0 0 0 3 4.04l.02 4a.96.96 0 0 0 1.92-.01l-.02-3.11z"/><path d="M11 19.998A1 1 0 0 0 12 21c.552 0 1-.454 1-1.007v-7.4c0-.556-.315-1.322-.705-1.713L5.207 3.793 3.793 5.207 11 12.414z"/></g></svg>`
    }, props, {
        newIcon: $3b2cb50a58f9d7c1$var$_decision.default
    }));
$3b2cb50a58f9d7c1$var$DecisionIcon.displayName = "DecisionIcon";
var $3b2cb50a58f9d7c1$var$_default = module.exports.default = $3b2cb50a58f9d7c1$var$DecisionIcon;

});
parcelRegister("jcATf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be0b9c9537e0b69b1d3c8d2587861fe5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dfabc0eb4536ae78$var$_react = $dfabc0eb4536ae78$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $dfabc0eb4536ae78$var$_baseNew = $dfabc0eb4536ae78$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $dfabc0eb4536ae78$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dfabc0eb4536ae78$var$DecisionIcon = (props)=>/*#__PURE__*/ $dfabc0eb4536ae78$var$_react.default.createElement($dfabc0eb4536ae78$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$dfabc0eb4536ae78$var$DecisionIcon.displayName = "DecisionIcon";
var $dfabc0eb4536ae78$var$_default = module.exports.default = $dfabc0eb4536ae78$var$DecisionIcon;

});


parcelRegister("9TuM8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $73411f76379301d6$var$_react = $73411f76379301d6$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $73411f76379301d6$var$_department = $73411f76379301d6$var$_interopRequireDefault((parcelRequire("20L2t")));
function $73411f76379301d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $73411f76379301d6$var$DepartmentIcon = (props)=>/*#__PURE__*/ $73411f76379301d6$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M11 5v2h2V5zm0 6V9h-1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1v2h5a1 1 0 0 1 1 1v3h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h1v-2H7v2h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h1v-3a1 1 0 0 1 1-1zm-6 6v2h2v-2zm12 0v2h2v-2z"/></svg>`
    }, props, {
        newIcon: $73411f76379301d6$var$_department.default
    }));
$73411f76379301d6$var$DepartmentIcon.displayName = "DepartmentIcon";
var $73411f76379301d6$var$_default = module.exports.default = $73411f76379301d6$var$DepartmentIcon;

});
parcelRegister("20L2t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84a07eff465bcaaea8db49f0fc7877da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $177011d2e77c7e3d$var$_react = $177011d2e77c7e3d$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $177011d2e77c7e3d$var$_baseNew = $177011d2e77c7e3d$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $177011d2e77c7e3d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Department".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for departments, reporting lines, or other tree chart representations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $177011d2e77c7e3d$var$DepartmentIcon = (props)=>/*#__PURE__*/ $177011d2e77c7e3d$var$_react.default.createElement($177011d2e77c7e3d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.5.75A.75.75 0 0 1 6.25 0h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-1v2.25h3.125c.76 0 1.375.616 1.375 1.375V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.75h-7.5V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.625c0-.76.616-1.375 1.375-1.375H7.25V5h-1a.75.75 0 0 1-.75-.75zM7 1.5v2h2v-2zm-4.5 11v2h2v-2zm9 0v2h2v-2z" clip-rule="evenodd"/>`
    }, props));
$177011d2e77c7e3d$var$DepartmentIcon.displayName = "DepartmentIcon";
var $177011d2e77c7e3d$var$_default = module.exports.default = $177011d2e77c7e3d$var$DepartmentIcon;

});


parcelRegister("8nSEF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61aade0ef464e452$var$_react = $61aade0ef464e452$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $61aade0ef464e452$var$_file = $61aade0ef464e452$var$_interopRequireDefault((parcelRequire("jwsof")));
function $61aade0ef464e452$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $61aade0ef464e452$var$DocumentIcon = (props)=>/*#__PURE__*/ $61aade0ef464e452$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M17 10.005V19H7V5h5.99v2.49a1.5 1.5 0 0 0 1.5 1.5h4.5v-.522c0-.297-.132-.578-.359-.768l-5.074-4.236c-.36-.3-.813-.464-1.282-.464H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8.995z"/></svg>`
    }, props, {
        newIcon: $61aade0ef464e452$var$_file.default
    }));
$61aade0ef464e452$var$DocumentIcon.displayName = "DocumentIcon";
var $61aade0ef464e452$var$_default = module.exports.default = $61aade0ef464e452$var$DocumentIcon;

});

parcelRegister("kPkjS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f298551cfda52fdb$var$_react = $f298551cfda52fdb$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $f298551cfda52fdb$var$_file = $f298551cfda52fdb$var$_interopRequireDefault((parcelRequire("jwsof")));
function $f298551cfda52fdb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f298551cfda52fdb$var$DocumentFilledIcon = (props)=>/*#__PURE__*/ $f298551cfda52fdb$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m18.99 8.99.01 1.015V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.275c.469 0 .922.164 1.282.464L18.631 7.7c.227.19.359.471.359.768zM12.02 5 12 8.192a.99.99 0 0 0 .994.991h4z"/></svg>`
    }, props, {
        newIcon: $f298551cfda52fdb$var$_file.default
    }));
$f298551cfda52fdb$var$DocumentFilledIcon.displayName = "DocumentFilledIcon";
var $f298551cfda52fdb$var$_default = module.exports.default = $f298551cfda52fdb$var$DocumentFilledIcon;

});

parcelRegister("dtz0w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cf9238aeadd75b4$var$_react = $9cf9238aeadd75b4$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $9cf9238aeadd75b4$var$_files = $9cf9238aeadd75b4$var$_interopRequireDefault((parcelRequire("wQpQg")));
function $9cf9238aeadd75b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9cf9238aeadd75b4$var$DocumentsIcon = (props)=>/*#__PURE__*/ $9cf9238aeadd75b4$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17H5V7h1V5H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1zm13-6.99V19H9V5h5.99v2.49a1.5 1.5 0 0 0 1.5 1.5h4.5v-.52c0-.3-.13-.58-.36-.77l-5.07-4.24c-.36-.3-.81-.46-1.28-.46H9a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8.99z"/></svg>`
    }, props, {
        newIcon: $9cf9238aeadd75b4$var$_files.default
    }));
$9cf9238aeadd75b4$var$DocumentsIcon.displayName = "DocumentsIcon";
var $9cf9238aeadd75b4$var$_default = module.exports.default = $9cf9238aeadd75b4$var$DocumentsIcon;

});
parcelRegister("wQpQg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b192fbc7db5453924997563ea93d01df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $062ba5f60682b26e$var$_react = $062ba5f60682b26e$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $062ba5f60682b26e$var$_baseNew = $062ba5f60682b26e$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $062ba5f60682b26e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Files".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: documents, files. Do not use to represent pages — use the dedicated 'Pages' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $062ba5f60682b26e$var$FilesIcon = (props)=>/*#__PURE__*/ $062ba5f60682b26e$var$_react.default.createElement($062ba5f60682b26e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 11a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4.25c0-.52-.208-1.02-.578-1.385L9.072.543A1.88 1.88 0 0 0 7.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h3v2.75c0 .414.336.75.75.75h2.75v6a.5.5 0 0 1-.5.5zm5.93-8H8.5V2.087z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7 16h4.75A3.25 3.25 0 0 0 15 12.75V5h-1.5v7.75a1.75 1.75 0 0 1-1.75 1.75H7z" clip-rule="evenodd"/>`
    }, props));
$062ba5f60682b26e$var$FilesIcon.displayName = "FilesIcon";
var $062ba5f60682b26e$var$_default = module.exports.default = $062ba5f60682b26e$var$FilesIcon;

});


parcelRegister("imXhV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d5f8457061b67753$var$_react = $d5f8457061b67753$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $d5f8457061b67753$var$_edit = $d5f8457061b67753$var$_interopRequireDefault((parcelRequire("aRydc")));
function $d5f8457061b67753$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d5f8457061b67753$var$EditIcon = (props)=>/*#__PURE__*/ $d5f8457061b67753$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $d5f8457061b67753$var$_edit.default
    }));
$d5f8457061b67753$var$EditIcon.displayName = "EditIcon";
var $d5f8457061b67753$var$_default = module.exports.default = $d5f8457061b67753$var$EditIcon;

});
parcelRegister("aRydc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8b466fb905db85ecf24180397d24c4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e896462d00fee46$var$_react = $7e896462d00fee46$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $7e896462d00fee46$var$_baseNew = $7e896462d00fee46$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $7e896462d00fee46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7e896462d00fee46$var$EditIcon = (props)=>/*#__PURE__*/ $7e896462d00fee46$var$_react.default.createElement($7e896462d00fee46$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$7e896462d00fee46$var$EditIcon.displayName = "EditIcon";
var $7e896462d00fee46$var$_default = module.exports.default = $7e896462d00fee46$var$EditIcon;

});


parcelRegister("bJ0Y9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8894a626592c4b72$var$_react = $8894a626592c4b72$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $8894a626592c4b72$var$_emoji = $8894a626592c4b72$var$_interopRequireDefault((parcelRequire("j25Ho")));
function $8894a626592c4b72$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8894a626592c4b72$var$EmojiIcon = (props)=>/*#__PURE__*/ $8894a626592c4b72$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18m0 16.071c3.9 0 7.071-3.171 7.071-7.071S15.9 4.929 12 4.929A7.08 7.08 0 0 0 4.929 12c0 3.9 3.171 7.071 7.071 7.071m-1.929-7.714a1.286 1.286 0 1 1 .001-2.572 1.286 1.286 0 0 1 0 2.572m3.858 0a1.286 1.286 0 1 1 0-2.572 1.286 1.286 0 0 1 0 2.572m.347 2.035a.805.805 0 0 1 1.198 1.073A4.67 4.67 0 0 1 12 16.018a4.67 4.67 0 0 1-3.469-1.548.804.804 0 0 1 1.196-1.074c1.158 1.29 3.393 1.29 4.549-.004"/></svg>`
    }, props, {
        newIcon: $8894a626592c4b72$var$_emoji.default
    }));
$8894a626592c4b72$var$EmojiIcon.displayName = "EmojiIcon";
var $8894a626592c4b72$var$_default = module.exports.default = $8894a626592c4b72$var$EmojiIcon;

});
parcelRegister("j25Ho", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0744cae5af6a1635a1b9234b867386>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ddb29fee3dff1f48$var$_react = $ddb29fee3dff1f48$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $ddb29fee3dff1f48$var$_baseNew = $ddb29fee3dff1f48$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $ddb29fee3dff1f48$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ddb29fee3dff1f48$var$EmojiIcon = (props)=>/*#__PURE__*/ $ddb29fee3dff1f48$var$_react.default.createElement($ddb29fee3dff1f48$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-2.915 3.783c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$ddb29fee3dff1f48$var$EmojiIcon.displayName = "EmojiIcon";
var $ddb29fee3dff1f48$var$_default = module.exports.default = $ddb29fee3dff1f48$var$EmojiIcon;

});


parcelRegister("d1xAD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97b56c9b9eb8a32b$var$_react = $97b56c9b9eb8a32b$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $97b56c9b9eb8a32b$var$_folderClosed = $97b56c9b9eb8a32b$var$_interopRequireDefault((parcelRequire("ehFjV")));
function $97b56c9b9eb8a32b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $97b56c9b9eb8a32b$var$FolderIcon = (props)=>/*#__PURE__*/ $97b56c9b9eb8a32b$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862z"/></svg>`
    }, props, {
        newIcon: $97b56c9b9eb8a32b$var$_folderClosed.default
    }));
$97b56c9b9eb8a32b$var$FolderIcon.displayName = "FolderIcon";
var $97b56c9b9eb8a32b$var$_default = module.exports.default = $97b56c9b9eb8a32b$var$FolderIcon;

});
parcelRegister("ehFjV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0bcbb1797ade28bc1c80b60f118d24e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a662b49752416b07$var$_react = $a662b49752416b07$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $a662b49752416b07$var$_baseNew = $a662b49752416b07$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $a662b49752416b07$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderClosed".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a662b49752416b07$var$FolderClosedIcon = (props)=>/*#__PURE__*/ $a662b49752416b07$var$_react.default.createElement($a662b49752416b07$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v3h11V4.75a.5.5 0 0 0-.5-.5H7.69L5.94 2.5zm10.5 5h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h3.56l1.75 1.75H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$a662b49752416b07$var$FolderClosedIcon.displayName = "FolderClosedIcon";
var $a662b49752416b07$var$_default = module.exports.default = $a662b49752416b07$var$FolderClosedIcon;

});


parcelRegister("DynGV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $076e5001bf288d85$var$_react = $076e5001bf288d85$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $076e5001bf288d85$var$_personAdd = $076e5001bf288d85$var$_interopRequireDefault((parcelRequire("g0xEi")));
function $076e5001bf288d85$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $076e5001bf288d85$var$InviteTeamIcon = (props)=>/*#__PURE__*/ $076e5001bf288d85$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="2" height="6" x="18" y="5" rx="1"/><rect width="6" height="2" x="16" y="7" rx="1"/><path d="M5 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="11" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $076e5001bf288d85$var$_personAdd.default
    }));
$076e5001bf288d85$var$InviteTeamIcon.displayName = "InviteTeamIcon";
var $076e5001bf288d85$var$_default = module.exports.default = $076e5001bf288d85$var$InviteTeamIcon;

});
parcelRegister("g0xEi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7c8caaba4b6537db98d2e63ce6d8f75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba76bf61c8eefd7a$var$_react = $ba76bf61c8eefd7a$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $ba76bf61c8eefd7a$var$_baseNew = $ba76bf61c8eefd7a$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $ba76bf61c8eefd7a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba76bf61c8eefd7a$var$PersonAddIcon = (props)=>/*#__PURE__*/ $ba76bf61c8eefd7a$var$_react.default.createElement($ba76bf61c8eefd7a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m11.25 4.75V11h1.5V8.75H16v-1.5h-2.25V5h-1.5v2.25H10v1.5zm-8.5 1.75a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.5A3.75 3.75 0 0 1 10 12.75V15H8.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$ba76bf61c8eefd7a$var$PersonAddIcon.displayName = "PersonAddIcon";
var $ba76bf61c8eefd7a$var$_default = module.exports.default = $ba76bf61c8eefd7a$var$PersonAddIcon;

});


parcelRegister("cNevM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95055157ec33958b$var$_react = $95055157ec33958b$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $95055157ec33958b$var$_workItem = $95055157ec33958b$var$_interopRequireDefault((parcelRequire("5DJNp")));
function $95055157ec33958b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $95055157ec33958b$var$IssueIcon = (props)=>/*#__PURE__*/ $95055157ec33958b$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 15.991c0 .007 14.005.009 14.005.009C18.999 16 19 8.009 19 8.009 19 8.002 4.995 8 4.995 8 5.001 8 5 15.991 5 15.991M3 8.01C3 6.899 3.893 6 4.995 6h14.01C20.107 6 21 6.902 21 8.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 15.991z"/><path d="M10.674 14.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3z"/></g></svg>`
    }, props, {
        newIcon: $95055157ec33958b$var$_workItem.default
    }));
$95055157ec33958b$var$IssueIcon.displayName = "IssueIcon";
var $95055157ec33958b$var$_default = module.exports.default = $95055157ec33958b$var$IssueIcon;

});
parcelRegister("5DJNp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16b1a013266ea85d8875a6b5e1d2412a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $41b41e64872b655c$var$_react = $41b41e64872b655c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $41b41e64872b655c$var$_baseNew = $41b41e64872b655c$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $41b41e64872b655c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $41b41e64872b655c$var$WorkItemIcon = (props)=>/*#__PURE__*/ $41b41e64872b655c$var$_react.default.createElement($41b41e64872b655c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$41b41e64872b655c$var$WorkItemIcon.displayName = "WorkItemIcon";
var $41b41e64872b655c$var$_default = module.exports.default = $41b41e64872b655c$var$WorkItemIcon;

});


parcelRegister("e9JPb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a4e573be262049b5$var$_react = $a4e573be262049b5$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $a4e573be262049b5$var$_lightbulb = $a4e573be262049b5$var$_interopRequireDefault((parcelRequire("foKoE")));
function $a4e573be262049b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a4e573be262049b5$var$LightbulbFilledIcon = (props)=>/*#__PURE__*/ $a4e573be262049b5$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.998 4A5.997 5.997 0 0 0 6 9.998c0 2.218 2.288 4.484 2.288 4.484.39.387.71 1.112.71 1.611s.45.907 1 .907h4c.55 0 1-.408 1-.907s.32-1.224.71-1.611c0 0 2.288-2.266 2.288-4.484A5.997 5.997 0 0 0 11.998 4m2.965 15c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v.003c0 .55.45 1 1 1h4c.55 0 1-.45 1-1z"/></svg>`
    }, props, {
        newIcon: $a4e573be262049b5$var$_lightbulb.default
    }));
$a4e573be262049b5$var$LightbulbFilledIcon.displayName = "LightbulbFilledIcon";
var $a4e573be262049b5$var$_default = module.exports.default = $a4e573be262049b5$var$LightbulbFilledIcon;

});
parcelRegister("foKoE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5f93e34be6622a1cb8208e9984b09a45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b35d164c36c1b05f$var$_react = $b35d164c36c1b05f$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b35d164c36c1b05f$var$_baseNew = $b35d164c36c1b05f$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b35d164c36c1b05f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b35d164c36c1b05f$var$LightbulbIcon = (props)=>/*#__PURE__*/ $b35d164c36c1b05f$var$_react.default.createElement($b35d164c36c1b05f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 12.5H6V14a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-2-11c-3.022 0-4.935 3.243-3.473 5.888L5.535 9.21c.303.548.463 1.164.465 1.79h4a3.7 3.7 0 0 1 .465-1.79l1.008-1.822C12.935 4.743 11.022 1.5 8 1.5M11.5 14a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-2.988a2.2 2.2 0 0 0-.277-1.075L3.215 8.114C1.2 4.47 3.835 0 8 0c4.164 0 6.8 4.47 4.785 8.114l-1.008 1.823a2.2 2.2 0 0 0-.277 1.075z"/>`
    }, props));
$b35d164c36c1b05f$var$LightbulbIcon.displayName = "LightbulbIcon";
var $b35d164c36c1b05f$var$_default = module.exports.default = $b35d164c36c1b05f$var$LightbulbIcon;

});


parcelRegister("lhvME", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7e3d70f77f45299$var$_react = $f7e3d70f77f45299$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");
function $f7e3d70f77f45299$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f7e3d70f77f45299$var$ListIcon = (props)=>/*#__PURE__*/ $f7e3d70f77f45299$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M3 18a1 1 0 0 0 .99 1H20a.99.99 0 0 0 1-1v-1H3zm0-7h18V9H3zm0-4h18V6c0-.55-.44-1-.99-1H3.99A.99.99 0 0 0 3 6zm0 8h18v-2H3z"/></svg>`
    }, props));
$f7e3d70f77f45299$var$ListIcon.displayName = "ListIcon";
var $f7e3d70f77f45299$var$_default = module.exports.default = $f7e3d70f77f45299$var$ListIcon;

});

parcelRegister("itghZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d72792188beaf418$var$_react = $d72792188beaf418$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $d72792188beaf418$var$_peopleGroup = $d72792188beaf418$var$_interopRequireDefault((parcelRequire("ft8Zd")));
function $d72792188beaf418$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d72792188beaf418$var$PeopleIcon = (props)=>/*#__PURE__*/ $d72792188beaf418$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props, {
        newIcon: $d72792188beaf418$var$_peopleGroup.default
    }));
$d72792188beaf418$var$PeopleIcon.displayName = "PeopleIcon";
var $d72792188beaf418$var$_default = module.exports.default = $d72792188beaf418$var$PeopleIcon;

});
parcelRegister("ft8Zd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bbccaea74398c387e69395dfeae5f34>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b43088f9384ecc2c$var$_react = $b43088f9384ecc2c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b43088f9384ecc2c$var$_baseNew = $b43088f9384ecc2c$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b43088f9384ecc2c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b43088f9384ecc2c$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $b43088f9384ecc2c$var$_react.default.createElement($b43088f9384ecc2c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>`
    }, props));
$b43088f9384ecc2c$var$PeopleGroupIcon.displayName = "PeopleGroupIcon";
var $b43088f9384ecc2c$var$_default = module.exports.default = $b43088f9384ecc2c$var$PeopleGroupIcon;

});


parcelRegister("fqjcR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b3a82eb5ce64069c$var$_react = $b3a82eb5ce64069c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");
function $b3a82eb5ce64069c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b3a82eb5ce64069c$var$PortfolioIcon = (props)=>/*#__PURE__*/ $b3a82eb5ce64069c$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.83 17h6.34a3.001 3.001 0 1 1 0 2H8.83a3.001 3.001 0 1 1 0-2M3 5c0-1.105.895-2 1.994-2h12.012C18.107 3 19 3.888 19 5c0 1.105-.895 2-1.994 2H4.994A1.99 1.99 0 0 1 3 5m5 6a2 2 0 0 1 2.003-2h8.994a2 2 0 1 1 0 4h-8.994A1.996 1.996 0 0 1 8 11"/></svg>`
    }, props));
$b3a82eb5ce64069c$var$PortfolioIcon.displayName = "PortfolioIcon";
var $b3a82eb5ce64069c$var$_default = module.exports.default = $b3a82eb5ce64069c$var$PortfolioIcon;

});

parcelRegister("cgxwH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ee0fc5254d5e6d3$var$_react = $8ee0fc5254d5e6d3$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $8ee0fc5254d5e6d3$var$_settings = $8ee0fc5254d5e6d3$var$_interopRequireDefault((parcelRequire("9kkWb")));
function $8ee0fc5254d5e6d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8ee0fc5254d5e6d3$var$SettingsIcon = (props)=>/*#__PURE__*/ $8ee0fc5254d5e6d3$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.701 16.7a5.002 5.002 0 1 1 0-10.003 5.002 5.002 0 0 1 0 10.004m8.368-3.117a1.995 1.995 0 0 1-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 0 0 .315-.574 9 9 0 0 0-.836-1.993.48.48 0 0 0-.598-.195 2.04 2.04 0 0 1-1.29.08 1.99 1.99 0 0 1-1.404-1.395 2.04 2.04 0 0 1 .076-1.297.48.48 0 0 0-.196-.597 9 9 0 0 0-1.975-.826.48.48 0 0 0-.574.314 1.995 1.995 0 0 1-1.885 1.346 1.99 1.99 0 0 1-1.884-1.345.48.48 0 0 0-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 0 0-.198.582A2.002 2.002 0 0 1 4.445 7.06a.48.48 0 0 0-.595.196 9 9 0 0 0-.833 1.994.48.48 0 0 0 .308.572 1.995 1.995 0 0 1 1.323 1.877c0 .867-.552 1.599-1.324 1.877a.48.48 0 0 0-.308.57 9 9 0 0 0 .723 1.79.477.477 0 0 0 .624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 0 0 .168.628 9 9 0 0 0 2.11.897.474.474 0 0 0 .57-.313 1.995 1.995 0 0 1 1.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 0 0 .57.313 9 9 0 0 0 2.084-.883.473.473 0 0 0 .167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 0 0 .628-.19 9 9 0 0 0 .728-1.793.48.48 0 0 0-.314-.573"/></svg>`
    }, props, {
        newIcon: $8ee0fc5254d5e6d3$var$_settings.default
    }));
$8ee0fc5254d5e6d3$var$SettingsIcon.displayName = "SettingsIcon";
var $8ee0fc5254d5e6d3$var$_default = module.exports.default = $8ee0fc5254d5e6d3$var$SettingsIcon;

});
parcelRegister("9kkWb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::654979ffcf55141d2c08f198a843721e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ca6390960ed258c$var$_react = $6ca6390960ed258c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $6ca6390960ed258c$var$_baseNew = $6ca6390960ed258c$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $6ca6390960ed258c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6ca6390960ed258c$var$SettingsIcon = (props)=>/*#__PURE__*/ $6ca6390960ed258c$var$_react.default.createElement($6ca6390960ed258c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$6ca6390960ed258c$var$SettingsIcon.displayName = "SettingsIcon";
var $6ca6390960ed258c$var$_default = module.exports.default = $6ca6390960ed258c$var$SettingsIcon;

});


parcelRegister("haaTf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7ebd15dd5a3a3bb$var$_react = $c7ebd15dd5a3a3bb$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $c7ebd15dd5a3a3bb$var$_sprint = $c7ebd15dd5a3a3bb$var$_interopRequireDefault((parcelRequire("cv7vZ")));
function $c7ebd15dd5a3a3bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c7ebd15dd5a3a3bb$var$SprintIcon = (props)=>/*#__PURE__*/ $c7ebd15dd5a3a3bb$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m17.717 17.137-1.436-1.438a1.003 1.003 0 0 1 1.418-1.418l3.007 3.01a1 1 0 0 1 0 1.417l-3.007 3.01a1.003 1.003 0 0 1-1.417-1.42l1.3-1.3-6.072-.003A8 8 0 0 1 4 11.01C4 6.587 7.582 3 12 3s8 3.587 8 8.01a8 8 0 0 1-.789 3.451l-1.438-1.44a6.1 6.1 0 0 0 .345-2.01A6.12 6.12 0 0 0 12 4.884a6.12 6.12 0 0 0-6.118 6.125 6.12 6.12 0 0 0 5.647 6.102zm-12.163-.119c.561.759 1.456 1.49 2.457 1.981L3.937 19C3.42 19 3 18.552 3 18s.42-1 .937-1l1.614.005z"/></svg>`
    }, props, {
        newIcon: $c7ebd15dd5a3a3bb$var$_sprint.default
    }));
$c7ebd15dd5a3a3bb$var$SprintIcon.displayName = "SprintIcon";
var $c7ebd15dd5a3a3bb$var$_default = module.exports.default = $c7ebd15dd5a3a3bb$var$SprintIcon;

});
parcelRegister("cv7vZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3028194b67909de4178ae7b995e8e7b7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $919e359f42e14ab3$var$_react = $919e359f42e14ab3$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $919e359f42e14ab3$var$_baseNew = $919e359f42e14ab3$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $919e359f42e14ab3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sprint".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sprints in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $919e359f42e14ab3$var$SprintIcon = (props)=>/*#__PURE__*/ $919e359f42e14ab3$var$_react.default.createElement($919e359f42e14ab3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A4.75 4.75 0 0 0 8 11h5.44l-2.22-2.22 1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H0V11h3.938A6.25 6.25 0 1 1 14.25 6.25h-1.5A4.75 4.75 0 0 0 8 1.5" clip-rule="evenodd"/>`
    }, props));
$919e359f42e14ab3$var$SprintIcon.displayName = "SprintIcon";
var $919e359f42e14ab3$var$_default = module.exports.default = $919e359f42e14ab3$var$SprintIcon;

});


parcelRegister("egeJ8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a61dfbc9e4aeb074$var$_react = $a61dfbc9e4aeb074$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");
function $a61dfbc9e4aeb074$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a61dfbc9e4aeb074$var$StatusIcon = (props)=>/*#__PURE__*/ $a61dfbc9e4aeb074$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M4 5h16c1.105 0 2 1.045 2 2.333v9.334C22 17.955 21.105 19 20 19H4c-1.105 0-2-1.045-2-2.333V7.333C2 6.045 2.895 5 4 5m3.465 9.887h1.278L6.786 9.251H5.399l-1.957 5.636h1.183l.434-1.343h1.98zM6.02 10.423h.07l.7 2.21H5.313zm6.215 4.464c1.203 0 1.95-.625 1.95-1.613 0-.726-.544-1.289-1.29-1.344v-.07a1.22 1.22 0 0 0 1.02-1.203c0-.871-.653-1.406-1.747-1.406H9.704v5.636zm-1.352-4.734h.985c.562 0 .886.27.886.719 0 .453-.347.715-.984.715h-.887zm0 3.832v-1.601h1.024c.695 0 1.074.273 1.074.789 0 .527-.367.812-1.047.812zm6.762 1.047c1.36 0 2.352-.84 2.45-2.059h-1.15c-.112.621-.62 1.02-1.296 1.02-.89 0-1.441-.738-1.441-1.926s.55-1.922 1.437-1.922c.672 0 1.184.426 1.297 1.074h1.148c-.086-1.226-1.109-2.113-2.445-2.113-1.637 0-2.645 1.13-2.645 2.961 0 1.836 1.012 2.965 2.645 2.965"/></svg>`
    }, props));
$a61dfbc9e4aeb074$var$StatusIcon.displayName = "StatusIcon";
var $a61dfbc9e4aeb074$var$_default = module.exports.default = $a61dfbc9e4aeb074$var$StatusIcon;

});

parcelRegister("2HBdl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f7c76e463f4d85f$var$_react = $1f7c76e463f4d85f$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $1f7c76e463f4d85f$var$_subtasks = $1f7c76e463f4d85f$var$_interopRequireDefault((parcelRequire("1i7Rp")));
function $1f7c76e463f4d85f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1f7c76e463f4d85f$var$SubtaskIcon = (props)=>/*#__PURE__*/ $1f7c76e463f4d85f$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M19 7c1.105.003 2 .899 2 2.006v9.988A2.005 2.005 0 0 1 18.994 21H9.006A2.005 2.005 0 0 1 7 19h11c.555 0 1-.448 1-1zM3 5.006C3 3.898 3.897 3 5.006 3h9.988C16.102 3 17 3.897 17 5.006v9.988A2.005 2.005 0 0 1 14.994 17H5.006A2.005 2.005 0 0 1 3 14.994zM5 5v10h10V5z"/><path d="M7.707 9.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L9 10.586z"/></g></svg>`
    }, props, {
        newIcon: $1f7c76e463f4d85f$var$_subtasks.default
    }));
$1f7c76e463f4d85f$var$SubtaskIcon.displayName = "SubtaskIcon";
var $1f7c76e463f4d85f$var$_default = module.exports.default = $1f7c76e463f4d85f$var$SubtaskIcon;

});
parcelRegister("1i7Rp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb1eed99abd44e812ae4cb98f136c93f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f0d91d0e8faa7c8$var$_react = $0f0d91d0e8faa7c8$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $0f0d91d0e8faa7c8$var$_baseNew = $0f0d91d0e8faa7c8$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $0f0d91d0e8faa7c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for subtask work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f0d91d0e8faa7c8$var$SubtasksIcon = (props)=>/*#__PURE__*/ $0f0d91d0e8faa7c8$var$_react.default.createElement($0f0d91d0e8faa7c8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 9.25a.5.5 0 0 0-.5-.5H8.75V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5zM7.25 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 0 .5.5h4.25zm1.5 4.25H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H9.25a2 2 0 0 1-2-2V8.75H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3.75a2 2 0 0 1 2 2z"/>`
    }, props));
$0f0d91d0e8faa7c8$var$SubtasksIcon.displayName = "SubtasksIcon";
var $0f0d91d0e8faa7c8$var$_default = module.exports.default = $0f0d91d0e8faa7c8$var$SubtasksIcon;

});


parcelRegister("iHnIP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9cea4d76be7ef3d$var$_react = $d9cea4d76be7ef3d$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $d9cea4d76be7ef3d$var$_teams = $d9cea4d76be7ef3d$var$_interopRequireDefault((parcelRequire("eH5ui")));
function $d9cea4d76be7ef3d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d9cea4d76be7ef3d$var$TeamsIcon = (props)=>/*#__PURE__*/ $d9cea4d76be7ef3d$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9 7.2a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m7.8 0a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m1.2 9.3a4.5 4.5 0 0 0-4.5-4.5h-1.378c-.484 0-1.275.127-1.875.41l.77 1.627c.14-.066.342-.129.566-.174s.421-.063.539-.063H17.1a2.7 2.7 0 0 1 2.7 2.7V18a.6.6 0 0 1-.6.6h-3.478a2.7 2.7 0 0 1-2.538-1.777l-.676-1.86A4.5 4.5 0 0 0 8.278 12H6.9a4.5 4.5 0 0 0-4.5 4.5V18a2.4 2.4 0 0 0 2.4 2.4h4.8v-1.8H4.8a.6.6 0 0 1-.6-.6v-1.5a2.7 2.7 0 0 1 2.7-2.7h1.378a2.7 2.7 0 0 1 2.538 1.777l.676 1.86a4.5 4.5 0 0 0 4.23 2.963H19.2a2.4 2.4 0 0 0 2.4-2.4z" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $d9cea4d76be7ef3d$var$_teams.default
    }));
$d9cea4d76be7ef3d$var$TeamsIcon.displayName = "TeamsIcon";
var $d9cea4d76be7ef3d$var$_default = module.exports.default = $d9cea4d76be7ef3d$var$TeamsIcon;

});
parcelRegister("eH5ui", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::045b0e6f318b6cb40cf896c360eca820>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab29569377c90e7c$var$_react = $ab29569377c90e7c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $ab29569377c90e7c$var$_baseNew = $ab29569377c90e7c$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $ab29569377c90e7c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab29569377c90e7c$var$TeamsIcon = (props)=>/*#__PURE__*/ $ab29569377c90e7c$var$_react.default.createElement($ab29569377c90e7c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>`
    }, props));
$ab29569377c90e7c$var$TeamsIcon.displayName = "TeamsIcon";
var $ab29569377c90e7c$var$_default = module.exports.default = $ab29569377c90e7c$var$TeamsIcon;

});


parcelRegister("lnsmo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f901beaf7c898181$var$_react = $f901beaf7c898181$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $f901beaf7c898181$var$_eyeOpen = $f901beaf7c898181$var$_interopRequireDefault((parcelRequire("cm6I6")));
function $f901beaf7c898181$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f901beaf7c898181$var$WatchIcon = (props)=>/*#__PURE__*/ $f901beaf7c898181$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M12 18c-4.536 0-7.999-4.26-7.999-6 0-2.001 3.459-6 8-6 4.376 0 7.998 3.973 7.998 6 0 1.74-3.462 6-7.998 6m0-14C6.48 4 2 8.841 2 12c0 3.086 4.576 8 10 8 5.423 0 10-4.914 10-8 0-3.159-4.48-8-10-8"/><path d="M11.978 13.984c-1.104 0-2-.897-2-2s.896-2 2-2c1.103 0 2 .897 2 2s-.897 2-2 2m0-6c-2.206 0-4 1.794-4 4s1.793 4 4 4 4-1.794 4-4-1.794-4-4-4"/></g></svg>`
    }, props, {
        newIcon: $f901beaf7c898181$var$_eyeOpen.default
    }));
$f901beaf7c898181$var$WatchIcon.displayName = "WatchIcon";
var $f901beaf7c898181$var$_default = module.exports.default = $f901beaf7c898181$var$WatchIcon;

});
parcelRegister("cm6I6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7831691c1245bdf104acebfc690a968c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8fecbea8f909d674$var$_react = $8fecbea8f909d674$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $8fecbea8f909d674$var$_baseNew = $8fecbea8f909d674$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $8fecbea8f909d674$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8fecbea8f909d674$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $8fecbea8f909d674$var$_react.default.createElement($8fecbea8f909d674$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$8fecbea8f909d674$var$EyeOpenIcon.displayName = "EyeOpenIcon";
var $8fecbea8f909d674$var$_default = module.exports.default = $8fecbea8f909d674$var$EyeOpenIcon;

});


parcelRegister("6akvZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47d3971a68f6de4a$var$_react = $47d3971a68f6de4a$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $47d3971a68f6de4a$var$_globe = $47d3971a68f6de4a$var$_interopRequireDefault((parcelRequire("5XRUs")));
function $47d3971a68f6de4a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $47d3971a68f6de4a$var$WorldIcon = (props)=>/*#__PURE__*/ $47d3971a68f6de4a$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m-.9-1.863A7.19 7.19 0 0 1 4.8 12c0-.558.072-1.089.189-1.611L9.3 14.7v.9c0 .99.81 1.8 1.8 1.8zm6.21-2.286A1.79 1.79 0 0 0 15.6 15.6h-.9v-2.7c0-.495-.405-.9-.9-.9H8.4v-1.8h1.8c.495 0 .9-.405.9-.9V7.5h1.8c.99 0 1.8-.81 1.8-1.8v-.369c2.637 1.071 4.5 3.654 4.5 6.669 0 1.872-.72 3.573-1.89 4.851"/></svg>`
    }, props, {
        newIcon: $47d3971a68f6de4a$var$_globe.default
    }));
$47d3971a68f6de4a$var$WorldIcon.displayName = "WorldIcon";
var $47d3971a68f6de4a$var$_default = module.exports.default = $47d3971a68f6de4a$var$WorldIcon;

});
parcelRegister("5XRUs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::04422a31fe921661fd3c15a462bdcae0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $457c47c57a91dbf4$var$_react = $457c47c57a91dbf4$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $457c47c57a91dbf4$var$_baseNew = $457c47c57a91dbf4$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $457c47c57a91dbf4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Globe".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: public link in Confluence share dialog, global rules in Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $457c47c57a91dbf4$var$GlobeIcon = (props)=>/*#__PURE__*/ $457c47c57a91dbf4$var$_react.default.createElement($457c47c57a91dbf4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.543 7.25h2.722c.073-1.784.403-3.413.92-4.663q.123-.294.26-.566A6.5 6.5 0 0 0 1.544 7.25M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 1.5c-.151 0-.364.07-.632.344-.27.276-.547.714-.796 1.316-.432 1.043-.733 2.47-.805 4.09h4.466c-.072-1.62-.373-3.047-.805-4.09-.249-.602-.526-1.04-.796-1.316C8.364 1.571 8.15 1.5 8 1.5m3.735 5.75c-.073-1.784-.403-3.413-.92-4.663a8 8 0 0 0-.26-.566 6.5 6.5 0 0 1 3.902 5.229zm-1.502 1.5H5.767c.072 1.62.373 3.047.805 4.09.249.602.526 1.04.796 1.316.268.273.481.344.632.344s.364-.07.632-.344c.27-.276.547-.714.796-1.316.432-1.043.733-2.47.805-4.09m.321 5.229q.14-.272.26-.566c.518-1.25.848-2.879.92-4.663h2.723a6.5 6.5 0 0 1-3.903 5.229m-5.108 0q-.14-.272-.26-.566c-.518-1.25-.848-2.879-.92-4.663H1.542a6.5 6.5 0 0 0 3.903 5.229" clip-rule="evenodd"/>`
    }, props));
$457c47c57a91dbf4$var$GlobeIcon.displayName = "GlobeIcon";
var $457c47c57a91dbf4$var$_default = module.exports.default = $457c47c57a91dbf4$var$GlobeIcon;

});



parcelRegister("2THDh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $940b70971081fe1e$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<cdbb621ac4ef7944807ab770c230da08>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $940b70971081fe1e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateKeyFeaturesSectionContentfulRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "ProductTemplateKeyFeaturesCollection",
            "kind": "LinkedField",
            "name": "keyFeaturesCollection",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaxonomyFeature",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "featureNameExternal",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "ProductTemplate",
    "abstractKey": null
};
$940b70971081fe1e$var$node.hash = "ea58d8a7472ddea992087c51d1db8a28";
var $940b70971081fe1e$export$2e2bcd8739ae039 = $940b70971081fe1e$var$node;

});


parcelRegister("2KyLQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $9b50fb2eb2b68c3e$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<ecc6c31075605bf43e861e94c653be35>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9b50fb2eb2b68c3e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "urlSlug"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 1
        },
        {
            "kind": "Variable",
            "name": "locale",
            "variableName": "locale"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "urlSlug",
                    "variableName": "urlSlug"
                }
            ],
            "kind": "ObjectValue",
            "name": "where"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "concreteType": "Sys",
        "kind": "LinkedField",
        "name": "sys",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "templateNameExternal",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pluginModuleKey",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v6 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organizationNameExternal",
            "storageKey": null
        }
    ], v7 = {
        "alias": null,
        "args": null,
        "concreteType": "CompanyNameInternal",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": null
    }, v8 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "CompanyNameInternal",
        "abstractKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "concreteType": "ProductTemplateTemplateTypeCollection",
        "kind": "LinkedField",
        "name": "templateTypeCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyTemplateType",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "templateTypeNameExternal",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlSlug",
        "storageKey": null
    }, v11 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
        }
    ], v12 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "json",
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "confluenceTemplateDetailsContentfulRelayPageQuery",
            "selections": [
                {
                    "alias": "templates",
                    "args": v1 /*: any*/ ,
                    "concreteType": "ProductTemplateCollection",
                    "kind": "LinkedField",
                    "name": "productTemplateCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductTemplate",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "templateHeaderSectionContentfulRelayFragment"
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "templateKeyFeaturesSectionContentfulRelayFragment"
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "templateCategorySectionContentfulRelayFragment"
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "templateDetailsSectionContentfulRelayFragment"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "confluenceTemplateDetailsContentfulRelayPageQuery",
            "selections": [
                {
                    "alias": "templates",
                    "args": v1 /*: any*/ ,
                    "concreteType": "ProductTemplateCollection",
                    "kind": "LinkedField",
                    "name": "productTemplateCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductTemplate",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "oneLinerHeadline",
                                    "storageKey": null
                                },
                                v4 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "contributor",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "authorNameExternal",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "jobTitle",
                                                    "storageKey": null
                                                },
                                                v7 /*: any*/ 
                                            ],
                                            "type": "Author",
                                            "abstractKey": null
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductTemplateKeyFeaturesCollection",
                                    "kind": "LinkedField",
                                    "name": "keyFeaturesCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TaxonomyFeature",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "featureNameExternal",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                v9 /*: any*/ ,
                                {
                                    "alias": "categories",
                                    "args": null,
                                    "concreteType": "ProductTemplateCategoryCollection",
                                    "kind": "LinkedField",
                                    "name": "categoryCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TaxonomyTemplateCategory",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "categoryNameExternal",
                                                    "storageKey": null
                                                },
                                                v10 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": "templatePreviews",
                                    "args": null,
                                    "concreteType": "AssetCollection",
                                    "kind": "LinkedField",
                                    "name": "templatePreviewCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Asset",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": v11 /*: any*/ ,
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductTemplateAboutThisTemplate",
                                    "kind": "LinkedField",
                                    "name": "aboutThisTemplate",
                                    "plural": false,
                                    "selections": v12 /*: any*/ ,
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductTemplateTemplateOverviewCollection",
                                    "kind": "LinkedField",
                                    "name": "templateOverviewCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TemplateOverview",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "overviewTitle",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TemplateOverviewOverviewDescription",
                                                    "kind": "LinkedField",
                                                    "name": "overviewDescription",
                                                    "plural": false,
                                                    "selections": v12 /*: any*/ ,
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductTemplateTemplateBenefitsCollection",
                                    "kind": "LinkedField",
                                    "name": "templateBenefitsCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TemplateBenefitContainer",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "benefitsTitle",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TemplateBenefitContainerTemplateBenefitContainerCollection",
                                                    "kind": "LinkedField",
                                                    "name": "templateBenefitContainerCollection",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "TemplateBenefit",
                                                            "kind": "LinkedField",
                                                            "name": "items",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "templateBenefitNameExternal",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "TemplateBenefitShortDescription",
                                                                    "kind": "LinkedField",
                                                                    "name": "shortDescription",
                                                                    "plural": false,
                                                                    "selections": v12 /*: any*/ ,
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductTemplateHowToUseThisTemplateCollection",
                                    "kind": "LinkedField",
                                    "name": "howToUseThisTemplateCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TemplateGuide",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "templateGuideNameExternal",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TemplateGuideTemplateStepsCollection",
                                                    "kind": "LinkedField",
                                                    "name": "templateStepsCollection",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "TemplateUseStep",
                                                            "kind": "LinkedField",
                                                            "name": "items",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "stepNameExternal",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "TemplateUseStepStepDescription",
                                                                    "kind": "LinkedField",
                                                                    "name": "stepDescription",
                                                                    "plural": false,
                                                                    "selections": v12 /*: any*/ ,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Asset",
                                                                    "kind": "LinkedField",
                                                                    "name": "stepAsset",
                                                                    "plural": false,
                                                                    "selections": v11 /*: any*/ ,
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductTemplateTemplateProductRationaleCollection",
                                    "kind": "LinkedField",
                                    "name": "templateProductRationaleCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TemplateProductRationale",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "rationaleTitle",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TemplateProductRationaleTemplateProductRationaleDescription",
                                                    "kind": "LinkedField",
                                                    "name": "templateProductRationaleDescription",
                                                    "plural": false,
                                                    "selections": v12 /*: any*/ ,
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductTemplateRelatedTemplatesCollection",
                                    "kind": "LinkedField",
                                    "name": "relatedTemplatesCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProductTemplate",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "previewBlurb",
                                                    "storageKey": null
                                                },
                                                v9 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "contributor",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v7 /*: any*/ 
                                                            ],
                                                            "type": "Author",
                                                            "abstractKey": null
                                                        },
                                                        v8 /*: any*/ 
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "1e56998e7009ce85b94c239b1b20a58d",
            "id": null,
            "metadata": {},
            "name": "confluenceTemplateDetailsContentfulRelayPageQuery",
            "operationKind": "query",
            "text": "query confluenceTemplateDetailsContentfulRelayPageQuery(\n  $locale: String\n  $urlSlug: String\n) {\n  templates: productTemplateCollection(limit: 1, locale: $locale, where: {urlSlug: $urlSlug}) {\n    items {\n      sys {\n        id\n      }\n      ...templateHeaderSectionContentfulRelayFragment\n      ...templateKeyFeaturesSectionContentfulRelayFragment\n      ...templateCategorySectionContentfulRelayFragment\n      ...templateDetailsSectionContentfulRelayFragment\n    }\n  }\n}\n\nfragment templateAuthorContentfulRelayFragment on ProductTemplate {\n  contributor {\n    __typename\n    ... on Author {\n      authorNameExternal\n      jobTitle\n      organization {\n        organizationNameExternal\n      }\n    }\n    ... on CompanyNameInternal {\n      organizationNameExternal\n    }\n  }\n}\n\nfragment templateBenefitsContentfulRelayFragment on TemplateBenefitContainer {\n  benefitsTitle\n  templateBenefitContainerCollection {\n    items {\n      templateBenefitNameExternal\n      shortDescription {\n        json\n      }\n    }\n  }\n}\n\nfragment templateCardContentfulRelayFragment on ProductTemplate {\n  sys {\n    id\n  }\n  templateNameExternal\n  urlSlug\n  pluginModuleKey\n  previewBlurb\n  templateTypeCollection {\n    items {\n      sys {\n        id\n      }\n      templateTypeNameExternal\n    }\n  }\n  contributor {\n    __typename\n    ... on Author {\n      organization {\n        organizationNameExternal\n      }\n    }\n    ... on CompanyNameInternal {\n      organizationNameExternal\n    }\n  }\n}\n\nfragment templateCategorySectionContentfulRelayFragment on ProductTemplate {\n  templateTypeCollection {\n    items {\n      sys {\n        id\n      }\n      templateTypeNameExternal\n    }\n  }\n  categories: categoryCollection {\n    items {\n      sys {\n        id\n      }\n      categoryNameExternal\n      urlSlug\n    }\n  }\n}\n\nfragment templateDescriptionContentfulRelayFragment on ProductTemplate {\n  aboutThisTemplate {\n    json\n  }\n}\n\nfragment templateDetailsSectionContentfulRelayFragment on ProductTemplate {\n  templateNameExternal\n  pluginModuleKey\n  templateTypeCollection {\n    items {\n      sys {\n        id\n      }\n      templateTypeNameExternal\n    }\n  }\n  ...templatePreviewContentfulRelayFragment\n  ...templateDescriptionContentfulRelayFragment\n  ...templateTabbedSectionContentfulRelayFragment\n  ...templateRelatedTemplatesContentfulRelayFragment\n}\n\nfragment templateGuideContentfulRelayFragment on TemplateGuide {\n  templateGuideNameExternal\n  templateStepsCollection {\n    items {\n      stepNameExternal\n      stepDescription {\n        json\n      }\n      stepAsset {\n        url\n      }\n    }\n  }\n}\n\nfragment templateHeaderSectionContentfulRelayFragment on ProductTemplate {\n  templateNameExternal\n  oneLinerHeadline\n  pluginModuleKey\n  ...templateAuthorContentfulRelayFragment\n}\n\nfragment templateKeyFeaturesSectionContentfulRelayFragment on ProductTemplate {\n  keyFeaturesCollection {\n    items {\n      featureNameExternal\n    }\n  }\n}\n\nfragment templatePreviewContentfulRelayFragment on ProductTemplate {\n  templateNameExternal\n  templateTypeCollection {\n    items {\n      sys {\n        id\n      }\n    }\n  }\n  templatePreviews: templatePreviewCollection {\n    items {\n      url\n    }\n  }\n}\n\nfragment templateRelatedTemplatesContentfulRelayFragment on ProductTemplate {\n  relatedTemplatesCollection {\n    items {\n      sys {\n        id\n      }\n      ...templateCardContentfulRelayFragment\n    }\n  }\n}\n\nfragment templateTabbedSectionContentfulRelayFragment on ProductTemplate {\n  templateOverviewCollection {\n    items {\n      overviewTitle\n      overviewDescription {\n        json\n      }\n    }\n  }\n  templateBenefitsCollection {\n    items {\n      ...templateBenefitsContentfulRelayFragment\n    }\n  }\n  howToUseThisTemplateCollection {\n    items {\n      ...templateGuideContentfulRelayFragment\n    }\n  }\n  templateProductRationaleCollection {\n    items {\n      rationaleTitle\n      templateProductRationaleDescription {\n        json\n      }\n    }\n  }\n}\n"
        }
    };
}();
$9b50fb2eb2b68c3e$var$node.hash = "58f05b29349913b5b21e570429855a37";
var $9b50fb2eb2b68c3e$export$2e2bcd8739ae039 = $9b50fb2eb2b68c3e$var$node;

});



parcelRegister("kyMgW", function(module, exports) {

$parcel$export(module.exports, "ConfluenceTemplatesRelayPage", function () { return $7dae8028b0fa3f83$export$931ec4cf658dfdff; });

var $loA2J = parcelRequire("loA2J");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");

var $dH3QU = parcelRequire("dH3QU");
const $7dae8028b0fa3f83$export$931ec4cf658dfdff = ({ queryRef: queryRef, mlTemplateIds: // @ts-ignore
mlTemplateIds })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3LLDq.CrossFlowTouchpointProvider), {
        productKeys: [
            (0, $i8kxh.ProductKeys).CONFLUENCE
        ],
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dH3QU.ConfluenceTemplatesUnifiedRelayPageTemplate), {
            queryRef: queryRef
        })
    });
};

});

parcelRegister("5YjFo", function(module, exports) {

$parcel$export(module.exports, "ConfluenceTemplateSearchRelayPage", function () { return $77ad31a83b99b350$export$b1405e79a5b8deb2; });

var $loA2J = parcelRequire("loA2J");

var $dH3QU = parcelRequire("dH3QU");
const $77ad31a83b99b350$export$b1405e79a5b8deb2 = ({ queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dH3QU.ConfluenceTemplatesUnifiedRelayPageTemplate), {
        queryRef: queryRef
    });
};

});

parcelRegister("7YM1S", function(module, exports) {

$parcel$export(module.exports, "SoftwareGuardPricingPage", function () { return $9323073cdf16db97$export$4d5b8f19509ba187; });

var $loA2J = parcelRequire("loA2J");

var $dT5kE = parcelRequire("dT5kE");
parcelRequire("3wIDg");
var $72MYd = parcelRequire("72MYd");
const $9323073cdf16db97$export$4d5b8f19509ba187 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dT5kE.PricingContentContextProviderRelay), {
        productId: "atlassian-access",
        pricingContent: pricingContent,
        queryRef: queryRef,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            "data-testid": "guard-pricing-page",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $72MYd.SoftwareGuardPricingPageTemplate), {
                pricing: pricing,
                countryCode: countryCode
            })
        })
    });
};

});
parcelRegister("3wIDg", function(module, exports) {
$parcel$export(module.exports, "SoftwareGuardPricingPageTemplate", function () { return (parcelRequire("72MYd")).SoftwareGuardPricingPageTemplate; });

var $72MYd = parcelRequire("72MYd");

});
parcelRegister("72MYd", function(module, exports) {

$parcel$export(module.exports, "SoftwareGuardPricingPageTemplate", function () { return $dd8dc2904dc2f574$export$633a765a05118a91; });
/* software-guard-pricing-page.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $5ZfUA = parcelRequire("5ZfUA");
parcelRequire("kmJhl");
var $jCXOw = parcelRequire("jCXOw");
var $bofgW = parcelRequire("bofgW");
parcelRequire("gUyvS");
var $khjAx = parcelRequire("khjAx");

var $dT5kE = parcelRequire("dT5kE");

var $ceE90 = parcelRequire("ceE90");

var $f8O3L = parcelRequire("f8O3L");

var $j1oGG = parcelRequire("j1oGG");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $gAJUc = parcelRequire("gAJUc");
parcelRequire("ccYBS");
var $1FqEx = parcelRequire("1FqEx");

var $4Cacz = parcelRequire("4Cacz");

var $evT5P = parcelRequire("evT5P");
const $dd8dc2904dc2f574$var$inlineLink = null;
const $dd8dc2904dc2f574$export$633a765a05118a91 = (props)=>{
    var _content_callToActionContainer, _content_callToActionContainer1, _questionsCtaContent_asset;
    const content = (0, $dT5kE.usePricingContentContext)();
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[0];
    const addonCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer1 = content.callToActionContainer) === null || _content_callToActionContainer1 === void 0 ? void 0 : _content_callToActionContainer1[1];
    const intl = (0, $f6qj2.default)();
    const localizedHref = (0, $3FBn4.useLocalizedHref)("/webinars/enterprise-cloud/defend-your-cloud-level-up-security-with-guard-premium");
    const guardBannerProps = {
        identifier: "GuardPricingPage.banner-alert.premium-edition",
        productKey: "atlassianGuard",
        text: intl.formatMessage({
            id: "GuardPricingPage.banner-alert.text",
            defaultMessage: "Atlassian Guard Premium is generally available!"
        }),
        linkText: intl.formatMessage({
            id: "GuardPricingPage.banner-alert.link-text",
            defaultMessage: "Read the blog."
        }),
        linkUrl: (0, $3FBn4.useLocalizedHref)("/blog/announcements/guard-premium"),
        dataEventProps: {
            "data-product-key": "atlassianGuard",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Read the blog",
            "data-label-english": "Read the blog"
        }
    };
    const webinarBannerProps = {
        identifier: "GuardPricingPage.banner-alert.webinar-september-4-2025",
        productKey: "atlassianGuard",
        text: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "GuardPricingPage.banner-alert.text.webinar-september-4-2025",
            defaultMessage: "<a>Ask the Experts: Guard Premium AMA</a> | Live Q&A | Sept 3rd & 4th",
            values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
                a: (textstring)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                        "data-event": "clicked",
                        "data-event-component": "linkButton",
                        "data-product-key": "guard",
                        "data-track-event": "GuardPricingPage.webinar.banner",
                        "data-event-container": "GuardPricingPageWebinar",
                        "data-label-english": "Ask the Experts: Guard Premium AMA",
                        href: localizedHref,
                        className: (0, $esG4f.default)([
                            "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz17la _9oik1r31 _1bnxglyw _jf4cnqa1"
                        ]),
                        style: {
                            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                        },
                        children: textstring
                    })
            })
        }),
        linkText: "",
        linkUrl: (0, $3FBn4.useLocalizedHref)("/blog/announcements/guard-premium")
    };
    const displayWebinarBanner = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7735GuardWebinar);
    const displayedBannerProps = displayWebinarBanner ? webinarBannerProps : guardBannerProps;
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _addonCtaContent_url, _content_getMoreDetailsTitle, _content_additionalDetails, _questionsCtaContent_url, _questionsCtaContent_title, _questionsCtaContent_text, _questionsCtaContent_valueProposition;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PricingPageLayout), {
            nav: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4Cacz.GuardNav), {}),
            banner: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5ZfUA.BannerAlert), (0, $7Knp0._)({}, displayedBannerProps)),
            showFallback: content === null || content === void 0 ? void 0 : content.hasError,
            children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1FqEx.ParentScrollTracking), {
                scrollTrackingEnabled: true,
                pageId: "guard-pricing-page",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PageHeading), {
                        children: content === null || content === void 0 ? void 0 : content.headline
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $evT5P.default), {
                        pricing: props.pricing,
                        countryCode: props.countryCode
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $khjAx.PricingFeatureTable), {
                        title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                        comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                        compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $jCXOw.DemoAddOn), {
                        headingText: addonCtaContent === null || addonCtaContent === void 0 ? void 0 : addonCtaContent.title,
                        bodyText: addonCtaContent === null || addonCtaContent === void 0 ? void 0 : addonCtaContent.valueProposition,
                        linkText: addonCtaContent === null || addonCtaContent === void 0 ? void 0 : addonCtaContent.text,
                        ctaHref: (_addonCtaContent_url = addonCtaContent === null || addonCtaContent === void 0 ? void 0 : addonCtaContent.url) !== null && _addonCtaContent_url !== void 0 ? _addonCtaContent_url : ""
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $f8O3L.QuotationsAdornment), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1FqEx.ParentScrollTracking), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ceE90.PricingFaq), {
                                header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                                planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $bofgW.QuestionsCta), {
                        product: "Guard",
                        ctaHref: (_questionsCtaContent_url = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.url) !== null && _questionsCtaContent_url !== void 0 ? _questionsCtaContent_url : undefined,
                        questionsHeader: (_questionsCtaContent_title = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.title) !== null && _questionsCtaContent_title !== void 0 ? _questionsCtaContent_title : undefined,
                        priceAndLicensingLinkText: (_questionsCtaContent_text = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.text) !== null && _questionsCtaContent_text !== void 0 ? _questionsCtaContent_text : undefined,
                        questionsBody: (_questionsCtaContent_valueProposition = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.valueProposition) !== null && _questionsCtaContent_valueProposition !== void 0 ? _questionsCtaContent_valueProposition : undefined,
                        imageHref: questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : (_questionsCtaContent_asset = questionsCtaContent.asset) === null || _questionsCtaContent_asset === void 0 ? void 0 : _questionsCtaContent_asset.url
                    })
                ]
            })
        })
    });
};

});
parcelRegister("4Cacz", function(module, exports) {

$parcel$export(module.exports, "GuardNav", function () { return $59641f41c7daf66c$export$941339143e9f5522; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $a0rKx = parcelRequire("a0rKx");

var $dyZbY = parcelRequire("dyZbY");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $gAJUc = parcelRequire("gAJUc");
const $59641f41c7daf66c$var$GuardLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "guard",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $a0rKx.GuardLogo), {
        appearance: "brand"
    });
};
const $59641f41c7daf66c$export$941339143e9f5522 = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = "https://admin.atlassian.com/atlassian-guard";
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    const capabilitiesHref = (0, $3FBn4.useLocalizedHref)("/software/guard/capabilities");
    const pricingHref = (0, $3FBn4.useLocalizedHref)("/software/guard/pricing");
    const guideHref = (0, $3FBn4.useLocalizedHref)("/software/guard/guide#getting-started");
    const demoHref = (0, $3FBn4.useLocalizedHref)("/software/guard/demo");
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "confluence-pt-cfind-1234-GuardNav",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
            productLogoUrl: "/software/guard",
            productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($59641f41c7daf66c$var$GuardLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "GuardPageTemplate.navbar.guard-logo",
                defaultMessage: "Guard logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "GuardPageTemplate.navbar.tryitfree",
                defaultMessage: "Try it free"
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: "GuardPageTemplate.navbar.tryitfree",
                defaultMessage: "Try it free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($59641f41c7daf66c$var$GuardLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "capabilities",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.capabilities",
                        defaultMessage: "Capabilities"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: capabilitiesHref
                },
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.pricing",
                        defaultMessage: "Pricing"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: pricingHref
                },
                {
                    globalLinksKey: "guide",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.guide",
                        defaultMessage: "Guide"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: guideHref
                },
                {
                    globalLinksKey: "demo",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.demo",
                        defaultMessage: "Demo"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: demoHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-guard",
                    mobileLinksProps: [
                        {
                            globalLinksKey: "capabilities",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.capabilities",
                                defaultMessage: "Capabilities"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: capabilitiesHref
                        },
                        {
                            globalLinksKey: "pricing",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.pricing",
                                defaultMessage: "Pricing"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: pricingHref
                        },
                        {
                            globalLinksKey: "guide",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.guide",
                                defaultMessage: "Guide"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: guideHref
                        },
                        {
                            globalLinksKey: "demo",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.demo",
                                defaultMessage: "Demo"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: demoHref
                        }
                    ]
                }
            ]
        })
    });
};

});

parcelRegister("evT5P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b79b9db3e02e169$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $6x1qA = parcelRequire("6x1qA");

var $7OWgU = parcelRequire("7OWgU");

var $l9lQF = parcelRequire("l9lQF");

var $esRX2 = parcelRequire("esRX2");

var $dT5kE = parcelRequire("dT5kE");
const $0b79b9db3e02e169$var$GuardPriceFinder = (props)=>{
    var _content_standard, _content_standard1, _content_premium, _content_premium1, _props_pricing_ccpPricingData, _props_pricing;
    const content = {
        standard: (0, $dT5kE.usePricingPlanComparison)("Standard"),
        premium: (0, $dT5kE.usePricingPlanComparison)("Premium")
    };
    const standardPlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "standard");
    const premiumPlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "premium");
    const guardProductPlans = [
        {
            planName: ((_content_standard = content.standard) === null || _content_standard === void 0 ? void 0 : _content_standard.planTitleExternal) || "Standard",
            offeringSku: "atlassian-access-standard-sku",
            description: ((_content_standard1 = content.standard) === null || _content_standard1 === void 0 ? void 0 : _content_standard1.planOneLiner) || "",
            recommendationLimit: 0,
            signupLimit: 50000,
            signupURLInfo: {
                shouldLocalize: false,
                urlDomain: "https://admin.atlassian.com",
                urlPath: "/atlassian-guard"
            },
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: ((_content_premium = content.premium) === null || _content_premium === void 0 ? void 0 : _content_premium.planTitleExternal) || "Premium",
            offeringSku: "atlassian-guard-premium-addon-sku",
            description: ((_content_premium1 = content.premium) === null || _content_premium1 === void 0 ? void 0 : _content_premium1.planOneLiner) || "",
            recommendationLimit: 99,
            signupLimit: 50000,
            signupURLInfo: {
                shouldLocalize: false,
                urlDomain: "https://admin.atlassian.com",
                urlPath: "/atlassian-guard-premium"
            },
            planFeatureMessages: premiumPlanFeatureMessages
        }
    ];
    const messages = (0, $6x1qA.defineMessages)({
        unitCountInputTextRedesign: {
            id: "GuardPriceFinder.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputTerm: {
            id: "GuardPriceFinder.priceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        cardOverSignupLimit: {
            id: "GuardPriceFinder.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "GuardPriceFinder.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "GuardPriceFinder.priceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "GuardPriceFinder.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        }
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $l9lQF.PriceFinderContextProvider), {
            dataProductKey: "atlassianGuard",
            productPlans: guardProductPlans,
            defaultUnitCount: 100,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OWgU.default), (0, $7Knp0._)({
                countryCode: props.countryCode,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.guard,
                messages: messages
            }, props))
        })
    });
};
$0b79b9db3e02e169$var$GuardPriceFinder.displayName = "GuardPriceFinderSection";
var $0b79b9db3e02e169$export$2e2bcd8739ae039 = $0b79b9db3e02e169$var$GuardPriceFinder;

});




parcelRegister("8KAIN", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswDesign", function () { return $38c6b9847b442370$export$911cc88a5f759c10; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $4xemF = parcelRequire("4xemF");
const $38c6b9847b442370$export$911cc88a5f759c10 = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4xemF.JiraSoftwarePagePaidLpJswAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-design",
        persona: "unknown",
        pageVariant: "design"
    }));
};

});
parcelRegister("4xemF", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswAnchor", function () { return $e203ff05954dfe45$export$5bd099500f106950; });
$parcel$export(module.exports, "useCheckPaidD0to6LoggedInJiraProductTourEligibility", function () { return $e203ff05954dfe45$export$c70e0e8af8a0ee98; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $5tcZn = parcelRequire("5tcZn");

var $f6qj2 = parcelRequire("f6qj2");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");
parcelRequire("D0EyQ");
var $g8Gdb = parcelRequire("g8Gdb");

var $3fquc = parcelRequire("3fquc");

var $gyzLx = parcelRequire("gyzLx");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");

var $k4Qty = parcelRequire("k4Qty");
const $e203ff05954dfe45$export$5bd099500f106950 = ({ anchorContents: anchorContents, persona: persona, teamType: teamType, pageId: pageId, pageVariant: pageVariant, animatedJiraTourProps: animatedJiraTourProps })=>{
    const intl = (0, $f6qj2.default)();
    const productHref = (0, $3FBn4.useLocalizedHref)("/software/jira");
    const [content, setContent] = (0, $iSvIT.useState)(undefined);
    const jfind1504ExperimentCheck = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).jfind1504AfterD7GetPaidUsersBackToProduct);
    const jfind1504AfterD7GetPaidUsersBackToProduct = jfind1504ExperimentCheck.type === "enrolled" && jfind1504ExperimentCheck.value;
    const fullVariantName = $e203ff05954dfe45$var$isTeamAnchor(pageVariant) ? `anchor-lp-jsw-team-${pageVariant}` : `paid-lp-jsw-${pageVariant || "features"}`;
    const { setAnchorLocalStorage: setAnchorLocalStorage } = (0, $k4Qty.useAnchorLocalStorage)();
    const isEligibleForJFind1504 = (0, $iMdoL.useGetUsersBackToProductAfterD7Cohort)(fullVariantName);
    if (isEligibleForJFind1504 && jfind1504ExperimentCheck.type === "enrolled") jfind1504ExperimentCheck.fireExposure();
    (0, $iSvIT.useEffect)(()=>{
        setAnchorLocalStorage({
            persona: persona,
            teamTypeInferredMl: teamType,
            team: ""
        });
        setContent(anchorContents);
    // We only want to run this useEffect once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const jiraD0to6Site = (0, $iMdoL.useProductD0to6Site)({
        productKey: (0, $jgJpJ.ProductKey).JIRA_SOFTWARE
    });
    /**
   * Jira Product Tour Paid D0to6 logged-in users
   */ const isPaidD0to6LoggedInJiraProductTourEligible = $e203ff05954dfe45$export$c70e0e8af8a0ee98(fullVariantName);
    if (!content) // TODO: loading UI for static renders
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {});
    const landingType = pageVariant === "features" || $e203ff05954dfe45$var$isTeamAnchor(pageVariant) ? "jira-software-rebranded-anchor" : "jira-software-anchor";
    const theme = pageVariant === "features" || $e203ff05954dfe45$var$isTeamAnchor(pageVariant) ? "dark-on-light" : "light-on-dark";
    const props = {
        hideNavigationBar: false,
        customHeroSection: undefined,
        landingType: landingType,
        pageId: pageId,
        animatedJiraTourProps: animatedJiraTourProps,
        showHorizontalRule: true,
        productNavProps: {
            productHref: productHref,
            productName: "jira",
            ariaLabel: intl.formatMessage({
                id: "wacJiraSoftwareNavigation.logo-label",
                defaultMessage: "Jira Software logo"
            }),
            dataProductKey: "jiraSoftware",
            showFreeHrefButton: false
        },
        heroProps: $e203ff05954dfe45$var$getHeroProps({
            resp: content,
            pageVariant: pageVariant,
            theme: theme
        }),
        tabsProps: $e203ff05954dfe45$var$getTabProps(content, landingType),
        ctaProps: $e203ff05954dfe45$var$getCtaProps(content),
        testimonialProps: $e203ff05954dfe45$var$getTestimonialProps(content),
        alternatingTextAndImageProps: $e203ff05954dfe45$var$getAlternatingTextAndImageProps(content),
        hasRebrandedSignupFormStyles: true,
        heroBgColor: theme == "dark-on-light" ? "bgWhite" : "bgBlackBlue"
    };
    return jiraD0to6Site && isPaidD0to6LoggedInJiraProductTourEligible ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "jfind-get-d1to6-users-back-to-product-for-paid",
        group: "variant",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
            experimentKey: "jfind-981-paid-jpto-logged-in-redesign",
            group: "Test",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gyzLx.PaidD0to6LoggedInJiraProductTourOverview), {})
        })
    }) : isEligibleForJFind1504 && jfind1504AfterD7GetPaidUsersBackToProduct ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $gyzLx.PaidD0to6LoggedInJiraProductTourOverview), {
        experimentValue: "jfind-1504-after-d7-get-users-back-to-product"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $3fquc.PaidLandingTemplate), (0, $7Knp0._)({}, props));
};
const $e203ff05954dfe45$var$heroFeatureMatrix = {
    features: {
        useNewHero: true,
        showAnimatedHero: true,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    pm: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: true
    },
    template: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: true
    },
    project_collaboration: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: false
    },
    automation: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: false
    },
    teamwork: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: false
    },
    agile: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: false
    },
    competitors: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: false
    },
    roadmaps: {
        useNewHero: true,
        showAnimatedHero: true,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: false
    },
    tracker: {
        useNewHero: true,
        showAnimatedHero: true,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: false
    },
    engineering: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    marketing: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    hr: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    legal: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    operations: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    design: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    programmgmt: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    sales: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    }
};
const $e203ff05954dfe45$var$isTeamAnchor = (pageVariant)=>{
    const teamAnchors = [
        "engineering",
        "marketing",
        "hr",
        "legal",
        "operations",
        "design",
        "programmgmt",
        "sales"
    ];
    return teamAnchors.includes(pageVariant);
};
const $e203ff05954dfe45$var$getHeroFeatures = (pageVariant)=>{
    const defaultFeatures = {
        useNewHero: false,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: false
    };
    return $e203ff05954dfe45$var$heroFeatureMatrix[pageVariant] || defaultFeatures;
};
// eslint-disable-next-line complexity
const $e203ff05954dfe45$var$getHeroProps = ({ resp: resp, pageVariant: pageVariant, theme: theme })=>{
    const defaultProps = {
        theme: theme,
        headerText: "",
        secondaryText: "",
        signup: {
            bundle: "jira-software",
            edition: "free",
            featureFlags: {
                enableDefaultExpandedEmail: false,
                enableDeferredFullName: true
            }
        }
    };
    if (!resp || !resp[0] || !resp[0].node) return defaultProps;
    const { headline: headline } = resp[0].node;
    const data = headline && headline[0] ? headline[0] : null;
    const planBenefits = (data === null || data === void 0 ? void 0 : data.planBenefits) && (data === null || data === void 0 ? void 0 : data.planBenefits[0]) ? data === null || data === void 0 ? void 0 : data.planBenefits[0] : null;
    const supportingAsset = planBenefits === null || planBenefits === void 0 ? void 0 : planBenefits.supportingAsset;
    const features = $e203ff05954dfe45$var$getHeroFeatures(pageVariant);
    const getImage = (url, description)=>url && description ? {
            src: url ? url : "",
            alt: description || ""
        } : undefined;
    const getFeaturesRawHtml = ()=>planBenefits && planBenefits.planFeatures && planBenefits.planFeatures[0] ? planBenefits.planFeatures[0].description || "" : "";
    return (0, $6iHNw._)((0, $7Knp0._)({}, defaultProps, features), {
        headerText: (data === null || data === void 0 ? void 0 : data.name) || "",
        secondaryText: (data === null || data === void 0 ? void 0 : data.subheading) || "",
        image: getImage(supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.url, supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.description),
        featuresRawHtml: getFeaturesRawHtml(),
        tertiaryText: (planBenefits === null || planBenefits === void 0 ? void 0 : planBenefits.description) || ""
    });
};
const $e203ff05954dfe45$var$getTabProps = (resp, landingType)=>{
    const defaultProps = {
        dataProductKey: "jiraSoftware-PaidLpJiraPm",
        headerText: "",
        tabStyles: {
            defaultBG: (0, $5ohHq.wacToken)("color.neutral.light0"),
            // eslint-disable-next-line local/ensure-wac-token-usage
            defaultText: "#091e42",
            hoverBG: (0, $5ohHq.wacToken)("color.neutral.light0"),
            // eslint-disable-next-line local/ensure-wac-token-usage
            hoverText: "#091e42",
            // eslint-disable-next-line local/ensure-wac-token-usage
            activeBG: "#deebff",
            // eslint-disable-next-line local/ensure-wac-token-usage
            activeText: "#091e42"
        },
        styles: {
            "--lp-tabs-hover": "#deebff",
            "--lp-tabs-unselected": "#6b778c"
        },
        tabs: undefined
    };
    if (!resp || !resp[0] || !resp[0].node) return defaultProps;
    const tabs = $e203ff05954dfe45$var$getTabs(resp);
    const primaryMessage = $e203ff05954dfe45$var$getPrimaryMessage(resp);
    return (0, $6iHNw._)((0, $7Knp0._)({}, defaultProps), {
        landingType: landingType,
        headerText: (primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.name) || "",
        tabs: tabs
    });
};
const $e203ff05954dfe45$var$getCtaProps = (resp)=>{
    const cta = $e203ff05954dfe45$var$getCta(resp);
    return {
        headerText: (cta === null || cta === void 0 ? void 0 : cta.valueProposition) || "",
        ctaProps: {
            buttonProps: {
                color: "yellow",
                url: (cta === null || cta === void 0 ? void 0 : cta.url) || "",
                text: (cta === null || cta === void 0 ? void 0 : cta.text) || "",
                dataEventProps: {
                    "data-event": "clicked",
                    "data-event-container": "ctaSection",
                    "data-event-component": "linkButton",
                    "data-product-key": "jiraSoftware"
                }
            }
        },
        backgroundProperties: {
            textColor: (0, $5ohHq.wacToken)("color.neutral.light0")
        }
    };
};
const $e203ff05954dfe45$var$getTestimonialProps = (resp)=>{
    var _data_customers;
    if (!resp || !resp[0] || !resp[0].node) return undefined;
    const { socialProof: socialProof } = resp[0].node;
    const data = socialProof && socialProof[0] ? socialProof[0] : null;
    if (!data) return undefined;
    return {
        headerText: data === null || data === void 0 ? void 0 : data.name,
        logos: data === null || data === void 0 ? void 0 : (_data_customers = data.customers) === null || _data_customers === void 0 ? void 0 : _data_customers.map((customer)=>{
            return {
                src: customer && customer.logo && (customer === null || customer === void 0 ? void 0 : customer.logo[0]) && (customer === null || customer === void 0 ? void 0 : customer.logo[0].url) ? customer === null || customer === void 0 ? void 0 : customer.logo[0].url : "",
                alt: customer && customer.logo && (customer === null || customer === void 0 ? void 0 : customer.logo[0]) && (customer === null || customer === void 0 ? void 0 : customer.logo[0].description) ? customer === null || customer === void 0 ? void 0 : customer.logo[0].description : "",
                lazy: true
            };
        })
    };
};
const $e203ff05954dfe45$var$getAlternatingTextAndImageProps = (resp)=>{
    const results = $e203ff05954dfe45$var$getResults(resp);
    function generateProps(result, index) {
        var _result_asset, _result_asset1;
        // this shouldn't go past
        const countMap = [
            "one",
            "two",
            "three",
            "four"
        ];
        const count = (0, (/*@__PURE__*/$parcel$interopDefault($5tcZn)))(`${countMap[index]}`);
        const position = index % 2 === 0 ? "left" : "right";
        return {
            [`row${count}Header`]: (result === null || result === void 0 ? void 0 : result.name) || "",
            [`row${count}Body`]: (result === null || result === void 0 ? void 0 : result.subheading) || "",
            [`row${count}ImageLink`]: result === null || result === void 0 ? void 0 : (_result_asset = result.asset) === null || _result_asset === void 0 ? void 0 : _result_asset.url,
            [`row${count}ImageAltText`]: (result === null || result === void 0 ? void 0 : (_result_asset1 = result.asset) === null || _result_asset1 === void 0 ? void 0 : _result_asset1.description) || "",
            [`row${count}ImagePosition`]: position
        };
    }
    const contentBlocks = results === null || results === void 0 ? void 0 : results.map((result, index)=>generateProps(result, index)).slice(0, 4) // ensure max of 4 results so we don't break the pattern
    .filter((result)=>!!result).reduce((acc, curr)=>{
        return (0, $7Knp0._)({}, acc, curr);
    });
    return (0, $7Knp0._)({
        imageWidth: "100%",
        imageTextSideRowOnePaddingBelowLargeScreen: "32px 0 16px",
        imageTextSideRowTwoPadding: "16px 0",
        imageTextSideRowThreePaddingBelowLargeScreen: "16px 0 32px"
    }, contentBlocks);
};
const $e203ff05954dfe45$var$getPrimaryMessage = (resp)=>{
    if (!resp || !resp[0] || !resp[0].node) return null;
    const { primaryMessage: primaryMessage } = resp[0].node;
    const data = primaryMessage && primaryMessage[0] ? primaryMessage[0] : null;
    return data;
};
const $e203ff05954dfe45$var$getTabs = (resp)=>{
    const primaryMessage = $e203ff05954dfe45$var$getPrimaryMessage(resp);
    if (!primaryMessage || !(primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.supportingExample)) return undefined;
    return primaryMessage.supportingExample.filter((tab)=>tab !== null)// eslint-disable-next-line complexity
    .map((tab)=>{
        var _advocateQuote_advocateHeadshot, _advocateQuote_advocateHeadshot1;
        const supportingAsset = tab === null || tab === void 0 ? void 0 : tab.supportingAsset;
        const advocateQuote = tab === null || tab === void 0 ? void 0 : tab.advocateQuote;
        return {
            textLabel: (tab === null || tab === void 0 ? void 0 : tab.name) || "",
            id: (tab === null || tab === void 0 ? void 0 : tab.name) || "",
            component: /*#__PURE__*/ (0, $loA2J.jsx)((0, $g8Gdb.default), {
                isShowTestimonyBorder: false,
                isIncludeTestimony: !!(tab === null || tab === void 0 ? void 0 : tab.advocateQuote),
                testimonyIsUsingTextQuotationMarks: true,
                title: (tab === null || tab === void 0 ? void 0 : tab.heading) || "",
                rawHtmlContent: (tab === null || tab === void 0 ? void 0 : tab.proofpoint) || "",
                imageSrc: (supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.url) || "",
                imageAlt: (supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.description) || "",
                quoteBlurb: (advocateQuote === null || advocateQuote === void 0 ? void 0 : advocateQuote.advocateQuote) || "",
                quoteName: (advocateQuote === null || advocateQuote === void 0 ? void 0 : advocateQuote.advocateName) || "",
                quoteCompany: (advocateQuote === null || advocateQuote === void 0 ? void 0 : advocateQuote.advocateJobTitle) || "",
                testimonyImageSrc: (advocateQuote === null || advocateQuote === void 0 ? void 0 : (_advocateQuote_advocateHeadshot = advocateQuote.advocateHeadshot) === null || _advocateQuote_advocateHeadshot === void 0 ? void 0 : _advocateQuote_advocateHeadshot.url) || "",
                testimonyImageAlt: (advocateQuote === null || advocateQuote === void 0 ? void 0 : (_advocateQuote_advocateHeadshot1 = advocateQuote.advocateHeadshot) === null || _advocateQuote_advocateHeadshot1 === void 0 ? void 0 : _advocateQuote_advocateHeadshot1.description) || ""
            }, tab === null || tab === void 0 ? void 0 : tab.name)
        };
    });
};
const $e203ff05954dfe45$var$getResults = (resp)=>{
    if (!resp || !resp[0] || !resp[0].node) return null;
    const { results: results } = resp[0].node;
    const data = results && results.length ? results : null;
    return data;
};
const $e203ff05954dfe45$var$getCta = (resp)=>{
    if (!resp || !resp[0] || !resp[0].node) return null;
    const { callToAction: callToAction } = resp[0].node;
    const data = callToAction && callToAction[0] ? callToAction[0] : null;
    return data;
};
const $e203ff05954dfe45$export$c70e0e8af8a0ee98 = (fullVariantName)=>{
    const excludedVariants = [
        "anchor-lp-jsw-team-engineering",
        "anchor-lp-jsw-team-marketing",
        "anchor-lp-jsw-team-hr",
        "anchor-lp-jsw-team-legal",
        "anchor-lp-jsw-team-operations",
        "anchor-lp-jsw-team-design",
        "anchor-lp-jsw-team-programmgmt",
        "anchor-lp-jsw-team-sales"
    ];
    return !excludedVariants.includes(fullVariantName);
};

});
parcelRegister("gyzLx", function(module, exports) {

$parcel$export(module.exports, "PaidD0to6LoggedInJiraProductTourOverview", function () { return $9b498fa8f55c50d4$export$bf24452123f59040; });

var $loA2J = parcelRequire("loA2J");

var $kex29 = parcelRequire("kex29");

var $jq0gD = parcelRequire("jq0gD");

var $fizjv = parcelRequire("fizjv");

var $b3X9l = parcelRequire("b3X9l");
parcelRequire("ccYBS");
var $1FqEx = parcelRequire("1FqEx");

var $iDySj = parcelRequire("iDySj");
const $9b498fa8f55c50d4$export$bf24452123f59040 = ({ experimentValue: experimentValue })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $fizjv.JiraSitesProvider), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $jq0gD.default), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $b3X9l.default), {})
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1FqEx.ParentScrollTracking), {
                    scrollTrackingEnabled: true,
                    pageId: "jsw",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $iDySj.LoggedInHeroSection), {
                            experimentValue: experimentValue
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {
                            fullWidth: true
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("fizjv", function(module, exports) {

$parcel$export(module.exports, "useJiraSitesContext", function () { return $d344c8ebc103d9ba$export$8095836340dcdac5; });
$parcel$export(module.exports, "JiraSitesProvider", function () { return $d344c8ebc103d9ba$export$e5844423e4215335; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $iMdoL = parcelRequire("iMdoL");

var $lpc6z = parcelRequire("lpc6z");

var $eZUFa = parcelRequire("eZUFa");
const $d344c8ebc103d9ba$var$JiraSitesContext = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $d344c8ebc103d9ba$export$8095836340dcdac5 = ()=>{
    const context = (0, $iSvIT.useContext)($d344c8ebc103d9ba$var$JiraSitesContext);
    if (!context) throw new Error("useJiraSitesContext must be used within a JiraSitesProvider");
    return context;
};
const $d344c8ebc103d9ba$export$e5844423e4215335 = ({ children: children })=>{
    var _profile_attributes;
    const [jiraSitesFromAgg, setJiraSitesFromAgg] = (0, $iSvIT.useState)(undefined);
    const { profile: profile } = (0, $iMdoL.useUserContext)();
    const { cloudSiteId: cloudSiteId } = (0, $eZUFa.useRecentJiraSite)();
    const aggClient = (0, $iSvIT.useMemo)(()=>new (0, $lpc6z.LoggedInUserJiraSitesClient)(), []);
    (0, $iSvIT.useEffect)(()=>{
        var _profile_attributes;
        if (!((_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingSites)) return;
        aggClient.getJiraSites(cloudSiteId !== null && cloudSiteId !== void 0 ? cloudSiteId : "").then((data)=>{
            setJiraSitesFromAgg(data);
        });
    }, [
        aggClient,
        (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingSites,
        cloudSiteId
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($d344c8ebc103d9ba$var$JiraSitesContext.Provider, {
        value: {
            jiraSitesFromAgg: jiraSitesFromAgg
        },
        children: children
    });
};

});

parcelRegister("b3X9l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66aaf34c3acac88c$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $iMdoL = parcelRequire("iMdoL");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $gAJUc = parcelRequire("gAJUc");

var $fizjv = parcelRequire("fizjv");
const $66aaf34c3acac88c$var$JiraLogo = ()=>{
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV2), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    });
};
const $66aaf34c3acac88c$var$SoftwareJiraLoggedInNavbar = ()=>{
    var _profile_attributes, _profile_attributes1;
    const intl = (0, $f6qj2.default)();
    const logoUrl = (0, $3FBn4.useLocalizedHref)("/software/jira");
    const { profile: profile } = (0, $iMdoL.useUserContext)();
    const { jiraSitesFromAgg: jiraSitesFromAgg } = (0, $fizjv.useJiraSitesContext)();
    const [siteUrl, setSiteUrl] = (0, $iSvIT.useState)("");
    (0, $iSvIT.useEffect)(()=>{
        var _profile_attributes, _jiraSitesFromAgg_jira_allJiraProjects_edges__node, _jiraSitesFromAgg_jira_allJiraProjects_edges_, _jiraSitesFromAgg_jira_allJiraProjects;
        //TODO: Probably a good spot for another UFO
        // e.g. if there are no resources for us to use
        const site = (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingSites[0];
        let tempSiteUrl = site === null || site === void 0 ? void 0 : site.url;
        if ((jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : jiraSitesFromAgg.jira.allJiraProjects.edges.length) === 1) tempSiteUrl = jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : (_jiraSitesFromAgg_jira_allJiraProjects = jiraSitesFromAgg.jira.allJiraProjects) === null || _jiraSitesFromAgg_jira_allJiraProjects === void 0 ? void 0 : (_jiraSitesFromAgg_jira_allJiraProjects_edges_ = _jiraSitesFromAgg_jira_allJiraProjects.edges[0]) === null || _jiraSitesFromAgg_jira_allJiraProjects_edges_ === void 0 ? void 0 : (_jiraSitesFromAgg_jira_allJiraProjects_edges__node = _jiraSitesFromAgg_jira_allJiraProjects_edges_.node) === null || _jiraSitesFromAgg_jira_allJiraProjects_edges__node === void 0 ? void 0 : _jiraSitesFromAgg_jira_allJiraProjects_edges__node.webUrl;
        setSiteUrl(tempSiteUrl !== null && tempSiteUrl !== void 0 ? tempSiteUrl : "");
    }, [
        jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : jiraSitesFromAgg.jira.allJiraProjects.edges,
        jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : jiraSitesFromAgg.jira.allJiraProjects.edges.length,
        (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingSites,
        (_profile_attributes1 = profile.attributes) === null || _profile_attributes1 === void 0 ? void 0 : _profile_attributes1.existingSites.length
    ]);
    const goToLoggedInJira = ()=>{
        window.location.assign(siteUrl);
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
        productLogoUrl: logoUrl,
        productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($66aaf34c3acac88c$var$JiraLogo, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: "wacJiraSoftwareNavigation.logo-label",
            defaultMessage: "Jira Software logo"
        }),
        mobileCtaText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.navbar.goToJira",
            defaultMessage: "Go to Jira"
        }),
        mobileCtaOnClick: goToLoggedInJira,
        mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($66aaf34c3acac88c$var$JiraLogo, {}),
        navigationTrynowCtaText: intl.formatMessage({
            id: "JiraFeatureSoftwarePageTemplate.navbar.goToJira",
            defaultMessage: "Go to Jira"
        }),
        navigationTrynowCtaOnClick: goToLoggedInJira,
        productPageNavLinks: [],
        mobileLinksSections: [],
        isShowSearchButton: false,
        isShowAppSwitcher: false,
        isShowTabletDropdown: false
    });
};
var $66aaf34c3acac88c$export$2e2bcd8739ae039 = $66aaf34c3acac88c$var$SoftwareJiraLoggedInNavbar;

});

parcelRegister("iDySj", function(module, exports) {

$parcel$export(module.exports, "LoggedInHeroSection", function () { return $f3fc89e21058fb11$export$49c6370202c57ed1; });
/* logged-in-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $iSjV6 = parcelRequire("iSjV6");

var $dWbel = parcelRequire("dWbel");

var $91nJf = parcelRequire("91nJf");

var $2ompn = parcelRequire("2ompn");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $1BHKA = parcelRequire("1BHKA");

var $eZUFa = parcelRequire("eZUFa");

var $c8uJK = parcelRequire("c8uJK");

var $5n5AO = parcelRequire("5n5AO");

var $fizjv = parcelRequire("fizjv");
var $f3fc89e21058fb11$var$TRACKING_EVENT_NAMES;
(function(TRACKING_EVENT_NAMES) {
    TRACKING_EVENT_NAMES["loggedInHeroProductCtaClicked"] = "loggedInHeroProductCtaClicked";
    TRACKING_EVENT_NAMES["loggedInHeroAnotherSiteCtaClicked"] = "loggedInHeroAnotherSiteCtaClicked";
    TRACKING_EVENT_NAMES["loggedInHeroExploreFeaturesClicked"] = "loggedInHeroExploreFeaturesClicked";
    TRACKING_EVENT_NAMES["loggedInHeroCreateNewSiteClicked"] = "loggedInHeroCreateNewSiteClicked";
})($f3fc89e21058fb11$var$TRACKING_EVENT_NAMES || ($f3fc89e21058fb11$var$TRACKING_EVENT_NAMES = {}));
const $f3fc89e21058fb11$var$START_URL = "https://start.atlassian.com";
const $f3fc89e21058fb11$export$cbc42fadf8b93ea3 = {
    eventType: "ui",
    action: "clicked",
    actionSubject: "button",
    actionSubjectId: "loggedInHero",
    source: "/software/jira"
};
const $f3fc89e21058fb11$var$jswLoggedInCss = null;
const $f3fc89e21058fb11$var$heroSectionCss = null;
const $f3fc89e21058fb11$var$anchorContainer = null;
const $f3fc89e21058fb11$var$blueBackdrop = null;
const $f3fc89e21058fb11$var$jiraSiteBoxCss = null;
const $f3fc89e21058fb11$var$headingCss = null;
const $f3fc89e21058fb11$var$starCss = null;
const $f3fc89e21058fb11$var$treatmentStarCss = null;
const $f3fc89e21058fb11$var$differentSiteCss = null;
const $f3fc89e21058fb11$var$subHeadingContainerCss = null;
const $f3fc89e21058fb11$var$createNewSiteAnchorCss = null;
const $f3fc89e21058fb11$var$subHeadingCss = null;
const $f3fc89e21058fb11$var$exploreFeaturesContainerCss = null;
const $f3fc89e21058fb11$var$exploreFeaturesHeadingCss = null;
const $f3fc89e21058fb11$var$exploreFeaturesCtaCss = null;
const $f3fc89e21058fb11$var$nameUnderlineCss = null;
const $f3fc89e21058fb11$var$inlineJiraLogoCss = null;
const $f3fc89e21058fb11$var$siteInfoContainerCss = null;
const $f3fc89e21058fb11$var$sitenameIconCss = null;
const $f3fc89e21058fb11$var$sitenameIconTextCss = null;
const $f3fc89e21058fb11$var$sitenameAndAvatarContainerCss = null;
const $f3fc89e21058fb11$var$siteNameSpanCss = null;
const $f3fc89e21058fb11$var$tooltipWrapperCss = null;
const $f3fc89e21058fb11$var$avatarContainerCss = null;
const $f3fc89e21058fb11$var$linkPlaceholderCss = null;
const $f3fc89e21058fb11$export$6f77dd305013b9bd = (experimentValue)=>{
    if (experimentValue === "jfind-1504-after-d7-get-users-back-to-product") return "ATLAS-93657";
    else return "ATLAS-77776";
}; // eslint-disable-next-line complexity
const $f3fc89e21058fb11$export$49c6370202c57ed1 = ({ experimentValue: experimentValue })=>{
    var _user_name, _jiraSitesFromAgg_jira_allJiraProjects_edges_, _jiraSitesFromAgg_jira, _jiraSitesFromAgg_jira1, _jiraSitesFromAgg_jira2, _profile_attributes, _jiraSitesFromAgg_jira3, _profile_attributes1;
    const { user: user, profile: profile } = (0, $2ompn.useUserContext)();
    const { jiraSitesFromAgg: jiraSitesFromAgg } = (0, $fizjv.useJiraSitesContext)();
    const intl = (0, $f6qj2.default)();
    const [teammateAvatars, setTeammateAvatars] = (0, $iSvIT.useState)([]);
    const [totalUserCount, setTotalUserCount] = (0, $iSvIT.useState)();
    const isTreatment = experimentValue === "jfind-1504-after-d7-get-users-back-to-product";
    const userFirstName = user === null || user === void 0 ? void 0 : (_user_name = user.name) === null || _user_name === void 0 ? void 0 : _user_name.split(" ")[0];
    const userPicture = user === null || user === void 0 ? void 0 : user.picture;
    const avatars = jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : (_jiraSitesFromAgg_jira = jiraSitesFromAgg.jira) === null || _jiraSitesFromAgg_jira === void 0 ? void 0 : (_jiraSitesFromAgg_jira_allJiraProjects_edges_ = _jiraSitesFromAgg_jira.allJiraProjects.edges[0]) === null || _jiraSitesFromAgg_jira_allJiraProjects_edges_ === void 0 ? void 0 : _jiraSitesFromAgg_jira_allJiraProjects_edges_.node.assignableUsers.edges;
    (0, $iSvIT.useEffect)(()=>{
        var _jiraSitesFromAgg_jira_allJiraProjects_edges_, _jiraSitesFromAgg_jira;
        var _jiraSitesFromAgg_jira_allJiraProjects_edges__node_assignableUsers_edges_filter_map;
        setTeammateAvatars((_jiraSitesFromAgg_jira_allJiraProjects_edges__node_assignableUsers_edges_filter_map = jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : (_jiraSitesFromAgg_jira = jiraSitesFromAgg.jira) === null || _jiraSitesFromAgg_jira === void 0 ? void 0 : (_jiraSitesFromAgg_jira_allJiraProjects_edges_ = _jiraSitesFromAgg_jira.allJiraProjects.edges[0]) === null || _jiraSitesFromAgg_jira_allJiraProjects_edges_ === void 0 ? void 0 : _jiraSitesFromAgg_jira_allJiraProjects_edges_.node.assignableUsers.edges.filter((assignableUser)=>assignableUser.node.picture != userPicture && assignableUser.node.accountStatus === "active" && !assignableUser.node.name.includes("-bot")).map((assignableUser)=>{
            var _assignableUser_node_picture;
            return (_assignableUser_node_picture = assignableUser.node.picture) !== null && _assignableUser_node_picture !== void 0 ? _assignableUser_node_picture : "";
        })) !== null && _jiraSitesFromAgg_jira_allJiraProjects_edges__node_assignableUsers_edges_filter_map !== void 0 ? _jiraSitesFromAgg_jira_allJiraProjects_edges__node_assignableUsers_edges_filter_map : []);
    }, [
        avatars,
        jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : (_jiraSitesFromAgg_jira1 = jiraSitesFromAgg.jira) === null || _jiraSitesFromAgg_jira1 === void 0 ? void 0 : _jiraSitesFromAgg_jira1.allJiraProjects.edges,
        userPicture
    ]);
    (0, $iSvIT.useEffect)(()=>{
        var _jiraSitesFromAgg_jira_allJiraProjects_edges_, _jiraSitesFromAgg_jira;
        return setTotalUserCount(jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : (_jiraSitesFromAgg_jira = jiraSitesFromAgg.jira) === null || _jiraSitesFromAgg_jira === void 0 ? void 0 : (_jiraSitesFromAgg_jira_allJiraProjects_edges_ = _jiraSitesFromAgg_jira.allJiraProjects.edges[0]) === null || _jiraSitesFromAgg_jira_allJiraProjects_edges_ === void 0 ? void 0 : _jiraSitesFromAgg_jira_allJiraProjects_edges_.node.assignableUsers.totalCount);
    }, [
        jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : (_jiraSitesFromAgg_jira2 = jiraSitesFromAgg.jira) === null || _jiraSitesFromAgg_jira2 === void 0 ? void 0 : _jiraSitesFromAgg_jira2.allJiraProjects.edges
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const localizedTryLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&createNew=true");
    const localizedProductGuideLink = (0, $3FBn4.useLocalizedHref)("/software/jira/guides/getting-started/introduction");
    const [hasMultipleJiras, setHasMultipleJiras] = (0, $iSvIT.useState)(false);
    const [siteName, setSiteName] = (0, $iSvIT.useState)("");
    const [siteInitials, setSiteInitials] = (0, $iSvIT.useState)("");
    (0, $iSvIT.useEffect)(()=>{
        var _profile_attributes, _availableJiraSites_;
        if (isTreatment) return;
        const availableJiraSites = (0, $eZUFa.filterAvailableJiraSites)((_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingSites); // Default state to whatever we might have got from SSR
        setHasMultipleJiras(availableJiraSites.length > 1);
        const siteNameFromAvailableJiraSites = ((_availableJiraSites_ = availableJiraSites[0]) === null || _availableJiraSites_ === void 0 ? void 0 : _availableJiraSites_.displayName) || "";
        setSiteName(siteNameFromAvailableJiraSites);
        setSiteInitials(siteNameFromAvailableJiraSites.slice(0, 1).toUpperCase() + siteNameFromAvailableJiraSites.slice(1, 2));
    }, [
        (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingSites,
        isTreatment
    ]);
    const [siteUrl, setSiteUrl] = (0, $iSvIT.useState)("");
    (0, $iSvIT.useEffect)(()=>{
        var _profile_attributes, _jiraSitesFromAgg_jira, _jiraSitesFromAgg_jira_allJiraProjects_edges_, _jiraSitesFromAgg_jira_allJiraProjects;
        if (isTreatment) return;
        if (!profile && !jiraSitesFromAgg) return;
        const siteFromUserProfile = (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingSites[0];
        let projectUrl = siteFromUserProfile === null || siteFromUserProfile === void 0 ? void 0 : siteFromUserProfile.url;
        if ((jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : (_jiraSitesFromAgg_jira = jiraSitesFromAgg.jira) === null || _jiraSitesFromAgg_jira === void 0 ? void 0 : _jiraSitesFromAgg_jira.allJiraProjects.edges.length) === 1) projectUrl = (_jiraSitesFromAgg_jira_allJiraProjects = jiraSitesFromAgg.jira.allJiraProjects) === null || _jiraSitesFromAgg_jira_allJiraProjects === void 0 ? void 0 : (_jiraSitesFromAgg_jira_allJiraProjects_edges_ = _jiraSitesFromAgg_jira_allJiraProjects.edges[0]) === null || _jiraSitesFromAgg_jira_allJiraProjects_edges_ === void 0 ? void 0 : _jiraSitesFromAgg_jira_allJiraProjects_edges_.node.webUrl;
        setSiteUrl(projectUrl !== null && projectUrl !== void 0 ? projectUrl : "");
    }, [
        jiraSitesFromAgg,
        jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : (_jiraSitesFromAgg_jira3 = jiraSitesFromAgg.jira) === null || _jiraSitesFromAgg_jira3 === void 0 ? void 0 : _jiraSitesFromAgg_jira3.allJiraProjects.edges,
        profile,
        (_profile_attributes1 = profile.attributes) === null || _profile_attributes1 === void 0 ? void 0 : _profile_attributes1.existingSites,
        isTreatment
    ]);
    const { hasMultipleJiras: mostRecentHasMultipleJiras, siteName: mostRecentSiteName, siteUrl: mostRecentSiteUrl, siteInitials: mostRecentSiteInitials } = (0, $eZUFa.useRecentJiraSite)();
    (0, $iSvIT.useEffect)(()=>{
        if (!isTreatment) return;
        setHasMultipleJiras(mostRecentHasMultipleJiras);
        setSiteName(mostRecentSiteName);
        setSiteUrl(mostRecentSiteUrl);
        setSiteInitials(mostRecentSiteInitials);
    }, [
        isTreatment,
        mostRecentHasMultipleJiras,
        mostRecentSiteInitials,
        mostRecentSiteName,
        mostRecentSiteUrl
    ]);
    const loggedInHeroLoadedAnalyticsPayload = {
        eventType: "ui",
        action: "loaded",
        actionSubject: "component",
        actionSubjectId: "loggedInHero",
        source: "/software/jira",
        attributes: {
            atlasId: $f3fc89e21058fb11$export$6f77dd305013b9bd(experimentValue)
        }
    };
    (0, $iSvIT.useEffect)(()=>{
        //if client side, fire analytics event
        if (typeof window !== "undefined") createAnalyticsEvent((0, $7Knp0._)({}, loggedInHeroLoadedAnalyticsPayload)).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const clickHandler = (eventName)=>{
        createAnalyticsEvent((0, $6iHNw._)((0, $7Knp0._)({}, $f3fc89e21058fb11$export$cbc42fadf8b93ea3), {
            attributes: {
                eventName: eventName,
                url: window.location.href,
                atlasId: $f3fc89e21058fb11$export$6f77dd305013b9bd(experimentValue)
            }
        })).fire();
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _11q71ybm _12vemgnk _1lrw1dfr _1e0c11p5 _yv0ehkll _4cvr1h6o _6a6z1h6o _18zr53f4 _1q5110yn _85i512am _1bsb1osq _1bhl10yn"
        ]),
        style: {
            "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_kqswh2mm _syaz1hlo _1bsb1osq _p12fk3xj _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf _s51sidpf"
            ]),
            style: {
                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
            },
            children: [
                isTreatment ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_t9ecuuzf _kqswstnw _1e0c1o8l _u7co1w81 _1e021vgi _1mjbglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: {
                            width: 88,
                            height: 70,
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/g06k378gucflnfse7s88i0365h14j40v.webp",
                            alt: "hand-drawn stars"
                        }
                    })
                }) : /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswstnw _1e0c1o8l _u7co53f4 _1e02r8pp _t9ecn2ni _1mjbglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: {
                            width: 88,
                            height: 70,
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/g06k378gucflnfse7s88i0365h14j40v.webp",
                            alt: "hand-drawn stars"
                        }
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                    className: (0, $esG4f.default)([
                        "_1wybckbl _vwz48vuz _k48p9y44 _ect41pz4 _6rtho7ao _bozgidpf _so7dldb6 _19q11ylp"
                    ]),
                    style: {
                        "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                    },
                    children: userFirstName ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBackWithName",
                        defaultMessage: `Welcome back, {name}.`,
                        values: {
                            name: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                className: (0, $esG4f.default)([
                                    "_zg8l4jg8 _kqswh2mm _3p6m1sr6 _1v5vmgnk _14rn6nkb _19h91f51 _aetrb3bt _1qdggktf _1gufd439 _1czd12gs _g0nfmyb0 _18postnw _14tt14id _1ruvyjp0"
                                ]),
                                style: {
                                    "--_1vwzriw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.yellow"))
                                },
                                children: userFirstName
                            })
                        }
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBack",
                        defaultMessage: "Welcome back"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1n261g80 _gy1p53f4 _1bah1yb4 _4cvr1q9y"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_ect4bzd7 _1wybgktf _vwz41f4h _k48p1nn1"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraSoftwarePageTemplate.loggedInHero.pickUpWhereYouLeftOffInProduct",
                                defaultMessage: "Pick up where you left off in <span>{product}</span>",
                                values: {
                                    product: "Jira",
                                    span: (text)=>/*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                    className: (0, $esG4f.default)([
                                                        "_1e0c1o8l _t9ec1jia _kqswh2mm _152tdlk8 _195g14id"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1BHKA.JiraMarkBrand), {})
                                                }),
                                                text
                                            ]
                                        })
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            "data-testid": "createNewSiteAnchor",
                            href: localizedTryLink,
                            onClick: ()=>clickHandler("loggedInHeroCreateNewSiteClicked"),
                            className: (0, $esG4f.default)([
                                "_ect4bzd7 _1wyb7vkz _k48pni7l _vwz41f4h _syaz17la"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                                "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "WacSignupForm.createNewSite",
                                defaultMessage: "Create a new site"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswh2mm _16jlkb7n _1wpz1fhb"
                    ]),
                    children: [
                        !isTreatment && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_kqswstnw _152tx19p _rjxp1fm0 _1bsb13sl _4t3i1osq _bfhk17la"
                            ]),
                            style: {
                                "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_bfhkcd5j _2rko1y44 _1bsb1osq _1ul91mjv _1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _19it1wcj _1rjc7vkz _18zr7vkz _1mougktf _kqswh2mm"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $c8uJK.JiraSiteContainer), {
                                isTreatment: isTreatment,
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c1txw _2lx2vrvc _4cvr1h6o _4t3ivbgk _zulppxbi"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_11q7ihgv _2rko1b66 _1e0c1txw _1bah1h6o _4cvr1h6o _4t3ivbgk _1bsbvbgk _1ul9vbgk"
                                                ]),
                                                style: {
                                                    "--_1efrnav": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.lime300"))
                                                },
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                                                    className: (0, $esG4f.default)([
                                                        "_syaz5wis _ect41pz4 _1wyb1ejb _k48pni7l _vwz41f4h _1dyznl7k _y3gn1h6o"
                                                    ]),
                                                    style: {
                                                        "--_1yoj5ey": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.lime800")),
                                                        "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                                                    },
                                                    children: siteInitials
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_1e0c1txw _2lx21bp4 _1bah1h6o _zulp19bv _kqswh2mm _4t3ivbgk"
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                        className: (0, $esG4f.default)([
                                                            "_4t3igktf"
                                                        ]),
                                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSjV6.default), {
                                                            content: siteName,
                                                            position: "top-end",
                                                            mousePosition: "top",
                                                            tag: "span",
                                                            children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                                className: (0, $esG4f.default)([
                                                                    "_ect4bzd7 _1wybgktf _k48p1fw0 _4t3igktf _vwz41j6v _y3gn1e5h _1bto1l2s _o5721q9c _1reo15vq _18m915vq _1e0c1o8l _s7n4jp4b _uhd0uuw1 _1tssl1r9"
                                                                ]),
                                                                style: {
                                                                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                                                },
                                                                children: siteName
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                        className: (0, $esG4f.default)([
                                                            "_4t3i1tcg _uhd0uuw1 _1tssl1r9"
                                                        ]),
                                                        children: userPicture && /*#__PURE__*/ (0, $loA2J.jsx)((0, $5n5AO.JFind1504AvatarFacepile), {
                                                            max: 4,
                                                            iconSize: 24,
                                                            icons: [
                                                                userPicture,
                                                                ...teammateAvatars
                                                            ],
                                                            totalUserCount: totalUserCount !== null && totalUserCount !== void 0 ? totalUserCount : 0
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                                        "data-testid": "goToJiraButton",
                                        variant: "primary",
                                        color: "yellow",
                                        href: siteUrl,
                                        size: "small",
                                        onClick: ()=>clickHandler("loggedInHeroProductCtaClicked"),
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                            id: "JiraSoftwarePageTemplate.loggedInHero.goToJira",
                                            defaultMessage: "Go to Jira"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                hasMultipleJiras ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_ect4bzd7 _1pfho7ao _1wybdlk8 _k48p1nn1 _gu181h6o"
                    ]),
                    style: {
                        "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        text: intl.formatMessage({
                            id: "ConfluenceSoftwarePageTemplate.loggedInHero.lookingForDifferentSite",
                            defaultMessage: "Looking for a different site?"
                        }),
                        href: $f3fc89e21058fb11$var$START_URL,
                        type: "primary",
                        onClick: ()=>clickHandler("loggedInHeroAnotherSiteCtaClicked")
                    })
                }) : /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_4t3iqslr"
                    ])
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1pfhvbgk _1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_ect4bzd7 _1wybgktf _vwz41f4h _k48p1nn1 _6rth7vkz"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraSoftwarePageTemplate.loggedInHero.findOutMore",
                                defaultMessage: "Want to find out more about Jira?"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            "data-testid": "exploreFeaturesAnchor",
                            href: localizedProductGuideLink,
                            onClick: ()=>clickHandler("loggedInHeroExploreFeaturesClicked"),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                className: (0, $esG4f.default)([
                                    "_ect4bzd7 _1wyb7vkz _k48pni7l _11q7glyw _r06hglyw _2rko1ul9 _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _19it1axk _80omtlke"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                },
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "jira-product-tour.staggered-double-feature-section.first-feature-link-text",
                                    defaultMessage: "Explore features"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$f3fc89e21058fb11$export$49c6370202c57ed1.displayName = "LoggedInHeroSection";
var $f3fc89e21058fb11$export$2e2bcd8739ae039 = $f3fc89e21058fb11$export$49c6370202c57ed1;

});
parcelRegister("5n5AO", function(module, exports) {

$parcel$export(module.exports, "JFind1504AvatarFacepile", function () { return $c686d49f91425752$export$a97371c364a7a976; });
/* jfind-1504-avatar-facepile.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $5ohHq = parcelRequire("5ohHq");

var $dLZRK = parcelRequire("dLZRK");
const $c686d49f91425752$export$a97371c364a7a976 = ({ icons: icons, max: max, overlap: overlap = 4, iconSize: iconSize = 16, totalUserCount: totalUserCount })=>{
    const userCountPillStyles = null;
    const intl = (0, $f6qj2.default)();
    const maxUsersStyles = null;
    const andMoreText = intl.formatMessage({
        id: "avatarFacePile.andMoreText",
        defaultMessage: "and more"
    });
    const facepileStyles = [
        null,
        overlap > 0 && null
    ];
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c116y _4t3ibv8l _1bsb1osq _9e7b1bmj",
            overlap > 0 && "_ahbqccqr"
        ]),
        style: {
            "--_1lwyf0k": (0, $43MIc.default)(iconSize, "px"),
            "--_19zwya0-": (0, $43MIc.default)(overlap, "px", "-"),
            "--_19zwya0": (0, $43MIc.default)(overlap, "px")
        },
        children: [
            icons.slice(0, max).map((icon, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $dLZRK.AvatarIcon), {
                    icon: icon,
                    iconSize: iconSize,
                    overlap: overlap
                }, index)),
            totalUserCount > 99 ? /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_syaz1yg0 _1wyb1crf _k48p1nn1 _ahbqi2wt _1e0c1txw _4cvr1h6o"
                ]),
                style: {
                    "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800"))
                },
                children: andMoreText
            }) : totalUserCount > max && /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                className: (0, $esG4f.default)([
                    "_4cvr1h6o _2rko1k4y _19it1dxc _syaz1yg0 _1e0c116y _1wybgbje _k48p1nn1 _zulpze3t _4t3ibv8l _1bah1h6o _vwz4bv8l _ahbq1564 _1yt418uk _y3gn1h6o _s7n4nkob _1bsb1wug"
                ]),
                style: {
                    "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800")),
                    "--_1lwyf0k": (0, $43MIc.default)(iconSize, "px"),
                    "--_1j20svt": (0, $43MIc.default)(overlap * -1, "px")
                },
                children: [
                    "+",
                    totalUserCount - max
                ]
            })
        ]
    });
};

});





parcelRegister("bs4n3", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswEngineering", function () { return $e3dfec4a5ac3a74c$export$21c206b8ba9eb903; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $4xemF = parcelRequire("4xemF");
const $e3dfec4a5ac3a74c$export$21c206b8ba9eb903 = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4xemF.JiraSoftwarePagePaidLpJswAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-engineering",
        persona: "unknown",
        pageVariant: "engineering"
    }));
};

});

parcelRegister("1Dw5R", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswHr", function () { return $4bfb39565c119f9f$export$ad7cb727602fa346; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $4xemF = parcelRequire("4xemF");
const $4bfb39565c119f9f$export$ad7cb727602fa346 = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4xemF.JiraSoftwarePagePaidLpJswAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-hr",
        persona: "unknown",
        pageVariant: "hr"
    }));
};

});

parcelRegister("jmVsK", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswLegal", function () { return $aa3fc8983d05e4c4$export$a54419ba9ddd4e32; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $4xemF = parcelRequire("4xemF");
const $aa3fc8983d05e4c4$export$a54419ba9ddd4e32 = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4xemF.JiraSoftwarePagePaidLpJswAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-legal",
        persona: "unknown",
        pageVariant: "legal"
    }));
};

});

parcelRegister("lHRSz", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswMarketing", function () { return $c50c6f274bcf379f$export$560daf6a01ddd7ea; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $4xemF = parcelRequire("4xemF");
const $c50c6f274bcf379f$export$560daf6a01ddd7ea = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4xemF.JiraSoftwarePagePaidLpJswAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-marketing",
        persona: "unknown",
        pageVariant: "marketing"
    }));
};

});

parcelRegister("0M3nE", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswOperations", function () { return $459114cdaa50bd7b$export$e2ac21102c7fc08d; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $4xemF = parcelRequire("4xemF");
const $459114cdaa50bd7b$export$e2ac21102c7fc08d = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4xemF.JiraSoftwarePagePaidLpJswAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-operations",
        persona: "unknown",
        pageVariant: "operations"
    }));
};

});

parcelRegister("eAxa6", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswProgramMgmt", function () { return $5bd006e06e0f5a92$export$474595b11c2cc21b; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $4xemF = parcelRequire("4xemF");
const $5bd006e06e0f5a92$export$474595b11c2cc21b = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4xemF.JiraSoftwarePagePaidLpJswAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-programmgmt",
        persona: "unknown",
        pageVariant: "programmgmt"
    }));
};

});

parcelRegister("jJy4Z", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswSales", function () { return $d6679c52ee947921$export$bd9265ca82ed6224; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $4xemF = parcelRequire("4xemF");
const $d6679c52ee947921$export$bd9265ca82ed6224 = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4xemF.JiraSoftwarePagePaidLpJswAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-sales",
        persona: "unknown",
        pageVariant: "sales"
    }));
};

});

parcelRegister("auFti", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePage", function () { return $44fb3717bf740836$export$a6be62ed06c967ea; });

var $loA2J = parcelRequire("loA2J");

var $lgDo7 = parcelRequire("lgDo7");

var $j27rt = parcelRequire("j27rt");

var $4LHd8 = parcelRequire("4LHd8");

var $dyZbY = parcelRequire("dyZbY");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");

var $iMdoL = parcelRequire("iMdoL");
parcelRequire("aRHrH");
var $9O2F2 = parcelRequire("9O2F2");
parcelRequire("6deXa");
var $aqpMp = parcelRequire("aqpMp");

var $7Ogtn = parcelRequire("7Ogtn");

var $d931y = parcelRequire("d931y");
parcelRequire("7e8IA");
var $cNEGt = parcelRequire("cNEGt");

var $9iWJ8 = parcelRequire("9iWJ8");

var $gAJUc = parcelRequire("gAJUc");
const $44fb3717bf740836$export$a6be62ed06c967ea = ()=>{
    const loggedInHasJira = (0, $iMdoL.useLoggedInHasJira)();
    const jiraD0to6 = (0, $iMdoL.useJiraD0to6)();
    const W2AndAfterOrMultipleJiras = (0, $iMdoL.useJiraW2AndAfterOrMultipleJiras)();
    const loggedInSkeletonEnabled = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).jfindLoggedInJiraProductTourSkeleton);
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $4LHd8.default).checkGate("gwp-737-enable-intercom-chat-jsw");
    const isWae = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).dxpMigrationJiraProductTourGate);
    const template = W2AndAfterOrMultipleJiras ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $9iWJ8.ExperimentView), {
        experiment: (0, $9iWJ8.experiments).jfind1506AfterD7GetOrganicUsersBackToProduct,
        render: (value)=>{
            switch(value){
                case "jfind-1506-after-d7-gubtp-organic":
                    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $d931y.OrganicD1to6LoggedInJiraProductTourOverview), {
                        experimentValue: "jfind-1506-after-d7-gubtp-organic"
                    });
                default:
                    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aqpMp.LoggedInJiraProductTourOverview), {});
            }
        }
    }) : jiraD0to6 ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $d931y.OrganicD1to6LoggedInJiraProductTourOverview), {
        experimentValue: "not-enrolled"
    }) : loggedInHasJira ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $aqpMp.LoggedInJiraProductTourOverview), {}) : isWae ? /*#__PURE__*/ (0, $loA2J.jsx)($44fb3717bf740836$var$WaeJiraPage, {}) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $cNEGt.LoggedOutOrNoJiraProductTourOverview), {});
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "jira-product-tour-overview",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9O2F2.IntercomProvider), {
            appId: "p0ww63i2",
            triggerBoot: isBootIntercom,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3LLDq.CrossFlowTouchpointProvider), {
                productKeys: [
                    (0, $i8kxh.ProductKeys).JIRA_SOFTWARE
                ],
                screenName: "wacJswProductTourPage",
                children: loggedInSkeletonEnabled ? //Feature Gate checks for logged in users
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $7Ogtn.LoggedInHeroContainer), {
                    children: template
                }) : template
            })
        })
    });
};
const $44fb3717bf740836$var$WaeJiraPage = ()=>{
    const { composition: composition } = (0, $j27rt.useWAEContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lgDo7.UniformEntryPage), {
        composition: composition
    });
};

});
parcelRegister("lgDo7", function(module, exports) {

$parcel$export(module.exports, "UniformEntryPage", function () { return $84c3366e54b9b039$export$f0d4a992b207ed41; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $dWbel = parcelRequire("dWbel");

var $4ktyF = parcelRequire("4ktyF");

var $luVwe = parcelRequire("luVwe");
parcelRequire("8ch47");
var $9AjEB = parcelRequire("9AjEB");
const $84c3366e54b9b039$export$f0d4a992b207ed41 = ({ composition: composition, compositionMetrics: compositionMetrics, isUniformPlayground: isUniformPlayground })=>{
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { compositionFetchStart: compositionFetchStart, compositionCacheStatus: compositionCacheStatus, ssrEndTime: ssrEndTime } = compositionMetrics || {};
    const sendPageRenderAnalyticsEvent = (0, $iSvIT.useCallback)((pageRenderTime, ssrEndTime, compositionFetchStart, fcp)=>{
        if (pageRenderTime && analyticsClient) analyticsClient.sendUIEvent({
            action: "pageRender",
            actionSubject: "uniformPage",
            source: window.location.pathname,
            attributes: {
                pageRenderTime: pageRenderTime,
                compositionFetchStart: compositionFetchStart,
                ssrEndTime: ssrEndTime,
                compositionCacheStatus: compositionCacheStatus,
                fcp: fcp,
                isUniformPlayground: isUniformPlayground || false
            }
        });
    }, [
        analyticsClient,
        compositionCacheStatus,
        isUniformPlayground
    ]);
    (0, $iSvIT.useEffect)(()=>{
        // @ts-ignore
        const measureFirstContentfulPaint = ()=>{
            try {
                // First, check if FCP is already available
                const paintEntries = performance.getEntriesByType("paint");
                const firstContentfulPaint = paintEntries.find((entry)=>entry.name === "first-contentful-paint");
                if (firstContentfulPaint && ssrEndTime && compositionFetchStart) {
                    const fcp = firstContentfulPaint.startTime;
                    // Calculate page render time
                    const pageRenderTime = ssrEndTime - compositionFetchStart + fcp;
                    if (pageRenderTime) sendPageRenderAnalyticsEvent(pageRenderTime, ssrEndTime, compositionFetchStart, fcp);
                    return firstContentfulPaint.startTime;
                }
                // If FCP isn't available yet, observe for it
                const observer = new PerformanceObserver((list)=>{
                    const entries = list.getEntries();
                    const fcpEntry = entries.find((entry)=>entry.name === "first-contentful-paint");
                    if (fcpEntry && compositionFetchStart && ssrEndTime) {
                        const fcp = fcpEntry.startTime;
                        // Calculate page render time
                        const pageRenderTime = ssrEndTime - compositionFetchStart + fcp;
                        if (pageRenderTime) sendPageRenderAnalyticsEvent(pageRenderTime, ssrEndTime, compositionFetchStart, fcp);
                        observer.disconnect();
                    }
                });
                observer.observe({
                    entryTypes: [
                        "paint"
                    ]
                });
                // Cleanup observer after 10 seconds to prevent memory leaks
                setTimeout(()=>{
                    observer.disconnect();
                }, 10000);
                return undefined;
            } catch (error) {
                console.warn("Error measuring Page Render Time:", error);
                return undefined;
            }
        };
        measureFirstContentfulPaint();
    }, [
        compositionFetchStart,
        compositionMetrics,
        sendPageRenderAnalyticsEvent,
        ssrEndTime
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4ktyF.default), {
        fallback: /*#__PURE__*/ (0, $loA2J.jsx)((0, $luVwe.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            "data-testid": "uniform-entry-page-root",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9AjEB.UniformEntryPageTemplate), {
                    composition: composition,
                    isUniformPlayground: isUniformPlayground
                })
            })
        })
    });
};

});
parcelRegister("8ch47", function(module, exports) {
$parcel$export(module.exports, "UniformEntryPageTemplate", function () { return (parcelRequire("9AjEB")).UniformEntryPageTemplate; });

var $9AjEB = parcelRequire("9AjEB");

});
parcelRegister("9AjEB", function(module, exports) {

$parcel$export(module.exports, "UniformEntryPageTemplate", function () { return $c0c979c21b492ce7$export$8328465fb6b6a7d2; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $4ktyF = parcelRequire("4ktyF");

var $aME7P = parcelRequire("aME7P");
const $c0c979c21b492ce7$export$8328465fb6b6a7d2 = ({ composition: composition, isUniformPlayground: isUniformPlayground })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4ktyF.default), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aME7P.UniformWrapper), {
            composition: composition,
            isUniformPlayground: isUniformPlayground
        })
    });
};

});



parcelRegister("6deXa", function(module, exports) {
$parcel$export(module.exports, "LoggedInJiraProductTourOverview", function () { return (parcelRequire("aqpMp")).LoggedInJiraProductTourOverview; });
parcelRequire("aqpMp");

});
parcelRegister("aqpMp", function(module, exports) {

$parcel$export(module.exports, "LoggedInJiraProductTourOverview", function () { return $40be019c0c1ebae0$export$5024f41464462328; });

var $loA2J = parcelRequire("loA2J");

var $kex29 = parcelRequire("kex29");

var $jq0gD = parcelRequire("jq0gD");
parcelRequire("ceCOS");
var $5AOuY = parcelRequire("5AOuY");
var $iElmF = parcelRequire("iElmF");
var $jEzAG = parcelRequire("jEzAG");
var $5NASl = parcelRequire("5NASl");
var $wh23v = parcelRequire("wh23v");
var $XH49N = parcelRequire("XH49N");
var $fbUwe = parcelRequire("fbUwe");
var $c4XRn = parcelRequire("c4XRn");
parcelRequire("ccYBS");
var $1FqEx = parcelRequire("1FqEx");

var $dJVgs = parcelRequire("dJVgs");
const $40be019c0c1ebae0$export$5024f41464462328 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jq0gD.default), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJVgs.default), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1FqEx.ParentScrollTracking), {
                scrollTrackingEnabled: true,
                pageId: "jsw",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5AOuY.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $iElmF.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $jEzAG.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5NASl.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $wh23v.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $XH49N.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $fbUwe.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $c4XRn.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
                ]
            })
        ]
    });
};

});
parcelRegister("ceCOS", function(module, exports) {

$parcel$export(module.exports, "BlogsSection", function () { return (parcelRequire("XH49N")).default; });
$parcel$export(module.exports, "CTASection", function () { return (parcelRequire("c4XRn")).default; });
$parcel$export(module.exports, "DevOpsSection", function () { return (parcelRequire("wh23v")).default; });
$parcel$export(module.exports, "LoggedInHeroSection", function () { return (parcelRequire("5AOuY")).default; });
$parcel$export(module.exports, "IntegrationSection", function () { return (parcelRequire("5NASl")).default; });
$parcel$export(module.exports, "ScalingSection", function () { return (parcelRequire("fbUwe")).default; });
$parcel$export(module.exports, "TabsSection", function () { return (parcelRequire("iElmF")).default; });
$parcel$export(module.exports, "WorkflowSection", function () { return (parcelRequire("jEzAG")).default; });

var $XH49N = parcelRequire("XH49N");

var $c4XRn = parcelRequire("c4XRn");

var $wh23v = parcelRequire("wh23v");

var $5NASl = parcelRequire("5NASl");

var $5AOuY = parcelRequire("5AOuY");

var $gnhk8 = parcelRequire("gnhk8");

var $fbUwe = parcelRequire("fbUwe");

var $iElmF = parcelRequire("iElmF");

var $jEzAG = parcelRequire("jEzAG");

});
parcelRegister("XH49N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa53ba870db7e564$export$2e2bcd8739ae039; });
/* blogs.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ /**
 * Add above due to attempt to merge in a merge conflict fix, which is file is out of scope for
 * Did not make a ticket to fix the nested selector on this file, due to
 * stating RW team have tickets for the whole codebase
 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");

var $bhreu = parcelRequire("bhreu");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $aa53ba870db7e564$var$blogLinkStyles = null;
const $aa53ba870db7e564$var$blogSectionStyles = null;
const $aa53ba870db7e564$var$flexWrap = null;
const $aa53ba870db7e564$var$blogLinkTextStyles = null;
const $aa53ba870db7e564$export$aa41e846a741df08 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/42xb8t784240dh2sfq3yb5k8fuq22mf1.svg",
        alt: "#1"
    });
};
const $aa53ba870db7e564$var$BlogsSection = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1yt4im2s _bfhku67f"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _yv0ei47z _1rqtf9jr _pdlmzwfg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_kzvi11p5 _1gzvzwfg _1da7f9jr"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1bsb1h3m _1yt4zu5n _1s4p1vuk _1e6zidpf _p0azv837"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)($aa53ba870db7e564$export$aa41e846a741df08, {})
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_12l2ka7h _1yt4zu5n _qwozidpf _11eb1lne _cg41l4fm _1kll1k8s _q7gq1j6v _1adi4jg8 _125xl4fm"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                                        headerType: "h2",
                                        headerText: intl.formatMessage({
                                            id: "JiraSoftwarePageTemplate.blogsSection.headerText",
                                            defaultMessage: "Why Jira is the #1 tool recommended by agile teams.*"
                                        }),
                                        bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                            id: "JiraSoftwarePageTemplate.blogsSection.bodyText",
                                            defaultMessage: "Trusted by more than 100,000 organizations, Jira comes out-of-the-box with the features and best practices agile teams need to develop and evolve their agile practices.",
                                            values: (0, $3FBn4.DEFAULT_VALUES)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_q7gq11yk _125xvwuj _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf"
                                        ]),
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                id: "JiraSoftwarePageTemplate.blogsSection.contentFooter",
                                                defaultMessage: "*2021 State of Agile Report",
                                                values: (0, $3FBn4.DEFAULT_VALUES)
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _zulpzwfg _navj1g80 _8164idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)($aa53ba870db7e564$export$50abcf278da62381, {}),
                                    /*#__PURE__*/ (0, $loA2J.jsx)($aa53ba870db7e564$export$83dad9d4a5d7a221, {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _zulpzwfg _navj1g80 _8164idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)($aa53ba870db7e564$export$61dec29d4439a90e, {}),
                                    /*#__PURE__*/ (0, $loA2J.jsx)($aa53ba870db7e564$export$2a774c444b770d05, {})
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $aa53ba870db7e564$export$50abcf278da62381 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)($aa53ba870db7e564$var$BlogLink, {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/0r168a11o11n866jv042iaqtc2560d15.webp",
        imageAlt: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.blogsSection.agileAltText",
            defaultMessage: "Agile illustration"
        }),
        href: (0, $3FBn4.useLocalizedHref)("/agile"),
        linkText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.blogsSection.agileLinkText",
            defaultMessage: "Learn agile best practices"
        })
    });
};
const $aa53ba870db7e564$export$83dad9d4a5d7a221 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)($aa53ba870db7e564$var$BlogLink, {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/e3buc7gjy550p1825lu05t674gf7116g.webp",
        imageAlt: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.blogsSection.teamPlaybookAltText",
            defaultMessage: "Team playbook illustration"
        }),
        href: (0, $3FBn4.useLocalizedHref)("/team-playbook"),
        linkText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.blogsSection.teamPlaybookLinkText",
            defaultMessage: "Team Playbook"
        })
    });
};
const $aa53ba870db7e564$export$61dec29d4439a90e = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)($aa53ba870db7e564$var$BlogLink, {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/g5h75c61iryjfgxc47b76c644gk323uy.webp",
        imageAlt: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.blogsSection.communityAltText",
            defaultMessage: "Community illustration"
        }),
        href: "https://community.atlassian.com/",
        linkText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.blogsSection.communityLinkText",
            defaultMessage: "Jira community"
        })
    });
};
const $aa53ba870db7e564$export$2a774c444b770d05 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)($aa53ba870db7e564$var$BlogLink, {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/n2a75c42wi3oj344bot150u635h5gns3.webp",
        imageAlt: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.blogsSection.devOpsAltText",
            defaultMessage: "DevOps loop illustration"
        }),
        href: (0, $3FBn4.useLocalizedHref)("/devops"),
        linkText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.blogsSection.devOpsLinkText",
            defaultMessage: "Learn DevOps best practices"
        })
    });
};
const $aa53ba870db7e564$var$BlogLink = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_18s81cfz _1wybpxbi _1iu2u2gc"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                href: props.href,
                "data-event-component": "linkButton",
                "data-event-container": "blogsSection",
                "data-event": "clicked",
                "data-label": props.linkText,
                "data-product-key": "jiraSoftware",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
                    src: props.imageSrc,
                    alt: props.imageAlt,
                    aspectRatio: "16/9"
                })
            }),
            $aa53ba870db7e564$var$blogLinkText(props.href, props.linkText)
        ]
    });
};
const $aa53ba870db7e564$var$blogLinkText = (href, linkText)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
            href: href,
            "data-event-component": "linkButton",
            "data-event-container": "blogsSection",
            "data-event": "clicked",
            "data-label": linkText,
            "data-product-key": "jiraSoftware",
            className: (0, $esG4f.default)([
                "_ysv7rbzz _1053rbzz _5bd61r31 _1ydc1r31 _13jxglyw _1x28glyw _xatrnqa1 _1726nqa1 _30l3oelr _1mfn1gfk _nalz1b66 _1y8f1r31 _kttp8stv _14t1nqa1"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c116y _1wybpxbi",
                    "link-text"
                ]),
                children: [
                    linkText,
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: "link-arrow",
                        children: $aa53ba870db7e564$var$linkArrow()
                    })
                ]
            })
        })
    });
};
const $aa53ba870db7e564$var$linkArrow = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        fill: "currentColor",
        width: "11",
        height: "8",
        viewBox: "0 0 11 8",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $esG4f.default)([
            "_ahbq12x7"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.40796 0L6.32831 1.2021L8.07854 3.1497H0.763182C0.341906 3.1497 0 3.53038 0 3.99943C0 4.46849 0.341906 4.84917 0.763182 4.84917H8.07854L6.32831 6.7979L7.40796 8L11 3.99943L7.40796 0Z"
        })
    });
};
$aa53ba870db7e564$var$BlogsSection.displayName = "BlogsSection";
var $aa53ba870db7e564$export$2e2bcd8739ae039 = $aa53ba870db7e564$var$BlogsSection;

});

parcelRegister("c4XRn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec233139fdae776f$export$2e2bcd8739ae039; });
/* cta.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");
const $ec233139fdae776f$var$CTASection = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/software/jira/free");
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).JIRA_SOFTWARE,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    const ctaButtonText = intl.formatMessage({
        id: "JiraSoftwarePageTemplate.ctaSection.getItFree",
        defaultMessage: "Get it free"
    });
    const linkDataEventProps = {
        "data-event-component": "linkButton",
        "data-event-container": "ctaSection",
        "data-event": "clicked",
        "data-product-key": "jiraSoftware",
        "data-label": ctaButtonText,
        "data-label-english": "Get it free",
        "data-track-event": "jiraSoftware.get-it-free-button-clicked"
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _bfhk1mpp _syazu67f _1e0c1txw _2lx21bp4 _zulp1tcg _ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _11ebahaf _8v2f1td8 _l5k1bfng _1kll1k8s _1nte1td8 _1qnibfng _1a7ix7w3 _ma1vi0pe _knqji0pe _sj7ki0pe _bnxci0pe _w5ku1r31 _zs4t8stv _1tjrnqa1 _1m2pmvkb"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                headerType: "h2",
                headerText: intl.formatMessage({
                    id: "JiraSoftwarePageTemplate.ctaSection.getStarted",
                    defaultMessage: "Get Started with Jira"
                }),
                orientation: "vertical",
                ctaProps: {
                    buttonProps: {
                        text: intl.formatMessage({
                            id: "JiraSoftwarePageTemplate.ctaSection.getItFree",
                            defaultMessage: "Get it free"
                        }),
                        color: "yellow",
                        url: signupLink,
                        dataEventProps: linkDataEventProps,
                        onClick: openCrossFlow
                    }
                },
                isCentered: true
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                className: "features-link",
                href: (0, $3FBn4.useLocalizedHref)("/software/jira/features"),
                text: intl.formatMessage({
                    id: "JiraSoftwarePageTemplate.ctaSection.seeFeatures",
                    defaultMessage: "See features"
                }),
                bgColor: "bgBlackBlue",
                dataEventProps: linkDataEventProps
            })
        ]
    });
};
$ec233139fdae776f$var$CTASection.displayName = "CTASection";
var $ec233139fdae776f$export$2e2bcd8739ae039 = $ec233139fdae776f$var$CTASection;

});

parcelRegister("wh23v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $133be36e67962bd9$export$2e2bcd8739ae039; });
/* dev-ops.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");

var $bhreu = parcelRequire("bhreu");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $jS47I = parcelRequire("jS47I");
const $133be36e67962bd9$var$devOpsSectionStyle = null;
const $133be36e67962bd9$var$DevOpsSection = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1itkfaik _ouxl1ssb _12vemgnk _1lrw1dfr _syazu67f _ca0q16xz _u5f314no _n3td16xz _19bvidpf _ai3d7vkz _fglvidpf _y5sa7vkz _1a4pidpf _1qj84jg8 _3skuahaf _1lcr1k8s _1oebvbgk _g5nwidpf _1sl9vbgk _1bkeidpf _18k6idpf _1i1pidpf _i6bg19bv _16tsidpf _1e02oqnp _3nsg4jg8 _5k96angw _vdmg1j6v _1ic74jg8 _1bl7bs82 _19p2ahaf _1o7bbfng _r6guclii _yhomp6o2 _2gm6idpf _lgxkidpf _11sridpf _1217idpf _2wcg1k92 _1ghd1nn1 _9brunl7k _11mk19ii _5c641txw _1o2r1bp4 _1von1h6o _1ufw7vkz _qaroidpf _3ogj7vkz _1r46idpf _1fwdglyw _1khm1bp4 _1vh71h6o _5cwf7vkz _uok1idpf _15x77vkz _1l1jidpf _yerozwfg _235vidpf _ugxvzwfg _1v4xidpf _1y7y7vkz _1ewg1w81 _1fes1osq _1em61bp9 _n1ju1wug _1sly1wug _exgw1wug _ow8r1wug _jss411p5 _1p0waj1j _17eu1a0z _15txzu5n _ofslglyw _1lhl1ule"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: "section-container",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: "desktop-img",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)($133be36e67962bd9$var$DevOpsImage, {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: "content-container",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: "dev-ops-content",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                                    headerType: "h2",
                                    headerText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.devOpsSection.header",
                                        defaultMessage: "Let developers focus on code",
                                        values: (0, $3FBn4.DEFAULT_VALUES)
                                    }),
                                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.devOpsSection.body",
                                        defaultMessage: "Developers want to focus on code, not update issues. We get it! Open DevOps makes it easier to do both regardless of the tools you use. Now developers can stay focused and the business can stay aligned.",
                                        values: (0, $3FBn4.DEFAULT_VALUES)
                                    }),
                                    ctaProps: {
                                        buttonProps: {
                                            text: intl.formatMessage({
                                                id: "JiraSoftwarePageTemplate.devOpsSection.cta",
                                                defaultMessage: "Explore Open DevOps"
                                            }),
                                            url: (0, $3FBn4.useLocalizedHref)("/solutions/devops"),
                                            type: "secondary",
                                            color: "white",
                                            size: "small",
                                            dataEventProps: {
                                                "data-event-component": "linkButton",
                                                "data-event-container": "devOpsSection",
                                                "data-event": "clicked",
                                                "data-product-key": "jiraSoftware"
                                            }
                                        }
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: "mobile-img",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)($133be36e67962bd9$var$DevOpsImage, {})
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: "benefits-container",
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                            id: "JiraSoftwarePageTemplate.devOpsSection.benefits",
                                            defaultMessage: "How customers are benefiting",
                                            values: (0, $3FBn4.DEFAULT_VALUES)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: "company-image-container",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
                                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ndd466s3h255c2d7jec4qab20voms0tf.webp",
                                            alt: intl.formatMessage({
                                                id: "JiraSoftwarePageTemplate.devOpsSection.flowLogoAlt",
                                                defaultMessage: "Flow company logo"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("h4", {
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                id: "JiraSoftwarePageTemplate.devOpsSection.floIncreasePercent",
                                                defaultMessage: "900%",
                                                values: (0, $3FBn4.DEFAULT_VALUES)
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                id: "JiraSoftwarePageTemplate.devOpsSection.floIncreaseMessage",
                                                defaultMessage: "<p>increase in deployments</p>",
                                                values: (0, $3FBn4.DEFAULT_VALUES)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("h4", {
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                id: "JiraSoftwarePageTemplate.devOpsSection.floDecreasePercent",
                                                defaultMessage: "50%"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                id: "JiraSoftwarePageTemplate.devOpsSection.floDecreaseMessage",
                                                defaultMessage: "<p>decrease in cycle time</p>",
                                                values: (0, $3FBn4.DEFAULT_VALUES)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $133be36e67962bd9$var$DevOpsImage = ()=>{
    const intl = (0, $f6qj2.default)();
    const localizedImageSrc = (0, $jS47I.getDevOpsSectionImage)(intl.locale);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
        src: localizedImageSrc,
        alt: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.devOpsSection.imageAlt",
            defaultMessage: "Jira Software DevOps diagram: Plan, code, deploy, operate, and collaborate"
        })
    });
};
$133be36e67962bd9$var$DevOpsSection.displayName = "DevOpsSection";
var $133be36e67962bd9$export$2e2bcd8739ae039 = $133be36e67962bd9$var$DevOpsSection;

});
parcelRegister("jS47I", function(module, exports) {

$parcel$export(module.exports, "getDevOpsSectionImage", function () { return $821836ac417e6c21$export$f5fc726b1f3a764d; });
$parcel$export(module.exports, "getPlanTabsSectionImage", function () { return $821836ac417e6c21$export$d0eb8e3477c372df; });
$parcel$export(module.exports, "getPlanTabsSectionVideo", function () { return $821836ac417e6c21$export$1185e048a42a7692; });
$parcel$export(module.exports, "getTrackTabsSectionImage", function () { return $821836ac417e6c21$export$3cebe896652d6248; });
$parcel$export(module.exports, "getReleaseTabsSectionImage", function () { return $821836ac417e6c21$export$dbda4fbdc6bac37c; });
$parcel$export(module.exports, "getReportTabsSectionImage", function () { return $821836ac417e6c21$export$7e0f538c5fb0ac2d; });
$parcel$export(module.exports, "getAutomateTabsSectionImage", function () { return $821836ac417e6c21$export$7a3d5ba0eee41c3d; });
$parcel$export(module.exports, "getWorkflowSectionImage", function () { return $821836ac417e6c21$export$af440fac00a2a630; });
$parcel$export(module.exports, "getScailingSectionJiraFreeImage", function () { return $821836ac417e6c21$export$edab907484587325; });
// no localized image for hu, it, ko, nl, pl, zh
const $821836ac417e6c21$var$devOpsSectionImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/v3346kr200jcjn6s25r1tt30u5v176vq.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/m6c87uds2rmr01d1l0nvt7rw1853543q.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/3gy5t516exvp226f8s16140ljfgjtt4b.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/3klwx86641ord17j6csodsaw3c8pmb4o.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/wwld70kj01143q7442d6cr0s8745ekyr.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/0fuw156nx8m1s3l553w5pbab3jb8766y.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/e6qwe41p1rm72s4qh1u7tia2sbp1jm38.webp"
};
// no localized images available for the placeholder image for the plan tab video
const $821836ac417e6c21$var$planTabsSectionImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/8q22ns81pbey0cqxk25j50spls50mw41.webp"
};
// no localized image for hu, it, ko, nl, pl, zh
const $821836ac417e6c21$var$planTabsSectionVideoMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-software/JSW-Plan.mp4",
    ja: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-software/JA/JSW-Plan-JA.mp4",
    de: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-software/DE/JSW-Plan-DE.mp4",
    es: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-software/ES/JSW-Plan-ES.mp4",
    fr: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-software/FR/JSW-Plan-FR.mp4",
    br: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-software/PT/JSW-Plan-PT-BR.mp4",
    ru: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-software/RU/JSW-Plan-RU.mp4"
};
// no localized images available
const $821836ac417e6c21$var$trackTabsSectionImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/5hde3vyy76yd4faeeu3mqp4yqss4500q.webp"
};
// no localized images available
const $821836ac417e6c21$var$releaseTabsSectionImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/e8i1y7s0mnma07f7xkvby25ju08227hx.webp"
};
// no localized images available
const $821836ac417e6c21$var$reportTabsSectionImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/c7w6yj6wl0skhah2wt56dv8q235782wp.webp"
};
// no localized images available
const $821836ac417e6c21$var$automateTabsSectionImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/4h4430vktkydp6sxq3a5ivtl85da683b.webp"
};
// no localized images available
const $821836ac417e6c21$var$scailingJiraFreeImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/q218xery30f2l28i55hgr8352d214y8u.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/q218xery30f2l28i55hgr8352d214y8u.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/q218xery30f2l28i55hgr8352d214y8u.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/q218xery30f2l28i55hgr8352d214y8u.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/q218xery30f2l28i55hgr8352d214y8u.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/q218xery30f2l28i55hgr8352d214y8u.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/q218xery30f2l28i55hgr8352d214y8u.webp"
};
// no localized image for hu, it, ko, nl, pl, zh
const $821836ac417e6c21$var$workflowSectionImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/o575pga731f3k7yeis26nm4631uc0688.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/8588gx77hlb7264626g7a25nie6083g1.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/s2rjykhu0l4cqe7i4x7ceq5i0e53eq6k.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/ti8xa750n8crthi0j41qq7md8b6m7845.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/5x4k2x175h54lv0378p6t0qoasuisby1.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/fsf33t0bun5g672x8ni1f0w713r8iem4.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/tk1o6v4elgjklv6lot8ml1m52t318304.webp"
};
const $821836ac417e6c21$export$f5fc726b1f3a764d = (locale)=>{
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return $821836ac417e6c21$var$devOpsSectionImageMap[locale] || $821836ac417e6c21$var$devOpsSectionImageMap["en"];
};
const $821836ac417e6c21$export$d0eb8e3477c372df = (locale)=>{
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return $821836ac417e6c21$var$planTabsSectionImageMap[locale] || $821836ac417e6c21$var$planTabsSectionImageMap["en"];
};
const $821836ac417e6c21$export$1185e048a42a7692 = (locale)=>{
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return $821836ac417e6c21$var$planTabsSectionVideoMap[locale] || $821836ac417e6c21$var$planTabsSectionVideoMap["en"];
};
const $821836ac417e6c21$export$3cebe896652d6248 = (locale)=>{
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return $821836ac417e6c21$var$trackTabsSectionImageMap[locale] || $821836ac417e6c21$var$trackTabsSectionImageMap["en"];
};
const $821836ac417e6c21$export$dbda4fbdc6bac37c = (locale)=>{
    return(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $821836ac417e6c21$var$releaseTabsSectionImageMap[locale] || $821836ac417e6c21$var$releaseTabsSectionImageMap["en"]);
};
const $821836ac417e6c21$export$7e0f538c5fb0ac2d = (locale)=>{
    return(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $821836ac417e6c21$var$reportTabsSectionImageMap[locale] || $821836ac417e6c21$var$reportTabsSectionImageMap["en"]);
};
const $821836ac417e6c21$export$7a3d5ba0eee41c3d = (locale)=>{
    return $821836ac417e6c21$var$automateTabsSectionImageMap[locale] || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $821836ac417e6c21$var$automateTabsSectionImageMap["en"];
};
const $821836ac417e6c21$export$af440fac00a2a630 = (locale)=>{
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return $821836ac417e6c21$var$workflowSectionImageMap[locale] || $821836ac417e6c21$var$workflowSectionImageMap["en"];
};
const $821836ac417e6c21$export$edab907484587325 = (locale)=>{
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return $821836ac417e6c21$var$scailingJiraFreeImageMap[locale] || $821836ac417e6c21$var$scailingJiraFreeImageMap["en"];
};

});


parcelRegister("5NASl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bc707c0097e7c64$export$2e2bcd8739ae039; });
/* integrations.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $0bc707c0097e7c64$var$integrationStyles = null;
const $0bc707c0097e7c64$var$IntegrationSection = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o _ca0qd36x _u5f3idpf _n3tdd36x _19bvidpf _bfhku67f _1mfriapn _10j01wp6 _1jg6eva1 _1j44ffox _14q21bp4 _1vlrn6wy _kgiyidpf _1w0xn6wy _958cidpf _1glwiapn _bzzi1wp6 _16tjeva1 _2h351pr0 _bpkw1bp4 _gkkofqoz _13hpzgvh _74gkeva1 _b2g01omv _i6jx16xz _1lh7idpf _z3nc16xz _wpaiidpf _1gnk1yaq _p17a1nw7 _1u5reva1 _rb2g1omv _3vsh16xz _op2cidpf _gos316xz _50abidpf _ij141yaq _1odr1h4v _18xueva1 _1o6012og _122l1yw0 _15l27vkz _vvoeidpf _jq287vkz _ckscidpf _4s0m1ssb _eupsidpf _13fo1wug _pb6midpf _p5bn1wug _1nq4ahaf _96o01j6v _x5m01tcg _f1ug1git _1gq61osq _1i2s1k8s _14o511ph _1pkrbys6 _k51wvehm _x22w1bqd _htr7dlk8 _1sm8bfng _1oki1mpp _mrde1tcg _11cj4jg8 _1bmsbys6 _rtzsvehm _17o5idpf _19zhidpf _1wroidpf _1a6aidpf _wqjv1y44 _1lrs19bv _8sqc1y44 _1i4a19bv _11y6bfng _1hlgn7od _1ykebys6 _7ihwvehm"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: "integrations-content",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                    headerText: intl.formatMessage({
                        id: "JiraSoftwarePageTemplate.integrationSection.header",
                        defaultMessage: "We believe in open relationships"
                    }),
                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "JiraSoftwarePageTemplate.integrationSection.body",
                        defaultMessage: "If your team uses it, we integrate with it. Easily add your tools from the Atlassian Marketplace, keeping Jira as your central source of truth.",
                        values: (0, $3FBn4.DEFAULT_VALUES)
                    }),
                    headerType: "h2",
                    isCentered: true,
                    orientation: "vertical",
                    ctaProps: {
                        buttonProps: {
                            text: intl.formatMessage({
                                id: "JiraSoftwarePageTemplate.integrationSection.cta",
                                defaultMessage: "Explore integrations"
                            }),
                            url: "https://marketplace.atlassian.com/",
                            type: "secondary",
                            size: "small",
                            dataEventProps: {
                                "data-event-component": "linkButton",
                                "data-event-container": "integrationSection",
                                "data-event": "clicked",
                                "data-product-key": "jiraSoftware"
                            }
                        }
                    }
                })
            })
        })
    });
};
$0bc707c0097e7c64$var$IntegrationSection.displayName = "IntegrationSection";
var $0bc707c0097e7c64$export$2e2bcd8739ae039 = $0bc707c0097e7c64$var$IntegrationSection;

});

parcelRegister("5AOuY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbceca7c75b80666$export$2e2bcd8739ae039; });
/* logged-in-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $6IiXU = parcelRequire("6IiXU");

var $4XrxY = parcelRequire("4XrxY");

var $dWbel = parcelRequire("dWbel");

var $eZUFa = parcelRequire("eZUFa");

var $cGUps = parcelRequire("cGUps");

var $3Ddvc = parcelRequire("3Ddvc");

var $3WGov = parcelRequire("3WGov");
const $fbceca7c75b80666$var$GRAPHQL_GATEWAY_URL = "https://www.atlassian.com/gateway/api/graphql";
const $fbceca7c75b80666$var$START_URL = "https://start.atlassian.com";
const $fbceca7c75b80666$var$jswHeroSectionStyle = null;
const $fbceca7c75b80666$var$targetStyle = null;
const $fbceca7c75b80666$var$arrowCircleStyle = null;
const $fbceca7c75b80666$var$heroTextSectionStyle = null;
const $fbceca7c75b80666$var$jiraSiteBoxStyle = null;
const $fbceca7c75b80666$var$headingStyle = null;
const $fbceca7c75b80666$var$siteStyle = null;
const $fbceca7c75b80666$var$productStyle = null;
const $fbceca7c75b80666$var$siteNameStyle = null;
const $fbceca7c75b80666$var$buttonStyle = null;
const $fbceca7c75b80666$var$otherJiraSiteStyle = null;
const $fbceca7c75b80666$var$subHeadingStyle = null;
const $fbceca7c75b80666$var$logoStyle = null;
const $fbceca7c75b80666$var$logoAndSiteNameStyle = null;
const $fbceca7c75b80666$var$LoggedInHeroSection = ()=>{
    const { splitName: splitName, hasMultipleJiras: hasMultipleJiras, siteName: siteName, siteUrl: siteUrl } = (0, $eZUFa.useRecentJiraSite)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    (0, $iSvIT.useEffect)(()=>{
        //if client side, fire analytics event
        if (typeof window !== "undefined") createAnalyticsEvent((0, $7Knp0._)({}, (0, $cGUps.loggedInHeroLoadedAnalyticsPayload))).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const clickHandler = (eventName)=>{
        createAnalyticsEvent((0, $6iHNw._)((0, $7Knp0._)({}, (0, $cGUps.loggedInHeroAnalyticsPayload)), {
            attributes: {
                eventName: eventName,
                url: window.location.href,
                atlasId: "ATLAS-53087"
            }
        })).fire();
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
            className: (0, $esG4f.default)([
                "_1itkpso1 _12vemgnk _1lrw1dfr _1e0c1txw _1n261g80 _4cvr1h6o _1bah1h6o _ca0qidpf _u5f3o7ao _n3tdidpf _19bvo7ao"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswstnw _1e02idpf _152tidpf _1mjbglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3WGov.default), {})
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswstnw _rjxpidpf _152tr0r7 _1mjbglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3Ddvc.default), {})
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_syazu67f _1bsb1osq _p12fk3xj _19pk53f4 _2hwx7l9q _otyr12am _18u07l9q _q7gqgktf _zcqx1f4h _1adi1nn1 _1mt153f4 _1tnt12am _xtn77l9q _1iyef34k _1fkko7ao"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                            className: (0, $esG4f.default)([
                                "_1wybckbl _vwz48vuz _k48pbfng _6rtho7ao"
                            ]),
                            children: splitName && splitName.length > 0 ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBackWithName",
                                defaultMessage: `Welcome back, {name}.`,
                                values: {
                                    name: splitName[0]
                                }
                            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBack",
                                defaultMessage: "Welcome back"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: (0, $esG4f.default)([
                                "_1pfho7ao _6rtho7ao"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraSoftwarePageTemplate.loggedInHero.pickUpWhereYouLeftOff",
                                defaultMessage: "Pick up where you left off in Jira."
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
                            href: siteUrl,
                            onClick: ()=>clickHandler((0, $cGUps.TRACKING_EVENT_NAMES).loggedInHeroProductCtaClicked),
                            className: (0, $esG4f.default)([
                                "_1bsb1osq _4t3it9kd _1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _19it1vx7 _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1pfhgktf _6rthgktf"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1e0c1txw _2lx2vrvc _4cvr1h6o _1ul9idpf"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_12l219bv _1pfhrdoj"
                                            ]),
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Logo), {
                                                brand: "jira",
                                                type: "mark",
                                                appearance: "brand"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                            className: (0, $esG4f.default)([
                                                "_vwz4qslr _1wyb7vkz _1reo15vq _18m915vq"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                    className: (0, $esG4f.default)([
                                                        "_k48pbfng _1wybl52n"
                                                    ]),
                                                    children: "Jira"
                                                }),
                                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                    className: (0, $esG4f.default)([
                                                        "_k48powjs _1bto1l2s _1reo15vq _18m915vq _o5721q9c"
                                                    ]),
                                                    children: siteName
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
                                    id: "jira-button",
                                    appearance: "warning",
                                    className: (0, $esG4f.default)([
                                        "_ahbqo7ao"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.loggedInHero.goToJira",
                                        defaultMessage: "Go to Jira"
                                    })
                                })
                            ]
                        }),
                        hasMultipleJiras && /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
                            href: $fbceca7c75b80666$var$START_URL,
                            appearance: "subtle-link",
                            onClick: ()=>clickHandler((0, $cGUps.TRACKING_EVENT_NAMES).loggedInHeroAnotherSiteCtaClicked),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                className: (0, $esG4f.default)([
                                    "_1pfho7ao _1wyb7vkz _4bfu1r31 _1hms8stv _ajmmnqa1 _syazu67f _k48p1kdj"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "JiraSoftwarePageTemplate.loggedInHero.lookingForAnotherSite",
                                    defaultMessage: "I\u2019m looking for another Jira site"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$fbceca7c75b80666$var$LoggedInHeroSection.displayName = "LoggedInHeroSection";
var $fbceca7c75b80666$export$2e2bcd8739ae039 = $fbceca7c75b80666$var$LoggedInHeroSection;

});
parcelRegister("cGUps", function(module, exports) {

$parcel$export(module.exports, "TRACKING_EVENT_NAMES", function () { return $2062e1475c6ebb76$export$9a56b303ccc53008; });
$parcel$export(module.exports, "loggedInHeroAnalyticsPayload", function () { return $2062e1475c6ebb76$export$cbc42fadf8b93ea3; });
$parcel$export(module.exports, "loggedInHeroLoadedAnalyticsPayload", function () { return $2062e1475c6ebb76$export$572cd721c4c6631c; });
var $2062e1475c6ebb76$export$9a56b303ccc53008;
(function(TRACKING_EVENT_NAMES) {
    TRACKING_EVENT_NAMES["loggedInHeroProductCtaClicked"] = "loggedInHeroProductCtaClicked";
    TRACKING_EVENT_NAMES["loggedInHeroAnotherSiteCtaClicked"] = "loggedInHeroAnotherSiteCtaClicked";
})($2062e1475c6ebb76$export$9a56b303ccc53008 || ($2062e1475c6ebb76$export$9a56b303ccc53008 = {}));
const $2062e1475c6ebb76$export$cbc42fadf8b93ea3 = {
    eventType: "ui",
    action: "clicked",
    actionSubject: "button",
    actionSubjectId: "loggedInHero",
    source: "/software/jira"
};
const $2062e1475c6ebb76$export$572cd721c4c6631c = {
    eventType: "ui",
    action: "loaded",
    actionSubject: "ATLAS-53087",
    actionSubjectId: "loggedInHero",
    source: "/software/jira",
    attributes: {
        atlasId: "ATLAS-53087"
    }
};

});

parcelRegister("3Ddvc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d66c58b21f254a7$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
const $9d66c58b21f254a7$var$ArrowCircle = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "157",
        height: "343",
        viewBox: "0 0 157 343",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M134 240C85.3995 240 46 200.601 46 152C46 103.399 85.3995 64 134 64",
                stroke: "url(#paint0_linear_1167_22236)",
                strokeWidth: "2.10383",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M118 48L134 63.976L118 80",
                stroke: "white",
                strokeWidth: "2.10383",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                cx: "148.5",
                cy: "148.5",
                r: "147.25",
                stroke: "#4C9AFF",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                filter: "url(#filter0_d_1167_22236)",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M160.785 218H136.262L124 239L136.262 260H160.785L173 239L160.785 218Z",
                        fill: "url(#paint1_linear_1167_22236)",
                        shapeRendering: "crispEdges"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M125.158 239L136.836 219H160.21L171.843 239L160.21 259H136.836L125.158 239Z",
                        stroke: "#B3D4FF",
                        strokeWidth: "2",
                        shapeRendering: "crispEdges"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                x: "112.25",
                y: "341.75",
                width: "148.5",
                height: "72.5",
                rx: "36.25",
                transform: "rotate(-90 112.25 341.75)",
                stroke: "#4C9AFF",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M148.5 319C161.479 319 172 308.479 172 295.5C172 282.521 161.479 272 148.5 272C135.521 272 125 282.521 125 295.5C125 308.479 135.521 319 148.5 319Z",
                fill: "url(#paint2_linear_1167_22236)"
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("filter", {
                        id: "filter0_d_1167_22236",
                        x: "92",
                        y: "186",
                        width: "113",
                        height: "106",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0, $loA2J.jsx)("feGaussianBlur", {
                                stdDeviation: "16"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.0156863 0 0 0 0 0.364706 0 0 0 0 0.894118 0 0 0 1 0"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_1167_22236"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_1167_22236",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                        id: "paint0_linear_1167_22236",
                        x1: "90",
                        y1: "64",
                        x2: "90",
                        y2: "240",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "1",
                                stopColor: "white",
                                stopOpacity: "0.15"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                        id: "paint1_linear_1167_22236",
                        x1: "131.776",
                        y1: "255.539",
                        x2: "164.898",
                        y2: "222.066",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0065FF",
                                stopOpacity: "0.67"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                        id: "paint2_linear_1167_22236",
                        x1: "131.894",
                        y1: "312.131",
                        x2: "165.128",
                        y2: "278.897",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                stopColor: "#F8A703"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FAA802",
                                stopOpacity: "0.67"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $9d66c58b21f254a7$export$2e2bcd8739ae039 = $9d66c58b21f254a7$var$ArrowCircle;

});

parcelRegister("3WGov", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0ca209dfebcb099$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
const $f0ca209dfebcb099$var$TargetSvg = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "254",
        height: "421",
        viewBox: "0 0 254 421",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M-9.5332 158.174C-38.8225 187.463 -39.1391 234.634 -10.2403 263.533C18.6585 292.432 65.8293 292.115 95.1186 262.826C124.408 233.537 124.725 186.366 95.8257 157.467C66.9269 128.568 19.7561 128.885 -9.5332 158.174Z",
                fill: "url(#paint0_linear_1058_39888)"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                cx: "43.4999",
                cy: "209.793",
                r: "107.75",
                transform: "rotate(135 43.4999 209.793)",
                stroke: "url(#paint1_linear_1058_39888)",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                cx: "43.4998",
                cy: "210.5",
                r: "147.25",
                transform: "rotate(135 43.4998 210.5)",
                stroke: "url(#paint2_linear_1058_39888)",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                        id: "paint0_linear_1058_39888",
                        x1: "43.2371",
                        y1: "135.994",
                        x2: "44.237",
                        y2: "284.98",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                stopColor: "#2684FF"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0E64DF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                        id: "paint1_linear_1058_39888",
                        x1: "141",
                        y1: "128.793",
                        x2: "23.9999",
                        y2: "328.793",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "1",
                                stopColor: "white",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                        id: "paint2_linear_1058_39888",
                        x1: "43.4998",
                        y1: "62",
                        x2: "43.4998",
                        y2: "359",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                stopColor: "#4C9AFF"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9BB2D1",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $f0ca209dfebcb099$export$2e2bcd8739ae039 = $f0ca209dfebcb099$var$TargetSvg;

});


parcelRegister("gnhk8", function(module, exports) {

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("fovuc");
var $5ZfUA = parcelRequire("5ZfUA");

var $3FBn4 = parcelRequire("3FBn4");
const $ebaf08bc66e7d763$var$JiraPlainBanners = ()=>{
    const intl = (0, $f6qj2.default)();
    const aiBannerMessages = {
        identifier: "jira-software.banner-alert.atlassian-intelligence",
        text: intl.formatMessage({
            id: "jira-software.banner-alert.text",
            defaultMessage: "Transform teamwork with Atlassian Intelligence - now available."
        }),
        linkText: intl.formatMessage({
            id: "jira-software.banner-alert.link-text",
            defaultMessage: "Learn more"
        }),
        linkUrl: (0, $3FBn4.useLocalizedHref)("/software/artificial-intelligence"),
        dataEventProps: {
            "data-product-key": "jiraSoftware",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Learn more",
            "data-label-english": "Learn more"
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5ZfUA.BannerAlert), (0, $7Knp0._)({}, aiBannerMessages));
};
$ebaf08bc66e7d763$var$JiraPlainBanners.displayName = "JiraPlainBanners";
var $ebaf08bc66e7d763$export$2e2bcd8739ae039 = $ebaf08bc66e7d763$var$JiraPlainBanners;

});

parcelRegister("fbUwe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e28518dcf481585c$export$2e2bcd8739ae039; });
/* scaling.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");

var $bhreu = parcelRequire("bhreu");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $jS47I = parcelRequire("jS47I");
const $e28518dcf481585c$var$backgroundStyles = null;
const $e28518dcf481585c$var$ScalingSection = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_bfhk1mpp _12vemgnk _syazu67f _ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _59381r31 _yha28stv _1nmznqa1 _gkko1pdx _13hp1ssb _b2g01dfr _1gnkx3m7 _p17a1m79 _rb2g1s9t _ij14x3m7 _1odr1c44 _1o601i26"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_kzvi1txw _1gzvzwfg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _1bsbzufs _p12fjsxk _11ebahaf _l5k14jg8 _17z41g1n _jw8h1tcg _q7gq1j6v _zcqxbs82 _1hr2uxkd _1rfm1osq _1kll1k8s"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                            headerType: "h2",
                            headerText: intl.formatMessage({
                                id: "JiraSoftwarePageTemplate.scalingSection.headerText",
                                defaultMessage: "Built for teams of 1 to 100,000"
                            }),
                            bodyText: intl.formatMessage({
                                id: "JiraSoftwarePageTemplate.scalingSection.bodyText",
                                defaultMessage: "A growing team doesn\u2019t need to mean growing pains. With best-of-breed features, security, privacy, and the right tool for every step of your journey - Jira allows you to scale without friction - regardless of your company size."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0cglyw _1itkcsvi _ouxlfo30 _12vemgnk _1lrwgi01 _1mjb1txw"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _2lx21bp4 _zulpor1b _ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)($e28518dcf481585c$var$ScalingStepsForSmallScreen, {
                                    imageSrc: (0, $jS47I.getScailingSectionJiraFreeImage)(intl.locale),
                                    imageAltText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.scalingSection.small.jiraFree",
                                        defaultMessage: "Jira free"
                                    }),
                                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.scalingSection.small.jiraSoftwareFree",
                                        defaultMessage: "Jira free forever for teams up to 10",
                                        values: (0, $3FBn4.DEFAULT_VALUES)
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)($e28518dcf481585c$var$ScalingStepsForSmallScreen, {
                                    imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/j35w660pt742q2m6rnk083y2610rnw71.webp",
                                    imageAltText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.scalingSection.small.jiraSoftware",
                                        defaultMessage: "Jira Software"
                                    }),
                                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.scalingSection.small.jiraSoftwareStandard",
                                        defaultMessage: "Jira Standard for growing teams",
                                        values: (0, $3FBn4.DEFAULT_VALUES)
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)($e28518dcf481585c$var$ScalingStepsForSmallScreen, {
                                    imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/55gl86x3tg73mwa05i2qifsd51400818.webp",
                                    imageAltText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.scalingSection.small.jiraSoftwarePremium",
                                        defaultMessage: "Jira Premium"
                                    }),
                                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.scalingSection.small.jiraSoftwarePremiumScale",
                                        defaultMessage: "Scale across teams with <a>Jira Premium</a>",
                                        values: (0, $7Knp0._)({
                                            a: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)("a" // eslint-disable-next-line react-hooks/rules-of-hooks
                                                , {
                                                    href: (0, $3FBn4.useLocalizedHref)("/software/jira/premium"),
                                                    "data-event-component": "linkButton",
                                                    "data-event-container": "textBlock",
                                                    "data-event": "clicked",
                                                    "data-label": "Jira Premium",
                                                    "data-product-key": "jiraSoftware",
                                                    children: str
                                                })
                                        }, (0, $3FBn4.DEFAULT_VALUES))
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)($e28518dcf481585c$var$ScalingStepsForSmallScreen, {
                                    imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/6p36547re745xu475rp6214nr53vj3q0.webp",
                                    imageAltText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.scalingSection.small.jiraSoftwareEnterprise",
                                        defaultMessage: "Jira Enterprise"
                                    }),
                                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.scalingSection.small.jiraSoftwareEnterpriseConnect",
                                        defaultMessage: "Connect and accelerate your entire <a>enterprise</a>",
                                        values: (0, $7Knp0._)({
                                            a: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)("a" // eslint-disable-next-line react-hooks/rules-of-hooks
                                                , {
                                                    href: (0, $3FBn4.useLocalizedHref)("/software/jira/enterprise"),
                                                    "data-event-component": "linkButton",
                                                    "data-event-container": "textBlock",
                                                    "data-event": "clicked",
                                                    "data-label": "enterprise",
                                                    "data-product-key": "jiraSoftware",
                                                    children: str
                                                })
                                        }, (0, $3FBn4.DEFAULT_VALUES))
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)($e28518dcf481585c$var$ScalingStepsForSmallScreen, {
                                    imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/s0f7hv6783r3srwgwj2ko2e1rk8808at.webp",
                                    imageAltText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.scalingSection.small.jiraAlign",
                                        defaultMessage: "Jira Align"
                                    }),
                                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.scalingSection.small.jiraAlignEnterprise",
                                        defaultMessage: "Enterprise agility with Jira Align",
                                        values: (0, $3FBn4.DEFAULT_VALUES)
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _1pfh1cg9 _6rthgktf _1mjbglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _1bah1h6o _1itk5eq5 _ouxl44ox _12vemgnk _1lrw1vx1 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _kqswh2mm _1e021ssb _t9eczr6s _1bsb6aaz _p12f1757"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)($e28518dcf481585c$var$ScalingStepsForLargeScreen, {
                                    imageSrc: (0, $jS47I.getScailingSectionJiraFreeImage)(intl.locale),
                                    imageAltText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.scalingSection.large.jiraFree",
                                        defaultMessage: "Jira free"
                                    }),
                                    cssTop: "80px",
                                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.scalingSection.large.jiraSoftwareFree",
                                        defaultMessage: "Jira free forever for teams up to 10",
                                        values: (0, $3FBn4.DEFAULT_VALUES)
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)($e28518dcf481585c$var$ScalingStepsForLargeScreen, {
                                    imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/j35w660pt742q2m6rnk083y2610rnw71.webp",
                                    imageAltText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.scalingSection.large.jiraSoftware",
                                        defaultMessage: "Jira"
                                    }),
                                    cssTop: "60px",
                                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.scalingSection.large.jiraSoftwareStandard",
                                        defaultMessage: "Jira Standard for growing teams",
                                        values: (0, $3FBn4.DEFAULT_VALUES)
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)($e28518dcf481585c$var$ScalingStepsForLargeScreen, {
                                    imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/55gl86x3tg73mwa05i2qifsd51400818.webp",
                                    imageAltText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.scalingSection.large.jiraSoftwarePremium",
                                        defaultMessage: "Jira Premium"
                                    }),
                                    cssTop: "40px",
                                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.scalingSection.large.jiraSoftwarePremiumScale",
                                        defaultMessage: "Scale across teams with <a>Jira Premium</a>",
                                        values: (0, $7Knp0._)({
                                            a: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)("a" // eslint-disable-next-line react-hooks/rules-of-hooks
                                                , {
                                                    href: (0, $3FBn4.useLocalizedHref)("/software/jira/premium"),
                                                    "data-event-component": "linkButton",
                                                    "data-event-container": "textBlock",
                                                    "data-event": "clicked",
                                                    "data-label": "Jira Premium",
                                                    "data-product-key": "jiraSoftware",
                                                    children: str
                                                })
                                        }, (0, $3FBn4.DEFAULT_VALUES))
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)($e28518dcf481585c$var$ScalingStepsForLargeScreen, {
                                    imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/6p36547re745xu475rp6214nr53vj3q0.webp",
                                    imageAltText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.scalingSection.large.jiraSoftwareEnterprise",
                                        defaultMessage: "Jira Enterprise"
                                    }),
                                    cssTop: "20px" // disabling eslint because the bodyText prop is a ReactNode
                                    ,
                                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.scalingSection.large.jiraSoftwareEnterpriseConnect",
                                        defaultMessage: "Connect and accelerate your entire <a>enterprise</a>",
                                        values: (0, $7Knp0._)({
                                            a: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)("a" // eslint-disable-next-line react-hooks/rules-of-hooks
                                                , {
                                                    href: (0, $3FBn4.useLocalizedHref)("/software/jira/enterprise"),
                                                    "data-event-component": "linkButton",
                                                    "data-event-container": "textBlock",
                                                    "data-event": "clicked",
                                                    "data-label": "enterprise",
                                                    "data-product-key": "jiraSoftware",
                                                    children: str
                                                })
                                        }, (0, $3FBn4.DEFAULT_VALUES))
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)($e28518dcf481585c$var$ScalingStepsForLargeScreen, {
                                    imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/s0f7hv6783r3srwgwj2ko2e1rk8808at.webp",
                                    imageAltText: intl.formatMessage({
                                        id: "JiraSoftwarePageTemplate.scalingSection.large.jiraAlign",
                                        defaultMessage: "Jira Align"
                                    }),
                                    cssTop: "0",
                                    bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "JiraSoftwarePageTemplate.scalingSection.large.jiraAlignEnterprise",
                                        defaultMessage: "Enterprise agility with Jira Align",
                                        values: (0, $3FBn4.DEFAULT_VALUES)
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $e28518dcf481585c$var$ScalingStepsForSmallScreen = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _4cvr1h6o _bna753f4 _1rg253f4 _mezj53f4 _1lx8cs5v"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
                    src: props.imageSrc,
                    alt: props.imageAltText
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4cvr1h6o _1e0c1txw _bozgzwfg _1bsb1ssb _1s4p1wug"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: (0, $esG4f.default)([
                        "_1wyb1j6v _19pkidpf _2hwxidpf _otyridpf _18u0idpf _vwz4bs82"
                    ]),
                    children: props.bodyText
                })
            })
        ]
    });
};
const $e28518dcf481585c$var$ScalingStepsForLargeScreen = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1bsbauyy"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1bah1h6o _1tke1wdt _kqswh2mm _1iu27vkz _f45rh2mm _12xta1to _mezj53f4 _bna753f4 _1lx8cs5v _aetrb3bt _18postnw _1qdgmgvx _19nq14em _eq431r3d _19h91cud _1v5vlllb _8s22gvcq _1bqqkb7n"
                    ]),
                    style: {
                        "--_1wfsy9y": (0, $43MIc.default)(props.cssTop)
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
                        src: props.imageSrc,
                        alt: props.imageAltText
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_bfhkdu3w _2rko1ssb _4t3igktf _19pkidpf _2hwx1wug _otyr1ul9 _18u01wug _1bsbgktf"
                    ])
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_1wyb1j6v _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o _vwz4bs82"
                        ]),
                        children: props.bodyText
                    })
                })
            ]
        })
    });
};
$e28518dcf481585c$var$ScalingSection.displayName = "ScalingSection";
var $e28518dcf481585c$export$2e2bcd8739ae039 = $e28518dcf481585c$var$ScalingSection;

});

parcelRegister("iElmF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6449ce724f3b3a5e$export$2e2bcd8739ae039; });
/* tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");
parcelRequire("6dRh5");
var $dq9mP = parcelRequire("dq9mP");

var $jS47I = parcelRequire("jS47I");
const $6449ce724f3b3a5e$var$TabsSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const QUOTE_IMAGE_PROPS = {
        className: "tab-quote-image",
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/41knb7g4sf3cg6sj54o2uubv0r3r3n33.svg",
        alt: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.tabs.quoteAlt",
            defaultMessage: "Quotation mark"
        })
    };
    const planLocalizedImageSrc = (0, $jS47I.getPlanTabsSectionImage)(intl.locale);
    const planLocalizedVideoSrc = (0, $jS47I.getPlanTabsSectionVideo)(intl.locale);
    const trackLocalizedImageSrc = (0, $jS47I.getTrackTabsSectionImage)(intl.locale);
    const releaseLocalizedImageSrc = (0, $jS47I.getReleaseTabsSectionImage)(intl.locale);
    const reportLocalizedImageSrc = (0, $jS47I.getReportTabsSectionImage)(intl.locale);
    const automateLocalizedImageSrc = (0, $jS47I.getAutomateTabsSectionImage)(intl.locale);
    const getPlanLocalizedMedia = (locale)=>{
        // english should show a still image, other locales will show a localized gif (since the still has not been localized)
        if (locale === "en") return {
            imageProps: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8q22ns81pbey0cqxk25j50spls50mw41.webp",
                alt: intl.formatMessage({
                    id: "JiraSoftwarePageTemplate.tabsPlan.imageAltText",
                    defaultMessage: "" // TODO - still awaiting what this should be
                }),
                aspectRatio: "none"
            }
        };
        return {
            videoProps: {
                videoLink: planLocalizedVideoSrc,
                videoPreviewImage: planLocalizedImageSrc,
                aspectRatio: "none"
            }
        };
    };
    const planLocalizedMedia = getPlanLocalizedMedia(intl.locale);
    const tabs = [
        {
            textLabel: "Plan",
            id: "tab-plan",
            headerText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsHeader.plan",
                defaultMessage: "Plan"
            }),
            bodyText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsBody.plan",
                defaultMessage: "Break the big ideas down into manageable chunks across teams with user stories, issues, and tasks."
            }),
            quoteImageProps: QUOTE_IMAGE_PROPS,
            quote: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsQuote.plan",
                defaultMessage: "Work becomes a lot more visible when it's all in one place. It makes collaboration a whole lot easier."
            }),
            name: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsName.plan",
                defaultMessage: "Jeff Lai"
            }),
            company: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePageTemplate.tabsCompany.plan",
                defaultMessage: "Internal Infrastructure, canva",
                values: (0, $3FBn4.DEFAULT_VALUES)
            }),
            display: planLocalizedMedia
        },
        {
            textLabel: "Track",
            id: "tab-track",
            headerText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsHeader.track",
                defaultMessage: "Track"
            }),
            bodyText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsBody.track",
                defaultMessage: "Prioritize and discuss your team\u2019s work in context with complete visibility at every level."
            }),
            quoteImageProps: QUOTE_IMAGE_PROPS,
            quote: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsQuote.track",
                defaultMessage: "The pace of delivery from idea to reality has exploded."
            }),
            name: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsName.track",
                defaultMessage: "Greg Franklin"
            }),
            company: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePageTemplate.tabsCompany.track",
                defaultMessage: "Agile lead, Cancer Research UK",
                values: (0, $3FBn4.DEFAULT_VALUES)
            }),
            display: {
                imageProps: {
                    src: trackLocalizedImageSrc,
                    alt: intl.formatMessage({
                        id: "JiraSoftwarePageTemplate.tabsImageAltText.track",
                        defaultMessage: "The timeline view in Jira allows users to review progress by sprints in weeks, months, or quarters. Status is by category in this example."
                    })
                }
            }
        },
        {
            textLabel: "Release",
            id: "tab-release",
            headerText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsHeader.release",
                defaultMessage: "Release"
            }),
            bodyText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsBody.release",
                defaultMessage: "Ship faster, with confidence knowing the information you have is always up-to-date."
            }),
            quoteImageProps: QUOTE_IMAGE_PROPS,
            quote: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsQuote.release",
                defaultMessage: "Less friction in the development process means better results and a faster time to market."
            }),
            name: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsName.release",
                defaultMessage: "Louis Bennett"
            }),
            company: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePageTemplate.tabsCompany.release",
                defaultMessage: "Director of Engineering, Trulia",
                values: (0, $3FBn4.DEFAULT_VALUES)
            }),
            display: {
                imageProps: {
                    src: releaseLocalizedImageSrc,
                    alt: intl.formatMessage({
                        id: "JiraSoftwarePageTemplate.tabsImageAltText.release",
                        defaultMessage: "Releases within a Jira project. This view contains the version, status, progress, start date, release date, and description."
                    })
                }
            }
        },
        {
            textLabel: "Report",
            id: "tab-report",
            headerText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsHeader.report",
                defaultMessage: "Report"
            }),
            bodyText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsBody.report",
                defaultMessage: "Improve team performance in context, based on real-time, visual data."
            }),
            quoteImageProps: QUOTE_IMAGE_PROPS,
            quote: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsQuote.report",
                defaultMessage: "Full visibility in Jira across the whole organization enables you to make better management judgment. "
            }),
            name: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsName.report",
                defaultMessage: "Paul Leaon"
            }),
            company: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePageTemplate.tabsCompany.report",
                defaultMessage: "Digital Portfolio Director, Inchcape",
                values: (0, $3FBn4.DEFAULT_VALUES)
            }),
            display: {
                imageProps: {
                    src: reportLocalizedImageSrc,
                    alt: intl.formatMessage({
                        id: "JiraSoftwarePageTemplate.tabsImageAltText.report",
                        defaultMessage: "Within the Kanban board in Jira, a project backlog shows 5 issues are on the board and 8 are in backlog."
                    })
                }
            }
        },
        {
            textLabel: "Automate",
            id: "tab-automate",
            headerText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsHeader.automate",
                defaultMessage: "Automate"
            }),
            bodyText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsBody.automate",
                defaultMessage: "Save time, keep your team focused, and help work flow with no-code automation."
            }),
            quoteImageProps: QUOTE_IMAGE_PROPS,
            quote: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsQuote.automate",
                defaultMessage: "We\u2019re saving 150 hours+ of valuable engineering time per month. "
            }),
            name: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsName.automate",
                defaultMessage: "Jeff Lai"
            }),
            company: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePageTemplate.tabsCompany.automate",
                defaultMessage: "Internal Infrastructure, canva",
                values: (0, $3FBn4.DEFAULT_VALUES)
            }),
            display: {
                imageProps: {
                    src: automateLocalizedImageSrc,
                    alt: intl.formatMessage({
                        id: "JiraSoftwarePageTemplate.tabsImageAltText.automate",
                        defaultMessage: "Automation workflow in Jira. An example automation closes all stories in an epic when the epic is completed."
                    })
                }
            }
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1dyznl7k _30peazy9 _6k4u1ssb _8vi8mgnk _1ls11dfr _1n8kokh7 _1so11y44 _5ilw7vkz _9oja1y44 _yf2h7vkz _14lo1ehm _1hkv1r31 _ntb519ly _spxy1o36 _hycx1k92 _1ijg1j28 _c2wd14gx _d7qx1osq _kzzg1wug _t4tn1wug _sfzq1wug _rsoa1wug _xkf4glyw _5e4v1j6v _zglv1ylp _10h7idpf _9enho7ao _10k7idpf _g2i4o7ao _1glu1osq _16gd1r31 _1ifu19ly _15ln1o36 _1flj66rk _w7gs7vkz _o1ftidpf _vryy7vkz _rtmhidpf _1lz31y6m _mumd1mrw _1j2u1h6o _1b6rbfng _wg8cnl7k _16y31td8 _vussahaf _i80qidpf _1y3uidpf _vq3zidpf _1x7sidpf _suv51td8 _uyj9ahaf _gem2idpf _1gtzidpf _19s1idpf _p2anidpf _10tn1tcg _v3z0lnmy _10vf1tcg _p1061k92 _7iyz4jg8 _zqtwnl7k _130319ii _ebc91k8s _18gv1k8s _1wkh1msg _1nq1glyw _bh331k92 _1s0mcjiy _tq29oxwj _1bap10nf _9izn12it _14sx1l9c _1kz6cs5v _19mv12it _q7gq1k92 _zcqxcjiy"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dq9mP.TabsQuote), {
            id: "tabs-section",
            label: "Tabs",
            headerText: intl.formatMessage({
                id: "JiraSoftwarePageTemplate.tabsHeader",
                defaultMessage: "All from a single source of truth"
            }),
            bodyText: "",
            tabs: tabs,
            colors: {
                defaultBG: "#42526e",
                defaultText: "#dfe1e6",
                activeBG: "#57d9a3",
                activeText: "#091e42",
                hoverBG: "#42526e",
                hoverText: "#dfe1e6",
                quoteColor: "#0065ff"
            },
            className: "software-jira-tabs"
        })
    });
};
$6449ce724f3b3a5e$var$TabsSection.displayName = "TabsSection";
var $6449ce724f3b3a5e$export$2e2bcd8739ae039 = $6449ce724f3b3a5e$var$TabsSection;

});
parcelRegister("6dRh5", function(module, exports) {
$parcel$export(module.exports, "TabsQuote", function () { return (parcelRequire("dq9mP")).TabsQuote; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("dq9mP")).TabsQuote; });

var $dq9mP = parcelRequire("dq9mP");

});
parcelRegister("dq9mP", function(module, exports) {

$parcel$export(module.exports, "TabsQuote", function () { return $c80b07db157526ca$export$ad1b9d9a70aaa9a5; });
/* tabs-quote.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");
parcelRequire("gXzhc");
var $fYNW7 = parcelRequire("fYNW7");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");
const $c80b07db157526ca$var$StatsStyle = null;
const $c80b07db157526ca$var$TabsWrapper = null;
const $c80b07db157526ca$export$ad1b9d9a70aaa9a5 = ({ id: id, label: label, headerText: headerText, bodyText: bodyText, tabs: tabs, colors: colors, ctaProps: ctaProps, linkPosition: linkPosition = "bottom", className: className, tabContentType: tabContentType = "quoteTextImage" })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_syazu67f _ca0qvbgk _u5f3idpf _n3tdvbgk _19bvidpf _i6jxckbl _1lh7idpf _z3ncckbl _wpaiidpf _1kmxzwfg _1ggmidpf _1ykzzwfg _1maeidpf",
            className
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                layout: "10",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                    className: "tabs-quote-header-content-block",
                    headerText: headerText,
                    headerType: "h2",
                    bodyText: bodyText,
                    isCentered: true,
                    ctaProps: linkPosition == "top" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? ctaProps : {}
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_ca0qgktf _u5f3idpf _n3tdgktf _19bvidpf",
                    "tabquote-tab-group-div"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fYNW7.TabGroup), {
                    colors: colors,
                    tabContentType: tabContentType,
                    tabs: tabs,
                    id: id,
                    label: label
                })
            }),
            linkPosition == "bottom" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), (0, $7Knp0._)({}, ctaProps.primaryLinkProps))
                })
            }) : null
        ]
    });
};

});



parcelRegister("jEzAG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e74f4f27f2bc13fe$export$2e2bcd8739ae039; });
/* workflow.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $bhreu = parcelRequire("bhreu");
parcelRequire("gXzhc");
var $fYNW7 = parcelRequire("fYNW7");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $jS47I = parcelRequire("jS47I");
const $e74f4f27f2bc13fe$var$sectionStyles = null;
const $e74f4f27f2bc13fe$var$h3Styles = null;
const $e74f4f27f2bc13fe$export$ccd9b7bceade3f2e = ()=>{
    const intl = (0, $f6qj2.default)();
    const localizedImageSrc = (0, $jS47I.getWorkflowSectionImage)(intl.locale);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
        src: localizedImageSrc,
        alt: "Diagram showcasing an example workflow using Jira Software"
    });
};
const $e74f4f27f2bc13fe$var$WorkflowSection = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _syazu67f _1e0c1txw _2lx21bp4 _1itkq02d _12vemgnk _1ywg1g6a _17m61ssb _16nzmgnk _9r801dfr _fehp1txw _4fwavrvc _1j0qkb7n _lei9kb7n _16arf1ug _10hl37uc _1uazkb7n _sjxrf1ug _f5z61w8u _cx5866rk _bh331k92 _1s0mcjiy _tq29oxwj _1bap10nf _9izn12it _14sx1l9c _1kz6cs5v _19mv12it _1dne1h6o _1g7k1txw _bclw1txw _lqde1h6o _1qws1bp4 _ig1uzwfg _14zoxy5q _16qj9by0 _fa5hidpf _11ku1txw _ty5v1h6o _12451bp4 _1bgrxy5q _maztzwfg _151u9by0"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_y3gn1h6o _k48p4jg8 _1wybahaf _1lzoviql _1cqs1k8s _q5ugidpf _7tldidpf _14adidpf _4uroidpf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "JiraSoftwarePageTemplate.workflowSection.header",
                    defaultMessage: "Easier than ever",
                    values: (0, $3FBn4.DEFAULT_VALUES)
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: "workflow-body",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: "icon-gradient",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)($e74f4f27f2bc13fe$var$IconGradient, {})
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: "workflow-container",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: "workflow-center-left",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                            className: (0, $esG4f.default)([
                                                "_y3gn1h6o _18s8olf4 _k48p4jg8 _1s181k8s _1cqs15x9"
                                            ]),
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                id: "JiraSoftwarePageTemplate.workflowSection.templatesHeader",
                                                defaultMessage: "Templates give you a head start",
                                                values: (0, $3FBn4.DEFAULT_VALUES)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                            className: "workflow-paragraph",
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                id: "JiraSoftwarePageTemplate.workflowSection.templatesSubheader",
                                                defaultMessage: "Get started with ready-made templates.",
                                                values: (0, $3FBn4.DEFAULT_VALUES)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                            className: "template-items-container",
                                            children: [
                                                /*#__PURE__*/ (0, $loA2J.jsx)($e74f4f27f2bc13fe$export$e9ddabec9e160c60, {}),
                                                /*#__PURE__*/ (0, $loA2J.jsx)($e74f4f27f2bc13fe$export$663afa91d60a5406, {}),
                                                /*#__PURE__*/ (0, $loA2J.jsx)($e74f4f27f2bc13fe$export$37aa17f472de4267, {}),
                                                /*#__PURE__*/ (0, $loA2J.jsx)($e74f4f27f2bc13fe$export$4c29df8ef83059b3, {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_2rko1msg _ahbq16gx"
                                            ]),
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fYNW7.Quote), {
                                                image: /*#__PURE__*/ (0, $loA2J.jsx)($e74f4f27f2bc13fe$export$8b64c1894b7932a5, {}),
                                                quote: intl.formatMessage({
                                                    id: "JiraSoftwarePageTemplate.workflowSection.quote",
                                                    defaultMessage: "You can decide how you are working as a team first and then let the software work around you."
                                                }) + '"',
                                                name: intl.formatMessage({
                                                    id: "JiraSoftwarePageTemplate.workflowSection.name",
                                                    defaultMessage: "Maria Bonorchis"
                                                }),
                                                company: intl.formatMessage({
                                                    id: "JiraSoftwarePageTemplate.workflowSection.company",
                                                    defaultMessage: "Agile Delivery Manager, Cancer Research UK"
                                                }),
                                                colors: {
                                                    defaultBG: "#42526e",
                                                    defaultText: "#dfe1e6",
                                                    activeBG: "#57d9a3",
                                                    activeText: "#091e42",
                                                    hoverBG: "#172b4d",
                                                    hoverText: "#dfe1e6",
                                                    quoteColor: "#0065ff"
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: "workflow-center-right",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                            className: (0, $esG4f.default)([
                                                "_y3gn1h6o _18s8olf4 _k48p4jg8 _1s181k8s _1cqs15x9"
                                            ]),
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                id: "JiraSoftwarePageTemplate.workflowSection.customizeHeader",
                                                defaultMessage: "Then customize as you grow",
                                                values: (0, $3FBn4.DEFAULT_VALUES)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                            className: "workflow-paragraph",
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                id: "JiraSoftwarePageTemplate.workflowSection.customizeSubheader",
                                                defaultMessage: "Jira adapts to the way you work, not the other way around. Start simple, customize as you go.",
                                                values: (0, $3FBn4.DEFAULT_VALUES)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)($e74f4f27f2bc13fe$export$ccd9b7bceade3f2e, {})
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $e74f4f27f2bc13fe$export$8b64c1894b7932a5 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
        className: "quote-image",
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/41knb7g4sf3cg6sj54o2uubv0r3r3n33.svg",
        alt: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.workflowSection.quoteImage",
            defaultMessage: "Quotation mark"
        })
    });
};
const $e74f4f27f2bc13fe$var$iconGradientStyles = null;
const $e74f4f27f2bc13fe$export$e9ddabec9e160c60 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)($e74f4f27f2bc13fe$var$TemplateItem, {
        headerText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.workflowSection.scrum",
            defaultMessage: "Scrum"
        }),
        image: "https://dam-cdn.atl.orangelogic.com/AssetLink/643n66r557l1i8psu0j0x23qpm6iwou8.svg",
        imageAltText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.workflowSection.scrumImageAltText",
            defaultMessage: "Agile illustration"
        }),
        href: (0, $3FBn4.useLocalizedHref)("/software/jira/templates/scrum")
    });
};
const $e74f4f27f2bc13fe$export$663afa91d60a5406 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)($e74f4f27f2bc13fe$var$TemplateItem, {
        headerText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.workflowSection.kanban",
            defaultMessage: "Kanban"
        }),
        image: "https://dam-cdn.atl.orangelogic.com/AssetLink/0det02q2xy1le35o8c17l73a4l2i5cc3.svg",
        imageAltText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.workflowSection.kanbanImageAltText",
            defaultMessage: "Kanban illustration"
        }),
        href: (0, $3FBn4.useLocalizedHref)("/software/jira/templates/kanban")
    });
};
const $e74f4f27f2bc13fe$export$37aa17f472de4267 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)($e74f4f27f2bc13fe$var$TemplateItem, {
        headerText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.workflowSection.bugTracking",
            defaultMessage: "Bug tracking"
        }),
        image: "https://dam-cdn.atl.orangelogic.com/AssetLink/qom8s2168ye5a741003k5m28v8r80g57.svg",
        imageAltText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.workflowSection.bugTrackingImageAltText",
            defaultMessage: "Bug illustration"
        }),
        href: (0, $3FBn4.useLocalizedHref)("/software/jira/templates/bug-tracking")
    });
};
const $e74f4f27f2bc13fe$export$4c29df8ef83059b3 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)($e74f4f27f2bc13fe$var$TemplateItem, {
        headerText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.workflowSection.devops",
            defaultMessage: "DevOps"
        }),
        image: "https://dam-cdn.atl.orangelogic.com/AssetLink/a3sp26uogt07ms5yk75s00e817f0bc84.svg",
        imageAltText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.workflowSection.devopsImageAltText",
            defaultMessage: "Devops illustration"
        }),
        href: (0, $3FBn4.useLocalizedHref)("/software/jira/templates/devops")
    });
};
const $e74f4f27f2bc13fe$export$4abdf9d2812569c8 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
        className: "workflow-icon",
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5vtd6c8c862vqv281l8rhxtq1hk4s273.svg",
        alt: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.workflowSection.templatesIcon",
            defaultMessage: "Templates icon"
        })
    });
};
const $e74f4f27f2bc13fe$export$e168ed240d9b8ab4 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
        className: "workflow-icon",
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ukex56bd8hjxoa63505tiq5s671s7qgc.svg",
        alt: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.workflowSection.workflowIcon",
            defaultMessage: "Workflow icon"
        })
    });
};
const $e74f4f27f2bc13fe$var$IconGradient = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1yb4 _p12fbxu3 _ouxl1ssb _12vemgnk _1gde1bp4 _1ywgi5dd _9r80vpnh _1u2q1x1l _xlt11x1l _476d1ssb _tnru1elo _1lp7vrvc _7uciw5cs _1l1414tn _1wfq176h _15vt176h _1ywmka7h _1lvaka7h _14b51n8h _qst38vuz"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)($e74f4f27f2bc13fe$export$4abdf9d2812569c8, {}),
            /*#__PURE__*/ (0, $loA2J.jsx)($e74f4f27f2bc13fe$export$e168ed240d9b8ab4, {})
        ]
    });
};
const $e74f4f27f2bc13fe$var$templateStyles = null;
const $e74f4f27f2bc13fe$var$TemplateItem = ({ headerText: headerText, image: image, imageAltText: imageAltText, href: href })=>{
    const intl = (0, $f6qj2.default)();
    const dataEventProps = {
        "data-event-component": "linkButton",
        "data-event-container": "workflowSection",
        "data-event": "clicked",
        "data-product-key": "jiraSoftware"
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1mgfv2br _a9cgmbak _18s81jx0 _1bsb1osq _1dfeu2gc _l0khu2gc _jaedbfng _h1451k92 _qyzc1td8 _1reg1h6o _ornn1bqd _1c4j1txw _1dr3xncg _jsbh1h6o _1ebypxbi _18lj146b _1qmmmbak _1c1i1fhb _1twsalr3 _1d591txw _uuuv1bp4 _1nfs1h6o _juhrpxbi _c8ehu2gc _1vcgpxbi _1hec1osq _1oqcidpf _1i6fidpf _x83zdlk8 _416xidpf _znp2i0pe _13fei0pe _rh7zi0pe _1oiii0pe _b2flx7w3 _hvglx7w3 _fza7x7w3 _1urxx7w3 _jds6i0pe _l3b8i0pe _54zzi0pe _15zui0pe _12591r31 _10e48stv _3zu2nqa1 _17ccmvkb"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: "template-image-container",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
                    src: image,
                    alt: imageAltText
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: "template-link-container",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: "template-header",
                        children: headerText
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        text: intl.formatMessage({
                            id: "JiraSoftwarePageTemplate.workflowSection.learnMore",
                            defaultMessage: "Learn more"
                        }),
                        href: href,
                        bgColor: "bgBlackBlue",
                        dataEventProps: dataEventProps
                    })
                ]
            })
        ]
    });
};
$e74f4f27f2bc13fe$var$WorkflowSection.displayName = "WorkflowSection";
var $e74f4f27f2bc13fe$export$2e2bcd8739ae039 = $e74f4f27f2bc13fe$var$WorkflowSection;

});




parcelRegister("7Ogtn", function(module, exports) {

$parcel$export(module.exports, "LoggedInHeroContainer", function () { return $db13acc45c08bc52$export$c91dc4c235bd2e79; });

var $loA2J = parcelRequire("loA2J");

var $iMdoL = parcelRequire("iMdoL");

var $kp78g = parcelRequire("kp78g");
const $db13acc45c08bc52$export$c91dc4c235bd2e79 = ({ children: children })=>{
    const { profile: { requestInProgress: profileRequestInProgress }, user: { requestInProgress: userRequestInProgress } } = (0, $iMdoL.useUserContext)();
    // Checking for both user and profile request in progress,
    // since profileRequestInProgress is initially defined as 'false' and then gets updated to true when the request is made.
    if (userRequestInProgress || profileRequestInProgress) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $kp78g.LoggedInHeroSkeleton), {});
    return children;
};

});
parcelRegister("kp78g", function(module, exports) {

$parcel$export(module.exports, "LoggedInHeroSkeleton", function () { return $1203c9de6f08390d$export$84abebbf129cccbc; });
/* logged-in-hero-skeleton.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $hjMWG = parcelRequire("hjMWG");
const $1203c9de6f08390d$var$headingSectionGap = null;
const $1203c9de6f08390d$var$sectionGap = null;
const $1203c9de6f08390d$var$contianerStyles = null;
const $1203c9de6f08390d$var$mobileDisplay = null;
const $1203c9de6f08390d$var$desktopDisplay = null;
const $1203c9de6f08390d$export$84abebbf129cccbc = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "logged-in-jira-pt-skeleton",
        className: (0, $esG4f.default)([
            "_1pfh1ejb"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1ule _1mjbglyw"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_6rth1epz"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                                width: "1152px",
                                height: "48px"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_6rthxncg _1eglxncg"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                                width: "1140px",
                                height: "1140px"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _1mjb1ule"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_6rth1epz"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                                width: "480px",
                                height: "48px"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_6rthxncg _1eglxncg"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hjMWG.Adg4Skeleton), {
                                width: "480px",
                                height: "480px"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

});


parcelRegister("d931y", function(module, exports) {

$parcel$export(module.exports, "OrganicD1to6LoggedInJiraProductTourOverview", function () { return $280b956605dda1fb$export$e3a19954eb6bb710; });

var $loA2J = parcelRequire("loA2J");

var $kex29 = parcelRequire("kex29");

var $jq0gD = parcelRequire("jq0gD");

var $1MbAx = parcelRequire("1MbAx");
parcelRequire("ccYBS");
var $1FqEx = parcelRequire("1FqEx");

var $jueTK = parcelRequire("jueTK");

var $6JmNM = parcelRequire("6JmNM");

var $64WOd = parcelRequire("64WOd");
const $280b956605dda1fb$export$e3a19954eb6bb710 = ({ experimentValue: experimentValue })=>{
    return experimentValue === "jfind-1506-after-d7-gubtp-organic" ? /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jueTK.JiraSitesProvider), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jq0gD.default), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $64WOd.default), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1FqEx.ParentScrollTracking), {
                scrollTrackingEnabled: true,
                pageId: "jsw",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $6JmNM.LoggedInHeroSection), {
                        experimentValue: experimentValue
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "jfind-organic-jpt-logged-in-redesign",
        group: "jfind-organic-jpt-logged-in-redesign",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jueTK.JiraSitesProvider), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $jq0gD.default), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $64WOd.default), {})
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1FqEx.ParentScrollTracking), {
                    scrollTrackingEnabled: true,
                    pageId: "jsw",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $6JmNM.LoggedInHeroSection), {
                            experimentValue: experimentValue
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("jueTK", function(module, exports) {

$parcel$export(module.exports, "useJiraSitesContext", function () { return $620b188a61005034$export$8095836340dcdac5; });
$parcel$export(module.exports, "JiraSitesProvider", function () { return $620b188a61005034$export$e5844423e4215335; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $iMdoL = parcelRequire("iMdoL");

var $lpc6z = parcelRequire("lpc6z");
const $620b188a61005034$var$JiraSitesContext = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $620b188a61005034$export$8095836340dcdac5 = ()=>{
    const context = (0, $iSvIT.useContext)($620b188a61005034$var$JiraSitesContext);
    if (!context) throw new Error("useJiraSitesContext must be used within a JiraSitesProvider");
    return context;
};
const $620b188a61005034$export$e5844423e4215335 = ({ children: children })=>{
    var _profile_attributes;
    const [jiraSitesFromAgg, setJiraSitesFromAgg] = (0, $iSvIT.useState)(undefined);
    const { profile: profile } = (0, $iMdoL.useUserContext)();
    const aggClient = (0, $iSvIT.useMemo)(()=>new (0, $lpc6z.LoggedInUserJiraSitesClient)(), []);
    (0, $iSvIT.useEffect)(()=>{
        var _profile_attributes;
        if (!((_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingSites) || profile.attributes.existingSites.length !== 1) return;
        const site = profile.attributes.existingSites[0];
        var _site_cloudId;
        aggClient.getJiraSites((_site_cloudId = site === null || site === void 0 ? void 0 : site.cloudId) !== null && _site_cloudId !== void 0 ? _site_cloudId : "").then((data)=>{
            setJiraSitesFromAgg(data);
        });
    }, [
        aggClient,
        (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingSites
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($620b188a61005034$var$JiraSitesContext.Provider, {
        value: {
            jiraSitesFromAgg: jiraSitesFromAgg
        },
        children: children
    });
};

});

parcelRegister("6JmNM", function(module, exports) {

$parcel$export(module.exports, "LoggedInHeroSection", function () { return $8d13ec49d1559c03$export$49c6370202c57ed1; });
/* logged-in-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $dWbel = parcelRequire("dWbel");

var $kZKty = parcelRequire("kZKty");

var $g9kzu = parcelRequire("g9kzu");

var $iSjV6 = parcelRequire("iSjV6");

var $iMdoL = parcelRequire("iMdoL");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $1BHKA = parcelRequire("1BHKA");

var $dLZRK = parcelRequire("dLZRK");

var $eZUFa = parcelRequire("eZUFa");

var $5wOn9 = parcelRequire("5wOn9");

var $c8uJK = parcelRequire("c8uJK");

var $jueTK = parcelRequire("jueTK");

var $gmOj8 = parcelRequire("gmOj8");
var $8d13ec49d1559c03$var$TRACKING_EVENT_NAMES;
(function(TRACKING_EVENT_NAMES) {
    TRACKING_EVENT_NAMES["loggedInHeroProductCtaClicked"] = "loggedInHeroProductCtaClicked";
    TRACKING_EVENT_NAMES["loggedInHeroAnotherSiteCtaClicked"] = "loggedInHeroAnotherSiteCtaClicked";
    TRACKING_EVENT_NAMES["loggedInHeroExploreFeaturesClicked"] = "loggedInHeroExploreFeaturesClicked";
    TRACKING_EVENT_NAMES["loggedInHeroCreateNewSiteClicked"] = "loggedInHeroCreateNewSiteClicked";
})($8d13ec49d1559c03$var$TRACKING_EVENT_NAMES || ($8d13ec49d1559c03$var$TRACKING_EVENT_NAMES = {}));
const $8d13ec49d1559c03$var$START_URL = "https://start.atlassian.com";
const $8d13ec49d1559c03$export$cbc42fadf8b93ea3 = {
    eventType: "ui",
    action: "clicked",
    actionSubject: "button",
    actionSubjectId: "loggedInHero",
    source: "/software/jira"
};
const $8d13ec49d1559c03$var$jswLoggedInCss = null;
const $8d13ec49d1559c03$var$heroSectionCss = null;
const $8d13ec49d1559c03$var$anchorContainer = null;
const $8d13ec49d1559c03$var$blueBackdrop = null;
const $8d13ec49d1559c03$var$jiraSiteBoxCss = null;
const $8d13ec49d1559c03$var$headingCss = null;
const $8d13ec49d1559c03$var$starCss = null;
const $8d13ec49d1559c03$var$treatmentStarCss = null;
const $8d13ec49d1559c03$var$differentSiteCss = null;
const $8d13ec49d1559c03$var$subHeadingContainerCss = null;
const $8d13ec49d1559c03$var$createNewSiteAnchorCss = null;
const $8d13ec49d1559c03$var$subHeadingCss = null;
const $8d13ec49d1559c03$var$exploreFeaturesContainerCss = null;
const $8d13ec49d1559c03$var$exploreFeaturesHeadingCss = null;
const $8d13ec49d1559c03$var$exploreFeaturesCtaCss = null;
const $8d13ec49d1559c03$var$nameUnderlineCss = null;
const $8d13ec49d1559c03$var$inlineJiraLogoCss = null;
const $8d13ec49d1559c03$var$siteInfoContainerCss = null;
const $8d13ec49d1559c03$var$sitenameIconCss = null;
const $8d13ec49d1559c03$var$sitenameIconTextCss = null;
const $8d13ec49d1559c03$var$sitenameAndAvatarContainerCss = null;
const $8d13ec49d1559c03$var$siteNameSpanCss = null;
const $8d13ec49d1559c03$var$tooltipWrapperCss = null;
const $8d13ec49d1559c03$var$avatarContainerCss = null;
const $8d13ec49d1559c03$var$linkPlaceholderCss = null; // eslint-disable-next-line complexity
const $8d13ec49d1559c03$export$49c6370202c57ed1 = ({ experimentValue: experimentValue })=>{
    var _user_name, _loggedInUserProfile_name, _jiraSitesFromAgg_jira_allJiraProjects_edges_, _jiraSitesFromAgg_jira, _jiraSitesFromAgg_jira1, _profile_attributes, _jiraSitesFromAgg_jira2, _profile_attributes1;
    const loggedInUserProfile = (0, $5wOn9.useLoggedInUser)();
    const { user: user, profile: profile } = (0, $iMdoL.useUserContext)();
    const { jiraSitesFromAgg: jiraSitesFromAgg } = (0, $jueTK.useJiraSitesContext)();
    const [teammateAvatars, setTeammateAvatars] = (0, $iSvIT.useState)([]);
    const isTreatment = experimentValue === "jfind-1506-after-d7-gubtp-organic";
    const intl = (0, $f6qj2.default)(); // Try to get name from props, and fallback to hook if needed
    var _user_name_split_;
    const userFirstName = (_user_name_split_ = (_user_name = user.name) === null || _user_name === void 0 ? void 0 : _user_name.split(" ")[0]) !== null && _user_name_split_ !== void 0 ? _user_name_split_ : (_loggedInUserProfile_name = loggedInUserProfile.name) === null || _loggedInUserProfile_name === void 0 ? void 0 : _loggedInUserProfile_name.split(" ")[0]; // Try to get picture from props, and fallback to hook if needed
    var _user_picture;
    const userPicture = (_user_picture = user === null || user === void 0 ? void 0 : user.picture) !== null && _user_picture !== void 0 ? _user_picture : loggedInUserProfile.picture;
    const avatars = jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : (_jiraSitesFromAgg_jira = jiraSitesFromAgg.jira) === null || _jiraSitesFromAgg_jira === void 0 ? void 0 : (_jiraSitesFromAgg_jira_allJiraProjects_edges_ = _jiraSitesFromAgg_jira.allJiraProjects.edges[0]) === null || _jiraSitesFromAgg_jira_allJiraProjects_edges_ === void 0 ? void 0 : _jiraSitesFromAgg_jira_allJiraProjects_edges_.node.assignableUsers.edges;
    (0, $iSvIT.useEffect)(()=>{
        var _jiraSitesFromAgg_jira_allJiraProjects_edges_, _jiraSitesFromAgg_jira;
        var _jiraSitesFromAgg_jira_allJiraProjects_edges__node_assignableUsers_edges_filter_map;
        setTeammateAvatars((_jiraSitesFromAgg_jira_allJiraProjects_edges__node_assignableUsers_edges_filter_map = jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : (_jiraSitesFromAgg_jira = jiraSitesFromAgg.jira) === null || _jiraSitesFromAgg_jira === void 0 ? void 0 : (_jiraSitesFromAgg_jira_allJiraProjects_edges_ = _jiraSitesFromAgg_jira.allJiraProjects.edges[0]) === null || _jiraSitesFromAgg_jira_allJiraProjects_edges_ === void 0 ? void 0 : _jiraSitesFromAgg_jira_allJiraProjects_edges_.node.assignableUsers.edges.filter((assignableUser)=>assignableUser.node.picture != userPicture && assignableUser.node.accountStatus === "active").map((assignableUser)=>{
            var _assignableUser_node_picture;
            return (_assignableUser_node_picture = assignableUser.node.picture) !== null && _assignableUser_node_picture !== void 0 ? _assignableUser_node_picture : "";
        })) !== null && _jiraSitesFromAgg_jira_allJiraProjects_edges__node_assignableUsers_edges_filter_map !== void 0 ? _jiraSitesFromAgg_jira_allJiraProjects_edges__node_assignableUsers_edges_filter_map : []);
    }, [
        avatars,
        jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : (_jiraSitesFromAgg_jira1 = jiraSitesFromAgg.jira) === null || _jiraSitesFromAgg_jira1 === void 0 ? void 0 : _jiraSitesFromAgg_jira1.allJiraProjects.edges,
        userPicture
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const localizedTryLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&createNew=true");
    const localizedProductGuideLink = (0, $3FBn4.useLocalizedHref)("/software/jira/guides/getting-started/introduction");
    const [hasMultipleJiras, setHasMultipleJiras] = (0, $iSvIT.useState)(false);
    const [siteName, setSiteName] = (0, $iSvIT.useState)("");
    const [siteInitials, setSiteInitials] = (0, $iSvIT.useState)("");
    (0, $iSvIT.useEffect)(()=>{
        var _profile_attributes, _availableJiraSites_;
        if (isTreatment) return;
        const availableJiraSites = (0, $eZUFa.filterAvailableJiraSites)((_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingSites); // Default state to whatever we might have got from SSR
        setHasMultipleJiras(availableJiraSites.length > 1);
        const siteNameFromAvailableJiraSites = ((_availableJiraSites_ = availableJiraSites[0]) === null || _availableJiraSites_ === void 0 ? void 0 : _availableJiraSites_.displayName) || "";
        setSiteName(siteNameFromAvailableJiraSites);
        setSiteInitials(siteNameFromAvailableJiraSites.slice(0, 1).toUpperCase() + siteNameFromAvailableJiraSites.slice(1, 2));
    }, [
        (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingSites,
        isTreatment
    ]);
    const [siteUrl, setSiteUrl] = (0, $iSvIT.useState)("");
    (0, $iSvIT.useEffect)(()=>{
        var _profile_attributes, _jiraSitesFromAgg_jira, _jiraSitesFromAgg_jira_allJiraProjects_edges_, _jiraSitesFromAgg_jira_allJiraProjects;
        if (isTreatment) return;
        if (!profile && !jiraSitesFromAgg) return;
        const siteFromUserProfile = profile === null || profile === void 0 ? void 0 : (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingSites[0];
        let projectUrl = siteFromUserProfile === null || siteFromUserProfile === void 0 ? void 0 : siteFromUserProfile.url;
        if ((jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : (_jiraSitesFromAgg_jira = jiraSitesFromAgg.jira) === null || _jiraSitesFromAgg_jira === void 0 ? void 0 : _jiraSitesFromAgg_jira.allJiraProjects.edges.length) === 1) projectUrl = (_jiraSitesFromAgg_jira_allJiraProjects = jiraSitesFromAgg.jira.allJiraProjects) === null || _jiraSitesFromAgg_jira_allJiraProjects === void 0 ? void 0 : (_jiraSitesFromAgg_jira_allJiraProjects_edges_ = _jiraSitesFromAgg_jira_allJiraProjects.edges[0]) === null || _jiraSitesFromAgg_jira_allJiraProjects_edges_ === void 0 ? void 0 : _jiraSitesFromAgg_jira_allJiraProjects_edges_.node.webUrl;
        setSiteUrl(projectUrl !== null && projectUrl !== void 0 ? projectUrl : "");
    }, [
        jiraSitesFromAgg,
        jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : (_jiraSitesFromAgg_jira2 = jiraSitesFromAgg.jira) === null || _jiraSitesFromAgg_jira2 === void 0 ? void 0 : _jiraSitesFromAgg_jira2.allJiraProjects.edges,
        profile,
        profile === null || profile === void 0 ? void 0 : (_profile_attributes1 = profile.attributes) === null || _profile_attributes1 === void 0 ? void 0 : _profile_attributes1.existingSites,
        isTreatment
    ]);
    const { hasMultipleJiras: mostRecentHasMultipleJiras, siteName: mostRecentSiteName, siteUrl: mostRecentSiteUrl, siteInitials: mostRecentSiteInitials } = (0, $eZUFa.useRecentJiraSite)();
    (0, $iSvIT.useEffect)(()=>{
        if (!isTreatment) return;
        setHasMultipleJiras(mostRecentHasMultipleJiras);
        setSiteName(mostRecentSiteName);
        setSiteUrl(mostRecentSiteUrl);
        setSiteInitials(mostRecentSiteInitials);
    }, [
        isTreatment,
        mostRecentHasMultipleJiras,
        mostRecentSiteInitials,
        mostRecentSiteName,
        mostRecentSiteUrl
    ]);
    const loggedInHeroLoadedAnalyticsPayload = {
        eventType: "ui",
        action: "loaded",
        actionSubject: "component",
        actionSubjectId: "loggedInHero",
        source: "/software/jira",
        attributes: {
            atlasId: (0, $gmOj8.getAtlasTicket)(experimentValue)
        }
    };
    (0, $iSvIT.useEffect)(()=>{
        //if client side, fire analytics event
        if (typeof window !== "undefined") createAnalyticsEvent((0, $7Knp0._)({}, loggedInHeroLoadedAnalyticsPayload)).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const clickHandler = (eventName)=>{
        createAnalyticsEvent((0, $6iHNw._)((0, $7Knp0._)({}, $8d13ec49d1559c03$export$cbc42fadf8b93ea3), {
            attributes: {
                eventName: eventName,
                url: window.location.href,
                atlasId: (0, $gmOj8.getAtlasTicket)(experimentValue)
            }
        })).fire();
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _11q71ybm _12vemgnk _1lrw1dfr _1e0c11p5 _yv0ehkll _4cvr1h6o _6a6z1h6o _18zr53f4 _1q5110yn _85i512am _1bsb1osq _1bhl10yn"
        ]),
        style: {
            "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_kqswh2mm _syaz1hlo _1bsb1osq _p12fk3xj _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf _s51sidpf"
            ]),
            style: {
                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
            },
            children: [
                isTreatment ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_t9ecuuzf _kqswstnw _1e0c1o8l _u7co1w81 _1e021vgi _1mjbglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: {
                            width: 88,
                            height: 70,
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/g06k378gucflnfse7s88i0365h14j40v.webp",
                            alt: "hand-drawn stars"
                        }
                    })
                }) : /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswstnw _1e0c1o8l _u7co53f4 _1e02r8pp _t9ecn2ni _1mjbglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: {
                            width: 88,
                            height: 70,
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/g06k378gucflnfse7s88i0365h14j40v.webp",
                            alt: "hand-drawn stars"
                        }
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                    className: (0, $esG4f.default)([
                        "_1wybckbl _vwz48vuz _k48p9y44 _ect41pz4 _6rtho7ao _bozgidpf _so7dldb6 _19q11ylp"
                    ]),
                    style: {
                        "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                    },
                    children: userFirstName ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBackWithName",
                        defaultMessage: `Welcome back, {name}.`,
                        values: {
                            name: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                className: (0, $esG4f.default)([
                                    "_zg8l4jg8 _kqswh2mm _3p6m1sr6 _1v5vmgnk _14rnhyuj _19h91f51 _aetrb3bt _1qdggktf _1gufd439 _1czd12gs _g0nfmyb0 _18postnw _14tt14id _1ruvyjp0"
                                ]),
                                style: {
                                    "--_1f8eaoq": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.yellow400"))
                                },
                                children: userFirstName
                            })
                        }
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBack",
                        defaultMessage: "Welcome back"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1n261g80 _gy1p53f4 _1bah1yb4 _4cvr1q9y"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_ect4bzd7 _1wybgktf _vwz41f4h _k48p1nn1"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraSoftwarePageTemplate.loggedInHero.pickUpWhereYouLeftOffInProduct",
                                defaultMessage: "Pick up where you left off in <span>{product}</span>",
                                values: {
                                    product: "Jira",
                                    span: (text)=>/*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                    className: (0, $esG4f.default)([
                                                        "_1e0c1o8l _t9ec1jia _kqswh2mm _152tdlk8 _195g14id"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1BHKA.JiraMarkBrand), {})
                                                }),
                                                text
                                            ]
                                        })
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            "data-testid": "createNewSiteAnchor",
                            href: localizedTryLink,
                            onClick: ()=>clickHandler("loggedInHeroCreateNewSiteClicked"),
                            className: (0, $esG4f.default)([
                                "_ect4bzd7 _1wyb7vkz _k48pni7l _vwz41f4h _syazjk2v"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                                "--_1b67llw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue700"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "WacSignupForm.createNewSite",
                                defaultMessage: "Create a new site"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswh2mm _16jlkb7n _1wpz1fhb"
                    ]),
                    children: [
                        !isTreatment && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_kqswstnw _152tx19p _rjxp1fm0 _1bsb13sl _4t3i1osq _bfhkjk2v"
                            ]),
                            style: {
                                "--_1b67llw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue700"))
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_bfhkcd5j _2rko1y44 _1bsb1osq _1ul91mjv _1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _19it1wcj _1rjc7vkz _18zr7vkz _1mougktf _kqswh2mm"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $c8uJK.JiraSiteContainer), {
                                isTreatment: isTreatment,
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c1txw _2lx2vrvc _4cvr1h6o _4t3ivbgk _zulppxbi"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_11q7ihgv _2rko1b66 _1e0c1txw _1bah1h6o _4cvr1h6o _4t3ivbgk _1bsbvbgk _1ul9vbgk"
                                                ]),
                                                style: {
                                                    "--_1efrnav": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.lime300"))
                                                },
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                                                    className: (0, $esG4f.default)([
                                                        "_syaz5wis _ect41pz4 _1wyb1ejb _k48pni7l _vwz41f4h _1dyznl7k _y3gn1h6o"
                                                    ]),
                                                    style: {
                                                        "--_1yoj5ey": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.lime800")),
                                                        "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                                                    },
                                                    children: siteInitials
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_1e0c1txw _2lx21bp4 _1bah1h6o _zulp19bv _kqswh2mm _4t3ivbgk"
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                        className: (0, $esG4f.default)([
                                                            "_4t3igktf"
                                                        ]),
                                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSjV6.default), {
                                                            content: siteName,
                                                            position: "top-end",
                                                            mousePosition: "top",
                                                            tag: "span",
                                                            children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                                className: (0, $esG4f.default)([
                                                                    "_ect4bzd7 _1wybgktf _k48p1fw0 _4t3igktf _vwz41j6v _y3gn1e5h _1bto1l2s _o5721q9c _1reo15vq _18m915vq _1e0c1o8l _s7n4jp4b _uhd0uuw1 _1tssl1r9"
                                                                ]),
                                                                style: {
                                                                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                                                },
                                                                children: siteName
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                        className: (0, $esG4f.default)([
                                                            "_4t3i1tcg _uhd0uuw1 _1tssl1r9"
                                                        ]),
                                                        children: userPicture && /*#__PURE__*/ (0, $loA2J.jsx)((0, $dLZRK.AvatarFacepile), {
                                                            max: 4,
                                                            iconSize: 24,
                                                            icons: [
                                                                userPicture,
                                                                ...teammateAvatars
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $kZKty.Adg4Button), {
                                        "data-testid": "goToJiraButton",
                                        variant: "primary",
                                        color: "yellow",
                                        href: siteUrl,
                                        size: "small",
                                        onClick: ()=>clickHandler("loggedInHeroProductCtaClicked"),
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                            id: "JiraSoftwarePageTemplate.loggedInHero.goToJira",
                                            defaultMessage: "Go to Jira"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                hasMultipleJiras ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_ect4bzd7 _1pfho7ao _1wybdlk8 _k48p1nn1 _gu181h6o"
                    ]),
                    style: {
                        "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        text: intl.formatMessage({
                            id: "ConfluenceSoftwarePageTemplate.loggedInHero.lookingForDifferentSite",
                            defaultMessage: "Looking for a different site?"
                        }),
                        href: $8d13ec49d1559c03$var$START_URL,
                        type: "primary",
                        onClick: ()=>clickHandler("loggedInHeroAnotherSiteCtaClicked")
                    })
                }) : /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_4t3iqslr"
                    ])
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1pfhvbgk _1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_ect4bzd7 _1wybgktf _vwz41f4h _k48p1nn1 _6rth7vkz"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraSoftwarePageTemplate.loggedInHero.findOutMore",
                                defaultMessage: "Want to find out more about Jira?"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            "data-testid": "exploreFeaturesAnchor",
                            href: localizedProductGuideLink,
                            onClick: ()=>clickHandler("loggedInHeroExploreFeaturesClicked"),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                className: (0, $esG4f.default)([
                                    "_ect4bzd7 _1wyb7vkz _k48pni7l _11q7glyw _r06hglyw _2rko1ul9 _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _19it1axk _80omtlke"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                },
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "jira-product-tour.staggered-double-feature-section.first-feature-link-text",
                                    defaultMessage: "Explore features"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$8d13ec49d1559c03$export$49c6370202c57ed1.displayName = "LoggedInHeroSection";
var $8d13ec49d1559c03$export$2e2bcd8739ae039 = $8d13ec49d1559c03$export$49c6370202c57ed1;

});
parcelRegister("gmOj8", function(module, exports) {

$parcel$export(module.exports, "getAtlasTicket", function () { return $c7ba16a897c24552$export$6f77dd305013b9bd; });
const $c7ba16a897c24552$export$6f77dd305013b9bd = (experimentValue)=>{
    if (experimentValue === "jfind-1506-after-d7-gubtp-organic") return "ATLAS-93656";
    else return "ATLAS-76385";
};

});


parcelRegister("64WOd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b96c356aea16fdce$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $iMdoL = parcelRequire("iMdoL");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $gAJUc = parcelRequire("gAJUc");

var $jueTK = parcelRequire("jueTK");
const $b96c356aea16fdce$var$JiraLogo = ()=>{
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV2), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    });
};
const $b96c356aea16fdce$var$SoftwareJiraLoggedInNavbar = ()=>{
    var _profile_attributes, _profile_attributes1;
    const intl = (0, $f6qj2.default)();
    const logoUrl = (0, $3FBn4.useLocalizedHref)("/software/jira");
    const { profile: profile } = (0, $iMdoL.useUserContext)();
    const { jiraSitesFromAgg: jiraSitesFromAgg } = (0, $jueTK.useJiraSitesContext)();
    const [siteUrl, setSiteUrl] = (0, $iSvIT.useState)("");
    (0, $iSvIT.useEffect)(()=>{
        var _profile_attributes, _jiraSitesFromAgg_jira_allJiraProjects_edges__node, _jiraSitesFromAgg_jira_allJiraProjects_edges_, _jiraSitesFromAgg_jira_allJiraProjects;
        const site = profile === null || profile === void 0 ? void 0 : (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingSites[0];
        let tempSiteUrl = site === null || site === void 0 ? void 0 : site.url;
        if ((jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : jiraSitesFromAgg.jira.allJiraProjects.edges.length) === 1) tempSiteUrl = jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : (_jiraSitesFromAgg_jira_allJiraProjects = jiraSitesFromAgg.jira.allJiraProjects) === null || _jiraSitesFromAgg_jira_allJiraProjects === void 0 ? void 0 : (_jiraSitesFromAgg_jira_allJiraProjects_edges_ = _jiraSitesFromAgg_jira_allJiraProjects.edges[0]) === null || _jiraSitesFromAgg_jira_allJiraProjects_edges_ === void 0 ? void 0 : (_jiraSitesFromAgg_jira_allJiraProjects_edges__node = _jiraSitesFromAgg_jira_allJiraProjects_edges_.node) === null || _jiraSitesFromAgg_jira_allJiraProjects_edges__node === void 0 ? void 0 : _jiraSitesFromAgg_jira_allJiraProjects_edges__node.webUrl;
        setSiteUrl(tempSiteUrl !== null && tempSiteUrl !== void 0 ? tempSiteUrl : "");
    }, [
        jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : jiraSitesFromAgg.jira.allJiraProjects.edges,
        jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : jiraSitesFromAgg.jira.allJiraProjects.edges.length,
        profile === null || profile === void 0 ? void 0 : (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingSites,
        profile === null || profile === void 0 ? void 0 : (_profile_attributes1 = profile.attributes) === null || _profile_attributes1 === void 0 ? void 0 : _profile_attributes1.existingSites.length
    ]);
    const goToLoggedInJira = ()=>{
        window.location.assign(siteUrl);
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
        productLogoUrl: logoUrl,
        productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($b96c356aea16fdce$var$JiraLogo, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: "wacJiraSoftwareNavigation.logo-label",
            defaultMessage: "Jira Software logo"
        }),
        mobileCtaText: intl.formatMessage({
            id: "JiraSoftwarePageTemplate.navbar.goToJira",
            defaultMessage: "Go to Jira"
        }),
        mobileCtaOnClick: goToLoggedInJira,
        mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($b96c356aea16fdce$var$JiraLogo, {}),
        navigationTrynowCtaText: intl.formatMessage({
            id: "JiraFeatureSoftwarePageTemplate.navbar.goToJira",
            defaultMessage: "Go to Jira"
        }),
        navigationTrynowCtaOnClick: goToLoggedInJira,
        productPageNavLinks: [],
        mobileLinksSections: [],
        isShowSearchButton: false,
        isShowAppSwitcher: false,
        isShowTabletDropdown: false
    });
};
var $b96c356aea16fdce$export$2e2bcd8739ae039 = $b96c356aea16fdce$var$SoftwareJiraLoggedInNavbar;

});



parcelRegister("75UBa", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswAgile", function () { return $5d7ab028fcf7aa6b$export$914726d7f0b742d9; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $4xemF = parcelRequire("4xemF");
const $5d7ab028fcf7aa6b$export$914726d7f0b742d9 = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4xemF.JiraSoftwarePagePaidLpJswAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-agile",
        persona: "unknown",
        pageVariant: "agile"
    }));
};

});

parcelRegister("6OWgV", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswAutomation", function () { return $9149254db5027355$export$ed27212f6342eeed; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $4xemF = parcelRequire("4xemF");
const $9149254db5027355$export$ed27212f6342eeed = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4xemF.JiraSoftwarePagePaidLpJswAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-automation",
        persona: "unknown",
        pageVariant: "automation"
    }));
};

});

parcelRegister("8rgnW", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswCompetitors", function () { return $a494ef26b6aa6a41$export$68f655f873e2ac04; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $4xemF = parcelRequire("4xemF");
const $a494ef26b6aa6a41$export$68f655f873e2ac04 = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4xemF.JiraSoftwarePagePaidLpJswAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-competitors",
        persona: "unknown",
        pageVariant: "competitors"
    }));
};

});

parcelRegister("3l68c", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswFeatures", function () { return $93344dcb75a36ae1$export$6ab6d2db3208c01b; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $fa3cB = parcelRequire("fa3cB");
parcelRequire("D0EyQ");
var $g8Gdb = parcelRequire("g8Gdb");

var $1Yyys = parcelRequire("1Yyys");

var $3fquc = parcelRequire("3fquc");

var $gyzLx = parcelRequire("gyzLx");

var $6JN6z = parcelRequire("6JN6z");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");

var $4xemF = parcelRequire("4xemF");
const $93344dcb75a36ae1$export$6ab6d2db3208c01b = ({ keyword: keyword })=>{
    const intl = (0, $f6qj2.default)();
    const productHref = (0, $3FBn4.useLocalizedHref)("/software/jira");
    const isW2AndAfterOrHasMultipleJiras = (0, $iMdoL.useJiraW2AndAfterOrMultipleJiras)();
    const ctaButtonPropsHref = (0, $3FBn4.useLocalizedHref)("#start-trial");
    const pageId = "paid-lp-jsw-features";
    const jiraD0to6Site = (0, $iMdoL.useProductD0to6Site)({
        productKey: (0, $jgJpJ.ProductKey).JIRA_SOFTWARE
    });
    const jfind1504ExperimentCheck = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).jfind1504AfterD7GetPaidUsersBackToProduct);
    const jfind1504AfterD7GetPaidUsersBackToProduct = jfind1504ExperimentCheck.type === "enrolled" && jfind1504ExperimentCheck.value;
    if (isW2AndAfterOrHasMultipleJiras && jfind1504ExperimentCheck.type === "enrolled") jfind1504ExperimentCheck.fireExposure();
    const paidLoggedOutHeroSection = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1Yyys.PaidTeamSelectionHeroSection), {
        keyword: keyword
    });
    const isPaidLoggedInJiraProductTourEligible = (0, $4xemF.useCheckPaidD0to6LoggedInJiraProductTourEligibility)("paid-lp-jsw-features");
    const gwpAJContextualBanditsJiraExperiment = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).gwpAJContextualBanditsJira);
    const isExperimentEnabled = gwpAJContextualBanditsJiraExperiment.type === "enrolled" && gwpAJContextualBanditsJiraExperiment.value;
    const props = {
        hideNavigationBar: false,
        customHeroSection: paidLoggedOutHeroSection,
        landingType: "jira-software",
        pageId: pageId,
        productNavProps: {
            productHref: productHref,
            productName: "jira",
            ariaLabel: intl.formatMessage({
                id: "wacJiraSoftwareNavigation.logo-label",
                defaultMessage: "Jira Software logo"
            }),
            dataProductKey: "jiraSoftware",
            showFreeHrefButton: false,
            logoLinkWrapperWidth: "auto"
        },
        heroProps: {
            headerText: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.hero.header",
                defaultMessage: "Connect every team, task, and project together with Jira"
            }),
            secondaryText: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.hero.body",
                defaultMessage: "Trusted by 100K+ teams that plan, track, release, and manage world-class software."
            }),
            tertiaryText: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.heroListHeading",
                defaultMessage: "INCLUDED IN YOUR FREE PLAN: Forever free for up to 10 users"
            }),
            image: {
                src: (0, $fa3cB.getLocalizedImage)("hero", intl.locale),
                alt: intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeatures.heroImageAlt",
                    defaultMessage: "Screen capture of a Jira backlog"
                }),
                width: 1134,
                height: 620
            },
            signup: {
                bundle: "jira-software",
                edition: "free",
                featureFlags: {
                    enableDefaultExpandedEmail: false,
                    enableDeferredFullName: true
                }
            }
        },
        tabsProps: {
            dataProductKey: "jiraSoftware-PaidLpJiraFeatures",
            headerText: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.tabs.heading",
                defaultMessage: "Discover the features that make Jira so easy to use"
            }),
            tabStyles: {
                defaultBG: (0, $5ohHq.wacToken)("color.neutral.light0"),
                defaultText: (0, $5ohHq.wacToken)("color.extended.blue1000"),
                hoverBG: (0, $5ohHq.wacToken)("color.neutral.light0"),
                hoverText: (0, $5ohHq.wacToken)("color.extended.blue1000"),
                activeBG: (0, $5ohHq.wacToken)("color.extended.blue200"),
                activeText: (0, $5ohHq.wacToken)("color.extended.blue1000")
            },
            styles: {
                "--lp-tabs-hover": (0, $5ohHq.wacToken)("color.extended.blue200"),
                "--lp-tabs-unselected": (0, $5ohHq.wacToken)("color.neutral.light700")
            },
            tabs: [
                {
                    textLabel: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab1.textLabel",
                        defaultMessage: "Boards"
                    }),
                    id: "boards",
                    component: $93344dcb75a36ae1$var$Boards()
                },
                {
                    textLabel: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab2.textLabel",
                        defaultMessage: "Timeline"
                    }),
                    id: "timeline",
                    component: $93344dcb75a36ae1$var$Timeline()
                },
                {
                    textLabel: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab3.textLabel",
                        defaultMessage: "Reports"
                    }),
                    id: "reports",
                    component: $93344dcb75a36ae1$var$Reports()
                },
                {
                    textLabel: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.textLabel",
                        defaultMessage: "Automation"
                    }),
                    id: "automation",
                    component: $93344dcb75a36ae1$var$Automation()
                }
            ]
        },
        ctaProps: {
            headerText: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.ctaSection.header",
                defaultMessage: "Move fast, stay aligned, and build better - together"
            }),
            ctaProps: {
                buttonProps: {
                    color: "yellow",
                    url: ctaButtonPropsHref,
                    text: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeatures.ctaSection.button",
                        defaultMessage: "Get it free"
                    }),
                    dataEventProps: {
                        "data-event": "clicked",
                        "data-event-container": "ctaSection",
                        "data-event-component": "linkButton",
                        "data-product-key": "jiraSoftware-PaidLpJiraFeatures"
                    }
                }
            },
            backgroundProperties: {
                textColor: (0, $5ohHq.wacToken)("color.neutral.light0")
            }
        },
        testimonialProps: {
            headerText: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.socialProof.heading",
                defaultMessage: "Trusted by over 100,000 customers world-wide"
            }),
            logos: [
                {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5382nib232306760cxko3fu33yr03hc6.svg",
                    alt: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeatures.socialProof.squareAlt",
                        defaultMessage: "Square logo"
                    }),
                    loading: "lazy",
                    width: 162,
                    height: 40
                },
                {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8sh6x4kh58c7576am3gc70215abr77gu.svg",
                    alt: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeatures.socialProof.ebayAlt",
                        defaultMessage: "eBay logo"
                    }),
                    loading: "lazy",
                    width: 99,
                    height: 41
                },
                {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/7l40fo7ky3ck1752eh0ti31556343388.svg",
                    alt: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeatures.socialProof.spotifyAlt",
                        defaultMessage: "Spotify logo"
                    }),
                    loading: "lazy",
                    width: 163,
                    height: 49
                },
                {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/0atd5rxku6yg42wfhx0b1jdrsusm532i.svg",
                    alt: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeatures.socialProof.ciscoAlt",
                        defaultMessage: "Cisco logo"
                    }),
                    loading: "lazy",
                    width: 92,
                    height: 49
                }
            ]
        },
        alternatingTextAndImageProps: {
            backgroundImage: `linear-gradient(225deg, ${(0, $5ohHq.wacToken)("color.extended.blue200")} 0%, ${(0, $5ohHq.wacToken)("color.neutral.light0")} 100%)`,
            horizontalRuleColor: (0, $5ohHq.wacToken)("color.extended.blue200"),
            imageWidth: "100%",
            imageTextSideRowOnePaddingBelowLargeScreen: "32px 0 16px",
            imageTextSideRowTwoPadding: "16px 0",
            imageTextSideRowThreePaddingBelowLargeScreen: "16px 0 32px",
            //Row 1
            rowOneHeader: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowOneHeader",
                defaultMessage: "Customize how your team\u2019s work flows"
            }),
            rowOneBody: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowOneBody",
                defaultMessage: "Set up, clean up, and automate even the most complicated project workflows."
            }),
            rowOneImageLink: (0, $fa3cB.getLocalizedImage)("row one", intl.locale),
            rowOneImageAltText: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowOneImageAltText",
                defaultMessage: "Jira boards"
            }),
            //Row 2
            rowTwoHeader: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.secondTextHeader",
                defaultMessage: "Stay on track \u2013 even when the track changes"
            }),
            rowTwoBody: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.secondTextBody",
                defaultMessage: "Use the timeline view to map out the big picture, communicate updates to stakeholders, and ensure your team stays on the same page."
            }),
            rowTwoImageLink: (0, $fa3cB.getLocalizedImage)("row two", intl.locale),
            rowTwoImageAltText: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowTwoImageAltText",
                defaultMessage: "Jira timeline view."
            }),
            //Row 3
            rowThreeHeader: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowThreeHeader",
                defaultMessage: "Bye-bye, spreadsheets"
            }),
            rowThreeBody: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowThreeBody",
                defaultMessage: "Keep every detail of a project centralized in real time so up-to-date info can flow freely across people, teams, and tools."
            }),
            rowThreeImageLink: (0, $fa3cB.getLocalizedImage)("row three", intl.locale),
            rowThreeImageAltText: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowThreeImageAltText",
                defaultMessage: "Spreadsheets"
            })
        }
    };
    return jiraD0to6Site && isPaidLoggedInJiraProductTourEligible ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "jfind-get-d1to6-users-back-to-product-for-paid",
        group: "variant",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
            experimentKey: "jfind-981-paid-jpto-logged-in-redesign",
            group: "Test",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gyzLx.PaidD0to6LoggedInJiraProductTourOverview), {})
        })
    }) : isW2AndAfterOrHasMultipleJiras && jfind1504AfterD7GetPaidUsersBackToProduct ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $gyzLx.PaidD0to6LoggedInJiraProductTourOverview), {
        experimentValue: "jfind-1504-after-d7-get-users-back-to-product"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $6JN6z.BanditsProvider), {
        product: "jira",
        isExperimentEnabled: isExperimentEnabled,
        keyword: keyword,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3fquc.PaidLandingTemplate), (0, $7Knp0._)({}, props))
    });
};
/* Tabs */ const $93344dcb75a36ae1$var$Boards = ()=>{
    const intl = (0, $f6qj2.default)();
    const title = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab1.heading",
        defaultMessage: "Powerful agile boards"
    });
    const listItems = [
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab1.item1",
            values: (0, $3FBn4.DEFAULT_VALUES),
            defaultMessage: "<strong>Scrum boards:</strong> Scrum boards help agile teams break large, complex projects into manageable pieces of work so focused teams ship faster."
        }, "tabs.tab1.item1"),
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab1.item2",
            values: (0, $3FBn4.DEFAULT_VALUES),
            defaultMessage: "<strong>Kanban boards:</strong> Agile and DevOps teams can use flexible kanban boards to visualize workflows, limit work-in-progress, and maximize efficiency as a team. Templates make it easy to get started quickly and customize as you go."
        }, "tabs.tab1.item2"),
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab1.item3",
            values: (0, $3FBn4.DEFAULT_VALUES),
            defaultMessage: "<strong>Choose your own adventure:</strong> Jira is flexible enough to mold to your team\u2019s own unique way of working, whether it is Scrum, Kanban, or something in between."
        }, "tabs.tab1.item3")
    ];
    const imageSrc = (0, $fa3cB.getLocalizedImage)("boards", intl.locale);
    const imageAlt = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab1.imageAlt",
        defaultMessage: "Jira boards"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g8Gdb.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $93344dcb75a36ae1$var$Timeline = ()=>{
    const intl = (0, $f6qj2.default)();
    const title = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab2.heading",
        defaultMessage: "Timeline"
    });
    const listItems = [
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab2.item1",
            values: (0, $3FBn4.DEFAULT_VALUES),
            defaultMessage: "<strong>Keep teams aligned:</strong> Give your team the visibility they need to make fast and informed decisions while staying aligned with the bigger goals."
        }, "tabs.tab2.item1"),
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab2.item2",
            values: (0, $3FBn4.DEFAULT_VALUES),
            defaultMessage: "<strong>Track the big picture:</strong> Plan and track how you\u2019re making progress on the big picture for a single team."
        }, "tabs.tab2.item2"),
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab2.item3",
            values: (0, $3FBn4.DEFAULT_VALUES),
            defaultMessage: "<strong>Get ahead of dependencies:</strong> Visualize dependencies within your team to account for them when making plans."
        }, "tabs.tab2.item3"),
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab2.item4",
            values: (0, $3FBn4.DEFAULT_VALUES),
            defaultMessage: "<strong>Plan with team capacity in mind (Premium only):</strong> Ensure your teams have bandwidth to complete the work they\u2019ve scoped. See multiple teams' capacity on a sprint-by-sprint basis."
        }, "tabs.tab2.item4")
    ];
    const imageSrc = (0, $fa3cB.getLocalizedImage)("timeline", intl.locale);
    const imageAlt = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab2.imageAlt",
        defaultMessage: "Jira timeline"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g8Gdb.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $93344dcb75a36ae1$var$Reports = ()=>{
    const intl = (0, $f6qj2.default)();
    const title = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab3.heading",
        defaultMessage: "Reports and insights"
    });
    const listItems = [
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab3.item1",
            values: (0, $3FBn4.DEFAULT_VALUES),
            defaultMessage: "<strong>Ready to go reporting:</strong> Out-of-the-box reports and dashboards in Jira offer critical insights within the context of your work to ensure your teams are always up to date and set up for success."
        }, "tabs.tab3.item1"),
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab3.item2",
            values: (0, $3FBn4.DEFAULT_VALUES),
            defaultMessage: "<strong>Sprint reporting:</strong> Determine where your team is overcommitted to reduce excessive scope creep and better understand completed work in each sprint."
        }, "tabs.tab3.item2"),
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab3.item3",
            values: (0, $3FBn4.DEFAULT_VALUES),
            defaultMessage: "<strong>Burndown chart:</strong> Track work towards sprint goals to manage progress and respond accordingly."
        }, "tabs.tab3.item3"),
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab3.item4",
            values: (0, $3FBn4.DEFAULT_VALUES),
            defaultMessage: "<strong>Release Burndown:</strong> Track and monitor the projected release date for versions and take action if work is falling behind schedule."
        }, "tabs.tab3.item4")
    ];
    const imageSrc = (0, $fa3cB.getLocalizedImage)("reports", intl.locale);
    const imageAlt = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab3.imageAlt",
        defaultMessage: "Jira reports"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g8Gdb.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $93344dcb75a36ae1$var$Automation = ()=>{
    const intl = (0, $f6qj2.default)();
    const title = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.heading",
        defaultMessage: "Automation"
    });
    const listItems = [
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.item1",
            values: (0, $3FBn4.DEFAULT_VALUES),
            defaultMessage: "<strong>Drag and drop automation:</strong> Focus on the important things. Let automation do the rest. Powerful, yet simple - Jira automation is actually fun to use."
        }, "tabs.tab4.item1"),
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.item2",
            values: (0, $3FBn4.DEFAULT_VALUES),
            defaultMessage: "<strong>Auto-assign issues:</strong> When an issue is raised without an assignee, auto-assign to whoever created it so nothing falls through the cracks."
        }, "tabs.tab4.item2"),
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.item3",
            values: (0, $3FBn4.DEFAULT_VALUES),
            defaultMessage: "<strong>Sync work:</strong> When an epic is marked as \u2018done\u2019 move all of its stories to \u2018done\u2019 also."
        }, "tabs.tab4.item3"),
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.item4",
            values: (0, $3FBn4.DEFAULT_VALUES),
            defaultMessage: "<strong>Daily Slack summary:</strong> Send a daily Slack message with a list of issues still open in the Sprint."
        }, "tabs.tab4.item4"),
        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.item5",
            values: (0, $3FBn4.DEFAULT_VALUES),
            defaultMessage: "<strong>Auto-close old support issues:</strong> If a customer has not responded to an issue in 5 days, close the issue and leave a comment."
        }, "tabs.tab4.item5")
    ];
    const imageSrc = (0, $fa3cB.getLocalizedImage)("automation", intl.locale);
    const imageAlt = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.imageAlt",
        defaultMessage: "Jira automation"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g8Gdb.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};

});
parcelRegister("fa3cB", function(module, exports) {

$parcel$export(module.exports, "getLocalizedImage", function () { return $344bf9f5cb8d6a91$export$df12673c228208c7; });
// no localized image for es, ru
const $344bf9f5cb8d6a91$var$heroSectionImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/t1hdrv58771uc7a1caq48j2vup58nuxq.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/i138n0173hw3vplo38724k74w12fhljw.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/7x1v3q2bn02e0r18p1c3p220orkcaa53.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/a6exiwjuxdt5yt737r34jm8r0qwgx5a1.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/4krne7la727rr2uo447m5y6dcutb5468.webp"
};
// no localized image for es, ru
const $344bf9f5cb8d6a91$var$tabsSectionAutomationImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/nhaj8o1l28kge001xo7746ov4nc72005.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/aw3e6hgl68r6v7mk0u4yw40xrk18kln0.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/j4dl52d0b2e8yn2s8tl0b34f2d0vwi1l.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/wf5834oq338l44v8yfrhf0s1q27g7kho.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/4ak0a2801n26ls3f2kr37x6s7di8g435.webp"
};
// no localized image for es, ru
const $344bf9f5cb8d6a91$var$tabsSectionBoardsImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/vsxtbk6nixxgyw7s86d2422h33183666.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/8qyaj2s5n36ouwe8sw77d040776w2un2.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/ei3ltwf7858ltw6l48670u8j6ews56bw.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/737g80fw6ml20lr326ccpphj50d7xex2.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/1y3cs512486c3a2t7u112yui0nl1l6a1.webp"
};
// no localized image for es, ru
const $344bf9f5cb8d6a91$var$tabsSectionReportsImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/670r88uhf63s523y62bq4p6r27cwo21h.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/8hf8r6r78ma46c3tkah540710e506k0g.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/c341bo7s5q43xhtyeosj20utoa62j4gf.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/t7du15rcv88p3epa4n0r63n1733rb7oe.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/07cpm5tqamy4s567700fk6qyu1w1f3q8.webp"
};
// no localized image for es, ru
const $344bf9f5cb8d6a91$var$tabsSectionTimelineImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/6i83t23511sqleh83338b6c3qdw3u5hy.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/78h0t1uh08qm08j78kyq1832060nsi2q.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/6nr6005kc5m6a0b5cu54862y667s561b.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/081fa55814t01f42l608c6v4rd4706yb.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/42f2e8u6c3g3fyq20k1lg6n6i08y3cr6.webp"
};
// no localized image for es, ru
const $344bf9f5cb8d6a91$var$rowOneImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/vsxtbk6nixxgyw7s86d2422h33183666.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/8qyaj2s5n36ouwe8sw77d040776w2un2.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/ei3ltwf7858ltw6l48670u8j6ews56bw.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/737g80fw6ml20lr326ccpphj50d7xex2.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/1y3cs512486c3a2t7u112yui0nl1l6a1.webp"
};
// no localized image for es, ru
const $344bf9f5cb8d6a91$var$rowTwoImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/1y066woqlgoe2430346q7c2r3pry10tb.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/l3yqms82gf6nyi141b7868v547mtk755.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/74u3u60n631kp01p67wlg211ml0ue676.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/03ww8q35s1o815s41383u0eye53o18ib.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/1wo8sdr62p0we8736414nximtscv142r.webp"
};
// no localized image for es, ru
const $344bf9f5cb8d6a91$var$rowThreeImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/7o3775x22n2c5yxfb7l5g0v3ye568v0s.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/5wp1j5x50y0ppby1t1r16qsy54231h15.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/46o4s1jbv7733e4qv2723p4n0m274g84.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/2oh1ay3ar5u0q28ey78w3e7iqsj5i5r1.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/0k071g3m4h17ng7s54bw0vm37qxf3g7f.webp"
};
const $344bf9f5cb8d6a91$var$getCorrespondingImageMap = (descriptor)=>{
    switch(descriptor){
        case "automation":
            return $344bf9f5cb8d6a91$var$tabsSectionAutomationImageMap;
        case "boards":
            return $344bf9f5cb8d6a91$var$tabsSectionBoardsImageMap;
        case "hero":
            return $344bf9f5cb8d6a91$var$heroSectionImageMap;
        case "reports":
            return $344bf9f5cb8d6a91$var$tabsSectionReportsImageMap;
        case "timeline":
            return $344bf9f5cb8d6a91$var$tabsSectionTimelineImageMap;
        case "row one":
            return $344bf9f5cb8d6a91$var$rowOneImageMap;
        case "row two":
            return $344bf9f5cb8d6a91$var$rowTwoImageMap;
        case "row three":
            return $344bf9f5cb8d6a91$var$rowThreeImageMap;
        default:
            throw new Error(`Unknown descriptor: ${descriptor}`);
    }
};
const $344bf9f5cb8d6a91$export$df12673c228208c7 = (descriptor, locale)=>{
    const map = $344bf9f5cb8d6a91$var$getCorrespondingImageMap(descriptor);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return map[locale] || map["en"];
};

});

parcelRegister("1Yyys", function(module, exports) {

$parcel$export(module.exports, "PaidTeamSelectionHeroSection", function () { return $0099352c27e86498$export$dbb9d3849f125826; });
/* paid-hero-section-team-selection-variant.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $cutM5 = parcelRequire("cutM5");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $k4Qty = parcelRequire("k4Qty");

var $8lIPu = parcelRequire("8lIPu");
const $0099352c27e86498$var$iconWrapperStyle = null;
const $0099352c27e86498$var$buttonDefaultStyles = null;
const $0099352c27e86498$var$iconHoverStyles = null; // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0099352c27e86498$var$buttonStyles = {
    sm: "_1bsb16xz",
    md: "_1bsb1et3",
    lg: "_1bsb68cl",
    xl: "_1bsb68cl"
};
const $0099352c27e86498$var$selectedStyles = null; // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0099352c27e86498$var$iconWrapperStyleMap = {
    sm: "_4t3i10mc _1bsb10mc _ca0q19bv _u5f319bv _n3td19bv _19bv19bv",
    md: "_4t3iajfg _1bsbajfg _ca0q1skh _u5f31skh _n3td1skh _19bv1skh",
    lg: "_4t3ickbl _1bsbckbl _ca0q1skh _u5f31skh _n3td1skh _19bv1skh",
    xl: "_4t3i1wqb _1bsb1wqb _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8"
};
const $0099352c27e86498$var$Tab = ({ teamTypeId: teamTypeId, index: index, title: title, iconSrc: iconSrc, iconSrcSelected: iconSrcSelected, setSelectedTeamType: setSelectedTeamType })=>{
    const { isCurrentTab: isCurrentTab } = (0, $cutM5.useAdg4TabsContext)();
    const isSelected = isCurrentTab(index);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)(); // analytics for "team expansion box" experiment GWP-4223
    const handleTeamTabClick = (clickedTeamType)=>{
        setSelectedTeamType(clickedTeamType);
        if (clickedTeamType) createAnalyticsEvent({
            eventName: "clickTeamSelectorTab",
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            actionSubjectId: "teamSelectorTab",
            source: "teamExpansionSelector",
            attributes: {
                product: "wac",
                pageUrl: window.location.href,
                pagePath: window.location.pathname,
                teamType: clickedTeamType
            }
        }).fire();
    };
    let buttonSize;
    switch(index){
        case 0:
        case 6:
            buttonSize = "sm";
            break;
        case 1:
        case 5:
            buttonSize = "md";
            break;
        case 2:
        case 4:
            buttonSize = "lg";
            break;
        case 3:
            buttonSize = "xl";
            break;
        default:
            buttonSize = "sm";
    }
    const buttonSizingStyles = $0099352c27e86498$var$buttonStyles[buttonSize];
    const iconWrapperSizingStyles = $0099352c27e86498$var$iconWrapperStyleMap[buttonSize];
    return /*#__PURE__*/ (0, $loA2J.jsxs)("button", {
        onClick: (e)=>{
            e.preventDefault();
            handleTeamTabClick(teamTypeId);
        },
        className: (0, $esG4f.default)([
            "_11q7glyw _19itglyw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _80omtlke _ect4bzd7 _k48p1nn1 _1e0c1txw _2lx21bp4 _4cvr1h6o",
            $0099352c27e86498$var$buttonStyles[buttonSize],
            "_z5z6jojz"
        ]),
        style: {
            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1bsb1wqb _4t3i1wqb _2rko14q1 _bfhk1kix _1e0c1txw _4cvr1h6o _1bah1h6o",
                    $0099352c27e86498$var$iconWrapperStyleMap[buttonSize],
                    isSelected && "_bfhk1ep1",
                    "icon-wrapper"
                ]),
                style: {
                    "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                    image: {
                        src: isSelected && iconSrcSelected ? iconSrcSelected : iconSrc,
                        alt: "",
                        width: 100
                    }
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                children: title
            })
        ]
    });
};
const $0099352c27e86498$export$dbb9d3849f125826 = ({ keyword: keyword })=>{
    const intl = (0, $f6qj2.default)();
    const whiteBackgroundStyle = null;
    const containerStyle = null;
    const teamData = (0, $8lIPu.JSW_FEATURES_TEAM_DATA);
    const { setAnchorLocalStorage: setAnchorLocalStorage } = (0, $k4Qty.useAnchorLocalStorage)();
    const [selectedTeamType, setSelectedTeamType] = (0, $iSvIT.useState)();
    (0, $iSvIT.useEffect)(()=>{
        setAnchorLocalStorage({
            team: selectedTeamType
        });
    }, [
        setAnchorLocalStorage,
        selectedTeamType
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": "hero-team-selection-variant",
        id: "start-trial",
        className: (0, $esG4f.default)([
            "_bfhkuzct"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1q5153f4 _85i5ymf6"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cutM5.Adg4Tabs), {
                initialTab: 3,
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTabList), {
                        children: teamData.map((team, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTab), {
                                tabIndex: index,
                                className: "round-tab",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)($0099352c27e86498$var$Tab, {
                                    index: index,
                                    title: intl.formatMessage(team.title),
                                    iconSrc: team.icon,
                                    iconSrcSelected: team.iconSrcSelected,
                                    setSelectedTeamType: setSelectedTeamType,
                                    teamTypeId: team.teamTypeId
                                })
                            }, index))
                    }),
                    teamData.map((team, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4TabPanel), {
                            panelIndex: index,
                            id: team.teamTypeId,
                            children: /*#__PURE__*/ (0, $iSvIT.cloneElement)(team.tabComponent, {
                                keyword: keyword
                            })
                        }, index))
                ]
            })
        })
    });
};
$0099352c27e86498$export$dbb9d3849f125826.displayName = "PaidTeamSelectionHeroSection";

});
parcelRegister("8lIPu", function(module, exports) {

$parcel$export(module.exports, "JSW_FEATURES_TEAM_DATA", function () { return $124f75c3ce50a4a8$export$cab6cf085c064769; });

var $loA2J = parcelRequire("loA2J");

var $6x1qA = parcelRequire("6x1qA");

var $kstiX = parcelRequire("kstiX");

var $96fnW = parcelRequire("96fnW");

var $1Tqd7 = parcelRequire("1Tqd7");

var $3AoAA = parcelRequire("3AoAA");

var $1AU39 = parcelRequire("1AU39");

var $2ZrxU = parcelRequire("2ZrxU");

var $9l9I2 = parcelRequire("9l9I2");
const $124f75c3ce50a4a8$export$cab6cf085c064769 = [
    {
        teamTypeId: "Software Engineering",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/575h0o4d5531rcso8b6or7m5ljj5yf77.svg",
        title: (0, $6x1qA.defineMessage)({
            id: "PaidLandingPage.teamSelectionHero.label.tab1",
            defaultMessage: "Software"
        }),
        englishLabel: "Software",
        tabComponent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9l9I2.default), {})
    },
    {
        teamTypeId: "Operations",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/yl01ea2raydqsbpq411uu2jb4x1o5k16.svg",
        title: (0, $6x1qA.defineMessage)({
            id: "PaidLandingPage.teamSelectionHero.label.tab2",
            defaultMessage: "Operations"
        }),
        englishLabel: "Operations",
        tabComponent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1AU39.default), {})
    },
    {
        teamTypeId: "HR",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/c85anlqa4vbx8kgn1y41t10q44q0325l.svg",
        title: (0, $6x1qA.defineMessage)({
            id: "PaidLandingPage.teamSelectionHero.label.tab3",
            defaultMessage: "HR"
        }),
        englishLabel: "HR",
        tabComponent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1Tqd7.default), {})
    },
    {
        teamTypeId: undefined,
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/7300dt61p6o2c340nk53534647755fep.svg",
        iconSrcSelected: "https://dam-cdn.atl.orangelogic.com/AssetLink/72lkaojcq61b111eyg28t62gv1002f22.svg",
        title: (0, $6x1qA.defineMessage)({
            id: "PaidLandingPage.teamSelectionHero.label.tab4",
            defaultMessage: "All Teams"
        }),
        englishLabel: "All Teams",
        tabComponent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kstiX.default), {})
    },
    {
        teamTypeId: "Marketing",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/6648s271ra1efk47v7r40xslp7630o4w.svg",
        title: (0, $6x1qA.defineMessage)({
            id: "PaidLandingPage.teamSelectionHero.label.tab5",
            defaultMessage: "Marketing"
        }),
        englishLabel: "Marketing",
        tabComponent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3AoAA.default), {})
    },
    {
        teamTypeId: "Design",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/x82hxxkp01k3f20y83q86a0r0bvm55p4.svg",
        title: (0, $6x1qA.defineMessage)({
            id: "PaidLandingPage.teamSelectionHero.label.tab6",
            defaultMessage: "Design"
        }),
        englishLabel: "Design",
        tabComponent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $96fnW.default), {})
    },
    {
        teamTypeId: "Sales",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/6101e5o3r21du53012037egepyolhibt.svg",
        title: (0, $6x1qA.defineMessage)({
            id: "PaidLandingPage.teamSelectionHero.label.tab7",
            defaultMessage: "Sales"
        }),
        englishLabel: "Sales",
        tabComponent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2ZrxU.default), {})
    }
];

});
parcelRegister("kstiX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9720862678b0d317$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $cqRZm = parcelRequire("cqRZm");
const $9720862678b0d317$var$AllTeamsTabContent = ()=>{
    const intl = (0, $f6qj2.default)();
    const allTeamsHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.hero.header",
            defaultMessage: "Connect every team, task, and project together with Jira"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/t501oo65h16scx35qe60q32dj6a4782t.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.default.heroImageAlt",
                defaultMessage: "Screen capture of a Jira backlog"
            })
        },
        showAnimatedHero: true
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cqRZm.PaidHeroTabPanelTemplate), (0, $6iHNw._)((0, $7Knp0._)({}, allTeamsHeroProps), {
        isAllTeamsTab: true
    }));
};
var $9720862678b0d317$export$2e2bcd8739ae039 = $9720862678b0d317$var$AllTeamsTabContent;

});
parcelRegister("cqRZm", function(module, exports) {

$parcel$export(module.exports, "PaidHeroTabPanelTemplate", function () { return $5dc72204b4059e7a$export$b11df6f0d1a6642c; });
/* hero-tab-panel-template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("al79j");
var $4L1BA = parcelRequire("4L1BA");

var $gZ0A3 = parcelRequire("gZ0A3");

var $47Euo = parcelRequire("47Euo");

var $iMdoL = parcelRequire("iMdoL");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");

var $cQk7Y = parcelRequire("cQk7Y");

var $f2a5L = parcelRequire("f2a5L");

var $6JN6z = parcelRequire("6JN6z");

var $1syhO = parcelRequire("1syhO");
const $5dc72204b4059e7a$var$contentStyle = null;
const $5dc72204b4059e7a$var$formColumn = null;
const $5dc72204b4059e7a$var$signupFormContainer = null;
const $5dc72204b4059e7a$var$headerStyle = null;
const $5dc72204b4059e7a$var$imgContainer = null;
const $5dc72204b4059e7a$var$carouselContainerStyles = null;
const $5dc72204b4059e7a$var$subHeaderStyles = null;
const $5dc72204b4059e7a$var$animationHeroContainer = null;
const $5dc72204b4059e7a$var$staticImageContainer = null;
const $5dc72204b4059e7a$export$b11df6f0d1a6642c = ({ header: header, subHeader: subHeader, image: image, showAnimatedHero: showAnimatedHero = false, carouselHeroProps: carouselHeroProps, isAllTeamsTab: isAllTeamsTab = false })=>{
    (0, $iSvIT.useEffect)(()=>{
        const getaaCompleteQueryObj = (0, $1syhO.getLocalStorage)((0, $cQk7Y.AA_AUTOCOMPLETE_POTENTIAL_CONVERSION_EVENT_LOCAL_STORAGE_KEY));
        if (getaaCompleteQueryObj) {
            const parsedStringifyAttributes = JSON.parse(getaaCompleteQueryObj);
            (0, $cQk7Y.sendConversionEventAlgolia)({
                objectID: parsedStringifyAttributes.objectID,
                queryID: parsedStringifyAttributes.queryID,
                position: parsedStringifyAttributes.position
            });
        }
    }, []);
    const { user: { isUserLoggedIn: isUserLoggedIn } } = (0, $iMdoL.useUserContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            "data-testid": "hero-tab-panel",
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx2vrvc _zulpzwfg _4cvr1h6o _1bah1h6o _19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1osq _na0i1bp4"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _10jxdgin _gltexe31 _1945stmo _dh1a1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                                className: (0, $esG4f.default)([
                                    "_ect41pz4 _1wyb1wto _vwz41k7u _k48pbfng _1pfh12am _6rth1tcg _gu181h6o"
                                ]),
                                style: {
                                    "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                                },
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6JN6z.BanditsHeaderWrapper), {
                                    product: "jira",
                                    type: "header",
                                    children: header
                                })
                            })
                        }),
                        subHeader && /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_6rth7vkz _y3gn1h6o _uj6k1e5h"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6JN6z.BanditsHeaderWrapper), {
                                product: "jira",
                                type: "subheader",
                                children: subHeader
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            "data-testid": "signup-form",
                            className: (0, $esG4f.default)([
                                "_p12f1feq _1bsb1osq"
                            ]),
                            children: isUserLoggedIn ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {}) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $f2a5L.PaidAccountCreation), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $6JN6z.BanditsAssetWrapper), {
                    product: "jira",
                    showChildren: !isAllTeamsTab,
                    children: [
                        showAnimatedHero && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_p12fstmo _glte1kpv _1mjb1txw _o5kc1h6o _na0i1bp4"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_kqswh2mm _1h1th1c8 _4t3i1wug _1tket94y _1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o _1y8o1osq _1mjbglyw"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gZ0A3.AnimatedJiraTour), {})
                            })
                        }),
                        carouselHeroProps ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_4cvr1h6o _1e0c1txw _1bah1h6o _1bsbcv93 _4t3i1ogm _1rfm1osq _tnru1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4L1BA.Carousel), (0, $7Knp0._)({}, carouselHeroProps))
                        }) : null,
                        image && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                showAnimatedHero ? "_1e0cglyw _1mjb1txw _o5kc1h6o _na0i1bp4" : "_p12fstmo _glte1kpv _1mjb1txw _o5kc1h6o _na0i1bp4"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                image: image,
                                style: {
                                    maxWidth: "100%"
                                }
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$5dc72204b4059e7a$export$b11df6f0d1a6642c.displayName = "PaidHeroTemplate";

});


parcelRegister("96fnW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4afff86bf5c99fa6$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $cqRZm = parcelRequire("cqRZm");
const $4afff86bf5c99fa6$var$DesignTabContent = ()=>{
    const intl = (0, $f6qj2.default)();
    const designHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.hero.design.header",
            defaultMessage: "Unleash innovative design work with Jira"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/stwkq56nns422b0684fodlf0074s3b6e.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.design.heroImageAlt",
                defaultMessage: "Screen capture of a Jira design ticket"
            })
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cqRZm.PaidHeroTabPanelTemplate), (0, $7Knp0._)({}, designHeroProps));
};
var $4afff86bf5c99fa6$export$2e2bcd8739ae039 = $4afff86bf5c99fa6$var$DesignTabContent;

});

parcelRegister("1Tqd7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a2699cae0bdd852$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $cqRZm = parcelRequire("cqRZm");
const $6a2699cae0bdd852$var$HRTabContent = ()=>{
    const intl = (0, $f6qj2.default)();
    const hrHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.hero.hr.header",
            defaultMessage: "Build teamwork and productivity across your organization with Jira"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/o3vf21711xl7j3k661enul0050252c02.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.hr.heroImageAlt",
                defaultMessage: "Screen capture of a Jira backlog"
            })
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cqRZm.PaidHeroTabPanelTemplate), (0, $7Knp0._)({}, hrHeroProps));
};
var $6a2699cae0bdd852$export$2e2bcd8739ae039 = $6a2699cae0bdd852$var$HRTabContent;

});

parcelRegister("3AoAA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83c4e4b34dbcd6e9$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $cqRZm = parcelRequire("cqRZm");
const $83c4e4b34dbcd6e9$var$MarketingTabContent = ()=>{
    const intl = (0, $f6qj2.default)();
    const marketingHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.hero.marketing.header",
            defaultMessage: "Unleash the power of marketing teams with Jira"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/62xi2h6p73mrb7t2ib163ss3qeh22c5f.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.marketing.heroImageAlt",
                defaultMessage: "Screen capture of a Jira board tracking a marketing launch"
            })
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cqRZm.PaidHeroTabPanelTemplate), (0, $7Knp0._)({}, marketingHeroProps));
};
var $83c4e4b34dbcd6e9$export$2e2bcd8739ae039 = $83c4e4b34dbcd6e9$var$MarketingTabContent;

});

parcelRegister("1AU39", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43ace0d192ed0eef$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $cqRZm = parcelRequire("cqRZm");
const $43ace0d192ed0eef$var$OperationsTabContent = ()=>{
    const intl = (0, $f6qj2.default)();
    const operationsHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.hero.operations.header",
            defaultMessage: "Operations processes made easy with Jira"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/w4g3m6wrfl232cm6kx12p83t1sg1odlm.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.operations.heroImageAlt",
                defaultMessage: "Screen capture of a Jira backlog"
            })
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cqRZm.PaidHeroTabPanelTemplate), (0, $7Knp0._)({}, operationsHeroProps));
};
var $43ace0d192ed0eef$export$2e2bcd8739ae039 = $43ace0d192ed0eef$var$OperationsTabContent;

});

parcelRegister("2ZrxU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $207d5e3fc85049a2$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $cqRZm = parcelRequire("cqRZm");
const $207d5e3fc85049a2$var$SalesTabContent = ()=>{
    const intl = (0, $f6qj2.default)();
    const salesHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.hero.sales.header",
            defaultMessage: "Hit sales team targets with Jira"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/87h6hy3p184v1kyn202mov58b5y6q82d.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.sales.heroImageAlt",
                defaultMessage: "Screen capture of a Jira board for a product launch"
            })
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cqRZm.PaidHeroTabPanelTemplate), (0, $7Knp0._)({}, salesHeroProps));
};
var $207d5e3fc85049a2$export$2e2bcd8739ae039 = $207d5e3fc85049a2$var$SalesTabContent;

});

parcelRegister("9l9I2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d1ef4e7faa4e585$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $cqRZm = parcelRequire("cqRZm");
const $2d1ef4e7faa4e585$var$SoftwareTabContent = ()=>{
    const intl = (0, $f6qj2.default)();
    const softwareHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.hero.software.header",
            defaultMessage: "Jira is the #1 software development tool used by agile teams"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/fya3j34w81idu648i580m4mutc60guo0.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.software.heroImageAlt",
                defaultMessage: "Screen capture of a Jira board"
            })
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cqRZm.PaidHeroTabPanelTemplate), (0, $7Knp0._)({}, softwareHeroProps));
};
var $2d1ef4e7faa4e585$export$2e2bcd8739ae039 = $2d1ef4e7faa4e585$var$SoftwareTabContent;

});




parcelRegister("kPNXB", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswPm", function () { return $ef0fb6f45a16ed85$export$3940e8f9b3d490c4; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $4xemF = parcelRequire("4xemF");
const $ef0fb6f45a16ed85$export$3940e8f9b3d490c4 = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4xemF.JiraSoftwarePagePaidLpJswAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-pm",
        persona: "unknown",
        pageVariant: "pm"
    }));
};

});

parcelRegister("4ewKx", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswProjCollab", function () { return $b0e39e76e2da20a4$export$f9651956eec158e0; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $4xemF = parcelRequire("4xemF");
const $b0e39e76e2da20a4$export$f9651956eec158e0 = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4xemF.JiraSoftwarePagePaidLpJswAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-project_collaboration",
        persona: "unknown",
        pageVariant: "project_collaboration"
    }));
};

});

parcelRegister("j7l2H", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswRoadmaps", function () { return $7218d8e135486b09$export$3507bd3b8f9604d1; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $4xemF = parcelRequire("4xemF");
const $7218d8e135486b09$export$3507bd3b8f9604d1 = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4xemF.JiraSoftwarePagePaidLpJswAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-roadmaps",
        persona: "unknown",
        pageVariant: "roadmaps"
    }));
};

});

parcelRegister("7Z8lp", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswTeamwork", function () { return $426044427224dd0f$export$3577f38e8e4e34f; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $4xemF = parcelRequire("4xemF");
const $426044427224dd0f$export$3577f38e8e4e34f = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4xemF.JiraSoftwarePagePaidLpJswAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-teamwork",
        persona: "unknown",
        pageVariant: "teamwork"
    }));
};

});

parcelRegister("aEM8Q", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswTemplate", function () { return $25efa534b925966b$export$4206a0db856d7544; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $4xemF = parcelRequire("4xemF");
const $25efa534b925966b$export$4206a0db856d7544 = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4xemF.JiraSoftwarePagePaidLpJswAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-template",
        persona: "unknown",
        pageVariant: "template"
    }));
};

});

parcelRegister("4jXNI", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswTracker", function () { return $04b777b657bdcf9b$export$5d7d37f42bf228bb; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $4xemF = parcelRequire("4xemF");
const $04b777b657bdcf9b$export$5d7d37f42bf228bb = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4xemF.JiraSoftwarePagePaidLpJswAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-tracker",
        persona: "unknown",
        pageVariant: "tracker"
    }));
};

});

parcelRegister("b3ZMX", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareFreePage", function () { return $49acf379ffbe3e26$export$a1727845ccb60c5c; });

var $3FBn4 = parcelRequire("3FBn4");
const $49acf379ffbe3e26$export$a1727845ccb60c5c = ()=>{
    // ATLAS-55799 - JSW Find Team
    const queryParameters = new URLSearchParams(location.search);
    var _queryParameters_get;
    const templateId = (_queryParameters_get = queryParameters.get("templateId")) !== null && _queryParameters_get !== void 0 ? _queryParameters_get : "";
    var _queryParameters_get1;
    const jiraProductTourSignupType = (_queryParameters_get1 = queryParameters.get("jiraProductTourSignupType")) !== null && _queryParameters_get1 !== void 0 ? _queryParameters_get1 : "";
    const signupPath = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup");
    const signupParameters = new URLSearchParams({
        bundle: "jira-software",
        edition: "free",
        skipBundles: "true"
    });
    if (templateId) signupParameters.append("templateId", templateId);
    if (jiraProductTourSignupType) signupParameters.append("jiraProductTourSignupType", jiraProductTourSignupType);
    location.href = `${signupPath}?${signupParameters}`;
    return null;
};

});

parcelRegister("a1ns9", function(module, exports) {

$parcel$export(module.exports, "getPricingTitleInternal", function () { return $eeb5c5988341dcd6$export$933c1404a4ee79b; });
const $eeb5c5988341dcd6$export$933c1404a4ee79b = ()=>{
    return "Jira Pricing Page";
};

});

parcelRegister("gDaC1", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePricingPage", function () { return $6c1df10bd4b772dc$export$743fd6231b24dcf9; });
// @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $4LHd8 = parcelRequire("4LHd8");

var $dT5kE = parcelRequire("dT5kE");
parcelRequire("aRHrH");
var $9O2F2 = parcelRequire("9O2F2");
parcelRequire("26Uky");
var $f84qs = parcelRequire("f84qs");

var $9iWJ8 = parcelRequire("9iWJ8");
const $6c1df10bd4b772dc$export$743fd6231b24dcf9 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $4LHd8.default).checkGate("gwp-737-enable-intercom-chat-jsw");
    const [hasFired, fireExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).jiraPricingPageWaeMigration);
    (0, $iSvIT.useEffect)(()=>{
        if (!hasFired) fireExposure();
    }, [
        hasFired,
        fireExposure
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9O2F2.IntercomProvider), {
        appId: "p0ww63i2",
        triggerBoot: isBootIntercom,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dT5kE.PricingContentContextProvider), {
            productId: "jira-software",
            pricingContent: pricingContent,
            queryRef: queryRef,
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $f84qs.JiraSoftwarePricingPageV2Template), {
                    pricing: pricing,
                    countryCode: countryCode
                })
            })
        })
    });
};

});
parcelRegister("26Uky", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePricingPageV2Template", function () { return (parcelRequire("f84qs")).JiraSoftwarePricingPageV2Template; });
parcelRequire("f84qs");

});
parcelRegister("f84qs", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePricingPageV2Template", function () { return $ae267e9e421433e6$export$413c805c73a21678; });

var $loA2J = parcelRequire("loA2J");

var $i4sgZ = parcelRequire("i4sgZ");

var $83YdV = parcelRequire("83YdV");
parcelRequire("gUyvS");
var $khjAx = parcelRequire("khjAx");
parcelRequire("kmJhl");
var $bofgW = parcelRequire("bofgW");

var $dT5kE = parcelRequire("dT5kE");
parcelRequire("3XyMp");
var $f8O3L = parcelRequire("f8O3L");

var $ceE90 = parcelRequire("ceE90");

var $j1oGG = parcelRequire("j1oGG");

var $1FqEx = parcelRequire("1FqEx");

var $dJVgs = parcelRequire("dJVgs");

var $jw3j5 = parcelRequire("jw3j5");
const $ae267e9e421433e6$export$413c805c73a21678 = (props)=>{
    var _content_callToActionContainer, _content_callToActionContainer1, _questionsCtaContent_asset;
    const content = (0, $dT5kE.usePricingContentContext)();
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[0];
    const dataCenterContent = (0, $dT5kE.useDatacenterPlans)("Contact Us", "Learn more");
    const featuresCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer1 = content.callToActionContainer) === null || _content_callToActionContainer1 === void 0 ? void 0 : _content_callToActionContainer1[1];
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _featuresCtaContent_text, _featuresCtaContent_url, _content_getMoreDetailsTitle, _content_additionalDetails, _questionsCtaContent_url, _questionsCtaContent_title, _questionsCtaContent_text, _questionsCtaContent_valueProposition;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJVgs.default), {}),
        showFallback: content === null || content === void 0 ? void 0 : content.hasError,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1FqEx.ParentScrollTracking), {
            scrollTrackingEnabled: true,
            pageId: "jira-software-pricing-page",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PageHeading), {
                    children: content === null || content === void 0 ? void 0 : content.headline
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $jw3j5.JiraPriceFinder), {
                    pricing: props.pricing,
                    countryCode: props.countryCode
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $khjAx.PricingFeatureTable), {
                    title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                    comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                    compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined,
                    linkValues: {
                        linkText: (_featuresCtaContent_text = featuresCtaContent === null || featuresCtaContent === void 0 ? void 0 : featuresCtaContent.text) !== null && _featuresCtaContent_text !== void 0 ? _featuresCtaContent_text : undefined,
                        linkHref: (_featuresCtaContent_url = featuresCtaContent === null || featuresCtaContent === void 0 ? void 0 : featuresCtaContent.url) !== null && _featuresCtaContent_url !== void 0 ? _featuresCtaContent_url : undefined
                    },
                    dataProductKey: "jiraSoftware",
                    stickyCtasEnabled: false
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $i4sgZ.DataCenterPromoCard), {
                    dataCenterContent: dataCenterContent
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $83YdV.TwcPromo), {
                    product: "jira"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $f8O3L.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1FqEx.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ceE90.PricingFaq), {
                            header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                            planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bofgW.QuestionsCta), {
                    product: "Jira",
                    ctaHref: (_questionsCtaContent_url = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.url) !== null && _questionsCtaContent_url !== void 0 ? _questionsCtaContent_url : undefined,
                    questionsHeader: (_questionsCtaContent_title = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.title) !== null && _questionsCtaContent_title !== void 0 ? _questionsCtaContent_title : undefined,
                    priceAndLicensingLinkText: (_questionsCtaContent_text = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.text) !== null && _questionsCtaContent_text !== void 0 ? _questionsCtaContent_text : undefined,
                    questionsBody: (_questionsCtaContent_valueProposition = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.valueProposition) !== null && _questionsCtaContent_valueProposition !== void 0 ? _questionsCtaContent_valueProposition : undefined,
                    imageHref: questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : (_questionsCtaContent_asset = questionsCtaContent.asset) === null || _questionsCtaContent_asset === void 0 ? void 0 : _questionsCtaContent_asset.url
                })
            ]
        })
    });
};

});
parcelRegister("jw3j5", function(module, exports) {

$parcel$export(module.exports, "JiraPriceFinder", function () { return $bdf57cd0d19e3966$export$1bf486cdabb14f4d; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $6x1qA = parcelRequire("6x1qA");

var $7OWgU = parcelRequire("7OWgU");

var $l9lQF = parcelRequire("l9lQF");

var $esRX2 = parcelRequire("esRX2");

var $dT5kE = parcelRequire("dT5kE");
const $bdf57cd0d19e3966$export$1bf486cdabb14f4d = (props)=>{
    var _content_free, _content_free1, _content_standard, _content_standard1, _content_premium, _content_premium1, _content_enterprise, _content_enterprise1, _props_pricing_ccpPricingData, _props_pricing;
    const content = {
        free: (0, $dT5kE.usePricingPlanComparison)("Free"),
        standard: (0, $dT5kE.usePricingPlanComparison)("Standard"),
        premium: (0, $dT5kE.usePricingPlanComparison)("Premium"),
        enterprise: (0, $dT5kE.usePricingPlanComparison)("Enterprise")
    };
    const freePlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "free");
    const standardPlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "standard");
    const premiumPlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "premium");
    const enterprisePlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "enterprise");
    const signupLimit = 100000;
    var _content_free_planTitleExternal, _content_free_planOneLiner, _content_standard_planTitleExternal, _content_standard_planOneLiner, _content_premium_planTitleExternal, _content_premium_planOneLiner, _content_enterprise_planTitleExternal, _content_enterprise_planOneLiner;
    // planNames should not be translated
    const jswProductPlans = [
        {
            planName: (_content_free_planTitleExternal = (_content_free = content.free) === null || _content_free === void 0 ? void 0 : _content_free.planTitleExternal) !== null && _content_free_planTitleExternal !== void 0 ? _content_free_planTitleExternal : "Free",
            offeringSku: "jira-software-free",
            description: (_content_free_planOneLiner = (_content_free1 = content.free) === null || _content_free1 === void 0 ? void 0 : _content_free1.planOneLiner) !== null && _content_free_planOneLiner !== void 0 ? _content_free_planOneLiner : "",
            recommendationLimit: 0,
            signupLimit: signupLimit,
            signupURLSuffix: "?bundle=jira-software&edition=free&editionIntent=free",
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: (_content_standard_planTitleExternal = (_content_standard = content.standard) === null || _content_standard === void 0 ? void 0 : _content_standard.planTitleExternal) !== null && _content_standard_planTitleExternal !== void 0 ? _content_standard_planTitleExternal : "Standard",
            offeringSku: "jira-software-standard",
            description: (_content_standard_planOneLiner = (_content_standard1 = content.standard) === null || _content_standard1 === void 0 ? void 0 : _content_standard1.planOneLiner) !== null && _content_standard_planOneLiner !== void 0 ? _content_standard_planOneLiner : "",
            recommendationLimit: 10,
            signupLimit: signupLimit,
            signupURLSuffix: "?bundle=jira-software&edition=standard",
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: (_content_premium_planTitleExternal = (_content_premium = content.premium) === null || _content_premium === void 0 ? void 0 : _content_premium.planTitleExternal) !== null && _content_premium_planTitleExternal !== void 0 ? _content_premium_planTitleExternal : "Premium",
            offeringSku: "jira-software-premium",
            description: (_content_premium_planOneLiner = (_content_premium1 = content.premium) === null || _content_premium1 === void 0 ? void 0 : _content_premium1.planOneLiner) !== null && _content_premium_planOneLiner !== void 0 ? _content_premium_planOneLiner : "",
            recommendationLimit: 250,
            signupLimit: signupLimit,
            signupURLSuffix: "?bundle=jira-software&edition=premium",
            planFeatureMessages: premiumPlanFeatureMessages
        },
        {
            planName: (_content_enterprise_planTitleExternal = (_content_enterprise = content.enterprise) === null || _content_enterprise === void 0 ? void 0 : _content_enterprise.planTitleExternal) !== null && _content_enterprise_planTitleExternal !== void 0 ? _content_enterprise_planTitleExternal : "Enterprise",
            offeringSku: "jira-software-enterprise-sku",
            recommendationLimit: 5000,
            description: (_content_enterprise_planOneLiner = (_content_enterprise1 = content.enterprise) === null || _content_enterprise1 === void 0 ? void 0 : _content_enterprise1.planOneLiner) !== null && _content_enterprise_planOneLiner !== void 0 ? _content_enterprise_planOneLiner : "",
            signupLimit: signupLimit,
            planFeatureMessages: enterprisePlanFeatureMessages
        }
    ];
    const messages = (0, $6x1qA.defineMessages)({
        headerText: {
            id: "JiraSoftwarePricingPageV2.priceFinder.header",
            defaultMessage: "<blue>Simple, transparent pricing</blue> for every team."
        },
        unitCountInputText: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputText",
            defaultMessage: "How many users are on your team?"
        },
        unitCountInputTextRedesign: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputDirectBuy: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputDirectBuy",
            defaultMessage: "What's your team size?"
        },
        unitCountInputTerm: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        billingCycleText: {
            id: "JiraSoftwarePricingPage.priceFinder.billingCycleText",
            defaultMessage: "Billing cycle:"
        },
        unitCountInputTooltip: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputTooltip",
            defaultMessage: "A Jira Software user is any user who can log in to Jira Software, and who exists in User Management"
        },
        cardOverSignupLimit: {
            id: "JiraSoftwarePricingPage.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "JiraSoftwarePricingPage.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "JiraSoftwarePricingPage.priceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "JiraSoftwarePricingPageV2.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        },
        cardFreeDescription: {
            id: "JiraSoftwarePricingPage.priceFinder.cardFreeDescription",
            defaultMessage: "Always free for 10 users"
        }
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $l9lQF.PriceFinderContextProvider), {
            productPlans: jswProductPlans,
            dataProductKey: "jiraSoftware",
            defaultUnitCount: 300,
            shouldAddBuyNow: true,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OWgU.default), {
                messages: messages,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.jiraSoftware,
                countryCode: props.countryCode
            })
        })
    });
};
$bdf57cd0d19e3966$export$1bf486cdabb14f4d.displayName = "JiraPriceFinder";

});




parcelRegister("6KSFr", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryPage", function () { return $35f571ea04e8eac4$export$d8efa57f95a0eae9; });
// @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $4LHd8 = parcelRequire("4LHd8");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");
parcelRequire("aRHrH");
var $9O2F2 = parcelRequire("9O2F2");

var $gAJUc = parcelRequire("gAJUc");
parcelRequire("hDgra");
var $iBOlP = parcelRequire("iBOlP");
const $35f571ea04e8eac4$export$d8efa57f95a0eae9 = ()=>{
    const intl = (0, $f6qj2.default)();
    const isBootIntercom = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp1304AddIntercomToJpdProductTour);
    (0, $iSvIT.useEffect)(()=>{
        (0, $4LHd8.default).getLayer("wac-edge-track-routing-layer").get("track", "main");
    }, []);
    const intercomAppId = intl.locale === "ja" ? "p0ww63i2" : "";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9O2F2.IntercomProvider), {
        appId: intercomAppId,
        triggerBoot: isBootIntercom,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3LLDq.CrossFlowTouchpointProvider), {
            screenName: "wacJpdProductTourPage",
            productKeys: [
                (0, $i8kxh.ProductKeys).JIRA_PRODUCT_DISCOVERY
            ],
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iBOlP.JiraProductDiscoveryTemplate), {})
        })
    });
};

});
parcelRegister("hDgra", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryTemplate", function () { return (parcelRequire("iBOlP")).JiraProductDiscoveryTemplate; });
parcelRequire("iBOlP");

});
parcelRegister("iBOlP", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryTemplate", function () { return $36eb65e9a86c668a$export$55460b563be26bbf; });

var $loA2J = parcelRequire("loA2J");

var $4XrxY = parcelRequire("4XrxY");

var $kex29 = parcelRequire("kex29");

var $4CuE6 = parcelRequire("4CuE6");

var $j6Axx = parcelRequire("j6Axx");

var $ksmCY = parcelRequire("ksmCY");

var $5twbI = parcelRequire("5twbI");

var $h0v1e = parcelRequire("h0v1e");

var $bWsik = parcelRequire("bWsik");

var $2m2Kl = parcelRequire("2m2Kl");

var $fnNPE = parcelRequire("fnNPE");

var $bvUhK = parcelRequire("bvUhK");

var $iGwIR = parcelRequire("iGwIR");

var $9GfN9 = parcelRequire("9GfN9");

var $8E2OI = parcelRequire("8E2OI");
const $36eb65e9a86c668a$export$55460b563be26bbf = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $j6Axx.default), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("main", {
                    id: "content",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $4CuE6.JPDBanner), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $fnNPE.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $9GfN9.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $bWsik.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $2m2Kl.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $iGwIR.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $ksmCY.AtlassianIntelligence), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $bvUhK.HowItWorks), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $8E2OI.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5twbI.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $h0v1e.default), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("4CuE6", function(module, exports) {

$parcel$export(module.exports, "JPDBanner", function () { return $382e43584557f81d$export$637e7e5d1efd26e9; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("fovuc");
var $5ZfUA = parcelRequire("5ZfUA");

var $3FBn4 = parcelRequire("3FBn4");

var $gAJUc = parcelRequire("gAJUc");
const $382e43584557f81d$export$637e7e5d1efd26e9 = ()=>{
    const intl = (0, $f6qj2.default)();
    const gwp6473JpdPremiumBanner = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp6473JpdPremiumBanner);
    const gwp7456JpdStateOfProductBanner = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7456JpdStateOfProductBanner);
    const gwp8038JpdBannerWebinar = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp8038JpdBannerWebinar);
    const jpdBannerMessagesWebinar = {
        identifier: "JPDPageTemplate.webinar-announcement",
        text: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "JPDPageTemplate.banner-alert.state-of-product-webinar-announcement",
            defaultMessage: "<strong>State of Product 2026:</strong> Register for the webinar to hear the surprising findings!",
            values: (0, $3FBn4.DEFAULT_VALUES)
        }),
        linkText: intl.formatMessage({
            id: "JPDPageTemplate.banner-alert.state-of-product-webinar-announcement.link-text",
            defaultMessage: "Register now \u2192"
        }),
        linkUrl: (0, $3FBn4.useLocalizedHref)("/webinars/software/state-of-product-2026"),
        dataEventProps: {
            "data-product-key": "confluence",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Register now",
            "data-label-english": "Register now",
            "data-track-event": "jpdPageTemplate.bannerAlert.stateOfProductWebinarAnnouncement.registerNow"
        }
    };
    const jpdBannerMessagesStateOfProduct = {
        identifier: "JPDPageTemplate.premium-announcement",
        text: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "JPDPageTemplate.banner-alert.state-of-product-announcement",
            defaultMessage: "<strong>State of Product 2026:</strong> Find out what 1000+ product teams think in our newest research report.",
            values: (0, $3FBn4.DEFAULT_VALUES)
        }),
        linkText: intl.formatMessage({
            id: "JPDPageTemplate.banner-alert.state-of-product-announcement.link-text",
            defaultMessage: "Read now \u2192"
        }),
        linkUrl: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery/resources/state-of-product-2026"),
        dataEventProps: {
            "data-product-key": "confluence",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Read now",
            "data-label-english": "Read now",
            "data-track-event": "jpdPageTemplate.bannerAlert.stateOfProductAnnouncement.readNow"
        }
    };
    const jpdBannerMessagesPremium = {
        identifier: "JPDPageTemplate.premium-announcement",
        text: intl.formatMessage({
            id: "JPDPageTemplate.banner-alert.premium-announcement",
            defaultMessage: "Jira Product Discovery Premium is now available! Get more visibility, control, and support to build products at scale."
        }),
        linkText: intl.formatMessage({
            id: "JPDPageTemplate.link-text",
            defaultMessage: "Learn more \u2192"
        }),
        linkUrl: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery/premium"),
        dataEventProps: {
            "data-product-key": "confluence",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Learn more",
            "data-label-english": "Learn more",
            "data-track-event": "jpdPageTemplate.announcementBanner.learnMore"
        }
    };
    if (gwp8038JpdBannerWebinar) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5ZfUA.BannerAlert), (0, $7Knp0._)({}, jpdBannerMessagesWebinar));
    if (gwp7456JpdStateOfProductBanner) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5ZfUA.BannerAlert), (0, $7Knp0._)({}, jpdBannerMessagesStateOfProduct));
    if (gwp6473JpdPremiumBanner) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5ZfUA.BannerAlert), (0, $7Knp0._)({}, jpdBannerMessagesPremium));
    return null;
};

});

parcelRegister("j6Axx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c253c89c6f96043e$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $gAJUc = parcelRequire("gAJUc");
const $c253c89c6f96043e$var$JpdLogo = ()=>{
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV2), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand"
    });
};
const $c253c89c6f96043e$var$JiraProductDiscoveryNavV2 = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-product-discovery");
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).JIRA_PRODUCT_DISCOVERY,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    const links = [
        {
            globalLinksKey: "features",
            linkText: intl.formatMessage({
                // this id can be renamed once the above has been fixed as well
                id: "jiraproductdiscovery.navbar.product-features",
                defaultMessage: "Features"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery/features")
        },
        {
            globalLinksKey: "pricing",
            linkText: intl.formatMessage({
                // this id should be renamed, but for Team'24 hotfix we need to keep existing mapping
                id: "jiraproductdiscovery.navbar.features",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery/pricing")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "jiraproductdiscovery.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery/resources")
        }
    ];
    // TODO: this duplicates the value from the v1 product nav
    // this was to use an accurate existing translation for a Team'24 hot fix
    const ctaText = intl.formatMessage({
        id: "productNavBar.get-it-free-button",
        defaultMessage: "Get it free"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
        productLogoUrl: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery"),
        productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($c253c89c6f96043e$var$JpdLogo, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: "wacJiraProductDiscoveryNavigation.logo-label",
            defaultMessage: "Jira Product Discovery logo"
        }),
        mobileCtaText: ctaText,
        mobileCtaUrl: signupLink,
        mobileCtaOnClick: openCrossFlow,
        mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($c253c89c6f96043e$var$JpdLogo, {}),
        navigationTrynowCtaText: ctaText,
        navigationTrynowCtaUrl: signupLink,
        navigationTrynowCtaOnClick: openCrossFlow,
        productPageNavLinks: links,
        mobileLinksSections: [
            {
                mobileLinkKey: "mobile-jira-product-discovery",
                mobileLinksProps: links
            }
        ]
    });
};
$c253c89c6f96043e$var$JiraProductDiscoveryNavV2.displayName = "JiraProductDiscoveryNavV2";
var $c253c89c6f96043e$export$2e2bcd8739ae039 = $c253c89c6f96043e$var$JiraProductDiscoveryNavV2;

});

parcelRegister("ksmCY", function(module, exports) {

$parcel$export(module.exports, "AtlassianIntelligence", function () { return $28812ae5faf1418d$export$eec9700d5a261698; });
/* ai.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $eDoPe = parcelRequire("eDoPe");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $28812ae5faf1418d$var$ArrowPencilPointRight = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        style: {
            color: props.color ? props.color : "currentColor",
            transform: `rotate(${props.rotate ? props.rotate : "0"}deg)`
        },
        width: "50",
        height: "17",
        viewBox: "0 0 72 25",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $esG4f.default)([
            "_tnrurdoj _1rfm1tcg _1vkhl52n _12rr12am"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            fill: "currentColor",
            d: "M59.938 15.4c-.92-.48-1.816-.597-2.7-.75a7.975 7.975 0 0 0-2.872.044c-.848.163-1.709.062-2.511-.19-1.5-.473-3.039-.55-4.597-.555-.973-.005-1.959-.054-2.916-.202-.663-.104-1.292-.416-1.965-.642-.392.625-.992.599-1.612.367-1.278-.481-2.594-.57-3.947-.543-.736.014-1.463-.158-2.068-.635-.077-.056-.175-.084-.267-.117-.61.602-1.323.564-2.063.397-1.19-.262-2.387-.5-3.577-.762-.804-.18-1.606-.377-2.409-.569-.797-.196-1.56-.48-2.43-.276-1.08.253-2.16-.009-3.235-.18-1.226-.2-2.439-.518-3.666-.604-2.097-.152-4.158-.522-6.235-.81-.993-.14-1.991-.243-2.975-.423a42.808 42.808 0 0 1-2.978-.664c-1.046-.264-2.085-.582-3.121-.882C1.122 7.214.74 6.67.444 6.112.36 5.953.59 5.534.78 5.337c.594-.621 1.35-.92 2.211-.987 1.934-.153 3.86-.06 5.774.12 1.72.162 3.425.459 5.124.761 1.963.342 3.938.566 5.928.725 1.551.12 3.096.346 4.645.495 1.447.144 2.9.241 4.353.38 1.607.156 3.215.305 4.824.502 2.28.273 4.55.593 6.831.872 1.62.199 3.241.391 4.895.293.938-.058 1.897.126 2.828.295 1.34.24 2.692.28 4.046.348 1.651.082 3.303.158 4.96.246.474.026.944.098 1.42.124.13.013.267-.05.401-.072-.052-.126-.069-.295-.162-.37-.553-.454-1.127-.874-1.68-1.327-1.467-1.208-2.934-2.416-4.394-3.635-.563-.473-.885-1.124-1.227-1.76-.208-.387-.023-.71.165-1.002.18-.28.301-.676.723-.71.29-.024.579-.048.87-.041 1.45.024 2.74.566 4.009 1.184.906.442 1.796.925 2.718 1.344.386.178.62.43.782.807.114.264.204.591.615.274.182-.137.404-.09.571.125.246.314.537.602.782.921.167.222.358.277.63.3 1.026.064 1.83.574 2.406 1.407.371.537.868.9 1.432 1.15.655.29 1.24.663 1.702 1.185.85.958 1.653 1.953 2.45 2.954.341.43.245 1.248-.147 1.657-.703.737-1.431 1.44-2.117 2.191-.368.406-.66.885-1 1.323-.14.178-.285.415-.478.478-.75.258-1.239.837-1.802 1.342-.233.21-.48.442-.76.557-.915.379-1.838.732-2.774 1.043-.273.091-.606-.027-.91-.023-.139.004-.345.03-.402.12-.507.805-1.262 1.2-2.163 1.25-1.377.08-2.673.52-4.003.82-1.53.344-3.061.683-4.589 1.052a13.66 13.66 0 0 1-3.57.36c-.512-.011-.884-.266-1.065-.674-.39-.899-.488-.879.139-1.69.118-.155.253-.297.35-.466.372-.67 1.031-.793 1.682-1.007 1.115-.364 2.208-.796 3.296-1.234 1.425-.578 2.831-1.193 4.246-1.784.764-.322 1.542-.601 2.29-.949.75-.348 1.47-.753 2.287-1.178l.016-.034z"
        })
    });
};
const $28812ae5faf1418d$var$ArrowPencilPointLeft = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        style: {
            color: props.color ? props.color : "currentColor",
            transform: `rotate(${props.rotate ? props.rotate : "0"}deg)`
        },
        width: "50",
        height: "17",
        viewBox: "0 0 72 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $esG4f.default)([
            "_tnrurdoj _1rfm1tcg _1vkhl52n _12rr12am"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            fill: "currentColor",
            d: "M11.923 9.891c.933.429 1.83.508 2.72.622a8.268 8.268 0 0 0 2.87-.149c.843-.189 1.706-.123 2.515.09 1.513.401 3.053.417 4.61.365.973-.031 1.96-.021 2.921.086.666.076 1.303.353 1.983.546.374-.617.975-.614 1.6-.413 1.292.416 2.61.453 3.962.376.735-.04 1.467.098 2.084.536.08.051.178.075.271.104.594-.604 1.307-.594 2.051-.46 1.197.208 2.4.393 3.597.601.809.144 1.616.304 2.424.46.802.16 1.572.404 2.437.176 1.072-.285 2.16-.072 3.24.053 1.23.147 2.452.409 3.68.446 2.102.069 4.172.35 6.256.55.997.097 1.998.16 2.986.297 1.006.139 2.007.323 2.995.53 1.053.216 2.101.484 3.145.735.677.158 1.073.668 1.385 1.196.088.15-.132.564-.316.76-.577.622-1.325.94-2.184 1.035-1.93.22-3.856.202-5.776.099-1.724-.091-3.436-.315-5.143-.543a66.397 66.397 0 0 0-5.946-.479c-1.554-.057-3.105-.218-4.657-.304-1.451-.086-2.906-.126-4.363-.206-1.611-.09-3.223-.174-4.836-.304-2.288-.179-4.566-.403-6.853-.588-1.626-.13-3.252-.256-4.902-.1-.936.091-1.9-.05-2.835-.179-1.348-.183-2.7-.17-4.055-.186-1.653-.017-3.307-.029-4.965-.052-.476-.007-.947-.06-1.423-.067-.13-.008-.267.059-.4.085.055.119.077.282.172.351.565.417 1.151.8 1.716 1.218 1.5 1.11 2.999 2.222 4.491 3.344.576.435.915 1.051 1.274 1.651.218.367.042.685-.137.974-.173.278-.284.664-.705.712-.288.034-.577.068-.869.072-1.449.03-2.753-.444-4.039-.993-.918-.393-1.821-.825-2.753-1.196a1.417 1.417 0 0 1-.805-.75c-.12-.25-.219-.562-.621-.24-.18.138-.402.1-.575-.1-.255-.294-.553-.561-.807-.86-.172-.207-.365-.254-.638-.266-1.027-.024-1.844-.485-2.444-1.268-.385-.504-.892-.836-1.462-1.057-.662-.256-1.258-.593-1.734-1.08a69.905 69.905 0 0 1-2.53-2.758c-.352-.404-.277-1.196.103-1.606.683-.737 1.392-1.443 2.058-2.192.356-.405.635-.879.964-1.314.135-.177.274-.41.464-.48.744-.276 1.217-.853 1.766-1.361.227-.211.467-.445.745-.566.904-.4 1.817-.775 2.745-1.11.27-.098.606.004.911-.011.138-.01.343-.042.398-.131.486-.796 1.23-1.205 2.129-1.287 1.374-.128 2.659-.601 3.98-.94 1.52-.39 3.042-.773 4.56-1.186C22.527.86 23.711.715 24.915.7c.513-.009.892.223 1.084.61.415.853.512.83-.093 1.635-.115.155-.246.297-.338.464-.354.66-1.01.803-1.654 1.034-1.105.393-2.186.85-3.262 1.314-1.41.61-2.798 1.257-4.197 1.879-.755.34-1.525.638-2.265 1.001-.74.364-1.448.781-2.254 1.222l-.014.033z"
        })
    });
};
const $28812ae5faf1418d$export$eec9700d5a261698 = ()=>{
    const intl = (0, $f6qj2.default)();
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "jpd-atlassianIntelligence",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
            id: "atlassian-intelligence",
            ref: scrollRef,
            className: (0, $esG4f.default)([
                "_85i51wqb _1reo15vq _18m915vq",
                sectionIsVisible ? "is-visible" : ""
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                layout: "12",
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswh2mm"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_kqswstnw _152tidpf _1e021ssb _t9eczr6s _1bsbtfvk _p12fauwl _bfhkqlpt _1pby1mrw _4t3i1w8u _mkrz1wiv _165t1mqo _1cfr1y69",
                                "background"
                            ])
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _4cvr1h6o _2lx21bp4 _kqswh2mm",
                                "content-wrapper"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _4cvr1h6o _2lx21bp4 _zulp4bvh _p12f32xz _1q511k4y _kqswh2mm _y3gn1h6o _81641tcg"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c1txw _2lx21bp4 _4cvr1h6o _srwzi2wt"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_1e0c1txw _4cvr1h6o _1bah1h6o _zulp1crf _6rthzwfg",
                                                    "branding"
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                                    image: {
                                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/228i1sr1dfw1gwf6gej5q22wij418525.svg",
                                                        alt: "Atlassian Intelligence",
                                                        width: 32,
                                                        height: 32
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                                className: (0, $esG4f.default)([
                                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz12cp _1pby11wp",
                                                    "_1rkb1w8u"
                                                ]),
                                                children: intl.formatMessage({
                                                    id: "JiraProductDiscoveryPage.atlassianIntelligence.header",
                                                    defaultMessage: "Transform teamwork with human-AI collaboration"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                        text: intl.formatMessage({
                                            id: "JiraProductDiscoveryPage.atlassianIntelligence.ctaText",
                                            defaultMessage: "Explore Atlassian Intelligence"
                                        }),
                                        href: (0, $3FBn4.useLocalizedHref)("/software/artificial-intelligence"),
                                        type: "primary",
                                        bgColor: "bgBlackBlue",
                                        dataEventProps: {
                                            "data-event": "clicked",
                                            "data-event-component": "linkButton",
                                            "data-event-container": "ctaSection",
                                            "data-product-key": "jiraProductDiscovery",
                                            "data-label-english": "Explore Atlassian Intelligence"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_kqswh2mm _1h1tcq2i _1bsb1osq _lcxvglyw"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)($28812ae5faf1418d$var$LeftArrows, {
                                                sectionIsVisible: sectionIsVisible
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)($28812ae5faf1418d$var$RightArrows, {
                                                sectionIsVisible: sectionIsVisible
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                                image: {
                                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/w5a2w16s762570j03psv36nc66c7bpuk.webp",
                                                    alt: "",
                                                    width: 1920,
                                                    height: 1080
                                                },
                                                style: {
                                                    maxWidth: "100%",
                                                    height: "auto"
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $28812ae5faf1418d$var$LeftArrows = ({ sectionIsVisible: sectionIsVisible })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqswstnw _4t3i1osq _1bsb1osq _152tidpf _1pbycs5v",
            "_152tubeo _1e02tidb _1vxpvqxi _mmgkvkhr _jj7e1xgq _zsl9vkhr _17s11xgq _dqt7vkhr"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hqu7fg"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($28812ae5faf1418d$var$ArrowPencilPointLeft, {
                    color: "#1868DB",
                    rotate: 200
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq1j6v"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($28812ae5faf1418d$var$ArrowPencilPointLeft, {
                    color: "#BC5DF2",
                    rotate: 222
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hqb8yl"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($28812ae5faf1418d$var$ArrowPencilPointLeft, {
                    color: "#fff",
                    rotate: 219
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq1gop"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($28812ae5faf1418d$var$ArrowPencilPointLeft, {
                    color: "#101214",
                    rotate: 196
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq1r2e"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($28812ae5faf1418d$var$ArrowPencilPointLeft, {
                    color: "#B9D58D",
                    rotate: 199
                })
            })
        ]
    });
};
const $28812ae5faf1418d$var$RightArrows = ({ sectionIsVisible: sectionIsVisible })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqswstnw _4t3i1osq _1bsb1osq _152tidpf _1pbycs5v",
            "_152t11oi _1e02sisq _1vxp1ebb _mmgk189v _jj7etpnp _zsl9189v _17s1tpnp _dqt7189v"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hqwpsi"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($28812ae5faf1418d$var$ArrowPencilPointRight, {
                    color: "#1868DB",
                    rotate: 139
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq1xrr"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($28812ae5faf1418d$var$ArrowPencilPointRight, {
                    color: "#fff",
                    rotate: 127
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq59wa"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($28812ae5faf1418d$var$ArrowPencilPointRight, {
                    color: "#82B536",
                    rotate: 114
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hqmgyd"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($28812ae5faf1418d$var$ArrowPencilPointRight, {
                    color: "#101214",
                    rotate: 138
                })
            })
        ]
    });
};
const $28812ae5faf1418d$var$sectionStyles = null;
const $28812ae5faf1418d$var$arrowStyles = null;
const $28812ae5faf1418d$var$wrapperStyles = null;
const $28812ae5faf1418d$var$leftAndRightArrowsStyles = null;
const $28812ae5faf1418d$var$svgStyles = null;
const $28812ae5faf1418d$var$leftArrowsStyles = null;
const $28812ae5faf1418d$var$rightArrowsStyles = null;
const $28812ae5faf1418d$var$headerStyles = null;
const $28812ae5faf1418d$var$containerStyles = null;
const $28812ae5faf1418d$var$backgroundStyles = null;
const $28812ae5faf1418d$var$textWrapperStyles = null;
const $28812ae5faf1418d$var$textStyles = null;
const $28812ae5faf1418d$var$brandingStyles = null;
const $28812ae5faf1418d$var$imageWrapperStyles = null;
const $28812ae5faf1418d$var$fadeIn = null;
const $28812ae5faf1418d$var$fadeInAnimation = null;
const $28812ae5faf1418d$var$arrowLeft1 = null;
const $28812ae5faf1418d$var$arrowLeft1Animation = null;
const $28812ae5faf1418d$var$arrowLeft2 = null;
const $28812ae5faf1418d$var$arrowLeft2Animation = null;
const $28812ae5faf1418d$var$arrowLeft3 = null;
const $28812ae5faf1418d$var$arrowLeft3Animation = null;
const $28812ae5faf1418d$var$arrowLeft4 = null;
const $28812ae5faf1418d$var$arrowLeft4Animation = null;
const $28812ae5faf1418d$var$arrowLeft5 = null;
const $28812ae5faf1418d$var$arrowLeft5Animation = null;
const $28812ae5faf1418d$var$arrowRight1 = null;
const $28812ae5faf1418d$var$arrowRight1Animation = null;
const $28812ae5faf1418d$var$arrowRight2 = null;
const $28812ae5faf1418d$var$arrowRight2Animation = null;
const $28812ae5faf1418d$var$arrowRight3 = null;
const $28812ae5faf1418d$var$arrowRight3Animation = null;
const $28812ae5faf1418d$var$arrowRight4 = null;
const $28812ae5faf1418d$var$arrowRight4Animation = null;

});

parcelRegister("5twbI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f436400e57f4fd3$export$2e2bcd8739ae039; });
/* community.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");
const $2f436400e57f4fd3$var$Community = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1mou1epz"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
            layout: "6-6",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/tj67uy2v6dlh816537m17ay3p0qwy6y2.webp",
                        alt: ""
                    },
                    className: (0, $esG4f.default)([
                        "_rtys1osq _bna71wug _1vr0xy5q"
                    ])
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            className: "h4",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraProductDiscoveryPage.community.heading",
                                defaultMessage: "Join us in the Atlassian Community"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraProductDiscoveryPage.community.subheading",
                                defaultMessage: "Ask questions, give app feedback, and connect with our team and other users to learn best practices."
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                            text: intl.formatMessage({
                                id: "JiraProductDiscoveryPage.community.ctaText",
                                defaultMessage: "Join the discussion"
                            }),
                            href: "https://community.atlassian.com/t5/Jira-Product-Discovery/ct-p/jpd",
                            type: "primary",
                            dataEventProps: {
                                "data-event-component": "linkButton",
                                "data-event-container": "pronouncedCtaSection",
                                "data-event": "clicked",
                                "data-product-key": "jiraProductDiscovery"
                            }
                        })
                    ]
                })
            ]
        })
    });
};
var $2f436400e57f4fd3$export$2e2bcd8739ae039 = $2f436400e57f4fd3$var$Community;
const $2f436400e57f4fd3$var$section = null;
const $2f436400e57f4fd3$var$img = null;

});

parcelRegister("h0v1e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67f5ab58647a7f49$export$2e2bcd8739ae039; });
/* cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $i8kxh = parcelRequire("i8kxh");

var $91nJf = parcelRequire("91nJf");

var $3LLDq = parcelRequire("3LLDq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $67f5ab58647a7f49$var$CtaSection = ()=>{
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-product-discovery");
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).JIRA_PRODUCT_DISCOVERY,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1reo15vq _p12f1osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            layout: "12",
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _y3gn1h6o _6rthxncg _1q51xncg _85i5xy5q _1e0c1txw _2lx21bp4 _4cvr1h6o _zulppxbi _1cs8stnw _1g0v1mrw _1kt9b3bt _1812ukr8 _gs7s10v4 _1rusbq5w _7dwz6xro _1kwxdcea _jbut1ssa _5t3m1oci _m2uvwt5r _18postnw _1bqq1mrw _aetrb3bt _13w1ukr8 _16gxmgjw _1hfkb29m _3p6m1cq2 _1v5vmgnk _z0bc1h14 _19h9d943 _1oj4kh7c _otsx1cpx _wi3iz9ld _tzs91clp"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        className: (0, $esG4f.default)([
                            "_syaz1gfe _1mouidpf _14b51n8h _1m0r1wug",
                            "_1cs8stnw _1mp410mc _kfgt10mc _1kt9b3bt _1s6k11z8 _1ank5vt7 _cfu11o8l _7dwz4djf"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "JiraProductDiscoveryPage.cta.section.heading",
                            defaultMessage: "<span>Build</span> better features, not more features.",
                            values: {
                                span: (chunks)=>/*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        children: chunks
                                    })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_syaz1gfe _1mouidpf _14b51n8h _1m0r1wug",
                            "body-lg"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "JiraProductDiscoveryPage.cta.section.subheading",
                            defaultMessage: "Leave the guess work behind and build products your customers love."
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                        color: "yellow",
                        variant: "primary",
                        size: "small",
                        dataEventProps: {
                            "data-event-component": "linkButton",
                            "data-event-container": "ctaSection",
                            "data-event": "clicked",
                            "data-product-key": "jiraProductDiscovery",
                            "data-label-english": "Get it free",
                            "data-track-event": "jiraProductDiscovery.get-it-free-button-clicked"
                        },
                        href: signupLink,
                        onClick: openCrossFlow,
                        className: (0, $esG4f.default)([
                            "_1pfhpxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "JiraProductDiscoveryPage.cta.section.cta.text",
                            defaultMessage: "Get it free"
                        })
                    })
                ]
            })
        })
    });
};
var $67f5ab58647a7f49$export$2e2bcd8739ae039 = $67f5ab58647a7f49$var$CtaSection;
const $67f5ab58647a7f49$var$container = null;
const $67f5ab58647a7f49$var$sectionStyle = null;
const $67f5ab58647a7f49$var$textStyle = null;
const $67f5ab58647a7f49$var$accent = null;
const $67f5ab58647a7f49$var$button = null;

});

parcelRegister("bWsik", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13a927b880777675$export$2e2bcd8739ae039; });
/* customers.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $13a927b880777675$var$sectionStyle = null;
const $13a927b880777675$var$logosGridStyle = null;
const $13a927b880777675$var$liStyle = null;
const $13a927b880777675$var$Customers = ()=>{
    const logos = [
        {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/260w4830ha12g7838ik7j5rq3ex31h8h.svg",
            alt: "Canva",
            width: 136,
            height: 43
        },
        {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4ojx82fmj7q6l0354r1qfe572un65j0m.svg",
            alt: "Coupa",
            width: 158
        },
        {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/g76770b7kmwx457yu43qbo42h874ann8.svg",
            alt: "Docker",
            width: 158
        },
        {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/7ivn8866tpd7e4155176u71d4syycwc8.webp",
            alt: "The Economist",
            width: 112
        },
        {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4x7bp61gn38200m4omcfxsx0cm75w71i.svg",
            alt: "Deliveroo",
            width: 148
        },
        {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/mmi427i07l27j8ul2aj32h25144vb65u.svg",
            alt: "Decathlon",
            width: 156
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_6rth12bs _y3gn1h6o _syazvejh"
        ]),
        style: {
            "--_nl5by5": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue1000"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                layout: "12",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    className: "h5",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "JiraProductDiscoveryPage.customers.heading",
                        defaultMessage: "Join the 10,000+ customers who build products with Jira Product Discovery"
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                layout: "12",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                    className: (0, $esG4f.default)([
                        "_1e0c11p5 _zulpviql _yv0e14qi _4cvr1h6o _6a6z1h6o _19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw _1bsb1osq _rtys1osq _1da7nl51 _1rqt1g7m"
                    ]),
                    children: logos.map((logo)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                            className: (0, $esG4f.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                image: (0, $7Knp0._)({}, logo)
                            })
                        }, logo.src))
                })
            })
        ]
    });
};
var $13a927b880777675$export$2e2bcd8739ae039 = $13a927b880777675$var$Customers;

});

parcelRegister("2m2Kl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fca3dc2ec5a05c1b$export$2e2bcd8739ae039; });
/* demo.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $91nJf = parcelRequire("91nJf");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $fca3dc2ec5a05c1b$var$bannerStyle = null;
const $fca3dc2ec5a05c1b$var$imgStyle = null;
const $fca3dc2ec5a05c1b$var$buttonStyle = null;
const $fca3dc2ec5a05c1b$var$DemoBanner = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_11q7owgw _2rkovwyg _1e0c11p5 _yv0ehkll _4cvr1h6o _6a6z1h6o _zulp1ejb _1bsb1osq _1q51xy5q _18zrpxbi _6rthxy5q _y3gn1h6o _12e81fhb _uj6kv2br _1j8b7y8c _16imze3t _su07xy5q _jplc1xh7 _bj231xh7"
            ]),
            style: {
                "--_1lpv4ka": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.lime")),
                "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card"))
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: "h3",
                    children: intl.formatMessage({
                        id: "JiraProductDiscoveryPage.demo.body.text",
                        defaultMessage: "Join our demo with live chat Q&A"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                    variant: "secondary",
                    color: "black",
                    href: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery/demo"),
                    dataEventProps: {
                        "data-event": "clicked",
                        "data-event-container": "banner-link-button",
                        "data-event-component": "linkButton",
                        "data-product-key": "jiraProductDiscovery"
                    },
                    className: (0, $esG4f.default)([
                        "_10fp1h6o"
                    ]),
                    children: intl.formatMessage({
                        id: "JiraProductDiscoveryPage.demo.cta.text",
                        defaultMessage: "Register now"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ua18axib18162bej4n515osj7675wepi.webp",
                        alt: intl.formatMessage({
                            id: "JiraProductDiscoveryPage.demo.screenshot.alt",
                            defaultMessage: "Screenshot of Jira Product Discovery"
                        }),
                        width: 368,
                        height: 154
                    },
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1wpzesu3 _p12f1osq _1kr6kb7n _dz5jcs5v _rtys1osq _bna71wug"
                    ])
                })
            ]
        })
    });
};
var $fca3dc2ec5a05c1b$export$2e2bcd8739ae039 = $fca3dc2ec5a05c1b$var$DemoBanner;

});

parcelRegister("fnNPE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad3bf2e3963eccf6$export$2e2bcd8739ae039; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $i8kxh = parcelRequire("i8kxh");

var $91nJf = parcelRequire("91nJf");

var $3LLDq = parcelRequire("3LLDq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $ad3bf2e3963eccf6$var$Hero = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-product-discovery");
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).JIRA_PRODUCT_DISCOVERY,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1reo15vq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            layout: "8",
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_y3gn1h6o _1rjc1lhf _26vxxncg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                        className: (0, $esG4f.default)([
                            "_kqswh2mm _1g0v1mrw _1cs8stnw _1kt9b3bt _1tes18wq _18crxkqj _f6gemgnk _wkf1wsfl _1nrl42os _1gg83zxr",
                            "superhero"
                        ]),
                        children: intl.formatMessage({
                            id: "JiraProductDiscoveryPage.hero.heading.super",
                            defaultMessage: "From ideas to <em>impact</em>, build what matters"
                        }, (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
                            em: (text)=>{
                                return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                    className: (0, $esG4f.default)([
                                        "_kqswh2mm _1cs8stnw _1kt9b3bt _1tesidpf _18crnqtd _f6gemgnk _wkf1174u _7dwz1vci _5z7wyan6 _1kwx1wlv _5t3mz98b"
                                    ]),
                                    children: text
                                });
                            }
                        }))
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: "body-lg",
                        children: intl.formatMessage({
                            id: "JiraProductDiscoveryPage.hero.subtitle",
                            defaultMessage: "Capture insights, prioritize ideas, and build roadmaps - all in Jira"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                        href: signupLink,
                        onClick: openCrossFlow,
                        variant: "primary",
                        dataEventProps: {
                            "data-event": "clicked",
                            "data-event-container": "heroSection",
                            "data-event-component": "linkButton",
                            "data-product-key": "jiraProductDiscovery",
                            "data-label-english": "Get it free",
                            "data-track-event": "jiraProductDiscovery.get-it-free-button-clicked"
                        },
                        className: (0, $esG4f.default)([
                            "_1pfhpxbi"
                        ]),
                        children: intl.formatMessage({
                            id: "JiraProductDiscoveryPage.hero.cta.label",
                            defaultMessage: "Get it free"
                        })
                    })
                ]
            })
        })
    });
};
var $ad3bf2e3963eccf6$export$2e2bcd8739ae039 = $ad3bf2e3963eccf6$var$Hero;
const $ad3bf2e3963eccf6$var$container = null;
const $ad3bf2e3963eccf6$var$heroContainer = null;
const $ad3bf2e3963eccf6$var$heading = null;
const $ad3bf2e3963eccf6$var$impact = null;
const $ad3bf2e3963eccf6$var$button = null;

});

parcelRegister("bvUhK", function(module, exports) {

$parcel$export(module.exports, "HowItWorks", function () { return $c6ee42b1c3c776e3$export$409faa00494a55a; });
/* how-it-works.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $cutM5 = parcelRequire("cutM5");
parcelRequire("bGE1b");
var $1p5F6 = parcelRequire("1p5F6");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");

var $cYqjE = parcelRequire("cYqjE");

var $28vYy = parcelRequire("28vYy");
const $c6ee42b1c3c776e3$export$409faa00494a55a = ()=>{
    const intl = (0, $f6qj2.default)();
    const cardRef = (0, $iSvIT.useRef)(null);
    const [activeTeamIndex, setActiveTeamIndex] = (0, $iSvIT.useState)(0);
    const [activeTeamData, setActiveTeamData] = (0, $iSvIT.useState)((0, $cYqjE.TEAM_DATA)[0]);
    (0, $iSvIT.useEffect)(()=>{
        setActiveTeamData((0, $cYqjE.TEAM_DATA)[activeTeamIndex]);
    }, [
        activeTeamIndex
    ]);
    const renderActiveMedia = ()=>{
        const { heroImage: heroImage, contentTitle: contentTitle, contentText: contentText, quoteColor: quoteColor, quoteText: quoteText, customerName: customerName, customerTitle: customerTitle } = activeTeamData;
        const quoteProps = {
            quoteColor: quoteColor,
            quoteText: intl.formatMessage(quoteText),
            customerName: intl.formatMessage(customerName),
            customerTitle: intl.formatMessage(customerTitle)
        };
        return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                    layout: "4-8",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                    children: intl.formatMessage(contentTitle)
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                    children: intl.formatMessage(contentText)
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_kzviglyw"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $28vYy.default), (0, $7Knp0._)({}, quoteProps))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_mezj1osq _bna71wug"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                image: {
                                    src: heroImage,
                                    alt: ""
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_dm25glyw _sugaglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                        layout: "8",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $28vYy.default), (0, $7Knp0._)({}, quoteProps))
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "homepage-v2-hero",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
            id: "hero-jira-cta",
            className: (0, $esG4f.default)([
                "_1reo15vq _18m915vq _6rth1ylp"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            className: (0, $esG4f.default)([
                                "_ect41pz4 _1wyb1ylp _k48p1fw0 _vwz4ckbl _y3gn1h6o"
                            ]),
                            style: {
                                "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                className: (0, $esG4f.default)([
                                    "_kqswh2mm _18postnw _z0ai1qo0 _1qdg1qjk _1guf1lpd _1czd17hu _aetrb3bt _3p6m1s0j _1mhxca9o _1nww1ul9 _1y2q17rr _sjmw1lpd _1efb101a"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "JiraProductDiscoveryPage.howItWorks.header",
                                    defaultMessage: "How it works",
                                    values: {
                                        teams: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1p5F6.Adg4TextUnderline), {
                                                underline: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                                                    width: "100%",
                                                    height: "30",
                                                    viewBox: "0 0 306 42",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                                        d: "M0.314542 22.3672C52.9464 14.9125 91.8245 33.6666 144.966 18.1254C147.46 24.7349 153.892 33.0058 163.497 33.1094C155.486 32.9725 142.641 15.7178 155.536 27.2686C163.119 36.0683 196.172 25.2364 170.842 32.944C188.334 31.2885 204.356 20.5339 216.163 10.9702C235.811 -2.65832 220.928 23.6737 235.178 36.8756C255.37 55.2242 316.463 7.29572 304.134 7.28816C296.296 13.2947 285.769 17.046 281.423 23.6985C204.757 63.1757 259.992 -9.72674 214.311 2.55426C139.744 53.2533 177.393 7.4163 133.572 10.6223C108.06 28.9946 -0.613806 0.46356 0.29434 22.3672L0.314542 22.3672Z",
                                                        fill: "#FFA900"
                                                    })
                                                }),
                                                children: str
                                            }),
                                        br: /*#__PURE__*/ (0, $loA2J.jsx)("br", {})
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            ref: cardRef,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4Tabs), {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTabList), {
                                        className: (0, $esG4f.default)([
                                            "_1e0c1txw _1bah1yb4 _19pkidpf _2hwx1wug _otyridpf _18u01wug _6rth12am _zulpckbl"
                                        ]),
                                        children: (0, $cYqjE.TEAM_DATA).map(({ title: title, id: id, icon: icon, englishLabel: englishLabel }, index)=>{
                                            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTab), {
                                                onClick: ()=>{
                                                    setActiveTeamIndex(index);
                                                },
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                                    "data-product-key": "home",
                                                    "data-event-component": "button",
                                                    "data-event-container": "heroSection",
                                                    "data-event": "clicked",
                                                    "data-label-english": englishLabel,
                                                    "aria-label": intl.formatMessage(title),
                                                    className: (0, $esG4f.default)([
                                                        "_19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _d0altlke"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                                        className: (0, $esG4f.default)([
                                                            "_vchhusvi _1e0c1txw _2lx21bp4 _1bsbh2q2 _4cvr1h6o _ca0qi2wt _u5f3i2wt _n3tdi2wt _19bvi2wt _zulpidpf _2rkoi2wt _19itt94y _11q7m7j4 _1j55glyw _19lc15ej _kbawglyw _1x381ule",
                                                            activeTeamIndex === index && "_19it1dfy _2rkoi2wt _1kd31fw0"
                                                        ]),
                                                        children: [
                                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                                className: (0, $esG4f.default)([
                                                                    "_4t3i3okq _1bsb3okq _mezj3okq _bna73okq",
                                                                    "default-icon"
                                                                ]),
                                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                                                    image: {
                                                                        src: `${icon}`,
                                                                        alt: "",
                                                                        draggable: "false"
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                                className: (0, $esG4f.default)([
                                                                    "_4t3i3okq _1bsb3okq _mezj3okq _bna73okq",
                                                                    "hover-icon"
                                                                ]),
                                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                                                    image: {
                                                                        src: icon,
                                                                        alt: "",
                                                                        draggable: "false"
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                                className: (0, $esG4f.default)([
                                                                    "_ect41pz4 _k48p1nn1 _1wyb1j6v _vwz41k8s _syazqlpt"
                                                                ]),
                                                                style: {
                                                                    "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                                                                },
                                                                children: intl.formatMessage(title)
                                                            })
                                                        ]
                                                    })
                                                })
                                            }, id);
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
                            children: renderActiveMedia()
                        })
                    ]
                })
            })
        })
    });
};
const $c6ee42b1c3c776e3$var$jiraHeroStyles = null;
const $c6ee42b1c3c776e3$var$heroTitleStyles = null;
const $c6ee42b1c3c776e3$var$heroTitleSpanStyles = null;
const $c6ee42b1c3c776e3$var$buttonResetStyle = null;
const $c6ee42b1c3c776e3$var$tabsStyle = null;
const $c6ee42b1c3c776e3$var$teamCardStyles = null;
const $c6ee42b1c3c776e3$var$iconContainerStyles = null;
const $c6ee42b1c3c776e3$var$teamCardTextStyles = null;
const $c6ee42b1c3c776e3$var$teamCardActiveStyles = null;
const $c6ee42b1c3c776e3$var$imageOverrideStyles = null;
const $c6ee42b1c3c776e3$var$quoteStyles = null;
const $c6ee42b1c3c776e3$var$tabletQuoteStyles = null;

});
parcelRegister("bGE1b", function(module, exports) {
$parcel$export(module.exports, "Adg4TextUnderline", function () { return (parcelRequire("1p5F6")).Adg4TextUnderline; });
parcelRequire("1p5F6");

});
parcelRegister("1p5F6", function(module, exports) {

$parcel$export(module.exports, "Adg4TextUnderline", function () { return $23a59b9be0d723ab$export$a8ef4069b9c5e8b7; });
/* text-underline.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $eDoPe = parcelRequire("eDoPe");
const $23a59b9be0d723ab$var$textStyle = null;
const $23a59b9be0d723ab$var$inViewTextStyle = null;
const $23a59b9be0d723ab$var$underlineStyle = null;
const $23a59b9be0d723ab$var$inViewUnderlineStyle = null;
const $23a59b9be0d723ab$var$hiddenText = null;
const $23a59b9be0d723ab$var$visibleText = null;
const $23a59b9be0d723ab$export$a8ef4069b9c5e8b7 = ({ text: text, children: children, underline: underline, underlineInset: underlineInset = "-37.5%", underlineLeft: underlineLeft = false, fontWeight: fontWeight = {
    from: 400,
    to: 800
}, useInViewOptions: useInViewOptions })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)(useInViewOptions);
    const fontWeightAnimation = null;
    const underlineInsetStyle = null;
    const toFontWeight = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
        ref: scrollRef,
        className: (0, $esG4f.default)([
            "_1e0c116y _19pkidpf _2hwxidpf _otyridpf _18u0idpf _kqswh2mm _ju251bs3 _5sagfnf5 _tip8kb7n _1o51q7pw _vwz4kb7n _1nmz1hna",
            sectionIsVisible && "_j7hq1dkr"
        ]),
        style: {
            "--_15xzfe0": (0, $43MIc.default)(fontWeight.from),
            "--_1bgzcf7": (0, $43MIc.default)(fontWeight.to)
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                "aria-hidden": true,
                className: (0, $esG4f.default)([
                    "_3um015vq _lcxvglyw",
                    "_k48p103h"
                ]),
                style: {
                    "--_1bgzcf7": (0, $43MIc.default)(fontWeight.to)
                },
                children: text !== null && text !== void 0 ? text : children
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _1e02idpf"
                ]),
                children: text !== null && text !== void 0 ? text : children
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bsb1osq _mkrz16t8 _ju251bs3 _5sagpwmj _tip8kb7n _1e02idpf _1o51q7pw _kqswstnw _1pby1mrw",
                    "_u7co11y5 _cjf710zq _1kni10zq",
                    sectionIsVisible && "_j7hqzu28"
                ]),
                style: {
                    "--_1jmpxqi": (0, $43MIc.default)(underlineInset),
                    "--_p0j3r4": (0, $43MIc.default)(underlineLeft ? "0" : "auto")
                },
                children: underline
            })
        ]
    });
};

});


parcelRegister("cYqjE", function(module, exports) {

$parcel$export(module.exports, "TEAM_DATA", function () { return $cf5d85e4a8ac8e6e$export$860b41270ca4de2e; });

var $6x1qA = parcelRequire("6x1qA");
const $cf5d85e4a8ac8e6e$export$860b41270ca4de2e = [
    {
        id: "software",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/0tktsadc6a0h85663hv4lb34mml07y0g.svg",
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/1l8b1267j66mc1b334eua3gyam2nggrx.webp",
        title: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.label.tab1",
            defaultMessage: "Capture"
        }),
        englishLabel: "Capture",
        contentTitle: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.title.tab1",
            defaultMessage: "Capture ideas and insights"
        }),
        contentText: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.text.tab1",
            defaultMessage: "There\u2019s now a home for all the unstructured work that happens before you start building software. Gather and organize your product opportunities, user feedback, and feature requests all in one place."
        }),
        quoteColor: "blue",
        quoteText: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.text.tab1",
            defaultMessage: "Jira Product Discovery is helping us do the right things, in the right order, and at the right time, focusing on work that will deliver on benefits."
        }),
        customerName: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.name.tab1",
            defaultMessage: "John Sayers"
        }),
        customerTitle: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.title.tab1",
            defaultMessage: "PMO Lead, Renaissancere"
        })
    },
    {
        id: "product-management",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/kha7lb4n41e6nqbfm6uu8jwym0dumt36.svg",
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/ohh610p3j7iv5hyda53yqh0006v40258.webp",
        title: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.label.tab2",
            defaultMessage: "Prioritize"
        }),
        englishLabel: "Prioritize",
        contentTitle: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.title.tab2",
            defaultMessage: "Prioritize \u2013 your way"
        }),
        contentText: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.text.tab2",
            defaultMessage: "Flexible views and granular fields let you compare ideas against one another using the prioritization method that works best for you."
        }),
        quoteColor: "lime",
        quoteText: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.text.tab2",
            defaultMessage: "Up until Jira Product Discovery, even with other roadmapping tools, we\u2019ve had to use shared spreadsheets and slide presentations to coordinate prioritization in an accessible way. However, within a week of \u201Ctrying\u201D out Jira Product Discovery, it became clear it was the tool to invest in going forward."
        }),
        customerName: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.name.tab2",
            defaultMessage: "John Daily Jr."
        }),
        customerTitle: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.title.tab2",
            defaultMessage: "Head of Product, Karhoo"
        })
    },
    {
        id: "marketing",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/36m76eu4oo0e46hvd21s744fn11i35q5.svg",
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/2fh1741j5vly80365ofehwwe0qes6b4a.webp",
        title: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.label.tab3",
            defaultMessage: "Engage"
        }),
        englishLabel: "Engage",
        contentTitle: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.title.tab3",
            defaultMessage: "Engage and align your teams"
        }),
        contentText: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.text.tab3",
            defaultMessage: "Create and share roadmaps tailored to individual stakeholders \u2013 even ones outside your organization \u2013 and let them provide feedback via comments, votes, or simple reactions."
        }),
        quoteColor: "purple",
        quoteText: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.text.tab3",
            defaultMessage: "Jira Product Discovery has revitalized how we think about roadmaps."
        }),
        customerName: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.name.tab3",
            defaultMessage: "Adam Chapman"
        }),
        customerTitle: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.title.tab3",
            defaultMessage: "Full Stack Developer, Apex Networks"
        })
    },
    {
        id: "project-management",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/3e2ln2b76w2544cn5633031qjtn2fobe.svg",
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/r1elfv055406ty7x72u4000npq20n46m.webp",
        title: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.label.tab4",
            defaultMessage: "Connect"
        }),
        englishLabel: "Connect",
        contentTitle: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.title.tab4",
            defaultMessage: "Connect teams, all in Jira"
        }),
        contentText: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.text.tab4",
            defaultMessage: "Seamlessly connect your ideas to delivery work in Jira so your teams have full context and visibility from discovery to delivery."
        }),
        quoteColor: "yellow",
        quoteText: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.text.tab4",
            defaultMessage: "Jira Product Discovery combines everything I was doing in spreadsheets and Powerpoints into one easy-to-navigate tool. Plus everything is added straight into Jira, instead of requiring some third-party tool to integrate."
        }),
        customerName: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.name.tab4",
            defaultMessage: "Abby Kiesling"
        }),
        customerTitle: (0, $6x1qA.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.title.tab4",
            defaultMessage: "Product Manager, EZ Texting"
        })
    }
];

});

parcelRegister("28vYy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6eed829f7fc44a38$export$2e2bcd8739ae039; });
/* testimonial-quote.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("3QHAr");
var $bESgj = parcelRequire("bESgj");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");
const $6eed829f7fc44a38$var$quoteStyles = null;
const $6eed829f7fc44a38$var$quotePStyles = null;
const $6eed829f7fc44a38$var$portraitStyles = null;
const $6eed829f7fc44a38$var$nameStyles = null;
const $6eed829f7fc44a38$var$titleStyles = null;
const $6eed829f7fc44a38$var$quoteSrcMap = {
    yellow: "https://dam-cdn.atl.orangelogic.com/AssetLink/3ixqjd5540sdn251h25h55i82occ48sa.svg",
    purple: "https://dam-cdn.atl.orangelogic.com/AssetLink/0ho3162460jba51mgj0a16k3cpvy074s.svg",
    lime: "https://dam-cdn.atl.orangelogic.com/AssetLink/q6j1k002cmxpvr2145m8q3u70gfrm2qt.svg",
    blue: "https://dam-cdn.atl.orangelogic.com/AssetLink/504175ycu5d01061dg4evte5l0m72pea.svg",
    none: ""
};
const $6eed829f7fc44a38$var$TestimonialQuote = ({ quoteText: quoteText, customerName: customerName, customerTitle: customerTitle, quoteColor: quoteColor, colorAgainst: colorAgainst })=>{
    const quoteImage = {
        src: $6eed829f7fc44a38$var$quoteSrcMap[quoteColor],
        alt: customerTitle
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_11q7qbzx _ca0q1ul9 _u5f3gktf _n3td1ul9 _19bv53f4 _kqswh2mm _1pfhzwfg _14dk1fw0"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_kqswh2mm _19pkidpf _2hwxidpf _otyr1j6v _18u0idpf _ect4bzd7 _1wybdlk8 _k48p1nn1 _vwz4gktf _y3gn1e5h",
                            "body-sm"
                        ]),
                        style: {
                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                        },
                        children: quoteText
                    }),
                    quoteColor !== "none" && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_kqswstnw _1bsb88uy _1e02gktf _152tgktf"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                            image: quoteImage
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_kqswh2mm _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1mt11ul9",
                            "body-sm name"
                        ]),
                        children: customerName
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_kqswh2mm _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1p1dangw",
                            "fine-print"
                        ]),
                        children: customerTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bESgj.Adg4SectionDivider), {
                variation: (0, $bESgj.SECTION_DIVIDER_VARIATION).FLIP,
                desktopHeight: 15,
                tabletHeight: 15,
                mobileHeight: 15,
                bgColor: "var(--ds-surface-sunken, #F7F8F9)",
                colorAgainst: colorAgainst
            })
        ]
    });
};
var $6eed829f7fc44a38$export$2e2bcd8739ae039 = $6eed829f7fc44a38$var$TestimonialQuote;

});


parcelRegister("iGwIR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d33928026e868f01$export$2e2bcd8739ae039; });
/* side-by-side.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $bhreu = parcelRequire("bhreu");
parcelRequire("ElG1F");
var $1bVgT = parcelRequire("1bVgT");
const $d33928026e868f01$var$SideBySide = ()=>{
    const intl = (0, $f6qj2.default)();
    const items = [
        {
            title: intl.formatMessage({
                id: "JiraProductDiscoveryPage.scroller.1.title",
                defaultMessage: "Bring structure to chaos"
            }),
            description: intl.formatMessage({
                id: "JiraProductDiscoveryPage.scroller.1.description",
                defaultMessage: "Leverage data and customer insights to help your team prioritize ideas that will make the biggest impact."
            }),
            img: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8i4ut65m3p28wvyedk7505mtqm5kiqr3.webp",
                alt: "",
                width: 768,
                height: 512
            }
        },
        {
            title: intl.formatMessage({
                id: "JiraProductDiscoveryPage.scroller.2.title",
                defaultMessage: "Get everyone on the same page"
            }),
            description: intl.formatMessage({
                id: "JiraProductDiscoveryPage.scroller.2.description",
                defaultMessage: "Spend less time updating and persuading with custom roadmaps that give your stakeholders the information they need."
            }),
            img: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/g5xp0826vanhei54fi3437v7nr227cn7.webp",
                alt: "",
                width: 768,
                height: 512
            }
        },
        {
            title: intl.formatMessage({
                id: "JiraProductDiscoveryPage.scroller.3.title",
                defaultMessage: "Connect discovery and delivery in Jira"
            }),
            description: intl.formatMessage({
                id: "JiraProductDiscoveryPage.scroller.3.description",
                defaultMessage: "Reduce context switching, add visibility, and move faster by seamlessly connecting your ideas to the delivery work happening in Jira."
            }),
            img: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/767r1t8n744265g8k4550obw1udklx2f.webp",
                alt: "",
                width: 768,
                height: 512
            }
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1reozryt"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1bVgT.Scroller), {
                items: items,
                renderText: (item)=>/*#__PURE__*/ (0, $loA2J.jsx)($d33928026e868f01$var$ScrollerContent, {
                        item: item
                    }),
                renderGraphic: (item)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: item.img,
                        className: (0, $esG4f.default)([
                            "_p12f1osq _rtys1osq _bna71wug"
                        ])
                    }),
                layout: "right",
                mobileGraphicLayout: "above",
                backgroundColor: "#fff",
                inScrollBackgroundColor: "#fff",
                heading: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_y3gn1h6o _1bsb1osq _1e0c11p5 _85i5xy5q"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            className: (0, $esG4f.default)([
                                "_6rthidpf"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraProductDiscoveryPage.scroller.heading.text",
                                defaultMessage: "Discover your next great product idea"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraProductDiscoveryPage.scroller.subheading.text",
                                defaultMessage: "Better product decisions are made as a team"
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $d33928026e868f01$export$2e2bcd8739ae039 = $d33928026e868f01$var$SideBySide;
const $d33928026e868f01$var$ScrollerContent = ({ item: item })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                children: item.title
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                children: item.description
            })
        ]
    });
};
const $d33928026e868f01$var$sectionStyle = null;
const $d33928026e868f01$var$scrollerHeading = null;
const $d33928026e868f01$var$heading = null;
const $d33928026e868f01$var$imgStyle = null;

});
parcelRegister("ElG1F", function(module, exports) {
$parcel$export(module.exports, "Scroller", function () { return (parcelRequire("1bVgT")).Scroller; });
parcelRequire("1bVgT");

});
parcelRegister("1bVgT", function(module, exports) {

$parcel$export(module.exports, "ScrollContext", function () { return $570cb559c6297724$export$dece24112a937f92; });
$parcel$export(module.exports, "Scroller", function () { return $570cb559c6297724$export$76d6749d1cf8513c; });
/* scroller.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $eDoPe = parcelRequire("eDoPe");

var $b5A0L = parcelRequire("b5A0L");
const $570cb559c6297724$export$dece24112a937f92 = /*#__PURE__*/ (0, $iSvIT.createContext)({
    activeIndex: 0,
    setActiveIndex: ()=>{
        return;
    },
    graphicHeight: 100,
    graphicTopBottom: {
        top: 188,
        bottom: 288
    }
});
const $570cb559c6297724$export$76d6749d1cf8513c = ({ items: items, renderText: renderText, renderGraphic: renderGraphic, heading: heading, layout: layout = "left", mobileGraphicLayout: mobileGraphicLayout = "above", backgroundColor: backgroundColor = "#fff", inScrollBackgroundColor: inScrollBackgroundColor, scrollerInViewOptions: scrollerInViewOptions, navHeight: navHeight = 68 })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)((0, $7Knp0._)({
        threshold: 0.2
    }, scrollerInViewOptions));
    const containerRef = /*#__PURE__*/ (0, $iSvIT.createRef)();
    const graphicRef = /*#__PURE__*/ (0, $iSvIT.createRef)();
    const headingRef = /*#__PURE__*/ (0, $iSvIT.createRef)();
    const [activeIndex, setActiveIndex] = (0, $iSvIT.useState)(0); /**
                                                      * The calculated top position to use for the graphic
                                                      */ 
    const [graphicTop, setGraphicTop] = (0, $iSvIT.useState)(navHeight + 100); /**
                                                                  * The height of the graphic, used to set min height on the text column
                                                                  */ 
    const [graphicHeight, setGraphicHeight] = (0, $iSvIT.useState)(null); /**
                                                                            * The calculated top and bottom positions
                                                                            * to use for determining if an item is aligned with the graphic
                                                                            */ 
    const [graphicTopBottom, setGraphicTopBottom] = (0, $iSvIT.useState)(null);
    (0, $iSvIT.useEffect)(()=>{
        if (!containerRef.current || !graphicRef.current || !headingRef.current || !window) return;
         // Where the magic happens
        const calculateSizes = ()=>{
            var _graphicRef_current, _headingRef_current;
            var _graphicRef_current_clientHeight;
            // Vertically center the graphic +navHeight for the sticky nav
            const currentGraphicHeight = (_graphicRef_current_clientHeight = (_graphicRef_current = graphicRef.current) === null || _graphicRef_current === void 0 ? void 0 : _graphicRef_current.clientHeight) !== null && _graphicRef_current_clientHeight !== void 0 ? _graphicRef_current_clientHeight : 100;
            var _headingRef_current_clientHeight;
            const currentHeaderHeight = (_headingRef_current_clientHeight = (_headingRef_current = headingRef.current) === null || _headingRef_current === void 0 ? void 0 : _headingRef_current.clientHeight) !== null && _headingRef_current_clientHeight !== void 0 ? _headingRef_current_clientHeight : 100;
            const viewHeight = window.innerHeight;
            const minGraphicY = navHeight + currentHeaderHeight;
            const top = (viewHeight - navHeight - currentGraphicHeight) / 2 + navHeight;
            const newTop = Math.max(minGraphicY, top);
            const newBottom = Math.min(viewHeight, newTop + currentGraphicHeight);
            setGraphicTop(Math.max(minGraphicY, top));
            setGraphicHeight(currentGraphicHeight);
            setGraphicTopBottom({
                top: newTop,
                bottom: newBottom
            });
        };
        const observer = new ResizeObserver(()=>{
            calculateSizes();
        });
        observer.observe(containerRef.current);
        return ()=>{
            // Cleanup the observer by unobserving all elements
            observer.disconnect();
        };
    }, [
        containerRef,
        graphicRef,
        headingRef,
        navHeight
    ]);
    const backgroundStyle = null;
    const inViewBackgroundStyle = null;
    const dynamicHeadingStyle = null;
    const inViewHeaderBackgroundStyle = null;
    var _items_activeIndex;
    const currentItem = (_items_activeIndex = items[activeIndex]) !== null && _items_activeIndex !== void 0 ? _items_activeIndex : items[0];
    return /*#__PURE__*/ (0, $loA2J.jsx)($570cb559c6297724$export$dece24112a937f92.Provider, {
        value: {
            activeIndex: activeIndex,
            setActiveIndex: setActiveIndex,
            graphicHeight: graphicHeight,
            graphicTopBottom: graphicTopBottom
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            ref: scrollRef,
            className: (0, $esG4f.default)([
                "_bfhkaxbu",
                sectionIsVisible && "_bfhk1tlu"
            ]),
            style: {
                "--_1ly4823": (0, $43MIc.default)(backgroundColor),
                "--_1p67x28": (0, $43MIc.default)(inScrollBackgroundColor)
            },
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                ref: containerRef,
                className: (0, $esG4f.default)([
                    "_kqswh2mm _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _1e0c1txw _2lx2vrvc _18zrzwfg _umua1wqb _owpu1wqb _gltezqdx",
                    "_85i568cl _1q51mgvx _4cvr1y6m _zulp1wqb _10l5idpf _1w2i1bp4",
                    layout === "right" && "_2lx21sbv"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        style: {
                            insetBlockEnd: graphicHeight ? graphicHeight + $570cb559c6297724$var$contentBlockEnd + "px" : "auto"
                        },
                        className: (0, $esG4f.default)([
                            "_kqswstnw _152tidpf _1e02idpf _rjxpidpf _1e0c1txw _1bah1h6o _rolbh2mm"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_16jlkb7n _1o9zkb7n _i0dl1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                ref: headingRef,
                                className: (0, $esG4f.default)([
                                    "_kqswh2mm _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _1e0c1txw _2lx2vrvc _18zrzwfg _umua1wqb _owpu1wqb _gltezqdx",
                                    "_152t1gys",
                                    "_1pbykb7n _kqsw1if8 _rolbh2mm _14ucidpf",
                                    sectionIsVisible && "_1itk1qvr"
                                ]),
                                style: {
                                    "--_l57dfm": (0, $43MIc.default)(navHeight ? navHeight + "px" : 0),
                                    "--_1p67x28": (0, $43MIc.default)(inScrollBackgroundColor)
                                },
                                children: heading
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_i0dlhwvj _311g1kc5 _c7541h6o"
                        ]),
                        children: items.map((item, i)=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $b5A0L.ScrollerItem), {
                                index: i,
                                children: [
                                    mobileGraphicLayout === "above" && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0cglyw _1yba1ule"
                                        ]),
                                        children: renderGraphic(item, activeIndex, true)
                                    }),
                                    renderText(item),
                                    mobileGraphicLayout === "below" && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0cglyw _1yba1ule"
                                        ]),
                                        children: renderGraphic(item, activeIndex, true)
                                    })
                                ]
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        ref: graphicRef,
                        style: {
                            insetBlockStart: graphicTop + "px"
                        },
                        className: (0, $esG4f.default)([
                            "_4cvresu3 _1e0c1txw _2lx21bp4 _1bah1h6o _i0dl1nrf _kqsw1if8 _1ybaglyw"
                        ]),
                        children: renderGraphic(currentItem, activeIndex, false)
                    })
                ]
            })
        })
    });
};
const $570cb559c6297724$var$mediaQuery = "@media (max-height: 49.99vw) and (max-width: 1271.99px), (max-height: 635.99px) and (min-width: 1272px), not all and (min-width: 48rem)";
const $570cb559c6297724$var$contentBlockEnd = 120;
const $570cb559c6297724$var$rowStyles = null;
const $570cb559c6297724$var$contentStyle = null;
const $570cb559c6297724$var$headingContainer = null;
const $570cb559c6297724$var$headingColumnContainer = null;
const $570cb559c6297724$var$headingStyle = null;
const $570cb559c6297724$var$rtlRowStyles = null;
const $570cb559c6297724$var$textColumn = null;
const $570cb559c6297724$var$mobileItemStyle = null;
const $570cb559c6297724$var$graphicColumn = null;

});
parcelRegister("b5A0L", function(module, exports) {

$parcel$export(module.exports, "ScrollerItem", function () { return $bfabf9ce9332d9b7$export$11692ab46144d76c; });
/* scroller-item.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $eDoPe = parcelRequire("eDoPe");

var $1bVgT = parcelRequire("1bVgT");
const $bfabf9ce9332d9b7$export$11692ab46144d76c = ({ children: children, index: index })=>{
    const { ref: scrollRef, inView: sectionInView } = (0, $eDoPe.useInView)({
        threshold: 0.25
    });
    const itemRef = /*#__PURE__*/ (0, $iSvIT.createRef)();
    const { setActiveIndex: setActiveIndex, graphicHeight: graphicHeight, graphicTopBottom: graphicTopBottom } = (0, $iSvIT.useContext)((0, $1bVgT.ScrollContext));
    (0, $iSvIT.useEffect)(()=>{
        if (!document) return;
        const checkElementPosition = ()=>{
            if (!itemRef.current || !graphicTopBottom || !sectionInView) return;
            const rect = itemRef.current.getBoundingClientRect();
            const top = rect.top;
            const bottom = rect.bottom;
            // check if this element overlaps with the top or bottom of the graphic
            if (top >= graphicTopBottom.top && top <= graphicTopBottom.bottom || bottom >= graphicTopBottom.top && bottom <= graphicTopBottom.bottom) setActiveIndex(index);
        };
        document.addEventListener("scroll", checkElementPosition);
        return ()=>{
            document.removeEventListener("scroll", checkElementPosition);
        };
    }, [
        setActiveIndex,
        index,
        itemRef,
        graphicTopBottom,
        sectionInView
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        ref: scrollRef,
        style: {
            minHeight: graphicHeight ? graphicHeight + "px" : "auto"
        },
        className: (0, $esG4f.default)([
            "_kqswh2mm _4t3i1osq _c71l1a8x _1e0c1txw _2lx21bp4 _1bah1h6o _37sk1kxc _19yo1h90 _14q01wqb"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            ref: itemRef,
            className: (0, $esG4f.default)([
                "_1e0c1txw _tzy4kb7n _zulp12am _2lx21bp4"
            ]),
            children: children
        })
    });
};
const $bfabf9ce9332d9b7$var$mediaQuery = "@media (max-height: 49.99vw) and (max-width: 1271.99px), (max-height: 635.99px) and (min-width: 1272px), not all and (min-width: 48rem)";
const $bfabf9ce9332d9b7$var$itemWrapperStyle = null;
const $bfabf9ce9332d9b7$var$itemStyle = null;

});




parcelRegister("9GfN9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6e39944b5408c78$export$2e2bcd8739ae039; });
/* video.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $bhreu = parcelRequire("bhreu");
parcelRequire("isSvf");
var $lxS8L = parcelRequire("lxS8L");

var $4XrxY = parcelRequire("4XrxY");
const $f6e39944b5408c78$var$HeroVideo = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c11p5 _4cvr1h6o _6a6z1h6o _1pfhmgjw _6rthxy5q _1ob9xncg"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                    image: {
                        alt: "",
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/eskxgojb0g32x168w8yg8g7g2586005n.svg"
                    },
                    className: (0, $esG4f.default)([
                        "_t9ec120f _yyhyrgcp _1ii7rgcp _1bsbj6kd"
                    ])
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $lxS8L.Video), {
                    loop: true,
                    muted: true,
                    // eslint-disable-next-line local/no-non-orangelogic-images-eslint
                    videoLink: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-product-discovery/JPD_product-tour_hero.mp4",
                    className: (0, $esG4f.default)([
                        "_1reozryt _18m9zryt _1h1tcq2i _2rko1kwk _kdam1319 _yyhyrgcp _1ii7rgcp _t9eck9uq _14dmvqnv _sfej3ovx"
                    ])
                })
            ]
        })
    });
};
var $f6e39944b5408c78$export$2e2bcd8739ae039 = $f6e39944b5408c78$var$HeroVideo;
const $f6e39944b5408c78$var$container = null;
const $f6e39944b5408c78$var$video = null;
const $f6e39944b5408c78$var$bgImage = null;

});

parcelRegister("8E2OI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $436d75ff88b5caae$export$2e2bcd8739ae039; });
/* workflow.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $bhreu = parcelRequire("bhreu");

var $4XrxY = parcelRequire("4XrxY");
const $436d75ff88b5caae$var$Workflow = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1bsb1osq _11q7m7j4 _195g1wug _1rjcoahv _2oz41k92 _1hr2kd3c _ecdxxy5q _6ru51ris"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
            layout: "6-6",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            className: (0, $esG4f.default)([
                                "_1mouidpf"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraProductDiscoveryPage.workflow.heading",
                                defaultMessage: "Connect your entire workflow with Jira"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraProductDiscoveryPage.workflow.body.text",
                                defaultMessage: "From strategy and ideation through planning and delivery, bring your entire software lifecycle together in Jira"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1036e8r078n724ru6bb24rdl38bot0iu.webp",
                        alt: ""
                    },
                    className: (0, $esG4f.default)([
                        "_rtys1osq _bna71wug"
                    ])
                })
            ]
        })
    });
};
var $436d75ff88b5caae$export$2e2bcd8739ae039 = $436d75ff88b5caae$var$Workflow;
const $436d75ff88b5caae$var$section = null;
const $436d75ff88b5caae$var$img = null;
const $436d75ff88b5caae$var$bodyContent = null;

});




parcelRegister("3aSr8", function(module, exports) {

$parcel$export(module.exports, "getPricingTitleInternal", function () { return $84e291da3fb54d6c$export$933c1404a4ee79b; });

var $gAJUc = parcelRequire("gAJUc");
const $84e291da3fb54d6c$export$933c1404a4ee79b = ()=>{
    const checkGate = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).jiraProductDiscoveryPremiumWacUpdates);
    return checkGate ? "Jira Product Discovery Pricing Page (GWP-5783)" : "Jira Product Discovery Pricing Page";
};

});

parcelRegister("7Icip", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryPricingPage", function () { return $9d296e7daa530570$export$4771e0906f773aa4; });

var $loA2J = parcelRequire("loA2J");

var $dT5kE = parcelRequire("dT5kE");

var $jHVdH = parcelRequire("jHVdH");
const $9d296e7daa530570$export$4771e0906f773aa4 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dT5kE.PricingContentContextProviderRelay), {
        productId: "jira-product-discovery",
        pricingContent: pricingContent,
        queryRef: queryRef,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            "data-testid": "jpd-pricing-page",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jHVdH.JiraProductDiscoveryPricingPageTemplate), {
                pricing: pricing,
                countryCode: countryCode
            })
        })
    });
};

});
parcelRegister("jHVdH", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryPricingPageTemplate", function () { return $cac683fe5e61a22b$export$6c2556bd70f89142; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("gUyvS");
var $khjAx = parcelRequire("khjAx");

var $dT5kE = parcelRequire("dT5kE");
parcelRequire("3XyMp");
var $f8O3L = parcelRequire("f8O3L");

var $j1oGG = parcelRequire("j1oGG");
parcelRequire("ccYBS");
var $1FqEx = parcelRequire("1FqEx");

var $ceE90 = parcelRequire("ceE90");

var $4CuE6 = parcelRequire("4CuE6");

var $j6Axx = parcelRequire("j6Axx");

var $lVY2b = parcelRequire("lVY2b");

var $6axbG = parcelRequire("6axbG");
const $cac683fe5e61a22b$export$6c2556bd70f89142 = (props)=>{
    const content = (0, $dT5kE.usePricingContentContext)();
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _content_getMoreDetailsTitle, _content_additionalDetails;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PricingPageLayout), {
            nav: /*#__PURE__*/ (0, $loA2J.jsx)((0, $j6Axx.default), {}),
            banner: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4CuE6.JPDBanner), {}),
            showFallback: content === null || content === void 0 ? void 0 : content.hasError,
            children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1FqEx.ParentScrollTracking), {
                scrollTrackingEnabled: true,
                pageId: "jpd-pricing-page",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PageHeading), {
                        children: content === null || content === void 0 ? void 0 : content.headline
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $lVY2b.JiraProductDiscoveryPriceFinder), {
                        pricing: props.pricing,
                        countryCode: props.countryCode
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $khjAx.PricingFeatureTable), {
                        title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                        comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                        compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $f8O3L.QuotationsAdornment), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1FqEx.ParentScrollTracking), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ceE90.PricingFaq), {
                                header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                                planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $6axbG.JpdQuestionsCta), {})
                ]
            })
        })
    });
};

});
parcelRegister("lVY2b", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryPriceFinder", function () { return $1ba74f52034e1541$export$b36576908b6a3c15; });

var $loA2J = parcelRequire("loA2J");

var $6x1qA = parcelRequire("6x1qA");

var $7OWgU = parcelRequire("7OWgU");

var $l9lQF = parcelRequire("l9lQF");

var $dT5kE = parcelRequire("dT5kE");
const $1ba74f52034e1541$export$b36576908b6a3c15 = (props)=>{
    var _content_free, _content_free1, _content_standard, _content_standard1, _content_premium, _content_premium1, _props_pricing_ccpPricingData, _props_pricing;
    const content = {
        free: (0, $dT5kE.usePricingPlanComparison)("Free"),
        standard: (0, $dT5kE.usePricingPlanComparison)("Standard"),
        premium: (0, $dT5kE.usePricingPlanComparison)("Premium")
    };
    var _content_free_planTitleExternal, _content_free_planOneLiner, _content_standard_planTitleExternal, _content_standard_planOneLiner, _content_premium_planTitleExternal, _content_premium_planOneLiner;
    const jiraProductDiscoveryProductPlans = [
        {
            planName: (_content_free_planTitleExternal = (_content_free = content.free) === null || _content_free === void 0 ? void 0 : _content_free.planTitleExternal) !== null && _content_free_planTitleExternal !== void 0 ? _content_free_planTitleExternal : "Free",
            offeringSku: "jira-servicedesk-free",
            description: (_content_free_planOneLiner = (_content_free1 = content.free) === null || _content_free1 === void 0 ? void 0 : _content_free1.planOneLiner) !== null && _content_free_planOneLiner !== void 0 ? _content_free_planOneLiner : "",
            recommendationLimit: 0,
            signupLimit: 20000,
            signupURLSuffix: "?bundle=jira-product-discovery&edition=free&signupSource=pricing"
        },
        {
            planName: (_content_standard_planTitleExternal = (_content_standard = content.standard) === null || _content_standard === void 0 ? void 0 : _content_standard.planTitleExternal) !== null && _content_standard_planTitleExternal !== void 0 ? _content_standard_planTitleExternal : "Standard",
            offeringSku: "jira-product-discovery-standard",
            description: (_content_standard_planOneLiner = (_content_standard1 = content.standard) === null || _content_standard1 === void 0 ? void 0 : _content_standard1.planOneLiner) !== null && _content_standard_planOneLiner !== void 0 ? _content_standard_planOneLiner : "",
            recommendationLimit: 3,
            signupLimit: 20000,
            signupURLSuffix: "?bundle=jira-product-discovery&edition=standard"
        },
        {
            planName: (_content_premium_planTitleExternal = (_content_premium = content.premium) === null || _content_premium === void 0 ? void 0 : _content_premium.planTitleExternal) !== null && _content_premium_planTitleExternal !== void 0 ? _content_premium_planTitleExternal : "Premium",
            offeringSku: "jira-product-discovery-premium-sku",
            description: (_content_premium_planOneLiner = (_content_premium1 = content.premium) === null || _content_premium1 === void 0 ? void 0 : _content_premium1.planOneLiner) !== null && _content_premium_planOneLiner !== void 0 ? _content_premium_planOneLiner : "",
            recommendationLimit: 50,
            signupLimit: 20000,
            signupURLSuffix: "?bundle=jira-product-discovery&edition=premium"
        }
    ];
    const messages = (0, $6x1qA.defineMessages)({
        unitCountInputTextRedesign: {
            id: "JiraProductDiscoveryPricingPage.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputTerm: {
            id: "JiraProductDiscoveryPricingPage.priceFinder.unitCountInputTerm",
            defaultMessage: "creators"
        },
        unitCountInputText: {
            id: "JiraProductDiscoveryPricingPage.priceFinder.unitCountInputText",
            defaultMessage: "How many agents are on your team?"
        },
        cardOverSignupLimit: {
            id: "JiraProductDiscoveryPricingPage.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your agent count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "JiraProductDiscoveryPricingPage.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more agents above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "JiraProductDiscoveryPricingPage.priceFinder.cardUnitCountTierRange",
            defaultMessage: "Creator tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "JiraProductDiscoveryPricingPageTeam24.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per creator / month"
        }
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $l9lQF.PriceFinderContextProvider), {
        dataProductKey: "jiraProductDiscovery",
        productPlans: jiraProductDiscoveryProductPlans,
        defaultUnitCount: 10,
        enterpriseMinimumCount: 201,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OWgU.default), {
            messages: messages,
            serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.jiraProductDiscovery,
            countryCode: props.countryCode
        })
    });
};
$1ba74f52034e1541$export$b36576908b6a3c15.displayName = "JiraProductDiscoveryPriceFinder";

});

parcelRegister("6axbG", function(module, exports) {

$parcel$export(module.exports, "JpdQuestionsCta", function () { return $9486cf3a1a373909$export$5481e63b06ebf9c4; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("kmJhl");
var $bofgW = parcelRequire("bofgW");

var $dT5kE = parcelRequire("dT5kE");

var $3FBn4 = parcelRequire("3FBn4");
const $9486cf3a1a373909$export$5481e63b06ebf9c4 = ()=>{
    var _content_callToActionContainer, _questionsCtaContent_asset;
    const content = (0, $dT5kE.usePricingContentContext)();
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[0];
    const questionsCtaHref = `https://www.atlassian.com${(0, $3FBn4.useLocalizedHref)("/licensing/jira-product-discovery#jira-product-discovery")}`;
    var _questionsCtaContent_url, _questionsCtaContent_title, _questionsCtaContent_text, _questionsCtaContent_valueProposition;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bofgW.QuestionsCta), {
        product: "Jira Product Discovery",
        ctaHref: (_questionsCtaContent_url = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.url) !== null && _questionsCtaContent_url !== void 0 ? _questionsCtaContent_url : questionsCtaHref,
        questionsHeader: (_questionsCtaContent_title = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.title) !== null && _questionsCtaContent_title !== void 0 ? _questionsCtaContent_title : undefined,
        priceAndLicensingLinkText: (_questionsCtaContent_text = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.text) !== null && _questionsCtaContent_text !== void 0 ? _questionsCtaContent_text : undefined,
        questionsBody: (_questionsCtaContent_valueProposition = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.valueProposition) !== null && _questionsCtaContent_valueProposition !== void 0 ? _questionsCtaContent_valueProposition : undefined,
        imageHref: questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : (_questionsCtaContent_asset = questionsCtaContent.asset) === null || _questionsCtaContent_asset === void 0 ? void 0 : _questionsCtaContent_asset.url
    });
};

});



parcelRegister("gtIRL", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorLpJsmAsset", function () { return $4c992fab3b0e2383$export$fd3c22504cf8dc2a; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $3cXkF = parcelRequire("3cXkF");
const $4c992fab3b0e2383$export$fd3c22504cf8dc2a = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3cXkF.JiraSoftwarePagePaidLpJsmAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-asset",
        persona: "unknown",
        pageVariant: "asset",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});
parcelRegister("3cXkF", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwarePagePaidLpJsmAnchor", function () { return $09e822fef14532d8$export$c1457b2e098e9b28; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $5tcZn = parcelRequire("5tcZn");

var $f6qj2 = parcelRequire("f6qj2");

var $7L1zQ = parcelRequire("7L1zQ");

var $g9kzu = parcelRequire("g9kzu");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");
parcelRequire("D0EyQ");
var $g8Gdb = parcelRequire("g8Gdb");

var $3fquc = parcelRequire("3fquc");

var $gFK1O = parcelRequire("gFK1O");

var $gAJUc = parcelRequire("gAJUc");

var $k4Qty = parcelRequire("k4Qty");

var $3wnRY = parcelRequire("3wnRY");

var $2emKj = parcelRequire("2emKj");
const $09e822fef14532d8$var$LANDING_TYPE = "jira-service-management-anchor";
const $09e822fef14532d8$export$c1457b2e098e9b28 = ({ anchorContents: anchorContents, persona: persona, teamType: teamType, pageId: pageId, pageVariant: pageVariant, animatedJiraTourProps: animatedJiraTourProps, bannerAlertProps: bannerAlertProps, signupEdition: signupEdition, auxiaResponse: auxiaResponse })=>{
    const intl = (0, $f6qj2.default)();
    const productHref = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management");
    const [content, setContent] = (0, $iSvIT.useState)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { setAnchorLocalStorage: setAnchorLocalStorage } = (0, $k4Qty.useAnchorLocalStorage)();
    const customHeadline = intl.formatMessage({
        id: "jira.servicemanagement.anchor.paidlpjsmitsm.variantb",
        defaultMessage: "End bad service management"
    });
    const anonymousId = decodeURIComponent((0, $gFK1O.Cookie).readCookie("ajs_anonymous_id") || "").replace(/['"]+/g, "");
    if ((0, $3wnRY.isAuxiaServedPage)(auxiaResponse)) createAnalyticsEvent({
        name: "getAuxiaJsmPaidLpTreatmentSuccess",
        action: "getAuxiaJsmPaidLpTreatmentSuccess",
        actionSubject: "auxiaPage",
        eventType: "operational",
        source: window.location.pathname,
        attributes: {
            pageUrl: window.location.href,
            anonymousId: anonymousId,
            auxiaResponse: auxiaResponse
        }
    }).fire();
    else if ((0, $3wnRY.isAuxiaResponseMalformed)(auxiaResponse)) createAnalyticsEvent({
        name: "getAuxiaJsmPaidLpTreatmentFailure",
        action: "getAuxiaJsmPaidLpTreatmentFailure",
        actionSubject: "auxiaPage",
        eventType: "operational",
        source: window.location.pathname,
        attributes: {
            pageUrl: window.location.href,
            anonymousId: anonymousId,
            auxiaResponse: auxiaResponse
        }
    }).fire();
    (0, $iSvIT.useEffect)(()=>{
        setAnchorLocalStorage({
            persona: persona,
            teamTypeInferredMl: teamType,
            team: ""
        });
        if ((0, $3wnRY.isAuxiaServedPage)(auxiaResponse)) {
            setContent(auxiaResponse.auxiaTreatment);
            (0, $2emKj.sendAnalyticsToAuxia)({
                anonymousId: anonymousId,
                treatmentTrackingId: auxiaResponse.treatmentTrackingId,
                treatmentId: auxiaResponse.treatmentId,
                interactionType: "VIEWED",
                interactionTimeMicros: (0, $2emKj.convertDateTimeToInteractionTimeMicros)(Date.now())
            });
        } else setContent(anchorContents);
    // We only want to run this useEffect once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!content) // TODO: loading UI for static renders
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {});
    const tabsProps = $09e822fef14532d8$var$getTabProps(content);
    const tabsHasTestimonials = tabsProps && tabsProps.tabs && tabsProps.tabs[0] ? tabsProps.tabs[0].isIncludeTestimony : null;
    const heroProps = $09e822fef14532d8$var$getHeroProps({
        resp: content,
        pageVariant: pageVariant,
        customHeadline: customHeadline,
        isAuxiaServedPage: !!(0, $3wnRY.isAuxiaServedPage)(auxiaResponse)
    });
    const heroImageSubheader = heroProps.tertiaryText;
    const servCoBanner = {
        identifier: "jira-service-management.banner-alert.service-collection",
        text: intl.formatMessage({
            id: "jira-service-management.banner-alert.service-collection.text",
            defaultMessage: "Jira Service Management is now more powerful than ever as part of Service Collection. Unlock exceptional service experiences with Rovo, Assets, and our new Customer Service Management app."
        }),
        linkText: intl.formatMessage({
            id: "jira-service-management.banner-alert.service-collection.cta",
            defaultMessage: "Try it now"
        }),
        linkUrl: "/try/cloud/signup?bundle=service-collection&edition=premium",
        hasProductNavBar: true
    };
    const paidJSMBannerAlertProps = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp8577ServiceCollectionBanners) ? servCoBanner : bannerAlertProps;
    const props = {
        landingType: $09e822fef14532d8$var$LANDING_TYPE,
        pageId: pageId,
        animatedJiraTourProps: animatedJiraTourProps,
        showHorizontalRule: !tabsHasTestimonials,
        productNavProps: {
            productHref: productHref,
            productName: "jiraservicemanagement",
            ariaLabel: intl.formatMessage({
                id: "wacJiraServiceManagementNavigation.logo-label",
                defaultMessage: "Jira Service Management logo"
            }),
            dataProductKey: "jiraServiceManagement",
            showFreeHrefButton: false,
            logoLinkWrapperWidth: "279px"
        },
        heroProps: (0, $6iHNw._)((0, $7Knp0._)({}, heroProps), {
            signup: (0, $6iHNw._)((0, $7Knp0._)({}, heroProps.signup), {
                edition: signupEdition
            })
        }),
        tabsProps: tabsProps,
        bannerAlertProps: paidJSMBannerAlertProps,
        bannerProps: $09e822fef14532d8$var$getBannerProps(content),
        ctaProps: $09e822fef14532d8$var$getCtaProps(content),
        testimonialProps: $09e822fef14532d8$export$aa9a7bf59732070a(content),
        alternatingTextAndImageProps: $09e822fef14532d8$var$getAlternatingTextAndImageProps(content),
        heroImageSubheader: heroImageSubheader,
        heroBgColor: "bgBlackBlue",
        hasRebrandedSignupFormStyles: true,
        auxiaResponse: auxiaResponse
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3fquc.PaidLandingTemplate), (0, $7Knp0._)({}, props));
};
const $09e822fef14532d8$var$heroFeatureMatrix = {
    "asset": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "automation": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "competitors": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "csm": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "devops": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "esm": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "features": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "features-cerebro": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "incidentchangemgmt": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "incident-changemgmt": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "itsm": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "service-desk": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "ticketing": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "marketing": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "engineering": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "hr": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "legal": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "operations": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "design": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "customerservice": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    }
};
const $09e822fef14532d8$var$getHeroFeatures = (pageVariant)=>{
    const defaultFeatures = {
        useNewHero: false,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: false
    };
    return $09e822fef14532d8$var$heroFeatureMatrix[pageVariant] || defaultFeatures;
};
// eslint-disable-next-line complexity
const $09e822fef14532d8$var$getHeroProps = ({ resp: resp, pageVariant: pageVariant, customHeadline: customHeadline })=>{
    const defaultProps = {
        theme: "light-on-dark",
        headerText: "",
        secondaryText: "",
        signup: {
            bundle: "jira-service-management",
            edition: "free",
            featureFlags: {
                enableDefaultExpandedEmail: false,
                enableDeferredFullName: true
            }
        }
    };
    if (!resp || !resp[0]) return defaultProps;
    const { headline: headline } = resp[0].node;
    const nodeName = resp[0].node.name;
    const data = headline && headline[0] ? headline[0] : null;
    const planBenefits = (data === null || data === void 0 ? void 0 : data.planBenefits) && (data === null || data === void 0 ? void 0 : data.planBenefits[0]) ? data === null || data === void 0 ? void 0 : data.planBenefits[0] : null;
    const supportingAsset = planBenefits === null || planBenefits === void 0 ? void 0 : planBenefits.supportingAsset;
    const features = $09e822fef14532d8$var$getHeroFeatures(pageVariant);
    const getImage = (url, description)=>url && description ? {
            src: url ? url : "",
            alt: description || ""
        } : undefined;
    const getFeaturesRawHtml = ()=>planBenefits && planBenefits.planFeatures && planBenefits.planFeatures[0] ? planBenefits.planFeatures[0].description || "" : "";
    return (0, $6iHNw._)((0, $7Knp0._)({}, defaultProps, features), {
        headerText: customHeadline && customHeadline.length > 0 && nodeName == "paid-lp-jsm-itsm" && !(0, $3wnRY.isAuxiaServedPage) ? customHeadline : (data === null || data === void 0 ? void 0 : data.name) || "",
        secondaryText: (data === null || data === void 0 ? void 0 : data.subheading) || "",
        image: getImage(supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.url, supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.description),
        featuresRawHtml: getFeaturesRawHtml(),
        tertiaryText: (planBenefits === null || planBenefits === void 0 ? void 0 : planBenefits.description) || ""
    });
};
const $09e822fef14532d8$var$getTabProps = (resp)=>{
    const defaultProps = {
        dataProductKey: "jiraSoftware-PaidLpJiraPm",
        headerText: "",
        tabStyles: {
            defaultBG: (0, $5ohHq.wacToken)("color.neutral.light200"),
            defaultText: (0, $5ohHq.wacToken)("color.extended.blue900"),
            hoverBG: (0, $5ohHq.wacToken)("color.neutral.light200"),
            hoverText: (0, $5ohHq.wacToken)("color.extended.blue900"),
            activeBG: (0, $5ohHq.wacToken)("color.extended.blue100"),
            activeText: (0, $5ohHq.wacToken)("color.extended.blue900")
        },
        styles: {
            "--lp-tabs-hover": (0, $5ohHq.wacToken)("color.extended.blue700"),
            "--lp-tabs-unselected": (0, $5ohHq.wacToken)("color.extended.blue900")
        },
        tabs: undefined
    };
    if (!resp || !resp[0]) return defaultProps;
    const tabs = $09e822fef14532d8$var$getTabs(resp);
    const primaryMessage = $09e822fef14532d8$var$getPrimaryMessage(resp);
    return (0, $6iHNw._)((0, $7Knp0._)({}, defaultProps), {
        landingType: $09e822fef14532d8$var$LANDING_TYPE,
        headerText: (primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.name) || "",
        tabs: tabs
    });
};
const $09e822fef14532d8$var$getBannerProps = (resp)=>{
    var _banner_bannerImage, _banner_bannerImage1;
    const banner = $09e822fef14532d8$var$getBanner(resp);
    if (!banner) return undefined;
    return {
        headerText: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: (0, (/*@__PURE__*/$parcel$interopDefault($7L1zQ)))((banner === null || banner === void 0 ? void 0 : banner.text) || "")
            }
        }),
        isBannerRichText: true,
        imageLink: (banner === null || banner === void 0 ? void 0 : (_banner_bannerImage = banner.bannerImage) === null || _banner_bannerImage === void 0 ? void 0 : _banner_bannerImage.url) || "",
        imageAltText: (banner === null || banner === void 0 ? void 0 : (_banner_bannerImage1 = banner.bannerImage) === null || _banner_bannerImage1 === void 0 ? void 0 : _banner_bannerImage1.description) || "imageAltText",
        imagePosition: "left",
        backgroundColor: (0, $5ohHq.wacToken)("color.extended.blue200"),
        ctaProps: {
            buttonProps: {
                text: (banner === null || banner === void 0 ? void 0 : banner.urlText) || "",
                url: (banner === null || banner === void 0 ? void 0 : banner.url) || "",
                color: "darkblue",
                type: "secondary"
            }
        },
        margin: "60px 0"
    };
};
const $09e822fef14532d8$var$getCtaProps = (resp)=>{
    const cta = $09e822fef14532d8$var$getCta(resp);
    return {
        headerText: (cta === null || cta === void 0 ? void 0 : cta.valueProposition) || "",
        ctaProps: {
            buttonProps: {
                color: "yellow",
                url: (cta === null || cta === void 0 ? void 0 : cta.url) || "",
                text: (cta === null || cta === void 0 ? void 0 : cta.text) || "",
                dataEventProps: {
                    "data-event": "clicked",
                    "data-event-container": "ctaSection",
                    "data-event-component": "linkButton",
                    "data-product-key": "jiraSoftware"
                }
            }
        },
        backgroundProperties: {
            textColor: (0, $5ohHq.wacToken)("color.neutral.light0")
        }
    };
};
const $09e822fef14532d8$export$aa9a7bf59732070a = (resp)=>{
    var _data_customers;
    if (!resp || !resp[0]) return undefined;
    const { socialProof: socialProof } = resp[0].node;
    const data = socialProof && socialProof[0] ? socialProof[0] : null;
    if (!data) return undefined;
    return {
        headerText: data === null || data === void 0 ? void 0 : data.name,
        logos: (data === null || data === void 0 ? void 0 : (_data_customers = data.customers) === null || _data_customers === void 0 ? void 0 : _data_customers.map((customer)=>{
            return {
                src: customer && customer.logo && (customer === null || customer === void 0 ? void 0 : customer.logo[0]) && (customer === null || customer === void 0 ? void 0 : customer.logo[0].url) ? customer === null || customer === void 0 ? void 0 : customer.logo[0].url : "",
                alt: customer && customer.logo && (customer === null || customer === void 0 ? void 0 : customer.logo[0]) && (customer === null || customer === void 0 ? void 0 : customer.logo[0].description) ? customer === null || customer === void 0 ? void 0 : customer.logo[0].description : "",
                lazy: true
            };
        })) || []
    };
};
const $09e822fef14532d8$var$getAlternatingTextAndImageProps = (resp)=>{
    const results = $09e822fef14532d8$var$getResults(resp);
    function generateProps(result, index) {
        var _result_asset, _result_asset1;
        // this shouldn't go past
        const countMap = [
            "one",
            "two",
            "three",
            "four"
        ];
        const count = (0, (/*@__PURE__*/$parcel$interopDefault($5tcZn)))(`${countMap[index]}`);
        const position = index % 2 === 0 ? "left" : "right";
        return {
            [`row${count}Header`]: (result === null || result === void 0 ? void 0 : result.name) || "",
            [`row${count}Body`]: (result === null || result === void 0 ? void 0 : result.subheading) || "",
            [`row${count}ImageLink`]: result === null || result === void 0 ? void 0 : (_result_asset = result.asset) === null || _result_asset === void 0 ? void 0 : _result_asset.url,
            //getLocalizedImage("row one", intl.locale),
            [`row${count}ImageAltText`]: (result === null || result === void 0 ? void 0 : (_result_asset1 = result.asset) === null || _result_asset1 === void 0 ? void 0 : _result_asset1.description) || "",
            [`row${count}ImagePosition`]: position
        };
    }
    const contentBlocks = results === null || results === void 0 ? void 0 : results.map((result, index)=>generateProps(result, index)).slice(0, 4) // ensure max of 4 results so we don't break the pattern
    .filter((result)=>!!result).reduce((acc, curr)=>{
        return (0, $7Knp0._)({}, acc, curr);
    });
    return (0, $7Knp0._)({
        imageWidth: "100%",
        imageTextSideRowOnePaddingBelowLargeScreen: "32px 0 16px",
        imageTextSideRowTwoPadding: "16px 0",
        imageTextSideRowThreePaddingBelowLargeScreen: "16px 0 32px"
    }, contentBlocks);
};
const $09e822fef14532d8$var$getPrimaryMessage = (resp)=>{
    if (!resp || !resp[0]) return null;
    const { primaryMessage: primaryMessage } = resp[0].node;
    const data = primaryMessage && primaryMessage[0] ? primaryMessage[0] : null;
    return data;
};
const $09e822fef14532d8$var$getTabs = (resp)=>{
    const primaryMessage = $09e822fef14532d8$var$getPrimaryMessage(resp);
    if (!primaryMessage || !(primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.supportingExample)) return undefined;
    return primaryMessage.supportingExample.filter((tab)=>tab !== null)// eslint-disable-next-line complexity
    .map((tab)=>{
        var _advocateQuote_advocateHeadshot, _advocateQuote_advocateHeadshot1;
        const supportingAsset = tab === null || tab === void 0 ? void 0 : tab.supportingAsset;
        const advocateQuote = tab === null || tab === void 0 ? void 0 : tab.advocateQuote;
        const isIncludeTestimony = !!(tab === null || tab === void 0 ? void 0 : tab.advocateQuote);
        return {
            textLabel: (tab === null || tab === void 0 ? void 0 : tab.name) || "",
            id: (tab === null || tab === void 0 ? void 0 : tab.name) || "",
            isIncludeTestimony: isIncludeTestimony,
            component: /*#__PURE__*/ (0, $loA2J.jsx)((0, $g8Gdb.default), {
                isShowTestimonyBorder: isIncludeTestimony,
                isIncludeTestimony: isIncludeTestimony,
                testimonyIsUsingTextQuotationMarks: false,
                title: (tab === null || tab === void 0 ? void 0 : tab.heading) || "",
                rawHtmlContent: (tab === null || tab === void 0 ? void 0 : tab.proofpoint) || "",
                imageSrc: (supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.url) || "",
                imageAlt: (supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.description) || "",
                quoteBlurb: (advocateQuote === null || advocateQuote === void 0 ? void 0 : advocateQuote.advocateQuote) || "",
                quoteName: (advocateQuote === null || advocateQuote === void 0 ? void 0 : advocateQuote.advocateName) || "",
                quoteCompany: (advocateQuote === null || advocateQuote === void 0 ? void 0 : advocateQuote.advocateJobTitle) || "",
                testimonyImageSrc: (advocateQuote === null || advocateQuote === void 0 ? void 0 : (_advocateQuote_advocateHeadshot = advocateQuote.advocateHeadshot) === null || _advocateQuote_advocateHeadshot === void 0 ? void 0 : _advocateQuote_advocateHeadshot.url) || "",
                testimonyImageAlt: (advocateQuote === null || advocateQuote === void 0 ? void 0 : (_advocateQuote_advocateHeadshot1 = advocateQuote.advocateHeadshot) === null || _advocateQuote_advocateHeadshot1 === void 0 ? void 0 : _advocateQuote_advocateHeadshot1.description) || "",
                isSmallQuote: true,
                isIncludeHorizontalMobileRule: false
            }, tab === null || tab === void 0 ? void 0 : tab.name)
        };
    });
};
const $09e822fef14532d8$var$getResults = (resp)=>{
    if (!resp || !resp[0]) return null;
    const { results: results } = resp[0].node;
    const data = results && results.length ? results : null;
    return data;
};
const $09e822fef14532d8$var$getCta = (resp)=>{
    if (!resp || !resp[0]) return null;
    const { callToAction: callToAction } = resp[0].node;
    const data = callToAction && callToAction[0] ? callToAction[0] : null;
    return data;
};
const $09e822fef14532d8$var$getBanner = (resp)=>{
    if (!resp || !resp[0]) return null;
    const { banner: banner } = resp[0].node;
    const data = banner && banner[0] ? banner[0] : null;
    return data;
};

});


parcelRegister("bv0o8", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorAutomation", function () { return $8f24ea5df3d75850$export$fe028e87ba31b736; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $3cXkF = parcelRequire("3cXkF");
const $8f24ea5df3d75850$export$fe028e87ba31b736 = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3cXkF.JiraSoftwarePagePaidLpJsmAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-automation",
        persona: "unknown",
        pageVariant: "automation",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("99FZR", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorCompetitors", function () { return $082842b045e96947$export$9e7550d57c83d484; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $3cXkF = parcelRequire("3cXkF");
const $082842b045e96947$export$9e7550d57c83d484 = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3cXkF.JiraSoftwarePagePaidLpJsmAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-competitors",
        persona: "unknown",
        pageVariant: "competitors",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("ldfiY", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorCsm", function () { return $ccacc1277c890912$export$1b2806c3b1e704cc; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $3cXkF = parcelRequire("3cXkF");
const $ccacc1277c890912$export$1b2806c3b1e704cc = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3cXkF.JiraSoftwarePagePaidLpJsmAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-csm",
        persona: "unknown",
        pageVariant: "csm",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("ehyVQ", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorLpJsmDevops", function () { return $ebf0b6bd07354eae$export$cbbd19ee24db230d; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $3cXkF = parcelRequire("3cXkF");
const $ebf0b6bd07354eae$export$cbbd19ee24db230d = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3cXkF.JiraSoftwarePagePaidLpJsmAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-devops",
        persona: "unknown",
        pageVariant: "devops",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("dknVo", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorEsm", function () { return $158e6c0067db175d$export$f88fd6b582bc38b8; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $3cXkF = parcelRequire("3cXkF");
const $158e6c0067db175d$export$f88fd6b582bc38b8 = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3cXkF.JiraSoftwarePagePaidLpJsmAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-esm",
        persona: "unknown",
        pageVariant: "esm",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("gBm7i", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorCustomerService", function () { return $7083791ce2fc1622$export$b02149e5ebf276fb; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $3cXkF = parcelRequire("3cXkF");
const $7083791ce2fc1622$export$b02149e5ebf276fb = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3cXkF.JiraSoftwarePagePaidLpJsmAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-team-customerservice",
        persona: "unknown",
        pageVariant: "customerservice",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("7BQx4", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorDesign", function () { return $248d921afcfadc76$export$c306ba868bad369c; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $3cXkF = parcelRequire("3cXkF");
const $248d921afcfadc76$export$c306ba868bad369c = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3cXkF.JiraSoftwarePagePaidLpJsmAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-team-design",
        persona: "unknown",
        pageVariant: "design",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("jwejb", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorEngineering", function () { return $75f9c6da91d96c13$export$a4c1bc231ccdbe60; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $3cXkF = parcelRequire("3cXkF");
const $75f9c6da91d96c13$export$a4c1bc231ccdbe60 = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3cXkF.JiraSoftwarePagePaidLpJsmAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-team-engineering",
        persona: "unknown",
        pageVariant: "engineering",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("iVJd6", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorHr", function () { return $865b235db85dbe03$export$7c87531041f697c3; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $3cXkF = parcelRequire("3cXkF");
const $865b235db85dbe03$export$7c87531041f697c3 = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3cXkF.JiraSoftwarePagePaidLpJsmAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-team-hr",
        persona: "unknown",
        pageVariant: "hr",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("hkBIf", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorLegal", function () { return $0345f8c3d788032c$export$c020747f2adc0733; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $3cXkF = parcelRequire("3cXkF");
const $0345f8c3d788032c$export$c020747f2adc0733 = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3cXkF.JiraSoftwarePagePaidLpJsmAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-team-legal",
        persona: "unknown",
        pageVariant: "legal",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("4ytMB", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorMarketing", function () { return $c1923e53d3a92e0a$export$d4eeb7a08f7b5c72; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $3cXkF = parcelRequire("3cXkF");
const $c1923e53d3a92e0a$export$d4eeb7a08f7b5c72 = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3cXkF.JiraSoftwarePagePaidLpJsmAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-team-marketing",
        persona: "unknown",
        pageVariant: "marketing",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("ljOnm", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorOperations", function () { return $cf3ef80f129db28c$export$4674d3807e1d8c79; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $3cXkF = parcelRequire("3cXkF");
const $cf3ef80f129db28c$export$4674d3807e1d8c79 = (pageProps)=>{
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3cXkF.JiraSoftwarePagePaidLpJsmAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-team-operations",
        persona: "unknown",
        pageVariant: "operations",
        signupEdition: "premium",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("dRBBv", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePage", function () { return $2bf80102d69fc6c1$export$b7297290cb91015b; });

var $loA2J = parcelRequire("loA2J");

var $4LHd8 = parcelRequire("4LHd8");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");

var $763wx = parcelRequire("763wx");

var $gkV6l = parcelRequire("gkV6l");
parcelRequire("aRHrH");
var $9O2F2 = parcelRequire("9O2F2");
parcelRequire("53d2O");
var $g1XEw = parcelRequire("g1XEw");
const $2bf80102d69fc6c1$export$b7297290cb91015b = ()=>{
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $4LHd8.default).checkGate("gwp-737-enable-intercom-chat-jsm");
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $763wx.LicenseContextProvider), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gkV6l.SiteSelectorContextProvider), {
            analyticsPrefix: "jsm.show",
            productKey: (0, $i8kxh.ProductKeys).JIRA_SERVICE_DESK,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9O2F2.IntercomProvider), {
                appId: "p0ww63i2",
                triggerBoot: isBootIntercom,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3LLDq.CrossFlowTouchpointProvider), {
                    productKeys: [
                        (0, $i8kxh.ProductKeys).JIRA_SERVICE_DESK
                    ],
                    screenName: "wacJsmProductTourPage",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $g1XEw.JiraServiceManagementSoftwarePageTemplate), {})
                })
            })
        })
    });
};

});
parcelRegister("763wx", function(module, exports) {

$parcel$export(module.exports, "LicenseContextProvider", function () { return $bdb9d0408c802688$export$cca99726a0e060c6; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $i8kxh = parcelRequire("i8kxh");

var $4himv = parcelRequire("4himv");
const $bdb9d0408c802688$export$b8df2a3e84891a11 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $bdb9d0408c802688$export$1828d2fb1045b6c5 = ()=>{
    const context = (0, $iSvIT.useContext)($bdb9d0408c802688$export$b8df2a3e84891a11);
    if (!context) throw new Error("useLicenseContext must be used within a LicenseContextProvider");
    return context;
};
const $bdb9d0408c802688$export$cca99726a0e060c6 = ({ children: children })=>{
    const [hasJsmLicense, setHasJsmLicense] = (0, $iSvIT.useState)(undefined);
    const [hasJpdLicense, setHasJpdLicense] = (0, $iSvIT.useState)(undefined);
    const { sites: sites } = (0, $4himv.useSitesContext)();
    (0, $iSvIT.useEffect)(()=>{
        if (sites !== undefined) {
            const hasJSM = sites.find((site)=>site.products.some((product)=>product === (0, $i8kxh.ProductKeys).JIRA_SERVICE_DESK));
            const hasJPD = sites.find((site)=>site.products.some((product)=>product === (0, $i8kxh.ProductKeys).JIRA_PRODUCT_DISCOVERY));
            setHasJsmLicense(!!hasJSM);
            setHasJpdLicense(!!hasJPD);
        }
    }, [
        sites
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($bdb9d0408c802688$export$b8df2a3e84891a11.Provider, {
        value: {
            hasJsmLicense: hasJsmLicense,
            hasJpdLicense: hasJpdLicense
        },
        children: children
    });
};

});

parcelRegister("53d2O", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementSoftwarePageTemplate", function () { return (parcelRequire("g1XEw")).JiraServiceManagementSoftwarePageTemplate; });

var $g1XEw = parcelRequire("g1XEw");

});
parcelRegister("g1XEw", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePageTemplate", function () { return $7048bbea03a149cb$export$900b5a4539b43299; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $iMdoL = parcelRequire("iMdoL");
parcelRequire("fovuc");
var $5ZfUA = parcelRequire("5ZfUA");

var $3FBn4 = parcelRequire("3FBn4");

var $kex29 = parcelRequire("kex29");

var $jq0gD = parcelRequire("jq0gD");

var $gAJUc = parcelRequire("gAJUc");

var $f6RqB = parcelRequire("f6RqB");

var $6pF2G = parcelRequire("6pF2G");

var $8UlfF = parcelRequire("8UlfF");

var $kMsPi = parcelRequire("kMsPi");

var $avg0H = parcelRequire("avg0H");

var $gd7EO = parcelRequire("gd7EO");

var $entQJ = parcelRequire("entQJ");

var $h3BeN = parcelRequire("h3BeN");

var $jcaSM = parcelRequire("jcaSM");

var $9g0oR = parcelRequire("9g0oR");

var $57Jg1 = parcelRequire("57Jg1");

var $4QWpU = parcelRequire("4QWpU");
const $7048bbea03a149cb$export$54938012d431ec60 = ()=>{
    const intl = (0, $f6qj2.default)();
    const showForrester = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp6701ForresterBanner);
    const showAiBanner = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).wacUipButterBarJsmGate);
    const showHighVelocityBanner = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7942JsmWebinarGate);
    const forresterBannerConfig = {
        identifier: "jira-service-management-software.banner.forrester-devops",
        text: "Atlassian recognized as a Leader in The Forrester Wave\u2122: DevOps Platforms, Q2 2025.",
        linkText: "Learn more",
        linkUrl: (0, $3FBn4.useLocalizedHref)("/forrester/forrester-wave-devops?utm_source=in-product-banner&utm_medium=banner&utm_campaign=P:bitbucket*O:clm*I:banner-wac-jiraservicemanagement*Y:cloud_mig*E:dc-cloud*&utm_sfdc-campaign_id=701QB00000SlywgYAB"),
        dataEventProps: {
            "data-product-key": "jiraServiceManagement",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked"
        }
    };
    const aiBannerMessages = {
        identifier: "jira-service-management-software.atlassian-intelligence_exp",
        text: intl.formatMessage({
            id: "jira-service-management-software.banner-alert.atlassian-intelligence_exp",
            defaultMessage: "Transform teamwork with Atlassian Intelligence - now available."
        }),
        linkText: intl.formatMessage({
            id: "jira-service-management-software.link-text",
            defaultMessage: "Learn more"
        }),
        linkUrl: (0, $3FBn4.useLocalizedHref)("/software/artificial-intelligence"),
        dataEventProps: {
            "data-product-key": "jiraServiceManagement",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Learn more",
            "data-label-english": "Learn more"
        }
    };
    const highVelocityBannerConfig = {
        identifier: "jira-service-management-software.banner.high-velocity",
        text: intl.formatMessage({
            id: "jira-service-management-software.banner-alert.high-velocity",
            defaultMessage: "Meet us at Atlassian Connect: High Velocity for networking, panels, workshops, and demos around the latest AI-powered innovations for high-velocity service management."
        }),
        linkText: intl.formatMessage({
            id: "jira-service-management-software.banner-alert.high-velocity.link-text",
            defaultMessage: "Register for free"
        }),
        linkUrl: "https://events.atlassian.com/connect-highvelocity?utm_medium=event-web-referral&utm_source=cross-promo&event_context=jsm_product_page&utm_campaign=K:event|H:in-person|N:connect_hv|P:agnostic|O:event-marketing|F:pre-event|C:event-home&utm_content=wac_banner&event_id=284907",
        dataEventProps: {
            "data-product-key": "jiraServiceManagement",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Register for free",
            "data-label-english": "Register for free"
        }
    };
    if (showHighVelocityBanner) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5ZfUA.BannerAlert), (0, $7Knp0._)({}, highVelocityBannerConfig));
    if (showForrester) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5ZfUA.BannerAlert), (0, $7Knp0._)({}, forresterBannerConfig));
    if (showAiBanner) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5ZfUA.BannerAlert), (0, $7Knp0._)({}, aiBannerMessages));
    return null;
};
const $7048bbea03a149cb$export$900b5a4539b43299 = ()=>{
    const isLoggedOut = (0, $iMdoL.useLoggedOut)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jq0gD.default), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9g0oR.default), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                name: "jsm-landing-banner",
                children: /*#__PURE__*/ (0, $loA2J.jsx)($7048bbea03a149cb$export$54938012d431ec60, {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("main", {
                id: "content",
                children: [
                    isLoggedOut ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                        name: "jsm-hero-embedded-signup",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6pF2G.default), {})
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                        name: "jsm-landing-hero",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $f6RqB.default), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                        name: "jsm-landing-hero-tabs",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8UlfF.default), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                        name: "jsm-landing-aiItsmSection",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kMsPi.AtlassianIntelligenceITSM), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                        name: "jsm-landing-tabsSection",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $57Jg1.default), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                        name: "jsm-landing-customersSection",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $entQJ.default), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                        name: "jsm-landing-scalingSection",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jcaSM.default), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                        name: "jsm-landing-tilesSection",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4QWpU.default), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                        name: "jsm-landing-cardsSection",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $avg0H.default), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                        name: "jsm-landing-integrationSection",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $h3BeN.default), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                        name: "jsm-landing-ctaSection",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gd7EO.default), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
                name: "jsm-landing-globalFooter",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
            })
        ]
    });
};

});
parcelRegister("f6RqB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5bace569b97dee0$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $6x1qA = parcelRequire("6x1qA");
var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $257fv = parcelRequire("257fv");
var $bZyGC = parcelRequire("bZyGC");
var $jXVyf = parcelRequire("jXVyf");
var $j7TVc = parcelRequire("j7TVc");

var $dWbel = parcelRequire("dWbel");
const $a5bace569b97dee0$var$messages = (0, $6x1qA.defineMessages)({
    heading: {
        id: "wacJiraServiceManagementPage.hero-heading",
        defaultMessage: "Unlock high-velocity teams with AI-powered service management"
    },
    subheading: {
        id: "wacJiraServiceManagementPage.hero-subheading-gwp-4949",
        defaultMessage: "End bad service management for good. Unite Dev, IT, and business teams on a single AI-powered platform to deliver great service experiences."
    }
});
const $a5bace569b97dee0$var$JsmUseCaseProductTourOnWac = ()=>{
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    // * Keep the original experiment event for attribution
    (0, $iSvIT.useEffect)(()=>{
        analyticsClient && createAnalyticsEvent({
            action: "exposed",
            actionSubject: "experiment",
            attributes: {
                cohort: "variation-one",
                experiment: "use-case-led-jsm-product-tour-on-wac"
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        analyticsClient
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
        xcss: $a5bace569b97dee0$var$HeroContainerStyle,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
            alignInline: "center",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                    xcss: $a5bace569b97dee0$var$HeroHeadingWrapperStyles,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "h1",
                        xcss: $a5bace569b97dee0$var$HeroHeadingStyles,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, $a5bace569b97dee0$var$messages.heading), {
                            values: {
                                span: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                                        as: "span",
                                        xcss: $a5bace569b97dee0$var$HeroHeadingSpanStyles,
                                        children: text
                                    })
                            }
                        }))
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                    as: "p",
                    xcss: $a5bace569b97dee0$var$HeroSubheadingStyles,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, $a5bace569b97dee0$var$messages.subheading))
                })
            ]
        })
    });
};
const $a5bace569b97dee0$var$HeroContainerStyle = (0, $j7TVc.xcss)({
    marginInline: "auto",
    width: "100%",
    overflow: "hidden"
});
const $a5bace569b97dee0$var$HeroHeadingWrapperStyles = (0, $j7TVc.xcss)({
    position: "relative"
});
const $a5bace569b97dee0$var$HeroHeadingStyles = (0, $j7TVc.xcss)({
    textAlign: "center",
    fontSize: "48px",
    fontWeight: "800",
    lineHeight: "56px",
    maxWidth: "378px",
    marginBlockEnd: "space.0",
    [(0, $bZyGC.media).above.sm]: {
        maxWidth: "600px"
    },
    [(0, $bZyGC.media).above.lg]: {
        fontSize: "48px",
        maxWidth: "800px"
    }
});
const $a5bace569b97dee0$var$HeroHeadingSpanStyles = (0, $j7TVc.xcss)({
    fontWeight: "400"
});
const $a5bace569b97dee0$var$HeroSubheadingStyles = (0, $j7TVc.xcss)({
    textAlign: "center",
    marginBlockEnd: "space.400",
    maxWidth: "328px",
    fontSize: "20px",
    lineHeight: "28px",
    [(0, $bZyGC.media).above.xs]: {
        maxWidth: "420px"
    },
    [(0, $bZyGC.media).above.sm]: {
        maxWidth: "600px"
    },
    [(0, $bZyGC.media).above.lg]: {
        marginBlockEnd: "space.600",
        maxWidth: "800px",
        fontSize: "20px",
        lineHeight: "28px"
    }
});
var $a5bace569b97dee0$export$2e2bcd8739ae039 = $a5bace569b97dee0$var$JsmUseCaseProductTourOnWac;

});
parcelRegister("257fv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1841abeec670011b$export$2e2bcd8739ae039; });

var $2McEe = parcelRequire("2McEe");

var $eWYnH = parcelRequire("eWYnH");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $ihHOk = parcelRequire("ihHOk");

var $j7TVc = parcelRequire("j7TVc");

var $ahkBr = parcelRequire("ahkBr");
var $1841abeec670011b$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $1841abeec670011b$var$_excluded2 = [
    "className"
];
var $1841abeec670011b$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, as = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $eWYnH.default)(_ref, $1841abeec670011b$var$_excluded);
    var Component = as;
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $eWYnH.default)(htmlAttributes, $1841abeec670011b$var$_excluded2);
    var className = xcss && (0, $j7TVc.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $2ZUkg.jsx)(Component, (0, $2McEe.default)({
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        css: [
            $1841abeec670011b$var$baseStyles,
            backgroundColor && (0, $ihHOk.backgroundColorStylesMap)[backgroundColor],
            (0, $ihHOk.isSurfaceColorToken)(backgroundColor) && (0, $ihHOk.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $ihHOk.paddingStylesMap).padding[padding],
            paddingBlock && (0, $ihHOk.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $ihHOk.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $ihHOk.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $ihHOk.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $ihHOk.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $ihHOk.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            className
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $2ZUkg.jsx)((0, $ahkBr.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $1841abeec670011b$export$2e2bcd8739ae039 = $1841abeec670011b$export$e71c4d32a2263218;
var $1841abeec670011b$var$baseStyles = (0, $2ZUkg.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("2McEe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2059e010a3271699$export$2e2bcd8739ae039; });
function $2059e010a3271699$export$2e2bcd8739ae039() {
    return $2059e010a3271699$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2059e010a3271699$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("eWYnH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae2551f1dbc1603c$export$2e2bcd8739ae039; });

var $fBC9x = parcelRequire("fBC9x");
function $ae2551f1dbc1603c$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $fBC9x.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("fBC9x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5c7e80f66f4aacf$export$2e2bcd8739ae039; });
function $b5c7e80f66f4aacf$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("ihHOk", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $d4fbcc68e1d18b35$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $d4fbcc68e1d18b35$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $d4fbcc68e1d18b35$export$632685d741f3dbbf; });
$parcel$export(module.exports, "inverseColorMap", function () { return $d4fbcc68e1d18b35$export$2185ce37f9bdd963; });
$parcel$export(module.exports, "opacityMap", function () { return $d4fbcc68e1d18b35$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $d4fbcc68e1d18b35$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $d4fbcc68e1d18b35$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $d4fbcc68e1d18b35$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $d4fbcc68e1d18b35$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $d4fbcc68e1d18b35$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $d4fbcc68e1d18b35$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $d4fbcc68e1d18b35$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $d4fbcc68e1d18b35$export$e615f061ca585a6c; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $d4fbcc68e1d18b35$export$bf46c3f9eeafc71f; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $d4fbcc68e1d18b35$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "textColorStylesMap", function () { return $d4fbcc68e1d18b35$export$3a1bcba60b23d7f0; });
$parcel$export(module.exports, "fontWeightStylesMap", function () { return $d4fbcc68e1d18b35$export$45f3f4fe16f9f7d5; });
$parcel$export(module.exports, "bodyTextStylesMap", function () { return $d4fbcc68e1d18b35$export$a1962444bbf058e; });
$parcel$export(module.exports, "uiTextStylesMap", function () { return $d4fbcc68e1d18b35$export$ca3e246f24657bd6; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $d4fbcc68e1d18b35$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $d4fbcc68e1d18b35$export$5e65a44e5b6ecadb; });

var $dFcgv = parcelRequire("dFcgv");

var $2ZUkg = parcelRequire("2ZUkg");

var $7zGnN = parcelRequire("7zGnN");
function $d4fbcc68e1d18b35$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d4fbcc68e1d18b35$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d4fbcc68e1d18b35$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dFcgv.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d4fbcc68e1d18b35$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d4fbcc68e1d18b35$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $d4fbcc68e1d18b35$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $d4fbcc68e1d18b35$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $d4fbcc68e1d18b35$export$632685d741f3dbbf = $d4fbcc68e1d18b35$var$_objectSpread($d4fbcc68e1d18b35$var$_objectSpread({}, $d4fbcc68e1d18b35$export$958d0ae7f2977ae4), $d4fbcc68e1d18b35$export$d2dc61f58390201c);
var $d4fbcc68e1d18b35$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $d4fbcc68e1d18b35$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $d4fbcc68e1d18b35$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $d4fbcc68e1d18b35$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $d4fbcc68e1d18b35$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $d4fbcc68e1d18b35$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $d4fbcc68e1d18b35$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)"
};
var $d4fbcc68e1d18b35$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $d4fbcc68e1d18b35$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $d4fbcc68e1d18b35$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $d4fbcc68e1d18b35$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $d4fbcc68e1d18b35$export$6cc560b4dedf3816 = {
    "font.size.050": "var(--ds-font-size-050, 11px)",
    "font.size.075": "var(--ds-font-size-075, 12px)",
    "font.size.100": "var(--ds-font-size-100, 14px)",
    "font.size.200": "var(--ds-font-size-200, 16px)",
    "font.size.300": "var(--ds-font-size-300, 20px)",
    "font.size.400": "var(--ds-font-size-400, 24px)",
    "font.size.500": "var(--ds-font-size-500, 29px)",
    "font.size.600": "var(--ds-font-size-600, 35px)"
};
var $d4fbcc68e1d18b35$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $d4fbcc68e1d18b35$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand": "var(--ds-font-family-brand, Charlie Sans)",
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.monospace": 'var(--ds-font-family-monospace, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.sans": 'var(--ds-font-family-sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif)'
};
var $d4fbcc68e1d18b35$export$360c29a380c1a34 = {
    "font.lineHeight.1": "var(--ds-font-lineHeight-1, 1)",
    "font.lineHeight.100": "var(--ds-font-lineHeight-100, 16px)",
    "font.lineHeight.200": "var(--ds-font-lineHeight-200, 20px)",
    "font.lineHeight.300": "var(--ds-font-lineHeight-300, 24px)",
    "font.lineHeight.400": "var(--ds-font-lineHeight-400, 28px)",
    "font.lineHeight.500": "var(--ds-font-lineHeight-500, 32px)",
    "font.lineHeight.600": "var(--ds-font-lineHeight-600, 40px)"
};
var $d4fbcc68e1d18b35$export$b5bac06d7d8fd0d1 = {
    body: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $d4fbcc68e1d18b35$export$b27166c9cf2c9f74 = {
    ui: 'var(--ds-font-ui, normal 500 14px/1 ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "ui.small": 'var(--ds-font-ui-small, normal 400 11px/1 ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $d4fbcc68e1d18b35$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $d4fbcc68e1d18b35$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $2ZUkg.css)((0, $dFcgv.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $d4fbcc68e1d18b35$export$e615f061ca585a6c = $d4fbcc68e1d18b35$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $d4fbcc68e1d18b35$var$getSerializedStylesMap(spacingProperty, $d4fbcc68e1d18b35$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $d4fbcc68e1d18b35$export$bf46c3f9eeafc71f = $d4fbcc68e1d18b35$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $d4fbcc68e1d18b35$var$getSerializedStylesMap(spacingProperty, $d4fbcc68e1d18b35$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $d4fbcc68e1d18b35$export$e7af83bafe7f9e63 = $d4fbcc68e1d18b35$var$getSerializedStylesMap("backgroundColor", $d4fbcc68e1d18b35$export$d1d79bf68ac056bd);
var $d4fbcc68e1d18b35$export$3a1bcba60b23d7f0 = $d4fbcc68e1d18b35$var$getSerializedStylesMap("color", $d4fbcc68e1d18b35$export$8473307aa00d6ea1);
var $d4fbcc68e1d18b35$export$f7183c9e2dbc2543 = $d4fbcc68e1d18b35$var$getSerializedStylesMap("fontSize", $d4fbcc68e1d18b35$export$6cc560b4dedf3816);
var $d4fbcc68e1d18b35$export$45f3f4fe16f9f7d5 = $d4fbcc68e1d18b35$var$getSerializedStylesMap("fontWeight", $d4fbcc68e1d18b35$export$303e322c6b1ed114);
var $d4fbcc68e1d18b35$export$68cc305da27dbaa4 = $d4fbcc68e1d18b35$var$getSerializedStylesMap("fontFamily", $d4fbcc68e1d18b35$export$3c7e9587132614b4);
var $d4fbcc68e1d18b35$export$8be4a21014f48eb1 = $d4fbcc68e1d18b35$var$getSerializedStylesMap("lineHeight", $d4fbcc68e1d18b35$export$360c29a380c1a34);
var $d4fbcc68e1d18b35$export$a1962444bbf058e = $d4fbcc68e1d18b35$var$getSerializedStylesMap("font", $d4fbcc68e1d18b35$export$b5bac06d7d8fd0d1);
var $d4fbcc68e1d18b35$export$ca3e246f24657bd6 = $d4fbcc68e1d18b35$var$getSerializedStylesMap("font", $d4fbcc68e1d18b35$export$b27166c9cf2c9f74);
var $d4fbcc68e1d18b35$export$ff257d957d48c421 = $d4fbcc68e1d18b35$var$getSerializedStylesMap((0, $7zGnN.CURRENT_SURFACE_CSS_VAR), $d4fbcc68e1d18b35$export$41a358c9c2356760);
var $d4fbcc68e1d18b35$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $d4fbcc68e1d18b35$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("dFcgv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f289e53e0bcd105$export$2e2bcd8739ae039; });

var $bW7sz = parcelRequire("bW7sz");
function $9f289e53e0bcd105$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $bW7sz.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("bW7sz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b0ae5d5eb78608c$export$2e2bcd8739ae039; });

var $hk95V = parcelRequire("hk95V");

var $avCeQ = parcelRequire("avCeQ");
function $8b0ae5d5eb78608c$export$2e2bcd8739ae039(t) {
    var i = (0, $avCeQ.default)(t, "string");
    return "symbol" == (0, $hk95V.default)(i) ? i : i + "";
}

});
parcelRegister("hk95V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9cb5bee7acb1ccd$export$2e2bcd8739ae039; });
function $c9cb5bee7acb1ccd$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $c9cb5bee7acb1ccd$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c9cb5bee7acb1ccd$export$2e2bcd8739ae039(o);
}

});

parcelRegister("avCeQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a6a75fb4952d11e$export$2e2bcd8739ae039; });

var $hk95V = parcelRequire("hk95V");
function $7a6a75fb4952d11e$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $hk95V.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $hk95V.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("7zGnN", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $583cada5b7e72920$export$9d7b58831ae93caa; });
var $583cada5b7e72920$export$4ef52930e33717cd = "data-theme";
var $583cada5b7e72920$export$a00eac3f8684bcd0 = "data-color-mode";
var $583cada5b7e72920$export$2112803007239c61 = "data-contrast-mode";
var $583cada5b7e72920$export$352e418ed5b6193a = "data-custom-theme";
var $583cada5b7e72920$export$2faeed762aac6741 = "light";
var $583cada5b7e72920$export$6f0c6fb8c80fcc92 = "ds";
var $583cada5b7e72920$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $583cada5b7e72920$export$dddac1532e822863 = "--".concat($583cada5b7e72920$export$6f0c6fb8c80fcc92, "-token-not-found");
var $583cada5b7e72920$export$9d7b58831ae93caa = "--".concat($583cada5b7e72920$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("j7TVc", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $deca0ca3b157666b$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $deca0ca3b157666b$export$f6c783d06584602c; });

var $dFcgv = parcelRequire("dFcgv");

var $3kZ88 = parcelRequire("3kZ88");

var $hk95V = parcelRequire("hk95V");

var $2ZUkg = parcelRequire("2ZUkg");

var $ihHOk = parcelRequire("ihHOk");

var $XAEGR = parcelRequire("XAEGR");
var $deca0ca3b157666b$export$9a199fbafee0014e = {
    backgroundColor: (0, $ihHOk.backgroundColorMap),
    blockSize: (0, $ihHOk.dimensionMap),
    borderBlockColor: (0, $ihHOk.borderColorMap),
    borderBlockEndColor: (0, $ihHOk.borderColorMap),
    borderBlockEndWidth: (0, $ihHOk.borderWidthMap),
    borderBlockStartColor: (0, $ihHOk.borderColorMap),
    borderBlockStartWidth: (0, $ihHOk.borderWidthMap),
    borderBlockWidth: (0, $ihHOk.borderWidthMap),
    borderBottomColor: (0, $ihHOk.borderColorMap),
    borderBottomLeftRadius: (0, $ihHOk.borderRadiusMap),
    borderBottomRightRadius: (0, $ihHOk.borderRadiusMap),
    borderBottomWidth: (0, $ihHOk.borderWidthMap),
    borderColor: (0, $ihHOk.borderColorMap),
    borderEndEndRadius: (0, $ihHOk.borderRadiusMap),
    borderEndStartRadius: (0, $ihHOk.borderRadiusMap),
    borderInlineColor: (0, $ihHOk.borderColorMap),
    borderInlineEndColor: (0, $ihHOk.borderColorMap),
    borderInlineEndWidth: (0, $ihHOk.borderWidthMap),
    borderInlineStartColor: (0, $ihHOk.borderColorMap),
    borderInlineStartWidth: (0, $ihHOk.borderWidthMap),
    borderInlineWidth: (0, $ihHOk.borderWidthMap),
    borderLeftColor: (0, $ihHOk.borderColorMap),
    borderLeftWidth: (0, $ihHOk.borderWidthMap),
    borderRadius: (0, $ihHOk.borderRadiusMap),
    borderRightColor: (0, $ihHOk.borderColorMap),
    borderRightWidth: (0, $ihHOk.borderWidthMap),
    borderStartEndRadius: (0, $ihHOk.borderRadiusMap),
    borderStartStartRadius: (0, $ihHOk.borderRadiusMap),
    borderTopColor: (0, $ihHOk.borderColorMap),
    borderTopLeftRadius: (0, $ihHOk.borderRadiusMap),
    borderTopRightRadius: (0, $ihHOk.borderRadiusMap),
    borderTopWidth: (0, $ihHOk.borderWidthMap),
    borderWidth: (0, $ihHOk.borderWidthMap),
    bottom: (0, $ihHOk.allSpaceMap),
    boxShadow: (0, $ihHOk.shadowMap),
    color: (0, $ihHOk.textColorMap),
    columnGap: (0, $ihHOk.positiveSpaceMap),
    gap: (0, $ihHOk.positiveSpaceMap),
    height: (0, $ihHOk.dimensionMap),
    inlineSize: (0, $ihHOk.dimensionMap),
    inset: (0, $ihHOk.allSpaceMap),
    insetBlock: (0, $ihHOk.allSpaceMap),
    insetBlockEnd: (0, $ihHOk.allSpaceMap),
    insetBlockStart: (0, $ihHOk.allSpaceMap),
    insetInline: (0, $ihHOk.allSpaceMap),
    insetInlineEnd: (0, $ihHOk.allSpaceMap),
    insetInlineStart: (0, $ihHOk.allSpaceMap),
    left: (0, $ihHOk.allSpaceMap),
    margin: (0, $ihHOk.allSpaceMap),
    marginBlock: (0, $ihHOk.allSpaceMap),
    marginBlockEnd: (0, $ihHOk.allSpaceMap),
    marginBlockStart: (0, $ihHOk.allSpaceMap),
    marginBottom: (0, $ihHOk.allSpaceMap),
    marginInline: (0, $ihHOk.allSpaceMap),
    marginInlineEnd: (0, $ihHOk.allSpaceMap),
    marginInlineStart: (0, $ihHOk.allSpaceMap),
    marginLeft: (0, $ihHOk.allSpaceMap),
    marginRight: (0, $ihHOk.allSpaceMap),
    marginTop: (0, $ihHOk.allSpaceMap),
    maxBlockSize: (0, $ihHOk.dimensionMap),
    maxHeight: (0, $ihHOk.dimensionMap),
    maxInlineSize: (0, $ihHOk.dimensionMap),
    maxWidth: (0, $ihHOk.dimensionMap),
    minBlockSize: (0, $ihHOk.dimensionMap),
    minHeight: (0, $ihHOk.dimensionMap),
    minInlineSize: (0, $ihHOk.dimensionMap),
    minWidth: (0, $ihHOk.dimensionMap),
    opacity: (0, $ihHOk.opacityMap),
    outlineColor: (0, $ihHOk.borderColorMap),
    outlineOffset: (0, $ihHOk.positiveSpaceMap),
    outlineWidth: (0, $ihHOk.borderWidthMap),
    padding: (0, $ihHOk.positiveSpaceMap),
    paddingBlock: (0, $ihHOk.positiveSpaceMap),
    paddingBlockEnd: (0, $ihHOk.positiveSpaceMap),
    paddingBlockStart: (0, $ihHOk.positiveSpaceMap),
    paddingBottom: (0, $ihHOk.positiveSpaceMap),
    paddingInline: (0, $ihHOk.positiveSpaceMap),
    paddingInlineEnd: (0, $ihHOk.positiveSpaceMap),
    paddingInlineStart: (0, $ihHOk.positiveSpaceMap),
    paddingLeft: (0, $ihHOk.positiveSpaceMap),
    paddingRight: (0, $ihHOk.positiveSpaceMap),
    paddingTop: (0, $ihHOk.positiveSpaceMap),
    right: (0, $ihHOk.allSpaceMap),
    rowGap: (0, $ihHOk.positiveSpaceMap),
    top: (0, $ihHOk.allSpaceMap),
    width: (0, $ihHOk.dimensionMap),
    zIndex: (0, $ihHOk.layerMap)
};
var $deca0ca3b157666b$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $deca0ca3b157666b$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $XAEGR === "undefined" ? "undefined" : (0, $hk95V.default)($XAEGR)) === "object" && (0, $hk95V.default)($XAEGR.env) === "object" && false;
};
var $deca0ca3b157666b$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $deca0ca3b157666b$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $deca0ca3b157666b$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, $hk95V.default)(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, $3kZ88.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, $hk95V.default)(value) === "object" && $deca0ca3b157666b$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($deca0ca3b157666b$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($deca0ca3b157666b$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $deca0ca3b157666b$export$9a199fbafee0014e)) return;
        var tokenValue = $deca0ca3b157666b$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $deca0ca3b157666b$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $deca0ca3b157666b$var$transformStyles(style);
    return (0, $dFcgv.default)({}, $deca0ca3b157666b$var$uniqueSymbol, (0, $2ZUkg.css)(transformedStyles));
};
var $deca0ca3b157666b$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) return args.map(function(x) {
        return x && parseXcss(x);
    }).filter(Boolean);
    var styles = args[$deca0ca3b157666b$var$uniqueSymbol];
    typeof $XAEGR === "undefined" || (0, $hk95V.default)($XAEGR);
    return styles;
};
function $deca0ca3b157666b$export$f6c783d06584602c(style) {
    return $deca0ca3b157666b$var$baseXcss(style);
}

});
parcelRegister("3kZ88", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26e2a88edc76a3e8$export$2e2bcd8739ae039; });

var $bEZf9 = parcelRequire("bEZf9");

var $58NJl = parcelRequire("58NJl");

var $hslXA = parcelRequire("hslXA");

var $8634D = parcelRequire("8634D");
function $26e2a88edc76a3e8$export$2e2bcd8739ae039(r, e) {
    return (0, $bEZf9.default)(r) || (0, $58NJl.default)(r, e) || (0, $hslXA.default)(r, e) || (0, $8634D.default)();
}

});
parcelRegister("bEZf9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87d2efc8b3b783d6$export$2e2bcd8739ae039; });
function $87d2efc8b3b783d6$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("58NJl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3be4468ad7c0f790$export$2e2bcd8739ae039; });
function $3be4468ad7c0f790$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("hslXA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb561603d103b773$export$2e2bcd8739ae039; });

var $7wX0I = parcelRequire("7wX0I");
function $cb561603d103b773$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $7wX0I.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $7wX0I.default)(r, a) : void 0;
    }
}

});
parcelRegister("7wX0I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57b94bd35ce84d44$export$2e2bcd8739ae039; });
function $57b94bd35ce84d44$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("8634D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e5144abe654c358$export$2e2bcd8739ae039; });
function $5e5144abe654c358$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("ahkBr", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $77bb793711e4317b$export$1ca2a26fecb070ae; });
$parcel$export(module.exports, "useSurface", function () { return $77bb793711e4317b$export$1aeb4f6b93c4540d; });

var $iSvIT = parcelRequire("iSvIT");
var $77bb793711e4317b$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $iSvIT.createContext)("elevation.surface");
var $77bb793711e4317b$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $iSvIT.useContext)($77bb793711e4317b$export$1ca2a26fecb070ae);
};
$77bb793711e4317b$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("jXVyf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8902b86efcd71d6$export$2e2bcd8739ae039; });

var $dClj0 = parcelRequire("dClj0");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $j7TVc = parcelRequire("j7TVc");

var $1Lr0O = parcelRequire("1Lr0O");
var $e8902b86efcd71d6$var$flexGrowMap = {
    hug: (0, $j7TVc.xcss)({
        flexGrow: 0
    }),
    fill: (0, $j7TVc.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $e8902b86efcd71d6$var$Stack = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    return (0, $2ZUkg.jsx)((0, $1Lr0O.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: grow ? [
            $e8902b86efcd71d6$var$flexGrowMap[grow]
        ].concat((0, $dClj0.default)(Array.isArray(xcss) ? xcss : [
            xcss
        ])) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss,
        testId: testId,
        ref: ref
    }, children);
}));
$e8902b86efcd71d6$var$Stack.displayName = "Stack";
var $e8902b86efcd71d6$export$2e2bcd8739ae039 = $e8902b86efcd71d6$var$Stack;

});
parcelRegister("dClj0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e9f59d4154a0a0e$export$2e2bcd8739ae039; });

var $kyY5k = parcelRequire("kyY5k");

var $cMl8z = parcelRequire("cMl8z");

var $hslXA = parcelRequire("hslXA");

var $6zNvR = parcelRequire("6zNvR");
function $9e9f59d4154a0a0e$export$2e2bcd8739ae039(r) {
    return (0, $kyY5k.default)(r) || (0, $cMl8z.default)(r) || (0, $hslXA.default)(r) || (0, $6zNvR.default)();
}

});
parcelRegister("kyY5k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef85973da19107e1$export$2e2bcd8739ae039; });

var $7wX0I = parcelRequire("7wX0I");
function $ef85973da19107e1$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $7wX0I.default)(r);
}

});

parcelRegister("cMl8z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94da5d202af3ce6b$export$2e2bcd8739ae039; });
function $94da5d202af3ce6b$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("6zNvR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c9c6b2b5d8fcd04$export$2e2bcd8739ae039; });
function $4c9c6b2b5d8fcd04$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("1Lr0O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $148f22484ac02ea1$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $ihHOk = parcelRequire("ihHOk");

var $j7TVc = parcelRequire("j7TVc");
var $148f22484ac02ea1$var$justifyContentMap = {
    start: (0, $2ZUkg.css)({
        justifyContent: "start"
    }),
    center: (0, $2ZUkg.css)({
        justifyContent: "center"
    }),
    end: (0, $2ZUkg.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $2ZUkg.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $2ZUkg.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $2ZUkg.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $2ZUkg.css)({
        justifyContent: "stretch"
    })
};
var $148f22484ac02ea1$var$flexDirectionMap = {
    column: (0, $2ZUkg.css)({
        flexDirection: "column"
    }),
    row: (0, $2ZUkg.css)({
        flexDirection: "row"
    })
};
var $148f22484ac02ea1$var$flexWrapMap = {
    wrap: (0, $2ZUkg.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $2ZUkg.css)({
        flexWrap: "nowrap"
    })
};
var $148f22484ac02ea1$var$alignItemsMap = {
    start: (0, $2ZUkg.css)({
        alignItems: "start"
    }),
    center: (0, $2ZUkg.css)({
        alignItems: "center"
    }),
    baseline: (0, $2ZUkg.css)({
        alignItems: "baseline"
    }),
    end: (0, $2ZUkg.css)({
        alignItems: "end"
    }),
    stretch: (0, $2ZUkg.css)({
        alignItems: "stretch"
    })
};
var $148f22484ac02ea1$var$baseStyles = (0, $2ZUkg.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $148f22484ac02ea1$var$Flex = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var xcssClassName = xcss && (0, $j7TVc.parseXcss)(xcss);
    return (0, $2ZUkg.jsx)(Component, {
        role: role,
        css: [
            $148f22484ac02ea1$var$baseStyles,
            gap && (0, $ihHOk.spaceStylesMap).gap[gap],
            columnGap && (0, $ihHOk.spaceStylesMap).columnGap[columnGap],
            rowGap && (0, $ihHOk.spaceStylesMap).rowGap[rowGap],
            alignItems && $148f22484ac02ea1$var$alignItemsMap[alignItems],
            direction && $148f22484ac02ea1$var$flexDirectionMap[direction],
            justifyContent && $148f22484ac02ea1$var$justifyContentMap[justifyContent],
            wrap && $148f22484ac02ea1$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            xcssClassName && xcssClassName
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$148f22484ac02ea1$var$Flex.displayName = "Flex";
var $148f22484ac02ea1$export$2e2bcd8739ae039 = $148f22484ac02ea1$var$Flex;

});



parcelRegister("6pF2G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2e09509ec9c0ee6$export$2e2bcd8739ae039; });
/* hero-embedded-signup.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $6x1qA = parcelRequire("6x1qA");

var $dyZbY = parcelRequire("dyZbY");

var $axg8K = parcelRequire("axg8K");
var $aZTjH = parcelRequire("aZTjH");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $d2e09509ec9c0ee6$var$messages = (0, $6x1qA.defineMessages)({
    heading: {
        id: "wacJiraServiceManagementPage.hero-heading-gwp-6480",
        defaultMessage: "Unlock high-velocity service management"
    },
    subheading: {
        id: "wacJiraServiceManagementPage.hero-subheading-gwp-6480",
        defaultMessage: "End bad service management for good. Unite teams on a single AI-powered platform to deliver service at scale."
    }
});
const $d2e09509ec9c0ee6$var$wrapperStyles = null;
const $d2e09509ec9c0ee6$var$leftStyles = null;
const $d2e09509ec9c0ee6$var$headingStyles = null;
const $d2e09509ec9c0ee6$var$accountCreationContainerStyles = null; /**
                                              * GWP-6480: Embedded Signup Form on jira service management software landing page hero
                                              *
                                              * This component is used to display the embedded signup form on the jira service management landing page hero.
                                              *
                                              * @returns {JSX.Element}
                                              */ 
const $d2e09509ec9c0ee6$var$GWP6480JSMEmbeddedSignup = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "jsm-hero-embedded-signup",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                id: "jsm-hero-embedded-signup",
                "data-testid": "jsm-hero-embedded-signup",
                className: (0, $esG4f.default)([
                    "_11q71ybm _1bsb1osq _1q511ylp _85i5fp70 _mkrz1ix2 _6rthxy5q"
                ]),
                style: {
                    "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                    layout: "6-6",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_uj6k1e5h _y3gn1h6o"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                                    className: (0, $esG4f.default)([
                                        "_1pfhv47k"
                                    ]),
                                    children: $d2e09509ec9c0ee6$var$messages.heading.defaultMessage
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                    className: "body-lg",
                                    children: $d2e09509ec9c0ee6$var$messages.subheading.defaultMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_p12fihnn _19pkidpf _2hwx1wug _otyridpf _18u01wug"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.default), {
                                    Login: null,
                                    Social: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aZTjH.Social), {
                                        providers: {
                                            google: "Google",
                                            microsoft: "Microsoft"
                                        }
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $d2e09509ec9c0ee6$export$2e2bcd8739ae039 = $d2e09509ec9c0ee6$var$GWP6480JSMEmbeddedSignup;

});

parcelRegister("8UlfF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2d1e9f7e5f6b4db$export$2e2bcd8739ae039; });
/* hero-tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $gf1F9 = parcelRequire("gf1F9");

var $8zMNO = parcelRequire("8zMNO");

var $257fv = parcelRequire("257fv");
var $hFDGT = parcelRequire("hFDGT");
var $6fxse = parcelRequire("6fxse");
var $bZyGC = parcelRequire("bZyGC");
var $jXVyf = parcelRequire("jXVyf");
var $j7TVc = parcelRequire("j7TVc");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");

var $bQawl = parcelRequire("bQawl");

var $bhreu = parcelRequire("bhreu");
parcelRequire("gXzhc");
var $fYNW7 = parcelRequire("fYNW7");

var $3FBn4 = parcelRequire("3FBn4");

var $kpWih = parcelRequire("kpWih");
const $a2d1e9f7e5f6b4db$var$TabContentStyles = (0, $j7TVc.xcss)({
    minHeight: "fit-content",
    maxWidth: "1200px",
    marginInline: "auto",
    gridTemplateColumns: "1fr",
    [(0, $bZyGC.media).above.sm]: {
        gridTemplateColumns: "340px 1fr"
    },
    [(0, $bZyGC.media).above.md]: {
        gridTemplateColumns: "400px 1fr"
    }
});
const $a2d1e9f7e5f6b4db$var$TabContentLeft = (0, $j7TVc.xcss)({
    order: "2",
    paddingInline: "space.400",
    paddingBlock: "space.200",
    [(0, $bZyGC.media).above.sm]: {
        order: "1"
    },
    [(0, $bZyGC.media).above.lg]: {
        paddingInline: "space.0"
    }
});
const $a2d1e9f7e5f6b4db$var$TabContentRight = null;
const $a2d1e9f7e5f6b4db$var$TabContentLeftHeadingStyles = (0, $j7TVc.xcss)({
    fontWeight: "700",
    [(0, $bZyGC.media).above.md]: {
        fontSize: "32px",
        lineHeight: "38px"
    }
});
const $a2d1e9f7e5f6b4db$var$TabContentListStyles = (0, $j7TVc.xcss)({
    listStyle: "none",
    paddingInlineStart: "space.0",
    marginBlockStart: "space.0",
    marginBlockEnd: "space.400"
});
const $a2d1e9f7e5f6b4db$var$TabContentListItemTextStyles = (0, $j7TVc.xcss)({
    fontSize: "16px",
    lineHeight: "24px",
    paddingInlineEnd: "space.0",
    [(0, $bZyGC.media).above.md]: {
        fontSize: "20px",
        lineHeight: "28px"
    }
});
const $a2d1e9f7e5f6b4db$var$TabContentRightPictureStyles = null;
const $a2d1e9f7e5f6b4db$var$TabContentLeftCtaStyles = null;
const $a2d1e9f7e5f6b4db$var$TabContentRightCtaStylestest = null;
const $a2d1e9f7e5f6b4db$var$tryNowButtonMessage = {
    id: "jsm-use-case-hero-tabs.try-now",
    defaultMessage: "Try now"
};
const $a2d1e9f7e5f6b4db$var$joinADemoButtonMessage = {
    id: "jsm-use-case-hero-tabs.join-a-demo",
    defaultMessage: "Join a demo"
};
const $a2d1e9f7e5f6b4db$var$learnMoreButtonMessage = {
    id: "jsm-use-case-hero-tabs.learn-more",
    defaultMessage: "Learn more"
}; // Component for the content of each tab, has a heading, a picture and a list of items with icons
// eslint-disable-next-line complexity
const $a2d1e9f7e5f6b4db$var$HeroTabContent = ({ heading: heading, picture: picture, list: list, imageAlt: imageAlt, primaryButton: primaryButton, secondaryButton: secondaryButton })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/free");
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).JIRA_SERVICE_DESK,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $hFDGT.default), {
        gap: "space.500",
        xcss: $a2d1e9f7e5f6b4db$var$TabContentStyles,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $257fv.default), {
                xcss: $a2d1e9f7e5f6b4db$var$TabContentLeft,
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        paddingBlockEnd: "space.300",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                            as: "h2",
                            size: "large",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                                as: "span",
                                xcss: $a2d1e9f7e5f6b4db$var$TabContentLeftHeadingStyles,
                                children: formatMessage(heading)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
                        as: "ul",
                        space: "space.200",
                        xcss: $a2d1e9f7e5f6b4db$var$TabContentListStyles,
                        children: [
                            list.map((item)=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $6fxse.default), {
                                    as: "li",
                                    alignBlock: "center",
                                    space: "space.100",
                                    children: [
                                        item.icon,
                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                                            as: "span",
                                            xcss: $a2d1e9f7e5f6b4db$var$TabContentListItemTextStyles,
                                            children: formatMessage(item.text)
                                        })
                                    ]
                                }, item.text.id)),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: "tab-content-ctas",
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $bQawl.default), {
                                        onClick: primaryButton ? openCrossFlow : undefined,
                                        url: (primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.url) || signupLink,
                                        text: formatMessage((primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.text) || $a2d1e9f7e5f6b4db$var$tryNowButtonMessage),
                                        "aria-label": (primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.text) || $a2d1e9f7e5f6b4db$var$tryNowButtonMessage,
                                        dataEventProps: {
                                            "data-product-key": "jiraServiceManagement",
                                            "data-event-component": "linkButton",
                                            "data-event-container": "heroSection",
                                            "data-event": "clicked",
                                            "data-label": formatMessage((primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.text) || $a2d1e9f7e5f6b4db$var$tryNowButtonMessage),
                                            "data-label-english": (primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.text.defaultMessage) || $a2d1e9f7e5f6b4db$var$tryNowButtonMessage.defaultMessage,
                                            "data-track-event": heading.defaultMessage
                                        },
                                        className: (0, $esG4f.default)([
                                            "_195g1wug _2rko1tcg _18zrgh54 _11q7b29m _1tkeckbl _1pfhpxbi _1wybgktf _19lc1b6v _1ywmidpf"
                                        ])
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $bQawl.default), {
                                        url: (0, $3FBn4.useLocalizedHref)((secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.url) || "/software/jira/service-management/demo"),
                                        text: formatMessage((secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.text) || $a2d1e9f7e5f6b4db$var$joinADemoButtonMessage),
                                        "aria-label": formatMessage((secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.text) || $a2d1e9f7e5f6b4db$var$joinADemoButtonMessage),
                                        type: "secondary",
                                        className: (0, $esG4f.default)([
                                            "_195g1wug _2rko1tcg _18zrgh54 _bfhk1j28 _19it1j28 _1tkeckbl _1pfhpxbi _1wybgktf _syazvb1l _9oik1r31 _1bnx8stv _jf4cnqa1 _irr31j28 _jomr1j28 _1di61j28 _1ywmidpf",
                                            "secondary-button"
                                        ]),
                                        dataEventProps: {
                                            "data-product-key": "jiraServiceManagement",
                                            "data-event-component": "linkButton",
                                            "data-event-container": "heroSection",
                                            "data-event": "clicked",
                                            "data-label": formatMessage((secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.text) || $a2d1e9f7e5f6b4db$var$joinADemoButtonMessage),
                                            "data-label-english": (secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.text.defaultMessage) || $a2d1e9f7e5f6b4db$var$joinADemoButtonMessage.defaultMessage
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1f49kb7n _1h1tp5r3 _tzy4idpf _y44vqz3z _6o24cs5v _7dyz12kb"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), (0, $6iHNw._)((0, $7Knp0._)({}, picture), {
                    image: {
                        src: picture.image.src,
                        alt: imageAlt ? formatMessage(imageAlt) : picture.image.alt
                    },
                    className: (0, $esG4f.default)([
                        "_1h1tbrkf _85i5pxbi _1jpx1dfr _18zxbrkf _1hgy1e8z"
                    ])
                }))
            })
        ]
    });
};
const $a2d1e9f7e5f6b4db$var$iconDimensions = (0, $j7TVc.xcss)({
    width: "48px",
    height: "48px"
}); // Content for each tab
const $a2d1e9f7e5f6b4db$var$tabs = [
    {
        id: "it-support",
        textLabel: "IT support",
        dataLabelEnglish: "IT supporty",
        component: /*#__PURE__*/ (0, $loA2J.jsx)($a2d1e9f7e5f6b4db$var$HeroTabContent, {
            heading: (0, $kpWih.messages).jsmUseCaseHeroTabsItSupportHeading,
            imageAlt: (0, $kpWih.messages).jsmUseCaseHeroTabsItSupportAlt,
            picture: {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ds5q16kwob38rb02h534e0dp37830mi7.webp",
                    alt: "A list of 4 service requests with fields for summary, status, requestor, channel and response. There is a search bar above the list of requests."
                },
                sources: [
                    {
                        srcSet: "https://dam-cdn.atl.orangelogic.com/AssetLink/0386o60lcs23u0wxo60c181728fvqa65.webp",
                        media: "(min-width: 48rem)",
                        type: "image/webp"
                    }
                ]
            },
            list: [
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsItSupportUsp1,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                    clipPath: "url(#clip0_1_3)",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M26.2857 13.7143L29.7212 13.7143V9.14286H18.279L18.279 13.7143L21.7143 13.7143V16.2073C15.8626 17.2822 11.4286 22.409 11.4286 28.5714V29.7143H36.5714V28.5714C36.5714 22.409 32.1374 17.2822 26.2857 16.2073V13.7143Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M38.8571 33.1429V37.7143L9.14286 37.7143V33.1429L38.8571 33.1429Z",
                                            fill: "#1868DB"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_1_3",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                },
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsItSupportUsp2,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                    clipPath: "url(#clip0_2_3)",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M32 20.5714L16 20.5714L16 16L32 16V20.5714Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M8 8V40H40V8H8ZM35.4286 12.5714H12.5714V24H17.1429C17.1429 27.7871 20.2129 30.8571 24 30.8571C27.7871 30.8571 30.8571 27.7871 30.8571 24H35.4286V12.5714Z",
                                            fill: "#1868DB"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_2_3",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                },
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsItSupportUsp3,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: (0, $j7TVc.xcss)({
                            width: "48px",
                            height: "48px"
                        }),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                d: "M9.14286 28.5714L27.4286 3.42857V19.4286H38.8571L20.5714 44.5714V28.5714H9.14286Z",
                                fill: "#1868DB"
                            })
                        })
                    })
                }
            ]
        })
    },
    {
        id: "engineering-support",
        textLabel: "Engineering support",
        dataLabelEnglish: "Engineering support",
        component: /*#__PURE__*/ (0, $loA2J.jsx)($a2d1e9f7e5f6b4db$var$HeroTabContent, {
            heading: (0, $kpWih.messages).jsmUseCaseHeroTabsEngineeringSupportHeading,
            imageAlt: (0, $kpWih.messages).jsmUseCaseHeroTabsEngineeringSupportAlt,
            picture: {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/h7r143ki88j2v6n656787rn8gc64yph1.webp",
                    alt: "A service project with options to see your queue, raise a request or see a knowledge base. One request is open. Its title is \u2018unhelpful error message\u2019 and has details about who raised the request and what it\u2019s about, as well as any linked requests."
                },
                sources: [
                    {
                        srcSet: "https://dam-cdn.atl.orangelogic.com/AssetLink/7v45j3bosu45w2lq477u15tjfem5783e.webp",
                        media: "(min-width: 48rem)",
                        type: "image/webp"
                    }
                ]
            },
            list: [
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsEngineeringSupportUsp1,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                                    clipPath: "url(#clip0_2_4)",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M40 8H24L4.57143 27.4286L20.5714 43.4286L40 24V8ZM30.8571 14.8571C29.5948 14.8571 28.5714 15.8805 28.5714 17.1429C28.5714 18.4052 29.5948 19.4286 30.8571 19.4286C32.1195 19.4286 33.1429 18.4052 33.1429 17.1429C33.1429 15.8805 32.1195 14.8571 30.8571 14.8571Z",
                                        fill: "#1868DB"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_2_4",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                },
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsEngineeringSupportUsp2,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                                    clipPath: "url(#clip0_5_26225)",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M19.4291 35.4279L40.0006 35.4275V7.99888L8.00056 7.99933V42.2846L19.4291 35.4279ZM33.1429 19.4286H14.8571V14.8571H33.1429V19.4286ZM25.1429 28.5714H14.8571V24H25.1429V28.5714Z",
                                        fill: "#1868DB"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_5_26225",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                },
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsEngineeringSupportUsp3,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: (0, $j7TVc.xcss)({
                            width: "48px",
                            height: "48px"
                        }),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8zMNO.JiraIcon), {
                            size: "large",
                            appearance: "brand"
                        })
                    })
                }
            ]
        })
    },
    {
        id: "employee-support",
        textLabel: "Employee support",
        dataLabelEnglish: "Employee support",
        component: /*#__PURE__*/ (0, $loA2J.jsx)($a2d1e9f7e5f6b4db$var$HeroTabContent, {
            heading: (0, $kpWih.messages).jsmUseCaseHeroTabsEmployeeSupportHeading,
            imageAlt: (0, $kpWih.messages).jsmUseCaseHeroTabsEmployeeSupportAlt,
            picture: {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/iejok30hpqe58a1ys00fwn86a4ho034m.webp",
                    alt: "A request portal with buttons for each company function to enter their part of the portal. For example, \u2018human resources - employee help\u2019 and \u2018Facilities - book an event\u2019."
                },
                sources: [
                    {
                        srcSet: "https://dam-cdn.atl.orangelogic.com/AssetLink/56m2ndu02rfu3qa17o7yl2i13t0628s0.webp",
                        media: "(min-width: 48rem)",
                        type: "image/webp"
                    }
                ]
            },
            list: [
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsEmployeeSupportUsp1,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                                    clipPath: "url(#clip0_5_26235)",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M19.4291 35.4279L40.0006 35.4275V7.99888L8.00056 7.99933V42.2846L19.4291 35.4279ZM33.1429 19.4286H14.8571V14.8571H33.1429V19.4286ZM25.1429 28.5714H14.8571V24H25.1429V28.5714Z",
                                        fill: "#1868DB"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_5_26235",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                },
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsEmployeeSupportUsp2,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                    clipPath: "url(#clip0_5_26238)",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M33.1429 19.4286H24V14.8571H33.1429V19.4286Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M30.8571 27.4286H24V22.8571H30.8571V27.4286Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M17.1429 8V14.8571H8V33.7143C8 37.1858 10.8142 40 14.2857 40H33.1429C36.9299 40 40 36.9299 40 33.1429V8H17.1429ZM36.5714 11.4286H20.5714V33.7143C20.5714 34.7431 20.3243 35.7142 19.886 36.5714H33.1429C35.0364 36.5714 36.5714 35.0364 36.5714 33.1429V11.4286Z",
                                            fill: "#1868DB"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_5_26238",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                },
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsEmployeeSupportUsp3,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                    clipPath: "url(#clip0_5_26241)",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M26.9551 17.8125L37.2408 7.52679L40.4733 10.7593L30.1876 21.045L26.9551 17.8125Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M15.8037 12.5714L26.2856 23.0534V40.0002H21.7142V24.9469L12.5711 15.8039L12.5712 23.2157H7.99972V8.00002L23.2154 8.00001L23.2154 12.5714L15.8037 12.5714Z",
                                            fill: "#1868DB"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_5_26241",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }
            ]
        })
    },
    {
        id: "it-operations",
        textLabel: "IT operations",
        dataLabelEnglish: "IT operations",
        component: /*#__PURE__*/ (0, $loA2J.jsx)($a2d1e9f7e5f6b4db$var$HeroTabContent, {
            heading: (0, $kpWih.messages).jsmUseCaseHeroTabsItOperationHeading,
            imageAlt: (0, $kpWih.messages).jsmUseCaseHeroTabsItOperationAlt,
            picture: {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/b5db764r7xdku57120or431jpot8843n.webp",
                    alt: "A request called \u2018Access service on staging\u2019 with requestor name (Andrew) and details about the request. There is also a risk summary and an option to either \u2018decline\u2019 or \u2018authorize\u2019 Andrew\u2019s request."
                },
                sources: [
                    {
                        srcSet: "https://dam-cdn.atl.orangelogic.com/AssetLink/27g7egubc3xn45a4r7e0t26d4q2p23r1.webp",
                        media: "(min-width: 48rem)",
                        type: "image/webp"
                    }
                ]
            },
            list: [
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsItOperationUsp1,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                                    clipPath: "url(#clip0_6_2)",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M9.14286 28.5714L27.4286 3.42857V19.4286H38.8571L20.5714 44.5714V28.5714H9.14286Z",
                                        fill: "#1868DB"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_6_2",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                },
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsItOperationUsp2,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                    clipPath: "url(#clip0_6_5)",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M24 16L13.2273 26.7727C10.815 25.6499 9.14276 23.2043 9.14286 20.3681C9.14296 17.2863 11.142 14.5606 14.0814 13.6345L15.7552 13.1071L16.2039 11.8349C17.2558 8.8521 20.0747 6.85714 23.2376 6.85714C26.6222 6.85714 29.5824 9.13624 30.4479 12.4083L31.1837 15.1905H33.8809C37.2604 15.1905 40 17.9301 40 21.3095C40 24.2111 37.9804 26.641 35.2702 27.2702L24 16Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M32.4736 29.2407L29.2411 32.4732L26.2858 29.5179V40H21.7144V29.5181L18.7593 32.4732L15.5268 29.2407L24.0002 20.7673L32.4736 29.2407Z",
                                            fill: "#1868DB"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_6_5",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                },
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsItOperationUsp3,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                    clipPath: "url(#clip0_6_8)",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M16.9388 22.8571L21.7143 8H26.2857L31.0612 22.8571H16.9388Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M15.4694 27.4286L12.898 35.4286H9.14286V40H38.8571V35.4286H35.102L32.5306 27.4286H15.4694Z",
                                            fill: "#1868DB"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_6_8",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }
            ]
        })
    },
    {
        id: "hr-service",
        textLabel: "HR service",
        dataLabelEnglish: "HR service",
        component: /*#__PURE__*/ (0, $loA2J.jsx)($a2d1e9f7e5f6b4db$var$HeroTabContent, {
            heading: (0, $kpWih.messages).jsmUseCaseHeroTabsHrServiceHeading,
            imageAlt: (0, $kpWih.messages).jsmUseCaseHeroTabsHrServiceAlt,
            picture: {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4cpm3q3n57lqn453lff53li7kn2p4kxb.webp",
                    alt: "A example company HR help center with a search bar at the top and a list of categories below. Categories include \u2018Software licensing\u2019, \u2018Travel and events\u2019, and \u2018Career Growth\u2019."
                },
                sources: [
                    {
                        srcSet: "https://dam-cdn.atl.orangelogic.com/AssetLink/83h76gf1uu347w786qympb8q43ys67s0.webp",
                        media: "(min-width: 48rem)",
                        type: "image/webp"
                    }
                ]
            },
            list: [
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsHrServiceUsp1,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                    clipPath: "url(#clip0_6_11)",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M23.3596 14.3508L9.4258 28.2845L7.36747 40.6292L19.7137 38.5724L33.6456 24.6405L23.3596 14.3508Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M36.0699 22.2161L39.1145 19.1716C40.8997 17.3863 40.8997 14.4919 39.1145 12.7066L35.2916 8.88372C33.5063 7.09847 30.6119 7.09847 28.8266 8.88372L25.784 11.9264L36.0699 22.2161Z",
                                            fill: "#1868DB"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_6_11",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                },
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsHrServiceUsp2,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                                    clipPath: "url(#clip0_6_14)",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M38,10H10v28h28V10ZM17,15.5c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2ZM17,28.5c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2ZM15,24c0-1.1.9-2,2-2s2,.9,2,2-.9,2-2,2-2-.9-2-2ZM32,19.01h-10v-3h10v3ZM32,25.5h-10v-3h10v3ZM22,32h10v-3h-10v3Z",
                                        fill: "#1868DB"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_6_14",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                },
                {
                    text: (0, $kpWih.messages).jsmUseCaseHeroTabsHrServiceUsp3,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "span",
                        xcss: $a2d1e9f7e5f6b4db$var$iconDimensions,
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                            width: "48",
                            height: "48",
                            viewBox: "0 0 48 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                    clipPath: "url(#clip0_6_13)",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M24,16c-1.1,0-2-.9-2-2v-3c0-1.1.9-2,2-2s2,.9,2,2v3c0,1.1-.9,2-2,2Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M34,22c-1.1,0-2,.9-2,2s.9,2,2,2h3c1.1,0,2-.9,2-2s-.9-2-2-2h-3Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M11,22c-1.1,0-2,.9-2,2s.9,2,2,2h3c1.1,0,2-.9,2-2s-.9-2-2-2h-3Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M22,37c0,1.1.9,2,2,2s2-.9,2-2v-3c0-1.1-.9-2-2-2s-2,.9-2,2v3Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M21.41,18.59l-9-9-2.83,2.83,9,9,2.83-2.83Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M9.59,35.59l9-9,2.83,2.83-9,9-2.83-2.83Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M35.59,38.41l-9-9,2.83-2.83,9,9-2.83,2.83Z",
                                            fill: "#1868DB"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M38.41,12.41l-9,9-2.83-2.83,9-9,2.83,2.83Z",
                                            fill: "#1868DB"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                                        id: "clip0_6_13",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            width: "48",
                                            height: "48",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }
            ],
            primaryButton: {
                text: $a2d1e9f7e5f6b4db$var$tryNowButtonMessage,
                url: "https://www.atlassian.com/software/jira/templates/hr-service-management"
            },
            secondaryButton: {
                text: $a2d1e9f7e5f6b4db$var$learnMoreButtonMessage,
                url: "https://www.atlassian.com/software/jira/service-management/hr"
            }
        })
    }
];
const $a2d1e9f7e5f6b4db$var$useTabs = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useMemo(()=>$a2d1e9f7e5f6b4db$var$tabs, []);
}; // Here's the overrides that we need to make the component work with the new design.
const $a2d1e9f7e5f6b4db$var$HeroTabStyles = null;
const $a2d1e9f7e5f6b4db$var$HeroTabs = ()=>{
    const tabs = $a2d1e9f7e5f6b4db$var$useTabs();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_85i5xy5q _1fpxglyw _6pje1txw _1vhk1wug _1ql51wug _2pzhglyw _1nb11q9c _cqnx1q9c _stua1y6m _1vowxy5q _1sdh1h6o _ar577vkz _1h311tcg _104bgktf _11uc1f4h _i63spxbi _12i1idpf _1sz71yqz _vtrs1yqz _6onnfg4m"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fYNW7.TabGroup), {
            tabContentType: "custom",
            id: "jsm-use-case-hero-tabs",
            dataProductKey: "jiraServiceManagement",
            label: "Product tour",
            tabs: tabs
        })
    });
};
var $a2d1e9f7e5f6b4db$export$2e2bcd8739ae039 = $a2d1e9f7e5f6b4db$var$HeroTabs;

});
parcelRegister("gf1F9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd2f563b70e4a361$export$2e2bcd8739ae039; });

var $55bgW = parcelRequire("55bgW");

var $hoKRr = parcelRequire("hoKRr");

var $51AkP = parcelRequire("51AkP");

var $2ZUkg = parcelRequire("2ZUkg");

var $lKLho = parcelRequire("lKLho");

var $f0Q8n = parcelRequire("f0Q8n");

var $XAEGR = parcelRequire("XAEGR");
var $bd2f563b70e4a361$var$_excluded = [
    "level",
    "size",
    "variant"
];
// https://atlassian.design/foundations/typography
var $bd2f563b70e4a361$var$levelMap = {
    h900: "h1",
    h800: "h1",
    h700: "h2",
    h600: "h3",
    h500: "h4",
    h400: "h5",
    h300: "h6",
    // NB: These two levels are not covered at all by the existing @atlaskit/css-reset
    h200: "div",
    h100: "div"
};
var $bd2f563b70e4a361$var$headingResetStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text, #172B4D)",
    marginBlock: "var(--ds-space-0, 0px)"
});
var $bd2f563b70e4a361$var$h900Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-600, 35px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-600, 40px)"
});
var $bd2f563b70e4a361$var$h800Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-500, 29px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-500, 32px)"
});
var $bd2f563b70e4a361$var$h700Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-400, 24px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-400, 28px)"
});
var $bd2f563b70e4a361$var$h600Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-300, 20px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.008em",
    lineHeight: "var(--ds-font-lineHeight-300, 24px)"
});
var $bd2f563b70e4a361$var$h500Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-200, 16px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.006em",
    lineHeight: "var(--ds-font-lineHeight-200, 20px)"
});
var $bd2f563b70e4a361$var$h400Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-100, 14px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.003em",
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $bd2f563b70e4a361$var$h300Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)",
    textTransform: "uppercase"
});
var $bd2f563b70e4a361$var$h200Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $bd2f563b70e4a361$var$h100Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-050, 11px)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $bd2f563b70e4a361$var$inverseStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
var $bd2f563b70e4a361$var$subtlestStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text-subtlest, #6B778C)"
});
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $bd2f563b70e4a361$var$Heading = function Heading(_ref) {
    var children = _ref.children, level = _ref.level, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? "default" : _ref$color;
    typeof $XAEGR;
    var _useHeading = (0, $lKLho.useHeading)($bd2f563b70e4a361$var$levelMap[level]), _useHeading2 = (0, $51AkP.default)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Markup = as || inferredElement;
    var isSubtleHeading = level === "h200" || level === "h100";
    var needsAriaRole = Markup === "div" && hLevel;
    return (0, $2ZUkg.jsx)(Markup, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $bd2f563b70e4a361$var$headingResetStyles,
            level === "h100" && $bd2f563b70e4a361$var$h100Styles,
            level === "h200" && $bd2f563b70e4a361$var$h200Styles,
            level === "h300" && $bd2f563b70e4a361$var$h300Styles,
            level === "h400" && $bd2f563b70e4a361$var$h400Styles,
            level === "h500" && $bd2f563b70e4a361$var$h500Styles,
            level === "h600" && $bd2f563b70e4a361$var$h600Styles,
            level === "h700" && $bd2f563b70e4a361$var$h700Styles,
            level === "h800" && $bd2f563b70e4a361$var$h800Styles,
            level === "h900" && $bd2f563b70e4a361$var$h900Styles,
            color === "inverse" && $bd2f563b70e4a361$var$inverseStyles,
            color === "default" && isSubtleHeading && $bd2f563b70e4a361$var$subtlestStyles
        ]
    }, children);
};
var $bd2f563b70e4a361$export$2e2bcd8739ae039 = function(_ref2) {
    var level = _ref2.level, size = _ref2.size, variant = _ref2.variant, props = (0, $hoKRr.default)(_ref2, $bd2f563b70e4a361$var$_excluded);
    return level ? // eslint-disable-next-line jsx-a11y/heading-has-content
    (0, $2ZUkg.jsx)($bd2f563b70e4a361$var$Heading, (0, $55bgW.default)({
        level: level
    }, props)) : // eslint-disable-next-line jsx-a11y/heading-has-content
    (0, $2ZUkg.jsx)((0, $f0Q8n.default), (0, $55bgW.default)({
        variant: variant,
        size: size
    }, props));
};

});
parcelRegister("55bgW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b3629cfac53a12d$export$2e2bcd8739ae039; });
function $3b3629cfac53a12d$export$2e2bcd8739ae039() {
    return $3b3629cfac53a12d$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3b3629cfac53a12d$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("hoKRr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $caa9072beea685d0$export$2e2bcd8739ae039; });

var $3yQ29 = parcelRequire("3yQ29");
function $caa9072beea685d0$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $3yQ29.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("3yQ29", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $297ce8e5514af5b7$export$2e2bcd8739ae039; });
function $297ce8e5514af5b7$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("51AkP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a893b15f80cd459$export$2e2bcd8739ae039; });

var $55WqS = parcelRequire("55WqS");

var $9bwzO = parcelRequire("9bwzO");

var $48n3y = parcelRequire("48n3y");

var $63ytQ = parcelRequire("63ytQ");
function $3a893b15f80cd459$export$2e2bcd8739ae039(r, e) {
    return (0, $55WqS.default)(r) || (0, $9bwzO.default)(r, e) || (0, $48n3y.default)(r, e) || (0, $63ytQ.default)();
}

});
parcelRegister("55WqS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b5abed66b4d156d$export$2e2bcd8739ae039; });
function $3b5abed66b4d156d$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("9bwzO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6afe692e4836e851$export$2e2bcd8739ae039; });
function $6afe692e4836e851$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("48n3y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3029cb4c0a9b1fea$export$2e2bcd8739ae039; });

var $gUiIg = parcelRequire("gUiIg");
function $3029cb4c0a9b1fea$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $gUiIg.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $gUiIg.default)(r, a) : void 0;
    }
}

});
parcelRegister("gUiIg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4f0644843190b98$export$2e2bcd8739ae039; });
function $c4f0644843190b98$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("63ytQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $468dc4fb5050bd06$export$2e2bcd8739ae039; });
function $468dc4fb5050bd06$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("lKLho", function(module, exports) {

$parcel$export(module.exports, "useHeading", function () { return $fd6291971cdbcf3a$export$97a37b1befbbf9b1; });

var $iSvIT = parcelRequire("iSvIT");
// Allows support for heading levels 1-9 via aria-level
var $fd6291971cdbcf3a$var$HeadingLevelContext = /*#__PURE__*/ (0, $iSvIT.createContext)(0);
var $fd6291971cdbcf3a$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $iSvIT.useContext)($fd6291971cdbcf3a$var$HeadingLevelContext);
};
var $fd6291971cdbcf3a$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $fd6291971cdbcf3a$export$6a64a1e2d0bbbf75();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? "div" : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $fd6291971cdbcf3a$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $fd6291971cdbcf3a$export$6a64a1e2d0bbbf75();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($fd6291971cdbcf3a$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $fd6291971cdbcf3a$export$2e2bcd8739ae039 = $fd6291971cdbcf3a$var$HeadingLevelContextProvider;

});

parcelRegister("f0Q8n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aedf4bde1316c1cf$export$2e2bcd8739ae039; });

var $51AkP = parcelRequire("51AkP");

var $2ZUkg = parcelRequire("2ZUkg");

var $lKLho = parcelRequire("lKLho");

var $XAEGR = parcelRequire("XAEGR");
var $aedf4bde1316c1cf$var$sizeTagMap = {
    xxlarge: "h1",
    xlarge: "h1",
    large: "h2",
    medium: "h3",
    small: "h4",
    xsmall: "h5",
    xxsmall: "h6"
};
var $aedf4bde1316c1cf$var$headingResetStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text, #172B4D)",
    letterSpacing: "normal",
    marginBlock: 0,
    textTransform: "none"
});
var $aedf4bde1316c1cf$var$inverseStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $aedf4bde1316c1cf$var$Heading = function Heading(_ref) {
    var children = _ref.children, size = _ref.size, variant = _ref.variant, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? "default" : _ref$color;
    typeof $XAEGR;
    // TODO: Temporary to move variant over to size
    var localSize = variant || size;
    // Technically size can be undefined here due to how the types work.
    // Once removing the level prop this assertion can be removed since size will be a required prop.
    var _useHeading = (0, $lKLho.useHeading)($aedf4bde1316c1cf$var$sizeTagMap[localSize]), _useHeading2 = (0, $51AkP.default)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === "div" && hLevel;
    return (0, $2ZUkg.jsx)(Component, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $aedf4bde1316c1cf$var$headingResetStyles,
            localSize && $aedf4bde1316c1cf$var$headingSizeStylesMap[localSize],
            color === "inverse" && $aedf4bde1316c1cf$var$inverseStyles
        ]
    }, children);
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::057c0fe2015c2071afe3d694c5afcc0e>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $aedf4bde1316c1cf$var$headingSizeStylesMap = {
    xxlarge: (0, $2ZUkg.css)({
        font: 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xlarge: (0, $2ZUkg.css)({
        font: 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    large: (0, $2ZUkg.css)({
        font: 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    medium: (0, $2ZUkg.css)({
        font: 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    small: (0, $2ZUkg.css)({
        font: 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xsmall: (0, $2ZUkg.css)({
        font: 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xxsmall: (0, $2ZUkg.css)({
        font: 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    })
};
var /**
 * @codegenEnd
 */ $aedf4bde1316c1cf$export$2e2bcd8739ae039 = $aedf4bde1316c1cf$var$Heading;

});


parcelRegister("hFDGT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdd50dcba0f85b09$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $ihHOk = parcelRequire("ihHOk");

var $j7TVc = parcelRequire("j7TVc");
var $cdd50dcba0f85b09$var$justifyContentMap = {
    start: (0, $2ZUkg.css)({
        justifyContent: "start"
    }),
    center: (0, $2ZUkg.css)({
        justifyContent: "center"
    }),
    end: (0, $2ZUkg.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $2ZUkg.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $2ZUkg.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $2ZUkg.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $2ZUkg.css)({
        justifyContent: "stretch"
    })
};
var $cdd50dcba0f85b09$var$justifyItemsMap = {
    start: (0, $2ZUkg.css)({
        justifyItems: "start"
    }),
    center: (0, $2ZUkg.css)({
        justifyItems: "center"
    }),
    end: (0, $2ZUkg.css)({
        justifyItems: "end"
    }),
    stretch: (0, $2ZUkg.css)({
        justifyItems: "stretch"
    })
};
var $cdd50dcba0f85b09$var$alignContentMap = {
    start: (0, $2ZUkg.css)({
        alignContent: "start"
    }),
    center: (0, $2ZUkg.css)({
        alignContent: "center"
    }),
    end: (0, $2ZUkg.css)({
        alignContent: "end"
    }),
    "space-between": (0, $2ZUkg.css)({
        alignContent: "space-between"
    }),
    "space-around": (0, $2ZUkg.css)({
        alignContent: "space-around"
    }),
    "space-evenly": (0, $2ZUkg.css)({
        alignContent: "space-evenly"
    }),
    stretch: (0, $2ZUkg.css)({
        alignContent: "stretch"
    })
};
var $cdd50dcba0f85b09$var$alignItemsMap = {
    start: (0, $2ZUkg.css)({
        alignItems: "start"
    }),
    center: (0, $2ZUkg.css)({
        alignItems: "center"
    }),
    baseline: (0, $2ZUkg.css)({
        alignItems: "baseline"
    }),
    end: (0, $2ZUkg.css)({
        alignItems: "end"
    })
};
var $cdd50dcba0f85b09$var$baseStyles = (0, $2ZUkg.css)({
    display: "grid",
    boxSizing: "border-box"
});
var $cdd50dcba0f85b09$var$gridAutoFlowMap = {
    row: (0, $2ZUkg.css)({
        gridAutoFlow: "row"
    }),
    column: (0, $2ZUkg.css)({
        gridAutoFlow: "column"
    }),
    dense: (0, $2ZUkg.css)({
        gridAutoFlow: "dense"
    }),
    "row dense": (0, $2ZUkg.css)({
        gridAutoFlow: "row dense"
    }),
    "column dense": (0, $2ZUkg.css)({
        gridAutoFlow: "column dense"
    })
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ var $cdd50dcba0f85b09$var$Grid = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignItems, alignContent = _ref.alignContent, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, id = _ref.id, role = _ref.role, testId = _ref.testId, autoFlow = _ref.autoFlow, gridTemplateAreas = _ref.templateAreas, gridTemplateRows = _ref.templateRows, gridTemplateColumns = _ref.templateColumns, xcss = _ref.xcss;
    var Component = as || "div";
    var xcssClassName = xcss && (0, $j7TVc.parseXcss)(xcss);
    var style = gridTemplateAreas || gridTemplateColumns || gridTemplateRows ? Object.assign({}, {
        gridTemplateAreas: gridTemplateAreas ? gridTemplateAreas.map(function(str) {
            return '"'.concat(str, '"');
        }).join("\n") : undefined,
        gridTemplateColumns: gridTemplateColumns,
        gridTemplateRows: gridTemplateRows
    }) : undefined;
    return (0, $2ZUkg.jsx)(Component, {
        id: id,
        role: role,
        style: style,
        css: [
            $cdd50dcba0f85b09$var$baseStyles,
            gap && (0, $ihHOk.spaceStylesMap).gap[gap],
            columnGap && (0, $ihHOk.spaceStylesMap).columnGap[columnGap],
            rowGap && (0, $ihHOk.spaceStylesMap).rowGap[rowGap],
            alignItems && $cdd50dcba0f85b09$var$alignItemsMap[alignItems],
            alignContent && $cdd50dcba0f85b09$var$alignContentMap[alignContent],
            justifyContent && $cdd50dcba0f85b09$var$justifyContentMap[justifyContent],
            autoFlow && $cdd50dcba0f85b09$var$gridAutoFlowMap[autoFlow],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            xcssClassName && xcssClassName
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$cdd50dcba0f85b09$var$Grid.displayName = "Grid";
var $cdd50dcba0f85b09$export$2e2bcd8739ae039 = $cdd50dcba0f85b09$var$Grid;

});

parcelRegister("6fxse", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48ce182491db562e$export$2e2bcd8739ae039; });

var $dClj0 = parcelRequire("dClj0");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $j7TVc = parcelRequire("j7TVc");

var $1Lr0O = parcelRequire("1Lr0O");
var $48ce182491db562e$var$flexGrowMap = {
    hug: (0, $j7TVc.xcss)({
        flexGrow: 0
    }),
    fill: (0, $j7TVc.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
var $48ce182491db562e$var$separatorStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $48ce182491db562e$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $2ZUkg.jsx)("span", {
        css: $48ce182491db562e$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $48ce182491db562e$var$Inline = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $2ZUkg.jsx)($48ce182491db562e$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $iSvIT.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    return (0, $2ZUkg.jsx)((0, $1Lr0O.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: grow ? [
            $48ce182491db562e$var$flexGrowMap[grow]
        ].concat((0, $dClj0.default)(Array.isArray(xcss) ? xcss : [
            xcss
        ])) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss,
        testId: testId,
        ref: ref
    }, children);
}));
$48ce182491db562e$var$Inline.displayName = "Inline";
var $48ce182491db562e$export$2e2bcd8739ae039 = $48ce182491db562e$var$Inline;

});

parcelRegister("kpWih", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $4733e7ac6f770226$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $4733e7ac6f770226$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    jsmUseCaseHeroTabsItSupportHeading: {
        id: "jsm-use-case-hero-tabs.it-support.heading",
        defaultMessage: "IT support"
    },
    jsmUseCaseHeroTabsItSupportAlt: {
        id: "jsm-use-case-hero-tabs.it-support.alt",
        defaultMessage: "A list of 4 service requests with fields for summary, status, requestor, channel and response. There is a search bar above the list of requests."
    },
    jsmUseCaseHeroTabsItSupportUsp1: {
        id: "jsm-use-case-hero-tabs.it-support.usp1",
        defaultMessage: "Spin up a service desk with ease"
    },
    jsmUseCaseHeroTabsItSupportUsp2: {
        id: "jsm-use-case-hero-tabs.it-support.usp2",
        defaultMessage: "Manage all your requests in one place"
    },
    jsmUseCaseHeroTabsItSupportUsp3: {
        id: "jsm-use-case-hero-tabs.it-support.usp3",
        defaultMessage: "Automate support interactions with AI"
    },
    jsmUseCaseHeroTabsEngineeringSupportHeading: {
        id: "jsm-use-case-hero-tabs.engineering-support.heading",
        defaultMessage: "Engineering support"
    },
    jsmUseCaseHeroTabsEngineeringSupportAlt: {
        id: "jsm-use-case-hero-tabs.engineering-support.alt",
        defaultMessage: "A service project with options to see your queue, raise a request or see a knowledge base. One request is open. Its title is \u2018unhelpful error message\u2019 and has details about who raised the request and what it\u2019s about, as well as any linked requests. "
    },
    jsmUseCaseHeroTabsEngineeringSupportUsp1: {
        id: "jsm-use-case-hero-tabs.engineering-support.usp1",
        defaultMessage: "Triage your unplanned work"
    },
    jsmUseCaseHeroTabsEngineeringSupportUsp2: {
        id: "jsm-use-case-hero-tabs.engineering-support.usp2",
        defaultMessage: "Manage customer requests"
    },
    jsmUseCaseHeroTabsEngineeringSupportUsp3: {
        id: "jsm-use-case-hero-tabs.engineering-support.usp3",
        defaultMessage: "Link requests to Jira issues"
    },
    jsmUseCaseHeroTabsEmployeeSupportHeading: {
        id: "jsm-use-case-hero-tabs.employee-support.heading",
        defaultMessage: "Employee support"
    },
    jsmUseCaseHeroTabsEmployeeSupportAlt: {
        id: "jsm-use-case-hero-tabs.employee-support.alt",
        defaultMessage: "A request portal with buttons for each company function to enter their part of the portal. For example, \u2018human resources - employee help\u2019 and \u2018Facilities - book an event\u2019."
    },
    jsmUseCaseHeroTabsEmployeeSupportUsp1: {
        id: "jsm-use-case-hero-tabs.employee-support.usp1",
        defaultMessage: "Ensure anyone can get help quickly"
    },
    jsmUseCaseHeroTabsEmployeeSupportUsp2: {
        id: "jsm-use-case-hero-tabs.employee-support.usp2",
        defaultMessage: "Empower employees with self-service"
    },
    jsmUseCaseHeroTabsEmployeeSupportUsp3: {
        id: "jsm-use-case-hero-tabs.employee-support.usp3",
        defaultMessage: "Deflect requests and save time with an AI-powered Virtual Service Agent"
    },
    jsmUseCaseHeroTabsItOperationHeading: {
        id: "jsm-use-case-hero-tabs.it-operation.heading",
        defaultMessage: "IT operations"
    },
    jsmUseCaseHeroTabsItOperationAlt: {
        id: "jsm-use-case-hero-tabs.it-operation.alt",
        defaultMessage: "A request called \u2018Access service on staging\u2019 with requestor name (Andrew) and details about the request. There is also a risk summary and an option to either \u2018decline\u2019 or \u2018authorize\u2019 Andrew\u2019s request."
    },
    jsmUseCaseHeroTabsItOperationUsp1: {
        id: "jsm-use-case-hero-tabs.it-operations.usp1",
        defaultMessage: "Automate change requests"
    },
    jsmUseCaseHeroTabsItOperationUsp2: {
        id: "jsm-use-case-hero-tabs.it-operations.usp2",
        defaultMessage: "Deploy with confidence"
    },
    jsmUseCaseHeroTabsItOperationUsp3: {
        id: "jsm-use-case-hero-tabs.it-operations.usp3",
        defaultMessage: "Detect, resolve, and prevent incidents with AI"
    },
    jsmUseCaseHeroTabsHrServiceHeading: {
        id: "jsm-use-case-hero-tabs.hr-service.heading",
        defaultMessage: "HR service"
    },
    jsmUseCaseHeroTabsHrServiceAlt: {
        id: "jsm-use-case-hero-tabs.hr-service.alt",
        defaultMessage: "A example company HR help center with a search bar at the top and a list of categories below. Categories include \u2018Software licensing\u2019, \u2018Travel and events\u2019, and \u2018Career Growth\u2019."
    },
    jsmUseCaseHeroTabsHrServiceUsp1: {
        id: "jsm-use-case-hero-tabs.hr-service.usp1",
        defaultMessage: "Customize your help center"
    },
    jsmUseCaseHeroTabsHrServiceUsp2: {
        id: "jsm-use-case-hero-tabs.hr-service.usp1",
        defaultMessage: "Get started fast, with prebuilt templates"
    },
    jsmUseCaseHeroTabsHrServiceUsp3: {
        id: "jsm-use-case-hero-tabs.hr-service.usp3",
        defaultMessage: "Automate employee support with the virtual service agent"
    }
});

});


parcelRegister("kMsPi", function(module, exports) {

$parcel$export(module.exports, "AtlassianIntelligenceITSM", function () { return $0a7427d500304e0f$export$670499c84e6e6f84; });
/* ai-itsm.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $91nJf = parcelRequire("91nJf");

var $cssyA = parcelRequire("cssyA");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $6qcUm = parcelRequire("6qcUm");
parcelRequire("Tf71T");
var $fkaMJ = parcelRequire("fkaMJ");
const $0a7427d500304e0f$export$670499c84e6e6f84 = ()=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $f6qj2.default)();
    const title = formatMessage({
        id: "jsm-product-tour.ai-section.title-text",
        defaultMessage: "Smarter ITSM, powered by AI"
    });
    const subTitle = formatMessage({
        id: "jsm-product-tour.ai-section.subtitle-text",
        defaultMessage: "AI helps support and operations teams stay ahead by predicting issues, suggesting actions, and automating resolutions to turn insights into action."
    });
    const buttonText = formatMessage({
        id: "jsm-product-tour.ai-section.button-text",
        defaultMessage: "Explore AI in ITSM"
    });
    const videoLink = (0, $fkaMJ.getAiVideoJSM)(locale);
    const imageLink = (0, $fkaMJ.getAiImageJSM)(locale);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: "gwp-4949-button-clicked",
                section: "ai-section"
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _6a6z1h6o _bfhk17la _syazcd5j _ca0qvbgk _u5f39by0 _n3tdvbgk _19bv9by0 _zulpzwfg"
                ]),
                style: {
                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $6qcUm.Intelligence), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                        className: (0, $esG4f.default)([
                            "_1wybckbl _k48p1fw0 _vwz4bs82 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o _flz0zwfg _1lzozwfg _1cqs1tcg"
                        ]),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_syazcd5j _y3gn1h6o _ect4bzd7 _1wyb7vkz _k48p1nn1 _p12f1ogm _1bsb1osq"
                        ]),
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                        },
                        children: subTitle
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1tz91y44 _1k797vkz"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                            variant: "secondary",
                            color: "white",
                            colorAgainst: "other",
                            size: "large",
                            href: (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/features/itsm/ai"),
                            onClick: handleClick,
                            dataEventProps: {
                                "data-product-key": "jira",
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "ctaSection",
                                "data-label": "explore-atlassian-intelligence",
                                "data-label-english": "Explore AI in ITSM",
                                "data-track-event": "jira-pt.ai-section.explore-atlassian-intelligence"
                            },
                            children: buttonText
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("video", {
                        playsInline: true,
                        muted: true,
                        preload: "auto",
                        autoPlay: true,
                        loop: true,
                        className: (0, $esG4f.default)([
                            "_p12f1uof _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _19451ogm _liwcglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                            src: videoLink,
                            type: "video/mp4"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $cssyA.Picture), {
                        image: {
                            src: imageLink,
                            alt: "",
                            width: 2752,
                            height: 1838
                        },
                        className: (0, $esG4f.default)([
                            "_mezj1osq _bna71wug _14bq7vkz _3tce7vkz _1ym67vkz _1xr17vkz _1z4kglyw"
                        ])
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1tkemgvx _12vemgnk _ouxlbbky _1lrwykpt _bfhku7gi _1itkoro1 _1jgo1wqb _1w8u1dh4"
                ])
            })
        ]
    });
};
const $0a7427d500304e0f$var$aiSectionStyles = null;
const $0a7427d500304e0f$var$imageStyles = null;
const $0a7427d500304e0f$var$videoStyles = null;
const $0a7427d500304e0f$var$titleStyles = null;
const $0a7427d500304e0f$var$subTitleStyles = null;
const $0a7427d500304e0f$var$buttonStyles = null;
const $0a7427d500304e0f$var$footerStyles = null;

});

parcelRegister("avg0H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c85ff98bbf90c6d$export$2e2bcd8739ae039; });
/* cards.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("9HFEq");
var $dbhgV = parcelRequire("dbhgV");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $3c85ff98bbf90c6d$var$pageSection = null;
const $3c85ff98bbf90c6d$var$divider = null;
const $3c85ff98bbf90c6d$var$resourcesHeader = null;
const $3c85ff98bbf90c6d$var$cardsContainer = null;
const $3c85ff98bbf90c6d$var$Card = ({ pictureProps: pictureProps, headerText: headerText, eyebrowText: eyebrowText, orientation: orientation, primaryLink: primaryLink })=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $dbhgV.Card), {
        headerText: headerText,
        eyebrowText: eyebrowText,
        pictureProps: pictureProps,
        orientation: orientation,
        ctaProps: {
            primaryLinkProps: {
                type: "primary",
                text: primaryLink.text,
                href: primaryLink.link,
                dataEventProps: {
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": `cardSection`,
                    "data-product-key": "jiraServiceDesk",
                    "data-label": primaryLink.text,
                    "data-label-english": primaryLink.dataLabelEnglish
                }
            }
        }
    });
const $3c85ff98bbf90c6d$var$CardsSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const cardData = [
        {
            pictureProps: {
                image: {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:01c0f236-3cb0-4068-8ca8-30219b394ae3/jsm-tei-report.png?cdnVersion=1290",
                    alt: intl.formatMessage({
                        id: "jira-service-management.resources.card0.image.alt",
                        defaultMessage: `Cover of spiral notebook titled: "The Total Economic Impact TM of Atlassian Jira Service Management"`
                    }),
                    width: 1136,
                    height: 680
                }
            },
            headerText: intl.formatMessage({
                id: "jira-service-management.resources.card0.body",
                defaultMessage: "The Total Economic Impact\u2122 of Atlassian for ITSM"
            }),
            eyebrowText: intl.formatMessage({
                id: "jira-service-management.resources.card0.header",
                defaultMessage: "forrester report"
            }),
            primaryLink: {
                text: intl.formatMessage({
                    id: "jira-service-management.resources.card0.primary.link",
                    defaultMessage: "Get report"
                }),
                dataLabelEnglish: "Get report",
                link: (0, $3FBn4.useLocalizedHref)("/jira/service-management/total-economic-impact-hub")
            },
            orientation: "vertical"
        },
        {
            pictureProps: {
                sources: [
                    {
                        srcSet: "https://wac-cdn.atlassian.com/dam/jcr:6d1ac7d5-56e6-4ca0-933a-cf4c28c646e5/jsm-get-started-wide.png?cdnVersion=1290",
                        media: "(max-width: 63.99rem)"
                    }
                ],
                image: {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:cc80a855-d6a0-4083-8f34-b46a3122bcc1/jsm-get-started.png?cdnVersion=1290",
                    alt: intl.formatMessage({
                        id: "jira-service-management.resources.card1.image.alt",
                        defaultMessage: "Customers being helped out at a service desk by an attendant"
                    })
                }
            },
            headerText: intl.formatMessage({
                id: "jira-service-management.resources.card1.body",
                defaultMessage: "Get started with Jira Service Management"
            }),
            eyebrowText: intl.formatMessage({
                id: "jira-service-management.resources.card1.header",
                defaultMessage: "Guides"
            }),
            primaryLink: {
                text: intl.formatMessage({
                    id: "jira-service-management.resources.card1.primary.link",
                    defaultMessage: "Learn more"
                }),
                dataLabelEnglish: "Learn more",
                link: (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/product-guide/getting-started/quick-start-guide")
            },
            orientation: "horizontal"
        },
        {
            pictureProps: {
                sources: [
                    {
                        srcSet: "https://wac-cdn.atlassian.com/dam/jcr:e40a81ed-cc02-472d-a62b-f5b2d21d11ef/tips-and-tricks-wide.png?cdnVersion=1290",
                        media: "(max-width: 63.99rem)"
                    }
                ],
                image: {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:e5c74440-938a-4c00-bd28-1bd53a67d798/jsm-tips.png?cdnVersion=1290",
                    alt: intl.formatMessage({
                        id: "jira-service-management.resources.card2.image.alt",
                        defaultMessage: "Two people learning concepts drawn on a black board"
                    })
                }
            },
            headerText: intl.formatMessage({
                id: "jira-service-management.resources.card2.body",
                defaultMessage: "Tips, tricks, and best practices for managing IT service delivery"
            }),
            eyebrowText: intl.formatMessage({
                id: "jira-service-management.resources.card2.header",
                defaultMessage: "ITSM"
            }),
            primaryLink: {
                text: intl.formatMessage({
                    id: "jira-service-management.resources.card2.primary.link",
                    defaultMessage: "Learn more"
                }),
                dataLabelEnglish: "Learn more",
                link: (0, $3FBn4.useLocalizedHref)("/itsm")
            },
            orientation: "horizontal"
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_12l21wug _ahbq1wug _1ul91osq _1yt4wf4d _11rm1hrf _kqswh2mm _1aahidpf"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("hr", {
                        className: (0, $esG4f.default)([
                            "_4t3iyh40 _19itidpf _1h6dlscw _bfhklscw _1bsb1osq _dbjgvbgk _1hvk1wug _isu4zwfg _15qm1wug _3wvkzwfg _1fbnidpf _1uby7vkz _1t0ridpf"
                        ]),
                        style: {
                            "--_w9vrer": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark1100"))
                        }
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_y3gn1h6o _cg411tj6 _l5k1bfng _1n467vkz _if5yidpf _1gnp7vkz _7e5bidpf _qc0pahaf _1kll1k8s"
                        ]),
                        style: {
                            "--_1tgiy09": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue900"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "jira-service-management.resources.header",
                            defaultMessage: "Jira Service Management resources",
                            tagName: "h2"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c11p5 _p12f1fra _zulpxy5q _19pkckbl _otyr7vkz _1rqtf9jr _12fk19ia _1da7z7l7 _4u9p13qz _fjgkz7l7 _1yx710xu _13i17vkz _d08ozwfg _1u3w7vkz _fxxg7vkz _9bmlxy5q _1qofzwfg _19fgzwfg _mw66zwfg _nqa3zwfg _1ic8gktf _13d6idpf _1aqaidpf _1yqbidpf _1ihtidpf _31yooqnp _uq2s1nn1 _lgg41tcg _tz0rt94y _qldh19bv _1oazidpf _qly9idpf _3nktidpf _1ritidpf _160g1nn1 _1vopidpf _1ugpidpf _1n35idpf _1j70idpf"
                        ]),
                        children: cardData.map((card, index)=>{
                            const cardStyles = [
                                index === 0 && null,
                                index === 1 && null,
                                index === 2 && null
                            ];
                            return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    index === 0 && "_nd5l1820 _1och1txw _15jj1bp4 _71rf1j6v _1ifi1ns9 _lin31wug",
                                    index === 1 && "_nd5l1hob _7vrlmxmv _ehw4idpf _12ii1txw _25qu1bp4",
                                    index === 2 && "_nd5l5lkg _7vrlmxmv _ehw4idpf _12ii1txw _25qu1bp4"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)($3c85ff98bbf90c6d$var$Card, (0, $7Knp0._)({}, card))
                            }, index);
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("hr", {
                        className: (0, $esG4f.default)([
                            "_4t3iyh40 _19itidpf _1h6dlscw _bfhklscw _1bsb1osq _dbjgvbgk _1hvk1wug _isu4zwfg _15qm1wug _3wvkzwfg _1fbnidpf _1uby7vkz _1t0ridpf"
                        ]),
                        style: {
                            "--_w9vrer": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark1100"))
                        }
                    })
                })
            ]
        })
    });
};
var $3c85ff98bbf90c6d$export$2e2bcd8739ae039 = $3c85ff98bbf90c6d$var$CardsSection;

});

parcelRegister("gd7EO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05d3458b1c028341$export$2e2bcd8739ae039; });
/* cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $05d3458b1c028341$var$ctaSectionStyles = null;
const $05d3458b1c028341$var$CTASection = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/free");
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).JIRA_SERVICE_DESK,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    const ctaButtonText = intl.formatMessage({
        id: "jira-service-management.cta.button",
        defaultMessage: "Try it free"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1h3e1khj _12vemgnk _1lrw1dfr _ouxl1ssb _w0ge1pfc _syazu67f _ixrs16xz _4x03idpf _94fo16xz _z9bjidpf _19xdvbgk _1k6widpf _17z4vbgk _1ymhidpf _1bao7vkz _1xsmidpf _eabl7vkz _z140idpf _1upwahaf _gamf11ph _16hmidpf _11vc1nn1 _16o61k8s _12kzdlk8 _im8vidpf _z1pmidpf _15kdidpf _qkjtidpf _j9pmidpf _7vjp1nn1 _1l677vkz _q19bb4wl"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                headerText: intl.formatMessage({
                    id: "jira-service-management.cta.header",
                    defaultMessage: "Get started with Jira Service Management today"
                }),
                headerType: "h2",
                isCentered: true,
                ctaProps: {
                    buttonProps: {
                        text: ctaButtonText,
                        color: "yellow",
                        className: "jsm-hero-section-cta",
                        dataEventProps: {
                            "data-event-component": "linkButton",
                            "data-event-container": "ctaSection",
                            "data-event": "clicked",
                            "data-product-key": "jiraServiceManagement",
                            "data-label-english": "Try it free",
                            "data-label": ctaButtonText
                        },
                        onClick: openCrossFlow,
                        url: signupLink
                    },
                    secondaryLinkProps: {
                        text: intl.formatMessage({
                            id: "jira-service-management.cta.link",
                            defaultMessage: "Explore plans"
                        }),
                        href: (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/pricing"),
                        type: "primary",
                        bgColor: "bgBlackBlue",
                        dataEventProps: {
                            "data-event-component": "linkButton",
                            "data-event-container": "ctaSection",
                            "data-event": "clicked",
                            "data-product-key": "jiraServiceManagement"
                        }
                    }
                }
            })
        })
    });
};
var $05d3458b1c028341$export$2e2bcd8739ae039 = $05d3458b1c028341$var$CTASection;

});

parcelRegister("entQJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $629e22e9cb1e779a$export$2e2bcd8739ae039; });
/* customers.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("2pEWv");
var $fXpYT = parcelRequire("fXpYT");
const $629e22e9cb1e779a$var$sectionStyle = null;
const $629e22e9cb1e779a$var$customerQuoteStyle = null;
const $629e22e9cb1e779a$var$image = null;
const $629e22e9cb1e779a$var$blurbStyle = null;
const $629e22e9cb1e779a$var$nameStyle = null;
const $629e22e9cb1e779a$var$benefitStyle = null;
const $629e22e9cb1e779a$var$inlineLogosProp = [
    {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8hil7171bgf726i008u426ly20lmckpd.svg",
        alt: "Square logo",
        width: "144px"
    },
    {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1728do7q372772c56nn1d6176lgv7g41.svg",
        alt: "Sotheby's logo",
        width: "146px"
    },
    {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ol564g48h6368my8s6v44fcc1w7jtds1.svg",
        alt: "Domino's logo",
        width: "162px"
    },
    {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/58qk6136v662bx6i084qm16f383471s2.svg",
        alt: "Puppet logo",
        width: "99px"
    },
    {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8h645v2kexjar2qvcn757ao4cws2jj8u.svg",
        alt: "Twitter logo",
        width: "43px"
    },
    {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5vhj2x4xck7s3f4gjhtin3ges02a2mn0.svg",
        alt: "The Telegraph logo",
        width: "219px"
    }
];
const $629e22e9cb1e779a$var$patternLogosJSMCustomersSectionStyle = null;
const $629e22e9cb1e779a$var$Benefit = ({ title: title, description: description })=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _zulp1k8s _18s8zu5n _qmr413ei _1o4kbfng _1hxgze3t _5t8d1j6v _1hgt1nn1 _1po3ze3t"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                children: title
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                children: description
            })
        ]
    });
const $629e22e9cb1e779a$var$CustomerQuote = ({ quote: quote, name: name, imageLink: imageLink, imageAltText: imageAltText, benefits: benefits })=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1pfhpxbi"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.default), {
                src: imageLink,
                alt: imageAltText,
                className: (0, $esG4f.default)([
                    "_1bsbfp70"
                ])
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_1wyb1k8s _k48powjs _vwz4nqt0 _18s8zu5n _1cqs1k92 _srwzpxbi _18ghnl7k"
                ]),
                children: quote
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_1wyboqnp _k48p1nn1 _srwzpxbi _18ght94y _1byscs5v"
                ]),
                children: name
            }),
            benefits.map((benefit, index)=>/*#__PURE__*/ (0, $loA2J.jsx)($629e22e9cb1e779a$var$Benefit, (0, $7Knp0._)({}, benefit), `${benefit.title}-${index}`))
        ]
    });
const $629e22e9cb1e779a$var$CustomersSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const benefits = [
        {
            title: "67%",
            description: intl.formatMessage({
                id: "jira-service-management.customers.benefits.one",
                defaultMessage: "reduction on license costs from switching to Jira Service Management"
            })
        },
        {
            title: "200",
            description: intl.formatMessage({
                id: "jira-service-management.customers.benefits.two",
                defaultMessage: "hours saved a month with report automation"
            })
        },
        {
            title: "100%",
            description: intl.formatMessage({
                id: "jira-service-management.customers.benefits.three",
                defaultMessage: "SLA compliance"
            })
        }
    ];
    const backgroundProperties = {
        textColor: (0, $5ohHq.wacToken)("color.neutral.light0"),
        gradientDirection: "180",
        // eslint-disable-next-line local/ensure-wac-token-usage
        bgColor: "#6554c0",
        // eslint-disable-next-line local/ensure-wac-token-usage
        bgColor2: "#091e42"
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_zrm015vq _1i2c15vq _xsegzu5n _tedvbys6 _11k5vehm _p69cahaf _14ic1nn1 _1b8d1ejb _1m3011ph _1pwq1k8s _1fi2pxbi _13hnowjs _xo3hze3t"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.StyledBackground), (0, $6iHNw._)((0, $7Knp0._)({}, backgroundProperties), {
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: "jsm-customers-section",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                        alignItems: "top",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                            className: "jsm-customers-header",
                            headerText: intl.formatMessage({
                                id: "jira-service-management.customers.title",
                                defaultMessage: "Teams across the world rely on Jira Service Management"
                            }),
                            headerType: "h2",
                            isCentered: true,
                            ctaProps: {
                                primaryLinkProps: {
                                    text: intl.formatMessage({
                                        id: "jira-service-management.customers.primaryLink",
                                        defaultMessage: "Explore customer stories"
                                    }),
                                    href: (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/customers"),
                                    type: "primary",
                                    bgColor: "bgBlackBlue",
                                    dataEventProps: {
                                        "data-event-component": "link",
                                        "data-event-container": "customersSection",
                                        "data-event": "clicked",
                                        "data-product-key": "jiraServiceManagement"
                                    }
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                        layout: "7-5",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                image: {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/10l08o2vaka472w5s7t2xn36574bt4w0.svg",
                                    alt: intl.formatMessage({
                                        id: "jira-service-management.customers.imageAltText",
                                        defaultMessage: "Coworkers collaborating through a series of tasks: documents, charts, video calls, and a service desk"
                                    })
                                }
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)($629e22e9cb1e779a$var$CustomerQuote, {
                                imageLink: "https://dam-cdn.atl.orangelogic.com/AssetLink/7n5j0hqxeq3dci261cgq33ubb03k2886.svg",
                                imageAltText: "Engie",
                                quote: intl.formatMessage({
                                    id: "jira-service-management.customers.quote",
                                    defaultMessage: "\u201CWe needed to move towards a more customer-centric approach on ITSM. Jira Service Management helped us meet our target while saving time and money.\u201D"
                                }),
                                name: intl.formatMessage({
                                    id: "jira-service-management.customers.name",
                                    defaultMessage: "JOSE LUIS LIZ\xc1RRAGA CASTRO, IT SUPPORT ENGINEER, ENGIE MEXICO"
                                }),
                                benefits: benefits
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $fXpYT.PatternLogos), {
                        inlineLogos: $629e22e9cb1e779a$var$inlineLogosProp,
                        className: (0, $esG4f.default)([
                            "_19i01txw _rf0b1g80 _m02rze3t _1rx11h6o _9gf31h6o _18m21wug _o9ht1wug _pcm31wug _1ryj1wug _1xvjuuw1 _llptpxbi _2bc87vkz _1kxwyfq0 _1vw7glyw _1tgj1osq"
                        ])
                    })
                ]
            })
        }))
    });
};
var $629e22e9cb1e779a$export$2e2bcd8739ae039 = $629e22e9cb1e779a$var$CustomersSection;

});
parcelRegister("2pEWv", function(module, exports) {
$parcel$export(module.exports, "PatternLogos", function () { return (parcelRequire("fXpYT")).PatternLogos; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("fXpYT")).PatternLogos; });

var $fXpYT = parcelRequire("fXpYT");

});
parcelRegister("fXpYT", function(module, exports) {

$parcel$export(module.exports, "PatternLogos", function () { return $bc1b089dcaa2a94e$export$355432025e812df1; });
/* logos.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $1UUq1 = parcelRequire("1UUq1");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");

var $4XrxY = parcelRequire("4XrxY");
const $bc1b089dcaa2a94e$var$ConditionalLogo = (props)=>{
    if (props.link) return /*#__PURE__*/ (0, $loA2J.jsx)("a", {
        href: props.link,
        className: "logoblock logo-linked",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
            src: props.src,
            alt: props.alt,
            width: props.width,
            loading: "lazy"
        })
    });
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $loA2J.jsx)("img", {
        className: "logoblock logo-plain",
        src: props.src,
        alt: props.alt,
        width: props.width,
        loading: "lazy"
    }));
};
const $bc1b089dcaa2a94e$export$355432025e812df1 = ({ inlineLogos: inlineLogos, headerText: headerText, bodyText: bodyText, className: className, eyebrowText: eyebrowText, footNoteText: footNoteText, ctaProps: ctaProps, linkPosition: linkPosition = "top" })=>{
    if (inlineLogos.length < 4 || inlineLogos.length > 12) throw new Error("Minimum 4 logos required, maximum 12");
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_ca0qvbgk _u5f3idpf _n3tdvbgk _19bvidpf _y3gn1h6o _i6jxckbl _1lh7idpf _z3ncckbl _wpaiidpf _1kmxzwfg _1ggmidpf _1ykzzwfg _1maeidpf _1916ud5o _1nk71e5h _jti51ul9 _xjyridpf _2thuidpf _hbr3idpf",
            className
        ]),
        children: [
            headerText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                layout: "10",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                    isCentered: true,
                    headerText: headerText,
                    headerType: "h2",
                    eyebrowText: eyebrowText,
                    bodyText: bodyText,
                    ctaProps: linkPosition == "top" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? ctaProps : undefined
                })
            }) : null,
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: `logos-content lgth length-${inlineLogos.length}`,
                    children: inlineLogos.map((inlineLogo, index)=>/*#__PURE__*/ (0, $loA2J.jsx)($bc1b089dcaa2a94e$var$ConditionalLogo, {
                            alt: inlineLogo.alt,
                            src: inlineLogo.src,
                            link: inlineLogo.link,
                            width: inlineLogo.width
                        }, index))
                })
            }),
            footNoteText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: "footnote-text",
                    children: footNoteText
                })
            }) : null,
            linkPosition == "bottom" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), (0, $7Knp0._)({}, ctaProps.primaryLinkProps))
                })
            }) : null
        ]
    });
};

});



parcelRegister("h3BeN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a076bf1cdf31cef5$export$2e2bcd8739ae039; });
/* integration.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");

var $3FBn4 = parcelRequire("3FBn4");
const $a076bf1cdf31cef5$var$integrationStyles = null;
const $a076bf1cdf31cef5$var$IntegrationSection = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o _ca0q1ex1 _u5f3idpf _n3td1ex1 _19bvidpf _1itk1ivq _12vervsl _1odr1qro _1o601tuk _p17ahrdt _rb2g1f5y _13hpkf03 _b2g0uoqq _1gauzve2 _1mqf1464 _p2zzrvsl _cuqf3b0z _uhdy16xz _1vq0idpf _1rhy16xz _1awkidpf _1yiofeli _cxtnglwf _19fueva1 _1yduvhbr _11f616xz _cwd6idpf _zi3e16xz _gqjyidpf _16aj7vkz _1c657vkz _8r0m7vkz _1kl67vkz _1piv1ssb _1gq61osq _ut0s16xz _t4tu7vkz _lrqn16xz _15wz7vkz _1chyzwfg _164pidpf _1w7fbys6 _1cz4bys6 _12l4bys6 _qobrvehm _16stvehm _zixkvehm _1h7l1bqd _bbbvbfng _18rf11ph _1jjh1k8s _160adlk8 _1kqodlk8 _1lx8ahaf _110w1mpp _1f5y4jg8 _1525bs82 _1sof1tcg _1gwb1tcg _1xjt1j6v _jpd019bv _ghl3vwuj _1mzy1nn1 _1kblt94y _1a78cs5v _zaid7vkz _7aw719bv _ehlykb7n _1iefidpf _5jj4idpf _1qhkidpf _n3pyidpf _acl8idpf _11sln7od _kfwe1nn1"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: "integrations-content",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                eyebrowText: intl.formatMessage({
                    id: "JiraServiceManagementPageTemplate.integrationSection.eyebrow",
                    defaultMessage: "Integrations for every team"
                }),
                headerText: intl.formatMessage({
                    id: "JiraServiceManagementPageTemplate.integrationSection.header",
                    defaultMessage: "Supercharge service management with apps and integrations"
                }),
                bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "JiraServiceManagementPageTemplate.integrationSection.body",
                    defaultMessage: "Atlassian Marketplace offers over 1,000 trusted applications and integrations to ensure Jira Service Management can be customized to fit your use case.",
                    values: (0, $3FBn4.DEFAULT_VALUES)
                }),
                headerType: "h2",
                isCentered: true,
                orientation: "vertical",
                ctaProps: {
                    primaryLinkProps: {
                        text: intl.formatMessage({
                            id: "JiraServiceManagementPageTemplate.integrationSection.cta",
                            defaultMessage: "Explore the Marketplace"
                        }),
                        href: "https://marketplace.atlassian.com/",
                        type: "primary",
                        dataEventProps: {
                            "data-product-key": "jiraServiceDesk",
                            "data-event-component": "linkButton",
                            "data-event-container": "integrationsSection",
                            "data-event": "clicked"
                        }
                    }
                }
            })
        })
    });
};
var $a076bf1cdf31cef5$export$2e2bcd8739ae039 = $a076bf1cdf31cef5$var$IntegrationSection;

});

parcelRegister("jcaSM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $010f7199a50fafba$export$2e2bcd8739ae039; });
/* scaling.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");
parcelRequire("37w71");
var $36iSx = parcelRequire("36iSx");
const $010f7199a50fafba$var$jsmScalingSectionStyle = null;
const $010f7199a50fafba$var$ScalingSection = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1ouu15vq _dbqh15vq _1oz08vuz _1w3uidpf _68j78vuz _oiltidpf _159zvejh _17aeidpf _eeazidpf _j6onidpf _14qkidpf _sk25d8mv _140edlk8 _1w38bfng _18so1k92 _1goq19ii _1qaibys6 _194zbys6 _43movehm _gnd0vehm _kyhscd5j _1r93cd5j _ch5hidpf _x6nlv2br _htkx8vuz _6ctlidpf _14xn8vuz _1jovidpf _i0or1k8s _1vs28vuz _1lfkidpf _74pf8vuz _1chjidpf _rkkeahaf _hocbdlk8 _15wridpf _14ps16xz _1592idpf _dc3e16xz _x0pyidpf _1w0yahaf _la6xd8mv _1pcn1tcg _1ah3idpf _1a5t7vkz _1b6xidpf _j0ch7vkz _1rb1ka7h _pnr8idpf _g12bidpf _26fkidpf _1dhjidpf _1m5dka7h"
        ]),
        style: {
            "--_nl5by5": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue1000")),
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $36iSx.SimpleImageTextSide), {
            headerText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.scalingHeader",
                defaultMessage: "Jira Service Management scales with you"
            }),
            bodyText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.scalingBody",
                defaultMessage: "Whether you\u2019re part of a small team or a big enterprise,  we have a plan for you. Choose only the features you need."
            }),
            ctaProps: {
                buttonProps: {
                    text: intl.formatMessage({
                        id: "JiraServiceManagementPageTemplate.scalingCTA",
                        defaultMessage: "Discover plans"
                    }),
                    url: (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/pricing"),
                    color: "yellow",
                    className: "jsm-scaling-section-cta",
                    dataEventProps: {
                        "data-event-component": "linkButton",
                        "data-event-container": "linkButton",
                        "data-event": "clicked",
                        "data-label-english": "Discover plans",
                        "data-product-key": "jiraServiceManagement",
                        "data-label": intl.formatMessage({
                            id: "JiraServiceManagementPageTemplate.scalingCTA",
                            defaultMessage: "Discover plans"
                        })
                    }
                }
            },
            backgroundColor: (0, $5ohHq.wacToken)("color.extended.blue1000"),
            margin: "0 0",
            className: "jsm-scaling-section",
            imageLink: "https://wac-cdn.atlassian.com/dam/jcr:56da3ff6-b5f2-4b64-815f-5e51867f59de/jsm-features.svg?cdnVersion=1286",
            imageAltText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.awardImageAltText",
                defaultMessage: "Jira Service management features as listed: SLA Management, Chat, Self Service, Queues, Automation, Assets, Atlassian Analytics, Deployment setting, incident investigation, and dynamic forms"
            })
        })
    });
};
var $010f7199a50fafba$export$2e2bcd8739ae039 = $010f7199a50fafba$var$ScalingSection;

});

parcelRegister("57Jg1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e977acddc42b1a7d$export$2e2bcd8739ae039; });
/* tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("6dRh5");
var $dq9mP = parcelRequire("dq9mP");

var $9F3se = parcelRequire("9F3se");
const $e977acddc42b1a7d$var$tabsWrapper = null;
const $e977acddc42b1a7d$var$TabsSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const accelerateDevAndOpsLocalizedMedia = {
        videoProps: {
            videoLink: (0, $9F3se.devopsTabSectionVideo)
        }
    };
    const empowerAllServiceTeamsLocalizedMedia = {
        videoProps: {
            videoLink: (0, $9F3se.empowerAllTeamsTabSectionVideo)
        }
    };
    const deliverValueFastLocalizedMedia = {
        videoProps: {
            videoLink: (0, $9F3se.deliverValueFastTabSectionVideo)
        }
    };
    const tabs = [
        {
            textLabel: "Accelerate Dev and Ops",
            id: "tab-accelerate-dev-and-ops",
            headerText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.tabsHeader.plan",
                defaultMessage: "Accelerate Dev and Ops"
            }),
            iconName: "accelerator",
            bodyText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.tabsBody.plan",
                defaultMessage: "Connect Dev and Ops teams on a single AI-powered platform to supercharge collaboration across changes, incidents, and requests - all while managing risk."
            }),
            display: accelerateDevAndOpsLocalizedMedia
        },
        {
            textLabel: "Empower all service teams",
            id: "tab-empower-all-service-teams",
            headerText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.tabsHeader.track",
                defaultMessage: "Empower all service teams"
            }),
            iconName: "team",
            bodyText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.tabsBody.track",
                defaultMessage: "Service management isn\u2019t just for IT. Make it easy for teams across the business - from HR to Legal to Facilities - to streamline requests, centralize knowledge, and work the way they want."
            }),
            display: empowerAllServiceTeamsLocalizedMedia
        },
        {
            textLabel: "Deliver value fast",
            id: "tab-deliver-value-fast",
            headerText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.tabsHeader.release",
                defaultMessage: "Deliver value fast"
            }),
            iconName: "lightning",
            bodyText: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.tabsBody.release",
                defaultMessage: "Tune Jira Service Management to your unique requirements - without the complexity of traditional ITSM solutions. Get started fast and and scale as you go, with features like customizable templates, dynamic forms, and AI-powered project configuration."
            }),
            display: deliverValueFastLocalizedMedia
        }
    ];
    const backgroundProperties = {
        textColor: (0, $5ohHq.wacToken)("color.neutral.light0"),
        gradientDirection: "180",
        bgColor: (0, $5ohHq.wacToken)("color.extended.blue800"),
        bgColor2: (0, $5ohHq.wacToken)("color.extended.purple800")
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1ieays9h _182oidpf _vsxzzwfg _1wgpidpf _gng410mc _9wq2ftgi _1khc1y44 _1jsl1ul9 _10xw1y44 _s8o21ul9 _1mxnokh7 _j16mp9y3 _1wiaowjs _19ait94y _12banqa1 _mcgut94y _ad699c0g _k0231r31 _5wi719ly _ivxy1o36 _15w11k92 _fkt91j28 _63i3idpf _pfqyidpf _en9midpf _wuruidpf _1wbo1mjv _f05r14gx _1oak1osq _h3hm1wug _4qao1wug _1itv1wug _sgdj1wug _dy9hglyw _flua1j6v _x7pi1ylp _he8uidpf _dhofo7ao _11gridpf _h8hfo7ao _hsw71osq _6hns1r31 _1q7419ly _2b7h1o36 _3u8dzwfg _tfcxidpf _112pzwfg _15pjidpf _1jxdv2br _llue1txw _runt1sxn _oeu5idpf _yxrcidpf _y4oridpf _1e45idpf _xpjw19bv _1dv2r5sb _dxdq1msg _158cglyw _vls211p5 _31en1r0c _11051bwz _vat81j6v _1z8av2br _9ik0nl7k _1dnnftgi _pzah1cy2 _rmms1y44 _1rp7utpp _1btk1nn1 _1wkv18xf _1o251tcg _16o51vh9 _1wl62ec4 _120aidpf _1699idpf _jszridpf _18s9idpf _1i23cd5j _41r41ssb _if4xor1b _ylm2or1b _19fp1txw _d69b1h6o _1bcz1h6o _111217la _17ar1tcg _1u331tcg _11rrahaf _cpc0idpf _1qscidpf _1lvridpf _10lgidpf _1xp91nn1 _16ob1k8s _klrhidpf _1fwiidpf _1py0idpf _1dpdidpf _ndta1pz4 _1yr21j6v _1x6p19ii _vn3rbys6 _1i8cvehm _9zi31k92 _s4ue1k92"
        ]),
        style: {
            "--_sse8eq": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark900")),
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.StyledBackground), (0, $6iHNw._)((0, $7Knp0._)({}, backgroundProperties), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dq9mP.TabsQuote), {
                id: "tabs-section",
                label: "Tabs",
                headerText: intl.formatMessage({
                    id: "JiraServiceManagementPageTemplate.tabsHeader",
                    defaultMessage: "High-velocity service management"
                }),
                bodyText: "",
                tabs: tabs,
                colors: {
                    defaultBG: (0, $5ohHq.wacToken)("color.neutral.light0"),
                    defaultText: (0, $5ohHq.wacToken)("color.neutral.light700"),
                    activeBG: (0, $5ohHq.wacToken)("color.extended.blue100"),
                    activeText: (0, $5ohHq.wacToken)("color.extended.blue1000"),
                    hoverBG: (0, $5ohHq.wacToken)("color.neutral.light0"),
                    hoverText: (0, $5ohHq.wacToken)("color.neutral.light700")
                },
                className: "jira-service-management-tabs"
            })
        }))
    });
};
var $e977acddc42b1a7d$export$2e2bcd8739ae039 = $e977acddc42b1a7d$var$TabsSection;

});
parcelRegister("9F3se", function(module, exports) {

$parcel$export(module.exports, "devopsTabSectionVideo", function () { return $56da178ed9f9074d$export$53481b52861292a7; });
$parcel$export(module.exports, "empowerAllTeamsTabSectionVideo", function () { return $56da178ed9f9074d$export$3e38b0232a5e801; });
$parcel$export(module.exports, "deliverValueFastTabSectionVideo", function () { return $56da178ed9f9074d$export$bbcf3da58a2469ed; });
// no localized image for hu, it, ko, nl, pl, zh, de, es, fr, ja, br, ru
const $56da178ed9f9074d$var$heroSectionImageMap = {
    en: "https://wac-cdn.atlassian.com/dam/jcr:de1966b5-df25-4e7c-8477-ebd8456930c5/jsm-hero-portal.png?cdnVersion=1276"
};
const $56da178ed9f9074d$export$55b4ecbb6fe6298e = (locale)=>{
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return $56da178ed9f9074d$var$heroSectionImageMap[locale] || $56da178ed9f9074d$var$heroSectionImageMap["en"];
};
const $56da178ed9f9074d$export$53481b52861292a7 = "https://dam-cdn.atl.orangelogic.com/AssetLink/8b6d8j2j8bot6l8753taue84xgmdilnt.mp4";
const $56da178ed9f9074d$export$3e38b0232a5e801 = "https://dam-cdn.atl.orangelogic.com/AssetLink/qk55334yq4gd01k1581083dshd3p3d27.mp4";
const $56da178ed9f9074d$export$bbcf3da58a2469ed = "https://dam-cdn.atl.orangelogic.com/AssetLink/0b3qjw6u11w3520ch250j22130hdtc6e.mp4";

});


parcelRegister("4QWpU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a68c22b264f35d83$export$2e2bcd8739ae039; });
/* tiles.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");

var $4XrxY = parcelRequire("4XrxY");

var $jChL3 = parcelRequire("jChL3");

var $jzN8u = parcelRequire("jzN8u");

var $1PkYS = parcelRequire("1PkYS");

var $kUFbA = parcelRequire("kUFbA");

var $9iiSH = parcelRequire("9iiSH");

var $bnvPE = parcelRequire("bnvPE");

var $gCrEB = parcelRequire("gCrEB");

var $2u0KA = parcelRequire("2u0KA");

var $hDRjU = parcelRequire("hDRjU");

var $lY0C7 = parcelRequire("lY0C7");
const $a68c22b264f35d83$var$tilesStyles = null;
const $a68c22b264f35d83$var$templateCardContainer = null;
const $a68c22b264f35d83$var$headerRow = null;
const $a68c22b264f35d83$var$getFeaturedTemplates = (intl, learnMoreLabel)=>[
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9iiSH.CogsIcon), {}),
            title: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.itsm.title",
                defaultMessage: "ITSM"
            }),
            name: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.itsm.name",
                defaultMessage: "IT service management"
            }),
            description: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.itsm.description",
                defaultMessage: "Manage requests, incidents, and changes to deliver great service, fast."
            }),
            try: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.itsm.try",
                defaultMessage: "Try the ITSM template"
            }),
            templateId: "com.atlassian.servicedesk:simplified-it-service-management-basic",
            learnMoreLink: "/software/jira/templates/it-service-management",
            learnMoreLabel: learnMoreLabel,
            // Note: Existing tech debt, should be fixed
            // eslint-disable-next-line local/ensure-wac-token-usage
            barColor: "#998dd9"
        },
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hDRjU.SmileyIcon), {}),
            title: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.customer-service.title",
                defaultMessage: "Customer service"
            }),
            name: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.customer-service.name",
                defaultMessage: "Customer service management"
            }),
            description: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.customer-service.description",
                defaultMessage: "Deliver great service experiences to external customers, fast."
            }),
            try: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.customer-service.try",
                defaultMessage: "Try the customer service template"
            }),
            templateId: "com.atlassian.servicedesk:next-gen-external-service-desk",
            learnMoreLink: "/software/jira/templates/customer-service-management",
            learnMoreLabel: learnMoreLabel,
            // Note: Existing tech debt, should be fixed
            // eslint-disable-next-line local/ensure-wac-token-usage
            barColor: "#4c9aff"
        },
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2u0KA.PeopleIcon), {}),
            title: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.hr.title",
                defaultMessage: "Human resources"
            }),
            name: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.hr.name",
                defaultMessage: "HR service management"
            }),
            description: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.hr.description",
                defaultMessage: "Manage onboarding and offboarding and respond to staff requests."
            }),
            try: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.hr.try",
                defaultMessage: "Try the HR template"
            }),
            templateId: "com.atlassian.servicedesk:simplified-hr-service-desk",
            learnMoreLink: "/software/jira/templates/hr-service-management",
            learnMoreLabel: learnMoreLabel,
            // Note: Existing tech debt, should be fixed
            // eslint-disable-next-line local/ensure-wac-token-usage
            barColor: "#0065ff"
        }
    ];
const $a68c22b264f35d83$var$getMoreTemplates = (intl, learnMoreLabel)=>[
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gCrEB.LightIcon), {}),
            title: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.facilities.title",
                defaultMessage: "Facilities"
            }),
            name: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.facilities.name",
                defaultMessage: "Facilities service management"
            }),
            description: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.facilities.description",
                defaultMessage: "Manage requests for maintenance, moving, and event planning."
            }),
            try: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.facilities.try",
                defaultMessage: "Try the facilities template"
            }),
            templateId: "com.atlassian.servicedesk:simplified-facilities-service-desk",
            learnMoreLink: "/software/jira/templates/facilities-service-management",
            learnMoreLabel: learnMoreLabel,
            // Note: Existing tech debt, should be fixed
            // eslint-disable-next-line local/ensure-wac-token-usage
            barColor: "#6554c0"
        },
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1PkYS.BriefCaseIcon), {}),
            title: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.legal.title",
                defaultMessage: "Legal"
            }),
            name: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.legal.name",
                defaultMessage: "Legal service management"
            }),
            description: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.legal.description",
                defaultMessage: "Create, manage, and track your contracts."
            }),
            try: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.legal.try",
                defaultMessage: "Try the legal template"
            }),
            templateId: "com.atlassian.servicedesk:simplified-legal-service-desk",
            learnMoreLink: "/software/jira/templates/legal-service-management",
            learnMoreLabel: learnMoreLabel,
            // Note: Existing tech debt, should be fixed
            // eslint-disable-next-line local/ensure-wac-token-usage
            barColor: "#8777d9"
        },
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bnvPE.DollarIcon), {}),
            title: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.finance.title",
                defaultMessage: "Finance"
            }),
            name: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.finance.name",
                defaultMessage: "Finance service management"
            }),
            description: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.finance.description",
                defaultMessage: "Manage budget, spend, and other finance requests."
            }),
            try: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.finance.try",
                defaultMessage: "Try the finance template"
            }),
            templateId: "com.atlassian.servicedesk:simplified-finance-service-desk",
            learnMoreLink: "/software/jira/templates/finance-service-management",
            learnMoreLabel: learnMoreLabel,
            // Note: Existing tech debt, should be fixed
            // eslint-disable-next-line local/ensure-wac-token-usage
            barColor: "#0065ff"
        },
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kUFbA.BullHornIcon), {}),
            title: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.marketing.title",
                defaultMessage: "Marketing"
            }),
            name: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.marketing.name",
                defaultMessage: "Marketing service management"
            }),
            description: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.marketing.description",
                defaultMessage: "Manage and track all your marketing requests."
            }),
            try: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.marketing.try",
                defaultMessage: "Try the marketing template"
            }),
            templateId: "com.atlassian.servicedesk:simplified-marketing-service-desk",
            learnMoreLink: "/software/jira/templates/marketing-service-management",
            learnMoreLabel: learnMoreLabel,
            // Note: Existing tech debt, should be fixed
            // eslint-disable-next-line local/ensure-wac-token-usage
            barColor: "#4c9aff"
        },
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lY0C7.StarIcon), {}),
            title: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.design.title",
                defaultMessage: "Design"
            }),
            name: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.design.name",
                defaultMessage: "Design service management"
            }),
            description: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.design.description",
                defaultMessage: "Easily manage and track all kinds of design requests."
            }),
            try: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.design.try",
                defaultMessage: "Try the design template"
            }),
            templateId: "com.atlassian.servicedesk:simplified-design-service-desk",
            learnMoreLink: "/software/jira/templates/design-service-management",
            learnMoreLabel: learnMoreLabel,
            // Note: Existing tech debt, should be fixed
            // eslint-disable-next-line local/ensure-wac-token-usage
            barColor: "#6554c0"
        },
        {
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jzN8u.BagIcon), {}),
            title: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.sales.title",
                defaultMessage: "Sales"
            }),
            name: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.sales.name",
                defaultMessage: "Sales service management"
            }),
            description: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.sales.description",
                defaultMessage: "Manage, track, and report on sales requests."
            }),
            try: intl.formatMessage({
                id: "JiraServiceManagementPageTemplate.templates.sales.try",
                defaultMessage: "Try the sales template"
            }),
            templateId: "com.atlassian.servicedesk:simplified-sales-service-desk",
            learnMoreLink: "/software/jira/templates/sales-service-management",
            learnMoreLabel: learnMoreLabel,
            // Note: Existing tech debt, should be fixed
            // eslint-disable-next-line local/ensure-wac-token-usage
            barColor: "#4c9aff"
        }
    ];
const $a68c22b264f35d83$var$TilesSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const [isExpanded, setIsExpanded] = (0, $iSvIT.useState)(false);
    const toggleShowMore = ()=>{
        setIsExpanded(!isExpanded);
    };
    const showMore = intl.formatMessage({
        id: "JiraServiceManagementPageTemplate.templatesSection.showMore",
        defaultMessage: "Show more"
    });
    const showLess = intl.formatMessage({
        id: "JiraServiceManagementPageTemplate.templatesSection.showLess",
        defaultMessage: "Show less"
    });
    const learnMore = intl.formatMessage({
        id: "JiraServiceManagementPageTemplate.templatesSection.learnMore",
        defaultMessage: "Learn more"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1yag1a1f _1itkt5k3 _ouxl1nty _12vemgnk _1lrw174u _6ssjn9zw _tlqvxncg _o4gw18qk _5kkl1k8s _lgdadlk8 _8mutze3t _199z1wug _jy1d1wug _s3ns1wug _3ojx1wug _koa4bys6 _ohp0bys6 _ula8bys6 _n202vehm _1p4dvehm _17e6vehm _x0jlahaf _k9hsqgjj _py051bqd _16h91tcg _1je8bfng _1huepxbi _6o5svwuj _1u7l1tcg _1qrt4jg8 _1oyn1k92 _mn5y19ii _1wf0yvqg _1o0mze3t _146c1osq _2i3n1k8s _drrhdlk8 _1lzoze3t _4rxo1jx0 _xoz6idpf _1eqoidpf _kebgidpf _1sxvidpf _126h1y44 _esg819bv _7atg1y44 _an1019bv _1s081nn1 _12y1n7od _vx12glyw _nr8zglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _4cvr1h6o _p12f1fra _19pk1wug _2hwx1wug _otyr1wug _18u01wug _6ssj1cfz"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                        className: "templates-header-content",
                        headerText: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            id: "templates-section-header",
                            children: intl.formatMessage({
                                id: "JiraServiceManagementPageTemplate.templatesSection.header",
                                defaultMessage: "Get started quickly with templates"
                            })
                        }),
                        bodyText: intl.formatMessage({
                            id: "JiraServiceManagementPageTemplate.templatesSection.body",
                            defaultMessage: "With pre-configured request types, workflows and other out-of-the-box capabilities, templates make it easy for any team to get started quickly with a service experience that fits the way they like to work."
                        }),
                        headerType: "h2",
                        isCentered: true,
                        orientation: "vertical"
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c11p5 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1fra _zulpxy5q _1j8bz7l7 _19d7i47z"
                    ]),
                    children: $a68c22b264f35d83$var$getFeaturedTemplates(intl, learnMore).map((template)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $jChL3.default), (0, $7Knp0._)({}, template), template.title))
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                    className: "templates-show-more-content",
                    headerText: "",
                    bodyText: "",
                    headerType: "h2",
                    isCentered: true,
                    orientation: "vertical",
                    ctaProps: {
                        primaryLinkProps: {
                            text: isExpanded ? showLess : showMore,
                            href: "",
                            type: "anchor",
                            id: "show-more-templates-link",
                            ariaLabelledby: "show-more-templates-link templates-section-header",
                            onClick (e) {
                                e.preventDefault();
                                toggleShowMore();
                            }
                        }
                    }
                })
            }),
            isExpanded && /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c11p5 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1fra _zulpxy5q _1j8bz7l7 _19d7i47z"
                    ]),
                    children: $a68c22b264f35d83$var$getMoreTemplates(intl, learnMore).map((template)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $jChL3.default), (0, $7Knp0._)({}, template), template.title))
                })
            })
        ]
    });
};
var $a68c22b264f35d83$export$2e2bcd8739ae039 = $a68c22b264f35d83$var$TilesSection;

});
parcelRegister("jChL3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5929061eb58f7ee6$export$2e2bcd8739ae039; });
/* template-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $i8kxh = parcelRequire("i8kxh");

var $gkV6l = parcelRequire("gkV6l");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");
const $5929061eb58f7ee6$var$cardStyles = null;
const $5929061eb58f7ee6$var$cardIconStyles = null;
const $5929061eb58f7ee6$var$cardHeading3Styles = null;
const $5929061eb58f7ee6$var$cardParagraphStyles = null;
const $5929061eb58f7ee6$var$cardAnchorStyles = null;
const $5929061eb58f7ee6$var$TemplateCard = (props)=>{
    const { icon: icon, title: title, name: name, description: description, try: tryText, templateId: templateId, learnMoreLink: learnMoreLink, learnMoreLabel: learnMoreLabel, barColor: barColor } = props;
    const { openModalForTemplate: openModalForTemplate } = (0, $gkV6l.useSiteSelectorContext)();
    const titleId = (0, $iSvIT.useId)();
    const learnMoreLinkId = (0, $iSvIT.useId)();
    const handleClicked = (event)=>{
        event.preventDefault();
        openModalForTemplate({
            templateId: templateId,
            templateName: name,
            productKey: (0, $i8kxh.ProductKeys).JIRA_SERVICE_DESK
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_bfhkcd5j _2rko1l7b _16qso5yx _7mya19bv _1sw7nqa1 _6rthu2gc _ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _y3gn1e5h _1bsb1osq"
        ]),
        style: {
            borderTopColor: barColor || "transparent",
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                style: {
                    backgroundColor: barColor || "transparent"
                },
                className: (0, $esG4f.default)([
                    "_2rko1ssb _1yt4pxbi _1bsbvbgk _4t3ivbgk _6rthpxbi"
                ]),
                children: icon
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                id: titleId,
                className: (0, $esG4f.default)([
                    "_syaz1bqd _1e0c1ule _1wyb1k8s _k48pbfng _vwz4xy5q _85i5pxbi _18s8ze3t _so7d1k92"
                ]),
                children: title
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_1wybpxbi _k48p1nn1 _vwz4v47k _6rth1ejb"
                ]),
                children: description
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                href: "",
                onClick: handleClicked,
                text: tryText,
                type: "external",
                className: (0, $esG4f.default)([
                    "_1d61glyw _rfqo1r31 _1bgk8stv _1t0pnqa1 _18smglyw _9m7f1r31 _w7sw8stv _15a9nqa1 _1wl11tcg",
                    "try-link"
                ])
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                id: learnMoreLinkId,
                href: (0, $3FBn4.useLocalizedHref)(learnMoreLink),
                text: learnMoreLabel,
                type: "primary",
                ariaLabelledby: `${titleId} ${learnMoreLinkId}`,
                className: (0, $esG4f.default)([
                    "_1d61glyw _rfqo1r31 _1bgk8stv _1t0pnqa1 _18smglyw _9m7f1r31 _w7sw8stv _15a9nqa1 _1wl11tcg"
                ])
            })
        ]
    });
};
var $5929061eb58f7ee6$export$2e2bcd8739ae039 = $5929061eb58f7ee6$var$TemplateCard;

});

parcelRegister("jzN8u", function(module, exports) {

$parcel$export(module.exports, "BagIcon", function () { return $d6c6c8cb527b2fbd$export$814ad7f304620551; });
/* eslint-disable react/self-closing-comp */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $1ui6x = parcelRequire("1ui6x");
const $d6c6c8cb527b2fbd$export$814ad7f304620551 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1ui6x.SvgContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMin meet",
            viewBox: "0 0 36 36",
            "aria-hidden": "true",
            children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#ffffff",
                fillRule: "evenodd",
                d: "M28.31,36a4.19,4.19,0,0,0,4.19-4.19V2.1A2.09,2.09,0,0,0,30.41,0H5.59A2.09,2.09,0,0,0,3.5,2.1V31.81A4.19,4.19,0,0,0,7.69,36ZM11,6.92A1.58,1.58,0,0,1,14.16,7V15.3a3.84,3.84,0,0,0,7.68-.1V6.92A1.57,1.57,0,0,1,25,7v8.33a7,7,0,0,1-14-.12V6.92Z"
            })
        })
    });
};

});
parcelRegister("1ui6x", function(module, exports) {

$parcel$export(module.exports, "SvgContainer", function () { return $246ba33ae1756725$export$483e7437cf07e16f; });
/* svg-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $246ba33ae1756725$export$483e7437cf07e16f = (props)=>{
    const styles = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1ii71ule _1i4xidpf _w8l51osq _4x2014no"
        ]),
        children: props.children
    });
};

});


parcelRegister("1PkYS", function(module, exports) {

$parcel$export(module.exports, "BriefCaseIcon", function () { return $77b53d826cd6ac42$export$8219767dc2711cb7; });
/* eslint-disable react/self-closing-comp */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $1ui6x = parcelRequire("1ui6x");
const $77b53d826cd6ac42$export$8219767dc2711cb7 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1ui6x.SvgContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMin meet",
            viewBox: "0 0 36 36",
            "aria-hidden": "true",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M12.06,6.06a6.06,6.06,0,1,1,12.11,0v2h-3v-2A3,3,0,0,0,18.2,3h-.09a3,3,0,0,0-3,3v2h-3ZM19.8,17.5H35.27V32a4,4,0,0,1-4,4H4.66a4,4,0,0,1-4-4V17.5H16.77v2.18a1.52,1.52,0,1,0,3,0Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: 0.5,
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M35.27,12.11a4,4,0,0,0-4-4H4.66a4,4,0,0,0-4,4V17.5H16.77V14.63a1.52,1.52,0,0,1,3,0V17.5H35.27Z"
                })
            ]
        })
    });
};

});

parcelRegister("kUFbA", function(module, exports) {

$parcel$export(module.exports, "BullHornIcon", function () { return $782cc9ea2315769a$export$ed69ce0c0a77942b; });
/* eslint-disable react/self-closing-comp */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $1ui6x = parcelRequire("1ui6x");
const $782cc9ea2315769a$export$ed69ce0c0a77942b = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1ui6x.SvgContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMin meet",
            viewBox: "0 0 36 36",
            "aria-hidden": "true",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: 0.5,
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M22.35,29.44a3.61,3.61,0,0,1-7.22,0V25.6l-2.94-.86c0,.09,0,.18,0,.27v4.43a6.56,6.56,0,0,0,13.12,0v-.88l-2.95-.86Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: 0.5,
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M1.84,12.22l1.48-.58v-.15a1.48,1.48,0,0,0-2.95.07v10.9a1.48,1.48,0,0,0,2.95-.07v-.23l-1.48-.43Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M33,.14,3.32,11.64l-1.48.58v9.51l1.48.43,8.87,2.58,2.94.86,7.22,2.1,2.95.86,7.81,2.28A2,2,0,0,0,35.63,29V2A2,2,0,0,0,33,.14Z"
                })
            ]
        })
    });
};

});

parcelRegister("9iiSH", function(module, exports) {

$parcel$export(module.exports, "CogsIcon", function () { return $590076bd21792b42$export$a5f9db729434ffda; });
/* eslint-disable react/self-closing-comp */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $1ui6x = parcelRequire("1ui6x");
const $590076bd21792b42$export$a5f9db729434ffda = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1ui6x.SvgContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMin meet",
            viewBox: "0 0 36 36",
            "aria-hidden": "true",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M14.36,13.27a1.49,1.49,0,0,0-1.49-1.49H11.32a1.49,1.49,0,0,0-1.49,1.49v1.82a8.76,8.76,0,0,0-2.34,1L6.2,14.78a1.48,1.48,0,0,0-2.11,0L3,15.87A1.48,1.48,0,0,0,3,18l1.28,1.29a8.76,8.76,0,0,0-1,2.34H1.49A1.49,1.49,0,0,0,0,23.1v1.55a1.49,1.49,0,0,0,1.49,1.49H3.31a8.63,8.63,0,0,0,1,2.34L3,29.77a1.48,1.48,0,0,0,0,2.11L4.09,33A1.5,1.5,0,0,0,6.2,33l1.29-1.29a8.76,8.76,0,0,0,2.34,1v1.82A1.49,1.49,0,0,0,11.32,36h1.55a1.49,1.49,0,0,0,1.49-1.49V32.66a8.63,8.63,0,0,0,2.34-1L18,33a1.5,1.5,0,0,0,2.11,0l1.1-1.1a1.5,1.5,0,0,0,0-2.11l-1.29-1.29a8.63,8.63,0,0,0,1-2.34H22.7a1.49,1.49,0,0,0,1.49-1.49V23.1a1.49,1.49,0,0,0-1.49-1.49H20.88a8.76,8.76,0,0,0-1-2.34L21.2,18a1.5,1.5,0,0,0,0-2.11l-1.1-1.09a1.48,1.48,0,0,0-2.11,0L16.7,16.06a8.63,8.63,0,0,0-2.34-1ZM12.1,19.89a4,4,0,1,1-4,4A4,4,0,0,1,12.1,19.89Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: 0.5,
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M31.74,1.88A1.09,1.09,0,0,0,31.1.49L30.05.1a1.08,1.08,0,0,0-1.39.62L28.2,2A6.22,6.22,0,0,0,26.37,2L25.82.81A1.09,1.09,0,0,0,24.39.27l-1,.46a1.08,1.08,0,0,0-.53,1.43l.55,1.19a6.87,6.87,0,0,0-1.25,1.33l-1.23-.46a1.08,1.08,0,0,0-1.39.63l-.39,1a1.08,1.08,0,0,0,.64,1.39L21,7.74a6.57,6.57,0,0,0,.07,1.83l-1.19.54a1.08,1.08,0,0,0-.54,1.43l.47,1a1.08,1.08,0,0,0,1.44.54l1.19-.54a6.42,6.42,0,0,0,1.34,1.26L23.33,15A1.08,1.08,0,0,0,24,16.42l1,.39a1.07,1.07,0,0,0,1.39-.62L26.86,15a6.57,6.57,0,0,0,1.83-.05l.55,1.19a1.09,1.09,0,0,0,1.43.54l1-.46a1.07,1.07,0,0,0,.53-1.43l-.54-1.19a6.28,6.28,0,0,0,1.24-1.33l1.23.46a1.07,1.07,0,0,0,1.39-.63l.39-1a1.08,1.08,0,0,0-.64-1.39l-1.23-.46A6.22,6.22,0,0,0,34,7.34l1.2-.54a1.06,1.06,0,0,0,.53-1.42l-.47-1a1.09,1.09,0,0,0-1.43-.54l-1.2.54a6.38,6.38,0,0,0-1.34-1.25ZM27.8,5.15a3.37,3.37,0,0,1,3.07,3.61,3.3,3.3,0,0,1-3.61,3,3.37,3.37,0,0,1-3.07-3.61A3.3,3.3,0,0,1,27.8,5.15Z"
                })
            ]
        })
    });
};

});

parcelRegister("bnvPE", function(module, exports) {

$parcel$export(module.exports, "DollarIcon", function () { return $6091cbd8cf820a17$export$e69f65903d0e6829; });
/* eslint-disable react/self-closing-comp */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $1ui6x = parcelRequire("1ui6x");
const $6091cbd8cf820a17$export$e69f65903d0e6829 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1ui6x.SvgContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMin meet",
            viewBox: "0 0 36 36",
            "aria-hidden": "true",
            children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#ffffff",
                fillRule: "evenodd",
                d: "M23,12.65a1.23,1.23,0,0,0,2.45-.06V11.15a7.45,7.45,0,0,0-6.22-7.22V1.17a1.23,1.23,0,0,0-2.46.06v2.7a7.43,7.43,0,0,0-6.22,7.34v.63A7.44,7.44,0,0,0,18,19.23h.09a5,5,0,0,1,4.91,5v.59a5,5,0,0,1-10-.09V23.35a1.23,1.23,0,0,0-2.45.06v1.44a7.45,7.45,0,0,0,6.22,7.22v2.76a1.23,1.23,0,0,0,2.46-.06v-2.7a7.43,7.43,0,0,0,6.22-7.34V24.1A7.44,7.44,0,0,0,18,16.77h-.09a5,5,0,0,1-4.91-5v-.59a5,5,0,0,1,10,.09v1.38Z"
            })
        })
    });
};

});

parcelRegister("gCrEB", function(module, exports) {

$parcel$export(module.exports, "LightIcon", function () { return $89810a220c6c05e6$export$82acdd66a4e4bf90; });
/* eslint-disable react/self-closing-comp */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $1ui6x = parcelRequire("1ui6x");
const $89810a220c6c05e6$export$82acdd66a4e4bf90 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1ui6x.SvgContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMin meet",
            viewBox: "0 0 36 36",
            "aria-hidden": "true",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: 0.5,
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M14.17,32.08A3.93,3.93,0,0,0,18.09,36h.12a3.93,3.93,0,0,0,3.93-3.92V32h-8Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: 0.5,
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M19.7,11.14V1.63a1.7,1.7,0,0,0-3.39.07v9.55a4.78,4.78,0,0,1,3.4-.11Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M23.05,18.82v-3a4.88,4.88,0,0,0-3.35-4.65,4.78,4.78,0,0,0-3.4.11,4.89,4.89,0,0,0-3.05,4.54v3A13.46,13.46,0,0,0,2.23,32l0,0h31.5l0,0A13.45,13.45,0,0,0,23.05,18.82Zm4.29,9.68A1.39,1.39,0,0,1,26,27.18v-.06a2.44,2.44,0,0,0-2.37-2.45h-.08a1.38,1.38,0,1,1,0-2.76,5.21,5.21,0,0,1,5.21,5.21A1.38,1.38,0,0,1,27.34,28.5Z"
                })
            ]
        })
    });
};

});

parcelRegister("2u0KA", function(module, exports) {

$parcel$export(module.exports, "PeopleIcon", function () { return $e8bf63e7ff55672a$export$a0096b57009ecc7c; });
/* eslint-disable react/self-closing-comp */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $1ui6x = parcelRequire("1ui6x");
const $e8bf63e7ff55672a$export$a0096b57009ecc7c = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1ui6x.SvgContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMin meet",
            viewBox: "0 0 36 36",
            "aria-hidden": "true",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: 0.5,
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M10.84,28.07V24.36a5.57,5.57,0,0,1,1.74-4.05A5.57,5.57,0,0,0,8.7,18.75H5.61A5.61,5.61,0,0,0,0,24.36v3.71a1,1,0,0,0,1,1H11.82A1,1,0,0,1,10.84,28.07Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: 0.5,
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M7.16,17.47A4.12,4.12,0,1,0,3,13.35,4.12,4.12,0,0,0,7.16,17.47Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: 0.5,
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M30.39,18.75H27.3a5.57,5.57,0,0,0-3.88,1.56,5.57,5.57,0,0,1,1.74,4.05v3.71a1,1,0,0,1-1,1H35a1,1,0,0,0,1-1V24.36A5.61,5.61,0,0,0,30.39,18.75Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: 0.5,
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M28.84,17.47a4.12,4.12,0,1,0-4.12-4.12A4.11,4.11,0,0,0,28.84,17.47Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    opacity: 0.5,
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M14.85,10.72a4.08,4.08,0,0,0-.92,2.58.43.43,0,0,1,0,0h4a.65.65,0,0,0,.52-.26l.93-1.24a.22.22,0,0,1,.35,0l.93,1.24a.68.68,0,0,0,.53.26h.91a.43.43,0,0,1,0,0A4.07,4.07,0,0,0,18,9.23a4.41,4.41,0,0,0-.52,0,2,2,0,0,0,0-.36,2,2,0,1,0-2.66,1.82Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M23.42,20.31a5.55,5.55,0,0,0-3.87-1.57H16.46a5.65,5.65,0,0,0-5.62,5.62v4.69H24.18a1,1,0,0,0,1-1V24.36A5.57,5.57,0,0,0,23.42,20.31Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M20.62,13.09l-.93-1.24a.22.22,0,0,0-.35,0l-.93,1.24a.65.65,0,0,1-.52.26h-4a1,1,0,0,0,0,.17,1.62,1.62,0,0,0,0,.22l0,.19,0,.21c0,.06,0,.12.05.19s0,.13,0,.2l.07.18.07.19.09.17.08.18.11.17a1.4,1.4,0,0,0,.1.16l.12.17a1.71,1.71,0,0,0,.11.14l.14.16.12.13.16.15a.69.69,0,0,1,.13.11l.19.14.12.09.21.13.13.07a1.67,1.67,0,0,0,.23.12l.12.05.28.11.09,0,.35.09h0a4.47,4.47,0,0,0,.82.08,4,4,0,0,0,1.21-.18h0l.34-.13.06,0,.3-.15.06,0,.27-.16.07-.05.24-.18.08-.07.21-.19.07-.08.19-.21.07-.09.17-.22.06-.11.14-.22.06-.13a1.63,1.63,0,0,0,.11-.23s0-.09.05-.13l.09-.24a.83.83,0,0,1,0-.15l.06-.24L22,14l0-.24a.91.91,0,0,0,0-.17,1.48,1.48,0,0,0,0-.21h-.91A.68.68,0,0,1,20.62,13.09Z"
                })
            ]
        })
    });
};

});

parcelRegister("hDRjU", function(module, exports) {

$parcel$export(module.exports, "SmileyIcon", function () { return $fb758fd81d573888$export$663870aff582477c; });
/* eslint-disable react/self-closing-comp */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $1ui6x = parcelRequire("1ui6x");
const $fb758fd81d573888$export$663870aff582477c = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1ui6x.SvgContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMin meet",
            viewBox: "0 0 36 36",
            "aria-hidden": "true",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M0,18A18,18,0,1,1,18,36,18,18,0,0,1,0,18Zm33.18,0A15.18,15.18,0,1,0,18,33.18,15.17,15.17,0,0,0,33.18,18Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    fill: "#ffffff",
                    fillRule: "evenodd",
                    d: "M9.28,19.65a1.41,1.41,0,0,1,1.81.84,7.43,7.43,0,0,0,13.82,0,1.41,1.41,0,1,1,2.65,1,10.25,10.25,0,0,1-19.12,0A1.41,1.41,0,0,1,9.28,19.65Z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                    cx: "12.21",
                    cy: "13.77",
                    r: "2.66",
                    fill: "#ffffff",
                    fillRule: "evenodd"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                    cx: "24.1",
                    cy: "13.77",
                    r: "2.66",
                    fill: "#ffffff",
                    fillRule: "evenodd"
                })
            ]
        })
    });
};

});

parcelRegister("lY0C7", function(module, exports) {

$parcel$export(module.exports, "StarIcon", function () { return $d728d2964c6c6969$export$2ee28caa7f1e962e; });
/* eslint-disable react/self-closing-comp */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $1ui6x = parcelRequire("1ui6x");
const $d728d2964c6c6969$export$2ee28caa7f1e962e = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1ui6x.SvgContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            preserveAspectRatio: "xMinYMin meet",
            viewBox: "0 0 36 36",
            "aria-hidden": "true",
            children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#ffffff",
                fillRule: "evenodd",
                d: "M14.75,2.7,11.15,10l-8,1.18A3.56,3.56,0,0,0,1,12.23L1,12.32a3.62,3.62,0,0,0,.14,5l5.83,5.69-1.38,8a3.68,3.68,0,0,0,.37,2.3l0,.09a3.62,3.62,0,0,0,4.84,1.43L18,31.12l7.2,3.79a3.6,3.6,0,0,0,2.3.36l.1,0a3.62,3.62,0,0,0,2.86-4.16l-1.38-8,5.83-5.69A3.56,3.56,0,0,0,36,15.29l0-.11a3.63,3.63,0,0,0-3.08-4l-8-1.18-3.6-7.3a3.62,3.62,0,0,0-6.5,0Z"
            })
        })
    });
};

});





parcelRegister("ai5nK", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePagePaidLpJsmFeatures", function () { return $d761158fed0ccdb5$export$be845ee60820b39e; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $3FBn4 = parcelRequire("3FBn4");

var $7qGkU = parcelRequire("7qGkU");

var $3cXkF = parcelRequire("3cXkF");
const $d761158fed0ccdb5$export$be845ee60820b39e = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const linkUrl = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/comparison");
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        bannerAlertProps: (0, $7qGkU.getBannerConfig)({
            intl: intl,
            linkUrl: linkUrl
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3cXkF.JiraSoftwarePagePaidLpJsmAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsm-features",
        persona: "unknown",
        pageVariant: "features",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});
parcelRegister("7qGkU", function(module, exports) {

$parcel$export(module.exports, "getBannerConfig", function () { return $fb00a2c66e3ab681$export$aad1aaa28842aab3; });

var $loA2J = parcelRequire("loA2J");

var $4LHd8 = parcelRequire("4LHd8");

var $1UUq1 = parcelRequire("1UUq1");
const $fb00a2c66e3ab681$export$aad1aaa28842aab3 = ({ intl: intl, linkUrl: linkUrl })=>{
    const isBannerEnabled = (0, $4LHd8.default).checkGate("gwp-2022-jsm-paid-lp-banner");
    return isBannerEnabled ? {
        identifier: "jira-service-management.banner-alert.itsm-leader",
        text: intl.formatMessage({
            id: "jira-service-management.banner-alert.itsm-leader.text",
            defaultMessage: "There\u2019s a new leader in ITSM software. <a>See why companies are switching</a> to Jira Service Management."
        }, {
            a: (chunks)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                    text: (chunks || "").toString(),
                    href: linkUrl,
                    type: "inline"
                })
        })
    } : undefined;
};

});


parcelRegister("kTpag", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePagePaidLpJsmFeaturesCerebro", function () { return $9e7f3a713aa7786e$export$ab92522b7cf27ff; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $3FBn4 = parcelRequire("3FBn4");

var $7qGkU = parcelRequire("7qGkU");

var $3cXkF = parcelRequire("3cXkF");
const $9e7f3a713aa7786e$export$ab92522b7cf27ff = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const linkUrl = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/comparison");
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        bannerAlertProps: (0, $7qGkU.getBannerConfig)({
            intl: intl,
            linkUrl: linkUrl
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3cXkF.JiraSoftwarePagePaidLpJsmAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsm-features-cerebro",
        persona: "unknown",
        pageVariant: "features-cerebro"
    }));
};

});

parcelRegister("54ICB", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePagePaidLpJsmIncidentchangemgmt", function () { return $051719c31d73a4ab$export$329b00bf88efc8dd; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $3FBn4 = parcelRequire("3FBn4");

var $7qGkU = parcelRequire("7qGkU");

var $3cXkF = parcelRequire("3cXkF");
const $051719c31d73a4ab$export$329b00bf88efc8dd = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const linkUrl = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/comparison");
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        bannerAlertProps: (0, $7qGkU.getBannerConfig)({
            intl: intl,
            linkUrl: linkUrl
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3cXkF.JiraSoftwarePagePaidLpJsmAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsm-incidentchangemgmt",
        persona: "unknown",
        pageVariant: "incidentchangemgmt",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("dt8LD", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePagePaidLpJsmItsm", function () { return $c1220547c444975b$export$3d1982be409f777c; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $3FBn4 = parcelRequire("3FBn4");

var $7qGkU = parcelRequire("7qGkU");

var $3cXkF = parcelRequire("3cXkF");
const $c1220547c444975b$export$3d1982be409f777c = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const linkUrl = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/comparison");
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        bannerAlertProps: (0, $7qGkU.getBannerConfig)({
            intl: intl,
            linkUrl: linkUrl
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3cXkF.JiraSoftwarePagePaidLpJsmAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsm-itsm",
        persona: "unknown",
        pageVariant: "itsm",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("kzx7G", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePagePaidLpJsmServiceDesk", function () { return $2a7630201e2cbd07$export$595fa6be9e31a4b2; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $3FBn4 = parcelRequire("3FBn4");

var $7qGkU = parcelRequire("7qGkU");

var $3cXkF = parcelRequire("3cXkF");
const $2a7630201e2cbd07$export$595fa6be9e31a4b2 = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const linkUrl = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/comparison");
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        bannerAlertProps: (0, $7qGkU.getBannerConfig)({
            intl: intl,
            linkUrl: linkUrl
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3cXkF.JiraSoftwarePagePaidLpJsmAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsm-service-desk",
        persona: "unknown",
        pageVariant: "service-desk",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("3MxDQ", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSoftwarePagePaidLpJsmTicketing", function () { return $7d285c8eb3a2bc5f$export$a288ad63561bc60a; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");
parcelRequire("8rqVU");
var $lsqCW = parcelRequire("lsqCW");

var $3FBn4 = parcelRequire("3FBn4");

var $7qGkU = parcelRequire("7qGkU");

var $3cXkF = parcelRequire("3cXkF");
const $7d285c8eb3a2bc5f$export$a288ad63561bc60a = (pageProps)=>{
    const intl = (0, $f6qj2.default)();
    const linkUrl = (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/comparison");
    const data = (0, $hOqV7.usePreloadedQuery)((0, $lsqCW.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        bannerAlertProps: (0, $7qGkU.getBannerConfig)({
            intl: intl,
            linkUrl: linkUrl
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3cXkF.JiraSoftwarePagePaidLpJsmAnchor), (0, $6iHNw._)((0, $7Knp0._)({}, pageProps), {
        anchorContents: (0, $lsqCW.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsm-ticketing",
        persona: "unknown",
        pageVariant: "ticketing",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("c6SB4", function(module, exports) {

$parcel$export(module.exports, "getPricingTitleInternal", function () { return $df28def2e86b17ed$export$933c1404a4ee79b; });
const $df28def2e86b17ed$export$933c1404a4ee79b = ()=>{
    return "Jira Service Management Pricing Page";
};

});

parcelRegister("hWRkD", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementPricingPage", function () { return $acb9bd70872a22d2$export$2a3104cce6671f76; });

var $loA2J = parcelRequire("loA2J");

var $4LHd8 = parcelRequire("4LHd8");

var $dT5kE = parcelRequire("dT5kE");
parcelRequire("aRHrH");
var $9O2F2 = parcelRequire("9O2F2");
parcelRequire("ggJem");
var $6TWZY = parcelRequire("6TWZY");
const $acb9bd70872a22d2$export$2a3104cce6671f76 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $4LHd8.default).checkGate("gwp-737-enable-intercom-chat-jsm");
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9O2F2.IntercomProvider), {
        appId: "p0ww63i2",
        triggerBoot: isBootIntercom,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dT5kE.PricingContentContextProviderRelay), {
            productId: "jira-service-management",
            pricingContent: pricingContent,
            queryRef: queryRef,
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                "data-testid": "jsm-pricing-page",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6TWZY.JiraServiceManagementPricingPageV2Template), {
                    pricing: pricing,
                    countryCode: countryCode
                })
            })
        })
    });
};

});
parcelRegister("ggJem", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementPricingPageV2Template", function () { return (parcelRequire("6TWZY")).JiraServiceManagementPricingPageV2Template; });
parcelRequire("6TWZY");

});
parcelRegister("6TWZY", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementPricingPageV2Template", function () { return $f6958f4f77595968$export$ac87b8d354f2d1fd; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("gUyvS");
var $khjAx = parcelRequire("khjAx");
parcelRequire("kmJhl");
var $591nI = parcelRequire("591nI");
var $9376M = parcelRequire("9376M");
var $bofgW = parcelRequire("bofgW");

var $dT5kE = parcelRequire("dT5kE");
parcelRequire("3XyMp");
var $f8O3L = parcelRequire("f8O3L");

var $ceE90 = parcelRequire("ceE90");

var $j1oGG = parcelRequire("j1oGG");

var $3FBn4 = parcelRequire("3FBn4");
parcelRequire("ccYBS");
var $1FqEx = parcelRequire("1FqEx");

var $9g0oR = parcelRequire("9g0oR");

var $kBYq9 = parcelRequire("kBYq9");
const $f6958f4f77595968$export$ac87b8d354f2d1fd = (props)=>{
    var _content_callToActionContainer, _questionsCtaContent_asset;
    const content = (0, $dT5kE.usePricingContentContext)();
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[0];
    const dataCenterContent = (0, $dT5kE.useDatacenterPlans)("Contact Us", "Learn more");
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _content_getMoreDetailsTitle, _content_additionalDetails, _questionsCtaContent_url, _questionsCtaContent_title, _questionsCtaContent_text, _questionsCtaContent_valueProposition;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9g0oR.default), {}),
        showFallback: content === null || content === void 0 ? void 0 : content.hasError,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1FqEx.ParentScrollTracking), {
            scrollTrackingEnabled: true,
            pageId: "jsm-pricing-page",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PageHeading), {
                    children: content === null || content === void 0 ? void 0 : content.headline
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $kBYq9.JsmPriceFinder), {
                    pricing: props.pricing,
                    countryCode: props.countryCode
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $khjAx.PricingFeatureTable), {
                    title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                    comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                    compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $591nI.AtlassianGuardAddOnShared), {
                    ctaHref: (0, $3FBn4.useLocalizedHref)("/software/guard")
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $9376M.DataCenterSection), (0, $7Knp0._)({}, dataCenterContent)),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $f8O3L.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1FqEx.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ceE90.PricingFaq), {
                            header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                            planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bofgW.QuestionsCta), {
                    product: "JSM",
                    ctaHref: (_questionsCtaContent_url = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.url) !== null && _questionsCtaContent_url !== void 0 ? _questionsCtaContent_url : undefined,
                    questionsHeader: (_questionsCtaContent_title = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.title) !== null && _questionsCtaContent_title !== void 0 ? _questionsCtaContent_title : undefined,
                    priceAndLicensingLinkText: (_questionsCtaContent_text = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.text) !== null && _questionsCtaContent_text !== void 0 ? _questionsCtaContent_text : undefined,
                    questionsBody: (_questionsCtaContent_valueProposition = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.valueProposition) !== null && _questionsCtaContent_valueProposition !== void 0 ? _questionsCtaContent_valueProposition : undefined,
                    imageHref: questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : (_questionsCtaContent_asset = questionsCtaContent.asset) === null || _questionsCtaContent_asset === void 0 ? void 0 : _questionsCtaContent_asset.url
                })
            ]
        })
    });
};

});
parcelRegister("kBYq9", function(module, exports) {

$parcel$export(module.exports, "JsmPriceFinder", function () { return $4ef769e121971577$export$27bafd5c0a9a3fce; });

var $loA2J = parcelRequire("loA2J");

var $6x1qA = parcelRequire("6x1qA");

var $7OWgU = parcelRequire("7OWgU");

var $l9lQF = parcelRequire("l9lQF");

var $esRX2 = parcelRequire("esRX2");

var $dT5kE = parcelRequire("dT5kE");

var $g8sHu = parcelRequire("g8sHu");
const $4ef769e121971577$export$27bafd5c0a9a3fce = (props)=>{
    var _content_free, _content_free1, _content_standard, _content_standard1, _content_premium, _content_premium1, _content_enterprise, _content_enterprise1, _props_pricing_ccpPricingData, _props_pricing;
    const messages = (0, $6x1qA.defineMessages)({
        headerText: {
            id: "JsmPricingPageV2.priceFinder.headerText",
            defaultMessage: "Service management <blue>that scales</blue>"
        },
        unitCountInputTextRedesign: {
            id: "JsmPricingPageV2.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputDirectBuy: {
            id: "JsmPricingPageV2.priceFinder.unitCountInputDirectBuy",
            defaultMessage: "What's your team size?"
        },
        unitCountInputTerm: {
            id: "JsmPricingPageV2.priceFinder.unitCountInputTerm",
            defaultMessage: "agents"
        },
        billingCycleText: {
            id: "JsmPricingPageV2.priceFinder.billingCycleText",
            defaultMessage: "Billing cycle:"
        },
        unitCountInputText: {
            id: "JsmPricingPageV2.priceFinder.unitCountInputText",
            defaultMessage: "How many agents are on your team?"
        },
        unitCountInputTooltip: {
            id: "JsmPricingPageV2.priceFinder.unitCountInputTooltip",
            defaultMessage: "Agents work on tickets and communicate directly with your customers."
        },
        cardOverSignupLimit: {
            id: "JsmPricingPageV2.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your agent count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "JsmPricingPageV2.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more agents above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "JsmPricingPageV2.priceFinder.cardUnitCountTierRange",
            defaultMessage: "Agent tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "JsmPricingPageV2.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per agent / month"
        },
        cardFreeDescription: {
            id: "JsmPricingPageV2.priceFinder.cardFreeDescription",
            defaultMessage: "always free for 3 agents,"
        }
    });
    const content = {
        free: (0, $dT5kE.usePricingPlanComparison)("Free"),
        standard: (0, $dT5kE.usePricingPlanComparison)("Standard"),
        premium: (0, $dT5kE.usePricingPlanComparison)("Premium"),
        enterprise: (0, $dT5kE.usePricingPlanComparison)("Enterprise")
    };
    const freePlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "free");
    const standardPlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "standard");
    const premiumPlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "premium");
    const enterprisePlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "enterprise");
    // Note: We need to use the jiraServiceDesk plan name instead of a new jiraServiceManagement key because of how the pricing data is stored in CCP/HAMS. jiraServiceManagement is used as the dataProductKey in all other components on the JSM pricing page.
    const jiraServiceManagementProductPlans = [
        {
            planName: ((_content_free = content.free) === null || _content_free === void 0 ? void 0 : _content_free.planTitleExternal) || "Free",
            offeringSku: "jira-servicedesk-free",
            description: ((_content_free1 = content.free) === null || _content_free1 === void 0 ? void 0 : _content_free1.planOneLiner) || "",
            recommendationLimit: 0,
            signupLimit: 20000,
            signupURLSuffix: "?bundle=jira-service-management&edition=free&signupSource=pricing",
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: ((_content_standard = content.standard) === null || _content_standard === void 0 ? void 0 : _content_standard.planTitleExternal) || "Standard",
            offeringSku: "jira-servicedesk-standard-repack-sku",
            description: ((_content_standard1 = content.standard) === null || _content_standard1 === void 0 ? void 0 : _content_standard1.planOneLiner) || "",
            recommendationLimit: 3,
            signupLimit: 20000,
            signupURLSuffix: "?bundle=jira-service-management&edition=standard",
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: ((_content_premium = content.premium) === null || _content_premium === void 0 ? void 0 : _content_premium.planTitleExternal) || "Premium",
            offeringSku: "jira-servicedesk-premium",
            description: ((_content_premium1 = content.premium) === null || _content_premium1 === void 0 ? void 0 : _content_premium1.planOneLiner) || "",
            recommendationLimit: 50,
            signupLimit: 20000,
            signupURLSuffix: "?bundle=jira-service-management&edition=premium",
            planFeatureMessages: premiumPlanFeatureMessages
        },
        {
            planName: ((_content_enterprise = content.enterprise) === null || _content_enterprise === void 0 ? void 0 : _content_enterprise.planTitleExternal) || "Enterprise",
            offeringSku: "jira-servicedesk-enterprise-sku",
            recommendationLimit: 250,
            description: ((_content_enterprise1 = content.enterprise) === null || _content_enterprise1 === void 0 ? void 0 : _content_enterprise1.planOneLiner) || "",
            signupLimit: 20000,
            planFeatureMessages: enterprisePlanFeatureMessages
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $l9lQF.PriceFinderContextProvider), {
        dataProductKey: "jiraServiceDesk",
        productPlans: jiraServiceManagementProductPlans,
        defaultUnitCount: 75,
        enterpriseMinimumCount: 201,
        shouldAddBuyNow: true,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OWgU.default), {
                messages: messages,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.jiraServiceDesk,
                countryCode: props.countryCode
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $g8sHu.default), {})
        ]
    });
};
$4ef769e121971577$export$27bafd5c0a9a3fce.displayName = "JsmPriceFinderSection";

});
parcelRegister("g8sHu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d012ded1687d8492$export$2e2bcd8739ae039; });
/* disclaimer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");
const $d012ded1687d8492$var$disclaimerTextStyles = null;
const $d012ded1687d8492$var$Disclaimer = ({ disclaimerText: disclaimerText })=>{
    const intl = (0, $f6qj2.default)();
    const text = disclaimerText !== null && disclaimerText !== void 0 ? disclaimerText : intl.formatMessage({
        id: "pricing.disclaimer.text",
        defaultMessage: "The prices shown are estimates and aren't binding for either you or Atlassian. The amount you are billed may be different if you change your scope of use, including by updating your agent count or exceeding your base plan usage of Assets or Virtual Service Agent."
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("p", {
        className: (0, $esG4f.default)([
            "_k48p1kdj _vwz4gktf _1wybdlk8 _syazr3uz _1q511tcg"
        ]),
        children: text
    });
};
$d012ded1687d8492$var$Disclaimer.displayName = "disclaimer";
var $d012ded1687d8492$export$2e2bcd8739ae039 = $d012ded1687d8492$var$Disclaimer;

});





parcelRegister("jIvlj", function(module, exports) {

$parcel$export(module.exports, "JiraTemplateCategoryPage", function () { return $7f9c78758782a715$export$52bd3b9163994b81; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("e1eJY");
var $guoAQ = parcelRequire("guoAQ");
const $7f9c78758782a715$export$52bd3b9163994b81 = ({ templates: templates })=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $guoAQ.JiraTemplateCategoryPageTemplate), {
        templates: templates
    });

});
parcelRegister("e1eJY", function(module, exports) {

$parcel$export(module.exports, "JiraTemplateCategoryPageTemplate", function () { return (parcelRequire("guoAQ")).JiraTemplateCategoryPageTemplate; });

var $guoAQ = parcelRequire("guoAQ");

});
parcelRegister("guoAQ", function(module, exports) {

$parcel$export(module.exports, "JiraTemplateCategoryPageTemplate", function () { return $c6cce14b5472a894$export$8ae757bfa7e42dde; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $i8kxh = parcelRequire("i8kxh");

var $2lEkF = parcelRequire("2lEkF");

var $3LLDq = parcelRequire("3LLDq");

var $fxdfZ = parcelRequire("fxdfZ");

var $4XrxY = parcelRequire("4XrxY");

var $13bKL = parcelRequire("13bKL");

var $gAJUc = parcelRequire("gAJUc");

var $gv7GE = parcelRequire("gv7GE");

var $gUTfs = parcelRequire("gUTfs");

var $8AWah = parcelRequire("8AWah");

var $9G171 = parcelRequire("9G171");
const $c6cce14b5472a894$var$PageContent = ({ templates: templates })=>{
    const templateCategoriesHidden = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).jiraTemplatesDxpMigration);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8AWah.SharedHeaderFooterContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.TypographyStyles), {
            children: [
                !templateCategoriesHidden && /*#__PURE__*/ (0, $loA2J.jsx)((0, $13bKL.SubNavJiraTemplates), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9G171.TemplatesGrid), {
                        templates: templates !== null && templates !== void 0 ? templates : (0, $gv7GE.JSM_TEMPLATES_CONTENT)
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $gUTfs.Resources), {})
            ]
        })
    });
};
const $c6cce14b5472a894$export$8ae757bfa7e42dde = ({ templates: templates })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const fireSLOErrorEvent = (0, $iSvIT.useCallback)((error)=>{
        createAnalyticsEvent({
            product: "marketing",
            eventType: "operational",
            actionSubject: "wacJsmTemplateScreenFailed",
            action: "failed",
            attributes: {
                errorMessage: (error === null || error === void 0 ? void 0 : error.message) || error
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fxdfZ.default), {
        fallback: /*#__PURE__*/ (0, $loA2J.jsx)($c6cce14b5472a894$var$PageContent, {
            templates: templates
        }),
        onError: (e)=>fireSLOErrorEvent(e),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2lEkF.CrossFlowProvider), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3LLDq.CrossFlowTouchpointProvider), {
                productKeys: [
                    (0, $i8kxh.ProductKeys).JIRA_SERVICE_DESK
                ],
                screenName: "wacJsmTemplateScreen",
                children: /*#__PURE__*/ (0, $loA2J.jsx)($c6cce14b5472a894$var$PageContent, {
                    templates: templates
                })
            })
        })
    });
};

});
parcelRegister("13bKL", function(module, exports) {

$parcel$export(module.exports, "SubNavJiraTemplates", function () { return $fffce8c2176e77f7$export$3222b75ebb2ca134; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");

var $8X9yo = parcelRequire("8X9yo");

var $e9PKE = parcelRequire("e9PKE");
const $fffce8c2176e77f7$export$3222b75ebb2ca134 = ()=>{
    const intl = (0, $f6qj2.default)();
    const productKey = "agile";
    const headerLinkText = intl.formatMessage({
        id: "jira-templates.logo-label",
        defaultMessage: "Jira Templates"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8X9yo.SubNav), {
        productKey: productKey,
        headerLinkText: headerLinkText,
        headerLinkHref: (0, $3FBn4.useLocalizedHref)("/software/jira/templates/service-management"),
        desktopLinks: [
            {
                globalLinksKey: "categories",
                linkText: intl.formatMessage({
                    id: "jira-templates.subnav.categories",
                    defaultMessage: "Categories"
                }),
                hasSubnav: true,
                content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $e9PKE.CategoriesDropdown), {})
            }
        ],
        mobileLinks: [
            {
                mobileLinkKey: "subnav-links",
                mobileLinksProps: [
                    {
                        globalLinksKey: "categories",
                        linkText: intl.formatMessage({
                            id: "jira-templates.subnav-mobile.dropdown.devops",
                            defaultMessage: "Categories"
                        }),
                        hasSubnav: true,
                        dropdownType: "categories"
                    }
                ]
            }
        ]
    });
};

});

parcelRegister("gv7GE", function(module, exports) {

$parcel$export(module.exports, "JSM_TEMPLATES_CONTENT", function () { return $ce1d1d2fccc23c01$export$a582b1f9bb954226; });
const $ce1d1d2fccc23c01$export$a582b1f9bb954226 = [
    {
        templateId: "it-service-management",
        name: "IT service management",
        oneLinerHeadline: "Intake requests, set up alerts, raise incidents, and fix issues quickly.",
        urlSlug: "it-service-management",
        templateIcon: {
            name: "Jira roadmap",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:f4f1a80b-82c9-4951-878a-ce360fb2da9d/Screen_Queues.png?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/ug362u6qv3ywnwcca17012vsdfpwcu1j.svg",
            description: "Jira roadmap"
        },
        keyFeatures: [
            {
                name: "Alerts and on-call schedules",
                iconRef: "alert-icon"
            },
            {
                name: "Multi-channel support",
                iconRef: "headphone-icon"
            }
        ]
    },
    {
        templateId: "advanced-it-service-management",
        name: "Advanced IT service management",
        oneLinerHeadline: "Incident, change, and problem management with ITSM best practices.",
        urlSlug: "advanced-it-service-management",
        templateIcon: {
            name: "Help Center screenshot",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:95aef340-57e7-4ec1-a92d-cbda63b1814e/var1%20for%20JSM%20templates.svg?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/3fte56b800hsu0n8r76727ht510v7808.svg",
            description: "Help Center screenshot"
        },
        keyFeatures: [
            {
                name: "Automated change requests",
                iconRef: "check-task-icon"
            },
            {
                name: "Alerts and on-call schedules",
                iconRef: "alert-icon"
            }
        ]
    },
    {
        templateId: "hr-service-management",
        name: "HR service management",
        oneLinerHeadline: "Manage onboarding and offboarding and respond to HR requests.",
        urlSlug: "hr-service-management",
        templateIcon: {
            name: "Jira roadmap",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:b7e76c98-78d2-4c35-9cf3-a30b6f888dc1/Screen_HelpCenter.png?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/cre6xx6lyq1hcp327v813e1t38k241sx.svg",
            description: "Jira roadmap"
        },
        keyFeatures: [
            {
                name: "Self-service and FAQ help center",
                iconRef: "help-icon"
            },
            {
                name: "Customizable request forms",
                iconRef: "mail-icon"
            }
        ]
    },
    {
        templateId: "customer-service-management",
        name: "Customer service management",
        oneLinerHeadline: "Deliver great service experiences for your external customers.",
        urlSlug: "customer-service-management",
        templateIcon: {
            name: "Jira roadmap",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:0abefbb4-6cfd-4163-829a-fcf2db0b99e7/var2%20for%20JSM%20templates.svg?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/2b83vv62ssm4g2km1m7638d126w2e1u3.svg",
            description: "Jira roadmap"
        },
        keyFeatures: [
            {
                name: "Developer escalations",
                iconRef: "flag-icon"
            },
            {
                name: "Self-service and FAQ help center",
                iconRef: "help-icon"
            }
        ]
    },
    {
        templateId: "marketing-service-management",
        name: "Marketing service management",
        oneLinerHeadline: "Manage and track all your marketing requests.",
        urlSlug: "marketing-service-management",
        templateIcon: {
            name: "Jira roadmap",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:b7e76c98-78d2-4c35-9cf3-a30b6f888dc1/Screen_HelpCenter.png?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/g13dr33528x350811shfr52mr5y5hr72.svg",
            description: "Jira roadmap"
        },
        keyFeatures: [
            {
                name: "Forms for Marketing requests",
                iconRef: "mail-icon"
            },
            {
                name: "Reports",
                iconRef: "data-points-icon"
            }
        ]
    },
    {
        templateId: "design-service-management",
        name: "Design service management",
        oneLinerHeadline: "Manage and track all your design requests.",
        urlSlug: "design-service-management",
        templateIcon: {
            name: "Help Center screenshot",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:95aef340-57e7-4ec1-a92d-cbda63b1814e/var1%20for%20JSM%20templates.svg?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/e4tgp6i7841gcfb7wf43k0j6a2576264.svg",
            description: "Help Center screenshot"
        },
        keyFeatures: [
            {
                name: "Self-service and FAQ help center",
                iconRef: "help-icon"
            },
            {
                name: "Automated design workflows",
                iconRef: "workflow-icon"
            }
        ]
    },
    {
        templateId: "finance-service-management",
        name: "Finance service management",
        oneLinerHeadline: "Manage and track budget, spend, and other finance requests.",
        urlSlug: "finance-service-management",
        templateIcon: {
            name: "Form view",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:f4f1a80b-82c9-4951-878a-ce360fb2da9d/Screen_Queues.png?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/401876mvht4ti1a070a3s3o3t3i6s51u.svg",
            description: "Form view"
        },
        keyFeatures: [
            {
                name: "Forms for Finance requests",
                iconRef: "mail-icon"
            },
            {
                name: "Reporting and tracking",
                iconRef: "data-points-icon"
            }
        ]
    },
    {
        templateId: "analytics-service-management",
        name: "Analytics service management",
        oneLinerHeadline: "Manage employee requests for the data and insights they need.",
        urlSlug: "analytics-service-management",
        templateIcon: {
            name: "Jira roadmap",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:95aef340-57e7-4ec1-a92d-cbda63b1814e/var1%20for%20JSM%20templates.svg?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/hqvjo4k71u4x3y6e2nkden08471f4e47.svg",
            description: "Jira roadmap"
        },
        keyFeatures: [
            {
                name: "Self-service and FAQ help center",
                iconRef: "help-icon"
            },
            {
                name: "Automated Analytics workflows",
                iconRef: "robot-icon"
            }
        ]
    },
    {
        templateId: "facilities-service-management",
        name: "Facilities service management",
        oneLinerHeadline: "Manage requests for maintenance, moving, and event planning.",
        urlSlug: "facilities-service-management",
        templateIcon: {
            name: "Help center screenshot",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:b7e76c98-78d2-4c35-9cf3-a30b6f888dc1/Screen_HelpCenter.png?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/18xqw35pw8do7ru0wp3d8oscs2fmw1mf.svg",
            description: "Help center screenshot"
        },
        keyFeatures: [
            {
                name: "Forms for Facilities requests",
                iconRef: "mail-icon"
            },
            {
                name: "Self-service and FAQ help center",
                iconRef: "help-icon"
            }
        ]
    },
    {
        templateId: "sales-service-management",
        name: "Sales service management",
        oneLinerHeadline: "Manage, track, and report on all your sales requests.",
        urlSlug: "sales-service-management",
        templateIcon: {
            name: "Kanban board",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:0abefbb4-6cfd-4163-829a-fcf2db0b99e7/var2%20for%20JSM%20templates.svg?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/1k3k7o8j66265rdk5e6vj0o23g611j04.svg",
            description: "Kanban board"
        },
        keyFeatures: [
            {
                name: "Forms designed for Sales requests",
                iconRef: "mail-icon"
            },
            {
                name: "Reporting and tracking",
                iconRef: "data-points-icon"
            }
        ]
    },
    {
        templateId: "legal-service-management",
        name: "Legal service management",
        oneLinerHeadline: "Manage and track all your contracts and legal requests.",
        urlSlug: "legal-service-management",
        templateIcon: {
            name: "Jira roadmap",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:b7e76c98-78d2-4c35-9cf3-a30b6f888dc1/Screen_HelpCenter.png?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/47k1ynn8f0024m4tg2vd6omf3jr60h7u.svg",
            description: "Jira roadmap"
        },
        keyFeatures: [
            {
                name: "Self-service and FAQ help center",
                iconRef: "help-icon"
            },
            {
                name: "Customer portal to take requests",
                iconRef: "mail-icon"
            }
        ]
    },
    {
        templateId: "general-service-management",
        name: "General service management",
        oneLinerHeadline: "Collect, prioritize, and manage requests for any business teams.",
        urlSlug: "general-service-management",
        templateIcon: {
            name: "Queues view",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:f4f1a80b-82c9-4951-878a-ce360fb2da9d/Screen_Queues.png?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/2x43564ibsn386dk7g764353rk2341n2.svg",
            description: "Queues view"
        },
        keyFeatures: [
            {
                name: "Self-service and FAQ help center",
                iconRef: "help-icon"
            },
            {
                name: "Customer portal to take requests",
                iconRef: "mail-icon"
            }
        ]
    }
];

});

parcelRegister("gUTfs", function(module, exports) {

$parcel$export(module.exports, "Resources", function () { return $68b5ba103ec57a1f$export$e9a269813a6315a4; });
/* resources.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $68b5ba103ec57a1f$var$backgroundStyles = null;
const $68b5ba103ec57a1f$var$h2Styles = null;
const $68b5ba103ec57a1f$var$h4Styles = null;
const $68b5ba103ec57a1f$var$pStyles = null;
const $68b5ba103ec57a1f$var$linkStyles = null;
const $68b5ba103ec57a1f$export$e9a269813a6315a4 = ()=>{
    const intl = (0, $f6qj2.default)();
    const resources = [
        {
            heading: intl.formatMessage({
                id: "jsm.templates.resources.gettingStartedGuide",
                defaultMessage: "Getting started guide"
            }),
            description: intl.formatMessage({
                id: "jsm.templates.resources.gettingStartedGuideDescription",
                defaultMessage: "Everything you need to know about getting started with Jira Service Management."
            }),
            link: {
                text: intl.formatMessage({
                    id: "jsm.templates.resources.gettingStartedGuideLink",
                    defaultMessage: "Go to guide"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/product-guide/getting-started/quick-start-guide"),
                type: "primary"
            }
        },
        {
            heading: intl.formatMessage({
                id: "jsm.templates.resources.productGuide",
                defaultMessage: "Jira Service Management product guides"
            }),
            description: intl.formatMessage({
                id: "jsm.templates.resources.productGuideDescription",
                defaultMessage: "How to use Jira Service Management: guides, tutorials, and demos."
            }),
            link: {
                text: intl.formatMessage({
                    id: "jsm.templates.resources.productGuideLink",
                    defaultMessage: "Review the guide"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/product-guide"),
                type: "primary"
            }
        },
        {
            heading: intl.formatMessage({
                id: "jsm.templates.resources.demo",
                defaultMessage: "Jira Service Management demo"
            }),
            description: intl.formatMessage({
                id: "jsm.templates.resources.demoDescription",
                defaultMessage: "Choose specific features you\u2019re interested in and we\u2019ll personalize a demo for you."
            }),
            link: {
                text: intl.formatMessage({
                    id: "jsm.templates.resources.demoLink",
                    defaultMessage: "Watch the demo"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/software/jira/service-management/demo"),
                type: "primary"
            }
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1itk1ejp _12vemgnk _1lrw1wug _1bsb1osq _ca0qgktf _u5f37vkz _n3tdckbl _19bv7vkz _1akockbl _c7s77vkz _4puvvbgk _1r3v7vkz _3int1h90 _4fuggrf3 _1ynq1h90 _1j3ngrf3 _ip651h90 _g8ou1h90 _1opi1h90 _1x951h90"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_syazmcao _1wybk299 _k48p124r _vwz42a8g _y3gn1qpp _19pkgrf3 _2hwx1h90 _otyrgrf3 _18u01h90 _ca0q7vkz _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _1ako1crf _c7s77vkz _4puv1crf _1r3v7vkz _1s18r6mz _uj6k1s23"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "resources.heading",
                    defaultMessage: "Service management resources"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                layout: "4-4-4",
                children: resources.map((resource, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                                className: (0, $esG4f.default)([
                                    "_syazmcao _k48p124r _vwz4cjiy _6rth1usy _1wyb19as _1dyzzyni _1s18n2z8"
                                ]),
                                children: resource.heading
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                className: (0, $esG4f.default)([
                                    "_syazt5hr _1wyb1j6v _k48pl8b6 _vwz41k8s _6rth1x4e"
                                ]),
                                children: resource.description
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), (0, $6iHNw._)((0, $7Knp0._)({}, resource.link), {
                                className: (0, $esG4f.default)([
                                    "_v56412xp"
                                ])
                            }))
                        ]
                    }, index))
            })
        ]
    });
};

});

parcelRegister("8AWah", function(module, exports) {

$parcel$export(module.exports, "SharedHeaderFooterContainer", function () { return $d6b791346e1ce583$export$93790172861f3d8b; });

var $loA2J = parcelRequire("loA2J");

var $i8kxh = parcelRequire("i8kxh");

var $gkV6l = parcelRequire("gkV6l");

var $kex29 = parcelRequire("kex29");

var $9g0oR = parcelRequire("9g0oR");
const $d6b791346e1ce583$export$93790172861f3d8b = ({ children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $9g0oR.default), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $gkV6l.SiteSelectorContextProvider), {
                productKey: (0, $i8kxh.ProductKeys).JIRA_SERVICE_DESK,
                analyticsPrefix: "wac.showroom",
                internalLinkAfterIdentity: "/team-playbook/plays/choose-your-site",
                children: children
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
        ]
    });
};

});

parcelRegister("9G171", function(module, exports) {

$parcel$export(module.exports, "TemplatesGrid", function () { return $39d3dab0f54415db$export$e845b3e887ad68a4; });
/* templates-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $5HIlD = parcelRequire("5HIlD");

var $4XrxY = parcelRequire("4XrxY");
const $39d3dab0f54415db$var$fontCharlieDisplay = `"Charlie Display", "Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif`;
const $39d3dab0f54415db$var$fontCharlieText = `"Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif`;
const $39d3dab0f54415db$var$backgroundStyles = null;
const $39d3dab0f54415db$var$containerStyles = null;
const $39d3dab0f54415db$var$titleStyles = null;
const $39d3dab0f54415db$var$h1Styles = null;
const $39d3dab0f54415db$var$pStyles = null;
const $39d3dab0f54415db$var$gridContainerStyles = null;
const $39d3dab0f54415db$export$e845b3e887ad68a4 = ({ templates: templates })=>{
    const templateGridRows = ()=>{
        const rows = [];
        for(let i = 0; i < templates.length; i += 3)rows.push(templates.slice(i, i + 3));
        return rows;
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1itk12hr _12vemgnk _1reoidpf _18m9idpf"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_ahbq1wug _12l21wug _85i57vkz _1q517vkz _p12f1fra _1yd316xz _1waf16xz"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_ahbq1wug _12l21wug _1bsb1osq _bozg7vkz _y4ti7vkz _85i5zwfg _14b5m8w4 _uj6k1h6o _1yd3vbgk _glte2c62 _40tuvbgk"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                            className: (0, $esG4f.default)([
                                "_syazmcao _vwz4zz36 _ect41bwv _k48p53lb _1pfhidpf _6rth7vkz _1wyb14b4 _1s181a5d _3p1cxxch"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "jsm.templates.page.title",
                                defaultMessage: "Service management templates"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: (0, $esG4f.default)([
                                "_syaz1fxt _ect41fn2"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "jsm.templates.page.subtitle",
                                defaultMessage: "Empower any team to get started with a service experience in Jira Service Management with pre-configured request types, workflows, and automations."
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    "data-testid": "templates-grid",
                    className: (0, $esG4f.default)([
                        "_1bsb1osq _bozg1gpt _y4ti1gpt _9bbqgrf3 _1qqcgrf3"
                    ]),
                    children: templateGridRows().map((row, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                            layout: "4-4-4",
                            children: row.map((template)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $5HIlD.TemplateCard), {
                                    template: template
                                }, template.urlSlug))
                        }, `template-grid-row-${index}`))
                })
            ]
        })
    });
};

});
parcelRegister("5HIlD", function(module, exports) {

$parcel$export(module.exports, "TemplateCard", function () { return $104e448545a35e69$export$ba340e850b866867; });
/* template-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("9HFEq");
var $dbhgV = parcelRequire("dbhgV");

var $5ohHq = parcelRequire("5ohHq");

var $l6She = parcelRequire("l6She");
const $104e448545a35e69$var$colorN700 = "#253858";
const $104e448545a35e69$var$containerStyles = null;
const $104e448545a35e69$export$ba340e850b866867 = ({ template: template })=>{
    var _template_templateIcon;
    const intl = (0, $f6qj2.default)();
    const url = template.urlSlug ? `/software/jira/templates/${template.urlSlug}` : "";
    const messages = // @ts-ignore
    (0, $l6She.JiraServiceManagementTemplateMessageMap)[template.templateId];
    var _template_templateIcon_url, _intl_formatMessage;
    if (messages) return /*#__PURE__*/ (0, $loA2J.jsx)("a", {
        href: url !== null && url !== void 0 ? url : "",
        className: (0, $esG4f.default)([
            "_z5uk1h67 _1boa1h67 _16it1h67 _ad5c1h67 _1rhqmcao _8kc9n2z8 _1euyw0jn _k6x01gpt _125xmcao _q7gq19as _zcqxk299 _1ayngrf3 _16qsl45a _v564mihd _1dbz1x6p _858u8ben _2rko1wa3 _1reo15vq _18m915vq _1ilwgrf3"
        ]),
        style: {
            "--_w9vrer": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark1100")),
            "--_nl5by5": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue1000"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dbhgV.Card), {
            className: "template-card",
            "data-testid": "template-card",
            headerText: intl.formatMessage(messages.name),
            headerType: "h4",
            bodyText: intl.formatMessage(messages.oneLinerHeadline),
            backgroundColor: (0, $5ohHq.wacToken)("color.neutral.light100"),
            textColor: $104e448545a35e69$var$colorN700,
            clickableCardUrl: url !== null && url !== void 0 ? url : "",
            pictureProps: {
                image: {
                    src: (_template_templateIcon_url = (_template_templateIcon = template.templateIcon) === null || _template_templateIcon === void 0 ? void 0 : _template_templateIcon.url) !== null && _template_templateIcon_url !== void 0 ? _template_templateIcon_url : "",
                    alt: (_intl_formatMessage = intl.formatMessage(messages.iconDescription)) !== null && _intl_formatMessage !== void 0 ? _intl_formatMessage : ""
                }
            }
        })
    });
    return null;
};

});
parcelRegister("l6She", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementTemplateMessageMap", function () { return $4459d2703ad50c55$export$7eb612acc27aff49; });

var $6x1qA = parcelRequire("6x1qA");
const $4459d2703ad50c55$export$7d34f3deca703e17 = (0, $6x1qA.defineMessages)({
    "it-service-managementName": {
        id: "jsm.templates.it-service-management.name",
        defaultMessage: "IT service management"
    },
    "it-service-managementOneLinerHeadline": {
        id: "jsm.templates.it-service-management.oneLinerHeadline",
        defaultMessage: "Intake requests, set up alerts, raise incidents, and fix issues quickly."
    },
    "it-service-managementIconName": {
        id: "jsm.templates.it-service-management.templateIcon.name",
        defaultMessage: "Jira roadmap"
    },
    "it-service-managementIconDescription": {
        id: "jsm.templates.it-service-management.templateIcon.description",
        defaultMessage: "Jira roadmap"
    },
    "it-service-managementFeature-1": {
        id: "jsm.templates.it-service-management.feature-1",
        defaultMessage: "Alerts and on-call schedules"
    },
    "it-service-managementFeature-2": {
        id: "jsm.templates.it-service-management.feature-2",
        defaultMessage: "Multi-channel support"
    },
    "advanced-it-service-managementName": {
        id: "jsm.templates.advanced-it-service-management.name",
        defaultMessage: "Advanced IT service management"
    },
    "advanced-it-service-managementOneLinerHeadline": {
        id: "jsm.templates.advanced-it-service-management.oneLinerHeadline",
        defaultMessage: "Incident, change, and problem management with ITSM best practices."
    },
    "advanced-it-service-managementIconName": {
        id: "jsm.templates.advanced-it-service-management.templateIcon.name",
        defaultMessage: "Help Center screenshot"
    },
    "advanced-it-service-managementIconDescription": {
        id: "jsm.templates.advanced-it-service-management.templateIcon.description",
        defaultMessage: "Help Center screenshot"
    },
    "advanced-it-service-managementFeature-1": {
        id: "jsm.templates.advanced-it-service-management.feature-1",
        defaultMessage: "Automated change requests"
    },
    "advanced-it-service-managementFeature-2": {
        id: "jsm.templates.advanced-it-service-management.feature-2",
        defaultMessage: "Alerts and on-call schedules"
    },
    "hr-service-managementName": {
        id: "jsm.templates.hr-service-management.name",
        defaultMessage: "HR service management"
    },
    "hr-service-managementOneLinerHeadline": {
        id: "jsm.templates.hr-service-management.oneLinerHeadline",
        defaultMessage: "Manage onboarding and offboarding and respond to HR requests."
    },
    "hr-service-managementIconName": {
        id: "jsm.templates.hr-service-management.templateIcon.name",
        defaultMessage: "Jira roadmap"
    },
    "hr-service-managementIconDescription": {
        id: "jsm.templates.hr-service-management.templateIcon.description",
        defaultMessage: "Jira roadmap"
    },
    "hr-service-managementFeature-1": {
        id: "jsm.templates.hr-service-management.feature-1",
        defaultMessage: "Self-service and FAQ help center"
    },
    "hr-service-managementFeature-2": {
        id: "jsm.templates.hr-service-management.feature-2",
        defaultMessage: "Customizable request forms"
    },
    "customer-service-managementName": {
        id: "jsm.templates.customer-service-management.name",
        defaultMessage: "Customer service management"
    },
    "customer-service-managementOneLinerHeadline": {
        id: "jsm.templates.customer-service-management.oneLinerHeadline",
        defaultMessage: "Deliver great service experiences for your external customers."
    },
    "customer-service-managementIconName": {
        id: "jsm.templates.customer-service-management.templateIcon.name",
        defaultMessage: "Jira roadmap"
    },
    "customer-service-managementIconDescription": {
        id: "jsm.templates.customer-service-management.templateIcon.description",
        defaultMessage: "Jira roadmap"
    },
    "customer-service-managementFeature-1": {
        id: "jsm.templates.customer-service-management.feature-1",
        defaultMessage: "Developer escalations"
    },
    "customer-service-managementFeature-2": {
        id: "jsm.templates.customer-service-management.feature-2",
        defaultMessage: "Self-service and FAQ help center"
    },
    "marketing-service-managementName": {
        id: "jsm.templates.marketing-service-management.name",
        defaultMessage: "Marketing service management"
    },
    "marketing-service-managementOneLinerHeadline": {
        id: "jsm.templates.marketing-service-management.oneLinerHeadline",
        defaultMessage: "Manage and track all your marketing requests."
    },
    "marketing-service-managementIconName": {
        id: "jsm.templates.marketing-service-management.templateIcon.name",
        defaultMessage: "Jira roadmap"
    },
    "marketing-service-managementIconDescription": {
        id: "jsm.templates.marketing-service-management.templateIcon.description",
        defaultMessage: "Jira roadmap"
    },
    "marketing-service-managementFeature-1": {
        id: "jsm.templates.marketing-service-management.feature-1",
        defaultMessage: "Forms for Marketing requests"
    },
    "marketing-service-managementFeature-2": {
        id: "jsm.templates.marketing-service-management.feature-2",
        defaultMessage: "Reports"
    },
    "design-service-managementName": {
        id: "jsm.templates.design-service-management.name",
        defaultMessage: "Design service management"
    },
    "design-service-managementOneLinerHeadline": {
        id: "jsm.templates.design-service-management.oneLinerHeadline",
        defaultMessage: "Manage and track all your design requests."
    },
    "design-service-managementIconName": {
        id: "jsm.templates.design-service-management.templateIcon.name",
        defaultMessage: "Help Center screenshot"
    },
    "design-service-managementIconDescription": {
        id: "jsm.templates.design-service-management.templateIcon.description",
        defaultMessage: "Help Center screenshot"
    },
    "design-service-managementFeature-1": {
        id: "jsm.templates.design-service-management.feature-1",
        defaultMessage: "Self-service and FAQ help center"
    },
    "design-service-managementFeature-2": {
        id: "jsm.templates.design-service-management.feature-2",
        defaultMessage: "Automated design workflows"
    },
    "finance-service-managementName": {
        id: "jsm.templates.finance-service-management.name",
        defaultMessage: "Finance service management"
    },
    "finance-service-managementOneLinerHeadline": {
        id: "jsm.templates.finance-service-management.oneLinerHeadline",
        defaultMessage: "Manage and track budget, spend, and other finance requests."
    },
    "finance-service-managementIconName": {
        id: "jsm.templates.finance-service-management.templateIcon.name",
        defaultMessage: "Form view"
    },
    "finance-service-managementIconDescription": {
        id: "jsm.templates.finance-service-management.templateIcon.description",
        defaultMessage: "Form view"
    },
    "finance-service-managementFeature-1": {
        id: "jsm.templates.finance-service-management.feature-1",
        defaultMessage: "Forms for Finance requests"
    },
    "finance-service-managementFeature-2": {
        id: "jsm.templates.finance-service-management.feature-2",
        defaultMessage: "Reporting and tracking"
    },
    "analytics-service-managementName": {
        id: "jsm.templates.analytics-service-management.name",
        defaultMessage: "Analytics service management"
    },
    "analytics-service-managementOneLinerHeadline": {
        id: "jsm.templates.analytics-service-management.oneLinerHeadline",
        defaultMessage: "Manage employee requests for the data and insights they need."
    },
    "analytics-service-managementIconName": {
        id: "jsm.templates.analytics-service-management.templateIcon.name",
        defaultMessage: "Jira roadmap"
    },
    "analytics-service-managementIconDescription": {
        id: "jsm.templates.analytics-service-management.templateIcon.description",
        defaultMessage: "Jira roadmap"
    },
    "analytics-service-managementFeature-1": {
        id: "jsm.templates.analytics-service-management.feature-1",
        defaultMessage: "Self-service and FAQ help center"
    },
    "analytics-service-managementFeature-2": {
        id: "jsm.templates.analytics-service-management.feature-2",
        defaultMessage: "Automated Analytics workflows"
    },
    "facilities-service-managementName": {
        id: "jsm.templates.facilities-service-management.name",
        defaultMessage: "Facilities service management"
    },
    "facilities-service-managementOneLinerHeadline": {
        id: "jsm.templates.facilities-service-management.oneLinerHeadline",
        defaultMessage: "Manage requests for maintenance, moving, and event planning."
    },
    "facilities-service-managementIconName": {
        id: "jsm.templates.facilities-service-management.templateIcon.name",
        defaultMessage: "Help center screenshot"
    },
    "facilities-service-managementIconDescription": {
        id: "jsm.templates.facilities-service-management.templateIcon.description",
        defaultMessage: "Help center screenshot"
    },
    "facilities-service-managementFeature-1": {
        id: "jsm.templates.facilities-service-management.feature-1",
        defaultMessage: "Forms for Facilities requests"
    },
    "facilities-service-managementFeature-2": {
        id: "jsm.templates.facilities-service-management.feature-2",
        defaultMessage: "Self-service and FAQ help center"
    },
    "sales-service-managementName": {
        id: "jsm.templates.sales-service-management.name",
        defaultMessage: "Sales service management"
    },
    "sales-service-managementOneLinerHeadline": {
        id: "jsm.templates.sales-service-management.oneLinerHeadline",
        defaultMessage: "Manage, track, and report on all your sales requests."
    },
    "sales-service-managementIconName": {
        id: "jsm.templates.sales-service-management.templateIcon.name",
        defaultMessage: "Kanban board"
    },
    "sales-service-managementIconDescription": {
        id: "jsm.templates.sales-service-management.template    .Icon.description",
        defaultMessage: "Kanban board"
    },
    "sales-service-managementFeature-1": {
        id: "jsm.templates.sales-service-management.feature-1",
        defaultMessage: "Forms designed for Sales requests"
    },
    "sales-service-managementFeature-2": {
        id: "jsm.templates.sales-service-management.feature-2",
        defaultMessage: "Reporting and tracking"
    },
    "legal-service-managementName": {
        id: "jsm.templates.legal-service-management.name",
        defaultMessage: "Legal service management"
    },
    "legal-service-managementOneLinerHeadline": {
        id: "jsm.templates.legal-service-management.oneLinerHeadline",
        defaultMessage: "Manage and track all your contracts and legal requests."
    },
    "legal-service-managementIconName": {
        id: "jsm.templates.legal-service-management.templateIcon.name",
        defaultMessage: "Jira roadmap"
    },
    "legal-service-managementIconDescription": {
        id: "jsm.templates.legal-service-management.templateIcon.description",
        defaultMessage: "Jira roadmap"
    },
    "legal-service-managementFeature-1": {
        id: "jsm.templates.legal-service-management.feature-1",
        defaultMessage: "Self-service and FAQ help center"
    },
    "legal-service-managementFeature-2": {
        id: "jsm.templates.legal-service-management.feature-2",
        defaultMessage: "Customer portal to take requests"
    },
    "general-service-managementName": {
        id: "jsm.templates.general-service-management.name",
        defaultMessage: "General service management"
    },
    "general-service-managementOneLinerHeadline": {
        id: "jsm.templates.general-service-management.oneLinerHeadline",
        defaultMessage: "Collect, prioritize, and manage requests for any business teams."
    },
    "general-service-managementIconName": {
        id: "jsm.templates.general-service-management.templateIcon.name",
        defaultMessage: "Queues view"
    },
    "general-service-managementIconDescription": {
        id: "jsm.templates.general-service-management.templateIcon.description",
        defaultMessage: "Queues view"
    },
    "general-service-managementFeature-1": {
        id: "jsm.templates.general-service-management.feature-1",
        defaultMessage: "Self-service and FAQ help center"
    },
    "general-service-managementFeature-2": {
        id: "jsm.templates.general-service-management.feature-2",
        defaultMessage: "Customer portal to take requests"
    }
});
const $4459d2703ad50c55$export$7eb612acc27aff49 = {
    "it-service-management": {
        name: $4459d2703ad50c55$export$7d34f3deca703e17["it-service-managementName"],
        oneLinerHeadline: $4459d2703ad50c55$export$7d34f3deca703e17["it-service-managementOneLinerHeadline"],
        iconName: $4459d2703ad50c55$export$7d34f3deca703e17["it-service-managementIconName"],
        iconDescription: $4459d2703ad50c55$export$7d34f3deca703e17["it-service-managementIconDescription"],
        keyFeatures: [
            $4459d2703ad50c55$export$7d34f3deca703e17["it-service-managementFeature-1"],
            $4459d2703ad50c55$export$7d34f3deca703e17["it-service-managementFeature-2"]
        ]
    },
    "advanced-it-service-management": {
        name: $4459d2703ad50c55$export$7d34f3deca703e17["advanced-it-service-managementName"],
        oneLinerHeadline: $4459d2703ad50c55$export$7d34f3deca703e17["advanced-it-service-managementOneLinerHeadline"],
        iconName: $4459d2703ad50c55$export$7d34f3deca703e17["advanced-it-service-managementIconName"],
        iconDescription: $4459d2703ad50c55$export$7d34f3deca703e17["advanced-it-service-managementIconDescription"],
        keyFeatures: [
            $4459d2703ad50c55$export$7d34f3deca703e17["advanced-it-service-managementFeature-1"],
            $4459d2703ad50c55$export$7d34f3deca703e17["advanced-it-service-managementFeature-2"]
        ]
    },
    "hr-service-management": {
        name: $4459d2703ad50c55$export$7d34f3deca703e17["hr-service-managementName"],
        oneLinerHeadline: $4459d2703ad50c55$export$7d34f3deca703e17["hr-service-managementOneLinerHeadline"],
        iconName: $4459d2703ad50c55$export$7d34f3deca703e17["hr-service-managementIconName"],
        iconDescription: $4459d2703ad50c55$export$7d34f3deca703e17["hr-service-managementIconDescription"],
        keyFeatures: [
            $4459d2703ad50c55$export$7d34f3deca703e17["hr-service-managementFeature-1"],
            $4459d2703ad50c55$export$7d34f3deca703e17["hr-service-managementFeature-2"]
        ]
    },
    "customer-service-management": {
        name: $4459d2703ad50c55$export$7d34f3deca703e17["customer-service-managementName"],
        oneLinerHeadline: $4459d2703ad50c55$export$7d34f3deca703e17["customer-service-managementOneLinerHeadline"],
        iconName: $4459d2703ad50c55$export$7d34f3deca703e17["customer-service-managementIconName"],
        iconDescription: $4459d2703ad50c55$export$7d34f3deca703e17["customer-service-managementIconDescription"],
        keyFeatures: [
            $4459d2703ad50c55$export$7d34f3deca703e17["customer-service-managementFeature-1"],
            $4459d2703ad50c55$export$7d34f3deca703e17["customer-service-managementFeature-2"]
        ]
    },
    "marketing-service-management": {
        name: $4459d2703ad50c55$export$7d34f3deca703e17["marketing-service-managementName"],
        oneLinerHeadline: $4459d2703ad50c55$export$7d34f3deca703e17["marketing-service-managementOneLinerHeadline"],
        iconName: $4459d2703ad50c55$export$7d34f3deca703e17["marketing-service-managementIconName"],
        iconDescription: $4459d2703ad50c55$export$7d34f3deca703e17["marketing-service-managementIconDescription"],
        keyFeatures: [
            $4459d2703ad50c55$export$7d34f3deca703e17["marketing-service-managementFeature-1"],
            $4459d2703ad50c55$export$7d34f3deca703e17["marketing-service-managementFeature-2"]
        ]
    },
    "design-service-management": {
        name: $4459d2703ad50c55$export$7d34f3deca703e17["design-service-managementName"],
        oneLinerHeadline: $4459d2703ad50c55$export$7d34f3deca703e17["design-service-managementOneLinerHeadline"],
        iconName: $4459d2703ad50c55$export$7d34f3deca703e17["design-service-managementIconName"],
        iconDescription: $4459d2703ad50c55$export$7d34f3deca703e17["design-service-managementIconDescription"],
        keyFeatures: [
            $4459d2703ad50c55$export$7d34f3deca703e17["design-service-managementFeature-1"],
            $4459d2703ad50c55$export$7d34f3deca703e17["design-service-managementFeature-2"]
        ]
    },
    "finance-service-management": {
        name: $4459d2703ad50c55$export$7d34f3deca703e17["finance-service-managementName"],
        oneLinerHeadline: $4459d2703ad50c55$export$7d34f3deca703e17["finance-service-managementOneLinerHeadline"],
        iconName: $4459d2703ad50c55$export$7d34f3deca703e17["finance-service-managementIconName"],
        iconDescription: $4459d2703ad50c55$export$7d34f3deca703e17["finance-service-managementIconDescription"],
        keyFeatures: [
            $4459d2703ad50c55$export$7d34f3deca703e17["finance-service-managementFeature-1"],
            $4459d2703ad50c55$export$7d34f3deca703e17["finance-service-managementFeature-2"]
        ]
    },
    "analytics-service-management": {
        name: $4459d2703ad50c55$export$7d34f3deca703e17["analytics-service-managementName"],
        oneLinerHeadline: $4459d2703ad50c55$export$7d34f3deca703e17["analytics-service-managementOneLinerHeadline"],
        iconName: $4459d2703ad50c55$export$7d34f3deca703e17["analytics-service-managementIconName"],
        iconDescription: $4459d2703ad50c55$export$7d34f3deca703e17["analytics-service-managementIconDescription"],
        keyFeatures: [
            $4459d2703ad50c55$export$7d34f3deca703e17["analytics-service-managementFeature-1"],
            $4459d2703ad50c55$export$7d34f3deca703e17["analytics-service-managementFeature-2"]
        ]
    },
    "facilities-service-management": {
        name: $4459d2703ad50c55$export$7d34f3deca703e17["facilities-service-managementName"],
        oneLinerHeadline: $4459d2703ad50c55$export$7d34f3deca703e17["facilities-service-managementOneLinerHeadline"],
        iconName: $4459d2703ad50c55$export$7d34f3deca703e17["facilities-service-managementIconName"],
        iconDescription: $4459d2703ad50c55$export$7d34f3deca703e17["facilities-service-managementIconDescription"],
        keyFeatures: [
            $4459d2703ad50c55$export$7d34f3deca703e17["facilities-service-managementFeature-1"],
            $4459d2703ad50c55$export$7d34f3deca703e17["facilities-service-managementFeature-2"]
        ]
    },
    "sales-service-management": {
        name: $4459d2703ad50c55$export$7d34f3deca703e17["sales-service-managementName"],
        oneLinerHeadline: $4459d2703ad50c55$export$7d34f3deca703e17["sales-service-managementOneLinerHeadline"],
        iconName: $4459d2703ad50c55$export$7d34f3deca703e17["sales-service-managementIconName"],
        iconDescription: $4459d2703ad50c55$export$7d34f3deca703e17["sales-service-managementIconDescription"],
        keyFeatures: [
            $4459d2703ad50c55$export$7d34f3deca703e17["sales-service-managementFeature-1"],
            $4459d2703ad50c55$export$7d34f3deca703e17["sales-service-managementFeature-2"]
        ]
    },
    "legal-service-management": {
        name: $4459d2703ad50c55$export$7d34f3deca703e17["legal-service-managementName"],
        oneLinerHeadline: $4459d2703ad50c55$export$7d34f3deca703e17["legal-service-managementOneLinerHeadline"],
        iconName: $4459d2703ad50c55$export$7d34f3deca703e17["legal-service-managementIconName"],
        iconDescription: $4459d2703ad50c55$export$7d34f3deca703e17["legal-service-managementIconDescription"],
        keyFeatures: [
            $4459d2703ad50c55$export$7d34f3deca703e17["legal-service-managementFeature-1"],
            $4459d2703ad50c55$export$7d34f3deca703e17["legal-service-managementFeature-2"]
        ]
    },
    "general-service-management": {
        name: $4459d2703ad50c55$export$7d34f3deca703e17["general-service-managementName"],
        oneLinerHeadline: $4459d2703ad50c55$export$7d34f3deca703e17["general-service-managementOneLinerHeadline"],
        iconName: $4459d2703ad50c55$export$7d34f3deca703e17["general-service-managementIconName"],
        iconDescription: $4459d2703ad50c55$export$7d34f3deca703e17["general-service-managementIconDescription"],
        keyFeatures: [
            $4459d2703ad50c55$export$7d34f3deca703e17["general-service-managementFeature-1"],
            $4459d2703ad50c55$export$7d34f3deca703e17["general-service-managementFeature-2"]
        ]
    }
};

});






parcelRegister("6c1Y0", function(module, exports) {

$parcel$export(module.exports, "LoomPricingPage", function () { return $1e95f3b47b7ff11f$export$1c056246c70ea895; });

var $loA2J = parcelRequire("loA2J");

var $dT5kE = parcelRequire("dT5kE");

var $hCXVx = parcelRequire("hCXVx");
const $1e95f3b47b7ff11f$export$1c056246c70ea895 = (props)=>{
    const { pricingContent: pricingContent, queryRef: queryRef } = props;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dT5kE.PricingContentContextProviderRelay), {
        productId: "loom",
        pricingContent: pricingContent,
        queryRef: queryRef,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hCXVx.LoomPricingPage), {})
    });
};

});
parcelRegister("hCXVx", function(module, exports) {

$parcel$export(module.exports, "LoomPricingPage", function () { return $ceb909be8a0294ec$export$1c056246c70ea895; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $83YdV = parcelRequire("83YdV");
parcelRequire("gUyvS");
var $khjAx = parcelRequire("khjAx");
parcelRequire("kmJhl");
var $bofgW = parcelRequire("bofgW");

var $dT5kE = parcelRequire("dT5kE");
parcelRequire("3XyMp");
var $f8O3L = parcelRequire("f8O3L");

var $ceE90 = parcelRequire("ceE90");

var $j1oGG = parcelRequire("j1oGG");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $68wZ4 = parcelRequire("68wZ4");

var $1FqEx = parcelRequire("1FqEx");

var $h7TOx = parcelRequire("h7TOx");

var $2uMOw = parcelRequire("2uMOw");

var $iE41P = parcelRequire("iE41P");
const $ceb909be8a0294ec$export$1c056246c70ea895 = (props)=>{
    var _content_callToActionContainer, _content_callToActionContainer1, _questionsCtaContent_asset;
    const { pricing: pricing, countryCode: countryCode } = props;
    const content = (0, $dT5kE.usePricingContentContext)();
    const featuresCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[1];
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer1 = content.callToActionContainer) === null || _content_callToActionContainer1 === void 0 ? void 0 : _content_callToActionContainer1[0];
    const intl = (0, $f6qj2.default)();
    const defaultQuestionsCtaHrefPath = (0, $iE41P.usePremiumSignupUrl)();
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _featuresCtaContent_text, _featuresCtaContent_url, _content_getMoreDetailsTitle, _content_additionalDetails, _questionsCtaContent_url, _questionsCtaContent_title, _questionsCtaContent_text, _questionsCtaContent_valueProposition;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $loA2J.jsx)((0, $68wZ4.default), {}),
        showFallback: content === null || content === void 0 ? void 0 : content.hasError,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1FqEx.ParentScrollTracking), {
            scrollTrackingEnabled: true,
            pageId: "loom-pricing-page",
            as: "main",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PageHeading), {
                    children: content === null || content === void 0 ? void 0 : content.headline
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $2uMOw.LoomPriceFinder), {
                    pricing: pricing,
                    countryCode: countryCode
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $h7TOx.LoomAiSection), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $khjAx.PricingFeatureTable), {
                    title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                    comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                    compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined,
                    linkValues: {
                        linkText: (_featuresCtaContent_text = featuresCtaContent === null || featuresCtaContent === void 0 ? void 0 : featuresCtaContent.text) !== null && _featuresCtaContent_text !== void 0 ? _featuresCtaContent_text : undefined,
                        linkHref: (_featuresCtaContent_url = featuresCtaContent === null || featuresCtaContent === void 0 ? void 0 : featuresCtaContent.url) !== null && _featuresCtaContent_url !== void 0 ? _featuresCtaContent_url : undefined
                    },
                    dataProductKey: "loom",
                    stickyCtasEnabled: false
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                    href: (0, $3FBn4.useLocalizedHref)("/teams/nonprofits/discount-pricing?tab=loom"),
                    text: intl.formatMessage({
                        id: "LoomPricingPage.educationDiscount",
                        defaultMessage: "Are you a teacher or a student? Take advantage of our Education discount"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $83YdV.TwcPromo), {
                        product: "loom"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $f8O3L.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1FqEx.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ceE90.PricingFaq), {
                            header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                            planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bofgW.QuestionsCta), {
                    product: "Loom",
                    ctaHref: (_questionsCtaContent_url = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.url) !== null && _questionsCtaContent_url !== void 0 ? _questionsCtaContent_url : defaultQuestionsCtaHrefPath,
                    questionsHeader: (_questionsCtaContent_title = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.title) !== null && _questionsCtaContent_title !== void 0 ? _questionsCtaContent_title : undefined,
                    priceAndLicensingLinkText: (_questionsCtaContent_text = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.text) !== null && _questionsCtaContent_text !== void 0 ? _questionsCtaContent_text : undefined,
                    questionsBody: (_questionsCtaContent_valueProposition = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.valueProposition) !== null && _questionsCtaContent_valueProposition !== void 0 ? _questionsCtaContent_valueProposition : undefined,
                    imageHref: questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : (_questionsCtaContent_asset = questionsCtaContent.asset) === null || _questionsCtaContent_asset === void 0 ? void 0 : _questionsCtaContent_asset.url
                })
            ]
        })
    });
};

});
parcelRegister("68wZ4", function(module, exports) {

$parcel$export(module.exports, "LoomNav", function () { return $5635adddc28602a5$export$e9541932877c1f74; });
$parcel$export(module.exports, "default", function () { return $5635adddc28602a5$export$2e2bcd8739ae039; });
/* loom-navbar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $5ifyY = parcelRequire("5ifyY");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $3XIdt = parcelRequire("3XIdt");

var $hbBKK = parcelRequire("hbBKK");

var $gAJUc = parcelRequire("gAJUc");

var $eyheK = parcelRequire("eyheK");

var $g0Zvb = parcelRequire("g0Zvb");
const $5635adddc28602a5$var$wrapSubnav = (subnav)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hbBKK.DivOnHoverExit), {
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3XIdt.MotionContainer), {
                direction: "none",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1rjc1jfw _18zr1jfw"
                    ]),
                    children: subnav
                })
            })
        })
    });
};
const $5635adddc28602a5$var$LoomLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "loomcircular",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $5ifyY.LoomAttributionLogo), {
        appearance: "brand"
    });
};
const $5635adddc28602a5$export$e9541932877c1f74 = ()=>{
    const intl = (0, $f6qj2.default)();
    const dropdownStyles = (0, $iSvIT.useMemo)(()=>{
        return {
            width: "fit-content !important",
            margin: 0,
            insetBlockStart: "4.25rem",
            transform: "translateX(-25%)"
        };
    }, []);
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=loom&edition=premium");
    const resourcesHref = (0, $3FBn4.useLocalizedHref)("/software/loom/resources");
    const pricingHref = (0, $3FBn4.useLocalizedHref)("/software/loom/pricing");
    const desktopLinks = [
        {
            globalLinksKey: "features",
            productKey: "loom",
            linkText: intl.formatMessage({
                id: "LoomPageTemplate.navbar.features",
                defaultMessage: "Features"
            }),
            hasSubnav: true,
            content: $5635adddc28602a5$var$wrapSubnav(/*#__PURE__*/ (0, $loA2J.jsx)((0, $eyheK.LoomFeaturesSubnav), {})),
            containerPosition: "relative"
        },
        {
            globalLinksKey: "solutions",
            productKey: "loom",
            linkText: intl.formatMessage({
                id: "LoomPageTemplate.navbar.resources",
                defaultMessage: "Solutions"
            }),
            hasSubnav: true,
            containerStyles: dropdownStyles,
            content: $5635adddc28602a5$var$wrapSubnav(/*#__PURE__*/ (0, $loA2J.jsx)((0, $g0Zvb.LoomSolutionsSubnav), {})),
            containerPosition: "relative"
        },
        {
            globalLinksKey: "resources",
            productKey: "loom",
            linkText: intl.formatMessage({
                id: "LoomPageTemplate.navbar.useCases",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            href: resourcesHref
        },
        {
            globalLinksKey: "pricing",
            productKey: "loom",
            linkText: intl.formatMessage({
                id: "LoomPageTemplate.navbar.pricing",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            href: pricingHref
        }
    ];
    const mobileLinks = [
        ...desktopLinks.map((link)=>({
                globalLinksKey: link.globalLinksKey,
                productKey: link.productKey,
                linkText: link.linkText,
                hasSubnav: link.hasSubnav,
                href: link.href,
                dropdownType: link.globalLinksKey
            }))
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
        productKey: "loom",
        productLogoUrl: "/software/loom",
        productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($5635adddc28602a5$var$LoomLogoComponent, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: "LoomPageTemplate.navbar.loom-logo",
            defaultMessage: "Loom logo"
        }),
        mobileCtaText: intl.formatMessage({
            id: "LoomPageTemplate.navbar.getitfree",
            defaultMessage: "Get it Free"
        }),
        navigationTrynowCtaText: intl.formatMessage({
            id: "LoomPageTemplate.navbar.getitfree",
            defaultMessage: "Get it Free"
        }),
        mobileCtaUrl: signupLink,
        mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($5635adddc28602a5$var$LoomLogoComponent, {}),
        productPageNavLinks: desktopLinks,
        navigationTrynowCtaUrl: signupLink,
        mobileLinksSections: [
            {
                mobileLinkKey: "mobile-loom",
                mobileLinksProps: mobileLinks
            }
        ],
        additionalMenuPageObjectsArray: [
            {
                menuPageKey: "features",
                menuPageObjects: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eyheK.LoomFeaturesSubnav), {})
            },
            {
                menuPageKey: "solutions",
                menuPageObjects: /*#__PURE__*/ (0, $loA2J.jsx)((0, $g0Zvb.LoomSolutionsSubnav), {})
            }
        ]
    });
};
var $5635adddc28602a5$export$2e2bcd8739ae039 = $5635adddc28602a5$export$e9541932877c1f74;

});
parcelRegister("5ifyY", function(module, exports) {

$parcel$export(module.exports, "LoomAttributionLogo", function () { return $3daab4b4ef34ab49$export$6e87ce8d41eda665; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $3daab4b4ef34ab49$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsForLoom)(appearance, colorMode);
    return '<svg\n		fill="none"\n		height="32"\n		xmlns="http://www.w3.org/2000/svg"\n		focusable="false"\n		aria-hidden="true"\n		viewBox="0 0 88 32"\n	>\n		<path\n			d="M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058"\n			fill="'.concat(colors.iconColor, '"\n		/>\n		<path\n			d="M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z"\n			fill="').concat(colors.textColor, '"\n		/>\n	</svg>');
};
var $3daab4b4ef34ab49$export$6e87ce8d41eda665 = function LoomAttributionLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Loom Attribution" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $3daab4b4ef34ab49$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("eyheK", function(module, exports) {

$parcel$export(module.exports, "LoomFeaturesSubnav", function () { return $e075e9345b3455b3$export$a7a6399eaf95e9b8; });
/* features-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $6x1qA = parcelRequire("6x1qA");
var $f6qj2 = parcelRequire("f6qj2");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $jGfor = parcelRequire("jGfor");
const $e075e9345b3455b3$export$a7a6399eaf95e9b8 = ()=>{
    const intl = (0, $f6qj2.default)();
    const productKey = "loom";
    const loomLinks = {
        features: {
            id: "features",
            title: (0, $6x1qA.defineMessage)({
                id: "bitbucketnav.subnav.loomFeatures.links.features",
                defaultMessage: "Explore Features"
            }),
            items: [
                {
                    id: "meeting-notes",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.meeting-notes",
                        defaultMessage: "Meeting Notes"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/ai-meeting")
                },
                {
                    id: "screen-recorder",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.screen-recorder",
                        defaultMessage: "Screen Recorder"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/screen-recorder")
                },
                {
                    id: "screenshots",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.screenshots",
                        defaultMessage: "Screenshots"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/screenshot")
                },
                {
                    id: "loom-ai",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.loom-ai",
                        defaultMessage: "Loom AI"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/ai")
                },
                {
                    id: "editing",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.editing",
                        defaultMessage: "Editing"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/editing")
                }
            ]
        }
    };
    const linkColumns = Object.values(loomLinks);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: linkColumns.map((column)=>{
            return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jGfor.LinkColumn), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: (0, $esG4f.default)([
                            "_1p1dangw _syazmt5y _1wyboqnp _ect4bzd7 _k48p1fw0 _vwz41j6v"
                        ]),
                        style: {
                            "--_1ex89o1": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark0")),
                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                        },
                        children: intl.formatMessage(column.title)
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c11p5 _umai1ylp"
                        ]),
                        children: column.items.map((link)=>{
                            return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_bpsp1nn1 _19tboxwj _43dsmt5y _qfs11r31 _s41oglyw _1k6pnqa1 _1caymt5y _1e0c1txw _4cvrh9n0"
                                ]),
                                style: {
                                    "--_1ex89o1": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark0"))
                                },
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                    type: "anchor",
                                    href: link.href,
                                    text: intl.formatMessage(link.text),
                                    ariaLabel: intl.formatMessage(link.text),
                                    dataEventProps: {
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "globalNavSubnav",
                                        "data-product-key": productKey
                                    }
                                })
                            }, link.id);
                        })
                    })
                ]
            }, column.id);
        })
    });
};

});

parcelRegister("g0Zvb", function(module, exports) {

$parcel$export(module.exports, "LoomSolutionsSubnav", function () { return $1f685d7846ca643c$export$e7b21fd28cd3f276; });
/* solutions-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $6x1qA = parcelRequire("6x1qA");
var $f6qj2 = parcelRequire("f6qj2");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $3XIdt = parcelRequire("3XIdt");

var $baj2f = parcelRequire("baj2f");

var $jGfor = parcelRequire("jGfor");

var $hbBKK = parcelRequire("hbBKK");
function $1f685d7846ca643c$var$useLoomSolutionsLinks() {
    return {
        features: {
            id: "teams",
            title: (0, $6x1qA.defineMessage)({
                id: "loom-product-nav.solutions.links.solution",
                defaultMessage: "Teams"
            }),
            items: [
                {
                    id: "sales",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.solutions.links.sales",
                        defaultMessage: "Sales"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/use-case/sales")
                },
                {
                    id: "marketing",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.solutions.links.marketing",
                        defaultMessage: "Marketing"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/use-case/marketing")
                },
                {
                    id: "design",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.solutions.links.design",
                        defaultMessage: "Design"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/use-case/design")
                },
                {
                    id: "support",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.solutions.links.support",
                        defaultMessage: "Support"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/use-case/support")
                },
                {
                    id: "productmanagement",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.solutions.links.product-management",
                        defaultMessage: "Product Management"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/use-case/product-management")
                },
                {
                    id: "engineering",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.solutions.links.engineering",
                        defaultMessage: "Engineering"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/use-case/engineering")
                }
            ]
        },
        usecases: {
            id: "usecases",
            title: (0, $6x1qA.defineMessage)({
                id: "loom-product-nav.solutions.links.use-cases",
                defaultMessage: "Use cases"
            }),
            items: [
                {
                    id: "loom-jira",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.solutions.links.loom-jira",
                        defaultMessage: "Loom + Jira"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/loom-jira")
                },
                {
                    id: "loom-confluence",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.solutions.links.loom-confluence",
                        defaultMessage: "Loom + Confluence"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/loom-confluence")
                }
            ]
        },
        companysize: {
            id: "companysize",
            title: (0, $6x1qA.defineMessage)({
                id: "loom-product-nav.solutions.links.company-size",
                defaultMessage: "Company Size"
            }),
            items: [
                {
                    id: "enterprise",
                    text: (0, $6x1qA.defineMessage)({
                        id: "loom-product-nav.solutions.links.enterprise",
                        defaultMessage: "Enterprise"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/loom/enterprise")
                }
            ]
        }
    };
}
const $1f685d7846ca643c$export$e7b21fd28cd3f276 = ({ productKey: productKey = "loom" })=>{
    const intl = (0, $f6qj2.default)();
    const loomSolutionLinks = $1f685d7846ca643c$var$useLoomSolutionsLinks();
    const linkColumns = Object.values(loomSolutionLinks);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hbBKK.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3XIdt.MotionContainer), {
                direction: "up",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_bfhkcd5j _fn1q1txw _12nx1bp4 _196i1ylp"
                    ]),
                    style: {
                        "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $baj2f.RowGrid), {
                        numCols: 3,
                        columnGap: "var(--ds-space-500, 40px)",
                        children: linkColumns.map((column)=>{
                            return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jGfor.LinkColumn), {
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        className: (0, $esG4f.default)([
                                            "_1p1dangw _syaz1hlo _1wyboqnp _ect4bzd7 _k48p1fw0 _vwz41j6v"
                                        ]),
                                        style: {
                                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                        },
                                        children: intl.formatMessage(column.title)
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c11p5 _umai1ylp"
                                        ]),
                                        children: column.items.map((link)=>{
                                            return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_bpsp1nn1 _19tboxwj _43ds1hlo _qfs11r31 _s41oglyw _1k6pnqa1 _1cay1hlo _oavv1ep1 _oxk41ep1 _1e0c1txw _4cvrh9n0"
                                                ]),
                                                style: {
                                                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                                    "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
                                                },
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                                    type: "anchor",
                                                    href: link.href,
                                                    text: intl.formatMessage(link.text),
                                                    ariaLabel: intl.formatMessage(link.text),
                                                    dataEventProps: {
                                                        "data-event": "clicked",
                                                        "data-event-component": "linkButton",
                                                        "data-event-container": "globalNavSubnav",
                                                        "data-product-key": productKey
                                                    }
                                                })
                                            }, link.id);
                                        })
                                    })
                                ]
                            }, column.id);
                        })
                    })
                })
            })
        })
    });
};

});


parcelRegister("h7TOx", function(module, exports) {

$parcel$export(module.exports, "LoomAiSection", function () { return $5422749ea7549c53$export$7b95013d8cafda1; });
/* loom-ai-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $8xSOc = parcelRequire("8xSOc");

var $bhreu = parcelRequire("bhreu");

var $dT5kE = parcelRequire("dT5kE");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");

var $iE41P = parcelRequire("iE41P");
const $5422749ea7549c53$export$7b95013d8cafda1 = ()=>{
    var _context_datacenterPlans, _loomAiContent_microCta_, _loomAiContent_microCta, _loomAiContent_highlightedFeaturesContainer;
    const context = (0, $dT5kE.usePricingContentContext)();
    const loomAiContent = context === null || context === void 0 ? void 0 : (_context_datacenterPlans = context.datacenterPlans) === null || _context_datacenterPlans === void 0 ? void 0 : _context_datacenterPlans[0];
    const ctaContent = (loomAiContent === null || loomAiContent === void 0 ? void 0 : (_loomAiContent_microCta = loomAiContent.microCta) === null || _loomAiContent_microCta === void 0 ? void 0 : (_loomAiContent_microCta_ = _loomAiContent_microCta[0]) === null || _loomAiContent_microCta_ === void 0 ? void 0 : _loomAiContent_microCta_.__typename) === "ContentPlatformCallToActionMicrocopy" ? loomAiContent.microCta[0] : undefined;
    var _loomAiContent_planOneLiner;
    const textParagraph = (_loomAiContent_planOneLiner = loomAiContent === null || loomAiContent === void 0 ? void 0 : loomAiContent.planOneLiner) !== null && _loomAiContent_planOneLiner !== void 0 ? _loomAiContent_planOneLiner : "";
    const textBullets = loomAiContent === null || loomAiContent === void 0 ? void 0 : (_loomAiContent_highlightedFeaturesContainer = loomAiContent.highlightedFeaturesContainer) === null || _loomAiContent_highlightedFeaturesContainer === void 0 ? void 0 : _loomAiContent_highlightedFeaturesContainer.map((highlightedFeature)=>{
        return {
            text: highlightedFeature === null || highlightedFeature === void 0 ? void 0 : highlightedFeature.highlightedFeatureTitleExternal,
            callOut: highlightedFeature === null || highlightedFeature === void 0 ? void 0 : highlightedFeature.callOut
        };
    });
    const zeroMarginCss = null;
    const defaultPremiumSignupUrl = (0, $iE41P.usePremiumSignupUrl)();
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
            layout: "6-6",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/07v5f6mik43gk4jga0367a2x5qn64vbp.webp",
                        alt: intl.formatMessage({
                            id: "LoomPricingPage.LoomAiSection.meetingGraphicAltText",
                            defaultMessage: "Example graphic of using Loom AI for meetings"
                        })
                    },
                    style: {
                        width: "100%",
                        height: "auto"
                    }
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _2lx2vrvc _4cvr1y6m _zulp1b66"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                    className: (0, $esG4f.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                    ]),
                                    children: loomAiContent === null || loomAiContent === void 0 ? void 0 : loomAiContent.planTitleExternal
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                    image: {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/y42547423ap63hd11cr1832n3n455pt5.webp",
                                        alt: ""
                                    },
                                    style: {
                                        width: "100%",
                                        height: "27px",
                                        position: "relative",
                                        insetBlockStart: "var(--ds-space-050, 4px)"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: (0, $esG4f.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                            ]),
                            children: textParagraph
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                            className: (0, $esG4f.default)([
                                "_6rthpxbi"
                            ]),
                            children: textBullets === null || textBullets === void 0 ? void 0 : textBullets.map((bullet)=>{
                                return /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                    className: (0, $esG4f.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("li", {
                                        children: [
                                            bullet.text,
                                            bullet.callOut && /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                className: (0, $esG4f.default)([
                                                    "_ahbq1b66"
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                                                    children: bullet.callOut
                                                })
                                            })
                                        ]
                                    })
                                }, bullet.text);
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
                            href: (ctaContent === null || ctaContent === void 0 ? void 0 : ctaContent.ctaUrl) || defaultPremiumSignupUrl,
                            size: "small",
                            children: (ctaContent === null || ctaContent === void 0 ? void 0 : ctaContent.ctaButtonText) || intl.formatMessage({
                                id: "LoomAiSection.ctaButtonText",
                                defaultMessage: "Try for free"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("iE41P", function(module, exports) {

$parcel$export(module.exports, "SIGNUP_URL_QUERY_PREMIUM", function () { return $54be68f0c66a9947$export$ff7054db20c33aeb; });
$parcel$export(module.exports, "usePremiumSignupUrl", function () { return $54be68f0c66a9947$export$aa185ad968f4b15f; });

var $3FBn4 = parcelRequire("3FBn4");
const $54be68f0c66a9947$export$ff7054db20c33aeb = "?bundle=loom&edition=premium";
const $54be68f0c66a9947$export$aa185ad968f4b15f = ()=>(0, $3FBn4.useLocalizedHref)(`/try/cloud/signup${$54be68f0c66a9947$export$ff7054db20c33aeb}`);

});


parcelRegister("2uMOw", function(module, exports) {

$parcel$export(module.exports, "LoomPriceFinder", function () { return $3778d3651a6422e5$export$4377a557bebc94dd; });
// @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $6x1qA = parcelRequire("6x1qA");
var $dFnC9 = parcelRequire("dFnC9");

var $1Z9Q6 = parcelRequire("1Z9Q6");

var $7OWgU = parcelRequire("7OWgU");

var $l9lQF = parcelRequire("l9lQF");

var $esRX2 = parcelRequire("esRX2");

var $dT5kE = parcelRequire("dT5kE");

var $3FBn4 = parcelRequire("3FBn4");

var $9RWec = parcelRequire("9RWec");

var $iE41P = parcelRequire("iE41P");
const $3778d3651a6422e5$export$4377a557bebc94dd = (props)=>{
    var _content_free, _content_standard, _content_premium, _content_enterprise, _props_pricing_ccpPricingData, _props_pricing;
    const content = {
        free: (0, $dT5kE.usePricingPlanComparison)("Starter"),
        standard: (0, $dT5kE.usePricingPlanComparison)("Business"),
        premium: (0, $dT5kE.usePricingPlanComparison)("Business + AI"),
        enterprise: (0, $dT5kE.usePricingPlanComparison)("Enterprise")
    };
    const freePlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "free");
    const standardPlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "standard");
    const premiumPlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "premium");
    const enterprisePlanFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "enterprise");
    var _content_free_planOneLiner, _content_standard_planOneLiner, _content_premium_planOneLiner, _content_enterprise_planOneLiner;
    const loomProductPlans = [
        {
            planName: "Starter",
            offeringSku: "loom-free-sku",
            recommendationLimit: Infinity,
            signupLimit: 50000,
            planFeatureMessages: freePlanFeatureMessages,
            description: (_content_free_planOneLiner = (_content_free = content.free) === null || _content_free === void 0 ? void 0 : _content_free.planOneLiner) !== null && _content_free_planOneLiner !== void 0 ? _content_free_planOneLiner : "",
            signupURLSuffix: (0, $iE41P.SIGNUP_URL_QUERY_PREMIUM)
        },
        {
            planName: "Business",
            offeringSku: "loom-business-sku",
            recommendationLimit: Infinity,
            signupLimit: 50000,
            planFeatureMessages: standardPlanFeatureMessages,
            description: (_content_standard_planOneLiner = (_content_standard = content.standard) === null || _content_standard === void 0 ? void 0 : _content_standard.planOneLiner) !== null && _content_standard_planOneLiner !== void 0 ? _content_standard_planOneLiner : "",
            signupURLSuffix: (0, $iE41P.SIGNUP_URL_QUERY_PREMIUM)
        },
        {
            planName: "Business + AI",
            planTitleComponent: (0, $9RWec.LoomAiTitle),
            offeringSku: "loom-business-ai-sku",
            recommendationLimit: 0,
            signupLimit: 50000,
            planFeatureMessages: premiumPlanFeatureMessages,
            description: (_content_premium_planOneLiner = (_content_premium = content.premium) === null || _content_premium === void 0 ? void 0 : _content_premium.planOneLiner) !== null && _content_premium_planOneLiner !== void 0 ? _content_premium_planOneLiner : "",
            signupURLSuffix: (0, $iE41P.SIGNUP_URL_QUERY_PREMIUM)
        },
        {
            planName: "Enterprise",
            offeringSku: "loom-enterprise-sku",
            recommendationLimit: Infinity,
            signupLimit: 50000,
            planFeatureMessages: enterprisePlanFeatureMessages,
            description: (_content_enterprise_planOneLiner = (_content_enterprise = content.enterprise) === null || _content_enterprise === void 0 ? void 0 : _content_enterprise.planOneLiner) !== null && _content_enterprise_planOneLiner !== void 0 ? _content_enterprise_planOneLiner : ""
        }
    ];
    let cardEnterpriseBodyOverride = /*#__PURE__*/ (0, $loA2J.jsx)("div", {});
    const locale = (0, $3FBn4.useLocale)();
    if (locale === "en") cardEnterpriseBodyOverride = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1Z9Q6.ContentText), {
        variant: "xl",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "LoomPriceFinderTeam25.cardEnterpriseBodyOverride",
            defaultMessage: "Let's talk"
        })
    });
    const messages = (0, $6x1qA.defineMessages)({
        unitCountInputTextRedesign: {
            id: "LoomPriceFinderTeam25.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputTerm: {
            id: "LoomPriceFinderTeam25.unitCountInputTerm",
            defaultMessage: "users"
        },
        billingCycleText: {
            id: "LoomPriceFinderTeam25.billingCycleText",
            defaultMessage: "Billing cycle:"
        },
        cardOverSignupLimit: {
            id: "LoomPriceFinderTeam25.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "LoomPriceFinderTeam25.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "LoomPriceFinderTeam25.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "LoomPricingPage.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        },
        cardEnterpriseBodyOverride: // @ts-ignore
        cardEnterpriseBodyOverride
    });
    const recommendationElement = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "LoomPriceFinderTeam25.recommendationElement",
        defaultMessage: "Most popular"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $l9lQF.PriceFinderContextProvider), {
            dataProductKey: "loom",
            productPlans: loomProductPlans,
            defaultUnitCount: 100,
            shouldAddDiscount: props.shouldAddDiscount,
            annualUserTierDisplayThreshold: 26,
            recommendationElement: recommendationElement,
            ctaUrlSource: props.ctaUrlSource,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OWgU.default), {
                messages: messages,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.loom,
                countryCode: props.countryCode
            })
        })
    });
};
$3778d3651a6422e5$export$4377a557bebc94dd.displayName = "LoomPriceFinder";

});
parcelRegister("9RWec", function(module, exports) {

$parcel$export(module.exports, "LoomAiTitle", function () { return $a29d940a2564b0d3$export$930d845fa234c9bc; });

var $loA2J = parcelRequire("loA2J");

var $kwHar = parcelRequire("kwHar");

var $bhreu = parcelRequire("bhreu");
const $a29d940a2564b0d3$export$930d845fa234c9bc = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
        id: `pricing-plan-title-${props.planName}`,
        children: [
            props.planName,
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/y42547423ap63hd11cr1832n3n455pt5.webp",
                    alt: ""
                },
                style: {
                    height: "17px",
                    width: "17px",
                    position: "relative",
                    insetInlineStart: (0, $kwHar.default)("space.025"),
                    insetBlockEnd: (0, $kwHar.default)("space.050")
                }
            })
        ]
    });
};

});




parcelRegister("7Nopm", function(module, exports) {

$parcel$export(module.exports, "SoftwareRovoPricingPage", function () { return $7f0e95e6fe8bc165$export$28b640e1f1ca7dbf; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $dT5kE = parcelRequire("dT5kE");
parcelRequire("h5MDW");
var $7yMZW = parcelRequire("7yMZW");
const $7f0e95e6fe8bc165$export$28b640e1f1ca7dbf = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": "rovo-pricing-page",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dT5kE.PricingContentContextProviderRelay), {
            productId: "rovo",
            pricingContent: props.pricingContent,
            queryRef: props.queryRef,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7yMZW.SoftwareRovoPricingPageTemplate), (0, $7Knp0._)({}, props))
        })
    });
};

});
parcelRegister("h5MDW", function(module, exports) {
$parcel$export(module.exports, "SoftwareRovoPricingPageTemplate", function () { return (parcelRequire("7yMZW")).SoftwareRovoPricingPageTemplate; });

var $7yMZW = parcelRequire("7yMZW");

});
parcelRegister("7yMZW", function(module, exports) {

$parcel$export(module.exports, "SoftwareRovoPricingPageTemplate", function () { return $ccdb88d414a80ebb$export$b59f422a2cd6b675; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");
parcelRequire("gUyvS");
var $khjAx = parcelRequire("khjAx");

var $dT5kE = parcelRequire("dT5kE");
parcelRequire("3XyMp");
var $f8O3L = parcelRequire("f8O3L");

var $ceE90 = parcelRequire("ceE90");

var $j1oGG = parcelRequire("j1oGG");

var $g99nl = parcelRequire("g99nl");

var $1FqEx = parcelRequire("1FqEx");

var $kK3gA = parcelRequire("kK3gA");

var $67lRy = parcelRequire("67lRy");
const $ccdb88d414a80ebb$export$b59f422a2cd6b675 = (props)=>{
    const content = (0, $dT5kE.usePricingContentContext)();
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _content_getMoreDetailsTitle, _content_additionalDetails;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $loA2J.jsx)((0, $g99nl.RovoNav), {}),
        showFallback: content === null || content === void 0 ? void 0 : content.hasError,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1FqEx.ParentScrollTracking), {
            pageId: "rovo-pricing-page",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PageHeading), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        id: "rovo",
                        children: content === null || content === void 0 ? void 0 : content.headline
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $kK3gA.RovoPriceFinder), (0, $7Knp0._)({}, props)),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $khjAx.PricingFeatureTable), {
                    title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                    comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                    compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $f8O3L.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1FqEx.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ceE90.PricingFaq), {
                            header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                            planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $67lRy.RovoQuestionsCta), {})
            ]
        })
    });
};

});
parcelRegister("g99nl", function(module, exports) {

$parcel$export(module.exports, "RovoNav", function () { return $5298b6428dc92303$export$f7b51e35c95f667c; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $bQiYD = parcelRequire("bQiYD");

var $dyZbY = parcelRequire("dyZbY");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $9g0oR = parcelRequire("9g0oR");

var $gAJUc = parcelRequire("gAJUc");

var $5wOn9 = parcelRequire("5wOn9");
const $5298b6428dc92303$export$f7b51e35c95f667c = ()=>{
    var _userSegments_UserSegmentTypes_OWNED_PRODUCTS;
    const intl = (0, $f6qj2.default)();
    const navLinks = [
        {
            globalLinksKey: "features",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.features",
                defaultMessage: "Features"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $3FBn4.useLocalizedHref)("/software/rovo/features")
        },
        {
            globalLinksKey: "connectors",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.connectors",
                defaultMessage: "Connectors"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $3FBn4.useLocalizedHref)("/software/rovo/connectors")
        },
        {
            globalLinksKey: "use-cases",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.use-cases",
                defaultMessage: "Use cases"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $3FBn4.useLocalizedHref)("/software/rovo/use-cases")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: true,
            productKey: "rovo",
            containerPosition: "relative",
            content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9g0oR.DropdownContent), {
                orientation: "column",
                contentSections: [
                    {
                        links: [
                            {
                                text: intl.formatMessage({
                                    id: "RovoPageTemplate.navbar.resources.ai-adoption-resources",
                                    defaultMessage: "AI adoption resources"
                                }),
                                href: (0, $3FBn4.useLocalizedHref)("http://community.atlassian.com/learning/hub/rovo")
                            },
                            {
                                text: intl.formatMessage({
                                    id: "RovoPageTemplate.navbar.resources.admin-onboarding",
                                    defaultMessage: "Admin onboarding"
                                }),
                                href: (0, $3FBn4.useLocalizedHref)("/software/rovo/guides/admin-guide")
                            },
                            {
                                text: intl.formatMessage({
                                    id: "RovoPageTemplate.navbar.resources.end-user-onboarding",
                                    defaultMessage: "End-user onboarding"
                                }),
                                href: (0, $3FBn4.useLocalizedHref)("/software/rovo/guides/end-user-guide")
                            }
                        ]
                    }
                ]
            })
        },
        {
            globalLinksKey: "licensing",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.licensing",
                defaultMessage: "Licensing"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $3FBn4.useLocalizedHref)("/licensing/rovo")
        }
    ];
    const { isUserLoggedIn: isUserLoggedIn, requestInProgress: requestInProgress } = (0, $5wOn9.useLoggedInUser)();
    const isRovoCtasEnabled = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp8011RovoProductTour);
    const { data: userSegments } = (0, $bQiYD.useUserSegments)();
    const isRovoInPlanList = userSegments === null || userSegments === void 0 ? void 0 : (_userSegments_UserSegmentTypes_OWNED_PRODUCTS = userSegments[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS]) === null || _userSegments_UserSegmentTypes_OWNED_PRODUCTS === void 0 ? void 0 : _userSegments_UserSegmentTypes_OWNED_PRODUCTS.includes("rovo.ondemand");
    const defaultCTAUrl = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=teamwork-collection&primaryCollectionProduct=rovo.ondemand&edition=premium");
    const isUserLoggedInAndCtasEnabledAndInPlan = isUserLoggedIn && isRovoCtasEnabled && isRovoInPlanList;
    const ctaText = isUserLoggedInAndCtasEnabledAndInPlan ? intl.formatMessage({
        id: "RovoPageTemplate.navbar.cta.try-rovo",
        defaultMessage: "Try Rovo"
    }) : isRovoCtasEnabled ? intl.formatMessage({
        id: "RovoPageTemplate.navbar.cta.get-rovo",
        defaultMessage: "Get Rovo"
    }) : undefined;
    const tryNowCTAUrl = isUserLoggedInAndCtasEnabledAndInPlan ? "https://home.atlassian.com/chat" : isRovoCtasEnabled ? defaultCTAUrl : undefined;
    const isShowTryNowLink = !requestInProgress && tryNowCTAUrl && ctaText ? true : false;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "RovoNav",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
            productLogoUrl: "/software/rovo",
            productLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
                brand: "rovo",
                type: "logo",
                appearance: "brand"
            }),
            productLogoAriaLabel: intl.formatMessage({
                id: "RovoPageTemplate.navbar.rovo-logo",
                defaultMessage: "Rovo logo"
            }),
            mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
                brand: "rovo",
                type: "logo",
                appearance: "brand"
            }),
            isShowTryNowLink: isShowTryNowLink,
            isIncludeMobileCTA: isShowTryNowLink,
            navigationTrynowCtaText: isShowTryNowLink ? ctaText : undefined,
            navigationTrynowCtaUrl: isShowTryNowLink ? tryNowCTAUrl : undefined,
            mobileCtaText: isShowTryNowLink ? ctaText : undefined,
            mobileCtaUrl: isShowTryNowLink ? tryNowCTAUrl : undefined,
            productPageNavLinks: navLinks,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-rovo",
                    mobileLinksProps: navLinks
                }
            ]
        })
    });
};

});

parcelRegister("kK3gA", function(module, exports) {

$parcel$export(module.exports, "RovoPriceFinder", function () { return $d71f78e860ad984c$export$dc441f522034d071; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $6x1qA = parcelRequire("6x1qA");

var $7OWgU = parcelRequire("7OWgU");

var $l9lQF = parcelRequire("l9lQF");

var $esRX2 = parcelRequire("esRX2");

var $dT5kE = parcelRequire("dT5kE");
const $d71f78e860ad984c$export$dc441f522034d071 = (props)=>{
    var _props_pricing_ccpPricingData, _props_pricing;
    const content = {
        standard: (0, $dT5kE.usePricingPlanComparison)("Rovo")
    };
    const planFeatureMessages = (0, $esRX2.createPlanFeatureMessages)(content, "standard");
    const rovoProductPlans = [
        {
            planName: "Standard",
            offeringSku: "rovo-org-purchase-sku",
            recommendationLimit: 100000,
            signupLimit: 35000,
            signupURLInfo: {
                urlDomain: window.location.origin,
                urlPath: "/software/rovo/start",
                shouldLocalize: true
            },
            planFeatureMessages: planFeatureMessages
        }
    ];
    const messages = (0, $6x1qA.defineMessages)({
        unitCountInputTextRedesign: {
            id: "RovoSoftwarePricingPage.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputTerm: {
            id: "RovoSoftwarePricingPage.priceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        cardOverSignupLimit: {
            id: "RovoSoftwarePricingPage.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "RovoSoftwarePricingPage.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "RovoSoftwarePricingPage.priceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "RovoSoftwarePricingPageTeam24.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        }
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $l9lQF.PriceFinderContextProvider), {
            dataProductKey: "rovo",
            productPlans: rovoProductPlans,
            defaultUnitCount: 375,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OWgU.default), (0, $7Knp0._)({
                messages: messages,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.rovo,
                countryCode: props.countryCode
            }, props))
        })
    });
};
$d71f78e860ad984c$export$dc441f522034d071.displayName = "RovoPriceFinderSection";

});

parcelRegister("67lRy", function(module, exports) {

$parcel$export(module.exports, "RovoQuestionsCta", function () { return $13c9273194812f0b$export$c1392586038e7a93; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("kmJhl");
var $bofgW = parcelRequire("bofgW");

var $dT5kE = parcelRequire("dT5kE");

var $3FBn4 = parcelRequire("3FBn4");
const $13c9273194812f0b$export$c1392586038e7a93 = ()=>{
    var _content_callToActionContainer, _questionsCtaContent_asset;
    const content = (0, $dT5kE.usePricingContentContext)();
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[0];
    const locale = (0, $3FBn4.useLocale)();
    const questionsCtaHref = `https://support.atlassian.com${(0, $3FBn4.getLocalizedHref)({
        locale: locale,
        href: "/subscriptions-and-billing/docs/managing-your-bill-for-rovo/",
        supportedLocales: (0, $3FBn4.ATLASSIAN_SUPPORT_CENTER_SUPPORTED_LOCALES)
    })}`;
    var _questionsCtaContent_url, _questionsCtaContent_title, _questionsCtaContent_text, _questionsCtaContent_valueProposition;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bofgW.QuestionsCta), {
        product: "Rovo",
        ctaHref: (_questionsCtaContent_url = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.url) !== null && _questionsCtaContent_url !== void 0 ? _questionsCtaContent_url : questionsCtaHref,
        questionsHeader: (_questionsCtaContent_title = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.title) !== null && _questionsCtaContent_title !== void 0 ? _questionsCtaContent_title : undefined,
        priceAndLicensingLinkText: (_questionsCtaContent_text = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.text) !== null && _questionsCtaContent_text !== void 0 ? _questionsCtaContent_text : undefined,
        questionsBody: (_questionsCtaContent_valueProposition = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.valueProposition) !== null && _questionsCtaContent_valueProposition !== void 0 ? _questionsCtaContent_valueProposition : undefined,
        imageHref: questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : (_questionsCtaContent_asset = questionsCtaContent.asset) === null || _questionsCtaContent_asset === void 0 ? void 0 : _questionsCtaContent_asset.url
    });
};
$13c9273194812f0b$export$c1392586038e7a93.displayName = "RovoQuestionsCtaSection";

});




parcelRegister("1KLms", function(module, exports) {

$parcel$export(module.exports, "SoftwareRovoStartPage", function () { return $c557b94eb5177315$export$7b3d03c2fa269586; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $fxdfZ = parcelRequire("fxdfZ");
parcelRequire("2zn7e");
var $jnZak = parcelRequire("jnZak");

var $63FK4 = parcelRequire("63FK4");
const $c557b94eb5177315$export$7b3d03c2fa269586 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const handleOnError = (0, $iSvIT.useCallback)((error)=>{
        createAnalyticsEvent({
            action: "failed",
            eventType: "track",
            actionSubject: "SoftwareRovoStartPage",
            source: "SoftwareRovoStartPage",
            attributes: {
                error: error.message
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fxdfZ.default), {
        fallback: /*#__PURE__*/ (0, $loA2J.jsx)((0, $63FK4.ErrorScreen), {}),
        onError: handleOnError,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jnZak.SoftwareRovoStartPageTemplate), {})
    });
};

});
parcelRegister("2zn7e", function(module, exports) {
$parcel$export(module.exports, "SoftwareRovoStartPageTemplate", function () { return (parcelRequire("jnZak")).SoftwareRovoStartPageTemplate; });

var $jnZak = parcelRequire("jnZak");

});
parcelRegister("jnZak", function(module, exports) {

$parcel$export(module.exports, "SoftwareRovoStartPageTemplate", function () { return $9e8e33cbd5ba7982$export$89c9d15d38180eeb; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $gkhN4 = parcelRequire("gkhN4");

var $9xGVG = parcelRequire("9xGVG");

var $5wOn9 = parcelRequire("5wOn9");

var $dWbel = parcelRequire("dWbel");

var $kR0zI = parcelRequire("kR0zI");

var $50BgN = parcelRequire("50BgN");

var $20Igh = parcelRequire("20Igh");
const $9e8e33cbd5ba7982$export$89c9d15d38180eeb = ()=>{
    const stargateClient = (0, $gkhN4.useBxpWebStargateClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { isUserLoggedIn: isUserLoggedIn, requestInProgress: requestInProgress } = (0, $5wOn9.useLoggedInUser)();
    const [redirectUrl, setRedirectUrl] = (0, $iSvIT.useState)();
    const localizedContactHref = (0, $kR0zI.useLocalizedHref)("/enterprise/contact");
    const adminBaseUrl = (0, $iSvIT.useMemo)(()=>{
        if (typeof window === "undefined") return "https://admin.atlassian.com";
        return (0, $9xGVG.Environment).isProduction() ? "https://admin.atlassian.com" : "https://admin.stg.atlassian.com";
    }, []);
    (0, $iSvIT.useEffect)(()=>{
        redirectUrl && setTimeout(()=>window.location.href = redirectUrl, 300);
    }, [
        redirectUrl
    ]);
    const fireViewAnalytics = (0, $iSvIT.useCallback)((attributes = {})=>{
        analyticsClient && createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: "softwareRovoStartPage",
            source: "softwareRovoStartPage",
            attributes: attributes
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const getIsOrgAdmin = (0, $iSvIT.useCallback)(async ()=>{
        const { success: success, accountOrgs: accountOrgs } = await stargateClient.getAccountOrgs({});
        if (!success) throw new Error("Get account/orgs call failed");
        const isOrgAdmin = !!(accountOrgs && accountOrgs.length > 0);
        fireViewAnalytics({
            isOrgAdmin: isOrgAdmin
        });
        isOrgAdmin ? setRedirectUrl(`${adminBaseUrl}/rovo`) : setRedirectUrl(localizedContactHref);
    }, [
        fireViewAnalytics,
        stargateClient,
        setRedirectUrl,
        localizedContactHref,
        adminBaseUrl
    ]);
    const checkIfRovoProductExists = (0, $iSvIT.useCallback)(async ()=>{
        const productsUrl = (0, $9xGVG.Environment).isProduction() ? "https://rovo.atlassian.com" : "https://home.stg.atlassian.com/rovo";
        const { accountProducts: accountProducts, success: success } = await stargateClient.getAccountProducts({});
        if (!success) throw new Error("Get account/products call failed");
        if (accountProducts && accountProducts.length > 0) {
            const siteWithRovo = accountProducts.find((site)=>site.products.includes("rovo.ondemand"));
            if (siteWithRovo) {
                fireViewAnalytics({
                    hasRovo: true
                });
                const cloudId = siteWithRovo.cloudId;
                setRedirectUrl(`${productsUrl}?cloudId=${cloudId}`);
                return;
            }
        }
        getIsOrgAdmin();
    }, [
        stargateClient,
        fireViewAnalytics,
        getIsOrgAdmin,
        setRedirectUrl
    ]);
    (0, $iSvIT.useEffect)(()=>{
        switch(requestInProgress){
            case false:
                switch(isUserLoggedIn){
                    case true:
                        checkIfRovoProductExists();
                        break;
                    case false:
                        fireViewAnalytics();
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }
    }, [
        fireViewAnalytics,
        checkIfRovoProductExists,
        isUserLoggedIn,
        requestInProgress
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: !requestInProgress && !isUserLoggedIn ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $50BgN.LoginContactSales), {}) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $20Igh.LoadingSpinner), {})
    });
};

});
parcelRegister("50BgN", function(module, exports) {

$parcel$export(module.exports, "LoginContactSales", function () { return $2b8bf8cf4f50a1d3$export$6a33a815ad7360e9; });
/* login-contact-sales.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $gf1F9 = parcelRequire("gf1F9");

var $iBKUT = parcelRequire("iBKUT");

var $257fv = parcelRequire("257fv");
var $6fxse = parcelRequire("6fxse");
var $jXVyf = parcelRequire("jXVyf");
var $agt8L = parcelRequire("agt8L");
var $j7TVc = parcelRequire("j7TVc");

var $91nJf = parcelRequire("91nJf");
parcelRequire("bGE1b");
var $1p5F6 = parcelRequire("1p5F6");

var $iu8Ap = parcelRequire("iu8Ap");

var $1UUq1 = parcelRequire("1UUq1");

var $9xGVG = parcelRequire("9xGVG");

var $dWbel = parcelRequire("dWbel");

var $kR0zI = parcelRequire("kR0zI");

var $44WDd = parcelRequire("44WDd");

var $aRRBD = parcelRequire("aRRBD");
const $2b8bf8cf4f50a1d3$var$elevatedContainerInnerStyles = (0, $j7TVc.xcss)({
    textAlign: "center",
    paddingBlockStart: "space.500"
});
const $2b8bf8cf4f50a1d3$var$bodyTextStyles = (0, $j7TVc.xcss)({
    paddingBlockStart: "space.100"
});
const $2b8bf8cf4f50a1d3$var$loginButtonStyles = (0, $j7TVc.xcss)({
    paddingBlockStart: "space.400",
    paddingBlockEnd: "space.400",
    paddingInlineStart: "space.800",
    paddingInlineEnd: "space.800"
});
const $2b8bf8cf4f50a1d3$var$contactAtlassianStyles = (0, $j7TVc.xcss)({
    justifyContent: "center"
});
const $2b8bf8cf4f50a1d3$var$relative = null;
const $2b8bf8cf4f50a1d3$var$whiteBackground = null;
const $2b8bf8cf4f50a1d3$export$6a33a815ad7360e9 = ()=>{
    const intl = (0, $f6qj2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const localizedContactHref = (0, $kR0zI.useLocalizedHref)("/enterprise/contact");
    const fireButtonAnalytics = (0, $iSvIT.useCallback)((buttonName)=>{
        analyticsClient && createAnalyticsEvent({
            action: "clicked",
            actionSubject: buttonName,
            actionSubjectId: "softwareRovoStartPageTemplate",
            attributes: {
                source: "loginContactSalesScreen"
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const loginButtonHandler = (0, $iSvIT.useCallback)(()=>fireButtonAnalytics("loginButton"), [
        fireButtonAnalytics
    ]);
    const contactSalesLinkHandler = (0, $iSvIT.useCallback)(()=>fireButtonAnalytics("contactSalesLink"), [
        fireButtonAnalytics
    ]);
    const loginUrl = (0, $iSvIT.useMemo)(()=>{
        if (typeof window === "undefined") return "id.atlassian.com/";
        return (0, $9xGVG.Environment).isProduction() ? "https://id.atlassian.com/" : "https://id.stg.internal.atlassian.com/";
    }, []);
    const LinktoContactAtlassian = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
            href: localizedContactHref,
            type: "primary",
            ariaLabel: "Contact Atlassian Page",
            text: props.children,
            onClick: contactSalesLinkHandler
        });
    const allItemsContactAtlassian = intl.formatMessage((0, $44WDd.messages).contactAtlassianText, {
        a: (contactAtlassian)=>/*#__PURE__*/ (0, $loA2J.jsx)(LinktoContactAtlassian, {
                children: contactAtlassian
            })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iBKUT.RovoLogo), {
            size: "xlarge",
            appearance: "brand"
        }),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
            xcss: $2b8bf8cf4f50a1d3$var$elevatedContainerInnerStyles,
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswh2mm _1pbyidpf"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_kqswstnw _152tidpf _u7coidpf _1e02idpf _rjxpidpf _1bsb1osq _4t3i1osq _bfhku67f _1pby1mrw"
                            ])
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                            as: "h1",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $44WDd.messages).rovoGetStarted), {
                                values: {
                                    started: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1p5F6.Adg4TextUnderline), {
                                            underline: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aRRBD.ScribbleImage), {}),
                                            fontWeight: {
                                                from: 600,
                                                to: 600
                                            },
                                            children: str
                                        })
                                }
                            }))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                    xcss: $2b8bf8cf4f50a1d3$var$bodyTextStyles,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $agt8L.default), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $44WDd.messages).rovoBodyText))
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                    xcss: $2b8bf8cf4f50a1d3$var$loginButtonStyles,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                        size: "small",
                        isFullWidth: true,
                        "aria-label": "Login Button",
                        href: `${loginUrl}login?continue=${encodeURIComponent(window.location.href)}`,
                        onClick: loginButtonHandler,
                        target: "",
                        children: intl.formatMessage((0, $44WDd.messages).loginButtonRovo)
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $6fxse.default), {
                    space: "space.100",
                    xcss: $2b8bf8cf4f50a1d3$var$contactAtlassianStyles,
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $44WDd.messages).dontHaveAccountText)),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                            children: allItemsContactAtlassian
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("iBKUT", function(module, exports) {

$parcel$export(module.exports, "RovoLogo", function () { return $d8c013606d123125$export$a0f6cb8061290bbb; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $d8c013606d123125$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 100 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path\n        d="M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z"\n        fill="'.concat(colors.iconColor, '"\n        fillRule="evenodd"\n      />\n      <path\n        d="m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z"\n        fill="').concat(colors.iconColor, '"\n        fillRule="evenodd"\n      />\n      <path\n        d="M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z"\n        fill="').concat(colors.textColor, '"\n      />\n    </svg>');
};
var $d8c013606d123125$export$a0f6cb8061290bbb = function RovoLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Rovo" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $d8c013606d123125$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("agt8L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $779200a93ff14d0d$export$2e2bcd8739ae039; });

var $eWYnH = parcelRequire("eWYnH");

var $dFcgv = parcelRequire("dFcgv");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $jNYFj = parcelRequire("jNYFj");

var $ihHOk = parcelRequire("ihHOk");

var $ahkBr = parcelRequire("ahkBr");
var $779200a93ff14d0d$var$_excluded = [
    "children"
];
function $779200a93ff14d0d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $779200a93ff14d0d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $779200a93ff14d0d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dFcgv.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $779200a93ff14d0d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $779200a93ff14d0d$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $779200a93ff14d0d$var$resetStyles = (0, $2ZUkg.css)({
    margin: 0
});
var $779200a93ff14d0d$var$variantStyles = $779200a93ff14d0d$var$_objectSpread($779200a93ff14d0d$var$_objectSpread({}, (0, $ihHOk.bodyTextStylesMap)), (0, $ihHOk.uiTextStylesMap));
var $779200a93ff14d0d$var$strongStyles = (0, $2ZUkg.css)({
    fontWeight: "bold"
});
var $779200a93ff14d0d$var$emStyles = (0, $2ZUkg.css)({
    fontStyle: "italic"
});
var $779200a93ff14d0d$var$textAlignMap = {
    center: (0, $2ZUkg.css)({
        textAlign: "center"
    }),
    end: (0, $2ZUkg.css)({
        textAlign: "end"
    }),
    start: (0, $2ZUkg.css)({
        textAlign: "start"
    })
};
var $779200a93ff14d0d$var$truncationStyles = (0, $2ZUkg.css)({
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical"
});
var $779200a93ff14d0d$var$wordBreakMap = {
    breakAll: (0, $2ZUkg.css)({
        wordBreak: "break-all"
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $779200a93ff14d0d$var$useColor = function useColor(colorProp) {
    var surface = (0, $ahkBr.useSurface)();
    var inverseTextColor = (0, $ihHOk.inverseColorMap)[surface];
    /**
   * Where the color of the surface is inverted we override the user choice
   * as there is no valid choice that is not covered by the override.
   */ var color = inverseTextColor !== null && inverseTextColor !== void 0 ? inverseTextColor : colorProp;
    return color;
};
var $779200a93ff14d0d$var$HasTextAncestorContext = /*#__PURE__*/ (0, $iSvIT.createContext)(false);
var $779200a93ff14d0d$var$useHasTextAncestor = function useHasTextAncestor() {
    return (0, $iSvIT.useContext)($779200a93ff14d0d$var$HasTextAncestorContext);
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $779200a93ff14d0d$var$Text = function Text(_ref) {
    var children = _ref.children, props = (0, $eWYnH.default)(_ref, $779200a93ff14d0d$var$_excluded);
    var asElement = props.as, _props$color = props.color, colorProp = _props$color === void 0 ? "color.text" : _props$color, textAlign = props.textAlign, testId = props.testId, id = props.id, _props$variant = props.variant, variant = _props$variant === void 0 ? "body" : _props$variant, weight = props.weight;
    // body variants -> p
    // ui variants -> span
    var Component = asElement || (variant.includes("body") ? "p" : "span");
    (0, $jNYFj.default)($779200a93ff14d0d$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    // Remove the ability to bypass typescript errors for maxLines
    var maxLines;
    if ("maxLines" in props && variant.includes("body")) maxLines = props.maxLines;
    var color = $779200a93ff14d0d$var$useColor(colorProp);
    var isWrapped = $779200a93ff14d0d$var$useHasTextAncestor();
    /**
   * If the text is already wrapped and applies no props we can just
   * render the children directly as a fragment.
   */ if (isWrapped && Object.keys(props).length === 0) return (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), null, children);
    var component = (0, $2ZUkg.jsx)(Component, {
        css: [
            $779200a93ff14d0d$var$resetStyles,
            variant && $779200a93ff14d0d$var$variantStyles[variant],
            color && (0, $ihHOk.textColorStylesMap)[color],
            maxLines && $779200a93ff14d0d$var$truncationStyles,
            maxLines === 1 && $779200a93ff14d0d$var$wordBreakMap.breakAll,
            textAlign && $779200a93ff14d0d$var$textAlignMap[textAlign],
            weight && (0, $ihHOk.fontWeightStylesMap)[weight],
            asElement === "em" && $779200a93ff14d0d$var$emStyles,
            asElement === "strong" && $779200a93ff14d0d$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return isWrapped ? // no need to re-apply context if the text is already wrapped
    component : (0, $2ZUkg.jsx)($779200a93ff14d0d$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
};
var $779200a93ff14d0d$export$2e2bcd8739ae039 = $779200a93ff14d0d$var$Text;

});

parcelRegister("44WDd", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $749e1e7a17e5468d$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $749e1e7a17e5468d$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    loading: {
        id: "SoftwareRovoStart.Page.loading",
        defaultMessage: "Loading"
    },
    login: {
        id: "SoftwareRovoStart.Page.login",
        defaultMessage: "Login"
    },
    contactSales: {
        id: "SoftwareRovoStart.Page.contactSales",
        defaultMessage: "Contact Sales"
    },
    rovoGetStarted: {
        defaultMessage: "Get <started>started</started> with Rovo",
        description: "Title text for WAC Rovo Start_logged out page",
        id: "SoftwareRovoStart.Page.rovoGetStarted"
    },
    loginButtonRovo: {
        defaultMessage: "Log in",
        id: "SoftwareRovoStart.Page.loginButtonRovo"
    },
    rovoBodyText: {
        defaultMessage: "Log in to add it to your organization",
        id: "SoftwareRovoStart.Page.rovoBodyText"
    },
    dontHaveAccountText: {
        defaultMessage: "Don\u2019t have an account?",
        id: "SoftwareRovoStart.Page.dontHaveAccountText"
    },
    contactAtlassianText: {
        defaultMessage: "<a>Contact Atlassian</a>",
        id: "SoftwareRovoStart.Page.contactAtlassianText"
    },
    errorScreenTitle: {
        defaultMessage: "Something went wrong",
        description: "Error screen title",
        id: "SoftwareRovoStart.Page.errorScreenTitle"
    },
    errorScreenMessageOne: {
        defaultMessage: "<a>Contact support</a> for further help or try again.",
        description: "Error screen message part one",
        id: "SoftwareRovoStart.Page.errorScreenMessageOne"
    },
    errorScreenMessageTwo: {
        defaultMessage: "To receive a quote for Rovo, <a>contact sales.</a>",
        description: "Error screen message part two",
        id: "SoftwareRovoStart.Page.errorScreenMessageTwo"
    }
});

});

parcelRegister("aRRBD", function(module, exports) {

$parcel$export(module.exports, "ScribbleImage", function () { return $891ddbb87e58b62a$export$31b1a25c5f295125; });

var $loA2J = parcelRequire("loA2J");
const $891ddbb87e58b62a$var$ScribbleImageComponent = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "105",
        height: "17",
        viewBox: "0 0 105 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M104.435 9.68613C86.4938 6.51631 73.1262 13.83 55.0489 7.43996C54.1658 10.0608 51.9298 13.3276 48.6487 13.3318C51.3855 13.3082 55.8543 6.49074 51.3954 11.0379C48.7638 14.5108 37.5257 10.0724 46.1409 13.2376C40.1743 12.5113 34.7527 8.16936 30.7652 4.31768C24.1184 -1.18196 29.0775 9.35501 24.148 14.5541C17.1646 21.7785 -3.47552 2.46837 0.735557 2.51293C3.38441 4.93365 6.96197 6.46719 8.41505 9.13148C34.4142 25.1383 15.8926 -4.08831 31.4374 0.975475C56.6666 21.4402 44.0238 3.05288 58.9761 4.49783C67.6031 11.908 104.856 0.972575 104.442 9.68622L104.435 9.68613Z",
            fill: "#FCA700"
        })
    });
};
const $891ddbb87e58b62a$export$31b1a25c5f295125 = $891ddbb87e58b62a$var$ScribbleImageComponent;

});


parcelRegister("20Igh", function(module, exports) {

$parcel$export(module.exports, "LoadingSpinner", function () { return $236206e4ad5a6732$export$b08b517936747730; });
/* spinner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $9gh2a = parcelRequire("9gh2a");

var $44WDd = parcelRequire("44WDd");
const $236206e4ad5a6732$var$loadingCss = null;
const $236206e4ad5a6732$export$b08b517936747730 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        role: "progressbar",
        "aria-label": intl.formatMessage((0, $44WDd.messages).loading),
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o _1tke1kxc"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gh2a.default), {
            size: "large"
        })
    });
};

});



parcelRegister("63FK4", function(module, exports) {

$parcel$export(module.exports, "ErrorScreen", function () { return $9a973e4f77d5475a$export$42f84e610f279c31; });
/* error-screen.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $gf1F9 = parcelRequire("gf1F9");

var $iBKUT = parcelRequire("iBKUT");

var $6fxse = parcelRequire("6fxse");
var $jXVyf = parcelRequire("jXVyf");
var $j7TVc = parcelRequire("j7TVc");

var $iu8Ap = parcelRequire("iu8Ap");

var $dWbel = parcelRequire("dWbel");

var $kR0zI = parcelRequire("kR0zI");

var $44WDd = parcelRequire("44WDd");

var $6unIx = parcelRequire("6unIx");
const $9a973e4f77d5475a$var$elevatedContainerInnerStyles = (0, $j7TVc.xcss)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "space.400",
    alignSelf: "stretch",
    paddingBlockStart: "space.150"
});
const $9a973e4f77d5475a$var$contentStyles = (0, $j7TVc.xcss)({
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "space.200"
});
const $9a973e4f77d5475a$var$bodyStyles = (0, $j7TVc.xcss)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    alignSelf: "stretch",
    fontSize: 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    fontWeight: "400"
});
const $9a973e4f77d5475a$var$linkStyles = null;
const $9a973e4f77d5475a$export$42f84e610f279c31 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const localizedContactHref = (0, $kR0zI.useLocalizedHref)("/enterprise/contact");
    (0, $iSvIT.useEffect)(()=>{
        analyticsClient && createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: "softwareRovoStartPageErrorScreen",
            source: "softwareRovoStartPage"
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const fireButtonAnalytics = (0, $iSvIT.useCallback)((buttonName)=>{
        analyticsClient && createAnalyticsEvent({
            action: "clicked",
            actionSubject: buttonName,
            actionSubjectId: "softwareRovoStartPageTemplate",
            attributes: {
                source: "errorScreen"
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const contactSupportLinkHandler = (0, $iSvIT.useCallback)(()=>fireButtonAnalytics("contactSupportLink"), [
        fireButtonAnalytics
    ]);
    const contactSalesLinkHandler = (0, $iSvIT.useCallback)(()=>fireButtonAnalytics("contactSalesLink"), [
        fireButtonAnalytics
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iBKUT.RovoLogo), {
            size: "xlarge",
            appearance: "brand"
        }),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
            xcss: $9a973e4f77d5475a$var$elevatedContainerInnerStyles,
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $6unIx.ErrorIconImage), {}),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
                    xcss: $9a973e4f77d5475a$var$contentStyles,
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                            as: "h1",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $44WDd.messages).errorScreenTitle))
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
                            xcss: $9a973e4f77d5475a$var$bodyStyles,
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $6fxse.default), {
                                    space: "space.075",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $44WDd.messages).errorScreenMessageOne), {
                                        values: {
                                            a: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                                    href: "https://support.atlassian.com/contact/",
                                                    onClick: contactSupportLinkHandler,
                                                    "aria-label": "Contact Atlassian Support Page",
                                                    className: (0, $esG4f.default)([
                                                        "_y3gn1h6o _syaz14q2 _k48p1fw0"
                                                    ]),
                                                    children: text
                                                })
                                        }
                                    }))
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $6fxse.default), {
                                    space: "space.075",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $44WDd.messages).errorScreenMessageTwo), {
                                        values: {
                                            a: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                                    href: localizedContactHref,
                                                    onClick: contactSalesLinkHandler,
                                                    "aria-label": "Contact Atlassian Sales Page",
                                                    className: (0, $esG4f.default)([
                                                        "_y3gn1h6o _syaz14q2 _k48p1fw0"
                                                    ]),
                                                    children: text
                                                })
                                        }
                                    }))
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("6unIx", function(module, exports) {

$parcel$export(module.exports, "ErrorIconImage", function () { return $0089f59eb8842b31$export$a1922be2c234f039; });

var $loA2J = parcelRequire("loA2J");
const $0089f59eb8842b31$var$ErrorIconComponent = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "105",
        height: "97",
        viewBox: "0 0 105 97",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                clipPath: "url(#clip0_2901_19175)",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M0.629883 96.2192L0.687156 96.3338H104.306L104.37 96.2192L52.4999 0.357422L0.629883 96.2192Z",
                        fill: "#DDDEE1"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M52.6782 34.6891V69.6954",
                        stroke: "white",
                        strokeWidth: "7.33",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M55.1283 80.6028C55.1601 80.4373 55.1728 80.2591 55.1728 80.0746C55.1728 79.8901 55.1601 79.7055 55.1283 79.5401C54.9501 78.541 54.2564 77.9301 53.2828 77.771C53.1174 77.7455 52.9455 77.7328 52.761 77.7328C52.5764 77.7328 52.3919 77.7455 52.2201 77.7773C51.2464 77.9364 50.5592 78.5537 50.3746 79.5464C50.3428 79.7119 50.3301 79.8901 50.3301 80.081C50.3301 80.2719 50.3428 80.4437 50.3746 80.6092C50.5528 81.6019 51.2464 82.2128 52.2201 82.3782C52.3919 82.4101 52.5764 82.4228 52.761 82.4228C52.9455 82.4228 53.1174 82.4101 53.2828 82.3846C54.2564 82.2255 54.9501 81.6082 55.1283 80.6155V80.6028Z",
                        stroke: "white",
                        strokeWidth: "7.33",
                        strokeMiterlimit: "10"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                    id: "clip0_2901_19175",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "105",
                        height: "97",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
const $0089f59eb8842b31$export$a1922be2c234f039 = $0089f59eb8842b31$var$ErrorIconComponent;

});



parcelRegister("anmoL", function(module, exports) {

$parcel$export(module.exports, "NonProfitPricingPage", function () { return $b4ad61374d932013$export$536ddfd40654e3e4; });

var $loA2J = parcelRequire("loA2J");

var $dT5kE = parcelRequire("dT5kE");
parcelRequire("8vIAf");
var $5JNXa = parcelRequire("5JNXa");
const $b4ad61374d932013$export$536ddfd40654e3e4 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dT5kE.PricingContentContextProviderRelay), {
        productId: "nonprofit",
        pricingContent: pricingContent,
        queryRef: queryRef,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            "data-testid": "non-profit-pricing",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5JNXa.NonProfitPricingPageTemplate), {
                pricing: pricing,
                countryCode: countryCode
            })
        })
    });
};

});
parcelRegister("8vIAf", function(module, exports) {
$parcel$export(module.exports, "NonProfitPricingPageTemplate", function () { return (parcelRequire("5JNXa")).NonProfitPricingPageTemplate; });
parcelRequire("5JNXa");

});
parcelRegister("5JNXa", function(module, exports) {

$parcel$export(module.exports, "NonProfitPricingPageTemplate", function () { return $85c8c2aac06800a2$export$55cf024acc460d8c; });

var $loA2J = parcelRequire("loA2J");

var $dT5kE = parcelRequire("dT5kE");
parcelRequire("3XyMp");
var $ceE90 = parcelRequire("ceE90");

var $j1oGG = parcelRequire("j1oGG");

var $2uMOw = parcelRequire("2uMOw");
parcelRequire("ccYBS");
var $1FqEx = parcelRequire("1FqEx");

var $5k7qk = parcelRequire("5k7qk");

var $iroZG = parcelRequire("iroZG");

var $bjKLz = parcelRequire("bjKLz");

var $1i2j7 = parcelRequire("1i2j7");

var $jQiaD = parcelRequire("jQiaD");

var $eM8Nf = parcelRequire("eM8Nf");

var $6HCAP = parcelRequire("6HCAP");

var $cVHP2 = parcelRequire("cVHP2");

var $joIaB = parcelRequire("joIaB");

var $7UazH = parcelRequire("7UazH");

var $5qSLn = parcelRequire("5qSLn");

var $NASPU = parcelRequire("NASPU");

var $livCd = parcelRequire("livCd");
const $85c8c2aac06800a2$export$55cf024acc460d8c = ({ pricing: pricing, countryCode: countryCode })=>{
    const content = (0, $dT5kE.usePricingContentContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1FqEx.ParentScrollTracking), {
            pageId: "nonprofit-pricing-page",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PricingPageLayout), {
                    nav: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7UazH.NonprofitNav), {}),
                    banner: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1i2j7.Banner), {}),
                    hero: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cVHP2.Hero), {}),
                    hasGlobalFooter: false
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PricingPageLayout), {
                    bgColor: "#F8F8F8",
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1FqEx.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jQiaD.EligibleSection), {})
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PricingPageLayout), {
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1FqEx.ParentScrollTracking), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $joIaB.NonprofitCalculatorHeading), {}),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5k7qk.PricingTabs), {
                                jiraCalculatorComponent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bjKLz.JiraPriceFinder), {
                                    pricing: pricing,
                                    countryCode: countryCode,
                                    shouldAddDiscount: true
                                }),
                                confluenceCalculatorComponent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iroZG.ConfluencePriceFinder), {
                                    pricing: pricing,
                                    countryCode: countryCode,
                                    shouldAddDiscount: true
                                }),
                                trelloCalculatorComponent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $livCd.TrelloPriceFinder), {
                                    pricing: pricing,
                                    countryCode: countryCode,
                                    shouldAddDiscount: true
                                }),
                                loomCalculatorComponent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2uMOw.LoomPriceFinder), {
                                    pricing: pricing,
                                    countryCode: countryCode,
                                    shouldAddDiscount: true,
                                    ctaUrlSource: "productPlans"
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $eM8Nf.EnterpriseSection), {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PricingPageLayout), {
                    bgColor: "#E9F2FE",
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1FqEx.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5qSLn.OfficialSection), {})
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PricingPageLayout), {
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1FqEx.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $NASPU.ResourcesSection), {})
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $j1oGG.PricingPageLayout), {
                    hasGlobalFooter: true,
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1FqEx.ParentScrollTracking), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $ceE90.PricingFaq), {
                                header: content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle,
                                planDetails: content === null || content === void 0 ? void 0 : content.additionalDetails
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $6HCAP.Fineprint), {})
                        ]
                    })
                })
            ]
        })
    });
};

});
parcelRegister("iroZG", function(module, exports) {

$parcel$export(module.exports, "ConfluencePriceFinder", function () { return $c42bcb4786ff75f1$export$a33aedde1d62b896; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $6x1qA = parcelRequire("6x1qA");
var $f6qj2 = parcelRequire("f6qj2");

var $7OWgU = parcelRequire("7OWgU");

var $l9lQF = parcelRequire("l9lQF");

var $h8FEE = parcelRequire("h8FEE");

var $kKd7o = parcelRequire("kKd7o");

var $gYNkb = parcelRequire("gYNkb");

var $4dyLA = parcelRequire("4dyLA");

var $b2c9u = parcelRequire("b2c9u");

var $jwBCQ = parcelRequire("jwBCQ");

var $hiqOA = parcelRequire("hiqOA");

var $Ez6Wt = parcelRequire("Ez6Wt");

var $8N5F8 = parcelRequire("8N5F8");

var $62R9f = parcelRequire("62R9f");

var $3aflv = parcelRequire("3aflv");

var $2ZdCZ = parcelRequire("2ZdCZ");

var $1P2k8 = parcelRequire("1P2k8");

var $kI6cN = parcelRequire("kI6cN");

var $6lyI0 = parcelRequire("6lyI0");

var $hUmbv = parcelRequire("hUmbv");

var $4VuTU = parcelRequire("4VuTU");
const $c42bcb4786ff75f1$export$a33aedde1d62b896 = (props)=>{
    var _props_pricing_ccpPricingData, _props_pricing;
    const intl = (0, $f6qj2.default)();
    const newTagText = intl.formatMessage({
        id: "ConfluencePricingPage.priceFinder.newTagText",
        defaultMessage: "New"
    });
    const freePlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.unlimitedPages.title",
                    defaultMessage: "Unlimited pages"
                }),
                content: (0, $6lyI0.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.unlimitedSpaces.title",
                    defaultMessage: "Unlimited spaces"
                }),
                content: (0, $hUmbv.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.databases.title",
                    defaultMessage: "Organize and connect work with databases"
                }),
                content: (0, $jwBCQ.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.templates.title",
                    defaultMessage: "Templates for Marketing, Product, Program Management and more"
                }),
                content: (0, $kI6cN.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.activeWhiteboards.title",
                    defaultMessage: "Up to 3 active whiteboards per user "
                }),
                content: (0, $h8FEE.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.freeAutomationRuleRuns.title",
                    defaultMessage: "10 automation rule runs per month "
                }),
                content: (0, $b2c9u.FreeAutomationRuleRuns)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.supportAppsAndIntegrations",
                    defaultMessage: "Support for apps and integrations"
                }),
                content: (0, $2ZdCZ.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.supportFromAtlassianCommunity",
                    defaultMessage: "Support from Atlassian Community"
                }),
                content: (0, $1P2k8.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.features.freeFileStorage",
                defaultMessage: "Up to 2 GB file storage"
            })
        }
    ];
    const standardPlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.externalCollaboration.title",
                    defaultMessage: "External collaboration"
                }),
                content: (0, $Ez6Wt.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.pagePermissions.title",
                    defaultMessage: "Page permissions"
                }),
                content: (0, $8N5F8.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.standardAutomationRuleRuns.title",
                    defaultMessage: "100 automation rule runs per month"
                }),
                content: (0, $b2c9u.StandardAutomationRuleRuns)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.features.standardStorage.title",
                defaultMessage: "250 GB of storage"
            })
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.regionalSupport.title",
                    defaultMessage: "9/5 regional support"
                }),
                content: (0, $3aflv.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.features.standard150000singlesSite.title",
                defaultMessage: "Up to 150,000 users on a single site"
            })
        }
    ];
    const premiumPlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.aiPowered.title",
                    defaultMessage: "AI-powered creation and collaboration"
                }),
                content: (0, $gYNkb.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.dynamicIntranet.title",
                    defaultMessage: "Dynamic intranet"
                }),
                content: (0, $hiqOA.default)
            },
            lozengeText: newTagText
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.perUserAutomation.title",
                    defaultMessage: "Per user automation limits (1000 per month)"
                }),
                content: (0, $4dyLA.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.unlimitedWhiteboards.title",
                    defaultMessage: "Unlimited whiteboards"
                }),
                content: (0, $4VuTU.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.adminControlsInsights.title",
                    defaultMessage: "Admin controls and insights"
                }),
                content: (0, $kKd7o.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.features.unlimitedStorage.title",
                defaultMessage: "Unlimited storage"
            })
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.premiumSupport.title",
                    defaultMessage: "24/7 support for critical issues"
                }),
                content: (0, $62R9f.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.features.premiumSla.title",
                defaultMessage: "99.9% uptime SLA"
            })
        }
    ];
    const confluenceProductPlans = [
        {
            planName: "Free",
            offeringSku: "confluence-free",
            description: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.priceFinder.freeDescription",
                defaultMessage: "Free forever for 10 users"
            }),
            recommendationLimit: 0,
            signupLimit: 150000,
            signupURLSuffix: "?bundle=confluence&edition=free&signupSource=pricing",
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: "Standard",
            offeringSku: "confluence-standard",
            description: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.priceFinder.standardDescription",
                defaultMessage: "Everything you need to get started"
            }),
            recommendationLimit: 10,
            signupLimit: 150000,
            signupURLSuffix: "?bundle=confluence&edition=standard",
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: "Premium",
            offeringSku: "confluence-premium",
            description: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.priceFinder.premiumDescription",
                defaultMessage: "Connect work across teams"
            }),
            recommendationLimit: 250,
            signupLimit: 150000,
            signupURLSuffix: "?bundle=confluence&edition=premium",
            planFeatureMessages: premiumPlanFeatureMessages
        }
    ];
    const messages = (0, $6x1qA.defineMessages)({
        headerText: {
            id: "ConfluencePricingPageTeam24.priceFinder.headerText",
            defaultMessage: "Build Your <blue>Source of Truth</blue>"
        },
        unitCountInputTextRedesign: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputDirectBuy: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputDirectBuy",
            defaultMessage: "What's your team size?"
        },
        unitCountInputTerm: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        billingCycleText: {
            id: "ConfluencePricingPage.priceFinder.billingCycleText",
            defaultMessage: "Billing cycle:"
        },
        unitCountInputText: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputText",
            defaultMessage: "How many users are on your team?"
        },
        unitCountInputTooltip: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTooltip",
            defaultMessage: "A Confluence user is any user who can log in to Confluence, and who exists in User Management"
        },
        monthlyExampleHelpText: {
            id: "ConfluencePricingPage.priceFinder.monthlyExampleHelpText",
            defaultMessage: "Monthly plans give you flexibility as your number of active users changes, so pay for seats as you use them. Remember that the number of seats may change the total price."
        },
        annualExampleHelpText: {
            id: "ConfluencePricingPage.priceFinder.annualExampleHelpText",
            defaultMessage: "Annual plans give you flexibility and help you prepare for growth. Buy a group of seats at a flat rate now, then fill your empty seats through the year at no extra cost."
        },
        exampleStandardPlan: {
            id: "ConfluencePricingPage.priceFinder.exampleStandardPlan",
            defaultMessage: "Pricing for {unitCount} users on Standard plan",
            description: "Standard is a plan name and should not be translated"
        },
        cardOverSignupLimit: {
            id: "ConfluencePricingPage.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "ConfluencePricingPage.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "ConfluencePricingPage.priceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "ConfluencePricingPageTeam24.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        },
        cardFreeDescription: {
            id: "ConfluencePricingPage.priceFinder.cardFreeDescription",
            defaultMessage: "Always free for 10 users"
        }
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $l9lQF.PriceFinderContextProvider), {
            dataProductKey: "confluence",
            productPlans: confluenceProductPlans,
            defaultUnitCount: 150,
            shouldAddDiscount: props.shouldAddDiscount,
            ctaUrlSource: "productPlans",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OWgU.default), {
                messages: messages,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.confluence,
                countryCode: props.countryCode
            })
        })
    });
};
$c42bcb4786ff75f1$export$a33aedde1d62b896.displayName = "ConfluencePriceFinder";
var $c42bcb4786ff75f1$export$2e2bcd8739ae039 = $c42bcb4786ff75f1$export$a33aedde1d62b896;

});
parcelRegister("h8FEE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5265f97166f9eed6$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $3FBn4 = parcelRequire("3FBn4");
const $5265f97166f9eed6$var$ActiveWhiteboards = ()=>{
    const localizedHref = (0, $3FBn4.useLocalizedHref)("/software/confluence/whiteboards");
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "ConfluencePricingPageTeam24.features.activeWhiteboards.content.body",
                defaultMessage: "Confluence whiteboards brings the flexibility of a digital whiteboard into your team workspace. Collaborate, brainstorm, draw and visualize ideas in a freeform way with up to 3 active whiteboards per user. <a>Learn more.</a>",
                values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.activeWhiteboards.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                })
            })
        })
    });
};
var $5265f97166f9eed6$export$2e2bcd8739ae039 = $5265f97166f9eed6$var$ActiveWhiteboards;

});

parcelRegister("kKd7o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $683e4695aaa56c24$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
const $683e4695aaa56c24$var$AdminControlsInsights = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "ConfluencePricingPageTeam24.features.adminControlsInsights.content.body",
                defaultMessage: "Inspect permissions to specify who can do and create what, and fix permission problems quickly with an admin key. Manage site health, get actionable alerts, and unlock site-level insights, all in one place."
            })
        })
    });
};
var $683e4695aaa56c24$export$2e2bcd8739ae039 = $683e4695aaa56c24$var$AdminControlsInsights;

});

parcelRegister("gYNkb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27d7463632a9b81d$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $3FBn4 = parcelRequire("3FBn4");
const $27d7463632a9b81d$var$AtlassianIntelligence = ()=>{
    const localizedHref = `https://support.atlassian.com${(0, $3FBn4.useLocalizedHref)("/organization-administration/docs/get-started-with-atlassian-intelligence/", {
        supportedLocales: (0, $3FBn4.ATLASSIAN_SUPPORT_CENTER_SUPPORTED_LOCALES)
    })}`;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "ConfluencePricingPageTeam24.features.atlassianIntelligence.content.body",
                defaultMessage: "Communicate efficiently, glean relevant insights, and work on what matters with AI capabilities. These include AI-powered editing experiences, quick summaries of long pages, and more. <a>Learn more.</a>",
                values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.atlassianInteligence.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                })
            })
        })
    });
};
var $27d7463632a9b81d$export$2e2bcd8739ae039 = $27d7463632a9b81d$var$AtlassianIntelligence;

});

parcelRegister("4dyLA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd4ccb5de58b4a01$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $3FBn4 = parcelRequire("3FBn4");
const $cd4ccb5de58b4a01$var$PerUserAutomation = ()=>{
    const localizedHref = (0, $3FBn4.useLocalizedHref)("/software/confluence/automation");
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "ConfluencePricingPageTeam24.features.perUserAutomation.content.body",
                defaultMessage: "Save time by automating repetitive, manual tasks to organize and manage content at scale. Get started quickly with out-of-the box templates or build your own powerful, custom rules by using the low-code / no-code rule builder and with AI. With Premium, unlock up to 1,000 automations per user per month. <a>Learn more.</a>",
                values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.perUserAutomation.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                })
            })
        })
    });
};
var $cd4ccb5de58b4a01$export$2e2bcd8739ae039 = $cd4ccb5de58b4a01$var$PerUserAutomation;

});

parcelRegister("b2c9u", function(module, exports) {

$parcel$export(module.exports, "FreeAutomationRuleRuns", function () { return $6239960fc35fcc57$export$cb1c6db7544762b5; });
$parcel$export(module.exports, "StandardAutomationRuleRuns", function () { return $6239960fc35fcc57$export$6716f876ee5d7d01; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $3FBn4 = parcelRequire("3FBn4");
const $6239960fc35fcc57$export$cb1c6db7544762b5 = ()=>{
    const localizedHref = (0, $3FBn4.useLocalizedHref)("/software/confluence/automation");
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "ConfluencePricingPageTeam24.features.freeAutomationRuleRuns.content.body",
                defaultMessage: "Increase efficiency by replacing manual, time-consuming work with automated processes and workflows. With Free, unlock 10 automation rule runs per instance per month. <a>Learn more.</a>",
                values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.freeAutomationRuleRuns.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                })
            })
        })
    });
};
const $6239960fc35fcc57$export$6716f876ee5d7d01 = ()=>{
    const localizedHref = (0, $3FBn4.useLocalizedHref)("/software/confluence/automation");
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "ConfluencePricingPageTeam24.features.standardAutomationRuleRuns.content.body",
                defaultMessage: "Increase efficiency by replacing manual, time-consuming work with automated processes and workflows. With Standard, unlock 100 automation rule runs per instance per month. <a>Learn more.</a>",
                values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.standardAutomationRuleRuns.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                })
            })
        })
    });
};

});

parcelRegister("jwBCQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b97ab56c9080252c$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $3FBn4 = parcelRequire("3FBn4");

var $jW6XO = parcelRequire("jW6XO");
const $b97ab56c9080252c$var$Databases = ()=>{
    const localizedHref = (0, $3FBn4.useLocalizedHref)("/software/confluence/databases");
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "ConfluencePricingPageTeam24.features.databases.content.body",
                defaultMessage: "Confluence databases are a central source of info that dramatically changes the way that teams can organize, reference, and display data in Confluence. <a>Learn more</a>.",
                values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
                    a: (0, $jW6XO.getMessageHyperlinkValue)({
                        localizedHref: localizedHref,
                        "data-event-container": "ConfluencePricingPage",
                        "data-label-english": "Learn more",
                        "data-track-event": "ConfluencePricingPageTeam24.databases"
                    })
                })
            })
        })
    });
};
var $b97ab56c9080252c$export$2e2bcd8739ae039 = $b97ab56c9080252c$var$Databases;

});
parcelRegister("jW6XO", function(module, exports) {

$parcel$export(module.exports, "getMessageHyperlinkValue", function () { return $fdb95383d657ab8f$export$c5b540569b1a51b0; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");
function $fdb95383d657ab8f$export$c5b540569b1a51b0(params) {
    const { localizedHref: localizedHref } = params, rest = (0, $akGnX._)(params, [
        "localizedHref"
    ]);
    return (chunks)=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)("a", (0, $6iHNw._)((0, $7Knp0._)({
            href: params.localizedHref
        }, rest), {
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-product-key": "confluence",
            children: chunks
        }));
    };
}

});


parcelRegister("hiqOA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ba4f4f7ce4c53c3$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $3FBn4 = parcelRequire("3FBn4");
const $6ba4f4f7ce4c53c3$var$DynamicIntranet = ()=>{
    const localizedHref = (0, $3FBn4.useLocalizedHref)("/software/confluence/use-cases/intranet-software");
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "ConfluencePricingPageTeam24.features.dynamicIntranet.content.body",
                defaultMessage: "Customize a dynamic info hub for your entire company with company hub, a single go-to destination for company news, announcements, and resources. <a>Learn more.</a>",
                values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.dynamicIntranet.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                })
            })
        })
    });
};
var $6ba4f4f7ce4c53c3$export$2e2bcd8739ae039 = $6ba4f4f7ce4c53c3$var$DynamicIntranet;

});

parcelRegister("Ez6Wt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9eba77885f855d65$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
const $9eba77885f855d65$var$ExternalCollaboration = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "ConfluencePricingPageTeam24.features.externalCollaboration.content.bodyOne",
                    defaultMessage: "Invite external partners to collaborate as guests in your Confluence site. Guests are free of charge, up to 5 guests per paid user."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "ConfluencePricingPageTeam24.features.externalCollaboration.content.bodyTwo",
                    defaultMessage: "You can also share view-only Confluence pages via public links. This can be useful for sharing information to the public, like customer FAQs and release notes."
                })
            })
        ]
    });
};
var $9eba77885f855d65$export$2e2bcd8739ae039 = $9eba77885f855d65$var$ExternalCollaboration;

});

parcelRegister("8N5F8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b096384e199249d3$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
const $b096384e199249d3$var$PagePermissions = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "ConfluencePricingPageTeam24.features.pagePermissions.content.body",
                defaultMessage: "Control who can view, edit and comment on your pages, so important information can stay restricted until you\u2019re ready to share."
            })
        })
    });
};
var $b096384e199249d3$export$2e2bcd8739ae039 = $b096384e199249d3$var$PagePermissions;

});

parcelRegister("62R9f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43f840efe60e4230$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $3FBn4 = parcelRequire("3FBn4");
const $43f840efe60e4230$var$PremiumSupport = ()=>{
    const localizedHref = (0, $3FBn4.useLocalizedHref)("/enterprise/support-services");
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "ConfluencePricingPageTeam24.features.premiumSupport.content.body",
                defaultMessage: "Get Premium support around the clock from a dedicated team with 1-hour response times to critical issues. <a>Learn more.</a>",
                values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.premiumSupport.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                })
            })
        })
    });
};
var $43f840efe60e4230$export$2e2bcd8739ae039 = $43f840efe60e4230$var$PremiumSupport;

});

parcelRegister("3aflv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24e71bd7145f9df7$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $3FBn4 = parcelRequire("3FBn4");
const $24e71bd7145f9df7$var$RegionalSupport = ()=>{
    const localizedHref = (0, $3FBn4.useLocalizedHref)("/enterprise/support-services");
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "ConfluencePricingPageTeam24.features.regionalSupport.content.body",
                defaultMessage: "Customer support during business hours is available with Confluence Standard plan. <a>Learn more.</a>",
                values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-track-event": "ConfluencePricingPageTeam24.regionalSupport.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            "data-label-english": "learn more",
                            href: localizedHref,
                            children: chunks
                        })
                })
            })
        })
    });
};
var $24e71bd7145f9df7$export$2e2bcd8739ae039 = $24e71bd7145f9df7$var$RegionalSupport;

});

parcelRegister("2ZdCZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98f7f6759ea462a8$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $3FBn4 = parcelRequire("3FBn4");
const $98f7f6759ea462a8$var$SupportAppsIntegrations = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "ConfluencePricingPageTeam24.features.supportAppsIntegrations.content.body",
                defaultMessage: "Integrate Confluence with other apps you\u2019re already using. <a>Learn more.</a>",
                values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "Learn More",
                            "data-track-event": "ConfluencePricingPageTeam24.supportAppsIntegrations.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: "https://marketplace.atlassian.com/search?product=confluence",
                            children: chunks
                        })
                })
            })
        })
    });
};
var $98f7f6759ea462a8$export$2e2bcd8739ae039 = $98f7f6759ea462a8$var$SupportAppsIntegrations;

});

parcelRegister("1P2k8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24f970dc92a80157$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $3FBn4 = parcelRequire("3FBn4");
const $24f970dc92a80157$var$SupportAtlassianCommunity = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "ConfluencePricingPageTeam24.features.supportAtlassianCommunity.content.body",
                defaultMessage: "Get support from the <a>Atlassian Community</a>, a public forum of community experts where you can ask questions. You can also access free Confluence guides and knowledge base articles.",
                values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-track-event": "ConfluencePricingPageTeam24.supportAtlassianCommunity",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            "data-label-english": "Atlassian Community",
                            href: "https://community.atlassian.com/",
                            children: chunks
                        })
                })
            })
        })
    });
};
var $24f970dc92a80157$export$2e2bcd8739ae039 = $24f970dc92a80157$var$SupportAtlassianCommunity;

});

parcelRegister("kI6cN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a34a0d8d5dad7c6$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $3FBn4 = parcelRequire("3FBn4");
const $1a34a0d8d5dad7c6$var$Templates = ()=>{
    const localizedHref = (0, $3FBn4.useLocalizedHref)("/software/confluence/templates");
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "ConfluencePricingPageTeam24.features.templates.content.body",
                defaultMessage: "Get started quickly by using the <a>template library</a>. From product requirement documents to marketing plans, there\u2019s a template that\u2019s perfect fit for your project.",
                values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-track-event": "ConfluencePricingPageTeam24.templates",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            "data-label-english": "template libary",
                            href: localizedHref,
                            children: chunks
                        })
                })
            })
        })
    });
};
var $1a34a0d8d5dad7c6$export$2e2bcd8739ae039 = $1a34a0d8d5dad7c6$var$Templates;

});

parcelRegister("6lyI0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $264fd08a9392e377$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
const $264fd08a9392e377$var$UnlimitedPages = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "ConfluencePricingPageTeam24.features.unlimitedPages.content.body",
                defaultMessage: "Pages are used to create, share, and edit knowledge. These are living documents you can create and update for almost anything \u2013 from project plans, meeting notes, policies and more. You can create as many pages as you need."
            })
        })
    });
};
var $264fd08a9392e377$export$2e2bcd8739ae039 = $264fd08a9392e377$var$UnlimitedPages;

});

parcelRegister("hUmbv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $524a5d86f54b9884$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
const $524a5d86f54b9884$var$UnlimitedSpaces = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "ConfluencePricingPageTeam24.features.unlimitedSpaces.content.body",
                defaultMessage: "Spaces are how you organize pages into meaningful categories, like different folders where you can store your work. You can create as many spaces as you need."
            })
        })
    });
};
var $524a5d86f54b9884$export$2e2bcd8739ae039 = $524a5d86f54b9884$var$UnlimitedSpaces;

});

parcelRegister("4VuTU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da29af2b3ed7fe0b$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $3FBn4 = parcelRequire("3FBn4");
const $da29af2b3ed7fe0b$var$UnlimitedWhiteboards = ()=>{
    const localizedHref = (0, $3FBn4.useLocalizedHref)("/software/confluence/whiteboards");
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "ConfluencePricingPageTeam24.features.unlimitedWhiteboards.content.body",
                defaultMessage: "Confluence whiteboards brings the flexibility of a digital whiteboard into your team workspace. With Premium, unlock unlimited whiteboards and advanced Jira integrations to brainstorm, plan and action work like never before. <a>Learn more.</a>",
                values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-track-event": "ConfluencePricingPageTeam24.unlimitedWhiteboards.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            "data-label-english": "learn more",
                            href: localizedHref,
                            children: chunks
                        })
                })
            })
        })
    });
};
var $da29af2b3ed7fe0b$export$2e2bcd8739ae039 = $da29af2b3ed7fe0b$var$UnlimitedWhiteboards;

});


parcelRegister("bjKLz", function(module, exports) {

$parcel$export(module.exports, "JiraPriceFinder", function () { return $c4aa43a1bfe26f2a$export$1bf486cdabb14f4d; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $6x1qA = parcelRequire("6x1qA");
var $f6qj2 = parcelRequire("f6qj2");

var $7OWgU = parcelRequire("7OWgU");

var $l9lQF = parcelRequire("l9lQF");

var $lWfjr = parcelRequire("lWfjr");

var $fSTxy = parcelRequire("fSTxy");

var $bjbOY = parcelRequire("bjbOY");

var $gQkgx = parcelRequire("gQkgx");

var $hGkkE = parcelRequire("hGkkE");

var $b8Tg2 = parcelRequire("b8Tg2");

var $ctfql = parcelRequire("ctfql");

var $6gIGi = parcelRequire("6gIGi");

var $5pDrs = parcelRequire("5pDrs");

var $1WQVf = parcelRequire("1WQVf");

var $gRL90 = parcelRequire("gRL90");

var $cTE0i = parcelRequire("cTE0i");

var $3ZjQm = parcelRequire("3ZjQm");
const $c4aa43a1bfe26f2a$export$1bf486cdabb14f4d = (props)=>{
    var _props_pricing_ccpPricingData, _props_pricing;
    const intl = (0, $f6qj2.default)();
    const newTagText = intl.formatMessage({
        id: "JiraSoftwarePricingPage.priceFinder.newTagText",
        defaultMessage: "New"
    });
    const freePlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.unlimitedProjectBoards.title.v2",
                    defaultMessage: "Unlimited goals, projects, tasks, and forms"
                }),
                content: (0, $cTE0i.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.backlogAndTimeline.title",
                    defaultMessage: "Backlog, list, board, timeline, calendar, and summary views"
                }),
                content: (0, $bjbOY.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.reportsAndDashboards.title",
                    defaultMessage: "Reports and dashboards"
                }),
                content: (0, $6gIGi.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.freeAutomations.title",
                    defaultMessage: "100 automation rule runs per month"
                }),
                content: (0, $fSTxy.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "JiraSoftwarePricingPage.priceFinder.freePlan2GBOfStorage",
                defaultMessage: "2 GB of storage"
            })
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.freeCommunitySupport.title",
                    defaultMessage: "Support from Atlassian Community"
                }),
                content: (0, $5pDrs.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.features.upTo10Users.title",
                defaultMessage: "Up to 10 users"
            })
        }
    ];
    const standardPlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.userRolesPermissions.title",
                    defaultMessage: "User roles and permissions"
                }),
                content: (0, $3ZjQm.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.externalCollaboration.title",
                    defaultMessage: "External collaboration"
                }),
                content: (0, $b8Tg2.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.multiRegionDataResidency.title",
                    defaultMessage: "Multi-region data residency"
                }),
                content: (0, $ctfql.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.standardAutomations.title",
                    defaultMessage: "1,700 automation rule runs per month"
                }),
                content: (0, $fSTxy.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.features.standardStorage.title",
                defaultMessage: "250 GB of storage"
            })
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.standardSupport.title",
                    defaultMessage: "9/5 regional support"
                }),
                content: (0, $gRL90.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.features.standard5000singlesSite.title",
                defaultMessage: "Up to 100,000 users on a single site"
            })
        }
    ];
    const premiumPlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.aiPowered.title.v2",
                    defaultMessage: "Generate, summarize, and search content with Atlassian Intelligence (AI)"
                }),
                content: (0, $lWfjr.default)
            },
            lozengeText: newTagText
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.crossTeamPlanning.title",
                    defaultMessage: "Cross-team planning and dependency management"
                }),
                content: (0, $gQkgx.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.customizableApprovalProcesses.title",
                    defaultMessage: "Customizable approval processes"
                }),
                content: (0, $hGkkE.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.premiumAutomation.title",
                    defaultMessage: "Per user automation limits (1,000 rule runs per month)"
                }),
                content: (0, $fSTxy.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.features.unlimitedStorage.title",
                defaultMessage: "Unlimited storage"
            })
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.premiumSupport.title",
                    defaultMessage: "24/7 support for critical issues"
                }),
                content: (0, $1WQVf.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.features.premiumSla.title",
                defaultMessage: "99.9% uptime SLA"
            })
        }
    ];
    const signupLimit = 100000;
    // planNames should not be translated
    const jswProductPlans = [
        {
            planName: "Free",
            offeringSku: "jira-software-free",
            description: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.priceFinder.freeDescription",
                defaultMessage: "Free forever for 10 users"
            }),
            recommendationLimit: 0,
            signupLimit: signupLimit,
            signupURLSuffix: "?bundle=jira-software&edition=free",
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: "Standard",
            offeringSku: "jira-software-standard",
            description: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.priceFinder.standardDescription",
                defaultMessage: "Everything you need to get started"
            }),
            recommendationLimit: 10,
            signupLimit: signupLimit,
            signupURLSuffix: "?bundle=jira-software&edition=standard",
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: "Premium",
            offeringSku: "jira-software-premium",
            description: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.priceFinder.premiumDescription",
                defaultMessage: "Align multiple teams"
            }),
            recommendationLimit: 250,
            signupLimit: signupLimit,
            signupURLSuffix: "?bundle=jira-software&edition=premium",
            planFeatureMessages: premiumPlanFeatureMessages
        }
    ];
    const messages = (0, $6x1qA.defineMessages)({
        headerText: {
            id: "JiraSoftwarePricingPageV2.priceFinder.header",
            defaultMessage: "<blue>Simple, transparent pricing</blue> for every team."
        },
        unitCountInputText: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputText",
            defaultMessage: "How many users are on your team?"
        },
        unitCountInputTextRedesign: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputDirectBuy: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputDirectBuy",
            defaultMessage: "What's your team size?"
        },
        unitCountInputTerm: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        billingCycleText: {
            id: "JiraSoftwarePricingPage.priceFinder.billingCycleText",
            defaultMessage: "Billing cycle:"
        },
        unitCountInputTooltip: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputTooltip",
            defaultMessage: "A Jira Software user is any user who can log in to Jira Software, and who exists in User Management"
        },
        cardOverSignupLimit: {
            id: "JiraSoftwarePricingPage.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "JiraSoftwarePricingPage.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "JiraSoftwarePricingPage.priceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "JiraSoftwarePricingPageV2.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        },
        cardFreeDescription: {
            id: "JiraSoftwarePricingPage.priceFinder.cardFreeDescription",
            defaultMessage: "Always free for 10 users"
        }
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $l9lQF.PriceFinderContextProvider), {
            productPlans: jswProductPlans,
            dataProductKey: "jiraSoftware",
            defaultUnitCount: 150,
            shouldAddDiscount: props.shouldAddDiscount,
            ctaUrlSource: "productPlans",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OWgU.default), {
                messages: messages,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.jiraSoftware,
                countryCode: props.countryCode
            })
        })
    });
};
$c4aa43a1bfe26f2a$export$1bf486cdabb14f4d.displayName = "JiraPriceFinder";

});
parcelRegister("lWfjr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ab2f587e3930128$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
const $2ab2f587e3930128$var$AtlassianIntelligence = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePricingPageTeam24.features.aiPowered.content.body.v2",
                defaultMessage: "Get more done with AI-powered summaries, generative AI editing, and natural language to build automations or search issues."
            })
        })
    });
};
var $2ab2f587e3930128$export$2e2bcd8739ae039 = $2ab2f587e3930128$var$AtlassianIntelligence;

});

parcelRegister("fSTxy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ea6e7f96b0fab27$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
const $7ea6e7f96b0fab27$var$Automations = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePricingPageTeam24.features.automations.content.body",
                defaultMessage: "Increase efficiency by replacing manual, time-consuming work with automated processes and workflows."
            })
        })
    });
};
var $7ea6e7f96b0fab27$export$2e2bcd8739ae039 = $7ea6e7f96b0fab27$var$Automations;

});

parcelRegister("bjbOY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6677cbc31fb00da1$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
const $6677cbc31fb00da1$var$Backlog = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePricingPageTeam24.features.backlogAndTimeline.content.body",
                defaultMessage: "Choose from different views to support your way of working."
            })
        })
    });
};
var $6677cbc31fb00da1$export$2e2bcd8739ae039 = $6677cbc31fb00da1$var$Backlog;

});

parcelRegister("gQkgx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8e3551115d5796b$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
const $e8e3551115d5796b$var$CrossTeamPlanning = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePricingPageTeam24.features.crossTeamPlanning.content.body",
                defaultMessage: "Plan and track goals, projects, and dependencies in one place."
            })
        })
    });
};
var $e8e3551115d5796b$export$2e2bcd8739ae039 = $e8e3551115d5796b$var$CrossTeamPlanning;

});

parcelRegister("hGkkE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40495166fc2bb76f$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
const $40495166fc2bb76f$var$CustomizableApprovalProcesses = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePricingPageTeam24.features.customizableApprovalProcesses.content.body",
                defaultMessage: "Add approval steps to your workflows to get required signoffs."
            })
        })
    });
};
var $40495166fc2bb76f$export$2e2bcd8739ae039 = $40495166fc2bb76f$var$CustomizableApprovalProcesses;

});

parcelRegister("b8Tg2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34e0801b48623fd9$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
const $34e0801b48623fd9$var$ExternalCollaboration = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePricingPageTeam24.features.externalCollaboration.content.body",
                defaultMessage: "Give people outside your org anonymous access to Jira projects."
            })
        })
    });
};
var $34e0801b48623fd9$export$2e2bcd8739ae039 = $34e0801b48623fd9$var$ExternalCollaboration;

});

parcelRegister("ctfql", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $474ae7d68248ce0e$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
const $474ae7d68248ce0e$var$MultiRegionDataResidency = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePricingPageTeam24.features.multiRegionDataResidency.content.body",
                defaultMessage: "Specify where your content and data are hosted."
            })
        })
    });
};
var $474ae7d68248ce0e$export$2e2bcd8739ae039 = $474ae7d68248ce0e$var$MultiRegionDataResidency;

});

parcelRegister("6gIGi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $562ef5fdc4fe6c2a$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
const $562ef5fdc4fe6c2a$var$ReportsAndDashboards = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePricingPageTeam24.features.reportsAndDashboards.content.body",
                defaultMessage: "Get insights on teamwork tracked in any Jira product or project."
            })
        })
    });
};
var $562ef5fdc4fe6c2a$export$2e2bcd8739ae039 = $562ef5fdc4fe6c2a$var$ReportsAndDashboards;

});

parcelRegister("5pDrs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55a4d7c6dd8c0161$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
const $55a4d7c6dd8c0161$var$CommunitySupport = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePricingPageTeam24.features.freeCommunitySupport.content.body",
                defaultMessage: "Find answers and support from other Atlassian users."
            })
        })
    });
};
var $55a4d7c6dd8c0161$export$2e2bcd8739ae039 = $55a4d7c6dd8c0161$var$CommunitySupport;

});

parcelRegister("1WQVf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e6deb9f379aa453$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
const $7e6deb9f379aa453$var$PremiumSupport = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePricingPageTeam24.features.premiumSupport.content.body",
                defaultMessage: "1-hr response time for critical issues from Cloud support team."
            })
        })
    });
};
var $7e6deb9f379aa453$export$2e2bcd8739ae039 = $7e6deb9f379aa453$var$PremiumSupport;

});

parcelRegister("gRL90", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1d1f294f71fb270$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
const $a1d1f294f71fb270$var$StandardSupport = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePricingPageTeam24.features.standardSupport.content.body",
                defaultMessage: "2-hr response time for critical issues from Cloud support team."
            })
        })
    });
};
var $a1d1f294f71fb270$export$2e2bcd8739ae039 = $a1d1f294f71fb270$var$StandardSupport;

});

parcelRegister("cTE0i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f29a583b1dd0e3a$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
const $6f29a583b1dd0e3a$var$UnlimitedProjects = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePricingPageTeam24.features.unlimitedProjectBoards.content.body.v2",
                defaultMessage: "Align projects and tasks to goals. Collect data with forms."
            })
        })
    });
};
var $6f29a583b1dd0e3a$export$2e2bcd8739ae039 = $6f29a583b1dd0e3a$var$UnlimitedProjects;

});

parcelRegister("3ZjQm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6bf83a0beed5fdd$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
const $f6bf83a0beed5fdd$var$UserRolesPermissions = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwarePricingPageTeam24.features.userRolesPermissions.content.body",
                defaultMessage: "Control what users can create, view, and comment on in Jira."
            })
        })
    });
};
var $f6bf83a0beed5fdd$export$2e2bcd8739ae039 = $f6bf83a0beed5fdd$var$UserRolesPermissions;

});


parcelRegister("1i2j7", function(module, exports) {

$parcel$export(module.exports, "Banner", function () { return $0bd224af77217624$export$3b4e64e77073e307; });
/* banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $7xXmN = parcelRequire("7xXmN");
const $0bd224af77217624$var$bannerContainerCss = null;
const $0bd224af77217624$var$bodyCss = null;
const $0bd224af77217624$export$3b4e64e77073e307 = ()=>{
    const ctaHref = "https://community.atlassian.com/t5/Nonprofit-articles/New-nonprofit-discounts-for-Loom-and-Rovo/ba-p/2877008";
    const isGwp7869 = (0, $7xXmN.getIsGwp7869)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_bfhk17la _1e0c1txw _1bah1h6o _y3gn1e5h _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _uj6k1h6o"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_syazu67f _1wyb7vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fbxu3 _1bsb1osq _1kny1nu9 _13pm1r31 _1dzg8stv _t1u2nqa1"
            ]),
            children: [
                isGwp7869 && /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "NonprofitPage.banner.body.gwp7869",
                    defaultMessage: "Social Enterprises are now eligible for Atlassian\u2019s discounted apps and support programs!"
                }),
                !isGwp7869 && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "NonprofitPage.banner.body.team25eu",
                            defaultMessage: "Loom and Rovo are now available at 75% off for eligible nonprofits."
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                text: "Learn more.",
                                className: "link-modifier",
                                href: ctaHref,
                                anchorProps: {
                                    "data-testid": "banner-cta-link"
                                },
                                bgColor: "bgBlackBlue"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("7xXmN", function(module, exports) {

$parcel$export(module.exports, "getIsGwp7869", function () { return $2e1f1017dbb27c43$export$add1777993af4ed8; });

var $gAJUc = parcelRequire("gAJUc");
function $2e1f1017dbb27c43$export$add1777993af4ed8() {
    return (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7869NonprofitPricingPageUpdates);
}

});


parcelRegister("jQiaD", function(module, exports) {

$parcel$export(module.exports, "EligibleSection", function () { return $2953788f48e21931$export$1830bba02ce6e4ac; });
/* eligible-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $7xXmN = parcelRequire("7xXmN");

var $89Z0c = parcelRequire("89Z0c");
const $2953788f48e21931$var$eligibleContainerCss = null;
const $2953788f48e21931$var$headerCss = null;
const $2953788f48e21931$var$subtitleCss = null;
const $2953788f48e21931$var$ctaBlockCss = null;
const $2953788f48e21931$var$ctaBlockContentCss = null;
const $2953788f48e21931$var$ctaBlockTitleCss = null;
const $2953788f48e21931$var$ctaBlockDetailCss = null;
const $2953788f48e21931$var$imageCss = null;
const $2953788f48e21931$export$1830bba02ce6e4ac = ()=>{
    const intl = (0, $f6qj2.default)();
    const isGwp7869 = (0, $7xXmN.getIsGwp7869)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_1wybzwfg _vwz410mc _k48p9y44 _19pkidpf _2hwxidpf _otyrdlk8 _18u0idpf _1s18ckbl _17gqckbl _15flidpf _1d2widpf _1svy7vkz _seovidpf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "NonprofitPage.eligible.header",
                    defaultMessage: "Who\u2019s eligible"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                className: (0, $esG4f.default)([
                    "_1wyb7vkz _vwz41tcg _k48p1nn1 _19pkidpf _2hwx1wug _otyr19bv _18u01wug _1s18gktf _17gq1f4h _b8yqbxu3 _15flidpf _1d2w1wug _1svygktf _seov1wug _3p1c1f4h _py5o1ylp _10jx1osq"
                ]),
                children: isGwp7869 ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "NonprofitPage.eligible.subtitle.gwp7869",
                    defaultMessage: "Discounts on Atlassian Cloud apps are available to nonprofits and social enterprises that are:"
                }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "NonprofitPage.eligible.subtitle",
                    defaultMessage: "If you\u2019re ready to move beyond the free license, 75% discounts on Atlassian Cloud apps are available to nonprofit organizations that are:"
                })
            }),
            isGwp7869 ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $89Z0c.EligibilityListGwp7869), {}) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $89Z0c.EligibilityList), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bah1h6o _1bsb1osq _19pk12am _2hwxidpf _otyridpf _18u0idpf _1lrw1sh2 _12veeva1 _ca0q4bvh _u5f37vkz _n3td4bvh _19bv7vkz _kqswh2mm _1itk1sc7 _13hp18tu _b2g019fs _i6jx16xz _1lh77vkz _z3nc16xz _wpai7vkz _1vkhvle5 _7uci11oj _2cw21ssb _1l142xu9"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _1bah1h6o _1ako7vkz _c7s77vkz _4puvzwfg _1r3v7vkz"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                            className: (0, $esG4f.default)([
                                "_1wyb1tcg _vwz41ul9 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "NonprofitPage.eligible.cta.title",
                                defaultMessage: "Need more info?"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: (0, $esG4f.default)([
                                "_1wyb7vkz _vwz41tcg"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "NonprofitPage.eligible.cta.content",
                                defaultMessage: "Get the answers for your most frequently asked eligibility questions."
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                            text: intl.formatMessage({
                                id: "NonprofitPage.eligible.cta.content.link",
                                defaultMessage: "Learn more"
                            }),
                            href: "#faq",
                            type: "primary",
                            dataEventProps: {
                                "data-event-component": "linkButton",
                                // @ts-ignore
                                "data-event-container": "Eligibility section",
                                "data-event": "clicked",
                                "data-product-key": "nonProfitCalculator"
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_p12f1obz _c71l7iqz _kqswstnw _rjxp1wqo _u7co15qf _mezj12it _bna712it _p5ceka7h _enhl9by0 _j0lc1osq _1jtm1osq _1t06x19p _wtm5ka7h"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                image: {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8fhb444317uecxj0n4dy144u8atr503c.webp",
                                    alt: ""
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
};
$2953788f48e21931$export$1830bba02ce6e4ac.displayName = "EligibleSection";

});
parcelRegister("89Z0c", function(module, exports) {

$parcel$export(module.exports, "EligibilityList", function () { return $db2b53eed69986d6$export$5a8c33720cbdacee; });
$parcel$export(module.exports, "EligibilityListGwp7869", function () { return $db2b53eed69986d6$export$c64766b093b22842; });
/* eligibility-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");
const $db2b53eed69986d6$export$5a8c33720cbdacee = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("ul", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1n261g80 _1bah1yb4 _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1cqi1ssb _498vusvi _1gee7vkz _18ts7vkz _75fp7vkz _r0eh7vkz _1yp81x1l"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)($db2b53eed69986d6$var$NonGovernmental, {}),
            /*#__PURE__*/ (0, $loA2J.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: {
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1665m6o0xxrphegnh7lnwf17585pj211.svg",
                            alt: ""
                        }
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                        className: (0, $esG4f.default)([
                            "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf _1s181tcg _17gq1ul9"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "NonprofitPage.card.title2",
                            defaultMessage: "Non-commercial"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fpcwi"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "NonprofitPage.card.content2",
                            defaultMessage: "operating on a not-for-profit basis and for the public benefit"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)($db2b53eed69986d6$var$NonPolitical, {}),
            /*#__PURE__*/ (0, $loA2J.jsx)($db2b53eed69986d6$var$Nonprofit, {})
        ]
    });
};
const $db2b53eed69986d6$export$c64766b093b22842 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("ul", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1n261g80 _1bah1yb4 _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1cqi1ssb _498vusvi _1gee7vkz _18ts7vkz _75fp7vkz _r0eh7vkz _1yp81x1l"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)($db2b53eed69986d6$var$NonGovernmental, {}),
            /*#__PURE__*/ (0, $loA2J.jsx)($db2b53eed69986d6$var$NonPolitical, {}),
            /*#__PURE__*/ (0, $loA2J.jsx)($db2b53eed69986d6$var$Nonprofit, {}),
            /*#__PURE__*/ (0, $loA2J.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: {
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1665m6o0xxrphegnh7lnwf17585pj211.svg",
                            alt: ""
                        }
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                        className: (0, $esG4f.default)([
                            "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf _1s181tcg _17gq1ul9"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "NonprofitPage.card.socialMissionTitle",
                            defaultMessage: "For-profit with a social mission"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fpcwi"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "NonprofitPage.card.socialMissionContent",
                            defaultMessage: "<a>as defined by Atlassian</a> and verified by Goodstack",
                            values: {
                                a: (chunks)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                        href: "#faq",
                                        className: (0, $esG4f.default)([
                                            "_syaz17la _4bfu1r31 _1hms8stv _ajmmnqa1"
                                        ]),
                                        style: {
                                            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                                        },
                                        children: chunks
                                    })
                            }
                        })
                    })
                ]
            })
        ]
    });
};
const $db2b53eed69986d6$var$NonGovernmental = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4vunf5vd4cboe8glor3vep3mam3a3d0o.svg",
                    alt: ""
                }
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                className: (0, $esG4f.default)([
                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf _1s181tcg _17gq1ul9"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "NonprofitPage.card.title1",
                    defaultMessage: "Non-governmental"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fpcwi"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "NonprofitPage.card.content1",
                    defaultMessage: "independent from government control"
                })
            })
        ]
    });
};
const $db2b53eed69986d6$var$NonPolitical = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/k1y270i4t5e33yp8hw62tn3l37850050.svg",
                    alt: ""
                }
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                className: (0, $esG4f.default)([
                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf _1s181tcg _17gq1ul9"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "NonprofitPage.card.title3",
                    defaultMessage: "Non-political"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fpcwi"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "NonprofitPage.card.content3",
                    defaultMessage: "or against any political party, candidate, or campaign"
                })
            })
        ]
    });
};
const $db2b53eed69986d6$var$Nonprofit = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8q882ia8oh77fl481x8f01up4y2a2q18.svg",
                    alt: ""
                }
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                className: (0, $esG4f.default)([
                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf _1s181tcg _17gq1ul9"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "NonprofitPage.card.title4",
                    defaultMessage: "Recognized as a nonprofit"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fpcwi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "NonprofitPage.card.content4",
                        defaultMessage: "in the country in which you are registered, in accordance with the "
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                        target: "_blank",
                        href: "https://goodstack.org/nonprofit-definitions",
                        rel: "noreferrer",
                        className: (0, $esG4f.default)([
                            "_syaz17la _4bfu1r31 _1hms8stv _ajmmnqa1"
                        ]),
                        style: {
                            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "NonprofitPage.card.content4.link",
                            defaultMessage: "eligibility criteria for that country"
                        })
                    })
                ]
            })
        ]
    });
};
const $db2b53eed69986d6$var$rowWrapperCss = null;
const $db2b53eed69986d6$var$cardTitleCss = null;
const $db2b53eed69986d6$var$cardContentCss = null;
const $db2b53eed69986d6$var$cardContentLinkCss = null;

});


parcelRegister("eM8Nf", function(module, exports) {

$parcel$export(module.exports, "EnterpriseSection", function () { return $f607768face98985$export$f366cf0ae8139431; });
/* enterprise-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $7xXmN = parcelRequire("7xXmN");
const $f607768face98985$export$f366cf0ae8139431 = ()=>{
    const isGwp7869 = (0, $7xXmN.getIsGwp7869)();
    const localizedCTAHRef = (0, $3FBn4.useLocalizedHref)("/software/views/community-license-request#/");
    const containerStyles = null;
    const pictureStyles = null;
    const contentBlockStyles = null;
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c11p5 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1bsb1osq _p12f5o3v _zulpoahv _yv0ewxkt _4cvr1h6o _y3gn1e5h _1ph4hkll _gu181h6o _1qgn1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: {
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/scjwn81w6s2ardgn7641002jp2ye5252.svg",
                            alt: ""
                        },
                        className: (0, $esG4f.default)([
                            "_6rthpxbi"
                        ])
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                        headerType: "h3",
                        headerText: isGwp7869 ? intl.formatMessage({
                            id: "NonprofitPage.enterprise-section.heading.gwp7869",
                            defaultMessage: "Enterprise plans are 50% off for eligible nonprofits and social enterprises."
                        }) : intl.formatMessage({
                            id: "NonprofitPage.enterprise-section.heading",
                            defaultMessage: "Enterprise plans are 50% off for eligible nonprofits."
                        }),
                        ctaProps: {
                            buttonProps: {
                                text: intl.formatMessage({
                                    id: "NonprofitPage.enterprise-section.cta",
                                    defaultMessage: "Apply now"
                                }),
                                url: localizedCTAHRef
                            }
                        },
                        className: (0, $esG4f.default)([
                            "_1axibfyo _r8ntni7l _ggmhxy5q _qliy1hlo"
                        ]),
                        style: {
                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1rg21ssb _1h6o1ssb _rtys1osq _15pj1osq _bna71wug _1r2v1wug _1cr61wug _dusl1wug _1hlx1wug _atom1wug _18741wug _2t2f1wug _10ew1wug _1iya1wug"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/334g168on374sch67v7r1lrv174i8psc.webp",
                        alt: ""
                    }
                })
            })
        ]
    });
};
$f607768face98985$export$f366cf0ae8139431.displayName = "EnterpriseSection";

});

parcelRegister("6HCAP", function(module, exports) {

$parcel$export(module.exports, "Fineprint", function () { return $ff6c91ea14101a83$export$3fb2e06c2eeca703; });
/* fineprint.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
const $ff6c91ea14101a83$var$fineprintContainerCss = null;
const $ff6c91ea14101a83$var$headerCss = null;
const $ff6c91ea14101a83$var$bodyCss = null;
const $ff6c91ea14101a83$export$3fb2e06c2eeca703 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_1wybzwfg _k48p9y44 _19pkidpf _2hwxidpf _otyrdlk8 _18u0idpf _1s18ckbl _15flidpf _1d2widpf _1svy7vkz _seovidpf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "NonprofitPage.fineprint.header",
                    defaultMessage: "The fine print"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_1wyb7vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fbxu3"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "NonprofitPage.fineprint.body",
                    defaultMessage: "Atlassian aims to unleash the potential of every team, including nonprofits and social enterprises, but not every organization may meet Atlassian\u2019s Community License eligibility criteria."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("br", {}),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_1wyb7vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fbxu3"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "NonprofitPage.fineprint.body.additional",
                    defaultMessage: "Atlassian verifies Community License eligibility in partnership with Goodstack, yet determines qualification for discounted licenses at its sole discretion. We reserve the right to grant or deny an individual or organization\u2019s application for a discounted license, or to discontinue an active discounted license, at any time, for any reason, and to supplement or amend our Community License eligibility guidelines at any time."
                })
            })
        ]
    });
};
$ff6c91ea14101a83$export$3fb2e06c2eeca703.displayName = "FineprintSection";

});

parcelRegister("cVHP2", function(module, exports) {

$parcel$export(module.exports, "Hero", function () { return $066e3ad99877e83f$export$887967f05dc521ae; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $91nJf = parcelRequire("91nJf");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $7xXmN = parcelRequire("7xXmN");
const $066e3ad99877e83f$var$heroContainerCss = null;
const $066e3ad99877e83f$var$contentBoxCss = null;
const $066e3ad99877e83f$var$preheaderCss = null;
const $066e3ad99877e83f$var$titleCss = null;
const $066e3ad99877e83f$var$subtitleCss = null;
const $066e3ad99877e83f$var$mobileImageCss = null;
const $066e3ad99877e83f$export$887967f05dc521ae = ()=>{
    const ctaButtonUrl = "/software/views/community-license-request#/";
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _1reo15vq _18m915vq _1bsb1osq _1gnk1029 _p17a18tu _1u5reva1 _rb2g8y3i _ij141rp3 _1odr1on4 _18xueva1 _1o60asht"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_syaz1hlo _y3gn1h6o _kqswh2mm _1q51zwfg _p12f1fra _1waf16xz _44j9idpf _1tz91y44 _1enu1f4h"
            ]),
            style: {
                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("h5", {
                    className: (0, $esG4f.default)([
                        "_1wybf6fq _vwz41ou6 _1pfhidpf _6rth1skh _k48p1fw0 _1s18gktf _17gq1f4h _1ob91tcg"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "NonprofitPage.hero.preheader",
                        defaultMessage: "ATLASSIAN FOR NONPROFITS"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                    className: (0, $esG4f.default)([
                        "_1wyb1wqb _vwz4ymf6 _k48p1nn1 _1pfhidpf _6rthf6fq _1s18ymf6 _17gqys9h _b8yq1ogm _jhy41nn1"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "NonprofitPage.hero.title",
                        defaultMessage: "Pricing that fits your nonprofit\u2019s budget"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                    className: (0, $esG4f.default)([
                        "_1wybgktf _vwz41f4h _p12f1178 _k48powjs _19pkidpf _2hwx1wug _otyr1skh _18u01wug _1s181f4h _17gq1ylp _b8yq1kdj _15flidpf _1d2w1wug _1svyo7ao _seov1wug"
                    ]),
                    children: (0, $7xXmN.getIsGwp7869)() ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "NonprofitPage.hero.subtitle.gwp7869",
                        defaultMessage: "Get discounted Atlassian apps for nonprofit and social enterprise teams"
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "NonprofitPage.hero.subtitle",
                        defaultMessage: "Get discounted Atlassian tools for nonprofit teams"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                    variant: "primary",
                    size: "small",
                    color: "blue",
                    href: (0, $3FBn4.useLocalizedHref)(ctaButtonUrl),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "NonprofitPage.hero.button",
                        defaultMessage: "Apply now"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswh2mm _1bsbixjv _4t3iva7c _1sjrglyw _mezj1osq _bna71osq"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: {
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8p5v165n7f507j620h6738eoudo17oae.svg",
                            alt: ""
                        }
                    })
                })
            ]
        })
    });
};

});

parcelRegister("joIaB", function(module, exports) {

$parcel$export(module.exports, "NonprofitCalculatorHeading", function () { return $521e9cb1491d1668$export$ea62e9564a56df6c; });
/* nonprofit-calculator-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $7xXmN = parcelRequire("7xXmN");
const $521e9cb1491d1668$export$ea62e9564a56df6c = ()=>{
    const headingStyles = null;
    const subtitleStyles = null;
    const imgStyles = null;
    const isGwp7869 = (0, $7xXmN.getIsGwp7869)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _zulpftgi _p12fbxu3 _kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_k48p9y44 _1wyb1ylp _vwz48vuz _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fz8o0 _1s18ckbl _b8yqstmo _syaz1hlo"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "NonprofitPage.calculator.heading",
                    defaultMessage: "Choose the tools and pricing that fit your team"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_p12fkbql _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: isGwp7869 ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "NonprofitPage.calculator.subheading.gwp7869",
                    defaultMessage: "Use our pricing calculator to get a <bold>discounted pricing estimate</bold> available to nonprofits and social enterprises.",
                    values: {
                        bold: (chunks)=>/*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                className: (0, $esG4f.default)([
                                    "_k48p8n31"
                                ]),
                                children: chunks
                            })
                    }
                }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "NonprofitPage.calculator.subheading",
                    defaultMessage: "Use our pricing calculator to compare offerings and get a pricing estimate with a nonprofit discount."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/27360l8wso6a72x4e44yyg66uak8r51f.svg",
                    alt: ""
                },
                className: (0, $esG4f.default)([
                    "_1e0cglyw _kqswstnw _4t3ivrzy _1bsb1dqv _mmgk1wqo _kzvi1ule _11901pbv _dm251ule"
                ])
            })
        ]
    });
};
$521e9cb1491d1668$export$ea62e9564a56df6c.displayName = "TabbedCalculatorHeadingSection";

});

parcelRegister("7UazH", function(module, exports) {

$parcel$export(module.exports, "NonprofitNav", function () { return $2c935ee547ee79ae$export$4dfedf5c077d010b; });
/* nonprofit-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $3FBn4 = parcelRequire("3FBn4");

var $cP0Yq = parcelRequire("cP0Yq");
const $2c935ee547ee79ae$var$NonprofitLogo = ()=>{
    const logoCss = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        className: (0, $esG4f.default)([
            "_1e0c1mog _1wyb1k92 _ca0q1ou6 _u5f3idpf _n3tdgktf _19bvidpf _k48pni7l"
        ]),
        children: "Nonprofits"
    });
};
const $2c935ee547ee79ae$export$4dfedf5c077d010b = ()=>{
    const intl = (0, $f6qj2.default)();
    const eligibilityHref = (0, $3FBn4.useLocalizedHref)("/teams/nonprofits/discount-pricing");
    const supportPrograms = (0, $3FBn4.useLocalizedHref)("/teams/nonprofits/support-programs");
    const resource = (0, $3FBn4.useLocalizedHref)("/teams/nonprofits/resources");
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "nonprofit-nav",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
            isShowTryNowLink: false,
            productLogoUrl: "/teams/nonprofits",
            productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($2c935ee547ee79ae$var$NonprofitLogo, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "NonprofitPageTemplate.navbar.nonprofit-logo",
                defaultMessage: "Nonprofit logo"
            }),
            mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($2c935ee547ee79ae$var$NonprofitLogo, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "NonprofitPageTemplate.navbar.pricing",
                        defaultMessage: "Eligibility and pricing"
                    }),
                    hasSubnav: false,
                    productKey: "nonprofit",
                    href: eligibilityHref
                },
                {
                    globalLinksKey: "support",
                    linkText: intl.formatMessage({
                        id: "NonprofitPageTemplate.navbar.support",
                        defaultMessage: "Support programs"
                    }),
                    hasSubnav: false,
                    productKey: "nonprofit",
                    href: supportPrograms
                },
                {
                    globalLinksKey: "resources",
                    linkText: intl.formatMessage({
                        id: "NonprofitPageTemplate.navbar.resources",
                        defaultMessage: "Resources"
                    }),
                    hasSubnav: false,
                    productKey: "nonprofit",
                    href: resource
                }
            ],
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-nonprofit",
                    mobileLinksProps: [
                        {
                            globalLinksKey: "pricing",
                            linkText: intl.formatMessage({
                                id: "NonprofitPageTemplate.navbar.pricing",
                                defaultMessage: "Eligibility and pricing"
                            }),
                            hasSubnav: false,
                            productKey: "nonprofit",
                            href: eligibilityHref
                        },
                        {
                            globalLinksKey: "support",
                            linkText: intl.formatMessage({
                                id: "NonprofitPageTemplate.navbar.support",
                                defaultMessage: "Support programs"
                            }),
                            hasSubnav: false,
                            productKey: "nonprofit",
                            href: supportPrograms
                        },
                        {
                            globalLinksKey: "resources",
                            linkText: intl.formatMessage({
                                id: "NonprofitPageTemplate.navbar.resources",
                                defaultMessage: "Resources"
                            }),
                            hasSubnav: false,
                            productKey: "nonprofit",
                            href: resource
                        }
                    ]
                }
            ]
        })
    });
};

});

parcelRegister("5qSLn", function(module, exports) {

$parcel$export(module.exports, "OfficialSection", function () { return $cf013017b3bbf9cf$export$dba159851b545af3; });
/* official-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $91nJf = parcelRequire("91nJf");

var $bhreu = parcelRequire("bhreu");

var $3FBn4 = parcelRequire("3FBn4");
const $cf013017b3bbf9cf$var$buttonStyle = null;
const $cf013017b3bbf9cf$var$officialContainerCss = null;
const $cf013017b3bbf9cf$var$headerCss = null;
const $cf013017b3bbf9cf$var$subtitleCss = null;
const $cf013017b3bbf9cf$var$rowWrapperCss = null;
const $cf013017b3bbf9cf$var$cardTitleCss = null;
const $cf013017b3bbf9cf$var$imageCss = null;
const $cf013017b3bbf9cf$export$dba159851b545af3 = ()=>{
    const ctaButtonUrl = "/software/views/community-license-request#/";
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_1wybzwfg _vwz410mc _k48p9y44 _19pkidpf _2hwx1wug _otyrdlk8 _18u01wug _p12f1y37 _1s18ckbl _17gqckbl _b8yqbxu3 _15flidpf _1d2w1wug _1svy7vkz _seov1wug"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "NonprofitPage.official.header",
                    defaultMessage: "Let\u2019s make it official"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                className: (0, $esG4f.default)([
                    "_1wyb7vkz _vwz41tcg _k48p1nn1 _19pkidpf _2hwx1wug _otyr19bv _18u01wug _p12f1y37 _1lzogktf _119z1f4h _lg5ridpf _d97m1wug _1b7egktf _12521wug _3p1c1f4h _py5o1ylp _10jxbxu3 _dbjgidpf _1hvk1wug _isu4gktf _15qm1wug"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "NonprofitPage.official.subtitle",
                    defaultMessage: "Apply to verify your eligibility and receive your discounted Community License. Here\u2019s how it\u2019ll work."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                variant: "primary",
                size: "small",
                color: "blue",
                href: (0, $3FBn4.useLocalizedHref)(ctaButtonUrl),
                className: (0, $esG4f.default)([
                    "_2rko1y44 _19pkidpf _2hwx1wug _otyr1tcg _18u01wug"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "NonprofitPage.hero.button",
                    defaultMessage: "Apply now"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("ul", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1n261g80 _1bah1yb4 _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1cqi1ssb _498vusvi _1gee7vkz _18ts7vkz _75fp7vkz _r0eh7vkz _1yp81x1l"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                image: {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1665m6o0xxrphegnh7lnwf17585pj211.svg",
                                    alt: ""
                                }
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                                className: (0, $esG4f.default)([
                                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "NonprofitPage.official.card.title1.v2",
                                    defaultMessage: "1. Choose your apps, calculate pricing, and sign up for a free plan or trial"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                image: {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ok813kjv073y16g445ogp8yerkv6qvc2.svg",
                                    alt: ""
                                }
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                                className: (0, $esG4f.default)([
                                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "NonprofitPage.official.card.title2",
                                    defaultMessage: "2. Apply for your discounted license"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                image: {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/h1503x520p8bg7w744h810188q4bypf3.svg",
                                    alt: ""
                                }
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                                className: (0, $esG4f.default)([
                                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "NonprofitPage.official.card.title3",
                                    defaultMessage: "3. In 2-3 days, verification approved and received!"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                image: {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/pe077p727atw2c04p00h3ecl1on0p841.svg",
                                    alt: ""
                                }
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                                className: (0, $esG4f.default)([
                                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "NonprofitPage.official.card.title4",
                                    defaultMessage: "4. Discount automatically applied to your subscription and any future upgrades"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_p12f1k4y _c71l4bvh _kqswstnw _rjxp4l2f _u7co1a11 _j6qu146b _1pn4ucft _p5ce16gx _enhl1vuk _j0lc12it _1jtm12it _10jxmgvx _1jc2mhvn _1t0616gx _wtm512it _18oi1osq _1ky91osq"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/g626i0m4331tsgn2313fln510p5578n1.svg",
                        alt: ""
                    }
                })
            })
        ]
    });
};
$cf013017b3bbf9cf$export$dba159851b545af3.displayName = "OfficialSection";

});

parcelRegister("NASPU", function(module, exports) {

$parcel$export(module.exports, "ResourcesSection", function () { return $f6bfc91fce35cda1$export$3f0336208d56829f; });
/* resources-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $5VP5O = parcelRequire("5VP5O");

var $7xXmN = parcelRequire("7xXmN");
const $f6bfc91fce35cda1$var$resourcesContainerCss = null;
const $f6bfc91fce35cda1$var$headerCss = null;
const $f6bfc91fce35cda1$var$subtitleCss = null;
const $f6bfc91fce35cda1$var$ctaBlockCss = null;
const $f6bfc91fce35cda1$var$ctaBlockContentCss = null;
const $f6bfc91fce35cda1$var$ctaBlockTitleCss = null;
const $f6bfc91fce35cda1$var$ctaBlockDetailCss = null;
const $f6bfc91fce35cda1$var$imageCss = null;
const $f6bfc91fce35cda1$var$cardBlockCss = null;
const $f6bfc91fce35cda1$export$3f0336208d56829f = ()=>{
    const intl = (0, $f6qj2.default)();
    const teamCardProps = {
        title: intl.formatMessage({
            id: "NonprofitPage.resources.team.title",
            defaultMessage: "Team up with us"
        }),
        titleAs: "h3",
        body: intl.formatMessage({
            id: "NonprofitPage.resources.team.body",
            defaultMessage: "Get free, customized app and teamwork coaching sessions with Atlassian experts. No question is too big or too small."
        }),
        image: {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/7g2k6ru6bw83f33121usy12j03td6p88.webp",
                alt: "Partners for Nonprofits"
            }
        },
        callToAction: {
            href: (0, $3FBn4.useLocalizedHref)("/teams/nonprofits/support-programs"),
            text: intl.formatMessage({
                id: "NonprofitPage.resources.team.link",
                defaultMessage: "Learn more"
            })
        }
    };
    const isGwp7869 = (0, $7xXmN.getIsGwp7869)();
    const successCardProps = {
        title: isGwp7869 ? intl.formatMessage({
            id: "NonprofitPage.resources.success.title.gwp7869",
            defaultMessage: "Social impact team success stories"
        }) : intl.formatMessage({
            id: "NonprofitPage.resources.success.title",
            defaultMessage: "Nonprofit teams success stories"
        }),
        titleAs: "h3",
        body: intl.formatMessage({
            id: "NonprofitPage.resources.success.body",
            defaultMessage: "Get inspired by teams like yours driving impact with Atlassian apps."
        }),
        image: {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6kp84so85h055h6o517q02jx1qp42p78.webp",
                alt: "Partners for Nonprofits"
            }
        },
        callToAction: {
            href: (0, $3FBn4.useLocalizedHref)("/teams/nonprofits/resources"),
            text: intl.formatMessage({
                id: "NonprofitPage.resources.success.link",
                defaultMessage: "See all use cases"
            })
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_1wybzwfg _vwz410mc _k48p9y44 _19pkidpf _2hwxidpf _otyrdlk8 _18u0idpf _y3gn1h6o _1s18ckbl _17gq8vuz _15flidpf _1d2widpf _1svy7vkz _seovidpf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "NonprofitPage.resources.header.v1",
                    defaultMessage: "Explore resources"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                className: (0, $esG4f.default)([
                    "_1wyb7vkz _vwz41tcg _k48powjs _19pkidpf _2hwx1wug _otyrgktf _18u01wug _y3gn1h6o _1lzogktf _119z1f4h _j6qubxu3 _lg5ridpf _d97m1wug _1b7eldb6 _12521wug _3p1c1f4h _py5o1ylp _10jx1osq"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "NonprofitPage.resources.subtitle",
                    defaultMessage: "While you wait for your Community License to be approved\u2026"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_3intidpf _4fugidpf _1ynqidpf _1j3nidpf _quu71osq _18zx1h90"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                    layout: "6-6",
                    className: (0, $esG4f.default)([
                        "_3intidpf _4fugidpf _1ynqidpf _1j3nidpf _quu71osq _18zx1h90"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5VP5O.Card), (0, $7Knp0._)({}, teamCardProps)),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5VP5O.Card), (0, $7Knp0._)({}, successCardProps))
                    ]
                })
            }),
            !isGwp7869 && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bah1h6o _1bsb1osq _19pk12am _2hwxidpf _otyridpf _18u0idpf _1lrw1sh2 _12veeva1 _kqswh2mm _ca0q10yn _u5f3o7ao _n3td10yn _19bvo7ao _1itk1c7i _13hp18tu _b2g019fs _1vkhvle5 _i6jxidpf _1lh7idpf _z3ncidpf _wpaiidpf _1h3e1ukp _s7vk1ssb _9szs2xu9"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_4cvr1h6o _syazcd5j _1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _1ako7vkz _c7s77vkz _4puvckbl _1r3v7vkz"
                    ]),
                    style: {
                        "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                    },
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_p12fckbl _c71lckbl _6rth19bv"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                image: {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/60gejft8yfd0xxjy5rnc2u822245u1t0.svg",
                                    alt: ""
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                            className: (0, $esG4f.default)([
                                "_1wyb1tcg _vwz41ul9 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "NonprofitPage.resources.cta.title",
                                defaultMessage: "Interested in self-managed apps?"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: (0, $esG4f.default)([
                                "_1wyb7vkz _vwz41tcg"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "NonprofitPage.resources.cta.content",
                                defaultMessage: "Data Center versions for select apps are available for free."
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                            text: intl.formatMessage({
                                id: "NonprofitPage.eligible.cta.content.link",
                                defaultMessage: "Learn more"
                            }),
                            href: "/licensing/purchase-licensing#pricing-discounts",
                            type: "primary",
                            bgColor: "bgBlackBlue",
                            dataEventProps: {
                                "data-event-component": "linkButton",
                                "data-event-container": "resourcesSection",
                                "data-event": "clicked",
                                "data-product-key": "nonProfitCalculator"
                            }
                        })
                    ]
                })
            })
        ]
    });
};
$f6bfc91fce35cda1$export$3f0336208d56829f.displayName = "ResourcesSection";

});

parcelRegister("livCd", function(module, exports) {

$parcel$export(module.exports, "TrelloPriceFinder", function () { return $68ff3930d767775f$export$954e0f4d6ca6524; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $6x1qA = parcelRequire("6x1qA");
var $f6qj2 = parcelRequire("f6qj2");

var $7OWgU = parcelRequire("7OWgU");

var $l9lQF = parcelRequire("l9lQF");
const $68ff3930d767775f$export$954e0f4d6ca6524 = (props)=>{
    var _props_pricing_ccpPricingData, _props_pricing;
    const intl = (0, $f6qj2.default)();
    const freePlanFeatureMessages = [
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.unlimitedCards.title",
                defaultMessage: "Unlimited cards"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.upTo10BoardsPerWorkspace.title",
                defaultMessage: "Up to 10 boards per Workspace"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.unlimitedPowerUpsPerBoard.title",
                defaultMessage: "Unlimited Power-Ups per board"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.unlimitedStorage.title.free",
                defaultMessage: "Unlimited storage (10MB/file)"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.workspaceCommandRuns.title",
                defaultMessage: "250 Workspace command runs per month"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.customBackgroundsAndStickers.title",
                defaultMessage: "Custom backgrounds & stickers"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.unlimitedActivityLog.title",
                defaultMessage: "Unlimited activity log"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.assigneeAndDueDates.title",
                defaultMessage: "Assignee and due dates"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.mobileApps.title",
                defaultMessage: "iOS and Android mobile apps"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.twoFactorAuthentication.title",
                defaultMessage: "2-factor authentication"
            })
        }
    ];
    const standardPlanFeatureMessages = [
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.unlimitedBoards.title",
                defaultMessage: "Unlimited boards"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.advancedChecklists.title",
                defaultMessage: "Advanced checklists"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.customFields.title",
                defaultMessage: "Custom Fields"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.unlimitedStorage.title",
                defaultMessage: "Unlimited storage (250MB/file)"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.workspaceCommandRuns.title",
                defaultMessage: "1,000 Workspace command runs per month"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.singleBoardGuests.title",
                defaultMessage: "Single board guests"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.savedSearches.title",
                defaultMessage: "Saved searches"
            })
        }
    ];
    const premiumPlanFeatureMessages = [
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.views.title",
                defaultMessage: "Views: Calendar, Timeline, Table, Dashboard, and Map"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.workspaceViews.title",
                defaultMessage: "Workspace views: Table and Calendar"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.unlimitedWorkspaceCommandRuns.title",
                defaultMessage: "Unlimited Workspace command runs"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.atlassianIntelligence.title",
                defaultMessage: "Atlassian Intelligence (AI)"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.adminAndSecurityFeatures.title",
                defaultMessage: "Admin and security features"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.workspaceLevelTemplates.title",
                defaultMessage: "Workspace-level templates"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.collections.title",
                defaultMessage: "Collections"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.observers.title",
                defaultMessage: "Observers"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.simpleDataExport.title",
                defaultMessage: "Simple data export"
            })
        }
    ];
    const trelloProductPlans = [
        {
            planName: "Free",
            offeringSku: "jira-servicedesk-free",
            recommendationLimit: 0,
            signupLimit: 150000,
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: "Standard",
            offeringSku: "trello-standard-non-profit",
            recommendationLimit: 10,
            signupLimit: 150000,
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: "Premium",
            offeringSku: "trello-premium-non-profit",
            recommendationLimit: 250,
            signupLimit: 150000,
            planFeatureMessages: premiumPlanFeatureMessages
        }
    ];
    const messages = (0, $6x1qA.defineMessages)({
        headerText: {
            id: "TrelloPricingPage.priceFinder.headerText",
            defaultMessage: "Build Your <blue>Source of Truth</blue>"
        },
        unitCountInputTextRedesign: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputTerm: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        billingCycleText: {
            id: "ConfluencePricingPage.priceFinder.billingCycleText",
            defaultMessage: "Billing cycle:"
        },
        unitCountInputText: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputText",
            defaultMessage: "How many users are on your team?"
        },
        unitCountInputTooltip: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTooltip",
            defaultMessage: "A Confluence user is any user who can log in to Confluence, and who exists in User Management"
        },
        monthlyExampleHelpText: {
            id: "ConfluencePricingPage.priceFinder.monthlyExampleHelpText",
            defaultMessage: "Monthly plans give you flexibility as your number of active users changes, so pay for seats as you use them. Remember that the number of seats may change the total price."
        },
        annualExampleHelpText: {
            id: "ConfluencePricingPage.priceFinder.annualExampleHelpText",
            defaultMessage: "Annual plans give you flexibility and help you prepare for growth. Buy a group of seats at a flat rate now, then fill your empty seats through the year at no extra cost."
        },
        exampleStandardPlan: {
            id: "ConfluencePricingPage.priceFinder.exampleStandardPlan",
            defaultMessage: "Pricing for {unitCount} users on Standard plan",
            description: "Standard is a plan name and should not be translated"
        },
        cardOverSignupLimit: {
            id: "ConfluencePricingPage.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "ConfluencePricingPage.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "ConfluencePricingPage.priceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "TrelloPricingPage.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        },
        cardFreeDescription: {
            id: "ConfluencePricingPage.priceFinder.cardFreeDescription",
            defaultMessage: "Always free for 10 users"
        }
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $l9lQF.PriceFinderContextProvider), {
            dataProductKey: "trello",
            productPlans: trelloProductPlans,
            defaultUnitCount: 150,
            shouldAddDiscount: props.shouldAddDiscount,
            ctaUrlSource: "productPlans",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OWgU.default), {
                messages: messages,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.trello,
                countryCode: props.countryCode
            })
        })
    });
};
$68ff3930d767775f$export$954e0f4d6ca6524.displayName = "TrelloPriceFinder";

});




parcelRegister("kTri3", function(module, exports) {

$parcel$export(module.exports, "TryPage", function () { return $cab6b90ee0aec048$export$609689a2a01efdbc; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("ociJF");
var $3asrx = parcelRequire("3asrx");
const $cab6b90ee0aec048$export$609689a2a01efdbc = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $3asrx.TryPageTemplate), {});

});
parcelRegister("ociJF", function(module, exports) {
$parcel$export(module.exports, "TryPageTemplate", function () { return (parcelRequire("3asrx")).TryPageTemplate; });

var $3asrx = parcelRequire("3asrx");

});
parcelRegister("3asrx", function(module, exports) {

$parcel$export(module.exports, "TryPageTemplate", function () { return $4c8430ff1444e406$export$86c5cc40b74df40f; });

var $loA2J = parcelRequire("loA2J");

var $kex29 = parcelRequire("kex29");

var $cP0Yq = parcelRequire("cP0Yq");

var $51uXk = parcelRequire("51uXk");

var $eVI4d = parcelRequire("eVI4d");

var $lXF4x = parcelRequire("lXF4x");

var $1dD1u = parcelRequire("1dD1u");

var $l7FNA = parcelRequire("l7FNA");

var $lPcTp = parcelRequire("lPcTp");

var $g5q4i = parcelRequire("g5q4i");

var $1SKTn = parcelRequire("1SKTn");
const $4c8430ff1444e406$export$86c5cc40b74df40f = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.default), {
                    isShowTryNowLink: false,
                    tryNowLinkCtaButtonColor: "light_grey",
                    productKey: "try"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $l7FNA.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $g5q4i.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $1SKTn.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $eVI4d.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $51uXk.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $lPcTp.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $1dD1u.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $lXF4x.default), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("51uXk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $022d2a8bb07c82aa$export$2e2bcd8739ae039; });
/* code-build-ship-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("lkWcW");
var $bjFQv = parcelRequire("bjFQv");
var $dCRJL = parcelRequire("dCRJL");

var $gxrnF = parcelRequire("gxrnF");
const $022d2a8bb07c82aa$var$sectionCss = null;
const $022d2a8bb07c82aa$var$CodeBuildShipSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const codeBuildShipHeaderText = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.headerText",
        defaultMessage: "Code, Build, & Ship"
    });
    const bitbucketBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.bitbucket.bodyText",
        defaultMessage: "Collaborate on code with inline comments and pull requests. Manage and share your Git repositories to build and ship software, as a team."
    });
    const sourcetreeBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.sourcetree.bodyText",
        defaultMessage: "Harness the full power of Git and Mercurial in a beautifully simple application. Get the free desktop client for Mac and Windows."
    });
    const compassBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.compass.bodyText",
        defaultMessage: "Bring your distributed software architecture and the teams that collaborate on it together in a single, unified place."
    });
    const rovoDevBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.rovoDev.bodyText",
        defaultMessage: "Stay in the flow longer with AI-enabled productivity and quality for the full software delivery lifecycle."
    });
    const tryCloud = intl.formatMessage((0, $gxrnF.messages).tryCloud);
    const downloadNow = intl.formatMessage((0, $gxrnF.messages).downloadNow);
    const bitbucketLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "bitbucket",
        type: "logo",
        appearance: "brand"
    });
    const rovoLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "rovodev",
        type: "logo",
        appearance: "brand"
    });
    const sourcetreeLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "sourcetree",
        type: "logo",
        appearance: "brand"
    });
    const compassLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "compass",
        type: "logo",
        appearance: "brand"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $dyZbY.default), {
        name: "code-build-ship",
        className: (0, $esG4f.default)([
            "_ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bjFQv.TryPageHeader), {
                    dividerColor: "#ff8b00",
                    headerText: codeBuildShipHeaderText
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), {
                        logo: bitbucketLogo,
                        link: (0, $3FBn4.useLocalizedHref)("/software/bitbucket/bundle"),
                        bodyText: bitbucketBody,
                        ctaText: tryCloud
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), {
                        logo: rovoLogo,
                        link: (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=devai"),
                        bodyText: rovoDevBody,
                        ctaText: tryCloud
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {}),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), {
                        logo: sourcetreeLogo,
                        link: "https://www.sourcetreeapp.com/",
                        bodyText: sourcetreeBody,
                        ctaText: downloadNow
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), {
                        logo: compassLogo,
                        link: (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=compass"),
                        bodyText: compassBody,
                        ctaText: tryCloud
                    })
                ]
            })
        ]
    });
};
var $022d2a8bb07c82aa$export$2e2bcd8739ae039 = $022d2a8bb07c82aa$var$CodeBuildShipSection;

});
parcelRegister("lkWcW", function(module, exports) {

$parcel$export(module.exports, "TryPageCard", function () { return (parcelRequire("dCRJL")).TryPageCard; });
$parcel$export(module.exports, "TryPageHeader", function () { return (parcelRequire("bjFQv")).TryPageHeader; });

var $dCRJL = parcelRequire("dCRJL");

var $bjFQv = parcelRequire("bjFQv");

});
parcelRegister("dCRJL", function(module, exports) {

$parcel$export(module.exports, "TryPageCard", function () { return $50f9be0a65972998$export$78a2651bc04a8175; });
/* try-page-card.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $bQawl = parcelRequire("bQawl");
const $50f9be0a65972998$var$pStyle = null;
const $50f9be0a65972998$var$tryPageCardStyles = null;
const $50f9be0a65972998$var$logoBlockStyles = null;
const $50f9be0a65972998$var$StyledLogo = (logo)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_6rth19bv _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1752zwfg _w8l51wug _4x201osq"
        ]),
        children: logo
    });
};
const $50f9be0a65972998$export$78a2651bc04a8175 = (props)=>{
    const { title: title, logo: logo, link: link, bodyText: bodyText, ctaText: ctaText, buttonColor: buttonColor, buttonType: buttonType } = props;
    const styledLogo = logo && $50f9be0a65972998$var$StyledLogo(logo);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf"
        ]),
        children: [
            title && /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                children: title
            }),
            styledLogo && /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                href: link,
                children: styledLogo
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_1wyb1j6v _1pfhgrf3 _6rth1tcg",
                    "tryCardText"
                ]),
                children: bodyText
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bQawl.Button), {
                className: "ctaButton",
                text: ctaText,
                type: buttonType !== null && buttonType !== void 0 ? buttonType : "secondary",
                url: link,
                size: "small",
                color: buttonColor !== null && buttonColor !== void 0 ? buttonColor : "darkblue"
            })
        ]
    });
};

});

parcelRegister("bjFQv", function(module, exports) {

$parcel$export(module.exports, "TryPageHeader", function () { return $08bbc3641997729e$export$d30aca31b48239d; });
/* try-page-header.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");
const $08bbc3641997729e$export$d30aca31b48239d = (props)=>{
    const { dividerColor: dividerColor, headerText: headerText } = props;
    const headerStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4f1d1bqd _z5uk7vkz _1boa7vkz _16itidpf _ad5cidpf _4rmj11ph _16niidpf _1132idpf _19abftgi _edooidpf _rzyb1k8s _1apkdlk8 _1x4qahaf _hkvxdlk8 _sizi1tcg _11o6bmm0 _u25g1y44 _19ed7vkz _pgbz11ux _2z90idpf _1mvaidpf"
        ]),
        style: {
            "--_ei0dq9": (0, $43MIc.default)(dividerColor)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
            headerText: headerText,
            headerType: "h2",
            horizontalRule: true
        })
    });
};

});


parcelRegister("gxrnF", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $2a8d719bd7cf1a79$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $2a8d719bd7cf1a79$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    tryCloud: {
        id: "TryPageTemplate.tryCloud",
        defaultMessage: "Try cloud"
    },
    downloadNow: {
        id: "TryPageTemplate.downloadNow",
        defaultMessage: "Download now"
    }
});

});


parcelRegister("eVI4d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3dabf38a715bba18$export$2e2bcd8739ae039; });
/* collaborate-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("lkWcW");
var $bjFQv = parcelRequire("bjFQv");
var $dCRJL = parcelRequire("dCRJL");

var $gxrnF = parcelRequire("gxrnF");
const $3dabf38a715bba18$var$sectionCss = null;
const $3dabf38a715bba18$var$CollaborateSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const tryCloud = intl.formatMessage((0, $gxrnF.messages).tryCloud);
    const collaborateTitle = intl.formatMessage({
        id: "TryPageTemplate.collaborate.title",
        defaultMessage: "Collaborate"
    });
    const confluenceBody = intl.formatMessage({
        id: "TryPageTemplate.collaborate.confluenceBody",
        defaultMessage: "Get things done instead of hunting things down. Organize your work, create documents, and discuss everything in one place."
    });
    const trelloBody = intl.formatMessage({
        id: "TryPageTemplate.collaborate.trelloBody",
        defaultMessage: "Collaborate and get more done. Trello boards enable your team to organize projects in a fun, flexible, and visual way."
    });
    const loomBody = intl.formatMessage({
        id: "TryPageTemplate.collaborate.loomBody",
        defaultMessage: "Record your screen, camera, and voice with Loom. Send async video messages on an AI-powered platform."
    });
    const confluenceLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "confluence",
        type: "logo",
        appearance: "brand"
    });
    const trelloLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "trello",
        type: "logo",
        appearance: "brand"
    });
    const loomLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "loom",
        type: "logo",
        appearance: "brand"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $dyZbY.default), {
        name: "collaborateCards",
        className: (0, $esG4f.default)([
            "_ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bjFQv.TryPageHeader), {
                    headerText: collaborateTitle,
                    dividerColor: (0, $5ohHq.wacToken)("color.primary.blue")
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), {
                        logo: confluenceLogo,
                        link: (0, $3FBn4.useLocalizedHref)("/software/confluence/free"),
                        bodyText: confluenceBody,
                        ctaText: tryCloud
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), {
                        logo: trelloLogo,
                        link: "https://www.trello.com/signup",
                        bodyText: trelloBody,
                        ctaText: tryCloud
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {}),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), {
                        logo: loomLogo,
                        link: (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=loom&edition=premium"),
                        bodyText: loomBody,
                        ctaText: tryCloud
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {})
                ]
            })
        ]
    });
};
var $3dabf38a715bba18$export$2e2bcd8739ae039 = $3dabf38a715bba18$var$CollaborateSection;

});

parcelRegister("lXF4x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c22e2f62e2e6dd0$export$2e2bcd8739ae039; });
/* enterprise-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("lkWcW");
var $dCRJL = parcelRequire("dCRJL");
const $7c22e2f62e2e6dd0$var$sectionCss = null;
const $7c22e2f62e2e6dd0$var$headerStyle = null;
const $7c22e2f62e2e6dd0$var$lowerCss = null;
const $7c22e2f62e2e6dd0$var$imageCss = null;
const $7c22e2f62e2e6dd0$var$EnterpriseSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const goBigHeader = intl.formatMessage({
        id: "try.enterprise.goBig",
        defaultMessage: "Go big with Atlassian Enterprise"
    });
    const goBigBody = intl.formatMessage({
        id: "try.enterprise.goBigBody",
        defaultMessage: "Connect, accelerate, and scale your entire enterprise with Atlassian enterprise solutions."
    });
    const learnMore = intl.formatMessage({
        id: "try.enterprise.learnMore",
        defaultMessage: "Learn more"
    });
    const cloud = intl.formatMessage({
        id: "try.enterprise.cloud",
        defaultMessage: "Cloud"
    });
    const cloudBody = intl.formatMessage({
        id: "try.enterprise.cloudBody",
        defaultMessage: "Atlassian cloud solutions are equipped with everything large and growing teams need to scale collaboration and workflows seamlessly."
    });
    const dataCenter = intl.formatMessage({
        id: "try.enterprise.dataCenter",
        defaultMessage: "Data Center"
    });
    const dataCenterBody = intl.formatMessage({
        id: "try.enterprise.dataCenterBody",
        defaultMessage: "Host our applications with IaaS vendors like AWS or Azure. Data Center is our self-managed solution for advanced administration at scale."
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_syazcd5j _bfhk1ep1 _ca0q12bs _u5f3idpf _n3td12bs _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_l5k1bfng _11ebahaf _2fhk4jg8 _bpspbfng _1r2tidpf _1h3oud5o _hrxpidpf _oqlkud5o _3fwinqt0"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                        headerText: goBigHeader,
                        headerType: "h2",
                        isCentered: true,
                        bodyText: goBigBody,
                        ctaProps: {
                            buttonProps: {
                                className: "ctaButton",
                                text: learnMore,
                                url: "https://www.atlassian.com/enterprise",
                                type: "primary",
                                color: "lightblue",
                                size: "small"
                            }
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1r2tidpf _1h3oud5o _hrxpidpf _oqlkud5o _3fwinqt0 _x3mzbfng _k48p4jg8 _1o6v1j6v _ggmh1k8s _r8nt4jg8 _1adi12sy _19tboxwj _43ds1ep1 _bna711ux"
                ]),
                style: {
                    "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), {
                            title: cloud,
                            link: (0, $3FBn4.useLocalizedHref)("/enterprise/cloud"),
                            bodyText: cloudBody,
                            ctaText: learnMore,
                            buttonColor: "lightblue",
                            buttonType: "primary"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), {
                            title: dataCenter,
                            link: (0, $3FBn4.useLocalizedHref)("/enterprise/data-center"),
                            bodyText: dataCenterBody,
                            ctaText: learnMore,
                            buttonColor: "lightblue",
                            buttonType: "primary"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _1bah1h6o _4cvr1h6o _1e0c1txw"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                image: {
                                    src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/database-server-on-v3.webp",
                                    alt: intl.formatMessage({
                                        id: "try.enterprise.databaseServer",
                                        defaultMessage: "Data center + server"
                                    })
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $7c22e2f62e2e6dd0$export$2e2bcd8739ae039 = $7c22e2f62e2e6dd0$var$EnterpriseSection;

});

parcelRegister("1dD1u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $912ed4874d605be1$export$2e2bcd8739ae039; });
/* get-the-most-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $5VP5O = parcelRequire("5VP5O");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $912ed4874d605be1$var$pageSection = null;
const $912ed4874d605be1$var$sectionCss = null;
const $912ed4874d605be1$var$headerStyle = null;
const $912ed4874d605be1$var$cardContainer = null;
const $912ed4874d605be1$var$GetTheMostSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const cardData = [
        {
            title: intl.formatMessage({
                id: "TryPageTemplate.getTheMost.marketplaceHeaderText",
                defaultMessage: "Tailor to your team\u2019s needs"
            }),
            titleAs: "h3",
            body: intl.formatMessage({
                id: "TryPageTemplate.getTheMost.marketplaceBodyText",
                defaultMessage: "Extend your Atlassian products with thousands of apps from Marketplace."
            }),
            callToAction: {
                href: "https://marketplace.atlassian.com/",
                text: intl.formatMessage({
                    id: "TryPageTemplate.getTheMost.marketplacePrimaryLink",
                    defaultMessage: "Go to Marketplace"
                })
            },
            orientation: "horizontal",
            spotIllustrationUrl: "https://wac-cdn.atlassian.com/dam/jcr:76e94ebd-d71e-4991-9008-7b2e838090c8/illustrations-spot-Integrations.svg?cdnVersion=2999"
        },
        {
            title: intl.formatMessage({
                id: "TryPageTemplate.getTheMost.universityHeaderText",
                defaultMessage: "Train with Atlassian University"
            }),
            titleAs: "h3",
            body: intl.formatMessage({
                id: "TryPageTemplate.getTheMost.universityBodyText",
                defaultMessage: "Develop new skills, improve your team\u2019s work, and advance your professional career."
            }),
            callToAction: {
                href: "https://www.atlassian.com/university",
                text: intl.formatMessage({
                    id: "TryPageTemplate.getTheMost.universityPrimaryLink",
                    defaultMessage: "Go to Atlassian University"
                })
            },
            orientation: "horizontal",
            spotIllustrationUrl: "https://wac-cdn.atlassian.com/dam/jcr:a88ae3d8-e6fd-4428-8a14-c9ce6b460b0e/illustrations-spot-Atlassian%20Book_1.svg?cdnVersion=2999"
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1q51xy5q _85i5xncg _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_12l21wug _ahbq1wug _1ul91osq _11rm1hrf _bfhkcd5j _kqswh2mm"
            ]),
            style: {
                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_y3gn1h6o _cg411tj6 _l5k1bfng _1pxq7vkz _ygm1idpf _u6q57vkz _sydsidpf _17z411ph _xztqidpf _ubikidpf _j8iydlk8 _h9g4idpf _1kll1ejb _1g9widpf _1kovidpf _bsriidpf _1qsfidpf _1x1pahaf _12adidpf _1xe1idpf _hcanidpf _nji3idpf _j269ahaf"
                        ]),
                        style: {
                            "--_1tgiy09": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue900"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "TryPageTemplate.getTheMost.header",
                                defaultMessage: "Get the most out of your products"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "6-6",
                    children: cardData.map((card, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1ui68ved"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5VP5O.Card), (0, $7Knp0._)({}, card))
                        }, index))
                })
            ]
        })
    });
};
var $912ed4874d605be1$export$2e2bcd8739ae039 = $912ed4874d605be1$var$GetTheMostSection;

});

parcelRegister("l7FNA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07014a24a41fc853$export$2e2bcd8739ae039; });
/* hero-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("lJjtp");
var $k2rni = parcelRequire("k2rni");
const $07014a24a41fc853$var$HeroTryGraphCard = ()=>{
    const intl = (0, $f6qj2.default)();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.hero.graphCard.bodyText",
        defaultMessage: "Collaborate seamlessly across cross-functional teams, at scale"
    });
    const imgLink = "https://wac-cdn.atlassian.com/dam/jcr:6f126124-1d52-4017-9078-40df4c78897e/illustrations-spot-Connections.svg?cdnVersion=1408";
    const imgAltText = intl.formatMessage({
        id: "TryPageTemplate.hero.graphCard.imgAltText",
        defaultMessage: "Connections illustration"
    });
    return {
        headerText: "",
        bodyText: headerText,
        imageAltText: imgAltText,
        imageLink: imgLink
    };
};
const $07014a24a41fc853$var$HeroTryLockCard = ()=>{
    const intl = (0, $f6qj2.default)();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.hero.lockCard.bodyText",
        defaultMessage: "Built with industry-leading privacy, security, and data control"
    });
    const imgLink = "https://wac-cdn.atlassian.com/dam/jcr:c0c94526-036b-44df-9f0d-cd1e9455d1e2/illustrations-spot-Trust%20and%20Security.svg?cdnVersion=1408";
    const imgAltText = intl.formatMessage({
        id: "TryPageTemplate.hero.lockCard.imgAltText",
        defaultMessage: "Trust and security illustration"
    });
    return {
        headerText: "",
        bodyText: headerText,
        imageAltText: imgAltText,
        imageLink: imgLink
    };
};
const $07014a24a41fc853$var$HeroTryPuzzleCard = ()=>{
    const intl = (0, $f6qj2.default)();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.hero.puzzleCard.bodyText",
        defaultMessage: "Customize your products with 1,000+ apps and integrations"
    });
    const imgLink = "https://wac-cdn.atlassian.com/dam/jcr:3dfc6901-1535-48aa-a25a-870ee1d5ff8e/illustrations-spot-Integration%20Puzzle.svg?cdnVersion=1408";
    const imgAltText = intl.formatMessage({
        id: "TryPageTemplate.hero.puzzleCard.imgAltText",
        defaultMessage: "Integration puzzle illustration"
    });
    return {
        headerText: "",
        bodyText: headerText,
        imageAltText: imgAltText,
        imageLink: imgLink
    };
};
const $07014a24a41fc853$var$sectionCssOverride = null;
const $07014a24a41fc853$var$outerContainerCssOverride = null;
const $07014a24a41fc853$var$HeroSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.hero.header",
        defaultMessage: "Try Atlassian apps for free"
    });
    const bodyText = intl.formatMessage({
        id: "TryPageTemplate.hero.bodyText",
        defaultMessage: "Our cloud products empower teams of all types, from startup to enterprise."
    });
    const backgroundProps = {
        bgColor: (0, $5ohHq.wacToken)("color.neutral.light100")
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_cg411tj6 _18oz1wto _1ap71k7u _u8fj1tcg _163midpf _yzu7idpf _1kll14b4 _1qdgidpf _7toc10nf _cjxodlk8 _a5ip1n2x _1f35m24h _ps1ee8xo _z0gn1h6o _p1061k92 _zqtwnl7k _130319ii _10vfidpf _1of01yg0 _1xw61h67 _sz6216xe _3int1gpt _dmb7grf3"
        ]),
        style: {
            "--_1tgiy09": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue900")),
            "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_16qs1cd0 _kqswh2mm"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $k2rni.ContentBlocksInline), {
                headerText: headerText,
                bodyText: bodyText,
                backgroundProperties: backgroundProps,
                inlineContentBlocks: [
                    $07014a24a41fc853$var$HeroTryGraphCard(),
                    $07014a24a41fc853$var$HeroTryLockCard(),
                    $07014a24a41fc853$var$HeroTryPuzzleCard()
                ]
            })
        })
    });
};
var $07014a24a41fc853$export$2e2bcd8739ae039 = $07014a24a41fc853$var$HeroSection;

});
parcelRegister("lJjtp", function(module, exports) {
$parcel$export(module.exports, "ContentBlocksInline", function () { return (parcelRequire("k2rni")).ContentBlocksInline; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("k2rni")).ContentBlocksInline; });

var $k2rni = parcelRequire("k2rni");

});
parcelRegister("k2rni", function(module, exports) {

$parcel$export(module.exports, "ContentBlocksInline", function () { return $44a7057441067a36$export$4fd59a663df2d810; });
/* content-blocks-inline.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
parcelRequire("ix9oc");
var $3hz64 = parcelRequire("3hz64");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");
const $44a7057441067a36$var$getCardAspectRatio = (length)=>{
    switch(length){
        case 4:
            return "4/3";
        case 3:
            return "4/3";
        case 2:
            return "2/1";
        default:
            return "1/1";
    }
};
const $44a7057441067a36$var$ctaStyle = null;
const $44a7057441067a36$export$4fd59a663df2d810 = ({ headerText: headerText, bodyText: bodyText, backgroundProperties: backgroundProperties, className: className, eyebrowText: eyebrowText, iconName: iconName, linkPosition: linkPosition = "bottom", ctaProps: ctaProps, inlineContentBlocks: inlineContentBlocks })=>{
    if (inlineContentBlocks.length < 2 || inlineContentBlocks.length > 4) throw new Error("Pattern is meant to display between 2 and 4 cards");
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.StyledBackground), (0, $6iHNw._)((0, $7Knp0._)({}, backgroundProperties), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1akovbgk _c7s7idpf _4puvvbgk _1r3vidpf _i6jxckbl _1lh7idpf _z3ncckbl _wpaiidpf _1kmxzwfg _1ggmidpf _1ykzzwfg _1maeidpf",
                className
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), {
                        headerText: headerText,
                        headerType: "h2",
                        eyebrowText: eyebrowText,
                        iconName: iconName,
                        bodyText: bodyText,
                        isCentered: true,
                        ctaProps: linkPosition == "top" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? ctaProps : {}
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: inlineContentBlocks.map((block, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $3hz64.ContentBlock), (0, $7Knp0._)({
                            aspectRatio: $44a7057441067a36$var$getCardAspectRatio(inlineContentBlocks.length)
                        }, block), index))
                }),
                linkPosition == "bottom" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        style: {
                            textAlign: "center"
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), (0, $7Knp0._)({}, ctaProps.primaryLinkProps))
                    })
                }) : null
            ]
        })
    }));
};

});



parcelRegister("lPcTp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8b4fa8d38716042$export$2e2bcd8739ae039; });
/* identity-and-security-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("lkWcW");
var $bjFQv = parcelRequire("bjFQv");

var $dCRJL = parcelRequire("dCRJL");

var $gxrnF = parcelRequire("gxrnF");
const $f8b4fa8d38716042$var$sectionStyles = null;
const $f8b4fa8d38716042$var$IdentityAndSecuritySection = ()=>{
    const intl = (0, $f6qj2.default)();
    const atlassianAccessHeaderText = intl.formatMessage({
        id: "TryPageTemplate.IdentityAndSecurity.title",
        defaultMessage: "Identity & Security"
    });
    const headerProps = {
        headerText: atlassianAccessHeaderText,
        dividerColor: (0, $5ohHq.wacToken)("color.primary.blue")
    };
    const atlassianAccessLink = "https://admin.atlassian.com/";
    const atlassianAccessBodyText = intl.formatMessage({
        id: "TryPageTemplate.identityAndSecurity.atlassianAccessBody",
        defaultMessage: "Gain company-wide visibility, security policies, and control across your Atlassian cloud infrastructure."
    });
    const tryCloud = intl.formatMessage((0, $gxrnF.messages).tryCloud);
    const guardLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "guard",
        type: "logo",
        appearance: "brand"
    });
    const cardProps = {
        logo: guardLogo,
        link: atlassianAccessLink,
        bodyText: atlassianAccessBodyText,
        ctaText: tryCloud
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $dyZbY.default), {
            name: "identityAndSecurity",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bjFQv.TryPageHeader), (0, $7Knp0._)({}, headerProps))
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                    layout: "6-6",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), (0, $7Knp0._)({}, cardProps)),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {})
                    ]
                })
            ]
        })
    });
};
var $f8b4fa8d38716042$export$2e2bcd8739ae039 = $f8b4fa8d38716042$var$IdentityAndSecuritySection;

});

parcelRegister("g5q4i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22b52fde8f6e55b3$export$2e2bcd8739ae039; });
/* plan-and-track.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("lkWcW");
var $bjFQv = parcelRequire("bjFQv");
var $dCRJL = parcelRequire("dCRJL");

var $gxrnF = parcelRequire("gxrnF");
const $22b52fde8f6e55b3$var$sectionStyles = null;
const $22b52fde8f6e55b3$var$PlanAndTrackSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const jiraSofttwareHeaderText = intl.formatMessage({
        id: "TryPageTemplate.PlanAndTrack.title",
        defaultMessage: "Plan & Track"
    });
    const headerProps = {
        headerText: jiraSofttwareHeaderText,
        dividerColor: (0, $5ohHq.wacToken)("color.primary.blue")
    };
    const jiraSofttwareBodyText = intl.formatMessage({
        id: "TryPageTemplate.PlanAndTrack.jiraBody",
        defaultMessage: "Friendly and intuitive collaboration for business teams and their projects, built for cross-team coordination and breaking down silos."
    });
    const jiraSofttwareLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&edition=free");
    const jirProductDiscoveryBodyText = intl.formatMessage({
        id: "TryPageTemplate.PlanAndTrack.jirProductDiscoveryBody",
        defaultMessage: "Organize and prioritize ideas, share product roadmaps, and connect business and tech teams, all in Jira."
    });
    const jirProductDiscoveryLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-product-discovery");
    const tryCloud = intl.formatMessage((0, $gxrnF.messages).tryCloud);
    const jiraLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    });
    const jpdLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand"
    });
    const jiracardProps = {
        logo: jiraLogo,
        link: jiraSofttwareLink,
        bodyText: jiraSofttwareBodyText,
        ctaText: tryCloud
    };
    const jpdcardProps = {
        logo: jpdLogo,
        link: jirProductDiscoveryLink,
        bodyText: jirProductDiscoveryBodyText,
        ctaText: tryCloud
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_ca0qvbgk _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bjFQv.TryPageHeader), (0, $7Knp0._)({}, headerProps))
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), (0, $7Knp0._)({}, jiracardProps)),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), (0, $7Knp0._)({}, jpdcardProps))
                ]
            })
        ]
    });
};
var $22b52fde8f6e55b3$export$2e2bcd8739ae039 = $22b52fde8f6e55b3$var$PlanAndTrackSection;

});

parcelRegister("1SKTn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71995569305677b7$export$2e2bcd8739ae039; });
/* support-and-fix-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $dCRJL = parcelRequire("dCRJL");

var $bjFQv = parcelRequire("bjFQv");

var $gxrnF = parcelRequire("gxrnF");
/* Cards */ const $71995569305677b7$var$JsmCard = ()=>{
    const intl = (0, $f6qj2.default)();
    const localizedLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-service-management");
    const localizedBodyText = intl.formatMessage({
        id: "TryPageTemplate.supportAndFix.jsmCard.bodyText",
        defaultMessage: "Collaborate at high-velocity, respond to business changes and deliver great customer and employee service experiences fast."
    });
    const localizedCtaText = intl.formatMessage((0, $gxrnF.messages).tryCloud);
    const jsmLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "jiraservicemanagement",
        type: "logo",
        appearance: "brand"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), {
        logo: jsmLogo,
        link: localizedLink,
        bodyText: localizedBodyText,
        ctaText: localizedCtaText
    });
};
const $71995569305677b7$var$StatusCard = ()=>{
    const intl = (0, $f6qj2.default)();
    const localizedLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=statuspage");
    const localizedBodyText = intl.formatMessage({
        id: "TryPageTemplate.supportAndFix.statusCard.bodyText",
        defaultMessage: "Incidents happen. Keep your users informed with fewer support emails during downtime."
    });
    const localizedCtaText = intl.formatMessage({
        id: "TryPageTemplate.tryCloud",
        defaultMessage: "Try cloud"
    });
    const statusPageLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "statuspage",
        type: "logo",
        appearance: "brand"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), {
        logo: statusPageLogo,
        link: localizedLink,
        bodyText: localizedBodyText,
        ctaText: localizedCtaText
    });
};
const $71995569305677b7$var$sectionStyles = null;
const $71995569305677b7$var$SupportAndFixSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.supportAndFix.headerText",
        defaultMessage: "Support & fix"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "support-and-fix",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bjFQv.TryPageHeader), {
                        dividerColor: "#ff8b00",
                        headerText: headerText
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                    layout: "6-6",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)($71995569305677b7$var$JsmCard, {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)($71995569305677b7$var$StatusCard, {})
                    ]
                })
            ]
        })
    });
};
var $71995569305677b7$export$2e2bcd8739ae039 = $71995569305677b7$var$SupportAndFixSection;

});




parcelRegister("4o4mW", function(module, exports) {

$parcel$export(module.exports, "UniformConfluencePricingEntryPage", function () { return $c83919ab22722e0c$export$46490ce46aa9f785; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $9iWJ8 = parcelRequire("9iWJ8");

var $lgDo7 = parcelRequire("lgDo7");
const $c83919ab22722e0c$export$46490ce46aa9f785 = (props)=>{
    const [hasFired, fireExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).confluencePricingPageWaeMigration);
    // this is the existing experiment in the confluence pricing page
    // services/wac-web/src/pages/software/confluence/pricing/confluence-pricing-page.tsx
    const [pricingDirectBuyCheckoutFired, pricingDirectBuyCheckoutFireExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).pricingDirectBuyCheckout);
    (0, $iSvIT.useEffect)(()=>{
        if (!pricingDirectBuyCheckoutFired) pricingDirectBuyCheckoutFireExposure();
    }, [
        pricingDirectBuyCheckoutFired,
        pricingDirectBuyCheckoutFireExposure
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (!hasFired) fireExposure();
    }, [
        hasFired,
        fireExposure
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lgDo7.UniformEntryPage), (0, $7Knp0._)({}, props));
};

});

parcelRegister("4ponz", function(module, exports) {

$parcel$export(module.exports, "UniformEntryLazyPage", function () { return $11a850bd22775944$export$821c7d7eefb4d74; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $dWbel = parcelRequire("dWbel");

var $4ktyF = parcelRequire("4ktyF");

var $luVwe = parcelRequire("luVwe");
parcelRequire("4FjY3");
var $fo948 = parcelRequire("fo948");
const $11a850bd22775944$export$821c7d7eefb4d74 = ({ composition: composition, compositionMetrics: compositionMetrics, isUniformPlayground: isUniformPlayground })=>{
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { compositionFetchStart: compositionFetchStart, compositionCacheStatus: compositionCacheStatus, ssrEndTime: ssrEndTime } = compositionMetrics || {};
    const sendPageRenderAnalyticsEvent = (0, $iSvIT.useCallback)((pageRenderTime, ssrEndTime, compositionFetchStart, fcp)=>{
        if (pageRenderTime && analyticsClient) analyticsClient.sendUIEvent({
            action: "pageRender",
            actionSubject: "uniformPage",
            source: window.location.pathname,
            attributes: {
                pageRenderTime: pageRenderTime,
                compositionFetchStart: compositionFetchStart,
                ssrEndTime: ssrEndTime,
                compositionCacheStatus: compositionCacheStatus,
                fcp: fcp,
                isUniformPlayground: isUniformPlayground || false
            }
        });
    }, [
        analyticsClient,
        compositionCacheStatus,
        isUniformPlayground
    ]);
    (0, $iSvIT.useEffect)(()=>{
        const measureFirstContentfulPaint = ()=>{
            try {
                // First, check if FCP is already available
                const paintEntries = performance.getEntriesByType("paint");
                const firstContentfulPaint = paintEntries.find((entry)=>entry.name === "first-contentful-paint");
                if (firstContentfulPaint && ssrEndTime && compositionFetchStart) {
                    const fcp = firstContentfulPaint.startTime;
                    // Calculate page render time
                    const pageRenderTime = ssrEndTime - compositionFetchStart + fcp;
                    if (pageRenderTime) sendPageRenderAnalyticsEvent(pageRenderTime, ssrEndTime, compositionFetchStart, fcp);
                    return firstContentfulPaint.startTime;
                }
                // If FCP isn't available yet, observe for it
                const observer = new PerformanceObserver((list)=>{
                    const entries = list.getEntries();
                    const fcpEntry = entries.find((entry)=>entry.name === "first-contentful-paint");
                    if (fcpEntry && compositionFetchStart && ssrEndTime) {
                        const fcp = fcpEntry.startTime;
                        // Calculate page render time
                        const pageRenderTime = ssrEndTime - compositionFetchStart + fcp;
                        if (pageRenderTime) sendPageRenderAnalyticsEvent(pageRenderTime, ssrEndTime, compositionFetchStart, fcp);
                        observer.disconnect();
                    }
                });
                observer.observe({
                    entryTypes: [
                        "paint"
                    ]
                });
                // Cleanup observer after 10 seconds to prevent memory leaks
                setTimeout(()=>{
                    observer.disconnect();
                }, 10000);
                return undefined;
            } catch (error) {
                console.warn("Error measuring Page Render Time:", error);
                return undefined;
            }
        };
        measureFirstContentfulPaint();
    }, [
        compositionFetchStart,
        compositionMetrics,
        sendPageRenderAnalyticsEvent,
        ssrEndTime
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4ktyF.default), {
        fallback: /*#__PURE__*/ (0, $loA2J.jsx)((0, $luVwe.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            "data-testid": "uniform-entry-lazy-page-root",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fo948.UniformEntryLazyPageTemplate), {
                    composition: composition,
                    isUniformPlayground: isUniformPlayground
                })
            })
        })
    });
};

});
parcelRegister("4FjY3", function(module, exports) {
$parcel$export(module.exports, "UniformEntryLazyPageTemplate", function () { return (parcelRequire("fo948")).UniformEntryLazyPageTemplate; });

var $fo948 = parcelRequire("fo948");

});
parcelRegister("fo948", function(module, exports) {

$parcel$export(module.exports, "UniformEntryLazyPageTemplate", function () { return $1498b97ab912b132$export$9e3a27c8379828f5; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $4ktyF = parcelRequire("4ktyF");

var $djMZd = parcelRequire("djMZd");
const $1498b97ab912b132$export$9e3a27c8379828f5 = ({ composition: composition, isUniformPlayground: isUniformPlayground })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4ktyF.default), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $djMZd.UniformWrapperLazy), {
            composition: composition,
            isUniformPlayground: isUniformPlayground
        })
    });
};

});
parcelRegister("djMZd", function(module, exports) {

$parcel$export(module.exports, "UniformWrapperLazy", function () { return $4fb9225c6226b129$export$936d5d2c91e06440; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");

var $lHB9W = parcelRequire("lHB9W");

var $lrVTP = parcelRequire("lrVTP");

var $3A0Kj = parcelRequire("3A0Kj");

var $9Dbz6 = parcelRequire("9Dbz6");

var $awQBc = parcelRequire("awQBc");

var $4sbR8 = parcelRequire("4sbR8");
/**
 * Helper to determine if a composition contains any lazy components that need Suspense
 */ /* eslint-disable @typescript-eslint/no-explicit-any */ function $4fb9225c6226b129$var$compositionHasLazyComponents(composition) {
    if (!composition) return false;
    const checkNode = (node)=>{
        if (node === null || node === void 0 ? void 0 : node.type) {
            var _component_hasOwnProperty;
            const component = (0, $awQBc.default)[node.type];
            if (component === null || component === void 0 ? void 0 : (_component_hasOwnProperty = component.hasOwnProperty) === null || _component_hasOwnProperty === void 0 ? void 0 : _component_hasOwnProperty.call(component, "_payload")) return true; // Found a lazy component
        }
        // Check slots recursively
        if (node === null || node === void 0 ? void 0 : node.slots) {
            for (const slotItems of Object.values(node.slots))if (Array.isArray(slotItems)) {
                if (slotItems.some(checkNode)) return true;
            }
        }
        return false;
    };
    return checkNode(composition);
}
const $4fb9225c6226b129$var$resolveRenderer = ({ type: type })=>{
    const MissingComponent = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $4sbR8.UniformMissingComponent), {
            componentName: type
        });
    const component = (0, $awQBc.default)[type];
    if (!component) {
        console.warn(`No component found for type: ${type}`);
        return MissingComponent;
    }
    return component;
};
const $4fb9225c6226b129$export$936d5d2c91e06440 = ({ composition: composition, isUniformPlayground: isUniformPlayground })=>{
    const [data, setData] = (0, $iSvIT.useState)();
    const [isFetched, setIsFetched] = (0, $iSvIT.useState)(false);
    const [isPreloaded, setIsPreloaded] = (0, $iSvIT.useState)(false);
    const [hasLazyComponents, setHasLazyComponents] = (0, $iSvIT.useState)(false);
    const isStaticFallback = typeof window !== "undefined" && window.IS_STATIC;
    const location = (0, $lrVTP.useLocation)();
    (0, $iSvIT.useEffect)(()=>{
        const fetchComposition = async ()=>{
            // Priority 1: Static fallback (highest priority)
            if (isStaticFallback && !isFetched) {
                try {
                    const { path: path, locale: locale } = (0, $9Dbz6.parseRoute)(location);
                    const slug = path.startsWith("/") ? path.substring(1) : path;
                    const cdn = "https://wac-uniform-promotion--production.us-east-1.prod.public.atl-paas.net/";
                    if (!cdn) throw new Error("UNIFORM_CDN environment variable not set");
                    const cdn_path = `${cdn}release/${locale}/${slug}/composition.json`;
                    const req = await fetch(cdn_path);
                    if (!req.ok) throw new Error(`HTTP ${req.status}: ${req.statusText}`);
                    const file = await req.json();
                    const enhancedComp = await (0, $3A0Kj.enhanceComposition)(file.compositionApiResponse.composition);
                    setData(enhancedComp);
                    setHasLazyComponents($4fb9225c6226b129$var$compositionHasLazyComponents(enhancedComp));
                    setIsFetched(true);
                    // Preload priority components immediately, then all components
                    (0, $awQBc.preloadPriorityComponentsInComposition)(enhancedComp).then(()=>{
                        // After priority components are loaded, preload the rest
                        (0, $awQBc.preloadCompositionComponents)(enhancedComp).then(()=>{
                            setIsPreloaded(true);
                        });
                    });
                } catch (error) {
                    console.error("Error fetching composition from CDN:", error);
                    setIsFetched(true); // Still mark as fetched to prevent infinite loops
                }
                return;
            }
            // Priority 2: Preloaded composition from window
            if (typeof window !== "undefined" && window._uniformPreloadedComposition && !isStaticFallback && !isFetched) {
                // @ts-ignore
                // eslint-disable-next-line react-hooks/exhaustive-deps
                isUniformPlayground = window.isUniformPlayground;
                const compositionData = window._uniformPreloadedComposition;
                setData(compositionData);
                setIsFetched(true);
                setHasLazyComponents($4fb9225c6226b129$var$compositionHasLazyComponents(compositionData));
                // Preload priority components immediately, then all components
                (0, $awQBc.preloadPriorityComponentsInComposition)(compositionData).then(()=>{
                    // After priority components are loaded, preload the rest
                    (0, $awQBc.preloadCompositionComponents)(compositionData).then(()=>{
                        setIsPreloaded(true);
                    });
                });
                return;
            }
            // Priority 3: Composition passed as prop
            if (composition && !isFetched) {
                setData(composition);
                setHasLazyComponents($4fb9225c6226b129$var$compositionHasLazyComponents(composition));
                setIsFetched(true);
                // Preload priority components immediately, then all components
                if (!isPreloaded) (0, $awQBc.preloadPriorityComponentsInComposition)(composition).then(()=>{
                    // After priority components are loaded, preload the rest
                    (0, $awQBc.preloadCompositionComponents)(composition).then(()=>{
                        setIsPreloaded(true);
                    });
                });
                return;
            }
            // Fallback: No composition available
            if (!isFetched) {
                console.warn("\u26A0\uFE0F No composition data available");
                setIsFetched(true);
            }
        };
        fetchComposition();
    }, [
        composition,
        isStaticFallback,
        isPreloaded
    ]);
    if (isUniformPlayground) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformPlayground), {
        resolveRenderer: $4fb9225c6226b129$var$resolveRenderer,
        contextualEditingEnhancer: ({ composition: composition })=>(0, $3A0Kj.enhanceComposition)(composition)
    });
    const renderComposition = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformComposition), {
            data: (0, $lHB9W.expectContent)(data),
            behaviorTracking: "onLoad",
            resolveRenderer: $4fb9225c6226b129$var$resolveRenderer,
            contextualEditingEnhancer: ({ composition: composition })=>(0, $3A0Kj.enhanceComposition)(composition)
        });
    return isFetched && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: hasLazyComponents ? /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Suspense, {
            fallback: null,
            children: renderComposition()
        }) : renderComposition()
    });
};

});
parcelRegister("awQBc", function(module, exports) {

$parcel$export(module.exports, "preloadCompositionComponents", function () { return $b13d28c25dca5a59$export$789b2b96542a616f; });
$parcel$export(module.exports, "preloadPriorityComponentsInComposition", function () { return $b13d28c25dca5a59$export$f3577375c6f4aa2f; });
$parcel$export(module.exports, "default", function () { return $b13d28c25dca5a59$export$2e2bcd8739ae039; });
// @ts-nocheck ts(2834)
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $iSvIT = parcelRequire("iSvIT");

var $9gXYv = parcelRequire("9gXYv");

var $4sbR8 = parcelRequire("4sbR8");
// ALL components are lazy loaded - no eager imports to bloat bundles!
const $b13d28c25dca5a59$var$UNIFORM_DEFINITIONS = {};
// Map each component type to lazy-loaded component
Object.entries((0, $9gXYv.UNIFORM_TYPE_TO_LOADER)).forEach(([uniformType, loaderKey])=>{
    const loader = (0, $9gXYv.componentLoaders)[loaderKey];
    if (loader) {
        const isPriority = (0, $9gXYv.PRIORITY_PRELOAD_COMPONENTS).has(uniformType);
        $b13d28c25dca5a59$var$UNIFORM_DEFINITIONS[uniformType] = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).lazy(()=>loader().then((module)=>{
                if (module && module.default) return {
                    default: module.default
                };
                else return null;
            }).catch((error)=>{
                return null;
            }));
    }
});
async function $b13d28c25dca5a59$export$7c05c44a44181e30(type) {
    const loaderKey = (0, $9gXYv.UNIFORM_TYPE_TO_LOADER)[type];
    if (!loaderKey) return null;
    const loader = (0, $9gXYv.componentLoaders)[loaderKey];
    if (!loader) return null;
    try {
        const module = await loader();
        if (module && module.default) return module.default;
        else throw new Error(`No default export found for component: ${type}`);
    } catch (error) {
        return 0, $4sbR8.UniformMissingComponent;
    }
}
/**
 * Extracts all component types from a composition recursively
 */ function $b13d28c25dca5a59$var$extractComponentTypes(composition) {
    const types = new Set();
    function traverse(node) {
        if (node === null || node === void 0 ? void 0 : node.type) types.add(node.type);
        if (node === null || node === void 0 ? void 0 : node.slots) Object.values(node.slots).forEach((slotItems)=>{
            if (Array.isArray(slotItems)) slotItems.forEach(traverse);
        });
    }
    traverse(composition);
    return types;
}
async function $b13d28c25dca5a59$export$789b2b96542a616f(composition) {
    if (!composition) return;
    const componentTypes = $b13d28c25dca5a59$var$extractComponentTypes(composition);
    const typesToPreload = Array.from(componentTypes).filter((type)=>(0, $9gXYv.UNIFORM_TYPE_TO_LOADER)[type]);
    if (typesToPreload.length === 0) return;
    await Promise.all(typesToPreload.map(async (type)=>{
        const loaderKey = (0, $9gXYv.UNIFORM_TYPE_TO_LOADER)[type];
        if (loaderKey && (0, $9gXYv.componentLoaders)[loaderKey]) try {
            await (0, $9gXYv.componentLoaders)[loaderKey]();
        } catch (error) {
            console.warn(`Failed to preload component: ${type}`, error);
        }
    }));
}
async function $b13d28c25dca5a59$export$f3577375c6f4aa2f(composition) {
    if (!composition) return;
    const componentTypes = $b13d28c25dca5a59$var$extractComponentTypes(composition);
    const priorityTypesInComposition = Array.from(componentTypes).filter((type)=>(0, $9gXYv.PRIORITY_PRELOAD_COMPONENTS).has(type) && (0, $9gXYv.UNIFORM_TYPE_TO_LOADER)[type]);
    if (priorityTypesInComposition.length === 0) return;
    await Promise.all(priorityTypesInComposition.map(async (type)=>{
        const loaderKey = (0, $9gXYv.UNIFORM_TYPE_TO_LOADER)[type];
        if (loaderKey && (0, $9gXYv.componentLoaders)[loaderKey]) try {
            await (0, $9gXYv.componentLoaders)[loaderKey]();
        } catch (error) {
            console.warn(`Failed to preload priority component: ${type}`, error);
        }
    }));
}
var $b13d28c25dca5a59$export$2e2bcd8739ae039 = $b13d28c25dca5a59$var$UNIFORM_DEFINITIONS;

});
parcelRegister("9gXYv", function(module, exports) {

$parcel$export(module.exports, "PRIORITY_PRELOAD_COMPONENTS", function () { return $895a645d87e93a47$export$b3ea4d62e0322ce; });
$parcel$export(module.exports, "componentLoaders", function () { return $895a645d87e93a47$export$14db8c195399483c; });
$parcel$export(module.exports, "UNIFORM_TYPE_TO_LOADER", function () { return $895a645d87e93a47$export$cbc74eadad531524; });
// @ts-nocheck ts(2834)
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Component loaders for dynamic imports
 * All components are lazy-loaded to optimize bundle size
 */ // Priority components (above-the-fold) - will be preloaded immediately
const $895a645d87e93a47$export$b3ea4d62e0322ce = new Set([
    "page",
    "globalNav",
    "globalFooter",
    "heroSection",
    "heroIntro",
    "heroCarousel",
    "heroCarouselSection",
    "customerStoriesDetailsHero",
    "container",
    // Often wraps above-the-fold content
    "heading",
    // Critical for LCP - headings are typically above-the-fold
    "text" // Often critical content that affects LCP,
]);
















































const $895a645d87e93a47$export$14db8c195399483c = {
    accordion: ()=>Promise.resolve((parcelRequire("g7YDa"))),
    bannerAlert: ()=>Promise.resolve((parcelRequire("1419P"))),
    bodyContent: ()=>Promise.resolve((parcelRequire("13r6t"))),
    button: ()=>Promise.resolve((parcelRequire("54jXi"))),
    callToAction: ()=>Promise.resolve((parcelRequire("aDgKf"))),
    card: ()=>Promise.resolve((parcelRequire("7vkxP"))),
    columnLayout: ()=>Promise.resolve((parcelRequire("haYnf"))).then((m)=>({
                default: m.UniformColumnLayout
            })),
    container: ()=>Promise.resolve((parcelRequire("hQud5"))),
    contentBlock: ()=>Promise.resolve((parcelRequire("bvk3D"))),
    customerStat: ()=>Promise.resolve((parcelRequire("dX6Xs"))),
    customerStoriesDetailsHero: ()=>Promise.resolve((parcelRequire("JGvCj"))),
    customerTestimonials: ()=>Promise.resolve((parcelRequire("dUTg3"))),
    globalFooter: ()=>Promise.resolve((parcelRequire("gMNh2"))),
    globalNav: ()=>Promise.resolve((parcelRequire("l0zDw"))),
    heading: ()=>Promise.resolve((parcelRequire("19QOl"))),
    heroCarousel: ()=>Promise.resolve((parcelRequire("98ja9"))),
    heroCarouselSection: ()=>Promise.resolve((parcelRequire("lrMw1"))),
    heroIntro: ()=>Promise.resolve((parcelRequire("e992t"))),
    heroSection: ()=>Promise.resolve((parcelRequire("hS2Tl"))),
    horizontalDivider: ()=>Promise.resolve((parcelRequire("7JHqD"))),
    image: ()=>Promise.resolve((parcelRequire("e6r6l"))),
    jiraTemplatesTabContentSubgridLayout: ()=>Promise.resolve((parcelRequire("4x11f"))),
    link: ()=>Promise.resolve((parcelRequire("dFD1n"))),
    list: ()=>Promise.resolve((parcelRequire("hykE5"))),
    listv2: ()=>Promise.resolve((parcelRequire("ee1EE"))),
    lozenge: ()=>Promise.resolve((parcelRequire("kgmR5"))),
    modal: ()=>Promise.resolve((parcelRequire("liGDD"))),
    page: ()=>Promise.resolve((parcelRequire("ixWw7"))),
    pagination: ()=>Promise.resolve((parcelRequire("bMQWw"))),
    personalizationContainer: ()=>Promise.resolve((parcelRequire("5TIC4"))),
    pricingCalculator: ()=>Promise.resolve((parcelRequire("1fx7M"))),
    pricingTable: ()=>Promise.resolve((parcelRequire("9nWUO"))),
    productCard: ()=>Promise.resolve((parcelRequire("cceBl"))),
    pullQuote: ()=>Promise.resolve((parcelRequire("7D1nQ"))),
    singleTab: ()=>Promise.resolve((parcelRequire("adl56"))),
    splitColorBackgroundContainer: ()=>Promise.resolve((parcelRequire("5znlu"))),
    statsSection: ()=>Promise.resolve((parcelRequire("a1e48"))),
    statsigExperimentContainer: ()=>Promise.resolve((parcelRequire("7z1ju"))),
    statsigFeatureGateContainer: ()=>Promise.resolve((parcelRequire("adPPd"))),
    subColumnLayout: ()=>Promise.resolve((parcelRequire("haYnf"))).then((m)=>({
                default: m.UniformSubColumnLayout
            })),
    tabs12Col: ()=>Promise.resolve((parcelRequire("2UtIB"))),
    tabs8Col: ()=>Promise.resolve((parcelRequire("1kxv4"))),
    templateModalButton: ()=>Promise.resolve((parcelRequire("diZQT"))),
    templatePreview: ()=>Promise.resolve((parcelRequire("5hZGW"))),
    text: ()=>Promise.resolve((parcelRequire("6NpvY"))),
    textWithIcon: ()=>Promise.resolve((parcelRequire("85qcB"))),
    variant: ()=>Promise.resolve((parcelRequire("jzDAp"))),
    variantContainer: ()=>Promise.resolve((parcelRequire("3Z0Az")))
};
const $895a645d87e93a47$export$cbc74eadad531524 = {
    accordion: "accordion",
    bannerAlert: "bannerAlert",
    blockContainer: "container",
    // Legacy alias
    button: "button",
    card: "card",
    columnLayout: "columnLayout",
    container: "container",
    contentBlock: "contentBlock",
    ctaWithPolygonBackground: "callToAction",
    customerBodyContent: "bodyContent",
    customerStat: "customerStat",
    customerStoriesDetailsHero: "customerStoriesDetailsHero",
    customerTestimonials: "customerTestimonials",
    globalFooter: "globalFooter",
    globalNav: "globalNav",
    heading: "heading",
    heroCarousel: "heroCarousel",
    // Maps to hero-carousel-v0
    heroCarouselSection: "heroCarouselSection",
    // Maps to hero-carousel
    heroIntro: "heroIntro",
    heroSection: "heroSection",
    horizontalDivider: "horizontalDivider",
    image: "image",
    jiraTemplatesTabContentSubgridLayout: "jiraTemplatesTabContentSubgridLayout",
    link: "link",
    list: "list",
    listv2: "listv2",
    lozenge: "lozenge",
    modal: "modal",
    page: "page",
    pagination: "pagination",
    personalizationContainer: "personalizationContainer",
    pricingCalculator: "pricingCalculator",
    pricingTable: "pricingTable",
    productCard: "productCard",
    pullQuote: "pullQuote",
    singleTab: "singleTab",
    splitBackgroundContainer: "splitColorBackgroundContainer",
    statsSection: "statsSection",
    statsigExperimentContainer: "statsigExperimentContainer",
    statsigFeatureGateContainer: "statsigFeatureGateContainer",
    subColumnLayout: "subColumnLayout",
    tabs12Col: "tabs12Col",
    tabs8Col: "tabs8Col",
    templateModalButton: "templateModalButton",
    templatePreview: "templatePreview",
    text: "text",
    textWithIcon: "textWithIcon",
    variant: "variant",
    variantContainer: "variantContainer"
};

});

parcelRegister("4sbR8", function(module, exports) {

$parcel$export(module.exports, "UniformMissingComponent", function () { return $bf3a6afbcc6e7c21$export$ec79654869ecfe2e; });
/* uniform-missing-component.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $bf3a6afbcc6e7c21$export$ec79654869ecfe2e = ({ componentName: componentName })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        id: `UNIFORM-MISSING-COMPONENT-${componentName}`,
        "data-nosnippet": true,
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            "_1e0cglyw"
        ])
    });
};

});






parcelRegister("lcvl0", function(module, exports) {

$parcel$export(module.exports, "UniformJiraPricingEntryPage", function () { return $35d94f79da85054c$export$bf65523dba15d046; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $9iWJ8 = parcelRequire("9iWJ8");

var $lgDo7 = parcelRequire("lgDo7");
const $35d94f79da85054c$export$bf65523dba15d046 = (props)=>{
    const [hasFired, fireExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).jiraPricingPageWaeMigration);
    (0, $iSvIT.useEffect)(()=>{
        if (!hasFired) fireExposure();
    }, [
        hasFired,
        fireExposure
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lgDo7.UniformEntryPage), (0, $7Knp0._)({}, props));
};

});

parcelRegister("bMysh", function(module, exports) {

$parcel$export(module.exports, "UniformPreviewPage", function () { return $9e9a724ad1764be5$export$485017e8654f464d; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("1JmyE");
var $3z0Z0 = parcelRequire("3z0Z0");
const $9e9a724ad1764be5$export$485017e8654f464d = ({ composition: composition, isUniformPlayground: isUniformPlayground })=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $3z0Z0.UniformPreviewPageTemplate), {
        composition: composition,
        isUniformPlayground: isUniformPlayground
    });

});
parcelRegister("1JmyE", function(module, exports) {
$parcel$export(module.exports, "UniformPreviewPageTemplate", function () { return (parcelRequire("3z0Z0")).UniformPreviewPageTemplate; });

var $3z0Z0 = parcelRequire("3z0Z0");

});
parcelRegister("3z0Z0", function(module, exports) {

$parcel$export(module.exports, "UniformPreviewPageTemplate", function () { return $b55e3d8b43b8e0f2$export$4236df4850175643; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $4ktyF = parcelRequire("4ktyF");

var $aME7P = parcelRequire("aME7P");
const $b55e3d8b43b8e0f2$export$4236df4850175643 = ({ composition: composition, isUniformPlayground: isUniformPlayground })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4ktyF.default), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aME7P.UniformWrapper), {
            composition: composition,
            isUniformPlayground: isUniformPlayground
        })
    });
};

});



parcelRegister("7Tq4R", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $a2725444c60d8295$export$2cd8252107eb640b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $9jv6U = parcelRequire("9jv6U");

var $01JF1 = parcelRequire("01JF1");

var $cGDYS = parcelRequire("cGDYS");

var $7RyUO = parcelRequire("7RyUO");

var $dunoe = parcelRequire("dunoe");

var $k2OeR = parcelRequire("k2OeR");

var $j0nzO = parcelRequire("j0nzO");

var $14zFQ = parcelRequire("14zFQ");

var $dJ4mM = parcelRequire("dJ4mM");

var $6wlNh = parcelRequire("6wlNh");

var $9uFWm = parcelRequire("9uFWm");

var $EyEcw = parcelRequire("EyEcw");

var $9Dbz6 = parcelRequire("9Dbz6");
window.BUILD_KEY = "p-4402d5942b";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $cGDYS.default)()
    }
};
const $a2725444c60d8295$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $dunoe.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $9Dbz6.parseRoute)(window.location);
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $k2OeR.isPerformanceOnetrustEnabled)(document.cookie, locationData);
    isPerfOnetrustEnabled && (0, $7RyUO.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $9jv6U.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $EyEcw.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $6wlNh.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $6wlNh.overrideAjsAnonIdFromCookie)();
        (0, $6wlNh.overrideCustomAttributes)();
    }
    (0, $j0nzO.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        if (isStatic) {
            // @ts-ignore
            const root = (0, $01JF1.createRoot)(document.getElementById("wac"));
            root.render(/*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
                locale: locale,
                messages: window.SSR_languagePack,
                cookies: document.cookie,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJ4mM.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    pureClientMode: true,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    // @ts-ignore
                    compositionMetrics: window.compositionMetrics,
                    isUniformPlayground: window.isUniformPlayground,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    clusterTag: window.clusterTag,
                    auxiaResponse: window.auxiaResponse,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    children: Component
                })
            }));
        } else (0, $01JF1.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), /*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $14zFQ.Layout), {
                analyticsWebClient: analyticsWebClient,
                location: window.location,
                pricing: window.prices,
                availableProducts: window.availableProducts,
                // @ts-ignore
                tutorial: window.tutorial,
                templates: window.templates,
                partnerTemplates: window.partnerTemplates,
                collections: window.collections,
                categories: window.categories,
                userProfile: window.userProfile,
                userProfileStatus: window.userProfileStatus,
                userContext: window.userContext,
                userContextStatus: window.userContextStatus,
                loggedOutContext: window.loggedOutContext,
                loggedOutContextStatus: window.loggedOutContextStatus,
                countryCode: window.countryCode,
                composition: window._uniformPreloadedComposition,
                // @ts-ignore
                compositionMetrics: window.compositionMetrics,
                isUniformPlayground: window.isUniformPlayground,
                teamType: window.teamType,
                keyword: window.keyword,
                mlTemplateIds: window.mlTemplateIds,
                referrer: window.referrer,
                anchor: window.anchor,
                subAnchor: window.subAnchor,
                clusterTag: window.clusterTag,
                auxiaResponse: window.auxiaResponse,
                transactionAccounts: window.transactionAccounts,
                userAgent: userAgent,
                children: Component
            })
        }), {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});

parcelRegister("2A2ZL", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $f29b64522dc0a459$export$2cd8252107eb640b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $9jv6U = parcelRequire("9jv6U");

var $01JF1 = parcelRequire("01JF1");

var $hOqV7 = parcelRequire("hOqV7");

var $cGDYS = parcelRequire("cGDYS");

var $7RyUO = parcelRequire("7RyUO");

var $dunoe = parcelRequire("dunoe");

var $200NX = parcelRequire("200NX");

var $kNCWT = parcelRequire("kNCWT");

var $j0nzO = parcelRequire("j0nzO");

var $14zFQ = parcelRequire("14zFQ");

var $dJ4mM = parcelRequire("dJ4mM");

var $1FD73 = parcelRequire("1FD73");

var $6wlNh = parcelRequire("6wlNh");

var $k2OeR = parcelRequire("k2OeR");

var $9uFWm = parcelRequire("9uFWm");

var $EyEcw = parcelRequire("EyEcw");

var $9Dbz6 = parcelRequire("9Dbz6");
window.BUILD_KEY = "p-4402d5942b";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $cGDYS.default)()
    }
};
const $f29b64522dc0a459$export$2cd8252107eb640b = (Component, query, queryVars, relayApi)=>{
    const analyticsWebClient = (0, $dunoe.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $9Dbz6.parseRoute)(window.location);
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $k2OeR.isPerformanceOnetrustEnabled)(document.cookie, locationData);
    isPerfOnetrustEnabled && (0, $7RyUO.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $9jv6U.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $EyEcw.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    if ((0, $6wlNh.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $6wlNh.overrideAjsAnonIdFromCookie)();
        (0, $6wlNh.overrideCustomAttributes)();
    }
    (0, $j0nzO.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const isStatic = typeof window !== "undefined" && window.IS_STATIC;
        const snapshot = window.relayStoreSnapshot;
        let relayBaseUrl = undefined;
        let relayAuthKey = undefined;
        if (relayApi === (0, $200NX.RELAY_API_CONTENTFUL)) {
            relayBaseUrl = (0, $kNCWT.CONTENTFUL_GRAPHQL_API_URL);
            relayAuthKey = window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES;
        }
        const relayEnvironment = (0, $1FD73.initRelayEnvironment)(snapshot, relayBaseUrl, relayAuthKey);
        const queryRef = (0, $hOqV7.loadQuery)(relayEnvironment, query, queryVars);
        if (isStatic) {
            // @ts-ignore
            const root = (0, $01JF1.createRoot)(document.getElementById("wac"));
            root.render(/*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
                locale: locale,
                messages: window.SSR_languagePack,
                cookies: document.cookie,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hOqV7.RelayEnvironmentProvider), {
                    environment: relayEnvironment,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJ4mM.PageWrapper), {
                        analyticsWebClient: analyticsWebClient,
                        pureClientMode: true,
                        location: window.location,
                        pricing: window.prices,
                        availableProducts: window.availableProducts,
                        userProfile: window.userProfile,
                        userProfileStatus: window.userProfileStatus,
                        userContext: window.userContext,
                        userContextStatus: window.userContextStatus,
                        loggedOutContext: window.loggedOutContext,
                        loggedOutContextStatus: window.loggedOutContextStatus,
                        countryCode: window.countryCode,
                        mlTemplateIds: window.mlTemplateIds,
                        keyword: window.keyword,
                        subAnchor: window.subAnchor,
                        auxiaResponse: window.auxiaResponse,
                        queryRef: queryRef,
                        transactionAccounts: window.transactionAccounts,
                        userAgent: userAgent,
                        children: Component
                    })
                })
            }));
        } else (0, $01JF1.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), /*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hOqV7.RelayEnvironmentProvider), {
                environment: relayEnvironment,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $14zFQ.Layout), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    countryCode: window.countryCode,
                    mlTemplateIds: window.mlTemplateIds,
                    keyword: window.keyword,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    queryRef: queryRef,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    children: Component
                })
            })
        }), {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});
parcelRegister("1FD73", function(module, exports) {

$parcel$export(module.exports, "initRelayEnvironment", function () { return $7d9774703a666878$export$1456be3de97c862f; });

var $4PJsz = parcelRequire("4PJsz");
(0, $4PJsz.RelayFeatureFlags).ENABLE_LOAD_QUERY_REQUEST_DEDUPING = true;
// TODO: Lift this into environment
const $7d9774703a666878$var$GATEWAY_URL = "https://www.atlassian.com/gateway/api/graphql";
function $7d9774703a666878$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken) {
    const baseUrl = baseUrlOverride !== null && baseUrlOverride !== void 0 ? baseUrlOverride : $7d9774703a666878$var$GATEWAY_URL;
    let headers = {
        "Content-Type": "application/json"
    };
    if (authToken) headers = Object.assign({}, headers, {
        Authorization: `Bearer ${authToken}`
    });
    const fetchResponse = (params, variables)=>{
        const startTime = Date.now();
        const response = fetch(baseUrl, {
            method: "POST",
            headers: headers,
            // Contentful uses an authToken, and Access-Control-Allow-Origin = "*",
            // therefore we cannot include credentials for Contentful queries
            credentials: authToken ? "same-origin" : "include",
            body: JSON.stringify({
                query: params.text,
                variables: variables
            })
        });
        return (0, $4PJsz.Observable).from(response.then(async (res)=>{
            const duration = Date.now() - startTime;
            // @ts-ignore
            if (!globalThis.IS_STATIC) try {
                // @ts-ignore
                globalThis.metrics.histogram(`contentful.duration`, "10_100_500_1000_2000_3000_5000_10000_30000", duration, {
                    gqlOperationName: params.name,
                    cacheStatus: res.headers.get("x-cache"),
                    status: res.status
                });
            } catch (e) {
                console.error(`Failed to track ${params.name} call`, e);
            }
            return res.json();
        }));
    };
    const network = (0, $4PJsz.Network).create(fetchResponse);
    const store = new (0, $4PJsz.Store)(new (0, $4PJsz.RecordSource)(initialRecords));
    return new (0, $4PJsz.Environment)({
        network: network,
        store: store
    });
}
let $7d9774703a666878$var$clientSideRelayEnvironment;
function $7d9774703a666878$export$1456be3de97c862f(initialRecords, baseUrlOverride, authToken) {
    const environment = $7d9774703a666878$var$clientSideRelayEnvironment !== null && $7d9774703a666878$var$clientSideRelayEnvironment !== void 0 ? $7d9774703a666878$var$clientSideRelayEnvironment : $7d9774703a666878$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken);
    if (typeof window === "undefined") return environment;
    if (!$7d9774703a666878$var$clientSideRelayEnvironment) $7d9774703a666878$var$clientSideRelayEnvironment = environment;
    else if (initialRecords) environment.getStore().publish(new (0, $4PJsz.RecordSource)(initialRecords));
    return $7d9774703a666878$var$clientSideRelayEnvironment;
}

});


parcelRegister("4OZuI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $382b8872d10951af$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $382b8872d10951af$export$2e2bcd8739ae039() {}

});

parcelRegister("gWVOm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c56ee842a6e145c0$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $jxLBU = parcelRequire("jxLBU");

var $e6NKX = parcelRequire("e6NKX");

var $5tewI = parcelRequire("5tewI");

var $2dIRV = parcelRequire("2dIRV");

var $8C2L4 = parcelRequire("8C2L4");
function $c56ee842a6e145c0$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? "effect" : _ref$mountStrategy;
    var isSubsequentRender = (0, $2dIRV.default)(mountStrategy);
    (0, $8C2L4.default)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $jxLBU.fg)("platform_design_system_team_portal_logic_r18_fix") ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $e6NKX.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5tewI.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("e6NKX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a45838cb14897e3d$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $i5UxU = parcelRequire("i5UxU");

var $kLBLt = parcelRequire("kLBLt");
function $a45838cb14897e3d$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $iSvIT.useMemo)(function() {
        return (0, $kLBLt.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $kLBLt.appendPortalContainerIfNotAppended)(container);
    (0, $iSvIT.useEffect)(function() {
        return function() {
            (0, $kLBLt.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $i5UxU.createPortal)(children, container);
}

});
parcelRegister("kLBLt", function(module, exports) {

$parcel$export(module.exports, "createContainer", function () { return $03e6cc59b51ea256$export$26ae5ca175b4ec5a; });
$parcel$export(module.exports, "removePortalContainer", function () { return $03e6cc59b51ea256$export$da99f98bf3fe55b3; });
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $03e6cc59b51ea256$export$c582005add11e141; });
$parcel$export(module.exports, "createAtlaskitPortal", function () { return $03e6cc59b51ea256$export$fef014d7cef9e543; });
$parcel$export(module.exports, "createPortalParent", function () { return $03e6cc59b51ea256$export$95029ca7aca2989e; });

var $9Ntbc = parcelRequire("9Ntbc");
var $03e6cc59b51ea256$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $9Ntbc.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $03e6cc59b51ea256$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $03e6cc59b51ea256$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $9Ntbc.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement("div");
        parent.className = (0, $9Ntbc.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        (_getBody = $03e6cc59b51ea256$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $03e6cc59b51ea256$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $03e6cc59b51ea256$var$getPortalParent().removeChild(container);
};
var $03e6cc59b51ea256$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $03e6cc59b51ea256$var$getPortalParent().appendChild(container);
};
var $03e6cc59b51ea256$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $03e6cc59b51ea256$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($03e6cc59b51ea256$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement("div");
        atlaskitportal.className = (0, $9Ntbc.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $03e6cc59b51ea256$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($03e6cc59b51ea256$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $9Ntbc.portalParentSelector));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement("div");
            parent.className = (0, $9Ntbc.portalParentClassName);
            parent.style.display = "flex";
            (_getBody2 = $03e6cc59b51ea256$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};

});
parcelRegister("9Ntbc", function(module, exports) {

$parcel$export(module.exports, "portalParentClassName", function () { return $721f53232fcd93dc$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $721f53232fcd93dc$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $721f53232fcd93dc$export$13f57c02915787b3; });
var $721f53232fcd93dc$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $721f53232fcd93dc$export$72f415121273627e = "body > .atlaskit-portal-container";
var $721f53232fcd93dc$export$13f57c02915787b3 = "atlaskit-portal";

});



parcelRegister("5tewI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fbaeddcb396f38b$export$2e2bcd8739ae039; });

var $79Oe9 = parcelRequire("79Oe9");

var $iSvIT = parcelRequire("iSvIT");

var $i5UxU = parcelRequire("i5UxU");

var $iunHK = parcelRequire("iunHK");

var $kLBLt = parcelRequire("kLBLt");
function $3fbaeddcb396f38b$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $iSvIT.useState)(null), _useState2 = (0, $79Oe9.default)(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $iunHK.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $kLBLt.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $kLBLt.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iSvIT.Suspense), {
        fallback: null
    }, children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $i5UxU.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("79Oe9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $536055b9bdf7c333$export$2e2bcd8739ae039; });

var $dwpqk = parcelRequire("dwpqk");

var $dTDZY = parcelRequire("dTDZY");

var $h97av = parcelRequire("h97av");

var $lKt99 = parcelRequire("lKt99");
function $536055b9bdf7c333$export$2e2bcd8739ae039(r, e) {
    return (0, $dwpqk.default)(r) || (0, $dTDZY.default)(r, e) || (0, $h97av.default)(r, e) || (0, $lKt99.default)();
}

});
parcelRegister("dwpqk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d81fc1ca835bb8e$export$2e2bcd8739ae039; });
function $9d81fc1ca835bb8e$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("dTDZY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1df704a378b2f5c$export$2e2bcd8739ae039; });
function $a1df704a378b2f5c$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("h97av", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7b8d67553326fc8$export$2e2bcd8739ae039; });

var $5Q4ke = parcelRequire("5Q4ke");
function $c7b8d67553326fc8$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $5Q4ke.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $5Q4ke.default)(r, a) : void 0;
    }
}

});
parcelRegister("5Q4ke", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $440529fabc132f31$export$2e2bcd8739ae039; });
function $440529fabc132f31$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("lKt99", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd5480c32357969c$export$2e2bcd8739ae039; });
function $fd5480c32357969c$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("iunHK", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $d75d6a96e6b81bcd$export$700979bc83e7db82; });

var $iSvIT = parcelRequire("iSvIT");
var $d75d6a96e6b81bcd$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $iSvIT.useLayoutEffect) : (0, $iSvIT.useEffect);

});


parcelRegister("2dIRV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19df99a875e98f8a$export$2e2bcd8739ae039; });

var $79Oe9 = parcelRequire("79Oe9");

var $iSvIT = parcelRequire("iSvIT");

var $iunHK = parcelRequire("iunHK");
var $19df99a875e98f8a$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $iSvIT.useState)(false), _useState2 = (0, $79Oe9.default)(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)(function() {
        return mountStrategy === "layoutEffect" ? (0, $iunHK.useIsomorphicLayoutEffect) : (0, $iSvIT.useEffect);
    }), _useState4 = (0, $79Oe9.default)(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $19df99a875e98f8a$export$2e2bcd8739ae039 = $19df99a875e98f8a$var$useIsSubsequentRender;

});

parcelRegister("8C2L4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6454030ec1bab2bf$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $bVKWb = parcelRequire("bVKWb");

var $8UQGM = parcelRequire("8UQGM");
var $6454030ec1bab2bf$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $iSvIT.useEffect)(function() {
        (0, $8UQGM.default)((0, $bVKWb.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $8UQGM.default)((0, $bVKWb.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $6454030ec1bab2bf$export$2e2bcd8739ae039 = $6454030ec1bab2bf$var$useFirePortalEvent;

});
parcelRegister("bVKWb", function(module, exports) {

$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $8af96d630ea5ecbc$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $8af96d630ea5ecbc$export$80816bd900e5bd00; });
var $8af96d630ea5ecbc$export$ed5835cc67e87f72 = "akPortalMount";
var $8af96d630ea5ecbc$export$80816bd900e5bd00 = "akPortalUnmount";

});

parcelRegister("8UQGM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67dc6ca7568094c8$export$2e2bcd8739ae039; });
var $67dc6ca7568094c8$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $67dc6ca7568094c8$var$getLayerName = function getLayerName(zIndex) {
    return $67dc6ca7568094c8$var$zIndexToName.hasOwnProperty(zIndex) ? $67dc6ca7568094c8$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $67dc6ca7568094c8$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $67dc6ca7568094c8$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $67dc6ca7568094c8$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $67dc6ca7568094c8$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("52xdm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ab6e7588760c130$export$2e2bcd8739ae039; });
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gLRVV = parcelRequire("gLRVV");

var $iSvIT = parcelRequire("iSvIT");

var $ecLC4 = parcelRequire("ecLC4");
var $g2S1g = parcelRequire("g2S1g");

var $1PRJ2 = parcelRequire("1PRJ2");

var $4OZuI = parcelRequire("4OZuI");

var $41imr = parcelRequire("41imr");

function $3ab6e7588760c130$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3ab6e7588760c130$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3ab6e7588760c130$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gLRVV.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3ab6e7588760c130$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3ab6e7588760c130$var$packageName = "@atlaskit/blanket";
var $3ab6e7588760c130$var$packageVersion = "15.0.0";
var $3ab6e7588760c130$var$analyticsAttributes = {
    componentName: "blanket",
    packageName: $3ab6e7588760c130$var$packageName,
    packageVersion: $3ab6e7588760c130$var$packageVersion
};
var $3ab6e7588760c130$var$baseStyles = null;
var $3ab6e7588760c130$var$shouldAllowClickThroughStyles = null;
var $3ab6e7588760c130$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $3ab6e7588760c130$var$Blanket = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $4OZuI.default) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var mouseDownTarget = (0, $iSvIT.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $1PRJ2.usePlatformLeafEventHandler)($3ab6e7588760c130$var$_objectSpread({
        fn: onBlanketClicked,
        action: "clicked",
        analyticsData: analyticsContext
    }, $3ab6e7588760c130$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $iSvIT.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $iSvIT.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $ecLC4.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk705f _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ]),
        style: {
            "--_10avjlk": (0, $g2S1g.default)("var(--ds-blanket, ".concat((0, $41imr.N100A), ")"))
        }
    }, children);
}));
$3ab6e7588760c130$var$Blanket.displayName = "Blanket";
var $3ab6e7588760c130$export$2e2bcd8739ae039 = $3ab6e7588760c130$var$Blanket;

});
parcelRegister("gLRVV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c35adf21fccd2072$export$2e2bcd8739ae039; });

var $39bLe = parcelRequire("39bLe");
function $c35adf21fccd2072$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $39bLe.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("39bLe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24ab55cacd2ffee4$export$2e2bcd8739ae039; });

var $evu92 = parcelRequire("evu92");

var $3MuJa = parcelRequire("3MuJa");
function $24ab55cacd2ffee4$export$2e2bcd8739ae039(t) {
    var i = (0, $3MuJa.default)(t, "string");
    return "symbol" == (0, $evu92.default)(i) ? i : i + "";
}

});
parcelRegister("evu92", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8fb581648d814b8$export$2e2bcd8739ae039; });
function $a8fb581648d814b8$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $a8fb581648d814b8$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a8fb581648d814b8$export$2e2bcd8739ae039(o);
}

});

parcelRegister("3MuJa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c0db0a868d42c88$export$2e2bcd8739ae039; });

var $evu92 = parcelRequire("evu92");
function $2c0db0a868d42c88$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $evu92.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $evu92.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("ecLC4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5771ea84e375501$export$2e2bcd8739ae039; });
const $a5771ea84e375501$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $a5771ea84e375501$var$ATOMIC_GROUP_LENGTH = 5;
function $a5771ea84e375501$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $a5771ea84e375501$var$UNDERSCORE_UNICODE ? $a5771ea84e375501$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("g2S1g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bae6bc5d268579a7$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $bae6bc5d268579a7$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});

parcelRegister("1PRJ2", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $15643a977b5a0f5c$export$a4687b0234b40e28; });

var $gLRVV = parcelRequire("gLRVV");

var $iSvIT = parcelRequire("iSvIT");

var $7NbUq = parcelRequire("7NbUq");

var $67lsh = parcelRequire("67lsh");
function $15643a977b5a0f5c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $15643a977b5a0f5c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $15643a977b5a0f5c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gLRVV.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $15643a977b5a0f5c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $15643a977b5a0f5c$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $7NbUq.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $67lsh.useTrackedRef)(analyticsData);
    var fnRef = (0, $67lsh.useTrackedRef)(fn);
    var handler = (0, $iSvIT.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $15643a977b5a0f5c$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("7NbUq", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $5ac658ebed47bba6$export$5bf35293e545f20c; });

var $6LIwV = parcelRequire("6LIwV");

var $7mr9U = parcelRequire("7mr9U");

var $1QaKl = parcelRequire("1QaKl");
function $5ac658ebed47bba6$export$5bf35293e545f20c() {
    var analyticsContext = (0, $1QaKl.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $6LIwV.useCallbackOne)(function(payload) {
        return new (0, $7mr9U.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("7mr9U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55bfa7a812165b3d$export$2e2bcd8739ae039; });

var $jObrW = parcelRequire("jObrW");

var $eJHTB = parcelRequire("eJHTB");

var $aCtuY = parcelRequire("aCtuY");

var $kAG3c = parcelRequire("kAG3c");

var $8RRS6 = parcelRequire("8RRS6");

var $grof2 = parcelRequire("grof2");

var $dICpU = parcelRequire("dICpU");

var $gLRVV = parcelRequire("gLRVV");

var $8NUKI = parcelRequire("8NUKI");
function $55bfa7a812165b3d$var$_callSuper(t, o, e) {
    return o = (0, $8RRS6.default)(o), (0, $kAG3c.default)(t, $55bfa7a812165b3d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $8RRS6.default)(t).constructor) : o.apply(t, e));
}
function $55bfa7a812165b3d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($55bfa7a812165b3d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $55bfa7a812165b3d$var$_superPropGet(t, o, e, r) {
    var p = (0, $grof2.default)((0, $8RRS6.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $55bfa7a812165b3d$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $55bfa7a812165b3d$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $55bfa7a812165b3d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $eJHTB.default)(this, UIAnalyticsEvent);
        _this = $55bfa7a812165b3d$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $gLRVV.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $gLRVV.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $jObrW.default)(_this.context);
            var handlers = (0, $jObrW.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $gLRVV.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $dICpU.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $aCtuY.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $55bfa7a812165b3d$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $8NUKI.default));

});
parcelRegister("jObrW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6bb91805f722845$export$2e2bcd8739ae039; });

var $3uTtl = parcelRequire("3uTtl");

var $g23oi = parcelRequire("g23oi");

var $ciCO0 = parcelRequire("ciCO0");

var $bE5xT = parcelRequire("bE5xT");
function $e6bb91805f722845$export$2e2bcd8739ae039(r) {
    return (0, $3uTtl.default)(r) || (0, $g23oi.default)(r) || (0, $ciCO0.default)(r) || (0, $bE5xT.default)();
}

});
parcelRegister("3uTtl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28bf3415abb3a24c$export$2e2bcd8739ae039; });

var $a2X0U = parcelRequire("a2X0U");
function $28bf3415abb3a24c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $a2X0U.default)(r);
}

});
parcelRegister("a2X0U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7507de2c1f7d329f$export$2e2bcd8739ae039; });
function $7507de2c1f7d329f$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("g23oi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $babf769cccb91b63$export$2e2bcd8739ae039; });
function $babf769cccb91b63$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("ciCO0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f45447396f6212e$export$2e2bcd8739ae039; });

var $a2X0U = parcelRequire("a2X0U");
function $8f45447396f6212e$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $a2X0U.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $a2X0U.default)(r, a) : void 0;
    }
}

});

parcelRegister("bE5xT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87a7bb5fcfb07324$export$2e2bcd8739ae039; });
function $87a7bb5fcfb07324$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("eJHTB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aba751772ee9cdc2$export$2e2bcd8739ae039; });
function $aba751772ee9cdc2$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("aCtuY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bb455cf3d4c1d97$export$2e2bcd8739ae039; });

var $39bLe = parcelRequire("39bLe");
function $7bb455cf3d4c1d97$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $39bLe.default)(o.key), o);
    }
}
function $7bb455cf3d4c1d97$export$2e2bcd8739ae039(e, r, t) {
    return r && $7bb455cf3d4c1d97$var$_defineProperties(e.prototype, r), t && $7bb455cf3d4c1d97$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("kAG3c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efd7c9c9f3f16f99$export$2e2bcd8739ae039; });

var $evu92 = parcelRequire("evu92");

var $l5AHL = parcelRequire("l5AHL");
function $efd7c9c9f3f16f99$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $evu92.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $l5AHL.default)(t);
}

});
parcelRegister("l5AHL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5a68969cad4ceaf$export$2e2bcd8739ae039; });
function $f5a68969cad4ceaf$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("8RRS6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $674d0fc31a50dc95$export$2e2bcd8739ae039; });
function $674d0fc31a50dc95$export$2e2bcd8739ae039(t) {
    return $674d0fc31a50dc95$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $674d0fc31a50dc95$export$2e2bcd8739ae039(t);
}

});

parcelRegister("grof2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf81f8d535c0eaa6$export$2e2bcd8739ae039; });

var $c4IrC = parcelRequire("c4IrC");
function $bf81f8d535c0eaa6$export$2e2bcd8739ae039() {
    return $bf81f8d535c0eaa6$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $c4IrC.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $bf81f8d535c0eaa6$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("c4IrC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ca8557ff8489a37$export$2e2bcd8739ae039; });

var $8RRS6 = parcelRequire("8RRS6");
function $8ca8557ff8489a37$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $8RRS6.default)(t)););
    return t;
}

});


parcelRegister("dICpU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fcd2f3b3a14b2bf$export$2e2bcd8739ae039; });

var $eazMz = parcelRequire("eazMz");
function $9fcd2f3b3a14b2bf$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $eazMz.default)(t, e);
}

});
parcelRegister("eazMz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a50dc186249673e7$export$2e2bcd8739ae039; });
function $a50dc186249673e7$export$2e2bcd8739ae039(t, e) {
    return $a50dc186249673e7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $a50dc186249673e7$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("8NUKI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $668eec2f6d97766c$export$2e2bcd8739ae039; });

var $evu92 = parcelRequire("evu92");

var $eJHTB = parcelRequire("eJHTB");

var $aCtuY = parcelRequire("aCtuY");

var $gLRVV = parcelRequire("gLRVV");
function $668eec2f6d97766c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $668eec2f6d97766c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $668eec2f6d97766c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gLRVV.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $668eec2f6d97766c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $668eec2f6d97766c$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $668eec2f6d97766c$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $668eec2f6d97766c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $eJHTB.default)(this, AnalyticsEvent);
        (0, $gLRVV.default)(this, "_isAnalyticsEvent", true);
        (0, $gLRVV.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $668eec2f6d97766c$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $aCtuY.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, $evu92.default)(updater) === "object") this.payload = $668eec2f6d97766c$var$_objectSpread($668eec2f6d97766c$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("1QaKl", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $1572fbce33c997e0$export$d1f587f82ad51c4; });

var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");
var $1572fbce33c997e0$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $iSvIT.useContext)((0, $lEO1D.default));
};

});


parcelRegister("67lsh", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $47440a13bcaa3ee2$export$1d27a74659855e44; });

var $iSvIT = parcelRequire("iSvIT");
var $47440a13bcaa3ee2$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $iSvIT.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("41imr", function(module, exports) {

$parcel$export(module.exports, "N100A", function () { return $2ed57f8980281ebc$export$486ab785e4bac3c6; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $2ed57f8980281ebc$export$4b84fd0e2c617bd = "#FFEBE6";
var $2ed57f8980281ebc$export$b34b069eff244586 = "#FFBDAD";
var $2ed57f8980281ebc$export$be802dd0d8b57f35 = "#FF8F73";
var $2ed57f8980281ebc$export$60847d42f9da92a6 = "#FF7452";
var $2ed57f8980281ebc$export$4a7404f376229999 = "#FF5630";
var $2ed57f8980281ebc$export$2010d0fb4295b346 = "#DE350B";
var $2ed57f8980281ebc$export$2837b5a1a71d5c02 = "#BF2600";
var $2ed57f8980281ebc$export$8d9596b529bbb9cf = "#FFFAE6";
var $2ed57f8980281ebc$export$41060a744ab0b7ae = "#FFF0B3";
var $2ed57f8980281ebc$export$1cc05bbbf340e559 = "#FFE380";
var $2ed57f8980281ebc$export$5aae31392d72caaa = "#FFC400";
var $2ed57f8980281ebc$export$c6930421db9fa514 = "#FFAB00";
var $2ed57f8980281ebc$export$59619663aa6500fb = "#FF991F";
var $2ed57f8980281ebc$export$874739ea9e379ab6 = "#FF8B00";
var $2ed57f8980281ebc$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $2ed57f8980281ebc$export$69a3bf21b9686c2b = "#ABF5D1";
var $2ed57f8980281ebc$export$afbce1382ec95f73 = "#79F2C0";
var $2ed57f8980281ebc$export$747d86715d4175de = "#57D9A3";
var $2ed57f8980281ebc$export$940e1f69e873f202 = "#36B37E";
var $2ed57f8980281ebc$export$a49394138f7b8e85 = "#00875A";
var $2ed57f8980281ebc$export$6fa04827ac68a4fb = "#006644";
var $2ed57f8980281ebc$export$226de0355ed012f8 = "#DEEBFF";
var $2ed57f8980281ebc$export$8c13c2ee36917869 = "#B3D4FF";
var $2ed57f8980281ebc$export$ecfc1dff386a3e7a = "#4C9AFF";
var $2ed57f8980281ebc$export$215b7063051591f1 = "#2684FF";
var $2ed57f8980281ebc$export$e62e8919cca44969 = "#0065FF";
var $2ed57f8980281ebc$export$b3de0ae08da2ce64 = "#0052CC";
var $2ed57f8980281ebc$export$a6ee3d71bc067634 = "#0747A6";
var $2ed57f8980281ebc$export$67f15409e87642a1 = "#669DF1";
var $2ed57f8980281ebc$export$f0539dbc42dbb067 = "#8FB8F6";
var $2ed57f8980281ebc$export$363e4475840015bb = "#EAE6FF";
var $2ed57f8980281ebc$export$4b0a4417ed59760f = "#C0B6F2";
var $2ed57f8980281ebc$export$6011520a64d9a187 = "#998DD9";
var $2ed57f8980281ebc$export$a7175d4e9206bc80 = "#8777D9";
var $2ed57f8980281ebc$export$b48405b95304b5a1 = "#6554C0";
var $2ed57f8980281ebc$export$c71e4279dd54a18d = "#5243AA";
var $2ed57f8980281ebc$export$147899de772240ec = "#403294";
var $2ed57f8980281ebc$export$2cf711fe14c66f06 = "#E6FCFF";
var $2ed57f8980281ebc$export$7a8f4d33f6f9772c = "#B3F5FF";
var $2ed57f8980281ebc$export$776c9c497ef08533 = "#79E2F2";
var $2ed57f8980281ebc$export$69cb3ca10c1e330e = "#00C7E6";
var $2ed57f8980281ebc$export$9dc1ef0f3f48059b = "#00B8D9";
var $2ed57f8980281ebc$export$7c835c78b6fcdef8 = "#00A3BF";
var $2ed57f8980281ebc$export$6036577f95c3877e = "#008DA6";
var $2ed57f8980281ebc$export$29a4f05edc054374 = "#FFFFFF";
var $2ed57f8980281ebc$export$e655ef011c4aa1a2 = "#FAFBFC";
var $2ed57f8980281ebc$export$9fdfb749e33cdf97 = "#F4F5F7";
var $2ed57f8980281ebc$export$3e51e8f1440314ba = "#EBECF0";
var $2ed57f8980281ebc$export$1ce2d1575d444ceb = "#DFE1E6";
var $2ed57f8980281ebc$export$8754fc7e6d8b3000 = "#C1C7D0";
var $2ed57f8980281ebc$export$c2e91cbeada39b8b = "#B3BAC5";
var $2ed57f8980281ebc$export$5f71e19f3a7ad9de = "#A5ADBA";
var $2ed57f8980281ebc$export$eaa8c8a70ac22806 = "#97A0AF";
var $2ed57f8980281ebc$export$7c87d337fb91a97d = "#8993A4";
var $2ed57f8980281ebc$export$d6447c357493214f = "#7A869A";
var $2ed57f8980281ebc$export$f563ee71e9ee74cd = "#6B778C";
var $2ed57f8980281ebc$export$e2ef2124cf4024b1 = "#5E6C84";
var $2ed57f8980281ebc$export$eece5f492e429f08 = "#505F79";
var $2ed57f8980281ebc$export$c39c0fe0f26207ae = "#42526E";
var $2ed57f8980281ebc$export$7090862dc3038a9f = "#344563";
var $2ed57f8980281ebc$export$ad0bacf983b7ddaa = "#253858";
var $2ed57f8980281ebc$export$7d61b15e0da132af = "#172B4D";
var $2ed57f8980281ebc$export$fbda843f0a27fe96 = "#091E42";
var $2ed57f8980281ebc$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $2ed57f8980281ebc$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $2ed57f8980281ebc$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $2ed57f8980281ebc$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $2ed57f8980281ebc$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $2ed57f8980281ebc$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $2ed57f8980281ebc$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $2ed57f8980281ebc$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $2ed57f8980281ebc$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $2ed57f8980281ebc$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $2ed57f8980281ebc$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $2ed57f8980281ebc$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $2ed57f8980281ebc$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $2ed57f8980281ebc$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $2ed57f8980281ebc$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $2ed57f8980281ebc$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $2ed57f8980281ebc$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $2ed57f8980281ebc$export$2f6319cf7d736c2a = "#E6EDFA";
var $2ed57f8980281ebc$export$95126bc8884d6634 = "#DCE5F5";
var $2ed57f8980281ebc$export$8338d8c35d44ff1 = "#CED9EB";
var $2ed57f8980281ebc$export$5368d76ae4fbbda7 = "#B8C7E0";
var $2ed57f8980281ebc$export$9f0a771d16ec8d36 = "#ABBBD6";
var $2ed57f8980281ebc$export$abcf8c38338b4aa5 = "#9FB0CC";
var $2ed57f8980281ebc$export$97e81faa16a182c7 = "#8C9CB8";
var $2ed57f8980281ebc$export$bfe21c59123ecf33 = "#7988A3";
var $2ed57f8980281ebc$export$ee82aa2ea6a1558 = "#67758F";
var $2ed57f8980281ebc$export$682927c6ed76be02 = "#56637A";
var $2ed57f8980281ebc$export$91fd9994c5be9757 = "#455166";
var $2ed57f8980281ebc$export$d281fbfe3cff2df6 = "#3B475C";
var $2ed57f8980281ebc$export$3902c91d8b98a753 = "#313D52";
var $2ed57f8980281ebc$export$8e8133c1ba5845b5 = "#283447";
var $2ed57f8980281ebc$export$33ff357f6620b39 = "#202B3D";
var $2ed57f8980281ebc$export$633847cf062b69e0 = "#1B2638";
var $2ed57f8980281ebc$export$9776a6e503bdbf76 = "#121A29";
var $2ed57f8980281ebc$export$6c813d5160dff5db = "#0E1624";
var $2ed57f8980281ebc$export$3d4f271a500072a = "#0D1424";
var $2ed57f8980281ebc$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $2ed57f8980281ebc$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $2ed57f8980281ebc$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $2ed57f8980281ebc$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $2ed57f8980281ebc$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $2ed57f8980281ebc$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $2ed57f8980281ebc$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $2ed57f8980281ebc$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $2ed57f8980281ebc$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $2ed57f8980281ebc$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $2ed57f8980281ebc$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $2ed57f8980281ebc$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $2ed57f8980281ebc$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $2ed57f8980281ebc$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $2ed57f8980281ebc$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $2ed57f8980281ebc$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $2ed57f8980281ebc$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $2ed57f8980281ebc$export$d2adc5dedf09fced = "#292A2E";
var $2ed57f8980281ebc$export$f51762073d2bb381 = "#94C748";
var $2ed57f8980281ebc$export$95e26d54def96891 = "#B3DF72";

});


parcelRegister("iy0QV", function(module, exports) {

$parcel$export(module.exports, "useExitingPersistence", function () { return $d80c10498eafa0ae$export$3b6f38abbdcbd000; });
$parcel$export(module.exports, "default", function () { return $d80c10498eafa0ae$export$2e2bcd8739ae039; });

var $6omqE = parcelRequire("6omqE");

var $iSvIT = parcelRequire("iSvIT");

var $jxLBU = parcelRequire("jxLBU");

var $fiHN5 = parcelRequire("fiHN5");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $d80c10498eafa0ae$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $d80c10498eafa0ae$var$ExitingContext = /*#__PURE__*/ (0, $iSvIT.createContext)($d80c10498eafa0ae$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $d80c10498eafa0ae$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $d80c10498eafa0ae$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($d80c10498eafa0ae$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $d80c10498eafa0ae$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $iSvIT.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $d80c10498eafa0ae$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $d80c10498eafa0ae$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $d80c10498eafa0ae$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $d80c10498eafa0ae$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $d80c10498eafa0ae$var$ExitingPersistence = /*#__PURE__*/ (0, $iSvIT.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $iSvIT.useState)([
        null,
        children
    ]), _useState2 = (0, $6omqE.default)(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)([]), _useState4 = (0, $6omqE.default)(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $iSvIT.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, $6omqE.default)(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $iSvIT.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $fiHN5.isReducedMotion)() && !(0, $jxLBU.fg)("platform_design_system_motion_on_finish_fix")) /**
     * We still want to use the `ExitingPersistence` with reduced motion,
     * otherwise the exiting `onFinish` is not called.
     */ return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, $6omqE.default)(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $d80c10498eafa0ae$var$childrenToArray(previousChildren);
    var current = $d80c10498eafa0ae$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $d80c10498eafa0ae$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $d80c10498eafa0ae$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $d80c10498eafa0ae$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $d80c10498eafa0ae$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $d80c10498eafa0ae$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $iSvIT.useContext)($d80c10498eafa0ae$var$ExitingContext);
};
$d80c10498eafa0ae$var$ExitingPersistence.displayName = "ExitingPersistence";
var $d80c10498eafa0ae$export$2e2bcd8739ae039 = $d80c10498eafa0ae$var$ExitingPersistence;

});
parcelRegister("6omqE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a7661e4a5e1a712$export$2e2bcd8739ae039; });

var $diQYQ = parcelRequire("diQYQ");

var $e6DER = parcelRequire("e6DER");

var $9qH2M = parcelRequire("9qH2M");

var $jEZdM = parcelRequire("jEZdM");
function $4a7661e4a5e1a712$export$2e2bcd8739ae039(r, e) {
    return (0, $diQYQ.default)(r) || (0, $e6DER.default)(r, e) || (0, $9qH2M.default)(r, e) || (0, $jEZdM.default)();
}

});
parcelRegister("diQYQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9af60d9bbcc25a55$export$2e2bcd8739ae039; });
function $9af60d9bbcc25a55$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("e6DER", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02a67537c81e26fd$export$2e2bcd8739ae039; });
function $02a67537c81e26fd$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("9qH2M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6dd7ee60ffe99b59$export$2e2bcd8739ae039; });

var $5XjpQ = parcelRequire("5XjpQ");
function $6dd7ee60ffe99b59$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $5XjpQ.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $5XjpQ.default)(r, a) : void 0;
    }
}

});
parcelRegister("5XjpQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $456186046ef97183$export$2e2bcd8739ae039; });
function $456186046ef97183$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("jEZdM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5013e03c74628e9$export$2e2bcd8739ae039; });
function $e5013e03c74628e9$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("fiHN5", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", function () { return $b23a815ec1a4fd1c$export$b7baf7667a68d87c; });
$parcel$export(module.exports, "prefersReducedMotion", function () { return $b23a815ec1a4fd1c$export$ff7706047246b98b; });

var $6omqE = parcelRequire("6omqE");

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");
var $b23a815ec1a4fd1c$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $b23a815ec1a4fd1c$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$b23a815ec1a4fd1c$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $b23a815ec1a4fd1c$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $iSvIT.useState)($b23a815ec1a4fd1c$export$b7baf7667a68d87c), _useState2 = (0, $6omqE.default)(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $iSvIT.useEffect)(function() {
        if (!$b23a815ec1a4fd1c$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $2e1kT.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $b23a815ec1a4fd1c$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $b23a815ec1a4fd1c$export$ff7706047246b98b = function prefersReducedMotion() {
    return $b23a815ec1a4fd1c$export$f0f789643ba5a83c;
};

});


parcelRegister("g2f6i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bac88be69adbc3f4$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $5OtVG = parcelRequire("5OtVG");
var $bac88be69adbc3f4$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $bac88be69adbc3f4$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $bac88be69adbc3f4$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === "proportional" ? "" : "-constant") : "fade-out";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5OtVG.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === "proportional" ? "" : "-constant") : "fade-in",
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $bac88be69adbc3f4$export$2e2bcd8739ae039 = $bac88be69adbc3f4$var$FadeIn;

});
parcelRegister("5OtVG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43b8d6a2e59b3708$export$2e2bcd8739ae039; });
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $6omqE = parcelRequire("6omqE");

var $iSvIT = parcelRequire("iSvIT");

var $bAZii = parcelRequire("bAZii");

var $jxLBU = parcelRequire("jxLBU");

var $fiHN5 = parcelRequire("fiHN5");

var $6U1Ci = parcelRequire("6U1Ci");

var $irr0b = parcelRequire("irr0b");

var $iy0QV = parcelRequire("iy0QV");

var $24ZLM = parcelRequire("24ZLM");
var $43b8d6a2e59b3708$var$zoomIn = null;
var $43b8d6a2e59b3708$var$zoomOut = null;
var $43b8d6a2e59b3708$var$fadeIn = null;
var $43b8d6a2e59b3708$var$fadeOut = null;
var $43b8d6a2e59b3708$var$fadeInFromTop = null;
var $43b8d6a2e59b3708$var$fadeOutFromTop = null;
var $43b8d6a2e59b3708$var$fadeInFromLeft = null;
var $43b8d6a2e59b3708$var$fadeOutFromLeft = null;
var $43b8d6a2e59b3708$var$fadeInFromBottom = null;
var $43b8d6a2e59b3708$var$fadeOutFromBottom = null;
var $43b8d6a2e59b3708$var$fadeInFromRight = null;
var $43b8d6a2e59b3708$var$fadeOutFromRight = null;
var $43b8d6a2e59b3708$var$fadeInFromTopConstant = null;
var $43b8d6a2e59b3708$var$fadeOutFromTopConstant = null;
var $43b8d6a2e59b3708$var$fadeInFromLeftConstant = null;
var $43b8d6a2e59b3708$var$fadeOutFromLeftConstant = null;
var $43b8d6a2e59b3708$var$fadeInFromBottomConstant = null;
var $43b8d6a2e59b3708$var$fadeOutFromBottomConstant = null;
var $43b8d6a2e59b3708$var$fadeInFromRightConstant = null;
var $43b8d6a2e59b3708$var$fadeOutFromRightConstant = null;
var $43b8d6a2e59b3708$var$slideInFromTop = null;
var $43b8d6a2e59b3708$var$slideOutFromTop = null;
var $43b8d6a2e59b3708$var$slideInFromRight = null;
var $43b8d6a2e59b3708$var$slideOutFromRight = null;
var $43b8d6a2e59b3708$var$slideInFromBottom = null;
var $43b8d6a2e59b3708$var$slideOutFromBottom = null;
var $43b8d6a2e59b3708$var$slideInFromLeft = null;
var $43b8d6a2e59b3708$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $43b8d6a2e59b3708$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration;
    var staggered = (0, $24ZLM.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $iy0QV.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $irr0b.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $iSvIT.useState)(appear), _useState2 = (0, $6omqE.default)(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $iSvIT.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === "exiting") // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $fiHN5.isReducedMotion)() && (0, $jxLBU.fg)("platform_design_system_motion_on_finish_fix")) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $6U1Ci.exitingDurations)[duration] : (0, $6U1Ci.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $bAZii.default)([
            (0, $bAZii.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $bAZii.default)([
                "_1y0ctrqk"
            ]),
            duration === "small" && (0, $bAZii.default)([
                "_5sag1yx9"
            ]),
            duration === "medium" && (0, $bAZii.default)([
                "_5sag1ttt"
            ]),
            duration === "large" && (0, $bAZii.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === "small" && (0, $bAZii.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === "medium" && (0, $bAZii.default)([
                "_5sagluct"
            ]),
            isExiting && duration === "large" && (0, $bAZii.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $bAZii.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === "linear" && (0, $bAZii.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === "ease-out" && (0, $bAZii.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === "ease-in" && (0, $bAZii.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === "ease-in-out" && (0, $bAZii.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === "linear" && (0, $bAZii.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-out" && (0, $bAZii.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in" && (0, $bAZii.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-out" && (0, $bAZii.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === "fade-in" || isExiting && exitingAnimation === "fade-in") && (0, $bAZii.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === "fade-out" || isExiting && exitingAnimation === "fade-out") && (0, $bAZii.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === "zoom-in" || isExiting && exitingAnimation === "zoom-in") && (0, $bAZii.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === "zoom-out" || isExiting && exitingAnimation === "zoom-out") && (0, $bAZii.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-top" || isExiting && exitingAnimation === "slide-in-from-top") && (0, $bAZii.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-top" || isExiting && exitingAnimation === "slide-out-from-top") && (0, $bAZii.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-right" || isExiting && exitingAnimation === "slide-in-from-right") && (0, $bAZii.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-right" || isExiting && exitingAnimation === "slide-out-from-right") && (0, $bAZii.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-bottom" || isExiting && exitingAnimation === "slide-in-from-bottom") && (0, $bAZii.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-bottom" || isExiting && exitingAnimation === "slide-out-from-bottom") && (0, $bAZii.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-left" || isExiting && exitingAnimation === "slide-in-from-left") && (0, $bAZii.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-left" || isExiting && exitingAnimation === "slide-out-from-left") && (0, $bAZii.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-top" || isExiting && exitingAnimation === "fade-in-from-top") && (0, $bAZii.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-top" || isExiting && exitingAnimation === "fade-out-from-top") && (0, $bAZii.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-left" || isExiting && exitingAnimation === "fade-in-from-left") && (0, $bAZii.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-left" || isExiting && exitingAnimation === "fade-out-from-left") && (0, $bAZii.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-bottom" || isExiting && exitingAnimation === "fade-in-from-bottom") && (0, $bAZii.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-bottom" || isExiting && exitingAnimation === "fade-out-from-bottom") && (0, $bAZii.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-right" || isExiting && exitingAnimation === "fade-in-from-right") && (0, $bAZii.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-right" || isExiting && exitingAnimation === "fade-out-from-right") && (0, $bAZii.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-top-constant" || isExiting && exitingAnimation === "fade-in-from-top-constant") && (0, $bAZii.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-top-constant" || isExiting && exitingAnimation === "fade-out-from-top-constant") && (0, $bAZii.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-left-constant" || isExiting && exitingAnimation === "fade-in-from-left-constant") && (0, $bAZii.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-left-constant" || isExiting && exitingAnimation === "fade-out-from-left-constant") && (0, $bAZii.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-bottom-constant" || isExiting && exitingAnimation === "fade-in-from-bottom-constant") && (0, $bAZii.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-bottom-constant" || isExiting && exitingAnimation === "fade-out-from-bottom-constant") && (0, $bAZii.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-right-constant" || isExiting && exitingAnimation === "fade-in-from-right-constant") && (0, $bAZii.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-right-constant" || isExiting && exitingAnimation === "fade-out-from-right-constant") && (0, $bAZii.default)([
                "_j7hq1pgp"
            ])
        ]) : "",
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $43b8d6a2e59b3708$export$2e2bcd8739ae039 = $43b8d6a2e59b3708$var$EnteringMotion;

});
parcelRegister("bAZii", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87129a3646e53da3$export$2e2bcd8739ae039; });
const $87129a3646e53da3$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $87129a3646e53da3$var$ATOMIC_GROUP_LENGTH = 5;
function $87129a3646e53da3$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $87129a3646e53da3$var$UNDERSCORE_UNICODE ? $87129a3646e53da3$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("6U1Ci", function(module, exports) {

$parcel$export(module.exports, "durations", function () { return $50693a1294ca35e7$export$38b928a7167ce124; });
$parcel$export(module.exports, "exitingDurations", function () { return $50693a1294ca35e7$export$30fa1a2e62ae150c; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $50693a1294ca35e7$export$368bacef0dacbe05 = 25;
var $50693a1294ca35e7$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $50693a1294ca35e7$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $50693a1294ca35e7$export$30fa1a2e62ae150c = {
    none: $50693a1294ca35e7$export$38b928a7167ce124.none,
    small: $50693a1294ca35e7$export$38b928a7167ce124.small * $50693a1294ca35e7$var$EXITING_MOTION_MULTIPLIER,
    medium: $50693a1294ca35e7$export$38b928a7167ce124.medium * $50693a1294ca35e7$var$EXITING_MOTION_MULTIPLIER,
    large: $50693a1294ca35e7$export$38b928a7167ce124.large * $50693a1294ca35e7$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("irr0b", function(module, exports) {

$parcel$export(module.exports, "useSetTimeout", function () { return $d6cfb1a347635687$export$4f34107a2b00f39c; });

var $iSvIT = parcelRequire("iSvIT");
var $d6cfb1a347635687$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $d6cfb1a347635687$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $iSvIT.useRef)([]);
    (0, $iSvIT.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $d6cfb1a347635687$var$getHookDeps(opts));
    return (0, $iSvIT.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $d6cfb1a347635687$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $iSvIT.useRef)([]);
    (0, $iSvIT.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $d6cfb1a347635687$var$getHookDeps(opts));
    return (0, $iSvIT.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("24ZLM", function(module, exports) {

$parcel$export(module.exports, "useStaggeredEntrance", function () { return $183bdea3f5b943ba$export$25c7213fc07ec080; });

var $6omqE = parcelRequire("6omqE");

var $iSvIT = parcelRequire("iSvIT");

var $4OZuI = parcelRequire("4OZuI");

var $dotOx = parcelRequire("dotOx");

var $2qAxF = parcelRequire("2qAxF");
var $183bdea3f5b943ba$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $iSvIT.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $4OZuI.default)
    };
});
var $183bdea3f5b943ba$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $2qAxF.useUniqueId)();
    var context = (0, $iSvIT.useContext)($183bdea3f5b943ba$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $183bdea3f5b943ba$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $iSvIT.useRef)([]);
    var indexes = [];
    var _useState = (0, $iSvIT.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, $6omqE.default)(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $dotOx.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($183bdea3f5b943ba$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $183bdea3f5b943ba$export$2e2bcd8739ae039 = $183bdea3f5b943ba$var$StaggeredEntrance;

});
parcelRegister("dotOx", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $9c04a4b23e949986$export$e5c5a5f917a5871c; });

var $iSvIT = parcelRequire("iSvIT");
var $9c04a4b23e949986$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $iSvIT.useEffect) : (0, $iSvIT.useLayoutEffect);

});

parcelRegister("2qAxF", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", function () { return $1c4a5af7c249a3b2$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $iSvIT = parcelRequire("iSvIT");
function $1c4a5af7c249a3b2$export$c485849f2e393253() {
    var identifier = (0, $iSvIT.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("lL4Ma", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd71b125bdc2cb99$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $fd71b125bdc2cb99$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("2uvCZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d06eac5e97d1452$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $cDjyV = parcelRequire("cDjyV");
function $1d06eac5e97d1452$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $iSvIT.useRef)(false);
    var onKeyDown = (0, $iSvIT.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $cDjyV.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $iSvIT.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $iSvIT.useEffect)(function() {
        return (0, $2e1kT.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
parcelRegister("cDjyV", function(module, exports) {

$parcel$export(module.exports, "KEY_UP", function () { return $93284d33e7d692bc$export$390330c10ff2b9a1; });
$parcel$export(module.exports, "KEY_DOWN", function () { return $93284d33e7d692bc$export$a80636c6f41931fe; });
$parcel$export(module.exports, "KEY_HOME", function () { return $93284d33e7d692bc$export$4af703091671bc; });
$parcel$export(module.exports, "KEY_END", function () { return $93284d33e7d692bc$export$e2bc30913faa5db7; });
$parcel$export(module.exports, "ESCAPE", function () { return $93284d33e7d692bc$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $93284d33e7d692bc$export$390330c10ff2b9a1 = "ArrowUp";
var $93284d33e7d692bc$export$a80636c6f41931fe = "ArrowDown";
var $93284d33e7d692bc$export$4af703091671bc = "Home";
var $93284d33e7d692bc$export$e2bc30913faa5db7 = "End";
var $93284d33e7d692bc$export$10f6869ed0a7d75b = "Tab";
var $93284d33e7d692bc$export$8152f929a25a0ff4 = "Enter";
var $93284d33e7d692bc$export$e51a3576c045c8d5 = "Space";
var $93284d33e7d692bc$export$2bb790b9008907b4 = "Escape";

});


parcelRegister("5dQuO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cd6e3473ed4cf2b$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
function $3cd6e3473ed4cf2b$export$2e2bcd8739ae039(value) {
    var ref = (0, $iSvIT.useRef)(value);
    (0, $iSvIT.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("jOB0X", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $e6cf6625d3cbb3c7$export$badac9ada3a0bdf9; });

var $iSvIT = parcelRequire("iSvIT");

var $5X460 = parcelRequire("5X460");

var $cGW7B = parcelRequire("cGW7B");

var $bqeX7 = parcelRequire("bqeX7");
var $e6cf6625d3cbb3c7$var$NOOP = function NOOP() {
    return void 0;
};
var $e6cf6625d3cbb3c7$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $e6cf6625d3cbb3c7$var$EMPTY_MODIFIERS = [];
function $e6cf6625d3cbb3c7$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom" : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "absolute" : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $e6cf6625d3cbb3c7$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $iSvIT.useContext((0, $5X460.ManagerReferenceNodeContext));
    var _React$useState = $iSvIT.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $iSvIT.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $iSvIT.useEffect(function() {
        (0, $cGW7B.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $iSvIT.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: "arrow",
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $bqeX7.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $iSvIT.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $e6cf6625d3cbb3c7$var$NOOP,
            update: update || $e6cf6625d3cbb3c7$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $cGW7B.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("5X460", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", function () { return $4555a3c53faf09aa$export$3dbd3405086fec7b; });
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", function () { return $4555a3c53faf09aa$export$cbabb21c2529b130; });
$parcel$export(module.exports, "Manager", function () { return $4555a3c53faf09aa$export$d0d38e7dec7a1a61; });

var $iSvIT = parcelRequire("iSvIT");
var $4555a3c53faf09aa$export$3dbd3405086fec7b = $iSvIT.createContext();
var $4555a3c53faf09aa$export$cbabb21c2529b130 = $iSvIT.createContext();
function $4555a3c53faf09aa$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $iSvIT.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $iSvIT.useRef(false);
    $iSvIT.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $iSvIT.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $iSvIT.createElement($4555a3c53faf09aa$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $iSvIT.createElement($4555a3c53faf09aa$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("cGW7B", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", function () { return $93d67e0a59d3d2f6$export$f52c55943429c8b6; });
$parcel$export(module.exports, "safeInvoke", function () { return $93d67e0a59d3d2f6$export$3dfa7c28635fe028; });
$parcel$export(module.exports, "setRef", function () { return $93d67e0a59d3d2f6$export$4bb192c7cacf928f; });
$parcel$export(module.exports, "fromEntries", function () { return $93d67e0a59d3d2f6$export$5150077fc2e7c662; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $93d67e0a59d3d2f6$export$700979bc83e7db82; });

var $iSvIT = parcelRequire("iSvIT");
var $93d67e0a59d3d2f6$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $93d67e0a59d3d2f6$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $93d67e0a59d3d2f6$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $93d67e0a59d3d2f6$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $93d67e0a59d3d2f6$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $93d67e0a59d3d2f6$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $iSvIT.useLayoutEffect : $iSvIT.useEffect;

});

parcelRegister("bqeX7", function(module, exports) {

$parcel$export(module.exports, "usePopper", function () { return $850db8a955db09bb$export$f4d5bf230a36dd6e; });

var $iSvIT = parcelRequire("iSvIT");

var $i5UxU = parcelRequire("i5UxU");

var $l4VaG = parcelRequire("l4VaG");

var $bfGvY = parcelRequire("bfGvY");

var $cGW7B = parcelRequire("cGW7B");
var $850db8a955db09bb$var$EMPTY_MODIFIERS = [];
var $850db8a955db09bb$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $iSvIT.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $850db8a955db09bb$var$EMPTY_MODIFIERS
    };
    var _React$useState = $iSvIT.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $iSvIT.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $i5UxU.flushSync(function() {
                    setState({
                        styles: (0, $cGW7B.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $cGW7B.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $iSvIT.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($bfGvY)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $iSvIT.useRef();
    (0, $cGW7B.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $cGW7B.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $l4VaG.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("l4VaG", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $f58651b769215666$export$8f7491d57c8f97a9; });

var $4sINm = parcelRequire("4sINm");

var $dFpwu = parcelRequire("dFpwu");

var $l8CtU = parcelRequire("l8CtU");

var $kxQmL = parcelRequire("kxQmL");

var $b3idU = parcelRequire("b3idU");

var $iD8Ez = parcelRequire("iD8Ez");

var $9SilT = parcelRequire("9SilT");

var $bvJu5 = parcelRequire("bvJu5");

var $j5iOn = parcelRequire("j5iOn");

var $i0SLD = parcelRequire("i0SLD");


var $f58651b769215666$export$d34966752335dd47 = [
    (0, $dFpwu.default),
    (0, $l8CtU.default),
    (0, $kxQmL.default),
    (0, $b3idU.default),
    (0, $iD8Ez.default),
    (0, $9SilT.default),
    (0, $bvJu5.default),
    (0, $j5iOn.default),
    (0, $i0SLD.default)
];
var $f58651b769215666$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $4sINm.popperGenerator)({
    defaultModifiers: $f58651b769215666$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("4sINm", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $33fc86535d22827c$export$ed5e13716264f202; });

var $4OMhL = parcelRequire("4OMhL");

var $1OPww = parcelRequire("1OPww");

var $7oPlk = parcelRequire("7oPlk");

var $2rxQ2 = parcelRequire("2rxQ2");

var $1qbIJ = parcelRequire("1qbIJ");

var $fkBpL = parcelRequire("fkBpL");

var $96ux6 = parcelRequire("96ux6");


var $b76zS = parcelRequire("b76zS");
var $33fc86535d22827c$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $33fc86535d22827c$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $33fc86535d22827c$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $33fc86535d22827c$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $33fc86535d22827c$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $b76zS.isElement)(reference) ? (0, $7oPlk.default)(reference) : reference.contextElement ? (0, $7oPlk.default)(reference.contextElement) : [],
                    popper: (0, $7oPlk.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $1qbIJ.default)((0, $96ux6.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$33fc86535d22827c$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $4OMhL.default)(reference, (0, $2rxQ2.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $1OPww.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $fkBpL.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$33fc86535d22827c$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $33fc86535d22827c$export$8f7491d57c8f97a9 = /*#__PURE__*/ $33fc86535d22827c$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("4OMhL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38214969e16d1042$export$2e2bcd8739ae039; });

var $1BrVI = parcelRequire("1BrVI");

var $bJGaP = parcelRequire("bJGaP");

var $6txiI = parcelRequire("6txiI");

var $b76zS = parcelRequire("b76zS");

var $1TePh = parcelRequire("1TePh");

var $4f5BV = parcelRequire("4f5BV");

var $bo2Ml = parcelRequire("bo2Ml");

var $8re5Y = parcelRequire("8re5Y");
function $38214969e16d1042$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $8re5Y.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $8re5Y.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $38214969e16d1042$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $b76zS.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $b76zS.isHTMLElement)(offsetParent) && $38214969e16d1042$var$isElementScaled(offsetParent);
    var documentElement = (0, $4f5BV.default)(offsetParent);
    var rect = (0, $1BrVI.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $6txiI.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $bo2Ml.default)(documentElement)) scroll = (0, $bJGaP.default)(offsetParent);
        if ((0, $b76zS.isHTMLElement)(offsetParent)) {
            offsets = (0, $1BrVI.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $1TePh.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("1BrVI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12aee97161d610a3$export$2e2bcd8739ae039; });

var $b76zS = parcelRequire("b76zS");

var $8re5Y = parcelRequire("8re5Y");

var $kzoZr = parcelRequire("kzoZr");

var $cLewc = parcelRequire("cLewc");
function $12aee97161d610a3$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $b76zS.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $8re5Y.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $8re5Y.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $b76zS.isElement)(element) ? (0, $kzoZr.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $cLewc.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("b76zS", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $817573558c4dfe7b$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $817573558c4dfe7b$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $817573558c4dfe7b$export$af51f0f06c0f328a; });

var $kzoZr = parcelRequire("kzoZr");
function $817573558c4dfe7b$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $kzoZr.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $817573558c4dfe7b$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $kzoZr.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $817573558c4dfe7b$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $kzoZr.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("kzoZr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef9a760b21913177$export$2e2bcd8739ae039; });
function $ef9a760b21913177$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("8re5Y", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $624bc769e7808e8a$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $624bc769e7808e8a$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $624bc769e7808e8a$export$2077e0241d6afd3c; });
var $624bc769e7808e8a$export$8960430cfd85939f = Math.max;
var $624bc769e7808e8a$export$96ec731ed4dcb222 = Math.min;
var $624bc769e7808e8a$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("cLewc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94a522dfa92ff29c$export$2e2bcd8739ae039; });

var $4Ldig = parcelRequire("4Ldig");
function $94a522dfa92ff29c$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $4Ldig.default)());
}

});
parcelRegister("4Ldig", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3775dd0b02ada958$export$2e2bcd8739ae039; });
function $3775dd0b02ada958$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});



parcelRegister("bJGaP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88b49c771227c1eb$export$2e2bcd8739ae039; });

var $aifkw = parcelRequire("aifkw");

var $kzoZr = parcelRequire("kzoZr");

var $b76zS = parcelRequire("b76zS");

var $5vRrm = parcelRequire("5vRrm");
function $88b49c771227c1eb$export$2e2bcd8739ae039(node) {
    if (node === (0, $kzoZr.default)(node) || !(0, $b76zS.isHTMLElement)(node)) return (0, $aifkw.default)(node);
    else return (0, $5vRrm.default)(node);
}

});
parcelRegister("aifkw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77e77a0d07b82928$export$2e2bcd8739ae039; });

var $kzoZr = parcelRequire("kzoZr");
function $77e77a0d07b82928$export$2e2bcd8739ae039(node) {
    var win = (0, $kzoZr.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("5vRrm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40394d1bd789c7bf$export$2e2bcd8739ae039; });
function $40394d1bd789c7bf$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("6txiI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b6f485f96ff651a$export$2e2bcd8739ae039; });
function $4b6f485f96ff651a$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("1TePh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16066da38606fbc0$export$2e2bcd8739ae039; });

var $1BrVI = parcelRequire("1BrVI");

var $4f5BV = parcelRequire("4f5BV");

var $aifkw = parcelRequire("aifkw");
function $16066da38606fbc0$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $1BrVI.default)((0, $4f5BV.default)(element)).left + (0, $aifkw.default)(element).scrollLeft;
}

});
parcelRegister("4f5BV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $316cea52ca85e0c3$export$2e2bcd8739ae039; });

var $b76zS = parcelRequire("b76zS");
function $316cea52ca85e0c3$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $b76zS.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("bo2Ml", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84a4176ab748bc86$export$2e2bcd8739ae039; });

var $7diql = parcelRequire("7diql");
function $84a4176ab748bc86$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $7diql.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("7diql", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $540809ec9278af95$export$2e2bcd8739ae039; });

var $kzoZr = parcelRequire("kzoZr");
function $540809ec9278af95$export$2e2bcd8739ae039(element) {
    return (0, $kzoZr.default)(element).getComputedStyle(element);
}

});



parcelRegister("1OPww", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15326d736c06a941$export$2e2bcd8739ae039; });

var $1BrVI = parcelRequire("1BrVI");
function $15326d736c06a941$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $1BrVI.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("7oPlk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $563299f8d4e2e7c0$export$2e2bcd8739ae039; });

var $kOIbx = parcelRequire("kOIbx");

var $km982 = parcelRequire("km982");

var $kzoZr = parcelRequire("kzoZr");

var $bo2Ml = parcelRequire("bo2Ml");
function $563299f8d4e2e7c0$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $kOIbx.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $kzoZr.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $bo2Ml.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($563299f8d4e2e7c0$export$2e2bcd8739ae039((0, $km982.default)(target)));
}

});
parcelRegister("kOIbx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f27ac0690733aaaa$export$2e2bcd8739ae039; });

var $km982 = parcelRequire("km982");

var $bo2Ml = parcelRequire("bo2Ml");

var $6txiI = parcelRequire("6txiI");

var $b76zS = parcelRequire("b76zS");
function $f27ac0690733aaaa$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $6txiI.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $b76zS.isHTMLElement)(node) && (0, $bo2Ml.default)(node)) return node;
    return $f27ac0690733aaaa$export$2e2bcd8739ae039((0, $km982.default)(node));
}

});
parcelRegister("km982", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed1cf17e29ee2325$export$2e2bcd8739ae039; });

var $6txiI = parcelRequire("6txiI");

var $4f5BV = parcelRequire("4f5BV");

var $b76zS = parcelRequire("b76zS");
function $ed1cf17e29ee2325$export$2e2bcd8739ae039(element) {
    if ((0, $6txiI.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $b76zS.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $4f5BV.default)(element) // fallback
    );
}

});



parcelRegister("2rxQ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c7859fb1539b0ed$export$2e2bcd8739ae039; });

var $kzoZr = parcelRequire("kzoZr");

var $6txiI = parcelRequire("6txiI");

var $7diql = parcelRequire("7diql");

var $b76zS = parcelRequire("b76zS");

var $lVjEu = parcelRequire("lVjEu");

var $km982 = parcelRequire("km982");

var $4Ldig = parcelRequire("4Ldig");
function $1c7859fb1539b0ed$var$getTrueOffsetParent(element) {
    if (!(0, $b76zS.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $7diql.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $1c7859fb1539b0ed$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $4Ldig.default)());
    var isIE = /Trident/i.test((0, $4Ldig.default)());
    if (isIE && (0, $b76zS.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $7diql.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $km982.default)(element);
    if ((0, $b76zS.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $b76zS.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $6txiI.default)(currentNode)) < 0){
        var css = (0, $7diql.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $1c7859fb1539b0ed$export$2e2bcd8739ae039(element) {
    var window = (0, $kzoZr.default)(element);
    var offsetParent = $1c7859fb1539b0ed$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $lVjEu.default)(offsetParent) && (0, $7diql.default)(offsetParent).position === "static")offsetParent = $1c7859fb1539b0ed$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $6txiI.default)(offsetParent) === "html" || (0, $6txiI.default)(offsetParent) === "body" && (0, $7diql.default)(offsetParent).position === "static")) return window;
    return offsetParent || $1c7859fb1539b0ed$var$getContainingBlock(element) || window;
}

});
parcelRegister("lVjEu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff5e2a51996a360b$export$2e2bcd8739ae039; });

var $6txiI = parcelRequire("6txiI");
function $ff5e2a51996a360b$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $6txiI.default)(element)) >= 0;
}

});


parcelRegister("1qbIJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10914f9a92c26362$export$2e2bcd8739ae039; });

var $cd2Tj = parcelRequire("cd2Tj");
function $10914f9a92c26362$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $10914f9a92c26362$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $10914f9a92c26362$var$order(modifiers); // order based on phase
    return (0, $cd2Tj.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("cd2Tj", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $8e38f107ea36317b$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $8e38f107ea36317b$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $8e38f107ea36317b$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $8e38f107ea36317b$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $8e38f107ea36317b$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $8e38f107ea36317b$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $8e38f107ea36317b$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $8e38f107ea36317b$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $8e38f107ea36317b$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $8e38f107ea36317b$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $8e38f107ea36317b$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $8e38f107ea36317b$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $8e38f107ea36317b$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $8e38f107ea36317b$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $8e38f107ea36317b$export$d087d3878fdf71d5; });
var $8e38f107ea36317b$export$1e95b668f3b82d = "top";
var $8e38f107ea36317b$export$40e543e69a8b3fbb = "bottom";
var $8e38f107ea36317b$export$79ffe56a765070d2 = "right";
var $8e38f107ea36317b$export$eabcd2c8791e7bf4 = "left";
var $8e38f107ea36317b$export$dfb5619354ba860 = "auto";
var $8e38f107ea36317b$export$aec2ce47c367b8c3 = [
    $8e38f107ea36317b$export$1e95b668f3b82d,
    $8e38f107ea36317b$export$40e543e69a8b3fbb,
    $8e38f107ea36317b$export$79ffe56a765070d2,
    $8e38f107ea36317b$export$eabcd2c8791e7bf4
];
var $8e38f107ea36317b$export$b3571188c770cc5a = "start";
var $8e38f107ea36317b$export$bd5df0f255a350f8 = "end";
var $8e38f107ea36317b$export$390fd549c5303b4d = "clippingParents";
var $8e38f107ea36317b$export$d7b7311ec04a3e8f = "viewport";
var $8e38f107ea36317b$export$ae5ab1c730825774 = "popper";
var $8e38f107ea36317b$export$ca50aac9f3ba507f = "reference";
var $8e38f107ea36317b$export$368f9a87e87fa4e1 = /*#__PURE__*/ $8e38f107ea36317b$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $8e38f107ea36317b$export$b3571188c770cc5a,
        placement + "-" + $8e38f107ea36317b$export$bd5df0f255a350f8
    ]);
}, []);
var $8e38f107ea36317b$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($8e38f107ea36317b$export$aec2ce47c367b8c3, [
    $8e38f107ea36317b$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $8e38f107ea36317b$export$b3571188c770cc5a,
        placement + "-" + $8e38f107ea36317b$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $8e38f107ea36317b$export$421679a7c3d56e = "beforeRead";
var $8e38f107ea36317b$export$aafa59e2e03f2942 = "read";
var $8e38f107ea36317b$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $8e38f107ea36317b$export$c65e99957a05207c = "beforeMain";
var $8e38f107ea36317b$export$f22da7240b7add18 = "main";
var $8e38f107ea36317b$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $8e38f107ea36317b$export$8d4d2d70e7d46032 = "beforeWrite";
var $8e38f107ea36317b$export$68d8715fc104d294 = "write";
var $8e38f107ea36317b$export$70a6e5159acce2e6 = "afterWrite";
var $8e38f107ea36317b$export$d087d3878fdf71d5 = [
    $8e38f107ea36317b$export$421679a7c3d56e,
    $8e38f107ea36317b$export$aafa59e2e03f2942,
    $8e38f107ea36317b$export$6964f6c886723980,
    $8e38f107ea36317b$export$c65e99957a05207c,
    $8e38f107ea36317b$export$f22da7240b7add18,
    $8e38f107ea36317b$export$bab79516f2d662fe,
    $8e38f107ea36317b$export$8d4d2d70e7d46032,
    $8e38f107ea36317b$export$68d8715fc104d294,
    $8e38f107ea36317b$export$70a6e5159acce2e6
];

});


parcelRegister("fkBpL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b295bf0b659a7351$export$2e2bcd8739ae039; });
function $b295bf0b659a7351$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("96ux6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a0c5bc851e69d4b$export$2e2bcd8739ae039; });
function $6a0c5bc851e69d4b$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("dFpwu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f32e70399de3db6$export$2e2bcd8739ae039; });

var $kzoZr = parcelRequire("kzoZr");
var $9f32e70399de3db6$var$passive = {
    passive: true
};
function $9f32e70399de3db6$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $kzoZr.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $9f32e70399de3db6$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $9f32e70399de3db6$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $9f32e70399de3db6$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $9f32e70399de3db6$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $9f32e70399de3db6$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $9f32e70399de3db6$var$effect,
    data: {}
};

});

parcelRegister("l8CtU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f63831f574792f31$export$2e2bcd8739ae039; });

var $1m5sm = parcelRequire("1m5sm");
function $f63831f574792f31$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $1m5sm.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $f63831f574792f31$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $f63831f574792f31$var$popperOffsets,
    data: {}
};

});
parcelRegister("1m5sm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fcc140c906c9127$export$2e2bcd8739ae039; });

var $39n0N = parcelRequire("39n0N");

var $4aO8K = parcelRequire("4aO8K");

var $6Wqdd = parcelRequire("6Wqdd");

var $cd2Tj = parcelRequire("cd2Tj");
function $0fcc140c906c9127$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $39n0N.default)(placement) : null;
    var variation = placement ? (0, $4aO8K.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $cd2Tj.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $cd2Tj.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $cd2Tj.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $cd2Tj.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $6Wqdd.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $cd2Tj.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $cd2Tj.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("39n0N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24b4100cfd6f211c$export$2e2bcd8739ae039; });

function $24b4100cfd6f211c$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("4aO8K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $309efd5f5b4f84c2$export$2e2bcd8739ae039; });
function $309efd5f5b4f84c2$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});

parcelRegister("6Wqdd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50dc7e05fd6c3049$export$2e2bcd8739ae039; });
function $50dc7e05fd6c3049$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});



parcelRegister("kxQmL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef4f828c341fc02a$export$2e2bcd8739ae039; });

var $cd2Tj = parcelRequire("cd2Tj");

var $2rxQ2 = parcelRequire("2rxQ2");

var $kzoZr = parcelRequire("kzoZr");

var $4f5BV = parcelRequire("4f5BV");

var $7diql = parcelRequire("7diql");

var $39n0N = parcelRequire("39n0N");

var $4aO8K = parcelRequire("4aO8K");

var $8re5Y = parcelRequire("8re5Y");
var $ef4f828c341fc02a$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $ef4f828c341fc02a$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $8re5Y.round)(x * dpr) / dpr || 0,
        y: (0, $8re5Y.round)(y * dpr) / dpr || 0
    };
}
function $ef4f828c341fc02a$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $cd2Tj.left);
    var sideY = (0, $cd2Tj.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $2rxQ2.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $kzoZr.default)(popper)) {
            offsetParent = (0, $4f5BV.default)(popper);
            if ((0, $7diql.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $cd2Tj.top) || (placement === (0, $cd2Tj.left) || placement === (0, $cd2Tj.right)) && variation === (0, $cd2Tj.end)) {
            sideY = (0, $cd2Tj.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $cd2Tj.left) || (placement === (0, $cd2Tj.top) || placement === (0, $cd2Tj.bottom)) && variation === (0, $cd2Tj.end)) {
            sideX = (0, $cd2Tj.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $ef4f828c341fc02a$var$unsetSides);
    var _ref4 = roundOffsets === true ? $ef4f828c341fc02a$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $kzoZr.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $ef4f828c341fc02a$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $39n0N.default)(state.placement),
        variation: (0, $4aO8K.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $ef4f828c341fc02a$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $ef4f828c341fc02a$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ef4f828c341fc02a$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $ef4f828c341fc02a$var$computeStyles,
    data: {}
};

});

parcelRegister("b3idU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80be1c4f59a1c607$export$2e2bcd8739ae039; });

var $6txiI = parcelRequire("6txiI");

var $b76zS = parcelRequire("b76zS");
// and applies them to the HTMLElements such as popper and arrow
function $80be1c4f59a1c607$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $b76zS.isHTMLElement)(element) || !(0, $6txiI.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $80be1c4f59a1c607$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $b76zS.isHTMLElement)(element) || !(0, $6txiI.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $80be1c4f59a1c607$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $80be1c4f59a1c607$var$applyStyles,
    effect: $80be1c4f59a1c607$var$effect,
    requires: [
        "computeStyles"
    ]
};

});

parcelRegister("iD8Ez", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d90294dedd7a53d1$export$2e2bcd8739ae039; });

var $39n0N = parcelRequire("39n0N");

var $cd2Tj = parcelRequire("cd2Tj");
function $d90294dedd7a53d1$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $39n0N.default)(placement);
    var invertDistance = [
        (0, $cd2Tj.left),
        (0, $cd2Tj.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $cd2Tj.left),
        (0, $cd2Tj.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $d90294dedd7a53d1$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $cd2Tj.placements).reduce(function(acc, placement) {
        acc[placement] = $d90294dedd7a53d1$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $d90294dedd7a53d1$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $d90294dedd7a53d1$var$offset
};

});

parcelRegister("9SilT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7307648f07b58bcc$export$2e2bcd8739ae039; });

var $jkESv = parcelRequire("jkESv");

var $39n0N = parcelRequire("39n0N");

var $1MPHY = parcelRequire("1MPHY");

var $BhOR7 = parcelRequire("BhOR7");

var $6QsDP = parcelRequire("6QsDP");

var $cd2Tj = parcelRequire("cd2Tj");

var $4aO8K = parcelRequire("4aO8K");
function $7307648f07b58bcc$var$getExpandedFallbackPlacements(placement) {
    if ((0, $39n0N.default)(placement) === (0, $cd2Tj.auto)) return [];
    var oppositePlacement = (0, $jkESv.default)(placement);
    return [
        (0, $1MPHY.default)(placement),
        oppositePlacement,
        (0, $1MPHY.default)(oppositePlacement)
    ];
}
function $7307648f07b58bcc$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $39n0N.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $jkESv.default)(preferredPlacement)
    ] : $7307648f07b58bcc$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $39n0N.default)(placement) === (0, $cd2Tj.auto) ? (0, $6QsDP.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $39n0N.default)(placement);
        var isStartVariation = (0, $4aO8K.default)(placement) === (0, $cd2Tj.start);
        var isVertical = [
            (0, $cd2Tj.top),
            (0, $cd2Tj.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $BhOR7.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $cd2Tj.right) : (0, $cd2Tj.left) : isStartVariation ? (0, $cd2Tj.bottom) : (0, $cd2Tj.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $jkESv.default)(mainVariationSide);
        var altVariationSide = (0, $jkESv.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $7307648f07b58bcc$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $7307648f07b58bcc$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("jkESv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e12f9823f63ea6f5$export$2e2bcd8739ae039; });
var $e12f9823f63ea6f5$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $e12f9823f63ea6f5$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $e12f9823f63ea6f5$var$hash[matched];
    });
}

});

parcelRegister("1MPHY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14d2624dcb1217f9$export$2e2bcd8739ae039; });
var $14d2624dcb1217f9$var$hash = {
    start: "end",
    end: "start"
};
function $14d2624dcb1217f9$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $14d2624dcb1217f9$var$hash[matched];
    });
}

});

parcelRegister("BhOR7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $070147594ed15d0b$export$2e2bcd8739ae039; });

var $3D5BW = parcelRequire("3D5BW");

var $4f5BV = parcelRequire("4f5BV");

var $1BrVI = parcelRequire("1BrVI");

var $1m5sm = parcelRequire("1m5sm");

var $9eWQD = parcelRequire("9eWQD");

var $cd2Tj = parcelRequire("cd2Tj");

var $b76zS = parcelRequire("b76zS");

var $2bSmT = parcelRequire("2bSmT");

var $F6b89 = parcelRequire("F6b89");
function $070147594ed15d0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $cd2Tj.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $cd2Tj.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $cd2Tj.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2bSmT.default)(typeof padding !== "number" ? padding : (0, $F6b89.default)(padding, (0, $cd2Tj.basePlacements)));
    var altContext = elementContext === (0, $cd2Tj.popper) ? (0, $cd2Tj.reference) : (0, $cd2Tj.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $3D5BW.default)((0, $b76zS.isElement)(element) ? element : element.contextElement || (0, $4f5BV.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $1BrVI.default)(state.elements.reference);
    var popperOffsets = (0, $1m5sm.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $9eWQD.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $cd2Tj.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $cd2Tj.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $cd2Tj.right),
                (0, $cd2Tj.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $cd2Tj.top),
                (0, $cd2Tj.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("3D5BW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a495dd4e79e357f$export$2e2bcd8739ae039; });

var $cd2Tj = parcelRequire("cd2Tj");

var $1MHXE = parcelRequire("1MHXE");

var $2jNOi = parcelRequire("2jNOi");

var $7oPlk = parcelRequire("7oPlk");

var $2rxQ2 = parcelRequire("2rxQ2");

var $4f5BV = parcelRequire("4f5BV");

var $7diql = parcelRequire("7diql");

var $b76zS = parcelRequire("b76zS");

var $1BrVI = parcelRequire("1BrVI");

var $km982 = parcelRequire("km982");

var $9ELqb = parcelRequire("9ELqb");

var $6txiI = parcelRequire("6txiI");

var $9eWQD = parcelRequire("9eWQD");

var $8re5Y = parcelRequire("8re5Y");
function $2a495dd4e79e357f$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $1BrVI.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $2a495dd4e79e357f$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $cd2Tj.viewport) ? (0, $9eWQD.default)((0, $1MHXE.default)(element, strategy)) : (0, $b76zS.isElement)(clippingParent) ? $2a495dd4e79e357f$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $9eWQD.default)((0, $2jNOi.default)((0, $4f5BV.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $2a495dd4e79e357f$var$getClippingParents(element) {
    var clippingParents = (0, $7oPlk.default)((0, $km982.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $7diql.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $b76zS.isHTMLElement)(element) ? (0, $2rxQ2.default)(element) : element;
    if (!(0, $b76zS.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $b76zS.isElement)(clippingParent) && (0, $9ELqb.default)(clippingParent, clipperElement) && (0, $6txiI.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $2a495dd4e79e357f$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $2a495dd4e79e357f$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $2a495dd4e79e357f$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $8re5Y.max)(rect.top, accRect.top);
        accRect.right = (0, $8re5Y.min)(rect.right, accRect.right);
        accRect.bottom = (0, $8re5Y.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $8re5Y.max)(rect.left, accRect.left);
        return accRect;
    }, $2a495dd4e79e357f$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("1MHXE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14cc5feb0267fcde$export$2e2bcd8739ae039; });

var $kzoZr = parcelRequire("kzoZr");

var $4f5BV = parcelRequire("4f5BV");

var $1TePh = parcelRequire("1TePh");

var $cLewc = parcelRequire("cLewc");
function $14cc5feb0267fcde$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $kzoZr.default)(element);
    var html = (0, $4f5BV.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $cLewc.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $1TePh.default)(element),
        y: y
    };
}

});

parcelRegister("2jNOi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b03fe692533a584$export$2e2bcd8739ae039; });

var $4f5BV = parcelRequire("4f5BV");

var $7diql = parcelRequire("7diql");

var $1TePh = parcelRequire("1TePh");

var $aifkw = parcelRequire("aifkw");

var $8re5Y = parcelRequire("8re5Y");
function $1b03fe692533a584$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $4f5BV.default)(element);
    var winScroll = (0, $aifkw.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $8re5Y.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $8re5Y.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $1TePh.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $7diql.default)(body || html).direction === "rtl") x += (0, $8re5Y.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("9ELqb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $707ca25dbce60242$export$2e2bcd8739ae039; });

var $b76zS = parcelRequire("b76zS");
function $707ca25dbce60242$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $b76zS.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("9eWQD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ba311d812de0117$export$2e2bcd8739ae039; });
function $6ba311d812de0117$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("2bSmT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1986c843b9323aec$export$2e2bcd8739ae039; });

var $8ryuN = parcelRequire("8ryuN");
function $1986c843b9323aec$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $8ryuN.default)(), paddingObject);
}

});
parcelRegister("8ryuN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $625b9a7fc7db1373$export$2e2bcd8739ae039; });
function $625b9a7fc7db1373$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("F6b89", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07b89f60442128ff$export$2e2bcd8739ae039; });
function $07b89f60442128ff$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("6QsDP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fbdd0fcb229a8df$export$2e2bcd8739ae039; });

var $4aO8K = parcelRequire("4aO8K");

var $cd2Tj = parcelRequire("cd2Tj");

var $BhOR7 = parcelRequire("BhOR7");

var $39n0N = parcelRequire("39n0N");
function $4fbdd0fcb229a8df$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $cd2Tj.placements) : _options$allowedAutoP;
    var variation = (0, $4aO8K.default)(placement);
    var placements = variation ? flipVariations ? (0, $cd2Tj.variationPlacements) : (0, $cd2Tj.variationPlacements).filter(function(placement) {
        return (0, $4aO8K.default)(placement) === variation;
    }) : (0, $cd2Tj.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $BhOR7.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $39n0N.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("bvJu5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8615df344805cdb3$export$2e2bcd8739ae039; });

var $cd2Tj = parcelRequire("cd2Tj");

var $39n0N = parcelRequire("39n0N");

var $6Wqdd = parcelRequire("6Wqdd");

var $hBuxQ = parcelRequire("hBuxQ");

var $8Ytr2 = parcelRequire("8Ytr2");

var $1OPww = parcelRequire("1OPww");

var $2rxQ2 = parcelRequire("2rxQ2");

var $BhOR7 = parcelRequire("BhOR7");

var $4aO8K = parcelRequire("4aO8K");

var $8ryuN = parcelRequire("8ryuN");

var $8re5Y = parcelRequire("8re5Y");
function $8615df344805cdb3$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $BhOR7.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $39n0N.default)(state.placement);
    var variation = (0, $4aO8K.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $6Wqdd.default)(basePlacement);
    var altAxis = (0, $hBuxQ.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $cd2Tj.top) : (0, $cd2Tj.left);
        var altSide = mainAxis === "y" ? (0, $cd2Tj.bottom) : (0, $cd2Tj.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $cd2Tj.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $cd2Tj.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $1OPww.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $8ryuN.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $8Ytr2.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $2rxQ2.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $8Ytr2.within)(tether ? (0, $8re5Y.min)(min, tetherMin) : min, offset, tether ? (0, $8re5Y.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $cd2Tj.top) : (0, $cd2Tj.left);
        var _altSide = mainAxis === "x" ? (0, $cd2Tj.bottom) : (0, $cd2Tj.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $cd2Tj.top),
            (0, $cd2Tj.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $8Ytr2.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $8Ytr2.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8615df344805cdb3$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $8615df344805cdb3$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("hBuxQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd0d95efa3e63271$export$2e2bcd8739ae039; });
function $cd0d95efa3e63271$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});

parcelRegister("8Ytr2", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $688ac285964ba20e$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $688ac285964ba20e$export$86c8af6d3ef0b4a; });

var $8re5Y = parcelRequire("8re5Y");
function $688ac285964ba20e$export$f28d906d67a997f3(min, value, max) {
    return (0, $8re5Y.max)(min, (0, $8re5Y.min)(value, max));
}
function $688ac285964ba20e$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $688ac285964ba20e$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("j5iOn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de4d13856fde189f$export$2e2bcd8739ae039; });

var $39n0N = parcelRequire("39n0N");

var $1OPww = parcelRequire("1OPww");

var $9ELqb = parcelRequire("9ELqb");

var $2rxQ2 = parcelRequire("2rxQ2");

var $6Wqdd = parcelRequire("6Wqdd");

var $8Ytr2 = parcelRequire("8Ytr2");

var $2bSmT = parcelRequire("2bSmT");

var $F6b89 = parcelRequire("F6b89");

var $cd2Tj = parcelRequire("cd2Tj");
var $de4d13856fde189f$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2bSmT.default)(typeof padding !== "number" ? padding : (0, $F6b89.default)(padding, (0, $cd2Tj.basePlacements)));
};
function $de4d13856fde189f$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $39n0N.default)(state.placement);
    var axis = (0, $6Wqdd.default)(basePlacement);
    var isVertical = [
        (0, $cd2Tj.left),
        (0, $cd2Tj.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $de4d13856fde189f$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $1OPww.default)(arrowElement);
    var minProp = axis === "y" ? (0, $cd2Tj.top) : (0, $cd2Tj.left);
    var maxProp = axis === "y" ? (0, $cd2Tj.bottom) : (0, $cd2Tj.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $2rxQ2.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $8Ytr2.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $de4d13856fde189f$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $9ELqb.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $de4d13856fde189f$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $de4d13856fde189f$var$arrow,
    effect: $de4d13856fde189f$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});

parcelRegister("i0SLD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1d2b5bdda3eeb74$export$2e2bcd8739ae039; });

var $cd2Tj = parcelRequire("cd2Tj");

var $BhOR7 = parcelRequire("BhOR7");
function $d1d2b5bdda3eeb74$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $d1d2b5bdda3eeb74$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $cd2Tj.top),
        (0, $cd2Tj.right),
        (0, $cd2Tj.bottom),
        (0, $cd2Tj.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $d1d2b5bdda3eeb74$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $BhOR7.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $BhOR7.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $d1d2b5bdda3eeb74$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $d1d2b5bdda3eeb74$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $d1d2b5bdda3eeb74$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $d1d2b5bdda3eeb74$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $d1d2b5bdda3eeb74$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $d1d2b5bdda3eeb74$var$hide
};

});




parcelRegister("KsdEf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08ba2fb95c504822$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "propDeprecationWarning", function () { return $08ba2fb95c504822$export$eb1decd851a5ae56; });

var $flYVx = parcelRequire("flYVx");

var $XAEGR = parcelRequire("XAEGR");
function $08ba2fb95c504822$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $flYVx.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $08ba2fb95c504822$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $XAEGR;
}

});
parcelRegister("flYVx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2d81406e4ef087e$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $b2d81406e4ef087e$var$printed = {};
function $b2d81406e4ef087e$export$2e2bcd8739ae039(message) {
    if ($b2d81406e4ef087e$var$printed[message]) return;
    $b2d81406e4ef087e$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}

});


parcelRegister("dWwnB", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $a269cf1455071b81$export$f680877a34711e37; });
$parcel$export(module.exports, "useIdSeed", function () { return $a269cf1455071b81$export$6ee17796e3d70de2; });

var $h1Lx1 = parcelRequire("h1Lx1");

var $iSvIT = parcelRequire("iSvIT");

var $lzzak = parcelRequire("lzzak");

var $jxLBU = parcelRequire("jxLBU");
var $a269cf1455071b81$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $a269cf1455071b81$var$react18UseId = ($a269cf1455071b81$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useId) !== null && $a269cf1455071b81$var$_React$useId !== void 0 ? $a269cf1455071b81$var$_React$useId : undefined;
function $a269cf1455071b81$export$f680877a34711e37() {
    if ($a269cf1455071b81$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $a269cf1455071b81$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $lzzak.useUID)());
}
var $a269cf1455071b81$export$6be90bcb437e928f = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($a269cf1455071b81$export$f680877a34711e37()).concat(postfix);
    (0, $iSvIT.useEffect)(function() {
        if (!ref) return;
        switch((0, $h1Lx1.default)(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, $h1Lx1.default)(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $a269cf1455071b81$export$6ee17796e3d70de2() {
    if ($a269cf1455071b81$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $a269cf1455071b81$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $lzzak.useUIDSeed)();
}

});
parcelRegister("h1Lx1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c657667475c58bdf$export$2e2bcd8739ae039; });
function $c657667475c58bdf$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $c657667475c58bdf$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c657667475c58bdf$export$2e2bcd8739ae039(o);
}

});


parcelRegister("gmylQ", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $be9958e582b7db3d$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("iSvIT");


var $2TR4y = parcelRequire("2TR4y");
var $be9958e582b7db3d$var$_createStrictAPI = (0, $2TR4y.createStrictAPI)(), $be9958e582b7db3d$var$XCSSProp = $be9958e582b7db3d$var$_createStrictAPI.XCSSProp, $be9958e582b7db3d$export$dbf350e5966cf602 = $be9958e582b7db3d$var$_createStrictAPI.css, $be9958e582b7db3d$export$eb1ecd84a24ee424 = $be9958e582b7db3d$var$_createStrictAPI.cssMap, $be9958e582b7db3d$export$a274e22fb40f762e = $be9958e582b7db3d$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means products only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});
parcelRegister("2TR4y", function(module, exports) {

$parcel$export(module.exports, "createStrictAPI", function () { return $21c9e2e7e85c9860$export$39716b4af53f4ad; });

var $aLIQn = parcelRequire("aLIQn");

var $bkAJD = parcelRequire("bkAJD");
function $21c9e2e7e85c9860$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $aLIQn.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $aLIQn.createStrictSetupError)();
        },
        cx: $bkAJD.cx,
        XCSSProp () {
            throw (0, $aLIQn.createStrictSetupError)();
        }
    };
}

});
parcelRegister("aLIQn", function(module, exports) {

$parcel$export(module.exports, "createStrictSetupError", function () { return $7d711432f6afc08d$export$c4df1cb0c2b4d77c; });
const $7d711432f6afc08d$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $7d711432f6afc08d$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("bkAJD", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $83fe0ec32f018b61$export$a274e22fb40f762e; });

var $grtJj = parcelRequire("grtJj");
const $83fe0ec32f018b61$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $grtJj.default)(actualStyles);
};

});
parcelRegister("grtJj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf863aaaa9a978ea$export$2e2bcd8739ae039; });
const $bf863aaaa9a978ea$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $bf863aaaa9a978ea$var$ATOMIC_GROUP_LENGTH = 5;
function $bf863aaaa9a978ea$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $bf863aaaa9a978ea$var$UNDERSCORE_UNICODE ? $bf863aaaa9a978ea$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});




parcelRegister("dyf9a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9dda332b821cec7d$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
function $9dda332b821cec7d$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $iSvIT.useRef)(true);
    (0, $iSvIT.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("aTopn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ee1f96a150e308d$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $5OtVG = parcelRequire("5OtVG");
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */ var $7ee1f96a150e308d$var$SlideIn = function SlideIn(_ref) {
    var children = _ref.children, enterFrom = _ref.enterFrom, exitTo = _ref.exitTo, _ref$fade = _ref.fade, fade = _ref$fade === void 0 ? "none" : _ref$fade, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "medium" : _ref$duration, isPaused = _ref.isPaused, onFinish = _ref.onFinish, _ref$animationTimingF = _ref.animationTimingFunction, animationTimingFunction = _ref$animationTimingF === void 0 ? "ease-out" : _ref$animationTimingF, _ref$animationTimingF2 = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF2 === void 0 ? "ease-in" : _ref$animationTimingF2;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5OtVG.default), {
        duration: duration,
        enteringAnimation: "slide-in-from-".concat(enterFrom),
        exitingAnimation: "slide-out-from-".concat(exitTo || enterFrom),
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish
    }, children);
};
var $7ee1f96a150e308d$export$2e2bcd8739ae039 = $7ee1f96a150e308d$var$SlideIn;

});

parcelRegister("fhngd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1fa7c996ccbe594$export$2e2bcd8739ae039; });
function $b1fa7c996ccbe594$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $b1fa7c996ccbe594$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $b1fa7c996ccbe594$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $b1fa7c996ccbe594$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("01Hnw", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $0051be2c8f71945a$var$runtime = (parcelRequire("5iXIe"))();
module.exports = $0051be2c8f71945a$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $0051be2c8f71945a$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $0051be2c8f71945a$var$runtime;
    else Function("r", "regeneratorRuntime = r")($0051be2c8f71945a$var$runtime);
}

});
parcelRegister("5iXIe", function(module, exports) {

var $2rT5j = parcelRequire("2rT5j");

var $3TQwb = parcelRequire("3TQwb");

var $aCbjv = parcelRequire("aCbjv");

var $6EgPV = parcelRequire("6EgPV");

var $lLDj3 = parcelRequire("lLDj3");

var $fwxM7 = parcelRequire("fwxM7");

var $foo2K = parcelRequire("foo2K");
function $3dccf3d14db89a75$var$_regeneratorRuntime() {
    "use strict";
    var r = $3TQwb(), e = r.m($3dccf3d14db89a75$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $foo2K(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $3dccf3d14db89a75$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $2rT5j(r, e);
            },
            AsyncIterator: $lLDj3,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $6EgPV : $aCbjv)(a(r), e, t, o, u);
            },
            keys: $fwxM7,
            values: $foo2K
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $3dccf3d14db89a75$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2rT5j", function(module, exports) {
function $1c88d50f2bfc6bb6$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $1c88d50f2bfc6bb6$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3TQwb", function(module, exports) {

var $15Jmd = parcelRequire("15Jmd");
function $2d6f3f26d874d413$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $15Jmd(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($15Jmd(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $15Jmd(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $15Jmd(u, "constructor", GeneratorFunctionPrototype), $15Jmd(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $15Jmd(GeneratorFunctionPrototype, o, "GeneratorFunction"), $15Jmd(u), $15Jmd(u, o, "Generator"), $15Jmd(u, n, function() {
        return this;
    }), $15Jmd(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $2d6f3f26d874d413$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $2d6f3f26d874d413$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("15Jmd", function(module, exports) {
function $0cb9711b7ec24a3a$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $0cb9711b7ec24a3a$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $0cb9711b7ec24a3a$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $0cb9711b7ec24a3a$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $0cb9711b7ec24a3a$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("aCbjv", function(module, exports) {

var $6EgPV = parcelRequire("6EgPV");
function $7ba63aa1982790f8$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $6EgPV(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $7ba63aa1982790f8$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6EgPV", function(module, exports) {

var $3TQwb = parcelRequire("3TQwb");

var $lLDj3 = parcelRequire("lLDj3");
function $4d7389dc2b8a66b4$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $lLDj3($3TQwb().w(r, e, t, o), n || Promise);
}
module.exports = $4d7389dc2b8a66b4$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lLDj3", function(module, exports) {

var $2rT5j = parcelRequire("2rT5j");

var $15Jmd = parcelRequire("15Jmd");
function $fd8c7a2cc9d49295$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $2rT5j ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($15Jmd($fd8c7a2cc9d49295$var$AsyncIterator.prototype), $15Jmd($fd8c7a2cc9d49295$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $15Jmd(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $fd8c7a2cc9d49295$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("fwxM7", function(module, exports) {
function $b4d40b31280de9da$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $b4d40b31280de9da$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("foo2K", function(module, exports) {

var $3BDLw = parcelRequire("3BDLw");
var $b34bbf68a8abeba1$var$_typeof = $3BDLw.default;
function $b34bbf68a8abeba1$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($b34bbf68a8abeba1$var$_typeof(e) + " is not iterable");
}
module.exports = $b34bbf68a8abeba1$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3BDLw", function(module, exports) {
function $2a03ac6954d9ca1d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2a03ac6954d9ca1d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2a03ac6954d9ca1d$var$_typeof(o);
}
module.exports = $2a03ac6954d9ca1d$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("kZv7b", function(module, exports) {
"use strict";
var $f481a3e403bb1ed3$var$has = Object.prototype.hasOwnProperty, $f481a3e403bb1ed3$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $f481a3e403bb1ed3$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $f481a3e403bb1ed3$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $f481a3e403bb1ed3$var$Events().__proto__) $f481a3e403bb1ed3$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $f481a3e403bb1ed3$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $f481a3e403bb1ed3$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $f481a3e403bb1ed3$var$EE(fn, context || emitter, once), evt = $f481a3e403bb1ed3$var$prefix ? $f481a3e403bb1ed3$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $f481a3e403bb1ed3$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $f481a3e403bb1ed3$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $f481a3e403bb1ed3$var$EventEmitter() {
    this._events = new $f481a3e403bb1ed3$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $f481a3e403bb1ed3$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($f481a3e403bb1ed3$var$has.call(events, name)) names.push($f481a3e403bb1ed3$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $f481a3e403bb1ed3$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $f481a3e403bb1ed3$var$prefix ? $f481a3e403bb1ed3$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $f481a3e403bb1ed3$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $f481a3e403bb1ed3$var$prefix ? $f481a3e403bb1ed3$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $f481a3e403bb1ed3$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $f481a3e403bb1ed3$var$prefix ? $f481a3e403bb1ed3$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f481a3e403bb1ed3$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $f481a3e403bb1ed3$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f481a3e403bb1ed3$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $f481a3e403bb1ed3$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f481a3e403bb1ed3$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $f481a3e403bb1ed3$var$prefix ? $f481a3e403bb1ed3$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $f481a3e403bb1ed3$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $f481a3e403bb1ed3$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $f481a3e403bb1ed3$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f481a3e403bb1ed3$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $f481a3e403bb1ed3$var$prefix ? $f481a3e403bb1ed3$var$prefix + event : event;
        if (this._events[evt]) $f481a3e403bb1ed3$var$clearEvent(this, evt);
    } else {
        this._events = new $f481a3e403bb1ed3$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$f481a3e403bb1ed3$var$EventEmitter.prototype.off = $f481a3e403bb1ed3$var$EventEmitter.prototype.removeListener;
$f481a3e403bb1ed3$var$EventEmitter.prototype.addListener = $f481a3e403bb1ed3$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$f481a3e403bb1ed3$var$EventEmitter.prefixed = $f481a3e403bb1ed3$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$f481a3e403bb1ed3$var$EventEmitter.EventEmitter = $f481a3e403bb1ed3$var$EventEmitter;
module.exports = $f481a3e403bb1ed3$var$EventEmitter;

});

parcelRegister("3SA17", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d325a7aa822ef94$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $hbPPp = parcelRequire("hbPPp");

var $5axFn = parcelRequire("5axFn");
function $2d325a7aa822ef94$export$2e2bcd8739ae039() {
    var intl = $iSvIT.useContext((0, $hbPPp.Context));
    (0, $5axFn.invariantIntlContext)(intl);
    return intl;
}

});
parcelRegister("hbPPp", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $c83baab996f3dcc2$export$2881499e37b75b9a; });
$parcel$export(module.exports, "Context", function () { return $c83baab996f3dcc2$export$841858b892ce1f4c; });
$parcel$export(module.exports, "default", function () { return $c83baab996f3dcc2$export$2e2bcd8739ae039; });

var $9z2vN = parcelRequire("9z2vN");

var $iSvIT = parcelRequire("iSvIT");

var $lgqAv = parcelRequire("lgqAv");

var $5axFn = parcelRequire("5axFn");
function $c83baab996f3dcc2$var$getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
// TODO: We should provide initial value here
var $c83baab996f3dcc2$var$IntlContext = $iSvIT.createContext(null);
var $c83baab996f3dcc2$var$IntlConsumer = $c83baab996f3dcc2$var$IntlContext.Consumer, $c83baab996f3dcc2$var$IntlProvider = $c83baab996f3dcc2$var$IntlContext.Provider;
var $c83baab996f3dcc2$export$2881499e37b75b9a = $c83baab996f3dcc2$var$IntlProvider;
var $c83baab996f3dcc2$export$841858b892ce1f4c = $c83baab996f3dcc2$var$IntlContext;
function $c83baab996f3dcc2$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? "intl" : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $iSvIT.createElement($c83baab996f3dcc2$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $5axFn.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $iSvIT.createElement(WrappedComponent, (0, $9z2vN.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($c83baab996f3dcc2$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($lgqAv)))($iSvIT.forwardRef(function(props, ref) {
        return $iSvIT.createElement(WithIntl, (0, $9z2vN.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lgqAv)))(WithIntl, WrappedComponent);
}

});
parcelRegister("5axFn", function(module, exports) {

$parcel$export(module.exports, "invariantIntlContext", function () { return $3c38005e1e6bec83$export$45c4bbf6e55bba1f; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $3c38005e1e6bec83$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "assignUniqueKeysToParts", function () { return $3c38005e1e6bec83$export$cfec03d26465fa63; });
$parcel$export(module.exports, "shallowEqual", function () { return $3c38005e1e6bec83$export$d36bdfa510afb180; });

var $9z2vN = parcelRequire("9z2vN");

var $iSvIT = parcelRequire("iSvIT");

var $gnUbQ = parcelRequire("gnUbQ");

var $8NEa0 = parcelRequire("8NEa0");
function $3c38005e1e6bec83$export$45c4bbf6e55bba1f(intl) {
    (0, $gnUbQ.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $3c38005e1e6bec83$export$b52f8d6fc0d47415 = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, (0, $8NEa0.DEFAULT_INTL_CONFIG)), {
    textComponent: $iSvIT.Fragment
});
function $3c38005e1e6bec83$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($iSvIT.Children.toArray(parts));
    };
}
function $3c38005e1e6bec83$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("gnUbQ", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $beda617c2f4d9e44$export$f5708dca728d7177; });
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $beda617c2f4d9e44$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $beda617c2f4d9e44$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === "function") return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join("");
}
function $beda617c2f4d9e44$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $beda617c2f4d9e44$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $beda617c2f4d9e44$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $beda617c2f4d9e44$export$3fae2929ed23c202(map, pl, field) {
    return $beda617c2f4d9e44$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $beda617c2f4d9e44$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $beda617c2f4d9e44$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === "literal";
}
function $beda617c2f4d9e44$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $beda617c2f4d9e44$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $beda617c2f4d9e44$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

});

parcelRegister("8NEa0", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $66820d552d796baa$export$d697c39a2985a4c; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $66820d552d796baa$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "createIntlCache", function () { return $66820d552d796baa$export$51c4f4e973f2dc00; });
$parcel$export(module.exports, "createFormatters", function () { return $66820d552d796baa$export$c3f4cd5551df13fd; });
$parcel$export(module.exports, "getNamedFormat", function () { return $66820d552d796baa$export$4ee1db8ce44a209b; });

var $9z2vN = parcelRequire("9z2vN");

var $6fndW = parcelRequire("6fndW");

var $lP9wQ = parcelRequire("lP9wQ");

var $lP6cc = parcelRequire("lP6cc");
function $66820d552d796baa$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $66820d552d796baa$var$defaultErrorHandler = function(error) {};
var $66820d552d796baa$var$defaultWarnHandler = function(warning) {};
var $66820d552d796baa$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $66820d552d796baa$var$defaultErrorHandler,
    onWarn: $66820d552d796baa$var$defaultWarnHandler
};
function $66820d552d796baa$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $66820d552d796baa$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $66820d552d796baa$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $66820d552d796baa$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $lP9wQ.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $9z2vN.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $66820d552d796baa$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $lP9wQ.strategies).variadic
    });
    var getNumberFormat = (0, $lP9wQ.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $9z2vN.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $66820d552d796baa$var$createFastMemoizeCache(cache.number),
        strategy: (0, $lP9wQ.strategies).variadic
    });
    var getPluralRules = (0, $lP9wQ.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $9z2vN.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $66820d552d796baa$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $lP9wQ.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $lP9wQ.default)(function(message, locales, overrideFormats, opts) {
            return new (0, $6fndW.IntlMessageFormat)(message, locales, overrideFormats, (0, $9z2vN.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $66820d552d796baa$var$createFastMemoizeCache(cache.message),
            strategy: (0, $lP9wQ.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $lP9wQ.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $9z2vN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $66820d552d796baa$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $lP9wQ.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $lP9wQ.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $9z2vN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $66820d552d796baa$var$createFastMemoizeCache(cache.list),
            strategy: (0, $lP9wQ.strategies).variadic
        }),
        getDisplayNames: (0, $lP9wQ.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $9z2vN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $66820d552d796baa$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $lP9wQ.strategies).variadic
        })
    };
}
function $66820d552d796baa$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $lP6cc.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("6fndW", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", function () { return $48c62891f7fe6e28$export$d342343268debc40; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $9z2vN = parcelRequire("9z2vN");

var $i2ZbQ = parcelRequire("i2ZbQ");

var $lP9wQ = parcelRequire("lP9wQ");

var $kIkVp = parcelRequire("kIkVp");
// -- MessageFormat --------------------------------------------------------
function $48c62891f7fe6e28$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $9z2vN.__assign)((0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $48c62891f7fe6e28$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $48c62891f7fe6e28$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $9z2vN.__assign)({}, defaultConfig));
}
function $48c62891f7fe6e28$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $48c62891f7fe6e28$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $lP9wQ.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $9z2vN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $48c62891f7fe6e28$var$createFastMemoizeCache(cache.number),
            strategy: (0, $lP9wQ.strategies).variadic
        }),
        getDateTimeFormat: (0, $lP9wQ.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $9z2vN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $48c62891f7fe6e28$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $lP9wQ.strategies).variadic
        }),
        getPluralRules: (0, $lP9wQ.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $9z2vN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $48c62891f7fe6e28$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $lP9wQ.strategies).variadic
        })
    };
}
var $48c62891f7fe6e28$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $kIkVp.PART_TYPE).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $kIkVp.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            return {
                locale: _this.resolvedLocale.toString()
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale
            });
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $48c62891f7fe6e28$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $48c62891f7fe6e28$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $i2ZbQ.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("i2ZbQ", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", function () { return (parcelRequire("jLPqv")).isArgumentElement; });
$parcel$export(module.exports, "isDateElement", function () { return (parcelRequire("jLPqv")).isDateElement; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return (parcelRequire("jLPqv")).isDateTimeSkeleton; });
$parcel$export(module.exports, "isLiteralElement", function () { return (parcelRequire("jLPqv")).isLiteralElement; });
$parcel$export(module.exports, "isNumberElement", function () { return (parcelRequire("jLPqv")).isNumberElement; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return (parcelRequire("jLPqv")).isNumberSkeleton; });
$parcel$export(module.exports, "isPluralElement", function () { return (parcelRequire("jLPqv")).isPluralElement; });
$parcel$export(module.exports, "isPoundElement", function () { return (parcelRequire("jLPqv")).isPoundElement; });
$parcel$export(module.exports, "isSelectElement", function () { return (parcelRequire("jLPqv")).isSelectElement; });
$parcel$export(module.exports, "isTagElement", function () { return (parcelRequire("jLPqv")).isTagElement; });
$parcel$export(module.exports, "isTimeElement", function () { return (parcelRequire("jLPqv")).isTimeElement; });
$parcel$export(module.exports, "TYPE", function () { return (parcelRequire("jLPqv")).TYPE; });

$parcel$export(module.exports, "parse", function () { return $d237e0f7e67bb514$export$98e6a39c04603d36; });

var $9z2vN = parcelRequire("9z2vN");

var $zIwe5 = parcelRequire("zIwe5");

var $eV8Pj = parcelRequire("eV8Pj");

var $jLPqv = parcelRequire("jLPqv");
function $d237e0f7e67bb514$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $jLPqv.isSelectElement)(el) || (0, $jLPqv.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $d237e0f7e67bb514$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $jLPqv.isNumberElement)(el) && (0, $jLPqv.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $jLPqv.isDateElement)(el) || (0, $jLPqv.isTimeElement)(el)) && (0, $jLPqv.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $jLPqv.isTagElement)(el)) $d237e0f7e67bb514$var$pruneLocation(el.children);
    });
}
function $d237e0f7e67bb514$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $9z2vN.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $eV8Pj.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $zIwe5.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $d237e0f7e67bb514$var$pruneLocation(result.val);
    return result.val;
}

});
parcelRegister("zIwe5", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", function () { return $06b5cd804c8dc602$export$896afd8541959ee5; });
var $06b5cd804c8dc602$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($06b5cd804c8dc602$export$896afd8541959ee5 || ($06b5cd804c8dc602$export$896afd8541959ee5 = {}));

});

parcelRegister("eV8Pj", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $adcd3c59f858a742$export$7acfa6ed01010e37; });

var $9z2vN = parcelRequire("9z2vN");

var $zIwe5 = parcelRequire("zIwe5");

var $jLPqv = parcelRequire("jLPqv");

var $97Qso = parcelRequire("97Qso");
parcelRequire("fqgzG");
var $4zpL2 = parcelRequire("4zpL2");
var $dj054 = parcelRequire("dj054");

var $9MUUG = parcelRequire("9MUUG");
var $adcd3c59f858a742$var$_a;
var $adcd3c59f858a742$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $97Qso.SPACE_SEPARATOR_REGEX).source, "*"));
var $adcd3c59f858a742$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $97Qso.SPACE_SEPARATOR_REGEX).source, "*$"));
function $adcd3c59f858a742$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $adcd3c59f858a742$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $adcd3c59f858a742$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $adcd3c59f858a742$var$hasNativeFromEntries = !!Object.fromEntries;
var $adcd3c59f858a742$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $adcd3c59f858a742$var$hasTrimStart = !!String.prototype.trimStart;
var $adcd3c59f858a742$var$hasTrimEnd = !!String.prototype.trimEnd;
var $adcd3c59f858a742$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $adcd3c59f858a742$var$isSafeInteger = $adcd3c59f858a742$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $adcd3c59f858a742$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $adcd3c59f858a742$var$re = $adcd3c59f858a742$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $adcd3c59f858a742$var$REGEX_SUPPORTS_U_AND_Y = (($adcd3c59f858a742$var$_a = $adcd3c59f858a742$var$re.exec("a")) === null || $adcd3c59f858a742$var$_a === void 0 ? void 0 : $adcd3c59f858a742$var$_a[0]) === "a";
} catch (_) {
    $adcd3c59f858a742$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $adcd3c59f858a742$var$startsWith = $adcd3c59f858a742$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $adcd3c59f858a742$var$fromCodePoint = $adcd3c59f858a742$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $adcd3c59f858a742$var$fromEntries = // native
$adcd3c59f858a742$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $adcd3c59f858a742$var$codePointAt = $adcd3c59f858a742$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $adcd3c59f858a742$var$trimStart = $adcd3c59f858a742$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($adcd3c59f858a742$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $adcd3c59f858a742$var$trimEnd = $adcd3c59f858a742$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($adcd3c59f858a742$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $adcd3c59f858a742$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $adcd3c59f858a742$var$matchIdentifierAtIndex;
if ($adcd3c59f858a742$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $adcd3c59f858a742$var$IDENTIFIER_PREFIX_RE_1 = $adcd3c59f858a742$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $adcd3c59f858a742$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $adcd3c59f858a742$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $adcd3c59f858a742$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$adcd3c59f858a742$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $adcd3c59f858a742$var$codePointAt(s, index);
        if (c === undefined || $adcd3c59f858a742$var$_isWhiteSpace(c) || $adcd3c59f858a742$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $adcd3c59f858a742$var$fromCodePoint.apply(void 0, match);
};
var $adcd3c59f858a742$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $jLPqv.TYPE).pound,
                    location: $adcd3c59f858a742$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $zIwe5.ErrorKind).UNMATCHED_CLOSING_TAG, $adcd3c59f858a742$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $adcd3c59f858a742$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, $jLPqv.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $adcd3c59f858a742$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$adcd3c59f858a742$var$_isAlpha(this.char())) return this.error((0, $zIwe5.ErrorKind).INVALID_TAG, $adcd3c59f858a742$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $zIwe5.ErrorKind).UNMATCHED_CLOSING_TAG, $adcd3c59f858a742$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, $zIwe5.ErrorKind).INVALID_TAG, $adcd3c59f858a742$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $jLPqv.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $adcd3c59f858a742$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $zIwe5.ErrorKind).UNCLOSED_TAG, $adcd3c59f858a742$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $zIwe5.ErrorKind).INVALID_TAG, $adcd3c59f858a742$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $adcd3c59f858a742$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $adcd3c59f858a742$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $jLPqv.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$adcd3c59f858a742$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $adcd3c59f858a742$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $adcd3c59f858a742$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $zIwe5.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $adcd3c59f858a742$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $zIwe5.ErrorKind).EMPTY_ARGUMENT, $adcd3c59f858a742$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $zIwe5.ErrorKind).MALFORMED_ARGUMENT, $adcd3c59f858a742$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $zIwe5.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $adcd3c59f858a742$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $jLPqv.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $adcd3c59f858a742$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $zIwe5.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $adcd3c59f858a742$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $zIwe5.ErrorKind).MALFORMED_ARGUMENT, $adcd3c59f858a742$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $adcd3c59f858a742$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $adcd3c59f858a742$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $zIwe5.ErrorKind).EXPECT_ARGUMENT_TYPE, $adcd3c59f858a742$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $adcd3c59f858a742$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $zIwe5.ErrorKind).EXPECT_ARGUMENT_STYLE, $adcd3c59f858a742$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $adcd3c59f858a742$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $adcd3c59f858a742$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $adcd3c59f858a742$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $adcd3c59f858a742$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $jLPqv.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $zIwe5.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $9MUUG.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $jLPqv.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $4zpL2.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? (0, $jLPqv.TYPE).date : (0, $jLPqv.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? (0, $jLPqv.TYPE).number : argType === "date" ? (0, $jLPqv.TYPE).date : (0, $jLPqv.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error((0, $zIwe5.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $adcd3c59f858a742$var$createLocation(typeEndPosition_1, (0, $9z2vN.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error((0, $zIwe5.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $adcd3c59f858a742$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $zIwe5.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $zIwe5.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $adcd3c59f858a742$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: (0, $jLPqv.TYPE).select,
                        value: value,
                        options: $adcd3c59f858a742$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $jLPqv.TYPE).plural,
                        value: value,
                        options: $adcd3c59f858a742$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $zIwe5.ErrorKind).INVALID_ARGUMENT_TYPE, $adcd3c59f858a742$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $zIwe5.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $adcd3c59f858a742$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $zIwe5.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $adcd3c59f858a742$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $dj054.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $zIwe5.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $jLPqv.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $dj054.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $zIwe5.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $zIwe5.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $adcd3c59f858a742$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, $zIwe5.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $zIwe5.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, $zIwe5.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $zIwe5.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $adcd3c59f858a742$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $adcd3c59f858a742$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, $zIwe5.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $zIwe5.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $adcd3c59f858a742$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $zIwe5.ErrorKind).MISSING_OTHER_CLAUSE, $adcd3c59f858a742$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $adcd3c59f858a742$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$adcd3c59f858a742$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $adcd3c59f858a742$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($adcd3c59f858a742$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $adcd3c59f858a742$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $adcd3c59f858a742$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $adcd3c59f858a742$var$_isAlphaOrSlash(codepoint) {
    return $adcd3c59f858a742$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $adcd3c59f858a742$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $adcd3c59f858a742$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $adcd3c59f858a742$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("jLPqv", function(module, exports) {

$parcel$export(module.exports, "TYPE", function () { return $e64a4c55aec85874$export$b87f371cbc396fcf; });
$parcel$export(module.exports, "SKELETON_TYPE", function () { return $e64a4c55aec85874$export$906452485466fa53; });
$parcel$export(module.exports, "isLiteralElement", function () { return $e64a4c55aec85874$export$cfa10c5697238752; });
$parcel$export(module.exports, "isArgumentElement", function () { return $e64a4c55aec85874$export$4f55724281bdfaf9; });
$parcel$export(module.exports, "isNumberElement", function () { return $e64a4c55aec85874$export$e11187b219e191e1; });
$parcel$export(module.exports, "isDateElement", function () { return $e64a4c55aec85874$export$32d811605da75f40; });
$parcel$export(module.exports, "isTimeElement", function () { return $e64a4c55aec85874$export$34ec46f596b1702f; });
$parcel$export(module.exports, "isSelectElement", function () { return $e64a4c55aec85874$export$dcfe1c11d168b5a1; });
$parcel$export(module.exports, "isPluralElement", function () { return $e64a4c55aec85874$export$6c796d116f0a4fbc; });
$parcel$export(module.exports, "isPoundElement", function () { return $e64a4c55aec85874$export$c0ece297bdd0c082; });
$parcel$export(module.exports, "isTagElement", function () { return $e64a4c55aec85874$export$5c83de34745812b; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return $e64a4c55aec85874$export$3f9a19cd4152eda3; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return $e64a4c55aec85874$export$7680c41f1a55f4cf; });
var $e64a4c55aec85874$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($e64a4c55aec85874$export$b87f371cbc396fcf || ($e64a4c55aec85874$export$b87f371cbc396fcf = {}));
var $e64a4c55aec85874$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($e64a4c55aec85874$export$906452485466fa53 || ($e64a4c55aec85874$export$906452485466fa53 = {}));
function $e64a4c55aec85874$export$cfa10c5697238752(el) {
    return el.type === $e64a4c55aec85874$export$b87f371cbc396fcf.literal;
}
function $e64a4c55aec85874$export$4f55724281bdfaf9(el) {
    return el.type === $e64a4c55aec85874$export$b87f371cbc396fcf.argument;
}
function $e64a4c55aec85874$export$e11187b219e191e1(el) {
    return el.type === $e64a4c55aec85874$export$b87f371cbc396fcf.number;
}
function $e64a4c55aec85874$export$32d811605da75f40(el) {
    return el.type === $e64a4c55aec85874$export$b87f371cbc396fcf.date;
}
function $e64a4c55aec85874$export$34ec46f596b1702f(el) {
    return el.type === $e64a4c55aec85874$export$b87f371cbc396fcf.time;
}
function $e64a4c55aec85874$export$dcfe1c11d168b5a1(el) {
    return el.type === $e64a4c55aec85874$export$b87f371cbc396fcf.select;
}
function $e64a4c55aec85874$export$6c796d116f0a4fbc(el) {
    return el.type === $e64a4c55aec85874$export$b87f371cbc396fcf.plural;
}
function $e64a4c55aec85874$export$c0ece297bdd0c082(el) {
    return el.type === $e64a4c55aec85874$export$b87f371cbc396fcf.pound;
}
function $e64a4c55aec85874$export$5c83de34745812b(el) {
    return el.type === $e64a4c55aec85874$export$b87f371cbc396fcf.tag;
}
function $e64a4c55aec85874$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === $e64a4c55aec85874$export$906452485466fa53.number);
}
function $e64a4c55aec85874$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === $e64a4c55aec85874$export$906452485466fa53.dateTime);
}
function $e64a4c55aec85874$export$f0ac572c1121c662(value) {
    return {
        type: $e64a4c55aec85874$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $e64a4c55aec85874$export$425e864b0ba114f1(value, style) {
    return {
        type: $e64a4c55aec85874$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("97Qso", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", function () { return $6a4d75562b3bb5ad$export$523451f94304dd6c; });
// @generated from regex-gen.ts
var $6a4d75562b3bb5ad$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $6a4d75562b3bb5ad$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("fqgzG", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return (parcelRequire("4zpL2")).parseDateTimeSkeleton; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return (parcelRequire("dj054")).parseNumberSkeleton; });
$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return (parcelRequire("dj054")).parseNumberSkeletonFromString; });
parcelRequire("4zpL2");
parcelRequire("dj054");

});
parcelRegister("4zpL2", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return $353e69429bc36371$export$f7b99fb377fe69fa; });
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $353e69429bc36371$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $353e69429bc36371$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($353e69429bc36371$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "short" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}

});

parcelRegister("dj054", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return $9afd1cbe03da4361$export$71cee2f16fba2480; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return $9afd1cbe03da4361$export$47c6f8480bda3e11; });

var $9z2vN = parcelRequire("9z2vN");

var $13QqM = parcelRequire("13QqM");
function $9afd1cbe03da4361$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $13QqM.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $9afd1cbe03da4361$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $9afd1cbe03da4361$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $9afd1cbe03da4361$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $9afd1cbe03da4361$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $9afd1cbe03da4361$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $9afd1cbe03da4361$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($9afd1cbe03da4361$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $9afd1cbe03da4361$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $9afd1cbe03da4361$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$9afd1cbe03da4361$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $9afd1cbe03da4361$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $9afd1cbe03da4361$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $9afd1cbe03da4361$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $9afd1cbe03da4361$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = (0, $9z2vN.__assign)((0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, all), $9afd1cbe03da4361$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = (0, $9z2vN.__assign)((0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, all), $9afd1cbe03da4361$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($9afd1cbe03da4361$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($9afd1cbe03da4361$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($9afd1cbe03da4361$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($9afd1cbe03da4361$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, result), $9afd1cbe03da4361$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($9afd1cbe03da4361$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, result), $9afd1cbe03da4361$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $9afd1cbe03da4361$var$parseSign(token.stem);
        if (signOpts) result = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $9afd1cbe03da4361$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("13QqM", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", function () { return $0c5ebdf325f9961b$export$2b8db14d8bcaece7; });
// @generated from regex-gen.ts
var $0c5ebdf325f9961b$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("9MUUG", function(module, exports) {

$parcel$export(module.exports, "getBestPattern", function () { return $7204be880d6ab633$export$29c5368be8904d27; });

var $dcRpX = parcelRequire("dcRpX");
function $7204be880d6ab633$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = $7204be880d6ab633$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $7204be880d6ab633$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = (0, $dcRpX.timeData)[regionTag || ""] || (0, $dcRpX.timeData)[languageTag || ""] || (0, $dcRpX.timeData)["".concat(languageTag, "-001")] || (0, $dcRpX.timeData)["001"];
    return hourCycles[0];
}

});
parcelRegister("dcRpX", function(module, exports) {

$parcel$export(module.exports, "timeData", function () { return $99d5d4fb8b2486a4$export$a8c9209db4084317; });
// @generated from time-data-gen.ts
// prettier-ignore  
var $99d5d4fb8b2486a4$export$a8c9209db4084317 = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

});




parcelRegister("lP9wQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe35c09d846f3c47$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "strategies", function () { return $fe35c09d846f3c47$export$c5491a8691a23b9e; });
//
// Main
//
function $fe35c09d846f3c47$export$2e2bcd8739ae039(fn, options) {
    var cache = options && options.cache ? options.cache : $fe35c09d846f3c47$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $fe35c09d846f3c47$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $fe35c09d846f3c47$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $fe35c09d846f3c47$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $fe35c09d846f3c47$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $fe35c09d846f3c47$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $fe35c09d846f3c47$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $fe35c09d846f3c47$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $fe35c09d846f3c47$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $fe35c09d846f3c47$var$monadic : $fe35c09d846f3c47$var$variadic;
    return $fe35c09d846f3c47$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $fe35c09d846f3c47$var$strategyVariadic(fn, options) {
    return $fe35c09d846f3c47$var$assemble(fn, this, $fe35c09d846f3c47$var$variadic, options.cache.create(), options.serializer);
}
function $fe35c09d846f3c47$var$strategyMonadic(fn, options) {
    return $fe35c09d846f3c47$var$assemble(fn, this, $fe35c09d846f3c47$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $fe35c09d846f3c47$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $fe35c09d846f3c47$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$fe35c09d846f3c47$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$fe35c09d846f3c47$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $fe35c09d846f3c47$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $fe35c09d846f3c47$var$ObjectWithoutPrototypeCache();
    }
};
var $fe35c09d846f3c47$export$c5491a8691a23b9e = {
    variadic: $fe35c09d846f3c47$var$strategyVariadic,
    monadic: $fe35c09d846f3c47$var$strategyMonadic
};

});

parcelRegister("kIkVp", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", function () { return $f14825f919577e41$export$49694c2877b44c57; });
$parcel$export(module.exports, "formatToParts", function () { return $f14825f919577e41$export$275d4a3bb5f66fda; });
parcelRequire("i2ZbQ");
var $jLPqv = parcelRequire("jLPqv");

var $2H3gJ = parcelRequire("2H3gJ");
var $f14825f919577e41$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($f14825f919577e41$export$49694c2877b44c57 || ($f14825f919577e41$export$49694c2877b44c57 = {}));
function $f14825f919577e41$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $f14825f919577e41$export$49694c2877b44c57.literal || part.type !== $f14825f919577e41$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $f14825f919577e41$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $f14825f919577e41$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $jLPqv.isLiteralElement)(els[0])) return [
        {
            type: $f14825f919577e41$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $jLPqv.isLiteralElement)(el)) {
            result.push({
                type: $f14825f919577e41$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $jLPqv.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $f14825f919577e41$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $2H3gJ.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $jLPqv.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $f14825f919577e41$export$49694c2877b44c57.literal : $f14825f919577e41$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $jLPqv.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $jLPqv.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $f14825f919577e41$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jLPqv.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $jLPqv.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $f14825f919577e41$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jLPqv.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $jLPqv.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $f14825f919577e41$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jLPqv.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$f14825f919577e41$export$df0c12a2d414a163(formatFn)) throw new (0, $2H3gJ.InvalidValueTypeError)(value_1, "function", originalMessage);
            var parts = $f14825f919577e41$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $f14825f919577e41$export$49694c2877b44c57.literal : $f14825f919577e41$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $jLPqv.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $2H3gJ.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $f14825f919577e41$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $jLPqv.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $2H3gJ.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $2H3gJ.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $2H3gJ.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $f14825f919577e41$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $f14825f919577e41$var$mergeLiteral(result);
}

});
parcelRegister("2H3gJ", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $1f62220ddeec7218$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "FormatError", function () { return $1f62220ddeec7218$export$7369836851cc1329; });
$parcel$export(module.exports, "InvalidValueError", function () { return $1f62220ddeec7218$export$565c3afc07dfa382; });
$parcel$export(module.exports, "InvalidValueTypeError", function () { return $1f62220ddeec7218$export$cbc0db47c750f7c9; });
$parcel$export(module.exports, "MissingValueError", function () { return $1f62220ddeec7218$export$8bfc137e4d23fdf0; });

var $9z2vN = parcelRequire("9z2vN");
var $1f62220ddeec7218$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($1f62220ddeec7218$export$d4e71bc0b80dc0fb || ($1f62220ddeec7218$export$d4e71bc0b80dc0fb = {}));
var $1f62220ddeec7218$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $1f62220ddeec7218$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $1f62220ddeec7218$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($1f62220ddeec7218$export$7369836851cc1329);
var $1f62220ddeec7218$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $1f62220ddeec7218$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($1f62220ddeec7218$export$7369836851cc1329);
var $1f62220ddeec7218$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $1f62220ddeec7218$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($1f62220ddeec7218$export$7369836851cc1329);

});



parcelRegister("lP6cc", function(module, exports) {

$parcel$export(module.exports, "IntlErrorCode", function () { return $fe332ac1850f4860$export$557d6acb76e8a244; });
$parcel$export(module.exports, "IntlError", function () { return $fe332ac1850f4860$export$c016d36112f6ddf8; });
$parcel$export(module.exports, "UnsupportedFormatterError", function () { return $fe332ac1850f4860$export$549f97e137a05c90; });
$parcel$export(module.exports, "InvalidConfigError", function () { return $fe332ac1850f4860$export$3ca04dd7fb305893; });
$parcel$export(module.exports, "MissingDataError", function () { return $fe332ac1850f4860$export$c1eaf877d81384b6; });
$parcel$export(module.exports, "IntlFormatError", function () { return $fe332ac1850f4860$export$e3b7eee1dbc44895; });
$parcel$export(module.exports, "MessageFormatError", function () { return $fe332ac1850f4860$export$74a601a3d3f31621; });
$parcel$export(module.exports, "MissingTranslationError", function () { return $fe332ac1850f4860$export$2ddcb436d0aa3688; });

var $9z2vN = parcelRequire("9z2vN");
var $fe332ac1850f4860$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($fe332ac1850f4860$export$557d6acb76e8a244 || ($fe332ac1850f4860$export$557d6acb76e8a244 = {}));
var $fe332ac1850f4860$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, " \n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : "")) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === "function") // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $fe332ac1850f4860$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $fe332ac1850f4860$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($fe332ac1850f4860$export$c016d36112f6ddf8);
var $fe332ac1850f4860$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $fe332ac1850f4860$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($fe332ac1850f4860$export$c016d36112f6ddf8);
var $fe332ac1850f4860$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $fe332ac1850f4860$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($fe332ac1850f4860$export$c016d36112f6ddf8);
var $fe332ac1850f4860$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        return _super.call(this, $fe332ac1850f4860$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, " \nLocale: ").concat(locale, "\n"), exception) || this;
    }
    return IntlFormatError;
}($fe332ac1850f4860$export$c016d36112f6ddf8);
var $fe332ac1850f4860$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, " \nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, " \n"), locale, exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}($fe332ac1850f4860$export$e3b7eee1dbc44895);
var $fe332ac1850f4860$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $fe332ac1850f4860$export$557d6acb76e8a244.MISSING_TRANSLATION, 'Missing message: "'.concat(descriptor.id, '" for locale "').concat(locale, '", using ').concat(descriptor.defaultMessage ? "default message" : "id", " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($fe332ac1850f4860$export$c016d36112f6ddf8);

});





parcelRegister("f2Ax6", function(module, exports) {

$parcel$export(module.exports, "defineMessages", function () { return $af33619a079c49ae$export$1adfeb024f5185b; });
$parcel$export(module.exports, "defineMessage", function () { return $af33619a079c49ae$export$747d244ee58120dd; });
$parcel$export(module.exports, "FormattedDate", function () { return $af33619a079c49ae$export$40ae3194919d16b; });
$parcel$export(module.exports, "FormattedTime", function () { return $af33619a079c49ae$export$5b390a54f8a846f7; });
$parcel$export(module.exports, "FormattedNumber", function () { return $af33619a079c49ae$export$db80edc1e6b2f63d; });
$parcel$export(module.exports, "FormattedList", function () { return $af33619a079c49ae$export$f52b44e459e6e71d; });
$parcel$export(module.exports, "FormattedDisplayName", function () { return $af33619a079c49ae$export$c2336ea5aaab92fa; });
$parcel$export(module.exports, "FormattedDateParts", function () { return $af33619a079c49ae$export$7fdc7d2c91ce149b; });
$parcel$export(module.exports, "FormattedTimeParts", function () { return $af33619a079c49ae$export$ec35873761676c2a; });
$parcel$export(module.exports, "FormattedDateTimeRange", function () { return (parcelRequire("kEtPr")).default; });
$parcel$export(module.exports, "FormattedMessage", function () { return (parcelRequire("bKQO4")).default; });
$parcel$export(module.exports, "FormattedPlural", function () { return (parcelRequire("kIDVr")).default; });
$parcel$export(module.exports, "FormattedRelativeTime", function () { return (parcelRequire("6Rdhc")).default; });
$parcel$export(module.exports, "IntlContext", function () { return (parcelRequire("hbPPp")).Context; });
$parcel$export(module.exports, "IntlProvider", function () { return (parcelRequire("gRp5g")).default; });
$parcel$export(module.exports, "RawIntlProvider", function () { return (parcelRequire("hbPPp")).Provider; });
$parcel$export(module.exports, "createIntl", function () { return (parcelRequire("gRp5g")).createIntl; });
$parcel$export(module.exports, "injectIntl", function () { return (parcelRequire("hbPPp")).default; });
$parcel$export(module.exports, "useIntl", function () { return (parcelRequire("3SA17")).default; });
$parcel$export(module.exports, "createIntlCache", function () { return (parcelRequire("8NEa0")).createIntlCache; });
$parcel$export(module.exports, "UnsupportedFormatterError", function () { return (parcelRequire("lP6cc")).UnsupportedFormatterError; });
$parcel$export(module.exports, "InvalidConfigError", function () { return (parcelRequire("lP6cc")).InvalidConfigError; });
$parcel$export(module.exports, "MissingDataError", function () { return (parcelRequire("lP6cc")).MissingDataError; });
$parcel$export(module.exports, "MessageFormatError", function () { return (parcelRequire("lP6cc")).MessageFormatError; });
$parcel$export(module.exports, "MissingTranslationError", function () { return (parcelRequire("lP6cc")).MissingTranslationError; });
$parcel$export(module.exports, "ReactIntlErrorCode", function () { return (parcelRequire("lP6cc")).IntlErrorCode; });
$parcel$export(module.exports, "ReactIntlError", function () { return (parcelRequire("lP6cc")).IntlError; });
$parcel$export(module.exports, "FormattedNumberParts", function () { return (parcelRequire("a3lMg")).FormattedNumberParts; });
$parcel$export(module.exports, "FormattedListParts", function () { return (parcelRequire("a3lMg")).FormattedListParts; });

var $a3lMg = parcelRequire("a3lMg");

var $hbPPp = parcelRequire("hbPPp");

var $3SA17 = parcelRequire("3SA17");

var $gRp5g = parcelRequire("gRp5g");

var $6Rdhc = parcelRequire("6Rdhc");

var $kIDVr = parcelRequire("kIDVr");

var $bKQO4 = parcelRequire("bKQO4");

var $kEtPr = parcelRequire("kEtPr");

var $8NEa0 = parcelRequire("8NEa0");
var $lP6cc = parcelRequire("lP6cc");
function $af33619a079c49ae$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $af33619a079c49ae$export$747d244ee58120dd(msg) {
    return msg;
}
var $af33619a079c49ae$export$40ae3194919d16b = (0, $a3lMg.createFormattedComponent)("formatDate");
var $af33619a079c49ae$export$5b390a54f8a846f7 = (0, $a3lMg.createFormattedComponent)("formatTime");
var $af33619a079c49ae$export$db80edc1e6b2f63d = (0, $a3lMg.createFormattedComponent)("formatNumber");
var $af33619a079c49ae$export$f52b44e459e6e71d = (0, $a3lMg.createFormattedComponent)("formatList");
var $af33619a079c49ae$export$c2336ea5aaab92fa = (0, $a3lMg.createFormattedComponent)("formatDisplayName");
var $af33619a079c49ae$export$7fdc7d2c91ce149b = (0, $a3lMg.createFormattedDateTimePartsComponent)("formatDate");
var $af33619a079c49ae$export$ec35873761676c2a = (0, $a3lMg.createFormattedDateTimePartsComponent)("formatTime");

});
parcelRegister("a3lMg", function(module, exports) {

$parcel$export(module.exports, "FormattedNumberParts", function () { return $751b13bb2d59a2dc$export$54d4989ed3eea1ea; });
$parcel$export(module.exports, "FormattedListParts", function () { return $751b13bb2d59a2dc$export$5ac259c7da6d2188; });
$parcel$export(module.exports, "createFormattedDateTimePartsComponent", function () { return $751b13bb2d59a2dc$export$7448277f6036d2ab; });
$parcel$export(module.exports, "createFormattedComponent", function () { return $751b13bb2d59a2dc$export$b37e14176d001dec; });

var $9z2vN = parcelRequire("9z2vN");

var $iSvIT = parcelRequire("iSvIT");

var $3SA17 = parcelRequire("3SA17");
var $751b13bb2d59a2dc$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($751b13bb2d59a2dc$var$DisplayName || ($751b13bb2d59a2dc$var$DisplayName = {}));
var $751b13bb2d59a2dc$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($751b13bb2d59a2dc$var$DisplayNameParts || ($751b13bb2d59a2dc$var$DisplayNameParts = {}));
var $751b13bb2d59a2dc$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $3SA17.default)();
    var value = props.value, children = props.children, formatProps = (0, $9z2vN.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$751b13bb2d59a2dc$export$54d4989ed3eea1ea.displayName = "FormattedNumberParts";
var $751b13bb2d59a2dc$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $3SA17.default)();
    var value = props.value, children = props.children, formatProps = (0, $9z2vN.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$751b13bb2d59a2dc$export$54d4989ed3eea1ea.displayName = "FormattedNumberParts";
function $751b13bb2d59a2dc$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $3SA17.default)();
        var value = props.value, children = props.children, formatProps = (0, $9z2vN.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === "string" ? new Date(value || 0) : value;
        var formattedParts = name === "formatDate" ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $751b13bb2d59a2dc$var$DisplayNameParts[name];
    return ComponentParts;
}
function $751b13bb2d59a2dc$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $3SA17.default)();
        var value = props.value, children = props.children, formatProps = (0, $9z2vN.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === "function") return children(formattedValue);
        var Text = intl.textComponent || $iSvIT.Fragment;
        return $iSvIT.createElement(Text, null, formattedValue);
    };
    Component.displayName = $751b13bb2d59a2dc$var$DisplayName[name];
    return Component;
}

});

parcelRegister("gRp5g", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $c4650db9f3b06f42$export$7e4cbedfdd7b4c0d; });
$parcel$export(module.exports, "default", function () { return $c4650db9f3b06f42$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $9z2vN = parcelRequire("9z2vN");

var $iSvIT = parcelRequire("iSvIT");

var $hbPPp = parcelRequire("hbPPp");

var $5axFn = parcelRequire("5axFn");

var $iGRAf = parcelRequire("iGRAf");
var $8NEa0 = parcelRequire("8NEa0");
var $jmp3h = parcelRequire("jmp3h");

var $ckEuy = parcelRequire("ckEuy");
function $c4650db9f3b06f42$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $c4650db9f3b06f42$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $ckEuy.isFormatXMLElementFn)(v) ? (0, $5axFn.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $c4650db9f3b06f42$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $c4650db9f3b06f42$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $jmp3h.formatMessage).apply(void 0, (0, $9z2vN.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $iSvIT.Children.toArray(chunks);
    return chunks;
};
var $c4650db9f3b06f42$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $9z2vN.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $c4650db9f3b06f42$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $iGRAf.createIntl)((0, $9z2vN.__assign)((0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, (0, $5axFn.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    return (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, coreIntl), {
        formatMessage: $c4650db9f3b06f42$var$formatMessage.bind(null, {
            locale: coreIntl.locale,
            timeZone: coreIntl.timeZone,
            fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
            formats: coreIntl.formats,
            defaultLocale: coreIntl.defaultLocale,
            defaultFormats: coreIntl.defaultFormats,
            messages: coreIntl.messages,
            onError: coreIntl.onError,
            defaultRichTextElements: defaultRichTextElements
        }, coreIntl.formatters)
    });
};
var $c4650db9f3b06f42$var$IntlProvider = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $8NEa0.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: $c4650db9f3b06f42$export$7e4cbedfdd7b4c0d($c4650db9f3b06f42$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $c4650db9f3b06f42$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $c4650db9f3b06f42$var$processIntlConfig(props);
        if (!(0, $5axFn.shallowEqual)(prevConfig, config)) return {
            intl: $c4650db9f3b06f42$export$7e4cbedfdd7b4c0d(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $5axFn.invariantIntlContext)(this.state.intl);
        return $iSvIT.createElement((0, $hbPPp.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = "IntlProvider";
    IntlProvider.defaultProps = (0, $5axFn.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($iSvIT.PureComponent);
var $c4650db9f3b06f42$export$2e2bcd8739ae039 = $c4650db9f3b06f42$var$IntlProvider;

});
parcelRegister("iGRAf", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $d9b5b6d11e6fa77c$export$7e4cbedfdd7b4c0d; });

var $9z2vN = parcelRequire("9z2vN");

var $8NEa0 = parcelRequire("8NEa0");

var $lP6cc = parcelRequire("lP6cc");

var $9s5XI = parcelRequire("9s5XI");

var $3kXkG = parcelRequire("3kXkG");

var $4Iw1H = parcelRequire("4Iw1H");

var $cPkpm = parcelRequire("cPkpm");

var $jmp3h = parcelRequire("jmp3h");

var $8j0Sv = parcelRequire("8j0Sv");

var $ecXhs = parcelRequire("ecXhs");
function $d9b5b6d11e6fa77c$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === "string";
}
function $d9b5b6d11e6fa77c$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $d9b5b6d11e6fa77c$var$messagesContainString(config.messages || {})) config.onWarn('[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. \nPlease consider using "@formatjs/cli" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution');
}
function $d9b5b6d11e6fa77c$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $8NEa0.createFormatters)(cache);
    var resolvedConfig = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, (0, $8NEa0.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $lP6cc.InvalidConfigError)('"locale" was not configured, using "'.concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details')));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $lP6cc.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.NumberFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $lP6cc.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.DateTimeFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    $d9b5b6d11e6fa77c$var$verifyConfigMessages(resolvedConfig);
    return (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $9s5XI.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $9s5XI.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $3kXkG.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $4Iw1H.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $4Iw1H.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $4Iw1H.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $4Iw1H.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $4Iw1H.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $cPkpm.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $jmp3h.formatMessage).bind(null, resolvedConfig, formatters),
        $t: (0, $jmp3h.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $8j0Sv.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $8j0Sv.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $ecXhs.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("9s5XI", function(module, exports) {

$parcel$export(module.exports, "formatNumber", function () { return $6e1b5a8a085c6188$export$f5dd818bff069720; });
$parcel$export(module.exports, "formatNumberToParts", function () { return $6e1b5a8a085c6188$export$6871080848f10b2f; });

var $8NEa0 = parcelRequire("8NEa0");

var $lP6cc = parcelRequire("lP6cc");
var $6e1b5a8a085c6188$var$NUMBER_FORMAT_OPTIONS = [
    "localeMatcher",
    "style",
    "currency",
    "currencyDisplay",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    // ES2020 NumberFormat
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem"
];
function $6e1b5a8a085c6188$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $8NEa0.getNamedFormat)(formats, "number", format, onError) || {};
    var filteredOptions = (0, $8NEa0.filterProps)(options, $6e1b5a8a085c6188$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $6e1b5a8a085c6188$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $6e1b5a8a085c6188$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $lP6cc.IntlError)((0, $lP6cc.IntlErrorCode).FORMAT_ERROR, "Error formatting number.", e));
    }
    return String(value);
}
function $6e1b5a8a085c6188$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $6e1b5a8a085c6188$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $lP6cc.IntlError)((0, $lP6cc.IntlErrorCode).FORMAT_ERROR, "Error formatting number.", e));
    }
    return [];
}

});

parcelRegister("3kXkG", function(module, exports) {

$parcel$export(module.exports, "formatRelativeTime", function () { return $26e1438fdb22b59f$export$b4ea3b48dcf921f6; });

var $8NEa0 = parcelRequire("8NEa0");

var $2H3gJ = parcelRequire("2H3gJ");

var $lP6cc = parcelRequire("lP6cc");
var $26e1438fdb22b59f$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function $26e1438fdb22b59f$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $8NEa0.getNamedFormat)(formats, "relative", format, onError) || {};
    var filteredOptions = (0, $8NEa0.filterProps)(options, $26e1438fdb22b59f$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $26e1438fdb22b59f$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = "second";
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $2H3gJ.FormatError)('Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-relativetimeformat"\n', (0, $2H3gJ.ErrorCode).MISSING_INTL_API));
    try {
        return $26e1438fdb22b59f$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $lP6cc.IntlFormatError)("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}

});

parcelRegister("4Iw1H", function(module, exports) {

$parcel$export(module.exports, "formatDate", function () { return $36f41d4057fef16a$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "formatTime", function () { return $36f41d4057fef16a$export$3203edd9e5edd663; });
$parcel$export(module.exports, "formatDateTimeRange", function () { return $36f41d4057fef16a$export$a7fc3a91cb2ec376; });
$parcel$export(module.exports, "formatDateToParts", function () { return $36f41d4057fef16a$export$dc1f059bce486b1; });
$parcel$export(module.exports, "formatTimeToParts", function () { return $36f41d4057fef16a$export$af6e5d7a5c73edeb; });

var $9z2vN = parcelRequire("9z2vN");

var $8NEa0 = parcelRequire("8NEa0");

var $lP6cc = parcelRequire("lP6cc");
var $36f41d4057fef16a$var$DATE_TIME_FORMAT_OPTIONS = [
    "localeMatcher",
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    // 'dayPeriod',
    "numberingSystem"
];
function $36f41d4057fef16a$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $8NEa0.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $8NEa0.filterProps)(options, $36f41d4057fef16a$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, filteredOptions), {
        hour: "numeric",
        minute: "numeric"
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $36f41d4057fef16a$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $36f41d4057fef16a$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $lP6cc.IntlError)((0, $lP6cc.IntlErrorCode).FORMAT_ERROR, "Error formatting date.", e));
    }
    return String(date);
}
function $36f41d4057fef16a$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $36f41d4057fef16a$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $lP6cc.IntlError)((0, $lP6cc.IntlErrorCode).FORMAT_ERROR, "Error formatting time.", e));
    }
    return String(date);
}
function $36f41d4057fef16a$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $8NEa0.filterProps)(options, $36f41d4057fef16a$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $lP6cc.IntlError)((0, $lP6cc.IntlErrorCode).FORMAT_ERROR, "Error formatting date time range.", e));
    }
    return String(from);
}
function $36f41d4057fef16a$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $36f41d4057fef16a$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $lP6cc.IntlError)((0, $lP6cc.IntlErrorCode).FORMAT_ERROR, "Error formatting date.", e));
    }
    return [];
}
function $36f41d4057fef16a$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $36f41d4057fef16a$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $lP6cc.IntlError)((0, $lP6cc.IntlErrorCode).FORMAT_ERROR, "Error formatting time.", e));
    }
    return [];
}

});

parcelRegister("cPkpm", function(module, exports) {

$parcel$export(module.exports, "formatPlural", function () { return $956a1411e62c10a5$export$bbbd05c900f3568d; });

var $8NEa0 = parcelRequire("8NEa0");

var $lP6cc = parcelRequire("lP6cc");

var $2H3gJ = parcelRequire("2H3gJ");
var $956a1411e62c10a5$var$PLURAL_FORMAT_OPTIONS = [
    "localeMatcher",
    "type"
];
function $956a1411e62c10a5$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $2H3gJ.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $2H3gJ.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $8NEa0.filterProps)(options, $956a1411e62c10a5$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $lP6cc.IntlFormatError)("Error formatting plural.", locale, e));
    }
    return "other";
}

});

parcelRegister("jmp3h", function(module, exports) {

$parcel$export(module.exports, "formatMessage", function () { return $e18381280b7ed4c1$export$25868d1e8e76735f; });

var $9z2vN = parcelRequire("9z2vN");

var $gnUbQ = parcelRequire("gnUbQ");

var $6fndW = parcelRequire("6fndW");

var $lP6cc = parcelRequire("lP6cc");
parcelRequire("i2ZbQ");
var $jLPqv = parcelRequire("jLPqv");
function $e18381280b7ed4c1$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $9z2vN.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $e18381280b7ed4c1$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $e18381280b7ed4c1$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $6fndW.IntlMessageFormat).formats;
    return (0, $9z2vN.__assign)((0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, mfFormats), f1), {
        date: $e18381280b7ed4c1$var$deepMergeOptions($e18381280b7ed4c1$var$setTimeZoneInOptions(mfFormats.date, timeZone), $e18381280b7ed4c1$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $e18381280b7ed4c1$var$deepMergeOptions($e18381280b7ed4c1$var$setTimeZoneInOptions(mfFormats.time, timeZone), $e18381280b7ed4c1$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
function $e18381280b7ed4c1$export$25868d1e8e76735f(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ""
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $gnUbQ.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $jLPqv.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === "string" && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, defaultRichTextElements), values || {});
    formats = $e18381280b7ed4c1$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $e18381280b7ed4c1$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $lP6cc.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $lP6cc.MessageFormatError)('Error formatting default message for: "'.concat(id, '", rendering default message verbatim'), locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $9z2vN.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $lP6cc.MessageFormatError)('Error formatting message: "'.concat(id, '", using ').concat(defaultMessage ? "default message" : "id", " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $lP6cc.MessageFormatError)('Error formatting the default message for: "'.concat(id, '", rendering message verbatim'), locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
}

});

parcelRegister("8j0Sv", function(module, exports) {

$parcel$export(module.exports, "formatList", function () { return $60c0c779a0799aa5$export$e8b8be48b45905bb; });
$parcel$export(module.exports, "formatListToParts", function () { return $60c0c779a0799aa5$export$6f284aad1934db69; });

var $9z2vN = parcelRequire("9z2vN");

var $8NEa0 = parcelRequire("8NEa0");

var $2H3gJ = parcelRequire("2H3gJ");

var $lP6cc = parcelRequire("lP6cc");
var $60c0c779a0799aa5$var$LIST_FORMAT_OPTIONS = [
    "localeMatcher",
    "type",
    "style"
];
var $60c0c779a0799aa5$var$now = Date.now();
function $60c0c779a0799aa5$var$generateToken(i) {
    return "".concat($60c0c779a0799aa5$var$now, "_").concat(i, "_").concat($60c0c779a0799aa5$var$now);
}
function $60c0c779a0799aa5$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $60c0c779a0799aa5$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results;
}
function $60c0c779a0799aa5$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $2H3gJ.FormatError)('Intl.ListFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-listformat"\n', (0, $2H3gJ.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $8NEa0.filterProps)(options, $60c0c779a0799aa5$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === "object") {
                var id = $60c0c779a0799aa5$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === "literal" ? part : (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $lP6cc.IntlError)((0, $lP6cc.IntlErrorCode).FORMAT_ERROR, "Error formatting list.", e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("ecXhs", function(module, exports) {

$parcel$export(module.exports, "formatDisplayName", function () { return $a5802b8e5e82fef6$export$62fe1a4d9e891fa2; });

var $8NEa0 = parcelRequire("8NEa0");

var $2H3gJ = parcelRequire("2H3gJ");

var $lP6cc = parcelRequire("lP6cc");
var $a5802b8e5e82fef6$var$DISPLAY_NAMES_OPTONS = [
    "localeMatcher",
    "style",
    "type",
    "fallback"
];
function $a5802b8e5e82fef6$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $2H3gJ.FormatError)('Intl.DisplayNames is not available in this environment.\nTry polyfilling it using "@formatjs/intl-displaynames"\n', (0, $2H3gJ.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $8NEa0.filterProps)(options, $a5802b8e5e82fef6$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $lP6cc.IntlError)((0, $lP6cc.IntlErrorCode).FORMAT_ERROR, "Error formatting display name.", e));
    }
}

});


parcelRegister("ckEuy", function(module, exports) {

$parcel$export(module.exports, "isFormatXMLElementFn", function () { return $8fa6c31e154b0cdb$export$df0c12a2d414a163; });
parcelRequire("i2ZbQ");
var $jLPqv = parcelRequire("jLPqv");

var $7jcfj = parcelRequire("7jcfj");
var $8fa6c31e154b0cdb$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($8fa6c31e154b0cdb$export$49694c2877b44c57 || ($8fa6c31e154b0cdb$export$49694c2877b44c57 = {}));
function $8fa6c31e154b0cdb$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $8fa6c31e154b0cdb$export$49694c2877b44c57.literal || part.type !== $8fa6c31e154b0cdb$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $8fa6c31e154b0cdb$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $8fa6c31e154b0cdb$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $jLPqv.isLiteralElement)(els[0])) return [
        {
            type: $8fa6c31e154b0cdb$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $jLPqv.isLiteralElement)(el)) {
            result.push({
                type: $8fa6c31e154b0cdb$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $jLPqv.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $8fa6c31e154b0cdb$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $7jcfj.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $jLPqv.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $8fa6c31e154b0cdb$export$49694c2877b44c57.literal : $8fa6c31e154b0cdb$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $jLPqv.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $jLPqv.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $8fa6c31e154b0cdb$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jLPqv.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $jLPqv.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $8fa6c31e154b0cdb$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jLPqv.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $jLPqv.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $8fa6c31e154b0cdb$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jLPqv.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$8fa6c31e154b0cdb$export$df0c12a2d414a163(formatFn)) throw new (0, $7jcfj.InvalidValueTypeError)(value_1, "function", originalMessage);
            var parts = $8fa6c31e154b0cdb$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $8fa6c31e154b0cdb$export$49694c2877b44c57.literal : $8fa6c31e154b0cdb$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $jLPqv.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $7jcfj.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $8fa6c31e154b0cdb$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $jLPqv.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $7jcfj.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $7jcfj.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $7jcfj.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $8fa6c31e154b0cdb$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $8fa6c31e154b0cdb$var$mergeLiteral(result);
}

});
parcelRegister("7jcfj", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $5523ce87e02deedb$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "FormatError", function () { return $5523ce87e02deedb$export$7369836851cc1329; });
$parcel$export(module.exports, "InvalidValueError", function () { return $5523ce87e02deedb$export$565c3afc07dfa382; });
$parcel$export(module.exports, "InvalidValueTypeError", function () { return $5523ce87e02deedb$export$cbc0db47c750f7c9; });
$parcel$export(module.exports, "MissingValueError", function () { return $5523ce87e02deedb$export$8bfc137e4d23fdf0; });

var $9z2vN = parcelRequire("9z2vN");
var $5523ce87e02deedb$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($5523ce87e02deedb$export$d4e71bc0b80dc0fb || ($5523ce87e02deedb$export$d4e71bc0b80dc0fb = {}));
var $5523ce87e02deedb$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $5523ce87e02deedb$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $5523ce87e02deedb$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($5523ce87e02deedb$export$7369836851cc1329);
var $5523ce87e02deedb$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $5523ce87e02deedb$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($5523ce87e02deedb$export$7369836851cc1329);
var $5523ce87e02deedb$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $5523ce87e02deedb$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($5523ce87e02deedb$export$7369836851cc1329);

});



parcelRegister("6Rdhc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fe1fdbbd01f65a8$export$2e2bcd8739ae039; });

var $9z2vN = parcelRequire("9z2vN");

var $iSvIT = parcelRequire("iSvIT");

var $gnUbQ = parcelRequire("gnUbQ");

var $3SA17 = parcelRequire("3SA17");
var $4fe1fdbbd01f65a8$var$MINUTE = 60;
var $4fe1fdbbd01f65a8$var$HOUR = 3600;
var $4fe1fdbbd01f65a8$var$DAY = 86400;
function $4fe1fdbbd01f65a8$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $4fe1fdbbd01f65a8$var$MINUTE) return "second";
    if (absValue < $4fe1fdbbd01f65a8$var$HOUR) return "minute";
    if (absValue < $4fe1fdbbd01f65a8$var$DAY) return "hour";
    return "day";
}
function $4fe1fdbbd01f65a8$var$getDurationInSeconds(unit) {
    switch(unit){
        case "second":
            return 1;
        case "minute":
            return $4fe1fdbbd01f65a8$var$MINUTE;
        case "hour":
            return $4fe1fdbbd01f65a8$var$HOUR;
        default:
            return $4fe1fdbbd01f65a8$var$DAY;
    }
}
function $4fe1fdbbd01f65a8$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case "second":
            return value;
        case "minute":
            return value * $4fe1fdbbd01f65a8$var$MINUTE;
        default:
            return value * $4fe1fdbbd01f65a8$var$HOUR;
    }
}
var $4fe1fdbbd01f65a8$var$INCREMENTABLE_UNITS = [
    "second",
    "minute",
    "hour"
];
function $4fe1fdbbd01f65a8$var$canIncrement(unit) {
    if (unit === void 0) unit = "second";
    return $4fe1fdbbd01f65a8$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $4fe1fdbbd01f65a8$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $3SA17.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $9z2vN.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === "function") return children(formattedRelativeTime);
    if (Text) return $iSvIT.createElement(Text, null, formattedRelativeTime);
    return $iSvIT.createElement($iSvIT.Fragment, null, formattedRelativeTime);
};
var $4fe1fdbbd01f65a8$var$FormattedRelativeTime = function(_a) {
    var value = _a.value, unit = _a.unit, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $9z2vN.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $gnUbQ.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $4fe1fdbbd01f65a8$var$canIncrement(unit)), "Cannot schedule update with unit longer than hour");
    var _b = $iSvIT.useState(), prevUnit = _b[0], setPrevUnit = _b[1];
    var _c = $iSvIT.useState(0), prevValue = _c[0], setPrevValue = _c[1];
    var _d = $iSvIT.useState(0), currentValueInSeconds = _d[0], setCurrentValueInSeconds = _d[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($4fe1fdbbd01f65a8$var$canIncrement(unit) ? $4fe1fdbbd01f65a8$var$valueToSeconds(value, unit) : 0);
    }
    $iSvIT.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$4fe1fdbbd01f65a8$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $4fe1fdbbd01f65a8$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === "day") return clearUpdateTimer;
        var unitDuration = $4fe1fdbbd01f65a8$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($4fe1fdbbd01f65a8$var$canIncrement(unit) && typeof currentValueInSeconds === "number" && updateIntervalInSeconds) {
        currentUnit = $4fe1fdbbd01f65a8$var$selectUnit(currentValueInSeconds);
        var unitDuration = $4fe1fdbbd01f65a8$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $iSvIT.createElement($4fe1fdbbd01f65a8$var$SimpleFormattedRelativeTime, (0, $9z2vN.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$4fe1fdbbd01f65a8$var$FormattedRelativeTime.displayName = "FormattedRelativeTime";
$4fe1fdbbd01f65a8$var$FormattedRelativeTime.defaultProps = {
    value: 0,
    unit: "second"
};
var $4fe1fdbbd01f65a8$export$2e2bcd8739ae039 = $4fe1fdbbd01f65a8$var$FormattedRelativeTime;

});

parcelRegister("kIDVr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f156e30e0830f116$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $iSvIT = parcelRequire("iSvIT");

var $3SA17 = parcelRequire("3SA17");
var $f156e30e0830f116$var$FormattedPlural = function(props) {
    var _a = (0, $3SA17.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === "function") return children(formattedPlural);
    if (Text) return $iSvIT.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$f156e30e0830f116$var$FormattedPlural.defaultProps = {
    type: "cardinal"
};
$f156e30e0830f116$var$FormattedPlural.displayName = "FormattedPlural";
var $f156e30e0830f116$export$2e2bcd8739ae039 = $f156e30e0830f116$var$FormattedPlural;

});

parcelRegister("bKQO4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88ecf3dc322a101e$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $9z2vN = parcelRequire("9z2vN");

var $iSvIT = parcelRequire("iSvIT");

var $3SA17 = parcelRequire("3SA17");

var $5axFn = parcelRequire("5axFn");
function $88ecf3dc322a101e$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $9z2vN.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $9z2vN.__rest)(nextProps, [
        "values"
    ]);
    return (0, $5axFn.shallowEqual)(nextValues, values) && (0, $5axFn.shallowEqual)(otherProps, nextOtherProps);
}
function $88ecf3dc322a101e$var$FormattedMessage(props) {
    var intl = (0, $3SA17.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $iSvIT.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === "function") return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $iSvIT.createElement(Component, null, $iSvIT.Children.toArray(nodes));
    return $iSvIT.createElement($iSvIT.Fragment, null, nodes);
}
$88ecf3dc322a101e$var$FormattedMessage.displayName = "FormattedMessage";
var $88ecf3dc322a101e$var$MemoizedFormattedMessage = $iSvIT.memo($88ecf3dc322a101e$var$FormattedMessage, $88ecf3dc322a101e$var$areEqual);
$88ecf3dc322a101e$var$MemoizedFormattedMessage.displayName = "MemoizedFormattedMessage";
var $88ecf3dc322a101e$export$2e2bcd8739ae039 = $88ecf3dc322a101e$var$MemoizedFormattedMessage;

});

parcelRegister("kEtPr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f08eae695db8f9f3$export$2e2bcd8739ae039; });

var $9z2vN = parcelRequire("9z2vN");

var $iSvIT = parcelRequire("iSvIT");

var $3SA17 = parcelRequire("3SA17");
var $f08eae695db8f9f3$var$FormattedDateTimeRange = function(props) {
    var intl = (0, $3SA17.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = (0, $9z2vN.__rest)(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === "function") return children(formattedValue);
    var Text = intl.textComponent || $iSvIT.Fragment;
    return $iSvIT.createElement(Text, null, formattedValue);
};
$f08eae695db8f9f3$var$FormattedDateTimeRange.displayName = "FormattedDateTimeRange";
var $f08eae695db8f9f3$export$2e2bcd8739ae039 = $f08eae695db8f9f3$var$FormattedDateTimeRange;

});


parcelRegister("4hU6i", function(module, exports) {

$parcel$export(module.exports, "J", function () { return $31f4445e1a7a95b7$export$b4171a6734a65d42; });
$parcel$export(module.exports, "E", function () { return $31f4445e1a7a95b7$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "H", function () { return $31f4445e1a7a95b7$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "G", function () { return $31f4445e1a7a95b7$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "I", function () { return $31f4445e1a7a95b7$export$9bb611d729802a56; });
$parcel$export(module.exports, "z", function () { return $31f4445e1a7a95b7$export$df995fae86a55f06; });
$parcel$export(module.exports, "A", function () { return $31f4445e1a7a95b7$export$ebd11618f299a286; });
$parcel$export(module.exports, "s", function () { return $31f4445e1a7a95b7$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "K", function () { return $31f4445e1a7a95b7$export$3466f893ebf79586; });
$parcel$export(module.exports, "D", function () { return $31f4445e1a7a95b7$export$96f57966bedc81b4; });
$parcel$export(module.exports, "C", function () { return $31f4445e1a7a95b7$export$e7094788287c5e9b; });
$parcel$export(module.exports, "B", function () { return $31f4445e1a7a95b7$export$ef35774e6d314e91; });
$parcel$export(module.exports, "r", function () { return $31f4445e1a7a95b7$export$43caf9889c228507; });
$parcel$export(module.exports, "m", function () { return $31f4445e1a7a95b7$export$953cecd6e717a553; });
$parcel$export(module.exports, "M", function () { return $31f4445e1a7a95b7$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "n", function () { return $31f4445e1a7a95b7$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "u", function () { return $31f4445e1a7a95b7$export$3b14a55fb2447963; });
$parcel$export(module.exports, "k", function () { return $31f4445e1a7a95b7$export$342063e11d6c3cad; });
$parcel$export(module.exports, "o", function () { return $31f4445e1a7a95b7$export$ae1af26003f05816; });
$parcel$export(module.exports, "b", function () { return $31f4445e1a7a95b7$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "y", function () { return $31f4445e1a7a95b7$export$4a5767248b18ef41; });
$parcel$export(module.exports, "i", function () { return $31f4445e1a7a95b7$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "e", function () { return $31f4445e1a7a95b7$export$f1e1789686576879; });
$parcel$export(module.exports, "a", function () { return $31f4445e1a7a95b7$export$407448d2b89b1813; });
$parcel$export(module.exports, "h", function () { return $31f4445e1a7a95b7$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "l", function () { return $31f4445e1a7a95b7$export$882b5998b3b9117c; });
$parcel$export(module.exports, "d", function () { return $31f4445e1a7a95b7$export$4368d992c4eafac0; });
$parcel$export(module.exports, "g", function () { return $31f4445e1a7a95b7$export$39b482c5e57630a8; });
$parcel$export(module.exports, "f", function () { return $31f4445e1a7a95b7$export$2d1720544b23b823; });
$parcel$export(module.exports, "j", function () { return $31f4445e1a7a95b7$export$35e795649ee09318; });
$parcel$export(module.exports, "p", function () { return $31f4445e1a7a95b7$export$ffb5f4729a158638; });
$parcel$export(module.exports, "q", function () { return $31f4445e1a7a95b7$export$9e5f44173e64f162; });
$parcel$export(module.exports, "t", function () { return $31f4445e1a7a95b7$export$625550452a3fa3ec; });
$parcel$export(module.exports, "v", function () { return $31f4445e1a7a95b7$export$90a7f3efeed30595; });
$parcel$export(module.exports, "w", function () { return $31f4445e1a7a95b7$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "x", function () { return $31f4445e1a7a95b7$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "c", function () { return $31f4445e1a7a95b7$export$db3b6bfb95261072; });
$parcel$export(module.exports, "F", function () { return $31f4445e1a7a95b7$export$d66501df72047452; });

var $k5N0O = parcelRequire("k5N0O");

var $fBUaU = parcelRequire("fBUaU");

var $2ZUkg = parcelRequire("2ZUkg");

var $9yUBC = parcelRequire("9yUBC");

var $h57BE = parcelRequire("h57BE");

var $hFz8f = parcelRequire("hFz8f");

var $5kd3B = parcelRequire("5kd3B");

var $1K5Eh = parcelRequire("1K5Eh");

var $iSvIT = parcelRequire("iSvIT");

var $i5UxU = parcelRequire("i5UxU");

var $24DUy = parcelRequire("24DUy");

var $3fOxZ = parcelRequire("3fOxZ");
var $31f4445e1a7a95b7$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $31f4445e1a7a95b7$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $31f4445e1a7a95b7$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $31f4445e1a7a95b7$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($31f4445e1a7a95b7$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
// ==============================
// Clean Value
// ==============================
var $31f4445e1a7a95b7$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($31f4445e1a7a95b7$var$isArray(value)) return value.filter(Boolean);
    if ((0, $hFz8f.default)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $31f4445e1a7a95b7$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $h57BE.default)(props, $31f4445e1a7a95b7$var$_excluded$4);
    return (0, $k5N0O.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $31f4445e1a7a95b7$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $31f4445e1a7a95b7$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $31f4445e1a7a95b7$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $31f4445e1a7a95b7$var$normalizedHeight(el) {
    if ($31f4445e1a7a95b7$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $31f4445e1a7a95b7$var$getScrollTop(el) {
    if ($31f4445e1a7a95b7$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $31f4445e1a7a95b7$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($31f4445e1a7a95b7$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $31f4445e1a7a95b7$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $31f4445e1a7a95b7$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $31f4445e1a7a95b7$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $31f4445e1a7a95b7$export$b4171a6734a65d42;
    var start = $31f4445e1a7a95b7$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $31f4445e1a7a95b7$var$easeOutCubic(currentTime, start, change, duration);
        $31f4445e1a7a95b7$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $31f4445e1a7a95b7$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $31f4445e1a7a95b7$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $31f4445e1a7a95b7$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $31f4445e1a7a95b7$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $31f4445e1a7a95b7$export$df995fae86a55f06() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $31f4445e1a7a95b7$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $31f4445e1a7a95b7$var$passiveOptionAccessed = false;
var $31f4445e1a7a95b7$var$options = {
    get passive () {
        return $31f4445e1a7a95b7$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $31f4445e1a7a95b7$var$w = typeof window !== "undefined" ? window : {};
if ($31f4445e1a7a95b7$var$w.addEventListener && $31f4445e1a7a95b7$var$w.removeEventListener) {
    $31f4445e1a7a95b7$var$w.addEventListener("p", $31f4445e1a7a95b7$export$b4171a6734a65d42, $31f4445e1a7a95b7$var$options);
    $31f4445e1a7a95b7$var$w.removeEventListener("p", $31f4445e1a7a95b7$export$b4171a6734a65d42, false);
}
var $31f4445e1a7a95b7$export$2408f22a0fab9ae5 = $31f4445e1a7a95b7$var$passiveOptionAccessed;
function $31f4445e1a7a95b7$export$3466f893ebf79586(item) {
    return item != null;
}
function $31f4445e1a7a95b7$var$isArray(arg) {
    return Array.isArray(arg);
}
function $31f4445e1a7a95b7$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $31f4445e1a7a95b7$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $31f4445e1a7a95b7$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $31f4445e1a7a95b7$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $9yUBC.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $9yUBC.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $31f4445e1a7a95b7$var$_excluded$3 = [
    "children",
    "innerProps"
], $31f4445e1a7a95b7$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $31f4445e1a7a95b7$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $31f4445e1a7a95b7$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $31f4445e1a7a95b7$var$normalizedHeight(scrollParent);
    var scrollTop = $31f4445e1a7a95b7$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $31f4445e1a7a95b7$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $31f4445e1a7a95b7$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) $31f4445e1a7a95b7$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $31f4445e1a7a95b7$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $31f4445e1a7a95b7$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $31f4445e1a7a95b7$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $31f4445e1a7a95b7$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $31f4445e1a7a95b7$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $k5N0O.default)((_objectSpread2 = {
        label: "menu"
    }, (0, $1K5Eh.default)(_objectSpread2, $31f4445e1a7a95b7$var$alignToControl(placement), "100%"), (0, $1K5Eh.default)(_objectSpread2, "position", "absolute"), (0, $1K5Eh.default)(_objectSpread2, "width", "100%"), (0, $1K5Eh.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $31f4445e1a7a95b7$var$PortalPlacementContext = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
// NOTE: internal only
var $31f4445e1a7a95b7$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $iSvIT.useContext)($31f4445e1a7a95b7$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $iSvIT.useRef)(null);
    var _useState = (0, $iSvIT.useState)(maxMenuHeight), _useState2 = (0, $9yUBC.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)(null), _useState4 = (0, $9yUBC.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $3fOxZ.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $31f4445e1a7a95b7$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $k5N0O.default)((0, $k5N0O.default)({}, props), {}, {
            placement: placement || $31f4445e1a7a95b7$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $31f4445e1a7a95b7$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "menu", {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $31f4445e1a7a95b7$var$Menu$1 = $31f4445e1a7a95b7$var$Menu;
// ==============================
// Menu List
// ==============================
var $31f4445e1a7a95b7$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $k5N0O.default)({
        maxHeight: maxHeight,
        overflowY: "auto",
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $31f4445e1a7a95b7$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $31f4445e1a7a95b7$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $k5N0O.default)({
        textAlign: "center"
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $31f4445e1a7a95b7$export$3b14a55fb2447963 = $31f4445e1a7a95b7$var$noticeCSS;
var $31f4445e1a7a95b7$export$342063e11d6c3cad = $31f4445e1a7a95b7$var$noticeCSS;
var $31f4445e1a7a95b7$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $h57BE.default)(_ref6, $31f4445e1a7a95b7$var$_excluded$3);
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps((0, $k5N0O.default)((0, $k5N0O.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), innerProps), children);
};
var $31f4445e1a7a95b7$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $h57BE.default)(_ref7, $31f4445e1a7a95b7$var$_excluded2$1);
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps((0, $k5N0O.default)((0, $k5N0O.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $31f4445e1a7a95b7$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $31f4445e1a7a95b7$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $iSvIT.useRef)(null);
    var cleanupRef = (0, $iSvIT.useRef)(null);
    var _useState5 = (0, $iSvIT.useState)($31f4445e1a7a95b7$var$coercePlacement(menuPlacement)), _useState6 = (0, $9yUBC.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $iSvIT.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $iSvIT.useState)(null), _useState8 = (0, $9yUBC.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $iSvIT.useCallback)(function() {
        if (!controlElement) return;
        var rect = $31f4445e1a7a95b7$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $3fOxZ.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $iSvIT.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $24DUy.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $3fOxZ.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $iSvIT.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({
        ref: setMenuPortalElement
    }, $31f4445e1a7a95b7$var$getStyleProps((0, $k5N0O.default)((0, $k5N0O.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), innerProps), children);
    return (0, $2ZUkg.jsx)($31f4445e1a7a95b7$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $i5UxU.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $31f4445e1a7a95b7$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $31f4445e1a7a95b7$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $31f4445e1a7a95b7$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $k5N0O.default)({
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $31f4445e1a7a95b7$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $31f4445e1a7a95b7$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $31f4445e1a7a95b7$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "indicatorsContainer", {
        indicators: true
    }), innerProps), children);
};
var $31f4445e1a7a95b7$var$_templateObject;
var $31f4445e1a7a95b7$var$_excluded$2 = [
    "size"
], $31f4445e1a7a95b7$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $31f4445e1a7a95b7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $31f4445e1a7a95b7$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $31f4445e1a7a95b7$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $h57BE.default)(_ref, $31f4445e1a7a95b7$var$_excluded$2);
    return (0, $2ZUkg.jsx)("svg", (0, $fBUaU.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $31f4445e1a7a95b7$var$_ref2
    }, props));
};
var $31f4445e1a7a95b7$var$CrossIcon = function CrossIcon(props) {
    return (0, $2ZUkg.jsx)($31f4445e1a7a95b7$var$Svg, (0, $fBUaU.default)({
        size: 20
    }, props), (0, $2ZUkg.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $31f4445e1a7a95b7$var$DownChevron = function DownChevron(props) {
    return (0, $2ZUkg.jsx)($31f4445e1a7a95b7$var$Svg, (0, $fBUaU.default)({
        size: 20
    }, props), (0, $2ZUkg.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $31f4445e1a7a95b7$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $k5N0O.default)({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $31f4445e1a7a95b7$export$f1e1789686576879 = $31f4445e1a7a95b7$var$baseCSS;
var $31f4445e1a7a95b7$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), innerProps), children || (0, $2ZUkg.jsx)($31f4445e1a7a95b7$var$DownChevron, null));
};
var $31f4445e1a7a95b7$export$407448d2b89b1813 = $31f4445e1a7a95b7$var$baseCSS;
var $31f4445e1a7a95b7$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), innerProps), children || (0, $2ZUkg.jsx)($31f4445e1a7a95b7$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $31f4445e1a7a95b7$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $k5N0O.default)({
        label: "indicatorSeparator",
        alignSelf: "stretch",
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $31f4445e1a7a95b7$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $2ZUkg.jsx)("span", (0, $fBUaU.default)({}, innerProps, $31f4445e1a7a95b7$var$getStyleProps(props, "indicatorSeparator", {
        "indicator-separator": true
    })));
};
// ==============================
// Loading
// ==============================
var $31f4445e1a7a95b7$var$loadingDotAnimations = (0, $2ZUkg.keyframes)($31f4445e1a7a95b7$var$_templateObject || ($31f4445e1a7a95b7$var$_templateObject = (0, $5kd3B.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $31f4445e1a7a95b7$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $k5N0O.default)({
        label: "loadingIndicator",
        display: "flex",
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $31f4445e1a7a95b7$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $2ZUkg.jsx)("span", {
        css: /*#__PURE__*/ (0, $2ZUkg.css)({
            animation: "".concat($31f4445e1a7a95b7$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "", "")
    });
};
var $31f4445e1a7a95b7$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $h57BE.default)(_ref7, $31f4445e1a7a95b7$var$_excluded2);
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps((0, $k5N0O.default)((0, $k5N0O.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), innerProps), (0, $2ZUkg.jsx)($31f4445e1a7a95b7$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $2ZUkg.jsx)($31f4445e1a7a95b7$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $2ZUkg.jsx)($31f4445e1a7a95b7$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $31f4445e1a7a95b7$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $k5N0O.default)({
        label: "control",
        alignItems: "center",
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms"
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $31f4445e1a7a95b7$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({
        ref: innerRef
    }, $31f4445e1a7a95b7$var$getStyleProps(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $31f4445e1a7a95b7$var$Control$1 = $31f4445e1a7a95b7$var$Control;
var $31f4445e1a7a95b7$var$_excluded$1 = [
    "data"
];
var $31f4445e1a7a95b7$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $31f4445e1a7a95b7$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "group", {
        group: true
    }), innerProps), (0, $2ZUkg.jsx)(Heading, (0, $fBUaU.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $2ZUkg.jsx)("div", null, children));
};
var $31f4445e1a7a95b7$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $k5N0O.default)({
        label: "group",
        cursor: "default",
        display: "block"
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    });
};
var $31f4445e1a7a95b7$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $31f4445e1a7a95b7$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $h57BE.default)(_cleanCommonProps, $31f4445e1a7a95b7$var$_excluded$1);
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "groupHeading", {
        "group-heading": true
    }), innerProps));
};
var $31f4445e1a7a95b7$var$Group$1 = $31f4445e1a7a95b7$var$Group;
var $31f4445e1a7a95b7$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $31f4445e1a7a95b7$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $k5N0O.default)((0, $k5N0O.default)({
        visibility: isDisabled ? "hidden" : "visible",
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, $31f4445e1a7a95b7$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $31f4445e1a7a95b7$var$spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $31f4445e1a7a95b7$var$containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": (0, $k5N0O.default)({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, $31f4445e1a7a95b7$var$spacingStyle)
};
var $31f4445e1a7a95b7$var$inputStyle = function inputStyle(isHidden) {
    return (0, $k5N0O.default)({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, $31f4445e1a7a95b7$var$spacingStyle);
};
var $31f4445e1a7a95b7$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $31f4445e1a7a95b7$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $h57BE.default)(_cleanCommonProps, $31f4445e1a7a95b7$var$_excluded);
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "input", {
        "input-container": true
    }), {
        "data-value": value || ""
    }), (0, $2ZUkg.jsx)("input", (0, $fBUaU.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $31f4445e1a7a95b7$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $31f4445e1a7a95b7$var$Input$1 = $31f4445e1a7a95b7$var$Input;
var $31f4445e1a7a95b7$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $k5N0O.default)({
        label: "multiValue",
        display: "flex",
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $31f4445e1a7a95b7$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $k5N0O.default)({
        overflow: "hidden",
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        padding: 3,
        paddingLeft: 6
    });
};
var $31f4445e1a7a95b7$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $k5N0O.default)({
        alignItems: "center",
        display: "flex"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $31f4445e1a7a95b7$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $2ZUkg.jsx)("div", innerProps, children);
};
var $31f4445e1a7a95b7$var$MultiValueContainer = $31f4445e1a7a95b7$var$MultiValueGeneric;
var $31f4445e1a7a95b7$var$MultiValueLabel = $31f4445e1a7a95b7$var$MultiValueGeneric;
function $31f4445e1a7a95b7$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({
        role: "button"
    }, innerProps), children || (0, $2ZUkg.jsx)($31f4445e1a7a95b7$var$CrossIcon, {
        size: 14
    }));
}
var $31f4445e1a7a95b7$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $2ZUkg.jsx)(Container, {
        data: data,
        innerProps: (0, $k5N0O.default)((0, $k5N0O.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "multiValue", {
            "multi-value": true,
            "multi-value--is-disabled": isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $2ZUkg.jsx)(Label, {
        data: data,
        innerProps: (0, $k5N0O.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "multiValueLabel", {
            "multi-value__label": true
        })),
        selectProps: selectProps
    }, children), (0, $2ZUkg.jsx)(Remove, {
        data: data,
        innerProps: (0, $k5N0O.default)((0, $k5N0O.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "multiValueRemove", {
            "multi-value__remove": true
        })), {}, {
            "aria-label": "Remove ".concat(children || "option")
        }, removeProps),
        selectProps: selectProps
    }));
};
var $31f4445e1a7a95b7$var$MultiValue$1 = $31f4445e1a7a95b7$var$MultiValue;
var $31f4445e1a7a95b7$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $k5N0O.default)({
        label: "option",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $31f4445e1a7a95b7$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $31f4445e1a7a95b7$var$Option$1 = $31f4445e1a7a95b7$var$Option;
var $31f4445e1a7a95b7$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $k5N0O.default)({
        label: "placeholder",
        gridArea: "1 / 1 / 2 / 3"
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $31f4445e1a7a95b7$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "placeholder", {
        placeholder: true
    }), innerProps), children);
};
var $31f4445e1a7a95b7$var$Placeholder$1 = $31f4445e1a7a95b7$var$Placeholder;
var $31f4445e1a7a95b7$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $k5N0O.default)({
        label: "singleValue",
        gridArea: "1 / 1 / 2 / 3",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $31f4445e1a7a95b7$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), innerProps), children);
};
var $31f4445e1a7a95b7$var$SingleValue$1 = $31f4445e1a7a95b7$var$SingleValue;
var $31f4445e1a7a95b7$export$db3b6bfb95261072 = {
    ClearIndicator: $31f4445e1a7a95b7$var$ClearIndicator,
    Control: $31f4445e1a7a95b7$var$Control$1,
    DropdownIndicator: $31f4445e1a7a95b7$var$DropdownIndicator,
    DownChevron: $31f4445e1a7a95b7$var$DownChevron,
    CrossIcon: $31f4445e1a7a95b7$var$CrossIcon,
    Group: $31f4445e1a7a95b7$var$Group$1,
    GroupHeading: $31f4445e1a7a95b7$var$GroupHeading,
    IndicatorsContainer: $31f4445e1a7a95b7$var$IndicatorsContainer,
    IndicatorSeparator: $31f4445e1a7a95b7$var$IndicatorSeparator,
    Input: $31f4445e1a7a95b7$var$Input$1,
    LoadingIndicator: $31f4445e1a7a95b7$var$LoadingIndicator,
    Menu: $31f4445e1a7a95b7$var$Menu$1,
    MenuList: $31f4445e1a7a95b7$var$MenuList,
    MenuPortal: $31f4445e1a7a95b7$var$MenuPortal,
    LoadingMessage: $31f4445e1a7a95b7$var$LoadingMessage,
    NoOptionsMessage: $31f4445e1a7a95b7$var$NoOptionsMessage,
    MultiValue: $31f4445e1a7a95b7$var$MultiValue$1,
    MultiValueContainer: $31f4445e1a7a95b7$var$MultiValueContainer,
    MultiValueLabel: $31f4445e1a7a95b7$var$MultiValueLabel,
    MultiValueRemove: $31f4445e1a7a95b7$var$MultiValueRemove,
    Option: $31f4445e1a7a95b7$var$Option$1,
    Placeholder: $31f4445e1a7a95b7$var$Placeholder$1,
    SelectContainer: $31f4445e1a7a95b7$var$SelectContainer,
    SingleValue: $31f4445e1a7a95b7$var$SingleValue$1,
    ValueContainer: $31f4445e1a7a95b7$var$ValueContainer
};
var $31f4445e1a7a95b7$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $k5N0O.default)((0, $k5N0O.default)({}, $31f4445e1a7a95b7$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("k5N0O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea0a4b0ecd424301$export$2e2bcd8739ae039; });

var $1K5Eh = parcelRequire("1K5Eh");
function $ea0a4b0ecd424301$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ea0a4b0ecd424301$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ea0a4b0ecd424301$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1K5Eh.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ea0a4b0ecd424301$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("1K5Eh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $144e78021ed09269$export$2e2bcd8739ae039; });

var $ienzO = parcelRequire("ienzO");
function $144e78021ed09269$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $ienzO.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("ienzO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d45bd29c3cab7e22$export$2e2bcd8739ae039; });

var $hFz8f = parcelRequire("hFz8f");

var $hN9gc = parcelRequire("hN9gc");
function $d45bd29c3cab7e22$export$2e2bcd8739ae039(t) {
    var i = (0, $hN9gc.default)(t, "string");
    return "symbol" == (0, $hFz8f.default)(i) ? i : i + "";
}

});
parcelRegister("hFz8f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdd184807c7256a2$export$2e2bcd8739ae039; });
function $cdd184807c7256a2$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $cdd184807c7256a2$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cdd184807c7256a2$export$2e2bcd8739ae039(o);
}

});

parcelRegister("hN9gc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf3e32264207fb02$export$2e2bcd8739ae039; });

var $hFz8f = parcelRequire("hFz8f");
function $cf3e32264207fb02$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $hFz8f.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $hFz8f.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("fBUaU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5d5e2e3743d6f8c$export$2e2bcd8739ae039; });
function $b5d5e2e3743d6f8c$export$2e2bcd8739ae039() {
    return $b5d5e2e3743d6f8c$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b5d5e2e3743d6f8c$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("9yUBC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f6332c376dd6780$export$2e2bcd8739ae039; });

var $8mMqI = parcelRequire("8mMqI");

var $cph43 = parcelRequire("cph43");

var $iHw5C = parcelRequire("iHw5C");

var $K3kP2 = parcelRequire("K3kP2");
function $6f6332c376dd6780$export$2e2bcd8739ae039(r, e) {
    return (0, $8mMqI.default)(r) || (0, $cph43.default)(r, e) || (0, $iHw5C.default)(r, e) || (0, $K3kP2.default)();
}

});
parcelRegister("8mMqI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6175f1fa848fa622$export$2e2bcd8739ae039; });
function $6175f1fa848fa622$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("cph43", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0254ba0a48c97bf5$export$2e2bcd8739ae039; });
function $0254ba0a48c97bf5$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("iHw5C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9d52280c9139c51$export$2e2bcd8739ae039; });

var $6HmTm = parcelRequire("6HmTm");
function $d9d52280c9139c51$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $6HmTm.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $6HmTm.default)(r, a) : void 0;
    }
}

});
parcelRegister("6HmTm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e088415cc1df056$export$2e2bcd8739ae039; });
function $4e088415cc1df056$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("K3kP2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08a6e239054ef01d$export$2e2bcd8739ae039; });
function $08a6e239054ef01d$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("h57BE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6f8cdc328676ca9$export$2e2bcd8739ae039; });

var $44FMd = parcelRequire("44FMd");
function $c6f8cdc328676ca9$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $44FMd.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("44FMd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f77f1228a691b81$export$2e2bcd8739ae039; });
function $2f77f1228a691b81$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("5kd3B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e08f2e494357ce8$export$2e2bcd8739ae039; });
function $3e08f2e494357ce8$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("24DUy", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", function () { return $8d1ccc98aa9166ca$export$deee3a793edee05f; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");
parcelRequire("kSdhf");
var $ft7ke = parcelRequire("ft7ke");
var $kSdhf = parcelRequire("kSdhf");

var $ft7ke = parcelRequire("ft7ke");

var $1aw9F = parcelRequire("1aw9F");
function $8d1ccc98aa9166ca$var$getCssDimensions(element) {
    const css = (0, $1aw9F.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $1aw9F.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $ft7ke.round)(width) !== offsetWidth || (0, $ft7ke.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $8d1ccc98aa9166ca$var$unwrapElement(element) {
    return !(0, $1aw9F.isElement)(element) ? element.contextElement : element;
}
function $8d1ccc98aa9166ca$var$getScale(element) {
    const domElement = $8d1ccc98aa9166ca$var$unwrapElement(element);
    if (!(0, $1aw9F.isHTMLElement)(domElement)) return (0, $ft7ke.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $8d1ccc98aa9166ca$var$getCssDimensions(domElement);
    let x = ($ ? (0, $ft7ke.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $ft7ke.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $8d1ccc98aa9166ca$var$noOffsets = /*#__PURE__*/ (0, $ft7ke.createCoords)(0);
function $8d1ccc98aa9166ca$var$getVisualOffsets(element) {
    const win = (0, $1aw9F.getWindow)(element);
    if (!(0, $1aw9F.isWebKit)() || !win.visualViewport) return $8d1ccc98aa9166ca$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $8d1ccc98aa9166ca$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $1aw9F.getWindow)(element)) return false;
    return isFixed;
}
function $8d1ccc98aa9166ca$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $8d1ccc98aa9166ca$var$unwrapElement(element);
    let scale = (0, $ft7ke.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $1aw9F.isElement)(offsetParent)) scale = $8d1ccc98aa9166ca$var$getScale(offsetParent);
        } else scale = $8d1ccc98aa9166ca$var$getScale(element);
    }
    const visualOffsets = $8d1ccc98aa9166ca$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $8d1ccc98aa9166ca$var$getVisualOffsets(domElement) : (0, $ft7ke.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $1aw9F.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $1aw9F.isElement)(offsetParent) ? (0, $1aw9F.getWindow)(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $8d1ccc98aa9166ca$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $1aw9F.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = (0, $1aw9F.getWindow)(currentIFrame).frameElement;
        }
    }
    return (0, $ft7ke.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $8d1ccc98aa9166ca$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = (0, $1aw9F.isHTMLElement)(offsetParent);
    const documentElement = (0, $1aw9F.getDocumentElement)(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $ft7ke.createCoords)(1);
    const offsets = (0, $ft7ke.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ((0, $1aw9F.getNodeName)(offsetParent) !== "body" || (0, $1aw9F.isOverflowElement)(documentElement)) scroll = (0, $1aw9F.getNodeScroll)(offsetParent);
        if ((0, $1aw9F.isHTMLElement)(offsetParent)) {
            const offsetRect = $8d1ccc98aa9166ca$var$getBoundingClientRect(offsetParent);
            scale = $8d1ccc98aa9166ca$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $8d1ccc98aa9166ca$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $8d1ccc98aa9166ca$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $8d1ccc98aa9166ca$var$getBoundingClientRect((0, $1aw9F.getDocumentElement)(element)).left + (0, $1aw9F.getNodeScroll)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $8d1ccc98aa9166ca$var$getDocumentRect(element) {
    const html = (0, $1aw9F.getDocumentElement)(element);
    const scroll = (0, $1aw9F.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $ft7ke.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $ft7ke.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $8d1ccc98aa9166ca$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $1aw9F.getComputedStyle)(body).direction === "rtl") x += (0, $ft7ke.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $8d1ccc98aa9166ca$var$getViewportRect(element, strategy) {
    const win = (0, $1aw9F.getWindow)(element);
    const html = (0, $1aw9F.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $1aw9F.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $8d1ccc98aa9166ca$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $8d1ccc98aa9166ca$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $1aw9F.isHTMLElement)(element) ? $8d1ccc98aa9166ca$var$getScale(element) : (0, $ft7ke.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $8d1ccc98aa9166ca$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $8d1ccc98aa9166ca$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $8d1ccc98aa9166ca$var$getDocumentRect((0, $1aw9F.getDocumentElement)(element));
    else if ((0, $1aw9F.isElement)(clippingAncestor)) rect = $8d1ccc98aa9166ca$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $8d1ccc98aa9166ca$var$getVisualOffsets(element);
        rect = (0, $6iHNw._)((0, $7Knp0._)({}, clippingAncestor), {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        });
    }
    return (0, $ft7ke.rectToClientRect)(rect);
}
function $8d1ccc98aa9166ca$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $1aw9F.getParentNode)(element);
    if (parentNode === stopNode || !(0, $1aw9F.isElement)(parentNode) || (0, $1aw9F.isLastTraversableNode)(parentNode)) return false;
    return (0, $1aw9F.getComputedStyle)(parentNode).position === "fixed" || $8d1ccc98aa9166ca$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $8d1ccc98aa9166ca$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $1aw9F.getOverflowAncestors)(element, [], false).filter((el)=>(0, $1aw9F.isElement)(el) && (0, $1aw9F.getNodeName)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $1aw9F.getComputedStyle)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $1aw9F.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $1aw9F.isElement)(currentNode) && !(0, $1aw9F.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $1aw9F.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $1aw9F.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $1aw9F.isOverflowElement)(currentNode) && !currentNodeIsContaining && $8d1ccc98aa9166ca$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $1aw9F.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $8d1ccc98aa9166ca$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $8d1ccc98aa9166ca$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $8d1ccc98aa9166ca$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $ft7ke.max)(rect.top, accRect.top);
        accRect.right = (0, $ft7ke.min)(rect.right, accRect.right);
        accRect.bottom = (0, $ft7ke.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $ft7ke.max)(rect.left, accRect.left);
        return accRect;
    }, $8d1ccc98aa9166ca$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $8d1ccc98aa9166ca$var$getDimensions(element) {
    return $8d1ccc98aa9166ca$var$getCssDimensions(element);
}
function $8d1ccc98aa9166ca$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $1aw9F.isHTMLElement)(offsetParent);
    const documentElement = (0, $1aw9F.getDocumentElement)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $8d1ccc98aa9166ca$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $ft7ke.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1aw9F.getNodeName)(offsetParent) !== "body" || (0, $1aw9F.isOverflowElement)(documentElement)) scroll = (0, $1aw9F.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $8d1ccc98aa9166ca$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $8d1ccc98aa9166ca$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $8d1ccc98aa9166ca$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $1aw9F.isHTMLElement)(element) || (0, $1aw9F.getComputedStyle)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $8d1ccc98aa9166ca$var$getOffsetParent(element, polyfill) {
    const window = (0, $1aw9F.getWindow)(element);
    if (!(0, $1aw9F.isHTMLElement)(element)) return window;
    let offsetParent = $8d1ccc98aa9166ca$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $1aw9F.isTableElement)(offsetParent) && (0, $1aw9F.getComputedStyle)(offsetParent).position === "static")offsetParent = $8d1ccc98aa9166ca$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $1aw9F.getNodeName)(offsetParent) === "html" || (0, $1aw9F.getNodeName)(offsetParent) === "body" && (0, $1aw9F.getComputedStyle)(offsetParent).position === "static" && !(0, $1aw9F.isContainingBlock)(offsetParent))) return window;
    return offsetParent || (0, $1aw9F.getContainingBlock)(element) || window;
}
const $8d1ccc98aa9166ca$var$getElementRects = async function(_ref) {
    let { reference: reference, floating: floating, strategy: strategy } = _ref;
    const getOffsetParentFn = this.getOffsetParent || $8d1ccc98aa9166ca$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $8d1ccc98aa9166ca$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
        floating: (0, $7Knp0._)({
            x: 0,
            y: 0
        }, await getDimensionsFn(floating))
    };
};
function $8d1ccc98aa9166ca$var$isRTL(element) {
    return (0, $1aw9F.getComputedStyle)(element).direction === "rtl";
}
const $8d1ccc98aa9166ca$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $8d1ccc98aa9166ca$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $1aw9F.getDocumentElement,
    getClippingRect: $8d1ccc98aa9166ca$var$getClippingRect,
    getOffsetParent: $8d1ccc98aa9166ca$var$getOffsetParent,
    getElementRects: $8d1ccc98aa9166ca$var$getElementRects,
    getClientRects: $8d1ccc98aa9166ca$var$getClientRects,
    getDimensions: $8d1ccc98aa9166ca$var$getDimensions,
    getScale: $8d1ccc98aa9166ca$var$getScale,
    isElement: $1aw9F.isElement,
    isRTL: $8d1ccc98aa9166ca$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $8d1ccc98aa9166ca$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $1aw9F.getDocumentElement)(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $ft7ke.floor)(top);
        const insetRight = (0, $ft7ke.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $ft7ke.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $ft7ke.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $ft7ke.max)(0, (0, $ft7ke.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, (0, $6iHNw._)((0, $7Knp0._)({}, options), {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $8d1ccc98aa9166ca$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $8d1ccc98aa9166ca$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $1aw9F.getOverflowAncestors)(referenceEl) : [],
        ...(0, $1aw9F.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $8d1ccc98aa9166ca$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $8d1ccc98aa9166ca$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $8d1ccc98aa9166ca$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $8d1ccc98aa9166ca$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = (0, $7Knp0._)({
        platform: $8d1ccc98aa9166ca$export$722a64dea1b767dc
    }, options);
    const platformWithCache = (0, $6iHNw._)((0, $7Knp0._)({}, mergedOptions.platform), {
        _c: cache
    });
    return (0, $kSdhf.computePosition)(reference, floating, (0, $6iHNw._)((0, $7Knp0._)({}, mergedOptions), {
        platform: platformWithCache
    }));
};

});
parcelRegister("kSdhf", function(module, exports) {

$parcel$export(module.exports, "computePosition", function () { return $9a5214747241b192$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "rectToClientRect", function () { return (parcelRequire("ft7ke")).rectToClientRect; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $ft7ke = parcelRequire("ft7ke");
function $9a5214747241b192$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $ft7ke.getSideAxis)(placement);
    const alignmentAxis = (0, $ft7ke.getAlignmentAxis)(placement);
    const alignLength = (0, $ft7ke.getAxisLength)(alignmentAxis);
    const side = (0, $ft7ke.getSide)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $ft7ke.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $9a5214747241b192$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $9a5214747241b192$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = (0, $6iHNw._)((0, $7Knp0._)({}, middlewareData), {
            [name]: (0, $7Knp0._)({}, middlewareData[name], data)
        });
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $9a5214747241b192$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $9a5214747241b192$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $ft7ke.evaluate)(options, state);
    const paddingObject = (0, $ft7ke.getPaddingObject)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $ft7ke.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? (0, $6iHNw._)((0, $7Knp0._)({}, rects.floating), {
        x: x,
        y: y
    }) : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $ft7ke.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9a5214747241b192$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $ft7ke.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $ft7ke.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $ft7ke.getAlignmentAxis)(placement);
            const length = (0, $ft7ke.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $ft7ke.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $ft7ke.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $ft7ke.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $ft7ke.getAlignment)(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: (0, $7Knp0._)({
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset
                }, shouldAddOffset && {
                    alignmentOffset: alignmentOffset
                }),
                reset: shouldAddOffset
            };
        }
    });
function $9a5214747241b192$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $ft7ke.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $ft7ke.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $ft7ke.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $ft7ke.getAlignment)(placement) === alignment || (autoAlignment ? (0, $ft7ke.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9a5214747241b192$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const _evaluate = (0, $ft7ke.evaluate)(options, state), { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $ft7ke.placements), autoAlignment: autoAlignment = true } = _evaluate, detectOverflowOptions = (0, $akGnX._)(_evaluate, [
                "crossAxis",
                "alignment",
                "allowedPlacements",
                "autoAlignment"
            ]);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $ft7ke.placements) ? $9a5214747241b192$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $9a5214747241b192$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $ft7ke.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $ft7ke.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $ft7ke.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $ft7ke.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9a5214747241b192$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const _evaluate = (0, $ft7ke.evaluate)(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true } = _evaluate, detectOverflowOptions = (0, $akGnX._)(_evaluate, [
                "mainAxis",
                "crossAxis",
                "fallbackPlacements",
                "fallbackStrategy",
                "fallbackAxisSideDirection",
                "flipAlignment"
            ]);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $ft7ke.getSide)(placement);
            const isBasePlacement = (0, $ft7ke.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $ft7ke.getOppositePlacement)(initialPlacement)
            ] : (0, $ft7ke.getExpandedPlacements)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $ft7ke.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $9a5214747241b192$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $ft7ke.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $9a5214747241b192$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $9a5214747241b192$var$isAnySideFullyClipped(overflow) {
    return (0, $ft7ke.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $9a5214747241b192$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const _evaluate = (0, $ft7ke.evaluate)(options, state), { strategy: strategy = "referenceHidden" } = _evaluate, detectOverflowOptions = (0, $akGnX._)(_evaluate, [
                "strategy"
            ]);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $9a5214747241b192$export$37b6bde19b108ecc(state, (0, $6iHNw._)((0, $7Knp0._)({}, detectOverflowOptions), {
                            elementContext: "reference"
                        }));
                        const offsets = $9a5214747241b192$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $9a5214747241b192$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $9a5214747241b192$export$37b6bde19b108ecc(state, (0, $6iHNw._)((0, $7Knp0._)({}, detectOverflowOptions), {
                            altBoundary: true
                        }));
                        const offsets = $9a5214747241b192$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $9a5214747241b192$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $9a5214747241b192$var$getBoundingRect(rects) {
    const minX = (0, $ft7ke.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $ft7ke.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $ft7ke.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $ft7ke.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $9a5214747241b192$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $ft7ke.rectToClientRect)($9a5214747241b192$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $9a5214747241b192$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $ft7ke.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $9a5214747241b192$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $ft7ke.rectToClientRect)($9a5214747241b192$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $ft7ke.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $ft7ke.getSideAxis)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $ft7ke.getSide)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $ft7ke.getSide)(placement) === "left";
                    const maxRight = (0, $ft7ke.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $ft7ke.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $9a5214747241b192$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $ft7ke.getSide)(placement);
    const alignment = (0, $ft7ke.getAlignment)(placement);
    const isVertical = (0, $ft7ke.getSideAxis)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $ft7ke.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : (0, $7Knp0._)({
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null
    }, rawValue);
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $9a5214747241b192$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            const { x: x, y: y } = state;
            const diffCoords = await $9a5214747241b192$var$convertValueToCoords(state, options);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9a5214747241b192$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const _evaluate = (0, $ft7ke.evaluate)(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            } } = _evaluate, detectOverflowOptions = (0, $akGnX._)(_evaluate, [
                "mainAxis",
                "crossAxis",
                "limiter"
            ]);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $9a5214747241b192$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $ft7ke.getSideAxis)((0, $ft7ke.getSide)(placement));
            const mainAxis = (0, $ft7ke.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $ft7ke.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $ft7ke.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn((0, $6iHNw._)((0, $7Knp0._)({}, state), {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            }));
            return (0, $6iHNw._)((0, $7Knp0._)({}, limitedCoords), {
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            });
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9a5214747241b192$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $ft7ke.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $ft7ke.getSideAxis)(placement);
            const mainAxis = (0, $ft7ke.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $ft7ke.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : (0, $7Knp0._)({
                mainAxis: 0,
                crossAxis: 0
            }, rawOffset);
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $ft7ke.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $9a5214747241b192$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const _evaluate = (0, $ft7ke.evaluate)(options, state), { apply: apply = ()=>{} } = _evaluate, detectOverflowOptions = (0, $akGnX._)(_evaluate, [
                "apply"
            ]);
            const overflow = await $9a5214747241b192$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $ft7ke.getSide)(placement);
            const alignment = (0, $ft7ke.getAlignment)(placement);
            const isYAxis = (0, $ft7ke.getSideAxis)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $ft7ke.min)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $ft7ke.min)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $ft7ke.max)(overflow.left, 0);
                const xMax = (0, $ft7ke.max)(overflow.right, 0);
                const yMin = (0, $ft7ke.max)(overflow.top, 0);
                const yMax = (0, $ft7ke.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $ft7ke.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $ft7ke.max)(overflow.top, overflow.bottom));
            }
            await apply((0, $6iHNw._)((0, $7Knp0._)({}, state), {
                availableWidth: availableWidth,
                availableHeight: availableHeight
            }));
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("ft7ke", function(module, exports) {

$parcel$export(module.exports, "sides", function () { return $a5cddb2008cdcd5d$export$832b6fa47fa053d2; });
$parcel$export(module.exports, "placements", function () { return $a5cddb2008cdcd5d$export$803cd8101b6c182b; });
$parcel$export(module.exports, "min", function () { return $a5cddb2008cdcd5d$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $a5cddb2008cdcd5d$export$8960430cfd85939f; });
$parcel$export(module.exports, "round", function () { return $a5cddb2008cdcd5d$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "floor", function () { return $a5cddb2008cdcd5d$export$a3fe094919f356fd; });
$parcel$export(module.exports, "createCoords", function () { return $a5cddb2008cdcd5d$export$a397704b5e280835; });
$parcel$export(module.exports, "clamp", function () { return $a5cddb2008cdcd5d$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "evaluate", function () { return $a5cddb2008cdcd5d$export$fef61f332f2c0afc; });
$parcel$export(module.exports, "getSide", function () { return $a5cddb2008cdcd5d$export$3c915306cb7fc97a; });
$parcel$export(module.exports, "getAlignment", function () { return $a5cddb2008cdcd5d$export$f0989780f32bfcda; });
$parcel$export(module.exports, "getOppositeAxis", function () { return $a5cddb2008cdcd5d$export$8a000a963141ac32; });
$parcel$export(module.exports, "getAxisLength", function () { return $a5cddb2008cdcd5d$export$320bd9d53520c68a; });
$parcel$export(module.exports, "getSideAxis", function () { return $a5cddb2008cdcd5d$export$f28e8f882010718a; });
$parcel$export(module.exports, "getAlignmentAxis", function () { return $a5cddb2008cdcd5d$export$2b57e0052a6d6d4c; });
$parcel$export(module.exports, "getAlignmentSides", function () { return $a5cddb2008cdcd5d$export$be42861551f17911; });
$parcel$export(module.exports, "getOppositePlacement", function () { return $a5cddb2008cdcd5d$export$9c5e28bad23365fa; });
$parcel$export(module.exports, "getExpandedPlacements", function () { return $a5cddb2008cdcd5d$export$496432a3699e50b1; });
$parcel$export(module.exports, "getOppositeAlignmentPlacement", function () { return $a5cddb2008cdcd5d$export$2b182c584985588b; });
$parcel$export(module.exports, "getOppositeAxisPlacements", function () { return $a5cddb2008cdcd5d$export$a9b6fb18fd92c3ec; });
$parcel$export(module.exports, "getPaddingObject", function () { return $a5cddb2008cdcd5d$export$598c291c29bc2e71; });
$parcel$export(module.exports, "rectToClientRect", function () { return $a5cddb2008cdcd5d$export$ee05aea0aeecbad4; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");
const $a5cddb2008cdcd5d$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $a5cddb2008cdcd5d$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $a5cddb2008cdcd5d$export$803cd8101b6c182b = /*#__PURE__*/ $a5cddb2008cdcd5d$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $a5cddb2008cdcd5d$export$27b07d8a310ed8b5[0], side + "-" + $a5cddb2008cdcd5d$export$27b07d8a310ed8b5[1]), []);
const $a5cddb2008cdcd5d$export$96ec731ed4dcb222 = Math.min;
const $a5cddb2008cdcd5d$export$8960430cfd85939f = Math.max;
const $a5cddb2008cdcd5d$export$2077e0241d6afd3c = Math.round;
const $a5cddb2008cdcd5d$export$a3fe094919f356fd = Math.floor;
const $a5cddb2008cdcd5d$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $a5cddb2008cdcd5d$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $a5cddb2008cdcd5d$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $a5cddb2008cdcd5d$export$7d15b64cf5a3a4c4(start, value, end) {
    return $a5cddb2008cdcd5d$export$8960430cfd85939f(start, $a5cddb2008cdcd5d$export$96ec731ed4dcb222(value, end));
}
function $a5cddb2008cdcd5d$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $a5cddb2008cdcd5d$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $a5cddb2008cdcd5d$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $a5cddb2008cdcd5d$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $a5cddb2008cdcd5d$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $a5cddb2008cdcd5d$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($a5cddb2008cdcd5d$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $a5cddb2008cdcd5d$export$2b57e0052a6d6d4c(placement) {
    return $a5cddb2008cdcd5d$export$8a000a963141ac32($a5cddb2008cdcd5d$export$f28e8f882010718a(placement));
}
function $a5cddb2008cdcd5d$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $a5cddb2008cdcd5d$export$f0989780f32bfcda(placement);
    const alignmentAxis = $a5cddb2008cdcd5d$export$2b57e0052a6d6d4c(placement);
    const length = $a5cddb2008cdcd5d$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $a5cddb2008cdcd5d$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $a5cddb2008cdcd5d$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $a5cddb2008cdcd5d$export$496432a3699e50b1(placement) {
    const oppositePlacement = $a5cddb2008cdcd5d$export$9c5e28bad23365fa(placement);
    return [
        $a5cddb2008cdcd5d$export$2b182c584985588b(placement),
        oppositePlacement,
        $a5cddb2008cdcd5d$export$2b182c584985588b(oppositePlacement)
    ];
}
function $a5cddb2008cdcd5d$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$a5cddb2008cdcd5d$var$oppositeAlignmentMap[alignment]);
}
function $a5cddb2008cdcd5d$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $a5cddb2008cdcd5d$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $a5cddb2008cdcd5d$export$f0989780f32bfcda(placement);
    let list = $a5cddb2008cdcd5d$var$getSideList($a5cddb2008cdcd5d$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($a5cddb2008cdcd5d$export$2b182c584985588b));
    }
    return list;
}
function $a5cddb2008cdcd5d$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$a5cddb2008cdcd5d$var$oppositeSideMap[side]);
}
function $a5cddb2008cdcd5d$export$1c66dbf1a9e34223(padding) {
    return (0, $7Knp0._)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, padding);
}
function $a5cddb2008cdcd5d$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $a5cddb2008cdcd5d$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $a5cddb2008cdcd5d$export$ee05aea0aeecbad4(rect) {
    return (0, $6iHNw._)((0, $7Knp0._)({}, rect), {
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("1aw9F", function(module, exports) {

$parcel$export(module.exports, "getNodeName", function () { return $e7725b143600c9c2$export$651544f548703224; });
$parcel$export(module.exports, "getWindow", function () { return $e7725b143600c9c2$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "getDocumentElement", function () { return $e7725b143600c9c2$export$e495491855dc5418; });
$parcel$export(module.exports, "isElement", function () { return $e7725b143600c9c2$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $e7725b143600c9c2$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isOverflowElement", function () { return $e7725b143600c9c2$export$989e911fa9af580a; });
$parcel$export(module.exports, "getComputedStyle", function () { return $e7725b143600c9c2$export$3735103072e4a80; });
$parcel$export(module.exports, "isTableElement", function () { return $e7725b143600c9c2$export$71535ffaa902797f; });
$parcel$export(module.exports, "isContainingBlock", function () { return $e7725b143600c9c2$export$d6c4e8150c35fed1; });
$parcel$export(module.exports, "isWebKit", function () { return $e7725b143600c9c2$export$78551043582a6a98; });
$parcel$export(module.exports, "getContainingBlock", function () { return $e7725b143600c9c2$export$940d8225183e1404; });
$parcel$export(module.exports, "getParentNode", function () { return $e7725b143600c9c2$export$4e12058fc4d51d56; });
$parcel$export(module.exports, "isLastTraversableNode", function () { return $e7725b143600c9c2$export$d1162fb0b6d4cd51; });
$parcel$export(module.exports, "getNodeScroll", function () { return $e7725b143600c9c2$export$dc8fc79fa2800137; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return $e7725b143600c9c2$export$3b57c1601291186b; });
function $e7725b143600c9c2$export$651544f548703224(node) {
    if ($e7725b143600c9c2$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $e7725b143600c9c2$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $e7725b143600c9c2$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($e7725b143600c9c2$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $e7725b143600c9c2$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $e7725b143600c9c2$export$38b2d434cce3ea22(value).Node;
}
function $e7725b143600c9c2$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $e7725b143600c9c2$export$38b2d434cce3ea22(value).Element;
}
function $e7725b143600c9c2$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $e7725b143600c9c2$export$38b2d434cce3ea22(value).HTMLElement;
}
function $e7725b143600c9c2$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $e7725b143600c9c2$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $e7725b143600c9c2$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $e7725b143600c9c2$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $e7725b143600c9c2$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($e7725b143600c9c2$export$651544f548703224(element));
}
function $e7725b143600c9c2$export$d6c4e8150c35fed1(element) {
    const webkit = $e7725b143600c9c2$export$78551043582a6a98();
    const css = $e7725b143600c9c2$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $e7725b143600c9c2$export$940d8225183e1404(element) {
    let currentNode = $e7725b143600c9c2$export$4e12058fc4d51d56(element);
    while($e7725b143600c9c2$export$1b3bfaa9684536aa(currentNode) && !$e7725b143600c9c2$export$d1162fb0b6d4cd51(currentNode)){
        if ($e7725b143600c9c2$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else currentNode = $e7725b143600c9c2$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $e7725b143600c9c2$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $e7725b143600c9c2$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($e7725b143600c9c2$export$651544f548703224(node));
}
function $e7725b143600c9c2$export$3735103072e4a80(element) {
    return $e7725b143600c9c2$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $e7725b143600c9c2$export$dc8fc79fa2800137(element) {
    if ($e7725b143600c9c2$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $e7725b143600c9c2$export$4e12058fc4d51d56(node) {
    if ($e7725b143600c9c2$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $e7725b143600c9c2$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $e7725b143600c9c2$export$e495491855dc5418(node);
    return $e7725b143600c9c2$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $e7725b143600c9c2$export$7cd01a57c8ca906c(node) {
    const parentNode = $e7725b143600c9c2$export$4e12058fc4d51d56(node);
    if ($e7725b143600c9c2$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($e7725b143600c9c2$export$1b3bfaa9684536aa(parentNode) && $e7725b143600c9c2$export$989e911fa9af580a(parentNode)) return parentNode;
    return $e7725b143600c9c2$export$7cd01a57c8ca906c(parentNode);
}
function $e7725b143600c9c2$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $e7725b143600c9c2$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $e7725b143600c9c2$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $e7725b143600c9c2$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $e7725b143600c9c2$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $e7725b143600c9c2$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}

});


parcelRegister("3fOxZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25e9fb6a7fb483de$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
var $25e9fb6a7fb483de$var$index = (0, $iSvIT.useLayoutEffect);
var $25e9fb6a7fb483de$export$2e2bcd8739ae039 = $25e9fb6a7fb483de$var$index;

});


parcelRegister("1K6UN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $144f737f35443e1b$export$2e2bcd8739ae039; });

var $lVIRl = parcelRequire("lVIRl");

var $fBUaU = parcelRequire("fBUaU");

var $iSvIT = parcelRequire("iSvIT");

var $Xt8rg = parcelRequire("Xt8rg");

var $eaGHY = parcelRequire("eaGHY");

var $gnUvj = parcelRequire("gnUvj");

var $4hU6i = parcelRequire("4hU6i");
parcelRequire("k5N0O");
parcelRequire("9yUBC");
parcelRequire("h57BE");
parcelRequire("aReVA");
parcelRequire("ly09p");
parcelRequire("5guBO");
parcelRequire("8BpI7");
parcelRequire("aGqhc");

parcelRequire("hFz8f");
parcelRequire("5kd3B");
parcelRequire("1K5Eh");
parcelRequire("i5UxU");

parcelRequire("3fOxZ");
var $144f737f35443e1b$var$StateManagedSelect = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $lVIRl.u)(props);
    return /*#__PURE__*/ $iSvIT.createElement((0, $Xt8rg.S), (0, $fBUaU.default)({
        ref: ref
    }, baseSelectProps));
});
var $144f737f35443e1b$export$2e2bcd8739ae039 = $144f737f35443e1b$var$StateManagedSelect;
var $144f737f35443e1b$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $iSvIT.useMemo)(function() {
        return (0, $gnUvj.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $iSvIT.createElement((0, $eaGHY.C), {
        value: emotionCache
    }, children);
};

});
parcelRegister("lVIRl", function(module, exports) {

$parcel$export(module.exports, "u", function () { return $ff71b7ff8294e068$export$3b14a55fb2447963; });

var $k5N0O = parcelRequire("k5N0O");

var $9yUBC = parcelRequire("9yUBC");

var $h57BE = parcelRequire("h57BE");

var $iSvIT = parcelRequire("iSvIT");
var $ff71b7ff8294e068$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $ff71b7ff8294e068$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $h57BE.default)(_ref, $ff71b7ff8294e068$var$_excluded);
    var _useState = (0, $iSvIT.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $9yUBC.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $9yUBC.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $iSvIT.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $9yUBC.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $iSvIT.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $iSvIT.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $iSvIT.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $iSvIT.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $k5N0O.default)((0, $k5N0O.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});

parcelRegister("Xt8rg", function(module, exports) {

$parcel$export(module.exports, "S", function () { return $0b2c1c6d9ef1aad4$export$25ce5a424b770e84; });

var $fBUaU = parcelRequire("fBUaU");

var $k5N0O = parcelRequire("k5N0O");

var $aReVA = parcelRequire("aReVA");

var $ly09p = parcelRequire("ly09p");

var $5guBO = parcelRequire("5guBO");

var $8BpI7 = parcelRequire("8BpI7");

var $aGqhc = parcelRequire("aGqhc");

var $iSvIT = parcelRequire("iSvIT");

var $4hU6i = parcelRequire("4hU6i");

var $2ZUkg = parcelRequire("2ZUkg");

var $fV0Sg = parcelRequire("fV0Sg");

var $h57BE = parcelRequire("h57BE");
function $0b2c1c6d9ef1aad4$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $0b2c1c6d9ef1aad4$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $0b2c1c6d9ef1aad4$var$A11yText = function A11yText(props) {
    return (0, $2ZUkg.jsx)("span", (0, $fBUaU.default)({
        css: $0b2c1c6d9ef1aad4$var$_ref
    }, props));
};
var $0b2c1c6d9ef1aad4$var$A11yText$1 = $0b2c1c6d9ef1aad4$var$A11yText;
var $0b2c1c6d9ef1aad4$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options".concat(isDisabled ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "");
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu") {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? "selected" : "focused").concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var $0b2c1c6d9ef1aad4$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $iSvIT.useMemo)(function() {
        return (0, $k5N0O.default)((0, $k5N0O.default)({}, $0b2c1c6d9ef1aad4$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $iSvIT.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $k5N0O.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $iSvIT.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $iSvIT.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $iSvIT.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), null, (0, $2ZUkg.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $2ZUkg.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    return (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), null, (0, $2ZUkg.jsx)($0b2c1c6d9ef1aad4$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $2ZUkg.jsx)($0b2c1c6d9ef1aad4$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $0b2c1c6d9ef1aad4$var$LiveRegion$1 = $0b2c1c6d9ef1aad4$var$LiveRegion;
var $0b2c1c6d9ef1aad4$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $0b2c1c6d9ef1aad4$var$anyDiacritic = new RegExp("[" + $0b2c1c6d9ef1aad4$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $0b2c1c6d9ef1aad4$var$diacriticToBase = {};
for(var $0b2c1c6d9ef1aad4$var$i = 0; $0b2c1c6d9ef1aad4$var$i < $0b2c1c6d9ef1aad4$var$diacritics.length; $0b2c1c6d9ef1aad4$var$i++){
    var $0b2c1c6d9ef1aad4$var$diacritic = $0b2c1c6d9ef1aad4$var$diacritics[$0b2c1c6d9ef1aad4$var$i];
    for(var $0b2c1c6d9ef1aad4$var$j = 0; $0b2c1c6d9ef1aad4$var$j < $0b2c1c6d9ef1aad4$var$diacritic.letters.length; $0b2c1c6d9ef1aad4$var$j++)$0b2c1c6d9ef1aad4$var$diacriticToBase[$0b2c1c6d9ef1aad4$var$diacritic.letters[$0b2c1c6d9ef1aad4$var$j]] = $0b2c1c6d9ef1aad4$var$diacritic.base;
}
var $0b2c1c6d9ef1aad4$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($0b2c1c6d9ef1aad4$var$anyDiacritic, function(match) {
        return $0b2c1c6d9ef1aad4$var$diacriticToBase[match];
    });
};
var $0b2c1c6d9ef1aad4$var$memoizedStripDiacriticsForInput = (0, $fV0Sg.default)($0b2c1c6d9ef1aad4$var$stripDiacritics);
var $0b2c1c6d9ef1aad4$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $0b2c1c6d9ef1aad4$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $0b2c1c6d9ef1aad4$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $k5N0O.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $0b2c1c6d9ef1aad4$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $0b2c1c6d9ef1aad4$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $0b2c1c6d9ef1aad4$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $0b2c1c6d9ef1aad4$var$memoizedStripDiacriticsForInput(input);
            candidate = $0b2c1c6d9ef1aad4$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $0b2c1c6d9ef1aad4$var$_excluded = [
    "innerRef"
];
function $0b2c1c6d9ef1aad4$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $h57BE.default)(_ref, $0b2c1c6d9ef1aad4$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $4hU6i.r)(props, "onExited", "in", "enter", "exit", "appear");
    return (0, $2ZUkg.jsx)("input", (0, $fBUaU.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $2ZUkg.css)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, "", "")
    }));
}
var $0b2c1c6d9ef1aad4$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $0b2c1c6d9ef1aad4$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $iSvIT.useRef)(false);
    var isTop = (0, $iSvIT.useRef)(false);
    var touchStart = (0, $iSvIT.useRef)(0);
    var scrollTarget = (0, $iSvIT.useRef)(null);
    var handleEventDelta = (0, $iSvIT.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $0b2c1c6d9ef1aad4$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $iSvIT.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $iSvIT.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $iSvIT.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $iSvIT.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $4hU6i.s) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $iSvIT.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $iSvIT.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $0b2c1c6d9ef1aad4$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $0b2c1c6d9ef1aad4$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $0b2c1c6d9ef1aad4$var$preventTouchMove(e) {
    e.preventDefault();
}
function $0b2c1c6d9ef1aad4$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $0b2c1c6d9ef1aad4$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $0b2c1c6d9ef1aad4$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $0b2c1c6d9ef1aad4$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $0b2c1c6d9ef1aad4$var$activeScrollLocks = 0;
var $0b2c1c6d9ef1aad4$var$listenerOptions = {
    capture: false,
    passive: false
};
function $0b2c1c6d9ef1aad4$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $iSvIT.useRef)({});
    var scrollTarget = (0, $iSvIT.useRef)(null);
    var addScrollLock = (0, $iSvIT.useCallback)(function(touchScrollTarget) {
        if (!$0b2c1c6d9ef1aad4$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $0b2c1c6d9ef1aad4$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $0b2c1c6d9ef1aad4$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($0b2c1c6d9ef1aad4$var$LOCK_STYLES).forEach(function(key) {
                var val = $0b2c1c6d9ef1aad4$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $0b2c1c6d9ef1aad4$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", $0b2c1c6d9ef1aad4$var$preventTouchMove, $0b2c1c6d9ef1aad4$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", $0b2c1c6d9ef1aad4$var$preventInertiaScroll, $0b2c1c6d9ef1aad4$var$listenerOptions);
                touchScrollTarget.addEventListener("touchmove", $0b2c1c6d9ef1aad4$var$allowTouchMove, $0b2c1c6d9ef1aad4$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $0b2c1c6d9ef1aad4$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $iSvIT.useCallback)(function(touchScrollTarget) {
        if (!$0b2c1c6d9ef1aad4$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $0b2c1c6d9ef1aad4$var$activeScrollLocks = Math.max($0b2c1c6d9ef1aad4$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $0b2c1c6d9ef1aad4$var$activeScrollLocks < 1) $0b2c1c6d9ef1aad4$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $0b2c1c6d9ef1aad4$var$isTouchDevice()) {
            target.removeEventListener("touchmove", $0b2c1c6d9ef1aad4$var$preventTouchMove, $0b2c1c6d9ef1aad4$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", $0b2c1c6d9ef1aad4$var$preventInertiaScroll, $0b2c1c6d9ef1aad4$var$listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", $0b2c1c6d9ef1aad4$var$allowTouchMove, $0b2c1c6d9ef1aad4$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $iSvIT.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $0b2c1c6d9ef1aad4$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0b2c1c6d9ef1aad4$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $0b2c1c6d9ef1aad4$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $0b2c1c6d9ef1aad4$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $0b2c1c6d9ef1aad4$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $0b2c1c6d9ef1aad4$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), null, lockEnabled && (0, $2ZUkg.jsx)("div", {
        onClick: $0b2c1c6d9ef1aad4$var$blurSelectInput,
        css: $0b2c1c6d9ef1aad4$var$_ref2$1
    }), children(targetRef));
}
function $0b2c1c6d9ef1aad4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0b2c1c6d9ef1aad4$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $0b2c1c6d9ef1aad4$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $2ZUkg.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $0b2c1c6d9ef1aad4$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $0b2c1c6d9ef1aad4$var$RequiredInput$1 = $0b2c1c6d9ef1aad4$var$RequiredInput;
var $0b2c1c6d9ef1aad4$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $0b2c1c6d9ef1aad4$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $0b2c1c6d9ef1aad4$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $0b2c1c6d9ef1aad4$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $0b2c1c6d9ef1aad4$var$defaultStyles = {
    clearIndicator: (0, $4hU6i.a),
    container: (0, $4hU6i.b),
    control: (0, $4hU6i.d),
    dropdownIndicator: (0, $4hU6i.e),
    group: (0, $4hU6i.g),
    groupHeading: (0, $4hU6i.f),
    indicatorsContainer: (0, $4hU6i.i),
    indicatorSeparator: (0, $4hU6i.h),
    input: (0, $4hU6i.j),
    loadingIndicator: (0, $4hU6i.l),
    loadingMessage: (0, $4hU6i.k),
    menu: (0, $4hU6i.m),
    menuList: (0, $4hU6i.n),
    menuPortal: (0, $4hU6i.o),
    multiValue: (0, $4hU6i.p),
    multiValueLabel: (0, $4hU6i.q),
    multiValueRemove: (0, $4hU6i.t),
    noOptionsMessage: (0, $4hU6i.u),
    option: (0, $4hU6i.v),
    placeholder: (0, $4hU6i.w),
    singleValue: (0, $4hU6i.x),
    valueContainer: (0, $4hU6i.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $0b2c1c6d9ef1aad4$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $k5N0O.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $0b2c1c6d9ef1aad4$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $0b2c1c6d9ef1aad4$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $0b2c1c6d9ef1aad4$var$baseUnit = 4;
// The minimum height of the control
var $0b2c1c6d9ef1aad4$var$controlHeight = 38;
// The amount of space between the control and menu */
var $0b2c1c6d9ef1aad4$var$menuGutter = $0b2c1c6d9ef1aad4$var$baseUnit * 2;
var $0b2c1c6d9ef1aad4$var$spacing = {
    baseUnit: $0b2c1c6d9ef1aad4$var$baseUnit,
    controlHeight: $0b2c1c6d9ef1aad4$var$controlHeight,
    menuGutter: $0b2c1c6d9ef1aad4$var$menuGutter
};
var $0b2c1c6d9ef1aad4$export$4368d992c4eafac0 = {
    borderRadius: $0b2c1c6d9ef1aad4$var$borderRadius,
    colors: $0b2c1c6d9ef1aad4$var$colors,
    spacing: $0b2c1c6d9ef1aad4$var$spacing
};
var $0b2c1c6d9ef1aad4$export$407448d2b89b1813 = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $4hU6i.z)(),
    captureMenuScroll: !(0, $4hU6i.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $0b2c1c6d9ef1aad4$export$db3b6bfb95261072(),
    formatGroupLabel: $0b2c1c6d9ef1aad4$var$formatGroupLabel,
    getOptionLabel: $0b2c1c6d9ef1aad4$export$8b22cf2602fb60ce,
    getOptionValue: $0b2c1c6d9ef1aad4$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $0b2c1c6d9ef1aad4$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $4hU6i.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $0b2c1c6d9ef1aad4$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $0b2c1c6d9ef1aad4$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $0b2c1c6d9ef1aad4$var$_isOptionSelected(props, option, selectValue);
    var label = $0b2c1c6d9ef1aad4$var$getOptionLabel(props, option);
    var value = $0b2c1c6d9ef1aad4$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $0b2c1c6d9ef1aad4$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $0b2c1c6d9ef1aad4$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $0b2c1c6d9ef1aad4$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $0b2c1c6d9ef1aad4$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $0b2c1c6d9ef1aad4$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $4hU6i.K));
}
function $0b2c1c6d9ef1aad4$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $aGqhc.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $0b2c1c6d9ef1aad4$var$buildFocusableOptions(props, selectValue) {
    return $0b2c1c6d9ef1aad4$var$buildFocusableOptionsFromCategorizedOptions($0b2c1c6d9ef1aad4$var$buildCategorizedOptions(props, selectValue));
}
function $0b2c1c6d9ef1aad4$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$0b2c1c6d9ef1aad4$var$shouldHideSelectedOptions(props) || !isSelected) && $0b2c1c6d9ef1aad4$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $0b2c1c6d9ef1aad4$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $0b2c1c6d9ef1aad4$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $0b2c1c6d9ef1aad4$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $0b2c1c6d9ef1aad4$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $0b2c1c6d9ef1aad4$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $0b2c1c6d9ef1aad4$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $0b2c1c6d9ef1aad4$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $0b2c1c6d9ef1aad4$var$getOptionValue(props, i) === candidate;
    });
}
function $0b2c1c6d9ef1aad4$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $0b2c1c6d9ef1aad4$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $0b2c1c6d9ef1aad4$var$instanceId = 1;
var $0b2c1c6d9ef1aad4$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $5guBO.default)(Select, _Component);
    var _super = (0, $8BpI7.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $aReVA.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = "";
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $4hU6i.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $4hU6i.B)([].concat((0, $aGqhc.default)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $4hU6i.C)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $4hU6i.C)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $4hU6i.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $4hU6i.D)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $4hU6i.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $4hU6i.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $0b2c1c6d9ef1aad4$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $0b2c1c6d9ef1aad4$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $0b2c1c6d9ef1aad4$var$defaultStyles[key](props, unstyled);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $4hU6i.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $0b2c1c6d9ef1aad4$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $0b2c1c6d9ef1aad4$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $k5N0O.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $4hU6i.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $0b2c1c6d9ef1aad4$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = "react-select-" + (_this.props.instanceId || ++$0b2c1c6d9ef1aad4$var$instanceId);
        _this.state.selectValue = (0, $4hU6i.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $ly09p.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $4hU6i.I)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $4hU6i.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $0b2c1c6d9ef1aad4$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($0b2c1c6d9ef1aad4$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $k5N0O.default)((0, $k5N0O.default)({}, $0b2c1c6d9ef1aad4$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $0b2c1c6d9ef1aad4$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $0b2c1c6d9ef1aad4$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $0b2c1c6d9ef1aad4$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $k5N0O.default)((0, $k5N0O.default)((0, $k5N0O.default)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-required": required,
                    role: "combobox"
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox"),
                    "aria-owns": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $iSvIT.createElement($0b2c1c6d9ef1aad4$var$DummyInput, (0, $fBUaU.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $4hU6i.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $iSvIT.createElement(Input, (0, $fBUaU.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $iSvIT.createElement(Placeholder, (0, $fBUaU.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $iSvIT.createElement(MultiValue, (0, $fBUaU.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $iSvIT.createElement(SingleValue, (0, $fBUaU.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $iSvIT.createElement(ClearIndicator, (0, $fBUaU.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $iSvIT.createElement(LoadingIndicator, (0, $fBUaU.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $iSvIT.createElement(IndicatorSeparator, (0, $fBUaU.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $iSvIT.createElement(DropdownIndicator, (0, $fBUaU.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $iSvIT.createElement(Option, (0, $fBUaU.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $iSvIT.createElement(Group, (0, $fBUaU.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $iSvIT.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $iSvIT.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $iSvIT.createElement((0, $4hU6i.M), (0, $fBUaU.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $iSvIT.createElement(Menu, (0, $fBUaU.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId("listbox")
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $iSvIT.createElement($0b2c1c6d9ef1aad4$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $iSvIT.createElement(MenuList, (0, $fBUaU.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ $iSvIT.createElement(MenuPortal, (0, $fBUaU.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $iSvIT.createElement($0b2c1c6d9ef1aad4$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $iSvIT.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $iSvIT.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $iSvIT.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $iSvIT.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ $iSvIT.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $iSvIT.createElement($0b2c1c6d9ef1aad4$var$LiveRegion$1, (0, $fBUaU.default)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $iSvIT.createElement(SelectContainer, (0, $fBUaU.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $iSvIT.createElement(Control, (0, $fBUaU.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $iSvIT.createElement(ValueContainer, (0, $fBUaU.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $iSvIT.createElement(IndicatorsContainer, (0, $fBUaU.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $4hU6i.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $0b2c1c6d9ef1aad4$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $0b2c1c6d9ef1aad4$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $0b2c1c6d9ef1aad4$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $4hU6i.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, $k5N0O.default)((0, $k5N0O.default)((0, $k5N0O.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $iSvIT.Component));
$0b2c1c6d9ef1aad4$export$25ce5a424b770e84.defaultProps = $0b2c1c6d9ef1aad4$export$407448d2b89b1813;

});
parcelRegister("aReVA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e7a6ef5f4648094$export$2e2bcd8739ae039; });
function $7e7a6ef5f4648094$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("ly09p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fafce3e1044e60b5$export$2e2bcd8739ae039; });

var $ienzO = parcelRequire("ienzO");
function $fafce3e1044e60b5$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $ienzO.default)(o.key), o);
    }
}
function $fafce3e1044e60b5$export$2e2bcd8739ae039(e, r, t) {
    return r && $fafce3e1044e60b5$var$_defineProperties(e.prototype, r), t && $fafce3e1044e60b5$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("5guBO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d5630a2b7f4f662$export$2e2bcd8739ae039; });

var $6Zycf = parcelRequire("6Zycf");
function $3d5630a2b7f4f662$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $6Zycf.default)(t, e);
}

});
parcelRegister("6Zycf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5172f74813dc4d15$export$2e2bcd8739ae039; });
function $5172f74813dc4d15$export$2e2bcd8739ae039(t, e) {
    return $5172f74813dc4d15$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $5172f74813dc4d15$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("8BpI7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6435b9048ce6c65b$export$2e2bcd8739ae039; });

var $h1rf5 = parcelRequire("h1rf5");

var $h19K0 = parcelRequire("h19K0");

var $2j9Ex = parcelRequire("2j9Ex");
function $6435b9048ce6c65b$export$2e2bcd8739ae039(t) {
    var r = (0, $h19K0.default)();
    return function() {
        var e, o = (0, $h1rf5.default)(t);
        if (r) {
            var s = (0, $h1rf5.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $2j9Ex.default)(this, e);
    };
}

});
parcelRegister("h1rf5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c647a9713f19d997$export$2e2bcd8739ae039; });
function $c647a9713f19d997$export$2e2bcd8739ae039(t) {
    return $c647a9713f19d997$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $c647a9713f19d997$export$2e2bcd8739ae039(t);
}

});

parcelRegister("h19K0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c63a16071b585dfa$export$2e2bcd8739ae039; });
function $c63a16071b585dfa$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c63a16071b585dfa$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("2j9Ex", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ae4d7f45fe314a8$export$2e2bcd8739ae039; });

var $hFz8f = parcelRequire("hFz8f");

var $1L5sO = parcelRequire("1L5sO");
function $1ae4d7f45fe314a8$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $hFz8f.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $1L5sO.default)(t);
}

});
parcelRegister("1L5sO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $147e6b36ac0d6910$export$2e2bcd8739ae039; });
function $147e6b36ac0d6910$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});



parcelRegister("aGqhc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c723597d5be111e$export$2e2bcd8739ae039; });

var $k6qnI = parcelRequire("k6qnI");

var $7qH2x = parcelRequire("7qH2x");

var $iHw5C = parcelRequire("iHw5C");

var $dNonQ = parcelRequire("dNonQ");
function $7c723597d5be111e$export$2e2bcd8739ae039(r) {
    return (0, $k6qnI.default)(r) || (0, $7qH2x.default)(r) || (0, $iHw5C.default)(r) || (0, $dNonQ.default)();
}

});
parcelRegister("k6qnI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea28d4ffd0784ba2$export$2e2bcd8739ae039; });

var $6HmTm = parcelRequire("6HmTm");
function $ea28d4ffd0784ba2$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $6HmTm.default)(r);
}

});

parcelRegister("7qH2x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $568c58f66325839e$export$2e2bcd8739ae039; });
function $568c58f66325839e$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("dNonQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0b2c40c090a0537$export$2e2bcd8739ae039; });
function $a0b2c40c090a0537$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("cAgz7", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $9295b2644e2d2519$var$__DEV__ = false;
var $9295b2644e2d2519$var$warning = function() {};
if ($9295b2644e2d2519$var$__DEV__) {
    var $9295b2644e2d2519$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $9295b2644e2d2519$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $9295b2644e2d2519$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $9295b2644e2d2519$var$warning;

});

parcelRegister("17K1G", function(module, exports) {

var $gz8iS = parcelRequire("gz8iS");
var $0d1a25b421884e2e$var$listeningFocusTrap = null;
function $0d1a25b421884e2e$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === "string" ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $0d1a25b421884e2e$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($0d1a25b421884e2e$var$listeningFocusTrap) $0d1a25b421884e2e$var$listeningFocusTrap.pause();
        $0d1a25b421884e2e$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $0d1a25b421884e2e$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener("focus", checkFocus, true);
        document.addEventListener("click", checkClick, true);
        document.addEventListener("mousedown", checkPointerDown, true);
        document.addEventListener("touchstart", checkPointerDown, true);
        document.addEventListener("keydown", checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $0d1a25b421884e2e$var$listeningFocusTrap !== trap) return;
        document.removeEventListener("focus", checkFocus, true);
        document.removeEventListener("click", checkClick, true);
        document.removeEventListener("mousedown", checkPointerDown, true);
        document.removeEventListener("touchstart", checkPointerDown, true);
        document.removeEventListener("keydown", checkKey, true);
        $0d1a25b421884e2e$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === "string") {
            node = document.querySelector(optionValue);
            if (!node) throw new Error("`" + optionName + "` refers to no known node");
        }
        if (typeof optionValue === "function") {
            node = optionValue();
            if (!node) throw new Error("`" + optionName + "` did not return a node");
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption("initialFocus") !== null) node = getNodeForOption("initialFocus");
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption("fallbackFocus");
        if (!node) throw new Error("You can't have a focus-trap without at least one focusable element");
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === "function") e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === "Tab" || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $0d1a25b421884e2e$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute("tabindex") && Number(e.target.getAttribute("tabindex")) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $0d1a25b421884e2e$var$tryFocus(lastTabbableNode);
            return $0d1a25b421884e2e$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $0d1a25b421884e2e$var$tryFocus(firstTabbableNode);
        $0d1a25b421884e2e$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $gz8iS(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $0d1a25b421884e2e$var$tryFocus(lastTabbableNode);
        $0d1a25b421884e2e$var$tryFocus(firstTabbableNode);
    }
}
function $0d1a25b421884e2e$var$isEscapeEvent(e) {
    return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
}
function $0d1a25b421884e2e$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === "input") node.select();
}
module.exports = $0d1a25b421884e2e$var$focusTrap;

});
parcelRegister("gz8iS", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $c0f65b23bdfd1790$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        "input",
        "select",
        "a[href]",
        "textarea",
        "button",
        "[tabindex]"
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(","));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute("tabindex"), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === "INPUT" && candidate.type === "hidden" || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $c0f65b23bdfd1790$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === "none") result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === "hidden";
    };
}

});


parcelRegister("iCerv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8d6fa97b174854a$export$2e2bcd8739ae039; });
function $d8d6fa97b174854a$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $d8d6fa97b174854a$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d8d6fa97b174854a$export$2e2bcd8739ae039(o);
}

});

parcelRegister("fR6TR", function(module, exports) {

$parcel$export(module.exports, "CrossFlowConsumer", function () { return $b8b12871181f1fbc$export$bb23a1e8e036feea; });

var $9H5Ac = parcelRequire("9H5Ac");

var $fhngd = parcelRequire("fhngd");

var $01Hnw = parcelRequire("01Hnw");

var $iSvIT = parcelRequire("iSvIT");

var $aYNGK = parcelRequire("aYNGK");
var $b8b12871181f1fbc$var$_excluded = [
    "onComplete",
    "onError"
];
var $b8b12871181f1fbc$export$bb23a1e8e036feea = function CrossFlowConsumer(props) {
    // Using useRef here to ensure that only the initial props are used
    // and it ensures that the useEffect handler below is only run once.
    // Any subsequent changes to props have no effect.
    var propsRef = (0, $iSvIT.useRef)(props);
    var crossFlowRef = (0, $iSvIT.useRef)((0, $aYNGK.useCrossFlow)());
    (0, $iSvIT.useEffect)(function() {
        var crossFlow = crossFlowRef.current;
        (0, $fhngd.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($01Hnw))).mark(function _callee() {
            var _propsRef$current, onComplete, onError, options, api, status;
            return (0, (/*@__PURE__*/$parcel$interopDefault($01Hnw))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _propsRef$current = propsRef.current, onComplete = _propsRef$current.onComplete, onError = _propsRef$current.onError, options = (0, $9H5Ac.default)(_propsRef$current, $b8b12871181f1fbc$var$_excluded);
                        if (!crossFlow.isEnabled) {
                            _context.next = 13;
                            break;
                        }
                        api = "v1" in options ? crossFlow.apiV1 : crossFlow.api;
                        _context.prev = 3;
                        _context.next = 6;
                        return api.open(options);
                    case 6:
                        status = _context.sent;
                        onComplete === null || onComplete === void 0 || onComplete(status);
                        _context.next = 13;
                        break;
                    case 10:
                        _context.prev = 10;
                        _context.t0 = _context["catch"](3);
                        onError === null || onError === void 0 || onError(_context.t0);
                    case 13:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    3,
                    10
                ]
            ]);
        }))();
    }, []);
    return null;
};

});

parcelRegister("c9HdH", function(module, exports) {

var $bcztx = parcelRequire("bcztx");

var $5JKmU = parcelRequire("5JKmU");
/** Used to compose bitmasks for value comparisons. */ var $8d97d9e1eed9e148$var$COMPARE_PARTIAL_FLAG = 1, $8d97d9e1eed9e148$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $8d97d9e1eed9e148$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $bcztx;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $5JKmU(srcValue, objValue, $8d97d9e1eed9e148$var$COMPARE_PARTIAL_FLAG | $8d97d9e1eed9e148$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $8d97d9e1eed9e148$var$baseIsMatch;

});
parcelRegister("bcztx", function(module, exports) {

var $1HaXd = parcelRequire("1HaXd");

var $aOqKz = parcelRequire("aOqKz");

var $jLuVq = parcelRequire("jLuVq");

var $bThnB = parcelRequire("bThnB");

var $lwkLP = parcelRequire("lwkLP");

var $2XKrJ = parcelRequire("2XKrJ");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $827c5561c68e6bc0$var$Stack(entries) {
    var data = this.__data__ = new $1HaXd(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$827c5561c68e6bc0$var$Stack.prototype.clear = $aOqKz;
$827c5561c68e6bc0$var$Stack.prototype["delete"] = $jLuVq;
$827c5561c68e6bc0$var$Stack.prototype.get = $bThnB;
$827c5561c68e6bc0$var$Stack.prototype.has = $lwkLP;
$827c5561c68e6bc0$var$Stack.prototype.set = $2XKrJ;
module.exports = $827c5561c68e6bc0$var$Stack;

});
parcelRegister("aOqKz", function(module, exports) {

var $1HaXd = parcelRequire("1HaXd");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $7df352e5de6c01c4$var$stackClear() {
    this.__data__ = new $1HaXd;
    this.size = 0;
}
module.exports = $7df352e5de6c01c4$var$stackClear;

});

parcelRegister("jLuVq", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e63a6535405040df$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $e63a6535405040df$var$stackDelete;

});

parcelRegister("bThnB", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $8a8250063136343f$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $8a8250063136343f$var$stackGet;

});

parcelRegister("lwkLP", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $faacb2b65c84a268$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $faacb2b65c84a268$var$stackHas;

});

parcelRegister("2XKrJ", function(module, exports) {

var $1HaXd = parcelRequire("1HaXd");

var $c4hom = parcelRequire("c4hom");

var $czXxz = parcelRequire("czXxz");
/** Used as the size to enable large array optimizations. */ var $22851ebfe11a0c7b$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $22851ebfe11a0c7b$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $1HaXd) {
        var pairs = data.__data__;
        if (!$c4hom || pairs.length < $22851ebfe11a0c7b$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $czXxz(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $22851ebfe11a0c7b$var$stackSet;

});


parcelRegister("5JKmU", function(module, exports) {

var $fc1mV = parcelRequire("fc1mV");

var $8VKar = parcelRequire("8VKar");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $42d51f88e25814a9$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$8VKar(value) && !$8VKar(other)) return value !== value && other !== other;
    return $fc1mV(value, other, bitmask, customizer, $42d51f88e25814a9$var$baseIsEqual, stack);
}
module.exports = $42d51f88e25814a9$var$baseIsEqual;

});
parcelRegister("fc1mV", function(module, exports) {

var $bcztx = parcelRequire("bcztx");

var $d73Yq = parcelRequire("d73Yq");

var $3I8ZU = parcelRequire("3I8ZU");

var $4hGi1 = parcelRequire("4hGi1");

var $iHlaM = parcelRequire("iHlaM");

var $epu4p = parcelRequire("epu4p");

var $jageE = parcelRequire("jageE");

var $03pXg = parcelRequire("03pXg");
/** Used to compose bitmasks for value comparisons. */ var $b0f909cda57cfca6$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $b0f909cda57cfca6$var$argsTag = "[object Arguments]", $b0f909cda57cfca6$var$arrayTag = "[object Array]", $b0f909cda57cfca6$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $b0f909cda57cfca6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b0f909cda57cfca6$var$hasOwnProperty = $b0f909cda57cfca6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $b0f909cda57cfca6$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $epu4p(object), othIsArr = $epu4p(other), objTag = objIsArr ? $b0f909cda57cfca6$var$arrayTag : $iHlaM(object), othTag = othIsArr ? $b0f909cda57cfca6$var$arrayTag : $iHlaM(other);
    objTag = objTag == $b0f909cda57cfca6$var$argsTag ? $b0f909cda57cfca6$var$objectTag : objTag;
    othTag = othTag == $b0f909cda57cfca6$var$argsTag ? $b0f909cda57cfca6$var$objectTag : othTag;
    var objIsObj = objTag == $b0f909cda57cfca6$var$objectTag, othIsObj = othTag == $b0f909cda57cfca6$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $jageE(object)) {
        if (!$jageE(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $bcztx);
        return objIsArr || $03pXg(object) ? $d73Yq(object, other, bitmask, customizer, equalFunc, stack) : $3I8ZU(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $b0f909cda57cfca6$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $b0f909cda57cfca6$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $b0f909cda57cfca6$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $bcztx);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $bcztx);
    return $4hGi1(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $b0f909cda57cfca6$var$baseIsEqualDeep;

});
parcelRegister("d73Yq", function(module, exports) {

var $iPCwY = parcelRequire("iPCwY");

var $2ljjQ = parcelRequire("2ljjQ");

var $jWXQR = parcelRequire("jWXQR");
/** Used to compose bitmasks for value comparisons. */ var $98bf02e1462d8556$var$COMPARE_PARTIAL_FLAG = 1, $98bf02e1462d8556$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $98bf02e1462d8556$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $98bf02e1462d8556$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $98bf02e1462d8556$var$COMPARE_UNORDERED_FLAG ? new $iPCwY : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$2ljjQ(other, function(othValue, othIndex) {
                if (!$jWXQR(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = $98bf02e1462d8556$var$equalArrays;

});
parcelRegister("iPCwY", function(module, exports) {

var $czXxz = parcelRequire("czXxz");

var $2TzuM = parcelRequire("2TzuM");

var $drzX2 = parcelRequire("drzX2");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $db5ae0d92e4bd623$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $czXxz;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$db5ae0d92e4bd623$var$SetCache.prototype.add = $db5ae0d92e4bd623$var$SetCache.prototype.push = $2TzuM;
$db5ae0d92e4bd623$var$SetCache.prototype.has = $drzX2;
module.exports = $db5ae0d92e4bd623$var$SetCache;

});
parcelRegister("2TzuM", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $21bc407e4a6ca11d$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $21bc407e4a6ca11d$var$setCacheAdd(value) {
    this.__data__.set(value, $21bc407e4a6ca11d$var$HASH_UNDEFINED);
    return this;
}
module.exports = $21bc407e4a6ca11d$var$setCacheAdd;

});

parcelRegister("drzX2", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $9c99af273d3240d6$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $9c99af273d3240d6$var$setCacheHas;

});


parcelRegister("2ljjQ", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $1b4c874f0e0a19c3$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $1b4c874f0e0a19c3$var$arraySome;

});

parcelRegister("jWXQR", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e861dc677ed43f7d$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $e861dc677ed43f7d$var$cacheHas;

});


parcelRegister("3I8ZU", function(module, exports) {

var $56Gbz = parcelRequire("56Gbz");

var $2et7A = parcelRequire("2et7A");

var $94z4y = parcelRequire("94z4y");

var $d73Yq = parcelRequire("d73Yq");

var $gCJfw = parcelRequire("gCJfw");

var $fQAkw = parcelRequire("fQAkw");
/** Used to compose bitmasks for value comparisons. */ var $2b3c75e288c1ac37$var$COMPARE_PARTIAL_FLAG = 1, $2b3c75e288c1ac37$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $2b3c75e288c1ac37$var$boolTag = "[object Boolean]", $2b3c75e288c1ac37$var$dateTag = "[object Date]", $2b3c75e288c1ac37$var$errorTag = "[object Error]", $2b3c75e288c1ac37$var$mapTag = "[object Map]", $2b3c75e288c1ac37$var$numberTag = "[object Number]", $2b3c75e288c1ac37$var$regexpTag = "[object RegExp]", $2b3c75e288c1ac37$var$setTag = "[object Set]", $2b3c75e288c1ac37$var$stringTag = "[object String]", $2b3c75e288c1ac37$var$symbolTag = "[object Symbol]";
var $2b3c75e288c1ac37$var$arrayBufferTag = "[object ArrayBuffer]", $2b3c75e288c1ac37$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $2b3c75e288c1ac37$var$symbolProto = $56Gbz ? $56Gbz.prototype : undefined, $2b3c75e288c1ac37$var$symbolValueOf = $2b3c75e288c1ac37$var$symbolProto ? $2b3c75e288c1ac37$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $2b3c75e288c1ac37$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $2b3c75e288c1ac37$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $2b3c75e288c1ac37$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $2et7A(object), new $2et7A(other))) return false;
            return true;
        case $2b3c75e288c1ac37$var$boolTag:
        case $2b3c75e288c1ac37$var$dateTag:
        case $2b3c75e288c1ac37$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $94z4y(+object, +other);
        case $2b3c75e288c1ac37$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $2b3c75e288c1ac37$var$regexpTag:
        case $2b3c75e288c1ac37$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $2b3c75e288c1ac37$var$mapTag:
            var convert = $gCJfw;
        case $2b3c75e288c1ac37$var$setTag:
            var isPartial = bitmask & $2b3c75e288c1ac37$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $fQAkw);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $2b3c75e288c1ac37$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $d73Yq(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $2b3c75e288c1ac37$var$symbolTag:
            if ($2b3c75e288c1ac37$var$symbolValueOf) return $2b3c75e288c1ac37$var$symbolValueOf.call(object) == $2b3c75e288c1ac37$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $2b3c75e288c1ac37$var$equalByTag;

});
parcelRegister("2et7A", function(module, exports) {

var $fbsQc = parcelRequire("fbsQc");
/** Built-in value references. */ var $1a037a7befeab862$var$Uint8Array = $fbsQc.Uint8Array;
module.exports = $1a037a7befeab862$var$Uint8Array;

});

parcelRegister("gCJfw", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $c1a34b895c4e5d70$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $c1a34b895c4e5d70$var$mapToArray;

});

parcelRegister("fQAkw", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $b897e4b3e51fe95f$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $b897e4b3e51fe95f$var$setToArray;

});


parcelRegister("4hGi1", function(module, exports) {

var $aN7pp = parcelRequire("aN7pp");
/** Used to compose bitmasks for value comparisons. */ var $31e98dc9ff365c44$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $31e98dc9ff365c44$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $31e98dc9ff365c44$var$hasOwnProperty = $31e98dc9ff365c44$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $31e98dc9ff365c44$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $31e98dc9ff365c44$var$COMPARE_PARTIAL_FLAG, objProps = $aN7pp(object), objLength = objProps.length, othProps = $aN7pp(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $31e98dc9ff365c44$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = $31e98dc9ff365c44$var$equalObjects;

});
parcelRegister("aN7pp", function(module, exports) {

var $4OMfZ = parcelRequire("4OMfZ");

var $kqsZv = parcelRequire("kqsZv");

var $ldH3d = parcelRequire("ldH3d");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7db43a3f56f13990$var$getAllKeys(object) {
    return $4OMfZ(object, $ldH3d, $kqsZv);
}
module.exports = $7db43a3f56f13990$var$getAllKeys;

});
parcelRegister("4OMfZ", function(module, exports) {

var $1qvtu = parcelRequire("1qvtu");

var $epu4p = parcelRequire("epu4p");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $382143c1a6fc866d$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $epu4p(object) ? result : $1qvtu(result, symbolsFunc(object));
}
module.exports = $382143c1a6fc866d$var$baseGetAllKeys;

});
parcelRegister("1qvtu", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $10a0a2596e41e14e$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $10a0a2596e41e14e$var$arrayPush;

});


parcelRegister("kqsZv", function(module, exports) {

var $4LG6t = parcelRequire("4LG6t");

var $g7VYj = parcelRequire("g7VYj");
/** Used for built-in method references. */ var $edecb95d732ed507$var$objectProto = Object.prototype;
/** Built-in value references. */ var $edecb95d732ed507$var$propertyIsEnumerable = $edecb95d732ed507$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $edecb95d732ed507$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $edecb95d732ed507$var$getSymbols = !$edecb95d732ed507$var$nativeGetSymbols ? $g7VYj : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $4LG6t($edecb95d732ed507$var$nativeGetSymbols(object), function(symbol) {
        return $edecb95d732ed507$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $edecb95d732ed507$var$getSymbols;

});
parcelRegister("4LG6t", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $378c36108c179673$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $378c36108c179673$var$arrayFilter;

});

parcelRegister("g7VYj", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $bbda44c1737be57f$var$stubArray() {
    return [];
}
module.exports = $bbda44c1737be57f$var$stubArray;

});




parcelRegister("iHlaM", function(module, exports) {

var $38RsQ = parcelRequire("38RsQ");

var $c4hom = parcelRequire("c4hom");

var $dc5b5 = parcelRequire("dc5b5");

var $c6mom = parcelRequire("c6mom");

var $liOEB = parcelRequire("liOEB");

var $Yvcvv = parcelRequire("Yvcvv");

var $jdev5 = parcelRequire("jdev5");
/** `Object#toString` result references. */ var $d9ccaaa112bb6e7e$var$mapTag = "[object Map]", $d9ccaaa112bb6e7e$var$objectTag = "[object Object]", $d9ccaaa112bb6e7e$var$promiseTag = "[object Promise]", $d9ccaaa112bb6e7e$var$setTag = "[object Set]", $d9ccaaa112bb6e7e$var$weakMapTag = "[object WeakMap]";
var $d9ccaaa112bb6e7e$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $d9ccaaa112bb6e7e$var$dataViewCtorString = $jdev5($38RsQ), $d9ccaaa112bb6e7e$var$mapCtorString = $jdev5($c4hom), $d9ccaaa112bb6e7e$var$promiseCtorString = $jdev5($dc5b5), $d9ccaaa112bb6e7e$var$setCtorString = $jdev5($c6mom), $d9ccaaa112bb6e7e$var$weakMapCtorString = $jdev5($liOEB);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $d9ccaaa112bb6e7e$var$getTag = $Yvcvv;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($38RsQ && $d9ccaaa112bb6e7e$var$getTag(new $38RsQ(new ArrayBuffer(1))) != $d9ccaaa112bb6e7e$var$dataViewTag || $c4hom && $d9ccaaa112bb6e7e$var$getTag(new $c4hom) != $d9ccaaa112bb6e7e$var$mapTag || $dc5b5 && $d9ccaaa112bb6e7e$var$getTag($dc5b5.resolve()) != $d9ccaaa112bb6e7e$var$promiseTag || $c6mom && $d9ccaaa112bb6e7e$var$getTag(new $c6mom) != $d9ccaaa112bb6e7e$var$setTag || $liOEB && $d9ccaaa112bb6e7e$var$getTag(new $liOEB) != $d9ccaaa112bb6e7e$var$weakMapTag) $d9ccaaa112bb6e7e$var$getTag = function(value) {
    var result = $Yvcvv(value), Ctor = result == $d9ccaaa112bb6e7e$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $jdev5(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $d9ccaaa112bb6e7e$var$dataViewCtorString:
            return $d9ccaaa112bb6e7e$var$dataViewTag;
        case $d9ccaaa112bb6e7e$var$mapCtorString:
            return $d9ccaaa112bb6e7e$var$mapTag;
        case $d9ccaaa112bb6e7e$var$promiseCtorString:
            return $d9ccaaa112bb6e7e$var$promiseTag;
        case $d9ccaaa112bb6e7e$var$setCtorString:
            return $d9ccaaa112bb6e7e$var$setTag;
        case $d9ccaaa112bb6e7e$var$weakMapCtorString:
            return $d9ccaaa112bb6e7e$var$weakMapTag;
    }
    return result;
};
module.exports = $d9ccaaa112bb6e7e$var$getTag;

});
parcelRegister("38RsQ", function(module, exports) {

var $7oqXh = parcelRequire("7oqXh");

var $fbsQc = parcelRequire("fbsQc");
/* Built-in method references that are verified to be native. */ var $249b9757c648f5e7$var$DataView = $7oqXh($fbsQc, "DataView");
module.exports = $249b9757c648f5e7$var$DataView;

});

parcelRegister("dc5b5", function(module, exports) {

var $7oqXh = parcelRequire("7oqXh");

var $fbsQc = parcelRequire("fbsQc");
/* Built-in method references that are verified to be native. */ var $99b069919fabd61d$var$Promise = $7oqXh($fbsQc, "Promise");
module.exports = $99b069919fabd61d$var$Promise;

});

parcelRegister("c6mom", function(module, exports) {

var $7oqXh = parcelRequire("7oqXh");

var $fbsQc = parcelRequire("fbsQc");
/* Built-in method references that are verified to be native. */ var $8cf76a24c320ca4c$var$Set = $7oqXh($fbsQc, "Set");
module.exports = $8cf76a24c320ca4c$var$Set;

});

parcelRegister("liOEB", function(module, exports) {

var $7oqXh = parcelRequire("7oqXh");

var $fbsQc = parcelRequire("fbsQc");
/* Built-in method references that are verified to be native. */ var $f82292379ae88733$var$WeakMap = $7oqXh($fbsQc, "WeakMap");
module.exports = $f82292379ae88733$var$WeakMap;

});





parcelRegister("fheCJ", function(module, exports) {

var $hmbWe = parcelRequire("hmbWe");

var $ldH3d = parcelRequire("ldH3d");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $b1f3c97d5526a696$var$getMatchData(object) {
    var result = $ldH3d(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $hmbWe(value)
        ];
    }
    return result;
}
module.exports = $b1f3c97d5526a696$var$getMatchData;

});
parcelRegister("hmbWe", function(module, exports) {

var $7jN5Q = parcelRequire("7jN5Q");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $ca2dc0710ac56d3d$var$isStrictComparable(value) {
    return value === value && !$7jN5Q(value);
}
module.exports = $ca2dc0710ac56d3d$var$isStrictComparable;

});


parcelRegister("9VgJ5", function(module, exports) {
"use strict";
var $7396696ae156f484$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $7396696ae156f484$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7396696ae156f484$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7396696ae156f484$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $iSvIT = parcelRequire("iSvIT");

var $4J1z5 = parcelRequire("4J1z5");
var $7396696ae156f484$var$ALL_INITIALIZERS = [];
var $7396696ae156f484$var$READY_INITIALIZERS = [];
function $7396696ae156f484$var$isWebpackReady(getModuleIds) {
    if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $7396696ae156f484$var$_typeof(__webpack_modules__)) !== "object") return false;
    return getModuleIds().every(function(moduleId) {
        return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
    });
}
function $7396696ae156f484$var$load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $7396696ae156f484$var$loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function(key) {
            var result = $7396696ae156f484$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then(function(res) {
                state.loaded[key] = res;
            }).catch(function(err) {
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function(res) {
        state.loading = false;
        return res;
    }).catch(function(err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function $7396696ae156f484$var$resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function $7396696ae156f484$var$render(loaded, props) {
    return $iSvIT.createElement($7396696ae156f484$var$resolve(loaded), props);
}
function $7396696ae156f484$var$createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) throw new Error("react-loadable requires a `loading` component");
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $7396696ae156f484$var$render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $7396696ae156f484$var$ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === "function") $7396696ae156f484$var$READY_INITIALIZERS.push(function() {
        if ($7396696ae156f484$var$isWebpackReady(opts.webpack)) return init();
    });
    return _temp = _class = function(_React$Component) {
        $7396696ae156f484$var$_inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            $7396696ae156f484$var$_classCallCheck(this, LoadableComponent);
            var _this = $7396696ae156f484$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.retry = function() {
                _this.setState({
                    error: null,
                    loading: true,
                    timedOut: false
                });
                res = loadFn(opts.loader);
                _this._loadModule();
            };
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        LoadableComponent.prototype.componentWillMount = function componentWillMount() {
            this._mounted = true;
            this._loadModule();
        };
        LoadableComponent.prototype._loadModule = function _loadModule() {
            var _this2 = this;
            if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                _this2.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) this.setState({
                    pastDelay: true
                });
                else this._delay = setTimeout(function() {
                    _this2.setState({
                        pastDelay: true
                    });
                }, opts.delay);
            }
            if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                _this2.setState({
                    timedOut: true
                });
            }, opts.timeout);
            var update = function update() {
                if (!_this2._mounted) return;
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function() {
                update();
            }).catch(function(err) {
                update();
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) return $iSvIT.createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error,
                retry: this.retry
            });
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        };
        return LoadableComponent;
    }($iSvIT.Component), _class.contextTypes = {
        loadable: $4J1z5.shape({
            report: $4J1z5.func.isRequired
        })
    }, _temp;
}
function $7396696ae156f484$var$Loadable(opts) {
    return $7396696ae156f484$var$createLoadableComponent($7396696ae156f484$var$load, opts);
}
function $7396696ae156f484$var$LoadableMap(opts) {
    if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
    return $7396696ae156f484$var$createLoadableComponent($7396696ae156f484$var$loadMap, opts);
}
$7396696ae156f484$var$Loadable.Map = $7396696ae156f484$var$LoadableMap;
var $7396696ae156f484$var$Capture = function(_React$Component2) {
    $7396696ae156f484$var$_inherits(Capture, _React$Component2);
    function Capture() {
        $7396696ae156f484$var$_classCallCheck(this, Capture);
        return $7396696ae156f484$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return $iSvIT.Children.only(this.props.children);
    };
    return Capture;
}($iSvIT.Component);
$7396696ae156f484$var$Capture.propTypes = {
    report: $4J1z5.func.isRequired
};
$7396696ae156f484$var$Capture.childContextTypes = {
    loadable: $4J1z5.shape({
        report: $4J1z5.func.isRequired
    }).isRequired
};
$7396696ae156f484$var$Loadable.Capture = $7396696ae156f484$var$Capture;
function $7396696ae156f484$var$flushInitializers(initializers) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) return $7396696ae156f484$var$flushInitializers(initializers);
    });
}
$7396696ae156f484$var$Loadable.preloadAll = function() {
    return new Promise(function(resolve, reject) {
        $7396696ae156f484$var$flushInitializers($7396696ae156f484$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$7396696ae156f484$var$Loadable.preloadReady = function() {
    return new Promise(function(resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        $7396696ae156f484$var$flushInitializers($7396696ae156f484$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $7396696ae156f484$var$Loadable;

});

parcelRegister("7TCqn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bfb79bc88b0e3f3$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");
var $5bfb79bc88b0e3f3$var$BORDER_WIDTH = 2;
var $5bfb79bc88b0e3f3$var$baseFocusOutsideStyles = (0, $2ZUkg.css)({
    outline: "".concat($5bfb79bc88b0e3f3$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $5bfb79bc88b0e3f3$var$BORDER_WIDTH
});
var $5bfb79bc88b0e3f3$var$baseInsetStyles = (0, $2ZUkg.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$5bfb79bc88b0e3f3$var$BORDER_WIDTH,
    outlineStyle: "solid",
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $5bfb79bc88b0e3f3$var$focusRingStyles = (0, $2ZUkg.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $5bfb79bc88b0e3f3$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $5bfb79bc88b0e3f3$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $5bfb79bc88b0e3f3$var$insetFocusRingStyles = (0, $2ZUkg.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $5bfb79bc88b0e3f3$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $5bfb79bc88b0e3f3$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: "-1px"
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $5bfb79bc88b0e3f3$var$FocusRing = /*#__PURE__*/ (0, $iSvIT.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $5bfb79bc88b0e3f3$var$baseInsetStyles : $5bfb79bc88b0e3f3$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $5bfb79bc88b0e3f3$var$insetFocusRingStyles : $5bfb79bc88b0e3f3$var$focusRingStyles;
    var focusCls = typeof focus === "undefined" ? uncontrolledStyles : focus === "on" && controlledStyles;
    return (0, $2ZUkg.jsx)((0, $2ZUkg.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $iSvIT.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $iSvIT.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$5bfb79bc88b0e3f3$var$FocusRing.displayName = "FocusRing";
var $5bfb79bc88b0e3f3$export$2e2bcd8739ae039 = $5bfb79bc88b0e3f3$var$FocusRing;

});

parcelRegister("93oEi", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", function () { return $6977839df1b9e614$export$64d6499adf9b2e51; });

var $fEGTK = parcelRequire("fEGTK");
function $6977839df1b9e614$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $fEGTK.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("fEGTK", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $b65bde22e3268204$export$ce553301d55c2fd8; });
$parcel$export(module.exports, "COMMERCIAL", function () { return $b65bde22e3268204$export$f005e2e9f707cb5f; });
$parcel$export(module.exports, "FEDRAMP_FEDEX", function () { return $b65bde22e3268204$export$bd6b5a7802d76127; });
$parcel$export(module.exports, "STAGING", function () { return $b65bde22e3268204$export$a739cd5aac835909; });
$parcel$export(module.exports, "PRODUCTION", function () { return $b65bde22e3268204$export$42dd0cdd351a4a9; });
$parcel$export(module.exports, "DEV", function () { return $b65bde22e3268204$export$404582bc18fe4d9e; });
var $b65bde22e3268204$export$ce553301d55c2fd8 = "fedramp-moderate";
var $b65bde22e3268204$export$f005e2e9f707cb5f = "commercial";
var $b65bde22e3268204$export$bd6b5a7802d76127 = "fedramp-fedex";
var $b65bde22e3268204$export$a739cd5aac835909 = "stg";
var $b65bde22e3268204$export$42dd0cdd351a4a9 = "prod";
var $b65bde22e3268204$export$404582bc18fe4d9e = "dev";

});


parcelRegister("b2CZb", function(module, exports) {

$parcel$export(module.exports, "Reference", function () { return $809e1f5d1d16c321$export$e0be378c32fb70a7; });

var $iSvIT = parcelRequire("iSvIT");

var $cAgz7 = parcelRequire("cAgz7");

var $5X460 = parcelRequire("5X460");

var $cGW7B = parcelRequire("cGW7B");
function $809e1f5d1d16c321$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $iSvIT.useContext((0, $5X460.ManagerReferenceNodeSetterContext));
    var refHandler = $iSvIT.useCallback(function(node) {
        (0, $cGW7B.setRef)(innerRef, node);
        (0, $cGW7B.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $iSvIT.useEffect(function() {
        return function() {
            return (0, $cGW7B.setRef)(innerRef, null);
        };
    }, []);
    $iSvIT.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($cAgz7)))(Boolean(setReferenceNode), "`Reference` should not be used outside of a `Manager` component.");
    }, [
        setReferenceNode
    ]);
    return (0, $cGW7B.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("6YMo9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $514de1a4fc5682b2$export$2e2bcd8739ae039; });

var $8kwBW = parcelRequire("8kwBW");
function $514de1a4fc5682b2$var$isOptionsObject(options) {
    return options === Object(options) && Object.keys(options).length !== 0;
}
function $514de1a4fc5682b2$var$defaultBehavior(actions, behavior) {
    if (behavior === void 0) behavior = "auto";
    var canSmoothScroll = "scrollBehavior" in document.body.style;
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        if (el.scroll && canSmoothScroll) el.scroll({
            top: top,
            left: left,
            behavior: behavior
        });
        else {
            el.scrollTop = top;
            el.scrollLeft = left;
        }
    });
}
function $514de1a4fc5682b2$var$getOptions(options) {
    if (options === false) return {
        block: "end",
        inline: "nearest"
    };
    if ($514de1a4fc5682b2$var$isOptionsObject(options)) return options;
    return {
        block: "start",
        inline: "nearest"
    };
}
function $514de1a4fc5682b2$var$scrollIntoView(target, options) {
    var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);
    if ($514de1a4fc5682b2$var$isOptionsObject(options) && typeof options.behavior === "function") return options.behavior(isTargetAttached ? (0, $8kwBW.default)(target, options) : []);
    if (!isTargetAttached) return;
    var computeOptions = $514de1a4fc5682b2$var$getOptions(options);
    return $514de1a4fc5682b2$var$defaultBehavior((0, $8kwBW.default)(target, computeOptions), computeOptions.behavior);
}
var $514de1a4fc5682b2$export$2e2bcd8739ae039 = $514de1a4fc5682b2$var$scrollIntoView;

});
parcelRegister("8kwBW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f89cc8ce4080200e$export$2e2bcd8739ae039; });
function $f89cc8ce4080200e$var$t(t) {
    return "object" == typeof t && null != t && 1 === t.nodeType;
}
function $f89cc8ce4080200e$var$e(t, e) {
    return (!e || "hidden" !== t) && "visible" !== t && "clip" !== t;
}
function $f89cc8ce4080200e$var$n(t, n) {
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        var r = getComputedStyle(t, null);
        return $f89cc8ce4080200e$var$e(r.overflowY, n) || $f89cc8ce4080200e$var$e(r.overflowX, n) || function(t) {
            var e = function(t) {
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            }(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        }(t);
    }
    return !1;
}
function $f89cc8ce4080200e$var$r(t, e, n, r, i, o, l, d) {
    return o < t && l > e || o > t && l < e ? 0 : o <= t && d <= n || l >= e && d >= n ? o - t - r : l > e && d < n || o < t && d > n ? l - e + i : 0;
}
var $f89cc8ce4080200e$export$2e2bcd8739ae039 = function(e, i) {
    var o = window, l = i.scrollMode, d = i.block, f = i.inline, h = i.boundary, u = i.skipOverflowHiddenElements, s = "function" == typeof h ? h : function(t) {
        return t !== h;
    };
    if (!$f89cc8ce4080200e$var$t(e)) throw new TypeError("Invalid target");
    for(var a, c, g = document.scrollingElement || document.documentElement, p = [], m = e; $f89cc8ce4080200e$var$t(m) && s(m);){
        if ((m = null == (c = (a = m).parentElement) ? a.getRootNode().host || null : c) === g) {
            p.push(m);
            break;
        }
        null != m && m === document.body && $f89cc8ce4080200e$var$n(m) && !$f89cc8ce4080200e$var$n(document.documentElement) || null != m && $f89cc8ce4080200e$var$n(m, u) && p.push(m);
    }
    for(var w = o.visualViewport ? o.visualViewport.width : innerWidth, v = o.visualViewport ? o.visualViewport.height : innerHeight, W = window.scrollX || pageXOffset, H = window.scrollY || pageYOffset, b = e.getBoundingClientRect(), y = b.height, E = b.width, M = b.top, V = b.right, x = b.bottom, I = b.left, C = "start" === d || "nearest" === d ? M : "end" === d ? x : M + y / 2, R = "center" === f ? I + E / 2 : "end" === f ? V : I, T = [], k = 0; k < p.length; k++){
        var B = p[k], D = B.getBoundingClientRect(), O = D.height, X = D.width, Y = D.top, L = D.right, S = D.bottom, j = D.left;
        if ("if-needed" === l && M >= 0 && I >= 0 && x <= v && V <= w && M >= Y && x <= S && I >= j && V <= L) return T;
        var N = getComputedStyle(B), q = parseInt(N.borderLeftWidth, 10), z = parseInt(N.borderTopWidth, 10), A = parseInt(N.borderRightWidth, 10), F = parseInt(N.borderBottomWidth, 10), G = 0, J = 0, K = "offsetWidth" in B ? B.offsetWidth - B.clientWidth - q - A : 0, P = "offsetHeight" in B ? B.offsetHeight - B.clientHeight - z - F : 0, Q = "offsetWidth" in B ? 0 === B.offsetWidth ? 0 : X / B.offsetWidth : 0, U = "offsetHeight" in B ? 0 === B.offsetHeight ? 0 : O / B.offsetHeight : 0;
        if (g === B) G = "start" === d ? C : "end" === d ? C - v : "nearest" === d ? $f89cc8ce4080200e$var$r(H, H + v, v, z, F, H + C, H + C + y, y) : C - v / 2, J = "start" === f ? R : "center" === f ? R - w / 2 : "end" === f ? R - w : $f89cc8ce4080200e$var$r(W, W + w, w, q, A, W + R, W + R + E, E), G = Math.max(0, G + H), J = Math.max(0, J + W);
        else {
            G = "start" === d ? C - Y - z : "end" === d ? C - S + F + P : "nearest" === d ? $f89cc8ce4080200e$var$r(Y, S, O, z, F + P, C, C + y, y) : C - (Y + O / 2) + P / 2, J = "start" === f ? R - j - q : "center" === f ? R - (j + X / 2) + K / 2 : "end" === f ? R - L + A + K : $f89cc8ce4080200e$var$r(j, L, X, q, A + K, R, R + E, E);
            var Z = B.scrollLeft, $ = B.scrollTop;
            C += $ - (G = Math.max(0, Math.min($ + G / U, B.scrollHeight - O / U + P))), R += Z - (J = Math.max(0, Math.min(Z + J / Q, B.scrollWidth - X / Q + K)));
        }
        T.push({
            el: B,
            top: G,
            left: J
        });
    }
    return T;
};

});


parcelRegister("4199E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $b9DvP = parcelRequire("b9DvP");
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $2ece5b5247d7fd0c$var$_interopRequireDefault($b9DvP).default;
    }
});
function $2ece5b5247d7fd0c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("b9DvP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $81ef2f52e6d5c559$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $j9CIH = parcelRequire("j9CIH");

var $i5UxU = parcelRequire("i5UxU");
function $81ef2f52e6d5c559$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $81ef2f52e6d5c559$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $81ef2f52e6d5c559$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $81ef2f52e6d5c559$var$NodeResolver = function(_Component) {
    $81ef2f52e6d5c559$var$_inherits(NodeResolver, _Component);
    function NodeResolver() {
        $81ef2f52e6d5c559$var$_classCallCheck(this, NodeResolver);
        return $81ef2f52e6d5c559$var$_possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
    }
    $81ef2f52e6d5c559$var$_createClass(NodeResolver, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.innerRef((0, $i5UxU.findDOMNode)(this));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}($j9CIH.Component);
module.exports.default = $81ef2f52e6d5c559$var$NodeResolver;

});
parcelRegister("j9CIH", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8ji0h"));

});
parcelRegister("8ji0h", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $60ce102d73463f1d$export$dca3b0875bd9a954; }, function (v) { return $60ce102d73463f1d$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $60ce102d73463f1d$export$16fa2f45be04daa8; }, function (v) { return $60ce102d73463f1d$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $60ce102d73463f1d$export$ffb0004e005737fa; }, function (v) { return $60ce102d73463f1d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $60ce102d73463f1d$export$e2c29f18771995cb; }, function (v) { return $60ce102d73463f1d$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $60ce102d73463f1d$export$221d75b3f55bb0bd; }, function (v) { return $60ce102d73463f1d$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $60ce102d73463f1d$export$5f8d39834fd61797; }, function (v) { return $60ce102d73463f1d$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $60ce102d73463f1d$export$74bf444e3cd11ea5; }, function (v) { return $60ce102d73463f1d$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $60ce102d73463f1d$export$ae55be85d98224ed; }, function (v) { return $60ce102d73463f1d$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $60ce102d73463f1d$export$e530037191fcd5d7; }, function (v) { return $60ce102d73463f1d$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $60ce102d73463f1d$export$fd42f52fd3ae1109; }, function (v) { return $60ce102d73463f1d$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $60ce102d73463f1d$export$c8a8987d4410bf2d; }, function (v) { return $60ce102d73463f1d$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $60ce102d73463f1d$export$d38cd72104c1f0e9; }, function (v) { return $60ce102d73463f1d$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $60ce102d73463f1d$export$7d1e3a5e95ceca43; }, function (v) { return $60ce102d73463f1d$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $60ce102d73463f1d$export$257a8862b851cb5b; }, function (v) { return $60ce102d73463f1d$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $60ce102d73463f1d$export$a8257692ac88316c; }, function (v) { return $60ce102d73463f1d$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $60ce102d73463f1d$export$488013bae63b21da; }, function (v) { return $60ce102d73463f1d$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $60ce102d73463f1d$export$7c73462e0d25e514; }, function (v) { return $60ce102d73463f1d$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $60ce102d73463f1d$export$7568632d0d33d16d; }, function (v) { return $60ce102d73463f1d$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $60ce102d73463f1d$export$88948ce120ea2619; }, function (v) { return $60ce102d73463f1d$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $60ce102d73463f1d$export$35808ee640e87ca7; }, function (v) { return $60ce102d73463f1d$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $60ce102d73463f1d$export$fae74005e78b1a27; }, function (v) { return $60ce102d73463f1d$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $60ce102d73463f1d$export$dc8fbce3eb94dc1e; }, function (v) { return $60ce102d73463f1d$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $60ce102d73463f1d$export$6a7bc4e911dc01cf; }, function (v) { return $60ce102d73463f1d$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $60ce102d73463f1d$export$6d9c69b0de29b591; }, function (v) { return $60ce102d73463f1d$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $60ce102d73463f1d$export$f680877a34711e37; }, function (v) { return $60ce102d73463f1d$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $60ce102d73463f1d$export$d5a552a76deda3c2; }, function (v) { return $60ce102d73463f1d$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $60ce102d73463f1d$export$aaabe4eda9ed9969; }, function (v) { return $60ce102d73463f1d$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $60ce102d73463f1d$export$e5c5a5f917a5871c; }, function (v) { return $60ce102d73463f1d$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $60ce102d73463f1d$export$1538c33de8887b59; }, function (v) { return $60ce102d73463f1d$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $60ce102d73463f1d$export$13e3392192263954; }, function (v) { return $60ce102d73463f1d$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $60ce102d73463f1d$export$b8f5890fc79d6aca; }, function (v) { return $60ce102d73463f1d$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $60ce102d73463f1d$export$60241385465d0a34; }, function (v) { return $60ce102d73463f1d$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $60ce102d73463f1d$export$306c0aa65ff9ec16; }, function (v) { return $60ce102d73463f1d$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $60ce102d73463f1d$export$7b286972b8d8ccbf; }, function (v) { return $60ce102d73463f1d$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $60ce102d73463f1d$export$83d89fbfd8236492; }, function (v) { return $60ce102d73463f1d$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $60ce102d73463f1d$export$dca3b0875bd9a954;
var $60ce102d73463f1d$export$16fa2f45be04daa8;
var $60ce102d73463f1d$export$ffb0004e005737fa;
var $60ce102d73463f1d$export$e2c29f18771995cb;
var $60ce102d73463f1d$export$221d75b3f55bb0bd;
var $60ce102d73463f1d$export$5f8d39834fd61797;
var $60ce102d73463f1d$export$74bf444e3cd11ea5;
var $60ce102d73463f1d$export$ae55be85d98224ed;
var $60ce102d73463f1d$export$e530037191fcd5d7;
var $60ce102d73463f1d$export$fd42f52fd3ae1109;
var $60ce102d73463f1d$export$c8a8987d4410bf2d;
var $60ce102d73463f1d$export$d38cd72104c1f0e9;
var $60ce102d73463f1d$export$7d1e3a5e95ceca43;
var $60ce102d73463f1d$export$257a8862b851cb5b;
var $60ce102d73463f1d$export$a8257692ac88316c;
var $60ce102d73463f1d$export$488013bae63b21da;
var $60ce102d73463f1d$export$7c73462e0d25e514;
var $60ce102d73463f1d$export$7568632d0d33d16d;
var $60ce102d73463f1d$export$88948ce120ea2619;
var $60ce102d73463f1d$export$35808ee640e87ca7;
var $60ce102d73463f1d$export$fae74005e78b1a27;
var $60ce102d73463f1d$export$dc8fbce3eb94dc1e;
var $60ce102d73463f1d$export$6a7bc4e911dc01cf;
var $60ce102d73463f1d$export$6d9c69b0de29b591;
var $60ce102d73463f1d$export$f680877a34711e37;
var $60ce102d73463f1d$export$d5a552a76deda3c2;
var $60ce102d73463f1d$export$aaabe4eda9ed9969;
var $60ce102d73463f1d$export$e5c5a5f917a5871c;
var $60ce102d73463f1d$export$1538c33de8887b59;
var $60ce102d73463f1d$export$13e3392192263954;
var $60ce102d73463f1d$export$b8f5890fc79d6aca;
var $60ce102d73463f1d$export$60241385465d0a34;
var $60ce102d73463f1d$export$306c0aa65ff9ec16;
var $60ce102d73463f1d$export$7b286972b8d8ccbf;
var $60ce102d73463f1d$export$83d89fbfd8236492;
"use strict";
var $60ce102d73463f1d$var$l = Symbol.for("react.element"), $60ce102d73463f1d$var$n = Symbol.for("react.portal"), $60ce102d73463f1d$var$p = Symbol.for("react.fragment"), $60ce102d73463f1d$var$q = Symbol.for("react.strict_mode"), $60ce102d73463f1d$var$r = Symbol.for("react.profiler"), $60ce102d73463f1d$var$t = Symbol.for("react.provider"), $60ce102d73463f1d$var$u = Symbol.for("react.context"), $60ce102d73463f1d$var$v = Symbol.for("react.forward_ref"), $60ce102d73463f1d$var$w = Symbol.for("react.suspense"), $60ce102d73463f1d$var$x = Symbol.for("react.memo"), $60ce102d73463f1d$var$y = Symbol.for("react.lazy"), $60ce102d73463f1d$var$z = Symbol.iterator;
function $60ce102d73463f1d$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $60ce102d73463f1d$var$z && a[$60ce102d73463f1d$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $60ce102d73463f1d$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $60ce102d73463f1d$var$C = Object.assign, $60ce102d73463f1d$var$D = {};
function $60ce102d73463f1d$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $60ce102d73463f1d$var$D;
    this.updater = e || $60ce102d73463f1d$var$B;
}
$60ce102d73463f1d$var$E.prototype.isReactComponent = {};
$60ce102d73463f1d$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$60ce102d73463f1d$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $60ce102d73463f1d$var$F() {}
$60ce102d73463f1d$var$F.prototype = $60ce102d73463f1d$var$E.prototype;
function $60ce102d73463f1d$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $60ce102d73463f1d$var$D;
    this.updater = e || $60ce102d73463f1d$var$B;
}
var $60ce102d73463f1d$var$H = $60ce102d73463f1d$var$G.prototype = new $60ce102d73463f1d$var$F;
$60ce102d73463f1d$var$H.constructor = $60ce102d73463f1d$var$G;
$60ce102d73463f1d$var$C($60ce102d73463f1d$var$H, $60ce102d73463f1d$var$E.prototype);
$60ce102d73463f1d$var$H.isPureReactComponent = !0;
var $60ce102d73463f1d$var$I = Array.isArray, $60ce102d73463f1d$var$J = Object.prototype.hasOwnProperty, $60ce102d73463f1d$var$K = {
    current: null
}, $60ce102d73463f1d$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $60ce102d73463f1d$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$60ce102d73463f1d$var$J.call(b, d) && !$60ce102d73463f1d$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $60ce102d73463f1d$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $60ce102d73463f1d$var$K.current
    };
}
function $60ce102d73463f1d$var$N(a, b) {
    return {
        $$typeof: $60ce102d73463f1d$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $60ce102d73463f1d$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $60ce102d73463f1d$var$l;
}
function $60ce102d73463f1d$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $60ce102d73463f1d$var$P = /\/+/g;
function $60ce102d73463f1d$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $60ce102d73463f1d$var$escape("" + a.key) : b.toString(36);
}
function $60ce102d73463f1d$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $60ce102d73463f1d$var$l:
                case $60ce102d73463f1d$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $60ce102d73463f1d$var$Q(h, 0) : d, $60ce102d73463f1d$var$I(c) ? (e = "", null != a && (e = a.replace($60ce102d73463f1d$var$P, "$&/") + "/"), $60ce102d73463f1d$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($60ce102d73463f1d$var$O(c) && (c = $60ce102d73463f1d$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($60ce102d73463f1d$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($60ce102d73463f1d$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $60ce102d73463f1d$var$Q(k, g);
        h += $60ce102d73463f1d$var$R(k, b, e, f, c);
    }
    else if (f = $60ce102d73463f1d$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $60ce102d73463f1d$var$Q(k, g++), h += $60ce102d73463f1d$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $60ce102d73463f1d$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $60ce102d73463f1d$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $60ce102d73463f1d$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $60ce102d73463f1d$var$U = {
    current: null
}, $60ce102d73463f1d$var$V = {
    transition: null
}, $60ce102d73463f1d$var$W = {
    ReactCurrentDispatcher: $60ce102d73463f1d$var$U,
    ReactCurrentBatchConfig: $60ce102d73463f1d$var$V,
    ReactCurrentOwner: $60ce102d73463f1d$var$K
};
$60ce102d73463f1d$export$dca3b0875bd9a954 = {
    map: $60ce102d73463f1d$var$S,
    forEach: function(a, b, e) {
        $60ce102d73463f1d$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $60ce102d73463f1d$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $60ce102d73463f1d$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$60ce102d73463f1d$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$60ce102d73463f1d$export$16fa2f45be04daa8 = $60ce102d73463f1d$var$E;
$60ce102d73463f1d$export$ffb0004e005737fa = $60ce102d73463f1d$var$p;
$60ce102d73463f1d$export$e2c29f18771995cb = $60ce102d73463f1d$var$r;
$60ce102d73463f1d$export$221d75b3f55bb0bd = $60ce102d73463f1d$var$G;
$60ce102d73463f1d$export$5f8d39834fd61797 = $60ce102d73463f1d$var$q;
$60ce102d73463f1d$export$74bf444e3cd11ea5 = $60ce102d73463f1d$var$w;
$60ce102d73463f1d$export$ae55be85d98224ed = $60ce102d73463f1d$var$W;
$60ce102d73463f1d$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $60ce102d73463f1d$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $60ce102d73463f1d$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$60ce102d73463f1d$var$J.call(b, f) && !$60ce102d73463f1d$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $60ce102d73463f1d$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$60ce102d73463f1d$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $60ce102d73463f1d$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $60ce102d73463f1d$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$60ce102d73463f1d$export$c8a8987d4410bf2d = $60ce102d73463f1d$var$M;
$60ce102d73463f1d$export$d38cd72104c1f0e9 = function(a) {
    var b = $60ce102d73463f1d$var$M.bind(null, a);
    b.type = a;
    return b;
};
$60ce102d73463f1d$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$60ce102d73463f1d$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $60ce102d73463f1d$var$v,
        render: a
    };
};
$60ce102d73463f1d$export$a8257692ac88316c = $60ce102d73463f1d$var$O;
$60ce102d73463f1d$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $60ce102d73463f1d$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $60ce102d73463f1d$var$T
    };
};
$60ce102d73463f1d$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $60ce102d73463f1d$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$60ce102d73463f1d$export$7568632d0d33d16d = function(a) {
    var b = $60ce102d73463f1d$var$V.transition;
    $60ce102d73463f1d$var$V.transition = {};
    try {
        a();
    } finally{
        $60ce102d73463f1d$var$V.transition = b;
    }
};
$60ce102d73463f1d$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$60ce102d73463f1d$export$35808ee640e87ca7 = function(a, b) {
    return $60ce102d73463f1d$var$U.current.useCallback(a, b);
};
$60ce102d73463f1d$export$fae74005e78b1a27 = function(a) {
    return $60ce102d73463f1d$var$U.current.useContext(a);
};
$60ce102d73463f1d$export$dc8fbce3eb94dc1e = function() {};
$60ce102d73463f1d$export$6a7bc4e911dc01cf = function(a) {
    return $60ce102d73463f1d$var$U.current.useDeferredValue(a);
};
$60ce102d73463f1d$export$6d9c69b0de29b591 = function(a, b) {
    return $60ce102d73463f1d$var$U.current.useEffect(a, b);
};
$60ce102d73463f1d$export$f680877a34711e37 = function() {
    return $60ce102d73463f1d$var$U.current.useId();
};
$60ce102d73463f1d$export$d5a552a76deda3c2 = function(a, b, e) {
    return $60ce102d73463f1d$var$U.current.useImperativeHandle(a, b, e);
};
$60ce102d73463f1d$export$aaabe4eda9ed9969 = function(a, b) {
    return $60ce102d73463f1d$var$U.current.useInsertionEffect(a, b);
};
$60ce102d73463f1d$export$e5c5a5f917a5871c = function(a, b) {
    return $60ce102d73463f1d$var$U.current.useLayoutEffect(a, b);
};
$60ce102d73463f1d$export$1538c33de8887b59 = function(a, b) {
    return $60ce102d73463f1d$var$U.current.useMemo(a, b);
};
$60ce102d73463f1d$export$13e3392192263954 = function(a, b, e) {
    return $60ce102d73463f1d$var$U.current.useReducer(a, b, e);
};
$60ce102d73463f1d$export$b8f5890fc79d6aca = function(a) {
    return $60ce102d73463f1d$var$U.current.useRef(a);
};
$60ce102d73463f1d$export$60241385465d0a34 = function(a) {
    return $60ce102d73463f1d$var$U.current.useState(a);
};
$60ce102d73463f1d$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $60ce102d73463f1d$var$U.current.useSyncExternalStore(a, b, e);
};
$60ce102d73463f1d$export$7b286972b8d8ccbf = function() {
    return $60ce102d73463f1d$var$U.current.useTransition();
};
$60ce102d73463f1d$export$83d89fbfd8236492 = "18.2.0";

});




parcelRegister("cpshT", function(module, exports) {

$parcel$export(module.exports, "easeInOut", function () { return $908dc3283992213c$export$c07234257a03d5e9; });
$parcel$export(module.exports, "easeOut", function () { return $908dc3283992213c$export$57636bb43b1ccbb0; });
var $908dc3283992213c$export$c07234257a03d5e9 = "cubic-bezier(0.15,1,0.3,1)";
var $908dc3283992213c$export$57636bb43b1ccbb0 = "cubic-bezier(0.2,0,0,1)";
var $908dc3283992213c$export$929e5a82286172a6 = "cubic-bezier(0.8,0,0,0.8)";
var $908dc3283992213c$export$45db2fc2f15997e7 = "cubic-bezier(0,0,1,1)";

});

parcelRegister("gZpCZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5e638ff765781e0$export$2e2bcd8739ae039; });

var $iwGlz = parcelRequire("iwGlz");

var $7UBII = parcelRequire("7UBII");

var $CqSRY = parcelRequire("CqSRY");

var $iPRKF = parcelRequire("iPRKF");

var $8tDm5 = parcelRequire("8tDm5");

var $kBf8F = parcelRequire("kBf8F");

var $izOL3 = parcelRequire("izOL3");
function $c5e638ff765781e0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c5e638ff765781e0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c5e638ff765781e0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iwGlz.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c5e638ff765781e0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $c5e638ff765781e0$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
const $c5e638ff765781e0$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
class $c5e638ff765781e0$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers.captureException) this.handlers.captureException(e, tags);
    }
    async fetchAndCacheArtifact(artifact, retryConfig) {
        const response = await (0, $7UBII.retryOnException)(async ()=>{
            try {
                // await the result here so that we capture any errors
                const result = await (0, $iPRKF.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                return result;
            } catch (error) {
                throw new (0, $8tDm5.default)({
                    artifact: artifact.key,
                    dimensions: artifact.dimensions,
                    error: error
                });
            }
        }, {
            captureException: this.captureException,
            retryOn: (err)=>$c5e638ff765781e0$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
            intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
            onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
        });
        if (!response) {
            const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
            this.captureException(missingArtifactError);
            throw missingArtifactError;
        }
        this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
        // Clear the in-flight check
        this.fetchFromFlightDeckPromises.delete(artifact.key);
        return response;
    }
    async fetchArtifactPromise(artifact, retryConfig) {
        // Check for in-flight requests for this artifact
        if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
        const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
        this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
        return fetchPromise;
    }
    async fetchConfigFromFlightDeck(artifact, retryConfig) {
        const experience = (0, $izOL3.flightDeckClientExperience)();
        experience.start();
        try {
            const artifactWithKey = $c5e638ff765781e0$var$_objectSpread($c5e638ff765781e0$var$_objectSpread({}, artifact), {}, {
                key: (0, $kBf8F.artifactKey)(artifact.name, artifact.dimensions)
            });
            experience.addMetadata({
                key: artifactWithKey.key,
                product: this.product
            });
            // Create the promise to fetch the config, we only need to await this if we don't have local config
            const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
            // Check local storage for the artifact
            const localConfig = this.storageClient.getItem(artifactWithKey.key);
            if (localConfig) {
                experience.addMetadata({
                    configSource: "localStorage"
                });
                return localConfig;
            }
            // Was a fallback config provided?
            if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                experience.addMetadata({
                    configSource: "fallback"
                });
                return this.fallbackArtifactMap.get(artifactWithKey.key);
            }
            experience.addMetadata({
                configSource: "fetch"
            });
            // No local copies of config, await FD fetch promise here so that we can capture any errors & fail the experience
            const result = await artifactPromise;
            return result;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: (0, $izOL3.exceptionToMetadata)(e)
                }
            });
            throw e;
        } finally{
            // if the experience has been failed in the "catch" block, calling "success" will have no effect
            experience.success();
        }
    }
    constructor(product, options = {
        handlers: {}
    }, fallbackArtifacts = []){
        (0, $iwGlz.default)(this, "fallbackArtifactMap", new Map());
        (0, $iwGlz.default)(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $CqSRY.default)($c5e638ff765781e0$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, $kBf8F.artifactKey)(artifact.name, artifact.dimensions), artifact.value));
        this.captureException = this.captureException.bind(this);
    }
}

});
parcelRegister("iwGlz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7cc106050ef85b8$export$2e2bcd8739ae039; });

var $gthAS = parcelRequire("gthAS");
function $d7cc106050ef85b8$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $gthAS.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("gthAS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfdd008b18e0bd09$export$2e2bcd8739ae039; });

var $iRuFs = parcelRequire("iRuFs");

var $3qfLB = parcelRequire("3qfLB");
function $bfdd008b18e0bd09$export$2e2bcd8739ae039(t) {
    var i = (0, $3qfLB.default)(t, "string");
    return "symbol" == (0, $iRuFs.default)(i) ? i : i + "";
}

});
parcelRegister("iRuFs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbb4f7323fe22ac7$export$2e2bcd8739ae039; });
function $dbb4f7323fe22ac7$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $dbb4f7323fe22ac7$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dbb4f7323fe22ac7$export$2e2bcd8739ae039(o);
}

});

parcelRegister("3qfLB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27e007c41b8b9b40$export$2e2bcd8739ae039; });

var $iRuFs = parcelRequire("iRuFs");
function $27e007c41b8b9b40$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $iRuFs.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $iRuFs.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("7UBII", function(module, exports) {

$parcel$export(module.exports, "retryOnException", function () { return $5c2b05cc74bb143e$export$1d94629c94e7a17f; });

var $avIa0 = parcelRequire("avIa0");

var $lNpP6 = parcelRequire("lNpP6");

var $8nhgi = parcelRequire("8nhgi");

var $FAyzE = parcelRequire("FAyzE");

var $kVaHx = parcelRequire("kVaHx");

var $ZlMDX = parcelRequire("ZlMDX");
var $5c2b05cc74bb143e$export$5c069c93d2b7493f = function wait(ms) {
    return new Promise(function(resolve) {
        setTimeout(resolve, ms);
    });
};
var $5c2b05cc74bb143e$var$NO_CALLS_ERROR = "No calls made";
var $5c2b05cc74bb143e$export$1d94629c94e7a17f = /*#__PURE__*/ function() {
    var _ref2 = (0, $lNpP6.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nhgi))).mark(function _callee(invokeOperation, _ref) {
        var _ref$intervalsMS, intervalsMS, _ref$retryOn, retryOn, captureException, onRetry, intervals, nextMSInterval, error;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8nhgi))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _ref$intervalsMS = _ref.intervalsMS, intervalsMS = _ref$intervalsMS === void 0 ? (0, $kVaHx.NO_RETRIES) : _ref$intervalsMS, _ref$retryOn = _ref.retryOn, retryOn = _ref$retryOn === void 0 ? [
                        (0, $ZlMDX.default)
                    ] : _ref$retryOn, captureException = _ref.captureException, onRetry = _ref.onRetry;
                    intervals = (0, $avIa0.default)(intervalsMS);
                    nextMSInterval = 0;
                    error = new Error($5c2b05cc74bb143e$var$NO_CALLS_ERROR);
                case 4:
                    if (!(nextMSInterval !== undefined)) {
                        _context.next = 22;
                        break;
                    }
                    _context.prev = 5;
                    if (!(nextMSInterval > 0)) {
                        _context.next = 9;
                        break;
                    }
                    _context.next = 9;
                    return $5c2b05cc74bb143e$export$5c069c93d2b7493f(nextMSInterval);
                case 9:
                    if (onRetry && error.message !== $5c2b05cc74bb143e$var$NO_CALLS_ERROR) onRetry(error);
                    _context.next = 12;
                    return invokeOperation();
                case 12:
                    return _context.abrupt("return", _context.sent);
                case 15:
                    _context.prev = 15;
                    _context.t0 = _context["catch"](5);
                    error = (0, $FAyzE.default)(_context.t0);
                    if (captureException) captureException(error);
                    // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
                    // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
                    if (typeof retryOn === "function" ? retryOn(error) : retryOn.some(function(err) {
                        return error instanceof err;
                    })) nextMSInterval = intervals.shift();
                    else nextMSInterval = undefined;
                case 20:
                    _context.next = 4;
                    break;
                case 22:
                    throw error;
                case 23:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                5,
                15
            ]
        ]);
    }));
    return function retryOnException(_x, _x2) {
        return _ref2.apply(this, arguments);
    };
}();

});
parcelRegister("avIa0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a6f0df4711df9a5$export$2e2bcd8739ae039; });

var $bA1SV = parcelRequire("bA1SV");

var $ddBnA = parcelRequire("ddBnA");

var $aXjd0 = parcelRequire("aXjd0");

var $lTiT4 = parcelRequire("lTiT4");
function $7a6f0df4711df9a5$export$2e2bcd8739ae039(r) {
    return (0, $bA1SV.default)(r) || (0, $ddBnA.default)(r) || (0, $aXjd0.default)(r) || (0, $lTiT4.default)();
}

});
parcelRegister("bA1SV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86e484cac0da127b$export$2e2bcd8739ae039; });

var $0422b = parcelRequire("0422b");
function $86e484cac0da127b$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $0422b.default)(r);
}

});
parcelRegister("0422b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00c1f3cfbd5e3c70$export$2e2bcd8739ae039; });
function $00c1f3cfbd5e3c70$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("ddBnA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99f97c03916b6e60$export$2e2bcd8739ae039; });
function $99f97c03916b6e60$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("aXjd0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f9e508715548bbc$export$2e2bcd8739ae039; });

var $0422b = parcelRequire("0422b");
function $7f9e508715548bbc$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $0422b.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $0422b.default)(r, a) : void 0;
    }
}

});

parcelRegister("lTiT4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fefd629f0ffacc30$export$2e2bcd8739ae039; });
function $fefd629f0ffacc30$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("lNpP6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fde2348535f210a1$export$2e2bcd8739ae039; });
function $fde2348535f210a1$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $fde2348535f210a1$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $fde2348535f210a1$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $fde2348535f210a1$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("8nhgi", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $618ddc8f5284fa4a$var$runtime = (parcelRequire("iZnTb"))();
module.exports = $618ddc8f5284fa4a$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $618ddc8f5284fa4a$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $618ddc8f5284fa4a$var$runtime;
    else Function("r", "regeneratorRuntime = r")($618ddc8f5284fa4a$var$runtime);
}

});
parcelRegister("iZnTb", function(module, exports) {

var $haG0u = parcelRequire("haG0u");

var $iEL29 = parcelRequire("iEL29");

var $7zq0M = parcelRequire("7zq0M");

var $4soI1 = parcelRequire("4soI1");

var $iqGes = parcelRequire("iqGes");

var $3le1B = parcelRequire("3le1B");

var $2IKCu = parcelRequire("2IKCu");
function $dd30745cae401186$var$_regeneratorRuntime() {
    "use strict";
    var r = $iEL29(), e = r.m($dd30745cae401186$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $2IKCu(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $dd30745cae401186$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $haG0u(r, e);
            },
            AsyncIterator: $iqGes,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $4soI1 : $7zq0M)(a(r), e, t, o, u);
            },
            keys: $3le1B,
            values: $2IKCu
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $dd30745cae401186$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("haG0u", function(module, exports) {
function $c803f4879194806a$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $c803f4879194806a$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iEL29", function(module, exports) {

var $9jBE9 = parcelRequire("9jBE9");
function $d950725bcd325ee2$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $9jBE9(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($9jBE9(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $9jBE9(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $9jBE9(u, "constructor", GeneratorFunctionPrototype), $9jBE9(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $9jBE9(GeneratorFunctionPrototype, o, "GeneratorFunction"), $9jBE9(u), $9jBE9(u, o, "Generator"), $9jBE9(u, n, function() {
        return this;
    }), $9jBE9(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $d950725bcd325ee2$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $d950725bcd325ee2$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9jBE9", function(module, exports) {
function $6c831736d061bde2$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $6c831736d061bde2$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $6c831736d061bde2$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $6c831736d061bde2$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $6c831736d061bde2$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("7zq0M", function(module, exports) {

var $4soI1 = parcelRequire("4soI1");
function $582ffaa4fd9fff19$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $4soI1(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $582ffaa4fd9fff19$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4soI1", function(module, exports) {

var $iEL29 = parcelRequire("iEL29");

var $iqGes = parcelRequire("iqGes");
function $33ecf1a107217293$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $iqGes($iEL29().w(r, e, t, o), n || Promise);
}
module.exports = $33ecf1a107217293$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("iqGes", function(module, exports) {

var $haG0u = parcelRequire("haG0u");

var $9jBE9 = parcelRequire("9jBE9");
function $d6ab6a24d81ba01e$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $haG0u ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($9jBE9($d6ab6a24d81ba01e$var$AsyncIterator.prototype), $9jBE9($d6ab6a24d81ba01e$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $9jBE9(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $d6ab6a24d81ba01e$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("3le1B", function(module, exports) {
function $26ee36498d166885$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $26ee36498d166885$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2IKCu", function(module, exports) {

var $bXTo1 = parcelRequire("bXTo1");
var $1fb3da8b8350bfa3$var$_typeof = $bXTo1.default;
function $1fb3da8b8350bfa3$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($1fb3da8b8350bfa3$var$_typeof(e) + " is not iterable");
}
module.exports = $1fb3da8b8350bfa3$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bXTo1", function(module, exports) {
function $8b602afe194136de$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $8b602afe194136de$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $8b602afe194136de$var$_typeof(o);
}
module.exports = $8b602afe194136de$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("FAyzE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07d02fd69fff0911$export$2e2bcd8739ae039; });

var $iRuFs = parcelRequire("iRuFs");
var $07d02fd69fff0911$var$convertToError = function convertToError(e) {
    var error;
    if (e instanceof Error) error = e;
    else if (typeof e === "string") error = new Error(e);
    else if ((0, $iRuFs.default)(e) === "object") try {
        error = new Error("Object error instance thrown for operation: " + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error("Object serialisation error thrown during operation: " + String(e));
    }
    else error = new Error("No error instance thrown for operation: " + String(e));
    return error;
};
var $07d02fd69fff0911$export$2e2bcd8739ae039 = $07d02fd69fff0911$var$convertToError;

});

parcelRegister("kVaHx", function(module, exports) {

$parcel$export(module.exports, "NO_RETRIES", function () { return $f3b16e8a2a251da3$export$a0a1c8f90becc136; });
var $f3b16e8a2a251da3$export$a0a1c8f90becc136 = [];
var $f3b16e8a2a251da3$export$972171517b12aa4 = [
    0,
    0
];
var $f3b16e8a2a251da3$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
var $f3b16e8a2a251da3$export$f6858378b665f957 = [
    100,
    500,
    1000
];

});

parcelRegister("ZlMDX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b86986240ab9d13$export$2e2bcd8739ae039; });

var $fuVkU = parcelRequire("fuVkU");

var $bMcPT = parcelRequire("bMcPT");

var $1TMxq = parcelRequire("1TMxq");

var $6bt80 = parcelRequire("6bt80");

var $df5mh = parcelRequire("df5mh");

var $cGJBv = parcelRequire("cGJBv");
function $0b86986240ab9d13$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0b86986240ab9d13$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $df5mh.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $df5mh.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6bt80.default)(this, result);
    };
}
function $0b86986240ab9d13$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $0b86986240ab9d13$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    (0, $1TMxq.default)(FailedFetchError, _Error);
    var _super = $0b86986240ab9d13$var$_createSuper(FailedFetchError);
    function FailedFetchError(_ref) {
        var _this;
        var error = _ref.error, path = _ref.path, method = _ref.method;
        (0, $bMcPT.default)(this, FailedFetchError);
        _this = _super.call(this);
        _this.name = "FailedFetchError";
        _this.message = error.message || "Unknown fetch error";
        _this.stack = error.stack;
        _this.originalName = error.name;
        _this.method = method;
        var p = path.split("?")[0];
        _this.path = /^[/-a-z]+$/i.test(p) ? p : "";
        return _this;
    }
    return (0, $fuVkU.default)(FailedFetchError);
}(/*#__PURE__*/ (0, $cGJBv.default)(Error));

});
parcelRegister("fuVkU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4862223402db196$export$2e2bcd8739ae039; });

var $gthAS = parcelRequire("gthAS");
function $b4862223402db196$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $gthAS.default)(o.key), o);
    }
}
function $b4862223402db196$export$2e2bcd8739ae039(e, r, t) {
    return r && $b4862223402db196$var$_defineProperties(e.prototype, r), t && $b4862223402db196$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("bMcPT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $892e225750709a0d$export$2e2bcd8739ae039; });
function $892e225750709a0d$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("1TMxq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16209423a1a85ada$export$2e2bcd8739ae039; });

var $dlSFY = parcelRequire("dlSFY");
function $16209423a1a85ada$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $dlSFY.default)(t, e);
}

});
parcelRegister("dlSFY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b87a60565090c2b$export$2e2bcd8739ae039; });
function $9b87a60565090c2b$export$2e2bcd8739ae039(t, e) {
    return $9b87a60565090c2b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $9b87a60565090c2b$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("6bt80", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $480a5d68d54ae0d1$export$2e2bcd8739ae039; });

var $iRuFs = parcelRequire("iRuFs");

var $f1CGn = parcelRequire("f1CGn");
function $480a5d68d54ae0d1$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $iRuFs.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $f1CGn.default)(t);
}

});
parcelRegister("f1CGn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af04f48e8e97c93e$export$2e2bcd8739ae039; });
function $af04f48e8e97c93e$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("df5mh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a40d52107730386$export$2e2bcd8739ae039; });
function $9a40d52107730386$export$2e2bcd8739ae039(t) {
    return $9a40d52107730386$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $9a40d52107730386$export$2e2bcd8739ae039(t);
}

});

parcelRegister("cGJBv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93ccc8401fccf0ea$export$2e2bcd8739ae039; });

var $df5mh = parcelRequire("df5mh");

var $dlSFY = parcelRequire("dlSFY");

var $fkTPz = parcelRequire("fkTPz");

var $55UEt = parcelRequire("55UEt");
function $93ccc8401fccf0ea$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $93ccc8401fccf0ea$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $fkTPz.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $55UEt.default)(t, arguments, (0, $df5mh.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $dlSFY.default)(Wrapper, t);
    }, $93ccc8401fccf0ea$export$2e2bcd8739ae039(t);
}

});
parcelRegister("fkTPz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2a4081f30038c13$export$2e2bcd8739ae039; });
function $b2a4081f30038c13$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("55UEt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b595d3ead778f56$export$2e2bcd8739ae039; });

var $1WB2m = parcelRequire("1WB2m");

var $dlSFY = parcelRequire("dlSFY");
function $3b595d3ead778f56$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $1WB2m.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $dlSFY.default)(p, r.prototype), p;
}

});
parcelRegister("1WB2m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16a7f00782c8ce42$export$2e2bcd8739ae039; });
function $16a7f00782c8ce42$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($16a7f00782c8ce42$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});





parcelRegister("CqSRY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $073867535d265287$export$2e2bcd8739ae039; });

var $bMcPT = parcelRequire("bMcPT");

var $fuVkU = parcelRequire("fuVkU");

var $iwGlz = parcelRequire("iwGlz");

var $rylkD = parcelRequire("rylkD");
var $073867535d265287$var$DEFAULT_STORAGE_ENGINE = "localStorage";
var $073867535d265287$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function StorageClient(clientKey, options) {
        var _this = this;
        (0, $bMcPT.default)(this, StorageClient);
        (0, $iwGlz.default)(this, "getItem", function(key) {
            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                useExpiredItem: false
            }, useExpiredItem = _ref.useExpiredItem;
            var item = _this.client.getItem(_this.itemKey(key));
            if (item) try {
                var parsedItem = JSON.parse(item);
                // item is expired
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    /**
             * Commented out removing this item, as it is a slightly different state
             * to the item not existing that we may want to preserve.
             *  this.client.removeItem(this.itemKey(key));
             */ if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                _this.captureException(e);
            }
            return undefined;
        });
        (0, $iwGlz.default)(this, "removeItem", function(key) {
            try {
                _this.client.removeItem(_this.itemKey(key));
            } catch (e) {
                _this.captureException(e);
            }
        });
        (0, $iwGlz.default)(this, "setItemWithExpiry", function(key, value, expireInMS) {
            var itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === "number" ? Date.now() + expireInMS : undefined
            };
            try {
                _this.client.setItem(_this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                _this.captureException(e);
            }
        });
        this.clientKey = clientKey;
        this.handlers = options === null || options === void 0 ? void 0 : options.handlers;
        var storageEngine = (options === null || options === void 0 ? void 0 : options.storageEngine) || $073867535d265287$var$DEFAULT_STORAGE_ENGINE;
        if (!Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $rylkD.mockWindowStorage)([
            storageEngine
        ]);
        this.client = window[storageEngine];
    }
    (0, $fuVkU.default)(StorageClient, [
        {
            key: "captureException",
            value: function captureException(e, tags) {
                var _this$handlers;
                if ((_this$handlers = this.handlers) !== null && _this$handlers !== void 0 && _this$handlers.captureException) {
                    var _this$handlers2;
                    (_this$handlers2 = this.handlers) === null || _this$handlers2 === void 0 || _this$handlers2.captureException(e, tags);
                }
            }
        },
        {
            key: "itemKey",
            value: function itemKey(key) {
                return "".concat(this.clientKey, "_").concat(key);
            }
        }
    ]);
    return StorageClient;
}();

});
parcelRegister("rylkD", function(module, exports) {

$parcel$export(module.exports, "mockWindowStorage", function () { return $052d298c40b05312$export$efebfe7859cae3c7; });

var $iwGlz = parcelRequire("iwGlz");
function $052d298c40b05312$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $052d298c40b05312$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $052d298c40b05312$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $iwGlz.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $052d298c40b05312$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $052d298c40b05312$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $052d298c40b05312$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $052d298c40b05312$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $052d298c40b05312$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $052d298c40b05312$var$_arrayLikeToArray(o, minLen);
}
function $052d298c40b05312$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $052d298c40b05312$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function setItem(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function getItem(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function removeItem(id) {
        return delete this._data[id];
    },
    clear: function clear() {
        return this._data = {};
    },
    key: function key(index) {
        return Object.keys(this._data)[index];
    }
};
var $052d298c40b05312$export$efebfe7859cae3c7 = function mockWindowStorage() {
    var storageToMock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
        "localStorage",
        "sessionStorage"
    ];
    var _iterator = $052d298c40b05312$var$_createForOfIteratorHelper(storageToMock), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var storageToMockElement = _step.value;
            Object.defineProperty(window, storageToMockElement, {
                value: $052d298c40b05312$var$_objectSpread({}, $052d298c40b05312$export$c65e688d8b365035),
                configurable: true
            });
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
};

});


parcelRegister("iPRKF", function(module, exports) {

$parcel$export(module.exports, "fetchFlightDeckConfiguration", function () { return $db66af64114fd6c6$export$6026918e023c9101; });

var $k5A7v = parcelRequire("k5A7v");

var $8ydJP = parcelRequire("8ydJP");

var $sYQAK = parcelRequire("sYQAK");

var $lFh7n = parcelRequire("lFh7n");

var $eVU5T = parcelRequire("eVU5T");

var $aidqA = parcelRequire("aidqA");

var $l5GF8 = parcelRequire("l5GF8");
/**
 * Arguments for passing in dimensions that the artifact might vary on.
 * For more details see: https://developer.atlassian.com/platform/flight-deck/getting-your-capability-onto-flight-deck/dimensions/
 */ /**
 * default to using prod instance since artifacts that don't depend on environment should be using the prod instance.
 */ const $db66af64114fd6c6$var$defaultEnvType = "prod";
/**
 * default to using commercial instance.
 */ const $db66af64114fd6c6$var$defaultPerimeter = "commercial";
async function $db66af64114fd6c6$export$6026918e023c9101(artifactName, dim = {}) {
    var _dim$environmentType, _dim$perimeter;
    const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $db66af64114fd6c6$var$defaultEnvType;
    const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $db66af64114fd6c6$var$defaultPerimeter;
    const environment = $db66af64114fd6c6$var$getEnvFromEnvType(environmentType);
    const locale = dim.locale && (0, $k5A7v.default)(dim.locale);
    const artifactDimensions = {
        perimeter: perimeter,
        environment: environment,
        locale: locale
    };
    const client = await $db66af64114fd6c6$var$getConfigClient(environmentType, perimeter);
    return client.getArtifact(artifactName, artifactDimensions);
}
async function $db66af64114fd6c6$export$4abbe3ae0811355(dim = {}) {
    var _dim$environmentType2, _dim$perimeter2;
    const client = await $db66af64114fd6c6$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $db66af64114fd6c6$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $db66af64114fd6c6$var$defaultPerimeter);
    return client.getLatestVersionMetadata();
}
async function $db66af64114fd6c6$var$getConfigClient(env, perimeter) {
    const fetchArtifactExperience = await (0, $aidqA.getFlightDeckFetchExperience)();
    const fetchVersionMetadataExperience = await (0, $aidqA.getVersionMetadataFetchExperience)();
    return new (0, $eVU5T.ConfigClient)(new (0, $sYQAK.BifrostDataSource)(new (0, $lFh7n.BifrostHttpClientImpl)(env, perimeter), (0, $8ydJP.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $db66af64114fd6c6$var$getEnvFromEnvType(environment) {
    if (environment === undefined || environment === "prod") return "prod-west";
    switch(environment){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
        case "fedex":
            return "stg-apse";
    }
}

});
parcelRegister("k5A7v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea004af38c4253c5$export$2e2bcd8739ae039; });
/**
 * This function is being used to address locale discrepancies in Atlassian products;
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ var $ea004af38c4253c5$export$852ff24d0930c62f = function mapLocaleToPrsLocale(locale) {
    var standardizedLocale = locale.replace("_", "-");
    switch(standardizedLocale){
        case "en-US":
        case "en-GB":
        case "pt-BR":
        case "zh-CN":
        case "zh-TW":
            return standardizedLocale;
        case "en-UK":
            return "en-GB";
        case "en":
            return "en-US";
        default:
            return standardizedLocale.split("-")[0];
    }
};
var $ea004af38c4253c5$export$2e2bcd8739ae039 = $ea004af38c4253c5$export$852ff24d0930c62f;

});

parcelRegister("8ydJP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $2lcmC = parcelRequire("2lcmC");
Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function() {
        return $2lcmC.Either;
    }
});

var $bzH6n = parcelRequire("bzH6n");
Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function() {
        return $bzH6n.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function() {
        return $bzH6n.tryGetArtifactData;
    }
});

var $bh2fp = parcelRequire("bh2fp");
Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function() {
        return $bh2fp.parseArtifactManifest;
    }
});

var $hYwI8 = parcelRequire("hYwI8");
Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function() {
        return $hYwI8.parseVersionMetadata;
    }
});

var $hVFsv = parcelRequire("hVFsv");
Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function() {
        return $hVFsv.checkManifest;
    }
});

var $kCe9t = parcelRequire("kCe9t");
Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function() {
        return $kCe9t.ConfigRegistryDataSource;
    }
});

var $l0HHm = parcelRequire("l0HHm");
Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function() {
        return $l0HHm.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function() {
        return $l0HHm.Versions;
    }
});

});
parcelRegister("2lcmC", function(module, exports) {
"use strict";
var $1b47221fbb00ce84$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $1b47221fbb00ce84$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $1b47221fbb00ce84$var$Right(value);
    };
    Either.left = function(error) {
        return new $1b47221fbb00ce84$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $1b47221fbb00ce84$var$Either;
var $1b47221fbb00ce84$var$Right = /** @class */ function(_super) {
    $1b47221fbb00ce84$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $1b47221fbb00ce84$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $1b47221fbb00ce84$var$Either.right(this.right);
    };
    return Right;
}($1b47221fbb00ce84$var$Either);
var $1b47221fbb00ce84$var$Left = /** @class */ function(_super) {
    $1b47221fbb00ce84$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $1b47221fbb00ce84$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $1b47221fbb00ce84$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $1b47221fbb00ce84$var$Either.left(f(this.left));
    };
    return Left;
}($1b47221fbb00ce84$var$Either);

});

parcelRegister("bzH6n", function(module, exports) {
"use strict";
var $86d465b5614f813b$var$__assign = module.exports && module.exports.__assign || function() {
    $86d465b5614f813b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $86d465b5614f813b$var$__assign.apply(this, arguments);
};
var $86d465b5614f813b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $86d465b5614f813b$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getArtifactFromSource = $86d465b5614f813b$var$getArtifactFromSource;
module.exports.tryGetArtifactData = $86d465b5614f813b$var$tryGetArtifactData;

var $eQcYb = parcelRequire("eQcYb");

var $8ydJP = parcelRequire("8ydJP");

var $jvv5S = parcelRequire("jvv5S");

var $GrYW0 = parcelRequire("GrYW0");

var $bqMwG = parcelRequire("bqMwG");
function $86d465b5614f813b$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $86d465b5614f813b$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $86d465b5614f813b$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $86d465b5614f813b$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $86d465b5614f813b$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $8ydJP.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $jvv5S.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $86d465b5614f813b$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $GrYW0.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $86d465b5614f813b$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $86d465b5614f813b$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $86d465b5614f813b$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $eQcYb.interpolateTagScheme)(manifest.tagScheme, $86d465b5614f813b$var$__assign($86d465b5614f813b$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $86d465b5614f813b$var$__awaiter(_this, void 0, void 0, function() {
                                return $86d465b5614f813b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $86d465b5614f813b$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $bqMwG.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $bqMwG.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $GrYW0.assertUnreachable)(artifact);
    }
}

});
parcelRegister("eQcYb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTagScheme = $acdffb8b838a0d39$var$interpolateTagScheme;
module.exports.generateTagScheme = $acdffb8b838a0d39$var$generateTagScheme;
module.exports.getDimensionsFromTagScheme = $acdffb8b838a0d39$var$getDimensionsFromTagScheme;
module.exports.getDataTagForManifest = $acdffb8b838a0d39$var$getDataTagForManifest;
module.exports.getVersionMetadataTag = $acdffb8b838a0d39$var$getVersionMetadataTag;
const $acdffb8b838a0d39$var$TAG_SCHEME_VERSION = 2;
function $acdffb8b838a0d39$var$interpolateTagScheme(tagSchema, context) {
    const dimensions = Array.from($acdffb8b838a0d39$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce((interpolatedTagScheme, dimension)=>{
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
        else {
            const contextAsJson = $acdffb8b838a0d39$var$toPrettyJson(context);
            throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
        }
    }, tagSchema);
}
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $acdffb8b838a0d39$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
    const effectiveDimensions = new Set([
        ...dimensions
    ].map(effectiveContextDimension));
    for (const dimensionToInclude of effectiveDimensions){
        if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
            `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
            `recognized as a dimension (known dimensions are ${[
                ...supportedDimensionPrefixes.keys()
            ].join(", ")}!`
        ].join(" "));
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    const padded_version = $acdffb8b838a0d39$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    let tagScheme = `v${padded_version}`;
    for (const entry of supportedDimensionPrefixes.entries()){
        const [dimension, prefix] = entry;
        if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
        // meaning on certain filesystems that make them painful to work with; we also don't use
        // ` ` or similar because whitespace characters are the default values used by shells
        // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
        tagScheme += `-${prefix}_$${dimension}$`;
    }
    return tagScheme;
}
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $acdffb8b838a0d39$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    const dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    const isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
    const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        const captures = allDim.map(([_, capture])=>capture);
        const dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
    }
}
function $acdffb8b838a0d39$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
}
function $acdffb8b838a0d39$var$getVersionMetadataTag(version) {
    return version ? `version_metadata_${version}` : "version_metadata";
}
function $acdffb8b838a0d39$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("jvv5S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = $e339082c03b2b655$var$getDimensionContext;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $e339082c03b2b655$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}

});

parcelRegister("GrYW0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = $07f9a0f6e4524ed0$var$assertUnreachable;
function $07f9a0f6e4524ed0$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}

});

parcelRegister("bqMwG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toJson = $8527c3b290bbf82b$var$toJson;
module.exports.toPrettyJson = $8527c3b290bbf82b$var$toPrettyJson;
function $8527c3b290bbf82b$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
function $8527c3b290bbf82b$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});


parcelRegister("bh2fp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = $8353068e0e989971$var$parseArtifactManifest;

var $6XWNm = parcelRequire("6XWNm");
function $8353068e0e989971$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $6XWNm.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $6XWNm.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $8353068e0e989971$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $6XWNm.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $8353068e0e989971$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $8353068e0e989971$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $6XWNm.parseUnknownObject)(dimensions);
    var supported = (0, $6XWNm.parseArray)(unparsedDimensions.supported).map($6XWNm.parseString);
    var fallback = (0, $6XWNm.parseUndefinedOr)($6XWNm.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $8353068e0e989971$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $6XWNm.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $8353068e0e989971$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $8353068e0e989971$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $6XWNm.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $6XWNm.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $6XWNm.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $6XWNm.parseUndefinedOr)($6XWNm.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $8353068e0e989971$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $8353068e0e989971$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}

});
parcelRegister("6XWNm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseString = $5125dc3bf941afde$var$parseString;
module.exports.parseArray = $5125dc3bf941afde$var$parseArray;
module.exports.parseBoolean = $5125dc3bf941afde$var$parseBoolean;
module.exports.parseUnknownObject = $5125dc3bf941afde$var$parseUnknownObject;
module.exports.parseUndefinedOr = $5125dc3bf941afde$var$parseUndefinedOr;
function $5125dc3bf941afde$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
function $5125dc3bf941afde$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
function $5125dc3bf941afde$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
function $5125dc3bf941afde$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
function $5125dc3bf941afde$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}

});


parcelRegister("hYwI8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = $d16169f299178a68$var$parseVersionMetadata;

var $6XWNm = parcelRequire("6XWNm");
function $d16169f299178a68$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $6XWNm.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $6XWNm.parseString)(unknownObject.version);
    var publishTime = new Date((0, $6XWNm.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $6XWNm.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}

});

parcelRegister("hVFsv", function(module, exports) {
"use strict";
var $d0d7eb5d24b1fed9$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = $d0d7eb5d24b1fed9$var$checkManifest;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $d0d7eb5d24b1fed9$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $d0d7eb5d24b1fed9$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}

});

parcelRegister("kCe9t", function(module, exports) {
"use strict";
var $f022557e2a7c6404$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f022557e2a7c6404$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $eQcYb = parcelRequire("eQcYb");

var $2lcmC = parcelRequire("2lcmC");

var $bh2fp = parcelRequire("bh2fp");

var $hYwI8 = parcelRequire("hYwI8");
var $f022557e2a7c6404$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $f022557e2a7c6404$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $f022557e2a7c6404$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $eQcYb.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($bh2fp.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $2lcmC.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $f022557e2a7c6404$var$__awaiter(this, void 0, void 0, function() {
            return $f022557e2a7c6404$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $f022557e2a7c6404$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $f022557e2a7c6404$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $eQcYb.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $hYwI8.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $f022557e2a7c6404$var$ConfigRegistryDataSource;

});

parcelRegister("l0HHm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = void 0;
var $f4bb7ea6108f8d3b$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $f4bb7ea6108f8d3b$var$BaseUrls;
var $f4bb7ea6108f8d3b$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $f4bb7ea6108f8d3b$var$Versions;

});


parcelRegister("sYQAK", function(module, exports) {

$parcel$export(module.exports, "BifrostDataSource", function () { return $0571d0a316264c42$export$2cb8d79200775058; });

var $8ydJP = parcelRequire("8ydJP");

var $eQcYb = parcelRequire("eQcYb");
class $0571d0a316264c42$export$2cb8d79200775058 {
    async getLatestVersionMetadata() {
        const tag = (0, $eQcYb.getVersionMetadataTag)();
        const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
        return bifrostResponse.fold((error)=>{
            return (0, $8ydJP.Either).left(error);
        }, (response)=>{
            try {
                const parsedVersionMetadata = (0, $8ydJP.parseVersionMetadata)(response);
                return (0, $8ydJP.Either).right(parsedVersionMetadata);
            } catch (e) {
                const error = {
                    key: "invalid-version-metadata"
                };
                return (0, $8ydJP.Either).left(error);
            }
        });
    }
    async getManifest(artifactName, artifactVersion) {
        const manifestTag = (0, $eQcYb.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
        const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
        return bifrostResponse.fold((error)=>{
            return (0, $8ydJP.Either).left(error);
        }, (response)=>{
            try {
                const parsedArtifact = (0, $8ydJP.parseArtifactManifest)(response);
                return (0, $8ydJP.Either).right(parsedArtifact);
            } catch (e) {
                const error = {
                    key: "invalid-manifest"
                };
                return (0, $8ydJP.Either).left(error);
            }
        });
    }
    async getArtifact(artifactName, tag) {
        return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
    }
    constructor(bifrostClient, manifestVersion){
        this.bifrostClient = bifrostClient;
        this.manifestVersion = manifestVersion;
    }
}

});

parcelRegister("lFh7n", function(module, exports) {

$parcel$export(module.exports, "BifrostHttpClientImpl", function () { return $fc5ab4929c386f5c$export$45c6d12ca9c14f83; });

var $8ydJP = parcelRequire("8ydJP");
function $fc5ab4929c386f5c$export$f654b28f82155665(env, perimeter) {
    if (perimeter === "commercial") switch(env){
        case "adev":
        case "ddev":
        case "pdev":
        case "stg":
            return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
        case "prod":
            return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    else if (perimeter === "fedramp-moderate") switch(env){
        case "stg":
            return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
        case "prod":
            return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
    }
    return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
}
class $fc5ab4929c386f5c$export$45c6d12ca9c14f83 {
    async getBlob(tag) {
        const endpoint = `${this.baseUrl}/assets/${tag}`;
        return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                if (!response.ok) resolve((0, $8ydJP.Either).left({
                    key: "unexpected-response-code",
                    httpResponseCode: response.status,
                    httpResponseStatusText: response.statusText
                }));
                response.json().then((json)=>resolve((0, $8ydJP.Either).right(json)));
            }).catch((error)=>resolve((0, $8ydJP.Either).left({
                    key: "failed-fetch",
                    error: "message" in error ? error.message : "unknown error"
                }))));
    }
    constructor(env, perimeter){
        this.baseUrl = $fc5ab4929c386f5c$export$f654b28f82155665(env, perimeter);
    }
}

});

parcelRegister("eVU5T", function(module, exports) {

$parcel$export(module.exports, "ConfigClient", function () { return $adf1e6b106b8436d$export$8489e2f039bfcc4c; });

var $iwGlz = parcelRequire("iwGlz");

var $8ydJP = parcelRequire("8ydJP");

var $h1p4j = parcelRequire("h1p4j");
function $adf1e6b106b8436d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $adf1e6b106b8436d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $adf1e6b106b8436d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iwGlz.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $adf1e6b106b8436d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $adf1e6b106b8436d$export$8489e2f039bfcc4c {
    async getArtifact(artifactName, dimensions) {
        this.fetchArtifactExperience.addMetadata(dimensions);
        this.fetchArtifactExperience.start();
        const specifiedDimensions = $adf1e6b106b8436d$var$_objectSpread($adf1e6b106b8436d$var$_objectSpread({}, dimensions), {}, {
            name: artifactName
        });
        const artifact = await (0, $8ydJP.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                type: "artifact-fetch-error",
                publishMetadata: {},
                error: {
                    key: "unexpected-error",
                    error: e
                }
            }));
        if (artifact.type === "success") this.fetchArtifactExperience.success();
        else {
            this.fetchArtifactExperience.addMetadata({
                errorType: artifact.type,
                error: "error" in artifact ? artifact.error.key : undefined
            });
            this.fetchArtifactExperience.failure();
        }
        return (0, $8ydJP.tryGetArtifactData)(artifact, this.dataSourceName);
    }
    async getLatestVersionMetadata() {
        this.versionMetadataExperience.start();
        const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
        return getVersionMetadataResult.fold((error)=>{
            this.versionMetadataExperience.addMetadata({
                error: error.key
            });
            this.versionMetadataExperience.failure();
            throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
        }, (data)=>{
            this.versionMetadataExperience.success();
            return data;
        });
    }
    constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $h1p4j.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
}

});
parcelRegister("h1p4j", function(module, exports) {

$parcel$export(module.exports, "ExperienceDataSourceWrapper", function () { return $c645f9bddec3b560$export$1cc944571619e6e8; });
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ class $c645f9bddec3b560$export$1cc944571619e6e8 {
    getLatestVersionMetadata() {
        this.versionMetadataExperience.mark("start-fetch-metadata");
        const result = this.dataSource.getLatestVersionMetadata();
        this.versionMetadataExperience.mark("end-fetch-metadata");
        return result;
    }
    async getManifest(artifactName, artifactVersion) {
        this.artifactExperience.mark("start-fetch-artifact");
        const result = await this.dataSource.getManifest(artifactName, artifactVersion);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getManifestError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-artifact");
        return result;
    }
    async getArtifact(artifactName, tag) {
        this.artifactExperience.mark("start-fetch-manifest");
        const result = await this.dataSource.getArtifact(artifactName, tag);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getArtifactError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-manifest");
        return result;
    }
    constructor(dataSource, artifactExperience, versionMetadataExperience){
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
}

});


parcelRegister("aidqA", function(module, exports) {

$parcel$export(module.exports, "getFlightDeckFetchExperience", function () { return $77e6004f46f92b4c$export$a3006f8f221c0a3b; });
$parcel$export(module.exports, "getVersionMetadataFetchExperience", function () { return $77e6004f46f92b4c$export$c3ac7702bfd47c1b; });
const $77e6004f46f92b4c$var$SAMPLING_RATE = 10;
class $77e6004f46f92b4c$var$UFOExperienceWrapper {
    start(startTime) {
        return this.experience.start(startTime);
    }
    success() {
        return this.experience.success();
    }
    failure() {
        return this.experience.failure();
    }
    addMetadata(data) {
        return this.experience.addMetadata(data);
    }
    mark(mark) {
        return this.experience.mark(mark);
    }
    constructor(experience){
        this.experience = experience;
    }
}
class $77e6004f46f92b4c$export$5e7536cf7bc56fee {
    start() {
        return Promise.resolve();
    }
    success() {
        return Promise.resolve(null);
    }
    failure() {
        return Promise.resolve(null);
    }
    mark() {
        return;
    }
    addMetadata() {
        return;
    }
}

async function $77e6004f46f92b4c$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    try {
        // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
        // to not flood Perf Portal with logs.
        if (Math.random() * 100 > $77e6004f46f92b4c$var$SAMPLING_RATE) return new $77e6004f46f92b4c$export$5e7536cf7bc56fee();
        const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("5Wl77"));
        const ufoExperience = new UFOExperience(id, {
            type: ExperienceTypes.Operation,
            performanceType: ExperiencePerformanceTypes.Custom,
            platform: {
                component: "flight-deck-client"
            },
            timings: timings
        });
        ufoExperience.addMetadata(metadata);
        return new $77e6004f46f92b4c$var$UFOExperienceWrapper(ufoExperience);
    } catch (_unused) {
        return new $77e6004f46f92b4c$export$5e7536cf7bc56fee();
    }
}
const $77e6004f46f92b4c$export$a3006f8f221c0a3b = ()=>$77e6004f46f92b4c$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
const $77e6004f46f92b4c$export$c3ac7702bfd47c1b = ()=>$77e6004f46f92b4c$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});

});
parcelRegister("5Wl77", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("1ZCHG")).then(()=>parcelRequire("1kq5E"));

});


parcelRegister("l5GF8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $hE6og = parcelRequire("hE6og");
Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function() {
        return $hE6og.parseConfigWithTargeting;
    }
});

var $c3tsX = parcelRequire("c3tsX");
Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function() {
        return $c3tsX.TargetedConfig;
    }
});

});
parcelRegister("hE6og", function(module, exports) {
"use strict";
var $cd8b211569c58b99$var$__assign = module.exports && module.exports.__assign || function() {
    $cd8b211569c58b99$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cd8b211569c58b99$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = $cd8b211569c58b99$var$parseConfigWithTargeting;

var $c3tsX = parcelRequire("c3tsX");
/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $cd8b211569c58b99$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $cd8b211569c58b99$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $c3tsX.TargetedConfig({
                defaultConfig: $cd8b211569c58b99$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $cd8b211569c58b99$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $c3tsX.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $cd8b211569c58b99$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $cd8b211569c58b99$var$__assign($cd8b211569c58b99$var$__assign({}, accObject), (_a = {}, _a[key] = $cd8b211569c58b99$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
function $cd8b211569c58b99$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $cd8b211569c58b99$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $cd8b211569c58b99$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $cd8b211569c58b99$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $cd8b211569c58b99$var$parseIdentifierList(target.orgIds),
            siteIds: $cd8b211569c58b99$var$parseIdentifierList(target.siteIds),
            userIds: $cd8b211569c58b99$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $cd8b211569c58b99$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});
parcelRegister("c3tsX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $8c6c9f30bf8dc84d$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
     * Determines whether to use the targeted configuration value or the default value
     * depending on whether the specified values match any of the target's rules.
     *
     * @param target the values to use to evaluate the config
     * @returns the {@link TargetingResult}, which would be the default value
     *     if the specified target did not match, or the targeted value if there
     *     was a match
     */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $8c6c9f30bf8dc84d$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $8c6c9f30bf8dc84d$var$TargetedConfig;
function $8c6c9f30bf8dc84d$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});




parcelRegister("8tDm5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62bf8f4771e89694$export$2e2bcd8739ae039; });
class $62bf8f4771e89694$export$2e2bcd8739ae039 extends Error {
    constructor({ artifact: artifact, dimensions: dimensions, error: error }){
        super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        this.name = "FlightDeckSDKError";
        this.error = error;
        this.artifact = artifact;
        this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
    }
}
const $62bf8f4771e89694$export$1d76d155060824c9 = (e)=>e instanceof $62bf8f4771e89694$export$2e2bcd8739ae039;

});

parcelRegister("kBf8F", function(module, exports) {

$parcel$export(module.exports, "artifactKey", function () { return $eff3019c1573ad61$export$e3553dc63541d477; });
const $eff3019c1573ad61$export$e3553dc63541d477 = (artifactName, dimensions)=>{
    return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
};

});

parcelRegister("izOL3", function(module, exports) {

$parcel$export(module.exports, "flightDeckClientExperience", function () { return $d862de58bf67bab7$export$1e3a41a51f6457c5; });
$parcel$export(module.exports, "exceptionToMetadata", function () { return $d862de58bf67bab7$export$f33622abb5224195; });

var $iwGlz = parcelRequire("iwGlz");

var $ejl0B = parcelRequire("ejl0B");
var $29s50 = parcelRequire("29s50");
function $d862de58bf67bab7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d862de58bf67bab7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d862de58bf67bab7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iwGlz.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d862de58bf67bab7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $d862de58bf67bab7$export$6061a1a9a61f2e21 = ()=>new (0, $29s50.UFOExperience)("fetch", {
        type: (0, $ejl0B.ExperienceTypes).Operation,
        performanceType: (0, $ejl0B.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $d862de58bf67bab7$export$1e3a41a51f6457c5 = ()=>new (0, $29s50.UFOExperience)("retrieve-artifact", {
        type: (0, $ejl0B.ExperienceTypes).Operation,
        performanceType: (0, $ejl0B.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $d862de58bf67bab7$export$f33622abb5224195 = (e)=>{
    return e instanceof Error ? $d862de58bf67bab7$var$_objectSpread($d862de58bf67bab7$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};

});
parcelRegister("ejl0B", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", function () { return $a6b322f2cf307ebc$export$994164cf3ae1cc9a; });
$parcel$export(module.exports, "ExperiencePerformanceTypes", function () { return $a6b322f2cf307ebc$export$cc26007c03242fff; });
var $a6b322f2cf307ebc$export$994164cf3ae1cc9a;
(function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
})($a6b322f2cf307ebc$export$994164cf3ae1cc9a || ($a6b322f2cf307ebc$export$994164cf3ae1cc9a = {}));
var $a6b322f2cf307ebc$export$cc26007c03242fff;
(function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
})($a6b322f2cf307ebc$export$cc26007c03242fff || ($a6b322f2cf307ebc$export$cc26007c03242fff = {}));

});

parcelRegister("29s50", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", function () { return $19123419a1a5c752$export$c00d22927c60484a; });

var $fuVkU = parcelRequire("fuVkU");

var $bMcPT = parcelRequire("bMcPT");

var $1TMxq = parcelRequire("1TMxq");

var $6bt80 = parcelRequire("6bt80");

var $df5mh = parcelRequire("df5mh");

var $XejKp = parcelRequire("XejKp");
function $19123419a1a5c752$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $19123419a1a5c752$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $df5mh.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $df5mh.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6bt80.default)(this, result);
    };
}
function $19123419a1a5c752$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $19123419a1a5c752$export$c00d22927c60484a = /*#__PURE__*/ function(_UFOAbstractExperienc) {
    (0, $1TMxq.default)(UFOExperience, _UFOAbstractExperienc);
    var _super = $19123419a1a5c752$var$_createSuper(UFOExperience);
    function UFOExperience() {
        (0, $bMcPT.default)(this, UFOExperience);
        return _super.apply(this, arguments);
    }
    return (0, $fuVkU.default)(UFOExperience);
}((0, $XejKp.UFOAbstractExperience));

});
parcelRegister("XejKp", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", function () { return $0b209df652ad8067$export$d31c89db257648c; });

var $avIa0 = parcelRequire("avIa0");

var $lNpP6 = parcelRequire("lNpP6");

var $bMcPT = parcelRequire("bMcPT");

var $fuVkU = parcelRequire("fuVkU");

var $iwGlz = parcelRequire("iwGlz");

var $8nhgi = parcelRequire("8nhgi");

var $7XSpk = parcelRequire("7XSpk");

var $cFZpC = parcelRequire("cFZpC");

var $e4Wr6 = parcelRequire("e4Wr6");

var $fwuoU = parcelRequire("fwuoU");

var $6nHDV = parcelRequire("6nHDV");

var $4EOtr = parcelRequire("4EOtr");

var $81qT4 = parcelRequire("81qT4");

var $i3qXh = parcelRequire("i3qXh");

var $fouDS = parcelRequire("fouDS");

var $lS6HX = parcelRequire("lS6HX");

var $ejl0B = parcelRequire("ejl0B");
function $0b209df652ad8067$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0b209df652ad8067$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0b209df652ad8067$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $iwGlz.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0b209df652ad8067$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $0b209df652ad8067$var$getPageVisibleState = function getPageVisibleState() {
    return !(0, $e4Wr6.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === "visible" ? (0, $81qT4.PageVisibleState).VISIBLE : (0, $81qT4.PageVisibleState).HIDDEN;
};
var $0b209df652ad8067$export$c753e8669d30c8ad = function perfNowOrTimestamp(timestamp) {
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $i3qXh.roundPerfNow)();
};
var $0b209df652ad8067$export$d31c89db257648c = /*#__PURE__*/ function() {
    // for concurrent
    // @todo move to page load experience when proper classes/inheritance prepared
    function UFOAbstractExperience(id, config) {
        var _this = this;
        var instanceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        (0, $bMcPT.default)(this, UFOAbstractExperience);
        (0, $iwGlz.default)(this, "state", (0, $fouDS.UFOExperienceState).NOT_STARTED);
        (0, $iwGlz.default)(this, "instanceId", null);
        (0, $iwGlz.default)(this, "parent", null);
        (0, $iwGlz.default)(this, "category", null);
        (0, $iwGlz.default)(this, "metadata", {});
        (0, $iwGlz.default)(this, "onDoneCallbacks", []);
        (0, $iwGlz.default)(this, "childExperiences", []);
        (0, $iwGlz.default)(this, "explicitTimings", {});
        (0, $iwGlz.default)(this, "isSSROutputAsFMP", false);
        (0, $iwGlz.default)(this, "uuid", null);
        (0, $iwGlz.default)(this, "_until", null);
        (0, $iwGlz.default)(this, "metrics", {
            startTime: null,
            endTime: null,
            marks: []
        });
        (0, $iwGlz.default)(this, "performanceConfig", {});
        (0, $iwGlz.default)(this, "setPageVisibleStateToMixed", function() {
            _this.pageVisibleState = (0, $81qT4.PageVisibleState).MIXED;
            (0, $4EOtr.visibilityChangeObserver).unsubscribe(_this.setPageVisibleStateToMixed);
        });
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $0b209df652ad8067$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $ejl0B.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $ejl0B.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    (0, $fuVkU.default)(UFOAbstractExperience, [
        {
            key: "transition",
            value: function() {
                var _transition = (0, $lNpP6.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nhgi))).mark(function _callee(newState, timestamp) {
                    var data;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8nhgi))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                (0, $6nHDV.ufolog)("async transition", this.id, this.state.id, newState.id);
                                if (!(0, $lS6HX.canTransition)(this.state, newState)) {
                                    _context.next = 15;
                                    break;
                                }
                                (0, $6nHDV.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " successful"), this.state.final, !newState.final);
                                if (newState === (0, $fouDS.UFOExperienceState).STARTED) this._reset();
                                if (this.state.final && !newState.final) {
                                    this.metrics.startTime = $0b209df652ad8067$export$c753e8669d30c8ad(timestamp);
                                    this.uuid = (0, $7XSpk.v4)();
                                }
                                this.state = newState;
                                if (!newState.final) {
                                    _context.next = 14;
                                    break;
                                }
                                this.metrics.endTime = $0b209df652ad8067$export$c753e8669d30c8ad(timestamp);
                                if (!this._isManualStateEnabled()) (0, $fwuoU.getGlobalEventStream)().push((0, $fwuoU.unsubscribeEvent)((0, $81qT4.SUBSCRIBE_ALL), this.handleDoneBind));
                                _context.next = 11;
                                return this.exportData();
                            case 11:
                                data = _context.sent;
                                (0, $6nHDV.ufolog)("this.parent", this.parent);
                                (0, $fwuoU.getGlobalEventStream)().push((0, $fwuoU.experiencePayloadEvent)(data));
                            case 14:
                                return _context.abrupt("return", true);
                            case 15:
                                (0, $6nHDV.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " unsuccessful"));
                                (0, $6nHDV.ufowarn)("transition of ".concat(this.id, " from ").concat(this.state, " to ").concat(newState, " is not possible"));
                                return _context.abrupt("return", false);
                            case 18:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function transition(_x, _x2) {
                    return _transition.apply(this, arguments);
                }
                return transition;
            }()
        },
        {
            key: "start",
            value: function() {
                var _start = (0, $lNpP6.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nhgi))).mark(function _callee2(startTime) {
                    var transitionSuccessful;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8nhgi))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.transition((0, $fouDS.UFOExperienceState).STARTED, startTime);
                            case 2:
                                transitionSuccessful = _context2.sent;
                                if (transitionSuccessful) {
                                    this.pageVisibleState = $0b209df652ad8067$var$getPageVisibleState();
                                    (0, $4EOtr.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                                    if (!this._isManualStateEnabled()) {
                                        (0, $6nHDV.ufolog)("subscribed", this.id);
                                        (0, $fwuoU.getGlobalEventStream)().push((0, $fwuoU.subscribeEvent)((0, $81qT4.SUBSCRIBE_ALL), this.handleDoneBind));
                                    }
                                }
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function start(_x3) {
                    return _start.apply(this, arguments);
                }
                return start;
            }()
        },
        {
            key: "mark",
            value: function mark(name, timestamp) {
                if (name !== (0, $81qT4.FMP_MARK) && name !== (0, $81qT4.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
                else (0, $6nHDV.ufowarn)("please use markFMP or markInlineResponse for specialised marks");
            }
        },
        {
            key: "_mark",
            value: function _mark(name, timestamp) {
                this.metrics.marks.push({
                    name: name,
                    time: $0b209df652ad8067$export$c753e8669d30c8ad(timestamp)
                });
                this.transition((0, $fouDS.UFOExperienceState).IN_PROGRESS);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                this._mark((0, $81qT4.FMP_MARK), timestamp);
            }
        },
        {
            key: "markInlineResponse",
            value: function markInlineResponse(timestamp) {
                this._mark((0, $81qT4.INLINE_RESPONSE_MARK), timestamp);
            }
        },
        {
            key: "_isManualStateEnabled",
            value: function _isManualStateEnabled() {
                return this.until === null;
            }
        },
        {
            key: "_validateManualState",
            value: function _validateManualState() {
                if (!this._isManualStateEnabled()) {
                    (0, $6nHDV.ufowarn)('manual change of state not allowed as "until" is defined');
                    return false;
                }
                return true;
            }
        },
        {
            key: "switchToEndState",
            value: function switchToEndState(state, config) {
                if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
                if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
                (0, $4EOtr.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
                return this.transition(state);
            }
        },
        {
            key: "success",
            value: function() {
                var _success = (0, $lNpP6.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nhgi))).mark(function _callee3(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8nhgi))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", this.switchToEndState((0, $fouDS.UFOExperienceState).SUCCEEDED, config));
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function success(_x4) {
                    return _success.apply(this, arguments);
                }
                return success;
            }()
        },
        {
            key: "failure",
            value: function() {
                var _failure = (0, $lNpP6.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nhgi))).mark(function _callee4(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8nhgi))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                return _context4.abrupt("return", this.switchToEndState((0, $fouDS.UFOExperienceState).FAILED, config));
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function failure(_x5) {
                    return _failure.apply(this, arguments);
                }
                return failure;
            }()
        },
        {
            key: "abort",
            value: function() {
                var _abort = (0, $lNpP6.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nhgi))).mark(function _callee5(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8nhgi))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                return _context5.abrupt("return", this.switchToEndState((0, $fouDS.UFOExperienceState).ABORTED, config));
                            case 1:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function abort(_x6) {
                    return _abort.apply(this, arguments);
                }
                return abort;
            }()
        },
        {
            key: "addMetadata",
            value: function addMetadata(data) {
                Object.assign(this.metadata, data);
            }
        },
        {
            key: "_handleDoneExperience",
            value: function _handleDoneExperience(data) {
                (0, $6nHDV.ufolog)("_handleDoneExperience in", this.id, data.state, data, this._until);
                if (data.state.final) {
                    if (this._until !== null) {
                        var _this$_until = this._until(data), done = _this$_until.done, state = _this$_until.state;
                        if (done && !this.state.final) this.transition(state);
                    }
                }
            }
        },
        {
            key: "getId",
            value: function() {
                var _getId = (0, $lNpP6.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nhgi))).mark(function _callee6() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8nhgi))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                return _context6.abrupt("return", this.id);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function getId() {
                    return _getId.apply(this, arguments);
                }
                return getId;
            }()
        },
        {
            key: "exportData",
            value: function() {
                var _exportData = (0, $lNpP6.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nhgi))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8nhgi))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                _context7.next = 2;
                                return this.getId();
                            case 2:
                                _context7.t0 = _context7.sent;
                                _context7.t1 = this.uuid;
                                _context7.t2 = this.type;
                                _context7.t3 = (0, $cFZpC.UFO_EXPERIMENTAL_BUILD_VERSION) || "unknown";
                                _context7.t4 = this.performanceType;
                                _context7.t5 = this.category;
                                _context7.t6 = this.state;
                                _context7.t7 = $0b209df652ad8067$var$_objectSpread({}, this.metadata);
                                _context7.t8 = $0b209df652ad8067$var$_objectSpread({}, this.metrics);
                                _context7.t9 = (0, $avIa0.default)(this.childExperiences);
                                _context7.t10 = {
                                    success: !!this.state.success,
                                    startTime: this.metrics.startTime,
                                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                                };
                                _context7.t11 = this.config.platform || null;
                                _context7.t12 = this.pageVisibleState;
                                _context7.t13 = this.featureFlags;
                                _context7.t14 = this.isSSROutputAsFMP;
                                _context7.t15 = this.timings;
                                _context7.t16 = this.explicitTimings;
                                _context7.t17 = this.performanceConfig;
                                return _context7.abrupt("return", {
                                    id: _context7.t0,
                                    uuid: _context7.t1,
                                    type: _context7.t2,
                                    schemaVersion: _context7.t3,
                                    performanceType: _context7.t4,
                                    category: _context7.t5,
                                    state: _context7.t6,
                                    metadata: _context7.t7,
                                    metrics: _context7.t8,
                                    children: _context7.t9,
                                    result: _context7.t10,
                                    platform: _context7.t11,
                                    pageVisibleState: _context7.t12,
                                    featureFlags: _context7.t13,
                                    isSSROutputAsFMP: _context7.t14,
                                    timings: _context7.t15,
                                    explicitTimings: _context7.t16,
                                    performanceConfig: _context7.t17
                                });
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function exportData() {
                    return _exportData.apply(this, arguments);
                }
                return exportData;
            }()
        },
        {
            key: "_reset",
            value: function _reset() {
                this.parent = null;
                this.metadata = {};
                this.onDoneCallbacks = [];
                this.childExperiences = [];
                this.metrics = {
                    startTime: null,
                    endTime: null,
                    marks: []
                };
                this._until = this.until ? this.until() : null;
            }
        }
    ]);
    return UFOAbstractExperience;
}();

});
parcelRegister("7XSpk", function(module, exports) {

var $XdLWA = parcelRequire("XdLWA");

var $6ClyQ = parcelRequire("6ClyQ");
var $5cc83f468b057b7e$var$uuid = $6ClyQ;
$5cc83f468b057b7e$var$uuid.v1 = $XdLWA;
$5cc83f468b057b7e$var$uuid.v4 = $6ClyQ;
module.exports = $5cc83f468b057b7e$var$uuid;

});
parcelRegister("XdLWA", function(module, exports) {

var $hGpQy = parcelRequire("hGpQy");

var $3JTlD = parcelRequire("3JTlD");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $0b2031b14a8f35ad$var$_nodeId;
var $0b2031b14a8f35ad$var$_clockseq;
// Previous uuid creation time
var $0b2031b14a8f35ad$var$_lastMSecs = 0;
var $0b2031b14a8f35ad$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $0b2031b14a8f35ad$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $0b2031b14a8f35ad$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $0b2031b14a8f35ad$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $hGpQy();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $0b2031b14a8f35ad$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $0b2031b14a8f35ad$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $0b2031b14a8f35ad$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $0b2031b14a8f35ad$var$_lastMSecs + (nsecs - $0b2031b14a8f35ad$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $0b2031b14a8f35ad$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $0b2031b14a8f35ad$var$_lastMSecs = msecs;
    $0b2031b14a8f35ad$var$_lastNSecs = nsecs;
    $0b2031b14a8f35ad$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $3JTlD(b);
}
module.exports = $0b2031b14a8f35ad$var$v1;

});
parcelRegister("hGpQy", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $cdfa68835ae1aba4$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($cdfa68835ae1aba4$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $cdfa68835ae1aba4$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $cdfa68835ae1aba4$var$getRandomValues($cdfa68835ae1aba4$var$rnds8);
        return $cdfa68835ae1aba4$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $cdfa68835ae1aba4$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $cdfa68835ae1aba4$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $cdfa68835ae1aba4$var$rnds;
    };
}

});

parcelRegister("3JTlD", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $2b9081fdeef2e457$var$byteToHex = [];
for(var $2b9081fdeef2e457$var$i = 0; $2b9081fdeef2e457$var$i < 256; ++$2b9081fdeef2e457$var$i)$2b9081fdeef2e457$var$byteToHex[$2b9081fdeef2e457$var$i] = ($2b9081fdeef2e457$var$i + 0x100).toString(16).substr(1);
function $2b9081fdeef2e457$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $2b9081fdeef2e457$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $2b9081fdeef2e457$var$bytesToUuid;

});


parcelRegister("6ClyQ", function(module, exports) {

var $hGpQy = parcelRequire("hGpQy");

var $3JTlD = parcelRequire("3JTlD");
function $4d17043fefac1eea$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $hGpQy)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $3JTlD(rnds);
}
module.exports = $4d17043fefac1eea$var$v4;

});


parcelRegister("cFZpC", function(module, exports) {

$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", function () { return $93a8f392c24676f9$export$2295b861f318254a; });
// temp solution until we can get it automated
var $93a8f392c24676f9$export$2295b861f318254a = "0.1.5";

});

parcelRegister("e4Wr6", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", function () { return $a3fec497939307cd$export$15e172712955e18f; });
var $a3fec497939307cd$export$15e172712955e18f = function isWindowObjectAvailable() {
    return typeof window !== "undefined";
};

});

parcelRegister("fwuoU", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", function () { return $b4d16d1e4eb4527a$export$6123a44dc2384540; });
$parcel$export(module.exports, "subscribeEvent", function () { return $b4d16d1e4eb4527a$export$37863216db4b714d; });
$parcel$export(module.exports, "unsubscribeEvent", function () { return $b4d16d1e4eb4527a$export$ee1a7bd1fc9ea85e; });
$parcel$export(module.exports, "experiencePayloadEvent", function () { return $b4d16d1e4eb4527a$export$7c957416596ca127; });

var $6nHDV = parcelRequire("6nHDV");

var $81qT4 = parcelRequire("81qT4");
var $b4d16d1e4eb4527a$var$MAX_EARLY_QUEUE_LENGTH = 250;
var $b4d16d1e4eb4527a$export$6123a44dc2384540 = function getGlobalEventStream() {
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        var earlyStream = function() {
            var stream = [];
            return {
                __buffer_only__: true,
                push: function push(event) {
                    if (stream.length < $b4d16d1e4eb4527a$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: function getStream() {
                    return stream;
                }
            };
        }();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
var $b4d16d1e4eb4527a$export$c1522520b417b066 = function setGlobalEventStream(eventStream) {
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $6nHDV.ufowarn)("Global Event Stream already initialised. Ignoring new event stream setup");
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
var $b4d16d1e4eb4527a$export$37863216db4b714d = function subscribeEvent(experienceId, callback) {
    return {
        type: (0, $81qT4.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $b4d16d1e4eb4527a$export$ee1a7bd1fc9ea85e = function unsubscribeEvent(experienceId, callback) {
    return {
        type: (0, $81qT4.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $b4d16d1e4eb4527a$export$7c957416596ca127 = function experiencePayloadEvent(data) {
    return {
        type: (0, $81qT4.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("6nHDV", function(module, exports) {

$parcel$export(module.exports, "ufolog", function () { return $4a56bea771b7a60e$export$b4958caff08a0960; });
$parcel$export(module.exports, "ufowarn", function () { return $4a56bea771b7a60e$export$d53d07b6034c4560; });

var $bMcPT = parcelRequire("bMcPT");

var $fuVkU = parcelRequire("fuVkU");

var $iwGlz = parcelRequire("iwGlz");
var $4a56bea771b7a60e$var$UFOLogger = /*#__PURE__*/ function() {
    function UFOLogger() {
        (0, $bMcPT.default)(this, UFOLogger);
        (0, $iwGlz.default)(this, "enabled", false);
    }
    (0, $fuVkU.default)(UFOLogger, [
        {
            key: "log",
            value: function log() {
                var _console;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // eslint-disable-next-line no-console
                this.enabled && (_console = console).log.apply(_console, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "warn",
            value: function warn() {
                var _console2;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                // eslint-disable-next-line no-console
                this.enabled && (_console2 = console).warn.apply(_console2, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.enabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.enabled = false;
            }
        }
    ]);
    return UFOLogger;
}();
(0, $iwGlz.default)($4a56bea771b7a60e$var$UFOLogger, "UFOprefix", "[ufo\uD83D\uDEF8]");
var $4a56bea771b7a60e$export$4ab84f6f04f6566d = new $4a56bea771b7a60e$var$UFOLogger();
var $4a56bea771b7a60e$export$b4958caff08a0960 = function ufolog() {
    $4a56bea771b7a60e$export$4ab84f6f04f6566d.log.apply($4a56bea771b7a60e$export$4ab84f6f04f6566d, arguments);
};
var $4a56bea771b7a60e$export$d53d07b6034c4560 = function ufowarn() {
    $4a56bea771b7a60e$export$4ab84f6f04f6566d.warn.apply($4a56bea771b7a60e$export$4ab84f6f04f6566d, arguments);
};

});

parcelRegister("81qT4", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", function () { return $5d7345f721ff8cbb$export$96253c35c37cf96b; });
$parcel$export(module.exports, "PageVisibleState", function () { return $5d7345f721ff8cbb$export$a12c67b37a306b13; });
$parcel$export(module.exports, "SUBSCRIBE_ALL", function () { return $5d7345f721ff8cbb$export$79bf131685ad41d7; });
$parcel$export(module.exports, "FMP_MARK", function () { return $5d7345f721ff8cbb$export$9f2bf58999404c75; });
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", function () { return $5d7345f721ff8cbb$export$837e0f79a8056912; });

var $5d7345f721ff8cbb$export$96253c35c37cf96b;
(function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
})($5d7345f721ff8cbb$export$96253c35c37cf96b || ($5d7345f721ff8cbb$export$96253c35c37cf96b = {}));
var $5d7345f721ff8cbb$export$a12c67b37a306b13;
(function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
})($5d7345f721ff8cbb$export$a12c67b37a306b13 || ($5d7345f721ff8cbb$export$a12c67b37a306b13 = {}));
var $5d7345f721ff8cbb$export$66b33c055cbb625e;
(function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
})($5d7345f721ff8cbb$export$66b33c055cbb625e || ($5d7345f721ff8cbb$export$66b33c055cbb625e = {}));
var $5d7345f721ff8cbb$export$3ce489cbe02dc21b;
(function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
})($5d7345f721ff8cbb$export$3ce489cbe02dc21b || ($5d7345f721ff8cbb$export$3ce489cbe02dc21b = {}));
var $5d7345f721ff8cbb$export$341b330828bd3906;
(function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
})($5d7345f721ff8cbb$export$341b330828bd3906 || ($5d7345f721ff8cbb$export$341b330828bd3906 = {}));
var $5d7345f721ff8cbb$export$b9b20160f581e4f8;
(function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
})($5d7345f721ff8cbb$export$b9b20160f581e4f8 || ($5d7345f721ff8cbb$export$b9b20160f581e4f8 = {}));
var $5d7345f721ff8cbb$export$79bf131685ad41d7 = "__SUBSCRIBE_ALL__";
var $5d7345f721ff8cbb$export$9f2bf58999404c75 = "fmp";
var $5d7345f721ff8cbb$export$837e0f79a8056912 = "inline-response";

});


parcelRegister("4EOtr", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", function () { return $36420ce6fc9abc9b$export$13e680397ec8f3eb; });

var $bMcPT = parcelRequire("bMcPT");

var $fuVkU = parcelRequire("fuVkU");

var $iwGlz = parcelRequire("iwGlz");

var $e4Wr6 = parcelRequire("e4Wr6");
var $36420ce6fc9abc9b$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, $bMcPT.default)(this, VisibilityChangeObserver);
        (0, $iwGlz.default)(this, "started", false);
        (0, $iwGlz.default)(this, "observers", []);
        (0, $iwGlz.default)(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    (0, $fuVkU.default)(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                if (this.started) return;
                this.started = true;
                document.addEventListener("visibilitychange", this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ if ((0, $e4Wr6.isWindowObjectAvailable)()) window.addEventListener("pagehide", this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
    return VisibilityChangeObserver;
}();
var $36420ce6fc9abc9b$export$13e680397ec8f3eb = new $36420ce6fc9abc9b$var$VisibilityChangeObserver();

});

parcelRegister("i3qXh", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", function () { return $d24d6a842470e354$export$5f490af6b2b115cf; });
var $d24d6a842470e354$export$5f490af6b2b115cf = function roundPerfNow() {
    return ~~performance.now();
};

});

parcelRegister("fouDS", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", function () { return $b350ddd438a24fcd$export$81b70111112841a0; });
var $b350ddd438a24fcd$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: "NOT_STARTED",
        final: true
    },
    STARTED: {
        id: "STARTED"
    },
    IN_PROGRESS: {
        id: "IN_PROGRESS"
    },
    BLOCKED: {
        id: "BLOCKED"
    },
    RECOVERED: {
        id: "RECOVERED"
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: "SUCCEEDED",
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: "SUCCEEDED_WAITING_FOR_DEPS"
    },
    FAILED: {
        id: "FAILED",
        final: true
    },
    ABORTED: {
        id: "ABORTED",
        final: true
    }
};

});

parcelRegister("lS6HX", function(module, exports) {

$parcel$export(module.exports, "canTransition", function () { return $fec3d8312bb020b8$export$178881f329fdb81f; });

var $iwGlz = parcelRequire("iwGlz");

var $fouDS = parcelRequire("fouDS");
var $fec3d8312bb020b8$var$_UFOStateAvailableTra;
var $fec3d8312bb020b8$var$UFOStateAvailableTransitions = ($fec3d8312bb020b8$var$_UFOStateAvailableTra = {}, (0, $iwGlz.default)($fec3d8312bb020b8$var$_UFOStateAvailableTra, (0, $fouDS.UFOExperienceState).NOT_STARTED.id, [
    (0, $fouDS.UFOExperienceState).STARTED.id
]), (0, $iwGlz.default)($fec3d8312bb020b8$var$_UFOStateAvailableTra, (0, $fouDS.UFOExperienceState).STARTED.id, [
    (0, $fouDS.UFOExperienceState).IN_PROGRESS.id,
    (0, $fouDS.UFOExperienceState).BLOCKED.id,
    (0, $fouDS.UFOExperienceState).SUCCEEDED.id,
    (0, $fouDS.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $fouDS.UFOExperienceState).FAILED.id,
    (0, $fouDS.UFOExperienceState).ABORTED.id
]), (0, $iwGlz.default)($fec3d8312bb020b8$var$_UFOStateAvailableTra, (0, $fouDS.UFOExperienceState).IN_PROGRESS.id, [
    (0, $fouDS.UFOExperienceState).BLOCKED.id,
    (0, $fouDS.UFOExperienceState).SUCCEEDED.id,
    (0, $fouDS.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $fouDS.UFOExperienceState).FAILED.id,
    (0, $fouDS.UFOExperienceState).ABORTED.id
]), (0, $iwGlz.default)($fec3d8312bb020b8$var$_UFOStateAvailableTra, (0, $fouDS.UFOExperienceState).BLOCKED.id, [
    (0, $fouDS.UFOExperienceState).RECOVERED.id,
    (0, $fouDS.UFOExperienceState).ABORTED.id
]), (0, $iwGlz.default)($fec3d8312bb020b8$var$_UFOStateAvailableTra, (0, $fouDS.UFOExperienceState).RECOVERED.id, [
    (0, $fouDS.UFOExperienceState).STARTED.id,
    (0, $fouDS.UFOExperienceState).SUCCEEDED.id,
    (0, $fouDS.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $fouDS.UFOExperienceState).FAILED.id,
    (0, $fouDS.UFOExperienceState).ABORTED.id
]), (0, $iwGlz.default)($fec3d8312bb020b8$var$_UFOStateAvailableTra, (0, $fouDS.UFOExperienceState).SUCCEEDED.id, [
    (0, $fouDS.UFOExperienceState).STARTED.id
]), (0, $iwGlz.default)($fec3d8312bb020b8$var$_UFOStateAvailableTra, (0, $fouDS.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id, [
    (0, $fouDS.UFOExperienceState).SUCCEEDED.id,
    (0, $fouDS.UFOExperienceState).FAILED.id,
    (0, $fouDS.UFOExperienceState).ABORTED.id
]), (0, $iwGlz.default)($fec3d8312bb020b8$var$_UFOStateAvailableTra, (0, $fouDS.UFOExperienceState).FAILED.id, [
    (0, $fouDS.UFOExperienceState).STARTED.id
]), (0, $iwGlz.default)($fec3d8312bb020b8$var$_UFOStateAvailableTra, (0, $fouDS.UFOExperienceState).ABORTED.id, [
    (0, $fouDS.UFOExperienceState).STARTED.id
]), $fec3d8312bb020b8$var$_UFOStateAvailableTra);
var $fec3d8312bb020b8$export$178881f329fdb81f = function canTransition(state1, state2) {
    return $fec3d8312bb020b8$var$UFOStateAvailableTransitions[state1.id] && $fec3d8312bb020b8$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});





parcelRegister("2EDqo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1eede61cbea36a5d$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $hUXhl = parcelRequire("hUXhl");

var $2O9Xz = parcelRequire("2O9Xz");

var $l9fTN = parcelRequire("l9fTN");
var $7WTyE = parcelRequire("7WTyE");

var $1Xueb = parcelRequire("1Xueb");

var $jZVbn = parcelRequire("jZVbn");
var $5rf5I = parcelRequire("5rf5I");
var $a6XiB = parcelRequire("a6XiB");
var $bnteb = parcelRequire("bnteb");
/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ var $1eede61cbea36a5d$var$EmptyState = function EmptyState(_ref) {
    var buttonGroupLabel = _ref.buttonGroupLabel, description = _ref.description, header = _ref.header, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 4 : _ref$headingLevel, _ref$headingSize = _ref.headingSize, headingSize = _ref$headingSize === void 0 ? "medium" : _ref$headingSize, imageHeight = _ref.imageHeight, imageUrl = _ref.imageUrl, imageWidth = _ref.imageWidth, isLoading = _ref.isLoading, _ref$maxImageHeight = _ref.maxImageHeight, maxImageHeight = _ref$maxImageHeight === void 0 ? 160 : _ref$maxImageHeight, _ref$maxImageWidth = _ref.maxImageWidth, maxImageWidth = _ref$maxImageWidth === void 0 ? 160 : _ref$maxImageWidth, primaryAction = _ref.primaryAction, renderImage = _ref.renderImage, secondaryAction = _ref.secondaryAction, width = _ref.width, tertiaryAction = _ref.tertiaryAction, testId = _ref.testId;
    var actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $jZVbn.default), null, primaryAction && secondaryAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $hUXhl.default), {
        label: buttonGroupLabel || "Button group",
        testId: testId && "".concat(testId, "-button-group")
    }, secondaryAction, primaryAction) : primaryAction || secondaryAction, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $bnteb.default), null, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1Xueb.default), {
        testId: "empty-state-spinner"
    }))) : null;
    var tag = "h".concat(headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5rf5I.default), {
        testId: testId,
        width: width || "wide"
    }, imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a6XiB.default), {
        src: imageUrl,
        maxWidth: maxImageWidth,
        maxHeight: maxImageHeight,
        width: imageWidth,
        height: imageHeight
    }) : renderImage && renderImage({
        maxImageWidth: maxImageWidth,
        maxImageHeight: maxImageHeight,
        imageWidth: imageWidth,
        imageHeight: imageHeight
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $l9fTN.default), {
        paddingBlockEnd: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2O9Xz.default), {
        size: headingSize,
        as: tag
    }, header)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $l9fTN.default), {
        paddingBlockEnd: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $7WTyE.default), {
        as: "p"
    }, description)), actionsContainer, tertiaryAction);
};
var $1eede61cbea36a5d$export$2e2bcd8739ae039 = $1eede61cbea36a5d$var$EmptyState;

});
parcelRegister("hUXhl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0b5a62ced001213$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");
var $d0b5a62ced001213$var$buttonGroupStyles = (0, $2ZUkg.css)({
    display: "inline-flex",
    gap: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> *": {
        flex: "1 0 auto"
    }
});
function $d0b5a62ced001213$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, testId = _ref.testId, label = _ref.label, titleId = _ref.titleId;
    return (0, $2ZUkg.jsx)("div", {
        css: $d0b5a62ced001213$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Children.toArray(children), function(child, idx) {
        if (!child) return null;
        return (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), {
            key: idx
        }, child);
    }));
}

});

parcelRegister("2O9Xz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20b7fa14b7c566d3$export$2e2bcd8739ae039; });
/* heading.partial.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $OHUyB = parcelRequire("OHUyB");

var $iSvIT = parcelRequire("iSvIT");

var $hQZqJ = parcelRequire("hQZqJ");

var $9rivP = parcelRequire("9rivP");

var $h0e3u = parcelRequire("h0e3u");

var $ksy24 = parcelRequire("ksy24");

var $XAEGR = parcelRequire("XAEGR");
var $20b7fa14b7c566d3$var$sizeTagMap = {
    xxlarge: "h1",
    xlarge: "h1",
    large: "h2",
    medium: "h3",
    small: "h4",
    xsmall: "h5",
    xxsmall: "h6"
};
var $20b7fa14b7c566d3$var$styles = {
    reset: "_1mouidpf _1dyz4jg8 _1p1dglyw"
};
var $20b7fa14b7c566d3$var$headingColorStylesMap = {
    "color.text": "_syaz1fxt",
    "color.text.inverse": "_syaz15cr",
    "color.text.warning.inverse": "_syazal3n"
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c47bed69b7a147a63fdb8c394e98514a>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $20b7fa14b7c566d3$var$headingSizeStylesMap = {
    xxlarge: "_11c84xcc",
    xlarge: "_11c81c04",
    large: "_11c8nf1z",
    medium: "_11c8lodh",
    small: "_11c8nbxd",
    xsmall: "_11c8140y",
    xxsmall: "_11c81vhk"
};
/**
 * @codegenEnd
 */ var $20b7fa14b7c566d3$var$useColor = function useColor(colorProp) {
    var surface = (0, $h0e3u.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $9rivP.inverseColorMap).hasOwnProperty(surface)) return (0, $9rivP.inverseColorMap)[surface];
    return "color.text";
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $20b7fa14b7c566d3$var$Heading = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof $XAEGR;
    var _useHeading = (0, $ksy24.useHeading)($20b7fa14b7c566d3$var$sizeTagMap[size]), _useHeading2 = (0, $OHUyB.default)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === "div" && hLevel;
    var color = $20b7fa14b7c566d3$var$useColor(colorProp);
    return /*#__PURE__*/ $iSvIT.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $hQZqJ.default)([
            $20b7fa14b7c566d3$var$styles.reset,
            size && $20b7fa14b7c566d3$var$headingSizeStylesMap[size],
            $20b7fa14b7c566d3$var$headingColorStylesMap[color]
        ])
    }, children);
});
var $20b7fa14b7c566d3$export$2e2bcd8739ae039 = $20b7fa14b7c566d3$var$Heading;

});
parcelRegister("OHUyB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0986bb7a62c4b506$export$2e2bcd8739ae039; });

var $8il4N = parcelRequire("8il4N");

var $6ZP7D = parcelRequire("6ZP7D");

var $3rGzL = parcelRequire("3rGzL");

var $lkyhV = parcelRequire("lkyhV");
function $0986bb7a62c4b506$export$2e2bcd8739ae039(r, e) {
    return (0, $8il4N.default)(r) || (0, $6ZP7D.default)(r, e) || (0, $3rGzL.default)(r, e) || (0, $lkyhV.default)();
}

});
parcelRegister("8il4N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60a05a811fa79391$export$2e2bcd8739ae039; });
function $60a05a811fa79391$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("6ZP7D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5180185b3dc11f53$export$2e2bcd8739ae039; });
function $5180185b3dc11f53$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("3rGzL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2824eb629d959c6b$export$2e2bcd8739ae039; });

var $kmEQo = parcelRequire("kmEQo");
function $2824eb629d959c6b$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $kmEQo.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $kmEQo.default)(r, a) : void 0;
    }
}

});
parcelRegister("kmEQo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed358b7a79a76c01$export$2e2bcd8739ae039; });
function $ed358b7a79a76c01$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("lkyhV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f876102569e7abe9$export$2e2bcd8739ae039; });
function $f876102569e7abe9$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("hQZqJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cff6f1c1c7d3c9e9$export$2e2bcd8739ae039; });
const $cff6f1c1c7d3c9e9$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $cff6f1c1c7d3c9e9$var$ATOMIC_GROUP_LENGTH = 5;
function $cff6f1c1c7d3c9e9$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $cff6f1c1c7d3c9e9$var$UNDERSCORE_UNICODE ? $cff6f1c1c7d3c9e9$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("9rivP", function(module, exports) {

$parcel$export(module.exports, "inverseColorMap", function () { return $6df4feddd4fc46aa$export$2185ce37f9bdd963; });

var $kWKbB = parcelRequire("kWKbB");

var $2ZUkg = parcelRequire("2ZUkg");

var $hF78t = parcelRequire("hF78t");
function $6df4feddd4fc46aa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6df4feddd4fc46aa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6df4feddd4fc46aa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $kWKbB.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6df4feddd4fc46aa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6df4feddd4fc46aa$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $6df4feddd4fc46aa$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $6df4feddd4fc46aa$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $6df4feddd4fc46aa$export$632685d741f3dbbf = $6df4feddd4fc46aa$var$_objectSpread($6df4feddd4fc46aa$var$_objectSpread({}, $6df4feddd4fc46aa$export$958d0ae7f2977ae4), $6df4feddd4fc46aa$export$d2dc61f58390201c);
var $6df4feddd4fc46aa$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $6df4feddd4fc46aa$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $6df4feddd4fc46aa$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $6df4feddd4fc46aa$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $6df4feddd4fc46aa$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $6df4feddd4fc46aa$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $6df4feddd4fc46aa$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $6df4feddd4fc46aa$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtlest": "var(--ds-icon-subtlest, #6B778C)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $6df4feddd4fc46aa$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $6df4feddd4fc46aa$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $6df4feddd4fc46aa$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $6df4feddd4fc46aa$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $6df4feddd4fc46aa$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $6df4feddd4fc46aa$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $6df4feddd4fc46aa$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $6df4feddd4fc46aa$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $6df4feddd4fc46aa$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $6df4feddd4fc46aa$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $2ZUkg.css)((0, $kWKbB.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $6df4feddd4fc46aa$export$e615f061ca585a6c = $6df4feddd4fc46aa$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $6df4feddd4fc46aa$export$ca0f9c2de39ffed7(spacingProperty, $6df4feddd4fc46aa$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $6df4feddd4fc46aa$export$bf46c3f9eeafc71f = $6df4feddd4fc46aa$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $6df4feddd4fc46aa$export$ca0f9c2de39ffed7(spacingProperty, $6df4feddd4fc46aa$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $6df4feddd4fc46aa$export$e7af83bafe7f9e63 = $6df4feddd4fc46aa$export$ca0f9c2de39ffed7("backgroundColor", $6df4feddd4fc46aa$export$d1d79bf68ac056bd);
var $6df4feddd4fc46aa$export$3a1bcba60b23d7f0 = $6df4feddd4fc46aa$export$ca0f9c2de39ffed7("color", $6df4feddd4fc46aa$export$8473307aa00d6ea1);
var $6df4feddd4fc46aa$export$45f3f4fe16f9f7d5 = $6df4feddd4fc46aa$export$ca0f9c2de39ffed7("fontWeight", $6df4feddd4fc46aa$export$303e322c6b1ed114);
var $6df4feddd4fc46aa$export$68cc305da27dbaa4 = $6df4feddd4fc46aa$export$ca0f9c2de39ffed7("fontFamily", $6df4feddd4fc46aa$export$3c7e9587132614b4);
var $6df4feddd4fc46aa$export$128f10c238242f83 = $6df4feddd4fc46aa$export$ca0f9c2de39ffed7("font", $6df4feddd4fc46aa$export$6ffa317d5e70375);
var $6df4feddd4fc46aa$export$219d364c0da35ae4 = $6df4feddd4fc46aa$export$ca0f9c2de39ffed7("font", $6df4feddd4fc46aa$export$236bfe3a33ef1292);
var $6df4feddd4fc46aa$export$38845ca010b93505 = $6df4feddd4fc46aa$export$ca0f9c2de39ffed7("fontWeight", $6df4feddd4fc46aa$export$855cfd311192d666);
var $6df4feddd4fc46aa$export$ff257d957d48c421 = $6df4feddd4fc46aa$export$ca0f9c2de39ffed7((0, $hF78t.CURRENT_SURFACE_CSS_VAR), $6df4feddd4fc46aa$export$41a358c9c2356760);
var $6df4feddd4fc46aa$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $6df4feddd4fc46aa$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("kWKbB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3fd0d030e7a7b00$export$2e2bcd8739ae039; });

var $c5te8 = parcelRequire("c5te8");
function $f3fd0d030e7a7b00$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $c5te8.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("c5te8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ccc9f892d3f535f$export$2e2bcd8739ae039; });

var $jMAJN = parcelRequire("jMAJN");

var $dsuUD = parcelRequire("dsuUD");
function $8ccc9f892d3f535f$export$2e2bcd8739ae039(t) {
    var i = (0, $dsuUD.default)(t, "string");
    return "symbol" == (0, $jMAJN.default)(i) ? i : i + "";
}

});
parcelRegister("jMAJN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e66eff587397e167$export$2e2bcd8739ae039; });
function $e66eff587397e167$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $e66eff587397e167$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e66eff587397e167$export$2e2bcd8739ae039(o);
}

});

parcelRegister("dsuUD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cc5de7a2dbe6f76$export$2e2bcd8739ae039; });

var $jMAJN = parcelRequire("jMAJN");
function $9cc5de7a2dbe6f76$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $jMAJN.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $jMAJN.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("hF78t", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $cdbbcd00e62b0b00$export$9d7b58831ae93caa; });
var $cdbbcd00e62b0b00$export$4ef52930e33717cd = "data-theme";
var $cdbbcd00e62b0b00$export$a00eac3f8684bcd0 = "data-color-mode";
var $cdbbcd00e62b0b00$export$2112803007239c61 = "data-contrast-mode";
var $cdbbcd00e62b0b00$export$352e418ed5b6193a = "data-custom-theme";
var $cdbbcd00e62b0b00$export$6f0c6fb8c80fcc92 = "ds";
var $cdbbcd00e62b0b00$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $cdbbcd00e62b0b00$export$dddac1532e822863 = "--".concat($cdbbcd00e62b0b00$export$6f0c6fb8c80fcc92, "-token-not-found");
var $cdbbcd00e62b0b00$export$9d7b58831ae93caa = "--".concat($cdbbcd00e62b0b00$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("h0e3u", function(module, exports) {

$parcel$export(module.exports, "useSurface", function () { return $c60d56da1d4de1bc$export$1aeb4f6b93c4540d; });

var $iSvIT = parcelRequire("iSvIT");
var $c60d56da1d4de1bc$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $iSvIT.createContext)("elevation.surface");
var $c60d56da1d4de1bc$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $iSvIT.useContext)($c60d56da1d4de1bc$export$1ca2a26fecb070ae);
};
$c60d56da1d4de1bc$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});

parcelRegister("ksy24", function(module, exports) {

$parcel$export(module.exports, "useHeading", function () { return $ee50d247cb57858a$export$97a37b1befbbf9b1; });

var $iSvIT = parcelRequire("iSvIT");
// Allows support for heading levels 1-9 via aria-level
var $ee50d247cb57858a$var$HeadingLevelContext = /*#__PURE__*/ (0, $iSvIT.createContext)(0);
/**
 * @internal
 * @returns The current heading level context.
 */ var $ee50d247cb57858a$var$useHeadingLevel = function useHeadingLevel() {
    return (0, $iSvIT.useContext)($ee50d247cb57858a$var$HeadingLevelContext);
};
var $ee50d247cb57858a$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $ee50d247cb57858a$var$useHeadingLevel();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? "div" : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $ee50d247cb57858a$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $ee50d247cb57858a$var$useHeadingLevel();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($ee50d247cb57858a$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $ee50d247cb57858a$export$2e2bcd8739ae039 = $ee50d247cb57858a$var$HeadingLevelContextProvider;

});


parcelRegister("l9fTN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f656c56a0f40c447$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $fjEbn = parcelRequire("fjEbn");

var $b70Jn = parcelRequire("b70Jn");

var $iSvIT = parcelRequire("iSvIT");

var $hQZqJ = parcelRequire("hQZqJ");

var $jYvuh = parcelRequire("jYvuh");
var $f656c56a0f40c447$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $f656c56a0f40c447$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $f656c56a0f40c447$var$baseStyles = null;
var $f656c56a0f40c447$var$backgroundColorMap = {
    "color.background.accent.lime.subtlest": "_bfhkm890",
    "color.background.accent.lime.subtlest.hovered": "_bfhkd4y8",
    "color.background.accent.lime.subtlest.pressed": "_bfhk1fno",
    "color.background.accent.lime.subtler": "_bfhkz2ec",
    "color.background.accent.lime.subtler.hovered": "_bfhk1eds",
    "color.background.accent.lime.subtler.pressed": "_bfhk1hgz",
    "color.background.accent.lime.subtle": "_bfhkbq5w",
    "color.background.accent.lime.subtle.hovered": "_bfhkfoww",
    "color.background.accent.lime.subtle.pressed": "_bfhkhgj8",
    "color.background.accent.lime.bolder": "_bfhktde4",
    "color.background.accent.lime.bolder.hovered": "_bfhknzpa",
    "color.background.accent.lime.bolder.pressed": "_bfhk1b17",
    "color.background.accent.red.subtlest": "_bfhk1vk5",
    "color.background.accent.red.subtlest.hovered": "_bfhk1i6i",
    "color.background.accent.red.subtlest.pressed": "_bfhk1pbw",
    "color.background.accent.red.subtler": "_bfhk1rtt",
    "color.background.accent.red.subtler.hovered": "_bfhkrw5d",
    "color.background.accent.red.subtler.pressed": "_bfhk69rw",
    "color.background.accent.red.subtle": "_bfhkkrt9",
    "color.background.accent.red.subtle.hovered": "_bfhk1sou",
    "color.background.accent.red.subtle.pressed": "_bfhk1tf4",
    "color.background.accent.red.bolder": "_bfhkuibq",
    "color.background.accent.red.bolder.hovered": "_bfhk100f",
    "color.background.accent.red.bolder.pressed": "_bfhkprmn",
    "color.background.accent.orange.subtlest": "_bfhk1g3m",
    "color.background.accent.orange.subtlest.hovered": "_bfhkg4tm",
    "color.background.accent.orange.subtlest.pressed": "_bfhk1ya0",
    "color.background.accent.orange.subtler": "_bfhkf2vu",
    "color.background.accent.orange.subtler.hovered": "_bfhk1lml",
    "color.background.accent.orange.subtler.pressed": "_bfhkuxsx",
    "color.background.accent.orange.subtle": "_bfhk1g6e",
    "color.background.accent.orange.subtle.hovered": "_bfhk1oew",
    "color.background.accent.orange.subtle.pressed": "_bfhk1phk",
    "color.background.accent.orange.bolder": "_bfhkjgng",
    "color.background.accent.orange.bolder.hovered": "_bfhkhi52",
    "color.background.accent.orange.bolder.pressed": "_bfhkf767",
    "color.background.accent.yellow.subtlest": "_bfhk1ozg",
    "color.background.accent.yellow.subtlest.hovered": "_bfhk19g9",
    "color.background.accent.yellow.subtlest.pressed": "_bfhk31d1",
    "color.background.accent.yellow.subtler": "_bfhk3fv2",
    "color.background.accent.yellow.subtler.hovered": "_bfhklg04",
    "color.background.accent.yellow.subtler.pressed": "_bfhk1d44",
    "color.background.accent.yellow.subtle": "_bfhkry5t",
    "color.background.accent.yellow.subtle.hovered": "_bfhk17e6",
    "color.background.accent.yellow.subtle.pressed": "_bfhko0y5",
    "color.background.accent.yellow.bolder": "_bfhk1vop",
    "color.background.accent.yellow.bolder.hovered": "_bfhkkjqf",
    "color.background.accent.yellow.bolder.pressed": "_bfhk32kj",
    "color.background.accent.green.subtlest": "_bfhkn729",
    "color.background.accent.green.subtlest.hovered": "_bfhk3utz",
    "color.background.accent.green.subtlest.pressed": "_bfhkv5yf",
    "color.background.accent.green.subtler": "_bfhk1wnw",
    "color.background.accent.green.subtler.hovered": "_bfhkung8",
    "color.background.accent.green.subtler.pressed": "_bfhk1p19",
    "color.background.accent.green.subtle": "_bfhk1rsu",
    "color.background.accent.green.subtle.hovered": "_bfhk12e3",
    "color.background.accent.green.subtle.pressed": "_bfhk8h4p",
    "color.background.accent.green.bolder": "_bfhk1e5c",
    "color.background.accent.green.bolder.hovered": "_bfhka5yi",
    "color.background.accent.green.bolder.pressed": "_bfhk1azz",
    "color.background.accent.teal.subtlest": "_bfhk7xuz",
    "color.background.accent.teal.subtlest.hovered": "_bfhk108c",
    "color.background.accent.teal.subtlest.pressed": "_bfhk1j2h",
    "color.background.accent.teal.subtler": "_bfhk1a17",
    "color.background.accent.teal.subtler.hovered": "_bfhkg5py",
    "color.background.accent.teal.subtler.pressed": "_bfhkq7li",
    "color.background.accent.teal.subtle": "_bfhktdv8",
    "color.background.accent.teal.subtle.hovered": "_bfhkzh8h",
    "color.background.accent.teal.subtle.pressed": "_bfhk10ai",
    "color.background.accent.teal.bolder": "_bfhk2c8p",
    "color.background.accent.teal.bolder.hovered": "_bfhkl3ve",
    "color.background.accent.teal.bolder.pressed": "_bfhkse6l",
    "color.background.accent.blue.subtlest": "_bfhkavxe",
    "color.background.accent.blue.subtlest.hovered": "_bfhkay3p",
    "color.background.accent.blue.subtlest.pressed": "_bfhk1xmr",
    "color.background.accent.blue.subtler": "_bfhk4v9p",
    "color.background.accent.blue.subtler.hovered": "_bfhk16e6",
    "color.background.accent.blue.subtler.pressed": "_bfhk1uh7",
    "color.background.accent.blue.subtle": "_bfhk1j89",
    "color.background.accent.blue.subtle.hovered": "_bfhk1f4s",
    "color.background.accent.blue.subtle.pressed": "_bfhkqctv",
    "color.background.accent.blue.bolder": "_bfhkc8cv",
    "color.background.accent.blue.bolder.hovered": "_bfhk1cwi",
    "color.background.accent.blue.bolder.pressed": "_bfhkhcrq",
    "color.background.accent.purple.subtlest": "_bfhkp7j4",
    "color.background.accent.purple.subtlest.hovered": "_bfhkm0d5",
    "color.background.accent.purple.subtlest.pressed": "_bfhkgslw",
    "color.background.accent.purple.subtler": "_bfhk1jkz",
    "color.background.accent.purple.subtler.hovered": "_bfhk1wyu",
    "color.background.accent.purple.subtler.pressed": "_bfhk5fkp",
    "color.background.accent.purple.subtle": "_bfhkdh45",
    "color.background.accent.purple.subtle.hovered": "_bfhk1wob",
    "color.background.accent.purple.subtle.pressed": "_bfhkwz05",
    "color.background.accent.purple.bolder": "_bfhkygwo",
    "color.background.accent.purple.bolder.hovered": "_bfhkadgs",
    "color.background.accent.purple.bolder.pressed": "_bfhk1uro",
    "color.background.accent.magenta.subtlest": "_bfhk8tvm",
    "color.background.accent.magenta.subtlest.hovered": "_bfhkr3zd",
    "color.background.accent.magenta.subtlest.pressed": "_bfhk1een",
    "color.background.accent.magenta.subtler": "_bfhkv9ra",
    "color.background.accent.magenta.subtler.hovered": "_bfhk1r0p",
    "color.background.accent.magenta.subtler.pressed": "_bfhkxuzc",
    "color.background.accent.magenta.subtle": "_bfhk1mi6",
    "color.background.accent.magenta.subtle.hovered": "_bfhkrwyz",
    "color.background.accent.magenta.subtle.pressed": "_bfhk1ovh",
    "color.background.accent.magenta.bolder": "_bfhkc3uk",
    "color.background.accent.magenta.bolder.hovered": "_bfhk1ok8",
    "color.background.accent.magenta.bolder.pressed": "_bfhkwaw3",
    "color.background.accent.gray.subtlest": "_bfhk11bn",
    "color.background.accent.gray.subtlest.hovered": "_bfhk12j4",
    "color.background.accent.gray.subtlest.pressed": "_bfhk1lb4",
    "color.background.accent.gray.subtler": "_bfhk1v33",
    "color.background.accent.gray.subtler.hovered": "_bfhk1f7l",
    "color.background.accent.gray.subtler.pressed": "_bfhkd8a2",
    "color.background.accent.gray.subtle": "_bfhk1t05",
    "color.background.accent.gray.subtle.hovered": "_bfhk1a2l",
    "color.background.accent.gray.subtle.pressed": "_bfhk1z0s",
    "color.background.accent.gray.bolder": "_bfhk1t1b",
    "color.background.accent.gray.bolder.hovered": "_bfhke4nv",
    "color.background.accent.gray.bolder.pressed": "_bfhk82ra",
    "color.background.disabled": "_bfhksyzs",
    "color.background.input": "_bfhk1j9a",
    "color.background.input.hovered": "_bfhk1d5g",
    "color.background.input.pressed": "_bfhkr01l",
    "color.background.inverse.subtle": "_bfhk1vck",
    "color.background.inverse.subtle.hovered": "_bfhkmpja",
    "color.background.inverse.subtle.pressed": "_bfhk1gii",
    "color.background.neutral": "_bfhkm7j4",
    "color.background.neutral.hovered": "_bfhk15ej",
    "color.background.neutral.pressed": "_bfhkip91",
    "color.background.neutral.subtle": "_bfhksm61",
    "color.background.neutral.subtle.hovered": "_bfhk166n",
    "color.background.neutral.subtle.pressed": "_bfhk1dty",
    "color.background.neutral.bold": "_bfhkcdhy",
    "color.background.neutral.bold.hovered": "_bfhk1bsc",
    "color.background.neutral.bold.pressed": "_bfhk1b6k",
    "color.background.selected": "_bfhkfg4m",
    "color.background.selected.hovered": "_bfhki1yw",
    "color.background.selected.pressed": "_bfhk19ru",
    "color.background.selected.bold": "_bfhk1fvw",
    "color.background.selected.bold.hovered": "_bfhk18hz",
    "color.background.selected.bold.pressed": "_bfhkgr1v",
    "color.background.brand.subtlest": "_bfhk3wxy",
    "color.background.brand.subtlest.hovered": "_bfhkezq1",
    "color.background.brand.subtlest.pressed": "_bfhk2ggb",
    "color.background.brand.bold": "_bfhkb29m",
    "color.background.brand.bold.hovered": "_bfhku1se",
    "color.background.brand.bold.pressed": "_bfhkqkzo",
    "color.background.brand.boldest": "_bfhk15mt",
    "color.background.brand.boldest.hovered": "_bfhk1uwk",
    "color.background.brand.boldest.pressed": "_bfhk17jr",
    "color.background.danger": "_bfhk1gly",
    "color.background.danger.hovered": "_bfhk1yvi",
    "color.background.danger.pressed": "_bfhk1io2",
    "color.background.danger.bold": "_bfhkybec",
    "color.background.danger.bold.hovered": "_bfhks9hg",
    "color.background.danger.bold.pressed": "_bfhk9pqq",
    "color.background.warning": "_bfhk1tzq",
    "color.background.warning.hovered": "_bfhk1rd4",
    "color.background.warning.pressed": "_bfhk11dh",
    "color.background.warning.bold": "_bfhk190i",
    "color.background.warning.bold.hovered": "_bfhk1i4c",
    "color.background.warning.bold.pressed": "_bfhkrj9s",
    "color.background.success": "_bfhkmv6i",
    "color.background.success.hovered": "_bfhk1jgi",
    "color.background.success.pressed": "_bfhky4f1",
    "color.background.success.bold": "_bfhk8emd",
    "color.background.success.bold.hovered": "_bfhk1q4l",
    "color.background.success.bold.pressed": "_bfhkcrcn",
    "color.background.discovery": "_bfhk1nvp",
    "color.background.discovery.hovered": "_bfhk1xp7",
    "color.background.discovery.pressed": "_bfhkdlkp",
    "color.background.discovery.bold": "_bfhk1lri",
    "color.background.discovery.bold.hovered": "_bfhk1w72",
    "color.background.discovery.bold.pressed": "_bfhkrb53",
    "color.background.information": "_bfhk33gi",
    "color.background.information.hovered": "_bfhk1vps",
    "color.background.information.pressed": "_bfhk1s0z",
    "color.background.information.bold": "_bfhk14wj",
    "color.background.information.bold.hovered": "_bfhk1amz",
    "color.background.information.bold.pressed": "_bfhk5bth",
    "color.blanket": "_bfhk10xm",
    "color.blanket.selected": "_bfhk7wq0",
    "color.blanket.danger": "_bfhkrprw",
    "color.skeleton": "_bfhkn82g",
    "color.skeleton.subtle": "_bfhkh3tw",
    "elevation.surface": "_bfhkvuon",
    "elevation.surface.hovered": "_bfhk108i",
    "elevation.surface.pressed": "_bfhk1ji5",
    "elevation.surface.overlay": "_bfhk1bhr",
    "elevation.surface.overlay.hovered": "_bfhk16qz",
    "elevation.surface.overlay.pressed": "_bfhkvq0a",
    "elevation.surface.raised": "_bfhkhp5a",
    "elevation.surface.raised.hovered": "_bfhk1a0f",
    "elevation.surface.raised.pressed": "_bfhkf7u5",
    "elevation.surface.sunken": "_bfhkqbzx",
    "utility.elevation.surface.current": "_bfhkchd4"
};
var $f656c56a0f40c447$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $f656c56a0f40c447$var$setSurfaceTokenMap = {
    "elevation.surface": "_1q1lvuon",
    "elevation.surface.hovered": "_1q1l108i",
    "elevation.surface.pressed": "_1q1l1ji5",
    "elevation.surface.overlay": "_1q1l1bhr",
    "elevation.surface.overlay.hovered": "_1q1l16qz",
    "elevation.surface.overlay.pressed": "_1q1lvq0a",
    "elevation.surface.raised": "_1q1lhp5a",
    "elevation.surface.raised.hovered": "_1q1l1a0f",
    "elevation.surface.raised.pressed": "_1q1lf7u5",
    "elevation.surface.sunken": "_1q1lqbzx"
};
var $f656c56a0f40c447$var$paddingBlockStartMap = {
    "space.0": "_1q51ze3t",
    "space.025": "_1q51v77o",
    "space.050": "_1q511b66",
    "space.075": "_1q5112x7",
    "space.100": "_1q51u2gc",
    "space.150": "_1q51utpp",
    "space.200": "_1q51pxbi",
    "space.250": "_1q51v47k",
    "space.300": "_1q511ejb",
    "space.400": "_1q51xy5q",
    "space.500": "_1q511jfw",
    "space.600": "_1q51oahv",
    "space.800": "_1q51xncg",
    "space.1000": "_1q511epz"
};
var $f656c56a0f40c447$var$paddingBlockEndMap = {
    "space.0": "_85i5ze3t",
    "space.025": "_85i5v77o",
    "space.050": "_85i51b66",
    "space.075": "_85i512x7",
    "space.100": "_85i5u2gc",
    "space.150": "_85i5utpp",
    "space.200": "_85i5pxbi",
    "space.250": "_85i5v47k",
    "space.300": "_85i51ejb",
    "space.400": "_85i5xy5q",
    "space.500": "_85i51jfw",
    "space.600": "_85i5oahv",
    "space.800": "_85i5xncg",
    "space.1000": "_85i51epz"
};
var $f656c56a0f40c447$var$paddingInlineStartMap = {
    "space.0": "_bozgze3t",
    "space.025": "_bozgv77o",
    "space.050": "_bozg1b66",
    "space.075": "_bozg12x7",
    "space.100": "_bozgu2gc",
    "space.150": "_bozgutpp",
    "space.200": "_bozgpxbi",
    "space.250": "_bozgv47k",
    "space.300": "_bozg1ejb",
    "space.400": "_bozgxy5q",
    "space.500": "_bozg1jfw",
    "space.600": "_bozgoahv",
    "space.800": "_bozgxncg",
    "space.1000": "_bozg1epz"
};
var $f656c56a0f40c447$var$paddingInlineEndMap = {
    "space.0": "_y4tize3t",
    "space.025": "_y4tiv77o",
    "space.050": "_y4ti1b66",
    "space.075": "_y4ti12x7",
    "space.100": "_y4tiu2gc",
    "space.150": "_y4tiutpp",
    "space.200": "_y4tipxbi",
    "space.250": "_y4tiv47k",
    "space.300": "_y4ti1ejb",
    "space.400": "_y4tixy5q",
    "space.500": "_y4ti1jfw",
    "space.600": "_y4tioahv",
    "space.800": "_y4tixncg",
    "space.1000": "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $f656c56a0f40c447$var$Box = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $b70Jn.default)(_ref, $f656c56a0f40c447$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $b70Jn.default)(htmlAttributes, $f656c56a0f40c447$var$_excluded2);
    var node = /*#__PURE__*/ $iSvIT.createElement(Component, (0, $fjEbn.default)({
        style: style,
        ref: ref,
        className: (0, $hQZqJ.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $f656c56a0f40c447$var$backgroundColorMap[backgroundColor],
            backgroundColor && $f656c56a0f40c447$var$isSurfaceToken(backgroundColor) && $f656c56a0f40c447$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $f656c56a0f40c447$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $f656c56a0f40c447$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $f656c56a0f40c447$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $f656c56a0f40c447$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $iSvIT.createElement((0, $jYvuh.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $f656c56a0f40c447$export$2e2bcd8739ae039 = $f656c56a0f40c447$var$Box;
function $f656c56a0f40c447$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $f656c56a0f40c447$var$setSurfaceTokenMap;
}

});
parcelRegister("fjEbn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b267ccc294f6614b$export$2e2bcd8739ae039; });
function $b267ccc294f6614b$export$2e2bcd8739ae039() {
    return $b267ccc294f6614b$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b267ccc294f6614b$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("b70Jn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8170ea450e0fe8ac$export$2e2bcd8739ae039; });

var $2UHnK = parcelRequire("2UHnK");
function $8170ea450e0fe8ac$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $2UHnK.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("2UHnK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21f2767a079eeaf1$export$2e2bcd8739ae039; });
function $21f2767a079eeaf1$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("jYvuh", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $e8ac0ba607a0b376$export$1ca2a26fecb070ae; });
$parcel$export(module.exports, "useSurface", function () { return $e8ac0ba607a0b376$export$1aeb4f6b93c4540d; });

var $iSvIT = parcelRequire("iSvIT");
var $e8ac0ba607a0b376$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $iSvIT.createContext)("elevation.surface");
var $e8ac0ba607a0b376$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $iSvIT.useContext)($e8ac0ba607a0b376$export$1ca2a26fecb070ae);
};
$e8ac0ba607a0b376$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("7WTyE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c990bcd94a6f4a8$export$2e2bcd8739ae039; });
/* text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $hQZqJ = parcelRequire("hQZqJ");

var $jNYFj = parcelRequire("jNYFj");

var $leo44 = parcelRequire("leo44");

var $jYvuh = parcelRequire("jYvuh");
var $5c990bcd94a6f4a8$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $5c990bcd94a6f4a8$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $jYvuh.useSurface)();
    if (colorProp === "inherit") return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($5c990bcd94a6f4a8$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $5c990bcd94a6f4a8$export$2185ce37f9bdd963[surface];
    return "color.text";
};
var $5c990bcd94a6f4a8$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    "as.strong": "_k48pmoej",
    "as.em": "_zg8l1m30",
    "textAlign.center": "_y3gn1h6o",
    "textAlign.end": "_y3gnh9n0",
    "textAlign.start": "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $5c990bcd94a6f4a8$var$fontSizeMap = {
    medium: "_11c82smr",
    UNSAFE_small: "_11c8dcr7",
    large: "_11c81ixg",
    small: "_11c81o8v"
};
var $5c990bcd94a6f4a8$var$fontWeightMap = {
    bold: "_k48pmoej",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $5c990bcd94a6f4a8$var$textColorMap = {
    "color.text": "_syaz1fxt",
    "color.text.accent.lime": "_syaz1tco",
    "color.text.accent.lime.bolder": "_syaz1ik3",
    "color.text.accent.red": "_syaz9lu1",
    "color.text.accent.red.bolder": "_syazhwvp",
    "color.text.accent.orange": "_syaz1q28",
    "color.text.accent.orange.bolder": "_syaz1vps",
    "color.text.accent.yellow": "_syazfb2s",
    "color.text.accent.yellow.bolder": "_syazekll",
    "color.text.accent.green": "_syazh55r",
    "color.text.accent.green.bolder": "_syaz1y78",
    "color.text.accent.teal": "_syaz17qg",
    "color.text.accent.teal.bolder": "_syaz12v7",
    "color.text.accent.blue": "_syazpnps",
    "color.text.accent.blue.bolder": "_syazsc1o",
    "color.text.accent.purple": "_syaz10m5",
    "color.text.accent.purple.bolder": "_syaz2ibx",
    "color.text.accent.magenta": "_syaz1s8m",
    "color.text.accent.magenta.bolder": "_syaz1qur",
    "color.text.accent.gray": "_syaz1dyx",
    "color.text.accent.gray.bolder": "_syaz1x9z",
    "color.text.disabled": "_syaz1lh4",
    "color.text.inverse": "_syaz15cr",
    "color.text.selected": "_syazaqb7",
    "color.text.brand": "_syaz1e6v",
    "color.text.danger": "_syaz1tmw",
    "color.text.warning": "_syazwx40",
    "color.text.warning.inverse": "_syazal3n",
    "color.text.success": "_syazy73q",
    "color.text.discovery": "_syazzjem",
    "color.text.information": "_syaze0os",
    "color.text.subtlest": "_syaz131l",
    "color.text.subtle": "_syaz1gjq",
    "color.link": "_syaz14q2",
    "color.link.pressed": "_syaz16c2",
    "color.link.visited": "_syazw7te",
    "color.link.visited.pressed": "_syazg3x0"
};
var $5c990bcd94a6f4a8$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $5c990bcd94a6f4a8$var$Text = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $jNYFj.default)($5c990bcd94a6f4a8$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = (0, $leo44.useHasTextAncestor)();
    var color = $5c990bcd94a6f4a8$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = "medium";
    var component = /*#__PURE__*/ $iSvIT.createElement(Component, {
        id: id,
        className: (0, $hQZqJ.default)([
            $5c990bcd94a6f4a8$var$styles.root,
            size && $5c990bcd94a6f4a8$var$fontSizeMap[size],
            color && $5c990bcd94a6f4a8$var$textColorMap[color],
            maxLines && $5c990bcd94a6f4a8$var$styles.truncation,
            maxLines === 1 && $5c990bcd94a6f4a8$var$styles.breakAll,
            align && $5c990bcd94a6f4a8$var$styles["textAlign.".concat(align)],
            weight && $5c990bcd94a6f4a8$var$fontWeightMap[weight],
            Component === "em" && $5c990bcd94a6f4a8$var$styles["as.em"],
            Component === "strong" && $5c990bcd94a6f4a8$var$styles["as.strong"],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $iSvIT.createElement((0, $leo44.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $5c990bcd94a6f4a8$export$2e2bcd8739ae039 = $5c990bcd94a6f4a8$var$Text;

});
parcelRegister("leo44", function(module, exports) {

$parcel$export(module.exports, "useHasTextAncestor", function () { return $f74d92894bc1153a$export$9322276ec105d055; });
$parcel$export(module.exports, "HasTextAncestorProvider", function () { return $f74d92894bc1153a$export$ae933c6cbe5643ad; });

var $iSvIT = parcelRequire("iSvIT");
var $f74d92894bc1153a$var$HasTextAncestorContext = /*#__PURE__*/ (0, $iSvIT.createContext)(false);
var $f74d92894bc1153a$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $iSvIT.useContext)($f74d92894bc1153a$var$HasTextAncestorContext);
};
var $f74d92894bc1153a$export$ae933c6cbe5643ad = $f74d92894bc1153a$var$HasTextAncestorContext.Provider;

});


parcelRegister("1Xueb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16d2bfc1b6057d68$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hQZqJ = parcelRequire("hQZqJ");

var $iSvIT = parcelRequire("iSvIT");

var $7nG8r = parcelRequire("7nG8r");

var $2dy9E = parcelRequire("2dy9E");

var $iu7vu = parcelRequire("iu7vu");
/**
 * Returns the appropriate circle stroke color.
 */ function $16d2bfc1b6057d68$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $2dy9E.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $2dy9E.N0), ")");
}
var $16d2bfc1b6057d68$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $16d2bfc1b6057d68$var$loadIn = null;
var $16d2bfc1b6057d68$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $16d2bfc1b6057d68$var$useLayoutEffect = typeof window === "undefined" ? (0, $iSvIT.useEffect) : (0, $iSvIT.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $16d2bfc1b6057d68$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $iu7vu.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $16d2bfc1b6057d68$var$getStrokeColor(appearance);
    var context = (0, $iSvIT.useContext)((0, $7nG8r.default));
    $16d2bfc1b6057d68$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $hQZqJ.default)([
            $16d2bfc1b6057d68$var$styles.wrapperStyles,
            $16d2bfc1b6057d68$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $hQZqJ.default)([
            $16d2bfc1b6057d68$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $hQZqJ.default)([
            $16d2bfc1b6057d68$var$styles.circleStyles
        ])
    })));
}));
var $16d2bfc1b6057d68$export$2e2bcd8739ae039 = $16d2bfc1b6057d68$var$Spinner;

});
parcelRegister("2dy9E", function(module, exports) {

$parcel$export(module.exports, "N0", function () { return $19d74a10046ab5e7$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $19d74a10046ab5e7$export$c39c0fe0f26207ae; });
// Reds
var $19d74a10046ab5e7$export$4b84fd0e2c617bd = "#FFEBE6";
var $19d74a10046ab5e7$export$b34b069eff244586 = "#FFBDAD";
var $19d74a10046ab5e7$export$be802dd0d8b57f35 = "#FF8F73";
var $19d74a10046ab5e7$export$60847d42f9da92a6 = "#FF7452";
var $19d74a10046ab5e7$export$4a7404f376229999 = "#FF5630";
var $19d74a10046ab5e7$export$2010d0fb4295b346 = "#DE350B";
var $19d74a10046ab5e7$export$2837b5a1a71d5c02 = "#BF2600";
var $19d74a10046ab5e7$export$8d9596b529bbb9cf = "#FFFAE6";
var $19d74a10046ab5e7$export$41060a744ab0b7ae = "#FFF0B3";
var $19d74a10046ab5e7$export$1cc05bbbf340e559 = "#FFE380";
var $19d74a10046ab5e7$export$5aae31392d72caaa = "#FFC400";
var $19d74a10046ab5e7$export$c6930421db9fa514 = "#FFAB00";
var $19d74a10046ab5e7$export$59619663aa6500fb = "#FF991F";
var $19d74a10046ab5e7$export$874739ea9e379ab6 = "#FF8B00";
var $19d74a10046ab5e7$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $19d74a10046ab5e7$export$69a3bf21b9686c2b = "#ABF5D1";
var $19d74a10046ab5e7$export$afbce1382ec95f73 = "#79F2C0";
var $19d74a10046ab5e7$export$747d86715d4175de = "#57D9A3";
var $19d74a10046ab5e7$export$940e1f69e873f202 = "#36B37E";
var $19d74a10046ab5e7$export$a49394138f7b8e85 = "#00875A";
var $19d74a10046ab5e7$export$6fa04827ac68a4fb = "#006644";
var $19d74a10046ab5e7$export$226de0355ed012f8 = "#DEEBFF";
var $19d74a10046ab5e7$export$8c13c2ee36917869 = "#B3D4FF";
var $19d74a10046ab5e7$export$ecfc1dff386a3e7a = "#4C9AFF";
var $19d74a10046ab5e7$export$215b7063051591f1 = "#2684FF";
var $19d74a10046ab5e7$export$e62e8919cca44969 = "#0065FF";
var $19d74a10046ab5e7$export$b3de0ae08da2ce64 = "#0052CC";
var $19d74a10046ab5e7$export$a6ee3d71bc067634 = "#0747A6";
var $19d74a10046ab5e7$export$67f15409e87642a1 = "#669DF1";
var $19d74a10046ab5e7$export$f0539dbc42dbb067 = "#8FB8F6";
var $19d74a10046ab5e7$export$363e4475840015bb = "#EAE6FF";
var $19d74a10046ab5e7$export$4b0a4417ed59760f = "#C0B6F2";
var $19d74a10046ab5e7$export$6011520a64d9a187 = "#998DD9";
var $19d74a10046ab5e7$export$a7175d4e9206bc80 = "#8777D9";
var $19d74a10046ab5e7$export$b48405b95304b5a1 = "#6554C0";
var $19d74a10046ab5e7$export$c71e4279dd54a18d = "#5243AA";
var $19d74a10046ab5e7$export$147899de772240ec = "#403294";
var $19d74a10046ab5e7$export$2cf711fe14c66f06 = "#E6FCFF";
var $19d74a10046ab5e7$export$7a8f4d33f6f9772c = "#B3F5FF";
var $19d74a10046ab5e7$export$776c9c497ef08533 = "#79E2F2";
var $19d74a10046ab5e7$export$69cb3ca10c1e330e = "#00C7E6";
var $19d74a10046ab5e7$export$9dc1ef0f3f48059b = "#00B8D9";
var $19d74a10046ab5e7$export$7c835c78b6fcdef8 = "#00A3BF";
var $19d74a10046ab5e7$export$6036577f95c3877e = "#008DA6";
var $19d74a10046ab5e7$export$29a4f05edc054374 = "#FFFFFF";
var $19d74a10046ab5e7$export$e655ef011c4aa1a2 = "#FAFBFC";
var $19d74a10046ab5e7$export$9fdfb749e33cdf97 = "#F4F5F7";
var $19d74a10046ab5e7$export$3e51e8f1440314ba = "#EBECF0";
var $19d74a10046ab5e7$export$1ce2d1575d444ceb = "#DFE1E6";
var $19d74a10046ab5e7$export$8754fc7e6d8b3000 = "#C1C7D0";
var $19d74a10046ab5e7$export$c2e91cbeada39b8b = "#B3BAC5";
var $19d74a10046ab5e7$export$5f71e19f3a7ad9de = "#A5ADBA";
var $19d74a10046ab5e7$export$eaa8c8a70ac22806 = "#97A0AF";
var $19d74a10046ab5e7$export$7c87d337fb91a97d = "#8993A4";
var $19d74a10046ab5e7$export$d6447c357493214f = "#7A869A";
var $19d74a10046ab5e7$export$f563ee71e9ee74cd = "#6B778C";
var $19d74a10046ab5e7$export$e2ef2124cf4024b1 = "#5E6C84";
var $19d74a10046ab5e7$export$eece5f492e429f08 = "#505F79";
var $19d74a10046ab5e7$export$c39c0fe0f26207ae = "#42526E";
var $19d74a10046ab5e7$export$7090862dc3038a9f = "#344563";
var $19d74a10046ab5e7$export$ad0bacf983b7ddaa = "#253858";
var $19d74a10046ab5e7$export$7d61b15e0da132af = "#172B4D";
var $19d74a10046ab5e7$export$fbda843f0a27fe96 = "#091E42";
var $19d74a10046ab5e7$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $19d74a10046ab5e7$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $19d74a10046ab5e7$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $19d74a10046ab5e7$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $19d74a10046ab5e7$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $19d74a10046ab5e7$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $19d74a10046ab5e7$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $19d74a10046ab5e7$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $19d74a10046ab5e7$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $19d74a10046ab5e7$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $19d74a10046ab5e7$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $19d74a10046ab5e7$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $19d74a10046ab5e7$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $19d74a10046ab5e7$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $19d74a10046ab5e7$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $19d74a10046ab5e7$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $19d74a10046ab5e7$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $19d74a10046ab5e7$export$2f6319cf7d736c2a = "#E6EDFA";
var $19d74a10046ab5e7$export$95126bc8884d6634 = "#DCE5F5";
var $19d74a10046ab5e7$export$8338d8c35d44ff1 = "#CED9EB";
var $19d74a10046ab5e7$export$5368d76ae4fbbda7 = "#B8C7E0";
var $19d74a10046ab5e7$export$9f0a771d16ec8d36 = "#ABBBD6";
var $19d74a10046ab5e7$export$abcf8c38338b4aa5 = "#9FB0CC";
var $19d74a10046ab5e7$export$97e81faa16a182c7 = "#8C9CB8";
var $19d74a10046ab5e7$export$bfe21c59123ecf33 = "#7988A3";
var $19d74a10046ab5e7$export$ee82aa2ea6a1558 = "#67758F";
var $19d74a10046ab5e7$export$682927c6ed76be02 = "#56637A";
var $19d74a10046ab5e7$export$91fd9994c5be9757 = "#455166";
var $19d74a10046ab5e7$export$d281fbfe3cff2df6 = "#3B475C";
var $19d74a10046ab5e7$export$3902c91d8b98a753 = "#313D52";
var $19d74a10046ab5e7$export$8e8133c1ba5845b5 = "#283447";
var $19d74a10046ab5e7$export$33ff357f6620b39 = "#202B3D";
var $19d74a10046ab5e7$export$633847cf062b69e0 = "#1B2638";
var $19d74a10046ab5e7$export$9776a6e503bdbf76 = "#121A29";
var $19d74a10046ab5e7$export$6c813d5160dff5db = "#0E1624";
var $19d74a10046ab5e7$export$3d4f271a500072a = "#0D1424";
var $19d74a10046ab5e7$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $19d74a10046ab5e7$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $19d74a10046ab5e7$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $19d74a10046ab5e7$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $19d74a10046ab5e7$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $19d74a10046ab5e7$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $19d74a10046ab5e7$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $19d74a10046ab5e7$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $19d74a10046ab5e7$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $19d74a10046ab5e7$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $19d74a10046ab5e7$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $19d74a10046ab5e7$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $19d74a10046ab5e7$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $19d74a10046ab5e7$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $19d74a10046ab5e7$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $19d74a10046ab5e7$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $19d74a10046ab5e7$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $19d74a10046ab5e7$export$d2adc5dedf09fced = "#292A2E";
var $19d74a10046ab5e7$export$f51762073d2bb381 = "#94C748";
var $19d74a10046ab5e7$export$95e26d54def96891 = "#B3DF72";

});

parcelRegister("iu7vu", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $d750da0ff4343fa3$export$4e9f1640bbe7a1a8; });
var $d750da0ff4343fa3$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("jZVbn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8f0121a78d9c38a$export$2e2bcd8739ae039; });
/* actions-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $hQZqJ = parcelRequire("hQZqJ");
var $e8f0121a78d9c38a$var$actionsStyles = null;
/**
 * __Actions container__
 *
 * A container for actions: primary action, secondary action, and tertiary action.
 *
 * @internal
 */ var $e8f0121a78d9c38a$var$ActionsContainer = function ActionsContainer(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        className: (0, $hQZqJ.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _6rthu2gc _bozg1jfw"
        ])
    }, children);
};
var $e8f0121a78d9c38a$export$2e2bcd8739ae039 = $e8f0121a78d9c38a$var$ActionsContainer;

});

parcelRegister("5rf5I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f5b2e24d3ac4a4d$export$2e2bcd8739ae039; });
/* container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $hQZqJ = parcelRequire("hQZqJ");
var $3f5b2e24d3ac4a4d$var$containerStyles = null;
/* Use max-width so the component can shrink on smaller viewports. */ var $3f5b2e24d3ac4a4d$var$wideContainerStyles = null;
var $3f5b2e24d3ac4a4d$var$narrowContainerStyles = null;
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */ var $3f5b2e24d3ac4a4d$var$Container = function Container(_ref) {
    var children = _ref.children, width = _ref.width, testId = _ref.testId;
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        "data-testid": testId,
        className: (0, $hQZqJ.default)([
            "_6rthoahv _1pfhoahv _12l21wug _ahbq1wug _y3gn1h6o",
            width === "narrow" ? "_p12fko4j" : "_p12f1pl1"
        ])
    }, children);
};
var $3f5b2e24d3ac4a4d$export$2e2bcd8739ae039 = $3f5b2e24d3ac4a4d$var$Container;

});

parcelRegister("a6XiB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75c8767e50d5191d$export$2e2bcd8739ae039; });
/* image.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $kWKbB = parcelRequire("kWKbB");

var $iSvIT = parcelRequire("iSvIT");

var $hQZqJ = parcelRequire("hQZqJ");
var $8rAib = parcelRequire("8rAib");
function $75c8767e50d5191d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $75c8767e50d5191d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $75c8767e50d5191d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $kWKbB.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $75c8767e50d5191d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $75c8767e50d5191d$var$CSS_VAR_MAX_WIDTH = "--max-width";
var $75c8767e50d5191d$var$CSS_VAR_MAX_HEIGHT = "--max-height";
var $75c8767e50d5191d$var$imageStyles = null;
/**
 * __Image__
 *
 * Image in Empty State.
 *
 * @internal
 */ var $75c8767e50d5191d$var$Image = function Image(_ref) {
    var maxHeight = _ref.maxHeight, maxWidth = _ref.maxWidth, _ref$height = _ref.height, height = _ref$height === void 0 ? "auto" : _ref$height, _ref$width = _ref.width, width = _ref$width === void 0 ? "auto" : _ref$width, src = _ref.src;
    return /*#__PURE__*/ $iSvIT.createElement("img", {
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        src: src,
        className: (0, $hQZqJ.default)([
            "_1e0c1ule _p12f163m _c71l649k _6rth1ejb _1pfhidpf _12l21wug _ahbq1wug"
        ]),
        style: $75c8767e50d5191d$var$_objectSpread($75c8767e50d5191d$var$_objectSpread({}, (0, $kWKbB.default)((0, $kWKbB.default)({}, $75c8767e50d5191d$var$CSS_VAR_MAX_WIDTH, "".concat(maxWidth, "px")), $75c8767e50d5191d$var$CSS_VAR_MAX_HEIGHT, "".concat(maxHeight, "px"))), {}, {
            "--_11x3y0": (0, $8rAib.default)("var(".concat($75c8767e50d5191d$var$CSS_VAR_MAX_WIDTH, ")")),
            "--_zsxb2b": (0, $8rAib.default)("var(".concat($75c8767e50d5191d$var$CSS_VAR_MAX_HEIGHT, ")"))
        })
    });
};
var $75c8767e50d5191d$export$2e2bcd8739ae039 = $75c8767e50d5191d$var$Image;

});
parcelRegister("8rAib", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $625cff3d92d17f0f$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $625cff3d92d17f0f$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});


parcelRegister("bnteb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $848883b72597808f$export$2e2bcd8739ae039; });
/* spinner-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $hQZqJ = parcelRequire("hQZqJ");
var $848883b72597808f$var$spinnerContainerStyles = null;
/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */ var $848883b72597808f$var$SpinnerContainer = function SpinnerContainer(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        className: (0, $hQZqJ.default)([
            "_1bsb1ejb _ahbqpxbi"
        ])
    }, children);
};
var $848883b72597808f$export$2e2bcd8739ae039 = $848883b72597808f$var$SpinnerContainer;

});


parcelRegister("1Z36a", function(module, exports) {

$parcel$export(module.exports, "useNotifyOpenLayerObserver", function () { return $171de43c7e5f11af$export$469bb693f11edc7f; });

var $iSvIT = parcelRequire("iSvIT");

var $ktFjJ = parcelRequire("ktFjJ");

var $fikNO = parcelRequire("fikNO");
function $171de43c7e5f11af$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    var context = (0, $iSvIT.useContext)((0, $ktFjJ.OpenLayerObserverContext));
    var namespace = (0, $fikNO.useOpenLayerObserverNamespace)();
    (0, $iSvIT.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose
    ]);
}

});
parcelRegister("ktFjJ", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverContext", function () { return $ee8690d29749d3d7$export$5fbf4d7fae6cdc00; });

var $iSvIT = parcelRequire("iSvIT");
var $ee8690d29749d3d7$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);

});

parcelRegister("fikNO", function(module, exports) {

$parcel$export(module.exports, "useOpenLayerObserverNamespace", function () { return $b228ac67f5288a1e$export$1d57e79091cc3046; });

var $iSvIT = parcelRequire("iSvIT");

var $j31Pm = parcelRequire("j31Pm");
function $b228ac67f5288a1e$export$1d57e79091cc3046() {
    var namespace = (0, $iSvIT.useContext)((0, $j31Pm.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("j31Pm", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", function () { return $dddfb708f55f9512$export$644a49f3b8c50fcd; });

var $iSvIT = parcelRequire("iSvIT");
var $dddfb708f55f9512$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $iSvIT.createContext)(null);

});



parcelRegister("gr749", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $bf74a61ab72e02e0$export$badac9ada3a0bdf9; });

var $QeCUX = parcelRequire("QeCUX");

var $jdwMh = parcelRequire("jdwMh");

var $iSvIT = parcelRequire("iSvIT");

var $jOB0X = parcelRequire("jOB0X");

var $3UjHj = parcelRequire("3UjHj");

// Export types from PopperJS / React Popper
var $bf74a61ab72e02e0$var$viewportPadding = 5;
var $bf74a61ab72e02e0$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: $bf74a61ab72e02e0$var$viewportPadding,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    }
];
function $bf74a61ab72e02e0$var$defaultChildrenFn() {
    return null;
}
var $bf74a61ab72e02e0$var$defaultOffset = [
    0,
    8
];
function $bf74a61ab72e02e0$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $bf74a61ab72e02e0$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $bf74a61ab72e02e0$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, $jdwMh.default)(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $iSvIT.useMemo)(function() {
        var preventOverflowModifier = {
            name: "preventOverflow",
            options: {
                padding: $bf74a61ab72e02e0$var$viewportPadding,
                rootBoundary: shouldFitViewport ? "viewport" : "document"
            }
        };
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $3UjHj.getMaxSizeModifiers)({
            viewportPadding: $bf74a61ab72e02e0$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($bf74a61ab72e02e0$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, $QeCUX.default)(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $iSvIT.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, $QeCUX.default)(internalModifiers), (0, $QeCUX.default)(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $jOB0X.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("QeCUX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09d0340098e160c0$export$2e2bcd8739ae039; });

var $5fGfd = parcelRequire("5fGfd");

var $3xpxP = parcelRequire("3xpxP");

var $kItQG = parcelRequire("kItQG");

var $6p0lI = parcelRequire("6p0lI");
function $09d0340098e160c0$export$2e2bcd8739ae039(r) {
    return (0, $5fGfd.default)(r) || (0, $3xpxP.default)(r) || (0, $kItQG.default)(r) || (0, $6p0lI.default)();
}

});
parcelRegister("5fGfd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d2f1f55f9daf3b7$export$2e2bcd8739ae039; });

var $7uFAN = parcelRequire("7uFAN");
function $3d2f1f55f9daf3b7$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $7uFAN.default)(r);
}

});
parcelRegister("7uFAN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $574b991fe2c3cdfc$export$2e2bcd8739ae039; });
function $574b991fe2c3cdfc$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("3xpxP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $293844d1c35ec236$export$2e2bcd8739ae039; });
function $293844d1c35ec236$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("kItQG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f14f120e0a479d64$export$2e2bcd8739ae039; });

var $7uFAN = parcelRequire("7uFAN");
function $f14f120e0a479d64$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $7uFAN.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $7uFAN.default)(r, a) : void 0;
    }
}

});

parcelRegister("6p0lI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a95593b9263df50$export$2e2bcd8739ae039; });
function $4a95593b9263df50$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jdwMh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfd8a83139d7705d$export$2e2bcd8739ae039; });

var $3U36y = parcelRequire("3U36y");

var $14IIL = parcelRequire("14IIL");

var $kItQG = parcelRequire("kItQG");

var $1BM4A = parcelRequire("1BM4A");
function $dfd8a83139d7705d$export$2e2bcd8739ae039(r, e) {
    return (0, $3U36y.default)(r) || (0, $14IIL.default)(r, e) || (0, $kItQG.default)(r, e) || (0, $1BM4A.default)();
}

});
parcelRegister("3U36y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d79029353831cab$export$2e2bcd8739ae039; });
function $2d79029353831cab$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("14IIL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c88dad6469c6616$export$2e2bcd8739ae039; });
function $0c88dad6469c6616$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("1BM4A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12be89753d49f872$export$2e2bcd8739ae039; });
function $12be89753d49f872$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("3UjHj", function(module, exports) {

$parcel$export(module.exports, "getMaxSizeModifiers", function () { return $2d85e197cf9e02bb$export$6d8c2b45c99d6e3f; });

var $jdwMh = parcelRequire("jdwMh");
function $2d85e197cf9e02bb$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: "maxSizeData",
            enabled: true,
            phase: "read",
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: "maxSize",
            enabled: true,
            phase: "beforeWrite",
            requiresIfExists: [
                "offset",
                "preventOverflow",
                "flip"
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== "number" || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== "number") // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split("-"), _state$placement$spli2 = (0, $jdwMh.default)(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === "top") maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "bottom") maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === "left") maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "right") maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});


parcelRegister("6F6FS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d9bbfcf2553f941$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $388ly = parcelRequire("388ly");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $4d9bbfcf2553f941$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $iSvIT.useContext)((0, $388ly.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $4d9bbfcf2553f941$export$2e2bcd8739ae039 = $4d9bbfcf2553f941$var$useRouterLink;

});
parcelRegister("388ly", function(module, exports) {

$parcel$export(module.exports, "RouterLinkProviderContext", function () { return $247897e82bd786c0$export$2931e0ee690eee88; });
$parcel$export(module.exports, "default", function () { return $247897e82bd786c0$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
var $247897e82bd786c0$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $iSvIT.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $247897e82bd786c0$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($247897e82bd786c0$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $247897e82bd786c0$export$2e2bcd8739ae039 = $247897e82bd786c0$var$RouterLinkProvider;

});


parcelRegister("iy4Sr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dfe75e26330f86b48e811f0d520fc5e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d80f2f7963c128c9$var$_react = $d80f2f7963c128c9$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $d80f2f7963c128c9$var$_baseNew = $d80f2f7963c128c9$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $d80f2f7963c128c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d80f2f7963c128c9$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $d80f2f7963c128c9$var$_react.default.createElement($d80f2f7963c128c9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12.5h1V16H1v-1.5h1zm1.5 12.5h2v-3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.75h2V2a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5zm5.5 0v-3H7v3zm-2-10H5V3h2zm4 0H9V3h2zM5 6h2v1.5H5zm4 0h2v1.5H9z" clip-rule="evenodd"/>`
    }, props));
$d80f2f7963c128c9$var$OfficeBuildingIcon.displayName = "OfficeBuildingIcon";
var $d80f2f7963c128c9$var$_default = module.exports.default = $d80f2f7963c128c9$var$OfficeBuildingIcon;

});

parcelRegister("hGQlB", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", function () { return $ce0ef700797d1e43$export$8fbe3c7d0ed2c683; });
$parcel$export(module.exports, "ErrorMessage", function () { return $ce0ef700797d1e43$export$915e9e7bd4f0f96d; });
/** @jsx jsx */ 
var $2ZUkg = parcelRequire("2ZUkg");

var $beKx6 = parcelRequire("beKx6");

var $ajAjT = parcelRequire("ajAjT");

var $i9mWg = parcelRequire("i9mWg");

var $eJftL = parcelRequire("eJftL");

var $gB0Pk = parcelRequire("gB0Pk");

var $1D2Zu = parcelRequire("1D2Zu");

var $8In0n = parcelRequire("8In0n");
/**
 * API for the internal `<Message />` component. This is not public API.
 */ /**
 * Public API of the various message components.
 */ var $ce0ef700797d1e43$var$fontFamily = (0, $gB0Pk.fontFamily)();
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $ce0ef700797d1e43$var$lightH200Styles = (0, $2ZUkg.css)((0, $1D2Zu.h200)({
    theme: {
        mode: "light"
    }
}));
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $ce0ef700797d1e43$var$darkH200Styles = (0, $2ZUkg.css)((0, $1D2Zu.h200)({
    theme: {
        mode: "dark"
    }
}));
var $ce0ef700797d1e43$var$messageStyles = (0, $2ZUkg.css)({
    display: "flex",
    marginTop: "var(--ds-space-050, 4px)",
    justifyContent: "baseline",
    fontFamily: "".concat($ce0ef700797d1e43$var$fontFamily),
    fontWeight: "normal"
});
var $ce0ef700797d1e43$var$messageAppearanceStyles = {
    default: (0, $2ZUkg.css)({
        color: "var(--ds-text-subtlest, ".concat((0, $i9mWg.N200), ")")
    }),
    error: (0, $2ZUkg.css)({
        color: "var(--ds-text-danger, #AE2A19)"
    }),
    valid: (0, $2ZUkg.css)({
        color: "var(--ds-text-success, #216E4E)"
    })
};
var $ce0ef700797d1e43$var$iconWrapperStyles = (0, $2ZUkg.css)({
    display: "flex"
});
var $ce0ef700797d1e43$var$IconWrapper = function IconWrapper(_ref) {
    var children = _ref.children;
    return (0, $2ZUkg.jsx)("span", {
        css: $ce0ef700797d1e43$var$iconWrapperStyles
    }, children);
};
var $ce0ef700797d1e43$var$messageIcons = {
    error: (0, $2ZUkg.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ajAjT))), {
        size: "small",
        label: "error"
    }),
    valid: (0, $2ZUkg.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($beKx6))), {
        size: "small",
        label: "success"
    })
};
var $ce0ef700797d1e43$var$Message = function Message(_ref2) {
    var children = _ref2.children, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, fieldId = _ref2.fieldId, testId = _ref2.testId;
    var _useGlobalTheme = (0, $eJftL.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var icon = $ce0ef700797d1e43$var$messageIcons[appearance];
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ var content = typeof children === "string" ? children : (0, $2ZUkg.jsx)("span", null, children);
    return (0, $2ZUkg.jsx)("div", {
        css: [
            mode === "light" ? $ce0ef700797d1e43$var$lightH200Styles : $ce0ef700797d1e43$var$darkH200Styles,
            $ce0ef700797d1e43$var$messageStyles,
            $ce0ef700797d1e43$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        "aria-live": "polite"
    }, icon && (0, $2ZUkg.jsx)($ce0ef700797d1e43$var$IconWrapper, null, icon), content);
};
var $ce0ef700797d1e43$export$8fbe3c7d0ed2c683 = function HelperMessage(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return (0, $2ZUkg.jsx)((0, $8In0n.FieldId).Consumer, null, function(fieldId) {
        return (0, $2ZUkg.jsx)($ce0ef700797d1e43$var$Message, {
            fieldId: fieldId ? "".concat(fieldId, "-helper") : undefined,
            testId: testId
        }, children);
    });
};
var $ce0ef700797d1e43$export$915e9e7bd4f0f96d = function ErrorMessage(_ref4) {
    var children = _ref4.children, testId = _ref4.testId;
    return (0, $2ZUkg.jsx)((0, $8In0n.FieldId).Consumer, null, function(fieldId) {
        return (0, $2ZUkg.jsx)($ce0ef700797d1e43$var$Message, {
            appearance: "error",
            fieldId: fieldId ? "".concat(fieldId, "-error") : undefined,
            testId: testId
        }, children);
    });
};
var $ce0ef700797d1e43$export$5505afb209a532c8 = function ValidMessage(_ref5) {
    var children = _ref5.children, testId = _ref5.testId;
    return (0, $2ZUkg.jsx)((0, $8In0n.FieldId).Consumer, null, function(fieldId) {
        return (0, $2ZUkg.jsx)($ce0ef700797d1e43$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? "".concat(fieldId, "-valid") : undefined,
            testId: testId
        }, children);
    });
};

});
parcelRegister("beKx6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $82e518fdeb6fbfd5$var$_react = $82e518fdeb6fbfd5$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $7mqaz = parcelRequire("7mqaz");
function $82e518fdeb6fbfd5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $82e518fdeb6fbfd5$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $82e518fdeb6fbfd5$var$_react.default.createElement($7mqaz.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 20a8 8 0 110-16 8 8 0 010 16zm1.364-10.964l-2.152 4.11-1.543-1.39a1 1 0 10-1.338 1.487l2.5 2.25a1 1 0 001.555-.279l2.75-5.25a1 1 0 00-1.772-.928z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$82e518fdeb6fbfd5$var$EditorSuccessIcon.displayName = "EditorSuccessIcon";
var $82e518fdeb6fbfd5$var$_default = $82e518fdeb6fbfd5$var$EditorSuccessIcon;
module.exports.default = $82e518fdeb6fbfd5$var$_default;

});
parcelRegister("7mqaz", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $55bee3329526d280$export$f04a61298a47a40f; });

var $gBJBQ = parcelRequire("gBJBQ");

var $5YztE = parcelRequire("5YztE");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $eJftL = parcelRequire("eJftL");

var $hFg9K = parcelRequire("hFg9K");

var $C5UR5 = parcelRequire("C5UR5");
function $55bee3329526d280$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $55bee3329526d280$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $55bee3329526d280$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $5YztE.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $55bee3329526d280$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $55bee3329526d280$var$iconStyles = (0, $2ZUkg.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> svg": $55bee3329526d280$var$_objectSpread($55bee3329526d280$var$_objectSpread({}, (0, $C5UR5.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $55bee3329526d280$var$baseHcmStyles = (0, $2ZUkg.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $55bee3329526d280$var$primaryEqualsSecondaryHcmStyles = (0, $2ZUkg.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $55bee3329526d280$var$secondaryTransparentHcmStyles = (0, $2ZUkg.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $55bee3329526d280$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $2ZUkg.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $C5UR5.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    var _useGlobalTheme = (0, $eJftL.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $2ZUkg.jsx)("span", (0, $gBJBQ.default)({
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            "--icon-secondary-color": secondaryColor || (0, $hFg9K.getBackground)(mode)
        }
    }, glyphProps, {
        css: [
            $55bee3329526d280$var$iconStyles,
            $55bee3329526d280$var$baseHcmStyles,
            primaryColor === secondaryColor && $55bee3329526d280$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $55bee3329526d280$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $2ZUkg.css)({
                width: dimensions.width,
                height: dimensions.height,
                "> svg": dimensions
            })
        ]
    }));
});
var $55bee3329526d280$export$2e2bcd8739ae039 = $55bee3329526d280$export$f04a61298a47a40f;

});
parcelRegister("gBJBQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1737b1fc36c59f9$export$2e2bcd8739ae039; });
function $c1737b1fc36c59f9$export$2e2bcd8739ae039() {
    return $c1737b1fc36c59f9$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c1737b1fc36c59f9$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("hFg9K", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $cdc2cc4711baaf6c$export$18cb9425622d4e06; });
var $cdc2cc4711baaf6c$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $cdc2cc4711baaf6c$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "light";
    return $cdc2cc4711baaf6c$var$themedBackground[mode];
};

});

parcelRegister("C5UR5", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $07282385e629ffb3$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $07282385e629ffb3$export$3eb7d6130acfda37; });

var $5GTS0 = parcelRequire("5GTS0");

var $2ZUkg = parcelRequire("2ZUkg");
var $07282385e629ffb3$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
var $07282385e629ffb3$var$smallStyles = (0, $2ZUkg.css)((0, $5GTS0.dimensions).small);
var $07282385e629ffb3$var$mediumStyles = (0, $2ZUkg.css)((0, $5GTS0.dimensions).medium);
var $07282385e629ffb3$var$largeStyles = (0, $2ZUkg.css)((0, $5GTS0.dimensions).large);
var $07282385e629ffb3$var$xlargeStyles = (0, $2ZUkg.css)((0, $5GTS0.dimensions).xlarge);
var $07282385e629ffb3$export$ef0ad74202575b64 = {
    small: $07282385e629ffb3$var$smallStyles,
    medium: $07282385e629ffb3$var$mediumStyles,
    large: $07282385e629ffb3$var$largeStyles,
    xlarge: $07282385e629ffb3$var$xlargeStyles
};
var $07282385e629ffb3$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $5GTS0.dimensions)[size];
    return undefined;
};

});
parcelRegister("5GTS0", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $424c36a103c23fbe$export$62ad7b0c781000e9; });
var $424c36a103c23fbe$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $424c36a103c23fbe$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $424c36a103c23fbe$export$62ad7b0c781000e9 = {
    small: {
        width: $424c36a103c23fbe$export$c647cb0ee6e282fe.small,
        height: $424c36a103c23fbe$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $424c36a103c23fbe$export$c647cb0ee6e282fe.medium,
        height: $424c36a103c23fbe$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $424c36a103c23fbe$export$c647cb0ee6e282fe.large,
        height: $424c36a103c23fbe$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $424c36a103c23fbe$export$c647cb0ee6e282fe.xlarge,
        height: $424c36a103c23fbe$export$c647cb0ee6e282fe.xlarge
    }
};

});




parcelRegister("ajAjT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7827da129d8b6100$var$_react = $7827da129d8b6100$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $7mqaz = parcelRequire("7mqaz");
function $7827da129d8b6100$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7827da129d8b6100$var$ErrorIcon = (props)=>/*#__PURE__*/ $7827da129d8b6100$var$_react.default.createElement($7mqaz.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M13.416 4.417a2.002 2.002 0 00-2.832 0l-6.168 6.167a2.002 2.002 0 000 2.833l6.168 6.167a2.002 2.002 0 002.832 0l6.168-6.167a2.002 2.002 0 000-2.833l-6.168-6.167z" fill="currentColor"/><path d="M12 14a1 1 0 01-1-1V8a1 1 0 012 0v5a1 1 0 01-1 1m0 3a1 1 0 010-2 1 1 0 010 2" fill="inherit"/></g></svg>`
    }, props));
$7827da129d8b6100$var$ErrorIcon.displayName = "ErrorIcon";
var $7827da129d8b6100$var$_default = $7827da129d8b6100$var$ErrorIcon;
module.exports.default = $7827da129d8b6100$var$_default;

});


parcelRegister("7mrZY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55c04e6a475fc645$export$2e2bcd8739ae039; });

var $e2ozx = parcelRequire("e2ozx");

var $rd5mD = parcelRequire("rd5mD");

var $b4iuA = parcelRequire("b4iuA");

var $2GGR1 = parcelRequire("2GGR1");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $a1y4y = parcelRequire("a1y4y");

var $kawNJ = parcelRequire("kawNJ");

var $afSD4 = parcelRequire("afSD4");

var $dAkuQ = parcelRequire("dAkuQ");
var $55c04e6a475fc645$var$_excluded = [
    "resize",
    "appearance",
    "isCompact",
    "isRequired",
    "isReadOnly",
    "isDisabled",
    "isInvalid",
    "isMonospaced",
    "minimumRows",
    "theme",
    "testId",
    "maxHeight",
    "onBlur",
    "onFocus",
    "onChange",
    "tokens",
    "value"
];
function $55c04e6a475fc645$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $55c04e6a475fc645$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $55c04e6a475fc645$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $b4iuA.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $55c04e6a475fc645$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $55c04e6a475fc645$var$packageName = "@atlaskit/textarea";
var $55c04e6a475fc645$var$packageVersion = "4.7.7";
var $55c04e6a475fc645$var$analyticsParams = {
    componentName: "textArea",
    packageName: $55c04e6a475fc645$var$packageName,
    packageVersion: $55c04e6a475fc645$var$packageVersion
};
var $55c04e6a475fc645$var$setSmartHeight = function setSmartHeight(el) {
    // Always reset height to auto before calculating new height
    el.style.height = "auto";
    var borderHeight = (0, $afSD4.borderWidth);
    var paddingBoxHeight = el.scrollHeight;
    var borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = "".concat(borderBoxHeight, "px");
};
var $55c04e6a475fc645$var$TextAreaWithTokens = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var ourRef = (0, $iSvIT.useRef)(null);
    var _props$resize = props.resize, resize = _props$resize === void 0 ? "smart" : _props$resize, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "standard" : _props$appearance, _props$isCompact = props.isCompact, isCompact = _props$isCompact === void 0 ? false : _props$isCompact, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, _props$isReadOnly = props.isReadOnly, isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isMonospaced = props.isMonospaced, isMonospaced = _props$isMonospaced === void 0 ? false : _props$isMonospaced, _props$minimumRows = props.minimumRows, minimumRows = _props$minimumRows === void 0 ? 2 : _props$minimumRows, theme = props.theme, testId = props.testId, _props$maxHeight = props.maxHeight, maxHeight = _props$maxHeight === void 0 ? "50vh" : _props$maxHeight, onBlur = props.onBlur, onFocus = props.onFocus, onChange = props.onChange, tokens = props.tokens, value = props.value, rest = (0, $2GGR1.default)(props, $55c04e6a475fc645$var$_excluded);
    (0, $iSvIT.useEffect)(function() {
        var el = ourRef.current;
        if (resize === "smart" && el) $55c04e6a475fc645$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    var onBlurWithAnalytics = (0, $a1y4y.usePlatformLeafEventHandler)($55c04e6a475fc645$var$_objectSpread({
        fn: function fn(event) {
            onBlur && onBlur(event);
        },
        action: "blurred"
    }, $55c04e6a475fc645$var$analyticsParams));
    var onFocusWithAnalytics = (0, $a1y4y.usePlatformLeafEventHandler)($55c04e6a475fc645$var$_objectSpread({
        fn: function fn(event) {
            onFocus && onFocus(event);
        },
        action: "focused"
    }, $55c04e6a475fc645$var$analyticsParams));
    var getTextAreaRef = function getTextAreaRef(elementRef) {
        ourRef.current = elementRef;
        if (ref && (0, $rd5mD.default)(ref) === "object") // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === "function") ref(elementRef);
    };
    var handleOnChange = (0, $iSvIT.useCallback)(function(e) {
        var el = ourRef.current;
        if (resize === "smart" && el) $55c04e6a475fc645$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    var controlProps = {
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-compact": isCompact ? isCompact : undefined,
        "data-testid": testId ? testId : undefined
    };
    var baseStyles = (0, $iSvIT.useMemo)(function() {
        return (0, $afSD4.getBaseStyles)({
            minimumRows: minimumRows,
            resize: resize,
            appearance: appearance,
            isMonospaced: isMonospaced,
            maxHeight: maxHeight
        });
    }, [
        minimumRows,
        resize,
        appearance,
        isMonospaced,
        maxHeight
    ]);
    var textAreaStyles = (0, $2ZUkg.css)([
        baseStyles,
        // not memoizing themeStyles as `tokens` is an unstable reference
        (0, $afSD4.themeStyles)(tokens, appearance)
    ]);
    return (0, $2ZUkg.jsx)("textarea", (0, $e2ozx.default)({}, controlProps, {
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        css: textAreaStyles
    }, rest));
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ var $55c04e6a475fc645$var$TextArea = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function TextArea(props, ref) {
    var _useGlobalTheme = (0, $kawNJ.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $2ZUkg.jsx)((0, $dAkuQ.Theme).Provider, {
        value: props.theme
    }, (0, $2ZUkg.jsx)((0, $dAkuQ.Theme).Consumer, {
        appearance: props.appearance || "standard",
        mode: mode
    }, function(tokens) {
        return (0, $2ZUkg.jsx)($55c04e6a475fc645$var$TextAreaWithTokens, (0, $e2ozx.default)({
            ref: ref
        }, props, {
            tokens: tokens
        }));
    }));
}));
$55c04e6a475fc645$var$TextArea.displayName = "TextArea";
var $55c04e6a475fc645$export$2e2bcd8739ae039 = $55c04e6a475fc645$var$TextArea;

});
parcelRegister("e2ozx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a384501dc969067a$export$2e2bcd8739ae039; });
function $a384501dc969067a$export$2e2bcd8739ae039() {
    return $a384501dc969067a$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a384501dc969067a$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("rd5mD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $051cac3e05bc20ab$export$2e2bcd8739ae039; });
function $051cac3e05bc20ab$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $051cac3e05bc20ab$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $051cac3e05bc20ab$export$2e2bcd8739ae039(o);
}

});

parcelRegister("b4iuA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80ee69a0a858bbbd$export$2e2bcd8739ae039; });

var $bKKzY = parcelRequire("bKKzY");
function $80ee69a0a858bbbd$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $bKKzY.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("bKKzY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88e81f3cc8b1ce16$export$2e2bcd8739ae039; });

var $rd5mD = parcelRequire("rd5mD");

var $12Kys = parcelRequire("12Kys");
function $88e81f3cc8b1ce16$export$2e2bcd8739ae039(t) {
    var i = (0, $12Kys.default)(t, "string");
    return "symbol" == (0, $rd5mD.default)(i) ? i : i + "";
}

});
parcelRegister("12Kys", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c2a1723dcf831c7$export$2e2bcd8739ae039; });

var $rd5mD = parcelRequire("rd5mD");
function $0c2a1723dcf831c7$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $rd5mD.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $rd5mD.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("2GGR1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f50befcc4f7a6c3$export$2e2bcd8739ae039; });

var $kNax9 = parcelRequire("kNax9");
function $1f50befcc4f7a6c3$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $kNax9.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("kNax9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2308e0b23457d4a$export$2e2bcd8739ae039; });
function $f2308e0b23457d4a$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("kawNJ", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", function () { return $eaee2f7424f848d4$export$7692396083754928; });

var $lh8cT = parcelRequire("lh8cT");
// Create default global light theme
var $eaee2f7424f848d4$var$_createTheme = (0, $lh8cT.createTheme)(function() {
    return {
        mode: "light"
    };
}), $eaee2f7424f848d4$var$Provider = $eaee2f7424f848d4$var$_createTheme.Provider, $eaee2f7424f848d4$var$Consumer = $eaee2f7424f848d4$var$_createTheme.Consumer, $eaee2f7424f848d4$export$7692396083754928 = $eaee2f7424f848d4$var$_createTheme.useTheme;
var $eaee2f7424f848d4$export$2e2bcd8739ae039 = {
    Provider: $eaee2f7424f848d4$var$Provider,
    Consumer: $eaee2f7424f848d4$var$Consumer
};

});
parcelRegister("lh8cT", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $f7d18d3b14f4e6a9$export$25d302a5b900a763; });

var $2GGR1 = parcelRequire("2GGR1");

var $iSvIT = parcelRequire("iSvIT");
var $f7d18d3b14f4e6a9$var$_excluded = [
    "children"
];
function $f7d18d3b14f4e6a9$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $iSvIT.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $iSvIT.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $2GGR1.default)(props, $f7d18d3b14f4e6a9$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $iSvIT.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $iSvIT.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("afSD4", function(module, exports) {

$parcel$export(module.exports, "borderWidth", function () { return $7775ae4ab14e299f$export$12879c7697ed953d; });
$parcel$export(module.exports, "getBaseStyles", function () { return $7775ae4ab14e299f$export$bff8031d86bb089; });
$parcel$export(module.exports, "themeStyles", function () { return $7775ae4ab14e299f$export$ded1c27b355b104; });

var $b4iuA = parcelRequire("b4iuA");

var $2ZUkg = parcelRequire("2ZUkg");

var $90ozF = parcelRequire("90ozF");

var $6wEUZ = parcelRequire("6wEUZ");
function $7775ae4ab14e299f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7775ae4ab14e299f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7775ae4ab14e299f$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $b4iuA.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7775ae4ab14e299f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $7775ae4ab14e299f$var$grid = (0, $6wEUZ.gridSize)();
var $7775ae4ab14e299f$var$lineHeightBase = $7775ae4ab14e299f$var$grid * 2.5;
var $7775ae4ab14e299f$var$lineHeightCompact = $7775ae4ab14e299f$var$grid * 2;
var $7775ae4ab14e299f$var$compactVerticalPadding = 2;
var $7775ae4ab14e299f$var$verticalPadding = 6;
var $7775ae4ab14e299f$var$horizontalPadding = $7775ae4ab14e299f$var$grid;
var $7775ae4ab14e299f$var$transitionDuration = "0.2s";
var $7775ae4ab14e299f$var$fontSize = (0, $6wEUZ.fontSize)();
var $7775ae4ab14e299f$var$fontFamily = (0, $6wEUZ.fontFamily)();
var $7775ae4ab14e299f$var$codeFontFamily = (0, $6wEUZ.codeFontFamily)();
var $7775ae4ab14e299f$export$12879c7697ed953d = 2;
// Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
var $7775ae4ab14e299f$var$overrideSafariDisabledStyles = {
    WebkitTextFillColor: "unset",
    WebkitOpacity: "1"
};
var $7775ae4ab14e299f$var$borderBoxMinHeight = function borderBoxMinHeight(minimumRows, borderHeight) {
    var contentHeight = $7775ae4ab14e299f$var$lineHeightBase * minimumRows;
    return contentHeight + $7775ae4ab14e299f$var$verticalPadding * 2 + borderHeight * 2;
};
var $7775ae4ab14e299f$var$borderBoxMinHeightCompact = function borderBoxMinHeightCompact(minimumRows, borderHeight) {
    var contentHeightCompact = $7775ae4ab14e299f$var$lineHeightCompact * minimumRows;
    return contentHeightCompact + $7775ae4ab14e299f$var$compactVerticalPadding * 2 + borderHeight * 2;
};
var $7775ae4ab14e299f$var$bgAndBorderColorStyles = function bgAndBorderColorStyles(props, appearance) {
    return (0, $2ZUkg.css)($7775ae4ab14e299f$var$_objectSpread({
        "&:focus": {
            backgroundColor: props.backgroundColorFocus,
            borderColor: props.borderColorFocus,
            boxShadow: (0, $90ozF.getBooleanFF)("platform.design-system-team.border-checkbox_nyoiu") ? "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", props.borderColorFocus) : undefined
        },
        "&:not(:focus)": {
            backgroundColor: props.backgroundColor,
            borderColor: props.borderColor
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "&[data-invalid]:focus": {
            backgroundColor: props.invalidRules.backgroundColorFocus,
            borderColor: props.invalidRules.borderColorFocus,
            boxShadow: (0, $90ozF.getBooleanFF)("platform.design-system-team.border-checkbox_nyoiu") ? "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", props.invalidRules.borderColorFocus) : undefined
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "&[data-invalid]:not(:focus)": {
            backgroundColor: props.invalidRules.backgroundColor,
            borderColor: props.invalidRules.borderColor,
            boxShadow: (0, $90ozF.getBooleanFF)("platform.design-system-team.border-checkbox_nyoiu") ? "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", props.invalidRules.borderColor) : undefined
        }
    }, appearance === "standard" ? {
        "&:disabled:focus": {
            backgroundColor: props.disabledRules.backgroundColorFocus,
            borderColor: props.disabledRules.borderColorFocus
        },
        "&:disabled:not(:focus)": {
            backgroundColor: props.disabledRules.backgroundColor,
            borderColor: props.disabledRules.borderColor
        }
    } : {}));
};
var $7775ae4ab14e299f$var$placeholderStyle = function placeholderStyle(placeholderTextColor) {
    return (0, $2ZUkg.css)({
        "&::placeholder": {
            color: placeholderTextColor
        }
    });
};
var $7775ae4ab14e299f$var$hoverBackgroundAndBorderStyles = function hoverBackgroundAndBorderStyles(props) {
    return (0, $2ZUkg.css)({
        "&:hover:not(:read-only):not(:focus)": {
            backgroundColor: props.backgroundColorHover,
            borderColor: props.borderColorHover,
            "&:disabled": {
                backgroundColor: props.disabledRules.backgroundColorHover
            },
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
            "&[data-invalid]": {
                backgroundColor: props.invalidRules.backgroundColorHover,
                borderColor: props.invalidRules.borderColor,
                boxShadow: (0, $90ozF.getBooleanFF)("platform.design-system-team.border-checkbox_nyoiu") ? "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", props.invalidRules.borderColor) : undefined
            }
        }
    });
};
var $7775ae4ab14e299f$var$resizeStyle = function resizeStyle(resize) {
    if (resize === "horizontal" || resize === "vertical") return (0, $2ZUkg.css)({
        resize: resize
    });
    if (resize === "auto") return (0, $2ZUkg.css)({
        resize: "both"
    });
    return (0, $2ZUkg.css)({
        resize: "none"
    });
};
var $7775ae4ab14e299f$var$borderStyle = function borderStyle(appearance) {
    return (0, $2ZUkg.css)({
        borderStyle: appearance === "none" ? "none" : "solid"
    });
};
var $7775ae4ab14e299f$var$fontFamilyStyle = function fontFamilyStyle(isMonospaced) {
    return (0, $2ZUkg.css)({
        fontFamily: isMonospaced ? $7775ae4ab14e299f$var$codeFontFamily : $7775ae4ab14e299f$var$fontFamily
    });
};
var $7775ae4ab14e299f$var$borderPaddingAndHeightStyles = function borderPaddingAndHeightStyles() {
    var minimumRows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var appearance = arguments.length > 1 ? arguments[1] : undefined;
    var borderWidth = (0, $90ozF.getBooleanFF)("platform.design-system-team.border-checkbox_nyoiu") && appearance !== "none" ? 1 : 2;
    var horizontalPaddingWithoutBorderWidth = $7775ae4ab14e299f$var$horizontalPadding - borderWidth;
    var borderHeight = borderWidth;
    return (0, $2ZUkg.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "&[data-compact]": {
            minHeight: $7775ae4ab14e299f$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            padding: "".concat($7775ae4ab14e299f$var$compactVerticalPadding, "px ").concat(horizontalPaddingWithoutBorderWidth, "px"),
            lineHeight: $7775ae4ab14e299f$var$lineHeightCompact / $7775ae4ab14e299f$var$fontSize
        },
        "&:not([data-compact])": {
            minHeight: $7775ae4ab14e299f$var$borderBoxMinHeight(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            padding: "".concat($7775ae4ab14e299f$var$verticalPadding, "px ").concat(horizontalPaddingWithoutBorderWidth, "px"),
            lineHeight: $7775ae4ab14e299f$var$lineHeightBase / $7775ae4ab14e299f$var$fontSize
        }
    });
};
var $7775ae4ab14e299f$var$staticStyles = (0, $2ZUkg.css)({
    display: "block",
    boxSizing: "border-box",
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    margin: 0,
    position: "relative",
    flex: "1 1 100%",
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    borderWidth: (0, $90ozF.getBooleanFF)("platform.design-system-team.border-checkbox_nyoiu") ? 1 : $7775ae4ab14e299f$export$12879c7697ed953d,
    fontSize: $7775ae4ab14e299f$var$fontSize,
    outline: "none",
    overflow: "auto",
    transition: "background-color ".concat($7775ae4ab14e299f$var$transitionDuration, " ease-in-out,\n               border-color ").concat($7775ae4ab14e299f$var$transitionDuration, " ease-in-out"),
    wordWrap: "break-word",
    "&:disabled": $7775ae4ab14e299f$var$_objectSpread({
        cursor: "not-allowed"
    }, $7775ae4ab14e299f$var$overrideSafariDisabledStyles),
    "&::-ms-clear": {
        display: "none"
    },
    "&:invalid": {
        boxShadow: "none"
    }
});
var $7775ae4ab14e299f$export$bff8031d86bb089 = function getBaseStyles(_ref) {
    var minimumRows = _ref.minimumRows, resize = _ref.resize, appearance = _ref.appearance, isMonospaced = _ref.isMonospaced, maxHeight = _ref.maxHeight;
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $2ZUkg.css)([
        $7775ae4ab14e299f$var$staticStyles,
        $7775ae4ab14e299f$var$borderPaddingAndHeightStyles(minimumRows, appearance),
        $7775ae4ab14e299f$var$resizeStyle(resize),
        $7775ae4ab14e299f$var$borderStyle(appearance),
        $7775ae4ab14e299f$var$fontFamilyStyle(isMonospaced),
        {
            maxHeight: maxHeight
        }
    ]));
};
var $7775ae4ab14e299f$export$ded1c27b355b104 = function themeStyles(props, appearance) {
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $2ZUkg.css)([
        $7775ae4ab14e299f$var$bgAndBorderColorStyles(props, appearance),
        $7775ae4ab14e299f$var$hoverBackgroundAndBorderStyles(props),
        $7775ae4ab14e299f$var$placeholderStyle(props.placeholderTextColor),
        {
            color: props.textColor,
            "&:disabled": {
                color: props.disabledRules.textColor
            }
        }
    ]));
};

});
parcelRegister("90ozF", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $68e72d1327d36f49$export$470e5c2be1411c89; });

var $kA11f = parcelRequire("kA11f");
function $68e72d1327d36f49$export$ba05d765b8392e5e(flagResolver) {
    (0, $kA11f.setBooleanResolver)(flagResolver);
}
function $68e72d1327d36f49$export$470e5c2be1411c89(name) {
    return (0, $kA11f.resolveBooleanFlag)(name);
}

});
parcelRegister("kA11f", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $efb7f5cd47d6d7ae$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $efb7f5cd47d6d7ae$export$6333b6aff9fc6275; });

var $9lGRg = parcelRequire("9lGRg");

var $XAEGR = parcelRequire("XAEGR");
var $efb7f5cd47d6d7ae$var$pkgName = "@atlaskit/platform-feature-flags";
var $efb7f5cd47d6d7ae$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $efb7f5cd47d6d7ae$var$hasProcessEnv = typeof $XAEGR !== "undefined" && typeof $XAEGR.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $efb7f5cd47d6d7ae$var$ENV_ENABLE_PLATFORM_FF = $efb7f5cd47d6d7ae$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $efb7f5cd47d6d7ae$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $efb7f5cd47d6d7ae$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $efb7f5cd47d6d7ae$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $efb7f5cd47d6d7ae$var$ENV_ENABLE_PLATFORM_FF || $efb7f5cd47d6d7ae$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $efb7f5cd47d6d7ae$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $efb7f5cd47d6d7ae$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$efb7f5cd47d6d7ae$var$globalVar[$efb7f5cd47d6d7ae$export$7e41b1b2bdee3f98] = $efb7f5cd47d6d7ae$var$globalVar[$efb7f5cd47d6d7ae$export$7e41b1b2bdee3f98] || $efb7f5cd47d6d7ae$var$DEFAULT_PFF_GLOBAL;
function $efb7f5cd47d6d7ae$export$f2b591175b3e424c(resolver) {
    $efb7f5cd47d6d7ae$var$globalVar[$efb7f5cd47d6d7ae$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2;
}
function $efb7f5cd47d6d7ae$export$6333b6aff9fc6275(flagKey) {
    if ($efb7f5cd47d6d7ae$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $9lGRg.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $efb7f5cd47d6d7ae$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL3;
        var result = (_globalVar$PFF_GLOBAL3 = $efb7f5cd47d6d7ae$var$globalVar[$efb7f5cd47d6d7ae$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("9lGRg", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $6ce751f328577a1f$export$1c9f709888824e05; });
var $6ce751f328577a1f$var$_ref, $6ce751f328577a1f$var$_globalThis$process, $6ce751f328577a1f$var$_globalThis$process$e, $6ce751f328577a1f$var$_globalThis$process2, $6ce751f328577a1f$var$_globalThis$process2$;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $6ce751f328577a1f$var$TESTS_MODE = ($6ce751f328577a1f$var$_ref = (globalThis === null || globalThis === void 0 ? void 0 : ($6ce751f328577a1f$var$_globalThis$process = globalThis.process) === null || $6ce751f328577a1f$var$_globalThis$process === void 0 ? void 0 : ($6ce751f328577a1f$var$_globalThis$process$e = $6ce751f328577a1f$var$_globalThis$process.env) === null || $6ce751f328577a1f$var$_globalThis$process$e === void 0 ? void 0 : $6ce751f328577a1f$var$_globalThis$process$e.JEST_WORKER_ID) !== undefined, $6ce751f328577a1f$var$_ref !== void 0) ? $6ce751f328577a1f$var$_ref : false;
var $6ce751f328577a1f$var$DEBUG_MODE = !$6ce751f328577a1f$var$TESTS_MODE && (globalThis === null || globalThis === void 0 ? void 0 : ($6ce751f328577a1f$var$_globalThis$process2 = globalThis.process) === null || $6ce751f328577a1f$var$_globalThis$process2 === void 0 ? void 0 : ($6ce751f328577a1f$var$_globalThis$process2$ = $6ce751f328577a1f$var$_globalThis$process2.env) === null || $6ce751f328577a1f$var$_globalThis$process2$ === void 0 ? void 0 : $6ce751f328577a1f$var$_globalThis$process2$.NODE_ENV) !== "production";
var $6ce751f328577a1f$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$6ce751f328577a1f$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("6wEUZ", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $4c0578b76a3fbac2$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $4c0578b76a3fbac2$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $4c0578b76a3fbac2$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "gridSize", function () { return $4c0578b76a3fbac2$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "fontSize", function () { return $4c0578b76a3fbac2$export$85e3c3ca0c6fb93; });
$parcel$export(module.exports, "fontFamily", function () { return $4c0578b76a3fbac2$export$a5975749f0374264; });
$parcel$export(module.exports, "codeFontFamily", function () { return $4c0578b76a3fbac2$export$356129969ee49c55; });

var $9qdtp = parcelRequire("9qdtp");

var $cfZgR = parcelRequire("cfZgR");
var $4c0578b76a3fbac2$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $4c0578b76a3fbac2$export$c93026a968943f95 = "light";
var $4c0578b76a3fbac2$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $4c0578b76a3fbac2$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $4c0578b76a3fbac2$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $4c0578b76a3fbac2$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $4c0578b76a3fbac2$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $4c0578b76a3fbac2$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $4c0578b76a3fbac2$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $4c0578b76a3fbac2$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $cfZgR.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $4c0578b76a3fbac2$export$6d8204c2cb2e06b8() / 4;
    (0, $9qdtp.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $4c0578b76a3fbac2$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $4c0578b76a3fbac2$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $4c0578b76a3fbac2$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $9qdtp.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $4c0578b76a3fbac2$export$ba1d834b86d72a09 = $4c0578b76a3fbac2$export$a1b3edb637fb4f35;
var $4c0578b76a3fbac2$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $cfZgR.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $cfZgR.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $cfZgR.N30A), ")")
            }
        }
    };
};

});
parcelRegister("9qdtp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6dc0fe4999f8e48b$export$2e2bcd8739ae039; });

var $7PMSv = parcelRequire("7PMSv");

var $XAEGR = parcelRequire("XAEGR");
function $6dc0fe4999f8e48b$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $7PMSv.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $6dc0fe4999f8e48b$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $XAEGR;
}

});
parcelRegister("7PMSv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b4336066b710f34$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $5b4336066b710f34$var$printed = {};
function $5b4336066b710f34$export$2e2bcd8739ae039(message) {
    if ($5b4336066b710f34$var$printed[message]) return;
    $5b4336066b710f34$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}

});


parcelRegister("cfZgR", function(module, exports) {

$parcel$export(module.exports, "R400", function () { return $8ec669e23e130cc2$export$2010d0fb4295b346; });
$parcel$export(module.exports, "B100", function () { return $8ec669e23e130cc2$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $8ec669e23e130cc2$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $8ec669e23e130cc2$export$29a4f05edc054374; });
$parcel$export(module.exports, "N10", function () { return $8ec669e23e130cc2$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $8ec669e23e130cc2$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $8ec669e23e130cc2$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $8ec669e23e130cc2$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N70", function () { return $8ec669e23e130cc2$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N100", function () { return $8ec669e23e130cc2$export$d6447c357493214f; });
$parcel$export(module.exports, "N200", function () { return $8ec669e23e130cc2$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N900", function () { return $8ec669e23e130cc2$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N30A", function () { return $8ec669e23e130cc2$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN600", function () { return $8ec669e23e130cc2$export$5368d76ae4fbbda7; });
$parcel$export(module.exports, "DN200", function () { return $8ec669e23e130cc2$export$bfe21c59123ecf33; });
$parcel$export(module.exports, "DN90", function () { return $8ec669e23e130cc2$export$682927c6ed76be02; });
$parcel$export(module.exports, "DN40", function () { return $8ec669e23e130cc2$export$33ff357f6620b39; });
$parcel$export(module.exports, "DN30", function () { return $8ec669e23e130cc2$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN20", function () { return $8ec669e23e130cc2$export$9776a6e503bdbf76; });
$parcel$export(module.exports, "DN10", function () { return $8ec669e23e130cc2$export$6c813d5160dff5db; });
$parcel$export(module.exports, "skeleton", function () { return $8ec669e23e130cc2$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $fDBBz = parcelRequire("fDBBz");
var $8ec669e23e130cc2$export$4b84fd0e2c617bd = "#FFEBE6";
var $8ec669e23e130cc2$export$b34b069eff244586 = "#FFBDAD";
var $8ec669e23e130cc2$export$be802dd0d8b57f35 = "#FF8F73";
var $8ec669e23e130cc2$export$60847d42f9da92a6 = "#FF7452";
var $8ec669e23e130cc2$export$4a7404f376229999 = "#FF5630";
var $8ec669e23e130cc2$export$2010d0fb4295b346 = "#DE350B";
var $8ec669e23e130cc2$export$2837b5a1a71d5c02 = "#BF2600";
var $8ec669e23e130cc2$export$8d9596b529bbb9cf = "#FFFAE6";
var $8ec669e23e130cc2$export$41060a744ab0b7ae = "#FFF0B3";
var $8ec669e23e130cc2$export$1cc05bbbf340e559 = "#FFE380";
var $8ec669e23e130cc2$export$5aae31392d72caaa = "#FFC400";
var $8ec669e23e130cc2$export$c6930421db9fa514 = "#FFAB00";
var $8ec669e23e130cc2$export$59619663aa6500fb = "#FF991F";
var $8ec669e23e130cc2$export$874739ea9e379ab6 = "#FF8B00";
var $8ec669e23e130cc2$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $8ec669e23e130cc2$export$69a3bf21b9686c2b = "#ABF5D1";
var $8ec669e23e130cc2$export$afbce1382ec95f73 = "#79F2C0";
var $8ec669e23e130cc2$export$747d86715d4175de = "#57D9A3";
var $8ec669e23e130cc2$export$940e1f69e873f202 = "#36B37E";
var $8ec669e23e130cc2$export$a49394138f7b8e85 = "#00875A";
var $8ec669e23e130cc2$export$6fa04827ac68a4fb = "#006644";
var $8ec669e23e130cc2$export$226de0355ed012f8 = "#DEEBFF";
var $8ec669e23e130cc2$export$8c13c2ee36917869 = "#B3D4FF";
var $8ec669e23e130cc2$export$ecfc1dff386a3e7a = "#4C9AFF";
var $8ec669e23e130cc2$export$215b7063051591f1 = "#2684FF";
var $8ec669e23e130cc2$export$e62e8919cca44969 = "#0065FF";
var $8ec669e23e130cc2$export$b3de0ae08da2ce64 = "#0052CC";
var $8ec669e23e130cc2$export$a6ee3d71bc067634 = "#0747A6";
var $8ec669e23e130cc2$export$363e4475840015bb = "#EAE6FF";
var $8ec669e23e130cc2$export$4b0a4417ed59760f = "#C0B6F2";
var $8ec669e23e130cc2$export$6011520a64d9a187 = "#998DD9";
var $8ec669e23e130cc2$export$a7175d4e9206bc80 = "#8777D9";
var $8ec669e23e130cc2$export$b48405b95304b5a1 = "#6554C0";
var $8ec669e23e130cc2$export$c71e4279dd54a18d = "#5243AA";
var $8ec669e23e130cc2$export$147899de772240ec = "#403294";
var $8ec669e23e130cc2$export$2cf711fe14c66f06 = "#E6FCFF";
var $8ec669e23e130cc2$export$7a8f4d33f6f9772c = "#B3F5FF";
var $8ec669e23e130cc2$export$776c9c497ef08533 = "#79E2F2";
var $8ec669e23e130cc2$export$69cb3ca10c1e330e = "#00C7E6";
var $8ec669e23e130cc2$export$9dc1ef0f3f48059b = "#00B8D9";
var $8ec669e23e130cc2$export$7c835c78b6fcdef8 = "#00A3BF";
var $8ec669e23e130cc2$export$6036577f95c3877e = "#008DA6";
var $8ec669e23e130cc2$export$29a4f05edc054374 = "#FFFFFF";
var $8ec669e23e130cc2$export$e655ef011c4aa1a2 = "#FAFBFC";
var $8ec669e23e130cc2$export$9fdfb749e33cdf97 = "#F4F5F7";
var $8ec669e23e130cc2$export$3e51e8f1440314ba = "#EBECF0";
var $8ec669e23e130cc2$export$1ce2d1575d444ceb = "#DFE1E6";
var $8ec669e23e130cc2$export$8754fc7e6d8b3000 = "#C1C7D0";
var $8ec669e23e130cc2$export$c2e91cbeada39b8b = "#B3BAC5";
var $8ec669e23e130cc2$export$5f71e19f3a7ad9de = "#A5ADBA";
var $8ec669e23e130cc2$export$eaa8c8a70ac22806 = "#97A0AF";
var $8ec669e23e130cc2$export$7c87d337fb91a97d = "#8993A4";
var $8ec669e23e130cc2$export$d6447c357493214f = "#7A869A";
var $8ec669e23e130cc2$export$f563ee71e9ee74cd = "#6B778C";
var $8ec669e23e130cc2$export$e2ef2124cf4024b1 = "#5E6C84";
var $8ec669e23e130cc2$export$eece5f492e429f08 = "#505F79";
var $8ec669e23e130cc2$export$c39c0fe0f26207ae = "#42526E";
var $8ec669e23e130cc2$export$7090862dc3038a9f = "#344563";
var $8ec669e23e130cc2$export$ad0bacf983b7ddaa = "#253858";
var $8ec669e23e130cc2$export$7d61b15e0da132af = "#172B4D";
var $8ec669e23e130cc2$export$fbda843f0a27fe96 = "#091E42";
var $8ec669e23e130cc2$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $8ec669e23e130cc2$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $8ec669e23e130cc2$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $8ec669e23e130cc2$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $8ec669e23e130cc2$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $8ec669e23e130cc2$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $8ec669e23e130cc2$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $8ec669e23e130cc2$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $8ec669e23e130cc2$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $8ec669e23e130cc2$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $8ec669e23e130cc2$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $8ec669e23e130cc2$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $8ec669e23e130cc2$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $8ec669e23e130cc2$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $8ec669e23e130cc2$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $8ec669e23e130cc2$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $8ec669e23e130cc2$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $8ec669e23e130cc2$export$2f6319cf7d736c2a = "#E6EDFA";
var $8ec669e23e130cc2$export$95126bc8884d6634 = "#DCE5F5";
var $8ec669e23e130cc2$export$8338d8c35d44ff1 = "#CED9EB";
var $8ec669e23e130cc2$export$5368d76ae4fbbda7 = "#B8C7E0";
var $8ec669e23e130cc2$export$9f0a771d16ec8d36 = "#ABBBD6";
var $8ec669e23e130cc2$export$abcf8c38338b4aa5 = "#9FB0CC";
var $8ec669e23e130cc2$export$97e81faa16a182c7 = "#8C9CB8";
var $8ec669e23e130cc2$export$bfe21c59123ecf33 = "#7988A3";
var $8ec669e23e130cc2$export$ee82aa2ea6a1558 = "#67758F";
var $8ec669e23e130cc2$export$682927c6ed76be02 = "#56637A";
var $8ec669e23e130cc2$export$91fd9994c5be9757 = "#455166";
var $8ec669e23e130cc2$export$d281fbfe3cff2df6 = "#3B475C";
var $8ec669e23e130cc2$export$3902c91d8b98a753 = "#313D52";
var $8ec669e23e130cc2$export$8e8133c1ba5845b5 = "#283447";
var $8ec669e23e130cc2$export$33ff357f6620b39 = "#202B3D";
var $8ec669e23e130cc2$export$633847cf062b69e0 = "#1B2638";
var $8ec669e23e130cc2$export$9776a6e503bdbf76 = "#121A29";
var $8ec669e23e130cc2$export$6c813d5160dff5db = "#0E1624";
var $8ec669e23e130cc2$export$3d4f271a500072a = "#0D1424";
var $8ec669e23e130cc2$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $8ec669e23e130cc2$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $8ec669e23e130cc2$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $8ec669e23e130cc2$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $8ec669e23e130cc2$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $8ec669e23e130cc2$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $8ec669e23e130cc2$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $8ec669e23e130cc2$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $8ec669e23e130cc2$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $8ec669e23e130cc2$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $8ec669e23e130cc2$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $8ec669e23e130cc2$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $8ec669e23e130cc2$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $8ec669e23e130cc2$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $8ec669e23e130cc2$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $8ec669e23e130cc2$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $8ec669e23e130cc2$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $8ec669e23e130cc2$export$8ce1fd94bee2f412 = (0, $fDBBz.default)({
    light: "var(--ds-surface, ".concat($8ec669e23e130cc2$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($8ec669e23e130cc2$export$633847cf062b69e0, ")")
});
var $8ec669e23e130cc2$export$b861914ea877b580 = (0, $fDBBz.default)({
    light: "var(--ds-background-selected, ".concat($8ec669e23e130cc2$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($8ec669e23e130cc2$export$8c13c2ee36917869, ")")
});
var $8ec669e23e130cc2$export$3f1b020df94387af = (0, $fDBBz.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($8ec669e23e130cc2$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($8ec669e23e130cc2$export$d281fbfe3cff2df6, ")")
});
var $8ec669e23e130cc2$export$c0183dbab98ca63e = (0, $fDBBz.default)({
    light: "var(--ds-surface-overlay, ".concat($8ec669e23e130cc2$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($8ec669e23e130cc2$export$8e8133c1ba5845b5, ")")
});
var $8ec669e23e130cc2$export$6f093cfa640b7166 = (0, $fDBBz.default)({
    light: "var(--ds-text, ".concat($8ec669e23e130cc2$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($8ec669e23e130cc2$export$5368d76ae4fbbda7, ")")
});
var $8ec669e23e130cc2$export$42f8e9c698766e7a = (0, $fDBBz.default)({
    light: "var(--ds-text, ".concat($8ec669e23e130cc2$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($8ec669e23e130cc2$export$5368d76ae4fbbda7, ")")
});
var $8ec669e23e130cc2$export$c2d157ca1c34b6e3 = (0, $fDBBz.default)({
    light: "var(--ds-text-selected, ".concat($8ec669e23e130cc2$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($8ec669e23e130cc2$export$b3de0ae08da2ce64, ")")
});
var $8ec669e23e130cc2$export$1905ba28d7cf066f = (0, $fDBBz.default)({
    light: "var(--ds-text-subtlest, ".concat($8ec669e23e130cc2$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($8ec669e23e130cc2$export$97e81faa16a182c7, ")")
});
var $8ec669e23e130cc2$export$bd9002130d306d39 = (0, $fDBBz.default)({
    light: "var(--ds-text-subtlest, ".concat($8ec669e23e130cc2$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($8ec669e23e130cc2$export$bfe21c59123ecf33, ")")
});
var $8ec669e23e130cc2$export$46e4a324ac90507f = (0, $fDBBz.default)({
    light: "var(--ds-text, ".concat($8ec669e23e130cc2$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($8ec669e23e130cc2$export$5368d76ae4fbbda7, ")")
});
var $8ec669e23e130cc2$export$79f3f2b82beb0d36 = (0, $fDBBz.default)({
    light: "var(--ds-text-subtlest, ".concat($8ec669e23e130cc2$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($8ec669e23e130cc2$export$97e81faa16a182c7, ")")
});
var $8ec669e23e130cc2$export$7bb0d5c671655cc4 = (0, $fDBBz.default)({
    light: $8ec669e23e130cc2$export$9fdfb749e33cdf97,
    dark: $8ec669e23e130cc2$export$8e8133c1ba5845b5
});
var $8ec669e23e130cc2$export$9c30223ca0a664fb = (0, $fDBBz.default)({
    light: "var(--ds-link, ".concat($8ec669e23e130cc2$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($8ec669e23e130cc2$export$ecfc1dff386a3e7a, ")")
});
var $8ec669e23e130cc2$export$7ed258b0728b004b = (0, $fDBBz.default)({
    light: "var(--ds-link-pressed, ".concat($8ec669e23e130cc2$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($8ec669e23e130cc2$export$215b7063051591f1, ")")
});
var $8ec669e23e130cc2$export$dfa920d8decc8a59 = (0, $fDBBz.default)({
    light: "var(--ds-link-pressed, ".concat($8ec669e23e130cc2$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($8ec669e23e130cc2$export$ecfc1dff386a3e7a, ")")
});
var $8ec669e23e130cc2$export$6069e6ad5c78f632 = (0, $fDBBz.default)({
    light: "var(--ds-border-focused, ".concat($8ec669e23e130cc2$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($8ec669e23e130cc2$export$215b7063051591f1, ")")
});
var $8ec669e23e130cc2$export$9ad721cf3b3debe0 = (0, $fDBBz.default)({
    light: "var(--ds-background-brand-bold, ".concat($8ec669e23e130cc2$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($8ec669e23e130cc2$export$ecfc1dff386a3e7a, ")")
});
var $8ec669e23e130cc2$export$2aa0182783e7e9de = (0, $fDBBz.default)({
    light: $8ec669e23e130cc2$export$b3de0ae08da2ce64,
    dark: $8ec669e23e130cc2$export$ecfc1dff386a3e7a
});
var $8ec669e23e130cc2$export$8bf7dff220b82b4a = (0, $fDBBz.default)({
    light: $8ec669e23e130cc2$export$9dc1ef0f3f48059b,
    dark: $8ec669e23e130cc2$export$69cb3ca10c1e330e
});
var $8ec669e23e130cc2$export$e13cce2a2d16a9d4 = (0, $fDBBz.default)({
    light: $8ec669e23e130cc2$export$b48405b95304b5a1,
    dark: $8ec669e23e130cc2$export$6011520a64d9a187
});
var $8ec669e23e130cc2$export$a90204d1394caf30 = (0, $fDBBz.default)({
    light: $8ec669e23e130cc2$export$4a7404f376229999,
    dark: $8ec669e23e130cc2$export$4a7404f376229999
});
var $8ec669e23e130cc2$export$594c5a8758200c32 = (0, $fDBBz.default)({
    light: $8ec669e23e130cc2$export$c6930421db9fa514,
    dark: $8ec669e23e130cc2$export$c6930421db9fa514
});
var $8ec669e23e130cc2$export$955a2ebd2fb142ae = (0, $fDBBz.default)({
    light: $8ec669e23e130cc2$export$940e1f69e873f202,
    dark: $8ec669e23e130cc2$export$940e1f69e873f202
});
var $8ec669e23e130cc2$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($8ec669e23e130cc2$export$8d43898f60b96a82, ")");
};

});
parcelRegister("fDBBz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b627ab12e146ca77$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $bSh3e = parcelRequire("bSh3e");
// Unpack custom variants, and get correct value for the current theme
function $b627ab12e146ca77$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $bSh3e.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $b627ab12e146ca77$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $b627ab12e146ca77$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $bSh3e.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("bSh3e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a51f6da67d9b7ca$export$2e2bcd8739ae039; });

var $6wEUZ = parcelRequire("6wEUZ");
function $8a51f6da67d9b7ca$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $6wEUZ.CHANNEL) in props.theme) return props.theme[0, $6wEUZ.CHANNEL];
        else if ("mode" in props.theme && (0, $6wEUZ.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $6wEUZ.DEFAULT_THEME_MODE)
    };
}

});





parcelRegister("dAkuQ", function(module, exports) {

$parcel$export(module.exports, "Theme", function () { return $9e3e895a81e1184b$export$14faa19a0f3bbeb2; });

var $lh8cT = parcelRequire("lh8cT");

var $bojaR = parcelRequire("bojaR");
var $9e3e895a81e1184b$var$disabledRules = {
    light: {
        backgroundColor: $bojaR.disabledBackground.light,
        backgroundColorFocus: $bojaR.disabledBackground.light,
        backgroundColorHover: $bojaR.disabledBackground.light,
        borderColor: $bojaR.disabledBorder.light,
        borderColorFocus: $bojaR.defaultBorderColorFocus.light,
        textColor: $bojaR.disabledTextColor.light
    },
    dark: {
        backgroundColor: $bojaR.disabledBackground.dark,
        backgroundColorFocus: $bojaR.disabledBackground.dark,
        backgroundColorHover: $bojaR.disabledBackground.dark,
        borderColor: $bojaR.disabledBorder.dark,
        borderColorFocus: $bojaR.defaultBorderColorFocus.dark,
        textColor: $bojaR.disabledTextColor.dark
    }
};
var $9e3e895a81e1184b$var$invalidRules = {
    light: {
        borderColor: $bojaR.invalidBorderColor.light,
        borderColorFocus: $bojaR.defaultBorderColorFocus.light,
        backgroundColor: $bojaR.defaultBackgroundColor.light,
        backgroundColorFocus: $bojaR.defaultBackgroundColorFocus.light,
        backgroundColorHover: $bojaR.defaultBackgroundColorHover.light
    },
    dark: {
        borderColor: $bojaR.invalidBorderColor.dark,
        borderColorFocus: $bojaR.defaultBorderColorFocus.dark,
        backgroundColor: $bojaR.defaultBackgroundColor.dark,
        backgroundColorFocus: $bojaR.defaultBackgroundColorFocus.dark,
        backgroundColorHover: $bojaR.defaultBackgroundColorHover.dark
    }
};
var $9e3e895a81e1184b$var$backgroundColor = {
    standard: $bojaR.defaultBackgroundColor,
    subtle: $bojaR.transparent,
    none: $bojaR.transparent
};
var $9e3e895a81e1184b$var$backgroundColorFocus = {
    standard: $bojaR.defaultBackgroundColorFocus,
    subtle: $bojaR.defaultBackgroundColorFocus,
    none: $bojaR.transparent
};
var $9e3e895a81e1184b$var$backgroundColorHover = {
    standard: $bojaR.defaultBackgroundColorHover,
    subtle: $bojaR.defaultBackgroundColorHover,
    none: $bojaR.transparent
};
var $9e3e895a81e1184b$var$borderColor = {
    standard: $bojaR.defaultBorderColor,
    subtle: $bojaR.transparent,
    none: $bojaR.transparent
};
var $9e3e895a81e1184b$var$borderColorFocus = {
    standard: $bojaR.defaultBorderColorFocus,
    subtle: $bojaR.defaultBorderColorFocus,
    none: $bojaR.transparent
};
var $9e3e895a81e1184b$var$borderColorHover = {
    standard: $bojaR.defaultBorderColor,
    subtle: $bojaR.subtleBorderColorHover,
    none: $bojaR.transparent
};
var $9e3e895a81e1184b$export$8c52b1fd9e189b5 = {
    borderColor: $9e3e895a81e1184b$var$borderColor,
    borderColorFocus: $9e3e895a81e1184b$var$borderColorFocus,
    backgroundColor: $9e3e895a81e1184b$var$backgroundColor,
    backgroundColorFocus: $9e3e895a81e1184b$var$backgroundColorFocus,
    backgroundColorHover: $9e3e895a81e1184b$var$backgroundColorHover,
    disabledRules: $9e3e895a81e1184b$var$disabledRules,
    invalidRules: $9e3e895a81e1184b$var$invalidRules,
    textColor: $bojaR.textColor,
    placeholderTextColor: $bojaR.placeholderTextColor
};
var $9e3e895a81e1184b$export$14faa19a0f3bbeb2 = (0, $lh8cT.createTheme)(function(_ref) {
    var appearance = _ref.appearance, mode = _ref.mode;
    return {
        borderColor: $9e3e895a81e1184b$var$borderColor[appearance][mode],
        borderColorFocus: $9e3e895a81e1184b$var$borderColorFocus[appearance][mode],
        borderColorHover: $9e3e895a81e1184b$var$borderColorHover[appearance][mode],
        backgroundColorHover: $9e3e895a81e1184b$var$backgroundColorHover[appearance][mode],
        backgroundColorFocus: $9e3e895a81e1184b$var$backgroundColorFocus[appearance][mode],
        backgroundColor: $9e3e895a81e1184b$var$backgroundColor[appearance][mode],
        disabledRules: $9e3e895a81e1184b$var$disabledRules[mode],
        invalidRules: $9e3e895a81e1184b$var$invalidRules[mode],
        textColor: $bojaR.textColor[mode],
        placeholderTextColor: $bojaR.placeholderTextColor[mode]
    };
});

});
parcelRegister("bojaR", function(module, exports) {

$parcel$export(module.exports, "disabledBackground", function () { return $84b0cf30959a60a3$export$ae3cba7672df0890; });
$parcel$export(module.exports, "disabledBorder", function () { return $84b0cf30959a60a3$export$fe505fe3c5edbdf6; });
$parcel$export(module.exports, "invalidBorderColor", function () { return $84b0cf30959a60a3$export$7f333bbf7ddab792; });
$parcel$export(module.exports, "defaultBorderColor", function () { return $84b0cf30959a60a3$export$dafd83031c202ca8; });
$parcel$export(module.exports, "defaultBorderColorFocus", function () { return $84b0cf30959a60a3$export$e8320c09dc1e4012; });
$parcel$export(module.exports, "defaultBackgroundColor", function () { return $84b0cf30959a60a3$export$b13414ee9ac9cae6; });
$parcel$export(module.exports, "defaultBackgroundColorHover", function () { return $84b0cf30959a60a3$export$bca15982c103d57b; });
$parcel$export(module.exports, "defaultBackgroundColorFocus", function () { return $84b0cf30959a60a3$export$21287e4b7f134f09; });
$parcel$export(module.exports, "subtleBorderColorHover", function () { return $84b0cf30959a60a3$export$a87538d56ee366ec; });
$parcel$export(module.exports, "placeholderTextColor", function () { return $84b0cf30959a60a3$export$5e076b2557ef7bbb; });
$parcel$export(module.exports, "textColor", function () { return $84b0cf30959a60a3$export$32f78bffcd82ff28; });
$parcel$export(module.exports, "disabledTextColor", function () { return $84b0cf30959a60a3$export$eb4a7d363eec53c8; });
$parcel$export(module.exports, "transparent", function () { return $84b0cf30959a60a3$export$f4d082c200a4b4b8; });

var $90ozF = parcelRequire("90ozF");

var $cfZgR = parcelRequire("cfZgR");
var $84b0cf30959a60a3$export$ae3cba7672df0890 = {
    light: "var(--ds-background-disabled, ".concat((0, $cfZgR.N20), ")"),
    dark: "var(--ds-background-disabled, ".concat((0, $cfZgR.DN20), ")")
};
var $84b0cf30959a60a3$export$fe505fe3c5edbdf6 = {
    light: "var(--ds-border-disabled, ".concat((0, $cfZgR.N40), ")"),
    dark: "var(--ds-border-disabled, ".concat((0, $cfZgR.DN40), ")")
};
var $84b0cf30959a60a3$export$7f333bbf7ddab792 = {
    light: "var(--ds-border-danger, ".concat((0, $cfZgR.R400), ")"),
    dark: "var(--ds-border-danger, ".concat((0, $cfZgR.R400), ")")
};
var $84b0cf30959a60a3$export$dafd83031c202ca8 = {
    light: "var(--ds-border-input, ".concat((0, $90ozF.getBooleanFF)("platform.design-system-team.border-checkbox_nyoiu") ? (0, $cfZgR.N100) : (0, $cfZgR.N40), ")"),
    dark: "var(--ds-border-input, ".concat((0, $90ozF.getBooleanFF)("platform.design-system-team.border-checkbox_nyoiu") ? (0, $cfZgR.DN200) : (0, $cfZgR.DN40), ")")
};
var $84b0cf30959a60a3$export$e8320c09dc1e4012 = {
    light: "var(--ds-border-focused, ".concat((0, $cfZgR.B200), ")"),
    dark: "var(--ds-border-focused, ".concat((0, $cfZgR.B100), ")")
};
var $84b0cf30959a60a3$export$b13414ee9ac9cae6 = {
    light: "var(--ds-background-input, ".concat((0, $cfZgR.N10), ")"),
    dark: "var(--ds-background-input, ".concat((0, $cfZgR.DN10), ")")
};
var $84b0cf30959a60a3$export$bca15982c103d57b = {
    light: "var(--ds-background-input-hovered, ".concat((0, $cfZgR.N30), ")"),
    dark: "var(--ds-background-input-hovered, ".concat((0, $cfZgR.DN30), ")")
};
var $84b0cf30959a60a3$export$21287e4b7f134f09 = {
    light: "var(--ds-background-input-pressed, ".concat((0, $cfZgR.N0), ")"),
    dark: "var(--ds-background-input-pressed, ".concat((0, $cfZgR.DN10), ")")
};
var $84b0cf30959a60a3$export$a87538d56ee366ec = {
    light: "var(--ds-border-input, transparent)",
    dark: "var(--ds-border-input, transparent)"
};
var $84b0cf30959a60a3$export$5e076b2557ef7bbb = {
    light: "var(--ds-text-subtlest, ".concat((0, $cfZgR.N200), ")"),
    dark: "var(--ds-text-subtlest, ".concat((0, $cfZgR.DN200), ")")
};
var $84b0cf30959a60a3$export$32f78bffcd82ff28 = {
    light: "var(--ds-text, ".concat((0, $cfZgR.N900), ")"),
    dark: "var(--ds-text, ".concat((0, $cfZgR.DN600), ")")
};
var $84b0cf30959a60a3$export$eb4a7d363eec53c8 = {
    light: "var(--ds-text-disabled, ".concat((0, $cfZgR.N70), ")"),
    dark: "var(--ds-text-disabled, ".concat((0, $cfZgR.DN90), ")")
};
var $84b0cf30959a60a3$export$f4d082c200a4b4b8 = {
    light: "transparent",
    dark: "transparent"
};

});



parcelRegister("awi0k", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryLogo", function () { return $7a8adbd18c710408$export$c49a2b642fe9eef4; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $7a8adbd18c710408$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 318 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z" />\n      <path fill="').concat(colors.textColor, '" d="M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404" />\n    </svg>');
};
var $7a8adbd18c710408$export$c49a2b642fe9eef4 = function JiraProductDiscoveryLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Product Discovery" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $7a8adbd18c710408$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("ciFJX", function(module, exports) {

$parcel$export(module.exports, "ServiceCollectionLogo", function () { return $9b5a68762b5c44f3$export$c75146d7e53859e0; });
/* service-collection-logo.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $5ohHq = parcelRequire("5ohHq");
const $9b5a68762b5c44f3$export$c75146d7e53859e0 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        viewBox: "0 0 224 64",
        fill: "none",
        className: (0, $esG4f.default)([
            "_4t3ickbl _v5641jnf _1bsb1wug _165tvbgk"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: (0, $5ohHq.wacToken)("color.extended.yellow300"),
                d: "m1.755 5.022 105.992 3.701-1.755 50.256L0 55.277z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: (0, $5ohHq.wacToken)("color.primary.black"),
                d: "M89.066 29.582c-1.204 0-1.818.87-1.972 2.586h3.866c-.128-1.792-.742-2.586-1.894-2.586Zm5.734 9.651c-1.254.461-2.97.794-4.685.794-5.3 0-7.68-2.33-7.68-6.682 0-4.172 2.304-7.142 6.707-7.142 4.352 0 6.144 2.944 6.144 7.142v.999h-8.09c.308 1.305 1.204 1.715 3.022 1.715 1.535 0 3.225-.23 4.582-.614v3.788ZM81.458 35.112v4.121c-.896.512-2.048.82-3.456.82-4.864 0-7.117-2.868-7.117-6.938 0-4.02 2.253-6.912 6.81-6.912 1.587 0 2.56.282 3.711.82v4.172a6.674 6.674 0 0 0-2.944-.64c-1.996 0-2.816 1.178-2.816 2.56 0 1.433.922 2.483 2.944 2.483 1.383 0 2.125-.205 2.868-.486ZM64.084 22.824c0-1.664 1.254-2.637 2.944-2.637 1.74 0 2.97.973 2.97 2.637 0 1.69-1.23 2.662-2.97 2.662-1.69 0-2.945-.973-2.945-2.662Zm.537 16.947V26.51h4.839v13.26H64.62ZM60.285 39.77h-6.707l-3.482-13.26h4.71l2.177 9.856 2.176-9.856h4.608l-3.482 13.26ZM46.21 33.345v6.426h-4.864V26.51h4.864v2.509c.691-1.792 1.767-2.79 3.507-2.688v4.966c-2.585-.18-3.507.333-3.507 2.048ZM33.665 29.582c-1.203 0-1.817.87-1.971 2.586h3.866c-.129-1.792-.743-2.586-1.895-2.586Zm5.735 9.651c-1.255.461-2.97.794-4.685.794-5.3 0-7.68-2.33-7.68-6.682 0-4.172 2.304-7.142 6.707-7.142 4.352 0 6.144 2.944 6.144 7.142v.999h-8.09c.307 1.305 1.203 1.715 3.021 1.715 1.536 0 3.226-.23 4.583-.614v3.788ZM26.055 34.497c0 3.482-1.972 5.555-6.836 5.555-2.97 0-5.12-.665-6.502-1.408v-4.608c1.562.717 4.506 1.51 6.451 1.51 1.178 0 1.613-.383 1.613-.998 0-.64-.512-.998-1.843-1.254-4.992-.82-6.426-2.79-6.426-5.35 0-3.303 2.432-5.274 6.887-5.274 2.355 0 4.582.512 6.016 1.28v4.454c-2.176-.819-4.685-1.357-6.144-1.357-1.101 0-1.664.333-1.664.973 0 .64.588.948 2.355 1.28 4.915.794 6.093 2.688 6.093 5.197ZM185 9.232c0-1.748-.936-2.576-3.549-3.146-1.453-.313-1.802-.644-1.802-1.104 0-.57.514-.827 1.471-.827 1.16 0 2.3.348 3.384.845V2.7c-.753-.387-1.931-.68-3.31-.68-2.593 0-3.934 1.123-3.934 2.981 0 1.471.679 2.65 3.364 3.164 1.6.33 1.931.588 1.931 1.122 0 .535-.331.845-1.471.845-1.305 0-2.867-.44-3.88-1.049v2.41c.809.405 1.875.846 3.862.846 2.832 0 3.934-1.25 3.934-3.108ZM213.299 2.17v10.024h2.132v-7.65l.901 2.041 3.017 5.61h2.685V2.168h-2.135v6.475l-.809-1.876-2.428-4.599h-3.363ZM199.728 2.17h-2.335v10.004h2.335V2.17ZM194.709 9.232c0-1.748-.939-2.576-3.55-3.146-1.453-.313-1.801-.644-1.801-1.104 0-.57.514-.827 1.47-.827 1.158 0 2.298.348 3.384.845V2.7c-.753-.387-1.931-.68-3.31-.68-2.592 0-3.936 1.123-3.936 2.981 0 1.471.682 2.65 3.364 3.164 1.6.33 1.931.588 1.931 1.122 0 .535-.331.845-1.471.845-1.305 0-2.867-.44-3.88-1.049v2.41c.809.405 1.875.846 3.862.846 2.832 0 3.937-1.25 3.937-3.108ZM159.166 2.17v10.024h4.798l.756-2.17h-3.201V2.168h-2.353ZM149.714 2.17v2.17h2.572v7.854h2.354V4.34h2.778V2.17h-7.704ZM144.768 8.699c-.441 0-.883-.074-1.288-.184l1.288-4.377 1.287 4.377c-.405.11-.845.184-1.287.184Zm1.544-6.529h-3.071l-3.493 10.005h2.666l.496-1.692a6.9 6.9 0 0 0 1.875.277 6.28 6.28 0 0 0 1.876-.277l.496 1.692h2.666L146.312 2.17ZM170.694 8.699c-.441 0-.883-.074-1.288-.184l1.288-4.377 1.287 4.377c-.422.11-.845.184-1.287.184Zm1.526-6.529h-3.071l-3.493 10.005h2.666l.496-1.692a6.902 6.902 0 0 0 1.876.277c.661 0 1.269-.091 1.875-.277l.496 1.692h2.666L172.22 2.17ZM206.587 8.699c-.44 0-.883-.074-1.288-.184l1.288-4.377 1.287 4.377c-.404.11-.827.184-1.287.184Zm1.544-6.529h-3.071l-3.493 10.005h2.666l.497-1.692a6.889 6.889 0 0 0 1.875.277c.661 0 1.269-.091 1.875-.277l.496 1.692h2.666L208.131 2.17Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: (0, $5ohHq.wacToken)("color.primary.black"),
                d: "M194.709 9.232c0-1.748-.919-2.576-3.55-3.146-1.453-.313-1.801-.644-1.801-1.104 0-.57.514-.827 1.47-.827 1.158 0 2.298.348 3.384.845V2.7a7.547 7.547 0 0 0-3.31-.68c-2.592 0-3.936 1.123-3.936 2.981 0 1.471.682 2.65 3.364 3.164 1.6.33 1.931.588 1.931 1.122 0 .535-.331.845-1.471.845a8.17 8.17 0 0 1-3.88-1.048v2.41c.809.404 1.875.845 3.862.845 2.814 0 3.916-1.25 3.937-3.108Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: (0, $5ohHq.wacToken)("color.neutral.light1000"),
                d: "M222.104 32.39v7.68h-2.254v-7.916c0-2.359-.944-3.408-3.093-3.408-2.097 0-3.539 1.39-3.539 4.037v7.287h-2.254V26.964h2.254v2.15c.839-1.547 2.385-2.412 4.142-2.412 3.014 0 4.744 2.07 4.744 5.688ZM202.158 40.332c-3.932 0-6.239-2.91-6.239-6.841 0-3.932 2.307-6.79 6.239-6.79 3.906 0 6.186 2.858 6.186 6.79s-2.28 6.841-6.186 6.841Zm0-11.533c-2.805 0-4.037 2.202-4.037 4.692s1.232 4.744 4.037 4.744c2.779 0 3.984-2.254 3.984-4.744 0-2.49-1.205-4.692-3.984-4.692ZM190.629 23.504c0-.996.655-1.573 1.573-1.573.917 0 1.572.577 1.572 1.573s-.655 1.573-1.572 1.573c-.918 0-1.573-.577-1.573-1.573Zm.419 16.566V26.964h2.255V40.07h-2.255ZM184.671 36.007c0 1.154.682 1.94 2.071 1.94.524 0 1.022-.105 1.416-.183v2.175c-.394.105-.839.21-1.521.21-2.805 0-4.168-1.651-4.168-4.09v-6.998h-2.123v-2.097h2.123v-2.778h2.202v2.778h3.487v2.097h-3.487v6.946ZM178.978 37.711v2.019c-.786.419-1.992.602-3.198.602-4.665 0-6.841-2.83-6.841-6.841 0-3.958 2.176-6.79 6.841-6.79 1.18 0 2.097.158 3.12.63v2.097c-.839-.393-1.73-.63-2.962-.63-3.408 0-4.797 2.15-4.797 4.693 0 2.543 1.415 4.692 4.849 4.692 1.337 0 2.176-.184 2.988-.472ZM161.274 28.747c-2.385 0-3.591 1.546-3.827 3.827h7.313c-.131-2.438-1.232-3.827-3.486-3.827Zm5.033 10.8c-1.075.576-2.726.785-4.063.785-4.902 0-7.051-2.83-7.051-6.841 0-3.958 2.202-6.79 6.186-6.79 4.037 0 5.662 2.806 5.662 6.79v1.022h-9.568c.315 2.228 1.757 3.67 4.85 3.67 1.52 0 2.804-.288 3.984-.708v2.071ZM153.938 40.044c-.183.053-.576.105-1.153.105-2.149 0-3.513-1.022-3.513-3.434v-15.23h2.255v14.968c0 1.18.786 1.599 1.756 1.599.236 0 .393 0 .655-.026v2.018ZM147.103 40.044c-.183.053-.576.105-1.153.105-2.149 0-3.512-1.022-3.512-3.434v-15.23h2.254v14.968c0 1.18.786 1.599 1.756 1.599.236 0 .393 0 .655-.026v2.018ZM133.632 40.332c-3.932 0-6.239-2.91-6.239-6.841 0-3.932 2.307-6.79 6.239-6.79 3.905 0 6.186 2.858 6.186 6.79s-2.281 6.841-6.186 6.841Zm0-11.533c-2.805 0-4.037 2.202-4.037 4.692s1.232 4.744 4.037 4.744c2.778 0 3.984-2.254 3.984-4.744 0-2.49-1.206-4.692-3.984-4.692ZM125.74 37.03v2.28c-1.075.708-2.779 1.022-4.561 1.022-5.662 0-8.86-3.407-8.86-8.833 0-5.243 3.198-8.913 8.807-8.913 1.678 0 3.355.315 4.587 1.206v2.28c-1.232-.786-2.595-1.205-4.587-1.205-4.036 0-6.448 2.674-6.448 6.632 0 3.958 2.49 6.58 6.579 6.58 1.809 0 3.224-.42 4.483-1.05Z"
            })
        ]
    });
const $9b5a68762b5c44f3$var$logoCss = null;

});

parcelRegister("6gPV0", function(module, exports) {
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("b68XW")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("c0qPQ")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("3ILx2")).useSelector; });
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $ddmnE = parcelRequire("ddmnE");

var $3mYuF = parcelRequire("3mYuF");
parcelRequire("3vnuu");
var $i5UxU = parcelRequire("i5UxU");

var $b8J6c = parcelRequire("b8J6c");

var $3ILx2 = parcelRequire("3ILx2");

var $aBAdc = parcelRequire("aBAdc");
parcelRequire("YglxP");
(0, $3ILx2.initializeUseSelector)((0, $3mYuF.useSyncExternalStoreWithSelector));
(0, $aBAdc.initializeConnect)((0, $ddmnE.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $b8J6c.setBatch)((0, $i5UxU.unstable_batchedUpdates));

});
parcelRegister("3mYuF", function(module, exports) {
"use strict";

module.exports = (parcelRequire("308f7"));

});
parcelRegister("308f7", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $22f7c404d928fa4e$export$bf730a2d8bf68b42; }, function (v) { return $22f7c404d928fa4e$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $22f7c404d928fa4e$export$bf730a2d8bf68b42;
"use strict";

var $iSvIT = parcelRequire("iSvIT");

var $ddmnE = parcelRequire("ddmnE");
function $22f7c404d928fa4e$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $22f7c404d928fa4e$var$q = "function" === typeof Object.is ? Object.is : $22f7c404d928fa4e$var$p, $22f7c404d928fa4e$var$r = $ddmnE.useSyncExternalStore, $22f7c404d928fa4e$var$t = $iSvIT.useRef, $22f7c404d928fa4e$var$u = $iSvIT.useEffect, $22f7c404d928fa4e$var$v = $iSvIT.useMemo, $22f7c404d928fa4e$var$w = $iSvIT.useDebugValue;
$22f7c404d928fa4e$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $22f7c404d928fa4e$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $22f7c404d928fa4e$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($22f7c404d928fa4e$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $22f7c404d928fa4e$var$r(a, c[0], c[1]);
    $22f7c404d928fa4e$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $22f7c404d928fa4e$var$w(d);
    return d;
};

});


parcelRegister("3vnuu", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", function () { return (parcelRequire("i5UxU")).unstable_batchedUpdates; });

var $i5UxU = parcelRequire("i5UxU");

});

parcelRegister("b8J6c", function(module, exports) {

$parcel$export(module.exports, "setBatch", function () { return $81c36cc8d2cc0403$export$4b9874722d0da7bc; });
$parcel$export(module.exports, "getBatch", function () { return $81c36cc8d2cc0403$export$fc47d4c0ba3bd2c6; });
// Default to a dummy "batch" implementation that just runs the callback
function $81c36cc8d2cc0403$var$defaultNoopBatch(callback) {
    callback();
}
let $81c36cc8d2cc0403$var$batch = $81c36cc8d2cc0403$var$defaultNoopBatch; // Allow injecting another batching function later
const $81c36cc8d2cc0403$export$4b9874722d0da7bc = (newBatch)=>$81c36cc8d2cc0403$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $81c36cc8d2cc0403$export$fc47d4c0ba3bd2c6 = ()=>$81c36cc8d2cc0403$var$batch;

});

parcelRegister("3ILx2", function(module, exports) {

$parcel$export(module.exports, "initializeUseSelector", function () { return $2b5a5a02b1e00ab8$export$e2e6e3f3f3b782e3; });
$parcel$export(module.exports, "useSelector", function () { return $2b5a5a02b1e00ab8$export$2105062e25df4afe; });

var $iSvIT = parcelRequire("iSvIT");

var $4oubS = parcelRequire("4oubS");

var $7qHTc = parcelRequire("7qHTc");

var $cqFSW = parcelRequire("cqFSW");
let $2b5a5a02b1e00ab8$var$useSyncExternalStoreWithSelector = (0, $cqFSW.notInitialized);
const $2b5a5a02b1e00ab8$export$e2e6e3f3f3b782e3 = (fn)=>{
    $2b5a5a02b1e00ab8$var$useSyncExternalStoreWithSelector = fn;
};
const $2b5a5a02b1e00ab8$var$refEquality = (a, b)=>a === b;
function $2b5a5a02b1e00ab8$export$2b53f90d2bd1cbfb(context = (0, $7qHTc.ReactReduxContext)) {
    const useReduxContext = context === (0, $7qHTc.ReactReduxContext) ? (0, $4oubS.useReduxContext) : (0, $4oubS.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $2b5a5a02b1e00ab8$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $iSvIT.useRef)(true);
        const wrappedSelector = (0, $iSvIT.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $2b5a5a02b1e00ab8$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $iSvIT.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $2b5a5a02b1e00ab8$export$2105062e25df4afe = /*#__PURE__*/ $2b5a5a02b1e00ab8$export$2b53f90d2bd1cbfb();

});
parcelRegister("4oubS", function(module, exports) {

$parcel$export(module.exports, "createReduxContextHook", function () { return $3330d285e220add5$export$d4d6226d5fc61558; });
$parcel$export(module.exports, "useReduxContext", function () { return $3330d285e220add5$export$c1275ca9a6fd3ec5; });

var $iSvIT = parcelRequire("iSvIT");

var $7qHTc = parcelRequire("7qHTc");
function $3330d285e220add5$export$d4d6226d5fc61558(context = (0, $7qHTc.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, $iSvIT.useContext)(context);
        return contextValue;
    };
}
const $3330d285e220add5$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $3330d285e220add5$export$d4d6226d5fc61558();

});
parcelRegister("7qHTc", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", function () { return $568d019eb32f3eda$export$cc80c08dc91f1c00; });

var $iSvIT = parcelRequire("iSvIT");
const $568d019eb32f3eda$var$ContextKey = Symbol.for(`react-redux-context`);
const $568d019eb32f3eda$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $568d019eb32f3eda$var$getContext() {
    var _gT$ContextKey;
    if (!$iSvIT.createContext) return {};
    const contextMap = (_gT$ContextKey = $568d019eb32f3eda$var$gT[$568d019eb32f3eda$var$ContextKey]) != null ? _gT$ContextKey : $568d019eb32f3eda$var$gT[$568d019eb32f3eda$var$ContextKey] = new Map();
    let realContext = contextMap.get($iSvIT.createContext);
    if (!realContext) {
        realContext = $iSvIT.createContext(null);
        contextMap.set($iSvIT.createContext, realContext);
    }
    return realContext;
}
const $568d019eb32f3eda$export$cc80c08dc91f1c00 = /*#__PURE__*/ $568d019eb32f3eda$var$getContext();
var $568d019eb32f3eda$export$2e2bcd8739ae039 = $568d019eb32f3eda$export$cc80c08dc91f1c00;

});


parcelRegister("cqFSW", function(module, exports) {

$parcel$export(module.exports, "notInitialized", function () { return $90c86743b7abf269$export$20656a4825650bd0; });
const $90c86743b7abf269$export$20656a4825650bd0 = ()=>{
    throw new Error("uSES not initialized!");
};

});


parcelRegister("aBAdc", function(module, exports) {

$parcel$export(module.exports, "initializeConnect", function () { return $7b89730221e93cf5$export$36d45daa6a4925b8; });

var $3EjNM = parcelRequire("3EjNM");

var $9wL9y = parcelRequire("9wL9y");

var $lgqAv = parcelRequire("lgqAv");

var $iSvIT = parcelRequire("iSvIT");

var $9SKjs = parcelRequire("9SKjs");

var $7D0rz = parcelRequire("7D0rz");

var $cS7l7 = parcelRequire("cS7l7");

var $8hgL1 = parcelRequire("8hgL1");

var $kvcYO = parcelRequire("kvcYO");

var $5lIpY = parcelRequire("5lIpY");

var $eBoaa = parcelRequire("eBoaa");

var $lPxlz = parcelRequire("lPxlz");
parcelRequire("fRQwu");

var $7qHTc = parcelRequire("7qHTc");

var $cqFSW = parcelRequire("cqFSW");
const $7b89730221e93cf5$var$_excluded = [
    "reactReduxForwardedRef"
];
let $7b89730221e93cf5$var$useSyncExternalStore = (0, $cqFSW.notInitialized);
const $7b89730221e93cf5$export$36d45daa6a4925b8 = (fn)=>{
    $7b89730221e93cf5$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $7b89730221e93cf5$var$EMPTY_ARRAY = [
    null,
    0
];
const $7b89730221e93cf5$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $7b89730221e93cf5$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $7b89730221e93cf5$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $eBoaa.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $7b89730221e93cf5$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $7b89730221e93cf5$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $7b89730221e93cf5$var$initStateUpdates = ()=>$7b89730221e93cf5$var$EMPTY_ARRAY;
function $7b89730221e93cf5$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $7b89730221e93cf5$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $7b89730221e93cf5$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $7b89730221e93cf5$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $lPxlz.default), areStatePropsEqual: areStatePropsEqual = (0, $lPxlz.default), areMergedPropsEqual: areMergedPropsEqual = (0, $lPxlz.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $7qHTc.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $8hgL1.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, $cS7l7.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, $kvcYO.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $iSvIT.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $9wL9y.default)(props, $7b89730221e93cf5$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $iSvIT.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $9SKjs.isContextConsumer)(/*#__PURE__*/ $iSvIT.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $iSvIT.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $iSvIT.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $7D0rz.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $iSvIT.useMemo(()=>{
                if (!shouldHandleStateChanges) return $7b89730221e93cf5$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $5lIpY.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $iSvIT.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $3EjNM.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $iSvIT.useRef();
            const lastWrapperProps = $iSvIT.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $iSvIT.useRef();
            const renderIsScheduled = $iSvIT.useRef(false);
            const isProcessingDispatch = $iSvIT.useRef(false);
            const isMounted = $iSvIT.useRef(false);
            const latestSubscriptionCallbackError = $iSvIT.useRef();
            (0, $eBoaa.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $iSvIT.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $iSvIT.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $7b89730221e93cf5$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $7b89730221e93cf5$var$useIsomorphicLayoutEffectWithArgs($7b89730221e93cf5$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $7b89730221e93cf5$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $eBoaa.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $iSvIT.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $iSvIT.createElement(WrappedComponent, (0, $3EjNM.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $iSvIT.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $iSvIT.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $iSvIT.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $iSvIT.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $iSvIT.createElement(Connect, (0, $3EjNM.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($lgqAv)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($lgqAv)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $7b89730221e93cf5$export$2e2bcd8739ae039 = $7b89730221e93cf5$var$connect;

});
parcelRegister("3EjNM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a8477c0fc9d827b$export$2e2bcd8739ae039; });
function $2a8477c0fc9d827b$export$2e2bcd8739ae039() {
    return $2a8477c0fc9d827b$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2a8477c0fc9d827b$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("9wL9y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6efbadd0a8df217b$export$2e2bcd8739ae039; });
function $6efbadd0a8df217b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("9SKjs", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1Edhg"));

});
parcelRegister("1Edhg", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $1333d37b3b91f23c$export$a7c73072b1a182ae; }, function (v) { return $1333d37b3b91f23c$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $1333d37b3b91f23c$export$9f27bc3417b4524d; }, function (v) { return $1333d37b3b91f23c$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $1333d37b3b91f23c$export$db77ccec0bb4ccac; }, function (v) { return $1333d37b3b91f23c$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $1333d37b3b91f23c$export$8392c0c9d3dcbd35; }, function (v) { return $1333d37b3b91f23c$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $1333d37b3b91f23c$export$ffb0004e005737fa; }, function (v) { return $1333d37b3b91f23c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $1333d37b3b91f23c$export$b624eff549462981; }, function (v) { return $1333d37b3b91f23c$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $1333d37b3b91f23c$export$7897aa7841a5380c; }, function (v) { return $1333d37b3b91f23c$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $1333d37b3b91f23c$export$602eac185826482c; }, function (v) { return $1333d37b3b91f23c$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $1333d37b3b91f23c$export$e2c29f18771995cb; }, function (v) { return $1333d37b3b91f23c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $1333d37b3b91f23c$export$5f8d39834fd61797; }, function (v) { return $1333d37b3b91f23c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $1333d37b3b91f23c$export$74bf444e3cd11ea5; }, function (v) { return $1333d37b3b91f23c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $1333d37b3b91f23c$export$998bcd577473dd93; }, function (v) { return $1333d37b3b91f23c$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $1333d37b3b91f23c$export$92387174baf9b227; }, function (v) { return $1333d37b3b91f23c$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $1333d37b3b91f23c$export$ec112efeb987d9c6; }, function (v) { return $1333d37b3b91f23c$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $1333d37b3b91f23c$export$b706b080d889d2c9; }, function (v) { return $1333d37b3b91f23c$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $1333d37b3b91f23c$export$5be5a87408f70ddc; }, function (v) { return $1333d37b3b91f23c$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $1333d37b3b91f23c$export$45a5e7f76e0caa8d; }, function (v) { return $1333d37b3b91f23c$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $1333d37b3b91f23c$export$455c2e768291efa6; }, function (v) { return $1333d37b3b91f23c$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $1333d37b3b91f23c$export$9522e17588c12572; }, function (v) { return $1333d37b3b91f23c$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $1333d37b3b91f23c$export$2110ac352bb060b9; }, function (v) { return $1333d37b3b91f23c$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $1333d37b3b91f23c$export$56885ab8b9c456ab; }, function (v) { return $1333d37b3b91f23c$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $1333d37b3b91f23c$export$d927fcb6adf8f9de; }, function (v) { return $1333d37b3b91f23c$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $1333d37b3b91f23c$export$b82d16f27459e05a; }, function (v) { return $1333d37b3b91f23c$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $1333d37b3b91f23c$export$522c17b4f5e123e8; }, function (v) { return $1333d37b3b91f23c$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $1333d37b3b91f23c$export$1aabd8a0274ecfd6; }, function (v) { return $1333d37b3b91f23c$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $1333d37b3b91f23c$export$3d6c20d97e46b957; }, function (v) { return $1333d37b3b91f23c$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $1333d37b3b91f23c$export$9b621391a187a31a; }, function (v) { return $1333d37b3b91f23c$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $1333d37b3b91f23c$export$f5bbd400c2f4426f; }, function (v) { return $1333d37b3b91f23c$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1333d37b3b91f23c$export$a7c73072b1a182ae;
var $1333d37b3b91f23c$export$9f27bc3417b4524d;
var $1333d37b3b91f23c$export$db77ccec0bb4ccac;
var $1333d37b3b91f23c$export$8392c0c9d3dcbd35;
var $1333d37b3b91f23c$export$ffb0004e005737fa;
var $1333d37b3b91f23c$export$b624eff549462981;
var $1333d37b3b91f23c$export$7897aa7841a5380c;
var $1333d37b3b91f23c$export$602eac185826482c;
var $1333d37b3b91f23c$export$e2c29f18771995cb;
var $1333d37b3b91f23c$export$5f8d39834fd61797;
var $1333d37b3b91f23c$export$74bf444e3cd11ea5;
var $1333d37b3b91f23c$export$998bcd577473dd93;
var $1333d37b3b91f23c$export$92387174baf9b227;
var $1333d37b3b91f23c$export$ec112efeb987d9c6;
var $1333d37b3b91f23c$export$b706b080d889d2c9;
var $1333d37b3b91f23c$export$5be5a87408f70ddc;
var $1333d37b3b91f23c$export$45a5e7f76e0caa8d;
var $1333d37b3b91f23c$export$455c2e768291efa6;
var $1333d37b3b91f23c$export$9522e17588c12572;
var $1333d37b3b91f23c$export$2110ac352bb060b9;
var $1333d37b3b91f23c$export$56885ab8b9c456ab;
var $1333d37b3b91f23c$export$d927fcb6adf8f9de;
var $1333d37b3b91f23c$export$b82d16f27459e05a;
var $1333d37b3b91f23c$export$522c17b4f5e123e8;
var $1333d37b3b91f23c$export$1aabd8a0274ecfd6;
var $1333d37b3b91f23c$export$3d6c20d97e46b957;
var $1333d37b3b91f23c$export$9b621391a187a31a;
var $1333d37b3b91f23c$export$f5bbd400c2f4426f;
"use strict";
var $1333d37b3b91f23c$var$b = Symbol.for("react.element"), $1333d37b3b91f23c$var$c = Symbol.for("react.portal"), $1333d37b3b91f23c$var$d = Symbol.for("react.fragment"), $1333d37b3b91f23c$var$e = Symbol.for("react.strict_mode"), $1333d37b3b91f23c$var$f = Symbol.for("react.profiler"), $1333d37b3b91f23c$var$g = Symbol.for("react.provider"), $1333d37b3b91f23c$var$h = Symbol.for("react.context"), $1333d37b3b91f23c$var$k = Symbol.for("react.server_context"), $1333d37b3b91f23c$var$l = Symbol.for("react.forward_ref"), $1333d37b3b91f23c$var$m = Symbol.for("react.suspense"), $1333d37b3b91f23c$var$n = Symbol.for("react.suspense_list"), $1333d37b3b91f23c$var$p = Symbol.for("react.memo"), $1333d37b3b91f23c$var$q = Symbol.for("react.lazy"), $1333d37b3b91f23c$var$t = Symbol.for("react.offscreen"), $1333d37b3b91f23c$var$u;
$1333d37b3b91f23c$var$u = Symbol.for("react.module.reference");
function $1333d37b3b91f23c$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $1333d37b3b91f23c$var$b:
                switch(a = a.type, a){
                    case $1333d37b3b91f23c$var$d:
                    case $1333d37b3b91f23c$var$f:
                    case $1333d37b3b91f23c$var$e:
                    case $1333d37b3b91f23c$var$m:
                    case $1333d37b3b91f23c$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $1333d37b3b91f23c$var$k:
                            case $1333d37b3b91f23c$var$h:
                            case $1333d37b3b91f23c$var$l:
                            case $1333d37b3b91f23c$var$q:
                            case $1333d37b3b91f23c$var$p:
                            case $1333d37b3b91f23c$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $1333d37b3b91f23c$var$c:
                return r;
        }
    }
}
$1333d37b3b91f23c$export$a7c73072b1a182ae = $1333d37b3b91f23c$var$h;
$1333d37b3b91f23c$export$9f27bc3417b4524d = $1333d37b3b91f23c$var$g;
$1333d37b3b91f23c$export$db77ccec0bb4ccac = $1333d37b3b91f23c$var$b;
$1333d37b3b91f23c$export$8392c0c9d3dcbd35 = $1333d37b3b91f23c$var$l;
$1333d37b3b91f23c$export$ffb0004e005737fa = $1333d37b3b91f23c$var$d;
$1333d37b3b91f23c$export$b624eff549462981 = $1333d37b3b91f23c$var$q;
$1333d37b3b91f23c$export$7897aa7841a5380c = $1333d37b3b91f23c$var$p;
$1333d37b3b91f23c$export$602eac185826482c = $1333d37b3b91f23c$var$c;
$1333d37b3b91f23c$export$e2c29f18771995cb = $1333d37b3b91f23c$var$f;
$1333d37b3b91f23c$export$5f8d39834fd61797 = $1333d37b3b91f23c$var$e;
$1333d37b3b91f23c$export$74bf444e3cd11ea5 = $1333d37b3b91f23c$var$m;
$1333d37b3b91f23c$export$998bcd577473dd93 = $1333d37b3b91f23c$var$n;
$1333d37b3b91f23c$export$92387174baf9b227 = function() {
    return !1;
};
$1333d37b3b91f23c$export$ec112efeb987d9c6 = function() {
    return !1;
};
$1333d37b3b91f23c$export$b706b080d889d2c9 = function(a) {
    return $1333d37b3b91f23c$var$v(a) === $1333d37b3b91f23c$var$h;
};
$1333d37b3b91f23c$export$5be5a87408f70ddc = function(a) {
    return $1333d37b3b91f23c$var$v(a) === $1333d37b3b91f23c$var$g;
};
$1333d37b3b91f23c$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1333d37b3b91f23c$var$b;
};
$1333d37b3b91f23c$export$455c2e768291efa6 = function(a) {
    return $1333d37b3b91f23c$var$v(a) === $1333d37b3b91f23c$var$l;
};
$1333d37b3b91f23c$export$9522e17588c12572 = function(a) {
    return $1333d37b3b91f23c$var$v(a) === $1333d37b3b91f23c$var$d;
};
$1333d37b3b91f23c$export$2110ac352bb060b9 = function(a) {
    return $1333d37b3b91f23c$var$v(a) === $1333d37b3b91f23c$var$q;
};
$1333d37b3b91f23c$export$56885ab8b9c456ab = function(a) {
    return $1333d37b3b91f23c$var$v(a) === $1333d37b3b91f23c$var$p;
};
$1333d37b3b91f23c$export$d927fcb6adf8f9de = function(a) {
    return $1333d37b3b91f23c$var$v(a) === $1333d37b3b91f23c$var$c;
};
$1333d37b3b91f23c$export$b82d16f27459e05a = function(a) {
    return $1333d37b3b91f23c$var$v(a) === $1333d37b3b91f23c$var$f;
};
$1333d37b3b91f23c$export$522c17b4f5e123e8 = function(a) {
    return $1333d37b3b91f23c$var$v(a) === $1333d37b3b91f23c$var$e;
};
$1333d37b3b91f23c$export$1aabd8a0274ecfd6 = function(a) {
    return $1333d37b3b91f23c$var$v(a) === $1333d37b3b91f23c$var$m;
};
$1333d37b3b91f23c$export$3d6c20d97e46b957 = function(a) {
    return $1333d37b3b91f23c$var$v(a) === $1333d37b3b91f23c$var$n;
};
$1333d37b3b91f23c$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $1333d37b3b91f23c$var$d || a === $1333d37b3b91f23c$var$f || a === $1333d37b3b91f23c$var$e || a === $1333d37b3b91f23c$var$m || a === $1333d37b3b91f23c$var$n || a === $1333d37b3b91f23c$var$t || "object" === typeof a && null !== a && (a.$$typeof === $1333d37b3b91f23c$var$q || a.$$typeof === $1333d37b3b91f23c$var$p || a.$$typeof === $1333d37b3b91f23c$var$g || a.$$typeof === $1333d37b3b91f23c$var$h || a.$$typeof === $1333d37b3b91f23c$var$l || a.$$typeof === $1333d37b3b91f23c$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$1333d37b3b91f23c$export$f5bbd400c2f4426f = $1333d37b3b91f23c$var$v;

});


parcelRegister("7D0rz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58dc8507f1cfb46c$export$2e2bcd8739ae039; });

var $9wL9y = parcelRequire("9wL9y");
parcelRequire("3Uic2");
const $58dc8507f1cfb46c$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $58dc8507f1cfb46c$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $58dc8507f1cfb46c$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $9wL9y.default)(_ref, $58dc8507f1cfb46c$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $58dc8507f1cfb46c$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("3Uic2", function(module, exports) {

var $fRQwu = parcelRequire("fRQwu");
function $2d84b6d9ce8e4568$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $fRQwu.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $2d84b6d9ce8e4568$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $2d84b6d9ce8e4568$var$verify(mapStateToProps, "mapStateToProps");
    $2d84b6d9ce8e4568$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $2d84b6d9ce8e4568$var$verify(mergeProps, "mergeProps");
}

});
parcelRegister("fRQwu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8d48c3c2ed5cef8$export$2e2bcd8739ae039; });
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $b8d48c3c2ed5cef8$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRegister("cS7l7", function(module, exports) {

$parcel$export(module.exports, "mapDispatchToPropsFactory", function () { return $95f038ab66955d76$export$b69a785ceac019a6; });

var $9J9DP = parcelRequire("9J9DP");

var $6lJSu = parcelRequire("6lJSu");

var $IruOX = parcelRequire("IruOX");
function $95f038ab66955d76$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $6lJSu.wrapMapToPropsConstant)((dispatch)=>(0, $9J9DP.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $6lJSu.wrapMapToPropsConstant)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? (0, $6lJSu.wrapMapToPropsFunc)(mapDispatchToProps, "mapDispatchToProps") : (0, $IruOX.createInvalidArgFactory)(mapDispatchToProps, "mapDispatchToProps");
}

});
parcelRegister("9J9DP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $714fcb9e2a83a098$export$2e2bcd8739ae039; });
function $714fcb9e2a83a098$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

});

parcelRegister("6lJSu", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", function () { return $49f84aa28bebd066$export$710f7c60f68acd3e; });
$parcel$export(module.exports, "wrapMapToPropsFunc", function () { return $49f84aa28bebd066$export$8d46c7f53c8c602f; });
parcelRequire("4Xiz8");
function $49f84aa28bebd066$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $49f84aa28bebd066$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $49f84aa28bebd066$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $49f84aa28bebd066$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $49f84aa28bebd066$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("4Xiz8", function(module, exports) {

var $22kT4 = parcelRequire("22kT4");

var $fRQwu = parcelRequire("fRQwu");
function $39bb12e1de06c15e$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $22kT4.default)(value)) (0, $fRQwu.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

});
parcelRegister("22kT4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17bbf87682034605$export$2e2bcd8739ae039; });
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $17bbf87682034605$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRegister("IruOX", function(module, exports) {

$parcel$export(module.exports, "createInvalidArgFactory", function () { return $085970547cb773d9$export$19ef7b929f7e2559; });
function $085970547cb773d9$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

});


parcelRegister("8hgL1", function(module, exports) {

$parcel$export(module.exports, "mapStateToPropsFactory", function () { return $606ce8eeba8be3eb$export$e00e93951827eda7; });

var $6lJSu = parcelRequire("6lJSu");

var $IruOX = parcelRequire("IruOX");
function $606ce8eeba8be3eb$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $6lJSu.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === "function" ? (0, $6lJSu.wrapMapToPropsFunc)(mapStateToProps, "mapStateToProps") : (0, $IruOX.createInvalidArgFactory)(mapStateToProps, "mapStateToProps");
}

});

parcelRegister("kvcYO", function(module, exports) {

$parcel$export(module.exports, "mergePropsFactory", function () { return $eed0c5711fe001cb$export$17457cf6fa742f84; });

var $3EjNM = parcelRequire("3EjNM");
parcelRequire("4Xiz8");

var $IruOX = parcelRequire("IruOX");
function $eed0c5711fe001cb$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $3EjNM.default)({}, ownProps, stateProps, dispatchProps);
}
function $eed0c5711fe001cb$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $eed0c5711fe001cb$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$eed0c5711fe001cb$export$691c327fc30bc857 : typeof mergeProps === "function" ? $eed0c5711fe001cb$export$5b105939c84b5234(mergeProps) : (0, $IruOX.createInvalidArgFactory)(mergeProps, "mergeProps");
}

});

parcelRegister("5lIpY", function(module, exports) {

$parcel$export(module.exports, "createSubscription", function () { return $3e515e60ffaaca61$export$d567d2b9af322f8f; });

var $b8J6c = parcelRequire("b8J6c");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $3e515e60ffaaca61$var$createListenerCollection() {
    const batch = (0, $b8J6c.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $3e515e60ffaaca61$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $3e515e60ffaaca61$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $3e515e60ffaaca61$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $3e515e60ffaaca61$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $3e515e60ffaaca61$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}

});

parcelRegister("eBoaa", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $aa1743a21f0d9c98$export$700979bc83e7db82; });

var $iSvIT = parcelRequire("iSvIT");
const $aa1743a21f0d9c98$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $aa1743a21f0d9c98$export$700979bc83e7db82 = $aa1743a21f0d9c98$export$71594e8a50f746f4 ? $iSvIT.useLayoutEffect : $iSvIT.useEffect;

});

parcelRegister("lPxlz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe483a6683e31b8f$export$2e2bcd8739ae039; });
function $fe483a6683e31b8f$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $fe483a6683e31b8f$export$2e2bcd8739ae039(objA, objB) {
    if ($fe483a6683e31b8f$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$fe483a6683e31b8f$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRegister("YglxP", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return (parcelRequire("b68XW")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("c0qPQ")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("3ILx2")).useSelector; });

var $b68XW = parcelRequire("b68XW");

var $aBAdc = parcelRequire("aBAdc");

var $7qHTc = parcelRequire("7qHTc");

var $c0qPQ = parcelRequire("c0qPQ");

var $3ILx2 = parcelRequire("3ILx2");

var $9nu81 = parcelRequire("9nu81");

var $lPxlz = parcelRequire("lPxlz");
parcelRequire("5UvfB");

});
parcelRegister("b68XW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $814735aa10c9e3eb$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $7qHTc = parcelRequire("7qHTc");

var $5lIpY = parcelRequire("5lIpY");

var $eBoaa = parcelRequire("eBoaa");
function $814735aa10c9e3eb$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", noopCheck: noopCheck = "once" }) {
    const contextValue = $iSvIT.useMemo(()=>{
        const subscription = (0, $5lIpY.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $iSvIT.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $eBoaa.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $7qHTc.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $iSvIT.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $814735aa10c9e3eb$export$2e2bcd8739ae039 = $814735aa10c9e3eb$var$Provider;

});

parcelRegister("c0qPQ", function(module, exports) {

$parcel$export(module.exports, "useDispatch", function () { return $8bda4d0530ce0927$export$8ad76b76a4c905f8; });

var $7qHTc = parcelRequire("7qHTc");

var $9nu81 = parcelRequire("9nu81");
function $8bda4d0530ce0927$export$bc9b55530897c558(context = (0, $7qHTc.ReactReduxContext)) {
    const useStore = context === (0, $7qHTc.ReactReduxContext) ? (0, $9nu81.useStore) : (0, $9nu81.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $8bda4d0530ce0927$export$8ad76b76a4c905f8 = /*#__PURE__*/ $8bda4d0530ce0927$export$bc9b55530897c558();

});
parcelRegister("9nu81", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", function () { return $6d3da1ea5bbd42eb$export$671dba69185d0304; });
$parcel$export(module.exports, "useStore", function () { return $6d3da1ea5bbd42eb$export$6ccbb43953eebf8; });

var $7qHTc = parcelRequire("7qHTc");

var $4oubS = parcelRequire("4oubS");
function $6d3da1ea5bbd42eb$export$671dba69185d0304(context = (0, $7qHTc.ReactReduxContext)) {
    const useReduxContext = context === (0, $7qHTc.ReactReduxContext) ? (0, $4oubS.useReduxContext) : (0, $4oubS.createReduxContextHook)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $6d3da1ea5bbd42eb$export$6ccbb43953eebf8 = /*#__PURE__*/ $6d3da1ea5bbd42eb$export$671dba69185d0304();

});


parcelRegister("5UvfB", function(module, exports) {

});



parcelRegister("ae9Z5", function(module, exports) {

$parcel$export(module.exports, "ConsentHubClientConfigProvider", function () { return $884ddbc337da1280$export$4f1d572ab3f4c2e6; });
$parcel$export(module.exports, "useConsentHubClientConfig", function () { return $884ddbc337da1280$export$ef2475d0eafefa1b; });
//@ts-nocheck

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $gkhN4 = parcelRequire("gkhN4");
const $884ddbc337da1280$var$requiredProps = [
    "email",
    "site",
    "locale",
    "formUrl"
];
const $884ddbc337da1280$var$defaultLocaleConfig = {
    locale: "UNKNOWN",
    localeRequiresMarketingCommunicationOptIn: true
};
const $884ddbc337da1280$export$ff156a5e09be2a6a = async (stargateClient)=>{
    return await stargateClient.getConsentConfig().then((response)=>response, (err)=>{
        return $884ddbc337da1280$var$defaultLocaleConfig;
    });
};
const $884ddbc337da1280$export$7bb3e177c1a1e841 = async (stargateClient, params, localeConfig)=>{
    const paramsLocale = params.paramsLocale ? params.paramsLocale : "UNKNOWN";
    const postData = (0, $7Knp0._)({
        locale: localeConfig.locale || paramsLocale
    }, params);
    if (!$884ddbc337da1280$var$requiredProps.every((prop)=>postData.hasOwnProperty(prop))) throw `Invalid parameters. Required: {${$884ddbc337da1280$var$requiredProps.toString()}}`;
    const updateConsentPreferencesResponseStatus = await stargateClient.updateConsentPreferences(postData);
    return updateConsentPreferencesResponseStatus;
};
const $884ddbc337da1280$var$useGetConsentConfig = ()=>{
    const stargateClient = (0, $gkhN4.useBxpWebStargateClient)();
    const [localeConfig, setLocaleConfig] = (0, $iSvIT.useState)($884ddbc337da1280$var$defaultLocaleConfig);
    (0, $iSvIT.useEffect)(()=>{
        const fetchConfigData = async ()=>{
            const consentHubConfig = await $884ddbc337da1280$export$ff156a5e09be2a6a(stargateClient);
            if (consentHubConfig) setLocaleConfig(consentHubConfig);
        };
        fetchConfigData().catch((err)=>console.log(err));
    }, [
        stargateClient
    ]);
    return [
        localeConfig
    ];
};
const $884ddbc337da1280$export$6ccd5662e539f2b6 = /*#__PURE__*/ (0, $iSvIT.createContext)($884ddbc337da1280$var$defaultLocaleConfig);
const $884ddbc337da1280$export$4f1d572ab3f4c2e6 = ({ children: children })=>{
    const [localeConfig] = $884ddbc337da1280$var$useGetConsentConfig();
    return /*#__PURE__*/ (0, $loA2J.jsx)($884ddbc337da1280$export$6ccd5662e539f2b6.Provider, {
        value: localeConfig,
        children: children
    });
};
const $884ddbc337da1280$export$ef2475d0eafefa1b = ()=>{
    const context = (0, $iSvIT.useContext)($884ddbc337da1280$export$6ccd5662e539f2b6);
    if (!context) throw new Error("useConsentHubClientConfig must be used within a ConsentHubClientConfigProvider");
    return context;
};

});

parcelRegister("bLzLw", function(module, exports) {

var $2aVf0 = parcelRequire("2aVf0");

var $gIMmF = parcelRequire("gIMmF");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $890fd3c0536b9814$var$merge = $gIMmF(function(object, source, srcIndex) {
    $2aVf0(object, source, srcIndex);
});
module.exports = $890fd3c0536b9814$var$merge;

});
parcelRegister("2aVf0", function(module, exports) {

var $bcztx = parcelRequire("bcztx");

var $3vSbX = parcelRequire("3vSbX");

var $8M3Aw = parcelRequire("8M3Aw");

var $ie7zk = parcelRequire("ie7zk");

var $7jN5Q = parcelRequire("7jN5Q");

var $kiLG8 = parcelRequire("kiLG8");

var $iBro3 = parcelRequire("iBro3");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $1958eacfb323c1ef$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $8M3Aw(source, function(srcValue, key) {
        stack || (stack = new $bcztx);
        if ($7jN5Q(srcValue)) $ie7zk(object, source, key, srcIndex, $1958eacfb323c1ef$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($iBro3(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $3vSbX(object, key, newValue);
        }
    }, $kiLG8);
}
module.exports = $1958eacfb323c1ef$var$baseMerge;

});
parcelRegister("3vSbX", function(module, exports) {

var $gu9fB = parcelRequire("gu9fB");

var $94z4y = parcelRequire("94z4y");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $28ee4dbcc4df35a6$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$94z4y(object[key], value) || value === undefined && !(key in object)) $gu9fB(object, key, value);
}
module.exports = $28ee4dbcc4df35a6$var$assignMergeValue;

});

parcelRegister("8M3Aw", function(module, exports) {

var $ijMvD = parcelRequire("ijMvD");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $663596ecb9bc8c97$var$baseFor = $ijMvD();
module.exports = $663596ecb9bc8c97$var$baseFor;

});
parcelRegister("ijMvD", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $d55fa14685f1a849$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $d55fa14685f1a849$var$createBaseFor;

});


parcelRegister("ie7zk", function(module, exports) {

var $3vSbX = parcelRequire("3vSbX");

var $ekHfp = parcelRequire("ekHfp");

var $gFMRp = parcelRequire("gFMRp");

var $c7nuc = parcelRequire("c7nuc");

var $2gQfZ = parcelRequire("2gQfZ");

var $ehCT3 = parcelRequire("ehCT3");

var $epu4p = parcelRequire("epu4p");

var $jHxb6 = parcelRequire("jHxb6");

var $jageE = parcelRequire("jageE");

var $6PxfT = parcelRequire("6PxfT");

var $7jN5Q = parcelRequire("7jN5Q");

var $5eRI9 = parcelRequire("5eRI9");

var $03pXg = parcelRequire("03pXg");

var $iBro3 = parcelRequire("iBro3");

var $kIslt = parcelRequire("kIslt");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $d44f67d2c0f149ff$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $iBro3(object, key), srcValue = $iBro3(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $3vSbX(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $epu4p(srcValue), isBuff = !isArr && $jageE(srcValue), isTyped = !isArr && !isBuff && $03pXg(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($epu4p(objValue)) newValue = objValue;
            else if ($jHxb6(objValue)) newValue = $c7nuc(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $ekHfp(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $gFMRp(srcValue, true);
            } else newValue = [];
        } else if ($5eRI9(srcValue) || $ehCT3(srcValue)) {
            newValue = objValue;
            if ($ehCT3(objValue)) newValue = $kIslt(objValue);
            else if (!$7jN5Q(objValue) || $6PxfT(objValue)) newValue = $2gQfZ(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    $3vSbX(object, key, newValue);
}
module.exports = $d44f67d2c0f149ff$var$baseMergeDeep;

});
parcelRegister("ekHfp", function(module, exports) {

var $fbsQc = parcelRequire("fbsQc");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $fbsQc.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("gFMRp", function(module, exports) {

var $bJUVy = parcelRequire("bJUVy");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $c2366051d0d94979$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $bJUVy(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $c2366051d0d94979$var$cloneTypedArray;

});
parcelRegister("bJUVy", function(module, exports) {

var $2et7A = parcelRequire("2et7A");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $88c00e3d120aa9fa$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $2et7A(result).set(new $2et7A(arrayBuffer));
    return result;
}
module.exports = $88c00e3d120aa9fa$var$cloneArrayBuffer;

});


parcelRegister("2gQfZ", function(module, exports) {

var $46FN9 = parcelRequire("46FN9");

var $i0aei = parcelRequire("i0aei");

var $5wN9z = parcelRequire("5wN9z");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $1a759c80316d623d$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$5wN9z(object) ? $46FN9($i0aei(object)) : {};
}
module.exports = $1a759c80316d623d$var$initCloneObject;

});
parcelRegister("46FN9", function(module, exports) {

var $7jN5Q = parcelRequire("7jN5Q");
/** Built-in value references. */ var $2fd823ebdf752945$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $2fd823ebdf752945$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$7jN5Q(proto)) return {};
        if ($2fd823ebdf752945$var$objectCreate) return $2fd823ebdf752945$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $2fd823ebdf752945$var$baseCreate;

});

parcelRegister("i0aei", function(module, exports) {

var $a7ALC = parcelRequire("a7ALC");
/** Built-in value references. */ var $d1b02978e2299c10$var$getPrototype = $a7ALC(Object.getPrototypeOf, Object);
module.exports = $d1b02978e2299c10$var$getPrototype;

});


parcelRegister("jHxb6", function(module, exports) {

var $h1PEc = parcelRequire("h1PEc");

var $8VKar = parcelRequire("8VKar");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $e57bc4f8f2a15df5$var$isArrayLikeObject(value) {
    return $8VKar(value) && $h1PEc(value);
}
module.exports = $e57bc4f8f2a15df5$var$isArrayLikeObject;

});

parcelRegister("5eRI9", function(module, exports) {

var $Yvcvv = parcelRequire("Yvcvv");

var $i0aei = parcelRequire("i0aei");

var $8VKar = parcelRequire("8VKar");
/** `Object#toString` result references. */ var $3d07ec73908a9211$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $3d07ec73908a9211$var$funcProto = Function.prototype, $3d07ec73908a9211$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $3d07ec73908a9211$var$funcToString = $3d07ec73908a9211$var$funcProto.toString;
/** Used to check objects for own properties. */ var $3d07ec73908a9211$var$hasOwnProperty = $3d07ec73908a9211$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $3d07ec73908a9211$var$objectCtorString = $3d07ec73908a9211$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $3d07ec73908a9211$var$isPlainObject(value) {
    if (!$8VKar(value) || $Yvcvv(value) != $3d07ec73908a9211$var$objectTag) return false;
    var proto = $i0aei(value);
    if (proto === null) return true;
    var Ctor = $3d07ec73908a9211$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $3d07ec73908a9211$var$funcToString.call(Ctor) == $3d07ec73908a9211$var$objectCtorString;
}
module.exports = $3d07ec73908a9211$var$isPlainObject;

});

parcelRegister("iBro3", function(module, exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d8b0ed2e12e79f74$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
module.exports = $d8b0ed2e12e79f74$var$safeGet;

});

parcelRegister("kIslt", function(module, exports) {

var $3KWOe = parcelRequire("3KWOe");

var $kiLG8 = parcelRequire("kiLG8");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $f14de77cfbb51d2c$var$toPlainObject(value) {
    return $3KWOe(value, $kiLG8(value));
}
module.exports = $f14de77cfbb51d2c$var$toPlainObject;

});
parcelRegister("3KWOe", function(module, exports) {

var $YhKXQ = parcelRequire("YhKXQ");

var $gu9fB = parcelRequire("gu9fB");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $2bc3493bdbc1fb53$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $gu9fB(object, key, newValue);
        else $YhKXQ(object, key, newValue);
    }
    return object;
}
module.exports = $2bc3493bdbc1fb53$var$copyObject;

});

parcelRegister("kiLG8", function(module, exports) {

var $6tgvt = parcelRequire("6tgvt");

var $afOP0 = parcelRequire("afOP0");

var $h1PEc = parcelRequire("h1PEc");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $ec7a790fcabbc4b9$var$keysIn(object) {
    return $h1PEc(object) ? $6tgvt(object, true) : $afOP0(object);
}
module.exports = $ec7a790fcabbc4b9$var$keysIn;

});
parcelRegister("afOP0", function(module, exports) {

var $7jN5Q = parcelRequire("7jN5Q");

var $5wN9z = parcelRequire("5wN9z");

var $aZQUW = parcelRequire("aZQUW");
/** Used for built-in method references. */ var $7772ba3e7660e7e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7772ba3e7660e7e8$var$hasOwnProperty = $7772ba3e7660e7e8$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $7772ba3e7660e7e8$var$baseKeysIn(object) {
    if (!$7jN5Q(object)) return $aZQUW(object);
    var isProto = $5wN9z(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$7772ba3e7660e7e8$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $7772ba3e7660e7e8$var$baseKeysIn;

});
parcelRegister("aZQUW", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $8018a62d03f6675e$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $8018a62d03f6675e$var$nativeKeysIn;

});






parcelRegister("gIMmF", function(module, exports) {

var $ioRXk = parcelRequire("ioRXk");

var $jTUDv = parcelRequire("jTUDv");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $c2c6459b33137c84$var$createAssigner(assigner) {
    return $ioRXk(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && $jTUDv(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $c2c6459b33137c84$var$createAssigner;

});
parcelRegister("ioRXk", function(module, exports) {

var $x6s15 = parcelRequire("x6s15");

var $5HpUv = parcelRequire("5HpUv");

var $f1TI9 = parcelRequire("f1TI9");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $d654526572a8e7b9$var$baseRest(func, start) {
    return $f1TI9($5HpUv(func, start, $x6s15), func + "");
}
module.exports = $d654526572a8e7b9$var$baseRest;

});
parcelRegister("x6s15", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $06381631277c7316$var$identity(value) {
    return value;
}
module.exports = $06381631277c7316$var$identity;

});

parcelRegister("5HpUv", function(module, exports) {

var $hCdfF = parcelRequire("hCdfF");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $426511273a82686d$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $426511273a82686d$var$overRest(func, start, transform) {
    start = $426511273a82686d$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $426511273a82686d$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $hCdfF(func, this, otherArgs);
    };
}
module.exports = $426511273a82686d$var$overRest;

});
parcelRegister("hCdfF", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $034f3ae648360a2b$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $034f3ae648360a2b$var$apply;

});


parcelRegister("f1TI9", function(module, exports) {

var $2PrXb = parcelRequire("2PrXb");

var $kKBfb = parcelRequire("kKBfb");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $af122a0e7b9ce9a2$var$setToString = $kKBfb($2PrXb);
module.exports = $af122a0e7b9ce9a2$var$setToString;

});
parcelRegister("2PrXb", function(module, exports) {

var $dup7e = parcelRequire("dup7e");

var $8MZy8 = parcelRequire("8MZy8");

var $x6s15 = parcelRequire("x6s15");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $20f6072abb29c3e0$var$baseSetToString = !$8MZy8 ? $x6s15 : function(func, string) {
    return $8MZy8(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $dup7e(string),
        "writable": true
    });
};
module.exports = $20f6072abb29c3e0$var$baseSetToString;

});
parcelRegister("dup7e", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $9d218f2b856aab6a$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $9d218f2b856aab6a$var$constant;

});


parcelRegister("kKBfb", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $f1b4fe692f887520$var$HOT_COUNT = 800, $f1b4fe692f887520$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f1b4fe692f887520$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $f1b4fe692f887520$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $f1b4fe692f887520$var$nativeNow(), remaining = $f1b4fe692f887520$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $f1b4fe692f887520$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $f1b4fe692f887520$var$shortOut;

});



parcelRegister("jTUDv", function(module, exports) {

var $94z4y = parcelRequire("94z4y");

var $h1PEc = parcelRequire("h1PEc");

var $8nTnJ = parcelRequire("8nTnJ");

var $7jN5Q = parcelRequire("7jN5Q");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $e7cf16227c3c7197$var$isIterateeCall(value, index, object) {
    if (!$7jN5Q(object)) return false;
    var type = typeof index;
    if (type == "number" ? $h1PEc(object) && $8nTnJ(index, object.length) : type == "string" && index in object) return $94z4y(object[index], value);
    return false;
}
module.exports = $e7cf16227c3c7197$var$isIterateeCall;

});



parcelRegister("axa0S", function(module, exports) {

var $8M3Aw = parcelRequire("8M3Aw");

var $ldH3d = parcelRequire("ldH3d");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $7ab4c0df4c807d33$var$baseForOwn(object, iteratee) {
    return object && $8M3Aw(object, iteratee, $ldH3d);
}
module.exports = $7ab4c0df4c807d33$var$baseForOwn;

});

parcelRegister("4GkEf", function(module, exports) {

var $QTxMi = parcelRequire("QTxMi");

var $14e6U = parcelRequire("14e6U");

var $x6s15 = parcelRequire("x6s15");

var $epu4p = parcelRequire("epu4p");

var $aVvcN = parcelRequire("aVvcN");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $368b19f0d36bec3f$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $x6s15;
    if (typeof value == "object") return $epu4p(value) ? $14e6U(value[0], value[1]) : $QTxMi(value);
    return $aVvcN(value);
}
module.exports = $368b19f0d36bec3f$var$baseIteratee;

});
parcelRegister("QTxMi", function(module, exports) {

var $c9HdH = parcelRequire("c9HdH");

var $fheCJ = parcelRequire("fheCJ");

var $5u6ws = parcelRequire("5u6ws");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $09eff1493f8b7b22$var$baseMatches(source) {
    var matchData = $fheCJ(source);
    if (matchData.length == 1 && matchData[0][2]) return $5u6ws(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $c9HdH(object, source, matchData);
    };
}
module.exports = $09eff1493f8b7b22$var$baseMatches;

});
parcelRegister("5u6ws", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $3fe4d052564c1bbf$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $3fe4d052564c1bbf$var$matchesStrictComparable;

});


parcelRegister("14e6U", function(module, exports) {

var $5JKmU = parcelRequire("5JKmU");

var $3jjVc = parcelRequire("3jjVc");

var $xvkn9 = parcelRequire("xvkn9");

var $17d0P = parcelRequire("17d0P");

var $hmbWe = parcelRequire("hmbWe");

var $5u6ws = parcelRequire("5u6ws");

var $258Tb = parcelRequire("258Tb");
/** Used to compose bitmasks for value comparisons. */ var $0c711c3203d958e1$var$COMPARE_PARTIAL_FLAG = 1, $0c711c3203d958e1$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $0c711c3203d958e1$var$baseMatchesProperty(path, srcValue) {
    if ($17d0P(path) && $hmbWe(srcValue)) return $5u6ws($258Tb(path), srcValue);
    return function(object) {
        var objValue = $3jjVc(object, path);
        return objValue === undefined && objValue === srcValue ? $xvkn9(object, path) : $5JKmU(srcValue, objValue, $0c711c3203d958e1$var$COMPARE_PARTIAL_FLAG | $0c711c3203d958e1$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $0c711c3203d958e1$var$baseMatchesProperty;

});
parcelRegister("3jjVc", function(module, exports) {

var $GDW72 = parcelRequire("GDW72");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $269299758f3ab5b3$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $GDW72(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $269299758f3ab5b3$var$get;

});
parcelRegister("GDW72", function(module, exports) {

var $aDJNh = parcelRequire("aDJNh");

var $258Tb = parcelRequire("258Tb");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $0802e6e01dab324b$var$baseGet(object, path) {
    path = $aDJNh(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$258Tb(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $0802e6e01dab324b$var$baseGet;

});


parcelRegister("xvkn9", function(module, exports) {

var $b6ep5 = parcelRequire("b6ep5");

var $kopxZ = parcelRequire("kopxZ");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $064b62301e2aec18$var$hasIn(object, path) {
    return object != null && $kopxZ(object, path, $b6ep5);
}
module.exports = $064b62301e2aec18$var$hasIn;

});
parcelRegister("b6ep5", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $814b6d87713616e0$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $814b6d87713616e0$var$baseHasIn;

});

parcelRegister("kopxZ", function(module, exports) {

var $aDJNh = parcelRequire("aDJNh");

var $ehCT3 = parcelRequire("ehCT3");

var $epu4p = parcelRequire("epu4p");

var $8nTnJ = parcelRequire("8nTnJ");

var $70oDt = parcelRequire("70oDt");

var $258Tb = parcelRequire("258Tb");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $ed89ddb066c86bb7$var$hasPath(object, path, hasFunc) {
    path = $aDJNh(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $258Tb(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $70oDt(length) && $8nTnJ(key, length) && ($epu4p(object) || $ehCT3(object));
}
module.exports = $ed89ddb066c86bb7$var$hasPath;

});



parcelRegister("aVvcN", function(module, exports) {

var $2Yxy8 = parcelRequire("2Yxy8");

var $l2Oot = parcelRequire("l2Oot");

var $17d0P = parcelRequire("17d0P");

var $258Tb = parcelRequire("258Tb");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $7f476f0185e23570$var$property(path) {
    return $17d0P(path) ? $2Yxy8($258Tb(path)) : $l2Oot(path);
}
module.exports = $7f476f0185e23570$var$property;

});
parcelRegister("2Yxy8", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $22ab359b590e5316$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $22ab359b590e5316$var$baseProperty;

});

parcelRegister("l2Oot", function(module, exports) {

var $GDW72 = parcelRequire("GDW72");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $f520e00563e167cd$var$basePropertyDeep(path) {
    return function(object) {
        return $GDW72(object, path);
    };
}
module.exports = $f520e00563e167cd$var$basePropertyDeep;

});



parcelRegister("4m2lj", function(module, exports) {
$parcel$export(module.exports, "applyMiddleware", function () { return (parcelRequire("5MIX0")).applyMiddleware; });
$parcel$export(module.exports, "combineReducers", function () { return (parcelRequire("5MIX0")).combineReducers; });
$parcel$export(module.exports, "compose", function () { return (parcelRequire("5MIX0")).compose; });
$parcel$export(module.exports, "createStore", function () { return (parcelRequire("5MIX0")).createStore; });

$parcel$export(module.exports, "createAction", function () { return $32bb08b9118b2714$export$309c7a02b0b0bc62; });
$parcel$export(module.exports, "configureStore", function () { return $32bb08b9118b2714$export$7d8a5b498da695ac; });
$parcel$export(module.exports, "createReducer", function () { return $32bb08b9118b2714$export$473eb76d322d0290; });
$parcel$export(module.exports, "createSlice", function () { return $32bb08b9118b2714$export$4d8d9bd83c24ae8b; });
$parcel$export(module.exports, "createAsyncThunk", function () { return $32bb08b9118b2714$export$6abd22dc03e5063f; });

var $6cEEF = parcelRequire("6cEEF");

var $5MIX0 = parcelRequire("5MIX0");

var $4Tcuq = parcelRequire("4Tcuq");

var $ldL10 = parcelRequire("ldL10");

var $XAEGR = parcelRequire("XAEGR");
var $32bb08b9118b2714$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $32bb08b9118b2714$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $32bb08b9118b2714$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $32bb08b9118b2714$var$__defProp = Object.defineProperty;
var $32bb08b9118b2714$var$__defProps = Object.defineProperties;
var $32bb08b9118b2714$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $32bb08b9118b2714$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $32bb08b9118b2714$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $32bb08b9118b2714$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $32bb08b9118b2714$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $32bb08b9118b2714$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $32bb08b9118b2714$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($32bb08b9118b2714$var$__hasOwnProp.call(b, prop)) $32bb08b9118b2714$var$__defNormalProp(a, prop, b[prop]);
    if ($32bb08b9118b2714$var$__getOwnPropSymbols) for(var _i = 0, _c = $32bb08b9118b2714$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($32bb08b9118b2714$var$__propIsEnum.call(b, prop)) $32bb08b9118b2714$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $32bb08b9118b2714$var$__spreadProps = function(a, b) {
    return $32bb08b9118b2714$var$__defProps(a, $32bb08b9118b2714$var$__getOwnPropDescs(b));
};
var $32bb08b9118b2714$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $32bb08b9118b2714$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $4Tcuq.createSelector).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $32bb08b9118b2714$var$__spreadArray([
            (0, $6cEEF.isDraft)(value) ? (0, $6cEEF.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $32bb08b9118b2714$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $5MIX0.compose;
    return (0, $5MIX0.compose).apply(null, arguments);
};
var $32bb08b9118b2714$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $32bb08b9118b2714$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $32bb08b9118b2714$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $32bb08b9118b2714$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $32bb08b9118b2714$var$__spreadValues($32bb08b9118b2714$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $32bb08b9118b2714$export$b956e38827fca970(action) {
    return $32bb08b9118b2714$export$53b83ca8eaab0383(action) && "type" in action;
}
function $32bb08b9118b2714$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $32bb08b9118b2714$var$hasMatchFunction(action);
}
function $32bb08b9118b2714$export$ebd532f9034651f3(action) {
    return $32bb08b9118b2714$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($32bb08b9118b2714$var$isValidKey);
}
function $32bb08b9118b2714$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $32bb08b9118b2714$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $32bb08b9118b2714$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "' + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $32bb08b9118b2714$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $32bb08b9118b2714$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $32bb08b9118b2714$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $32bb08b9118b2714$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $32bb08b9118b2714$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $32bb08b9118b2714$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $32bb08b9118b2714$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $32bb08b9118b2714$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $32bb08b9118b2714$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $32bb08b9118b2714$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $32bb08b9118b2714$var$freezeDraftable(val) {
    return (0, $6cEEF.isDraftable)(val) ? (0, $6cEEF.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $32bb08b9118b2714$var$isProduction = true;
var $32bb08b9118b2714$var$prefix = "Invariant failed";
function $32bb08b9118b2714$var$invariant(condition, message) {
    if (condition) return;
    if ($32bb08b9118b2714$var$isProduction) throw new Error($32bb08b9118b2714$var$prefix);
    throw new Error($32bb08b9118b2714$var$prefix + ": " + (message || ""));
}
function $32bb08b9118b2714$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $32bb08b9118b2714$var$getSerialize(serializer, decycler), indent);
}
function $32bb08b9118b2714$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $32bb08b9118b2714$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $32bb08b9118b2714$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $32bb08b9118b2714$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $32bb08b9118b2714$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $32bb08b9118b2714$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $32bb08b9118b2714$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $32bb08b9118b2714$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $32bb08b9118b2714$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $32bb08b9118b2714$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $32bb08b9118b2714$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $32bb08b9118b2714$export$53b83ca8eaab0383(val);
}
function $32bb08b9118b2714$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $32bb08b9118b2714$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $32bb08b9118b2714$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $32bb08b9118b2714$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $32bb08b9118b2714$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$32bb08b9118b2714$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $32bb08b9118b2714$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $32bb08b9118b2714$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $32bb08b9118b2714$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $32bb08b9118b2714$export$36c1185aeee5b0a6(options);
    };
}
function $32bb08b9118b2714$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $32bb08b9118b2714$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($32bb08b9118b2714$var$isBoolean(thunk)) middlewareArray.push((0, $ldL10.default));
        else middlewareArray.push((0, $ldL10.default).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $32bb08b9118b2714$var$IS_PRODUCTION = true;
function $32bb08b9118b2714$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $32bb08b9118b2714$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($32bb08b9118b2714$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $5MIX0.combineReducers)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$32bb08b9118b2714$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$32bb08b9118b2714$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $5MIX0.applyMiddleware).apply(void 0, finalMiddleware);
    var finalCompose = (0, $5MIX0.compose);
    if (devTools) finalCompose = $32bb08b9118b2714$var$composeWithDevTools($32bb08b9118b2714$var$__spreadValues({
        trace: !$32bb08b9118b2714$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $32bb08b9118b2714$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $32bb08b9118b2714$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $5MIX0.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $32bb08b9118b2714$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $32bb08b9118b2714$var$isStateFunction(x) {
    return typeof x === "function";
}
var $32bb08b9118b2714$var$hasWarnedAboutObjectNotation = false;
function $32bb08b9118b2714$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $32bb08b9118b2714$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($32bb08b9118b2714$var$isStateFunction(initialState)) getInitialState = function() {
        return $32bb08b9118b2714$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $32bb08b9118b2714$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $32bb08b9118b2714$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $6cEEF.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $6cEEF.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $6cEEF.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $32bb08b9118b2714$var$hasWarnedAboutObjectNotation2 = false;
function $32bb08b9118b2714$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $32bb08b9118b2714$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $XAEGR;
    var initialState = typeof options.initialState == "function" ? options.initialState : $32bb08b9118b2714$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $32bb08b9118b2714$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $32bb08b9118b2714$export$309c7a02b0b0bc62(type, prepareCallback) : $32bb08b9118b2714$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $32bb08b9118b2714$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $32bb08b9118b2714$var$__spreadValues($32bb08b9118b2714$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $32bb08b9118b2714$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $32bb08b9118b2714$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $32bb08b9118b2714$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($32bb08b9118b2714$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $32bb08b9118b2714$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $32bb08b9118b2714$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $32bb08b9118b2714$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $32bb08b9118b2714$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $32bb08b9118b2714$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $32bb08b9118b2714$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $32bb08b9118b2714$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $32bb08b9118b2714$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $32bb08b9118b2714$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $32bb08b9118b2714$var$createSingleArgumentStateOperator(mutator) {
    var operator = $32bb08b9118b2714$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $32bb08b9118b2714$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $32bb08b9118b2714$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $6cEEF.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $6cEEF.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $32bb08b9118b2714$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $32bb08b9118b2714$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $32bb08b9118b2714$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $32bb08b9118b2714$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $32bb08b9118b2714$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $32bb08b9118b2714$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $32bb08b9118b2714$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $32bb08b9118b2714$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $32bb08b9118b2714$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $32bb08b9118b2714$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $32bb08b9118b2714$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $32bb08b9118b2714$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $32bb08b9118b2714$var$__spreadValues($32bb08b9118b2714$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $32bb08b9118b2714$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $32bb08b9118b2714$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $32bb08b9118b2714$var$createStateOperator(addOneMutably),
        addMany: $32bb08b9118b2714$var$createStateOperator(addManyMutably),
        setOne: $32bb08b9118b2714$var$createStateOperator(setOneMutably),
        setMany: $32bb08b9118b2714$var$createStateOperator(setManyMutably),
        setAll: $32bb08b9118b2714$var$createStateOperator(setAllMutably),
        updateOne: $32bb08b9118b2714$var$createStateOperator(updateOneMutably),
        updateMany: $32bb08b9118b2714$var$createStateOperator(updateManyMutably),
        upsertOne: $32bb08b9118b2714$var$createStateOperator(upsertOneMutably),
        upsertMany: $32bb08b9118b2714$var$createStateOperator(upsertManyMutably),
        removeOne: $32bb08b9118b2714$var$createStateOperator(removeOneMutably),
        removeMany: $32bb08b9118b2714$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $32bb08b9118b2714$var$createSortedStateAdapter(selectId, sort) {
    var _c = $32bb08b9118b2714$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $32bb08b9118b2714$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($32bb08b9118b2714$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $32bb08b9118b2714$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $32bb08b9118b2714$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $32bb08b9118b2714$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $32bb08b9118b2714$var$createStateOperator(addOneMutably),
        updateOne: $32bb08b9118b2714$var$createStateOperator(updateOneMutably),
        upsertOne: $32bb08b9118b2714$var$createStateOperator(upsertOneMutably),
        setOne: $32bb08b9118b2714$var$createStateOperator(setOneMutably),
        setMany: $32bb08b9118b2714$var$createStateOperator(setManyMutably),
        setAll: $32bb08b9118b2714$var$createStateOperator(setAllMutably),
        addMany: $32bb08b9118b2714$var$createStateOperator(addManyMutably),
        updateMany: $32bb08b9118b2714$var$createStateOperator(updateManyMutably),
        upsertMany: $32bb08b9118b2714$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $32bb08b9118b2714$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $32bb08b9118b2714$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $32bb08b9118b2714$var$createInitialStateFactory();
    var selectorsFactory = $32bb08b9118b2714$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $32bb08b9118b2714$var$createSortedStateAdapter(selectId, sortComparer) : $32bb08b9118b2714$var$createUnsortedStateAdapter(selectId);
    return $32bb08b9118b2714$var$__spreadValues($32bb08b9118b2714$var$__spreadValues($32bb08b9118b2714$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $32bb08b9118b2714$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $32bb08b9118b2714$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $32bb08b9118b2714$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $32bb08b9118b2714$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $32bb08b9118b2714$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $32bb08b9118b2714$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $32bb08b9118b2714$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $32bb08b9118b2714$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $32bb08b9118b2714$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $32bb08b9118b2714$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $32bb08b9118b2714$var$__spreadProps($32bb08b9118b2714$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $32bb08b9118b2714$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $32bb08b9118b2714$var$__spreadProps($32bb08b9118b2714$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $32bb08b9118b2714$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $32bb08b9118b2714$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $32bb08b9118b2714$var$__spreadProps($32bb08b9118b2714$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $32bb08b9118b2714$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $32bb08b9118b2714$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $32bb08b9118b2714$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$32bb08b9118b2714$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $32bb08b9118b2714$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $32bb08b9118b2714$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $32bb08b9118b2714$var$RejectWithValue) throw result;
                                                if (result instanceof $32bb08b9118b2714$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $32bb08b9118b2714$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($32bb08b9118b2714$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $32bb08b9118b2714$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $32bb08b9118b2714$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $32bb08b9118b2714$var$matches = function(matcher, action) {
    if ($32bb08b9118b2714$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $32bb08b9118b2714$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $32bb08b9118b2714$var$matches(matcher, action);
        });
    };
}
function $32bb08b9118b2714$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $32bb08b9118b2714$var$matches(matcher, action);
        });
    };
}
function $32bb08b9118b2714$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $32bb08b9118b2714$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $32bb08b9118b2714$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $32bb08b9118b2714$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$32bb08b9118b2714$var$isAsyncThunkArray(asyncThunks)) return $32bb08b9118b2714$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $32bb08b9118b2714$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $32bb08b9118b2714$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $32bb08b9118b2714$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$32bb08b9118b2714$var$isAsyncThunkArray(asyncThunks)) return $32bb08b9118b2714$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $32bb08b9118b2714$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $32bb08b9118b2714$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $32bb08b9118b2714$export$9dd1fb32974da385($32bb08b9118b2714$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$32bb08b9118b2714$var$isAsyncThunkArray(asyncThunks)) return $32bb08b9118b2714$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $32bb08b9118b2714$export$9dd1fb32974da385($32bb08b9118b2714$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $32bb08b9118b2714$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $32bb08b9118b2714$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$32bb08b9118b2714$var$isAsyncThunkArray(asyncThunks)) return $32bb08b9118b2714$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $32bb08b9118b2714$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $32bb08b9118b2714$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $32bb08b9118b2714$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$32bb08b9118b2714$var$isAsyncThunkArray(asyncThunks)) return $32bb08b9118b2714$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $32bb08b9118b2714$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $32bb08b9118b2714$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $32bb08b9118b2714$var$noop = function() {};
var $32bb08b9118b2714$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $32bb08b9118b2714$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $32bb08b9118b2714$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $32bb08b9118b2714$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $32bb08b9118b2714$var$task = "task";
var $32bb08b9118b2714$var$listener = "listener";
var $32bb08b9118b2714$var$completed = "completed";
var $32bb08b9118b2714$var$cancelled = "cancelled";
var $32bb08b9118b2714$var$taskCancelled = "task-" + $32bb08b9118b2714$var$cancelled;
var $32bb08b9118b2714$var$taskCompleted = "task-" + $32bb08b9118b2714$var$completed;
var $32bb08b9118b2714$var$listenerCancelled = $32bb08b9118b2714$var$listener + "-" + $32bb08b9118b2714$var$cancelled;
var $32bb08b9118b2714$var$listenerCompleted = $32bb08b9118b2714$var$listener + "-" + $32bb08b9118b2714$var$completed;
var $32bb08b9118b2714$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $32bb08b9118b2714$var$task + " " + $32bb08b9118b2714$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $32bb08b9118b2714$var$validateActive = function(signal) {
    if (signal.aborted) throw new $32bb08b9118b2714$export$cb1bdac908fed7f(signal.reason);
};
function $32bb08b9118b2714$var$raceWithSignal(signal, promise2) {
    var cleanup = $32bb08b9118b2714$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $32bb08b9118b2714$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $32bb08b9118b2714$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $32bb08b9118b2714$var$noop;
    });
}
var $32bb08b9118b2714$var$runTask = function(task2, cleanUp) {
    return $32bb08b9118b2714$var$__async(void 0, null, function() {
        var value, error_1;
        return $32bb08b9118b2714$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $32bb08b9118b2714$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $32bb08b9118b2714$var$createPause = function(signal) {
    return function(promise2) {
        return $32bb08b9118b2714$var$catchRejection($32bb08b9118b2714$var$raceWithSignal(signal, promise2).then(function(output) {
            $32bb08b9118b2714$var$validateActive(signal);
            return output;
        }));
    };
};
var $32bb08b9118b2714$var$createDelay = function(signal) {
    var pause = $32bb08b9118b2714$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $32bb08b9118b2714$var$assign = Object.assign;
var $32bb08b9118b2714$var$INTERNAL_NIL_TOKEN = {};
var $32bb08b9118b2714$var$alm = "listenerMiddleware";
var $32bb08b9118b2714$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $32bb08b9118b2714$var$addAbortSignalListener(parentAbortSignal, function() {
            return $32bb08b9118b2714$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $32bb08b9118b2714$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $32bb08b9118b2714$var$runTask(function() {
            return $32bb08b9118b2714$var$__async(void 0, null, function() {
                var result2;
                return $32bb08b9118b2714$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $32bb08b9118b2714$var$validateActive(parentAbortSignal);
                            $32bb08b9118b2714$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $32bb08b9118b2714$var$createPause(childAbortController.signal),
                                    delay: $32bb08b9118b2714$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $32bb08b9118b2714$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $32bb08b9118b2714$var$abortControllerWithReason(childAbortController, $32bb08b9118b2714$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $32bb08b9118b2714$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $32bb08b9118b2714$var$abortControllerWithReason(childAbortController, $32bb08b9118b2714$var$taskCancelled);
            }
        };
    };
};
var $32bb08b9118b2714$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $32bb08b9118b2714$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $32bb08b9118b2714$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $32bb08b9118b2714$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $32bb08b9118b2714$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $32bb08b9118b2714$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $32bb08b9118b2714$var$catchRejection(take(predicate, timeout));
    };
};
var $32bb08b9118b2714$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $32bb08b9118b2714$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $32bb08b9118b2714$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $32bb08b9118b2714$var$createListenerEntry = function(options) {
    var _c = $32bb08b9118b2714$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $32bb08b9118b2714$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $32bb08b9118b2714$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $32bb08b9118b2714$var$abortControllerWithReason(controller, $32bb08b9118b2714$var$listenerCancelled);
    });
};
var $32bb08b9118b2714$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($32bb08b9118b2714$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $32bb08b9118b2714$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $32bb08b9118b2714$export$f03a6b845d3fb58b = $32bb08b9118b2714$export$309c7a02b0b0bc62($32bb08b9118b2714$var$alm + "/add");
var $32bb08b9118b2714$export$b1b8022855fb2b71 = $32bb08b9118b2714$export$309c7a02b0b0bc62($32bb08b9118b2714$var$alm + "/removeAll");
var $32bb08b9118b2714$export$b03e9483f936dccb = $32bb08b9118b2714$export$309c7a02b0b0bc62($32bb08b9118b2714$var$alm + "/remove");
var $32bb08b9118b2714$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $32bb08b9118b2714$var$__spreadArray([
        $32bb08b9118b2714$var$alm + "/error"
    ], args));
};
function $32bb08b9118b2714$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $32bb08b9118b2714$var$defaultErrorHandler : _c;
    $32bb08b9118b2714$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $32bb08b9118b2714$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $32bb08b9118b2714$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $32bb08b9118b2714$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $32bb08b9118b2714$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $32bb08b9118b2714$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $32bb08b9118b2714$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $32bb08b9118b2714$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $32bb08b9118b2714$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $32bb08b9118b2714$var$createDelay(internalTaskController.signal),
                                pause: $32bb08b9118b2714$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $32bb08b9118b2714$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $32bb08b9118b2714$var$abortControllerWithReason(controller, $32bb08b9118b2714$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $32bb08b9118b2714$export$cb1bdac908fed7f)) $32bb08b9118b2714$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $32bb08b9118b2714$var$abortControllerWithReason(internalTaskController, $32bb08b9118b2714$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $32bb08b9118b2714$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$32bb08b9118b2714$export$b956e38827fca970(action)) return next(action);
                if ($32bb08b9118b2714$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($32bb08b9118b2714$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($32bb08b9118b2714$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $32bb08b9118b2714$var$INTERNAL_NIL_TOKEN) throw new Error($32bb08b9118b2714$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $32bb08b9118b2714$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $32bb08b9118b2714$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $32bb08b9118b2714$export$8fb31c0f05df007b = "RTK_autoBatch";
var $32bb08b9118b2714$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$32bb08b9118b2714$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $32bb08b9118b2714$var$promise;
var $32bb08b9118b2714$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($32bb08b9118b2714$var$promise || ($32bb08b9118b2714$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $32bb08b9118b2714$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $32bb08b9118b2714$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $32bb08b9118b2714$var$createQueueWithTimer(10);
var $32bb08b9118b2714$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $32bb08b9118b2714$var$queueMicrotaskShim : options.type === "raf" ? $32bb08b9118b2714$var$rAF : options.type === "callback" ? options.queueNotification : $32bb08b9118b2714$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$32bb08b9118b2714$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $6cEEF.enableES5)();

});
parcelRegister("5MIX0", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $43644db33e376939$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combineReducers", function () { return $43644db33e376939$export$66e4520cdb265d18; });
$parcel$export(module.exports, "compose", function () { return $43644db33e376939$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "applyMiddleware", function () { return $43644db33e376939$export$9ff26e0402cc7b7; });

var $33gim = parcelRequire("33gim");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $43644db33e376939$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $43644db33e376939$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $43644db33e376939$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $43644db33e376939$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $43644db33e376939$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $43644db33e376939$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $43644db33e376939$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $43644db33e376939$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $43644db33e376939$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($43644db33e376939$var$isDate(val)) return "date";
    if ($43644db33e376939$var$isError(val)) return "error";
    var constructorName = $43644db33e376939$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $43644db33e376939$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $43644db33e376939$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $43644db33e376939$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $43644db33e376939$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $43644db33e376939$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($43644db33e376939$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($43644db33e376939$var$formatProdErrorMessage(1));
        return enhancer($43644db33e376939$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($43644db33e376939$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($43644db33e376939$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($43644db33e376939$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($43644db33e376939$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($43644db33e376939$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$43644db33e376939$var$isPlainObject(action)) throw new Error($43644db33e376939$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($43644db33e376939$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($43644db33e376939$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($43644db33e376939$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $43644db33e376939$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($43644db33e376939$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$43644db33e376939$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $43644db33e376939$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$43644db33e376939$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $43644db33e376939$export$8928921ea2d3b126 = $43644db33e376939$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $43644db33e376939$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $43644db33e376939$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $43644db33e376939$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$43644db33e376939$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $43644db33e376939$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $43644db33e376939$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $43644db33e376939$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $43644db33e376939$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($43644db33e376939$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $43644db33e376939$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($43644db33e376939$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $43644db33e376939$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $43644db33e376939$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($43644db33e376939$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $43644db33e376939$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $43644db33e376939$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $43644db33e376939$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($43644db33e376939$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $43644db33e376939$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $43644db33e376939$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $43644db33e376939$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($43644db33e376939$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $43644db33e376939$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $33gim.default)((0, $33gim.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("33gim", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $238e4acc44833297$export$2e2bcd8739ae039; });

var $4MJ5w = parcelRequire("4MJ5w");
function $238e4acc44833297$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $238e4acc44833297$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $238e4acc44833297$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $4MJ5w.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $238e4acc44833297$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("4MJ5w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37be9ea588ddf2fa$export$2e2bcd8739ae039; });

var $2iTus = parcelRequire("2iTus");
function $37be9ea588ddf2fa$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $2iTus.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("2iTus", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ad84e6823e0baba$export$2e2bcd8739ae039; });

var $dk6pF = parcelRequire("dk6pF");

var $6S58V = parcelRequire("6S58V");
function $1ad84e6823e0baba$export$2e2bcd8739ae039(t) {
    var i = (0, $6S58V.default)(t, "string");
    return "symbol" == (0, $dk6pF.default)(i) ? i : i + "";
}

});
parcelRegister("dk6pF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b321e1452bc4eae$export$2e2bcd8739ae039; });
function $9b321e1452bc4eae$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $9b321e1452bc4eae$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9b321e1452bc4eae$export$2e2bcd8739ae039(o);
}

});

parcelRegister("6S58V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $500bc684c261acf4$export$2e2bcd8739ae039; });

var $dk6pF = parcelRequire("dk6pF");
function $500bc684c261acf4$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $dk6pF.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $dk6pF.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("4Tcuq", function(module, exports) {

$parcel$export(module.exports, "createSelector", function () { return $38f5fcb1ed8618e5$export$595d22ed68ca2841; });

var $6CP7y = parcelRequire("6CP7y");
function $38f5fcb1ed8618e5$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $38f5fcb1ed8618e5$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $38f5fcb1ed8618e5$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $38f5fcb1ed8618e5$export$595d22ed68ca2841 = /* #__PURE__ */ $38f5fcb1ed8618e5$export$5943f4447f6ef248((0, $6CP7y.defaultMemoize));
var $38f5fcb1ed8618e5$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $38f5fcb1ed8618e5$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRegister("6CP7y", function(module, exports) {

$parcel$export(module.exports, "defaultMemoize", function () { return $4d2df23793b75120$export$281bff7f05488aa2; });
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $4d2df23793b75120$var$NOT_FOUND = "NOT_FOUND";
function $4d2df23793b75120$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $4d2df23793b75120$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $4d2df23793b75120$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $4d2df23793b75120$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $4d2df23793b75120$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $4d2df23793b75120$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $4d2df23793b75120$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $4d2df23793b75120$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $4d2df23793b75120$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $4d2df23793b75120$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $4d2df23793b75120$var$createSingletonCache(comparator) : $4d2df23793b75120$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $4d2df23793b75120$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});


parcelRegister("ldL10", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f72f4823bd9ac762$export$2e2bcd8739ae039; });
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $f72f4823bd9ac762$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $f72f4823bd9ac762$var$thunk = $f72f4823bd9ac762$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$f72f4823bd9ac762$var$thunk.withExtraArgument = $f72f4823bd9ac762$var$createThunkMiddleware;
var $f72f4823bd9ac762$export$2e2bcd8739ae039 = $f72f4823bd9ac762$var$thunk;

});


parcelRegister("6BsmU", function(module, exports) {

module.exports = (parcelRequire("1tnm6"));

});
parcelRegister("1tnm6", function(module, exports) {

var $cIphY = parcelRequire("cIphY");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $cIphY(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error("minTimeout is greater than maxTimeout");
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === "function") methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("cIphY", function(module, exports) {
function $941d35f089257864$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === "boolean") options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $941d35f089257864$var$RetryOperation;
$941d35f089257864$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$941d35f089257864$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$941d35f089257864$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error("RetryOperation timeout occurred"));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$941d35f089257864$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$941d35f089257864$var$RetryOperation.prototype.try = function(fn) {
    console.log("Using RetryOperation.try() is deprecated");
    this.attempt(fn);
};
$941d35f089257864$var$RetryOperation.prototype.start = function(fn) {
    console.log("Using RetryOperation.start() is deprecated");
    this.attempt(fn);
};
$941d35f089257864$var$RetryOperation.prototype.start = $941d35f089257864$var$RetryOperation.prototype.try;
$941d35f089257864$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$941d35f089257864$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$941d35f089257864$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});



parcelRegister("fngxH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02e372ef7bfe2286$var$_react = $02e372ef7bfe2286$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $02e372ef7bfe2286$var$_statusInformation = $02e372ef7bfe2286$var$_interopRequireDefault((parcelRequire("7hke1")));
function $02e372ef7bfe2286$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $02e372ef7bfe2286$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $02e372ef7bfe2286$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $02e372ef7bfe2286$var$_statusInformation.default
    }));
$02e372ef7bfe2286$var$EditorPanelIcon.displayName = "EditorPanelIcon";
var $02e372ef7bfe2286$var$_default = module.exports.default = $02e372ef7bfe2286$var$EditorPanelIcon;

});
parcelRegister("7hke1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0749aecb688ec01c0962b8f7fb609ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $54c9cf39b5702298$var$_react = $54c9cf39b5702298$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $54c9cf39b5702298$var$_baseNew = $54c9cf39b5702298$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $54c9cf39b5702298$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $54c9cf39b5702298$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $54c9cf39b5702298$var$_react.default.createElement($54c9cf39b5702298$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$54c9cf39b5702298$var$StatusInformationIcon.displayName = "StatusInformationIcon";
var $54c9cf39b5702298$var$_default = module.exports.default = $54c9cf39b5702298$var$StatusInformationIcon;

});


parcelRegister("9REvE", function(module, exports) {
$parcel$export(module.exports, "DropdownSelector", function () { return (parcelRequire("2m1xf")).DropdownSelector; });

var $2m1xf = parcelRequire("2m1xf");

});
parcelRegister("2m1xf", function(module, exports) {

$parcel$export(module.exports, "DropdownSelector", function () { return $ca8de50e57748f6a$export$67ffdcf8cfce0fd; });
/* dropdown-selector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $1K6UN = parcelRequire("1K6UN");
const $ca8de50e57748f6a$var$dropdownSelectorContainerStyle = null;
const $ca8de50e57748f6a$var$labelStyle = null;
const $ca8de50e57748f6a$var$labelStyleSignup = null;
const $ca8de50e57748f6a$export$67ffdcf8cfce0fd = ({ options: options, name: name, id: id, testId: testId, label: label, onChangeHandler: onChangeHandler, defaultValue: defaultValue, cssOverrides: cssOverrides, className: className })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $iSvIT.useState)(false);
    const elementID = id ? id : `${name}-dropdown`;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c116y _2lx21bp4 _1bsb1osq",
            className
        ]),
        children: [
            (cssOverrides === null || cssOverrides === void 0 ? void 0 : cssOverrides.labelStyle) === "signup" && /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                htmlFor: elementID,
                className: (0, $esG4f.default)([
                    "_syazvwuj _vwz41gnr _6rth1b66 _y3gn1e5h _k48pbfng _1wybdlk8"
                ]),
                children: label
            }),
            !(cssOverrides === null || cssOverrides === void 0 ? void 0 : cssOverrides.labelStyle) && /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                htmlFor: elementID,
                className: (0, $esG4f.default)([
                    "_syazvwuj _1wyboqnp _vwz41gnr _6rth1b66 _y3gn1e5h"
                ]),
                children: label
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: "select-dropdown-container",
                "data-testid": testId ? testId : elementID,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1K6UN.default), {
                    defaultValue: defaultValue || {
                        label: "Select...",
                        value: ""
                    },
                    options: options,
                    unstyled: true,
                    inputId: elementID,
                    onChange: (selectedOption)=>{
                        onChangeHandler === null || onChangeHandler === void 0 ? void 0 : onChangeHandler((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) || "");
                    },
                    onMenuOpen: ()=>setIsMenuOpen(true),
                    onMenuClose: ()=>setIsMenuOpen(false),
                    styles: {
                        container: (provided)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                appearance: "none",
                                flexDirection: "row",
                                fontSize: "1rem",
                                lineHeight: "1.2",
                                textAlign: "left"
                            }), (cssOverrides || {}).container),
                        singleValue: (provided)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                marginLeft: "var(--ds-space-025, 2px)",
                                marginRight: "var(--ds-space-025, 2px)"
                            }), (cssOverrides || {}).singleValue),
                        placeholder: (provided)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                marginLeft: "var(--ds-space-025, 2px)",
                                marginRight: "var(--ds-space-025, 2px)"
                            }), (cssOverrides || {}).placeholder),
                        valueContainer: (provided)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                paddingLeft: "var(--ds-space-075, 6px)",
                                paddingRight: "var(--ds-space-075, 6px)"
                            }), (cssOverrides || {}).valueContainer),
                        menu: (provided)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                marginTop: "var(--ds-space-050, 4px)",
                                boxShadow: "0px 3px 5px 0px #091E4233",
                                background: "#ffffff",
                                padding: 0,
                                borderRadius: "var(--ds-space-050, 4px)"
                            }), (cssOverrides || {}).menu),
                        control: (provided, state)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                "cursor": "pointer",
                                "backgroundColor": isMenuOpen ? "#253858" : "#FAFBFC",
                                "color": isMenuOpen ? "#ffffff" : "#172B4D",
                                "height": "2.65rem",
                                "border": state.isFocused ? `2px solid #4C9AFF` : `2px solid #dfe1e6`,
                                "borderRadius": "var(--ds-space-050, 4px)",
                                "&:hover": {
                                    background: isMenuOpen ? undefined : "#F4F5F7"
                                }
                            }), (cssOverrides || {}).control),
                        dropdownIndicator: (provided, state)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                transition: "all .2s ease",
                                transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : undefined
                            }), (cssOverrides || {}).dropdownIndicator),
                        indicatorsContainer: (provided)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                paddingTop: "var(--ds-space-075, 6px)",
                                paddingBottom: "var(--ds-space-075, 6px)",
                                paddingLeft: "var(--ds-space-025, 2px)",
                                paddingRight: "var(--ds-space-075, 6px)"
                            }), (cssOverrides || {}).indicatorsContainer),
                        option: (provided, state)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                "cursor": "pointer",
                                "padding": `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`,
                                "whiteSpace": "pre-wrap",
                                "overflowWrap": "break-word",
                                "backgroundColor": state.isSelected ? "#B2D4FF" : state.isFocused ? "#EBECF0" : "#FAFBFC",
                                "color": state.isSelected ? "#0065FF" : "#172B4D",
                                "&:hover": {
                                    background: state.isSelected ? "#B2D4FF" : "#EBECF0"
                                },
                                "&:active": {
                                    background: "#DFE1E5"
                                }
                            }), (cssOverrides || {}).option),
                        input: (provided)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                color: "transparent"
                            }), (cssOverrides || {}).input)
                    }
                })
            })
        ]
    });
};

});


parcelRegister("7nbgg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55e36aa12b926aa8$export$2e2bcd8739ae039; });

var $3QRB6 = parcelRequire("3QRB6");

var $kfgWa = parcelRequire("kfgWa");

var $6fzNH = parcelRequire("6fzNH");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $a1y4y = parcelRequire("a1y4y");

var $9rjSt = parcelRequire("9rjSt");

var $lN9Ao = parcelRequire("lN9Ao");

var $kM77d = parcelRequire("kM77d");
var $h9ozc = parcelRequire("h9ozc");
var $h32HL = parcelRequire("h32HL");
var $6UVdu = parcelRequire("6UVdu");
var $55e36aa12b926aa8$var$_excluded = [
    "isChecked",
    "isDisabled",
    "isInvalid",
    "defaultChecked",
    "isIndeterminate",
    "size",
    "onChange",
    "analyticsContext",
    "label",
    "name",
    "value",
    "isRequired",
    "testId"
];
/* eslint-disable @atlaskit/design-system/no-nested-styles */ var $55e36aa12b926aa8$var$checkboxStyles = (0, $2ZUkg.css)({
    width: "100%",
    height: "100%",
    margin: "var(--ds-space-0, 0px)",
    appearance: "none",
    border: "none",
    gridArea: "1 / 1 / 2 / 2",
    opacity: 0,
    outline: "none",
    "& + svg": {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ "--checkbox-background-color": "var(--local-background)",
        "--checkbox-border-color": "var(--local-border)",
        "--checkbox-tick-color": "var(--local-tick-rest)",
        color: "var(--checkbox-background-color)",
        fill: "var(--checkbox-tick-color)",
        gridArea: "1 / 1 / 2 / 2",
        pointerEvents: "none",
        transition: "color 0.2s ease-in-out, fill 0.2s ease-in-out",
        "rect:first-of-type": {
            stroke: "var(--checkbox-border-color)",
            strokeWidth: (0, $lN9Ao.getBooleanFF)("platform.design-system-team.update-border-radio-checkbox_7askv") ? "var(--ds-border-width, 1px)" : 2,
            transition: "stroke 0.2s ease-in-out"
        }
    },
    "&&:focus + svg, &&:checked:focus + svg": {
        "--checkbox-border-color": "var(--local-border-focus)"
    },
    "&:hover + svg": {
        "--checkbox-background-color": "var(--local-background-hover)",
        "--checkbox-border-color": "var(--local-border-hover)"
    },
    "&:checked:hover + svg": {
        "--checkbox-background-color": "var(--local-background-checked-hover)",
        "--checkbox-border-color": "var(--local-border-checked-hover)"
    },
    "&:checked + svg": {
        "--checkbox-background-color": "var(--local-background-checked)",
        "--checkbox-border-color": "var(--local-border-checked)",
        "--checkbox-tick-color": "var(--local-tick-checked)"
    },
    "&[data-invalid] + svg": {
        "--checkbox-border-color": "var(--local-border-invalid)"
    },
    "&:checked[data-invalid] + svg": {
        "--checkbox-border-color": "var(--local-border-checked-invalid)"
    },
    "&:active + svg": {
        "--checkbox-background-color": "var(--local-background-active)",
        "--checkbox-border-color": "var(--local-border-active)"
    },
    "&:checked:active + svg": {
        "--checkbox-background-color": "var(--local-background-active)",
        "--checkbox-border-color": "var(--local-border-active)",
        "--checkbox-tick-color": "var(--local-tick-active)"
    },
    "&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg": {
        "--checkbox-background-color": "var(--local-background-disabled)",
        "--checkbox-border-color": "var(--local-border-disabled)",
        cursor: "not-allowed",
        pointerEvents: "none"
    },
    "&:disabled:checked + svg": {
        "--checkbox-tick-color": "var(--local-tick-disabled)"
    },
    "@media screen and (forced-colors: active)": {
        "& + svg": {
            "--checkbox-background-color": "Canvas",
            "--checkbox-border-color": "CanvasText",
            "--checkbox-tick-color": "CanvasText"
        },
        "&:checked + svg, &:checked:hover + svg": {
            "--checkbox-background-color": "Canvas",
            "--checkbox-border-color": "CanvasText",
            "--checkbox-tick-color": "CanvasText"
        },
        "&:focus + svg rect:first-of-type": {
            stroke: "Highlight"
        },
        "&[data-invalid] + svg": {
            "--checkbox-border-color": "Highlight"
        },
        "&:checked[data-invalid] + svg": {
            "--checkbox-border-color": "Highlight"
        },
        "&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg": {
            "--checkbox-background-color": "Canvas",
            "--checkbox-border-color": "GrayText",
            "--checkbox-tick-color": "GrayText"
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ var $55e36aa12b926aa8$var$Checkbox = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function Checkbox(props, ref) {
    var isCheckedProp = props.isChecked, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$defaultChecked = props.defaultChecked, defaultChecked = _props$defaultChecked === void 0 ? false : _props$defaultChecked, _props$isIndeterminat = props.isIndeterminate, isIndeterminate = _props$isIndeterminat === void 0 ? false : _props$isIndeterminat, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, onChangeProps = props.onChange, analyticsContext = props.analyticsContext, label = props.label, name = props.name, value = props.value, isRequired = props.isRequired, testId = props.testId, rest = (0, $6fzNH.default)(props, $55e36aa12b926aa8$var$_excluded);
    var _useState = (0, $iSvIT.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked), _useState2 = (0, $kfgWa.default)(_useState, 2), isCheckedState = _useState2[0], setIsCheckedState = _useState2[1];
    var onChange = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    var onChangeAnalytics = (0, $a1y4y.usePlatformLeafEventHandler)({
        fn: onChange,
        action: "changed",
        analyticsData: analyticsContext,
        componentName: "checkbox",
        packageName: "@atlaskit/checkbox",
        packageVersion: "12.6.11"
    });
    var internalRef = (0, $iSvIT.useRef)(null);
    var mergedRefs = (0, $9rjSt.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    var isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    return (0, $2ZUkg.jsx)((0, $h9ozc.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? "".concat(rest.id, "-label") : undefined,
        testId: testId && "".concat(testId, "--checkbox-label")
    }, (0, $2ZUkg.jsx)("input", (0, $3QRB6.default)({}, rest, {
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $55e36aa12b926aa8$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-checked": isIndeterminate ? "mixed" : isChecked,
        "aria-invalid": isInvalid ? "true" : undefined,
        "data-testid": testId && "".concat(testId, "--hidden-checkbox"),
        "data-invalid": isInvalid ? "true" : undefined
    })), (0, $2ZUkg.jsx)((0, $kM77d.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && (0, $2ZUkg.jsx)((0, $h32HL.default), null, label, isRequired && (0, $2ZUkg.jsx)((0, $6UVdu.default), null)));
}));
$55e36aa12b926aa8$var$Checkbox.displayName = "Checkbox";
var $55e36aa12b926aa8$export$2e2bcd8739ae039 = $55e36aa12b926aa8$var$Checkbox;

});
parcelRegister("3QRB6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cdfcdbd8da79b74$export$2e2bcd8739ae039; });
function $2cdfcdbd8da79b74$export$2e2bcd8739ae039() {
    return $2cdfcdbd8da79b74$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2cdfcdbd8da79b74$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("kfgWa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebd258bad8656764$export$2e2bcd8739ae039; });

var $8qfQd = parcelRequire("8qfQd");

var $3BWcO = parcelRequire("3BWcO");

var $hRUT6 = parcelRequire("hRUT6");

var $9sgnQ = parcelRequire("9sgnQ");
function $ebd258bad8656764$export$2e2bcd8739ae039(r, e) {
    return (0, $8qfQd.default)(r) || (0, $3BWcO.default)(r, e) || (0, $hRUT6.default)(r, e) || (0, $9sgnQ.default)();
}

});
parcelRegister("8qfQd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $621d0a25f75c18e3$export$2e2bcd8739ae039; });
function $621d0a25f75c18e3$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("3BWcO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a11fa4123d6e0cb$export$2e2bcd8739ae039; });
function $2a11fa4123d6e0cb$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("hRUT6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d02383a0ee658c10$export$2e2bcd8739ae039; });

var $8oJva = parcelRequire("8oJva");
function $d02383a0ee658c10$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $8oJva.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $8oJva.default)(r, a) : void 0;
    }
}

});
parcelRegister("8oJva", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61d3dc52462304ad$export$2e2bcd8739ae039; });
function $61d3dc52462304ad$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("9sgnQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e23700825c7c4ab$export$2e2bcd8739ae039; });
function $6e23700825c7c4ab$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("6fzNH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48cfea081e2afaad$export$2e2bcd8739ae039; });

var $7JwIa = parcelRequire("7JwIa");
function $48cfea081e2afaad$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $7JwIa.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("7JwIa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0173f8324e4fc3a5$export$2e2bcd8739ae039; });
function $0173f8324e4fc3a5$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("9rjSt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6df60df8e4f17b4a$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $6df60df8e4f17b4a$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("lN9Ao", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $fdd59c25c185ae11$export$470e5c2be1411c89; });

var $i0Q1k = parcelRequire("i0Q1k");
function $fdd59c25c185ae11$export$ba05d765b8392e5e(flagResolver) {
    (0, $i0Q1k.setBooleanResolver)(flagResolver);
}
function $fdd59c25c185ae11$export$470e5c2be1411c89(name) {
    return (0, $i0Q1k.resolveBooleanFlag)(name);
}

});
parcelRegister("i0Q1k", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $d1d094449e79bf89$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $d1d094449e79bf89$export$6333b6aff9fc6275; });

var $1Gbsw = parcelRequire("1Gbsw");

var $XAEGR = parcelRequire("XAEGR");
var $d1d094449e79bf89$var$pkgName = "@atlaskit/platform-feature-flags";
var $d1d094449e79bf89$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $d1d094449e79bf89$var$hasProcessEnv = typeof $XAEGR !== "undefined" && typeof $XAEGR.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $d1d094449e79bf89$var$ENV_ENABLE_PLATFORM_FF = $d1d094449e79bf89$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $d1d094449e79bf89$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $d1d094449e79bf89$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $d1d094449e79bf89$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $d1d094449e79bf89$var$ENV_ENABLE_PLATFORM_FF || $d1d094449e79bf89$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $d1d094449e79bf89$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $d1d094449e79bf89$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$d1d094449e79bf89$var$globalVar[$d1d094449e79bf89$export$7e41b1b2bdee3f98] = $d1d094449e79bf89$var$globalVar[$d1d094449e79bf89$export$7e41b1b2bdee3f98] || $d1d094449e79bf89$var$DEFAULT_PFF_GLOBAL;
function $d1d094449e79bf89$export$f2b591175b3e424c(resolver) {
    $d1d094449e79bf89$var$globalVar[$d1d094449e79bf89$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2;
}
function $d1d094449e79bf89$export$6333b6aff9fc6275(flagKey) {
    if ($d1d094449e79bf89$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $1Gbsw.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $d1d094449e79bf89$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL3;
        var result = (_globalVar$PFF_GLOBAL3 = $d1d094449e79bf89$var$globalVar[$d1d094449e79bf89$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("1Gbsw", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $13929a39deece6af$export$1c9f709888824e05; });
var $13929a39deece6af$var$_ref, $13929a39deece6af$var$_globalThis$process, $13929a39deece6af$var$_globalThis$process$e, $13929a39deece6af$var$_globalThis$process2, $13929a39deece6af$var$_globalThis$process2$;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $13929a39deece6af$var$TESTS_MODE = ($13929a39deece6af$var$_ref = (globalThis === null || globalThis === void 0 ? void 0 : ($13929a39deece6af$var$_globalThis$process = globalThis.process) === null || $13929a39deece6af$var$_globalThis$process === void 0 ? void 0 : ($13929a39deece6af$var$_globalThis$process$e = $13929a39deece6af$var$_globalThis$process.env) === null || $13929a39deece6af$var$_globalThis$process$e === void 0 ? void 0 : $13929a39deece6af$var$_globalThis$process$e.JEST_WORKER_ID) !== undefined, $13929a39deece6af$var$_ref !== void 0) ? $13929a39deece6af$var$_ref : false;
var $13929a39deece6af$var$DEBUG_MODE = !$13929a39deece6af$var$TESTS_MODE && (globalThis === null || globalThis === void 0 ? void 0 : ($13929a39deece6af$var$_globalThis$process2 = globalThis.process) === null || $13929a39deece6af$var$_globalThis$process2 === void 0 ? void 0 : ($13929a39deece6af$var$_globalThis$process2$ = $13929a39deece6af$var$_globalThis$process2.env) === null || $13929a39deece6af$var$_globalThis$process2$ === void 0 ? void 0 : $13929a39deece6af$var$_globalThis$process2$.NODE_ENV) !== "production";
var $13929a39deece6af$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$13929a39deece6af$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("kM77d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1fdcf5536b48d5c$export$2e2bcd8739ae039; });
/**  @jsx jsx */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $12HLC = parcelRequire("12HLC");
function $f1fdcf5536b48d5c$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return (0, $2ZUkg.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return (0, $2ZUkg.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ var $f1fdcf5536b48d5c$var$CheckboxIcon = /*#__PURE__*/ (0, $iSvIT.memo)(function(_ref) {
    var size = _ref.size, isIndeterminate = _ref.isIndeterminate, isChecked = _ref.isChecked;
    var icon = (0, $iSvIT.useMemo)(function() {
        return $f1fdcf5536b48d5c$var$getIcon(isIndeterminate, isChecked);
    }, [
        isIndeterminate,
        isChecked
    ]);
    return (0, $2ZUkg.jsx)((0, $12HLC.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, (0, $2ZUkg.jsx)("g", {
        fillRule: "evenodd"
    }, (0, $2ZUkg.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $f1fdcf5536b48d5c$export$2e2bcd8739ae039 = $f1fdcf5536b48d5c$var$CheckboxIcon;

});
parcelRegister("12HLC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c27ed93d991eda0$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $kw3ka = parcelRequire("kw3ka");

var $kxnJk = parcelRequire("kxnJk");

var $lwAzL = parcelRequire("lwAzL");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $0c27ed93d991eda0$var$svgStyles = (0, $2ZUkg.css)((0, $lwAzL.commonSVGStyles));
/**
 * __SVG__
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ var $0c27ed93d991eda0$var$SVG = /*#__PURE__*/ (0, $iSvIT.memo)(function SVG(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, label = _ref.label, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, testId = _ref.testId, children = _ref.children;
    var _useGlobalTheme = (0, $kw3ka.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $2ZUkg.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor || (0, $kxnJk.getBackground)(mode)
        },
        css: [
            $0c27ed93d991eda0$var$svgStyles,
            (0, $lwAzL.sizeStyleMap)[size]
        ],
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? "img" : "presentation"
    }, children);
});
var $0c27ed93d991eda0$export$2e2bcd8739ae039 = $0c27ed93d991eda0$var$SVG;

});
parcelRegister("kw3ka", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", function () { return $eef95ff130f8ccd0$export$7692396083754928; });

var $hAhfP = parcelRequire("hAhfP");
// Create default global light theme
var $eef95ff130f8ccd0$var$_createTheme = (0, $hAhfP.createTheme)(function() {
    return {
        mode: "light"
    };
}), $eef95ff130f8ccd0$var$Provider = $eef95ff130f8ccd0$var$_createTheme.Provider, $eef95ff130f8ccd0$var$Consumer = $eef95ff130f8ccd0$var$_createTheme.Consumer, $eef95ff130f8ccd0$export$7692396083754928 = $eef95ff130f8ccd0$var$_createTheme.useTheme;
var $eef95ff130f8ccd0$export$2e2bcd8739ae039 = {
    Provider: $eef95ff130f8ccd0$var$Provider,
    Consumer: $eef95ff130f8ccd0$var$Consumer
};

});
parcelRegister("hAhfP", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $ccd32ed3f909dfcb$export$25d302a5b900a763; });

var $6fzNH = parcelRequire("6fzNH");

var $iSvIT = parcelRequire("iSvIT");
var $ccd32ed3f909dfcb$var$_excluded = [
    "children"
];
function $ccd32ed3f909dfcb$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $iSvIT.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $iSvIT.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $6fzNH.default)(props, $ccd32ed3f909dfcb$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $iSvIT.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $iSvIT.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("kxnJk", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $ef394c029959b46b$export$18cb9425622d4e06; });
var $ef394c029959b46b$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $ef394c029959b46b$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "light";
    return $ef394c029959b46b$var$themedBackground[mode];
};

});

parcelRegister("lwAzL", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $fab8f5565569cfda$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "sizeStyleMap", function () { return $fab8f5565569cfda$export$ef0ad74202575b64; });

var $50ecP = parcelRequire("50ecP");

var $2ZUkg = parcelRequire("2ZUkg");
var $fab8f5565569cfda$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
var $fab8f5565569cfda$var$smallStyles = (0, $2ZUkg.css)((0, $50ecP.dimensions).small);
var $fab8f5565569cfda$var$mediumStyles = (0, $2ZUkg.css)((0, $50ecP.dimensions).medium);
var $fab8f5565569cfda$var$largeStyles = (0, $2ZUkg.css)((0, $50ecP.dimensions).large);
var $fab8f5565569cfda$var$xlargeStyles = (0, $2ZUkg.css)((0, $50ecP.dimensions).xlarge);
var $fab8f5565569cfda$export$ef0ad74202575b64 = {
    small: $fab8f5565569cfda$var$smallStyles,
    medium: $fab8f5565569cfda$var$mediumStyles,
    large: $fab8f5565569cfda$var$largeStyles,
    xlarge: $fab8f5565569cfda$var$xlargeStyles
};
var $fab8f5565569cfda$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $50ecP.dimensions)[size];
    return undefined;
};

});
parcelRegister("50ecP", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $3a47f8d8073f4a81$export$62ad7b0c781000e9; });
var $3a47f8d8073f4a81$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $3a47f8d8073f4a81$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $3a47f8d8073f4a81$export$62ad7b0c781000e9 = {
    small: {
        width: $3a47f8d8073f4a81$export$c647cb0ee6e282fe.small,
        height: $3a47f8d8073f4a81$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $3a47f8d8073f4a81$export$c647cb0ee6e282fe.medium,
        height: $3a47f8d8073f4a81$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $3a47f8d8073f4a81$export$c647cb0ee6e282fe.large,
        height: $3a47f8d8073f4a81$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $3a47f8d8073f4a81$export$c647cb0ee6e282fe.xlarge,
        height: $3a47f8d8073f4a81$export$c647cb0ee6e282fe.xlarge
    }
};

});




parcelRegister("h9ozc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7c655604a3a4252$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $2ZUkg = parcelRequire("2ZUkg");

var $5ritt = parcelRequire("5ritt");

var $kw3ka = parcelRequire("kw3ka");

var $2YUKm = parcelRequire("2YUKm");

var $8zvo2 = parcelRequire("8zvo2");
var $c7c655604a3a4252$var$labelStyles = (0, $2ZUkg.css)({
    display: "grid",
    gridAutoColumns: "1fr",
    gridAutoRows: "min-content",
    color: "var(--ds-text, ".concat((0, $5ritt.N900), ")"),
    cursor: "default",
    fontFamily: "var(--ds-font-family-sans, ".concat((0, $2YUKm.fontFamily), ")")
});
var $c7c655604a3a4252$var$textLabelLayoutStyles = (0, $2ZUkg.css)({
    gap: "var(--ds-space-0, 0px)".concat(" ", "var(--ds-space-050, 4px)"),
    gridTemplateColumns: "min-content auto"
});
var $c7c655604a3a4252$var$disabledStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text-disabled, ".concat((0, $5ritt.N80), ")"),
    cursor: "not-allowed"
});
var $c7c655604a3a4252$var$themeStyles = {
    light: (0, $2ZUkg.css)({
        /**
     * Background
     */ "--local-background": (0, $8zvo2.default).light.boxColor.rest,
        "--local-background-active": (0, $8zvo2.default).light.boxColor.active,
        "--local-background-checked": (0, $8zvo2.default).light.boxColor.checked,
        "--local-background-checked-hover": (0, $8zvo2.default).light.boxColor.hoveredAndChecked,
        "--local-background-disabled": (0, $8zvo2.default).light.boxColor.disabled,
        "--local-background-hover": (0, $8zvo2.default).light.boxColor.hovered,
        /**
     * Border
     */ "--local-border": (0, $8zvo2.default).light.borderColor.rest,
        "--local-border-active": (0, $8zvo2.default).light.borderColor.active,
        "--local-border-checked": (0, $8zvo2.default).light.borderColor.checked,
        "--local-border-checked-hover": (0, $8zvo2.default).light.borderColor.hoveredAndChecked,
        "--local-border-checked-invalid": (0, $8zvo2.default).light.borderColor.invalidAndChecked,
        "--local-border-disabled": (0, $8zvo2.default).light.borderColor.disabled,
        "--local-border-focus": (0, $8zvo2.default).light.borderColor.focused,
        "--local-border-hover": (0, $8zvo2.default).light.borderColor.hovered,
        "--local-border-invalid": (0, $8zvo2.default).light.borderColor.invalid,
        /**
     * Tick
     */ "--local-tick-active": (0, $8zvo2.default).light.tickColor.activeAndChecked,
        "--local-tick-checked": (0, $8zvo2.default).light.tickColor.checked,
        "--local-tick-disabled": (0, $8zvo2.default).light.tickColor.disabledAndChecked,
        "--local-tick-rest": "transparent"
    }),
    dark: (0, $2ZUkg.css)({
        /**
     * Background
     */ "--local-background": (0, $8zvo2.default).dark.boxColor.rest,
        "--local-background-active": (0, $8zvo2.default).dark.boxColor.active,
        "--local-background-checked": (0, $8zvo2.default).dark.boxColor.checked,
        "--local-background-checked-hover": (0, $8zvo2.default).dark.boxColor.hoveredAndChecked,
        "--local-background-disabled": (0, $8zvo2.default).dark.boxColor.disabled,
        "--local-background-hover": (0, $8zvo2.default).dark.boxColor.hovered,
        /**
     * Border
     */ "--local-border": (0, $8zvo2.default).dark.borderColor.rest,
        "--local-border-active": (0, $8zvo2.default).dark.borderColor.active,
        "--local-border-checked": (0, $8zvo2.default).dark.borderColor.checked,
        "--local-border-checked-hover": (0, $8zvo2.default).dark.borderColor.hoveredAndChecked,
        "--local-border-checked-invalid": (0, $8zvo2.default).dark.borderColor.invalidAndChecked,
        "--local-border-disabled": (0, $8zvo2.default).dark.borderColor.disabled,
        "--local-border-focus": (0, $8zvo2.default).dark.borderColor.focused,
        "--local-border-hover": (0, $8zvo2.default).dark.borderColor.hovered,
        "--local-border-invalid": (0, $8zvo2.default).dark.borderColor.invalid,
        /**
     * Tick
     */ "--local-tick-active": (0, $8zvo2.default).dark.tickColor.activeAndChecked,
        "--local-tick-checked": (0, $8zvo2.default).dark.tickColor.checked,
        "--local-tick-disabled": (0, $8zvo2.default).dark.tickColor.disabledAndChecked,
        "--local-tick-rest": "transparent"
    })
};
function $c7c655604a3a4252$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, testId = _ref.testId, label = _ref.label, id = _ref.id;
    var _useGlobalTheme = (0, $kw3ka.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $2ZUkg.jsx)("label", {
        css: [
            $c7c655604a3a4252$var$labelStyles,
            label && $c7c655604a3a4252$var$textLabelLayoutStyles,
            isDisabled && $c7c655604a3a4252$var$disabledStyles,
            mode === "light" && $c7c655604a3a4252$var$themeStyles.light,
            mode === "dark" && $c7c655604a3a4252$var$themeStyles.dark
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});
parcelRegister("5ritt", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $3f5dce01bba8dae7$export$4a7404f376229999; });
$parcel$export(module.exports, "R500", function () { return $3f5dce01bba8dae7$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "B50", function () { return $3f5dce01bba8dae7$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $3f5dce01bba8dae7$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B200", function () { return $3f5dce01bba8dae7$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $3f5dce01bba8dae7$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $3f5dce01bba8dae7$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N10", function () { return $3f5dce01bba8dae7$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $3f5dce01bba8dae7$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $3f5dce01bba8dae7$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $3f5dce01bba8dae7$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N70", function () { return $3f5dce01bba8dae7$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N80", function () { return $3f5dce01bba8dae7$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "N100", function () { return $3f5dce01bba8dae7$export$d6447c357493214f; });
$parcel$export(module.exports, "N900", function () { return $3f5dce01bba8dae7$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N30A", function () { return $3f5dce01bba8dae7$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN200", function () { return $3f5dce01bba8dae7$export$bfe21c59123ecf33; });
$parcel$export(module.exports, "DN90", function () { return $3f5dce01bba8dae7$export$682927c6ed76be02; });
$parcel$export(module.exports, "DN80", function () { return $3f5dce01bba8dae7$export$91fd9994c5be9757; });
$parcel$export(module.exports, "DN30", function () { return $3f5dce01bba8dae7$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN10", function () { return $3f5dce01bba8dae7$export$6c813d5160dff5db; });
$parcel$export(module.exports, "skeleton", function () { return $3f5dce01bba8dae7$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $kItww = parcelRequire("kItww");
var $3f5dce01bba8dae7$export$4b84fd0e2c617bd = "#FFEBE6";
var $3f5dce01bba8dae7$export$b34b069eff244586 = "#FFBDAD";
var $3f5dce01bba8dae7$export$be802dd0d8b57f35 = "#FF8F73";
var $3f5dce01bba8dae7$export$60847d42f9da92a6 = "#FF7452";
var $3f5dce01bba8dae7$export$4a7404f376229999 = "#FF5630";
var $3f5dce01bba8dae7$export$2010d0fb4295b346 = "#DE350B";
var $3f5dce01bba8dae7$export$2837b5a1a71d5c02 = "#BF2600";
var $3f5dce01bba8dae7$export$8d9596b529bbb9cf = "#FFFAE6";
var $3f5dce01bba8dae7$export$41060a744ab0b7ae = "#FFF0B3";
var $3f5dce01bba8dae7$export$1cc05bbbf340e559 = "#FFE380";
var $3f5dce01bba8dae7$export$5aae31392d72caaa = "#FFC400";
var $3f5dce01bba8dae7$export$c6930421db9fa514 = "#FFAB00";
var $3f5dce01bba8dae7$export$59619663aa6500fb = "#FF991F";
var $3f5dce01bba8dae7$export$874739ea9e379ab6 = "#FF8B00";
var $3f5dce01bba8dae7$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $3f5dce01bba8dae7$export$69a3bf21b9686c2b = "#ABF5D1";
var $3f5dce01bba8dae7$export$afbce1382ec95f73 = "#79F2C0";
var $3f5dce01bba8dae7$export$747d86715d4175de = "#57D9A3";
var $3f5dce01bba8dae7$export$940e1f69e873f202 = "#36B37E";
var $3f5dce01bba8dae7$export$a49394138f7b8e85 = "#00875A";
var $3f5dce01bba8dae7$export$6fa04827ac68a4fb = "#006644";
var $3f5dce01bba8dae7$export$226de0355ed012f8 = "#DEEBFF";
var $3f5dce01bba8dae7$export$8c13c2ee36917869 = "#B3D4FF";
var $3f5dce01bba8dae7$export$ecfc1dff386a3e7a = "#4C9AFF";
var $3f5dce01bba8dae7$export$215b7063051591f1 = "#2684FF";
var $3f5dce01bba8dae7$export$e62e8919cca44969 = "#0065FF";
var $3f5dce01bba8dae7$export$b3de0ae08da2ce64 = "#0052CC";
var $3f5dce01bba8dae7$export$a6ee3d71bc067634 = "#0747A6";
var $3f5dce01bba8dae7$export$363e4475840015bb = "#EAE6FF";
var $3f5dce01bba8dae7$export$4b0a4417ed59760f = "#C0B6F2";
var $3f5dce01bba8dae7$export$6011520a64d9a187 = "#998DD9";
var $3f5dce01bba8dae7$export$a7175d4e9206bc80 = "#8777D9";
var $3f5dce01bba8dae7$export$b48405b95304b5a1 = "#6554C0";
var $3f5dce01bba8dae7$export$c71e4279dd54a18d = "#5243AA";
var $3f5dce01bba8dae7$export$147899de772240ec = "#403294";
var $3f5dce01bba8dae7$export$2cf711fe14c66f06 = "#E6FCFF";
var $3f5dce01bba8dae7$export$7a8f4d33f6f9772c = "#B3F5FF";
var $3f5dce01bba8dae7$export$776c9c497ef08533 = "#79E2F2";
var $3f5dce01bba8dae7$export$69cb3ca10c1e330e = "#00C7E6";
var $3f5dce01bba8dae7$export$9dc1ef0f3f48059b = "#00B8D9";
var $3f5dce01bba8dae7$export$7c835c78b6fcdef8 = "#00A3BF";
var $3f5dce01bba8dae7$export$6036577f95c3877e = "#008DA6";
var $3f5dce01bba8dae7$export$29a4f05edc054374 = "#FFFFFF";
var $3f5dce01bba8dae7$export$e655ef011c4aa1a2 = "#FAFBFC";
var $3f5dce01bba8dae7$export$9fdfb749e33cdf97 = "#F4F5F7";
var $3f5dce01bba8dae7$export$3e51e8f1440314ba = "#EBECF0";
var $3f5dce01bba8dae7$export$1ce2d1575d444ceb = "#DFE1E6";
var $3f5dce01bba8dae7$export$8754fc7e6d8b3000 = "#C1C7D0";
var $3f5dce01bba8dae7$export$c2e91cbeada39b8b = "#B3BAC5";
var $3f5dce01bba8dae7$export$5f71e19f3a7ad9de = "#A5ADBA";
var $3f5dce01bba8dae7$export$eaa8c8a70ac22806 = "#97A0AF";
var $3f5dce01bba8dae7$export$7c87d337fb91a97d = "#8993A4";
var $3f5dce01bba8dae7$export$d6447c357493214f = "#7A869A";
var $3f5dce01bba8dae7$export$f563ee71e9ee74cd = "#6B778C";
var $3f5dce01bba8dae7$export$e2ef2124cf4024b1 = "#5E6C84";
var $3f5dce01bba8dae7$export$eece5f492e429f08 = "#505F79";
var $3f5dce01bba8dae7$export$c39c0fe0f26207ae = "#42526E";
var $3f5dce01bba8dae7$export$7090862dc3038a9f = "#344563";
var $3f5dce01bba8dae7$export$ad0bacf983b7ddaa = "#253858";
var $3f5dce01bba8dae7$export$7d61b15e0da132af = "#172B4D";
var $3f5dce01bba8dae7$export$fbda843f0a27fe96 = "#091E42";
var $3f5dce01bba8dae7$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $3f5dce01bba8dae7$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $3f5dce01bba8dae7$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $3f5dce01bba8dae7$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $3f5dce01bba8dae7$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $3f5dce01bba8dae7$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $3f5dce01bba8dae7$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $3f5dce01bba8dae7$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $3f5dce01bba8dae7$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $3f5dce01bba8dae7$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $3f5dce01bba8dae7$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $3f5dce01bba8dae7$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $3f5dce01bba8dae7$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $3f5dce01bba8dae7$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $3f5dce01bba8dae7$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $3f5dce01bba8dae7$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $3f5dce01bba8dae7$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $3f5dce01bba8dae7$export$2f6319cf7d736c2a = "#E6EDFA";
var $3f5dce01bba8dae7$export$95126bc8884d6634 = "#DCE5F5";
var $3f5dce01bba8dae7$export$8338d8c35d44ff1 = "#CED9EB";
var $3f5dce01bba8dae7$export$5368d76ae4fbbda7 = "#B8C7E0";
var $3f5dce01bba8dae7$export$9f0a771d16ec8d36 = "#ABBBD6";
var $3f5dce01bba8dae7$export$abcf8c38338b4aa5 = "#9FB0CC";
var $3f5dce01bba8dae7$export$97e81faa16a182c7 = "#8C9CB8";
var $3f5dce01bba8dae7$export$bfe21c59123ecf33 = "#7988A3";
var $3f5dce01bba8dae7$export$ee82aa2ea6a1558 = "#67758F";
var $3f5dce01bba8dae7$export$682927c6ed76be02 = "#56637A";
var $3f5dce01bba8dae7$export$91fd9994c5be9757 = "#455166";
var $3f5dce01bba8dae7$export$d281fbfe3cff2df6 = "#3B475C";
var $3f5dce01bba8dae7$export$3902c91d8b98a753 = "#313D52";
var $3f5dce01bba8dae7$export$8e8133c1ba5845b5 = "#283447";
var $3f5dce01bba8dae7$export$33ff357f6620b39 = "#202B3D";
var $3f5dce01bba8dae7$export$633847cf062b69e0 = "#1B2638";
var $3f5dce01bba8dae7$export$9776a6e503bdbf76 = "#121A29";
var $3f5dce01bba8dae7$export$6c813d5160dff5db = "#0E1624";
var $3f5dce01bba8dae7$export$3d4f271a500072a = "#0D1424";
var $3f5dce01bba8dae7$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $3f5dce01bba8dae7$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $3f5dce01bba8dae7$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $3f5dce01bba8dae7$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $3f5dce01bba8dae7$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $3f5dce01bba8dae7$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $3f5dce01bba8dae7$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $3f5dce01bba8dae7$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $3f5dce01bba8dae7$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $3f5dce01bba8dae7$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $3f5dce01bba8dae7$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $3f5dce01bba8dae7$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $3f5dce01bba8dae7$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $3f5dce01bba8dae7$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $3f5dce01bba8dae7$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $3f5dce01bba8dae7$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $3f5dce01bba8dae7$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $3f5dce01bba8dae7$export$8ce1fd94bee2f412 = (0, $kItww.default)({
    light: "var(--ds-surface, ".concat($3f5dce01bba8dae7$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($3f5dce01bba8dae7$export$633847cf062b69e0, ")")
});
var $3f5dce01bba8dae7$export$b861914ea877b580 = (0, $kItww.default)({
    light: "var(--ds-background-selected, ".concat($3f5dce01bba8dae7$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($3f5dce01bba8dae7$export$8c13c2ee36917869, ")")
});
var $3f5dce01bba8dae7$export$3f1b020df94387af = (0, $kItww.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($3f5dce01bba8dae7$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($3f5dce01bba8dae7$export$d281fbfe3cff2df6, ")")
});
var $3f5dce01bba8dae7$export$c0183dbab98ca63e = (0, $kItww.default)({
    light: "var(--ds-surface-overlay, ".concat($3f5dce01bba8dae7$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($3f5dce01bba8dae7$export$8e8133c1ba5845b5, ")")
});
var $3f5dce01bba8dae7$export$6f093cfa640b7166 = (0, $kItww.default)({
    light: "var(--ds-text, ".concat($3f5dce01bba8dae7$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($3f5dce01bba8dae7$export$5368d76ae4fbbda7, ")")
});
var $3f5dce01bba8dae7$export$42f8e9c698766e7a = (0, $kItww.default)({
    light: "var(--ds-text, ".concat($3f5dce01bba8dae7$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($3f5dce01bba8dae7$export$5368d76ae4fbbda7, ")")
});
var $3f5dce01bba8dae7$export$c2d157ca1c34b6e3 = (0, $kItww.default)({
    light: "var(--ds-text-selected, ".concat($3f5dce01bba8dae7$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($3f5dce01bba8dae7$export$b3de0ae08da2ce64, ")")
});
var $3f5dce01bba8dae7$export$1905ba28d7cf066f = (0, $kItww.default)({
    light: "var(--ds-text-subtlest, ".concat($3f5dce01bba8dae7$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($3f5dce01bba8dae7$export$97e81faa16a182c7, ")")
});
var $3f5dce01bba8dae7$export$bd9002130d306d39 = (0, $kItww.default)({
    light: "var(--ds-text-subtlest, ".concat($3f5dce01bba8dae7$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($3f5dce01bba8dae7$export$bfe21c59123ecf33, ")")
});
var $3f5dce01bba8dae7$export$46e4a324ac90507f = (0, $kItww.default)({
    light: "var(--ds-text, ".concat($3f5dce01bba8dae7$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($3f5dce01bba8dae7$export$5368d76ae4fbbda7, ")")
});
var $3f5dce01bba8dae7$export$79f3f2b82beb0d36 = (0, $kItww.default)({
    light: "var(--ds-text-subtlest, ".concat($3f5dce01bba8dae7$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($3f5dce01bba8dae7$export$97e81faa16a182c7, ")")
});
var $3f5dce01bba8dae7$export$7bb0d5c671655cc4 = (0, $kItww.default)({
    light: $3f5dce01bba8dae7$export$9fdfb749e33cdf97,
    dark: $3f5dce01bba8dae7$export$8e8133c1ba5845b5
});
var $3f5dce01bba8dae7$export$9c30223ca0a664fb = (0, $kItww.default)({
    light: "var(--ds-link, ".concat($3f5dce01bba8dae7$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($3f5dce01bba8dae7$export$ecfc1dff386a3e7a, ")")
});
var $3f5dce01bba8dae7$export$7ed258b0728b004b = (0, $kItww.default)({
    light: "var(--ds-link-pressed, ".concat($3f5dce01bba8dae7$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($3f5dce01bba8dae7$export$215b7063051591f1, ")")
});
var $3f5dce01bba8dae7$export$dfa920d8decc8a59 = (0, $kItww.default)({
    light: "var(--ds-link-pressed, ".concat($3f5dce01bba8dae7$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($3f5dce01bba8dae7$export$ecfc1dff386a3e7a, ")")
});
var $3f5dce01bba8dae7$export$6069e6ad5c78f632 = (0, $kItww.default)({
    light: "var(--ds-border-focused, ".concat($3f5dce01bba8dae7$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($3f5dce01bba8dae7$export$215b7063051591f1, ")")
});
var $3f5dce01bba8dae7$export$9ad721cf3b3debe0 = (0, $kItww.default)({
    light: "var(--ds-background-brand-bold, ".concat($3f5dce01bba8dae7$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($3f5dce01bba8dae7$export$ecfc1dff386a3e7a, ")")
});
var $3f5dce01bba8dae7$export$2aa0182783e7e9de = (0, $kItww.default)({
    light: $3f5dce01bba8dae7$export$b3de0ae08da2ce64,
    dark: $3f5dce01bba8dae7$export$ecfc1dff386a3e7a
});
var $3f5dce01bba8dae7$export$8bf7dff220b82b4a = (0, $kItww.default)({
    light: $3f5dce01bba8dae7$export$9dc1ef0f3f48059b,
    dark: $3f5dce01bba8dae7$export$69cb3ca10c1e330e
});
var $3f5dce01bba8dae7$export$e13cce2a2d16a9d4 = (0, $kItww.default)({
    light: $3f5dce01bba8dae7$export$b48405b95304b5a1,
    dark: $3f5dce01bba8dae7$export$6011520a64d9a187
});
var $3f5dce01bba8dae7$export$a90204d1394caf30 = (0, $kItww.default)({
    light: $3f5dce01bba8dae7$export$4a7404f376229999,
    dark: $3f5dce01bba8dae7$export$4a7404f376229999
});
var $3f5dce01bba8dae7$export$594c5a8758200c32 = (0, $kItww.default)({
    light: $3f5dce01bba8dae7$export$c6930421db9fa514,
    dark: $3f5dce01bba8dae7$export$c6930421db9fa514
});
var $3f5dce01bba8dae7$export$955a2ebd2fb142ae = (0, $kItww.default)({
    light: $3f5dce01bba8dae7$export$940e1f69e873f202,
    dark: $3f5dce01bba8dae7$export$940e1f69e873f202
});
var $3f5dce01bba8dae7$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($3f5dce01bba8dae7$export$8d43898f60b96a82, ")");
};

});
parcelRegister("kItww", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f14ed17348408500$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $gOSYe = parcelRequire("gOSYe");
// Unpack custom variants, and get correct value for the current theme
function $f14ed17348408500$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $gOSYe.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $f14ed17348408500$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $f14ed17348408500$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $gOSYe.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("gOSYe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3ebf4d96e723393$export$2e2bcd8739ae039; });

var $5FHHN = parcelRequire("5FHHN");
function $c3ebf4d96e723393$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $5FHHN.CHANNEL) in props.theme) return props.theme[0, $5FHHN.CHANNEL];
        else if ("mode" in props.theme && (0, $5FHHN.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $5FHHN.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("5FHHN", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $4212af0d1940b502$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $4212af0d1940b502$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $4212af0d1940b502$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "fontFamily", function () { return $4212af0d1940b502$export$a5975749f0374264; });

var $crT8a = parcelRequire("crT8a");

var $5ritt = parcelRequire("5ritt");
var $4212af0d1940b502$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $4212af0d1940b502$export$c93026a968943f95 = "light";
var $4212af0d1940b502$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $4212af0d1940b502$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $4212af0d1940b502$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $4212af0d1940b502$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $4212af0d1940b502$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $4212af0d1940b502$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $4212af0d1940b502$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $4212af0d1940b502$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $5ritt.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $4212af0d1940b502$export$6d8204c2cb2e06b8() / 4;
    (0, $crT8a.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $4212af0d1940b502$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $4212af0d1940b502$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $4212af0d1940b502$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $crT8a.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $4212af0d1940b502$export$ba1d834b86d72a09 = $4212af0d1940b502$export$a1b3edb637fb4f35;
var $4212af0d1940b502$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $5ritt.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $5ritt.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $5ritt.N30A), ")")
            }
        }
    };
};

});
parcelRegister("crT8a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9102c57781ea3eef$export$2e2bcd8739ae039; });

var $1AypZ = parcelRequire("1AypZ");

var $XAEGR = parcelRequire("XAEGR");
function $9102c57781ea3eef$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $1AypZ.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $9102c57781ea3eef$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $XAEGR;
}

});
parcelRegister("1AypZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1283d9f2c71dc1c3$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $1283d9f2c71dc1c3$var$printed = {};
function $1283d9f2c71dc1c3$export$2e2bcd8739ae039(message) {
    if ($1283d9f2c71dc1c3$var$printed[message]) return;
    $1283d9f2c71dc1c3$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}

});






parcelRegister("2YUKm", function(module, exports) {

$parcel$export(module.exports, "fontFamily", function () { return $22bd341197c4bf2c$export$a5975749f0374264; });

var $5FHHN = parcelRequire("5FHHN");
var $22bd341197c4bf2c$export$a5975749f0374264 = (0, $5FHHN.fontFamily)();

});

parcelRegister("8zvo2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63d9f05efa832be7$export$2e2bcd8739ae039; });

var $lN9Ao = parcelRequire("lN9Ao");

var $5ritt = parcelRequire("5ritt");
var $63d9f05efa832be7$var$theme = {
    light: {
        borderColor: {
            rest: (0, $lN9Ao.getBooleanFF)("platform.design-system-team.update-border-radio-checkbox_7askv") ? "var(--ds-border-bold, ".concat((0, $5ritt.N100), ")") : "var(--ds-border-input, ".concat((0, $5ritt.N40), ")"),
            hovered: (0, $lN9Ao.getBooleanFF)("platform.design-system-team.update-border-radio-checkbox_7askv") ? "var(--ds-border-bold, ".concat((0, $5ritt.N100), ")") : "var(--ds-border-input, ".concat((0, $5ritt.N40), ")"),
            disabled: "var(--ds-background-disabled, ".concat((0, $5ritt.N20), ")"),
            checked: "var(--ds-background-selected-bold, ".concat((0, $5ritt.B400), ")"),
            active: "var(--ds-border, ".concat((0, $5ritt.B50), ")"),
            invalid: "var(--ds-border-danger, ".concat((0, $5ritt.R300), ")"),
            invalidAndChecked: "var(--ds-border-danger, ".concat((0, $5ritt.R300), ")"),
            focused: "var(--ds-border-focused, ".concat((0, $5ritt.B200), ")"),
            hoveredAndChecked: "var(--ds-background-selected-bold-hovered, ".concat((0, $5ritt.B300), ")")
        },
        boxColor: {
            rest: "var(--ds-background-input, ".concat((0, $5ritt.N10), ")"),
            hovered: "var(--ds-background-input-hovered, ".concat((0, $5ritt.N30), ")"),
            disabled: "var(--ds-background-disabled, ".concat((0, $5ritt.N20), ")"),
            active: "var(--ds-background-input-pressed, ".concat((0, $5ritt.B50), ")"),
            hoveredAndChecked: "var(--ds-background-selected-bold-hovered, ".concat((0, $5ritt.B300), ")"),
            checked: "var(--ds-background-selected-bold, ".concat((0, $5ritt.B400), ")")
        },
        tickColor: {
            disabledAndChecked: "var(--ds-icon-disabled, ".concat((0, $5ritt.N70), ")"),
            activeAndChecked: "var(--ds-icon-inverse, ".concat((0, $5ritt.B400), ")"),
            checked: "var(--ds-icon-inverse, ".concat((0, $5ritt.N10), ")")
        }
    },
    dark: {
        borderColor: {
            rest: (0, $lN9Ao.getBooleanFF)("platform.design-system-team.update-border-radio-checkbox_7askv") ? "var(--ds-border-bold, ".concat((0, $5ritt.DN200), ")") : "var(--ds-border-input, ".concat((0, $5ritt.DN80), ")"),
            hovered: "var(--ds-border-input, ".concat((0, $5ritt.DN200), ")"),
            disabled: "var(--ds-background-disabled, ".concat((0, $5ritt.DN10), ")"),
            checked: "var(--ds-background-selected-bold, ".concat((0, $5ritt.B400), ")"),
            active: "var(--ds-border, ".concat((0, $5ritt.B200), ")"),
            invalid: "var(--ds-border-danger, ".concat((0, $5ritt.R300), ")"),
            invalidAndChecked: "var(--ds-border-danger, ".concat((0, $5ritt.R300), ")"),
            focused: "var(--ds-border-focused, ".concat((0, $5ritt.B75), ")"),
            hoveredAndChecked: "var(--ds-background-selected-bold-hovered, ".concat((0, $5ritt.B75), ")")
        },
        boxColor: {
            rest: "var(--ds-background-input, ".concat((0, $5ritt.DN10), ")"),
            hovered: "var(--ds-background-input-hovered, ".concat((0, $5ritt.DN30), ")"),
            disabled: "var(--ds-background-disabled, ".concat((0, $5ritt.DN10), ")"),
            active: "var(--ds-background-input-pressed, ".concat((0, $5ritt.B200), ")"),
            hoveredAndChecked: "var(--ds-background-selected-bold-hovered, ".concat((0, $5ritt.B75), ")"),
            checked: "var(--ds-background-selected-bold, ".concat((0, $5ritt.B400), ")")
        },
        tickColor: {
            disabledAndChecked: "var(--ds-icon-disabled, ".concat((0, $5ritt.DN90), ")"),
            activeAndChecked: "var(--ds-icon-inverse, ".concat((0, $5ritt.DN10), ")"),
            checked: "var(--ds-icon-inverse, ".concat((0, $5ritt.DN10), ")")
        }
    }
};
var $63d9f05efa832be7$export$2e2bcd8739ae039 = $63d9f05efa832be7$var$theme;

});


parcelRegister("h32HL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c694d09b6e682acb$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $2ZUkg = parcelRequire("2ZUkg");
var $c694d09b6e682acb$var$labelTextStyles = (0, $2ZUkg.css)({
    alignSelf: "center",
    gridArea: "1 / 2 / 2 / 3"
});
function $c694d09b6e682acb$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return (0, $2ZUkg.jsx)("span", {
        css: $c694d09b6e682acb$var$labelTextStyles
    }, children);
}

});

parcelRegister("6UVdu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50945b119d9abf4a$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $2ZUkg = parcelRequire("2ZUkg");

var $5ritt = parcelRequire("5ritt");
var $50945b119d9abf4a$var$requiredIndicatorStyles = (0, $2ZUkg.css)({
    paddingLeft: "var(--ds-space-025, 2px)",
    color: "var(--ds-text-danger, ".concat((0, $5ritt.R500), ")")
});
function $50945b119d9abf4a$export$2e2bcd8739ae039() {
    return (0, $2ZUkg.jsx)("span", {
        css: $50945b119d9abf4a$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});


parcelRegister("1cFxM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70e4741cbfa8f6087ac64902b38a7366>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e072330d63539b0$var$_react = $0e072330d63539b0$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $0e072330d63539b0$var$_baseNew = $0e072330d63539b0$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $0e072330d63539b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e072330d63539b0$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $0e072330d63539b0$var$_react.default.createElement($0e072330d63539b0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$0e072330d63539b0$var$CrossCircleIcon.displayName = "CrossCircleIcon";
var $0e072330d63539b0$var$_default = module.exports.default = $0e072330d63539b0$var$CrossCircleIcon;

});

parcelRegister("8UUGz", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $67df864366923ec5$export$f680877a34711e37; });

var $d05Rs = parcelRequire("d05Rs");

var $iSvIT = parcelRequire("iSvIT");

var $lzzak = parcelRequire("lzzak");

var $3NArX = parcelRequire("3NArX");
var $67df864366923ec5$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $67df864366923ec5$var$react18UseId = ($67df864366923ec5$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useId) !== null && $67df864366923ec5$var$_React$useId !== void 0 ? $67df864366923ec5$var$_React$useId : undefined;
function $67df864366923ec5$export$f680877a34711e37() {
    if ($67df864366923ec5$var$react18UseId && (0, $3NArX.fg)("platform.design-system-team.react-18-use-id_mn8q4")) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $67df864366923ec5$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $lzzak.useUID)());
}
var $67df864366923ec5$export$6be90bcb437e928f = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($67df864366923ec5$export$f680877a34711e37()).concat(postfix);
    (0, $iSvIT.useEffect)(function() {
        if (!ref) return;
        switch((0, $d05Rs.default)(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, $d05Rs.default)(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $67df864366923ec5$export$6ee17796e3d70de2() {
    if ($67df864366923ec5$var$react18UseId && (0, $3NArX.fg)("platform.design-system-team.react-18-use-id_mn8q4")) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $67df864366923ec5$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $lzzak.useUIDSeed)();
}

});

parcelRegister("4cm4O", function(module, exports) {

$parcel$export(module.exports, "BitbucketIcon", function () { return $30e9685f4e5f4451$export$5fc1066e677788d4; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $30e9685f4e5f4451$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill='.concat(colors.iconColor, ' d="m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95"/>\n    </svg>');
};
var $30e9685f4e5f4451$export$5fc1066e677788d4 = function BitbucketIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Bitbucket" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        svg: $30e9685f4e5f4451$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("SBv14", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", function () { return $0a4221d53d079a25$export$68f3db7f6af48bcb; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $0a4221d53d079a25$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>\n    </svg>');
};
var $0a4221d53d079a25$export$68f3db7f6af48bcb = function ConfluenceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Confluence" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        svg: $0a4221d53d079a25$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("i9ZDc", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementIcon", function () { return $d388dfec80f457df$export$3c6158790f5e01c4; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $d388dfec80f457df$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill='.concat(colors.iconColor, ' d="M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z"/>\n    </svg>');
};
var $d388dfec80f457df$export$3c6158790f5e01c4 = function JiraServiceManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Service Management" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        svg: $d388dfec80f457df$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("8GbB2", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareIcon", function () { return $651b3dc8845704f0$export$c3835feba2a66e67; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $8UUGz = parcelRequire("8UUGz");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $651b3dc8845704f0$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: (0, $hFZoE.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $hFZoE.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return '\n  <svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">\n    <defs>\n      <linearGradient x1="108.695%" x2="12.439%" y1="-14.936%" y2="45.215%" id="'.concat(id, '-1">\n        <stop stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' offset="0%"></stop>\n        <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%"></stop>\n      </linearGradient>\n      <linearGradient x1="0%" x2="91.029%" y1="118.55%" y2="63.971%" id="').concat(id, '-2">\n        <stop stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' offset="0%"></stop>\n        <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke="none" stroke-width="1" fill-rule="nonzero">\n      <path fill="').concat(colors.iconColor, '" d="M15.9669691 29.3616152C17.2195568 28.1097726 17.9233158 26.4114623 17.9233158 24.6405626 17.9233158 22.8696629 17.2195568 21.1713527 15.9669691 19.91951L7.26805808 11.2489111 3.31143376 15.2055354C2.89743442 15.6200502 2.89743442 16.291565 3.31143376 16.7060799L15.9669691 29.3616152zM28.6225045 15.2055354L15.9669691 2.55 15.9280399 2.58892922C13.3485687 5.19994003 13.3612164 9.40374108 15.9563521 11.9991833L24.6623412 20.6662432 28.6225045 16.7060799C29.0365039 16.291565 29.0365039 15.6200502 28.6225045 15.2055354z" />\n      <path fill="url(#').concat(id, '-1" d="M15.9669691,11.9921053 C13.3718335,9.39666304 13.3591857,5.19286199 15.938657,2.58185118 L6.91061706,11.6063521 L11.6316697,16.3274047 L15.9669691,11.9921053 Z" />\n      <path fill="url(#').concat(id, '-2" d="M20.2951906,15.5912886 L15.9669691,19.91951 C17.2195568,21.1713527 17.9233158,22.8696629 17.9233158,24.6405626 C17.9233158,26.4114623 17.2195568,28.1097726 15.9669691,29.3616152 L25.0162432,20.3123412 L20.2951906,15.5912886 Z" />\n    </g>\n  </svg>');
};
var $651b3dc8845704f0$export$c3835feba2a66e67 = function JiraSoftwareIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Software" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $8UUGz.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        svg: $651b3dc8845704f0$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("lkZfy", function(module, exports) {

$parcel$export(module.exports, "JiraWorkManagementIcon", function () { return $f88afa30381c0530$export$7330b9fc5718fd30; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $8UUGz = parcelRequire("8UUGz");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $f88afa30381c0530$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: (0, $hFZoE.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $hFZoE.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return '\n    <svg\n      fill="none"\n      height="32"\n      viewBox="0 0 32 32"\n      xmlns="http://www.w3.org/2000/svg"\n    >\n      <linearGradient\n        id="'.concat(id, '"\n        gradientUnits="userSpaceOnUse"\n        x1="13.9485"\n        x2="20.7792"\n        y1="20.2388"\n        y2="11.8277"\n      >\n        <stop offset="0" stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' />\n        <stop offset="100%" stop-color="').concat(colors.iconGradientStop, '" />\n      </linearGradient>\n      <path\n        d="m18.3893 7-3.4257 13.1867c4.3592 1.2052 7.8383-.3558 9.1709-5.4802l1.9988-7.6973z"\n        fill="url(#').concat(id, ')"\n      />\n      <path\n      fill="').concat(colors.iconColor, '"\n      d="m13.7566 24.8265 3.4257-13.1866c-4.3623-1.196-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z"\n      />\n    </svg>');
};
var $f88afa30381c0530$export$7330b9fc5718fd30 = function JiraWorkManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Work Management" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $8UUGz.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        svg: $f88afa30381c0530$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("6hUR8", function(module, exports) {

$parcel$export(module.exports, "AtlassianAdminIcon", function () { return $49406f09a7705948$export$84109e099492cb5f; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $49406f09a7705948$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">\n      <path\n        d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z"\n        fill="'.concat(colors.iconColor, '"\n      />\n    </svg>');
};
var $49406f09a7705948$export$84109e099492cb5f = function AtlassianAdminIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian Admin" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        svg: $49406f09a7705948$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2X17f", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8054c1d672105cf334f7f37a83f0cf2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2261f51209fdb137$var$_react = $2261f51209fdb137$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $2261f51209fdb137$var$_baseNew = $2261f51209fdb137$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $2261f51209fdb137$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2261f51209fdb137$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $2261f51209fdb137$var$_react.default.createElement($2261f51209fdb137$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 4V1h1.5v3zM5.47 6.53l-4-4 1.06-1.06 4 4zm4-1.06 4-4 1.06 1.06-4 4zM1 7.25h3v1.5H1zm11 0h3v1.5h-3zM1.47 13.47l4-4 1.06 1.06-4 4zm12 1.06-4-4 1.06-1.06 4 4zM7.25 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$2261f51209fdb137$var$AtlassianIntelligenceIcon.displayName = "AtlassianIntelligenceIcon";
var $2261f51209fdb137$var$_default = module.exports.default = $2261f51209fdb137$var$AtlassianIntelligenceIcon;

});

parcelRegister("fAXUo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19440c8dd0e3db5766add744ad314d45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5a8b06569b97ba9$var$_react = $b5a8b06569b97ba9$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b5a8b06569b97ba9$var$_baseNew = $b5a8b06569b97ba9$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b5a8b06569b97ba9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b5a8b06569b97ba9$var$EmailIcon = (props)=>/*#__PURE__*/ $b5a8b06569b97ba9$var$_react.default.createElement($b5a8b06569b97ba9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$b5a8b06569b97ba9$var$EmailIcon.displayName = "EmailIcon";
var $b5a8b06569b97ba9$var$_default = module.exports.default = $b5a8b06569b97ba9$var$EmailIcon;

});

parcelRegister("3uD1D", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28b2720e9e231e40$var$_react = $28b2720e9e231e40$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $28b2720e9e231e40$var$_baseNew = $28b2720e9e231e40$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $28b2720e9e231e40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $28b2720e9e231e40$var$LockLockedIcon = (props)=>/*#__PURE__*/ $28b2720e9e231e40$var$_react.default.createElement($28b2720e9e231e40$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$28b2720e9e231e40$var$LockLockedIcon.displayName = "LockLockedIcon";
var $28b2720e9e231e40$var$_default = module.exports.default = $28b2720e9e231e40$var$LockLockedIcon;

});

parcelRegister("iHmgk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aedef9bb726854d64999097926d2fc86>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9cd82fde84d01f4$var$_react = $d9cd82fde84d01f4$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $d9cd82fde84d01f4$var$_baseNew = $d9cd82fde84d01f4$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $d9cd82fde84d01f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d9cd82fde84d01f4$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $d9cd82fde84d01f4$var$_react.default.createElement($d9cd82fde84d01f4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$d9cd82fde84d01f4$var$PersonAvatarIcon.displayName = "PersonAvatarIcon";
var $d9cd82fde84d01f4$var$_default = module.exports.default = $d9cd82fde84d01f4$var$PersonAvatarIcon;

});

parcelRegister("fkwrS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b34e6857b52d4ec156a688609aa0810c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b291e4eada3682d9$var$_react = $b291e4eada3682d9$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b291e4eada3682d9$var$_baseNew = $b291e4eada3682d9$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b291e4eada3682d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Phone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: call us, phone number input.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b291e4eada3682d9$var$PhoneIcon = (props)=>/*#__PURE__*/ $b291e4eada3682d9$var$_react.default.createElement($b291e4eada3682d9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h3.5a.75.75 0 0 1 .721.544l.821 2.874a1.75 1.75 0 0 1-.562 1.825L4.29 7.86c.975 1.55 2.3 2.875 3.85 3.85l1.617-1.94a1.75 1.75 0 0 1 1.825-.562l2.874.82a.75.75 0 0 1 .544.722v3.5a.75.75 0 0 1-.75.75c-2.266 0-4.422-.61-6.309-1.664a13.77 13.77 0 0 1-5.277-5.277A12.9 12.9 0 0 1 1 1.75m8.484 10.69c1.25.578 2.606.94 4.016 1.035v-2.16l-2.33-.665a.25.25 0 0 0-.26.08zM3.56 6.516 5.27 5.09a.25.25 0 0 0 .08-.261L4.684 2.5H2.525A11.4 11.4 0 0 0 3.56 6.516" clip-rule="evenodd"/>`
    }, props));
$b291e4eada3682d9$var$PhoneIcon.displayName = "PhoneIcon";
var $b291e4eada3682d9$var$_default = module.exports.default = $b291e4eada3682d9$var$PhoneIcon;

});

parcelRegister("guk0p", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7de7c2be3f7c9d9cc79e629bb0768f3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c00ef75bf5693ff4$var$_react = $c00ef75bf5693ff4$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $c00ef75bf5693ff4$var$_baseNew = $c00ef75bf5693ff4$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $c00ef75bf5693ff4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Timeline".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for timelines in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c00ef75bf5693ff4$var$TimelineIcon = (props)=>/*#__PURE__*/ $c00ef75bf5693ff4$var$_react.default.createElement($c00ef75bf5693ff4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11 2.5H1V1h10zm4 4.167H5v-1.5h10zm-4 4.167H1v-1.5h10zM15 15H5v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$c00ef75bf5693ff4$var$TimelineIcon.displayName = "TimelineIcon";
var $c00ef75bf5693ff4$var$_default = module.exports.default = $c00ef75bf5693ff4$var$TimelineIcon;

});

parcelRegister("7ZFBY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c615014b011664b243a37531e093f861>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d1e8213996c7b0a$var$_react = $5d1e8213996c7b0a$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $5d1e8213996c7b0a$var$_baseNew = $5d1e8213996c7b0a$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $5d1e8213996c7b0a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d1e8213996c7b0a$var$WarningIcon = (props)=>/*#__PURE__*/ $5d1e8213996c7b0a$var$_react.default.createElement($5d1e8213996c7b0a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.169c.757-1.396 2.76-1.396 3.516 0l5.9 10.878C16.381 13.379 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$5d1e8213996c7b0a$var$WarningIcon.displayName = "WarningIcon";
var $5d1e8213996c7b0a$var$_default = module.exports.default = $5d1e8213996c7b0a$var$WarningIcon;

});

parcelRegister("eueWN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8bb9804f9ea7eaa10f227008c94bcff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a8bf76410aad6a8e$var$_react = $a8bf76410aad6a8e$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $a8bf76410aad6a8e$var$_baseNew = $a8bf76410aad6a8e$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $a8bf76410aad6a8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Customize".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a8bf76410aad6a8e$var$CustomizeIcon = (props)=>/*#__PURE__*/ $a8bf76410aad6a8e$var$_react.default.createElement($a8bf76410aad6a8e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.375C3 1.615 3.616 1 4.375 1h1.75c.76 0 1.375.616 1.375 1.375v4.25C7.5 7.385 6.884 8 6.125 8h-1.75C3.615 8 3 7.384 3 6.625V5.25H0v-1.5h3zm1.5.125v4H6v-4zM16 5.25H8.5v-1.5H16zM8.5 9.375C8.5 8.615 9.116 8 9.875 8h1.75C12.385 8 13 8.616 13 9.375v1.375h3v1.5h-3v1.375c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zM10 9.5v4h1.5v-4zM0 12.25v-1.5h7.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$a8bf76410aad6a8e$var$CustomizeIcon.displayName = "CustomizeIcon";
var $a8bf76410aad6a8e$var$_default = module.exports.default = $a8bf76410aad6a8e$var$CustomizeIcon;

});

parcelRegister("fPKMu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cca747bf584e772ee6e9df3631122996>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b86fe83597f76dc8$var$_react = $b86fe83597f76dc8$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b86fe83597f76dc8$var$_baseNew = $b86fe83597f76dc8$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b86fe83597f76dc8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b86fe83597f76dc8$var$IncidentIcon = (props)=>/*#__PURE__*/ $b86fe83597f76dc8$var$_react.default.createElement($b86fe83597f76dc8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$b86fe83597f76dc8$var$IncidentIcon.displayName = "IncidentIcon";
var $b86fe83597f76dc8$var$_default = module.exports.default = $b86fe83597f76dc8$var$IncidentIcon;

});

parcelRegister("1BHq9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2b2be59784c9b52b8b3b5b23f53d5b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12baed95ccc7a34c$var$_react = $12baed95ccc7a34c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $12baed95ccc7a34c$var$_baseNew = $12baed95ccc7a34c$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $12baed95ccc7a34c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdded".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for a user added to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $12baed95ccc7a34c$var$PersonAddedIcon = (props)=>/*#__PURE__*/ $12baed95ccc7a34c$var$_react.default.createElement($12baed95ccc7a34c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m14.877 2.03-4 4a.75.75 0 0 1-1.051.01L8.98 8.262l1.04-1.08 1.316 1.267 3.48-3.48zM3.75 10.5a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.52a3.75 3.75 0 0 1 3.75 3.75V15h-1.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$12baed95ccc7a34c$var$PersonAddedIcon.displayName = "PersonAddedIcon";
var $12baed95ccc7a34c$var$_default = module.exports.default = $12baed95ccc7a34c$var$PersonAddedIcon;

});

parcelRegister("2z9gi", function(module, exports) {

$parcel$export(module.exports, "ExperienceSuccess", function () { return $1de608da17d12f15$export$4962f3898bd5c829; });

var $iSvIT = parcelRequire("iSvIT");
var $1de608da17d12f15$export$4962f3898bd5c829 = function ExperienceSuccess(_ref) {
    var experience = _ref.experience;
    (0, $iSvIT.useLayoutEffect)(function() {
        experience.success();
    }, [
        experience
    ]);
    return null;
};

});

parcelRegister("an8Ry", function(module, exports) {

$parcel$export(module.exports, "AGGClientV2", function () { return $ee75216eb8beffcc$export$8e26c32d2304478; });

var $8J0O8 = parcelRequire("8J0O8");
const $ee75216eb8beffcc$var$GATEWAY_URL = "/gateway/api/graphql";
const $ee75216eb8beffcc$var$DEFAULT_OPTIONS = {
    gatewayUrl: $ee75216eb8beffcc$var$GATEWAY_URL
};
class $ee75216eb8beffcc$export$8e26c32d2304478 {
    async query(query, variables, context) {
        return this.client.query(query, variables, context).toPromise();
    }
    constructor(params = $ee75216eb8beffcc$var$DEFAULT_OPTIONS){
        this.params = params;
        this.client = new (0, $8J0O8.Client)({
            url: this.params.gatewayUrl || $ee75216eb8beffcc$var$GATEWAY_URL,
            exchanges: [
                (0, $8J0O8.cacheExchange),
                (0, $8J0O8.fetchExchange)
            ]
        });
    }
}

});

parcelRegister("aoS05", function(module, exports) {

$parcel$export(module.exports, "graphql", function () { return $aa79769a9fc6a9ec$export$1eb4e7c0ed67b035; });

var $6N78h = parcelRequire("6N78h");
const $aa79769a9fc6a9ec$export$1eb4e7c0ed67b035 = (0, $6N78h.initGraphQLTada)();

});
parcelRegister("6N78h", function(module, exports) {

$parcel$export(module.exports, "initGraphQLTada", function () { return $11a7c16bd0178f54$export$421a65ee623ceca2; });

var $kihxu = parcelRequire("kihxu");
function $11a7c16bd0178f54$export$421a65ee623ceca2() {
    function graphql(e, a) {
        var i = (0, $kihxu.parse)(e).definitions;
        var t = new Set;
        for (var s of a || []){
            for (var d of s.definitions)if (d.kind === (0, $kihxu.Kind).FRAGMENT_DEFINITION && !t.has(d)) {
                i.push(d);
                t.add(d);
            }
        }
        if (i[0].kind === (0, $kihxu.Kind).FRAGMENT_DEFINITION && i[0].directives) i[0].directives = i[0].directives.filter((r)=>"_unmask" !== r.name.value);
        return {
            kind: (0, $kihxu.Kind).DOCUMENT,
            definitions: i
        };
    }
    graphql.scalar = function scalar(r, n) {
        return n;
    };
    graphql.persisted = function persisted(n) {
        return {
            kind: (0, $kihxu.Kind).DOCUMENT,
            definitions: [],
            documentId: n
        };
    };
    return graphql;
}
function $11a7c16bd0178f54$export$98e6a39c04603d36(r) {
    return (0, $kihxu.parse)(r);
}
function $11a7c16bd0178f54$export$f105281f156b6cc0(...r) {
    return 2 === r.length ? r[1] : r[0];
}
function $11a7c16bd0178f54$export$d4a2d0b9594de4ca(r, n) {
    return n;
}
function $11a7c16bd0178f54$export$2c5c6911a07498d4(r, n) {
    return n;
}
var $11a7c16bd0178f54$export$1eb4e7c0ed67b035 = $11a7c16bd0178f54$export$421a65ee623ceca2();

});


parcelRegister("ayjUl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e570c2c471e9f2c44e5e57e4d5245eb9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7aec85a235a3439c$var$_react = $7aec85a235a3439c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $7aec85a235a3439c$var$_baseNew = $7aec85a235a3439c$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $7aec85a235a3439c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7aec85a235a3439c$var$AddIcon = (props)=>/*#__PURE__*/ $7aec85a235a3439c$var$_react.default.createElement($7aec85a235a3439c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 8.75V15h1.5V8.75H15v-1.5H8.75V1h-1.5v6.25H1v1.5z" clip-rule="evenodd"/>`
    }, props));
$7aec85a235a3439c$var$AddIcon.displayName = "AddIcon";
var $7aec85a235a3439c$var$_default = module.exports.default = $7aec85a235a3439c$var$AddIcon;

});

parcelRegister("3cmdt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2543b9c45eebfb2f$var$_react = $2543b9c45eebfb2f$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $2543b9c45eebfb2f$var$_arrowRight = $2543b9c45eebfb2f$var$_interopRequireDefault((parcelRequire("1U6T0")));
function $2543b9c45eebfb2f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2543b9c45eebfb2f$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $2543b9c45eebfb2f$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $2543b9c45eebfb2f$var$_arrowRight.default
    }));
$2543b9c45eebfb2f$var$ArrowRightIcon.displayName = "ArrowRightIcon";
var $2543b9c45eebfb2f$var$_default = module.exports.default = $2543b9c45eebfb2f$var$ArrowRightIcon;

});
parcelRegister("1U6T0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $16305ce039613543$var$_react = $16305ce039613543$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $16305ce039613543$var$_baseNew = $16305ce039613543$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $16305ce039613543$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $16305ce039613543$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $16305ce039613543$var$_react.default.createElement($16305ce039613543$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$16305ce039613543$var$ArrowRightIcon.displayName = "ArrowRightIcon";
var $16305ce039613543$var$_default = module.exports.default = $16305ce039613543$var$ArrowRightIcon;

});


parcelRegister("gsk9h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfaee3f31e759839$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $2ZUkg = parcelRequire("2ZUkg");

var $eJftL = parcelRequire("eJftL");

var $1D2Zu = parcelRequire("1D2Zu");
var $bfaee3f31e759839$var$formSectionDescriptionStyles = (0, $2ZUkg.css)({
    marginTop: "var(--ds-space-100, 8px)"
});
var $bfaee3f31e759839$var$formSectionTitleStyles = (0, $2ZUkg.css)({
    marginTop: 0,
    marginRight: "var(--ds-space-400, 32px)",
    lineHeight: "var(--ds-space-400, 32px)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $bfaee3f31e759839$var$formSectionWrapperStyles = (0, $2ZUkg.css)({
    marginTop: "var(--ds-space-300, 24px)"
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $bfaee3f31e759839$var$lightH600Styles = (0, $2ZUkg.css)((0, $1D2Zu.h600)({
    theme: {
        mode: "light"
    }
}));
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $bfaee3f31e759839$var$darkH600Styles = (0, $2ZUkg.css)((0, $1D2Zu.h600)({
    theme: {
        mode: "dark"
    }
}));
var $bfaee3f31e759839$var$FormSectionWrapper = function FormSectionWrapper(_ref) {
    var children = _ref.children;
    return (0, $2ZUkg.jsx)("div", {
        css: $bfaee3f31e759839$var$formSectionWrapperStyles
    }, children);
};
var $bfaee3f31e759839$var$FormSectionTitle = function FormSectionTitle(_ref2) {
    var children = _ref2.children;
    var _useGlobalTheme = (0, $eJftL.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $2ZUkg.jsx)("h3", {
        css: [
            $bfaee3f31e759839$var$formSectionTitleStyles,
            mode === "light" ? $bfaee3f31e759839$var$lightH600Styles : $bfaee3f31e759839$var$darkH600Styles
        ]
    }, children);
};
var $bfaee3f31e759839$var$FormSectionDescription = function FormSectionDescription(_ref3) {
    var children = _ref3.children;
    return (0, $2ZUkg.jsx)("div", {
        css: $bfaee3f31e759839$var$formSectionDescriptionStyles
    }, children);
};
/**
 * __Form section__
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 */ var $bfaee3f31e759839$var$FormSection = function FormSection(_ref4) {
    var children = _ref4.children, description = _ref4.description, title = _ref4.title;
    return (0, $2ZUkg.jsx)($bfaee3f31e759839$var$FormSectionWrapper, null, title && (0, $2ZUkg.jsx)($bfaee3f31e759839$var$FormSectionTitle, null, title), description && (0, $2ZUkg.jsx)($bfaee3f31e759839$var$FormSectionDescription, null, description), children);
};
var $bfaee3f31e759839$export$2e2bcd8739ae039 = $bfaee3f31e759839$var$FormSection;

});

parcelRegister("9jWQb", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", function () { return $6c9387eaef4d4c57$export$30ab340faaed55d4; });

var $iSvIT = parcelRequire("iSvIT");
var $6c9387eaef4d4c57$var$useConstructor = function useConstructor(callback) {
    var hasBeenFired = (0, $iSvIT.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
var $6c9387eaef4d4c57$export$30ab340faaed55d4 = function useUFOComponentExperience(experience) {
    (0, $iSvIT.useEffect)(function() {
        return function() {
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $6c9387eaef4d4c57$var$useConstructor(function() {
        return experience.start();
    });
    return null;
};

});

parcelRegister("5Gkwm", function(module, exports) {

var $1qvtu = parcelRequire("1qvtu");

var $cqbgb = parcelRequire("cqbgb");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $4230cb095aad19b8$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $cqbgb);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $4230cb095aad19b8$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $1qvtu(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $4230cb095aad19b8$var$baseFlatten;

});
parcelRegister("cqbgb", function(module, exports) {

var $56Gbz = parcelRequire("56Gbz");

var $ehCT3 = parcelRequire("ehCT3");

var $epu4p = parcelRequire("epu4p");
/** Built-in value references. */ var $90b0a5ba1b463d5a$var$spreadableSymbol = $56Gbz ? $56Gbz.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $90b0a5ba1b463d5a$var$isFlattenable(value) {
    return $epu4p(value) || $ehCT3(value) || !!($90b0a5ba1b463d5a$var$spreadableSymbol && value && value[$90b0a5ba1b463d5a$var$spreadableSymbol]);
}
module.exports = $90b0a5ba1b463d5a$var$isFlattenable;

});


parcelRegister("5DpNA", function(module, exports) {

var $axa0S = parcelRequire("axa0S");

var $eZOvN = parcelRequire("eZOvN");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $41a49b604c390cf6$var$baseEach = $eZOvN($axa0S);
module.exports = $41a49b604c390cf6$var$baseEach;

});
parcelRegister("eZOvN", function(module, exports) {

var $h1PEc = parcelRequire("h1PEc");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $aeadf1ce524d010d$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$h1PEc(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $aeadf1ce524d010d$var$createBaseEach;

});


parcelRegister("9bV5B", function(module, exports) {

$parcel$export(module.exports, "LevelContext", function () { return $6b116ce29fe4a1ff$export$650d12d3c2ddb8fc; });
$parcel$export(module.exports, "LevelNodeContext", function () { return $6b116ce29fe4a1ff$export$18f4d8b5b3a77f59; });
$parcel$export(module.exports, "RootNodeContext", function () { return $6b116ce29fe4a1ff$export$fa973f110e8f6ca8; });
$parcel$export(module.exports, "TopLevelContext", function () { return $6b116ce29fe4a1ff$export$48b383b280e20440; });
$parcel$export(module.exports, "Layering", function () { return $6b116ce29fe4a1ff$export$7c885f891c940977; });

var $iSvIT = parcelRequire("iSvIT");

var $dIgfB = parcelRequire("dIgfB");

var $j0gGQ = parcelRequire("j0gGQ");

var $6yx1E = parcelRequire("6yx1E");
var $6b116ce29fe4a1ff$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $iSvIT.createContext)(0);
var $6b116ce29fe4a1ff$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $iSvIT.createContext)({
    current: null
});
var $6b116ce29fe4a1ff$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $iSvIT.createContext)({
    current: null
});
var $6b116ce29fe4a1ff$export$48b383b280e20440 = /*#__PURE__*/ (0, $iSvIT.createContext)({
    topLevelRef: {
        current: null
    },
    layerList: {
        current: null
    },
    setTopLevel: (0, $dIgfB.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $6b116ce29fe4a1ff$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel, levelNode = _ref.node;
    (0, $iSvIT.useEffect)(function() {
        var levelNodeSafe = levelNode.current;
        var parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 || parentNode.addChild(levelNodeSafe);
        return function() {
            parentNode === null || parentNode === void 0 || parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($6b116ce29fe4a1ff$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($6b116ce29fe4a1ff$export$18f4d8b5b3a77f59.Provider, {
        value: levelNode
    }, children));
};
/**
 *
 *  @internal @deprecated
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $6b116ce29fe4a1ff$var$LevelProviderOld = function LevelProviderOld(_ref2) {
    var children = _ref2.children, currentLevel = _ref2.currentLevel;
    var _useContext = (0, $iSvIT.useContext)($6b116ce29fe4a1ff$export$48b383b280e20440), layerList = _useContext.layerList;
    // This is not unstable, it will run once for ref creation.
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var id = (0, $iSvIT.useRef)(Math.random().toString(36));
    (0, $iSvIT.useEffect)(function() {
        var safeLayerList = layerList === null || layerList === void 0 ? void 0 : layerList.current;
        var safeId = id.current;
        if (!safeLayerList) return;
        safeLayerList.push(safeId);
        return function() {
            var index = safeLayerList.indexOf(safeId);
            if (index > -1) safeLayerList.splice(index, 1);
        };
    }, [
        layerList,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($6b116ce29fe4a1ff$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal @deprecated
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $6b116ce29fe4a1ff$var$LayeringProvider = function LayeringProvider(_ref3) {
    var children = _ref3.children;
    var topLevelRef = (0, $iSvIT.useRef)(0);
    var layerList = (0, $iSvIT.useRef)([]);
    var value = (0, $iSvIT.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            },
            layerList: layerList
        };
    }, [
        topLevelRef,
        layerList
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($6b116ce29fe4a1ff$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
/**
 *
 * @deprecated
 * @important the component is toggled by isDisabled props, the default isDisabled is true
 *
 * Layering component is a wrapper to let children to consume layer contexts and hooks.
 *
 */ var $6b116ce29fe4a1ff$var$LayeringOld = function LayeringOld(_ref4) {
    var children = _ref4.children, _ref4$isDisabled = _ref4.isDisabled, isDisabled = _ref4$isDisabled === void 0 ? true : _ref4$isDisabled;
    var currentLevel = (0, $iSvIT.useContext)($6b116ce29fe4a1ff$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($6b116ce29fe4a1ff$var$LevelProviderOld, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($6b116ce29fe4a1ff$var$LayeringProvider, null, content);
};
/**
 *
 * @important the component is toggled by isDisabled props, the default isDisabled is true
 *
 * Layering component is a wrapper to let children to consume layer contexts and hooks.
 *
 */ var $6b116ce29fe4a1ff$var$LayeringNew = function LayeringNew(_ref5) {
    var children = _ref5.children, _ref5$isDisabled = _ref5.isDisabled, isDisabled = _ref5$isDisabled === void 0 ? true : _ref5$isDisabled;
    var currentLevel = (0, $iSvIT.useContext)($6b116ce29fe4a1ff$export$650d12d3c2ddb8fc);
    var parentNode = (0, $iSvIT.useContext)($6b116ce29fe4a1ff$export$18f4d8b5b3a77f59);
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var newNode = (0, $iSvIT.useRef)(new (0, $6yx1E.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($6b116ce29fe4a1ff$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($6b116ce29fe4a1ff$export$fa973f110e8f6ca8.Provider, {
        value: newNode
    }, content);
};
var $6b116ce29fe4a1ff$export$7c885f891c940977 = (0, $j0gGQ.componentWithFG)("layering-tree-graph", $6b116ce29fe4a1ff$var$LayeringNew, $6b116ce29fe4a1ff$var$LayeringOld);

});
parcelRegister("dIgfB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fbbfd72d4c1c688$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $9fbbfd72d4c1c688$export$2e2bcd8739ae039() {}

});

parcelRegister("j0gGQ", function(module, exports) {

$parcel$export(module.exports, "componentWithFG", function () { return $dd5af6b7709ed6b6$export$cf56d0f54cfcce4; });

var $jxLBU = parcelRequire("jxLBU");

var $8DrxP = parcelRequire("8DrxP");
var $dd5af6b7709ed6b6$export$cf56d0f54cfcce4 = function componentWithFG(featureFlagName, ComponentTrue, ComponentFalse) {
    return (0, $8DrxP.componentWithCondition)(function() {
        return (0, $jxLBU.fg)(featureFlagName);
    }, ComponentTrue, ComponentFalse);
};

});
parcelRegister("8DrxP", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", function () { return $64975508553e76f5$export$6e8ea24b15199873; });

var $d4WzD = parcelRequire("d4WzD");

var $iSvIT = parcelRequire("iSvIT");
function $64975508553e76f5$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    var ComponentWithCondition = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
        return condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(ComponentTrue, (0, $d4WzD.default)({}, props, {
            ref: ref
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(ComponentFalse, (0, $d4WzD.default)({}, props, {
            ref: ref
        }));
    });
    if (ComponentTrue.name !== "") ComponentWithCondition.displayName = "ComponentWithCondition[".concat(condition.name, "]");
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});
parcelRegister("d4WzD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9859159ac9033b66$export$2e2bcd8739ae039; });
function $9859159ac9033b66$export$2e2bcd8739ae039() {
    return $9859159ac9033b66$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9859159ac9033b66$export$2e2bcd8739ae039.apply(null, arguments);
}

});



parcelRegister("6yx1E", function(module, exports) {

$parcel$export(module.exports, "LayerNode", function () { return $4c5f894303f1097c$export$da4f61fd78d35243; });

var $lTZDq = parcelRequire("lTZDq");

var $eJga2 = parcelRequire("eJga2");

var $kEPej = parcelRequire("kEPej");
var $4c5f894303f1097c$export$da4f61fd78d35243 = /*#__PURE__*/ function() {
    function LayerNode(id, parent) {
        (0, $eJga2.default)(this, LayerNode);
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    return (0, $kEPej.default)(LayerNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.childNodes.push(node);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.childNodes = this.childNodes.filter(function(child) {
                    return child.id !== node.id;
                });
            }
        },
        {
            key: "getLevel",
            value: function getLevel() {
                if (!this.parent) return 1;
                return this.parent.getLevel() + 1;
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                if (this.childNodes.length === 0) return 1;
                return Math.max.apply(Math, (0, $lTZDq.default)(this.childNodes.map(function(child) {
                    return child.getHeight();
                }))) + 1;
            }
        }
    ]);
}();

});
parcelRegister("lTZDq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff1e8b6c566fea92$export$2e2bcd8739ae039; });

var $a1Her = parcelRequire("a1Her");

var $itNgG = parcelRequire("itNgG");

var $2f4BU = parcelRequire("2f4BU");

var $j3aY0 = parcelRequire("j3aY0");
function $ff1e8b6c566fea92$export$2e2bcd8739ae039(r) {
    return (0, $a1Her.default)(r) || (0, $itNgG.default)(r) || (0, $2f4BU.default)(r) || (0, $j3aY0.default)();
}

});
parcelRegister("a1Her", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74cb8856750fe507$export$2e2bcd8739ae039; });

var $1BPQf = parcelRequire("1BPQf");
function $74cb8856750fe507$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $1BPQf.default)(r);
}

});
parcelRegister("1BPQf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12c175d4868256ea$export$2e2bcd8739ae039; });
function $12c175d4868256ea$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("itNgG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d741270ba51c1d4f$export$2e2bcd8739ae039; });
function $d741270ba51c1d4f$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("2f4BU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a208f050060eec9$export$2e2bcd8739ae039; });

var $1BPQf = parcelRequire("1BPQf");
function $1a208f050060eec9$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $1BPQf.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $1BPQf.default)(r, a) : void 0;
    }
}

});

parcelRegister("j3aY0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dde6cdea3fed184c$export$2e2bcd8739ae039; });
function $dde6cdea3fed184c$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("eJga2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab91cddc819c5fe0$export$2e2bcd8739ae039; });
function $ab91cddc819c5fe0$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("kEPej", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f09f4845948fac0c$export$2e2bcd8739ae039; });

var $hzogk = parcelRequire("hzogk");
function $f09f4845948fac0c$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $hzogk.default)(o.key), o);
    }
}
function $f09f4845948fac0c$export$2e2bcd8739ae039(e, r, t) {
    return r && $f09f4845948fac0c$var$_defineProperties(e.prototype, r), t && $f09f4845948fac0c$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("hzogk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cca8868f8b3db00c$export$2e2bcd8739ae039; });

var $4SdeB = parcelRequire("4SdeB");

var $jAXcp = parcelRequire("jAXcp");
function $cca8868f8b3db00c$export$2e2bcd8739ae039(t) {
    var i = (0, $jAXcp.default)(t, "string");
    return "symbol" == (0, $4SdeB.default)(i) ? i : i + "";
}

});
parcelRegister("4SdeB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38c678ac097f1e99$export$2e2bcd8739ae039; });
function $38c678ac097f1e99$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $38c678ac097f1e99$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $38c678ac097f1e99$export$2e2bcd8739ae039(o);
}

});

parcelRegister("jAXcp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e43f4cd6cf0ead25$export$2e2bcd8739ae039; });

var $4SdeB = parcelRequire("4SdeB");
function $e43f4cd6cf0ead25$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $4SdeB.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $4SdeB.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("47p9E", function(module, exports) {

$parcel$export(module.exports, "useCloseOnEscapePress", function () { return $2ffb540f57ea509e$export$4a4bf067ea9e7886; });
$parcel$export(module.exports, "useLayering", function () { return $2ffb540f57ea509e$export$c8b4d54e03dee6ed; });

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $jxLBU = parcelRequire("jxLBU");

var $9bV5B = parcelRequire("9bV5B");
var $2ffb540f57ea509e$var$ESCAPE = "Escape";
function $2ffb540f57ea509e$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $iSvIT.useRef)(false);
    var _useLayering = $2ffb540f57ea509e$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $iSvIT.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $2ffb540f57ea509e$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $iSvIT.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $iSvIT.useEffect)(function() {
        return (0, $2e1kT.bindAll)(window, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $2ffb540f57ea509e$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $iSvIT.useContext)((0, $9bV5B.LevelContext));
    // Remove TopLevelContext on FG cleanup layering-tree-graph
    var _useContext = (0, $iSvIT.useContext)((0, $9bV5B.TopLevelContext)), topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    var layerNode;
    var rootNode;
    if ((0, $jxLBU.fg)("layering-tree-graph")) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        layerNode = (0, $iSvIT.useContext)((0, $9bV5B.LevelNodeContext));
        // eslint-disable-next-line react-hooks/rules-of-hooks
        rootNode = (0, $iSvIT.useContext)((0, $9bV5B.RootNodeContext));
    }
    var isLayerDisabled = (0, $iSvIT.useCallback)(function() {
        var _layerList$current$le, _layerList$current;
        if ((0, $jxLBU.fg)("layering-tree-graph")) {
            var _layerNode, _rootNode;
            // This is an impossible case, added for type safety
            if (!((_layerNode = layerNode) !== null && _layerNode !== void 0 && _layerNode.current) || !((_rootNode = rootNode) !== null && _rootNode !== void 0 && _rootNode.current)) return false;
            return layerNode.current.getLevel() < rootNode.current.getHeight();
        }
        return ((_layerList$current$le = layerList === null || layerList === void 0 || (_layerList$current = layerList.current) === null || _layerList$current === void 0 ? void 0 : _layerList$current.length) !== null && _layerList$current$le !== void 0 ? _layerList$current$le : 0) !== currentLevel;
    }, [
        currentLevel,
        layerList,
        layerNode,
        rootNode
    ]);
    var getTopLevel = (0, $iSvIT.useCallback)(function() {
        var _rootNode2;
        return (_rootNode2 = rootNode) !== null && _rootNode2 !== void 0 && _rootNode2.current ? rootNode.current.getHeight() : null;
    }, [
        rootNode
    ]);
    return (0, $jxLBU.fg)("layering-tree-graph") ? {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    } : {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled,
        layerList: layerList
    };
}

});

parcelRegister("jwzfp", function(module, exports) {

$parcel$export(module.exports, "combine", function () { return (parcelRequire("gienU")).combine; });

var $gienU = parcelRequire("gienU");

});
parcelRegister("gienU", function(module, exports) {

$parcel$export(module.exports, "combine", function () { return $bdc97c493f7e402c$export$1be1fc439b849fdf; });
/** Create a new combined function that will call all the provided functions */ function $bdc97c493f7e402c$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function cleanup() {
        fns.forEach(function(fn) {
            return fn();
        });
    };
}

});


parcelRegister("1lxXS", function(module, exports) {

$parcel$export(module.exports, "draggable", function () { return (parcelRequire("9cik8")).draggable; });
$parcel$export(module.exports, "dropTargetForElements", function () { return (parcelRequire("9cik8")).dropTargetForElements; });
$parcel$export(module.exports, "monitorForElements", function () { return (parcelRequire("9cik8")).monitorForElements; });

var $9cik8 = parcelRequire("9cik8");
 // Payload for the draggable being dragged

});
parcelRegister("9cik8", function(module, exports) {

$parcel$export(module.exports, "dropTargetForElements", function () { return $6b2372c5f7a4accf$export$e7140b68045b5036; });
$parcel$export(module.exports, "monitorForElements", function () { return $6b2372c5f7a4accf$export$59a074bac4c54f54; });
$parcel$export(module.exports, "draggable", function () { return $6b2372c5f7a4accf$export$c746a5152d4ba26c; });

var $3waQB = parcelRequire("3waQB");

var $2e1kT = parcelRequire("2e1kT");

var $uwtOf = parcelRequire("uwtOf");

var $axUl0 = parcelRequire("axUl0");

var $hwAHG = parcelRequire("hwAHG");

var $gienU = parcelRequire("gienU");

var $3xRvc = parcelRequire("3xRvc");

var $jQJfX = parcelRequire("jQJfX");

var $3ovVT = parcelRequire("3ovVT");

var $05fTs = parcelRequire("05fTs");

var $6N5b2 = parcelRequire("6N5b2");

var $93hKE = parcelRequire("93hKE");

var $gqzpU = parcelRequire("gqzpU");
var $6b2372c5f7a4accf$var$draggableRegistry = new WeakMap();
function $6b2372c5f7a4accf$var$addToRegistry(args) {
    $6b2372c5f7a4accf$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $6b2372c5f7a4accf$var$draggableRegistry.delete(args.element);
    };
}
var $6b2372c5f7a4accf$var$honeyPotFix = (0, $axUl0.makeHoneyPotFix)();
var $6b2372c5f7a4accf$var$adapter = (0, $hwAHG.makeAdapter)({
    typeKey: "element",
    defaultDropEffect: "move",
    mount: function mount(api) {
        /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */ return (0, $gienU.combine)($6b2372c5f7a4accf$var$honeyPotFix.bindEvents(), (0, $2e1kT.bind)(document, {
            type: "dragstart",
            listener: function listener(event) {
                var _entry$dragHandle, _entry$getInitialData, _entry$getInitialData2, _entry$dragHandle2, _entry$getInitialData3, _entry$getInitialData4;
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                var target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return null;
                // see if the thing being dragged is owned by us
                var entry = $6b2372c5f7a4accf$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return null;
                /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */ var input = (0, $05fTs.getInput)(event);
                var feedback = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle = entry.dragHandle) !== null && _entry$dragHandle !== void 0 ? _entry$dragHandle : null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return null;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    var over = (0, $uwtOf.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return null;
                    }
                }
                /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */ var nativeData = (_entry$getInitialData = (_entry$getInitialData2 = entry.getInitialDataForExternal) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) !== null && _entry$getInitialData !== void 0 ? _entry$getInitialData : null;
                if (nativeData) for(var _i = 0, _Object$entries = Object.entries(nativeData); _i < _Object$entries.length; _i++){
                    var _Object$entries$_i = (0, $3waQB.default)(_Object$entries[_i], 2), key = _Object$entries$_i[0], data = _Object$entries$_i[1];
                    event.dataTransfer.setData(key, data !== null && data !== void 0 ? data : "");
                }
                /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */ if ((0, $3ovVT.isAndroid)() && !event.dataTransfer.types.includes((0, $6N5b2.textMediaType)) && !event.dataTransfer.types.includes((0, $93hKE.URLMediaType))) event.dataTransfer.setData((0, $6N5b2.textMediaType), (0, $3ovVT.androidFallbackText));
                /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */ event.dataTransfer.setData((0, $gqzpU.elementAdapterNativeDataKey), "");
                var payload = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle2 = entry.dragHandle) !== null && _entry$dragHandle2 !== void 0 ? _entry$dragHandle2 : null,
                    data: (_entry$getInitialData3 = (_entry$getInitialData4 = entry.getInitialData) === null || _entry$getInitialData4 === void 0 ? void 0 : _entry$getInitialData4.call(entry, feedback)) !== null && _entry$getInitialData3 !== void 0 ? _entry$getInitialData3 : {}
                };
                var dragType = {
                    type: "element",
                    payload: payload,
                    startedFrom: "internal"
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: function dispatchEventToSource(_ref) {
        var _draggableRegistry$ge, _draggableRegistry$ge2;
        var eventName = _ref.eventName, payload = _ref.payload;
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        (_draggableRegistry$ge = $6b2372c5f7a4accf$var$draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(_draggableRegistry$ge, // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $6b2372c5f7a4accf$var$honeyPotFix.getOnPostDispatch()
});
var $6b2372c5f7a4accf$export$e7140b68045b5036 = $6b2372c5f7a4accf$var$adapter.dropTarget;
var $6b2372c5f7a4accf$export$59a074bac4c54f54 = $6b2372c5f7a4accf$var$adapter.monitor;
function $6b2372c5f7a4accf$export$c746a5152d4ba26c(args) {
    var existing;
    var cleanup = (0, $gienU.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $6b2372c5f7a4accf$var$adapter.registerUsage(), $6b2372c5f7a4accf$var$addToRegistry(args), (0, $jQJfX.addAttribute)(args.element, {
        attribute: "draggable",
        value: "true"
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $3xRvc.once)(cleanup);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrag()`) on for a `draggable()` */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForElements()` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForElements` */ 

});
parcelRegister("3waQB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28fcc65261f8a631$export$2e2bcd8739ae039; });

var $8i4Kx = parcelRequire("8i4Kx");

var $b2pqu = parcelRequire("b2pqu");

var $dLoz5 = parcelRequire("dLoz5");

var $98L1N = parcelRequire("98L1N");
function $28fcc65261f8a631$export$2e2bcd8739ae039(r, e) {
    return (0, $8i4Kx.default)(r) || (0, $b2pqu.default)(r, e) || (0, $dLoz5.default)(r, e) || (0, $98L1N.default)();
}

});
parcelRegister("8i4Kx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6093b05de64649d6$export$2e2bcd8739ae039; });
function $6093b05de64649d6$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("b2pqu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80939ac00440d561$export$2e2bcd8739ae039; });
function $80939ac00440d561$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("dLoz5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a052b834f720ee2c$export$2e2bcd8739ae039; });

var $gWWXM = parcelRequire("gWWXM");
function $a052b834f720ee2c$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $gWWXM.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $gWWXM.default)(r, a) : void 0;
    }
}

});
parcelRegister("gWWXM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c56fccfad62c60a8$export$2e2bcd8739ae039; });
function $c56fccfad62c60a8$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("98L1N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a79572e51fd5afe$export$2e2bcd8739ae039; });
function $6a79572e51fd5afe$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("uwtOf", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", function () { return $05bbff4496470a23$export$81d0353f25f5dd; });

var $3waQB = parcelRequire("3waQB");

var $as23p = parcelRequire("as23p");
function $05bbff4496470a23$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    var _document$elementsFro = document.elementsFromPoint(client.x, client.y), _document$elementsFro2 = (0, $3waQB.default)(_document$elementsFro, 2), top = _document$elementsFro2[0], second = _document$elementsFro2[1];
    if (!top) return null;
    if ((0, $as23p.isHoneyPotElement)(top)) return second !== null && second !== void 0 ? second : null;
    return top;
}

});
parcelRegister("as23p", function(module, exports) {

$parcel$export(module.exports, "isHoneyPotElement", function () { return $79be1ccce6822bdd$export$821bdcd739a2706b; });

var $kIc1k = parcelRequire("kIc1k");
function $79be1ccce6822bdd$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $kIc1k.honeyPotDataAttribute));
}

});
parcelRegister("kIc1k", function(module, exports) {

$parcel$export(module.exports, "honeyPotDataAttribute", function () { return $f1413db992774f5a$export$6eafea55f7947469; });
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
var $f1413db992774f5a$export$6eafea55f7947469 = "data-pdnd-honey-pot";

});



parcelRegister("axUl0", function(module, exports) {

$parcel$export(module.exports, "makeHoneyPotFix", function () { return $7ad8aff18995ae40$export$8ecad27c959e89e0; });

var $iD8mG = parcelRequire("iD8mG");

var $2e1kT = parcelRequire("2e1kT");

var $gBDFU = parcelRequire("gBDFU");

var $kIc1k = parcelRequire("kIc1k");
function $7ad8aff18995ae40$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7ad8aff18995ae40$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7ad8aff18995ae40$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iD8mG.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7ad8aff18995ae40$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7ad8aff18995ae40$var$honeyPotSize = 2;
var $7ad8aff18995ae40$var$halfHoneyPotSize = $7ad8aff18995ae40$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $7ad8aff18995ae40$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $7ad8aff18995ae40$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $7ad8aff18995ae40$var$halfHoneyPotSize,
        y: point.y - $7ad8aff18995ae40$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $7ad8aff18995ae40$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $7ad8aff18995ae40$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $7ad8aff18995ae40$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $7ad8aff18995ae40$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $7ad8aff18995ae40$var$getHoneyPotRectFor(_ref) {
    var client = _ref.client;
    var point = $7ad8aff18995ae40$var$preventGoingForwardsOffScreen($7ad8aff18995ae40$var$preventGoingBackwardsOffScreen($7ad8aff18995ae40$var$pullBackByHalfHoneyPotSize($7ad8aff18995ae40$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $7ad8aff18995ae40$var$honeyPotSize,
        height: $7ad8aff18995ae40$var$honeyPotSize
    });
}
function $7ad8aff18995ae40$var$getRectStyles(_ref2) {
    var clientRect = _ref2.clientRect;
    return {
        left: "".concat(clientRect.left, "px"),
        top: "".concat(clientRect.top, "px"),
        width: "".concat(clientRect.width, "px"),
        height: "".concat(clientRect.height, "px")
    };
}
function $7ad8aff18995ae40$var$isWithin(_ref3) {
    var client = _ref3.client, clientRect = _ref3.clientRect;
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $7ad8aff18995ae40$var$mountHoneyPot(_ref4) {
    var initial = _ref4.initial;
    var element = document.createElement("div");
    element.setAttribute((0, $kIc1k.honeyPotDataAttribute), "true");
    // can shift during the drag thanks to Firefox
    var clientRect = $7ad8aff18995ae40$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, $7ad8aff18995ae40$var$_objectSpread($7ad8aff18995ae40$var$_objectSpread({
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: "transparent",
        position: "fixed",
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: "border-box"
    }, $7ad8aff18995ae40$var$getRectStyles({
        clientRect: clientRect
    })), {}, {
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: "auto",
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $gBDFU.maxZIndex)
    }));
    document.body.appendChild(element);
    /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */ var unbindPointerMove = (0, $2e1kT.bind)(window, {
        type: "pointermove",
        listener: function listener(event) {
            var client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $7ad8aff18995ae40$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $7ad8aff18995ae40$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish(_ref5) {
        var current = _ref5.current;
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($7ad8aff18995ae40$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        var unbindPostDragEvents = (0, $2e1kT.bindAll)(window, [
            {
                type: "pointerdown",
                listener: cleanup
            },
            {
                type: "pointermove",
                listener: cleanup
            },
            {
                type: "focusin",
                listener: cleanup
            },
            {
                type: "focusout",
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: "dragstart",
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: "dragenter",
                listener: cleanup
            },
            {
                type: "dragover",
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $7ad8aff18995ae40$export$8ecad27c959e89e0() {
    var latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $2e1kT.bind)(window, {
            type: "pointermove",
            listener: function listener(event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        var finish = null;
        return function onPostEvent(_ref6) {
            var eventName = _ref6.eventName, payload = _ref6.payload;
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === "onDragStart") {
                var input = payload.location.initial.input;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                var initial = latestPointerMove !== null && latestPointerMove !== void 0 ? latestPointerMove : {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $7ad8aff18995ae40$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === "onDrop") {
                var _finish;
                var _input = payload.location.current.input;
                (_finish = finish) === null || _finish === void 0 || _finish({
                    current: {
                        x: _input.clientX,
                        y: _input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
parcelRegister("iD8mG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9025b9eda0ac8bc$export$2e2bcd8739ae039; });

var $lmuje = parcelRequire("lmuje");
function $d9025b9eda0ac8bc$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $lmuje.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("lmuje", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8d329ce30558ae8$export$2e2bcd8739ae039; });

var $7WVE3 = parcelRequire("7WVE3");

var $dOewv = parcelRequire("dOewv");
function $f8d329ce30558ae8$export$2e2bcd8739ae039(t) {
    var i = (0, $dOewv.default)(t, "string");
    return "symbol" == (0, $7WVE3.default)(i) ? i : i + "";
}

});
parcelRegister("7WVE3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c9aaa43d34fda75$export$2e2bcd8739ae039; });
function $5c9aaa43d34fda75$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $5c9aaa43d34fda75$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5c9aaa43d34fda75$export$2e2bcd8739ae039(o);
}

});

parcelRegister("dOewv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0db35e933527abe$export$2e2bcd8739ae039; });

var $7WVE3 = parcelRequire("7WVE3");
function $a0db35e933527abe$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $7WVE3.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $7WVE3.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("gBDFU", function(module, exports) {

$parcel$export(module.exports, "maxZIndex", function () { return $c16ee0aa3c39a5bc$export$7d0a15ee70427305; });
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
var $c16ee0aa3c39a5bc$export$7d0a15ee70427305 = 2147483647;

});


parcelRegister("hwAHG", function(module, exports) {

$parcel$export(module.exports, "makeAdapter", function () { return $cc21e560a9da8528$export$2aa3a33160990d96; });

var $15Xz5 = parcelRequire("15Xz5");

var $80gBL = parcelRequire("80gBL");

var $8MwdD = parcelRequire("8MwdD");

var $8kyvw = parcelRequire("8kyvw");
function $cc21e560a9da8528$export$2aa3a33160990d96(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount, dispatchEventToSource = _ref.dispatchEventToSource, onPostDispatch = _ref.onPostDispatch, defaultDropEffect = _ref.defaultDropEffect;
    var monitorAPI = (0, $8kyvw.makeMonitor)();
    var dropTargetAPI = (0, $8MwdD.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource === null || dispatchEventToSource === void 0 || dispatchEventToSource(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
    }
    function start(_ref2) {
        var event = _ref2.event, dragType = _ref2.dragType;
        (0, $15Xz5.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            var api = {
                canStart: (0, $15Xz5.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $80gBL.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("15Xz5", function(module, exports) {

$parcel$export(module.exports, "lifecycle", function () { return $0cc47667b961f065$export$3efdceeb8ca25c51; });

var $1Nakb = parcelRequire("1Nakb");

var $2e1kT = parcelRequire("2e1kT");

var $uwtOf = parcelRequire("uwtOf");

var $as23p = parcelRequire("as23p");

var $hw8N0 = parcelRequire("hw8N0");

var $gJgj4 = parcelRequire("gJgj4");

var $05fTs = parcelRequire("05fTs");

var $gBxnK = parcelRequire("gBxnK");
var $0cc47667b961f065$var$globalState = {
    isActive: false
};
function $0cc47667b961f065$var$canStart() {
    return !$0cc47667b961f065$var$globalState.isActive;
}
function $0cc47667b961f065$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $0cc47667b961f065$var$hasHierarchyChanged(_ref) {
    var current = _ref.current, next = _ref.next;
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(var i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $0cc47667b961f065$var$start(_ref2) {
    var event = _ref2.event, dragType = _ref2.dragType, getDropTargetsOver = _ref2.getDropTargetsOver, dispatchEvent = _ref2.dispatchEvent;
    if (!$0cc47667b961f065$var$canStart()) return;
    var initial = $0cc47667b961f065$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $0cc47667b961f065$var$globalState.isActive = true;
    var state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $0cc47667b961f065$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    var dispatch = (0, $gBxnK.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        var hasChanged = $0cc47667b961f065$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        var input = (0, $05fTs.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        var target = (0, $as23p.isHoneyPotElement)(event.target) ? (0, $uwtOf.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        var nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $0cc47667b961f065$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $0cc47667b961f065$var$globalState.isActive = false;
        unbindEvents();
    }
    var unbindEvents = (0, $2e1kT.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: "dragover",
            listener: function listener(event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: "dragenter",
            listener: onUpdateEvent
        },
        {
            type: "dragleave",
            listener: function listener(event) {
                if (!(0, $hw8N0.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === "external") cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: "drop",
            listener: function listener(event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $05fTs.getInput)(event)
                };
                /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $0cc47667b961f065$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === "external" ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: "dragend",
            listener: function listener(event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $05fTs.getInput)(event)
                };
                cancel();
            }
        }
    ].concat((0, $1Nakb.default)((0, $gJgj4.getBindingsForBrokenDrags)({
        onDragEnd: cancel
    }))), // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $0cc47667b961f065$var$getNativeSetDragImage(event)
    });
}
function $0cc47667b961f065$var$setDropEffectOnEvent(_ref3) {
    var _current$;
    var event = _ref3.event, current = _ref3.current;
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    var innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $0cc47667b961f065$var$getStartLocation(_ref4) {
    var event = _ref4.event, dragType = _ref4.dragType, getDropTargetsOver = _ref4.getDropTargetsOver;
    var input = (0, $05fTs.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === "external") return {
        input: input,
        dropTargets: []
    };
    var dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
var $0cc47667b961f065$export$3efdceeb8ca25c51 = {
    canStart: $0cc47667b961f065$var$canStart,
    start: $0cc47667b961f065$var$start
};

});
parcelRegister("1Nakb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14e26045d8cb0898$export$2e2bcd8739ae039; });

var $bXjUz = parcelRequire("bXjUz");

var $fiM1w = parcelRequire("fiM1w");

var $dLoz5 = parcelRequire("dLoz5");

var $zgHtn = parcelRequire("zgHtn");
function $14e26045d8cb0898$export$2e2bcd8739ae039(r) {
    return (0, $bXjUz.default)(r) || (0, $fiM1w.default)(r) || (0, $dLoz5.default)(r) || (0, $zgHtn.default)();
}

});
parcelRegister("bXjUz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b44a668ce78d4b9$export$2e2bcd8739ae039; });

var $gWWXM = parcelRequire("gWWXM");
function $8b44a668ce78d4b9$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $gWWXM.default)(r);
}

});

parcelRegister("fiM1w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b23dc9eac10669c6$export$2e2bcd8739ae039; });
function $b23dc9eac10669c6$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("zgHtn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06a0394e33733a34$export$2e2bcd8739ae039; });
function $06a0394e33733a34$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("hw8N0", function(module, exports) {

$parcel$export(module.exports, "isLeavingWindow", function () { return $cc0c3e3eb04836c7$export$57d220c74e84a273; });

var $dz6xg = parcelRequire("dz6xg");

var $lWrIX = parcelRequire("lWrIX");

var $iEpzj = parcelRequire("iEpzj");

var $eKhbp = parcelRequire("eKhbp");
function $cc0c3e3eb04836c7$export$57d220c74e84a273(_ref) {
    var dragLeave = _ref.dragLeave;
    var type = dragLeave.type, relatedTarget = dragLeave.relatedTarget;
    if (type !== "dragleave") return false;
    if ((0, $lWrIX.isSafari)()) return (0, $iEpzj.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */ if ((0, $dz6xg.isFirefox)()) return (0, $eKhbp.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("dz6xg", function(module, exports) {

$parcel$export(module.exports, "isFirefox", function () { return $9e039d15f8b1de65$export$b7d78993b74f766d; });

var $3xRvc = parcelRequire("3xRvc");
var $9e039d15f8b1de65$export$b7d78993b74f766d = (0, $3xRvc.once)(function isFirefox() {
    return navigator.userAgent.includes("Firefox");
});

});
parcelRegister("3xRvc", function(module, exports) {

$parcel$export(module.exports, "once", function () { return $294df4920a31e702$export$d2de3aaeafa91619; });
/** Provide a function that you only ever want to be called a single time */ function $294df4920a31e702$export$d2de3aaeafa91619(fn) {
    var cache = null;
    return function wrapped() {
        if (!cache) {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});


parcelRegister("lWrIX", function(module, exports) {

$parcel$export(module.exports, "isSafari", function () { return $ff94852d81765969$export$95df08bae54cb4df; });

var $3xRvc = parcelRequire("3xRvc");
var $ff94852d81765969$export$95df08bae54cb4df = (0, $3xRvc.once)(function isSafari() {
    var _navigator = navigator, userAgent = _navigator.userAgent;
    return userAgent.includes("AppleWebKit") && !userAgent.includes("Chrome");
});

});

parcelRegister("iEpzj", function(module, exports) {

$parcel$export(module.exports, "isEnteringWindowInSafari", function () { return $d93fcbce42e66776$export$de68634bd94ed596; });
$parcel$export(module.exports, "isLeavingWindowInSafari", function () { return $d93fcbce42e66776$export$f21837c338005454; });

var $2e1kT = parcelRequire("2e1kT");

var $lWrIX = parcelRequire("lWrIX");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
var $d93fcbce42e66776$var$symbols = {
    isLeavingWindow: Symbol("leaving"),
    isEnteringWindow: Symbol("entering")
};
function $d93fcbce42e66776$export$de68634bd94ed596(_ref) {
    var dragEnter = _ref.dragEnter;
    if (!(0, $lWrIX.isSafari)()) return false;
    return dragEnter.hasOwnProperty($d93fcbce42e66776$var$symbols.isEnteringWindow);
}
function $d93fcbce42e66776$export$f21837c338005454(_ref2) {
    var dragLeave = _ref2.dragLeave;
    if (!(0, $lWrIX.isSafari)()) return false;
    return dragLeave.hasOwnProperty($d93fcbce42e66776$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === "undefined") return;
    if (!(0, $lWrIX.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    var state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $2e1kT.bindAll)(window, [
        {
            type: "dragstart",
            listener: function listener() {
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: "drop",
            listener: resetState
        },
        {
            type: "dragend",
            listener: resetState
        },
        {
            type: "dragenter",
            listener: function listener(event) {
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                // @ts-expect-error: adding property to the event object
                event[$d93fcbce42e66776$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: "dragleave",
            listener: function listener(event) {
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    // @ts-expect-error: adding property to the event object
                    event[$d93fcbce42e66776$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("eKhbp", function(module, exports) {

$parcel$export(module.exports, "isFromAnotherWindow", function () { return $abc2b0c108871406$export$e46810fef53b5b0e; });
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $abc2b0c108871406$var$isNodeLike(target) {
    return "nodeName" in target;
}
function $abc2b0c108871406$export$e46810fef53b5b0e(eventTarget) {
    return $abc2b0c108871406$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("gJgj4", function(module, exports) {

$parcel$export(module.exports, "getBindingsForBrokenDrags", function () { return $c2dd7f72bcb5309a$export$ac5e5b0daf997b2; });
function $c2dd7f72bcb5309a$export$ac5e5b0daf997b2(_ref) {
    var onDragEnd = _ref.onDragEnd;
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            }()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: "pointerdown",
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("05fTs", function(module, exports) {

$parcel$export(module.exports, "getInput", function () { return $00fccbddaef35b57$export$7c112ceec8941e67; });
function $00fccbddaef35b57$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("gBxnK", function(module, exports) {

$parcel$export(module.exports, "makeDispatch", function () { return $c169ff012f4a90a0$export$9f13ecc44e83d682; });

var $kA3CX = parcelRequire("kA3CX");
var $c169ff012f4a90a0$var$scheduleOnDrag = (0, $kA3CX.default)(function(fn) {
    return fn();
});
var $c169ff012f4a90a0$var$dragStart = function() {
    var scheduled = null;
    function schedule(fn) {
        var frameId = requestAnimationFrame(function() {
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
}();
function $c169ff012f4a90a0$export$9f13ecc44e83d682(_ref) {
    var source = _ref.source, initial = _ref.initial, dispatchEvent = _ref.dispatchEvent;
    var previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    var dispatch = {
        start: function start(_ref2) {
            var nativeSetDragImage = _ref2.nativeSetDragImage;
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            var location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: "onGenerateDragPreview",
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $c169ff012f4a90a0$var$dragStart.schedule(function() {
                safeDispatch({
                    eventName: "onDragStart",
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate: function dragUpdate(_ref3) {
            var current = _ref3.current;
            $c169ff012f4a90a0$var$dragStart.flush();
            $c169ff012f4a90a0$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: "onDropTargetChange",
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag: function drag(_ref4) {
            var current = _ref4.current;
            $c169ff012f4a90a0$var$scheduleOnDrag(function() {
                $c169ff012f4a90a0$var$dragStart.flush();
                var location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: "onDrag",
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop: function drop(_ref5) {
            var current = _ref5.current, updatedSourcePayload = _ref5.updatedSourcePayload;
            $c169ff012f4a90a0$var$dragStart.flush();
            $c169ff012f4a90a0$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: "onDrop",
                payload: {
                    source: updatedSourcePayload !== null && updatedSourcePayload !== void 0 ? updatedSourcePayload : source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});


parcelRegister("80gBL", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $5d3b34d5b43ed9bf$export$6503ec6e8aabbaf; });
// Extending `Map` to allow us to link Key and Values together
var $5d3b34d5b43ed9bf$var$ledger = new Map();
function $5d3b34d5b43ed9bf$var$registerUsage(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount;
    var entry = $5d3b34d5b43ed9bf$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    var initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $5d3b34d5b43ed9bf$var$ledger.set(typeKey, initial);
    return initial;
}
function $5d3b34d5b43ed9bf$export$6503ec6e8aabbaf(args) {
    var entry = $5d3b34d5b43ed9bf$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $5d3b34d5b43ed9bf$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("8MwdD", function(module, exports) {

$parcel$export(module.exports, "makeDropTarget", function () { return $664bcc7234d2314c$export$47d10e7bd9c81890; });

var $iD8mG = parcelRequire("iD8mG");

var $1Nakb = parcelRequire("1Nakb");

var $gienU = parcelRequire("gienU");

var $3xRvc = parcelRequire("3xRvc");

var $jQJfX = parcelRequire("jQJfX");
function $664bcc7234d2314c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $664bcc7234d2314c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $664bcc7234d2314c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iD8mG.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $664bcc7234d2314c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $664bcc7234d2314c$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $664bcc7234d2314c$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $664bcc7234d2314c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $664bcc7234d2314c$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $664bcc7234d2314c$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $664bcc7234d2314c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $664bcc7234d2314c$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $664bcc7234d2314c$export$47d10e7bd9c81890(_ref) {
    var typeKey = _ref.typeKey, defaultDropEffect = _ref.defaultDropEffect;
    var registry = new WeakMap();
    var dropTargetDataAtt = "data-drop-target-for-".concat(typeKey);
    var dropTargetSelector = "[".concat(dropTargetDataAtt, "]");
    function addToRegistry(args) {
        registry.set(args.element, args);
        return function() {
            return registry.delete(args.element);
        };
    }
    function dropTargetForConsumers(args) {
        var existing;
        var cleanup = (0, $gienU.combine)((0, $jQJfX.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: "true"
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $3xRvc.once)(cleanup);
    }
    function getActualDropTargets(_ref2) {
        var _args$getData, _args$getData2, _args$getDropEffect, _args$getDropEffect2;
        var source = _ref2.source, target = _ref2.target, input = _ref2.input, _ref2$result = _ref2.result, result = _ref2$result === void 0 ? [] : _ref2$result;
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        var closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        var args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        var feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        var data = (_args$getData = (_args$getData2 = args.getData) === null || _args$getData2 === void 0 ? void 0 : _args$getData2.call(args, feedback)) !== null && _args$getData !== void 0 ? _args$getData : {};
        var dropEffect = (_args$getDropEffect = (_args$getDropEffect2 = args.getDropEffect) === null || _args$getDropEffect2 === void 0 ? void 0 : _args$getDropEffect2.call(args, feedback)) !== null && _args$getDropEffect !== void 0 ? _args$getDropEffect : defaultDropEffect;
        var record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [].concat((0, $1Nakb.default)(result), [
                record
            ])
        });
    }
    function notifyCurrent(_ref3) {
        var eventName = _ref3.eventName, payload = _ref3.payload;
        var _iterator = $664bcc7234d2314c$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _entry$eventName;
                var record = _step.value;
                var entry = registry.get(record.element);
                var args = $664bcc7234d2314c$var$_objectSpread($664bcc7234d2314c$var$_objectSpread({}, payload), {}, {
                    self: record
                });
                entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(entry, // I cannot seem to get the types right here.
                // TS doesn't seem to like that one event can need `nativeSetDragImage`
                // @ts-expect-error
                args);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    var actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: function onDropTargetChange(_ref4) {
            var payload = _ref4.payload;
            var isCurrent = new Set(payload.location.current.dropTargets.map(function(record) {
                return record.element;
            }));
            var visited = new Set();
            var _iterator2 = $664bcc7234d2314c$var$_createForOfIteratorHelper(payload.location.previous.dropTargets), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _entry$onDropTargetCh;
                    var record = _step2.value;
                    visited.add(record.element);
                    var entry = registry.get(record.element);
                    var isOver = isCurrent.has(record.element);
                    var args = $664bcc7234d2314c$var$_objectSpread($664bcc7234d2314c$var$_objectSpread({}, payload), {}, {
                        self: record
                    });
                    entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);
                    // if we cannot find the drop target in the current array, then it has been left
                    if (!isOver) {
                        var _entry$onDragLeave;
                        entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var _iterator3 = $664bcc7234d2314c$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _entry$onDropTargetCh2, _entry$onDragEnter;
                    var _record = _step3.value;
                    // already published an update to this drop target
                    if (visited.has(_record.element)) continue;
                    // at this point we have a new drop target that is being entered into
                    var _args = $664bcc7234d2314c$var$_objectSpread($664bcc7234d2314c$var$_objectSpread({}, payload), {}, {
                        self: _record
                    });
                    var _entry = registry.get(_record.element);
                    _entry === null || _entry === void 0 || (_entry$onDropTargetCh2 = _entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(_entry, _args);
                    _entry === null || _entry === void 0 || (_entry$onDragEnter = _entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(_entry, _args);
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver(_ref5) {
        var source = _ref5.source, target = _ref5.target, input = _ref5.input, current = _ref5.current;
        var actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        var lastCaptureOrdered = $664bcc7234d2314c$var$copyReverse(current);
        var actualCaptureOrdered = $664bcc7234d2314c$var$copyReverse(actual);
        var resultCaptureOrdered = [];
        for(var index = 0; index < lastCaptureOrdered.length; index++){
            var _argsForLast$getIsSti;
            var last = lastCaptureOrdered[index];
            var fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            var parent = resultCaptureOrdered[index - 1];
            var lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) break;
            // We need to check whether the old drop target can still be dropped on
            var argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            var feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push($664bcc7234d2314c$var$_objectSpread($664bcc7234d2314c$var$_objectSpread({}, last), {}, {
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            }));
        }
        // return bubble ordered result
        return $664bcc7234d2314c$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("jQJfX", function(module, exports) {

$parcel$export(module.exports, "addAttribute", function () { return $e735faa3da647eda$export$5dcb5c23b6ba980a; });
function $e735faa3da647eda$export$5dcb5c23b6ba980a(element, _ref) {
    var attribute = _ref.attribute, value = _ref.value;
    element.setAttribute(attribute, value);
    return function() {
        return element.removeAttribute(attribute);
    };
}

});


parcelRegister("8kyvw", function(module, exports) {

$parcel$export(module.exports, "makeMonitor", function () { return $610af56cc591f8c5$export$5dd4ed888d5b12ca; });

var $iD8mG = parcelRequire("iD8mG");

var $3xRvc = parcelRequire("3xRvc");
function $610af56cc591f8c5$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $610af56cc591f8c5$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $610af56cc591f8c5$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $610af56cc591f8c5$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $610af56cc591f8c5$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $610af56cc591f8c5$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $610af56cc591f8c5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $610af56cc591f8c5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $610af56cc591f8c5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iD8mG.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $610af56cc591f8c5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $610af56cc591f8c5$export$5dd4ed888d5b12ca() {
    var registry = new Set();
    var dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        var entry = $610af56cc591f8c5$var$_objectSpread({}, args);
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $3xRvc.once)(cleanup);
    }
    function dispatchEvent(_ref) {
        var eventName = _ref.eventName, payload = _ref.payload;
        if (eventName === "onGenerateDragPreview") {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            var _iterator = $610af56cc591f8c5$var$_createForOfIteratorHelper(registry), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var monitor = _step.value;
                    tryAddToActive(monitor);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        var active = Array.from(dragging.active);
        for(var _i = 0, _active = active; _i < _active.length; _i++){
            var _monitor = _active[_i];
            // A monitor can be removed by another monitor during an event.
            // We need to check that the monitor is still registered before calling it
            if (dragging.active.has(_monitor)) {
                var _monitor$eventName;
                // @ts-expect-error: I cannot get this type working!
                (_monitor$eventName = _monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(_monitor, payload);
            }
        }
        if (eventName === "onDrop") {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("3ovVT", function(module, exports) {

$parcel$export(module.exports, "isAndroid", function () { return $278c622a808ea207$export$a11b0059900ceec8; });
$parcel$export(module.exports, "androidFallbackText", function () { return $278c622a808ea207$export$aceb3ed8b7f7bd2c; });

var $3xRvc = parcelRequire("3xRvc");
var $278c622a808ea207$export$a11b0059900ceec8 = (0, $3xRvc.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes("android");
});
var $278c622a808ea207$export$aceb3ed8b7f7bd2c = "pdnd:android-fallback";

});

parcelRegister("6N5b2", function(module, exports) {

$parcel$export(module.exports, "textMediaType", function () { return $4f1b55bfa33c018f$export$fd3d00026297c0ad; });
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $4f1b55bfa33c018f$export$fd3d00026297c0ad = "text/plain";

});

parcelRegister("93hKE", function(module, exports) {

$parcel$export(module.exports, "URLMediaType", function () { return $697229ef8184b798$export$4c44a460f123106; });
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $697229ef8184b798$export$4c44a460f123106 = "text/uri-list";

});

parcelRegister("gqzpU", function(module, exports) {

$parcel$export(module.exports, "elementAdapterNativeDataKey", function () { return $bf5a8c1a931e712e$export$c9c4cc54e73b125d; });
/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ var $bf5a8c1a931e712e$export$c9c4cc54e73b125d = "application/vnd.pdnd";

});



parcelRegister("lLlRm", function(module, exports) {

$parcel$export(module.exports, "monitorForExternal", function () { return (parcelRequire("2Yf7R")).monitorForExternal; });

var $2Yf7R = parcelRequire("2Yf7R");
 // The data that is being dragged

});
parcelRegister("2Yf7R", function(module, exports) {

$parcel$export(module.exports, "monitorForExternal", function () { return $229ceb0be6293d85$export$bb1740f3194979c1; });

var $1Nakb = parcelRequire("1Nakb");

var $2e1kT = parcelRequire("2e1kT");

var $hwAHG = parcelRequire("hwAHG");

var $3ovVT = parcelRequire("3ovVT");

var $aDvb9 = parcelRequire("aDvb9");

var $gJgj4 = parcelRequire("gJgj4");

var $6N5b2 = parcelRequire("6N5b2");

var $gqzpU = parcelRequire("gqzpU");
function $229ceb0be6293d85$export$a8e56a860d7957c7(_ref) {
    var type = _ref.type, value = _ref.value;
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $gqzpU.elementAdapterNativeDataKey)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $6N5b2.textMediaType) && value === (0, $3ovVT.androidFallbackText)) return false;
    return true;
}
function $229ceb0be6293d85$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter(function(type) {
        return $229ceb0be6293d85$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        });
    });
}
function $229ceb0be6293d85$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter(function(item) {
        return item.kind === "file" || $229ceb0be6293d85$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        });
    });
}
var $229ceb0be6293d85$var$didDragStartLocally = false;
var $229ceb0be6293d85$var$adapter = (0, $hwAHG.makeAdapter)({
    typeKey: "external",
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: "copy",
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $2e1kT.bind)(window, {
            type: "dragenter",
            listener: function listener(event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($229ceb0be6293d85$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $aDvb9.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                var types = $229ceb0be6293d85$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                var locked = {
                    types: types,
                    items: [],
                    getStringData: function getStringData() {
                        return null;
                    }
                };
                api.start({
                    event: event,
                    dragType: {
                        type: "external",
                        startedFrom: "external",
                        payload: locked,
                        getDropPayload: function getDropPayload(event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            var items = $229ceb0be6293d85$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            var nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData: function getStringData(mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    var value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$229ceb0be6293d85$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $229ceb0be6293d85$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $229ceb0be6293d85$var$adapter.dropTarget(args);
}
function $229ceb0be6293d85$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $229ceb0be6293d85$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === "undefined") return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $229ceb0be6293d85$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    var idle = {
        type: "idle"
    };
    var state = idle;
    function clear() {
        if (state.type !== "dragging") return;
        $229ceb0be6293d85$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $2e1kT.bindAll)(window, [
            {
                type: "dragend",
                listener: clear
            }
        ].concat((0, $1Nakb.default)((0, $gJgj4.getBindingsForBrokenDrags)({
            onDragEnd: clear
        }))), // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $2e1kT.bind)(window, {
        type: "dragstart",
        listener: function listener() {
            // something bad has happened if this is true!
            if (state.type !== "idle") return;
            // set our global flag
            $229ceb0be6293d85$var$didDragStartLocally = true;
            state = {
                type: "dragging",
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})(); /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 

});
parcelRegister("aDvb9", function(module, exports) {

$parcel$export(module.exports, "isEnteringWindow", function () { return $7be5bb6406d7b0b6$export$d1c6f249e893cdf4; });

var $dz6xg = parcelRequire("dz6xg");

var $lWrIX = parcelRequire("lWrIX");

var $iEpzj = parcelRequire("iEpzj");

var $eKhbp = parcelRequire("eKhbp");
function $7be5bb6406d7b0b6$export$d1c6f249e893cdf4(_ref) {
    var dragEnter = _ref.dragEnter;
    var type = dragEnter.type, relatedTarget = dragEnter.relatedTarget;
    if (type !== "dragenter") return false;
    if ((0, $lWrIX.isSafari)()) return (0, $iEpzj.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is the `iframe` element in the parent `window`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is an element inside the child `iframe`
   * (foreign element)
   */ if ((0, $dz6xg.isFirefox)()) return (0, $eKhbp.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is `null` *(standard check)*
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is the `iframe` element in the parent `window`
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});



parcelRegister("adrrV", function(module, exports) {

$parcel$export(module.exports, "monitorForTextSelection", function () { return (parcelRequire("aZ608")).monitorForTextSelection; });

var $aZ608 = parcelRequire("aZ608");
 // Payload for the text selection being dragged

});
parcelRegister("aZ608", function(module, exports) {

$parcel$export(module.exports, "monitorForTextSelection", function () { return $7ff4419b9d9f253a$export$2e178e3647f5e6e9; });

var $2e1kT = parcelRequire("2e1kT");

var $axUl0 = parcelRequire("axUl0");

var $hwAHG = parcelRequire("hwAHG");

var $gienU = parcelRequire("gienU");

var $lWrIX = parcelRequire("lWrIX");

var $9Sra9 = parcelRequire("9Sra9");

var $6N5b2 = parcelRequire("6N5b2");

var $gqzpU = parcelRequire("gqzpU");
function $7ff4419b9d9f253a$var$findTextNode(event) {
    var _event$dataTransfer;
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $lWrIX.isSafari)()) return null;
    /**
   * According to the spec, `event.target` should be the `Text` node that
   * the drag started from when dragging a text selection.
   *
   * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
   *
   * However, in Safari the closest `HTMLElement` is returned.
   * So we need to figure out if text is dragging ourselves.
   *
   * → https://bugs.webkit.org/show_bug.cgi?id=268959
   */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!((_event$dataTransfer = event.dataTransfer) !== null && _event$dataTransfer !== void 0 && _event$dataTransfer.getData((0, $6N5b2.textMediaType)))) return null;
    /**
   * Grab the first Text node and use that.
   * Only doing a single level search as that is all we need for this bug.
   */ var text = Array.from(event.target.childNodes).find(function(node) {
        return node.nodeType === Node.TEXT_NODE;
    });
    return text !== null && text !== void 0 ? text : null;
}
var $7ff4419b9d9f253a$var$honeyPotFix = (0, $axUl0.makeHoneyPotFix)();
var $7ff4419b9d9f253a$var$adapter = (0, $hwAHG.makeAdapter)({
    typeKey: "text-selection",
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: "copy",
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $gienU.combine)($7ff4419b9d9f253a$var$honeyPotFix.bindEvents(), (0, $2e1kT.bind)(window, {
            type: "dragstart",
            listener: function listener(event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $gqzpU.elementAdapterNativeDataKey))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $6N5b2.textMediaType))) return;
                var target = $7ff4419b9d9f253a$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                var payload = {
                    // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target: target,
                    plain: event.dataTransfer.getData((0, $6N5b2.textMediaType)),
                    HTML: event.dataTransfer.getData((0, $9Sra9.HTMLMediaType))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: "text-selection",
                        startedFrom: "internal",
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $7ff4419b9d9f253a$var$honeyPotFix.getOnPostDispatch()
});
function $7ff4419b9d9f253a$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $7ff4419b9d9f253a$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === "undefined") return;
    $7ff4419b9d9f253a$var$adapter.registerUsage();
})();
function $7ff4419b9d9f253a$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $7ff4419b9d9f253a$var$adapter.monitor(args);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Argument given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Argument given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 

});
parcelRegister("9Sra9", function(module, exports) {

$parcel$export(module.exports, "HTMLMediaType", function () { return $730e3a2d362610ef$export$338a9f6c7a1f02b0; });
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $730e3a2d362610ef$export$338a9f6c7a1f02b0 = "text/html";

});



parcelRegister("3hEqL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::40d49d14e43276e4147396a05e9540f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $264252501ef81c81$var$_react = $264252501ef81c81$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $264252501ef81c81$var$_cross = $264252501ef81c81$var$_interopRequireDefault((parcelRequire("emEGs")));

var $264252501ef81c81$var$_cross2 = $264252501ef81c81$var$_interopRequireDefault((parcelRequire("f448m")));
function $264252501ef81c81$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $264252501ef81c81$var$CrossIcon = (props)=>/*#__PURE__*/ $264252501ef81c81$var$_react.default.createElement($264252501ef81c81$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $264252501ef81c81$var$_cross2.default
    }, props));
$264252501ef81c81$var$CrossIcon.Name = "CrossIconMigration";
var $264252501ef81c81$var$_default = module.exports.default = $264252501ef81c81$var$CrossIcon;

});

parcelRegister("azaWc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8687bcf05df783ceffe46d3fd0178463>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7b15a84a5d7693a3$var$_react = $7b15a84a5d7693a3$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $7b15a84a5d7693a3$var$_statusError = $7b15a84a5d7693a3$var$_interopRequireDefault((parcelRequire("1nHsw")));

var $7b15a84a5d7693a3$var$_error = $7b15a84a5d7693a3$var$_interopRequireDefault((parcelRequire("1EpFI")));
function $7b15a84a5d7693a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7b15a84a5d7693a3$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $7b15a84a5d7693a3$var$_react.default.createElement($7b15a84a5d7693a3$var$_statusError.default, Object.assign({
        LEGACY_fallbackIcon: $7b15a84a5d7693a3$var$_error.default
    }, props));
$7b15a84a5d7693a3$var$StatusErrorIcon.Name = "StatusErrorIconMigration";
var $7b15a84a5d7693a3$var$_default = module.exports.default = $7b15a84a5d7693a3$var$StatusErrorIcon;

});

parcelRegister("k9ADk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c4f87fa6bbdffcdd6698ec12cc5fa12>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eac1108cbba4c2b0$var$_react = $eac1108cbba4c2b0$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $eac1108cbba4c2b0$var$_statusWarning = $eac1108cbba4c2b0$var$_interopRequireDefault((parcelRequire("goemm")));

var $eac1108cbba4c2b0$var$_warning = $eac1108cbba4c2b0$var$_interopRequireDefault((parcelRequire("53DZ3")));
function $eac1108cbba4c2b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eac1108cbba4c2b0$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $eac1108cbba4c2b0$var$_react.default.createElement($eac1108cbba4c2b0$var$_statusWarning.default, Object.assign({
        LEGACY_fallbackIcon: $eac1108cbba4c2b0$var$_warning.default
    }, props));
$eac1108cbba4c2b0$var$StatusWarningIcon.Name = "StatusWarningIconMigration";
var $eac1108cbba4c2b0$var$_default = module.exports.default = $eac1108cbba4c2b0$var$StatusWarningIcon;

});

parcelRegister("ePLWY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b604d93f37780dd1b714089781bfee62>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $accb06081a3aa0ab$var$_react = $accb06081a3aa0ab$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $accb06081a3aa0ab$var$_chevronDown = $accb06081a3aa0ab$var$_interopRequireDefault((parcelRequire("4vcv5")));

var $accb06081a3aa0ab$var$_chevronDown2 = $accb06081a3aa0ab$var$_interopRequireDefault((parcelRequire("h6aNO")));
function $accb06081a3aa0ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $accb06081a3aa0ab$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $accb06081a3aa0ab$var$_react.default.createElement($accb06081a3aa0ab$var$_chevronDown.default, Object.assign({
        LEGACY_fallbackIcon: $accb06081a3aa0ab$var$_chevronDown2.default
    }, props));
$accb06081a3aa0ab$var$ChevronDownIcon.Name = "ChevronDownIconMigration";
var $accb06081a3aa0ab$var$_default = module.exports.default = $accb06081a3aa0ab$var$ChevronDownIcon;

});
parcelRegister("h6aNO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c72b60579b631d81$var$_react = $c72b60579b631d81$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $c72b60579b631d81$var$_chevronDown = $c72b60579b631d81$var$_interopRequireDefault((parcelRequire("4vcv5")));
function $c72b60579b631d81$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c72b60579b631d81$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $c72b60579b631d81$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $c72b60579b631d81$var$_chevronDown.default
    }));
$c72b60579b631d81$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $c72b60579b631d81$var$_default = module.exports.default = $c72b60579b631d81$var$ChevronDownIcon;

});


parcelRegister("i1zqV", function(module, exports) {

$parcel$export(module.exports, "auth", function () { return $d1f3ce50c454dd06$export$73693bad9f5880b0; });
$parcel$export(module.exports, "AuthError", function () { return (parcelRequire("4SUwI")).AuthError; });

var $8dWZt = parcelRequire("8dWZt");

var $4SUwI = parcelRequire("4SUwI");

var $9yeH0 = parcelRequire("9yeH0");
function $d1f3ce50c454dd06$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise(function(resolve, reject) {
        var authWindow = null;
        var authWindowInterval;
        var handleAuthWindowMessage = function handleAuthWindowMessage(event) {
            if (event.source !== authWindow) return;
            var data = event.data;
            if ((0, $8dWZt.default)(data) !== "object") return;
            switch(data.type){
                case "outbound-auth:success":
                    finish();
                    resolve();
                    break;
                case "outbound-auth:failure":
                    finish();
                    var errorType = data.errorType.toLowerCase();
                    if ((0, $9yeH0.isOfTypeAuthError)(errorType)) reject(new (0, $4SUwI.AuthError)(data.message, errorType));
                    else reject(new (0, $4SUwI.AuthError)(data.message));
                    break;
            }
        };
        var handleAuthWindowInterval = function handleAuthWindowInterval() {
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $4SUwI.AuthError)("The auth window was closed", "auth_window_closed"));
            }
        };
        var start = function start() {
            window.addEventListener("message", handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        var finish = function finish() {
            clearInterval(authWindowInterval);
            window.removeEventListener("message", handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("8dWZt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fcd4beab3f76d6e$export$2e2bcd8739ae039; });
function $5fcd4beab3f76d6e$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $5fcd4beab3f76d6e$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5fcd4beab3f76d6e$export$2e2bcd8739ae039(o);
}

});

parcelRegister("4SUwI", function(module, exports) {

$parcel$export(module.exports, "AuthError", function () { return $38e80d973edee46b$export$145273558d58e0ac; });

var $eXbcV = parcelRequire("eXbcV");

var $728PJ = parcelRequire("728PJ");

var $ioc8c = parcelRequire("ioc8c");

var $kIBCi = parcelRequire("kIBCi");

var $gGNIS = parcelRequire("gGNIS");

var $78AO6 = parcelRequire("78AO6");
function $38e80d973edee46b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $38e80d973edee46b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $gGNIS.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $gGNIS.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $kIBCi.default)(this, result);
    };
}
function $38e80d973edee46b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($38e80d973edee46b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $38e80d973edee46b$export$145273558d58e0ac = /*#__PURE__*/ function(_Error) {
    (0, $ioc8c.default)(AuthError, _Error);
    var _super = $38e80d973edee46b$var$_createSuper(AuthError);
    function AuthError(message, type) {
        var _this;
        (0, $728PJ.default)(this, AuthError);
        _this = _super.call(this, message);
        _this.message = message;
        _this.type = type;
        _this.name = "AuthError";
        _this.type = type;
        _this.message = message;
        return _this;
    }
    return (0, $eXbcV.default)(AuthError);
}(/*#__PURE__*/ (0, $78AO6.default)(Error));

});
parcelRegister("eXbcV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae2f44f7b5990a60$export$2e2bcd8739ae039; });

var $b5mnt = parcelRequire("b5mnt");
function $ae2f44f7b5990a60$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $b5mnt.default)(o.key), o);
    }
}
function $ae2f44f7b5990a60$export$2e2bcd8739ae039(e, r, t) {
    return r && $ae2f44f7b5990a60$var$_defineProperties(e.prototype, r), t && $ae2f44f7b5990a60$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("b5mnt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8121850dc1e734d0$export$2e2bcd8739ae039; });

var $8dWZt = parcelRequire("8dWZt");

var $fZiim = parcelRequire("fZiim");
function $8121850dc1e734d0$export$2e2bcd8739ae039(t) {
    var i = (0, $fZiim.default)(t, "string");
    return "symbol" == (0, $8dWZt.default)(i) ? i : i + "";
}

});
parcelRegister("fZiim", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba3abe8831ea55dd$export$2e2bcd8739ae039; });

var $8dWZt = parcelRequire("8dWZt");
function $ba3abe8831ea55dd$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $8dWZt.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $8dWZt.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("728PJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51ef926d6b09f637$export$2e2bcd8739ae039; });
function $51ef926d6b09f637$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("ioc8c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d633e0e20f089dc0$export$2e2bcd8739ae039; });

var $ioVQw = parcelRequire("ioVQw");
function $d633e0e20f089dc0$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $ioVQw.default)(t, e);
}

});
parcelRegister("ioVQw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d65756ea3a1e97fe$export$2e2bcd8739ae039; });
function $d65756ea3a1e97fe$export$2e2bcd8739ae039(t, e) {
    return $d65756ea3a1e97fe$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $d65756ea3a1e97fe$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("kIBCi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f155189e120ca5a5$export$2e2bcd8739ae039; });

var $8dWZt = parcelRequire("8dWZt");

var $ggMTJ = parcelRequire("ggMTJ");
function $f155189e120ca5a5$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $8dWZt.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $ggMTJ.default)(t);
}

});
parcelRegister("ggMTJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd84120d69e1e6f8$export$2e2bcd8739ae039; });
function $bd84120d69e1e6f8$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("gGNIS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c26723858ca461e4$export$2e2bcd8739ae039; });
function $c26723858ca461e4$export$2e2bcd8739ae039(t) {
    return $c26723858ca461e4$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $c26723858ca461e4$export$2e2bcd8739ae039(t);
}

});

parcelRegister("78AO6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5325d4df836ade42$export$2e2bcd8739ae039; });

var $gGNIS = parcelRequire("gGNIS");

var $ioVQw = parcelRequire("ioVQw");

var $bb82t = parcelRequire("bb82t");

var $gMvM7 = parcelRequire("gMvM7");
function $5325d4df836ade42$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $5325d4df836ade42$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $bb82t.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $gMvM7.default)(t, arguments, (0, $gGNIS.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $ioVQw.default)(Wrapper, t);
    }, $5325d4df836ade42$export$2e2bcd8739ae039(t);
}

});
parcelRegister("bb82t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8236f5283d52c95a$export$2e2bcd8739ae039; });
function $8236f5283d52c95a$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("gMvM7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c379c6e38816a8c2$export$2e2bcd8739ae039; });

var $eHYaC = parcelRequire("eHYaC");

var $ioVQw = parcelRequire("ioVQw");
function $c379c6e38816a8c2$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $eHYaC.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $ioVQw.default)(p, r.prototype), p;
}

});
parcelRegister("eHYaC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab53c16a7444fb74$export$2e2bcd8739ae039; });
function $ab53c16a7444fb74$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ab53c16a7444fb74$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});




parcelRegister("9yeH0", function(module, exports) {

$parcel$export(module.exports, "isOfTypeAuthError", function () { return $6f42afa90803fb12$export$400e64c8451aa84f; });
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
var $6f42afa90803fb12$export$400e64c8451aa84f = function isOfTypeAuthError(inputString) {
    return [
        "auth_window_closed",
        "invalid_request",
        "unauthorized_client",
        "access_denied",
        "unsupported_response_type",
        "invalid_scope",
        "server_error",
        "temporarily_unavailable",
        "authclientoauth2.autherror"
    ].includes(inputString);
};

});


parcelRegister("baMJU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82266f85dbd46f1d$export$2e2bcd8739ae039; });
/* menu-group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1MZec = parcelRequire("1MZec");

var $TMm6K = parcelRequire("TMm6K");

var $iSvIT = parcelRequire("iSvIT");

var $lpers = parcelRequire("lpers");

var $04fQe = parcelRequire("04fQe");
var $82266f85dbd46f1d$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "menuLabel",
    "className"
];
var $82266f85dbd46f1d$var$baseStyles = null;
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $82266f85dbd46f1d$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "cozy" : _ref$spacing, menuLabel = _ref.menuLabel, UNSAFE_className = _ref.className, rest = (0, $TMm6K.default)(_ref, $82266f85dbd46f1d$var$_excluded);
    return /*#__PURE__*/ $iSvIT.createElement((0, $04fQe.SpacingContext).Provider, {
        value: spacing
    }, /*#__PURE__*/ $iSvIT.createElement((0, $04fQe.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "border"
    }, /*#__PURE__*/ $iSvIT.createElement("div", (0, $1MZec.default)({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        "data-testid": testId,
        role: role,
        className: (0, $lpers.default)([
            "_1reo1wug _18m91wug _1e0c1txw _kqswpfqs _2lx21bp4",
            UNSAFE_className
        ]),
        "aria-label": menuLabel
    }, rest))));
};
var $82266f85dbd46f1d$export$2e2bcd8739ae039 = $82266f85dbd46f1d$var$MenuGroup;

});
parcelRegister("1MZec", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14d9c4c53a69dc6b$export$2e2bcd8739ae039; });
function $14d9c4c53a69dc6b$export$2e2bcd8739ae039() {
    return $14d9c4c53a69dc6b$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $14d9c4c53a69dc6b$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("TMm6K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a7aa5946453b3b4$export$2e2bcd8739ae039; });

var $a9DvU = parcelRequire("a9DvU");
function $0a7aa5946453b3b4$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $a9DvU.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("a9DvU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $764965423703d604$export$2e2bcd8739ae039; });
function $764965423703d604$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("lpers", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f957229a0fcb6e49$export$2e2bcd8739ae039; });
const $f957229a0fcb6e49$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $f957229a0fcb6e49$var$ATOMIC_GROUP_LENGTH = 5;
function $f957229a0fcb6e49$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $f957229a0fcb6e49$var$UNDERSCORE_UNICODE ? $f957229a0fcb6e49$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("04fQe", function(module, exports) {

$parcel$export(module.exports, "SpacingContext", function () { return $00cca9a0b29bfc5c$export$443076ec7ebce042; });
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", function () { return $00cca9a0b29bfc5c$export$9ca534b70725964d; });

var $iSvIT = parcelRequire("iSvIT");
var $00cca9a0b29bfc5c$export$443076ec7ebce042 = /*#__PURE__*/ (0, $iSvIT.createContext)("cozy");
var $00cca9a0b29bfc5c$export$9ca534b70725964d = /*#__PURE__*/ (0, $iSvIT.createContext)("border");

});


parcelRegister("3Zk3O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b775822095ff11ff1cfe3f316db8614>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e76a1366de38009$var$_react = $2e76a1366de38009$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $2e76a1366de38009$var$_showMoreHorizontal = $2e76a1366de38009$var$_interopRequireDefault((parcelRequire("d5c7X")));

var $2e76a1366de38009$var$_more = $2e76a1366de38009$var$_interopRequireDefault((parcelRequire("1hHcS")));
function $2e76a1366de38009$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "MoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2e76a1366de38009$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $2e76a1366de38009$var$_react.default.createElement($2e76a1366de38009$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $2e76a1366de38009$var$_more.default
    }, props));
$2e76a1366de38009$var$ShowMoreHorizontalIcon.Name = "ShowMoreHorizontalIconMigration";
var $2e76a1366de38009$var$_default = module.exports.default = $2e76a1366de38009$var$ShowMoreHorizontalIcon;

});
parcelRegister("d5c7X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fb6bef909769872b46b1e0328cacf596>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9865263b0a914927$var$_react = $9865263b0a914927$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $9865263b0a914927$var$_baseNew = $9865263b0a914927$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $9865263b0a914927$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9865263b0a914927$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $9865263b0a914927$var$_react.default.createElement($9865263b0a914927$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$9865263b0a914927$var$ShowMoreHorizontalIcon.displayName = "ShowMoreHorizontalIcon";
var $9865263b0a914927$var$_default = module.exports.default = $9865263b0a914927$var$ShowMoreHorizontalIcon;

});

parcelRegister("1hHcS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ef8e4eacbaa8695$var$_react = $0ef8e4eacbaa8695$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $0ef8e4eacbaa8695$var$_showMoreHorizontal = $0ef8e4eacbaa8695$var$_interopRequireDefault((parcelRequire("d5c7X")));
function $0ef8e4eacbaa8695$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0ef8e4eacbaa8695$var$MoreIcon = (props)=>/*#__PURE__*/ $0ef8e4eacbaa8695$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></g></svg>`
    }, props, {
        newIcon: $0ef8e4eacbaa8695$var$_showMoreHorizontal.default
    }));
$0ef8e4eacbaa8695$var$MoreIcon.displayName = "MoreIcon";
var $0ef8e4eacbaa8695$var$_default = module.exports.default = $0ef8e4eacbaa8695$var$MoreIcon;

});


parcelRegister("cDjdn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9328083693f8d41b$export$2e2bcd8739ae039; });
/* section.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1MZec = parcelRequire("1MZec");

var $TMm6K = parcelRequire("TMm6K");

var $iSvIT = parcelRequire("iSvIT");

var $lpers = parcelRequire("lpers");

var $bPXiE = parcelRequire("bPXiE");
var $9328083693f8d41b$var$_excluded = [
    "children",
    "title",
    "titleId",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "isSideNavSection",
    "className"
];
var $9328083693f8d41b$var$itemHeadingTopMargin = 20;
var $9328083693f8d41b$var$itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $9328083693f8d41b$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
var $9328083693f8d41b$var$skeletonHeadingHeight = 8;
var $9328083693f8d41b$var$skeletonHeadingMarginOffset = 3;
var $9328083693f8d41b$var$skeletonHeadingTopMargin = $9328083693f8d41b$var$itemHeadingTopMargin + ($9328083693f8d41b$var$itemHeadingContentHeight - $9328083693f8d41b$var$skeletonHeadingHeight) - $9328083693f8d41b$var$skeletonHeadingMarginOffset;
var $9328083693f8d41b$var$sectionPaddingTopBottom = 6;
var $9328083693f8d41b$var$styles = {
    root: "_1ywu1ule _cfu11ule _1qdgi2wt _kfgti2wt _aetrb3bt _1kt9b3bt _1p3hi2wt _1l6bgktf _osbldlk8 _auo4rdoj _hp2110yn _1mfv8jkm _1bg41n1a",
    scrollable: "_1reo1wug _18m91wug _1o9zkb7n",
    unscrollable: "_1o9zidpf",
    thinSeparator: "_mqm21imm",
    noSeparator: "_n7cnyjp0",
    sideNavSectionHeading: "_18zru2gc"
};
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $9328083693f8d41b$var$Section = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, title = _ref.title, titleId = _ref.titleId, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, _ref$isSideNavSection = _ref.isSideNavSection, isSideNavSection = _ref$isSideNavSection === void 0 ? false : _ref$isSideNavSection, UNSAFE_className = _ref.className, rest = (0, $TMm6K.default)(_ref, $9328083693f8d41b$var$_excluded);
    var content = isList ? /*#__PURE__*/ $iSvIT.createElement("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $iSvIT.Children).map((0, $iSvIT.Children).toArray(children), function(child, index) {
        return /*#__PURE__*/ $iSvIT.createElement("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: "none",
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? /*#__PURE__*/ $iSvIT.createElement((0, $iSvIT.Fragment), null, /*#__PURE__*/ $iSvIT.createElement((0, $bPXiE.default), {
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true,
        className: (0, $lpers.default)([
            isSideNavSection && $9328083693f8d41b$var$styles.sideNavSectionHeading
        ])
    }, title), content) : /*#__PURE__*/ $iSvIT.createElement((0, $iSvIT.Fragment), null, content);
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $1MZec.default)({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $lpers.default)([
            $9328083693f8d41b$var$styles.root,
            isScrollable ? $9328083693f8d41b$var$styles.scrollable : $9328083693f8d41b$var$styles.unscrollable,
            hasSeparator ? $9328083693f8d41b$var$styles.thinSeparator : $9328083693f8d41b$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        "aria-label": title,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $9328083693f8d41b$export$2e2bcd8739ae039 = $9328083693f8d41b$var$Section;

});
parcelRegister("bPXiE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89e274d8f292451e$export$2e2bcd8739ae039; });
/* heading-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1MZec = parcelRequire("1MZec");

var $TMm6K = parcelRequire("TMm6K");

var $iSvIT = parcelRequire("iSvIT");

var $lpers = parcelRequire("lpers");
var $67VWR = parcelRequire("67VWR");

var $5v9rX = parcelRequire("5v9rX");
var $89e274d8f292451e$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "className"
];
var $89e274d8f292451e$var$headingStyles = null;
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $89e274d8f292451e$var$HeadingItem = /*#__PURE__*/ (0, $iSvIT.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, UNSAFE_className = _ref.className, rest = (0, $TMm6K.default)(_ref, $89e274d8f292451e$var$_excluded);
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $1MZec.default)({
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: (0, $lpers.default)([
            "_11c81vhk _1rjcze3t _18zrpxbi _syaz1vvm",
            UNSAFE_className
        ])
    }, rest, {
        style: {
            "--_bbz764": (0, $67VWR.default)("var(--ds-text-subtle, ".concat((0, $5v9rX.N300), ")"))
        }
    }), children);
});
var $89e274d8f292451e$export$2e2bcd8739ae039 = $89e274d8f292451e$var$HeadingItem;

});
parcelRegister("67VWR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $476058d80dab4e33$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $476058d80dab4e33$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});

parcelRegister("5v9rX", function(module, exports) {

$parcel$export(module.exports, "N300", function () { return $40172d8fd4a222f6$export$e2ef2124cf4024b1; });
// Reds
var $40172d8fd4a222f6$export$4b84fd0e2c617bd = "#FFEBE6";
var $40172d8fd4a222f6$export$b34b069eff244586 = "#FFBDAD";
var $40172d8fd4a222f6$export$be802dd0d8b57f35 = "#FF8F73";
var $40172d8fd4a222f6$export$60847d42f9da92a6 = "#FF7452";
var $40172d8fd4a222f6$export$4a7404f376229999 = "#FF5630";
var $40172d8fd4a222f6$export$2010d0fb4295b346 = "#DE350B";
var $40172d8fd4a222f6$export$2837b5a1a71d5c02 = "#BF2600";
var $40172d8fd4a222f6$export$8d9596b529bbb9cf = "#FFFAE6";
var $40172d8fd4a222f6$export$41060a744ab0b7ae = "#FFF0B3";
var $40172d8fd4a222f6$export$1cc05bbbf340e559 = "#FFE380";
var $40172d8fd4a222f6$export$5aae31392d72caaa = "#FFC400";
var $40172d8fd4a222f6$export$c6930421db9fa514 = "#FFAB00";
var $40172d8fd4a222f6$export$59619663aa6500fb = "#FF991F";
var $40172d8fd4a222f6$export$874739ea9e379ab6 = "#FF8B00";
var $40172d8fd4a222f6$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $40172d8fd4a222f6$export$69a3bf21b9686c2b = "#ABF5D1";
var $40172d8fd4a222f6$export$afbce1382ec95f73 = "#79F2C0";
var $40172d8fd4a222f6$export$747d86715d4175de = "#57D9A3";
var $40172d8fd4a222f6$export$940e1f69e873f202 = "#36B37E";
var $40172d8fd4a222f6$export$a49394138f7b8e85 = "#00875A";
var $40172d8fd4a222f6$export$6fa04827ac68a4fb = "#006644";
var $40172d8fd4a222f6$export$226de0355ed012f8 = "#DEEBFF";
var $40172d8fd4a222f6$export$8c13c2ee36917869 = "#B3D4FF";
var $40172d8fd4a222f6$export$ecfc1dff386a3e7a = "#4C9AFF";
var $40172d8fd4a222f6$export$215b7063051591f1 = "#2684FF";
var $40172d8fd4a222f6$export$e62e8919cca44969 = "#0065FF";
var $40172d8fd4a222f6$export$b3de0ae08da2ce64 = "#0052CC";
var $40172d8fd4a222f6$export$a6ee3d71bc067634 = "#0747A6";
var $40172d8fd4a222f6$export$67f15409e87642a1 = "#669DF1";
var $40172d8fd4a222f6$export$f0539dbc42dbb067 = "#8FB8F6";
var $40172d8fd4a222f6$export$363e4475840015bb = "#EAE6FF";
var $40172d8fd4a222f6$export$4b0a4417ed59760f = "#C0B6F2";
var $40172d8fd4a222f6$export$6011520a64d9a187 = "#998DD9";
var $40172d8fd4a222f6$export$a7175d4e9206bc80 = "#8777D9";
var $40172d8fd4a222f6$export$b48405b95304b5a1 = "#6554C0";
var $40172d8fd4a222f6$export$c71e4279dd54a18d = "#5243AA";
var $40172d8fd4a222f6$export$147899de772240ec = "#403294";
var $40172d8fd4a222f6$export$2cf711fe14c66f06 = "#E6FCFF";
var $40172d8fd4a222f6$export$7a8f4d33f6f9772c = "#B3F5FF";
var $40172d8fd4a222f6$export$776c9c497ef08533 = "#79E2F2";
var $40172d8fd4a222f6$export$69cb3ca10c1e330e = "#00C7E6";
var $40172d8fd4a222f6$export$9dc1ef0f3f48059b = "#00B8D9";
var $40172d8fd4a222f6$export$7c835c78b6fcdef8 = "#00A3BF";
var $40172d8fd4a222f6$export$6036577f95c3877e = "#008DA6";
var $40172d8fd4a222f6$export$29a4f05edc054374 = "#FFFFFF";
var $40172d8fd4a222f6$export$e655ef011c4aa1a2 = "#FAFBFC";
var $40172d8fd4a222f6$export$9fdfb749e33cdf97 = "#F4F5F7";
var $40172d8fd4a222f6$export$3e51e8f1440314ba = "#EBECF0";
var $40172d8fd4a222f6$export$1ce2d1575d444ceb = "#DFE1E6";
var $40172d8fd4a222f6$export$8754fc7e6d8b3000 = "#C1C7D0";
var $40172d8fd4a222f6$export$c2e91cbeada39b8b = "#B3BAC5";
var $40172d8fd4a222f6$export$5f71e19f3a7ad9de = "#A5ADBA";
var $40172d8fd4a222f6$export$eaa8c8a70ac22806 = "#97A0AF";
var $40172d8fd4a222f6$export$7c87d337fb91a97d = "#8993A4";
var $40172d8fd4a222f6$export$d6447c357493214f = "#7A869A";
var $40172d8fd4a222f6$export$f563ee71e9ee74cd = "#6B778C";
var $40172d8fd4a222f6$export$e2ef2124cf4024b1 = "#5E6C84";
var $40172d8fd4a222f6$export$eece5f492e429f08 = "#505F79";
var $40172d8fd4a222f6$export$c39c0fe0f26207ae = "#42526E";
var $40172d8fd4a222f6$export$7090862dc3038a9f = "#344563";
var $40172d8fd4a222f6$export$ad0bacf983b7ddaa = "#253858";
var $40172d8fd4a222f6$export$7d61b15e0da132af = "#172B4D";
var $40172d8fd4a222f6$export$fbda843f0a27fe96 = "#091E42";
var $40172d8fd4a222f6$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $40172d8fd4a222f6$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $40172d8fd4a222f6$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $40172d8fd4a222f6$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $40172d8fd4a222f6$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $40172d8fd4a222f6$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $40172d8fd4a222f6$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $40172d8fd4a222f6$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $40172d8fd4a222f6$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $40172d8fd4a222f6$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $40172d8fd4a222f6$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $40172d8fd4a222f6$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $40172d8fd4a222f6$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $40172d8fd4a222f6$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $40172d8fd4a222f6$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $40172d8fd4a222f6$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $40172d8fd4a222f6$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $40172d8fd4a222f6$export$2f6319cf7d736c2a = "#E6EDFA";
var $40172d8fd4a222f6$export$95126bc8884d6634 = "#DCE5F5";
var $40172d8fd4a222f6$export$8338d8c35d44ff1 = "#CED9EB";
var $40172d8fd4a222f6$export$5368d76ae4fbbda7 = "#B8C7E0";
var $40172d8fd4a222f6$export$9f0a771d16ec8d36 = "#ABBBD6";
var $40172d8fd4a222f6$export$abcf8c38338b4aa5 = "#9FB0CC";
var $40172d8fd4a222f6$export$97e81faa16a182c7 = "#8C9CB8";
var $40172d8fd4a222f6$export$bfe21c59123ecf33 = "#7988A3";
var $40172d8fd4a222f6$export$ee82aa2ea6a1558 = "#67758F";
var $40172d8fd4a222f6$export$682927c6ed76be02 = "#56637A";
var $40172d8fd4a222f6$export$91fd9994c5be9757 = "#455166";
var $40172d8fd4a222f6$export$d281fbfe3cff2df6 = "#3B475C";
var $40172d8fd4a222f6$export$3902c91d8b98a753 = "#313D52";
var $40172d8fd4a222f6$export$8e8133c1ba5845b5 = "#283447";
var $40172d8fd4a222f6$export$33ff357f6620b39 = "#202B3D";
var $40172d8fd4a222f6$export$633847cf062b69e0 = "#1B2638";
var $40172d8fd4a222f6$export$9776a6e503bdbf76 = "#121A29";
var $40172d8fd4a222f6$export$6c813d5160dff5db = "#0E1624";
var $40172d8fd4a222f6$export$3d4f271a500072a = "#0D1424";
var $40172d8fd4a222f6$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $40172d8fd4a222f6$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $40172d8fd4a222f6$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $40172d8fd4a222f6$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $40172d8fd4a222f6$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $40172d8fd4a222f6$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $40172d8fd4a222f6$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $40172d8fd4a222f6$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $40172d8fd4a222f6$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $40172d8fd4a222f6$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $40172d8fd4a222f6$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $40172d8fd4a222f6$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $40172d8fd4a222f6$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $40172d8fd4a222f6$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $40172d8fd4a222f6$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $40172d8fd4a222f6$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $40172d8fd4a222f6$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $40172d8fd4a222f6$export$d2adc5dedf09fced = "#292A2E";
var $40172d8fd4a222f6$export$f51762073d2bb381 = "#94C748";
var $40172d8fd4a222f6$export$95e26d54def96891 = "#B3DF72";

});



parcelRegister("hqrFq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cafa5381cb9a028c$export$2e2bcd8739ae039; });
/* button-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1MZec = parcelRequire("1MZec");

var $TMm6K = parcelRequire("TMm6K");

var $iSvIT = parcelRequire("iSvIT");


var $7nG8r = parcelRequire("7nG8r");

var $jxLBU = parcelRequire("jxLBU");

var $eh5q2 = parcelRequire("eh5q2");
var $cafa5381cb9a028c$var$_excluded = [
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "interactionName"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $cafa5381cb9a028c$var$ButtonItem = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var children = props.children, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, interactionName = props.interactionName, rest = (0, $TMm6K.default)(props, $cafa5381cb9a028c$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $iSvIT.useContext)((0, $7nG8r.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ $iSvIT.createElement((0, $eh5q2.default), (0, $1MZec.default)({
        className: UNSAFE_className
    }, rest, {
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $iSvIT.createElement("button", (0, $1MZec.default)({
            "data-testid": testId,
            "aria-current": isSelected && (0, $jxLBU.fg)("platform_dst_menu_item_button_aria_current") ? "true" : undefined
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $cafa5381cb9a028c$export$2e2bcd8739ae039 = $cafa5381cb9a028c$var$ButtonItem;

});
parcelRegister("eh5q2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a646db50c7e2eb4d$export$2e2bcd8739ae039; });
/* menu-item-primitive.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $lpers = parcelRequire("lpers");

var $jxLBU = parcelRequire("jxLBU");

var $jm9p1 = parcelRequire("jm9p1");

var $04fQe = parcelRequire("04fQe");
var $a646db50c7e2eb4d$var$renderTitle = function renderTitle(Component, props) {
    return(/*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    $iSvIT.createElement(Component, props));
};
var $a646db50c7e2eb4d$var$styles = {
    root: "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _vchhusvi _1bsb1osq _1tke1ylp _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _4cvr1h6o _uiztglyw _80omtlke _ymio1r31 _ypr0glyw _zcxs1o36 _nt75194a _mizu194a _1bg411pw _1ah311pw _49pcnqa1 _ra3xnqa1 _1hvw1bk5 _128m1bk5 _9oik1r31 _1bnxglyw _jf4cnqa1 _1cvmnqa1 _4davt94y",
    beforeAfterElement: "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf",
    content: "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _16jlkb7n _y3gn1e5h",
    truncate: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    title: "_11c82smr",
    wordBreak: "_1nmz1hna",
    description: "_11c8dcr7 _syaz1wmz",
    disabledDescription: "_syaz2oi6",
    unselected: "_bfhkqtfy _syaz1r31 _10531r31 _irr31dko _30l31r31 _1di61dko _9h8h1r31",
    disabled: "_80om13gf _bfhkqtfy _syaz2oi6 _irr3qtfy _30l32oi6 _1di6qtfy _9h8h2oi6",
    selectedBorder: "_1mp4yh40 _1cs8stnw _1rus67is _1kt9b3bt _1fkrze3t _iajmze3t _z5wtze3t",
    selectedNotch: "_rfx315o9 _1mp41y44 _1cs8stnw _1rus67is _1kt9b3bt _1fkrutpp _iajmutpp _z5wtze3t",
    selected: "_bfhk1q4k _syazhu5v _1053hu5v _irr32seo _30l316ov _1di6guph _9h8hhu5v",
    selectedOld: "_30l3hu5v"
};
var $a646db50c7e2eb4d$var$spacingMapStyles = {
    cozy: "_1rjcu2gc _18zrpxbi",
    compact: "_1rjc1b66 _18zrutpp _1tkezwfg"
};
var $a646db50c7e2eb4d$var$gapMap = {
    compact: "space.100",
    cozy: "space.150"
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $a646db50c7e2eb4d$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, testId = _ref.testId;
    var spacing = (0, $iSvIT.useContext)((0, $04fQe.SpacingContext));
    var selectionStyle = (0, $iSvIT.useContext)((0, $04fQe.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    var UNSAFE_className = UNSAFE_externalClassName;
    return function() {
        return children({
            className: (0, $lpers.default)([
                (0, $lpers.default)([
                    $a646db50c7e2eb4d$var$styles.root,
                    $a646db50c7e2eb4d$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $a646db50c7e2eb4d$var$styles.unselected,
                    !isDisabled && isSelected && $a646db50c7e2eb4d$var$styles.selected,
                    !(0, $jxLBU.fg)("platform_fix_a11y_selected_and_hovered_state_color") && !isDisabled && isSelected && $a646db50c7e2eb4d$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === "border" && $a646db50c7e2eb4d$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === "notch" && $a646db50c7e2eb4d$var$styles.selectedNotch,
                    isDisabled && $a646db50c7e2eb4d$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ $iSvIT.createElement((0, $jm9p1.default), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $a646db50c7e2eb4d$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && /*#__PURE__*/ $iSvIT.createElement("span", {
                "data-item-elem-before": true,
                "data-testid": testId && "".concat(testId, "--icon-before"),
                className: (0, $lpers.default)([
                    $a646db50c7e2eb4d$var$styles.beforeAfterElement
                ])
            }, iconBefore), title && /*#__PURE__*/ $iSvIT.createElement("div", {
                className: (0, $lpers.default)([
                    $a646db50c7e2eb4d$var$styles.content
                ])
            }, $a646db50c7e2eb4d$var$renderTitle(isTitleHeading ? "h2" : "span", {
                children: title,
                className: (0, $lpers.default)([
                    $a646db50c7e2eb4d$var$styles.title,
                    shouldTitleWrap ? $a646db50c7e2eb4d$var$styles.wordBreak : $a646db50c7e2eb4d$var$styles.truncate
                ]),
                "data-item-title": true
            }), description && /*#__PURE__*/ $iSvIT.createElement("span", {
                "data-item-description": true,
                className: (0, $lpers.default)([
                    $a646db50c7e2eb4d$var$styles.description,
                    isDisabled && $a646db50c7e2eb4d$var$styles.disabledDescription,
                    shouldDescriptionWrap && $a646db50c7e2eb4d$var$styles.wordBreak,
                    !shouldDescriptionWrap && $a646db50c7e2eb4d$var$styles.truncate
                ])
            }, description)), iconAfter && /*#__PURE__*/ $iSvIT.createElement("span", {
                "data-item-elem-after": true,
                "data-testid": testId && "".concat(testId, "--icon-after"),
                className: (0, $lpers.default)([
                    $a646db50c7e2eb4d$var$styles.beforeAfterElement
                ])
            }, iconAfter))
        });
    }();
};
var $a646db50c7e2eb4d$export$2e2bcd8739ae039 = $a646db50c7e2eb4d$var$MenuItemPrimitive;

});
parcelRegister("jm9p1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1775d91fa3c38bc$export$2e2bcd8739ae039; });
/* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1MZec = parcelRequire("1MZec");

var $TMm6K = parcelRequire("TMm6K");

var $iSvIT = parcelRequire("iSvIT");

var $lpers = parcelRequire("lpers");

var $9BTqR = parcelRequire("9BTqR");

var $diH9G = parcelRequire("diH9G");
var $e1775d91fa3c38bc$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $e1775d91fa3c38bc$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $e1775d91fa3c38bc$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        className: (0, $lpers.default)([
            $e1775d91fa3c38bc$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $e1775d91fa3c38bc$var$Inline = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, $TMm6K.default)(_ref2, $e1775d91fa3c38bc$var$_excluded);
    var separatorComponent = typeof separator === "string" ? /*#__PURE__*/ $iSvIT.createElement($e1775d91fa3c38bc$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $iSvIT.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $iSvIT.createElement((0, $iSvIT.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $iSvIT.createElement((0, $diH9G.default), (0, $1MZec.default)({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: (0, $9BTqR.cx)(grow === "hug" && $e1775d91fa3c38bc$var$styles.hug, grow === "fill" && $e1775d91fa3c38bc$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$e1775d91fa3c38bc$var$Inline.displayName = "Inline";
var $e1775d91fa3c38bc$export$2e2bcd8739ae039 = $e1775d91fa3c38bc$var$Inline;

});
parcelRegister("9BTqR", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $6ff291771c90042d$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("iSvIT");


var $gdAdD = parcelRequire("gdAdD");
var $6ff291771c90042d$var$_createStrictAPI = (0, $gdAdD.createStrictAPI)(), $6ff291771c90042d$var$XCSSProp = $6ff291771c90042d$var$_createStrictAPI.XCSSProp, $6ff291771c90042d$export$dbf350e5966cf602 = $6ff291771c90042d$var$_createStrictAPI.css, $6ff291771c90042d$export$eb1ecd84a24ee424 = $6ff291771c90042d$var$_createStrictAPI.cssMap, $6ff291771c90042d$export$a274e22fb40f762e = $6ff291771c90042d$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means products only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});
parcelRegister("gdAdD", function(module, exports) {

$parcel$export(module.exports, "createStrictAPI", function () { return $bce9f4906a24a095$export$39716b4af53f4ad; });

var $iMMDq = parcelRequire("iMMDq");

var $e4sZm = parcelRequire("e4sZm");
function $bce9f4906a24a095$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $iMMDq.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $iMMDq.createStrictSetupError)();
        },
        cx: $e4sZm.cx,
        XCSSProp () {
            throw (0, $iMMDq.createStrictSetupError)();
        }
    };
}

});
parcelRegister("iMMDq", function(module, exports) {

$parcel$export(module.exports, "createStrictSetupError", function () { return $dad26f92a24c0342$export$c4df1cb0c2b4d77c; });
const $dad26f92a24c0342$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $dad26f92a24c0342$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("e4sZm", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $a3e7ecf1a2df8590$export$a274e22fb40f762e; });

var $lpers = parcelRequire("lpers");
const $a3e7ecf1a2df8590$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $lpers.default)(actualStyles);
};

});



parcelRegister("diH9G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9aee6e81fca33eb6$export$2e2bcd8739ae039; });
/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1MZec = parcelRequire("1MZec");

var $TMm6K = parcelRequire("TMm6K");

var $iSvIT = parcelRequire("iSvIT");

var $lpers = parcelRequire("lpers");
var $9aee6e81fca33eb6$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $9aee6e81fca33eb6$var$rowGapMap = {
    "space.0": "_1p57ze3t",
    "space.025": "_1p57v77o",
    "space.050": "_1p571b66",
    "space.075": "_1p5712x7",
    "space.100": "_1p57u2gc",
    "space.150": "_1p57utpp",
    "space.200": "_1p57pxbi",
    "space.250": "_1p57v47k",
    "space.300": "_1p571ejb",
    "space.400": "_1p57xy5q",
    "space.500": "_1p571jfw",
    "space.600": "_1p57oahv",
    "space.800": "_1p57xncg",
    "space.1000": "_1p571epz"
};
var $9aee6e81fca33eb6$var$columnGapMap = {
    "space.0": "_gy1pze3t",
    "space.025": "_gy1pv77o",
    "space.050": "_gy1p1b66",
    "space.075": "_gy1p12x7",
    "space.100": "_gy1pu2gc",
    "space.150": "_gy1putpp",
    "space.200": "_gy1ppxbi",
    "space.250": "_gy1pv47k",
    "space.300": "_gy1p1ejb",
    "space.400": "_gy1pxy5q",
    "space.500": "_gy1p1jfw",
    "space.600": "_gy1poahv",
    "space.800": "_gy1pxncg",
    "space.1000": "_gy1p1epz"
};
var $9aee6e81fca33eb6$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    "space-between": "_1bah1yb4",
    "space-around": "_1bah1b1v",
    "space-evenly": "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $9aee6e81fca33eb6$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $9aee6e81fca33eb6$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $9aee6e81fca33eb6$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $9aee6e81fca33eb6$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $9aee6e81fca33eb6$var$Flex = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, $TMm6K.default)(_ref, $9aee6e81fca33eb6$var$_excluded);
    return /*#__PURE__*/ $iSvIT.createElement(Component, (0, $1MZec.default)({}, ariaAttributes, {
        role: role,
        className: (0, $lpers.default)([
            $9aee6e81fca33eb6$var$styles.root,
            gap && $9aee6e81fca33eb6$var$columnGapMap[gap],
            columnGap && $9aee6e81fca33eb6$var$columnGapMap[columnGap],
            gap && $9aee6e81fca33eb6$var$rowGapMap[gap],
            rowGap && $9aee6e81fca33eb6$var$rowGapMap[rowGap],
            alignItems && $9aee6e81fca33eb6$var$alignItemsMap[alignItems],
            direction && $9aee6e81fca33eb6$var$flexDirectionMap[direction],
            justifyContent && $9aee6e81fca33eb6$var$justifyContentMap[justifyContent],
            wrap && $9aee6e81fca33eb6$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$9aee6e81fca33eb6$var$Flex.displayName = "Flex";
var $9aee6e81fca33eb6$export$2e2bcd8739ae039 = $9aee6e81fca33eb6$var$Flex;

});




parcelRegister("Kym27", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08bef20e369c16ba$export$2e2bcd8739ae039; });
/* custom-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1MZec = parcelRequire("1MZec");

var $TMm6K = parcelRequire("TMm6K");

var $iSvIT = parcelRequire("iSvIT");


var $7nG8r = parcelRequire("7nG8r");

var $eh5q2 = parcelRequire("eh5q2");
var $08bef20e369c16ba$var$_excluded = [
    "component",
    "isDisabled",
    "isSelected",
    "isTitleHeading",
    "onClick",
    "testId",
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $08bef20e369c16ba$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
// Dirty hack to get generics working with forward ref [1/2]
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $08bef20e369c16ba$var$CustomItem = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var Component = _ref.component, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, onClick = _ref.onClick, testId = _ref.testId, children = _ref.children, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, onMouseDown = _ref.onMouseDown, shouldTitleWrap = _ref.shouldTitleWrap, shouldDescriptionWrap = _ref.shouldDescriptionWrap, UNSAFE_className = _ref.className, UNSAFE_isDraggable = _ref.UNSAFE_isDraggable, interactionName = _ref.interactionName, rest = (0, $TMm6K.default)(_ref, $08bef20e369c16ba$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $iSvIT.useContext)((0, $7nG8r.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ $iSvIT.createElement((0, $eh5q2.default), (0, $1MZec.default)({
        className: UNSAFE_className
    }, rest, {
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref2) {
        var children = _ref2.children, className = _ref2.className;
        return /*#__PURE__*/ $iSvIT.createElement(Component, (0, $1MZec.default)({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $08bef20e369c16ba$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $08bef20e369c16ba$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $08bef20e369c16ba$var$preventEvent : handleClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }), children);
    });
}));
var $08bef20e369c16ba$export$2e2bcd8739ae039 = $08bef20e369c16ba$var$CustomItem;

});

parcelRegister("gWsly", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5580d2d46b2a11a$export$2e2bcd8739ae039; });
/* link-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1MZec = parcelRequire("1MZec");

var $TMm6K = parcelRequire("TMm6K");

var $iSvIT = parcelRequire("iSvIT");


var $6F6FS = parcelRequire("6F6FS");

var $7nG8r = parcelRequire("7nG8r");

var $eh5q2 = parcelRequire("eh5q2");
var $c5580d2d46b2a11a$var$_excluded = [
    "children",
    "href",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_shouldDisableRouterLink",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $c5580d2d46b2a11a$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $c5580d2d46b2a11a$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $c5580d2d46b2a11a$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $c5580d2d46b2a11a$var$LinkItem = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var children = props.children, href = props.href, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable = props.UNSAFE_isDraggable, interactionName = props.interactionName, rest = (0, $TMm6K.default)(props, $c5580d2d46b2a11a$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, $6F6FS.default)();
    var interactionContext = (0, $iSvIT.useContext)((0, $7nG8r.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    var isExternal = typeof href === "string" && $c5580d2d46b2a11a$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === "string" && $c5580d2d46b2a11a$var$IS_NON_HTTP_BASED.test(href);
    var isEmptyHref = href == null || href === "";
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    var Component = isRouterLink ? RouterLink : "a";
    return /*#__PURE__*/ $iSvIT.createElement((0, $eh5q2.default), (0, $1MZec.default)({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $iSvIT.createElement(Component, (0, $1MZec.default)({
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined,
            "data-vc": "link-item"
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $c5580d2d46b2a11a$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $c5580d2d46b2a11a$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $c5580d2d46b2a11a$var$preventEvent : handleClick,
            "aria-current": isSelected ? "page" : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }), children);
    });
}));
var $c5580d2d46b2a11a$export$2e2bcd8739ae039 = $c5580d2d46b2a11a$var$LinkItem;

});

parcelRegister("7xtRp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa37e7fb05387379200e2a91e20ea76e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57d2c72041636d74$var$_react = $57d2c72041636d74$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $57d2c72041636d74$var$_baseNew = $57d2c72041636d74$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $57d2c72041636d74$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $57d2c72041636d74$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $57d2c72041636d74$var$_react.default.createElement($57d2c72041636d74$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.47 12.47 9.75-9.75 1.06 1.06-9.75 9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M12 4H5.75V2.5h7a.75.75 0 0 1 .75.75v7H12z" clip-rule="evenodd"/>`
    }, props));
$57d2c72041636d74$var$ArrowUpRightIcon.displayName = "ArrowUpRightIcon";
var $57d2c72041636d74$var$_default = module.exports.default = $57d2c72041636d74$var$ArrowUpRightIcon;

});

parcelRegister("c8hkI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3359cfcb124b9edec9402a579fa9711>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d53ad63e3caa159$var$_react = $8d53ad63e3caa159$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $8d53ad63e3caa159$var$_baseNew = $8d53ad63e3caa159$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $8d53ad63e3caa159$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8d53ad63e3caa159$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $8d53ad63e3caa159$var$_react.default.createElement($8d53ad63e3caa159$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$8d53ad63e3caa159$var$CheckboxCheckedIcon.displayName = "CheckboxCheckedIcon";
var $8d53ad63e3caa159$var$_default = module.exports.default = $8d53ad63e3caa159$var$CheckboxCheckedIcon;

});

parcelRegister("hiFO1", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", function () { return $c9848bdff23800bd$export$81b70111112841a0; });
var $c9848bdff23800bd$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: "NOT_STARTED",
        final: true
    },
    STARTED: {
        id: "STARTED"
    },
    IN_PROGRESS: {
        id: "IN_PROGRESS"
    },
    BLOCKED: {
        id: "BLOCKED"
    },
    RECOVERED: {
        id: "RECOVERED"
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: "SUCCEEDED",
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: "SUCCEEDED_WAITING_FOR_DEPS"
    },
    FAILED: {
        id: "FAILED",
        final: true
    },
    ABORTED: {
        id: "ABORTED",
        final: true
    }
};

});

parcelRegister("am2oZ", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", function () { return $0ac88c33a7cdd10e$export$3e67810a3f0e9f1c; });
function $0ac88c33a7cdd10e$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $0ac88c33a7cdd10e$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $0ac88c33a7cdd10e$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $0ac88c33a7cdd10e$export$967a6b9924a689f7(a, b);
    return $0ac88c33a7cdd10e$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("aZAko", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", function () { return $800bc7d8f16498ae$export$ac1cddfee07ba6ac; });

var $9DI7H = parcelRequire("9DI7H");

var $87mML = parcelRequire("87mML");

var $hNkel = parcelRequire("hNkel");

var $ihybq = parcelRequire("ihybq");

var $94Wrd = parcelRequire("94Wrd");
var $800bc7d8f16498ae$export$ac1cddfee07ba6ac = /*#__PURE__*/ function() {
    function ConcurrentExperience(experienceId, config) {
        (0, $9DI7H.default)(this, ConcurrentExperience);
        (0, $hNkel.default)(this, "instances", {});
        this.experienceId = experienceId;
        this.config = config;
    }
    return (0, $87mML.default)(ConcurrentExperience, [
        {
            key: "getInstance",
            value: function getInstance(instanceId) {
                if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $94Wrd.UFOExperience)(this.experienceId, this.config, instanceId);
                return this.instances[instanceId];
            }
        },
        {
            key: "release",
            value: function release(instanceId) {
                (0, $ihybq.ufolog)("instanceId", instanceId);
                if (this.instances[instanceId]) this.instances[instanceId].abort();
                delete this.instances[instanceId];
            }
        }
    ]);
}();

});
parcelRegister("9DI7H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7049fb87032a6465$export$2e2bcd8739ae039; });
function $7049fb87032a6465$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("87mML", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e90a6ea82ef809b$export$2e2bcd8739ae039; });

var $jtQBe = parcelRequire("jtQBe");
function $5e90a6ea82ef809b$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $jtQBe.default)(o.key), o);
    }
}
function $5e90a6ea82ef809b$export$2e2bcd8739ae039(e, r, t) {
    return r && $5e90a6ea82ef809b$var$_defineProperties(e.prototype, r), t && $5e90a6ea82ef809b$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("jtQBe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2e986ecb5186843$export$2e2bcd8739ae039; });

var $7RHG1 = parcelRequire("7RHG1");

var $buCSS = parcelRequire("buCSS");
function $e2e986ecb5186843$export$2e2bcd8739ae039(t) {
    var i = (0, $buCSS.default)(t, "string");
    return "symbol" == (0, $7RHG1.default)(i) ? i : i + "";
}

});
parcelRegister("7RHG1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b9f5ced1b980003$export$2e2bcd8739ae039; });
function $5b9f5ced1b980003$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $5b9f5ced1b980003$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5b9f5ced1b980003$export$2e2bcd8739ae039(o);
}

});

parcelRegister("buCSS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85e0a8a57c791132$export$2e2bcd8739ae039; });

var $7RHG1 = parcelRequire("7RHG1");
function $85e0a8a57c791132$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $7RHG1.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $7RHG1.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("hNkel", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf46b4947c3d580c$export$2e2bcd8739ae039; });

var $jtQBe = parcelRequire("jtQBe");
function $cf46b4947c3d580c$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $jtQBe.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("ihybq", function(module, exports) {

$parcel$export(module.exports, "ufolog", function () { return $d4f454983ba5d899$export$b4958caff08a0960; });
$parcel$export(module.exports, "ufowarn", function () { return $d4f454983ba5d899$export$d53d07b6034c4560; });

var $9DI7H = parcelRequire("9DI7H");

var $87mML = parcelRequire("87mML");

var $hNkel = parcelRequire("hNkel");
var $d4f454983ba5d899$var$UFOLogger = /*#__PURE__*/ function() {
    function UFOLogger() {
        (0, $9DI7H.default)(this, UFOLogger);
        (0, $hNkel.default)(this, "enabled", false);
    }
    return (0, $87mML.default)(UFOLogger, [
        {
            key: "log",
            value: function log() {
                var _console;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // eslint-disable-next-line no-console
                this.enabled && (_console = console).log.apply(_console, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "warn",
            value: function warn() {
                var _console2;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                // eslint-disable-next-line no-console
                this.enabled && (_console2 = console).warn.apply(_console2, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.enabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.enabled = false;
            }
        }
    ]);
}();
(0, $hNkel.default)($d4f454983ba5d899$var$UFOLogger, "UFOprefix", "[ufo\uD83D\uDEF8]");
var $d4f454983ba5d899$export$4ab84f6f04f6566d = new $d4f454983ba5d899$var$UFOLogger();
var $d4f454983ba5d899$export$b4958caff08a0960 = function ufolog() {
    $d4f454983ba5d899$export$4ab84f6f04f6566d.log.apply($d4f454983ba5d899$export$4ab84f6f04f6566d, arguments);
};
var $d4f454983ba5d899$export$d53d07b6034c4560 = function ufowarn() {
    $d4f454983ba5d899$export$4ab84f6f04f6566d.warn.apply($d4f454983ba5d899$export$4ab84f6f04f6566d, arguments);
};

});

parcelRegister("94Wrd", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", function () { return $69c1d150c89584fb$export$c00d22927c60484a; });

var $87mML = parcelRequire("87mML");

var $9DI7H = parcelRequire("9DI7H");

var $1msPr = parcelRequire("1msPr");

var $bgB6C = parcelRequire("bgB6C");

var $69Rla = parcelRequire("69Rla");

var $4Um9p = parcelRequire("4Um9p");
function $69c1d150c89584fb$var$_callSuper(t, o, e) {
    return o = (0, $bgB6C.default)(o), (0, $1msPr.default)(t, $69c1d150c89584fb$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $bgB6C.default)(t).constructor) : o.apply(t, e));
}
function $69c1d150c89584fb$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($69c1d150c89584fb$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $69c1d150c89584fb$export$c00d22927c60484a = /*#__PURE__*/ function(_UFOAbstractExperienc) {
    function UFOExperience() {
        (0, $9DI7H.default)(this, UFOExperience);
        return $69c1d150c89584fb$var$_callSuper(this, UFOExperience, arguments);
    }
    (0, $69Rla.default)(UFOExperience, _UFOAbstractExperienc);
    return (0, $87mML.default)(UFOExperience);
}((0, $4Um9p.UFOAbstractExperience));

});
parcelRegister("1msPr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fde354cb4c3c615$export$2e2bcd8739ae039; });

var $7RHG1 = parcelRequire("7RHG1");

var $lydgT = parcelRequire("lydgT");
function $0fde354cb4c3c615$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $7RHG1.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $lydgT.default)(t);
}

});
parcelRegister("lydgT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb0711617c7bea5d$export$2e2bcd8739ae039; });
function $fb0711617c7bea5d$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("bgB6C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $833df8c66fe257ba$export$2e2bcd8739ae039; });
function $833df8c66fe257ba$export$2e2bcd8739ae039(t) {
    return $833df8c66fe257ba$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $833df8c66fe257ba$export$2e2bcd8739ae039(t);
}

});

parcelRegister("69Rla", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47bcf5a5a9db39bb$export$2e2bcd8739ae039; });

var $b7x5Y = parcelRequire("b7x5Y");
function $47bcf5a5a9db39bb$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $b7x5Y.default)(t, e);
}

});
parcelRegister("b7x5Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $818a052ff97c3817$export$2e2bcd8739ae039; });
function $818a052ff97c3817$export$2e2bcd8739ae039(t, e) {
    return $818a052ff97c3817$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $818a052ff97c3817$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("4Um9p", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", function () { return $392d930fd8655aa1$export$d31c89db257648c; });

var $dKONQ = parcelRequire("dKONQ");

var $jcRsg = parcelRequire("jcRsg");

var $9DI7H = parcelRequire("9DI7H");

var $87mML = parcelRequire("87mML");

var $hNkel = parcelRequire("hNkel");

var $aXc0l = parcelRequire("aXc0l");

var $fJncN = parcelRequire("fJncN");

var $k2su8 = parcelRequire("k2su8");

var $lQWwC = parcelRequire("lQWwC");

var $ihybq = parcelRequire("ihybq");

var $5TnYJ = parcelRequire("5TnYJ");

var $aFIlZ = parcelRequire("aFIlZ");

var $j8TkB = parcelRequire("j8TkB");

var $ddwhl = parcelRequire("ddwhl");

var $hiFO1 = parcelRequire("hiFO1");

var $fHiSC = parcelRequire("fHiSC");

var $11Cwy = parcelRequire("11Cwy");
function $392d930fd8655aa1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $392d930fd8655aa1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $392d930fd8655aa1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hNkel.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $392d930fd8655aa1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $392d930fd8655aa1$var$getPageVisibleState = function getPageVisibleState() {
    return !(0, $ddwhl.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === "visible" ? (0, $aFIlZ.PageVisibleState).VISIBLE : (0, $aFIlZ.PageVisibleState).HIDDEN;
};
var $392d930fd8655aa1$export$c753e8669d30c8ad = function perfNowOrTimestamp(timestamp) {
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $j8TkB.roundPerfNow)();
};
var $392d930fd8655aa1$export$d31c89db257648c = /*#__PURE__*/ function() {
    function UFOAbstractExperience(id, config) {
        var _this = this;
        var instanceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        (0, $9DI7H.default)(this, UFOAbstractExperience);
        (0, $hNkel.default)(this, "state", (0, $hiFO1.UFOExperienceState).NOT_STARTED);
        (0, $hNkel.default)(this, "instanceId", null);
        // for concurrent
        (0, $hNkel.default)(this, "parent", null);
        (0, $hNkel.default)(this, "category", null);
        (0, $hNkel.default)(this, "metadata", {});
        (0, $hNkel.default)(this, "onDoneCallbacks", []);
        (0, $hNkel.default)(this, "childExperiences", []);
        (0, $hNkel.default)(this, "explicitTimings", {});
        // @todo move to page load experience when proper classes/inheritance prepared
        (0, $hNkel.default)(this, "isSSROutputAsFMP", false);
        (0, $hNkel.default)(this, "uuid", null);
        (0, $hNkel.default)(this, "_until", null);
        (0, $hNkel.default)(this, "metrics", {
            startTime: null,
            endTime: null,
            marks: []
        });
        (0, $hNkel.default)(this, "performanceConfig", {});
        (0, $hNkel.default)(this, "setPageVisibleStateToMixed", function() {
            _this.pageVisibleState = (0, $aFIlZ.PageVisibleState).MIXED;
            (0, $5TnYJ.visibilityChangeObserver).unsubscribe(_this.setPageVisibleStateToMixed);
        });
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $392d930fd8655aa1$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $11Cwy.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $11Cwy.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    return (0, $87mML.default)(UFOAbstractExperience, [
        {
            key: "transition",
            value: function() {
                var _transition = (0, $jcRsg.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aXc0l))).mark(function _callee(newState, timestamp) {
                    var data;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aXc0l))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                (0, $ihybq.ufolog)("async transition", this.id, this.state.id, newState.id);
                                if (!(0, $fHiSC.canTransition)(this.state, newState)) {
                                    _context.next = 15;
                                    break;
                                }
                                (0, $ihybq.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " successful"), this.state.final, !newState.final);
                                if (newState === (0, $hiFO1.UFOExperienceState).STARTED) this._reset();
                                if (this.state.final && !newState.final) {
                                    this.metrics.startTime = $392d930fd8655aa1$export$c753e8669d30c8ad(timestamp);
                                    this.uuid = (0, $fJncN.v4)();
                                }
                                this.state = newState;
                                if (!newState.final) {
                                    _context.next = 14;
                                    break;
                                }
                                this.metrics.endTime = $392d930fd8655aa1$export$c753e8669d30c8ad(timestamp);
                                if (!this._isManualStateEnabled()) (0, $lQWwC.getGlobalEventStream)().push((0, $lQWwC.unsubscribeEvent)((0, $aFIlZ.SUBSCRIBE_ALL), this.handleDoneBind));
                                _context.next = 11;
                                return this.exportData();
                            case 11:
                                data = _context.sent;
                                (0, $ihybq.ufolog)("this.parent", this.parent);
                                (0, $lQWwC.getGlobalEventStream)().push((0, $lQWwC.experiencePayloadEvent)(data));
                            case 14:
                                return _context.abrupt("return", true);
                            case 15:
                                (0, $ihybq.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " unsuccessful"));
                                (0, $ihybq.ufowarn)("transition of ".concat(this.id, " from ").concat(this.state, " to ").concat(newState, " is not possible"));
                                return _context.abrupt("return", false);
                            case 18:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function transition(_x, _x2) {
                    return _transition.apply(this, arguments);
                }
                return transition;
            }()
        },
        {
            key: "start",
            value: function() {
                var _start = (0, $jcRsg.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aXc0l))).mark(function _callee2(startTime) {
                    var transitionSuccessful;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aXc0l))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.transition((0, $hiFO1.UFOExperienceState).STARTED, startTime);
                            case 2:
                                transitionSuccessful = _context2.sent;
                                if (transitionSuccessful) {
                                    this.pageVisibleState = $392d930fd8655aa1$var$getPageVisibleState();
                                    (0, $5TnYJ.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                                    if (!this._isManualStateEnabled()) {
                                        (0, $ihybq.ufolog)("subscribed", this.id);
                                        (0, $lQWwC.getGlobalEventStream)().push((0, $lQWwC.subscribeEvent)((0, $aFIlZ.SUBSCRIBE_ALL), this.handleDoneBind));
                                    }
                                }
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function start(_x3) {
                    return _start.apply(this, arguments);
                }
                return start;
            }()
        },
        {
            key: "mark",
            value: function mark(name, timestamp) {
                if (name !== (0, $aFIlZ.FMP_MARK) && name !== (0, $aFIlZ.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
                else (0, $ihybq.ufowarn)("please use markFMP or markInlineResponse for specialised marks");
            }
        },
        {
            key: "_mark",
            value: function _mark(name, timestamp) {
                this.metrics.marks.push({
                    name: name,
                    time: $392d930fd8655aa1$export$c753e8669d30c8ad(timestamp)
                });
                this.transition((0, $hiFO1.UFOExperienceState).IN_PROGRESS);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                this._mark((0, $aFIlZ.FMP_MARK), timestamp);
            }
        },
        {
            key: "markInlineResponse",
            value: function markInlineResponse(timestamp) {
                this._mark((0, $aFIlZ.INLINE_RESPONSE_MARK), timestamp);
            }
        },
        {
            key: "_isManualStateEnabled",
            value: function _isManualStateEnabled() {
                return this.until === null;
            }
        },
        {
            key: "_validateManualState",
            value: function _validateManualState() {
                if (!this._isManualStateEnabled()) {
                    (0, $ihybq.ufowarn)('manual change of state not allowed as "until" is defined');
                    return false;
                }
                return true;
            }
        },
        {
            key: "switchToEndState",
            value: function switchToEndState(state, config) {
                if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
                if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
                (0, $5TnYJ.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
                return this.transition(state);
            }
        },
        {
            key: "success",
            value: function() {
                var _success = (0, $jcRsg.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aXc0l))).mark(function _callee3(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aXc0l))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", this.switchToEndState((0, $hiFO1.UFOExperienceState).SUCCEEDED, config));
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function success(_x4) {
                    return _success.apply(this, arguments);
                }
                return success;
            }()
        },
        {
            key: "failure",
            value: function() {
                var _failure = (0, $jcRsg.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aXc0l))).mark(function _callee4(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aXc0l))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                return _context4.abrupt("return", this.switchToEndState((0, $hiFO1.UFOExperienceState).FAILED, config));
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function failure(_x5) {
                    return _failure.apply(this, arguments);
                }
                return failure;
            }()
        },
        {
            key: "abort",
            value: function() {
                var _abort = (0, $jcRsg.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aXc0l))).mark(function _callee5(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aXc0l))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                return _context5.abrupt("return", this.switchToEndState((0, $hiFO1.UFOExperienceState).ABORTED, config));
                            case 1:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function abort(_x6) {
                    return _abort.apply(this, arguments);
                }
                return abort;
            }()
        },
        {
            key: "addMetadata",
            value: function addMetadata(data) {
                Object.assign(this.metadata, data);
            }
        },
        {
            key: "_handleDoneExperience",
            value: function _handleDoneExperience(data) {
                (0, $ihybq.ufolog)("_handleDoneExperience in", this.id, data.state, data, this._until);
                if (data.state.final) {
                    if (this._until !== null) {
                        var _this$_until = this._until(data), done = _this$_until.done, state = _this$_until.state;
                        if (done && !this.state.final) this.transition(state);
                    }
                }
            }
        },
        {
            key: "getId",
            value: function() {
                var _getId = (0, $jcRsg.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aXc0l))).mark(function _callee6() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aXc0l))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                return _context6.abrupt("return", this.id);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function getId() {
                    return _getId.apply(this, arguments);
                }
                return getId;
            }()
        },
        {
            key: "exportData",
            value: function() {
                var _exportData = (0, $jcRsg.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aXc0l))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aXc0l))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                _context7.next = 2;
                                return this.getId();
                            case 2:
                                _context7.t0 = _context7.sent;
                                _context7.t1 = this.uuid;
                                _context7.t2 = this.type;
                                _context7.t3 = (0, $k2su8.UFO_EXPERIMENTAL_BUILD_VERSION) || "unknown";
                                _context7.t4 = this.performanceType;
                                _context7.t5 = this.category;
                                _context7.t6 = this.state;
                                _context7.t7 = $392d930fd8655aa1$var$_objectSpread({}, this.metadata);
                                _context7.t8 = $392d930fd8655aa1$var$_objectSpread({}, this.metrics);
                                _context7.t9 = (0, $dKONQ.default)(this.childExperiences);
                                _context7.t10 = {
                                    success: !!this.state.success,
                                    startTime: this.metrics.startTime,
                                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                                };
                                _context7.t11 = this.config.platform || null;
                                _context7.t12 = this.pageVisibleState;
                                _context7.t13 = this.featureFlags;
                                _context7.t14 = this.isSSROutputAsFMP;
                                _context7.t15 = this.timings;
                                _context7.t16 = this.explicitTimings;
                                _context7.t17 = this.performanceConfig;
                                return _context7.abrupt("return", {
                                    id: _context7.t0,
                                    uuid: _context7.t1,
                                    type: _context7.t2,
                                    schemaVersion: _context7.t3,
                                    performanceType: _context7.t4,
                                    category: _context7.t5,
                                    state: _context7.t6,
                                    metadata: _context7.t7,
                                    metrics: _context7.t8,
                                    children: _context7.t9,
                                    result: _context7.t10,
                                    platform: _context7.t11,
                                    pageVisibleState: _context7.t12,
                                    featureFlags: _context7.t13,
                                    isSSROutputAsFMP: _context7.t14,
                                    timings: _context7.t15,
                                    explicitTimings: _context7.t16,
                                    performanceConfig: _context7.t17
                                });
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function exportData() {
                    return _exportData.apply(this, arguments);
                }
                return exportData;
            }()
        },
        {
            key: "_reset",
            value: function _reset() {
                this.parent = null;
                this.metadata = {};
                this.onDoneCallbacks = [];
                this.childExperiences = [];
                this.metrics = {
                    startTime: null,
                    endTime: null,
                    marks: []
                };
                this._until = this.until ? this.until() : null;
            }
        }
    ]);
}();

});
parcelRegister("dKONQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a036faabeb9f64d6$export$2e2bcd8739ae039; });

var $8YlKF = parcelRequire("8YlKF");

var $bJmCZ = parcelRequire("bJmCZ");

var $3gRpw = parcelRequire("3gRpw");

var $9bmBX = parcelRequire("9bmBX");
function $a036faabeb9f64d6$export$2e2bcd8739ae039(r) {
    return (0, $8YlKF.default)(r) || (0, $bJmCZ.default)(r) || (0, $3gRpw.default)(r) || (0, $9bmBX.default)();
}

});
parcelRegister("8YlKF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6884ccc5e1b68a90$export$2e2bcd8739ae039; });

var $dXiG2 = parcelRequire("dXiG2");
function $6884ccc5e1b68a90$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $dXiG2.default)(r);
}

});
parcelRegister("dXiG2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a28f45ee81f02e02$export$2e2bcd8739ae039; });
function $a28f45ee81f02e02$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("bJmCZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88a5731d6ec7dc63$export$2e2bcd8739ae039; });
function $88a5731d6ec7dc63$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("3gRpw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $261c4bfa85c44b24$export$2e2bcd8739ae039; });

var $dXiG2 = parcelRequire("dXiG2");
function $261c4bfa85c44b24$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $dXiG2.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $dXiG2.default)(r, a) : void 0;
    }
}

});

parcelRegister("9bmBX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6af6ae3edd6e0afa$export$2e2bcd8739ae039; });
function $6af6ae3edd6e0afa$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jcRsg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfb89a51362517b3$export$2e2bcd8739ae039; });
function $dfb89a51362517b3$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $dfb89a51362517b3$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $dfb89a51362517b3$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $dfb89a51362517b3$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("aXc0l", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $7f98b9ecfba36d60$var$runtime = (parcelRequire("kSKtK"))();
module.exports = $7f98b9ecfba36d60$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $7f98b9ecfba36d60$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $7f98b9ecfba36d60$var$runtime;
    else Function("r", "regeneratorRuntime = r")($7f98b9ecfba36d60$var$runtime);
}

});
parcelRegister("kSKtK", function(module, exports) {

var $hckRU = parcelRequire("hckRU");

var $jFsaE = parcelRequire("jFsaE");

var $kQZLy = parcelRequire("kQZLy");

var $7Hpe1 = parcelRequire("7Hpe1");

var $1mex0 = parcelRequire("1mex0");

var $fBhek = parcelRequire("fBhek");

var $e3RHY = parcelRequire("e3RHY");
function $f33ce783bc691b94$var$_regeneratorRuntime() {
    "use strict";
    var r = $jFsaE(), e = r.m($f33ce783bc691b94$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $e3RHY(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $f33ce783bc691b94$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $hckRU(r, e);
            },
            AsyncIterator: $1mex0,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $7Hpe1 : $kQZLy)(a(r), e, t, o, u);
            },
            keys: $fBhek,
            values: $e3RHY
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $f33ce783bc691b94$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hckRU", function(module, exports) {
function $c853beb0bdd3bc85$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $c853beb0bdd3bc85$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jFsaE", function(module, exports) {

var $6xomZ = parcelRequire("6xomZ");
function $e517b2c5d43a8b43$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $6xomZ(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($6xomZ(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $6xomZ(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $6xomZ(u, "constructor", GeneratorFunctionPrototype), $6xomZ(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $6xomZ(GeneratorFunctionPrototype, o, "GeneratorFunction"), $6xomZ(u), $6xomZ(u, o, "Generator"), $6xomZ(u, n, function() {
        return this;
    }), $6xomZ(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $e517b2c5d43a8b43$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $e517b2c5d43a8b43$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6xomZ", function(module, exports) {
function $4c28ba7b88a995b1$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $4c28ba7b88a995b1$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $4c28ba7b88a995b1$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $4c28ba7b88a995b1$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $4c28ba7b88a995b1$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("kQZLy", function(module, exports) {

var $7Hpe1 = parcelRequire("7Hpe1");
function $f2e893701060b3a5$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $7Hpe1(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $f2e893701060b3a5$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7Hpe1", function(module, exports) {

var $jFsaE = parcelRequire("jFsaE");

var $1mex0 = parcelRequire("1mex0");
function $59b01db9f990e6aa$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $1mex0($jFsaE().w(r, e, t, o), n || Promise);
}
module.exports = $59b01db9f990e6aa$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1mex0", function(module, exports) {

var $hckRU = parcelRequire("hckRU");

var $6xomZ = parcelRequire("6xomZ");
function $0fd31e23c815ae84$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $hckRU ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($6xomZ($0fd31e23c815ae84$var$AsyncIterator.prototype), $6xomZ($0fd31e23c815ae84$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $6xomZ(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $0fd31e23c815ae84$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("fBhek", function(module, exports) {
function $b5b7ad3caf4a7ccf$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $b5b7ad3caf4a7ccf$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("e3RHY", function(module, exports) {

var $fRx3M = parcelRequire("fRx3M");
var $a3cb01d101216f5c$var$_typeof = $fRx3M.default;
function $a3cb01d101216f5c$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($a3cb01d101216f5c$var$_typeof(e) + " is not iterable");
}
module.exports = $a3cb01d101216f5c$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fRx3M", function(module, exports) {
function $b8c57343ba59ce1f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $b8c57343ba59ce1f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $b8c57343ba59ce1f$var$_typeof(o);
}
module.exports = $b8c57343ba59ce1f$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("fJncN", function(module, exports) {

var $72oXI = parcelRequire("72oXI");

var $4DYvX = parcelRequire("4DYvX");
var $b73d0f1b4c1c2756$var$uuid = $4DYvX;
$b73d0f1b4c1c2756$var$uuid.v1 = $72oXI;
$b73d0f1b4c1c2756$var$uuid.v4 = $4DYvX;
module.exports = $b73d0f1b4c1c2756$var$uuid;

});
parcelRegister("72oXI", function(module, exports) {

var $gnwno = parcelRequire("gnwno");

var $lKwqb = parcelRequire("lKwqb");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $51fc154a348fe7d0$var$_nodeId;
var $51fc154a348fe7d0$var$_clockseq;
// Previous uuid creation time
var $51fc154a348fe7d0$var$_lastMSecs = 0;
var $51fc154a348fe7d0$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $51fc154a348fe7d0$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $51fc154a348fe7d0$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $51fc154a348fe7d0$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $gnwno();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $51fc154a348fe7d0$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $51fc154a348fe7d0$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $51fc154a348fe7d0$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $51fc154a348fe7d0$var$_lastMSecs + (nsecs - $51fc154a348fe7d0$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $51fc154a348fe7d0$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $51fc154a348fe7d0$var$_lastMSecs = msecs;
    $51fc154a348fe7d0$var$_lastNSecs = nsecs;
    $51fc154a348fe7d0$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $lKwqb(b);
}
module.exports = $51fc154a348fe7d0$var$v1;

});
parcelRegister("gnwno", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $bec7e8910b0dfa3d$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($bec7e8910b0dfa3d$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $bec7e8910b0dfa3d$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $bec7e8910b0dfa3d$var$getRandomValues($bec7e8910b0dfa3d$var$rnds8);
        return $bec7e8910b0dfa3d$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $bec7e8910b0dfa3d$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $bec7e8910b0dfa3d$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $bec7e8910b0dfa3d$var$rnds;
    };
}

});

parcelRegister("lKwqb", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $fd570b1129527645$var$byteToHex = [];
for(var $fd570b1129527645$var$i = 0; $fd570b1129527645$var$i < 256; ++$fd570b1129527645$var$i)$fd570b1129527645$var$byteToHex[$fd570b1129527645$var$i] = ($fd570b1129527645$var$i + 0x100).toString(16).substr(1);
function $fd570b1129527645$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $fd570b1129527645$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $fd570b1129527645$var$bytesToUuid;

});


parcelRegister("4DYvX", function(module, exports) {

var $gnwno = parcelRequire("gnwno");

var $lKwqb = parcelRequire("lKwqb");
function $3619bed40c098434$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $gnwno)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $lKwqb(rnds);
}
module.exports = $3619bed40c098434$var$v4;

});


parcelRegister("k2su8", function(module, exports) {

$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", function () { return $e96a171c816c7297$export$2295b861f318254a; });
// temp solution until we can get it automated
var $e96a171c816c7297$export$2295b861f318254a = "0.1.5";

});

parcelRegister("lQWwC", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", function () { return $fe8bda313e9d62e0$export$6123a44dc2384540; });
$parcel$export(module.exports, "subscribeEvent", function () { return $fe8bda313e9d62e0$export$37863216db4b714d; });
$parcel$export(module.exports, "unsubscribeEvent", function () { return $fe8bda313e9d62e0$export$ee1a7bd1fc9ea85e; });
$parcel$export(module.exports, "experiencePayloadEvent", function () { return $fe8bda313e9d62e0$export$7c957416596ca127; });

var $ihybq = parcelRequire("ihybq");

var $aFIlZ = parcelRequire("aFIlZ");
var $fe8bda313e9d62e0$var$MAX_EARLY_QUEUE_LENGTH = 250;
var $fe8bda313e9d62e0$export$6123a44dc2384540 = function getGlobalEventStream() {
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        var earlyStream = function() {
            var stream = [];
            return {
                __buffer_only__: true,
                push: function push(event) {
                    if (stream.length < $fe8bda313e9d62e0$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: function getStream() {
                    return stream;
                }
            };
        }();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
var $fe8bda313e9d62e0$export$c1522520b417b066 = function setGlobalEventStream(eventStream) {
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $ihybq.ufowarn)("Global Event Stream already initialised. Ignoring new event stream setup");
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
var $fe8bda313e9d62e0$export$37863216db4b714d = function subscribeEvent(experienceId, callback) {
    return {
        type: (0, $aFIlZ.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $fe8bda313e9d62e0$export$ee1a7bd1fc9ea85e = function unsubscribeEvent(experienceId, callback) {
    return {
        type: (0, $aFIlZ.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $fe8bda313e9d62e0$export$7c957416596ca127 = function experiencePayloadEvent(data) {
    return {
        type: (0, $aFIlZ.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("aFIlZ", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", function () { return $7c502373466a5093$export$96253c35c37cf96b; });
$parcel$export(module.exports, "PageVisibleState", function () { return $7c502373466a5093$export$a12c67b37a306b13; });
$parcel$export(module.exports, "SUBSCRIBE_ALL", function () { return $7c502373466a5093$export$79bf131685ad41d7; });
$parcel$export(module.exports, "FMP_MARK", function () { return $7c502373466a5093$export$9f2bf58999404c75; });
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", function () { return $7c502373466a5093$export$837e0f79a8056912; });
var $7c502373466a5093$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $7c502373466a5093$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $7c502373466a5093$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $7c502373466a5093$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $7c502373466a5093$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $7c502373466a5093$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
var $7c502373466a5093$export$79bf131685ad41d7 = "__SUBSCRIBE_ALL__";
var $7c502373466a5093$export$9f2bf58999404c75 = "fmp";
var $7c502373466a5093$export$837e0f79a8056912 = "inline-response";

});


parcelRegister("5TnYJ", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", function () { return $44a4b06d3f4cfd7b$export$13e680397ec8f3eb; });

var $9DI7H = parcelRequire("9DI7H");

var $87mML = parcelRequire("87mML");

var $hNkel = parcelRequire("hNkel");

var $ddwhl = parcelRequire("ddwhl");
var $44a4b06d3f4cfd7b$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, $9DI7H.default)(this, VisibilityChangeObserver);
        (0, $hNkel.default)(this, "started", false);
        (0, $hNkel.default)(this, "observers", []);
        (0, $hNkel.default)(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    return (0, $87mML.default)(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                if (this.started) return;
                this.started = true;
                document.addEventListener("visibilitychange", this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ if ((0, $ddwhl.isWindowObjectAvailable)()) window.addEventListener("pagehide", this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
}();
var $44a4b06d3f4cfd7b$export$13e680397ec8f3eb = new $44a4b06d3f4cfd7b$var$VisibilityChangeObserver();

});
parcelRegister("ddwhl", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", function () { return $99f5872bca5ffcb5$export$15e172712955e18f; });
var $99f5872bca5ffcb5$export$15e172712955e18f = function isWindowObjectAvailable() {
    return typeof window !== "undefined";
};

});


parcelRegister("j8TkB", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", function () { return $def9af534ca9bf87$export$5f490af6b2b115cf; });
var $def9af534ca9bf87$export$5f490af6b2b115cf = function roundPerfNow() {
    return ~~performance.now();
};

});

parcelRegister("fHiSC", function(module, exports) {

$parcel$export(module.exports, "canTransition", function () { return $b6d9844e878bae0c$export$178881f329fdb81f; });

var $hNkel = parcelRequire("hNkel");

var $hiFO1 = parcelRequire("hiFO1");
var $b6d9844e878bae0c$var$UFOStateAvailableTransitions = (0, $hNkel.default)((0, $hNkel.default)((0, $hNkel.default)((0, $hNkel.default)((0, $hNkel.default)((0, $hNkel.default)((0, $hNkel.default)((0, $hNkel.default)((0, $hNkel.default)({}, (0, $hiFO1.UFOExperienceState).NOT_STARTED.id, [
    (0, $hiFO1.UFOExperienceState).STARTED.id
]), (0, $hiFO1.UFOExperienceState).STARTED.id, [
    (0, $hiFO1.UFOExperienceState).IN_PROGRESS.id,
    (0, $hiFO1.UFOExperienceState).BLOCKED.id,
    (0, $hiFO1.UFOExperienceState).SUCCEEDED.id,
    (0, $hiFO1.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $hiFO1.UFOExperienceState).FAILED.id,
    (0, $hiFO1.UFOExperienceState).ABORTED.id
]), (0, $hiFO1.UFOExperienceState).IN_PROGRESS.id, [
    (0, $hiFO1.UFOExperienceState).BLOCKED.id,
    (0, $hiFO1.UFOExperienceState).SUCCEEDED.id,
    (0, $hiFO1.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $hiFO1.UFOExperienceState).FAILED.id,
    (0, $hiFO1.UFOExperienceState).ABORTED.id
]), (0, $hiFO1.UFOExperienceState).BLOCKED.id, [
    (0, $hiFO1.UFOExperienceState).RECOVERED.id,
    (0, $hiFO1.UFOExperienceState).ABORTED.id
]), (0, $hiFO1.UFOExperienceState).RECOVERED.id, [
    (0, $hiFO1.UFOExperienceState).STARTED.id,
    (0, $hiFO1.UFOExperienceState).SUCCEEDED.id,
    (0, $hiFO1.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $hiFO1.UFOExperienceState).FAILED.id,
    (0, $hiFO1.UFOExperienceState).ABORTED.id
]), (0, $hiFO1.UFOExperienceState).SUCCEEDED.id, [
    (0, $hiFO1.UFOExperienceState).STARTED.id
]), (0, $hiFO1.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id, [
    (0, $hiFO1.UFOExperienceState).SUCCEEDED.id,
    (0, $hiFO1.UFOExperienceState).FAILED.id,
    (0, $hiFO1.UFOExperienceState).ABORTED.id
]), (0, $hiFO1.UFOExperienceState).FAILED.id, [
    (0, $hiFO1.UFOExperienceState).STARTED.id
]), (0, $hiFO1.UFOExperienceState).ABORTED.id, [
    (0, $hiFO1.UFOExperienceState).STARTED.id
]);
var $b6d9844e878bae0c$export$178881f329fdb81f = function canTransition(state1, state2) {
    return $b6d9844e878bae0c$var$UFOStateAvailableTransitions[state1.id] && $b6d9844e878bae0c$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("11Cwy", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", function () { return $0bf3c4876bb6c9e1$export$994164cf3ae1cc9a; });
$parcel$export(module.exports, "ExperiencePerformanceTypes", function () { return $0bf3c4876bb6c9e1$export$cc26007c03242fff; });
var $0bf3c4876bb6c9e1$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $0bf3c4876bb6c9e1$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});




parcelRegister("clbzo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b2014ecb862bd114df9c4eca3bb7d0c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8fc06bbeb8110a2e$var$_react = $8fc06bbeb8110a2e$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $8fc06bbeb8110a2e$var$_email = $8fc06bbeb8110a2e$var$_interopRequireDefault((parcelRequire("fAXUo")));

var $8fc06bbeb8110a2e$var$_email2 = $8fc06bbeb8110a2e$var$_interopRequireDefault((parcelRequire("7ED1e")));
function $8fc06bbeb8110a2e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmailIcon.
 * This component is EmailIcon, with `UNSAFE_fallbackIcon` set to "EmailIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8fc06bbeb8110a2e$var$EmailIcon = (props)=>/*#__PURE__*/ $8fc06bbeb8110a2e$var$_react.default.createElement($8fc06bbeb8110a2e$var$_email.default, Object.assign({
        LEGACY_fallbackIcon: $8fc06bbeb8110a2e$var$_email2.default
    }, props));
$8fc06bbeb8110a2e$var$EmailIcon.Name = "EmailIconMigration";
var $8fc06bbeb8110a2e$var$_default = module.exports.default = $8fc06bbeb8110a2e$var$EmailIcon;

});
parcelRegister("7ED1e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $592a89268d5bc470$var$_react = $592a89268d5bc470$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $592a89268d5bc470$var$_email = $592a89268d5bc470$var$_interopRequireDefault((parcelRequire("fAXUo")));
function $592a89268d5bc470$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $592a89268d5bc470$var$EmailIcon = (props)=>/*#__PURE__*/ $592a89268d5bc470$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props, {
        newIcon: $592a89268d5bc470$var$_email.default
    }));
$592a89268d5bc470$var$EmailIcon.displayName = "EmailIcon";
var $592a89268d5bc470$var$_default = module.exports.default = $592a89268d5bc470$var$EmailIcon;

});


parcelRegister("9oJUD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::325d0bc066f2b42d61e7c5ff0e093014>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d79f836368fa383$var$_react = $6d79f836368fa383$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $6d79f836368fa383$var$_person = $6d79f836368fa383$var$_interopRequireDefault((parcelRequire("gTkVc")));

var $6d79f836368fa383$var$_person2 = $6d79f836368fa383$var$_interopRequireDefault((parcelRequire("6qzuG")));
function $6d79f836368fa383$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonIcon.
 * This component is PersonIcon, with `UNSAFE_fallbackIcon` set to "PersonIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6d79f836368fa383$var$PersonIcon = (props)=>/*#__PURE__*/ $6d79f836368fa383$var$_react.default.createElement($6d79f836368fa383$var$_person.default, Object.assign({
        LEGACY_fallbackIcon: $6d79f836368fa383$var$_person2.default
    }, props));
$6d79f836368fa383$var$PersonIcon.Name = "PersonIconMigration";
var $6d79f836368fa383$var$_default = module.exports.default = $6d79f836368fa383$var$PersonIcon;

});
parcelRegister("gTkVc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69f4e6f87c1306b0b7d1107d65930cc1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4c203016fffe508$var$_react = $c4c203016fffe508$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $c4c203016fffe508$var$_baseNew = $c4c203016fffe508$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $c4c203016fffe508$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4c203016fffe508$var$PersonIcon = (props)=>/*#__PURE__*/ $c4c203016fffe508$var$_react.default.createElement($c4c203016fffe508$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$c4c203016fffe508$var$PersonIcon.displayName = "PersonIcon";
var $c4c203016fffe508$var$_default = module.exports.default = $c4c203016fffe508$var$PersonIcon;

});

parcelRegister("6qzuG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4ae0b4288b79ad4c$var$_react = $4ae0b4288b79ad4c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $4ae0b4288b79ad4c$var$_person = $4ae0b4288b79ad4c$var$_interopRequireDefault((parcelRequire("gTkVc")));
function $4ae0b4288b79ad4c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4ae0b4288b79ad4c$var$PersonIcon = (props)=>/*#__PURE__*/ $4ae0b4288b79ad4c$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $4ae0b4288b79ad4c$var$_person.default
    }));
$4ae0b4288b79ad4c$var$PersonIcon.displayName = "PersonIcon";
var $4ae0b4288b79ad4c$var$_default = module.exports.default = $4ae0b4288b79ad4c$var$PersonIcon;

});


parcelRegister("iCK7M", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df09611fb9f343ce3ed015b37269b5a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8ef8dfd4e31cdef$var$_react = $d8ef8dfd4e31cdef$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $d8ef8dfd4e31cdef$var$_release = $d8ef8dfd4e31cdef$var$_interopRequireDefault((parcelRequire("foz0J")));

var $d8ef8dfd4e31cdef$var$_ship = $d8ef8dfd4e31cdef$var$_interopRequireDefault((parcelRequire("4e74O")));
function $d8ef8dfd4e31cdef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ReleaseIcon.
 * This component is ReleaseIcon, with `UNSAFE_fallbackIcon` set to "ShipIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d8ef8dfd4e31cdef$var$ReleaseIcon = (props)=>/*#__PURE__*/ $d8ef8dfd4e31cdef$var$_react.default.createElement($d8ef8dfd4e31cdef$var$_release.default, Object.assign({
        LEGACY_fallbackIcon: $d8ef8dfd4e31cdef$var$_ship.default
    }, props));
$d8ef8dfd4e31cdef$var$ReleaseIcon.Name = "ReleaseIconMigration";
var $d8ef8dfd4e31cdef$var$_default = module.exports.default = $d8ef8dfd4e31cdef$var$ReleaseIcon;

});
parcelRegister("foz0J", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1a26e96d639121c034f7ae4d8530108>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b354414cd2696ad2$var$_react = $b354414cd2696ad2$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b354414cd2696ad2$var$_baseNew = $b354414cd2696ad2$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b354414cd2696ad2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b354414cd2696ad2$var$ReleaseIcon = (props)=>/*#__PURE__*/ $b354414cd2696ad2$var$_react.default.createElement($b354414cd2696ad2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$b354414cd2696ad2$var$ReleaseIcon.displayName = "ReleaseIcon";
var $b354414cd2696ad2$var$_default = module.exports.default = $b354414cd2696ad2$var$ReleaseIcon;

});

parcelRegister("4e74O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $313df580dc198eb2$var$_react = $313df580dc198eb2$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $313df580dc198eb2$var$_release = $313df580dc198eb2$var$_interopRequireDefault((parcelRequire("foz0J")));
function $313df580dc198eb2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $313df580dc198eb2$var$ShipIcon = (props)=>/*#__PURE__*/ $313df580dc198eb2$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
    }, props, {
        newIcon: $313df580dc198eb2$var$_release.default
    }));
$313df580dc198eb2$var$ShipIcon.displayName = "ShipIcon";
var $313df580dc198eb2$var$_default = module.exports.default = $313df580dc198eb2$var$ShipIcon;

});


parcelRegister("4g8xa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d32cfb464fc797f765cf705a7186f08e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $319f46b59ae588b5$var$_react = $319f46b59ae588b5$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $319f46b59ae588b5$var$_baseNew = $319f46b59ae588b5$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $319f46b59ae588b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkBroken".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $319f46b59ae588b5$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $319f46b59ae588b5$var$_react.default.createElement($319f46b59ae588b5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1v3H4.5V1zm2.22 1.22a3.932 3.932 0 1 1 5.56 5.56l-.75.75-1.06-1.06.75-.75a2.432 2.432 0 0 0-3.44-3.44l-.75.75-1.06-1.06zM1 4.5h3V6H1zm1.22 3.72.75-.75 1.06 1.06-.75.75a2.432 2.432 0 0 0 3.44 3.44l.75-.75 1.06 1.06-.75.75a3.932 3.932 0 1 1-5.56-5.56M15 11.5h-3V10h3zM10 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$319f46b59ae588b5$var$LinkBrokenIcon.displayName = "LinkBrokenIcon";
var $319f46b59ae588b5$var$_default = module.exports.default = $319f46b59ae588b5$var$LinkBrokenIcon;

});

parcelRegister("1Td3S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $16050f3c8fea9b34$var$_react = $16050f3c8fea9b34$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $16050f3c8fea9b34$var$_linkBroken = $16050f3c8fea9b34$var$_interopRequireDefault((parcelRequire("4g8xa")));
function $16050f3c8fea9b34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $16050f3c8fea9b34$var$UnlinkIcon = (props)=>/*#__PURE__*/ $16050f3c8fea9b34$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13.72 14.43a.97.97 0 0 0-1.37 0l-2.09 2.06a1.93 1.93 0 0 1-1.37.57c-.59 0-1.13-.26-1.52-.74-.63-.78-.5-1.93.2-2.64l1.32-1.32.69-.69a.97.97 0 0 0 0-1.38.97.97 0 0 0-1.37 0l-2.07 2.07a3.89 3.89 0 0 0 0 5.5l.01.01A3.87 3.87 0 0 0 8.89 19a3.87 3.87 0 0 0 2.75-1.14l2.08-2.08a.95.95 0 0 0 0-1.34m-3.44-4.87a.97.97 0 0 0 1.37 0l2.09-2.06c.37-.37.85-.57 1.37-.57.59 0 1.14.26 1.53.74.63.78.51 1.93-.2 2.64l-1.32 1.32-.69.69a.97.97 0 0 0 0 1.38c.38.38 1 .38 1.38 0l2.07-2.07a3.89 3.89 0 0 0 0-5.5l-.01-.01A3.87 3.87 0 0 0 15.11 5a3.87 3.87 0 0 0-2.75 1.14l-2.08 2.09a.95.95 0 0 0 0 1.35M8.92 4.62l.4.97a1 1 0 1 1-1.85.77l-.4-.97a1 1 0 1 1 1.85-.76M5.38 7.08l.97.4a1 1 0 0 1-.77 1.85l-.97-.4a1 1 0 0 1 .77-1.85m9.94 10.41a1 1 0 0 0-.54 1.31l.4.97a1 1 0 1 0 1.84-.77l-.4-.97a1 1 0 0 0-1.31-.54m2.18-2.17a1 1 0 0 0 .54 1.31l.97.4a1 1 0 0 0 .77-1.85l-.97-.4a1 1 0 0 0-1.31.54"/></svg>`
    }, props, {
        newIcon: $16050f3c8fea9b34$var$_linkBroken.default
    }));
$16050f3c8fea9b34$var$UnlinkIcon.displayName = "UnlinkIcon";
var $16050f3c8fea9b34$var$_default = module.exports.default = $16050f3c8fea9b34$var$UnlinkIcon;

});

parcelRegister("cNZhw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::707984c4bf43fbcb724a560e605082a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $952998e7153cad95$var$_react = $952998e7153cad95$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $952998e7153cad95$var$_arrowLeft = $952998e7153cad95$var$_interopRequireDefault((parcelRequire("kLtJu")));

var $952998e7153cad95$var$_arrowLeft2 = $952998e7153cad95$var$_interopRequireDefault((parcelRequire("7rnlV")));
function $952998e7153cad95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $952998e7153cad95$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $952998e7153cad95$var$_react.default.createElement($952998e7153cad95$var$_arrowLeft.default, Object.assign({
        LEGACY_fallbackIcon: $952998e7153cad95$var$_arrowLeft2.default
    }, props));
$952998e7153cad95$var$ArrowLeftIcon.Name = "ArrowLeftIconMigration";
var $952998e7153cad95$var$_default = module.exports.default = $952998e7153cad95$var$ArrowLeftIcon;

});
parcelRegister("kLtJu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efa63c6a59a6ee993a0458e40fc93a18>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1df42b7e99557b0$var$_react = $f1df42b7e99557b0$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $f1df42b7e99557b0$var$_baseNew = $f1df42b7e99557b0$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $f1df42b7e99557b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1df42b7e99557b0$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $f1df42b7e99557b0$var$_react.default.createElement($f1df42b7e99557b0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$f1df42b7e99557b0$var$ArrowLeftIcon.displayName = "ArrowLeftIcon";
var $f1df42b7e99557b0$var$_default = module.exports.default = $f1df42b7e99557b0$var$ArrowLeftIcon;

});

parcelRegister("7rnlV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56ad2b58c43b0342$var$_react = $56ad2b58c43b0342$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $56ad2b58c43b0342$var$_arrowLeft = $56ad2b58c43b0342$var$_interopRequireDefault((parcelRequire("kLtJu")));
function $56ad2b58c43b0342$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $56ad2b58c43b0342$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $56ad2b58c43b0342$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.207 5.793a1 1 0 0 1 0 1.414L8.414 11H18a1 1 0 1 1 0 2H8.414l3.793 3.793a1 1 0 1 1-1.415 1.414l-5.499-5.5A1 1 0 0 1 5 12.028v-.057a1 1 0 0 1 .293-.678l5.499-5.5a1 1 0 0 1 1.415 0" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $56ad2b58c43b0342$var$_arrowLeft.default
    }));
$56ad2b58c43b0342$var$ArrowLeftIcon.displayName = "ArrowLeftIcon";
var $56ad2b58c43b0342$var$_default = module.exports.default = $56ad2b58c43b0342$var$ArrowLeftIcon;

});


parcelRegister("5pB2m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f0c045d04c11b56$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");


var $h6ibP = parcelRequire("h6ibP");

var $1oqvf = parcelRequire("1oqvf");

var $ku6Ja = parcelRequire("ku6Ja");
var $3f0c045d04c11b56$var$SimpleTagComponent = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var appearance = _ref.appearance, _ref$elemBefore = _ref.elemBefore, elemBefore = _ref$elemBefore === void 0 ? null : _ref$elemBefore, _ref$color = _ref.color, color = _ref$color === void 0 ? "standard" : _ref$color, href = _ref.href, testId = _ref.testId, _ref$text = _ref.text, text = _ref$text === void 0 ? "" : _ref$text, linkComponent = _ref.linkComponent;
    var content = /*#__PURE__*/ $iSvIT.createElement((0, $ku6Ja.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent,
        testId: testId
    });
    return /*#__PURE__*/ $iSvIT.createElement((0, $h6ibP.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ $iSvIT.createElement((0, $1oqvf.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ var $3f0c045d04c11b56$var$SimpleTag = /*#__PURE__*/ (0, $iSvIT.memo)($3f0c045d04c11b56$var$SimpleTagComponent);
var $3f0c045d04c11b56$export$2e2bcd8739ae039 = $3f0c045d04c11b56$var$SimpleTag;

});
parcelRegister("h6ibP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7311b50570f5d83$export$2e2bcd8739ae039; });
/* base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3RqSj = parcelRequire("3RqSj");

var $fnWjc = parcelRequire("fnWjc");

var $3Dbej = parcelRequire("3Dbej");

var $dLBUJ = parcelRequire("dLBUJ");
var $jW5F8 = parcelRequire("jW5F8");

var $iSvIT = parcelRequire("iSvIT");

var $jxLBU = parcelRequire("jxLBU");

var $ikdtm = parcelRequire("ikdtm");
var $c7311b50570f5d83$var$_excluded = [
    "before",
    "contentElement",
    "after",
    "testId",
    "appearance",
    "style",
    "color",
    "href",
    "className"
];
function $c7311b50570f5d83$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c7311b50570f5d83$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c7311b50570f5d83$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fnWjc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c7311b50570f5d83$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c7311b50570f5d83$var$borderColorCssVar = "--ds-bc";
var $c7311b50570f5d83$var$focusRingCssVar = "--ds-cfr";
var $c7311b50570f5d83$var$textLinkCssVar = "--ds-ctl";
var $c7311b50570f5d83$var$textDefaultCssVar = "--ds-ct";
var $c7311b50570f5d83$var$textHoverCssVar = "--ds-cth";
var $c7311b50570f5d83$var$textActiveCssVar = "--ds-ctp";
var $c7311b50570f5d83$var$backgroundDefaultCssVar = "--ds-cb";
var $c7311b50570f5d83$var$backgroundHoverCssVar = "--ds-cbh";
var $c7311b50570f5d83$var$backgroundActiveCssVar = "--ds-cba";
var $c7311b50570f5d83$var$removeButtonDefaultCssVar = "--ds-rb";
var $c7311b50570f5d83$var$removeButtonHoverCssVar = "--ds-rbh";
var $c7311b50570f5d83$var$borderRadiusCssVar = "--ds-br";
// To be removed with platform-component-visual-refresh (BLU-2992)
var $c7311b50570f5d83$var$baseStylesOld = null;
var $c7311b50570f5d83$var$baseStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
var $c7311b50570f5d83$var$interactiveStylesOld = null;
var $c7311b50570f5d83$var$interactiveStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
var $c7311b50570f5d83$var$focusRingStylesOld = null;
var $c7311b50570f5d83$var$focusRingStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
var $c7311b50570f5d83$var$nonStandardLinkStyles = null;
var $c7311b50570f5d83$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function BaseTag(_ref, ref) {
    var _objectSpread2;
    var before = _ref.before, contentElement = _ref.contentElement, after = _ref.after, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, style = _ref.style, _ref$color = _ref.color, color = _ref$color === void 0 ? "standard" : _ref$color, href = _ref.href, className = _ref.className, other = (0, $3Dbej.default)(_ref, $c7311b50570f5d83$var$_excluded);
    var isLink = Boolean(href);
    var isRemovable = Boolean(after);
    var isInteractive = isLink || isRemovable;
    var isStandardLink = isLink && color === "standard";
    // Change link text color if  the tag is standard color
    var textLinkColors = isStandardLink ? (0, $ikdtm.textColors)["standardLink"] : (0, $ikdtm.textColors)[color];
    var backgroundHoverColors = isRemovable && !isLink ? (0, $ikdtm.backgroundColors)[color] : (0, $ikdtm.linkHoverBackgroundColors)[color];
    var backgroundActiveColors = isRemovable && !isLink ? (0, $ikdtm.backgroundColors)[color] : (0, $ikdtm.linkActiveBackgroundColors)[color];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", (0, $3RqSj.default)({}, other, {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $dLBUJ.default)([
            (0, $jxLBU.fg)("platform-component-visual-refresh") ? "_zulp1b66 _2rko1sit _1h6d1v25 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3iv47k _kqswh2mm _4cvr1h6o _bfhksm61 _syaz1fxt _80om73ad" : "_2rko1j8i _1mou1b66 _195g1b66 _1rjcze3t _18zrze3t _1e0c116y _1ul9idpf _4t3iv47k _kqswh2mm _bfhku1jc _syaz10v1 _80om73ad",
            (0, $jxLBU.fg)("platform-component-visual-refresh") ? "_1e3812j9 _7glxv77o" : "_1guj1r31 _pbhaglyw _11ow1o36 _1u6l1gmt",
            isLink && (0, $jxLBU.fg)("platform-component-visual-refresh") && "_irr3166n _1di61dty",
            !(0, $jxLBU.fg)("platform-component-visual-refresh") && isLink && !isStandardLink && "_9h8h1n0b",
            !(0, $jxLBU.fg)("platform-component-visual-refresh") && isInteractive && "_irr3169c _1di62f3m",
            className
        ]),
        "data-testid": testId,
        style: $c7311b50570f5d83$var$_objectSpread($c7311b50570f5d83$var$_objectSpread({}, $c7311b50570f5d83$var$_objectSpread((_objectSpread2 = {}, (0, $fnWjc.default)((0, $fnWjc.default)((0, $fnWjc.default)((0, $fnWjc.default)((0, $fnWjc.default)((0, $fnWjc.default)((0, $fnWjc.default)((0, $fnWjc.default)((0, $fnWjc.default)((0, $fnWjc.default)(_objectSpread2, $c7311b50570f5d83$var$borderColorCssVar, (0, $ikdtm.borderColors)[color]), $c7311b50570f5d83$var$textDefaultCssVar, (0, $ikdtm.textColors)[color]), $c7311b50570f5d83$var$textHoverCssVar, (0, $ikdtm.textHoverColors)[color]), $c7311b50570f5d83$var$textActiveCssVar, (0, $ikdtm.textActiveColors)[color]), $c7311b50570f5d83$var$textLinkCssVar, textLinkColors), $c7311b50570f5d83$var$backgroundDefaultCssVar, (0, $ikdtm.backgroundColors)[color]), $c7311b50570f5d83$var$backgroundHoverCssVar, backgroundHoverColors), $c7311b50570f5d83$var$backgroundActiveCssVar, backgroundActiveColors), $c7311b50570f5d83$var$focusRingCssVar, (0, $ikdtm.focusRingColors)), $c7311b50570f5d83$var$removeButtonDefaultCssVar, (0, $ikdtm.removeButtonColors)[color]), (0, $fnWjc.default)((0, $fnWjc.default)(_objectSpread2, $c7311b50570f5d83$var$removeButtonHoverCssVar, (0, $ikdtm.removeButtonHoverColors)[color]), $c7311b50570f5d83$var$borderRadiusCssVar, appearance === "rounded" ? "10px" : "3px")), style)), {}, {
            "--_u1k3am": (0, $jW5F8.default)("var(".concat($c7311b50570f5d83$var$borderColorCssVar, ")")),
            "--_djp4lp": (0, $jW5F8.default)("var(".concat($c7311b50570f5d83$var$backgroundDefaultCssVar, ")")),
            "--_ah97e": (0, $jW5F8.default)("var(".concat($c7311b50570f5d83$var$borderRadiusCssVar, ")")),
            "--_y52nzb": (0, $jW5F8.default)("var(".concat($c7311b50570f5d83$var$textDefaultCssVar, ")")),
            "--_toyvsf": (0, $jW5F8.default)("2px solid ".concat("var(--ds-border-focused, #388BFF)")),
            "--_1h6rakg": (0, $jW5F8.default)("0 0 0 2px var(".concat($c7311b50570f5d83$var$focusRingCssVar, ")")),
            "--_gnpw3": (0, $jW5F8.default)("var(".concat($c7311b50570f5d83$var$textActiveCssVar, ")")),
            "--_1ooqx0l": (0, $jW5F8.default)("var(".concat($c7311b50570f5d83$var$backgroundHoverCssVar, ")")),
            "--_1wmp8ry": (0, $jW5F8.default)("var(".concat($c7311b50570f5d83$var$backgroundActiveCssVar, ")"))
        })
    }), before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c7311b50570f5d83$export$2e2bcd8739ae039 = $c7311b50570f5d83$var$BaseTag;

});
parcelRegister("3RqSj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cfb2b286dd31c32$export$2e2bcd8739ae039; });
function $2cfb2b286dd31c32$export$2e2bcd8739ae039() {
    return $2cfb2b286dd31c32$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2cfb2b286dd31c32$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("fnWjc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3363bddf17d6dd4$export$2e2bcd8739ae039; });

var $9kNRb = parcelRequire("9kNRb");
function $b3363bddf17d6dd4$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $9kNRb.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("9kNRb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cbca7d3b8c4f85b$export$2e2bcd8739ae039; });

var $kUATI = parcelRequire("kUATI");

var $eeyDt = parcelRequire("eeyDt");
function $6cbca7d3b8c4f85b$export$2e2bcd8739ae039(t) {
    var i = (0, $eeyDt.default)(t, "string");
    return "symbol" == (0, $kUATI.default)(i) ? i : i + "";
}

});
parcelRegister("kUATI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f395a8bc735ab66e$export$2e2bcd8739ae039; });
function $f395a8bc735ab66e$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $f395a8bc735ab66e$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f395a8bc735ab66e$export$2e2bcd8739ae039(o);
}

});

parcelRegister("eeyDt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5cd3d645ccd0762$export$2e2bcd8739ae039; });

var $kUATI = parcelRequire("kUATI");
function $a5cd3d645ccd0762$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $kUATI.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $kUATI.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("3Dbej", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a4db99f11e785c3$export$2e2bcd8739ae039; });

var $a27Fk = parcelRequire("a27Fk");
function $2a4db99f11e785c3$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $a27Fk.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("a27Fk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74e0098333d0ac32$export$2e2bcd8739ae039; });
function $74e0098333d0ac32$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("dLBUJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a05d131723f24ba4$export$2e2bcd8739ae039; });
const $a05d131723f24ba4$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $a05d131723f24ba4$var$ATOMIC_GROUP_LENGTH = 5;
function $a05d131723f24ba4$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $a05d131723f24ba4$var$UNDERSCORE_UNICODE ? $a05d131723f24ba4$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("jW5F8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e837d38899704ef2$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $e837d38899704ef2$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});

parcelRegister("ikdtm", function(module, exports) {

$parcel$export(module.exports, "textColors", function () { return $d5748ba3a6bf6d97$export$daa0ace263cb20d2; });
$parcel$export(module.exports, "borderColors", function () { return $d5748ba3a6bf6d97$export$1c1b571cf296eca7; });
$parcel$export(module.exports, "textHoverColors", function () { return $d5748ba3a6bf6d97$export$7c7104a5f052cab7; });
$parcel$export(module.exports, "textActiveColors", function () { return $d5748ba3a6bf6d97$export$382469baad253eb7; });
$parcel$export(module.exports, "backgroundColors", function () { return $d5748ba3a6bf6d97$export$b9d7c59a579c23c6; });
$parcel$export(module.exports, "linkHoverBackgroundColors", function () { return $d5748ba3a6bf6d97$export$4410079763249c74; });
$parcel$export(module.exports, "linkActiveBackgroundColors", function () { return $d5748ba3a6bf6d97$export$76be99c5e13e3566; });
$parcel$export(module.exports, "focusRingColors", function () { return $d5748ba3a6bf6d97$export$2a31dbe82788f940; });
$parcel$export(module.exports, "removeButtonColors", function () { return $d5748ba3a6bf6d97$export$f64c7641cbc22da7; });
$parcel$export(module.exports, "removeButtonHoverColors", function () { return $d5748ba3a6bf6d97$export$b03fbc2a369c563e; });
// Text colors
var $d5748ba3a6bf6d97$export$daa0ace263cb20d2 = {
    standard: "var(--ds-text, #253858)",
    standardLink: "var(--ds-link, #0052CC)",
    blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
    red: "var(--ds-text-accent-red-bolder, #172B4D)",
    yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
    green: "var(--ds-text-accent-green-bolder, #172B4D)",
    teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
    purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #0747A6)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #006644)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #403294)",
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
var $d5748ba3a6bf6d97$export$1c1b571cf296eca7 = {
    standard: "#B7B9BE",
    blue: "#669DF1",
    red: "#F87168",
    yellow: "#DDB30E",
    green: "#4BCE97",
    teal: "#6CC3E0",
    purple: "#C97CF4",
    lime: "#94C748",
    magenta: "#E774BB",
    orange: "#FCA700",
    grey: "#B7B9BE",
    standardLink: "#B7B9BE",
    blueLight: "#669DF1",
    redLight: "#F87168",
    yellowLight: "#DDB30E",
    greenLight: "#4BCE97",
    tealLight: "#6CC3E0",
    purpleLight: "#C97CF4",
    limeLight: "#94C748",
    magentaLight: "#E774BB",
    orangeLight: "#FCA700",
    greyLight: "#B7B9BE"
};
var $d5748ba3a6bf6d97$export$7c7104a5f052cab7 = {
    standard: "var(--ds-link, #0065FF)",
    blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
    red: "var(--ds-text-accent-red-bolder, #172B4D)",
    yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
    green: "var(--ds-text-accent-green-bolder, #172B4D)",
    teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
    purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #0747A6)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #006644)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #403294)",
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
var $d5748ba3a6bf6d97$export$382469baad253eb7 = {
    standard: "var(--ds-link-pressed, #0065FF)",
    blue: "var(--ds-text-accent-blue, #172B4D)",
    red: "var(--ds-text-accent-red, #172B4D)",
    yellow: "var(--ds-text-accent-yellow, #172B4D)",
    green: "var(--ds-text-accent-green, #172B4D)",
    teal: "var(--ds-text-accent-teal, #172B4D)",
    purple: "var(--ds-text-accent-purple, #172B4D)",
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: "var(--ds-text-accent-gray, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue-bolder, #0747A6)",
    redLight: "var(--ds-text-accent-red-bolder, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow-bolder, #42526E)",
    greenLight: "var(--ds-text-accent-green-bolder, #006644)",
    tealLight: "var(--ds-text-accent-teal-bolder, #42526E)",
    purpleLight: "var(--ds-text-accent-purple-bolder, #403294)",
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: "var(--ds-text-accent-gray-bolder, #42526E)"
};
var $d5748ba3a6bf6d97$export$b9d7c59a579c23c6 = {
    standard: "var(--ds-background-neutral, #F4F5F7)",
    blue: "var(--ds-background-accent-blue-subtle, #4C9AFF)",
    red: "var(--ds-background-accent-red-subtle, #FF8F73)",
    yellow: "var(--ds-background-accent-yellow-subtle, #FFC400)",
    green: "var(--ds-background-accent-green-subtle, #57D9A3)",
    teal: "var(--ds-background-accent-teal-subtle, #00C7E6)",
    purple: "var(--ds-background-accent-purple-subtle, #998DD9)",
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: "var(--ds-background-accent-gray-subtle, #42526E)",
    blueLight: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    redLight: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    yellowLight: "var(--ds-background-accent-yellow-subtler, #FFE380)",
    greenLight: "var(--ds-background-accent-green-subtler, #79F2C0)",
    tealLight: "var(--ds-background-accent-teal-subtler, #79E2F2)",
    purpleLight: "var(--ds-background-accent-purple-subtler, #C0B6F2)",
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: "var(--ds-background-accent-gray-subtler, #EBECF0)"
};
var $d5748ba3a6bf6d97$export$4410079763249c74 = {
    standard: "var(--ds-background-neutral-hovered, #EBECF0)",
    blue: "var(--ds-background-accent-blue-subtle-hovered, #B3D4FF)",
    red: "var(--ds-background-accent-red-subtle-hovered, #FFBDAD)",
    yellow: "var(--ds-background-accent-yellow-subtle-hovered, #FFE380)",
    green: "var(--ds-background-accent-green-subtle-hovered, #79F2C0)",
    teal: "var(--ds-background-accent-teal-subtle-hovered, #79E2F2)",
    purple: "var(--ds-background-accent-purple-subtle-hovered, #C0B6F2)",
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: "var(--ds-background-accent-gray-subtle-hovered, #505F79)",
    blueLight: "var(--ds-background-accent-blue-subtler-hovered, #DEEBFF)",
    redLight: "var(--ds-background-accent-red-subtler-hovered, #FFEBE6)",
    yellowLight: "var(--ds-background-accent-yellow-subtler-hovered, #FFF0B3)",
    greenLight: "var(--ds-background-accent-green-subtler-hovered, #ABF5D1)",
    tealLight: "var(--ds-background-accent-teal-subtler-hovered, #B3F5FF)",
    purpleLight: "var(--ds-background-accent-purple-subtler-hovered, #EAE6FF)",
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: "var(--ds-background-accent-gray-subtler-hovered, #DFE1E6)"
};
var $d5748ba3a6bf6d97$export$76be99c5e13e3566 = {
    standard: "var(--ds-background-neutral-pressed, #EBECF0)",
    blue: "var(--ds-background-accent-blue-subtle-pressed, #DEEBFF)",
    red: "var(--ds-background-accent-red-subtle-pressed, #FFEBE6)",
    yellow: "var(--ds-background-accent-yellow-subtle-pressed, #FFF0B3)",
    green: "var(--ds-background-accent-green-subtle-pressed, #ABF5D1)",
    teal: "var(--ds-background-accent-teal-subtle-pressed, #B3F5FF)",
    purple: "var(--ds-background-accent-purple-subtle-pressed, #EAE6FF)",
    grey: "var(--ds-background-accent-gray-subtle-pressed, #5E6C84)",
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: "var(--ds-background-accent-blue-subtler-pressed, #4C9AFF)",
    redLight: "var(--ds-background-accent-red-subtler-pressed, #FF8F73)",
    yellowLight: "var(--ds-background-accent-yellow-subtler-pressed, #FFC400)",
    greenLight: "var(--ds-background-accent-green-subtler-pressed, #57D9A3)",
    tealLight: "var(--ds-background-accent-teal-subtler-pressed, #00C7E6)",
    purpleLight: "var(--ds-background-accent-purple-subtler-pressed, #998DD9)",
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: "var(--ds-background-accent-gray-subtler-pressed, #C1C7D0)"
};
var $d5748ba3a6bf6d97$export$2a31dbe82788f940 = "var(--ds-border-focused, #4C9AFF)";
var $d5748ba3a6bf6d97$export$1202b7eb21da7b58 = "var(--ds-background-danger, #FFEBE6)";
var $d5748ba3a6bf6d97$export$62ace793ebb16bda = "var(--ds-background-danger-hovered, #FFEBE6)";
var $d5748ba3a6bf6d97$export$17d206ccea111bbb = "var(--ds-text-danger, #BF2600)";
var $d5748ba3a6bf6d97$export$f64c7641cbc22da7 = {
    standard: "var(--ds-text, #42526E)",
    blue: "var(--ds-text-accent-blue-bolder, #42526E)",
    red: "var(--ds-text-accent-red-bolder, #42526E)",
    yellow: "var(--ds-text-accent-yellow-bolder, #42526E)",
    green: "var(--ds-text-accent-green-bolder, #42526E)",
    teal: "var(--ds-text-accent-teal-bolder, #42526E)",
    purple: "var(--ds-text-accent-purple-bolder, #42526E)",
    lime: "var(--ds-text-accent-lime-bolder, #42526E)",
    magenta: "var(--ds-text-accent-magenta-bolder, #42526E)",
    orange: "var(--ds-text-accent-orange-bolder, #42526E)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #42526E)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #42526E)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #42526E)",
    limeLight: "var(--ds-text-accent-lime, #42526E)",
    magentaLight: "var(--ds-text-accent-magenta, #42526E)",
    orangeLight: "var(--ds-text-accent-orange, #42526E)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
var $d5748ba3a6bf6d97$export$b03fbc2a369c563e = {
    standard: "var(--ds-text-danger, #253858)",
    standardLink: "var(--ds-text-danger, #0052CC)",
    blue: "var(--ds-text-danger, #172B4D)",
    red: "var(--ds-text-danger, #172B4D)",
    yellow: "var(--ds-text-danger, #172B4D)",
    green: "var(--ds-text-danger, #172B4D)",
    teal: "var(--ds-text-danger, #172B4D)",
    purple: "var(--ds-text-danger, #172B4D)",
    lime: "var(--ds-text-danger, #172B4D)",
    magenta: "var(--ds-text-danger, #172B4D)",
    orange: "var(--ds-text-danger, #172B4D)",
    grey: "var(--ds-text-danger, #172B4D)",
    blueLight: "var(--ds-text-danger, #0747A6)",
    redLight: "var(--ds-text-danger, #42526E)",
    yellowLight: "var(--ds-text-danger, #42526E)",
    greenLight: "var(--ds-text-danger, #006644)",
    tealLight: "var(--ds-text-danger, #42526E)",
    purpleLight: "var(--ds-text-danger, #403294)",
    limeLight: "var(--ds-text-danger, #403294)",
    magentaLight: "var(--ds-text-danger, #403294)",
    orangeLight: "var(--ds-text-danger, #403294)",
    greyLight: "var(--ds-text-danger, #42526E)"
};

});


parcelRegister("1oqvf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $103c974ceaf72f2f$export$2e2bcd8739ae039; });
/* before.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $dLBUJ = parcelRequire("dLBUJ");

var $jxLBU = parcelRequire("jxLBU");
var $103c974ceaf72f2f$var$beforeElementStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
var $103c974ceaf72f2f$var$beforeElementStylesOld = null;
var $103c974ceaf72f2f$var$Before = function Before(_ref) {
    var elemBefore = _ref.elemBefore;
    return elemBefore ? /*#__PURE__*/ $iSvIT.createElement("span", {
        className: (0, $dLBUJ.default)([
            (0, $jxLBU.fg)("platform-component-visual-refresh") ? "_1e0c1txw _4t3i7vkz _4cvr1h6o _1bah1h6o _152tze3t" : "_2rko1l5z _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _152tze3t"
        ])
    }, elemBefore) : null;
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$103c974ceaf72f2f$export$2e2bcd8739ae039 = $103c974ceaf72f2f$var$Before;

});

parcelRegister("ku6Ja", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee9bd3f469c651a6$export$2e2bcd8739ae039; });
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $dLBUJ = parcelRequire("dLBUJ");

var $jxLBU = parcelRequire("jxLBU");
// To be removed with platform-component-visual-refresh (BLU-2992)
var $ee9bd3f469c651a6$var$baseStylesOld = null;
var $ee9bd3f469c651a6$var$baseStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
var $ee9bd3f469c651a6$var$linkStylesOld = null;
var $ee9bd3f469c651a6$var$linkStyles = null;
var $ee9bd3f469c651a6$var$hasAfterStylesOld = null;
var $ee9bd3f469c651a6$var$hasAfterStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
var $ee9bd3f469c651a6$var$hasBeforeStyles = null;
var $ee9bd3f469c651a6$var$Content = function Content(_ref) {
    var _ref$elemBefore = _ref.elemBefore, elemBefore = _ref$elemBefore === void 0 ? null : _ref$elemBefore, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? "" : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? "standard" : _ref$color, href = _ref.href, linkComponent = _ref.linkComponent, testId = _ref.testId;
    var Link = linkComponent !== null && linkComponent !== void 0 ? linkComponent : "a";
    if (href) return /*#__PURE__*/ $iSvIT.createElement(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? "".concat(testId, "--link") : undefined,
        className: (0, $dLBUJ.default)([
            (0, $jxLBU.fg)("platform-component-visual-refresh") ? "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c82smr _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c",
            (0, $jxLBU.fg)("platform-component-visual-refresh") ? "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1fxt _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31fxt _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8h1fxt" : "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazs5nr _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3117u _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8h1348",
            !(0, $jxLBU.fg)("platform-component-visual-refresh") && elemBefore && "_ahbqv47k",
            isRemovable && (0, $jxLBU.fg)("platform-component-visual-refresh") && "_p12f1lit",
            isRemovable && !(0, $jxLBU.fg)("platform-component-visual-refresh") && "_p12f1lit _y4tipxbi"
        ])
    }, text);
    else return /*#__PURE__*/ $iSvIT.createElement("span", {
        className: (0, $dLBUJ.default)([
            (0, $jxLBU.fg)("platform-component-visual-refresh") ? "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c82smr _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c",
            !(0, $jxLBU.fg)("platform-component-visual-refresh") && elemBefore && "_ahbqv47k",
            isRemovable && (0, $jxLBU.fg)("platform-component-visual-refresh") && "_p12f1lit",
            isRemovable && !(0, $jxLBU.fg)("platform-component-visual-refresh") && "_p12f1lit _y4tipxbi"
        ])
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ee9bd3f469c651a6$export$2e2bcd8739ae039 = $ee9bd3f469c651a6$var$Content;

});


parcelRegister("gLhLj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c33ed04b07fb9f0d$var$_react = $c33ed04b07fb9f0d$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $c33ed04b07fb9f0d$var$_baseNew = $c33ed04b07fb9f0d$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $c33ed04b07fb9f0d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c33ed04b07fb9f0d$var$LinkIcon = (props)=>/*#__PURE__*/ $c33ed04b07fb9f0d$var$_react.default.createElement($c33ed04b07fb9f0d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$c33ed04b07fb9f0d$var$LinkIcon.displayName = "LinkIcon";
var $c33ed04b07fb9f0d$var$_default = module.exports.default = $c33ed04b07fb9f0d$var$LinkIcon;

});

parcelRegister("bEK1x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87c7217e524af1cc$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Popup", function () { return (parcelRequire("kXmYu")).Popup; });

var $kXmYu = parcelRequire("kXmYu");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$87c7217e524af1cc$export$2e2bcd8739ae039 = (0, $kXmYu.Popup);

});
parcelRegister("kXmYu", function(module, exports) {

$parcel$export(module.exports, "Popup", function () { return $f41b23a070aeb17e$export$129a32eedafa97c5; });
/* popup.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $i5GO6 = parcelRequire("i5GO6");

var $iSvIT = parcelRequire("iSvIT");


var $6Y4D0 = parcelRequire("6Y4D0");

var $9bV5B = parcelRequire("9bV5B");

var $1Z36a = parcelRequire("1Z36a");

var $jxLBU = parcelRequire("jxLBU");

var $5X460 = parcelRequire("5X460");
var $b2CZb = parcelRequire("b2CZb");

var $gWVOm = parcelRequire("gWVOm");

var $bMgDq = parcelRequire("bMgDq");

var $bf7VN = parcelRequire("bf7VN");

var $2tpZJ = parcelRequire("2tpZJ");

var $7sPqo = parcelRequire("7sPqo");

var $ewg7R = parcelRequire("ewg7R");
var $f41b23a070aeb17e$var$defaultLayer = 400;
var $f41b23a070aeb17e$var$wrapperStyles = {
    root: "_kqswh2mm"
};
var $f41b23a070aeb17e$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $iSvIT.memo)(function(_ref) {
    var xcss = _ref.xcss, _ref$appearance = _ref.appearance, inAppearance = _ref$appearance === void 0 ? "default" : _ref$appearance, isOpen = _ref.isOpen, providedId = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? "viewport" : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "auto" : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $f41b23a070aeb17e$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, inShouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport;
    var _useState = (0, $iSvIT.useState)(null), _useState2 = (0, $i5GO6.default)(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $7sPqo.useGetMemoizedMergedTriggerRef)();
    var getMergedTriggerRefNew = (0, $ewg7R.useGetMemoizedMergedTriggerRefNew)();
    var generatedId = (0, $6Y4D0.useId)();
    var _usePopupAppearance = (0, $2tpZJ.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    var handleOpenLayerObserverCloseSignal = (0, $iSvIT.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose(null);
    }, [
        onClose
    ]);
    (0, $1Z36a.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal
    });
    var renderPopperWrapper = /*#__PURE__*/ $iSvIT.createElement((0, $9bV5B.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $iSvIT.createElement((0, $bf7VN.default), {
        xcss: xcss,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? "absolute" : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = /*#__PURE__*/ $iSvIT.createElement((0, $5X460.Manager), null, /*#__PURE__*/ $iSvIT.createElement((0, $b2CZb.Reference), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: !(0, $jxLBU.fg)("platform-design-system-popup-ref") ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            "aria-controls": isOpen ? id : undefined,
            "aria-expanded": isOpen,
            "aria-haspopup": role === "dialog" && (0, $jxLBU.fg)("platform_dst_popup-disable-focuslock") ? "dialog" : true
        });
    }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $iSvIT.createElement((0, $gWVOm.default), {
        zIndex: zIndex
    }, renderPopperWrapper)));
    if (shouldFitContainer) return /*#__PURE__*/ $iSvIT.createElement((0, $bMgDq.default), {
        xcss: $f41b23a070aeb17e$var$wrapperStyles.root
    }, popupContent);
    return popupContent;
});

});
parcelRegister("i5GO6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2b9e63a48056fee$export$2e2bcd8739ae039; });

var $jcbCY = parcelRequire("jcbCY");

var $hqu09 = parcelRequire("hqu09");

var $2HE4Z = parcelRequire("2HE4Z");

var $cmYBR = parcelRequire("cmYBR");
function $d2b9e63a48056fee$export$2e2bcd8739ae039(r, e) {
    return (0, $jcbCY.default)(r) || (0, $hqu09.default)(r, e) || (0, $2HE4Z.default)(r, e) || (0, $cmYBR.default)();
}

});
parcelRegister("jcbCY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df982855e562baed$export$2e2bcd8739ae039; });
function $df982855e562baed$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("hqu09", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cafc2309cc969969$export$2e2bcd8739ae039; });
function $cafc2309cc969969$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("2HE4Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f7eafe2ea6e8c2c$export$2e2bcd8739ae039; });

var $b3vle = parcelRequire("b3vle");
function $1f7eafe2ea6e8c2c$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $b3vle.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $b3vle.default)(r, a) : void 0;
    }
}

});
parcelRegister("b3vle", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80c84945aaa54902$export$2e2bcd8739ae039; });
function $80c84945aaa54902$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("cmYBR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90168df194d8ce52$export$2e2bcd8739ae039; });
function $90168df194d8ce52$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("6Y4D0", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $512befb8fe76cbea$export$f680877a34711e37; });

var $dZxBv = parcelRequire("dZxBv");

var $iSvIT = parcelRequire("iSvIT");

var $lzzak = parcelRequire("lzzak");

var $jxLBU = parcelRequire("jxLBU");
var $512befb8fe76cbea$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $512befb8fe76cbea$var$react18UseId = ($512befb8fe76cbea$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useId) !== null && $512befb8fe76cbea$var$_React$useId !== void 0 ? $512befb8fe76cbea$var$_React$useId : undefined;
function $512befb8fe76cbea$export$f680877a34711e37() {
    if ($512befb8fe76cbea$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) return $512befb8fe76cbea$var$react18UseId();
    return "uid".concat((0, $lzzak.useUID)());
}
var $512befb8fe76cbea$export$6be90bcb437e928f = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($512befb8fe76cbea$export$f680877a34711e37()).concat(postfix);
    (0, $iSvIT.useEffect)(function() {
        if (!ref) return;
        switch((0, $dZxBv.default)(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, $dZxBv.default)(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $512befb8fe76cbea$export$6ee17796e3d70de2() {
    if ($512befb8fe76cbea$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) {
        var uid = $512befb8fe76cbea$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $lzzak.useUIDSeed)();
}

});
parcelRegister("dZxBv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2fb09ecaa863e47$export$2e2bcd8739ae039; });
function $a2fb09ecaa863e47$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $a2fb09ecaa863e47$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a2fb09ecaa863e47$export$2e2bcd8739ae039(o);
}

});


parcelRegister("bMgDq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $893114bf1a22146a$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $049YL = parcelRequire("049YL");

var $52y2f = parcelRequire("52y2f");

var $iSvIT = parcelRequire("iSvIT");

var $c4Cgq = parcelRequire("c4Cgq");

var $8f5V2 = parcelRequire("8f5V2");
var $893114bf1a22146a$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $893114bf1a22146a$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $893114bf1a22146a$var$baseStyles = null;
var $893114bf1a22146a$var$backgroundColorMap = {
    "color.background.accent.lime.subtlest": "_bfhkm890",
    "color.background.accent.lime.subtlest.hovered": "_bfhkd4y8",
    "color.background.accent.lime.subtlest.pressed": "_bfhk1fno",
    "color.background.accent.lime.subtler": "_bfhkz2ec",
    "color.background.accent.lime.subtler.hovered": "_bfhk1eds",
    "color.background.accent.lime.subtler.pressed": "_bfhk1hgz",
    "color.background.accent.lime.subtle": "_bfhkbq5w",
    "color.background.accent.lime.subtle.hovered": "_bfhkfoww",
    "color.background.accent.lime.subtle.pressed": "_bfhkhgj8",
    "color.background.accent.lime.bolder": "_bfhktde4",
    "color.background.accent.lime.bolder.hovered": "_bfhknzpa",
    "color.background.accent.lime.bolder.pressed": "_bfhk1b17",
    "color.background.accent.red.subtlest": "_bfhk1vk5",
    "color.background.accent.red.subtlest.hovered": "_bfhk1i6i",
    "color.background.accent.red.subtlest.pressed": "_bfhk1pbw",
    "color.background.accent.red.subtler": "_bfhk1rtt",
    "color.background.accent.red.subtler.hovered": "_bfhkrw5d",
    "color.background.accent.red.subtler.pressed": "_bfhk69rw",
    "color.background.accent.red.subtle": "_bfhkkrt9",
    "color.background.accent.red.subtle.hovered": "_bfhk1sou",
    "color.background.accent.red.subtle.pressed": "_bfhk1tf4",
    "color.background.accent.red.bolder": "_bfhkuibq",
    "color.background.accent.red.bolder.hovered": "_bfhk100f",
    "color.background.accent.red.bolder.pressed": "_bfhkprmn",
    "color.background.accent.orange.subtlest": "_bfhk1g3m",
    "color.background.accent.orange.subtlest.hovered": "_bfhkg4tm",
    "color.background.accent.orange.subtlest.pressed": "_bfhk1ya0",
    "color.background.accent.orange.subtler": "_bfhkf2vu",
    "color.background.accent.orange.subtler.hovered": "_bfhk1lml",
    "color.background.accent.orange.subtler.pressed": "_bfhkuxsx",
    "color.background.accent.orange.subtle": "_bfhk1g6e",
    "color.background.accent.orange.subtle.hovered": "_bfhk1oew",
    "color.background.accent.orange.subtle.pressed": "_bfhk1phk",
    "color.background.accent.orange.bolder": "_bfhkjgng",
    "color.background.accent.orange.bolder.hovered": "_bfhkhi52",
    "color.background.accent.orange.bolder.pressed": "_bfhkf767",
    "color.background.accent.yellow.subtlest": "_bfhk1ozg",
    "color.background.accent.yellow.subtlest.hovered": "_bfhk19g9",
    "color.background.accent.yellow.subtlest.pressed": "_bfhk31d1",
    "color.background.accent.yellow.subtler": "_bfhk3fv2",
    "color.background.accent.yellow.subtler.hovered": "_bfhklg04",
    "color.background.accent.yellow.subtler.pressed": "_bfhk1d44",
    "color.background.accent.yellow.subtle": "_bfhkry5t",
    "color.background.accent.yellow.subtle.hovered": "_bfhk17e6",
    "color.background.accent.yellow.subtle.pressed": "_bfhko0y5",
    "color.background.accent.yellow.bolder": "_bfhk1vop",
    "color.background.accent.yellow.bolder.hovered": "_bfhkkjqf",
    "color.background.accent.yellow.bolder.pressed": "_bfhk32kj",
    "color.background.accent.green.subtlest": "_bfhkn729",
    "color.background.accent.green.subtlest.hovered": "_bfhk3utz",
    "color.background.accent.green.subtlest.pressed": "_bfhkv5yf",
    "color.background.accent.green.subtler": "_bfhk1wnw",
    "color.background.accent.green.subtler.hovered": "_bfhkung8",
    "color.background.accent.green.subtler.pressed": "_bfhk1p19",
    "color.background.accent.green.subtle": "_bfhk1rsu",
    "color.background.accent.green.subtle.hovered": "_bfhk12e3",
    "color.background.accent.green.subtle.pressed": "_bfhk8h4p",
    "color.background.accent.green.bolder": "_bfhk1e5c",
    "color.background.accent.green.bolder.hovered": "_bfhka5yi",
    "color.background.accent.green.bolder.pressed": "_bfhk1azz",
    "color.background.accent.teal.subtlest": "_bfhk7xuz",
    "color.background.accent.teal.subtlest.hovered": "_bfhk108c",
    "color.background.accent.teal.subtlest.pressed": "_bfhk1j2h",
    "color.background.accent.teal.subtler": "_bfhk1a17",
    "color.background.accent.teal.subtler.hovered": "_bfhkg5py",
    "color.background.accent.teal.subtler.pressed": "_bfhkq7li",
    "color.background.accent.teal.subtle": "_bfhktdv8",
    "color.background.accent.teal.subtle.hovered": "_bfhkzh8h",
    "color.background.accent.teal.subtle.pressed": "_bfhk10ai",
    "color.background.accent.teal.bolder": "_bfhk2c8p",
    "color.background.accent.teal.bolder.hovered": "_bfhkl3ve",
    "color.background.accent.teal.bolder.pressed": "_bfhkse6l",
    "color.background.accent.blue.subtlest": "_bfhkavxe",
    "color.background.accent.blue.subtlest.hovered": "_bfhkay3p",
    "color.background.accent.blue.subtlest.pressed": "_bfhk1xmr",
    "color.background.accent.blue.subtler": "_bfhk4v9p",
    "color.background.accent.blue.subtler.hovered": "_bfhk16e6",
    "color.background.accent.blue.subtler.pressed": "_bfhk1uh7",
    "color.background.accent.blue.subtle": "_bfhk1j89",
    "color.background.accent.blue.subtle.hovered": "_bfhk1f4s",
    "color.background.accent.blue.subtle.pressed": "_bfhkqctv",
    "color.background.accent.blue.bolder": "_bfhkc8cv",
    "color.background.accent.blue.bolder.hovered": "_bfhk1cwi",
    "color.background.accent.blue.bolder.pressed": "_bfhkhcrq",
    "color.background.accent.purple.subtlest": "_bfhkp7j4",
    "color.background.accent.purple.subtlest.hovered": "_bfhkm0d5",
    "color.background.accent.purple.subtlest.pressed": "_bfhkgslw",
    "color.background.accent.purple.subtler": "_bfhk1jkz",
    "color.background.accent.purple.subtler.hovered": "_bfhk1wyu",
    "color.background.accent.purple.subtler.pressed": "_bfhk5fkp",
    "color.background.accent.purple.subtle": "_bfhkdh45",
    "color.background.accent.purple.subtle.hovered": "_bfhk1wob",
    "color.background.accent.purple.subtle.pressed": "_bfhkwz05",
    "color.background.accent.purple.bolder": "_bfhkygwo",
    "color.background.accent.purple.bolder.hovered": "_bfhkadgs",
    "color.background.accent.purple.bolder.pressed": "_bfhk1uro",
    "color.background.accent.magenta.subtlest": "_bfhk8tvm",
    "color.background.accent.magenta.subtlest.hovered": "_bfhkr3zd",
    "color.background.accent.magenta.subtlest.pressed": "_bfhk1een",
    "color.background.accent.magenta.subtler": "_bfhkv9ra",
    "color.background.accent.magenta.subtler.hovered": "_bfhk1r0p",
    "color.background.accent.magenta.subtler.pressed": "_bfhkxuzc",
    "color.background.accent.magenta.subtle": "_bfhk1mi6",
    "color.background.accent.magenta.subtle.hovered": "_bfhkrwyz",
    "color.background.accent.magenta.subtle.pressed": "_bfhk1ovh",
    "color.background.accent.magenta.bolder": "_bfhkc3uk",
    "color.background.accent.magenta.bolder.hovered": "_bfhk1ok8",
    "color.background.accent.magenta.bolder.pressed": "_bfhkwaw3",
    "color.background.accent.gray.subtlest": "_bfhk11bn",
    "color.background.accent.gray.subtlest.hovered": "_bfhk12j4",
    "color.background.accent.gray.subtlest.pressed": "_bfhk1lb4",
    "color.background.accent.gray.subtler": "_bfhk1v33",
    "color.background.accent.gray.subtler.hovered": "_bfhk1f7l",
    "color.background.accent.gray.subtler.pressed": "_bfhkd8a2",
    "color.background.accent.gray.subtle": "_bfhk1t05",
    "color.background.accent.gray.subtle.hovered": "_bfhk1a2l",
    "color.background.accent.gray.subtle.pressed": "_bfhk1z0s",
    "color.background.accent.gray.bolder": "_bfhk1t1b",
    "color.background.accent.gray.bolder.hovered": "_bfhke4nv",
    "color.background.accent.gray.bolder.pressed": "_bfhk82ra",
    "color.background.disabled": "_bfhksyzs",
    "color.background.input": "_bfhk1j9a",
    "color.background.input.hovered": "_bfhk1d5g",
    "color.background.input.pressed": "_bfhkr01l",
    "color.background.inverse.subtle": "_bfhk1vck",
    "color.background.inverse.subtle.hovered": "_bfhkmpja",
    "color.background.inverse.subtle.pressed": "_bfhk1gii",
    "color.background.neutral": "_bfhkm7j4",
    "color.background.neutral.hovered": "_bfhk15ej",
    "color.background.neutral.pressed": "_bfhkip91",
    "color.background.neutral.subtle": "_bfhksm61",
    "color.background.neutral.subtle.hovered": "_bfhk166n",
    "color.background.neutral.subtle.pressed": "_bfhk1dty",
    "color.background.neutral.bold": "_bfhkcdhy",
    "color.background.neutral.bold.hovered": "_bfhk1bsc",
    "color.background.neutral.bold.pressed": "_bfhk1b6k",
    "color.background.selected": "_bfhkfg4m",
    "color.background.selected.hovered": "_bfhki1yw",
    "color.background.selected.pressed": "_bfhk19ru",
    "color.background.selected.bold": "_bfhk1fvw",
    "color.background.selected.bold.hovered": "_bfhk18hz",
    "color.background.selected.bold.pressed": "_bfhkgr1v",
    "color.background.brand.subtlest": "_bfhk3wxy",
    "color.background.brand.subtlest.hovered": "_bfhkezq1",
    "color.background.brand.subtlest.pressed": "_bfhk2ggb",
    "color.background.brand.bold": "_bfhkb29m",
    "color.background.brand.bold.hovered": "_bfhku1se",
    "color.background.brand.bold.pressed": "_bfhkqkzo",
    "color.background.brand.boldest": "_bfhk15mt",
    "color.background.brand.boldest.hovered": "_bfhk1uwk",
    "color.background.brand.boldest.pressed": "_bfhk17jr",
    "color.background.danger": "_bfhk1gly",
    "color.background.danger.hovered": "_bfhk1yvi",
    "color.background.danger.pressed": "_bfhk1io2",
    "color.background.danger.bold": "_bfhkybec",
    "color.background.danger.bold.hovered": "_bfhks9hg",
    "color.background.danger.bold.pressed": "_bfhk9pqq",
    "color.background.warning": "_bfhk1tzq",
    "color.background.warning.hovered": "_bfhk1rd4",
    "color.background.warning.pressed": "_bfhk11dh",
    "color.background.warning.bold": "_bfhk190i",
    "color.background.warning.bold.hovered": "_bfhk1i4c",
    "color.background.warning.bold.pressed": "_bfhkrj9s",
    "color.background.success": "_bfhkmv6i",
    "color.background.success.hovered": "_bfhk1jgi",
    "color.background.success.pressed": "_bfhky4f1",
    "color.background.success.bold": "_bfhk8emd",
    "color.background.success.bold.hovered": "_bfhk1q4l",
    "color.background.success.bold.pressed": "_bfhkcrcn",
    "color.background.discovery": "_bfhk1nvp",
    "color.background.discovery.hovered": "_bfhk1xp7",
    "color.background.discovery.pressed": "_bfhkdlkp",
    "color.background.discovery.bold": "_bfhk1lri",
    "color.background.discovery.bold.hovered": "_bfhk1w72",
    "color.background.discovery.bold.pressed": "_bfhkrb53",
    "color.background.information": "_bfhk33gi",
    "color.background.information.hovered": "_bfhk1vps",
    "color.background.information.pressed": "_bfhk1s0z",
    "color.background.information.bold": "_bfhk14wj",
    "color.background.information.bold.hovered": "_bfhk1amz",
    "color.background.information.bold.pressed": "_bfhk5bth",
    "color.blanket": "_bfhk10xm",
    "color.blanket.selected": "_bfhk7wq0",
    "color.blanket.danger": "_bfhkrprw",
    "color.skeleton": "_bfhkn82g",
    "color.skeleton.subtle": "_bfhkh3tw",
    "elevation.surface": "_bfhkvuon",
    "elevation.surface.hovered": "_bfhk108i",
    "elevation.surface.pressed": "_bfhk1ji5",
    "elevation.surface.overlay": "_bfhk1bhr",
    "elevation.surface.overlay.hovered": "_bfhk16qz",
    "elevation.surface.overlay.pressed": "_bfhkvq0a",
    "elevation.surface.raised": "_bfhkhp5a",
    "elevation.surface.raised.hovered": "_bfhk1a0f",
    "elevation.surface.raised.pressed": "_bfhkf7u5",
    "elevation.surface.sunken": "_bfhkqbzx",
    "utility.elevation.surface.current": "_bfhkchd4"
};
var $893114bf1a22146a$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $893114bf1a22146a$var$setSurfaceTokenMap = {
    "elevation.surface": "_1q1lvuon",
    "elevation.surface.hovered": "_1q1l108i",
    "elevation.surface.pressed": "_1q1l1ji5",
    "elevation.surface.overlay": "_1q1l1bhr",
    "elevation.surface.overlay.hovered": "_1q1l16qz",
    "elevation.surface.overlay.pressed": "_1q1lvq0a",
    "elevation.surface.raised": "_1q1lhp5a",
    "elevation.surface.raised.hovered": "_1q1l1a0f",
    "elevation.surface.raised.pressed": "_1q1lf7u5",
    "elevation.surface.sunken": "_1q1lqbzx"
};
var $893114bf1a22146a$var$paddingBlockStartMap = {
    "space.0": "_1q51ze3t",
    "space.025": "_1q51v77o",
    "space.050": "_1q511b66",
    "space.075": "_1q5112x7",
    "space.100": "_1q51u2gc",
    "space.150": "_1q51utpp",
    "space.200": "_1q51pxbi",
    "space.250": "_1q51v47k",
    "space.300": "_1q511ejb",
    "space.400": "_1q51xy5q",
    "space.500": "_1q511jfw",
    "space.600": "_1q51oahv",
    "space.800": "_1q51xncg",
    "space.1000": "_1q511epz"
};
var $893114bf1a22146a$var$paddingBlockEndMap = {
    "space.0": "_85i5ze3t",
    "space.025": "_85i5v77o",
    "space.050": "_85i51b66",
    "space.075": "_85i512x7",
    "space.100": "_85i5u2gc",
    "space.150": "_85i5utpp",
    "space.200": "_85i5pxbi",
    "space.250": "_85i5v47k",
    "space.300": "_85i51ejb",
    "space.400": "_85i5xy5q",
    "space.500": "_85i51jfw",
    "space.600": "_85i5oahv",
    "space.800": "_85i5xncg",
    "space.1000": "_85i51epz"
};
var $893114bf1a22146a$var$paddingInlineStartMap = {
    "space.0": "_bozgze3t",
    "space.025": "_bozgv77o",
    "space.050": "_bozg1b66",
    "space.075": "_bozg12x7",
    "space.100": "_bozgu2gc",
    "space.150": "_bozgutpp",
    "space.200": "_bozgpxbi",
    "space.250": "_bozgv47k",
    "space.300": "_bozg1ejb",
    "space.400": "_bozgxy5q",
    "space.500": "_bozg1jfw",
    "space.600": "_bozgoahv",
    "space.800": "_bozgxncg",
    "space.1000": "_bozg1epz"
};
var $893114bf1a22146a$var$paddingInlineEndMap = {
    "space.0": "_y4tize3t",
    "space.025": "_y4tiv77o",
    "space.050": "_y4ti1b66",
    "space.075": "_y4ti12x7",
    "space.100": "_y4tiu2gc",
    "space.150": "_y4tiutpp",
    "space.200": "_y4tipxbi",
    "space.250": "_y4tiv47k",
    "space.300": "_y4ti1ejb",
    "space.400": "_y4tixy5q",
    "space.500": "_y4ti1jfw",
    "space.600": "_y4tioahv",
    "space.800": "_y4tixncg",
    "space.1000": "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $893114bf1a22146a$var$Box = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $52y2f.default)(_ref, $893114bf1a22146a$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $52y2f.default)(htmlAttributes, $893114bf1a22146a$var$_excluded2);
    var node = /*#__PURE__*/ $iSvIT.createElement(Component, (0, $049YL.default)({
        style: style,
        ref: ref,
        className: (0, $c4Cgq.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $893114bf1a22146a$var$backgroundColorMap[backgroundColor],
            backgroundColor && $893114bf1a22146a$var$isSurfaceToken(backgroundColor) && $893114bf1a22146a$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $893114bf1a22146a$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $893114bf1a22146a$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $893114bf1a22146a$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $893114bf1a22146a$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $iSvIT.createElement((0, $8f5V2.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $893114bf1a22146a$export$2e2bcd8739ae039 = $893114bf1a22146a$var$Box;
function $893114bf1a22146a$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $893114bf1a22146a$var$setSurfaceTokenMap;
}

});
parcelRegister("049YL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00c81d7a0689df7b$export$2e2bcd8739ae039; });
function $00c81d7a0689df7b$export$2e2bcd8739ae039() {
    return $00c81d7a0689df7b$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $00c81d7a0689df7b$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("52y2f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ab78a570ac3e216$export$2e2bcd8739ae039; });

var $5Jlsm = parcelRequire("5Jlsm");
function $3ab78a570ac3e216$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $5Jlsm.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("5Jlsm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42c1cc80212717d6$export$2e2bcd8739ae039; });
function $42c1cc80212717d6$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("c4Cgq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ca38a29b04362fd$export$2e2bcd8739ae039; });
const $8ca38a29b04362fd$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $8ca38a29b04362fd$var$ATOMIC_GROUP_LENGTH = 5;
function $8ca38a29b04362fd$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $8ca38a29b04362fd$var$UNDERSCORE_UNICODE ? $8ca38a29b04362fd$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("8f5V2", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $600450d2706830bb$export$1ca2a26fecb070ae; });

var $iSvIT = parcelRequire("iSvIT");
var $600450d2706830bb$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $iSvIT.createContext)("elevation.surface");
var $600450d2706830bb$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $iSvIT.useContext)($600450d2706830bb$export$1ca2a26fecb070ae);
};
$600450d2706830bb$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("bf7VN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82f73f5fd8d924d2$export$2e2bcd8739ae039; });
/* popper-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8udZL = parcelRequire("8udZL");

var $i5GO6 = parcelRequire("i5GO6");

var $049YL = parcelRequire("049YL");

var $52y2f = parcelRequire("52y2f");

var $iSvIT = parcelRequire("iSvIT");

var $c4Cgq = parcelRequire("c4Cgq");

var $47p9E = parcelRequire("47p9E");

var $jxLBU = parcelRequire("jxLBU");

var $gr749 = parcelRequire("gr749");

var $jkOJr = parcelRequire("jkOJr");

var $3m5dx = parcelRequire("3m5dx");

var $jJF4r = parcelRequire("jJF4r");
var $82f73f5fd8d924d2$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "className",
    "isReferenceHidden"
];
var $82f73f5fd8d924d2$var$LOCAL_CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $82f73f5fd8d924d2$var$fullWidthStyles = null;
var $82f73f5fd8d924d2$var$wrapperStyles = {
    root: "_2rkoglpi _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs1cd0 _syaz1fxt _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36"
};
var $82f73f5fd8d924d2$var$scrollableStyles = null;
var $82f73f5fd8d924d2$var$blanketStyles = null;
var $82f73f5fd8d924d2$var$modalStyles = null;
var $82f73f5fd8d924d2$var$focusRingStyles = {
    root: "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y"
};
var $82f73f5fd8d924d2$var$DefaultPopupComponent = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, className = props.className, isReferenceHidden = props.isReferenceHidden, htmlAttributes = (0, $52y2f.default)(props, $82f73f5fd8d924d2$var$_excluded);
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $049YL.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $c4Cgq.default)([
            $82f73f5fd8d924d2$var$wrapperStyles.root,
            appearance === "UNSAFE_modal-below-sm" && "_dk5d1b66 _c71ldtre _kqsw1n9t _152t1b66",
            !shouldRenderToParent && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ])
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $82f73f5fd8d924d2$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "auto" : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $82f73f5fd8d924d2$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance;
    var _useState = (0, $iSvIT.useState)(null), _useState2 = (0, $i5GO6.default)(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)(null), _useState4 = (0, $i5GO6.default)(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== "dialog";
    (0, $jJF4r.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $3m5dx.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $47p9E.useLayering)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $iSvIT.useMemo)(function() {
        return [
            {
                name: "flip",
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, $8udZL.default)(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ $iSvIT.createElement((0, $gr749.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update, isReferenceHidden = _ref2.isReferenceHidden;
        var popupContainer = /*#__PURE__*/ $iSvIT.createElement(PopupContainer, {
            className: (0, $c4Cgq.default)([
                xcss,
                // @ts-expect-error: `ax` is not typed correctly
                !initialFocusRef && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $jxLBU.fg)("platform-design-system-apply-popup-wrapper-focus") && $82f73f5fd8d924d2$var$focusRingStyles.root
            ]),
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === "function") _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: appearance === "UNSAFE_modal-below-sm" ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer,
            isReferenceHidden: isReferenceHidden
        }, /*#__PURE__*/ $iSvIT.createElement((0, $jkOJr.RepositionOnUpdate), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        return /*#__PURE__*/ $iSvIT.createElement((0, $iSvIT.Fragment), null, popupContainer, appearance === "UNSAFE_modal-below-sm" && /*#__PURE__*/ $iSvIT.createElement("div", {
            className: (0, $c4Cgq.default)([
                "_1r04idpf _kqsw1n9t _bfhk10xm"
            ])
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$82f73f5fd8d924d2$export$2e2bcd8739ae039 = $82f73f5fd8d924d2$var$PopperWrapper;

});
parcelRegister("8udZL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62dbfb3d076a285d$export$2e2bcd8739ae039; });

var $1K8nY = parcelRequire("1K8nY");

var $gufVc = parcelRequire("gufVc");

var $2HE4Z = parcelRequire("2HE4Z");

var $20Wty = parcelRequire("20Wty");
function $62dbfb3d076a285d$export$2e2bcd8739ae039(r) {
    return (0, $1K8nY.default)(r) || (0, $gufVc.default)(r) || (0, $2HE4Z.default)(r) || (0, $20Wty.default)();
}

});
parcelRegister("1K8nY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1450978885dcedf6$export$2e2bcd8739ae039; });

var $b3vle = parcelRequire("b3vle");
function $1450978885dcedf6$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $b3vle.default)(r);
}

});

parcelRegister("gufVc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c00bcc60db2b8c23$export$2e2bcd8739ae039; });
function $c00bcc60db2b8c23$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("20Wty", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1778f0e519c773c5$export$2e2bcd8739ae039; });
function $1778f0e519c773c5$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jkOJr", function(module, exports) {

$parcel$export(module.exports, "RepositionOnUpdate", function () { return $e1373ce4bb4cf8e0$export$51eddd7655ca235a; });

var $iSvIT = parcelRequire("iSvIT");
var $e1373ce4bb4cf8e0$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $iSvIT.useRef)(true);
    (0, $iSvIT.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iSvIT.Fragment), null, children);
};

});

parcelRegister("3m5dx", function(module, exports) {

$parcel$export(module.exports, "useCloseManager", function () { return $271779402b0afad7$export$92dae2778ae88f9d; });
// eslint-disable-next-line no-duplicate-imports

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $bxYNr = parcelRequire("bxYNr");

var $47p9E = parcelRequire("47p9E");

var $jxLBU = parcelRequire("jxLBU");

var $8KKEt = parcelRequire("8KKEt");

var $ckmVv = parcelRequire("ckmVv");
var $271779402b0afad7$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $47p9E.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $ckmVv.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    (0, $iSvIT.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $bxYNr.default;
        var inIframe = window && window.self !== window.top && (0, $jxLBU.fg)("fix-dropdown-close-outside-iframe");
        var closePopup = function closePopup(event) {
            if (onClose) {
                var _currentLevel = null;
                if (event.target instanceof HTMLElement) {
                    var _event$target$closest;
                    _currentLevel = (_event$target$closest = event.target.closest("[data-ds--level]")) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.getAttribute("data-ds--level");
                }
                _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $jxLBU.fg)("platform_dst_popup-disable-focuslock")) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute("tabindex", "0");
                if (popupRef && autoFocus) popupRef.setAttribute("tabindex", "0");
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist && !inIframe) return;
            if (isLayerDisabled()) {
                if (target instanceof HTMLElement) {
                    var _target$closest;
                    var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                    if (layeredElement) {
                        var closeType = layeredElement.getAttribute("[data-ds--close--type]");
                        if (closeType === "single") // if the close type is single, we won't close other disabled layers when clicking outside
                        return;
                        var levelOfClickedLayer = layeredElement.getAttribute("data-ds--level");
                        if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                        return;
                    }
                }
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $8KKEt.isInteractiveElement)(document.activeElement) && (0, $jxLBU.fg)("platform_dst_popup-disable-focuslock")) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onKeyDown = function onKeyDown(event) {
            if ((0, $jxLBU.fg)("platform_dst_popup-disable-focuslock")) {
                var key = event.key, shiftKey = event.shiftKey;
                if (shiftKey && key === "Tab" && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === "Tab") {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest("[aria-modal]")) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === "Escape" || key === "Esc") {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                var _key = event.key;
                if (_key === "Escape" || _key === "Esc" || shouldCloseOnTab && _key === "Tab") closePopup(event);
            }
        };
        var parentUnbind;
        // if the popup is inside iframe, we want to listen to click events outside iframe,
        // to close the popup correctly in the iframe.
        if (inIframe && isOpen) parentUnbind = (0, $2e1kT.bind)(window.parent.window, {
            type: "click",
            listener: onClick,
            options: {
                capture: capture
            }
        });
        var unbind = (0, $bxYNr.default);
        if ((0, $jxLBU.fg)("popup-onclose-fix")) setTimeout(function() {
            unbind = (0, $2e1kT.bindAll)(window, [
                {
                    type: "click",
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: "keydown",
                    listener: onKeyDown
                }
            ]);
        }, 0);
        else unbind = (0, $2e1kT.bindAll)(window, [
            {
                type: "click",
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: "keydown",
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $bxYNr.default);
        unbindBlur = (0, $2e1kT.bind)(window, {
            type: "blur",
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            var _parentUnbind;
            if ((0, $jxLBU.fg)("popup-onclose-fix")) setTimeout(function() {
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            (_parentUnbind = parentUnbind) === null || _parentUnbind === void 0 || _parentUnbind();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("bxYNr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8681efae2c1793a6$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $8681efae2c1793a6$export$2e2bcd8739ae039() {}

});

parcelRegister("8KKEt", function(module, exports) {

$parcel$export(module.exports, "isInteractiveElement", function () { return $65f6ceb05e7caee0$export$3dee5e4542c672d9; });
var $65f6ceb05e7caee0$var$interactiveTags = [
    "button",
    "a",
    "input",
    "select",
    "textarea"
];
var $65f6ceb05e7caee0$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($65f6ceb05e7caee0$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute("tabindex") !== null || element.hasAttribute("contenteditable")) return true;
    return false;
};

});

parcelRegister("ckmVv", function(module, exports) {

$parcel$export(module.exports, "useAnimationFrame", function () { return $8f992302fa1a94dd$export$641fa9c94086b46e; });

var $iSvIT = parcelRequire("iSvIT");
var $8f992302fa1a94dd$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $iSvIT.useRef)([]);
    var requestFrame = (0, $iSvIT.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $iSvIT.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $iSvIT.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("jJF4r", function(module, exports) {

$parcel$export(module.exports, "useFocusManager", function () { return $e5e214103ee7a84c$export$10c5169755ce7bd7; });

var $iSvIT = parcelRequire("iSvIT");

var $17K1G = parcelRequire("17K1G");

var $bxYNr = parcelRequire("bxYNr");

var $47p9E = parcelRequire("47p9E");

var $jxLBU = parcelRequire("jxLBU");

var $ckmVv = parcelRequire("ckmVv");
var $e5e214103ee7a84c$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $ckmVv.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $47p9E.useLayering)(), currentLevel = _useLayering.currentLevel;
    (0, $iSvIT.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $bxYNr.default;
        if (shouldDisableFocusTrap && (0, $jxLBU.fg)("platform_dst_popup-disable-focuslock")) {
            var isDropdown = popupRef.matches("[id^=ds--dropdown--]");
            var popups = document.querySelectorAll('[data-ds--level="'.concat(currentLevel - 1, '"]'));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute("tabindex", "-1");
                    if (popupRef && autoFocus) popupRef.setAttribute("tabindex", "-1");
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $bxYNr.default;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($17K1G)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});


parcelRegister("2tpZJ", function(module, exports) {

$parcel$export(module.exports, "usePopupAppearance", function () { return $1cd274330e545005$export$4065aef1d79a5730; });

var $i5GO6 = parcelRequire("i5GO6");

var $iSvIT = parcelRequire("iSvIT");

var $co3Jy = parcelRequire("co3Jy");
function $1cd274330e545005$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var mq = (0, $co3Jy.UNSAFE_useMediaQuery)("below.sm", function(e) {
        setIsSmallViewport(!!e.matches);
    });
    var _useState = (0, $iSvIT.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, $i5GO6.default)(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = _appearance === "UNSAFE_modal-below-sm" && isSmallViewport ? "UNSAFE_modal-below-sm" : "default";
    var shouldRenderToParent = _shouldRenderToParent && appearance === "default";
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("co3Jy", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", function () { return $904a9f5fbf6533ec$export$49e55ae2c03d6045; });

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $3CUnf = parcelRequire("3CUnf");
var $904a9f5fbf6533ec$var$_window, $904a9f5fbf6533ec$var$_window$matchMedia, $904a9f5fbf6533ec$var$_window2, $904a9f5fbf6533ec$var$_window2$matchMedia, $904a9f5fbf6533ec$var$_window3, $904a9f5fbf6533ec$var$_window3$matchMedia, $904a9f5fbf6533ec$var$_window4, $904a9f5fbf6533ec$var$_window4$matchMedia, $904a9f5fbf6533ec$var$_window5, $904a9f5fbf6533ec$var$_window5$matchMedia, $904a9f5fbf6533ec$var$_window6, $904a9f5fbf6533ec$var$_window6$matchMedia, $904a9f5fbf6533ec$var$_window7, $904a9f5fbf6533ec$var$_window7$matchMedia, $904a9f5fbf6533ec$var$_window8, $904a9f5fbf6533ec$var$_window8$matchMedia, $904a9f5fbf6533ec$var$_window9, $904a9f5fbf6533ec$var$_window9$matchMedia, $904a9f5fbf6533ec$var$_window0, $904a9f5fbf6533ec$var$_window0$matchMedia, $904a9f5fbf6533ec$var$_window1, $904a9f5fbf6533ec$var$_window1$matchMedia;
var $904a9f5fbf6533ec$var$queries = {
    "above.xxs": typeof window === "undefined" ? undefined : ($904a9f5fbf6533ec$var$_window = window) === null || $904a9f5fbf6533ec$var$_window === void 0 || ($904a9f5fbf6533ec$var$_window$matchMedia = $904a9f5fbf6533ec$var$_window.matchMedia) === null || $904a9f5fbf6533ec$var$_window$matchMedia === void 0 ? void 0 : $904a9f5fbf6533ec$var$_window$matchMedia.call($904a9f5fbf6533ec$var$_window, (0, $3CUnf.media).above.xxs.replace("@media ", "").trim()),
    "above.xs": typeof window === "undefined" ? undefined : ($904a9f5fbf6533ec$var$_window2 = window) === null || $904a9f5fbf6533ec$var$_window2 === void 0 || ($904a9f5fbf6533ec$var$_window2$matchMedia = $904a9f5fbf6533ec$var$_window2.matchMedia) === null || $904a9f5fbf6533ec$var$_window2$matchMedia === void 0 ? void 0 : $904a9f5fbf6533ec$var$_window2$matchMedia.call($904a9f5fbf6533ec$var$_window2, (0, $3CUnf.media).above.xs.replace("@media ", "").trim()),
    "above.sm": typeof window === "undefined" ? undefined : ($904a9f5fbf6533ec$var$_window3 = window) === null || $904a9f5fbf6533ec$var$_window3 === void 0 || ($904a9f5fbf6533ec$var$_window3$matchMedia = $904a9f5fbf6533ec$var$_window3.matchMedia) === null || $904a9f5fbf6533ec$var$_window3$matchMedia === void 0 ? void 0 : $904a9f5fbf6533ec$var$_window3$matchMedia.call($904a9f5fbf6533ec$var$_window3, (0, $3CUnf.media).above.sm.replace("@media ", "").trim()),
    "above.md": typeof window === "undefined" ? undefined : ($904a9f5fbf6533ec$var$_window4 = window) === null || $904a9f5fbf6533ec$var$_window4 === void 0 || ($904a9f5fbf6533ec$var$_window4$matchMedia = $904a9f5fbf6533ec$var$_window4.matchMedia) === null || $904a9f5fbf6533ec$var$_window4$matchMedia === void 0 ? void 0 : $904a9f5fbf6533ec$var$_window4$matchMedia.call($904a9f5fbf6533ec$var$_window4, (0, $3CUnf.media).above.md.replace("@media ", "").trim()),
    "above.lg": typeof window === "undefined" ? undefined : ($904a9f5fbf6533ec$var$_window5 = window) === null || $904a9f5fbf6533ec$var$_window5 === void 0 || ($904a9f5fbf6533ec$var$_window5$matchMedia = $904a9f5fbf6533ec$var$_window5.matchMedia) === null || $904a9f5fbf6533ec$var$_window5$matchMedia === void 0 ? void 0 : $904a9f5fbf6533ec$var$_window5$matchMedia.call($904a9f5fbf6533ec$var$_window5, (0, $3CUnf.media).above.lg.replace("@media ", "").trim()),
    "above.xl": typeof window === "undefined" ? undefined : ($904a9f5fbf6533ec$var$_window6 = window) === null || $904a9f5fbf6533ec$var$_window6 === void 0 || ($904a9f5fbf6533ec$var$_window6$matchMedia = $904a9f5fbf6533ec$var$_window6.matchMedia) === null || $904a9f5fbf6533ec$var$_window6$matchMedia === void 0 ? void 0 : $904a9f5fbf6533ec$var$_window6$matchMedia.call($904a9f5fbf6533ec$var$_window6, (0, $3CUnf.media).above.xl.replace("@media ", "").trim()),
    "below.xs": typeof window === "undefined" ? undefined : ($904a9f5fbf6533ec$var$_window7 = window) === null || $904a9f5fbf6533ec$var$_window7 === void 0 || ($904a9f5fbf6533ec$var$_window7$matchMedia = $904a9f5fbf6533ec$var$_window7.matchMedia) === null || $904a9f5fbf6533ec$var$_window7$matchMedia === void 0 ? void 0 : $904a9f5fbf6533ec$var$_window7$matchMedia.call($904a9f5fbf6533ec$var$_window7, (0, $3CUnf.media).below.xs.replace("@media ", "").trim()),
    "below.sm": typeof window === "undefined" ? undefined : ($904a9f5fbf6533ec$var$_window8 = window) === null || $904a9f5fbf6533ec$var$_window8 === void 0 || ($904a9f5fbf6533ec$var$_window8$matchMedia = $904a9f5fbf6533ec$var$_window8.matchMedia) === null || $904a9f5fbf6533ec$var$_window8$matchMedia === void 0 ? void 0 : $904a9f5fbf6533ec$var$_window8$matchMedia.call($904a9f5fbf6533ec$var$_window8, (0, $3CUnf.media).below.sm.replace("@media ", "").trim()),
    "below.md": typeof window === "undefined" ? undefined : ($904a9f5fbf6533ec$var$_window9 = window) === null || $904a9f5fbf6533ec$var$_window9 === void 0 || ($904a9f5fbf6533ec$var$_window9$matchMedia = $904a9f5fbf6533ec$var$_window9.matchMedia) === null || $904a9f5fbf6533ec$var$_window9$matchMedia === void 0 ? void 0 : $904a9f5fbf6533ec$var$_window9$matchMedia.call($904a9f5fbf6533ec$var$_window9, (0, $3CUnf.media).below.md.replace("@media ", "").trim()),
    "below.lg": typeof window === "undefined" ? undefined : ($904a9f5fbf6533ec$var$_window0 = window) === null || $904a9f5fbf6533ec$var$_window0 === void 0 || ($904a9f5fbf6533ec$var$_window0$matchMedia = $904a9f5fbf6533ec$var$_window0.matchMedia) === null || $904a9f5fbf6533ec$var$_window0$matchMedia === void 0 ? void 0 : $904a9f5fbf6533ec$var$_window0$matchMedia.call($904a9f5fbf6533ec$var$_window0, (0, $3CUnf.media).below.lg.replace("@media ", "").trim()),
    "below.xl": typeof window === "undefined" ? undefined : ($904a9f5fbf6533ec$var$_window1 = window) === null || $904a9f5fbf6533ec$var$_window1 === void 0 || ($904a9f5fbf6533ec$var$_window1$matchMedia = $904a9f5fbf6533ec$var$_window1.matchMedia) === null || $904a9f5fbf6533ec$var$_window1$matchMedia === void 0 ? void 0 : $904a9f5fbf6533ec$var$_window1$matchMedia.call($904a9f5fbf6533ec$var$_window1, (0, $3CUnf.media).below.xl.replace("@media ", "").trim())
};
var $904a9f5fbf6533ec$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $iSvIT.useRef)(listener);
    (0, $iSvIT.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $904a9f5fbf6533ec$var$queries[queryString];
    (0, $iSvIT.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $2e1kT.bind)(mq, {
            type: "change",
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("3CUnf", function(module, exports) {

$parcel$export(module.exports, "media", function () { return $2a40a6615bf8868c$export$987d49ffe1b0900f; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $2a40a6615bf8868c$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 110.49rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110.5rem)"
    }
};

});



parcelRegister("7sPqo", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", function () { return $56f309c7a0c9242b$export$7cc5c058dd769dff; });

var $i5GO6 = parcelRequire("i5GO6");

var $iSvIT = parcelRequire("iSvIT");

var $fV0Sg = parcelRequire("fV0Sg");
var $56f309c7a0c9242b$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $iSvIT.useState)(function() {
        return (0, $fV0Sg.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === "function") ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, $i5GO6.default)(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("ewg7R", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", function () { return $a920901e35c79f3f$export$5d3a2de79e07b376; });

var $i5GO6 = parcelRequire("i5GO6");

var $iSvIT = parcelRequire("iSvIT");

var $fV0Sg = parcelRequire("fV0Sg");
var $a920901e35c79f3f$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $iSvIT.useState)(function() {
        return (0, $fV0Sg.default)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === "function") ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, $i5GO6.default)(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};

});



parcelRegister("2lcYG", function(module, exports) {

$parcel$export(module.exports, "BuyNowButtonExperiment", function () { return $b0f4bb9f957a36f1$export$dba4199f449a53bc; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");
parcelRequire("f0Hih");
var $dhmEV = parcelRequire("dhmEV");

var $1UUq1 = parcelRequire("1UUq1");

var $5wOn9 = parcelRequire("5wOn9");

var $1QwzH = parcelRequire("1QwzH");
const $b0f4bb9f957a36f1$export$dba4199f449a53bc = (props)=>{
    const intl = (0, $f6qj2.default)();
    const userInfo = (0, $5wOn9.useLoggedInUser)();
    const { defaultUnitCount: defaultUnitCount, unitCount: unitCount, pricingPlanId: pricingPlanId, dataProductKey: dataProductKey, planName: planName, edition: edition } = props;
    const bacDeepUrl = (0, $1QwzH.useBacDeepUrl)(userInfo.isUserLoggedIn, defaultUnitCount, unitCount, pricingPlanId);
    const buyButtonText = intl.formatMessage({
        id: "Pricing.PriceCard.BuyNow",
        defaultMessage: "Buy now"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dhmEV.default), {
            intentType: "buy",
            containerId: "priceBlockBuyNow",
            productKey: dataProductKey,
            edition: edition,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                text: buyButtonText,
                className: "link-class",
                type: "anchor",
                anchorProps: {
                    target: "_self"
                },
                dataEventProps: {
                    "data-product-key": dataProductKey,
                    "data-event-component": "linkButton",
                    "data-event-container": "priceBlockBuyNow",
                    "data-event": "clicked",
                    "data-label": `${planName}-buy-now`,
                    "data-label-english": `${planName}-buy-now`
                },
                href: bacDeepUrl
            })
        })
    });
};

});
parcelRegister("1QwzH", function(module, exports) {

$parcel$export(module.exports, "useBacDeepUrl", function () { return $5ed43c02283f262a$export$c3b1e3c51f68d9a1; });

var $9xGVG = parcelRequire("9xGVG");
function $5ed43c02283f262a$export$c3b1e3c51f68d9a1(isLoggedIn, defaultUnitCount, unitCount, pricingPlanId) {
    return isLoggedIn ? $5ed43c02283f262a$var$getBacDeepUrl(defaultUnitCount, unitCount, pricingPlanId) : $5ed43c02283f262a$var$getBacDeepUrlForSignup(defaultUnitCount, unitCount, pricingPlanId);
}
const $5ed43c02283f262a$var$getBacDeepUrl = (defaultUnitCount, unitCount, pricingPlanId)=>{
    if (typeof window === "undefined") return "https://www.atlassian.com";
    const baseUrl = (0, $9xGVG.Environment).isProduction() ? "https://www.atlassian.com" : "https://wac.stg.internal.atlassian.com";
    const usersQueryParam = defaultUnitCount === unitCount ? "" : `&users=${unitCount}`;
    const queryParams = `place-order?pricingPlanId=${pricingPlanId}${usersQueryParam}`;
    return `${baseUrl}/purchase/cloudcart/${queryParams}`;
};
const $5ed43c02283f262a$var$getBacDeepUrlForSignup = (defaultUnitCount, unitCount, pricingPlanId)=>{
    if (typeof window === "undefined") return "https://id.atlassian.com";
    const continueBacUrl = $5ed43c02283f262a$var$getBacDeepUrl(defaultUnitCount, unitCount, pricingPlanId);
    const baseUrl = (0, $9xGVG.Environment).isProduction() ? "https://id.atlassian.com" : "https://id.stg.internal.atlassian.com";
    return `${baseUrl}/login?continue=${encodeURIComponent(continueBacUrl)}`;
};

});


parcelRegister("lrAJa", function(module, exports) {

$parcel$export(module.exports, "useDirectBuyExperiment", function () { return $834b03d0a4908f6e$export$fffd63fb7d65b164; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $iSvIT = parcelRequire("iSvIT");

var $4LHd8 = parcelRequire("4LHd8");

var $9iWJ8 = parcelRequire("9iWJ8");
const $834b03d0a4908f6e$var$VALID_SKU = [
    "confluence-standard",
    "confluence-premium"
];
const $834b03d0a4908f6e$var$VALID_SKU_EMPTY = [
    "confluence-free",
    "confluence-enterprise-sku"
];
function $834b03d0a4908f6e$export$fffd63fb7d65b164(billingCycle, offeringSku, shouldShowDirectBuy) {
    const isGateEnabled = (0, $4LHd8.default).checkGate("pricing_direct_buy_checkout_fg");
    const experiment = (0, $9iWJ8.useExperiment)((0, $6iHNw._)((0, $7Knp0._)({}, (0, $9iWJ8.experiments).pricingDirectBuyCheckout), {
        options: {
            fireExperimentExposure: false,
            typeGuard: (0, $9iWJ8.experiments).pricingDirectBuyCheckout.options.typeGuard
        }
    }));
    const cohort = experiment.type === "enrolled" ? experiment.value : null;
    const isMonthly = billingCycle == "MONTHLY";
    const isVariation = cohort === "variation";
    const isValidEditionBtn = (0, $iSvIT.useMemo)(()=>offeringSku ? $834b03d0a4908f6e$var$VALID_SKU.includes(offeringSku) : false, [
        offeringSku
    ]);
    const isValidEditionEmpty = (0, $iSvIT.useMemo)(()=>offeringSku ? $834b03d0a4908f6e$var$VALID_SKU_EMPTY.includes(offeringSku) : false, [
        offeringSku
    ]);
    if (!offeringSku || !isMonthly || !isVariation || !isGateEnabled || !shouldShowDirectBuy) return {
        renderDirectBuyBtn: false,
        renderDirectBuyMatchSpace: false
    };
    return {
        renderDirectBuyBtn: isValidEditionBtn,
        renderDirectBuyMatchSpace: isValidEditionEmpty
    };
}

});

parcelRegister("c3Aax", function(module, exports) {

$parcel$export(module.exports, "getFreePriceCalc", function () { return $3c547c4b97809cab$export$cb6f0dbb8c9b28d2; });
$parcel$export(module.exports, "usePriceFinderRequests", function () { return $3c547c4b97809cab$export$e1ef037d62746bfa; });
$parcel$export(module.exports, "usePricing", function () { return $3c547c4b97809cab$export$2bd1dff4b72a4894; });

var $iSvIT = parcelRequire("iSvIT");

var $7mfju = parcelRequire("7mfju");

var $ax2GG = parcelRequire("ax2GG");

var $jl6Sn = parcelRequire("jl6Sn");

var $455M7 = parcelRequire("455M7");
const $3c547c4b97809cab$export$cb6f0dbb8c9b28d2 = (currencyISOCode)=>{
    const zeroPrice = (0, $ax2GG.getFormattedPrice)(currencyISOCode, 0);
    return {
        totalPrice: 0,
        avgPerUnitPrice: 0,
        avgPerUnitPriceWithDiscount: 0,
        formattedTotalPrice: zeroPrice,
        formattedAvgPerUnitPrice: zeroPrice,
        formattedAvgPerUnitPriceWithDiscount: zeroPrice,
        formattedTotalPriceWithDiscount: zeroPrice,
        hasFlatRateFirstTier: true,
        breakdown: [
            {
                unitsInTier: 0,
                unitsAvailableInTier: 0,
                unitLimitLower: 0,
                unitLimitUpper: 0,
                totalPriceForTier: 0,
                avgPerUnitPriceForTier: 0
            }
        ],
        formattedBreakdown: [
            {
                formattedUnitsInTier: "0",
                formattedUnitsAvailableInTier: "0",
                formattedUnitLimitLower: "0",
                formattedUnitLimitUpper: "0",
                formattedTotalPriceForTier: zeroPrice,
                formattedAvgPerUnitPriceForTier: zeroPrice
            }
        ]
    };
};
const $3c547c4b97809cab$export$e1ef037d62746bfa = (productKey, productPlans, unitMinEnterprise, unitCount, billingCycle)=>{
    return (0, $iSvIT.useMemo)(()=>{
        const getNumUnits = (planName, signupUnitLimit)=>{
            let adjNumUnits = 0;
            // following scenarios do not have pricing and should send a zero unit count,
            // the zero pricing will not be displayed and is needed only to retain the
            // correct array order of the pricing requests/responses
            // Free plan has no pricing
            const isFree = planName === (0, $7mfju.SpecialPlanNames).FREE;
            // Enterprise plans do not have monthly pricing
            const isMonthlyEnterprise = planName === (0, $7mfju.SpecialPlanNames).ENTERPRISE && billingCycle === "MONTHLY";
            // Enterprise plans have a minimum unit count
            const isUnmetUnitCountEnterprise = planName === (0, $7mfju.SpecialPlanNames).ENTERPRISE && unitCount < unitMinEnterprise;
            const isOverSignupUnitLimit = unitCount > signupUnitLimit;
            if (![
                isFree,
                isMonthlyEnterprise,
                isUnmetUnitCountEnterprise,
                isOverSignupUnitLimit
            ].includes(true)) adjNumUnits = unitCount;
            // keep unit count to general maximum limit
            return Math.min(adjNumUnits, signupUnitLimit);
        };
        const planPriceReqs = productPlans.map(({ offeringSku: offeringSku, planName: planName, signupLimit: signupLimit })=>({
                ccpOfferingSKU: offeringSku,
                hamsProductKey: productKey + (planName === (0, $7mfju.SpecialPlanNames).STANDARD ? "" : `.${planName.toLowerCase()}`),
                numUnits: getNumUnits(planName, signupLimit || (0, $7mfju.DefaultPlanLimits).UNIT_LIMIT),
                period: billingCycle
            }));
        return planPriceReqs;
    }, [
        productPlans,
        productKey,
        billingCycle,
        unitCount,
        unitMinEnterprise
    ]);
};
const $3c547c4b97809cab$export$2bd1dff4b72a4894 = (ccpPricingData, hamsPricingData, getPriceRequests, currencyISOCode, localeISOCode)=>{
    const priceCalculations = [];
    for (const { ccpOfferingSKU: ccpOfferingSKU, hamsProductKey: hamsProductKey, numUnits: numUnits, period: period } of getPriceRequests)if (numUnits === 0) priceCalculations.push($3c547c4b97809cab$export$cb6f0dbb8c9b28d2(currencyISOCode));
    else {
        const pricingTiers = (0, $jl6Sn.extractPricingTiersFromEntry)(ccpPricingData, hamsPricingData, period, currencyISOCode, ccpOfferingSKU, hamsProductKey);
        if (!pricingTiers) {
            console.log(`Pricing tiers not found for ${period}.`);
            priceCalculations.push($3c547c4b97809cab$export$cb6f0dbb8c9b28d2(currencyISOCode));
        } else priceCalculations.push((0, $455M7.calculatePrice)(numUnits, pricingTiers, currencyISOCode, period, localeISOCode));
    }
    return priceCalculations;
};

});
parcelRegister("ax2GG", function(module, exports) {

$parcel$export(module.exports, "getFormattedPrice", function () { return $1e994aaafa291feb$export$1b80ff309ec5fcb1; });
$parcel$export(module.exports, "getTwoDigitFormattedPrice", function () { return $1e994aaafa291feb$export$716b461c5fe22c57; });
$parcel$export(module.exports, "getFormattedUnitAmount", function () { return $1e994aaafa291feb$export$4f6f7f43804883a5; });
const $1e994aaafa291feb$export$93b318a4d10f1db1 = (value)=>{
    if (value !== null && value !== undefined && !Number.isNaN(value)) return Number.isInteger(+value) ? 0 : 2;
    else return 0;
};
const $1e994aaafa291feb$var$fmtCurrencyValue = (currencyISOCode, value, useTwoDigits)=>{
    const isJPY = currencyISOCode === "JPY";
    const adjVal = isJPY ? Math.ceil(value || 0) : value;
    return new Intl.NumberFormat(isJPY ? "ja-JP" : "en-US", {
        style: "currency",
        currency: currencyISOCode,
        // Note: JPY does not use decimals
        minimumFractionDigits: useTwoDigits && !isJPY ? 2 : $1e994aaafa291feb$export$93b318a4d10f1db1(adjVal),
        maximumFractionDigits: useTwoDigits && !isJPY ? 2 : $1e994aaafa291feb$export$93b318a4d10f1db1(adjVal)
    }).format(adjVal || 0);
};
const $1e994aaafa291feb$export$1b80ff309ec5fcb1 = (currencyISOCode, value)=>$1e994aaafa291feb$var$fmtCurrencyValue(currencyISOCode, value, false);
const $1e994aaafa291feb$export$716b461c5fe22c57 = (currencyISOCode, value)=>$1e994aaafa291feb$var$fmtCurrencyValue(currencyISOCode, value, true);
const $1e994aaafa291feb$export$4f6f7f43804883a5 = (localeISOCode, value)=>new Intl.NumberFormat(localeISOCode).format(value || 0);

});

parcelRegister("jl6Sn", function(module, exports) {

$parcel$export(module.exports, "extractPricingTiersFromEntry", function () { return $bd6c0a670fd8430c$export$99b3bd15b49bca3d; });

var $3jEwL = parcelRequire("3jEwL");
const $bd6c0a670fd8430c$export$99b3bd15b49bca3d = (ccpOfferingsBySKU, hamsPricingPlansByKey, period, currencyISOCode, ccpOfferingSKU, hamsProductKey, getCcpTiers)=>{
    let pricingPlans;
    let pricingTiers;
    if (ccpOfferingSKU) {
        const offering = ccpOfferingsBySKU[ccpOfferingSKU];
        pricingPlans = offering === null || offering === void 0 ? void 0 : offering.defaultPricingPlans;
        if (!pricingPlans) {
            console.log(`Offering empty of pricing plan data for: ${ccpOfferingSKU}`);
            return undefined;
        }
        const convertedTiers = (0, $3jEwL.convertCCPPricingPlansToHAMS)(pricingPlans, currencyISOCode, getCcpTiers);
        if (period === "MONTHLY" && convertedTiers.monthly) pricingTiers = convertedTiers.monthly.slice();
        else if (period === "ANNUAL" && convertedTiers.annual) pricingTiers = convertedTiers.annual.slice();
        else {
            console.log(`Found neither monthly or annual pricing tiers for CCP Offering SKU: ${ccpOfferingSKU}`);
            return undefined;
        }
    } else {
        if (hamsProductKey === undefined) {
            console.log(`HAMS product key was undefined for price request!`);
            return undefined;
        }
        pricingPlans = hamsPricingPlansByKey[hamsProductKey];
        if (pricingPlans === undefined) {
            console.log(`No ${period} pricing plans found for HAMS product key: ${hamsProductKey}`);
            return undefined;
        }
        if (period === "MONTHLY" && pricingPlans.monthly) pricingTiers = pricingPlans.monthly.slice();
        else if (period === "ANNUAL" && pricingPlans.annual) pricingTiers = pricingPlans.annual.slice();
        else {
            console.log(`Found neither monthly or annual (period is ${period}) pricing tiers for HAMS product key: ${hamsProductKey}`);
            return undefined;
        }
    }
    return pricingTiers;
};

});
parcelRegister("3jEwL", function(module, exports) {

$parcel$export(module.exports, "convertCCPPricingPlansToHAMS", function () { return $4cd0225de8db8885$export$1fb00d50ed2ce89c; });

var $7mfju = parcelRequire("7mfju");
// CCP Amounts are stored in cents - Note: JPY needs no conversion
const $4cd0225de8db8885$var$formatCentsToDollars = (value, currency)=>{
    if (currency === "USD" && value) return value / 100;
    return value;
};
const $4cd0225de8db8885$var$convertCCPTiersToHAMS = (ccpTiers, chargeElement, currency)=>ccpTiers.map((ccpTier)=>{
        let pricingStrategy = (0, $7mfju.PricingStrategy).MARGINAL_PER_UNIT;
        let unitPrice = ccpTier.unitAmount;
        if (ccpTier.flatAmount) {
            pricingStrategy = (0, $7mfju.PricingStrategy).FIXED_COST;
            unitPrice = ccpTier.flatAmount;
        }
        return {
            starter: false,
            pricingStrategy: pricingStrategy,
            unitDescription: chargeElement,
            unitLimitLower: ccpTier.floor,
            unitLimitUpper: ccpTier.ceiling,
            prices: [
                {
                    currency: currency,
                    unitPrice: $4cd0225de8db8885$var$formatCentsToDollars(unitPrice, currency)
                }
            ]
        };
    });
const $4cd0225de8db8885$export$1fb00d50ed2ce89c = (pricingPlans, currencyISOCode, getCcpTiers)=>{
    const [monthlyCCP, annualCCP] = [
        "MONTH",
        "YEAR"
    ].map((primaryCycle)=>// Per CCP Team: We need to filter by COMMERCIAL, DEFAULT_PRICING
        pricingPlans.find((pricingPlan)=>pricingPlan.primaryCycle_interval === primaryCycle && pricingPlan.type === "COMMERCIAL" && pricingPlan.activatedWithReason === "DEFAULT_PRICING" && // We filter by currencyISOCode as we need both USD & JPY Pricing for Pricing Pages
            // If needed, can filter by USD only which we will pass in directly in those components
            pricingPlan.currency === currencyISOCode));
    const [monthly, annual] = [
        monthlyCCP,
        annualCCP
    ].map((ccpContent)=>{
        if (!ccpContent) return undefined;
        const ccpTiers = getCcpTiers ? getCcpTiers(ccpContent) : ccpContent.items[0];
        const { tiers: tiers, chargeElement: chargeElement } = ccpTiers;
        return $4cd0225de8db8885$var$convertCCPTiersToHAMS(tiers, chargeElement, ccpContent.currency);
    });
    return {
        monthly: monthly,
        annual: annual
    };
};

});


parcelRegister("455M7", function(module, exports) {

$parcel$export(module.exports, "calculatePrice", function () { return $c1c1f31d7fdb0d3b$export$8f857d3e1dbdf9cf; });

var $7mfju = parcelRequire("7mfju");

var $ax2GG = parcelRequire("ax2GG");

var $ikTVg = parcelRequire("ikTVg");

var $l9UIK = parcelRequire("l9UIK");
const $c1c1f31d7fdb0d3b$var$getTierIdxForNumUnits = (numUnits, tiers)=>tiers.findIndex(({ unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper })=>numUnits >= (unitLimitLower || 0) && numUnits <= (unitLimitUpper || Math.pow(10, 1000)));
function $c1c1f31d7fdb0d3b$export$8f857d3e1dbdf9cf(numUnits, tiers, currencyISOCode, period, localeISOCode = "en-US") {
    if (!Number.isInteger(numUnits) || numUnits < 1) throw new Error(`Number of units must be a positive non-zero integer, got ${numUnits}.`);
    if (!tiers || tiers.length === 0) throw new Error(`Price tiers must not be null, undefined or an empty array, got ${tiers}.`);
    tiers.sort((a, b)=>{
        var _a_unitLimitLower, _b_unitLimitLower;
        return ((_a_unitLimitLower = a.unitLimitLower) !== null && _a_unitLimitLower !== void 0 ? _a_unitLimitLower : 0) - ((_b_unitLimitLower = b.unitLimitLower) !== null && _b_unitLimitLower !== void 0 ? _b_unitLimitLower : 0);
    });
    let matchingTierIdx = $c1c1f31d7fdb0d3b$var$getTierIdxForNumUnits(numUnits, tiers);
    const matchingTier = tiers[matchingTierIdx];
    const finalTier = tiers[tiers.length - 1];
    let adjustedNumberOfUnits = numUnits;
    let calcFunc;
    if (matchingTier !== undefined) {
        const tierPricingStrategy = matchingTier.pricingStrategy;
        calcFunc = period === "MONTHLY" || tierPricingStrategy === (0, $7mfju.PricingStrategy).MARGINAL_PER_UNIT ? (0, $l9UIK.default) : (0, $ikTVg.default);
    } else if (finalTier && finalTier.pricingStrategy === (0, $7mfju.PricingStrategy).MARGINAL_PER_UNIT) calcFunc = (0, $l9UIK.default);
    else {
        /*
     * When a user input is greater than the max tier limit
     * we will reset the number of users to max tier limit
     * of that product and perform price calculations.
     * */ adjustedNumberOfUnits = (finalTier === null || finalTier === void 0 ? void 0 : finalTier.unitLimitUpper) || 0;
        matchingTierIdx = $c1c1f31d7fdb0d3b$var$getTierIdxForNumUnits(adjustedNumberOfUnits, tiers);
        calcFunc = (0, $ikTVg.default);
    }
    const fmtUnit = (amount)=>(0, $ax2GG.getFormattedUnitAmount)(localeISOCode, amount);
    const fmtPrice = (price)=>(0, $ax2GG.getFormattedPrice)(currencyISOCode, price);
    const { totalPrice: totalPrice, avgPerUnitPrice: avgPerUnitPrice, hasFlatRateFirstTier: hasFlatRateFirstTier, breakdown: breakdown } = calcFunc(adjustedNumberOfUnits, matchingTierIdx, tiers, currencyISOCode);
    const avgPerUnitPriceWithDiscount = (0, $ikTVg.calculateDiscountedPrice)(0.75, avgPerUnitPrice);
    const totalPriceWithDiscount = (0, $ikTVg.calculateDiscountedPrice)(0.75, totalPrice);
    return {
        totalPrice: totalPrice,
        avgPerUnitPriceWithDiscount: avgPerUnitPriceWithDiscount,
        formattedTotalPrice: fmtPrice(totalPrice),
        formattedAvgPerUnitPriceWithDiscount: fmtPrice(avgPerUnitPriceWithDiscount),
        formattedTotalPriceWithDiscount: fmtPrice(totalPriceWithDiscount),
        avgPerUnitPrice: avgPerUnitPrice,
        formattedAvgPerUnitPrice: fmtPrice(avgPerUnitPrice),
        breakdown: breakdown,
        hasFlatRateFirstTier: hasFlatRateFirstTier,
        formattedBreakdown: breakdown.map(({ unitsInTier: unitsInTier, unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, unitsAvailableInTier: unitsAvailableInTier, totalPriceForTier: totalPriceForTier, avgPerUnitPriceForTier: avgPerUnitPriceForTier })=>({
                formattedUnitsInTier: fmtUnit(unitsInTier),
                formattedUnitsAvailableInTier: fmtUnit(unitsAvailableInTier),
                formattedUnitLimitLower: fmtUnit(unitLimitLower),
                formattedUnitLimitUpper: fmtUnit(unitLimitUpper),
                formattedTotalPriceForTier: (0, $ax2GG.getTwoDigitFormattedPrice)(currencyISOCode, totalPriceForTier),
                formattedAvgPerUnitPriceForTier: (0, $ax2GG.getTwoDigitFormattedPrice)(currencyISOCode, avgPerUnitPriceForTier)
            }))
    };
}

});
parcelRegister("ikTVg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0049fa8b0eecc5b3$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "calculateDiscountedPrice", function () { return $0049fa8b0eecc5b3$export$3a875854e1248ca4; });

var $86mMv = parcelRequire("86mMv");
function $0049fa8b0eecc5b3$export$2e2bcd8739ae039(numUnits, matchingTierIdx, tiers, currencyISOCode) {
    const matchingTier = tiers[matchingTierIdx];
    if (!matchingTier) throw new Error(`Matching price tier not found for ${numUnits}.`);
    const { prices: prices, unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper } = matchingTier;
    const totalPrice = (0, $86mMv.getLocalUnitPrice)(currencyISOCode, prices.slice());
    const avgPerUnitPrice = totalPrice / numUnits;
    return {
        totalPrice: totalPrice,
        avgPerUnitPrice: avgPerUnitPrice,
        hasFlatRateFirstTier: true,
        breakdown: [
            {
                unitsInTier: numUnits,
                unitsAvailableInTier: (unitLimitUpper || 0) - numUnits,
                unitLimitLower: unitLimitLower || 1,
                unitLimitUpper: unitLimitUpper || 0,
                totalPriceForTier: totalPrice,
                avgPerUnitPriceForTier: totalPrice / numUnits
            }
        ]
    };
}
const $0049fa8b0eecc5b3$export$3a875854e1248ca4 = (discountRate, price)=>price * (1 - discountRate);

});
parcelRegister("86mMv", function(module, exports) {

$parcel$export(module.exports, "getLocalUnitPrice", function () { return $bebbea878e2c5a98$export$e4a3f0ac75d6f09; });
const $bebbea878e2c5a98$export$e4a3f0ac75d6f09 = (currencyISOCode, prices)=>{
    var _prices_find;
    return ((_prices_find = prices.find(({ currency: currency })=>currency === currencyISOCode)) === null || _prices_find === void 0 ? void 0 : _prices_find.unitPrice) || 0;
};

});


parcelRegister("l9UIK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06a29f0b36f17f8e$export$2e2bcd8739ae039; });

var $7mfju = parcelRequire("7mfju");

var $86mMv = parcelRequire("86mMv");
function $06a29f0b36f17f8e$export$2e2bcd8739ae039(numUnits, matchingTierIdx, tiers, currencyISOCode) {
    var _tiers_;
    let totalPrice = 0;
    let price = 0;
    const breakdown = [];
    const getUnitPrice = (prices)=>(0, $86mMv.getLocalUnitPrice)(currencyISOCode, prices);
    // if no matching tier then default to highest (last) tier
    if (matchingTierIdx === -1) matchingTierIdx = tiers.length - 1;
    let idx = 0;
    for (const tier of tiers){
        const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper } = tier;
        const adjUnitLimitLower = Math.max((unitLimitLower || 0) - 1, 0);
        // the upper unit limit can't be undefined so we can just set it to
        // one million units as an upper bound
        const adjUnitLimitUpper = unitLimitUpper || 1000000;
        const unitsInTier = idx === matchingTierIdx ? numUnits - adjUnitLimitLower : adjUnitLimitUpper - adjUnitLimitLower;
        if (tier.pricingStrategy === (0, $7mfju.PricingStrategy).FIXED_COST) price = getUnitPrice(tier.prices.slice());
        else {
            const finalTier = tiers[Math.min(idx, tiers.length - 1)];
            price = getUnitPrice(finalTier.prices.slice());
        }
        const totalPriceForTier = tier.pricingStrategy === (0, $7mfju.PricingStrategy).FIXED_COST ? price : unitsInTier * price;
        totalPrice += totalPriceForTier;
        breakdown.push({
            unitsInTier: unitsInTier,
            unitsAvailableInTier: adjUnitLimitUpper - unitsInTier,
            unitLimitLower: adjUnitLimitLower || 1,
            unitLimitUpper: adjUnitLimitUpper,
            totalPriceForTier: totalPriceForTier,
            avgPerUnitPriceForTier: price
        });
        if (++idx > matchingTierIdx) break;
    }
    const avgPerUnitPrice = totalPrice / numUnits;
    return {
        totalPrice: totalPrice,
        avgPerUnitPrice: avgPerUnitPrice,
        hasFlatRateFirstTier: ((_tiers_ = tiers[0]) === null || _tiers_ === void 0 ? void 0 : _tiers_.pricingStrategy) === (0, $7mfju.PricingStrategy).FIXED_COST,
        breakdown: breakdown
    };
}

});



parcelRegister("11puL", function(module, exports) {

$parcel$export(module.exports, "useDirectBuyCohort", function () { return $5810276580854fee$export$d49d57ae381ab55f; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $4LHd8 = parcelRequire("4LHd8");

var $9iWJ8 = parcelRequire("9iWJ8");
const $5810276580854fee$var$VALID_PRODUCT_KEYS = [
    "jiraSoftware",
    "jiraServiceDesk",
    "confluence"
];
function $5810276580854fee$export$d49d57ae381ab55f(productKey) {
    const isGateEnabled = (0, $4LHd8.default).checkGate("pricing_direct_buy_checkout_fg");
    const validProductKey = $5810276580854fee$var$VALID_PRODUCT_KEYS.includes(productKey);
    const experiment = (0, $9iWJ8.useExperiment)((0, $6iHNw._)((0, $7Knp0._)({}, (0, $9iWJ8.experiments).pricingDirectBuyCheckout), {
        options: {
            fireExperimentExposure: false,
            typeGuard: (0, $9iWJ8.experiments).pricingDirectBuyCheckout.options.typeGuard
        }
    }));
    if (!isGateEnabled || !validProductKey) return {
        isVariation: false
    };
    const cohort = experiment.type === "enrolled" ? experiment.value : null;
    const isVariation = cohort === "variation";
    return {
        isVariation: isVariation
    };
}

});

parcelRegister("gcm2L", function(module, exports) {

var $5e9Y0 = parcelRequire("5e9Y0");

var $7jN5Q = parcelRequire("7jN5Q");
/** Error message constants. */ var $bcaeddb66f900366$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $bcaeddb66f900366$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($bcaeddb66f900366$var$FUNC_ERROR_TEXT);
    if ($7jN5Q(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $5e9Y0(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
module.exports = $bcaeddb66f900366$var$throttle;

});

parcelRegister("hsvIJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb5da8340dc46696$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $ecRo7 = parcelRequire("ecRo7");

var $jYs0i = parcelRequire("jYs0i");
var $cb5da8340dc46696$var$headerStyles = (0, $2ZUkg.css)({
    display: "flex",
    position: "relative",
    alignItems: "center",
    justifyContent: "space-between",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginBlockEnd: -(0, $jYs0i.keylineHeight),
    paddingBlockEnd: "var(--ds-space-200, 16px)",
    paddingBlockStart: "var(--ds-space-300, 24px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $cb5da8340dc46696$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $ecRo7.useModal)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    return (0, $2ZUkg.jsx)("div", {
        css: $cb5da8340dc46696$var$headerStyles,
        "data-testid": testId
    }, children);
};
var $cb5da8340dc46696$export$2e2bcd8739ae039 = $cb5da8340dc46696$var$ModalHeader;

});

parcelRegister("7fb7E", function(module, exports) {

$parcel$export(module.exports, "tabbedHeroSectionPagesMessages", function () { return $ba40a511116bcc38$export$4256e39427240bad; });
$parcel$export(module.exports, "tabbedHeroSectionWhiteboardsMessages", function () { return $ba40a511116bcc38$export$86b5cdc1c559b81d; });
$parcel$export(module.exports, "tabbedHeroSectionDatabasesMessages", function () { return $ba40a511116bcc38$export$505de7052a30846e; });
$parcel$export(module.exports, "tabbedHeroSectionSpacesMessages", function () { return $ba40a511116bcc38$export$954db68b244e5987; });

var $6x1qA = parcelRequire("6x1qA");
const $ba40a511116bcc38$export$4256e39427240bad = (0, $6x1qA.defineMessages)({
    tabName: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.tabName",
        defaultMessage: "Pages"
    },
    contentTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.title.v2",
        defaultMessage: "Get everyone on the same page"
    },
    contentDescription: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.description.v2",
        defaultMessage: "Take notes, plan projects, and refine ideas with flexible Confluence live docs and pages. Or let AI do it for you."
    },
    contentIconTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.iconsHeader",
        defaultMessage: "Create content with ease:"
    },
    contentFeaturePoint1: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.icon1",
        defaultMessage: "Countless templates to get started fast"
    },
    contentFeaturePoint2: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.icon2",
        defaultMessage: "Realtime collaboration with live docs, or draft and publish with pages"
    },
    contentFeaturePoint3: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.icon3",
        defaultMessage: "AI editor to fill in the blanks"
    },
    contentCta: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.cta",
        defaultMessage: "Try it out"
    }
});
const $ba40a511116bcc38$export$86b5cdc1c559b81d = (0, $6x1qA.defineMessages)({
    tabName: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.tabName",
        defaultMessage: "Whiteboards"
    },
    contentTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.title",
        defaultMessage: "Next-gen brainstorming"
    },
    contentDescription: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.description",
        defaultMessage: "Capture free-flowing thoughts and collaborate on ideas with Confluence Whiteboards."
    },
    contentIconTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.iconsHeader",
        defaultMessage: "Ideate on an infinite canvas with:"
    },
    contentFeaturePoint1: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.icon1",
        defaultMessage: "Brainstorming templates"
    },
    contentFeaturePoint2: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.icon2",
        defaultMessage: "Diagrams and flow charts"
    },
    contentFeaturePoint3: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.icon3",
        defaultMessage: "Team retrospectives"
    },
    contentCta: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.cta",
        defaultMessage: "Explore Whiteboards"
    }
});
const $ba40a511116bcc38$export$505de7052a30846e = (0, $6x1qA.defineMessages)({
    tabName: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.tabName",
        defaultMessage: "Databases"
    },
    tabLozenge: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.tabLozenge",
        defaultMessage: "beta"
    },
    contentTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.title",
        defaultMessage: "A new way to stay in sync"
    },
    contentDescription: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.description",
        defaultMessage: "Add structure, sync in real-time, and visualize your team\u2019s work with Confluence Databases."
    },
    contentIconTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.iconsHeader",
        defaultMessage: "Connect and relate information with:"
    },
    contentFeaturePoint1: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.icon1",
        defaultMessage: "Dynamic fields"
    },
    contentFeaturePoint2: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.icon2",
        defaultMessage: "Configurable views"
    },
    contentFeaturePoint3: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.icon3",
        defaultMessage: "Aggregated data sources"
    },
    contentCta: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.cta",
        defaultMessage: "Explore Databases"
    }
});
const $ba40a511116bcc38$export$954db68b244e5987 = (0, $6x1qA.defineMessages)({
    tabName: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.tabName",
        defaultMessage: "Spaces"
    },
    contentTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.title",
        defaultMessage: "Find what you need"
    },
    contentDescription: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.description",
        defaultMessage: "Organize knowledge across teams, projects, and goals with Spaces in Confluence."
    },
    contentIconTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.iconsHeader",
        defaultMessage: "Discover relevant information with:"
    },
    contentFeaturePoint1: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.icon1",
        defaultMessage: "Structured page tree"
    },
    contentFeaturePoint2: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.icon2",
        defaultMessage: "Centralized access to knowledge"
    },
    contentFeaturePoint3: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.icon3",
        defaultMessage: "Customizable permissions"
    },
    contentCta: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.cta",
        defaultMessage: "Explore knowledge sharing"
    }
});

});

parcelRegister("iThfY", function(module, exports) {

$parcel$export(module.exports, "CustomerDetailsStats", function () { return $b645e199078d01fe$export$60ec57d65c4d2d2b; });
/* customer-details-stats.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $5ohHq = parcelRequire("5ohHq");
const $b645e199078d01fe$var$containerStyle = null;
const $b645e199078d01fe$var$horizontalContainerWithThreeStatsStyle = null;
const $b645e199078d01fe$var$statsContainerStyle = null;
const $b645e199078d01fe$var$statStyle = null;
const $b645e199078d01fe$var$statTextStyle = null;
const $b645e199078d01fe$var$horizontalStatStyle = null;
const $b645e199078d01fe$var$horizontalStatTextStyle = null;
const $b645e199078d01fe$var$layoutStyle = null;
const $b645e199078d01fe$var$oneStatDesktopStyle = null; // Stat number color to be changed in the future to be dynamic based on the page-level accent color
const $b645e199078d01fe$var$isEmptyStats = (currentObject)=>JSON.stringify(currentObject) === "{}";
const $b645e199078d01fe$export$60ec57d65c4d2d2b = ({ title: title, stats: stats })=>{
    if (!stats || (stats === null || stats === void 0 ? void 0 : stats.every($b645e199078d01fe$var$isEmptyStats))) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _1bsb1osq _1wpz1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_2rkovwyg _1wpz1h6o _11q71rga _18zrxy5q _1e0c1txw _2lx21bp4 _zulp1ejb _1rjcxy5q _1bhl1ejb _2osnpxbi",
                (stats === null || stats === void 0 ? void 0 : stats.length) === 1 && "_glte12it _xtn71wug",
                (stats === null || stats === void 0 ? void 0 : stats.length) === 3 && "_glteqciz _u5ggze3t _xtn7ukr8"
            ]),
            style: {
                "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
                "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: "eyebrow-md",
                    children: title
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx2vrvc _zulpxy5q _2osn1ejb _1gde1bp4 _8164pxbi"
                    ]),
                    children: stats === null || stats === void 0 ? void 0 : stats.map((stat, idx)=>{
                        return /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _1wpz1fhb _16jlkb7n _i0dlidpf _2lx21bp4",
                                    (stats === null || stats === void 0 ? void 0 : stats.length) < 3 && "_1inivrvc _pdlmxy5q"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        className: (0, $esG4f.default)([
                                            "_1wpz1fhb _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                            (stats === null || stats === void 0 ? void 0 : stats.length) < 3 && "_cdjm1h6o",
                                            "stat-sm"
                                        ]),
                                        children: stat === null || stat === void 0 ? void 0 : stat.stat
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        className: (0, $esG4f.default)([
                                            "_1wpz1fhb _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                            (stats === null || stats === void 0 ? void 0 : stats.length) < 3 && "_cdjm1h6o",
                                            "body-md"
                                        ]),
                                        children: stat === null || stat === void 0 ? void 0 : stat.statDescription
                                    })
                                ]
                            })
                        }, idx);
                    })
                })
            ]
        })
    });
};

});

parcelRegister("lD5of", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbf16bd5d1f8ff37$export$2e2bcd8739ae039; });

var $4J9Jx = parcelRequire("4J9Jx");

var $bZBYx = parcelRequire("bZBYx");

var $jTVYe = parcelRequire("jTVYe");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $a1y4y = parcelRequire("a1y4y");

var $7OFSq = parcelRequire("7OFSq");

var $eqG3R = parcelRequire("eqG3R");

var $3XSTJ = parcelRequire("3XSTJ");

var $7xyUM = parcelRequire("7xyUM");
function $fbf16bd5d1f8ff37$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fbf16bd5d1f8ff37$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fbf16bd5d1f8ff37$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $4J9Jx.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fbf16bd5d1f8ff37$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fbf16bd5d1f8ff37$var$baseStyles = (0, $2ZUkg.css)({
    display: "flex",
    maxWidth: "100%",
    minHeight: "0%",
    flexBasis: "100%",
    flexDirection: "column",
    flexGrow: 1
});
var $fbf16bd5d1f8ff37$var$analyticsAttributes = {
    componentName: "tabs",
    packageName: "@atlaskit/tabs",
    packageVersion: "13.4.9"
};
var $fbf16bd5d1f8ff37$var$getTabPanelWithContext = function getTabPanelWithContext(_ref) {
    var tabPanel = _ref.tabPanel, index = _ref.index, isSelected = _ref.isSelected, tabsId = _ref.tabsId;
    return(// Ensure tabPanel exists in case it has been removed
    tabPanel && (0, $2ZUkg.jsx)((0, $eqG3R.TabPanelContext).Provider, {
        value: {
            role: "tabpanel",
            id: "".concat(tabsId, "-").concat(index, "-tab"),
            hidden: isSelected ? undefined : true,
            "aria-labelledby": "".concat(tabsId, "-").concat(index),
            onMouseDown: (0, $7xyUM.onMouseDownBlur),
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel));
};
/**
 * __Tabs__
 *
 * Tabs acts as a container for all Tab components.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $fbf16bd5d1f8ff37$var$Tabs = function Tabs(props) {
    var _props$shouldUnmountT = props.shouldUnmountTabPanelOnChange, shouldUnmountTabPanelOnChange = _props$shouldUnmountT === void 0 ? false : _props$shouldUnmountT, SelectedType = props.selected, defaultSelected = props.defaultSelected, onChangeProp = props.onChange, id = props.id, analyticsContext = props.analyticsContext, children = props.children, testId = props.testId;
    var _useGlobalTheme = (0, $7OFSq.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var _useState = (0, $iSvIT.useState)(SelectedType || defaultSelected || 0), _useState2 = (0, $jTVYe.default)(_useState, 2), selectedState = _useState2[0], setSelected = _useState2[1];
    var selected = SelectedType === undefined ? selectedState : SelectedType;
    var childrenArray = (0, $iSvIT.Children).toArray(children)// Don't include any conditional children
    .filter(function(child) {
        return Boolean(child);
    });
    // First child should be a tabList followed by tab panels
    var _childrenArray = (0, $bZBYx.default)(childrenArray), tabList = _childrenArray[0], tabPanels = _childrenArray.slice(1);
    // Keep track of visited and add to a set
    var visited = (0, $iSvIT.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    var onChange = (0, $iSvIT.useCallback)(function(index, analyticsEvent) {
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    var onChangeAnalytics = (0, $a1y4y.usePlatformLeafEventHandler)($fbf16bd5d1f8ff37$var$_objectSpread({
        fn: onChange,
        action: "clicked",
        analyticsData: analyticsContext
    }, $fbf16bd5d1f8ff37$var$analyticsAttributes));
    var tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $fbf16bd5d1f8ff37$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map(function(tabIndex) {
        return $fbf16bd5d1f8ff37$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        });
    });
    var tabsStyles = (0, $iSvIT.useMemo)(function() {
        return (0, $3XSTJ.getTabsStyles)(mode);
    }, [
        mode
    ]);
    return(// Only styles that affect the Tabs container itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTabPanel(),
    // which applies accessibility attributes that we use as a styling hook.
    (0, $2ZUkg.jsx)("div", {
        "data-testid": testId,
        css: [
            $fbf16bd5d1f8ff37$var$baseStyles,
            tabsStyles
        ]
    }, (0, $2ZUkg.jsx)((0, $eqG3R.TabListContext).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), null, tabPanelsWithContext)));
};
var $fbf16bd5d1f8ff37$export$2e2bcd8739ae039 = $fbf16bd5d1f8ff37$var$Tabs;

});
parcelRegister("4J9Jx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3712ea3caa047c9b$export$2e2bcd8739ae039; });

var $dxoBu = parcelRequire("dxoBu");
function $3712ea3caa047c9b$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $dxoBu.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("dxoBu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9db17132b5ce98c8$export$2e2bcd8739ae039; });

var $gEQb4 = parcelRequire("gEQb4");

var $4WQnG = parcelRequire("4WQnG");
function $9db17132b5ce98c8$export$2e2bcd8739ae039(t) {
    var i = (0, $4WQnG.default)(t, "string");
    return "symbol" == (0, $gEQb4.default)(i) ? i : i + "";
}

});
parcelRegister("gEQb4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c208db21d4d62e03$export$2e2bcd8739ae039; });
function $c208db21d4d62e03$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $c208db21d4d62e03$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c208db21d4d62e03$export$2e2bcd8739ae039(o);
}

});

parcelRegister("4WQnG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39a535fde77fd795$export$2e2bcd8739ae039; });

var $gEQb4 = parcelRequire("gEQb4");
function $39a535fde77fd795$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $gEQb4.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $gEQb4.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("bZBYx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8bb2d951a7baee12$export$2e2bcd8739ae039; });

var $b5ivW = parcelRequire("b5ivW");

var $4PAo1 = parcelRequire("4PAo1");

var $aOKnV = parcelRequire("aOKnV");

var $j5qQe = parcelRequire("j5qQe");
function $8bb2d951a7baee12$export$2e2bcd8739ae039(r) {
    return (0, $b5ivW.default)(r) || (0, $4PAo1.default)(r) || (0, $aOKnV.default)(r) || (0, $j5qQe.default)();
}

});
parcelRegister("b5ivW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $811e85e4d0e063fb$export$2e2bcd8739ae039; });
function $811e85e4d0e063fb$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("4PAo1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $384826739c5c985f$export$2e2bcd8739ae039; });
function $384826739c5c985f$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("aOKnV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e028dfb2d6babd6$export$2e2bcd8739ae039; });

var $fFYJ3 = parcelRequire("fFYJ3");
function $7e028dfb2d6babd6$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $fFYJ3.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $fFYJ3.default)(r, a) : void 0;
    }
}

});
parcelRegister("fFYJ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b699ca3279955314$export$2e2bcd8739ae039; });
function $b699ca3279955314$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("j5qQe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de534e19c4c5dcf9$export$2e2bcd8739ae039; });
function $de534e19c4c5dcf9$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jTVYe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7d01f1457117c33$export$2e2bcd8739ae039; });

var $b5ivW = parcelRequire("b5ivW");

var $a2f0S = parcelRequire("a2f0S");

var $aOKnV = parcelRequire("aOKnV");

var $j5qQe = parcelRequire("j5qQe");
function $e7d01f1457117c33$export$2e2bcd8739ae039(r, e) {
    return (0, $b5ivW.default)(r) || (0, $a2f0S.default)(r, e) || (0, $aOKnV.default)(r, e) || (0, $j5qQe.default)();
}

});
parcelRegister("a2f0S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74e5bc960d403ba5$export$2e2bcd8739ae039; });
function $74e5bc960d403ba5$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});


parcelRegister("7OFSq", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", function () { return $5b0dafcc3dc061f5$export$7692396083754928; });

var $hYwD8 = parcelRequire("hYwD8");
// Create default global light theme
var $5b0dafcc3dc061f5$var$_createTheme = (0, $hYwD8.createTheme)(function() {
    return {
        mode: "light"
    };
}), $5b0dafcc3dc061f5$var$Provider = $5b0dafcc3dc061f5$var$_createTheme.Provider, $5b0dafcc3dc061f5$var$Consumer = $5b0dafcc3dc061f5$var$_createTheme.Consumer, $5b0dafcc3dc061f5$export$7692396083754928 = $5b0dafcc3dc061f5$var$_createTheme.useTheme;
var $5b0dafcc3dc061f5$export$2e2bcd8739ae039 = {
    Provider: $5b0dafcc3dc061f5$var$Provider,
    Consumer: $5b0dafcc3dc061f5$var$Consumer
};

});
parcelRegister("hYwD8", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $d16159f4573fb9ba$export$25d302a5b900a763; });

var $8J0Sm = parcelRequire("8J0Sm");

var $iSvIT = parcelRequire("iSvIT");
var $d16159f4573fb9ba$var$_excluded = [
    "children"
];
function $d16159f4573fb9ba$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $iSvIT.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $iSvIT.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $8J0Sm.default)(props, $d16159f4573fb9ba$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $iSvIT.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $iSvIT.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});
parcelRegister("8J0Sm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65a3349a8b6fcbd4$export$2e2bcd8739ae039; });

var $jHNXr = parcelRequire("jHNXr");
function $65a3349a8b6fcbd4$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $jHNXr.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("jHNXr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e588c905ceea2002$export$2e2bcd8739ae039; });
function $e588c905ceea2002$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});




parcelRegister("eqG3R", function(module, exports) {

$parcel$export(module.exports, "TabContext", function () { return $a8141ee2f8ed604f$export$5a5d356ca5f10a0a; });
$parcel$export(module.exports, "TabListContext", function () { return $a8141ee2f8ed604f$export$aa6907f9fd69e93b; });
$parcel$export(module.exports, "TabPanelContext", function () { return $a8141ee2f8ed604f$export$2054129d247c3102; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $iSvIT = parcelRequire("iSvIT");
var $a8141ee2f8ed604f$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
var $a8141ee2f8ed604f$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
var $a8141ee2f8ed604f$export$2054129d247c3102 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);

});

parcelRegister("3XSTJ", function(module, exports) {

$parcel$export(module.exports, "getTabsStyles", function () { return $2e3177615d59ec44$export$dd5afd2190fb792c; });
$parcel$export(module.exports, "getTabListStyles", function () { return $2e3177615d59ec44$export$42a3c683c377bcb2; });

var $4J9Jx = parcelRequire("4J9Jx");

var $2ZUkg = parcelRequire("2ZUkg");

var $al99c = parcelRequire("al99c");
function $2e3177615d59ec44$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2e3177615d59ec44$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2e3177615d59ec44$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $4J9Jx.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2e3177615d59ec44$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2e3177615d59ec44$var$tabLeftRightPadding = "var(--ds-space-100, 8px)";
var $2e3177615d59ec44$var$tabTopBottomPadding = "var(--ds-space-050, 4px)";
// TODO this should probably be `border.width.indicator`
var $2e3177615d59ec44$var$underlineHeight = "var(--ds-border-width-outline, 2px)";
var $2e3177615d59ec44$var$highContrastFocusStyles = {
    outline: "var(--ds-border-width, 1px)".concat(" solid")
};
// Required so the focus ring is visible in high contrast mode
var $2e3177615d59ec44$var$highContrastFocusRing = {
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": $2e3177615d59ec44$var$highContrastFocusStyles,
        "@supports not selector(*:focus-visible)": {
            "&:focus": $2e3177615d59ec44$var$highContrastFocusStyles
        }
    }
};
var $2e3177615d59ec44$var$tabFocusStyles = function tabFocusStyles(mode) {
    return {
        boxShadow: "0 0 0 2px ".concat((0, $al99c.getTabPanelFocusColor)(mode), " inset"),
        borderRadius: "var(--ds-border-radius, 3px)",
        outline: "none"
    };
};
var $2e3177615d59ec44$var$getTabPanelStyles = function getTabPanelStyles(mode) {
    return $2e3177615d59ec44$var$_objectSpread({
        flexGrow: 1,
        /*
      NOTE min-height set to 0% because of Firefox bug
      FF http://stackoverflow.com/questions/28636832/firefox-overflow-y-not-working-with-nested-flexbox
    */ minHeight: "0%",
        display: "flex",
        padding: "0 ".concat($2e3177615d59ec44$var$tabLeftRightPadding),
        "&:focus-visible": $2e3177615d59ec44$var$tabFocusStyles(mode),
        "@supports not selector(*:focus-visible)": {
            "&:focus": $2e3177615d59ec44$var$tabFocusStyles(mode)
        }
    }, $2e3177615d59ec44$var$highContrastFocusRing);
};
var $2e3177615d59ec44$export$dd5afd2190fb792c = function getTabsStyles(mode) {
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $2ZUkg.css)({
        '& [role="tabpanel"]': $2e3177615d59ec44$var$getTabPanelStyles(mode),
        // The hidden attribute doesn't work on flex elements
        // Change display to be none
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "& > [hidden]": {
            display: "none"
        }
    }));
};
var $2e3177615d59ec44$var$tabLineStyles = {
    content: '""',
    borderRadius: "var(--ds-border-radius-050, 2px)",
    bottom: 0,
    margin: 0,
    position: "absolute",
    width: "inherit",
    left: $2e3177615d59ec44$var$tabLeftRightPadding,
    right: $2e3177615d59ec44$var$tabLeftRightPadding
};
var $2e3177615d59ec44$export$42a3c683c377bcb2 = function getTabListStyles(mode) {
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $2ZUkg.css)({
        '& [role="tab"]': $2e3177615d59ec44$export$916c8b0fccbb37d2(mode),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        "&::before": $2e3177615d59ec44$var$_objectSpread($2e3177615d59ec44$var$_objectSpread({}, $2e3177615d59ec44$var$tabLineStyles), {}, {
            height: $2e3177615d59ec44$var$underlineHeight,
            // This line is not a border so the selected line is visible in high contrast mode
            backgroundColor: (0, $al99c.getTabLineColor)(mode).lineColor
        })
    }));
};
var $2e3177615d59ec44$var$tabPanelFocusStyles = function tabPanelFocusStyles(mode) {
    var colors = (0, $al99c.getTabColors)(mode);
    return {
        boxShadow: "0 0 0 2px ".concat(colors.focusBorderColor, " inset"),
        borderRadius: "var(--ds-border-radius, 3px)",
        outline: "none",
        // Hide TabLine on focus
        "&::after": {
            opacity: 0
        }
    };
};
var $2e3177615d59ec44$export$916c8b0fccbb37d2 = function getTabStyles(mode) {
    var colors = (0, $al99c.getTabColors)(mode);
    return $2e3177615d59ec44$var$_objectSpread($2e3177615d59ec44$var$_objectSpread({
        color: colors.labelColor,
        cursor: "pointer",
        lineHeight: 1.8,
        margin: 0,
        padding: "".concat($2e3177615d59ec44$var$tabTopBottomPadding, " ").concat($2e3177615d59ec44$var$tabLeftRightPadding),
        position: "relative",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        "&:hover": {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            "&::after": $2e3177615d59ec44$var$_objectSpread($2e3177615d59ec44$var$_objectSpread({}, $2e3177615d59ec44$var$tabLineStyles), {}, {
                borderBottom: "".concat($2e3177615d59ec44$var$underlineHeight, " solid ").concat((0, $al99c.getTabLineColor)(mode).hoveredColor),
                height: 0
            })
        },
        "&:active": {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            "&::after": $2e3177615d59ec44$var$_objectSpread($2e3177615d59ec44$var$_objectSpread({}, $2e3177615d59ec44$var$tabLineStyles), {}, {
                borderBottom: "".concat($2e3177615d59ec44$var$underlineHeight, " solid ").concat((0, $al99c.getTabLineColor)(mode).activeColor),
                height: 0
            })
        },
        "&:focus-visible": $2e3177615d59ec44$var$tabPanelFocusStyles(mode),
        "@supports not selector(*:focus-visible)": {
            "&:focus": $2e3177615d59ec44$var$tabPanelFocusStyles(mode)
        }
    }, $2e3177615d59ec44$var$highContrastFocusRing), {}, {
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            "&::after": $2e3177615d59ec44$var$_objectSpread($2e3177615d59ec44$var$_objectSpread({}, $2e3177615d59ec44$var$tabLineStyles), {}, {
                // This line is a border so it is visible in high contrast mode
                borderBottom: "".concat($2e3177615d59ec44$var$underlineHeight, " solid ").concat((0, $al99c.getTabLineColor)(mode).selectedColor),
                height: 0
            })
        }
    });
};

});
parcelRegister("al99c", function(module, exports) {

$parcel$export(module.exports, "getTabColors", function () { return $7872f60a8db901a9$export$8a53023232713127; });
$parcel$export(module.exports, "getTabLineColor", function () { return $7872f60a8db901a9$export$eff40d6a7c078cf; });
$parcel$export(module.exports, "getTabPanelFocusColor", function () { return $7872f60a8db901a9$export$5b33c784b26b1d3f; });

var $elRv0 = parcelRequire("elRv0");
var $7872f60a8db901a9$var$tabColorMap = {
    light: {
        labelColor: "var(--ds-text-subtle, ".concat((0, $elRv0.N500), ")"),
        activeLabelColor: "var(--ds-text, ".concat((0, $elRv0.B500), ")"),
        hoverLabelColor: "var(--ds-text-subtle, ".concat((0, $elRv0.B400), ")"),
        selectedColor: "var(--ds-text-selected, ".concat((0, $elRv0.B400), ")"),
        focusBorderColor: "var(--ds-border-focused, ".concat((0, $elRv0.B100), ")")
    },
    dark: {
        labelColor: "var(--ds-text-subtle, ".concat((0, $elRv0.DN400), ")"),
        activeLabelColor: "var(--ds-text, ".concat((0, $elRv0.B200), ")"),
        hoverLabelColor: "var(--ds-text-subtle, ".concat((0, $elRv0.B75), ")"),
        selectedColor: "var(--ds-text-selected, ".concat((0, $elRv0.B75), ")"),
        focusBorderColor: "var(--ds-border-focused, ".concat((0, $elRv0.B75), ")")
    }
};
var $7872f60a8db901a9$export$8a53023232713127 = function getTabColors(mode) {
    return $7872f60a8db901a9$var$tabColorMap[mode];
};
var $7872f60a8db901a9$var$tabLineColorMap = {
    light: {
        lineColor: "var(--ds-border, ".concat((0, $elRv0.N30), ")"),
        hoveredColor: "var(--ds-border, transparent)",
        activeColor: "var(--ds-border, transparent)",
        selectedColor: "var(--ds-border-selected, ".concat((0, $elRv0.B400), ")")
    },
    dark: {
        lineColor: "var(--ds-border, ".concat((0, $elRv0.DN0), ")"),
        hoveredColor: "var(--ds-border, transparent)",
        activeColor: "var(--ds-border, transparent)",
        selectedColor: "var(--ds-border-selected, ".concat((0, $elRv0.B75), ")")
    }
};
var $7872f60a8db901a9$export$eff40d6a7c078cf = function getTabLineColor(mode) {
    return $7872f60a8db901a9$var$tabLineColorMap[mode];
};
var $7872f60a8db901a9$var$tabPanelFocusColorMap = {
    light: "var(--ds-border-focused, ".concat((0, $elRv0.B100), ")"),
    dark: "var(--ds-border-focused, ".concat((0, $elRv0.B75), ")")
};
var $7872f60a8db901a9$export$5b33c784b26b1d3f = function getTabPanelFocusColor(mode) {
    return $7872f60a8db901a9$var$tabPanelFocusColorMap[mode];
};

});
parcelRegister("elRv0", function(module, exports) {

$parcel$export(module.exports, "B75", function () { return $a72c86af10661c4d$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $a72c86af10661c4d$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $a72c86af10661c4d$export$215b7063051591f1; });
$parcel$export(module.exports, "B400", function () { return $a72c86af10661c4d$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $a72c86af10661c4d$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "N30", function () { return $a72c86af10661c4d$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N500", function () { return $a72c86af10661c4d$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N30A", function () { return $a72c86af10661c4d$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN400", function () { return $a72c86af10661c4d$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN0", function () { return $a72c86af10661c4d$export$3d4f271a500072a; });
$parcel$export(module.exports, "skeleton", function () { return $a72c86af10661c4d$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $ceZbE = parcelRequire("ceZbE");
var $a72c86af10661c4d$export$4b84fd0e2c617bd = "#FFEBE6";
var $a72c86af10661c4d$export$b34b069eff244586 = "#FFBDAD";
var $a72c86af10661c4d$export$be802dd0d8b57f35 = "#FF8F73";
var $a72c86af10661c4d$export$60847d42f9da92a6 = "#FF7452";
var $a72c86af10661c4d$export$4a7404f376229999 = "#FF5630";
var $a72c86af10661c4d$export$2010d0fb4295b346 = "#DE350B";
var $a72c86af10661c4d$export$2837b5a1a71d5c02 = "#BF2600";
var $a72c86af10661c4d$export$8d9596b529bbb9cf = "#FFFAE6";
var $a72c86af10661c4d$export$41060a744ab0b7ae = "#FFF0B3";
var $a72c86af10661c4d$export$1cc05bbbf340e559 = "#FFE380";
var $a72c86af10661c4d$export$5aae31392d72caaa = "#FFC400";
var $a72c86af10661c4d$export$c6930421db9fa514 = "#FFAB00";
var $a72c86af10661c4d$export$59619663aa6500fb = "#FF991F";
var $a72c86af10661c4d$export$874739ea9e379ab6 = "#FF8B00";
var $a72c86af10661c4d$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $a72c86af10661c4d$export$69a3bf21b9686c2b = "#ABF5D1";
var $a72c86af10661c4d$export$afbce1382ec95f73 = "#79F2C0";
var $a72c86af10661c4d$export$747d86715d4175de = "#57D9A3";
var $a72c86af10661c4d$export$940e1f69e873f202 = "#36B37E";
var $a72c86af10661c4d$export$a49394138f7b8e85 = "#00875A";
var $a72c86af10661c4d$export$6fa04827ac68a4fb = "#006644";
var $a72c86af10661c4d$export$226de0355ed012f8 = "#DEEBFF";
var $a72c86af10661c4d$export$8c13c2ee36917869 = "#B3D4FF";
var $a72c86af10661c4d$export$ecfc1dff386a3e7a = "#4C9AFF";
var $a72c86af10661c4d$export$215b7063051591f1 = "#2684FF";
var $a72c86af10661c4d$export$e62e8919cca44969 = "#0065FF";
var $a72c86af10661c4d$export$b3de0ae08da2ce64 = "#0052CC";
var $a72c86af10661c4d$export$a6ee3d71bc067634 = "#0747A6";
var $a72c86af10661c4d$export$363e4475840015bb = "#EAE6FF";
var $a72c86af10661c4d$export$4b0a4417ed59760f = "#C0B6F2";
var $a72c86af10661c4d$export$6011520a64d9a187 = "#998DD9";
var $a72c86af10661c4d$export$a7175d4e9206bc80 = "#8777D9";
var $a72c86af10661c4d$export$b48405b95304b5a1 = "#6554C0";
var $a72c86af10661c4d$export$c71e4279dd54a18d = "#5243AA";
var $a72c86af10661c4d$export$147899de772240ec = "#403294";
var $a72c86af10661c4d$export$2cf711fe14c66f06 = "#E6FCFF";
var $a72c86af10661c4d$export$7a8f4d33f6f9772c = "#B3F5FF";
var $a72c86af10661c4d$export$776c9c497ef08533 = "#79E2F2";
var $a72c86af10661c4d$export$69cb3ca10c1e330e = "#00C7E6";
var $a72c86af10661c4d$export$9dc1ef0f3f48059b = "#00B8D9";
var $a72c86af10661c4d$export$7c835c78b6fcdef8 = "#00A3BF";
var $a72c86af10661c4d$export$6036577f95c3877e = "#008DA6";
var $a72c86af10661c4d$export$29a4f05edc054374 = "#FFFFFF";
var $a72c86af10661c4d$export$e655ef011c4aa1a2 = "#FAFBFC";
var $a72c86af10661c4d$export$9fdfb749e33cdf97 = "#F4F5F7";
var $a72c86af10661c4d$export$3e51e8f1440314ba = "#EBECF0";
var $a72c86af10661c4d$export$1ce2d1575d444ceb = "#DFE1E6";
var $a72c86af10661c4d$export$8754fc7e6d8b3000 = "#C1C7D0";
var $a72c86af10661c4d$export$c2e91cbeada39b8b = "#B3BAC5";
var $a72c86af10661c4d$export$5f71e19f3a7ad9de = "#A5ADBA";
var $a72c86af10661c4d$export$eaa8c8a70ac22806 = "#97A0AF";
var $a72c86af10661c4d$export$7c87d337fb91a97d = "#8993A4";
var $a72c86af10661c4d$export$d6447c357493214f = "#7A869A";
var $a72c86af10661c4d$export$f563ee71e9ee74cd = "#6B778C";
var $a72c86af10661c4d$export$e2ef2124cf4024b1 = "#5E6C84";
var $a72c86af10661c4d$export$eece5f492e429f08 = "#505F79";
var $a72c86af10661c4d$export$c39c0fe0f26207ae = "#42526E";
var $a72c86af10661c4d$export$7090862dc3038a9f = "#344563";
var $a72c86af10661c4d$export$ad0bacf983b7ddaa = "#253858";
var $a72c86af10661c4d$export$7d61b15e0da132af = "#172B4D";
var $a72c86af10661c4d$export$fbda843f0a27fe96 = "#091E42";
var $a72c86af10661c4d$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $a72c86af10661c4d$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $a72c86af10661c4d$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $a72c86af10661c4d$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $a72c86af10661c4d$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $a72c86af10661c4d$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $a72c86af10661c4d$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $a72c86af10661c4d$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $a72c86af10661c4d$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $a72c86af10661c4d$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $a72c86af10661c4d$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $a72c86af10661c4d$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $a72c86af10661c4d$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $a72c86af10661c4d$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $a72c86af10661c4d$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $a72c86af10661c4d$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $a72c86af10661c4d$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $a72c86af10661c4d$export$2f6319cf7d736c2a = "#E6EDFA";
var $a72c86af10661c4d$export$95126bc8884d6634 = "#DCE5F5";
var $a72c86af10661c4d$export$8338d8c35d44ff1 = "#CED9EB";
var $a72c86af10661c4d$export$5368d76ae4fbbda7 = "#B8C7E0";
var $a72c86af10661c4d$export$9f0a771d16ec8d36 = "#ABBBD6";
var $a72c86af10661c4d$export$abcf8c38338b4aa5 = "#9FB0CC";
var $a72c86af10661c4d$export$97e81faa16a182c7 = "#8C9CB8";
var $a72c86af10661c4d$export$bfe21c59123ecf33 = "#7988A3";
var $a72c86af10661c4d$export$ee82aa2ea6a1558 = "#67758F";
var $a72c86af10661c4d$export$682927c6ed76be02 = "#56637A";
var $a72c86af10661c4d$export$91fd9994c5be9757 = "#455166";
var $a72c86af10661c4d$export$d281fbfe3cff2df6 = "#3B475C";
var $a72c86af10661c4d$export$3902c91d8b98a753 = "#313D52";
var $a72c86af10661c4d$export$8e8133c1ba5845b5 = "#283447";
var $a72c86af10661c4d$export$33ff357f6620b39 = "#202B3D";
var $a72c86af10661c4d$export$633847cf062b69e0 = "#1B2638";
var $a72c86af10661c4d$export$9776a6e503bdbf76 = "#121A29";
var $a72c86af10661c4d$export$6c813d5160dff5db = "#0E1624";
var $a72c86af10661c4d$export$3d4f271a500072a = "#0D1424";
var $a72c86af10661c4d$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $a72c86af10661c4d$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $a72c86af10661c4d$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $a72c86af10661c4d$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $a72c86af10661c4d$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $a72c86af10661c4d$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $a72c86af10661c4d$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $a72c86af10661c4d$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $a72c86af10661c4d$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $a72c86af10661c4d$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $a72c86af10661c4d$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $a72c86af10661c4d$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $a72c86af10661c4d$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $a72c86af10661c4d$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $a72c86af10661c4d$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $a72c86af10661c4d$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $a72c86af10661c4d$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $a72c86af10661c4d$export$8ce1fd94bee2f412 = (0, $ceZbE.default)({
    light: "var(--ds-surface, ".concat($a72c86af10661c4d$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($a72c86af10661c4d$export$633847cf062b69e0, ")")
});
var $a72c86af10661c4d$export$b861914ea877b580 = (0, $ceZbE.default)({
    light: "var(--ds-background-selected, ".concat($a72c86af10661c4d$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($a72c86af10661c4d$export$8c13c2ee36917869, ")")
});
var $a72c86af10661c4d$export$3f1b020df94387af = (0, $ceZbE.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($a72c86af10661c4d$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($a72c86af10661c4d$export$d281fbfe3cff2df6, ")")
});
var $a72c86af10661c4d$export$c0183dbab98ca63e = (0, $ceZbE.default)({
    light: "var(--ds-surface-overlay, ".concat($a72c86af10661c4d$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($a72c86af10661c4d$export$8e8133c1ba5845b5, ")")
});
var $a72c86af10661c4d$export$6f093cfa640b7166 = (0, $ceZbE.default)({
    light: "var(--ds-text, ".concat($a72c86af10661c4d$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($a72c86af10661c4d$export$5368d76ae4fbbda7, ")")
});
var $a72c86af10661c4d$export$42f8e9c698766e7a = (0, $ceZbE.default)({
    light: "var(--ds-text, ".concat($a72c86af10661c4d$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($a72c86af10661c4d$export$5368d76ae4fbbda7, ")")
});
var $a72c86af10661c4d$export$c2d157ca1c34b6e3 = (0, $ceZbE.default)({
    light: "var(--ds-text-selected, ".concat($a72c86af10661c4d$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($a72c86af10661c4d$export$b3de0ae08da2ce64, ")")
});
var $a72c86af10661c4d$export$1905ba28d7cf066f = (0, $ceZbE.default)({
    light: "var(--ds-text-subtlest, ".concat($a72c86af10661c4d$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($a72c86af10661c4d$export$97e81faa16a182c7, ")")
});
var $a72c86af10661c4d$export$bd9002130d306d39 = (0, $ceZbE.default)({
    light: "var(--ds-text-subtlest, ".concat($a72c86af10661c4d$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($a72c86af10661c4d$export$bfe21c59123ecf33, ")")
});
var $a72c86af10661c4d$export$46e4a324ac90507f = (0, $ceZbE.default)({
    light: "var(--ds-text, ".concat($a72c86af10661c4d$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($a72c86af10661c4d$export$5368d76ae4fbbda7, ")")
});
var $a72c86af10661c4d$export$79f3f2b82beb0d36 = (0, $ceZbE.default)({
    light: "var(--ds-text-subtlest, ".concat($a72c86af10661c4d$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($a72c86af10661c4d$export$97e81faa16a182c7, ")")
});
var $a72c86af10661c4d$export$7bb0d5c671655cc4 = (0, $ceZbE.default)({
    light: $a72c86af10661c4d$export$9fdfb749e33cdf97,
    dark: $a72c86af10661c4d$export$8e8133c1ba5845b5
});
var $a72c86af10661c4d$export$9c30223ca0a664fb = (0, $ceZbE.default)({
    light: "var(--ds-link, ".concat($a72c86af10661c4d$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($a72c86af10661c4d$export$ecfc1dff386a3e7a, ")")
});
var $a72c86af10661c4d$export$7ed258b0728b004b = (0, $ceZbE.default)({
    light: "var(--ds-link-pressed, ".concat($a72c86af10661c4d$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($a72c86af10661c4d$export$215b7063051591f1, ")")
});
var $a72c86af10661c4d$export$dfa920d8decc8a59 = (0, $ceZbE.default)({
    light: "var(--ds-link-pressed, ".concat($a72c86af10661c4d$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($a72c86af10661c4d$export$ecfc1dff386a3e7a, ")")
});
var $a72c86af10661c4d$export$6069e6ad5c78f632 = (0, $ceZbE.default)({
    light: "var(--ds-border-focused, ".concat($a72c86af10661c4d$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($a72c86af10661c4d$export$215b7063051591f1, ")")
});
var $a72c86af10661c4d$export$9ad721cf3b3debe0 = (0, $ceZbE.default)({
    light: "var(--ds-background-brand-bold, ".concat($a72c86af10661c4d$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($a72c86af10661c4d$export$ecfc1dff386a3e7a, ")")
});
var $a72c86af10661c4d$export$2aa0182783e7e9de = (0, $ceZbE.default)({
    light: $a72c86af10661c4d$export$b3de0ae08da2ce64,
    dark: $a72c86af10661c4d$export$ecfc1dff386a3e7a
});
var $a72c86af10661c4d$export$8bf7dff220b82b4a = (0, $ceZbE.default)({
    light: $a72c86af10661c4d$export$9dc1ef0f3f48059b,
    dark: $a72c86af10661c4d$export$69cb3ca10c1e330e
});
var $a72c86af10661c4d$export$e13cce2a2d16a9d4 = (0, $ceZbE.default)({
    light: $a72c86af10661c4d$export$b48405b95304b5a1,
    dark: $a72c86af10661c4d$export$6011520a64d9a187
});
var $a72c86af10661c4d$export$a90204d1394caf30 = (0, $ceZbE.default)({
    light: $a72c86af10661c4d$export$4a7404f376229999,
    dark: $a72c86af10661c4d$export$4a7404f376229999
});
var $a72c86af10661c4d$export$594c5a8758200c32 = (0, $ceZbE.default)({
    light: $a72c86af10661c4d$export$c6930421db9fa514,
    dark: $a72c86af10661c4d$export$c6930421db9fa514
});
var $a72c86af10661c4d$export$955a2ebd2fb142ae = (0, $ceZbE.default)({
    light: $a72c86af10661c4d$export$940e1f69e873f202,
    dark: $a72c86af10661c4d$export$940e1f69e873f202
});
var $a72c86af10661c4d$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($a72c86af10661c4d$export$8d43898f60b96a82, ")");
};

});
parcelRegister("ceZbE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e964143c8d0a2f4$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $2zLl0 = parcelRequire("2zLl0");
// Unpack custom variants, and get correct value for the current theme
function $8e964143c8d0a2f4$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $2zLl0.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $8e964143c8d0a2f4$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $8e964143c8d0a2f4$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $2zLl0.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("2zLl0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e0391f110b68d81$export$2e2bcd8739ae039; });

var $8wAfb = parcelRequire("8wAfb");
function $1e0391f110b68d81$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $8wAfb.CHANNEL) in props.theme) return props.theme[0, $8wAfb.CHANNEL];
        else if ("mode" in props.theme && (0, $8wAfb.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $8wAfb.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("8wAfb", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $634d6d2fafc8e4cc$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $634d6d2fafc8e4cc$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $634d6d2fafc8e4cc$export$6ba72c8346b4c57e; });

var $dSkST = parcelRequire("dSkST");

var $elRv0 = parcelRequire("elRv0");
var $634d6d2fafc8e4cc$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $634d6d2fafc8e4cc$export$c93026a968943f95 = "light";
var $634d6d2fafc8e4cc$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $634d6d2fafc8e4cc$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $634d6d2fafc8e4cc$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $634d6d2fafc8e4cc$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $634d6d2fafc8e4cc$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $634d6d2fafc8e4cc$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $634d6d2fafc8e4cc$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $634d6d2fafc8e4cc$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $elRv0.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $634d6d2fafc8e4cc$export$6d8204c2cb2e06b8() / 4;
    (0, $dSkST.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $634d6d2fafc8e4cc$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $634d6d2fafc8e4cc$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $634d6d2fafc8e4cc$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $dSkST.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $634d6d2fafc8e4cc$export$ba1d834b86d72a09 = $634d6d2fafc8e4cc$export$a1b3edb637fb4f35;
var $634d6d2fafc8e4cc$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $elRv0.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $elRv0.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $elRv0.N30A), ")")
            }
        }
    };
};

});
parcelRegister("dSkST", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1a084bb84812b67$export$2e2bcd8739ae039; });

var $4pFFU = parcelRequire("4pFFU");

var $XAEGR = parcelRequire("XAEGR");
function $a1a084bb84812b67$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $4pFFU.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $a1a084bb84812b67$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $XAEGR;
}

});
parcelRegister("4pFFU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3369d3042320a7ff$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $3369d3042320a7ff$var$printed = {};
function $3369d3042320a7ff$export$2e2bcd8739ae039(message) {
    if ($3369d3042320a7ff$var$printed[message]) return;
    $3369d3042320a7ff$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}

});








parcelRegister("7xyUM", function(module, exports) {

$parcel$export(module.exports, "onMouseDownBlur", function () { return $57d6b2d0665322ef$export$1aedf39a68fc0142; });
// Prevent a focus ring if clicked
var $57d6b2d0665322ef$export$1aedf39a68fc0142 = function onMouseDownBlur(e) {
    var currentTarget = e.currentTarget;
    var focusedDuringMouseDown = currentTarget === document.activeElement;
    requestAnimationFrame(function() {
        if (focusedDuringMouseDown && currentTarget !== document.activeElement && document.body.contains(currentTarget)) {
            currentTarget.focus();
            return;
        }
        if (!focusedDuringMouseDown && document.body.contains(currentTarget)) currentTarget.blur();
    });
};

});


parcelRegister("28wqY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18e57cd6637e11a5$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $7OFSq = parcelRequire("7OFSq");

var $3l2qu = parcelRequire("3l2qu");

var $eqG3R = parcelRequire("eqG3R");

var $3XSTJ = parcelRequire("3XSTJ");

var $7xyUM = parcelRequire("7xyUM");
var $18e57cd6637e11a5$var$baseStyles = (0, $2ZUkg.css)({
    display: "flex",
    padding: "var(--ds-space-0, 0px)",
    position: "relative"
});
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $18e57cd6637e11a5$var$TabList = function TabList(_ref) {
    var children = _ref.children;
    var _useGlobalTheme = (0, $7OFSq.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var _useTabList = (0, $3l2qu.useTabList)(), tabsId = _useTabList.tabsId, selected = _useTabList.selected, onChange = _useTabList.onChange;
    var ref = /*#__PURE__*/ (0, $iSvIT.createRef)();
    // Don't include any conditional children
    var childrenArray = (0, $iSvIT.Children).toArray(children).filter(Boolean);
    var length = childrenArray.length;
    var tabListStyles = (0, $iSvIT.useMemo)(function() {
        return (0, $3XSTJ.getTabListStyles)(mode);
    }, [
        mode
    ]);
    var selectTabByIndex = (0, $iSvIT.useCallback)(function(index) {
        var _ref$current;
        var newSelectedNode = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelector("[id='".concat(tabsId, "-").concat(index, "']"));
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    var onKeyDown = (0, $iSvIT.useCallback)(function(e) {
        if (![
            "ArrowRight",
            "ArrowLeft",
            "Home",
            "End"
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        var lastTabIndex = length - 1;
        if ([
            "Home",
            "End"
        ].includes(e.key)) {
            var _newSelected = e.key === "Home" ? 0 : lastTabIndex;
            selectTabByIndex(_newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        var selectedIndex = parseInt(e.currentTarget.getAttribute("aria-posinset") || "0") - 1;
        var modifier = e.key === "ArrowRight" ? 1 : -1;
        var newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    var getTabWithContext = (0, $iSvIT.useCallback)(function(_ref2) {
        var tab = _ref2.tab, isSelected = _ref2.isSelected, index = _ref2.index;
        return (0, $2ZUkg.jsx)((0, $eqG3R.TabContext).Provider, {
            value: {
                onClick: function onClick() {
                    return onChange(index);
                },
                onMouseDown: (0, $7xyUM.onMouseDownBlur),
                onKeyDown: onKeyDown,
                "aria-setsize": length,
                role: "tab",
                id: "".concat(tabsId, "-").concat(index),
                "aria-posinset": index + 1,
                "aria-selected": isSelected,
                "aria-controls": "".concat(tabsId, "-").concat(index, "-tab"),
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tab);
    }, [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return(// Only styles that affect the TabList itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTab(),
    // which applies accessibility atributes that we use as a styling hook.
    (0, $2ZUkg.jsx)("div", {
        role: "tablist",
        ref: ref,
        css: [
            $18e57cd6637e11a5$var$baseStyles,
            tabListStyles
        ]
    }, childrenArray.map(function(child, index) {
        return getTabWithContext({
            tab: child,
            index: index,
            isSelected: index === selected
        });
    })));
};
var $18e57cd6637e11a5$export$2e2bcd8739ae039 = $18e57cd6637e11a5$var$TabList;

});
parcelRegister("3l2qu", function(module, exports) {

$parcel$export(module.exports, "useTab", function () { return $26e53714a4c30c90$export$fdf4756d5b8ef90a; });
$parcel$export(module.exports, "useTabList", function () { return $26e53714a4c30c90$export$773e389e644c5874; });
$parcel$export(module.exports, "useTabPanel", function () { return $26e53714a4c30c90$export$fae0121b5afe572d; });

var $iSvIT = parcelRequire("iSvIT");

var $eqG3R = parcelRequire("eqG3R");
var $26e53714a4c30c90$export$fdf4756d5b8ef90a = function useTab() {
    var tabData = (0, $iSvIT.useContext)((0, $eqG3R.TabContext));
    if (tabData == null || typeof tabData === "undefined") throw Error("@atlaskit/tabs: A Tab must have a TabList parent.");
    return tabData;
};
var $26e53714a4c30c90$export$773e389e644c5874 = function useTabList() {
    var tabListData = (0, $iSvIT.useContext)((0, $eqG3R.TabListContext));
    if (tabListData === null || typeof tabListData === "undefined") throw Error("@atlaskit/tabs: A TabList must have a Tabs parent.");
    return tabListData;
};
var $26e53714a4c30c90$export$fae0121b5afe572d = function useTabPanel() {
    var tabPanelData = (0, $iSvIT.useContext)((0, $eqG3R.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === "undefined") throw Error("@atlaskit/tabs:  A TabPanel must have a Tabs parent.");
    return tabPanelData;
};

});


parcelRegister("ih47h", function(module, exports) {

$parcel$export(module.exports, "useFireAnalyticsEvents", function () { return $04eebad2fd486270$export$637f611434c7b092; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $dWbel = parcelRequire("dWbel");
const $04eebad2fd486270$var$EMPTY_ATTRIBUTES = {};
const $04eebad2fd486270$export$637f611434c7b092 = (initialAttributes)=>{
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const pendingEvents = (0, $iSvIT.useRef)([]);
    // Memoize initialAttributes to prevent unnecessary re-renders
    const memoizedInitialAttributes = (0, $iSvIT.useMemo)(()=>initialAttributes !== null && initialAttributes !== void 0 ? initialAttributes : $04eebad2fd486270$var$EMPTY_ATTRIBUTES, [
        initialAttributes
    ]);
    const fireEvent = (0, $iSvIT.useCallback)((eventPayload)=>{
        if (analyticsClient) createAnalyticsEvent((0, $6iHNw._)((0, $7Knp0._)({}, eventPayload), {
            attributes: (0, $7Knp0._)({}, memoizedInitialAttributes, eventPayload["attributes"] || {})
        })).fire();
        else // store events to send later
        pendingEvents.current.push(eventPayload);
    }, [
        analyticsClient,
        createAnalyticsEvent,
        memoizedInitialAttributes
    ]);
    // fires pending events once client is available
    (0, $iSvIT.useEffect)(()=>{
        if (analyticsClient && pendingEvents.current.length > 0) {
            pendingEvents.current.forEach((eventPayload)=>{
                createAnalyticsEvent((0, $6iHNw._)((0, $7Knp0._)({}, eventPayload), {
                    attributes: (0, $7Knp0._)({}, memoizedInitialAttributes, eventPayload["attributes"] || {})
                })).fire();
            });
            pendingEvents.current = [];
        }
    // we only need to run this effect when the analytics client changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        analyticsClient
    ]);
    const fireUIEvent = (0, $iSvIT.useCallback)((eventPayload)=>{
        fireEvent((0, $6iHNw._)((0, $7Knp0._)({}, eventPayload), {
            eventType: "ui"
        }));
    }, [
        fireEvent
    ]);
    const fireTrackEvent = (0, $iSvIT.useCallback)((eventPayload)=>{
        fireEvent((0, $6iHNw._)((0, $7Knp0._)({}, eventPayload), {
            eventType: "track"
        }));
    }, [
        fireEvent
    ]);
    const fireScreenEvent = (0, $iSvIT.useCallback)((eventPayload)=>{
        fireEvent((0, $6iHNw._)((0, $7Knp0._)({}, eventPayload), {
            eventType: "screen"
        }));
    }, [
        fireEvent
    ]);
    const fireOperationalEvent = (0, $iSvIT.useCallback)((eventPayload)=>{
        fireEvent((0, $6iHNw._)((0, $7Knp0._)({}, eventPayload), {
            eventType: "operational"
        }));
    }, [
        fireEvent
    ]);
    return {
        fireUIEvent: fireUIEvent,
        fireTrackEvent: fireTrackEvent,
        fireScreenEvent: fireScreenEvent,
        fireOperationalEvent: fireOperationalEvent,
        pendingEvents: pendingEvents
    };
};

});

parcelRegister("fxRez", function(module, exports) {

$parcel$export(module.exports, "isSafari", function () { return $b5133b43f7dd91b1$export$95df08bae54cb4df; });
function $b5133b43f7dd91b1$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== "undefined" && window.navigator != null ? //@ts-expect-error ignore userAgentData type issue
    re.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $b5133b43f7dd91b1$var$isIPhone() {
    return $b5133b43f7dd91b1$var$testPlatform(/^iPhone/i);
}
function $b5133b43f7dd91b1$var$isMac() {
    return $b5133b43f7dd91b1$var$testPlatform(/^Mac/i);
}
function $b5133b43f7dd91b1$var$isIPad() {
    return $b5133b43f7dd91b1$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    // eslint-disable-next-line compat/compat
    $b5133b43f7dd91b1$var$isMac() && navigator.maxTouchPoints > 1;
}
function $b5133b43f7dd91b1$var$isIOS() {
    return $b5133b43f7dd91b1$var$isIPhone() || $b5133b43f7dd91b1$var$isIPad();
}
function $b5133b43f7dd91b1$export$95df08bae54cb4df() {
    if (typeof window !== "undefined" && window.navigator != null) {
        var _window$navigator$use2;
        var ua = (_window$navigator$use2 = window.navigator.userAgent) === null || _window$navigator$use2 === void 0 ? void 0 : _window$navigator$use2.toLowerCase();
        return ua ? ua.includes("safari") && !ua.includes("chrome") : false;
    }
    return false;
}
function $b5133b43f7dd91b1$export$e1865c3bedcd822b() {
    return $b5133b43f7dd91b1$var$isMac() || $b5133b43f7dd91b1$var$isIOS();
}

});

parcelRegister("72NmR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $520f03b66cf6a10c$export$2e2bcd8739ae039; });
function $520f03b66cf6a10c$export$2e2bcd8739ae039() {
    return $520f03b66cf6a10c$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $520f03b66cf6a10c$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("cJhvT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $944745cf1254dbd7$export$2e2bcd8739ae039; });

var $4PXW5 = parcelRequire("4PXW5");
function $944745cf1254dbd7$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $4PXW5.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("4PXW5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $385a6ae08bbb3b15$export$2e2bcd8739ae039; });
function $385a6ae08bbb3b15$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("12ZPF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c35f0f595d2f583$export$2e2bcd8739ae039; });
/* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $72NmR = parcelRequire("72NmR");

var $cJhvT = parcelRequire("cJhvT");

var $8fP1t = parcelRequire("8fP1t");

var $iSvIT = parcelRequire("iSvIT");

var $gmylQ = parcelRequire("gmylQ");

var $lL4Ma = parcelRequire("lL4Ma");

var $dyf9a = parcelRequire("dyf9a");

var $dWwnB = parcelRequire("dWwnB");

var $jxLBU = parcelRequire("jxLBU");

var $2rRcm = parcelRequire("2rRcm");

var $eTo1d = parcelRequire("eTo1d");

var $2i2fk = parcelRequire("2i2fk");

var $9lekW = parcelRequire("9lekW");

var $5rIkq = parcelRequire("5rIkq");
var $0c35f0f595d2f583$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $0c35f0f595d2f583$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $0c35f0f595d2f583$var$LOADING_LABEL = ", Loading";
var $0c35f0f595d2f583$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhk1fvb _syaz1lh4 _aetrglyw _irr31fvb _30l31lh4 _1di61fvb _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko14q2",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $0c35f0f595d2f583$var$defaultStyles = {
    root: "_bfhk1j54 _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhksm61 _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr3yw9d _30l310s3 _1di6ih13 _9h8h10s3",
    interactiveRefreshed: "_irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
var $0c35f0f595d2f583$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $0c35f0f595d2f583$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $0c35f0f595d2f583$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $0c35f0f595d2f583$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $0c35f0f595d2f583$var$subtleStyles = {
    root: "_bfhkqtfy _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhkqtfy _syaz1gjq _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    interactiveRefreshed: "_irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
var $0c35f0f595d2f583$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _30l31pke _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $0c35f0f595d2f583$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? "default" : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, $cJhvT.default)(_ref, $0c35f0f595d2f583$var$_excluded);
    var localRef = (0, $iSvIT.useRef)(null);
    var splitButtonContext = (0, $2i2fk.useSplitButtonContext)();
    var loadingLabelId = (0, $dWwnB.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === "default";
    var appearance = isDefaultAppearanceSplitButton && (0, $jxLBU.fg)("platform-component-visual-refresh") ? "subtle" : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || "default";
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $dyf9a.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $cJhvT.default)(unsafeRest, $0c35f0f595d2f583$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2rRcm.default), (0, $72NmR.default)({}, saferRest, {
        componentName: componentName || "button",
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $lL4Ma.default)([
            localRef,
            ref
        ]),
        xcss: (0, $gmylQ.cx)($0c35f0f595d2f583$var$styles.base, appearance === "default" && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $0c35f0f595d2f583$var$defaultStyles.rootRefreshed : $0c35f0f595d2f583$var$defaultStyles.root), appearance === "default" && isInteractive && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $0c35f0f595d2f583$var$defaultStyles.interactiveRefreshed : $0c35f0f595d2f583$var$defaultStyles.interactive), appearance === "primary" && $0c35f0f595d2f583$var$primaryStyles.root, appearance === "primary" && isInteractive && $0c35f0f595d2f583$var$primaryStyles.interactive, appearance === "warning" && $0c35f0f595d2f583$var$warningStyles.root, appearance === "warning" && isInteractive && $0c35f0f595d2f583$var$warningStyles.interactive, appearance === "danger" && $0c35f0f595d2f583$var$dangerStyles.root, appearance === "danger" && isInteractive && $0c35f0f595d2f583$var$dangerStyles.interactive, appearance === "discovery" && $0c35f0f595d2f583$var$discoveryStyles.root, appearance === "discovery" && isInteractive && $0c35f0f595d2f583$var$discoveryStyles.interactive, appearance === "subtle" && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $0c35f0f595d2f583$var$subtleStyles.rootRefreshed : $0c35f0f595d2f583$var$subtleStyles.root), appearance === "subtle" && isInteractive && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $0c35f0f595d2f583$var$subtleStyles.interactiveRefreshed : $0c35f0f595d2f583$var$subtleStyles.interactive), $0c35f0f595d2f583$var$styles.linkDecorationUnset, isSelected && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $0c35f0f595d2f583$var$selectedStyles.rootRefreshed : $0c35f0f595d2f583$var$selectedStyles.root), isSelected && isSplitButton && $0c35f0f595d2f583$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $0c35f0f595d2f583$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "danger" && $0c35f0f595d2f583$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "warning" && $0c35f0f595d2f583$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "discovery" && $0c35f0f595d2f583$var$selectedStyles.discovery, isDisabled && $0c35f0f595d2f583$var$styles.disabled, isCircle && !isSplitButton && $0c35f0f595d2f583$var$styles.circle, spacing === "compact" && $0c35f0f595d2f583$var$styles.spacingCompact, hasIconBefore && $0c35f0f595d2f583$var$styles.buttonIconBefore, shouldFitContainer && $0c35f0f595d2f583$var$styles.fullWidth, hasIconAfter && $0c35f0f595d2f583$var$styles.buttonIconAfter, isIconButton && $0c35f0f595d2f583$var$styles.iconButton, isIconButton && spacing === "compact" && $0c35f0f595d2f583$var$styles.iconButtonCompact, isLoading && $0c35f0f595d2f583$var$styles.loading, isSplitButton && $0c35f0f595d2f583$var$styles.splitButton, isNavigationSplitButton && $0c35f0f595d2f583$var$styles.navigationSplitButton),
        isDisabled: isEffectivelyDisabled,
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($0c35f0f595d2f583$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $9lekW.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2i2fk.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        className: (0, $8fP1t.default)([
            $0c35f0f595d2f583$var$styles.loadingOverlay
        ])
    }, (0, $5rIkq.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eTo1d.default), {
        id: loadingLabelId
    }, $0c35f0f595d2f583$var$LOADING_LABEL)));
});
var $0c35f0f595d2f583$export$2e2bcd8739ae039 = $0c35f0f595d2f583$var$ButtonBase;

});
parcelRegister("8fP1t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60274d7ac7956653$export$2e2bcd8739ae039; });
const $60274d7ac7956653$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $60274d7ac7956653$var$ATOMIC_GROUP_LENGTH = 5;
function $60274d7ac7956653$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $60274d7ac7956653$var$UNDERSCORE_UNICODE ? $60274d7ac7956653$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("2rRcm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c875e7a6748cdf3$export$2e2bcd8739ae039; });
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $72NmR = parcelRequire("72NmR");

var $cJhvT = parcelRequire("cJhvT");

var $iSvIT = parcelRequire("iSvIT");


var $iSupW = parcelRequire("iSupW");

var $1OPAa = parcelRequire("1OPAa");

var $fxRez = parcelRequire("fxRez");

var $4OZuI = parcelRequire("4OZuI");

var $7nG8r = parcelRequire("7nG8r");

var $ad8Y3 = parcelRequire("ad8Y3");
var $1c875e7a6748cdf3$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $1c875e7a6748cdf3$var$_excluded2 = [
    "className"
];
var $1c875e7a6748cdf3$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $1c875e7a6748cdf3$var$Pressable = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $4OZuI.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, $cJhvT.default)(_ref, $1c875e7a6748cdf3$var$_excluded);
    var interactionContext = (0, $iSvIT.useContext)((0, $7nG8r.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $1OPAa.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.8.0",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $cJhvT.default)(htmlAttributes, $1c875e7a6748cdf3$var$_excluded2);
    return /*#__PURE__*/ $iSvIT.createElement((0, $ad8Y3.default), (0, $72NmR.default)({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $fxRez.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $iSupW.cx)($1c875e7a6748cdf3$var$styles.root, isDisabled && $1c875e7a6748cdf3$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $1c875e7a6748cdf3$export$2e2bcd8739ae039 = $1c875e7a6748cdf3$var$Pressable;

});
parcelRegister("iSupW", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $dbe4dd62d3d356c9$export$a274e22fb40f762e; });

var $8fP1t = parcelRequire("8fP1t");
const $dbe4dd62d3d356c9$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $8fP1t.default)(actualStyles);
};

});

parcelRegister("1OPAa", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $153279223e414a41$export$a4687b0234b40e28; });

var $dP3BU = parcelRequire("dP3BU");

var $iSvIT = parcelRequire("iSvIT");

var $k5Bsf = parcelRequire("k5Bsf");

var $k55JW = parcelRequire("k55JW");
function $153279223e414a41$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $153279223e414a41$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $153279223e414a41$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dP3BU.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $153279223e414a41$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $153279223e414a41$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $k5Bsf.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $k55JW.useTrackedRef)(analyticsData);
    var fnRef = (0, $k55JW.useTrackedRef)(fn);
    var handler = (0, $iSvIT.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $153279223e414a41$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("dP3BU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a102d6c213982e57$export$2e2bcd8739ae039; });

var $i0z7F = parcelRequire("i0z7F");
function $a102d6c213982e57$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $i0z7F.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("i0z7F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1c378ba6144e676$export$2e2bcd8739ae039; });

var $dldEl = parcelRequire("dldEl");

var $99rB8 = parcelRequire("99rB8");
function $d1c378ba6144e676$export$2e2bcd8739ae039(t) {
    var i = (0, $99rB8.default)(t, "string");
    return "symbol" == (0, $dldEl.default)(i) ? i : i + "";
}

});
parcelRegister("dldEl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b67d319c0855535$export$2e2bcd8739ae039; });
function $9b67d319c0855535$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $9b67d319c0855535$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9b67d319c0855535$export$2e2bcd8739ae039(o);
}

});

parcelRegister("99rB8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a9a5cb606e8b590$export$2e2bcd8739ae039; });

var $dldEl = parcelRequire("dldEl");
function $6a9a5cb606e8b590$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $dldEl.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $dldEl.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("k5Bsf", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $ea0153f6bfa9bb46$export$5bf35293e545f20c; });

var $6LIwV = parcelRequire("6LIwV");

var $1gW2N = parcelRequire("1gW2N");

var $5CAGV = parcelRequire("5CAGV");
function $ea0153f6bfa9bb46$export$5bf35293e545f20c() {
    var analyticsContext = (0, $5CAGV.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $6LIwV.useCallbackOne)(function(payload) {
        return new (0, $1gW2N.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("1gW2N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ed44f683336b539$export$2e2bcd8739ae039; });

var $jgfgd = parcelRequire("jgfgd");

var $b1D3B = parcelRequire("b1D3B");

var $18fN8 = parcelRequire("18fN8");

var $9ap0A = parcelRequire("9ap0A");

var $4MjlJ = parcelRequire("4MjlJ");

var $k3Mua = parcelRequire("k3Mua");

var $e2uTX = parcelRequire("e2uTX");

var $dP3BU = parcelRequire("dP3BU");

var $4DozO = parcelRequire("4DozO");
function $0ed44f683336b539$var$_callSuper(t, o, e) {
    return o = (0, $4MjlJ.default)(o), (0, $9ap0A.default)(t, $0ed44f683336b539$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $4MjlJ.default)(t).constructor) : o.apply(t, e));
}
function $0ed44f683336b539$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0ed44f683336b539$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $0ed44f683336b539$var$_superPropGet(t, o, e, r) {
    var p = (0, $k3Mua.default)((0, $4MjlJ.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $0ed44f683336b539$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $0ed44f683336b539$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $0ed44f683336b539$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $b1D3B.default)(this, UIAnalyticsEvent);
        _this = $0ed44f683336b539$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $dP3BU.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $dP3BU.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $jgfgd.default)(_this.context);
            var handlers = (0, $jgfgd.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $dP3BU.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $e2uTX.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $18fN8.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $0ed44f683336b539$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $4DozO.default));

});
parcelRegister("jgfgd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e05b5959581d2392$export$2e2bcd8739ae039; });

var $2CKEd = parcelRequire("2CKEd");

var $bXzdY = parcelRequire("bXzdY");

var $it1kQ = parcelRequire("it1kQ");

var $dZsFm = parcelRequire("dZsFm");
function $e05b5959581d2392$export$2e2bcd8739ae039(r) {
    return (0, $2CKEd.default)(r) || (0, $bXzdY.default)(r) || (0, $it1kQ.default)(r) || (0, $dZsFm.default)();
}

});
parcelRegister("2CKEd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e93509ff8d63640$export$2e2bcd8739ae039; });

var $dOo4n = parcelRequire("dOo4n");
function $1e93509ff8d63640$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $dOo4n.default)(r);
}

});
parcelRegister("dOo4n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0e29d9b462432ea$export$2e2bcd8739ae039; });
function $a0e29d9b462432ea$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("bXzdY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b50873e16f82ca4$export$2e2bcd8739ae039; });
function $8b50873e16f82ca4$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("it1kQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d71bf89229499e6d$export$2e2bcd8739ae039; });

var $dOo4n = parcelRequire("dOo4n");
function $d71bf89229499e6d$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $dOo4n.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $dOo4n.default)(r, a) : void 0;
    }
}

});

parcelRegister("dZsFm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2f73556a46ddb4f$export$2e2bcd8739ae039; });
function $a2f73556a46ddb4f$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("b1D3B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $806e159c06770daf$export$2e2bcd8739ae039; });
function $806e159c06770daf$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("18fN8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d32c9af86537399$export$2e2bcd8739ae039; });

var $i0z7F = parcelRequire("i0z7F");
function $0d32c9af86537399$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $i0z7F.default)(o.key), o);
    }
}
function $0d32c9af86537399$export$2e2bcd8739ae039(e, r, t) {
    return r && $0d32c9af86537399$var$_defineProperties(e.prototype, r), t && $0d32c9af86537399$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("9ap0A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ac8726054d5c40e$export$2e2bcd8739ae039; });

var $dldEl = parcelRequire("dldEl");

var $a36le = parcelRequire("a36le");
function $6ac8726054d5c40e$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $dldEl.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $a36le.default)(t);
}

});
parcelRegister("a36le", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $750f1a7bf4aa3f3b$export$2e2bcd8739ae039; });
function $750f1a7bf4aa3f3b$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("4MjlJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37aaa785fd73773d$export$2e2bcd8739ae039; });
function $37aaa785fd73773d$export$2e2bcd8739ae039(t) {
    return $37aaa785fd73773d$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $37aaa785fd73773d$export$2e2bcd8739ae039(t);
}

});

parcelRegister("k3Mua", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9a9b2acee5e1cb1$export$2e2bcd8739ae039; });

var $4UMBW = parcelRequire("4UMBW");
function $e9a9b2acee5e1cb1$export$2e2bcd8739ae039() {
    return $e9a9b2acee5e1cb1$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $4UMBW.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $e9a9b2acee5e1cb1$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("4UMBW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39421985f104f14f$export$2e2bcd8739ae039; });

var $4MjlJ = parcelRequire("4MjlJ");
function $39421985f104f14f$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $4MjlJ.default)(t)););
    return t;
}

});


parcelRegister("e2uTX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a389390489c906c6$export$2e2bcd8739ae039; });

var $cDpSB = parcelRequire("cDpSB");
function $a389390489c906c6$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $cDpSB.default)(t, e);
}

});
parcelRegister("cDpSB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $932d33bb87c2c478$export$2e2bcd8739ae039; });
function $932d33bb87c2c478$export$2e2bcd8739ae039(t, e) {
    return $932d33bb87c2c478$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $932d33bb87c2c478$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("4DozO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35fdde594ed62dfb$export$2e2bcd8739ae039; });

var $dldEl = parcelRequire("dldEl");

var $b1D3B = parcelRequire("b1D3B");

var $18fN8 = parcelRequire("18fN8");

var $dP3BU = parcelRequire("dP3BU");
function $35fdde594ed62dfb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $35fdde594ed62dfb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $35fdde594ed62dfb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dP3BU.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $35fdde594ed62dfb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $35fdde594ed62dfb$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $35fdde594ed62dfb$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $35fdde594ed62dfb$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $b1D3B.default)(this, AnalyticsEvent);
        (0, $dP3BU.default)(this, "_isAnalyticsEvent", true);
        (0, $dP3BU.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $35fdde594ed62dfb$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $18fN8.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, $dldEl.default)(updater) === "object") this.payload = $35fdde594ed62dfb$var$_objectSpread($35fdde594ed62dfb$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("5CAGV", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $417cf67a62041f86$export$d1f587f82ad51c4; });

var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");
var $417cf67a62041f86$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $iSvIT.useContext)((0, $lEO1D.default));
};

});


parcelRegister("k55JW", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $e9e8ba225b8658da$export$1d27a74659855e44; });

var $iSvIT = parcelRequire("iSvIT");
var $e9e8ba225b8658da$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $iSvIT.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("ad8Y3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76f2130a15a45e85$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $72NmR = parcelRequire("72NmR");

var $dP3BU = parcelRequire("dP3BU");

var $cJhvT = parcelRequire("cJhvT");

var $iSvIT = parcelRequire("iSvIT");

var $8fP1t = parcelRequire("8fP1t");
var $iyj5N = parcelRequire("iyj5N");
var $76f2130a15a45e85$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $76f2130a15a45e85$var$_excluded2 = [
    "className"
];
function $76f2130a15a45e85$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $76f2130a15a45e85$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $76f2130a15a45e85$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dP3BU.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $76f2130a15a45e85$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $76f2130a15a45e85$var$focusRingStyles = null;
var $76f2130a15a45e85$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $76f2130a15a45e85$var$Focusable = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "button" : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $cJhvT.default)(_ref, $76f2130a15a45e85$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $cJhvT.default)(htmlAttributes, $76f2130a15a45e85$var$_excluded2);
    return /*#__PURE__*/ $iSvIT.createElement(Component, (0, $72NmR.default)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $8fP1t.default)([
            "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y",
            isInset && "_1ah3115h _2mwq115h",
            xcss
        ]),
        "data-testid": testId,
        style: $76f2130a15a45e85$var$_objectSpread($76f2130a15a45e85$var$_objectSpread({}, style), {}, {
            "--_1203r2w": (0, $iyj5N.default)("calc(0px - ".concat("var(--ds-border-width-outline, 2px)", ")"))
        })
    }), children);
});
var $76f2130a15a45e85$export$2e2bcd8739ae039 = $76f2130a15a45e85$var$Focusable;

});
parcelRegister("iyj5N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d81a365bd67ded07$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $d81a365bd67ded07$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});



parcelRegister("eTo1d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad78d55b7d6a0bec$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden

var $iSvIT = parcelRequire("iSvIT");

var $gKst0 = parcelRequire("gKst0");
var $ad78d55b7d6a0bec$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $ad78d55b7d6a0bec$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $gKst0.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ])
    }, children);
};
var $ad78d55b7d6a0bec$export$2e2bcd8739ae039 = $ad78d55b7d6a0bec$var$VisuallyHidden;

});
parcelRegister("gKst0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3170623079a860a$export$2e2bcd8739ae039; });
const $c3170623079a860a$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $c3170623079a860a$var$ATOMIC_GROUP_LENGTH = 5;
function $c3170623079a860a$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $c3170623079a860a$var$UNDERSCORE_UNICODE ? $c3170623079a860a$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});


parcelRegister("2i2fk", function(module, exports) {

$parcel$export(module.exports, "SplitButtonContext", function () { return $1aaf014670118ed6$export$4b86304b2c0d7e71; });
$parcel$export(module.exports, "useSplitButtonContext", function () { return $1aaf014670118ed6$export$47e2c6fdb142d947; });

var $iSvIT = parcelRequire("iSvIT");
var $1aaf014670118ed6$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $iSvIT.createContext)(undefined);
var $1aaf014670118ed6$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $iSvIT.useContext)($1aaf014670118ed6$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === "navigation") {
        var newContext = {
            spacing: "default",
            appearance: "subtle",
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("9lekW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cd132358d836558$export$2e2bcd8739ae039; });
function $6cd132358d836558$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $6cd132358d836558$var$tabKeyCode = 9;
function $6cd132358d836558$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $6cd132358d836558$var$tabKeyCode) return;
    $6cd132358d836558$var$abort(event);
}
function $6cd132358d836558$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $6cd132358d836558$var$abort,
        onMouseUpCapture: $6cd132358d836558$var$abort,
        onKeyDownCapture: $6cd132358d836558$var$onKey,
        onKeyUpCapture: $6cd132358d836558$var$onKey,
        onTouchStartCapture: $6cd132358d836558$var$abort,
        onTouchEndCapture: $6cd132358d836558$var$abort,
        onPointerDownCapture: $6cd132358d836558$var$abort,
        onPointerUpCapture: $6cd132358d836558$var$abort,
        onClickCapture: $6cd132358d836558$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $6cd132358d836558$var$abort
    } : events;
}

});

parcelRegister("5rIkq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f71dc1866f7c5a9$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $efFUG = parcelRequire("efFUG");
function $3f71dc1866f7c5a9$var$getIconSpacing(spacing) {
    switch(spacing){
        case "compact":
            return "small";
        default:
            return "medium";
    }
}
function $3f71dc1866f7c5a9$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return "inherit";
    if (appearance === "primary" || appearance === "danger" || appearance === "discovery") return "invert";
    return "inherit";
}
function $3f71dc1866f7c5a9$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $efFUG.default), {
        size: $3f71dc1866f7c5a9$var$getIconSpacing(spacing),
        appearance: $3f71dc1866f7c5a9$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("efFUG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a602fa79da67b6ca$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hfd70 = parcelRequire("hfd70");

var $iSvIT = parcelRequire("iSvIT");

var $7nG8r = parcelRequire("7nG8r");

var $6NCsh = parcelRequire("6NCsh");

var $bvKnA = parcelRequire("bvKnA");
/**
 * Returns the appropriate circle stroke color.
 */ function $a602fa79da67b6ca$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $6NCsh.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $6NCsh.N0), ")");
}
var $a602fa79da67b6ca$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $a602fa79da67b6ca$var$loadIn = null;
var $a602fa79da67b6ca$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $a602fa79da67b6ca$var$useLayoutEffect = typeof window === "undefined" ? (0, $iSvIT.useEffect) : (0, $iSvIT.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $a602fa79da67b6ca$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $bvKnA.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $a602fa79da67b6ca$var$getStrokeColor(appearance);
    var context = (0, $iSvIT.useContext)((0, $7nG8r.default));
    $a602fa79da67b6ca$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $hfd70.default)([
            $a602fa79da67b6ca$var$styles.wrapperStyles,
            $a602fa79da67b6ca$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $hfd70.default)([
            $a602fa79da67b6ca$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $hfd70.default)([
            $a602fa79da67b6ca$var$styles.circleStyles
        ])
    })));
}));
var $a602fa79da67b6ca$export$2e2bcd8739ae039 = $a602fa79da67b6ca$var$Spinner;

});
parcelRegister("hfd70", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8de022614a8e617$export$2e2bcd8739ae039; });
const $c8de022614a8e617$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $c8de022614a8e617$var$ATOMIC_GROUP_LENGTH = 5;
function $c8de022614a8e617$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $c8de022614a8e617$var$UNDERSCORE_UNICODE ? $c8de022614a8e617$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("6NCsh", function(module, exports) {

$parcel$export(module.exports, "N0", function () { return $4f35260efcc26874$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $4f35260efcc26874$export$c39c0fe0f26207ae; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $4f35260efcc26874$export$4b84fd0e2c617bd = "#FFEBE6";
var $4f35260efcc26874$export$b34b069eff244586 = "#FFBDAD";
var $4f35260efcc26874$export$be802dd0d8b57f35 = "#FF8F73";
var $4f35260efcc26874$export$60847d42f9da92a6 = "#FF7452";
var $4f35260efcc26874$export$4a7404f376229999 = "#FF5630";
var $4f35260efcc26874$export$2010d0fb4295b346 = "#DE350B";
var $4f35260efcc26874$export$2837b5a1a71d5c02 = "#BF2600";
var $4f35260efcc26874$export$8d9596b529bbb9cf = "#FFFAE6";
var $4f35260efcc26874$export$41060a744ab0b7ae = "#FFF0B3";
var $4f35260efcc26874$export$1cc05bbbf340e559 = "#FFE380";
var $4f35260efcc26874$export$5aae31392d72caaa = "#FFC400";
var $4f35260efcc26874$export$c6930421db9fa514 = "#FFAB00";
var $4f35260efcc26874$export$59619663aa6500fb = "#FF991F";
var $4f35260efcc26874$export$874739ea9e379ab6 = "#FF8B00";
var $4f35260efcc26874$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $4f35260efcc26874$export$69a3bf21b9686c2b = "#ABF5D1";
var $4f35260efcc26874$export$afbce1382ec95f73 = "#79F2C0";
var $4f35260efcc26874$export$747d86715d4175de = "#57D9A3";
var $4f35260efcc26874$export$940e1f69e873f202 = "#36B37E";
var $4f35260efcc26874$export$a49394138f7b8e85 = "#00875A";
var $4f35260efcc26874$export$6fa04827ac68a4fb = "#006644";
var $4f35260efcc26874$export$226de0355ed012f8 = "#DEEBFF";
var $4f35260efcc26874$export$8c13c2ee36917869 = "#B3D4FF";
var $4f35260efcc26874$export$ecfc1dff386a3e7a = "#4C9AFF";
var $4f35260efcc26874$export$215b7063051591f1 = "#2684FF";
var $4f35260efcc26874$export$e62e8919cca44969 = "#0065FF";
var $4f35260efcc26874$export$b3de0ae08da2ce64 = "#0052CC";
var $4f35260efcc26874$export$a6ee3d71bc067634 = "#0747A6";
var $4f35260efcc26874$export$67f15409e87642a1 = "#669DF1";
var $4f35260efcc26874$export$f0539dbc42dbb067 = "#8FB8F6";
var $4f35260efcc26874$export$363e4475840015bb = "#EAE6FF";
var $4f35260efcc26874$export$4b0a4417ed59760f = "#C0B6F2";
var $4f35260efcc26874$export$6011520a64d9a187 = "#998DD9";
var $4f35260efcc26874$export$a7175d4e9206bc80 = "#8777D9";
var $4f35260efcc26874$export$b48405b95304b5a1 = "#6554C0";
var $4f35260efcc26874$export$c71e4279dd54a18d = "#5243AA";
var $4f35260efcc26874$export$147899de772240ec = "#403294";
var $4f35260efcc26874$export$2cf711fe14c66f06 = "#E6FCFF";
var $4f35260efcc26874$export$7a8f4d33f6f9772c = "#B3F5FF";
var $4f35260efcc26874$export$776c9c497ef08533 = "#79E2F2";
var $4f35260efcc26874$export$69cb3ca10c1e330e = "#00C7E6";
var $4f35260efcc26874$export$9dc1ef0f3f48059b = "#00B8D9";
var $4f35260efcc26874$export$7c835c78b6fcdef8 = "#00A3BF";
var $4f35260efcc26874$export$6036577f95c3877e = "#008DA6";
var $4f35260efcc26874$export$29a4f05edc054374 = "#FFFFFF";
var $4f35260efcc26874$export$e655ef011c4aa1a2 = "#FAFBFC";
var $4f35260efcc26874$export$9fdfb749e33cdf97 = "#F4F5F7";
var $4f35260efcc26874$export$3e51e8f1440314ba = "#EBECF0";
var $4f35260efcc26874$export$1ce2d1575d444ceb = "#DFE1E6";
var $4f35260efcc26874$export$8754fc7e6d8b3000 = "#C1C7D0";
var $4f35260efcc26874$export$c2e91cbeada39b8b = "#B3BAC5";
var $4f35260efcc26874$export$5f71e19f3a7ad9de = "#A5ADBA";
var $4f35260efcc26874$export$eaa8c8a70ac22806 = "#97A0AF";
var $4f35260efcc26874$export$7c87d337fb91a97d = "#8993A4";
var $4f35260efcc26874$export$d6447c357493214f = "#7A869A";
var $4f35260efcc26874$export$f563ee71e9ee74cd = "#6B778C";
var $4f35260efcc26874$export$e2ef2124cf4024b1 = "#5E6C84";
var $4f35260efcc26874$export$eece5f492e429f08 = "#505F79";
var $4f35260efcc26874$export$c39c0fe0f26207ae = "#42526E";
var $4f35260efcc26874$export$7090862dc3038a9f = "#344563";
var $4f35260efcc26874$export$ad0bacf983b7ddaa = "#253858";
var $4f35260efcc26874$export$7d61b15e0da132af = "#172B4D";
var $4f35260efcc26874$export$fbda843f0a27fe96 = "#091E42";
var $4f35260efcc26874$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $4f35260efcc26874$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $4f35260efcc26874$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $4f35260efcc26874$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $4f35260efcc26874$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $4f35260efcc26874$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $4f35260efcc26874$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $4f35260efcc26874$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $4f35260efcc26874$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $4f35260efcc26874$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $4f35260efcc26874$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $4f35260efcc26874$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $4f35260efcc26874$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $4f35260efcc26874$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $4f35260efcc26874$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $4f35260efcc26874$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $4f35260efcc26874$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $4f35260efcc26874$export$2f6319cf7d736c2a = "#E6EDFA";
var $4f35260efcc26874$export$95126bc8884d6634 = "#DCE5F5";
var $4f35260efcc26874$export$8338d8c35d44ff1 = "#CED9EB";
var $4f35260efcc26874$export$5368d76ae4fbbda7 = "#B8C7E0";
var $4f35260efcc26874$export$9f0a771d16ec8d36 = "#ABBBD6";
var $4f35260efcc26874$export$abcf8c38338b4aa5 = "#9FB0CC";
var $4f35260efcc26874$export$97e81faa16a182c7 = "#8C9CB8";
var $4f35260efcc26874$export$bfe21c59123ecf33 = "#7988A3";
var $4f35260efcc26874$export$ee82aa2ea6a1558 = "#67758F";
var $4f35260efcc26874$export$682927c6ed76be02 = "#56637A";
var $4f35260efcc26874$export$91fd9994c5be9757 = "#455166";
var $4f35260efcc26874$export$d281fbfe3cff2df6 = "#3B475C";
var $4f35260efcc26874$export$3902c91d8b98a753 = "#313D52";
var $4f35260efcc26874$export$8e8133c1ba5845b5 = "#283447";
var $4f35260efcc26874$export$33ff357f6620b39 = "#202B3D";
var $4f35260efcc26874$export$633847cf062b69e0 = "#1B2638";
var $4f35260efcc26874$export$9776a6e503bdbf76 = "#121A29";
var $4f35260efcc26874$export$6c813d5160dff5db = "#0E1624";
var $4f35260efcc26874$export$3d4f271a500072a = "#0D1424";
var $4f35260efcc26874$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $4f35260efcc26874$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $4f35260efcc26874$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $4f35260efcc26874$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $4f35260efcc26874$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $4f35260efcc26874$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $4f35260efcc26874$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $4f35260efcc26874$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $4f35260efcc26874$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $4f35260efcc26874$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $4f35260efcc26874$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $4f35260efcc26874$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $4f35260efcc26874$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $4f35260efcc26874$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $4f35260efcc26874$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $4f35260efcc26874$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $4f35260efcc26874$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $4f35260efcc26874$export$d2adc5dedf09fced = "#292A2E";
var $4f35260efcc26874$export$f51762073d2bb381 = "#94C748";
var $4f35260efcc26874$export$95e26d54def96891 = "#B3DF72";

});

parcelRegister("bvKnA", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $861690f6931162cb$export$4e9f1640bbe7a1a8; });
var $861690f6931162cb$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("MIq2I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0926f081bc351187$export$2e2bcd8739ae039; });
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8fP1t = parcelRequire("8fP1t");

var $iSvIT = parcelRequire("iSvIT");
var $0926f081bc351187$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $0926f081bc351187$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? "text" : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        className: (0, $8fP1t.default)([
            $0926f081bc351187$var$styles.common,
            type === "text" && $0926f081bc351187$var$styles.text,
            type === "icon" && $0926f081bc351187$var$styles.icon,
            isLoading && $0926f081bc351187$var$styles.fade,
            position === "before" && $0926f081bc351187$var$styles.beforeIcon,
            position === "after" && $0926f081bc351187$var$styles.afterIcon
        ])
    }, children);
};
var $0926f081bc351187$export$2e2bcd8739ae039 = $0926f081bc351187$var$Content;

});

parcelRegister("kMg75", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f204ca20b8d3f120$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
function $f204ca20b8d3f120$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === "function" // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $f204ca20b8d3f120$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, $f204ca20b8d3f120$var$isIconRenderProp(Icon) ? Icon({
        label: "",
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Icon, {
        label: "",
        color: "currentColor"
    }));
};
var $f204ca20b8d3f120$export$2e2bcd8739ae039 = $f204ca20b8d3f120$var$IconRenderer;

});

parcelRegister("6k5Ux", function(module, exports) {

$parcel$export(module.exports, "CloseModalButton", function () { return $b6c7a5686eb9158d$export$33330c88045ecd2e; });
/* close-modal-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f448m = parcelRequire("f448m");

var $lyYco = parcelRequire("lyYco");
const $b6c7a5686eb9158d$var$closeModalButtonStyles = null;
const $b6c7a5686eb9158d$export$33330c88045ecd2e = ({ forwardRef: forwardRef, onCloseClick: onCloseClick, styleOverrides: styleOverrides })=>{
    const [messages] = (0, $lyYco.useMessages)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
        "data-testid": "closeModalBtn",
        "aria-label": messages.createIssueModalCloseBtn,
        style: styleOverrides,
        id: "createIssueModalCloseBtn",
        onClick: onCloseClick,
        ref: forwardRef,
        className: (0, $esG4f.default)([
            "_1bsb1ul9 _4t3i1ul9 _bfhk1j28 _19itglyw _1e0c1txw _1bah1h6o _4cvr1h6o _2rko1sit _80omtlke _v564fnf5 _vbqb1lg7 _jomr1f0r _irr31f0r"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f448m))), {
            label: "",
            size: "medium"
        })
    });
};

});
parcelRegister("lyYco", function(module, exports) {

$parcel$export(module.exports, "useMessages", function () { return $84c26da1c748a082$export$4d17e2d9c5348842; });
$parcel$export(module.exports, "useInteractiveBoardStore", function () { return $84c26da1c748a082$export$1953ec6382166e6d; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $4ejMU = parcelRequire("4ejMU");
var $ij7wO = parcelRequire("ij7wO");

var $ilpFV = parcelRequire("ilpFV");

var $575p2 = parcelRequire("575p2");
const $84c26da1c748a082$var$initialState = {
    step: (0, $575p2.Steps).CREATE_FIRST_STORY,
    isCreateButtonFocused: false,
    isDemoComplete: false,
    isTicketModalOpen: false,
    isDemoCompleteModalOpen: false,
    isDemoMessageVisible: true,
    todoCol: [],
    inProgressCol: [
        {
            id: "inProg1",
            summary: (0, $ilpFV.messages).inProgStaticLabel1,
            issueType: (0, $575p2.IssueTypeName).STORY,
            epicName: (0, $575p2.EpicName).FEATURES,
            assignee: (0, $575p2.Assignee).JANE,
            priority: (0, $575p2.Priority).BLOCKER
        },
        {
            id: "inProg2",
            summary: (0, $ilpFV.messages).inProgStaticLabel2,
            issueType: (0, $575p2.IssueTypeName).STORY,
            epicName: (0, $575p2.EpicName).FEATURES,
            assignee: (0, $575p2.Assignee).BLAKE,
            priority: (0, $575p2.Priority).HIGH
        }
    ],
    doneCol: [
        {
            id: "done1",
            summary: (0, $ilpFV.messages).doneStaticLabel1,
            issueType: (0, $575p2.IssueTypeName).BUG,
            epicName: (0, $575p2.EpicName).FEATURES,
            assignee: (0, $575p2.Assignee).ALVIN,
            priority: (0, $575p2.Priority).MINOR
        },
        {
            id: "done2",
            summary: (0, $ilpFV.messages).doneStaticLabel2,
            issueType: (0, $575p2.IssueTypeName).TASK,
            epicName: (0, $575p2.EpicName).FEATURES,
            assignee: (0, $575p2.Assignee).JANE,
            priority: (0, $575p2.Priority).CRITICAL
        }
    ],
    messages: (0, $ilpFV.messages),
    animateCardExit: false
};
const $84c26da1c748a082$var$actions = {
    completeDemo: ()=>({ setState: setState })=>{
            setState({
                isDemoComplete: true,
                isDemoMessageVisible: false,
                step: undefined
            });
        },
    createIssue: (jiraIssueData)=>({ setState: setState, getState: getState })=>{
            const { todoCol: todoCol } = getState();
            const todoColAppend = todoCol.concat([
                jiraIssueData
            ]);
            setState({
                todoCol: todoColAppend
            });
        },
    nextDemoStep: ()=>({ setState: setState, getState: getState })=>{
            const { step: step } = getState();
            if (step === (0, $575p2.stepsLength) - 1) {
                console.error("Error: cannot goto next message, currently on final message");
                return;
            }
            setState({
                step: step + 1,
                isDemoMessageVisible: true,
                animateCardExit: false
            });
        },
    prevDemoStep: ()=>({ setState: setState, getState: getState })=>{
            const { step: step } = getState();
            if (step === 0) {
                console.error("Error: cannot goto prev message, currently on first message");
                return;
            }
            setState({
                step: step - 1,
                isDemoMessageVisible: true
            });
        },
    restartDemo: ()=>({ setState: setState, getState: getState })=>{
            const { messages: messages, inProgressCol: inProgressCol, doneCol: doneCol } = getState();
            setState((0, $6iHNw._)((0, $7Knp0._)({}, $84c26da1c748a082$var$initialState), {
                messages: messages,
                inProgressCol: inProgressCol,
                doneCol: doneCol,
                isCreateButtonFocused: true
            }));
        },
    resetIncompleteDemo: ()=>({ setState: setState })=>{
            setState({
                step: (0, $575p2.Steps).CREATE_FIRST_STORY,
                isDemoMessageVisible: true
            });
        },
    setTodoCol: (colInfo)=>({ setState: setState })=>{
            setState({
                todoCol: colInfo
            });
        },
    setDoneCol: (colInfo)=>({ setState: setState })=>{
            setState({
                doneCol: colInfo
            });
        },
    setInProgressCol: (colInfo)=>({ setState: setState })=>{
            setState({
                inProgressCol: colInfo
            });
        },
    setDemoStep: (step)=>({ setState: setState })=>{
            setState({
                step: step
            });
        },
    toggleCompleteDemoModalOpen: ()=>({ setState: setState, getState: getState })=>{
            const { isDemoCompleteModalOpen: prevStateIsModalOpen } = getState();
            setState({
                isCreateButtonFocused: prevStateIsModalOpen,
                isDemoCompleteModalOpen: !prevStateIsModalOpen
            });
        },
    setSpotlightVisibility: (visible)=>({ setState: setState })=>{
            setState({
                isDemoMessageVisible: visible
            });
        },
    toggleTicketModalOpen: ()=>({ setState: setState, getState: getState })=>{
            const { isTicketModalOpen: prevStateIsModalOpen } = getState();
            setState({
                isCreateButtonFocused: prevStateIsModalOpen,
                isTicketModalOpen: !prevStateIsModalOpen
            });
        },
    transitionCard: ()=>({ setState: setState })=>{
            setState({
                animateCardExit: true
            });
        }
};
const $84c26da1c748a082$var$InteractiveBoardStore = (0, $ij7wO.createStore)({
    initialState: $84c26da1c748a082$var$initialState,
    actions: $84c26da1c748a082$var$actions,
    name: "jsw-interactive-board-store"
});
const $84c26da1c748a082$var$getMessages = (state)=>state.messages;
const $84c26da1c748a082$export$4d17e2d9c5348842 = (0, $4ejMU.createHook)($84c26da1c748a082$var$InteractiveBoardStore, {
    selector: $84c26da1c748a082$var$getMessages
});
const $84c26da1c748a082$export$1953ec6382166e6d = (0, $4ejMU.createHook)($84c26da1c748a082$var$InteractiveBoardStore);

});
parcelRegister("ilpFV", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $cbdd78813a066596$export$defe85febe8b728c; });
const $cbdd78813a066596$export$defe85febe8b728c = {
    createIssueModalHeader: "Create issue",
    createIssueModalInput1Label: "Project",
    createIssueModalInput2Label: "Issue type",
    createIssueModalInput3Label: "Summary",
    createIssueModalInput3Placeholder: "Ex: Create a requirements doc",
    createIssueModalInput4Label: "Issue description",
    createIssueModalInput4Placeholder: "Add notes: \nWrite details here like receive final prototypes from design. \n \nAdd tasks: \nWrite necessary tasks to complete your project here.",
    createIssueModalInput5Label: "Priority",
    createIssueModalInput6Label: "Epic link",
    createIssueModalInput7Label: "Assignee",
    createIssueModalInput8Label: "Due date",
    createIssueModalProjectOption1: "Team Rocket",
    createIssueModalProjectAssetLabel1: "project team rocket",
    createIssueModalIssueTypeOption1: "Task",
    createIssueModalIssueTypeAssetLabel1: "Issue type: Task",
    createIssueModalIssueTypeOption2: "Story",
    createIssueModalIssueTypeAssetLabel2: "Issue type: Story",
    createIssueModalIssueTypeOption3: "Bug",
    createIssueModalIssueTypeAssetLabel3: "Issue type: Bug",
    createIssueModalAssigneeOption1: "Alvin",
    createIssueModalAssigneeAssetLabel1: "Assignee: Alvin",
    createIssueModalAssigneeOption2: "Jane",
    createIssueModalAssigneeAssetLabel2: "Assignee: Jane",
    createIssueModalAssigneeOption3: "Blake",
    createIssueModalAssigneeAssetLabel3: "Assignee: Blake",
    createIssueModalPriorityOption1: "High",
    createIssueModalPriorityAssetLabel1: "Priority: High",
    createIssueModalPriorityOption2: "Critical",
    createIssueModalPriorityAssetLabel2: "Priority: Critical",
    createIssueModalPriorityOption3: "Blocker",
    createIssueModalPriorityAssetLabel3: "Priority: Blocker",
    createIssueModalPriorityOption4: "Minor",
    createIssueModalPriorityAssetLabel4: "Priority: Minor",
    createIssueModalEpicLinkOption1: "Features",
    createIssueModalEpicLinkOption1Description: "APP-153",
    createIssueModalEpicLinkAssetLabel1: "Epic link: Features",
    createIssueModalEpicLinkOption2: "Analytics",
    createIssueModalEpicLinkOption2Description: "APP-154",
    createIssueModalEpicLinkAssetLabel2: "Epic link: Features",
    createIssueModalEpicLinkOption3: "Payments",
    createIssueModalEpicLinkOption3Description: "APP-155",
    createIssueModalEpicLinkAssetLabel3: "Epic link: Payments",
    createIssueModalSubmitBtn: "Create",
    createIssueModalCloseBtn: "Close modal",
    toDo: "To Do",
    inProgress: "In Progress",
    done: "Done",
    create: "Create",
    restartDemo: "Restart demo",
    avatarGroupAriaLabel: "Collection of user avatars showing team members",
    todoStaticLabel: "Design AI shopping suggestions for homepage",
    inProgStaticLabel1: "Create AI-generated shopping suggestions for homepage",
    inProgStaticLabel2: "Add advanced analytics tracking events",
    doneStaticLabel1: "Improve payment checkout time on mobile",
    doneStaticLabel2: "Define requirements to use new AI integrations",
    spotlightInitialCreateButtonHeading: "Let's set up your board",
    spotlightInitialCreateButtonDescription: "Kanban boards are great for project management. Select create to start tracking work that your team would like to do.",
    spotlightSelectIssueHeading: "Create an issue",
    spotlightSelectIssueDescription: "Issues are used to track work in Jira. Tasks, stories, and bugs are different types of issues. Select what type of issue you\u2019d like to create.",
    spotlightMoveIssueHeading: "Move your task to the board",
    spotlightMoveIssueDescription: `Now that you\u{2019}ve added all the info to your task. Select create to see your work on the \u{201C}To-do\u{201D} list.`,
    spotlightSummaryHeading: "Tell us about your work",
    spotlightSummaryDescription: "Summarize your to-do in a few words. It can be anything, like complete mobile app designs or developing a new feature.",
    spotlightAddDescriptionHeading: "Provide useful details",
    spotlightAddDescriptionDescription: "Add any important information about the work that\u2019s needed to move it forward.",
    spotlightSelectPriorityHeading: "Prioritize your task",
    spotlightSelectPriorityDescription: "Choose the importance of a task to change how it appears on the board. Select a level of priority to identify this task at a glance.",
    spotlightSelectEpicLinkHeading: "Connect work to larger projects",
    spotlightSelectEpicLinkDescription: "You can connect this issue to longer term projects. This will help your team plan accurately.",
    staticSpotlightHeading: "Expand your screen size to use this demo",
    successModalHeading: "Congrats, you\u2019ve made your first issue!",
    successModalDescription: "You\u2019ve taken the first step towards streamlined collaboration and task tracking. Get started for free using the project management template in Jira.",
    successModalCtaButton: "Get it free"
};

});

parcelRegister("575p2", function(module, exports) {

$parcel$export(module.exports, "Steps", function () { return $e073124ced5a2b69$export$fb587a27d5a722e7; });
$parcel$export(module.exports, "IssueTypeName", function () { return $e073124ced5a2b69$export$41bec0868bbe9664; });
$parcel$export(module.exports, "EpicName", function () { return $e073124ced5a2b69$export$82af5b919cf981f7; });
$parcel$export(module.exports, "Assignee", function () { return $e073124ced5a2b69$export$361f73eba39649ac; });
$parcel$export(module.exports, "Priority", function () { return $e073124ced5a2b69$export$300334f671c43555; });
$parcel$export(module.exports, "stepsLength", function () { return $e073124ced5a2b69$export$33096039fd990cf4; });
var $e073124ced5a2b69$export$fb587a27d5a722e7;
(function(Steps) {
    Steps[Steps["CREATE_FIRST_STORY"] = 0] = "CREATE_FIRST_STORY";
    Steps[Steps["SELECT_ISSUE_TYPE"] = 1] = "SELECT_ISSUE_TYPE";
    Steps[Steps["ADD_SUMMARY"] = 2] = "ADD_SUMMARY";
    Steps[Steps["ADD_DESCRIPTION"] = 3] = "ADD_DESCRIPTION";
    Steps[Steps["SELECT_PRIORITY"] = 4] = "SELECT_PRIORITY";
    Steps[Steps["SELECT_EPIC_LINK"] = 5] = "SELECT_EPIC_LINK";
    Steps[Steps["MOVE_ISSUE"] = 6] = "MOVE_ISSUE";
    Steps[Steps["PULSE_CARD"] = 7] = "PULSE_CARD";
})($e073124ced5a2b69$export$fb587a27d5a722e7 || ($e073124ced5a2b69$export$fb587a27d5a722e7 = {}));
var $e073124ced5a2b69$export$b6032183171af19f;
(function(Project) {
    Project["TeamRocket"] = "team-rocket";
})($e073124ced5a2b69$export$b6032183171af19f || ($e073124ced5a2b69$export$b6032183171af19f = {}));
var $e073124ced5a2b69$export$41bec0868bbe9664;
(function(IssueTypeName) {
    IssueTypeName["TASK"] = "task";
    IssueTypeName["STORY"] = "story";
    IssueTypeName["BUG"] = "bug";
})($e073124ced5a2b69$export$41bec0868bbe9664 || ($e073124ced5a2b69$export$41bec0868bbe9664 = {}));
var $e073124ced5a2b69$export$82af5b919cf981f7;
(function(EpicName) {
    EpicName["FEATURES"] = "features";
    EpicName["ANALYTICS"] = "analytics";
    EpicName["PAYMENTS"] = "payments";
})($e073124ced5a2b69$export$82af5b919cf981f7 || ($e073124ced5a2b69$export$82af5b919cf981f7 = {}));
var $e073124ced5a2b69$export$361f73eba39649ac;
(function(Assignee) {
    Assignee["ALVIN"] = "alvin";
    Assignee["JANE"] = "jane";
    Assignee["BLAKE"] = "blake";
})($e073124ced5a2b69$export$361f73eba39649ac || ($e073124ced5a2b69$export$361f73eba39649ac = {}));
var $e073124ced5a2b69$export$300334f671c43555;
(function(Priority) {
    Priority["HIGH"] = "high";
    Priority["CRITICAL"] = "critical";
    Priority["BLOCKER"] = "blocker";
    Priority["MINOR"] = "minor";
})($e073124ced5a2b69$export$300334f671c43555 || ($e073124ced5a2b69$export$300334f671c43555 = {}));
const $e073124ced5a2b69$export$33096039fd990cf4 = Object.keys($e073124ced5a2b69$export$fb587a27d5a722e7).length / 2;
const $e073124ced5a2b69$export$22aad1fd6cb58c70 = 255;
const $e073124ced5a2b69$export$938f0a0c059b7000 = 1500;
const $e073124ced5a2b69$export$fabaed2692852e55 = "firstInteractiveDemoIssueId";

});



parcelRegister("gxbtf", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", function () { return (parcelRequire("2oOKG")).preventUnhandled; });

var $2oOKG = parcelRequire("2oOKG");

});
parcelRegister("2oOKG", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", function () { return $1bf530f212ecec63$export$453c0582481cc59d; });

var $1Nakb = parcelRequire("1Nakb");

var $2e1kT = parcelRequire("2e1kT");

var $gJgj4 = parcelRequire("gJgj4");
function $1bf530f212ecec63$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = "move";
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
var $1bf530f212ecec63$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $1bf530f212ecec63$var$start() {
    $1bf530f212ecec63$var$cleanup();
    $1bf530f212ecec63$var$unbindEvents = (0, $2e1kT.bindAll)(window, [
        {
            type: "dragover",
            listener: $1bf530f212ecec63$var$acceptDrop
        },
        {
            type: "dragenter",
            listener: $1bf530f212ecec63$var$acceptDrop
        },
        {
            type: "drop",
            listener: function listener(event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $1bf530f212ecec63$var$cleanup();
            }
        },
        {
            type: "dragend",
            listener: $1bf530f212ecec63$var$cleanup
        }
    ].concat((0, $1Nakb.default)((0, $gJgj4.getBindingsForBrokenDrags)({
        onDragEnd: $1bf530f212ecec63$var$cleanup
    }))), // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $1bf530f212ecec63$var$cleanup() {
    var _unbindEvents;
    (_unbindEvents = $1bf530f212ecec63$var$unbindEvents) === null || _unbindEvents === void 0 || _unbindEvents();
    $1bf530f212ecec63$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $1bf530f212ecec63$var$stop() {
    var _window$event;
    /**
   * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
   * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
   * ("drop" events caused by dropping over a drop target)
   * `preventUnhandled()` causes every element to become a drop target (according to the browser)
   *
   * To opt out of the default behaviour for a `"drop"` event, we need to make sure
   * that we cancel it.
   *
   * The `"drop"` event listener in core is in the `capture` phase, so people calling
   * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
   * file before it has the chance to cancel the event.
   *
   * Being sneaky and using the `window.event` global to sniff out the current event
   */ if (((_window$event = window.event) === null || _window$event === void 0 ? void 0 : _window$event.type) === "drop") {
        var _window$event2;
        (_window$event2 = window.event) === null || _window$event2 === void 0 || _window$event2.preventDefault();
    }
    $1bf530f212ecec63$var$cleanup();
}
var $1bf530f212ecec63$export$453c0582481cc59d = {
    start: $1bf530f212ecec63$var$start,
    stop: $1bf530f212ecec63$var$stop
};

});


parcelRegister("5iYet", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", function () { return (parcelRequire("hSPIT")).disableNativeDragPreview; });

var $hSPIT = parcelRequire("hSPIT");

});
parcelRegister("hSPIT", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", function () { return $d04f99f14a8139fd$export$c588cb30ff3b876e; });
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
var $d04f99f14a8139fd$var$tinyTransparentImage = function() {
    // SSR safe
    if (typeof window === "undefined") return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    var img = new Image();
    img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";
    return img;
}();
function $d04f99f14a8139fd$export$c588cb30ff3b876e(_ref) {
    var nativeSetDragImage = _ref.nativeSetDragImage;
    if (nativeSetDragImage && $d04f99f14a8139fd$var$tinyTransparentImage) nativeSetDragImage($d04f99f14a8139fd$var$tinyTransparentImage, 0, 0);
}

});


parcelRegister("ko7jr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc58ff4eb916aa4715fd29d4da19740a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ed7bb8ab02f4bb84$var$_react = $ed7bb8ab02f4bb84$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $ed7bb8ab02f4bb84$var$_baseNew = $ed7bb8ab02f4bb84$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $ed7bb8ab02f4bb84$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Project".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for projects in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ed7bb8ab02f4bb84$var$ProjectIcon = (props)=>/*#__PURE__*/ $ed7bb8ab02f4bb84$var$_react.default.createElement($ed7bb8ab02f4bb84$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.482a.5.5 0 0 0-.354.146L7.78 5.03a.75.75 0 0 1-.53.22H3.018a.5.5 0 0 0-.354.146l-.353.354 1.72 1.72a.75.75 0 0 1 0 1.06l-2.25 2.25L.72 9.72 2.44 8 .72 6.28a.75.75 0 0 1 0-1.06l.884-.884a2 2 0 0 1 1.414-.586h3.921l2.165-2.164A2 2 0 0 1 10.518 1H13a2 2 0 0 1 2 2v2.482a2 2 0 0 1-.586 1.414L12.25 9.061v3.921a2 2 0 0 1-.586 1.415l-.884.883a.75.75 0 0 1-1.06 0L8 13.56l-1.72 1.72-1.06-1.06 2.25-2.25a.75.75 0 0 1 1.06 0l1.72 1.72.354-.354a.5.5 0 0 0 .146-.354V8.75a.75.75 0 0 1 .22-.53l2.384-2.384a.5.5 0 0 0 .146-.354zm-6.72 7.28-5 5-1.06-1.06 5-5z" clip-rule="evenodd"/><path fill="currentcolor" d="M12.5 4.625a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"/>`
    }, props));
$ed7bb8ab02f4bb84$var$ProjectIcon.displayName = "ProjectIcon";
var $ed7bb8ab02f4bb84$var$_default = module.exports.default = $ed7bb8ab02f4bb84$var$ProjectIcon;

});

parcelRegister("4w8Rb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::56a48b6e9d6992ba3e844b7827f74013>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34a10561d56b8ab8$var$_react = $34a10561d56b8ab8$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $34a10561d56b8ab8$var$_baseNew = $34a10561d56b8ab8$var$_interopRequireDefault((parcelRequire("bTGUY")));
function $34a10561d56b8ab8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RoadmapsPlan".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for roadmaps plan.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $34a10561d56b8ab8$var$RoadmapsPlanIcon = (props)=>/*#__PURE__*/ $34a10561d56b8ab8$var$_react.default.createElement($34a10561d56b8ab8$var$_baseNew.default, Object.assign({
        name: "RoadmapsPlanIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M1 3.5a2.5 2.5 0 0 1 4.886-.75h4.864a3 3 0 1 1 0 6h-5.5a1.5 1.5 0 1 0 0 3h4.865a2.501 2.501 0 1 1 0 1.5H5.25a3 3 0 1 1 0-6h5.5a1.5 1.5 0 0 0 0-3H5.886A2.501 2.501 0 0 1 1 3.5m11.5 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$34a10561d56b8ab8$var$RoadmapsPlanIcon.displayName = "RoadmapsPlanIcon";
var $34a10561d56b8ab8$var$_default = module.exports.default = $34a10561d56b8ab8$var$RoadmapsPlanIcon;

});

parcelRegister("h0Muo", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $c6280cb2974ef23d$var$noop() {
// No operation performed.
}
module.exports = $c6280cb2974ef23d$var$noop;

});

parcelRegister("9XU1G", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("iSvIT")));
})(module.exports, function(exports1, React) {
    "use strict";
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== "default") {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === "function") return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || "Unknown";
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

});

parcelRegister("c0YON", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bf4a9630aeeae23$var$_react = $8bf4a9630aeeae23$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $97VfE = parcelRequire("97VfE");
function $8bf4a9630aeeae23$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8bf4a9630aeeae23$var$Document16Icon = (props)=>/*#__PURE__*/ $8bf4a9630aeeae23$var$_react.default.createElement($97VfE.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: "small"
    }));
$8bf4a9630aeeae23$var$Document16Icon.displayName = "Document16Icon";
var $8bf4a9630aeeae23$var$_default = module.exports.default = $8bf4a9630aeeae23$var$Document16Icon;

});
parcelRegister("97VfE", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $6a512d6f590dd62d$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $6RsLT = parcelRequire("6RsLT");

var $1RMyA = parcelRequire("1RMyA");

var $iSvIT = parcelRequire("iSvIT");

var $5yHYf = parcelRequire("5yHYf");
function $6a512d6f590dd62d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6a512d6f590dd62d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6a512d6f590dd62d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1RMyA.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6a512d6f590dd62d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $6a512d6f590dd62d$var$iconStyles = null;
var $6a512d6f590dd62d$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $6a512d6f590dd62d$var$baseHcmStyles = null;
var $6a512d6f590dd62d$var$primaryEqualsSecondaryHcmStyles = null;
var $6a512d6f590dd62d$var$secondaryTransparentHcmStyles = null;
var $6a512d6f590dd62d$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $iSvIT.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + "px",
        height: height + "px"
    } : null;
    return /*#__PURE__*/ $iSvIT.createElement("span", (0, $6RsLT.default)({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $6a512d6f590dd62d$var$_objectSpread($6a512d6f590dd62d$var$_objectSpread({}, customDimensions), {}, {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $5yHYf.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === "transparent" && "_4fyi1j28",
            size && $6a512d6f590dd62d$var$sizeStyles[size]
        ])
    }));
});
var $6a512d6f590dd62d$export$2e2bcd8739ae039 = $6a512d6f590dd62d$export$f04a61298a47a40f;

});
parcelRegister("6RsLT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fee02b9973f6fde$export$2e2bcd8739ae039; });
function $4fee02b9973f6fde$export$2e2bcd8739ae039() {
    return $4fee02b9973f6fde$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4fee02b9973f6fde$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("1RMyA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15c0680f329bd696$export$2e2bcd8739ae039; });

var $bTjzY = parcelRequire("bTjzY");
function $15c0680f329bd696$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $bTjzY.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("bTjzY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a8404c359e94de0$export$2e2bcd8739ae039; });

var $jauqS = parcelRequire("jauqS");

var $c6J4G = parcelRequire("c6J4G");
function $8a8404c359e94de0$export$2e2bcd8739ae039(t) {
    var i = (0, $c6J4G.default)(t, "string");
    return "symbol" == (0, $jauqS.default)(i) ? i : i + "";
}

});
parcelRegister("jauqS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df468ec32995802a$export$2e2bcd8739ae039; });
function $df468ec32995802a$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $df468ec32995802a$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $df468ec32995802a$export$2e2bcd8739ae039(o);
}

});

parcelRegister("c6J4G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d09026fe82cb5c7$export$2e2bcd8739ae039; });

var $jauqS = parcelRequire("jauqS");
function $8d09026fe82cb5c7$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $jauqS.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $jauqS.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("5yHYf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40c23c6694037848$export$2e2bcd8739ae039; });
const $40c23c6694037848$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $40c23c6694037848$var$ATOMIC_GROUP_LENGTH = 5;
function $40c23c6694037848$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $40c23c6694037848$var$UNDERSCORE_UNICODE ? $40c23c6694037848$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});



parcelRegister("bJIbE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02347c95c6c194e3$var$_react = $02347c95c6c194e3$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $97VfE = parcelRequire("97VfE");
function $02347c95c6c194e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $02347c95c6c194e3$var$Document24Icon = (props)=>/*#__PURE__*/ $02347c95c6c194e3$var$_react.default.createElement($97VfE.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
    }, props, {
        size: "medium"
    }));
$02347c95c6c194e3$var$Document24Icon.displayName = "Document24Icon";
var $02347c95c6c194e3$var$_default = module.exports.default = $02347c95c6c194e3$var$Document24Icon;

});

parcelRegister("fZtyx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba437ab8ef18585b$var$_react = $ba437ab8ef18585b$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $ba437ab8ef18585b$var$_baseNew = $ba437ab8ef18585b$var$_interopRequireDefault((parcelRequire("bTGUY")));
function $ba437ab8ef18585b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba437ab8ef18585b$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $ba437ab8ef18585b$var$_react.default.createElement($ba437ab8ef18585b$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$ba437ab8ef18585b$var$PageLiveDocIcon.displayName = "PageLiveDocIcon";
var $ba437ab8ef18585b$var$_default = module.exports.default = $ba437ab8ef18585b$var$PageLiveDocIcon;

});

parcelRegister("4mfRg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $32c5849b629f06b0$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $iSvIT = parcelRequire("iSvIT");
var $32c5849b629f06b0$var$React = $32c5849b629f06b0$var$_interopRequireWildcard($iSvIT);
function $32c5849b629f06b0$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $32c5849b629f06b0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $32c5849b629f06b0$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $32c5849b629f06b0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $32c5849b629f06b0$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $32c5849b629f06b0$var$loaded() {
    return {
        isLoaded: true
    };
}
function $32c5849b629f06b0$var$errored() {
    return {
        isErrored: true
    };
}
function $32c5849b629f06b0$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $32c5849b629f06b0$var$ImageRenderer = function(_React$Component) {
    $32c5849b629f06b0$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $32c5849b629f06b0$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $32c5849b629f06b0$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($32c5849b629f06b0$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($32c5849b629f06b0$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $32c5849b629f06b0$var$_possibleConstructorReturn(_this, _ret);
    }
    $32c5849b629f06b0$var$_createClass(ImageRenderer, [
        {
            key: "load",
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: "unload",
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: "componentWillMount",
            value: function componentWillMount() {
                if (typeof window === "undefined") return;
                this.setState($32c5849b629f06b0$var$loading(new Image()));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                if ($32c5849b629f06b0$var$hasPropsChanged(this.props, nextProps)) this.setState($32c5849b629f06b0$var$loading(new Image()));
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if ($32c5849b629f06b0$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($32c5849b629f06b0$var$React.Component);
module.exports.default = $32c5849b629f06b0$var$ImageRenderer;

});

parcelRegister("5XkWH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4562b5d23184c324$export$2e2bcd8739ae039; });

var $72NmR = parcelRequire("72NmR");

var $cJhvT = parcelRequire("cJhvT");

var $iSvIT = parcelRequire("iSvIT");

var $lL4Ma = parcelRequire("lL4Ma");

var $fS4A7 = parcelRequire("fS4A7");

var $eTo1d = parcelRequire("eTo1d");

var $12ZPF = parcelRequire("12ZPF");

var $MIq2I = parcelRequire("MIq2I");

var $kMg75 = parcelRequire("kMg75");
var $4562b5d23184c324$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $4562b5d23184c324$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $4562b5d23184c324$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, unsafeRest = (0, $cJhvT.default)(_ref, $4562b5d23184c324$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $cJhvT.default)(unsafeRest, $4562b5d23184c324$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $12ZPF.default), (0, $72NmR.default)({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === "circle",
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $MIq2I.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $kMg75.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eTo1d.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $fS4A7.default), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $12ZPF.default), (0, $72NmR.default)({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === "circle",
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $lL4Ma.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $MIq2I.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $kMg75.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eTo1d.default), null, label)));
    });
}));
$4562b5d23184c324$var$IconButton.displayName = "IconButton";
var $4562b5d23184c324$export$2e2bcd8739ae039 = $4562b5d23184c324$var$IconButton;

});
parcelRegister("fS4A7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8df73faabd56637$export$2e2bcd8739ae039; });

var $72NmR = parcelRequire("72NmR");

var $98ZsH = parcelRequire("98ZsH");

var $dP3BU = parcelRequire("dP3BU");

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $fqY7p = parcelRequire("fqY7p");

var $4OZuI = parcelRequire("4OZuI");

var $2uvCZ = parcelRequire("2uvCZ");

var $5dQuO = parcelRequire("5dQuO");

var $4atXX = parcelRequire("4atXX");

var $iy0QV = parcelRequire("iy0QV");
var $g2f6i = parcelRequire("g2f6i");

var $jxLBU = parcelRequire("jxLBU");

var $5NOk7 = parcelRequire("5NOk7");

var $gWVOm = parcelRequire("gWVOm");

var $kSy4D = parcelRequire("kSy4D");

var $iPZUv = parcelRequire("iPZUv");

var $5Cu19 = parcelRequire("5Cu19");

var $hmvkc = parcelRequire("hmvkc");

var $jSvFS = parcelRequire("jSvFS");

var $8xQ2S = parcelRequire("8xQ2S");
function $b8df73faabd56637$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b8df73faabd56637$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b8df73faabd56637$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dP3BU.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b8df73faabd56637$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b8df73faabd56637$var$tooltipZIndex = (0, $kSy4D.layers).tooltip();
var $b8df73faabd56637$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "20.2.2"
};
// Inverts motion direction
var $b8df73faabd56637$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $b8df73faabd56637$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $b8df73faabd56637$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $jSvFS.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $4OZuI.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $4OZuI.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $fqY7p.usePlatformLeafSyntheticEventHandler)($b8df73faabd56637$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $b8df73faabd56637$var$analyticsAttributes));
    var onHideHandler = (0, $fqY7p.usePlatformLeafSyntheticEventHandler)($b8df73faabd56637$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $b8df73faabd56637$var$analyticsAttributes));
    var apiRef = (0, $iSvIT.useRef)(null);
    var _useState = (0, $iSvIT.useState)("hide"), _useState2 = (0, $98ZsH.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $iSvIT.useRef)(null);
    var containerRef = (0, $iSvIT.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $iSvIT.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $5dQuO.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $5dQuO.default)(onShowHandler);
    var onHideHandlerStable = (0, $5dQuO.default)(onHideHandler);
    var delayStable = (0, $5dQuO.default)(delay);
    var canAppearStable = (0, $5dQuO.default)(canAppear);
    var hasCalledShowHandler = (0, $iSvIT.useRef)(false);
    var start = (0, $iSvIT.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $iSvIT.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $iSvIT.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $iSvIT.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $iSvIT.useRef)(false);
    (0, $iSvIT.useEffect)(function() {
        return (0, $iPZUv.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $iSvIT.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $5Cu19.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $iSvIT.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $2uvCZ.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $iSvIT.useEffect)(function() {
        if (state === "hide") return 0, $4OZuI.default;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $2e1kT.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $iSvIT.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $iSvIT.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $iSvIT.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $8xQ2S.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $iSvIT.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $8xQ2S.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $iSvIT.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $iSvIT.useCallback)(function() {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (targetRef.current && !targetRef.current.matches(":focus-visible") && (0, $jxLBU.fg)("platform-tooltip-focus-visible")) return;
        } catch (_) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: "keyboard"
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $iSvIT.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $iSvIT.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && stableState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== "hide" && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    var handleOpenLayerObserverCloseSignal = (0, $iSvIT.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $4atXX.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && ((0, $jxLBU.fg)("platform_dst_open_layer_observer_close_layers") ? shouldRenderTooltipChildren : true),
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5;
        if (position === "mouse" && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePosition) {
            var _apiRef$current6;
            return (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 ? void 0 : _apiRef$current6.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $hmvkc.default)("tooltip", shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === "function";
    (0, $iSvIT.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute("aria-describedby", tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute("aria-describedby");
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === "function" ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, typeof children === "function" ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children($b8df73faabd56637$var$_objectSpread($b8df73faabd56637$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(CastTargetContainer, (0, $72NmR.default)({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $gWVOm.default), {
        zIndex: $b8df73faabd56637$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5NOk7.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $b8df73faabd56637$var$invertedDirection[$b8df73faabd56637$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iy0QV.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $g2f6i.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== "show-immediate" ? "medium" : "none"
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $b8df73faabd56637$var$_objectSpread($b8df73faabd56637$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: "none"
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$b8df73faabd56637$var$Tooltip.displayName = "Tooltip";
var $b8df73faabd56637$export$2e2bcd8739ae039 = $b8df73faabd56637$var$Tooltip;

});
parcelRegister("98ZsH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a84897a8b478d6f$export$2e2bcd8739ae039; });

var $d1w9t = parcelRequire("d1w9t");

var $gdPKC = parcelRequire("gdPKC");

var $it1kQ = parcelRequire("it1kQ");

var $23XsZ = parcelRequire("23XsZ");
function $6a84897a8b478d6f$export$2e2bcd8739ae039(r, e) {
    return (0, $d1w9t.default)(r) || (0, $gdPKC.default)(r, e) || (0, $it1kQ.default)(r, e) || (0, $23XsZ.default)();
}

});
parcelRegister("d1w9t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97b44f0b9713f021$export$2e2bcd8739ae039; });
function $97b44f0b9713f021$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("gdPKC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bcf600e5e8b8103c$export$2e2bcd8739ae039; });
function $bcf600e5e8b8103c$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("23XsZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1809fd6c57a37a16$export$2e2bcd8739ae039; });
function $1809fd6c57a37a16$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("fqY7p", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $b3c7eafc46575957$export$1a04351537078b55; });

var $dP3BU = parcelRequire("dP3BU");

var $iSvIT = parcelRequire("iSvIT");

var $33LDM = parcelRequire("33LDM");

var $8Sebi = parcelRequire("8Sebi");
function $b3c7eafc46575957$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b3c7eafc46575957$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b3c7eafc46575957$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dP3BU.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b3c7eafc46575957$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b3c7eafc46575957$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $33LDM.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $8Sebi.useTrackedRef)(analyticsData);
    var fnRef = (0, $8Sebi.useTrackedRef)(fn);
    var handler = (0, $iSvIT.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $b3c7eafc46575957$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("33LDM", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $23a69b52bc39c617$export$5bf35293e545f20c; });

var $6LIwV = parcelRequire("6LIwV");

var $1Ybii = parcelRequire("1Ybii");

var $jlznK = parcelRequire("jlznK");
function $23a69b52bc39c617$export$5bf35293e545f20c() {
    var analyticsContext = (0, $jlznK.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $6LIwV.useCallbackOne)(function(payload) {
        return new (0, $1Ybii.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("1Ybii", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16f427ca2b878040$export$2e2bcd8739ae039; });

var $jgfgd = parcelRequire("jgfgd");

var $b1D3B = parcelRequire("b1D3B");

var $18fN8 = parcelRequire("18fN8");

var $9ap0A = parcelRequire("9ap0A");

var $4MjlJ = parcelRequire("4MjlJ");

var $k3Mua = parcelRequire("k3Mua");

var $e2uTX = parcelRequire("e2uTX");

var $dP3BU = parcelRequire("dP3BU");

var $cuB5y = parcelRequire("cuB5y");
function $16f427ca2b878040$var$_callSuper(t, o, e) {
    return o = (0, $4MjlJ.default)(o), (0, $9ap0A.default)(t, $16f427ca2b878040$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $4MjlJ.default)(t).constructor) : o.apply(t, e));
}
function $16f427ca2b878040$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($16f427ca2b878040$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $16f427ca2b878040$var$_superPropGet(t, o, e, r) {
    var p = (0, $k3Mua.default)((0, $4MjlJ.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $16f427ca2b878040$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $16f427ca2b878040$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $16f427ca2b878040$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $b1D3B.default)(this, UIAnalyticsEvent);
        _this = $16f427ca2b878040$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $dP3BU.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $dP3BU.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $jgfgd.default)(_this.context);
            var handlers = (0, $jgfgd.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $dP3BU.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $e2uTX.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $18fN8.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $16f427ca2b878040$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $cuB5y.default));

});
parcelRegister("cuB5y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91850e64c667bf52$export$2e2bcd8739ae039; });

var $dldEl = parcelRequire("dldEl");

var $b1D3B = parcelRequire("b1D3B");

var $18fN8 = parcelRequire("18fN8");

var $dP3BU = parcelRequire("dP3BU");
function $91850e64c667bf52$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $91850e64c667bf52$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $91850e64c667bf52$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dP3BU.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $91850e64c667bf52$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $91850e64c667bf52$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $91850e64c667bf52$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $91850e64c667bf52$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $b1D3B.default)(this, AnalyticsEvent);
        (0, $dP3BU.default)(this, "_isAnalyticsEvent", true);
        (0, $dP3BU.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $91850e64c667bf52$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $18fN8.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, $dldEl.default)(updater) === "object") this.payload = $91850e64c667bf52$var$_objectSpread($91850e64c667bf52$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("jlznK", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $e15b6ca452143758$export$d1f587f82ad51c4; });

var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");
var $e15b6ca452143758$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $iSvIT.useContext)((0, $lEO1D.default));
};

});


parcelRegister("8Sebi", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $675e5df4517aade6$export$1d27a74659855e44; });

var $iSvIT = parcelRequire("iSvIT");
var $675e5df4517aade6$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $iSvIT.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("4atXX", function(module, exports) {

$parcel$export(module.exports, "useNotifyOpenLayerObserver", function () { return $308f573d6c2dc1c4$export$469bb693f11edc7f; });

var $iSvIT = parcelRequire("iSvIT");

var $jxLBU = parcelRequire("jxLBU");

var $dZJi6 = parcelRequire("dZJi6");

var $ay6qq = parcelRequire("ay6qq");
function $308f573d6c2dc1c4$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    var context = (0, $iSvIT.useContext)((0, $dZJi6.OpenLayerObserverContext));
    var namespace = (0, $ay6qq.useOpenLayerObserverNamespace)();
    (0, $iSvIT.useEffect)(function() {
        if ((0, $jxLBU.fg)("platform_dst_open_layer_observer_close_layers")) return;
        /**
     * Increments the layer count when the component mounts or becomes visible.
     *
     * Returns a cleanup function to decrement the layer count when the component unmounts or becomes hidden.
     */ if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function cleanup() {
            context.decrement();
        };
    }, [
        context,
        isOpen,
        namespace
    ]);
    (0, $iSvIT.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (!(0, $jxLBU.fg)("platform_dst_open_layer_observer_close_layers")) return;
        if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose
    ]);
}

});
parcelRegister("dZJi6", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverContext", function () { return $a3041abc82d12910$export$5fbf4d7fae6cdc00; });

var $iSvIT = parcelRequire("iSvIT");
var $a3041abc82d12910$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);

});

parcelRegister("ay6qq", function(module, exports) {

$parcel$export(module.exports, "useOpenLayerObserverNamespace", function () { return $7ae21041cddb3848$export$1d57e79091cc3046; });

var $iSvIT = parcelRequire("iSvIT");

var $agnpi = parcelRequire("agnpi");
function $7ae21041cddb3848$export$1d57e79091cc3046() {
    var namespace = (0, $iSvIT.useContext)((0, $agnpi.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("agnpi", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", function () { return $778d8e20fd4f2046$export$644a49f3b8c50fcd; });

var $iSvIT = parcelRequire("iSvIT");
var $778d8e20fd4f2046$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $iSvIT.createContext)(null);

});



parcelRegister("5NOk7", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $4398908f7967a614$export$badac9ada3a0bdf9; });

var $jgfgd = parcelRequire("jgfgd");

var $98ZsH = parcelRequire("98ZsH");

var $iSvIT = parcelRequire("iSvIT");

var $jOB0X = parcelRequire("jOB0X");

var $fLh5s = parcelRequire("fLh5s");

// Export types from PopperJS / React Popper
var $4398908f7967a614$var$viewportPadding = 5;
var $4398908f7967a614$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: $4398908f7967a614$var$viewportPadding,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    }
];
function $4398908f7967a614$var$defaultChildrenFn() {
    return null;
}
var $4398908f7967a614$var$defaultOffset = [
    0,
    8
];
function $4398908f7967a614$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $4398908f7967a614$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $4398908f7967a614$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, $98ZsH.default)(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $iSvIT.useMemo)(function() {
        var preventOverflowModifier = {
            name: "preventOverflow",
            options: {
                padding: $4398908f7967a614$var$viewportPadding,
                rootBoundary: shouldFitViewport ? "viewport" : "document"
            }
        };
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $fLh5s.getMaxSizeModifiers)({
            viewportPadding: $4398908f7967a614$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($4398908f7967a614$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, $jgfgd.default)(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $iSvIT.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, $jgfgd.default)(internalModifiers), (0, $jgfgd.default)(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $jOB0X.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("fLh5s", function(module, exports) {

$parcel$export(module.exports, "getMaxSizeModifiers", function () { return $b7987fee6229f6e7$export$6d8c2b45c99d6e3f; });

var $98ZsH = parcelRequire("98ZsH");
function $b7987fee6229f6e7$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: "maxSizeData",
            enabled: true,
            phase: "read",
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: "maxSize",
            enabled: true,
            phase: "beforeWrite",
            requiresIfExists: [
                "offset",
                "preventOverflow",
                "flip"
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== "number" || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== "number") // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split("-"), _state$placement$spli2 = (0, $98ZsH.default)(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === "top") maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "bottom") maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === "left") maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "right") maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});


parcelRegister("kSy4D", function(module, exports) {

$parcel$export(module.exports, "layers", function () { return $f333481c1557969b$export$7be255094ccdc533; });

var $KsdEf = parcelRequire("KsdEf");

var $hSPBp = parcelRequire("hSPBp");
var $f333481c1557969b$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $f333481c1557969b$export$c93026a968943f95 = "light";
var $f333481c1557969b$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $f333481c1557969b$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $f333481c1557969b$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $f333481c1557969b$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $hSPBp.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f333481c1557969b$export$6d8204c2cb2e06b8() / 4;
    (0, $KsdEf.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $f333481c1557969b$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $f333481c1557969b$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $f333481c1557969b$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $KsdEf.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $f333481c1557969b$export$ba1d834b86d72a09 = $f333481c1557969b$export$a1b3edb637fb4f35;
var $f333481c1557969b$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $hSPBp.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $hSPBp.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $hSPBp.N30A), ")")
            }
        }
    };
};

});
parcelRegister("hSPBp", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $d04f81f82ec0d086$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $d04f81f82ec0d086$export$29a4f05edc054374; });
$parcel$export(module.exports, "N800", function () { return $d04f81f82ec0d086$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $d04f81f82ec0d086$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $d04f81f82ec0d086$export$920c0d5c49070351; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $d04f81f82ec0d086$export$4b84fd0e2c617bd = "#FFEBE6";
var $d04f81f82ec0d086$export$b34b069eff244586 = "#FFBDAD";
var $d04f81f82ec0d086$export$be802dd0d8b57f35 = "#FF8F73";
var $d04f81f82ec0d086$export$60847d42f9da92a6 = "#FF7452";
var $d04f81f82ec0d086$export$4a7404f376229999 = "#FF5630";
var $d04f81f82ec0d086$export$2010d0fb4295b346 = "#DE350B";
var $d04f81f82ec0d086$export$2837b5a1a71d5c02 = "#BF2600";
var $d04f81f82ec0d086$export$8d9596b529bbb9cf = "#FFFAE6";
var $d04f81f82ec0d086$export$41060a744ab0b7ae = "#FFF0B3";
var $d04f81f82ec0d086$export$1cc05bbbf340e559 = "#FFE380";
var $d04f81f82ec0d086$export$5aae31392d72caaa = "#FFC400";
var $d04f81f82ec0d086$export$c6930421db9fa514 = "#FFAB00";
var $d04f81f82ec0d086$export$59619663aa6500fb = "#FF991F";
var $d04f81f82ec0d086$export$874739ea9e379ab6 = "#FF8B00";
var $d04f81f82ec0d086$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $d04f81f82ec0d086$export$69a3bf21b9686c2b = "#ABF5D1";
var $d04f81f82ec0d086$export$afbce1382ec95f73 = "#79F2C0";
var $d04f81f82ec0d086$export$747d86715d4175de = "#57D9A3";
var $d04f81f82ec0d086$export$940e1f69e873f202 = "#36B37E";
var $d04f81f82ec0d086$export$a49394138f7b8e85 = "#00875A";
var $d04f81f82ec0d086$export$6fa04827ac68a4fb = "#006644";
var $d04f81f82ec0d086$export$226de0355ed012f8 = "#DEEBFF";
var $d04f81f82ec0d086$export$8c13c2ee36917869 = "#B3D4FF";
var $d04f81f82ec0d086$export$ecfc1dff386a3e7a = "#4C9AFF";
var $d04f81f82ec0d086$export$215b7063051591f1 = "#2684FF";
var $d04f81f82ec0d086$export$e62e8919cca44969 = "#0065FF";
var $d04f81f82ec0d086$export$b3de0ae08da2ce64 = "#0052CC";
var $d04f81f82ec0d086$export$a6ee3d71bc067634 = "#0747A6";
var $d04f81f82ec0d086$export$67f15409e87642a1 = "#669DF1";
var $d04f81f82ec0d086$export$f0539dbc42dbb067 = "#8FB8F6";
var $d04f81f82ec0d086$export$363e4475840015bb = "#EAE6FF";
var $d04f81f82ec0d086$export$4b0a4417ed59760f = "#C0B6F2";
var $d04f81f82ec0d086$export$6011520a64d9a187 = "#998DD9";
var $d04f81f82ec0d086$export$a7175d4e9206bc80 = "#8777D9";
var $d04f81f82ec0d086$export$b48405b95304b5a1 = "#6554C0";
var $d04f81f82ec0d086$export$c71e4279dd54a18d = "#5243AA";
var $d04f81f82ec0d086$export$147899de772240ec = "#403294";
var $d04f81f82ec0d086$export$2cf711fe14c66f06 = "#E6FCFF";
var $d04f81f82ec0d086$export$7a8f4d33f6f9772c = "#B3F5FF";
var $d04f81f82ec0d086$export$776c9c497ef08533 = "#79E2F2";
var $d04f81f82ec0d086$export$69cb3ca10c1e330e = "#00C7E6";
var $d04f81f82ec0d086$export$9dc1ef0f3f48059b = "#00B8D9";
var $d04f81f82ec0d086$export$7c835c78b6fcdef8 = "#00A3BF";
var $d04f81f82ec0d086$export$6036577f95c3877e = "#008DA6";
var $d04f81f82ec0d086$export$29a4f05edc054374 = "#FFFFFF";
var $d04f81f82ec0d086$export$e655ef011c4aa1a2 = "#FAFBFC";
var $d04f81f82ec0d086$export$9fdfb749e33cdf97 = "#F4F5F7";
var $d04f81f82ec0d086$export$3e51e8f1440314ba = "#EBECF0";
var $d04f81f82ec0d086$export$1ce2d1575d444ceb = "#DFE1E6";
var $d04f81f82ec0d086$export$8754fc7e6d8b3000 = "#C1C7D0";
var $d04f81f82ec0d086$export$c2e91cbeada39b8b = "#B3BAC5";
var $d04f81f82ec0d086$export$5f71e19f3a7ad9de = "#A5ADBA";
var $d04f81f82ec0d086$export$eaa8c8a70ac22806 = "#97A0AF";
var $d04f81f82ec0d086$export$7c87d337fb91a97d = "#8993A4";
var $d04f81f82ec0d086$export$d6447c357493214f = "#7A869A";
var $d04f81f82ec0d086$export$f563ee71e9ee74cd = "#6B778C";
var $d04f81f82ec0d086$export$e2ef2124cf4024b1 = "#5E6C84";
var $d04f81f82ec0d086$export$eece5f492e429f08 = "#505F79";
var $d04f81f82ec0d086$export$c39c0fe0f26207ae = "#42526E";
var $d04f81f82ec0d086$export$7090862dc3038a9f = "#344563";
var $d04f81f82ec0d086$export$ad0bacf983b7ddaa = "#253858";
var $d04f81f82ec0d086$export$7d61b15e0da132af = "#172B4D";
var $d04f81f82ec0d086$export$fbda843f0a27fe96 = "#091E42";
var $d04f81f82ec0d086$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $d04f81f82ec0d086$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $d04f81f82ec0d086$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $d04f81f82ec0d086$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $d04f81f82ec0d086$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $d04f81f82ec0d086$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $d04f81f82ec0d086$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $d04f81f82ec0d086$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $d04f81f82ec0d086$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $d04f81f82ec0d086$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $d04f81f82ec0d086$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $d04f81f82ec0d086$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $d04f81f82ec0d086$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $d04f81f82ec0d086$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $d04f81f82ec0d086$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $d04f81f82ec0d086$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $d04f81f82ec0d086$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $d04f81f82ec0d086$export$2f6319cf7d736c2a = "#E6EDFA";
var $d04f81f82ec0d086$export$95126bc8884d6634 = "#DCE5F5";
var $d04f81f82ec0d086$export$8338d8c35d44ff1 = "#CED9EB";
var $d04f81f82ec0d086$export$5368d76ae4fbbda7 = "#B8C7E0";
var $d04f81f82ec0d086$export$9f0a771d16ec8d36 = "#ABBBD6";
var $d04f81f82ec0d086$export$abcf8c38338b4aa5 = "#9FB0CC";
var $d04f81f82ec0d086$export$97e81faa16a182c7 = "#8C9CB8";
var $d04f81f82ec0d086$export$bfe21c59123ecf33 = "#7988A3";
var $d04f81f82ec0d086$export$ee82aa2ea6a1558 = "#67758F";
var $d04f81f82ec0d086$export$682927c6ed76be02 = "#56637A";
var $d04f81f82ec0d086$export$91fd9994c5be9757 = "#455166";
var $d04f81f82ec0d086$export$d281fbfe3cff2df6 = "#3B475C";
var $d04f81f82ec0d086$export$3902c91d8b98a753 = "#313D52";
var $d04f81f82ec0d086$export$8e8133c1ba5845b5 = "#283447";
var $d04f81f82ec0d086$export$33ff357f6620b39 = "#202B3D";
var $d04f81f82ec0d086$export$633847cf062b69e0 = "#1B2638";
var $d04f81f82ec0d086$export$9776a6e503bdbf76 = "#121A29";
var $d04f81f82ec0d086$export$6c813d5160dff5db = "#0E1624";
var $d04f81f82ec0d086$export$3d4f271a500072a = "#0D1424";
var $d04f81f82ec0d086$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $d04f81f82ec0d086$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $d04f81f82ec0d086$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $d04f81f82ec0d086$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $d04f81f82ec0d086$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $d04f81f82ec0d086$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $d04f81f82ec0d086$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $d04f81f82ec0d086$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $d04f81f82ec0d086$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $d04f81f82ec0d086$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $d04f81f82ec0d086$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $d04f81f82ec0d086$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $d04f81f82ec0d086$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $d04f81f82ec0d086$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $d04f81f82ec0d086$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $d04f81f82ec0d086$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $d04f81f82ec0d086$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $d04f81f82ec0d086$export$d2adc5dedf09fced = "#292A2E";
var $d04f81f82ec0d086$export$f51762073d2bb381 = "#94C748";
var $d04f81f82ec0d086$export$95e26d54def96891 = "#B3DF72";

});


parcelRegister("iPZUv", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $db6d0383d5960063$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $2e1kT = parcelRequire("2e1kT");
var $db6d0383d5960063$var$registrations = new Set();
var $db6d0383d5960063$var$cleanupEndEventListeners = null;
function $db6d0383d5960063$var$onDragStart() {
    if ($db6d0383d5960063$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $db6d0383d5960063$var$cleanupEndEventListeners = (0, $2e1kT.bindAll)(window, [
        {
            type: "dragend",
            listener: $db6d0383d5960063$var$onDragEnd
        },
        {
            type: "pointerdown",
            listener: $db6d0383d5960063$var$onDragEnd
        },
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $db6d0383d5960063$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($db6d0383d5960063$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $db6d0383d5960063$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $db6d0383d5960063$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $db6d0383d5960063$var$cleanupEndEventListeners = null;
    var clone = Array.from($db6d0383d5960063$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $db6d0383d5960063$var$bindStartEvents() {
    return (0, $2e1kT.bindAll)(window, [
        {
            type: "dragstart",
            listener: $db6d0383d5960063$var$onDragStart
        },
        {
            type: "dragenter",
            listener: $db6d0383d5960063$var$onDragStart
        }
    ]);
}
var $db6d0383d5960063$var$cleanupStartEventListeners = null;
function $db6d0383d5960063$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$db6d0383d5960063$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $db6d0383d5960063$var$cleanupStartEventListeners = $db6d0383d5960063$var$bindStartEvents();
    $db6d0383d5960063$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $db6d0383d5960063$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $db6d0383d5960063$var$registrations.delete(registration);
        if ($db6d0383d5960063$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $db6d0383d5960063$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $db6d0383d5960063$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("5Cu19", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $4177c93facb20c70$export$57bf213be019eeb0; });

var $9C95L = parcelRequire("9C95L");
// This file is a singleton for managing tooltips
var $4177c93facb20c70$var$active = null;
function $4177c93facb20c70$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($4177c93facb20c70$var$active && $4177c93facb20c70$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $9C95L.clearScheduled)();
            $4177c93facb20c70$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $9C95L.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $9C95L.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $9C95L.scheduleTimeout)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($4177c93facb20c70$var$active && $4177c93facb20c70$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($4177c93facb20c70$var$active) {
            (0, $9C95L.clearScheduled)();
            $4177c93facb20c70$var$active.entry.hide({
                isImmediate: true
            });
            $4177c93facb20c70$var$active.entry.done();
            $4177c93facb20c70$var$active = null;
        }
        // this tooltip is now the active tooltip
        $4177c93facb20c70$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $9C95L.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("9C95L", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", function () { return $6ffeb71f2320f50c$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $6ffeb71f2320f50c$export$5f4d6617421d489b; });
var $6ffeb71f2320f50c$var$delayId = null;
function $6ffeb71f2320f50c$export$eaf678f6f93f5250() {
    if ($6ffeb71f2320f50c$var$delayId != null) {
        window.clearTimeout($6ffeb71f2320f50c$var$delayId);
        $6ffeb71f2320f50c$var$delayId = null;
    }
}
function $6ffeb71f2320f50c$export$5f4d6617421d489b(fn, delay) {
    $6ffeb71f2320f50c$export$eaf678f6f93f5250();
    $6ffeb71f2320f50c$var$delayId = window.setTimeout(function() {
        $6ffeb71f2320f50c$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("hmvkc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca3cca37866d0466$export$2e2bcd8739ae039; });

var $dWwnB = parcelRequire("dWwnB");
function $ca3cca37866d0466$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $dWwnB.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});

parcelRegister("jSvFS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e78ba15d47c2024d$export$2e2bcd8739ae039; });
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dP3BU = parcelRequire("dP3BU");

var $iSvIT = parcelRequire("iSvIT");

var $8fP1t = parcelRequire("8fP1t");
var $iyj5N = parcelRequire("iyj5N");

var $hSPBp = parcelRequire("hSPBp");

var $5KX3b = parcelRequire("5KX3b");
function $e78ba15d47c2024d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e78ba15d47c2024d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e78ba15d47c2024d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dP3BU.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e78ba15d47c2024d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e78ba15d47c2024d$var$baseStyles = null;
var $e78ba15d47c2024d$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $e78ba15d47c2024d$var$TooltipContainer = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $iSvIT.createElement((0, $5KX3b.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8fP1t.default)([
            "_2rko1sit _11c8dcr7 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        style: $e78ba15d47c2024d$var$_objectSpread($e78ba15d47c2024d$var$_objectSpread({}, style), {}, {
            "--_yr7xfv": (0, $iyj5N.default)("var(--ds-background-neutral-bold, ".concat((0, $hSPBp.N800), ")")),
            "--_ywovvi": (0, $iyj5N.default)("var(--ds-text-inverse, ".concat((0, $hSPBp.N0), ")"))
        })
    }, children);
});
$e78ba15d47c2024d$var$TooltipContainer.displayName = "TooltipContainer";
var $e78ba15d47c2024d$export$2e2bcd8739ae039 = $e78ba15d47c2024d$var$TooltipContainer;

});
parcelRegister("5KX3b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $430f0dc6c2cca8bc$export$2e2bcd8739ae039; });
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8fP1t = parcelRequire("8fP1t");
var $430f0dc6c2cca8bc$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $430f0dc6c2cca8bc$var$TooltipPrimitive = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $iSvIT.createElement("div", {
        role: "tooltip",
        className: (0, $8fP1t.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$430f0dc6c2cca8bc$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $430f0dc6c2cca8bc$export$2e2bcd8739ae039 = $430f0dc6c2cca8bc$var$TooltipPrimitive;

});


parcelRegister("8xQ2S", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", function () { return $6389c6effd81733b$export$642213d516a9b928; });
function $6389c6effd81733b$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});



parcelRegister("fJ5Su", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c12e14f5c33454d538618fce8415497d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b72f9e363cfb0bc0$var$_react = $b72f9e363cfb0bc0$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b72f9e363cfb0bc0$var$_baseNew = $b72f9e363cfb0bc0$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b72f9e363cfb0bc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: feedback in products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b72f9e363cfb0bc0$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $b72f9e363cfb0bc0$var$_react.default.createElement($b72f9e363cfb0bc0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3.096a.5.5 0 0 0-.686-.464L7.5 4.758v4.734l5.314 2.126a.5.5 0 0 0 .686-.464zm-6 8.012 4.757 1.903A2 2 0 0 0 15 11.154V3.096a2 2 0 0 0-2.743-1.857L6.606 3.5H3a2 2 0 0 0-2 2v3.25a2 2 0 0 0 2 2h.5V13a2 2 0 0 0 2 2h1.25a.75.75 0 0 0 .75-.75zM6 9.25H3a.5.5 0 0 1-.5-.5V5.5A.5.5 0 0 1 3 5h3zm0 1.5v2.75h-.5A.5.5 0 0 1 5 13v-2.25z" clip-rule="evenodd"/>`
    }, props));
$b72f9e363cfb0bc0$var$MegaphoneIcon.displayName = "MegaphoneIcon";
var $b72f9e363cfb0bc0$var$_default = module.exports.default = $b72f9e363cfb0bc0$var$MegaphoneIcon;

});

parcelRegister("ioYoi", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", function () { return $d65950446a0d1ede$export$ce91654eb9fea460; });
$parcel$export(module.exports, "default", function () { return $d65950446a0d1ede$export$2e2bcd8739ae039; });

var $6AJ7a = parcelRequire("6AJ7a");

var $e1TEF = parcelRequire("e1TEF");

var $hedGb = parcelRequire("hedGb");

var $fR3ga = parcelRequire("fR3ga");

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $4NEBB = parcelRequire("4NEBB");
var $eP0GV = parcelRequire("eP0GV");
var $96Jyw = parcelRequire("96Jyw");
function $d65950446a0d1ede$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d65950446a0d1ede$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d65950446a0d1ede$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $e1TEF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d65950446a0d1ede$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d65950446a0d1ede$var$defaultThemeSettings = function defaultThemeSettings() {
    return {
        dark: "dark",
        light: "light",
        spacing: "spacing",
        typography: "typography"
    };
};
var $d65950446a0d1ede$var$ColorModeContext = /*#__PURE__*/ (0, $iSvIT.createContext)(undefined);
var $d65950446a0d1ede$var$SetColorModeContext = /*#__PURE__*/ (0, $iSvIT.createContext)(undefined);
var $d65950446a0d1ede$var$ThemeContext = /*#__PURE__*/ (0, $iSvIT.createContext)(undefined);
var $d65950446a0d1ede$var$SetThemeContext = /*#__PURE__*/ (0, $iSvIT.createContext)(undefined);
function $d65950446a0d1ede$export$ce91654eb9fea460() {
    var value = (0, $iSvIT.useContext)($d65950446a0d1ede$var$ColorModeContext);
    return value;
}
function $d65950446a0d1ede$export$20f3076712c8dfa() {
    var value = (0, $iSvIT.useContext)($d65950446a0d1ede$var$ColorModeContext);
    var _getGlobalTheme = (0, $4NEBB.default)(), colorMode = _getGlobalTheme.colorMode;
    var _useState = (0, $iSvIT.useState)(colorMode || "light"), _useState2 = (0, $hedGb.default)(_useState, 2), resolvedColorMode = _useState2[0], setResolvedColorMode = _useState2[1];
    (0, $iSvIT.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        var observer = new (0, $96Jyw.default)(function(theme) {
            setResolvedColorMode(theme.colorMode || "light");
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}
function $d65950446a0d1ede$export$e2afe7397c3d11c7() {
    var value = (0, $iSvIT.useContext)($d65950446a0d1ede$var$SetColorModeContext);
    if (!value) throw new Error("useSetColorMode must be used within AppProvider.");
    return value;
}
function $d65950446a0d1ede$export$93d4e7f90805808f() {
    var theme = (0, $iSvIT.useContext)($d65950446a0d1ede$var$ThemeContext);
    var _useState3 = (0, $iSvIT.useState)(theme || (0, $4NEBB.default)()), _useState4 = (0, $hedGb.default)(_useState3, 2), resolvedTheme = _useState4[0], setResolvedTheme = _useState4[1];
    (0, $iSvIT.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (theme) return;
        var observer = new (0, $96Jyw.default)(setResolvedTheme);
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        theme
    ]);
    return theme ? theme : resolvedTheme;
}
function $d65950446a0d1ede$export$501aa0dcd5527a48() {
    var value = (0, $iSvIT.useContext)($d65950446a0d1ede$var$SetThemeContext);
    if (!value) throw new Error("useSetTheme must be used within AppProvider.");
    return value;
}
var $d65950446a0d1ede$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
var $d65950446a0d1ede$var$prefersDarkModeMql = $d65950446a0d1ede$var$isMatchMediaAvailable ? window.matchMedia("(prefers-color-scheme: dark)") : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $d65950446a0d1ede$var$getReconciledColorMode(colorMode) {
    if (colorMode === "auto") return $d65950446a0d1ede$var$prefersDarkModeMql !== null && $d65950446a0d1ede$var$prefersDarkModeMql !== void 0 && $d65950446a0d1ede$var$prefersDarkModeMql.matches ? "dark" : "light";
    return colorMode;
}
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 *
 * @internal
 */ function $d65950446a0d1ede$var$ThemeProvider(_ref) {
    var children = _ref.children, defaultColorMode = _ref.defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState5 = (0, $iSvIT.useState)(defaultColorMode), _useState6 = (0, $hedGb.default)(_useState5, 2), chosenColorMode = _useState6[0], setChosenColorMode = _useState6[1];
    var _useState7 = (0, $iSvIT.useState)($d65950446a0d1ede$var$getReconciledColorMode(defaultColorMode)), _useState8 = (0, $hedGb.default)(_useState7, 2), reconciledColorMode = _useState8[0], setReconciledColorMode = _useState8[1];
    var _useState9 = (0, $iSvIT.useState)(function() {
        return $d65950446a0d1ede$var$_objectSpread($d65950446a0d1ede$var$_objectSpread({}, $d65950446a0d1ede$var$defaultThemeSettings()), defaultTheme);
    }), _useState0 = (0, $hedGb.default)(_useState9, 2), theme = _useState0[0], setTheme = _useState0[1];
    var setColorMode = (0, $iSvIT.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($d65950446a0d1ede$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $iSvIT.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $d65950446a0d1ede$var$_objectSpread($d65950446a0d1ede$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $iSvIT.useRef)(null);
    (0, $iSvIT.useEffect)(function() {
        /**
     * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
     * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
     * `data-color-mode` attribute on the root element).
     *
     * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
     * applying the new theme.
     *
     * Without this, we can end up in the following scenario:
     * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
     * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
     * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
     * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
     */ var cleanupLastFnCall = /*#__PURE__*/ function() {
            var _ref2 = (0, $6AJ7a.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fR3ga))).mark(function _callee() {
                var unbindFn;
                return (0, (/*@__PURE__*/$parcel$interopDefault($fR3ga))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!lastSetGlobalThemePromiseRef.current) {
                                _context.next = 6;
                                break;
                            }
                            _context.next = 3;
                            return lastSetGlobalThemePromiseRef.current;
                        case 3:
                            unbindFn = _context.sent;
                            unbindFn();
                            lastSetGlobalThemePromiseRef.current = null;
                        case 6:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function cleanupLastFnCall() {
                return _ref2.apply(this, arguments);
            };
        }();
        var safelySetGlobalTheme = /*#__PURE__*/ function() {
            var _ref3 = (0, $6AJ7a.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fR3ga))).mark(function _callee2() {
                var promise;
                return (0, (/*@__PURE__*/$parcel$interopDefault($fR3ga))).wrap(function _callee2$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            _context2.next = 2;
                            return cleanupLastFnCall();
                        case 2:
                            promise = (0, $eP0GV.default)($d65950446a0d1ede$var$_objectSpread($d65950446a0d1ede$var$_objectSpread({}, theme), {}, {
                                colorMode: reconciledColorMode
                            }));
                            lastSetGlobalThemePromiseRef.current = promise;
                        case 4:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2);
            }));
            return function safelySetGlobalTheme() {
                return _ref3.apply(this, arguments);
            };
        }();
        safelySetGlobalTheme();
        return function cleanup() {
            cleanupLastFnCall();
        };
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $iSvIT.useEffect)(function() {
        if (!$d65950446a0d1ede$var$prefersDarkModeMql) return;
        var unbindListener = (0, $2e1kT.bind)($d65950446a0d1ede$var$prefersDarkModeMql, {
            type: "change",
            listener: function listener(event) {
                if (chosenColorMode === "auto") setReconciledColorMode(event.matches ? "dark" : "light");
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($d65950446a0d1ede$var$ColorModeContext.Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($d65950446a0d1ede$var$SetColorModeContext.Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($d65950446a0d1ede$var$ThemeContext.Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($d65950446a0d1ede$var$SetThemeContext.Provider, {
        value: setPartialTheme
    }, children))));
}
var $d65950446a0d1ede$export$2e2bcd8739ae039 = $d65950446a0d1ede$var$ThemeProvider;

});
parcelRegister("6AJ7a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cc919b34d51e67b$export$2e2bcd8739ae039; });
function $4cc919b34d51e67b$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $4cc919b34d51e67b$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $4cc919b34d51e67b$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $4cc919b34d51e67b$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("e1TEF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a36c5494f5bd7f26$export$2e2bcd8739ae039; });

var $RmFbr = parcelRequire("RmFbr");
function $a36c5494f5bd7f26$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $RmFbr.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("RmFbr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a0687cd33980aec$export$2e2bcd8739ae039; });

var $2H6JV = parcelRequire("2H6JV");

var $5ETas = parcelRequire("5ETas");
function $0a0687cd33980aec$export$2e2bcd8739ae039(t) {
    var i = (0, $5ETas.default)(t, "string");
    return "symbol" == (0, $2H6JV.default)(i) ? i : i + "";
}

});
parcelRegister("2H6JV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f64d35026fb3216$export$2e2bcd8739ae039; });
function $1f64d35026fb3216$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $1f64d35026fb3216$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1f64d35026fb3216$export$2e2bcd8739ae039(o);
}

});

parcelRegister("5ETas", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41eb7b599f66bffc$export$2e2bcd8739ae039; });

var $2H6JV = parcelRequire("2H6JV");
function $41eb7b599f66bffc$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $2H6JV.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $2H6JV.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("hedGb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8ae5ae8bcd0019d$export$2e2bcd8739ae039; });

var $lJjnb = parcelRequire("lJjnb");

var $29dO6 = parcelRequire("29dO6");

var $1VGQZ = parcelRequire("1VGQZ");

var $7QDP3 = parcelRequire("7QDP3");
function $c8ae5ae8bcd0019d$export$2e2bcd8739ae039(r, e) {
    return (0, $lJjnb.default)(r) || (0, $29dO6.default)(r, e) || (0, $1VGQZ.default)(r, e) || (0, $7QDP3.default)();
}

});
parcelRegister("lJjnb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd1cd3fdd64c269c$export$2e2bcd8739ae039; });
function $fd1cd3fdd64c269c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("29dO6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $190721dd29eb9334$export$2e2bcd8739ae039; });
function $190721dd29eb9334$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("1VGQZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $167c5b28f4243e80$export$2e2bcd8739ae039; });

var $dDEJf = parcelRequire("dDEJf");
function $167c5b28f4243e80$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $dDEJf.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $dDEJf.default)(r, a) : void 0;
    }
}

});
parcelRegister("dDEJf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ede82c346aefe59$export$2e2bcd8739ae039; });
function $9ede82c346aefe59$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("7QDP3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b6c47a889b1b23f$export$2e2bcd8739ae039; });
function $5b6c47a889b1b23f$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("fR3ga", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $b8ae558c81e2b993$var$runtime = (parcelRequire("7RSCm"))();
module.exports = $b8ae558c81e2b993$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $b8ae558c81e2b993$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $b8ae558c81e2b993$var$runtime;
    else Function("r", "regeneratorRuntime = r")($b8ae558c81e2b993$var$runtime);
}

});
parcelRegister("7RSCm", function(module, exports) {

var $g9AIN = parcelRequire("g9AIN");

var $bVALO = parcelRequire("bVALO");

var $gSIcq = parcelRequire("gSIcq");

var $cYgch = parcelRequire("cYgch");

var $5ETpi = parcelRequire("5ETpi");

var $b6UxV = parcelRequire("b6UxV");

var $8e0wI = parcelRequire("8e0wI");
function $5ba7d98ec58a2ae1$var$_regeneratorRuntime() {
    "use strict";
    var r = $bVALO(), e = r.m($5ba7d98ec58a2ae1$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $8e0wI(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $5ba7d98ec58a2ae1$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $g9AIN(r, e);
            },
            AsyncIterator: $5ETpi,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $cYgch : $gSIcq)(a(r), e, t, o, u);
            },
            keys: $b6UxV,
            values: $8e0wI
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $5ba7d98ec58a2ae1$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("g9AIN", function(module, exports) {
function $bc29f8b6c5ba9b2a$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $bc29f8b6c5ba9b2a$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bVALO", function(module, exports) {

var $jz7Ob = parcelRequire("jz7Ob");
function $8af18a58ee3eb9b6$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $jz7Ob(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($jz7Ob(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $jz7Ob(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $jz7Ob(u, "constructor", GeneratorFunctionPrototype), $jz7Ob(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $jz7Ob(GeneratorFunctionPrototype, o, "GeneratorFunction"), $jz7Ob(u), $jz7Ob(u, o, "Generator"), $jz7Ob(u, n, function() {
        return this;
    }), $jz7Ob(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $8af18a58ee3eb9b6$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $8af18a58ee3eb9b6$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jz7Ob", function(module, exports) {
function $e3e757c5f62d60e7$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $e3e757c5f62d60e7$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $e3e757c5f62d60e7$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $e3e757c5f62d60e7$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $e3e757c5f62d60e7$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gSIcq", function(module, exports) {

var $cYgch = parcelRequire("cYgch");
function $c4a3f98e84ac2384$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $cYgch(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $c4a3f98e84ac2384$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cYgch", function(module, exports) {

var $bVALO = parcelRequire("bVALO");

var $5ETpi = parcelRequire("5ETpi");
function $9717a70516b9e32e$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $5ETpi($bVALO().w(r, e, t, o), n || Promise);
}
module.exports = $9717a70516b9e32e$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5ETpi", function(module, exports) {

var $g9AIN = parcelRequire("g9AIN");

var $jz7Ob = parcelRequire("jz7Ob");
function $41ebaad5846d6eea$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $g9AIN ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($jz7Ob($41ebaad5846d6eea$var$AsyncIterator.prototype), $jz7Ob($41ebaad5846d6eea$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $jz7Ob(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $41ebaad5846d6eea$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("b6UxV", function(module, exports) {
function $816c1e1eb038fac5$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $816c1e1eb038fac5$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8e0wI", function(module, exports) {

var $hSt7E = parcelRequire("hSt7E");
var $5fd00a1aff059210$var$_typeof = $hSt7E.default;
function $5fd00a1aff059210$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($5fd00a1aff059210$var$_typeof(e) + " is not iterable");
}
module.exports = $5fd00a1aff059210$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hSt7E", function(module, exports) {
function $d03e11e9c7e15a30$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $d03e11e9c7e15a30$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $d03e11e9c7e15a30$var$_typeof(o);
}
module.exports = $d03e11e9c7e15a30$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("4NEBB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37eb3c6a350a0ce4$export$2e2bcd8739ae039; });

var $e1TEF = parcelRequire("e1TEF");

var $hvvbS = parcelRequire("hvvbS");

var $ehRbc = parcelRequire("ehRbc");

var $ixXLm = parcelRequire("ixXLm");
function $37eb3c6a350a0ce4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $37eb3c6a350a0ce4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $37eb3c6a350a0ce4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $e1TEF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $37eb3c6a350a0ce4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $37eb3c6a350a0ce4$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $ehRbc.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $37eb3c6a350a0ce4$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === "undefined") return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $hvvbS.COLOR_MODE_ATTRIBUTE)) || "";
    var theme = element.getAttribute((0, $hvvbS.THEME_DATA_ATTRIBUTE)) || "";
    return $37eb3c6a350a0ce4$var$_objectSpread($37eb3c6a350a0ce4$var$_objectSpread({}, (0, $ixXLm.themeStringToObject)(theme)), $37eb3c6a350a0ce4$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $37eb3c6a350a0ce4$export$2e2bcd8739ae039 = $37eb3c6a350a0ce4$var$getGlobalTheme;

});
parcelRegister("hvvbS", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $cbed86ba02e81b0b$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $cbed86ba02e81b0b$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", function () { return $cbed86ba02e81b0b$export$2112803007239c61; });
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", function () { return $cbed86ba02e81b0b$export$352e418ed5b6193a; });
var $cbed86ba02e81b0b$export$4ef52930e33717cd = "data-theme";
var $cbed86ba02e81b0b$export$a00eac3f8684bcd0 = "data-color-mode";
var $cbed86ba02e81b0b$export$2112803007239c61 = "data-contrast-mode";
var $cbed86ba02e81b0b$export$352e418ed5b6193a = "data-custom-theme";
var $cbed86ba02e81b0b$export$6f0c6fb8c80fcc92 = "ds";
var $cbed86ba02e81b0b$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $cbed86ba02e81b0b$export$dddac1532e822863 = "--".concat($cbed86ba02e81b0b$export$6f0c6fb8c80fcc92, "-token-not-found");
var $cbed86ba02e81b0b$export$9d7b58831ae93caa = "--".concat($cbed86ba02e81b0b$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("ehRbc", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", function () { return $a66be79957582721$export$83993de8eb66733; });
$parcel$export(module.exports, "themeIds", function () { return $a66be79957582721$export$7d43e72a58e3283f; });
$parcel$export(module.exports, "themeStateDefaults", function () { return $a66be79957582721$export$9aedcfa7336a207; });
$parcel$export(module.exports, "default", function () { return $a66be79957582721$export$2e2bcd8739ae039; });

var $jxLBU = parcelRequire("jxLBU");
var $a66be79957582721$export$83993de8eb66733 = [
    "light",
    "dark",
    "auto"
];
/**
 * Contrast preferences: The system contrast preference
 */ var $a66be79957582721$var$themeContrastModes = [
    "more",
    "no-preference",
    "auto"
];
var $a66be79957582721$export$7d43e72a58e3283f = [
    "light-increased-contrast",
    "light",
    "light-future",
    "light-brand-refresh",
    "dark",
    "dark-future",
    "dark-increased-contrast",
    "dark-brand-refresh",
    "legacy-light",
    "legacy-dark",
    "spacing",
    "shape",
    "typography",
    "typography-adg3",
    "typography-modernized",
    "typography-refreshed"
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $a66be79957582721$var$themeOverrideIds = [];
var $a66be79957582721$export$92ba366331403db2 = [].concat($a66be79957582721$export$7d43e72a58e3283f, $a66be79957582721$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $a66be79957582721$var$themeConfig = {
    "atlassian-light": {
        id: "light",
        displayName: "Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-light-future": {
        id: "light-future",
        displayName: "Future Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        override: "light"
    },
    "atlassian-light-increased-contrast": {
        id: "light-increased-contrast",
        displayName: "Light Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        extends: "light",
        increasesContrastFor: "light"
    },
    "atlassian-dark": {
        id: "dark",
        displayName: "Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-dark-future": {
        id: "dark-future",
        displayName: "Future Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        override: "light"
    },
    "atlassian-dark-increased-contrast": {
        id: "dark-increased-contrast",
        displayName: "Dark Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        extends: "dark",
        increasesContrastFor: "dark"
    },
    "atlassian-legacy-light": {
        id: "legacy-light",
        displayName: "Light Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-legacy-dark": {
        id: "legacy-dark",
        displayName: "Dark Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-spacing": {
        id: "spacing",
        displayName: "Atlassian Spacing",
        palette: "spacingScale",
        attributes: {
            type: "spacing"
        }
    },
    "atlassian-typography": {
        id: "typography",
        displayName: "Atlassian Typography",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-typography-adg3": {
        id: "typography-adg3",
        displayName: "ADG3 Typography",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-shape": {
        id: "shape",
        displayName: "Atlassian Shape",
        palette: "shapePalette",
        attributes: {
            type: "shape"
        }
    },
    "atlassian-typography-modernized": {
        id: "typography-modernized",
        displayName: "Atlassian Typography (Modernized)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-typography-refreshed": {
        id: "typography-refreshed",
        displayName: "Atlassian Typography (Refreshed)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-light-brand-refresh": {
        id: "light-brand-refresh",
        displayName: "Light theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-dark-brand-refresh": {
        id: "dark-brand-refresh",
        displayName: "Dark theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    }
};
var $a66be79957582721$export$9aedcfa7336a207 = {
    colorMode: "auto",
    contrastMode: "auto",
    dark: "dark",
    light: "light",
    shape: undefined,
    spacing: "spacing",
    typography: function typography() {
        if ((0, $jxLBU.fg)("platform-disable-default-typography")) return undefined;
        return "typography";
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $a66be79957582721$export$2e2bcd8739ae039 = $a66be79957582721$var$themeConfig;

});

parcelRegister("ixXLm", function(module, exports) {

$parcel$export(module.exports, "themeStringToObject", function () { return $d809aab5710794dd$export$f19b488f7c0547ee; });
$parcel$export(module.exports, "themeObjectToString", function () { return $d809aab5710794dd$export$62c37ab81302621a; });

var $2H6JV = parcelRequire("2H6JV");

var $hedGb = parcelRequire("hedGb");

var $ehRbc = parcelRequire("ehRbc");
var $d809aab5710794dd$var$themeKinds = [
    "light",
    "dark",
    "spacing",
    "typography",
    "shape"
];
var $d809aab5710794dd$var$customThemeOptions = "UNSAFE_themeOptions";
var $d809aab5710794dd$var$isThemeKind = function isThemeKind(themeKind) {
    return $d809aab5710794dd$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $d809aab5710794dd$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $ehRbc.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $d809aab5710794dd$var$isColorMode = function isColorMode(modeId) {
    return [
        "light",
        "dark",
        "auto"
    ].includes(modeId);
};
var $d809aab5710794dd$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(" ").map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $hedGb.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === "colorMode" && $d809aab5710794dd$var$isColorMode(id)) themeObject[kind] = id;
        if ($d809aab5710794dd$var$isThemeKind(kind) && $d809aab5710794dd$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $d809aab5710794dd$var$customThemeOptions) try {
            themeObject[$d809aab5710794dd$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error("Invalid custom theme string");
        }
        return themeObject;
    }, {});
};
var $d809aab5710794dd$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, $hedGb.default)(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === "colorMode" && typeof id === "string" && $d809aab5710794dd$var$isColorMode(id) || // custom theme state
        kind === $d809aab5710794dd$var$customThemeOptions && (0, $2H6JV.default)(id) === "object" || // other theme states
        $d809aab5710794dd$var$isThemeKind(kind) && typeof id === "string" && $d809aab5710794dd$var$isThemeIds(id)) return themeString + "".concat(themeString ? " " : "") + "".concat(kind, ":").concat((0, $2H6JV.default)(id) === "object" ? JSON.stringify(id) : id);
        return themeString;
    }, "");
};

});


parcelRegister("eP0GV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aca65d5f47e12574$export$2e2bcd8739ae039; });

var $6AJ7a = parcelRequire("6AJ7a");

var $fR3ga = parcelRequire("fR3ga");

var $jxLBU = parcelRequire("jxLBU");

var $ehRbc = parcelRequire("ehRbc");

var $iSlNk = parcelRequire("iSlNk");

var $lggyG = parcelRequire("lggyG");

var $iCkMQ = parcelRequire("iCkMQ");

var $9LO6I = parcelRequire("9LO6I");

var $dP5Vv = parcelRequire("dP5Vv");
function $aca65d5f47e12574$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $aca65d5f47e12574$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $aca65d5f47e12574$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $aca65d5f47e12574$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $aca65d5f47e12574$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $aca65d5f47e12574$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $aca65d5f47e12574$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, $6AJ7a.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fR3ga))).mark(function _callee3() {
        var _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeLoader, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fR3ga))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _ref2 = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {}, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $ehRbc.themeStateDefaults)["colorMode"] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $ehRbc.themeStateDefaults)["contrastMode"] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $ehRbc.themeStateDefaults)["dark"] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $ehRbc.themeStateDefaults)["light"] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $ehRbc.themeStateDefaults)["shape"] : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $ehRbc.themeStateDefaults)["spacing"] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $ehRbc.themeStateDefaults)["typography"]() : _ref2$typography, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $ehRbc.themeStateDefaults)["UNSAFE_themeOptions"] : _ref2$UNSAFE_themeOpt;
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $jxLBU.fg)("platform_increased-contrast-themes")) {
                        if (light === "light-increased-contrast") light = "light";
                        if (dark === "dark-increased-contrast") dark = "dark";
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $9LO6I.getThemePreferences)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $dP5Vv.loadAndAppendThemeCss); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, $6AJ7a.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fR3ga))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($fR3ga))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $iSlNk.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $ehRbc.themeStateDefaults)["colorMode"];
                        attrOfMissingCustomStyles = (0, $iCkMQ.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, $6AJ7a.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fR3ga))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($fR3ga))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("lmUkA"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? "auto" : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 10;
                    return Promise.all(loadingTasks);
                case 10:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $9LO6I.getThemeOverridePreferences)(themeState);
                    _iterator = $aca65d5f47e12574$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 12;
                    _iterator.s();
                case 14:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 20;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 18;
                    return loadingStrategy(themeId);
                case 18:
                    _context3.next = 14;
                    break;
                case 20:
                    _context3.next = 25;
                    break;
                case 22:
                    _context3.prev = 22;
                    _context3.t0 = _context3["catch"](12);
                    _iterator.e(_context3.t0);
                case 25:
                    _context3.prev = 25;
                    _iterator.f();
                    return _context3.finish(25);
                case 28:
                    autoUnbind = (0, $lggyG.default)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 30:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                12,
                22,
                25,
                28
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $aca65d5f47e12574$export$2e2bcd8739ae039 = $aca65d5f47e12574$var$setGlobalTheme;

});
parcelRegister("iSlNk", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", function () { return $dbde2d1d87b981d5$export$53031ac1ecb71f44; });
$parcel$export(module.exports, "rgbToHex", function () { return $dbde2d1d87b981d5$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgbA", function () { return $dbde2d1d87b981d5$export$b36dbdb4f463f05c; });
$parcel$export(module.exports, "hexToRgb", function () { return $dbde2d1d87b981d5$export$5a544e13ad4e1fa5; });
$parcel$export(module.exports, "hexToHSL", function () { return $dbde2d1d87b981d5$export$47ea145a83f50dc0; });
$parcel$export(module.exports, "HSLToRGB", function () { return $dbde2d1d87b981d5$export$1ff93e992dd58bec; });
$parcel$export(module.exports, "relativeLuminanceW3C", function () { return $dbde2d1d87b981d5$export$e770b01b744f3745; });
$parcel$export(module.exports, "getContrastRatio", function () { return $dbde2d1d87b981d5$export$d061e26956a60b0a; });
$parcel$export(module.exports, "deltaE", function () { return $dbde2d1d87b981d5$export$e8ddad763b4bebf9; });
// valid hex color with 6 digits
var $dbde2d1d87b981d5$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $dbde2d1d87b981d5$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $dbde2d1d87b981d5$export$34d09c4a771c46ef(r, g, b) {
    return "#" + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $dbde2d1d87b981d5$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $dbde2d1d87b981d5$export$b36dbdb4f463f05c(hex) {
    if (!$dbde2d1d87b981d5$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var c;
    c = hex.substring(1).split("");
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = "0x" + c.join("");
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $dbde2d1d87b981d5$export$1212645cf40ebf71(hex)
    ];
}
function $dbde2d1d87b981d5$export$5a544e13ad4e1fa5(hex) {
    if (!$dbde2d1d87b981d5$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var c;
    c = hex.substring(1).split("");
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = "0x" + c.join("");
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $dbde2d1d87b981d5$export$47ea145a83f50dc0(hex) {
    if (!$dbde2d1d87b981d5$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = "0x" + hex[1] + hex[1];
        g = "0x" + hex[2] + hex[2];
        b = "0x" + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = "0x" + hex[1] + hex[2];
        g = "0x" + hex[3] + hex[4];
        b = "0x" + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $dbde2d1d87b981d5$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $dbde2d1d87b981d5$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $dbde2d1d87b981d5$export$d061e26956a60b0a(foreground, background) {
    if (!$dbde2d1d87b981d5$var$isValidHex(foreground) || !$dbde2d1d87b981d5$var$isValidHex(background)) throw new Error("Invalid HEX");
    var foregroundRgb = $dbde2d1d87b981d5$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $dbde2d1d87b981d5$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $dbde2d1d87b981d5$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $dbde2d1d87b981d5$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $dbde2d1d87b981d5$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $dbde2d1d87b981d5$var$rgbToLab(rgbA);
    var labB = $dbde2d1d87b981d5$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $dbde2d1d87b981d5$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("lggyG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7a7efbda6dd21b4$export$2e2bcd8739ae039; });

var $hedGb = parcelRequire("hedGb");

var $jxLBU = parcelRequire("jxLBU");

var $2Tfv2 = parcelRequire("2Tfv2");

var $lMLpp = parcelRequire("lMLpp");

var $5uvWg = parcelRequire("5uvWg");
function $f7a7efbda6dd21b4$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === "auto") {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $lMLpp.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $lMLpp.default).bind();
    } else (0, $lMLpp.default).unbind();
    if ((0, $jxLBU.fg)("platform_increased-contrast-themes")) {
        if (themeState.contrastMode === "auto") {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $5uvWg.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $5uvWg.default).bind();
        } else (0, $5uvWg.default).unbind();
    }
    var themeAttributes = (0, $2Tfv2.default)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, $hedGb.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $lMLpp.default).unbind();
        if ((0, $jxLBU.fg)("platform_increased-contrast-themes")) (0, $5uvWg.default).unbind();
    };
}

});
parcelRegister("2Tfv2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21acbdbbbf7c7a66$export$2e2bcd8739ae039; });

var $e1TEF = parcelRequire("e1TEF");

var $jxLBU = parcelRequire("jxLBU");

var $hvvbS = parcelRequire("hvvbS");

var $ehRbc = parcelRequire("ehRbc");

var $ixXLm = parcelRequire("ixXLm");

var $iSlNk = parcelRequire("iSlNk");

var $6gEjv = parcelRequire("6gEjv");
function $21acbdbbbf7c7a66$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $21acbdbbbf7c7a66$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $21acbdbbbf7c7a66$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $e1TEF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $21acbdbbbf7c7a66$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $21acbdbbbf7c7a66$var$defaultColorMode = "light";
var $21acbdbbbf7c7a66$var$defaultContrastMode = "no-preference";
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $21acbdbbbf7c7a66$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $ehRbc.themeStateDefaults)["colorMode"] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $ehRbc.themeStateDefaults)["dark"] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $ehRbc.themeStateDefaults)["light"] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $ehRbc.themeStateDefaults)["contrastMode"] : _ref$contrastMode, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $ehRbc.themeStateDefaults)["shape"] : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $ehRbc.themeStateDefaults)["spacing"] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $ehRbc.themeStateDefaults)["typography"]() : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $ehRbc.themeStateDefaults)["UNSAFE_themeOptions"] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $ixXLm.themeObjectToString)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, $e1TEF.default)((0, $e1TEF.default)({}, (0, $hvvbS.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $hvvbS.COLOR_MODE_ATTRIBUTE), colorMode === "auto" ? $21acbdbbbf7c7a66$var$defaultColorMode : colorMode);
    if ((0, $jxLBU.fg)("platform_increased-contrast-themes")) result = $21acbdbbbf7c7a66$var$_objectSpread($21acbdbbbf7c7a66$var$_objectSpread({}, result), {}, (0, $e1TEF.default)({}, (0, $hvvbS.CONTRAST_MODE_ATTRIBUTE), contrastMode === "auto" ? $21acbdbbbf7c7a66$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $iSlNk.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $6gEjv.hash)(optionString);
        result[0, $hvvbS.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $21acbdbbbf7c7a66$export$2e2bcd8739ae039 = $21acbdbbbf7c7a66$var$getThemeHtmlAttrs;

});
parcelRegister("6gEjv", function(module, exports) {

$parcel$export(module.exports, "hash", function () { return $49038221fa701b4d$export$d6af199866bfb566; });
var $49038221fa701b4d$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});


parcelRegister("lMLpp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdc2db1305326f6d$export$2e2bcd8739ae039; });

var $gizSW = parcelRequire("gizSW");

var $9XJr0 = parcelRequire("9XJr0");

var $e1TEF = parcelRequire("e1TEF");

var $2e1kT = parcelRequire("2e1kT");

var $hvvbS = parcelRequire("hvvbS");

var $dP5Vv = parcelRequire("dP5Vv");
var $fdc2db1305326f6d$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $fdc2db1305326f6d$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $hvvbS.COLOR_MODE_ATTRIBUTE), e.matches ? "dark" : "light");
}
var $fdc2db1305326f6d$var$darkModeMql = $fdc2db1305326f6d$var$isMatchMediaAvailable && window.matchMedia((0, $dP5Vv.darkModeMediaQuery));
var $fdc2db1305326f6d$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, $gizSW.default)(this, ColorModeObserver);
        (0, $e1TEF.default)(this, "unbindThemeChangeListener", null);
    }
    return (0, $9XJr0.default)(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$fdc2db1305326f6d$var$darkModeMql) return "light";
                return $fdc2db1305326f6d$var$darkModeMql !== null && $fdc2db1305326f6d$var$darkModeMql !== void 0 && $fdc2db1305326f6d$var$darkModeMql.matches ? "dark" : "light";
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($fdc2db1305326f6d$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $2e1kT.bind)($fdc2db1305326f6d$var$darkModeMql, {
                    type: "change",
                    listener: $fdc2db1305326f6d$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $fdc2db1305326f6d$var$SingletonColorModeObserver = new $fdc2db1305326f6d$var$ColorModeObserver();
var $fdc2db1305326f6d$export$2e2bcd8739ae039 = $fdc2db1305326f6d$var$SingletonColorModeObserver;

});
parcelRegister("gizSW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdda29d41a4eb4ec$export$2e2bcd8739ae039; });
function $bdda29d41a4eb4ec$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("9XJr0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $740cde1fd64ee384$export$2e2bcd8739ae039; });

var $RmFbr = parcelRequire("RmFbr");
function $740cde1fd64ee384$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $RmFbr.default)(o.key), o);
    }
}
function $740cde1fd64ee384$export$2e2bcd8739ae039(e, r, t) {
    return r && $740cde1fd64ee384$var$_defineProperties(e.prototype, r), t && $740cde1fd64ee384$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("dP5Vv", function(module, exports) {

$parcel$export(module.exports, "loadAndAppendThemeCss", function () { return $a104a2aac525c430$export$26cd7ae85c7144e5; });
$parcel$export(module.exports, "darkModeMediaQuery", function () { return $a104a2aac525c430$export$bb1e815119d30f8b; });
$parcel$export(module.exports, "moreContrastMediaQuery", function () { return $a104a2aac525c430$export$8662df6937d86fcb; });

var $6AJ7a = parcelRequire("6AJ7a");

var $fR3ga = parcelRequire("fR3ga");

var $jxLBU = parcelRequire("jxLBU");

var $eXWIJ = parcelRequire("eXWIJ");

var $hvvbS = parcelRequire("hvvbS");
var $a104a2aac525c430$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, $6AJ7a.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fR3ga))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fR3ga))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $hvvbS.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]:not([').concat((0, $hvvbS.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return $a104a2aac525c430$export$8a48286ed7df6720(themeId);
                case 6:
                    themeCss = _context.sent;
                    style = document.createElement("style");
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $a104a2aac525c430$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, $6AJ7a.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fR3ga))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fR3ga))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if ((themeId === "light" || themeId === "dark") && (0, $jxLBU.fg)("platform-component-visual-refresh")) themeId += "-brand-refresh";
                    _context2.next = 3;
                    return (0, $eXWIJ.default)[themeId]();
                case 3:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 6:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $a104a2aac525c430$export$bb1e815119d30f8b = "(prefers-color-scheme: dark)";
var $a104a2aac525c430$export$8662df6937d86fcb = "(prefers-contrast: more)";

});
parcelRegister("eXWIJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae5420092cddc7b7$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::4131829e60733a1a5e513dcc84af81de>>
 * @codegenCommand yarn build tokens
 */ 















var $ae5420092cddc7b7$var$themeImportsMap = {
    "light": function light() {
        return (parcelRequire("3v0nO"));
    },
    "light-future": function lightFuture() {
        return (parcelRequire("6D926"));
    },
    "light-increased-contrast": function lightIncreasedContrast() {
        return (parcelRequire("96aBV"));
    },
    "dark": function dark() {
        return (parcelRequire("6KVtD"));
    },
    "dark-future": function darkFuture() {
        return (parcelRequire("7jnXc"));
    },
    "dark-increased-contrast": function darkIncreasedContrast() {
        return (parcelRequire("3USgY"));
    },
    "legacy-light": function legacyLight() {
        return (parcelRequire("46IUF"));
    },
    "legacy-dark": function legacyDark() {
        return (parcelRequire("f8aem"));
    },
    "spacing": function spacing() {
        return (parcelRequire("ffJco"));
    },
    "typography": function typography() {
        return (parcelRequire("8hqwU"));
    },
    "typography-adg3": function typographyAdg3() {
        return (parcelRequire("bEsCN"));
    },
    "shape": function shape() {
        return (parcelRequire("cIj94"));
    },
    "typography-modernized": function typographyModernized() {
        return (parcelRequire("eb1ZC"));
    },
    "typography-refreshed": function typographyRefreshed() {
        return (parcelRequire("3eLio"));
    },
    "light-brand-refresh": function lightBrandRefresh() {
        return (parcelRequire("lmmqN"));
    },
    "dark-brand-refresh": function darkBrandRefresh() {
        return (parcelRequire("lLEFf"));
    }
};
var $ae5420092cddc7b7$export$2e2bcd8739ae039 = $ae5420092cddc7b7$var$themeImportsMap;

});
parcelRegister("3v0nO", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("dTSzc")).then(()=>parcelRequire("fGLGe"));

});

parcelRegister("6D926", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("a0OrX")).then(()=>parcelRequire("jjWvm"));

});

parcelRegister("96aBV", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("dLsXP")).then(()=>parcelRequire("8ZTWe"));

});

parcelRegister("6KVtD", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("atHTn")).then(()=>parcelRequire("fvHw0"));

});

parcelRegister("7jnXc", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("6L1UE")).then(()=>parcelRequire("4EyLl"));

});

parcelRegister("3USgY", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("4FYGR")).then(()=>parcelRequire("k0g6C"));

});

parcelRegister("46IUF", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("K0TKH")).then(()=>parcelRequire("jp22E"));

});

parcelRegister("f8aem", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("SluOy")).then(()=>parcelRequire("kvZp2"));

});

parcelRegister("ffJco", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("awVri")).then(()=>parcelRequire("4jd7f"));

});

parcelRegister("8hqwU", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("9ApAy")).then(()=>parcelRequire("gXHBN"));

});

parcelRegister("bEsCN", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("lfJEO")).then(()=>parcelRequire("4YMy1"));

});

parcelRegister("cIj94", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("aTZHm")).then(()=>parcelRequire("bRxcW"));

});

parcelRegister("eb1ZC", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("g02NO")).then(()=>parcelRequire("8KKnq"));

});

parcelRegister("3eLio", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("am7MJ")).then(()=>parcelRequire("fOFqq"));

});

parcelRegister("lmmqN", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("3CJl5")).then(()=>parcelRequire("kqkNw"));

});

parcelRegister("lLEFf", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("ja77r")).then(()=>parcelRequire("8XTwk"));

});




parcelRegister("5uvWg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ff88775587697cb$export$2e2bcd8739ae039; });

var $gizSW = parcelRequire("gizSW");

var $9XJr0 = parcelRequire("9XJr0");

var $e1TEF = parcelRequire("e1TEF");

var $2e1kT = parcelRequire("2e1kT");

var $hvvbS = parcelRequire("hvvbS");

var $dP5Vv = parcelRequire("dP5Vv");
var $3ff88775587697cb$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $3ff88775587697cb$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $hvvbS.CONTRAST_MODE_ATTRIBUTE), e.matches ? "more" : "no-preference");
}
var $3ff88775587697cb$var$contrastModeMql = $3ff88775587697cb$var$isMatchMediaAvailable && window.matchMedia((0, $dP5Vv.moreContrastMediaQuery));
var $3ff88775587697cb$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, $gizSW.default)(this, ContrastModeObserver);
        (0, $e1TEF.default)(this, "unbindContrastChangeListener", null);
    }
    return (0, $9XJr0.default)(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$3ff88775587697cb$var$contrastModeMql) return "no-preference";
                return $3ff88775587697cb$var$contrastModeMql !== null && $3ff88775587697cb$var$contrastModeMql !== void 0 && $3ff88775587697cb$var$contrastModeMql.matches ? "more" : "no-preference";
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($3ff88775587697cb$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $2e1kT.bind)($3ff88775587697cb$var$contrastModeMql, {
                    type: "change",
                    listener: $3ff88775587697cb$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $3ff88775587697cb$var$SingletonContrastModeObserver = new $3ff88775587697cb$var$ContrastModeObserver();
var $3ff88775587697cb$export$2e2bcd8739ae039 = $3ff88775587697cb$var$SingletonContrastModeObserver;

});


parcelRegister("iCkMQ", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", function () { return $037f6af1372a4da0$export$bd1ac9300b0e885a; });
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", function () { return $037f6af1372a4da0$export$e7ae172320e03461; });
$parcel$export(module.exports, "reduceTokenMap", function () { return $037f6af1372a4da0$export$e673f367da2ff23e; });

var $hedGb = parcelRequire("hedGb");

var $TjxRP = parcelRequire("TjxRP");

var $fZufR = parcelRequire("fZufR");

var $hvvbS = parcelRequire("hvvbS");

var $6gEjv = parcelRequire("6gEjv");
function $037f6af1372a4da0$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $6gEjv.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === "auto" ? [
        "light",
        "dark"
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $hvvbS.CUSTOM_THEME_ATTRIBUTE), '="').concat(uniqueId, '"][').concat((0, $hvvbS.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]'));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $037f6af1372a4da0$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, $TjxRP.default)(Array.from(document.head.querySelectorAll("style[".concat((0, $hvvbS.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $hvvbS.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $037f6af1372a4da0$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, $hedGb.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $fZufR.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === "string" ? value : themeRamp[value], ";") : acc;
    }, "");
}

});
parcelRegister("TjxRP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a644c7290dab0d4$export$2e2bcd8739ae039; });

var $6bE4d = parcelRequire("6bE4d");

var $hcvqt = parcelRequire("hcvqt");

var $1VGQZ = parcelRequire("1VGQZ");

var $5eMjO = parcelRequire("5eMjO");
function $0a644c7290dab0d4$export$2e2bcd8739ae039(r) {
    return (0, $6bE4d.default)(r) || (0, $hcvqt.default)(r) || (0, $1VGQZ.default)(r) || (0, $5eMjO.default)();
}

});
parcelRegister("6bE4d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4812d99efb7d5735$export$2e2bcd8739ae039; });

var $dDEJf = parcelRequire("dDEJf");
function $4812d99efb7d5735$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $dDEJf.default)(r);
}

});

parcelRegister("hcvqt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c85bef380c4e6e10$export$2e2bcd8739ae039; });
function $c85bef380c4e6e10$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("5eMjO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d03bda0b8c7b042$export$2e2bcd8739ae039; });
function $3d03bda0b8c7b042$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("fZufR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba440580a74628a1$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e39d81369b0c277ebeac5d0b02ae5cb>>
 * @codegenCommand yarn build tokens
 */ var $ba440580a74628a1$var$tokens = {
    "color.text": "--ds-text",
    "color.text.accent.lime": "--ds-text-accent-lime",
    "color.text.accent.lime.bolder": "--ds-text-accent-lime-bolder",
    "color.text.accent.red": "--ds-text-accent-red",
    "color.text.accent.red.bolder": "--ds-text-accent-red-bolder",
    "color.text.accent.orange": "--ds-text-accent-orange",
    "color.text.accent.orange.bolder": "--ds-text-accent-orange-bolder",
    "color.text.accent.yellow": "--ds-text-accent-yellow",
    "color.text.accent.yellow.bolder": "--ds-text-accent-yellow-bolder",
    "color.text.accent.green": "--ds-text-accent-green",
    "color.text.accent.green.bolder": "--ds-text-accent-green-bolder",
    "color.text.accent.teal": "--ds-text-accent-teal",
    "color.text.accent.teal.bolder": "--ds-text-accent-teal-bolder",
    "color.text.accent.blue": "--ds-text-accent-blue",
    "color.text.accent.blue.bolder": "--ds-text-accent-blue-bolder",
    "color.text.accent.purple": "--ds-text-accent-purple",
    "color.text.accent.purple.bolder": "--ds-text-accent-purple-bolder",
    "color.text.accent.magenta": "--ds-text-accent-magenta",
    "color.text.accent.magenta.bolder": "--ds-text-accent-magenta-bolder",
    "color.text.accent.gray": "--ds-text-accent-gray",
    "color.text.accent.gray.bolder": "--ds-text-accent-gray-bolder",
    "color.text.disabled": "--ds-text-disabled",
    "color.text.inverse": "--ds-text-inverse",
    "color.text.selected": "--ds-text-selected",
    "color.text.brand": "--ds-text-brand",
    "color.text.danger": "--ds-text-danger",
    "color.text.warning": "--ds-text-warning",
    "color.text.warning.inverse": "--ds-text-warning-inverse",
    "color.text.success": "--ds-text-success",
    "color.text.discovery": "--ds-text-discovery",
    "color.text.information": "--ds-text-information",
    "color.text.subtlest": "--ds-text-subtlest",
    "color.text.subtle": "--ds-text-subtle",
    "color.link": "--ds-link",
    "color.link.pressed": "--ds-link-pressed",
    "color.link.visited": "--ds-link-visited",
    "color.link.visited.pressed": "--ds-link-visited-pressed",
    "color.icon": "--ds-icon",
    "color.icon.accent.lime": "--ds-icon-accent-lime",
    "color.icon.accent.red": "--ds-icon-accent-red",
    "color.icon.accent.orange": "--ds-icon-accent-orange",
    "color.icon.accent.yellow": "--ds-icon-accent-yellow",
    "color.icon.accent.green": "--ds-icon-accent-green",
    "color.icon.accent.teal": "--ds-icon-accent-teal",
    "color.icon.accent.blue": "--ds-icon-accent-blue",
    "color.icon.accent.purple": "--ds-icon-accent-purple",
    "color.icon.accent.magenta": "--ds-icon-accent-magenta",
    "color.icon.accent.gray": "--ds-icon-accent-gray",
    "color.icon.disabled": "--ds-icon-disabled",
    "color.icon.inverse": "--ds-icon-inverse",
    "color.icon.selected": "--ds-icon-selected",
    "color.icon.brand": "--ds-icon-brand",
    "color.icon.danger": "--ds-icon-danger",
    "color.icon.warning": "--ds-icon-warning",
    "color.icon.warning.inverse": "--ds-icon-warning-inverse",
    "color.icon.success": "--ds-icon-success",
    "color.icon.discovery": "--ds-icon-discovery",
    "color.icon.information": "--ds-icon-information",
    "color.icon.subtlest": "--ds-icon-subtlest",
    "color.icon.subtle": "--ds-icon-subtle",
    "color.border": "--ds-border",
    "color.border.accent.lime": "--ds-border-accent-lime",
    "color.border.accent.red": "--ds-border-accent-red",
    "color.border.accent.orange": "--ds-border-accent-orange",
    "color.border.accent.yellow": "--ds-border-accent-yellow",
    "color.border.accent.green": "--ds-border-accent-green",
    "color.border.accent.teal": "--ds-border-accent-teal",
    "color.border.accent.blue": "--ds-border-accent-blue",
    "color.border.accent.purple": "--ds-border-accent-purple",
    "color.border.accent.magenta": "--ds-border-accent-magenta",
    "color.border.accent.gray": "--ds-border-accent-gray",
    "color.border.disabled": "--ds-border-disabled",
    "color.border.focused": "--ds-border-focused",
    "color.border.input": "--ds-border-input",
    "color.border.inverse": "--ds-border-inverse",
    "color.border.selected": "--ds-border-selected",
    "color.border.brand": "--ds-border-brand",
    "color.border.danger": "--ds-border-danger",
    "color.border.warning": "--ds-border-warning",
    "color.border.success": "--ds-border-success",
    "color.border.discovery": "--ds-border-discovery",
    "color.border.information": "--ds-border-information",
    "color.border.bold": "--ds-border-bold",
    "color.background.accent.lime.subtlest": "--ds-background-accent-lime-subtlest",
    "color.background.accent.lime.subtlest.hovered": "--ds-background-accent-lime-subtlest-hovered",
    "color.background.accent.lime.subtlest.pressed": "--ds-background-accent-lime-subtlest-pressed",
    "color.background.accent.lime.subtler": "--ds-background-accent-lime-subtler",
    "color.background.accent.lime.subtler.hovered": "--ds-background-accent-lime-subtler-hovered",
    "color.background.accent.lime.subtler.pressed": "--ds-background-accent-lime-subtler-pressed",
    "color.background.accent.lime.subtle": "--ds-background-accent-lime-subtle",
    "color.background.accent.lime.subtle.hovered": "--ds-background-accent-lime-subtle-hovered",
    "color.background.accent.lime.subtle.pressed": "--ds-background-accent-lime-subtle-pressed",
    "color.background.accent.lime.bolder": "--ds-background-accent-lime-bolder",
    "color.background.accent.lime.bolder.hovered": "--ds-background-accent-lime-bolder-hovered",
    "color.background.accent.lime.bolder.pressed": "--ds-background-accent-lime-bolder-pressed",
    "color.background.accent.red.subtlest": "--ds-background-accent-red-subtlest",
    "color.background.accent.red.subtlest.hovered": "--ds-background-accent-red-subtlest-hovered",
    "color.background.accent.red.subtlest.pressed": "--ds-background-accent-red-subtlest-pressed",
    "color.background.accent.red.subtler": "--ds-background-accent-red-subtler",
    "color.background.accent.red.subtler.hovered": "--ds-background-accent-red-subtler-hovered",
    "color.background.accent.red.subtler.pressed": "--ds-background-accent-red-subtler-pressed",
    "color.background.accent.red.subtle": "--ds-background-accent-red-subtle",
    "color.background.accent.red.subtle.hovered": "--ds-background-accent-red-subtle-hovered",
    "color.background.accent.red.subtle.pressed": "--ds-background-accent-red-subtle-pressed",
    "color.background.accent.red.bolder": "--ds-background-accent-red-bolder",
    "color.background.accent.red.bolder.hovered": "--ds-background-accent-red-bolder-hovered",
    "color.background.accent.red.bolder.pressed": "--ds-background-accent-red-bolder-pressed",
    "color.background.accent.orange.subtlest": "--ds-background-accent-orange-subtlest",
    "color.background.accent.orange.subtlest.hovered": "--ds-background-accent-orange-subtlest-hovered",
    "color.background.accent.orange.subtlest.pressed": "--ds-background-accent-orange-subtlest-pressed",
    "color.background.accent.orange.subtler": "--ds-background-accent-orange-subtler",
    "color.background.accent.orange.subtler.hovered": "--ds-background-accent-orange-subtler-hovered",
    "color.background.accent.orange.subtler.pressed": "--ds-background-accent-orange-subtler-pressed",
    "color.background.accent.orange.subtle": "--ds-background-accent-orange-subtle",
    "color.background.accent.orange.subtle.hovered": "--ds-background-accent-orange-subtle-hovered",
    "color.background.accent.orange.subtle.pressed": "--ds-background-accent-orange-subtle-pressed",
    "color.background.accent.orange.bolder": "--ds-background-accent-orange-bolder",
    "color.background.accent.orange.bolder.hovered": "--ds-background-accent-orange-bolder-hovered",
    "color.background.accent.orange.bolder.pressed": "--ds-background-accent-orange-bolder-pressed",
    "color.background.accent.yellow.subtlest": "--ds-background-accent-yellow-subtlest",
    "color.background.accent.yellow.subtlest.hovered": "--ds-background-accent-yellow-subtlest-hovered",
    "color.background.accent.yellow.subtlest.pressed": "--ds-background-accent-yellow-subtlest-pressed",
    "color.background.accent.yellow.subtler": "--ds-background-accent-yellow-subtler",
    "color.background.accent.yellow.subtler.hovered": "--ds-background-accent-yellow-subtler-hovered",
    "color.background.accent.yellow.subtler.pressed": "--ds-background-accent-yellow-subtler-pressed",
    "color.background.accent.yellow.subtle": "--ds-background-accent-yellow-subtle",
    "color.background.accent.yellow.subtle.hovered": "--ds-background-accent-yellow-subtle-hovered",
    "color.background.accent.yellow.subtle.pressed": "--ds-background-accent-yellow-subtle-pressed",
    "color.background.accent.yellow.bolder": "--ds-background-accent-yellow-bolder",
    "color.background.accent.yellow.bolder.hovered": "--ds-background-accent-yellow-bolder-hovered",
    "color.background.accent.yellow.bolder.pressed": "--ds-background-accent-yellow-bolder-pressed",
    "color.background.accent.green.subtlest": "--ds-background-accent-green-subtlest",
    "color.background.accent.green.subtlest.hovered": "--ds-background-accent-green-subtlest-hovered",
    "color.background.accent.green.subtlest.pressed": "--ds-background-accent-green-subtlest-pressed",
    "color.background.accent.green.subtler": "--ds-background-accent-green-subtler",
    "color.background.accent.green.subtler.hovered": "--ds-background-accent-green-subtler-hovered",
    "color.background.accent.green.subtler.pressed": "--ds-background-accent-green-subtler-pressed",
    "color.background.accent.green.subtle": "--ds-background-accent-green-subtle",
    "color.background.accent.green.subtle.hovered": "--ds-background-accent-green-subtle-hovered",
    "color.background.accent.green.subtle.pressed": "--ds-background-accent-green-subtle-pressed",
    "color.background.accent.green.bolder": "--ds-background-accent-green-bolder",
    "color.background.accent.green.bolder.hovered": "--ds-background-accent-green-bolder-hovered",
    "color.background.accent.green.bolder.pressed": "--ds-background-accent-green-bolder-pressed",
    "color.background.accent.teal.subtlest": "--ds-background-accent-teal-subtlest",
    "color.background.accent.teal.subtlest.hovered": "--ds-background-accent-teal-subtlest-hovered",
    "color.background.accent.teal.subtlest.pressed": "--ds-background-accent-teal-subtlest-pressed",
    "color.background.accent.teal.subtler": "--ds-background-accent-teal-subtler",
    "color.background.accent.teal.subtler.hovered": "--ds-background-accent-teal-subtler-hovered",
    "color.background.accent.teal.subtler.pressed": "--ds-background-accent-teal-subtler-pressed",
    "color.background.accent.teal.subtle": "--ds-background-accent-teal-subtle",
    "color.background.accent.teal.subtle.hovered": "--ds-background-accent-teal-subtle-hovered",
    "color.background.accent.teal.subtle.pressed": "--ds-background-accent-teal-subtle-pressed",
    "color.background.accent.teal.bolder": "--ds-background-accent-teal-bolder",
    "color.background.accent.teal.bolder.hovered": "--ds-background-accent-teal-bolder-hovered",
    "color.background.accent.teal.bolder.pressed": "--ds-background-accent-teal-bolder-pressed",
    "color.background.accent.blue.subtlest": "--ds-background-accent-blue-subtlest",
    "color.background.accent.blue.subtlest.hovered": "--ds-background-accent-blue-subtlest-hovered",
    "color.background.accent.blue.subtlest.pressed": "--ds-background-accent-blue-subtlest-pressed",
    "color.background.accent.blue.subtler": "--ds-background-accent-blue-subtler",
    "color.background.accent.blue.subtler.hovered": "--ds-background-accent-blue-subtler-hovered",
    "color.background.accent.blue.subtler.pressed": "--ds-background-accent-blue-subtler-pressed",
    "color.background.accent.blue.subtle": "--ds-background-accent-blue-subtle",
    "color.background.accent.blue.subtle.hovered": "--ds-background-accent-blue-subtle-hovered",
    "color.background.accent.blue.subtle.pressed": "--ds-background-accent-blue-subtle-pressed",
    "color.background.accent.blue.bolder": "--ds-background-accent-blue-bolder",
    "color.background.accent.blue.bolder.hovered": "--ds-background-accent-blue-bolder-hovered",
    "color.background.accent.blue.bolder.pressed": "--ds-background-accent-blue-bolder-pressed",
    "color.background.accent.purple.subtlest": "--ds-background-accent-purple-subtlest",
    "color.background.accent.purple.subtlest.hovered": "--ds-background-accent-purple-subtlest-hovered",
    "color.background.accent.purple.subtlest.pressed": "--ds-background-accent-purple-subtlest-pressed",
    "color.background.accent.purple.subtler": "--ds-background-accent-purple-subtler",
    "color.background.accent.purple.subtler.hovered": "--ds-background-accent-purple-subtler-hovered",
    "color.background.accent.purple.subtler.pressed": "--ds-background-accent-purple-subtler-pressed",
    "color.background.accent.purple.subtle": "--ds-background-accent-purple-subtle",
    "color.background.accent.purple.subtle.hovered": "--ds-background-accent-purple-subtle-hovered",
    "color.background.accent.purple.subtle.pressed": "--ds-background-accent-purple-subtle-pressed",
    "color.background.accent.purple.bolder": "--ds-background-accent-purple-bolder",
    "color.background.accent.purple.bolder.hovered": "--ds-background-accent-purple-bolder-hovered",
    "color.background.accent.purple.bolder.pressed": "--ds-background-accent-purple-bolder-pressed",
    "color.background.accent.magenta.subtlest": "--ds-background-accent-magenta-subtlest",
    "color.background.accent.magenta.subtlest.hovered": "--ds-background-accent-magenta-subtlest-hovered",
    "color.background.accent.magenta.subtlest.pressed": "--ds-background-accent-magenta-subtlest-pressed",
    "color.background.accent.magenta.subtler": "--ds-background-accent-magenta-subtler",
    "color.background.accent.magenta.subtler.hovered": "--ds-background-accent-magenta-subtler-hovered",
    "color.background.accent.magenta.subtler.pressed": "--ds-background-accent-magenta-subtler-pressed",
    "color.background.accent.magenta.subtle": "--ds-background-accent-magenta-subtle",
    "color.background.accent.magenta.subtle.hovered": "--ds-background-accent-magenta-subtle-hovered",
    "color.background.accent.magenta.subtle.pressed": "--ds-background-accent-magenta-subtle-pressed",
    "color.background.accent.magenta.bolder": "--ds-background-accent-magenta-bolder",
    "color.background.accent.magenta.bolder.hovered": "--ds-background-accent-magenta-bolder-hovered",
    "color.background.accent.magenta.bolder.pressed": "--ds-background-accent-magenta-bolder-pressed",
    "color.background.accent.gray.subtlest": "--ds-background-accent-gray-subtlest",
    "color.background.accent.gray.subtlest.hovered": "--ds-background-accent-gray-subtlest-hovered",
    "color.background.accent.gray.subtlest.pressed": "--ds-background-accent-gray-subtlest-pressed",
    "color.background.accent.gray.subtler": "--ds-background-accent-gray-subtler",
    "color.background.accent.gray.subtler.hovered": "--ds-background-accent-gray-subtler-hovered",
    "color.background.accent.gray.subtler.pressed": "--ds-background-accent-gray-subtler-pressed",
    "color.background.accent.gray.subtle": "--ds-background-accent-gray-subtle",
    "color.background.accent.gray.subtle.hovered": "--ds-background-accent-gray-subtle-hovered",
    "color.background.accent.gray.subtle.pressed": "--ds-background-accent-gray-subtle-pressed",
    "color.background.accent.gray.bolder": "--ds-background-accent-gray-bolder",
    "color.background.accent.gray.bolder.hovered": "--ds-background-accent-gray-bolder-hovered",
    "color.background.accent.gray.bolder.pressed": "--ds-background-accent-gray-bolder-pressed",
    "color.background.disabled": "--ds-background-disabled",
    "color.background.input": "--ds-background-input",
    "color.background.input.hovered": "--ds-background-input-hovered",
    "color.background.input.pressed": "--ds-background-input-pressed",
    "color.background.inverse.subtle": "--ds-background-inverse-subtle",
    "color.background.inverse.subtle.hovered": "--ds-background-inverse-subtle-hovered",
    "color.background.inverse.subtle.pressed": "--ds-background-inverse-subtle-pressed",
    "color.background.neutral": "--ds-background-neutral",
    "color.background.neutral.hovered": "--ds-background-neutral-hovered",
    "color.background.neutral.pressed": "--ds-background-neutral-pressed",
    "color.background.neutral.subtle": "--ds-background-neutral-subtle",
    "color.background.neutral.subtle.hovered": "--ds-background-neutral-subtle-hovered",
    "color.background.neutral.subtle.pressed": "--ds-background-neutral-subtle-pressed",
    "color.background.neutral.bold": "--ds-background-neutral-bold",
    "color.background.neutral.bold.hovered": "--ds-background-neutral-bold-hovered",
    "color.background.neutral.bold.pressed": "--ds-background-neutral-bold-pressed",
    "color.background.selected": "--ds-background-selected",
    "color.background.selected.hovered": "--ds-background-selected-hovered",
    "color.background.selected.pressed": "--ds-background-selected-pressed",
    "color.background.selected.bold": "--ds-background-selected-bold",
    "color.background.selected.bold.hovered": "--ds-background-selected-bold-hovered",
    "color.background.selected.bold.pressed": "--ds-background-selected-bold-pressed",
    "color.background.brand.subtlest": "--ds-background-brand-subtlest",
    "color.background.brand.subtlest.hovered": "--ds-background-brand-subtlest-hovered",
    "color.background.brand.subtlest.pressed": "--ds-background-brand-subtlest-pressed",
    "color.background.brand.bold": "--ds-background-brand-bold",
    "color.background.brand.bold.hovered": "--ds-background-brand-bold-hovered",
    "color.background.brand.bold.pressed": "--ds-background-brand-bold-pressed",
    "color.background.brand.boldest": "--ds-background-brand-boldest",
    "color.background.brand.boldest.hovered": "--ds-background-brand-boldest-hovered",
    "color.background.brand.boldest.pressed": "--ds-background-brand-boldest-pressed",
    "color.background.danger": "--ds-background-danger",
    "color.background.danger.hovered": "--ds-background-danger-hovered",
    "color.background.danger.pressed": "--ds-background-danger-pressed",
    "color.background.danger.bold": "--ds-background-danger-bold",
    "color.background.danger.bold.hovered": "--ds-background-danger-bold-hovered",
    "color.background.danger.bold.pressed": "--ds-background-danger-bold-pressed",
    "color.background.warning": "--ds-background-warning",
    "color.background.warning.hovered": "--ds-background-warning-hovered",
    "color.background.warning.pressed": "--ds-background-warning-pressed",
    "color.background.warning.bold": "--ds-background-warning-bold",
    "color.background.warning.bold.hovered": "--ds-background-warning-bold-hovered",
    "color.background.warning.bold.pressed": "--ds-background-warning-bold-pressed",
    "color.background.success": "--ds-background-success",
    "color.background.success.hovered": "--ds-background-success-hovered",
    "color.background.success.pressed": "--ds-background-success-pressed",
    "color.background.success.bold": "--ds-background-success-bold",
    "color.background.success.bold.hovered": "--ds-background-success-bold-hovered",
    "color.background.success.bold.pressed": "--ds-background-success-bold-pressed",
    "color.background.discovery": "--ds-background-discovery",
    "color.background.discovery.hovered": "--ds-background-discovery-hovered",
    "color.background.discovery.pressed": "--ds-background-discovery-pressed",
    "color.background.discovery.bold": "--ds-background-discovery-bold",
    "color.background.discovery.bold.hovered": "--ds-background-discovery-bold-hovered",
    "color.background.discovery.bold.pressed": "--ds-background-discovery-bold-pressed",
    "color.background.information": "--ds-background-information",
    "color.background.information.hovered": "--ds-background-information-hovered",
    "color.background.information.pressed": "--ds-background-information-pressed",
    "color.background.information.bold": "--ds-background-information-bold",
    "color.background.information.bold.hovered": "--ds-background-information-bold-hovered",
    "color.background.information.bold.pressed": "--ds-background-information-bold-pressed",
    "color.blanket": "--ds-blanket",
    "color.blanket.selected": "--ds-blanket-selected",
    "color.blanket.danger": "--ds-blanket-danger",
    "color.interaction.hovered": "--ds-interaction-hovered",
    "color.interaction.pressed": "--ds-interaction-pressed",
    "color.skeleton": "--ds-skeleton",
    "color.skeleton.subtle": "--ds-skeleton-subtle",
    "color.chart.categorical.1": "--ds-chart-categorical-1",
    "color.chart.categorical.1.hovered": "--ds-chart-categorical-1-hovered",
    "color.chart.categorical.2": "--ds-chart-categorical-2",
    "color.chart.categorical.2.hovered": "--ds-chart-categorical-2-hovered",
    "color.chart.categorical.3": "--ds-chart-categorical-3",
    "color.chart.categorical.3.hovered": "--ds-chart-categorical-3-hovered",
    "color.chart.categorical.4": "--ds-chart-categorical-4",
    "color.chart.categorical.4.hovered": "--ds-chart-categorical-4-hovered",
    "color.chart.categorical.5": "--ds-chart-categorical-5",
    "color.chart.categorical.5.hovered": "--ds-chart-categorical-5-hovered",
    "color.chart.categorical.6": "--ds-chart-categorical-6",
    "color.chart.categorical.6.hovered": "--ds-chart-categorical-6-hovered",
    "color.chart.categorical.7": "--ds-chart-categorical-7",
    "color.chart.categorical.7.hovered": "--ds-chart-categorical-7-hovered",
    "color.chart.categorical.8": "--ds-chart-categorical-8",
    "color.chart.categorical.8.hovered": "--ds-chart-categorical-8-hovered",
    "color.chart.lime.bold": "--ds-chart-lime-bold",
    "color.chart.lime.bold.hovered": "--ds-chart-lime-bold-hovered",
    "color.chart.lime.bolder": "--ds-chart-lime-bolder",
    "color.chart.lime.bolder.hovered": "--ds-chart-lime-bolder-hovered",
    "color.chart.lime.boldest": "--ds-chart-lime-boldest",
    "color.chart.lime.boldest.hovered": "--ds-chart-lime-boldest-hovered",
    "color.chart.neutral": "--ds-chart-neutral",
    "color.chart.neutral.hovered": "--ds-chart-neutral-hovered",
    "color.chart.red.bold": "--ds-chart-red-bold",
    "color.chart.red.bold.hovered": "--ds-chart-red-bold-hovered",
    "color.chart.red.bolder": "--ds-chart-red-bolder",
    "color.chart.red.bolder.hovered": "--ds-chart-red-bolder-hovered",
    "color.chart.red.boldest": "--ds-chart-red-boldest",
    "color.chart.red.boldest.hovered": "--ds-chart-red-boldest-hovered",
    "color.chart.orange.bold": "--ds-chart-orange-bold",
    "color.chart.orange.bold.hovered": "--ds-chart-orange-bold-hovered",
    "color.chart.orange.bolder": "--ds-chart-orange-bolder",
    "color.chart.orange.bolder.hovered": "--ds-chart-orange-bolder-hovered",
    "color.chart.orange.boldest": "--ds-chart-orange-boldest",
    "color.chart.orange.boldest.hovered": "--ds-chart-orange-boldest-hovered",
    "color.chart.yellow.bold": "--ds-chart-yellow-bold",
    "color.chart.yellow.bold.hovered": "--ds-chart-yellow-bold-hovered",
    "color.chart.yellow.bolder": "--ds-chart-yellow-bolder",
    "color.chart.yellow.bolder.hovered": "--ds-chart-yellow-bolder-hovered",
    "color.chart.yellow.boldest": "--ds-chart-yellow-boldest",
    "color.chart.yellow.boldest.hovered": "--ds-chart-yellow-boldest-hovered",
    "color.chart.green.bold": "--ds-chart-green-bold",
    "color.chart.green.bold.hovered": "--ds-chart-green-bold-hovered",
    "color.chart.green.bolder": "--ds-chart-green-bolder",
    "color.chart.green.bolder.hovered": "--ds-chart-green-bolder-hovered",
    "color.chart.green.boldest": "--ds-chart-green-boldest",
    "color.chart.green.boldest.hovered": "--ds-chart-green-boldest-hovered",
    "color.chart.teal.bold": "--ds-chart-teal-bold",
    "color.chart.teal.bold.hovered": "--ds-chart-teal-bold-hovered",
    "color.chart.teal.bolder": "--ds-chart-teal-bolder",
    "color.chart.teal.bolder.hovered": "--ds-chart-teal-bolder-hovered",
    "color.chart.teal.boldest": "--ds-chart-teal-boldest",
    "color.chart.teal.boldest.hovered": "--ds-chart-teal-boldest-hovered",
    "color.chart.blue.bold": "--ds-chart-blue-bold",
    "color.chart.blue.bold.hovered": "--ds-chart-blue-bold-hovered",
    "color.chart.blue.bolder": "--ds-chart-blue-bolder",
    "color.chart.blue.bolder.hovered": "--ds-chart-blue-bolder-hovered",
    "color.chart.blue.boldest": "--ds-chart-blue-boldest",
    "color.chart.blue.boldest.hovered": "--ds-chart-blue-boldest-hovered",
    "color.chart.purple.bold": "--ds-chart-purple-bold",
    "color.chart.purple.bold.hovered": "--ds-chart-purple-bold-hovered",
    "color.chart.purple.bolder": "--ds-chart-purple-bolder",
    "color.chart.purple.bolder.hovered": "--ds-chart-purple-bolder-hovered",
    "color.chart.purple.boldest": "--ds-chart-purple-boldest",
    "color.chart.purple.boldest.hovered": "--ds-chart-purple-boldest-hovered",
    "color.chart.magenta.bold": "--ds-chart-magenta-bold",
    "color.chart.magenta.bold.hovered": "--ds-chart-magenta-bold-hovered",
    "color.chart.magenta.bolder": "--ds-chart-magenta-bolder",
    "color.chart.magenta.bolder.hovered": "--ds-chart-magenta-bolder-hovered",
    "color.chart.magenta.boldest": "--ds-chart-magenta-boldest",
    "color.chart.magenta.boldest.hovered": "--ds-chart-magenta-boldest-hovered",
    "color.chart.gray.bold": "--ds-chart-gray-bold",
    "color.chart.gray.bold.hovered": "--ds-chart-gray-bold-hovered",
    "color.chart.gray.bolder": "--ds-chart-gray-bolder",
    "color.chart.gray.bolder.hovered": "--ds-chart-gray-bolder-hovered",
    "color.chart.gray.boldest": "--ds-chart-gray-boldest",
    "color.chart.gray.boldest.hovered": "--ds-chart-gray-boldest-hovered",
    "color.chart.brand": "--ds-chart-brand",
    "color.chart.brand.hovered": "--ds-chart-brand-hovered",
    "color.chart.danger": "--ds-chart-danger",
    "color.chart.danger.hovered": "--ds-chart-danger-hovered",
    "color.chart.danger.bold": "--ds-chart-danger-bold",
    "color.chart.danger.bold.hovered": "--ds-chart-danger-bold-hovered",
    "color.chart.warning": "--ds-chart-warning",
    "color.chart.warning.hovered": "--ds-chart-warning-hovered",
    "color.chart.warning.bold": "--ds-chart-warning-bold",
    "color.chart.warning.bold.hovered": "--ds-chart-warning-bold-hovered",
    "color.chart.success": "--ds-chart-success",
    "color.chart.success.hovered": "--ds-chart-success-hovered",
    "color.chart.success.bold": "--ds-chart-success-bold",
    "color.chart.success.bold.hovered": "--ds-chart-success-bold-hovered",
    "color.chart.discovery": "--ds-chart-discovery",
    "color.chart.discovery.hovered": "--ds-chart-discovery-hovered",
    "color.chart.discovery.bold": "--ds-chart-discovery-bold",
    "color.chart.discovery.bold.hovered": "--ds-chart-discovery-bold-hovered",
    "color.chart.information": "--ds-chart-information",
    "color.chart.information.hovered": "--ds-chart-information-hovered",
    "color.chart.information.bold": "--ds-chart-information-bold",
    "color.chart.information.bold.hovered": "--ds-chart-information-bold-hovered",
    "elevation.surface": "--ds-surface",
    "elevation.surface.hovered": "--ds-surface-hovered",
    "elevation.surface.pressed": "--ds-surface-pressed",
    "elevation.surface.overlay": "--ds-surface-overlay",
    "elevation.surface.overlay.hovered": "--ds-surface-overlay-hovered",
    "elevation.surface.overlay.pressed": "--ds-surface-overlay-pressed",
    "elevation.surface.raised": "--ds-surface-raised",
    "elevation.surface.raised.hovered": "--ds-surface-raised-hovered",
    "elevation.surface.raised.pressed": "--ds-surface-raised-pressed",
    "elevation.surface.sunken": "--ds-surface-sunken",
    "elevation.shadow.overflow": "--ds-shadow-overflow",
    "elevation.shadow.overflow.perimeter": "--ds-shadow-overflow-perimeter",
    "elevation.shadow.overflow.spread": "--ds-shadow-overflow-spread",
    "elevation.shadow.overlay": "--ds-shadow-overlay",
    "elevation.shadow.raised": "--ds-shadow-raised",
    "opacity.disabled": "--ds-opacity-disabled",
    "opacity.loading": "--ds-opacity-loading",
    "utility.UNSAFE.textTransformUppercase": "--ds-UNSAFE-textTransformUppercase",
    "utility.UNSAFE.transparent": "--ds-UNSAFE-transparent",
    "utility.elevation.surface.current": "--ds-elevation-surface-current",
    "border.radius.050": "--ds-border-radius-050",
    "border.radius": "--ds-border-radius",
    "border.radius.100": "--ds-border-radius-100",
    "border.radius.200": "--ds-border-radius-200",
    "border.radius.300": "--ds-border-radius-300",
    "border.radius.400": "--ds-border-radius-400",
    "border.radius.circle": "--ds-border-radius-circle",
    "border.width": "--ds-border-width",
    "border.width.0": "--ds-border-width-0",
    "border.width.indicator": "--ds-border-width-indicator",
    "border.width.outline": "--ds-border-width-outline",
    "space.0": "--ds-space-0",
    "space.025": "--ds-space-025",
    "space.050": "--ds-space-050",
    "space.075": "--ds-space-075",
    "space.100": "--ds-space-100",
    "space.150": "--ds-space-150",
    "space.200": "--ds-space-200",
    "space.250": "--ds-space-250",
    "space.300": "--ds-space-300",
    "space.400": "--ds-space-400",
    "space.500": "--ds-space-500",
    "space.600": "--ds-space-600",
    "space.800": "--ds-space-800",
    "space.1000": "--ds-space-1000",
    "space.negative.025": "--ds-space-negative-025",
    "space.negative.050": "--ds-space-negative-050",
    "space.negative.075": "--ds-space-negative-075",
    "space.negative.100": "--ds-space-negative-100",
    "space.negative.150": "--ds-space-negative-150",
    "space.negative.200": "--ds-space-negative-200",
    "space.negative.250": "--ds-space-negative-250",
    "space.negative.300": "--ds-space-negative-300",
    "space.negative.400": "--ds-space-negative-400",
    "font.heading.xxlarge": "--ds-font-heading-xxlarge",
    "font.heading.xlarge": "--ds-font-heading-xlarge",
    "font.heading.large": "--ds-font-heading-large",
    "font.heading.medium": "--ds-font-heading-medium",
    "font.heading.small": "--ds-font-heading-small",
    "font.heading.xsmall": "--ds-font-heading-xsmall",
    "font.heading.xxsmall": "--ds-font-heading-xxsmall",
    "font.body.large": "--ds-font-body-large",
    "font.body": "--ds-font-body",
    "font.body.small": "--ds-font-body-small",
    "font.body.UNSAFE_small": "--ds-font-body-UNSAFE_small",
    "font.metric.large": "--ds-font-metric-large",
    "font.metric.medium": "--ds-font-metric-medium",
    "font.metric.small": "--ds-font-metric-small",
    "font.code": "--ds-font-code",
    "font.weight.regular": "--ds-font-weight-regular",
    "font.weight.medium": "--ds-font-weight-medium",
    "font.weight.semibold": "--ds-font-weight-semibold",
    "font.weight.bold": "--ds-font-weight-bold",
    "font.family.heading": "--ds-font-family-heading",
    "font.family.body": "--ds-font-family-body",
    "font.family.code": "--ds-font-family-code",
    "font.family.brand.heading": "--ds-font-family-brand-heading",
    "font.family.brand.body": "--ds-font-family-brand-body"
};
var $ba440580a74628a1$export$2e2bcd8739ae039 = $ba440580a74628a1$var$tokens;

});


parcelRegister("9LO6I", function(module, exports) {

$parcel$export(module.exports, "getThemePreferences", function () { return $71cf5f2133366006$export$dd6aeb7c823fc03d; });
$parcel$export(module.exports, "getThemeOverridePreferences", function () { return $71cf5f2133366006$export$5d76d7014f4a5d08; });

var $TjxRP = parcelRequire("TjxRP");

var $jxLBU = parcelRequire("jxLBU");

var $ACtU3 = parcelRequire("ACtU3");
var $71cf5f2133366006$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === "auto") {
        if (contrastMode !== "no-preference" && (0, $jxLBU.fg)("platform_increased-contrast-themes")) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $ACtU3.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== "no-preference" && (0, $jxLBU.fg)("platform_increased-contrast-themes")) {
            var increasedContrastTheme = (0, $ACtU3.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, $TjxRP.default)(new Set(themePreferences));
};
var $71cf5f2133366006$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, $TjxRP.default)(new Set(themeOverridePreferences));
};

});
parcelRegister("ACtU3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06e1367e6c1f14aa$export$2e2bcd8739ae039; });

var $hedGb = parcelRequire("hedGb");

var $ehRbc = parcelRequire("ehRbc");
function $06e1367e6c1f14aa$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $ehRbc.default)).find(function(_ref) {
        var _ref2 = (0, $hedGb.default)(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}

});


parcelRegister("lmUkA", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("hVFq5")).then(()=>parcelRequire("cOsFj"));

});


parcelRegister("96Jyw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a180305523a4b59$export$2e2bcd8739ae039; });

var $gizSW = parcelRequire("gizSW");

var $9XJr0 = parcelRequire("9XJr0");

var $e1TEF = parcelRequire("e1TEF");

var $hvvbS = parcelRequire("hvvbS");

var $4NEBB = parcelRequire("4NEBB");
/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $6a180305523a4b59$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, $gizSW.default)(this, ThemeMutationObserver);
        (0, $e1TEF.default)(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, $9XJr0.default)(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $4NEBB.default)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $hvvbS.THEME_DATA_ATTRIBUTE),
                            (0, $hvvbS.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, $e1TEF.default)($6a180305523a4b59$export$2e2bcd8739ae039, "observer", null);
(0, $e1TEF.default)($6a180305523a4b59$export$2e2bcd8739ae039, "callbacks", new Set());

});


parcelRegister("4mM75", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::76f067d08aa7c324d1505318ade2e26f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32de89ce2440f456$var$_react = $32de89ce2440f456$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $32de89ce2440f456$var$_baseNew = $32de89ce2440f456$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $32de89ce2440f456$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Alert".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for alerts in JSM and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $32de89ce2440f456$var$AlertIcon = (props)=>/*#__PURE__*/ $32de89ce2440f456$var$_react.default.createElement($32de89ce2440f456$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 0v3h-1.5V0zM2.123 1.063 4.172 3.11 3.11 4.17 1.063 2.124zm12.814 1.06L12.89 4.172 11.83 3.11l2.047-2.048zM4.195 5.875A1.5 1.5 0 0 1 5.69 4.5h4.62a1.5 1.5 0 0 1 1.495 1.375l.635 7.625H14V15H2v-1.5h1.56zm.87 7.625h5.87L10.31 6H5.69z" clip-rule="evenodd"/>`
    }, props));
$32de89ce2440f456$var$AlertIcon.displayName = "AlertIcon";
var $32de89ce2440f456$var$_default = module.exports.default = $32de89ce2440f456$var$AlertIcon;

});

parcelRegister("jUWXi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::54f75e2054943fb775b789c9f2b57e27>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e800fa9e8b124f98$var$_react = $e800fa9e8b124f98$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $e800fa9e8b124f98$var$_baseNew = $e800fa9e8b124f98$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $e800fa9e8b124f98$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bar charts; Reports in JSM, Space Analytics in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e800fa9e8b124f98$var$ChartBarIcon = (props)=>/*#__PURE__*/ $e800fa9e8b124f98$var$_react.default.createElement($e800fa9e8b124f98$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="m5.25 8.5.077.004A.75.75 0 0 1 6 9.25v2.5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 .75-.75zm4-3.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 8.25 5zm4-3a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$e800fa9e8b124f98$var$ChartBarIcon.displayName = "ChartBarIcon";
var $e800fa9e8b124f98$var$_default = module.exports.default = $e800fa9e8b124f98$var$ChartBarIcon;

});

parcelRegister("bNqWX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::de887aadbfedd5e674ee79e9bf8242ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89692d04c9f53368$var$_react = $89692d04c9f53368$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $89692d04c9f53368$var$_baseNew = $89692d04c9f53368$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $89692d04c9f53368$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LobbyBell".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: risks in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $89692d04c9f53368$var$LobbyBellIcon = (props)=>/*#__PURE__*/ $89692d04c9f53368$var$_react.default.createElement($89692d04c9f53368$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1h4v1.5H8.75v1.75h.92a4.75 4.75 0 0 1 4.72 4.225l.355 3.192A.75.75 0 0 1 14 12.5H2a.75.75 0 0 1-.745-.833l.354-3.192A4.75 4.75 0 0 1 6.33 4.25h.92V2.5H6zm.33 4.75A3.25 3.25 0 0 0 3.1 8.641L2.838 11h10.324L12.9 8.641A3.25 3.25 0 0 0 9.67 5.75zM15 13.5V15H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$89692d04c9f53368$var$LobbyBellIcon.displayName = "LobbyBellIcon";
var $89692d04c9f53368$var$_default = module.exports.default = $89692d04c9f53368$var$LobbyBellIcon;

});

parcelRegister("aLqNf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f64abe706416b0877b5dd221be64e7d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d6313c91c7359ed$var$_react = $7d6313c91c7359ed$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $7d6313c91c7359ed$var$_baseNew = $7d6313c91c7359ed$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $7d6313c91c7359ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7d6313c91c7359ed$var$PageIcon = (props)=>/*#__PURE__*/ $7d6313c91c7359ed$var$_react.default.createElement($7d6313c91c7359ed$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$7d6313c91c7359ed$var$PageIcon.displayName = "PageIcon";
var $7d6313c91c7359ed$var$_default = module.exports.default = $7d6313c91c7359ed$var$PageIcon;

});

parcelRegister("7DwKW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $58f5959e6ceaaa31$var$_react = $58f5959e6ceaaa31$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $58f5959e6ceaaa31$var$_baseNew = $58f5959e6ceaaa31$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $58f5959e6ceaaa31$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $58f5959e6ceaaa31$var$AutomationIcon = (props)=>/*#__PURE__*/ $58f5959e6ceaaa31$var$_react.default.createElement($58f5959e6ceaaa31$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$58f5959e6ceaaa31$var$AutomationIcon.displayName = "AutomationIcon";
var $58f5959e6ceaaa31$var$_default = module.exports.default = $58f5959e6ceaaa31$var$AutomationIcon;

});

parcelRegister("3Xdhp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c939fd7642839817f37f5fef435fb296>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e112ed9ad5aeb06$var$_react = $2e112ed9ad5aeb06$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $2e112ed9ad5aeb06$var$_baseNew = $2e112ed9ad5aeb06$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $2e112ed9ad5aeb06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2e112ed9ad5aeb06$var$ChangesIcon = (props)=>/*#__PURE__*/ $2e112ed9ad5aeb06$var$_react.default.createElement($2e112ed9ad5aeb06$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$2e112ed9ad5aeb06$var$ChangesIcon.displayName = "ChangesIcon";
var $2e112ed9ad5aeb06$var$_default = module.exports.default = $2e112ed9ad5aeb06$var$ChangesIcon;

});

parcelRegister("7Zpdo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aff4cd926156d74fe58acdf2d87dd6f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d11ca1091cdc9de$var$_react = $5d11ca1091cdc9de$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $5d11ca1091cdc9de$var$_baseNew = $5d11ca1091cdc9de$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $5d11ca1091cdc9de$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d11ca1091cdc9de$var$PagesIcon = (props)=>/*#__PURE__*/ $5d11ca1091cdc9de$var$_react.default.createElement($5d11ca1091cdc9de$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$5d11ca1091cdc9de$var$PagesIcon.displayName = "PagesIcon";
var $5d11ca1091cdc9de$var$_default = module.exports.default = $5d11ca1091cdc9de$var$PagesIcon;

});

parcelRegister("6Whls", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3a8c88470e968ec08c5aa075e8f42b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50d59d3b5204e4f5$var$_react = $50d59d3b5204e4f5$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $50d59d3b5204e4f5$var$_baseNew = $50d59d3b5204e4f5$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $50d59d3b5204e4f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBubble".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bubble and matrix charts; Matrix view in in JPD
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $50d59d3b5204e4f5$var$ChartBubbleIcon = (props)=>/*#__PURE__*/ $50d59d3b5204e4f5$var$_react.default.createElement($50d59d3b5204e4f5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M11.27 9.01a1.38 1.38 0 1 1-1.51 1.51l-.01-.14.01-.14A1.38 1.38 0 0 1 11.13 9zM5.75 6.5a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m4.75-5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"/>`
    }, props));
$50d59d3b5204e4f5$var$ChartBubbleIcon.displayName = "ChartBubbleIcon";
var $50d59d3b5204e4f5$var$_default = module.exports.default = $50d59d3b5204e4f5$var$ChartBubbleIcon;

});

parcelRegister("elfku", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d288013ed94ec7ddbe1bb143e39a4fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a70eeaf536306268$var$_react = $a70eeaf536306268$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $a70eeaf536306268$var$_baseNew = $a70eeaf536306268$var$_interopRequireDefault((parcelRequire("bTGUY")));
function $a70eeaf536306268$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BrowserExtension".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for chrome extensions
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a70eeaf536306268$var$BrowserExtensionIcon = (props)=>/*#__PURE__*/ $a70eeaf536306268$var$_react.default.createElement($a70eeaf536306268$var$_baseNew.default, Object.assign({
        name: "BrowserExtensionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.25 2v.5h2.25a2 2 0 0 1 2 2v2.25h.5a2 2 0 1 1 0 4h-.5V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2.25a.75.75 0 0 1 .75-.75h.5a1.25 1.25 0 1 0 0-2.5h-.5A.75.75 0 0 1 1 6.75V4.5a2 2 0 0 1 2-2h2.25V2a2 2 0 1 1 4 0M2.5 4.5A.5.5 0 0 1 3 4h8.5a.5.5 0 0 1 .5.5V13a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-1.511a2.75 2.75 0 0 0 0-5.478z" clip-rule="evenodd"/>`
    }, props));
$a70eeaf536306268$var$BrowserExtensionIcon.displayName = "BrowserExtensionIcon";
var $a70eeaf536306268$var$_default = module.exports.default = $a70eeaf536306268$var$BrowserExtensionIcon;

});

parcelRegister("3SkcQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62b2367dcefa534d3cc5e1a7e205b220>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2d2616ca0d7754f7$var$_react = $2d2616ca0d7754f7$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $2d2616ca0d7754f7$var$_baseNew = $2d2616ca0d7754f7$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $2d2616ca0d7754f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Goal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for goals in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2d2616ca0d7754f7$var$GoalIcon = (props)=>/*#__PURE__*/ $2d2616ca0d7754f7$var$_react.default.createElement($2d2616ca0d7754f7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0" clip-rule="evenodd"/>`
    }, props));
$2d2616ca0d7754f7$var$GoalIcon.displayName = "GoalIcon";
var $2d2616ca0d7754f7$var$_default = module.exports.default = $2d2616ca0d7754f7$var$GoalIcon;

});

parcelRegister("4TbFb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab25c6896d727bd4806885f3b789ade9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $38f558929341d75e$var$_react = $38f558929341d75e$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $38f558929341d75e$var$_baseNew = $38f558929341d75e$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $38f558929341d75e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $38f558929341d75e$var$BugIcon = (props)=>/*#__PURE__*/ $38f558929341d75e$var$_react.default.createElement($38f558929341d75e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$38f558929341d75e$var$BugIcon.displayName = "BugIcon";
var $38f558929341d75e$var$_default = module.exports.default = $38f558929341d75e$var$BugIcon;

});

parcelRegister("iSfb0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbd90adf4f00ef86$var$_react = $dbd90adf4f00ef86$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $dbd90adf4f00ef86$var$_baseNew = $dbd90adf4f00ef86$var$_interopRequireDefault((parcelRequire("bTGUY")));
function $dbd90adf4f00ef86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dbd90adf4f00ef86$var$NotepadIcon = (props)=>/*#__PURE__*/ $dbd90adf4f00ef86$var$_react.default.createElement($dbd90adf4f00ef86$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$dbd90adf4f00ef86$var$NotepadIcon.displayName = "NotepadIcon";
var $dbd90adf4f00ef86$var$_default = module.exports.default = $dbd90adf4f00ef86$var$NotepadIcon;

});

parcelRegister("kuew8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::840e9064aa0761adacec2a7ce2dee628>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eea1ded7df24e1fa$var$_react = $eea1ded7df24e1fa$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $eea1ded7df24e1fa$var$_baseNew = $eea1ded7df24e1fa$var$_interopRequireDefault((parcelRequire("bTGUY")));
function $eea1ded7df24e1fa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sync".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for syncing changes and save operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eea1ded7df24e1fa$var$SyncIcon = (props)=>/*#__PURE__*/ $eea1ded7df24e1fa$var$_react.default.createElement($eea1ded7df24e1fa$var$_baseNew.default, Object.assign({
        name: "SyncIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$eea1ded7df24e1fa$var$SyncIcon.displayName = "SyncIcon";
var $eea1ded7df24e1fa$var$_default = module.exports.default = $eea1ded7df24e1fa$var$SyncIcon;

});

parcelRegister("el1aS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a703f014195acea4$var$_react = $a703f014195acea4$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $a703f014195acea4$var$_link = $a703f014195acea4$var$_interopRequireDefault((parcelRequire("gLhLj")));
function $a703f014195acea4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a703f014195acea4$var$LinkIcon = (props)=>/*#__PURE__*/ $a703f014195acea4$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $a703f014195acea4$var$_link.default
    }));
$a703f014195acea4$var$LinkIcon.displayName = "LinkIcon";
var $a703f014195acea4$var$_default = module.exports.default = $a703f014195acea4$var$LinkIcon;

});

parcelRegister("dxLOu", function(module, exports) {

var $fA0s7 = parcelRequire("fA0s7");

var $7Pwoh = parcelRequire("7Pwoh");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $9dc3722522c72776$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $9dc3722522c72776$var$rsComboMarksRange = "\\u0300-\\u036f", $9dc3722522c72776$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $9dc3722522c72776$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $9dc3722522c72776$var$rsComboRange = $9dc3722522c72776$var$rsComboMarksRange + $9dc3722522c72776$var$reComboHalfMarksRange + $9dc3722522c72776$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $9dc3722522c72776$var$rsCombo = "[" + $9dc3722522c72776$var$rsComboRange + "]";
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $9dc3722522c72776$var$reComboMark = RegExp($9dc3722522c72776$var$rsCombo, "g");
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $9dc3722522c72776$var$deburr(string) {
    string = $7Pwoh(string);
    return string && string.replace($9dc3722522c72776$var$reLatin, $fA0s7).replace($9dc3722522c72776$var$reComboMark, "");
}
module.exports = $9dc3722522c72776$var$deburr;

});
parcelRegister("fA0s7", function(module, exports) {

var $hCB4J = parcelRequire("hCB4J");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $b57a91a6c1bea905$var$deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "\u0100": "A",
    "\u0102": "A",
    "\u0104": "A",
    "\u0101": "a",
    "\u0103": "a",
    "\u0105": "a",
    "\u0106": "C",
    "\u0108": "C",
    "\u010A": "C",
    "\u010C": "C",
    "\u0107": "c",
    "\u0109": "c",
    "\u010B": "c",
    "\u010D": "c",
    "\u010E": "D",
    "\u0110": "D",
    "\u010F": "d",
    "\u0111": "d",
    "\u0112": "E",
    "\u0114": "E",
    "\u0116": "E",
    "\u0118": "E",
    "\u011A": "E",
    "\u0113": "e",
    "\u0115": "e",
    "\u0117": "e",
    "\u0119": "e",
    "\u011B": "e",
    "\u011C": "G",
    "\u011E": "G",
    "\u0120": "G",
    "\u0122": "G",
    "\u011D": "g",
    "\u011F": "g",
    "\u0121": "g",
    "\u0123": "g",
    "\u0124": "H",
    "\u0126": "H",
    "\u0125": "h",
    "\u0127": "h",
    "\u0128": "I",
    "\u012A": "I",
    "\u012C": "I",
    "\u012E": "I",
    "\u0130": "I",
    "\u0129": "i",
    "\u012B": "i",
    "\u012D": "i",
    "\u012F": "i",
    "\u0131": "i",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u0138": "k",
    "\u0139": "L",
    "\u013B": "L",
    "\u013D": "L",
    "\u013F": "L",
    "\u0141": "L",
    "\u013A": "l",
    "\u013C": "l",
    "\u013E": "l",
    "\u0140": "l",
    "\u0142": "l",
    "\u0143": "N",
    "\u0145": "N",
    "\u0147": "N",
    "\u014A": "N",
    "\u0144": "n",
    "\u0146": "n",
    "\u0148": "n",
    "\u014B": "n",
    "\u014C": "O",
    "\u014E": "O",
    "\u0150": "O",
    "\u014D": "o",
    "\u014F": "o",
    "\u0151": "o",
    "\u0154": "R",
    "\u0156": "R",
    "\u0158": "R",
    "\u0155": "r",
    "\u0157": "r",
    "\u0159": "r",
    "\u015A": "S",
    "\u015C": "S",
    "\u015E": "S",
    "\u0160": "S",
    "\u015B": "s",
    "\u015D": "s",
    "\u015F": "s",
    "\u0161": "s",
    "\u0162": "T",
    "\u0164": "T",
    "\u0166": "T",
    "\u0163": "t",
    "\u0165": "t",
    "\u0167": "t",
    "\u0168": "U",
    "\u016A": "U",
    "\u016C": "U",
    "\u016E": "U",
    "\u0170": "U",
    "\u0172": "U",
    "\u0169": "u",
    "\u016B": "u",
    "\u016D": "u",
    "\u016F": "u",
    "\u0171": "u",
    "\u0173": "u",
    "\u0174": "W",
    "\u0175": "w",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "\u0179": "Z",
    "\u017B": "Z",
    "\u017D": "Z",
    "\u017A": "z",
    "\u017C": "z",
    "\u017E": "z",
    "\u0132": "IJ",
    "\u0133": "ij",
    "\u0152": "Oe",
    "\u0153": "oe",
    "\u0149": "'n",
    "\u017F": "s"
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $b57a91a6c1bea905$var$deburrLetter = $hCB4J($b57a91a6c1bea905$var$deburredLetters);
module.exports = $b57a91a6c1bea905$var$deburrLetter;

});
parcelRegister("hCB4J", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $cd42beacc430a026$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $cd42beacc430a026$var$basePropertyOf;

});



parcelRegister("aBwAD", function(module, exports) {

var $5tcZn = parcelRequire("5tcZn");

var $5LOCi = parcelRequire("5LOCi");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $7b86a3c12fad2d7c$var$camelCase = $5LOCi(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $5tcZn(word) : word);
});
module.exports = $7b86a3c12fad2d7c$var$camelCase;

});
parcelRegister("5LOCi", function(module, exports) {

var $cadWX = parcelRequire("cadWX");

var $dxLOu = parcelRequire("dxLOu");

var $5AfPI = parcelRequire("5AfPI");
/** Used to compose unicode capture groups. */ var $43389af73d27921d$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $43389af73d27921d$var$reApos = RegExp($43389af73d27921d$var$rsApos, "g");
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $43389af73d27921d$var$createCompounder(callback) {
    return function(string) {
        return $cadWX($5AfPI($dxLOu(string).replace($43389af73d27921d$var$reApos, "")), callback, "");
    };
}
module.exports = $43389af73d27921d$var$createCompounder;

});
parcelRegister("cadWX", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $02490d608c3d97f0$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $02490d608c3d97f0$var$arrayReduce;

});

parcelRegister("5AfPI", function(module, exports) {

var $kV8WP = parcelRequire("kV8WP");

var $2djvA = parcelRequire("2djvA");

var $7Pwoh = parcelRequire("7Pwoh");

var $3o2tK = parcelRequire("3o2tK");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $410c98a878f53903$var$words(string, pattern, guard) {
    string = $7Pwoh(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $2djvA(string) ? $3o2tK(string) : $kV8WP(string);
    return string.match(pattern) || [];
}
module.exports = $410c98a878f53903$var$words;

});
parcelRegister("kV8WP", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $f3b0125cb3982892$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $f3b0125cb3982892$var$asciiWords(string) {
    return string.match($f3b0125cb3982892$var$reAsciiWord) || [];
}
module.exports = $f3b0125cb3982892$var$asciiWords;

});

parcelRegister("2djvA", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $19cbeda9c0322aec$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $19cbeda9c0322aec$var$hasUnicodeWord(string) {
    return $19cbeda9c0322aec$var$reHasUnicodeWord.test(string);
}
module.exports = $19cbeda9c0322aec$var$hasUnicodeWord;

});

parcelRegister("3o2tK", function(module, exports) {
/** Used to compose unicode character classes. */ var $2775893b2f1256fa$var$rsAstralRange = "\ud800-\udfff", $2775893b2f1256fa$var$rsComboMarksRange = "\\u0300-\\u036f", $2775893b2f1256fa$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $2775893b2f1256fa$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $2775893b2f1256fa$var$rsComboRange = $2775893b2f1256fa$var$rsComboMarksRange + $2775893b2f1256fa$var$reComboHalfMarksRange + $2775893b2f1256fa$var$rsComboSymbolsRange, $2775893b2f1256fa$var$rsDingbatRange = "\\u2700-\\u27bf", $2775893b2f1256fa$var$rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", $2775893b2f1256fa$var$rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", $2775893b2f1256fa$var$rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", $2775893b2f1256fa$var$rsPunctuationRange = "\\u2000-\\u206f", $2775893b2f1256fa$var$rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $2775893b2f1256fa$var$rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", $2775893b2f1256fa$var$rsVarRange = "\\ufe0e\\ufe0f", $2775893b2f1256fa$var$rsBreakRange = $2775893b2f1256fa$var$rsMathOpRange + $2775893b2f1256fa$var$rsNonCharRange + $2775893b2f1256fa$var$rsPunctuationRange + $2775893b2f1256fa$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $2775893b2f1256fa$var$rsApos = "['\u2019]", $2775893b2f1256fa$var$rsBreak = "[" + $2775893b2f1256fa$var$rsBreakRange + "]", $2775893b2f1256fa$var$rsCombo = "[" + $2775893b2f1256fa$var$rsComboRange + "]", $2775893b2f1256fa$var$rsDigits = "\\d+", $2775893b2f1256fa$var$rsDingbat = "[" + $2775893b2f1256fa$var$rsDingbatRange + "]", $2775893b2f1256fa$var$rsLower = "[" + $2775893b2f1256fa$var$rsLowerRange + "]", $2775893b2f1256fa$var$rsMisc = "[^" + $2775893b2f1256fa$var$rsAstralRange + $2775893b2f1256fa$var$rsBreakRange + $2775893b2f1256fa$var$rsDigits + $2775893b2f1256fa$var$rsDingbatRange + $2775893b2f1256fa$var$rsLowerRange + $2775893b2f1256fa$var$rsUpperRange + "]", $2775893b2f1256fa$var$rsFitz = "\ud83c[\udffb-\udfff]", $2775893b2f1256fa$var$rsModifier = "(?:" + $2775893b2f1256fa$var$rsCombo + "|" + $2775893b2f1256fa$var$rsFitz + ")", $2775893b2f1256fa$var$rsNonAstral = "[^" + $2775893b2f1256fa$var$rsAstralRange + "]", $2775893b2f1256fa$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $2775893b2f1256fa$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $2775893b2f1256fa$var$rsUpper = "[" + $2775893b2f1256fa$var$rsUpperRange + "]", $2775893b2f1256fa$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $2775893b2f1256fa$var$rsMiscLower = "(?:" + $2775893b2f1256fa$var$rsLower + "|" + $2775893b2f1256fa$var$rsMisc + ")", $2775893b2f1256fa$var$rsMiscUpper = "(?:" + $2775893b2f1256fa$var$rsUpper + "|" + $2775893b2f1256fa$var$rsMisc + ")", $2775893b2f1256fa$var$rsOptContrLower = "(?:" + $2775893b2f1256fa$var$rsApos + "(?:d|ll|m|re|s|t|ve))?", $2775893b2f1256fa$var$rsOptContrUpper = "(?:" + $2775893b2f1256fa$var$rsApos + "(?:D|LL|M|RE|S|T|VE))?", $2775893b2f1256fa$var$reOptMod = $2775893b2f1256fa$var$rsModifier + "?", $2775893b2f1256fa$var$rsOptVar = "[" + $2775893b2f1256fa$var$rsVarRange + "]?", $2775893b2f1256fa$var$rsOptJoin = "(?:" + $2775893b2f1256fa$var$rsZWJ + "(?:" + [
    $2775893b2f1256fa$var$rsNonAstral,
    $2775893b2f1256fa$var$rsRegional,
    $2775893b2f1256fa$var$rsSurrPair
].join("|") + ")" + $2775893b2f1256fa$var$rsOptVar + $2775893b2f1256fa$var$reOptMod + ")*", $2775893b2f1256fa$var$rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", $2775893b2f1256fa$var$rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $2775893b2f1256fa$var$rsSeq = $2775893b2f1256fa$var$rsOptVar + $2775893b2f1256fa$var$reOptMod + $2775893b2f1256fa$var$rsOptJoin, $2775893b2f1256fa$var$rsEmoji = "(?:" + [
    $2775893b2f1256fa$var$rsDingbat,
    $2775893b2f1256fa$var$rsRegional,
    $2775893b2f1256fa$var$rsSurrPair
].join("|") + ")" + $2775893b2f1256fa$var$rsSeq;
/** Used to match complex or compound words. */ var $2775893b2f1256fa$var$reUnicodeWord = RegExp([
    $2775893b2f1256fa$var$rsUpper + "?" + $2775893b2f1256fa$var$rsLower + "+" + $2775893b2f1256fa$var$rsOptContrLower + "(?=" + [
        $2775893b2f1256fa$var$rsBreak,
        $2775893b2f1256fa$var$rsUpper,
        "$"
    ].join("|") + ")",
    $2775893b2f1256fa$var$rsMiscUpper + "+" + $2775893b2f1256fa$var$rsOptContrUpper + "(?=" + [
        $2775893b2f1256fa$var$rsBreak,
        $2775893b2f1256fa$var$rsUpper + $2775893b2f1256fa$var$rsMiscLower,
        "$"
    ].join("|") + ")",
    $2775893b2f1256fa$var$rsUpper + "?" + $2775893b2f1256fa$var$rsMiscLower + "+" + $2775893b2f1256fa$var$rsOptContrLower,
    $2775893b2f1256fa$var$rsUpper + "+" + $2775893b2f1256fa$var$rsOptContrUpper,
    $2775893b2f1256fa$var$rsOrdUpper,
    $2775893b2f1256fa$var$rsOrdLower,
    $2775893b2f1256fa$var$rsDigits,
    $2775893b2f1256fa$var$rsEmoji
].join("|"), "g");
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $2775893b2f1256fa$var$unicodeWords(string) {
    return string.match($2775893b2f1256fa$var$reUnicodeWord) || [];
}
module.exports = $2775893b2f1256fa$var$unicodeWords;

});




parcelRegister("g7YDa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("iBtwn")).default; });

var $iBtwn = parcelRequire("iBtwn");

});
parcelRegister("iBtwn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f73576dbd586feaf$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $40KoW = parcelRequire("40KoW");

var $hRjh0 = parcelRequire("hRjh0");

var $8lB1y = parcelRequire("8lB1y");
const $f73576dbd586feaf$var$UniformAccordion = (props)=>{
    const { id: id, header: header, textBody: textBody, richText: richText } = props;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hRjh0.Accordion), {
        id: id,
        header: header,
        content: richText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            text: richText
        }) : !(0, $40KoW.isRichTextValueConsideredEmpty)(props.uniformRichText) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            uniformParameter: "uniformRichText"
        }) : textBody
    });
};
var $f73576dbd586feaf$export$2e2bcd8739ae039 = $f73576dbd586feaf$var$UniformAccordion;

});
parcelRegister("40KoW", function(module, exports) {

$parcel$export(module.exports, "isRichTextValueConsideredEmpty", function () { return $2ebb27d3fd99ac6b$export$3113f85f4f2c043b; });
$parcel$export(module.exports, "getRichTextTagsFromTextFormat", function () { return $2ebb27d3fd99ac6b$export$5a89a4161bd9ebd2; });
$parcel$export(module.exports, "walkRichTextTree", function () { return $2ebb27d3fd99ac6b$export$5a4dbd7b3859d56e; });
// src/elements.ts

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");
var $2ebb27d3fd99ac6b$var$rendererTypeTagMap = /* @__PURE__ */ new Map([
    [
        "linebreak",
        [
            "br"
        ]
    ],
    [
        "quote",
        [
            "blockquote"
        ]
    ],
    [
        "code",
        [
            "pre",
            "code"
        ]
    ]
]);
function $2ebb27d3fd99ac6b$export$a4ec677d66b3eef3(text) {
    return text.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $2ebb27d3fd99ac6b$export$8553002765ef8155(format) {
    return Boolean(format && [
        "center",
        "end",
        "justify",
        "left",
        "right",
        "start"
    ].includes(format));
}
function $2ebb27d3fd99ac6b$export$2d8458e4858dd6bc(direction) {
    return Boolean(direction && [
        "ltr",
        "rtl"
    ].includes(direction));
}
var $2ebb27d3fd99ac6b$var$voidElements = /* @__PURE__ */ new Set([
    "area",
    "base",
    "br",
    "col",
    "embed",
    "hr",
    "img",
    "input",
    "link",
    "meta",
    "source",
    "track",
    "wbr"
]);
function $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb(tag, attributes, children) {
    const attributesString = attributes && attributes.size > 0 ? " " + Array.from(attributes).reduce((result, [key, value])=>[
            ...result,
            `${key}="${value}"`
        ], []).join(" ") : "";
    return $2ebb27d3fd99ac6b$var$voidElements.has(tag) ? `<${tag}${attributesString}>` : `<${tag}${attributesString}>${children != null ? children : ""}</${tag}>`;
}
// src/guards.ts
function $2ebb27d3fd99ac6b$export$70f15e3e004ad6dd(arr) {
    return Array.isArray(arr) && arr.length > 0;
}
function $2ebb27d3fd99ac6b$export$5397ae48e85521ee(node) {
    return !!node && typeof node === "object" && "type" in node;
}
function $2ebb27d3fd99ac6b$export$bce37bf8275274bb(value) {
    return typeof value === "object" && value !== null && "root" in value && $2ebb27d3fd99ac6b$export$5397ae48e85521ee(value.root);
}
function $2ebb27d3fd99ac6b$export$76356ac770fe566f(node, type) {
    return $2ebb27d3fd99ac6b$export$5397ae48e85521ee(node) && node.type === type;
}
function $2ebb27d3fd99ac6b$export$3113f85f4f2c043b(value) {
    if (!value) return true;
    if (value.root.children.length === 0) return true;
    if (value.root.children.length > 1) return false;
    const child = value.root.children[0];
    if (!$2ebb27d3fd99ac6b$export$76356ac770fe566f(child, "paragraph")) return false;
    return child.children === void 0 || child.children.length === 0;
}
function $2ebb27d3fd99ac6b$export$bd5ff50f0e53d41c(node) {
    return "children" in node && $2ebb27d3fd99ac6b$export$70f15e3e004ad6dd(node.children);
}
// src/nodes/asset.ts
var $2ebb27d3fd99ac6b$export$7b8470edeb266d2d = ({ context: context })=>{
    var _a, _b;
    const node = context.currentNode;
    if (node.__asset === void 0) return "";
    if (node.__asset.type !== "image") return "";
    const imgAttributes = /* @__PURE__ */ new Map();
    imgAttributes.set("src", node.__asset.fields.url.value);
    if ((_a = node.__asset.fields.title) == null ? void 0 : _a.value) imgAttributes.set("alt", node.__asset.fields.title.value);
    const img = $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb("img", imgAttributes);
    const figcaption = ((_b = node.__asset.fields.description) == null ? void 0 : _b.value) ? $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb("figcaption", null, node.__asset.fields.description.value) : "";
    return $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb("figure", null, `${img}${figcaption}`);
};
// src/nodes/heading.ts
var $2ebb27d3fd99ac6b$export$bf6388ba992fa09c = ({ context: context, renderChildren: renderChildren })=>{
    var _a;
    const node = context.currentNode;
    return $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb((_a = node.tag) != null ? _a : "h1", null, renderChildren(context.currentNode.children));
};
var $2ebb27d3fd99ac6b$var$headingTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $2ebb27d3fd99ac6b$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
// src/nodes/link.ts
var $2ebb27d3fd99ac6b$export$936fe693edb52ead = ({ context: context, renderChildren: renderChildren })=>{
    const node = context.currentNode;
    const attributes = /* @__PURE__ */ new Map();
    const href = $2ebb27d3fd99ac6b$export$14401f8b485975ea(node.link);
    if (href) attributes.set("href", href);
    return $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb("a", attributes, renderChildren(context.currentNode.children));
};
function $2ebb27d3fd99ac6b$export$14401f8b485975ea(link) {
    switch(link == null ? void 0 : link.type){
        case "email":
            return `mailto:${link.path}`;
        case "tel":
            return `tel:${link.path}`;
        case "url":
            return link.path;
        case "projectMapNode":
            return link.path;
    }
}
// src/nodes/list.ts
var $2ebb27d3fd99ac6b$export$7d9d55832c255604 = ({ context: context, renderChildren: renderChildren })=>{
    var _a;
    const node = context.currentNode;
    const attributes = /* @__PURE__ */ new Map();
    if (node.start > 1) attributes.set("start", node.start.toString());
    return $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb((_a = node.tag) != null ? _a : "ul", attributes, renderChildren(context.currentNode.children));
};
// src/nodes/listitem.ts
var $2ebb27d3fd99ac6b$export$7db814f6895f686a = ({ context: context, renderChildren: renderChildren })=>{
    const node = context.currentNode;
    const attributes = /* @__PURE__ */ new Map();
    if (Number.isFinite(node.value) && node.value > 0) attributes.set("value", node.value.toString());
    return $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb("li", attributes, renderChildren(context.currentNode.children));
};
var $2ebb27d3fd99ac6b$var$listitemTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    if (!$2ebb27d3fd99ac6b$export$bd5ff50f0e53d41c(context.currentNode)) return "";
    const childrenRendered = renderChildren(context.currentNode.children);
    if (childrenRendered.endsWith(" ")) return childrenRendered;
    return `${childrenRendered} `;
};
// src/nodes/paragraph.ts
var $2ebb27d3fd99ac6b$export$8bcf4977d6029c8 = ({ context: context, renderChildren: renderChildren })=>{
    const node = context.currentNode;
    const attributes = /* @__PURE__ */ new Map();
    if ($2ebb27d3fd99ac6b$export$8553002765ef8155(node.format)) attributes.set("style", `text-align: ${node.format};`);
    if ($2ebb27d3fd99ac6b$export$2d8458e4858dd6bc(node.direction)) attributes.set("dir", node.direction);
    return $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb("p", attributes, $2ebb27d3fd99ac6b$export$bd5ff50f0e53d41c(context.currentNode) ? renderChildren(context.currentNode.children) : "<br>");
};
var $2ebb27d3fd99ac6b$var$paragraphTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $2ebb27d3fd99ac6b$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
// src/nodes/root.ts
var $2ebb27d3fd99ac6b$export$1a6e4df79d5098f8 = ({ context: context, renderChildren: renderChildren })=>{
    return $2ebb27d3fd99ac6b$export$bd5ff50f0e53d41c(context.currentNode) ? renderChildren(context.currentNode.children) : "";
};
// src/nodes/table.ts
var $2ebb27d3fd99ac6b$export$29b37b9cb24833f8 = ({ context: context, renderChildren: renderChildren })=>{
    return [
        "table",
        "tbody"
    ].reduceRight((children, tag)=>{
        return $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb(tag, null, children);
    }, renderChildren(context.currentNode.children));
};
var $2ebb27d3fd99ac6b$var$tableTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $2ebb27d3fd99ac6b$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
// src/nodes/tablecell.ts
var $2ebb27d3fd99ac6b$export$5bdbd5436df1f109 = ({ context: context, renderChildren: renderChildren })=>{
    const node = context.currentNode;
    const tag = $2ebb27d3fd99ac6b$export$37fd5c6d3c00d303(node.headerState);
    return $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb(tag, null, renderChildren(context.currentNode.children));
};
var $2ebb27d3fd99ac6b$var$tablecellTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $2ebb27d3fd99ac6b$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
function $2ebb27d3fd99ac6b$export$37fd5c6d3c00d303(headerState) {
    if (headerState === 0) return "td";
    return "th";
}
// src/nodes/tablerow.ts
var $2ebb27d3fd99ac6b$export$28c41253e2c9901a = ({ context: context, renderChildren: renderChildren })=>{
    return $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb("tr", null, renderChildren(context.currentNode.children));
};
var $2ebb27d3fd99ac6b$var$tablerowTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $2ebb27d3fd99ac6b$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
// src/nodes/text.ts
var $2ebb27d3fd99ac6b$export$56ed6376d093860 = ({ context: context })=>{
    const node = context.currentNode;
    const tags = $2ebb27d3fd99ac6b$export$5a89a4161bd9ebd2(node.format);
    const pureText = $2ebb27d3fd99ac6b$export$a4ec677d66b3eef3(node.text);
    return tags.length === 0 ? pureText : tags.reduceRight((children, tag)=>{
        return $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb(tag, null, children);
    }, pureText);
};
var $2ebb27d3fd99ac6b$var$textTextRenderer = ({ context: context })=>{
    const node = context.currentNode;
    return node.text;
};
function $2ebb27d3fd99ac6b$export$5a89a4161bd9ebd2(format) {
    const tags = [];
    if (format & 1) tags.push("strong");
    if (format & 2) tags.push("em");
    if (format & 4) tags.push("s");
    if (format & 8) tags.push("u");
    if (format & 16) tags.push("code");
    if (format & 32) tags.push("sub");
    if (format & 64) tags.push("sup");
    return tags;
}
// src/nodes/tab.ts
var $2ebb27d3fd99ac6b$var$tabHtmlRenderer = ()=>{
    return "	";
};
var $2ebb27d3fd99ac6b$var$tabTextRenderer = ()=>{
    return "	";
};
// src/renderToHtml.ts
var $2ebb27d3fd99ac6b$var$rendererTypeMap = /* @__PURE__ */ new Map([
    [
        "heading",
        $2ebb27d3fd99ac6b$export$bf6388ba992fa09c
    ],
    [
        "link",
        $2ebb27d3fd99ac6b$export$936fe693edb52ead
    ],
    [
        "list",
        $2ebb27d3fd99ac6b$export$7d9d55832c255604
    ],
    [
        "listitem",
        $2ebb27d3fd99ac6b$export$7db814f6895f686a
    ],
    [
        "paragraph",
        $2ebb27d3fd99ac6b$export$8bcf4977d6029c8
    ],
    [
        "root",
        $2ebb27d3fd99ac6b$export$1a6e4df79d5098f8
    ],
    [
        "text",
        $2ebb27d3fd99ac6b$export$56ed6376d093860
    ],
    [
        "tab",
        $2ebb27d3fd99ac6b$var$tabHtmlRenderer
    ],
    [
        "table",
        $2ebb27d3fd99ac6b$export$29b37b9cb24833f8
    ],
    [
        "tablecell",
        $2ebb27d3fd99ac6b$export$5bdbd5436df1f109
    ],
    [
        "tablerow",
        $2ebb27d3fd99ac6b$export$28c41253e2c9901a
    ],
    [
        "asset",
        $2ebb27d3fd99ac6b$export$7b8470edeb266d2d
    ]
]);
var $2ebb27d3fd99ac6b$export$28174e313edd87cd = (context)=>{
    const renderer = $2ebb27d3fd99ac6b$var$rendererTypeMap.get(context.currentNode.type);
    if (renderer) return renderer;
    const tags = $2ebb27d3fd99ac6b$var$rendererTypeTagMap.get(context.currentNode.type);
    if (tags) return ({ renderChildren: renderChildren })=>{
        var _a;
        return (_a = tags.reduceRight((children, tag)=>{
            return $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb(tag, null, children);
        }, $2ebb27d3fd99ac6b$export$bd5ff50f0e53d41c(context.currentNode) ? renderChildren(context.currentNode.children) : void 0)) != null ? _a : "";
    };
    return ()=>`<!-- WARNING: No renderer for type ${context.currentNode.type} -->`;
};
function $2ebb27d3fd99ac6b$var$initializeRenderContext(node, parentContext) {
    let ancestorNodes = [];
    if (parentContext == null ? void 0 : parentContext.ancestorNodes) ancestorNodes = ancestorNodes.concat(parentContext.ancestorNodes);
    if (parentContext == null ? void 0 : parentContext.currentNode) ancestorNodes.unshift(parentContext.currentNode);
    return (0, $6iHNw._)((0, $7Knp0._)({}, parentContext != null ? parentContext : {}), {
        currentNode: node,
        ancestorNodes: ancestorNodes
    });
}
function $2ebb27d3fd99ac6b$export$32f1246b4326e182(node, parentContext) {
    var _a;
    if (!$2ebb27d3fd99ac6b$export$5397ae48e85521ee(node)) return "";
    const context = $2ebb27d3fd99ac6b$var$initializeRenderContext(node, parentContext);
    let renderer = (_a = context.resolveRenderer) == null ? void 0 : _a.call(context, context);
    if (typeof renderer === "undefined") renderer = $2ebb27d3fd99ac6b$export$28174e313edd87cd(context);
    else if (renderer === null) return "";
    const renderChildren = (children)=>$2ebb27d3fd99ac6b$export$e4421ac256b62cb6(children, context);
    if (renderer) return renderer({
        context: context,
        renderChildren: renderChildren
    });
    else throw new Error(`There is no renderer for node type: ${context.currentNode.type}`);
}
function $2ebb27d3fd99ac6b$export$e4421ac256b62cb6(children, context) {
    return Array.isArray(children) ? children.map((node)=>$2ebb27d3fd99ac6b$export$32f1246b4326e182(node, context)).join("") : "";
}
// src/nodes/linebreak.ts
var $2ebb27d3fd99ac6b$var$linebreakTextRenderer = ()=>{
    return " ";
};
// src/renderToText.ts
var $2ebb27d3fd99ac6b$var$rendererTypeMap2 = /* @__PURE__ */ new Map([
    [
        "text",
        $2ebb27d3fd99ac6b$var$textTextRenderer
    ],
    [
        "tab",
        $2ebb27d3fd99ac6b$var$tabTextRenderer
    ],
    [
        "linebreak",
        $2ebb27d3fd99ac6b$var$linebreakTextRenderer
    ],
    [
        "paragraph",
        $2ebb27d3fd99ac6b$var$paragraphTextRenderer
    ],
    [
        "listitem",
        $2ebb27d3fd99ac6b$var$listitemTextRenderer
    ],
    [
        "heading",
        $2ebb27d3fd99ac6b$var$headingTextRenderer
    ],
    [
        "table",
        $2ebb27d3fd99ac6b$var$tableTextRenderer
    ],
    [
        "tablecell",
        $2ebb27d3fd99ac6b$var$tablecellTextRenderer
    ],
    [
        "tablerow",
        $2ebb27d3fd99ac6b$var$tablerowTextRenderer
    ]
]);
var $2ebb27d3fd99ac6b$export$dd531e7b53a0cbec = (context)=>{
    const renderer = $2ebb27d3fd99ac6b$var$rendererTypeMap2.get(context.currentNode.type);
    if (renderer) return renderer;
    return ({ context: context2, renderChildren: renderChildren })=>{
        return $2ebb27d3fd99ac6b$export$bd5ff50f0e53d41c(context2.currentNode) ? renderChildren(context2.currentNode.children) : "";
    };
};
function $2ebb27d3fd99ac6b$var$initializeRenderContext2(node, parentContext) {
    let ancestorNodes = [];
    if (parentContext == null ? void 0 : parentContext.ancestorNodes) ancestorNodes = ancestorNodes.concat(parentContext.ancestorNodes);
    if (parentContext == null ? void 0 : parentContext.currentNode) ancestorNodes.unshift(parentContext.currentNode);
    return (0, $6iHNw._)((0, $7Knp0._)({}, parentContext != null ? parentContext : {}), {
        currentNode: node,
        ancestorNodes: ancestorNodes
    });
}
function $2ebb27d3fd99ac6b$export$f21c5276b1e9847a(node, parentContext) {
    var _a;
    if (!$2ebb27d3fd99ac6b$export$5397ae48e85521ee(node)) return "";
    const context = $2ebb27d3fd99ac6b$var$initializeRenderContext2(node, parentContext);
    let renderer = (_a = context.resolveRenderer) == null ? void 0 : _a.call(context, context);
    if (typeof renderer === "undefined") renderer = $2ebb27d3fd99ac6b$export$dd531e7b53a0cbec(context);
    else if (renderer === null) return "";
    const renderChildren = (children)=>$2ebb27d3fd99ac6b$export$6ba9468a0a4c5ffc(children, context);
    if (renderer) {
        const rendered = renderer({
            context: context,
            renderChildren: renderChildren
        });
        return context.ancestorNodes.length > 0 ? rendered : rendered.trim();
    } else throw new Error(`There is no renderer for node type: ${context.currentNode.type}`);
}
function $2ebb27d3fd99ac6b$export$6ba9468a0a4c5ffc(children, context) {
    return Array.isArray(children) ? children.map((node)=>$2ebb27d3fd99ac6b$export$f21c5276b1e9847a(node, context)).join("") : "";
}
// src/utils.ts
var $2ebb27d3fd99ac6b$export$5a4dbd7b3859d56e = (node, callback, parent)=>{
    if (!$2ebb27d3fd99ac6b$export$5397ae48e85521ee(node)) return;
    callback(node, parent);
    if (Array.isArray(node.children)) {
        let i = 0;
        while(node.children.length > i){
            $2ebb27d3fd99ac6b$export$5a4dbd7b3859d56e(node.children[i], callback, node);
            i += 1;
        }
    }
};
var $2ebb27d3fd99ac6b$export$4593e5e0513f0a70 = [
    {
        label: "Heading 1",
        type: "h1"
    },
    {
        label: "Heading 2",
        type: "h2"
    },
    {
        label: "Heading 3",
        type: "h3"
    },
    {
        label: "Heading 4",
        type: "h4"
    },
    {
        label: "Heading 5",
        type: "h5"
    },
    {
        label: "Heading 6",
        type: "h6"
    },
    {
        label: "Bullet List",
        type: "unorderedList"
    },
    {
        label: "Ordered List",
        type: "orderedList"
    },
    {
        label: "Link",
        type: "link"
    },
    {
        label: "Blockquote",
        type: "quote"
    },
    {
        label: "Code Block",
        type: "code"
    },
    {
        label: "Table",
        type: "table"
    },
    {
        label: "Asset",
        type: "asset"
    },
    {
        label: "Dynamic Token",
        type: "variable"
    }
];
var $2ebb27d3fd99ac6b$export$1c57de179d11d54c = [
    {
        label: "Bold",
        type: "bold"
    },
    {
        label: "Italic",
        type: "italic"
    },
    {
        label: "Underline",
        type: "underline"
    },
    {
        label: "Strikethrough",
        type: "strikethrough"
    },
    {
        label: "Code",
        type: "code"
    },
    {
        label: "Superscript",
        type: "superscript"
    },
    {
        label: "Subscript",
        type: "subscript"
    }
];
var $2ebb27d3fd99ac6b$export$401e495ff5af005a = (type)=>{
    var _a;
    if (type === "paragraph") return "Normal";
    const element = $2ebb27d3fd99ac6b$export$4593e5e0513f0a70.find((element2)=>element2.type === type);
    return (_a = element == null ? void 0 : element.label) != null ? _a : type;
};
var $2ebb27d3fd99ac6b$export$419f7a872c5c801f = (type)=>{
    var _a;
    const format = $2ebb27d3fd99ac6b$export$1c57de179d11d54c.find((element)=>element.type === type);
    return (_a = format == null ? void 0 : format.label) != null ? _a : type;
};
var $2ebb27d3fd99ac6b$export$ea67c934009c1e06 = {
    root: {
        type: "root",
        version: 1,
        direction: null,
        format: "",
        indent: 0,
        children: [
            {
                type: "paragraph",
                version: 1,
                format: "start",
                indent: 0,
                direction: null,
                children: [],
                textFormat: 0,
                textStyle: ""
            }
        ]
    }
};

});



parcelRegister("1419P", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("5tOAJ")).default; });

var $5tOAJ = parcelRequire("5tOAJ");

});
parcelRegister("5tOAJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51ad7e783341a3f6$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $6N99x = parcelRequire("6N99x");
const $51ad7e783341a3f6$var$UniformBannerAlert = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6N99x.BannerAlert), (0, $7Knp0._)({}, props));
};
var $51ad7e783341a3f6$export$2e2bcd8739ae039 = $51ad7e783341a3f6$var$UniformBannerAlert;

});


parcelRegister("13r6t", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("dz7kb")).default; });

var $dz7kb = parcelRequire("dz7kb");

});
parcelRegister("dz7kb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b56ffa84a8f8d25d$export$2e2bcd8739ae039; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $3DJF0 = parcelRequire("3DJF0");
const $b56ffa84a8f8d25d$export$d9468344d3651243 = (body)=>{
    if (!body) return {};
    const { story: story, richText: richText, image: image, embeddedVideoLink: embeddedVideoLink, imageCaption: imageCaption } = body;
    var _story_storyText, _ref, _story_bodyAsset, _story_embeddedVideoLink, _ref1, _story_bodyAssetCaption, _ref2;
    const formattedBody = {
        storyText: (_ref = (_story_storyText = story === null || story === void 0 ? void 0 : story.storyText) !== null && _story_storyText !== void 0 ? _story_storyText : richText) !== null && _ref !== void 0 ? _ref : undefined,
        bodyAsset: $b56ffa84a8f8d25d$var$formatBodyAsset((_story_bodyAsset = story === null || story === void 0 ? void 0 : story.bodyAsset) !== null && _story_bodyAsset !== void 0 ? _story_bodyAsset : image),
        embeddedVideoLink: (_ref1 = (_story_embeddedVideoLink = story === null || story === void 0 ? void 0 : story.embeddedVideoLink) !== null && _story_embeddedVideoLink !== void 0 ? _story_embeddedVideoLink : embeddedVideoLink) !== null && _ref1 !== void 0 ? _ref1 : undefined,
        bodyAssetCaption: (_ref2 = (_story_bodyAssetCaption = story === null || story === void 0 ? void 0 : story.bodyAssetCaption) !== null && _story_bodyAssetCaption !== void 0 ? _story_bodyAssetCaption : imageCaption) !== null && _ref2 !== void 0 ? _ref2 : undefined,
        quote: $b56ffa84a8f8d25d$var$formatQuote(story === null || story === void 0 ? void 0 : story.quote)
    };
    // Remove undefined properties
    return Object.fromEntries(Object.entries(formattedBody).filter(([_, value])=>value !== undefined));
};
// eslint-disable-next-line complexity
const $b56ffa84a8f8d25d$var$formatBodyAsset = (bodyAsset)=>{
    var _fields_file_details, _fields_file, _fields_file1, _fields_file_image, _fields_file2, _fields_image, _fields_file3, _fields_file4;
    if (!(bodyAsset === null || bodyAsset === void 0 ? void 0 : bodyAsset.fields)) return undefined;
    const { fields: fields } = bodyAsset;
    var _fields_file_fileName, _fields_file_image_height, _fields_image_width, _fields_description, _fields_file_contentType;
    return {
        name: fields.title,
        size: (_fields_file = fields.file) === null || _fields_file === void 0 ? void 0 : (_fields_file_details = _fields_file.details) === null || _fields_file_details === void 0 ? void 0 : _fields_file_details.size,
        fileName: (_fields_file_fileName = (_fields_file1 = fields.file) === null || _fields_file1 === void 0 ? void 0 : _fields_file1.fileName) !== null && _fields_file_fileName !== void 0 ? _fields_file_fileName : null,
        height: (_fields_file_image_height = (_fields_file2 = fields.file) === null || _fields_file2 === void 0 ? void 0 : (_fields_file_image = _fields_file2.image) === null || _fields_file_image === void 0 ? void 0 : _fields_file_image.height) !== null && _fields_file_image_height !== void 0 ? _fields_file_image_height : null,
        width: (_fields_image_width = (_fields_image = fields.image) === null || _fields_image === void 0 ? void 0 : _fields_image.width) !== null && _fields_image_width !== void 0 ? _fields_image_width : null,
        url: (_fields_file3 = fields.file) === null || _fields_file3 === void 0 ? void 0 : _fields_file3.url,
        description: (_fields_description = fields.description) !== null && _fields_description !== void 0 ? _fields_description : null,
        contentType: (_fields_file_contentType = (_fields_file4 = fields.file) === null || _fields_file4 === void 0 ? void 0 : _fields_file4.contentType) !== null && _fields_file_contentType !== void 0 ? _fields_file_contentType : null
    };
};
const $b56ffa84a8f8d25d$var$formatQuote = (quote)=>{
    if (!(quote === null || quote === void 0 ? void 0 : quote.fields)) return undefined;
    const { fields: fields } = quote;
    return {
        quote: fields.advocateQuote,
        authorName: fields.advocateName,
        authorDetails: fields.advocateJobTitle
    };
};
const $b56ffa84a8f8d25d$var$UniformBodyContent = (props)=>{
    const bodyComponent = (0, $iSvIT.useMemo)(()=>$b56ffa84a8f8d25d$export$d9468344d3651243(props), [
        props
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3DJF0.BodyContent), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        story: bodyComponent
    }));
};
var $b56ffa84a8f8d25d$export$2e2bcd8739ae039 = $b56ffa84a8f8d25d$var$UniformBodyContent;

});
parcelRegister("3DJF0", function(module, exports) {

$parcel$export(module.exports, "BodyContent", function () { return $a0ae596e2684c3fb$export$36cf6d64005c1ddf; });
/* body-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $h2e6B = parcelRequire("h2e6B");

var $6O6jV = parcelRequire("6O6jV");
parcelRequire("dyrzP");
var $9Kv7x = parcelRequire("9Kv7x");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");

var $krNyQ = parcelRequire("krNyQ");
function $a0ae596e2684c3fb$var$getRichText(richText) {
    if (typeof richText === "string") return richText;
    return (0, $h2e6B.documentToHtmlString)(richText);
}
const $a0ae596e2684c3fb$export$36cf6d64005c1ddf = ({ story: story })=>{
    var _story_bodyAsset_url, _story_bodyAsset_description;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "customer-story-article-content",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulp1ejb"
        ]),
        children: [
            (story === null || story === void 0 ? void 0 : story.storyText) && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_rrz6idpf _1cobidpf _7exw1ejb _1o6v1ejb"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                    name: null,
                    text: $a0ae596e2684c3fb$var$getRichText(story.storyText)
                })
            }),
            (story === null || story === void 0 ? void 0 : story.quote) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                layout: "10",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.PullQuote), {
                    quote: story.quote.quote,
                    authorName: story.quote.authorName,
                    authorDetails: story.quote.authorDetails,
                    alignment: "start",
                    variant: story.quote.heroQuote ? "cutout" : "basic"
                })
            }),
            (story === null || story === void 0 ? void 0 : story.bodyAsset) && (story === null || story === void 0 ? void 0 : story.embeddedVideoLink) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $6O6jV.AgileVideo), {
                embedLink: story.embeddedVideoLink,
                thumbnail: story.bodyAsset,
                title: ""
            }),
            (story === null || story === void 0 ? void 0 : story.bodyAsset) && !(story === null || story === void 0 ? void 0 : story.embeddedVideoLink) && /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _zulpu2gc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $9Kv7x.ContentPlatformImage), {
                        src: (_story_bodyAsset_url = story.bodyAsset.url) !== null && _story_bodyAsset_url !== void 0 ? _story_bodyAsset_url : "",
                        alt: (_story_bodyAsset_description = story.bodyAsset.description) !== null && _story_bodyAsset_description !== void 0 ? _story_bodyAsset_description : "",
                        contentType: story.bodyAsset.contentType,
                        baseWidth: 856,
                        className: (0, $esG4f.default)([
                            "_p12f1osq"
                        ])
                    }),
                    story.bodyAssetCaption && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                            "fine-print"
                        ]),
                        children: story.bodyAssetCaption
                    })
                ]
            })
        ]
    });
};

});



parcelRegister("54jXi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("fHStO")).default; });

var $fHStO = parcelRequire("fHStO");

});
parcelRegister("fHStO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e638ba4003f2be17$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $3FBn4 = parcelRequire("3FBn4");

var $lbVpk = parcelRequire("lbVpk");
const $e638ba4003f2be17$var$UniformButton = (props)=>{
    const localizedHref = (0, $3FBn4.useLocalizedHref)(props.href);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lbVpk.Button), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        href: localizedHref,
        children: props.text
    }));
};
var $e638ba4003f2be17$export$2e2bcd8739ae039 = $e638ba4003f2be17$var$UniformButton;

});


parcelRegister("aDgKf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("kjD5h")).default; });

var $kjD5h = parcelRequire("kjD5h");

});
parcelRegister("kjD5h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e86c567ab983d0ac$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");

var $1UUq1 = parcelRequire("1UUq1");
parcelRequire("dMM9X");
var $kyoYi = parcelRequire("kyoYi");

var $3FBn4 = parcelRequire("3FBn4");
const $e86c567ab983d0ac$export$386f3ec84bf404ad = (props)=>{
    var _props_ctaUrl;
    const localizedHref = (0, $3FBn4.useLocalizedHref)((_props_ctaUrl = props.ctaUrl) !== null && _props_ctaUrl !== void 0 ? _props_ctaUrl : "");
    const button = ()=>{
        if (props.ctaText && props.ctaText !== "" && props.ctaUrl && props.ctaUrl !== "") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
            href: localizedHref,
            children: props.ctaText
        });
        return;
    };
    var _button;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $kyoYi.CallToAction), {
        header: props.title,
        paragraph: props.description,
        button: (_button = button()) !== null && _button !== void 0 ? _button : /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "ctaButton"
        }),
        backgroundColor: props.backgroundColor
    });
};
var $e86c567ab983d0ac$export$2e2bcd8739ae039 = $e86c567ab983d0ac$export$386f3ec84bf404ad;

});
parcelRegister("dMM9X", function(module, exports) {

$parcel$export(module.exports, "CallToAction", function () { return (parcelRequire("kyoYi")).CallToAction; });
$parcel$export(module.exports, "HeroCarousel", function () { return (parcelRequire("5C9Aa")).HeroCarousel; });
$parcel$export(module.exports, "Logos", function () { return (parcelRequire("2Nqw3")).Logos; });
$parcel$export(module.exports, "FeaturesHighlight", function () { return (parcelRequire("3Yf2x")).FeaturesHighlight; });
$parcel$export(module.exports, "Integration", function () { return (parcelRequire("g4WuQ")).Integration; });
$parcel$export(module.exports, "MobileApp", function () { return (parcelRequire("cJh4j")).MobileApp; });

var $kyoYi = parcelRequire("kyoYi");

var $55vkU = parcelRequire("55vkU");

var $3Yf2x = parcelRequire("3Yf2x");

var $gtQwZ = parcelRequire("gtQwZ");

var $5C9Aa = parcelRequire("5C9Aa");

var $g4WuQ = parcelRequire("g4WuQ");

var $2Nqw3 = parcelRequire("2Nqw3");

var $cJh4j = parcelRequire("cJh4j");

var $2p5f0 = parcelRequire("2p5f0");
parcelRequire("62VZK");
var $7CBQh = parcelRequire("7CBQh");

});
parcelRegister("kyoYi", function(module, exports) {

$parcel$export(module.exports, "CallToAction", function () { return $9844db6cec37a539$export$9438b36140854db6; });
/* call-to-action.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $9844db6cec37a539$var$callToActionStyles = null;
const $9844db6cec37a539$var$typographyOverrides = null;
const $9844db6cec37a539$var$polygonStyles = null;
const $9844db6cec37a539$var$contentStyles = null;
const $9844db6cec37a539$export$9438b36140854db6 = ({ header: header, paragraph: paragraph, button: button, backgroundColor: backgroundColor = "black" })=>{
    let transformedButton;
    if (backgroundColor === "blue") transformedButton = /*#__PURE__*/ (0, $iSvIT.cloneElement)(button, {
        variant: "primary_alt"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_p12f1git _195g1wug _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            style: {
                "--background-color": (0, $5ohHq.wacToken)(`color.primary.${backgroundColor}`)
            },
            className: (0, $esG4f.default)([
                "_11q76ulk _mkrz1q5k _1vthpg2b _1yt4koci"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c11p5 _zulpu2gc _6rthxy5q"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                className: (0, $esG4f.default)([
                                    "_1mou78py",
                                    "h3"
                                ]),
                                style: {
                                    color: (0, $5ohHq.wacToken)("color.neutral.light0")
                                },
                                children: header
                            }),
                            paragraph && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                className: (0, $esG4f.default)([
                                    "_1mou78py",
                                    ".body-md"
                                ]),
                                style: {
                                    color: (0, $5ohHq.wacToken)("color.neutral.light0")
                                },
                                children: paragraph
                            })
                        ]
                    })
                }),
                transformedButton !== null && transformedButton !== void 0 ? transformedButton : button
            ]
        })
    });
};

});

parcelRegister("55vkU", function(module, exports) {

$parcel$export(module.exports, "CustomerTestimonials", function () { return $25af9ba243d3e879$export$ff99f9acc73d9931; });
/* customer-testimonials.tsx generated by @compiled/babel-plugin v0.28.8 */ // Initial changes from ADG4CustomerTestimonials
// Removed scroll Ref and inview tracker, since there is no longer an automatic transition to new tabs
// Removed className since it was not in use
// Removed testimonialCta since that is a non standard usage in the Confluence Product Tour and clouds the core Design Pattern
// Removed Blue as an option for backgrounds for now since that is not spec
// Removed h2 heading (that should be included as a Content Block separately going forward)
// Removed TypographyStyles wrapper for consistency with other components/patterns
// Cleaned up unused classnames within the component

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $cutM5 = parcelRequire("cutM5");

var $9Kv7x = parcelRequire("9Kv7x");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");
const $25af9ba243d3e879$var$backgroundColorStyleMap = {
    black: "_bfhkr3uz",
    white: "_bfhku67f"
};
const $25af9ba243d3e879$var$backgroundShape = null;
const $25af9ba243d3e879$var$fontColorStyleMap = {
    "dark-bg": "_syaz12cp",
    "white-bg": "_syazn7od"
};
const $25af9ba243d3e879$var$topLineStyleMap = {
    black: "_bfhku67f",
    white: "_bfhkr3uz"
};
const $25af9ba243d3e879$var$logoOptionStyleMap = {
    "dark-bg": "_d4ksu67f _i862u67f _1uiy1wzc",
    "white-bg": "_d4ksr3uz _i862r3uz"
};
const $25af9ba243d3e879$var$justifyContentStyleMap = {
    "dark-bg": "_1bahh9n0",
    "white-bg": "_1bah1h6o"
};
const $25af9ba243d3e879$export$ff99f9acc73d9931 = ({ bgColor: bgColor = "black", testimonials: testimonials, productKey: productKey })=>{
    const bgTheme = bgColor === "black" ? "dark-bg" : "white-bg";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4Tabs), {
        loop: true,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _1pbykb7n _6rth1jfw",
                    $25af9ba243d3e879$var$fontColorStyleMap[bgTheme]
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_kqswstnw _1r04idpf _1bsb1lk2 _p12fklux _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1rfm1osq",
                                    $25af9ba243d3e879$var$backgroundColorStyleMap[bgColor],
                                    bgColor === "black" && "_mkrzq8qa _kxoh75ra"
                                ])
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c11p5 _yv0ehkll _2z05hkll _1ir7idpf _bhknkb7n _1rrs1txw _s9hn1ekt _16l7kb7n _w53ccs5v"
                                ]),
                                children: testimonials.map((testimonial, index)=>{
                                    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4TabPanel), {
                                        id: `${index}`,
                                        panelIndex: index,
                                        forceRender: true,
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)($25af9ba243d3e879$var$TopRowContent, {
                                            testimonial: testimonial,
                                            index: index,
                                            bgTheme: bgTheme,
                                            bgColor: bgColor
                                        })
                                    }, index);
                                })
                            }),
                            testimonials.length > 1 && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_kqswh2mm _1e0c1txw _1p57v47k _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1reo15vq _18m915vq _1bsb1osq _1bah1yb4 _1v611bp4 _476dgktf"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cutM5.Adg4DraggableTabList), {
                                        rowGap: "32px",
                                        className: (0, $esG4f.default)([
                                            "_6rth1fu0 _1q511aa3 _qtt8agmp"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_kqswstnw _152tt94y _1e02idpf _rjxpidpf _4t3it94y _2rkoyh40 _tzy4105o _xaej183y",
                                                    $25af9ba243d3e879$var$topLineStyleMap[bgColor]
                                                ])
                                            }),
                                            testimonials.map((testimonial, index)=>{
                                                return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTab), {
                                                    as: "li",
                                                    tabIndex: index,
                                                    dataEventProps: {
                                                        "data-product-key": productKey,
                                                        "data-event-component": "tab",
                                                        "data-event-container": "testimonialsSection",
                                                        "data-event": "clicked",
                                                        "data-label-english": testimonial.label
                                                    },
                                                    label: testimonial.label,
                                                    className: (0, $esG4f.default)([
                                                        $25af9ba243d3e879$var$logoOptionStyleMap[bgTheme],
                                                        "_1e0c1txw _1bah1fhb _4cvr1fhb _kqswh2mm _1atpidpf"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $loA2J.jsx)($25af9ba243d3e879$var$LogoTabContent, {
                                                        testimonialLogo: testimonial.logo
                                                    })
                                                }, index);
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $25af9ba243d3e879$var$TopRowContent = ({ testimonial: testimonial, index: index, bgTheme: bgTheme, bgColor: bgColor, isPanelActive: isPanelActive })=>{
    var _testimonial_link_type;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _1e0c1txw _1p57v47k _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o",
            "_6rth1ylp _1e0c11p5 _yv0ewxkt _gy1pzwfg _tzy4idpf _1pbykb7n _1ph4hkll",
            isPanelActive && "_tzy4kb7n _1pbycs5v"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _i0dlhwvj _1e0c1txw _1bah1h6o _4cvresu3 _16xt1ssb _1rfm1vuk _q5ugidpf _7tld1wug _14adidpf _4uro1wug _7bcc1n8h _18jmidpf _qji61wug _ms0lidpf _v5we1wug"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_bna7ng7t _1jtm1c95 _1fhe1c95 _1cwsdlvw _mezj1wug _v4pn1ule",
                        isPanelActive && "_m3691nt4"
                    ]),
                    children: typeof testimonial.image !== "string" && "contentType" in testimonial.image ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $9Kv7x.ContentPlatformImage), (0, $7Knp0._)({}, testimonial.image)) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: {
                            src: testimonial.image,
                            alt: ""
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_i0dl1nrf _1reo15vq _18m915vq _1a8l1ssb"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _4t3i1osq _2rkogktf _kqswh2mm _19pkidpf _2hwx1wug _otyridpf _18u01wug _26vxys9h _12rr1e9y _1rfm1osq",
                        $25af9ba243d3e879$var$justifyContentStyleMap[bgTheme]
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_v5641pn7 _1e0c1txw _2lx21bp4 _zulp1tcg",
                            isPanelActive && "_y44v13sw _11vozap6"
                        ]),
                        children: [
                            testimonial.eyebrow && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                className: (0, $esG4f.default)([
                                    $25af9ba243d3e879$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "eyebrow-md"
                                ]),
                                children: testimonial.eyebrow
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("blockquote", {
                                className: (0, $esG4f.default)([
                                    $25af9ba243d3e879$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "callout"
                                ]),
                                children: [
                                    "\u201C",
                                    testimonial.quote,
                                    "\u201D"
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                                className: (0, $esG4f.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        className: (0, $esG4f.default)([
                                            $25af9ba243d3e879$var$fontColorStyleMap[bgTheme],
                                            "eyebrow-lg"
                                        ]),
                                        children: testimonial.name
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        className: (0, $esG4f.default)([
                                            $25af9ba243d3e879$var$fontColorStyleMap[bgTheme],
                                            "body-md title"
                                        ]),
                                        children: testimonial.title
                                    })
                                ]
                            }),
                            testimonial.link ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                anchorProps: {
                                    tabIndex: isPanelActive ? 0 : -1
                                },
                                text: testimonial.link.text,
                                href: testimonial.link.url,
                                type: (_testimonial_link_type = testimonial.link.type) !== null && _testimonial_link_type !== void 0 ? _testimonial_link_type : "primary",
                                bgColor: bgColor === "black" ? "bgBlackBlue" : "bgWhite",
                                dataEventProps: testimonial.link.dataEventProps
                            }) : null
                        ]
                    }, index)
                })
            })
        ]
    });
};
const $25af9ba243d3e879$var$topRowActiveStyle = null;
const $25af9ba243d3e879$var$customerImagesImgActiveStyle = null;
const $25af9ba243d3e879$var$quoteContainerActiveStyle = null;
const $25af9ba243d3e879$var$LogoTabContent = ({ testimonialLogo: testimonialLogo, isSelected: isSelected = false })=>{
    const isContentfulImage = "contentType" in testimonialLogo;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_tzy4kb7n _kqswstnw _152tj39m _1e02idpf _rjxpidpf _4t3i14y2 _2rkoyh40",
                    "top-marker"
                ])
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_11q7glyw _19itidpf _r06hglyw _1q51gktf _80omtlke _kqswh2mm"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    className: (0, $esG4f.default)([
                        "_tzy4105o _v5641bs3 _16l4kb7n",
                        "_4t3i1u1b _1e0c1txw _4cvr1h6o",
                        isSelected && "_tzy4kb7n"
                    ]),
                    children: isContentfulImage ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $9Kv7x.ContentPlatformImage), (0, $6iHNw._)((0, $7Knp0._)({}, testimonialLogo), {
                        width: "140",
                        height: "34",
                        style: {
                            objectFit: "contain",
                            objectPosition: "center center"
                        },
                        className: "tab-logo"
                    })) : testimonialLogo
                })
            })
        ]
    });
}; // LogoTabContent styles
const $25af9ba243d3e879$var$logoImgStyle = null;
const $25af9ba243d3e879$var$logoImgSelectedStyle = null;
const $25af9ba243d3e879$var$logoButtonStyle = null;
const $25af9ba243d3e879$var$topMarkerStyle = null;
const $25af9ba243d3e879$var$logoImgContainerStyle = null; // ADG4CustomerTestimonials styles
const $25af9ba243d3e879$var$topLineStyles = null;
const $25af9ba243d3e879$var$testimonialKeyframeStyles = null;
const $25af9ba243d3e879$var$rowWidthStyle = null;
const $25af9ba243d3e879$var$topRowStyle = null;
const $25af9ba243d3e879$var$bgShapeStyle = null;
const $25af9ba243d3e879$var$customerImagesSectionStyles = null;
const $25af9ba243d3e879$var$customerImagesSectionImageStyles = null;
const $25af9ba243d3e879$var$customerQuotesSectionStyle = null;
const $25af9ba243d3e879$var$testimonialQuotesSectionStyle = null;
const $25af9ba243d3e879$var$quoteContainerStyle = null;
const $25af9ba243d3e879$var$quoteContainerPStyle = null;
const $25af9ba243d3e879$var$logosContainerBaseStyle = null;
const $25af9ba243d3e879$var$logosStyle = null;
const $25af9ba243d3e879$var$logoOptionStyle = null;
const $25af9ba243d3e879$var$testimonialStyles = null;
const $25af9ba243d3e879$var$tabPanelWrapperStyles = null;

});

parcelRegister("3Yf2x", function(module, exports) {

$parcel$export(module.exports, "FeaturesHighlight", function () { return $a5d0df8bfd42a304$export$bf20c48d528647dd; });
/* features-highlight.tsx generated by @compiled/babel-plugin v0.28.8 */ // import type {
//     MouseEvent as ReactMouseEvent,
//     TouchEvent as ReactTouchEvent,
//     KeyboardEvent as ReactKeyboardEvent
// } from "react";
// import { useRef, useEffect, useState, useCallback } from "react";

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $vqrsL = parcelRequire("vqrsL");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
const $a5d0df8bfd42a304$export$bf20c48d528647dd = (props)=>{
    const [activeFeature, setActiveFeature] = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useState(0);
    const onFeatureSelect = (featureKey)=>{
        setActiveFeature(featureKey);
    };
    const singleFeature = (content, featureKey)=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            onClick: ()=>onFeatureSelect(featureKey),
            onKeyDown: (e)=>{
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onFeatureSelect(featureKey);
                }
            },
            className: (0, $esG4f.default)([
                "_80omtlke _kqswh2mm _u5ggpxbi _11xx17la _uoz5x71z _suga1ule _1ah31y44",
                `feature ${activeFeature === featureKey ? "selected" : ""}`
            ]),
            role: "tab",
            tabIndex: 0,
            style: {
                "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
            },
            children: [
                activeFeature === featureKey && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswstnw _1pbykb7n _bfhk17la _2rko1y44 _1bsb1osq _4t3iftgi _165t1osq _glteftgi"
                    ]),
                    style: {
                        "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                    }
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_owpupxbi _6ssjpxbi"
                    ]),
                    children: content
                })
            ]
        });
    const feature1Text = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.ContentBlock), {
        title: props.feature1Title,
        titleAs: "h3",
        text: props.feature1Body,
        eyebrow: props.feature1Eyebrow,
        alignment: "start"
    });
    var _props_feature1ImageAltText;
    const feature1Image = /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: props.feature1ImageSrc,
            alt: (_props_feature1ImageAltText = props.feature1ImageAltText) !== null && _props_feature1ImageAltText !== void 0 ? _props_feature1ImageAltText : "",
            style: {
                width: "100%",
                height: "auto"
            }
        },
        style: {
            width: "100%",
            height: "auto"
        }
    });
    const feature2Text = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.ContentBlock), {
        title: props.feature2Title,
        titleAs: "h3",
        text: props.feature2Body,
        eyebrow: props.feature2Eyebrow,
        alignment: "start"
    });
    var _props_feature2ImageAltText;
    const feature2Image = /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: props.feature2ImageSrc,
            alt: (_props_feature2ImageAltText = props.feature2ImageAltText) !== null && _props_feature2ImageAltText !== void 0 ? _props_feature2ImageAltText : "",
            style: {
                width: "100%",
                height: "auto"
            }
        },
        style: {
            width: "100%",
            height: "auto"
        }
    });
    const feature3Text = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.ContentBlock), {
        title: props.feature3Title,
        titleAs: "h3",
        text: props.feature3Body,
        eyebrow: props.feature3Eyebrow,
        alignment: "start"
    });
    var _props_feature3ImageAltText;
    const feature3Image = /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: props.feature3ImageSrc,
            alt: (_props_feature3ImageAltText = props.feature3ImageAltText) !== null && _props_feature3ImageAltText !== void 0 ? _props_feature3ImageAltText : "",
            style: {
                width: "100%",
                height: "auto"
            }
        },
        style: {
            width: "100%",
            height: "auto"
        }
    });
    const featureTexts = [
        feature1Text,
        feature2Text,
        props.feature3Title && feature3Text
    ];
    const images = [
        feature1Image,
        feature2Image,
        props.feature3Title && feature3Image
    ];
    const sectionContainerStyles = null;
    const topContentContainerStyles = null;
    const featuresContainerStyles = null;
    const imageContainerStyles = null;
    const navDotsContainerStyles = null;
    const navDot = (featureNum)=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1bsbftgi _4t3iftgi _2rko1y44 _bfhk1cls"
            ]),
            style: {
                "--_1lhuu6n": (0, $43MIc.default)(featureNum === activeFeature ? (0, $5ohHq.wacToken)("color.primary.black") : (0, $5ohHq.wacToken)("color.neutral.light500"))
            }
        });
    }; // @ts-ignore
    const navDotsContainer = (_)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _zulppxbi _1bah1h6o _1q51pxbi"
            ]),
            children: featureTexts.map((_, index)=>navDot(index))
        });
    const mobileCarouselContainerStyles = null;
    const sliderSettings = {
        dots: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        afterChange: (current)=>setActiveFeature(current),
        appendDots: navDotsContainer
    };
    const featureSlideStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_15fl1wug _1d2w1wug _1svy1wug _seov1wug _16imoahv _b8yq1osq _14b51osq _su071wqb _1j8bcx6w _181n11p5 _dwk3usvi _19wg14hz _11mz1tcg _owpu1wqb _10jxzqdx _1vsw1vi7 _suga1txw _1gde1bp4 _1rfm1osq _tnru1osq _8164pxbi _133i1jfw"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1rfm1osq _xlt11ejb _s51szwfg _uoz5179g _1e3ceqnf _1e0c1txw _2lx21bp4 _zulpu2gc _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.ContentBlock), {
                        title: props.title,
                        titleAs: "h2",
                        text: props.description,
                        alignment: "center"
                    }),
                    props.linkText && props.linkHref && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        text: props.linkText,
                        href: props.linkHref
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                role: "tablist",
                className: (0, $esG4f.default)([
                    "_1e3cx71z _dm251txw _1ini1bp4 _kzvi1bgi _1e0cglyw"
                ]),
                children: featureTexts.map((feature, index)=>singleFeature(feature, index))
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                role: "tabpanel",
                className: (0, $esG4f.default)([
                    "_1e3cthi2 _165t1osq _uoz5uufb _sugaglyw"
                ]),
                children: images[activeFeature]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _suga1ule",
                    "_vnijh2mm _1ls01ule _1dtvusvi _1kb1glyw _fjwtglyw _1wv2glyw _1r6vglyw _zookglyw _8rkdglyw _1tpbmuzh _u8dlmuzh _e1ct1j28 _1t25h2mm _ll151ule _8lsh15vq _kuv715vq _19moidpf _1vqqidpf _m8oxidpf _bzd2idpf _zwvbidpf _19wzidpf _2awfidpf _l1guidpf _3otn1r31 _1d59glyw _r3kx1o36 _1y6utlke _1t6x161g _1u6z161g _1vpa161g _5skb161g _1xca161g _xcl1161g _rzx1161g _1xcr161g _57of161g _b29h161g _snlxh2mm _1rfpidpf _104oidpf _j6fg1ule _gkdh1wug _1jbo1wug _1qa65mfb _r4f35mfb _y1t8b3bt _1v9lb3bt _v42h1hrf _1t4e15vq _1u35glyw _1vrb1e5h _m8yv1osq _gzcot94y _tovh1txw _160x1h6o _1a23usic _k4vw1ule _19i1glyw _1afyglyw _1xnx1ule _qzmo15vq _1xzb1ule _ntpm1wug _4v68okh7 _13h3glyw",
                    "slider-container"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($vqrsL))), (0, $6iHNw._)((0, $7Knp0._)({}, sliderSettings), {
                    children: featureTexts.map((feature, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_18zrzwfg _1e0c1txw _2lx21bp4 _zulppxbi"
                            ]),
                            children: [
                                singleFeature(feature, index),
                                images[index]
                            ]
                        }, index))
                }))
            })
        ]
    });
};
// Source https://github.com/kenwheeler/slick/blob/master/slick/slick.css
const $a5d0df8bfd42a304$var$slickStyle = null;

});

parcelRegister("gtQwZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $359d438096babc01$export$2e2bcd8739ae039; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $lbVpk = parcelRequire("lbVpk");

var $c4STr = parcelRequire("c4STr");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $359d438096babc01$export$887967f05dc521ae = (_param)=>{
    var { layout: layout = "image-right" } = _param, props = (0, $akGnX._)(_param, [
        "layout"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        style: {
            "--background-color": `${props.backgroundColor ? (0, $5ohHq.wacToken)(props.backgroundColor) : "transparent"}`
        },
        className: (0, $esG4f.default)([
            "_11q76ulk"
        ]),
        children: layout === "image-both" ? /*#__PURE__*/ (0, $loA2J.jsx)($359d438096babc01$var$HeroBothImages, (0, $7Knp0._)({
            layout: layout
        }, props)) : /*#__PURE__*/ (0, $loA2J.jsx)($359d438096babc01$var$HeroOneImage, (0, $7Knp0._)({
            layout: layout
        }, props))
    });
};
var $359d438096babc01$export$2e2bcd8739ae039 = $359d438096babc01$export$887967f05dc521ae;
const $359d438096babc01$var$DARK_BKGD_COLORS = [
    "color.primary.black"
];
const $359d438096babc01$var$HeadingContent = ({ heading: heading, subheading: subheading, callToActionProps: callToActionProps, size: size = "regular", backgroundColor: backgroundColor })=>{
    const _ref = callToActionProps !== null && callToActionProps !== void 0 ? callToActionProps : {}, { text: buttonText } = _ref, buttonProps = (0, $akGnX._)(_ref, [
        "text"
    ]);
    const isLarge = size === "large";
    const useLightText = backgroundColor ? $359d438096babc01$var$DARK_BKGD_COLORS.includes(backgroundColor) : false;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                style: {
                    color: useLightText ? (0, $5ohHq.wacToken)("color.neutral.light0") : "inherit"
                },
                className: (0, $esG4f.default)([
                    "_18s8ze3t",
                    isLarge ? "superhero" : undefined
                ]),
                children: heading
            }),
            subheading && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_6rthze3t",
                    isLarge ? "body-lg" : "body-md"
                ]),
                style: {
                    color: useLightText ? (0, $5ohHq.wacToken)("color.neutral.light0") : "inherit"
                },
                children: subheading
            }),
            buttonText && buttonProps && /*#__PURE__*/ (0, $loA2J.jsx)((0, $lbVpk.Button), (0, $6iHNw._)((0, $7Knp0._)({}, buttonProps), {
                size: "large",
                className: (0, $esG4f.default)([
                    "_1pfhxy5q"
                ]),
                children: buttonText
            }))
        ]
    });
};
const $359d438096babc01$var$HeroOneImage = (_param)=>{
    var { layout: layout = "image-right", imageProps: imageProps } = _param, props = (0, $akGnX._)(_param, [
        "layout",
        "imageProps"
    ]);
    var _imageProps_alt;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c11p5 _zulp1ejb _1rjc1jfw _y3gn1h6o _4cvr1h6o _1j8bwxkt _lagd18l3 _19wgxy5q _uj6kv2br _1ooboahv _1s0lxncg"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        layout === "image-left" && "_1b1qcs5v"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)($359d438096babc01$var$HeadingContent, (0, $7Knp0._)({}, props))
                }),
                imageProps && /*#__PURE__*/ (0, $loA2J.jsx)((0, $c4STr.Image), {
                    maxPossibleWidth: 700,
                    src: imageProps.src,
                    alt: (_imageProps_alt = imageProps.alt) !== null && _imageProps_alt !== void 0 ? _imageProps_alt : "",
                    loading: "eager",
                    width: imageProps.width,
                    height: imageProps.height
                })
            ]
        })
    });
};
const $359d438096babc01$var$gridStyle = null;
const $359d438096babc01$var$headingStyle = null;
const $359d438096babc01$var$imageStartStyle = null;
const $359d438096babc01$var$bodyStyle = null;
const $359d438096babc01$var$buttonStyle = null; /*
                          This is an experimental start to support the needs of the Hero variation with images on the sides, primary content centered
                          Initial support is seens on Product enterprise pages (such as /software/jira/enterprise) as served by WAC Authoring Engine
                          
                          TODO: We need to understand the levels of configurability desired/needed to support a variety of use cases, collab with design.
                            Currently it is very tailored to the aforementioned enterprise experience
                          */ 
const $359d438096babc01$var$HeroBothImages = (_param)=>{
    var { imageProps: imageProps, secondaryImageProps: secondaryImageProps } = _param, props = (0, $akGnX._)(_param, [
        "imageProps",
        "secondaryImageProps"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1reo15vq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            layout: "12",
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_uaqo1x3a _13j917im",
                    "_kqswh2mm _1e0c11p5 _10fp1h6o _y3gn1h6o _4cvr1h6o _6a6z1h6o _1rjc1jfw _14b51ssb _su07u2gc _1ooboahv _1s0lxncg _bxthb3bt _t4hxstnw _1yp51osq _1bpvsmen _brhgmgnk _5kbx1f51 _1gg8w2la _n4lfidpf _1nls12it _14xsidpf _16bh12it _1z0y9by0 _ixsu1osq _a6uwb3bt _dbttstnw _83tk1wn5 _10wjmgnk _tzs91f51 _wi3i1048 _1x65idpf _oppa12it _1ohy1kly _nd8fidpf _1yam12it _ugza1kly _mlxy9by0 _k4z51osq _xcpbpwvu"
                ]),
                style: {
                    "--_1thiznr": (0, $43MIc.default)(imageProps ? `url(${imageProps.src})` : "none"),
                    "--_c31b9r": (0, $43MIc.default)(secondaryImageProps ? `url(${secondaryImageProps.src})` : "none")
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)($359d438096babc01$var$HeadingContent, (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                    size: "regular"
                }))
            })
        })
    });
};
const $359d438096babc01$var$gridTwoImagesStyle = null;

});

parcelRegister("5C9Aa", function(module, exports) {

$parcel$export(module.exports, "HeroCarousel", function () { return $47d867af5ed4b3f4$export$b92905002f03c113; });
/* hero-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $eDoPe = parcelRequire("eDoPe");
parcelRequire("isSvf");
var $lxS8L = parcelRequire("lxS8L");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $lbVpk = parcelRequire("lbVpk");

var $1O6nN = parcelRequire("1O6nN");
const $47d867af5ed4b3f4$export$b92905002f03c113 = ({ tabsData: tabsData })=>{
    const [selectedTab, setSelectedTab] = (0, $iSvIT.useState)(0);
    const listRef = (0, $iSvIT.useRef)(null);
    const { ref: lastTabRef, inView: isTabListEndVisible } = (0, $eDoPe.useInView)({
        root: listRef === null || listRef === void 0 ? void 0 : listRef.current,
        threshold: 1
    });
    const { ref: firstTabRef, inView: isTabListStartVisible } = (0, $eDoPe.useInView)({
        root: listRef === null || listRef === void 0 ? void 0 : listRef.current,
        threshold: 1
    });
    (0, $iSvIT.useEffect)(()=>{
        const listElement = listRef === null || listRef === void 0 ? void 0 : listRef.current;
        if (listElement) {
            var _listElement_children;
            const tabElement = (_listElement_children = listElement.children) === null || _listElement_children === void 0 ? void 0 : _listElement_children[selectedTab + 1];
            if (tabElement && typeof tabElement.scrollIntoView === "function") {
                tabElement.scrollIntoView({
                    behavior: "smooth",
                    inline: "center",
                    block: "end"
                });
                tabElement.focus();
            }
        }
    }, [
        selectedTab
    ]);
    const onKeyDown = (e)=>{
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
            let newFocusIndex = 0;
            if (e.key === "ArrowRight") {
                newFocusIndex = selectedTab + 1;
                if (newFocusIndex >= tabsData.length) newFocusIndex = 0;
            } else if (e.key === "ArrowLeft") {
                newFocusIndex = selectedTab - 1; // If we're at the start, move to the end
                if (newFocusIndex < 0) newFocusIndex = tabsData.length - 1;
            }
            setSelectedTab(newFocusIndex);
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        id: "hero-carousel",
        "data-testid": "hero-carousel",
        className: (0, $esG4f.default)([
            "_1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx21sxn _1bsb1osq _1reo15vq _18m915vq"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)($47d867af5ed4b3f4$var$TabList, {
                    listRef: listRef,
                    isTabListViewable: isTabListStartVisible && isTabListEndVisible,
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            ref: firstTabRef
                        }),
                        tabsData.map((tab, i)=>/*#__PURE__*/ (0, $loA2J.jsxs)($47d867af5ed4b3f4$var$Tab, {
                                isSelected: i === selectedTab,
                                id: tab.id,
                                onClick: ()=>{
                                    setSelectedTab(i);
                                },
                                onKeyDown: onKeyDown,
                                children: [
                                    tab.eyebrow && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        className: (0, $esG4f.default)([
                                            "_syaz121t _y3gnv2br _19pkidpf _2hwxidpf _otyridpf _18u0idpf _tzy4105o _v564177f",
                                            "eyebrow-sm"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                                        },
                                        children: tab.eyebrow
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        className: (0, $esG4f.default)([
                                            "_syaz121t _y3gnv2br _19pkidpf _2hwxidpf _otyridpf _18u0idpf _tzy4105o _v564177f",
                                            "_1wyb19as _k48p16tn _vwz41xr0"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                                        },
                                        children: tab.title
                                    })
                                ]
                            }, tab.id)),
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            ref: lastTabRef
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)($47d867af5ed4b3f4$var$PanelContainer, {
                    children: tabsData.map((tab, i)=>/*#__PURE__*/ (0, $loA2J.jsx)($47d867af5ed4b3f4$var$Panel, {
                            isSelected: i === selectedTab,
                            id: tab.id,
                            panel: tab.panel,
                            titleAs: i === 0 ? "h1" : "h2"
                        }, tab.id))
                })
            ]
        })
    });
};
var $47d867af5ed4b3f4$export$2e2bcd8739ae039 = $47d867af5ed4b3f4$export$b92905002f03c113;
const $47d867af5ed4b3f4$var$TabList = ({ children: children, listRef: listRef, isTabListViewable: isTabListViewable })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_11q71hlo _1bsb1osq _syazcd5j _1reo15vq _18m915vq _18zrzwfg _su071wqb"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div" // @ts-ignore
        , {
            ref: listRef,
            tabIndex: -1,
            role: "tablist",
            className: (0, $esG4f.default)([
                "_1tkegad4 _1e0c1txw _qtt8glyw _1mouidpf _195g1wug _18zridpf _1rjcie5z _1reo15zi _rjfvx6dd _b8yqzqdx _zcekze3t _kpfhglyw",
                isTabListViewable && "_1bah1h6o"
            ]),
            children: children
        })
    });
};
const $47d867af5ed4b3f4$var$Tab = ({ children: children, isSelected: isSelected, id: id, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
        type: "button",
        tabIndex: isSelected ? 0 : -1,
        role: "tab",
        "aria-selected": isSelected ? "true" : "false",
        "aria-controls": `hero-panel-${id}`,
        id: `hero-tab-${id}`,
        onClick: onClick,
        onKeyDown: onKeyDown,
        "data-label": `hero-tab-${id}`,
        className: (0, $esG4f.default)([
            "_mqm21kma _v564ucvz _179rglyw _h7alglyw _r06hglyw _bfhk1j28 _ect41kw7 _1wyb1j6v _1bsb1ltq _1ul91ltq _80omtlke _1hu1v2br _1rjcu2gc _18zr1ejb _4cvrv2br _1e0c1txw _2lx21bp4 _zulp12x7 _ihhukb7n _n41hkb7n",
            isSelected && "_mqm21hn9 _1mrhkb7n"
        ]),
        style: {
            "--_1vwzriw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.yellow"))
        },
        children: children
    });
};
const $47d867af5ed4b3f4$var$PanelContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c11p5"
        ]),
        children: children
    });
};
const $47d867af5ed4b3f4$var$Panel = (_param)=>{
    var { isSelected: isSelected, id: id, panel: panel } = _param, props = (0, $akGnX._)(_param, [
        "isSelected",
        "id",
        "panel"
    ]);
    var _panel_secondaryCallToAction, _panel_bgImage, _panel_secondaryCallToAction1;
    const [isModalOpen, setIsModalOpen] = (0, $iSvIT.useState)(false);
    const baseStyle = null;
    const isVideoLink = ((_panel_secondaryCallToAction = panel.secondaryCallToAction) === null || _panel_secondaryCallToAction === void 0 ? void 0 : _panel_secondaryCallToAction.type) === "video";
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        role: "tabpanel",
        id: `hero-panel-${id}`,
        "data-testid": `hero-panel-${id}`,
        "aria-hidden": !isSelected,
        "aria-labelledby": `hero-tab-${id}`,
        className: (0, $esG4f.default)([
            "_v564twcc _yyhy183o _1ii7183o _1e0c11p5 _tzy4idpf _1pby1mrw _kqswh2mm",
            isSelected && "_tzy4kb7n _1pbykb7n",
            "_1kt9b3bt _1g0v1mrw _1cs8stnw _1tesidpf _1rusu6yl _aetrb3bt _1bqq1mrw _18postnw _16gxidpf _z0ai1osq _wbcj14i6 _1kje1h6o _1hfku6yl _1a1fdirt _19h91dfr _z0bc12wd"
        ]),
        style: {
            "--bg-color": panel.bgColor === "neutral" ? (0, $5ohHq.wacToken)(`color.neutral.light200`) : (0, $5ohHq.wacToken)(`color.primary.${panel.bgColor}`),
            "--_1gk99st": (0, $43MIc.default)(((_panel_bgImage = panel.bgImage) === null || _panel_bgImage === void 0 ? void 0 : _panel_bgImage.lg) ? `url(${panel.bgImage.lg})` : undefined),
            "--_xe4ghn": (0, $43MIc.default)(panel.layout === "end" ? "0% 50%" : "center center")
        },
        children: [
            isVideoLink && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Modal), {
                isOpen: isModalOpen,
                closeModal: ()=>{
                    setIsModalOpen(false);
                },
                closeLabel: "Close video",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lxS8L.Video), {
                    muted: false,
                    videoType: "mp4",
                    videoLink: (_panel_secondaryCallToAction1 = panel.secondaryCallToAction) === null || _panel_secondaryCallToAction1 === void 0 ? void 0 : _panel_secondaryCallToAction1.href
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_yyhy183o _1ii7183o _18zrzwfg _1rjcxncg _1e0c11p5 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulp1ejb _1qon1h6o _1lb81h6o _5qqy1h6o _su071wqb _1rqtcx6w _pdlmxy5q _10jxzqdx",
                    panel.layout === "end" ? "_1uyy1d44 _1cxzv2br _10wbv2br _s0n3v2br" : panel.layout === "start" ? "_1uyy1vi5 _1cxzv2br _10wbv2br _s0n3v2br" : "_1uyyeqnf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)($47d867af5ed4b3f4$var$PanelContent, {
                        panel: panel,
                        titleAs: props.titleAs
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($47d867af5ed4b3f4$var$PanelActions, (0, $6iHNw._)((0, $7Knp0._)({}, panel), {
                        onVideoClick: isVideoLink ? (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            setIsModalOpen(true);
                        } : undefined
                    }))
                ]
            })
        ]
    });
};
const $47d867af5ed4b3f4$var$PanelContent = (_param)=>{
    var { panel: panel } = _param, props = (0, $akGnX._)(_param, [
        "panel"
    ]);
    // We need to think about this more holistically going forward, instead of on a per component level
    const isForegroundLight = [
        "blue",
        "black"
    ].includes(panel.bgColor);
    const { titleAs: Title = "h2" } = props;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)(Title, {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                    isForegroundLight && "_syaz121t",
                    "h1"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: panel.title
            }),
            panel.body && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                    isForegroundLight && "_syaz121t",
                    "body-lg"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: panel.body
            })
        ]
    });
};
const $47d867af5ed4b3f4$var$PanelActions = (panel)=>{
    return panel && /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _1n261g80 _zulp1ejb",
            (panel.layout === "start" || panel.layout === "end") && "_msupv2br"
        ]),
        children: [
            panel.primaryCallToAction && /*#__PURE__*/ (0, $loA2J.jsx)($47d867af5ed4b3f4$var$PrimaryCallToAction, (0, $7Knp0._)({
                bgColor: panel.bgColor
            }, panel.primaryCallToAction)),
            panel.secondaryCallToAction && /*#__PURE__*/ (0, $loA2J.jsx)($47d867af5ed4b3f4$var$SecondaryCallToAction, (0, $7Knp0._)({}, panel))
        ]
    });
};
const $47d867af5ed4b3f4$var$PrimaryCallToAction = (props)=>{
    const { bgColor: bgColor } = props, rest = (0, $akGnX._)(props, [
        "bgColor"
    ]);
    let variant = "primary";
    if (bgColor === "blue") variant = "primary_alt";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lbVpk.Button), (0, $6iHNw._)((0, $7Knp0._)({}, rest), {
        variant: variant,
        "data-testid": "primary-cta",
        children: props.text
    }));
};
const $47d867af5ed4b3f4$var$SecondaryCallToAction = (panel)=>{
    const { secondaryCallToAction: secondaryCallToAction } = panel;
    const bgColor = [
        "blue",
        "black"
    ].includes(panel.bgColor) ? "bgBlackBlue" : "bgWhite";
    return(// @ts-ignore
    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1O6nN.Link), (0, $6iHNw._)((0, $7Knp0._)({}, secondaryCallToAction), {
        bgColor: bgColor,
        anchorProps: {
            "data-testid": "secondary-cta"
        },
        onClick: panel.onVideoClick
    })));
};
const $47d867af5ed4b3f4$var$sectionStyles = null;
const $47d867af5ed4b3f4$var$tabListStyle = null;
const $47d867af5ed4b3f4$var$scrollableStyle = null;
const $47d867af5ed4b3f4$var$fittableStyle = null;
const $47d867af5ed4b3f4$var$tabStyle = null;
const $47d867af5ed4b3f4$var$tabTextStyle = null; /* Need to refactor our default typography to reduce need for important on a classless paragraph */ 
const $47d867af5ed4b3f4$var$tabTitleStyle = null;
const $47d867af5ed4b3f4$var$tabSelectedStyle = null;
const $47d867af5ed4b3f4$var$panelContainerStyle = null;
const $47d867af5ed4b3f4$var$panelStyle = null;
const $47d867af5ed4b3f4$var$panelSelectedStyle = null;
const $47d867af5ed4b3f4$var$panelDetailsStyle = null;
const $47d867af5ed4b3f4$var$panelEndStyle = null;
const $47d867af5ed4b3f4$var$panelStartStyle = null;
const $47d867af5ed4b3f4$var$panelCenteredStyle = null;
const $47d867af5ed4b3f4$var$detailsTextStyle = null;
const $47d867af5ed4b3f4$var$panelColorStyle = null;
const $47d867af5ed4b3f4$var$actionContainerStyle = null;
const $47d867af5ed4b3f4$var$actionStartStyle = null;

});

parcelRegister("g4WuQ", function(module, exports) {

$parcel$export(module.exports, "Integration", function () { return $edab1f6e8003d45e$export$8912007324034abd; });
/* integration.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
const $edab1f6e8003d45e$var$logoSizes = {
    regular: {
        size: "78px",
        cornerRadius: "18.7px"
    },
    large: {
        size: "100px",
        cornerRadius: "24px"
    }
};
const $edab1f6e8003d45e$var$IntegrationLogo = (props)=>{
    const logoListItemStyles = null;
    const logoLinkStyles = null;
    const logoImageContainerStyles = null;
    if (!props.href) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("li", {
        className: (0, $esG4f.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _80omtlke _1bsbcae7 _4t3icae7 _bfhkcd5j _19it1k0a _2rko13r7 _gltef22m _165tf22m _2oz41w8s _1dbz1cd0"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300")),
            "--_1jpuyj7": (0, $43MIc.default)($edab1f6e8003d45e$var$logoSizes[props.logoSize].size),
            "--_1k7rxgg": (0, $43MIc.default)($edab1f6e8003d45e$var$logoSizes[props.logoSize].cornerRadius)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
            href: props.href,
            className: (0, $esG4f.default)([
                "_1e0c1txw _4t3i1osq _1bsb1osq _4cvr1h6o _1bah1h6o _1yt4u2gc"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbsq37 _4t3isbdl"
                ]),
                style: {
                    "--_1hn5070": (0, $43MIc.default)(props.width ? `${props.width}px` : "100%"),
                    "--_1jk4xy3": (0, $43MIc.default)(props.width ? "auto" : "100%")
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: props.src,
                    alt: props.alt,
                    style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "contain"
                    }
                })
            })
        })
    });
};
const $edab1f6e8003d45e$export$8912007324034abd = ({ eyebrow: eyebrow, title: title, titleAs: titleAs = "h3", body: body, linkLabel: linkLabel, linkHref: linkHref, logos: logos, background: background = "polygon", backgroundColor: backgroundColor = "neutral.light100", flipLayout: flipLayout = false })=>{
    const numLogos = logos.filter((logo)=>{
        var _logo_href;
        return (_logo_href = logo.href) !== null && _logo_href !== void 0 ? _logo_href : false;
    }).length;
    const logoSize = numLogos <= 6 ? "large" : "regular";
    const responsiveSectionDividerHeightsStyles = null;
    const sectionStyles = null;
    const polygonStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1bsb1osq _kqswh2mm _1moul8wr _11q7fulm _1rjcq9zu",
            "_9luy1wqb _ce5au29b _wfa7llbu"
        ]),
        style: {
            "--_pxzrua": (0, $43MIc.default)(background === "full" ? 0 : "var(--ds-space-800, 64px)"),
            "--_1sgx88i": (0, $43MIc.default)(background === "full" ? (0, $5ohHq.wacToken)(`color.${backgroundColor}`) : "transparent")
        },
        children: [
            background === "polygon" && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_11q71xvm _kqswstnw _1bsb1osq _4t3imhst _14b5zqdx _b8yq87gh _1e021ssb _t9eczr6s _1kt9b3bt _1cs8stnw _iajm14o7 _kfgtq9zu _1mp41osq _1s6k1xvm _tgsmcdv4 _aetrb3bt _18postnw _1qdgq9zu _19nq1osq _z0ai1osq _16r21xvm _1oj41mhh"
                ]),
                style: {
                    "--_vp2za": (0, $43MIc.default)((0, $5ohHq.wacToken)(`color.${backgroundColor}`))
                }
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_195g1wug _p12f1osq _1bsb1osq _kqswh2mm _1pbykb7n _13ltwklj _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _1j8bwxkt _1vsw1vi7 _d2ik1wqb _exxm1wqb _10jxzqdx _1e0c11p5 _vchhusvi _zulp14hz _1dsl1tcg _4t3i1osq _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _1n261g80 _p12f1to9 _195g1wug _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bah1h6o _4cvr1h6o _1p571ejb _gy1pxy5q _8fz6nklw _688gkb7n",
                            flipLayout && "_1f49kb7n",
                            numLogos === 7 && "_w9am12am _1bhm12am"
                        ]),
                        children: logos.map((logo, index)=>/*#__PURE__*/ (0, $loA2J.jsx)($edab1f6e8003d45e$var$IntegrationLogo, (0, $6iHNw._)((0, $7Knp0._)({}, logo), {
                                logoSize: logoSize
                            }), index))
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.ContentBlock), {
                        eyebrow: eyebrow,
                        title: title,
                        titleAs: titleAs,
                        text: body,
                        callToActionProps: linkLabel && linkHref ? {
                            link: {
                                text: linkLabel,
                                href: linkHref
                            }
                        } : undefined,
                        alignment: {
                            mobile: "center",
                            tablet: "start",
                            desktop: "start"
                        }
                    })
                ]
            })
        ]
    });
};
const $edab1f6e8003d45e$var$contentContainerStyles = null;
const $edab1f6e8003d45e$var$logosContainerStyles = null;
const $edab1f6e8003d45e$var$sevenLogosGridStyles = null;

});

parcelRegister("2Nqw3", function(module, exports) {

$parcel$export(module.exports, "Logos", function () { return $cfbf5b5ca75d407c$export$c847549a613b9060; });
/* logos.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $1UUq1 = parcelRequire("1UUq1");
const $cfbf5b5ca75d407c$export$c847549a613b9060 = ({ logos: logos })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1n261g80 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw _1bah1h6o _1p57oahv _gy1pxy5q _99s6xncg _1plrxncg _4cvr1h6o"
        ]),
        children: logos.map((logo, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: logo.src,
                    alt: logo.alt,
                    style: (0, $7Knp0._)({}, $cfbf5b5ca75d407c$var$logoStyles, logo.width ? {
                        width: `${logo.width}px`,
                        height: "auto"
                    } : {})
                })
            }, index))
    });
};
const $cfbf5b5ca75d407c$var$logosContainerStyle = null;
const $cfbf5b5ca75d407c$var$logoStyles = {
    height: "32px",
    width: "auto",
    maxWidth: "auto",
    filter: "grayscale(100%) brightness(66%)",
    ["-webkit-filter"]: "grayscale(100%) brightness(66%)"
};

});

parcelRegister("cJh4j", function(module, exports) {

$parcel$export(module.exports, "MobileApp", function () { return $998fa7af6915eee4$export$f81bbe9088ca57b0; });
/* mobile-app.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $1UUq1 = parcelRequire("1UUq1");
const $998fa7af6915eee4$export$f81bbe9088ca57b0 = ({ title: title, description: description, linkLabel: linkLabel, linkHref: linkHref, imageSrc: imageSrc, imageAlt: imageAlt = "", appleAppStoreUrl: appleAppStoreUrl, googlePlayStoreUrl: googlePlayStoreUrl })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1e0c11p5 _vchhusvi _zulp14hz _1bsb1osq _1dsl1tcg _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _1j8bwxkt _1vsw1vi7 _d2ik1wqb _exxm1wqb _10jxzqdx _1pfhxncg"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1yd3xy5q _40tuxncg _1mou1wug"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.ContentBlock), {
                        title: title,
                        titleAs: "h2",
                        text: description,
                        callToActionProps: linkLabel && linkHref ? {
                            link: {
                                text: linkLabel,
                                href: linkHref
                            }
                        } : undefined
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _zulppxbi _1pfhxy5q"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                href: appleAppStoreUrl,
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3g0xj4162q6vj8iis1nr5pkh2scjm13a.png",
                                    alt: "Download on the Apple App Store"
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                href: googlePlayStoreUrl,
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/md1w60b88865q56fl84744t5u0heh751.png",
                                    alt: "Get it on the Google Play Store"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1reo15vq _18m915vq"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: imageSrc,
                    alt: imageAlt,
                    className: (0, $esG4f.default)([
                        "_glte1osq _165t1pna _12rrk5xz _1vkhidpf _1x6l1osq _1bsb1osq _4t3ia91z _5ral1dfr _rsufq0ho"
                    ])
                })
            })
        ]
    });
};
const $998fa7af6915eee4$var$sectionStyles = null;
const $998fa7af6915eee4$var$leftSideContentStyles = null;
const $998fa7af6915eee4$var$appStoreLinksContainerStyles = null;
const $998fa7af6915eee4$var$imageContainerStyles = null;
const $998fa7af6915eee4$var$imageStyles = null;

});

parcelRegister("62VZK", function(module, exports) {

$parcel$export(module.exports, "useTabsContext", function () { return (parcelRequire("cPhXv")).useTabsContext; });
$parcel$export(module.exports, "Tabs", function () { return (parcelRequire("cPhXv")).Tabs; });
$parcel$export(module.exports, "DraggableTabList", function () { return (parcelRequire("gq8af")).DraggableTabList; });
$parcel$export(module.exports, "DraggableTab", function () { return (parcelRequire("6YaIp")).DraggableTab; });
$parcel$export(module.exports, "TabPanel", function () { return (parcelRequire("bN8aD")).TabPanel; });
$parcel$export(module.exports, "TabsSection", function () { return (parcelRequire("7CBQh")).TabsSection; });
$parcel$export(module.exports, "mapChild", function () { return (parcelRequire("kWavG")).mapChild; });

var $cPhXv = parcelRequire("cPhXv");

var $gq8af = parcelRequire("gq8af");

var $6YaIp = parcelRequire("6YaIp");

var $bN8aD = parcelRequire("bN8aD");

var $7CBQh = parcelRequire("7CBQh");

var $kWavG = parcelRequire("kWavG");

});
parcelRegister("cPhXv", function(module, exports) {

$parcel$export(module.exports, "useTabsContext", function () { return $5601ed8c8774e035$export$5c3d36c3adf0ba92; });
$parcel$export(module.exports, "Tabs", function () { return $5601ed8c8774e035$export$b2539bed5023c21c; });
/* tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $eDoPe = parcelRequire("eDoPe");

var $4xseM = parcelRequire("4xseM");

var $kWavG = parcelRequire("kWavG");
const $5601ed8c8774e035$var$TabsContext = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $5601ed8c8774e035$export$5c3d36c3adf0ba92 = ()=>{
    const context = (0, $iSvIT.useContext)($5601ed8c8774e035$var$TabsContext);
    if (!context) throw new Error("useTabsContext must be used within Tabs");
    return context;
};
let $5601ed8c8774e035$var$nextId = 0;
const $5601ed8c8774e035$export$b2539bed5023c21c = ({ id: id, initialTab: initialTab, loop: loop = true, children: children, useInViewOptionsContainer: useInViewOptionsContainer })=>{
    const [currentTab, setCurrentTab] = (0, $iSvIT.useState)(initialTab !== null && initialTab !== void 0 ? initialTab : 0);
    const [userSelected, setUserSelected] = (0, $iSvIT.useState)(false);
    const [focus, setFocus] = (0, $iSvIT.useState)(false);
    const tabIds = (0, $iSvIT.useRef)([]);
    const contextId = (0, $iSvIT.useRef)(`:tabs:${id ? id : $5601ed8c8774e035$var$nextId++}:`);
    const DEFAULT_IN_VIEW_THRESHOLD = 0.3;
    const { ref: containerScrollRef, inView: tabsContainerIsVisible } = (0, $eDoPe.useInView)((0, $7Knp0._)({
        threshold: DEFAULT_IN_VIEW_THRESHOLD
    }, useInViewOptionsContainer));
    const { ref: tabListScrollRef, inView: tabListIsVisible } = (0, $eDoPe.useInView)({
        threshold: DEFAULT_IN_VIEW_THRESHOLD
    });
    function getTabsCount() {
        let count = 0;
        (0, $kWavG.deepForEach)(children, (child)=>{
            if ((0, $kWavG.isTab)(child)) count++;
        });
        return count;
    }
    function getChildren() {
        let panelIndex = 0;
        tabIds.current = tabIds.current || [];
        let diff = tabIds.current.length - getTabsCount(); // Add ids if new tabs have been added
        // Don't bother removing ids, just keep them in case they are added again
        // This is more efficient, and keeps the uuid counter under control
        while(diff++ < 0)tabIds.current.push(`${contextId.current}${tabIds.current.length}`);
         // Map children to dynamically setup refs
        return (0, $kWavG.deepMap)(children, (child)=>{
            var _window_document_activeElement;
            let result = child; // Check if the window is available
            const windowAvailable = !!window && !!window.document && !!window.document.activeElement; // Get the active element id
            const activeElementId = windowAvailable ? (_window_document_activeElement = window.document.activeElement) === null || _window_document_activeElement === void 0 ? void 0 : _window_document_activeElement.id : null; // Clone TabList and Tab components to have refs
            if ((0, $kWavG.isTabList)(child)) {
                let listIndex = 0; // Figure out if the current focus in the DOM is set on a Tab
                // If it is we should keep the focus on the next selected tab
                let wasTabFocus = false;
                if (windowAvailable && activeElementId) // Check if the active element is a tab
                wasTabFocus = (0, $iSvIT.Children).toArray(child.props.children).filter((0, $kWavG.isTab)).some((_, i)=>{
                    return activeElementId === `tab${tabIds.current[i]}`;
                });
                result = /*#__PURE__*/ (0, $iSvIT.cloneElement)(child, {
                    children: (0, $kWavG.deepMap)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    child.props.children, (tab)=>{
                        const selected = currentTab === listIndex;
                        const props = {
                            id: tabIds.current[listIndex],
                            tabIndex: listIndex,
                            focus: selected && (focus || wasTabFocus)
                        };
                        listIndex++;
                        return /*#__PURE__*/ (0, $iSvIT.cloneElement)(tab, props);
                    })
                });
            } else if ((0, $kWavG.isTabPanel)(child)) {
                const props = {
                    id: tabIds.current[panelIndex],
                    panelIndex: panelIndex
                };
                panelIndex++;
                result = /*#__PURE__*/ (0, $iSvIT.cloneElement)(child, props);
            }
            return result;
        });
    }
    const goToTab = (tabIndex)=>{
        if (tabIndex === undefined) return;
        setCurrentTab(tabIndex);
    };
    const isCurrentTab = (tabIndex)=>{
        return tabIndex === currentTab;
    };
    const goToNextTab = (0, $iSvIT.useCallback)(()=>{
        if (currentTab + 1 < tabIds.current.length) goToTab(currentTab + 1);
        else if (loop) goToTab(0);
    }, [
        loop,
        currentTab
    ]);
    const goToPrevTab = (0, $iSvIT.useCallback)(()=>{
        if (currentTab - 1 >= 0) goToTab(currentTab - 1);
        else if (loop) goToTab(tabIds.current.length - 1);
    }, [
        loop,
        currentTab
    ]);
    const goToFirstTab = ()=>{
        goToTab(0);
    };
    const goToLastTab = ()=>{
        goToTab(tabIds.current.length - 1);
    };
    const onKeyDown = (e)=>{
        if (e.code === "ArrowLeft" || e.code === "ArrowUp") goToPrevTab();
        else if (e.code === "ArrowRight" || e.code === "ArrowDown") goToNextTab();
        else if (e.code === "End") // Select last tab (End key)
        goToFirstTab();
        else if (e.code === "Home") // Select first tab (Home key)
        goToLastTab();
        else return;
        setUserSelected(true);
        setFocus(true); // This prevents scrollbars from moving around
        e.preventDefault();
    }; // Reset the userSelected state when the section is visible again
    (0, $iSvIT.useEffect)(()=>{
        if (tabsContainerIsVisible) setUserSelected(false);
    }, [
        tabsContainerIsVisible
    ]); // Reinitialize analytics when the tab changes
    // this is needed because the content wasn't rendered before
    (0, $iSvIT.useEffect)(()=>{
        (0, $4xseM.Initializer).autoTrack();
    }, [
        currentTab
    ]);
    const containerStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)($5601ed8c8774e035$var$TabsContext.Provider, {
        value: {
            currentTab: currentTab,
            userSelected: userSelected,
            goToTab: goToTab,
            isCurrentTab: isCurrentTab,
            goToNextTab: goToNextTab,
            goToPrevTab: goToPrevTab,
            goToFirstTab: goToFirstTab,
            goToLastTab: goToLastTab,
            onKeyDown: onKeyDown,
            tabsContainerIsVisible: tabsContainerIsVisible,
            tabListIsVisible: tabListIsVisible,
            tabListScrollRef: tabListScrollRef
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            ref: containerScrollRef,
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx21bp4 _zulp1jfw _1reo15vq _18m915vq"
            ]),
            children: getChildren()
        })
    });
};

});
parcelRegister("kWavG", function(module, exports) {

$parcel$export(module.exports, "isTab", function () { return $9ba823149c88c072$export$bdc9792d96913679; });
$parcel$export(module.exports, "isTabList", function () { return $9ba823149c88c072$export$9c326233b9ae5588; });
$parcel$export(module.exports, "isTabPanel", function () { return $9ba823149c88c072$export$9e12445c79db89b; });
$parcel$export(module.exports, "mapChild", function () { return $9ba823149c88c072$export$886f34b49305b07b; });
$parcel$export(module.exports, "deepMap", function () { return $9ba823149c88c072$export$ce7eaaed37329a1b; });
$parcel$export(module.exports, "deepForEach", function () { return $9ba823149c88c072$export$519ada94592b97fc; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $iSvIT = parcelRequire("iSvIT");
function $9ba823149c88c072$var$makeTypeChecker(tabsRole) {
    return (element)=>!!element.type && element.type.tabsRole === tabsRole;
}
const $9ba823149c88c072$export$bdc9792d96913679 = $9ba823149c88c072$var$makeTypeChecker("Tab");
const $9ba823149c88c072$export$9c326233b9ae5588 = $9ba823149c88c072$var$makeTypeChecker("TabList");
const $9ba823149c88c072$export$9e12445c79db89b = $9ba823149c88c072$var$makeTypeChecker("TabPanel");
const $9ba823149c88c072$export$dbaa4172856e20ab = (element)=>!!element.type && typeof element.type === "function";
function $9ba823149c88c072$var$isTabChild(child) {
    return $9ba823149c88c072$export$bdc9792d96913679(child) || $9ba823149c88c072$export$9c326233b9ae5588(child) || $9ba823149c88c072$export$9e12445c79db89b(child);
}
function $9ba823149c88c072$export$886f34b49305b07b(child, additionalProps) {
    if (child === null) return null;
    // Only pass additionalProps to functional components
    // React.cloneElement will throw an error if you pass additionalProps to a dom component like div
    if ($9ba823149c88c072$export$dbaa4172856e20ab(child)) return (0, $iSvIT.cloneElement)(child, (0, $7Knp0._)({}, child.props, additionalProps));
    return child;
}
function $9ba823149c88c072$export$ce7eaaed37329a1b(children, callback) {
    return (0, $iSvIT.Children).map(children, (child, index)=>{
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return null;
        if ($9ba823149c88c072$var$isTabChild(child)) return callback(child, index);
        if (child && child.props && child.props.children && typeof child.props.children === "object") // Clone the child that has children and map them too
        return (0, $iSvIT.cloneElement)(child, (0, $6iHNw._)((0, $7Knp0._)({}, child.props), {
            children: $9ba823149c88c072$export$ce7eaaed37329a1b(child.props.children, callback)
        }));
        return child;
    });
}
function $9ba823149c88c072$export$519ada94592b97fc(children, callback) {
    return (0, $iSvIT.Children).forEach(children, (child, index)=>{
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return;
        if ($9ba823149c88c072$export$bdc9792d96913679(child) || $9ba823149c88c072$export$9e12445c79db89b(child)) callback(child, index);
        else if (child && child.props && child.props.children && typeof child.props.children === "object") {
            if ($9ba823149c88c072$export$9c326233b9ae5588(child)) callback(child, index);
            $9ba823149c88c072$export$519ada94592b97fc(child.props.children, callback);
        }
    });
}

});


parcelRegister("gq8af", function(module, exports) {

$parcel$export(module.exports, "DraggableTabList", function () { return $36f3fdc852638cc4$export$dbb4ac5a817c6612; });
/* draggable-tab-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
parcelRequire("62VZK");
var $cPhXv = parcelRequire("cPhXv");
const $36f3fdc852638cc4$export$dbb4ac5a817c6612 = ({ alignment: alignment = "start", tabSize: // @ts-ignore
tabSize = "large", children: children })=>{
    const containerRef = (0, $iSvIT.useRef)(null);
    const mouseDown = (0, $iSvIT.useRef)(false);
    const startX = (0, $iSvIT.useRef)(0);
    const scrollLeft = (0, $iSvIT.useRef)(0);
    const canDrag = (0, $iSvIT.useRef)(false);
    const { onKeyDown: onKeyDown } = (0, $cPhXv.useTabsContext)();
    const startDragging = (mouse, touch)=>{
        var _containerRef_current;
        if (!canDrag.current) return;
         // Start listening for mouseup and mousemove events outside of the tab list
        document.addEventListener("mouseup", stopDragging);
        document.addEventListener("mousemove", move);
        mouseDown.current = true;
        var _ref;
        startX.current = (_ref = touch && touch.touches[0] ? touch.touches[0].clientX : mouse === null || mouse === void 0 ? void 0 : mouse.clientX) !== null && _ref !== void 0 ? _ref : 0;
        var _containerRef_current_scrollLeft;
        scrollLeft.current = (_containerRef_current_scrollLeft = (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.scrollLeft) !== null && _containerRef_current_scrollLeft !== void 0 ? _containerRef_current_scrollLeft : 0;
    };
    const stopDragging = ()=>{
        if (!canDrag.current) return;
         // Stop listening for mouseup and mousemove events
        document.removeEventListener("mouseup", stopDragging);
        document.removeEventListener("mousemove", move);
        mouseDown.current = false;
    };
    const move = (mouse, touch)=>{
        if (!canDrag.current || !mouseDown.current || !containerRef.current) return;
        let dragAmount = 0;
        if (touch && touch.changedTouches[0]) dragAmount = touch.changedTouches[0].clientX - startX.current;
        else if (mouse) dragAmount = mouse.clientX - startX.current;
        containerRef.current.scrollLeft = scrollLeft.current - dragAmount;
    };
    (0, $iSvIT.useEffect)(()=>{
        const updateCanDrag = ()=>{
            if (containerRef.current) {
                const container = containerRef.current;
                canDrag.current = container.scrollWidth > container.clientWidth;
            }
        };
        const setStartingPoint = ()=>{
            if (containerRef.current) {
                if (canDrag.current) {
                    const tabPanels = document.querySelector(".tab-panels");
                    const tabPanelsStyle = tabPanels && window.getComputedStyle(tabPanels);
                    containerRef.current.setAttribute("style", `padding-left: calc(${tabPanelsStyle === null || tabPanelsStyle === void 0 ? void 0 : tabPanelsStyle.marginLeft} + ${tabPanelsStyle === null || tabPanelsStyle === void 0 ? void 0 : tabPanelsStyle.paddingLeft});`);
                } else if (alignment === "center") containerRef.current.setAttribute("style", "margin-inline: auto; padding-inline: var(--fixed-padding);");
            }
        };
        if (!containerRef.current) return;
        const observer = new ResizeObserver(()=>{
            updateCanDrag();
            setStartingPoint();
        });
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    });
    const wrapperStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        ref: containerRef,
        className: (0, $esG4f.default)([
            "_1reo15vq _p12f1osq _11q81vi7 _3hzp1wqb"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div" // @ts-ignore
        , {
            onTouchStart: (e)=>startDragging(undefined, e),
            onMouseDown: (e)=>startDragging(e),
            onTouchEnd: (e)=>{
                // @ts-ignore
                move(undefined, e);
                stopDragging();
            },
            onTouchMove: (e)=>move(undefined, e),
            onKeyDown: onKeyDown,
            className: (0, $esG4f.default)([
                "_1e0c1txw _4cvr1y6m _1bah1y6m _1n261q9c _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw _1bsb1ns9 _p12f1osq _1moupxbi _zulp1ejb",
                "tab-list"
            ]),
            tabIndex: -1,
            role: "tablist",
            children: children
        })
    });
};
const $36f3fdc852638cc4$var$tabsContainerStyles = null;
$36f3fdc852638cc4$export$dbb4ac5a817c6612.tabsRole = "TabList";

});

parcelRegister("6YaIp", function(module, exports) {

$parcel$export(module.exports, "DraggableTab", function () { return $e90b6760ea28386b$export$3a29ca89d63c5c20; });
/* draggable-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("62VZK");
var $cPhXv = parcelRequire("cPhXv");
// eslint-disable-next-line complexity
const $e90b6760ea28386b$export$3a29ca89d63c5c20 = (_param)=>{
    var { id: id, focus: focus, tabIndex: tabIndex, title: title, iconUrl: iconUrl, tabSize: tabSize = "large", bgColor: bgColor = "bgWhite", label: label, dataEventProps: dataEventProps, className: className, enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false } = _param, props = (0, $akGnX._)(_param, [
        "id",
        "focus",
        "tabIndex",
        "title",
        "iconUrl",
        "tabSize",
        "bgColor",
        "label",
        "dataEventProps",
        "className",
        "enableRovoBorder",
        "enableResponsiveTabSize"
    ]);
    const { goToTab: goToTab, isCurrentTab: isCurrentTab, userSelected: userSelected } = (0, $cPhXv.useTabsContext)();
    const startX = (0, $iSvIT.useRef)(0);
    const tabRef = /*#__PURE__*/ (0, $iSvIT.createRef)();
    const isTabSelected = isCurrentTab(tabIndex);
    (0, $iSvIT.useEffect)(()=>{
        if (!tabRef.current || !tabRef.current.parentElement || !tabRef.current.parentElement.scrollTo || !tabRef.current.parentElement.parentElement || !tabRef.current.parentElement.parentElement.scrollTo) return;
         // Scroll to the selected tab if it's not in view
        if (isTabSelected) {
            var _tabRef_current_parentElement;
            if ((_tabRef_current_parentElement = tabRef.current.parentElement) === null || _tabRef_current_parentElement === void 0 ? void 0 : _tabRef_current_parentElement.parentElement) {
                // calculate the offset to center the tab in the parent
                const offsetLeft = tabRef.current.offsetLeft - tabRef.current.parentElement.offsetLeft - tabRef.current.parentElement.offsetWidth / 2 + tabRef.current.offsetWidth / 2;
                tabRef.current.parentElement.parentElement.scrollTo({
                    left: offsetLeft,
                    top: 0,
                    behavior: "smooth"
                });
            }
            if (focus) tabRef.current.focus({
                preventScroll: true
            });
        }
        if (isTabSelected && dataEventProps && userSelected) tabRef.current.dispatchEvent(new Event("select"));
    }, [
        tabRef,
        isTabSelected,
        focus,
        userSelected,
        dataEventProps
    ]);
    const onMouseDown = (e)=>{
        var _props_onMouseDown;
        var _e_clientX;
        startX.current = (_e_clientX = e.clientX) !== null && _e_clientX !== void 0 ? _e_clientX : 0;
        (_props_onMouseDown = props.onMouseDown) === null || _props_onMouseDown === void 0 ? void 0 : _props_onMouseDown.call(props, e);
    };
    const onClick = (0, $iSvIT.useCallback)((e)=>{
        var _props_onClick;
        if (Math.abs(e.clientX - startX.current) > 15) // Prevent click event if user is dragging
        return;
        (_props_onClick = props.onClick) === null || _props_onClick === void 0 ? void 0 : _props_onClick.call(props, e);
        if (isTabSelected) return;
        goToTab(tabIndex);
    }, [
        isTabSelected,
        tabIndex,
        goToTab,
        props
    ]);
    const onKeyDown = (e)=>{
        if (e.code === "Space" || e.code === "Enter") {
            goToTab(tabIndex);
            e.preventDefault();
        }
    };
    const tabColor = bgColor === "bgWhite" ? (0, $5ohHq.wacToken)("color.neutral.light200") : (0, $5ohHq.wacToken)("color.neutral.light0");
    const tabStyles = null;
    const rovoBorderStyles = null;
    const borderStyles = null;
    const largeTabStyles = null;
    const smallTabStyles = null;
    const iconTabStyles = null;
    const iconLargeTabStyles = null;
    const iconSmallTabStyles = null;
    const responsiveIconTabStyles = null;
    const iconLargeContainerStyles = null;
    const iconSmallContainerStyles = null;
    const responsiveIconContainerStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", (0, $6iHNw._)((0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, props), {
        ref: tabRef,
        className: className,
        id: `tab${id}`,
        "aria-selected": isTabSelected,
        "aria-controls": `panel${id}`,
        "aria-label": label,
        title: label,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onKeyDown: onKeyDown,
        role: "tab",
        tabIndex: -1
    }), dataEventProps), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("button", {
            className: (0, $esG4f.default)([
                "_o5721q9c _1ul9ymf6 _bfhk1jrh _4cvr1h6o _1bah1h6o _vchhusvi _1e0c1txw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko17td _19itq75r _80omtlke _4cvx17la _8y9r1hlo",
                iconUrl && "_2lx21bp4 _2rkoi2wt _1wyb1j6v",
                iconUrl && enableRovoBorder ? "_1h6d1j28 _1s79mzrp _1esp1ws1 _494pusvi _iusibx47" : "_1npj1ybm _1s7917la",
                iconUrl && enableResponsiveTabSize && "_4t3i1n2x _1ul9176v _1yt437zh _1xlocmky _1d2y11ux _6ytt139i",
                !iconUrl && tabSize === "large" && "_ca0qdlk8 _u5f31f4h _n3tddlk8 _19bv1f4h _vwz41f4h _4t3i1wqb _1wyb1cby",
                !iconUrl && tabSize === "small" && "_1yt41c98 _vwz4v47k _4t3i1ylp _1wyb1j6v",
                iconUrl && !enableResponsiveTabSize && tabSize === "large" && "_4t3icmky _1ul911ux _1yt4139i",
                iconUrl && !enableResponsiveTabSize && tabSize === "small" && "_4t3i1n2x _1ul9176v _1yt437zh",
                `${isTabSelected ? "currentTab" : ""}`
            ]),
            "data-product-key": "template",
            "data-event": "clicked",
            "data-event-component": "button",
            "data-event-container": "tabsMenu",
            "data-label": title,
            style: {
                "--_7aj7gm": (0, $43MIc.default)(tabColor),
                "--_514je1": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.pill")),
                "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100"))
            },
            children: [
                iconUrl && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        !enableResponsiveTabSize && tabSize === "large" && "_4t3ickbl _1bsbckbl",
                        !enableResponsiveTabSize && tabSize === "small" && "_4t3i10mc _1bsb10mc",
                        enableResponsiveTabSize && "_4t3i10mc _1bsb10mc _1xlockbl _14b5ckbl",
                        "default-icon"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                        src: `${iconUrl || ""}`,
                        alt: "",
                        draggable: false
                    })
                }),
                title
            ]
        })
    }));
};
$e90b6760ea28386b$export$3a29ca89d63c5c20.tabsRole = "Tab";

});

parcelRegister("bN8aD", function(module, exports) {

$parcel$export(module.exports, "TabPanel", function () { return $9a33649b5acaee05$export$3d96ec278d3efce4; });
/* tab-panel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
parcelRequire("62VZK");
var $cPhXv = parcelRequire("cPhXv");
var $kWavG = parcelRequire("kWavG");
const $9a33649b5acaee05$var$hidePanelStyle = null;
const $9a33649b5acaee05$export$3d96ec278d3efce4 = (_param)=>{
    var { forceRender: forceRender, children: children, panelIndex: panelIndex, id: id } = _param, props = (0, $akGnX._)(_param, [
        "forceRender",
        "children",
        "panelIndex",
        "id"
    ]);
    const { isCurrentTab: isCurrentTab } = (0, $cPhXv.useTabsContext)();
    const isTabSelected = isCurrentTab(panelIndex);
    const activeClass = isTabSelected ? "active-panel" : "";
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        id: `panel${id}`,
        "aria-labelledby": `tab${id}`,
        "aria-hidden": !isTabSelected,
        role: "tabpanel",
        className: (0, $esG4f.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                "tab-panel",
                activeClass
            ].join(" ")
        ]),
        children: (0, $iSvIT.Children).map(children, (child)=>{
            return (0, $kWavG.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    }));
};
$9a33649b5acaee05$export$3d96ec278d3efce4.tabsRole = "TabPanel";

});

parcelRegister("7CBQh", function(module, exports) {

$parcel$export(module.exports, "TabsSection", function () { return $8c54ab3226897d8a$export$502de1d4d55224c1; });
/* tabs-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");
parcelRequire("62VZK");
var $cPhXv = parcelRequire("cPhXv");
var $gq8af = parcelRequire("gq8af");
var $6YaIp = parcelRequire("6YaIp");
var $bN8aD = parcelRequire("bN8aD");
const $8c54ab3226897d8a$export$502de1d4d55224c1 = ({ alignment: alignment = "start", tabsData: tabsData, tabSize: tabSize = "large", bgColor: bgColor = "bgWhite", enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false })=>{
    const sectionStyles = null;
    const fullWidthContainerStyles = null;
    const enableIconTabs = tabsData.every((tab)=>tab.iconUrl);
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        id: "tabs",
        className: (0, $esG4f.default)([
            "_1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cPhXv.Tabs), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $gq8af.DraggableTabList), {
                    tabSize: tabSize,
                    alignment: alignment,
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $6YaIp.DraggableTab), {
                            tabIndex: index,
                            title: tab.title,
                            iconUrl: enableIconTabs ? tab.iconUrl : undefined,
                            tabSize: tabSize,
                            bgColor: bgColor,
                            className: "round-tab",
                            enableRovoBorder: enableIconTabs && enableRovoBorder,
                            enableResponsiveTabSize: enableIconTabs && enableResponsiveTabSize
                        }, index))
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        tabSize === "large" && "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _1reoewfl _18m9ewfl _bozgzwfg _y4tizwfg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx",
                        "tab-panels"
                    ]),
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $bN8aD.TabPanel), {
                            panelIndex: index,
                            id: tab.id,
                            children: tab.tabComponent
                        }, index))
                })
            ]
        })
    });
};

});





parcelRegister("7vkxP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("6q68w")).default; });

var $6q68w = parcelRequire("6q68w");

});
parcelRegister("6q68w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94975d69a8f24321$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $1UUq1 = parcelRequire("1UUq1");

var $8lB1y = parcelRequire("8lB1y");

var $3FBn4 = parcelRequire("3FBn4");
const $94975d69a8f24321$var$getBodyText = (props)=>{
    if (!props.body && !props.richText) return undefined;
    if (props.richText) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
        text: props.richText
    });
    return props.body;
};
const $94975d69a8f24321$var$UniformCard = (props)=>{
    var _props_linkUrl;
    var _props_linkUrl_toString;
    const localizedHref = (0, $3FBn4.useLocalizedHref)((_props_linkUrl_toString = (_props_linkUrl = props.linkUrl) === null || _props_linkUrl === void 0 ? void 0 : _props_linkUrl.toString()) !== null && _props_linkUrl_toString !== void 0 ? _props_linkUrl_toString : "");
    var _props_imageAlt;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Card), {
        align: props.alignment,
        orientation: props.orientation,
        columns: props.columns,
        background: props.background,
        eyebrow: props.eyebrow ? props.eyebrow : undefined,
        logo: props.logo,
        title: props.title ? props.title : undefined,
        titleAs: props.titleAs,
        body: $94975d69a8f24321$var$getBodyText(props),
        callToAction: props.linkUrl && props.linkText ? {
            text: props.linkText,
            href: localizedHref
        } : undefined,
        image: props.imageUrl ? {
            image: {
                src: props.imageUrl,
                alt: (_props_imageAlt = props.imageAlt) !== null && _props_imageAlt !== void 0 ? _props_imageAlt : ""
            }
        } : undefined,
        icon: props.iconUrl ? {
            linkedIcon: {
                url: props.iconUrl,
                size: props.iconSize
            }
        } : undefined,
        spotIllustrationUrl: props.spotIllustrationUrl
    });
};
var $94975d69a8f24321$export$2e2bcd8739ae039 = $94975d69a8f24321$var$UniformCard;

});


parcelRegister("haYnf", function(module, exports) {
$parcel$export(module.exports, "UniformColumnLayout", function () { return (parcelRequire("gVN7C")).UniformColumnLayout; });
$parcel$export(module.exports, "UniformSubColumnLayout", function () { return (parcelRequire("gVN7C")).UniformSubColumnLayout; });
parcelRequire("gVN7C");

});
parcelRegister("gVN7C", function(module, exports) {

$parcel$export(module.exports, "UniformColumnLayout", function () { return $cf835c6cfdad349b$export$23133ddca0202abb; });
$parcel$export(module.exports, "UniformSubColumnLayout", function () { return $cf835c6cfdad349b$export$8807233e43f557a9; });
/* column-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");
const $cf835c6cfdad349b$var$baseStyle = null;
const $cf835c6cfdad349b$var$fullWidthStyles = null;
const $cf835c6cfdad349b$var$layout10 = null;
const $cf835c6cfdad349b$var$layout8 = null; // For 8-4 the following is equivalent to having a 12 column grid
// where the first child is `gridColumn: 1 / span 8` and the second is `9 / -1`
const $cf835c6cfdad349b$var$layout84 = null;
const $cf835c6cfdad349b$var$layout48 = null;
const $cf835c6cfdad349b$var$layout93 = null;
const $cf835c6cfdad349b$var$layout39 = null;
const $cf835c6cfdad349b$var$layout66 = null;
const $cf835c6cfdad349b$var$layout75 = null;
const $cf835c6cfdad349b$var$layout57 = null;
const $cf835c6cfdad349b$var$layout336 = null;
const $cf835c6cfdad349b$var$layout633 = null;
const $cf835c6cfdad349b$var$layout444 = null;
const $cf835c6cfdad349b$var$layout3333 = null;
const $cf835c6cfdad349b$var$layout222222 = null;
const $cf835c6cfdad349b$var$resetListStyles = null;
const $cf835c6cfdad349b$var$slotWrapper = ({ items: items })=>{
    return items.map((element, index)=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)("li", {
            children: element
        }, index);
    });
}; // Compiled styling requires complex set of choices
const $cf835c6cfdad349b$export$23133ddca0202abb = ({ layout: layout = "12", paddingTopv2: paddingTopv2, paddingBottomv2: paddingBottomv2, verticalAlignment: verticalAlignment = "normal", renderAsList: renderAsList, children: children })=>{
    var _paddingTopv2_mobile, _paddingTopv2_tablet, _ref, // @ts-ignore
    _paddingTopv2_desktop, _ref1, _ref2;
    const paddingTopObject = {
        // @ts-ignore
        mobile: (_paddingTopv2_mobile = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _paddingTopv2_mobile !== void 0 ? _paddingTopv2_mobile : "0",
        // @ts-ignore
        tablet: (_ref = (_paddingTopv2_tablet = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.tablet) !== null && _paddingTopv2_tablet !== void 0 ? _paddingTopv2_tablet : paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _ref !== void 0 ? _ref : "0",
        desktop: (_ref2 = (_ref1 = (_paddingTopv2_desktop = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.desktop) !== null && _paddingTopv2_desktop !== void 0 ? _paddingTopv2_desktop : // @ts-ignore
        paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.tablet) !== null && _ref1 !== void 0 ? _ref1 : // @ts-ignore
        paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _ref2 !== void 0 ? _ref2 : "0"
    };
    var _paddingBottomv2_mobile, _paddingBottomv2_tablet, _ref3, // @ts-ignore
    _paddingBottomv2_desktop, _ref4, _ref5;
    const paddingBottomObject = {
        // @ts-ignore
        mobile: (_paddingBottomv2_mobile = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _paddingBottomv2_mobile !== void 0 ? _paddingBottomv2_mobile : "0",
        // @ts-ignore
        tablet: (_ref3 = (_paddingBottomv2_tablet = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.tablet) !== null && _paddingBottomv2_tablet !== void 0 ? _paddingBottomv2_tablet : paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _ref3 !== void 0 ? _ref3 : "0",
        desktop: (_ref5 = (_ref4 = (_paddingBottomv2_desktop = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.desktop) !== null && _paddingBottomv2_desktop !== void 0 ? _paddingBottomv2_desktop : // @ts-ignore
        paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.tablet) !== null && _ref4 !== void 0 ? _ref4 : // @ts-ignore
        paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _ref5 !== void 0 ? _ref5 : "0"
    };
    const paddingStyles = null;
    const alignmentStyles = null;
    const Container = renderAsList !== null && renderAsList !== void 0 ? renderAsList : "div";
    return /*#__PURE__*/ (0, $loA2J.jsx)(Container, {
        className: (0, $esG4f.default)([
            renderAsList && "_qtt815ep _18zridpf _1e7yidpf _go4ridpf _omn3idpf _s22yidpf _1eg6idpf _1xnlidpf _53osidpf _138kidpf",
            "_1e0c11p5 _vchhusvi _zulp14hz _1bsb1osq _1dsl1tcg _13ltwklj _1vsw1vi7",
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx",
            "_1q51aqwo _85i51jtx _1waf136c _1yd317nz _26vx1ut2 _40tu7014",
            "_4cvr1ekp",
            layout === "10" && "_1j8bcx6w _klsv179g",
            layout === "8" && "_1j8bcx6w _klsveqnf",
            layout === "8-4" && "_19smexmx _1j8b1890",
            layout === "4-8" && "_19smexmx _1j8bi0c8",
            layout === "9-3" && "_1i4gqiai _1j8b1i9f",
            layout === "3-9" && "_1i4gqiai _1j8bvfzv",
            layout === "7-5" && "_13wb12kr _1j8bkxgm",
            layout === "5-7" && "_13wb12kr _1j8bdq95",
            layout === "6-6" && "_1j8bwxkt",
            layout === "4-4-4" && "_1j8b16hb",
            layout === "3-3-3-3" && "_1j8bwxkt _1rqt1ezz",
            layout === "2-2-2-2-2-2" && "_yv0ewxkt _1j8b1g7m",
            layout === "6-3-3" && "_1i4gqiai _1j8b1jr3",
            layout === "3-3-6" && "_1i4gqiai _1j8bmdi6"
        ]),
        style: {
            "--_x9jeny": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.mobile + ")"),
            "--_15jk1js": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.mobile + ")"),
            "--_d48zib": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.tablet + ")"),
            "--_8w0mk6": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.tablet + ")"),
            "--_1l28e2h": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.desktop + ")"),
            "--_14v99j0": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.desktop + ")"),
            "--_1813xhc": (0, $43MIc.default)(verticalAlignment)
        },
        children: children ? children : /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "content",
            wrapperComponent: renderAsList ? $cf835c6cfdad349b$var$slotWrapper : undefined
        })
    });
}; // Compiled styling requires complex set of choices
const $cf835c6cfdad349b$export$8807233e43f557a9 = ({ layout: layout = "12", paddingTopv2: paddingTopv2, paddingBottomv2: paddingBottomv2, verticalAlignment: verticalAlignment = "normal", renderAsList: renderAsList, children: children })=>{
    var _paddingTopv2_mobile, _paddingTopv2_tablet, _ref, // @ts-ignore
    _paddingTopv2_desktop, _ref1, _ref2;
    const paddingTopObject = {
        // @ts-ignore
        mobile: (_paddingTopv2_mobile = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _paddingTopv2_mobile !== void 0 ? _paddingTopv2_mobile : "0",
        // @ts-ignore
        tablet: (_ref = (_paddingTopv2_tablet = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.tablet) !== null && _paddingTopv2_tablet !== void 0 ? _paddingTopv2_tablet : paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _ref !== void 0 ? _ref : "0",
        desktop: (_ref2 = (_ref1 = (_paddingTopv2_desktop = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.desktop) !== null && _paddingTopv2_desktop !== void 0 ? _paddingTopv2_desktop : // @ts-ignore
        paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.tablet) !== null && _ref1 !== void 0 ? _ref1 : // @ts-ignore
        paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _ref2 !== void 0 ? _ref2 : "0"
    };
    var _paddingBottomv2_mobile, _paddingBottomv2_tablet, _ref3, // @ts-ignore
    _paddingBottomv2_desktop, _ref4, _ref5;
    const paddingBottomObject = {
        // @ts-ignore
        mobile: (_paddingBottomv2_mobile = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _paddingBottomv2_mobile !== void 0 ? _paddingBottomv2_mobile : "0",
        // @ts-ignore
        tablet: (_ref3 = (_paddingBottomv2_tablet = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.tablet) !== null && _paddingBottomv2_tablet !== void 0 ? _paddingBottomv2_tablet : paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _ref3 !== void 0 ? _ref3 : "0",
        // @ts-ignore
        desktop: (_ref5 = (_ref4 = (_paddingBottomv2_desktop = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.desktop) !== null && _paddingBottomv2_desktop !== void 0 ? _paddingBottomv2_desktop : // @ts-ignore
        paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.tablet) !== null && _ref4 !== void 0 ? _ref4 : // @ts-ignore
        paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _ref5 !== void 0 ? _ref5 : "0"
    };
    const paddingStyles = null;
    const alignmentStyles = null;
    const Container = renderAsList !== null && renderAsList !== void 0 ? renderAsList : "div";
    return /*#__PURE__*/ (0, $loA2J.jsx)(Container, {
        className: (0, $esG4f.default)([
            "_1e0c11p5 _vchhusvi _zulp14hz _1bsb1osq _1dsl1tcg _13ltwklj _1vsw1vi7",
            "_1q51aqwo _85i51jtx _1waf136c _1yd317nz _26vx1ut2 _40tu7014",
            "_4cvr1ekp",
            renderAsList && "_qtt815ep _18zridpf _1e7yidpf _go4ridpf _omn3idpf _s22yidpf _1eg6idpf _1xnlidpf _53osidpf _138kidpf",
            layout === "10" && "_1j8bcx6w _klsv179g",
            layout === "8" && "_1j8bcx6w _klsveqnf",
            layout === "8-4" && "_19smexmx _1j8b1890",
            layout === "4-8" && "_19smexmx _1j8bi0c8",
            layout === "9-3" && "_1i4gqiai _1j8b1i9f",
            layout === "3-9" && "_1i4gqiai _1j8bvfzv",
            layout === "7-5" && "_13wb12kr _1j8bkxgm",
            layout === "5-7" && "_13wb12kr _1j8bdq95",
            layout === "6-6" && "_1j8bwxkt",
            layout === "4-4-4" && "_1j8b16hb",
            layout === "3-3-3-3" && "_1j8bwxkt _1rqt1ezz",
            layout === "2-2-2-2-2-2" && "_yv0ewxkt _1j8b1g7m",
            layout === "6-3-3" && "_1i4gqiai _1j8b1jr3",
            layout === "3-3-6" && "_1i4gqiai _1j8bmdi6"
        ]),
        style: {
            "--_x9jeny": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.mobile + ")"),
            "--_15jk1js": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.mobile + ")"),
            "--_d48zib": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.tablet + ")"),
            "--_8w0mk6": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.tablet + ")"),
            "--_1l28e2h": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.desktop + ")"),
            "--_14v99j0": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.desktop + ")"),
            "--_1813xhc": (0, $43MIc.default)(verticalAlignment)
        },
        children: children ? children : /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "content",
            wrapperComponent: renderAsList ? $cf835c6cfdad349b$var$slotWrapper : undefined
        })
    });
}; // Both components are exported as named exports above

});


parcelRegister("hQud5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("jgBDg")).default; });

var $jgBDg = parcelRequire("jgBDg");

});
parcelRegister("jgBDg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af65450661bcb715$export$2e2bcd8739ae039; });
/* container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");

var $8lB1y = parcelRequire("8lB1y");

var $gAJUc = parcelRequire("gAJUc");
parcelRequire("ccYBS");
var $e6FyV = parcelRequire("e6FyV");
const $af65450661bcb715$var$UniformContainer = ({ spacing: spacing, horizontalAlignment: horizontalAlignment = "default", verticalAlignment: verticalAlignment = "default", orientation: orientation = {
    mobile: "vertical"
}, gapv2: gapv2 = {
    mobile: "0"
}, hat: hat, pants: pants, backgroundColor: backgroundColor, extendBackgroundColor: extendBackgroundColor, sticky: sticky = false, responsiveHiding: responsiveHiding, overflow: overflow = "visible", label: label })=>{
    var _composition_data, _spacing_mobile, _spacing_mobile1, _spacing_mobile2, _spacing_mobile3, _spacing_mobile4, _spacing_mobile5, _spacing_mobile6, _spacing_mobile7, _spacing_tablet, _spacing_mobile8, _spacing_tablet1, _spacing_mobile9, _spacing_tablet2, _spacing_mobile10, _spacing_tablet3, _spacing_mobile11, _spacing_tablet4, _spacing_mobile12, _spacing_tablet5, _spacing_mobile13, _spacing_tablet6, _spacing_mobile14, _spacing_tablet7, _spacing_mobile15, _spacing_desktop, _spacing_tablet8, _spacing_mobile16, _spacing_desktop1, _spacing_tablet9, _spacing_mobile17, _spacing_desktop2, _spacing_tablet10, _spacing_mobile18, _spacing_desktop3, _spacing_tablet11, _spacing_mobile19, _spacing_desktop4, _spacing_tablet12, _spacing_mobile20, _spacing_desktop5, _spacing_tablet13, _spacing_mobile21, _spacing_desktop6, _spacing_tablet14, _spacing_mobile22, _spacing_desktop7, _spacing_tablet15, _spacing_mobile23;
    const composition = (0, $aiugz.useUniformCurrentComposition)();
    const compositionId = composition === null || composition === void 0 ? void 0 : (_composition_data = composition.data) === null || _composition_data === void 0 ? void 0 : _composition_data._id;
    const tracker = (0, $e6FyV.useScrollTracking)(label !== null && label !== void 0 ? label : "", {
        dwellTimeEnabled: true,
        additionalAttributes: {
            compositionId: compositionId
        }
    });
    var _spacing_mobile_marginTop, _spacing_mobile_marginBottom, _spacing_mobile_marginLeft, _spacing_mobile_marginRight, _spacing_mobile_paddingTop, _spacing_mobile_paddingBottom, _spacing_mobile_paddingLeft, _spacing_mobile_paddingRight, _spacing_tablet_marginTop, _ref, _spacing_tablet_marginBottom, _ref1, _spacing_tablet_marginLeft, _ref2, _spacing_tablet_marginRight, _ref3, _spacing_tablet_paddingTop, _ref4, _spacing_tablet_paddingBottom, _ref5, _spacing_tablet_paddingLeft, _ref6, _spacing_tablet_paddingRight, _ref7, _spacing_desktop_marginTop, _ref8, _ref9, _spacing_desktop_marginBottom, _ref10, _ref11, _spacing_desktop_marginLeft, _ref12, _ref13, _spacing_desktop_marginRight, _ref14, _ref15, _spacing_desktop_paddingTop, _ref16, _ref17, _spacing_desktop_paddingBottom, _ref18, _ref19, _spacing_desktop_paddingLeft, _ref20, _ref21, _spacing_desktop_paddingRight, _ref22, _ref23;
    const spacingObject = {
        mobile: {
            marginTop: (_spacing_mobile_marginTop = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile = spacing.mobile) === null || _spacing_mobile === void 0 ? void 0 : _spacing_mobile.marginTop) !== null && _spacing_mobile_marginTop !== void 0 ? _spacing_mobile_marginTop : "0",
            marginBottom: (_spacing_mobile_marginBottom = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile1 = spacing.mobile) === null || _spacing_mobile1 === void 0 ? void 0 : _spacing_mobile1.marginBottom) !== null && _spacing_mobile_marginBottom !== void 0 ? _spacing_mobile_marginBottom : "0",
            marginLeft: (_spacing_mobile_marginLeft = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile2 = spacing.mobile) === null || _spacing_mobile2 === void 0 ? void 0 : _spacing_mobile2.marginLeft) !== null && _spacing_mobile_marginLeft !== void 0 ? _spacing_mobile_marginLeft : "0",
            marginRight: (_spacing_mobile_marginRight = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile3 = spacing.mobile) === null || _spacing_mobile3 === void 0 ? void 0 : _spacing_mobile3.marginRight) !== null && _spacing_mobile_marginRight !== void 0 ? _spacing_mobile_marginRight : "0",
            paddingTop: (_spacing_mobile_paddingTop = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile4 = spacing.mobile) === null || _spacing_mobile4 === void 0 ? void 0 : _spacing_mobile4.paddingTop) !== null && _spacing_mobile_paddingTop !== void 0 ? _spacing_mobile_paddingTop : "0",
            paddingBottom: (_spacing_mobile_paddingBottom = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile5 = spacing.mobile) === null || _spacing_mobile5 === void 0 ? void 0 : _spacing_mobile5.paddingBottom) !== null && _spacing_mobile_paddingBottom !== void 0 ? _spacing_mobile_paddingBottom : "0",
            paddingLeft: (_spacing_mobile_paddingLeft = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile6 = spacing.mobile) === null || _spacing_mobile6 === void 0 ? void 0 : _spacing_mobile6.paddingLeft) !== null && _spacing_mobile_paddingLeft !== void 0 ? _spacing_mobile_paddingLeft : "0",
            paddingRight: (_spacing_mobile_paddingRight = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile7 = spacing.mobile) === null || _spacing_mobile7 === void 0 ? void 0 : _spacing_mobile7.paddingRight) !== null && _spacing_mobile_paddingRight !== void 0 ? _spacing_mobile_paddingRight : "0"
        },
        tablet: {
            marginTop: (_ref = (_spacing_tablet_marginTop = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet = spacing.tablet) === null || _spacing_tablet === void 0 ? void 0 : _spacing_tablet.marginTop) !== null && _spacing_tablet_marginTop !== void 0 ? _spacing_tablet_marginTop : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile8 = spacing.mobile) === null || _spacing_mobile8 === void 0 ? void 0 : _spacing_mobile8.marginTop) !== null && _ref !== void 0 ? _ref : "0",
            marginBottom: (_ref1 = (_spacing_tablet_marginBottom = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet1 = spacing.tablet) === null || _spacing_tablet1 === void 0 ? void 0 : _spacing_tablet1.marginBottom) !== null && _spacing_tablet_marginBottom !== void 0 ? _spacing_tablet_marginBottom : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile9 = spacing.mobile) === null || _spacing_mobile9 === void 0 ? void 0 : _spacing_mobile9.marginBottom) !== null && _ref1 !== void 0 ? _ref1 : "0",
            marginLeft: (_ref2 = (_spacing_tablet_marginLeft = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet2 = spacing.tablet) === null || _spacing_tablet2 === void 0 ? void 0 : _spacing_tablet2.marginLeft) !== null && _spacing_tablet_marginLeft !== void 0 ? _spacing_tablet_marginLeft : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile10 = spacing.mobile) === null || _spacing_mobile10 === void 0 ? void 0 : _spacing_mobile10.marginLeft) !== null && _ref2 !== void 0 ? _ref2 : "0",
            marginRight: (_ref3 = (_spacing_tablet_marginRight = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet3 = spacing.tablet) === null || _spacing_tablet3 === void 0 ? void 0 : _spacing_tablet3.marginRight) !== null && _spacing_tablet_marginRight !== void 0 ? _spacing_tablet_marginRight : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile11 = spacing.mobile) === null || _spacing_mobile11 === void 0 ? void 0 : _spacing_mobile11.marginRight) !== null && _ref3 !== void 0 ? _ref3 : "0",
            paddingTop: (_ref4 = (_spacing_tablet_paddingTop = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet4 = spacing.tablet) === null || _spacing_tablet4 === void 0 ? void 0 : _spacing_tablet4.paddingTop) !== null && _spacing_tablet_paddingTop !== void 0 ? _spacing_tablet_paddingTop : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile12 = spacing.mobile) === null || _spacing_mobile12 === void 0 ? void 0 : _spacing_mobile12.paddingTop) !== null && _ref4 !== void 0 ? _ref4 : "0",
            paddingBottom: (_ref5 = (_spacing_tablet_paddingBottom = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet5 = spacing.tablet) === null || _spacing_tablet5 === void 0 ? void 0 : _spacing_tablet5.paddingBottom) !== null && _spacing_tablet_paddingBottom !== void 0 ? _spacing_tablet_paddingBottom : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile13 = spacing.mobile) === null || _spacing_mobile13 === void 0 ? void 0 : _spacing_mobile13.paddingBottom) !== null && _ref5 !== void 0 ? _ref5 : "0",
            paddingLeft: (_ref6 = (_spacing_tablet_paddingLeft = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet6 = spacing.tablet) === null || _spacing_tablet6 === void 0 ? void 0 : _spacing_tablet6.paddingLeft) !== null && _spacing_tablet_paddingLeft !== void 0 ? _spacing_tablet_paddingLeft : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile14 = spacing.mobile) === null || _spacing_mobile14 === void 0 ? void 0 : _spacing_mobile14.paddingLeft) !== null && _ref6 !== void 0 ? _ref6 : "0",
            paddingRight: (_ref7 = (_spacing_tablet_paddingRight = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet7 = spacing.tablet) === null || _spacing_tablet7 === void 0 ? void 0 : _spacing_tablet7.paddingRight) !== null && _spacing_tablet_paddingRight !== void 0 ? _spacing_tablet_paddingRight : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile15 = spacing.mobile) === null || _spacing_mobile15 === void 0 ? void 0 : _spacing_mobile15.paddingRight) !== null && _ref7 !== void 0 ? _ref7 : "0"
        },
        desktop: {
            marginTop: (_ref9 = (_ref8 = (_spacing_desktop_marginTop = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop = spacing.desktop) === null || _spacing_desktop === void 0 ? void 0 : _spacing_desktop.marginTop) !== null && _spacing_desktop_marginTop !== void 0 ? _spacing_desktop_marginTop : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet8 = spacing.tablet) === null || _spacing_tablet8 === void 0 ? void 0 : _spacing_tablet8.marginTop) !== null && _ref8 !== void 0 ? _ref8 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile16 = spacing.mobile) === null || _spacing_mobile16 === void 0 ? void 0 : _spacing_mobile16.marginTop) !== null && _ref9 !== void 0 ? _ref9 : "0",
            marginBottom: (_ref11 = (_ref10 = (_spacing_desktop_marginBottom = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop1 = spacing.desktop) === null || _spacing_desktop1 === void 0 ? void 0 : _spacing_desktop1.marginBottom) !== null && _spacing_desktop_marginBottom !== void 0 ? _spacing_desktop_marginBottom : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet9 = spacing.tablet) === null || _spacing_tablet9 === void 0 ? void 0 : _spacing_tablet9.marginBottom) !== null && _ref10 !== void 0 ? _ref10 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile17 = spacing.mobile) === null || _spacing_mobile17 === void 0 ? void 0 : _spacing_mobile17.marginBottom) !== null && _ref11 !== void 0 ? _ref11 : "0",
            marginLeft: (_ref13 = (_ref12 = (_spacing_desktop_marginLeft = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop2 = spacing.desktop) === null || _spacing_desktop2 === void 0 ? void 0 : _spacing_desktop2.marginLeft) !== null && _spacing_desktop_marginLeft !== void 0 ? _spacing_desktop_marginLeft : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet10 = spacing.tablet) === null || _spacing_tablet10 === void 0 ? void 0 : _spacing_tablet10.marginLeft) !== null && _ref12 !== void 0 ? _ref12 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile18 = spacing.mobile) === null || _spacing_mobile18 === void 0 ? void 0 : _spacing_mobile18.marginLeft) !== null && _ref13 !== void 0 ? _ref13 : "0",
            marginRight: (_ref15 = (_ref14 = (_spacing_desktop_marginRight = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop3 = spacing.desktop) === null || _spacing_desktop3 === void 0 ? void 0 : _spacing_desktop3.marginRight) !== null && _spacing_desktop_marginRight !== void 0 ? _spacing_desktop_marginRight : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet11 = spacing.tablet) === null || _spacing_tablet11 === void 0 ? void 0 : _spacing_tablet11.marginRight) !== null && _ref14 !== void 0 ? _ref14 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile19 = spacing.mobile) === null || _spacing_mobile19 === void 0 ? void 0 : _spacing_mobile19.marginRight) !== null && _ref15 !== void 0 ? _ref15 : "0",
            paddingTop: (_ref17 = (_ref16 = (_spacing_desktop_paddingTop = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop4 = spacing.desktop) === null || _spacing_desktop4 === void 0 ? void 0 : _spacing_desktop4.paddingTop) !== null && _spacing_desktop_paddingTop !== void 0 ? _spacing_desktop_paddingTop : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet12 = spacing.tablet) === null || _spacing_tablet12 === void 0 ? void 0 : _spacing_tablet12.paddingTop) !== null && _ref16 !== void 0 ? _ref16 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile20 = spacing.mobile) === null || _spacing_mobile20 === void 0 ? void 0 : _spacing_mobile20.paddingTop) !== null && _ref17 !== void 0 ? _ref17 : "0",
            paddingBottom: (_ref19 = (_ref18 = (_spacing_desktop_paddingBottom = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop5 = spacing.desktop) === null || _spacing_desktop5 === void 0 ? void 0 : _spacing_desktop5.paddingBottom) !== null && _spacing_desktop_paddingBottom !== void 0 ? _spacing_desktop_paddingBottom : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet13 = spacing.tablet) === null || _spacing_tablet13 === void 0 ? void 0 : _spacing_tablet13.paddingBottom) !== null && _ref18 !== void 0 ? _ref18 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile21 = spacing.mobile) === null || _spacing_mobile21 === void 0 ? void 0 : _spacing_mobile21.paddingBottom) !== null && _ref19 !== void 0 ? _ref19 : "0",
            paddingLeft: (_ref21 = (_ref20 = (_spacing_desktop_paddingLeft = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop6 = spacing.desktop) === null || _spacing_desktop6 === void 0 ? void 0 : _spacing_desktop6.paddingLeft) !== null && _spacing_desktop_paddingLeft !== void 0 ? _spacing_desktop_paddingLeft : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet14 = spacing.tablet) === null || _spacing_tablet14 === void 0 ? void 0 : _spacing_tablet14.paddingLeft) !== null && _ref20 !== void 0 ? _ref20 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile22 = spacing.mobile) === null || _spacing_mobile22 === void 0 ? void 0 : _spacing_mobile22.paddingLeft) !== null && _ref21 !== void 0 ? _ref21 : "0",
            paddingRight: (_ref23 = (_ref22 = (_spacing_desktop_paddingRight = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop7 = spacing.desktop) === null || _spacing_desktop7 === void 0 ? void 0 : _spacing_desktop7.paddingRight) !== null && _spacing_desktop_paddingRight !== void 0 ? _spacing_desktop_paddingRight : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet15 = spacing.tablet) === null || _spacing_tablet15 === void 0 ? void 0 : _spacing_tablet15.paddingRight) !== null && _ref22 !== void 0 ? _ref22 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile23 = spacing.mobile) === null || _spacing_mobile23 === void 0 ? void 0 : _spacing_mobile23.paddingRight) !== null && _ref23 !== void 0 ? _ref23 : "0"
        }
    };
    const marginStyles = null;
    const paddingStyles = null;
    (0, $iSvIT.useEffect)(()=>{
        (0, $8lB1y.updateStickyNavOffset)();
    }, []);
    const hiddenMobileStyle = null;
    const hiddenTabletStyle = null;
    const hiddenDesktopStyle = null;
    const colorStyle = null;
    var _gapv2_mobile, _gapv2_tablet, _ref24, _gapv2_desktop, _ref25, _ref26;
    const gapObject = {
        mobile: (_gapv2_mobile = gapv2.mobile) !== null && _gapv2_mobile !== void 0 ? _gapv2_mobile : "0",
        tablet: (_ref24 = (_gapv2_tablet = gapv2 === null || gapv2 === void 0 ? void 0 : gapv2.tablet) !== null && _gapv2_tablet !== void 0 ? _gapv2_tablet : gapv2.mobile) !== null && _ref24 !== void 0 ? _ref24 : "0",
        desktop: (_ref26 = (_ref25 = (_gapv2_desktop = gapv2 === null || gapv2 === void 0 ? void 0 : gapv2.desktop) !== null && _gapv2_desktop !== void 0 ? _gapv2_desktop : gapv2 === null || gapv2 === void 0 ? void 0 : gapv2.tablet) !== null && _ref25 !== void 0 ? _ref25 : gapv2.mobile) !== null && _ref26 !== void 0 ? _ref26 : "0"
    };
    const innerStyle = null;
    const orientationObject = {
        mobile: orientation.mobile || "vertical",
        tablet: orientation.tablet || orientation.mobile || "vertical",
        desktop: orientation.desktop || orientation.tablet || orientation.mobile || "vertical"
    };
    const orientationStyle = null;
    const verticalAlignmentValue = verticalAlignment === "center" ? "center" : "flex-start";
    const horizontalAlignmentValue = horizontalAlignment === "center" ? "center" : horizontalAlignment === "start" ? "flex-start" : "initial";
    const hiddenOnMobile = responsiveHiding === null || responsiveHiding === void 0 ? void 0 : responsiveHiding.includes("mobile");
    const hiddenOnTablet = responsiveHiding === null || responsiveHiding === void 0 ? void 0 : responsiveHiding.includes("tablet");
    const hiddenOnDesktop = responsiveHiding === null || responsiveHiding === void 0 ? void 0 : responsiveHiding.includes("desktop");
    const overflowStyle = null;
    const responsiveSectionDividerHeightsStyles = null;
    const extendedBackgroundColorComponent = /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqswstnw _1bsbauwl _4t3i1cn3 _14b5zqdx _b8yq87gh _1e021ssb _t9eczr6s _11q7wvjo",
            hat && "_1kt9b3bt _cfu11ule _kfgt1m3o _1s6kwvjo",
            hat && "_1cs8h2mm _iajm18y9",
            hat && hat === "high-right" ? "_tgsmkyn1" : hat === "high-left" ? "_tgsmvrmp" : "_tgsmcdv4",
            pants && "_aetrb3bt _1ywu1ule _1qdg1aiy _16r2wvjo",
            pants && "_18poh2mm _19nq1osq",
            pants && hat && "_18poh2mm _19nq1e6p",
            pants && pants === "high-right" ? "_1oj4snn3" : pants === "high-left" ? "_1oj4df5m" : "_1oj41mhh"
        ])
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        ref: (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7603UniformPageDwellTime) && label ? tracker === null || tracker === void 0 ? void 0 : tracker.ref : null,
        className: (0, $esG4f.default)([
            "_vhvk1xho _wsfyeyca _11nbax5h _tqhlzoxj _9s88d2ta _1rcb14zp",
            "_1pfhanyo _6rthpu7k _ahbq5tu6 _12l21ubn _kiya1jt3 _1ob9vj1y _1ywm6esm _1lva1cm9 _1mt1153n _1tntw79i _3l1a4z27 _161b1c8k",
            "_14lsaxbu",
            hat && !extendBackgroundColor && "_1kt9b3bt _cfu11ule _kfgt1m3o _1s6kwvjo",
            hat && !extendBackgroundColor && hat === "high-right" ? "_tgsmkyn1" : hat === "high-left" ? "_tgsmvrmp" : "_tgsmcdv4",
            pants && !extendBackgroundColor && "_aetrb3bt _1ywu1ule _1qdg1aiy _16r2wvjo",
            pants && !extendBackgroundColor && pants === "high-right" ? "_1oj4snn3" : pants === "high-left" ? "_1oj4df5m" : "_1oj41mhh",
            hiddenOnMobile && "_sugaglyw",
            hiddenOnTablet && "_kzviglyw",
            hiddenOnDesktop && "_dm25glyw",
            "_1idncgrn",
            extendBackgroundColor && "_kqswh2mm",
            extendBackgroundColor && hat && "_1q511m3o",
            extendBackgroundColor && pants && "_85i51aiy"
        ]),
        style: {
            "--_9ux5rl": (0, $43MIc.default)(hat ? `${(0, $8lB1y.SECTION_DIVIDER_HEIGHTS).mobile}px` : "0px"),
            "--_eu2x2b": (0, $43MIc.default)(pants ? `${(0, $8lB1y.SECTION_DIVIDER_HEIGHTS).mobile}px` : "0px"),
            "--_up8d13": (0, $43MIc.default)(hat ? `${(0, $8lB1y.SECTION_DIVIDER_HEIGHTS).tablet}px` : "0px"),
            "--_alf06v": (0, $43MIc.default)(pants ? `${(0, $8lB1y.SECTION_DIVIDER_HEIGHTS).tablet}px` : "0px"),
            "--_138i2bk": (0, $43MIc.default)(hat ? `${(0, $8lB1y.SECTION_DIVIDER_HEIGHTS).desktop}px` : "0px"),
            "--_1r8eu8k": (0, $43MIc.default)(pants ? `${(0, $8lB1y.SECTION_DIVIDER_HEIGHTS).desktop}px` : "0px"),
            "--_gbj3vn": (0, $43MIc.default)("var(--ds-space-" + spacingObject.mobile.marginTop + ")"),
            "--_1ml8i62": (0, $43MIc.default)("var(--ds-space-" + spacingObject.mobile.marginBottom + ")"),
            "--_eitxkt": (0, $43MIc.default)("var(--ds-space-" + spacingObject.mobile.marginLeft + ")"),
            "--_17oyghn": (0, $43MIc.default)("var(--ds-space-" + spacingObject.mobile.marginRight + ")"),
            "--_13w6wc6": (0, $43MIc.default)("var(--ds-space-" + spacingObject.tablet.marginTop + ")"),
            "--_1g7gc60": (0, $43MIc.default)("var(--ds-space-" + spacingObject.tablet.marginBottom + ")"),
            "--_1w7fn9j": (0, $43MIc.default)("var(--ds-space-" + spacingObject.tablet.marginLeft + ")"),
            "--_y26vmc": (0, $43MIc.default)("var(--ds-space-" + spacingObject.tablet.marginRight + ")"),
            "--_12q7gcg": (0, $43MIc.default)("var(--ds-space-" + spacingObject.desktop.marginTop + ")"),
            "--_1unjz24": (0, $43MIc.default)("var(--ds-space-" + spacingObject.desktop.marginBottom + ")"),
            "--_6sej3x": (0, $43MIc.default)("var(--ds-space-" + spacingObject.desktop.marginLeft + ")"),
            "--_4gatm0": (0, $43MIc.default)("var(--ds-space-" + spacingObject.desktop.marginRight + ")"),
            "--_1ly4823": (0, $43MIc.default)(backgroundColor),
            "--_lyok2l": (0, $43MIc.default)(overflow)
        },
        children: [
            extendBackgroundColor && extendedBackgroundColorComponent,
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_11q7wvjo _1bsb1osq _4t3i1wug _1e0c1txw _zulp1a6y _19wggsi3 _pdlmxbqd",
                    extendBackgroundColor && "_bfhk1j28 _kqswh2mm _1pbykb7n",
                    "_1q5117qr _85i51lcc _bozg1k1r _y4ti1one _1wafbrnf _1yd32emj _1wfq1myb _15vt1nm0 _26vx19ue _40tu16pv _d2ik8srg _exxmep75",
                    "_1e0c1txw _2lx22h65 _1lp71tnc _1inip4d6",
                    orientationObject.mobile === "horizontal" && "_4cvrop21 _1bah8u0b",
                    orientationObject.tablet === "horizontal" && "_q8t5op21 _e8gh8u0b",
                    orientationObject.desktop === "horizontal" && "_1jsvop21 _msup8u0b",
                    orientationObject.mobile === "vertical" && "_4cvr8u0b _1bahop21",
                    orientationObject.tablet === "vertical" && "_q8t58u0b _e8ghop21",
                    orientationObject.desktop === "vertical" && "_1jsv8u0b _msupop21",
                    sticky && "_kqsw1if8 _152txohi"
                ]),
                style: {
                    "--_rkv8x9": (0, $43MIc.default)("var(--ds-space-" + gapObject.mobile + ")"),
                    "--_9wptik": (0, $43MIc.default)("var(--ds-space-" + gapObject.tablet + ")"),
                    "--_3wdyhk": (0, $43MIc.default)("var(--ds-space-" + gapObject.desktop + ")"),
                    "--_16fd4zu": (0, $43MIc.default)("var(--ds-space-" + spacingObject.mobile.paddingTop + ")"),
                    "--_1j5swcl": (0, $43MIc.default)("var(--ds-space-" + spacingObject.mobile.paddingBottom + ")"),
                    "--_u69j6n": (0, $43MIc.default)("var(--ds-space-" + spacingObject.mobile.paddingLeft + ")"),
                    "--_o2jkov": (0, $43MIc.default)("var(--ds-space-" + spacingObject.mobile.paddingRight + ")"),
                    "--_703coj": (0, $43MIc.default)("var(--ds-space-" + spacingObject.tablet.paddingTop + ")"),
                    "--_1fsgwhq": (0, $43MIc.default)("var(--ds-space-" + spacingObject.tablet.paddingBottom + ")"),
                    "--_13hg674": (0, $43MIc.default)("var(--ds-space-" + spacingObject.tablet.paddingLeft + ")"),
                    "--_1qs0f4o": (0, $43MIc.default)("var(--ds-space-" + spacingObject.tablet.paddingRight + ")"),
                    "--_pqmqgy": (0, $43MIc.default)("var(--ds-space-" + spacingObject.desktop.paddingTop + ")"),
                    "--_1ybsets": (0, $43MIc.default)("var(--ds-space-" + spacingObject.desktop.paddingBottom + ")"),
                    "--_okopco": (0, $43MIc.default)("var(--ds-space-" + spacingObject.desktop.paddingLeft + ")"),
                    "--_x42pdd": (0, $43MIc.default)("var(--ds-space-" + spacingObject.desktop.paddingRight + ")"),
                    "--_pv2ypa": (0, $43MIc.default)(orientationObject.mobile === "horizontal" ? "row" : "column"),
                    "--_dek1s0": (0, $43MIc.default)(orientationObject.tablet === "horizontal" ? "row" : "column"),
                    "--_1ng513r": (0, $43MIc.default)(orientationObject.desktop === "horizontal" ? "row" : "column"),
                    "--_7phn4c": (0, $43MIc.default)(verticalAlignmentValue),
                    "--_7e5uq9": (0, $43MIc.default)(horizontalAlignmentValue)
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                    name: "component"
                })
            })
        ]
    });
};
const $af65450661bcb715$var$hatCommonStyle = null;
const $af65450661bcb715$var$extendedBackgroundColorHatStyle = null;
const $af65450661bcb715$var$hatHighLeft = null;
const $af65450661bcb715$var$hatHighRight = null;
const $af65450661bcb715$var$hatPolygon = null;
const $af65450661bcb715$var$pantsCommonStyle = null;
const $af65450661bcb715$var$extendedBackgroundColorPantsStyle = null;
const $af65450661bcb715$var$extendedBackgroundColorPantsWithHatStyle = null;
const $af65450661bcb715$var$pantsHighLeft = null;
const $af65450661bcb715$var$pantsHighRight = null;
const $af65450661bcb715$var$pantsPolygon = null;
var $af65450661bcb715$export$2e2bcd8739ae039 = $af65450661bcb715$var$UniformContainer;

});


parcelRegister("bvk3D", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("j5qkq")).default; });

var $j5qkq = parcelRequire("j5qkq");

});
parcelRegister("j5qkq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5b2b3e6806e7c2d$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $40KoW = parcelRequire("40KoW");

var $1UUq1 = parcelRequire("1UUq1");

var $8lB1y = parcelRequire("8lB1y");

var $3FBn4 = parcelRequire("3FBn4");
const $d5b2b3e6806e7c2d$var$UniformContentBlock = (props)=>{
    var _props_linkHref, _props_buttonHref;
    var _props_linkHref_path;
    const localizedLinkHref = (0, $3FBn4.useLocalizedHref)((_props_linkHref_path = (_props_linkHref = props.linkHref) === null || _props_linkHref === void 0 ? void 0 : _props_linkHref.path) !== null && _props_linkHref_path !== void 0 ? _props_linkHref_path : "");
    var _props_buttonHref_path;
    const localizedButtonHref = (0, $3FBn4.useLocalizedHref)((_props_buttonHref_path = (_props_buttonHref = props.buttonHref) === null || _props_buttonHref === void 0 ? void 0 : _props_buttonHref.path) !== null && _props_buttonHref_path !== void 0 ? _props_buttonHref_path : "");
    const callToActionProps = $d5b2b3e6806e7c2d$var$transformCtaProps((0, $6iHNw._)((0, $7Knp0._)({}, props), {
        linkHref: props.linkHref ? {
            path: localizedLinkHref
        } : undefined,
        buttonHref: props.buttonHref ? {
            path: localizedButtonHref
        } : undefined
    }));
    var _props_imageAlt, _props_iconAlt;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.ContentBlock), {
        title: props.title,
        text: props.richText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            text: props.richText
        }) : !(0, $40KoW.isRichTextValueConsideredEmpty)(props.uniformRichText) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            uniformParameter: "uniformRichText"
        }) : props.text,
        titleAs: props.titleAs,
        logo: props.logo,
        eyebrow: props.eyebrow,
        alignment: props.alignment,
        callToActionProps: callToActionProps,
        pictureProps: props.imageUrl ? {
            image: {
                src: props.imageUrl,
                alt: (_props_imageAlt = props.imageAlt) !== null && _props_imageAlt !== void 0 ? _props_imageAlt : ""
            }
        } : undefined,
        spotIllustrationUrl: props.spotIllustrationUrl,
        icon: props.iconUrl ? {
            linkedIcon: {
                url: props.iconUrl,
                size: props.iconSize,
                alt: (_props_iconAlt = props.iconAlt) !== null && _props_iconAlt !== void 0 ? _props_iconAlt : ""
            }
        } : undefined,
        orientation: props.orientation,
        columns: props.columns,
        backgroundColor: props.backgroundColor,
        hat: props.hat,
        pants: props.pants
    });
};
function $d5b2b3e6806e7c2d$var$transformCtaProps({ buttonHref: buttonHref, buttonLabel: buttonLabel, buttonVariant: buttonVariant, linkHref: linkHref, linkText: linkText, linkType: linkType }) {
    const isButton = !!(buttonHref === null || buttonHref === void 0 ? void 0 : buttonHref.path) && !!buttonLabel;
    const isLink = !!(linkHref === null || linkHref === void 0 ? void 0 : linkHref.path) && !!linkText;
    if (isButton || isLink) {
        const ctaProps = {
            button: isButton ? {
                href: buttonHref.path
            } : undefined,
            buttonText: buttonLabel !== null && buttonLabel !== void 0 ? buttonLabel : undefined,
            buttonVariant: buttonVariant !== null && buttonVariant !== void 0 ? buttonVariant : undefined,
            link: isLink ? {
                href: linkHref.path,
                text: linkText,
                type: linkType
            } : undefined
        };
        return ctaProps;
    }
    return undefined;
}
var $d5b2b3e6806e7c2d$export$2e2bcd8739ae039 = $d5b2b3e6806e7c2d$var$UniformContentBlock;

});


parcelRegister("dX6Xs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("jgCjv")).default; });

var $jgCjv = parcelRequire("jgCjv");

});
parcelRegister("jgCjv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26db6e668dcd1535$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $2bAHw = parcelRequire("2bAHw");

var $iThfY = parcelRequire("iThfY");
const $26db6e668dcd1535$export$760d8d36b06866af = (props)=>{
    const statProps = (0, $7Knp0._)({}, props);
    statProps.stats = (0, $2bAHw.flattenValues)(props.stats);
    return statProps;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $26db6e668dcd1535$var$UniformCustomerStat = (props)=>{
    const statProps = $26db6e668dcd1535$export$760d8d36b06866af(props);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iThfY.CustomerDetailsStats), (0, $7Knp0._)({}, statProps));
};
var $26db6e668dcd1535$export$2e2bcd8739ae039 = $26db6e668dcd1535$var$UniformCustomerStat;

});


parcelRegister("JGvCj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("6Y74j")).default; });

var $6Y74j = parcelRequire("6Y74j");

});
parcelRegister("6Y74j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de57eb9f51f78d6e$export$2e2bcd8739ae039; });
/* customer-stories-details-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $aiugz = parcelRequire("aiugz");

var $gAJUc = parcelRequire("gAJUc");
parcelRequire("ccYBS");
var $e6FyV = parcelRequire("e6FyV");
parcelRequire("e992t");
var $8fNuT = parcelRequire("8fNuT");

var $7opTn = parcelRequire("7opTn");
const $de57eb9f51f78d6e$var$heroContainerCss = null;
const $de57eb9f51f78d6e$export$74f30557f8a70c45 = ({ title: title, subtitle: subtitle, imgSrc: imgSrc, imgAlt: imgAlt, quote: quote, author: author, role: role, company: company })=>{
    var _composition_data;
    const composition = (0, $aiugz.useUniformCurrentComposition)();
    const compositionId = composition === null || composition === void 0 ? void 0 : (_composition_data = composition.data) === null || _composition_data === void 0 ? void 0 : _composition_data._id;
    const tracker = (0, $e6FyV.useScrollTracking)("UniformCustomerStoriesDetailsHero", {
        dwellTimeEnabled: true,
        additionalAttributes: {
            compositionId: compositionId
        }
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        ref: (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7603UniformPageDwellTime) ? tracker === null || tracker === void 0 ? void 0 : tracker.ref : null,
        className: (0, $esG4f.default)([
            "_1e0c11p5 _1bah1yb4 _1pfhxy5q _p12f1osq _vchhusvi _zulp1tcg _1bsb1osq _yv0ei47z _pdlmzwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8fNuT.default), {
                title: title,
                subtitle: subtitle,
                alignment: imgSrc ? "left" : "center"
            }),
            quote && /*#__PURE__*/ (0, $loA2J.jsx)((0, $7opTn.default), {
                imgSrc: imgSrc,
                imgAlt: imgAlt,
                quote: quote,
                author: author,
                role: role,
                company: company
            })
        ]
    });
};
var $de57eb9f51f78d6e$export$2e2bcd8739ae039 = $de57eb9f51f78d6e$export$74f30557f8a70c45;

});
parcelRegister("e992t", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("8fNuT")).default; });

var $8fNuT = parcelRequire("8fNuT");

});
parcelRegister("8fNuT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2094b45cba049d08$export$2e2bcd8739ae039; });
/* hero-intro.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
const $2094b45cba049d08$var$UniformHeroIntro = ({ title: title, subtitle: subtitle, alignment: alignment })=>{
    const heroContainer = null;
    const textCss = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_y3gnoues _yv0ecx6w _1e0c11p5 _gy1p1tcg _1rqtaigu _ikjdzwfg"
        ]),
        style: {
            "--_1v0xqnb": (0, $43MIc.default)(alignment)
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_6rthidpf _yyhy13k5 _1e3c9kbg"
                ]),
                style: {
                    "--_1gb0l6x": (0, $43MIc.default)(alignment == "center" ? "2" : "1")
                },
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_6rthidpf _yyhy13k5 _1e3c9kbg",
                    "body-lg"
                ]),
                style: {
                    "--_1gb0l6x": (0, $43MIc.default)(alignment == "center" ? "2" : "1")
                },
                children: subtitle
            })
        ]
    });
};
var $2094b45cba049d08$export$2e2bcd8739ae039 = $2094b45cba049d08$var$UniformHeroIntro;

});


parcelRegister("7opTn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f04546e5dcf926f8$export$2e2bcd8739ae039; });
/* customer-stories-details-hero-quote.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $aiugz = parcelRequire("aiugz");
parcelRequire("dyrzP");
var $9Kv7x = parcelRequire("9Kv7x");

var $1UUq1 = parcelRequire("1UUq1");

var $gAJUc = parcelRequire("gAJUc");
parcelRequire("ccYBS");
var $e6FyV = parcelRequire("e6FyV");
const $f04546e5dcf926f8$var$quoteBodyCss = null;
const $f04546e5dcf926f8$var$quoteStylingWithImage = null;
const $f04546e5dcf926f8$var$quoteStylingNoImage = null;
const $f04546e5dcf926f8$var$imageCss = null;
const $f04546e5dcf926f8$var$quoteContainerStyles = null;
const $f04546e5dcf926f8$export$d35b0bc1e0617ca6 = ({ imgSrc: imgSrc, imgAlt: imgAlt, quote: quote, author: author, role: role, company: company })=>{
    var _composition_data;
    const composition = (0, $aiugz.useUniformCurrentComposition)();
    const compositionId = composition === null || composition === void 0 ? void 0 : (_composition_data = composition.data) === null || _composition_data === void 0 ? void 0 : _composition_data._id;
    const tracker = (0, $e6FyV.useScrollTracking)("UniformCustomerStoriesDetailsHeroQuote", {
        dwellTimeEnabled: true,
        additionalAttributes: {
            compositionId: compositionId
        }
    });
    const authorDetails = [
        role,
        company
    ].filter(Boolean).join(", ");
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        ref: (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7603UniformPageDwellTime) ? tracker === null || tracker === void 0 ? void 0 : tracker.ref : null,
        className: (0, $esG4f.default)([
            "_1e0c11p5 _yv0ecx6w _zulp1tcg _4cvr1h6o _6a6zv2br _1rqtaigu _pdlmzwfg"
        ]),
        children: [
            imgSrc && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1461kb7n _f0zu1ohn _nw6ekb7n _1jpu1mrw _uhi5kb7n _eao7qfx8"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9Kv7x.ContentPlatformImage), {
                    contentType: /* Since we do not pass in the direct Contentful image via Uniform,
      this uses a rough assumption to trigger a webp transformation */ imgSrc.endsWith(".png") ? "image/png" : undefined,
                    src: imgSrc,
                    alt: imgAlt !== null && imgAlt !== void 0 ? imgAlt : "",
                    style: {
                        maxWidth: "100%"
                    },
                    baseWidth: 440
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1461kb7n _f0zu1mrw _1vb6grf3",
                    imgSrc ? "_1e3c1gti" : "_1e3ceqnf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.PullQuote), {
                    quote: quote !== null && quote !== void 0 ? quote : "",
                    authorName: author !== null && author !== void 0 ? author : "",
                    authorDetails: authorDetails,
                    alignment: imgSrc ? "start" : "center",
                    size: "large",
                    variant: "basic"
                })
            })
        ]
    });
};
var $f04546e5dcf926f8$export$2e2bcd8739ae039 = $f04546e5dcf926f8$export$d35b0bc1e0617ca6;

});



parcelRegister("dUTg3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("dPZ0n")).default; });

var $dPZ0n = parcelRequire("dPZ0n");

});
parcelRegister("dPZ0n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0da449692bf398b2$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $55vkU = parcelRequire("55vkU");
const $0da449692bf398b2$var$transformImage = (props, alt)=>{
    var _props_file, _props_file1, _props_file_details_image, _props_file_details, _props_file2, _props_file_details_image1, _props_file_details1, _props_file3;
    if (!props) return undefined;
    return {
        contentType: (_props_file = props.file) === null || _props_file === void 0 ? void 0 : _props_file.contentType,
        src: (_props_file1 = props.file) === null || _props_file1 === void 0 ? void 0 : _props_file1.url,
        alt: alt !== null && alt !== void 0 ? alt : "",
        baseWidth: 500,
        width: (_props_file2 = props.file) === null || _props_file2 === void 0 ? void 0 : (_props_file_details = _props_file2.details) === null || _props_file_details === void 0 ? void 0 : (_props_file_details_image = _props_file_details.image) === null || _props_file_details_image === void 0 ? void 0 : _props_file_details_image.width,
        height: (_props_file3 = props.file) === null || _props_file3 === void 0 ? void 0 : (_props_file_details1 = _props_file3.details) === null || _props_file_details1 === void 0 ? void 0 : (_props_file_details_image1 = _props_file_details1.image) === null || _props_file_details_image1 === void 0 ? void 0 : _props_file_details_image1.height
    };
};
const $0da449692bf398b2$var$transformCta = (linkUrl, linkText)=>{
    if (linkUrl && linkText) return {
        url: linkUrl,
        text: linkText
    };
    return undefined;
};
const $0da449692bf398b2$var$transformProps = (props)=>{
    var _props_theme;
    return {
        bgColor: (_props_theme = props.theme) !== null && _props_theme !== void 0 ? _props_theme : "white",
        testimonials: props.quotes.map((quote)=>{
            var _fields_advocateCta__fields, _fields_advocateCta_, _fields_advocateCta, _fields_advocateCta__fields1, _fields_advocateCta_1, _fields_advocateCta1, _fields_organization_fields_logo_, _fields_organization_fields_logo, _fields_organization_fields, _fields_organization, _fields_organization_fields1, _fields_organization1, _fields_advocateHeadshot;
            const fields = quote.fields;
            const linkUrl = (_fields_advocateCta = fields.advocateCta) === null || _fields_advocateCta === void 0 ? void 0 : (_fields_advocateCta_ = _fields_advocateCta[0]) === null || _fields_advocateCta_ === void 0 ? void 0 : (_fields_advocateCta__fields = _fields_advocateCta_.fields) === null || _fields_advocateCta__fields === void 0 ? void 0 : _fields_advocateCta__fields.ctaUrl;
            const linkText = (_fields_advocateCta1 = fields.advocateCta) === null || _fields_advocateCta1 === void 0 ? void 0 : (_fields_advocateCta_1 = _fields_advocateCta1[0]) === null || _fields_advocateCta_1 === void 0 ? void 0 : (_fields_advocateCta__fields1 = _fields_advocateCta_1.fields) === null || _fields_advocateCta__fields1 === void 0 ? void 0 : _fields_advocateCta__fields1.ctaButtonText;
            return {
                logo: $0da449692bf398b2$var$transformImage((_fields_organization = fields.organization) === null || _fields_organization === void 0 ? void 0 : (_fields_organization_fields = _fields_organization.fields) === null || _fields_organization_fields === void 0 ? void 0 : (_fields_organization_fields_logo = _fields_organization_fields.logo) === null || _fields_organization_fields_logo === void 0 ? void 0 : (_fields_organization_fields_logo_ = _fields_organization_fields_logo[0]) === null || _fields_organization_fields_logo_ === void 0 ? void 0 : _fields_organization_fields_logo_.fields, (_fields_organization1 = fields.organization) === null || _fields_organization1 === void 0 ? void 0 : (_fields_organization_fields1 = _fields_organization1.fields) === null || _fields_organization_fields1 === void 0 ? void 0 : _fields_organization_fields1.organizationNameExternal),
                name: fields.advocateName,
                title: fields.advocateJobTitle,
                image: $0da449692bf398b2$var$transformImage((_fields_advocateHeadshot = fields.advocateHeadshot) === null || _fields_advocateHeadshot === void 0 ? void 0 : _fields_advocateHeadshot.fields),
                quote: fields.advocateQuote,
                link: $0da449692bf398b2$var$transformCta(linkUrl, linkText)
            };
        }).filter((quote)=>{
            return !!quote.logo && !!quote.name && !!quote.title && !!quote.image && !!quote.quote;
        })
    };
};
const $0da449692bf398b2$var$UniformCustomerTestimonials = (props)=>{
    //TODO GWP-6632: add CTA links, and ensure they are localized in each panel
    const transformed = $0da449692bf398b2$var$transformProps(props);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $55vkU.CustomerTestimonials), {
        bgColor: transformed.bgColor,
        testimonials: transformed.testimonials
    });
};
var $0da449692bf398b2$export$2e2bcd8739ae039 = $0da449692bf398b2$var$UniformCustomerTestimonials;

});


parcelRegister("gMNh2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("8TUqr")).default; });

var $8TUqr = parcelRequire("8TUqr");

});
parcelRegister("8TUqr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70d47a54af07b35a$export$2e2bcd8739ae039; });

var $kex29 = parcelRequire("kex29");
var $70d47a54af07b35a$export$2e2bcd8739ae039 = (0, $kex29.GlobalFooter);

});


parcelRegister("l0zDw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("3qApo")).default; });

var $3qApo = parcelRequire("3qApo");

});
parcelRegister("3qApo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4d70652145ea3ff$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $6NDAm = parcelRequire("6NDAm");
const $a4d70652145ea3ff$var$UniformGlobalNav = ({ productKey: // This productKey is used for UFO instrumentation
// This prop is standardized to the value `uniform`
// See ldr/0018-set-standard-uniform-globalnav-productkey.md for more details
productKey = "uniform", isShowTryNowLink: isShowTryNowLink = true })=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $6NDAm.GlobalNav), {
        productKey: productKey,
        isShowTryNowLink: isShowTryNowLink
    });
var $a4d70652145ea3ff$export$2e2bcd8739ae039 = $a4d70652145ea3ff$var$UniformGlobalNav;

});


parcelRegister("19QOl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("das6y")).default; });

var $das6y = parcelRequire("das6y");
$parcel$exportWildcard(module.exports, $das6y);

});
parcelRegister("das6y", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $03bb69f29d14e6f6$export$2e2bcd8739ae039; });
/* heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $aiugz = parcelRequire("aiugz");

var $40KoW = parcelRequire("40KoW");

var $5ohHq = parcelRequire("5ohHq");
var $03bb69f29d14e6f6$var$GestureLineType;
(function(GestureLineType) {
    GestureLineType["UNDERLINE_SQUIGGLE"] = "underline-squiggle";
    GestureLineType["EYELASH"] = "eyelash";
})($03bb69f29d14e6f6$var$GestureLineType || ($03bb69f29d14e6f6$var$GestureLineType = {}));
const $03bb69f29d14e6f6$var$UniformHeading = ({ text: text, uniformRichText: uniformRichText, customRichText: customRichText, alignment: alignment = "start", wordWrap: wordWrap })=>{
    const headingCss = [
        null,
        wordWrap && null
    ];
    function resolveUniformRichText({ node: node, children: children }) {
        const nodeIsBold = (node)=>{
            return node.type === "text" && (0, $40KoW.getRichTextTagsFromTextFormat)(node.format).includes("strong");
        };
        const richTextValueHasBold = (value)=>{
            let hasBold = false;
            (0, $40KoW.walkRichTextTree)(value, (node)=>{
                if (nodeIsBold(node)) hasBold = true;
            });
            return hasBold;
        };
        const hasBoldText = richTextValueHasBold(node);
        return /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
            className: (0, $esG4f.default)([
                "_1mouidpf _y3gnoues",
                wordWrap && "_ct361wug",
                hasBoldText ? "h1-contrast" : ""
            ]),
            style: {
                "--_1v0xqnb": (0, $43MIc.default)(alignment)
            },
            children: children
        });
    }
    function resolveUniformRichTextRenderer(node) {
        if (node.type === "paragraph") return resolveUniformRichText;
        return undefined;
    }
    const customRichTextIsConsideredEmpty = (customRichTextPropValue)=>{
        return !customRichTextPropValue || customRichTextPropValue.plainText === "";
    };
    const renderCustomRichText = ()=>{
        const nodeIsBold = (node)=>{
            return node.type === "bold";
        };
        const walkCustomRichTextTree = (node, callBack)=>{
            callBack(node);
            if (node.children) node.children.forEach((child)=>{
                walkCustomRichTextTree(child, callBack);
            });
        };
        const customRichTextValueHasBold = (value)=>{
            let hasBold = false;
            walkCustomRichTextTree(value, (node)=>{
                if (nodeIsBold(node)) hasBold = true;
            });
            return hasBold;
        };
        const hasBoldText = ()=>{
            let hasBold = false;
            customRichText === null || customRichText === void 0 ? void 0 : customRichText.content.forEach((node)=>{
                if (customRichTextValueHasBold(node)) hasBold = true;
            });
            return hasBold;
        };
        const renderCustomRichTextNode = (node, index)=>{
            switch(node.type){
                case "bold":
                    var _node_children;
                    return /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                        children: (_node_children = node.children) === null || _node_children === void 0 ? void 0 : _node_children.map((child, childIndex)=>renderCustomRichTextNode(child, childIndex))
                    }, index);
                case "underline-squiggle":
                    var _node_children1;
                    return /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                        className: (0, $esG4f.default)([
                            "_kqswh2mm"
                        ]),
                        children: [
                            $03bb69f29d14e6f6$var$getGestureLine(node.type, node.color),
                            (_node_children1 = node.children) === null || _node_children1 === void 0 ? void 0 : _node_children1.map((child, childIndex)=>renderCustomRichTextNode(child, childIndex))
                        ]
                    }, index);
                case "eyelash":
                    var _node_children2;
                    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("br", {}),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                                className: (0, $esG4f.default)([
                                    "_kqswh2mm"
                                ]),
                                children: [
                                    $03bb69f29d14e6f6$var$getGestureLine(node.type, node.color),
                                    (_node_children2 = node.children) === null || _node_children2 === void 0 ? void 0 : _node_children2.map((child, childIndex)=>renderCustomRichTextNode(child, childIndex))
                                ]
                            }, index)
                        ]
                    });
                case "text":
                default:
                    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        children: node.text || ""
                    }, index);
            }
        };
        return /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
            className: (0, $esG4f.default)([
                "_1mouidpf _y3gnoues",
                wordWrap && "_ct361wug",
                hasBoldText() ? "h1-contrast" : ""
            ]),
            style: {
                "--_1v0xqnb": (0, $43MIc.default)(alignment)
            },
            children: customRichText === null || customRichText === void 0 ? void 0 : customRichText.content.map((node, index)=>renderCustomRichTextNode(node, index))
        });
    };
    return !(0, $40KoW.isRichTextValueConsideredEmpty)(uniformRichText) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformRichText), {
        parameterId: "uniformRichText",
        resolveRichTextRenderer: resolveUniformRichTextRenderer
    }) : !customRichTextIsConsideredEmpty(customRichText) ? renderCustomRichText() : /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
        className: (0, $esG4f.default)([
            "_1mouidpf _y3gnoues",
            wordWrap && "_ct361wug"
        ]),
        style: {
            "--_1v0xqnb": (0, $43MIc.default)(alignment)
        },
        children: text
    });
};
const $03bb69f29d14e6f6$var$getGestureLine = (gestureLine, gestureColor)=>{
    switch(gestureLine){
        case "underline-squiggle":
            return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "168",
                height: "16",
                viewBox: "0 0 168 16",
                fill: "none",
                "aria-hidden": "true",
                className: (0, $esG4f.default)([
                    "_kqswstnw _u7comgjw _1e021ssb _t9eczr6s"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M2.28772 11.6604C3.27772 12.0304 4.34772 11.9903 5.35772 11.8503C7.39772 11.5403 9.37772 10.8704 11.5877 10.1904C12.1377 9.84043 12.2377 9.88052 12.0577 9.53052C12.1777 9.40052 12.3777 9.17054 12.2377 9.05054C11.7477 8.23054 13.1677 7.92036 13.7077 7.62036C13.8777 8.38036 14.7577 8.34047 15.9677 7.98047C16.3177 7.88047 16.4477 7.83054 16.7777 7.80054C17.1377 7.75054 17.5177 7.69037 17.9177 7.63037C18.6977 7.55037 19.5677 7.43051 20.3677 7.52051C21.1777 7.59051 21.9477 7.82033 22.5477 8.34033C23.1577 8.85033 23.5977 9.61033 23.9377 10.3403C24.2777 11.0803 24.5277 11.7703 24.7977 12.3303C25.0477 12.8903 25.3077 13.2605 25.4377 13.4805C25.2677 13.7805 25.3077 14.2403 25.6877 14.5603C25.8477 14.7603 26.1177 14.8404 26.3877 14.9504C26.6777 15.0204 26.9977 15.0505 27.3177 15.0405C27.9777 14.9905 28.6077 14.7703 29.1477 14.6003C29.6277 14.4003 30.0777 14.2805 30.4177 14.2905C30.3777 14.3905 29.9477 14.8704 29.8977 14.9504C30.2677 15.0804 31.5877 14.5504 33.0877 13.6204C34.5877 12.6804 36.3277 11.3904 37.8377 10.1504C40.8877 7.70039 43.2477 5.65034 41.7577 7.85034C42.9077 7.23034 44.1177 6.56054 45.3277 5.80054C45.6277 5.61054 45.9377 5.42047 46.2477 5.23047L46.4577 5.10034L46.5577 5.05054C46.6177 5.02054 46.6877 4.98046 46.7477 4.97046H46.9577C46.9577 4.97046 47.0077 4.99048 47.0677 4.99048L47.3177 4.97046C47.6477 4.93046 47.9577 4.97046 48.2877 4.97046C49.5577 5.03046 50.7077 5.27036 51.5177 5.87036C52.3577 6.43036 53.0377 7.39032 53.8677 8.83032C54.2877 9.54032 54.7477 10.3605 55.4377 11.2405C56.1177 12.1105 57.1877 13.1003 58.5577 13.5903C58.8977 13.6903 59.2377 13.8104 59.5777 13.8804C59.9077 13.9304 60.2477 13.9705 60.5877 14.0005C61.2077 14.0005 61.8677 14.0004 62.4177 13.8804C62.6977 13.8304 62.9977 13.7905 63.2677 13.7205L64.0477 13.5005C64.5877 13.3605 65.0377 13.1605 65.5277 12.9805C69.2577 11.4205 72.3477 9.28033 75.4077 7.09033L77.3177 5.68042L78.2877 5.3103C78.6577 5.1603 78.9877 5.13052 79.3377 5.03052C79.5177 4.97052 79.6677 4.96045 79.8177 4.96045L80.2677 4.92041C80.4177 4.90041 80.5077 4.95044 80.6377 4.95044C80.7577 4.96044 80.8877 4.9505 80.9677 5.0105C81.3577 5.0805 81.7077 5.38037 82.1877 5.88037C83.1277 6.87037 84.1977 8.90048 86.2677 10.2405C86.7977 10.5505 87.3177 10.8705 87.8977 11.0505C88.1777 11.1505 88.4677 11.2603 88.7477 11.3403L89.6277 11.5005L90.1877 11.5903C90.3777 11.6103 90.5577 11.6904 90.7377 11.6204L91.7777 11.4004L93.0077 11.1504C99.5477 9.79039 105.978 9.92039 111.408 10.6504L111.248 10.4805C111.418 10.5405 111.958 10.4604 112.088 10.6704C113.168 10.3804 115.148 10.2204 116.858 10.1104C118.568 9.99035 120.008 9.98047 120.008 9.98047L126.178 9.68042C126.178 9.68042 128.828 10.0004 132.038 10.1804C135.248 10.3504 139.018 10.3505 141.168 9.75049C146.538 9.91049 151.978 9.90038 157.378 9.14038C157.378 9.14038 157.798 9.06042 158.458 8.93042C159.108 8.76042 159.998 8.50045 160.938 8.21045C161.878 7.90045 162.878 7.63048 163.728 7.24048C164.578 6.84048 165.308 6.46038 165.738 6.14038C166.818 5.34038 167.398 4.60032 167.398 4.08032C167.398 3.56032 166.798 3.26034 165.488 3.35034C164.838 3.40034 164.008 3.5403 162.978 3.8103C161.958 4.0903 160.678 4.30047 159.188 4.73047C159.108 4.69047 158.848 4.68034 158.798 4.60034C155.658 5.58034 152.388 5.81031 149.118 5.82031C147.488 5.85031 145.828 5.71044 144.178 5.70044C142.518 5.66044 140.838 5.55033 139.138 5.59033C139.218 5.88033 138.988 6.11045 138.788 5.96045L138.868 5.60034C134.278 6.20034 131.478 4.87037 127.188 5.88037C127.188 5.88037 127.698 5.43041 127.708 5.42041C124.088 5.28041 120.148 5.02035 115.968 4.86035C111.798 4.67035 107.398 4.61033 102.918 4.84033C101.798 4.92033 100.678 5.00032 99.5477 5.08032C98.4277 5.18032 97.2977 5.37051 96.1777 5.52051L94.4977 5.7605L92.8277 6.12036L91.1677 6.49048L90.4477 6.65039C90.5277 6.65039 90.4077 6.67039 90.3977 6.65039C90.3677 6.65039 90.3977 6.65037 90.3277 6.63037L90.0777 6.60034C89.8977 6.60034 89.7877 6.50046 89.6377 6.47046C89.3377 6.41046 89.1177 6.22034 88.8477 6.10034C88.3577 5.76034 87.8377 5.20043 87.2377 4.44043C86.6277 3.70043 85.9777 2.69047 84.7877 1.73047C84.5377 1.49047 84.1477 1.29032 83.8277 1.08032C83.4977 0.860322 83.1177 0.720332 82.7377 0.590332C81.9677 0.270332 81.2177 0.260439 80.4877 0.200439C80.5177 0.210439 80.5577 0.240498 80.5977 0.260498L80.5477 0.310303C80.8177 0.380303 81.2077 0.480342 81.6777 0.600342C82.1377 0.700342 82.7077 1.02054 83.2677 1.30054C84.3877 2.00054 85.2177 3.07043 85.7777 3.94043C86.3577 4.84043 86.7577 5.54052 87.1077 6.03052C87.4577 6.48052 87.6877 6.76048 87.6877 6.74048C86.5777 6.38048 85.6577 5.36052 84.6977 4.28052C84.1877 3.75052 83.6877 3.17048 82.9877 2.74048C82.3277 2.26048 81.5077 2.01037 80.6977 1.88037C79.8977 1.79037 79.0677 1.79041 78.3077 1.92041C77.4877 1.99041 76.8377 2.21041 76.0077 2.42041L75.6577 2.52051C75.5477 2.57051 75.4477 2.64045 75.3377 2.71045L74.8077 3.03052L73.9177 3.58032C73.3277 3.96032 72.7577 4.34047 72.1877 4.73047L71.9477 4.32031C72.9277 3.67031 73.7977 2.95035 74.5077 2.36035L74.6377 2.25049L74.8677 2.07031C75.0177 1.96031 75.1377 1.82049 75.2977 1.75049C75.5977 1.62049 75.8977 1.48039 76.0577 1.40039C76.4177 1.22039 76.7177 1.06042 76.9377 0.93042C76.6377 1.02042 76.3377 1.10043 76.0177 1.19043C75.8277 1.25043 75.6377 1.31036 75.4477 1.37036L75.0877 1.49048C74.9677 1.55048 74.8677 1.63044 74.7577 1.70044C74.2077 2.06044 73.6377 2.43031 73.0377 2.82031C71.9577 3.52031 70.7877 4.26048 69.5577 4.99048C68.3377 5.72048 67.0477 6.48035 65.7477 7.11035C64.4677 7.75035 63.1077 8.35031 61.9777 8.57031C61.4477 8.66031 60.9377 8.7304 60.6677 8.6604C60.3877 8.6004 60.2477 8.55031 59.9677 8.32031C59.6977 8.10031 59.3477 7.66033 58.9677 7.09033C58.5877 6.53033 58.1977 5.88043 57.7177 5.19043C56.8077 3.83043 55.4277 2.36054 53.8077 1.55054C52.1877 0.720537 50.5777 0.550342 49.3377 0.600342C49.3977 0.690342 49.6377 0.730479 49.9777 0.740479C50.3177 0.770479 50.7777 0.8304 51.2477 0.9104C51.7177 1.0204 52.2077 1.20043 52.5777 1.44043C52.9477 1.71043 53.2077 2.02036 53.2477 2.37036C52.0777 1.73036 50.7777 1.51044 49.5877 1.45044L48.6977 1.43042L47.8477 1.50049C47.5677 1.52049 47.2777 1.53032 47.0177 1.58032C46.6977 1.63032 46.3777 1.67046 46.0677 1.72046C46.0177 1.53046 46.0977 1.40053 46.2577 1.29053C46.3377 1.24053 46.4377 1.19039 46.5477 1.15039C46.6377 1.11039 46.7077 1.0903 46.7977 1.0603C47.1377 0.950303 47.5377 0.960381 47.6577 0.890381C47.5377 0.880381 47.3277 0.840352 47.0677 0.860352C46.9377 0.860352 46.7877 0.870371 46.6277 0.880371C46.3877 0.900371 46.1277 0.930439 45.8477 0.950439C45.6977 0.960439 45.5477 0.980488 45.3777 1.00049L45.1277 1.02051C45.0477 1.05051 44.9877 1.11039 44.9177 1.15039C44.6377 1.35039 44.3377 1.56053 44.0177 1.79053C43.6377 2.05053 43.2077 2.3404 42.7477 2.6604C40.9377 3.9104 38.5277 5.5904 35.7377 7.4104C34.3477 8.3304 32.8477 9.23033 31.3077 10.0903C30.9277 10.2903 30.5377 10.4804 30.1477 10.6804C29.7677 10.8504 29.3877 11.0204 28.9977 11.1904L28.4577 11.3704L28.1877 11.4705L28.0877 11.4905C27.9377 11.5305 27.8877 11.5305 27.8177 11.5205C27.6677 11.5205 27.5777 11.3805 27.5377 11.2505L27.2377 10.2505C27.0977 9.76049 26.9177 9.1703 26.6777 8.5603C26.4377 7.9403 26.0877 7.27035 25.6277 6.61035C25.3577 6.29035 25.0977 5.96041 24.7877 5.67041C24.4577 5.40041 24.1377 5.09038 23.7677 4.89038C22.2977 3.98038 20.7377 3.74048 19.4877 3.74048C18.1677 3.71048 17.0877 3.89035 15.9277 4.11035C15.7477 4.16035 15.5177 4.15049 15.3077 4.25049L14.7377 4.49048L13.9977 4.83032C13.5277 5.06032 13.0777 5.2805 12.6577 5.5105C10.9577 6.4105 9.43772 7.26043 8.02772 7.94043C6.62772 8.62043 5.32772 9.14035 4.32772 9.36035C3.83772 9.47035 3.42772 9.49046 3.18772 9.47046C2.95772 9.46046 2.81772 9.42033 2.64772 9.34033C2.36772 9.20033 2.02772 8.68046 1.82772 8.22046C1.59772 7.77046 1.46772 7.39051 1.29772 7.27051C1.13772 7.14051 0.99772 7.24036 0.86772 7.62036C0.73772 8.01036 0.61772 8.68038 0.80772 9.64038C0.63772 9.58038 0.44772 9.51041 0.28772 9.42041C0.58772 10.4404 1.30772 11.3504 2.30772 11.7004L2.28772 11.6604Z",
                    fill: (0, $5ohHq.wacToken)(`color.${gestureColor}`)
                })
            });
        case "eyelash":
            return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "117",
                height: "117",
                viewBox: "0 0 117 117",
                fill: "none",
                "aria-hidden": "true",
                className: (0, $esG4f.default)([
                    "_kqswstnw _rjxp120u _152txmi2 _1bsb1wug _4t3i1vuk"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M25.93 74.8872C25.1564 75.4245 12.3829 73.151 16.0089 71.2258C17.2313 70.3577 18.3652 70.4522 18.7372 71.7455C19.127 69.2416 21.5364 72.5841 22.7056 71.7691C22.3041 70.0211 25.7765 73.6706 25.115 71.8518C38.9455 69.9857 66.6537 86.9815 32.7862 76.7356C36.1641 75.956 32.987 75.2593 31.4693 75.6431C33.6248 77.8813 27.306 75.9325 26.1426 75.1589C28.1032 75.2061 24.8788 73.5526 25.9359 74.8813L25.93 74.8872Z",
                        fill: (0, $5ohHq.wacToken)(`color.${gestureColor}`)
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M51.0103 53.7517C49.2092 53.6395 41.6974 41.3562 40.7526 40.187C39.1994 37.311 43.345 37.0866 44.0123 39.5374C44.3489 39.9566 45.5123 43.4468 46.3568 41.9527C49.8823 42.7263 50.3548 48.9624 53.3311 49.3522C52.8528 50.173 53.9039 51.1533 53.6618 51.7025C54.5476 51.608 55.0377 52.795 54.8251 52.9013C58.5987 55.978 53.898 59.604 51.8784 55.1867C51.7248 55.3757 50.6973 54.5961 51.0102 53.7635L51.0103 53.7517Z",
                        fill: (0, $5ohHq.wacToken)(`color.${gestureColor}`)
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M96.948 30.7506C98.5602 32.788 98.4539 30.6385 97.6566 29.6523C96.198 31.477 96.2098 27.2133 96.6999 26.1208C96.7885 26.5637 97.5562 26.6346 97.4263 25.7133C95.5838 26.5637 94.0779 14.9005 98.5661 19.991C98.5779 20.1918 97.0838 20.4457 97.5739 20.6287C99.8121 19.9851 98.4007 21.9989 98.2767 22.5363C99.4578 22.3945 98.4066 23.0087 98.9086 23.0855C100.438 22.2764 98.0641 25.5598 99.57 24.6681C102.245 27.0834 99.564 32.7408 101.962 34.5478C99.44 36.2545 104.241 44.3981 98.8437 41.6462C97.3378 38.0734 96.3988 35.1147 96.948 30.7506Z",
                        fill: (0, $5ohHq.wacToken)(`color.${gestureColor}`)
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M67.6391 11.4579C71.2001 10.1291 71.1824 18.2727 72.8891 20.2983C75.2808 22.7136 85.4263 50.3746 77.5308 43.7665C74.5308 35.3689 70.6037 29.0087 68.2533 18.3672C67.7454 16.6664 65.0643 11.5051 67.6391 11.4579Z",
                        fill: (0, $5ohHq.wacToken)(`color.${gestureColor}`)
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M43.5337 100.854C45.9077 103.617 48.5592 99.584 50.7796 101.828C54.2166 106.222 27.3351 110.663 27.7485 105.737C28.6757 101.551 41.7739 102.826 43.5337 100.854Z",
                        fill: (0, $5ohHq.wacToken)(`color.${gestureColor}`)
                    })
                ]
            });
        default:
            return null;
    }
};
var $03bb69f29d14e6f6$export$2e2bcd8739ae039 = $03bb69f29d14e6f6$var$UniformHeading;

});


parcelRegister("lrMw1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("25N89")).default; });

var $25N89 = parcelRequire("25N89");

});
parcelRegister("25N89", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5301e65b8a5b2dde$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");
parcelRequire("dMM9X");
var $5C9Aa = parcelRequire("5C9Aa");
const $5301e65b8a5b2dde$var$renderHeroCarousel = ({ items: items })=>{
    // First pass to work through Uniform setting empty to "" vs undefined that underlying component expects
    // eslint-disable-next-line complexity
    const transformed = items.map((heroSlide)=>{
        var _heroSlide_props_children_props_data, _heroSlide_props_children_props, _heroSlide_props_children, _heroSlide_props, _params_id, _params_tabEyebrow, _params_tabLabel, _params_title, _params_body, _params_buttonText, _params_buttonHref, _params_buttonText1, _params_buttonHref1, _params_buttonAriaLabel, _params_linkText, _params_linkHref, _params_linkText1, _params_linkHref1, _params_linkType, _params_linkAriaLabel, _params_bgColor, _params_imageLarge, _params_alignment;
        const params = (_heroSlide_props = heroSlide.props) === null || _heroSlide_props === void 0 ? void 0 : (_heroSlide_props_children = _heroSlide_props.children) === null || _heroSlide_props_children === void 0 ? void 0 : (_heroSlide_props_children_props = _heroSlide_props_children.props) === null || _heroSlide_props_children_props === void 0 ? void 0 : (_heroSlide_props_children_props_data = _heroSlide_props_children_props.data) === null || _heroSlide_props_children_props_data === void 0 ? void 0 : _heroSlide_props_children_props_data.parameters;
        return {
            id: ((_params_id = params.id) === null || _params_id === void 0 ? void 0 : _params_id.value) || undefined,
            eyebrow: ((_params_tabEyebrow = params.tabEyebrow) === null || _params_tabEyebrow === void 0 ? void 0 : _params_tabEyebrow.value) || undefined,
            title: (params === null || params === void 0 ? void 0 : (_params_tabLabel = params.tabLabel) === null || _params_tabLabel === void 0 ? void 0 : _params_tabLabel.value) || undefined,
            panel: {
                title: ((_params_title = params.title) === null || _params_title === void 0 ? void 0 : _params_title.value) || undefined,
                body: ((_params_body = params.body) === null || _params_body === void 0 ? void 0 : _params_body.value) || undefined,
                primaryCallToAction: ((_params_buttonText = params.buttonText) === null || _params_buttonText === void 0 ? void 0 : _params_buttonText.value) && ((_params_buttonHref = params.buttonHref) === null || _params_buttonHref === void 0 ? void 0 : _params_buttonHref.value) ? {
                    "text": (_params_buttonText1 = params.buttonText) === null || _params_buttonText1 === void 0 ? void 0 : _params_buttonText1.value,
                    "href": (_params_buttonHref1 = params.buttonHref) === null || _params_buttonHref1 === void 0 ? void 0 : _params_buttonHref1.value,
                    "aria-label": ((_params_buttonAriaLabel = params.buttonAriaLabel) === null || _params_buttonAriaLabel === void 0 ? void 0 : _params_buttonAriaLabel.value) || undefined
                } : undefined,
                secondaryCallToAction: ((_params_linkText = params.linkText) === null || _params_linkText === void 0 ? void 0 : _params_linkText.value) && ((_params_linkHref = params.linkHref) === null || _params_linkHref === void 0 ? void 0 : _params_linkHref.value) ? {
                    text: (_params_linkText1 = params.linkText) === null || _params_linkText1 === void 0 ? void 0 : _params_linkText1.value,
                    href: (_params_linkHref1 = params.linkHref) === null || _params_linkHref1 === void 0 ? void 0 : _params_linkHref1.value,
                    type: ((_params_linkType = params.linkType) === null || _params_linkType === void 0 ? void 0 : _params_linkType.value) || undefined,
                    ariaLabel: ((_params_linkAriaLabel = params.linkAriaLabel) === null || _params_linkAriaLabel === void 0 ? void 0 : _params_linkAriaLabel.value) || undefined
                } : undefined,
                bgColor: ((_params_bgColor = params.bgColor) === null || _params_bgColor === void 0 ? void 0 : _params_bgColor.value) || undefined,
                bgImage: {
                    lg: ((_params_imageLarge = params.imageLarge) === null || _params_imageLarge === void 0 ? void 0 : _params_imageLarge.value) || undefined
                },
                layout: ((_params_alignment = params.alignment) === null || _params_alignment === void 0 ? void 0 : _params_alignment.value) || undefined
            }
        };
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5C9Aa.HeroCarousel), {
        tabsData: transformed
    });
};
const $5301e65b8a5b2dde$var$UniformHeroCarousel = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "tabdata",
            wrapperComponent: $5301e65b8a5b2dde$var$renderHeroCarousel
        })
    });
};
var $5301e65b8a5b2dde$export$2e2bcd8739ae039 = $5301e65b8a5b2dde$var$UniformHeroCarousel;

});


parcelRegister("98ja9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("gpIg5")).default; });

var $gpIg5 = parcelRequire("gpIg5");

});
parcelRegister("gpIg5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0385a163ab1ba80$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("6iLAo");
var $8A8QS = parcelRequire("8A8QS");
const $c0385a163ab1ba80$var$UniformHeroCarouselV0 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8A8QS.HeroV2Section), {});
};
var $c0385a163ab1ba80$export$2e2bcd8739ae039 = $c0385a163ab1ba80$var$UniformHeroCarouselV0;

});


parcelRegister("hS2Tl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("bEbxJ")).default; });

var $bEbxJ = parcelRequire("bEbxJ");

});
parcelRegister("bEbxJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $facb2e5cfffff962$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $gtQwZ = parcelRequire("gtQwZ");

var $3FBn4 = parcelRequire("3FBn4");
const $facb2e5cfffff962$var$UniformHeroSection = (props)=>{
    var _props_buttonHref;
    var _props_buttonHref_path;
    const localizedButtonHref = (0, $3FBn4.useLocalizedHref)((_props_buttonHref_path = (_props_buttonHref = props.buttonHref) === null || _props_buttonHref === void 0 ? void 0 : _props_buttonHref.path) !== null && _props_buttonHref_path !== void 0 ? _props_buttonHref_path : "");
    var _props_layout, _props_imageAlt;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $gtQwZ.default), {
        heading: props.heading,
        subheading: props.subheading,
        layout: (_props_layout = props.layout) !== null && _props_layout !== void 0 ? _props_layout : "image-right",
        // @ts-ignore
        backgroundColor: props.backgroundColor,
        callToActionProps: props.buttonHref && props.buttonLabel ? {
            text: props.buttonLabel,
            href: localizedButtonHref
        } : undefined,
        imageProps: props.imageUrl ? {
            src: props.imageUrl,
            alt: (_props_imageAlt = props.imageAlt) !== null && _props_imageAlt !== void 0 ? _props_imageAlt : ""
        } : undefined,
        secondaryImageProps: props.secondaryImageUrl ? {
            src: props.secondaryImageUrl,
            alt: ""
        } : undefined
    });
};
var $facb2e5cfffff962$export$2e2bcd8739ae039 = $facb2e5cfffff962$var$UniformHeroSection;

});


parcelRegister("7JHqD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("3IgE4")).default; });

var $3IgE4 = parcelRequire("3IgE4");

});
parcelRegister("3IgE4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9df49062445c098$export$2e2bcd8739ae039; });
/* horizontal-divider.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $4J1z5 = parcelRequire("4J1z5");

var $5ohHq = parcelRequire("5ohHq");
const $e9df49062445c098$var$dividerStyle = null;
const $e9df49062445c098$var$UniformHorizontalDivider = ({ lineStyle: lineStyle = "solid" })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("hr", {
        role: "presentation",
        style: {
            borderBlockStart: `1px ${lineStyle} ${(0, $5ohHq.wacToken)("color.neutral.light400")}`
        },
        className: (0, $esG4f.default)([
            "_1bsb1osq _19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    });
};
$e9df49062445c098$var$UniformHorizontalDivider.propTypes = {
    lineStyle: (0, (/*@__PURE__*/$parcel$interopDefault($4J1z5))).string
};
var $e9df49062445c098$export$2e2bcd8739ae039 = $e9df49062445c098$var$UniformHorizontalDivider;

});


parcelRegister("e6r6l", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("l8rpb")).default; });

var $l8rpb = parcelRequire("l8rpb");

});
parcelRegister("l8rpb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a14fc0a3a762f3f$export$2e2bcd8739ae039; });
/* image.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $bhreu = parcelRequire("bhreu");
// eslint-disable-next-line complexity
const $6a14fc0a3a762f3f$var$UniformImage = ({ source: source, altText: altText = "", width: width, maxWidth: maxWidth, height: height, maxHeight: maxHeight, objectFit: objectFit, objectPosition: objectPosition, tabletWidth: tabletWidth, desktopWidth: desktopWidth, tabletHeight: tabletHeight, desktopHeight: desktopHeight, makeCircle: makeCircle = false })=>{
    const imageStyle = {
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    const widthStyle = null;
    const heightStyle = null;
    const tabletWidthStyle = null;
    const desktopWidthStyle = null;
    const tabletHeightStyle = null;
    const desktopHeightStyle = null; // @ts-ignore
    const responsiveStyles = null;
    const makeCircleStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: source,
            alt: altText
        },
        className: (0, $esG4f.default)([
            width && "_1bsbzdsf",
            height && "_4t3i1rot",
            tabletWidth && "_14b51mzn",
            desktopWidth && "_glte1k6c",
            tabletHeight && "_1xloa7f3",
            desktopHeight && "_165tbekw",
            makeCircle && "_2rko1ssb"
        ]),
        style: (0, $6iHNw._)((0, $7Knp0._)({}, imageStyle), {
            "--_m5r7t4": (0, $43MIc.default)(width ? width : "auto"),
            "--_mzs5ed": (0, $43MIc.default)(height ? height : "auto"),
            "--_dwkr3u": (0, $43MIc.default)(tabletWidth ? tabletWidth : "auto"),
            "--_1mc860w": (0, $43MIc.default)(desktopWidth ? desktopWidth : "auto"),
            "--_1cta8t7": (0, $43MIc.default)(tabletHeight ? tabletHeight : "auto"),
            "--_1frmj6s": (0, $43MIc.default)(desktopHeight ? desktopHeight : "auto")
        })
    });
};
var $6a14fc0a3a762f3f$export$2e2bcd8739ae039 = $6a14fc0a3a762f3f$var$UniformImage;

});


parcelRegister("4x11f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("6wjLX")).default; });

var $6wjLX = parcelRequire("6wjLX");

});
parcelRegister("6wjLX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b643348a4469187c$export$2e2bcd8739ae039; });
/* jira-templates-tab-content-subgrid-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $aiugz = parcelRequire("aiugz");
const $b643348a4469187c$export$2f2a2862921598f6 = ()=>{
    const renderJiraTemplatesTabContent = ({ items: items })=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx21bp4 _zulpv47k _dm2511p5 _dbjgidpf _1hvkidpf _isu4idpf _15qmidpf _oqicidpf _1rmjidpf _cjbtidpf _pnmbidpf _pdlm14hz _glte1osq _1vsw13cz _18jf188f _azss12kr _1rqt1we7"
            ]),
            children: items
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: "jiraTemplatesTabContent",
        wrapperComponent: renderJiraTemplatesTabContent
    });
};
var $b643348a4469187c$export$2e2bcd8739ae039 = $b643348a4469187c$export$2f2a2862921598f6;

});


parcelRegister("dFD1n", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("9KNdd")).default; });

var $9KNdd = parcelRequire("9KNdd");

});
parcelRegister("9KNdd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb3d14b85778a1e0$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $3FBn4 = parcelRequire("3FBn4");

var $9iZsm = parcelRequire("9iZsm");

var $gAJUc = parcelRequire("gAJUc");

var $1O6nN = parcelRequire("1O6nN");
const $bb3d14b85778a1e0$export$64bc9cd96d3d9a80 = (props)=>{
    let localizedHref = (0, $3FBn4.useLocalizedHref)(props.href);
    const localizedPartnerDirectoryUrl = (0, $9iZsm.useLocalizedPartnerDirectoryHref)(props.href);
    const checkGate = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwpUniformLinkLocalizePartnerDirectory);
    if (checkGate && props.href !== localizedPartnerDirectoryUrl) localizedHref = localizedPartnerDirectoryUrl;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1O6nN.Link), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        href: localizedHref
    }));
};
var $bb3d14b85778a1e0$export$2e2bcd8739ae039 = $bb3d14b85778a1e0$export$64bc9cd96d3d9a80;

});


parcelRegister("hykE5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("dWM7f")).default; });

var $dWM7f = parcelRequire("dWM7f");

});
parcelRegister("dWM7f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17a81881ca6e4dbf$export$2e2bcd8739ae039; });
/* list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");

var $4muOv = parcelRequire("4muOv");
const $17a81881ca6e4dbf$var$UniformList = ({ gap: gap = "space.100", maxHeight: maxHeight, isHorizontal: isHorizontal = false })=>{
    const spaceTokenValue = (0, $4muOv.spaceTokenValues)[gap];
    const listStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21q43 _zulpfogq _c71l1nve _1reo15vq _18m915vq"
        ]),
        style: {
            "--_edet6m": (0, $43MIc.default)(isHorizontal ? "row" : "column"),
            "--_e9ez6f": (0, $43MIc.default)("var(--ds-space-" + spaceTokenValue + ")"),
            "--_6stjzx": (0, $43MIc.default)(maxHeight ? maxHeight + "px" : "none")
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "listItems"
        })
    });
};
var $17a81881ca6e4dbf$export$2e2bcd8739ae039 = $17a81881ca6e4dbf$var$UniformList;

});


parcelRegister("ee1EE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("1Yaob")).default; });

var $1Yaob = parcelRequire("1Yaob");

});
parcelRegister("1Yaob", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebf870f54152743d$export$2e2bcd8739ae039; });
/* listv2.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");

var $62pC7 = parcelRequire("62pC7");
const $ebf870f54152743d$var$UniformListV2 = ({ listType: listType, gapv2: gapv2 = {
    mobile: "0"
} })=>{
    var _gapv2_mobile, _gapv2_tablet, _ref, _gapv2_desktop, _ref1, _ref2;
    const gapObject = {
        mobile: (_gapv2_mobile = gapv2.mobile) !== null && _gapv2_mobile !== void 0 ? _gapv2_mobile : "0",
        tablet: (_ref = (_gapv2_tablet = gapv2 === null || gapv2 === void 0 ? void 0 : gapv2.tablet) !== null && _gapv2_tablet !== void 0 ? _gapv2_tablet : gapv2.mobile) !== null && _ref !== void 0 ? _ref : "0",
        desktop: (_ref2 = (_ref1 = (_gapv2_desktop = gapv2 === null || gapv2 === void 0 ? void 0 : gapv2.desktop) !== null && _gapv2_desktop !== void 0 ? _gapv2_desktop : gapv2 === null || gapv2 === void 0 ? void 0 : gapv2.tablet) !== null && _ref1 !== void 0 ? _ref1 : gapv2.mobile) !== null && _ref2 !== void 0 ? _ref2 : "0"
    };
    const listStyle = null;
    const zeroMarginPadding = null;
    const renderListItems = ({ items: items })=>{
        // Only works for paired dt/dd items. Would need different solution for different structure
        if (listType === "dl") return items.map((item, index)=>{
            if (index % 2 === 0) return /*#__PURE__*/ (0, $loA2J.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("dt", {
                        children: item
                    }),
                    items[index + 1] && /*#__PURE__*/ (0, $loA2J.jsx)("dd", {
                        children: items[index + 1]
                    })
                ]
            }, index);
            return null;
        });
        if (listType === "ol") return items.map((item, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("li", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
                    "_qtt8glyw _1e0c1txw _2lx21bp4 _zulp1crf _1lp7vrvc _q8t51q9y"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $62pC7.ListItemNumber), {
                        value: index + 1
                    }),
                    item
                ]
            }, index));
        return items.map((item, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                className: (0, $esG4f.default)([
                    "_kkk2n7od _1e0c1txw",
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                ]),
                children: item
            }, index));
    };
    const ListTypeComponent = listType || "ul";
    return /*#__PURE__*/ (0, $loA2J.jsx)(ListTypeComponent, {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulp1a6y _19wggsi3 _pdlmxbqd",
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
        ]),
        style: {
            "--_rkv8x9": (0, $43MIc.default)("var(--ds-space-" + gapObject.mobile + ")"),
            "--_9wptik": (0, $43MIc.default)("var(--ds-space-" + gapObject.tablet + ")"),
            "--_3wdyhk": (0, $43MIc.default)("var(--ds-space-" + gapObject.desktop + ")")
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "listItems",
            wrapperComponent: renderListItems
        })
    });
};
var $ebf870f54152743d$export$2e2bcd8739ae039 = $ebf870f54152743d$var$UniformListV2;

});
parcelRegister("62pC7", function(module, exports) {

$parcel$export(module.exports, "ListItemNumber", function () { return $f824e5ec7d10d94f$export$448080ad20b09ab8; });
/* list-item-number.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $5ohHq = parcelRequire("5ohHq");
const $f824e5ec7d10d94f$export$448080ad20b09ab8 = (props)=>{
    const { value: value } = props;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _4t3ickbl _1bsbckbl _2rko1osq _11q76kkz _1e0c1txw _1bah1h6o _4cvr1h6o _syaz1tj6 _y3gn1h6o _ect41pz4 _1wybgktf _zg8l4jg8 _k48p1fw0 _vwz4183y"
        ]),
        style: {
            "--_1qa6cp7": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue200")),
            "--_1tgiy09": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue900")),
            "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
        },
        children: value
    });
};

});



parcelRegister("kgmR5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("fq2e7")).default; });

var $fq2e7 = parcelRequire("fq2e7");

});
parcelRegister("fq2e7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a78475915aa8c839$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $5VMi0 = parcelRequire("5VMi0");
const $a78475915aa8c839$export$d64e2f97651f7f4d = (props)=>{
    const appearance = props.color === "red" ? "danger" : props.color || "neutral";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5VMi0.Lozenge), {
        appearance: appearance,
        text: props.text
    });
};
var $a78475915aa8c839$export$2e2bcd8739ae039 = $a78475915aa8c839$export$d64e2f97651f7f4d;

});


parcelRegister("liGDD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("9ScPv")).default; });

var $9ScPv = parcelRequire("9ScPv");

});
parcelRegister("9ScPv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cb2f8cde4557d14$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");

var $1rLfN = parcelRequire("1rLfN");
const $0cb2f8cde4557d14$var$UniformModal = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1rLfN.ModalLink), {
        modalTitle: props.modalTitle,
        modalCloseLabel: props.modalCloseLabel,
        ctaText: props.ctaText,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "modalContent"
        })
    });
};
var $0cb2f8cde4557d14$export$2e2bcd8739ae039 = $0cb2f8cde4557d14$var$UniformModal;

});
parcelRegister("1rLfN", function(module, exports) {

$parcel$export(module.exports, "ModalLink", function () { return $8bb80322af964ea2$export$cf363aa9ce73688b; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $1O6nN = parcelRequire("1O6nN");

var $edRuD = parcelRequire("edRuD");
const $8bb80322af964ea2$export$cf363aa9ce73688b = ({ modalTitle: modalTitle, modalCloseLabel: modalCloseLabel, children: children, ctaText: ctaText })=>{
    const [isOpen, setIsOpen] = (0, $iSvIT.useState)(false);
    const openModal = (e)=>{
        e.preventDefault();
        setIsOpen(true);
    };
    const closeModal = (0, $iSvIT.useCallback)(()=>setIsOpen(false), []);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1O6nN.Link), {
                onClick: openModal,
                text: ctaText,
                href: "#",
                type: "modal"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $edRuD.Modal), {
                closeModal: closeModal,
                closeLabel: modalCloseLabel,
                title: modalTitle,
                isOpen: isOpen,
                children: children
            })
        ]
    });
};

});



parcelRegister("ixWw7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("cJj5V")).default; });

var $cJj5V = parcelRequire("cJj5V");

});
parcelRegister("cJj5V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a9cc98f36fb0b33$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");

var $gPr7r = parcelRequire("gPr7r");
parcelRequire("aRHrH");
var $9O2F2 = parcelRequire("9O2F2");

var $4XrxY = parcelRequire("4XrxY");

var $kex29 = parcelRequire("kex29");

var $cP0Yq = parcelRequire("cP0Yq");

var $2RWab = parcelRequire("2RWab");

var $a4JY7 = parcelRequire("a4JY7");

var $8PL6n = parcelRequire("8PL6n");

var $bwE7U = parcelRequire("bwE7U");

var $gxFZp = parcelRequire("gxFZp");

var $hDoR2 = parcelRequire("hDoR2");

var $kGZng = parcelRequire("kGZng");

var $lGc56 = parcelRequire("lGc56");

var $4Cacz = parcelRequire("4Cacz");

var $j6Axx = parcelRequire("j6Axx");

var $dJVgs = parcelRequire("dJVgs");

var $61A0C = parcelRequire("61A0C");

var $9g0oR = parcelRequire("9g0oR");

var $2ChcF = parcelRequire("2ChcF");

var $68wZ4 = parcelRequire("68wZ4");

var $g99nl = parcelRequire("g99nl");

var $gAJUc = parcelRequire("gAJUc");

var $2ceSC = parcelRequire("2ceSC");

var $gygyq = parcelRequire("gygyq");

var $52gYK = parcelRequire("52gYK");
const $1a9cc98f36fb0b33$export$6955bcca4cd3539f = (props)=>{
    var _component_slots;
    const { component: component, siteSelectorProductKey: siteSelectorProductKey, siteSelectorAnalyticsPrefix: siteSelectorAnalyticsPrefix } = props;
    const fullSiteSelectorProductKey = siteSelectorProductKey === "jira-service-management" ? "jira-servicedesk.ondemand" : `${siteSelectorProductKey}.ondemand`;
    const locale = (0, $2ceSC.useLocale)();
    const isBootIntercom = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp5381AddIntercomWidgetToUniform);
    const intercomAppId = locale === "ja" ? "p0ww63i2" : "";
    var _component_slots_content;
    const contentSlot = (_component_slots_content = (_component_slots = component.slots) === null || _component_slots === void 0 ? void 0 : _component_slots["content"]) !== null && _component_slots_content !== void 0 ? _component_slots_content : [];
    const pageHasGlobalNavComponent = !!contentSlot.find((content)=>content.type === "globalNav");
    const pageHasGlobalFooterComponent = !!contentSlot.find((content)=>content.type === "globalFooter");
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $9O2F2.IntercomProvider), {
        appId: intercomAppId,
        triggerBoot: isBootIntercom,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $gPr7r.default), {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $52gYK.OptionalSiteSelectorContextProvider), {
                    siteSelectorProductKey: fullSiteSelectorProductKey,
                    siteSelectorAnalyticsPrefix: siteSelectorAnalyticsPrefix,
                    children: [
                        !pageHasGlobalNavComponent && /*#__PURE__*/ (0, $loA2J.jsx)($1a9cc98f36fb0b33$var$PageNav, {
                            component: component
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("main", {
                                id: "content",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                                    name: "content"
                                })
                            })
                        })
                    ]
                })
            }),
            !pageHasGlobalFooterComponent && /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
        ]
    });
};
// eslint-disable-next-line complexity
const $1a9cc98f36fb0b33$var$PageNav = ({ component: component })=>{
    const pageNavType = component.parameters && component.parameters["nav"] && component.parameters["nav"].value;
    let pageNav;
    switch(pageNavType){
        case "confluence":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $kGZng.default), {});
            break;
        case "bitbucket":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $gxFZp.BitbucketNav), {});
            break;
        case "confluence-template-experiment":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $lGc56.ConfluenceTemplateHeaderContainer), {});
            break;
        case "enterprise":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $bwE7U.default), {});
            break;
        case "jira-software":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJVgs.default), {});
            break;
        case "jira-service-management":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $9g0oR.default), {});
            break;
        case "jira-product-discovery":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $j6Axx.default), {});
            break;
        case "gwp-7880-jira-software-templates-experiment":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $61A0C.default), {});
            break;
        case "gwp-7880-jira-service-management-templates-experiment":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $2ChcF.default), {});
            break;
        case "compass":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $hDoR2.CompassNav), {});
            break;
        case "atlassian-access":
        case "guard":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4Cacz.GuardNav), {});
            break;
        case "rovo":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $g99nl.RovoNav), {});
            break;
        case "rovo-dev":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $gygyq.RovoDevNav), {});
            break;
        case "loom":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $68wZ4.LoomNav), {});
            break;
        case "teamwork-collection":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $8PL6n.TeamworkCollectionNavbar), {});
            break;
        case "strategy-collection":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $2RWab.StrategyCollectionNavbar), {});
            break;
        case "service-collection":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $a4JY7.ServiceCollectionNavbar), {});
            break;
        case "none":
            break;
        case "global":
        default:
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.default), {
                productKey: "uniform",
                isShowTryNowLink: true
            });
            break;
    }
    return pageNav;
};
var $1a9cc98f36fb0b33$export$2e2bcd8739ae039 = $1a9cc98f36fb0b33$export$6955bcca4cd3539f;

});
parcelRegister("gPr7r", function(module, exports) {

$parcel$export(module.exports, "useProductTemplateContext", function () { return $205f85a083271d56$export$9aa15cd8273c8730; });
$parcel$export(module.exports, "default", function () { return $205f85a083271d56$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $205f85a083271d56$var$ProductTemplateContext = /*#__PURE__*/ (0, $iSvIT.createContext)({
    template: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setTemplate: ()=>{}
});
const $205f85a083271d56$export$d254455f6d2132ac = ({ children: children })=>{
    const [template, setTemplate] = (0, $iSvIT.useState)(null);
    const value = (0, $iSvIT.useMemo)(()=>({
            template: template,
            setTemplate: setTemplate
        }), [
        template
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($205f85a083271d56$var$ProductTemplateContext.Provider, {
        value: value,
        children: children
    });
};
const $205f85a083271d56$export$9aa15cd8273c8730 = ()=>{
    const context = (0, $iSvIT.useContext)($205f85a083271d56$var$ProductTemplateContext);
    if (!context) throw new Error("useProductTemplateContext must be used within a ProductTemplateContextProvider");
    return context;
};
var $205f85a083271d56$export$2e2bcd8739ae039 = $205f85a083271d56$export$d254455f6d2132ac;

});

parcelRegister("a4JY7", function(module, exports) {

$parcel$export(module.exports, "ServiceCollectionNavbar", function () { return $d8f13c7e7c4f9ba4$export$21a8ade06194f818; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $cP0Yq = parcelRequire("cP0Yq");

var $4R0f2 = parcelRequire("4R0f2");

var $lCocY = parcelRequire("lCocY");
const $d8f13c7e7c4f9ba4$export$21a8ade06194f818 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.GlobalNav), {
        productKey: "home",
        compoundNav: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $4R0f2.CollectionsCompoundSubNavProps)()), {
            ctaUrl: (0, $lCocY.CTA_URL_PATH)
        })
    });
};

});
parcelRegister("lCocY", function(module, exports) {

$parcel$export(module.exports, "CTA_URL_PATH", function () { return $753242cc13657a15$export$d5587a12d9eea1dc; });
const $753242cc13657a15$export$d5587a12d9eea1dc = "/collections/service#contact";

});


parcelRegister("61A0C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $537cd27d87d2a568$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $gPr7r = parcelRequire("gPr7r");

var $5ZKRm = parcelRequire("5ZKRm");

var $dJVgs = parcelRequire("dJVgs");
const $537cd27d87d2a568$var$JiraSoftwareNavUniform = ()=>{
    const { template: template } = (0, $gPr7r.useProductTemplateContext)();
    const { openModalForTemplate: openModalForTemplate } = (0, $5ZKRm.useSiteSelectorContext)();
    const [isUseOpenCrossFlow, setIsUseOpenCrossFlow] = (0, $iSvIT.useState)(false);
    const openModalForTemplateClickAction = (0, $iSvIT.useMemo)(()=>{
        return (event)=>{
            event.preventDefault();
            event.stopPropagation();
            openModalForTemplate({
                templateId: template === null || template === void 0 ? void 0 : template.templateId,
                templateName: template === null || template === void 0 ? void 0 : template.templateName,
                productKey: template === null || template === void 0 ? void 0 : template.productKey
            });
        };
    }, [
        openModalForTemplate,
        template === null || template === void 0 ? void 0 : template.templateId,
        template === null || template === void 0 ? void 0 : template.templateName,
        template === null || template === void 0 ? void 0 : template.productKey
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if ((template === null || template === void 0 ? void 0 : template.templateId) && (template === null || template === void 0 ? void 0 : template.templateName) && (template === null || template === void 0 ? void 0 : template.productKey)) setIsUseOpenCrossFlow(true);
    }, [
        template === null || template === void 0 ? void 0 : template.templateId,
        template === null || template === void 0 ? void 0 : template.templateName,
        template === null || template === void 0 ? void 0 : template.productKey
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJVgs.default), {
        productNavCtaCTAClickFunction: openModalForTemplateClickAction,
        isUseOpenCrossFlow: isUseOpenCrossFlow
    });
};
$537cd27d87d2a568$var$JiraSoftwareNavUniform.displayName = "JiraSoftwareNavUniform";
var $537cd27d87d2a568$export$2e2bcd8739ae039 = $537cd27d87d2a568$var$JiraSoftwareNavUniform;

});

parcelRegister("2ChcF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5968950e65378e4$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $gPr7r = parcelRequire("gPr7r");

var $5ZKRm = parcelRequire("5ZKRm");

var $9g0oR = parcelRequire("9g0oR");
const $f5968950e65378e4$var$JiraServiceManagementSoftwareNavV2Uniform = ()=>{
    const { template: template } = (0, $gPr7r.useProductTemplateContext)();
    const { openModalForTemplate: openModalForTemplate } = (0, $5ZKRm.useSiteSelectorContext)();
    const [isUseOpenCrossFlow, setIsUseOpenCrossFlow] = (0, $iSvIT.useState)(false);
    const openModalForTemplateClickAction = (0, $iSvIT.useMemo)(()=>{
        return (event)=>{
            event.preventDefault();
            event.stopPropagation();
            openModalForTemplate({
                templateId: template === null || template === void 0 ? void 0 : template.templateId,
                templateName: template === null || template === void 0 ? void 0 : template.templateName,
                productKey: template === null || template === void 0 ? void 0 : template.productKey
            });
        };
    }, [
        openModalForTemplate,
        template === null || template === void 0 ? void 0 : template.templateId,
        template === null || template === void 0 ? void 0 : template.templateName,
        template === null || template === void 0 ? void 0 : template.productKey
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if ((template === null || template === void 0 ? void 0 : template.templateId) && (template === null || template === void 0 ? void 0 : template.templateName) && (template === null || template === void 0 ? void 0 : template.productKey)) setIsUseOpenCrossFlow(true);
    }, [
        template === null || template === void 0 ? void 0 : template.templateId,
        template === null || template === void 0 ? void 0 : template.templateName,
        template === null || template === void 0 ? void 0 : template.productKey
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9g0oR.default), {
        productNavCtaCTAClickFunction: openModalForTemplateClickAction,
        isUseOpenCrossFlow: isUseOpenCrossFlow
    });
};
$f5968950e65378e4$var$JiraServiceManagementSoftwareNavV2Uniform.displayName = "JiraServiceManagementSoftwareNavV2Uniform";
var $f5968950e65378e4$export$2e2bcd8739ae039 = $f5968950e65378e4$var$JiraServiceManagementSoftwareNavV2Uniform;

});

parcelRegister("gygyq", function(module, exports) {

$parcel$export(module.exports, "RovoDevNav", function () { return $585a7ff05ee5573e$export$446da800ffd5a425; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $bhreu = parcelRequire("bhreu");

var $3FBn4 = parcelRequire("3FBn4");

var $cP0Yq = parcelRequire("cP0Yq");
const $585a7ff05ee5573e$export$446da800ffd5a425 = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=devai");
    const pricingHref = (0, $3FBn4.useLocalizedHref)("/software/rovo-dev/pricing");
    const documentationHref = (0, $3FBn4.useLocalizedHref)("https://support.atlassian.com/rovo/docs/work-with-rovo-dev-agents");
    const logo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/d888ipg7v6w1c6x4xfb578gfiw5238d0.svg",
            alt: "Rovo Dev"
        },
        style: {
            height: "26px"
        }
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
        productLogoUrl: "/software/rovo-dev",
        productLogo: logo,
        productLogoAriaLabel: intl.formatMessage({
            id: "RovoDevNav.productLogoAriaLabel",
            defaultMessage: "Rovo Dev logo"
        }),
        mobileCtaText: intl.formatMessage({
            id: "RovoDevNav.tryItFree",
            defaultMessage: "Try it Free"
        }),
        navigationTrynowCtaText: intl.formatMessage({
            id: "RovoDevNav.tryItFree",
            defaultMessage: "Try it Free"
        }),
        mobileCtaUrl: signupLink,
        mobileLogo: logo,
        productPageNavLinks: [
            {
                globalLinksKey: "pricing",
                linkText: intl.formatMessage({
                    id: "RovoDevNav.pricing",
                    defaultMessage: "Pricing"
                }),
                hasSubnav: false,
                productKey: "rovo-dev",
                href: pricingHref
            },
            {
                globalLinksKey: "documentation",
                linkText: intl.formatMessage({
                    id: "RovoDevNav.documentation",
                    defaultMessage: "Documentation"
                }),
                hasSubnav: false,
                productKey: "rovo-dev",
                href: documentationHref
            }
        ],
        navigationTrynowCtaUrl: signupLink,
        mobileLinksSections: [
            {
                mobileLinkKey: "mobile-rovo-dev",
                mobileLinksProps: [
                    {
                        globalLinksKey: "pricing",
                        linkText: intl.formatMessage({
                            id: "RovoDevNav.pricing",
                            defaultMessage: "Pricing"
                        }),
                        hasSubnav: false,
                        productKey: "rovo-dev",
                        href: pricingHref
                    },
                    {
                        globalLinksKey: "documentation",
                        linkText: intl.formatMessage({
                            id: "RovoDevNav.documentation",
                            defaultMessage: "Documentation"
                        }),
                        hasSubnav: false,
                        productKey: "rovo-dev",
                        href: documentationHref
                    }
                ]
            }
        ]
    });
};

});

parcelRegister("52gYK", function(module, exports) {

$parcel$export(module.exports, "OptionalSiteSelectorContextProvider", function () { return $f7786a656b77b76d$export$ef73016e54e00d81; });

var $loA2J = parcelRequire("loA2J");

var $gkV6l = parcelRequire("gkV6l");
const $f7786a656b77b76d$export$ef73016e54e00d81 = (props)=>{
    const { siteSelectorProductKey: siteSelectorProductKey, siteSelectorAnalyticsPrefix: siteSelectorAnalyticsPrefix, children: children } = props;
    if (!siteSelectorProductKey) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $gkV6l.SiteSelectorContextProvider), {
        productKey: siteSelectorProductKey,
        analyticsPrefix: siteSelectorAnalyticsPrefix !== null && siteSelectorAnalyticsPrefix !== void 0 ? siteSelectorAnalyticsPrefix : siteSelectorProductKey,
        children: children
    });
};

});



parcelRegister("bMQWw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("k3kI6")).default; });

var $k3kI6 = parcelRequire("k3kI6");

});
parcelRegister("k3kI6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fedb85474fab90c9$export$2e2bcd8739ae039; });
/* pagination.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $8LSiz = parcelRequire("8LSiz");
const $fedb85474fab90c9$var$centerStyles = null;
const $fedb85474fab90c9$var$UniformPagination = (props)=>{
    // Generate pages array from total pages
    const pagesArray = Array.from({
        length: props.pages
    }, (_, i)=>i + 1); // For now, using defaults until page logic is implemented
    const selectedIndex = 0;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8LSiz.Pagination), {
            pages: pagesArray,
            selectedIndex: selectedIndex
        })
    });
};
var $fedb85474fab90c9$export$2e2bcd8739ae039 = $fedb85474fab90c9$var$UniformPagination;

});


parcelRegister("5TIC4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("6Lfpq")).default; });

var $6Lfpq = parcelRequire("6Lfpq");

});
parcelRegister("6Lfpq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67ea48e347ad7dcf$export$2e2bcd8739ae039; });
/* personalization-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");

var $g9kzu = parcelRequire("g9kzu");

var $5ohHq = parcelRequire("5ohHq");

var $9iWJ8 = parcelRequire("9iWJ8");

var $gAJUc = parcelRequire("gAJUc");

var $kNCWT = parcelRequire("kNCWT");

var $jFQmg = parcelRequire("jFQmg");

var $1mZZG = parcelRequire("1mZZG");

var $bQiYD = parcelRequire("bQiYD");
var $67ea48e347ad7dcf$var$VariantsStatus;
(function(VariantsStatus) {
    VariantsStatus["NO_VARIANT_MATCH"] = "no_variant_match";
    VariantsStatus["VARIANTS_AVAILABLE"] = "variants_available";
    VariantsStatus["FETCHING_SEGMENTS"] = "fetching_segments";
    VariantsStatus["SEGMENT_FETCH_ERROR"] = "segment_fetch_error";
    VariantsStatus["MISSING_USER_SEGMENTS"] = "missing_user_segments";
    VariantsStatus["PERSONALIZATION_DISABLED"] = "personalization_disabled";
    VariantsStatus["NOT_ENROLLED_IN_EXPERIMENT"] = "not_enrolled_in_experiment";
})($67ea48e347ad7dcf$var$VariantsStatus || ($67ea48e347ad7dcf$var$VariantsStatus = {}));
const $67ea48e347ad7dcf$var$VariantSelector = (props)=>{
    return(// this should only be one item, but the SlotWrapper expects an array
    /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
        children: props.items.map((item, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                children: item
            }, index))
    }));
}; // Helper function to render default slot
const $67ea48e347ad7dcf$var$renderDefaultSlot = (variantStatus, setRenderMessage)=>{
    const messages = {
        ["no_variant_match"]: "No variants match. Rendering Default",
        ["missing_user_segments"]: "No User Segments acquired. Rendering Default",
        ["personalization_disabled"]: "Personalization is disabled. Rendering Default",
        ["segment_fetch_error"]: "Error fetching User Segments. Rendering Default",
        ["not_enrolled_in_experiment"]: "User not enrolled in experiment. Rendering Default",
        ["fetching_segments"]: "Fetching User Segments. Temporarily rendering Default",
        // never invoked, but needed to satisfy the type system s
        ["variants_available"]: ""
    };
    setRenderMessage(messages[variantStatus]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: "default",
        wrapperComponent: $67ea48e347ad7dcf$var$VariantSelector
    });
}; // Helper function to find matching variant index
const $67ea48e347ad7dcf$var$findMatchingVariant = (variantCandidates, personalizationSegmentValues)=>{
    if (!personalizationSegmentValues) return -1;
    return variantCandidates.findIndex((variantCandidate)=>{
        var _variantCandidate_parameters_personalizationSegment, _variantCandidate_parameters;
        // all user segments specified by the Author in the variant (product, job function, domain type, etc.)
        const segments = (_variantCandidate_parameters = variantCandidate.parameters) === null || _variantCandidate_parameters === void 0 ? void 0 : (_variantCandidate_parameters_personalizationSegment = _variantCandidate_parameters["personalizationSegment"]) === null || _variantCandidate_parameters_personalizationSegment === void 0 ? void 0 : _variantCandidate_parameters_personalizationSegment.value; // check if all segments match the user's profile
        return segments.every(({ segmentType: segmentType, value: segmentTargets })=>{
            const userValueForThisSegment = personalizationSegmentValues[segmentType]; // if the user doesn't have a value for this segment, it can't match
            if (!userValueForThisSegment) return false;
             // handle owned products differently, since it's an array of products.
            if (segmentType === (0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS) // we want to check if any of the user's owned products match one of the author-defined segment's value
            return segmentTargets.some((product)=>userValueForThisSegment.includes(product));
             // for all other single-valued segments, simply check if the user's value
            return segmentTargets.includes(userValueForThisSegment || "");
        });
    });
}; // Helper function to get final personalization values
const $67ea48e347ad7dcf$var$getFinalPersonalizationValues = (userSegments, overrides)=>{
    const finalValues = (0, $6iHNw._)((0, $7Knp0._)({}, userSegments, (overrides === null || overrides === void 0 ? void 0 : overrides.useOverrides) ? overrides : {}), {
        useOverrides: (overrides === null || overrides === void 0 ? void 0 : overrides.useOverrides) || false,
        enrollInExperiment: (overrides === null || overrides === void 0 ? void 0 : overrides.enrollInExperiment) || false
    });
    return finalValues;
};
const $67ea48e347ad7dcf$var$ExperimentallyPersonalizedSection = ({ experimentId: experimentId, setVariantStatus: setVariantStatus, overrides: overrides, setRenderMessage: setRenderMessage, variantComponent: variantComponent })=>{
    const experimentStatus = (0, $9iWJ8.useExperiment)({
        experimentName: experimentId,
        parameterName: "enrolled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: (value)=>typeof value === "boolean"
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Personalization Experiment - configured in Uniform",
            expectedReleaseDate: "unknown - configured in Uniform",
            expectedRuntime: "unknown - configured in Uniform",
            context: {
                urls: []
            }
        }
    });
    const showTreatment = experimentStatus.type === "enrolled" && experimentStatus.value;
    (0, $iSvIT.useEffect)(()=>{
        if (!showTreatment && !(overrides === null || overrides === void 0 ? void 0 : overrides.enrollInExperiment)) {
            if (setVariantStatus) setVariantStatus("not_enrolled_in_experiment");
        }
    }, [
        showTreatment,
        overrides === null || overrides === void 0 ? void 0 : overrides.enrollInExperiment,
        setVariantStatus
    ]);
    if (!showTreatment && !(overrides === null || overrides === void 0 ? void 0 : overrides.enrollInExperiment)) return $67ea48e347ad7dcf$var$renderDefaultSlot("not_enrolled_in_experiment", setRenderMessage);
    return variantComponent;
}; // Helper function to validate personalization prerequisites
const $67ea48e347ad7dcf$var$validatePersonalizationPrerequisites = (shouldPersonalize, userSegments, userSegmentStatus, error, overrides)=>{
    if (userSegmentStatus !== "complete") return {
        isValid: false,
        status: "fetching_segments"
    };
    if (!shouldPersonalize) return {
        isValid: false,
        status: "personalization_disabled"
    };
    if (!userSegments) return {
        isValid: false,
        status: "missing_user_segments"
    };
    if (error && !(overrides === null || overrides === void 0 ? void 0 : overrides.useOverrides)) return {
        isValid: false,
        status: "segment_fetch_error"
    };
    return {
        isValid: true
    };
}; // Helper function to create variant component
const $67ea48e347ad7dcf$var$createVariantComponent = (chosenVariantIndex)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: "variants",
        wrapperComponent: (slotProps)=>$67ea48e347ad7dcf$var$VariantSelector((0, $6iHNw._)((0, $7Knp0._)({}, slotProps), {
                items: [
                    slotProps.items[chosenVariantIndex]
                ]
            }))
    }); // Helper function to set render message for variant
const $67ea48e347ad7dcf$var$setVariantRenderMessage = (variantCandidates, chosenVariantIndex, overrides, setRenderMessage)=>{
    const variantName = $67ea48e347ad7dcf$var$getCurrentVariantName(variantCandidates, chosenVariantIndex);
    const sourceType = (overrides === null || overrides === void 0 ? void 0 : overrides.useOverrides) ? "Overrides" : "User Segments";
    setRenderMessage(`Rendering "${variantName}" Variant based on ${sourceType}`);
};
const $67ea48e347ad7dcf$var$getCurrentVariantName = (variantCandidates, chosenVariantIndex)=>{
    var _variantCandidates_chosenVariantIndex_parameters_variantName, _variantCandidates_chosenVariantIndex_parameters, _variantCandidates_chosenVariantIndex;
    return ((_variantCandidates_chosenVariantIndex = variantCandidates[chosenVariantIndex]) === null || _variantCandidates_chosenVariantIndex === void 0 ? void 0 : (_variantCandidates_chosenVariantIndex_parameters = _variantCandidates_chosenVariantIndex.parameters) === null || _variantCandidates_chosenVariantIndex_parameters === void 0 ? void 0 : (_variantCandidates_chosenVariantIndex_parameters_variantName = _variantCandidates_chosenVariantIndex_parameters["variantName"]) === null || _variantCandidates_chosenVariantIndex_parameters_variantName === void 0 ? void 0 : _variantCandidates_chosenVariantIndex_parameters_variantName.value) || "unknown";
};
const $67ea48e347ad7dcf$var$PersonalizedSection = (props)=>{
    var _composition_data;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const analyticsClient = (0, $jFQmg.useAnalyticsClient)();
    const [selectedVariantKey, setSelectedVariantKey] = (0, $iSvIT.useState)(null);
    const [variantStatus, setVariantStatus] = (0, $iSvIT.useState)(null);
    const [renderedExperience, setRenderedExperience] = (0, $iSvIT.useState)(null);
    const { data: userSegments, error: error, status: userSegmentStatus } = (0, $bQiYD.useUserSegments)();
    const shouldPersonalize = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).uniformPersonalizationEnabled);
    const composition = (0, $aiugz.useUniformCurrentComposition)();
    const compositionId = composition === null || composition === void 0 ? void 0 : (_composition_data = composition.data) === null || _composition_data === void 0 ? void 0 : _composition_data._id; // Memoize slots to prevent infinite loops
    const variantSlots = (0, $iSvIT.useMemo)(()=>{
        var _props_component_slots;
        var _props_component_slots_variants;
        return (_props_component_slots_variants = (_props_component_slots = props.component.slots) === null || _props_component_slots === void 0 ? void 0 : _props_component_slots["variants"]) !== null && _props_component_slots_variants !== void 0 ? _props_component_slots_variants : [];
    }, [
        props.component.slots
    ]); // Send metrics once when variant changes
    (0, $iSvIT.useEffect)(()=>{
        const validation = $67ea48e347ad7dcf$var$validatePersonalizationPrerequisites(shouldPersonalize, userSegments, userSegmentStatus, error, props.overrides);
        if (!validation.isValid) {
            setSelectedVariantKey("default_experience");
            setVariantStatus(validation.status);
            setRenderedExperience($67ea48e347ad7dcf$var$renderDefaultSlot(validation.status, props.setRenderMessage));
            return;
        } // Process personalization logic
        const personalizationValues = $67ea48e347ad7dcf$var$getFinalPersonalizationValues(userSegments, props.overrides);
        const chosenVariantIndex = $67ea48e347ad7dcf$var$findMatchingVariant(variantSlots, personalizationValues); // Check if variant was found
        if (chosenVariantIndex < 0) {
            setSelectedVariantKey("default_experience");
            setVariantStatus("no_variant_match");
            setRenderedExperience($67ea48e347ad7dcf$var$renderDefaultSlot("no_variant_match", props.setRenderMessage));
            return;
        }
        const variantName = $67ea48e347ad7dcf$var$getCurrentVariantName(variantSlots, chosenVariantIndex);
        setSelectedVariantKey(variantName);
        setVariantStatus("variants_available");
        $67ea48e347ad7dcf$var$setVariantRenderMessage(variantSlots, chosenVariantIndex, props.overrides, props.setRenderMessage);
        const variantComponent = $67ea48e347ad7dcf$var$createVariantComponent(chosenVariantIndex);
        setRenderedExperience(variantComponent); // Handle experimental personalization
        if (props.experimentId) setRenderedExperience(/*#__PURE__*/ (0, $loA2J.jsx)($67ea48e347ad7dcf$var$ExperimentallyPersonalizedSection, {
            containerName: props.containerName,
            setRenderMessage: props.setRenderMessage,
            setVariantStatus: setVariantStatus,
            experimentId: props.experimentId,
            variantComponent: variantComponent,
            overrides: props.overrides,
            component: props.component
        }));
        return;
    }, [
        error,
        props.overrides,
        props.setRenderMessage,
        props.experimentId,
        props.containerName,
        props.component,
        shouldPersonalize,
        userSegmentStatus,
        userSegments,
        variantSlots,
        setVariantStatus
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (!selectedVariantKey || !variantStatus) return;
        if (analyticsClient) createAnalyticsEvent({
            name: "waePersonalizationVariantRender",
            action: "personalizationVariantRender",
            actionSubject: "uniformPage",
            eventType: "screen",
            source: window.location.pathname,
            attributes: {
                containerName: props.containerName,
                path: window.location.pathname,
                compositionId: compositionId,
                variantName: selectedVariantKey,
                status: variantStatus
            }
        }).fire();
    }, [
        compositionId,
        createAnalyticsEvent,
        selectedVariantKey,
        props.containerName,
        variantStatus,
        analyticsClient
    ]);
    return renderedExperience;
};
const $67ea48e347ad7dcf$var$UniformPersonalizationContainer = (props)=>{
    const isProd = (0, $kNCWT.isProduction)();
    const [overrides, setOverrides] = (0, $iSvIT.useState)({
        useOverrides: false,
        enrollInExperiment: false
    });
    const [renderMessage, setRenderMessage] = (0, $iSvIT.useState)("");
    const [isContainerHovered, setIsContainerHovered] = (0, $iSvIT.useState)(false);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        onMouseEnter: !isProd ? ()=>setIsContainerHovered(true) : undefined,
        onMouseLeave: !isProd ? ()=>setIsContainerHovered(false) : undefined,
        className: (0, $esG4f.default)([
            "_kqswh2mm _19itv6l3 _2rko1m5y _1yt4u2gc _v564u973 _1qs911pv"
        ]),
        style: {
            "--_1k5ts5z": (0, $43MIc.default)(!isProd && isContainerHovered ? `2px solid ${(0, $5ohHq.wacToken)("color.extended.blue300")}` : "2px solid transparent"),
            "--_1r0zder": (0, $43MIc.default)(!isProd ? (0, $5ohHq.wacToken)("corner.radius.card") : "0"),
            "--_i1pnuw": (0, $43MIc.default)(!isProd ? "border-color 0.2s ease" : "none"),
            "--_hiqpr4": (0, $43MIc.default)(!isProd ? {
                border: `2px solid ${(0, $5ohHq.wacToken)("color.extended.blue300")}`
            } : {})
        },
        children: [
            !isProd && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1mZZG.PersonalizationOverrideControls), {
                values: overrides,
                setValues: setOverrides,
                renderMessage: renderMessage,
                isContainerHovered: isContainerHovered
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)($67ea48e347ad7dcf$var$PersonalizedSection, (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                overrides: overrides,
                setRenderMessage: setRenderMessage,
                experimentId: props.experimentId
            }))
        ]
    });
};
var $67ea48e347ad7dcf$export$2e2bcd8739ae039 = $67ea48e347ad7dcf$var$UniformPersonalizationContainer;

});
parcelRegister("1mZZG", function(module, exports) {

$parcel$export(module.exports, "PersonalizationOverrideControls", function () { return $1acdd970fef71b54$export$3509149ef9c5f46; });
/* personalization-controls.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("fYEXy");
var $53o08 = parcelRequire("53o08");
parcelRequire("9REvE");
var $2m1xf = parcelRequire("2m1xf");

var $9Yq3D = parcelRequire("9Yq3D");

var $5ohHq = parcelRequire("5ohHq");

var $bQiYD = parcelRequire("bQiYD");
const $1acdd970fef71b54$var$JOB_FUNCTION = [
    {
        value: "engineering",
        label: "Engineering"
    },
    {
        value: "product management",
        label: "Product Management"
    },
    {
        value: "design",
        label: "Design"
    },
    {
        value: "data science",
        label: "Data Science"
    },
    {
        value: "marketing",
        label: "Marketing"
    },
    {
        value: "sales",
        label: "Sales"
    },
    {
        value: "human resources",
        label: "Human Resources"
    },
    {
        value: "finance",
        label: "Finance"
    },
    {
        value: "operations",
        label: "Operations"
    },
    {
        value: "legal",
        label: "Legal"
    },
    {
        value: "customer success",
        label: "Customer Success"
    },
    {
        value: "executive",
        label: "Executive"
    },
    {
        value: "other",
        label: "Other"
    }
];
const $1acdd970fef71b54$var$PersonalizationControlPanel = ({ values: values, handleSelectChange: handleSelectChange })=>{
    var _JOB_FUNCTION_find;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulpu2gc"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                onClick: (e)=>{
                    const target = e.target;
                    if (target.type === "checkbox") handleSelectChange("enrollInExperiment", target.checked);
                },
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleSelectChange("enrollInExperiment", !values.enrollInExperiment);
                    }
                },
                role: "button",
                tabIndex: 0,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $53o08.Checkbox), {
                    id: "enrollInExperiment",
                    name: "enrollInExperiment",
                    value: "enrollInExperiment",
                    label: "Enroll in Experiment Treatment?",
                    checked: values.enrollInExperiment
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                onClick: (e)=>{
                    const target = e.target;
                    if (target.type === "checkbox") handleSelectChange("useOverrides", target.checked);
                },
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleSelectChange("useOverrides", !values.useOverrides);
                    }
                },
                role: "button",
                tabIndex: 0,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $53o08.Checkbox), {
                    id: "useOverrides",
                    name: "useOverrides",
                    value: "useOverrides",
                    label: "Use Overrides?",
                    checked: values.useOverrides
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2m1xf.DropdownSelector), {
                    name: (0, $bQiYD.UserSegmentTypes).LOGIN_STATUS,
                    id: (0, $bQiYD.UserSegmentTypes).LOGIN_STATUS,
                    label: "Login Status",
                    options: [
                        {
                            value: "loggedIn",
                            label: "Logged In"
                        },
                        {
                            value: "loggedOut",
                            label: "Logged Out"
                        }
                    ],
                    defaultValue: {
                        value: values[(0, $bQiYD.UserSegmentTypes).LOGIN_STATUS] || "",
                        label: values[(0, $bQiYD.UserSegmentTypes).LOGIN_STATUS] === "loggedIn" ? "Logged In" : "Logged Out"
                    },
                    onChangeHandler: (value)=>{
                        handleSelectChange((0, $bQiYD.UserSegmentTypes).LOGIN_STATUS, value);
                    }
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9Yq3D.TextInput), {
                    id: "geolocation",
                    name: (0, $bQiYD.UserSegmentTypes).GEOLOCATION,
                    label: "Geolocation",
                    placeholder: "e.g. US, UK, AU",
                    value: values[(0, $bQiYD.UserSegmentTypes).GEOLOCATION],
                    onChangeHandler: (value)=>{
                        handleSelectChange((0, $bQiYD.UserSegmentTypes).GEOLOCATION, value);
                    }
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2m1xf.DropdownSelector), {
                    name: (0, $bQiYD.UserSegmentTypes).JOB_FUNCTION,
                    id: (0, $bQiYD.UserSegmentTypes).JOB_FUNCTION,
                    label: "Job Function",
                    options: $1acdd970fef71b54$var$JOB_FUNCTION.map((entry)=>({
                            value: entry.value,
                            label: entry.label
                        })),
                    defaultValue: {
                        value: values[(0, $bQiYD.UserSegmentTypes).JOB_FUNCTION] || "",
                        label: ((_JOB_FUNCTION_find = $1acdd970fef71b54$var$JOB_FUNCTION.find((e)=>{
                            return e.value === values[(0, $bQiYD.UserSegmentTypes).JOB_FUNCTION];
                        })) === null || _JOB_FUNCTION_find === void 0 ? void 0 : _JOB_FUNCTION_find.label) || "test"
                    },
                    onChangeHandler: (value)=>{
                        handleSelectChange((0, $bQiYD.UserSegmentTypes).JOB_FUNCTION, value);
                    }
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2m1xf.DropdownSelector), {
                    name: (0, $bQiYD.UserSegmentTypes).DOMAIN_TYPE,
                    id: (0, $bQiYD.UserSegmentTypes).DOMAIN_TYPE,
                    label: "Domain Type",
                    options: [
                        {
                            value: "BUSINESS",
                            label: "Business"
                        },
                        {
                            value: "PERSONAL",
                            label: "Personal"
                        }
                    ],
                    defaultValue: {
                        value: values[(0, $bQiYD.UserSegmentTypes).DOMAIN_TYPE] || "",
                        label: values[(0, $bQiYD.UserSegmentTypes).DOMAIN_TYPE] === "BUSINESS" ? "Business" : "Personal"
                    },
                    onChangeHandler: (value)=>{
                        handleSelectChange((0, $bQiYD.UserSegmentTypes).DOMAIN_TYPE, value);
                    }
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                        htmlFor: (0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS,
                        className: (0, $esG4f.default)([
                            "_1e0c1ule _syaz5k8o _1wyboqnp _vwz41gnr _6rth1b66 _y3gn1e5h"
                        ]),
                        style: {
                            "--_1ntr8rj": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark200"))
                        },
                        children: "Owned Products"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _1n261g80 _zulp1b66 _1yt4u2gc _19it1nj5 _2rko1y44 _1tke1ylp _4cvr1h6o"
                        ]),
                        style: {
                            "--_19aes6n": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark700"))
                        },
                        children: [
                            {
                                value: "jira-software",
                                label: "Jira"
                            },
                            {
                                value: "confluence",
                                label: "Confluence"
                            },
                            {
                                value: "bitbucket",
                                label: "Bitbucket"
                            },
                            {
                                value: "compass",
                                label: "Compass"
                            },
                            {
                                value: "jira-product-discovery",
                                label: "Jira Product Discovery"
                            },
                            {
                                value: "statuspage",
                                label: "Statuspage"
                            },
                            {
                                value: "loom",
                                label: "Loom"
                            },
                            {
                                value: "compass",
                                label: "Compass"
                            },
                            {
                                value: "rovo.ondemand",
                                label: "Rovo"
                            },
                            {
                                value: "trello",
                                label: "Trello"
                            }
                        ].map((product)=>{
                            var _values_UserSegmentTypes_OWNED_PRODUCTS;
                            const isSelected = Array.isArray(values[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS]) ? (_values_UserSegmentTypes_OWNED_PRODUCTS = values[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS]) === null || _values_UserSegmentTypes_OWNED_PRODUCTS === void 0 ? void 0 : _values_UserSegmentTypes_OWNED_PRODUCTS.includes(product.value) : values[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS] === product.value;
                            return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                type: "button",
                                onClick: ()=>{
                                    const currentProducts = Array.isArray(values[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS]) ? values[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS] || [] : values[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS] ? [
                                        values[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS]
                                    ] : [];
                                    let updatedProducts;
                                    if (isSelected) updatedProducts = currentProducts.filter((p)=>p !== product.value);
                                    else updatedProducts = [
                                        ...currentProducts,
                                        product.value
                                    ];
                                    handleSelectChange((0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS, updatedProducts);
                                },
                                className: (0, $esG4f.default)([
                                    "_1yt418iy _bfhkl9kt _syaz1o9l _19itglyw _2rko1y44 _80omtlke _1wyboxwj _irr31nu1"
                                ]),
                                style: {
                                    "--_3kul7g": (0, $43MIc.default)(isSelected ? (0, $5ohHq.wacToken)("color.extended.blue300") : (0, $5ohHq.wacToken)("color.neutral.light200")),
                                    "--_8buy8y": (0, $43MIc.default)(isSelected ? (0, $5ohHq.wacToken)("color.neutral.light0") : (0, $5ohHq.wacToken)("color.neutral.dark200")),
                                    "--_1pblbmt": (0, $43MIc.default)(isSelected ? (0, $5ohHq.wacToken)("color.extended.blue400") : (0, $5ohHq.wacToken)("color.neutral.light300"))
                                },
                                children: product.label
                            }, product.value);
                        })
                    })
                ]
            })
        ]
    });
};
const $1acdd970fef71b54$export$3509149ef9c5f46 = ({ values: values, setValues: setValues, renderMessage: renderMessage, isContainerHovered: isContainerHovered })=>{
    const [isVisible, setIsVisible] = (0, $iSvIT.useState)(false);
    const handleSelectChange = (field, value)=>{
        setValues((0, $6iHNw._)((0, $7Knp0._)({}, values), {
            [field]: value
        }));
    }; // Only show the dog-ear when container is hovered
    if (!isContainerHovered) return null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        onMouseEnter: ()=>setIsVisible(true),
        onMouseLeave: ()=>setIsVisible(false),
        role: "button",
        tabIndex: 0,
        className: (0, $esG4f.default)([
            "_kqswstnw _152t12gs _1e0212gs _1bsb1lmt _4t3i1n85 _1pbyzo7u"
        ]),
        style: {
            "--_6q42yv": (0, $43MIc.default)(isVisible ? "320px" : "auto"),
            "--_1j9tq0n": (0, $43MIc.default)(isVisible ? "400px" : "auto")
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                title: "Personalization Controls",
                className: (0, $esG4f.default)([
                    "_kqswstnw _152tidpf _1e02idpf _1pby3ced _1bsbckbl _4t3ickbl _80omtlke _v5641hdd _tzy413ze _t9ec13e0"
                ]),
                style: {
                    "--_ymxjy5": (0, $43MIc.default)(isContainerHovered ? 1 : 0),
                    "--_51sge": (0, $43MIc.default)(isContainerHovered ? "scale(1)" : "scale(0.8)")
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_kqswstnw _152tidpf _1e02idpf _1bsbckbl _4t3ickbl _bfhk1mxb _2rko1dia _v5641hdd _16qs1s6v _irr3cqtm"
                        ]),
                        style: {
                            "--_9qtbdu": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue300")),
                            "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
                            "--_1mbq9ci": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark800")),
                            "--_r4erkq": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue400"))
                        }
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_kqswstnw _152t1ssb _1e021ssb _t9ec1ooe _syazcd5j _1wyb7vkz _vwz4kb7n _lcxvglyw _w19j12yu"
                        ]),
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                            "--_1mbq9ci": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark800"))
                        },
                        children: "\uD83D\uDC65"
                    })
                ]
            }),
            isVisible && /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _152t1ex1 _1e02ftgi _1bsb1178 _1pby1rya _1yt4pxbi _bfhkcd5j _2rkovwyg _16qsswb1 _19it1nj5"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                    "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
                    "--_1mbq9ci": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark800")),
                    "--_19aes6n": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark700"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                        className: (0, $esG4f.default)([
                            "_18s819a1 _1wybbzd7 _syaz5k8o"
                        ]),
                        style: {
                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                            "--_1ntr8rj": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark200"))
                        },
                        children: "Personalization Controls"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_18s8h2s3 _1yt412x7 _1wyboqnp _syazgc2p _bfhkjzbh _2rko1y44 _19itacih"
                        ]),
                        style: {
                            "--_1jncskl": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark300")),
                            "--_1bsbd8h": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.yellow100")),
                            "--_1oxqp4m": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.yellow300"))
                        },
                        children: "These controls and the blue border are only visible in pre-production environments"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($1acdd970fef71b54$var$PersonalizationControlPanel, {
                        values: values,
                        handleSelectChange: handleSelectChange
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1pfhutpp _1yt4u2gc _bfhk1ybm _syazgc2p"
                        ]),
                        style: {
                            "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100")),
                            "--_1jncskl": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark300"))
                        },
                        children: renderMessage
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("fYEXy", function(module, exports) {
$parcel$export(module.exports, "Checkbox", function () { return (parcelRequire("53o08")).Checkbox; });

var $53o08 = parcelRequire("53o08");

});
parcelRegister("53o08", function(module, exports) {

$parcel$export(module.exports, "Checkbox", function () { return $72b2951a2c888331$export$48513f6b9f8ce62d; });
/* checkbox.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $72b2951a2c888331$var$textStyle = null;
const $72b2951a2c888331$var$containerStyle = null;
const $72b2951a2c888331$var$checkboxStyle = null;
const $72b2951a2c888331$export$48513f6b9f8ce62d = (props)=>{
    const { id: id, name: name, value: value, label: label, color: color = "light", accentColor: accentColor = "#0065ff", disabled: disabled, testId: testId, checked: checked, indeterminate: indeterminate, className: className } = props;
    const ref = (0, $iSvIT.useRef)(null);
    (0, $iSvIT.useEffect)(()=>{
        if (ref.current) {
            if (indeterminate) ref.current.indeterminate = indeterminate;
            else ref.current.checked = checked || false;
        }
    }, [
        props
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _1e0c1txw _4cvr1y6m _ca0qyh40 _u5f3idpf _n3tdyh40 _19bvidpf _vwz4bs82",
            className
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                id: id,
                type: "checkbox",
                "data-testid": testId ? testId : id,
                style: {
                    accentColor: accentColor
                },
                ref: ref,
                name: name,
                value: value,
                disabled: disabled || false,
                className: (0, $esG4f.default)([
                    "_s7n4nkob _1bsb7vkz _4t3i7vkz _19pk1y44 _2hwxidpf _otyridpf _18u0idpf _1372tlke _d0altlke _jomr3739 _irr33739"
                ])
            }),
            label && /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                style: {
                    color: color == "dark" ? "#172b4d" : "#5e6c84"
                },
                htmlFor: id,
                className: (0, $esG4f.default)([
                    "_80omtlke _1wyboxwj _k48p1nn1 _ahbqftgi"
                ]),
                children: label
            })
        ]
    });
};

});





parcelRegister("1fx7M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("hCb7M")).default; });

var $hCb7M = parcelRequire("hCb7M");

});
parcelRegister("hCb7M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e24a006ad056402e$export$2e2bcd8739ae039; });
/* price-calculator.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $3ayMq = parcelRequire("3ayMq");

var $5ohHq = parcelRequire("5ohHq");

var $jnh2H = parcelRequire("jnh2H");

var $gEOac = parcelRequire("gEOac");
parcelRequire("MciJy");
var $1rXz0 = parcelRequire("1rXz0");
var $chlmU = parcelRequire("chlmU");
parcelRequire("MciJy");
var $85vSY = parcelRequire("85vSY");
parcelRequire("hqKpV");
var $3ItZP = parcelRequire("3ItZP");

var $bd3Mi = parcelRequire("bd3Mi");

var $bU2dC = parcelRequire("bU2dC");

var $5YjMr = parcelRequire("5YjMr");

var $hmeL1 = parcelRequire("hmeL1");
const $e24a006ad056402e$var$RecommendationTracker = ({ plan: plan, index: index, onRecommendedChange: onRecommendedChange })=>{
    const state = (0, $gEOac.useCalculationState)({
        offeringSku: plan.fields.sku
    });
    (0, $iSvIT.useEffect)(()=>{
        onRecommendedChange(index, state.recommended);
    }, [
        index,
        state.recommended,
        onRecommendedChange
    ]);
    return null;
};
const $e24a006ad056402e$var$PricingCalculatorContent = ({ comparePlansData: comparePlansData, urlSlug: urlSlug, selectedCardIndex: selectedCardIndex, setSelectedCardIndex: setSelectedCardIndex, disclaimer: disclaimer, omitInputs: omitInputs, numSections: numSections })=>{
    const intl = (0, $f6qj2.default)();
    const handleRecommendedChange = (0, $iSvIT.useCallback)((index, isRecommended)=>{
        if (isRecommended) setSelectedCardIndex(index);
    }, [
        setSelectedCardIndex
    ]);
    const unitsLabel = $e24a006ad056402e$var$useUnitsLabel(comparePlansData);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: [
            comparePlansData.length > 1 && comparePlansData.map((planData, index)=>/*#__PURE__*/ (0, $loA2J.jsx)($e24a006ad056402e$var$RecommendationTracker, {
                    plan: planData,
                    index: index,
                    onRecommendedChange: handleRecommendedChange
                }, `tracker-${planData.fields.sku}`)),
            !omitInputs && /*#__PURE__*/ (0, $loA2J.jsx)((0, $85vSY.PricingCalculatorInputs), {
                unitCountLabel: intl.formatMessage($5YjMr.units.teamSizePrompt),
                unitsLabel: unitsLabel,
                dataProductKey: (0, $3ayMq.urlSlugToDataProductKey)[urlSlug]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jnh2H.PricingCards // must set the number of sections here if removing the bottom section
            ), {
                // could also infer this from planData's getFeaturesList(fields.highlightedFeaturesContainer)
                numSections: numSections,
                selectedCardIndex: selectedCardIndex ? selectedCardIndex + 1 : 1,
                children: comparePlansData.map((planData, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $hmeL1.PricingCalculatorCard), {
                        showBannerText: comparePlansData.length > 1,
                        planData: planData,
                        urlSlug: urlSlug,
                        index: index,
                        isSingleCard: comparePlansData.length === 1
                    }, planData.fields.sku))
            }),
            disclaimer && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bah1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: (0, $esG4f.default)([
                        "_p12frdnh _k48p1nn1 _vwz4gktf _1wybdlk8 _syaz1hlo _1yt4utpp _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                    ]),
                    style: {
                        "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                    },
                    children: disclaimer
                })
            })
        ]
    });
};
const $e24a006ad056402e$var$disclaimerContainerCss = null;
const $e24a006ad056402e$var$disclaimerCss = null;
const $e24a006ad056402e$var$UniformPricingCalculator = (props)=>{
    var _comparePlansData__fields, _comparePlansData_;
    const { comparePlansData: comparePlansData, urlSlug: urlSlug, disclaimer: disclaimer } = props;
    const [selectedCardIndex, setSelectedCardIndex] = (0, $iSvIT.useState)(undefined);
    const providerResult = (0, $bU2dC.useProviderProps)({
        plans: comparePlansData,
        product: urlSlug
    });
    if (providerResult.status === "pending") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1rXz0.LoadingSpinner), {});
    if (providerResult.status === "error") return null; // todo: fire an event @bsparks GWP-6943
    if (providerResult.status !== "ready") return null; // this should never happen due to checks above, but fixes type error
    const { config: config, inputValues: inputValues } = providerResult.props;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bd3Mi.PricingCalculatorContextProvider), {
        config: config,
        inputValues: inputValues,
        children: /*#__PURE__*/ (0, $loA2J.jsx)($e24a006ad056402e$var$PricingCalculatorContent, {
            comparePlansData: comparePlansData,
            urlSlug: urlSlug,
            selectedCardIndex: selectedCardIndex,
            setSelectedCardIndex: setSelectedCardIndex,
            disclaimer: disclaimer,
            numSections: (0, $chlmU.getFeaturesList)(comparePlansData === null || comparePlansData === void 0 ? void 0 : (_comparePlansData_ = comparePlansData[0]) === null || _comparePlansData_ === void 0 ? void 0 : (_comparePlansData__fields = _comparePlansData_.fields) === null || _comparePlansData__fields === void 0 ? void 0 : _comparePlansData__fields.highlightedFeaturesContainer) === undefined ? 1 : 2,
            omitInputs: !config.billingCycleConfig.monthly && !config.billingCycleConfig.annual
        })
    });
};
var $e24a006ad056402e$export$2e2bcd8739ae039 = $e24a006ad056402e$var$UniformPricingCalculator;
function $e24a006ad056402e$var$useUnitsLabel(comparePlansData) {
    const intl = (0, $f6qj2.default)();
    const hasAgents = comparePlansData.some((plan)=>{
        return [
            (0, $3ItZP.serviceCollectionOfferingSkus).free,
            (0, $3ItZP.serviceCollectionOfferingSkus).standard,
            (0, $3ItZP.serviceCollectionOfferingSkus).premium,
            (0, $3ItZP.serviceCollectionOfferingSkus).enterprise
        ].includes(plan.fields.sku);
    });
    if (hasAgents) return intl.formatMessage($5YjMr.units.agentsUnitsLabel);
    return intl.formatMessage($5YjMr.units.usersUnitsLabel);
}

});
parcelRegister("3ayMq", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_PRODUCT_KEY", function () { return $ae0d591ec5522d40$export$b65b36d21c9a62a9; });
$parcel$export(module.exports, "urlSlugToDataProductKey", function () { return $ae0d591ec5522d40$export$9c59efe722f16a54; });
const $ae0d591ec5522d40$export$e36fc9e5c75fc113 = "jiraSoftware";
const $ae0d591ec5522d40$export$b65b36d21c9a62a9 = "confluence";
const $ae0d591ec5522d40$export$b24966420407028a = "strategyCollection";
const $ae0d591ec5522d40$export$46061d552ba374f4 = "teamworkCollection";
const $ae0d591ec5522d40$export$e7e2043098922532 = "compass";
const $ae0d591ec5522d40$export$6648fdba742bde2c = "serviceCollection";
const $ae0d591ec5522d40$export$b3fce742f95b2633 = "atlassianGuard";
const $ae0d591ec5522d40$export$9c59efe722f16a54 = {
    jira: $ae0d591ec5522d40$export$e36fc9e5c75fc113,
    confluence: $ae0d591ec5522d40$export$b65b36d21c9a62a9,
    strategy: $ae0d591ec5522d40$export$b24966420407028a,
    teamwork: $ae0d591ec5522d40$export$46061d552ba374f4,
    compass: $ae0d591ec5522d40$export$e7e2043098922532,
    service: $ae0d591ec5522d40$export$6648fdba742bde2c,
    guard: $ae0d591ec5522d40$export$b3fce742f95b2633
};

});

parcelRegister("jnh2H", function(module, exports) {

$parcel$export(module.exports, "PricingCards", function () { return $4ff5675958f7efd2$export$eb5ade451900e238; });
/* pricing-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");
const $4ff5675958f7efd2$export$eb5ade451900e238 = (props)=>{
    const { selectedCardIndex: selectedCardIndex, children: children, numSections: numSections = 2, hasCalloutSlot: hasCalloutSlot, hasRangeSlot: hasRangeSlot, hasLinkSlot: hasLinkSlot, hasBannerSlot: hasBannerSlot } = props;
    const numberOfChildren = (0, $iSvIT.Children).count(children);
    const getBorderProps = (childIndex, numSections)=>{
        if (numSections !== 1) return {};
        const isFirstChild = childIndex === 1;
        const isLastChild = childIndex === numberOfChildren;
        return {
            topSectionStyle: {
                borderStartEndRadius: isFirstChild ? "0" : undefined,
                borderEndEndRadius: isFirstChild ? "0px" : undefined,
                borderStartStartRadius: isLastChild ? "0" : undefined,
                borderEndStartRadius: isLastChild ? "0px" : undefined
            }
        };
    };
    const getSelectedBorderProps = (childIndex)=>{
        if (selectedCardIndex === undefined || selectedCardIndex !== childIndex) return {};
        const isFirstChild = childIndex === 1;
        const isLastChild = childIndex === numberOfChildren;
        const blackBorder = `1px solid ${(0, $5ohHq.wacToken)("color.primary.black")}`;
        return {
            topSectionStyle: {
                borderInlineEnd: blackBorder,
                borderInlineStart: blackBorder,
                borderBlockStart: blackBorder,
                borderLeftRadius: "10px",
                borderTopRightRadius: numSections === 1 && isLastChild ? "20px" : undefined,
                borderBottomLeftRadius: numSections === 1 && isLastChild ? "0px" : undefined,
                borderBottomRightRadius: numSections === 1 && isFirstChild ? "0px" : undefined,
                borderRadius: numSections === 1 && !isFirstChild && !isLastChild ? `0px` : undefined,
                borderBottom: numSections === 1 ? blackBorder : undefined
            },
            bottomSectionStyle: {
                borderInlineEnd: blackBorder,
                borderInlineStart: blackBorder,
                borderBlockEnd: blackBorder
            }
        };
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_2z054em0 _yv0e1579 _1e0c11p5 _wij21bp4 _1bsb1ns9 _ca0q1crf _u5f31crf _n3td1crf _19bv1crf _glte1ns9 _1ao8yzqy _37tx5os2 _11nh5os2 _157nyzqy _1r9zyzqy _qrtggktf _bzkjkpzv _bi30wrl1 _x330kpzv _1q1tyzqy _14bpgktf _uedh18ji _sqhgyzqy _1bs9gktf _1o36gktf _r0rayzqy _23ugyzqy _4ezvyzqy",
            numSections !== 1 && "_1aqcftgi",
            "_1mjb1txw _na0i1bp4 _1s4p1osq _1a7ngktf _1xwygktf _9h3lyzqy _9rrkyzqy _18xwyzqy",
            numSections === 1 && "_pmhu1txs _ukazftgi _i370yzqy _1635yzqy"
        ]),
        style: {
            "--_wcq253": (0, $43MIc.default)(numSections),
            "--_1j6te2o": (0, $43MIc.default)(numberOfChildren),
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400")),
            "--_vgqxqn": (0, $43MIc.default)(numSections === 1 ? `1px solid ${(0, $5ohHq.wacToken)("color.neutral.light400")}` : undefined),
            "--_3ro2cj": (0, $43MIc.default)(numSections === 1 ? "0px" : "20px"),
            "--_14z1886": (0, $43MIc.default)(numSections === 1 ? "0px" : undefined),
            "--_1ecp6y0": (0, $43MIc.default)(numSections === 1 ? "20px" : undefined)
        },
        children: (0, $iSvIT.Children).map(children, (child, index)=>{
            if (!child) return null;
            return /*#__PURE__*/ (0, $iSvIT.cloneElement)(child, (0, $7Knp0._)({
                key: index,
                hasCalloutSlot: hasCalloutSlot,
                hasRangeSlot: hasRangeSlot,
                hasLinkSlot: hasLinkSlot,
                hasBannerSlot: hasBannerSlot
            }, index + 1 === selectedCardIndex ? getSelectedBorderProps(index + 1) : getBorderProps(index + 1, numSections)));
        })
    });
};

});

parcelRegister("gEOac", function(module, exports) {

$parcel$export(module.exports, "useCalculationState", function () { return $7fc6bb143d8dc713$export$5ac48a71a65a15bc; });

var $j1tjc = parcelRequire("j1tjc");

var $iXUxi = parcelRequire("iXUxi");
function $7fc6bb143d8dc713$export$5ac48a71a65a15bc(props) {
    const { offeringSku: offeringSku } = props;
    return {
        billingCycle: (0, $j1tjc.useSelector)($iXUxi.getBillingCycle),
        isUnitCountAboveMaxThreshold: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.isUnitCountAboveMaxThreshold(ctx, offeringSku)),
        unitCountMin: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.getUnitCountMinThreshold(ctx, offeringSku)),
        isUnitCountBelowMinThreshold: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.isUnitCountBelowMinThreshold(ctx, offeringSku)),
        price: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.getFormattedPlanPrice(ctx, offeringSku)),
        recommended: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.isOfferingRecommended(ctx, offeringSku)),
        unitCount: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.getUnitCount(ctx)),
        unitTierLowerBound: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.getUnitTierLowerBound(ctx, offeringSku)),
        unitTierUpperBound: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.getUnitTierUpperBound(ctx, offeringSku)),
        unitsAvailableInTier: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.getUnitsAvailableInTier(ctx, offeringSku)),
        numberFormatLocale: (0, $j1tjc.useSelector)($iXUxi.getNumberFormatLocale)
    };
}

});
parcelRegister("j1tjc", function(module, exports) {

$parcel$export(module.exports, "useUnitCount", function () { return $58bc496f267c3520$export$856785685ba8098f; });
$parcel$export(module.exports, "useBillingCycle", function () { return $58bc496f267c3520$export$ada282ac321ec3b9; });
$parcel$export(module.exports, "useSelector", function () { return $58bc496f267c3520$export$2105062e25df4afe; });
$parcel$export(module.exports, "useCcpPricingData", function () { return $58bc496f267c3520$export$97374d6e908d2c; });

var $iSvIT = parcelRequire("iSvIT");

var $kxn2n = parcelRequire("kxn2n");

var $bd3Mi = parcelRequire("bd3Mi");
function $58bc496f267c3520$export$856785685ba8098f() {
    const { inputValues: inputValues, changeInputValues: changeInputValues } = (0, $bd3Mi.usePricingCalculatorContext)();
    const { unitCount: unitCount } = inputValues;
    const changeUnitCount = (value)=>{
        return changeInputValues({
            unitCount: value
        });
    };
    return [
        unitCount,
        changeUnitCount
    ];
}
function $58bc496f267c3520$export$ada282ac321ec3b9() {
    const { inputValues: inputValues, changeInputValues: changeInputValues } = (0, $bd3Mi.usePricingCalculatorContext)();
    const { billingCycle: billingCycle } = inputValues;
    const changeBillingCycle = (value)=>{
        return changeInputValues({
            billingCycle: value
        });
    };
    return [
        billingCycle,
        changeBillingCycle
    ];
}
function $58bc496f267c3520$export$f3fe2cc7a9497569() {
    return (0, $bd3Mi.usePricingCalculatorContext)().calculationResult;
}
const $58bc496f267c3520$export$2105062e25df4afe = (selector)=>{
    const context = (0, $bd3Mi.usePricingCalculatorContext)();
    return selector(context);
};
const $58bc496f267c3520$var$PRODUCT_CATALOG_DELIVERY_KEY = "nDQjfHDrrDfmPuccfIHYNMU3pSNCi1WOTRsI-q0igVU";
const $58bc496f267c3520$var$PRODUCT_CATALOG_SPACE = "3s3v3nq72la0";
const $58bc496f267c3520$export$97374d6e908d2c = (props)=>{
    const { offeringSkus: offeringSkus, ssrData: ssrData } = props;
    const { fetchData: fetchData, status: fetchStatus, prices: clientSideData } = (0, $kxn2n.useCCPPriceFinderData)(offeringSkus, $58bc496f267c3520$var$PRODUCT_CATALOG_DELIVERY_KEY, $58bc496f267c3520$var$PRODUCT_CATALOG_SPACE);
    const execFetch = (0, $iSvIT.useCallback)(async ()=>{
        await fetchData();
    }, []);
    (0, $iSvIT.useEffect)(()=>{
        if (!ssrData) execFetch();
    }, []);
    const status = $58bc496f267c3520$var$getCcpPricingDataStatus({
        hasSsrData: !!ssrData,
        fetchStatus: fetchStatus
    });
    return {
        data: ssrData !== null && ssrData !== void 0 ? ssrData : clientSideData,
        status: status
    };
};
function $58bc496f267c3520$var$getCcpPricingDataStatus(args) {
    const { fetchStatus: fetchStatus, hasSsrData: hasSsrData } = args;
    if (hasSsrData || fetchStatus === "complete") return "ready";
    if (fetchStatus === "idle" || fetchStatus === "fetching") return "pending";
    return "error";
}

});
parcelRegister("bd3Mi", function(module, exports) {

$parcel$export(module.exports, "usePricingCalculatorContext", function () { return $6a1ababb8109d222$export$cf6d27bb6377cd5b; });
$parcel$export(module.exports, "PricingCalculatorContextProvider", function () { return $6a1ababb8109d222$export$5a79cf764fd87278; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("8aCoe");
var $gz56C = parcelRequire("gz56C");
var $8XIVp = parcelRequire("8XIVp");
const $6a1ababb8109d222$var$PricingCalculatorContext = /*#__PURE__*/ (0, $iSvIT.createContext)(undefined);
const $6a1ababb8109d222$export$cf6d27bb6377cd5b = ()=>{
    const pricingCalculatorContext = (0, $iSvIT.useContext)($6a1ababb8109d222$var$PricingCalculatorContext);
    if (!pricingCalculatorContext) throw new Error("usePricingCalculatorContext must be used within a PricingCalculatorProvider");
    return pricingCalculatorContext;
};
const $6a1ababb8109d222$export$5a79cf764fd87278 = (props)=>{
    const [inputValues, setInputValues] = (0, $iSvIT.useState)(props.inputValues);
    const calculate = (0, $iSvIT.useCallback)((v)=>{
        const { config: config } = props;
        const productCalculationInputs = (0, $gz56C.getProductCalculationInputs)(config.planLimitConfigs, config.unitMinEnterprise, v.unitCount, v.billingCycle);
        return (0, $8XIVp.calculateProductPricing)(config.ccpPricingData, productCalculationInputs, config.currencyISOCode, config.localeISOCode);
    }, [
        props
    ]);
    const [calculationResult, setCalculationResult] = (0, $iSvIT.useState)(()=>calculate(inputValues));
    // Recalculate when config (including currency) changes
    (0, $iSvIT.useEffect)(()=>{
        const result = calculate(inputValues);
        setCalculationResult(result);
    }, [
        props.config,
        inputValues,
        calculate
    ]);
    const changeInputValues = (changes)=>{
        const nextValues = (0, $7Knp0._)({}, inputValues, changes);
        setInputValues(nextValues);
        const result = calculate(nextValues);
        setCalculationResult(result);
        return result;
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)($6a1ababb8109d222$var$PricingCalculatorContext.Provider, {
        value: {
            inputValues: inputValues,
            changeInputValues: changeInputValues,
            calculationResult: calculationResult,
            config: props.config
        },
        children: props.children
    });
};

});
parcelRegister("8aCoe", function(module, exports) {
$parcel$export(module.exports, "calculateProductPricing", function () { return (parcelRequire("8XIVp")).calculateProductPricing; });
$parcel$export(module.exports, "getProductCalculationInputs", function () { return (parcelRequire("gz56C")).getProductCalculationInputs; });
parcelRequire("8XIVp");
parcelRequire("gz56C");

});
parcelRegister("8XIVp", function(module, exports) {

$parcel$export(module.exports, "calculateProductPricing", function () { return $050627253a5a34fa$export$6c0aa9d51dade71d; });

var $7Knp0 = parcelRequire("7Knp0");

var $3FlK9 = parcelRequire("3FlK9");
const $050627253a5a34fa$export$6c0aa9d51dade71d = (ccpPricingData, productCalculationInputs, currencyISOCode, localeISOCode)=>{
    const productPricing = [];
    for (const planCalculationInputs of productCalculationInputs){
        const { ccpOfferingSKU: ccpOfferingSKU, numUnits: numUnits, period: period } = planCalculationInputs;
        const planPricing = (0, $3FlK9.calculatePlanPricing)({
            ccpPricingData: ccpPricingData,
            ccpOfferingSKU: ccpOfferingSKU,
            numUnits: numUnits,
            period: period,
            currencyISOCode: currencyISOCode,
            localeISOCode: localeISOCode
        });
        productPricing.push((0, $7Knp0._)({
            // @ts-ignore
            offeringSku: ccpOfferingSKU
        }, planPricing));
    }
    return productPricing;
};

});
parcelRegister("3FlK9", function(module, exports) {

$parcel$export(module.exports, "calculatePlanPricing", function () { return $2a81506982df3304$export$f9574505c9651410; });

var $7Knp0 = parcelRequire("7Knp0");

var $jl6Sn = parcelRequire("jl6Sn");

var $455M7 = parcelRequire("455M7");

var $c3Aax = parcelRequire("c3Aax");

var $8EXPa = parcelRequire("8EXPa");
parcelRequire("hqKpV");
var $fNdr1 = parcelRequire("fNdr1");
const $2a81506982df3304$var$hamsPricingDataStub = {};
const $2a81506982df3304$var$hamsProductKeyStub = "";
function $2a81506982df3304$export$f9574505c9651410(args) {
    const { ccpPricingData: ccpPricingData, ccpOfferingSKU: ccpOfferingSKU, period: period, numUnits: numUnits, currencyISOCode: currencyISOCode, localeISOCode: localeISOCode } = args;
    if (numUnits === 0) return (0, $7Knp0._)({
        offeringSku: ccpOfferingSKU
    }, (0, $c3Aax.getFreePriceCalc)(currencyISOCode));
    else {
        let getCcpTiers = undefined;
        if (ccpOfferingSKU === (0, $fNdr1.rovoDevOfferingSkus).standard || ccpOfferingSKU === (0, $8EXPa.bitbucketOfferingSkus).standard || ccpOfferingSKU === (0, $8EXPa.bitbucketOfferingSkus).premium) // rovodev-standard price-plans contain both user and rovodev-credits charge-items
        // bitbucket-standard and bitbucket-premium price-plans contain both user and bitbucket-credits charge-items as well
        // so, we need to get the plan with the user charge-item
        // todo: GWP-8253 move out of reusable calc logic
        getCcpTiers = (pricingPlans)=>pricingPlans.items.find((item)=>item.chargeElement === "user");
        const pricingTiers = (0, $jl6Sn.extractPricingTiersFromEntry)(ccpPricingData, $2a81506982df3304$var$hamsPricingDataStub, period, currencyISOCode, ccpOfferingSKU, $2a81506982df3304$var$hamsProductKeyStub, getCcpTiers);
        if (!pricingTiers) {
            console.log(`Pricing tiers not found for ${period}.`);
            return (0, $7Knp0._)({
                offeringSku: ccpOfferingSKU
            }, (0, $c3Aax.getFreePriceCalc)(currencyISOCode));
        } else return (0, $7Knp0._)({
            offeringSku: ccpOfferingSKU
        }, (0, $455M7.calculatePrice)(numUnits, pricingTiers, currencyISOCode, period, localeISOCode));
    }
}

});
parcelRegister("8EXPa", function(module, exports) {

$parcel$export(module.exports, "BITBUCKET_DEFAULT_BILLING_CYCLE", function () { return $fdd1778c4e973722$export$6e78cb64dcbedbb9; });
$parcel$export(module.exports, "BITBUCKET_DEFAULT_UNIT_COUNT", function () { return $fdd1778c4e973722$export$36a5806a0e4fc360; });
$parcel$export(module.exports, "BITBUCKET_MIN_ENTERPRISE_USER_COUNT", function () { return $fdd1778c4e973722$export$2b15976b7672c2da; });
$parcel$export(module.exports, "bitbucketOfferingSkus", function () { return $fdd1778c4e973722$export$eeb88db779daf862; });
$parcel$export(module.exports, "BITBUCKET_SIGNUP_LIMIT", function () { return $fdd1778c4e973722$export$4d264dc26702f23b; });
$parcel$export(module.exports, "bitbucketPlanLimitConfigs", function () { return $fdd1778c4e973722$export$66d05a9262b43b7f; });
$parcel$export(module.exports, "bitbucketBillingCycleConfig", function () { return $fdd1778c4e973722$export$f9cab01559b23739; });
const $fdd1778c4e973722$export$6e78cb64dcbedbb9 = "MONTHLY";
const $fdd1778c4e973722$export$36a5806a0e4fc360 = 5;
const $fdd1778c4e973722$export$2b15976b7672c2da = 201;
const $fdd1778c4e973722$export$eeb88db779daf862 = {
    free: "bitbucket-test-free",
    standard: "bitbucket-std",
    premium: "bitbucket-premium"
};
const $fdd1778c4e973722$export$4d264dc26702f23b = 35000;
const $fdd1778c4e973722$export$9a2735659d85fd7c = Object.values($fdd1778c4e973722$export$eeb88db779daf862);
const $fdd1778c4e973722$export$66d05a9262b43b7f = [
    {
        planName: "Free",
        offeringSku: $fdd1778c4e973722$export$eeb88db779daf862.free,
        recommendationLimit: 0,
        signupLimit: $fdd1778c4e973722$export$4d264dc26702f23b
    },
    {
        planName: "Standard",
        offeringSku: $fdd1778c4e973722$export$eeb88db779daf862.standard,
        recommendationLimit: 5,
        signupLimit: $fdd1778c4e973722$export$4d264dc26702f23b
    },
    {
        planName: "Premium",
        offeringSku: $fdd1778c4e973722$export$eeb88db779daf862.premium,
        recommendationLimit: 100,
        signupLimit: $fdd1778c4e973722$export$4d264dc26702f23b
    }
];
const $fdd1778c4e973722$export$f9cab01559b23739 = {
    monthly: true,
    annual: false
};

});

parcelRegister("hqKpV", function(module, exports) {
$parcel$export(module.exports, "jiraOfferingSkus", function () { return (parcelRequire("ktygn")).jiraOfferingSkus; });
$parcel$export(module.exports, "CONFLUENCE_DEFAULT_UNIT_COUNT", function () { return (parcelRequire("1i1dJ")).CONFLUENCE_DEFAULT_UNIT_COUNT; });
$parcel$export(module.exports, "confluenceOfferingSkus", function () { return (parcelRequire("1i1dJ")).confluenceOfferingSkus; });
$parcel$export(module.exports, "strategyCollectionOfferingSkus", function () { return (parcelRequire("awylZ")).strategyCollectionOfferingSkus; });
$parcel$export(module.exports, "teamworkCollectionOfferingSkus", function () { return (parcelRequire("fPLSq")).teamworkCollectionOfferingSkus; });
$parcel$export(module.exports, "loomOfferingSkus", function () { return (parcelRequire("1F9wN")).loomOfferingSkus; });
$parcel$export(module.exports, "jpdOfferingSkus", function () { return (parcelRequire("5kiq4")).jpdOfferingSkus; });
$parcel$export(module.exports, "compassOfferingSkus", function () { return (parcelRequire("iRy5O")).compassOfferingSkus; });
$parcel$export(module.exports, "guardOfferingSkus", function () { return (parcelRequire("5Rijz")).guardOfferingSkus; });
$parcel$export(module.exports, "serviceCollectionOfferingSkus", function () { return (parcelRequire("3ItZP")).serviceCollectionOfferingSkus; });
$parcel$export(module.exports, "rovoDevOfferingSkus", function () { return (parcelRequire("fNdr1")).rovoDevOfferingSkus; });
parcelRequire("ktygn");
parcelRequire("1i1dJ");
parcelRequire("awylZ");
parcelRequire("fPLSq");
parcelRequire("1F9wN");
parcelRequire("fKYQO");
parcelRequire("5kiq4");
parcelRequire("iRy5O");
parcelRequire("5Rijz");
parcelRequire("3ItZP");
parcelRequire("fNdr1");

});
parcelRegister("ktygn", function(module, exports) {

$parcel$export(module.exports, "JIRA_DEFAULT_BILLING_CYCLE", function () { return $4898376357b002ff$export$c34e5566df36b6ba; });
$parcel$export(module.exports, "JIRA_DEFAULT_UNIT_COUNT", function () { return $4898376357b002ff$export$6521a918e64524fb; });
$parcel$export(module.exports, "JIRA_MIN_ENTERPRISE_USER_COUNT", function () { return $4898376357b002ff$export$9aef50cd5f48bb38; });
$parcel$export(module.exports, "jiraOfferingSkus", function () { return $4898376357b002ff$export$7529f2cfeec98447; });
$parcel$export(module.exports, "jiraPlanLimitConfigs", function () { return $4898376357b002ff$export$3070b86c7bc28aea; });
const $4898376357b002ff$export$c34e5566df36b6ba = "MONTHLY";
const $4898376357b002ff$export$6521a918e64524fb = 300;
const $4898376357b002ff$export$9aef50cd5f48bb38 = 801;
const $4898376357b002ff$export$7529f2cfeec98447 = {
    free: "jira-software-free",
    standard: "jira-software-standard",
    premium: "jira-software-premium",
    enterprise: "jira-software-enterprise-sku"
};
const $4898376357b002ff$export$b2b09200ca76754f = Object.values($4898376357b002ff$export$7529f2cfeec98447);
const $4898376357b002ff$export$3070b86c7bc28aea = [
    {
        planName: "Free",
        offeringSku: $4898376357b002ff$export$7529f2cfeec98447.free,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: "Standard",
        offeringSku: $4898376357b002ff$export$7529f2cfeec98447.standard,
        recommendationLimit: 10,
        signupLimit: 100000
    },
    {
        planName: "Premium",
        offeringSku: $4898376357b002ff$export$7529f2cfeec98447.premium,
        recommendationLimit: 250,
        signupLimit: 100000
    },
    {
        planName: "Enterprise",
        offeringSku: $4898376357b002ff$export$7529f2cfeec98447.enterprise,
        recommendationLimit: 5000,
        signupLimit: 100000,
        minUnitCount: $4898376357b002ff$export$9aef50cd5f48bb38
    }
];
const $4898376357b002ff$export$7a133a10c706882b = {
    monthly: true,
    annual: true
};

});

parcelRegister("1i1dJ", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_DEFAULT_BILLING_CYCLE", function () { return $5b71775fc0eefb97$export$d60dc2d142b5e9dd; });
$parcel$export(module.exports, "CONFLUENCE_DEFAULT_UNIT_COUNT", function () { return $5b71775fc0eefb97$export$ab3750ec8101ffcc; });
$parcel$export(module.exports, "CONFLUENCE_MIN_ENTERPRISE_USER_COUNT", function () { return $5b71775fc0eefb97$export$f76a76b996ace375; });
$parcel$export(module.exports, "confluenceOfferingSkus", function () { return $5b71775fc0eefb97$export$ffe6d3f38b5f7c3a; });
$parcel$export(module.exports, "confluencePlanLimitConfigs", function () { return $5b71775fc0eefb97$export$53fbba6eb29a73ad; });
const $5b71775fc0eefb97$export$d60dc2d142b5e9dd = "MONTHLY";
const $5b71775fc0eefb97$export$ab3750ec8101ffcc = 300;
const $5b71775fc0eefb97$export$f76a76b996ace375 = 801;
const $5b71775fc0eefb97$export$ffe6d3f38b5f7c3a = {
    free: "confluence-free",
    standard: "confluence-standard",
    premium: "confluence-premium",
    enterprise: "confluence-enterprise-sku"
};
const $5b71775fc0eefb97$export$39e8fbae2abd0443 = Object.values($5b71775fc0eefb97$export$ffe6d3f38b5f7c3a);
const $5b71775fc0eefb97$export$53fbba6eb29a73ad = [
    {
        planName: "Free",
        offeringSku: $5b71775fc0eefb97$export$ffe6d3f38b5f7c3a.free,
        recommendationLimit: 0,
        signupLimit: 150000
    },
    {
        planName: "Standard",
        offeringSku: $5b71775fc0eefb97$export$ffe6d3f38b5f7c3a.standard,
        recommendationLimit: 10,
        signupLimit: 150000
    },
    {
        planName: "Premium",
        offeringSku: $5b71775fc0eefb97$export$ffe6d3f38b5f7c3a.premium,
        recommendationLimit: 250,
        signupLimit: 150000
    },
    {
        planName: "Enterprise",
        offeringSku: $5b71775fc0eefb97$export$ffe6d3f38b5f7c3a.enterprise,
        recommendationLimit: 5000,
        signupLimit: 150000,
        minUnitCount: $5b71775fc0eefb97$export$f76a76b996ace375
    }
];
const $5b71775fc0eefb97$export$e8f1610e98745fd7 = {
    monthly: true,
    annual: true
};

});

parcelRegister("awylZ", function(module, exports) {

$parcel$export(module.exports, "STRATEGY_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $e331a20e06ae1835$export$c00ddd271304729a; });
$parcel$export(module.exports, "STRATEGY_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $e331a20e06ae1835$export$27579c7f06007c25; });
$parcel$export(module.exports, "STRATEGY_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $e331a20e06ae1835$export$a99f1f06dfc3702a; });
$parcel$export(module.exports, "strategyCollectionOfferingSkus", function () { return $e331a20e06ae1835$export$8427e2db10f569be; });
$parcel$export(module.exports, "strategyCollectionPlanLimitConfigs", function () { return $e331a20e06ae1835$export$bc4927fbd68771ac; });
$parcel$export(module.exports, "strategyCollectionBillingCycleConfig", function () { return $e331a20e06ae1835$export$2225b2a65811f064; });
const $e331a20e06ae1835$export$c00ddd271304729a = "ANNUAL";
const $e331a20e06ae1835$export$27579c7f06007c25 = 50;
const $e331a20e06ae1835$export$a99f1f06dfc3702a = 50;
const $e331a20e06ae1835$export$8427e2db10f569be = {
    enterprise: "strategy-collection-enterprise-sku"
};
const $e331a20e06ae1835$export$3b4c7d53b38ef615 = Object.values($e331a20e06ae1835$export$8427e2db10f569be);
const $e331a20e06ae1835$export$bc4927fbd68771ac = [
    {
        planName: "Enterprise",
        offeringSku: $e331a20e06ae1835$export$8427e2db10f569be.enterprise,
        recommendationLimit: 2000,
        signupLimit: 2000,
        minUnitCount: $e331a20e06ae1835$export$a99f1f06dfc3702a
    }
];
const $e331a20e06ae1835$export$2225b2a65811f064 = {
    monthly: false,
    annual: true
};

});

parcelRegister("fPLSq", function(module, exports) {

$parcel$export(module.exports, "TEAMWORK_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $72cd788fce91eb06$export$5784a04bb778d3c1; });
$parcel$export(module.exports, "TEAMWORK_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $72cd788fce91eb06$export$482604a575f7b4a5; });
$parcel$export(module.exports, "TEAMWORK_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $72cd788fce91eb06$export$da0d6abd6eaa52b2; });
$parcel$export(module.exports, "teamworkCollectionOfferingSkus", function () { return $72cd788fce91eb06$export$2e2107bfa20be1d8; });
$parcel$export(module.exports, "teamworkCollectionPlanLimitConfigs", function () { return $72cd788fce91eb06$export$88bcddbae46dd5f1; });
$parcel$export(module.exports, "teamworkCollectionBillingCycleConfig", function () { return $72cd788fce91eb06$export$5861c5ce06e1556; });
const $72cd788fce91eb06$export$5784a04bb778d3c1 = "MONTHLY";
const $72cd788fce91eb06$export$482604a575f7b4a5 = 300;
const $72cd788fce91eb06$export$da0d6abd6eaa52b2 = 801;
const $72cd788fce91eb06$export$2e2107bfa20be1d8 = {
    free: "teamwork-collection-free-sku",
    standard: "teamwork-collection-standard-sku",
    premium: "teamwork-collection-premium-sku",
    enterprise: "teamwork-collection-enterprise-sku"
};
const $72cd788fce91eb06$export$b61ab2c6a18de6d4 = Object.values($72cd788fce91eb06$export$2e2107bfa20be1d8);
const $72cd788fce91eb06$export$88bcddbae46dd5f1 = [
    {
        planName: "Free",
        offeringSku: $72cd788fce91eb06$export$2e2107bfa20be1d8.free,
        recommendationLimit: 0,
        signupLimit: 10
    },
    {
        planName: "Standard",
        offeringSku: $72cd788fce91eb06$export$2e2107bfa20be1d8.standard,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: "Premium",
        offeringSku: $72cd788fce91eb06$export$2e2107bfa20be1d8.premium,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: "Enterprise",
        offeringSku: $72cd788fce91eb06$export$2e2107bfa20be1d8.enterprise,
        recommendationLimit: 5000,
        signupLimit: 100000,
        minUnitCount: $72cd788fce91eb06$export$da0d6abd6eaa52b2
    }
];
const $72cd788fce91eb06$export$5861c5ce06e1556 = {
    monthly: true,
    annual: true
};

});

parcelRegister("1F9wN", function(module, exports) {

$parcel$export(module.exports, "LOOM_DEFAULT_BILLING_CYCLE", function () { return $8db8255cb645bec1$export$501dc9dfd5b2bde4; });
$parcel$export(module.exports, "LOOM_DEFAULT_UNIT_COUNT", function () { return $8db8255cb645bec1$export$2aa1a93e0ac00fc; });
$parcel$export(module.exports, "LOOM_MIN_ENTERPRISE_USER_COUNT", function () { return $8db8255cb645bec1$export$2a2f7d7a7ae18850; });
$parcel$export(module.exports, "loomOfferingSkus", function () { return $8db8255cb645bec1$export$a64578a63428ae96; });
$parcel$export(module.exports, "loomPlanLimitConfigs", function () { return $8db8255cb645bec1$export$ed1379ed8713d252; });
$parcel$export(module.exports, "loomBillingCycleConfig", function () { return $8db8255cb645bec1$export$d2bfeac6f7899675; });
const $8db8255cb645bec1$export$501dc9dfd5b2bde4 = "MONTHLY";
const $8db8255cb645bec1$export$2aa1a93e0ac00fc = 100;
const $8db8255cb645bec1$export$2a2f7d7a7ae18850 = Infinity;
const $8db8255cb645bec1$export$a64578a63428ae96 = {
    free: "loom-free-sku",
    business: "loom-business-sku",
    businessPlusAi: "loom-business-ai-sku",
    enterprise: "loom-enterprise-sku"
};
const $8db8255cb645bec1$export$9f95f1c871571078 = Object.values($8db8255cb645bec1$export$a64578a63428ae96);
const $8db8255cb645bec1$export$ed1379ed8713d252 = [
    {
        planName: "Free",
        offeringSku: $8db8255cb645bec1$export$a64578a63428ae96.free,
        recommendationLimit: Infinity,
        signupLimit: 50000
    },
    {
        planName: "Business",
        offeringSku: $8db8255cb645bec1$export$a64578a63428ae96.business,
        recommendationLimit: Infinity,
        signupLimit: 50000
    },
    {
        planName: "Business + AI",
        offeringSku: $8db8255cb645bec1$export$a64578a63428ae96.businessPlusAi,
        recommendationLimit: 0,
        signupLimit: 50000
    },
    {
        planName: "Enterprise",
        offeringSku: $8db8255cb645bec1$export$a64578a63428ae96.enterprise,
        recommendationLimit: Infinity,
        signupLimit: 50000
    }
];
const $8db8255cb645bec1$export$d2bfeac6f7899675 = {
    monthly: true,
    annual: true
};

});

parcelRegister("fKYQO", function(module, exports) {
const $e2063f4ed18d2b98$export$be354061b07829a8 = "MONTHLY";
const $e2063f4ed18d2b98$export$2295858875312a6f = 75;
const $e2063f4ed18d2b98$export$66d53803b4a2565a = 201;
const $e2063f4ed18d2b98$export$38631f866342776a = {
    free: "jira-servicedesk-free",
    standard: "jira-servicedesk-standard",
    premium: "jira-servicedesk-premium",
    enterprise: "jira-servicedesk-enterprise-sku"
};
const $e2063f4ed18d2b98$export$efd16829e921ffb8 = Object.values($e2063f4ed18d2b98$export$38631f866342776a);
const $e2063f4ed18d2b98$export$9e62e4d7dc794618 = [
    {
        planName: "Free",
        offeringSku: $e2063f4ed18d2b98$export$38631f866342776a.free,
        recommendationLimit: 0,
        signupLimit: 20000
    },
    {
        planName: "Standard",
        offeringSku: $e2063f4ed18d2b98$export$38631f866342776a.standard,
        recommendationLimit: 3,
        signupLimit: 20000
    },
    {
        planName: "Premium",
        offeringSku: $e2063f4ed18d2b98$export$38631f866342776a.premium,
        recommendationLimit: 50,
        signupLimit: 20000
    },
    {
        planName: "Enterprise",
        offeringSku: $e2063f4ed18d2b98$export$38631f866342776a.enterprise,
        recommendationLimit: 250,
        signupLimit: 20000
    }
];
const $e2063f4ed18d2b98$export$34fbcdd33d5f7ba7 = {
    monthly: true,
    annual: true
};

});

parcelRegister("5kiq4", function(module, exports) {

$parcel$export(module.exports, "JPD_DEFAULT_BILLING_CYCLE", function () { return $3ff405992fae1ce1$export$513f99bdcd3bd2; });
$parcel$export(module.exports, "JPD_DEFAULT_UNIT_COUNT", function () { return $3ff405992fae1ce1$export$503245d941330408; });
$parcel$export(module.exports, "JPD_MIN_ENTERPRISE_USER_COUNT", function () { return $3ff405992fae1ce1$export$4ebabaf17c585254; });
$parcel$export(module.exports, "jpdOfferingSkus", function () { return $3ff405992fae1ce1$export$400db592c8d58797; });
$parcel$export(module.exports, "jpdPlanLimitConfigs", function () { return $3ff405992fae1ce1$export$886e6b42d7675517; });
$parcel$export(module.exports, "jpdBillingCycleConfig", function () { return $3ff405992fae1ce1$export$370b1f24abd91670; });
const $3ff405992fae1ce1$export$513f99bdcd3bd2 = "MONTHLY";
const $3ff405992fae1ce1$export$503245d941330408 = 10;
const $3ff405992fae1ce1$export$4ebabaf17c585254 = 201;
const $3ff405992fae1ce1$export$400db592c8d58797 = {
    free: "jira-servicedesk-free",
    // jpd-free shares the same sku as jsm-free
    standard: "jira-product-discovery-standard",
    premium: "jira-product-discovery-premium-sku"
};
const $3ff405992fae1ce1$export$cf1798af40f51188 = Object.values($3ff405992fae1ce1$export$400db592c8d58797);
const $3ff405992fae1ce1$export$886e6b42d7675517 = [
    {
        planName: "Free",
        offeringSku: $3ff405992fae1ce1$export$400db592c8d58797.free,
        recommendationLimit: 0,
        signupLimit: 20000
    },
    {
        planName: "Standard",
        offeringSku: $3ff405992fae1ce1$export$400db592c8d58797.standard,
        recommendationLimit: 3,
        signupLimit: 20000
    },
    {
        planName: "Premium",
        offeringSku: $3ff405992fae1ce1$export$400db592c8d58797.premium,
        recommendationLimit: 50,
        signupLimit: 20000
    }
];
const $3ff405992fae1ce1$export$370b1f24abd91670 = {
    monthly: true,
    annual: true
};

});

parcelRegister("iRy5O", function(module, exports) {

$parcel$export(module.exports, "COMPASS_DEFAULT_BILLING_CYCLE", function () { return $59446ee27ebc264e$export$2c789441f8bab310; });
$parcel$export(module.exports, "COMPASS_DEFAULT_UNIT_COUNT", function () { return $59446ee27ebc264e$export$887bc0e84eafd3c; });
$parcel$export(module.exports, "COMPASS_MIN_ENTERPRISE_USER_COUNT", function () { return $59446ee27ebc264e$export$862352663e0ac9d7; });
$parcel$export(module.exports, "compassOfferingSkus", function () { return $59446ee27ebc264e$export$f93fb5caff8c778a; });
$parcel$export(module.exports, "compassPlanLimitConfigs", function () { return $59446ee27ebc264e$export$4df3b64d28e0d138; });
$parcel$export(module.exports, "compassBillingCycleConfig", function () { return $59446ee27ebc264e$export$e0b3f0eba764d747; });
const $59446ee27ebc264e$export$2c789441f8bab310 = "MONTHLY";
const $59446ee27ebc264e$export$887bc0e84eafd3c = 300;
const $59446ee27ebc264e$export$862352663e0ac9d7 = Infinity;
const $59446ee27ebc264e$export$f93fb5caff8c778a = {
    free: "compass-free",
    standard: "compass-standard",
    premium: "compass-premium-sku"
};
const $59446ee27ebc264e$export$74a0fd94f40ef5c5 = Object.values($59446ee27ebc264e$export$f93fb5caff8c778a);
const $59446ee27ebc264e$export$4df3b64d28e0d138 = [
    {
        planName: "Free",
        offeringSku: $59446ee27ebc264e$export$f93fb5caff8c778a.free,
        recommendationLimit: 0,
        signupLimit: 3
    },
    {
        planName: "Standard",
        offeringSku: $59446ee27ebc264e$export$f93fb5caff8c778a.standard,
        recommendationLimit: 3,
        signupLimit: 35000
    },
    {
        planName: "Premium",
        offeringSku: $59446ee27ebc264e$export$f93fb5caff8c778a.premium,
        recommendationLimit: 250,
        signupLimit: 35000
    }
];
const $59446ee27ebc264e$export$e0b3f0eba764d747 = {
    monthly: true,
    annual: true
};

});

parcelRegister("5Rijz", function(module, exports) {

$parcel$export(module.exports, "GUARD_DEFAULT_BILLING_CYCLE", function () { return $5cadcd121392db78$export$9be98af08cc25cad; });
$parcel$export(module.exports, "GUARD_DEFAULT_UNIT_COUNT", function () { return $5cadcd121392db78$export$d28097ea69640bd5; });
$parcel$export(module.exports, "GUARD_MIN_ENTERPRISE_USER_COUNT", function () { return $5cadcd121392db78$export$13b500e201e8b319; });
$parcel$export(module.exports, "guardOfferingSkus", function () { return $5cadcd121392db78$export$91a420e9c7eb7c83; });
$parcel$export(module.exports, "guardPlanLimitConfigs", function () { return $5cadcd121392db78$export$a2329ae21ff2ff84; });
$parcel$export(module.exports, "guardBillingCycleConfig", function () { return $5cadcd121392db78$export$129a445945b6d9b3; });
const $5cadcd121392db78$export$9be98af08cc25cad = "MONTHLY";
const $5cadcd121392db78$export$d28097ea69640bd5 = 100;
const $5cadcd121392db78$export$13b500e201e8b319 = Infinity;
const $5cadcd121392db78$export$91a420e9c7eb7c83 = {
    standard: "atlassian-access-standard-sku",
    premium: "atlassian-guard-premium-addon-sku"
};
const $5cadcd121392db78$export$159558c2b3d66b11 = Object.values($5cadcd121392db78$export$91a420e9c7eb7c83);
const $5cadcd121392db78$export$a2329ae21ff2ff84 = [
    {
        planName: "Standard",
        offeringSku: $5cadcd121392db78$export$91a420e9c7eb7c83.standard,
        recommendationLimit: 0,
        signupLimit: 50000
    },
    {
        planName: "Premium",
        offeringSku: $5cadcd121392db78$export$91a420e9c7eb7c83.premium,
        recommendationLimit: 99,
        signupLimit: 50000
    }
];
const $5cadcd121392db78$export$129a445945b6d9b3 = {
    monthly: true,
    annual: true
};

});

parcelRegister("3ItZP", function(module, exports) {

$parcel$export(module.exports, "SERVICE_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $98d786164d4b1720$export$9423de11a8a6dfa7; });
$parcel$export(module.exports, "SERVICE_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $98d786164d4b1720$export$515fa2affea780b3; });
$parcel$export(module.exports, "SERVICE_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $98d786164d4b1720$export$3df704b75c4818f2; });
$parcel$export(module.exports, "serviceCollectionOfferingSkus", function () { return $98d786164d4b1720$export$84b191ede7d628ea; });
$parcel$export(module.exports, "serviceCollectionPlanLimitConfigs", function () { return $98d786164d4b1720$export$29e5f53cb4f38894; });
$parcel$export(module.exports, "serviceCollectionBillingCycleConfig", function () { return $98d786164d4b1720$export$7c96cfb0c18bfb05; });
const $98d786164d4b1720$export$9423de11a8a6dfa7 = "MONTHLY";
const $98d786164d4b1720$export$515fa2affea780b3 = 75;
const $98d786164d4b1720$export$3df704b75c4818f2 = 201;
const $98d786164d4b1720$export$84b191ede7d628ea = {
    free: "service-collection-free",
    standard: "service-collection-standard",
    premium: "service-collection-premium",
    enterprise: "service-collection-enterprise"
};
const $98d786164d4b1720$export$953539e2774d6323 = Object.values($98d786164d4b1720$export$84b191ede7d628ea);
const $98d786164d4b1720$export$29e5f53cb4f38894 = [
    {
        planName: "Free",
        offeringSku: $98d786164d4b1720$export$84b191ede7d628ea.free,
        recommendationLimit: 0,
        signupLimit: 20000
    },
    {
        planName: "Standard",
        offeringSku: $98d786164d4b1720$export$84b191ede7d628ea.standard,
        recommendationLimit: 3,
        signupLimit: 20000
    },
    {
        planName: "Premium",
        offeringSku: $98d786164d4b1720$export$84b191ede7d628ea.premium,
        recommendationLimit: 50,
        signupLimit: 20000
    },
    {
        planName: "Enterprise",
        offeringSku: $98d786164d4b1720$export$84b191ede7d628ea.enterprise,
        recommendationLimit: 250,
        signupLimit: 20000,
        minUnitCount: $98d786164d4b1720$export$3df704b75c4818f2
    }
];
const $98d786164d4b1720$export$7c96cfb0c18bfb05 = {
    monthly: true,
    annual: true
};

});

parcelRegister("fNdr1", function(module, exports) {

$parcel$export(module.exports, "ROVO_DEV_DEFAULT_BILLING_CYCLE", function () { return $9cae7a096cb356f4$export$f7b45b42f23a06a6; });
$parcel$export(module.exports, "ROVO_DEV_DEFAULT_UNIT_COUNT", function () { return $9cae7a096cb356f4$export$c80f45e98f559c29; });
$parcel$export(module.exports, "ROVO_DEV_MIN_ENTERPRISE_USER_COUNT", function () { return $9cae7a096cb356f4$export$5cdb7bb84622bb8e; });
$parcel$export(module.exports, "rovoDevOfferingSkus", function () { return $9cae7a096cb356f4$export$6a8477cfea6a8fb8; });
$parcel$export(module.exports, "rovoDevPlanLimitConfigs", function () { return $9cae7a096cb356f4$export$93aaa2531823d54e; });
$parcel$export(module.exports, "rovoDevBillingCycleConfig", function () { return $9cae7a096cb356f4$export$120b0272a23f9b21; });
const $9cae7a096cb356f4$export$f7b45b42f23a06a6 = "MONTHLY";
const $9cae7a096cb356f4$export$c80f45e98f559c29 = 10;
const $9cae7a096cb356f4$export$5cdb7bb84622bb8e = Infinity;
const $9cae7a096cb356f4$export$6a8477cfea6a8fb8 = {
    standard: "rovodev-standard"
};
const $9cae7a096cb356f4$export$69f1beff4f684452 = Object.values($9cae7a096cb356f4$export$6a8477cfea6a8fb8);
const $9cae7a096cb356f4$export$93aaa2531823d54e = [
    {
        planName: "Standard",
        offeringSku: $9cae7a096cb356f4$export$6a8477cfea6a8fb8.standard,
        recommendationLimit: Infinity,
        signupLimit: Infinity,
        minUnitCount: $9cae7a096cb356f4$export$5cdb7bb84622bb8e
    }
];
const $9cae7a096cb356f4$export$120b0272a23f9b21 = {
    monthly: false,
    annual: false
};

});




parcelRegister("gz56C", function(module, exports) {

$parcel$export(module.exports, "getProductCalculationInputs", function () { return $09379941b2c1216c$export$915d8a609f55f86e; });

var $7mfju = parcelRequire("7mfju");
const $09379941b2c1216c$export$915d8a609f55f86e = (productPlans, unitMinEnterprise, unitCount, billingCycle)=>{
    const getNumUnits = (planName, signupUnitLimit)=>{
        let adjNumUnits = 0;
        // following scenarios do not have pricing and should send a zero unit count,
        // the zero pricing will not be displayed and is needed only to retain the
        // correct array order of the pricing requests/responses
        // Free plan has no pricing
        const isFree = planName === (0, $7mfju.SpecialPlanNames).FREE;
        // Enterprise plans do not have monthly pricing
        const isMonthlyEnterprise = planName === (0, $7mfju.SpecialPlanNames).ENTERPRISE && billingCycle === "MONTHLY";
        // Enterprise plans have a minimum unit count
        const isUnmetUnitCountEnterprise = planName === (0, $7mfju.SpecialPlanNames).ENTERPRISE && unitCount < unitMinEnterprise;
        const isOverSignupUnitLimit = unitCount > signupUnitLimit;
        if (![
            isFree,
            isMonthlyEnterprise,
            isUnmetUnitCountEnterprise,
            isOverSignupUnitLimit
        ].includes(true)) adjNumUnits = unitCount;
        // keep unit count to general maximum limit
        return Math.min(adjNumUnits, signupUnitLimit);
    };
    const planPriceReqs = productPlans.map(({ offeringSku: offeringSku, planName: planName, signupLimit: signupLimit })=>({
            ccpOfferingSKU: offeringSku,
            hamsProductKey: undefined,
            numUnits: getNumUnits(planName, signupLimit || (0, $7mfju.DefaultPlanLimits).UNIT_LIMIT),
            period: billingCycle
        }));
    return planPriceReqs;
};

});




parcelRegister("iXUxi", function(module, exports) {

$parcel$export(module.exports, "getUnitCount", function () { return $aa8ab4fefb73d271$export$f188fc3b389e4986; });
$parcel$export(module.exports, "getBillingCycle", function () { return $aa8ab4fefb73d271$export$36cee2c7009ae4b; });
$parcel$export(module.exports, "hasAnnualBilling", function () { return $aa8ab4fefb73d271$export$101e70cd0fc05902; });
$parcel$export(module.exports, "hasMonthlyBilling", function () { return $aa8ab4fefb73d271$export$9adfa96ec47fe801; });
$parcel$export(module.exports, "isUnitCountAboveMaxThreshold", function () { return $aa8ab4fefb73d271$export$bdaa994f7aee683f; });
$parcel$export(module.exports, "getUnitCountMinThreshold", function () { return $aa8ab4fefb73d271$export$80145dc7d2cff456; });
$parcel$export(module.exports, "isUnitCountBelowMinThreshold", function () { return $aa8ab4fefb73d271$export$5566acad9364293b; });
$parcel$export(module.exports, "getNumberFormatLocale", function () { return $aa8ab4fefb73d271$export$3d36f1c8af14c3fb; });
$parcel$export(module.exports, "getCurrencyIsoCode", function () { return $aa8ab4fefb73d271$export$5052d5e5b6a90fdc; });
$parcel$export(module.exports, "isOfferingRecommended", function () { return $aa8ab4fefb73d271$export$d9589e71fc109cc; });
$parcel$export(module.exports, "getUnitTierLowerBound", function () { return $aa8ab4fefb73d271$export$f88112553e09e018; });
$parcel$export(module.exports, "getUnitTierUpperBound", function () { return $aa8ab4fefb73d271$export$6f3b3ca7764acc97; });
$parcel$export(module.exports, "getUnitsAvailableInTier", function () { return $aa8ab4fefb73d271$export$daa8dd568be987ed; });
$parcel$export(module.exports, "getFormattedPlanPrice", function () { return $aa8ab4fefb73d271$export$8808c13548cf959c; });
$parcel$export(module.exports, "getPricePlanId", function () { return $aa8ab4fefb73d271$export$235d4fbb478dfba0; });
const $aa8ab4fefb73d271$export$f188fc3b389e4986 = (ctx)=>ctx.inputValues.unitCount;
const $aa8ab4fefb73d271$export$36cee2c7009ae4b = (ctx)=>ctx.inputValues.billingCycle;
const $aa8ab4fefb73d271$export$101e70cd0fc05902 = (ctx)=>{
    return ctx.config.billingCycleConfig.annual;
};
const $aa8ab4fefb73d271$export$9adfa96ec47fe801 = (ctx)=>{
    return ctx.config.billingCycleConfig.monthly;
};
const $aa8ab4fefb73d271$export$bdaa994f7aee683f = (ctx, offeringSku)=>{
    const unitCount = $aa8ab4fefb73d271$export$f188fc3b389e4986(ctx);
    const planLimitConfig = $aa8ab4fefb73d271$var$getPlanLimitConfig(ctx, offeringSku);
    return unitCount > planLimitConfig.signupLimit;
};
const $aa8ab4fefb73d271$export$80145dc7d2cff456 = (ctx, offeringSku)=>{
    const { minUnitCount: minUnitCount } = $aa8ab4fefb73d271$var$getPlanLimitConfig(ctx, offeringSku);
    return minUnitCount !== null && minUnitCount !== void 0 ? minUnitCount : 0;
};
const $aa8ab4fefb73d271$export$5566acad9364293b = (ctx, offeringSku)=>{
    const minUnitCount = $aa8ab4fefb73d271$export$80145dc7d2cff456(ctx, offeringSku);
    const unitCount = $aa8ab4fefb73d271$export$f188fc3b389e4986(ctx);
    return unitCount < minUnitCount;
};
const $aa8ab4fefb73d271$export$3a3e581c62c2c0f = (ctx)=>{
    const unitCount = $aa8ab4fefb73d271$export$f188fc3b389e4986(ctx);
    const unitMinEnterprise = ctx.config.unitMinEnterprise;
    return unitCount >= unitMinEnterprise;
};
const $aa8ab4fefb73d271$var$getPlanLimitConfigs = (ctx)=>{
    return ctx.config.planLimitConfigs;
};
const $aa8ab4fefb73d271$var$getPlanLimitConfig = (ctx, offeringSku)=>{
    const planLimitConfigs = $aa8ab4fefb73d271$var$getPlanLimitConfigs(ctx);
    const planLimitConfig = planLimitConfigs.find((plan)=>plan.offeringSku === offeringSku);
    if (!planLimitConfig) throw new Error("unexpected empty value");
    return planLimitConfig;
};
const $aa8ab4fefb73d271$var$getPlanPriceResult = (ctx, offeringSku)=>{
    const planPriceResult = ctx.calculationResult.find((plan)=>plan.offeringSku === offeringSku);
    if (!planPriceResult) throw new Error("unexpected empty value");
    return planPriceResult;
};
const $aa8ab4fefb73d271$export$e3c7f1437cafb58a = (ctx, offeringSku)=>{
    const price = $aa8ab4fefb73d271$var$getPlanPriceResult(ctx, offeringSku);
    return price.formattedTotalPrice;
};
const $aa8ab4fefb73d271$export$2aabcb5d2a5bee2b = (ctx, offeringSku)=>{
    const price = $aa8ab4fefb73d271$var$getPlanPriceResult(ctx, offeringSku);
    return price.avgPerUnitPrice;
};
const $aa8ab4fefb73d271$export$10818dfc4986524e = (price)=>{
    return Math.round(price);
};
const $aa8ab4fefb73d271$export$2dd65b072d3a3106 = (price)=>{
    return Math.ceil(price);
};
const $aa8ab4fefb73d271$export$3d36f1c8af14c3fb = (ctx)=>{
    const currencyISOCode = $aa8ab4fefb73d271$export$5052d5e5b6a90fdc(ctx);
    const isJPY = currencyISOCode === "JPY";
    return isJPY ? "ja-JP" : "en-US";
};
const $aa8ab4fefb73d271$export$c86caf1be068fb8d = (ctx, price, options = {})=>{
    const numberFormatLocale = $aa8ab4fefb73d271$export$3d36f1c8af14c3fb(ctx);
    const currencyISOCode = $aa8ab4fefb73d271$export$5052d5e5b6a90fdc(ctx);
    var _options_minimumFractionDigits, _options_minimumFractionDigits1;
    return new Intl.NumberFormat(numberFormatLocale, {
        style: "currency",
        currency: currencyISOCode,
        minimumFractionDigits: (_options_minimumFractionDigits = options.minimumFractionDigits) !== null && _options_minimumFractionDigits !== void 0 ? _options_minimumFractionDigits : 0,
        maximumFractionDigits: (_options_minimumFractionDigits1 = options.minimumFractionDigits) !== null && _options_minimumFractionDigits1 !== void 0 ? _options_minimumFractionDigits1 : 0
    }).format(price);
};
const $aa8ab4fefb73d271$export$b3a0d360c4444407 = (ctx, offeringSku)=>{
    const price = $aa8ab4fefb73d271$var$getPlanPriceResult(ctx, offeringSku);
    return price.formattedAvgPerUnitPrice;
};
const $aa8ab4fefb73d271$export$d9589e71fc109cc = (ctx, offeringSku)=>{
    const recommendedOfferingSku = $aa8ab4fefb73d271$var$getRecommendedOfferingSku(ctx);
    return recommendedOfferingSku === offeringSku;
};
const $aa8ab4fefb73d271$var$getRecommendedOfferingSku = (ctx)=>{
    var _planLimitConfigs_recommendedPlanIdx;
    const getRecommendedPlanIdx = (unitCount, minUnitCounts)=>{
        const len = minUnitCounts.length - 1;
        return len - minUnitCounts.reverse().findIndex((minUnitCount)=>unitCount > minUnitCount);
    };
    const unitCount = $aa8ab4fefb73d271$export$f188fc3b389e4986(ctx);
    const planLimitConfigs = $aa8ab4fefb73d271$var$getPlanLimitConfigs(ctx);
    const recommendedPlanIdx = getRecommendedPlanIdx(unitCount, planLimitConfigs.map((productPlan)=>productPlan.recommendationLimit));
    return (_planLimitConfigs_recommendedPlanIdx = planLimitConfigs[recommendedPlanIdx]) === null || _planLimitConfigs_recommendedPlanIdx === void 0 ? void 0 : _planLimitConfigs_recommendedPlanIdx.offeringSku;
};
const $aa8ab4fefb73d271$var$getUnformattedBreakdown = (ctx, offeringSku)=>{
    const planPriceResult = $aa8ab4fefb73d271$var$getPlanPriceResult(ctx, offeringSku);
    return planPriceResult.breakdown.at(-1);
};
const $aa8ab4fefb73d271$export$f88112553e09e018 = (ctx, offeringSku)=>{
    const breakdown = $aa8ab4fefb73d271$var$getUnformattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.unitLimitLower;
};
const $aa8ab4fefb73d271$export$6f3b3ca7764acc97 = (ctx, offeringSku)=>{
    const breakdown = $aa8ab4fefb73d271$var$getUnformattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.unitLimitUpper;
};
const $aa8ab4fefb73d271$export$daa8dd568be987ed = (ctx, offeringSku)=>{
    const unitCount = $aa8ab4fefb73d271$export$f188fc3b389e4986(ctx);
    const unitTierUpperBound = $aa8ab4fefb73d271$export$6f3b3ca7764acc97(ctx, offeringSku);
    return (unitTierUpperBound !== null && unitTierUpperBound !== void 0 ? unitTierUpperBound : 0) - unitCount;
};
/**
 * @deprecated
 */ const $aa8ab4fefb73d271$var$getFormattedBreakdown = (ctx, offeringSku)=>{
    const planPriceResult = $aa8ab4fefb73d271$var$getPlanPriceResult(ctx, offeringSku);
    return planPriceResult.formattedBreakdown.at(-1);
};
const $aa8ab4fefb73d271$export$b1a3e695caa8081d = (ctx, offeringSku)=>{
    const breakdown = $aa8ab4fefb73d271$var$getFormattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.formattedUnitLimitLower;
};
const $aa8ab4fefb73d271$export$24bf67bcc0364ee6 = (ctx, offeringSku)=>{
    const breakdown = $aa8ab4fefb73d271$var$getFormattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.formattedUnitLimitUpper;
};
const $aa8ab4fefb73d271$export$5052d5e5b6a90fdc = (ctx)=>ctx.config.currencyISOCode;
const $aa8ab4fefb73d271$export$8808c13548cf959c = (ctx, offeringSku)=>{
    const billingCycle = $aa8ab4fefb73d271$export$36cee2c7009ae4b(ctx);
    const currencyISOCode = $aa8ab4fefb73d271$export$5052d5e5b6a90fdc(ctx);
    if (billingCycle === "ANNUAL") return $aa8ab4fefb73d271$export$e3c7f1437cafb58a(ctx, offeringSku);
    let price = $aa8ab4fefb73d271$export$2aabcb5d2a5bee2b(ctx, offeringSku);
    if (currencyISOCode === "JPY") {
        price = $aa8ab4fefb73d271$export$2dd65b072d3a3106(price);
        return $aa8ab4fefb73d271$export$c86caf1be068fb8d(ctx, price, {
            minimumFractionDigits: 0
        });
    }
    return $aa8ab4fefb73d271$export$c86caf1be068fb8d(ctx, price, {
        minimumFractionDigits: price === 0 || Number.isInteger(price) ? 0 : 2
    });
};
const $aa8ab4fefb73d271$export$235d4fbb478dfba0 = (ctx, args)=>{
    var _offering_defaultPricingPlans;
    const { offeringSku: offeringSku, edition: edition } = args;
    const offering = Object.values(ctx.config.ccpPricingData).find((offering)=>offering.sku === offeringSku);
    const currencyISOCode = $aa8ab4fefb73d271$export$5052d5e5b6a90fdc(ctx);
    const billingCycle = $aa8ab4fefb73d271$export$36cee2c7009ae4b(ctx);
    // taken from `usePricingPlan` services/wac-web/src/components/wpl/pricing/src/price-finder/price-card/experiment-direct-buy/use-pricing-plan.tsx
    const defaultPricingPlan = offering === null || offering === void 0 ? void 0 : (_offering_defaultPricingPlans = offering.defaultPricingPlans) === null || _offering_defaultPricingPlans === void 0 ? void 0 : _offering_defaultPricingPlans.filter((item)=>item.currency.toLowerCase() == currencyISOCode.toLowerCase() && item.offeringName.toLowerCase() == edition.toLowerCase() && item.primaryCycle_name.toLowerCase() == billingCycle.toLowerCase() && item.status.toLowerCase() == "active");
    const lastPricingPlan = defaultPricingPlan === null || defaultPricingPlan === void 0 ? void 0 : defaultPricingPlan[defaultPricingPlan.length - 1];
    return (lastPricingPlan === null || lastPricingPlan === void 0 ? void 0 : lastPricingPlan.id) || "";
};

});


parcelRegister("MciJy", function(module, exports) {
$parcel$export(module.exports, "PricingCalculatorInputs", function () { return (parcelRequire("85vSY")).PricingCalculatorInputs; });
$parcel$export(module.exports, "RovoDevStandardPriceCard", function () { return (parcelRequire("9IdXN")).RovoDevStandardPriceCard; });
$parcel$export(module.exports, "ServiceCollectionEnterprisePriceCard", function () { return (parcelRequire("zcwoT")).ServiceCollectionEnterprisePriceCard; });
$parcel$export(module.exports, "ServiceCollectionFreePriceCard", function () { return (parcelRequire("zcwoT")).ServiceCollectionFreePriceCard; });
$parcel$export(module.exports, "ServiceCollectionPremiumPriceCard", function () { return (parcelRequire("zcwoT")).ServiceCollectionPremiumPriceCard; });
$parcel$export(module.exports, "ServiceCollectionStandardPriceCard", function () { return (parcelRequire("zcwoT")).ServiceCollectionStandardPriceCard; });
$parcel$export(module.exports, "LoomBusinessPlusAiPriceCard", function () { return (parcelRequire("3A3AJ")).LoomBusinessPlusAiPriceCard; });
$parcel$export(module.exports, "LoomBusinessPriceCard", function () { return (parcelRequire("3A3AJ")).LoomBusinessPriceCard; });
$parcel$export(module.exports, "LoomEnterprisePriceCard", function () { return (parcelRequire("3A3AJ")).LoomEnterprisePriceCard; });
$parcel$export(module.exports, "LoomFreePriceCard", function () { return (parcelRequire("3A3AJ")).LoomFreePriceCard; });
$parcel$export(module.exports, "JiraProductDiscoveryFreePriceCard", function () { return (parcelRequire("ebQhK")).JiraProductDiscoveryFreePriceCard; });
$parcel$export(module.exports, "JiraProductDiscoveryPremiumPriceCard", function () { return (parcelRequire("ebQhK")).JiraProductDiscoveryPremiumPriceCard; });
$parcel$export(module.exports, "JiraProductDiscoveryStandardPriceCard", function () { return (parcelRequire("ebQhK")).JiraProductDiscoveryStandardPriceCard; });

$parcel$export(module.exports, "LoadingSpinner", function () { return (parcelRequire("1rXz0")).LoadingSpinner; });
$parcel$export(module.exports, "PriceAltContainer", function () { return (parcelRequire("1JG1M")).PriceAltContainer; });
$parcel$export(module.exports, "MonthlyEnterpriseMessage", function () { return (parcelRequire("1wBc7")).MonthlyEnterpriseMessage; });
$parcel$export(module.exports, "getFeaturesList", function () { return (parcelRequire("chlmU")).getFeaturesList; });
$parcel$export(module.exports, "UserTier", function () { return (parcelRequire("fKqpx")).UserTier; });
$parcel$export(module.exports, "UserTierExpanded", function () { return (parcelRequire("fKqpx")).UserTierExpanded; });
$parcel$export(module.exports, "useLocalizedCtaUrl", function () { return (parcelRequire("4oRsq")).useLocalizedCtaUrl; });
$parcel$export(module.exports, "useConfluenceDirectBuyExperiment", function () { return (parcelRequire("38spb")).useConfluenceDirectBuyExperiment; });
$parcel$export(module.exports, "ConfluenceDirectBuyButton", function () { return (parcelRequire("38spb")).ConfluenceDirectBuyButton; });
parcelRequire("85vSY");

var $1rXz0 = parcelRequire("1rXz0");

var $1JG1M = parcelRequire("1JG1M");

var $1wBc7 = parcelRequire("1wBc7");

var $chlmU = parcelRequire("chlmU");

var $fKqpx = parcelRequire("fKqpx");

var $4oRsq = parcelRequire("4oRsq");

var $38spb = parcelRequire("38spb");
parcelRequire("9IdXN");
parcelRequire("zcwoT");
parcelRequire("3A3AJ");
parcelRequire("ebQhK");

});
parcelRegister("85vSY", function(module, exports) {

$parcel$export(module.exports, "PricingCalculatorInputs", function () { return $d80e3b774d43409a$export$8c44531ca473ca22; });
/* pricing-calculator-inputs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $7mfju = parcelRequire("7mfju");

var $11puL = parcelRequire("11puL");

var $E9GJt = parcelRequire("E9GJt");

var $5ohHq = parcelRequire("5ohHq");

var $j1tjc = parcelRequire("j1tjc");

var $iXUxi = parcelRequire("iXUxi");
const $d80e3b774d43409a$export$8c44531ca473ca22 = (props)=>{
    const { unitCountLabel: unitCountLabel, unitsLabel: unitsLabel, dataProductKey: dataProductKey } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const [billingCycle, setBillingCycle] = (0, $j1tjc.useBillingCycle)();
    const [unitCount, setUnitCount] = (0, $j1tjc.useUnitCount)();
    const hasMonthlyBilling = (0, $j1tjc.useSelector)($iXUxi.hasMonthlyBilling);
    const hasAnnualBilling = (0, $j1tjc.useSelector)($iXUxi.hasAnnualBilling); // @ts-ignore
    const { isVariation: isDirectBuyExperimentVariation } = (0, $11puL.useDirectBuyCohort)(dataProductKey);
    const [visualUnitCount, setVisualUnitCount] = (0, $iSvIT.useState)(// @ts-ignore
    unitCount);
    (0, $iSvIT.useEffect)(()=>{
        if (visualUnitCount !== "" && visualUnitCount > 0 && !Number.isNaN(visualUnitCount)) // @ts-ignore
        setUnitCount(visualUnitCount);
    }, [
        visualUnitCount
    ]);
    const handleUnitCountChange = (e)=>{
        const stringValue = e.target.value;
        if (stringValue === "") return setVisualUnitCount(""); // validate max number of digits
        // default is 5
        // TODO: make this configurable
        if (stringValue.length > 6) return;
        const numberValue = parseInt(stringValue, 10);
        if (numberValue < 1) return;
        setVisualUnitCount(numberValue);
    };
    const handleUnitCountBlurChange = ()=>{
        // @ts-ignore
        if (visualUnitCount === "") setVisualUnitCount(unitCount);
        const data = {
            unitCount: unitCount,
            productKey: dataProductKey
        };
        createAnalyticsEvent({
            eventType: "ui",
            eventName: `${(0, $7mfju.TRACKING_EVENT_NAMES).unitTierBox}_blurred`,
            eventComponent: "input",
            event: "blurred",
            actionSubject: (0, $7mfju.TRACKING_EVENT_NAMES).unitTierBox,
            action: "blurred",
            attributes: data,
            data: data
        }).fire();
    };
    const handleRadioChange = (billingCycle)=>{
        const data = {
            billingCycle: billingCycle,
            productKey: dataProductKey
        };
        createAnalyticsEvent({
            eventType: "ui",
            eventName: (0, $7mfju.TRACKING_EVENT_NAMES).billingCycleChanged,
            eventComponent: "radioButton",
            event: "clicked",
            actionSubject: (0, $7mfju.TRACKING_EVENT_NAMES).billingCycleChanged,
            action: "clicked",
            attributes: data
        }).fire();
        setBillingCycle(billingCycle);
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12fogza"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_p12f1kdj _19pk1wug _2hwx1wug _otyr1wug _18u01wug _b8yq1osq _3wvkidpf _1fbnidpf _1uby1wug _1t0ridpf"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_p12f1kdj _6rth1tcg _181n1txw _b8yq1osq _e8gh1h6o _19wgys9h"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _4cvr1h6o _181n1ule"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                                htmlFor: "unit-count",
                                className: (0, $esG4f.default)([
                                    "_ect4bzd7 _1wyb1j6v _1dyznl7k _k48pni7l _o5721q9c",
                                    "_12l2ftgi _syaz1hlo"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                                },
                                children: unitCountLabel
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _1bah1h6o _4cvr1h6o _1bsb1ns9 _15flidpf _1d2widpf _1svyidpf _seovidpf _1akoidpf _c7s7idpf _4puvidpf _1r3vidpf _181n116y _1t19kb7n _p7vbkb7n _1rhgf1ug"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                                    id: "unit-count",
                                    type: "number",
                                    value: visualUnitCount,
                                    onChange: handleUnitCountChange,
                                    onBlur: handleUnitCountBlurChange,
                                    "data-event-component": "inputNumber",
                                    "data-event-container": "priceBlock",
                                    "data-event": "clicked",
                                    className: (0, $esG4f.default)([
                                        "_syazalr3 _k48p1nn1 _1wyb1j6v _vwz41tcg _12l214y2 _ca0qftgi _u5f3i2wt _n3tdftgi _19bvi2wt _1bsb8ved _2rko1y44 _bfhk1hxd _19itglyw _13di444r _jh1sglyw _ji0mglyw"
                                    ])
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                                htmlFor: "unit-term",
                                className: (0, $esG4f.default)([
                                    "_syaz1mpp _ect4bzd7 _1wyb1j6v _1dyznl7k _k48p1nn1 _16jlkb7n _1o9zkb7n _i0dlf1ug"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                },
                                children: unitsLabel
                            })
                        ]
                    }),
                    hasMonthlyBilling && hasAnnualBilling && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $E9GJt.RadioButtons), {
                            wrap: false,
                            dataProductKey: dataProductKey,
                            selectedButtonId: billingCycle,
                            onChange: handleRadioChange,
                            groupLabel: /*#__PURE__*/ (0, $loA2J.jsx)("legend", {
                                className: (0, $esG4f.default)([
                                    "_ect4bzd7 _1wyb1j6v _1dyznl7k _k48pni7l _o5721q9c",
                                    "_1aax1e5h"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                },
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "Pricing.priceFinderInputs.billMeText",
                                    defaultMessage: "Bill me:"
                                })
                            }),
                            buttons: [
                                {
                                    id: "MONTHLY",
                                    label: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "Pricing.priceFinderInputs.monthly",
                                        defaultMessage: "Monthly"
                                    })
                                },
                                {
                                    id: "ANNUAL",
                                    label: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "Pricing.pricingCalculatorInputs.anually",
                                        defaultMessage: "Annually"
                                    }),
                                    lozenge: {
                                        appearance: "blue",
                                        text: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                            id: "Pricing.pricingCalculatorInputs.saveUpTo",
                                            defaultMessage: "SAVE UP TO 17%"
                                        })
                                    }
                                }
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $d80e3b774d43409a$var$labelStyles = null;
const $d80e3b774d43409a$var$legendStyles = null;
const $d80e3b774d43409a$var$inputTermStyle = null;
const $d80e3b774d43409a$var$inputCss = null;

});

parcelRegister("1rXz0", function(module, exports) {

$parcel$export(module.exports, "LoadingSpinner", function () { return $c4cc7b92cb3c529d$export$b08b517936747730; });
/* spinner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $9gh2a = parcelRequire("9gh2a");
const $c4cc7b92cb3c529d$export$b08b517936747730 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _4t3i1ogm _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            role: "alert",
            "aria-label": "Loading",
            "data-testid": "global-nav-user-profile-container-spinner",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gh2a.default), {})
        })
    });

});

parcelRegister("1JG1M", function(module, exports) {

$parcel$export(module.exports, "PriceAltContainer", function () { return $6dfad2080b0e1df0$export$4e62248194b0727b; });
/* price-alt-container.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");
const $6dfad2080b0e1df0$export$4e62248194b0727b = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        className: (0, $esG4f.default)([
            "_1wybdlk8 _y3gn1h6o"
        ]),
        children: props.children
    }));
};
const $6dfad2080b0e1df0$var$priceAltTextCss = null;

});

parcelRegister("1wBc7", function(module, exports) {

$parcel$export(module.exports, "MonthlyEnterpriseMessage", function () { return $866173e91f168028$export$16f86c6a635bb9af; });
/* monthly-enterprise-message.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $5ohHq = parcelRequire("5ohHq");

var $5YjMr = parcelRequire("5YjMr");

var $1JG1M = parcelRequire("1JG1M");
const $866173e91f168028$export$16f86c6a635bb9af = (props)=>{
    const { switchToAnnual: switchToAnnual } = props;
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1JG1M.PriceAltContainer), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                type: "button",
                onClick: switchToAnnual,
                tabIndex: 0,
                "data-event-component": "linkButton",
                "data-event": "clicked",
                className: (0, $esG4f.default)([
                    "_bfhk1j28 _19itidpf _80omtlke _syaz17la _ect41kw7 _1wyb1kw7 _vwz4idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l31ep1"
                ]),
                style: {
                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
                    "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
                },
                children: intl.formatMessage($5YjMr.billedAnnually)
            }),
            "\xa0",
            intl.formatMessage($5YjMr.switchToAnnualToViewEnterprise)
        ]
    });
};
const $866173e91f168028$var$buttonCss = null;

});
parcelRegister("5YjMr", function(module, exports) {

$parcel$export(module.exports, "recommended", function () { return $b760b6823903a84f$export$bc5b8d0824876806; });
$parcel$export(module.exports, "units", function () { return $b760b6823903a84f$export$fe0319385f0cf5a7; });
$parcel$export(module.exports, "perUserPerMonth", function () { return $b760b6823903a84f$export$d8b49137e99effc2; });
$parcel$export(module.exports, "perYear", function () { return $b760b6823903a84f$export$5eae4ab34e5b16ae; });
$parcel$export(module.exports, "aboveUnitMaxThreshold", function () { return $b760b6823903a84f$export$bf2ba8467ff15aa5; });
$parcel$export(module.exports, "belowUnitMinThreshold", function () { return $b760b6823903a84f$export$2e64ce41e89d1e18; });
$parcel$export(module.exports, "billedAnnually", function () { return $b760b6823903a84f$export$9e1a6bb525180618; });
$parcel$export(module.exports, "switchToAnnualToViewEnterprise", function () { return $b760b6823903a84f$export$3277af2b318f7bfa; });
$parcel$export(module.exports, "enterpriseJpyMessage", function () { return $b760b6823903a84f$export$68a1387c7d0a683f; });

var $6x1qA = parcelRequire("6x1qA");
const $b760b6823903a84f$export$bc5b8d0824876806 = (0, $6x1qA.defineMessage)({
    id: "priceFinder.recommended",
    defaultMessage: "Recommended"
});
const $b760b6823903a84f$export$fe0319385f0cf5a7 = (0, $6x1qA.defineMessages)({
    teamSizePrompt: {
        id: "priceFinder.teamSizePrompt",
        defaultMessage: "Team Size:"
    },
    usersUnitsLabel: {
        id: "priceFinder.usersUnitsLabel",
        defaultMessage: "users"
    },
    agentsUnitsLabel: {
        id: "priceFinder.agentsUnitsLabel",
        defaultMessage: "agents"
    }
});
const $b760b6823903a84f$export$d8b49137e99effc2 = (0, $6x1qA.defineMessage)({
    id: "priceFinder.perUnitPerMonth",
    defaultMessage: "per user / month"
});
const $b760b6823903a84f$export$5eae4ab34e5b16ae = (0, $6x1qA.defineMessage)({
    id: "priceFinder.perYear",
    defaultMessage: "per year"
});
const $b760b6823903a84f$export$bf2ba8467ff15aa5 = (0, $6x1qA.defineMessages)({
    default: {
        id: "priceFinder.aboveUserMaxThreshold.default",
        defaultMessage: "Your user count exceeds this plan's limit"
    },
    cloudEnterprise: {
        id: "priceFinder.aboveUserMaxThreshold.cloudEnterprise",
        defaultMessage: "Talk to our sales team about pricing for Cloud Enterprise"
    },
    agents: {
        id: "priceFinder.aboveUserMaxThreshold.agents",
        defaultMessage: "Your agent count exceeds this plan's limit"
    },
    specificCount: {
        id: "priceFinder.aboveUserMaxThreshold.specificCount",
        defaultMessage: "For teams of more than {lowerLimit}, contact our sales team."
    },
    creators: {
        id: "priceFinder.aboveUserMaxThreshold.creators",
        defaultMessage: "Your creator count exceeds this plan's limit"
    }
});
const $b760b6823903a84f$export$2e64ce41e89d1e18 = (0, $6x1qA.defineMessages)({
    cloudEnterprise: {
        id: "priceFinder.belowUnitMinThreshold.cloudEnterprise",
        defaultMessage: "Enterprise plan pricing is available when you enter {minUnitCount} or more users above"
    }
});
const $b760b6823903a84f$export$9e1a6bb525180618 = (0, $6x1qA.defineMessage)({
    id: "priceFinder.billedAnnually",
    defaultMessage: "Billed annually."
});
const $b760b6823903a84f$export$3277af2b318f7bfa = (0, $6x1qA.defineMessage)({
    id: "priceFinder.switchToAnnualToViewEnterprise",
    defaultMessage: "Switch to Annual billing above to view Enterprise pricing."
});
const $b760b6823903a84f$export$68a1387c7d0a683f = (0, $6x1qA.defineMessage)({
    id: "priceFinder.enterpriseJpyMessage",
    defaultMessage: "For pricing details see FAQ below or talk to our sales team"
});

});


parcelRegister("chlmU", function(module, exports) {

$parcel$export(module.exports, "getFeaturesList", function () { return $4be00d6905ab8116$export$501f60b80ced167; });
/* features-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $7uQnK = parcelRequire("7uQnK");

var $cyfPT = parcelRequire("cyfPT");
const $4be00d6905ab8116$export$501f60b80ced167 = (highlightedFeaturesContainer)=>{
    return highlightedFeaturesContainer === null || highlightedFeaturesContainer === void 0 ? void 0 : highlightedFeaturesContainer.map((feature)=>({
            label: feature.fields.highlightedFeatureTitleExternal,
            details: feature.fields.highlightedFeatureDetails && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_q7gqdlk8"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7uQnK.RichTextComponent), {
                    text: (0, $cyfPT.richTextToHTML)(// @ts-ignore
                    feature.fields.highlightedFeatureDetails)
                })
            }),
            lozengeText: feature.fields.highlightedLabel
        }));
};
const $4be00d6905ab8116$var$featureDetailsCss = null;

});

parcelRegister("fKqpx", function(module, exports) {

$parcel$export(module.exports, "UserTier", function () { return $3b63c85f893f58c4$export$cd4f9ca719669f8d; });
$parcel$export(module.exports, "UserTierExpanded", function () { return $3b63c85f893f58c4$export$a4c8408bf932bb2; });
/* user-tier.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6x1qA = parcelRequire("6x1qA");
var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");
const $3b63c85f893f58c4$export$cd4f9ca719669f8d = (props)=>{
    const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, numberFormatLocale: numberFormatLocale = "en-US", unitType: unitType } = props;
    const formatNumber = new Intl.NumberFormat(numberFormatLocale).format;
    if (unitType === "agent") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "PricingCalculator.agentTier.range",
        defaultMessage: "Agent tier: {lowerLimit} - {upperLimit}",
        values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
            lowerLimit: formatNumber(unitLimitLower),
            upperLimit: formatNumber(unitLimitUpper)
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "PriceFunder.userTier.range",
        defaultMessage: "User tier: {lowerLimit} - {upperLimit}",
        values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
            lowerLimit: formatNumber(unitLimitLower),
            upperLimit: formatNumber(unitLimitUpper)
        })
    });
};
const $3b63c85f893f58c4$export$a4c8408bf932bb2 = (props)=>{
    const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, unitsInTier: unitsInTier, unitsAvailableInTier: unitsAvailableInTier, numberFormatLocale: numberFormatLocale = "en-US" } = props;
    const intl = (0, $f6qj2.default)();
    const formatNumber = new Intl.NumberFormat(numberFormatLocale).format;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1wybdlk8 _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                children: [
                    intl.formatMessage($3b63c85f893f58c4$var$messages.tier),
                    /*#__PURE__*/ (0, $loA2J.jsx)("br", {}),
                    formatNumber(unitLimitLower),
                    " - ",
                    formatNumber(unitLimitUpper)
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                children: [
                    intl.formatMessage($3b63c85f893f58c4$var$messages.filledSeats),
                    /*#__PURE__*/ (0, $loA2J.jsx)("br", {}),
                    formatNumber(unitsInTier)
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                children: [
                    intl.formatMessage($3b63c85f893f58c4$var$messages.availableSeats),
                    /*#__PURE__*/ (0, $loA2J.jsx)("br", {}),
                    formatNumber(unitsAvailableInTier)
                ]
            })
        ]
    });
};
const $3b63c85f893f58c4$var$messages = (0, $6x1qA.defineMessages)({
    tier: {
        id: "PriceFinder.userTier.tier",
        defaultMessage: "Tier:"
    },
    filledSeats: {
        id: "PriceFinder.userTier.filledSeats",
        defaultMessage: "Filled seats:"
    },
    availableSeats: {
        id: "PriceFinder.userTier.availableSeats",
        defaultMessage: "Available seats:"
    }
});

});

parcelRegister("4oRsq", function(module, exports) {

$parcel$export(module.exports, "useLocalizedCtaUrl", function () { return $0ce07cf2e2166107$export$b5e9728b9b8ebe33; });

var $3FBn4 = parcelRequire("3FBn4");
function $0ce07cf2e2166107$export$b5e9728b9b8ebe33(ctaFields) {
    var _ctaFields_ctaUrl;
    return (0, $3FBn4.useLocalizedHref)((_ctaFields_ctaUrl = ctaFields === null || ctaFields === void 0 ? void 0 : ctaFields.ctaUrl) !== null && _ctaFields_ctaUrl !== void 0 ? _ctaFields_ctaUrl : "", {
        absolute: true
    });
}

});

parcelRegister("38spb", function(module, exports) {

$parcel$export(module.exports, "useConfluenceDirectBuyExperiment", function () { return $de6bf2b1b8db6126$export$fae015b2716f6f7; });
$parcel$export(module.exports, "ConfluenceDirectBuyButton", function () { return $de6bf2b1b8db6126$export$ac5f3af0a99903ed; });
// @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $3ayMq = parcelRequire("3ayMq");

var $2lcYG = parcelRequire("2lcYG");

var $lrAJa = parcelRequire("lrAJa");
parcelRequire("hqKpV");
var $1i1dJ = parcelRequire("1i1dJ");

var $j1tjc = parcelRequire("j1tjc");

var $iXUxi = parcelRequire("iXUxi");
function $de6bf2b1b8db6126$export$fae015b2716f6f7(props) {
    const { sku: sku } = props;
    const billingCycle = (0, $j1tjc.useSelector)((0, $iXUxi.getBillingCycle));
    return (0, $lrAJa.useDirectBuyExperiment)(billingCycle, sku, Object.values((0, $1i1dJ.confluenceOfferingSkus)).includes(// @ts-ignore
    sku));
}
const $de6bf2b1b8db6126$export$ac5f3af0a99903ed = (props)=>{
    const { sku: sku, edition: edition } = props;
    const pricingPlanId = (0, $j1tjc.useSelector)((ctx)=>(0, $iXUxi.getPricePlanId)(ctx, {
            offeringSku: sku,
            edition: edition
        }));
    const unitCount = (0, $j1tjc.useSelector)((0, $iXUxi.getUnitCount));
    let planName;
    if (edition === "standard") planName = "Standard";
    if (edition === "premium") planName = "Premium";
    if (!pricingPlanId || !planName) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $2lcYG.BuyNowButtonExperiment), {
        defaultUnitCount: (0, $1i1dJ.CONFLUENCE_DEFAULT_UNIT_COUNT),
        unitCount: unitCount,
        pricingPlanId: pricingPlanId,
        edition: edition,
        dataProductKey: (0, $3ayMq.CONFLUENCE_PRODUCT_KEY),
        planName: planName
    });
};

});

parcelRegister("9IdXN", function(module, exports) {

$parcel$export(module.exports, "RovoDevStandardPriceCard", function () { return $0517d00c4a6a340c$export$f0e8bcb2fb60056a; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $6OBwI = parcelRequire("6OBwI");
const $0517d00c4a6a340c$export$f0e8bcb2fb60056a = (props)=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.StandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        isSingleCard: true,
        monthlyPerUserLabel: intl.formatMessage({
            id: "RovoDevStandardPriceCard.monthlyPerUserLabel",
            defaultMessage: "per developer / month"
        })
    }));
};

});
parcelRegister("6OBwI", function(module, exports) {

$parcel$export(module.exports, "FreePriceCard", function () { return $bc086416dfe42289$export$75a717cafbbb6b29; });
$parcel$export(module.exports, "StandardPriceCard", function () { return $bc086416dfe42289$export$b2f3ad255eaef337; });
$parcel$export(module.exports, "PremiumPriceCard", function () { return $bc086416dfe42289$export$51a8509266751bd0; });
$parcel$export(module.exports, "EnterprisePriceCard", function () { return $bc086416dfe42289$export$ba2214b2dcd26743; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $3lPlV = parcelRequire("3lPlV");

var $4gHL4 = parcelRequire("4gHL4");

var $jNkbn = parcelRequire("jNkbn");

var $gEOac = parcelRequire("gEOac");
parcelRequire("MciJy");
var $4oRsq = parcelRequire("4oRsq");
var $38spb = parcelRequire("38spb");
var $chlmU = parcelRequire("chlmU");
var $1JG1M = parcelRequire("1JG1M");
var $fKqpx = parcelRequire("fKqpx");
var $1wBc7 = parcelRequire("1wBc7");

var $j1tjc = parcelRequire("j1tjc");

var $5YjMr = parcelRequire("5YjMr");

var $iXUxi = parcelRequire("iXUxi");
function $bc086416dfe42289$var$usePriceCardTryIntent(props) {
    const { productKey: productKey, edition: edition } = props;
    return (0, $4gHL4.useTryIntent)({
        containerId: (0, $3lPlV.PRICE_FINDER_CONTAINER),
        intentType: "button",
        productKey: productKey,
        edition: edition
    });
}
const $bc086416dfe42289$var$FREE_EDITION = "free";
const $bc086416dfe42289$export$75a717cafbbb6b29 = (props)=>{
    var _fields_microCta_, _fields_microCta;
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, customBannerText: customBannerText } = props;
    const fields = planData.fields;
    const state = (0, $gEOac.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $f6qj2.default)();
    const currencyIsoCode = (0, $j1tjc.useSelector)((0, $iXUxi.getCurrencyIsoCode));
    const cta = (_fields_microCta = fields.microCta) === null || _fields_microCta === void 0 ? void 0 : (_fields_microCta_ = _fields_microCta[0]) === null || _fields_microCta_ === void 0 ? void 0 : _fields_microCta_.fields;
    const ctaUrl = (0, $4oRsq.useLocalizedCtaUrl)(cta);
    const tryIntent = $bc086416dfe42289$var$usePriceCardTryIntent({
        productKey: props.trackingProductKey,
        edition: $bc086416dfe42289$var$FREE_EDITION
    });
    const dataEventPropsLabel = `${$bc086416dfe42289$var$FREE_EDITION}-get-it-now`;
    const { renderDirectBuyMatchSpace: renderDirectBuyMatchSpace } = (0, $38spb.useConfluenceDirectBuyExperiment)({
        sku: fields.sku
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jNkbn.PricingCard), {
        hasBannerSlot: true,
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText !== null && customBannerText !== void 0 ? customBannerText : state.recommended && intl.formatMessage($5YjMr.recommended),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: state.price,
        hasUnitSlot: true,
        hasRangeSlot: props.hasRangeSlot !== undefined ? props.hasRangeSlot : state.billingCycle === "ANNUAL",
        buttonText: cta === null || cta === void 0 ? void 0 : cta.ctaButtonText,
        buttonVariant: state.recommended ? "primary" : "secondary",
        buttonHref: ctaUrl,
        buttonProps: {
            onClick: tryIntent.onClick,
            onKeyDown: tryIntent.onKeyDown,
            dataEventProps: {
                "data-product-key": props.trackingProductKey,
                "data-event-component": "linkButton",
                "data-event-container": (0, $3lPlV.PRICE_FINDER_CONTAINER),
                "data-event": "clicked",
                "data-label": `${dataEventPropsLabel}`,
                "data-label-english": `${dataEventPropsLabel}`
            }
        },
        hasLinkSlot: renderDirectBuyMatchSpace,
        benefitsTitle: fields.highlightedFeaturesTitle,
        benefits: (0, $chlmU.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};
const $bc086416dfe42289$var$STANDARD_EDITION = "standard";
const $bc086416dfe42289$var$PREMIUM_EDITION = "premium";
const $bc086416dfe42289$export$b2f3ad255eaef337 = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)($bc086416dfe42289$var$CommonPriceCard, (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        edition: $bc086416dfe42289$var$STANDARD_EDITION
    }));
const $bc086416dfe42289$export$51a8509266751bd0 = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)($bc086416dfe42289$var$CommonPriceCard, (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        edition: $bc086416dfe42289$var$PREMIUM_EDITION
    }));
// eslint-disable-next-line complexity
const $bc086416dfe42289$var$CommonPriceCard = (props)=>{
    var _fields_microCta_, _fields_microCta;
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, tierLabelType: tierLabelType, customBannerText: customBannerText } = props;
    const fields = planData.fields;
    const state = (0, $gEOac.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $f6qj2.default)();
    const currencyIsoCode = (0, $j1tjc.useSelector)((0, $iXUxi.getCurrencyIsoCode));
    const dataEventPropsLabel = `${props.edition}-start-trial`;
    const cta = (_fields_microCta = fields.microCta) === null || _fields_microCta === void 0 ? void 0 : (_fields_microCta_ = _fields_microCta[0]) === null || _fields_microCta_ === void 0 ? void 0 : _fields_microCta_.fields;
    const ctaUrl = (0, $4oRsq.useLocalizedCtaUrl)(cta);
    const tryIntent = $bc086416dfe42289$var$usePriceCardTryIntent({
        productKey: props.trackingProductKey,
        edition: props.edition
    });
    const { renderDirectBuyBtn: renderDirectBuyBtn } = (0, $38spb.useConfluenceDirectBuyExperiment)({
        sku: fields.sku
    });
    const priceAltElement = (()=>{
        if (state.isUnitCountAboveMaxThreshold && props.priceAltElementForAboveMaxThreshold !== undefined) return props.priceAltElementForAboveMaxThreshold;
        return null;
    })();
    var _props_monthlyPerUserLabel;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jNkbn.PricingCard), {
        hasRangeSlot: state.isUnitCountAboveMaxThreshold && currencyIsoCode === "JPY" && state.billingCycle === "ANNUAL",
        hasBannerSlot: true,
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText !== null && customBannerText !== void 0 ? customBannerText : state.recommended && intl.formatMessage($5YjMr.recommended),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: !state.isUnitCountAboveMaxThreshold && state.price,
        priceAltElement: state.isUnitCountAboveMaxThreshold && props.priceAltElementForAboveMaxThreshold !== undefined ? priceAltElement : /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            children: intl.formatMessage($5YjMr.aboveUnitMaxThreshold.default)
        }),
        unit: state.isUnitCountAboveMaxThreshold ? undefined : state.billingCycle === "MONTHLY" ? (_props_monthlyPerUserLabel = props.monthlyPerUserLabel) !== null && _props_monthlyPerUserLabel !== void 0 ? _props_monthlyPerUserLabel : intl.formatMessage($5YjMr.perUserPerMonth) : intl.formatMessage($5YjMr.perYear),
        hasUnitSlot: true,
        range: state.billingCycle === "ANNUAL" && !props.omitRange && !state.isUnitCountAboveMaxThreshold && /*#__PURE__*/ (0, $loA2J.jsx)((0, $fKqpx.UserTier), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitType: tierLabelType
        }),
        tooltipContent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fKqpx.UserTierExpanded), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitsInTier: state.unitCount,
            unitsAvailableInTier: state.unitsAvailableInTier
        }),
        buttonText: cta === null || cta === void 0 ? void 0 : cta.ctaButtonText,
        buttonHref: ctaUrl,
        buttonDisabled: state.isUnitCountAboveMaxThreshold,
        buttonVariant: state.recommended || props.isSingleCard ? "primary" : "secondary",
        buttonProps: {
            onClick: tryIntent.onClick,
            onKeyDown: tryIntent.onKeyDown,
            dataEventProps: {
                "data-product-key": props.trackingProductKey,
                "data-event-component": "linkButton",
                "data-event-container": (0, $3lPlV.PRICE_FINDER_CONTAINER),
                "data-event": "clicked",
                "data-label": `${dataEventPropsLabel}`,
                "data-label-english": `${dataEventPropsLabel}`
            }
        },
        link: renderDirectBuyBtn && /*#__PURE__*/ (0, $loA2J.jsx)((0, $38spb.ConfluenceDirectBuyButton), {
            sku: fields.sku,
            edition: props.edition
        }),
        benefitsTitle: fields.highlightedFeaturesTitle,
        benefits: (0, $chlmU.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};
const $bc086416dfe42289$export$ba2214b2dcd26743 = (props)=>{
    var _fields_microCta_, _fields_microCta;
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, showBannerText: showBannerText = true, isSingleCard: isSingleCard, tierLabelType: tierLabelType, customBannerText: customBannerText, isJpyPriceEnabled: isJpyPriceEnabled } = props;
    const fields = planData.fields;
    const state = (0, $gEOac.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $f6qj2.default)();
    const currencyIsoCode = (0, $j1tjc.useSelector)((0, $iXUxi.getCurrencyIsoCode));
    const [_, changeBillingCycle] = (0, $j1tjc.useBillingCycle)();
    const priceAltElement = (()=>{
        if (props.priceAltElement !== undefined) return props.priceAltElement;
        if (currencyIsoCode === "JPY" && !isJpyPriceEnabled) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            children: intl.formatMessage($5YjMr.enterpriseJpyMessage)
        });
        if (state.billingCycle === "MONTHLY") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            style: {
                paddingBlockEnd: "24px"
            },
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1wBc7.MonthlyEnterpriseMessage), {
                switchToAnnual: ()=>changeBillingCycle("ANNUAL")
            })
        });
        if (state.isUnitCountAboveMaxThreshold) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            style: {
                paddingBlockEnd: "48px"
            },
            children: intl.formatMessage($5YjMr.aboveUnitMaxThreshold.cloudEnterprise)
        });
        if (state.isUnitCountBelowMinThreshold) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            style: {
                paddingBlockEnd: "48px"
            },
            children: intl.formatMessage($5YjMr.belowUnitMinThreshold.cloudEnterprise, {
                minUnitCount: state.unitCountMin
            })
        });
        return null;
    })();
    const isPriceShown = !state.isUnitCountAboveMaxThreshold && !priceAltElement;
    let price = undefined;
    let range = undefined;
    let tooltipContent = undefined;
    if (isPriceShown) {
        price = state.price;
        range = /*#__PURE__*/ (0, $loA2J.jsx)((0, $fKqpx.UserTier), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitType: tierLabelType
        });
        tooltipContent = /*#__PURE__*/ (0, $loA2J.jsx)((0, $fKqpx.UserTierExpanded), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitsInTier: state.unitCount,
            unitsAvailableInTier: state.unitsAvailableInTier
        });
    }
    const cta = (_fields_microCta = fields.microCta) === null || _fields_microCta === void 0 ? void 0 : (_fields_microCta_ = _fields_microCta[0]) === null || _fields_microCta_ === void 0 ? void 0 : _fields_microCta_.fields;
    const ctaUrl = (0, $4oRsq.useLocalizedCtaUrl)(cta);
    const edition = "enterprise";
    const tryIntent = $bc086416dfe42289$var$usePriceCardTryIntent({
        productKey: props.trackingProductKey,
        edition: edition
    });
    const dataEventPropsLabel = `${edition}-contact-sales`;
    const { renderDirectBuyMatchSpace: renderDirectBuyMatchSpace } = (0, $38spb.useConfluenceDirectBuyExperiment)({
        sku: fields.sku
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jNkbn.PricingCard), {
        hasBannerSlot: true,
        hasRangeSlot: currencyIsoCode === "JPY" && state.billingCycle === "ANNUAL",
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText !== null && customBannerText !== void 0 ? customBannerText : showBannerText && state.recommended && intl.formatMessage($5YjMr.recommended),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: price,
        priceAltElement: priceAltElement,
        unit: // if a price alt element exists, there should be no unit
        priceAltElement ? undefined : !state.isUnitCountAboveMaxThreshold && !state.isUnitCountBelowMinThreshold ? intl.formatMessage($5YjMr.perYear) : undefined,
        range: range,
        hasUnitSlot: // the unbounded text for the price alt element makes the unbounded
        currencyIsoCode === "JPY",
        tooltipContent: tooltipContent,
        buttonText: cta === null || cta === void 0 ? void 0 : cta.ctaButtonText,
        buttonHref: ctaUrl,
        buttonVariant: state.recommended || isSingleCard ? "primary" : "secondary",
        buttonProps: {
            onClick: tryIntent.onClick,
            onKeyDown: tryIntent.onKeyDown,
            dataEventProps: {
                "data-product-key": props.trackingProductKey,
                "data-event-component": "linkButton",
                "data-event-container": (0, $3lPlV.PRICE_FINDER_CONTAINER),
                "data-event": "clicked",
                "data-label": `${dataEventPropsLabel}`,
                "data-label-english": `${dataEventPropsLabel}`
            }
        },
        hasLinkSlot: renderDirectBuyMatchSpace,
        benefitsTitle: fields.highlightedFeaturesTitle,
        // in order for us to render just the top section fo a pricing card, the contentful data must be empty/undefined
        benefits: (0, $chlmU.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};

});
parcelRegister("3lPlV", function(module, exports) {

$parcel$export(module.exports, "PRICE_FINDER_CONTAINER", function () { return $3e5191e452008b58$export$c5526af38120e3f; });
const $3e5191e452008b58$export$c5526af38120e3f = "priceBlock";

});



parcelRegister("zcwoT", function(module, exports) {

$parcel$export(module.exports, "ServiceCollectionFreePriceCard", function () { return $2c2a7242901762ae$export$ce09fc7b6ac40092; });
$parcel$export(module.exports, "ServiceCollectionStandardPriceCard", function () { return $2c2a7242901762ae$export$84affe19123eb209; });
$parcel$export(module.exports, "ServiceCollectionPremiumPriceCard", function () { return $2c2a7242901762ae$export$1383d1ba03ed3746; });
$parcel$export(module.exports, "ServiceCollectionEnterprisePriceCard", function () { return $2c2a7242901762ae$export$c277b80f2da61f89; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $6OBwI = parcelRequire("6OBwI");
const $2c2a7242901762ae$export$ce09fc7b6ac40092 = (props)=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.FreePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};
const $2c2a7242901762ae$export$84affe19123eb209 = (props)=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.StandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};
const $2c2a7242901762ae$export$1383d1ba03ed3746 = (props)=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.PremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};
const $2c2a7242901762ae$export$c277b80f2da61f89 = (props)=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.EnterprisePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};

});

parcelRegister("3A3AJ", function(module, exports) {

$parcel$export(module.exports, "LoomFreePriceCard", function () { return $e968a4dcab76f69a$export$947796c8957ff6ff; });
$parcel$export(module.exports, "LoomBusinessPriceCard", function () { return $e968a4dcab76f69a$export$2a7af2744a13b8c2; });
$parcel$export(module.exports, "LoomBusinessPlusAiPriceCard", function () { return $e968a4dcab76f69a$export$efaf4c20492b36b7; });
$parcel$export(module.exports, "LoomEnterprisePriceCard", function () { return $e968a4dcab76f69a$export$d88b84b01ca5e441; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $j1tjc = parcelRequire("j1tjc");

var $6OBwI = parcelRequire("6OBwI");
const $e968a4dcab76f69a$var$OMIT_TIER_UNIT_THRESHOLD = 26;
const $e968a4dcab76f69a$export$947796c8957ff6ff = (props)=>{
    const omitRange = $e968a4dcab76f69a$var$useOmitRange();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.FreePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        omitRange: omitRange,
        hasRangeSlot: omitRange ? false : undefined
    }));
};
const $e968a4dcab76f69a$export$2a7af2744a13b8c2 = (props)=>{
    const omitRange = $e968a4dcab76f69a$var$useOmitRange();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.StandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        omitRange: omitRange
    }));
};
const $e968a4dcab76f69a$export$efaf4c20492b36b7 = (props)=>{
    const omitRange = $e968a4dcab76f69a$var$useOmitRange();
    const intl = (0, $f6qj2.default)();
    const customBannerText = intl.formatMessage({
        id: "LoomBusinessPlusAiPriceCard.mostPopular",
        defaultMessage: "Most popular"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.PremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        omitRange: omitRange,
        customBannerText: customBannerText
    }));
};
const $e968a4dcab76f69a$export$d88b84b01ca5e441 = (props)=>{
    const omitRange = $e968a4dcab76f69a$var$useOmitRange();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.EnterprisePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        omitRange: omitRange,
        priceAltElement: /*#__PURE__*/ (0, $loA2J.jsx)("div", {})
    }));
};
const $e968a4dcab76f69a$var$useOmitRange = ()=>{
    const [billingCycle] = (0, $j1tjc.useBillingCycle)();
    const [unitCount] = (0, $j1tjc.useUnitCount)();
    return billingCycle === "ANNUAL" && unitCount < $e968a4dcab76f69a$var$OMIT_TIER_UNIT_THRESHOLD;
};

});

parcelRegister("ebQhK", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryFreePriceCard", function () { return $857985716a1569a3$export$9301352401a96395; });
$parcel$export(module.exports, "JiraProductDiscoveryStandardPriceCard", function () { return $857985716a1569a3$export$f632b4bee5bd80fe; });
$parcel$export(module.exports, "JiraProductDiscoveryPremiumPriceCard", function () { return $857985716a1569a3$export$1fb355a43910f211; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $5YjMr = parcelRequire("5YjMr");

var $1JG1M = parcelRequire("1JG1M");

var $6OBwI = parcelRequire("6OBwI");
const $857985716a1569a3$export$9301352401a96395 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.FreePriceCard), (0, $7Knp0._)({}, props));
};
const $857985716a1569a3$export$f632b4bee5bd80fe = (props)=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.StandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        tierLabelType: "user",
        monthlyPerUserLabel: intl.formatMessage({
            id: "JiraProductDiscoveryPriceCard.perCreatorPerMonth",
            defaultMessage: "per creator / month"
        }),
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            children: intl.formatMessage($5YjMr.aboveUnitMaxThreshold.creators)
        })
    }));
};
const $857985716a1569a3$export$1fb355a43910f211 = (props)=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.PremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        tierLabelType: "user",
        monthlyPerUserLabel: intl.formatMessage({
            id: "JiraProductDiscoveryPriceCard.perCreatorPerMonth",
            defaultMessage: "per creator / month"
        }),
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            children: intl.formatMessage($5YjMr.aboveUnitMaxThreshold.creators)
        })
    }));
};

});


parcelRegister("bU2dC", function(module, exports) {

$parcel$export(module.exports, "useProviderProps", function () { return $e2230c4ac3c21599$export$521c373ccc32c300; });
// @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $9kpo9 = parcelRequire("9kpo9");

var $9Cnr8 = parcelRequire("9Cnr8");

var $8EXPa = parcelRequire("8EXPa");

var $iRy5O = parcelRequire("iRy5O");

var $1i1dJ = parcelRequire("1i1dJ");

var $5Rijz = parcelRequire("5Rijz");

var $ktygn = parcelRequire("ktygn");

var $5kiq4 = parcelRequire("5kiq4");

var $1F9wN = parcelRequire("1F9wN");

var $fNdr1 = parcelRequire("fNdr1");

var $3ItZP = parcelRequire("3ItZP");

var $awylZ = parcelRequire("awylZ");

var $fPLSq = parcelRequire("fPLSq");

var $j1tjc = parcelRequire("j1tjc");
function $e2230c4ac3c21599$export$521c373ccc32c300(props) {
    const { plans: plans, product: product } = props;
    const locale = (0, $9kpo9.useLocale)();
    const currencyISOCode = (0, $9Cnr8.getCurrencyFromUserLocale)(locale);
    const ssrData = plans.reduce((acc, plan)=>{
        return (0, $6iHNw._)((0, $7Knp0._)({}, acc), {
            [plan.fields.sku]: plan.pricingPlan
        });
    }, {});
    const { data: ccpPricingData, status: status } = (0, $j1tjc.useCcpPricingData)({
        offeringSkus: plans.map((plan)=>plan.fields.sku),
        ssrData: ssrData
    });
    if (status === "error") return {
        status: "error"
    };
    if (status === "pending") return {
        status: "pending"
    };
    if (product === "jira") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $ktygn.JIRA_DEFAULT_BILLING_CYCLE,
                unitCount: $ktygn.JIRA_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $ktygn.jiraPlanLimitConfigs,
                unitMinEnterprise: $ktygn.JIRA_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: {
                    monthly: true,
                    annual: true
                }
            }
        }
    };
    if (product === "confluence") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $1i1dJ.CONFLUENCE_DEFAULT_BILLING_CYCLE,
                unitCount: $1i1dJ.CONFLUENCE_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $1i1dJ.confluencePlanLimitConfigs,
                unitMinEnterprise: $1i1dJ.CONFLUENCE_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: {
                    monthly: true,
                    annual: true
                }
            }
        }
    };
    if (product === "teamwork") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $fPLSq.TEAMWORK_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: $fPLSq.TEAMWORK_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $fPLSq.teamworkCollectionPlanLimitConfigs,
                unitMinEnterprise: $fPLSq.TEAMWORK_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $fPLSq.teamworkCollectionBillingCycleConfig
            }
        }
    };
    if (product === "guard") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $5Rijz.GUARD_DEFAULT_BILLING_CYCLE,
                unitCount: $5Rijz.GUARD_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $5Rijz.guardPlanLimitConfigs,
                unitMinEnterprise: $5Rijz.GUARD_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $5Rijz.guardBillingCycleConfig
            }
        }
    };
    if (product === "bitbucket") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $8EXPa.BITBUCKET_DEFAULT_BILLING_CYCLE,
                unitCount: $8EXPa.BITBUCKET_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $8EXPa.bitbucketPlanLimitConfigs,
                unitMinEnterprise: $8EXPa.BITBUCKET_MIN_ENTERPRISE_USER_COUNT,
                // bitbucket only supports USD
                currencyISOCode: "USD",
                localeISOCode: locale,
                billingCycleConfig: $8EXPa.bitbucketBillingCycleConfig
            }
        }
    };
    if (product === "strategy") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $awylZ.STRATEGY_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: $awylZ.STRATEGY_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $awylZ.strategyCollectionPlanLimitConfigs,
                unitMinEnterprise: $awylZ.STRATEGY_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $awylZ.strategyCollectionBillingCycleConfig
            }
        }
    };
    if (product === "compass") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $iRy5O.COMPASS_DEFAULT_BILLING_CYCLE,
                unitCount: $iRy5O.COMPASS_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $iRy5O.compassPlanLimitConfigs,
                // not sure why this field is necessary
                unitMinEnterprise: $iRy5O.COMPASS_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $iRy5O.compassBillingCycleConfig
            }
        }
    };
    if (product === "service") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $3ItZP.SERVICE_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: $3ItZP.SERVICE_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $3ItZP.serviceCollectionPlanLimitConfigs,
                unitMinEnterprise: $3ItZP.SERVICE_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $3ItZP.serviceCollectionBillingCycleConfig
            }
        }
    };
    if (product === "rovo-dev") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $fNdr1.ROVO_DEV_DEFAULT_BILLING_CYCLE,
                unitCount: $fNdr1.ROVO_DEV_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $fNdr1.rovoDevPlanLimitConfigs,
                unitMinEnterprise: $fNdr1.ROVO_DEV_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $fNdr1.rovoDevBillingCycleConfig
            }
        }
    };
    if (product === "loom") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $1F9wN.LOOM_DEFAULT_BILLING_CYCLE,
                unitCount: $1F9wN.LOOM_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $1F9wN.loomPlanLimitConfigs,
                unitMinEnterprise: $1F9wN.LOOM_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $1F9wN.loomBillingCycleConfig
            }
        }
    };
    if (product === "product-discovery") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $5kiq4.JPD_DEFAULT_BILLING_CYCLE,
                unitCount: $5kiq4.JPD_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $5kiq4.jpdPlanLimitConfigs,
                unitMinEnterprise: $5kiq4.JPD_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $5kiq4.jpdBillingCycleConfig
            }
        }
    };
    throw new Error("unknown product");
}

});
parcelRegister("9kpo9", function(module, exports) {
"use strict";
var $6ca9acf34c85a58f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6ca9acf34c85a58f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6ca9acf34c85a58f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6ca9acf34c85a58f$var$__exportStar((parcelRequire("lzarR")), module.exports);

});
parcelRegister("lzarR", function(module, exports) {
"use strict";
var $fb34f8afabff3c89$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fb34f8afabff3c89$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fb34f8afabff3c89$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fb34f8afabff3c89$var$__exportStar((parcelRequire("lrT2K")), module.exports);

$fb34f8afabff3c89$var$__exportStar((parcelRequire("jJk5Z")), module.exports);

$fb34f8afabff3c89$var$__exportStar((parcelRequire("iZOWt")), module.exports);

$fb34f8afabff3c89$var$__exportStar((parcelRequire("3XOWT")), module.exports);

});
parcelRegister("lrT2K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LOCALES = module.exports.LOCALE_REGISTRY = module.exports.DEFAULT_LOCALE = void 0;
module.exports.DEFAULT_LOCALE = "en";
module.exports.LOCALE_REGISTRY = Object.freeze({
    [module.exports.DEFAULT_LOCALE]: {
        label: "English"
    },
    de: {
        label: "Deutsch"
    },
    es: {
        label: "Espa\xf1ol"
    },
    fr: {
        label: "Fran\xe7ais"
    },
    it: {
        label: "Italiano"
    },
    ko: {
        label: "\uD55C\uAD6D\uC5B4"
    },
    nl: {
        label: "Nederlands"
    },
    ja: {
        label: "\u65E5\u672C\u8A9E"
    },
    pl: {
        label: "Polski"
    },
    br: {
        label: "Portugu\xeas"
    },
    ru: {
        label: "\u0440\u0443\u0441\u0441\u043A\u0438\u0439"
    },
    zh: {
        label: "\u4E2D\u6587"
    }
});
module.exports.LOCALES = Object.keys(module.exports.LOCALE_REGISTRY);

});

parcelRegister("jJk5Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useLocale = $e5d1ceda02205161$var$useLocale;

var $f6qj2 = parcelRequire("f6qj2");
function $e5d1ceda02205161$var$useLocale() {
    const intl = (0, $f6qj2.default)();
    return intl.locale;
}

});

parcelRegister("iZOWt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useLocalizedHref = $dd457090bbf63b1d$var$useLocalizedHref;

var $lrT2K = parcelRequire("lrT2K");

var $jJk5Z = parcelRequire("jJk5Z");
function $dd457090bbf63b1d$var$useLocalizedHref(href) {
    const locale = (0, $jJk5Z.useLocale)();
    if (locale === $lrT2K.DEFAULT_LOCALE) return href;
    else return `/${locale}${href}`;
}

});

parcelRegister("3XOWT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_VALUES = void 0;

var $loA2J = parcelRequire("loA2J");
module.exports.DEFAULT_VALUES = Object.freeze({
    br: (0, $loA2J.jsx)("br", {}),
    p: (chunks)=>(0, $loA2J.jsx)("p", {
            children: chunks
        }),
    strong: (chunks)=>(0, $loA2J.jsx)("strong", {
            children: chunks
        }),
    span: (chunks)=>(0, $loA2J.jsx)("span", {
            children: chunks
        })
});

});




parcelRegister("hmeL1", function(module, exports) {

$parcel$export(module.exports, "PricingCalculatorCard", function () { return $0a37e8017914ab10$export$14072311c149f96f; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $3ayMq = parcelRequire("3ayMq");
parcelRequire("MciJy");
var $9IdXN = parcelRequire("9IdXN");
var $zcwoT = parcelRequire("zcwoT");
var $3A3AJ = parcelRequire("3A3AJ");
var $ebQhK = parcelRequire("ebQhK");

var $cMtLi = parcelRequire("cMtLi");

var $6OBwI = parcelRequire("6OBwI");

var $8EXPa = parcelRequire("8EXPa");
parcelRequire("hqKpV");
var $ktygn = parcelRequire("ktygn");
var $1i1dJ = parcelRequire("1i1dJ");
var $fPLSq = parcelRequire("fPLSq");
var $iRy5O = parcelRequire("iRy5O");
var $5Rijz = parcelRequire("5Rijz");
var $awylZ = parcelRequire("awylZ");
var $fNdr1 = parcelRequire("fNdr1");
var $3ItZP = parcelRequire("3ItZP");
var $1F9wN = parcelRequire("1F9wN");
var $5kiq4 = parcelRequire("5kiq4");
const $0a37e8017914ab10$export$14072311c149f96f = (props)=>{
    const sku = props.planData.fields.sku;
    const trackingProductKey = (0, $3ayMq.urlSlugToDataProductKey)[props.urlSlug];
    switch(sku){
        // Free
        case (0, $ktygn.jiraOfferingSkus).free:
        case (0, $1i1dJ.confluenceOfferingSkus).free:
        case (0, $fPLSq.teamworkCollectionOfferingSkus).free:
        case (0, $iRy5O.compassOfferingSkus).free:
        case (0, $8EXPa.bitbucketOfferingSkus).free:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.FreePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        // Standard
        case (0, $ktygn.jiraOfferingSkus).standard:
        case (0, $1i1dJ.confluenceOfferingSkus).standard:
        case (0, $fPLSq.teamworkCollectionOfferingSkus).standard:
        case (0, $5Rijz.guardOfferingSkus).standard:
        case (0, $iRy5O.compassOfferingSkus).standard:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.StandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $8EXPa.bitbucketOfferingSkus).standard:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cMtLi.BitbucketStandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        // Premium
        case (0, $ktygn.jiraOfferingSkus).premium:
        case (0, $1i1dJ.confluenceOfferingSkus).premium:
        case (0, $fPLSq.teamworkCollectionOfferingSkus).premium:
        case (0, $5Rijz.guardOfferingSkus).premium:
        case (0, $iRy5O.compassOfferingSkus).premium:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.PremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $8EXPa.bitbucketOfferingSkus).premium:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cMtLi.BitbucketPremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        // Enterprise
        case (0, $ktygn.jiraOfferingSkus).enterprise:
        case (0, $1i1dJ.confluenceOfferingSkus).enterprise:
        case (0, $fPLSq.teamworkCollectionOfferingSkus).enterprise:
            // @ts-ignore
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.EnterprisePriceCard), (0, $7Knp0._)({}, props));
        case (0, $awylZ.strategyCollectionOfferingSkus).enterprise:
            // @ts-ignore
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.EnterprisePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                isJpyPriceEnabled: true
            }));
        // Custom, for any tier
        case (0, $fNdr1.rovoDevOfferingSkus).standard:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9IdXN.RovoDevStandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $3ItZP.serviceCollectionOfferingSkus).free:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $zcwoT.ServiceCollectionFreePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $3ItZP.serviceCollectionOfferingSkus).standard:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $zcwoT.ServiceCollectionStandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $3ItZP.serviceCollectionOfferingSkus).premium:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $zcwoT.ServiceCollectionPremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $3ItZP.serviceCollectionOfferingSkus).enterprise:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $zcwoT.ServiceCollectionEnterprisePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $1F9wN.loomOfferingSkus).free:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3A3AJ.LoomFreePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $1F9wN.loomOfferingSkus).business:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3A3AJ.LoomBusinessPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $1F9wN.loomOfferingSkus).businessPlusAi:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3A3AJ.LoomBusinessPlusAiPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $1F9wN.loomOfferingSkus).enterprise:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3A3AJ.LoomEnterprisePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $5kiq4.jpdOfferingSkus).free:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $ebQhK.JiraProductDiscoveryFreePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $5kiq4.jpdOfferingSkus).standard:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $ebQhK.JiraProductDiscoveryStandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $5kiq4.jpdOfferingSkus).premium:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $ebQhK.JiraProductDiscoveryPremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        default:
            // todo: @bsparks GWP-6943 fire an event for unexpected sku
            return null;
    }
};

});
parcelRegister("cMtLi", function(module, exports) {

$parcel$export(module.exports, "BitbucketStandardPriceCard", function () { return $e7bfa2be1f5e3998$export$3f65201715c64fe0; });
$parcel$export(module.exports, "BitbucketPremiumPriceCard", function () { return $e7bfa2be1f5e3998$export$3845e26e0454185b; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $8EXPa = parcelRequire("8EXPa");

var $5YjMr = parcelRequire("5YjMr");

var $1JG1M = parcelRequire("1JG1M");

var $6OBwI = parcelRequire("6OBwI");
const $e7bfa2be1f5e3998$export$3f65201715c64fe0 = (props)=>{
    const intl = (0, $f6qj2.default)();
    const formattedLimit = intl.formatNumber((0, $8EXPa.BITBUCKET_SIGNUP_LIMIT));
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.StandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            children: intl.formatMessage($5YjMr.aboveUnitMaxThreshold.specificCount, {
                lowerLimit: formattedLimit
            })
        })
    }));
};
const $e7bfa2be1f5e3998$export$3845e26e0454185b = (props)=>{
    const intl = (0, $f6qj2.default)();
    const formattedLimit = intl.formatNumber((0, $8EXPa.BITBUCKET_SIGNUP_LIMIT));
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.PremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            children: intl.formatMessage($5YjMr.aboveUnitMaxThreshold.specificCount, {
                lowerLimit: formattedLimit
            })
        })
    }));
};

});




parcelRegister("9nWUO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("3OzIV")).default; });

var $3OzIV = parcelRequire("3OzIV");

});
parcelRegister("3OzIV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02de01c697849ba2$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("aYZfk");
var $iRRBp = parcelRequire("iRRBp");

var $lQMRe = parcelRequire("lQMRe");
const $02de01c697849ba2$var$UniformPricingTable = (props)=>{
    const { tableData: tableData = [], planTitles: planTitles } = props;
    const effectivePlanTitles = planTitles.map(({ fields: fields })=>fields.planTitleExternal);
    const transformedSections = (0, $lQMRe.transformContentfulDataToTableData)(tableData, effectivePlanTitles);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iRRBp.Table), {
        header: {
            titles: [
                "",
                ...effectivePlanTitles
            ]
        },
        sections: transformedSections
    });
};
var $02de01c697849ba2$export$2e2bcd8739ae039 = $02de01c697849ba2$var$UniformPricingTable;

});
parcelRegister("aYZfk", function(module, exports) {
$parcel$export(module.exports, "Table", function () { return (parcelRequire("iRRBp")).Table; });
parcelRequire("iRRBp");

});
parcelRegister("iRRBp", function(module, exports) {

$parcel$export(module.exports, "Table", function () { return $90c5e4ded2bc5115$export$54ec01a60f47d33d; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("bwop0");
var $aBMfN = parcelRequire("aBMfN");

var $5KYDU = parcelRequire("5KYDU");

var $54y9B = parcelRequire("54y9B");

var $Hw7na = parcelRequire("Hw7na");

var $2NR3S = parcelRequire("2NR3S");
const $90c5e4ded2bc5115$export$54ec01a60f47d33d = (props)=>{
    const { sections: sections, header: header } = props;
    const columnCount = (0, $2NR3S.getColumnCount)(sections);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $aBMfN.Table), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $54y9B.Header), (0, $7Knp0._)({}, header)),
            /*#__PURE__*/ (0, $loA2J.jsx)("tbody", {
                children: sections.map((section, sectionIndex)=>{
                    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $Hw7na.SectionHeader), {
                                sectionTitle: section.title,
                                totalColumnCount: columnCount
                            }),
                            section.rows.map((row, rowIndex)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $5KYDU.ContentRow), {
                                    row: row,
                                    rowKey: `${sectionIndex}-${rowIndex}`,
                                    columnTitles: header.titles
                                }, `${sectionIndex}-${rowIndex}`))
                        ]
                    }, sectionIndex);
                })
            })
        ]
    });
};

});
parcelRegister("bwop0", function(module, exports) {
$parcel$export(module.exports, "Table", function () { return (parcelRequire("aBMfN")).Table; });
$parcel$export(module.exports, "Row", function () { return (parcelRequire("jBZAY")).Row; });
$parcel$export(module.exports, "RowCell", function () { return (parcelRequire("jBZAY")).RowCell; });
$parcel$export(module.exports, "RowHeaderCell", function () { return (parcelRequire("jBZAY")).RowHeaderCell; });
$parcel$export(module.exports, "Head", function () { return (parcelRequire("52o7a")).Head; });
$parcel$export(module.exports, "HeadCell", function () { return (parcelRequire("52o7a")).HeadCell; });
$parcel$export(module.exports, "HeadRow", function () { return (parcelRequire("52o7a")).HeadRow; });
$parcel$export(module.exports, "SectionHeader", function () { return (parcelRequire("jF79E")).SectionHeader; });
$parcel$export(module.exports, "SectionHeaderCell", function () { return (parcelRequire("jF79E")).SectionHeaderCell; });
parcelRequire("aBMfN");
parcelRequire("jBZAY");
parcelRequire("52o7a");
parcelRequire("jF79E");

});
parcelRegister("aBMfN", function(module, exports) {

$parcel$export(module.exports, "Table", function () { return $ffe506304ebe021b$export$54ec01a60f47d33d; });
/* table.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");
const $ffe506304ebe021b$export$54ec01a60f47d33d = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("table", (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        className: (0, $esG4f.default)([
            "_2lx21bp4 _1kqm1n9t _1bsb1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _y3gn1h6o _yq5hcfaq _btyzidpf _suga1txw _1e0c5mfb"
        ])
    }));
};
const $ffe506304ebe021b$var$tableCss = null;

});

parcelRegister("jBZAY", function(module, exports) {

$parcel$export(module.exports, "Row", function () { return $2aa512b05205b590$export$b59bdbef9ce70de2; });
$parcel$export(module.exports, "RowHeaderCell", function () { return $2aa512b05205b590$export$90b286dd97c43ca1; });
$parcel$export(module.exports, "RowCell", function () { return $2aa512b05205b590$export$502da2b9cfd708e5; });
/* row.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $5ohHq = parcelRequire("5ohHq");
const $2aa512b05205b590$export$b59bdbef9ce70de2 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("tr", (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        className: (0, $esG4f.default)([
            "_19pk7vkz _2hwxidpf _otyr7vkz _18u0idpf _bfhkcd5j _v56411zw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _y3gn1h6o _1ckvidpf _irr31rga _1o4gu1j4 _a5ztgktf _suga1txw _1gde1bp4"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100")),
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
        }
    }));
};
const $2aa512b05205b590$export$90b286dd97c43ca1 = (props)=>{
    const { children: children } = props, tdProps = (0, $akGnX._)(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("td", (0, $6iHNw._)((0, $7Knp0._)({}, tdProps), {
        className: (0, $esG4f.default)([
            "_y3gnv2br _16nmgktf _1w6hgktf _gtp7150w _1kmxdlk8 _1ggmdlk8 _1ykzdlk8 _1maedlk8",
            "_s7n4jp4b _1bah1yb4 _4cvr1h6o _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zyzqy _10msglyw"
        ]),
        style: {
            "--_8nj8hf": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light200")),
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            className: (0, $esG4f.default)([
                "_1bsb1osq _1reo15vq"
            ]),
            children: children
        })
    }));
};
const $2aa512b05205b590$export$502da2b9cfd708e5 = (props)=>{
    const { children: children = null, columnTitle: columnTitle } = props, tdProps = (0, $akGnX._)(props, [
        "children",
        "columnTitle"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("td", (0, $6iHNw._)((0, $7Knp0._)({}, tdProps), {
        className: (0, $esG4f.default)([
            "_s7n4jp4b _1bah1yb4 _4cvr1h6o _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zyzqy _10msglyw"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_181nglyw"
                ]),
                children: columnTitle
            }),
            children
        ]
    }));
};
const $2aa512b05205b590$var$rowCss = null;
const $2aa512b05205b590$var$rowHeaderCellCss = null;
const $2aa512b05205b590$var$rowHeaderCellSpanCss = null;
const $2aa512b05205b590$var$cellCss = null;
const $2aa512b05205b590$var$cellColumnTitleCss = null;

});

parcelRegister("52o7a", function(module, exports) {

$parcel$export(module.exports, "Head", function () { return $933bdcbf8a46a400$export$e93312b7773dfcac; });
$parcel$export(module.exports, "HeadRow", function () { return $933bdcbf8a46a400$export$b008e842a2213343; });
$parcel$export(module.exports, "HeadCell", function () { return $933bdcbf8a46a400$export$4e8024263ace498b; });
/* head.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $5ohHq = parcelRequire("5ohHq");
const $933bdcbf8a46a400$export$e93312b7773dfcac = (props)=>{
    const { stickyOffset: stickyOffset } = props;
    return /*#__PURE__*/ (0, $loA2J.jsx)("thead", (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        className: (0, $esG4f.default)([
            "_179ru1j4 _sugaglyw _1pbykb7n _11q7cd5j"
        ]),
        style: (0, $6iHNw._)((0, $7Knp0._)({}, stickyOffset === undefined ? {} : {
            top: stickyOffset,
            position: "sticky"
        }), {
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400")),
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        })
    }));
};
const $933bdcbf8a46a400$export$b008e842a2213343 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("tr", (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        className: (0, $esG4f.default)([
            "_17gvangw _7dd6v2br"
        ])
    }));
};
const $933bdcbf8a46a400$export$4e8024263ace498b = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("th", (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        scope: "col",
        className: (0, $esG4f.default)([
            "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zyzqy _10msglyw"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
        }
    }));
};
const $933bdcbf8a46a400$var$headCss = null;
const $933bdcbf8a46a400$var$headRowCss = null;
const $933bdcbf8a46a400$var$headCellStyles = null;

});

parcelRegister("jF79E", function(module, exports) {

$parcel$export(module.exports, "SectionHeader", function () { return $57e91e78af4acf28$export$8adb256d999cd5a0; });
$parcel$export(module.exports, "SectionHeaderCell", function () { return $57e91e78af4acf28$export$32421cd0bed4993f; });
/* section.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $5ohHq = parcelRequire("5ohHq");
const $57e91e78af4acf28$export$8adb256d999cd5a0 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("tr", (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        className: (0, $esG4f.default)([
            "_syaz1hlo _2lx21bp4 _19pk7vkz _2hwxidpf _otyr7vkz _18u0idpf _bfhk1rga _v56411zw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _y3gn1h6o _sugaglyw"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
        }
    }));
};
const $57e91e78af4acf28$export$32421cd0bed4993f = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("td", (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        className: (0, $esG4f.default)([
            "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zyzqy _10msglyw"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
        }
    }));
};
const $57e91e78af4acf28$var$sectionHeaderCss = null;
const $57e91e78af4acf28$var$sectionHeaderCellCss = null;

});


parcelRegister("5KYDU", function(module, exports) {

$parcel$export(module.exports, "ContentRow", function () { return $dfdd9714744d1af7$export$47e3a1a30e4428e1; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");
parcelRequire("bwop0");
var $jBZAY = parcelRequire("jBZAY");

var $cmvVn = parcelRequire("cmvVn");
const $dfdd9714744d1af7$export$47e3a1a30e4428e1 = (props)=>{
    const { row: row, rowKey: rowKey, columnTitles: columnTitles } = props;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jBZAY.Row), {
        children: row.map((cell, cellIndex)=>cellIndex === 0 ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $jBZAY.RowHeaderCell), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cmvVn.ContentCell), {
                    isRowHeader: true,
                    cellData: cell
                })
            }, cellIndex) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $jBZAY.RowCell), {
                // @ts-ignore
                columnTitle: columnTitles[cellIndex],
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cmvVn.ContentCell), {
                    cellData: cell
                })
            }, cellIndex))
    }, rowKey);
};

});
parcelRegister("cmvVn", function(module, exports) {

$parcel$export(module.exports, "ContentCell", function () { return $2c7a928e1976f815$export$6245b75abe178459; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");
parcelRequire("lq8nC");
var $5nSlB = parcelRequire("5nSlB");
const $2c7a928e1976f815$export$6245b75abe178459 = (props)=>{
    const { cellData: cellData, isRowHeader: isRowHeader } = props;
    if (cellData === null) return null;
    switch(cellData.type){
        case "text":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5nSlB.CellTextContent), {
                data: cellData,
                isRowHeader: isRowHeader
            });
        case "check":
            // @ts-ignore
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5nSlB.CellCheckContent), {
                data: cellData
            });
        case "expander":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5nSlB.CellExpanderContent), {
                data: cellData
            });
        case "hyperlink":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5nSlB.CellHyperlinkContent), {
                data: cellData
            });
        case "render":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5nSlB.CellRenderContent), {
                data: cellData
            });
        default:
            return null;
    }
};

});
parcelRegister("lq8nC", function(module, exports) {
$parcel$export(module.exports, "CellCheckContent", function () { return (parcelRequire("5nSlB")).CellCheckContent; });
$parcel$export(module.exports, "CellExpanderContent", function () { return (parcelRequire("5nSlB")).CellExpanderContent; });
$parcel$export(module.exports, "CellHyperlinkContent", function () { return (parcelRequire("5nSlB")).CellHyperlinkContent; });
$parcel$export(module.exports, "CellRenderContent", function () { return (parcelRequire("5nSlB")).CellRenderContent; });
$parcel$export(module.exports, "CellTextContent", function () { return (parcelRequire("5nSlB")).CellTextContent; });
parcelRequire("5nSlB");
parcelRequire("laObo");

});
parcelRegister("5nSlB", function(module, exports) {

$parcel$export(module.exports, "CellTextContent", function () { return $4f8d7018fec2d385$export$6336b55f7613eff7; });
$parcel$export(module.exports, "CellCheckContent", function () { return $4f8d7018fec2d385$export$2ff19a9fa1e2bf3d; });
$parcel$export(module.exports, "CellExpanderContent", function () { return $4f8d7018fec2d385$export$9df6260913c83267; });
$parcel$export(module.exports, "CellHyperlinkContent", function () { return $4f8d7018fec2d385$export$baed7aa80eb77f27; });
$parcel$export(module.exports, "CellRenderContent", function () { return $4f8d7018fec2d385$export$70b9bce915221e55; });
/* cell-variants.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $lK5pR = parcelRequire("lK5pR");

var $1O6nN = parcelRequire("1O6nN");

var $5VMi0 = parcelRequire("5VMi0");

var $15aBT = parcelRequire("15aBT");

var $1rxrS = parcelRequire("1rxrS");
const $4f8d7018fec2d385$export$6336b55f7613eff7 = (props)=>{
    const { data: data, isRowHeader: isRowHeader } = props;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _zulpu2gc",
            isRowHeader && "_bozg1ul9"
        ]),
        children: [
            data.check && !isRowHeader && /*#__PURE__*/ (0, $loA2J.jsx)((0, $15aBT.Checkmark), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    data.check && "_1q5171o5"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1rxrS.TextContent), {
                    data: data.value
                })
            }),
            data.lozenge && /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5VMi0.Lozenge), {
                    text: data.lozenge
                })
            })
        ]
    });
};
const $4f8d7018fec2d385$export$2ff19a9fa1e2bf3d = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $15aBT.Checkmark), {});
};
const $4f8d7018fec2d385$export$9df6260913c83267 = (props)=>{
    const { data: data } = props;
    const label = data.lozenge ? /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
        children: [
            data.label,
            " ",
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5VMi0.Lozenge), {
                text: data.lozenge
            })
        ]
    }) : data.label;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lK5pR.Expand), {
        label: label,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1rxrS.TextContent), {
            data: data.body
        })
    });
};
const $4f8d7018fec2d385$export$baed7aa80eb77f27 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1O6nN.Link // id={rowDescId} // todo
    ), {
        text: props.data.label,
        href: props.data.href,
        type: "primary",
        className: (0, $esG4f.default)([
            "_1wybdlk8 _ahbq1y44"
        ])
    });
};
const $4f8d7018fec2d385$export$70b9bce915221e55 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        children: props.data.render()
    });
};

});
parcelRegister("15aBT", function(module, exports) {

$parcel$export(module.exports, "Checkmark", function () { return $5e87c96e85adaac2$export$4f481e0a96cfbed6; });
/* checkmark.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $5e87c96e85adaac2$export$4f481e0a96cfbed6 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "data-testid": "checkmark",
        className: (0, $esG4f.default)([
            "_bfhkl30o _2rko1ssb _syazcd5j _1e0c1o8l _1o9zidpf _k48p8n31 _vwz41tcg _y3gn1h6o _4t3i1tcg _1bsb1tcg"
        ]),
        style: {
            "--_1x006p6": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.lime700")),
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Icon), {
            name: "featurecheckmark",
            size: "xs",
            color: (0, $5ohHq.wacToken)("color.neutral.light0")
        })
    });
};
const $5e87c96e85adaac2$var$containerInnerCss = null;

});

parcelRegister("1rxrS", function(module, exports) {

$parcel$export(module.exports, "TextContent", function () { return $f667198e6312b233$export$1b51c6466e79404f; });
/* text-content.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $8lB1y = parcelRequire("8lB1y");
const $f667198e6312b233$export$1b51c6466e79404f = (props)=>{
    const { data: data } = props;
    if (data.type === "plaintext") return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        className: (0, $esG4f.default)([
            "_y3gnv2br _1wybdlk8 _q7gqdlk8"
        ]),
        children: data.value
    });
    if (data.type === "richtext") return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        className: (0, $esG4f.default)([
            "_y3gnv2br _1wybdlk8 _q7gqdlk8"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            text: data.value
        })
    });
    throw new Error(`unknown text-content type: ${data.type}`);
};
const $f667198e6312b233$var$textCss = null;

});


parcelRegister("laObo", function(module, exports) {

});




parcelRegister("54y9B", function(module, exports) {

$parcel$export(module.exports, "Header", function () { return $31cae16aca6a1b1d$export$8b251419efc915eb; });
/* header.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("bwop0");
var $52o7a = parcelRequire("52o7a");
const $31cae16aca6a1b1d$export$8b251419efc915eb = (props)=>{
    const { titles: titles, stickyOffset: stickyOffset } = props;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $52o7a.Head), {
        stickyOffset: stickyOffset,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $52o7a.HeadRow), {
            children: titles.map((heading, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $52o7a.HeadCell), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _2lx21bp4 _zulpftgi _4cvr1y6m"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_syaz1hlo _k48p1fw0"
                            ]),
                            style: {
                                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                            },
                            children: heading
                        })
                    })
                }, index))
        })
    });
};
const $31cae16aca6a1b1d$var$headCellDivCss = null;
const $31cae16aca6a1b1d$var$headCellSpanCss = null;

});

parcelRegister("Hw7na", function(module, exports) {

$parcel$export(module.exports, "SectionHeader", function () { return $b00a391f8c4429d7$export$8adb256d999cd5a0; });
/* section-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("bwop0");
var $jF79E = parcelRequire("jF79E");
const $b00a391f8c4429d7$export$8adb256d999cd5a0 = (props)=>{
    const { sectionTitle: sectionTitle, totalColumnCount: totalColumnCount } = props;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jF79E.SectionHeader), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jF79E.SectionHeaderCell), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    className: (0, $esG4f.default)([
                        "_syaz1hlo _1bsb1osq _k48p8n31 _4t3i1wug _1e0c1ule _1i4q1hna"
                    ]),
                    style: {
                        "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                    },
                    children: sectionTitle
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
                children: Array(totalColumnCount - 1).fill("").map((_, idx)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $jF79E.SectionHeaderCell), {}, idx))
            })
        ]
    });
};
const $b00a391f8c4429d7$var$sectionHeaderSpanCss = null;

});

parcelRegister("2NR3S", function(module, exports) {

$parcel$export(module.exports, "getColumnCount", function () { return $36febbb52c955bef$export$813bef8f01765aa1; });
function $36febbb52c955bef$export$813bef8f01765aa1(sections) {
    return $36febbb52c955bef$var$getColumnCountOfRowsOfSections(sections);
}
function $36febbb52c955bef$var$getColumnCountOfRowsOfSections(sections) {
    if (sections.length === 0) throw new Error("sections count should be > 0");
    let columnCount;
    sections.forEach((section, index)=>{
        try {
            const columnCountOfRows = $36febbb52c955bef$var$getColumnCountOfRows(section.rows);
            if (columnCount === undefined) columnCount = columnCountOfRows;
            else {
                if (columnCount !== columnCountOfRows) throw new Error(`inconsistent number of columns: section at index ${index} contains ${columnCountOfRows} columns; expected ${columnCount} columns based on previous section(s)`);
            }
        } catch (error) {
            // @ts-ignore
            throw new Error(`error at table section index ${index}`, {
                cause: error
            });
        }
    });
    if (columnCount === undefined) throw new Error("column count is undefined");
    return columnCount;
}
function $36febbb52c955bef$var$getColumnCountOfRows(rows) {
    if (rows.length === 0) throw new Error("rows count should be > 0");
    let columnCount;
    rows.forEach((row, index)=>{
        if (columnCount === undefined) columnCount = row.length;
        else {
            if (row.length !== columnCount) throw new Error(`inconsistent number of columns: row at index ${index} contains ${row.length} columns; expected ${columnCount} columns based on previous row(s)`);
        }
    });
    if (columnCount === undefined) throw new Error("column count is undefined");
    if (columnCount === 0) throw new Error("columnCount should not be 0");
    return columnCount;
}

});



parcelRegister("lQMRe", function(module, exports) {

$parcel$export(module.exports, "transformContentfulDataToTableData", function () { return $c16941b57a376563$export$d095b9a7d993b440; });
const $c16941b57a376563$export$e28b7b712925a1 = (featureGroup)=>{
    const { fields: fields } = featureGroup;
    return fields.featureGroupTitleExternal;
};
const $c16941b57a376563$export$74a00f18b9031fa7 = (featureFields)=>{
    return featureFields.featureNameExternal || "";
};
const $c16941b57a376563$export$c2c44121b33af1d6 = (featureFields, planTitles)=>{
    // @ts-ignore
    return planTitles.map((planTitle, i)=>{
        var _featureFields_relevantPlan, // @ts-ignore
        _featureFields_featureAdditionalInformation_find, _featureFields_featureAdditionalInformation;
        const isRelevant = (_featureFields_relevantPlan = featureFields.relevantPlan) === null || _featureFields_relevantPlan === void 0 ? void 0 : _featureFields_relevantPlan.some((plan)=>{
            var _plan_fields;
            return ((_plan_fields = plan.fields) === null || _plan_fields === void 0 ? void 0 : _plan_fields.planTitleExternal) === planTitle;
        });
        const additionalInfo = featureFields === null || featureFields === void 0 ? void 0 : (_featureFields_featureAdditionalInformation = featureFields.featureAdditionalInformation) === null || _featureFields_featureAdditionalInformation === void 0 ? void 0 : (_featureFields_featureAdditionalInformation_find = _featureFields_featureAdditionalInformation.find(// @ts-ignore
        (info)=>{
            var _info_fields_relevantPlan, _info_fields;
            return !!((_info_fields = info.fields) === null || _info_fields === void 0 ? void 0 : (_info_fields_relevantPlan = _info_fields.relevantPlan) === null || _info_fields_relevantPlan === void 0 ? void 0 : _info_fields_relevantPlan.some((plan)=>{
                var _plan_fields;
                return ((_plan_fields = plan.fields) === null || _plan_fields === void 0 ? void 0 : _plan_fields.planTitleExternal) === planTitle;
            }));
        })) === null || _featureFields_featureAdditionalInformation_find === void 0 ? void 0 : _featureFields_featureAdditionalInformation_find.fields.featureAdditionalInformation;
        // 1. if there is featureAdditionalInformation, use that as type rich text (links, etc.)
        if (additionalInfo) return {
            type: "text",
            check: additionalInfo && isRelevant,
            value: {
                type: "richtext",
                value: additionalInfo
            }
        };
        // 2. if isRelevant, use type check with empty value
        if (isRelevant) return {
            type: "check"
        };
        // 3. otherwise, use type text with empty value
        return {
            type: "text",
            value: {
                type: "plaintext",
                value: ""
            }
        };
    });
};
const $c16941b57a376563$export$4de3ae5ff94aba4 = (featureFields, featureName, descriptionText)=>{
    if (featureFields.relevantUrl) return {
        type: "hyperlink",
        label: featureName,
        href: featureFields.relevantUrl
    };
    if (descriptionText) return {
        type: "expander",
        label: featureName,
        lozenge: featureFields.callOut,
        body: {
            type: "richtext",
            value: descriptionText || featureName
        }
    };
    return {
        type: "text",
        value: {
            type: "plaintext",
            value: featureName
        },
        lozenge: featureFields.callOut,
        check: false
    };
};
const $c16941b57a376563$export$6fa65ac9a366ed09 = (feature, planTitles)=>{
    const featureFields = feature.fields;
    // left side column link or label
    const featureName = $c16941b57a376563$export$74a00f18b9031fa7(featureFields);
    // individual cells
    const planCells = $c16941b57a376563$export$c2c44121b33af1d6(featureFields, planTitles);
    // left side column
    const featureCell = $c16941b57a376563$export$4de3ae5ff94aba4(featureFields, featureName, featureFields.description);
    return [
        featureCell,
        ...planCells
    ];
};
const $c16941b57a376563$export$11afdf5edf7de08e = (featureGroup, planTitles)=>{
    var _featureGroup_fields_features;
    const sectionTitle = $c16941b57a376563$export$e28b7b712925a1(featureGroup);
    const rows = ((_featureGroup_fields_features = featureGroup.fields.features) === null || _featureGroup_fields_features === void 0 ? void 0 : _featureGroup_fields_features.map((feature)=>$c16941b57a376563$export$6fa65ac9a366ed09(feature, planTitles))) || [];
    return {
        title: sectionTitle,
        rows: rows
    };
};
const $c16941b57a376563$export$d095b9a7d993b440 = (contentfulData, planTitles)=>{
    return contentfulData.map((featureGroup)=>$c16941b57a376563$export$11afdf5edf7de08e(featureGroup, planTitles));
};

});



parcelRegister("cceBl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $1f0ddae1c4249f8b$export$2e2bcd8739ae039; });

var $kIHPB = parcelRequire("kIHPB");
var $1f0ddae1c4249f8b$export$2e2bcd8739ae039 = (0, $kIHPB.default);

});
parcelRegister("kIHPB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a207c7df7bd4bbe$export$2e2bcd8739ae039; });
/* product-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");
const $0a207c7df7bd4bbe$export$fef9b561ff2e7cb1 = ({ id: id, name: name, description: description, href: href, className: className, imgSrc: imgSrc, imgAlt: imgAlt, type: type = "secondary" })=>{
    const localizedHref = (0, $3FBn4.useLocalizedHref)(href !== null && href !== void 0 ? href : "");
    if (typeof href === "undefined") return null;
    const formattedHref = (0, $3FBn4.isLocalizableHref)(href) ? localizedHref : href;
    const iconSize = type === "primary" ? 44 : 32;
    let normalizedId;
    if (id === "jira-software") normalizedId = "jira";
    else if (id === "atlassian-access") normalizedId = "guard";
    else if (id) // The id for some products in Contentful have "-" in between (ex. jira-service-management), so we need to remove it to match data-product-key values in the global nav
    normalizedId = id.replace(/-/g, "");
    else normalizedId = name.replace(/ /g, "").toLowerCase();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1bsb1osq _1mouu2gc _b27r17la",
            className
        ]),
        "data-testid": "wae-product-card",
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
            href: formattedHref,
            target: (0, $3FBn4.isLocalizableHref)(href) ? "" : "_blank",
            rel: (0, $3FBn4.isLocalizableHref)(href) ? "" : "noreferrer",
            "aria-label": name,
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "customerStories",
            "data-product-key": normalizedId,
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1aax1e5h _12l2utpp _4cvr1h6o _1bah1h6o _4t3i1ady _1bsb1ady _1wpz1q9y"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: {
                            src: imgSrc !== null && imgSrc !== void 0 ? imgSrc : "https://dam-cdn.atl.orangelogic.com/AssetLink/5sd7w3j2d7rdm7354yi413c5s1eo6s10.webp",
                            alt: imgAlt !== null && imgAlt !== void 0 ? imgAlt : "",
                            width: iconSize,
                            height: iconSize
                        }
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _zulpv77o _1q51v77o _1tke1ady",
                        "_1b2mvd4q _gp0igktf",
                        !description && "_1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: "h6",
                            children: name
                        }),
                        description && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: "body-sm",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
};
const $0a207c7df7bd4bbe$var$cardStyle = null;
const $0a207c7df7bd4bbe$var$iconStyle = null;
const $0a207c7df7bd4bbe$var$textContainerStyle = null;
const $0a207c7df7bd4bbe$var$noDescriptionStyle = null;
const $0a207c7df7bd4bbe$var$overrideTextStyling = null;
var $0a207c7df7bd4bbe$export$2e2bcd8739ae039 = $0a207c7df7bd4bbe$export$fef9b561ff2e7cb1;

});


parcelRegister("7D1nQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ba308be7eb70f97b$export$2e2bcd8739ae039; });

var $1UUq1 = parcelRequire("1UUq1");
var $ba308be7eb70f97b$export$2e2bcd8739ae039 = (0, $1UUq1.PullQuote);

});

parcelRegister("adl56", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("koVMZ")).default; });

var $koVMZ = parcelRequire("koVMZ");

});
parcelRegister("koVMZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73e8cc6d4da7295e$export$2e2bcd8739ae039; });
/* single-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $aiugz = parcelRequire("aiugz");
// eslint-disable-next-line complexity
const $73e8cc6d4da7295e$var$UniformSingleTab = (props)=>{
    const { orientation: orientation = {
        mobile: "vertical"
    }, gap: gap = {
        mobile: "0"
    } } = props;
    var _gap_mobile, _gap_tablet, _ref, _gap_desktop, _ref1, _ref2;
    const gapObject = {
        mobile: (_gap_mobile = gap.mobile) !== null && _gap_mobile !== void 0 ? _gap_mobile : "0",
        // @ts-ignore
        tablet: (_ref = (_gap_tablet = gap === null || gap === void 0 ? void 0 : gap.tablet) !== null && _gap_tablet !== void 0 ? _gap_tablet : gap.mobile) !== null && _ref !== void 0 ? _ref : "0",
        // @ts-ignore
        desktop: (_ref2 = (_ref1 = (_gap_desktop = gap === null || gap === void 0 ? void 0 : gap.desktop) !== null && _gap_desktop !== void 0 ? _gap_desktop : gap === null || gap === void 0 ? void 0 : gap.tablet) !== null && _ref1 !== void 0 ? _ref1 : gap.mobile) !== null && _ref2 !== void 0 ? _ref2 : "0"
    };
    const styles = null;
    const orientationObject = {
        mobile: orientation.mobile || "vertical",
        // @ts-ignore
        tablet: orientation.tablet || orientation.mobile || "vertical",
        desktop: // @ts-ignore
        orientation.desktop || // @ts-ignore
        orientation.tablet || orientation.mobile || "vertical"
    };
    const orientationStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1bsb1osq _4t3i1wug _1e0c1txw _zulp1a6y _19wggsi3 _pdlmxbqd",
            "_1e0c1txw _2lx22h65 _1lp71tnc _1inip4d6"
        ]),
        style: {
            "--_rkv8x9": (0, $43MIc.default)("var(--ds-space-" + gapObject.mobile + ")"),
            "--_9wptik": (0, $43MIc.default)("var(--ds-space-" + gapObject.tablet + ")"),
            "--_3wdyhk": (0, $43MIc.default)("var(--ds-space-" + gapObject.desktop + ")"),
            "--_pv2ypa": (0, $43MIc.default)(orientationObject.mobile === "horizontal" ? "row" : "column"),
            "--_dek1s0": (0, $43MIc.default)(orientationObject.tablet === "horizontal" ? "row" : "column"),
            "--_1ng513r": (0, $43MIc.default)(orientationObject.desktop === "horizontal" ? "row" : "column")
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "tabContents"
        })
    });
};
var $73e8cc6d4da7295e$export$2e2bcd8739ae039 = $73e8cc6d4da7295e$var$UniformSingleTab;

});


parcelRegister("5znlu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("gmi9U")).default; });

var $gmi9U = parcelRequire("gmi9U");

});
parcelRegister("gmi9U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e77a1f912177c1d$export$2e2bcd8739ae039; });
/* split-color-background-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");
const $0e77a1f912177c1d$var$UniformSplitColorBackgroundContainer = ({ topColor: topColor, bottomColor: bottomColor, sectionDivider: sectionDivider, extendBackgroundColor: extendBackgroundColor })=>{
    const baseStyle = null;
    const horizontalStyle = null;
    const highLeft = null;
    const highRight = null;
    const coverStyles = null;
    const sectionDividerComponent = /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqswstnw _4t3iq9zu _1bsb1osq _11q7jj3k _152t1ssb _t9ec1i34 _1kt9b3bt _cfu11ule _kfgt1osq _1mp41osq _1cs8stnw _iajmidpf _1rus1utj",
            bottomColor === "transparent" && sectionDivider === "high-left" && "_mkrz7yzi",
            bottomColor === "transparent" && sectionDivider === "high-right" && "_mkrz1swj",
            sectionDivider === "high-left" && "_tgsmte2m",
            sectionDivider === "high-right" && "_tgsmrjfx"
        ]),
        style: {
            "--_nlw01g": (0, $43MIc.default)(topColor),
            "--_130a3qa": (0, $43MIc.default)(bottomColor)
        }
    });
    const extendedBackgroundColorComponent = /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqswstnw _1bsbauwl _4t3i1osq _14b5zqdx _b8yq87gh _1e021ssb _t9eczr6s",
            sectionDivider && "_1kt9b3bt _cfu11ule _1mp41osq _1cs8stnw _iajmidpf _1rusjj3k _kfgt2ts6 _aetrb3bt _1ywu1ule _z0ai1osq _18postnw _1bqq1mrw _1gufidpf _1hfk1utj _1qdg2ts6",
            !sectionDivider && "_11q7eqnl"
        ]),
        style: {
            "--_nlw01g": (0, $43MIc.default)(topColor),
            "--_130a3qa": (0, $43MIc.default)(bottomColor)
        },
        children: sectionDivider && sectionDividerComponent
    });
    const slotWrapper = ({ items: items })=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_kqswh2mm"
            ]),
            children: items
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _9luy1wqb _ce5au29b _wfa7llbu",
            !extendBackgroundColor && sectionDivider && "_1kt9b3bt _cfu11ule _1mp41osq _1cs8stnw _iajmidpf _1rusjj3k _kfgt2ts6 _aetrb3bt _1ywu1ule _z0ai1osq _18postnw _1bqq1mrw _1gufidpf _1hfk1utj _1qdg2ts6",
            !extendBackgroundColor && !sectionDivider && "_11q7eqnl"
        ]),
        style: {
            "--_nlw01g": (0, $43MIc.default)(topColor),
            "--_130a3qa": (0, $43MIc.default)(bottomColor)
        },
        children: [
            sectionDivider && !extendBackgroundColor && sectionDividerComponent,
            extendBackgroundColor && extendedBackgroundColorComponent,
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                name: "component",
                wrapperComponent: sectionDivider ? slotWrapper : undefined
            })
        ]
    });
};
var $0e77a1f912177c1d$export$2e2bcd8739ae039 = $0e77a1f912177c1d$var$UniformSplitColorBackgroundContainer;

});


parcelRegister("a1e48", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $5740366ed819cf5d$export$2e2bcd8739ae039; });

var $3uNzn = parcelRequire("3uNzn");
var $5740366ed819cf5d$export$2e2bcd8739ae039 = (0, $3uNzn.UniformStatsSection);

});
parcelRegister("3uNzn", function(module, exports) {

$parcel$export(module.exports, "UniformStatsSection", function () { return $6533a8d6d9a59ddf$export$a5aec67e611930b9; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $5ohHq = parcelRequire("5ohHq");

var $2p5f0 = parcelRequire("2p5f0");
const $6533a8d6d9a59ddf$export$a5aec67e611930b9 = (props)=>{
    const statsProps = {
        headerText: props.title,
        bigStat: {
            stat: props.primaryStatNumber,
            statText: props.primaryStatDescription,
            statColor: (0, $5ohHq.wacToken)("color.primary.blue"),
            statSymbol: {
                symbolCharacter: props.primaryStatSymbolCharacter,
                symbolCharacterColor: (0, $5ohHq.wacToken)("color.primary.blue")
            }
        },
        littleStats: [
            {
                stat: props.secondaryStatNumber,
                statText: props.secondaryStatDescription,
                statColor: (0, $5ohHq.wacToken)("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: props.secondaryStatSymbolCharacter,
                    symbolCharacterColor: (0, $5ohHq.wacToken)("color.primary.blue")
                }
            },
            {
                stat: props.tertiaryStatNumber,
                statText: props.tertiaryStatDescription,
                statColor: (0, $5ohHq.wacToken)("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: props.tertiaryStatSymbolCharacter,
                    symbolCharacterColor: (0, $5ohHq.wacToken)("color.primary.blue")
                }
            }
        ]
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $2p5f0.Stats), (0, $7Knp0._)({}, statsProps));
};

});


parcelRegister("7z1ju", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("b7byh")).default; });

var $b7byh = parcelRequire("b7byh");

});
parcelRegister("b7byh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdcd578708f4e493$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");

var $8jdfl = parcelRequire("8jdfl");

var $j27rt = parcelRequire("j27rt");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");
const $bdcd578708f4e493$var$UniformStatsigExperimentContainer = (props)=>{
    var _Object_entries_find;
    const { experimentId: experimentId, override: override, postExperimentationMode: postExperimentationMode } = props;
    const context = (0, $j27rt.useWAEContextSafe)();
    if (postExperimentationMode) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: experimentId,
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "treatment"
        })
    });
    const experiment = (_Object_entries_find = Object.entries((0, $9iWJ8.experiments)).find(([, value])=>value.experimentName === experimentId)) === null || _Object_entries_find === void 0 ? void 0 : _Object_entries_find[1];
    if (override && (context === null || context === void 0 ? void 0 : context.wacEnvironment) !== "production") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: override
    });
    if (!experiment) return (context === null || context === void 0 ? void 0 : context.wacEnvironment) === "production" ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: "control"
    }) : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8jdfl.ManifestErrorMessage), {
                id: experimentId
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                name: "control"
            })
        ]
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const experimentStatus = (0, $9iWJ8.useExperiment)(experiment);
    const showTreatment = experimentStatus.type === "enrolled" && experimentStatus.value;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: showTreatment ? "treatment" : "control"
    });
};
var $bdcd578708f4e493$export$2e2bcd8739ae039 = $bdcd578708f4e493$var$UniformStatsigExperimentContainer;

});
parcelRegister("8jdfl", function(module, exports) {

$parcel$export(module.exports, "ManifestErrorMessage", function () { return $641d3f539f73a96d$export$702dc26c1a322512; });

var $loA2J = parcelRequire("loA2J");

var $cUvUr = parcelRequire("cUvUr");
const $641d3f539f73a96d$export$702dc26c1a322512 = ({ id: id })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: id.length === 0 ? null : /*#__PURE__*/ (0, $loA2J.jsx)((0, $cUvUr.default), {
            appearance: "error",
            isDismissible: true,
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                        children: "Manifest entry not found for:"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $loA2J.jsx)("code", {
                        children: id
                    }),
                    ". Rendering control slot."
                ]
            })
        })
    });
};

});



parcelRegister("adPPd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("QabZk")).default; });

var $QabZk = parcelRequire("QabZk");

});
parcelRegister("QabZk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5a43868693f0326$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");

var $8jdfl = parcelRequire("8jdfl");

var $j27rt = parcelRequire("j27rt");

var $gAJUc = parcelRequire("gAJUc");
const $d5a43868693f0326$var$UniformStatsigFeatureGateContainer = (props)=>{
    var _Object_entries_find;
    const { featureGateId: featureGateId, override: override } = props;
    const context = (0, $j27rt.useWAEContextSafe)();
    const featureGate = (_Object_entries_find = Object.entries((0, $gAJUc.featureFlags)).find(([, value])=>value.featureFlagName === featureGateId)) === null || _Object_entries_find === void 0 ? void 0 : _Object_entries_find[1];
    if (override && (context === null || context === void 0 ? void 0 : context.wacEnvironment) !== "production") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: override
    });
    if (!featureGate) return (context === null || context === void 0 ? void 0 : context.wacEnvironment) === "production" ? null : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8jdfl.ManifestErrorMessage), {
                id: featureGateId
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                name: "control"
            })
        ]
    });
    const showTreatment = (0, $gAJUc.checkFeatureFlagGate)(featureGate);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: showTreatment ? "treatment" : "control"
    });
};
var $d5a43868693f0326$export$2e2bcd8739ae039 = $d5a43868693f0326$var$UniformStatsigFeatureGateContainer;

});


parcelRegister("2UtIB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("5QIwB")).default; });

var $5QIwB = parcelRequire("5QIwB");

});
parcelRegister("5QIwB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67c6a84774d31eaa$export$2e2bcd8739ae039; });
/* tabs-12-col.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");

var $asiio = parcelRequire("asiio");
parcelRequire("62VZK");
var $7CBQh = parcelRequire("7CBQh");

var $8yGg3 = parcelRequire("8yGg3");
const $67c6a84774d31eaa$var$uniformTabsContainerStyles = null;
const $67c6a84774d31eaa$var$UniformTabs12Col = ({ headerText: headerText, subHeaderText: subHeaderText, bgColor: bgColor = "bgWhite", enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false })=>{
    const renderTabs = (0, $iSvIT.useCallback)(({ items: items })=>{
        const tabsData = items.map((item, index)=>{
            var // @ts-ignore
            _item_props_children_props_data, _item_props_children_props, _item_props_children, _item_props, _params_title, _params_iconUrl;
            const params = (_item_props = item.props) === null || _item_props === void 0 ? void 0 : (_item_props_children = _item_props.children) === null || _item_props_children === void 0 ? void 0 : (_item_props_children_props = _item_props_children.props) === null || _item_props_children_props === void 0 ? void 0 : (_item_props_children_props_data = _item_props_children_props.data) === null || _item_props_children_props_data === void 0 ? void 0 : _item_props_children_props_data.parameters;
            return {
                id: `tab-${index}`,
                title: params === null || params === void 0 ? void 0 : (_params_title = params.title) === null || _params_title === void 0 ? void 0 : _params_title.value,
                iconUrl: params === null || params === void 0 ? void 0 : (_params_iconUrl = params.iconUrl) === null || _params_iconUrl === void 0 ? void 0 : _params_iconUrl.value,
                tabComponent: item
            };
        });
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7CBQh.TabsSection), {
            alignment: "center",
            tabsData: tabsData,
            tabSize: "large",
            bgColor: bgColor,
            enableRovoBorder: enableRovoBorder,
            enableResponsiveTabSize: enableResponsiveTabSize
        });
    }, [
        bgColor,
        enableRovoBorder,
        enableResponsiveTabSize
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulp1jfw _1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: [
            (headerText || subHeaderText) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $8yGg3.Row), {
                layout: "8",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $asiio.ContentBlock), {
                    title: headerText,
                    text: subHeaderText,
                    titleAs: "h2",
                    alignment: "center"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                name: "tabs",
                wrapperComponent: renderTabs
            })
        ]
    });
};
var $67c6a84774d31eaa$export$2e2bcd8739ae039 = $67c6a84774d31eaa$var$UniformTabs12Col;

});


parcelRegister("1kxv4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("gRQBn")).default; });

var $gRQBn = parcelRequire("gRQBn");

});
parcelRegister("gRQBn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2efe52b47d57fc66$export$2e2bcd8739ae039; });
/* tabs-8-col.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");

var $asiio = parcelRequire("asiio");
parcelRequire("62VZK");
var $7CBQh = parcelRequire("7CBQh");
const $2efe52b47d57fc66$var$uniformTabsContainerStyles = null;
const $2efe52b47d57fc66$var$UniformTabs8Col = ({ headerText: headerText, subHeaderText: subHeaderText, bgColor: bgColor = "bgWhite" })=>{
    const renderTabs = ({ items: items })=>{
        const tabsData = items.map((item, index)=>{
            var _item_props_children_props_data_parameters_title, _item_props_children_props_data_parameters, _item_props_children_props_data, _item_props_children_props, _item_props_children, _item_props;
            return {
                id: `tab-${index}`,
                // @ts-ignore
                title: (_item_props = item.props) === null || _item_props === void 0 ? void 0 : (_item_props_children = _item_props.children) === null || _item_props_children === void 0 ? void 0 : (_item_props_children_props = _item_props_children.props) === null || _item_props_children_props === void 0 ? void 0 : (_item_props_children_props_data = _item_props_children_props.data) === null || _item_props_children_props_data === void 0 ? void 0 : (_item_props_children_props_data_parameters = _item_props_children_props_data.parameters) === null || _item_props_children_props_data_parameters === void 0 ? void 0 : (_item_props_children_props_data_parameters_title = _item_props_children_props_data_parameters.title) === null || _item_props_children_props_data_parameters_title === void 0 ? void 0 : _item_props_children_props_data_parameters_title.value,
                tabComponent: item
            };
        });
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7CBQh.TabsSection), {
            alignment: "start",
            tabsData: tabsData,
            tabSize: "small",
            bgColor: bgColor
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulp1jfw _1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: [
            (headerText || subHeaderText) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $asiio.ContentBlock), {
                title: headerText,
                titleAs: "h2",
                alignment: "start",
                text: subHeaderText
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                name: "tabs",
                wrapperComponent: renderTabs
            })
        ]
    });
};
var $2efe52b47d57fc66$export$2e2bcd8739ae039 = $2efe52b47d57fc66$var$UniformTabs8Col;

});


parcelRegister("diZQT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("h3wk5")).default; });

var $h3wk5 = parcelRequire("h3wk5");

});
parcelRegister("h3wk5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9034dfb6d5e5a2d2$export$2e2bcd8739ae039; });
// @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $gPr7r = parcelRequire("gPr7r");

var $gkV6l = parcelRequire("gkV6l");

var $cX9ng = parcelRequire("cX9ng");

var $knAj5 = parcelRequire("knAj5");

var $lbVpk = parcelRequire("lbVpk");

var $3FBn4 = parcelRequire("3FBn4");
const $9034dfb6d5e5a2d2$var$UniformTemplateModalButton = (props)=>{
    const { text: text, productKey: productKey, templateName: templateName, pluginModuleKey: pluginModuleKey, href: href } = props;
    const { openModalForTemplate: openModalForTemplate } = (0, $gkV6l.useSiteSelectorContext)();
    const { setTemplate: setTemplate } = (0, $gPr7r.useProductTemplateContext)();
    // AIS = Atlassian Identity Service - provides user's existing Atlassian sites
    const aisSites = (0, $knAj5.useSitesWithCurrentProduct)();
    const locale = (0, $3FBn4.useLocale)();
    const localizedSignupHref = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup");
    const [buttonProps, setButtonProps] = (0, $iSvIT.useState)({
        href: $9034dfb6d5e5a2d2$var$getDefaultHref({
            productKey: productKey,
            locale: locale
        })
    });
    const fullStargateProductKey = productKey === "jira-service-management" ? "jira-servicedesk.ondemand" : `${productKey}.ondemand`;
    (0, $iSvIT.useEffect)(()=>{
        if (pluginModuleKey && productKey) {
            const templateData = {
                templateId: pluginModuleKey,
                templateName: templateName,
                productKey: fullStargateProductKey
            };
            setTemplate(templateData);
            var _aisSites_map;
            // Get site URLs for the current product
            const siteUrls = (_aisSites_map = aisSites === null || aisSites === void 0 ? void 0 : aisSites.map((site)=>site.url)) !== null && _aisSites_map !== void 0 ? _aisSites_map : [];
            // Determine action based on user's sites
            const action = (0, $cX9ng.getTemplateAction)({
                templateData: templateData,
                siteUrls: siteUrls,
                localizedSignupHref: localizedSignupHref
            });
            if (action.type === "modal") setButtonProps({
                onClick: (event)=>{
                    event.stopPropagation();
                    event.preventDefault();
                    openModalForTemplate(templateData);
                }
            });
            else setButtonProps({
                href: action.href
            });
        } else if (href) setButtonProps({
            href: (0, $3FBn4.getLocalizedHref)({
                href: href,
                locale: locale
            })
        });
        return ()=>{
            setTemplate(null);
        };
    }, [
        openModalForTemplate,
        templateName,
        pluginModuleKey,
        fullStargateProductKey,
        href,
        productKey,
        locale,
        aisSites,
        localizedSignupHref,
        setTemplate
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lbVpk.Button), (0, $6iHNw._)((0, $7Knp0._)({}, buttonProps), {
        children: text
    }));
};
function $9034dfb6d5e5a2d2$var$getDefaultHref(args) {
    const { locale: locale, productKey: productKey } = args;
    if (productKey === "jira-software") return (0, $3FBn4.getLocalizedHref)({
        href: "/try/cloud/signup?bundle=jira&edition=free",
        locale: locale
    });
    if (productKey === "confluence") return (0, $3FBn4.getLocalizedHref)({
        href: "/try/cloud/signup?bundle=confluence&edition=free",
        locale: locale
    });
    if (productKey === "jira-service-management") return (0, $3FBn4.getLocalizedHref)({
        href: "/try/cloud/signup?bundle=jira-service-management&edition=free",
        locale: locale
    });
    return "";
}
var $9034dfb6d5e5a2d2$export$2e2bcd8739ae039 = $9034dfb6d5e5a2d2$var$UniformTemplateModalButton;

});
parcelRegister("cX9ng", function(module, exports) {

$parcel$export(module.exports, "getTemplateAction", function () { return $9286df2b38d515c7$export$4935503ffd4d8306; });

var $i8kxh = parcelRequire("i8kxh");

var $hG0Y6 = parcelRequire("hG0Y6");
const $9286df2b38d515c7$export$4935503ffd4d8306 = (params)=>{
    const { templateData: templateData, siteUrls: siteUrls, redirectToIdentity: redirectToIdentity, internalLinkAfterIdentity: internalLinkAfterIdentity, localizedSignupHref: localizedSignupHref } = params;
    // If user has existing sites, show modal
    if (siteUrls.length > 0) return {
        type: "modal",
        templateData: templateData
    };
    // Otherwise, redirect directly
    const href = $9286df2b38d515c7$var$getRedirectHref({
        templateData: templateData,
        redirectToIdentity: redirectToIdentity,
        internalLinkAfterIdentity: internalLinkAfterIdentity,
        localizedSignupHref: localizedSignupHref
    });
    return {
        type: "redirect",
        href: href
    };
};
const $9286df2b38d515c7$var$getRedirectHref = (params)=>{
    const { templateData: templateData, redirectToIdentity: redirectToIdentity, internalLinkAfterIdentity: internalLinkAfterIdentity, localizedSignupHref: localizedSignupHref } = params;
    const { templateId: templateId, templateName: templateName } = templateData;
    if (redirectToIdentity && internalLinkAfterIdentity) return $9286df2b38d515c7$var$getIdentityUrl(templateId, templateName, internalLinkAfterIdentity);
    return $9286df2b38d515c7$var$getCloudSignupUrl(templateData, localizedSignupHref, internalLinkAfterIdentity);
};
const $9286df2b38d515c7$var$isJiraProduct = (productKey)=>{
    return [
        (0, $i8kxh.ProductKeys).JIRA_CORE,
        (0, $i8kxh.ProductKeys).JIRA_SERVICE_DESK,
        (0, $i8kxh.ProductKeys).JIRA_SOFTWARE,
        (0, $i8kxh.ProductKeys).JIRA_PRODUCT_DISCOVERY
    ].includes(productKey);
};
const $9286df2b38d515c7$var$getCloudSignupUrl = (templateData, localizedSignupHref, internalLinkAfterIdentity)=>{
    const { templateId: templateId, templateName: templateName, productKey: productKey } = templateData;
    let url = `${localizedSignupHref}?product=${productKey}&templateId=${templateId}&edition=free`;
    if ($9286df2b38d515c7$var$isJiraProduct(productKey)) {
        const urlParams = new URLSearchParams(location.search);
        if (!urlParams.has("p")) urlParams.append("templateModal", templateId);
        url += `&continue=${encodeURIComponent(`${location.href}?${urlParams.toString()}`)}`;
    } else if (productKey === (0, $i8kxh.ProductKeys).CONFLUENCE) {
        const continueUrl = `${(0, $hG0Y6.Environment).getWacIntegrationUrl()}${internalLinkAfterIdentity !== null && internalLinkAfterIdentity !== void 0 ? internalLinkAfterIdentity : ""}?templateId=${templateId + encodeURIComponent("&templateName=" + encodeURIComponent(templateName))}`;
        url = `${url}&continue=${encodeURIComponent(continueUrl)}`;
    }
    return url;
};
const $9286df2b38d515c7$var$getIdentityUrl = (templateId, templateName, internalLinkAfterIdentity)=>{
    const loginUrl = `${(0, $hG0Y6.Environment).getIdentityBaseUrl()}/login?`;
    const continueUrl = `${(0, $hG0Y6.Environment).getWacIntegrationUrl()}${internalLinkAfterIdentity}?templateName=${encodeURIComponent(templateName)}&templateId=${templateId}`;
    return `${loginUrl}&continue=${encodeURIComponent(continueUrl)}`;
};

});



parcelRegister("5hZGW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("c7WmW")).default; });

var $c7WmW = parcelRequire("c7WmW");

});
parcelRegister("c7WmW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c9e25ac92daa05c$export$2e2bcd8739ae039; });
/* template-preview.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $4VhzM = parcelRequire("4VhzM");

var $5T6ho = parcelRequire("5T6ho");
const $5c9e25ac92daa05c$var$UniformTemplatePreview = ({ templatePreview: templatePreview, templateType: templateType })=>{
    if (!templatePreview) return null;
    var _templatePreview_file_url, _templatePreview_description;
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_y3gn1h6o _kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5T6ho.UniformTemplatePreviewWindow), {
            url: (_templatePreview_file_url = templatePreview.file.url) !== null && _templatePreview_file_url !== void 0 ? _templatePreview_file_url : "",
            alt: (_templatePreview_description = templatePreview.description) !== null && _templatePreview_description !== void 0 ? _templatePreview_description : "",
            templateType: templateType || (0, $4VhzM.TemplateType).Page
        })
    });
};
const $5c9e25ac92daa05c$var$templatePreviewSection = null;
var $5c9e25ac92daa05c$export$2e2bcd8739ae039 = $5c9e25ac92daa05c$var$UniformTemplatePreview;

});
parcelRegister("5T6ho", function(module, exports) {

$parcel$export(module.exports, "UniformTemplatePreviewWindow", function () { return $02ee184ca6f63762$export$7796399069f4fd6e; });
/* template-preview-window.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $lHjhp = parcelRequire("lHjhp");

var $4VhzM = parcelRequire("4VhzM");

var $5ohHq = parcelRequire("5ohHq");

var $kqt8V = parcelRequire("kqt8V");

var $ik2oV = parcelRequire("ik2oV");
const $02ee184ca6f63762$var$previewTopBar = null;
const $02ee184ca6f63762$var$previewBarDot = null;
const $02ee184ca6f63762$var$previewImage = null;
const $02ee184ca6f63762$export$7796399069f4fd6e = ({ url: url, alt: alt, templateType: templateType })=>{
    const templatePreview = null;
    const previewScreenshot = null;
    const whiteboardPreviewWrapper = null;
    const zoomControls = null;
    const zoomControl = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_p12f1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug"
        ]),
        children: templateType === (0, $4VhzM.TemplateType).Whiteboard ? /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1yt41ano _4t3ipxbi _vchhusvi _1s1g1b66 _5fbc1b66 _bfhkvejh"
                    ]),
                    style: {
                        "--_nl5by5": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue1000"))
                    },
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_4t3i1gwv _18m91wug _bfhkcd5j _1yxn1b66 _1ein1b66 _19it1k0a _11qbbn52 _12fm15vq",
                        "_80om1qgj _ou2u1osq"
                    ]),
                    style: {
                        "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                        "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300"))
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lHjhp.TransformWrapper), {
                        children: ({ zoomIn: zoomIn, zoomOut: zoomOut })=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $lHjhp.TransformComponent), {
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                                            src: url,
                                            alt: alt,
                                            className: (0, $esG4f.default)([
                                                "_1bsb1osq _p12f1osq"
                                            ])
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c1txw _zulpu2gc _kqswstnw _u7copxbi _rjxppxbi"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                                onClick: ()=>zoomIn(),
                                                "aria-label": "Zoom In",
                                                className: (0, $esG4f.default)([
                                                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _11q7glyw _80omtlke"
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kqt8V.ZoomIn), {
                                                    size: "16"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                                onClick: ()=>zoomOut(),
                                                "aria-label": "Zoom Out",
                                                className: (0, $esG4f.default)([
                                                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _11q7glyw _80omtlke"
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ik2oV.ZoomOut), {
                                                    size: "16"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1yt41ano _4t3ipxbi _vchhusvi _1s1g1b66 _5fbc1b66 _bfhkvejh"
                    ]),
                    style: {
                        "--_nl5by5": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue1000"))
                    },
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_4t3i1gwv _18m91wug _bfhkcd5j _1yxn1b66 _1ein1b66 _19it1k0a _11qbbn52 _12fm15vq"
                    ]),
                    style: {
                        "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                        "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300"))
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                        src: url,
                        alt: alt,
                        className: (0, $esG4f.default)([
                            "_1bsb1osq _p12f1osq"
                        ])
                    })
                })
            ]
        })
    });
};

});



parcelRegister("6NpvY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("1GDqm")).default; });

var $1GDqm = parcelRequire("1GDqm");

});
parcelRegister("1GDqm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23620155247a97b9$export$2e2bcd8739ae039; });
/* text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $4XrxY = parcelRequire("4XrxY");
const $23620155247a97b9$var$UniformText = ({ text: text, style: style = "body-lg", alignment: alignment = "left" })=>{
    const alignmentStyle = null;
    const boldStyling = null;
    const resetMargin = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            className: (0, $esG4f.default)([
                style.includes("bold") && "_3dt51fw0",
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                "_y3gnoues",
                style
            ]),
            style: {
                "--_1v0xqnb": (0, $43MIc.default)(alignment)
            },
            children: text
        })
    });
};
var $23620155247a97b9$export$2e2bcd8739ae039 = $23620155247a97b9$var$UniformText;

});


parcelRegister("85qcB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("9SZQE")).default; });

var $9SZQE = parcelRequire("9SZQE");

});
parcelRegister("9SZQE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b10d693545bcf6f$export$2e2bcd8739ae039; });
/* text-with-icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("6NpvY");
var $1GDqm = parcelRequire("1GDqm");

var $734nn = parcelRequire("734nn");
const $6b10d693545bcf6f$export$69f8fbc89c62ee2a = "body-md";
const $6b10d693545bcf6f$export$8cea64591eaafc6 = (props)=>{
    const { text: text, style: style = $6b10d693545bcf6f$export$69f8fbc89c62ee2a, icon: icon } = props;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _zulpftgi"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    "data-testid": "TextWithIcon-icon",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $734nn.Icon), {
                        name: icon,
                        size: style === "body-sm" ? "small" : "medium"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    className: (0, $esG4f.default)([
                        style === "body-sm" && "_1pfht94y",
                        style === "body-md" && "_1pfh1l7b"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1GDqm.default), {
                        text: text,
                        style: style
                    })
                })
            ]
        })
    });
};
const $6b10d693545bcf6f$var$wrapperCss = null;
const $6b10d693545bcf6f$var$smTextCss = null;
const $6b10d693545bcf6f$var$mdTextCss = null;
var $6b10d693545bcf6f$export$2e2bcd8739ae039 = $6b10d693545bcf6f$export$8cea64591eaafc6;

});
parcelRegister("734nn", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $ec5ba767a2e09822$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $1QA99 = parcelRequire("1QA99");
const $ec5ba767a2e09822$export$f04a61298a47a40f = (props)=>{
    const { name: name, size: size } = props;
    if (!name) return /*#__PURE__*/ (0, $loA2J.jsx)($ec5ba767a2e09822$var$GlyphIcon, {
        size: size,
        name: "TaskInProgressIcon"
    });
    // @ts-ignore
    const { version: version } = (0, $1QA99.iconMapping)[name];
    if (version === "glyph") return /*#__PURE__*/ (0, $loA2J.jsx)($ec5ba767a2e09822$var$GlyphIcon, (0, $7Knp0._)({}, props));
    return /*#__PURE__*/ (0, $loA2J.jsx)($ec5ba767a2e09822$var$CoreIcon, (0, $7Knp0._)({}, props));
};
const $ec5ba767a2e09822$var$iconWrapperSmallCss = null;
const $ec5ba767a2e09822$var$iconWrapperMediumCss = null;
const $ec5ba767a2e09822$var$CoreIcon = (props)=>{
    const { name: name, size: size } = props; // @ts-ignore
    const BaseIcon = (0, $1QA99.iconMapping)[name].component;
    return /*#__PURE__*/ (0, $loA2J.jsx)("span" // @ts-ignore
    , {
        className: (0, $esG4f.default)([
            size === "small" && "_1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o",
            size === "medium" && "_1bsbzwfg _4t3izwfg _1e0c1txw _1bah1h6o _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)(BaseIcon, {
            icon: name
        })
    });
};
const $ec5ba767a2e09822$var$GlyphIcon = (props)=>{
    const { name: name, size: size } = props; // @ts-ignore
    const BaseGlyphIcon = (0, $1QA99.iconMapping)[name].component;
    return /*#__PURE__*/ (0, $loA2J.jsx)("span" // @ts-ignore
    , {
        className: (0, $esG4f.default)([
            size === "small" && "_1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o",
            size === "small" && "_17521o4j",
            size === "medium" && "_1bsbzwfg _4t3izwfg _1e0c1txw _1bah1h6o _4cvr1h6o",
            size === "medium" && "_1q511lya _17521txs"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)(BaseGlyphIcon, {
            icon: name,
            size: size
        })
    });
};
const $ec5ba767a2e09822$var$glyphIconWrapperSmallCss = null;
const $ec5ba767a2e09822$var$glyphIconWrapperMediumCss = null;

});
parcelRegister("1QA99", function(module, exports) {

$parcel$export(module.exports, "iconMapping", function () { return $ee9cc442b3519108$export$82f701de2810d5a7; });

var $4mM75 = parcelRequire("4mM75");

var $gg1Wi = parcelRequire("gg1Wi");

var $dpNdQ = parcelRequire("dpNdQ");

var $7DwKW = parcelRequire("7DwKW");

var $7fq8b = parcelRequire("7fq8b");

var $lPup9 = parcelRequire("lPup9");

var $kqqsh = parcelRequire("kqqsh");

var $fgomw = parcelRequire("fgomw");

var $5Rv2O = parcelRequire("5Rv2O");

var $4TbFb = parcelRequire("4TbFb");

var $7M1uQ = parcelRequire("7M1uQ");

var $3Xdhp = parcelRequire("3Xdhp");

var $jUWXi = parcelRequire("jUWXi");

var $6Whls = parcelRequire("6Whls");

var $74nrU = parcelRequire("74nrU");

var $7lagR = parcelRequire("7lagR");

var $2RsRU = parcelRequire("2RsRU");

var $hlDQ4 = parcelRequire("hlDQ4");

var $c8hkI = parcelRequire("c8hkI");

var $ctYD4 = parcelRequire("ctYD4");

var $jcATf = parcelRequire("jcATf");

var $20L2t = parcelRequire("20L2t");

var $aRydc = parcelRequire("aRydc");

var $j25Ho = parcelRequire("j25Ho");

var $cm6I6 = parcelRequire("cm6I6");

var $llWxg = parcelRequire("llWxg");

var $jwsof = parcelRequire("jwsof");

var $wQpQg = parcelRequire("wQpQg");

var $iocYh = parcelRequire("iocYh");

var $3SkcQ = parcelRequire("3SkcQ");

var $fI3Vg = parcelRequire("fI3Vg");

var $89oGH = parcelRequire("89oGH");

var $267hL = parcelRequire("267hL");

var $bNqWX = parcelRequire("bNqWX");

var $3UpUT = parcelRequire("3UpUT");

var $hieSB = parcelRequire("hieSB");

var $fJ5Su = parcelRequire("fJ5Su");

var $bRs7t = parcelRequire("bRs7t");

var $iy4Sr = parcelRequire("iy4Sr");

var $e5LHD = parcelRequire("e5LHD");

var $aLqNf = parcelRequire("aLqNf");

var $7Zpdo = parcelRequire("7Zpdo");

var $ft8Zd = parcelRequire("ft8Zd");

var $g0xEi = parcelRequire("g0xEi");

var $1BHq9 = parcelRequire("1BHq9");

var $fkwrS = parcelRequire("fkwrS");

var $gbUnT = parcelRequire("gbUnT");

var $jDXvh = parcelRequire("jDXvh");

var $ko7jr = parcelRequire("ko7jr");

var $30lzE = parcelRequire("30lzE");

var $lWAak = parcelRequire("lWAak");

var $509Ny = parcelRequire("509Ny");

var $8P0uP = parcelRequire("8P0uP");

var $cDp2C = parcelRequire("cDp2C");

var $g8hkf = parcelRequire("g8hkf");

var $9PjA9 = parcelRequire("9PjA9");

var $ggvlr = parcelRequire("ggvlr");

var $eH5ui = parcelRequire("eH5ui");

var $guk0p = parcelRequire("guk0p");

var $6PLjX = parcelRequire("6PLjX");

var $7ZFBY = parcelRequire("7ZFBY");

var $elfku = parcelRequire("elfku");

var $iSfb0 = parcelRequire("iSfb0");

var $4w8Rb = parcelRequire("4w8Rb");

var $kuew8 = parcelRequire("kuew8");
const $ee9cc442b3519108$export$82f701de2810d5a7 = {
    TimelineIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($guk0p))),
        version: "core"
    },
    CalendarIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7M1uQ))),
        version: "core"
    },
    WarningIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7ZFBY))),
        version: "core"
    },
    TeamsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($eH5ui))),
        version: "core"
    },
    ChangesIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3Xdhp))),
        version: "core"
    },
    ChartBarIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($jUWXi))),
        version: "core"
    },
    BriefcaseIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($5Rv2O))),
        version: "core"
    },
    AutomationIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7DwKW))),
        version: "core"
    },
    BugIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($4TbFb))),
        version: "core"
    },
    DepartmentIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($20L2t))),
        version: "core"
    },
    EyeOpenIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($cm6I6))),
        version: "core"
    },
    BranchIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fgomw))),
        version: "core"
    },
    PhoneIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fkwrS))),
        version: "core"
    },
    CommentIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ctYD4))),
        version: "core"
    },
    Page: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($aLqNf))),
        version: "core"
    },
    PersonAddIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($g0xEi))),
        version: "core"
    },
    PersonAddedIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($1BHq9))),
        version: "core"
    },
    LobbyBellIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($bNqWX))),
        version: "core"
    },
    InformationIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fI3Vg))),
        version: "core"
    },
    PriorityMajorIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($jDXvh))),
        version: "core"
    },
    OfficeBuildingIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($iy4Sr))),
        version: "core"
    },
    ChartTrendIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7lagR))),
        version: "core"
    },
    CheckboxCheckedIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($c8hkI))),
        version: "core"
    },
    GoalIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3SkcQ))),
        version: "core"
    },
    ScreenIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($lWAak))),
        version: "core"
    },
    BookWithBookmarkIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($kqqsh))),
        version: "core"
    },
    PagesIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7Zpdo))),
        version: "core"
    },
    ChartMatrixIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($74nrU))),
        version: "core"
    },
    RoadmapIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($30lzE))),
        version: "core"
    },
    ShowMoreVerticalIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($8P0uP))),
        version: "core"
    },
    TagIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($9PjA9))),
        version: "core"
    },
    MarketplaceIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($hieSB))),
        version: "core"
    },
    AngleBracketsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gg1Wi))),
        version: "core"
    },
    ProjectIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ko7jr))),
        version: "core"
    },
    BoardIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($lPup9))),
        version: "core"
    },
    MegaphoneIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fJ5Su))),
        version: "core"
    },
    TransitionIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6PLjX))),
        version: "core"
    },
    StarStarredIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($g8hkf))),
        version: "core"
    },
    EmojiIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($j25Ho))),
        version: "core"
    },
    TaskInProgressIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ggvlr))),
        version: "core"
    },
    FormsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($iocYh))),
        version: "core"
    },
    FilesIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($wQpQg))),
        version: "core"
    },
    FileIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($jwsof))),
        version: "core"
    },
    ListBulletedIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($89oGH))),
        version: "core"
    },
    SmartLinkListIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($cDp2C))),
        version: "core"
    },
    MagicWandIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3UpUT))),
        version: "core"
    },
    OperationsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($e5LHD))),
        version: "core"
    },
    DecisionIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($jcATf))),
        version: "core"
    },
    FeedbackIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($llWxg))),
        version: "core"
    },
    ObjectiveIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($bRs7t))),
        version: "core"
    },
    PresenterModeIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gbUnT))),
        version: "core"
    },
    BacklogIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7fq8b))),
        version: "core"
    },
    SearchIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($509Ny))),
        version: "core"
    },
    EditIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($aRydc))),
        version: "core"
    },
    CheckMarkIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($hlDQ4))),
        version: "core"
    },
    CheckCircleIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($2RsRU))),
        version: "core"
    },
    ListChecklistIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($267hL))),
        version: "core"
    },
    ArchiveBoxIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($dpNdQ))),
        version: "core"
    },
    AlertIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($4mM75))),
        version: "core"
    },
    RoadmapsPlanIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($4w8Rb))),
        version: "core"
    },
    PeopleGroupIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ft8Zd))),
        version: "core"
    },
    BrowserExtensionIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($elfku))),
        version: "core"
    },
    SyncIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($kuew8))),
        version: "core"
    },
    NotepadIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($iSfb0))),
        version: "core"
    },
    ChartBubbleIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6Whls))),
        version: "core"
    }
};

});
parcelRegister("gg1Wi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::196b600e7960a1af1a5f6fffc09ddaa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd5fa50b89111176$var$_react = $bd5fa50b89111176$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $bd5fa50b89111176$var$_baseNew = $bd5fa50b89111176$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $bd5fa50b89111176$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bd5fa50b89111176$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $bd5fa50b89111176$var$_react.default.createElement($bd5fa50b89111176$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$bd5fa50b89111176$var$AngleBracketsIcon.displayName = "AngleBracketsIcon";
var $bd5fa50b89111176$var$_default = module.exports.default = $bd5fa50b89111176$var$AngleBracketsIcon;

});

parcelRegister("dpNdQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53af402aec64299fbaefa11fd3d04c88>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c43caaf2d5893de$var$_react = $9c43caaf2d5893de$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $9c43caaf2d5893de$var$_baseNew = $9c43caaf2d5893de$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $9c43caaf2d5893de$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArchiveBox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: archiving pages, storage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c43caaf2d5893de$var$ArchiveBoxIcon = (props)=>/*#__PURE__*/ $9c43caaf2d5893de$var$_react.default.createElement($9c43caaf2d5893de$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v5h-1v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6H1zm2.5 5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V6zm10-1.5h-11v-2h11zm-3 4.5h-5V7.5h5z" clip-rule="evenodd"/>`
    }, props));
$9c43caaf2d5893de$var$ArchiveBoxIcon.displayName = "ArchiveBoxIcon";
var $9c43caaf2d5893de$var$_default = module.exports.default = $9c43caaf2d5893de$var$ArchiveBoxIcon;

});

parcelRegister("fgomw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1cb3f795038bad9$var$_react = $b1cb3f795038bad9$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b1cb3f795038bad9$var$_baseNew = $b1cb3f795038bad9$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b1cb3f795038bad9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b1cb3f795038bad9$var$BranchIcon = (props)=>/*#__PURE__*/ $b1cb3f795038bad9$var$_react.default.createElement($b1cb3f795038bad9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$b1cb3f795038bad9$var$BranchIcon.displayName = "BranchIcon";
var $b1cb3f795038bad9$var$_default = module.exports.default = $b1cb3f795038bad9$var$BranchIcon;

});

parcelRegister("5Rv2O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e2b10cb2fb36d0ad7bfa02e0b0408651>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4449fbbad119e5d2$var$_react = $4449fbbad119e5d2$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $4449fbbad119e5d2$var$_baseNew = $4449fbbad119e5d2$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $4449fbbad119e5d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Briefcase".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Job title in Atlas, Operations in JSM.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4449fbbad119e5d2$var$BriefcaseIcon = (props)=>/*#__PURE__*/ $4449fbbad119e5d2$var$_react.default.createElement($4449fbbad119e5d2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 2.5a.5.5 0 0 0-.5.5v1h5V3a.5.5 0 0 0-.5-.5zM12 4V3a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v1H3a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 5.5a.5.5 0 0 0-.5.5v2h11V6a.5.5 0 0 0-.5-.5zm10.5 4H8.75V11h-1.5V9.5H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$4449fbbad119e5d2$var$BriefcaseIcon.displayName = "BriefcaseIcon";
var $4449fbbad119e5d2$var$_default = module.exports.default = $4449fbbad119e5d2$var$BriefcaseIcon;

});

parcelRegister("74nrU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d0119e14b14178352097aaf532e33e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $525b189de5fa6099$var$_react = $525b189de5fa6099$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $525b189de5fa6099$var$_baseNew = $525b189de5fa6099$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $525b189de5fa6099$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartMatrix".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Matrix view in in JPD, and other matrix charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $525b189de5fa6099$var$ChartMatrixIcon = (props)=>/*#__PURE__*/ $525b189de5fa6099$var$_react.default.createElement($525b189de5fa6099$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8 4.25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M13.25 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-5.5 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2m5.5-9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m8 3.5a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5M10.5 8A1.75 1.75 0 1 1 14 8a1.75 1.75 0 0 1-3.5 0m-5 2.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$525b189de5fa6099$var$ChartMatrixIcon.displayName = "ChartMatrixIcon";
var $525b189de5fa6099$var$_default = module.exports.default = $525b189de5fa6099$var$ChartMatrixIcon;

});

parcelRegister("iocYh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f6cd595d4ec67af9dd83acc02e35c9f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d63487b8d7103f43$var$_react = $d63487b8d7103f43$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $d63487b8d7103f43$var$_baseNew = $d63487b8d7103f43$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $d63487b8d7103f43$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Form".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Represents forms across Atlassian products, including Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d63487b8d7103f43$var$FormIcon = (props)=>/*#__PURE__*/ $d63487b8d7103f43$var$_react.default.createElement($d63487b8d7103f43$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 1.5H1V0h6zM1 3.875c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75C15 6.385 14.384 7 13.625 7H2.375C1.615 7 1 6.384 1 5.625zM2.5 4v1.5h11V4zM7 10.5H1V9h6zm-6 2.375c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75c0 .76-.616 1.375-1.375 1.375H2.375C1.615 16 1 15.384 1 14.625zM2.5 13v1.5h11V13z" clip-rule="evenodd"/>`
    }, props));
$d63487b8d7103f43$var$FormIcon.displayName = "FormIcon";
var $d63487b8d7103f43$var$_default = module.exports.default = $d63487b8d7103f43$var$FormIcon;

});

parcelRegister("fI3Vg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d43a7428702b82788297fb999fe29f0a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6fe0201439438b3$var$_react = $b6fe0201439438b3$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b6fe0201439438b3$var$_baseNew = $b6fe0201439438b3$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b6fe0201439438b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b6fe0201439438b3$var$InformationIcon = (props)=>/*#__PURE__*/ $b6fe0201439438b3$var$_react.default.createElement($b6fe0201439438b3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$b6fe0201439438b3$var$InformationIcon.displayName = "InformationIcon";
var $b6fe0201439438b3$var$_default = module.exports.default = $b6fe0201439438b3$var$InformationIcon;

});

parcelRegister("267hL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::481d1ea8ad85e9d7b0bddff8ba9b16d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1871cb1583e370a3$var$_react = $1871cb1583e370a3$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $1871cb1583e370a3$var$_baseNew = $1871cb1583e370a3$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $1871cb1583e370a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListChecklist".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: Checklist, 'Requirement' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1871cb1583e370a3$var$ListChecklistIcon = (props)=>/*#__PURE__*/ $1871cb1583e370a3$var$_react.default.createElement($1871cb1583e370a3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m5.59 9.97-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07-1.37-2.12 1.26-.81.81 1.25 2.33-2.95zm0-7.5-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07L.01 4.04l1.26-.81.81 1.25 2.33-2.95zM16 11v1.5H7V11zm0-7.5V5H7V3.5z"/>`
    }, props));
$1871cb1583e370a3$var$ListChecklistIcon.displayName = "ListChecklistIcon";
var $1871cb1583e370a3$var$_default = module.exports.default = $1871cb1583e370a3$var$ListChecklistIcon;

});

parcelRegister("3UpUT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b57d69a7e6f53846886bde82f36883e5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2d8ab48e24800f67$var$_react = $2d8ab48e24800f67$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $2d8ab48e24800f67$var$_baseNew = $2d8ab48e24800f67$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $2d8ab48e24800f67$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "MagicWand".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2d8ab48e24800f67$var$MagicWandIcon = (props)=>/*#__PURE__*/ $2d8ab48e24800f67$var$_react.default.createElement($2d8ab48e24800f67$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9.027 3.911a1.376 1.376 0 0 1 1.841-.094l.105.094 1.116 1.116a1.376 1.376 0 0 1 0 1.946l-8.616 8.616a1.376 1.376 0 0 1-1.946 0L.411 14.473a1.376 1.376 0 0 1 0-1.946zM1.561 13.5l.939.94L7.938 9 7 8.061zm13.431-4.067-1.06 1.06-1.415-1.414 1.061-1.06zM8.061 7l.938.938L10.939 6l-.94-.94zM16 5v1.5h-2V5zM7.982 2.422l-1.06 1.06-1.414-1.414 1.06-1.06zm7.01-.354-1.414 1.414-1.06-1.06 1.414-1.414zM11 0v2H9.5V0z"/>`
    }, props));
$2d8ab48e24800f67$var$MagicWandIcon.displayName = "MagicWandIcon";
var $2d8ab48e24800f67$var$_default = module.exports.default = $2d8ab48e24800f67$var$MagicWandIcon;

});

parcelRegister("hieSB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ed07350d21c7e2ad94ff4198361d506>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c96fa8ea1d90bb95$var$_react = $c96fa8ea1d90bb95$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $c96fa8ea1d90bb95$var$_baseNew = $c96fa8ea1d90bb95$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $c96fa8ea1d90bb95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Marketplace".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Marketplace.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c96fa8ea1d90bb95$var$MarketplaceIcon = (props)=>/*#__PURE__*/ $c96fa8ea1d90bb95$var$_react.default.createElement($c96fa8ea1d90bb95$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.789 1.513A.75.75 0 0 1 2.5 1h11a.75.75 0 0 1 .711.513l1.502 4.5a.8.8 0 0 1 .038.237A3.08 3.08 0 0 1 14 9.032V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.031A3.08 3.08 0 0 1 .25 6.25q0-.12.038-.237zM3.5 9.329V13a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9.33a3.08 3.08 0 0 1-2.166-1.064A3.08 3.08 0 0 1 8 9.334a3.08 3.08 0 0 1-2.334-1.068A3.08 3.08 0 0 1 3.5 9.329M4.916 6.25v.03a1.584 1.584 0 0 1-3.163.08l.037-.11zm1.5.038.005-.038h3.158l.004.038a1.584 1.584 0 0 1-3.166 0M9.413 4.75H6.588l.25-2.25h2.324zm1.672 1.5a1.584 1.584 0 0 0 3.164.11l-.037-.11zm2.626-1.5h-2.788l-.25-2.25h2.288zM5.33 2.5l-.25 2.25H2.29l.75-2.25z" clip-rule="evenodd"/>`
    }, props));
$c96fa8ea1d90bb95$var$MarketplaceIcon.displayName = "MarketplaceIcon";
var $c96fa8ea1d90bb95$var$_default = module.exports.default = $c96fa8ea1d90bb95$var$MarketplaceIcon;

});

parcelRegister("bRs7t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6209776ef69c56f26af2970fd840a919>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a2a74e45c0701ee$var$_react = $8a2a74e45c0701ee$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $8a2a74e45c0701ee$var$_baseNew = $8a2a74e45c0701ee$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $8a2a74e45c0701ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Objective".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for objectives.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a2a74e45c0701ee$var$ObjectiveIcon = (props)=>/*#__PURE__*/ $8a2a74e45c0701ee$var$_react.default.createElement($8a2a74e45c0701ee$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.422.02a.75.75 0 0 1 .54.493l.38 1.144 1.145.381a.75.75 0 0 1 .293 1.242l-2 2a.75.75 0 0 1-.53.22h-1.69L8.03 9.03 6.97 7.97l3.53-3.53V2.75a.75.75 0 0 1 .22-.53l2-2a.75.75 0 0 1 .702-.2M12 4h.94l.922-.922-.35-.116a.75.75 0 0 1-.473-.475l-.117-.349-.922.923zM8 1.5A6.5 6.5 0 1 0 14.5 8H16a8 8 0 1 1-8-8zM8 5a3 3 0 1 0 3 3h1.5A4.5 4.5 0 1 1 8 3.5z" clip-rule="evenodd"/>`
    }, props));
$8a2a74e45c0701ee$var$ObjectiveIcon.displayName = "ObjectiveIcon";
var $8a2a74e45c0701ee$var$_default = module.exports.default = $8a2a74e45c0701ee$var$ObjectiveIcon;

});

parcelRegister("e5LHD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30e149500cf1a05a183dbc43511b361c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a426891697dd54be$var$_react = $a426891697dd54be$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $a426891697dd54be$var$_baseNew = $a426891697dd54be$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $a426891697dd54be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Operations".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for IT Operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a426891697dd54be$var$OperationsIcon = (props)=>/*#__PURE__*/ $a426891697dd54be$var$_react.default.createElement($a426891697dd54be$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.036 2.904A6.501 6.501 0 1 0 8 14.5V16a8 8 0 1 1 5.657-13.657l.53.53L8.28 8.78 7.22 7.72l2.304-2.305A3.001 3.001 0 1 0 8 11v1.5a4.5 4.5 0 1 1 2.608-8.168z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M14.58 4.862a.75.75 0 0 1 .959.454l.008.025a.75.75 0 1 1-1.414.499l-.007-.02a.75.75 0 0 1 .454-.958m-2.798 2.573a.75.75 0 0 1 .713.786l-.001.015-.001.014a.75.75 0 1 1-1.498-.083v-.01l.001-.01a.75.75 0 0 1 .786-.712m3.497.184a.75.75 0 0 1 .71.787v.026a.75.75 0 1 1-1.498-.081V8.33a.75.75 0 0 1 .788-.711m-4.205 2.656a.75.75 0 0 1-.052 1.06l-.022.019a.75.75 0 1 1-1-1.118l.015-.013a.75.75 0 0 1 1.059.052m3.799.16a.75.75 0 0 1 .355.999l-.011.023a.75.75 0 0 1-1.353-.649l.01-.019a.75.75 0 0 1 .999-.355m-1.457 2.442a.75.75 0 0 1-.053 1.06l-.02.017a.75.75 0 0 1-1.001-1.117l.015-.014a.75.75 0 0 1 1.06.054m-2.278 1.703a.75.75 0 0 1-.454.959l-.025.008a.75.75 0 0 1-.499-1.414l.02-.007a.75.75 0 0 1 .958.454" clip-rule="evenodd"/>`
    }, props));
$a426891697dd54be$var$OperationsIcon.displayName = "OperationsIcon";
var $a426891697dd54be$var$_default = module.exports.default = $a426891697dd54be$var$OperationsIcon;

});

parcelRegister("gbUnT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::975f3556f302c98e53e9a5c512ff1020>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc996930445c07e8$var$_react = $bc996930445c07e8$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $bc996930445c07e8$var$_baseNew = $bc996930445c07e8$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $bc996930445c07e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PresenterMode".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for presenter mode in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bc996930445c07e8$var$PresenterModeIcon = (props)=>/*#__PURE__*/ $bc996930445c07e8$var$_react.default.createElement($bc996930445c07e8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.909 2.5a2.409 2.409 0 0 0-1.054 4.576l-.657 1.348a3.909 3.909 0 1 1 5.226-5.226l-1.348.657A2.41 2.41 0 0 0 4.909 2.5m-.19 2.22a.75.75 0 0 1 .786-.175l9 3.25a.75.75 0 0 1 .02 1.403l-3.822 1.505-1.505 3.822a.75.75 0 0 1-1.403-.02l-3.25-9a.75.75 0 0 1 .175-.785M6.5 6.498l2.032 5.628.896-2.276a.75.75 0 0 1 .423-.423l2.276-.896z" clip-rule="evenodd"/>`
    }, props));
$bc996930445c07e8$var$PresenterModeIcon.displayName = "PresenterModeIcon";
var $bc996930445c07e8$var$_default = module.exports.default = $bc996930445c07e8$var$PresenterModeIcon;

});

parcelRegister("jDXvh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ff5f3689a11c3468e5139786a8e64251>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e4cfd1038e117e57$var$_react = $e4cfd1038e117e57$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $e4cfd1038e117e57$var$_baseNew = $e4cfd1038e117e57$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $e4cfd1038e117e57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityMajor".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for major work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e4cfd1038e117e57$var$PriorityMajorIcon = (props)=>/*#__PURE__*/ $e4cfd1038e117e57$var$_react.default.createElement($e4cfd1038e117e57$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.913 4.75-5.5-3.625a.75.75 0 0 0-.826 0l-5.5 3.625L2.913 6 8 2.65 13.087 6zm0 4.5-5.5-3.625a.75.75 0 0 0-.826 0l-5.5 3.625.826 1.252L8 7.149l5.087 3.353zm0 4.5-5.5-3.626a.75.75 0 0 0-.826 0l-5.5 3.625.826 1.252L8 11.65l5.087 3.353z"/>`
    }, props));
$e4cfd1038e117e57$var$PriorityMajorIcon.displayName = "PriorityMajorIcon";
var $e4cfd1038e117e57$var$_default = module.exports.default = $e4cfd1038e117e57$var$PriorityMajorIcon;

});

parcelRegister("lWAak", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1698552166bfef93121ec02f2fff1081>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff9b1182de1c9206$var$_react = $ff9b1182de1c9206$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $ff9b1182de1c9206$var$_baseNew = $ff9b1182de1c9206$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $ff9b1182de1c9206$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Screen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ff9b1182de1c9206$var$ScreenIcon = (props)=>/*#__PURE__*/ $ff9b1182de1c9206$var$_react.default.createElement($ff9b1182de1c9206$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8.75v1.5H12V15H4v-1.5h3.25V12H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$ff9b1182de1c9206$var$ScreenIcon.displayName = "ScreenIcon";
var $ff9b1182de1c9206$var$_default = module.exports.default = $ff9b1182de1c9206$var$ScreenIcon;

});

parcelRegister("8P0uP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::02df73cd5dddff20d82e48f58fe7ce92>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66c378ab0381dd7f$var$_react = $66c378ab0381dd7f$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $66c378ab0381dd7f$var$_baseNew = $66c378ab0381dd7f$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $66c378ab0381dd7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus, traditionally on mobile.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66c378ab0381dd7f$var$ShowMoreVerticalIcon = (props)=>/*#__PURE__*/ $66c378ab0381dd7f$var$_react.default.createElement($66c378ab0381dd7f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.5 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$66c378ab0381dd7f$var$ShowMoreVerticalIcon.displayName = "ShowMoreVerticalIcon";
var $66c378ab0381dd7f$var$_default = module.exports.default = $66c378ab0381dd7f$var$ShowMoreVerticalIcon;

});

parcelRegister("cDp2C", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d0cf5658da3b79d5f876ad9c272a691a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $932c8d3be2b6f2b7$var$_react = $932c8d3be2b6f2b7$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $932c8d3be2b6f2b7$var$_baseNew = $932c8d3be2b6f2b7$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $932c8d3be2b6f2b7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkList".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing Smart link embedded link lists.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $932c8d3be2b6f2b7$var$SmartLinkListIcon = (props)=>/*#__PURE__*/ $932c8d3be2b6f2b7$var$_react.default.createElement($932c8d3be2b6f2b7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm2.5 3H4V4h1.5zm6.5 0H7V4h5zM5.5 8.75H4v-1.5h1.5zm6.5 0H7v-1.5h5zM5.5 12H4v-1.5h1.5zm6.5 0H7v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$932c8d3be2b6f2b7$var$SmartLinkListIcon.displayName = "SmartLinkListIcon";
var $932c8d3be2b6f2b7$var$_default = module.exports.default = $932c8d3be2b6f2b7$var$SmartLinkListIcon;

});

parcelRegister("9PjA9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::338651941b03ec38a528c6808ae2ffcd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $727811146868953b$var$_react = $727811146868953b$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $727811146868953b$var$_baseNew = $727811146868953b$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $727811146868953b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tag".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $727811146868953b$var$TagIcon = (props)=>/*#__PURE__*/ $727811146868953b$var$_react.default.createElement($727811146868953b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/><path fill="currentcolor" fill-rule="evenodd" d="M9.286 1a3.25 3.25 0 0 0-2.299.952L1.604 7.336a2 2 0 0 0 0 2.828l4.232 4.232a2 2 0 0 0 2.828 0l5.384-5.383A3.25 3.25 0 0 0 15 6.714V3a2 2 0 0 0-2-2zM8.048 3.013A1.75 1.75 0 0 1 9.286 2.5H13a.5.5 0 0 1 .5.5v3.714c0 .465-.184.91-.513 1.238l-5.383 5.384a.5.5 0 0 1-.708 0L2.664 9.104a.5.5 0 0 1 0-.708z" clip-rule="evenodd"/>`
    }, props));
$727811146868953b$var$TagIcon.displayName = "TagIcon";
var $727811146868953b$var$_default = module.exports.default = $727811146868953b$var$TagIcon;

});

parcelRegister("ggvlr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::350d68f25c9b4e9b7a6f8128f373fbcc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd767466e2ef74ca$var$_react = $bd767466e2ef74ca$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $bd767466e2ef74ca$var$_baseNew = $bd767466e2ef74ca$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $bd767466e2ef74ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TaskInProgress".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for in progress task status. Used in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bd767466e2ef74ca$var$TaskInProgressIcon = (props)=>/*#__PURE__*/ $bd767466e2ef74ca$var$_react.default.createElement($bd767466e2ef74ca$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.543 7.25h7.646L6.97 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H1.542a6.501 6.501 0 1 0 0-1.5M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8" clip-rule="evenodd"/>`
    }, props));
$bd767466e2ef74ca$var$TaskInProgressIcon.displayName = "TaskInProgressIcon";
var $bd767466e2ef74ca$var$_default = module.exports.default = $bd767466e2ef74ca$var$TaskInProgressIcon;

});

parcelRegister("6PLjX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b20915105f9f06f3ef89ee9497af0ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f9c367122dee778$var$_react = $4f9c367122dee778$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $4f9c367122dee778$var$_baseNew = $4f9c367122dee778$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $4f9c367122dee778$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Transition".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for transitions in Analytics.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4f9c367122dee778$var$TransitionIcon = (props)=>/*#__PURE__*/ $4f9c367122dee778$var$_react.default.createElement($4f9c367122dee778$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.75 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.122 0a2.251 2.251 0 1 1 0 1.5h-.816c-.586 0-1.062.476-1.062 1.063v5.875A2.563 2.563 0 0 1 6.188 13.5h-.816a2.25 2.25 0 1 1 0-1.5h.816c.586 0 1.062-.476 1.062-1.062V5.062A2.56 2.56 0 0 1 9.813 2.5zM3.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$4f9c367122dee778$var$TransitionIcon.displayName = "TransitionIcon";
var $4f9c367122dee778$var$_default = module.exports.default = $4f9c367122dee778$var$TransitionIcon;

});





parcelRegister("jzDAp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("4d4f5")).default; });

var $4d4f5 = parcelRequire("4d4f5");
 // export type { UniformVariantProps } from "./src/variant";

});
parcelRegister("4d4f5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e222d054d5504f7$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");
const $1e222d054d5504f7$var$UniformVariant = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: "content"
    });
};
var $1e222d054d5504f7$export$2e2bcd8739ae039 = $1e222d054d5504f7$var$UniformVariant;

});


parcelRegister("3Z0Az", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("bR2Mn")).default; });

var $bR2Mn = parcelRequire("bR2Mn");

});
parcelRegister("bR2Mn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50c82a39185e8ede$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");
const $50c82a39185e8ede$var$UniformVariantContainer = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: "content"
    });
var $50c82a39185e8ede$export$2e2bcd8739ae039 = $50c82a39185e8ede$var$UniformVariantContainer;

});


//@ts-nocheck
// This file is the entry for Webpack and Parcel fallback.
// This file includes the mapping between the route and the component that should be rendered for that route.
// You are not meant to import this file on client-side code, as it will make the bundle size bigger.

var $evZwi = parcelRequire("evZwi");

var $200NX = parcelRequire("200NX");

var $9iWJ8 = parcelRequire("9iWJ8");
parcelRequire("iTDk2");
var $cCupH = parcelRequire("cCupH");
var $3oPm6 = parcelRequire("3oPm6");
var $4va49 = parcelRequire("4va49");
var $bl3E5 = parcelRequire("bl3E5");
var $lsqCW = parcelRequire("lsqCW");

var $a6B8g = parcelRequire("a6B8g");

var $7dX9c = parcelRequire("7dX9c");

var $7Fuy3 = parcelRequire("7Fuy3");

var $cQTaT = parcelRequire("cQTaT");

var $5asZh = parcelRequire("5asZh");

var $3vHgs = parcelRequire("3vHgs");

var $eyRtN = parcelRequire("eyRtN");

var $dgztS = parcelRequire("dgztS");

var $ewIf8 = parcelRequire("ewIf8");

var $hVOzm = parcelRequire("hVOzm");

var $jeTGv = parcelRequire("jeTGv");

var $cbOuC = parcelRequire("cbOuC");

var $cy7iU = parcelRequire("cy7iU");

var $cZ6ed = parcelRequire("cZ6ed");

var $6aWz6 = parcelRequire("6aWz6");

var $3nv1K = parcelRequire("3nv1K");

var $jJFPZ = parcelRequire("jJFPZ");

var $iiPAa = parcelRequire("iiPAa");

var $QtTDf = parcelRequire("QtTDf");

var $jhLgK = parcelRequire("jhLgK");

var $1eXgi = parcelRequire("1eXgi");

var $3kaLT = parcelRequire("3kaLT");

var $5l8W2 = parcelRequire("5l8W2");

var $bmKvu = parcelRequire("bmKvu");

var $bYVXE = parcelRequire("bYVXE");

var $3hOaF = parcelRequire("3hOaF");

var $dP45N = parcelRequire("dP45N");

var $l9dqv = parcelRequire("l9dqv");

var $jZQGv = parcelRequire("jZQGv");

var $d7VZR = parcelRequire("d7VZR");

var $dIAEL = parcelRequire("dIAEL");

var $aQuME = parcelRequire("aQuME");

var $kGjia = parcelRequire("kGjia");

var $iPHuy = parcelRequire("iPHuy");

var $29ctt = parcelRequire("29ctt");

var $7T3K5 = parcelRequire("7T3K5");

var $fR8rA = parcelRequire("fR8rA");

var $dUMGS = parcelRequire("dUMGS");

var $iiM0Q = parcelRequire("iiM0Q");

var $28rj9 = parcelRequire("28rj9");

var $gr0Wo = parcelRequire("gr0Wo");

var $eYo1w = parcelRequire("eYo1w");

var $88Nc8 = parcelRequire("88Nc8");

var $aR9rM = parcelRequire("aR9rM");

var $cvEcp = parcelRequire("cvEcp");

var $4Kg8I = parcelRequire("4Kg8I");

var $lDCFR = parcelRequire("lDCFR");

var $aSYwy = parcelRequire("aSYwy");

var $crPWy = parcelRequire("crPWy");

var $e15Q8 = parcelRequire("e15Q8");

var $kyMgW = parcelRequire("kyMgW");

var $5YjFo = parcelRequire("5YjFo");

var $7YM1S = parcelRequire("7YM1S");

var $8KAIN = parcelRequire("8KAIN");

var $bs4n3 = parcelRequire("bs4n3");

var $1Dw5R = parcelRequire("1Dw5R");

var $jmVsK = parcelRequire("jmVsK");

var $lHRSz = parcelRequire("lHRSz");

var $0M3nE = parcelRequire("0M3nE");

var $eAxa6 = parcelRequire("eAxa6");

var $jJy4Z = parcelRequire("jJy4Z");

var $auFti = parcelRequire("auFti");

var $75UBa = parcelRequire("75UBa");

var $6OWgV = parcelRequire("6OWgV");

var $8rgnW = parcelRequire("8rgnW");

var $3l68c = parcelRequire("3l68c");

var $kPNXB = parcelRequire("kPNXB");

var $4ewKx = parcelRequire("4ewKx");

var $j7l2H = parcelRequire("j7l2H");

var $7Z8lp = parcelRequire("7Z8lp");

var $aEM8Q = parcelRequire("aEM8Q");

var $4jXNI = parcelRequire("4jXNI");

var $i8zdv = parcelRequire("i8zdv");

var $b3ZMX = parcelRequire("b3ZMX");

var $a1ns9 = parcelRequire("a1ns9");

var $gDaC1 = parcelRequire("gDaC1");

var $6KSFr = parcelRequire("6KSFr");

var $3aSr8 = parcelRequire("3aSr8");

var $7Icip = parcelRequire("7Icip");

var $gtIRL = parcelRequire("gtIRL");

var $bv0o8 = parcelRequire("bv0o8");

var $99FZR = parcelRequire("99FZR");

var $ldfiY = parcelRequire("ldfiY");

var $ehyVQ = parcelRequire("ehyVQ");

var $dknVo = parcelRequire("dknVo");

var $gBm7i = parcelRequire("gBm7i");

var $7BQx4 = parcelRequire("7BQx4");

var $jwejb = parcelRequire("jwejb");

var $iVJd6 = parcelRequire("iVJd6");

var $hkBIf = parcelRequire("hkBIf");

var $4ytMB = parcelRequire("4ytMB");

var $ljOnm = parcelRequire("ljOnm");

var $dRBBv = parcelRequire("dRBBv");

var $ai5nK = parcelRequire("ai5nK");

var $kTpag = parcelRequire("kTpag");

var $54ICB = parcelRequire("54ICB");

var $dt8LD = parcelRequire("dt8LD");

var $kzx7G = parcelRequire("kzx7G");

var $3MxDQ = parcelRequire("3MxDQ");

var $c6SB4 = parcelRequire("c6SB4");

var $hWRkD = parcelRequire("hWRkD");

var $jIvlj = parcelRequire("jIvlj");

var $6c1Y0 = parcelRequire("6c1Y0");

var $7Nopm = parcelRequire("7Nopm");

var $1KLms = parcelRequire("1KLms");

var $anmoL = parcelRequire("anmoL");

var $b45Um = parcelRequire("b45Um");

var $kTri3 = parcelRequire("kTri3");

var $4o4mW = parcelRequire("4o4mW");

var $4ponz = parcelRequire("4ponz");

var $lgDo7 = parcelRequire("lgDo7");

var $lcvl0 = parcelRequire("lcvl0");
parcelRequire("bMysh");

var $6sE8c = parcelRequire("6sE8c");

var $78sex = parcelRequire("78sex");

var $dH3QU = parcelRequire("dH3QU");

var $hrScA = parcelRequire("hrScA");

var $fvAxO = parcelRequire("fvAxO");

var $9Dbz6 = parcelRequire("9Dbz6");
const $d760fc1e0b4af0ff$var$inRoutingTable = (segments, index, segLength, routeObject)=>{
    const currSeg = String(segments[index]);
    const hasSeg = routeObject[currSeg];
    const hasWildcard = routeObject["*"];
    const lastSeg = index == segLength;
    if (hasSeg) {
        if (lastSeg) return !Boolean(hasSeg["p"]);
        return $d760fc1e0b4af0ff$var$inRoutingTable(segments, index + 1, segLength, hasSeg);
    }
    if (hasWildcard) {
        if (lastSeg) return !Boolean(hasWildcard["p"]);
        return $d760fc1e0b4af0ff$var$inRoutingTable(segments, index + 1, segLength, hasWildcard);
    }
    return false;
};
const $d760fc1e0b4af0ff$export$da6d2f7032b7150b = (location, userLocale, userLoggedIn, subAnchor, routingTable)=>{
    const route = (0, $9Dbz6.parseRoute)(location);
    // Check if page is a Uniform-supported route
    if (routingTable) {
        const segments = route.path.split("/");
        const segLength = segments.length;
        if (routingTable && route.path !== "" && $d760fc1e0b4af0ff$var$inRoutingTable(segments, 0, segLength - 1, routingTable["wac"])) {
            console.log(route.path, "is Uniform route served by Routing Table");
            return {
                Component: (0, $lgDo7.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        } else console.log(route.path, "is NOT Uniform route");
    }
    const isUniformLazyLoadingEnabled = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).uniformLazyLoading);
    console.log("isUniformLazyLoadingEnabled: %s - %s", isUniformLazyLoadingEnabled, route.path);
    if (isUniformLazyLoadingEnabled) {
        console.log("Setting Component to UniformEntryLazyPage");
        return {
            Component: (0, $4ponz.UniformEntryLazyPage),
            entryName: "uniform-entry-lazy-page",
            isUniformCanary: route.isUniformCanary,
            isS3UniformRoute: true
        };
    }
    switch(route.path){
        case `fastshift`:
        case `fastshift/${$d760fc1e0b4af0ff$var$getRouteExtension(route.path, "fastshift/")}`:
            route.variant;
            return {
                Component: (0, $6aWz6.FastshiftDashboardPage),
                entryName: "fastshift-dashboard-page"
            };
        case "uniform-preview":
            return {
                Component: (0, $a6B8g.FourOhFourPage),
                entryName: "404"
            };
        case "software/rovo/pricing":
            route.variant;
            return {
                Component: (0, $7Nopm.SoftwareRovoPricingPage),
                entryName: "software-rovo-pricing-page",
                query: (0, $cCupH.PricingPageRelayQuery),
                queryVars: (0, $cCupH.getPricingPageRelayQueryVars)("rovo", location),
                isRelayEnabled: true,
                relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
            };
        case "software/rovo-dev/pricing":
            const isRovoDevPricingEnabled = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).gwp8036RovoDevPricingPage);
            if (isRovoDevPricingEnabled) return {
                Component: (0, $lgDo7.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
            return {
                Component: (0, $a6B8g.FourOhFourPage),
                entryName: "404"
            };
        case "software/rovo":
            switch(route.variant){
                default:
                    const isRovoProductTourEnabled = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).gwp8011RovoProductTour);
                    if (isRovoProductTourEnabled) return {
                        Component: (0, $lgDo7.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $a6B8g.FourOhFourPage),
                        entryName: "404"
                    };
            }
        case "software/jira/product-discovery/pricing":
            switch(route.variant){
                default:
                    const isWae = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).gwp7856PricingPagesWaeMigrationM3);
                    if (isWae) return {
                        Component: (0, $lgDo7.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    const jiraProductDiscoveryPricingTitle = (0, $3aSr8.getPricingTitleInternal)();
                    return {
                        Component: (0, $7Icip.JiraProductDiscoveryPricingPage),
                        entryName: "jira-product-discovery-pricing-page",
                        query: (0, $cCupH.PricingPageRelayQuery),
                        queryVars: (0, $cCupH.getPricingPageRelayQueryVars)("jira-product-discovery", location, jiraProductDiscoveryPricingTitle),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
            }
        case "software/guard/pricing":
            switch(route.variant){
                default:
                    const isWae1 = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).gwp7856PricingPagesWaeMigrationM3);
                    if (isWae1) return {
                        Component: (0, $lgDo7.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $7YM1S.SoftwareGuardPricingPage),
                        entryName: "software-guard-pricing-page",
                        query: (0, $cCupH.PricingPageRelayQuery),
                        queryVars: (0, $cCupH.getPricingPageRelayQueryVars)("atlassian-access", location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
            }
        case "software/compass/pricing":
            switch(route.variant){
                default:
                    const isWae2 = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).gwp7856PricingPagesWaeMigrationM3);
                    if (isWae2) return {
                        Component: (0, $lgDo7.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $3kaLT.SoftwareCompassPricingPage),
                        entryName: "software-compass-pricing-page",
                        query: (0, $cCupH.PricingPageRelayQuery),
                        queryVars: (0, $cCupH.getPricingPageRelayQueryVars)("compass", location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
            }
        case "software/loom/pricing":
            switch(route.variant){
                default:
                    const isWae3 = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).gwp7856PricingPagesWaeMigrationM3);
                    if (isWae3) return {
                        Component: (0, $lgDo7.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $6c1Y0.LoomPricingPage),
                        entryName: "loom-pricing-page",
                        query: (0, $cCupH.PricingPageRelayQuery),
                        queryVars: (0, $cCupH.getPricingPageRelayQueryVars)("loom", location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
            }
        case "collections/service/pricing":
            switch(route.variant){
                default:
                    const isServiceCollectionPricingEnabled = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).gwp8037ServiceCollectionPricingPage);
                    if (isServiceCollectionPricingEnabled) return {
                        Component: (0, $lgDo7.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $a6B8g.FourOhFourPage),
                        entryName: "404"
                    };
            }
        case "collections/teamwork/pricing":
            switch(route.variant){
                default:
                    const isWae4 = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).gwp7856PricingPagesWaeMigrationM3);
                    if (isWae4) return {
                        Component: (0, $lgDo7.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $hVOzm.TeamworkCollectionPricingPage),
                        entryName: "teamwork-collection-pricing-page",
                        query: (0, $cCupH.PricingPageRelayQuery),
                        queryVars: (0, $cCupH.getPricingPageRelayQueryVars)("teamwork", location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
            }
        case "collections/strategy/pricing":
            switch(route.variant){
                default:
                    const isWae5 = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).gwp7856PricingPagesWaeMigrationM3);
                    if (isWae5) return {
                        Component: (0, $lgDo7.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $ewIf8.StrategyCollectionPricingPage),
                        entryName: "strategy-collection-pricing-page",
                        query: (0, $cCupH.PricingPageRelayQuery),
                        queryVars: (0, $cCupH.getPricingPageRelayQueryVars)("strategy", location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
            }
        case "buy/cloud/org-setup":
            route.variant;
            return {
                Component: (0, $5asZh.BuyCloudOrgSetupPage),
                entryName: "buy-cloud-org-setup-page"
            };
        case "buy/cloud/site-setup":
            route.variant;
            return {
                Component: (0, $eyRtN.BuyCloudSiteSetupPage),
                entryName: "buy-cloud-site-setup-page"
            };
        case "software/bitbucket/pricing":
            switch(route.variant){
                default:
                    const isWae6 = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).gwp7856PricingPagesWaeMigrationM3);
                    if (isWae6) return {
                        Component: (0, $lgDo7.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $1eXgi.SoftwareBitbucketPricingPage),
                        entryName: "software-bitbucket-pricing-page",
                        query: (0, $cCupH.PricingPageRelayQuery),
                        queryVars: (0, $cCupH.getPricingPageRelayQueryVars)("bitbucket", location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
            }
        case "buy/cloud/post-order-provisioning":
            route.variant;
            return {
                Component: (0, $3vHgs.BuyCloudPostOrderProvisioningPage),
                entryName: "buy-cloud-post-order-provisioning-page"
            };
        case "software/rovo/start":
            route.variant;
            return {
                Component: (0, $1KLms.SoftwareRovoStartPage),
                entryName: "software-rovo-start-page"
            };
        case "agile":
            return {
                Component: (0, $lgDo7.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case "agile/advantage":
        case "agile/agile-conversations":
        case "agile/agile-at-scale":
        case "agile/agile-marketing":
        case "agile/design":
        case "agile/kanban":
        case "agile/product-management":
        case "agile/project-management":
        case "agile/scrum":
        case "agile/software-development":
        case "agile/teams":
        case "agile/tutorials":
            if ((0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).agileHubTopicsDxpMigrationGate)) return {
                Component: (0, $lgDo7.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
            else return {
                Component: (0, $7Fuy3.AgileOverviewPage),
                entryName: "agile-overview",
                query: (0, $3oPm6.AgileOverviewOneQuery),
                queryVars: (0, $3oPm6.getAgileOverviewQueryVars)(location),
                isRelayEnabled: true,
                relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
            };
        case "agile/manifesto":
            return {
                Component: (0, $lgDo7.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case "agile/value-stream-management":
            return {
                Component: (0, $lgDo7.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case `agile/advantage${$d760fc1e0b4af0ff$var$getRouteExtension(route.path, "agile/advantage")}`:
        case `agile/agile-conversations${$d760fc1e0b4af0ff$var$getRouteExtension(route.path, "agile/agile-conversations")}`:
        case `agile/agile-at-scale${$d760fc1e0b4af0ff$var$getRouteExtension(route.path, "agile/agile-at-scale")}`:
        case `agile/agile-marketing${$d760fc1e0b4af0ff$var$getRouteExtension(route.path, "agile/agile-marketing")}`:
        case `agile/design${$d760fc1e0b4af0ff$var$getRouteExtension(route.path, "agile/design")}`:
        case `agile/kanban${$d760fc1e0b4af0ff$var$getRouteExtension(route.path, "agile/kanban")}`:
        case `agile/product-management${$d760fc1e0b4af0ff$var$getRouteExtension(route.path, "agile/product-management")}`:
        case `agile/project-management${$d760fc1e0b4af0ff$var$getRouteExtension(route.path, "agile/project-management")}`:
        case `agile/scrum${$d760fc1e0b4af0ff$var$getRouteExtension(route.path, "agile/scrum")}`:
        case `agile/software-development${$d760fc1e0b4af0ff$var$getRouteExtension(route.path, "agile/software-development")}`:
        case `agile/teams${$d760fc1e0b4af0ff$var$getRouteExtension(route.path, "agile/teams")}`:
        case `agile/devops`:
            if ((0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).agileHubArticlesDxpMigrationGate)) return {
                Component: (0, $lgDo7.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
            else return {
                Component: (0, $7dX9c.AgileArticlePage),
                entryName: "agile-article",
                query: (0, $4va49.AgileArticleOneQuery),
                queryVars: (0, $4va49.getAgileArticleQueryVars)(location),
                isRelayEnabled: true,
                relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
            };
        case `agile/tutorials${$d760fc1e0b4af0ff$var$getRouteExtension(route.path, "agile/tutorials")}`:
            if ((0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).agileHubTutorialsDxpMigrationGate)) return {
                Component: (0, $lgDo7.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
            else return {
                Component: (0, $cQTaT.AgileTutorialPage),
                entryName: "agile-tutorial",
                query: (0, $bl3E5.AgileTutorialOneQuery),
                queryVars: (0, $bl3E5.getAgileTutorialQueryVars)(location),
                isRelayEnabled: true,
                relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
            };
        case `agile/about${$d760fc1e0b4af0ff$var$getRouteExtension(route.path, "agile/about")}`:
            return {
                Component: (0, $lgDo7.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case "customers":
            return {
                Component: (0, $jeTGv.CustomersLandingPage),
                entryName: "customers-landing-page",
                query: (0, $evZwi.CustomerLandingPageRelayQuery),
                queryVars: (0, $evZwi.getCustomerLandingPageRelayQueryVars)(location),
                isRelayEnabled: true,
                relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
            };
        case `customers${$d760fc1e0b4af0ff$var$getRouteExtension(route.path, "customers")}`:
            if (// these should only be of the form `customers/<slug>`.
            // There should never be more than 2 parts
            $d760fc1e0b4af0ff$var$getRouteExtension(route.path, "customers").split("/").length > 2) return {
                Component: (0, $a6B8g.FourOhFourPage),
                entryName: "404"
            };
            return {
                Component: (0, $lgDo7.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case "jira":
            const isWaeJira = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).dxpMigrationJiraProductTourGate);
            if (isWaeJira) return {
                Component: (0, $lgDo7.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
            return {
                Component: (0, $jJFPZ.JiraLandingPage),
                entryName: "jira-landing-page"
            };
        case "software/jira":
            switch(route.variant){
                case "paid-lp-jsw-features":
                    return {
                        Component: (0, $3l68c.JiraSoftwarePagePaidLpJswFeatures),
                        entryName: "jira-software-page-paid-lp-jsw-features"
                    };
                case "paid-lp-jsw-roadmaps":
                    return {
                        Component: (0, $j7l2H.JiraSoftwarePagePaidLpJswRoadmaps),
                        entryName: "jira-software-page-paid-lp-jsw-roadmaps",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsw-template":
                    return {
                        Component: (0, $aEM8Q.JiraSoftwarePagePaidLpJswTemplate),
                        entryName: "jira-software-page-paid-lp-jsw-template",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsw-tracker":
                    return {
                        Component: (0, $4jXNI.JiraSoftwarePagePaidLpJswTracker),
                        entryName: "jira-software-page-paid-lp-jsw-tracker",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsw-pm":
                    return {
                        Component: (0, $kPNXB.JiraSoftwarePagePaidLpJswPm),
                        entryName: "jira-software-page-paid-lp-jsw-pm",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsw-project_collaboration":
                    return {
                        Component: (0, $4ewKx.JiraSoftwarePagePaidLpJswProjCollab),
                        entryName: "jira-software-page-paid-lp-jsw-project_collaboration",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsw-automation":
                    return {
                        Component: (0, $6OWgV.JiraSoftwarePagePaidLpJswAutomation),
                        entryName: "jira-software-page-paid-lp-jsw-automation",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsw-teamwork":
                    return {
                        Component: (0, $7Z8lp.JiraSoftwarePagePaidLpJswTeamwork),
                        entryName: "jira-software-page-paid-lp-jsw-teamwork",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsw-agile":
                    return {
                        Component: (0, $75UBa.JiraSoftwarePagePaidLpJswAgile),
                        entryName: "jira-software-page-paid-lp-jsw-agile",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsw-competitors":
                    return {
                        Component: (0, $8rgnW.JiraSoftwarePagePaidLpJswCompetitors),
                        entryName: "jira-software-page-paid-lp-jsw-competitors",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsw-team-engineering":
                    return {
                        Component: (0, $bs4n3.JiraSoftwarePageAnchorLpJswEngineering),
                        entryName: "jira-software-page-anchor-lp-jsw-team-engineering",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsw-team-marketing":
                    return {
                        Component: (0, $lHRSz.JiraSoftwarePageAnchorLpJswMarketing),
                        entryName: "jira-software-page-anchor-lp-jsw-team-marketing",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsw-team-hr":
                    return {
                        Component: (0, $1Dw5R.JiraSoftwarePageAnchorLpJswHr),
                        entryName: "jira-software-page-anchor-lp-jsw-team-hr",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsw-team-legal":
                    return {
                        Component: (0, $jmVsK.JiraSoftwarePageAnchorLpJswLegal),
                        entryName: "jira-software-page-anchor-lp-jsw-team-legal",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsw-team-operations":
                    return {
                        Component: (0, $0M3nE.JiraSoftwarePageAnchorLpJswOperations),
                        entryName: "jira-software-page-anchor-lp-jsw-team-operations",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsw-team-design":
                    return {
                        Component: (0, $8KAIN.JiraSoftwarePageAnchorLpJswDesign),
                        entryName: "jira-software-page-anchor-lp-jsw-team-design",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsw-team-programmgmt":
                    return {
                        Component: (0, $eAxa6.JiraSoftwarePageAnchorLpJswProgramMgmt),
                        entryName: "jira-software-page-anchor-lp-jsw-team-programmgmt",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsw-team-sales":
                    return {
                        Component: (0, $jJy4Z.JiraSoftwarePageAnchorLpJswSales),
                        entryName: "jira-software-page-anchor-lp-jsw-team-sales",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                default:
                    //For logged out users, we redirect directly to Uniform
                    const isWaeJira1 = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).dxpMigrationJiraProductTourGate);
                    if (isWaeJira1 && !userLoggedIn) return {
                        Component: (0, $lgDo7.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        // Using any to unblock unclear type error for Team 25 timeline
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    //For logged in, we will either show a "Has Jira" experience, otherwise the Uniform "logged out" page
                    return {
                        Component: (0, $auFti.JiraSoftwarePage),
                        entryName: "jira-software-page",
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
            }
        case "software/jira/product-discovery":
            return {
                Component: (0, $6KSFr.JiraProductDiscoveryPage),
                entryName: "jira-product-discovery-page"
            };
        case "software/jira/features":
            return {
                Component: (0, $i8zdv.JiraSoftwareFeaturesPage),
                entryName: "jira-software-features-page"
            };
        case "software/jira/free":
            return {
                Component: (0, $b3ZMX.JiraSoftwareFreePage),
                entryName: "jira-software-free-page"
            };
        case "software/jira/pricing":
            const isWae7 = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).jiraPricingPageWaeMigration);
            if (isWae7) return {
                Component: (0, $lcvl0.UniformJiraPricingEntryPage),
                entryName: "uniform-jira-pricing-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
            const jiraPricingTitleInternal = (0, $a1ns9.getPricingTitleInternal)();
            return {
                Component: (0, $gDaC1.JiraSoftwarePricingPage),
                entryName: "jira-software-pricing-page",
                query: (0, $cCupH.PricingPageRelayQuery),
                queryVars: (0, $cCupH.getPricingPageRelayQueryVars)("jira-software", location, jiraPricingTitleInternal),
                isRelayEnabled: true,
                relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
            };
        case "software/jira/service-management":
            switch(route.variant){
                case "anchor-lp-jsm-automation":
                    return {
                        Component: (0, $bv0o8.JiraServiceManagementSoftwarePageAnchorAutomation),
                        entryName: "jira-service-management-anchor-lp-jsm-automation",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-competitors":
                    return {
                        Component: (0, $99FZR.JiraServiceManagementSoftwarePageAnchorCompetitors),
                        entryName: "jira-service-management-anchor-lp-jsm-competitors",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-esm":
                    return {
                        Component: (0, $dknVo.JiraServiceManagementSoftwarePageAnchorEsm),
                        entryName: "jira-service-management-anchor-lp-jsm-esm",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-csm":
                    return {
                        Component: (0, $ldfiY.JiraServiceManagementSoftwarePageAnchorCsm),
                        entryName: "jira-service-management-anchor-lp-jsm-csm",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-team-marketing":
                    return {
                        Component: (0, $4ytMB.JiraServiceManagementSoftwarePageAnchorMarketing),
                        entryName: "jira-service-management-anchor-lp-jsm-team-marketing",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-team-engineering":
                    return {
                        Component: (0, $jwejb.JiraServiceManagementSoftwarePageAnchorEngineering),
                        entryName: "jira-service-management-anchor-lp-jsm-team-engineering",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-team-hr":
                    return {
                        Component: (0, $iVJd6.JiraServiceManagementSoftwarePageAnchorHr),
                        entryName: "jira-service-management-anchor-lp-jsm-team-hr",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-team-legal":
                    return {
                        Component: (0, $hkBIf.JiraServiceManagementSoftwarePageAnchorLegal),
                        entryName: "jira-service-management-anchor-lp-jsm-team-legal",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-team-operations":
                    return {
                        Component: (0, $ljOnm.JiraServiceManagementSoftwarePageAnchorOperations),
                        entryName: "jira-service-management-anchor-lp-jsm-team-operations",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsm-features":
                    return {
                        Component: (0, $ai5nK.JiraServiceManagementSoftwarePagePaidLpJsmFeatures),
                        entryName: "jira-service-management-software-page-paid-lp-jsm-features",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsm-features-cerebro":
                    return {
                        Component: (0, $kTpag.JiraServiceManagementSoftwarePagePaidLpJsmFeaturesCerebro),
                        entryName: "jira-service-management-software-page-paid-lp-jsm-features-cerebro",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsm-incidentchangemgmt":
                    return {
                        Component: (0, $54ICB.JiraServiceManagementSoftwarePagePaidLpJsmIncidentchangemgmt),
                        entryName: "jira-service-management-software-page-paid-lp-jsm-incidentchangemgmt",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsm-ticketing":
                    return {
                        Component: (0, $3MxDQ.JiraServiceManagementSoftwarePagePaidLpJsmTicketing),
                        entryName: "jira-service-management-software-page-paid-lp-jsm-ticketing",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsm-service-desk":
                    return {
                        Component: (0, $kzx7G.JiraServiceManagementSoftwarePagePaidLpJsmServiceDesk),
                        entryName: "jira-service-management-software-page-paid-lp-jsm-service-desk",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsm-itsm":
                    return {
                        Component: (0, $dt8LD.JiraServiceManagementSoftwarePagePaidLpJsmItsm),
                        entryName: "jira-service-management-software-page-paid-lp-jsm-itsm",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-asset":
                    return {
                        Component: (0, $gtIRL.JiraServiceManagementSoftwarePageAnchorLpJsmAsset),
                        entryName: "jira-service-management-software-page-anchor-lp-jsm-asset",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-devops":
                    return {
                        Component: (0, $ehyVQ.JiraServiceManagementSoftwarePageAnchorLpJsmDevops),
                        entryName: "jira-service-management-software-page-anchor-lp-jsm-devops",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-team-customerservice":
                    return {
                        Component: (0, $gBm7i.JiraServiceManagementSoftwarePageAnchorCustomerService),
                        entryName: "jira-service-management-software-page-anchor-lp-jsm-team-customerservice",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-team-design":
                    return {
                        Component: (0, $7BQx4.JiraServiceManagementSoftwarePageAnchorDesign),
                        entryName: "jira-service-management-software-page-anchor-lp-jsm-team-design",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                default:
                    if ((0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).dxpMigrationJsmProductTourGate)) return {
                        Component: (0, $lgDo7.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    else return {
                        Component: (0, $dRBBv.JiraServiceManagementSoftwarePage),
                        entryName: "jira-service-management-software-page"
                    };
            }
        case "software/confluence":
            const excludedCountyCodesFromExperiment = [
                "IN",
                "ID",
                "GB"
            ];
            const excludedCountry = userLocale != null && excludedCountyCodesFromExperiment.includes(userLocale);
            if (route.variant && (0, $aR9rM.isTargetedSubAnchor)(subAnchor) && !excludedCountry) {
                const subAnchorExperiment = (0, $9iWJ8.getExperiment)((0, $9iWJ8.experiments).cfind4782LandingPageSubAnchorV3);
                // if treatment return the sub anchor experiment, else control gets whatever normal route behavior is
                if (subAnchorExperiment.type == "enrolled" && subAnchorExperiment.value) return {
                    Component: (0, $28rj9.ConfluenceSoftwarePageVariantPaidLpConfSubAnchors),
                    entryName: "confluence-software-page-variant-paid-lp-conf-subAnchors",
                    query: (0, $lsqCW.AnchorPageRelayQuery),
                    queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)((0, $aR9rM.getPageId)(subAnchor), location),
                    isRelayEnabled: true,
                    relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                };
            }
            if (!userLoggedIn && route.variant && (0, $fR8rA.isTargetedKeyword)(route.keyword)) return {
                Component: (0, $iiM0Q.ConfluenceSoftwarePageVariantPaidLpConfKeywords),
                entryName: "confluence-software-page-variant-paid-lp-conf-keywords",
                query: (0, $lsqCW.AnchorPageRelayQuery),
                queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)((0, $fR8rA.getPageId)(route.keyword), location),
                isRelayEnabled: true,
                relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
            };
            switch(route.variant){
                case "paid-lp-conf-features":
                    return {
                        Component: (0, $dUMGS.ConfluenceSoftwarePageVariantPaidLpConfFeatures),
                        entryName: "confluence-software-page-variant-paid-lp-conf-features"
                    };
                case "paid-lp-confl-template":
                    return {
                        Component: (0, $88Nc8.ConfluenceSoftwarePageVariantPaidLpConflTemplate),
                        entryName: "confluence-software-page-variant-paid-lp-confl-template",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-confl-documentation":
                    return {
                        Component: (0, $gr0Wo.ConfluenceSoftwarePageVariantPaidLpConflDocumentation),
                        entryName: "confluence-software-page-variant-paid-lp-confl-documentation",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-confl-projectmgmt":
                    return {
                        Component: (0, $eYo1w.ConfluenceSoftwarePageVariantPaidLpConflProjectMgmt),
                        entryName: "confluence-software-page-variant-paid-lp-confl-projectmgmt",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-collaboration":
                    return {
                        Component: (0, $bmKvu.ConfluenceSoftwarePageVariantAnchorLpConfCollaboration),
                        entryName: "confluence-software-page-variant-anchor-lp-conf-collaboration",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-automation":
                    return {
                        Component: (0, $5l8W2.ConfluenceSoftwarePageAnchorAutomation),
                        entryName: "confluence-software-anchor-lp-automation",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-teamwork":
                    return {
                        Component: (0, $iPHuy.ConfluenceSoftwarePageAnchorTeamwork),
                        entryName: "confluence-software-anchor-lp-teamwork",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-competitors":
                    return {
                        Component: (0, $bYVXE.ConfluenceSoftwarePageAnchorCompetitors),
                        entryName: "confluence-software-anchor-lp-competitors",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-work-management":
                    return {
                        Component: (0, $29ctt.ConfluenceSoftwarePageAnchorWorkManagement),
                        entryName: "confluence-software-anchor-lp-work-management",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-team-engineering":
                    return {
                        Component: (0, $l9dqv.ConfluenceSoftwarePageAnchorEngineering),
                        entryName: "confluence-software-anchor-lp-team-engineering",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-team-marketing":
                    return {
                        Component: (0, $dIAEL.ConfluenceSoftwarePageAnchorMarketing),
                        entryName: "confluence-software-anchor-lp-team-marketing",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-team-legal":
                    return {
                        Component: (0, $d7VZR.ConfluenceSoftwarePageAnchorLegal),
                        entryName: "confluence-software-anchor-lp-team-legal",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-team-hr":
                    return {
                        Component: (0, $jZQGv.ConfluenceSoftwarePageAnchorHr),
                        entryName: "confluence-software-anchor-lp-team-hr",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-team-operations":
                    return {
                        Component: (0, $aQuME.ConfluenceSoftwarePageAnchorOperations),
                        entryName: "confluence-software-anchor-lp-team-operations",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-team-design":
                    return {
                        Component: (0, $dP45N.ConfluenceSoftwarePageAnchorDesign),
                        entryName: "confluence-software-anchor-lp-team-design",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-team-programmgmt":
                    return {
                        Component: (0, $kGjia.ConfluenceSoftwarePageAnchorProgramMgmt),
                        entryName: "confluence-software-anchor-lp-team-programmgmt",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-team-customerservice":
                    return {
                        Component: (0, $3hOaF.ConfluenceSoftwarePageAnchorCustomerService),
                        entryName: "confluence-software-anchor-lp-team-customerservice",
                        query: (0, $lsqCW.AnchorPageRelayQuery),
                        queryVars: (0, $lsqCW.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
                    };
                default:
                    if ((0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).dxpMigrationConfluenceProductTourGate)) return {
                        Component: (0, $lgDo7.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    else return {
                        Component: (0, $7T3K5.ConfluenceSoftwarePage),
                        entryName: "confluence-software-page"
                    };
            }
        case "software/jira/service-management/product-pricing":
            if (!(0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).gwp7923NewJsmRouteDeIndex)) return {
                Component: (0, $a6B8g.FourOhFourPage),
                entryName: "404"
            };
            const jiraServiceManagementProductPricingTitle = (0, $c6SB4.getPricingTitleInternal)();
            return {
                Component: (0, $hWRkD.JiraServiceManagementPricingPage),
                entryName: "jira-service-management-pricing-page",
                query: (0, $cCupH.PricingPageRelayQuery),
                queryVars: (0, $cCupH.getPricingPageRelayQueryVars)("jira-service-management", location, jiraServiceManagementProductPricingTitle),
                isRelayEnabled: true,
                relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
            };
        case "software/jira/service-management/pricing":
            const jiraServiceManagementPricingTitle = (0, $c6SB4.getPricingTitleInternal)();
            return {
                Component: (0, $hWRkD.JiraServiceManagementPricingPage),
                entryName: "jira-service-management-pricing-page",
                query: (0, $cCupH.PricingPageRelayQuery),
                queryVars: (0, $cCupH.getPricingPageRelayQueryVars)("jira-service-management", location, jiraServiceManagementPricingTitle),
                isRelayEnabled: true,
                relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
            };
        case "software/confluence/pricing":
            const isWaeMigration = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).confluencePricingPageWaeMigration);
            if (isWaeMigration) return {
                Component: (0, $4o4mW.UniformConfluencePricingEntryPage),
                entryName: "uniform-confluence-pricing-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
            const confluencePricingTitleInternal = (0, $lDCFR.getPricingTitleInternal)();
            return {
                Component: (0, $4Kg8I.ConfluencePricingPage),
                entryName: "confluence-pricing-page",
                query: (0, $cCupH.PricingPageRelayQuery),
                queryVars: (0, $cCupH.getPricingPageRelayQueryVars)("confluence", location, confluencePricingTitleInternal),
                isRelayEnabled: true,
                relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
            };
        case "software/confluence/free":
            return {
                Component: (0, $cvEcp.ConfluenceFreePage),
                entryName: "confluence-free-page"
            };
        case "software/confluence/templates":
            return {
                Component: (0, $kyMgW.ConfluenceTemplatesRelayPage),
                entryName: "confluence-templates-contentful-relay-page",
                query: (0, $dH3QU.ConfluenceTemplatesUnifiedRelayPageQuery),
                queryVars: (0, $dH3QU.getConfluenceTemplatesUnifiedRelayPageQueryVars)(location),
                isRelayEnabled: true,
                relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
            };
        case "try":
            return {
                Component: (0, $kTri3.TryPage),
                entryName: "try-page"
            };
        case "try/cloud/signup":
            return {
                Component: (0, $b45Um.SignupPage),
                entryName: "signup-page"
            };
        case "ondemand/signup/checkemail":
            return {
                Component: (0, $iiPAa.CheckemailPage),
                entryName: "checkemail-page"
            };
        case "ondemand/signup/confirmation":
        case "buy/cloud/confirmation":
            return {
                Component: (0, $QtTDf.ConfirmationPage),
                entryName: "confirmation-page",
                featureFlags: route.featureFlags
            };
        case "software/confluence/templates/search":
            return {
                Component: (0, $5YjFo.ConfluenceTemplateSearchRelayPage),
                entryName: "confluence-template-search-contentful-relay-page",
                query: (0, $dH3QU.ConfluenceTemplatesUnifiedRelayPageQuery),
                queryVars: (0, $dH3QU.getConfluenceTemplatesUnifiedRelayPageQueryVars)(location),
                isRelayEnabled: true,
                relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
            };
        case `software/confluence/templates/categories${$d760fc1e0b4af0ff$var$getRouteExtension(route.path, "software/confluence/templates/categories")}`:
            return {
                Component: (0, $aSYwy.ConfluenceTemplateCategoryRelayPage),
                entryName: "confluence-template-category-contentful-relay-page",
                query: (0, $dH3QU.ConfluenceTemplatesUnifiedRelayPageQuery),
                queryVars: (0, $dH3QU.getConfluenceTemplatesUnifiedRelayPageQueryVars)(location),
                isRelayEnabled: true,
                relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
            };
        case `software/confluence/templates/collections${$d760fc1e0b4af0ff$var$getRouteExtension(route.path, "software/confluence/templates/collections")}`:
            return {
                Component: (0, $crPWy.ConfluenceTemplateCollectionDetailsRelayPage),
                entryName: "confluence-template-collection-details-contentful-relay-page",
                query: (0, $6sE8c.ConfluenceTemplateCollectionDetailsRelayPageQuery),
                queryVars: (0, $6sE8c.getConfluenceTemplateCollectionDetailsRelayPageQueryVars)(location),
                isRelayEnabled: true,
                relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
            };
        case `software/jira/templates/service-management`:
            return {
                Component: (0, $jIvlj.JiraTemplateCategoryPage),
                entryName: "jira-template-category-page"
            };
        case `software/jira/templates${$d760fc1e0b4af0ff$var$getRouteExtension(route.path, "software/jira/templates")}`:
            return {
                Component: (0, $lgDo7.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case "enterprise/contact":
            return {
                Component: (0, $cbOuC.EnterpriseContactSalesPage),
                entryName: "enterprise-contact-sales-page"
            };
        case "enterprise/contact-thanks":
            switch(route.variant){
                case "product-features":
                    return {
                        Component: (0, $cy7iU.EnterpriseContactThanksPage),
                        entryName: "enterprise-contact-thanks-page"
                    };
                case "pricing-quotes":
                    return {
                        Component: (0, $cy7iU.EnterpriseContactThanksPage),
                        entryName: "enterprise-contact-thanks-page"
                    };
                case "migration-options":
                    return {
                        Component: (0, $cy7iU.EnterpriseContactThanksPage),
                        entryName: "enterprise-contact-thanks-page"
                    };
                case "billing-licensing":
                    return {
                        Component: (0, $cy7iU.EnterpriseContactThanksPage),
                        entryName: "enterprise-contact-thanks-page"
                    };
                case "technical-support":
                    return {
                        Component: (0, $cy7iU.EnterpriseContactThanksPage),
                        entryName: "enterprise-contact-thanks-page"
                    };
                default:
                    return {
                        Component: (0, $cy7iU.EnterpriseContactThanksPage),
                        entryName: "enterprise-contact-thanks-page"
                    };
            }
        case "enterprise/success":
            return {
                Component: (0, $lgDo7.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case "software/confluence/enterprise":
            return {
                Component: (0, $lgDo7.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case "software/jira/enterprise":
            return {
                Component: (0, $lgDo7.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case "software/jira/service-management/enterprise":
            return {
                Component: (0, $lgDo7.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case "enterprise":
            if ((0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).enterprisePageDXPMigration)) return {
                Component: (0, $lgDo7.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
            return {
                Component: (0, $cZ6ed.EnterpriseLandingPage),
                entryName: "enterprise-landing-page"
            };
        case "teams/nonprofits/discount-pricing":
            return {
                Component: (0, $anmoL.NonProfitPricingPage),
                entryName: "non-profit-pricing-page",
                query: (0, $cCupH.PricingPageRelayQuery),
                queryVars: (0, $cCupH.getPricingPageRelayQueryVars)("nonprofit", location),
                isRelayEnabled: true,
                relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
            };
        case `software/confluence/templates${$d760fc1e0b4af0ff$var$getRouteExtension(route.path, "software/confluence/templates")}`:
            if ((0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).confluenceTemplatesDxpMigration)) return {
                Component: (0, $lgDo7.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
            else return {
                Component: (0, $e15Q8.ConfluenceTemplateDetailsRelayPage),
                entryName: "confluence-template-details-contentful-relay-page",
                query: (0, $78sex.ConfluenceTemplateDetailsRelayPageQuery),
                queryVars: (0, $78sex.getConfluenceTemplateDetailsRelayPageQueryVars)(location),
                isRelayEnabled: true,
                relayApi: (0, $200NX.RELAY_API_CONTENTFUL)
            };
        case "cdn-library":
            return {
                Component: (0, $dgztS.default),
                entryName: "cdn-library"
            };
        case "search":
            return {
                Component: (0, $jhLgK.SearchResultsPage),
                entryName: "search"
            };
        case "":
            return {
                Component: (0, $3nv1K.HomePage),
                entryName: "home"
            };
        default:
            return {
                Component: (0, $a6B8g.FourOhFourPage),
                entryName: "404"
            };
    }
};
const $d760fc1e0b4af0ff$var$getRouteExtension = (path, baseTemplate)=>{
    const pathExtn = path.split(baseTemplate)[1];
    return pathExtn ? pathExtn : "";
};



var $7Tq4R = parcelRequire("7Tq4R");

var $2A2ZL = parcelRequire("2A2ZL");
const { Component: $618a7806372e752d$var$Component, isRelayEnabled: $618a7806372e752d$var$isRelayEnabled, query: $618a7806372e752d$var$query, queryVars: $618a7806372e752d$var$queryVars, relayApi: $618a7806372e752d$var$relayApi } = (0, $d760fc1e0b4af0ff$export$da6d2f7032b7150b)(window.location);
if (!$618a7806372e752d$var$isRelayEnabled) (0, $7Tq4R.init)($618a7806372e752d$var$Component);
else (0, $2A2ZL.init)($618a7806372e752d$var$Component, $618a7806372e752d$var$query, $618a7806372e752d$var$queryVars, $618a7806372e752d$var$relayApi);




//# sourceMappingURL=index.64189fd3.js.map
